(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("prop-types"), require("react"), require("react-dom"));else if (typeof define === 'function' && define.amd) define(["prop-types", "react", "react-dom"], factory);else if (typeof exports === 'object') exports["Formatic"] = factory(require("prop-types"), require("react"), require("react-dom"));else root["Formatic"] = factory(root["PropTypes"], root["React"], root["ReactDOM"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__16__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 1196);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE__0__;
      /***/
    },
    /* 1 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE__1__;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _assign = __webpack_require__(1169);

      var _assign2 = _interopRequireDefault(_assign);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = _assign2.default || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };
      /***/

    },
    /* 3 */

    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
      */

      /* global define */


      (function () {
        'use strict';

        var hasOwn = {}.hasOwnProperty;

        function classNames() {
          var classes = [];

          for (var i = 0; i < arguments.length; i++) {
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;

            if (argType === 'string' || argType === 'number') {
              classes.push(arg);
            } else if (Array.isArray(arg) && arg.length) {
              var inner = classNames.apply(null, arg);

              if (inner) {
                classes.push(inner);
              }
            } else if (argType === 'object') {
              for (var key in arg) {
                if (hasOwn.call(arg, key) && arg[key]) {
                  classes.push(key);
                }
              }
            }
          }

          return classes.join(' ');
        }

        if (typeof module !== 'undefined' && module.exports) {
          classNames.default = classNames;
          module.exports = classNames;
        } else if (true) {
          // register as 'classnames', consistent with npm package name
          !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return classNames;
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
      })();
      /***/

    },
    /* 4 */

    /***/
    function (module, exports) {
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      module.exports = _defineProperty;
      /***/
    },
    /* 5 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _typeof2 = __webpack_require__(49);

      var _typeof3 = _interopRequireDefault(_typeof2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
      };
      /***/

    },
    /* 6 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _defineProperty = __webpack_require__(655);

      var _defineProperty2 = _interopRequireDefault(_defineProperty);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (obj, key, value) {
        if (key in obj) {
          (0, _defineProperty2.default)(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      };
      /***/

    },
    /* 7 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      exports.default = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      };
      /***/

    },
    /* 8 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _setPrototypeOf = __webpack_require__(1144);

      var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

      var _create = __webpack_require__(1140);

      var _create2 = _interopRequireDefault(_create);

      var _typeof2 = __webpack_require__(49);

      var _typeof3 = _interopRequireDefault(_typeof2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
        }

        subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
      };
      /***/

    },
    /* 9 */

    /***/
    function (module, exports) {
      /**
       * This method returns `undefined`.
       *
       * @static
       * @memberOf _
       * @since 2.3.0
       * @category Util
       * @example
       *
       * _.times(2, _.noop);
       * // => [undefined, undefined]
       */
      function noop() {// No operation performed.
      }

      module.exports = noop;
      /***/
    },
    /* 10 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGet = __webpack_require__(249);
      /**
       * Gets the value at `path` of `object`. If the resolved value is
       * `undefined`, the `defaultValue` is returned in its place.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to get.
       * @param {*} [defaultValue] The value returned for `undefined` resolved values.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.get(object, 'a[0].b.c');
       * // => 3
       *
       * _.get(object, ['a', '0', 'b', 'c']);
       * // => 3
       *
       * _.get(object, 'a.b.c', 'default');
       * // => 'default'
       */


      function get(object, path, defaultValue) {
        var result = object == null ? undefined : baseGet(object, path);
        return result === undefined ? defaultValue : result;
      }

      module.exports = get;
      /***/
    },
    /* 11 */

    /***/
    function (module, exports) {
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return self;
      }

      module.exports = _assertThisInitialized;
      /***/
    },
    /* 12 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _defineProperty = __webpack_require__(655);

      var _defineProperty2 = _interopRequireDefault(_defineProperty);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, _defineProperty2.default)(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();
      /***/

    },
    /* 13 */

    /***/
    function (module, exports, __webpack_require__) {
      var defineProperty = __webpack_require__(4);

      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          var ownKeys = Object.keys(source);

          if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
              return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
          }

          ownKeys.forEach(function (key) {
            defineProperty(target, key, source[key]);
          });
        }

        return target;
      }

      module.exports = _objectSpread;
      /***/
    },
    /* 14 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (module) {
        var require; //! moment.js


        ;

        (function (global, factory) {
          true ? module.exports = factory() : undefined;
        })(this, function () {
          'use strict';

          var hookCallback;

          function hooks() {
            return hookCallback.apply(null, arguments);
          } // This is done to register the method called with moment()
          // without creating circular dependencies.


          function setHookCallback(callback) {
            hookCallback = callback;
          }

          function isArray(input) {
            return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
          }

          function isObject(input) {
            // IE8 will treat undefined and null as object if it wasn't for
            // input != null
            return input != null && Object.prototype.toString.call(input) === '[object Object]';
          }

          function isObjectEmpty(obj) {
            if (Object.getOwnPropertyNames) {
              return Object.getOwnPropertyNames(obj).length === 0;
            } else {
              var k;

              for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                  return false;
                }
              }

              return true;
            }
          }

          function isUndefined(input) {
            return input === void 0;
          }

          function isNumber(input) {
            return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
          }

          function isDate(input) {
            return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
          }

          function map(arr, fn) {
            var res = [],
                i;

            for (i = 0; i < arr.length; ++i) {
              res.push(fn(arr[i], i));
            }

            return res;
          }

          function hasOwnProp(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
          }

          function extend(a, b) {
            for (var i in b) {
              if (hasOwnProp(b, i)) {
                a[i] = b[i];
              }
            }

            if (hasOwnProp(b, 'toString')) {
              a.toString = b.toString;
            }

            if (hasOwnProp(b, 'valueOf')) {
              a.valueOf = b.valueOf;
            }

            return a;
          }

          function createUTC(input, format, locale, strict) {
            return createLocalOrUTC(input, format, locale, strict, true).utc();
          }

          function defaultParsingFlags() {
            // We need to deep clone this object.
            return {
              empty: false,
              unusedTokens: [],
              unusedInput: [],
              overflow: -2,
              charsLeftOver: 0,
              nullInput: false,
              invalidMonth: null,
              invalidFormat: false,
              userInvalidated: false,
              iso: false,
              parsedDateParts: [],
              meridiem: null,
              rfc2822: false,
              weekdayMismatch: false
            };
          }

          function getParsingFlags(m) {
            if (m._pf == null) {
              m._pf = defaultParsingFlags();
            }

            return m._pf;
          }

          var some;

          if (Array.prototype.some) {
            some = Array.prototype.some;
          } else {
            some = function some(fun) {
              var t = Object(this);
              var len = t.length >>> 0;

              for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                  return true;
                }
              }

              return false;
            };
          }

          function isValid(m) {
            if (m._isValid == null) {
              var flags = getParsingFlags(m);
              var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
              });
              var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

              if (m._strict) {
                isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
              }

              if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
              } else {
                return isNowValid;
              }
            }

            return m._isValid;
          }

          function createInvalid(flags) {
            var m = createUTC(NaN);

            if (flags != null) {
              extend(getParsingFlags(m), flags);
            } else {
              getParsingFlags(m).userInvalidated = true;
            }

            return m;
          } // Plugins that add properties should also add the key here (null value),
          // so we can properly clone ourselves.


          var momentProperties = hooks.momentProperties = [];

          function copyConfig(to, from) {
            var i, prop, val;

            if (!isUndefined(from._isAMomentObject)) {
              to._isAMomentObject = from._isAMomentObject;
            }

            if (!isUndefined(from._i)) {
              to._i = from._i;
            }

            if (!isUndefined(from._f)) {
              to._f = from._f;
            }

            if (!isUndefined(from._l)) {
              to._l = from._l;
            }

            if (!isUndefined(from._strict)) {
              to._strict = from._strict;
            }

            if (!isUndefined(from._tzm)) {
              to._tzm = from._tzm;
            }

            if (!isUndefined(from._isUTC)) {
              to._isUTC = from._isUTC;
            }

            if (!isUndefined(from._offset)) {
              to._offset = from._offset;
            }

            if (!isUndefined(from._pf)) {
              to._pf = getParsingFlags(from);
            }

            if (!isUndefined(from._locale)) {
              to._locale = from._locale;
            }

            if (momentProperties.length > 0) {
              for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];

                if (!isUndefined(val)) {
                  to[prop] = val;
                }
              }
            }

            return to;
          }

          var updateInProgress = false; // Moment prototype object

          function Moment(config) {
            copyConfig(this, config);
            this._d = new Date(config._d != null ? config._d.getTime() : NaN);

            if (!this.isValid()) {
              this._d = new Date(NaN);
            } // Prevent infinite loop in case updateOffset creates new moment
            // objects.


            if (updateInProgress === false) {
              updateInProgress = true;
              hooks.updateOffset(this);
              updateInProgress = false;
            }
          }

          function isMoment(obj) {
            return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
          }

          function absFloor(number) {
            if (number < 0) {
              // -0 -> 0
              return Math.ceil(number) || 0;
            } else {
              return Math.floor(number);
            }
          }

          function toInt(argumentForCoercion) {
            var coercedNumber = +argumentForCoercion,
                value = 0;

            if (coercedNumber !== 0 && isFinite(coercedNumber)) {
              value = absFloor(coercedNumber);
            }

            return value;
          } // compare two arrays, return the number of differences


          function compareArrays(array1, array2, dontConvert) {
            var len = Math.min(array1.length, array2.length),
                lengthDiff = Math.abs(array1.length - array2.length),
                diffs = 0,
                i;

            for (i = 0; i < len; i++) {
              if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
                diffs++;
              }
            }

            return diffs + lengthDiff;
          }

          function warn(msg) {
            if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
              console.warn('Deprecation warning: ' + msg);
            }
          }

          function deprecate(msg, fn) {
            var firstTime = true;
            return extend(function () {
              if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
              }

              if (firstTime) {
                var args = [];
                var arg;

                for (var i = 0; i < arguments.length; i++) {
                  arg = '';

                  if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';

                    for (var key in arguments[0]) {
                      arg += key + ': ' + arguments[0][key] + ', ';
                    }

                    arg = arg.slice(0, -2); // Remove trailing comma and space
                  } else {
                    arg = arguments[i];
                  }

                  args.push(arg);
                }

                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
              }

              return fn.apply(this, arguments);
            }, fn);
          }

          var deprecations = {};

          function deprecateSimple(name, msg) {
            if (hooks.deprecationHandler != null) {
              hooks.deprecationHandler(name, msg);
            }

            if (!deprecations[name]) {
              warn(msg);
              deprecations[name] = true;
            }
          }

          hooks.suppressDeprecationWarnings = false;
          hooks.deprecationHandler = null;

          function isFunction(input) {
            return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
          }

          function set(config) {
            var prop, i;

            for (i in config) {
              prop = config[i];

              if (isFunction(prop)) {
                this[i] = prop;
              } else {
                this['_' + i] = prop;
              }
            }

            this._config = config; // Lenient ordinal parsing accepts just a number in addition to
            // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
            // TODO: Remove "ordinalParse" fallback in next major release.

            this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
          }

          function mergeConfigs(parentConfig, childConfig) {
            var res = extend({}, parentConfig),
                prop;

            for (prop in childConfig) {
              if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                  res[prop] = {};
                  extend(res[prop], parentConfig[prop]);
                  extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                  res[prop] = childConfig[prop];
                } else {
                  delete res[prop];
                }
              }
            }

            for (prop in parentConfig) {
              if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
              }
            }

            return res;
          }

          function Locale(config) {
            if (config != null) {
              this.set(config);
            }
          }

          var keys;

          if (Object.keys) {
            keys = Object.keys;
          } else {
            keys = function keys(obj) {
              var i,
                  res = [];

              for (i in obj) {
                if (hasOwnProp(obj, i)) {
                  res.push(i);
                }
              }

              return res;
            };
          }

          var defaultCalendar = {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
          };

          function calendar(key, mom, now) {
            var output = this._calendar[key] || this._calendar['sameElse'];
            return isFunction(output) ? output.call(mom, now) : output;
          }

          var defaultLongDateFormat = {
            LTS: 'h:mm:ss A',
            LT: 'h:mm A',
            L: 'MM/DD/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A'
          };

          function longDateFormat(key) {
            var format = this._longDateFormat[key],
                formatUpper = this._longDateFormat[key.toUpperCase()];

            if (format || !formatUpper) {
              return format;
            }

            this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
              return val.slice(1);
            });
            return this._longDateFormat[key];
          }

          var defaultInvalidDate = 'Invalid date';

          function invalidDate() {
            return this._invalidDate;
          }

          var defaultOrdinal = '%d';
          var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

          function ordinal(number) {
            return this._ordinal.replace('%d', number);
          }

          var defaultRelativeTime = {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
          };

          function relativeTime(number, withoutSuffix, string, isFuture) {
            var output = this._relativeTime[string];
            return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
          }

          function pastFuture(diff, output) {
            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
            return isFunction(format) ? format(output) : format.replace(/%s/i, output);
          }

          var aliases = {};

          function addUnitAlias(unit, shorthand) {
            var lowerCase = unit.toLowerCase();
            aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
          }

          function normalizeUnits(units) {
            return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
          }

          function normalizeObjectUnits(inputObject) {
            var normalizedInput = {},
                normalizedProp,
                prop;

            for (prop in inputObject) {
              if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);

                if (normalizedProp) {
                  normalizedInput[normalizedProp] = inputObject[prop];
                }
              }
            }

            return normalizedInput;
          }

          var priorities = {};

          function addUnitPriority(unit, priority) {
            priorities[unit] = priority;
          }

          function getPrioritizedUnits(unitsObj) {
            var units = [];

            for (var u in unitsObj) {
              units.push({
                unit: u,
                priority: priorities[u]
              });
            }

            units.sort(function (a, b) {
              return a.priority - b.priority;
            });
            return units;
          }

          function zeroFill(number, targetLength, forceSign) {
            var absNumber = '' + Math.abs(number),
                zerosToFill = targetLength - absNumber.length,
                sign = number >= 0;
            return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
          }

          var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
          var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
          var formatFunctions = {};
          var formatTokenFunctions = {}; // token:    'M'
          // padded:   ['MM', 2]
          // ordinal:  'Mo'
          // callback: function () { this.month() + 1 }

          function addFormatToken(token, padded, ordinal, callback) {
            var func = callback;

            if (typeof callback === 'string') {
              func = function func() {
                return this[callback]();
              };
            }

            if (token) {
              formatTokenFunctions[token] = func;
            }

            if (padded) {
              formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
              };
            }

            if (ordinal) {
              formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
              };
            }
          }

          function removeFormattingTokens(input) {
            if (input.match(/\[[\s\S]/)) {
              return input.replace(/^\[|\]$/g, '');
            }

            return input.replace(/\\/g, '');
          }

          function makeFormatFunction(format) {
            var array = format.match(formattingTokens),
                i,
                length;

            for (i = 0, length = array.length; i < length; i++) {
              if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
              } else {
                array[i] = removeFormattingTokens(array[i]);
              }
            }

            return function (mom) {
              var output = '',
                  i;

              for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
              }

              return output;
            };
          } // format date using native date object


          function formatMoment(m, format) {
            if (!m.isValid()) {
              return m.localeData().invalidDate();
            }

            format = expandFormat(format, m.localeData());
            formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
            return formatFunctions[format](m);
          }

          function expandFormat(format, locale) {
            var i = 5;

            function replaceLongDateFormatTokens(input) {
              return locale.longDateFormat(input) || input;
            }

            localFormattingTokens.lastIndex = 0;

            while (i >= 0 && localFormattingTokens.test(format)) {
              format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
              localFormattingTokens.lastIndex = 0;
              i -= 1;
            }

            return format;
          }

          var match1 = /\d/; //       0 - 9

          var match2 = /\d\d/; //      00 - 99

          var match3 = /\d{3}/; //     000 - 999

          var match4 = /\d{4}/; //    0000 - 9999

          var match6 = /[+-]?\d{6}/; // -999999 - 999999

          var match1to2 = /\d\d?/; //       0 - 99

          var match3to4 = /\d\d\d\d?/; //     999 - 9999

          var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999

          var match1to3 = /\d{1,3}/; //       0 - 999

          var match1to4 = /\d{1,4}/; //       0 - 9999

          var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

          var matchUnsigned = /\d+/; //       0 - inf

          var matchSigned = /[+-]?\d+/; //    -inf - inf

          var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z

          var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

          var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
          // any word (or two) characters or numbers including two/three word month in arabic.
          // includes scottish gaelic two word and hyphenated months

          var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
          var regexes = {};

          function addRegexToken(token, regex, strictRegex) {
            regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
              return isStrict && strictRegex ? strictRegex : regex;
            };
          }

          function getParseRegexForToken(token, config) {
            if (!hasOwnProp(regexes, token)) {
              return new RegExp(unescapeFormat(token));
            }

            return regexes[token](config._strict, config._locale);
          } // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript


          function unescapeFormat(s) {
            return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
              return p1 || p2 || p3 || p4;
            }));
          }

          function regexEscape(s) {
            return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
          }

          var tokens = {};

          function addParseToken(token, callback) {
            var i,
                func = callback;

            if (typeof token === 'string') {
              token = [token];
            }

            if (isNumber(callback)) {
              func = function func(input, array) {
                array[callback] = toInt(input);
              };
            }

            for (i = 0; i < token.length; i++) {
              tokens[token[i]] = func;
            }
          }

          function addWeekParseToken(token, callback) {
            addParseToken(token, function (input, array, config, token) {
              config._w = config._w || {};
              callback(input, config._w, config, token);
            });
          }

          function addTimeToArrayFromToken(token, input, config) {
            if (input != null && hasOwnProp(tokens, token)) {
              tokens[token](input, config._a, config, token);
            }
          }

          var YEAR = 0;
          var MONTH = 1;
          var DATE = 2;
          var HOUR = 3;
          var MINUTE = 4;
          var SECOND = 5;
          var MILLISECOND = 6;
          var WEEK = 7;
          var WEEKDAY = 8; // FORMATTING

          addFormatToken('Y', 0, 0, function () {
            var y = this.year();
            return y <= 9999 ? '' + y : '+' + y;
          });
          addFormatToken(0, ['YY', 2], 0, function () {
            return this.year() % 100;
          });
          addFormatToken(0, ['YYYY', 4], 0, 'year');
          addFormatToken(0, ['YYYYY', 5], 0, 'year');
          addFormatToken(0, ['YYYYYY', 6, true], 0, 'year'); // ALIASES

          addUnitAlias('year', 'y'); // PRIORITIES

          addUnitPriority('year', 1); // PARSING

          addRegexToken('Y', matchSigned);
          addRegexToken('YY', match1to2, match2);
          addRegexToken('YYYY', match1to4, match4);
          addRegexToken('YYYYY', match1to6, match6);
          addRegexToken('YYYYYY', match1to6, match6);
          addParseToken(['YYYYY', 'YYYYYY'], YEAR);
          addParseToken('YYYY', function (input, array) {
            array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
          });
          addParseToken('YY', function (input, array) {
            array[YEAR] = hooks.parseTwoDigitYear(input);
          });
          addParseToken('Y', function (input, array) {
            array[YEAR] = parseInt(input, 10);
          }); // HELPERS

          function daysInYear(year) {
            return isLeapYear(year) ? 366 : 365;
          }

          function isLeapYear(year) {
            return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
          } // HOOKS


          hooks.parseTwoDigitYear = function (input) {
            return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
          }; // MOMENTS


          var getSetYear = makeGetSet('FullYear', true);

          function getIsLeapYear() {
            return isLeapYear(this.year());
          }

          function makeGetSet(unit, keepTime) {
            return function (value) {
              if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
              } else {
                return get(this, unit);
              }
            };
          }

          function get(mom, unit) {
            return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
          }

          function set$1(mom, unit, value) {
            if (mom.isValid() && !isNaN(value)) {
              if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
              } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
              }
            }
          } // MOMENTS


          function stringGet(units) {
            units = normalizeUnits(units);

            if (isFunction(this[units])) {
              return this[units]();
            }

            return this;
          }

          function stringSet(units, value) {
            if (typeof units === 'object') {
              units = normalizeObjectUnits(units);
              var prioritized = getPrioritizedUnits(units);

              for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
              }
            } else {
              units = normalizeUnits(units);

              if (isFunction(this[units])) {
                return this[units](value);
              }
            }

            return this;
          }

          function mod(n, x) {
            return (n % x + x) % x;
          }

          var indexOf;

          if (Array.prototype.indexOf) {
            indexOf = Array.prototype.indexOf;
          } else {
            indexOf = function indexOf(o) {
              // I know
              var i;

              for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                  return i;
                }
              }

              return -1;
            };
          }

          function daysInMonth(year, month) {
            if (isNaN(year) || isNaN(month)) {
              return NaN;
            }

            var modMonth = mod(month, 12);
            year += (month - modMonth) / 12;
            return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
          } // FORMATTING


          addFormatToken('M', ['MM', 2], 'Mo', function () {
            return this.month() + 1;
          });
          addFormatToken('MMM', 0, 0, function (format) {
            return this.localeData().monthsShort(this, format);
          });
          addFormatToken('MMMM', 0, 0, function (format) {
            return this.localeData().months(this, format);
          }); // ALIASES

          addUnitAlias('month', 'M'); // PRIORITY

          addUnitPriority('month', 8); // PARSING

          addRegexToken('M', match1to2);
          addRegexToken('MM', match1to2, match2);
          addRegexToken('MMM', function (isStrict, locale) {
            return locale.monthsShortRegex(isStrict);
          });
          addRegexToken('MMMM', function (isStrict, locale) {
            return locale.monthsRegex(isStrict);
          });
          addParseToken(['M', 'MM'], function (input, array) {
            array[MONTH] = toInt(input) - 1;
          });
          addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
            var month = config._locale.monthsParse(input, token, config._strict); // if we didn't find a month name, mark the date as invalid.


            if (month != null) {
              array[MONTH] = month;
            } else {
              getParsingFlags(config).invalidMonth = input;
            }
          }); // LOCALES

          var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
          var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');

          function localeMonths(m, format) {
            if (!m) {
              return isArray(this._months) ? this._months : this._months['standalone'];
            }

            return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
          }

          var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');

          function localeMonthsShort(m, format) {
            if (!m) {
              return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
            }

            return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
          }

          function handleStrictParse(monthName, format, strict) {
            var i,
                ii,
                mom,
                llc = monthName.toLocaleLowerCase();

            if (!this._monthsParse) {
              // this is not used
              this._monthsParse = [];
              this._longMonthsParse = [];
              this._shortMonthsParse = [];

              for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
              }
            }

            if (strict) {
              if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
              } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
              }
            } else {
              if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);

                if (ii !== -1) {
                  return ii;
                }

                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
              } else {
                ii = indexOf.call(this._longMonthsParse, llc);

                if (ii !== -1) {
                  return ii;
                }

                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
              }
            }
          }

          function localeMonthsParse(monthName, format, strict) {
            var i, mom, regex;

            if (this._monthsParseExact) {
              return handleStrictParse.call(this, monthName, format, strict);
            }

            if (!this._monthsParse) {
              this._monthsParse = [];
              this._longMonthsParse = [];
              this._shortMonthsParse = [];
            } // TODO: add sorting
            // Sorting makes sure if one month (or abbr) is a prefix of another
            // see sorting in computeMonthsParse


            for (i = 0; i < 12; i++) {
              // make the regex if we don't have it already
              mom = createUTC([2000, i]);

              if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
              }

              if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
              } // test the regex


              if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
              } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
              } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
              }
            }
          } // MOMENTS


          function setMonth(mom, value) {
            var dayOfMonth;

            if (!mom.isValid()) {
              // No op
              return mom;
            }

            if (typeof value === 'string') {
              if (/^\d+$/.test(value)) {
                value = toInt(value);
              } else {
                value = mom.localeData().monthsParse(value); // TODO: Another silent failure?

                if (!isNumber(value)) {
                  return mom;
                }
              }
            }

            dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));

            mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);

            return mom;
          }

          function getSetMonth(value) {
            if (value != null) {
              setMonth(this, value);
              hooks.updateOffset(this, true);
              return this;
            } else {
              return get(this, 'Month');
            }
          }

          function getDaysInMonth() {
            return daysInMonth(this.year(), this.month());
          }

          var defaultMonthsShortRegex = matchWord;

          function monthsShortRegex(isStrict) {
            if (this._monthsParseExact) {
              if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
              }

              if (isStrict) {
                return this._monthsShortStrictRegex;
              } else {
                return this._monthsShortRegex;
              }
            } else {
              if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
              }

              return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
            }
          }

          var defaultMonthsRegex = matchWord;

          function monthsRegex(isStrict) {
            if (this._monthsParseExact) {
              if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
              }

              if (isStrict) {
                return this._monthsStrictRegex;
              } else {
                return this._monthsRegex;
              }
            } else {
              if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
              }

              return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
            }
          }

          function computeMonthsParse() {
            function cmpLenRev(a, b) {
              return b.length - a.length;
            }

            var shortPieces = [],
                longPieces = [],
                mixedPieces = [],
                i,
                mom;

            for (i = 0; i < 12; i++) {
              // make the regex if we don't have it already
              mom = createUTC([2000, i]);
              shortPieces.push(this.monthsShort(mom, ''));
              longPieces.push(this.months(mom, ''));
              mixedPieces.push(this.months(mom, ''));
              mixedPieces.push(this.monthsShort(mom, ''));
            } // Sorting makes sure if one month (or abbr) is a prefix of another it
            // will match the longer piece.


            shortPieces.sort(cmpLenRev);
            longPieces.sort(cmpLenRev);
            mixedPieces.sort(cmpLenRev);

            for (i = 0; i < 12; i++) {
              shortPieces[i] = regexEscape(shortPieces[i]);
              longPieces[i] = regexEscape(longPieces[i]);
            }

            for (i = 0; i < 24; i++) {
              mixedPieces[i] = regexEscape(mixedPieces[i]);
            }

            this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
            this._monthsShortRegex = this._monthsRegex;
            this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
            this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
          }

          function createDate(y, m, d, h, M, s, ms) {
            // can't just apply() to create a date:
            // https://stackoverflow.com/q/181348
            var date; // the date constructor remaps years 0-99 to 1900-1999

            if (y < 100 && y >= 0) {
              // preserve leap years using a full 400 year cycle, then reset
              date = new Date(y + 400, m, d, h, M, s, ms);

              if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
              }
            } else {
              date = new Date(y, m, d, h, M, s, ms);
            }

            return date;
          }

          function createUTCDate(y) {
            var date; // the Date.UTC function remaps years 0-99 to 1900-1999

            if (y < 100 && y >= 0) {
              var args = Array.prototype.slice.call(arguments); // preserve leap years using a full 400 year cycle, then reset

              args[0] = y + 400;
              date = new Date(Date.UTC.apply(null, args));

              if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
              }
            } else {
              date = new Date(Date.UTC.apply(null, arguments));
            }

            return date;
          } // start-of-first-week - start-of-year


          function firstWeekOffset(year, dow, doy) {
            var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
                // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
            return -fwdlw + fwd - 1;
          } // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday


          function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
            var localWeekday = (7 + weekday - dow) % 7,
                weekOffset = firstWeekOffset(year, dow, doy),
                dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
                resYear,
                resDayOfYear;

            if (dayOfYear <= 0) {
              resYear = year - 1;
              resDayOfYear = daysInYear(resYear) + dayOfYear;
            } else if (dayOfYear > daysInYear(year)) {
              resYear = year + 1;
              resDayOfYear = dayOfYear - daysInYear(year);
            } else {
              resYear = year;
              resDayOfYear = dayOfYear;
            }

            return {
              year: resYear,
              dayOfYear: resDayOfYear
            };
          }

          function weekOfYear(mom, dow, doy) {
            var weekOffset = firstWeekOffset(mom.year(), dow, doy),
                week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
                resWeek,
                resYear;

            if (week < 1) {
              resYear = mom.year() - 1;
              resWeek = week + weeksInYear(resYear, dow, doy);
            } else if (week > weeksInYear(mom.year(), dow, doy)) {
              resWeek = week - weeksInYear(mom.year(), dow, doy);
              resYear = mom.year() + 1;
            } else {
              resYear = mom.year();
              resWeek = week;
            }

            return {
              week: resWeek,
              year: resYear
            };
          }

          function weeksInYear(year, dow, doy) {
            var weekOffset = firstWeekOffset(year, dow, doy),
                weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
            return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
          } // FORMATTING


          addFormatToken('w', ['ww', 2], 'wo', 'week');
          addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek'); // ALIASES

          addUnitAlias('week', 'w');
          addUnitAlias('isoWeek', 'W'); // PRIORITIES

          addUnitPriority('week', 5);
          addUnitPriority('isoWeek', 5); // PARSING

          addRegexToken('w', match1to2);
          addRegexToken('ww', match1to2, match2);
          addRegexToken('W', match1to2);
          addRegexToken('WW', match1to2, match2);
          addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
          }); // HELPERS
          // LOCALES

          function localeWeek(mom) {
            return weekOfYear(mom, this._week.dow, this._week.doy).week;
          }

          var defaultLocaleWeek = {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          };

          function localeFirstDayOfWeek() {
            return this._week.dow;
          }

          function localeFirstDayOfYear() {
            return this._week.doy;
          } // MOMENTS


          function getSetWeek(input) {
            var week = this.localeData().week(this);
            return input == null ? week : this.add((input - week) * 7, 'd');
          }

          function getSetISOWeek(input) {
            var week = weekOfYear(this, 1, 4).week;
            return input == null ? week : this.add((input - week) * 7, 'd');
          } // FORMATTING


          addFormatToken('d', 0, 'do', 'day');
          addFormatToken('dd', 0, 0, function (format) {
            return this.localeData().weekdaysMin(this, format);
          });
          addFormatToken('ddd', 0, 0, function (format) {
            return this.localeData().weekdaysShort(this, format);
          });
          addFormatToken('dddd', 0, 0, function (format) {
            return this.localeData().weekdays(this, format);
          });
          addFormatToken('e', 0, 0, 'weekday');
          addFormatToken('E', 0, 0, 'isoWeekday'); // ALIASES

          addUnitAlias('day', 'd');
          addUnitAlias('weekday', 'e');
          addUnitAlias('isoWeekday', 'E'); // PRIORITY

          addUnitPriority('day', 11);
          addUnitPriority('weekday', 11);
          addUnitPriority('isoWeekday', 11); // PARSING

          addRegexToken('d', match1to2);
          addRegexToken('e', match1to2);
          addRegexToken('E', match1to2);
          addRegexToken('dd', function (isStrict, locale) {
            return locale.weekdaysMinRegex(isStrict);
          });
          addRegexToken('ddd', function (isStrict, locale) {
            return locale.weekdaysShortRegex(isStrict);
          });
          addRegexToken('dddd', function (isStrict, locale) {
            return locale.weekdaysRegex(isStrict);
          });
          addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
            var weekday = config._locale.weekdaysParse(input, token, config._strict); // if we didn't get a weekday name, mark the date as invalid


            if (weekday != null) {
              week.d = weekday;
            } else {
              getParsingFlags(config).invalidWeekday = input;
            }
          });
          addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
            week[token] = toInt(input);
          }); // HELPERS

          function parseWeekday(input, locale) {
            if (typeof input !== 'string') {
              return input;
            }

            if (!isNaN(input)) {
              return parseInt(input, 10);
            }

            input = locale.weekdaysParse(input);

            if (typeof input === 'number') {
              return input;
            }

            return null;
          }

          function parseIsoWeekday(input, locale) {
            if (typeof input === 'string') {
              return locale.weekdaysParse(input) % 7 || 7;
            }

            return isNaN(input) ? null : input;
          } // LOCALES


          function shiftWeekdays(ws, n) {
            return ws.slice(n, 7).concat(ws.slice(0, n));
          }

          var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');

          function localeWeekdays(m, format) {
            var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
            return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
          }

          var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');

          function localeWeekdaysShort(m) {
            return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
          }

          var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');

          function localeWeekdaysMin(m) {
            return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
          }

          function handleStrictParse$1(weekdayName, format, strict) {
            var i,
                ii,
                mom,
                llc = weekdayName.toLocaleLowerCase();

            if (!this._weekdaysParse) {
              this._weekdaysParse = [];
              this._shortWeekdaysParse = [];
              this._minWeekdaysParse = [];

              for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
              }
            }

            if (strict) {
              if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
              } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
              } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
              }
            } else {
              if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);

                if (ii !== -1) {
                  return ii;
                }

                ii = indexOf.call(this._shortWeekdaysParse, llc);

                if (ii !== -1) {
                  return ii;
                }

                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
              } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);

                if (ii !== -1) {
                  return ii;
                }

                ii = indexOf.call(this._weekdaysParse, llc);

                if (ii !== -1) {
                  return ii;
                }

                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
              } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);

                if (ii !== -1) {
                  return ii;
                }

                ii = indexOf.call(this._weekdaysParse, llc);

                if (ii !== -1) {
                  return ii;
                }

                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
              }
            }
          }

          function localeWeekdaysParse(weekdayName, format, strict) {
            var i, mom, regex;

            if (this._weekdaysParseExact) {
              return handleStrictParse$1.call(this, weekdayName, format, strict);
            }

            if (!this._weekdaysParse) {
              this._weekdaysParse = [];
              this._minWeekdaysParse = [];
              this._shortWeekdaysParse = [];
              this._fullWeekdaysParse = [];
            }

            for (i = 0; i < 7; i++) {
              // make the regex if we don't have it already
              mom = createUTC([2000, 1]).day(i);

              if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
              }

              if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
              } // test the regex


              if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
              } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
              } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
              } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
              }
            }
          } // MOMENTS


          function getSetDayOfWeek(input) {
            if (!this.isValid()) {
              return input != null ? this : NaN;
            }

            var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();

            if (input != null) {
              input = parseWeekday(input, this.localeData());
              return this.add(input - day, 'd');
            } else {
              return day;
            }
          }

          function getSetLocaleDayOfWeek(input) {
            if (!this.isValid()) {
              return input != null ? this : NaN;
            }

            var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return input == null ? weekday : this.add(input - weekday, 'd');
          }

          function getSetISODayOfWeek(input) {
            if (!this.isValid()) {
              return input != null ? this : NaN;
            } // behaves the same as moment#day except
            // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
            // as a setter, sunday should belong to the previous week.


            if (input != null) {
              var weekday = parseIsoWeekday(input, this.localeData());
              return this.day(this.day() % 7 ? weekday : weekday - 7);
            } else {
              return this.day() || 7;
            }
          }

          var defaultWeekdaysRegex = matchWord;

          function weekdaysRegex(isStrict) {
            if (this._weekdaysParseExact) {
              if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
              }

              if (isStrict) {
                return this._weekdaysStrictRegex;
              } else {
                return this._weekdaysRegex;
              }
            } else {
              if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
              }

              return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
            }
          }

          var defaultWeekdaysShortRegex = matchWord;

          function weekdaysShortRegex(isStrict) {
            if (this._weekdaysParseExact) {
              if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
              }

              if (isStrict) {
                return this._weekdaysShortStrictRegex;
              } else {
                return this._weekdaysShortRegex;
              }
            } else {
              if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
              }

              return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
            }
          }

          var defaultWeekdaysMinRegex = matchWord;

          function weekdaysMinRegex(isStrict) {
            if (this._weekdaysParseExact) {
              if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
              }

              if (isStrict) {
                return this._weekdaysMinStrictRegex;
              } else {
                return this._weekdaysMinRegex;
              }
            } else {
              if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
              }

              return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
            }
          }

          function computeWeekdaysParse() {
            function cmpLenRev(a, b) {
              return b.length - a.length;
            }

            var minPieces = [],
                shortPieces = [],
                longPieces = [],
                mixedPieces = [],
                i,
                mom,
                minp,
                shortp,
                longp;

            for (i = 0; i < 7; i++) {
              // make the regex if we don't have it already
              mom = createUTC([2000, 1]).day(i);
              minp = this.weekdaysMin(mom, '');
              shortp = this.weekdaysShort(mom, '');
              longp = this.weekdays(mom, '');
              minPieces.push(minp);
              shortPieces.push(shortp);
              longPieces.push(longp);
              mixedPieces.push(minp);
              mixedPieces.push(shortp);
              mixedPieces.push(longp);
            } // Sorting makes sure if one weekday (or abbr) is a prefix of another it
            // will match the longer piece.


            minPieces.sort(cmpLenRev);
            shortPieces.sort(cmpLenRev);
            longPieces.sort(cmpLenRev);
            mixedPieces.sort(cmpLenRev);

            for (i = 0; i < 7; i++) {
              shortPieces[i] = regexEscape(shortPieces[i]);
              longPieces[i] = regexEscape(longPieces[i]);
              mixedPieces[i] = regexEscape(mixedPieces[i]);
            }

            this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
            this._weekdaysShortRegex = this._weekdaysRegex;
            this._weekdaysMinRegex = this._weekdaysRegex;
            this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
            this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
            this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
          } // FORMATTING


          function hFormat() {
            return this.hours() % 12 || 12;
          }

          function kFormat() {
            return this.hours() || 24;
          }

          addFormatToken('H', ['HH', 2], 0, 'hour');
          addFormatToken('h', ['hh', 2], 0, hFormat);
          addFormatToken('k', ['kk', 2], 0, kFormat);
          addFormatToken('hmm', 0, 0, function () {
            return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
          });
          addFormatToken('hmmss', 0, 0, function () {
            return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
          });
          addFormatToken('Hmm', 0, 0, function () {
            return '' + this.hours() + zeroFill(this.minutes(), 2);
          });
          addFormatToken('Hmmss', 0, 0, function () {
            return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
          });

          function meridiem(token, lowercase) {
            addFormatToken(token, 0, 0, function () {
              return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
            });
          }

          meridiem('a', true);
          meridiem('A', false); // ALIASES

          addUnitAlias('hour', 'h'); // PRIORITY

          addUnitPriority('hour', 13); // PARSING

          function matchMeridiem(isStrict, locale) {
            return locale._meridiemParse;
          }

          addRegexToken('a', matchMeridiem);
          addRegexToken('A', matchMeridiem);
          addRegexToken('H', match1to2);
          addRegexToken('h', match1to2);
          addRegexToken('k', match1to2);
          addRegexToken('HH', match1to2, match2);
          addRegexToken('hh', match1to2, match2);
          addRegexToken('kk', match1to2, match2);
          addRegexToken('hmm', match3to4);
          addRegexToken('hmmss', match5to6);
          addRegexToken('Hmm', match3to4);
          addRegexToken('Hmmss', match5to6);
          addParseToken(['H', 'HH'], HOUR);
          addParseToken(['k', 'kk'], function (input, array, config) {
            var kInput = toInt(input);
            array[HOUR] = kInput === 24 ? 0 : kInput;
          });
          addParseToken(['a', 'A'], function (input, array, config) {
            config._isPm = config._locale.isPM(input);
            config._meridiem = input;
          });
          addParseToken(['h', 'hh'], function (input, array, config) {
            array[HOUR] = toInt(input);
            getParsingFlags(config).bigHour = true;
          });
          addParseToken('hmm', function (input, array, config) {
            var pos = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos));
            array[MINUTE] = toInt(input.substr(pos));
            getParsingFlags(config).bigHour = true;
          });
          addParseToken('hmmss', function (input, array, config) {
            var pos1 = input.length - 4;
            var pos2 = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos1));
            array[MINUTE] = toInt(input.substr(pos1, 2));
            array[SECOND] = toInt(input.substr(pos2));
            getParsingFlags(config).bigHour = true;
          });
          addParseToken('Hmm', function (input, array, config) {
            var pos = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos));
            array[MINUTE] = toInt(input.substr(pos));
          });
          addParseToken('Hmmss', function (input, array, config) {
            var pos1 = input.length - 4;
            var pos2 = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos1));
            array[MINUTE] = toInt(input.substr(pos1, 2));
            array[SECOND] = toInt(input.substr(pos2));
          }); // LOCALES

          function localeIsPM(input) {
            // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
            // Using charAt should be more compatible.
            return (input + '').toLowerCase().charAt(0) === 'p';
          }

          var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;

          function localeMeridiem(hours, minutes, isLower) {
            if (hours > 11) {
              return isLower ? 'pm' : 'PM';
            } else {
              return isLower ? 'am' : 'AM';
            }
          } // MOMENTS
          // Setting the hour should keep the time, because the user explicitly
          // specified which hour they want. So trying to maintain the same hour (in
          // a new timezone) makes sense. Adding/subtracting hours does not follow
          // this rule.


          var getSetHour = makeGetSet('Hours', true);
          var baseConfig = {
            calendar: defaultCalendar,
            longDateFormat: defaultLongDateFormat,
            invalidDate: defaultInvalidDate,
            ordinal: defaultOrdinal,
            dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
            relativeTime: defaultRelativeTime,
            months: defaultLocaleMonths,
            monthsShort: defaultLocaleMonthsShort,
            week: defaultLocaleWeek,
            weekdays: defaultLocaleWeekdays,
            weekdaysMin: defaultLocaleWeekdaysMin,
            weekdaysShort: defaultLocaleWeekdaysShort,
            meridiemParse: defaultLocaleMeridiemParse
          }; // internal storage for locale config files

          var locales = {};
          var localeFamilies = {};
          var globalLocale;

          function normalizeLocale(key) {
            return key ? key.toLowerCase().replace('_', '-') : key;
          } // pick the locale from the array
          // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
          // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root


          function chooseLocale(names) {
            var i = 0,
                j,
                next,
                locale,
                split;

            while (i < names.length) {
              split = normalizeLocale(names[i]).split('-');
              j = split.length;
              next = normalizeLocale(names[i + 1]);
              next = next ? next.split('-') : null;

              while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));

                if (locale) {
                  return locale;
                }

                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                  //the next array item is better than a shallower substring of this one
                  break;
                }

                j--;
              }

              i++;
            }

            return globalLocale;
          }

          function loadLocale(name) {
            var oldLocale = null; // TODO: Find a better way to register and load all the locales in Node

            if (!locales[name] && typeof module !== 'undefined' && module && module.exports) {
              try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;

                __webpack_require__(1115)("./" + name);

                getSetGlobalLocale(oldLocale);
              } catch (e) {}
            }

            return locales[name];
          } // This function will load locale and then set the global locale.  If
          // no arguments are passed in, it will simply return the current global
          // locale key.


          function getSetGlobalLocale(key, values) {
            var data;

            if (key) {
              if (isUndefined(values)) {
                data = getLocale(key);
              } else {
                data = defineLocale(key, values);
              }

              if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
              } else {
                if (typeof console !== 'undefined' && console.warn) {
                  //warn user if arguments are passed but the locale could not be set
                  console.warn('Locale ' + key + ' not found. Did you forget to load it?');
                }
              }
            }

            return globalLocale._abbr;
          }

          function defineLocale(name, config) {
            if (config !== null) {
              var locale,
                  parentConfig = baseConfig;
              config.abbr = name;

              if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
              } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                  parentConfig = locales[config.parentLocale]._config;
                } else {
                  locale = loadLocale(config.parentLocale);

                  if (locale != null) {
                    parentConfig = locale._config;
                  } else {
                    if (!localeFamilies[config.parentLocale]) {
                      localeFamilies[config.parentLocale] = [];
                    }

                    localeFamilies[config.parentLocale].push({
                      name: name,
                      config: config
                    });
                    return null;
                  }
                }
              }

              locales[name] = new Locale(mergeConfigs(parentConfig, config));

              if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                  defineLocale(x.name, x.config);
                });
              } // backwards compat for now: also set the locale
              // make sure we set the locale AFTER all child locales have been
              // created, so we won't end up with the child locale set.


              getSetGlobalLocale(name);
              return locales[name];
            } else {
              // useful for testing
              delete locales[name];
              return null;
            }
          }

          function updateLocale(name, config) {
            if (config != null) {
              var locale,
                  tmpLocale,
                  parentConfig = baseConfig; // MERGE

              tmpLocale = loadLocale(name);

              if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
              }

              config = mergeConfigs(parentConfig, config);
              locale = new Locale(config);
              locale.parentLocale = locales[name];
              locales[name] = locale; // backwards compat for now: also set the locale

              getSetGlobalLocale(name);
            } else {
              // pass null for config to unupdate, useful for tests
              if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                  locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                  delete locales[name];
                }
              }
            }

            return locales[name];
          } // returns locale data


          function getLocale(key) {
            var locale;

            if (key && key._locale && key._locale._abbr) {
              key = key._locale._abbr;
            }

            if (!key) {
              return globalLocale;
            }

            if (!isArray(key)) {
              //short-circuit everything else
              locale = loadLocale(key);

              if (locale) {
                return locale;
              }

              key = [key];
            }

            return chooseLocale(key);
          }

          function listLocales() {
            return keys(locales);
          }

          function checkOverflow(m) {
            var overflow;
            var a = m._a;

            if (a && getParsingFlags(m).overflow === -2) {
              overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

              if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
              }

              if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
              }

              if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
              }

              getParsingFlags(m).overflow = overflow;
            }

            return m;
          } // Pick the first defined of two or three arguments.


          function defaults(a, b, c) {
            if (a != null) {
              return a;
            }

            if (b != null) {
              return b;
            }

            return c;
          }

          function currentDateArray(config) {
            // hooks is actually the exported moment object
            var nowValue = new Date(hooks.now());

            if (config._useUTC) {
              return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
            }

            return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
          } // convert an array to a date.
          // the array should mirror the parameters below
          // note: all values past the year are optional and will default to the lowest possible value.
          // [year, month, day , hour, minute, second, millisecond]


          function configFromArray(config) {
            var i,
                date,
                input = [],
                currentDate,
                expectedWeekday,
                yearToUse;

            if (config._d) {
              return;
            }

            currentDate = currentDateArray(config); //compute day of the year from weeks and weekdays

            if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
              dayOfYearFromWeekInfo(config);
            } //if the day of the year is set, figure out what it is


            if (config._dayOfYear != null) {
              yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

              if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
              }

              date = createUTCDate(yearToUse, 0, config._dayOfYear);
              config._a[MONTH] = date.getUTCMonth();
              config._a[DATE] = date.getUTCDate();
            } // Default to current date.
            // * if no year, month, day of month are given, default to today
            // * if day of month is given, default month and year
            // * if month is given, default only year
            // * if year is given, don't default anything


            for (i = 0; i < 3 && config._a[i] == null; ++i) {
              config._a[i] = input[i] = currentDate[i];
            } // Zero out whatever was not defaulted, including time


            for (; i < 7; i++) {
              config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
            } // Check for 24:00:00.000


            if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
              config._nextDay = true;
              config._a[HOUR] = 0;
            }

            config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
            expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay(); // Apply timezone offset from input. The actual utcOffset can be changed
            // with parseZone.

            if (config._tzm != null) {
              config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            }

            if (config._nextDay) {
              config._a[HOUR] = 24;
            } // check for mismatching day of week


            if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
              getParsingFlags(config).weekdayMismatch = true;
            }
          }

          function dayOfYearFromWeekInfo(config) {
            var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
            w = config._w;

            if (w.GG != null || w.W != null || w.E != null) {
              dow = 1;
              doy = 4; // TODO: We need to take the current isoWeekYear, but that depends on
              // how we interpret now (local, utc, fixed offset). So create
              // a now version of current config (take local/utc/offset flags, and
              // create now).

              weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
              week = defaults(w.W, 1);
              weekday = defaults(w.E, 1);

              if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
              }
            } else {
              dow = config._locale._week.dow;
              doy = config._locale._week.doy;
              var curWeek = weekOfYear(createLocal(), dow, doy);
              weekYear = defaults(w.gg, config._a[YEAR], curWeek.year); // Default to current week.

              week = defaults(w.w, curWeek.week);

              if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;

                if (weekday < 0 || weekday > 6) {
                  weekdayOverflow = true;
                }
              } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;

                if (w.e < 0 || w.e > 6) {
                  weekdayOverflow = true;
                }
              } else {
                // default to beginning of week
                weekday = dow;
              }
            }

            if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
              getParsingFlags(config)._overflowWeeks = true;
            } else if (weekdayOverflow != null) {
              getParsingFlags(config)._overflowWeekday = true;
            } else {
              temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
              config._a[YEAR] = temp.year;
              config._dayOfYear = temp.dayOfYear;
            }
          } // iso 8601 regex
          // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)


          var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
          var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
          var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
          var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], // YYYYMM is NOT allowed by the standard
          ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]]; // iso time formats and regexes

          var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];
          var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i; // date from iso format

          function configFromISO(config) {
            var i,
                l,
                string = config._i,
                match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
                allowTime,
                dateFormat,
                timeFormat,
                tzFormat;

            if (match) {
              getParsingFlags(config).iso = true;

              for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                  dateFormat = isoDates[i][0];
                  allowTime = isoDates[i][2] !== false;
                  break;
                }
              }

              if (dateFormat == null) {
                config._isValid = false;
                return;
              }

              if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                  if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                  }
                }

                if (timeFormat == null) {
                  config._isValid = false;
                  return;
                }
              }

              if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
              }

              if (match[4]) {
                if (tzRegex.exec(match[4])) {
                  tzFormat = 'Z';
                } else {
                  config._isValid = false;
                  return;
                }
              }

              config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
              configFromStringAndFormat(config);
            } else {
              config._isValid = false;
            }
          } // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3


          var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

          function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
            var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

            if (secondStr) {
              result.push(parseInt(secondStr, 10));
            }

            return result;
          }

          function untruncateYear(yearStr) {
            var year = parseInt(yearStr, 10);

            if (year <= 49) {
              return 2000 + year;
            } else if (year <= 999) {
              return 1900 + year;
            }

            return year;
          }

          function preprocessRFC2822(s) {
            // Remove comments and folding whitespace and replace multiple-spaces with a single space
            return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
          }

          function checkWeekday(weekdayStr, parsedInput, config) {
            if (weekdayStr) {
              // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
              var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                  weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();

              if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
              }
            }

            return true;
          }

          var obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60
          };

          function calculateOffset(obsOffset, militaryOffset, numOffset) {
            if (obsOffset) {
              return obsOffsets[obsOffset];
            } else if (militaryOffset) {
              // the only allowed military tz is Z
              return 0;
            } else {
              var hm = parseInt(numOffset, 10);
              var m = hm % 100,
                  h = (hm - m) / 100;
              return h * 60 + m;
            }
          } // date and time from ref 2822 format


          function configFromRFC2822(config) {
            var match = rfc2822.exec(preprocessRFC2822(config._i));

            if (match) {
              var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);

              if (!checkWeekday(match[1], parsedArray, config)) {
                return;
              }

              config._a = parsedArray;
              config._tzm = calculateOffset(match[8], match[9], match[10]);
              config._d = createUTCDate.apply(null, config._a);

              config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

              getParsingFlags(config).rfc2822 = true;
            } else {
              config._isValid = false;
            }
          } // date from iso format or fallback


          function configFromString(config) {
            var matched = aspNetJsonRegex.exec(config._i);

            if (matched !== null) {
              config._d = new Date(+matched[1]);
              return;
            }

            configFromISO(config);

            if (config._isValid === false) {
              delete config._isValid;
            } else {
              return;
            }

            configFromRFC2822(config);

            if (config._isValid === false) {
              delete config._isValid;
            } else {
              return;
            } // Final attempt, use Input Fallback


            hooks.createFromInputFallback(config);
          }

          hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
          }); // constant that refers to the ISO standard

          hooks.ISO_8601 = function () {}; // constant that refers to the RFC 2822 form


          hooks.RFC_2822 = function () {}; // date from string and format string


          function configFromStringAndFormat(config) {
            // TODO: Move this to another part of the creation flow to prevent circular deps
            if (config._f === hooks.ISO_8601) {
              configFromISO(config);
              return;
            }

            if (config._f === hooks.RFC_2822) {
              configFromRFC2822(config);
              return;
            }

            config._a = [];
            getParsingFlags(config).empty = true; // This array is used to make a Date, either with `new Date` or `Date.UTC`

            var string = '' + config._i,
                i,
                parsedInput,
                tokens,
                token,
                skipped,
                stringLength = string.length,
                totalParsedInputLength = 0;
            tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

            for (i = 0; i < tokens.length; i++) {
              token = tokens[i];
              parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0]; // console.log('token', token, 'parsedInput', parsedInput,
              //         'regex', getParseRegexForToken(token, config));

              if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));

                if (skipped.length > 0) {
                  getParsingFlags(config).unusedInput.push(skipped);
                }

                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
              } // don't parse if it's not a known token


              if (formatTokenFunctions[token]) {
                if (parsedInput) {
                  getParsingFlags(config).empty = false;
                } else {
                  getParsingFlags(config).unusedTokens.push(token);
                }

                addTimeToArrayFromToken(token, parsedInput, config);
              } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
              }
            } // add remaining unparsed input length to the string


            getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;

            if (string.length > 0) {
              getParsingFlags(config).unusedInput.push(string);
            } // clear _12h flag if hour is <= 12


            if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
              getParsingFlags(config).bigHour = undefined;
            }

            getParsingFlags(config).parsedDateParts = config._a.slice(0);
            getParsingFlags(config).meridiem = config._meridiem; // handle meridiem

            config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
            configFromArray(config);
            checkOverflow(config);
          }

          function meridiemFixWrap(locale, hour, meridiem) {
            var isPm;

            if (meridiem == null) {
              // nothing to do
              return hour;
            }

            if (locale.meridiemHour != null) {
              return locale.meridiemHour(hour, meridiem);
            } else if (locale.isPM != null) {
              // Fallback
              isPm = locale.isPM(meridiem);

              if (isPm && hour < 12) {
                hour += 12;
              }

              if (!isPm && hour === 12) {
                hour = 0;
              }

              return hour;
            } else {
              // this is not supposed to happen
              return hour;
            }
          } // date from string and array of format strings


          function configFromStringAndArray(config) {
            var tempConfig, bestMoment, scoreToBeat, i, currentScore;

            if (config._f.length === 0) {
              getParsingFlags(config).invalidFormat = true;
              config._d = new Date(NaN);
              return;
            }

            for (i = 0; i < config._f.length; i++) {
              currentScore = 0;
              tempConfig = copyConfig({}, config);

              if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
              }

              tempConfig._f = config._f[i];
              configFromStringAndFormat(tempConfig);

              if (!isValid(tempConfig)) {
                continue;
              } // if there is any input that was not parsed add a penalty for that format


              currentScore += getParsingFlags(tempConfig).charsLeftOver; //or tokens

              currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
              getParsingFlags(tempConfig).score = currentScore;

              if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
              }
            }

            extend(config, bestMoment || tempConfig);
          }

          function configFromObject(config) {
            if (config._d) {
              return;
            }

            var i = normalizeObjectUnits(config._i);
            config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
              return obj && parseInt(obj, 10);
            });
            configFromArray(config);
          }

          function createFromConfig(config) {
            var res = new Moment(checkOverflow(prepareConfig(config)));

            if (res._nextDay) {
              // Adding is smart enough around DST
              res.add(1, 'd');
              res._nextDay = undefined;
            }

            return res;
          }

          function prepareConfig(config) {
            var input = config._i,
                format = config._f;
            config._locale = config._locale || getLocale(config._l);

            if (input === null || format === undefined && input === '') {
              return createInvalid({
                nullInput: true
              });
            }

            if (typeof input === 'string') {
              config._i = input = config._locale.preparse(input);
            }

            if (isMoment(input)) {
              return new Moment(checkOverflow(input));
            } else if (isDate(input)) {
              config._d = input;
            } else if (isArray(format)) {
              configFromStringAndArray(config);
            } else if (format) {
              configFromStringAndFormat(config);
            } else {
              configFromInput(config);
            }

            if (!isValid(config)) {
              config._d = null;
            }

            return config;
          }

          function configFromInput(config) {
            var input = config._i;

            if (isUndefined(input)) {
              config._d = new Date(hooks.now());
            } else if (isDate(input)) {
              config._d = new Date(input.valueOf());
            } else if (typeof input === 'string') {
              configFromString(config);
            } else if (isArray(input)) {
              config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
              });
              configFromArray(config);
            } else if (isObject(input)) {
              configFromObject(config);
            } else if (isNumber(input)) {
              // from milliseconds
              config._d = new Date(input);
            } else {
              hooks.createFromInputFallback(config);
            }
          }

          function createLocalOrUTC(input, format, locale, strict, isUTC) {
            var c = {};

            if (locale === true || locale === false) {
              strict = locale;
              locale = undefined;
            }

            if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
              input = undefined;
            } // object construction must be done this way.
            // https://github.com/moment/moment/issues/1423


            c._isAMomentObject = true;
            c._useUTC = c._isUTC = isUTC;
            c._l = locale;
            c._i = input;
            c._f = format;
            c._strict = strict;
            return createFromConfig(c);
          }

          function createLocal(input, format, locale, strict) {
            return createLocalOrUTC(input, format, locale, strict, false);
          }

          var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
            var other = createLocal.apply(null, arguments);

            if (this.isValid() && other.isValid()) {
              return other < this ? this : other;
            } else {
              return createInvalid();
            }
          });
          var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
            var other = createLocal.apply(null, arguments);

            if (this.isValid() && other.isValid()) {
              return other > this ? this : other;
            } else {
              return createInvalid();
            }
          }); // Pick a moment m from moments so that m[fn](other) is true for all
          // other. This relies on the function fn to be transitive.
          //
          // moments should either be an array of moment objects or an array, whose
          // first element is an array of moment objects.

          function pickBy(fn, moments) {
            var res, i;

            if (moments.length === 1 && isArray(moments[0])) {
              moments = moments[0];
            }

            if (!moments.length) {
              return createLocal();
            }

            res = moments[0];

            for (i = 1; i < moments.length; ++i) {
              if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
              }
            }

            return res;
          } // TODO: Use [].sort instead?


          function min() {
            var args = [].slice.call(arguments, 0);
            return pickBy('isBefore', args);
          }

          function max() {
            var args = [].slice.call(arguments, 0);
            return pickBy('isAfter', args);
          }

          var now = function now() {
            return Date.now ? Date.now() : +new Date();
          };

          var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

          function isDurationValid(m) {
            for (var key in m) {
              if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
              }
            }

            var unitHasDecimal = false;

            for (var i = 0; i < ordering.length; ++i) {
              if (m[ordering[i]]) {
                if (unitHasDecimal) {
                  return false; // only allow non-integers for smallest unit
                }

                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                  unitHasDecimal = true;
                }
              }
            }

            return true;
          }

          function isValid$1() {
            return this._isValid;
          }

          function createInvalid$1() {
            return createDuration(NaN);
          }

          function Duration(duration) {
            var normalizedInput = normalizeObjectUnits(duration),
                years = normalizedInput.year || 0,
                quarters = normalizedInput.quarter || 0,
                months = normalizedInput.month || 0,
                weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
                days = normalizedInput.day || 0,
                hours = normalizedInput.hour || 0,
                minutes = normalizedInput.minute || 0,
                seconds = normalizedInput.second || 0,
                milliseconds = normalizedInput.millisecond || 0;
            this._isValid = isDurationValid(normalizedInput); // representation for dateAddRemove

            this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
            // Because of dateAddRemove treats 24 hours as different from a
            // day when working around DST, we need to store them separately

            this._days = +days + weeks * 7; // It is impossible to translate months into days without knowing
            // which months you are are talking about, so we have to store
            // it separately.

            this._months = +months + quarters * 3 + years * 12;
            this._data = {};
            this._locale = getLocale();

            this._bubble();
          }

          function isDuration(obj) {
            return obj instanceof Duration;
          }

          function absRound(number) {
            if (number < 0) {
              return Math.round(-1 * number) * -1;
            } else {
              return Math.round(number);
            }
          } // FORMATTING


          function offset(token, separator) {
            addFormatToken(token, 0, 0, function () {
              var offset = this.utcOffset();
              var sign = '+';

              if (offset < 0) {
                offset = -offset;
                sign = '-';
              }

              return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
            });
          }

          offset('Z', ':');
          offset('ZZ', ''); // PARSING

          addRegexToken('Z', matchShortOffset);
          addRegexToken('ZZ', matchShortOffset);
          addParseToken(['Z', 'ZZ'], function (input, array, config) {
            config._useUTC = true;
            config._tzm = offsetFromString(matchShortOffset, input);
          }); // HELPERS
          // timezone chunker
          // '+10:00' > ['10',  '00']
          // '-1530'  > ['-15', '30']

          var chunkOffset = /([\+\-]|\d\d)/gi;

          function offsetFromString(matcher, string) {
            var matches = (string || '').match(matcher);

            if (matches === null) {
              return null;
            }

            var chunk = matches[matches.length - 1] || [];
            var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
            var minutes = +(parts[1] * 60) + toInt(parts[2]);
            return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
          } // Return a moment from input, that is local/utc/zone equivalent to model.


          function cloneWithOffset(input, model) {
            var res, diff;

            if (model._isUTC) {
              res = model.clone();
              diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf(); // Use low-level api, because this fn is low-level api.

              res._d.setTime(res._d.valueOf() + diff);

              hooks.updateOffset(res, false);
              return res;
            } else {
              return createLocal(input).local();
            }
          }

          function getDateOffset(m) {
            // On Firefox.24 Date#getTimezoneOffset returns a floating point.
            // https://github.com/moment/moment/pull/1871
            return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
          } // HOOKS
          // This function will be called whenever a moment is mutated.
          // It is intended to keep the offset in sync with the timezone.


          hooks.updateOffset = function () {}; // MOMENTS
          // keepLocalTime = true means only change the timezone, without
          // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
          // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
          // +0200, so we adjust the time as needed, to be valid.
          //
          // Keeping the time actually adds/subtracts (one hour)
          // from the actual represented time. That is why we call updateOffset
          // a second time. In case it wants us to change the offset again
          // _changeInProgress == true case, then we have to adjust, because
          // there is no such time in the given timezone.


          function getSetOffset(input, keepLocalTime, keepMinutes) {
            var offset = this._offset || 0,
                localAdjust;

            if (!this.isValid()) {
              return input != null ? this : NaN;
            }

            if (input != null) {
              if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);

                if (input === null) {
                  return this;
                }
              } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
              }

              if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
              }

              this._offset = input;
              this._isUTC = true;

              if (localAdjust != null) {
                this.add(localAdjust, 'm');
              }

              if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                  addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                  this._changeInProgress = true;
                  hooks.updateOffset(this, true);
                  this._changeInProgress = null;
                }
              }

              return this;
            } else {
              return this._isUTC ? offset : getDateOffset(this);
            }
          }

          function getSetZone(input, keepLocalTime) {
            if (input != null) {
              if (typeof input !== 'string') {
                input = -input;
              }

              this.utcOffset(input, keepLocalTime);
              return this;
            } else {
              return -this.utcOffset();
            }
          }

          function setOffsetToUTC(keepLocalTime) {
            return this.utcOffset(0, keepLocalTime);
          }

          function setOffsetToLocal(keepLocalTime) {
            if (this._isUTC) {
              this.utcOffset(0, keepLocalTime);
              this._isUTC = false;

              if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
              }
            }

            return this;
          }

          function setOffsetToParsedOffset() {
            if (this._tzm != null) {
              this.utcOffset(this._tzm, false, true);
            } else if (typeof this._i === 'string') {
              var tZone = offsetFromString(matchOffset, this._i);

              if (tZone != null) {
                this.utcOffset(tZone);
              } else {
                this.utcOffset(0, true);
              }
            }

            return this;
          }

          function hasAlignedHourOffset(input) {
            if (!this.isValid()) {
              return false;
            }

            input = input ? createLocal(input).utcOffset() : 0;
            return (this.utcOffset() - input) % 60 === 0;
          }

          function isDaylightSavingTime() {
            return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
          }

          function isDaylightSavingTimeShifted() {
            if (!isUndefined(this._isDSTShifted)) {
              return this._isDSTShifted;
            }

            var c = {};
            copyConfig(c, this);
            c = prepareConfig(c);

            if (c._a) {
              var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
              this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
            } else {
              this._isDSTShifted = false;
            }

            return this._isDSTShifted;
          }

          function isLocal() {
            return this.isValid() ? !this._isUTC : false;
          }

          function isUtcOffset() {
            return this.isValid() ? this._isUTC : false;
          }

          function isUtc() {
            return this.isValid() ? this._isUTC && this._offset === 0 : false;
          } // ASP.NET json date format regex


          var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/; // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
          // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
          // and further modified to allow for strings containing both week and day

          var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

          function createDuration(input, key) {
            var duration = input,
                // matching against regexp is expensive, do it on demand
            match = null,
                sign,
                ret,
                diffRes;

            if (isDuration(input)) {
              duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
              };
            } else if (isNumber(input)) {
              duration = {};

              if (key) {
                duration[key] = input;
              } else {
                duration.milliseconds = input;
              }
            } else if (!!(match = aspNetRegex.exec(input))) {
              sign = match[1] === '-' ? -1 : 1;
              duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match

              };
            } else if (!!(match = isoRegex.exec(input))) {
              sign = match[1] === '-' ? -1 : 1;
              duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
              };
            } else if (duration == null) {
              // checks for null or undefined
              duration = {};
            } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
              diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
              duration = {};
              duration.ms = diffRes.milliseconds;
              duration.M = diffRes.months;
            }

            ret = new Duration(duration);

            if (isDuration(input) && hasOwnProp(input, '_locale')) {
              ret._locale = input._locale;
            }

            return ret;
          }

          createDuration.fn = Duration.prototype;
          createDuration.invalid = createInvalid$1;

          function parseIso(inp, sign) {
            // We'd normally use ~~inp for this, but unfortunately it also
            // converts floats to ints.
            // inp may be undefined, so careful calling replace on it.
            var res = inp && parseFloat(inp.replace(',', '.')); // apply sign while we're at it

            return (isNaN(res) ? 0 : res) * sign;
          }

          function positiveMomentsDifference(base, other) {
            var res = {};
            res.months = other.month() - base.month() + (other.year() - base.year()) * 12;

            if (base.clone().add(res.months, 'M').isAfter(other)) {
              --res.months;
            }

            res.milliseconds = +other - +base.clone().add(res.months, 'M');
            return res;
          }

          function momentsDifference(base, other) {
            var res;

            if (!(base.isValid() && other.isValid())) {
              return {
                milliseconds: 0,
                months: 0
              };
            }

            other = cloneWithOffset(other, base);

            if (base.isBefore(other)) {
              res = positiveMomentsDifference(base, other);
            } else {
              res = positiveMomentsDifference(other, base);
              res.milliseconds = -res.milliseconds;
              res.months = -res.months;
            }

            return res;
          } // TODO: remove 'name' arg after deprecation is removed


          function createAdder(direction, name) {
            return function (val, period) {
              var dur, tmp; //invert the arguments, but complain about it

              if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
              }

              val = typeof val === 'string' ? +val : val;
              dur = createDuration(val, period);
              addSubtract(this, dur, direction);
              return this;
            };
          }

          function addSubtract(mom, duration, isAdding, updateOffset) {
            var milliseconds = duration._milliseconds,
                days = absRound(duration._days),
                months = absRound(duration._months);

            if (!mom.isValid()) {
              // No op
              return;
            }

            updateOffset = updateOffset == null ? true : updateOffset;

            if (months) {
              setMonth(mom, get(mom, 'Month') + months * isAdding);
            }

            if (days) {
              set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
            }

            if (milliseconds) {
              mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
            }

            if (updateOffset) {
              hooks.updateOffset(mom, days || months);
            }
          }

          var add = createAdder(1, 'add');
          var subtract = createAdder(-1, 'subtract');

          function getCalendarFormat(myMoment, now) {
            var diff = myMoment.diff(now, 'days', true);
            return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
          }

          function calendar$1(time, formats) {
            // We want to compare the start of today, vs this.
            // Getting start-of-today depends on whether we're local/utc/offset or not.
            var now = time || createLocal(),
                sod = cloneWithOffset(now, this).startOf('day'),
                format = hooks.calendarFormat(this, sod) || 'sameElse';
            var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
            return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
          }

          function clone() {
            return new Moment(this);
          }

          function isAfter(input, units) {
            var localInput = isMoment(input) ? input : createLocal(input);

            if (!(this.isValid() && localInput.isValid())) {
              return false;
            }

            units = normalizeUnits(units) || 'millisecond';

            if (units === 'millisecond') {
              return this.valueOf() > localInput.valueOf();
            } else {
              return localInput.valueOf() < this.clone().startOf(units).valueOf();
            }
          }

          function isBefore(input, units) {
            var localInput = isMoment(input) ? input : createLocal(input);

            if (!(this.isValid() && localInput.isValid())) {
              return false;
            }

            units = normalizeUnits(units) || 'millisecond';

            if (units === 'millisecond') {
              return this.valueOf() < localInput.valueOf();
            } else {
              return this.clone().endOf(units).valueOf() < localInput.valueOf();
            }
          }

          function isBetween(from, to, units, inclusivity) {
            var localFrom = isMoment(from) ? from : createLocal(from),
                localTo = isMoment(to) ? to : createLocal(to);

            if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
              return false;
            }

            inclusivity = inclusivity || '()';
            return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
          }

          function isSame(input, units) {
            var localInput = isMoment(input) ? input : createLocal(input),
                inputMs;

            if (!(this.isValid() && localInput.isValid())) {
              return false;
            }

            units = normalizeUnits(units) || 'millisecond';

            if (units === 'millisecond') {
              return this.valueOf() === localInput.valueOf();
            } else {
              inputMs = localInput.valueOf();
              return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
            }
          }

          function isSameOrAfter(input, units) {
            return this.isSame(input, units) || this.isAfter(input, units);
          }

          function isSameOrBefore(input, units) {
            return this.isSame(input, units) || this.isBefore(input, units);
          }

          function diff(input, units, asFloat) {
            var that, zoneDelta, output;

            if (!this.isValid()) {
              return NaN;
            }

            that = cloneWithOffset(input, this);

            if (!that.isValid()) {
              return NaN;
            }

            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
            units = normalizeUnits(units);

            switch (units) {
              case 'year':
                output = monthDiff(this, that) / 12;
                break;

              case 'month':
                output = monthDiff(this, that);
                break;

              case 'quarter':
                output = monthDiff(this, that) / 3;
                break;

              case 'second':
                output = (this - that) / 1e3;
                break;
              // 1000

              case 'minute':
                output = (this - that) / 6e4;
                break;
              // 1000 * 60

              case 'hour':
                output = (this - that) / 36e5;
                break;
              // 1000 * 60 * 60

              case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break;
              // 1000 * 60 * 60 * 24, negate dst

              case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break;
              // 1000 * 60 * 60 * 24 * 7, negate dst

              default:
                output = this - that;
            }

            return asFloat ? output : absFloor(output);
          }

          function monthDiff(a, b) {
            // difference in months
            var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
                // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
                anchor2,
                adjust;

            if (b - anchor < 0) {
              anchor2 = a.clone().add(wholeMonthDiff - 1, 'months'); // linear across the month

              adjust = (b - anchor) / (anchor - anchor2);
            } else {
              anchor2 = a.clone().add(wholeMonthDiff + 1, 'months'); // linear across the month

              adjust = (b - anchor) / (anchor2 - anchor);
            } //check for negative zero, return zero if negative zero


            return -(wholeMonthDiff + adjust) || 0;
          }

          hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
          hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

          function toString() {
            return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
          }

          function toISOString(keepOffset) {
            if (!this.isValid()) {
              return null;
            }

            var utc = keepOffset !== true;
            var m = utc ? this.clone().utc() : this;

            if (m.year() < 0 || m.year() > 9999) {
              return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
            }

            if (isFunction(Date.prototype.toISOString)) {
              // native implementation is ~50x faster, use it when we can
              if (utc) {
                return this.toDate().toISOString();
              } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
              }
            }

            return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
          }
          /**
           * Return a human readable representation of a moment that can
           * also be evaluated to get a new moment which is the same
           *
           * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
           */


          function inspect() {
            if (!this.isValid()) {
              return 'moment.invalid(/* ' + this._i + ' */)';
            }

            var func = 'moment';
            var zone = '';

            if (!this.isLocal()) {
              func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
              zone = 'Z';
            }

            var prefix = '[' + func + '("]';
            var year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
            var datetime = '-MM-DD[T]HH:mm:ss.SSS';
            var suffix = zone + '[")]';
            return this.format(prefix + year + datetime + suffix);
          }

          function format(inputString) {
            if (!inputString) {
              inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
            }

            var output = formatMoment(this, inputString);
            return this.localeData().postformat(output);
          }

          function from(time, withoutSuffix) {
            if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
              return createDuration({
                to: this,
                from: time
              }).locale(this.locale()).humanize(!withoutSuffix);
            } else {
              return this.localeData().invalidDate();
            }
          }

          function fromNow(withoutSuffix) {
            return this.from(createLocal(), withoutSuffix);
          }

          function to(time, withoutSuffix) {
            if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
              return createDuration({
                from: this,
                to: time
              }).locale(this.locale()).humanize(!withoutSuffix);
            } else {
              return this.localeData().invalidDate();
            }
          }

          function toNow(withoutSuffix) {
            return this.to(createLocal(), withoutSuffix);
          } // If passed a locale key, it will set the locale for this
          // instance.  Otherwise, it will return the locale configuration
          // variables for this instance.


          function locale(key) {
            var newLocaleData;

            if (key === undefined) {
              return this._locale._abbr;
            } else {
              newLocaleData = getLocale(key);

              if (newLocaleData != null) {
                this._locale = newLocaleData;
              }

              return this;
            }
          }

          var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
            if (key === undefined) {
              return this.localeData();
            } else {
              return this.locale(key);
            }
          });

          function localeData() {
            return this._locale;
          }

          var MS_PER_SECOND = 1000;
          var MS_PER_MINUTE = 60 * MS_PER_SECOND;
          var MS_PER_HOUR = 60 * MS_PER_MINUTE;
          var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR; // actual modulo - handles negative numbers (for dates before 1970):

          function mod$1(dividend, divisor) {
            return (dividend % divisor + divisor) % divisor;
          }

          function localStartOfDate(y, m, d) {
            // the date constructor remaps years 0-99 to 1900-1999
            if (y < 100 && y >= 0) {
              // preserve leap years using a full 400 year cycle, then reset
              return new Date(y + 400, m, d) - MS_PER_400_YEARS;
            } else {
              return new Date(y, m, d).valueOf();
            }
          }

          function utcStartOfDate(y, m, d) {
            // Date.UTC remaps years 0-99 to 1900-1999
            if (y < 100 && y >= 0) {
              // preserve leap years using a full 400 year cycle, then reset
              return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
            } else {
              return Date.UTC(y, m, d);
            }
          }

          function startOf(units) {
            var time;
            units = normalizeUnits(units);

            if (units === undefined || units === 'millisecond' || !this.isValid()) {
              return this;
            }

            var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

            switch (units) {
              case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;

              case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;

              case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;

              case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;

              case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;

              case 'day':
              case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;

              case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;

              case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;

              case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
            }

            this._d.setTime(time);

            hooks.updateOffset(this, true);
            return this;
          }

          function endOf(units) {
            var time;
            units = normalizeUnits(units);

            if (units === undefined || units === 'millisecond' || !this.isValid()) {
              return this;
            }

            var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

            switch (units) {
              case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;

              case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;

              case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;

              case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;

              case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;

              case 'day':
              case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;

              case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;

              case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;

              case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
            }

            this._d.setTime(time);

            hooks.updateOffset(this, true);
            return this;
          }

          function valueOf() {
            return this._d.valueOf() - (this._offset || 0) * 60000;
          }

          function unix() {
            return Math.floor(this.valueOf() / 1000);
          }

          function toDate() {
            return new Date(this.valueOf());
          }

          function toArray() {
            var m = this;
            return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
          }

          function toObject() {
            var m = this;
            return {
              years: m.year(),
              months: m.month(),
              date: m.date(),
              hours: m.hours(),
              minutes: m.minutes(),
              seconds: m.seconds(),
              milliseconds: m.milliseconds()
            };
          }

          function toJSON() {
            // new Date(NaN).toJSON() === null
            return this.isValid() ? this.toISOString() : null;
          }

          function isValid$2() {
            return isValid(this);
          }

          function parsingFlags() {
            return extend({}, getParsingFlags(this));
          }

          function invalidAt() {
            return getParsingFlags(this).overflow;
          }

          function creationData() {
            return {
              input: this._i,
              format: this._f,
              locale: this._locale,
              isUTC: this._isUTC,
              strict: this._strict
            };
          } // FORMATTING


          addFormatToken(0, ['gg', 2], 0, function () {
            return this.weekYear() % 100;
          });
          addFormatToken(0, ['GG', 2], 0, function () {
            return this.isoWeekYear() % 100;
          });

          function addWeekYearFormatToken(token, getter) {
            addFormatToken(0, [token, token.length], 0, getter);
          }

          addWeekYearFormatToken('gggg', 'weekYear');
          addWeekYearFormatToken('ggggg', 'weekYear');
          addWeekYearFormatToken('GGGG', 'isoWeekYear');
          addWeekYearFormatToken('GGGGG', 'isoWeekYear'); // ALIASES

          addUnitAlias('weekYear', 'gg');
          addUnitAlias('isoWeekYear', 'GG'); // PRIORITY

          addUnitPriority('weekYear', 1);
          addUnitPriority('isoWeekYear', 1); // PARSING

          addRegexToken('G', matchSigned);
          addRegexToken('g', matchSigned);
          addRegexToken('GG', match1to2, match2);
          addRegexToken('gg', match1to2, match2);
          addRegexToken('GGGG', match1to4, match4);
          addRegexToken('gggg', match1to4, match4);
          addRegexToken('GGGGG', match1to6, match6);
          addRegexToken('ggggg', match1to6, match6);
          addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
          });
          addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
            week[token] = hooks.parseTwoDigitYear(input);
          }); // MOMENTS

          function getSetWeekYear(input) {
            return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
          }

          function getSetISOWeekYear(input) {
            return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
          }

          function getISOWeeksInYear() {
            return weeksInYear(this.year(), 1, 4);
          }

          function getWeeksInYear() {
            var weekInfo = this.localeData()._week;

            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
          }

          function getSetWeekYearHelper(input, week, weekday, dow, doy) {
            var weeksTarget;

            if (input == null) {
              return weekOfYear(this, dow, doy).year;
            } else {
              weeksTarget = weeksInYear(input, dow, doy);

              if (week > weeksTarget) {
                week = weeksTarget;
              }

              return setWeekAll.call(this, input, week, weekday, dow, doy);
            }
          }

          function setWeekAll(weekYear, week, weekday, dow, doy) {
            var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
                date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
            this.year(date.getUTCFullYear());
            this.month(date.getUTCMonth());
            this.date(date.getUTCDate());
            return this;
          } // FORMATTING


          addFormatToken('Q', 0, 'Qo', 'quarter'); // ALIASES

          addUnitAlias('quarter', 'Q'); // PRIORITY

          addUnitPriority('quarter', 7); // PARSING

          addRegexToken('Q', match1);
          addParseToken('Q', function (input, array) {
            array[MONTH] = (toInt(input) - 1) * 3;
          }); // MOMENTS

          function getSetQuarter(input) {
            return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
          } // FORMATTING


          addFormatToken('D', ['DD', 2], 'Do', 'date'); // ALIASES

          addUnitAlias('date', 'D'); // PRIORITY

          addUnitPriority('date', 9); // PARSING

          addRegexToken('D', match1to2);
          addRegexToken('DD', match1to2, match2);
          addRegexToken('Do', function (isStrict, locale) {
            // TODO: Remove "ordinalParse" fallback in next major release.
            return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
          });
          addParseToken(['D', 'DD'], DATE);
          addParseToken('Do', function (input, array) {
            array[DATE] = toInt(input.match(match1to2)[0]);
          }); // MOMENTS

          var getSetDayOfMonth = makeGetSet('Date', true); // FORMATTING

          addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'); // ALIASES

          addUnitAlias('dayOfYear', 'DDD'); // PRIORITY

          addUnitPriority('dayOfYear', 4); // PARSING

          addRegexToken('DDD', match1to3);
          addRegexToken('DDDD', match3);
          addParseToken(['DDD', 'DDDD'], function (input, array, config) {
            config._dayOfYear = toInt(input);
          }); // HELPERS
          // MOMENTS

          function getSetDayOfYear(input) {
            var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
            return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
          } // FORMATTING


          addFormatToken('m', ['mm', 2], 0, 'minute'); // ALIASES

          addUnitAlias('minute', 'm'); // PRIORITY

          addUnitPriority('minute', 14); // PARSING

          addRegexToken('m', match1to2);
          addRegexToken('mm', match1to2, match2);
          addParseToken(['m', 'mm'], MINUTE); // MOMENTS

          var getSetMinute = makeGetSet('Minutes', false); // FORMATTING

          addFormatToken('s', ['ss', 2], 0, 'second'); // ALIASES

          addUnitAlias('second', 's'); // PRIORITY

          addUnitPriority('second', 15); // PARSING

          addRegexToken('s', match1to2);
          addRegexToken('ss', match1to2, match2);
          addParseToken(['s', 'ss'], SECOND); // MOMENTS

          var getSetSecond = makeGetSet('Seconds', false); // FORMATTING

          addFormatToken('S', 0, 0, function () {
            return ~~(this.millisecond() / 100);
          });
          addFormatToken(0, ['SS', 2], 0, function () {
            return ~~(this.millisecond() / 10);
          });
          addFormatToken(0, ['SSS', 3], 0, 'millisecond');
          addFormatToken(0, ['SSSS', 4], 0, function () {
            return this.millisecond() * 10;
          });
          addFormatToken(0, ['SSSSS', 5], 0, function () {
            return this.millisecond() * 100;
          });
          addFormatToken(0, ['SSSSSS', 6], 0, function () {
            return this.millisecond() * 1000;
          });
          addFormatToken(0, ['SSSSSSS', 7], 0, function () {
            return this.millisecond() * 10000;
          });
          addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
            return this.millisecond() * 100000;
          });
          addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
            return this.millisecond() * 1000000;
          }); // ALIASES

          addUnitAlias('millisecond', 'ms'); // PRIORITY

          addUnitPriority('millisecond', 16); // PARSING

          addRegexToken('S', match1to3, match1);
          addRegexToken('SS', match1to3, match2);
          addRegexToken('SSS', match1to3, match3);
          var token;

          for (token = 'SSSS'; token.length <= 9; token += 'S') {
            addRegexToken(token, matchUnsigned);
          }

          function parseMs(input, array) {
            array[MILLISECOND] = toInt(('0.' + input) * 1000);
          }

          for (token = 'S'; token.length <= 9; token += 'S') {
            addParseToken(token, parseMs);
          } // MOMENTS


          var getSetMillisecond = makeGetSet('Milliseconds', false); // FORMATTING

          addFormatToken('z', 0, 0, 'zoneAbbr');
          addFormatToken('zz', 0, 0, 'zoneName'); // MOMENTS

          function getZoneAbbr() {
            return this._isUTC ? 'UTC' : '';
          }

          function getZoneName() {
            return this._isUTC ? 'Coordinated Universal Time' : '';
          }

          var proto = Moment.prototype;
          proto.add = add;
          proto.calendar = calendar$1;
          proto.clone = clone;
          proto.diff = diff;
          proto.endOf = endOf;
          proto.format = format;
          proto.from = from;
          proto.fromNow = fromNow;
          proto.to = to;
          proto.toNow = toNow;
          proto.get = stringGet;
          proto.invalidAt = invalidAt;
          proto.isAfter = isAfter;
          proto.isBefore = isBefore;
          proto.isBetween = isBetween;
          proto.isSame = isSame;
          proto.isSameOrAfter = isSameOrAfter;
          proto.isSameOrBefore = isSameOrBefore;
          proto.isValid = isValid$2;
          proto.lang = lang;
          proto.locale = locale;
          proto.localeData = localeData;
          proto.max = prototypeMax;
          proto.min = prototypeMin;
          proto.parsingFlags = parsingFlags;
          proto.set = stringSet;
          proto.startOf = startOf;
          proto.subtract = subtract;
          proto.toArray = toArray;
          proto.toObject = toObject;
          proto.toDate = toDate;
          proto.toISOString = toISOString;
          proto.inspect = inspect;
          proto.toJSON = toJSON;
          proto.toString = toString;
          proto.unix = unix;
          proto.valueOf = valueOf;
          proto.creationData = creationData;
          proto.year = getSetYear;
          proto.isLeapYear = getIsLeapYear;
          proto.weekYear = getSetWeekYear;
          proto.isoWeekYear = getSetISOWeekYear;
          proto.quarter = proto.quarters = getSetQuarter;
          proto.month = getSetMonth;
          proto.daysInMonth = getDaysInMonth;
          proto.week = proto.weeks = getSetWeek;
          proto.isoWeek = proto.isoWeeks = getSetISOWeek;
          proto.weeksInYear = getWeeksInYear;
          proto.isoWeeksInYear = getISOWeeksInYear;
          proto.date = getSetDayOfMonth;
          proto.day = proto.days = getSetDayOfWeek;
          proto.weekday = getSetLocaleDayOfWeek;
          proto.isoWeekday = getSetISODayOfWeek;
          proto.dayOfYear = getSetDayOfYear;
          proto.hour = proto.hours = getSetHour;
          proto.minute = proto.minutes = getSetMinute;
          proto.second = proto.seconds = getSetSecond;
          proto.millisecond = proto.milliseconds = getSetMillisecond;
          proto.utcOffset = getSetOffset;
          proto.utc = setOffsetToUTC;
          proto.local = setOffsetToLocal;
          proto.parseZone = setOffsetToParsedOffset;
          proto.hasAlignedHourOffset = hasAlignedHourOffset;
          proto.isDST = isDaylightSavingTime;
          proto.isLocal = isLocal;
          proto.isUtcOffset = isUtcOffset;
          proto.isUtc = isUtc;
          proto.isUTC = isUtc;
          proto.zoneAbbr = getZoneAbbr;
          proto.zoneName = getZoneName;
          proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
          proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
          proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
          proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
          proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

          function createUnix(input) {
            return createLocal(input * 1000);
          }

          function createInZone() {
            return createLocal.apply(null, arguments).parseZone();
          }

          function preParsePostFormat(string) {
            return string;
          }

          var proto$1 = Locale.prototype;
          proto$1.calendar = calendar;
          proto$1.longDateFormat = longDateFormat;
          proto$1.invalidDate = invalidDate;
          proto$1.ordinal = ordinal;
          proto$1.preparse = preParsePostFormat;
          proto$1.postformat = preParsePostFormat;
          proto$1.relativeTime = relativeTime;
          proto$1.pastFuture = pastFuture;
          proto$1.set = set;
          proto$1.months = localeMonths;
          proto$1.monthsShort = localeMonthsShort;
          proto$1.monthsParse = localeMonthsParse;
          proto$1.monthsRegex = monthsRegex;
          proto$1.monthsShortRegex = monthsShortRegex;
          proto$1.week = localeWeek;
          proto$1.firstDayOfYear = localeFirstDayOfYear;
          proto$1.firstDayOfWeek = localeFirstDayOfWeek;
          proto$1.weekdays = localeWeekdays;
          proto$1.weekdaysMin = localeWeekdaysMin;
          proto$1.weekdaysShort = localeWeekdaysShort;
          proto$1.weekdaysParse = localeWeekdaysParse;
          proto$1.weekdaysRegex = weekdaysRegex;
          proto$1.weekdaysShortRegex = weekdaysShortRegex;
          proto$1.weekdaysMinRegex = weekdaysMinRegex;
          proto$1.isPM = localeIsPM;
          proto$1.meridiem = localeMeridiem;

          function get$1(format, index, field, setter) {
            var locale = getLocale();
            var utc = createUTC().set(setter, index);
            return locale[field](utc, format);
          }

          function listMonthsImpl(format, index, field) {
            if (isNumber(format)) {
              index = format;
              format = undefined;
            }

            format = format || '';

            if (index != null) {
              return get$1(format, index, field, 'month');
            }

            var i;
            var out = [];

            for (i = 0; i < 12; i++) {
              out[i] = get$1(format, i, field, 'month');
            }

            return out;
          } // ()
          // (5)
          // (fmt, 5)
          // (fmt)
          // (true)
          // (true, 5)
          // (true, fmt, 5)
          // (true, fmt)


          function listWeekdaysImpl(localeSorted, format, index, field) {
            if (typeof localeSorted === 'boolean') {
              if (isNumber(format)) {
                index = format;
                format = undefined;
              }

              format = format || '';
            } else {
              format = localeSorted;
              index = format;
              localeSorted = false;

              if (isNumber(format)) {
                index = format;
                format = undefined;
              }

              format = format || '';
            }

            var locale = getLocale(),
                shift = localeSorted ? locale._week.dow : 0;

            if (index != null) {
              return get$1(format, (index + shift) % 7, field, 'day');
            }

            var i;
            var out = [];

            for (i = 0; i < 7; i++) {
              out[i] = get$1(format, (i + shift) % 7, field, 'day');
            }

            return out;
          }

          function listMonths(format, index) {
            return listMonthsImpl(format, index, 'months');
          }

          function listMonthsShort(format, index) {
            return listMonthsImpl(format, index, 'monthsShort');
          }

          function listWeekdays(localeSorted, format, index) {
            return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
          }

          function listWeekdaysShort(localeSorted, format, index) {
            return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
          }

          function listWeekdaysMin(localeSorted, format, index) {
            return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
          }

          getSetGlobalLocale('en', {
            dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
            ordinal: function ordinal(number) {
              var b = number % 10,
                  output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
              return number + output;
            }
          }); // Side effect imports

          hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
          hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
          var mathAbs = Math.abs;

          function abs() {
            var data = this._data;
            this._milliseconds = mathAbs(this._milliseconds);
            this._days = mathAbs(this._days);
            this._months = mathAbs(this._months);
            data.milliseconds = mathAbs(data.milliseconds);
            data.seconds = mathAbs(data.seconds);
            data.minutes = mathAbs(data.minutes);
            data.hours = mathAbs(data.hours);
            data.months = mathAbs(data.months);
            data.years = mathAbs(data.years);
            return this;
          }

          function addSubtract$1(duration, input, value, direction) {
            var other = createDuration(input, value);
            duration._milliseconds += direction * other._milliseconds;
            duration._days += direction * other._days;
            duration._months += direction * other._months;
            return duration._bubble();
          } // supports only 2.0-style add(1, 's') or add(duration)


          function add$1(input, value) {
            return addSubtract$1(this, input, value, 1);
          } // supports only 2.0-style subtract(1, 's') or subtract(duration)


          function subtract$1(input, value) {
            return addSubtract$1(this, input, value, -1);
          }

          function absCeil(number) {
            if (number < 0) {
              return Math.floor(number);
            } else {
              return Math.ceil(number);
            }
          }

          function bubble() {
            var milliseconds = this._milliseconds;
            var days = this._days;
            var months = this._months;
            var data = this._data;
            var seconds, minutes, hours, years, monthsFromDays; // if we have a mix of positive and negative values, bubble down first
            // check: https://github.com/moment/moment/issues/2166

            if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
              milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
              days = 0;
              months = 0;
            } // The following code bubbles up values, see the tests for
            // examples of what that means.


            data.milliseconds = milliseconds % 1000;
            seconds = absFloor(milliseconds / 1000);
            data.seconds = seconds % 60;
            minutes = absFloor(seconds / 60);
            data.minutes = minutes % 60;
            hours = absFloor(minutes / 60);
            data.hours = hours % 24;
            days += absFloor(hours / 24); // convert days to months

            monthsFromDays = absFloor(daysToMonths(days));
            months += monthsFromDays;
            days -= absCeil(monthsToDays(monthsFromDays)); // 12 months -> 1 year

            years = absFloor(months / 12);
            months %= 12;
            data.days = days;
            data.months = months;
            data.years = years;
            return this;
          }

          function daysToMonths(days) {
            // 400 years have 146097 days (taking into account leap year rules)
            // 400 years have 12 months === 4800
            return days * 4800 / 146097;
          }

          function monthsToDays(months) {
            // the reverse of daysToMonths
            return months * 146097 / 4800;
          }

          function as(units) {
            if (!this.isValid()) {
              return NaN;
            }

            var days;
            var months;
            var milliseconds = this._milliseconds;
            units = normalizeUnits(units);

            if (units === 'month' || units === 'quarter' || units === 'year') {
              days = this._days + milliseconds / 864e5;
              months = this._months + daysToMonths(days);

              switch (units) {
                case 'month':
                  return months;

                case 'quarter':
                  return months / 3;

                case 'year':
                  return months / 12;
              }
            } else {
              // handle milliseconds separately because of floating point math errors (issue #1867)
              days = this._days + Math.round(monthsToDays(this._months));

              switch (units) {
                case 'week':
                  return days / 7 + milliseconds / 6048e5;

                case 'day':
                  return days + milliseconds / 864e5;

                case 'hour':
                  return days * 24 + milliseconds / 36e5;

                case 'minute':
                  return days * 1440 + milliseconds / 6e4;

                case 'second':
                  return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here

                case 'millisecond':
                  return Math.floor(days * 864e5) + milliseconds;

                default:
                  throw new Error('Unknown unit ' + units);
              }
            }
          } // TODO: Use this.as('ms')?


          function valueOf$1() {
            if (!this.isValid()) {
              return NaN;
            }

            return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
          }

          function makeAs(alias) {
            return function () {
              return this.as(alias);
            };
          }

          var asMilliseconds = makeAs('ms');
          var asSeconds = makeAs('s');
          var asMinutes = makeAs('m');
          var asHours = makeAs('h');
          var asDays = makeAs('d');
          var asWeeks = makeAs('w');
          var asMonths = makeAs('M');
          var asQuarters = makeAs('Q');
          var asYears = makeAs('y');

          function clone$1() {
            return createDuration(this);
          }

          function get$2(units) {
            units = normalizeUnits(units);
            return this.isValid() ? this[units + 's']() : NaN;
          }

          function makeGetter(name) {
            return function () {
              return this.isValid() ? this._data[name] : NaN;
            };
          }

          var milliseconds = makeGetter('milliseconds');
          var seconds = makeGetter('seconds');
          var minutes = makeGetter('minutes');
          var hours = makeGetter('hours');
          var days = makeGetter('days');
          var months = makeGetter('months');
          var years = makeGetter('years');

          function weeks() {
            return absFloor(this.days() / 7);
          }

          var round = Math.round;
          var thresholds = {
            ss: 44,
            // a few seconds to seconds
            s: 45,
            // seconds to minute
            m: 45,
            // minutes to hour
            h: 22,
            // hours to day
            d: 26,
            // days to month
            M: 11 // months to year

          }; // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize

          function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
            return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
          }

          function relativeTime$1(posNegDuration, withoutSuffix, locale) {
            var duration = createDuration(posNegDuration).abs();
            var seconds = round(duration.as('s'));
            var minutes = round(duration.as('m'));
            var hours = round(duration.as('h'));
            var days = round(duration.as('d'));
            var months = round(duration.as('M'));
            var years = round(duration.as('y'));
            var a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
            a[2] = withoutSuffix;
            a[3] = +posNegDuration > 0;
            a[4] = locale;
            return substituteTimeAgo.apply(null, a);
          } // This function allows you to set the rounding function for relative time strings


          function getSetRelativeTimeRounding(roundingFunction) {
            if (roundingFunction === undefined) {
              return round;
            }

            if (typeof roundingFunction === 'function') {
              round = roundingFunction;
              return true;
            }

            return false;
          } // This function allows you to set a threshold for relative time strings


          function getSetRelativeTimeThreshold(threshold, limit) {
            if (thresholds[threshold] === undefined) {
              return false;
            }

            if (limit === undefined) {
              return thresholds[threshold];
            }

            thresholds[threshold] = limit;

            if (threshold === 's') {
              thresholds.ss = limit - 1;
            }

            return true;
          }

          function humanize(withSuffix) {
            if (!this.isValid()) {
              return this.localeData().invalidDate();
            }

            var locale = this.localeData();
            var output = relativeTime$1(this, !withSuffix, locale);

            if (withSuffix) {
              output = locale.pastFuture(+this, output);
            }

            return locale.postformat(output);
          }

          var abs$1 = Math.abs;

          function sign(x) {
            return (x > 0) - (x < 0) || +x;
          }

          function toISOString$1() {
            // for ISO strings we do not use the normal bubbling rules:
            //  * milliseconds bubble up until they become hours
            //  * days do not bubble at all
            //  * months bubble up until they become years
            // This is because there is no context-free conversion between hours and days
            // (think of clock changes)
            // and also not between days and months (28-31 days per month)
            if (!this.isValid()) {
              return this.localeData().invalidDate();
            }

            var seconds = abs$1(this._milliseconds) / 1000;
            var days = abs$1(this._days);
            var months = abs$1(this._months);
            var minutes, hours, years; // 3600 seconds -> 60 minutes -> 1 hour

            minutes = absFloor(seconds / 60);
            hours = absFloor(minutes / 60);
            seconds %= 60;
            minutes %= 60; // 12 months -> 1 year

            years = absFloor(months / 12);
            months %= 12; // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js

            var Y = years;
            var M = months;
            var D = days;
            var h = hours;
            var m = minutes;
            var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
            var total = this.asSeconds();

            if (!total) {
              // this is the same as C#'s (Noda) and python (isodate)...
              // but not other JS (goog.date)
              return 'P0D';
            }

            var totalSign = total < 0 ? '-' : '';
            var ymSign = sign(this._months) !== sign(total) ? '-' : '';
            var daysSign = sign(this._days) !== sign(total) ? '-' : '';
            var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
            return totalSign + 'P' + (Y ? ymSign + Y + 'Y' : '') + (M ? ymSign + M + 'M' : '') + (D ? daysSign + D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? hmsSign + h + 'H' : '') + (m ? hmsSign + m + 'M' : '') + (s ? hmsSign + s + 'S' : '');
          }

          var proto$2 = Duration.prototype;
          proto$2.isValid = isValid$1;
          proto$2.abs = abs;
          proto$2.add = add$1;
          proto$2.subtract = subtract$1;
          proto$2.as = as;
          proto$2.asMilliseconds = asMilliseconds;
          proto$2.asSeconds = asSeconds;
          proto$2.asMinutes = asMinutes;
          proto$2.asHours = asHours;
          proto$2.asDays = asDays;
          proto$2.asWeeks = asWeeks;
          proto$2.asMonths = asMonths;
          proto$2.asQuarters = asQuarters;
          proto$2.asYears = asYears;
          proto$2.valueOf = valueOf$1;
          proto$2._bubble = bubble;
          proto$2.clone = clone$1;
          proto$2.get = get$2;
          proto$2.milliseconds = milliseconds;
          proto$2.seconds = seconds;
          proto$2.minutes = minutes;
          proto$2.hours = hours;
          proto$2.days = days;
          proto$2.weeks = weeks;
          proto$2.months = months;
          proto$2.years = years;
          proto$2.humanize = humanize;
          proto$2.toISOString = toISOString$1;
          proto$2.toString = toISOString$1;
          proto$2.toJSON = toISOString$1;
          proto$2.locale = locale;
          proto$2.localeData = localeData;
          proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
          proto$2.lang = lang; // Side effect imports
          // FORMATTING

          addFormatToken('X', 0, 0, 'unix');
          addFormatToken('x', 0, 0, 'valueOf'); // PARSING

          addRegexToken('x', matchSigned);
          addRegexToken('X', matchTimestamp);
          addParseToken('X', function (input, array, config) {
            config._d = new Date(parseFloat(input, 10) * 1000);
          });
          addParseToken('x', function (input, array, config) {
            config._d = new Date(toInt(input));
          }); // Side effect imports

          hooks.version = '2.24.0';
          setHookCallback(createLocal);
          hooks.fn = proto;
          hooks.min = min;
          hooks.max = max;
          hooks.now = now;
          hooks.utc = createUTC;
          hooks.unix = createUnix;
          hooks.months = listMonths;
          hooks.isDate = isDate;
          hooks.locale = getSetGlobalLocale;
          hooks.invalid = createInvalid;
          hooks.duration = createDuration;
          hooks.isMoment = isMoment;
          hooks.weekdays = listWeekdays;
          hooks.parseZone = createInZone;
          hooks.localeData = getLocale;
          hooks.isDuration = isDuration;
          hooks.monthsShort = listMonthsShort;
          hooks.weekdaysMin = listWeekdaysMin;
          hooks.defineLocale = defineLocale;
          hooks.updateLocale = updateLocale;
          hooks.locales = listLocales;
          hooks.weekdaysShort = listWeekdaysShort;
          hooks.normalizeUnits = normalizeUnits;
          hooks.relativeTimeRounding = getSetRelativeTimeRounding;
          hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
          hooks.calendarFormat = getCalendarFormat;
          hooks.prototype = proto; // currently HTML5 input type only supports 24-hour formats

          hooks.HTML5_FMT = {
            DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
            // <input type="datetime-local" />
            DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
            // <input type="datetime-local" step="1" />
            DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
            // <input type="datetime-local" step="0.001" />
            DATE: 'YYYY-MM-DD',
            // <input type="date" />
            TIME: 'HH:mm',
            // <input type="time" />
            TIME_SECONDS: 'HH:mm:ss',
            // <input type="time" step="1" />
            TIME_MS: 'HH:mm:ss.SSS',
            // <input type="time" step="0.001" />
            WEEK: 'GGGG-[W]WW',
            // <input type="week" />
            MONTH: 'YYYY-MM' // <input type="month" />

          };
          return hooks;
        });
        /* WEBPACK VAR INJECTION */

      }).call(this, __webpack_require__(212)(module));
      /***/
    },
    /* 15 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js

      var defineProperty = __webpack_require__(4);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: ./src/components/AbnAcn.js


      var components_AbnAcn = __webpack_require__(271); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(36);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/lodash/noop.js


      var noop = __webpack_require__(9);

      var noop_default =
      /*#__PURE__*/
      __webpack_require__.n(noop); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // EXTERNAL MODULE: ./node_modules/antd/lib/auto-complete/index.js


      var auto_complete = __webpack_require__(267);

      var auto_complete_default =
      /*#__PURE__*/
      __webpack_require__.n(auto_complete); // CONCATENATED MODULE: ./src/components/AutoComplete.js


      var AutoComplete_AutoComplete = function AutoComplete(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(auto_complete_default.a, {
          value: props.value,
          className: classnames_default()('formatic-auto-complete', defineProperty_default()({}, props.className, props.className)),
          dataSource: props.dataSource,
          disabled: props.readOnly,
          dropdownClassName: props.dropdownClassName,
          onSearch: props.onSearch,
          onChange: props.onChange,
          onSelect: props.onSelect,
          optionLabelProp: props.optionLabelProp,
          filterOption: props.filterOption,
          placeholder: props.placeholder,
          onBlur: props.onBlur,
          onFocus: props.onFocus
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(props.input, extends_default()({}, props.inputOptions, {
          className: props.inputClassName,
          id: props.inputId,
          value: props.value
        })));
      };

      AutoComplete_AutoComplete.defaultProps = {
        className: '',
        dataSource: [],
        dropdownClassName: '',
        filterOption: false,
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        onChange: noop_default.a,
        onSearch: noop_default.a,
        onSelect: noop_default.a,
        input: 'input',
        inputClassName: '',
        inputId: '',
        inputOptions: {},
        optionLabelProp: 'text',
        placeholder: '',
        readOnly: false,
        value: ''
      };
      AutoComplete_AutoComplete.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        dataSource: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        dropdownClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        filterOption: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        input: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.element, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        inputClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        optionLabelProp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var components_AutoComplete = AutoComplete_AutoComplete; // CONCATENATED MODULE: ./src/components/AutoCompleteOption.js

      var AutoCompleteOption_Option = auto_complete_default.a.Option;

      var AutoCompleteOption_AutoCompleteOption = function AutoCompleteOption(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(AutoCompleteOption_Option, {
          disabled: props.disabled,
          className: classnames_default()('formatic-auto-complete-option', defineProperty_default()({}, props.className, props.className))
        }, props.children);
      };

      AutoCompleteOption_AutoCompleteOption.defaultProps = {
        className: '',
        children: '',
        disabled: false,
        text: ''
      };
      AutoCompleteOption_AutoCompleteOption.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        text: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var components_AutoCompleteOption = AutoCompleteOption_AutoCompleteOption; // CONCATENATED MODULE: ./src/components/Alert.js

      var Alert_Alert = function Alert(_ref) {
        var body = _ref.body,
            className = _ref.className,
            color = _ref.color,
            title = _ref.title;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "".concat(className, " formatic-alert__color-").concat(color)
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-alert-_content"
        }, title && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("h4", {
          className: "formatic-heading formatic-alert__heading"
        }, title), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("p", {
          className: "formatic-alert__body"
        }, body)));
      };

      Alert_Alert.defaultProps = {
        className: 'formatic-alert',
        color: 'success',
        title: ''
      };
      Alert_Alert.propTypes = {
        body: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        color: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        title: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var components_Alert = Alert_Alert; // EXTERNAL MODULE: ./src/components/Dropdown.js

      var components_Dropdown = __webpack_require__(279); // CONCATENATED MODULE: ./src/components/DropdownNative.js


      var DropdownNative_DropdownNative = function DropdownNative(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("select", {
          className: props.className,
          id: props.id,
          name: props.id,
          onBlur: props.onBlur,
          onChange: props.onChange,
          onFocus: props.onFocus,
          value: props.value === '' ? undefined : props.value
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("option", {
          value: ""
        }, props.placeholder), props.options.map(function (option, index) {
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("option", {
            value: option,
            key: index
          }, option);
        }));
      };

      DropdownNative_DropdownNative.defaultProps = {
        className: 'formatic-dropdown-native__select',
        defaultValue: '',
        id: '',
        onBlur: noop_default.a,
        onChange: noop_default.a,
        onFocus: noop_default.a,
        value: '',
        // attributes from dashboard
        options: [],
        placeholder: ''
      };
      DropdownNative_DropdownNative.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // attributes from dashboard
        options: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var components_DropdownNative = DropdownNative_DropdownNative; // EXTERNAL MODULE: ./src/components/ErrorMessage.js

      var components_ErrorMessage = __webpack_require__(120); // EXTERNAL MODULE: ./src/components/InputMask.js


      var components_InputMask = __webpack_require__(266); // EXTERNAL MODULE: ./src/components/Label.js


      var components_Label = __webpack_require__(187); // EXTERNAL MODULE: ./src/core/utils.js + 1 modules


      var utils = __webpack_require__(18); // CONCATENATED MODULE: ./src/components/RichTextArea.js

      /* eslint-disable react/no-danger */


      var RichTextArea_RichTextArea = function RichTextArea(_ref) {
        var className = _ref.className,
            html = _ref.html;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()(defineProperty_default()({}, className, className)),
          dangerouslySetInnerHTML: {
            __html: Object(utils["m"
            /* getSafeHTML */
            ])(html)
          }
        });
      };

      RichTextArea_RichTextArea.defaultProps = {
        className: '',
        html: ''
      };
      RichTextArea_RichTextArea.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        html: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var components_RichTextArea = RichTextArea_RichTextArea; // EXTERNAL MODULE: ./src/components/Text.js

      var components_Text = __webpack_require__(167); // EXTERNAL MODULE: ./src/components/Textarea.js


      var components_Textarea = __webpack_require__(281); // EXTERNAL MODULE: ./src/components/Checkbox.js


      var components_Checkbox = __webpack_require__(188); // EXTERNAL MODULE: ./src/components/CheckboxList.js


      var components_CheckboxList = __webpack_require__(221); // CONCATENATED MODULE: ./src/components/FieldDescription.js


      var FieldDescription_FieldDescription = function FieldDescription(_ref) {
        var className = _ref.className,
            description = _ref.description;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(src_components_RichTextArea, {
          className: classnames_default()(defineProperty_default()({
            'formatic-field-description': true
          }, className, className)),
          html: description
        });
      };

      FieldDescription_FieldDescription.defaultProps = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      FieldDescription_FieldDescription.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired
      };
      /* harmony default export */

      var components_FieldDescription = FieldDescription_FieldDescription; // CONCATENATED MODULE: ./src/components/Heading.js

      var Heading_Heading = function Heading(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(props.headingLevel, {
          className: props.className
        }, props.label);
      };

      Heading_Heading.defaultProps = {
        className: 'formatic-heading',
        label: '',
        headingLevel: 'h1'
      };
      Heading_Heading.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // attributes from dashboard
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        headingLevel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var components_Heading = Heading_Heading; // CONCATENATED MODULE: ./src/components/Image.js

      var Image_Image = function Image(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("img", {
          alt: props.alt,
          className: props.className,
          height: props.height,
          src: props.url,
          width: props.width
        });
      };

      Image_Image.defaultProps = {
        className: 'formatic-image__img',
        alt: '',
        height: '',
        width: ''
      };
      Image_Image.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        alt: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        height: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        url: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        width: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string])
      };
      /* harmony default export */

      var components_Image = Image_Image; // EXTERNAL MODULE: ./src/components/Button.js

      var components_Button = __webpack_require__(165); // EXTERNAL MODULE: ./src/components/DatePicker.js


      var components_DatePicker = __webpack_require__(278); // EXTERNAL MODULE: ./node_modules/antd/lib/date-picker/index.js


      var date_picker = __webpack_require__(383);

      var date_picker_default =
      /*#__PURE__*/
      __webpack_require__.n(date_picker); // CONCATENATED MODULE: ./src/components/AntDesignDatePicker.js


      var AntDesignDatePicker_AntDesignDatePicker = function AntDesignDatePicker(props) {
        var options = {
          className: props.className,
          dropdownClassName: props.dropdownClassName,
          format: props.format,
          defaultValue: props.defaultValue,
          value: props.value,
          placeholder: props.placeholder,
          onChange: props.onChange,
          ref: props.reference,
          onBlur: props.onBlur,
          onFocus: props.onFocus,
          disabledDate: props.disabledDate,
          onOpenChange: props.onOpenChange,
          defaultPickerValue: props.defaultPickerValue,
          open: props.open
        };
        return props.isMonthPicker ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(date_picker_default.a.MonthPicker, options) : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(date_picker_default.a, options);
      };

      AntDesignDatePicker_AntDesignDatePicker.defaultProps = {
        className: '',
        disabledDate: noop_default.a,
        dropdownClassName: '',
        onBlur: noop_default.a,
        onChange: noop_default.a,
        onFocus: noop_default.a,
        onOpenChange: noop_default.a,
        reference: noop_default.a,
        defaultValue: null,
        value: '',
        open: false,
        // attributes from dashboard
        format: '',
        isMonthPicker: false,
        placeholder: '',
        defaultPickerValue: null
      };
      AntDesignDatePicker_AntDesignDatePicker.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        disabledDate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        dropdownClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onOpenChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        reference: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        open: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // attributes from dashboard
        format: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        isMonthPicker: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        defaultPickerValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object])
      };
      /* harmony default export */

      var components_AntDesignDatePicker = AntDesignDatePicker_AntDesignDatePicker; // EXTERNAL MODULE: ./src/components/NumericInput.js

      var components_NumericInput = __webpack_require__(277); // EXTERNAL MODULE: ./src/components/NumericSlider.js


      var components_NumericSlider = __webpack_require__(276); // EXTERNAL MODULE: ./src/components/RadioList.js


      var components_RadioList = __webpack_require__(280); // EXTERNAL MODULE: ./src/components/ButtonList.js


      var components_ButtonList = __webpack_require__(272); // EXTERNAL MODULE: ./src/components/NetPromoterScore.js


      var components_NetPromoterScore = __webpack_require__(273); // CONCATENATED MODULE: ./src/components/Repeatable.js


      var Repeatable_Repeatable = function Repeatable(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-repeatable__items"
        }, props.items());
      };

      Repeatable_Repeatable.defaultProps = {
        items: noop_default.a
      };
      Repeatable_Repeatable.propTypes = {
        items: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      /* harmony default export */

      var components_Repeatable = Repeatable_Repeatable; // EXTERNAL MODULE: ./src/components/FileUpload.js

      var components_FileUpload = __webpack_require__(274); // EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js


      var Recompose = __webpack_require__(26); // EXTERNAL MODULE: ./src/core/hoc/withOverride.js


      var withOverride = __webpack_require__(83); // CONCATENATED MODULE: ./src/components/Field.js


      var Field_Field = function Field(props) {
        if (!componentMap[props.renderer]) {
          return null; // unknown renderer
        }

        var Component = componentMap[props.renderer];
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Component, props);
      };

      Field_Field.defaultProps = {
        renderer: ''
      };
      Field_Field.propTypes = {
        renderer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var components_Field = Object(Recompose["a"
      /* compose */
      ])(Object(withOverride["a"
      /* default */
      ])({
        overrideType: 'fieldComponent'
      }))(Field_Field); // EXTERNAL MODULE: ./src/components/FormLoading.js

      var components_FormLoading = __webpack_require__(116); // EXTERNAL MODULE: ./src/components/ReviewTable/ReviewTable.js


      var ReviewTable_ReviewTable = __webpack_require__(264); // CONCATENATED MODULE: ./src/components/DigitalSignature.js


      var DigitalSignature_DigitalSignature = function DigitalSignature(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()('formatic-digital-signature__container', defineProperty_default()({}, props.className, props.className))
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-digital-signature__body"
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("canvas", {
          id: props.id,
          className: classnames_default()('formatic-digital-signature__canvas', {
            'formatic-field-read-only': props.readOnly
          }),
          onChange: props.onChange,
          onBlur: props.onBlur,
          onFocus: props.onFocus,
          readOnly: props.readOnly
        })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-digital-signature__footer"
        }, props.enableUndo && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("button", {
          className: "formatic-digital-signature__button--undo",
          onClick: props.onUndo
        }, props.undoLabel), props.enableReset && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("button", {
          className: "formatic-digital-signature__button--reset",
          onClick: props.onReset
        }, props.resetLabel)));
      };

      DigitalSignature_DigitalSignature.defaultProps = {
        className: '',
        id: Object(utils["k"
        /* getRandomId */
        ])(),
        onBlur: noop_default.a,
        onChange: noop_default.a,
        onFocus: noop_default.a,
        onReset: noop_default.a,
        onUndo: noop_default.a,
        // attributes from dashboard
        enableReset: true,
        enableUndo: true,
        readOnly: false,
        resetLabel: 'Reset',
        undoLabel: 'Undo'
      };
      DigitalSignature_DigitalSignature.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onReset: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onUndo: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        // attributes from dashboard
        enableReset: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        enableUndo: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        resetLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        undoLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var components_DigitalSignature = DigitalSignature_DigitalSignature; // EXTERNAL MODULE: ./src/components/TrueFalse.js

      var components_TrueFalse = __webpack_require__(270); // CONCATENATED MODULE: ./src/config/componentMap.js


      var componentMap_COMPONENT_RENDERER$A;
      var componentMap_COMPONENT_RENDERER = {
        AbnAcn: 'abcAcn',
        AntDesignDatePicker: 'antDesignDatePicker',
        Alert: 'alert',
        AutoComplete: 'autoComplete',
        AutoCompleteOption: 'autoCompleteOption',
        Button: 'button',
        ButtonList: 'buttonList',
        Checkbox: 'checkbox',
        CheckboxList: 'checkboxList',
        DatePicker: 'datePicker',
        Dropdown: 'dropdown',
        DropdownNative: 'dropdownNative',
        ErrorMessage: 'errorMessage',
        Field: 'field',
        FieldDescription: 'fieldDescription',
        FileUpload: 'fileUpload',
        FormLoading: 'formLoading',
        Heading: 'heading',
        Image: 'image',
        InputMask: 'inputMask',
        Label: 'label',
        NetPromoterScore: 'netPromoterScore',
        NumericInput: 'numericInput',
        NumericSlider: 'numericSlider',
        RadioList: 'radioList',
        Repeatable: 'repeatable',
        ReviewTable: 'reviewTable',
        RichTextArea: 'richTextArea',
        Text: 'text',
        Textarea: 'textarea',
        DigitalSignature: 'digitalSignature',
        TrueFalse: 'trueFalse'
      };
      /**
       * Mapping between component (using its renderer value as key) and the react component
       * @type {Object}
       */

      /* harmony default export */

      var componentMap = (componentMap_COMPONENT_RENDERER$A = {}, defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.AbnAcn, components_AbnAcn["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Alert, components_Alert), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.AutoComplete, components_AutoComplete), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.AutoCompleteOption, components_AutoCompleteOption), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Button, components_Button["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.ButtonList, components_ButtonList["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Checkbox, components_Checkbox["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.CheckboxList, components_CheckboxList["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.DatePicker, components_DatePicker["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.AntDesignDatePicker, components_AntDesignDatePicker), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Dropdown, components_Dropdown["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.DropdownNative, components_DropdownNative), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.ErrorMessage, components_ErrorMessage["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Field, components_Field), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.FieldDescription, components_FieldDescription), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.FormLoading, components_FormLoading["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Heading, components_Heading), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Image, components_Image), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.InputMask, components_InputMask["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Label, components_Label["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.RadioList, components_RadioList["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.RichTextArea, components_RichTextArea), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Text, components_Text["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Textarea, components_Textarea["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.CheckboxList, components_CheckboxList["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Heading, components_Heading), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Image, components_Image), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Button, components_Button["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.NumericInput, components_NumericInput["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.NumericSlider, components_NumericSlider["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.NetPromoterScore, components_NetPromoterScore["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.Repeatable, components_Repeatable), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.FileUpload, components_FileUpload["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.ReviewTable, ReviewTable_ReviewTable["a"
      /* default */
      ]), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.DigitalSignature, components_DigitalSignature), defineProperty_default()(componentMap_COMPONENT_RENDERER$A, componentMap_COMPONENT_RENDERER.TrueFalse, components_TrueFalse["a"
      /* default */
      ]), componentMap_COMPONENT_RENDERER$A); // CONCATENATED MODULE: ./src/components/index.js

      /* unused harmony export AbnAcn */

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return src_components_Alert;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return src_components_AntDesignDatePicker;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return src_components_AutoComplete;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return src_components_AutoCompleteOption;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return src_components_Button;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "f", function () {
        return src_components_ButtonList;
      });
      /* unused harmony export Checkbox */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "g", function () {
        return src_components_CheckboxList;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "h", function () {
        return src_components_DatePicker;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "i", function () {
        return src_components_DigitalSignature;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "j", function () {
        return src_components_Dropdown;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "k", function () {
        return src_components_DropdownNative;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "l", function () {
        return src_components_ErrorMessage;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "m", function () {
        return src_components_FieldDescription;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "o", function () {
        return src_components_FormLoading;
      });
      /* unused harmony export Field */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "n", function () {
        return src_components_FileUpload;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "p", function () {
        return src_components_Heading;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "q", function () {
        return src_components_Image;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "r", function () {
        return src_components_InputMask;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "s", function () {
        return src_components_Label;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "t", function () {
        return src_components_NetPromoterScore;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "u", function () {
        return src_components_NumericInput;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "v", function () {
        return src_components_NumericSlider;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "w", function () {
        return src_components_RadioList;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "x", function () {
        return src_components_Repeatable;
      });
      /* unused harmony export ReviewTable */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "y", function () {
        return src_components_RichTextArea;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "z", function () {
        return src_components_Text;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "A", function () {
        return src_components_Textarea;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "B", function () {
        return src_components_TrueFalse;
      });
      /* unused harmony export InputCalendarPicker */

      /**
       * @file ./components/index.js
       * Exports out the component map to later be exported by the library.
       *
       * Capitalises the first letter of each key within the config component map
       * for improved readability (Components.RadioList vs. Components.radioList)
       */


      var components_components = {};
      var components_componentsWithOverride = {};
      Object.keys(componentMap).forEach(function (key) {
        var componentName = key[0].toUpperCase() + key.slice(1);
        components_components[componentName] = componentMap[key]; // Export components with override for direct import

        components_componentsWithOverride[componentName] = Object(withOverride["a"
        /* default */
        ])({
          overrideType: 'fieldComponent'
        }, key)(componentMap[key]);
      });
      var src_components_AbnAcn = components_componentsWithOverride.AbnAcn,
          src_components_Alert = components_componentsWithOverride.Alert,
          src_components_AntDesignDatePicker = components_componentsWithOverride.AntDesignDatePicker,
          src_components_AutoComplete = components_componentsWithOverride.AutoComplete,
          src_components_AutoCompleteOption = components_componentsWithOverride.AutoCompleteOption,
          src_components_Button = components_componentsWithOverride.Button,
          src_components_ButtonList = components_componentsWithOverride.ButtonList,
          src_components_Checkbox = components_componentsWithOverride.Checkbox,
          src_components_CheckboxList = components_componentsWithOverride.CheckboxList,
          src_components_DatePicker = components_componentsWithOverride.DatePicker,
          src_components_DigitalSignature = components_componentsWithOverride.DigitalSignature,
          src_components_Dropdown = components_componentsWithOverride.Dropdown,
          src_components_DropdownNative = components_componentsWithOverride.DropdownNative,
          src_components_ErrorMessage = components_componentsWithOverride.ErrorMessage,
          src_components_FormLoading = components_componentsWithOverride.FormLoading,
          src_components_Field = components_componentsWithOverride.Field,
          src_components_FieldDescription = components_componentsWithOverride.FieldDescription,
          src_components_FileUpload = components_componentsWithOverride.FileUpload,
          src_components_Heading = components_componentsWithOverride.Heading,
          src_components_Image = components_componentsWithOverride.Image,
          src_components_InputMask = components_componentsWithOverride.InputMask,
          src_components_Label = components_componentsWithOverride.Label,
          src_components_NetPromoterScore = components_componentsWithOverride.NetPromoterScore,
          src_components_NumericInput = components_componentsWithOverride.NumericInput,
          src_components_NumericSlider = components_componentsWithOverride.NumericSlider,
          src_components_RadioList = components_componentsWithOverride.RadioList,
          src_components_Repeatable = components_componentsWithOverride.Repeatable,
          components_ReviewTable = components_componentsWithOverride.ReviewTable,
          src_components_RichTextArea = components_componentsWithOverride.RichTextArea,
          src_components_Text = components_componentsWithOverride.Text,
          src_components_Textarea = components_componentsWithOverride.Textarea,
          src_components_TrueFalse = components_componentsWithOverride.TrueFalse,
          components_InputCalendarPicker = components_componentsWithOverride.InputCalendarPicker;
      /* harmony default export */

      var src_components = __webpack_exports__["C"] = components_components;
      /***/
    },
    /* 16 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE__16__;
      /***/
    },
    /* 17 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectSpread.js

      var objectSpread = __webpack_require__(13);

      var objectSpread_default =
      /*#__PURE__*/
      __webpack_require__.n(objectSpread); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js


      var defineProperty = __webpack_require__(4);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: ./node_modules/lodash/concat.js


      var concat = __webpack_require__(688);

      var concat_default =
      /*#__PURE__*/
      __webpack_require__.n(concat); // EXTERNAL MODULE: ./node_modules/lodash/debounce.js


      var debounce = __webpack_require__(35);

      var debounce_default =
      /*#__PURE__*/
      __webpack_require__.n(debounce); // EXTERNAL MODULE: ./node_modules/lodash/get.js


      var get = __webpack_require__(10);

      var get_default =
      /*#__PURE__*/
      __webpack_require__.n(get); // EXTERNAL MODULE: ./node_modules/lodash/uniqWith.js


      var uniqWith = __webpack_require__(687);

      var uniqWith_default =
      /*#__PURE__*/
      __webpack_require__.n(uniqWith); // EXTERNAL MODULE: ./node_modules/lodash/isEqual.js


      var isEqual = __webpack_require__(30);

      var isEqual_default =
      /*#__PURE__*/
      __webpack_require__.n(isEqual); // EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js


      var isEmpty = __webpack_require__(25);

      var isEmpty_default =
      /*#__PURE__*/
      __webpack_require__.n(isEmpty); // EXTERNAL MODULE: ./src/core/utils/constants.js


      var constants = __webpack_require__(27); // EXTERNAL MODULE: ./src/core/utils/localStorage.js


      var localStorage = __webpack_require__(44); // EXTERNAL MODULE: ./src/core/utils.js + 1 modules


      var utils = __webpack_require__(18); // EXTERNAL MODULE: ./src/core/utils/actions/index.js + 4 modules


      var actions = __webpack_require__(69); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js


      var taggedTemplateLiteral = __webpack_require__(78);

      var taggedTemplateLiteral_default =
      /*#__PURE__*/
      __webpack_require__.n(taggedTemplateLiteral); // EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js


      var src = __webpack_require__(119);

      var src_default =
      /*#__PURE__*/
      __webpack_require__.n(src); // CONCATENATED MODULE: ./src/core/utils/graphql/analytics.js


      function analytics_templateObject() {
        var data = taggedTemplateLiteral_default()(["\n  mutation AddAnalyticLog(\n    $submissionId: String!\n    $formId: Int!\n    $snapshotId: String\n    $channel: String\n    $branch: String\n    $events: [analyticEvent]!\n  ) {\n    AddAnalyticLog(\n      submissionId: $submissionId\n      formId: $formId\n      snapshotId: $snapshotId\n      channel: $channel\n      branch: $branch\n      events: $events\n    ) {\n      success\n    }\n  }\n"]);

        analytics_templateObject = function _templateObject() {
          return data;
        };

        return data;
      }

      var analytics_addAnalyticLogMutation = src_default()(analytics_templateObject());
      /**
       * Returns the options to be used in conjuction with addAnalyticLogMutation.
       * It returns an object that contains variables and optimisticResponse objects on it.
       * @param {number} formId
       * @param {string} submissionId
       * @param {array} newAttributes Array of objects where every object has the following structure { id, value }
       * @param {array} newFields Array of objects where every object has the following structure { id, value }
       * @param {object} currentSubmission Object that contains the current submission values for attributes and fields (both arrays).
       * @param {number} timestamp
       * @param {string} channel
       * @param {string} branch
       */

      var analytics_getAnalyticLogOptions = function getAnalyticLogOptions(formId, submissionId, events, snapshotId, channel, branch) {
        return {
          variables: {
            formId: formId,
            submissionId: submissionId,
            events: events,
            snapshotId: snapshotId,
            channel: channel,
            branch: branch
          }
        };
      }; // CONCATENATED MODULE: ./src/core/utils/analytics.js

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return analytics_AnalyticsEvents;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return analytics_AnalyticsEventsDataId;
      });
      /* unused harmony export sendAnalyticsData */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return analytics_analyticsCallback;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return analytics_getAnalyticsParam;
      });

      var analytics_AnalyticsEventsDataI;
      var analytics_AnalyticsEvents = {
        Blur: 'onBlur',
        Click: 'onClick',
        FieldError: 'onFieldError',
        Focus: 'onFocus',
        FormComplete: 'onFormComplete',
        FormInit: 'onFormInit',
        NextPage: 'onNextPage',
        NextPageClick: 'onNextPageClick',
        PrevPageClick: 'onPrevPageClick',
        PrevPage: 'onPrevPage',
        ValueChange: 'onValueChange',
        WindowBlur: 'onWindowBlur',
        WindowClose: 'onWindowClose',
        WindowFocus: 'onWindowFocus',
        InteractionStart: 'interactionStart',
        InteractionEnd: 'interactionEnd'
      };
      var analytics_AnalyticsEventsDataId = (analytics_AnalyticsEventsDataI = {}, defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.Blur, ['fieldId']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.Click, ['fieldId']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.Focus, ['fieldId']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.NextPageClick, ['currentPage']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.PrevPageClick, ['currentPage']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.ValueChange, ['fieldId']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.FieldError, ['fieldId']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.FormInit, ['pageId']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.WindowBlur, ['pageId']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.WindowFocus, ['pageId']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.WindowClose, ['pageId']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.FormComplete, ['pageId']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.PrevPage, ['from', 'to']), defineProperty_default()(analytics_AnalyticsEventsDataI, analytics_AnalyticsEvents.NextPage, ['from', 'to']), analytics_AnalyticsEventsDataI);

      var analytics_createAnalyticsSendQueue = function createAnalyticsSendQueue(formId) {
        var storageEngine = Object(localStorage["e"
        /* getStorageEngine */
        ])();
        var cacheKey = "formaticAnalytics-".concat(formId);
        var queueKey = "formaticAnalyticsQueue-".concat(formId);
        var queue = Object(utils["s"
        /* safeJSONParse */
        ])(Object(localStorage["f"
        /* localStorageGetItem */
        ])(queueKey, storageEngine)) || {};
        var cache = Object(utils["s"
        /* safeJSONParse */
        ])(Object(localStorage["f"
        /* localStorageGetItem */
        ])(cacheKey, storageEngine)) || {};
        var events = concat_default()(queue.events || [], cache.events || []);

        if (events.length > 0) {
          Object(localStorage["h"
          /* localStorageSetItem */
          ])(queueKey, JSON.stringify(objectSpread_default()({}, cache, {
            events: events
          })), storageEngine);
          Object(localStorage["g"
          /* localStorageRemoveItem */
          ])(cacheKey, storageEngine);
          var lastSentKey = "formaticAnalyticsSent-".concat(formId);
          Object(localStorage["h"
          /* localStorageSetItem */
          ])(lastSentKey, Object(utils["q"
          /* now */
          ])().toString(), storageEngine);
          return queueKey;
        }

        return '';
      }; // Run the mutation to save analytic log
      // On failure, requeue the event to try again later.


      var analytics_sendAnalyticsData = function sendAnalyticsData(key) {
        var storageEngine = Object(localStorage["e"
        /* getStorageEngine */
        ])();
        var analyticData = Object(utils["s"
        /* safeJSONParse */
        ])(Object(localStorage["f"
        /* localStorageGetItem */
        ])(key, storageEngine));

        if (analyticData === null || !analyticData.submissionId) {
          Object(localStorage["g"
          /* localStorageRemoveItem */
          ])(key);
          return;
        }

        var options = analytics_getAnalyticLogOptions(analyticData.formId, analyticData.submissionId, analyticData.events, '', // @TODO snapshotId required,
        analyticData.channel, analyticData.branch); // Always remove from local queue

        Object(localStorage["g"
        /* localStorageRemoveItem */
        ])(key);
        var client = Object(actions["a"
        /* getClient */
        ])();
        client.mutate(objectSpread_default()({
          mutation: analytics_addAnalyticLogMutation
        }, options)).then(function (response) {
          var requeueAnalyticLog = true;

          try {
            requeueAnalyticLog = response.data.AddAnalyticLog.success !== true;
          } catch (error) {} // Assuming requeue above
          // @TODO on server failure, this could stuck in an endless cycle?


          if (requeueAnalyticLog) {
            // See if more analytics have been queued since this request.
            // If so, update our analyticData object with a unique set of events and re-queue it
            var cache = Object(utils["s"
            /* safeJSONParse */
            ])(Object(localStorage["f"
            /* localStorageGetItem */
            ])(key, storageEngine));

            if (cache) {
              var cacheEvents = cache.events || [];
              var allEvents = cacheEvents.concat(analyticData.events);
              analyticData.events = uniqWith_default()(allEvents, isEqual_default.a);
            }

            Object(localStorage["h"
            /* localStorageSetItem */
            ])(key, JSON.stringify(analyticData), storageEngine);
          }
        });
      }; // Debounces the send request to batch send events that trigger in quick succession,
      // eg.fieldBlur and fieldFocus while tabbing through form fields


      var analytics_debouncedSendAnalytics = debounce_default()(function (formId) {
        return analytics_sendAnalyticsData(analytics_createAnalyticsSendQueue(formId));
      }, 250);

      var analytics_analyticsCallback = function analyticsCallback(sessionData, emitter, parentId) {
        return function (eventType, args) {
          var params = typeof args === 'function' ? args() : args;

          if (parentId) {
            params.parentId = parentId;
          }

          var eventData = {
            time: Object(utils["q"
            /* now */
            ])(),
            event: eventType,
            params: params
          };
          var cacheKey = "formaticAnalytics-".concat(sessionData.formId);
          var lastSentKey = "formaticAnalyticsSent-".concat(sessionData.formId);
          var storageEngine = Object(localStorage["e"
          /* getStorageEngine */
          ])();
          var cache = Object(utils["s"
          /* safeJSONParse */
          ])(Object(localStorage["f"
          /* localStorageGetItem */
          ])(cacheKey, storageEngine)) || sessionData;
          var events = cache.events || [];
          events.push(eventData);
          Object(localStorage["h"
          /* localStorageSetItem */
          ])(cacheKey, JSON.stringify(objectSpread_default()({}, cache, {
            events: events
          })), storageEngine);
          var lastSent = parseInt(Object(localStorage["f"
          /* localStorageGetItem */
          ])(lastSentKey, storageEngine), 10) || 0;
          var threshold = 2000;

          if (Object(utils["q"
          /* now */
          ])() - lastSent > threshold) {
            analytics_debouncedSendAnalytics(sessionData.formId);
          }

          emitter.emit(constants["Events"].AnalyticsCallback, {
            type: eventType,
            data: eventData
          });
        };
      };

      function analytics_getAnalyticsParam(paramValue) {
        var result = {
          valueLength: 0,
          component: ''
        };

        if (paramValue === undefined) {
          return result;
        }

        if (paramValue.length) {
          // string and array
          result.valueLength = get_default()(paramValue, 'length');
        } else if (Object.keys(paramValue).length > 0) {
          // object
          return Object.keys(paramValue).reduce(function (acc, key) {
            var analyticsParam = analytics_getAnalyticsParam(paramValue[key]);
            acc.valueLength += analyticsParam.valueLength;

            if (!isEmpty_default()(acc.component)) {
              acc.component += '-';
            }

            acc.component += analyticsParam.component + key;
            return acc;
          }, result);
        } else if (typeof paramValue === 'boolean') {
          result.valueLength = 1;
        } else if (typeof paramValue === 'number') {
          result.valueLength = paramValue.toString().length;
        }

        return objectSpread_default()({}, result);
      }
      /* harmony default export */


      var analytics = {
        AnalyticsEvents: analytics_AnalyticsEvents,
        AnalyticsEventsDataId: analytics_AnalyticsEventsDataId,
        sendAnalyticsData: analytics_sendAnalyticsData,
        analyticsCallback: analytics_analyticsCallback,
        getAnalyticsParam: analytics_getAnalyticsParam
      };
      /***/
    },
    /* 18 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/toConsumableArray.js

      var toConsumableArray = __webpack_require__(40);

      var toConsumableArray_default =
      /*#__PURE__*/
      __webpack_require__.n(toConsumableArray); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js


      var helpers_typeof = __webpack_require__(39);

      var typeof_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_typeof); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1); // EXTERNAL MODULE: ./node_modules/lodash/isString.js


      var isString = __webpack_require__(121);

      var isString_default =
      /*#__PURE__*/
      __webpack_require__.n(isString); // EXTERNAL MODULE: ./node_modules/lodash/omit.js


      var omit = __webpack_require__(62);

      var omit_default =
      /*#__PURE__*/
      __webpack_require__.n(omit); // EXTERNAL MODULE: ./node_modules/lodash/values.js


      var values = __webpack_require__(378);

      var values_default =
      /*#__PURE__*/
      __webpack_require__.n(values); // EXTERNAL MODULE: ./node_modules/lodash/isNumber.js


      var isNumber = __webpack_require__(690);

      var isNumber_default =
      /*#__PURE__*/
      __webpack_require__.n(isNumber); // EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js


      var lodash_isEmpty = __webpack_require__(25);

      var isEmpty_default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_isEmpty); // EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js


      var purify = __webpack_require__(689);

      var purify_default =
      /*#__PURE__*/
      __webpack_require__.n(purify); // EXTERNAL MODULE: ./node_modules/lodash/isEqual.js


      var isEqual = __webpack_require__(30);

      var isEqual_default =
      /*#__PURE__*/
      __webpack_require__.n(isEqual); // EXTERNAL MODULE: ./src/config/index.js


      var config = __webpack_require__(28); // CONCATENATED MODULE: ./src/config/lang.js

      /**
       * English language dictionary
       * @type {Object}
       */


      var en = {
        formLoading: 'Loading ...'
      };
      /**
       * Spanish language dictionary
       * @type {Object}
       */

      var es = {
        formLoading: 'Cargando ...'
      };
      /**
       * Export out the languages
       * @type {Object}
       */

      /* harmony default export */

      var lang = {
        en: en,
        es: es
      }; // CONCATENATED MODULE: ./src/core/utils.js

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "h", function () {
        return utils_getOrigin;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "i", function () {
        return utils_getOverrides;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "l", function () {
        return utils_getRootComponents;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "g", function () {
        return utils_getLangValue;
      });
      /* unused harmony export capitalize */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "n", function () {
        return utils_getValueFromList;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "f", function () {
        return utils_getKVObjectFromList;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "p", function () {
        return utils_mobileAndTabletcheck;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "k", function () {
        return utils_getRandomId;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "r", function () {
        return utils_randomString;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "s", function () {
        return utils_safeJSONParse;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "q", function () {
        return utils_now;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "j", function () {
        return utils_getParameterByName;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "t", function () {
        return utils_valueHasInputMask;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return utils_getInputRawValue;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return utils_getInputValueAsStringIfAvailable;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "o", function () {
        return utils_isEmpty;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return utils_equalOrEmpty;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "m", function () {
        return utils_getSafeHTML;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return utils_formatWord;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return utils_getDatePattern;
      });
      /**
       * Gets current url and port
       * @return {string}
       */


      var utils_getOrigin = function getOrigin() {
        var origin = window.location.href;
        origin = origin.split('/');
        origin = "".concat(origin[0], "//").concat(origin[2]);
        return origin;
      };
      /**
       * Formats overrides from children props and returns the overrides
       * @param  {object} children - React props children
       * @return {object}
       */


      var utils_getOverrides = function getOverrides(children) {
        var overrides = {};
        var overrideTypes = {
          OverrideFieldComponent: 'fieldComponent',
          OverrideFieldContainer: 'fieldContainer',
          OverrideSection: 'sections',
          OverridePage: 'pages',
          OverrideSystem: 'system',
          OverrideHOC: 'hoc'
        }; // initialise override

        values_default()(overrideTypes).forEach(function (overrideKey) {
          overrides[overrideKey] = [];
        });
        external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(children, function (child) {
          if (typeof overrideTypes[child.props.overrideType] !== 'undefined') {
            overrides[overrideTypes[child.props.overrideType]].push(omit_default()(child.props, 'overrideType'));
          }
        });
        return overrides;
      };
      /**
       * Gets root components given children props
       * @param  {object} children - React props children
       * @return {array}
       */


      var utils_getRootComponents = function getRootComponents(children) {
        var rootComponents = [];
        external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(children, function (child) {
          if (child.props.injectableType === 'RootComponent') {
            rootComponents.push(child.props);
          }
        });
        return rootComponents;
      };
      /**
       * Given a key it will fetch a value from config
       * @param  {string} key - Language dictionary key
       * @param  {string} [selectedLang=config.defaultLang] - Config language
       * @return {string}
       */


      var utils_getLangValueFromConfig = function getLangValueFromConfig(key) {
        var selectedLang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : config["a"
        /* default */
        ].defaultLang; // probably needs better error handling here ...

        return lang[selectedLang][key];
      };
      /**
       * Given a key will fetch a value from the langDict or a default value from config
       * @param  {string} key - Language dictionary key
       * @param  {Object|string} langDict - String or object of dictionary
       * @return {string}
       */


      var utils_getLangValue = function getLangValue(key) {
        var langDict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (typeof_default()(langDict) === 'object') {
          if (typeof langDict[key] !== 'undefined') {
            return langDict[key];
          }
        }

        if (typeof langDict === 'string') {
          return utils_getLangValueFromConfig(key, langDict);
        }

        return utils_getLangValueFromConfig(key);
      };
      /**
       * Capitalise the first character
       * @param  {string} inputString
       * @return {string}
       */


      var utils_capitalize = function capitalize(inputString) {
        if (!isString_default()(inputString)) {
          return inputString;
        }

        return inputString.charAt(0).toUpperCase() + inputString.slice(1);
      };
      /**
       * Provides the data from a list with { id, value }
       * @param  {string} id
       * @param  {array} list
       * @return {string|object|null}
       */


      var utils_getValueFromList = function getValueFromList(id, list) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';

        if (!Array.isArray(list)) {
          try {
            list = Object.keys(list);
          } catch (e) {
            return null;
          }
        }

        var filtered = list.filter(function (x) {
          return x.id === id;
        });

        if (filtered.length === 0) {
          return null;
        }

        if (isString_default()(key)) {
          return filtered[0][key];
        }

        return filtered[0];
      };
      /**
       * Returns a k:v object from a list
       * @param  {array} list
       * @return {object}
       */


      var utils_getKVObjectFromList = function getKVObjectFromList(list) {
        if (!Array.isArray(list)) {
          return {};
        }

        var returnValues = {}; // eslint-disable-next-line no-return-assign

        list.map(function (x) {
          return returnValues[x.id] = x.value;
        });
        return returnValues;
      };

      var utils_mobileAndTabletcheck = function mobileAndTabletcheck() {
        var check = false;

        var isMobile = function isMobile(a) {
          if (/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(a)) {
            check = true;
          }
        };

        isMobile(window.opera || window.navigator.userAgent || window.navigator.vendor);
        return check;
      }; // getRandomId from https://stackoverflow.com/questions/6860853/generate-random-string-for-div-id


      var utils_getRandomId = function getRandomId() {
        var s4 = function s4() {
          return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
        }; // eslint-disable-line no-bitwise


        return "".concat(s4()).concat(s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4()).concat(s4()).concat(s4());
      };

      var utils_randomString = function randomString(length) {
        var lowerCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var text = '';
        var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';

        for (var i = 0; i <= length - 1; i += 1) {
          text += possible[Math.floor(Math.random() * possible.length)];
        }

        return lowerCase ? text.toLowerCase() : text;
      }; // Returns null on an invalid stringified JSON


      var utils_safeJSONParse = function safeJSONParse(str) {
        try {
          return JSON.parse(str);
        } catch (e) {
          return null;
        }
      }; // Return current timestamp in milliseconds


      var utils_now = function now() {
        return new Date().getTime();
      }; // getParameterByName from https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript


      var utils_getParameterByName = function getParameterByName(name, url) {
        var getFromParentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var windowHref = getFromParentPage ? window.parent.location.href : window.location.href;
        url = !url ? windowHref : url;
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"));
        var results = regex.exec(url);
        if (!results) return undefined;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      };
      /**
       * Returns true if a field value has had an input mask applied against it
       * @param {mixed} value
       * @returns {boolean}
       */


      var utils_valueHasInputMask = function valueHasInputMask(value) {
        return value !== null && typeof_default()(value) === 'object' && Object.prototype.hasOwnProperty.call(value, 'maskedValue') && Object.prototype.hasOwnProperty.call(value, 'rawValue');
      };
      /**
       * Returns the raw value from a field that has had an input mask applied against it
       * @param {object} value
       * @returns {string}
       */


      var utils_getInputRawValue = function getInputRawValue(value) {
        return utils_valueHasInputMask(value) ? value.rawValue : value;
      };
      /**
       * Attempt to translate the value if an input when that input is an object,
       * to get this helper working your input value (the object) must contain a toStringValue attribute.
       * @param {object} value
       * @returns {string}
       */


      var utils_getInputValueAsStringIfAvailable = function getInputValueAsStringIfAvailable(value) {
        if (typeof value.toStringValue === 'string') {
          return value.toStringValue;
        }

        return value;
      }; // Lodash isEmpty have a problem with number values
      // https://lodash.com/docs/4.17.4#isEmpty numbers are considered empty


      var utils_isEmpty = function isEmpty(value) {
        return isNumber_default()(value) ? false : isEmpty_default()(value);
      };
      /**
       * Compares valueA and valueB and returns true if they equal OR if both are empty.
       * Otherwise it returns false.
       */


      var utils_equalOrEmpty = function equalOrEmpty(valueA, valueB) {
        if (Array.isArray(valueA) && Array.isArray(valueB)) {
          return isEqual_default()(toConsumableArray_default()(valueA).sort(), toConsumableArray_default()(valueB).sort()) || utils_isEmpty(valueA) && utils_isEmpty(valueB);
        }

        return isEqual_default()(valueA, valueB) || utils_isEmpty(valueA) && utils_isEmpty(valueB);
      };

      var utils_getSafeHTML = function getSafeHTML(unsafe) {
        var customAtt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var configAtt = {
          ADD_ATTR: ['target', 'href'].concat(toConsumableArray_default()(customAtt))
        };
        return purify_default.a.sanitize(unsafe, configAtt);
      };
      /**
       * Transforms API result to human redeable format
       * @param {string} word
       * @return {string}
       */


      var utils_formatWord = function formatWord(word) {
        var formattedWord = word.replace(/_/g, ' ', 'g').toLowerCase();
        return formattedWord.substr(0, 1).toUpperCase() + formattedWord.substr(1);
      }; // returns pattern of data for the input masking in DatePickerContainer component


      var utils_getDatePattern = function getDatePattern(format) {
        var seperator = format.match(/(-|\/|\.)/g);
        var pattern = format.split(seperator[0]).map(function (item) {
          return item.length;
        });
        return {
          seperator: seperator[0],
          pattern: pattern,
          format: format
        };
      };
      /***/

    },
    /* 19 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /**
       * @ignore
       * some key-codes definition and utils from closure-library
       * @author yiminghe@gmail.com
       */

      var KeyCode = {
        /**
         * MAC_ENTER
         */
        MAC_ENTER: 3,

        /**
         * BACKSPACE
         */
        BACKSPACE: 8,

        /**
         * TAB
         */
        TAB: 9,

        /**
         * NUMLOCK on FF/Safari Mac
         */
        NUM_CENTER: 12,
        // NUMLOCK on FF/Safari Mac

        /**
         * ENTER
         */
        ENTER: 13,

        /**
         * SHIFT
         */
        SHIFT: 16,

        /**
         * CTRL
         */
        CTRL: 17,

        /**
         * ALT
         */
        ALT: 18,

        /**
         * PAUSE
         */
        PAUSE: 19,

        /**
         * CAPS_LOCK
         */
        CAPS_LOCK: 20,

        /**
         * ESC
         */
        ESC: 27,

        /**
         * SPACE
         */
        SPACE: 32,

        /**
         * PAGE_UP
         */
        PAGE_UP: 33,
        // also NUM_NORTH_EAST

        /**
         * PAGE_DOWN
         */
        PAGE_DOWN: 34,
        // also NUM_SOUTH_EAST

        /**
         * END
         */
        END: 35,
        // also NUM_SOUTH_WEST

        /**
         * HOME
         */
        HOME: 36,
        // also NUM_NORTH_WEST

        /**
         * LEFT
         */
        LEFT: 37,
        // also NUM_WEST

        /**
         * UP
         */
        UP: 38,
        // also NUM_NORTH

        /**
         * RIGHT
         */
        RIGHT: 39,
        // also NUM_EAST

        /**
         * DOWN
         */
        DOWN: 40,
        // also NUM_SOUTH

        /**
         * PRINT_SCREEN
         */
        PRINT_SCREEN: 44,

        /**
         * INSERT
         */
        INSERT: 45,
        // also NUM_INSERT

        /**
         * DELETE
         */
        DELETE: 46,
        // also NUM_DELETE

        /**
         * ZERO
         */
        ZERO: 48,

        /**
         * ONE
         */
        ONE: 49,

        /**
         * TWO
         */
        TWO: 50,

        /**
         * THREE
         */
        THREE: 51,

        /**
         * FOUR
         */
        FOUR: 52,

        /**
         * FIVE
         */
        FIVE: 53,

        /**
         * SIX
         */
        SIX: 54,

        /**
         * SEVEN
         */
        SEVEN: 55,

        /**
         * EIGHT
         */
        EIGHT: 56,

        /**
         * NINE
         */
        NINE: 57,

        /**
         * QUESTION_MARK
         */
        QUESTION_MARK: 63,
        // needs localization

        /**
         * A
         */
        A: 65,

        /**
         * B
         */
        B: 66,

        /**
         * C
         */
        C: 67,

        /**
         * D
         */
        D: 68,

        /**
         * E
         */
        E: 69,

        /**
         * F
         */
        F: 70,

        /**
         * G
         */
        G: 71,

        /**
         * H
         */
        H: 72,

        /**
         * I
         */
        I: 73,

        /**
         * J
         */
        J: 74,

        /**
         * K
         */
        K: 75,

        /**
         * L
         */
        L: 76,

        /**
         * M
         */
        M: 77,

        /**
         * N
         */
        N: 78,

        /**
         * O
         */
        O: 79,

        /**
         * P
         */
        P: 80,

        /**
         * Q
         */
        Q: 81,

        /**
         * R
         */
        R: 82,

        /**
         * S
         */
        S: 83,

        /**
         * T
         */
        T: 84,

        /**
         * U
         */
        U: 85,

        /**
         * V
         */
        V: 86,

        /**
         * W
         */
        W: 87,

        /**
         * X
         */
        X: 88,

        /**
         * Y
         */
        Y: 89,

        /**
         * Z
         */
        Z: 90,

        /**
         * META
         */
        META: 91,
        // WIN_KEY_LEFT

        /**
         * WIN_KEY_RIGHT
         */
        WIN_KEY_RIGHT: 92,

        /**
         * CONTEXT_MENU
         */
        CONTEXT_MENU: 93,

        /**
         * NUM_ZERO
         */
        NUM_ZERO: 96,

        /**
         * NUM_ONE
         */
        NUM_ONE: 97,

        /**
         * NUM_TWO
         */
        NUM_TWO: 98,

        /**
         * NUM_THREE
         */
        NUM_THREE: 99,

        /**
         * NUM_FOUR
         */
        NUM_FOUR: 100,

        /**
         * NUM_FIVE
         */
        NUM_FIVE: 101,

        /**
         * NUM_SIX
         */
        NUM_SIX: 102,

        /**
         * NUM_SEVEN
         */
        NUM_SEVEN: 103,

        /**
         * NUM_EIGHT
         */
        NUM_EIGHT: 104,

        /**
         * NUM_NINE
         */
        NUM_NINE: 105,

        /**
         * NUM_MULTIPLY
         */
        NUM_MULTIPLY: 106,

        /**
         * NUM_PLUS
         */
        NUM_PLUS: 107,

        /**
         * NUM_MINUS
         */
        NUM_MINUS: 109,

        /**
         * NUM_PERIOD
         */
        NUM_PERIOD: 110,

        /**
         * NUM_DIVISION
         */
        NUM_DIVISION: 111,

        /**
         * F1
         */
        F1: 112,

        /**
         * F2
         */
        F2: 113,

        /**
         * F3
         */
        F3: 114,

        /**
         * F4
         */
        F4: 115,

        /**
         * F5
         */
        F5: 116,

        /**
         * F6
         */
        F6: 117,

        /**
         * F7
         */
        F7: 118,

        /**
         * F8
         */
        F8: 119,

        /**
         * F9
         */
        F9: 120,

        /**
         * F10
         */
        F10: 121,

        /**
         * F11
         */
        F11: 122,

        /**
         * F12
         */
        F12: 123,

        /**
         * NUMLOCK
         */
        NUMLOCK: 144,

        /**
         * SEMICOLON
         */
        SEMICOLON: 186,
        // needs localization

        /**
         * DASH
         */
        DASH: 189,
        // needs localization

        /**
         * EQUALS
         */
        EQUALS: 187,
        // needs localization

        /**
         * COMMA
         */
        COMMA: 188,
        // needs localization

        /**
         * PERIOD
         */
        PERIOD: 190,
        // needs localization

        /**
         * SLASH
         */
        SLASH: 191,
        // needs localization

        /**
         * APOSTROPHE
         */
        APOSTROPHE: 192,
        // needs localization

        /**
         * SINGLE_QUOTE
         */
        SINGLE_QUOTE: 222,
        // needs localization

        /**
         * OPEN_SQUARE_BRACKET
         */
        OPEN_SQUARE_BRACKET: 219,
        // needs localization

        /**
         * BACKSLASH
         */
        BACKSLASH: 220,
        // needs localization

        /**
         * CLOSE_SQUARE_BRACKET
         */
        CLOSE_SQUARE_BRACKET: 221,
        // needs localization

        /**
         * WIN_KEY
         */
        WIN_KEY: 224,

        /**
         * MAC_FF_META
         */
        MAC_FF_META: 224,
        // Firefox (Gecko) fires this for the meta key instead of 91

        /**
         * WIN_IME
         */
        WIN_IME: 229
      };
      /*
       whether text and modified key is entered at the same time.
       */

      KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;

        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
          return false;
        } // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.


        switch (keyCode) {
          case KeyCode.ALT:
          case KeyCode.CAPS_LOCK:
          case KeyCode.CONTEXT_MENU:
          case KeyCode.CTRL:
          case KeyCode.DOWN:
          case KeyCode.END:
          case KeyCode.ESC:
          case KeyCode.HOME:
          case KeyCode.INSERT:
          case KeyCode.LEFT:
          case KeyCode.MAC_FF_META:
          case KeyCode.META:
          case KeyCode.NUMLOCK:
          case KeyCode.NUM_CENTER:
          case KeyCode.PAGE_DOWN:
          case KeyCode.PAGE_UP:
          case KeyCode.PAUSE:
          case KeyCode.PRINT_SCREEN:
          case KeyCode.RIGHT:
          case KeyCode.SHIFT:
          case KeyCode.UP:
          case KeyCode.WIN_KEY:
          case KeyCode.WIN_KEY_RIGHT:
            return false;

          default:
            return true;
        }
      };
      /*
       whether character is entered.
       */


      KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
        if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
          return true;
        }

        if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
          return true;
        }

        if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
          return true;
        } // Safari sends zero key code for non-latin characters.


        if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
          return true;
        }

        switch (keyCode) {
          case KeyCode.SPACE:
          case KeyCode.QUESTION_MARK:
          case KeyCode.NUM_PLUS:
          case KeyCode.NUM_MINUS:
          case KeyCode.NUM_PERIOD:
          case KeyCode.NUM_DIVISION:
          case KeyCode.SEMICOLON:
          case KeyCode.DASH:
          case KeyCode.EQUALS:
          case KeyCode.COMMA:
          case KeyCode.PERIOD:
          case KeyCode.SLASH:
          case KeyCode.APOSTROPHE:
          case KeyCode.SINGLE_QUOTE:
          case KeyCode.OPEN_SQUARE_BRACKET:
          case KeyCode.BACKSLASH:
          case KeyCode.CLOSE_SQUARE_BRACKET:
            return true;

          default:
            return false;
        }
      };
      /* harmony default export */


      __webpack_exports__["a"] = KeyCode;
      /***/
    },
    /* 20 */

    /***/
    function (module, exports) {
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      module.exports = _createClass;
      /***/
    },
    /* 21 */

    /***/
    function (module, exports) {
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      module.exports = _classCallCheck;
      /***/
    },
    /* 22 */

    /***/
    function (module, exports, __webpack_require__) {
      var setPrototypeOf = __webpack_require__(1195);

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) setPrototypeOf(subClass, superClass);
      }

      module.exports = _inherits;
      /***/
    },
    /* 23 */

    /***/
    function (module, exports) {
      function _getPrototypeOf(o) {
        module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }

      module.exports = _getPrototypeOf;
      /***/
    },
    /* 24 */

    /***/
    function (module, exports, __webpack_require__) {
      var _typeof = __webpack_require__(39);

      var assertThisInitialized = __webpack_require__(11);

      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }

        return assertThisInitialized(self);
      }

      module.exports = _possibleConstructorReturn;
      /***/
    },
    /* 25 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseKeys = __webpack_require__(456),
          getTag = __webpack_require__(153),
          isArguments = __webpack_require__(211),
          isArray = __webpack_require__(55),
          isArrayLike = __webpack_require__(134),
          isBuffer = __webpack_require__(208),
          isPrototype = __webpack_require__(209),
          isTypedArray = __webpack_require__(245);
      /** `Object#toString` result references. */


      var mapTag = '[object Map]',
          setTag = '[object Set]';
      /** Used for built-in method references. */

      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Checks if `value` is an empty object, collection, map, or set.
       *
       * Objects are considered empty if they have no own enumerable string keyed
       * properties.
       *
       * Array-like values such as `arguments` objects, arrays, buffers, strings, or
       * jQuery-like collections are considered empty if they have a `length` of `0`.
       * Similarly, maps and sets are considered empty if they have a `size` of `0`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is empty, else `false`.
       * @example
       *
       * _.isEmpty(null);
       * // => true
       *
       * _.isEmpty(true);
       * // => true
       *
       * _.isEmpty(1);
       * // => true
       *
       * _.isEmpty([1, 2, 3]);
       * // => false
       *
       * _.isEmpty({ 'a': 1 });
       * // => false
       */

      function isEmpty(value) {
        if (value == null) {
          return true;
        }

        if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }

        var tag = getTag(value);

        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }

        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }

        for (var key in value) {
          if (hasOwnProperty.call(value, key)) {
            return false;
          }
        }

        return true;
      }

      module.exports = isEmpty;
      /***/
    },
    /* 26 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export mapProps */

      /* unused harmony export withProps */

      /* unused harmony export withPropsOnChange */

      /* unused harmony export withHandlers */

      /* unused harmony export defaultProps */

      /* unused harmony export renameProp */

      /* unused harmony export renameProps */

      /* unused harmony export flattenProp */

      /* unused harmony export withState */

      /* unused harmony export withStateHandlers */

      /* unused harmony export withReducer */

      /* unused harmony export branch */

      /* unused harmony export renderComponent */

      /* unused harmony export renderNothing */

      /* unused harmony export shouldUpdate */

      /* unused harmony export pure */

      /* unused harmony export onlyUpdateForKeys */

      /* unused harmony export onlyUpdateForPropTypes */

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "c", function () {
        return withContext;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return getContext;
      });
      /* unused harmony export lifecycle */

      /* unused harmony export toClass */

      /* unused harmony export setStatic */

      /* unused harmony export setPropTypes */

      /* unused harmony export setDisplayName */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return compose;
      });
      /* unused harmony export getDisplayName */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return wrapDisplayName;
      });
      /* unused harmony export isClassComponent */

      /* unused harmony export createEagerElement */

      /* unused harmony export createEagerFactory */

      /* unused harmony export createSink */

      /* unused harmony export componentFromProp */

      /* unused harmony export nest */

      /* unused harmony export hoistStatics */

      /* unused harmony export componentFromStream */

      /* unused harmony export componentFromStreamWithConfig */

      /* unused harmony export mapPropsStream */

      /* unused harmony export mapPropsStreamWithConfig */

      /* unused harmony export createEventHandler */

      /* unused harmony export setObservableConfig */

      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var fbjs_lib_shallowEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(190);
      /* harmony import */


      var fbjs_lib_shallowEqual__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(fbjs_lib_shallowEqual__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(693);
      /* harmony import */


      var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var change_emitter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(385);
      /* harmony import */


      var change_emitter__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(change_emitter__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var symbol_observable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(122);

      var setStatic = function setStatic(key, value) {
        return function (BaseComponent) {
          /* eslint-disable no-param-reassign */
          BaseComponent[key] = value;
          /* eslint-enable no-param-reassign */

          return BaseComponent;
        };
      };

      var setDisplayName = function setDisplayName(displayName) {
        return setStatic('displayName', displayName);
      };

      var getDisplayName = function getDisplayName(Component$$1) {
        if (typeof Component$$1 === 'string') {
          return Component$$1;
        }

        if (!Component$$1) {
          return undefined;
        }

        return Component$$1.displayName || Component$$1.name || 'Component';
      };

      var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
        return hocName + '(' + getDisplayName(BaseComponent) + ')';
      };

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      var classCallCheck = function classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      };

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var inherits = function inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      };

      var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      };

      var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      };

      var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
        if (!hasKey && isReferentiallyTransparent) {
          if (children) {
            return type(_extends({}, props, {
              children: children
            }));
          }

          return type(props);
        }

        var Component$$1 = type;

        if (children) {
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component$$1, props, children);
        }

        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component$$1, props);
      };

      var isClassComponent = function isClassComponent(Component$$1) {
        return Boolean(Component$$1 && Component$$1.prototype && _typeof(Component$$1.prototype.isReactComponent) === 'object');
      };

      var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component$$1) {
        return Boolean(typeof Component$$1 === 'function' && !isClassComponent(Component$$1) && !Component$$1.defaultProps && !Component$$1.contextTypes && ("production" === 'production' || !Component$$1.propTypes));
      };

      var createFactory = function createFactory(type) {
        var isReferentiallyTransparent = isReferentiallyTransparentFunctionComponent(type);
        return function (p, c) {
          return createEagerElementUtil(false, isReferentiallyTransparent, type, p, c);
        };
      };

      var mapProps = function mapProps(propsMapper) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          var MapProps = function MapProps(props) {
            return factory(propsMapper(props));
          };

          if (false) {}

          return MapProps;
        };
      };

      var withProps = function withProps(input) {
        var hoc = mapProps(function (props) {
          return _extends({}, props, typeof input === 'function' ? input(props) : input);
        });

        if (false) {}

        return hoc;
      };

      var pick = function pick(obj, keys) {
        var result = {};

        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];

          if (obj.hasOwnProperty(key)) {
            result[key] = obj[key];
          }
        }

        return result;
      };

      var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);
          var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
            return !fbjs_lib_shallowEqual__WEBPACK_IMPORTED_MODULE_1___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
          };

          var WithPropsOnChange = function (_Component) {
            inherits(WithPropsOnChange, _Component);

            function WithPropsOnChange() {
              var _temp, _this, _ret;

              classCallCheck(this, WithPropsOnChange);

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
            }

            WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
              if (shouldMap(this.props, nextProps)) {
                this.computedProps = propsMapper(nextProps);
              }
            };

            WithPropsOnChange.prototype.render = function render() {
              return factory(_extends({}, this.props, this.computedProps));
            };

            return WithPropsOnChange;
          }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

          if (false) {}

          return WithPropsOnChange;
        };
      };

      var mapValues = function mapValues(obj, func) {
        var result = {};
        /* eslint-disable no-restricted-syntax */

        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            result[key] = func(obj[key], key);
          }
        }
        /* eslint-enable no-restricted-syntax */


        return result;
      };
      /* eslint-disable no-console */


      var withHandlers = function withHandlers(handlers) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          var WithHandlers = function (_Component) {
            inherits(WithHandlers, _Component);

            function WithHandlers() {
              var _temp, _this, _ret;

              classCallCheck(this, WithHandlers);

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
            }

            WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
              this.cachedHandlers = {};
            };

            WithHandlers.prototype.render = function render() {
              return factory(_extends({}, this.props, this.handlers));
            };

            return WithHandlers;
          }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

          var _initialiseProps = function _initialiseProps() {
            var _this2 = this;

            this.cachedHandlers = {};
            this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
              return function () {
                var cachedHandler = _this2.cachedHandlers[handlerName];

                if (cachedHandler) {
                  return cachedHandler.apply(undefined, arguments);
                }

                var handler = createHandler(_this2.props);
                _this2.cachedHandlers[handlerName] = handler;

                if (false) {}

                return handler.apply(undefined, arguments);
              };
            });
          };

          if (false) {}

          return WithHandlers;
        };
      };

      var defaultProps = function defaultProps(props) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          var DefaultProps = function DefaultProps(ownerProps) {
            return factory(ownerProps);
          };

          DefaultProps.defaultProps = props;

          if (false) {}

          return DefaultProps;
        };
      };

      var omit = function omit(obj, keys) {
        var rest = objectWithoutProperties(obj, []);

        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];

          if (rest.hasOwnProperty(key)) {
            delete rest[key];
          }
        }

        return rest;
      };

      var renameProp = function renameProp(oldName, newName) {
        var hoc = mapProps(function (props) {
          var _babelHelpers$extends;

          return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
        });

        if (false) {}

        return hoc;
      };

      var keys = Object.keys;

      var mapKeys = function mapKeys(obj, func) {
        return keys(obj).reduce(function (result, key) {
          var val = obj[key];
          /* eslint-disable no-param-reassign */

          result[func(val, key)] = val;
          /* eslint-enable no-param-reassign */

          return result;
        }, {});
      };

      var renameProps = function renameProps(nameMap) {
        var hoc = mapProps(function (props) {
          return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
            return nameMap[oldName];
          }));
        });

        if (false) {}

        return hoc;
      };

      var flattenProp = function flattenProp(propName) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          var FlattenProp = function FlattenProp(props) {
            return factory(_extends({}, props, props[propName]));
          };

          if (false) {}

          return FlattenProp;
        };
      };

      var withState = function withState(stateName, stateUpdaterName, initialState) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          var WithState = function (_Component) {
            inherits(WithState, _Component);

            function WithState() {
              var _temp, _this, _ret;

              classCallCheck(this, WithState);

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
                stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
              }, _this.updateStateValue = function (updateFn, callback) {
                return _this.setState(function (_ref) {
                  var stateValue = _ref.stateValue;
                  return {
                    stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
                  };
                }, callback);
              }, _temp), possibleConstructorReturn(_this, _ret);
            }

            WithState.prototype.render = function render() {
              var _babelHelpers$extends;

              return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
            };

            return WithState;
          }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

          if (false) {}

          return WithState;
        };
      };

      var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          var WithStateHandlers = function (_Component) {
            inherits(WithStateHandlers, _Component);

            function WithStateHandlers() {
              var _temp, _this, _ret;

              classCallCheck(this, WithStateHandlers);

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
            }

            WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
              var propsChanged = nextProps !== this.props; // the idea is to skip render if stateUpdater handler return undefined
              // this allows to create no state update handlers with access to state and props

              var stateChanged = !fbjs_lib_shallowEqual__WEBPACK_IMPORTED_MODULE_1___default()(nextState, this.state);
              return propsChanged || stateChanged;
            };

            WithStateHandlers.prototype.render = function render() {
              return factory(_extends({}, this.props, this.state, this.stateUpdaters));
            };

            return WithStateHandlers;
          }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

          var _initialiseProps = function _initialiseProps() {
            var _this2 = this;

            this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
            this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
              return function () {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = arguments[_key2];
                }

                return _this2.setState(function (state, props) {
                  return handler(state, props).apply(undefined, args);
                });
              };
            });
          };

          if (false) {}

          return WithStateHandlers;
        };
      };

      var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          var WithReducer = function (_Component) {
            inherits(WithReducer, _Component);

            function WithReducer() {
              var _temp, _this, _ret;

              classCallCheck(this, WithReducer);

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
                stateValue: _this.initializeStateValue()
              }, _this.dispatch = function (action) {
                return _this.setState(function (_ref) {
                  var stateValue = _ref.stateValue;
                  return {
                    stateValue: reducer(stateValue, action)
                  };
                });
              }, _temp), possibleConstructorReturn(_this, _ret);
            }

            WithReducer.prototype.initializeStateValue = function initializeStateValue() {
              if (initialState !== undefined) {
                return typeof initialState === 'function' ? initialState(this.props) : initialState;
              }

              return reducer(undefined, {
                type: '@@recompose/INIT'
              });
            };

            WithReducer.prototype.render = function render() {
              var _babelHelpers$extends;

              return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
            };

            return WithReducer;
          }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

          if (false) {}

          return WithReducer;
        };
      };

      var identity = function identity(Component$$1) {
        return Component$$1;
      };

      var branch = function branch(test, left) {
        var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
        return function (BaseComponent) {
          var leftFactory = void 0;
          var rightFactory = void 0;

          var Branch = function Branch(props) {
            if (test(props)) {
              leftFactory = leftFactory || createFactory(left(BaseComponent));
              return leftFactory(props);
            }

            rightFactory = rightFactory || createFactory(right(BaseComponent));
            return rightFactory(props);
          };

          if (false) {}

          return Branch;
        };
      };

      var renderComponent = function renderComponent(Component$$1) {
        return function (_) {
          var factory = createFactory(Component$$1);

          var RenderComponent = function RenderComponent(props) {
            return factory(props);
          };

          if (false) {}

          return RenderComponent;
        };
      };

      var Nothing = function (_Component) {
        inherits(Nothing, _Component);

        function Nothing() {
          classCallCheck(this, Nothing);
          return possibleConstructorReturn(this, _Component.apply(this, arguments));
        }

        Nothing.prototype.render = function render() {
          return null;
        };

        return Nothing;
      }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

      var renderNothing = function renderNothing(_) {
        return Nothing;
      };

      var shouldUpdate = function shouldUpdate(test) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          var ShouldUpdate = function (_Component) {
            inherits(ShouldUpdate, _Component);

            function ShouldUpdate() {
              classCallCheck(this, ShouldUpdate);
              return possibleConstructorReturn(this, _Component.apply(this, arguments));
            }

            ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
              return test(this.props, nextProps);
            };

            ShouldUpdate.prototype.render = function render() {
              return factory(this.props);
            };

            return ShouldUpdate;
          }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

          if (false) {}

          return ShouldUpdate;
        };
      };

      var pure = function pure(BaseComponent) {
        var hoc = shouldUpdate(function (props, nextProps) {
          return !fbjs_lib_shallowEqual__WEBPACK_IMPORTED_MODULE_1___default()(props, nextProps);
        });

        if (false) {}

        return hoc(BaseComponent);
      };

      var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
        var hoc = shouldUpdate(function (props, nextProps) {
          return !fbjs_lib_shallowEqual__WEBPACK_IMPORTED_MODULE_1___default()(pick(nextProps, propKeys), pick(props, propKeys));
        });

        if (false) {}

        return hoc;
      };

      var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
        var propTypes = BaseComponent.propTypes;

        if (false) {}

        var propKeys = Object.keys(propTypes || {});
        var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

        if (false) {}

        return OnlyUpdateForPropTypes;
      };

      var withContext = function withContext(childContextTypes, getChildContext) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          var WithContext = function (_Component) {
            inherits(WithContext, _Component);

            function WithContext() {
              var _temp, _this, _ret;

              classCallCheck(this, WithContext);

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
                return getChildContext(_this.props);
              }, _temp), possibleConstructorReturn(_this, _ret);
            }

            WithContext.prototype.render = function render() {
              return factory(this.props);
            };

            return WithContext;
          }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

          WithContext.childContextTypes = childContextTypes;

          if (false) {}

          return WithContext;
        };
      };

      var getContext = function getContext(contextTypes) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          var GetContext = function GetContext(ownerProps, context) {
            return factory(_extends({}, ownerProps, context));
          };

          GetContext.contextTypes = contextTypes;

          if (false) {}

          return GetContext;
        };
      };
      /* eslint-disable no-console */


      var lifecycle = function lifecycle(spec) {
        return function (BaseComponent) {
          var factory = createFactory(BaseComponent);

          if (false) {}

          var Lifecycle = function (_Component) {
            inherits(Lifecycle, _Component);

            function Lifecycle() {
              classCallCheck(this, Lifecycle);
              return possibleConstructorReturn(this, _Component.apply(this, arguments));
            }

            Lifecycle.prototype.render = function render() {
              return factory(_extends({}, this.props, this.state));
            };

            return Lifecycle;
          }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

          Object.keys(spec).forEach(function (hook) {
            return Lifecycle.prototype[hook] = spec[hook];
          });

          if (false) {}

          return Lifecycle;
        };
      };

      var toClass = function toClass(baseComponent) {
        if (isClassComponent(baseComponent)) {
          return baseComponent;
        }

        var ToClass = function (_Component) {
          inherits(ToClass, _Component);

          function ToClass() {
            classCallCheck(this, ToClass);
            return possibleConstructorReturn(this, _Component.apply(this, arguments));
          }

          ToClass.prototype.render = function render() {
            if (typeof baseComponent === 'string') {
              return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(baseComponent, this.props);
            }

            return baseComponent(this.props, this.context);
          };

          return ToClass;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

        ToClass.displayName = getDisplayName(baseComponent);
        ToClass.propTypes = baseComponent.propTypes;
        ToClass.contextTypes = baseComponent.contextTypes;
        ToClass.defaultProps = baseComponent.defaultProps;
        return ToClass;
      };

      var setPropTypes = function setPropTypes(propTypes) {
        return setStatic('propTypes', propTypes);
      };

      function compose() {
        for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
          funcs[_key] = arguments[_key];
        }

        if (funcs.length === 0) {
          return function (arg) {
            return arg;
          };
        }

        if (funcs.length === 1) {
          return funcs[0];
        }

        return funcs.reduce(function (a, b) {
          return function () {
            return a(b.apply(undefined, arguments));
          };
        });
      }

      var createEagerElement = function createEagerElement(type, props, children) {
        var isReferentiallyTransparent = isReferentiallyTransparentFunctionComponent(type);
        /* eslint-disable */

        var hasKey = props && props.hasOwnProperty('key');
        /* eslint-enable */

        return createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children);
      };

      var createSink = function createSink(callback) {
        return function (_Component) {
          inherits(Sink, _Component);

          function Sink() {
            classCallCheck(this, Sink);
            return possibleConstructorReturn(this, _Component.apply(this, arguments));
          }

          Sink.prototype.componentWillMount = function componentWillMount() {
            callback(this.props);
          };

          Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            callback(nextProps);
          };

          Sink.prototype.render = function render() {
            return null;
          };

          return Sink;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
      };

      var componentFromProp = function componentFromProp(propName) {
        var Component$$1 = function Component$$1(props) {
          return createEagerElement(props[propName], omit(props, [propName]));
        };

        Component$$1.displayName = 'componentFromProp(' + propName + ')';
        return Component$$1;
      };

      var nest = function nest() {
        for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
          Components[_key] = arguments[_key];
        }

        var factories = Components.map(createFactory);

        var Nest = function Nest(_ref) {
          var props = objectWithoutProperties(_ref, []),
              children = _ref.children;
          return factories.reduceRight(function (child, factory) {
            return factory(props, child);
          }, children);
        };

        if (false) {
          var displayNames;
        }

        return Nest;
      };

      var hoistStatics = function hoistStatics(higherOrderComponent) {
        return function (BaseComponent) {
          var NewComponent = higherOrderComponent(BaseComponent);
          hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default()(NewComponent, BaseComponent);
          return NewComponent;
        };
      };

      var _config = {
        fromESObservable: null,
        toESObservable: null
      };

      var configureObservable = function configureObservable(c) {
        _config = c;
      };

      var config = {
        fromESObservable: function fromESObservable(observable) {
          return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
        },
        toESObservable: function toESObservable(stream) {
          return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
        }
      };

      var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
        return function (propsToVdom) {
          return function (_Component) {
            inherits(ComponentFromStream, _Component);

            function ComponentFromStream() {
              var _config$fromESObserva;

              var _temp, _this, _ret;

              classCallCheck(this, ComponentFromStream);

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
                vdom: null
              }, _this.propsEmitter = Object(change_emitter__WEBPACK_IMPORTED_MODULE_3__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
                subscribe: function subscribe(observer) {
                  var unsubscribe = _this.propsEmitter.listen(function (props) {
                    if (props) {
                      observer.next(props);
                    } else {
                      observer.complete();
                    }
                  });

                  return {
                    unsubscribe: unsubscribe
                  };
                }
              }, _config$fromESObserva[symbol_observable__WEBPACK_IMPORTED_MODULE_4__["default"]] = function () {
                return this;
              }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
            } // Stream of props
            // Stream of vdom


            ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
              var _this2 = this; // Subscribe to child prop changes so we know when to re-render


              this.subscription = this.vdom$.subscribe({
                next: function next(vdom) {
                  _this2.setState({
                    vdom: vdom
                  });
                }
              });
              this.propsEmitter.emit(this.props);
            };

            ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
              // Receive new props from the owner
              this.propsEmitter.emit(nextProps);
            };

            ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
              return nextState.vdom !== this.state.vdom;
            };

            ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
              // Call without arguments to complete stream
              this.propsEmitter.emit(); // Clean-up subscription before un-mounting

              this.subscription.unsubscribe();
            };

            ComponentFromStream.prototype.render = function render() {
              return this.state.vdom;
            };

            return ComponentFromStream;
          }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        };
      };

      var componentFromStream = function componentFromStream(propsToVdom) {
        return componentFromStreamWithConfig(config)(propsToVdom);
      };

      var identity$1 = function identity(t) {
        return t;
      };

      var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
        var componentFromStream = componentFromStreamWithConfig({
          fromESObservable: identity$1,
          toESObservable: identity$1
        });
        return function (transform) {
          return function (BaseComponent) {
            var factory = createFactory(BaseComponent);
            var fromESObservable = config$$1.fromESObservable,
                toESObservable = config$$1.toESObservable;
            return componentFromStream(function (props$) {
              var _ref;

              return _ref = {
                subscribe: function subscribe(observer) {
                  var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
                    next: function next(childProps) {
                      return observer.next(factory(childProps));
                    }
                  });
                  return {
                    unsubscribe: function unsubscribe() {
                      return subscription.unsubscribe();
                    }
                  };
                }
              }, _ref[symbol_observable__WEBPACK_IMPORTED_MODULE_4__["default"]] = function () {
                return this;
              }, _ref;
            });
          };
        };
      };

      var mapPropsStream = function mapPropsStream(transform) {
        var hoc = mapPropsStreamWithConfig(config)(transform);

        if (false) {}

        return hoc;
      };

      var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
        return function () {
          var _config$fromESObserva;

          var emitter = Object(change_emitter__WEBPACK_IMPORTED_MODULE_3__["createChangeEmitter"])();
          var stream = config$$1.fromESObservable((_config$fromESObserva = {
            subscribe: function subscribe(observer) {
              var unsubscribe = emitter.listen(function (value) {
                return observer.next(value);
              });
              return {
                unsubscribe: unsubscribe
              };
            }
          }, _config$fromESObserva[symbol_observable__WEBPACK_IMPORTED_MODULE_4__["default"]] = function () {
            return this;
          }, _config$fromESObserva));
          return {
            handler: emitter.emit,
            stream: stream
          };
        };
      };

      var createEventHandler = createEventHandlerWithConfig(config); // Higher-order component helpers

      /***/
    },
    /* 27 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Validator", function () {
        return Validator;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Events", function () {
        return Events;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "DefaultRequiredMessage", function () {
        return DefaultRequiredMessage;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "DefaultTooSmallMessage", function () {
        return DefaultTooSmallMessage;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Analytics", function () {
        return Analytics;
      });

      var Validator = {
        Custom: 'Custom',
        Empty: 'Empty'
      };
      var Events = {
        AnalyticsCallback: 'AnalyticsCallback',
        BeforeFormRender: 'BeforeFormRender',
        BeforePageRender: 'BeforePageRender',
        ButtonClicked: 'ButtonClicked',
        FieldError: 'FieldError',
        FieldValidated: 'FieldValidated',
        FormRender: 'FormRender',
        NextPage: 'NextPage',
        PageRender: 'PageRender',
        PrevPage: 'PrevPage',
        SessionComplete: 'SessionComplete',
        SessionStarted: 'SessionStarted',
        ValueChanged: 'ValueChanged'
      };
      var DefaultRequiredMessage = 'This field is required';
      var DefaultTooSmallMessage = 'Password must be at least {0} characters';
      var Analytics = {
        FieldComplete: 'FieldComplete',
        FieldInteraction: 'FieldInteraction'
      };
      /***/
    },
    /* 28 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      var configFromProps = {};

      var setConfigFromProps = function setConfigFromProps(_ref) {
        var apiServer = _ref.apiServer,
            appendFormIdToSubmissionIdKey = _ref.appendFormIdToSubmissionIdKey,
            fieldUpdateTimeout = _ref.fieldUpdateTimeout,
            initialValues = _ref.initialValues,
            server = _ref.server,
            submissionIdKey = _ref.submissionIdKey,
            subscriptionServer = _ref.subscriptionServer,
            subscriptionTimeout = _ref.subscriptionTimeout;
        configFromProps = {
          apiServer: apiServer,
          appendFormIdToSubmissionIdKey: appendFormIdToSubmissionIdKey,
          fieldUpdateTimeout: fieldUpdateTimeout,
          initialValues: initialValues,
          server: server,
          submissionIdKey: submissionIdKey,
          subscriptionServer: subscriptionServer,
          subscriptionTimeout: subscriptionTimeout
        };
      };
      /**
       * Server to send GraphQL requests
       * @returns {Object}
       */


      var graphQLServer = function graphQLServer() {
        switch ("production") {
          case 'development':
            return {
              host: 'localhost:8888',
              protocol: 'http'
            };

          default:
            return {
              host: 'staging.api.formatic.com.au',
              protocol: 'https'
            };
        }
      };
      /**
       * Server to use for subscription requests
       * @returns {Object}
       */


      var subscriptionServer = function subscriptionServer() {
        switch ("production") {
          case 'development':
            return {
              host: 'localhost:8888',
              protocol: 'http',
              webSocket: 'ws'
            };

          default:
            return {
              host: 'staging.ws.formatic.com.au',
              protocol: 'https',
              webSocket: 'wss'
            };
        }
      };
      /**
       * Server to send API v1 requests
       * @returns {string}
       */


      var apiServer = function apiServer() {
        switch ("production") {
          case 'development':
            return 'http://localhost:6081';

          default:
            return 'https://staging.api.formatic.com.au';
        }
      };

      var server = graphQLServer();
      var subServer = subscriptionServer();

      var getServer = function getServer() {
        if (configFromProps.server === undefined) {
          return "".concat(server.protocol, "://").concat(server.host, "/graphql");
        }

        return configFromProps.server;
      };

      var getApiServer = function getApiServer() {
        if (configFromProps.apiServer === undefined) {
          return apiServer();
        }

        return configFromProps.apiServer;
      };

      var getSubscriptionServer = function getSubscriptionServer() {
        if (configFromProps.subscriptionServer === undefined) {
          return "".concat(subServer.webSocket, "://").concat(subServer.host, "/subscriptions");
        }

        return configFromProps.subscriptionServer;
      };

      var getFieldUpdateTimeout = function getFieldUpdateTimeout() {
        if (configFromProps.fieldUpdateTimeout === undefined) {
          return 300;
        }

        return configFromProps.fieldUpdateTimeout;
      };

      var getFieldInteractionDebounce = function getFieldInteractionDebounce() {
        if (configFromProps.fieldInteractionDebounce === undefined) {
          return 500;
        }

        return configFromProps.fieldInteractionDebounce;
      };

      var getSubscriptionTimeout = function getSubscriptionTimeout() {
        if (configFromProps.subscriptionTimeout === undefined) {
          return 20000;
        }

        return configFromProps.subscriptionTimeout;
      };

      var getSubmissionIdKey = function getSubmissionIdKey() {
        if (configFromProps.submissionIdKey === undefined) {
          return 'formatic';
        }

        return configFromProps.submissionIdKey;
      };

      var getAppendFormIdToSubmissionIdKey = function getAppendFormIdToSubmissionIdKey() {
        if (configFromProps.appendFormIdToSubmissionIdKey === undefined) {
          return true;
        }

        return configFromProps.appendFormIdToSubmissionIdKey;
      };

      var getInitialValues = function getInitialValues() {
        var values = configFromProps.initialValues || {};
        return Object.keys(values).map(function (id) {
          return {
            id: id,
            value: values[id]
          };
        });
      };

      var getConfig = function getConfig() {
        return configFromProps;
      };
      /* harmony default export */


      __webpack_exports__["a"] = {
        autoCompleteDisabledValue: 'off',
        autoCompleteBrowserValue: 'none',
        defaultLang: 'en',
        defaultMultiPage: false,
        getApiServer: getApiServer,
        getAppendFormIdToSubmissionIdKey: getAppendFormIdToSubmissionIdKey,
        getFieldUpdateTimeout: getFieldUpdateTimeout,
        getFieldInteractionDebounce: getFieldInteractionDebounce,
        getInitialValues: getInitialValues,
        getServer: getServer,
        setConfigFromProps: setConfigFromProps,
        getSubmissionIdKey: getSubmissionIdKey,
        getSubscriptionServer: getSubscriptionServer,
        getSubscriptionTimeout: getSubscriptionTimeout,
        getConfig: getConfig
      };
      /***/
    },
    /* 29 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "b", function () {
        return ADD_VALIDATOR;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "g", function () {
        return REMOVE_VALIDATOR;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "i", function () {
        return SET_API_KEY;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "k", function () {
        return SET_CURRENT_PAGE;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "z", function () {
        return SET_SUBMISSION_ID;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "C", function () {
        return SET_VISIBLE_FIELDS;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "q", function () {
        return SET_FIELD_ERRORS;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "w", function () {
        return SET_ORDERED_FIELDS;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "h", function () {
        return REMOVE_VISIBLE_FIELDS;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "l", function () {
        return SET_CUSTOM_SUBITEM;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "B", function () {
        return SET_TOKENS;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "A", function () {
        return SET_TOKEN;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "x", function () {
        return SET_PAGE_FLOW;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "s", function () {
        return SET_FORM_ID;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "t", function () {
        return SET_FORM_LOADING;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "E", function () {
        return STORE_FIELDS_IMPACTING_PAGE_FLOW;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "D", function () {
        return STORE_DATA_FORM;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return REGISTER_NAVIGATE;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return REGISTER_SUBMIT_FORM;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "m", function () {
        return SET_DATA_FORM_BY_ID;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "n", function () {
        return SET_DATA_MACHINE_TAGS_TO_FIELD_IDS;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "p", function () {
        return SET_DATA_SUBMISSION_BY_ID;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "f", function () {
        return REMOVE_DATA_SUBMISSION_BY_ID;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "o", function () {
        return SET_DATA_SUBMISSION;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "v", function () {
        return SET_INTERACTIONS;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "j", function () {
        return SET_CURRENT_FLOW;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "r", function () {
        return SET_FORM_FLOWS;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "y", function () {
        return SET_SUBMISSION_COMPLETION;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return ADD_BODY_CLASS;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return REMOVE_BODY_CLASS;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "u", function () {
        return SET_INITIAL_VALUES;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Z", function () {
        return setSubmissionCompletion;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "F", function () {
        return addBodyClass;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "J", function () {
        return removeBodyClass;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "W", function () {
        return setInitialValues;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "K", function () {
        return removeDataSubmissionById;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "H", function () {
        return registerNavigate;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "I", function () {
        return registerSubmitForm;
      });
      /* unused harmony export setApiKey */

      /* unused harmony export setFormId */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "V", function () {
        return setFormLoading;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Ea", function () {
        return storeFieldsImpactingPageFlow;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Da", function () {
        return storeDataForm;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "G", function () {
        return addValidator;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "L", function () {
        return removeValidator;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "O", function () {
        return setCurrentPage;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "N", function () {
        return setCurrentFlow;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "U", function () {
        return setFormFlows;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Ca", function () {
        return setVisibleFields;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "M", function () {
        return removeVisibleFields;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "T", function () {
        return setFieldErrors;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "X", function () {
        return setOrderedFields;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Ba", function () {
        return setTokens;
      });
      /* unused harmony export setToken */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Aa", function () {
        return setSubmissionId;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Y", function () {
        return setPageFlow;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "P", function () {
        return setDataFormById;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "Q", function () {
        return setDataMachineTagsToFieldIds;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "R", function () {
        return setDataSubmission;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "S", function () {
        return setDataSubmissionById;
      });

      var ADD_VALIDATOR = 'ADD_VALIDATOR';
      var REMOVE_VALIDATOR = 'REMOVE_VALIDATOR';
      var SET_API_KEY = 'SET_API_KEY';
      var SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
      var SET_SUBMISSION_ID = 'SET_SUBMISSION_ID';
      var SET_VISIBLE_FIELDS = 'SET_VISIBLE_FIELDS';
      var SET_FIELD_ERRORS = 'SET_FIELD_ERRORS';
      var SET_ORDERED_FIELDS = 'SET_ORDERED_FIELDS';
      var REMOVE_VISIBLE_FIELDS = 'REMOVE_VISIBLE_FIELDS';
      var SET_CUSTOM_SUBITEM = 'SET_CUSTOM_SUBITEM';
      var SET_TOKENS = 'SET_TOKENS';
      var SET_TOKEN = 'SET_TOKEN';
      var SET_PAGE_FLOW = 'SET_PAGE_FLOW';
      var SET_FORM_ID = 'SET_FORM_ID';
      var SET_FORM_LOADING = 'SET_FORM_LOADING';
      var STORE_FIELDS_IMPACTING_PAGE_FLOW = 'STORE_FIELDS_IMPACTING_PAGE_FLOW';
      var STORE_DATA_FORM = 'STORE_DATA_FORM';
      var REGISTER_NAVIGATE = 'REGISTER_NAVIGATE';
      var REGISTER_SUBMIT_FORM = 'REGISTER_SUBMIT_FORM';
      var SET_DATA_FORM_BY_ID = 'SET_DATA_FORM_BY_ID';
      var SET_DATA_MACHINE_TAGS_TO_FIELD_IDS = 'SET_DATA_MACHINE_TAGS_TO_FIELD_IDS';
      var SET_DATA_SUBMISSION_BY_ID = 'SET_DATA_SUBMISSION_BY_ID';
      var REMOVE_DATA_SUBMISSION_BY_ID = 'REMOVE_DATA_SUBMISSION_BY_ID';
      var SET_DATA_SUBMISSION = 'SET_DATA_SUBMISSION';
      var SET_INTERACTIONS = 'SET_INTERACTIONS';
      var SET_CURRENT_FLOW = 'SET_CURRENT_FLOW';
      var SET_FORM_FLOWS = 'SET_FORM_FLOWS';
      var SET_SUBMISSION_COMPLETION = 'SET_SUBMISSION_COMPLETION';
      var ADD_BODY_CLASS = 'ADD_BODY_CLASS';
      var REMOVE_BODY_CLASS = 'REMOVE_BODY_CLASS';
      var SET_INITIAL_VALUES = 'SET_INITIAL_VALUES';

      function setSubmissionCompletion(submissionCompleted) {
        return {
          type: SET_SUBMISSION_COMPLETION,
          submissionCompleted: submissionCompleted
        };
      }

      function addBodyClass(className) {
        return {
          type: ADD_BODY_CLASS,
          className: className
        };
      }

      function removeBodyClass(className) {
        return {
          type: REMOVE_BODY_CLASS,
          className: className
        };
      }

      function setInitialValues(initialValues) {
        return {
          type: SET_INITIAL_VALUES,
          initialValues: initialValues
        };
      }

      function removeDataSubmissionById() {
        return {
          type: REMOVE_DATA_SUBMISSION_BY_ID
        };
      }

      function registerNavigate(navigate) {
        return {
          type: REGISTER_NAVIGATE,
          navigate: navigate
        };
      }

      function registerSubmitForm(submitForm) {
        return {
          type: REGISTER_SUBMIT_FORM,
          submitForm: submitForm
        };
      }

      function setApiKey(apiKey) {
        return {
          type: SET_API_KEY,
          apiKey: apiKey
        };
      }

      function setFormId(formId) {
        return {
          type: SET_FORM_ID,
          formId: formId
        };
      }

      function setFormLoading(loading) {
        return {
          type: SET_FORM_LOADING,
          formLoading: loading
        };
      }

      function storeFieldsImpactingPageFlow(fields) {
        return {
          type: STORE_FIELDS_IMPACTING_PAGE_FLOW,
          fields: fields
        };
      }

      function storeDataForm(dataForm) {
        return {
          type: STORE_DATA_FORM,
          dataForm: dataForm
        };
      }

      function addValidator(fieldId, validator, actionType) {
        return {
          type: ADD_VALIDATOR,
          fieldId: fieldId,
          validator: validator,
          actionType: actionType
        };
      }

      function removeValidator(fieldId, actionType) {
        return {
          type: REMOVE_VALIDATOR,
          fieldId: fieldId,
          actionType: actionType
        };
      }

      function setCurrentPage(pageId, channel) {
        var requestTimestamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
        return {
          type: SET_CURRENT_PAGE,
          channel: channel,
          pageId: pageId,
          requestTimestamp: requestTimestamp
        };
      }

      function setCurrentFlow(name) {
        return {
          type: SET_CURRENT_FLOW,
          name: name
        };
      }

      function setFormFlows(flows) {
        return {
          type: SET_FORM_FLOWS,
          flows: flows
        };
      }

      function setVisibleFields(visibleFields) {
        return {
          type: SET_VISIBLE_FIELDS,
          visibleFields: visibleFields
        };
      }

      function removeVisibleFields(visibleFields) {
        return {
          type: REMOVE_VISIBLE_FIELDS,
          visibleFields: visibleFields
        };
      }

      function setFieldErrors(fieldId, errors) {
        return {
          type: SET_FIELD_ERRORS,
          fieldId: fieldId,
          errors: errors
        };
      }

      function setOrderedFields(orderedFields) {
        return {
          type: SET_ORDERED_FIELDS,
          orderedFields: orderedFields
        };
      }

      function setTokens(tokens) {
        return {
          type: SET_TOKENS,
          tokens: tokens
        };
      }

      function setToken(path, value) {
        return {
          type: SET_TOKEN,
          path: path,
          value: value
        };
      }

      function setSubmissionId(submissionId) {
        return {
          type: SET_SUBMISSION_ID,
          submissionId: submissionId
        };
      }

      function setPageFlow(pageFlow) {
        return {
          type: SET_PAGE_FLOW,
          pageFlow: pageFlow
        };
      }

      function setDataFormById(fieldsById, sectionsById, pagesById) {
        return {
          type: SET_DATA_FORM_BY_ID,
          fieldsById: fieldsById,
          sectionsById: sectionsById,
          pagesById: pagesById
        };
      }

      function setDataMachineTagsToFieldIds(machineTagsToFieldIds) {
        return {
          type: SET_DATA_MACHINE_TAGS_TO_FIELD_IDS,
          machineTagsToFieldIds: machineTagsToFieldIds
        };
      }

      function setDataSubmission(submission) {
        return {
          type: SET_DATA_SUBMISSION,
          submission: submission
        };
      }

      function setDataSubmissionById(submissionFieldsById, submissionAttributesById) {
        return {
          type: SET_DATA_SUBMISSION_BY_ID,
          submissionFieldsById: submissionFieldsById,
          submissionAttributesById: submissionAttributesById
        };
      }
      /***/

    },
    /* 30 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIsEqual = __webpack_require__(330);
      /**
       * Performs a deep comparison between two values to determine if they are
       * equivalent.
       *
       * **Note:** This method supports comparing arrays, array buffers, booleans,
       * date objects, error objects, maps, numbers, `Object` objects, regexes,
       * sets, strings, symbols, and typed arrays. `Object` objects are compared
       * by their own, not inherited, enumerable properties. Functions and DOM
       * nodes are compared by strict equality, i.e. `===`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * var object = { 'a': 1 };
       * var other = { 'a': 1 };
       *
       * _.isEqual(object, other);
       * // => true
       *
       * object === other;
       * // => false
       */


      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }

      module.exports = isEqual;
      /***/
    },
    /* 31 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule Draft
       * @format
       * 
       */

      var AtomicBlockUtils = __webpack_require__(1035);

      var BlockMapBuilder = __webpack_require__(206);

      var CharacterMetadata = __webpack_require__(96);

      var CompositeDraftDecorator = __webpack_require__(1019);

      var ContentBlock = __webpack_require__(155);

      var ContentState = __webpack_require__(344);

      var DefaultDraftBlockRenderMap = __webpack_require__(341);

      var DefaultDraftInlineStyle = __webpack_require__(477);

      var DraftEditor = __webpack_require__(1018);

      var DraftEditorBlock = __webpack_require__(475);

      var DraftEntity = __webpack_require__(241);

      var DraftModifier = __webpack_require__(93);

      var DraftEntityInstance = __webpack_require__(479);

      var EditorState = __webpack_require__(60);

      var KeyBindingUtil = __webpack_require__(333);

      var RichTextEditorUtil = __webpack_require__(461);

      var SelectionState = __webpack_require__(174);

      var convertFromDraftStateToRaw = __webpack_require__(957);

      var convertFromHTMLToContentBlocks = __webpack_require__(463);

      var convertFromRawToDraftState = __webpack_require__(954);

      var generateRandomKey = __webpack_require__(127);

      var getDefaultKeyBinding = __webpack_require__(460);

      var getVisibleSelectionRect = __webpack_require__(949);

      var DraftPublic = {
        Editor: DraftEditor,
        EditorBlock: DraftEditorBlock,
        EditorState: EditorState,
        CompositeDecorator: CompositeDraftDecorator,
        Entity: DraftEntity,
        EntityInstance: DraftEntityInstance,
        BlockMapBuilder: BlockMapBuilder,
        CharacterMetadata: CharacterMetadata,
        ContentBlock: ContentBlock,
        ContentState: ContentState,
        SelectionState: SelectionState,
        AtomicBlockUtils: AtomicBlockUtils,
        KeyBindingUtil: KeyBindingUtil,
        Modifier: DraftModifier,
        RichUtils: RichTextEditorUtil,
        DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
        DefaultDraftInlineStyle: DefaultDraftInlineStyle,
        convertFromHTML: convertFromHTMLToContentBlocks,
        convertFromRaw: convertFromRawToDraftState,
        convertToRaw: convertFromDraftStateToRaw,
        genKey: generateRandomKey,
        getDefaultKeyBinding: getDefaultKeyBinding,
        getVisibleSelectionRect: getVisibleSelectionRect
      };
      module.exports = DraftPublic;
      /***/
    },
    /* 32 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      var React = __webpack_require__(1);

      var factory = __webpack_require__(1128);

      if (typeof React === 'undefined') {
        throw Error('create-react-class could not find the React object. If you are using script tags, ' + 'make sure that React is being loaded before create-react-class.');
      } // Hack to grab NoopUpdateQueue from isomorphic React


      var ReactNoopUpdateQueue = new React.Component().updater;
      module.exports = factory(React.Component, React.isValidElement, ReactNoopUpdateQueue);
      /***/
    },
    /* 33 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

      function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
      } // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // CONCATENATED MODULE: ./node_modules/react-redux/es/utils/PropTypes.js


      var PropTypes_subscriptionShape = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
        trySubscribe: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        tryUnsubscribe: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        notifyNestedSubs: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        isSubscribed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired
      });
      var PropTypes_storeShape = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
        subscribe: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        dispatch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        getState: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired
      }); // CONCATENATED MODULE: ./node_modules/react-redux/es/utils/warning.js

      /**
       * Prints a warning in the console if it exists.
       *
       * @param {String} message The warning message.
       * @returns {void}
       */

      function warning(message) {
        /* eslint-disable no-console */
        if (typeof console !== 'undefined' && typeof console.error === 'function') {
          console.error(message);
        }
        /* eslint-enable no-console */


        try {
          // This error was thrown as a convenience so that if you enable
          // "break on all exceptions" in your console,
          // it would pause the execution at this line.
          throw new Error(message);
          /* eslint-disable no-empty */
        } catch (e) {}
        /* eslint-enable no-empty */

      } // CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js


      var Provider_didWarnAboutReceivingStore = false;

      function Provider_warnAboutReceivingStore() {
        if (Provider_didWarnAboutReceivingStore) {
          return;
        }

        Provider_didWarnAboutReceivingStore = true;
        warning('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
      }

      function Provider_createProvider(storeKey) {
        var _Provider$childContex;

        if (storeKey === void 0) {
          storeKey = 'store';
        }

        var subscriptionKey = storeKey + "Subscription";

        var Provider =
        /*#__PURE__*/
        function (_Component) {
          _inheritsLoose(Provider, _Component);

          var _proto = Provider.prototype;

          _proto.getChildContext = function getChildContext() {
            var _ref;

            return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
          };

          function Provider(props, context) {
            var _this;

            _this = _Component.call(this, props, context) || this;
            _this[storeKey] = props.store;
            return _this;
          }

          _proto.render = function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].only(this.props.children);
          };

          return Provider;
        }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

        if (false) {}

        Provider.propTypes = {
          store: PropTypes_storeShape.isRequired,
          children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.element.isRequired
        };
        Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = PropTypes_storeShape.isRequired, _Provider$childContex[subscriptionKey] = PropTypes_subscriptionShape, _Provider$childContex);
        return Provider;
      }
      /* harmony default export */


      var components_Provider = Provider_createProvider(); // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js

      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return self;
      } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js


      function _extends() {
        _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        return _extends.apply(this, arguments);
      } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js


      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;

        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }

        return target;
      } // EXTERNAL MODULE: ./node_modules/react-redux/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js


      var hoist_non_react_statics_cjs = __webpack_require__(694);

      var hoist_non_react_statics_cjs_default =
      /*#__PURE__*/
      __webpack_require__.n(hoist_non_react_statics_cjs); // EXTERNAL MODULE: ./node_modules/invariant/browser.js


      var browser = __webpack_require__(141);

      var browser_default =
      /*#__PURE__*/
      __webpack_require__.n(browser); // EXTERNAL MODULE: ./node_modules/react-is/index.js


      var react_is = __webpack_require__(261); // CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
      // encapsulates the subscription logic for connecting a component to the redux store, as
      // well as nesting subscriptions of descendant components, so that we can ensure the
      // ancestor components re-render before descendants


      var CLEARED = null;
      var nullListeners = {
        notify: function notify() {}
      };

      function createListenerCollection() {
        // the current/next pattern is copied from redux's createStore code.
        // TODO: refactor+expose that code to be reusable here?
        var current = [];
        var next = [];
        return {
          clear: function clear() {
            next = CLEARED;
            current = CLEARED;
          },
          notify: function notify() {
            var listeners = current = next;

            for (var i = 0; i < listeners.length; i++) {
              listeners[i]();
            }
          },
          get: function get() {
            return next;
          },
          subscribe: function subscribe(listener) {
            var isSubscribed = true;
            if (next === current) next = current.slice();
            next.push(listener);
            return function unsubscribe() {
              if (!isSubscribed || current === CLEARED) return;
              isSubscribed = false;
              if (next === current) next = current.slice();
              next.splice(next.indexOf(listener), 1);
            };
          }
        };
      }

      var Subscription =
      /*#__PURE__*/
      function () {
        function Subscription(store, parentSub, onStateChange) {
          this.store = store;
          this.parentSub = parentSub;
          this.onStateChange = onStateChange;
          this.unsubscribe = null;
          this.listeners = nullListeners;
        }

        var _proto = Subscription.prototype;

        _proto.addNestedSub = function addNestedSub(listener) {
          this.trySubscribe();
          return this.listeners.subscribe(listener);
        };

        _proto.notifyNestedSubs = function notifyNestedSubs() {
          this.listeners.notify();
        };

        _proto.isSubscribed = function isSubscribed() {
          return Boolean(this.unsubscribe);
        };

        _proto.trySubscribe = function trySubscribe() {
          if (!this.unsubscribe) {
            this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
            this.listeners = createListenerCollection();
          }
        };

        _proto.tryUnsubscribe = function tryUnsubscribe() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
            this.listeners.clear();
            this.listeners = nullListeners;
          }
        };

        return Subscription;
      }(); // CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js


      var connectAdvanced_hotReloadingVersion = 0;
      var connectAdvanced_dummyState = {};

      function connectAdvanced_noop() {}

      function connectAdvanced_makeSelectorStateful(sourceSelector, store) {
        // wrap the selector in an object that tracks its results between runs.
        var selector = {
          run: function runComponentSelector(props) {
            try {
              var nextProps = sourceSelector(store.getState(), props);

              if (nextProps !== selector.props || selector.error) {
                selector.shouldComponentUpdate = true;
                selector.props = nextProps;
                selector.error = null;
              }
            } catch (error) {
              selector.shouldComponentUpdate = true;
              selector.error = error;
            }
          }
        };
        return selector;
      }

      function connectAdvanced_connectAdvanced(
      /*
        selectorFactory is a func that is responsible for returning the selector function used to
        compute new props from state, props, and dispatch. For example:
           export default connectAdvanced((dispatch, options) => (state, props) => ({
            thing: state.things[props.thingId],
            saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
          }))(YourComponent)
         Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
        outside of their selector as an optimization. Options passed to connectAdvanced are passed to
        the selectorFactory, along with displayName and WrappedComponent, as the second argument.
         Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
        props. Do not use connectAdvanced directly without memoizing results between calls to your
        selector, otherwise the Connect component will re-render on every state or props change.
      */
      selectorFactory, // options object:
      _ref) {
        var _contextTypes, _childContextTypes;

        if (_ref === void 0) {
          _ref = {};
        }

        var _ref2 = _ref,
            _ref2$getDisplayName = _ref2.getDisplayName,
            getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
          return "ConnectAdvanced(" + name + ")";
        } : _ref2$getDisplayName,
            _ref2$methodName = _ref2.methodName,
            methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
            _ref2$renderCountProp = _ref2.renderCountProp,
            renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
            _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
            shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
            _ref2$storeKey = _ref2.storeKey,
            storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
            _ref2$withRef = _ref2.withRef,
            withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
            connectOptions = _objectWithoutPropertiesLoose(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

        var subscriptionKey = storeKey + 'Subscription';
        var version = connectAdvanced_hotReloadingVersion++;
        var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = PropTypes_storeShape, _contextTypes[subscriptionKey] = PropTypes_subscriptionShape, _contextTypes);
        var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = PropTypes_subscriptionShape, _childContextTypes);
        return function wrapWithConnect(WrappedComponent) {
          browser_default()(Object(react_is["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
          var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
          var displayName = getDisplayName(wrappedComponentName);

          var selectorFactoryOptions = _extends({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            withRef: withRef,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

            /* eslint-disable react/no-deprecated */

          });

          var Connect =
          /*#__PURE__*/
          function (_Component) {
            _inheritsLoose(Connect, _Component);

            function Connect(props, context) {
              var _this;

              _this = _Component.call(this, props, context) || this;
              _this.version = version;
              _this.state = {};
              _this.renderCount = 0;
              _this.store = props[storeKey] || context[storeKey];
              _this.propsMode = Boolean(props[storeKey]);
              _this.setWrappedInstance = _this.setWrappedInstance.bind(_assertThisInitialized(_assertThisInitialized(_this)));
              browser_default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

              _this.initSelector();

              _this.initSubscription();

              return _this;
            }

            var _proto = Connect.prototype;

            _proto.getChildContext = function getChildContext() {
              var _ref3; // If this component received store from props, its subscription should be transparent
              // to any descendants receiving store+subscription from context; it passes along
              // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
              // Connect to control ordering of notifications to flow top-down.


              var subscription = this.propsMode ? null : this.subscription;
              return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
            };

            _proto.componentDidMount = function componentDidMount() {
              if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
              // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
              // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
              // To handle the case where a child component may have triggered a state change by
              // dispatching an action in its componentWillMount, we have to re-run the select and maybe
              // re-render.

              this.subscription.trySubscribe();
              this.selector.run(this.props);
              if (this.selector.shouldComponentUpdate) this.forceUpdate();
            };

            _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
              this.selector.run(nextProps);
            };

            _proto.shouldComponentUpdate = function shouldComponentUpdate() {
              return this.selector.shouldComponentUpdate;
            };

            _proto.componentWillUnmount = function componentWillUnmount() {
              if (this.subscription) this.subscription.tryUnsubscribe();
              this.subscription = null;
              this.notifyNestedSubs = connectAdvanced_noop;
              this.store = null;
              this.selector.run = connectAdvanced_noop;
              this.selector.shouldComponentUpdate = false;
            };

            _proto.getWrappedInstance = function getWrappedInstance() {
              browser_default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
              return this.wrappedInstance;
            };

            _proto.setWrappedInstance = function setWrappedInstance(ref) {
              this.wrappedInstance = ref;
            };

            _proto.initSelector = function initSelector() {
              var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
              this.selector = connectAdvanced_makeSelectorStateful(sourceSelector, this.store);
              this.selector.run(this.props);
            };

            _proto.initSubscription = function initSubscription() {
              if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
              // connected to the store via props shouldn't use subscription from context, or vice versa.

              var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
              this.subscription = new Subscription(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
              // the middle of the notification loop, where `this.subscription` will then be null. An
              // extra null check every change can be avoided by copying the method onto `this` and then
              // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
              // listeners logic is changed to not call listeners that have been unsubscribed in the
              // middle of the notification loop.

              this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
            };

            _proto.onStateChange = function onStateChange() {
              this.selector.run(this.props);

              if (!this.selector.shouldComponentUpdate) {
                this.notifyNestedSubs();
              } else {
                this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
                this.setState(connectAdvanced_dummyState);
              }
            };

            _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
              // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
              // needs to notify nested subs. Once called, it unimplements itself until further state
              // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
              // a boolean check every time avoids an extra method call most of the time, resulting
              // in some perf boost.
              this.componentDidUpdate = undefined;
              this.notifyNestedSubs();
            };

            _proto.isSubscribed = function isSubscribed() {
              return Boolean(this.subscription) && this.subscription.isSubscribed();
            };

            _proto.addExtraProps = function addExtraProps(props) {
              if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
              // this is especially important for 'ref' since that's a reference back to the component
              // instance. a singleton memoized selector would then be holding a reference to the
              // instance, preventing the instance from being garbage collected, and that would be bad

              var withExtras = _extends({}, props);

              if (withRef) withExtras.ref = this.setWrappedInstance;
              if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
              if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
              return withExtras;
            };

            _proto.render = function render() {
              var selector = this.selector;
              selector.shouldComponentUpdate = false;

              if (selector.error) {
                throw selector.error;
              } else {
                return Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
              }
            };

            return Connect;
          }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
          /* eslint-enable react/no-deprecated */


          Connect.WrappedComponent = WrappedComponent;
          Connect.displayName = displayName;
          Connect.childContextTypes = childContextTypes;
          Connect.contextTypes = contextTypes;
          Connect.propTypes = contextTypes;

          if (false) {}

          return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
        };
      } // CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js


      var hasOwn = Object.prototype.hasOwnProperty;

      function is(x, y) {
        if (x === y) {
          return x !== 0 || y !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }

      function shallowEqual(objA, objB) {
        if (is(objA, objB)) return true;

        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
          return false;
        }

        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;

        for (var i = 0; i < keysA.length; i++) {
          if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
          }
        }

        return true;
      } // EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules


      var es = __webpack_require__(94); // CONCATENATED MODULE: ./node_modules/react-redux/es/utils/isPlainObject.js

      /**
       * @param {any} obj The object to inspect.
       * @returns {boolean} True if the argument appears to be a plain object.
       */


      function isPlainObject(obj) {
        if (typeof obj !== 'object' || obj === null) return false;
        var proto = Object.getPrototypeOf(obj);
        if (proto === null) return true;
        var baseProto = proto;

        while (Object.getPrototypeOf(baseProto) !== null) {
          baseProto = Object.getPrototypeOf(baseProto);
        }

        return proto === baseProto;
      } // CONCATENATED MODULE: ./node_modules/react-redux/es/utils/verifyPlainObject.js


      function verifyPlainObject_verifyPlainObject(value, displayName, methodName) {
        if (!isPlainObject(value)) {
          warning(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
        }
      } // CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js


      function wrapMapToPropsConstant(getConstant) {
        return function initConstantSelector(dispatch, options) {
          var constant = getConstant(dispatch, options);

          function constantSelector() {
            return constant;
          }

          constantSelector.dependsOnOwnProps = false;
          return constantSelector;
        };
      } // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
      // to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
      // whether mapToProps needs to be invoked when props have changed.
      // 
      // A length of one signals that mapToProps does not depend on props from the parent component.
      // A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
      // therefore not reporting its length accurately..


      function getDependsOnOwnProps(mapToProps) {
        return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
      } // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
      // this function wraps mapToProps in a proxy function which does several things:
      // 
      //  * Detects whether the mapToProps function being called depends on props, which
      //    is used by selectorFactory to decide if it should reinvoke on props changes.
      //    
      //  * On first call, handles mapToProps if returns another function, and treats that
      //    new function as the true mapToProps for subsequent calls.
      //    
      //  * On first call, verifies the first result is a plain object, in order to warn
      //    the developer that their mapToProps function is not returning a valid result.
      //    


      function wrapMapToPropsFunc(mapToProps, methodName) {
        return function initProxySelector(dispatch, _ref) {
          var displayName = _ref.displayName;

          var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
          }; // allow detectFactoryAndVerify to get ownProps


          proxy.dependsOnOwnProps = true;

          proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);

            if (typeof props === 'function') {
              proxy.mapToProps = props;
              proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
              props = proxy(stateOrDispatch, ownProps);
            }

            if (false) {}

            return props;
          };

          return proxy;
        };
      } // CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


      function mapDispatchToProps_whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
        return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
      }

      function mapDispatchToProps_whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
        return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
          return {
            dispatch: dispatch
          };
        }) : undefined;
      }

      function mapDispatchToProps_whenMapDispatchToPropsIsObject(mapDispatchToProps) {
        return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
          return Object(es["bindActionCreators"])(mapDispatchToProps, dispatch);
        }) : undefined;
      }
      /* harmony default export */


      var connect_mapDispatchToProps = [mapDispatchToProps_whenMapDispatchToPropsIsFunction, mapDispatchToProps_whenMapDispatchToPropsIsMissing, mapDispatchToProps_whenMapDispatchToPropsIsObject]; // CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

      function mapStateToProps_whenMapStateToPropsIsFunction(mapStateToProps) {
        return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
      }

      function mapStateToProps_whenMapStateToPropsIsMissing(mapStateToProps) {
        return !mapStateToProps ? wrapMapToPropsConstant(function () {
          return {};
        }) : undefined;
      }
      /* harmony default export */


      var connect_mapStateToProps = [mapStateToProps_whenMapStateToPropsIsFunction, mapStateToProps_whenMapStateToPropsIsMissing]; // CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js

      function mergeProps_defaultMergeProps(stateProps, dispatchProps, ownProps) {
        return _extends({}, ownProps, stateProps, dispatchProps);
      }

      function mergeProps_wrapMergePropsFunc(mergeProps) {
        return function initMergePropsProxy(dispatch, _ref) {
          var displayName = _ref.displayName,
              pure = _ref.pure,
              areMergedPropsEqual = _ref.areMergedPropsEqual;
          var hasRunOnce = false;
          var mergedProps;
          return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

            if (hasRunOnce) {
              if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
              hasRunOnce = true;
              mergedProps = nextMergedProps;

              if (false) {}
            }

            return mergedProps;
          };
        };
      }

      function mergeProps_whenMergePropsIsFunction(mergeProps) {
        return typeof mergeProps === 'function' ? mergeProps_wrapMergePropsFunc(mergeProps) : undefined;
      }

      function mergeProps_whenMergePropsIsOmitted(mergeProps) {
        return !mergeProps ? function () {
          return mergeProps_defaultMergeProps;
        } : undefined;
      }
      /* harmony default export */


      var connect_mergeProps = [mergeProps_whenMergePropsIsFunction, mergeProps_whenMergePropsIsOmitted]; // CONCATENATED MODULE: ./node_modules/react-redux/es/connect/verifySubselectors.js

      function verifySubselectors_verify(selector, methodName, displayName) {
        if (!selector) {
          throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
        } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
          if (!selector.hasOwnProperty('dependsOnOwnProps')) {
            warning("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
          }
        }
      }

      function verifySubselectors_verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
        verifySubselectors_verify(mapStateToProps, 'mapStateToProps', displayName);
        verifySubselectors_verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
        verifySubselectors_verify(mergeProps, 'mergeProps', displayName);
      } // CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js


      function selectorFactory_impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
        return function impureFinalPropsSelector(state, ownProps) {
          return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
        };
      }

      function selectorFactory_pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
        var areStatesEqual = _ref.areStatesEqual,
            areOwnPropsEqual = _ref.areOwnPropsEqual,
            areStatePropsEqual = _ref.areStatePropsEqual;
        var hasRunAtLeastOnce = false;
        var state;
        var ownProps;
        var stateProps;
        var dispatchProps;
        var mergedProps;

        function handleFirstCall(firstState, firstOwnProps) {
          state = firstState;
          ownProps = firstOwnProps;
          stateProps = mapStateToProps(state, ownProps);
          dispatchProps = mapDispatchToProps(dispatch, ownProps);
          mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
          hasRunAtLeastOnce = true;
          return mergedProps;
        }

        function handleNewPropsAndNewState() {
          stateProps = mapStateToProps(state, ownProps);
          if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
          mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
          return mergedProps;
        }

        function handleNewProps() {
          if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
          if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
          mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
          return mergedProps;
        }

        function handleNewState() {
          var nextStateProps = mapStateToProps(state, ownProps);
          var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
          stateProps = nextStateProps;
          if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
          return mergedProps;
        }

        function handleSubsequentCalls(nextState, nextOwnProps) {
          var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
          var stateChanged = !areStatesEqual(nextState, state);
          state = nextState;
          ownProps = nextOwnProps;
          if (propsChanged && stateChanged) return handleNewPropsAndNewState();
          if (propsChanged) return handleNewProps();
          if (stateChanged) return handleNewState();
          return mergedProps;
        }

        return function pureFinalPropsSelector(nextState, nextOwnProps) {
          return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
        };
      } // TODO: Add more comments
      // If pure is true, the selector returned by selectorFactory will memoize its results,
      // allowing connectAdvanced's shouldComponentUpdate to return false if final
      // props have not changed. If false, the selector will always return a new
      // object and shouldComponentUpdate will always return true.


      function selectorFactory_finalPropsSelectorFactory(dispatch, _ref2) {
        var initMapStateToProps = _ref2.initMapStateToProps,
            initMapDispatchToProps = _ref2.initMapDispatchToProps,
            initMergeProps = _ref2.initMergeProps,
            options = _objectWithoutPropertiesLoose(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

        var mapStateToProps = initMapStateToProps(dispatch, options);
        var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
        var mergeProps = initMergeProps(dispatch, options);

        if (false) {}

        var selectorFactory = options.pure ? selectorFactory_pureFinalPropsSelectorFactory : selectorFactory_impureFinalPropsSelectorFactory;
        return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
      } // CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js

      /*
        connect is a facade over connectAdvanced. It turns its args into a compatible
        selectorFactory, which has the signature:
      
          (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
        
        connect passes its args to connectAdvanced as options, which will in turn pass them to
        selectorFactory each time a Connect component instance is instantiated or hot reloaded.
      
        selectorFactory returns a final props selector from its mapStateToProps,
        mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
        mergePropsFactories, and pure args.
      
        The resulting final props selector is called by the Connect component instance whenever
        it receives new props or store state.
       */


      function connect_match(arg, factories, name) {
        for (var i = factories.length - 1; i >= 0; i--) {
          var result = factories[i](arg);
          if (result) return result;
        }

        return function (dispatch, options) {
          throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
        };
      }

      function connect_strictEqual(a, b) {
        return a === b;
      } // createConnect with default args builds the 'official' connect behavior. Calling it with
      // different options opens up some testing and extensibility scenarios


      function connect_createConnect(_temp) {
        var _ref = _temp === void 0 ? {} : _temp,
            _ref$connectHOC = _ref.connectHOC,
            connectHOC = _ref$connectHOC === void 0 ? connectAdvanced_connectAdvanced : _ref$connectHOC,
            _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
            mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? connect_mapStateToProps : _ref$mapStateToPropsF,
            _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
            mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? connect_mapDispatchToProps : _ref$mapDispatchToPro,
            _ref$mergePropsFactor = _ref.mergePropsFactories,
            mergePropsFactories = _ref$mergePropsFactor === void 0 ? connect_mergeProps : _ref$mergePropsFactor,
            _ref$selectorFactory = _ref.selectorFactory,
            selectorFactory = _ref$selectorFactory === void 0 ? selectorFactory_finalPropsSelectorFactory : _ref$selectorFactory;

        return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
          if (_ref2 === void 0) {
            _ref2 = {};
          }

          var _ref3 = _ref2,
              _ref3$pure = _ref3.pure,
              pure = _ref3$pure === void 0 ? true : _ref3$pure,
              _ref3$areStatesEqual = _ref3.areStatesEqual,
              areStatesEqual = _ref3$areStatesEqual === void 0 ? connect_strictEqual : _ref3$areStatesEqual,
              _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
              areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
              _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
              areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
              _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
              areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
              extraOptions = _objectWithoutPropertiesLoose(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

          var initMapStateToProps = connect_match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
          var initMapDispatchToProps = connect_match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
          var initMergeProps = connect_match(mergeProps, mergePropsFactories, 'mergeProps');
          return connectHOC(selectorFactory, _extends({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
              return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
          }, extraOptions));
        };
      }
      /* harmony default export */


      var connect_connect = connect_createConnect(); // CONCATENATED MODULE: ./node_modules/react-redux/es/index.js

      /* unused concated harmony import Provider */

      /* concated harmony reexport */

      __webpack_require__.d(__webpack_exports__, false, function () {
        return components_Provider;
      });
      /* unused concated harmony import createProvider */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return Provider_createProvider;
      });
      /* unused concated harmony import connectAdvanced */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return connectAdvanced_connectAdvanced;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return connect_connect;
      });
      /***/

    },
    /* 34 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "b", function () {
        return defaultPropsToVerify;
      });
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_7___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_8___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
      /* harmony import */


      var recompose__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26);
      /* harmony import */


      var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_11___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_11__);
      /* harmony import */


      var lodash_set__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52);
      /* harmony import */


      var lodash_set__WEBPACK_IMPORTED_MODULE_12___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_set__WEBPACK_IMPORTED_MODULE_12__);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(62);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_13___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_13__);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_14___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_14__);
      /* harmony import */


      var _core_utils_tokens_tokens__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61);
      /* harmony import */


      var _core_utils_handlebars__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(166);

      var propsToOmit = ['myTokens']; // withTokens HoC will only replace tokens on the following attributes content

      var defaultPropsToVerify = ['description', 'helpText', 'helpTextTitle', 'label', 'rich', 'onLoadValue'];

      var withFieldToken = function withFieldToken() {
        var attributesToVerify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultPropsToVerify;
        return function (WrappedComponent) {
          var WithFieldTokenComponent =
          /*#__PURE__*/
          function (_Component) {
            _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(WithFieldTokenComponent, _Component);

            function WithFieldTokenComponent(props) {
              var _this;

              _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, WithFieldTokenComponent);

              _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(WithFieldTokenComponent).call(this, props));
              _this.displayName = Object(recompose__WEBPACK_IMPORTED_MODULE_9__[
              /* wrapDisplayName */
              "d"])(WrappedComponent, 'withFieldToken');
              return _this;
            } // Replaces all tokens in all attributes listed at 'attributesToVerify' and returns it


            _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(WithFieldTokenComponent, [{
              key: "replaceAllTokensInAllAttributes",
              value: function replaceAllTokensInAllAttributes() {
                var _this2 = this;

                var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var additionalTokens = {}; // if belongs to a repeatable, make the repeatable data available

                if (attributes.repeatableTag) {
                  additionalTokens.repeatable = lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(this.props.myTokens, "fields.".concat(attributes.repeatableTag), {});
                } // needs to clone it otherwise it'll change the this.props.attributes
                // attributes is a fringe case until flattened


                var attributesCopy = {
                  attributes: lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_14___default()(attributes.attributes || {})
                };
                attributesToVerify.forEach(function (attribute) {
                  // verify if the attribute is a string (if it has match function)
                  var value = lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(attributes, attribute, false);

                  if (value) {
                    var context = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, _this2.props.myTokens, additionalTokens);

                    try {
                      // replace all tokens by its content
                      if (typeof value === 'string') {
                        // simple string replacement
                        lodash_set__WEBPACK_IMPORTED_MODULE_12___default()(attributesCopy, attribute, _core_utils_handlebars__WEBPACK_IMPORTED_MODULE_16__[
                        /* default */
                        "a"].compile(Object(_core_utils_tokens_tokens__WEBPACK_IMPORTED_MODULE_15__[
                        /* replaceValuesAlias */
                        "d"])(value))(context));
                      } else if (Array.isArray(value)) {
                        // try to replace array values (e.g. checkbox list options/radio list options)
                        lodash_set__WEBPACK_IMPORTED_MODULE_12___default()(attributesCopy, attribute, value.map(function (v) {
                          if (typeof v !== 'string') {
                            return v;
                          }

                          return _core_utils_handlebars__WEBPACK_IMPORTED_MODULE_16__[
                          /* default */
                          "a"].compile(Object(_core_utils_tokens_tokens__WEBPACK_IMPORTED_MODULE_15__[
                          /* replaceValuesAlias */
                          "d"])(v))(context);
                        }));
                      }
                    } catch (error) {} // eslint-disable-line

                  }
                });
                return attributesCopy;
              }
            }, {
              key: "render",
              value: function render() {
                var tokenizedAttributes = this.replaceAllTokensInAllAttributes(this.props);
                return react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(WrappedComponent, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, lodash_omit__WEBPACK_IMPORTED_MODULE_13___default()(this.props, propsToOmit), tokenizedAttributes));
              }
            }]);

            return WithFieldTokenComponent;
          }(react__WEBPACK_IMPORTED_MODULE_7__["Component"]);

          WithFieldTokenComponent.defaultProps = {
            myTokens: {}
          };
          WithFieldTokenComponent.propTypes = {
            myTokens: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object
          };
          return Object(recompose__WEBPACK_IMPORTED_MODULE_9__[
          /* compose */
          "a"])(Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[
          /* connect */
          "a"])(function (_ref) {
            var formatic = _ref.formatic;
            return {
              myTokens: formatic.tokens
            };
          }))(WithFieldTokenComponent);
        };
      };
      /* harmony default export */


      __webpack_exports__["a"] = withFieldToken;
      /***/
    },
    /* 35 */

    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(97),
          now = __webpack_require__(1109),
          toNumber = __webpack_require__(513);
      /** Error message constants. */


      var FUNC_ERROR_TEXT = 'Expected a function';
      /* Built-in method references for those with the same name as other `lodash` methods. */

      var nativeMax = Math.max,
          nativeMin = Math.min;
      /**
       * Creates a debounced function that delays invoking `func` until after `wait`
       * milliseconds have elapsed since the last time the debounced function was
       * invoked. The debounced function comes with a `cancel` method to cancel
       * delayed `func` invocations and a `flush` method to immediately invoke them.
       * Provide `options` to indicate whether `func` should be invoked on the
       * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
       * with the last arguments provided to the debounced function. Subsequent
       * calls to the debounced function return the result of the last `func`
       * invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the debounced function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.debounce` and `_.throttle`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to debounce.
       * @param {number} [wait=0] The number of milliseconds to delay.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=false]
       *  Specify invoking on the leading edge of the timeout.
       * @param {number} [options.maxWait]
       *  The maximum time `func` is allowed to be delayed before it's invoked.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new debounced function.
       * @example
       *
       * // Avoid costly calculations while the window size is in flux.
       * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
       *
       * // Invoke `sendMail` when clicked, debouncing subsequent calls.
       * jQuery(element).on('click', _.debounce(sendMail, 300, {
       *   'leading': true,
       *   'trailing': false
       * }));
       *
       * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
       * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
       * var source = new EventSource('/stream');
       * jQuery(source).on('message', debounced);
       *
       * // Cancel the trailing debounced invocation.
       * jQuery(window).on('popstate', debounced.cancel);
       */

      function debounce(func, wait, options) {
        var lastArgs,
            lastThis,
            maxWait,
            result,
            timerId,
            lastCallTime,
            lastInvokeTime = 0,
            leading = false,
            maxing = false,
            trailing = true;

        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        wait = toNumber(wait) || 0;

        if (isObject(options)) {
          leading = !!options.leading;
          maxing = 'maxWait' in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }

        function invokeFunc(time) {
          var args = lastArgs,
              thisArg = lastThis;
          lastArgs = lastThis = undefined;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }

        function leadingEdge(time) {
          // Reset any `maxWait` timer.
          lastInvokeTime = time; // Start the timer for the trailing edge.

          timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

          return leading ? invokeFunc(time) : result;
        }

        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime,
              timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }

        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
          // trailing edge, the system time has gone backwards and we're treating
          // it as the trailing edge, or we've hit the `maxWait` limit.

          return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }

        function timerExpired() {
          var time = now();

          if (shouldInvoke(time)) {
            return trailingEdge(time);
          } // Restart the timer.


          timerId = setTimeout(timerExpired, remainingWait(time));
        }

        function trailingEdge(time) {
          timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
          // debounced at least once.

          if (trailing && lastArgs) {
            return invokeFunc(time);
          }

          lastArgs = lastThis = undefined;
          return result;
        }

        function cancel() {
          if (timerId !== undefined) {
            clearTimeout(timerId);
          }

          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined;
        }

        function flush() {
          return timerId === undefined ? result : trailingEdge(now());
        }

        function debounced() {
          var time = now(),
              isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;

          if (isInvoking) {
            if (timerId === undefined) {
              return leadingEdge(lastCallTime);
            }

            if (maxing) {
              // Handle invocations in a tight loop.
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }

          if (timerId === undefined) {
            timerId = setTimeout(timerExpired, wait);
          }

          return result;
        }

        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }

      module.exports = debounce;
      /***/
    },
    /* 36 */

    /***/
    function (module, exports) {
      function _extends() {
        module.exports = _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        return _extends.apply(this, arguments);
      }

      module.exports = _extends;
      /***/
    },
    /* 37 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/extends.js

      var helpers_extends = __webpack_require__(36);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectSpread.js


      var objectSpread = __webpack_require__(13);

      var objectSpread_default =
      /*#__PURE__*/
      __webpack_require__.n(objectSpread); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(21);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/createClass.js


      var createClass = __webpack_require__(20);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(24);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/getPrototypeOf.js


      var getPrototypeOf = __webpack_require__(23);

      var getPrototypeOf_default =
      /*#__PURE__*/
      __webpack_require__.n(getPrototypeOf); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/assertThisInitialized.js


      var assertThisInitialized = __webpack_require__(11);

      var assertThisInitialized_default =
      /*#__PURE__*/
      __webpack_require__.n(assertThisInitialized); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/inherits.js


      var inherits = __webpack_require__(22);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js


      var defineProperty = __webpack_require__(4);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js


      var Recompose = __webpack_require__(26); // EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules


      var es = __webpack_require__(33); // EXTERNAL MODULE: ./node_modules/lodash/noop.js


      var noop = __webpack_require__(9);

      var noop_default =
      /*#__PURE__*/
      __webpack_require__.n(noop); // EXTERNAL MODULE: ./node_modules/lodash/omit.js


      var omit = __webpack_require__(62);

      var omit_default =
      /*#__PURE__*/
      __webpack_require__.n(omit); // EXTERNAL MODULE: ./node_modules/lodash/get.js


      var get = __webpack_require__(10);

      var get_default =
      /*#__PURE__*/
      __webpack_require__.n(get); // EXTERNAL MODULE: ./node_modules/lodash/debounce.js


      var debounce = __webpack_require__(35);

      var debounce_default =
      /*#__PURE__*/
      __webpack_require__.n(debounce); // EXTERNAL MODULE: ./src/core/utils/analytics.js + 1 modules


      var analytics = __webpack_require__(17); // EXTERNAL MODULE: ./src/config/index.js


      var config = __webpack_require__(28); // EXTERNAL MODULE: ./src/components/Text.js


      var Text = __webpack_require__(167); // EXTERNAL MODULE: ./src/components/Textarea.js


      var Textarea = __webpack_require__(281); // EXTERNAL MODULE: ./src/components/RadioList.js


      var RadioList = __webpack_require__(280); // EXTERNAL MODULE: ./src/components/CheckboxList.js


      var CheckboxList = __webpack_require__(221); // EXTERNAL MODULE: ./src/components/Dropdown.js


      var Dropdown = __webpack_require__(279); // EXTERNAL MODULE: ./src/components/DatePicker.js


      var DatePicker = __webpack_require__(278); // EXTERNAL MODULE: ./src/components/NumericInput.js


      var NumericInput = __webpack_require__(277); // EXTERNAL MODULE: ./src/components/NumericSlider.js


      var NumericSlider = __webpack_require__(276); // EXTERNAL MODULE: ./src/components/Email.js


      var Email = __webpack_require__(275); // EXTERNAL MODULE: ./src/components/FileUpload.js


      var FileUpload = __webpack_require__(274); // EXTERNAL MODULE: ./src/components/NetPromoterScore.js


      var NetPromoterScore = __webpack_require__(273); // EXTERNAL MODULE: ./src/components/ButtonList.js


      var ButtonList = __webpack_require__(272); // EXTERNAL MODULE: ./src/components/AbnAcn.js


      var AbnAcn = __webpack_require__(271); // EXTERNAL MODULE: ./src/components/TrueFalse.js


      var TrueFalse = __webpack_require__(270); // CONCATENATED MODULE: ./src/config/componentDefaultValueMap.js
      // import RepeatableContainer from '../containers/RepeatableContainer';

      /**
       * Mapping between component (using its renderer value as key) and its default value
       * @type {Object}
       */

      /* harmony default export */


      var componentDefaultValueMap = {
        abnAcn: AbnAcn["a"
        /* default */
        ].defaultProps.value,
        // Issue as below with repeatable
        addressLookup: {
          fullAddress: '',
          address: '',
          suburb: '',
          state: '',
          postcode: '',
          country: '',
          isManual: false
        },
        buttonList: ButtonList["a"
        /* default */
        ].defaultProps.value,
        checkboxList: CheckboxList["a"
        /* default */
        ].defaultProps.value,
        datePicker: DatePicker["a"
        /* default */
        ].defaultProps.value,
        dropdown: Dropdown["a"
        /* default */
        ].defaultProps.value,
        email: Email["b"
        /* default */
        ].defaultProps.value,
        fileUpload: FileUpload["a"
        /* default */
        ].defaultProps.value,
        netPromoterScore: NetPromoterScore["a"
        /* default */
        ].defaultProps.virtualValue,
        numericInput: NumericInput["a"
        /* default */
        ].defaultProps.value,
        numericSlider: NumericSlider["a"
        /* default */
        ].defaultProps.value,
        radioList: RadioList["a"
        /* default */
        ].defaultProps.value,

        /*
        TODO: For some unknown reason when we import RepeatableContainer they are undefined.
        The investigation that I did so far revealed that if we remove 'import FieldContainer from './FieldContainer';'
        from those files, then they are correctly imported on this file and then we can access their defaultValues.
        It might be related with storybook build or webpack (that's a guess).
        */
        repeatable: [],
        smsVerification: {
          blockedPhone: false,
          checksum: '',
          code: '',
          phone: '',
          smsSentTo: '',
          status: '',
          verifiedPhone: '',
          version: 4
        },
        emailVerification: {
          blockedEmail: false,
          checksum: '',
          code: '',
          email: '',
          emailSentTo: '',
          status: '',
          verifiedEmail: '',
          version: 4
        },
        text: Text["a"
        /* default */
        ].defaultProps.value,
        textarea: Textarea["a"
        /* default */
        ].defaultProps.value,
        password: Text["a"
        /* default */
        ].defaultProps.value,
        trueFalse: TrueFalse["a"
        /* default */
        ].defaultProps.selected
      }; // EXTERNAL MODULE: ./src/core/utils/constants.js

      var constants = __webpack_require__(27); // EXTERNAL MODULE: ./src/core/utils.js + 1 modules


      var utils = __webpack_require__(18); // EXTERNAL MODULE: ./src/core/utils/populate.js + 1 modules


      var populate = __webpack_require__(184); // CONCATENATED MODULE: ./src/hocs/withFieldSync.js


      var withFieldSync_propsToOmit = ['updateSubmissionField', 'myAttributeById', 'myEmitter', 'myFieldsById', 'mySubmissionFieldsById', 'myTokens'];

      var withFieldSync_withFieldSync = function withFieldSync(WrappedComponent) {
        var WithFieldSync =
        /*#__PURE__*/
        function (_Component) {
          inherits_default()(WithFieldSync, _Component);

          function WithFieldSync(props) {
            var _this;

            classCallCheck_default()(this, WithFieldSync);
            _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(WithFieldSync).call(this, props));
            defineProperty_default()(assertThisInitialized_default()(_this), "changeValue", function (value) {
              var debounceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var analyticsParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                valueLength: 0,
                component: ''
              };
              var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop_default.a;
              var oldValue = _this.state.value;
              var lastUpdated = Date.now();

              _this.setState({
                lastUpdated: lastUpdated,
                value: value
              }, function () {
                if (debounceUpdate) {
                  _this.debouncedUpdateDataSync(lastUpdated);
                } else {
                  _this.updateDataSync(lastUpdated, value);
                }

                if (typeof callback === 'function') {
                  callback();
                }
              });

              if (_this.props.sendAnalytics !== WithFieldSync.defaultProps.sendAnalytics) {
                // Call analytics
                _this.sendAnalytics(value, analyticsParams);
              }

              _this.props.myEmitter.emit(constants["Events"].ValueChanged, {
                fieldID: _this.props.fieldId,
                oldValue: oldValue,
                newValue: value
              });
            });
            defineProperty_default()(assertThisInitialized_default()(_this), "updateDataSync", function (lastUpdated) {
              var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.value;
              var thisFieldChange = [{
                id: _this.props.fieldId,
                value: value
              }]; // populates other fields

              var fields = thisFieldChange.concat(Object(populate["a"
              /* getFieldsToBePopulated */
              ])(_this.props, _this.props.fieldId, value)); // updates the server with the new values

              _this.props.updateSubmissionField({
                fields: fields,
                timestamp: lastUpdated
              }, {
                attributes: Object.values(_this.props.myAttributesById),
                fields: Object.values(_this.props.mySubmissionFieldsById)
              });
            });
            defineProperty_default()(assertThisInitialized_default()(_this), "sendAnalytics", function (value, syncAnalyticsParams) {
              var defaultAnalyticsParam = Object(analytics["d"
              /* getAnalyticsParam */
              ])(value);
              var analyticsParams = objectSpread_default()({}, _this.props.analyticsParams, {
                valueLength: syncAnalyticsParams.valueLength || defaultAnalyticsParam.valueLength,
                component: syncAnalyticsParams.component || defaultAnalyticsParam.component
              }); // send analytics

              _this.props.sendAnalytics(analytics["a"
              /* AnalyticsEvents */
              ].ValueChange, analyticsParams);
            });
            _this.displayName = Object(Recompose["d"
            /* wrapDisplayName */
            ])(WrappedComponent, 'withFieldSync');
            var submissionValue = get_default()(props, "mySubmissionFieldsById[".concat(props.fieldId, "].value"));
            var defaultValue = !Object(utils["o"
            /* isEmpty */
            ])(props.default) ? props.default : componentDefaultValueMap[props.renderer];

            var _value = submissionValue || defaultValue;

            if (props.forceOnLoadValue || !Object(utils["o"
            /* isEmpty */
            ])(props.onLoadValue) && Object(utils["a"
            /* equalOrEmpty */
            ])(submissionValue, defaultValue)) {
              // on load population value
              _value = props.onLoadValue;
            } // set the initial state to the data from submission


            _this.state = {
              lastUpdated: Date.now(),
              value: _value
            };
            _this.debouncedUpdateDataSync = debounce_default()(function (lastUpdated) {
              _this.updateDataSync(lastUpdated);
            }, config["a"
            /* default */
            ].getFieldUpdateTimeout());
            return _this;
          }

          createClass_default()(WithFieldSync, [{
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
              // if the submission data gets updated then update our own internal store
              var requestTimestamp = get_default()(nextProps, "mySubmissionFieldsById[".concat(nextProps.fieldId, "].requestTimestamp"));

              if (requestTimestamp && this.state.lastUpdated < requestTimestamp) {
                var newValue = get_default()(nextProps, "mySubmissionFieldsById[".concat(nextProps.fieldId, "].value"));
                var oldValue = this.state.value;
                this.setState({
                  value: newValue,
                  lastUpdated: requestTimestamp
                });
                this.props.myEmitter.emit(constants["Events"].ValueChanged, {
                  fieldID: this.props.fieldId,
                  oldValue: oldValue,
                  newValue: newValue
                });
              }
            }
            /**
             * It receives the new value for a particular field and then send it to the server.
             * It'll send it straightaway if debounceUpdate is false. Please note that having debounceUpdate is false
             * can lead to the possibility of spamming the server if no additional controls are in place (that's why the defaul must be true).
             *
             * @param  {[type]}  value           The new value to be sent to the server.
             * @param  {Boolean} [debounce=true] Indicates whether or not the request should be debounced. Default is true!
             * @param  {Object} [analyticsParams={ valueLength: 0, component: '' }] Analytics parameter used on sendAnalytics. It is mainly used
             * for complex components since changeValue generates that for all the other components.
             * @param {func} callback function
             */

          }, {
            key: "render",
            value: function render() {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(WrappedComponent, extends_default()({}, omit_default()(this.props, withFieldSync_propsToOmit), {
                value: this.state.value,
                changeValue: this.changeValue
              }));
            }
          }]);
          return WithFieldSync;
        }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

        WithFieldSync.defaultProps = {
          changeValue: noop_default.a,
          data: {},
          dataSubmission: {},
          fieldId: '',
          renderer: '',
          sendAnalytics: noop_default.a,
          updateSubmissionField: noop_default.a,
          analyticsParams: {},
          // Dashboard
          default: '',
          forceOnLoadValue: false,
          onLoadValue: '',
          populate: [],
          tag: '',
          // props from connect formatic store
          myEmitter: noop_default.a,
          myFieldsById: {},
          mySubmissionFieldsById: {},
          myTokens: {}
        };
        WithFieldSync.propTypes = {
          changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          dataSubmission: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          renderer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          updateSubmissionField: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          // Dashboard
          default: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          forceOnLoadValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          onLoadValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          // populate is optional
          populate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
            fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
            // mandatory
            fromSubValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
            // optional
            toSubValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
            // optional
            forcePopulation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
            // optional
            // conditions is optional
            conditions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
              condition: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
              rules: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
                field: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
                id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
                input: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
                operator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
                type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
                value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
              })),
              destinationValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
            })])
          })),
          tag: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          // props from connect formatic store
          myAttributesById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
          myEmitter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          myFieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          mySubmissionFieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          myTokens: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
        };

        var mapStateToProps = function mapStateToProps(_ref) {
          var _ref$formatic = _ref.formatic,
              _ref$formatic$data = _ref$formatic.data,
              myFieldsDefById = _ref$formatic$data.form.fieldsById,
              _ref$formatic$data$su = _ref$formatic$data.submission,
              attributesById = _ref$formatic$data$su.attributesById,
              fieldsById = _ref$formatic$data$su.fieldsById,
              tokens = _ref$formatic.tokens,
              emitter = _ref$formatic.emitter;
          return {
            myEmitter: emitter,
            myAttributesById: attributesById,
            mySubmissionFieldsById: fieldsById,
            myFieldsById: myFieldsDefById,
            myTokens: tokens
          };
        };

        return Object(Recompose["a"
        /* compose */
        ])(Object(Recompose["b"
        /* getContext */
        ])({
          updateSubmissionField: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        }), Object(es["a"
        /* connect */
        ])(mapStateToProps))(WithFieldSync);
      };
      /* harmony default export */


      var hocs_withFieldSync = __webpack_exports__["a"] = withFieldSync_withFieldSync;
      /***/
    },
    /* 38 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/extends.js

      var helpers_extends = __webpack_require__(36);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectSpread.js


      var objectSpread = __webpack_require__(13);

      var objectSpread_default =
      /*#__PURE__*/
      __webpack_require__.n(objectSpread); // EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js


      var regenerator = __webpack_require__(76);

      var regenerator_default =
      /*#__PURE__*/
      __webpack_require__.n(regenerator); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/asyncToGenerator.js


      var asyncToGenerator = __webpack_require__(104);

      var asyncToGenerator_default =
      /*#__PURE__*/
      __webpack_require__.n(asyncToGenerator); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(21);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/createClass.js


      var createClass = __webpack_require__(20);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(24);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/getPrototypeOf.js


      var getPrototypeOf = __webpack_require__(23);

      var getPrototypeOf_default =
      /*#__PURE__*/
      __webpack_require__.n(getPrototypeOf); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/assertThisInitialized.js


      var assertThisInitialized = __webpack_require__(11);

      var assertThisInitialized_default =
      /*#__PURE__*/
      __webpack_require__.n(assertThisInitialized); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/inherits.js


      var inherits = __webpack_require__(22);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js


      var defineProperty = __webpack_require__(4);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js


      var Recompose = __webpack_require__(26); // EXTERNAL MODULE: ./node_modules/lodash/get.js


      var get = __webpack_require__(10);

      var get_default =
      /*#__PURE__*/
      __webpack_require__.n(get); // EXTERNAL MODULE: ./node_modules/lodash/noop.js


      var noop = __webpack_require__(9);

      var noop_default =
      /*#__PURE__*/
      __webpack_require__.n(noop); // EXTERNAL MODULE: ./node_modules/lodash/isEqual.js


      var isEqual = __webpack_require__(30);

      var isEqual_default =
      /*#__PURE__*/
      __webpack_require__.n(isEqual); // EXTERNAL MODULE: ./node_modules/lodash/omit.js


      var omit = __webpack_require__(62);

      var omit_default =
      /*#__PURE__*/
      __webpack_require__.n(omit); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules


      var es = __webpack_require__(33); // EXTERNAL MODULE: ./node_modules/lodash/debounce.js


      var debounce = __webpack_require__(35);

      var debounce_default =
      /*#__PURE__*/
      __webpack_require__.n(debounce); // EXTERNAL MODULE: ./node_modules/lodash/startsWith.js


      var startsWith = __webpack_require__(269);

      var startsWith_default =
      /*#__PURE__*/
      __webpack_require__.n(startsWith); // EXTERNAL MODULE: ./src/core/hoc/withOverride.js


      var withOverride = __webpack_require__(83); // EXTERNAL MODULE: ./src/core/actions/index.js


      var actions = __webpack_require__(29); // EXTERNAL MODULE: ./src/core/utils.js + 1 modules


      var utils = __webpack_require__(18); // EXTERNAL MODULE: ./src/core/utils/checkLogic.js


      var checkLogic = __webpack_require__(99); // EXTERNAL MODULE: ./src/core/utils/constants.js


      var constants = __webpack_require__(27); // EXTERNAL MODULE: ./src/components/ErrorMessage.js


      var ErrorMessage = __webpack_require__(120); // EXTERNAL MODULE: ./src/core/utils/analytics.js + 1 modules


      var analytics = __webpack_require__(17); // EXTERNAL MODULE: ./src/config/index.js


      var config = __webpack_require__(28); // EXTERNAL MODULE: ./src/core/RootComponents/context/RootContext.js


      var RootContext = __webpack_require__(268); // CONCATENATED MODULE: ./src/core/RootComponents/context/withRootContext.js


      var withRootContext_withRootContext = function withRootContext() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'context';
        return function (WrappedComponent) {
          return function (props) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(RootContext["a"
            /* default */
            ].Consumer, null, function (state) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(WrappedComponent, extends_default()({}, props, defineProperty_default()({}, key, state)));
            });
          };
        };
      };
      /* harmony default export */


      var context_withRootContext = withRootContext_withRootContext; // CONCATENATED MODULE: ./src/hocs/withFieldValidation.js

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "b", function () {
        return withFieldValidation_withFieldValidationWithoutOverride;
      });
      /* unused harmony export valueIsEmpty */


      var withFieldValidation_propsToOmit = ['myContext', 'myEmitter', 'myFieldsById', 'myOrderedFields', 'myValidators', 'mySections', 'myTokens', 'deRegisterValidator', 'registerValidator', 'removeVisibleFields', 'setFieldErrors', 'setVisibleFields'];
      var withFieldValidation_logicKeys = {
        channel: 'myContext.data.variables.channel',
        branch: 'myContext.data.variables.branch'
      };
      /**
       * Check if a form is empty, as validation should not run if the field is empty and not required
       * Fall back to isEmpty() from core/utils - but it currently not checking for masked fields etc
       * @param {Mixed} value
       */

      var withFieldValidation_valueIsEmpty = function valueIsEmpty(value) {
        // For our purposes here 0, NaN, infinite are not empty
        if (typeof value === 'number') {
          return false;
        } // A boolean should also be considered a non empty value


        if (typeof value === 'boolean') {
          return false;
        } // Special check for masked values / calc results


        if (Object(utils["t"
        /* valueHasInputMask */
        ])(value)) {
          return valueIsEmpty(Object(utils["d"
          /* getInputRawValue */
          ])(value));
        } // Eliminate empty string, null, undefined.


        if (!value) {
          return true;
        } // Otherwise check for empty object / arrays


        return Object(utils["o"
        /* isEmpty */
        ])(value);
      };

      var withFieldValidation_withFieldValidationWithoutOverride = function withFieldValidationWithoutOverride(WrappedComponent) {
        var withFieldValidationComponent =
        /*#__PURE__*/
        function (_Component) {
          inherits_default()(withFieldValidationComponent, _Component);

          function withFieldValidationComponent(_props) {
            var _this;

            classCallCheck_default()(this, withFieldValidationComponent);
            _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(withFieldValidationComponent).call(this, _props)); // assign displayName

            defineProperty_default()(assertThisInitialized_default()(_this), "setErrors", function (errors, displayErrorMessage) {
              _this.setState({
                errors: errors,
                displayErrorMessage: displayErrorMessage
              });

              _this.props.setFieldErrors(_this.props.fieldId, errors);

              _this.props.myEmitter.emit(constants["Events"].FieldError, {
                fieldId: _this.props.fieldId,
                value: _this.props.value,
                errors: errors
              });

              _this.props.sendAnalytics(analytics["a"
              /* AnalyticsEvents */
              ].FieldError, {
                fieldId: _this.props.fieldId,
                errors: errors
              });
            });
            defineProperty_default()(assertThisInitialized_default()(_this), "clearErrors", function () {
              if (!Object(utils["o"
              /* isEmpty */
              ])(_this.state.errors) || _this.state.displayErrorMessage !== undefined) {
                // we don't want to render all component because we're setting 'errors' to '{}' when it already is an empty json
                _this.setState({
                  errors: {},
                  // initial value is null, therefore undefined means it was validated and there is no error
                  displayErrorMessage: undefined
                });

                _this.props.setFieldErrors(_this.props.fieldId, {});

                _this.props.myEmitter.emit(constants["Events"].FieldValidated, {
                  fieldId: _this.props.fieldId,
                  value: _this.props.value
                });
              }
            });
            defineProperty_default()(assertThisInitialized_default()(_this), "getValidityErrorMessage", function (operation, isValid) {
              if (operation.operationType === 'validity') {
                return isValid ? '' : get_default()(operation, ['attributes', 'message']);
              }

              return '';
            });
            defineProperty_default()(assertThisInitialized_default()(_this), "getRequiredErrorMessages", function () {
              var requiredLogic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                condition: {},
                attributes: {}
              };
              var submission = arguments.length > 1 ? arguments[1] : undefined;
              var internalFieldKey = arguments.length > 2 ? arguments[2] : undefined;
              var isFromPageNavigation = arguments.length > 3 ? arguments[3] : undefined;
              var props = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _this.props;
              var errorMessages = {
                displayErrorMessage: ''
              };
              var value = props.value;
              var logic = get_default()(requiredLogic, 'condition.attributes.logic');
              var checkLogicResult = logic && Object(checkLogic["a"
              /* default */
              ])(submission, logic, _this.props, withFieldValidation_logicKeys, _this.props.myTokens);
              var logicIsRequired = get_default()(requiredLogic, 'operation.attributes.required', false);

              if (get_default()(props, 'required', false)) {
                if (props.myValidators[constants["Validator"].Empty][props.fieldId]) {
                  // Check for custom empty validator.
                  var result = props.myValidators[constants["Validator"].Empty][props.fieldId](value, internalFieldKey, isFromPageNavigation, props);

                  if (get_default()(result, 'displayErrorMessage')) {
                    errorMessages.displayErrorMessage = get_default()(result, 'displayErrorMessage');
                  }

                  if (get_default()(result, 'errors')) {
                    errorMessages.errors = get_default()(result, 'errors', {});
                  }
                } else if (value ? value.length < 1 : true) {
                  errorMessages.displayErrorMessage = get_default()(props, 'requiredMessage', constants["DefaultRequiredMessage"]);
                } // Can be required, but have logic to make this not required


                if (checkLogicResult && !logicIsRequired) {
                  errorMessages = {
                    displayErrorMessage: ''
                  };
                }
              } // Add required error when value is empty but required


              if (checkLogicResult && withFieldValidation_valueIsEmpty(value) && logicIsRequired) {
                var message = get_default()(requiredLogic, 'operation.attributes.message', constants["DefaultRequiredMessage"]); // if errorMessages is empty or the errorMessages[0] is different from message

                if (!errorMessages.errors || errorMessages.errors.length === 0 || errorMessages.errors.length === 1 && !isEqual_default()(errorMessages.errors[0], message)) {
                  errorMessages.displayErrorMessage = message;
                }
              }

              return errorMessages;
            });
            defineProperty_default()(assertThisInitialized_default()(_this), "getCustomValidatorResult", function (internalFieldKey, isFromPageNavigation) {
              var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.props;
              var customValidatorResult;
              var customValidator = props.myValidators[constants["Validator"].Custom][props.fieldId];

              if (customValidator) {
                // Check for custom validator. If exists, pass value and confirm validity
                customValidatorResult = customValidator(props.value, internalFieldKey, isFromPageNavigation, props);
              }

              return customValidatorResult;
            });
            defineProperty_default()(assertThisInitialized_default()(_this), "processLogic", function (internalFieldKey, isFromPageNavigation) {
              var logic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.logic;
              var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _this.props;
              var fieldValue = props.value;
              var fieldRequired = props.required;
              var values = Object.keys(props.myFieldsById).reduce(function (acc, fieldId) {
                acc[fieldId] = fieldId === props.fieldId ? props.value : props.myFieldsById[fieldId].value;
                return acc;
              }, {});
              values[props.fieldId] = props.value;
              var requiredLogic = logic.filter(function (l) {
                return get_default()(l, 'operation.operationType') === 'required';
              });
              var numRequiredLogic = requiredLogic.length;
              var errors = {
                displayErrorMessage: ''
              }; // If no logic rules configured, will test custom validators and dashboard default prop

              if (numRequiredLogic === 0) {
                errors = _this.getRequiredErrorMessages(null, values, internalFieldKey, isFromPageNavigation, props);
              } // With set required logic loop through each but break on the first error since we only show one


              if (numRequiredLogic > 0) {
                for (var y = 0; y < numRequiredLogic; y += 1) {
                  var logicIsRequired = get_default()(requiredLogic, 'operation.attributes.required', false);
                  errors = _this.getRequiredErrorMessages(requiredLogic[y], values, internalFieldKey, isFromPageNavigation, props);

                  if (errors.displayErrorMessage !== '' || !logicIsRequired && errors.displayErrorMessage === '') {
                    break;
                  }
                }
              } // If field is not flagged as required, and optional required logic hasn't generated errors,
              // ignore additional validation logic checks if field value is empty


              if (!errors.displayErrorMessage && !fieldRequired && withFieldValidation_valueIsEmpty(fieldValue)) {
                return errors;
              }

              if (!errors.displayErrorMessage) {
                for (var lc = 0; lc < logic.length; lc += 1) {
                  // only formLogic supported for now
                  if (logic[lc].condition.conditionType === 'formLogic' && logic[lc].operation.operationType === 'validity') {
                    var formLogicResult = Object(checkLogic["a"
                    /* default */
                    ])(values, logic[lc].condition.attributes.logic, _this.props, withFieldValidation_logicKeys, _this.props.myTokens);
                    errors.displayErrorMessage = _this.getValidityErrorMessage(logic[lc].operation, !formLogicResult);

                    if (errors.displayErrorMessage !== '') {
                      break;
                    }
                  }
                }
              }

              return errors;
            });
            defineProperty_default()(assertThisInitialized_default()(_this), "asyncValidate",
            /*#__PURE__*/
            function () {
              var _ref = asyncToGenerator_default()(
              /*#__PURE__*/
              regenerator_default.a.mark(function _callee(internalFieldKey, isFromPageNavigation) {
                var debounceValidate,
                    _args = arguments;
                return regenerator_default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        debounceValidate = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;

                        if (!debounceValidate) {
                          _context.next = 3;
                          break;
                        }

                        return _context.abrupt("return", _this.debouncedValidate(internalFieldKey, isFromPageNavigation));

                      case 3:
                        _context.next = 5;
                        return new Promise(function (resolve) {
                          return setTimeout(resolve, 0);
                        });

                      case 5:
                        return _context.abrupt("return", _this.syncValidate(internalFieldKey, isFromPageNavigation));

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x, _x2) {
                return _ref.apply(this, arguments);
              };
            }());
            defineProperty_default()(assertThisInitialized_default()(_this), "syncValidate", function (internalFieldKey, isFromPageNavigation) {
              var internalValidateResult = _this.internalValidate(internalFieldKey, isFromPageNavigation);

              if (!Object(utils["o"
              /* isEmpty */
              ])(internalValidateResult.errors)) {
                _this.setErrors(internalValidateResult.errors, internalValidateResult.setErrorsMessage);
              } else if (internalValidateResult.callClearErrors) {
                _this.clearErrors();
              }

              return {
                isValid: internalValidateResult.isValid,
                errors: internalValidateResult.errors
              };
            });
            defineProperty_default()(assertThisInitialized_default()(_this), "internalValidate", function (internalFieldKey, isFromPageNavigation) {
              var logic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.logic;
              var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _this.props;

              var processLogicResult = _this.processLogic(internalFieldKey, isFromPageNavigation, logic, props);

              var customValidatorResult = _this.getCustomValidatorResult(internalFieldKey, isFromPageNavigation, props);

              var errors;
              var setErrorsMessage;
              var callClearErrors = false;

              if (customValidatorResult && customValidatorResult.isValid !== undefined && !customValidatorResult.isValid) {
                errors = objectSpread_default()({}, customValidatorResult.errors, {
                  value: customValidatorResult.displayErrorMessage
                });
                setErrorsMessage = customValidatorResult.displayErrorMessage;
              } else if (processLogicResult.displayErrorMessage) {
                errors = {
                  value: processLogicResult.displayErrorMessage
                };
                setErrorsMessage = processLogicResult.displayErrorMessage;
              } else {
                callClearErrors = true;
              }

              if (processLogicResult.errors && Object.keys(processLogicResult.errors).length > 0) {
                errors = objectSpread_default()({
                  errors: errors
                }, processLogicResult.errors);
                callClearErrors = false;
              }

              return {
                isValid: Object(utils["o"
                /* isEmpty */
                ])(errors),
                errors: errors,
                callClearErrors: callClearErrors,
                setErrorsMessage: setErrorsMessage
              };
            });
            defineProperty_default()(assertThisInitialized_default()(_this), "registerValidator", function (validator, id, type, componentWillHandleValidationClasses) {
              _this.setState({
                componentWillHandleValidationClasses: componentWillHandleValidationClasses
              });

              _this.props.registerValidator(validator, id, type);
            });
            _this.displayName = Object(Recompose["d"
            /* wrapDisplayName */
            ])(WrappedComponent, 'withFieldValidation');
            var _logic = [];

            if (!Object(utils["o"
            /* isEmpty */
            ])(_props.logic)) {
              _logic = _props.logic;
            } else {
              var field = Object(utils["n"
              /* getValueFromList */
              ])(_props.fieldId, Object(utils["n"
              /* getValueFromList */
              ])(_props.sectionId, _props.mySections, 'fields'), {});
              _logic = get_default()(field, 'logic', []);
            }

            var hasSubmissionValue = _props.myFieldsById[_props.fieldId];
            _this.debouncedValidate = debounce_default()(_this.syncValidate, config["a"
            /* default */
            ].getFieldUpdateTimeout()); // only validates the field, if field has a submission value.
            // otherwise we'll load the form and all optional fields will be validaded (with the valid class on it)

            var _internalValidateResult = hasSubmissionValue ? _this.internalValidate(undefined, false, _logic, _props) : {};

            _this.state = {
              componentWillHandleValidationClasses: false,
              // displayErrorMessage equals to undefined means that it was valided and there is no error
              // displayErrorMessage equals to null means that it was initialised
              // NOTE: if in the future we want to display the error message on load,
              //       just replace the 'null' below by 'internalValidateResult.setErrorsMessage'
              displayErrorMessage: _internalValidateResult.isValid && hasSubmissionValue ? undefined : null,
              errors: {},
              logic: _logic
            }; // When the field is optional and we refresh the browser is displaying the field as valid

            if (!_props.required && _internalValidateResult.isValid && hasSubmissionValue && Object(utils["o"
            /* isEmpty */
            ])(hasSubmissionValue.value)) {
              _this.state.displayErrorMessage = null;
            } // using 'findIndex and startsWith' instead of 'indexOf' because orderedFields only contains the repeatable id
            // (it doesn't have the field ids that are in a repeatable)
            // NOTE: since orderedFields does NOT contain the field ids that are inside of a repeatable, only the repeatable id
            // fieldIndexInForm will be the same for all the fields in the same repeatable


            var fieldIndexInForm = _this.props.myOrderedFields.findIndex(function (fieldId) {
              return startsWith_default()(_this.props.fieldId, fieldId);
            });

            _this.props.setVisibleFields(defineProperty_default()({}, _this.props.fieldId, {
              errors: {},
              validate: _this.syncValidate,
              fieldIndexInForm: fieldIndexInForm
            }));

            return _this;
          }

          createClass_default()(withFieldValidationComponent, [{
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
              this.props.removeVisibleFields([this.props.fieldId]);
              this.props.deRegisterValidator(this.props.fieldId);
            }
            /**
             * Sets the errors and display error message.
             *
             * 'errors' contains all the errors in an object that a field has
             * 'displayErrorMessage' is the error message that will be rendered on the bottom of the component
             * When errors is empty it will add the 'formatic-field-valid' class on 'div.formatic-field-container'
             * When errors is not empty it add the 'formatic-field-error' class on 'div.formatic-field-container'
             */

          }, {
            key: "render",
            value: function render() {
              var _this$state = this.state,
                  componentWillHandleValidationClasses = _this$state.componentWillHandleValidationClasses,
                  displayErrorMessage = _this$state.displayErrorMessage;
              var isRepeatable = this.props.renderer === 'repeatable';
              var addFieldErrorClass = !isRepeatable && !componentWillHandleValidationClasses && !Object(utils["o"
              /* isEmpty */
              ])(displayErrorMessage); // initial value is null, therefore 'undefined' means it was validated and there is no error

              var addFieldValidClass = !isRepeatable && !componentWillHandleValidationClasses && displayErrorMessage === undefined;
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(WrappedComponent, extends_default()({}, omit_default()(this.props, withFieldValidation_propsToOmit), {
                className: classnames_default()(defineProperty_default()({}, this.props.className, this.props.className), {
                  'formatic-field-error': addFieldErrorClass
                }, {
                  'formatic-field-valid': addFieldValidClass
                }, {
                  'formatic-field-empty': withFieldValidation_valueIsEmpty(this.props.value)
                }),
                clearErrors: this.clearErrors,
                errorMessage: this.state.displayErrorMessage && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ErrorMessage["a"
                /* default */
                ], {
                  text: this.state.displayErrorMessage
                }),
                errors: this.state.errors,
                registerValidator: this.registerValidator,
                setErrors: this.setErrors,
                validate: this.asyncValidate,
                syncValidate: this.syncValidate
              }));
            }
          }]);
          return withFieldValidationComponent;
        }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

        withFieldValidationComponent.defaultProps = {
          className: '',
          fieldId: '',
          logic: [],
          renderer: '',
          required: true,
          sectionId: '',
          sendAnalytics: noop_default.a,
          value: '',
          // props from connect formatic store
          mySections: [],
          myEmitter: {},
          myFieldsById: {},
          myOrderedFields: [],
          myValidators: {},
          myTokens: {},
          // props from connect dispatch
          deRegisterValidator: noop_default.a,
          registerValidator: noop_default.a,
          removeVisibleFields: noop_default.a,
          setFieldErrors: noop_default.a,
          setVisibleFields: noop_default.a
        };
        withFieldValidationComponent.propTypes = {
          className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          logic: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          renderer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          sectionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          // props from connect formatic store
          mySections: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object),
          myEmitter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          myFieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          myOrderedFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
          myValidators: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          myTokens: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          // props from connect dispatch
          deRegisterValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          removeVisibleFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          setFieldErrors: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          setVisibleFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        };

        var mapStateToProps = function mapStateToProps(_ref2) {
          var _ref2$formatic = _ref2.formatic,
              emitter = _ref2$formatic.emitter,
              fieldsById = _ref2$formatic.data.submission.fieldsById,
              sections = _ref2$formatic.dataForm.sections,
              orderedFields = _ref2$formatic.orderedFields,
              validators = _ref2$formatic.validators,
              tokens = _ref2$formatic.tokens;
          return {
            myEmitter: emitter,
            myFieldsById: fieldsById,
            myOrderedFields: orderedFields,
            myValidators: validators,
            mySections: sections,
            myTokens: tokens
          };
        };

        var mapDispatchToProps = function mapDispatchToProps(dispatch) {
          return {
            deRegisterValidator: function deRegisterValidator(id) {
              var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return dispatch(Object(actions["L"
              /* removeValidator */
              ])(id || get_default()(this.props, 'id'), type));
            },
            registerValidator: function registerValidator(validator, id) {
              var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : constants["Validator"].Custom;
              return dispatch(Object(actions["G"
              /* addValidator */
              ])(id || get_default()(this.props, 'id'), validator, type));
            },
            removeVisibleFields: function removeVisibleFields(visibleFields) {
              return dispatch(Object(actions["M"
              /* removeVisibleFields */
              ])(visibleFields));
            },
            setFieldErrors: function setFieldErrors(fieldId, errors) {
              return dispatch(Object(actions["T"
              /* setFieldErrors */
              ])(fieldId, errors));
            },
            setVisibleFields: function setVisibleFields(visibleFields) {
              return dispatch(Object(actions["Ca"
              /* setVisibleFields */
              ])(visibleFields));
            }
          };
        };

        return Object(Recompose["a"
        /* compose */
        ])(context_withRootContext('myContext'), Object(es["a"
        /* connect */
        ])(mapStateToProps, mapDispatchToProps))(withFieldValidationComponent);
      };

      var withFieldValidation_withFieldValidation = function withFieldValidation(WrappedComponent) {
        var hoc = withFieldValidation_withFieldValidationWithoutOverride(WrappedComponent);
        return Object(Recompose["a"
        /* compose */
        ])(Object(withOverride["a"
        /* default */
        ])({
          overrideType: 'hoc',
          type: 'withFieldValidation',
          WrappedComponent: WrappedComponent
        }))(hoc);
      };
      /* harmony default export */


      var hocs_withFieldValidation = __webpack_exports__["a"] = withFieldValidation_withFieldValidation;
      /***/
    },
    /* 39 */

    /***/
    function (module, exports) {
      function _typeof2(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof2 = function _typeof2(obj) {
            return typeof obj;
          };
        } else {
          _typeof2 = function _typeof2(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof2(obj);
      }

      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          module.exports = _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          module.exports = _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }

        return _typeof(obj);
      }

      module.exports = _typeof;
      /***/
    },
    /* 40 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayWithoutHoles = __webpack_require__(875);

      var iterableToArray = __webpack_require__(874);

      var nonIterableSpread = __webpack_require__(873);

      function _toConsumableArray(arr) {
        return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
      }

      module.exports = _toConsumableArray;
      /***/
    },
    /* 41 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11);
      /* harmony import */


      var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_9___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_10___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
      /* harmony import */


      var recompose__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_12___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_12__);
      /* harmony import */


      var lodash_set__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52);
      /* harmony import */


      var lodash_set__WEBPACK_IMPORTED_MODULE_13___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_set__WEBPACK_IMPORTED_MODULE_13__);
      /* harmony import */


      var react_redux__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(33);
      /* harmony import */


      var lodash_debounce__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35);
      /* harmony import */


      var lodash_debounce__WEBPACK_IMPORTED_MODULE_15___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_15__);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(62);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_16___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_16__);
      /* harmony import */


      var _core_utils_analytics__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(17);
      /* harmony import */


      var _core_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(18);
      /* harmony import */


      var _config__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(28);

      var INTERACTION_STARTED = 'INTERACTION_STARTED';
      var INTERACTION_ENDED = 'INTERACTION_ENDED';
      var propsToOmit = ['myChannel', 'myEmitter', 'myEnvironment', 'myFormId', 'mySubmissionId'];

      var withAnalytics = function withAnalytics(WrappedComponent) {
        var WithAnalyticsComponent =
        /*#__PURE__*/
        function (_Component) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(WithAnalyticsComponent, _Component);

          function WithAnalyticsComponent(props) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, WithAnalyticsComponent);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(WithAnalyticsComponent).call(this, props)); // assign displayName

            _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "setInteractionGroupId", function () {
              var generateNewId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

              if (generateNewId || !_this.currentInteraction.interactionGroupId) {
                _this.currentInteraction.interactionGroupId = Object(_core_utils__WEBPACK_IMPORTED_MODULE_18__[
                /* getRandomId */
                "k"])();
              }
            });

            _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "shouldIgnore", function (event) {
              switch (event) {
                case 'onValueChange':
                  return function (params, _ref) {
                    var onValueChange = _ref.onValueChange;
                    var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16000;
                    return params.valueLength > 0 && onValueChange.valueLength > 0 && Object(_core_utils__WEBPACK_IMPORTED_MODULE_18__[
                    /* now */
                    "q"])() - onValueChange.time < threshold;
                  };

                default:
                  return lodash_noop__WEBPACK_IMPORTED_MODULE_12___default.a;
              }
            });

            _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "debounceEventTriggers", function (event, params) {
              if (_this.shouldIgnore(event)(params, _this.lastEvents)) {
                return;
              }

              lodash_set__WEBPACK_IMPORTED_MODULE_13___default()(_this.lastEvents, event, {
                time: Object(_core_utils__WEBPACK_IMPORTED_MODULE_18__[
                /* now */
                "q"])(),
                fieldId: params.fieldId,
                valueLength: params.valueLength
              });

              _this.sendAnalytics(event, _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({
                fieldId: _this.props.id || _this.props.fieldId
              }, params));
            });

            _this.displayName = Object(recompose__WEBPACK_IMPORTED_MODULE_11__[
            /* wrapDisplayName */
            "d"])(WrappedComponent, 'withAnalytics');
            _this.lastEvents = {
              onValueChange: {
                time: Object(_core_utils__WEBPACK_IMPORTED_MODULE_18__[
                /* now */
                "q"])(),
                fieldId: '',
                valueLength: -1
              }
            };
            _this.currentInteraction = {
              interactionGroupId: null,
              interactionState: null
            };
            _this.sendAnalytics = Object(_core_utils_analytics__WEBPACK_IMPORTED_MODULE_17__[
            /* analyticsCallback */
            "c"])({
              submissionId: props.mySubmissionId,
              formId: props.myFormId,
              branch: props.myEnvironment,
              channel: props.myChannel
            }, props.myEmitter);

            var interactionDebounce = _config__WEBPACK_IMPORTED_MODULE_19__[
            /* default */
            "a"].getFieldInteractionDebounce();

            _this.startInteraction = function (AnalyticsEvent) {
              _this.setInteractionGroupId();

              if (_this.currentInteraction.interactionState !== INTERACTION_STARTED) {
                _this.currentInteraction.interactionState = INTERACTION_STARTED;

                _this.sendAnalytics(_core_utils_analytics__WEBPACK_IMPORTED_MODULE_17__[
                /* AnalyticsEvents */
                "a"].InteractionStart, {
                  fieldId: _this.props.fieldId,
                  interactionGroupId: _this.currentInteraction.interactionGroupId,
                  parentFieldId: _this.props.analyticsParams.parentFieldId
                });
              }

              _this.endInteraction(AnalyticsEvent);
            };

            _this.endInteraction = lodash_debounce__WEBPACK_IMPORTED_MODULE_15___default()(function (AnalyticsEvent) {
              var sendAnalytic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              _this.currentInteraction.interactionState = INTERACTION_ENDED;

              if (sendAnalytic) {
                _this.sendAnalytics(_core_utils_analytics__WEBPACK_IMPORTED_MODULE_17__[
                /* AnalyticsEvents */
                "a"].InteractionEnd, {
                  fieldId: _this.props.fieldId,
                  interactionGroupId: _this.currentInteraction.interactionGroupId,
                  parentFieldId: _this.props.analyticsParams.parentFieldId
                });
              } // If the field loses focus, reset the groupId
              // This will help our backend scripts group interactions better for calcs


              if (AnalyticsEvent === _core_utils_analytics__WEBPACK_IMPORTED_MODULE_17__[
              /* AnalyticsEvents */
              "a"].Blur) {
                _this.currentInteraction.interactionGroupId = null;
              }
            }, interactionDebounce);

            _this.analyticsInteraction = function () {
              var AnalyticsEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

              _this.startInteraction(AnalyticsEvent);
            };

            return _this;
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(WithAnalyticsComponent, [{
            key: "render",
            value: function render() {
              // Some components will set custom analytics params so we need to allow for this
              // Note repeatable params like parentFieldId etc are potentially redundant as the main id is a composite key,
              // But repeatable structure may be changing in the future.
              var analyticsParams = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, this.props.analyticsParams || {}, {
                fieldId: this.props.fieldId
              });

              return react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(WrappedComponent, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, lodash_omit__WEBPACK_IMPORTED_MODULE_16___default()(this.props, propsToOmit), {
                sendAnalytics: this.debounceEventTriggers,
                analyticsParams: analyticsParams,
                analyticsInteraction: this.analyticsInteraction
              }));
            }
          }]);

          return WithAnalyticsComponent;
        }(react__WEBPACK_IMPORTED_MODULE_9__["Component"]);

        WithAnalyticsComponent.defaultProps = {
          id: '',
          fieldId: '',
          parentFieldId: null,
          data: {},
          analyticsParams: {},
          // props from connect formatic store
          myChannel: '',
          myEmitter: {},
          myEnvironment: '',
          myFormId: '',
          mySubmissionId: ''
        };
        WithAnalyticsComponent.propTypes = {
          id: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
          fieldId: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
          parentFieldId: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string || prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool,
          data: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.object,
          analyticsParams: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.object,
          // props from connect formatic store
          myChannel: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
          myEmitter: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.object,
          myEnvironment: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
          myFormId: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.number,
          mySubmissionId: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string
        };
        return Object(recompose__WEBPACK_IMPORTED_MODULE_11__[
        /* compose */
        "a"])(Object(react_redux__WEBPACK_IMPORTED_MODULE_14__[
        /* connect */
        "a"])(function (_ref2) {
          var formatic = _ref2.formatic;
          return {
            myChannel: formatic.channel,
            myEmitter: formatic.emitter,
            myEnvironment: formatic.environment,
            myFormId: formatic.formId,
            mySubmissionId: formatic.submissionId
          };
        }))(WithAnalyticsComponent);
      };
      /* harmony default export */


      __webpack_exports__["a"] = withAnalytics;
      /***/
    },
    /* 42 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      exports.default = function (obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      };
      /***/

    },
    /* 43 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js


      var defineProperty = __webpack_require__(6);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js


      var createClass = __webpack_require__(12);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // CONCATENATED MODULE: ./node_modules/rc-animate/es/ChildrenUtils.js


      function ChildrenUtils_toArrayChildren(children) {
        var ret = [];
        external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(children, function (child) {
          ret.push(child);
        });
        return ret;
      }

      function ChildrenUtils_findChildInChildrenByKey(children, key) {
        var ret = null;

        if (children) {
          children.forEach(function (child) {
            if (ret) {
              return;
            }

            if (child && child.key === key) {
              ret = child;
            }
          });
        }

        return ret;
      }

      function ChildrenUtils_findShownChildInChildrenByKey(children, key, showProp) {
        var ret = null;

        if (children) {
          children.forEach(function (child) {
            if (child && child.key === key && child.props[showProp]) {
              if (ret) {
                throw new Error('two child with same key for <rc-animate> children');
              }

              ret = child;
            }
          });
        }

        return ret;
      }

      function ChildrenUtils_findHiddenChildInChildrenByKey(children, key, showProp) {
        var found = 0;

        if (children) {
          children.forEach(function (child) {
            if (found) {
              return;
            }

            found = child && child.key === key && !child.props[showProp];
          });
        }

        return found;
      }

      function ChildrenUtils_isSameChildren(c1, c2, showProp) {
        var same = c1.length === c2.length;

        if (same) {
          c1.forEach(function (child, index) {
            var child2 = c2[index];

            if (child && child2) {
              if (child && !child2 || !child && child2) {
                same = false;
              } else if (child.key !== child2.key) {
                same = false;
              } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
                same = false;
              }
            }
          });
        }

        return same;
      }

      function ChildrenUtils_mergeChildren(prev, next) {
        var ret = []; // For each key of `next`, the list of keys to insert before that key in
        // the combined list

        var nextChildrenPending = {};
        var pendingChildren = [];
        prev.forEach(function (child) {
          if (child && ChildrenUtils_findChildInChildrenByKey(next, child.key)) {
            if (pendingChildren.length) {
              nextChildrenPending[child.key] = pendingChildren;
              pendingChildren = [];
            }
          } else {
            pendingChildren.push(child);
          }
        });
        next.forEach(function (child) {
          if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
            ret = ret.concat(nextChildrenPending[child.key]);
          }

          ret.push(child);
        });
        ret = ret.concat(pendingChildren);
        return ret;
      } // EXTERNAL MODULE: external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}


      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_ = __webpack_require__(16);

      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_); // EXTERNAL MODULE: ./node_modules/css-animation/es/index.js + 1 modules


      var es = __webpack_require__(164); // CONCATENATED MODULE: ./node_modules/rc-animate/es/util/animate.js


      var util = {
        isAppearSupported: function isAppearSupported(props) {
          return props.transitionName && props.transitionAppear || props.animation.appear;
        },
        isEnterSupported: function isEnterSupported(props) {
          return props.transitionName && props.transitionEnter || props.animation.enter;
        },
        isLeaveSupported: function isLeaveSupported(props) {
          return props.transitionName && props.transitionLeave || props.animation.leave;
        },
        allowAppearCallback: function allowAppearCallback(props) {
          return props.transitionAppear || props.animation.appear;
        },
        allowEnterCallback: function allowEnterCallback(props) {
          return props.transitionEnter || props.animation.enter;
        },
        allowLeaveCallback: function allowLeaveCallback(props) {
          return props.transitionLeave || props.animation.leave;
        }
      };
      /* harmony default export */

      var animate = util; // CONCATENATED MODULE: ./node_modules/rc-animate/es/AnimateChild.js

      var AnimateChild_transitionMap = {
        enter: 'transitionEnter',
        appear: 'transitionAppear',
        leave: 'transitionLeave'
      };

      var AnimateChild_AnimateChild = function (_React$Component) {
        inherits_default()(AnimateChild, _React$Component);

        function AnimateChild() {
          classCallCheck_default()(this, AnimateChild);
          return possibleConstructorReturn_default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
        }

        createClass_default()(AnimateChild, [{
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this.stop();
          }
        }, {
          key: 'componentWillEnter',
          value: function componentWillEnter(done) {
            if (animate.isEnterSupported(this.props)) {
              this.transition('enter', done);
            } else {
              done();
            }
          }
        }, {
          key: 'componentWillAppear',
          value: function componentWillAppear(done) {
            if (animate.isAppearSupported(this.props)) {
              this.transition('appear', done);
            } else {
              done();
            }
          }
        }, {
          key: 'componentWillLeave',
          value: function componentWillLeave(done) {
            if (animate.isLeaveSupported(this.props)) {
              this.transition('leave', done);
            } else {
              // always sync, do not interupt with react component life cycle
              // update hidden -> animate hidden ->
              // didUpdate -> animate leave -> unmount (if animate is none)
              done();
            }
          }
        }, {
          key: 'transition',
          value: function transition(animationType, finishCallback) {
            var _this2 = this;

            var node = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this);
            var props = this.props;
            var transitionName = props.transitionName;
            var nameIsObj = typeof transitionName === 'object';
            this.stop();

            var end = function end() {
              _this2.stopper = null;
              finishCallback();
            };

            if ((es["b"
            /* isCssAnimationSupported */
            ] || !props.animation[animationType]) && transitionName && props[AnimateChild_transitionMap[animationType]]) {
              var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
              var activeName = name + '-active';

              if (nameIsObj && transitionName[animationType + 'Active']) {
                activeName = transitionName[animationType + 'Active'];
              }

              this.stopper = Object(es["a"
              /* default */
              ])(node, {
                name: name,
                active: activeName
              }, end);
            } else {
              this.stopper = props.animation[animationType](node, end);
            }
          }
        }, {
          key: 'stop',
          value: function stop() {
            var stopper = this.stopper;

            if (stopper) {
              this.stopper = null;
              stopper.stop();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            return this.props.children;
          }
        }]);
        return AnimateChild;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      AnimateChild_AnimateChild.propTypes = {
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      /* harmony default export */

      var es_AnimateChild = AnimateChild_AnimateChild; // CONCATENATED MODULE: ./node_modules/rc-animate/es/Animate.js

      var Animate_defaultKey = 'rc_animate_' + Date.now();

      function Animate_getChildrenFromProps(props) {
        var children = props.children;

        if (external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.isValidElement(children)) {
          if (!children.key) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(children, {
              key: Animate_defaultKey
            });
          }
        }

        return children;
      }

      function Animate_noop() {}

      var Animate_Animate = function (_React$Component) {
        inherits_default()(Animate, _React$Component); // eslint-disable-line

        function Animate(props) {
          classCallCheck_default()(this, Animate);

          var _this = possibleConstructorReturn_default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

          Animate_initialiseProps.call(_this);
          _this.currentlyAnimatingKeys = {};
          _this.keysToEnter = [];
          _this.keysToLeave = [];
          _this.state = {
            children: ChildrenUtils_toArrayChildren(Animate_getChildrenFromProps(props))
          };
          _this.childrenRefs = {};
          return _this;
        }

        createClass_default()(Animate, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _this2 = this;

            var showProp = this.props.showProp;
            var children = this.state.children;

            if (showProp) {
              children = children.filter(function (child) {
                return !!child.props[showProp];
              });
            }

            children.forEach(function (child) {
              if (child) {
                _this2.performAppear(child.key);
              }
            });
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var _this3 = this;

            this.nextProps = nextProps;
            var nextChildren = ChildrenUtils_toArrayChildren(Animate_getChildrenFromProps(nextProps));
            var props = this.props; // exclusive needs immediate response

            if (props.exclusive) {
              Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
                _this3.stop(key);
              });
            }

            var showProp = props.showProp;
            var currentlyAnimatingKeys = this.currentlyAnimatingKeys; // last props children if exclusive

            var currentChildren = props.exclusive ? ChildrenUtils_toArrayChildren(Animate_getChildrenFromProps(props)) : this.state.children; // in case destroy in showProp mode

            var newChildren = [];

            if (showProp) {
              currentChildren.forEach(function (currentChild) {
                var nextChild = currentChild && ChildrenUtils_findChildInChildrenByKey(nextChildren, currentChild.key);
                var newChild = void 0;

                if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
                  newChild = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(nextChild || currentChild, defineProperty_default()({}, showProp, true));
                } else {
                  newChild = nextChild;
                }

                if (newChild) {
                  newChildren.push(newChild);
                }
              });
              nextChildren.forEach(function (nextChild) {
                if (!nextChild || !ChildrenUtils_findChildInChildrenByKey(currentChildren, nextChild.key)) {
                  newChildren.push(nextChild);
                }
              });
            } else {
              newChildren = ChildrenUtils_mergeChildren(currentChildren, nextChildren);
            } // need render to avoid update


            this.setState({
              children: newChildren
            });
            nextChildren.forEach(function (child) {
              var key = child && child.key;

              if (child && currentlyAnimatingKeys[key]) {
                return;
              }

              var hasPrev = child && ChildrenUtils_findChildInChildrenByKey(currentChildren, key);

              if (showProp) {
                var showInNext = child.props[showProp];

                if (hasPrev) {
                  var showInNow = ChildrenUtils_findShownChildInChildrenByKey(currentChildren, key, showProp);

                  if (!showInNow && showInNext) {
                    _this3.keysToEnter.push(key);
                  }
                } else if (showInNext) {
                  _this3.keysToEnter.push(key);
                }
              } else if (!hasPrev) {
                _this3.keysToEnter.push(key);
              }
            });
            currentChildren.forEach(function (child) {
              var key = child && child.key;

              if (child && currentlyAnimatingKeys[key]) {
                return;
              }

              var hasNext = child && ChildrenUtils_findChildInChildrenByKey(nextChildren, key);

              if (showProp) {
                var showInNow = child.props[showProp];

                if (hasNext) {
                  var showInNext = ChildrenUtils_findShownChildInChildrenByKey(nextChildren, key, showProp);

                  if (!showInNext && showInNow) {
                    _this3.keysToLeave.push(key);
                  }
                } else if (showInNow) {
                  _this3.keysToLeave.push(key);
                }
              } else if (!hasNext) {
                _this3.keysToLeave.push(key);
              }
            });
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            var keysToEnter = this.keysToEnter;
            this.keysToEnter = [];
            keysToEnter.forEach(this.performEnter);
            var keysToLeave = this.keysToLeave;
            this.keysToLeave = [];
            keysToLeave.forEach(this.performLeave);
          }
        }, {
          key: 'isValidChildByKey',
          value: function isValidChildByKey(currentChildren, key) {
            var showProp = this.props.showProp;

            if (showProp) {
              return ChildrenUtils_findShownChildInChildrenByKey(currentChildren, key, showProp);
            }

            return ChildrenUtils_findChildInChildrenByKey(currentChildren, key);
          }
        }, {
          key: 'stop',
          value: function stop(key) {
            delete this.currentlyAnimatingKeys[key];
            var component = this.childrenRefs[key];

            if (component) {
              component.stop();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this4 = this;

            var props = this.props;
            this.nextProps = props;
            var stateChildren = this.state.children;
            var children = null;

            if (stateChildren) {
              children = stateChildren.map(function (child) {
                if (child === null || child === undefined) {
                  return child;
                }

                if (!child.key) {
                  throw new Error('must set key for <rc-animate> children');
                }

                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_AnimateChild, {
                  key: child.key,
                  ref: function ref(node) {
                    _this4.childrenRefs[child.key] = node;
                  },
                  animation: props.animation,
                  transitionName: props.transitionName,
                  transitionEnter: props.transitionEnter,
                  transitionAppear: props.transitionAppear,
                  transitionLeave: props.transitionLeave
                }, child);
              });
            }

            var Component = props.component;

            if (Component) {
              var passedProps = props;

              if (typeof Component === 'string') {
                passedProps = extends_default()({
                  className: props.className,
                  style: props.style
                }, props.componentProps);
              }

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Component, passedProps, children);
            }

            return children[0] || null;
          }
        }]);
        return Animate;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Animate_Animate.isAnimate = true;
      Animate_Animate.propTypes = {
        component: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        componentProps: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        animation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        transitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        transitionEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        transitionAppear: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        exclusive: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        transitionLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onEnd: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onAppear: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        showProp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node
      };
      Animate_Animate.defaultProps = {
        animation: {},
        component: 'span',
        componentProps: {},
        transitionEnter: true,
        transitionLeave: true,
        transitionAppear: false,
        onEnd: Animate_noop,
        onEnter: Animate_noop,
        onLeave: Animate_noop,
        onAppear: Animate_noop
      };

      var Animate_initialiseProps = function _initialiseProps() {
        var _this5 = this;

        this.performEnter = function (key) {
          // may already remove by exclusive
          if (_this5.childrenRefs[key]) {
            _this5.currentlyAnimatingKeys[key] = true;

            _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
          }
        };

        this.performAppear = function (key) {
          if (_this5.childrenRefs[key]) {
            _this5.currentlyAnimatingKeys[key] = true;

            _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
          }
        };

        this.handleDoneAdding = function (key, type) {
          var props = _this5.props;
          delete _this5.currentlyAnimatingKeys[key]; // if update on exclusive mode, skip check

          if (props.exclusive && props !== _this5.nextProps) {
            return;
          }

          var currentChildren = ChildrenUtils_toArrayChildren(Animate_getChildrenFromProps(props));

          if (!_this5.isValidChildByKey(currentChildren, key)) {
            // exclusive will not need this
            _this5.performLeave(key);
          } else if (type === 'appear') {
            if (animate.allowAppearCallback(props)) {
              props.onAppear(key);
              props.onEnd(key, true);
            }
          } else if (animate.allowEnterCallback(props)) {
            props.onEnter(key);
            props.onEnd(key, true);
          }
        };

        this.performLeave = function (key) {
          // may already remove by exclusive
          if (_this5.childrenRefs[key]) {
            _this5.currentlyAnimatingKeys[key] = true;

            _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
          }
        };

        this.handleDoneLeaving = function (key) {
          var props = _this5.props;
          delete _this5.currentlyAnimatingKeys[key]; // if update on exclusive mode, skip check

          if (props.exclusive && props !== _this5.nextProps) {
            return;
          }

          var currentChildren = ChildrenUtils_toArrayChildren(Animate_getChildrenFromProps(props)); // in case state change is too fast

          if (_this5.isValidChildByKey(currentChildren, key)) {
            _this5.performEnter(key);
          } else {
            var end = function end() {
              if (animate.allowLeaveCallback(props)) {
                props.onLeave(key);
                props.onEnd(key, false);
              }
            };

            if (!ChildrenUtils_isSameChildren(_this5.state.children, currentChildren, props.showProp)) {
              _this5.setState({
                children: currentChildren
              }, end);
            } else {
              end();
            }
          }
        };
      };
      /* harmony default export */


      var es_Animate = __webpack_exports__["default"] = Animate_Animate;
      /***/
    },
    /* 44 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "e", function () {
        return getStorageEngine;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "h", function () {
        return localStorageSetItem;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "f", function () {
        return localStorageGetItem;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "g", function () {
        return localStorageRemoveItem;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return getLocalStorageSubmissionKey;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return getLocalSubmissionId;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return Engine;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return StorageEngineKey;
      });
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _utils_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69);
      /* harmony import */


      var _config_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28);

      var Engine = {
        LocalStorage: 'local',
        SessionStorage: 'session'
      };
      var DefaultEngine = Engine.LocalStorage;
      var StorageEngineKey = 'formatic-storage-engine-';
      /**
       * Retrieves the storage engine from redux
       */

      var getStorageEngine = function getStorageEngine() {
        var store = Object(_utils_actions__WEBPACK_IMPORTED_MODULE_1__[
        /* getStore */
        "d"])();
        var state = store.getState();
        return lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(state, 'formatic.dataForm.attributes.storage', DefaultEngine);
      };
      /**
       * Returns the engine if valid, otherwise returns the default
       * @param {string} engine
       */


      function getEngine(engine) {
        if (engine === null) {
          return getStorageEngine();
        }

        if (!Object.values(Engine).includes(engine)) {
          return DefaultEngine;
        }

        return engine;
      }
      /**
       * Checks whether the browser has support for local storage
       */


      var supportsLocalStorage = function () {
        var submissionIdKey = _config_index__WEBPACK_IMPORTED_MODULE_2__[
        /* default */
        "a"].getSubmissionIdKey();

        try {
          localStorage.setItem("".concat(submissionIdKey, "-test"), submissionIdKey);
          localStorage.removeItem("".concat(submissionIdKey, "-test"));
          return true;
        } catch (e) {
          return false;
        }
      }();
      /**
       * Persistently save an item in the browser
       * @param {string} key - Key to save against
       * @param {string} value - Value to set
       * @param {string} [engine] - Storage engine to set with
       */


      var localStorageSetItem = function localStorageSetItem(key, value) {
        var engine = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        if (supportsLocalStorage) {
          switch (getEngine(engine)) {
            case Engine.SessionStorage:
              sessionStorage.setItem(key, value);
              break;

            default:
              localStorage.setItem(key, value);
          }
        }
      };
      /**
       * Retrieves a saved item from browser storage negine
       * @param {string} key - Key to retrieve for
       * @param {string} [engine] - Storage engine to look in
       */


      var localStorageGetItem = function localStorageGetItem(key) {
        var engine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (supportsLocalStorage) {
          switch (getEngine(engine)) {
            case Engine.SessionStorage:
              return sessionStorage.getItem(key);

            default:
              return localStorage.getItem(key);
          }
        }

        return null;
      };
      /**
       * Remove an item from the browser's storage
       * @param {string} key - Key to search for and remove
       * @param {string} [engine] - Storage engine to remove from
       */


      var localStorageRemoveItem = function localStorageRemoveItem(key) {
        var engine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (supportsLocalStorage) {
          switch (getEngine(engine)) {
            case Engine.SessionStorage:
              sessionStorage.removeItem(key);
              break;

            default:
              localStorage.removeItem(key);
          }
        }
      };
      /**
       * The key to save the submission ID against
       * @param {string} id
       */


      var getLocalStorageSubmissionKey = function getLocalStorageSubmissionKey(id) {
        return _config_index__WEBPACK_IMPORTED_MODULE_2__[
        /* default */
        "a"].getAppendFormIdToSubmissionIdKey() ? "".concat(_config_index__WEBPACK_IMPORTED_MODULE_2__[
        /* default */
        "a"].getSubmissionIdKey(), "-").concat(id) : _config_index__WEBPACK_IMPORTED_MODULE_2__[
        /* default */
        "a"].getSubmissionIdKey();
      };
      /**
       * Retrieve the submission ID from browser storage. The submission ID is needed
       * before the form schema has been requested (as the submission ID is sent up with
       * the initial GraphQL request). Therefore, the engine the submission ID is stored
       * in for the form is retained in local storage (whereas the actual submission ID
       * itself might be in session storage).
       *
       * @param {string} id - ID to lookup
       * @param {string} [engine] - Storage engine to look in
       */


      var getLocalSubmissionId = function getLocalSubmissionId(id) {
        var engine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        try {
          var storageEngine = engine;

          if (engine === null) {
            var storageEngineKey = "".concat(StorageEngineKey).concat(id);
            storageEngine = localStorage.getItem(storageEngineKey);
          }

          if (storageEngine === null) {
            return null;
          }

          return localStorageGetItem(getLocalStorageSubmissionKey(id), storageEngine) || null;
        } catch (e) {
          // Some (all of our current) storage engines not available within node, just return null
          // on error
          return null;
        }
      };
      /***/

    },
    /* 45 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */


      var babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
      /* harmony import */


      var babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);

      function omit(obj, fields) {
        var shallowCopy = babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, obj);

        for (var i = 0; i < fields.length; i++) {
          var key = fields[i];
          delete shallowCopy[key];
        }

        return shallowCopy;
      }
      /* harmony default export */


      __webpack_exports__["default"] = omit;
      /***/
    },
    /* 46 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        /**
         * Create a Matrix. The function creates a new `math.type.Matrix` object from
         * an `Array`. A Matrix has utility functions to manipulate the data in the
         * matrix, like getting the size and getting or setting values in the matrix.
         * Supported storage formats are 'dense' and 'sparse'.
         *
         * Syntax:
         *
         *    math.matrix()                         // creates an empty matrix using default storage format (dense).
         *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
         *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
         *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
         *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
         *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
         *
         * Examples:
         *
         *    let m = math.matrix([[1, 2], [3, 4]])
         *    m.size()                        // Array [2, 2]
         *    m.resize([3, 2], 5)
         *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
         *    m.get([1, 0])                    // number 3
         *
         * See also:
         *
         *    bignumber, boolean, complex, index, number, string, unit, sparse
         *
         * @param {Array | Matrix} [data]    A multi dimensional array
         * @param {string} [format]          The Matrix storage format
         *
         * @return {Matrix} The created matrix
         */
        var matrix = typed('matrix', {
          '': function _() {
            return _create([]);
          },
          'string': function string(format) {
            return _create([], format);
          },
          'string, string': function stringString(format, datatype) {
            return _create([], format, datatype);
          },
          'Array': function Array(data) {
            return _create(data);
          },
          'Matrix': function Matrix(data) {
            return _create(data, data.storage());
          },
          'Array | Matrix, string': _create,
          'Array | Matrix, string, string': _create
        });
        matrix.toTex = {
          0: '\\begin{bmatrix}\\end{bmatrix}',
          1: "\\left(${args[0]}\\right)",
          2: "\\left(${args[0]}\\right)"
        };
        return matrix;
        /**
         * Create a new Matrix with given storage format
         * @param {Array} data
         * @param {string} [format]
         * @param {string} [datatype]
         * @returns {Matrix} Returns a new Matrix
         * @private
         */

        function _create(data, format, datatype) {
          // get storage format constructor
          var M = type.Matrix.storage(format || 'default'); // create instance

          return new M(data, datatype);
        }
      }

      exports.name = 'matrix';
      exports.factory = factory;
      /***/
    },
    /* 47 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "d", function () {
        return getTodayTime;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return getTitleString;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return getTodayTimeStr;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return getMonthName;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "g", function () {
        return syncTime;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return getTimeConfig;
      });
      /* unused harmony export isTimeValidByConfig */

      /* unused harmony export isTimeValid */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "f", function () {
        return isAllowedDate;
      });
      /* harmony import */


      var babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
      /* harmony import */


      var babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14);
      /* harmony import */


      var moment__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);

      var defaultDisabledTime = {
        disabledHours: function disabledHours() {
          return [];
        },
        disabledMinutes: function disabledMinutes() {
          return [];
        },
        disabledSeconds: function disabledSeconds() {
          return [];
        }
      };

      function getTodayTime(value) {
        var today = moment__WEBPACK_IMPORTED_MODULE_1___default()();
        today.locale(value.locale()).utcOffset(value.utcOffset());
        return today;
      }

      function getTitleString(value) {
        return value.format('LL');
      }

      function getTodayTimeStr(value) {
        var today = getTodayTime(value);
        return getTitleString(today);
      }

      function getMonthName(month) {
        var locale = month.locale();
        var localeData = month.localeData();
        return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
      }

      function syncTime(from, to) {
        if (!moment__WEBPACK_IMPORTED_MODULE_1___default.a.isMoment(from) || !moment__WEBPACK_IMPORTED_MODULE_1___default.a.isMoment(to)) return;
        to.hour(from.hour());
        to.minute(from.minute());
        to.second(from.second());
      }

      function getTimeConfig(value, disabledTime) {
        var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
        disabledTimeConfig = babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, defaultDisabledTime, disabledTimeConfig);
        return disabledTimeConfig;
      }

      function isTimeValidByConfig(value, disabledTimeConfig) {
        var invalidTime = false;

        if (value) {
          var hour = value.hour();
          var minutes = value.minute();
          var seconds = value.second();
          var disabledHours = disabledTimeConfig.disabledHours();

          if (disabledHours.indexOf(hour) === -1) {
            var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);

            if (disabledMinutes.indexOf(minutes) === -1) {
              var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
              invalidTime = disabledSeconds.indexOf(seconds) !== -1;
            } else {
              invalidTime = true;
            }
          } else {
            invalidTime = true;
          }
        }

        return !invalidTime;
      }

      function isTimeValid(value, disabledTime) {
        var disabledTimeConfig = getTimeConfig(value, disabledTime);
        return isTimeValidByConfig(value, disabledTimeConfig);
      }

      function isAllowedDate(value, disabledDate, disabledTime) {
        if (disabledDate) {
          if (disabledDate(value)) {
            return false;
          }
        }

        if (disabledTime) {
          if (!isTimeValid(value, disabledTime)) {
            return false;
          }
        }

        return true;
      }
      /***/

    },
    /* 48 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.size = size;
      exports.validate = validate;
      exports.validateIndex = validateIndex;
      exports.resize = resize;
      exports.reshape = reshape;
      exports.squeeze = squeeze;
      exports.unsqueeze = unsqueeze;
      exports.flatten = flatten;
      exports.map = map;
      exports.forEach = forEach;
      exports.filter = filter;
      exports.filterRegExp = filterRegExp;
      exports.join = join;
      exports.identify = identify;
      exports.generalize = generalize;

      var _number = _interopRequireDefault(__webpack_require__(67));

      var _string = _interopRequireDefault(__webpack_require__(79));

      var _DimensionError = _interopRequireDefault(__webpack_require__(92));

      var _IndexError = _interopRequireDefault(__webpack_require__(198));

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          "default": obj
        };
      }
      /**
       * Calculate the size of a multi dimensional array.
       * This function checks the size of the first entry, it does not validate
       * whether all dimensions match. (use function `validate` for that)
       * @param {Array} x
       * @Return {Number[]} size
       */


      function size(x) {
        var s = [];

        while (Array.isArray(x)) {
          s.push(x.length);
          x = x[0];
        }

        return s;
      }
      /**
       * Recursively validate whether each element in a multi dimensional array
       * has a size corresponding to the provided size array.
       * @param {Array} array    Array to be validated
       * @param {number[]} size  Array with the size of each dimension
       * @param {number} dim   Current dimension
       * @throws DimensionError
       * @private
       */


      function _validate(array, size, dim) {
        var i;
        var len = array.length;

        if (len !== size[dim]) {
          throw new _DimensionError["default"](len, size[dim]);
        }

        if (dim < size.length - 1) {
          // recursively validate each child array
          var dimNext = dim + 1;

          for (i = 0; i < len; i++) {
            var child = array[i];

            if (!Array.isArray(child)) {
              throw new _DimensionError["default"](size.length - 1, size.length, '<');
            }

            _validate(array[i], size, dimNext);
          }
        } else {
          // last dimension. none of the childs may be an array
          for (i = 0; i < len; i++) {
            if (Array.isArray(array[i])) {
              throw new _DimensionError["default"](size.length + 1, size.length, '>');
            }
          }
        }
      }
      /**
       * Validate whether each element in a multi dimensional array has
       * a size corresponding to the provided size array.
       * @param {Array} array    Array to be validated
       * @param {number[]} size  Array with the size of each dimension
       * @throws DimensionError
       */


      function validate(array, size) {
        var isScalar = size.length === 0;

        if (isScalar) {
          // scalar
          if (Array.isArray(array)) {
            throw new _DimensionError["default"](array.length, 0);
          }
        } else {
          // array
          _validate(array, size, 0);
        }
      }
      /**
       * Test whether index is an integer number with index >= 0 and index < length
       * when length is provided
       * @param {number} index    Zero-based index
       * @param {number} [length] Length of the array
       */


      function validateIndex(index, length) {
        if (!_number["default"].isNumber(index) || !_number["default"].isInteger(index)) {
          throw new TypeError('Index must be an integer (value: ' + index + ')');
        }

        if (index < 0 || typeof length === 'number' && index >= length) {
          throw new _IndexError["default"](index, length);
        }
      }
      /**
       * Resize a multi dimensional array. The resized array is returned.
       * @param {Array} array         Array to be resized
       * @param {Array.<number>} size Array with the size of each dimension
       * @param {*} [defaultValue=0]  Value to be filled in in new entries,
       *                              zero by default. Specify for example `null`,
       *                              to clearly see entries that are not explicitly
       *                              set.
       * @return {Array} array         The resized array
       */


      function resize(array, size, defaultValue) {
        // TODO: add support for scalars, having size=[] ?
        // check the type of the arguments
        if (!Array.isArray(array) || !Array.isArray(size)) {
          throw new TypeError('Array expected');
        }

        if (size.length === 0) {
          throw new Error('Resizing to scalar is not supported');
        } // check whether size contains positive integers


        size.forEach(function (value) {
          if (!_number["default"].isNumber(value) || !_number["default"].isInteger(value) || value < 0) {
            throw new TypeError('Invalid size, must contain positive integers ' + '(size: ' + _string["default"].format(size) + ')');
          }
        }); // recursively resize the array

        var _defaultValue = defaultValue !== undefined ? defaultValue : 0;

        _resize(array, size, 0, _defaultValue);

        return array;
      }
      /**
       * Recursively resize a multi dimensional array
       * @param {Array} array         Array to be resized
       * @param {number[]} size       Array with the size of each dimension
       * @param {number} dim          Current dimension
       * @param {*} [defaultValue]    Value to be filled in in new entries,
       *                              undefined by default.
       * @private
       */


      function _resize(array, size, dim, defaultValue) {
        var i;
        var elem;
        var oldLen = array.length;
        var newLen = size[dim];
        var minLen = Math.min(oldLen, newLen); // apply new length

        array.length = newLen;

        if (dim < size.length - 1) {
          // non-last dimension
          var dimNext = dim + 1; // resize existing child arrays

          for (i = 0; i < minLen; i++) {
            // resize child array
            elem = array[i];

            if (!Array.isArray(elem)) {
              elem = [elem]; // add a dimension

              array[i] = elem;
            }

            _resize(elem, size, dimNext, defaultValue);
          } // create new child arrays


          for (i = minLen; i < newLen; i++) {
            // get child array
            elem = [];
            array[i] = elem; // resize new child array

            _resize(elem, size, dimNext, defaultValue);
          }
        } else {
          // last dimension
          // remove dimensions of existing values
          for (i = 0; i < minLen; i++) {
            while (Array.isArray(array[i])) {
              array[i] = array[i][0];
            }
          } // fill new elements with the default value


          for (i = minLen; i < newLen; i++) {
            array[i] = defaultValue;
          }
        }
      }
      /**
       * Re-shape a multi dimensional array to fit the specified dimensions
       * @param {Array} array           Array to be reshaped
       * @param {Array.<number>} sizes  List of sizes for each dimension
       * @returns {Array}               Array whose data has been formatted to fit the
       *                                specified dimensions
       *
       * @throws {DimensionError}       If the product of the new dimension sizes does
       *                                not equal that of the old ones
       */


      function reshape(array, sizes) {
        var flatArray = flatten(array);
        var newArray;

        function product(arr) {
          return arr.reduce(function (prev, curr) {
            return prev * curr;
          });
        }

        if (!Array.isArray(array) || !Array.isArray(sizes)) {
          throw new TypeError('Array expected');
        }

        if (sizes.length === 0) {
          throw new _DimensionError["default"](0, product(size(array)), '!=');
        }

        var totalSize = 1;

        for (var sizeIndex = 0; sizeIndex < sizes.length; sizeIndex++) {
          totalSize *= sizes[sizeIndex];
        }

        if (flatArray.length !== totalSize) {
          throw new _DimensionError["default"](product(sizes), product(size(array)), '!=');
        }

        try {
          newArray = _reshape(flatArray, sizes);
        } catch (e) {
          if (e instanceof _DimensionError["default"]) {
            throw new _DimensionError["default"](product(sizes), product(size(array)), '!=');
          }

          throw e;
        }

        return newArray;
      }
      /**
       * Iteratively re-shape a multi dimensional array to fit the specified dimensions
       * @param {Array} array           Array to be reshaped
       * @param {Array.<number>} sizes  List of sizes for each dimension
       * @returns {Array}               Array whose data has been formatted to fit the
       *                                specified dimensions
       */


      function _reshape(array, sizes) {
        // testing if there are enough elements for the requested shape
        var tmpArray = array;
        var tmpArray2; // for each dimensions starting by the last one and ignoring the first one

        for (var sizeIndex = sizes.length - 1; sizeIndex > 0; sizeIndex--) {
          var size = sizes[sizeIndex];
          tmpArray2 = []; // aggregate the elements of the current tmpArray in elements of the requested size

          var length = tmpArray.length / size;

          for (var i = 0; i < length; i++) {
            tmpArray2.push(tmpArray.slice(i * size, (i + 1) * size));
          } // set it as the new tmpArray for the next loop turn or for return


          tmpArray = tmpArray2;
        }

        return tmpArray;
      }
      /**
       * Squeeze a multi dimensional array
       * @param {Array} array
       * @param {Array} [arraySize]
       * @returns {Array} returns the array itself
       */


      function squeeze(array, arraySize) {
        var s = arraySize || size(array); // squeeze outer dimensions

        while (Array.isArray(array) && array.length === 1) {
          array = array[0];
          s.shift();
        } // find the first dimension to be squeezed


        var dims = s.length;

        while (s[dims - 1] === 1) {
          dims--;
        } // squeeze inner dimensions


        if (dims < s.length) {
          array = _squeeze(array, dims, 0);
          s.length = dims;
        }

        return array;
      }
      /**
       * Recursively squeeze a multi dimensional array
       * @param {Array} array
       * @param {number} dims Required number of dimensions
       * @param {number} dim  Current dimension
       * @returns {Array | *} Returns the squeezed array
       * @private
       */


      function _squeeze(array, dims, dim) {
        var i, ii;

        if (dim < dims) {
          var next = dim + 1;

          for (i = 0, ii = array.length; i < ii; i++) {
            array[i] = _squeeze(array[i], dims, next);
          }
        } else {
          while (Array.isArray(array)) {
            array = array[0];
          }
        }

        return array;
      }
      /**
       * Unsqueeze a multi dimensional array: add dimensions when missing
       *
       * Paramter `size` will be mutated to match the new, unqueezed matrix size.
       *
       * @param {Array} array
       * @param {number} dims       Desired number of dimensions of the array
       * @param {number} [outer]    Number of outer dimensions to be added
       * @param {Array} [arraySize] Current size of array.
       * @returns {Array} returns the array itself
       * @private
       */


      function unsqueeze(array, dims, outer, arraySize) {
        var s = arraySize || size(array); // unsqueeze outer dimensions

        if (outer) {
          for (var i = 0; i < outer; i++) {
            array = [array];
            s.unshift(1);
          }
        } // unsqueeze inner dimensions


        array = _unsqueeze(array, dims, 0);

        while (s.length < dims) {
          s.push(1);
        }

        return array;
      }
      /**
       * Recursively unsqueeze a multi dimensional array
       * @param {Array} array
       * @param {number} dims Required number of dimensions
       * @param {number} dim  Current dimension
       * @returns {Array | *} Returns the squeezed array
       * @private
       */


      function _unsqueeze(array, dims, dim) {
        var i, ii;

        if (Array.isArray(array)) {
          var next = dim + 1;

          for (i = 0, ii = array.length; i < ii; i++) {
            array[i] = _unsqueeze(array[i], dims, next);
          }
        } else {
          for (var d = dim; d < dims; d++) {
            array = [array];
          }
        }

        return array;
      }
      /**
       * Flatten a multi dimensional array, put all elements in a one dimensional
       * array
       * @param {Array} array   A multi dimensional array
       * @return {Array}        The flattened array (1 dimensional)
       */


      function flatten(array) {
        if (!Array.isArray(array)) {
          // if not an array, return as is
          return array;
        }

        var flat = [];
        array.forEach(function callback(value) {
          if (Array.isArray(value)) {
            value.forEach(callback); // traverse through sub-arrays recursively
          } else {
            flat.push(value);
          }
        });
        return flat;
      }
      /**
       * A safe map
       * @param {Array} array
       * @param {function} callback
       */


      function map(array, callback) {
        return Array.prototype.map.call(array, callback);
      }
      /**
       * A safe forEach
       * @param {Array} array
       * @param {function} callback
       */


      function forEach(array, callback) {
        Array.prototype.forEach.call(array, callback);
      }
      /**
       * A safe filter
       * @param {Array} array
       * @param {function} callback
       */


      function filter(array, callback) {
        if (size(array).length !== 1) {
          throw new Error('Only one dimensional matrices supported');
        }

        return Array.prototype.filter.call(array, callback);
      }
      /**
       * Filter values in a callback given a regular expression
       * @param {Array} array
       * @param {RegExp} regexp
       * @return {Array} Returns the filtered array
       * @private
       */


      function filterRegExp(array, regexp) {
        if (size(array).length !== 1) {
          throw new Error('Only one dimensional matrices supported');
        }

        return Array.prototype.filter.call(array, function (entry) {
          return regexp.test(entry);
        });
      }
      /**
       * A safe join
       * @param {Array} array
       * @param {string} separator
       */


      function join(array, separator) {
        return Array.prototype.join.call(array, separator);
      }
      /**
       * Assign a numeric identifier to every element of a sorted array
       * @param {Array} a  An array
       * @return {Array} An array of objects containing the original value and its identifier
       */


      function identify(a) {
        if (!Array.isArray(a)) {
          throw new TypeError('Array input expected');
        }

        if (a.length === 0) {
          return a;
        }

        var b = [];
        var count = 0;
        b[0] = {
          value: a[0],
          identifier: 0
        };

        for (var i = 1; i < a.length; i++) {
          if (a[i] === a[i - 1]) {
            count++;
          } else {
            count = 0;
          }

          b.push({
            value: a[i],
            identifier: count
          });
        }

        return b;
      }
      /**
       * Remove the numeric identifier from the elements
       * @param {array} a  An array
       * @return {array} An array of values without identifiers
       */


      function generalize(a) {
        if (!Array.isArray(a)) {
          throw new TypeError('Array input expected');
        }

        if (a.length === 0) {
          return a;
        }

        var b = [];

        for (var i = 0; i < a.length; i++) {
          b.push(a[i].value);
        }

        return b;
      }
      /***/

    },
    /* 49 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _iterator = __webpack_require__(1163);

      var _iterator2 = _interopRequireDefault(_iterator);

      var _symbol = __webpack_require__(1154);

      var _symbol2 = _interopRequireDefault(_symbol);

      var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
      };

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
        return typeof obj === "undefined" ? "undefined" : _typeof(obj);
      } : function (obj) {
        return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
      };
      /***/
    },
    /* 50 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return NavigationDirection;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return pageValidation;
      });
      /* harmony import */


      var react_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(143);
      /* harmony import */


      var react_scroll__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react_scroll__WEBPACK_IMPORTED_MODULE_0__);

      var NavigationDirection = {
        Next: 'Next',
        Prev: 'Prev',
        // NewFlow is used when the user input changes the page flow
        NewFlow: 'NewFlow'
      };
      /**
       * Returns whether the page has failed validation.
       * Sets display errors and scrolls to the first field where it has an error.
       */

      var pageValidation = function pageValidation() {
        var visibleFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var formBehaviours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var smallestIndex = Number.MAX_SAFE_INTEGER;
        var fieldIdWithSmallestIndex;
        var isPageValid = true;
        Object.keys(visibleFields).forEach(function (fieldId) {
          var validateResult = visibleFields[fieldId].validate && visibleFields[fieldId].validate(undefined, true);

          if (validateResult && !validateResult.isValid) {
            isPageValid = false;

            if (visibleFields[fieldId].fieldIndexInForm < smallestIndex) {
              smallestIndex = visibleFields[fieldId].fieldIndexInForm;
              fieldIdWithSmallestIndex = fieldId;
            }
          }
        });
        var scrollOnFieldError = formBehaviours.scrollOnFieldError,
            scrollAnimation = formBehaviours.scrollAnimation,
            scrollDuration = formBehaviours.scrollDuration,
            scrollOffsetPage = formBehaviours.scrollOffsetPage;

        if (scrollOnFieldError && !isPageValid) {
          react_scroll__WEBPACK_IMPORTED_MODULE_0__["scroller"].scrollTo(fieldIdWithSmallestIndex, {
            duration: scrollDuration,
            delay: 0,
            smooth: scrollAnimation,
            offset: scrollOffsetPage
          });
        }

        return isPageValid;
      };
      /***/

    },
    /* 51 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      /**
       * Use invariant() to assert state which your program assumes to be true.
       *
       * Provide sprintf-style format (only %s is supported) and arguments
       * to provide information about what broke and what you were
       * expecting.
       *
       * The invariant message will be stripped in production, but the invariant
       * will remain to ensure logic does not differ in production.
       */

      var validateFormat = function validateFormat(format) {};

      if (false) {}

      function invariant(condition, format, a, b, c, d, e, f) {
        validateFormat(format);

        if (!condition) {
          var error;

          if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
          } else {
            var args = [a, b, c, d, e, f];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function () {
              return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
          }

          error.framesToPop = 1; // we don't care about invariant's own frame

          throw error;
        }
      }

      module.exports = invariant;
      /***/
    },
    /* 52 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseSet = __webpack_require__(506);
      /**
       * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
       * it's created. Arrays are created for missing index properties while objects
       * are created for all other missing properties. Use `_.setWith` to customize
       * `path` creation.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.set(object, 'a[0].b.c', 4);
       * console.log(object.a[0].b.c);
       * // => 4
       *
       * _.set(object, ['x', '0', 'y', 'z'], 5);
       * console.log(object.x[0].y.z);
       * // => 5
       */


      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }

      module.exports = set;
      /***/
    },
    /* 53 */

    /***/
    function (module, exports, __webpack_require__) {
      /**
       *  Copyright (c) 2014-2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */
      (function (global, factory) {
        true ? module.exports = factory() : undefined;
      })(this, function () {
        'use strict';

        var SLICE$0 = Array.prototype.slice;

        function createClass(ctor, superClass) {
          if (superClass) {
            ctor.prototype = Object.create(superClass.prototype);
          }

          ctor.prototype.constructor = ctor;
        }

        function Iterable(value) {
          return isIterable(value) ? value : Seq(value);
        }

        createClass(KeyedIterable, Iterable);

        function KeyedIterable(value) {
          return isKeyed(value) ? value : KeyedSeq(value);
        }

        createClass(IndexedIterable, Iterable);

        function IndexedIterable(value) {
          return isIndexed(value) ? value : IndexedSeq(value);
        }

        createClass(SetIterable, Iterable);

        function SetIterable(value) {
          return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
        }

        function isIterable(maybeIterable) {
          return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
        }

        function isKeyed(maybeKeyed) {
          return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
        }

        function isIndexed(maybeIndexed) {
          return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
        }

        function isAssociative(maybeAssociative) {
          return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
        }

        function isOrdered(maybeOrdered) {
          return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
        }

        Iterable.isIterable = isIterable;
        Iterable.isKeyed = isKeyed;
        Iterable.isIndexed = isIndexed;
        Iterable.isAssociative = isAssociative;
        Iterable.isOrdered = isOrdered;
        Iterable.Keyed = KeyedIterable;
        Iterable.Indexed = IndexedIterable;
        Iterable.Set = SetIterable;
        var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
        var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
        var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
        var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@'; // Used for setting prototype methods that IE8 chokes on.

        var DELETE = 'delete'; // Constants describing the size of trie nodes.

        var SHIFT = 5; // Resulted in best performance after ______?

        var SIZE = 1 << SHIFT;
        var MASK = SIZE - 1; // A consistent shared value representing "not set" which equals nothing other
        // than itself, and nothing that could be provided externally.

        var NOT_SET = {}; // Boolean references, Rough equivalent of `bool &`.

        var CHANGE_LENGTH = {
          value: false
        };
        var DID_ALTER = {
          value: false
        };

        function MakeRef(ref) {
          ref.value = false;
          return ref;
        }

        function SetRef(ref) {
          ref && (ref.value = true);
        } // A function which returns a value representing an "owner" for transient writes
        // to tries. The return value will only ever equal itself, and will not equal
        // the return of any subsequent call of this function.


        function OwnerID() {} // http://jsperf.com/copy-array-inline


        function arrCopy(arr, offset) {
          offset = offset || 0;
          var len = Math.max(0, arr.length - offset);
          var newArr = new Array(len);

          for (var ii = 0; ii < len; ii++) {
            newArr[ii] = arr[ii + offset];
          }

          return newArr;
        }

        function ensureSize(iter) {
          if (iter.size === undefined) {
            iter.size = iter.__iterate(returnTrue);
          }

          return iter.size;
        }

        function wrapIndex(iter, index) {
          // This implements "is array index" which the ECMAString spec defines as:
          //
          //     A String property name P is an array index if and only if
          //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
          //     to 2^32−1.
          //
          // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
          if (typeof index !== 'number') {
            var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32

            if ('' + uint32Index !== index || uint32Index === 4294967295) {
              return NaN;
            }

            index = uint32Index;
          }

          return index < 0 ? ensureSize(iter) + index : index;
        }

        function returnTrue() {
          return true;
        }

        function wholeSlice(begin, end, size) {
          return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
        }

        function resolveBegin(begin, size) {
          return resolveIndex(begin, size, 0);
        }

        function resolveEnd(end, size) {
          return resolveIndex(end, size, size);
        }

        function resolveIndex(index, size, defaultIndex) {
          return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
        }
        /* global Symbol */


        var ITERATE_KEYS = 0;
        var ITERATE_VALUES = 1;
        var ITERATE_ENTRIES = 2;
        var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = '@@iterator';
        var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;

        function Iterator(next) {
          this.next = next;
        }

        Iterator.prototype.toString = function () {
          return '[Iterator]';
        };

        Iterator.KEYS = ITERATE_KEYS;
        Iterator.VALUES = ITERATE_VALUES;
        Iterator.ENTRIES = ITERATE_ENTRIES;

        Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
          return this.toString();
        };

        Iterator.prototype[ITERATOR_SYMBOL] = function () {
          return this;
        };

        function iteratorValue(type, k, v, iteratorResult) {
          var value = type === 0 ? k : type === 1 ? v : [k, v];
          iteratorResult ? iteratorResult.value = value : iteratorResult = {
            value: value,
            done: false
          };
          return iteratorResult;
        }

        function iteratorDone() {
          return {
            value: undefined,
            done: true
          };
        }

        function hasIterator(maybeIterable) {
          return !!getIteratorFn(maybeIterable);
        }

        function isIterator(maybeIterator) {
          return maybeIterator && typeof maybeIterator.next === 'function';
        }

        function getIterator(iterable) {
          var iteratorFn = getIteratorFn(iterable);
          return iteratorFn && iteratorFn.call(iterable);
        }

        function getIteratorFn(iterable) {
          var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);

          if (typeof iteratorFn === 'function') {
            return iteratorFn;
          }
        }

        function isArrayLike(value) {
          return value && typeof value.length === 'number';
        }

        createClass(Seq, Iterable);

        function Seq(value) {
          return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
        }

        Seq.of = function ()
        /*...values*/
        {
          return Seq(arguments);
        };

        Seq.prototype.toSeq = function () {
          return this;
        };

        Seq.prototype.toString = function () {
          return this.__toString('Seq {', '}');
        };

        Seq.prototype.cacheResult = function () {
          if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
          }

          return this;
        }; // abstract __iterateUncached(fn, reverse)


        Seq.prototype.__iterate = function (fn, reverse) {
          return seqIterate(this, fn, reverse, true);
        }; // abstract __iteratorUncached(type, reverse)


        Seq.prototype.__iterator = function (type, reverse) {
          return seqIterator(this, type, reverse, true);
        };

        createClass(KeyedSeq, Seq);

        function KeyedSeq(value) {
          return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
        }

        KeyedSeq.prototype.toKeyedSeq = function () {
          return this;
        };

        createClass(IndexedSeq, Seq);

        function IndexedSeq(value) {
          return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
        }

        IndexedSeq.of = function ()
        /*...values*/
        {
          return IndexedSeq(arguments);
        };

        IndexedSeq.prototype.toIndexedSeq = function () {
          return this;
        };

        IndexedSeq.prototype.toString = function () {
          return this.__toString('Seq [', ']');
        };

        IndexedSeq.prototype.__iterate = function (fn, reverse) {
          return seqIterate(this, fn, reverse, false);
        };

        IndexedSeq.prototype.__iterator = function (type, reverse) {
          return seqIterator(this, type, reverse, false);
        };

        createClass(SetSeq, Seq);

        function SetSeq(value) {
          return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
        }

        SetSeq.of = function ()
        /*...values*/
        {
          return SetSeq(arguments);
        };

        SetSeq.prototype.toSetSeq = function () {
          return this;
        };

        Seq.isSeq = isSeq;
        Seq.Keyed = KeyedSeq;
        Seq.Set = SetSeq;
        Seq.Indexed = IndexedSeq;
        var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
        Seq.prototype[IS_SEQ_SENTINEL] = true;
        createClass(ArraySeq, IndexedSeq);

        function ArraySeq(array) {
          this._array = array;
          this.size = array.length;
        }

        ArraySeq.prototype.get = function (index, notSetValue) {
          return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
        };

        ArraySeq.prototype.__iterate = function (fn, reverse) {
          var array = this._array;
          var maxIndex = array.length - 1;

          for (var ii = 0; ii <= maxIndex; ii++) {
            if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
              return ii + 1;
            }
          }

          return ii;
        };

        ArraySeq.prototype.__iterator = function (type, reverse) {
          var array = this._array;
          var maxIndex = array.length - 1;
          var ii = 0;
          return new Iterator(function () {
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
          });
        };

        createClass(ObjectSeq, KeyedSeq);

        function ObjectSeq(object) {
          var keys = Object.keys(object);
          this._object = object;
          this._keys = keys;
          this.size = keys.length;
        }

        ObjectSeq.prototype.get = function (key, notSetValue) {
          if (notSetValue !== undefined && !this.has(key)) {
            return notSetValue;
          }

          return this._object[key];
        };

        ObjectSeq.prototype.has = function (key) {
          return this._object.hasOwnProperty(key);
        };

        ObjectSeq.prototype.__iterate = function (fn, reverse) {
          var object = this._object;
          var keys = this._keys;
          var maxIndex = keys.length - 1;

          for (var ii = 0; ii <= maxIndex; ii++) {
            var key = keys[reverse ? maxIndex - ii : ii];

            if (fn(object[key], key, this) === false) {
              return ii + 1;
            }
          }

          return ii;
        };

        ObjectSeq.prototype.__iterator = function (type, reverse) {
          var object = this._object;
          var keys = this._keys;
          var maxIndex = keys.length - 1;
          var ii = 0;
          return new Iterator(function () {
            var key = keys[reverse ? maxIndex - ii : ii];
            return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
          });
        };

        ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
        createClass(IterableSeq, IndexedSeq);

        function IterableSeq(iterable) {
          this._iterable = iterable;
          this.size = iterable.length || iterable.size;
        }

        IterableSeq.prototype.__iterateUncached = function (fn, reverse) {
          if (reverse) {
            return this.cacheResult().__iterate(fn, reverse);
          }

          var iterable = this._iterable;
          var iterator = getIterator(iterable);
          var iterations = 0;

          if (isIterator(iterator)) {
            var step;

            while (!(step = iterator.next()).done) {
              if (fn(step.value, iterations++, this) === false) {
                break;
              }
            }
          }

          return iterations;
        };

        IterableSeq.prototype.__iteratorUncached = function (type, reverse) {
          if (reverse) {
            return this.cacheResult().__iterator(type, reverse);
          }

          var iterable = this._iterable;
          var iterator = getIterator(iterable);

          if (!isIterator(iterator)) {
            return new Iterator(iteratorDone);
          }

          var iterations = 0;
          return new Iterator(function () {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
          });
        };

        createClass(IteratorSeq, IndexedSeq);

        function IteratorSeq(iterator) {
          this._iterator = iterator;
          this._iteratorCache = [];
        }

        IteratorSeq.prototype.__iterateUncached = function (fn, reverse) {
          if (reverse) {
            return this.cacheResult().__iterate(fn, reverse);
          }

          var iterator = this._iterator;
          var cache = this._iteratorCache;
          var iterations = 0;

          while (iterations < cache.length) {
            if (fn(cache[iterations], iterations++, this) === false) {
              return iterations;
            }
          }

          var step;

          while (!(step = iterator.next()).done) {
            var val = step.value;
            cache[iterations] = val;

            if (fn(val, iterations++, this) === false) {
              break;
            }
          }

          return iterations;
        };

        IteratorSeq.prototype.__iteratorUncached = function (type, reverse) {
          if (reverse) {
            return this.cacheResult().__iterator(type, reverse);
          }

          var iterator = this._iterator;
          var cache = this._iteratorCache;
          var iterations = 0;
          return new Iterator(function () {
            if (iterations >= cache.length) {
              var step = iterator.next();

              if (step.done) {
                return step;
              }

              cache[iterations] = step.value;
            }

            return iteratorValue(type, iterations, cache[iterations++]);
          });
        }; // # pragma Helper functions


        function isSeq(maybeSeq) {
          return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
        }

        var EMPTY_SEQ;

        function emptySequence() {
          return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
        }

        function keyedSeqFromValue(value) {
          var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === 'object' ? new ObjectSeq(value) : undefined;

          if (!seq) {
            throw new TypeError('Expected Array or iterable object of [k, v] entries, ' + 'or keyed object: ' + value);
          }

          return seq;
        }

        function indexedSeqFromValue(value) {
          var seq = maybeIndexedSeqFromValue(value);

          if (!seq) {
            throw new TypeError('Expected Array or iterable object of values: ' + value);
          }

          return seq;
        }

        function seqFromValue(value) {
          var seq = maybeIndexedSeqFromValue(value) || typeof value === 'object' && new ObjectSeq(value);

          if (!seq) {
            throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
          }

          return seq;
        }

        function maybeIndexedSeqFromValue(value) {
          return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
        }

        function seqIterate(seq, fn, reverse, useKeys) {
          var cache = seq._cache;

          if (cache) {
            var maxIndex = cache.length - 1;

            for (var ii = 0; ii <= maxIndex; ii++) {
              var entry = cache[reverse ? maxIndex - ii : ii];

              if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
                return ii + 1;
              }
            }

            return ii;
          }

          return seq.__iterateUncached(fn, reverse);
        }

        function seqIterator(seq, type, reverse, useKeys) {
          var cache = seq._cache;

          if (cache) {
            var maxIndex = cache.length - 1;
            var ii = 0;
            return new Iterator(function () {
              var entry = cache[reverse ? maxIndex - ii : ii];
              return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
            });
          }

          return seq.__iteratorUncached(type, reverse);
        }

        function fromJS(json, converter) {
          return converter ? fromJSWith(converter, json, '', {
            '': json
          }) : fromJSDefault(json);
        }

        function fromJSWith(converter, json, key, parentJSON) {
          if (Array.isArray(json)) {
            return converter.call(parentJSON, key, IndexedSeq(json).map(function (v, k) {
              return fromJSWith(converter, v, k, json);
            }));
          }

          if (isPlainObj(json)) {
            return converter.call(parentJSON, key, KeyedSeq(json).map(function (v, k) {
              return fromJSWith(converter, v, k, json);
            }));
          }

          return json;
        }

        function fromJSDefault(json) {
          if (Array.isArray(json)) {
            return IndexedSeq(json).map(fromJSDefault).toList();
          }

          if (isPlainObj(json)) {
            return KeyedSeq(json).map(fromJSDefault).toMap();
          }

          return json;
        }

        function isPlainObj(value) {
          return value && (value.constructor === Object || value.constructor === undefined);
        }
        /**
         * An extension of the "same-value" algorithm as [described for use by ES6 Map
         * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
         *
         * NaN is considered the same as NaN, however -0 and 0 are considered the same
         * value, which is different from the algorithm described by
         * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
         *
         * This is extended further to allow Objects to describe the values they
         * represent, by way of `valueOf` or `equals` (and `hashCode`).
         *
         * Note: because of this extension, the key equality of Immutable.Map and the
         * value equality of Immutable.Set will differ from ES6 Map and Set.
         *
         * ### Defining custom values
         *
         * The easiest way to describe the value an object represents is by implementing
         * `valueOf`. For example, `Date` represents a value by returning a unix
         * timestamp for `valueOf`:
         *
         *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
         *     var date2 = new Date(1234567890000);
         *     date1.valueOf(); // 1234567890000
         *     assert( date1 !== date2 );
         *     assert( Immutable.is( date1, date2 ) );
         *
         * Note: overriding `valueOf` may have other implications if you use this object
         * where JavaScript expects a primitive, such as implicit string coercion.
         *
         * For more complex types, especially collections, implementing `valueOf` may
         * not be performant. An alternative is to implement `equals` and `hashCode`.
         *
         * `equals` takes another object, presumably of similar type, and returns true
         * if the it is equal. Equality is symmetrical, so the same result should be
         * returned if this and the argument are flipped.
         *
         *     assert( a.equals(b) === b.equals(a) );
         *
         * `hashCode` returns a 32bit integer number representing the object which will
         * be used to determine how to store the value object in a Map or Set. You must
         * provide both or neither methods, one must not exist without the other.
         *
         * Also, an important relationship between these methods must be upheld: if two
         * values are equal, they *must* return the same hashCode. If the values are not
         * equal, they might have the same hashCode; this is called a hash collision,
         * and while undesirable for performance reasons, it is acceptable.
         *
         *     if (a.equals(b)) {
         *       assert( a.hashCode() === b.hashCode() );
         *     }
         *
         * All Immutable collections implement `equals` and `hashCode`.
         *
         */


        function is(valueA, valueB) {
          if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
            return true;
          }

          if (!valueA || !valueB) {
            return false;
          }

          if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
            valueA = valueA.valueOf();
            valueB = valueB.valueOf();

            if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
              return true;
            }

            if (!valueA || !valueB) {
              return false;
            }
          }

          if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) {
            return true;
          }

          return false;
        }

        function deepEqual(a, b) {
          if (a === b) {
            return true;
          }

          if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) {
            return false;
          }

          if (a.size === 0 && b.size === 0) {
            return true;
          }

          var notAssociative = !isAssociative(a);

          if (isOrdered(a)) {
            var entries = a.entries();
            return b.every(function (v, k) {
              var entry = entries.next().value;
              return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
            }) && entries.next().done;
          }

          var flipped = false;

          if (a.size === undefined) {
            if (b.size === undefined) {
              if (typeof a.cacheResult === 'function') {
                a.cacheResult();
              }
            } else {
              flipped = true;
              var _ = a;
              a = b;
              b = _;
            }
          }

          var allEqual = true;

          var bSize = b.__iterate(function (v, k) {
            if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
              allEqual = false;
              return false;
            }
          });

          return allEqual && a.size === bSize;
        }

        createClass(Repeat, IndexedSeq);

        function Repeat(value, times) {
          if (!(this instanceof Repeat)) {
            return new Repeat(value, times);
          }

          this._value = value;
          this.size = times === undefined ? Infinity : Math.max(0, times);

          if (this.size === 0) {
            if (EMPTY_REPEAT) {
              return EMPTY_REPEAT;
            }

            EMPTY_REPEAT = this;
          }
        }

        Repeat.prototype.toString = function () {
          if (this.size === 0) {
            return 'Repeat []';
          }

          return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
        };

        Repeat.prototype.get = function (index, notSetValue) {
          return this.has(index) ? this._value : notSetValue;
        };

        Repeat.prototype.includes = function (searchValue) {
          return is(this._value, searchValue);
        };

        Repeat.prototype.slice = function (begin, end) {
          var size = this.size;
          return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
        };

        Repeat.prototype.reverse = function () {
          return this;
        };

        Repeat.prototype.indexOf = function (searchValue) {
          if (is(this._value, searchValue)) {
            return 0;
          }

          return -1;
        };

        Repeat.prototype.lastIndexOf = function (searchValue) {
          if (is(this._value, searchValue)) {
            return this.size;
          }

          return -1;
        };

        Repeat.prototype.__iterate = function (fn, reverse) {
          for (var ii = 0; ii < this.size; ii++) {
            if (fn(this._value, ii, this) === false) {
              return ii + 1;
            }
          }

          return ii;
        };

        Repeat.prototype.__iterator = function (type, reverse) {
          var this$0 = this;
          var ii = 0;
          return new Iterator(function () {
            return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
          });
        };

        Repeat.prototype.equals = function (other) {
          return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
        };

        var EMPTY_REPEAT;

        function invariant(condition, error) {
          if (!condition) throw new Error(error);
        }

        createClass(Range, IndexedSeq);

        function Range(start, end, step) {
          if (!(this instanceof Range)) {
            return new Range(start, end, step);
          }

          invariant(step !== 0, 'Cannot step a Range by 0');
          start = start || 0;

          if (end === undefined) {
            end = Infinity;
          }

          step = step === undefined ? 1 : Math.abs(step);

          if (end < start) {
            step = -step;
          }

          this._start = start;
          this._end = end;
          this._step = step;
          this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);

          if (this.size === 0) {
            if (EMPTY_RANGE) {
              return EMPTY_RANGE;
            }

            EMPTY_RANGE = this;
          }
        }

        Range.prototype.toString = function () {
          if (this.size === 0) {
            return 'Range []';
          }

          return 'Range [ ' + this._start + '...' + this._end + (this._step > 1 ? ' by ' + this._step : '') + ' ]';
        };

        Range.prototype.get = function (index, notSetValue) {
          return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
        };

        Range.prototype.includes = function (searchValue) {
          var possibleIndex = (searchValue - this._start) / this._step;
          return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
        };

        Range.prototype.slice = function (begin, end) {
          if (wholeSlice(begin, end, this.size)) {
            return this;
          }

          begin = resolveBegin(begin, this.size);
          end = resolveEnd(end, this.size);

          if (end <= begin) {
            return new Range(0, 0);
          }

          return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
        };

        Range.prototype.indexOf = function (searchValue) {
          var offsetValue = searchValue - this._start;

          if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;

            if (index >= 0 && index < this.size) {
              return index;
            }
          }

          return -1;
        };

        Range.prototype.lastIndexOf = function (searchValue) {
          return this.indexOf(searchValue);
        };

        Range.prototype.__iterate = function (fn, reverse) {
          var maxIndex = this.size - 1;
          var step = this._step;
          var value = reverse ? this._start + maxIndex * step : this._start;

          for (var ii = 0; ii <= maxIndex; ii++) {
            if (fn(value, ii, this) === false) {
              return ii + 1;
            }

            value += reverse ? -step : step;
          }

          return ii;
        };

        Range.prototype.__iterator = function (type, reverse) {
          var maxIndex = this.size - 1;
          var step = this._step;
          var value = reverse ? this._start + maxIndex * step : this._start;
          var ii = 0;
          return new Iterator(function () {
            var v = value;
            value += reverse ? -step : step;
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
          });
        };

        Range.prototype.equals = function (other) {
          return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
        };

        var EMPTY_RANGE;
        createClass(Collection, Iterable);

        function Collection() {
          throw TypeError('Abstract');
        }

        createClass(KeyedCollection, Collection);

        function KeyedCollection() {}

        createClass(IndexedCollection, Collection);

        function IndexedCollection() {}

        createClass(SetCollection, Collection);

        function SetCollection() {}

        Collection.Keyed = KeyedCollection;
        Collection.Indexed = IndexedCollection;
        Collection.Set = SetCollection;
        var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
          a = a | 0; // int

          b = b | 0; // int

          var c = a & 0xffff;
          var d = b & 0xffff; // Shift by 0 fixes the sign on the high part.

          return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
        }; // v8 has an optimization for storing 31-bit signed numbers.
        // Values which have either 00 or 11 as the high order bits qualify.
        // This function drops the highest order bit in a signed number, maintaining
        // the sign bit.

        function smi(i32) {
          return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
        }

        function hash(o) {
          if (o === false || o === null || o === undefined) {
            return 0;
          }

          if (typeof o.valueOf === 'function') {
            o = o.valueOf();

            if (o === false || o === null || o === undefined) {
              return 0;
            }
          }

          if (o === true) {
            return 1;
          }

          var type = typeof o;

          if (type === 'number') {
            var h = o | 0;

            if (h !== o) {
              h ^= o * 0xFFFFFFFF;
            }

            while (o > 0xFFFFFFFF) {
              o /= 0xFFFFFFFF;
              h ^= o;
            }

            return smi(h);
          }

          if (type === 'string') {
            return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
          }

          if (typeof o.hashCode === 'function') {
            return o.hashCode();
          }

          if (type === 'object') {
            return hashJSObj(o);
          }

          if (typeof o.toString === 'function') {
            return hashString(o.toString());
          }

          throw new Error('Value type ' + type + ' cannot be hashed.');
        }

        function cachedHashString(string) {
          var hash = stringHashCache[string];

          if (hash === undefined) {
            hash = hashString(string);

            if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
              STRING_HASH_CACHE_SIZE = 0;
              stringHashCache = {};
            }

            STRING_HASH_CACHE_SIZE++;
            stringHashCache[string] = hash;
          }

          return hash;
        } // http://jsperf.com/hashing-strings


        function hashString(string) {
          // This is the hash from JVM
          // The hash code for a string is computed as
          // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
          // where s[i] is the ith character of the string and n is the length of
          // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
          // (exclusive) by dropping high bits.
          var hash = 0;

          for (var ii = 0; ii < string.length; ii++) {
            hash = 31 * hash + string.charCodeAt(ii) | 0;
          }

          return smi(hash);
        }

        function hashJSObj(obj) {
          var hash;

          if (usingWeakMap) {
            hash = weakMap.get(obj);

            if (hash !== undefined) {
              return hash;
            }
          }

          hash = obj[UID_HASH_KEY];

          if (hash !== undefined) {
            return hash;
          }

          if (!canDefineProperty) {
            hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];

            if (hash !== undefined) {
              return hash;
            }

            hash = getIENodeHash(obj);

            if (hash !== undefined) {
              return hash;
            }
          }

          hash = ++objHashUID;

          if (objHashUID & 0x40000000) {
            objHashUID = 0;
          }

          if (usingWeakMap) {
            weakMap.set(obj, hash);
          } else if (isExtensible !== undefined && isExtensible(obj) === false) {
            throw new Error('Non-extensible objects are not allowed as keys.');
          } else if (canDefineProperty) {
            Object.defineProperty(obj, UID_HASH_KEY, {
              'enumerable': false,
              'configurable': false,
              'writable': false,
              'value': hash
            });
          } else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
            // Since we can't define a non-enumerable property on the object
            // we'll hijack one of the less-used non-enumerable properties to
            // save our hash on it. Since this is a function it will not show up in
            // `JSON.stringify` which is what we want.
            obj.propertyIsEnumerable = function () {
              return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            };

            obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
          } else if (obj.nodeType !== undefined) {
            // At this point we couldn't get the IE `uniqueID` to use as a hash
            // and we couldn't use a non-enumerable property to exploit the
            // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
            // itself.
            obj[UID_HASH_KEY] = hash;
          } else {
            throw new Error('Unable to set a non-enumerable property on object.');
          }

          return hash;
        } // Get references to ES5 object methods.


        var isExtensible = Object.isExtensible; // True if Object.defineProperty works as expected. IE8 fails this test.

        var canDefineProperty = function () {
          try {
            Object.defineProperty({}, '@', {});
            return true;
          } catch (e) {
            return false;
          }
        }(); // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
        // and avoid memory leaks from the IE cloneNode bug.


        function getIENodeHash(node) {
          if (node && node.nodeType > 0) {
            switch (node.nodeType) {
              case 1:
                // Element
                return node.uniqueID;

              case 9:
                // Document
                return node.documentElement && node.documentElement.uniqueID;
            }
          }
        } // If possible, use a WeakMap.


        var usingWeakMap = typeof WeakMap === 'function';
        var weakMap;

        if (usingWeakMap) {
          weakMap = new WeakMap();
        }

        var objHashUID = 0;
        var UID_HASH_KEY = '__immutablehash__';

        if (typeof Symbol === 'function') {
          UID_HASH_KEY = Symbol(UID_HASH_KEY);
        }

        var STRING_HASH_CACHE_MIN_STRLEN = 16;
        var STRING_HASH_CACHE_MAX_SIZE = 255;
        var STRING_HASH_CACHE_SIZE = 0;
        var stringHashCache = {};

        function assertNotInfinite(size) {
          invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
        }

        createClass(Map, KeyedCollection); // @pragma Construction

        function Map(value) {
          return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function (map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v, k) {
              return map.set(k, v);
            });
          });
        }

        Map.prototype.toString = function () {
          return this.__toString('Map {', '}');
        }; // @pragma Access


        Map.prototype.get = function (k, notSetValue) {
          return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
        }; // @pragma Modification


        Map.prototype.set = function (k, v) {
          return updateMap(this, k, v);
        };

        Map.prototype.setIn = function (keyPath, v) {
          return this.updateIn(keyPath, NOT_SET, function () {
            return v;
          });
        };

        Map.prototype.remove = function (k) {
          return updateMap(this, k, NOT_SET);
        };

        Map.prototype.deleteIn = function (keyPath) {
          return this.updateIn(keyPath, function () {
            return NOT_SET;
          });
        };

        Map.prototype.update = function (k, notSetValue, updater) {
          return arguments.length === 1 ? k(this) : this.updateIn([k], notSetValue, updater);
        };

        Map.prototype.updateIn = function (keyPath, notSetValue, updater) {
          if (!updater) {
            updater = notSetValue;
            notSetValue = undefined;
          }

          var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
          return updatedValue === NOT_SET ? undefined : updatedValue;
        };

        Map.prototype.clear = function () {
          if (this.size === 0) {
            return this;
          }

          if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return emptyMap();
        }; // @pragma Composition


        Map.prototype.merge = function ()
        /*...iters*/
        {
          return mergeIntoMapWith(this, undefined, arguments);
        };

        Map.prototype.mergeWith = function (merger) {
          var iters = SLICE$0.call(arguments, 1);
          return mergeIntoMapWith(this, merger, iters);
        };

        Map.prototype.mergeIn = function (keyPath) {
          var iters = SLICE$0.call(arguments, 1);
          return this.updateIn(keyPath, emptyMap(), function (m) {
            return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
          });
        };

        Map.prototype.mergeDeep = function ()
        /*...iters*/
        {
          return mergeIntoMapWith(this, deepMerger, arguments);
        };

        Map.prototype.mergeDeepWith = function (merger) {
          var iters = SLICE$0.call(arguments, 1);
          return mergeIntoMapWith(this, deepMergerWith(merger), iters);
        };

        Map.prototype.mergeDeepIn = function (keyPath) {
          var iters = SLICE$0.call(arguments, 1);
          return this.updateIn(keyPath, emptyMap(), function (m) {
            return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
          });
        };

        Map.prototype.sort = function (comparator) {
          // Late binding
          return OrderedMap(sortFactory(this, comparator));
        };

        Map.prototype.sortBy = function (mapper, comparator) {
          // Late binding
          return OrderedMap(sortFactory(this, comparator, mapper));
        }; // @pragma Mutability


        Map.prototype.withMutations = function (fn) {
          var mutable = this.asMutable();
          fn(mutable);
          return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
        };

        Map.prototype.asMutable = function () {
          return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
        };

        Map.prototype.asImmutable = function () {
          return this.__ensureOwner();
        };

        Map.prototype.wasAltered = function () {
          return this.__altered;
        };

        Map.prototype.__iterator = function (type, reverse) {
          return new MapIterator(this, type, reverse);
        };

        Map.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          var iterations = 0;
          this._root && this._root.iterate(function (entry) {
            iterations++;
            return fn(entry[1], entry[0], this$0);
          }, reverse);
          return iterations;
        };

        Map.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
          }

          return makeMap(this.size, this._root, ownerID, this.__hash);
        };

        function isMap(maybeMap) {
          return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
        }

        Map.isMap = isMap;
        var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
        var MapPrototype = Map.prototype;
        MapPrototype[IS_MAP_SENTINEL] = true;
        MapPrototype[DELETE] = MapPrototype.remove;
        MapPrototype.removeIn = MapPrototype.deleteIn; // #pragma Trie Nodes

        function ArrayMapNode(ownerID, entries) {
          this.ownerID = ownerID;
          this.entries = entries;
        }

        ArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
          var entries = this.entries;

          for (var ii = 0, len = entries.length; ii < len; ii++) {
            if (is(key, entries[ii][0])) {
              return entries[ii][1];
            }
          }

          return notSetValue;
        };

        ArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          var removed = value === NOT_SET;
          var entries = this.entries;
          var idx = 0;

          for (var len = entries.length; idx < len; idx++) {
            if (is(key, entries[idx][0])) {
              break;
            }
          }

          var exists = idx < len;

          if (exists ? entries[idx][1] === value : removed) {
            return this;
          }

          SetRef(didAlter);
          (removed || !exists) && SetRef(didChangeSize);

          if (removed && entries.length === 1) {
            return; // undefined
          }

          if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
            return createNodes(ownerID, entries, key, value);
          }

          var isEditable = ownerID && ownerID === this.ownerID;
          var newEntries = isEditable ? entries : arrCopy(entries);

          if (exists) {
            if (removed) {
              idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            } else {
              newEntries[idx] = [key, value];
            }
          } else {
            newEntries.push([key, value]);
          }

          if (isEditable) {
            this.entries = newEntries;
            return this;
          }

          return new ArrayMapNode(ownerID, newEntries);
        };

        function BitmapIndexedNode(ownerID, bitmap, nodes) {
          this.ownerID = ownerID;
          this.bitmap = bitmap;
          this.nodes = nodes;
        }

        BitmapIndexedNode.prototype.get = function (shift, keyHash, key, notSetValue) {
          if (keyHash === undefined) {
            keyHash = hash(key);
          }

          var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
          var bitmap = this.bitmap;
          return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
        };

        BitmapIndexedNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          if (keyHash === undefined) {
            keyHash = hash(key);
          }

          var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
          var bit = 1 << keyHashFrag;
          var bitmap = this.bitmap;
          var exists = (bitmap & bit) !== 0;

          if (!exists && value === NOT_SET) {
            return this;
          }

          var idx = popCount(bitmap & bit - 1);
          var nodes = this.nodes;
          var node = exists ? nodes[idx] : undefined;
          var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

          if (newNode === node) {
            return this;
          }

          if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
            return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
          }

          if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
            return nodes[idx ^ 1];
          }

          if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
            return newNode;
          }

          var isEditable = ownerID && ownerID === this.ownerID;
          var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
          var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);

          if (isEditable) {
            this.bitmap = newBitmap;
            this.nodes = newNodes;
            return this;
          }

          return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
        };

        function HashArrayMapNode(ownerID, count, nodes) {
          this.ownerID = ownerID;
          this.count = count;
          this.nodes = nodes;
        }

        HashArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
          if (keyHash === undefined) {
            keyHash = hash(key);
          }

          var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
          var node = this.nodes[idx];
          return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
        };

        HashArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          if (keyHash === undefined) {
            keyHash = hash(key);
          }

          var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
          var removed = value === NOT_SET;
          var nodes = this.nodes;
          var node = nodes[idx];

          if (removed && !node) {
            return this;
          }

          var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

          if (newNode === node) {
            return this;
          }

          var newCount = this.count;

          if (!node) {
            newCount++;
          } else if (!newNode) {
            newCount--;

            if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
              return packNodes(ownerID, nodes, newCount, idx);
            }
          }

          var isEditable = ownerID && ownerID === this.ownerID;
          var newNodes = setIn(nodes, idx, newNode, isEditable);

          if (isEditable) {
            this.count = newCount;
            this.nodes = newNodes;
            return this;
          }

          return new HashArrayMapNode(ownerID, newCount, newNodes);
        };

        function HashCollisionNode(ownerID, keyHash, entries) {
          this.ownerID = ownerID;
          this.keyHash = keyHash;
          this.entries = entries;
        }

        HashCollisionNode.prototype.get = function (shift, keyHash, key, notSetValue) {
          var entries = this.entries;

          for (var ii = 0, len = entries.length; ii < len; ii++) {
            if (is(key, entries[ii][0])) {
              return entries[ii][1];
            }
          }

          return notSetValue;
        };

        HashCollisionNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          if (keyHash === undefined) {
            keyHash = hash(key);
          }

          var removed = value === NOT_SET;

          if (keyHash !== this.keyHash) {
            if (removed) {
              return this;
            }

            SetRef(didAlter);
            SetRef(didChangeSize);
            return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
          }

          var entries = this.entries;
          var idx = 0;

          for (var len = entries.length; idx < len; idx++) {
            if (is(key, entries[idx][0])) {
              break;
            }
          }

          var exists = idx < len;

          if (exists ? entries[idx][1] === value : removed) {
            return this;
          }

          SetRef(didAlter);
          (removed || !exists) && SetRef(didChangeSize);

          if (removed && len === 2) {
            return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
          }

          var isEditable = ownerID && ownerID === this.ownerID;
          var newEntries = isEditable ? entries : arrCopy(entries);

          if (exists) {
            if (removed) {
              idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            } else {
              newEntries[idx] = [key, value];
            }
          } else {
            newEntries.push([key, value]);
          }

          if (isEditable) {
            this.entries = newEntries;
            return this;
          }

          return new HashCollisionNode(ownerID, this.keyHash, newEntries);
        };

        function ValueNode(ownerID, keyHash, entry) {
          this.ownerID = ownerID;
          this.keyHash = keyHash;
          this.entry = entry;
        }

        ValueNode.prototype.get = function (shift, keyHash, key, notSetValue) {
          return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
        };

        ValueNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          var removed = value === NOT_SET;
          var keyMatch = is(key, this.entry[0]);

          if (keyMatch ? value === this.entry[1] : removed) {
            return this;
          }

          SetRef(didAlter);

          if (removed) {
            SetRef(didChangeSize);
            return; // undefined
          }

          if (keyMatch) {
            if (ownerID && ownerID === this.ownerID) {
              this.entry[1] = value;
              return this;
            }

            return new ValueNode(ownerID, this.keyHash, [key, value]);
          }

          SetRef(didChangeSize);
          return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
        }; // #pragma Iterators


        ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function (fn, reverse) {
          var entries = this.entries;

          for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
            if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
              return false;
            }
          }
        };

        BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function (fn, reverse) {
          var nodes = this.nodes;

          for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
            var node = nodes[reverse ? maxIndex - ii : ii];

            if (node && node.iterate(fn, reverse) === false) {
              return false;
            }
          }
        };

        ValueNode.prototype.iterate = function (fn, reverse) {
          return fn(this.entry);
        };

        createClass(MapIterator, Iterator);

        function MapIterator(map, type, reverse) {
          this._type = type;
          this._reverse = reverse;
          this._stack = map._root && mapIteratorFrame(map._root);
        }

        MapIterator.prototype.next = function () {
          var type = this._type;
          var stack = this._stack;

          while (stack) {
            var node = stack.node;
            var index = stack.index++;
            var maxIndex;

            if (node.entry) {
              if (index === 0) {
                return mapIteratorValue(type, node.entry);
              }
            } else if (node.entries) {
              maxIndex = node.entries.length - 1;

              if (index <= maxIndex) {
                return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
              }
            } else {
              maxIndex = node.nodes.length - 1;

              if (index <= maxIndex) {
                var subNode = node.nodes[this._reverse ? maxIndex - index : index];

                if (subNode) {
                  if (subNode.entry) {
                    return mapIteratorValue(type, subNode.entry);
                  }

                  stack = this._stack = mapIteratorFrame(subNode, stack);
                }

                continue;
              }
            }

            stack = this._stack = this._stack.__prev;
          }

          return iteratorDone();
        };

        function mapIteratorValue(type, entry) {
          return iteratorValue(type, entry[0], entry[1]);
        }

        function mapIteratorFrame(node, prev) {
          return {
            node: node,
            index: 0,
            __prev: prev
          };
        }

        function makeMap(size, root, ownerID, hash) {
          var map = Object.create(MapPrototype);
          map.size = size;
          map._root = root;
          map.__ownerID = ownerID;
          map.__hash = hash;
          map.__altered = false;
          return map;
        }

        var EMPTY_MAP;

        function emptyMap() {
          return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
        }

        function updateMap(map, k, v) {
          var newRoot;
          var newSize;

          if (!map._root) {
            if (v === NOT_SET) {
              return map;
            }

            newSize = 1;
            newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
          } else {
            var didChangeSize = MakeRef(CHANGE_LENGTH);
            var didAlter = MakeRef(DID_ALTER);
            newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);

            if (!didAlter.value) {
              return map;
            }

            newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
          }

          if (map.__ownerID) {
            map.size = newSize;
            map._root = newRoot;
            map.__hash = undefined;
            map.__altered = true;
            return map;
          }

          return newRoot ? makeMap(newSize, newRoot) : emptyMap();
        }

        function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          if (!node) {
            if (value === NOT_SET) {
              return node;
            }

            SetRef(didAlter);
            SetRef(didChangeSize);
            return new ValueNode(ownerID, keyHash, [key, value]);
          }

          return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
        }

        function isLeafNode(node) {
          return node.constructor === ValueNode || node.constructor === HashCollisionNode;
        }

        function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
          if (node.keyHash === keyHash) {
            return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
          }

          var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
          var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
          var newNode;
          var nodes = idx1 === idx2 ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);
          return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
        }

        function createNodes(ownerID, entries, key, value) {
          if (!ownerID) {
            ownerID = new OwnerID();
          }

          var node = new ValueNode(ownerID, hash(key), [key, value]);

          for (var ii = 0; ii < entries.length; ii++) {
            var entry = entries[ii];
            node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
          }

          return node;
        }

        function packNodes(ownerID, nodes, count, excluding) {
          var bitmap = 0;
          var packedII = 0;
          var packedNodes = new Array(count);

          for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
            var node = nodes[ii];

            if (node !== undefined && ii !== excluding) {
              bitmap |= bit;
              packedNodes[packedII++] = node;
            }
          }

          return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
        }

        function expandNodes(ownerID, nodes, bitmap, including, node) {
          var count = 0;
          var expandedNodes = new Array(SIZE);

          for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
            expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
          }

          expandedNodes[including] = node;
          return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
        }

        function mergeIntoMapWith(map, merger, iterables) {
          var iters = [];

          for (var ii = 0; ii < iterables.length; ii++) {
            var value = iterables[ii];
            var iter = KeyedIterable(value);

            if (!isIterable(value)) {
              iter = iter.map(function (v) {
                return fromJS(v);
              });
            }

            iters.push(iter);
          }

          return mergeIntoCollectionWith(map, merger, iters);
        }

        function deepMerger(existing, value, key) {
          return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
        }

        function deepMergerWith(merger) {
          return function (existing, value, key) {
            if (existing && existing.mergeDeepWith && isIterable(value)) {
              return existing.mergeDeepWith(merger, value);
            }

            var nextValue = merger(existing, value, key);
            return is(existing, nextValue) ? existing : nextValue;
          };
        }

        function mergeIntoCollectionWith(collection, merger, iters) {
          iters = iters.filter(function (x) {
            return x.size !== 0;
          });

          if (iters.length === 0) {
            return collection;
          }

          if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
            return collection.constructor(iters[0]);
          }

          return collection.withMutations(function (collection) {
            var mergeIntoMap = merger ? function (value, key) {
              collection.update(key, NOT_SET, function (existing) {
                return existing === NOT_SET ? value : merger(existing, value, key);
              });
            } : function (value, key) {
              collection.set(key, value);
            };

            for (var ii = 0; ii < iters.length; ii++) {
              iters[ii].forEach(mergeIntoMap);
            }
          });
        }

        function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
          var isNotSet = existing === NOT_SET;
          var step = keyPathIter.next();

          if (step.done) {
            var existingValue = isNotSet ? notSetValue : existing;
            var newValue = updater(existingValue);
            return newValue === existingValue ? existing : newValue;
          }

          invariant(isNotSet || existing && existing.set, 'invalid keyPath');
          var key = step.value;
          var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
          var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
          return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
        }

        function popCount(x) {
          x = x - (x >> 1 & 0x55555555);
          x = (x & 0x33333333) + (x >> 2 & 0x33333333);
          x = x + (x >> 4) & 0x0f0f0f0f;
          x = x + (x >> 8);
          x = x + (x >> 16);
          return x & 0x7f;
        }

        function setIn(array, idx, val, canEdit) {
          var newArray = canEdit ? array : arrCopy(array);
          newArray[idx] = val;
          return newArray;
        }

        function spliceIn(array, idx, val, canEdit) {
          var newLen = array.length + 1;

          if (canEdit && idx + 1 === newLen) {
            array[idx] = val;
            return array;
          }

          var newArray = new Array(newLen);
          var after = 0;

          for (var ii = 0; ii < newLen; ii++) {
            if (ii === idx) {
              newArray[ii] = val;
              after = -1;
            } else {
              newArray[ii] = array[ii + after];
            }
          }

          return newArray;
        }

        function spliceOut(array, idx, canEdit) {
          var newLen = array.length - 1;

          if (canEdit && idx === newLen) {
            array.pop();
            return array;
          }

          var newArray = new Array(newLen);
          var after = 0;

          for (var ii = 0; ii < newLen; ii++) {
            if (ii === idx) {
              after = 1;
            }

            newArray[ii] = array[ii + after];
          }

          return newArray;
        }

        var MAX_ARRAY_MAP_SIZE = SIZE / 4;
        var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
        var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
        createClass(List, IndexedCollection); // @pragma Construction

        function List(value) {
          var empty = emptyList();

          if (value === null || value === undefined) {
            return empty;
          }

          if (isList(value)) {
            return value;
          }

          var iter = IndexedIterable(value);
          var size = iter.size;

          if (size === 0) {
            return empty;
          }

          assertNotInfinite(size);

          if (size > 0 && size < SIZE) {
            return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
          }

          return empty.withMutations(function (list) {
            list.setSize(size);
            iter.forEach(function (v, i) {
              return list.set(i, v);
            });
          });
        }

        List.of = function ()
        /*...values*/
        {
          return this(arguments);
        };

        List.prototype.toString = function () {
          return this.__toString('List [', ']');
        }; // @pragma Access


        List.prototype.get = function (index, notSetValue) {
          index = wrapIndex(this, index);

          if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
          }

          return notSetValue;
        }; // @pragma Modification


        List.prototype.set = function (index, value) {
          return updateList(this, index, value);
        };

        List.prototype.remove = function (index) {
          return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
        };

        List.prototype.insert = function (index, value) {
          return this.splice(index, 0, value);
        };

        List.prototype.clear = function () {
          if (this.size === 0) {
            return this;
          }

          if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return emptyList();
        };

        List.prototype.push = function ()
        /*...values*/
        {
          var values = arguments;
          var oldSize = this.size;
          return this.withMutations(function (list) {
            setListBounds(list, 0, oldSize + values.length);

            for (var ii = 0; ii < values.length; ii++) {
              list.set(oldSize + ii, values[ii]);
            }
          });
        };

        List.prototype.pop = function () {
          return setListBounds(this, 0, -1);
        };

        List.prototype.unshift = function ()
        /*...values*/
        {
          var values = arguments;
          return this.withMutations(function (list) {
            setListBounds(list, -values.length);

            for (var ii = 0; ii < values.length; ii++) {
              list.set(ii, values[ii]);
            }
          });
        };

        List.prototype.shift = function () {
          return setListBounds(this, 1);
        }; // @pragma Composition


        List.prototype.merge = function ()
        /*...iters*/
        {
          return mergeIntoListWith(this, undefined, arguments);
        };

        List.prototype.mergeWith = function (merger) {
          var iters = SLICE$0.call(arguments, 1);
          return mergeIntoListWith(this, merger, iters);
        };

        List.prototype.mergeDeep = function ()
        /*...iters*/
        {
          return mergeIntoListWith(this, deepMerger, arguments);
        };

        List.prototype.mergeDeepWith = function (merger) {
          var iters = SLICE$0.call(arguments, 1);
          return mergeIntoListWith(this, deepMergerWith(merger), iters);
        };

        List.prototype.setSize = function (size) {
          return setListBounds(this, 0, size);
        }; // @pragma Iteration


        List.prototype.slice = function (begin, end) {
          var size = this.size;

          if (wholeSlice(begin, end, size)) {
            return this;
          }

          return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
        };

        List.prototype.__iterator = function (type, reverse) {
          var index = 0;
          var values = iterateList(this, reverse);
          return new Iterator(function () {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
          });
        };

        List.prototype.__iterate = function (fn, reverse) {
          var index = 0;
          var values = iterateList(this, reverse);
          var value;

          while ((value = values()) !== DONE) {
            if (fn(value, index++, this) === false) {
              break;
            }
          }

          return index;
        };

        List.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          if (!ownerID) {
            this.__ownerID = ownerID;
            return this;
          }

          return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
        };

        function isList(maybeList) {
          return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
        }

        List.isList = isList;
        var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
        var ListPrototype = List.prototype;
        ListPrototype[IS_LIST_SENTINEL] = true;
        ListPrototype[DELETE] = ListPrototype.remove;
        ListPrototype.setIn = MapPrototype.setIn;
        ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
        ListPrototype.update = MapPrototype.update;
        ListPrototype.updateIn = MapPrototype.updateIn;
        ListPrototype.mergeIn = MapPrototype.mergeIn;
        ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
        ListPrototype.withMutations = MapPrototype.withMutations;
        ListPrototype.asMutable = MapPrototype.asMutable;
        ListPrototype.asImmutable = MapPrototype.asImmutable;
        ListPrototype.wasAltered = MapPrototype.wasAltered;

        function VNode(array, ownerID) {
          this.array = array;
          this.ownerID = ownerID;
        } // TODO: seems like these methods are very similar


        VNode.prototype.removeBefore = function (ownerID, level, index) {
          if (index === level ? 1 << level : 0 || this.array.length === 0) {
            return this;
          }

          var originIndex = index >>> level & MASK;

          if (originIndex >= this.array.length) {
            return new VNode([], ownerID);
          }

          var removingFirst = originIndex === 0;
          var newChild;

          if (level > 0) {
            var oldChild = this.array[originIndex];
            newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);

            if (newChild === oldChild && removingFirst) {
              return this;
            }
          }

          if (removingFirst && !newChild) {
            return this;
          }

          var editable = editableVNode(this, ownerID);

          if (!removingFirst) {
            for (var ii = 0; ii < originIndex; ii++) {
              editable.array[ii] = undefined;
            }
          }

          if (newChild) {
            editable.array[originIndex] = newChild;
          }

          return editable;
        };

        VNode.prototype.removeAfter = function (ownerID, level, index) {
          if (index === (level ? 1 << level : 0) || this.array.length === 0) {
            return this;
          }

          var sizeIndex = index - 1 >>> level & MASK;

          if (sizeIndex >= this.array.length) {
            return this;
          }

          var newChild;

          if (level > 0) {
            var oldChild = this.array[sizeIndex];
            newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);

            if (newChild === oldChild && sizeIndex === this.array.length - 1) {
              return this;
            }
          }

          var editable = editableVNode(this, ownerID);
          editable.array.splice(sizeIndex + 1);

          if (newChild) {
            editable.array[sizeIndex] = newChild;
          }

          return editable;
        };

        var DONE = {};

        function iterateList(list, reverse) {
          var left = list._origin;
          var right = list._capacity;
          var tailPos = getTailOffset(right);
          var tail = list._tail;
          return iterateNodeOrLeaf(list._root, list._level, 0);

          function iterateNodeOrLeaf(node, level, offset) {
            return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
          }

          function iterateLeaf(node, offset) {
            var array = offset === tailPos ? tail && tail.array : node && node.array;
            var from = offset > left ? 0 : left - offset;
            var to = right - offset;

            if (to > SIZE) {
              to = SIZE;
            }

            return function () {
              if (from === to) {
                return DONE;
              }

              var idx = reverse ? --to : from++;
              return array && array[idx];
            };
          }

          function iterateNode(node, level, offset) {
            var values;
            var array = node && node.array;
            var from = offset > left ? 0 : left - offset >> level;
            var to = (right - offset >> level) + 1;

            if (to > SIZE) {
              to = SIZE;
            }

            return function () {
              do {
                if (values) {
                  var value = values();

                  if (value !== DONE) {
                    return value;
                  }

                  values = null;
                }

                if (from === to) {
                  return DONE;
                }

                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
              } while (true);
            };
          }
        }

        function makeList(origin, capacity, level, root, tail, ownerID, hash) {
          var list = Object.create(ListPrototype);
          list.size = capacity - origin;
          list._origin = origin;
          list._capacity = capacity;
          list._level = level;
          list._root = root;
          list._tail = tail;
          list.__ownerID = ownerID;
          list.__hash = hash;
          list.__altered = false;
          return list;
        }

        var EMPTY_LIST;

        function emptyList() {
          return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
        }

        function updateList(list, index, value) {
          index = wrapIndex(list, index);

          if (index !== index) {
            return list;
          }

          if (index >= list.size || index < 0) {
            return list.withMutations(function (list) {
              index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
            });
          }

          index += list._origin;
          var newTail = list._tail;
          var newRoot = list._root;
          var didAlter = MakeRef(DID_ALTER);

          if (index >= getTailOffset(list._capacity)) {
            newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
          } else {
            newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
          }

          if (!didAlter.value) {
            return list;
          }

          if (list.__ownerID) {
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
          }

          return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
        }

        function updateVNode(node, ownerID, level, index, value, didAlter) {
          var idx = index >>> level & MASK;
          var nodeHas = node && idx < node.array.length;

          if (!nodeHas && value === undefined) {
            return node;
          }

          var newNode;

          if (level > 0) {
            var lowerNode = node && node.array[idx];
            var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);

            if (newLowerNode === lowerNode) {
              return node;
            }

            newNode = editableVNode(node, ownerID);
            newNode.array[idx] = newLowerNode;
            return newNode;
          }

          if (nodeHas && node.array[idx] === value) {
            return node;
          }

          SetRef(didAlter);
          newNode = editableVNode(node, ownerID);

          if (value === undefined && idx === newNode.array.length - 1) {
            newNode.array.pop();
          } else {
            newNode.array[idx] = value;
          }

          return newNode;
        }

        function editableVNode(node, ownerID) {
          if (ownerID && node && ownerID === node.ownerID) {
            return node;
          }

          return new VNode(node ? node.array.slice() : [], ownerID);
        }

        function listNodeFor(list, rawIndex) {
          if (rawIndex >= getTailOffset(list._capacity)) {
            return list._tail;
          }

          if (rawIndex < 1 << list._level + SHIFT) {
            var node = list._root;
            var level = list._level;

            while (node && level > 0) {
              node = node.array[rawIndex >>> level & MASK];
              level -= SHIFT;
            }

            return node;
          }
        }

        function setListBounds(list, begin, end) {
          // Sanitize begin & end using this shorthand for ToInt32(argument)
          // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
          if (begin !== undefined) {
            begin = begin | 0;
          }

          if (end !== undefined) {
            end = end | 0;
          }

          var owner = list.__ownerID || new OwnerID();
          var oldOrigin = list._origin;
          var oldCapacity = list._capacity;
          var newOrigin = oldOrigin + begin;
          var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;

          if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
            return list;
          } // If it's going to end after it starts, it's empty.


          if (newOrigin >= newCapacity) {
            return list.clear();
          }

          var newLevel = list._level;
          var newRoot = list._root; // New origin might need creating a higher root.

          var offsetShift = 0;

          while (newOrigin + offsetShift < 0) {
            newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
            newLevel += SHIFT;
            offsetShift += 1 << newLevel;
          }

          if (offsetShift) {
            newOrigin += offsetShift;
            oldOrigin += offsetShift;
            newCapacity += offsetShift;
            oldCapacity += offsetShift;
          }

          var oldTailOffset = getTailOffset(oldCapacity);
          var newTailOffset = getTailOffset(newCapacity); // New size might need creating a higher root.

          while (newTailOffset >= 1 << newLevel + SHIFT) {
            newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
            newLevel += SHIFT;
          } // Locate or create the new tail.


          var oldTail = list._tail;
          var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail; // Merge Tail into tree.

          if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
            newRoot = editableVNode(newRoot, owner);
            var node = newRoot;

            for (var level = newLevel; level > SHIFT; level -= SHIFT) {
              var idx = oldTailOffset >>> level & MASK;
              node = node.array[idx] = editableVNode(node.array[idx], owner);
            }

            node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
          } // If the size has been reduced, there's a chance the tail needs to be trimmed.


          if (newCapacity < oldCapacity) {
            newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
          } // If the new origin is within the tail, then we do not need a root.


          if (newOrigin >= newTailOffset) {
            newOrigin -= newTailOffset;
            newCapacity -= newTailOffset;
            newLevel = SHIFT;
            newRoot = null;
            newTail = newTail && newTail.removeBefore(owner, 0, newOrigin); // Otherwise, if the root has been trimmed, garbage collect.
          } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
            offsetShift = 0; // Identify the new top root node of the subtree of the old root.

            while (newRoot) {
              var beginIndex = newOrigin >>> newLevel & MASK;

              if (beginIndex !== newTailOffset >>> newLevel & MASK) {
                break;
              }

              if (beginIndex) {
                offsetShift += (1 << newLevel) * beginIndex;
              }

              newLevel -= SHIFT;
              newRoot = newRoot.array[beginIndex];
            } // Trim the new sides of the new root.


            if (newRoot && newOrigin > oldOrigin) {
              newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
            }

            if (newRoot && newTailOffset < oldTailOffset) {
              newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
            }

            if (offsetShift) {
              newOrigin -= offsetShift;
              newCapacity -= offsetShift;
            }
          }

          if (list.__ownerID) {
            list.size = newCapacity - newOrigin;
            list._origin = newOrigin;
            list._capacity = newCapacity;
            list._level = newLevel;
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
          }

          return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
        }

        function mergeIntoListWith(list, merger, iterables) {
          var iters = [];
          var maxSize = 0;

          for (var ii = 0; ii < iterables.length; ii++) {
            var value = iterables[ii];
            var iter = IndexedIterable(value);

            if (iter.size > maxSize) {
              maxSize = iter.size;
            }

            if (!isIterable(value)) {
              iter = iter.map(function (v) {
                return fromJS(v);
              });
            }

            iters.push(iter);
          }

          if (maxSize > list.size) {
            list = list.setSize(maxSize);
          }

          return mergeIntoCollectionWith(list, merger, iters);
        }

        function getTailOffset(size) {
          return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
        }

        createClass(OrderedMap, Map); // @pragma Construction

        function OrderedMap(value) {
          return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function (map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v, k) {
              return map.set(k, v);
            });
          });
        }

        OrderedMap.of = function ()
        /*...values*/
        {
          return this(arguments);
        };

        OrderedMap.prototype.toString = function () {
          return this.__toString('OrderedMap {', '}');
        }; // @pragma Access


        OrderedMap.prototype.get = function (k, notSetValue) {
          var index = this._map.get(k);

          return index !== undefined ? this._list.get(index)[1] : notSetValue;
        }; // @pragma Modification


        OrderedMap.prototype.clear = function () {
          if (this.size === 0) {
            return this;
          }

          if (this.__ownerID) {
            this.size = 0;

            this._map.clear();

            this._list.clear();

            return this;
          }

          return emptyOrderedMap();
        };

        OrderedMap.prototype.set = function (k, v) {
          return updateOrderedMap(this, k, v);
        };

        OrderedMap.prototype.remove = function (k) {
          return updateOrderedMap(this, k, NOT_SET);
        };

        OrderedMap.prototype.wasAltered = function () {
          return this._map.wasAltered() || this._list.wasAltered();
        };

        OrderedMap.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          return this._list.__iterate(function (entry) {
            return entry && fn(entry[1], entry[0], this$0);
          }, reverse);
        };

        OrderedMap.prototype.__iterator = function (type, reverse) {
          return this._list.fromEntrySeq().__iterator(type, reverse);
        };

        OrderedMap.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          var newMap = this._map.__ensureOwner(ownerID);

          var newList = this._list.__ensureOwner(ownerID);

          if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            this._list = newList;
            return this;
          }

          return makeOrderedMap(newMap, newList, ownerID, this.__hash);
        };

        function isOrderedMap(maybeOrderedMap) {
          return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
        }

        OrderedMap.isOrderedMap = isOrderedMap;
        OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
        OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;

        function makeOrderedMap(map, list, ownerID, hash) {
          var omap = Object.create(OrderedMap.prototype);
          omap.size = map ? map.size : 0;
          omap._map = map;
          omap._list = list;
          omap.__ownerID = ownerID;
          omap.__hash = hash;
          return omap;
        }

        var EMPTY_ORDERED_MAP;

        function emptyOrderedMap() {
          return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
        }

        function updateOrderedMap(omap, k, v) {
          var map = omap._map;
          var list = omap._list;
          var i = map.get(k);
          var has = i !== undefined;
          var newMap;
          var newList;

          if (v === NOT_SET) {
            // removed
            if (!has) {
              return omap;
            }

            if (list.size >= SIZE && list.size >= map.size * 2) {
              newList = list.filter(function (entry, idx) {
                return entry !== undefined && i !== idx;
              });
              newMap = newList.toKeyedSeq().map(function (entry) {
                return entry[0];
              }).flip().toMap();

              if (omap.__ownerID) {
                newMap.__ownerID = newList.__ownerID = omap.__ownerID;
              }
            } else {
              newMap = map.remove(k);
              newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
            }
          } else {
            if (has) {
              if (v === list.get(i)[1]) {
                return omap;
              }

              newMap = map;
              newList = list.set(i, [k, v]);
            } else {
              newMap = map.set(k, list.size);
              newList = list.set(list.size, [k, v]);
            }
          }

          if (omap.__ownerID) {
            omap.size = newMap.size;
            omap._map = newMap;
            omap._list = newList;
            omap.__hash = undefined;
            return omap;
          }

          return makeOrderedMap(newMap, newList);
        }

        createClass(ToKeyedSequence, KeyedSeq);

        function ToKeyedSequence(indexed, useKeys) {
          this._iter = indexed;
          this._useKeys = useKeys;
          this.size = indexed.size;
        }

        ToKeyedSequence.prototype.get = function (key, notSetValue) {
          return this._iter.get(key, notSetValue);
        };

        ToKeyedSequence.prototype.has = function (key) {
          return this._iter.has(key);
        };

        ToKeyedSequence.prototype.valueSeq = function () {
          return this._iter.valueSeq();
        };

        ToKeyedSequence.prototype.reverse = function () {
          var this$0 = this;
          var reversedSequence = reverseFactory(this, true);

          if (!this._useKeys) {
            reversedSequence.valueSeq = function () {
              return this$0._iter.toSeq().reverse();
            };
          }

          return reversedSequence;
        };

        ToKeyedSequence.prototype.map = function (mapper, context) {
          var this$0 = this;
          var mappedSequence = mapFactory(this, mapper, context);

          if (!this._useKeys) {
            mappedSequence.valueSeq = function () {
              return this$0._iter.toSeq().map(mapper, context);
            };
          }

          return mappedSequence;
        };

        ToKeyedSequence.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          var ii;
          return this._iter.__iterate(this._useKeys ? function (v, k) {
            return fn(v, k, this$0);
          } : (ii = reverse ? resolveSize(this) : 0, function (v) {
            return fn(v, reverse ? --ii : ii++, this$0);
          }), reverse);
        };

        ToKeyedSequence.prototype.__iterator = function (type, reverse) {
          if (this._useKeys) {
            return this._iter.__iterator(type, reverse);
          }

          var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

          var ii = reverse ? resolveSize(this) : 0;
          return new Iterator(function () {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
          });
        };

        ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
        createClass(ToIndexedSequence, IndexedSeq);

        function ToIndexedSequence(iter) {
          this._iter = iter;
          this.size = iter.size;
        }

        ToIndexedSequence.prototype.includes = function (value) {
          return this._iter.includes(value);
        };

        ToIndexedSequence.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          var iterations = 0;
          return this._iter.__iterate(function (v) {
            return fn(v, iterations++, this$0);
          }, reverse);
        };

        ToIndexedSequence.prototype.__iterator = function (type, reverse) {
          var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

          var iterations = 0;
          return new Iterator(function () {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value, step);
          });
        };

        createClass(ToSetSequence, SetSeq);

        function ToSetSequence(iter) {
          this._iter = iter;
          this.size = iter.size;
        }

        ToSetSequence.prototype.has = function (key) {
          return this._iter.includes(key);
        };

        ToSetSequence.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          return this._iter.__iterate(function (v) {
            return fn(v, v, this$0);
          }, reverse);
        };

        ToSetSequence.prototype.__iterator = function (type, reverse) {
          var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

          return new Iterator(function () {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
          });
        };

        createClass(FromEntriesSequence, KeyedSeq);

        function FromEntriesSequence(entries) {
          this._iter = entries;
          this.size = entries.size;
        }

        FromEntriesSequence.prototype.entrySeq = function () {
          return this._iter.toSeq();
        };

        FromEntriesSequence.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          return this._iter.__iterate(function (entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
              validateEntry(entry);
              var indexedIterable = isIterable(entry);
              return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
            }
          }, reverse);
        };

        FromEntriesSequence.prototype.__iterator = function (type, reverse) {
          var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

          return new Iterator(function () {
            while (true) {
              var step = iterator.next();

              if (step.done) {
                return step;
              }

              var entry = step.value; // Check if entry exists first so array access doesn't throw for holes
              // in the parent iteration.

              if (entry) {
                validateEntry(entry);
                var indexedIterable = isIterable(entry);
                return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
              }
            }
          });
        };

        ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;

        function flipFactory(iterable) {
          var flipSequence = makeSequence(iterable);
          flipSequence._iter = iterable;
          flipSequence.size = iterable.size;

          flipSequence.flip = function () {
            return iterable;
          };

          flipSequence.reverse = function () {
            var reversedSequence = iterable.reverse.apply(this); // super.reverse()

            reversedSequence.flip = function () {
              return iterable.reverse();
            };

            return reversedSequence;
          };

          flipSequence.has = function (key) {
            return iterable.includes(key);
          };

          flipSequence.includes = function (key) {
            return iterable.has(key);
          };

          flipSequence.cacheResult = cacheResultThrough;

          flipSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function (v, k) {
              return fn(k, v, this$0) !== false;
            }, reverse);
          };

          flipSequence.__iteratorUncached = function (type, reverse) {
            if (type === ITERATE_ENTRIES) {
              var iterator = iterable.__iterator(type, reverse);

              return new Iterator(function () {
                var step = iterator.next();

                if (!step.done) {
                  var k = step.value[0];
                  step.value[0] = step.value[1];
                  step.value[1] = k;
                }

                return step;
              });
            }

            return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
          };

          return flipSequence;
        }

        function mapFactory(iterable, mapper, context) {
          var mappedSequence = makeSequence(iterable);
          mappedSequence.size = iterable.size;

          mappedSequence.has = function (key) {
            return iterable.has(key);
          };

          mappedSequence.get = function (key, notSetValue) {
            var v = iterable.get(key, NOT_SET);
            return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
          };

          mappedSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function (v, k, c) {
              return fn(mapper.call(context, v, k, c), k, this$0) !== false;
            }, reverse);
          };

          mappedSequence.__iteratorUncached = function (type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

            return new Iterator(function () {
              var step = iterator.next();

              if (step.done) {
                return step;
              }

              var entry = step.value;
              var key = entry[0];
              return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
            });
          };

          return mappedSequence;
        }

        function reverseFactory(iterable, useKeys) {
          var reversedSequence = makeSequence(iterable);
          reversedSequence._iter = iterable;
          reversedSequence.size = iterable.size;

          reversedSequence.reverse = function () {
            return iterable;
          };

          if (iterable.flip) {
            reversedSequence.flip = function () {
              var flipSequence = flipFactory(iterable);

              flipSequence.reverse = function () {
                return iterable.flip();
              };

              return flipSequence;
            };
          }

          reversedSequence.get = function (key, notSetValue) {
            return iterable.get(useKeys ? key : -1 - key, notSetValue);
          };

          reversedSequence.has = function (key) {
            return iterable.has(useKeys ? key : -1 - key);
          };

          reversedSequence.includes = function (value) {
            return iterable.includes(value);
          };

          reversedSequence.cacheResult = cacheResultThrough;

          reversedSequence.__iterate = function (fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function (v, k) {
              return fn(v, k, this$0);
            }, !reverse);
          };

          reversedSequence.__iterator = function (type, reverse) {
            return iterable.__iterator(type, !reverse);
          };

          return reversedSequence;
        }

        function filterFactory(iterable, predicate, context, useKeys) {
          var filterSequence = makeSequence(iterable);

          if (useKeys) {
            filterSequence.has = function (key) {
              var v = iterable.get(key, NOT_SET);
              return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
            };

            filterSequence.get = function (key, notSetValue) {
              var v = iterable.get(key, NOT_SET);
              return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
            };
          }

          filterSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;
            var iterations = 0;

            iterable.__iterate(function (v, k, c) {
              if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$0);
              }
            }, reverse);

            return iterations;
          };

          filterSequence.__iteratorUncached = function (type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

            var iterations = 0;
            return new Iterator(function () {
              while (true) {
                var step = iterator.next();

                if (step.done) {
                  return step;
                }

                var entry = step.value;
                var key = entry[0];
                var value = entry[1];

                if (predicate.call(context, value, key, iterable)) {
                  return iteratorValue(type, useKeys ? key : iterations++, value, step);
                }
              }
            });
          };

          return filterSequence;
        }

        function countByFactory(iterable, grouper, context) {
          var groups = Map().asMutable();

          iterable.__iterate(function (v, k) {
            groups.update(grouper.call(context, v, k, iterable), 0, function (a) {
              return a + 1;
            });
          });

          return groups.asImmutable();
        }

        function groupByFactory(iterable, grouper, context) {
          var isKeyedIter = isKeyed(iterable);
          var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();

          iterable.__iterate(function (v, k) {
            groups.update(grouper.call(context, v, k, iterable), function (a) {
              return a = a || [], a.push(isKeyedIter ? [k, v] : v), a;
            });
          });

          var coerce = iterableClass(iterable);
          return groups.map(function (arr) {
            return reify(iterable, coerce(arr));
          });
        }

        function sliceFactory(iterable, begin, end, useKeys) {
          var originalSize = iterable.size; // Sanitize begin & end using this shorthand for ToInt32(argument)
          // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32

          if (begin !== undefined) {
            begin = begin | 0;
          }

          if (end !== undefined) {
            end = end | 0;
          }

          if (wholeSlice(begin, end, originalSize)) {
            return iterable;
          }

          var resolvedBegin = resolveBegin(begin, originalSize);
          var resolvedEnd = resolveEnd(end, originalSize); // begin or end will be NaN if they were provided as negative numbers and
          // this iterable's size is unknown. In that case, cache first so there is
          // a known size and these do not resolve to NaN.

          if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
            return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
          } // Note: resolvedEnd is undefined when the original sequence's length is
          // unknown and this slice did not supply an end and should contain all
          // elements after resolvedBegin.
          // In that case, resolvedSize will be NaN and sliceSize will remain undefined.


          var resolvedSize = resolvedEnd - resolvedBegin;
          var sliceSize;

          if (resolvedSize === resolvedSize) {
            sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
          }

          var sliceSeq = makeSequence(iterable); // If iterable.size is undefined, the size of the realized sliceSeq is
          // unknown at this point unless the number of items to slice is 0

          sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

          if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
            sliceSeq.get = function (index, notSetValue) {
              index = wrapIndex(this, index);
              return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
            };
          }

          sliceSeq.__iterateUncached = function (fn, reverse) {
            var this$0 = this;

            if (sliceSize === 0) {
              return 0;
            }

            if (reverse) {
              return this.cacheResult().__iterate(fn, reverse);
            }

            var skipped = 0;
            var isSkipping = true;
            var iterations = 0;

            iterable.__iterate(function (v, k) {
              if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
              }
            });

            return iterations;
          };

          sliceSeq.__iteratorUncached = function (type, reverse) {
            if (sliceSize !== 0 && reverse) {
              return this.cacheResult().__iterator(type, reverse);
            } // Don't bother instantiating parent iterator if taking 0.


            var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);

            var skipped = 0;
            var iterations = 0;
            return new Iterator(function () {
              while (skipped++ < resolvedBegin) {
                iterator.next();
              }

              if (++iterations > sliceSize) {
                return iteratorDone();
              }

              var step = iterator.next();

              if (useKeys || type === ITERATE_VALUES) {
                return step;
              } else if (type === ITERATE_KEYS) {
                return iteratorValue(type, iterations - 1, undefined, step);
              } else {
                return iteratorValue(type, iterations - 1, step.value[1], step);
              }
            });
          };

          return sliceSeq;
        }

        function takeWhileFactory(iterable, predicate, context) {
          var takeSequence = makeSequence(iterable);

          takeSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;

            if (reverse) {
              return this.cacheResult().__iterate(fn, reverse);
            }

            var iterations = 0;

            iterable.__iterate(function (v, k, c) {
              return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
            });

            return iterations;
          };

          takeSequence.__iteratorUncached = function (type, reverse) {
            var this$0 = this;

            if (reverse) {
              return this.cacheResult().__iterator(type, reverse);
            }

            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

            var iterating = true;
            return new Iterator(function () {
              if (!iterating) {
                return iteratorDone();
              }

              var step = iterator.next();

              if (step.done) {
                return step;
              }

              var entry = step.value;
              var k = entry[0];
              var v = entry[1];

              if (!predicate.call(context, v, k, this$0)) {
                iterating = false;
                return iteratorDone();
              }

              return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
          };

          return takeSequence;
        }

        function skipWhileFactory(iterable, predicate, context, useKeys) {
          var skipSequence = makeSequence(iterable);

          skipSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;

            if (reverse) {
              return this.cacheResult().__iterate(fn, reverse);
            }

            var isSkipping = true;
            var iterations = 0;

            iterable.__iterate(function (v, k, c) {
              if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$0);
              }
            });

            return iterations;
          };

          skipSequence.__iteratorUncached = function (type, reverse) {
            var this$0 = this;

            if (reverse) {
              return this.cacheResult().__iterator(type, reverse);
            }

            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

            var skipping = true;
            var iterations = 0;
            return new Iterator(function () {
              var step, k, v;

              do {
                step = iterator.next();

                if (step.done) {
                  if (useKeys || type === ITERATE_VALUES) {
                    return step;
                  } else if (type === ITERATE_KEYS) {
                    return iteratorValue(type, iterations++, undefined, step);
                  } else {
                    return iteratorValue(type, iterations++, step.value[1], step);
                  }
                }

                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$0));
              } while (skipping);

              return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
          };

          return skipSequence;
        }

        function concatFactory(iterable, values) {
          var isKeyedIterable = isKeyed(iterable);
          var iters = [iterable].concat(values).map(function (v) {
            if (!isIterable(v)) {
              v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
            } else if (isKeyedIterable) {
              v = KeyedIterable(v);
            }

            return v;
          }).filter(function (v) {
            return v.size !== 0;
          });

          if (iters.length === 0) {
            return iterable;
          }

          if (iters.length === 1) {
            var singleton = iters[0];

            if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) {
              return singleton;
            }
          }

          var concatSeq = new ArraySeq(iters);

          if (isKeyedIterable) {
            concatSeq = concatSeq.toKeyedSeq();
          } else if (!isIndexed(iterable)) {
            concatSeq = concatSeq.toSetSeq();
          }

          concatSeq = concatSeq.flatten(true);
          concatSeq.size = iters.reduce(function (sum, seq) {
            if (sum !== undefined) {
              var size = seq.size;

              if (size !== undefined) {
                return sum + size;
              }
            }
          }, 0);
          return concatSeq;
        }

        function flattenFactory(iterable, depth, useKeys) {
          var flatSequence = makeSequence(iterable);

          flatSequence.__iterateUncached = function (fn, reverse) {
            var iterations = 0;
            var stopped = false;

            function flatDeep(iter, currentDepth) {
              var this$0 = this;

              iter.__iterate(function (v, k) {
                if ((!depth || currentDepth < depth) && isIterable(v)) {
                  flatDeep(v, currentDepth + 1);
                } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
                  stopped = true;
                }

                return !stopped;
              }, reverse);
            }

            flatDeep(iterable, 0);
            return iterations;
          };

          flatSequence.__iteratorUncached = function (type, reverse) {
            var iterator = iterable.__iterator(type, reverse);

            var stack = [];
            var iterations = 0;
            return new Iterator(function () {
              while (iterator) {
                var step = iterator.next();

                if (step.done !== false) {
                  iterator = stack.pop();
                  continue;
                }

                var v = step.value;

                if (type === ITERATE_ENTRIES) {
                  v = v[1];
                }

                if ((!depth || stack.length < depth) && isIterable(v)) {
                  stack.push(iterator);
                  iterator = v.__iterator(type, reverse);
                } else {
                  return useKeys ? step : iteratorValue(type, iterations++, v, step);
                }
              }

              return iteratorDone();
            });
          };

          return flatSequence;
        }

        function flatMapFactory(iterable, mapper, context) {
          var coerce = iterableClass(iterable);
          return iterable.toSeq().map(function (v, k) {
            return coerce(mapper.call(context, v, k, iterable));
          }).flatten(true);
        }

        function interposeFactory(iterable, separator) {
          var interposedSequence = makeSequence(iterable);
          interposedSequence.size = iterable.size && iterable.size * 2 - 1;

          interposedSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;
            var iterations = 0;

            iterable.__iterate(function (v, k) {
              return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
            }, reverse);

            return iterations;
          };

          interposedSequence.__iteratorUncached = function (type, reverse) {
            var iterator = iterable.__iterator(ITERATE_VALUES, reverse);

            var iterations = 0;
            var step;
            return new Iterator(function () {
              if (!step || iterations % 2) {
                step = iterator.next();

                if (step.done) {
                  return step;
                }
              }

              return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
            });
          };

          return interposedSequence;
        }

        function sortFactory(iterable, comparator, mapper) {
          if (!comparator) {
            comparator = defaultComparator;
          }

          var isKeyedIterable = isKeyed(iterable);
          var index = 0;
          var entries = iterable.toSeq().map(function (v, k) {
            return [k, v, index++, mapper ? mapper(v, k, iterable) : v];
          }).toArray();
          entries.sort(function (a, b) {
            return comparator(a[3], b[3]) || a[2] - b[2];
          }).forEach(isKeyedIterable ? function (v, i) {
            entries[i].length = 2;
          } : function (v, i) {
            entries[i] = v[1];
          });
          return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
        }

        function maxFactory(iterable, comparator, mapper) {
          if (!comparator) {
            comparator = defaultComparator;
          }

          if (mapper) {
            var entry = iterable.toSeq().map(function (v, k) {
              return [v, mapper(v, k, iterable)];
            }).reduce(function (a, b) {
              return maxCompare(comparator, a[1], b[1]) ? b : a;
            });
            return entry && entry[0];
          } else {
            return iterable.reduce(function (a, b) {
              return maxCompare(comparator, a, b) ? b : a;
            });
          }
        }

        function maxCompare(comparator, a, b) {
          var comp = comparator(b, a); // b is considered the new max if the comparator declares them equal, but
          // they are not equal and b is in fact a nullish value.

          return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
        }

        function zipWithFactory(keyIter, zipper, iters) {
          var zipSequence = makeSequence(keyIter);
          zipSequence.size = new ArraySeq(iters).map(function (i) {
            return i.size;
          }).min(); // Note: this a generic base implementation of __iterate in terms of
          // __iterator which may be more generically useful in the future.

          zipSequence.__iterate = function (fn, reverse) {
            /* generic:
            var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
            var step;
            var iterations = 0;
            while (!(step = iterator.next()).done) {
              iterations++;
              if (fn(step.value[1], step.value[0], this) === false) {
                break;
              }
            }
            return iterations;
            */
            // indexed:
            var iterator = this.__iterator(ITERATE_VALUES, reverse);

            var step;
            var iterations = 0;

            while (!(step = iterator.next()).done) {
              if (fn(step.value, iterations++, this) === false) {
                break;
              }
            }

            return iterations;
          };

          zipSequence.__iteratorUncached = function (type, reverse) {
            var iterators = iters.map(function (i) {
              return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
            });
            var iterations = 0;
            var isDone = false;
            return new Iterator(function () {
              var steps;

              if (!isDone) {
                steps = iterators.map(function (i) {
                  return i.next();
                });
                isDone = steps.some(function (s) {
                  return s.done;
                });
              }

              if (isDone) {
                return iteratorDone();
              }

              return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function (s) {
                return s.value;
              })));
            });
          };

          return zipSequence;
        } // #pragma Helper Functions


        function reify(iter, seq) {
          return isSeq(iter) ? seq : iter.constructor(seq);
        }

        function validateEntry(entry) {
          if (entry !== Object(entry)) {
            throw new TypeError('Expected [K, V] tuple: ' + entry);
          }
        }

        function resolveSize(iter) {
          assertNotInfinite(iter.size);
          return ensureSize(iter);
        }

        function iterableClass(iterable) {
          return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
        }

        function makeSequence(iterable) {
          return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
        }

        function cacheResultThrough() {
          if (this._iter.cacheResult) {
            this._iter.cacheResult();

            this.size = this._iter.size;
            return this;
          } else {
            return Seq.prototype.cacheResult.call(this);
          }
        }

        function defaultComparator(a, b) {
          return a > b ? 1 : a < b ? -1 : 0;
        }

        function forceIterator(keyPath) {
          var iter = getIterator(keyPath);

          if (!iter) {
            // Array might not be iterable in this environment, so we need a fallback
            // to our wrapped type.
            if (!isArrayLike(keyPath)) {
              throw new TypeError('Expected iterable or array-like: ' + keyPath);
            }

            iter = getIterator(Iterable(keyPath));
          }

          return iter;
        }

        createClass(Record, KeyedCollection);

        function Record(defaultValues, name) {
          var hasInitialized;

          var RecordType = function Record(values) {
            if (values instanceof RecordType) {
              return values;
            }

            if (!(this instanceof RecordType)) {
              return new RecordType(values);
            }

            if (!hasInitialized) {
              hasInitialized = true;
              var keys = Object.keys(defaultValues);
              setProps(RecordTypePrototype, keys);
              RecordTypePrototype.size = keys.length;
              RecordTypePrototype._name = name;
              RecordTypePrototype._keys = keys;
              RecordTypePrototype._defaultValues = defaultValues;
            }

            this._map = Map(values);
          };

          var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
          RecordTypePrototype.constructor = RecordType;
          return RecordType;
        }

        Record.prototype.toString = function () {
          return this.__toString(recordName(this) + ' {', '}');
        }; // @pragma Access


        Record.prototype.has = function (k) {
          return this._defaultValues.hasOwnProperty(k);
        };

        Record.prototype.get = function (k, notSetValue) {
          if (!this.has(k)) {
            return notSetValue;
          }

          var defaultVal = this._defaultValues[k];
          return this._map ? this._map.get(k, defaultVal) : defaultVal;
        }; // @pragma Modification


        Record.prototype.clear = function () {
          if (this.__ownerID) {
            this._map && this._map.clear();
            return this;
          }

          var RecordType = this.constructor;
          return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
        };

        Record.prototype.set = function (k, v) {
          if (!this.has(k)) {
            throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
          }

          var newMap = this._map && this._map.set(k, v);

          if (this.__ownerID || newMap === this._map) {
            return this;
          }

          return makeRecord(this, newMap);
        };

        Record.prototype.remove = function (k) {
          if (!this.has(k)) {
            return this;
          }

          var newMap = this._map && this._map.remove(k);

          if (this.__ownerID || newMap === this._map) {
            return this;
          }

          return makeRecord(this, newMap);
        };

        Record.prototype.wasAltered = function () {
          return this._map.wasAltered();
        };

        Record.prototype.__iterator = function (type, reverse) {
          var this$0 = this;
          return KeyedIterable(this._defaultValues).map(function (_, k) {
            return this$0.get(k);
          }).__iterator(type, reverse);
        };

        Record.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          return KeyedIterable(this._defaultValues).map(function (_, k) {
            return this$0.get(k);
          }).__iterate(fn, reverse);
        };

        Record.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          var newMap = this._map && this._map.__ensureOwner(ownerID);

          if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
          }

          return makeRecord(this, newMap, ownerID);
        };

        var RecordPrototype = Record.prototype;
        RecordPrototype[DELETE] = RecordPrototype.remove;
        RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
        RecordPrototype.merge = MapPrototype.merge;
        RecordPrototype.mergeWith = MapPrototype.mergeWith;
        RecordPrototype.mergeIn = MapPrototype.mergeIn;
        RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
        RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
        RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
        RecordPrototype.setIn = MapPrototype.setIn;
        RecordPrototype.update = MapPrototype.update;
        RecordPrototype.updateIn = MapPrototype.updateIn;
        RecordPrototype.withMutations = MapPrototype.withMutations;
        RecordPrototype.asMutable = MapPrototype.asMutable;
        RecordPrototype.asImmutable = MapPrototype.asImmutable;

        function makeRecord(likeRecord, map, ownerID) {
          var record = Object.create(Object.getPrototypeOf(likeRecord));
          record._map = map;
          record.__ownerID = ownerID;
          return record;
        }

        function recordName(record) {
          return record._name || record.constructor.name || 'Record';
        }

        function setProps(prototype, names) {
          try {
            names.forEach(setProp.bind(undefined, prototype));
          } catch (error) {// Object.defineProperty failed. Probably IE8.
          }
        }

        function setProp(prototype, name) {
          Object.defineProperty(prototype, name, {
            get: function get() {
              return this.get(name);
            },
            set: function set(value) {
              invariant(this.__ownerID, 'Cannot set on an immutable record.');
              this.set(name, value);
            }
          });
        }

        createClass(Set, SetCollection); // @pragma Construction

        function Set(value) {
          return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function (set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v) {
              return set.add(v);
            });
          });
        }

        Set.of = function ()
        /*...values*/
        {
          return this(arguments);
        };

        Set.fromKeys = function (value) {
          return this(KeyedIterable(value).keySeq());
        };

        Set.prototype.toString = function () {
          return this.__toString('Set {', '}');
        }; // @pragma Access


        Set.prototype.has = function (value) {
          return this._map.has(value);
        }; // @pragma Modification


        Set.prototype.add = function (value) {
          return updateSet(this, this._map.set(value, true));
        };

        Set.prototype.remove = function (value) {
          return updateSet(this, this._map.remove(value));
        };

        Set.prototype.clear = function () {
          return updateSet(this, this._map.clear());
        }; // @pragma Composition


        Set.prototype.union = function () {
          var iters = SLICE$0.call(arguments, 0);
          iters = iters.filter(function (x) {
            return x.size !== 0;
          });

          if (iters.length === 0) {
            return this;
          }

          if (this.size === 0 && !this.__ownerID && iters.length === 1) {
            return this.constructor(iters[0]);
          }

          return this.withMutations(function (set) {
            for (var ii = 0; ii < iters.length; ii++) {
              SetIterable(iters[ii]).forEach(function (value) {
                return set.add(value);
              });
            }
          });
        };

        Set.prototype.intersect = function () {
          var iters = SLICE$0.call(arguments, 0);

          if (iters.length === 0) {
            return this;
          }

          iters = iters.map(function (iter) {
            return SetIterable(iter);
          });
          var originalSet = this;
          return this.withMutations(function (set) {
            originalSet.forEach(function (value) {
              if (!iters.every(function (iter) {
                return iter.includes(value);
              })) {
                set.remove(value);
              }
            });
          });
        };

        Set.prototype.subtract = function () {
          var iters = SLICE$0.call(arguments, 0);

          if (iters.length === 0) {
            return this;
          }

          iters = iters.map(function (iter) {
            return SetIterable(iter);
          });
          var originalSet = this;
          return this.withMutations(function (set) {
            originalSet.forEach(function (value) {
              if (iters.some(function (iter) {
                return iter.includes(value);
              })) {
                set.remove(value);
              }
            });
          });
        };

        Set.prototype.merge = function () {
          return this.union.apply(this, arguments);
        };

        Set.prototype.mergeWith = function (merger) {
          var iters = SLICE$0.call(arguments, 1);
          return this.union.apply(this, iters);
        };

        Set.prototype.sort = function (comparator) {
          // Late binding
          return OrderedSet(sortFactory(this, comparator));
        };

        Set.prototype.sortBy = function (mapper, comparator) {
          // Late binding
          return OrderedSet(sortFactory(this, comparator, mapper));
        };

        Set.prototype.wasAltered = function () {
          return this._map.wasAltered();
        };

        Set.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          return this._map.__iterate(function (_, k) {
            return fn(k, k, this$0);
          }, reverse);
        };

        Set.prototype.__iterator = function (type, reverse) {
          return this._map.map(function (_, k) {
            return k;
          }).__iterator(type, reverse);
        };

        Set.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          var newMap = this._map.__ensureOwner(ownerID);

          if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
          }

          return this.__make(newMap, ownerID);
        };

        function isSet(maybeSet) {
          return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
        }

        Set.isSet = isSet;
        var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
        var SetPrototype = Set.prototype;
        SetPrototype[IS_SET_SENTINEL] = true;
        SetPrototype[DELETE] = SetPrototype.remove;
        SetPrototype.mergeDeep = SetPrototype.merge;
        SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
        SetPrototype.withMutations = MapPrototype.withMutations;
        SetPrototype.asMutable = MapPrototype.asMutable;
        SetPrototype.asImmutable = MapPrototype.asImmutable;
        SetPrototype.__empty = emptySet;
        SetPrototype.__make = makeSet;

        function updateSet(set, newMap) {
          if (set.__ownerID) {
            set.size = newMap.size;
            set._map = newMap;
            return set;
          }

          return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
        }

        function makeSet(map, ownerID) {
          var set = Object.create(SetPrototype);
          set.size = map ? map.size : 0;
          set._map = map;
          set.__ownerID = ownerID;
          return set;
        }

        var EMPTY_SET;

        function emptySet() {
          return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
        }

        createClass(OrderedSet, Set); // @pragma Construction

        function OrderedSet(value) {
          return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function (set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v) {
              return set.add(v);
            });
          });
        }

        OrderedSet.of = function ()
        /*...values*/
        {
          return this(arguments);
        };

        OrderedSet.fromKeys = function (value) {
          return this(KeyedIterable(value).keySeq());
        };

        OrderedSet.prototype.toString = function () {
          return this.__toString('OrderedSet {', '}');
        };

        function isOrderedSet(maybeOrderedSet) {
          return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
        }

        OrderedSet.isOrderedSet = isOrderedSet;
        var OrderedSetPrototype = OrderedSet.prototype;
        OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
        OrderedSetPrototype.__empty = emptyOrderedSet;
        OrderedSetPrototype.__make = makeOrderedSet;

        function makeOrderedSet(map, ownerID) {
          var set = Object.create(OrderedSetPrototype);
          set.size = map ? map.size : 0;
          set._map = map;
          set.__ownerID = ownerID;
          return set;
        }

        var EMPTY_ORDERED_SET;

        function emptyOrderedSet() {
          return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
        }

        createClass(Stack, IndexedCollection); // @pragma Construction

        function Stack(value) {
          return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
        }

        Stack.of = function ()
        /*...values*/
        {
          return this(arguments);
        };

        Stack.prototype.toString = function () {
          return this.__toString('Stack [', ']');
        }; // @pragma Access


        Stack.prototype.get = function (index, notSetValue) {
          var head = this._head;
          index = wrapIndex(this, index);

          while (head && index--) {
            head = head.next;
          }

          return head ? head.value : notSetValue;
        };

        Stack.prototype.peek = function () {
          return this._head && this._head.value;
        }; // @pragma Modification


        Stack.prototype.push = function ()
        /*...values*/
        {
          if (arguments.length === 0) {
            return this;
          }

          var newSize = this.size + arguments.length;
          var head = this._head;

          for (var ii = arguments.length - 1; ii >= 0; ii--) {
            head = {
              value: arguments[ii],
              next: head
            };
          }

          if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return makeStack(newSize, head);
        };

        Stack.prototype.pushAll = function (iter) {
          iter = IndexedIterable(iter);

          if (iter.size === 0) {
            return this;
          }

          assertNotInfinite(iter.size);
          var newSize = this.size;
          var head = this._head;
          iter.reverse().forEach(function (value) {
            newSize++;
            head = {
              value: value,
              next: head
            };
          });

          if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return makeStack(newSize, head);
        };

        Stack.prototype.pop = function () {
          return this.slice(1);
        };

        Stack.prototype.unshift = function ()
        /*...values*/
        {
          return this.push.apply(this, arguments);
        };

        Stack.prototype.unshiftAll = function (iter) {
          return this.pushAll(iter);
        };

        Stack.prototype.shift = function () {
          return this.pop.apply(this, arguments);
        };

        Stack.prototype.clear = function () {
          if (this.size === 0) {
            return this;
          }

          if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return emptyStack();
        };

        Stack.prototype.slice = function (begin, end) {
          if (wholeSlice(begin, end, this.size)) {
            return this;
          }

          var resolvedBegin = resolveBegin(begin, this.size);
          var resolvedEnd = resolveEnd(end, this.size);

          if (resolvedEnd !== this.size) {
            // super.slice(begin, end);
            return IndexedCollection.prototype.slice.call(this, begin, end);
          }

          var newSize = this.size - resolvedBegin;
          var head = this._head;

          while (resolvedBegin--) {
            head = head.next;
          }

          if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return makeStack(newSize, head);
        }; // @pragma Mutability


        Stack.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
          }

          return makeStack(this.size, this._head, ownerID, this.__hash);
        }; // @pragma Iteration


        Stack.prototype.__iterate = function (fn, reverse) {
          if (reverse) {
            return this.reverse().__iterate(fn);
          }

          var iterations = 0;
          var node = this._head;

          while (node) {
            if (fn(node.value, iterations++, this) === false) {
              break;
            }

            node = node.next;
          }

          return iterations;
        };

        Stack.prototype.__iterator = function (type, reverse) {
          if (reverse) {
            return this.reverse().__iterator(type);
          }

          var iterations = 0;
          var node = this._head;
          return new Iterator(function () {
            if (node) {
              var value = node.value;
              node = node.next;
              return iteratorValue(type, iterations++, value);
            }

            return iteratorDone();
          });
        };

        function isStack(maybeStack) {
          return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
        }

        Stack.isStack = isStack;
        var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
        var StackPrototype = Stack.prototype;
        StackPrototype[IS_STACK_SENTINEL] = true;
        StackPrototype.withMutations = MapPrototype.withMutations;
        StackPrototype.asMutable = MapPrototype.asMutable;
        StackPrototype.asImmutable = MapPrototype.asImmutable;
        StackPrototype.wasAltered = MapPrototype.wasAltered;

        function makeStack(size, head, ownerID, hash) {
          var map = Object.create(StackPrototype);
          map.size = size;
          map._head = head;
          map.__ownerID = ownerID;
          map.__hash = hash;
          map.__altered = false;
          return map;
        }

        var EMPTY_STACK;

        function emptyStack() {
          return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
        }
        /**
         * Contributes additional methods to a constructor
         */


        function mixin(ctor, methods) {
          var keyCopier = function keyCopier(key) {
            ctor.prototype[key] = methods[key];
          };

          Object.keys(methods).forEach(keyCopier);
          Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
          return ctor;
        }

        Iterable.Iterator = Iterator;
        mixin(Iterable, {
          // ### Conversion to other types
          toArray: function toArray() {
            assertNotInfinite(this.size);
            var array = new Array(this.size || 0);

            this.valueSeq().__iterate(function (v, i) {
              array[i] = v;
            });

            return array;
          },
          toIndexedSeq: function toIndexedSeq() {
            return new ToIndexedSequence(this);
          },
          toJS: function toJS() {
            return this.toSeq().map(function (value) {
              return value && typeof value.toJS === 'function' ? value.toJS() : value;
            }).__toJS();
          },
          toJSON: function toJSON() {
            return this.toSeq().map(function (value) {
              return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
            }).__toJS();
          },
          toKeyedSeq: function toKeyedSeq() {
            return new ToKeyedSequence(this, true);
          },
          toMap: function toMap() {
            // Use Late Binding here to solve the circular dependency.
            return Map(this.toKeyedSeq());
          },
          toObject: function toObject() {
            assertNotInfinite(this.size);
            var object = {};

            this.__iterate(function (v, k) {
              object[k] = v;
            });

            return object;
          },
          toOrderedMap: function toOrderedMap() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedMap(this.toKeyedSeq());
          },
          toOrderedSet: function toOrderedSet() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
          },
          toSet: function toSet() {
            // Use Late Binding here to solve the circular dependency.
            return Set(isKeyed(this) ? this.valueSeq() : this);
          },
          toSetSeq: function toSetSeq() {
            return new ToSetSequence(this);
          },
          toSeq: function toSeq() {
            return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
          },
          toStack: function toStack() {
            // Use Late Binding here to solve the circular dependency.
            return Stack(isKeyed(this) ? this.valueSeq() : this);
          },
          toList: function toList() {
            // Use Late Binding here to solve the circular dependency.
            return List(isKeyed(this) ? this.valueSeq() : this);
          },
          // ### Common JavaScript methods and properties
          toString: function toString() {
            return '[Iterable]';
          },
          __toString: function __toString(head, tail) {
            if (this.size === 0) {
              return head + tail;
            }

            return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
          },
          // ### ES6 Collection methods (ES6 Array and Map)
          concat: function concat() {
            var values = SLICE$0.call(arguments, 0);
            return reify(this, concatFactory(this, values));
          },
          includes: function includes(searchValue) {
            return this.some(function (value) {
              return is(value, searchValue);
            });
          },
          entries: function entries() {
            return this.__iterator(ITERATE_ENTRIES);
          },
          every: function every(predicate, context) {
            assertNotInfinite(this.size);
            var returnValue = true;

            this.__iterate(function (v, k, c) {
              if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
              }
            });

            return returnValue;
          },
          filter: function filter(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, true));
          },
          find: function find(predicate, context, notSetValue) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[1] : notSetValue;
          },
          findEntry: function findEntry(predicate, context) {
            var found;

            this.__iterate(function (v, k, c) {
              if (predicate.call(context, v, k, c)) {
                found = [k, v];
                return false;
              }
            });

            return found;
          },
          findLastEntry: function findLastEntry(predicate, context) {
            return this.toSeq().reverse().findEntry(predicate, context);
          },
          forEach: function forEach(sideEffect, context) {
            assertNotInfinite(this.size);
            return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
          },
          join: function join(separator) {
            assertNotInfinite(this.size);
            separator = separator !== undefined ? '' + separator : ',';
            var joined = '';
            var isFirst = true;

            this.__iterate(function (v) {
              isFirst ? isFirst = false : joined += separator;
              joined += v !== null && v !== undefined ? v.toString() : '';
            });

            return joined;
          },
          keys: function keys() {
            return this.__iterator(ITERATE_KEYS);
          },
          map: function map(mapper, context) {
            return reify(this, mapFactory(this, mapper, context));
          },
          reduce: function reduce(reducer, initialReduction, context) {
            assertNotInfinite(this.size);
            var reduction;
            var useFirst;

            if (arguments.length < 2) {
              useFirst = true;
            } else {
              reduction = initialReduction;
            }

            this.__iterate(function (v, k, c) {
              if (useFirst) {
                useFirst = false;
                reduction = v;
              } else {
                reduction = reducer.call(context, reduction, v, k, c);
              }
            });

            return reduction;
          },
          reduceRight: function reduceRight(reducer, initialReduction, context) {
            var reversed = this.toKeyedSeq().reverse();
            return reversed.reduce.apply(reversed, arguments);
          },
          reverse: function reverse() {
            return reify(this, reverseFactory(this, true));
          },
          slice: function slice(begin, end) {
            return reify(this, sliceFactory(this, begin, end, true));
          },
          some: function some(predicate, context) {
            return !this.every(not(predicate), context);
          },
          sort: function sort(comparator) {
            return reify(this, sortFactory(this, comparator));
          },
          values: function values() {
            return this.__iterator(ITERATE_VALUES);
          },
          // ### More sequential methods
          butLast: function butLast() {
            return this.slice(0, -1);
          },
          isEmpty: function isEmpty() {
            return this.size !== undefined ? this.size === 0 : !this.some(function () {
              return true;
            });
          },
          count: function count(predicate, context) {
            return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
          },
          countBy: function countBy(grouper, context) {
            return countByFactory(this, grouper, context);
          },
          equals: function equals(other) {
            return deepEqual(this, other);
          },
          entrySeq: function entrySeq() {
            var iterable = this;

            if (iterable._cache) {
              // We cache as an entries array, so we can just return the cache!
              return new ArraySeq(iterable._cache);
            }

            var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();

            entriesSequence.fromEntrySeq = function () {
              return iterable.toSeq();
            };

            return entriesSequence;
          },
          filterNot: function filterNot(predicate, context) {
            return this.filter(not(predicate), context);
          },
          findLast: function findLast(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
          },
          first: function first() {
            return this.find(returnTrue);
          },
          flatMap: function flatMap(mapper, context) {
            return reify(this, flatMapFactory(this, mapper, context));
          },
          flatten: function flatten(depth) {
            return reify(this, flattenFactory(this, depth, true));
          },
          fromEntrySeq: function fromEntrySeq() {
            return new FromEntriesSequence(this);
          },
          get: function get(searchKey, notSetValue) {
            return this.find(function (_, key) {
              return is(key, searchKey);
            }, undefined, notSetValue);
          },
          getIn: function getIn(searchKeyPath, notSetValue) {
            var nested = this; // Note: in an ES6 environment, we would prefer:
            // for (var key of searchKeyPath) {

            var iter = forceIterator(searchKeyPath);
            var step;

            while (!(step = iter.next()).done) {
              var key = step.value;
              nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;

              if (nested === NOT_SET) {
                return notSetValue;
              }
            }

            return nested;
          },
          groupBy: function groupBy(grouper, context) {
            return groupByFactory(this, grouper, context);
          },
          has: function has(searchKey) {
            return this.get(searchKey, NOT_SET) !== NOT_SET;
          },
          hasIn: function hasIn(searchKeyPath) {
            return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
          },
          isSubset: function isSubset(iter) {
            iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
            return this.every(function (value) {
              return iter.includes(value);
            });
          },
          isSuperset: function isSuperset(iter) {
            iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
            return iter.isSubset(this);
          },
          keySeq: function keySeq() {
            return this.toSeq().map(keyMapper).toIndexedSeq();
          },
          last: function last() {
            return this.toSeq().reverse().first();
          },
          max: function max(comparator) {
            return maxFactory(this, comparator);
          },
          maxBy: function maxBy(mapper, comparator) {
            return maxFactory(this, comparator, mapper);
          },
          min: function min(comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
          },
          minBy: function minBy(mapper, comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
          },
          rest: function rest() {
            return this.slice(1);
          },
          skip: function skip(amount) {
            return this.slice(Math.max(0, amount));
          },
          skipLast: function skipLast(amount) {
            return reify(this, this.toSeq().reverse().skip(amount).reverse());
          },
          skipWhile: function skipWhile(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, true));
          },
          skipUntil: function skipUntil(predicate, context) {
            return this.skipWhile(not(predicate), context);
          },
          sortBy: function sortBy(mapper, comparator) {
            return reify(this, sortFactory(this, comparator, mapper));
          },
          take: function take(amount) {
            return this.slice(0, Math.max(0, amount));
          },
          takeLast: function takeLast(amount) {
            return reify(this, this.toSeq().reverse().take(amount).reverse());
          },
          takeWhile: function takeWhile(predicate, context) {
            return reify(this, takeWhileFactory(this, predicate, context));
          },
          takeUntil: function takeUntil(predicate, context) {
            return this.takeWhile(not(predicate), context);
          },
          valueSeq: function valueSeq() {
            return this.toIndexedSeq();
          },
          // ### Hashable Object
          hashCode: function hashCode() {
            return this.__hash || (this.__hash = hashIterable(this));
          } // ### Internal
          // abstract __iterate(fn, reverse)
          // abstract __iterator(type, reverse)

        }); // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
        // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
        // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
        // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

        var IterablePrototype = Iterable.prototype;
        IterablePrototype[IS_ITERABLE_SENTINEL] = true;
        IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
        IterablePrototype.__toJS = IterablePrototype.toArray;
        IterablePrototype.__toStringMapper = quoteString;

        IterablePrototype.inspect = IterablePrototype.toSource = function () {
          return this.toString();
        };

        IterablePrototype.chain = IterablePrototype.flatMap;
        IterablePrototype.contains = IterablePrototype.includes; // Temporary warning about using length

        (function () {
          try {
            Object.defineProperty(IterablePrototype, 'length', {
              get: function get() {
                if (!Iterable.noLengthWarning) {
                  var stack;

                  try {
                    throw new Error();
                  } catch (error) {
                    stack = error.stack;
                  }

                  if (stack.indexOf('_wrapObject') === -1) {
                    console && console.warn && console.warn('iterable.length has been deprecated, ' + 'use iterable.size or iterable.count(). ' + 'This warning will become a silent error in a future version. ' + stack);
                    return this.size;
                  }
                }
              }
            });
          } catch (e) {}
        })();

        mixin(KeyedIterable, {
          // ### More sequential methods
          flip: function flip() {
            return reify(this, flipFactory(this));
          },
          findKey: function findKey(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry && entry[0];
          },
          findLastKey: function findLastKey(predicate, context) {
            return this.toSeq().reverse().findKey(predicate, context);
          },
          keyOf: function keyOf(searchValue) {
            return this.findKey(function (value) {
              return is(value, searchValue);
            });
          },
          lastKeyOf: function lastKeyOf(searchValue) {
            return this.findLastKey(function (value) {
              return is(value, searchValue);
            });
          },
          mapEntries: function mapEntries(mapper, context) {
            var this$0 = this;
            var iterations = 0;
            return reify(this, this.toSeq().map(function (v, k) {
              return mapper.call(context, [k, v], iterations++, this$0);
            }).fromEntrySeq());
          },
          mapKeys: function mapKeys(mapper, context) {
            var this$0 = this;
            return reify(this, this.toSeq().flip().map(function (k, v) {
              return mapper.call(context, k, v, this$0);
            }).flip());
          }
        });
        var KeyedIterablePrototype = KeyedIterable.prototype;
        KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
        KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
        KeyedIterablePrototype.__toJS = IterablePrototype.toObject;

        KeyedIterablePrototype.__toStringMapper = function (v, k) {
          return JSON.stringify(k) + ': ' + quoteString(v);
        };

        mixin(IndexedIterable, {
          // ### Conversion to other types
          toKeyedSeq: function toKeyedSeq() {
            return new ToKeyedSequence(this, false);
          },
          // ### ES6 Collection methods (ES6 Array and Map)
          filter: function filter(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, false));
          },
          findIndex: function findIndex(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[0] : -1;
          },
          indexOf: function indexOf(searchValue) {
            var key = this.toKeyedSeq().keyOf(searchValue);
            return key === undefined ? -1 : key;
          },
          lastIndexOf: function lastIndexOf(searchValue) {
            var key = this.toKeyedSeq().reverse().keyOf(searchValue);
            return key === undefined ? -1 : key; // var index =
            // return this.toSeq().reverse().indexOf(searchValue);
          },
          reverse: function reverse() {
            return reify(this, reverseFactory(this, false));
          },
          slice: function slice(begin, end) {
            return reify(this, sliceFactory(this, begin, end, false));
          },
          splice: function splice(index, removeNum
          /*, ...values*/
          ) {
            var numArgs = arguments.length;
            removeNum = Math.max(removeNum | 0, 0);

            if (numArgs === 0 || numArgs === 2 && !removeNum) {
              return this;
            } // If index is negative, it should resolve relative to the size of the
            // collection. However size may be expensive to compute if not cached, so
            // only call count() if the number is in fact negative.


            index = resolveBegin(index, index < 0 ? this.count() : this.size);
            var spliced = this.slice(0, index);
            return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
          },
          // ### More collection methods
          findLastIndex: function findLastIndex(predicate, context) {
            var key = this.toKeyedSeq().findLastKey(predicate, context);
            return key === undefined ? -1 : key;
          },
          first: function first() {
            return this.get(0);
          },
          flatten: function flatten(depth) {
            return reify(this, flattenFactory(this, depth, false));
          },
          get: function get(index, notSetValue) {
            index = wrapIndex(this, index);
            return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function (_, key) {
              return key === index;
            }, undefined, notSetValue);
          },
          has: function has(index) {
            index = wrapIndex(this, index);
            return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
          },
          interpose: function interpose(separator) {
            return reify(this, interposeFactory(this, separator));
          },
          interleave: function interleave()
          /*...iterables*/
          {
            var iterables = [this].concat(arrCopy(arguments));
            var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
            var interleaved = zipped.flatten(true);

            if (zipped.size) {
              interleaved.size = zipped.size * iterables.length;
            }

            return reify(this, interleaved);
          },
          last: function last() {
            return this.get(-1);
          },
          skipWhile: function skipWhile(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, false));
          },
          zip: function zip()
          /*, ...iterables */
          {
            var iterables = [this].concat(arrCopy(arguments));
            return reify(this, zipWithFactory(this, defaultZipper, iterables));
          },
          zipWith: function zipWith(zipper
          /*, ...iterables */
          ) {
            var iterables = arrCopy(arguments);
            iterables[0] = this;
            return reify(this, zipWithFactory(this, zipper, iterables));
          }
        });
        IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
        IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
        mixin(SetIterable, {
          // ### ES6 Collection methods (ES6 Array and Map)
          get: function get(value, notSetValue) {
            return this.has(value) ? value : notSetValue;
          },
          includes: function includes(value) {
            return this.has(value);
          },
          // ### More sequential methods
          keySeq: function keySeq() {
            return this.valueSeq();
          }
        });
        SetIterable.prototype.has = IterablePrototype.includes; // Mixin subclasses

        mixin(KeyedSeq, KeyedIterable.prototype);
        mixin(IndexedSeq, IndexedIterable.prototype);
        mixin(SetSeq, SetIterable.prototype);
        mixin(KeyedCollection, KeyedIterable.prototype);
        mixin(IndexedCollection, IndexedIterable.prototype);
        mixin(SetCollection, SetIterable.prototype); // #pragma Helper functions

        function keyMapper(v, k) {
          return k;
        }

        function entryMapper(v, k) {
          return [k, v];
        }

        function not(predicate) {
          return function () {
            return !predicate.apply(this, arguments);
          };
        }

        function neg(predicate) {
          return function () {
            return -predicate.apply(this, arguments);
          };
        }

        function quoteString(value) {
          return typeof value === 'string' ? JSON.stringify(value) : value;
        }

        function defaultZipper() {
          return arrCopy(arguments);
        }

        function defaultNegComparator(a, b) {
          return a < b ? 1 : a > b ? -1 : 0;
        }

        function hashIterable(iterable) {
          if (iterable.size === Infinity) {
            return 0;
          }

          var ordered = isOrdered(iterable);
          var keyed = isKeyed(iterable);
          var h = ordered ? 1 : 0;

          var size = iterable.__iterate(keyed ? ordered ? function (v, k) {
            h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
          } : function (v, k) {
            h = h + hashMerge(hash(v), hash(k)) | 0;
          } : ordered ? function (v) {
            h = 31 * h + hash(v) | 0;
          } : function (v) {
            h = h + hash(v) | 0;
          });

          return murmurHashOfSize(size, h);
        }

        function murmurHashOfSize(size, h) {
          h = imul(h, 0xCC9E2D51);
          h = imul(h << 15 | h >>> -15, 0x1B873593);
          h = imul(h << 13 | h >>> -13, 5);
          h = (h + 0xE6546B64 | 0) ^ size;
          h = imul(h ^ h >>> 16, 0x85EBCA6B);
          h = imul(h ^ h >>> 13, 0xC2B2AE35);
          h = smi(h ^ h >>> 16);
          return h;
        }

        function hashMerge(a, b) {
          return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
        }

        var Immutable = {
          Iterable: Iterable,
          Seq: Seq,
          Collection: Collection,
          Map: Map,
          OrderedMap: OrderedMap,
          List: List,
          Stack: Stack,
          Set: Set,
          OrderedSet: OrderedSet,
          Record: Record,
          Range: Range,
          Repeat: Repeat,
          is: is,
          fromJS: fromJS
        };
        return Immutable;
      });
      /***/

    },
    /* 54 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return Constants;
      });

      var Constants = {
        DefaultFlow: 'main',
        DefaultPageFlow: {
          main: []
        },
        FlowAttributeKey: 'currentFlow',
        FlowChannelsExitPageKey: 'flowChannelsExitPage'
      };
      /***/
    },
    /* 55 */

    /***/
    function (module, exports) {
      /**
       * Checks if `value` is classified as an `Array` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array, else `false`.
       * @example
       *
       * _.isArray([1, 2, 3]);
       * // => true
       *
       * _.isArray(document.body.children);
       * // => false
       *
       * _.isArray('abc');
       * // => false
       *
       * _.isArray(_.noop);
       * // => false
       */
      var isArray = Array.isArray;
      module.exports = isArray;
      /***/
    },
    /* 56 */

    /***/
    function (module, exports) {
      //
      module.exports = function shallowEqual(objA, objB, compare, compareContext) {
        var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

        if (ret !== void 0) {
          return !!ret;
        }

        if (objA === objB) {
          return true;
        }

        if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
          return false;
        }

        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);

        if (keysA.length !== keysB.length) {
          return false;
        }

        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.

        for (var idx = 0; idx < keysA.length; idx++) {
          var key = keysA[idx];

          if (!bHasOwnProperty(key)) {
            return false;
          }

          var valueA = objA[key];
          var valueB = objB[key];
          ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

          if (ret === false || ret === void 0 && valueA !== valueB) {
            return false;
          }
        }

        return true;
      };
      /***/

    },
    /* 57 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return addEventListenerWrap;
      });
      /* harmony import */


      var add_dom_event_listener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(380);
      /* harmony import */


      var add_dom_event_listener__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(add_dom_event_listener__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16);
      /* harmony import */


      var react_dom__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);

      function addEventListenerWrap(target, eventType, cb, option) {
        /* eslint camelcase: 2 */
        var callback = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.unstable_batchedUpdates ? function run(e) {
          react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.unstable_batchedUpdates(cb, e);
        } : cb;
        return add_dom_event_listener__WEBPACK_IMPORTED_MODULE_0___default()(target, eventType, callback, option);
      }
      /***/

    },
    /* 58 */

    /***/
    function (module, exports, __webpack_require__) {
      (function (global, factory) {
        true ? factory(exports, __webpack_require__(1), __webpack_require__(0), __webpack_require__(94), __webpack_require__(715), __webpack_require__(119)) : undefined;
      })(this, function (exports, React, PropTypes, redux, apolloClient, graphqlTag) {
        'use strict';

        graphqlTag = graphqlTag && graphqlTag.hasOwnProperty('default') ? graphqlTag['default'] : graphqlTag;

        var __assign = undefined && undefined.__assign || Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        var __rest = undefined && undefined.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        var ObservableQueryRecycler = function () {
          function ObservableQueryRecycler() {
            this.observableQueries = [];
          }

          ObservableQueryRecycler.prototype.recycle = function (observableQuery) {
            observableQuery.setOptions({
              fetchPolicy: 'standby',
              pollInterval: 0,
              fetchResults: false
            });
            this.observableQueries.push({
              observableQuery: observableQuery,
              subscription: observableQuery.subscribe({})
            });
          };

          ObservableQueryRecycler.prototype.reuse = function (options) {
            if (this.observableQueries.length <= 0) {
              return null;
            }

            var _a = this.observableQueries.pop(),
                observableQuery = _a.observableQuery,
                subscription = _a.subscription;

            subscription.unsubscribe();

            var ssr = options.ssr,
                skip = options.skip,
                client = options.client,
                modifiableOpts = __rest(options, ["ssr", "skip", "client"]);

            observableQuery.setOptions(__assign({}, modifiableOpts, {
              pollInterval: options.pollInterval,
              fetchPolicy: options.fetchPolicy
            }));
            return observableQuery;
          };

          return ObservableQueryRecycler;
        }();

        var __extends$1 = undefined && undefined.__extends || function () {
          var extendStatics = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) {
              if (b.hasOwnProperty(p)) d[p] = b[p];
            }
          };

          return function (d, b) {
            extendStatics(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var QueryRecyclerProvider = function (_super) {
          __extends$1(QueryRecyclerProvider, _super);

          function QueryRecyclerProvider(props) {
            var _this = _super.call(this, props) || this;

            _this.recyclers = new WeakMap();
            _this.getQueryRecycler = _this.getQueryRecycler.bind(_this);
            return _this;
          }

          QueryRecyclerProvider.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (this.context.client !== nextContext.client) {
              this.recyclers = new WeakMap();
            }
          };

          QueryRecyclerProvider.prototype.getQueryRecycler = function (component) {
            if (!this.recyclers.has(component)) {
              this.recyclers.set(component, new ObservableQueryRecycler());
            }

            return this.recyclers.get(component);
          };

          QueryRecyclerProvider.prototype.getChildContext = function () {
            return {
              getQueryRecycler: this.getQueryRecycler
            };
          };

          QueryRecyclerProvider.prototype.render = function () {
            return React.Children.only(this.props.children);
          };

          QueryRecyclerProvider.propTypes = {
            children: PropTypes.element.isRequired
          };
          QueryRecyclerProvider.contextTypes = {
            client: PropTypes.object
          };
          QueryRecyclerProvider.childContextTypes = {
            getQueryRecycler: PropTypes.func.isRequired
          };
          return QueryRecyclerProvider;
        }(React.Component);

        var __extends = undefined && undefined.__extends || function () {
          var extendStatics = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) {
              if (b.hasOwnProperty(p)) d[p] = b[p];
            }
          };

          return function (d, b) {
            extendStatics(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var invariant = __webpack_require__(141);

        var ApolloProvider = function (_super) {
          __extends(ApolloProvider, _super);

          function ApolloProvider(props, context) {
            var _this = _super.call(this, props, context) || this;

            invariant(props.client, 'ApolloClient was not passed a client instance. Make ' + 'sure you pass in your client via the "client" prop.');

            if (!props.store && typeof props.client.initStore === 'function') {
              props.client.initStore();
            }

            return _this;
          }

          ApolloProvider.prototype.componentWillReceiveProps = function (nextProps) {
            if (nextProps.client !== this.props.client && !nextProps.store && typeof nextProps.client.initStore === 'function') {
              nextProps.client.initStore();
            }
          };

          ApolloProvider.prototype.getChildContext = function () {
            return {
              store: this.props.store || this.context.store,
              client: this.props.client
            };
          };

          ApolloProvider.prototype.render = function () {
            return React.createElement(QueryRecyclerProvider, null, React.Children.only(this.props.children));
          };

          ApolloProvider.propTypes = {
            store: PropTypes.shape({
              subscribe: PropTypes.func.isRequired,
              dispatch: PropTypes.func.isRequired,
              getState: PropTypes.func.isRequired
            }),
            client: PropTypes.object.isRequired,
            children: PropTypes.element.isRequired
          };
          ApolloProvider.childContextTypes = {
            store: PropTypes.object,
            client: PropTypes.object.isRequired
          };
          ApolloProvider.contextTypes = {
            store: PropTypes.object
          };
          return ApolloProvider;
        }(React.Component);

        function shallowEqual(objA, objB) {
          if (!objA || !objB) return false;
          if (objA === objB) return true;
          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);
          if (keysA.length !== keysB.length) return false;
          var hasOwn = Object.prototype.hasOwnProperty;

          for (var i = 0; i < keysA.length; i++) {
            if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
              return false;
            }
          }

          return true;
        }

        var invariant$2 = __webpack_require__(141);

        var DocumentType;

        (function (DocumentType) {
          DocumentType[DocumentType["Query"] = 0] = "Query";
          DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
          DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
        })(DocumentType || (DocumentType = {}));

        function parser(document) {
          var variables, type, name;
          invariant$2(!!document && !!document.kind, "Argument of " + document + " passed to parser was not a valid GraphQL DocumentNode. You may need to use 'graphql-tag' or another method to convert your operation into a document");
          var fragments = document.definitions.filter(function (x) {
            return x.kind === 'FragmentDefinition';
          });
          var queries = document.definitions.filter(function (x) {
            return x.kind === 'OperationDefinition' && x.operation === 'query';
          });
          var mutations = document.definitions.filter(function (x) {
            return x.kind === 'OperationDefinition' && x.operation === 'mutation';
          });
          var subscriptions = document.definitions.filter(function (x) {
            return x.kind === 'OperationDefinition' && x.operation === 'subscription';
          });
          invariant$2(!fragments.length || queries.length || mutations.length || subscriptions.length, "Passing only a fragment to 'graphql' is not yet supported. You must include a query, subscription or mutation as well");
          invariant$2(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " + document + " had " + queries.length + " queries, " + subscriptions.length + " subscriptions and " + mutations.length + " mutations. You can use 'compose' to join multiple operation types to a component");
          type = queries.length ? DocumentType.Query : DocumentType.Mutation;
          if (!queries.length && !mutations.length) type = DocumentType.Subscription;
          var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
          invariant$2(definitions.length === 1, "react-apollo only supports one defintion per HOC. " + document + " had " + definitions.length + " definitions. You can use 'compose' to join multiple operation types to a component");
          var definition = definitions[0];
          variables = definition.variableDefinitions || [];
          var hasName = definition.name && definition.name.kind === 'Name';
          name = hasName ? definition.name.value : 'data';
          return {
            name: name,
            type: type,
            variables: variables
          };
        }

        var __extends$2 = undefined && undefined.__extends || function () {
          var extendStatics = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) {
              if (b.hasOwnProperty(p)) d[p] = b[p];
            }
          };

          return function (d, b) {
            extendStatics(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign$1 = undefined && undefined.__assign || Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        var pick = __webpack_require__(1183);

        var invariant$1 = __webpack_require__(141);

        var assign = __webpack_require__(82);

        var hoistNonReactStatics = __webpack_require__(370);

        var defaultMapPropsToOptions = function defaultMapPropsToOptions(props) {
          return {};
        };

        var defaultMapResultToProps = function defaultMapResultToProps(props) {
          return props;
        };

        var defaultMapPropsToSkip = function defaultMapPropsToSkip(props) {
          return false;
        };

        function observableQueryFields(observable) {
          var fields = pick(observable, 'variables', 'refetch', 'fetchMore', 'updateQuery', 'startPolling', 'stopPolling', 'subscribeToMore');
          Object.keys(fields).forEach(function (key) {
            if (typeof fields[key] === 'function') {
              fields[key] = fields[key].bind(observable);
            }
          });
          return fields;
        }

        function getDisplayName(WrappedComponent) {
          return WrappedComponent.displayName || WrappedComponent.name || 'Component';
        }

        var nextVersion = 0;

        function graphql(document, operationOptions) {
          if (operationOptions === void 0) {
            operationOptions = {};
          }

          var _a = operationOptions.options,
              options = _a === void 0 ? defaultMapPropsToOptions : _a,
              _b = operationOptions.skip,
              skip = _b === void 0 ? defaultMapPropsToSkip : _b,
              _c = operationOptions.alias,
              alias = _c === void 0 ? 'Apollo' : _c;
          var mapPropsToOptions = options;
          if (typeof mapPropsToOptions !== 'function') mapPropsToOptions = function mapPropsToOptions() {
            return options;
          };
          var mapPropsToSkip = skip;
          if (typeof mapPropsToSkip !== 'function') mapPropsToSkip = function mapPropsToSkip() {
            return skip;
          };
          var mapResultToProps = operationOptions.props;
          var operation = parser(document);
          var version = nextVersion++;

          function wrapWithApolloComponent(WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";

            var GraphQL = function (_super) {
              __extends$2(GraphQL, _super);

              function GraphQL(props, context) {
                var _this = _super.call(this, props, context) || this;

                _this.previousData = {};
                _this.version = version;
                _this.type = operation.type;
                _this.dataForChildViaMutation = _this.dataForChildViaMutation.bind(_this);
                _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
                return _this;
              }

              GraphQL.prototype.componentWillMount = function () {
                if (!this.shouldSkip(this.props)) {
                  this.setInitialProps();
                }
              };

              GraphQL.prototype.componentDidMount = function () {
                this.hasMounted = true;
                if (this.type === DocumentType.Mutation) return;

                if (!this.shouldSkip(this.props)) {
                  this.subscribeToQuery();

                  if (this.refetcherQueue) {
                    var _a = this.refetcherQueue,
                        args = _a.args,
                        resolve = _a.resolve,
                        reject = _a.reject;
                    this.queryObservable.refetch(args).then(resolve).catch(reject);
                  }
                }
              };

              GraphQL.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
                var client = mapPropsToOptions(nextProps).client;

                if (shallowEqual(this.props, nextProps) && (this.client === client || this.client === nextContext.client)) {
                  return;
                }

                this.shouldRerender = true;

                if (this.client !== client && this.client !== nextContext.client) {
                  if (client) {
                    this.client = client;
                  } else {
                    this.client = nextContext.client;
                  }

                  this.unsubscribeFromQuery();
                  this.queryObservable = null;
                  this.previousData = {};
                  this.updateQuery(nextProps);

                  if (!this.shouldSkip(nextProps)) {
                    this.subscribeToQuery();
                  }

                  return;
                }

                if (this.type === DocumentType.Mutation) {
                  return;
                }

                if (this.type === DocumentType.Subscription && operationOptions.shouldResubscribe && operationOptions.shouldResubscribe(this.props, nextProps)) {
                  this.unsubscribeFromQuery();
                  delete this.queryObservable;
                  this.updateQuery(nextProps);
                  this.subscribeToQuery();
                  return;
                }

                if (this.shouldSkip(nextProps)) {
                  if (!this.shouldSkip(this.props)) {
                    this.unsubscribeFromQuery();
                  }

                  return;
                }

                this.updateQuery(nextProps);
                this.subscribeToQuery();
              };

              GraphQL.prototype.componentWillUnmount = function () {
                if (this.type === DocumentType.Query) {
                  if (this.queryObservable) {
                    var recycler = this.getQueryRecycler();

                    if (recycler) {
                      recycler.recycle(this.queryObservable);
                      delete this.queryObservable;
                    }
                  }

                  this.unsubscribeFromQuery();
                }

                if (this.type === DocumentType.Subscription) this.unsubscribeFromQuery();
                this.hasMounted = false;
              };

              GraphQL.prototype.getQueryRecycler = function () {
                return this.context.getQueryRecycler && this.context.getQueryRecycler(GraphQL);
              };

              GraphQL.prototype.getClient = function (props) {
                if (this.client) return this.client;
                var client = mapPropsToOptions(props).client;

                if (client) {
                  this.client = client;
                } else {
                  this.client = this.context.client;
                }

                invariant$1(!!this.client, "Could not find \"client\" in the context of " + ("\"" + graphQLDisplayName + "\". ") + "Wrap the root component in an <ApolloProvider>");
                return this.client;
              };

              GraphQL.prototype.calculateOptions = function (props, newOpts) {
                if (props === void 0) {
                  props = this.props;
                }

                var opts = mapPropsToOptions(props);

                if (newOpts && newOpts.variables) {
                  newOpts.variables = assign({}, opts.variables, newOpts.variables);
                }

                if (newOpts) opts = assign({}, opts, newOpts);
                if (opts.variables || !operation.variables.length) return opts;
                var variables = {};

                for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
                  var _b = _a[_i],
                      variable = _b.variable,
                      type = _b.type;
                  if (!variable.name || !variable.name.value) continue;

                  if (typeof props[variable.name.value] !== 'undefined') {
                    variables[variable.name.value] = props[variable.name.value];
                    continue;
                  }

                  if (type.kind !== 'NonNullType') {
                    variables[variable.name.value] = null;
                    continue;
                  }

                  invariant$1(typeof props[variable.name.value] !== 'undefined', "The operation '" + operation.name + "' wrapping '" + getDisplayName(WrappedComponent) + "' " + ("is expecting a variable: '" + variable.name.value + "' but it was not found in the props ") + ("passed to '" + graphQLDisplayName + "'"));
                }

                opts = __assign$1({}, opts, {
                  variables: variables
                });
                return opts;
              };

              GraphQL.prototype.calculateResultProps = function (result) {
                var name = this.type === DocumentType.Mutation ? 'mutate' : 'data';
                if (operationOptions.name) name = operationOptions.name;
                var newResult = (_a = {}, _a[name] = result, _a.ownProps = this.props, _a);
                if (mapResultToProps) return mapResultToProps(newResult);
                return _b = {}, _b[name] = defaultMapResultToProps(result), _b;

                var _a, _b;
              };

              GraphQL.prototype.setInitialProps = function () {
                if (this.type === DocumentType.Mutation) {
                  return;
                }

                var opts = this.calculateOptions(this.props);
                this.createQuery(opts);
              };

              GraphQL.prototype.createQuery = function (opts, props) {
                if (props === void 0) {
                  props = this.props;
                }

                if (this.type === DocumentType.Subscription) {
                  this.queryObservable = this.getClient(props).subscribe(assign({
                    query: document
                  }, opts));
                } else {
                  var recycler = this.getQueryRecycler();
                  var queryObservable = null;
                  if (recycler) queryObservable = recycler.reuse(opts);

                  if (queryObservable === null) {
                    this.queryObservable = this.getClient(props).watchQuery(assign({
                      query: document,
                      metadata: {
                        reactComponent: {
                          displayName: graphQLDisplayName
                        }
                      }
                    }, opts));
                  } else {
                    this.queryObservable = queryObservable;
                  }
                }
              };

              GraphQL.prototype.updateQuery = function (props) {
                var opts = this.calculateOptions(props);

                if (!this.queryObservable) {
                  this.createQuery(opts, props);
                }

                if (this.queryObservable._setOptionsNoResult) {
                  this.queryObservable._setOptionsNoResult(opts);
                } else {
                  if (this.queryObservable.setOptions) {
                    this.queryObservable.setOptions(opts).catch(function (error) {
                      return null;
                    });
                  }
                }
              };

              GraphQL.prototype.fetchData = function () {
                if (this.shouldSkip()) return false;
                if (operation.type === DocumentType.Mutation || operation.type === DocumentType.Subscription) return false;
                var opts = this.calculateOptions();
                if (opts.ssr === false) return false;

                if (opts.fetchPolicy === 'network-only' || opts.fetchPolicy === 'cache-and-network') {
                  opts.fetchPolicy = 'cache-first';
                }

                var observable = this.getClient(this.props).watchQuery(assign({
                  query: document
                }, opts));
                var result = observable.currentResult();

                if (result.loading) {
                  return observable.result();
                } else {
                  return false;
                }
              };

              GraphQL.prototype.subscribeToQuery = function () {
                var _this = this;

                if (this.querySubscription) {
                  return;
                }

                var next = function next(results) {
                  if (_this.type === DocumentType.Subscription) {
                    _this.lastSubscriptionData = results;
                    results = {
                      data: results
                    };
                  }

                  var clashingKeys = Object.keys(observableQueryFields(results.data));
                  invariant$1(clashingKeys.length === 0, "the result of the '" + graphQLDisplayName + "' operation contains keys that " + "conflict with the return object." + clashingKeys.map(function (k) {
                    return "'" + k + "'";
                  }).join(', ') + " not allowed.");

                  _this.forceRenderChildren();
                };

                var handleError = function handleError(error) {
                  if (error.hasOwnProperty('graphQLErrors')) return next({
                    error: error
                  });
                  throw error;
                };

                this.querySubscription = this.queryObservable.subscribe({
                  next: next,
                  error: handleError
                });
              };

              GraphQL.prototype.unsubscribeFromQuery = function () {
                if (this.querySubscription) {
                  this.querySubscription.unsubscribe();
                  delete this.querySubscription;
                }
              };

              GraphQL.prototype.shouldSkip = function (props) {
                if (props === void 0) {
                  props = this.props;
                }

                return mapPropsToSkip(props) || mapPropsToOptions(props).skip;
              };

              GraphQL.prototype.forceRenderChildren = function () {
                this.shouldRerender = true;
                if (this.hasMounted) this.forceUpdate();
              };

              GraphQL.prototype.getWrappedInstance = function () {
                invariant$1(operationOptions.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
                return this.wrappedInstance;
              };

              GraphQL.prototype.setWrappedInstance = function (ref) {
                this.wrappedInstance = ref;
              };

              GraphQL.prototype.dataForChildViaMutation = function (mutationOpts) {
                var opts = this.calculateOptions(this.props, mutationOpts);
                if (typeof opts.variables === 'undefined') delete opts.variables;
                opts.mutation = document;
                return this.getClient(this.props).mutate(opts);
              };

              GraphQL.prototype.dataForChild = function () {
                var _this = this;

                if (this.type === DocumentType.Mutation) {
                  return this.dataForChildViaMutation;
                }

                var opts = this.calculateOptions(this.props);
                var data = {};
                assign(data, observableQueryFields(this.queryObservable));

                if (this.type === DocumentType.Subscription) {
                  assign(data, {
                    loading: !this.lastSubscriptionData,
                    variables: opts.variables
                  }, this.lastSubscriptionData);
                } else {
                  var currentResult = this.queryObservable.currentResult();
                  var loading = currentResult.loading,
                      error_1 = currentResult.error,
                      networkStatus = currentResult.networkStatus;
                  assign(data, {
                    loading: loading,
                    networkStatus: networkStatus
                  });
                  var logErrorTimeoutId_1 = setTimeout(function () {
                    if (error_1) {
                      console.error('Unhandled (in react-apollo)', error_1.stack || error_1);
                    }
                  }, 10);
                  Object.defineProperty(data, 'error', {
                    configurable: true,
                    enumerable: true,
                    get: function get() {
                      clearTimeout(logErrorTimeoutId_1);
                      return error_1;
                    }
                  });

                  if (loading) {
                    assign(data, this.previousData, currentResult.data);
                  } else if (error_1) {
                    assign(data, (this.queryObservable.getLastResult() || {}).data);
                  } else {
                    assign(data, currentResult.data);
                    this.previousData = currentResult.data;
                  }

                  if (!this.querySubscription) {
                    data.refetch = function (args) {
                      return new Promise(function (r, f) {
                        _this.refetcherQueue = {
                          resolve: r,
                          reject: f,
                          args: args
                        };
                      });
                    };
                  }
                }

                return data;
              };

              GraphQL.prototype.render = function () {
                if (this.shouldSkip()) {
                  if (operationOptions.withRef) {
                    return React.createElement(WrappedComponent, assign({}, this.props, {
                      ref: this.setWrappedInstance
                    }));
                  }

                  return React.createElement(WrappedComponent, this.props);
                }

                var _a = this,
                    shouldRerender = _a.shouldRerender,
                    renderedElement = _a.renderedElement,
                    props = _a.props;

                this.shouldRerender = false;

                if (!shouldRerender && renderedElement && renderedElement.type === WrappedComponent) {
                  return renderedElement;
                }

                var data = this.dataForChild();
                var clientProps = this.calculateResultProps(data);
                var mergedPropsAndData = assign({}, props, clientProps);
                if (operationOptions.withRef) mergedPropsAndData.ref = this.setWrappedInstance;
                this.renderedElement = React.createElement(WrappedComponent, mergedPropsAndData);
                return this.renderedElement;
              };

              GraphQL.displayName = graphQLDisplayName;
              GraphQL.WrappedComponent = WrappedComponent;
              GraphQL.contextTypes = {
                client: PropTypes.object,
                getQueryRecycler: PropTypes.func
              };
              return GraphQL;
            }(React.Component);

            return hoistNonReactStatics(GraphQL, WrappedComponent, {});
          }

          return wrapWithApolloComponent;
        }

        var __extends$3 = undefined && undefined.__extends || function () {
          var extendStatics = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) {
              if (b.hasOwnProperty(p)) d[p] = b[p];
            }
          };

          return function (d, b) {
            extendStatics(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var invariant$3 = __webpack_require__(141);

        var assign$1 = __webpack_require__(82);

        var hoistNonReactStatics$1 = __webpack_require__(370);

        function getDisplayName$1(WrappedComponent) {
          return WrappedComponent.displayName || WrappedComponent.name || 'Component';
        }

        function withApollo(WrappedComponent, operationOptions) {
          if (operationOptions === void 0) {
            operationOptions = {};
          }

          var withDisplayName = "withApollo(" + getDisplayName$1(WrappedComponent) + ")";

          var WithApollo = function (_super) {
            __extends$3(WithApollo, _super);

            function WithApollo(props, context) {
              var _this = _super.call(this, props, context) || this;

              _this.client = context.client;
              _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
              invariant$3(!!_this.client, "Could not find \"client\" in the context of " + ("\"" + withDisplayName + "\". ") + "Wrap the root component in an <ApolloProvider>");
              return _this;
            }

            WithApollo.prototype.getWrappedInstance = function () {
              invariant$3(operationOptions.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
              return this.wrappedInstance;
            };

            WithApollo.prototype.setWrappedInstance = function (ref) {
              this.wrappedInstance = ref;
            };

            WithApollo.prototype.render = function () {
              var props = assign$1({}, this.props);
              props.client = this.client;
              if (operationOptions.withRef) props.ref = this.setWrappedInstance;
              return React.createElement(WrappedComponent, props);
            };

            WithApollo.displayName = withDisplayName;
            WithApollo.WrappedComponent = WrappedComponent;
            WithApollo.contextTypes = {
              client: PropTypes.object.isRequired
            };
            return WithApollo;
          }(React.Component);

          return hoistNonReactStatics$1(WithApollo, WrappedComponent, {});
        }

        exports.ApolloProvider = ApolloProvider;
        exports.graphql = graphql;
        exports.withApollo = withApollo;
        exports.compose = redux.compose;
        exports.gql = graphqlTag;
        Object.keys(apolloClient).forEach(function (key) {
          exports[key] = apolloClient[key];
        });
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
      });
      /***/

    },
    /* 59 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      var isBigNumber = __webpack_require__(308);
      /**
       * Clone an object
       *
       *     clone(x)
       *
       * Can clone any primitive type, array, and object.
       * If x has a function clone, this function will be invoked to clone the object.
       *
       * @param {*} x
       * @return {*} clone
       */


      exports.clone = function clone(x) {
        var type = _typeof(x); // immutable primitive types


        if (type === 'number' || type === 'string' || type === 'boolean' || x === null || x === undefined) {
          return x;
        } // use clone function of the object when available


        if (typeof x.clone === 'function') {
          return x.clone();
        } // array


        if (Array.isArray(x)) {
          return x.map(function (value) {
            return clone(value);
          });
        }

        if (x instanceof Date) return new Date(x.valueOf());
        if (isBigNumber(x)) return x; // bignumbers are immutable

        if (x instanceof RegExp) throw new TypeError('Cannot clone ' + x); // TODO: clone a RegExp
        // object

        return exports.map(x, clone);
      };
      /**
       * Apply map to all properties of an object
       * @param {Object} object
       * @param {function} callback
       * @return {Object} Returns a copy of the object with mapped properties
       */


      exports.map = function (object, callback) {
        var clone = {};

        for (var key in object) {
          if (exports.hasOwnProperty(object, key)) {
            clone[key] = callback(object[key]);
          }
        }

        return clone;
      };
      /**
       * Extend object a with the properties of object b
       * @param {Object} a
       * @param {Object} b
       * @return {Object} a
       */


      exports.extend = function (a, b) {
        for (var prop in b) {
          if (exports.hasOwnProperty(b, prop)) {
            a[prop] = b[prop];
          }
        }

        return a;
      };
      /**
       * Deep extend an object a with the properties of object b
       * @param {Object} a
       * @param {Object} b
       * @returns {Object}
       */


      exports.deepExtend = function deepExtend(a, b) {
        // TODO: add support for Arrays to deepExtend
        if (Array.isArray(b)) {
          throw new TypeError('Arrays are not supported by deepExtend');
        }

        for (var prop in b) {
          if (exports.hasOwnProperty(b, prop)) {
            if (b[prop] && b[prop].constructor === Object) {
              if (a[prop] === undefined) {
                a[prop] = {};
              }

              if (a[prop].constructor === Object) {
                deepExtend(a[prop], b[prop]);
              } else {
                a[prop] = b[prop];
              }
            } else if (Array.isArray(b[prop])) {
              throw new TypeError('Arrays are not supported by deepExtend');
            } else {
              a[prop] = b[prop];
            }
          }
        }

        return a;
      };
      /**
       * Deep test equality of all fields in two pairs of arrays or objects.
       * @param {Array | Object} a
       * @param {Array | Object} b
       * @returns {boolean}
       */


      exports.deepEqual = function deepEqual(a, b) {
        var prop, i, len;

        if (Array.isArray(a)) {
          if (!Array.isArray(b)) {
            return false;
          }

          if (a.length !== b.length) {
            return false;
          }

          for (i = 0, len = a.length; i < len; i++) {
            if (!exports.deepEqual(a[i], b[i])) {
              return false;
            }
          }

          return true;
        } else if (a instanceof Object) {
          if (Array.isArray(b) || !(b instanceof Object)) {
            return false;
          }

          for (prop in a) {
            // noinspection JSUnfilteredForInLoop
            if (!exports.deepEqual(a[prop], b[prop])) {
              return false;
            }
          }

          for (prop in b) {
            // noinspection JSUnfilteredForInLoop
            if (!exports.deepEqual(a[prop], b[prop])) {
              return false;
            }
          }

          return true;
        } else {
          return a === b;
        }
      };
      /**
       * Test whether the current JavaScript engine supports Object.defineProperty
       * @returns {boolean} returns true if supported
       */


      exports.canDefineProperty = function () {
        // test needed for broken IE8 implementation
        try {
          if (Object.defineProperty) {
            Object.defineProperty({}, 'x', {
              get: function get() {}
            });
            return true;
          }
        } catch (e) {}

        return false;
      };
      /**
       * Attach a lazy loading property to a constant.
       * The given function `fn` is called once when the property is first requested.
       * On older browsers (<IE8), the function will fall back to direct evaluation
       * of the properties value.
       * @param {Object} object   Object where to add the property
       * @param {string} prop     Property name
       * @param {Function} fn     Function returning the property value. Called
       *                          without arguments.
       */


      exports.lazy = function (object, prop, fn) {
        if (exports.canDefineProperty()) {
          var _uninitialized = true;

          var _value;

          Object.defineProperty(object, prop, {
            get: function get() {
              if (_uninitialized) {
                _value = fn();
                _uninitialized = false;
              }

              return _value;
            },
            set: function set(value) {
              _value = value;
              _uninitialized = false;
            },
            configurable: true,
            enumerable: true
          });
        } else {
          // fall back to immediate evaluation
          object[prop] = fn();
        }
      };
      /**
       * Traverse a path into an object.
       * When a namespace is missing, it will be created
       * @param {Object} object
       * @param {string} path   A dot separated string like 'name.space'
       * @return {Object} Returns the object at the end of the path
       */


      exports.traverse = function (object, path) {
        var obj = object;

        if (path) {
          var names = path.split('.');

          for (var i = 0; i < names.length; i++) {
            var name = names[i];

            if (!(name in obj)) {
              obj[name] = {};
            }

            obj = obj[name];
          }
        }

        return obj;
      };
      /**
       * A safe hasOwnProperty
       * @param {Object} object
       * @param {string} property
       */


      exports.hasOwnProperty = function (object, property) {
        return object && Object.hasOwnProperty.call(object, property);
      };
      /**
       * Test whether an object is a factory. a factory has fields:
       *
       * - factory: function (type: Object, config: Object, load: function, typed: function [, math: Object])   (required)
       * - name: string (optional)
       * - path: string    A dot separated path (optional)
       * - math: boolean   If true (false by default), the math namespace is passed
       *                   as fifth argument of the factory function
       *
       * @param {*} object
       * @returns {boolean}
       */


      exports.isFactory = function (object) {
        return object && typeof object.factory === 'function';
      };
      /***/

    },
    /* 60 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule EditorState
       * @format
       * 
       */

      var _assign = __webpack_require__(82);

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var BlockTree = __webpack_require__(480);

      var ContentState = __webpack_require__(344);

      var EditorBidiService = __webpack_require__(1022);

      var Immutable = __webpack_require__(53);

      var SelectionState = __webpack_require__(174);

      var OrderedSet = Immutable.OrderedSet,
          Record = Immutable.Record,
          Stack = Immutable.Stack;
      var defaultRecord = {
        allowUndo: true,
        currentContent: null,
        decorator: null,
        directionMap: null,
        forceSelection: false,
        inCompositionMode: false,
        inlineStyleOverride: null,
        lastChangeType: null,
        nativelyRenderedContent: null,
        redoStack: Stack(),
        selection: null,
        treeMap: null,
        undoStack: Stack()
      };
      var EditorStateRecord = Record(defaultRecord);

      var EditorState = function () {
        EditorState.createEmpty = function createEmpty(decorator) {
          return EditorState.createWithContent(ContentState.createFromText(''), decorator);
        };

        EditorState.createWithContent = function createWithContent(contentState, decorator) {
          var firstKey = contentState.getBlockMap().first().getKey();
          return EditorState.create({
            currentContent: contentState,
            undoStack: Stack(),
            redoStack: Stack(),
            decorator: decorator || null,
            selection: SelectionState.createEmpty(firstKey)
          });
        };

        EditorState.create = function create(config) {
          var currentContent = config.currentContent,
              decorator = config.decorator;

          var recordConfig = _extends({}, config, {
            treeMap: generateNewTreeMap(currentContent, decorator),
            directionMap: EditorBidiService.getDirectionMap(currentContent)
          });

          return new EditorState(new EditorStateRecord(recordConfig));
        };

        EditorState.set = function set(editorState, put) {
          var map = editorState.getImmutable().withMutations(function (state) {
            var existingDecorator = state.get('decorator');
            var decorator = existingDecorator;

            if (put.decorator === null) {
              decorator = null;
            } else if (put.decorator) {
              decorator = put.decorator;
            }

            var newContent = put.currentContent || editorState.getCurrentContent();

            if (decorator !== existingDecorator) {
              var treeMap = state.get('treeMap');
              var newTreeMap;

              if (decorator && existingDecorator) {
                newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
              } else {
                newTreeMap = generateNewTreeMap(newContent, decorator);
              }

              state.merge({
                decorator: decorator,
                treeMap: newTreeMap,
                nativelyRenderedContent: null
              });
              return;
            }

            var existingContent = editorState.getCurrentContent();

            if (newContent !== existingContent) {
              state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
            }

            state.merge(put);
          });
          return new EditorState(map);
        };

        EditorState.prototype.toJS = function toJS() {
          return this.getImmutable().toJS();
        };

        EditorState.prototype.getAllowUndo = function getAllowUndo() {
          return this.getImmutable().get('allowUndo');
        };

        EditorState.prototype.getCurrentContent = function getCurrentContent() {
          return this.getImmutable().get('currentContent');
        };

        EditorState.prototype.getUndoStack = function getUndoStack() {
          return this.getImmutable().get('undoStack');
        };

        EditorState.prototype.getRedoStack = function getRedoStack() {
          return this.getImmutable().get('redoStack');
        };

        EditorState.prototype.getSelection = function getSelection() {
          return this.getImmutable().get('selection');
        };

        EditorState.prototype.getDecorator = function getDecorator() {
          return this.getImmutable().get('decorator');
        };

        EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
          return this.getImmutable().get('inCompositionMode');
        };

        EditorState.prototype.mustForceSelection = function mustForceSelection() {
          return this.getImmutable().get('forceSelection');
        };

        EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
          return this.getImmutable().get('nativelyRenderedContent');
        };

        EditorState.prototype.getLastChangeType = function getLastChangeType() {
          return this.getImmutable().get('lastChangeType');
        };
        /**
         * While editing, the user may apply inline style commands with a collapsed
         * cursor, intending to type text that adopts the specified style. In this
         * case, we track the specified style as an "override" that takes precedence
         * over the inline style of the text adjacent to the cursor.
         *
         * If null, there is no override in place.
         */


        EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
          return this.getImmutable().get('inlineStyleOverride');
        };

        EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
          return EditorState.set(editorState, {
            inlineStyleOverride: inlineStyleOverride
          });
        };
        /**
         * Get the appropriate inline style for the editor state. If an
         * override is in place, use it. Otherwise, the current style is
         * based on the location of the selection state.
         */


        EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
          var override = this.getInlineStyleOverride();

          if (override != null) {
            return override;
          }

          var content = this.getCurrentContent();
          var selection = this.getSelection();

          if (selection.isCollapsed()) {
            return getInlineStyleForCollapsedSelection(content, selection);
          }

          return getInlineStyleForNonCollapsedSelection(content, selection);
        };

        EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
          return this.getImmutable().getIn(['treeMap', blockKey]);
        };

        EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
          var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
          return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
        };

        EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
          var content = this.getCurrentContent();
          var blockMap = content.getBlockMap();
          var last = blockMap.last();
          var end = last.getLength();
          return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
        };

        EditorState.prototype.getDirectionMap = function getDirectionMap() {
          return this.getImmutable().get('directionMap');
        };
        /**
         * Incorporate native DOM selection changes into the EditorState. This
         * method can be used when we simply want to accept whatever the DOM
         * has given us to represent selection, and we do not need to re-render
         * the editor.
         *
         * To forcibly move the DOM selection, see `EditorState.forceSelection`.
         */


        EditorState.acceptSelection = function acceptSelection(editorState, selection) {
          return updateSelection(editorState, selection, false);
        };
        /**
         * At times, we need to force the DOM selection to be where we
         * need it to be. This can occur when the anchor or focus nodes
         * are non-text nodes, for instance. In this case, we want to trigger
         * a re-render of the editor, which in turn forces selection into
         * the correct place in the DOM. The `forceSelection` method
         * accomplishes this.
         *
         * This method should be used in cases where you need to explicitly
         * move the DOM selection from one place to another without a change
         * in ContentState.
         */


        EditorState.forceSelection = function forceSelection(editorState, selection) {
          if (!selection.getHasFocus()) {
            selection = selection.set('hasFocus', true);
          }

          return updateSelection(editorState, selection, true);
        };
        /**
         * Move selection to the end of the editor without forcing focus.
         */


        EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
          var content = editorState.getCurrentContent();
          var lastBlock = content.getLastBlock();
          var lastKey = lastBlock.getKey();
          var length = lastBlock.getLength();
          return EditorState.acceptSelection(editorState, new SelectionState({
            anchorKey: lastKey,
            anchorOffset: length,
            focusKey: lastKey,
            focusOffset: length,
            isBackward: false
          }));
        };
        /**
         * Force focus to the end of the editor. This is useful in scenarios
         * where we want to programmatically focus the input and it makes sense
         * to allow the user to continue working seamlessly.
         */


        EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
          var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
          return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
        };
        /**
         * Push the current ContentState onto the undo stack if it should be
         * considered a boundary state, and set the provided ContentState as the
         * new current content.
         */


        EditorState.push = function push(editorState, contentState, changeType) {
          if (editorState.getCurrentContent() === contentState) {
            return editorState;
          }

          var forceSelection = changeType !== 'insert-characters';
          var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());

          if (!editorState.getAllowUndo()) {
            return EditorState.set(editorState, {
              currentContent: contentState,
              directionMap: directionMap,
              lastChangeType: changeType,
              selection: contentState.getSelectionAfter(),
              forceSelection: forceSelection,
              inlineStyleOverride: null
            });
          }

          var selection = editorState.getSelection();
          var currentContent = editorState.getCurrentContent();
          var undoStack = editorState.getUndoStack();
          var newContent = contentState;

          if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
            undoStack = undoStack.push(currentContent);
            newContent = newContent.set('selectionBefore', selection);
          } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
            // Preserve the previous selection.
            newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
          }

          var inlineStyleOverride = editorState.getInlineStyleOverride(); // Don't discard inline style overrides for the following change types:

          var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

          if (overrideChangeTypes.indexOf(changeType) === -1) {
            inlineStyleOverride = null;
          }

          var editorStateChanges = {
            currentContent: newContent,
            directionMap: directionMap,
            undoStack: undoStack,
            redoStack: Stack(),
            lastChangeType: changeType,
            selection: contentState.getSelectionAfter(),
            forceSelection: forceSelection,
            inlineStyleOverride: inlineStyleOverride
          };
          return EditorState.set(editorState, editorStateChanges);
        };
        /**
         * Make the top ContentState in the undo stack the new current content and
         * push the current content onto the redo stack.
         */


        EditorState.undo = function undo(editorState) {
          if (!editorState.getAllowUndo()) {
            return editorState;
          }

          var undoStack = editorState.getUndoStack();
          var newCurrentContent = undoStack.peek();

          if (!newCurrentContent) {
            return editorState;
          }

          var currentContent = editorState.getCurrentContent();
          var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
          return EditorState.set(editorState, {
            currentContent: newCurrentContent,
            directionMap: directionMap,
            undoStack: undoStack.shift(),
            redoStack: editorState.getRedoStack().push(currentContent),
            forceSelection: true,
            inlineStyleOverride: null,
            lastChangeType: 'undo',
            nativelyRenderedContent: null,
            selection: currentContent.getSelectionBefore()
          });
        };
        /**
         * Make the top ContentState in the redo stack the new current content and
         * push the current content onto the undo stack.
         */


        EditorState.redo = function redo(editorState) {
          if (!editorState.getAllowUndo()) {
            return editorState;
          }

          var redoStack = editorState.getRedoStack();
          var newCurrentContent = redoStack.peek();

          if (!newCurrentContent) {
            return editorState;
          }

          var currentContent = editorState.getCurrentContent();
          var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
          return EditorState.set(editorState, {
            currentContent: newCurrentContent,
            directionMap: directionMap,
            undoStack: editorState.getUndoStack().push(currentContent),
            redoStack: redoStack.shift(),
            forceSelection: true,
            inlineStyleOverride: null,
            lastChangeType: 'redo',
            nativelyRenderedContent: null,
            selection: newCurrentContent.getSelectionAfter()
          });
        };
        /**
         * Not for public consumption.
         */


        function EditorState(immutable) {
          _classCallCheck(this, EditorState);

          this._immutable = immutable;
        }
        /**
         * Not for public consumption.
         */


        EditorState.prototype.getImmutable = function getImmutable() {
          return this._immutable;
        };

        return EditorState;
      }();
      /**
       * Set the supplied SelectionState as the new current selection, and set
       * the `force` flag to trigger manual selection placement by the view.
       */


      function updateSelection(editorState, selection, forceSelection) {
        return EditorState.set(editorState, {
          selection: selection,
          forceSelection: forceSelection,
          nativelyRenderedContent: null,
          inlineStyleOverride: null
        });
      }
      /**
       * Regenerate the entire tree map for a given ContentState and decorator.
       * Returns an OrderedMap that maps all available ContentBlock objects.
       */


      function generateNewTreeMap(contentState, decorator) {
        return contentState.getBlockMap().map(function (block) {
          return BlockTree.generate(contentState, block, decorator);
        }).toOrderedMap();
      }
      /**
       * Regenerate tree map objects for all ContentBlocks that have changed
       * between the current editorState and newContent. Returns an OrderedMap
       * with only changed regenerated tree map objects.
       */


      function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
        var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
        var prevBlockMap = contentState.getBlockMap();
        var prevTreeMap = editorState.getImmutable().get('treeMap');
        return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
          return block !== prevBlockMap.get(key);
        }).map(function (block) {
          return BlockTree.generate(contentState, block, decorator);
        }));
      }
      /**
       * Generate tree map objects for a new decorator object, preserving any
       * decorations that are unchanged from the previous decorator.
       *
       * Note that in order for this to perform optimally, decoration Lists for
       * decorators should be preserved when possible to allow for direct immutable
       * List comparison.
       */


      function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
        return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
          return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
        }).map(function (block) {
          return BlockTree.generate(content, block, decorator);
        }));
      }
      /**
       * Return whether a change should be considered a boundary state, given
       * the previous change type. Allows us to discard potential boundary states
       * during standard typing or deletion behavior.
       */


      function mustBecomeBoundary(editorState, changeType) {
        var lastChangeType = editorState.getLastChangeType();
        return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
      }

      function getInlineStyleForCollapsedSelection(content, selection) {
        var startKey = selection.getStartKey();
        var startOffset = selection.getStartOffset();
        var startBlock = content.getBlockForKey(startKey); // If the cursor is not at the start of the block, look backward to
        // preserve the style of the preceding character.

        if (startOffset > 0) {
          return startBlock.getInlineStyleAt(startOffset - 1);
        } // The caret is at position zero in this block. If the block has any
        // text at all, use the style of the first character.


        if (startBlock.getLength()) {
          return startBlock.getInlineStyleAt(0);
        } // Otherwise, look upward in the document to find the closest character.


        return lookUpwardForInlineStyle(content, startKey);
      }

      function getInlineStyleForNonCollapsedSelection(content, selection) {
        var startKey = selection.getStartKey();
        var startOffset = selection.getStartOffset();
        var startBlock = content.getBlockForKey(startKey); // If there is a character just inside the selection, use its style.

        if (startOffset < startBlock.getLength()) {
          return startBlock.getInlineStyleAt(startOffset);
        } // Check if the selection at the end of a non-empty block. Use the last
        // style in the block.


        if (startOffset > 0) {
          return startBlock.getInlineStyleAt(startOffset - 1);
        } // Otherwise, look upward in the document to find the closest character.


        return lookUpwardForInlineStyle(content, startKey);
      }

      function lookUpwardForInlineStyle(content, fromKey) {
        var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
          return k === fromKey;
        }).skip(1).skipUntil(function (block, _) {
          return block.getLength();
        }).first();
        if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
        return OrderedSet();
      }

      module.exports = EditorState;
      /***/
    },
    /* 61 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/lodash/merge.js

      var merge = __webpack_require__(81);

      var merge_default =
      /*#__PURE__*/
      __webpack_require__.n(merge); // EXTERNAL MODULE: ./node_modules/lodash/replace.js


      var replace = __webpack_require__(84);

      var replace_default =
      /*#__PURE__*/
      __webpack_require__.n(replace); // EXTERNAL MODULE: ./node_modules/lodash/get.js


      var get = __webpack_require__(10);

      var get_default =
      /*#__PURE__*/
      __webpack_require__.n(get); // EXTERNAL MODULE: ./node_modules/lodash/set.js


      var set = __webpack_require__(52);

      var set_default =
      /*#__PURE__*/
      __webpack_require__.n(set); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js


      var defineProperty = __webpack_require__(4);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectSpread.js


      var objectSpread = __webpack_require__(13);

      var objectSpread_default =
      /*#__PURE__*/
      __webpack_require__.n(objectSpread); // EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js


      var isEmpty = __webpack_require__(25);

      var isEmpty_default =
      /*#__PURE__*/
      __webpack_require__.n(isEmpty); // EXTERNAL MODULE: ./node_modules/lodash/isEqual.js


      var isEqual = __webpack_require__(30);

      var isEqual_default =
      /*#__PURE__*/
      __webpack_require__.n(isEqual); // EXTERNAL MODULE: ./src/core/utils/repeatable.js


      var repeatable = __webpack_require__(282); // CONCATENATED MODULE: ./src/core/utils/tokens/dataStructure.js

      /**
       * Creates and returns two objects:
       * 1- fieldTagById which contains all field tags by the field id;
       * 2- formFieldsById which contains all field objects (including the ones defined inside of a repeatable) by the field id;
       * @param {Array} formFields Fields present at data.form.fields
       * @param {Object} submissionValueById Object containing values fields where the key is the fieldId
       */


      var dataStructure_createDataStructures = function createDataStructures(formFields, sectionsById, submissionValueById) {
        var fieldTagById = {};
        var formFieldsById = {};
        var repeatablesToBeProcessed = [];

        var addTagInFieldTagById = function addTagInFieldTagById(id, tag) {
          if (!isEmpty_default()(tag)) {
            fieldTagById[id] = tag;
          }
        };

        formFields.forEach(function (field) {
          if (field.renderer === 'repeatable') {
            // process the repeatables later in order to easily get the field tag by id through fieldTagById
            repeatablesToBeProcessed.push(field);
          } else {
            addTagInFieldTagById(field.id, field.attributes.tag);
          }

          formFieldsById[field.id] = field;
        });

        var handleInternalRepeatableField = function handleInternalRepeatableField(internalRepeatableField, prefix) {
          addTagInFieldTagById("".concat(prefix).concat(internalRepeatableField.id), internalRepeatableField.attributes.tag);
          formFieldsById["".concat(prefix).concat(internalRepeatableField.id)] = internalRepeatableField;
        };

        var handleRepeatableSection = function handleRepeatableSection(internalRepeatableField, processedPrefix) {
          var internalRepeatableFields = {};
          var repeatableSectionFields = [];
          var sectionIdToRepeat = get_default()(internalRepeatableField, 'attributes.sectionIdToRepeat');

          if (sectionsById[sectionIdToRepeat]) {
            get_default()(internalRepeatableField, 'attributes.objects', []).forEach(function (internalFieldInRepeatableSection) {
              handleInternalRepeatableField(internalFieldInRepeatableSection, processedPrefix);
              internalRepeatableFields[internalFieldInRepeatableSection.id] = true;
            });
            var sectionFields = Object(repeatable["a"
            /* getSectionFields */
            ])(internalRepeatableField, sectionsById);
            sectionFields.forEach(function (sectionField) {
              repeatableSectionFields.push({
                id: sectionField.id
              });
            });
          }

          return [internalRepeatableFields, repeatableSectionFields];
        }; // the handleRepeatableField needs to be declared here since it'll be used inside of handleRepetition
        // and it needs to only create the handleRepeatableField function after handleRepetition
        // since handleRepeatableField will use handleRepetition


        var handleRepeatableField;

        var handleRepetition = function handleRepetition(repField, repetitionId) {
          var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
          var internalRepeatableFields = {};
          var repeatableSectionFields = [];
          var processedPrefix = prefix ? "".concat(prefix).concat(repetitionId, "-") : "".concat(repField.id, "-").concat(repetitionId, "-");
          get_default()(repField, 'attributes.objects', []).forEach(function (internalRepeatableField) {
            if (internalRepeatableField.renderer === 'repeatable') {
              // internalRepeatableField is a nested repeatable inside of repField
              handleRepeatableField(internalRepeatableField, processedPrefix);
              formFieldsById["".concat(processedPrefix).concat(internalRepeatableField.id)] = internalRepeatableField;
            } else if (internalRepeatableField.renderer === 'repeatableSection') {
              merge_default()([internalRepeatableFields, repeatableSectionFields], handleRepeatableSection(internalRepeatableField, processedPrefix));
            } else {
              handleInternalRepeatableField(internalRepeatableField, processedPrefix);
              internalRepeatableFields[internalRepeatableField.id] = true;
            }
          }); // fields in repeatableSectionFields are external repeatable fields, therefore concatenate them with 'attributes.fields'

          repeatableSectionFields.concat(get_default()(repField, 'attributes.fields', [])).forEach(function (repeatableField) {
            if (internalRepeatableFields[repeatableField.id] === undefined) {
              // then repeatableField is an external repeatable field
              // (in another words, it's not defined inside of attributes.objects but rather in data.form.fields)
              addTagInFieldTagById("".concat(repField.id, "-").concat(repetitionId, "-").concat(repeatableField.id), fieldTagById[repeatableField.id]);
            }
          });
        };

        handleRepeatableField = function handleRepeatableField(field) {
          var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
          var repetitionIdsList = submissionValueById["".concat(prefix).concat(field.id)] || [];
          var prefixForHandlingRepetition = prefix ? "".concat(prefix).concat(field.id, "-") : prefix;
          addTagInFieldTagById("".concat(prefix).concat(field.id), get_default()(field, 'attributes.tag'));
          repetitionIdsList.forEach(function (repetitionId) {
            return handleRepetition(field, repetitionId, prefixForHandlingRepetition);
          });
        };

        repeatablesToBeProcessed.forEach(function (repetableField) {
          return handleRepeatableField(repetableField);
        });
        return {
          fieldTagById: fieldTagById,
          formFieldsById: formFieldsById
        };
      };
      /* harmony default export */


      var dataStructure = dataStructure_createDataStructures; // CONCATENATED MODULE: ./src/core/utils/tokens/lastDataObject.js

      var lastDataObject_lastDataObject = {
        submissions: {
          data: [],
          tokens: {}
        },
        formVariables: {
          data: [],
          tokens: {},
          tokensToUpdate: {}
        },
        globalVariables: {
          data: [],
          tokens: {},
          tokensToUpdate: {}
        }
      };

      var lastDataObject_saveLatestDataObject = function saveLatestDataObject(lastDataObjectKey, newData, newTokens, formId, dataStorageKey, tokenStorageKey) {
        var newTokensToUpdate = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
        lastDataObject_lastDataObject[lastDataObjectKey].data = newData;
        lastDataObject_lastDataObject[lastDataObjectKey].tokens = newTokens;

        if (!isEmpty_default()(newTokensToUpdate)) {
          lastDataObject_lastDataObject[lastDataObjectKey].tokensToUpdate = newTokensToUpdate;
        }
      }; // CONCATENATED MODULE: ./src/core/utils/tokens/submissionTokens.js


      var submissionTokens_createTokensFromSubmissionValues = function createTokensFromSubmissionValues(submissionValueById, fieldTagById, formFieldsById) {
        var tokens = {};

        var createTokenFromFieldInRepeatable = function createTokenFromFieldInRepeatable(fieldIdPieces, fieldId) {
          var tokenPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
          var idPrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
          var correctId = "".concat(idPrefix).concat(fieldIdPieces[0]);
          var repeatableTag = get_default()(formFieldsById, "[".concat(correctId, "].attributes.tag"));
          var sufix = ''; // if the repeatable does not have a tag, then we'll not create tokens for what's inside of the repeatable

          if (isEmpty_default()(repeatableTag)) {
            return;
          }

          if (get_default()(formFieldsById, "[".concat(fieldId, "].renderer")) === 'repeatable') {
            // it's a repeatable field
            sufix = '.value';
          }

          var repetitionIdsList = submissionValueById[correctId] || [];

          if (!Array.isArray(repetitionIdsList)) {
            return;
          }

          var repetitionIndex = repetitionIdsList.indexOf(fieldIdPieces[1]); // fieldIdPieces[0] is the repeatable id
          // fieldIdPieces[1] is the repetition id
          // fieldIdPieces[2] is the field id (this field id can be another repeatable id,
          // however if that's the case fieldIdPieces will have more than 3 items)

          if (fieldIdPieces.length === 3) {
            if (fieldTagById[fieldId]) {
              set_default()(tokens, "fields.".concat(tokenPrefix).concat(repeatableTag, ".repetition[").concat(repetitionIndex, "].").concat(fieldTagById[fieldId]).concat(sufix), submissionValueById[fieldId]);
            }
          } else if (fieldIdPieces.length > 3) {
            // it's a field inside of a nested repeatable
            var fieldIdPiecesWithoutFirstTwoItems = fieldIdPieces.splice(2, fieldIdPieces.length - 2);
            createTokenFromFieldInRepeatable(fieldIdPiecesWithoutFirstTwoItems, fieldId, "".concat(repeatableTag, ".repetition[").concat(repetitionIndex, "]."), "".concat(fieldIdPieces[0], "-").concat(fieldIdPieces[1], "-"));
          }
        };

        Object.keys(submissionValueById).forEach(function (fieldId) {
          if (fieldId.indexOf('-') >= 0) {
            // it's a field id that resides inside of a repeatable
            createTokenFromFieldInRepeatable(fieldId.split('-'), fieldId);
          } else if (fieldTagById[fieldId]) {
            if (formFieldsById[fieldId].renderer === 'repeatable') {
              // it's a repeatable field
              set_default()(tokens, "fields.".concat(fieldTagById[fieldId], ".value"), submissionValueById[fieldId]);
            } else {
              // it's a field id
              set_default()(tokens, "fields.".concat(fieldTagById[fieldId]), submissionValueById[fieldId]);
            }
          }
        });
        return tokens;
      };

      var submissionTokens_loadSubmissionTokensOrCreateThem = function loadSubmissionTokensOrCreateThem(submissionFields, formFields, formSections, formId) {
        var tokens = {};
        var lastDataObjectKey = 'submissions';
        var dataStorageKey = 'submission-fields';
        var tokenStorageKey = 'submission-tokens';

        if (isEqual_default()(lastDataObject_lastDataObject[lastDataObjectKey].data, submissionFields) && !isEmpty_default()(lastDataObject_lastDataObject[lastDataObjectKey].data)) {
          // load previous tokens instead of processing the data in order to generate it
          merge_default()(tokens, lastDataObject_lastDataObject[lastDataObjectKey].tokens);
        } else {
          // create submission tokens
          var submissionValueById = submissionFields.reduce(function (acc, field) {
            return objectSpread_default()({}, acc, defineProperty_default()({}, field.id, field.value));
          }, {});
          var sectionsById = formSections.reduce(function (acc, section) {
            return objectSpread_default()({}, acc, defineProperty_default()({}, section.id, section));
          }, {});

          var _createDataStructures = dataStructure(formFields, sectionsById, submissionValueById),
              fieldTagById = _createDataStructures.fieldTagById,
              formFieldsById = _createDataStructures.formFieldsById;

          merge_default()(tokens, submissionTokens_createTokensFromSubmissionValues(submissionValueById, fieldTagById, formFieldsById));
          lastDataObject_saveLatestDataObject(lastDataObjectKey, submissionFields, tokens, formId, dataStorageKey, tokenStorageKey);
        }

        return tokens;
      };
      /* harmony default export */


      var submissionTokens = submissionTokens_loadSubmissionTokensOrCreateThem; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js

      var helpers_typeof = __webpack_require__(39);

      var typeof_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_typeof); // CONCATENATED MODULE: ./src/core/utils/tokens/variableTokens.js


      var variableTokens_getTokensToBeUpdated = function getTokensToBeUpdated(variables, variable, variablePrefix) {
        var tokensToBeUpdated = {};
        var matches = tokens_getTokensMatches(variables[variable]);
        var token;

        if (matches) {
          set_default()(tokensToBeUpdated, "".concat(variablePrefix, ".").concat(variable), []);
          matches.forEach(function (match) {
            token = tokens_removeTokensBrackets(match);
            get_default()(tokensToBeUpdated, "".concat(variablePrefix, ".").concat(variable)).push(token);
          });
        }

        return tokensToBeUpdated;
      };

      var variableTokens_createTokensFromVariables = function createTokensFromVariables(variables, variablePrefix) {
        var tokens = {};
        var tokensToUpdate = {};
        Object.keys(variables).forEach(function (variable) {
          if (typeof_default()(variables[variable]) === 'object') {
            merge_default()([tokens, tokensToUpdate], createTokensFromVariables(variables[variable], "".concat(variablePrefix, ".").concat(variable)));
          } else {
            set_default()(tokens, "".concat(variablePrefix, ".").concat(variable), variables[variable]);
            merge_default()(tokensToUpdate, variableTokens_getTokensToBeUpdated(variables, variable, variablePrefix));
          }
        });
        return [tokens, tokensToUpdate];
      };

      var variableTokens_loadVariablesTokensOrCreateThem = function loadVariablesTokensOrCreateThem(variables, formId, lastDataObjectKey, dataStorageKey, tokenStorageKey, variablePrefix) {
        var tokens = {};
        var tokensToUpdate = {};

        if (isEqual_default()(lastDataObject_lastDataObject[lastDataObjectKey].data, variables) && !isEmpty_default()(lastDataObject_lastDataObject[lastDataObjectKey].data)) {
          // load previous tokens instead of processing the data in order to generate it
          merge_default()(tokens, lastDataObject_lastDataObject[lastDataObjectKey].tokens);
          merge_default()(tokensToUpdate, lastDataObject_lastDataObject[lastDataObjectKey].tokensToUpdate);
        } else {
          // create variables tokens
          merge_default()([tokens, tokensToUpdate], variableTokens_createTokensFromVariables(variables, variablePrefix));
        }

        lastDataObject_saveLatestDataObject(lastDataObjectKey, variables, tokens, formId, dataStorageKey, tokenStorageKey, tokensToUpdate);
        return [tokens, tokensToUpdate];
      };
      /* harmony default export */


      var variableTokens = variableTokens_loadVariablesTokensOrCreateThem; // CONCATENATED MODULE: ./src/core/utils/tokens/tokens.js

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "b", function () {
        return tokens_getTokensMatches;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return tokens_replaceValuesAlias;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return tokens_removeTokensBrackets;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return tokens_tokenizer;
      });
      /**
       * Returns all the tokens matches that content has
       * @param {string} content
       */


      var tokens_getTokensMatches = function getTokensMatches(content) {
        return content && content.match && content.match(new RegExp(/{{[^}}]+}}/, 'g'));
      };
      /**
       * Replace {{values.machineLabel}} with {{fields.machineLabel}} to allow consistency with dashboard actions.
       * @param {string} token
       */


      var tokens_replaceValuesAlias = function replaceValuesAlias(token) {
        if (typeof token === 'string') {
          token = token.replace(new RegExp('{{([ ]+|#|/|^|!|[> ]+|)values(.|)', 'g'), '{{$1fields$2');
        }

        return token;
      };
      /**
       * Removes the first two chacters and the two last chacters from token string (which are the {{}} around the token)
       * @param {string} token
       */


      var tokens_removeTokensBrackets = function removeTokensBrackets(token) {
        return token && token.substring && token.substring(2, token.length - 2);
      };
      /**
       * Shortcut to perform tokenization on a string value
       * @param {obj} tokens
       */


      var tokens_tokenizer = function tokenizer(tokens) {
        return function (value) {
          var matches = tokens_getTokensMatches(value);

          if (matches) {
            var token;
            matches.forEach(function (match) {
              token = tokens_removeTokensBrackets(match);
              value = replace_default()(value, match, get_default()(tokens, token, ''));
            });
          }

          return value;
        };
      };
      /**
       * It updates all tokens in 'tokens' that are in 'tokensToUpdate' with the content of other tokens.
       * After updating all tokens in 'tokens', it returns 'tokens' with the updated content.
       *
       * @param {object} tokens Object that getTokens will return (see getTokens description)
       * @param {object} tokensToUpdate Object with some levels until the children are arrays of strings.
       * *  e.g. of tokensToUpdate = {"global":{"testing":{"secondGlobalKey":["variables.global.testing.firstGlobalKey"]}}}
       *    that means that "variables.global.testing.secondGlobalKey" contains a token ("variables.global.testing.firstGlobalKey")
       *    on its value which needs to be replaced by that tokens value
       */


      var tokens_updateTokensContent = function updateTokensContent(tokens, tokensToUpdate) {
        var updateTokenWithOtherTokensValue = function updateTokenWithOtherTokensValue(tokenPathToUpdate, tokenPathToReadFrom) {
          var currentTokenValue = get_default()(tokens, tokenPathToUpdate);
          var tokenToBeReplaced = "{{".concat(tokenPathToReadFrom, "}}");
          var tokenValue = get_default()(tokens, tokenPathToReadFrom, '');
          var newTokenValue = replace_default()(currentTokenValue, tokenToBeReplaced, tokenValue);
          set_default()(tokens, tokenPathToUpdate, newTokenValue);
        };

        var loopThroughAllChildrenAndUpdateTokens = function loopThroughAllChildrenAndUpdateTokens(tokenPathToUpdate) {
          var arrayOrObject = get_default()(tokensToUpdate, tokenPathToUpdate);

          if (arrayOrObject.forEach) {
            arrayOrObject.forEach(function (tokenPath) {
              updateTokenWithOtherTokensValue(tokenPathToUpdate, tokenPath);
            });
          } else {
            Object.keys(arrayOrObject).forEach(function (key) {
              loopThroughAllChildrenAndUpdateTokens("".concat(tokenPathToUpdate, ".").concat(key));
            });
          }
        }; // loop through all children of tokensToUpdate and update tokens content with other token's value


        Object.keys(tokensToUpdate).forEach(function (key) {
          loopThroughAllChildrenAndUpdateTokens(key);
        });
        return tokens;
      };
      /**
       * It generates and returns all the tokens.
       * The returned object has two keys/objects: 'fields' and 'variables'.
       *   - the 'fields' object contains field tags with the field value.
       *   - the 'variables' object contains 'form' and 'global' keys/objects:
       *     - the 'form' object contains the form variables received in 'formVariables' parameter.
       *     - the 'global' object contains the form variables received in 'globalVariables' parameter.
       *
       * @param {array} formFields Array of field objects (fields present at data.form.fields) containing the field id and field tag.
       * @param {array} formSections Array of section objects (sections present at data.form.sections) containing all fields that it has.
       * @param {array} submissionFields Array of field objects with user input.
       * @param {object} formVariables Object containing the form variables defined in dashboard.
       * @param {object} globalVariables Object containing the global variables defined in dashboard.
       * @param {object} formId The form id.
       */


      var tokens_getTokens = function getTokens() {
        var formFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var formSections = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var submissionFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var formVariables = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var globalVariables = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        var formId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var tokens = {};
        var tokensToUpdate = {};
        merge_default()(tokens, submissionTokens(submissionFields, formFields, formSections, formId));
        merge_default()([tokens, tokensToUpdate], variableTokens(formVariables, formId, 'formVariables', 'form-variables', 'form-variables-tokens', 'variables.form'));
        merge_default()([tokens, tokensToUpdate], variableTokens(globalVariables, formId, 'globalVariables', 'global-variables', 'global-variables-tokens', 'variables.global'));
        return tokens_updateTokensContent(tokens, tokensToUpdate);
      };
      /* harmony default export */


      var tokens_tokens = __webpack_exports__["a"] = tokens_getTokens;
      /***/
    },
    /* 62 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayMap = __webpack_require__(176),
          baseClone = __webpack_require__(323),
          baseUnset = __webpack_require__(880),
          castPath = __webpack_require__(177),
          copyObject = __webpack_require__(156),
          customOmitClone = __webpack_require__(876),
          flatRest = __webpack_require__(442),
          getAllKeysIn = __webpack_require__(322);
      /** Used to compose bitmasks for cloning. */


      var CLONE_DEEP_FLAG = 1,
          CLONE_FLAT_FLAG = 2,
          CLONE_SYMBOLS_FLAG = 4;
      /**
       * The opposite of `_.pick`; this method creates an object composed of the
       * own and inherited enumerable property paths of `object` that are not omitted.
       *
       * **Note:** This method is considerably slower than `_.pick`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The source object.
       * @param {...(string|string[])} [paths] The property paths to omit.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.omit(object, ['a', 'c']);
       * // => { 'b': '2' }
       */

      var omit = flatRest(function (object, paths) {
        var result = {};

        if (object == null) {
          return result;
        }

        var isDeep = false;
        paths = arrayMap(paths, function (path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result);

        if (isDeep) {
          result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }

        var length = paths.length;

        while (length--) {
          baseUnset(result, paths[length]);
        }

        return result;
      });
      module.exports = omit;
      /***/
    },
    /* 63 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "b", function () {
        return readSubmissionQuery;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return setSubmissionValuesMutation;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return getSubmissionOptions;
      });
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78);
      /* harmony import */


      var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(119);
      /* harmony import */


      var graphql_tag__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_4__);

      function _templateObject2() {
        var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2___default()(["\n  mutation SetSubmissionValues(\n    $submissionId: String!\n    $fields: [ValueInput]\n    $attributes: [ValueInput]\n    $timestamp: Float!\n    $formId: Int!\n    $channel: String!\n    $branch: String!\n  ) {\n    SetSubmissionValues(\n      submissionId: $submissionId\n      fields: $fields\n      attributes: $attributes\n      timestamp: $timestamp\n      formId: $formId\n      channel: $channel\n      branch: $branch\n    ) {\n      id\n      attributes {\n        id\n        value\n        requestTimestamp\n        type\n      }\n      fields {\n        id\n        value\n        requestTimestamp\n      }\n    }\n  }\n"]);

        _templateObject2 = function _templateObject2() {
          return data;
        };

        return data;
      }

      function _templateObject() {
        var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2___default()(["\n    query ReadSubmission(\n      $formId: Int!\n      $submissionId: String\n      $branch: String\n      $channel: String\n      $initialValues: [ValueInput]\n    ) {\n      Submission(\n        id: $submissionId\n        formId: $formId\n        branch: $branch\n        channel: $channel\n        initialValues: $initialValues\n      ) {\n        id\n        attributes {\n          id\n          value\n          requestTimestamp\n          type\n        }\n        fields {\n          id\n          value\n          requestTimestamp\n        }\n      }\n    }\n  "]);

        _templateObject = function _templateObject() {
          return data;
        };

        return data;
      }

      var readSubmissionQuery = {
        query: graphql_tag__WEBPACK_IMPORTED_MODULE_3___default()(_templateObject())
      };
      var setSubmissionValuesMutation = graphql_tag__WEBPACK_IMPORTED_MODULE_3___default()(_templateObject2());
      /**
       * Returns an array that contains all values of currentSubmissionData concatenated with the values present in arrayWithNewValues.
       * If there is a value present in both arrays, then the value present in arrayWithNewValues will be the one used on the returned array.
       * @param {array} currentSubmissionData Array of objects where every object has the following structure { id, value }
       * @param {object} currentSubmissionDataObjectIndexById Object that contains the index of every object inside of currentSubmissionData by id
       * @param {array} arrayWithNewValues Array of objects where every object has the following structure { id, value }
       * @param {object} newSubmissionDataObjectIndexById Object that contains the index of every object inside of arrayWithNewValues by id
       * @param {number} timestamp
       */

      var getSubmissionOptionsOptimisticData = function getSubmissionOptionsOptimisticData(currentSubmissionData, currentSubmissionDataObjectIndexById, arrayWithNewValues, newSubmissionDataObjectIndexById, timestamp, type) {
        var optimisticResponse = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_4___default()(currentSubmissionData);
        Object.keys(newSubmissionDataObjectIndexById).forEach(function (fieldIdKey) {
          // Iterate through the new attributes to send up
          var objectIndex = newSubmissionDataObjectIndexById[fieldIdKey];

          if (currentSubmissionDataObjectIndexById[fieldIdKey] === undefined) {
            // Attribute does not currently exist/have value set, need to create new
            var response = {
              id: fieldIdKey,
              value: arrayWithNewValues[objectIndex].value,
              requestTimestamp: timestamp,
              __typename: 'SubmissionValue'
            };

            if (typeof type === 'string') {
              response.type = type;
            }

            optimisticResponse.push(response);
          } else {
            // Attribute value is set, need to update existing response
            var submissionIndex = currentSubmissionDataObjectIndexById[fieldIdKey];

            var _response = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, optimisticResponse[submissionIndex], {
              value: arrayWithNewValues[objectIndex].value,
              requestTimestamp: timestamp
            });

            if (typeof type === 'string') {
              _response.type = type;
            } else if (_response.type) {
              delete _response.type;
            }

            optimisticResponse[submissionIndex] = _response;
          }
        });
        return optimisticResponse;
      };
      /**
       * Returns an object that all keys are the ids of the objects present in arrayOfObjects.
       * The value for those keys is the index of that object in arrayOfObjects.
       *  e.g.
       *   arrayOfObjects = [{ id: '123', ... }, { id: '456', ... }, { id: '789', ... } ]
       *   returns { '123': 0, '456': 1, '789': 2 }
       *
       * @param {array} arrayOfObjects Array of objects where every object contains at least the id key.
       */


      var convertArrayIntoObjectIndexById = function convertArrayIntoObjectIndexById() {
        var arrayOfObjects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return arrayOfObjects.reduce(function (acc, object, index) {
          return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, acc, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, object.id, index));
        }, {});
      };
      /**
       * Returns an object containing the SetSubmissionValues object with the optimistic response for attributes and fields.
       * @param {string} submissionId
       * @param {array} newAttributes Array of objects where every object has the following structure { id, value }
       * @param {array} newFields Array of objects where every object has the following structure { id, value }
       * @param {object} currentSubmission Object that contains the current submission values for attributes and fields (both arrays).
       * @param {number} timestamp
       */


      var getSubmissionOptionsOptimisticResponse = function getSubmissionOptionsOptimisticResponse(submissionId) {
        var newAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var newFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var currentSubmission = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
          attributes: [],
          fields: []
        };
        var timestamp = arguments.length > 4 ? arguments[4] : undefined;
        var type = arguments.length > 5 ? arguments[5] : undefined;
        return {
          SetSubmissionValues: {
            id: submissionId,
            __typename: 'Submission',
            attributes: getSubmissionOptionsOptimisticData(currentSubmission.attributes, convertArrayIntoObjectIndexById(currentSubmission.attributes), newAttributes, convertArrayIntoObjectIndexById(newAttributes), timestamp, type),
            fields: getSubmissionOptionsOptimisticData(currentSubmission.fields, convertArrayIntoObjectIndexById(currentSubmission.fields), newFields, convertArrayIntoObjectIndexById(newFields), timestamp)
          }
        };
      };
      /**
       * Returns the options to be used in conjuction with setSubmissionValuesMutation.
       * It returns an object that contains variables and optimisticResponse objects on it.
       * @param {number} formId
       * @param {string} submissionId
       * @param {array} newAttributes Array of objects where every object has the following structure { id, value }
       * @param {array} newFields Array of objects where every object has the following structure { id, value }
       * @param {object} currentSubmission Object that contains the current submission values for attributes and fields (both arrays).
       * @param {number} timestamp
       * @param {string} channel
       * @param {string} branch
       */


      var getSubmissionOptions = function getSubmissionOptions(formId, submissionId) {
        var newAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var newFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        var currentSubmission = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
          attributes: [],
          fields: []
        };
        var timestamp = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Date.now();
        var channel = arguments.length > 6 ? arguments[6] : undefined;
        var branch = arguments.length > 7 ? arguments[7] : undefined;
        var type = arguments.length > 8 ? arguments[8] : undefined;
        return {
          variables: {
            submissionId: submissionId,
            formId: formId,
            attributes: newAttributes,
            fields: newFields,
            timestamp: timestamp,
            channel: channel,
            branch: branch
          },
          optimisticResponse: getSubmissionOptionsOptimisticResponse(submissionId, newAttributes, newFields, currentSubmission, timestamp, type)
        };
      };
      /***/

    },
    /* 64 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "c", function () {
        return queryEncode;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return requestData;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return apiServerUrl;
      });
      /* unused harmony export flattenObject */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return requestMethod;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return contentType;
      });
      /* harmony import */


      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
      /* harmony import */


      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(382);
      /* harmony import */


      var axios__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28);
      /**
       * Converts JS (JSON) object to x-www-form-urlencoded to send over HTTP(S)
       * @param {object} obj
       */


      var queryEncode = function queryEncode(obj) {
        return Object.keys(obj).map(function (key) {
          return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key]));
        }).join('&');
      };
      /**
       * Uses axios to send request see https://github.com/axios/axios for usage
       * @param {object} options
       */


      var requestData = function requestData(options) {
        if (!axios__WEBPACK_IMPORTED_MODULE_2___default.a[options.method]) {
          return new Promise(function (resolve, reject) {
            reject(new Error('options.method should be a valid axios function'));
          });
        }

        options.headers = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, options.headers, {
          'Client-Version': "0.9.78"
        });
        return axios__WEBPACK_IMPORTED_MODULE_2___default()(options);
      };

      var apiServerUrl = function apiServerUrl(uri) {
        return _config__WEBPACK_IMPORTED_MODULE_3__[
        /* default */
        "a"].getApiServer().concat(uri);
      };

      var flattenObject = function flattenObject(obj, inRet, inPrefix) {
        var ret = inRet || {};
        var prefix = inPrefix || '';

        if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(obj) === 'object' && obj !== null) {
          Object.keys(obj).forEach(function (key) {
            flattenObject(obj[key], ret, prefix === '' ? key : "".concat(prefix, "[").concat(key, "]"));
          });
        } else if (prefix !== '') {
          ret[prefix] = obj;
        }

        return ret;
      };

      var requestMethod = {
        DELETE: 'DELETE',
        GET: 'GET',
        POST: 'POST',
        PUT: 'PUT'
      };
      var contentType = {
        formUrlencoded: 'application/x-www-form-urlencoded',
        formData: 'multipart/form-data',
        html: 'text/html; charset=utf-8',
        json: 'application/json',
        text: 'text/plain'
      }; // TODO: export function that resolves an URI to Formatic API

      /* unused harmony default export */

      var _unused_webpack_default_export = {
        apiServerUrl: apiServerUrl,
        contentType: contentType,
        queryEncode: queryEncode,
        requestData: requestData,
        requestMethod: requestMethod
      };
      /***/
    },
    /* 65 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _from = __webpack_require__(1135);

      var _from2 = _interopRequireDefault(_from);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        } else {
          return (0, _from2.default)(arr);
        }
      };
      /***/

    },
    /* 66 */

    /***/
    function (module, exports, __webpack_require__) {
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      (function (global, factory) {
        true ? module.exports = factory() : undefined;
      })(this, function () {
        'use strict';

        var SLICE$0 = Array.prototype.slice;

        function createClass(ctor, superClass) {
          if (superClass) {
            ctor.prototype = Object.create(superClass.prototype);
          }

          ctor.prototype.constructor = ctor;
        }

        function Iterable(value) {
          return isIterable(value) ? value : Seq(value);
        }

        createClass(KeyedIterable, Iterable);

        function KeyedIterable(value) {
          return isKeyed(value) ? value : KeyedSeq(value);
        }

        createClass(IndexedIterable, Iterable);

        function IndexedIterable(value) {
          return isIndexed(value) ? value : IndexedSeq(value);
        }

        createClass(SetIterable, Iterable);

        function SetIterable(value) {
          return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
        }

        function isIterable(maybeIterable) {
          return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
        }

        function isKeyed(maybeKeyed) {
          return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
        }

        function isIndexed(maybeIndexed) {
          return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
        }

        function isAssociative(maybeAssociative) {
          return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
        }

        function isOrdered(maybeOrdered) {
          return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
        }

        Iterable.isIterable = isIterable;
        Iterable.isKeyed = isKeyed;
        Iterable.isIndexed = isIndexed;
        Iterable.isAssociative = isAssociative;
        Iterable.isOrdered = isOrdered;
        Iterable.Keyed = KeyedIterable;
        Iterable.Indexed = IndexedIterable;
        Iterable.Set = SetIterable;
        var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
        var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
        var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
        var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@'; // Used for setting prototype methods that IE8 chokes on.

        var DELETE = 'delete'; // Constants describing the size of trie nodes.

        var SHIFT = 5; // Resulted in best performance after ______?

        var SIZE = 1 << SHIFT;
        var MASK = SIZE - 1; // A consistent shared value representing "not set" which equals nothing other
        // than itself, and nothing that could be provided externally.

        var NOT_SET = {}; // Boolean references, Rough equivalent of `bool &`.

        var CHANGE_LENGTH = {
          value: false
        };
        var DID_ALTER = {
          value: false
        };

        function MakeRef(ref) {
          ref.value = false;
          return ref;
        }

        function SetRef(ref) {
          ref && (ref.value = true);
        } // A function which returns a value representing an "owner" for transient writes
        // to tries. The return value will only ever equal itself, and will not equal
        // the return of any subsequent call of this function.


        function OwnerID() {} // http://jsperf.com/copy-array-inline


        function arrCopy(arr, offset) {
          offset = offset || 0;
          var len = Math.max(0, arr.length - offset);
          var newArr = new Array(len);

          for (var ii = 0; ii < len; ii++) {
            newArr[ii] = arr[ii + offset];
          }

          return newArr;
        }

        function ensureSize(iter) {
          if (iter.size === undefined) {
            iter.size = iter.__iterate(returnTrue);
          }

          return iter.size;
        }

        function wrapIndex(iter, index) {
          // This implements "is array index" which the ECMAString spec defines as:
          //
          //     A String property name P is an array index if and only if
          //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
          //     to 2^32−1.
          //
          // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
          if (typeof index !== 'number') {
            var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32

            if ('' + uint32Index !== index || uint32Index === 4294967295) {
              return NaN;
            }

            index = uint32Index;
          }

          return index < 0 ? ensureSize(iter) + index : index;
        }

        function returnTrue() {
          return true;
        }

        function wholeSlice(begin, end, size) {
          return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
        }

        function resolveBegin(begin, size) {
          return resolveIndex(begin, size, 0);
        }

        function resolveEnd(end, size) {
          return resolveIndex(end, size, size);
        }

        function resolveIndex(index, size, defaultIndex) {
          return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
        }
        /* global Symbol */


        var ITERATE_KEYS = 0;
        var ITERATE_VALUES = 1;
        var ITERATE_ENTRIES = 2;
        var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = '@@iterator';
        var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;

        function Iterator(next) {
          this.next = next;
        }

        Iterator.prototype.toString = function () {
          return '[Iterator]';
        };

        Iterator.KEYS = ITERATE_KEYS;
        Iterator.VALUES = ITERATE_VALUES;
        Iterator.ENTRIES = ITERATE_ENTRIES;

        Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
          return this.toString();
        };

        Iterator.prototype[ITERATOR_SYMBOL] = function () {
          return this;
        };

        function iteratorValue(type, k, v, iteratorResult) {
          var value = type === 0 ? k : type === 1 ? v : [k, v];
          iteratorResult ? iteratorResult.value = value : iteratorResult = {
            value: value,
            done: false
          };
          return iteratorResult;
        }

        function iteratorDone() {
          return {
            value: undefined,
            done: true
          };
        }

        function hasIterator(maybeIterable) {
          return !!getIteratorFn(maybeIterable);
        }

        function isIterator(maybeIterator) {
          return maybeIterator && typeof maybeIterator.next === 'function';
        }

        function getIterator(iterable) {
          var iteratorFn = getIteratorFn(iterable);
          return iteratorFn && iteratorFn.call(iterable);
        }

        function getIteratorFn(iterable) {
          var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);

          if (typeof iteratorFn === 'function') {
            return iteratorFn;
          }
        }

        function isArrayLike(value) {
          return value && typeof value.length === 'number';
        }

        createClass(Seq, Iterable);

        function Seq(value) {
          return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
        }

        Seq.of = function ()
        /*...values*/
        {
          return Seq(arguments);
        };

        Seq.prototype.toSeq = function () {
          return this;
        };

        Seq.prototype.toString = function () {
          return this.__toString('Seq {', '}');
        };

        Seq.prototype.cacheResult = function () {
          if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
          }

          return this;
        }; // abstract __iterateUncached(fn, reverse)


        Seq.prototype.__iterate = function (fn, reverse) {
          return seqIterate(this, fn, reverse, true);
        }; // abstract __iteratorUncached(type, reverse)


        Seq.prototype.__iterator = function (type, reverse) {
          return seqIterator(this, type, reverse, true);
        };

        createClass(KeyedSeq, Seq);

        function KeyedSeq(value) {
          return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
        }

        KeyedSeq.prototype.toKeyedSeq = function () {
          return this;
        };

        createClass(IndexedSeq, Seq);

        function IndexedSeq(value) {
          return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
        }

        IndexedSeq.of = function ()
        /*...values*/
        {
          return IndexedSeq(arguments);
        };

        IndexedSeq.prototype.toIndexedSeq = function () {
          return this;
        };

        IndexedSeq.prototype.toString = function () {
          return this.__toString('Seq [', ']');
        };

        IndexedSeq.prototype.__iterate = function (fn, reverse) {
          return seqIterate(this, fn, reverse, false);
        };

        IndexedSeq.prototype.__iterator = function (type, reverse) {
          return seqIterator(this, type, reverse, false);
        };

        createClass(SetSeq, Seq);

        function SetSeq(value) {
          return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
        }

        SetSeq.of = function ()
        /*...values*/
        {
          return SetSeq(arguments);
        };

        SetSeq.prototype.toSetSeq = function () {
          return this;
        };

        Seq.isSeq = isSeq;
        Seq.Keyed = KeyedSeq;
        Seq.Set = SetSeq;
        Seq.Indexed = IndexedSeq;
        var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
        Seq.prototype[IS_SEQ_SENTINEL] = true;
        createClass(ArraySeq, IndexedSeq);

        function ArraySeq(array) {
          this._array = array;
          this.size = array.length;
        }

        ArraySeq.prototype.get = function (index, notSetValue) {
          return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
        };

        ArraySeq.prototype.__iterate = function (fn, reverse) {
          var array = this._array;
          var maxIndex = array.length - 1;

          for (var ii = 0; ii <= maxIndex; ii++) {
            if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
              return ii + 1;
            }
          }

          return ii;
        };

        ArraySeq.prototype.__iterator = function (type, reverse) {
          var array = this._array;
          var maxIndex = array.length - 1;
          var ii = 0;
          return new Iterator(function () {
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
          });
        };

        createClass(ObjectSeq, KeyedSeq);

        function ObjectSeq(object) {
          var keys = Object.keys(object);
          this._object = object;
          this._keys = keys;
          this.size = keys.length;
        }

        ObjectSeq.prototype.get = function (key, notSetValue) {
          if (notSetValue !== undefined && !this.has(key)) {
            return notSetValue;
          }

          return this._object[key];
        };

        ObjectSeq.prototype.has = function (key) {
          return this._object.hasOwnProperty(key);
        };

        ObjectSeq.prototype.__iterate = function (fn, reverse) {
          var object = this._object;
          var keys = this._keys;
          var maxIndex = keys.length - 1;

          for (var ii = 0; ii <= maxIndex; ii++) {
            var key = keys[reverse ? maxIndex - ii : ii];

            if (fn(object[key], key, this) === false) {
              return ii + 1;
            }
          }

          return ii;
        };

        ObjectSeq.prototype.__iterator = function (type, reverse) {
          var object = this._object;
          var keys = this._keys;
          var maxIndex = keys.length - 1;
          var ii = 0;
          return new Iterator(function () {
            var key = keys[reverse ? maxIndex - ii : ii];
            return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
          });
        };

        ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
        createClass(IterableSeq, IndexedSeq);

        function IterableSeq(iterable) {
          this._iterable = iterable;
          this.size = iterable.length || iterable.size;
        }

        IterableSeq.prototype.__iterateUncached = function (fn, reverse) {
          if (reverse) {
            return this.cacheResult().__iterate(fn, reverse);
          }

          var iterable = this._iterable;
          var iterator = getIterator(iterable);
          var iterations = 0;

          if (isIterator(iterator)) {
            var step;

            while (!(step = iterator.next()).done) {
              if (fn(step.value, iterations++, this) === false) {
                break;
              }
            }
          }

          return iterations;
        };

        IterableSeq.prototype.__iteratorUncached = function (type, reverse) {
          if (reverse) {
            return this.cacheResult().__iterator(type, reverse);
          }

          var iterable = this._iterable;
          var iterator = getIterator(iterable);

          if (!isIterator(iterator)) {
            return new Iterator(iteratorDone);
          }

          var iterations = 0;
          return new Iterator(function () {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
          });
        };

        createClass(IteratorSeq, IndexedSeq);

        function IteratorSeq(iterator) {
          this._iterator = iterator;
          this._iteratorCache = [];
        }

        IteratorSeq.prototype.__iterateUncached = function (fn, reverse) {
          if (reverse) {
            return this.cacheResult().__iterate(fn, reverse);
          }

          var iterator = this._iterator;
          var cache = this._iteratorCache;
          var iterations = 0;

          while (iterations < cache.length) {
            if (fn(cache[iterations], iterations++, this) === false) {
              return iterations;
            }
          }

          var step;

          while (!(step = iterator.next()).done) {
            var val = step.value;
            cache[iterations] = val;

            if (fn(val, iterations++, this) === false) {
              break;
            }
          }

          return iterations;
        };

        IteratorSeq.prototype.__iteratorUncached = function (type, reverse) {
          if (reverse) {
            return this.cacheResult().__iterator(type, reverse);
          }

          var iterator = this._iterator;
          var cache = this._iteratorCache;
          var iterations = 0;
          return new Iterator(function () {
            if (iterations >= cache.length) {
              var step = iterator.next();

              if (step.done) {
                return step;
              }

              cache[iterations] = step.value;
            }

            return iteratorValue(type, iterations, cache[iterations++]);
          });
        }; // # pragma Helper functions


        function isSeq(maybeSeq) {
          return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
        }

        var EMPTY_SEQ;

        function emptySequence() {
          return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
        }

        function keyedSeqFromValue(value) {
          var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === 'object' ? new ObjectSeq(value) : undefined;

          if (!seq) {
            throw new TypeError('Expected Array or iterable object of [k, v] entries, ' + 'or keyed object: ' + value);
          }

          return seq;
        }

        function indexedSeqFromValue(value) {
          var seq = maybeIndexedSeqFromValue(value);

          if (!seq) {
            throw new TypeError('Expected Array or iterable object of values: ' + value);
          }

          return seq;
        }

        function seqFromValue(value) {
          var seq = maybeIndexedSeqFromValue(value) || typeof value === 'object' && new ObjectSeq(value);

          if (!seq) {
            throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
          }

          return seq;
        }

        function maybeIndexedSeqFromValue(value) {
          return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
        }

        function seqIterate(seq, fn, reverse, useKeys) {
          var cache = seq._cache;

          if (cache) {
            var maxIndex = cache.length - 1;

            for (var ii = 0; ii <= maxIndex; ii++) {
              var entry = cache[reverse ? maxIndex - ii : ii];

              if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
                return ii + 1;
              }
            }

            return ii;
          }

          return seq.__iterateUncached(fn, reverse);
        }

        function seqIterator(seq, type, reverse, useKeys) {
          var cache = seq._cache;

          if (cache) {
            var maxIndex = cache.length - 1;
            var ii = 0;
            return new Iterator(function () {
              var entry = cache[reverse ? maxIndex - ii : ii];
              return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
            });
          }

          return seq.__iteratorUncached(type, reverse);
        }

        function fromJS(json, converter) {
          return converter ? fromJSWith(converter, json, '', {
            '': json
          }) : fromJSDefault(json);
        }

        function fromJSWith(converter, json, key, parentJSON) {
          if (Array.isArray(json)) {
            return converter.call(parentJSON, key, IndexedSeq(json).map(function (v, k) {
              return fromJSWith(converter, v, k, json);
            }));
          }

          if (isPlainObj(json)) {
            return converter.call(parentJSON, key, KeyedSeq(json).map(function (v, k) {
              return fromJSWith(converter, v, k, json);
            }));
          }

          return json;
        }

        function fromJSDefault(json) {
          if (Array.isArray(json)) {
            return IndexedSeq(json).map(fromJSDefault).toList();
          }

          if (isPlainObj(json)) {
            return KeyedSeq(json).map(fromJSDefault).toMap();
          }

          return json;
        }

        function isPlainObj(value) {
          return value && (value.constructor === Object || value.constructor === undefined);
        }
        /**
         * An extension of the "same-value" algorithm as [described for use by ES6 Map
         * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
         *
         * NaN is considered the same as NaN, however -0 and 0 are considered the same
         * value, which is different from the algorithm described by
         * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
         *
         * This is extended further to allow Objects to describe the values they
         * represent, by way of `valueOf` or `equals` (and `hashCode`).
         *
         * Note: because of this extension, the key equality of Immutable.Map and the
         * value equality of Immutable.Set will differ from ES6 Map and Set.
         *
         * ### Defining custom values
         *
         * The easiest way to describe the value an object represents is by implementing
         * `valueOf`. For example, `Date` represents a value by returning a unix
         * timestamp for `valueOf`:
         *
         *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
         *     var date2 = new Date(1234567890000);
         *     date1.valueOf(); // 1234567890000
         *     assert( date1 !== date2 );
         *     assert( Immutable.is( date1, date2 ) );
         *
         * Note: overriding `valueOf` may have other implications if you use this object
         * where JavaScript expects a primitive, such as implicit string coercion.
         *
         * For more complex types, especially collections, implementing `valueOf` may
         * not be performant. An alternative is to implement `equals` and `hashCode`.
         *
         * `equals` takes another object, presumably of similar type, and returns true
         * if the it is equal. Equality is symmetrical, so the same result should be
         * returned if this and the argument are flipped.
         *
         *     assert( a.equals(b) === b.equals(a) );
         *
         * `hashCode` returns a 32bit integer number representing the object which will
         * be used to determine how to store the value object in a Map or Set. You must
         * provide both or neither methods, one must not exist without the other.
         *
         * Also, an important relationship between these methods must be upheld: if two
         * values are equal, they *must* return the same hashCode. If the values are not
         * equal, they might have the same hashCode; this is called a hash collision,
         * and while undesirable for performance reasons, it is acceptable.
         *
         *     if (a.equals(b)) {
         *       assert( a.hashCode() === b.hashCode() );
         *     }
         *
         * All Immutable collections implement `equals` and `hashCode`.
         *
         */


        function is(valueA, valueB) {
          if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
            return true;
          }

          if (!valueA || !valueB) {
            return false;
          }

          if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
            valueA = valueA.valueOf();
            valueB = valueB.valueOf();

            if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
              return true;
            }

            if (!valueA || !valueB) {
              return false;
            }
          }

          if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) {
            return true;
          }

          return false;
        }

        function deepEqual(a, b) {
          if (a === b) {
            return true;
          }

          if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) {
            return false;
          }

          if (a.size === 0 && b.size === 0) {
            return true;
          }

          var notAssociative = !isAssociative(a);

          if (isOrdered(a)) {
            var entries = a.entries();
            return b.every(function (v, k) {
              var entry = entries.next().value;
              return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
            }) && entries.next().done;
          }

          var flipped = false;

          if (a.size === undefined) {
            if (b.size === undefined) {
              if (typeof a.cacheResult === 'function') {
                a.cacheResult();
              }
            } else {
              flipped = true;
              var _ = a;
              a = b;
              b = _;
            }
          }

          var allEqual = true;

          var bSize = b.__iterate(function (v, k) {
            if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
              allEqual = false;
              return false;
            }
          });

          return allEqual && a.size === bSize;
        }

        createClass(Repeat, IndexedSeq);

        function Repeat(value, times) {
          if (!(this instanceof Repeat)) {
            return new Repeat(value, times);
          }

          this._value = value;
          this.size = times === undefined ? Infinity : Math.max(0, times);

          if (this.size === 0) {
            if (EMPTY_REPEAT) {
              return EMPTY_REPEAT;
            }

            EMPTY_REPEAT = this;
          }
        }

        Repeat.prototype.toString = function () {
          if (this.size === 0) {
            return 'Repeat []';
          }

          return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
        };

        Repeat.prototype.get = function (index, notSetValue) {
          return this.has(index) ? this._value : notSetValue;
        };

        Repeat.prototype.includes = function (searchValue) {
          return is(this._value, searchValue);
        };

        Repeat.prototype.slice = function (begin, end) {
          var size = this.size;
          return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
        };

        Repeat.prototype.reverse = function () {
          return this;
        };

        Repeat.prototype.indexOf = function (searchValue) {
          if (is(this._value, searchValue)) {
            return 0;
          }

          return -1;
        };

        Repeat.prototype.lastIndexOf = function (searchValue) {
          if (is(this._value, searchValue)) {
            return this.size;
          }

          return -1;
        };

        Repeat.prototype.__iterate = function (fn, reverse) {
          for (var ii = 0; ii < this.size; ii++) {
            if (fn(this._value, ii, this) === false) {
              return ii + 1;
            }
          }

          return ii;
        };

        Repeat.prototype.__iterator = function (type, reverse) {
          var this$0 = this;
          var ii = 0;
          return new Iterator(function () {
            return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
          });
        };

        Repeat.prototype.equals = function (other) {
          return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
        };

        var EMPTY_REPEAT;

        function invariant(condition, error) {
          if (!condition) throw new Error(error);
        }

        createClass(Range, IndexedSeq);

        function Range(start, end, step) {
          if (!(this instanceof Range)) {
            return new Range(start, end, step);
          }

          invariant(step !== 0, 'Cannot step a Range by 0');
          start = start || 0;

          if (end === undefined) {
            end = Infinity;
          }

          step = step === undefined ? 1 : Math.abs(step);

          if (end < start) {
            step = -step;
          }

          this._start = start;
          this._end = end;
          this._step = step;
          this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);

          if (this.size === 0) {
            if (EMPTY_RANGE) {
              return EMPTY_RANGE;
            }

            EMPTY_RANGE = this;
          }
        }

        Range.prototype.toString = function () {
          if (this.size === 0) {
            return 'Range []';
          }

          return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
        };

        Range.prototype.get = function (index, notSetValue) {
          return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
        };

        Range.prototype.includes = function (searchValue) {
          var possibleIndex = (searchValue - this._start) / this._step;
          return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
        };

        Range.prototype.slice = function (begin, end) {
          if (wholeSlice(begin, end, this.size)) {
            return this;
          }

          begin = resolveBegin(begin, this.size);
          end = resolveEnd(end, this.size);

          if (end <= begin) {
            return new Range(0, 0);
          }

          return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
        };

        Range.prototype.indexOf = function (searchValue) {
          var offsetValue = searchValue - this._start;

          if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;

            if (index >= 0 && index < this.size) {
              return index;
            }
          }

          return -1;
        };

        Range.prototype.lastIndexOf = function (searchValue) {
          return this.indexOf(searchValue);
        };

        Range.prototype.__iterate = function (fn, reverse) {
          var maxIndex = this.size - 1;
          var step = this._step;
          var value = reverse ? this._start + maxIndex * step : this._start;

          for (var ii = 0; ii <= maxIndex; ii++) {
            if (fn(value, ii, this) === false) {
              return ii + 1;
            }

            value += reverse ? -step : step;
          }

          return ii;
        };

        Range.prototype.__iterator = function (type, reverse) {
          var maxIndex = this.size - 1;
          var step = this._step;
          var value = reverse ? this._start + maxIndex * step : this._start;
          var ii = 0;
          return new Iterator(function () {
            var v = value;
            value += reverse ? -step : step;
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
          });
        };

        Range.prototype.equals = function (other) {
          return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
        };

        var EMPTY_RANGE;
        createClass(Collection, Iterable);

        function Collection() {
          throw TypeError('Abstract');
        }

        createClass(KeyedCollection, Collection);

        function KeyedCollection() {}

        createClass(IndexedCollection, Collection);

        function IndexedCollection() {}

        createClass(SetCollection, Collection);

        function SetCollection() {}

        Collection.Keyed = KeyedCollection;
        Collection.Indexed = IndexedCollection;
        Collection.Set = SetCollection;
        var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
          a = a | 0; // int

          b = b | 0; // int

          var c = a & 0xffff;
          var d = b & 0xffff; // Shift by 0 fixes the sign on the high part.

          return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
        }; // v8 has an optimization for storing 31-bit signed numbers.
        // Values which have either 00 or 11 as the high order bits qualify.
        // This function drops the highest order bit in a signed number, maintaining
        // the sign bit.

        function smi(i32) {
          return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
        }

        function hash(o) {
          if (o === false || o === null || o === undefined) {
            return 0;
          }

          if (typeof o.valueOf === 'function') {
            o = o.valueOf();

            if (o === false || o === null || o === undefined) {
              return 0;
            }
          }

          if (o === true) {
            return 1;
          }

          var type = typeof o;

          if (type === 'number') {
            if (o !== o || o === Infinity) {
              return 0;
            }

            var h = o | 0;

            if (h !== o) {
              h ^= o * 0xFFFFFFFF;
            }

            while (o > 0xFFFFFFFF) {
              o /= 0xFFFFFFFF;
              h ^= o;
            }

            return smi(h);
          }

          if (type === 'string') {
            return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
          }

          if (typeof o.hashCode === 'function') {
            return o.hashCode();
          }

          if (type === 'object') {
            return hashJSObj(o);
          }

          if (typeof o.toString === 'function') {
            return hashString(o.toString());
          }

          throw new Error('Value type ' + type + ' cannot be hashed.');
        }

        function cachedHashString(string) {
          var hash = stringHashCache[string];

          if (hash === undefined) {
            hash = hashString(string);

            if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
              STRING_HASH_CACHE_SIZE = 0;
              stringHashCache = {};
            }

            STRING_HASH_CACHE_SIZE++;
            stringHashCache[string] = hash;
          }

          return hash;
        } // http://jsperf.com/hashing-strings


        function hashString(string) {
          // This is the hash from JVM
          // The hash code for a string is computed as
          // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
          // where s[i] is the ith character of the string and n is the length of
          // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
          // (exclusive) by dropping high bits.
          var hash = 0;

          for (var ii = 0; ii < string.length; ii++) {
            hash = 31 * hash + string.charCodeAt(ii) | 0;
          }

          return smi(hash);
        }

        function hashJSObj(obj) {
          var hash;

          if (usingWeakMap) {
            hash = weakMap.get(obj);

            if (hash !== undefined) {
              return hash;
            }
          }

          hash = obj[UID_HASH_KEY];

          if (hash !== undefined) {
            return hash;
          }

          if (!canDefineProperty) {
            hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];

            if (hash !== undefined) {
              return hash;
            }

            hash = getIENodeHash(obj);

            if (hash !== undefined) {
              return hash;
            }
          }

          hash = ++objHashUID;

          if (objHashUID & 0x40000000) {
            objHashUID = 0;
          }

          if (usingWeakMap) {
            weakMap.set(obj, hash);
          } else if (isExtensible !== undefined && isExtensible(obj) === false) {
            throw new Error('Non-extensible objects are not allowed as keys.');
          } else if (canDefineProperty) {
            Object.defineProperty(obj, UID_HASH_KEY, {
              'enumerable': false,
              'configurable': false,
              'writable': false,
              'value': hash
            });
          } else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
            // Since we can't define a non-enumerable property on the object
            // we'll hijack one of the less-used non-enumerable properties to
            // save our hash on it. Since this is a function it will not show up in
            // `JSON.stringify` which is what we want.
            obj.propertyIsEnumerable = function () {
              return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            };

            obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
          } else if (obj.nodeType !== undefined) {
            // At this point we couldn't get the IE `uniqueID` to use as a hash
            // and we couldn't use a non-enumerable property to exploit the
            // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
            // itself.
            obj[UID_HASH_KEY] = hash;
          } else {
            throw new Error('Unable to set a non-enumerable property on object.');
          }

          return hash;
        } // Get references to ES5 object methods.


        var isExtensible = Object.isExtensible; // True if Object.defineProperty works as expected. IE8 fails this test.

        var canDefineProperty = function () {
          try {
            Object.defineProperty({}, '@', {});
            return true;
          } catch (e) {
            return false;
          }
        }(); // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
        // and avoid memory leaks from the IE cloneNode bug.


        function getIENodeHash(node) {
          if (node && node.nodeType > 0) {
            switch (node.nodeType) {
              case 1:
                // Element
                return node.uniqueID;

              case 9:
                // Document
                return node.documentElement && node.documentElement.uniqueID;
            }
          }
        } // If possible, use a WeakMap.


        var usingWeakMap = typeof WeakMap === 'function';
        var weakMap;

        if (usingWeakMap) {
          weakMap = new WeakMap();
        }

        var objHashUID = 0;
        var UID_HASH_KEY = '__immutablehash__';

        if (typeof Symbol === 'function') {
          UID_HASH_KEY = Symbol(UID_HASH_KEY);
        }

        var STRING_HASH_CACHE_MIN_STRLEN = 16;
        var STRING_HASH_CACHE_MAX_SIZE = 255;
        var STRING_HASH_CACHE_SIZE = 0;
        var stringHashCache = {};

        function assertNotInfinite(size) {
          invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
        }

        createClass(Map, KeyedCollection); // @pragma Construction

        function Map(value) {
          return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function (map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v, k) {
              return map.set(k, v);
            });
          });
        }

        Map.of = function () {
          var keyValues = SLICE$0.call(arguments, 0);
          return emptyMap().withMutations(function (map) {
            for (var i = 0; i < keyValues.length; i += 2) {
              if (i + 1 >= keyValues.length) {
                throw new Error('Missing value for key: ' + keyValues[i]);
              }

              map.set(keyValues[i], keyValues[i + 1]);
            }
          });
        };

        Map.prototype.toString = function () {
          return this.__toString('Map {', '}');
        }; // @pragma Access


        Map.prototype.get = function (k, notSetValue) {
          return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
        }; // @pragma Modification


        Map.prototype.set = function (k, v) {
          return updateMap(this, k, v);
        };

        Map.prototype.setIn = function (keyPath, v) {
          return this.updateIn(keyPath, NOT_SET, function () {
            return v;
          });
        };

        Map.prototype.remove = function (k) {
          return updateMap(this, k, NOT_SET);
        };

        Map.prototype.deleteIn = function (keyPath) {
          return this.updateIn(keyPath, function () {
            return NOT_SET;
          });
        };

        Map.prototype.update = function (k, notSetValue, updater) {
          return arguments.length === 1 ? k(this) : this.updateIn([k], notSetValue, updater);
        };

        Map.prototype.updateIn = function (keyPath, notSetValue, updater) {
          if (!updater) {
            updater = notSetValue;
            notSetValue = undefined;
          }

          var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
          return updatedValue === NOT_SET ? undefined : updatedValue;
        };

        Map.prototype.clear = function () {
          if (this.size === 0) {
            return this;
          }

          if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return emptyMap();
        }; // @pragma Composition


        Map.prototype.merge = function ()
        /*...iters*/
        {
          return mergeIntoMapWith(this, undefined, arguments);
        };

        Map.prototype.mergeWith = function (merger) {
          var iters = SLICE$0.call(arguments, 1);
          return mergeIntoMapWith(this, merger, iters);
        };

        Map.prototype.mergeIn = function (keyPath) {
          var iters = SLICE$0.call(arguments, 1);
          return this.updateIn(keyPath, emptyMap(), function (m) {
            return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
          });
        };

        Map.prototype.mergeDeep = function ()
        /*...iters*/
        {
          return mergeIntoMapWith(this, deepMerger, arguments);
        };

        Map.prototype.mergeDeepWith = function (merger) {
          var iters = SLICE$0.call(arguments, 1);
          return mergeIntoMapWith(this, deepMergerWith(merger), iters);
        };

        Map.prototype.mergeDeepIn = function (keyPath) {
          var iters = SLICE$0.call(arguments, 1);
          return this.updateIn(keyPath, emptyMap(), function (m) {
            return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
          });
        };

        Map.prototype.sort = function (comparator) {
          // Late binding
          return OrderedMap(sortFactory(this, comparator));
        };

        Map.prototype.sortBy = function (mapper, comparator) {
          // Late binding
          return OrderedMap(sortFactory(this, comparator, mapper));
        }; // @pragma Mutability


        Map.prototype.withMutations = function (fn) {
          var mutable = this.asMutable();
          fn(mutable);
          return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
        };

        Map.prototype.asMutable = function () {
          return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
        };

        Map.prototype.asImmutable = function () {
          return this.__ensureOwner();
        };

        Map.prototype.wasAltered = function () {
          return this.__altered;
        };

        Map.prototype.__iterator = function (type, reverse) {
          return new MapIterator(this, type, reverse);
        };

        Map.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          var iterations = 0;
          this._root && this._root.iterate(function (entry) {
            iterations++;
            return fn(entry[1], entry[0], this$0);
          }, reverse);
          return iterations;
        };

        Map.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
          }

          return makeMap(this.size, this._root, ownerID, this.__hash);
        };

        function isMap(maybeMap) {
          return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
        }

        Map.isMap = isMap;
        var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
        var MapPrototype = Map.prototype;
        MapPrototype[IS_MAP_SENTINEL] = true;
        MapPrototype[DELETE] = MapPrototype.remove;
        MapPrototype.removeIn = MapPrototype.deleteIn; // #pragma Trie Nodes

        function ArrayMapNode(ownerID, entries) {
          this.ownerID = ownerID;
          this.entries = entries;
        }

        ArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
          var entries = this.entries;

          for (var ii = 0, len = entries.length; ii < len; ii++) {
            if (is(key, entries[ii][0])) {
              return entries[ii][1];
            }
          }

          return notSetValue;
        };

        ArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          var removed = value === NOT_SET;
          var entries = this.entries;
          var idx = 0;

          for (var len = entries.length; idx < len; idx++) {
            if (is(key, entries[idx][0])) {
              break;
            }
          }

          var exists = idx < len;

          if (exists ? entries[idx][1] === value : removed) {
            return this;
          }

          SetRef(didAlter);
          (removed || !exists) && SetRef(didChangeSize);

          if (removed && entries.length === 1) {
            return; // undefined
          }

          if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
            return createNodes(ownerID, entries, key, value);
          }

          var isEditable = ownerID && ownerID === this.ownerID;
          var newEntries = isEditable ? entries : arrCopy(entries);

          if (exists) {
            if (removed) {
              idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            } else {
              newEntries[idx] = [key, value];
            }
          } else {
            newEntries.push([key, value]);
          }

          if (isEditable) {
            this.entries = newEntries;
            return this;
          }

          return new ArrayMapNode(ownerID, newEntries);
        };

        function BitmapIndexedNode(ownerID, bitmap, nodes) {
          this.ownerID = ownerID;
          this.bitmap = bitmap;
          this.nodes = nodes;
        }

        BitmapIndexedNode.prototype.get = function (shift, keyHash, key, notSetValue) {
          if (keyHash === undefined) {
            keyHash = hash(key);
          }

          var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
          var bitmap = this.bitmap;
          return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
        };

        BitmapIndexedNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          if (keyHash === undefined) {
            keyHash = hash(key);
          }

          var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
          var bit = 1 << keyHashFrag;
          var bitmap = this.bitmap;
          var exists = (bitmap & bit) !== 0;

          if (!exists && value === NOT_SET) {
            return this;
          }

          var idx = popCount(bitmap & bit - 1);
          var nodes = this.nodes;
          var node = exists ? nodes[idx] : undefined;
          var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

          if (newNode === node) {
            return this;
          }

          if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
            return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
          }

          if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
            return nodes[idx ^ 1];
          }

          if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
            return newNode;
          }

          var isEditable = ownerID && ownerID === this.ownerID;
          var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
          var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);

          if (isEditable) {
            this.bitmap = newBitmap;
            this.nodes = newNodes;
            return this;
          }

          return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
        };

        function HashArrayMapNode(ownerID, count, nodes) {
          this.ownerID = ownerID;
          this.count = count;
          this.nodes = nodes;
        }

        HashArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
          if (keyHash === undefined) {
            keyHash = hash(key);
          }

          var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
          var node = this.nodes[idx];
          return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
        };

        HashArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          if (keyHash === undefined) {
            keyHash = hash(key);
          }

          var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
          var removed = value === NOT_SET;
          var nodes = this.nodes;
          var node = nodes[idx];

          if (removed && !node) {
            return this;
          }

          var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

          if (newNode === node) {
            return this;
          }

          var newCount = this.count;

          if (!node) {
            newCount++;
          } else if (!newNode) {
            newCount--;

            if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
              return packNodes(ownerID, nodes, newCount, idx);
            }
          }

          var isEditable = ownerID && ownerID === this.ownerID;
          var newNodes = setIn(nodes, idx, newNode, isEditable);

          if (isEditable) {
            this.count = newCount;
            this.nodes = newNodes;
            return this;
          }

          return new HashArrayMapNode(ownerID, newCount, newNodes);
        };

        function HashCollisionNode(ownerID, keyHash, entries) {
          this.ownerID = ownerID;
          this.keyHash = keyHash;
          this.entries = entries;
        }

        HashCollisionNode.prototype.get = function (shift, keyHash, key, notSetValue) {
          var entries = this.entries;

          for (var ii = 0, len = entries.length; ii < len; ii++) {
            if (is(key, entries[ii][0])) {
              return entries[ii][1];
            }
          }

          return notSetValue;
        };

        HashCollisionNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          if (keyHash === undefined) {
            keyHash = hash(key);
          }

          var removed = value === NOT_SET;

          if (keyHash !== this.keyHash) {
            if (removed) {
              return this;
            }

            SetRef(didAlter);
            SetRef(didChangeSize);
            return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
          }

          var entries = this.entries;
          var idx = 0;

          for (var len = entries.length; idx < len; idx++) {
            if (is(key, entries[idx][0])) {
              break;
            }
          }

          var exists = idx < len;

          if (exists ? entries[idx][1] === value : removed) {
            return this;
          }

          SetRef(didAlter);
          (removed || !exists) && SetRef(didChangeSize);

          if (removed && len === 2) {
            return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
          }

          var isEditable = ownerID && ownerID === this.ownerID;
          var newEntries = isEditable ? entries : arrCopy(entries);

          if (exists) {
            if (removed) {
              idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            } else {
              newEntries[idx] = [key, value];
            }
          } else {
            newEntries.push([key, value]);
          }

          if (isEditable) {
            this.entries = newEntries;
            return this;
          }

          return new HashCollisionNode(ownerID, this.keyHash, newEntries);
        };

        function ValueNode(ownerID, keyHash, entry) {
          this.ownerID = ownerID;
          this.keyHash = keyHash;
          this.entry = entry;
        }

        ValueNode.prototype.get = function (shift, keyHash, key, notSetValue) {
          return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
        };

        ValueNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          var removed = value === NOT_SET;
          var keyMatch = is(key, this.entry[0]);

          if (keyMatch ? value === this.entry[1] : removed) {
            return this;
          }

          SetRef(didAlter);

          if (removed) {
            SetRef(didChangeSize);
            return; // undefined
          }

          if (keyMatch) {
            if (ownerID && ownerID === this.ownerID) {
              this.entry[1] = value;
              return this;
            }

            return new ValueNode(ownerID, this.keyHash, [key, value]);
          }

          SetRef(didChangeSize);
          return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
        }; // #pragma Iterators


        ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function (fn, reverse) {
          var entries = this.entries;

          for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
            if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
              return false;
            }
          }
        };

        BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function (fn, reverse) {
          var nodes = this.nodes;

          for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
            var node = nodes[reverse ? maxIndex - ii : ii];

            if (node && node.iterate(fn, reverse) === false) {
              return false;
            }
          }
        };

        ValueNode.prototype.iterate = function (fn, reverse) {
          return fn(this.entry);
        };

        createClass(MapIterator, Iterator);

        function MapIterator(map, type, reverse) {
          this._type = type;
          this._reverse = reverse;
          this._stack = map._root && mapIteratorFrame(map._root);
        }

        MapIterator.prototype.next = function () {
          var type = this._type;
          var stack = this._stack;

          while (stack) {
            var node = stack.node;
            var index = stack.index++;
            var maxIndex;

            if (node.entry) {
              if (index === 0) {
                return mapIteratorValue(type, node.entry);
              }
            } else if (node.entries) {
              maxIndex = node.entries.length - 1;

              if (index <= maxIndex) {
                return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
              }
            } else {
              maxIndex = node.nodes.length - 1;

              if (index <= maxIndex) {
                var subNode = node.nodes[this._reverse ? maxIndex - index : index];

                if (subNode) {
                  if (subNode.entry) {
                    return mapIteratorValue(type, subNode.entry);
                  }

                  stack = this._stack = mapIteratorFrame(subNode, stack);
                }

                continue;
              }
            }

            stack = this._stack = this._stack.__prev;
          }

          return iteratorDone();
        };

        function mapIteratorValue(type, entry) {
          return iteratorValue(type, entry[0], entry[1]);
        }

        function mapIteratorFrame(node, prev) {
          return {
            node: node,
            index: 0,
            __prev: prev
          };
        }

        function makeMap(size, root, ownerID, hash) {
          var map = Object.create(MapPrototype);
          map.size = size;
          map._root = root;
          map.__ownerID = ownerID;
          map.__hash = hash;
          map.__altered = false;
          return map;
        }

        var EMPTY_MAP;

        function emptyMap() {
          return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
        }

        function updateMap(map, k, v) {
          var newRoot;
          var newSize;

          if (!map._root) {
            if (v === NOT_SET) {
              return map;
            }

            newSize = 1;
            newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
          } else {
            var didChangeSize = MakeRef(CHANGE_LENGTH);
            var didAlter = MakeRef(DID_ALTER);
            newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);

            if (!didAlter.value) {
              return map;
            }

            newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
          }

          if (map.__ownerID) {
            map.size = newSize;
            map._root = newRoot;
            map.__hash = undefined;
            map.__altered = true;
            return map;
          }

          return newRoot ? makeMap(newSize, newRoot) : emptyMap();
        }

        function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
          if (!node) {
            if (value === NOT_SET) {
              return node;
            }

            SetRef(didAlter);
            SetRef(didChangeSize);
            return new ValueNode(ownerID, keyHash, [key, value]);
          }

          return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
        }

        function isLeafNode(node) {
          return node.constructor === ValueNode || node.constructor === HashCollisionNode;
        }

        function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
          if (node.keyHash === keyHash) {
            return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
          }

          var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
          var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
          var newNode;
          var nodes = idx1 === idx2 ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);
          return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
        }

        function createNodes(ownerID, entries, key, value) {
          if (!ownerID) {
            ownerID = new OwnerID();
          }

          var node = new ValueNode(ownerID, hash(key), [key, value]);

          for (var ii = 0; ii < entries.length; ii++) {
            var entry = entries[ii];
            node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
          }

          return node;
        }

        function packNodes(ownerID, nodes, count, excluding) {
          var bitmap = 0;
          var packedII = 0;
          var packedNodes = new Array(count);

          for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
            var node = nodes[ii];

            if (node !== undefined && ii !== excluding) {
              bitmap |= bit;
              packedNodes[packedII++] = node;
            }
          }

          return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
        }

        function expandNodes(ownerID, nodes, bitmap, including, node) {
          var count = 0;
          var expandedNodes = new Array(SIZE);

          for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
            expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
          }

          expandedNodes[including] = node;
          return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
        }

        function mergeIntoMapWith(map, merger, iterables) {
          var iters = [];

          for (var ii = 0; ii < iterables.length; ii++) {
            var value = iterables[ii];
            var iter = KeyedIterable(value);

            if (!isIterable(value)) {
              iter = iter.map(function (v) {
                return fromJS(v);
              });
            }

            iters.push(iter);
          }

          return mergeIntoCollectionWith(map, merger, iters);
        }

        function deepMerger(existing, value, key) {
          return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
        }

        function deepMergerWith(merger) {
          return function (existing, value, key) {
            if (existing && existing.mergeDeepWith && isIterable(value)) {
              return existing.mergeDeepWith(merger, value);
            }

            var nextValue = merger(existing, value, key);
            return is(existing, nextValue) ? existing : nextValue;
          };
        }

        function mergeIntoCollectionWith(collection, merger, iters) {
          iters = iters.filter(function (x) {
            return x.size !== 0;
          });

          if (iters.length === 0) {
            return collection;
          }

          if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
            return collection.constructor(iters[0]);
          }

          return collection.withMutations(function (collection) {
            var mergeIntoMap = merger ? function (value, key) {
              collection.update(key, NOT_SET, function (existing) {
                return existing === NOT_SET ? value : merger(existing, value, key);
              });
            } : function (value, key) {
              collection.set(key, value);
            };

            for (var ii = 0; ii < iters.length; ii++) {
              iters[ii].forEach(mergeIntoMap);
            }
          });
        }

        function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
          var isNotSet = existing === NOT_SET;
          var step = keyPathIter.next();

          if (step.done) {
            var existingValue = isNotSet ? notSetValue : existing;
            var newValue = updater(existingValue);
            return newValue === existingValue ? existing : newValue;
          }

          invariant(isNotSet || existing && existing.set, 'invalid keyPath');
          var key = step.value;
          var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
          var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
          return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
        }

        function popCount(x) {
          x = x - (x >> 1 & 0x55555555);
          x = (x & 0x33333333) + (x >> 2 & 0x33333333);
          x = x + (x >> 4) & 0x0f0f0f0f;
          x = x + (x >> 8);
          x = x + (x >> 16);
          return x & 0x7f;
        }

        function setIn(array, idx, val, canEdit) {
          var newArray = canEdit ? array : arrCopy(array);
          newArray[idx] = val;
          return newArray;
        }

        function spliceIn(array, idx, val, canEdit) {
          var newLen = array.length + 1;

          if (canEdit && idx + 1 === newLen) {
            array[idx] = val;
            return array;
          }

          var newArray = new Array(newLen);
          var after = 0;

          for (var ii = 0; ii < newLen; ii++) {
            if (ii === idx) {
              newArray[ii] = val;
              after = -1;
            } else {
              newArray[ii] = array[ii + after];
            }
          }

          return newArray;
        }

        function spliceOut(array, idx, canEdit) {
          var newLen = array.length - 1;

          if (canEdit && idx === newLen) {
            array.pop();
            return array;
          }

          var newArray = new Array(newLen);
          var after = 0;

          for (var ii = 0; ii < newLen; ii++) {
            if (ii === idx) {
              after = 1;
            }

            newArray[ii] = array[ii + after];
          }

          return newArray;
        }

        var MAX_ARRAY_MAP_SIZE = SIZE / 4;
        var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
        var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
        createClass(List, IndexedCollection); // @pragma Construction

        function List(value) {
          var empty = emptyList();

          if (value === null || value === undefined) {
            return empty;
          }

          if (isList(value)) {
            return value;
          }

          var iter = IndexedIterable(value);
          var size = iter.size;

          if (size === 0) {
            return empty;
          }

          assertNotInfinite(size);

          if (size > 0 && size < SIZE) {
            return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
          }

          return empty.withMutations(function (list) {
            list.setSize(size);
            iter.forEach(function (v, i) {
              return list.set(i, v);
            });
          });
        }

        List.of = function ()
        /*...values*/
        {
          return this(arguments);
        };

        List.prototype.toString = function () {
          return this.__toString('List [', ']');
        }; // @pragma Access


        List.prototype.get = function (index, notSetValue) {
          index = wrapIndex(this, index);

          if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
          }

          return notSetValue;
        }; // @pragma Modification


        List.prototype.set = function (index, value) {
          return updateList(this, index, value);
        };

        List.prototype.remove = function (index) {
          return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
        };

        List.prototype.insert = function (index, value) {
          return this.splice(index, 0, value);
        };

        List.prototype.clear = function () {
          if (this.size === 0) {
            return this;
          }

          if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return emptyList();
        };

        List.prototype.push = function ()
        /*...values*/
        {
          var values = arguments;
          var oldSize = this.size;
          return this.withMutations(function (list) {
            setListBounds(list, 0, oldSize + values.length);

            for (var ii = 0; ii < values.length; ii++) {
              list.set(oldSize + ii, values[ii]);
            }
          });
        };

        List.prototype.pop = function () {
          return setListBounds(this, 0, -1);
        };

        List.prototype.unshift = function ()
        /*...values*/
        {
          var values = arguments;
          return this.withMutations(function (list) {
            setListBounds(list, -values.length);

            for (var ii = 0; ii < values.length; ii++) {
              list.set(ii, values[ii]);
            }
          });
        };

        List.prototype.shift = function () {
          return setListBounds(this, 1);
        }; // @pragma Composition


        List.prototype.merge = function ()
        /*...iters*/
        {
          return mergeIntoListWith(this, undefined, arguments);
        };

        List.prototype.mergeWith = function (merger) {
          var iters = SLICE$0.call(arguments, 1);
          return mergeIntoListWith(this, merger, iters);
        };

        List.prototype.mergeDeep = function ()
        /*...iters*/
        {
          return mergeIntoListWith(this, deepMerger, arguments);
        };

        List.prototype.mergeDeepWith = function (merger) {
          var iters = SLICE$0.call(arguments, 1);
          return mergeIntoListWith(this, deepMergerWith(merger), iters);
        };

        List.prototype.setSize = function (size) {
          return setListBounds(this, 0, size);
        }; // @pragma Iteration


        List.prototype.slice = function (begin, end) {
          var size = this.size;

          if (wholeSlice(begin, end, size)) {
            return this;
          }

          return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
        };

        List.prototype.__iterator = function (type, reverse) {
          var index = 0;
          var values = iterateList(this, reverse);
          return new Iterator(function () {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
          });
        };

        List.prototype.__iterate = function (fn, reverse) {
          var index = 0;
          var values = iterateList(this, reverse);
          var value;

          while ((value = values()) !== DONE) {
            if (fn(value, index++, this) === false) {
              break;
            }
          }

          return index;
        };

        List.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          if (!ownerID) {
            this.__ownerID = ownerID;
            return this;
          }

          return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
        };

        function isList(maybeList) {
          return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
        }

        List.isList = isList;
        var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
        var ListPrototype = List.prototype;
        ListPrototype[IS_LIST_SENTINEL] = true;
        ListPrototype[DELETE] = ListPrototype.remove;
        ListPrototype.setIn = MapPrototype.setIn;
        ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
        ListPrototype.update = MapPrototype.update;
        ListPrototype.updateIn = MapPrototype.updateIn;
        ListPrototype.mergeIn = MapPrototype.mergeIn;
        ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
        ListPrototype.withMutations = MapPrototype.withMutations;
        ListPrototype.asMutable = MapPrototype.asMutable;
        ListPrototype.asImmutable = MapPrototype.asImmutable;
        ListPrototype.wasAltered = MapPrototype.wasAltered;

        function VNode(array, ownerID) {
          this.array = array;
          this.ownerID = ownerID;
        } // TODO: seems like these methods are very similar


        VNode.prototype.removeBefore = function (ownerID, level, index) {
          if (index === level ? 1 << level : 0 || this.array.length === 0) {
            return this;
          }

          var originIndex = index >>> level & MASK;

          if (originIndex >= this.array.length) {
            return new VNode([], ownerID);
          }

          var removingFirst = originIndex === 0;
          var newChild;

          if (level > 0) {
            var oldChild = this.array[originIndex];
            newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);

            if (newChild === oldChild && removingFirst) {
              return this;
            }
          }

          if (removingFirst && !newChild) {
            return this;
          }

          var editable = editableVNode(this, ownerID);

          if (!removingFirst) {
            for (var ii = 0; ii < originIndex; ii++) {
              editable.array[ii] = undefined;
            }
          }

          if (newChild) {
            editable.array[originIndex] = newChild;
          }

          return editable;
        };

        VNode.prototype.removeAfter = function (ownerID, level, index) {
          if (index === (level ? 1 << level : 0) || this.array.length === 0) {
            return this;
          }

          var sizeIndex = index - 1 >>> level & MASK;

          if (sizeIndex >= this.array.length) {
            return this;
          }

          var newChild;

          if (level > 0) {
            var oldChild = this.array[sizeIndex];
            newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);

            if (newChild === oldChild && sizeIndex === this.array.length - 1) {
              return this;
            }
          }

          var editable = editableVNode(this, ownerID);
          editable.array.splice(sizeIndex + 1);

          if (newChild) {
            editable.array[sizeIndex] = newChild;
          }

          return editable;
        };

        var DONE = {};

        function iterateList(list, reverse) {
          var left = list._origin;
          var right = list._capacity;
          var tailPos = getTailOffset(right);
          var tail = list._tail;
          return iterateNodeOrLeaf(list._root, list._level, 0);

          function iterateNodeOrLeaf(node, level, offset) {
            return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
          }

          function iterateLeaf(node, offset) {
            var array = offset === tailPos ? tail && tail.array : node && node.array;
            var from = offset > left ? 0 : left - offset;
            var to = right - offset;

            if (to > SIZE) {
              to = SIZE;
            }

            return function () {
              if (from === to) {
                return DONE;
              }

              var idx = reverse ? --to : from++;
              return array && array[idx];
            };
          }

          function iterateNode(node, level, offset) {
            var values;
            var array = node && node.array;
            var from = offset > left ? 0 : left - offset >> level;
            var to = (right - offset >> level) + 1;

            if (to > SIZE) {
              to = SIZE;
            }

            return function () {
              do {
                if (values) {
                  var value = values();

                  if (value !== DONE) {
                    return value;
                  }

                  values = null;
                }

                if (from === to) {
                  return DONE;
                }

                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
              } while (true);
            };
          }
        }

        function makeList(origin, capacity, level, root, tail, ownerID, hash) {
          var list = Object.create(ListPrototype);
          list.size = capacity - origin;
          list._origin = origin;
          list._capacity = capacity;
          list._level = level;
          list._root = root;
          list._tail = tail;
          list.__ownerID = ownerID;
          list.__hash = hash;
          list.__altered = false;
          return list;
        }

        var EMPTY_LIST;

        function emptyList() {
          return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
        }

        function updateList(list, index, value) {
          index = wrapIndex(list, index);

          if (index !== index) {
            return list;
          }

          if (index >= list.size || index < 0) {
            return list.withMutations(function (list) {
              index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
            });
          }

          index += list._origin;
          var newTail = list._tail;
          var newRoot = list._root;
          var didAlter = MakeRef(DID_ALTER);

          if (index >= getTailOffset(list._capacity)) {
            newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
          } else {
            newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
          }

          if (!didAlter.value) {
            return list;
          }

          if (list.__ownerID) {
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
          }

          return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
        }

        function updateVNode(node, ownerID, level, index, value, didAlter) {
          var idx = index >>> level & MASK;
          var nodeHas = node && idx < node.array.length;

          if (!nodeHas && value === undefined) {
            return node;
          }

          var newNode;

          if (level > 0) {
            var lowerNode = node && node.array[idx];
            var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);

            if (newLowerNode === lowerNode) {
              return node;
            }

            newNode = editableVNode(node, ownerID);
            newNode.array[idx] = newLowerNode;
            return newNode;
          }

          if (nodeHas && node.array[idx] === value) {
            return node;
          }

          SetRef(didAlter);
          newNode = editableVNode(node, ownerID);

          if (value === undefined && idx === newNode.array.length - 1) {
            newNode.array.pop();
          } else {
            newNode.array[idx] = value;
          }

          return newNode;
        }

        function editableVNode(node, ownerID) {
          if (ownerID && node && ownerID === node.ownerID) {
            return node;
          }

          return new VNode(node ? node.array.slice() : [], ownerID);
        }

        function listNodeFor(list, rawIndex) {
          if (rawIndex >= getTailOffset(list._capacity)) {
            return list._tail;
          }

          if (rawIndex < 1 << list._level + SHIFT) {
            var node = list._root;
            var level = list._level;

            while (node && level > 0) {
              node = node.array[rawIndex >>> level & MASK];
              level -= SHIFT;
            }

            return node;
          }
        }

        function setListBounds(list, begin, end) {
          // Sanitize begin & end using this shorthand for ToInt32(argument)
          // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
          if (begin !== undefined) {
            begin = begin | 0;
          }

          if (end !== undefined) {
            end = end | 0;
          }

          var owner = list.__ownerID || new OwnerID();
          var oldOrigin = list._origin;
          var oldCapacity = list._capacity;
          var newOrigin = oldOrigin + begin;
          var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;

          if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
            return list;
          } // If it's going to end after it starts, it's empty.


          if (newOrigin >= newCapacity) {
            return list.clear();
          }

          var newLevel = list._level;
          var newRoot = list._root; // New origin might need creating a higher root.

          var offsetShift = 0;

          while (newOrigin + offsetShift < 0) {
            newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
            newLevel += SHIFT;
            offsetShift += 1 << newLevel;
          }

          if (offsetShift) {
            newOrigin += offsetShift;
            oldOrigin += offsetShift;
            newCapacity += offsetShift;
            oldCapacity += offsetShift;
          }

          var oldTailOffset = getTailOffset(oldCapacity);
          var newTailOffset = getTailOffset(newCapacity); // New size might need creating a higher root.

          while (newTailOffset >= 1 << newLevel + SHIFT) {
            newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
            newLevel += SHIFT;
          } // Locate or create the new tail.


          var oldTail = list._tail;
          var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail; // Merge Tail into tree.

          if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
            newRoot = editableVNode(newRoot, owner);
            var node = newRoot;

            for (var level = newLevel; level > SHIFT; level -= SHIFT) {
              var idx = oldTailOffset >>> level & MASK;
              node = node.array[idx] = editableVNode(node.array[idx], owner);
            }

            node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
          } // If the size has been reduced, there's a chance the tail needs to be trimmed.


          if (newCapacity < oldCapacity) {
            newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
          } // If the new origin is within the tail, then we do not need a root.


          if (newOrigin >= newTailOffset) {
            newOrigin -= newTailOffset;
            newCapacity -= newTailOffset;
            newLevel = SHIFT;
            newRoot = null;
            newTail = newTail && newTail.removeBefore(owner, 0, newOrigin); // Otherwise, if the root has been trimmed, garbage collect.
          } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
            offsetShift = 0; // Identify the new top root node of the subtree of the old root.

            while (newRoot) {
              var beginIndex = newOrigin >>> newLevel & MASK;

              if (beginIndex !== newTailOffset >>> newLevel & MASK) {
                break;
              }

              if (beginIndex) {
                offsetShift += (1 << newLevel) * beginIndex;
              }

              newLevel -= SHIFT;
              newRoot = newRoot.array[beginIndex];
            } // Trim the new sides of the new root.


            if (newRoot && newOrigin > oldOrigin) {
              newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
            }

            if (newRoot && newTailOffset < oldTailOffset) {
              newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
            }

            if (offsetShift) {
              newOrigin -= offsetShift;
              newCapacity -= offsetShift;
            }
          }

          if (list.__ownerID) {
            list.size = newCapacity - newOrigin;
            list._origin = newOrigin;
            list._capacity = newCapacity;
            list._level = newLevel;
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
          }

          return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
        }

        function mergeIntoListWith(list, merger, iterables) {
          var iters = [];
          var maxSize = 0;

          for (var ii = 0; ii < iterables.length; ii++) {
            var value = iterables[ii];
            var iter = IndexedIterable(value);

            if (iter.size > maxSize) {
              maxSize = iter.size;
            }

            if (!isIterable(value)) {
              iter = iter.map(function (v) {
                return fromJS(v);
              });
            }

            iters.push(iter);
          }

          if (maxSize > list.size) {
            list = list.setSize(maxSize);
          }

          return mergeIntoCollectionWith(list, merger, iters);
        }

        function getTailOffset(size) {
          return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
        }

        createClass(OrderedMap, Map); // @pragma Construction

        function OrderedMap(value) {
          return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function (map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v, k) {
              return map.set(k, v);
            });
          });
        }

        OrderedMap.of = function ()
        /*...values*/
        {
          return this(arguments);
        };

        OrderedMap.prototype.toString = function () {
          return this.__toString('OrderedMap {', '}');
        }; // @pragma Access


        OrderedMap.prototype.get = function (k, notSetValue) {
          var index = this._map.get(k);

          return index !== undefined ? this._list.get(index)[1] : notSetValue;
        }; // @pragma Modification


        OrderedMap.prototype.clear = function () {
          if (this.size === 0) {
            return this;
          }

          if (this.__ownerID) {
            this.size = 0;

            this._map.clear();

            this._list.clear();

            return this;
          }

          return emptyOrderedMap();
        };

        OrderedMap.prototype.set = function (k, v) {
          return updateOrderedMap(this, k, v);
        };

        OrderedMap.prototype.remove = function (k) {
          return updateOrderedMap(this, k, NOT_SET);
        };

        OrderedMap.prototype.wasAltered = function () {
          return this._map.wasAltered() || this._list.wasAltered();
        };

        OrderedMap.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          return this._list.__iterate(function (entry) {
            return entry && fn(entry[1], entry[0], this$0);
          }, reverse);
        };

        OrderedMap.prototype.__iterator = function (type, reverse) {
          return this._list.fromEntrySeq().__iterator(type, reverse);
        };

        OrderedMap.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          var newMap = this._map.__ensureOwner(ownerID);

          var newList = this._list.__ensureOwner(ownerID);

          if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            this._list = newList;
            return this;
          }

          return makeOrderedMap(newMap, newList, ownerID, this.__hash);
        };

        function isOrderedMap(maybeOrderedMap) {
          return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
        }

        OrderedMap.isOrderedMap = isOrderedMap;
        OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
        OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;

        function makeOrderedMap(map, list, ownerID, hash) {
          var omap = Object.create(OrderedMap.prototype);
          omap.size = map ? map.size : 0;
          omap._map = map;
          omap._list = list;
          omap.__ownerID = ownerID;
          omap.__hash = hash;
          return omap;
        }

        var EMPTY_ORDERED_MAP;

        function emptyOrderedMap() {
          return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
        }

        function updateOrderedMap(omap, k, v) {
          var map = omap._map;
          var list = omap._list;
          var i = map.get(k);
          var has = i !== undefined;
          var newMap;
          var newList;

          if (v === NOT_SET) {
            // removed
            if (!has) {
              return omap;
            }

            if (list.size >= SIZE && list.size >= map.size * 2) {
              newList = list.filter(function (entry, idx) {
                return entry !== undefined && i !== idx;
              });
              newMap = newList.toKeyedSeq().map(function (entry) {
                return entry[0];
              }).flip().toMap();

              if (omap.__ownerID) {
                newMap.__ownerID = newList.__ownerID = omap.__ownerID;
              }
            } else {
              newMap = map.remove(k);
              newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
            }
          } else {
            if (has) {
              if (v === list.get(i)[1]) {
                return omap;
              }

              newMap = map;
              newList = list.set(i, [k, v]);
            } else {
              newMap = map.set(k, list.size);
              newList = list.set(list.size, [k, v]);
            }
          }

          if (omap.__ownerID) {
            omap.size = newMap.size;
            omap._map = newMap;
            omap._list = newList;
            omap.__hash = undefined;
            return omap;
          }

          return makeOrderedMap(newMap, newList);
        }

        createClass(ToKeyedSequence, KeyedSeq);

        function ToKeyedSequence(indexed, useKeys) {
          this._iter = indexed;
          this._useKeys = useKeys;
          this.size = indexed.size;
        }

        ToKeyedSequence.prototype.get = function (key, notSetValue) {
          return this._iter.get(key, notSetValue);
        };

        ToKeyedSequence.prototype.has = function (key) {
          return this._iter.has(key);
        };

        ToKeyedSequence.prototype.valueSeq = function () {
          return this._iter.valueSeq();
        };

        ToKeyedSequence.prototype.reverse = function () {
          var this$0 = this;
          var reversedSequence = reverseFactory(this, true);

          if (!this._useKeys) {
            reversedSequence.valueSeq = function () {
              return this$0._iter.toSeq().reverse();
            };
          }

          return reversedSequence;
        };

        ToKeyedSequence.prototype.map = function (mapper, context) {
          var this$0 = this;
          var mappedSequence = mapFactory(this, mapper, context);

          if (!this._useKeys) {
            mappedSequence.valueSeq = function () {
              return this$0._iter.toSeq().map(mapper, context);
            };
          }

          return mappedSequence;
        };

        ToKeyedSequence.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          var ii;
          return this._iter.__iterate(this._useKeys ? function (v, k) {
            return fn(v, k, this$0);
          } : (ii = reverse ? resolveSize(this) : 0, function (v) {
            return fn(v, reverse ? --ii : ii++, this$0);
          }), reverse);
        };

        ToKeyedSequence.prototype.__iterator = function (type, reverse) {
          if (this._useKeys) {
            return this._iter.__iterator(type, reverse);
          }

          var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

          var ii = reverse ? resolveSize(this) : 0;
          return new Iterator(function () {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
          });
        };

        ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
        createClass(ToIndexedSequence, IndexedSeq);

        function ToIndexedSequence(iter) {
          this._iter = iter;
          this.size = iter.size;
        }

        ToIndexedSequence.prototype.includes = function (value) {
          return this._iter.includes(value);
        };

        ToIndexedSequence.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          var iterations = 0;
          return this._iter.__iterate(function (v) {
            return fn(v, iterations++, this$0);
          }, reverse);
        };

        ToIndexedSequence.prototype.__iterator = function (type, reverse) {
          var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

          var iterations = 0;
          return new Iterator(function () {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value, step);
          });
        };

        createClass(ToSetSequence, SetSeq);

        function ToSetSequence(iter) {
          this._iter = iter;
          this.size = iter.size;
        }

        ToSetSequence.prototype.has = function (key) {
          return this._iter.includes(key);
        };

        ToSetSequence.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          return this._iter.__iterate(function (v) {
            return fn(v, v, this$0);
          }, reverse);
        };

        ToSetSequence.prototype.__iterator = function (type, reverse) {
          var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

          return new Iterator(function () {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
          });
        };

        createClass(FromEntriesSequence, KeyedSeq);

        function FromEntriesSequence(entries) {
          this._iter = entries;
          this.size = entries.size;
        }

        FromEntriesSequence.prototype.entrySeq = function () {
          return this._iter.toSeq();
        };

        FromEntriesSequence.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          return this._iter.__iterate(function (entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
              validateEntry(entry);
              var indexedIterable = isIterable(entry);
              return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
            }
          }, reverse);
        };

        FromEntriesSequence.prototype.__iterator = function (type, reverse) {
          var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

          return new Iterator(function () {
            while (true) {
              var step = iterator.next();

              if (step.done) {
                return step;
              }

              var entry = step.value; // Check if entry exists first so array access doesn't throw for holes
              // in the parent iteration.

              if (entry) {
                validateEntry(entry);
                var indexedIterable = isIterable(entry);
                return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
              }
            }
          });
        };

        ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;

        function flipFactory(iterable) {
          var flipSequence = makeSequence(iterable);
          flipSequence._iter = iterable;
          flipSequence.size = iterable.size;

          flipSequence.flip = function () {
            return iterable;
          };

          flipSequence.reverse = function () {
            var reversedSequence = iterable.reverse.apply(this); // super.reverse()

            reversedSequence.flip = function () {
              return iterable.reverse();
            };

            return reversedSequence;
          };

          flipSequence.has = function (key) {
            return iterable.includes(key);
          };

          flipSequence.includes = function (key) {
            return iterable.has(key);
          };

          flipSequence.cacheResult = cacheResultThrough;

          flipSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function (v, k) {
              return fn(k, v, this$0) !== false;
            }, reverse);
          };

          flipSequence.__iteratorUncached = function (type, reverse) {
            if (type === ITERATE_ENTRIES) {
              var iterator = iterable.__iterator(type, reverse);

              return new Iterator(function () {
                var step = iterator.next();

                if (!step.done) {
                  var k = step.value[0];
                  step.value[0] = step.value[1];
                  step.value[1] = k;
                }

                return step;
              });
            }

            return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
          };

          return flipSequence;
        }

        function mapFactory(iterable, mapper, context) {
          var mappedSequence = makeSequence(iterable);
          mappedSequence.size = iterable.size;

          mappedSequence.has = function (key) {
            return iterable.has(key);
          };

          mappedSequence.get = function (key, notSetValue) {
            var v = iterable.get(key, NOT_SET);
            return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
          };

          mappedSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function (v, k, c) {
              return fn(mapper.call(context, v, k, c), k, this$0) !== false;
            }, reverse);
          };

          mappedSequence.__iteratorUncached = function (type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

            return new Iterator(function () {
              var step = iterator.next();

              if (step.done) {
                return step;
              }

              var entry = step.value;
              var key = entry[0];
              return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
            });
          };

          return mappedSequence;
        }

        function reverseFactory(iterable, useKeys) {
          var reversedSequence = makeSequence(iterable);
          reversedSequence._iter = iterable;
          reversedSequence.size = iterable.size;

          reversedSequence.reverse = function () {
            return iterable;
          };

          if (iterable.flip) {
            reversedSequence.flip = function () {
              var flipSequence = flipFactory(iterable);

              flipSequence.reverse = function () {
                return iterable.flip();
              };

              return flipSequence;
            };
          }

          reversedSequence.get = function (key, notSetValue) {
            return iterable.get(useKeys ? key : -1 - key, notSetValue);
          };

          reversedSequence.has = function (key) {
            return iterable.has(useKeys ? key : -1 - key);
          };

          reversedSequence.includes = function (value) {
            return iterable.includes(value);
          };

          reversedSequence.cacheResult = cacheResultThrough;

          reversedSequence.__iterate = function (fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function (v, k) {
              return fn(v, k, this$0);
            }, !reverse);
          };

          reversedSequence.__iterator = function (type, reverse) {
            return iterable.__iterator(type, !reverse);
          };

          return reversedSequence;
        }

        function filterFactory(iterable, predicate, context, useKeys) {
          var filterSequence = makeSequence(iterable);

          if (useKeys) {
            filterSequence.has = function (key) {
              var v = iterable.get(key, NOT_SET);
              return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
            };

            filterSequence.get = function (key, notSetValue) {
              var v = iterable.get(key, NOT_SET);
              return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
            };
          }

          filterSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;
            var iterations = 0;

            iterable.__iterate(function (v, k, c) {
              if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$0);
              }
            }, reverse);

            return iterations;
          };

          filterSequence.__iteratorUncached = function (type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

            var iterations = 0;
            return new Iterator(function () {
              while (true) {
                var step = iterator.next();

                if (step.done) {
                  return step;
                }

                var entry = step.value;
                var key = entry[0];
                var value = entry[1];

                if (predicate.call(context, value, key, iterable)) {
                  return iteratorValue(type, useKeys ? key : iterations++, value, step);
                }
              }
            });
          };

          return filterSequence;
        }

        function countByFactory(iterable, grouper, context) {
          var groups = Map().asMutable();

          iterable.__iterate(function (v, k) {
            groups.update(grouper.call(context, v, k, iterable), 0, function (a) {
              return a + 1;
            });
          });

          return groups.asImmutable();
        }

        function groupByFactory(iterable, grouper, context) {
          var isKeyedIter = isKeyed(iterable);
          var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();

          iterable.__iterate(function (v, k) {
            groups.update(grouper.call(context, v, k, iterable), function (a) {
              return a = a || [], a.push(isKeyedIter ? [k, v] : v), a;
            });
          });

          var coerce = iterableClass(iterable);
          return groups.map(function (arr) {
            return reify(iterable, coerce(arr));
          });
        }

        function sliceFactory(iterable, begin, end, useKeys) {
          var originalSize = iterable.size; // Sanitize begin & end using this shorthand for ToInt32(argument)
          // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32

          if (begin !== undefined) {
            begin = begin | 0;
          }

          if (end !== undefined) {
            if (end === Infinity) {
              end = originalSize;
            } else {
              end = end | 0;
            }
          }

          if (wholeSlice(begin, end, originalSize)) {
            return iterable;
          }

          var resolvedBegin = resolveBegin(begin, originalSize);
          var resolvedEnd = resolveEnd(end, originalSize); // begin or end will be NaN if they were provided as negative numbers and
          // this iterable's size is unknown. In that case, cache first so there is
          // a known size and these do not resolve to NaN.

          if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
            return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
          } // Note: resolvedEnd is undefined when the original sequence's length is
          // unknown and this slice did not supply an end and should contain all
          // elements after resolvedBegin.
          // In that case, resolvedSize will be NaN and sliceSize will remain undefined.


          var resolvedSize = resolvedEnd - resolvedBegin;
          var sliceSize;

          if (resolvedSize === resolvedSize) {
            sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
          }

          var sliceSeq = makeSequence(iterable); // If iterable.size is undefined, the size of the realized sliceSeq is
          // unknown at this point unless the number of items to slice is 0

          sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

          if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
            sliceSeq.get = function (index, notSetValue) {
              index = wrapIndex(this, index);
              return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
            };
          }

          sliceSeq.__iterateUncached = function (fn, reverse) {
            var this$0 = this;

            if (sliceSize === 0) {
              return 0;
            }

            if (reverse) {
              return this.cacheResult().__iterate(fn, reverse);
            }

            var skipped = 0;
            var isSkipping = true;
            var iterations = 0;

            iterable.__iterate(function (v, k) {
              if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
              }
            });

            return iterations;
          };

          sliceSeq.__iteratorUncached = function (type, reverse) {
            if (sliceSize !== 0 && reverse) {
              return this.cacheResult().__iterator(type, reverse);
            } // Don't bother instantiating parent iterator if taking 0.


            var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);

            var skipped = 0;
            var iterations = 0;
            return new Iterator(function () {
              while (skipped++ < resolvedBegin) {
                iterator.next();
              }

              if (++iterations > sliceSize) {
                return iteratorDone();
              }

              var step = iterator.next();

              if (useKeys || type === ITERATE_VALUES) {
                return step;
              } else if (type === ITERATE_KEYS) {
                return iteratorValue(type, iterations - 1, undefined, step);
              } else {
                return iteratorValue(type, iterations - 1, step.value[1], step);
              }
            });
          };

          return sliceSeq;
        }

        function takeWhileFactory(iterable, predicate, context) {
          var takeSequence = makeSequence(iterable);

          takeSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;

            if (reverse) {
              return this.cacheResult().__iterate(fn, reverse);
            }

            var iterations = 0;

            iterable.__iterate(function (v, k, c) {
              return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
            });

            return iterations;
          };

          takeSequence.__iteratorUncached = function (type, reverse) {
            var this$0 = this;

            if (reverse) {
              return this.cacheResult().__iterator(type, reverse);
            }

            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

            var iterating = true;
            return new Iterator(function () {
              if (!iterating) {
                return iteratorDone();
              }

              var step = iterator.next();

              if (step.done) {
                return step;
              }

              var entry = step.value;
              var k = entry[0];
              var v = entry[1];

              if (!predicate.call(context, v, k, this$0)) {
                iterating = false;
                return iteratorDone();
              }

              return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
          };

          return takeSequence;
        }

        function skipWhileFactory(iterable, predicate, context, useKeys) {
          var skipSequence = makeSequence(iterable);

          skipSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;

            if (reverse) {
              return this.cacheResult().__iterate(fn, reverse);
            }

            var isSkipping = true;
            var iterations = 0;

            iterable.__iterate(function (v, k, c) {
              if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$0);
              }
            });

            return iterations;
          };

          skipSequence.__iteratorUncached = function (type, reverse) {
            var this$0 = this;

            if (reverse) {
              return this.cacheResult().__iterator(type, reverse);
            }

            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

            var skipping = true;
            var iterations = 0;
            return new Iterator(function () {
              var step, k, v;

              do {
                step = iterator.next();

                if (step.done) {
                  if (useKeys || type === ITERATE_VALUES) {
                    return step;
                  } else if (type === ITERATE_KEYS) {
                    return iteratorValue(type, iterations++, undefined, step);
                  } else {
                    return iteratorValue(type, iterations++, step.value[1], step);
                  }
                }

                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$0));
              } while (skipping);

              return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
          };

          return skipSequence;
        }

        function concatFactory(iterable, values) {
          var isKeyedIterable = isKeyed(iterable);
          var iters = [iterable].concat(values).map(function (v) {
            if (!isIterable(v)) {
              v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
            } else if (isKeyedIterable) {
              v = KeyedIterable(v);
            }

            return v;
          }).filter(function (v) {
            return v.size !== 0;
          });

          if (iters.length === 0) {
            return iterable;
          }

          if (iters.length === 1) {
            var singleton = iters[0];

            if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) {
              return singleton;
            }
          }

          var concatSeq = new ArraySeq(iters);

          if (isKeyedIterable) {
            concatSeq = concatSeq.toKeyedSeq();
          } else if (!isIndexed(iterable)) {
            concatSeq = concatSeq.toSetSeq();
          }

          concatSeq = concatSeq.flatten(true);
          concatSeq.size = iters.reduce(function (sum, seq) {
            if (sum !== undefined) {
              var size = seq.size;

              if (size !== undefined) {
                return sum + size;
              }
            }
          }, 0);
          return concatSeq;
        }

        function flattenFactory(iterable, depth, useKeys) {
          var flatSequence = makeSequence(iterable);

          flatSequence.__iterateUncached = function (fn, reverse) {
            var iterations = 0;
            var stopped = false;

            function flatDeep(iter, currentDepth) {
              var this$0 = this;

              iter.__iterate(function (v, k) {
                if ((!depth || currentDepth < depth) && isIterable(v)) {
                  flatDeep(v, currentDepth + 1);
                } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
                  stopped = true;
                }

                return !stopped;
              }, reverse);
            }

            flatDeep(iterable, 0);
            return iterations;
          };

          flatSequence.__iteratorUncached = function (type, reverse) {
            var iterator = iterable.__iterator(type, reverse);

            var stack = [];
            var iterations = 0;
            return new Iterator(function () {
              while (iterator) {
                var step = iterator.next();

                if (step.done !== false) {
                  iterator = stack.pop();
                  continue;
                }

                var v = step.value;

                if (type === ITERATE_ENTRIES) {
                  v = v[1];
                }

                if ((!depth || stack.length < depth) && isIterable(v)) {
                  stack.push(iterator);
                  iterator = v.__iterator(type, reverse);
                } else {
                  return useKeys ? step : iteratorValue(type, iterations++, v, step);
                }
              }

              return iteratorDone();
            });
          };

          return flatSequence;
        }

        function flatMapFactory(iterable, mapper, context) {
          var coerce = iterableClass(iterable);
          return iterable.toSeq().map(function (v, k) {
            return coerce(mapper.call(context, v, k, iterable));
          }).flatten(true);
        }

        function interposeFactory(iterable, separator) {
          var interposedSequence = makeSequence(iterable);
          interposedSequence.size = iterable.size && iterable.size * 2 - 1;

          interposedSequence.__iterateUncached = function (fn, reverse) {
            var this$0 = this;
            var iterations = 0;

            iterable.__iterate(function (v, k) {
              return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
            }, reverse);

            return iterations;
          };

          interposedSequence.__iteratorUncached = function (type, reverse) {
            var iterator = iterable.__iterator(ITERATE_VALUES, reverse);

            var iterations = 0;
            var step;
            return new Iterator(function () {
              if (!step || iterations % 2) {
                step = iterator.next();

                if (step.done) {
                  return step;
                }
              }

              return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
            });
          };

          return interposedSequence;
        }

        function sortFactory(iterable, comparator, mapper) {
          if (!comparator) {
            comparator = defaultComparator;
          }

          var isKeyedIterable = isKeyed(iterable);
          var index = 0;
          var entries = iterable.toSeq().map(function (v, k) {
            return [k, v, index++, mapper ? mapper(v, k, iterable) : v];
          }).toArray();
          entries.sort(function (a, b) {
            return comparator(a[3], b[3]) || a[2] - b[2];
          }).forEach(isKeyedIterable ? function (v, i) {
            entries[i].length = 2;
          } : function (v, i) {
            entries[i] = v[1];
          });
          return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
        }

        function maxFactory(iterable, comparator, mapper) {
          if (!comparator) {
            comparator = defaultComparator;
          }

          if (mapper) {
            var entry = iterable.toSeq().map(function (v, k) {
              return [v, mapper(v, k, iterable)];
            }).reduce(function (a, b) {
              return maxCompare(comparator, a[1], b[1]) ? b : a;
            });
            return entry && entry[0];
          } else {
            return iterable.reduce(function (a, b) {
              return maxCompare(comparator, a, b) ? b : a;
            });
          }
        }

        function maxCompare(comparator, a, b) {
          var comp = comparator(b, a); // b is considered the new max if the comparator declares them equal, but
          // they are not equal and b is in fact a nullish value.

          return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
        }

        function zipWithFactory(keyIter, zipper, iters) {
          var zipSequence = makeSequence(keyIter);
          zipSequence.size = new ArraySeq(iters).map(function (i) {
            return i.size;
          }).min(); // Note: this a generic base implementation of __iterate in terms of
          // __iterator which may be more generically useful in the future.

          zipSequence.__iterate = function (fn, reverse) {
            /* generic:
            var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
            var step;
            var iterations = 0;
            while (!(step = iterator.next()).done) {
              iterations++;
              if (fn(step.value[1], step.value[0], this) === false) {
                break;
              }
            }
            return iterations;
            */
            // indexed:
            var iterator = this.__iterator(ITERATE_VALUES, reverse);

            var step;
            var iterations = 0;

            while (!(step = iterator.next()).done) {
              if (fn(step.value, iterations++, this) === false) {
                break;
              }
            }

            return iterations;
          };

          zipSequence.__iteratorUncached = function (type, reverse) {
            var iterators = iters.map(function (i) {
              return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
            });
            var iterations = 0;
            var isDone = false;
            return new Iterator(function () {
              var steps;

              if (!isDone) {
                steps = iterators.map(function (i) {
                  return i.next();
                });
                isDone = steps.some(function (s) {
                  return s.done;
                });
              }

              if (isDone) {
                return iteratorDone();
              }

              return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function (s) {
                return s.value;
              })));
            });
          };

          return zipSequence;
        } // #pragma Helper Functions


        function reify(iter, seq) {
          return isSeq(iter) ? seq : iter.constructor(seq);
        }

        function validateEntry(entry) {
          if (entry !== Object(entry)) {
            throw new TypeError('Expected [K, V] tuple: ' + entry);
          }
        }

        function resolveSize(iter) {
          assertNotInfinite(iter.size);
          return ensureSize(iter);
        }

        function iterableClass(iterable) {
          return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
        }

        function makeSequence(iterable) {
          return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
        }

        function cacheResultThrough() {
          if (this._iter.cacheResult) {
            this._iter.cacheResult();

            this.size = this._iter.size;
            return this;
          } else {
            return Seq.prototype.cacheResult.call(this);
          }
        }

        function defaultComparator(a, b) {
          return a > b ? 1 : a < b ? -1 : 0;
        }

        function forceIterator(keyPath) {
          var iter = getIterator(keyPath);

          if (!iter) {
            // Array might not be iterable in this environment, so we need a fallback
            // to our wrapped type.
            if (!isArrayLike(keyPath)) {
              throw new TypeError('Expected iterable or array-like: ' + keyPath);
            }

            iter = getIterator(Iterable(keyPath));
          }

          return iter;
        }

        createClass(Record, KeyedCollection);

        function Record(defaultValues, name) {
          var hasInitialized;

          var RecordType = function Record(values) {
            if (values instanceof RecordType) {
              return values;
            }

            if (!(this instanceof RecordType)) {
              return new RecordType(values);
            }

            if (!hasInitialized) {
              hasInitialized = true;
              var keys = Object.keys(defaultValues);
              setProps(RecordTypePrototype, keys);
              RecordTypePrototype.size = keys.length;
              RecordTypePrototype._name = name;
              RecordTypePrototype._keys = keys;
              RecordTypePrototype._defaultValues = defaultValues;
            }

            this._map = Map(values);
          };

          var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
          RecordTypePrototype.constructor = RecordType;
          return RecordType;
        }

        Record.prototype.toString = function () {
          return this.__toString(recordName(this) + ' {', '}');
        }; // @pragma Access


        Record.prototype.has = function (k) {
          return this._defaultValues.hasOwnProperty(k);
        };

        Record.prototype.get = function (k, notSetValue) {
          if (!this.has(k)) {
            return notSetValue;
          }

          var defaultVal = this._defaultValues[k];
          return this._map ? this._map.get(k, defaultVal) : defaultVal;
        }; // @pragma Modification


        Record.prototype.clear = function () {
          if (this.__ownerID) {
            this._map && this._map.clear();
            return this;
          }

          var RecordType = this.constructor;
          return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
        };

        Record.prototype.set = function (k, v) {
          if (!this.has(k)) {
            throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
          }

          if (this._map && !this._map.has(k)) {
            var defaultVal = this._defaultValues[k];

            if (v === defaultVal) {
              return this;
            }
          }

          var newMap = this._map && this._map.set(k, v);

          if (this.__ownerID || newMap === this._map) {
            return this;
          }

          return makeRecord(this, newMap);
        };

        Record.prototype.remove = function (k) {
          if (!this.has(k)) {
            return this;
          }

          var newMap = this._map && this._map.remove(k);

          if (this.__ownerID || newMap === this._map) {
            return this;
          }

          return makeRecord(this, newMap);
        };

        Record.prototype.wasAltered = function () {
          return this._map.wasAltered();
        };

        Record.prototype.__iterator = function (type, reverse) {
          var this$0 = this;
          return KeyedIterable(this._defaultValues).map(function (_, k) {
            return this$0.get(k);
          }).__iterator(type, reverse);
        };

        Record.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          return KeyedIterable(this._defaultValues).map(function (_, k) {
            return this$0.get(k);
          }).__iterate(fn, reverse);
        };

        Record.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          var newMap = this._map && this._map.__ensureOwner(ownerID);

          if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
          }

          return makeRecord(this, newMap, ownerID);
        };

        var RecordPrototype = Record.prototype;
        RecordPrototype[DELETE] = RecordPrototype.remove;
        RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
        RecordPrototype.merge = MapPrototype.merge;
        RecordPrototype.mergeWith = MapPrototype.mergeWith;
        RecordPrototype.mergeIn = MapPrototype.mergeIn;
        RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
        RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
        RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
        RecordPrototype.setIn = MapPrototype.setIn;
        RecordPrototype.update = MapPrototype.update;
        RecordPrototype.updateIn = MapPrototype.updateIn;
        RecordPrototype.withMutations = MapPrototype.withMutations;
        RecordPrototype.asMutable = MapPrototype.asMutable;
        RecordPrototype.asImmutable = MapPrototype.asImmutable;

        function makeRecord(likeRecord, map, ownerID) {
          var record = Object.create(Object.getPrototypeOf(likeRecord));
          record._map = map;
          record.__ownerID = ownerID;
          return record;
        }

        function recordName(record) {
          return record._name || record.constructor.name || 'Record';
        }

        function setProps(prototype, names) {
          try {
            names.forEach(setProp.bind(undefined, prototype));
          } catch (error) {// Object.defineProperty failed. Probably IE8.
          }
        }

        function setProp(prototype, name) {
          Object.defineProperty(prototype, name, {
            get: function get() {
              return this.get(name);
            },
            set: function set(value) {
              invariant(this.__ownerID, 'Cannot set on an immutable record.');
              this.set(name, value);
            }
          });
        }

        createClass(Set, SetCollection); // @pragma Construction

        function Set(value) {
          return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function (set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v) {
              return set.add(v);
            });
          });
        }

        Set.of = function ()
        /*...values*/
        {
          return this(arguments);
        };

        Set.fromKeys = function (value) {
          return this(KeyedIterable(value).keySeq());
        };

        Set.prototype.toString = function () {
          return this.__toString('Set {', '}');
        }; // @pragma Access


        Set.prototype.has = function (value) {
          return this._map.has(value);
        }; // @pragma Modification


        Set.prototype.add = function (value) {
          return updateSet(this, this._map.set(value, true));
        };

        Set.prototype.remove = function (value) {
          return updateSet(this, this._map.remove(value));
        };

        Set.prototype.clear = function () {
          return updateSet(this, this._map.clear());
        }; // @pragma Composition


        Set.prototype.union = function () {
          var iters = SLICE$0.call(arguments, 0);
          iters = iters.filter(function (x) {
            return x.size !== 0;
          });

          if (iters.length === 0) {
            return this;
          }

          if (this.size === 0 && !this.__ownerID && iters.length === 1) {
            return this.constructor(iters[0]);
          }

          return this.withMutations(function (set) {
            for (var ii = 0; ii < iters.length; ii++) {
              SetIterable(iters[ii]).forEach(function (value) {
                return set.add(value);
              });
            }
          });
        };

        Set.prototype.intersect = function () {
          var iters = SLICE$0.call(arguments, 0);

          if (iters.length === 0) {
            return this;
          }

          iters = iters.map(function (iter) {
            return SetIterable(iter);
          });
          var originalSet = this;
          return this.withMutations(function (set) {
            originalSet.forEach(function (value) {
              if (!iters.every(function (iter) {
                return iter.includes(value);
              })) {
                set.remove(value);
              }
            });
          });
        };

        Set.prototype.subtract = function () {
          var iters = SLICE$0.call(arguments, 0);

          if (iters.length === 0) {
            return this;
          }

          iters = iters.map(function (iter) {
            return SetIterable(iter);
          });
          var originalSet = this;
          return this.withMutations(function (set) {
            originalSet.forEach(function (value) {
              if (iters.some(function (iter) {
                return iter.includes(value);
              })) {
                set.remove(value);
              }
            });
          });
        };

        Set.prototype.merge = function () {
          return this.union.apply(this, arguments);
        };

        Set.prototype.mergeWith = function (merger) {
          var iters = SLICE$0.call(arguments, 1);
          return this.union.apply(this, iters);
        };

        Set.prototype.sort = function (comparator) {
          // Late binding
          return OrderedSet(sortFactory(this, comparator));
        };

        Set.prototype.sortBy = function (mapper, comparator) {
          // Late binding
          return OrderedSet(sortFactory(this, comparator, mapper));
        };

        Set.prototype.wasAltered = function () {
          return this._map.wasAltered();
        };

        Set.prototype.__iterate = function (fn, reverse) {
          var this$0 = this;
          return this._map.__iterate(function (_, k) {
            return fn(k, k, this$0);
          }, reverse);
        };

        Set.prototype.__iterator = function (type, reverse) {
          return this._map.map(function (_, k) {
            return k;
          }).__iterator(type, reverse);
        };

        Set.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          var newMap = this._map.__ensureOwner(ownerID);

          if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
          }

          return this.__make(newMap, ownerID);
        };

        function isSet(maybeSet) {
          return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
        }

        Set.isSet = isSet;
        var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
        var SetPrototype = Set.prototype;
        SetPrototype[IS_SET_SENTINEL] = true;
        SetPrototype[DELETE] = SetPrototype.remove;
        SetPrototype.mergeDeep = SetPrototype.merge;
        SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
        SetPrototype.withMutations = MapPrototype.withMutations;
        SetPrototype.asMutable = MapPrototype.asMutable;
        SetPrototype.asImmutable = MapPrototype.asImmutable;
        SetPrototype.__empty = emptySet;
        SetPrototype.__make = makeSet;

        function updateSet(set, newMap) {
          if (set.__ownerID) {
            set.size = newMap.size;
            set._map = newMap;
            return set;
          }

          return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
        }

        function makeSet(map, ownerID) {
          var set = Object.create(SetPrototype);
          set.size = map ? map.size : 0;
          set._map = map;
          set.__ownerID = ownerID;
          return set;
        }

        var EMPTY_SET;

        function emptySet() {
          return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
        }

        createClass(OrderedSet, Set); // @pragma Construction

        function OrderedSet(value) {
          return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function (set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v) {
              return set.add(v);
            });
          });
        }

        OrderedSet.of = function ()
        /*...values*/
        {
          return this(arguments);
        };

        OrderedSet.fromKeys = function (value) {
          return this(KeyedIterable(value).keySeq());
        };

        OrderedSet.prototype.toString = function () {
          return this.__toString('OrderedSet {', '}');
        };

        function isOrderedSet(maybeOrderedSet) {
          return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
        }

        OrderedSet.isOrderedSet = isOrderedSet;
        var OrderedSetPrototype = OrderedSet.prototype;
        OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
        OrderedSetPrototype.__empty = emptyOrderedSet;
        OrderedSetPrototype.__make = makeOrderedSet;

        function makeOrderedSet(map, ownerID) {
          var set = Object.create(OrderedSetPrototype);
          set.size = map ? map.size : 0;
          set._map = map;
          set.__ownerID = ownerID;
          return set;
        }

        var EMPTY_ORDERED_SET;

        function emptyOrderedSet() {
          return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
        }

        createClass(Stack, IndexedCollection); // @pragma Construction

        function Stack(value) {
          return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
        }

        Stack.of = function ()
        /*...values*/
        {
          return this(arguments);
        };

        Stack.prototype.toString = function () {
          return this.__toString('Stack [', ']');
        }; // @pragma Access


        Stack.prototype.get = function (index, notSetValue) {
          var head = this._head;
          index = wrapIndex(this, index);

          while (head && index--) {
            head = head.next;
          }

          return head ? head.value : notSetValue;
        };

        Stack.prototype.peek = function () {
          return this._head && this._head.value;
        }; // @pragma Modification


        Stack.prototype.push = function ()
        /*...values*/
        {
          if (arguments.length === 0) {
            return this;
          }

          var newSize = this.size + arguments.length;
          var head = this._head;

          for (var ii = arguments.length - 1; ii >= 0; ii--) {
            head = {
              value: arguments[ii],
              next: head
            };
          }

          if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return makeStack(newSize, head);
        };

        Stack.prototype.pushAll = function (iter) {
          iter = IndexedIterable(iter);

          if (iter.size === 0) {
            return this;
          }

          assertNotInfinite(iter.size);
          var newSize = this.size;
          var head = this._head;
          iter.reverse().forEach(function (value) {
            newSize++;
            head = {
              value: value,
              next: head
            };
          });

          if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return makeStack(newSize, head);
        };

        Stack.prototype.pop = function () {
          return this.slice(1);
        };

        Stack.prototype.unshift = function ()
        /*...values*/
        {
          return this.push.apply(this, arguments);
        };

        Stack.prototype.unshiftAll = function (iter) {
          return this.pushAll(iter);
        };

        Stack.prototype.shift = function () {
          return this.pop.apply(this, arguments);
        };

        Stack.prototype.clear = function () {
          if (this.size === 0) {
            return this;
          }

          if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return emptyStack();
        };

        Stack.prototype.slice = function (begin, end) {
          if (wholeSlice(begin, end, this.size)) {
            return this;
          }

          var resolvedBegin = resolveBegin(begin, this.size);
          var resolvedEnd = resolveEnd(end, this.size);

          if (resolvedEnd !== this.size) {
            // super.slice(begin, end);
            return IndexedCollection.prototype.slice.call(this, begin, end);
          }

          var newSize = this.size - resolvedBegin;
          var head = this._head;

          while (resolvedBegin--) {
            head = head.next;
          }

          if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
          }

          return makeStack(newSize, head);
        }; // @pragma Mutability


        Stack.prototype.__ensureOwner = function (ownerID) {
          if (ownerID === this.__ownerID) {
            return this;
          }

          if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
          }

          return makeStack(this.size, this._head, ownerID, this.__hash);
        }; // @pragma Iteration


        Stack.prototype.__iterate = function (fn, reverse) {
          if (reverse) {
            return this.reverse().__iterate(fn);
          }

          var iterations = 0;
          var node = this._head;

          while (node) {
            if (fn(node.value, iterations++, this) === false) {
              break;
            }

            node = node.next;
          }

          return iterations;
        };

        Stack.prototype.__iterator = function (type, reverse) {
          if (reverse) {
            return this.reverse().__iterator(type);
          }

          var iterations = 0;
          var node = this._head;
          return new Iterator(function () {
            if (node) {
              var value = node.value;
              node = node.next;
              return iteratorValue(type, iterations++, value);
            }

            return iteratorDone();
          });
        };

        function isStack(maybeStack) {
          return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
        }

        Stack.isStack = isStack;
        var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
        var StackPrototype = Stack.prototype;
        StackPrototype[IS_STACK_SENTINEL] = true;
        StackPrototype.withMutations = MapPrototype.withMutations;
        StackPrototype.asMutable = MapPrototype.asMutable;
        StackPrototype.asImmutable = MapPrototype.asImmutable;
        StackPrototype.wasAltered = MapPrototype.wasAltered;

        function makeStack(size, head, ownerID, hash) {
          var map = Object.create(StackPrototype);
          map.size = size;
          map._head = head;
          map.__ownerID = ownerID;
          map.__hash = hash;
          map.__altered = false;
          return map;
        }

        var EMPTY_STACK;

        function emptyStack() {
          return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
        }
        /**
         * Contributes additional methods to a constructor
         */


        function mixin(ctor, methods) {
          var keyCopier = function keyCopier(key) {
            ctor.prototype[key] = methods[key];
          };

          Object.keys(methods).forEach(keyCopier);
          Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
          return ctor;
        }

        Iterable.Iterator = Iterator;
        mixin(Iterable, {
          // ### Conversion to other types
          toArray: function toArray() {
            assertNotInfinite(this.size);
            var array = new Array(this.size || 0);

            this.valueSeq().__iterate(function (v, i) {
              array[i] = v;
            });

            return array;
          },
          toIndexedSeq: function toIndexedSeq() {
            return new ToIndexedSequence(this);
          },
          toJS: function toJS() {
            return this.toSeq().map(function (value) {
              return value && typeof value.toJS === 'function' ? value.toJS() : value;
            }).__toJS();
          },
          toJSON: function toJSON() {
            return this.toSeq().map(function (value) {
              return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
            }).__toJS();
          },
          toKeyedSeq: function toKeyedSeq() {
            return new ToKeyedSequence(this, true);
          },
          toMap: function toMap() {
            // Use Late Binding here to solve the circular dependency.
            return Map(this.toKeyedSeq());
          },
          toObject: function toObject() {
            assertNotInfinite(this.size);
            var object = {};

            this.__iterate(function (v, k) {
              object[k] = v;
            });

            return object;
          },
          toOrderedMap: function toOrderedMap() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedMap(this.toKeyedSeq());
          },
          toOrderedSet: function toOrderedSet() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
          },
          toSet: function toSet() {
            // Use Late Binding here to solve the circular dependency.
            return Set(isKeyed(this) ? this.valueSeq() : this);
          },
          toSetSeq: function toSetSeq() {
            return new ToSetSequence(this);
          },
          toSeq: function toSeq() {
            return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
          },
          toStack: function toStack() {
            // Use Late Binding here to solve the circular dependency.
            return Stack(isKeyed(this) ? this.valueSeq() : this);
          },
          toList: function toList() {
            // Use Late Binding here to solve the circular dependency.
            return List(isKeyed(this) ? this.valueSeq() : this);
          },
          // ### Common JavaScript methods and properties
          toString: function toString() {
            return '[Iterable]';
          },
          __toString: function __toString(head, tail) {
            if (this.size === 0) {
              return head + tail;
            }

            return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
          },
          // ### ES6 Collection methods (ES6 Array and Map)
          concat: function concat() {
            var values = SLICE$0.call(arguments, 0);
            return reify(this, concatFactory(this, values));
          },
          includes: function includes(searchValue) {
            return this.some(function (value) {
              return is(value, searchValue);
            });
          },
          entries: function entries() {
            return this.__iterator(ITERATE_ENTRIES);
          },
          every: function every(predicate, context) {
            assertNotInfinite(this.size);
            var returnValue = true;

            this.__iterate(function (v, k, c) {
              if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
              }
            });

            return returnValue;
          },
          filter: function filter(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, true));
          },
          find: function find(predicate, context, notSetValue) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[1] : notSetValue;
          },
          forEach: function forEach(sideEffect, context) {
            assertNotInfinite(this.size);
            return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
          },
          join: function join(separator) {
            assertNotInfinite(this.size);
            separator = separator !== undefined ? '' + separator : ',';
            var joined = '';
            var isFirst = true;

            this.__iterate(function (v) {
              isFirst ? isFirst = false : joined += separator;
              joined += v !== null && v !== undefined ? v.toString() : '';
            });

            return joined;
          },
          keys: function keys() {
            return this.__iterator(ITERATE_KEYS);
          },
          map: function map(mapper, context) {
            return reify(this, mapFactory(this, mapper, context));
          },
          reduce: function reduce(reducer, initialReduction, context) {
            assertNotInfinite(this.size);
            var reduction;
            var useFirst;

            if (arguments.length < 2) {
              useFirst = true;
            } else {
              reduction = initialReduction;
            }

            this.__iterate(function (v, k, c) {
              if (useFirst) {
                useFirst = false;
                reduction = v;
              } else {
                reduction = reducer.call(context, reduction, v, k, c);
              }
            });

            return reduction;
          },
          reduceRight: function reduceRight(reducer, initialReduction, context) {
            var reversed = this.toKeyedSeq().reverse();
            return reversed.reduce.apply(reversed, arguments);
          },
          reverse: function reverse() {
            return reify(this, reverseFactory(this, true));
          },
          slice: function slice(begin, end) {
            return reify(this, sliceFactory(this, begin, end, true));
          },
          some: function some(predicate, context) {
            return !this.every(not(predicate), context);
          },
          sort: function sort(comparator) {
            return reify(this, sortFactory(this, comparator));
          },
          values: function values() {
            return this.__iterator(ITERATE_VALUES);
          },
          // ### More sequential methods
          butLast: function butLast() {
            return this.slice(0, -1);
          },
          isEmpty: function isEmpty() {
            return this.size !== undefined ? this.size === 0 : !this.some(function () {
              return true;
            });
          },
          count: function count(predicate, context) {
            return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
          },
          countBy: function countBy(grouper, context) {
            return countByFactory(this, grouper, context);
          },
          equals: function equals(other) {
            return deepEqual(this, other);
          },
          entrySeq: function entrySeq() {
            var iterable = this;

            if (iterable._cache) {
              // We cache as an entries array, so we can just return the cache!
              return new ArraySeq(iterable._cache);
            }

            var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();

            entriesSequence.fromEntrySeq = function () {
              return iterable.toSeq();
            };

            return entriesSequence;
          },
          filterNot: function filterNot(predicate, context) {
            return this.filter(not(predicate), context);
          },
          findEntry: function findEntry(predicate, context, notSetValue) {
            var found = notSetValue;

            this.__iterate(function (v, k, c) {
              if (predicate.call(context, v, k, c)) {
                found = [k, v];
                return false;
              }
            });

            return found;
          },
          findKey: function findKey(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry && entry[0];
          },
          findLast: function findLast(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
          },
          findLastEntry: function findLastEntry(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
          },
          findLastKey: function findLastKey(predicate, context) {
            return this.toKeyedSeq().reverse().findKey(predicate, context);
          },
          first: function first() {
            return this.find(returnTrue);
          },
          flatMap: function flatMap(mapper, context) {
            return reify(this, flatMapFactory(this, mapper, context));
          },
          flatten: function flatten(depth) {
            return reify(this, flattenFactory(this, depth, true));
          },
          fromEntrySeq: function fromEntrySeq() {
            return new FromEntriesSequence(this);
          },
          get: function get(searchKey, notSetValue) {
            return this.find(function (_, key) {
              return is(key, searchKey);
            }, undefined, notSetValue);
          },
          getIn: function getIn(searchKeyPath, notSetValue) {
            var nested = this; // Note: in an ES6 environment, we would prefer:
            // for (var key of searchKeyPath) {

            var iter = forceIterator(searchKeyPath);
            var step;

            while (!(step = iter.next()).done) {
              var key = step.value;
              nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;

              if (nested === NOT_SET) {
                return notSetValue;
              }
            }

            return nested;
          },
          groupBy: function groupBy(grouper, context) {
            return groupByFactory(this, grouper, context);
          },
          has: function has(searchKey) {
            return this.get(searchKey, NOT_SET) !== NOT_SET;
          },
          hasIn: function hasIn(searchKeyPath) {
            return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
          },
          isSubset: function isSubset(iter) {
            iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
            return this.every(function (value) {
              return iter.includes(value);
            });
          },
          isSuperset: function isSuperset(iter) {
            iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
            return iter.isSubset(this);
          },
          keyOf: function keyOf(searchValue) {
            return this.findKey(function (value) {
              return is(value, searchValue);
            });
          },
          keySeq: function keySeq() {
            return this.toSeq().map(keyMapper).toIndexedSeq();
          },
          last: function last() {
            return this.toSeq().reverse().first();
          },
          lastKeyOf: function lastKeyOf(searchValue) {
            return this.toKeyedSeq().reverse().keyOf(searchValue);
          },
          max: function max(comparator) {
            return maxFactory(this, comparator);
          },
          maxBy: function maxBy(mapper, comparator) {
            return maxFactory(this, comparator, mapper);
          },
          min: function min(comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
          },
          minBy: function minBy(mapper, comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
          },
          rest: function rest() {
            return this.slice(1);
          },
          skip: function skip(amount) {
            return this.slice(Math.max(0, amount));
          },
          skipLast: function skipLast(amount) {
            return reify(this, this.toSeq().reverse().skip(amount).reverse());
          },
          skipWhile: function skipWhile(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, true));
          },
          skipUntil: function skipUntil(predicate, context) {
            return this.skipWhile(not(predicate), context);
          },
          sortBy: function sortBy(mapper, comparator) {
            return reify(this, sortFactory(this, comparator, mapper));
          },
          take: function take(amount) {
            return this.slice(0, Math.max(0, amount));
          },
          takeLast: function takeLast(amount) {
            return reify(this, this.toSeq().reverse().take(amount).reverse());
          },
          takeWhile: function takeWhile(predicate, context) {
            return reify(this, takeWhileFactory(this, predicate, context));
          },
          takeUntil: function takeUntil(predicate, context) {
            return this.takeWhile(not(predicate), context);
          },
          valueSeq: function valueSeq() {
            return this.toIndexedSeq();
          },
          // ### Hashable Object
          hashCode: function hashCode() {
            return this.__hash || (this.__hash = hashIterable(this));
          } // ### Internal
          // abstract __iterate(fn, reverse)
          // abstract __iterator(type, reverse)

        }); // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
        // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
        // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
        // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

        var IterablePrototype = Iterable.prototype;
        IterablePrototype[IS_ITERABLE_SENTINEL] = true;
        IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
        IterablePrototype.__toJS = IterablePrototype.toArray;
        IterablePrototype.__toStringMapper = quoteString;

        IterablePrototype.inspect = IterablePrototype.toSource = function () {
          return this.toString();
        };

        IterablePrototype.chain = IterablePrototype.flatMap;
        IterablePrototype.contains = IterablePrototype.includes;
        mixin(KeyedIterable, {
          // ### More sequential methods
          flip: function flip() {
            return reify(this, flipFactory(this));
          },
          mapEntries: function mapEntries(mapper, context) {
            var this$0 = this;
            var iterations = 0;
            return reify(this, this.toSeq().map(function (v, k) {
              return mapper.call(context, [k, v], iterations++, this$0);
            }).fromEntrySeq());
          },
          mapKeys: function mapKeys(mapper, context) {
            var this$0 = this;
            return reify(this, this.toSeq().flip().map(function (k, v) {
              return mapper.call(context, k, v, this$0);
            }).flip());
          }
        });
        var KeyedIterablePrototype = KeyedIterable.prototype;
        KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
        KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
        KeyedIterablePrototype.__toJS = IterablePrototype.toObject;

        KeyedIterablePrototype.__toStringMapper = function (v, k) {
          return JSON.stringify(k) + ': ' + quoteString(v);
        };

        mixin(IndexedIterable, {
          // ### Conversion to other types
          toKeyedSeq: function toKeyedSeq() {
            return new ToKeyedSequence(this, false);
          },
          // ### ES6 Collection methods (ES6 Array and Map)
          filter: function filter(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, false));
          },
          findIndex: function findIndex(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[0] : -1;
          },
          indexOf: function indexOf(searchValue) {
            var key = this.keyOf(searchValue);
            return key === undefined ? -1 : key;
          },
          lastIndexOf: function lastIndexOf(searchValue) {
            var key = this.lastKeyOf(searchValue);
            return key === undefined ? -1 : key;
          },
          reverse: function reverse() {
            return reify(this, reverseFactory(this, false));
          },
          slice: function slice(begin, end) {
            return reify(this, sliceFactory(this, begin, end, false));
          },
          splice: function splice(index, removeNum
          /*, ...values*/
          ) {
            var numArgs = arguments.length;
            removeNum = Math.max(removeNum | 0, 0);

            if (numArgs === 0 || numArgs === 2 && !removeNum) {
              return this;
            } // If index is negative, it should resolve relative to the size of the
            // collection. However size may be expensive to compute if not cached, so
            // only call count() if the number is in fact negative.


            index = resolveBegin(index, index < 0 ? this.count() : this.size);
            var spliced = this.slice(0, index);
            return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
          },
          // ### More collection methods
          findLastIndex: function findLastIndex(predicate, context) {
            var entry = this.findLastEntry(predicate, context);
            return entry ? entry[0] : -1;
          },
          first: function first() {
            return this.get(0);
          },
          flatten: function flatten(depth) {
            return reify(this, flattenFactory(this, depth, false));
          },
          get: function get(index, notSetValue) {
            index = wrapIndex(this, index);
            return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function (_, key) {
              return key === index;
            }, undefined, notSetValue);
          },
          has: function has(index) {
            index = wrapIndex(this, index);
            return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
          },
          interpose: function interpose(separator) {
            return reify(this, interposeFactory(this, separator));
          },
          interleave: function interleave()
          /*...iterables*/
          {
            var iterables = [this].concat(arrCopy(arguments));
            var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
            var interleaved = zipped.flatten(true);

            if (zipped.size) {
              interleaved.size = zipped.size * iterables.length;
            }

            return reify(this, interleaved);
          },
          keySeq: function keySeq() {
            return Range(0, this.size);
          },
          last: function last() {
            return this.get(-1);
          },
          skipWhile: function skipWhile(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, false));
          },
          zip: function zip()
          /*, ...iterables */
          {
            var iterables = [this].concat(arrCopy(arguments));
            return reify(this, zipWithFactory(this, defaultZipper, iterables));
          },
          zipWith: function zipWith(zipper
          /*, ...iterables */
          ) {
            var iterables = arrCopy(arguments);
            iterables[0] = this;
            return reify(this, zipWithFactory(this, zipper, iterables));
          }
        });
        IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
        IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
        mixin(SetIterable, {
          // ### ES6 Collection methods (ES6 Array and Map)
          get: function get(value, notSetValue) {
            return this.has(value) ? value : notSetValue;
          },
          includes: function includes(value) {
            return this.has(value);
          },
          // ### More sequential methods
          keySeq: function keySeq() {
            return this.valueSeq();
          }
        });
        SetIterable.prototype.has = IterablePrototype.includes;
        SetIterable.prototype.contains = SetIterable.prototype.includes; // Mixin subclasses

        mixin(KeyedSeq, KeyedIterable.prototype);
        mixin(IndexedSeq, IndexedIterable.prototype);
        mixin(SetSeq, SetIterable.prototype);
        mixin(KeyedCollection, KeyedIterable.prototype);
        mixin(IndexedCollection, IndexedIterable.prototype);
        mixin(SetCollection, SetIterable.prototype); // #pragma Helper functions

        function keyMapper(v, k) {
          return k;
        }

        function entryMapper(v, k) {
          return [k, v];
        }

        function not(predicate) {
          return function () {
            return !predicate.apply(this, arguments);
          };
        }

        function neg(predicate) {
          return function () {
            return -predicate.apply(this, arguments);
          };
        }

        function quoteString(value) {
          return typeof value === 'string' ? JSON.stringify(value) : String(value);
        }

        function defaultZipper() {
          return arrCopy(arguments);
        }

        function defaultNegComparator(a, b) {
          return a < b ? 1 : a > b ? -1 : 0;
        }

        function hashIterable(iterable) {
          if (iterable.size === Infinity) {
            return 0;
          }

          var ordered = isOrdered(iterable);
          var keyed = isKeyed(iterable);
          var h = ordered ? 1 : 0;

          var size = iterable.__iterate(keyed ? ordered ? function (v, k) {
            h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
          } : function (v, k) {
            h = h + hashMerge(hash(v), hash(k)) | 0;
          } : ordered ? function (v) {
            h = 31 * h + hash(v) | 0;
          } : function (v) {
            h = h + hash(v) | 0;
          });

          return murmurHashOfSize(size, h);
        }

        function murmurHashOfSize(size, h) {
          h = imul(h, 0xCC9E2D51);
          h = imul(h << 15 | h >>> -15, 0x1B873593);
          h = imul(h << 13 | h >>> -13, 5);
          h = (h + 0xE6546B64 | 0) ^ size;
          h = imul(h ^ h >>> 16, 0x85EBCA6B);
          h = imul(h ^ h >>> 13, 0xC2B2AE35);
          h = smi(h ^ h >>> 16);
          return h;
        }

        function hashMerge(a, b) {
          return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
        }

        var Immutable = {
          Iterable: Iterable,
          Seq: Seq,
          Collection: Collection,
          Map: Map,
          OrderedMap: OrderedMap,
          List: List,
          Stack: Stack,
          Set: Set,
          OrderedSet: OrderedSet,
          Record: Record,
          Range: Range,
          Repeat: Repeat,
          is: is,
          fromJS: fromJS
        };
        return Immutable;
      });
      /***/

    },
    /* 67 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var objectUtils = __webpack_require__(59);
      /**
       * @typedef {{sign: '+' | '-' | '', coefficients: number[], exponent: number}} SplitValue
       */

      /**
       * Test whether value is a number
       * @param {*} value
       * @return {boolean} isNumber
       */


      exports.isNumber = function (value) {
        return typeof value === 'number';
      };
      /**
       * Check if a number is integer
       * @param {number | boolean} value
       * @return {boolean} isInteger
       */


      exports.isInteger = function (value) {
        if (typeof value === 'boolean') {
          return true;
        }

        return isFinite(value) ? value === Math.round(value) : false; // Note: we use ==, not ===, as we can have Booleans as well
      };
      /**
       * Calculate the sign of a number
       * @param {number} x
       * @returns {*}
       */


      exports.sign = Math.sign || function (x) {
        if (x > 0) {
          return 1;
        } else if (x < 0) {
          return -1;
        } else {
          return 0;
        }
      };
      /**
       * Convert a number to a formatted string representation.
       *
       * Syntax:
       *
       *    format(value)
       *    format(value, options)
       *    format(value, precision)
       *    format(value, fn)
       *
       * Where:
       *
       *    {number} value   The value to be formatted
       *    {Object} options An object with formatting options. Available options:
       *                     {string} notation
       *                         Number notation. Choose from:
       *                         'fixed'          Always use regular number notation.
       *                                          For example '123.40' and '14000000'
       *                         'exponential'    Always use exponential notation.
       *                                          For example '1.234e+2' and '1.4e+7'
       *                         'engineering'    Always use engineering notation.
       *                                          For example '123.4e+0' and '14.0e+6'
       *                         'auto' (default) Regular number notation for numbers
       *                                          having an absolute value between
       *                                          `lowerExp` and `upperExp` bounds, and
       *                                          uses exponential notation elsewhere.
       *                                          Lower bound is included, upper bound
       *                                          is excluded.
       *                                          For example '123.4' and '1.4e7'.
       *                     {number} precision   A number between 0 and 16 to round
       *                                          the digits of the number.
       *                                          In case of notations 'exponential',
       *                                          'engineering', and 'auto',
       *                                          `precision` defines the total
       *                                          number of significant digits returned.
       *                                          In case of notation 'fixed',
       *                                          `precision` defines the number of
       *                                          significant digits after the decimal
       *                                          point.
       *                                          `precision` is undefined by default,
       *                                          not rounding any digits.
       *                     {number} lowerExp    Exponent determining the lower boundary
       *                                          for formatting a value with an exponent
       *                                          when `notation='auto`.
       *                                          Default value is `-3`.
       *                     {number} upperExp    Exponent determining the upper boundary
       *                                          for formatting a value with an exponent
       *                                          when `notation='auto`.
       *                                          Default value is `5`.
       *    {Function} fn    A custom formatting function. Can be used to override the
       *                     built-in notations. Function `fn` is called with `value` as
       *                     parameter and must return a string. Is useful for example to
       *                     format all values inside a matrix in a particular way.
       *
       * Examples:
       *
       *    format(6.4)                                        // '6.4'
       *    format(1240000)                                    // '1.24e6'
       *    format(1/3)                                        // '0.3333333333333333'
       *    format(1/3, 3)                                     // '0.333'
       *    format(21385, 2)                                   // '21000'
       *    format(12.071, {notation: 'fixed'})                // '12'
       *    format(2.3,    {notation: 'fixed', precision: 2})  // '2.30'
       *    format(52.8,   {notation: 'exponential'})          // '5.28e+1'
       *    format(12345678, {notation: 'engineering'})        // '12.345678e+6'
       *
       * @param {number} value
       * @param {Object | Function | number} [options]
       * @return {string} str The formatted value
       */


      exports.format = function (value, options) {
        if (typeof options === 'function') {
          // handle format(value, fn)
          return options(value);
        } // handle special cases


        if (value === Infinity) {
          return 'Infinity';
        } else if (value === -Infinity) {
          return '-Infinity';
        } else if (isNaN(value)) {
          return 'NaN';
        } // default values for options


        var notation = 'auto';
        var precision;

        if (options) {
          // determine notation from options
          if (options.notation) {
            notation = options.notation;
          } // determine precision from options


          if (exports.isNumber(options)) {
            precision = options;
          } else if (exports.isNumber(options.precision)) {
            precision = options.precision;
          }
        } // handle the various notations


        switch (notation) {
          case 'fixed':
            return exports.toFixed(value, precision);

          case 'exponential':
            return exports.toExponential(value, precision);

          case 'engineering':
            return exports.toEngineering(value, precision);

          case 'auto':
            // TODO: clean up some day. Deprecated since: 2018-01-24
            // @deprecated upper and lower are replaced with upperExp and lowerExp since v4.0.0
            if (options && options.exponential && (options.exponential.lower !== undefined || options.exponential.upper !== undefined)) {
              var fixedOptions = objectUtils.map(options, function (x) {
                return x;
              });
              fixedOptions.exponential = undefined;

              if (options.exponential.lower !== undefined) {
                fixedOptions.lowerExp = Math.round(Math.log(options.exponential.lower) / Math.LN10);
              }

              if (options.exponential.upper !== undefined) {
                fixedOptions.upperExp = Math.round(Math.log(options.exponential.upper) / Math.LN10);
              }

              console.warn('Deprecation warning: Formatting options exponential.lower and exponential.upper ' + '(minimum and maximum value) ' + 'are replaced with exponential.lowerExp and exponential.upperExp ' + '(minimum and maximum exponent) since version 4.0.0. ' + 'Replace ' + JSON.stringify(options) + ' with ' + JSON.stringify(fixedOptions));
              return exports.toPrecision(value, precision, fixedOptions);
            }

            return exports.toPrecision(value, precision, options && options) // remove trailing zeros after the decimal point
            .replace(/((\.\d*?)(0+))($|e)/, function () {
              var digits = arguments[2];
              var e = arguments[4];
              return digits !== '.' ? digits + e : e;
            });

          default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", or "fixed".');
        }
      };
      /**
       * Split a number into sign, coefficients, and exponent
       * @param {number | string} value
       * @return {SplitValue}
       *              Returns an object containing sign, coefficients, and exponent
       */


      exports.splitNumber = function (value) {
        // parse the input value
        var match = String(value).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);

        if (!match) {
          throw new SyntaxError('Invalid number ' + value);
        }

        var sign = match[1];
        var digits = match[2];
        var exponent = parseFloat(match[4] || '0');
        var dot = digits.indexOf('.');
        exponent += dot !== -1 ? dot - 1 : digits.length - 1;
        var coefficients = digits.replace('.', '') // remove the dot (must be removed before removing leading zeros)
        .replace(/^0*/, function (zeros) {
          // remove leading zeros, add their count to the exponent
          exponent -= zeros.length;
          return '';
        }).replace(/0*$/, '') // remove trailing zeros
        .split('').map(function (d) {
          return parseInt(d);
        });

        if (coefficients.length === 0) {
          coefficients.push(0);
          exponent++;
        }

        return {
          sign: sign,
          coefficients: coefficients,
          exponent: exponent
        };
      };
      /**
       * Format a number in engineering notation. Like '1.23e+6', '2.3e+0', '3.500e-3'
       * @param {number | string} value
       * @param {number} [precision]        Optional number of significant figures to return.
       */


      exports.toEngineering = function (value, precision) {
        if (isNaN(value) || !isFinite(value)) {
          return String(value);
        }

        var rounded = exports.roundDigits(exports.splitNumber(value), precision);
        var e = rounded.exponent;
        var c = rounded.coefficients; // find nearest lower multiple of 3 for exponent

        var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3;

        if (exports.isNumber(precision)) {
          // add zeroes to give correct sig figs
          while (precision > c.length || e - newExp + 1 > c.length) {
            c.push(0);
          }
        } else {
          // concatenate coefficients with necessary zeros
          var significandsDiff = e >= 0 ? e : Math.abs(newExp); // add zeros if necessary (for ex: 1e+8)

          while (c.length - 1 < significandsDiff) {
            c.push(0);
          }
        } // find difference in exponents


        var expDiff = Math.abs(e - newExp);
        var decimalIdx = 1; // push decimal index over by expDiff times

        while (expDiff > 0) {
          decimalIdx++;
          expDiff--;
        } // if all coefficient values are zero after the decimal point and precision is unset, don't add a decimal value.
        // otherwise concat with the rest of the coefficients


        var decimals = c.slice(decimalIdx).join('');
        var decimalVal = exports.isNumber(precision) && decimals.length || decimals.match(/[1-9]/) ? '.' + decimals : '';
        var str = c.slice(0, decimalIdx).join('') + decimalVal + 'e' + (e >= 0 ? '+' : '') + newExp.toString();
        return rounded.sign + str;
      };
      /**
       * Format a number with fixed notation.
       * @param {number | string} value
       * @param {number} [precision=undefined]  Optional number of decimals after the
       *                                        decimal point. null by default.
       */


      exports.toFixed = function (value, precision) {
        if (isNaN(value) || !isFinite(value)) {
          return String(value);
        }

        var splitValue = exports.splitNumber(value);
        var rounded = typeof precision === 'number' ? exports.roundDigits(splitValue, splitValue.exponent + 1 + precision) : splitValue;
        var c = rounded.coefficients;
        var p = rounded.exponent + 1; // exponent may have changed
        // append zeros if needed

        var pp = p + (precision || 0);

        if (c.length < pp) {
          c = c.concat(zeros(pp - c.length));
        } // prepend zeros if needed


        if (p < 0) {
          c = zeros(-p + 1).concat(c);
          p = 1;
        } // insert a dot if needed


        if (p < c.length) {
          c.splice(p, 0, p === 0 ? '0.' : '.');
        }

        return rounded.sign + c.join('');
      };
      /**
       * Format a number in exponential notation. Like '1.23e+5', '2.3e+0', '3.500e-3'
       * @param {number | string} value
       * @param {number} [precision]  Number of digits in formatted output.
       *                              If not provided, the maximum available digits
       *                              is used.
       */


      exports.toExponential = function (value, precision) {
        if (isNaN(value) || !isFinite(value)) {
          return String(value);
        } // round if needed, else create a clone


        var split = exports.splitNumber(value);
        var rounded = precision ? exports.roundDigits(split, precision) : split;
        var c = rounded.coefficients;
        var e = rounded.exponent; // append zeros if needed

        if (c.length < precision) {
          c = c.concat(zeros(precision - c.length));
        } // format as `C.CCCe+EEE` or `C.CCCe-EEE`


        var first = c.shift();
        return rounded.sign + first + (c.length > 0 ? '.' + c.join('') : '') + 'e' + (e >= 0 ? '+' : '') + e;
      };
      /**
       * Format a number with a certain precision
       * @param {number | string} value
       * @param {number} [precision=undefined] Optional number of digits.
       * @param {{lowerExp: number | undefined, upperExp: number | undefined}} [options]
       *                                       By default:
       *                                         lowerExp = -3 (incl)
       *                                         upper = +5 (excl)
       * @return {string}
       */


      exports.toPrecision = function (value, precision, options) {
        if (isNaN(value) || !isFinite(value)) {
          return String(value);
        } // determine lower and upper bound for exponential notation.


        var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
        var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5;
        var split = exports.splitNumber(value);

        if (split.exponent < lowerExp || split.exponent >= upperExp) {
          // exponential notation
          return exports.toExponential(value, precision);
        } else {
          var rounded = precision ? exports.roundDigits(split, precision) : split;
          var c = rounded.coefficients;
          var e = rounded.exponent; // append trailing zeros

          if (c.length < precision) {
            c = c.concat(zeros(precision - c.length));
          } // append trailing zeros
          // TODO: simplify the next statement


          c = c.concat(zeros(e - c.length + 1 + (c.length < precision ? precision - c.length : 0))); // prepend zeros

          c = zeros(-e).concat(c);
          var dot = e > 0 ? e : 0;

          if (dot < c.length - 1) {
            c.splice(dot + 1, 0, '.');
          }

          return rounded.sign + c.join('');
        }
      };
      /**
       * Round the number of digits of a number *
       * @param {SplitValue} split       A value split with .splitNumber(value)
       * @param {number} precision  A positive integer
       * @return {SplitValue}
       *              Returns an object containing sign, coefficients, and exponent
       *              with rounded digits
       */


      exports.roundDigits = function (split, precision) {
        // create a clone
        var rounded = {
          sign: split.sign,
          coefficients: split.coefficients,
          exponent: split.exponent
        };
        var c = rounded.coefficients; // prepend zeros if needed

        while (precision <= 0) {
          c.unshift(0);
          rounded.exponent++;
          precision++;
        }

        if (c.length > precision) {
          var removed = c.splice(precision, c.length - precision);

          if (removed[0] >= 5) {
            var i = precision - 1;
            c[i]++;

            while (c[i] === 10) {
              c.pop();

              if (i === 0) {
                c.unshift(0);
                rounded.exponent++;
                i++;
              }

              i--;
              c[i]++;
            }
          }
        }

        return rounded;
      };
      /**
       * Create an array filled with zeros.
       * @param {number} length
       * @return {Array}
       */


      function zeros(length) {
        var arr = [];

        for (var i = 0; i < length; i++) {
          arr.push(0);
        }

        return arr;
      }
      /**
       * Count the number of significant digits of a number.
       *
       * For example:
       *   2.34 returns 3
       *   0.0034 returns 2
       *   120.5e+30 returns 4
       *
       * @param {number} value
       * @return {number} digits   Number of significant digits
       */


      exports.digits = function (value) {
        return value.toExponential().replace(/e.*$/, '') // remove exponential notation
        .replace(/^0\.?0*|\./, '') // remove decimal point and leading zeros
        .length;
      };
      /**
       * Minimum number added to one that makes the result different than one
       */


      exports.DBL_EPSILON = Number.EPSILON || 2.2204460492503130808472633361816E-16;
      /**
       * Compares two floating point numbers.
       * @param {number} x          First value to compare
       * @param {number} y          Second value to compare
       * @param {number} [epsilon]  The maximum relative difference between x and y
       *                            If epsilon is undefined or null, the function will
       *                            test whether x and y are exactly equal.
       * @return {boolean} whether the two numbers are nearly equal
      */

      exports.nearlyEqual = function (x, y, epsilon) {
        // if epsilon is null or undefined, test whether x and y are exactly equal
        if (epsilon === null || epsilon === undefined) {
          return x === y;
        }

        if (x === y) {
          return true;
        } // NaN


        if (isNaN(x) || isNaN(y)) {
          return false;
        } // at this point x and y should be finite


        if (isFinite(x) && isFinite(y)) {
          // check numbers are very close, needed when comparing numbers near zero
          var diff = Math.abs(x - y);

          if (diff < exports.DBL_EPSILON) {
            return true;
          } else {
            // use relative error
            return diff <= Math.max(Math.abs(x), Math.abs(y)) * epsilon;
          }
        } // Infinite and Number or negative Infinite and positive Infinite cases


        return false;
      };
      /***/

    },
    /* 68 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseClone = __webpack_require__(323);
      /** Used to compose bitmasks for cloning. */


      var CLONE_DEEP_FLAG = 1,
          CLONE_SYMBOLS_FLAG = 4;
      /**
       * This method is like `_.clone` except that it recursively clones `value`.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Lang
       * @param {*} value The value to recursively clone.
       * @returns {*} Returns the deep cloned value.
       * @see _.clone
       * @example
       *
       * var objects = [{ 'a': 1 }, { 'b': 2 }];
       *
       * var deep = _.cloneDeep(objects);
       * console.log(deep[0] === objects[0]);
       * // => false
       */

      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }

      module.exports = cloneDeep;
      /***/
    },
    /* 69 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./src/core/utils/graphql/subscription.js

      var subscription = __webpack_require__(222); // EXTERNAL MODULE: ./src/core/utils/analytics.js + 1 modules


      var analytics = __webpack_require__(17); // EXTERNAL MODULE: ./node_modules/lodash/get.js


      var get = __webpack_require__(10);

      var get_default =
      /*#__PURE__*/
      __webpack_require__.n(get); // CONCATENATED MODULE: ./src/core/utils/actions/triggers.js

      /**
       * The triggers object contains the data structure for all front end actions and its triggers.
       *
       * {
       *    <event name - received as event in processEvent>: {
       *      <event type - received as params.type in processEvent>: {
       *        *<data id value - received in params.data.params in processEvent>: {
       *          <action name>: {
       *            <action parameters>
       *          }
       *        }
       *      }
       *    }
       * }
       *
       * NOTE:
       *  - * <data id value - received in params.data.params in processEvent>
       *      data id value has a mapping in AnalyticsEventsDataId for every analytic event what is its dataId
       *      to better understand its usage, please read getValueFromDataParamsByDataIds summary and its implementation
       *
       * Example of a front end action that set a submission attribute (formLoading to true)
       * once the user clicks on Next button being on the page with its id as 5a9f35461cc48a0007201818
       * (in another words:
       *  once onNextPageClick event is triggered and the currentPage from params.data.params in processEvent is '5a9f35461cc48a0007201818'
       * )
       *
       * {
            AnalyticsCallback: { // trigger event type (only support Analytics events as trigger at the moment)
              onNextPageClick: { // analytics event trigger
                '5a9f35461cc48a0007201818': { // condition: page id which onNextPageClick should be triggered in order to do the following actions
                  setSubmissionAttributes: { // action name
                    // formLoading is a submission attribute id
                    formLoading: true, // params for setSubmissionAttributes action
                  },
                  setSubmissionValues: { // action name
                    // 4b0f354610048a0007201771 is a field id
                    '4b0f354610048a0007201771': 'new value', // params for setSubmissionValues action
                  },
                  raiseAnalyticsEvent: {  // action name
                    <event name>: { // params for raiseAnalyticsEvent action
                      <event params>
                    }
                  }
                  raiseExternalEvent: {  // action name
                    <event name>: { // params for raiseExternalEvent action
                      <event params>
                    }
                  }
                },
              },
            },
          }
       */


      var triggers_triggers = {};
      /**
       * Receives the triggers data in graphQL format and then convert into the local structure using objects
       *
       * e.g. of a graphqlTriggers content:
       *
       *
        [
          {
            "eventType": "AnalyticsCallback",
            "triggersAndActions": [
              {
                "triggerId": "onNextPageClick",
                "triggerParamsAndActions": [
                  {
                    "triggerDataId": "5a9f35461cc48a0007201818",
                    "actions": [
                      {
                        "actionId": "setSubmissionAttributes",
                        "actionParams": [
                          {
                            "id": "formLoading",
                            "value": true,
                          }
                        ],
                      }
                    ],
                  }
                ],
              }
            ],
          }
        ]
      
        it would return the following object:
      
        {
          AnalyticsCallback: {
            onNextPageClick: {
              '5a9f35461cc48a0007201818': {
                setSubmissionAttributes: {
                  formLoading: true,
                }
              },
            },
          },
        }
      
        for explanation on that every layer of this object means, please read the comments on top of this file,
        present just above _triggers variable definition
       *
       * @param {array} graphqlTriggers Array containing the triggers data in the GraphQL format
       */

      var triggers_transformGraphQLTriggersIntoLocalStructure = function transformGraphQLTriggersIntoLocalStructure() {
        var graphqlTriggers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var triggers = {};
        graphqlTriggers.forEach(function (event) {
          var eventType = event.eventType;
          triggers[eventType] = {};
          get_default()(event, 'triggersAndActions', []).forEach(function (triggerAndActions) {
            var triggerId = triggerAndActions.triggerId;
            triggers[eventType][triggerId] = {};
            get_default()(triggerAndActions, 'triggerParamsAndActions', []).forEach(function (triggerDataIdAndActions) {
              var triggerDataId = triggerDataIdAndActions.triggerDataId;
              triggers[eventType][triggerId][triggerDataId] = {};
              get_default()(triggerDataIdAndActions, 'actions', []).forEach(function (actionIdAndParams) {
                var actionId = actionIdAndParams.actionId;
                triggers[eventType][triggerId][triggerDataId][actionId] = {};
                get_default()(actionIdAndParams, 'actionParams', []).forEach(function (actionParams) {
                  var id = actionParams.id,
                      value = actionParams.value;
                  triggers[eventType][triggerId][triggerDataId][actionId][id] = value;
                });
              });
            });
          });
        });
        return triggers;
      };

      var triggers_setTriggers = function setTriggers(triggers) {
        triggers_triggers = triggers_transformGraphQLTriggersIntoLocalStructure(triggers);
      };

      var triggers_getTriggers = function getTriggers() {
        return triggers_triggers;
      }; // EXTERNAL MODULE: ./src/core/utils/data/helpers.js


      var helpers = __webpack_require__(91); // CONCATENATED MODULE: ./src/core/utils/actions/constants.js


      var BACK_END_TOPIC_EVENT = {
        formActionFired: 'formActionFired'
      };
      var BACK_END_ACTIONS = {
        navigateToPage: 'navigateToPage',
        tryToNavigateToNextPage: 'tryToNavigateToNextPage'
      };
      var FRONT_END_ACTIONS = {
        setSubmissionAttributes: 'setSubmissionAttributes',
        setSubmissionValues: 'setSubmissionValues',
        raiseAnalyticsEvent: 'raiseAnalyticsEvent',
        raiseExternalEvent: 'raiseExternalEvent'
      };
      var FRONT_BACK_END_ACTIONS = {
        changeFlow: 'changeFlow'
      }; // CONCATENATED MODULE: ./src/core/utils/actions/handleAction.js

      /**
       * It handles setSubmissionAttributes and setSubmissionValues actions properly.
       * @param {string} actionName It should be setSubmissionAttributes or setSubmissionValues
       * @param {object} actionParameters Object containing all parameters for setSubmissionAttributes or setSubmissionValues.
       */

      var handleAction_handleSetSubmissionActions = function handleSetSubmissionActions(actionName, actionParameters) {
        if (actionName !== FRONT_END_ACTIONS.setSubmissionAttributes && actionName !== FRONT_END_ACTIONS.setSubmissionValues) {
          return;
        }

        var attributes = []; // array of objects with following structure { id, value }

        var fields = []; // array of objects with following structure { id, value }

        if (actionName === FRONT_END_ACTIONS.setSubmissionAttributes) {
          Object.keys(actionParameters).forEach(function (attribute) {
            attributes.push({
              id: attribute,
              value: actionParameters[attribute]
            });
          });
        } else if (actionName === FRONT_END_ACTIONS.setSubmissionValues) {
          Object.keys(actionParameters).forEach(function (fieldId) {
            fields.push({
              id: fieldId,
              value: actionParameters[fieldId]
            });
          });
        }

        Object(helpers["c"
        /* setSubmissionValues */
        ])(attributes, fields, Date.now(), actions_getStore(), actions_getClient());
      };
      /**
       * It receives events object containing all events with its params to be raised.
       * Strucutre of events object:
       *  {
            <event name>: { // params for raiseExternalEvent action
              <event params>
            },
            ...
          }
       * @param {object} events Object containing all events with its params to be raised.
       */


      var handleAction_handleRaiseExternalEvents = function handleRaiseExternalEvents(events) {
        Object.keys(events).forEach(function (eventName) {
          actions_getEmitter().emit(eventName, events[eventName]);
        });
      };
      /**
       * It receives events object containing all events with its params to be raised.
       * Strucutre of events object:
       *  {
            <event name>: { // params for raiseAnalyticsEvent action
              <event params>
            },
            ...
          }
       * @param {object} events Object containing all events with its params to be raised.
       */


      var handleAction_handleRaiseAnalyticsEvents = function handleRaiseAnalyticsEvents(events) {
        Object.keys(events).forEach(function (eventName) {
          actions_getSendAnalytics()(eventName, events[eventName]);
        });
      };
      /**
       * Call the appropriate action handler according to the actionName
       * @param {string} actionName The action name to be handled
       * @param {object} actionParameters Object containing all parameters for the action to be handled
       */


      var handleAction_handleAction = function handleAction(actionName, actionParameters) {
        if (actionName === FRONT_END_ACTIONS.setSubmissionAttributes || actionName === FRONT_END_ACTIONS.setSubmissionValues) {
          handleAction_handleSetSubmissionActions(actionName, actionParameters);
        } else if (actionName === FRONT_END_ACTIONS.raiseAnalyticsEvent) {
          handleAction_handleRaiseAnalyticsEvents(actionParameters);
        } else if (actionName === FRONT_END_ACTIONS.raiseExternalEvent) {
          handleAction_handleRaiseExternalEvents(actionParameters);
        } else if (actionName === FRONT_BACK_END_ACTIONS.changeFlow) {
          Object(helpers["a"
          /* changeFlow */
          ])(actions_getClient(), actions_getStore(), actionParameters);
        }
      };
      /**
       * Handles back end actions that have its type as BACK_END_TOPIC_EVENT.formActionFired
       *
       * e.g. of formActionData
          {
            params:  {
              channel: "master",
              pageId: "5a9f37e51cc48a001537c7da"
            }
            type: "navigateToPage",
          }
       * @param {object} formActionData
       */


      var handleAction_handleNewActionSubscriptionEvent = function handleNewActionSubscriptionEvent(formActionData) {
        var params = formActionData.params,
            type = formActionData.type;

        if (type === BACK_END_ACTIONS.navigateToPage) {
          Object(helpers["b"
          /* navigateToPage */
          ])(actions_getClient(), actions_getStore(), params.pageId, params.channel);
        } else if (type === FRONT_BACK_END_ACTIONS.changeFlow) {
          Object(helpers["a"
          /* changeFlow */
          ])(actions_getClient(), actions_getStore(), params);
        } else if (type === BACK_END_ACTIONS.tryToNavigateToNextPage) {
          // set formLoading to false
          Object(helpers["c"
          /* setSubmissionValues */
          ])([{
            id: 'formLoading',
            value: false
          }], [], Date.now(), actions_getStore(), actions_getClient());
          Object(helpers["d"
          /* tryToNavigateToNextPage */
          ])(actions_getClient(), actions_getStore(), params.channel, true, true);
        }
      }; // EXTERNAL MODULE: ./src/core/utils/constants.js


      var constants = __webpack_require__(27); // CONCATENATED MODULE: ./src/core/utils/actions/processEvent.js

      /**
       * It returns the value in params considering dataIds.
       * Therefore if dataIds constains more than one value, it'll concatenate the values using a dash (-)
       * to separate the values consindering the order determined in the array (dataIds) (see 2nd example below).
       *
       * 1st e.g. returns 'currentPage' value
       *   dataIds = ['currentPage']
       *   params = { currentPage: "5a9f35021cc48a001537c7bc" }
       * it'll return "5a9f35021cc48a001537c7bc"
       *
       * 2nd e.g. return 'to-from' values
       *   dataIds = ['to','from']
       *   params = { from: "5a9f35461cc48a0007201818", to: "5a9f35021cc48a001537c7bc" }
       * it'll return "5a9f35021cc48a001537c7bc-5a9f35461cc48a0007201818"
       *
       */


      var processEvent_getValueFromDataParamsByDataIds = function getValueFromDataParamsByDataIds() {
        var dataIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var params = arguments.length > 1 ? arguments[1] : undefined;
        return dataIds.reduce(function (acc, dataId, index) {
          acc += params[dataId];

          if (dataIds.length - 1 !== index) {
            acc += '-';
          }

          return acc;
        }, '');
      };
      /**
       * Returns all actions configured for this event and data.
       * It returns an empty object if there isn't actions configured for this event and data.
       */


      var processEvent_getActionsForThisEvent = function getActionsForThisEvent(event, paramsType, paramsData, triggers) {
        // gets the dataId from AnalyticsEventsDataId mapping using the data.type (event type)
        // e.g. for onNextPageClick event (data.type === 'onNextPageClick')
        //      dataId is ['currentPage']
        var dataIds = analytics["b"
        /* AnalyticsEventsDataId */
        ][paramsType]; // so considering data.data.params as { currentPage: "5a9f35021cc48a001537c7bc" }
        // then value will contain "5a9f35021cc48a001537c7bc"

        var value = processEvent_getValueFromDataParamsByDataIds(dataIds, paramsData.params); // using get since it will only return something if a trigger was configured for this event and data

        return get_default()(triggers, "[".concat(event, "][").concat(paramsType, "][").concat(value, "]"), {});
      };
      /**
       * Receives an event and then it executes all actions that are configured for this event
       *
       * Currently it only AnalyticsCallback events
       *
       * @param {string} event The event name
       * @param {object} params The data object that the event has containing information about it
       */


      var processEvent_processEvent = function processEvent(event, params) {
        switch (event) {
          case FRONT_BACK_END_ACTIONS.changeFlow:
            {
              handleAction_handleAction(event, params);
              return;
            }

          case FRONT_END_ACTIONS.setSubmissionValues:
            {
              handleAction_handleAction(event, params);
              return;
            }

          default:
            break;
        }

        if (event !== constants["Events"].AnalyticsCallback || !params.type) {
          return;
        }

        var triggers = triggers_getTriggers();

        if (triggers[event] && triggers[event][params.type]) {
          var actions = processEvent_getActionsForThisEvent(event, params.type, params.data, triggers);
          Object.keys(actions).forEach(function (action) {
            handleAction_handleAction(action, actions[action]);
          });
        }
      }; // CONCATENATED MODULE: ./src/core/utils/actions/index.js

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "f", function () {
        return actions_setClient;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return actions_getClient;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "h", function () {
        return actions_setStore;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return actions_getStore;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "i", function () {
        return actions_setSubmissionId;
      });
      /* unused harmony export getSubmissionId */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "g", function () {
        return actions_setEmitter;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return actions_getEmitter;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return actions_getSendAnalytics;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "e", function () {
        return actions_initialiseTriggerData;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "j", function () {
        return actions_subscribeOnFormAction;
      });

      var actions_emitter;
      var actions_client;
      var actions_store;
      var actions_submissionId;
      var actions_sendAnalytics;

      var actions_setClient = function setClient(client) {
        actions_client = client;
      };

      var actions_getClient = function getClient() {
        return actions_client;
      };

      var actions_setStore = function setStore(store) {
        actions_store = store;
      };

      var actions_getStore = function getStore() {
        return actions_store;
      };

      var actions_setSubmissionId = function setSubmissionId(submissionId) {
        actions_submissionId = submissionId;
      };

      var actions_getSubmissionId = function getSubmissionId() {
        return actions_submissionId;
      };

      var actions_setEmitter = function setEmitter(emitter) {
        actions_emitter = emitter;
      };

      var actions_getEmitter = function getEmitter() {
        return actions_emitter;
      };

      var actions_getSendAnalytics = function getSendAnalytics() {
        return actions_sendAnalytics;
      };

      var actions_initialiseTriggerData = function initialiseTriggerData(triggers) {
        if (actions_sendAnalytics !== undefined || actions_store === undefined) {
          return;
        }

        triggers_setTriggers(triggers);
        var state = actions_store.getState();
        actions_sendAnalytics = Object(analytics["c"
        /* analyticsCallback */
        ])({
          submissionId: state.formatic.submissionId,
          form_id: state.formatic.formId,
          branch: state.formatic.environment,
          channel: state.formatic.channel
        }, actions_emitter);
        actions_emitter.on('*', processEvent_processEvent);
      };

      var actions_subscribeOnFormAction = function subscribeOnFormAction() {
        if (actions_client === undefined) {
          return;
        }

        actions_client.subscribe({
          query: subscription["b"
          /* subscriptionOnFormAction */
          ],
          variables: {
            submission: actions_submissionId
          }
        }).subscribe({
          next: function next(data) {
            Object.keys(data).forEach(function (key) {
              if (key === BACK_END_TOPIC_EVENT.formActionFired) {
                handleAction_handleNewActionSubscriptionEvent(data[key]);
              }
            });
          }
        });
      };
      /***/

    },
    /* 70 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.create = exports.connect = exports.Provider = undefined;

      var _Provider2 = __webpack_require__(1126);

      var _Provider3 = _interopRequireDefault(_Provider2);

      var _connect2 = __webpack_require__(1125);

      var _connect3 = _interopRequireDefault(_connect2);

      var _create2 = __webpack_require__(1124);

      var _create3 = _interopRequireDefault(_create2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.Provider = _Provider3.default;
      exports.connect = _connect3.default;
      exports.create = _create3.default;
      /***/
    },
    /* 71 */

    /***/
    function (module, exports) {
      var g; // This works in non-strict mode

      g = function () {
        return this;
      }();

      try {
        // This works if eval is allowed (see CSP)
        g = g || Function("return this")() || (1, eval)("this");
      } catch (e) {
        // This works if the window reference is available
        if (typeof window === "object") g = window;
      } // g can still be undefined, but nothing to do about it...
      // We return undefined, instead of nothing here, so it's
      // easier to handle this case. if(!global) { ...}


      module.exports = g;
      /***/
    },
    /* 72 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var escapeLatex = __webpack_require__(784);

      exports.symbols = {
        // GREEK LETTERS
        Alpha: 'A',
        alpha: '\\alpha',
        Beta: 'B',
        beta: '\\beta',
        Gamma: '\\Gamma',
        gamma: '\\gamma',
        Delta: '\\Delta',
        delta: '\\delta',
        Epsilon: 'E',
        epsilon: '\\epsilon',
        varepsilon: '\\varepsilon',
        Zeta: 'Z',
        zeta: '\\zeta',
        Eta: 'H',
        eta: '\\eta',
        Theta: '\\Theta',
        theta: '\\theta',
        vartheta: '\\vartheta',
        Iota: 'I',
        iota: '\\iota',
        Kappa: 'K',
        kappa: '\\kappa',
        varkappa: '\\varkappa',
        Lambda: '\\Lambda',
        lambda: '\\lambda',
        Mu: 'M',
        mu: '\\mu',
        Nu: 'N',
        nu: '\\nu',
        Xi: '\\Xi',
        xi: '\\xi',
        Omicron: 'O',
        omicron: 'o',
        Pi: '\\Pi',
        pi: '\\pi',
        varpi: '\\varpi',
        Rho: 'P',
        rho: '\\rho',
        varrho: '\\varrho',
        Sigma: '\\Sigma',
        sigma: '\\sigma',
        varsigma: '\\varsigma',
        Tau: 'T',
        tau: '\\tau',
        Upsilon: "\\Upsilon",
        upsilon: "\\upsilon",
        Phi: '\\Phi',
        phi: '\\phi',
        varphi: '\\varphi',
        Chi: 'X',
        chi: '\\chi',
        Psi: '\\Psi',
        psi: '\\psi',
        Omega: '\\Omega',
        omega: '\\omega',
        // logic
        'true': '\\mathrm{True}',
        'false': '\\mathrm{False}',
        // other
        i: 'i',
        // TODO use \i ??
        inf: '\\infty',
        Inf: '\\infty',
        infinity: '\\infty',
        Infinity: '\\infty',
        oo: '\\infty',
        lim: '\\lim',
        'undefined': '\\mathbf{?}'
      };
      exports.operators = {
        'transpose': '^\\top',
        'ctranspose': '^H',
        'factorial': '!',
        'pow': '^',
        'dotPow': '.^\\wedge',
        // TODO find ideal solution
        'unaryPlus': '+',
        'unaryMinus': '-',
        'bitNot': '\\~',
        // TODO find ideal solution
        'not': '\\neg',
        'multiply': '\\cdot',
        'divide': '\\frac',
        // TODO how to handle that properly?
        'dotMultiply': '.\\cdot',
        // TODO find ideal solution
        'dotDivide': '.:',
        // TODO find ideal solution
        'mod': '\\mod',
        'add': '+',
        'subtract': '-',
        'to': '\\rightarrow',
        'leftShift': '<<',
        'rightArithShift': '>>',
        'rightLogShift': '>>>',
        'equal': '=',
        'unequal': '\\neq',
        'smaller': '<',
        'larger': '>',
        'smallerEq': '\\leq',
        'largerEq': '\\geq',
        'bitAnd': '\\&',
        'bitXor': "\\underline{|}",
        'bitOr': '|',
        'and': '\\wedge',
        'xor': '\\veebar',
        'or': '\\vee'
      };
      exports.defaultTemplate = "\\mathrm{${name}}\\left(${args}\\right)";
      var units = {
        deg: '^\\circ'
      };

      exports.escape = function (string) {
        return escapeLatex(string, {
          'preserveFormatting': true
        });
      }; // @param {string} name
      // @param {boolean} isUnit


      exports.toSymbol = function (name, isUnit) {
        isUnit = typeof isUnit === 'undefined' ? false : isUnit;

        if (isUnit) {
          if (units.hasOwnProperty(name)) {
            return units[name];
          }

          return '\\mathrm{' + exports.escape(name) + '}';
        }

        if (exports.symbols.hasOwnProperty(name)) {
          return exports.symbols[name];
        }

        return exports.escape(name);
      };
      /***/

    },
    /* 73 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright 2014-2015, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       */

      /**
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */

      var warning = function warning() {};

      if (false) {}

      module.exports = warning;
      /***/
    },
    /* 74 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js

      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/create-react-class/index.js


      var create_react_class = __webpack_require__(32);

      var create_react_class_default =
      /*#__PURE__*/
      __webpack_require__.n(create_react_class); // EXTERNAL MODULE: ./node_modules/mini-store/lib/index.js


      var lib = __webpack_require__(70); // EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js


      var KeyCode = __webpack_require__(19); // EXTERNAL MODULE: ./node_modules/rc-util/es/createChainedFunction.js


      var createChainedFunction = __webpack_require__(148); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // CONCATENATED MODULE: ./node_modules/rc-menu/es/util.js


      function util_noop() {}

      function util_getKeyFromChildrenIndex(child, menuEventKey, index) {
        var prefix = menuEventKey || '';
        return child.key || prefix + 'item_' + index;
      }

      function util_getMenuIdFromSubMenuEventKey(eventKey) {
        return eventKey + '-menu-';
      }

      function util_loopMenuItem(children, cb) {
        var index = -1;
        external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(children, function (c) {
          index++;

          if (c && c.type && c.type.isMenuItemGroup) {
            external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(c.props.children, function (c2) {
              index++;
              cb(c2, index);
            });
          } else {
            cb(c, index);
          }
        });
      }

      function util_loopMenuItemRecusively(children, keys, ret) {
        if (!children || ret.find) {
          return;
        }

        external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(children, function (c) {
          if (ret.find) {
            return;
          }

          if (c) {
            var construt = c.type;

            if (!construt || !(construt.isSubMenu || construt.isMenuItem || construt.isMenuItemGroup)) {
              return;
            }

            if (keys.indexOf(c.key) !== -1) {
              ret.find = true;
            } else if (c.props.children) {
              util_loopMenuItemRecusively(c.props.children, keys, ret);
            }
          }
        });
      } // CONCATENATED MODULE: ./node_modules/rc-menu/es/DOMWrap.js


      var DOMWrap_DOMWrap = create_react_class_default()({
        displayName: 'DOMWrap',
        propTypes: {
          tag: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          hiddenClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
        },
        getDefaultProps: function getDefaultProps() {
          return {
            tag: 'div'
          };
        },
        render: function render() {
          var props = extends_default()({}, this.props);

          if (!props.visible) {
            props.className = props.className || '';
            props.className += ' ' + props.hiddenClassName;
          }

          var Tag = props.tag;
          delete props.tag;
          delete props.hiddenClassName;
          delete props.visible;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Tag, props);
        }
      });
      /* harmony default export */

      var es_DOMWrap = DOMWrap_DOMWrap; // CONCATENATED MODULE: ./node_modules/rc-menu/es/MenuMixin.js

      function MenuMixin_allDisabled(arr) {
        if (!arr.length) {
          return true;
        }

        return arr.every(function (c) {
          return !!c.props.disabled;
        });
      }

      function MenuMixin_updateActiveKey(store, menuId, activeKey) {
        var _extends2;

        var state = store.getState();
        store.setState({
          activeKey: extends_default()({}, state.activeKey, (_extends2 = {}, _extends2[menuId] = activeKey, _extends2))
        });
      }

      function MenuMixin_getActiveKey(props, originalActiveKey) {
        var activeKey = originalActiveKey;
        var children = props.children,
            eventKey = props.eventKey;

        if (activeKey) {
          var found = void 0;
          util_loopMenuItem(children, function (c, i) {
            if (c && !c.props.disabled && activeKey === util_getKeyFromChildrenIndex(c, eventKey, i)) {
              found = true;
            }
          });

          if (found) {
            return activeKey;
          }
        }

        activeKey = null;

        if (props.defaultActiveFirst) {
          util_loopMenuItem(children, function (c, i) {
            if (!activeKey && c && !c.props.disabled) {
              activeKey = util_getKeyFromChildrenIndex(c, eventKey, i);
            }
          });
          return activeKey;
        }

        return activeKey;
      }

      function MenuMixin_saveRef(index, subIndex, c) {
        if (c) {
          if (subIndex !== undefined) {
            this.instanceArray[index] = this.instanceArray[index] || [];
            this.instanceArray[index][subIndex] = c;
          } else {
            this.instanceArray[index] = c;
          }
        }
      }

      var MenuMixin_MenuMixin = {
        propTypes: {
          focusable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          defaultActiveFirst: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          activeKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          selectedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
          defaultSelectedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
          defaultOpenKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
          openKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
          children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
        },
        getDefaultProps: function getDefaultProps() {
          return {
            prefixCls: 'rc-menu',
            className: '',
            mode: 'vertical',
            level: 1,
            inlineIndent: 24,
            visible: true,
            focusable: true,
            style: {}
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          var originalActiveKey = 'activeKey' in nextProps ? nextProps.activeKey : this.getStore().getState().activeKey[this.getEventKey()];
          var activeKey = MenuMixin_getActiveKey(nextProps, originalActiveKey);

          if (activeKey !== originalActiveKey) {
            MenuMixin_updateActiveKey(this.getStore(), this.getEventKey(), activeKey);
          }
        },
        shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
          return this.props.visible || nextProps.visible;
        },
        componentWillMount: function componentWillMount() {
          this.instanceArray = [];
        },
        // all keyboard events callbacks run from here at first
        onKeyDown: function onKeyDown(e, callback) {
          var keyCode = e.keyCode;
          var handled = void 0;
          this.getFlatInstanceArray().forEach(function (obj) {
            if (obj && obj.props.active && obj.onKeyDown) {
              handled = obj.onKeyDown(e);
            }
          });

          if (handled) {
            return 1;
          }

          var activeItem = null;

          if (keyCode === KeyCode["a"
          /* default */
          ].UP || keyCode === KeyCode["a"
          /* default */
          ].DOWN) {
            activeItem = this.step(keyCode === KeyCode["a"
            /* default */
            ].UP ? -1 : 1);
          }

          if (activeItem) {
            e.preventDefault();
            MenuMixin_updateActiveKey(this.getStore(), this.getEventKey(), activeItem.props.eventKey);

            if (typeof callback === 'function') {
              callback(activeItem);
            }

            return 1;
          } else if (activeItem === undefined) {
            e.preventDefault();
            MenuMixin_updateActiveKey(this.getStore(), this.getEventKey(), null);
            return 1;
          }
        },
        onItemHover: function onItemHover(e) {
          var key = e.key,
              hover = e.hover;
          MenuMixin_updateActiveKey(this.getStore(), this.getEventKey(), hover ? key : null);
        },
        getEventKey: function getEventKey() {
          // when eventKey not available ,it's menu and return menu id '0-menu-'
          return this.props.eventKey || '0-menu-';
        },
        getStore: function getStore() {
          var store = this.store || this.props.store;
          return store;
        },
        getFlatInstanceArray: function getFlatInstanceArray() {
          var instanceArray = this.instanceArray;
          var hasInnerArray = instanceArray.some(function (a) {
            return Array.isArray(a);
          });

          if (hasInnerArray) {
            instanceArray = [];
            this.instanceArray.forEach(function (a) {
              if (Array.isArray(a)) {
                instanceArray.push.apply(instanceArray, a);
              } else {
                instanceArray.push(a);
              }
            });
            this.instanceArray = instanceArray;
          }

          return instanceArray;
        },
        renderCommonMenuItem: function renderCommonMenuItem(child, i, subIndex, extraProps) {
          var state = this.getStore().getState();
          var props = this.props;
          var key = util_getKeyFromChildrenIndex(child, props.eventKey, i);
          var childProps = child.props;
          var isActive = key === state.activeKey;
          var newChildProps = extends_default()({
            mode: props.mode,
            level: props.level,
            inlineIndent: props.inlineIndent,
            renderMenuItem: this.renderMenuItem,
            rootPrefixCls: props.prefixCls,
            index: i,
            parentMenu: this,
            // customized ref function, need to be invoked manually in child's componentDidMount
            manualRef: childProps.disabled ? undefined : Object(createChainedFunction["a"
            /* default */
            ])(child.ref, MenuMixin_saveRef.bind(this, i, subIndex)),
            eventKey: key,
            active: !childProps.disabled && isActive,
            multiple: props.multiple,
            onClick: this.onClick,
            onItemHover: this.onItemHover,
            openTransitionName: this.getOpenTransitionName(),
            openAnimation: props.openAnimation,
            subMenuOpenDelay: props.subMenuOpenDelay,
            subMenuCloseDelay: props.subMenuCloseDelay,
            forceSubMenuRender: props.forceSubMenuRender,
            onOpenChange: this.onOpenChange,
            onDeselect: this.onDeselect,
            onSelect: this.onSelect
          }, extraProps);

          if (props.mode === 'inline') {
            newChildProps.triggerSubMenuAction = 'click';
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(child, newChildProps);
        },
        renderRoot: function renderRoot(props) {
          var _this = this;

          this.instanceArray = [];
          var className = classnames_default()(props.prefixCls, props.className, props.prefixCls + '-' + props.mode);
          var domProps = {
            className: className,
            role: 'menu',
            'aria-activedescendant': ''
          };

          if (props.id) {
            domProps.id = props.id;
          }

          if (props.focusable) {
            domProps.tabIndex = '0';
            domProps.onKeyDown = this.onKeyDown;
          }

          return (// ESLint is not smart enough to know that the type of `children` was checked.

            /* eslint-disable */
            external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_DOMWrap, extends_default()({
              style: props.style,
              tag: 'ul',
              hiddenClassName: props.prefixCls + '-hidden',
              visible: props.visible
            }, domProps), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.map(props.children, function (c, i, subIndex) {
              return _this.renderMenuItem(c, i, subIndex, props.eventKey || '0-menu-');
            }))
            /*eslint-enable */

          );
        },
        step: function step(direction) {
          var children = this.getFlatInstanceArray();
          var activeKey = this.getStore().getState().activeKey[this.getEventKey()];
          var len = children.length;

          if (!len) {
            return null;
          }

          if (direction < 0) {
            children = children.concat().reverse();
          } // find current activeIndex


          var activeIndex = -1;
          children.every(function (c, ci) {
            if (c && c.props.eventKey === activeKey) {
              activeIndex = ci;
              return false;
            }

            return true;
          });

          if (!this.props.defaultActiveFirst && activeIndex !== -1) {
            if (MenuMixin_allDisabled(children.slice(activeIndex, len - 1))) {
              return undefined;
            }
          }

          var start = (activeIndex + 1) % len;
          var i = start;

          for (;;) {
            var child = children[i];

            if (!child || child.props.disabled) {
              i = (i + 1 + len) % len; // complete a loop

              if (i === start) {
                return null;
              }
            } else {
              return child;
            }
          }
        }
      };
      /* harmony default export */

      var es_MenuMixin = MenuMixin_MenuMixin; // CONCATENATED MODULE: ./node_modules/rc-menu/es/Menu.js

      var Menu_Menu = create_react_class_default()({
        displayName: 'Menu',
        propTypes: {
          defaultSelectedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
          selectedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
          defaultOpenKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
          openKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
          mode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
          getPopupContainer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onDeselect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onDestroy: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          openTransitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          openAnimation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
          subMenuOpenDelay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          subMenuCloseDelay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          forceSubMenuRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          triggerSubMenuAction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          level: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          selectable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
        },
        mixins: [es_MenuMixin],
        isRootMenu: true,
        getDefaultProps: function getDefaultProps() {
          return {
            selectable: true,
            onClick: util_noop,
            onSelect: util_noop,
            onOpenChange: util_noop,
            onDeselect: util_noop,
            defaultSelectedKeys: [],
            defaultOpenKeys: [],
            subMenuOpenDelay: 0.1,
            subMenuCloseDelay: 0.1,
            triggerSubMenuAction: 'hover'
          };
        },
        getInitialState: function getInitialState() {
          var props = this.props;
          var selectedKeys = props.defaultSelectedKeys;
          var openKeys = props.defaultOpenKeys;

          if ('selectedKeys' in props) {
            selectedKeys = props.selectedKeys || [];
          }

          if ('openKeys' in props) {
            openKeys = props.openKeys || [];
          }

          this.store = Object(lib["create"])({
            selectedKeys: selectedKeys,
            openKeys: openKeys,
            activeKey: {
              '0-menu-': MenuMixin_getActiveKey(props, props.activeKey)
            }
          });
          return {};
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          if ('selectedKeys' in nextProps) {
            this.store.setState({
              selectedKeys: nextProps.selectedKeys || []
            });
          }

          if ('openKeys' in nextProps) {
            this.store.setState({
              openKeys: nextProps.openKeys || []
            });
          }
        },
        onSelect: function onSelect(selectInfo) {
          var props = this.props;

          if (props.selectable) {
            // root menu
            var selectedKeys = this.store.getState().selectedKeys;
            var selectedKey = selectInfo.key;

            if (props.multiple) {
              selectedKeys = selectedKeys.concat([selectedKey]);
            } else {
              selectedKeys = [selectedKey];
            }

            if (!('selectedKeys' in props)) {
              this.store.setState({
                selectedKeys: selectedKeys
              });
            }

            props.onSelect(extends_default()({}, selectInfo, {
              selectedKeys: selectedKeys
            }));
          }
        },
        onClick: function onClick(e) {
          this.props.onClick(e);
        },
        onOpenChange: function onOpenChange(event) {
          var props = this.props;
          var openKeys = this.store.getState().openKeys.concat();
          var changed = false;

          var processSingle = function processSingle(e) {
            var oneChanged = false;

            if (e.open) {
              oneChanged = openKeys.indexOf(e.key) === -1;

              if (oneChanged) {
                openKeys.push(e.key);
              }
            } else {
              var index = openKeys.indexOf(e.key);
              oneChanged = index !== -1;

              if (oneChanged) {
                openKeys.splice(index, 1);
              }
            }

            changed = changed || oneChanged;
          };

          if (Array.isArray(event)) {
            // batch change call
            event.forEach(processSingle);
          } else {
            processSingle(event);
          }

          if (changed) {
            if (!('openKeys' in this.props)) {
              this.store.setState({
                openKeys: openKeys
              });
            }

            props.onOpenChange(openKeys);
          }
        },
        onDeselect: function onDeselect(selectInfo) {
          var props = this.props;

          if (props.selectable) {
            var selectedKeys = this.store.getState().selectedKeys.concat();
            var selectedKey = selectInfo.key;
            var index = selectedKeys.indexOf(selectedKey);

            if (index !== -1) {
              selectedKeys.splice(index, 1);
            }

            if (!('selectedKeys' in props)) {
              this.store.setState({
                selectedKeys: selectedKeys
              });
            }

            props.onDeselect(extends_default()({}, selectInfo, {
              selectedKeys: selectedKeys
            }));
          }
        },
        getOpenTransitionName: function getOpenTransitionName() {
          var props = this.props;
          var transitionName = props.openTransitionName;
          var animationName = props.openAnimation;

          if (!transitionName && typeof animationName === 'string') {
            transitionName = props.prefixCls + '-open-' + animationName;
          }

          return transitionName;
        },
        isInlineMode: function isInlineMode() {
          return this.props.mode === 'inline';
        },
        lastOpenSubMenu: function lastOpenSubMenu() {
          var lastOpen = [];

          var _store$getState = this.store.getState(),
              openKeys = _store$getState.openKeys;

          if (openKeys.length) {
            lastOpen = this.getFlatInstanceArray().filter(function (c) {
              return c && openKeys.indexOf(c.props.eventKey) !== -1;
            });
          }

          return lastOpen[0];
        },
        renderMenuItem: function renderMenuItem(c, i, subIndex, subMenuKey) {
          if (!c) {
            return null;
          }

          var state = this.store.getState();
          var extraProps = {
            openKeys: state.openKeys,
            selectedKeys: state.selectedKeys,
            triggerSubMenuAction: this.props.triggerSubMenuAction,
            subMenuKey: subMenuKey
          };
          return this.renderCommonMenuItem(c, i, subIndex, extraProps);
        },
        render: function render() {
          var props = extends_default()({}, this.props);
          props.className += ' ' + props.prefixCls + '-root';
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(lib["Provider"], {
            store: this.store
          }, this.renderRoot(props));
        }
      });
      /* harmony default export */

      var es_Menu = Menu_Menu; // EXTERNAL MODULE: external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}

      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_ = __webpack_require__(16);

      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_); // EXTERNAL MODULE: ./node_modules/rc-trigger/es/index.js + 20 modules


      var es = __webpack_require__(75); // EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 3 modules


      var Animate = __webpack_require__(43); // CONCATENATED MODULE: ./node_modules/rc-menu/es/SubPopupMenu.js


      var SubPopupMenu_SubPopupMenu = create_react_class_default()({
        displayName: 'SubPopupMenu',
        propTypes: {
          onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onDeselect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onOpenChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onDestroy: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          openTransitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          openAnimation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
          openKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
          visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
        },
        mixins: [es_MenuMixin],
        getInitialState: function getInitialState() {
          var _extends2;

          var props = this.props;
          props.store.setState({
            activeKey: extends_default()({}, props.store.getState().activeKey, (_extends2 = {}, _extends2[props.eventKey] = MenuMixin_getActiveKey(props, props.activeKey), _extends2))
          });
          return {};
        },
        componentDidMount: function componentDidMount() {
          // invoke customized ref to expose component to mixin
          if (this.props.manualRef) {
            this.props.manualRef(this);
          }
        },
        onDeselect: function onDeselect(selectInfo) {
          this.props.onDeselect(selectInfo);
        },
        onSelect: function onSelect(selectInfo) {
          this.props.onSelect(selectInfo);
        },
        onClick: function onClick(e) {
          this.props.onClick(e);
        },
        onOpenChange: function onOpenChange(e) {
          this.props.onOpenChange(e);
        },
        onDestroy: function onDestroy(key) {
          this.props.onDestroy(key);
        },
        getOpenTransitionName: function getOpenTransitionName() {
          return this.props.openTransitionName;
        },
        renderMenuItem: function renderMenuItem(c, i, subIndex, subMenuKey) {
          if (!c) {
            return null;
          }

          var props = this.props;
          var extraProps = {
            openKeys: props.openKeys,
            selectedKeys: props.selectedKeys,
            triggerSubMenuAction: props.triggerSubMenuAction,
            subMenuKey: subMenuKey
          };
          return this.renderCommonMenuItem(c, i, subIndex, extraProps);
        },
        render: function render() {
          var props = extends_default()({}, this.props);
          var haveRendered = this.haveRendered;
          this.haveRendered = true;
          this.haveOpened = this.haveOpened || props.visible || props.forceSubMenuRender;

          if (!this.haveOpened) {
            return null;
          }

          var transitionAppear = !(!haveRendered && props.visible && props.mode === 'inline');
          props.className += ' ' + props.prefixCls + '-sub';
          var animProps = {};

          if (props.openTransitionName) {
            animProps.transitionName = props.openTransitionName;
          } else if (typeof props.openAnimation === 'object') {
            animProps.animation = extends_default()({}, props.openAnimation);

            if (!transitionAppear) {
              delete animProps.animation.appear;
            }
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], extends_default()({}, animProps, {
            showProp: 'visible',
            component: '',
            transitionAppear: transitionAppear
          }), this.renderRoot(props));
        }
      });
      /* harmony default export */

      var es_SubPopupMenu = Object(lib["connect"])()(SubPopupMenu_SubPopupMenu); // CONCATENATED MODULE: ./node_modules/rc-menu/es/placements.js

      var autoAdjustOverflow = {
        adjustX: 1,
        adjustY: 1
      };
      var placements = {
        topLeft: {
          points: ['bl', 'tl'],
          overflow: autoAdjustOverflow,
          offset: [0, -7]
        },
        bottomLeft: {
          points: ['tl', 'bl'],
          overflow: autoAdjustOverflow,
          offset: [0, 7]
        },
        leftTop: {
          points: ['tr', 'tl'],
          overflow: autoAdjustOverflow,
          offset: [-4, 0]
        },
        rightTop: {
          points: ['tl', 'tr'],
          overflow: autoAdjustOverflow,
          offset: [4, 0]
        }
      };
      /* harmony default export */

      var es_placements = placements; // CONCATENATED MODULE: ./node_modules/rc-menu/es/SubMenu.js

      var SubMenu_guid = 0;
      var SubMenu_popupPlacementMap = {
        horizontal: 'bottomLeft',
        vertical: 'rightTop',
        'vertical-left': 'rightTop',
        'vertical-right': 'leftTop'
      };

      var SubMenu_updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
        var _extends2;

        var menuId = util_getMenuIdFromSubMenuEventKey(eventKey);
        var state = store.getState();
        store.setState({
          defaultActiveFirst: extends_default()({}, state.defaultActiveFirst, (_extends2 = {}, _extends2[menuId] = defaultActiveFirst, _extends2))
        });
      };

      var SubMenu_SubMenu = create_react_class_default()({
        displayName: 'SubMenu',
        propTypes: {
          parentMenu: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          title: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
          children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          selectedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          openKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          onClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onOpenChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          rootPrefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          eventKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          active: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          // TODO: remove
          onItemHover: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          triggerSubMenuAction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          onDeselect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onDestroy: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onTitleMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onTitleMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onTitleClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          isOpen: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
        },
        isRootMenu: false,
        getDefaultProps: function getDefaultProps() {
          return {
            onMouseEnter: util_noop,
            onMouseLeave: util_noop,
            onTitleMouseEnter: util_noop,
            onTitleMouseLeave: util_noop,
            onTitleClick: util_noop,
            title: ''
          };
        },
        getInitialState: function getInitialState() {
          this.isSubMenu = 1;
          var props = this.props;
          var store = props.store;
          var eventKey = props.eventKey;
          var defaultActiveFirst = store.getState().defaultActiveFirst;
          var value = false;

          if (defaultActiveFirst) {
            value = defaultActiveFirst[eventKey];
          }

          SubMenu_updateDefaultActiveFirst(store, eventKey, value);
          return {};
        },
        componentDidMount: function componentDidMount() {
          this.componentDidUpdate(); // invoke customized ref to expose component to mixin

          if (this.props.manualRef) {
            this.props.manualRef(this);
          }
        },
        componentDidUpdate: function componentDidUpdate() {
          var _this = this;

          var _props = this.props,
              mode = _props.mode,
              parentMenu = _props.parentMenu;

          if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
            return;
          }

          this.minWidthTimeout = setTimeout(function () {
            if (!_this.subMenuTitle || !_this.menuInstance) {
              return;
            }

            var popupMenu = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(_this.menuInstance);

            if (popupMenu.offsetWidth >= _this.subMenuTitle.offsetWidth) {
              return;
            }

            popupMenu.style.minWidth = _this.subMenuTitle.offsetWidth + 'px';
          }, 0);
        },
        componentWillUnmount: function componentWillUnmount() {
          var _props2 = this.props,
              onDestroy = _props2.onDestroy,
              eventKey = _props2.eventKey;

          if (onDestroy) {
            onDestroy(eventKey);
          }

          if (this.minWidthTimeout) {
            clearTimeout(this.minWidthTimeout);
          }

          if (this.mouseenterTimeout) {
            clearTimeout(this.mouseenterTimeout);
          }
        },
        onDestroy: function onDestroy(key) {
          this.props.onDestroy(key);
        },
        onKeyDown: function onKeyDown(e) {
          var keyCode = e.keyCode;
          var menu = this.menuInstance;
          var _props3 = this.props,
              isOpen = _props3.isOpen,
              store = _props3.store;

          if (keyCode === KeyCode["a"
          /* default */
          ].ENTER) {
            this.onTitleClick(e);
            SubMenu_updateDefaultActiveFirst(store, this.props.eventKey, true);
            return true;
          }

          if (keyCode === KeyCode["a"
          /* default */
          ].RIGHT) {
            if (isOpen) {
              menu.onKeyDown(e);
            } else {
              this.triggerOpenChange(true); // need to update current menu's defaultActiveFirst value

              SubMenu_updateDefaultActiveFirst(store, this.props.eventKey, true);
            }

            return true;
          }

          if (keyCode === KeyCode["a"
          /* default */
          ].LEFT) {
            var handled = void 0;

            if (isOpen) {
              handled = menu.onKeyDown(e);
            } else {
              return undefined;
            }

            if (!handled) {
              this.triggerOpenChange(false);
              handled = true;
            }

            return handled;
          }

          if (isOpen && (keyCode === KeyCode["a"
          /* default */
          ].UP || keyCode === KeyCode["a"
          /* default */
          ].DOWN)) {
            return menu.onKeyDown(e);
          }
        },
        onOpenChange: function onOpenChange(e) {
          this.props.onOpenChange(e);
        },
        onPopupVisibleChange: function onPopupVisibleChange(visible) {
          this.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
        },
        onMouseEnter: function onMouseEnter(e) {
          var _props4 = this.props,
              key = _props4.eventKey,
              onMouseEnter = _props4.onMouseEnter,
              store = _props4.store;
          SubMenu_updateDefaultActiveFirst(store, this.props.eventKey, false);
          onMouseEnter({
            key: key,
            domEvent: e
          });
        },
        onMouseLeave: function onMouseLeave(e) {
          var _props5 = this.props,
              parentMenu = _props5.parentMenu,
              eventKey = _props5.eventKey,
              onMouseLeave = _props5.onMouseLeave;
          parentMenu.subMenuInstance = this;
          onMouseLeave({
            key: eventKey,
            domEvent: e
          });
        },
        onTitleMouseEnter: function onTitleMouseEnter(domEvent) {
          var _props6 = this.props,
              key = _props6.eventKey,
              onItemHover = _props6.onItemHover,
              onTitleMouseEnter = _props6.onTitleMouseEnter;
          onItemHover({
            key: key,
            hover: true
          });
          onTitleMouseEnter({
            key: key,
            domEvent: domEvent
          });
        },
        onTitleMouseLeave: function onTitleMouseLeave(e) {
          var _props7 = this.props,
              parentMenu = _props7.parentMenu,
              eventKey = _props7.eventKey,
              onItemHover = _props7.onItemHover,
              onTitleMouseLeave = _props7.onTitleMouseLeave;
          parentMenu.subMenuInstance = this;
          onItemHover({
            key: eventKey,
            hover: false
          });
          onTitleMouseLeave({
            key: eventKey,
            domEvent: e
          });
        },
        onTitleClick: function onTitleClick(e) {
          var props = this.props;
          props.onTitleClick({
            key: props.eventKey,
            domEvent: e
          });

          if (props.triggerSubMenuAction === 'hover') {
            return;
          }

          this.triggerOpenChange(!props.isOpen, 'click');
          SubMenu_updateDefaultActiveFirst(props.store, this.props.eventKey, false);
        },
        onSubMenuClick: function onSubMenuClick(info) {
          this.props.onClick(this.addKeyPath(info));
        },
        onSelect: function onSelect(info) {
          this.props.onSelect(info);
        },
        onDeselect: function onDeselect(info) {
          this.props.onDeselect(info);
        },
        getPrefixCls: function getPrefixCls() {
          return this.props.rootPrefixCls + '-submenu';
        },
        getActiveClassName: function getActiveClassName() {
          return this.getPrefixCls() + '-active';
        },
        getDisabledClassName: function getDisabledClassName() {
          return this.getPrefixCls() + '-disabled';
        },
        getSelectedClassName: function getSelectedClassName() {
          return this.getPrefixCls() + '-selected';
        },
        getOpenClassName: function getOpenClassName() {
          return this.props.rootPrefixCls + '-submenu-open';
        },
        saveMenuInstance: function saveMenuInstance(c) {
          // children menu instance
          this.menuInstance = c;
        },
        addKeyPath: function addKeyPath(info) {
          return extends_default()({}, info, {
            keyPath: (info.keyPath || []).concat(this.props.eventKey)
          });
        },
        triggerOpenChange: function triggerOpenChange(open, type) {
          var _this2 = this;

          var key = this.props.eventKey;

          var openChange = function openChange() {
            _this2.onOpenChange({
              key: key,
              item: _this2,
              trigger: type,
              open: open
            });
          };

          if (type === 'mouseenter') {
            // make sure mouseenter happen after other menu item's mouseleave
            this.mouseenterTimeout = setTimeout(function () {
              openChange();
            }, 0);
          } else {
            openChange();
          }
        },
        isChildrenSelected: function isChildrenSelected() {
          var ret = {
            find: false
          };
          util_loopMenuItemRecusively(this.props.children, this.props.selectedKeys, ret);
          return ret.find;
        },
        isOpen: function isOpen() {
          return this.props.openKeys.indexOf(this.props.eventKey) !== -1;
        },
        renderChildren: function renderChildren(children) {
          var props = this.props;
          var baseProps = {
            mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
            visible: this.props.isOpen,
            level: props.level + 1,
            inlineIndent: props.inlineIndent,
            focusable: false,
            onClick: this.onSubMenuClick,
            onSelect: this.onSelect,
            onDeselect: this.onDeselect,
            onDestroy: this.onDestroy,
            selectedKeys: props.selectedKeys,
            eventKey: props.eventKey + '-menu-',
            openKeys: props.openKeys,
            openTransitionName: props.openTransitionName,
            openAnimation: props.openAnimation,
            onOpenChange: this.onOpenChange,
            subMenuOpenDelay: props.subMenuOpenDelay,
            subMenuCloseDelay: props.subMenuCloseDelay,
            forceSubMenuRender: props.forceSubMenuRender,
            triggerSubMenuAction: props.triggerSubMenuAction,
            defaultActiveFirst: props.store.getState().defaultActiveFirst[util_getMenuIdFromSubMenuEventKey(props.eventKey)],
            multiple: props.multiple,
            prefixCls: props.rootPrefixCls,
            id: this._menuId,
            manualRef: this.saveMenuInstance
          };
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_SubPopupMenu, baseProps, children);
        },
        saveSubMenuTitle: function saveSubMenuTitle(subMenuTitle) {
          this.subMenuTitle = subMenuTitle;
        },
        render: function render() {
          var _classNames;

          var props = this.props;
          var isOpen = props.isOpen;
          var prefixCls = this.getPrefixCls();
          var isInlineMode = props.mode === 'inline';
          var className = classnames_default()(prefixCls, prefixCls + '-' + props.mode, (_classNames = {}, _classNames[props.className] = !!props.className, _classNames[this.getOpenClassName()] = isOpen, _classNames[this.getActiveClassName()] = props.active || isOpen && !isInlineMode, _classNames[this.getDisabledClassName()] = props.disabled, _classNames[this.getSelectedClassName()] = this.isChildrenSelected(), _classNames));

          if (!this._menuId) {
            if (props.eventKey) {
              this._menuId = props.eventKey + '$Menu';
            } else {
              this._menuId = '$__$' + ++SubMenu_guid + '$Menu';
            }
          }

          var mouseEvents = {};
          var titleClickEvents = {};
          var titleMouseEvents = {};

          if (!props.disabled) {
            mouseEvents = {
              onMouseLeave: this.onMouseLeave,
              onMouseEnter: this.onMouseEnter
            }; // only works in title, not outer li

            titleClickEvents = {
              onClick: this.onTitleClick
            };
            titleMouseEvents = {
              onMouseEnter: this.onTitleMouseEnter,
              onMouseLeave: this.onTitleMouseLeave
            };
          }

          var style = {};

          if (isInlineMode) {
            style.paddingLeft = props.inlineIndent * props.level;
          }

          var title = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', extends_default()({
            ref: this.saveSubMenuTitle,
            style: style,
            className: prefixCls + '-title'
          }, titleMouseEvents, titleClickEvents, {
            'aria-expanded': isOpen,
            'aria-owns': this._menuId,
            'aria-haspopup': 'true',
            title: typeof props.title === 'string' ? props.title : undefined
          }), props.title, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('i', {
            className: prefixCls + '-arrow'
          }));
          var children = this.renderChildren(props.children);
          var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
            return triggerNode.parentNode;
          };
          var popupPlacement = SubMenu_popupPlacementMap[props.mode];
          var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', extends_default()({}, mouseEvents, {
            className: className,
            style: props.style
          }), isInlineMode && title, isInlineMode && children, !isInlineMode && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es["default"], {
            prefixCls: prefixCls,
            popupClassName: prefixCls + '-popup ' + popupClassName,
            getPopupContainer: getPopupContainer,
            builtinPlacements: es_placements,
            popupPlacement: popupPlacement,
            popupVisible: isOpen,
            popup: children,
            action: props.disabled ? [] : [props.triggerSubMenuAction],
            mouseEnterDelay: props.subMenuOpenDelay,
            mouseLeaveDelay: props.subMenuCloseDelay,
            onPopupVisibleChange: this.onPopupVisibleChange,
            forceRender: props.forceSubMenuRender
          }, title));
        }
      });
      SubMenu_SubMenu.isSubMenu = 1;
      /* harmony default export */

      var es_SubMenu = Object(lib["connect"])(function (_ref, _ref2) {
        var openKeys = _ref.openKeys,
            activeKey = _ref.activeKey;
        var eventKey = _ref2.eventKey,
            subMenuKey = _ref2.subMenuKey;
        return {
          isOpen: openKeys.indexOf(eventKey) > -1,
          active: activeKey[subMenuKey] === eventKey
        };
      })(SubMenu_SubMenu); // EXTERNAL MODULE: ./node_modules/dom-scroll-into-view/lib/index.js

      var dom_scroll_into_view_lib = __webpack_require__(146);

      var dom_scroll_into_view_lib_default =
      /*#__PURE__*/
      __webpack_require__.n(dom_scroll_into_view_lib); // CONCATENATED MODULE: ./node_modules/rc-menu/es/MenuItem.js

      /* eslint react/no-is-mounted:0 */


      var MenuItem_MenuItem = create_react_class_default()({
        displayName: 'MenuItem',
        propTypes: {
          rootPrefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          eventKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          active: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          selectedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          title: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          onItemHover: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onDeselect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          parentMenu: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          onDestroy: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        },
        getDefaultProps: function getDefaultProps() {
          return {
            onSelect: util_noop,
            onMouseEnter: util_noop,
            onMouseLeave: util_noop
          };
        },
        componentWillUnmount: function componentWillUnmount() {
          var props = this.props;

          if (props.onDestroy) {
            props.onDestroy(props.eventKey);
          }
        },
        componentDidMount: function componentDidMount() {
          // invoke customized ref to expose component to mixin
          this.callRef();
        },
        componentDidUpdate: function componentDidUpdate() {
          if (this.props.active) {
            dom_scroll_into_view_lib_default()(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this), external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this.props.parentMenu), {
              onlyScrollIfNeeded: true
            });
          }

          this.callRef();
        },
        onKeyDown: function onKeyDown(e) {
          var keyCode = e.keyCode;

          if (keyCode === KeyCode["a"
          /* default */
          ].ENTER) {
            this.onClick(e);
            return true;
          }
        },
        onMouseLeave: function onMouseLeave(e) {
          var _props = this.props,
              eventKey = _props.eventKey,
              onItemHover = _props.onItemHover,
              onMouseLeave = _props.onMouseLeave;
          onItemHover({
            key: eventKey,
            hover: false
          });
          onMouseLeave({
            key: eventKey,
            domEvent: e
          });
        },
        onMouseEnter: function onMouseEnter(e) {
          var _props2 = this.props,
              eventKey = _props2.eventKey,
              onItemHover = _props2.onItemHover,
              onMouseEnter = _props2.onMouseEnter;
          onItemHover({
            key: eventKey,
            hover: true
          });
          onMouseEnter({
            key: eventKey,
            domEvent: e
          });
        },
        onClick: function onClick(e) {
          var _props3 = this.props,
              eventKey = _props3.eventKey,
              multiple = _props3.multiple,
              onClick = _props3.onClick,
              onSelect = _props3.onSelect,
              onDeselect = _props3.onDeselect,
              isSelected = _props3.isSelected;
          var info = {
            key: eventKey,
            keyPath: [eventKey],
            item: this,
            domEvent: e
          };
          onClick(info);

          if (multiple) {
            if (isSelected) {
              onDeselect(info);
            } else {
              onSelect(info);
            }
          } else if (!isSelected) {
            onSelect(info);
          }
        },
        getPrefixCls: function getPrefixCls() {
          return this.props.rootPrefixCls + '-item';
        },
        getActiveClassName: function getActiveClassName() {
          return this.getPrefixCls() + '-active';
        },
        getSelectedClassName: function getSelectedClassName() {
          return this.getPrefixCls() + '-selected';
        },
        getDisabledClassName: function getDisabledClassName() {
          return this.getPrefixCls() + '-disabled';
        },
        callRef: function callRef() {
          if (this.props.manualRef) {
            this.props.manualRef(this);
          }
        },
        render: function render() {
          var _classNames;

          var props = this.props;
          var className = classnames_default()(this.getPrefixCls(), props.className, (_classNames = {}, _classNames[this.getActiveClassName()] = !props.disabled && props.active, _classNames[this.getSelectedClassName()] = props.isSelected, _classNames[this.getDisabledClassName()] = props.disabled, _classNames));
          var attrs = extends_default()({}, props.attribute, {
            title: props.title,
            className: className,
            role: 'menuitem',
            'aria-selected': props.isSelected,
            'aria-disabled': props.disabled
          });
          var mouseEvent = {};

          if (!props.disabled) {
            mouseEvent = {
              onClick: this.onClick,
              onMouseLeave: this.onMouseLeave,
              onMouseEnter: this.onMouseEnter
            };
          }

          var style = extends_default()({}, props.style);

          if (props.mode === 'inline') {
            style.paddingLeft = props.inlineIndent * props.level;
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', extends_default()({}, attrs, mouseEvent, {
            style: style
          }), props.children);
        }
      });
      MenuItem_MenuItem.isMenuItem = 1;
      /* harmony default export */

      var es_MenuItem = Object(lib["connect"])(function (_ref, _ref2) {
        var activeKey = _ref.activeKey,
            selectedKeys = _ref.selectedKeys;
        var eventKey = _ref2.eventKey,
            subMenuKey = _ref2.subMenuKey;
        return {
          active: activeKey[subMenuKey] === eventKey,
          isSelected: selectedKeys.indexOf(eventKey) !== -1
        };
      })(MenuItem_MenuItem); // CONCATENATED MODULE: ./node_modules/rc-menu/es/MenuItemGroup.js

      var MenuItemGroup_MenuItemGroup = create_react_class_default()({
        displayName: 'MenuItemGroup',
        propTypes: {
          renderMenuItem: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          index: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          rootPrefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        },
        getDefaultProps: function getDefaultProps() {
          // To fix keyboard UX.
          return {
            disabled: true
          };
        },
        renderInnerMenuItem: function renderInnerMenuItem(item, subIndex) {
          var _props = this.props,
              renderMenuItem = _props.renderMenuItem,
              index = _props.index;
          return renderMenuItem(item, index, subIndex, this.props.subMenuKey);
        },
        render: function render() {
          var props = this.props;
          var _props$className = props.className,
              className = _props$className === undefined ? '' : _props$className,
              rootPrefixCls = props.rootPrefixCls;
          var titleClassName = rootPrefixCls + '-item-group-title';
          var listClassName = rootPrefixCls + '-item-group-list';
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
            className: className + ' ' + rootPrefixCls + '-item-group'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: titleClassName,
            title: typeof props.title === 'string' ? props.title : undefined
          }, props.title), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', {
            className: listClassName
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.map(props.children, this.renderInnerMenuItem)));
        }
      });
      MenuItemGroup_MenuItemGroup.isMenuItemGroup = true;
      /* harmony default export */

      var es_MenuItemGroup = MenuItemGroup_MenuItemGroup; // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js

      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // CONCATENATED MODULE: ./node_modules/rc-menu/es/Divider.js


      var Divider_Divider = function (_React$Component) {
        inherits_default()(Divider, _React$Component);

        function Divider() {
          classCallCheck_default()(this, Divider);
          return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
        }

        Divider.prototype.render = function render() {
          var _props = this.props,
              _props$className = _props.className,
              className = _props$className === undefined ? '' : _props$className,
              rootPrefixCls = _props.rootPrefixCls;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
            className: className + ' ' + rootPrefixCls + '-item-divider'
          });
        };

        return Divider;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Divider_Divider.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        rootPrefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      Divider_Divider.defaultProps = {
        disabled: true
      };
      /* harmony default export */

      var es_Divider = Divider_Divider; // CONCATENATED MODULE: ./node_modules/rc-menu/es/index.js

      /* concated harmony reexport */

      __webpack_require__.d(__webpack_exports__, "d", function () {
        return es_SubMenu;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return es_MenuItem;
      });
      /* unused concated harmony import MenuItem */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_MenuItem;
      });
      /* unused concated harmony import MenuItemGroup */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_MenuItemGroup;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return es_MenuItemGroup;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return es_Divider;
      });
      /* harmony default export */


      var rc_menu_es = __webpack_exports__["e"] = es_Menu;
      /***/
    },
    /* 75 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}


      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_ = __webpack_require__(16);

      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_); // EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/contains.js


      var contains = __webpack_require__(168); // EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/addEventListener.js


      var addEventListener = __webpack_require__(57); // EXTERNAL MODULE: ./node_modules/rc-util/es/ContainerRender.js


      var ContainerRender = __webpack_require__(294); // EXTERNAL MODULE: ./node_modules/rc-util/es/Portal.js


      var Portal = __webpack_require__(293); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // CONCATENATED MODULE: ./node_modules/rc-trigger/es/utils.js


      function utils_isPointsEq(a1, a2, isAlignPoint) {
        if (isAlignPoint) {
          return a1[0] === a2[0];
        }

        return a1[0] === a2[0] && a1[1] === a2[1];
      }

      function utils_getAlignFromPlacement(builtinPlacements, placementStr, align) {
        var baseAlign = builtinPlacements[placementStr] || {};
        return extends_default()({}, baseAlign, align);
      }

      function utils_getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
        var points = align.points;

        for (var placement in builtinPlacements) {
          if (builtinPlacements.hasOwnProperty(placement)) {
            if (utils_isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
              return prefixCls + '-placement-' + placement;
            }
          }
        }

        return '';
      }

      function utils_saveRef(name, component) {
        this[name] = component;
      } // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js


      var createClass = __webpack_require__(12);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // CONCATENATED MODULE: ./node_modules/dom-align/es/propertyUtils.js


      var vendorPrefix = void 0;
      var jsCssMap = {
        Webkit: '-webkit-',
        Moz: '-moz-',
        // IE did it wrong again ...
        ms: '-ms-',
        O: '-o-'
      };

      function getVendorPrefix() {
        if (vendorPrefix !== undefined) {
          return vendorPrefix;
        }

        vendorPrefix = '';
        var style = document.createElement('p').style;
        var testProp = 'Transform';

        for (var key in jsCssMap) {
          if (key + testProp in style) {
            vendorPrefix = key;
          }
        }

        return vendorPrefix;
      }

      function getTransitionName() {
        return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
      }

      function getTransformName() {
        return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
      }

      function setTransitionProperty(node, value) {
        var name = getTransitionName();

        if (name) {
          node.style[name] = value;

          if (name !== 'transitionProperty') {
            node.style.transitionProperty = value;
          }
        }
      }

      function propertyUtils_setTransform(node, value) {
        var name = getTransformName();

        if (name) {
          node.style[name] = value;

          if (name !== 'transform') {
            node.style.transform = value;
          }
        }
      }

      function getTransitionProperty(node) {
        return node.style.transitionProperty || node.style[getTransitionName()];
      }

      function getTransformXY(node) {
        var style = window.getComputedStyle(node, null);
        var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

        if (transform && transform !== 'none') {
          var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
          return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
          };
        }

        return {
          x: 0,
          y: 0
        };
      }

      var matrix2d = /matrix\((.*)\)/;
      var matrix3d = /matrix3d\((.*)\)/;

      function setTransformXY(node, xy) {
        var style = window.getComputedStyle(node, null);
        var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

        if (transform && transform !== 'none') {
          var arr = void 0;
          var match2d = transform.match(matrix2d);

          if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(',').map(function (item) {
              return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            propertyUtils_setTransform(node, 'matrix(' + arr.join(',') + ')');
          } else {
            var match3d = transform.match(matrix3d)[1];
            arr = match3d.split(',').map(function (item) {
              return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            propertyUtils_setTransform(node, 'matrix3d(' + arr.join(',') + ')');
          }
        } else {
          propertyUtils_setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
        }
      } // CONCATENATED MODULE: ./node_modules/dom-align/es/utils.js


      var utils_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
      var utils_RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
      var utils_getComputedStyleX = void 0; // https://stackoverflow.com/a/3485654/3040605

      function utils_forceRelayout(elem) {
        var originalStyle = elem.style.display;
        elem.style.display = 'none';
        elem.offsetHeight; // eslint-disable-line

        elem.style.display = originalStyle;
      }

      function utils_css(el, name, v) {
        var value = v;

        if ((typeof name === 'undefined' ? 'undefined' : utils_typeof(name)) === 'object') {
          for (var i in name) {
            if (name.hasOwnProperty(i)) {
              utils_css(el, i, name[i]);
            }
          }

          return undefined;
        }

        if (typeof value !== 'undefined') {
          if (typeof value === 'number') {
            value = value + 'px';
          }

          el.style[name] = value;
          return undefined;
        }

        return utils_getComputedStyleX(el, name);
      }

      function utils_getClientPosition(elem) {
        var box = void 0;
        var x = void 0;
        var y = void 0;
        var doc = elem.ownerDocument;
        var body = doc.body;
        var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

        box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
        // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
        // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

        x = box.left;
        y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
        // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
        // IE6 standards mode, this border can be overridden by setting the
        // document element's border to zero -- thus, we cannot rely on the
        // offset always being 2 pixels.
        // In quirks mode, the offset can be determined by querying the body's
        // clientLeft/clientTop, but in standards mode, it is found by querying
        // the document element's clientLeft/clientTop.  Since we already called
        // getClientBoundingRect we have already forced a reflow, so it is not
        // too expensive just to query them all.
        // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
        // 窗口边框标准是设 documentElement ,quirks 时设置 body
        // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
        // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
        // 标准 ie 下 docElem.clientTop 就是 border-top
        // ie7 html 即窗口边框改变不了。永远为 2
        // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

        x -= docElem.clientLeft || body.clientLeft || 0;
        y -= docElem.clientTop || body.clientTop || 0;
        return {
          left: x,
          top: y
        };
      }

      function utils_getScroll(w, top) {
        var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
        var method = 'scroll' + (top ? 'Top' : 'Left');

        if (typeof ret !== 'number') {
          var d = w.document; // ie6,7,8 standard mode

          ret = d.documentElement[method];

          if (typeof ret !== 'number') {
            // quirks mode
            ret = d.body[method];
          }
        }

        return ret;
      }

      function utils_getScrollLeft(w) {
        return utils_getScroll(w);
      }

      function utils_getScrollTop(w) {
        return utils_getScroll(w, true);
      }

      function utils_getOffset(el) {
        var pos = utils_getClientPosition(el);
        var doc = el.ownerDocument;
        var w = doc.defaultView || doc.parentWindow;
        pos.left += utils_getScrollLeft(w);
        pos.top += utils_getScrollTop(w);
        return pos;
      }
      /**
       * A crude way of determining if an object is a window
       * @member util
       */


      function utils_isWindow(obj) {
        // must use == for ie8

        /* eslint eqeqeq:0 */
        return obj !== null && obj !== undefined && obj == obj.window;
      }

      function utils_getDocument(node) {
        if (utils_isWindow(node)) {
          return node.document;
        }

        if (node.nodeType === 9) {
          return node;
        }

        return node.ownerDocument;
      }

      function utils_getComputedStyle(elem, name, cs) {
        var computedStyle = cs;
        var val = '';
        var d = utils_getDocument(elem);
        computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

        if (computedStyle) {
          val = computedStyle.getPropertyValue(name) || computedStyle[name];
        }

        return val;
      }

      var utils_RE_NUM_NO_PX = new RegExp('^(' + utils_RE_NUM + ')(?!px)[a-z%]+$', 'i');
      var utils_RE_POS = /^(top|right|bottom|left)$/;
      var utils_CURRENT_STYLE = 'currentStyle';
      var utils_RUNTIME_STYLE = 'runtimeStyle';
      var utils_LEFT = 'left';
      var utils_PX = 'px';

      function utils_getComputedStyleIE(elem, name) {
        // currentStyle maybe null
        // http://msdn.microsoft.com/en-us/library/ms535231.aspx
        var ret = elem[utils_CURRENT_STYLE] && elem[utils_CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
        // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
        // 在 ie 下不对，需要直接用 offset 方式
        // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
        // From the awesome hack by Dean Edwards
        // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
        // If we're not dealing with a regular pixel number
        // but a number that has a weird ending, we need to convert it to pixels
        // exclude left right for relativity

        if (utils_RE_NUM_NO_PX.test(ret) && !utils_RE_POS.test(name)) {
          // Remember the original values
          var style = elem.style;
          var left = style[utils_LEFT];
          var rsLeft = elem[utils_RUNTIME_STYLE][utils_LEFT]; // prevent flashing of content

          elem[utils_RUNTIME_STYLE][utils_LEFT] = elem[utils_CURRENT_STYLE][utils_LEFT]; // Put in the new values to get a computed value out

          style[utils_LEFT] = name === 'fontSize' ? '1em' : ret || 0;
          ret = style.pixelLeft + utils_PX; // Revert the changed values

          style[utils_LEFT] = left;
          elem[utils_RUNTIME_STYLE][utils_LEFT] = rsLeft;
        }

        return ret === '' ? 'auto' : ret;
      }

      if (typeof window !== 'undefined') {
        utils_getComputedStyleX = window.getComputedStyle ? utils_getComputedStyle : utils_getComputedStyleIE;
      }

      function utils_getOffsetDirection(dir, option) {
        if (dir === 'left') {
          return option.useCssRight ? 'right' : dir;
        }

        return option.useCssBottom ? 'bottom' : dir;
      }

      function utils_oppositeOffsetDirection(dir) {
        if (dir === 'left') {
          return 'right';
        } else if (dir === 'right') {
          return 'left';
        } else if (dir === 'top') {
          return 'bottom';
        } else if (dir === 'bottom') {
          return 'top';
        }
      } // 设置 elem 相对 elem.ownerDocument 的坐标


      function utils_setLeftTop(elem, offset, option) {
        // set position first, in-case top/left are set even on static elem
        if (utils_css(elem, 'position') === 'static') {
          elem.style.position = 'relative';
        }

        var presetH = -999;
        var presetV = -999;
        var horizontalProperty = utils_getOffsetDirection('left', option);
        var verticalProperty = utils_getOffsetDirection('top', option);
        var oppositeHorizontalProperty = utils_oppositeOffsetDirection(horizontalProperty);
        var oppositeVerticalProperty = utils_oppositeOffsetDirection(verticalProperty);

        if (horizontalProperty !== 'left') {
          presetH = 999;
        }

        if (verticalProperty !== 'top') {
          presetV = 999;
        }

        var originalTransition = '';
        var originalOffset = utils_getOffset(elem);

        if ('left' in offset || 'top' in offset) {
          originalTransition = getTransitionProperty(elem) || '';
          setTransitionProperty(elem, 'none');
        }

        if ('left' in offset) {
          elem.style[oppositeHorizontalProperty] = '';
          elem.style[horizontalProperty] = presetH + 'px';
        }

        if ('top' in offset) {
          elem.style[oppositeVerticalProperty] = '';
          elem.style[verticalProperty] = presetV + 'px';
        } // force relayout


        utils_forceRelayout(elem);
        var old = utils_getOffset(elem);
        var originalStyle = {};

        for (var key in offset) {
          if (offset.hasOwnProperty(key)) {
            var dir = utils_getOffsetDirection(key, option);
            var preset = key === 'left' ? presetH : presetV;
            var off = originalOffset[key] - old[key];

            if (dir === key) {
              originalStyle[dir] = preset + off;
            } else {
              originalStyle[dir] = preset - off;
            }
          }
        }

        utils_css(elem, originalStyle); // force relayout

        utils_forceRelayout(elem);

        if ('left' in offset || 'top' in offset) {
          setTransitionProperty(elem, originalTransition);
        }

        var ret = {};

        for (var _key in offset) {
          if (offset.hasOwnProperty(_key)) {
            var _dir = utils_getOffsetDirection(_key, option);

            var _off = offset[_key] - originalOffset[_key];

            if (_key === _dir) {
              ret[_dir] = originalStyle[_dir] + _off;
            } else {
              ret[_dir] = originalStyle[_dir] - _off;
            }
          }
        }

        utils_css(elem, ret);
      }

      function utils_setTransform(elem, offset) {
        var originalOffset = utils_getOffset(elem);
        var originalXY = getTransformXY(elem);
        var resultXY = {
          x: originalXY.x,
          y: originalXY.y
        };

        if ('left' in offset) {
          resultXY.x = originalXY.x + offset.left - originalOffset.left;
        }

        if ('top' in offset) {
          resultXY.y = originalXY.y + offset.top - originalOffset.top;
        }

        setTransformXY(elem, resultXY);
      }

      function utils_setOffset(elem, offset, option) {
        if (option.ignoreShake) {
          var oriOffset = utils_getOffset(elem);
          var oLeft = oriOffset.left.toFixed(0);
          var oTop = oriOffset.top.toFixed(0);
          var tLeft = offset.left.toFixed(0);
          var tTop = offset.top.toFixed(0);

          if (oLeft === tLeft && oTop === tTop) {
            return;
          }
        }

        if (option.useCssRight || option.useCssBottom) {
          utils_setLeftTop(elem, offset, option);
        } else if (option.useCssTransform && getTransformName() in document.body.style) {
          utils_setTransform(elem, offset, option);
        } else {
          utils_setLeftTop(elem, offset, option);
        }
      }

      function utils_each(arr, fn) {
        for (var i = 0; i < arr.length; i++) {
          fn(arr[i]);
        }
      }

      function utils_isBorderBoxFn(elem) {
        return utils_getComputedStyleX(elem, 'boxSizing') === 'border-box';
      }

      var utils_BOX_MODELS = ['margin', 'border', 'padding'];
      var utils_CONTENT_INDEX = -1;
      var utils_PADDING_INDEX = 2;
      var utils_BORDER_INDEX = 1;
      var utils_MARGIN_INDEX = 0;

      function utils_swap(elem, options, callback) {
        var old = {};
        var style = elem.style;
        var name = void 0; // Remember the old values, and insert the new ones

        for (name in options) {
          if (options.hasOwnProperty(name)) {
            old[name] = style[name];
            style[name] = options[name];
          }
        }

        callback.call(elem); // Revert the old values

        for (name in options) {
          if (options.hasOwnProperty(name)) {
            style[name] = old[name];
          }
        }
      }

      function utils_getPBMWidth(elem, props, which) {
        var value = 0;
        var prop = void 0;
        var j = void 0;
        var i = void 0;

        for (j = 0; j < props.length; j++) {
          prop = props[j];

          if (prop) {
            for (i = 0; i < which.length; i++) {
              var cssProp = void 0;

              if (prop === 'border') {
                cssProp = '' + prop + which[i] + 'Width';
              } else {
                cssProp = prop + which[i];
              }

              value += parseFloat(utils_getComputedStyleX(elem, cssProp)) || 0;
            }
          }
        }

        return value;
      }

      var utils_domUtils = {};
      utils_each(['Width', 'Height'], function (name) {
        utils_domUtils['doc' + name] = function (refWin) {
          var d = refWin.document;
          return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
          // ie standard mode : documentElement.scrollHeight> body.scrollHeight
          d.documentElement['scroll' + name], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
          d.body['scroll' + name], utils_domUtils['viewport' + name](d));
        };

        utils_domUtils['viewport' + name] = function (win) {
          // pc browser includes scrollbar in window.innerWidth
          var prop = 'client' + name;
          var doc = win.document;
          var body = doc.body;
          var documentElement = doc.documentElement;
          var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
          // backcompat 取 body

          return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
        };
      });
      /*
       得到元素的大小信息
       @param elem
       @param name
       @param {String} [extra]  'padding' : (css width) + padding
       'border' : (css width) + padding + border
       'margin' : (css width) + padding + border + margin
       */

      function utils_getWH(elem, name, ex) {
        var extra = ex;

        if (utils_isWindow(elem)) {
          return name === 'width' ? utils_domUtils.viewportWidth(elem) : utils_domUtils.viewportHeight(elem);
        } else if (elem.nodeType === 9) {
          return name === 'width' ? utils_domUtils.docWidth(elem) : utils_domUtils.docHeight(elem);
        }

        var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
        var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
        var computedStyle = utils_getComputedStyleX(elem);
        var isBorderBox = utils_isBorderBoxFn(elem, computedStyle);
        var cssBoxValue = 0;

        if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
          borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

          cssBoxValue = utils_getComputedStyleX(elem, name);

          if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
            cssBoxValue = elem.style[name] || 0;
          } // Normalize '', auto, and prepare for extra


          cssBoxValue = parseFloat(cssBoxValue) || 0;
        }

        if (extra === undefined) {
          extra = isBorderBox ? utils_BORDER_INDEX : utils_CONTENT_INDEX;
        }

        var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
        var val = borderBoxValue || cssBoxValue;

        if (extra === utils_CONTENT_INDEX) {
          if (borderBoxValueOrIsBorderBox) {
            return val - utils_getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
          }

          return cssBoxValue;
        } else if (borderBoxValueOrIsBorderBox) {
          if (extra === utils_BORDER_INDEX) {
            return val;
          }

          return val + (extra === utils_PADDING_INDEX ? -utils_getPBMWidth(elem, ['border'], which, computedStyle) : utils_getPBMWidth(elem, ['margin'], which, computedStyle));
        }

        return cssBoxValue + utils_getPBMWidth(elem, utils_BOX_MODELS.slice(extra), which, computedStyle);
      }

      var utils_cssShow = {
        position: 'absolute',
        visibility: 'hidden',
        display: 'block'
      }; // fix #119 : https://github.com/kissyteam/kissy/issues/119

      function utils_getWHIgnoreDisplay() {
        for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var val = void 0;
        var elem = args[0]; // in case elem is window
        // elem.offsetWidth === undefined

        if (elem.offsetWidth !== 0) {
          val = utils_getWH.apply(undefined, args);
        } else {
          utils_swap(elem, utils_cssShow, function () {
            val = utils_getWH.apply(undefined, args);
          });
        }

        return val;
      }

      utils_each(['width', 'height'], function (name) {
        var first = name.charAt(0).toUpperCase() + name.slice(1);

        utils_domUtils['outer' + first] = function (el, includeMargin) {
          return el && utils_getWHIgnoreDisplay(el, name, includeMargin ? utils_MARGIN_INDEX : utils_BORDER_INDEX);
        };

        var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

        utils_domUtils[name] = function (elem, v) {
          var val = v;

          if (val !== undefined) {
            if (elem) {
              var computedStyle = utils_getComputedStyleX(elem);
              var isBorderBox = utils_isBorderBoxFn(elem);

              if (isBorderBox) {
                val += utils_getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
              }

              return utils_css(elem, name, val);
            }

            return undefined;
          }

          return elem && utils_getWHIgnoreDisplay(elem, name, utils_CONTENT_INDEX);
        };
      });

      function utils_mix(to, from) {
        for (var i in from) {
          if (from.hasOwnProperty(i)) {
            to[i] = from[i];
          }
        }

        return to;
      }

      var utils_utils = {
        getWindow: function getWindow(node) {
          if (node && node.document && node.setTimeout) {
            return node;
          }

          var doc = node.ownerDocument || node;
          return doc.defaultView || doc.parentWindow;
        },
        getDocument: utils_getDocument,
        offset: function offset(el, value, option) {
          if (typeof value !== 'undefined') {
            utils_setOffset(el, value, option || {});
          } else {
            return utils_getOffset(el);
          }
        },
        isWindow: utils_isWindow,
        each: utils_each,
        css: utils_css,
        clone: function clone(obj) {
          var i = void 0;
          var ret = {};

          for (i in obj) {
            if (obj.hasOwnProperty(i)) {
              ret[i] = obj[i];
            }
          }

          var overflow = obj.overflow;

          if (overflow) {
            for (i in obj) {
              if (obj.hasOwnProperty(i)) {
                ret.overflow[i] = obj.overflow[i];
              }
            }
          }

          return ret;
        },
        mix: utils_mix,
        getWindowScrollLeft: function getWindowScrollLeft(w) {
          return utils_getScrollLeft(w);
        },
        getWindowScrollTop: function getWindowScrollTop(w) {
          return utils_getScrollTop(w);
        },
        merge: function merge() {
          var ret = {};

          for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
            args[_key3] = arguments[_key3];
          }

          for (var i = 0; i < args.length; i++) {
            utils_utils.mix(ret, args[i]);
          }

          return ret;
        },
        viewportWidth: 0,
        viewportHeight: 0
      };
      utils_mix(utils_utils, utils_domUtils);
      /* harmony default export */

      var es_utils = utils_utils; // CONCATENATED MODULE: ./node_modules/dom-align/es/getOffsetParent.js

      /**
       * 得到会导致元素显示不全的祖先元素
       */

      function getOffsetParent_getOffsetParent(element) {
        if (es_utils.isWindow(element) || element.nodeType === 9) {
          return null;
        } // ie 这个也不是完全可行

        /*
         <div style="width: 50px;height: 100px;overflow: hidden">
         <div style="width: 50px;height: 100px;position: relative;" id="d6">
         元素 6 高 100px 宽 50px<br/>
         </div>
         </div>
         */
        // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
        //  In other browsers it only includes elements with position absolute, relative or
        // fixed, not elements with overflow set to auto or scroll.
        //        if (UA.ie && ieMode < 8) {
        //            return element.offsetParent;
        //        }
        // 统一的 offsetParent 方法


        var doc = es_utils.getDocument(element);
        var body = doc.body;
        var parent = void 0;
        var positionStyle = es_utils.css(element, 'position');
        var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

        if (!skipStatic) {
          return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
        }

        for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
          positionStyle = es_utils.css(parent, 'position');

          if (positionStyle !== 'static') {
            return parent;
          }
        }

        return null;
      }
      /* harmony default export */


      var es_getOffsetParent = getOffsetParent_getOffsetParent; // CONCATENATED MODULE: ./node_modules/dom-align/es/isAncestorFixed.js

      function isAncestorFixed_isAncestorFixed(element) {
        if (es_utils.isWindow(element) || element.nodeType === 9) {
          return false;
        }

        var doc = es_utils.getDocument(element);
        var body = doc.body;
        var parent = null;

        for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
          var positionStyle = es_utils.css(parent, 'position');

          if (positionStyle === 'fixed') {
            return true;
          }
        }

        return false;
      } // CONCATENATED MODULE: ./node_modules/dom-align/es/getVisibleRectForElement.js

      /**
       * 获得元素的显示部分的区域
       */


      function getVisibleRectForElement_getVisibleRectForElement(element) {
        var visibleRect = {
          left: 0,
          right: Infinity,
          top: 0,
          bottom: Infinity
        };
        var el = es_getOffsetParent(element);
        var doc = es_utils.getDocument(element);
        var win = doc.defaultView || doc.parentWindow;
        var body = doc.body;
        var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
        // all scrollable containers.

        while (el) {
          // clientWidth is zero for inline block elements in ie.
          if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
          // viewport. In some browsers, el.offsetParent may be
          // document.documentElement, so check for that too.
          el !== body && el !== documentElement && es_utils.css(el, 'overflow') !== 'visible') {
            var pos = es_utils.offset(el); // add border

            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
          } else if (el === body || el === documentElement) {
            break;
          }

          el = es_getOffsetParent(el);
        } // Set element position to fixed
        // make sure absolute element itself don't affect it's visible area
        // https://github.com/ant-design/ant-design/issues/7601


        var originalPosition = null;

        if (!es_utils.isWindow(element) && element.nodeType !== 9) {
          originalPosition = element.style.position;
          var position = es_utils.css(element, 'position');

          if (position === 'absolute') {
            element.style.position = 'fixed';
          }
        }

        var scrollX = es_utils.getWindowScrollLeft(win);
        var scrollY = es_utils.getWindowScrollTop(win);
        var viewportWidth = es_utils.viewportWidth(win);
        var viewportHeight = es_utils.viewportHeight(win);
        var documentWidth = documentElement.scrollWidth;
        var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
        // We should cut this ourself.

        var bodyStyle = window.getComputedStyle(body);

        if (bodyStyle.overflowX === 'hidden') {
          documentWidth = win.innerWidth;
        }

        if (bodyStyle.overflowY === 'hidden') {
          documentHeight = win.innerHeight;
        } // Reset element position after calculate the visible area


        if (element.style) {
          element.style.position = originalPosition;
        }

        if (isAncestorFixed_isAncestorFixed(element)) {
          // Clip by viewport's size.
          visibleRect.left = Math.max(visibleRect.left, scrollX);
          visibleRect.top = Math.max(visibleRect.top, scrollY);
          visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
          visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
        } else {
          // Clip by document's size.
          var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
          visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
          var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
          visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
        }

        return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
      }
      /* harmony default export */


      var es_getVisibleRectForElement = getVisibleRectForElement_getVisibleRectForElement; // CONCATENATED MODULE: ./node_modules/dom-align/es/adjustForViewport.js

      function adjustForViewport_adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
        var pos = es_utils.clone(elFuturePos);
        var size = {
          width: elRegion.width,
          height: elRegion.height
        };

        if (overflow.adjustX && pos.left < visibleRect.left) {
          pos.left = visibleRect.left;
        } // Left edge inside and right edge outside viewport, try to resize it.


        if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
          size.width -= pos.left + size.width - visibleRect.right;
        } // Right edge outside viewport, try to move it.


        if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
          // 保证左边界和可视区域左边界对齐
          pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
        } // Top edge outside viewport, try to move it.


        if (overflow.adjustY && pos.top < visibleRect.top) {
          pos.top = visibleRect.top;
        } // Top edge inside and bottom edge outside viewport, try to resize it.


        if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
          size.height -= pos.top + size.height - visibleRect.bottom;
        } // Bottom edge outside viewport, try to move it.


        if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
          // 保证上边界和可视区域上边界对齐
          pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
        }

        return es_utils.mix(pos, size);
      }
      /* harmony default export */


      var es_adjustForViewport = adjustForViewport_adjustForViewport; // CONCATENATED MODULE: ./node_modules/dom-align/es/getRegion.js

      function getRegion_getRegion(node) {
        var offset = void 0;
        var w = void 0;
        var h = void 0;

        if (!es_utils.isWindow(node) && node.nodeType !== 9) {
          offset = es_utils.offset(node);
          w = es_utils.outerWidth(node);
          h = es_utils.outerHeight(node);
        } else {
          var win = es_utils.getWindow(node);
          offset = {
            left: es_utils.getWindowScrollLeft(win),
            top: es_utils.getWindowScrollTop(win)
          };
          w = es_utils.viewportWidth(win);
          h = es_utils.viewportHeight(win);
        }

        offset.width = w;
        offset.height = h;
        return offset;
      }
      /* harmony default export */


      var es_getRegion = getRegion_getRegion; // CONCATENATED MODULE: ./node_modules/dom-align/es/getAlignOffset.js

      /**
       * 获取 node 上的 align 对齐点 相对于页面的坐标
       */

      function getAlignOffset(region, align) {
        var V = align.charAt(0);
        var H = align.charAt(1);
        var w = region.width;
        var h = region.height;
        var x = region.left;
        var y = region.top;

        if (V === 'c') {
          y += h / 2;
        } else if (V === 'b') {
          y += h;
        }

        if (H === 'c') {
          x += w / 2;
        } else if (H === 'r') {
          x += w;
        }

        return {
          left: x,
          top: y
        };
      }
      /* harmony default export */


      var es_getAlignOffset = getAlignOffset; // CONCATENATED MODULE: ./node_modules/dom-align/es/getElFuturePos.js

      function getElFuturePos_getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
        var p1 = es_getAlignOffset(refNodeRegion, points[1]);
        var p2 = es_getAlignOffset(elRegion, points[0]);
        var diff = [p2.left - p1.left, p2.top - p1.top];
        return {
          left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
          top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
        };
      }
      /* harmony default export */


      var es_getElFuturePos = getElFuturePos_getElFuturePos; // CONCATENATED MODULE: ./node_modules/dom-align/es/align/align.js

      /**
       * align dom node flexibly
       * @author yiminghe@gmail.com
       */
      // http://yiminghe.iteye.com/blog/1124720

      function align_isFailX(elFuturePos, elRegion, visibleRect) {
        return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
      }

      function align_isFailY(elFuturePos, elRegion, visibleRect) {
        return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
      }

      function align_isCompleteFailX(elFuturePos, elRegion, visibleRect) {
        return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
      }

      function align_isCompleteFailY(elFuturePos, elRegion, visibleRect) {
        return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
      }

      function align_flip(points, reg, map) {
        var ret = [];
        es_utils.each(points, function (p) {
          ret.push(p.replace(reg, function (m) {
            return map[m];
          }));
        });
        return ret;
      }

      function align_flipOffset(offset, index) {
        offset[index] = -offset[index];
        return offset;
      }

      function align_convertOffset(str, offsetLen) {
        var n = void 0;

        if (/%$/.test(str)) {
          n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
        } else {
          n = parseInt(str, 10);
        }

        return n || 0;
      }

      function align_normalizeOffset(offset, el) {
        offset[0] = align_convertOffset(offset[0], el.width);
        offset[1] = align_convertOffset(offset[1], el.height);
      }
      /**
       * @param el
       * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
       * @param align
       */


      function align_doAlign(el, tgtRegion, align, isTgtRegionVisible) {
        var points = align.points;
        var offset = align.offset || [0, 0];
        var targetOffset = align.targetOffset || [0, 0];
        var overflow = align.overflow;
        var source = align.source || el;
        offset = [].concat(offset);
        targetOffset = [].concat(targetOffset);
        overflow = overflow || {};
        var newOverflowCfg = {};
        var fail = 0; // 当前节点可以被放置的显示区域

        var visibleRect = es_getVisibleRectForElement(source); // 当前节点所占的区域, left/top/width/height

        var elRegion = es_getRegion(source); // 将 offset 转换成数值，支持百分比

        align_normalizeOffset(offset, elRegion);
        align_normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

        var elFuturePos = es_getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

        var newElRegion = es_utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

        if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
          if (overflow.adjustX) {
            // 如果横向不能放下
            if (align_isFailX(elFuturePos, elRegion, visibleRect)) {
              // 对齐位置反下
              var newPoints = align_flip(points, /[lr]/ig, {
                l: 'r',
                r: 'l'
              }); // 偏移量也反下

              var newOffset = align_flipOffset(offset, 0);
              var newTargetOffset = align_flipOffset(targetOffset, 0);
              var newElFuturePos = es_getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

              if (!align_isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                fail = 1;
                points = newPoints;
                offset = newOffset;
                targetOffset = newTargetOffset;
              }
            }
          }

          if (overflow.adjustY) {
            // 如果纵向不能放下
            if (align_isFailY(elFuturePos, elRegion, visibleRect)) {
              // 对齐位置反下
              var _newPoints = align_flip(points, /[tb]/ig, {
                t: 'b',
                b: 't'
              }); // 偏移量也反下


              var _newOffset = align_flipOffset(offset, 1);

              var _newTargetOffset = align_flipOffset(targetOffset, 1);

              var _newElFuturePos = es_getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

              if (!align_isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                fail = 1;
                points = _newPoints;
                offset = _newOffset;
                targetOffset = _newTargetOffset;
              }
            }
          } // 如果失败，重新计算当前节点将要被放置的位置


          if (fail) {
            elFuturePos = es_getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            es_utils.mix(newElRegion, elFuturePos);
          }

          var isStillFailX = align_isFailX(elFuturePos, elRegion, visibleRect);
          var isStillFailY = align_isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
          // 1. 复原修改过的定位参数

          if (isStillFailX || isStillFailY) {
            points = align.points;
            offset = align.offset || [0, 0];
            targetOffset = align.targetOffset || [0, 0];
          } // 2. 只有指定了可以调整当前方向才调整


          newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
          newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

          if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
            newElRegion = es_adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
          }
        } // need judge to in case set fixed with in css on height auto element


        if (newElRegion.width !== elRegion.width) {
          es_utils.css(source, 'width', es_utils.width(source) + newElRegion.width - elRegion.width);
        }

        if (newElRegion.height !== elRegion.height) {
          es_utils.css(source, 'height', es_utils.height(source) + newElRegion.height - elRegion.height);
        } // https://github.com/kissyteam/kissy/issues/190
        // 相对于屏幕位置没变，而 left/top 变了
        // 例如 <div 'relative'><el absolute></div>


        es_utils.offset(source, {
          left: newElRegion.left,
          top: newElRegion.top
        }, {
          useCssRight: align.useCssRight,
          useCssBottom: align.useCssBottom,
          useCssTransform: align.useCssTransform,
          ignoreShake: align.ignoreShake
        });
        return {
          points: points,
          offset: offset,
          targetOffset: targetOffset,
          overflow: newOverflowCfg
        };
      }
      /* harmony default export */


      var align_align = align_doAlign;
      /**
       *  2012-04-26 yiminghe@gmail.com
       *   - 优化智能对齐算法
       *   - 慎用 resizeXX
       *
       *  2011-07-13 yiminghe@gmail.com note:
       *   - 增加智能对齐，以及大小调整选项
       **/
      // CONCATENATED MODULE: ./node_modules/dom-align/es/align/alignElement.js

      function alignElement_isOutOfVisibleRect(target) {
        var visibleRect = es_getVisibleRectForElement(target);
        var targetRegion = es_getRegion(target);
        return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
      }

      function alignElement_alignElement(el, refNode, align) {
        var target = align.target || refNode;
        var refNodeRegion = es_getRegion(target);
        var isTargetNotOutOfVisible = !alignElement_isOutOfVisibleRect(target);
        return align_align(el, refNodeRegion, align, isTargetNotOutOfVisible);
      }

      alignElement_alignElement.__getOffsetParent = es_getOffsetParent;
      alignElement_alignElement.__getVisibleRectForElement = es_getVisibleRectForElement;
      /* harmony default export */

      var align_alignElement = alignElement_alignElement; // CONCATENATED MODULE: ./node_modules/dom-align/es/align/alignPoint.js

      var alignPoint_extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };
      /**
       * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
       * If client position provided, will internal convert to page position.
       */


      function alignPoint_alignPoint(el, tgtPoint, align) {
        var pageX = void 0;
        var pageY = void 0;
        var doc = es_utils.getDocument(el);
        var win = doc.defaultView || doc.parentWindow;
        var scrollX = es_utils.getWindowScrollLeft(win);
        var scrollY = es_utils.getWindowScrollTop(win);
        var viewportWidth = es_utils.viewportWidth(win);
        var viewportHeight = es_utils.viewportHeight(win);

        if ('pageX' in tgtPoint) {
          pageX = tgtPoint.pageX;
        } else {
          pageX = scrollX + tgtPoint.clientX;
        }

        if ('pageY' in tgtPoint) {
          pageY = tgtPoint.pageY;
        } else {
          pageY = scrollY + tgtPoint.clientY;
        }

        var tgtRegion = {
          left: pageX,
          top: pageY,
          width: 0,
          height: 0
        };
        var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

        var points = [align.points[0], 'cc'];
        return align_align(el, tgtRegion, alignPoint_extends({}, align, {
          points: points
        }), pointInView);
      }
      /* harmony default export */


      var align_alignPoint = alignPoint_alignPoint; // CONCATENATED MODULE: ./node_modules/dom-align/es/index.js

      /* harmony default export */

      var es = align_alignElement; // CONCATENATED MODULE: ./node_modules/rc-align/es/util.js

      function util_buffer(fn, ms) {
        var timer = void 0;

        function clear() {
          if (timer) {
            clearTimeout(timer);
            timer = null;
          }
        }

        function bufferFn() {
          clear();
          timer = setTimeout(fn, ms);
        }

        bufferFn.clear = clear;
        return bufferFn;
      }

      function util_isSamePoint(prev, next) {
        if (prev === next) return true;
        if (!prev || !next) return false;

        if ('pageX' in next && 'pageY' in next) {
          return prev.pageX === next.pageX && prev.pageY === next.pageY;
        }

        if ('clientX' in next && 'clientY' in next) {
          return prev.clientX === next.clientX && prev.clientY === next.clientY;
        }

        return false;
      }

      function util_isWindow(obj) {
        return obj && typeof obj === 'object' && obj.window === obj;
      }

      function util_isSimilarValue(val1, val2) {
        var int1 = Math.floor(val1);
        var int2 = Math.floor(val2);
        return Math.abs(int1 - int2) <= 1;
      }

      function util_restoreFocus(activeElement, container) {
        // Focus back if is in the container
        if (activeElement !== document.activeElement && Object(contains["a"
        /* default */
        ])(container, activeElement)) {
          activeElement.focus();
        }
      } // CONCATENATED MODULE: ./node_modules/rc-align/es/Align.js


      function Align_getElement(func) {
        if (typeof func !== 'function' || !func) return null;
        return func();
      }

      function Align_getPoint(point) {
        if (typeof point !== 'object' || !point) return null;
        return point;
      }

      var Align_Align = function (_Component) {
        inherits_default()(Align, _Component);

        function Align() {
          var _ref;

          var _temp, _this, _ret;

          classCallCheck_default()(this, Align);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
            var _this$props = _this.props,
                disabled = _this$props.disabled,
                target = _this$props.target,
                align = _this$props.align,
                onAlign = _this$props.onAlign;

            if (!disabled && target) {
              var source = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(_this);
              var result = void 0;
              var element = Align_getElement(target);
              var point = Align_getPoint(target); // IE lose focus after element realign
              // We should record activeElement and restore later

              var activeElement = document.activeElement;

              if (element) {
                result = align_alignElement(source, element, align);
              } else if (point) {
                result = align_alignPoint(source, point, align);
              }

              util_restoreFocus(activeElement, source);

              if (onAlign) {
                onAlign(source, result);
              }
            }
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        createClass_default()(Align, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var props = this.props; // if parent ref not attached .... use document.getElementById

            this.forceAlign();

            if (!props.disabled && props.monitorWindowResize) {
              this.startMonitorWindowResize();
            }
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate(prevProps) {
            var reAlign = false;
            var props = this.props;

            if (!props.disabled) {
              var source = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this);
              var sourceRect = source ? source.getBoundingClientRect() : null;

              if (prevProps.disabled) {
                reAlign = true;
              } else {
                var lastElement = Align_getElement(prevProps.target);
                var currentElement = Align_getElement(props.target);
                var lastPoint = Align_getPoint(prevProps.target);
                var currentPoint = Align_getPoint(props.target);

                if (util_isWindow(lastElement) && util_isWindow(currentElement)) {
                  // Skip if is window
                  reAlign = false;
                } else if (lastElement !== currentElement || // Element change
                lastElement && !currentElement && currentPoint || // Change from element to point
                lastPoint && currentPoint && currentElement || // Change from point to element
                currentPoint && !util_isSamePoint(lastPoint, currentPoint)) {
                  reAlign = true;
                } // If source element size changed


                var preRect = this.sourceRect || {};

                if (!reAlign && source && (!util_isSimilarValue(preRect.width, sourceRect.width) || !util_isSimilarValue(preRect.height, sourceRect.height))) {
                  reAlign = true;
                }
              }

              this.sourceRect = sourceRect;
            }

            if (reAlign) {
              this.forceAlign();
            }

            if (props.monitorWindowResize && !props.disabled) {
              this.startMonitorWindowResize();
            } else {
              this.stopMonitorWindowResize();
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this.stopMonitorWindowResize();
          }
        }, {
          key: 'startMonitorWindowResize',
          value: function startMonitorWindowResize() {
            if (!this.resizeHandler) {
              this.bufferMonitor = util_buffer(this.forceAlign, this.props.monitorBufferTime);
              this.resizeHandler = Object(addEventListener["a"
              /* default */
              ])(window, 'resize', this.bufferMonitor);
            }
          }
        }, {
          key: 'stopMonitorWindowResize',
          value: function stopMonitorWindowResize() {
            if (this.resizeHandler) {
              this.bufferMonitor.clear();
              this.resizeHandler.remove();
              this.resizeHandler = null;
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this;

            var _props = this.props,
                childrenProps = _props.childrenProps,
                children = _props.children;
            var child = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.only(children);

            if (childrenProps) {
              var newProps = {};
              var propList = Object.keys(childrenProps);
              propList.forEach(function (prop) {
                newProps[prop] = _this2.props[childrenProps[prop]];
              });
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(child, newProps);
            }

            return child;
          }
        }]);
        return Align;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Align_Align.propTypes = {
        childrenProps: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        align: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        target: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          clientX: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          clientY: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          pageX: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          pageY: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
        })]),
        onAlign: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        monitorBufferTime: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        monitorWindowResize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      Align_Align.defaultProps = {
        target: function target() {
          return window;
        },
        monitorBufferTime: 50,
        monitorWindowResize: false,
        disabled: false
      };
      /* harmony default export */

      var es_Align = Align_Align; // CONCATENATED MODULE: ./node_modules/rc-align/es/index.js
      // export this package's api

      /* harmony default export */

      var rc_align_es = es_Align; // EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 3 modules

      var Animate = __webpack_require__(43); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js


      var objectWithoutProperties = __webpack_require__(42);

      var objectWithoutProperties_default =
      /*#__PURE__*/
      __webpack_require__.n(objectWithoutProperties); // CONCATENATED MODULE: ./node_modules/rc-trigger/es/LazyRenderBox.js


      var LazyRenderBox_LazyRenderBox = function (_Component) {
        inherits_default()(LazyRenderBox, _Component);

        function LazyRenderBox() {
          classCallCheck_default()(this, LazyRenderBox);
          return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
        }

        LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          return nextProps.hiddenClassName || nextProps.visible;
        };

        LazyRenderBox.prototype.render = function render() {
          var _props = this.props,
              hiddenClassName = _props.hiddenClassName,
              visible = _props.visible,
              props = objectWithoutProperties_default()(_props, ['hiddenClassName', 'visible']);

          if (hiddenClassName || external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.count(props.children) > 1) {
            if (!visible && hiddenClassName) {
              props.className += ' ' + hiddenClassName;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', props);
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.only(props.children);
        };

        return LazyRenderBox;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      LazyRenderBox_LazyRenderBox.propTypes = {
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        hiddenClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var es_LazyRenderBox = LazyRenderBox_LazyRenderBox; // CONCATENATED MODULE: ./node_modules/rc-trigger/es/PopupInner.js

      var PopupInner_PopupInner = function (_Component) {
        inherits_default()(PopupInner, _Component);

        function PopupInner() {
          classCallCheck_default()(this, PopupInner);
          return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
        }

        PopupInner.prototype.render = function render() {
          var props = this.props;
          var className = props.className;

          if (!props.visible) {
            className += ' ' + props.hiddenClassName;
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: className,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            onMouseDown: props.onMouseDown,
            onTouchStart: props.onTouchStart,
            style: props.style
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_LazyRenderBox, {
            className: props.prefixCls + '-content',
            visible: props.visible
          }, props.children));
        };

        return PopupInner;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      PopupInner_PopupInner.propTypes = {
        hiddenClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onTouchStart: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      /* harmony default export */

      var es_PopupInner = PopupInner_PopupInner; // CONCATENATED MODULE: ./node_modules/rc-trigger/es/Popup.js

      var Popup_Popup = function (_Component) {
        inherits_default()(Popup, _Component);

        function Popup(props) {
          classCallCheck_default()(this, Popup);

          var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

          Popup_initialiseProps.call(_this);
          _this.state = {
            // Used for stretch
            stretchChecked: false,
            targetWidth: undefined,
            targetHeight: undefined
          };
          _this.savePopupRef = utils_saveRef.bind(_this, 'popupInstance');
          _this.saveAlignRef = utils_saveRef.bind(_this, 'alignInstance');
          return _this;
        }

        Popup.prototype.componentDidMount = function componentDidMount() {
          this.rootNode = this.getPopupDomNode();
          this.setStretchSize();
        };

        Popup.prototype.componentDidUpdate = function componentDidUpdate() {
          this.setStretchSize();
        }; // Record size if stretch needed


        Popup.prototype.getPopupDomNode = function getPopupDomNode() {
          return external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this.popupInstance);
        }; // `target` on `rc-align` can accept as a function to get the bind element or a point.
        // ref: https://www.npmjs.com/package/rc-align


        Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
          var props = this.props;
          var transitionName = props.maskTransitionName;
          var animation = props.maskAnimation;

          if (!transitionName && animation) {
            transitionName = props.prefixCls + '-' + animation;
          }

          return transitionName;
        };

        Popup.prototype.getTransitionName = function getTransitionName() {
          var props = this.props;
          var transitionName = props.transitionName;

          if (!transitionName && props.animation) {
            transitionName = props.prefixCls + '-' + props.animation;
          }

          return transitionName;
        };

        Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
          return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
        };

        Popup.prototype.getPopupElement = function getPopupElement() {
          var _this2 = this;

          var savePopupRef = this.savePopupRef;
          var _state = this.state,
              stretchChecked = _state.stretchChecked,
              targetHeight = _state.targetHeight,
              targetWidth = _state.targetWidth;
          var _props = this.props,
              align = _props.align,
              visible = _props.visible,
              prefixCls = _props.prefixCls,
              style = _props.style,
              getClassNameFromAlign = _props.getClassNameFromAlign,
              destroyPopupOnHide = _props.destroyPopupOnHide,
              stretch = _props.stretch,
              children = _props.children,
              onMouseEnter = _props.onMouseEnter,
              onMouseLeave = _props.onMouseLeave,
              onMouseDown = _props.onMouseDown,
              onTouchStart = _props.onTouchStart;
          var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
          var hiddenClassName = prefixCls + '-hidden';

          if (!visible) {
            this.currentAlignClassName = null;
          }

          var sizeStyle = {};

          if (stretch) {
            // Stretch with target
            if (stretch.indexOf('height') !== -1) {
              sizeStyle.height = targetHeight;
            } else if (stretch.indexOf('minHeight') !== -1) {
              sizeStyle.minHeight = targetHeight;
            }

            if (stretch.indexOf('width') !== -1) {
              sizeStyle.width = targetWidth;
            } else if (stretch.indexOf('minWidth') !== -1) {
              sizeStyle.minWidth = targetWidth;
            } // Delay force align to makes ui smooth


            if (!stretchChecked) {
              sizeStyle.visibility = 'hidden';
              setTimeout(function () {
                if (_this2.alignInstance) {
                  _this2.alignInstance.forceAlign();
                }
              }, 0);
            }
          }

          var newStyle = extends_default()({}, sizeStyle, style, this.getZIndexStyle());
          var popupInnerProps = {
            className: className,
            prefixCls: prefixCls,
            ref: savePopupRef,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDown: onMouseDown,
            onTouchStart: onTouchStart,
            style: newStyle
          };

          if (destroyPopupOnHide) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], {
              component: '',
              exclusive: true,
              transitionAppear: true,
              transitionName: this.getTransitionName()
            }, visible ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_align_es, {
              target: this.getAlignTarget(),
              key: 'popup',
              ref: this.saveAlignRef,
              monitorWindowResize: true,
              align: align,
              onAlign: this.onAlign
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_PopupInner, extends_default()({
              visible: true
            }, popupInnerProps), children)) : null);
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], {
            component: '',
            exclusive: true,
            transitionAppear: true,
            transitionName: this.getTransitionName(),
            showProp: 'xVisible'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_align_es, {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            xVisible: visible,
            childrenProps: {
              visible: 'xVisible'
            },
            disabled: !visible,
            align: align,
            onAlign: this.onAlign
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_PopupInner, extends_default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps), children)));
        };

        Popup.prototype.getZIndexStyle = function getZIndexStyle() {
          var style = {};
          var props = this.props;

          if (props.zIndex !== undefined) {
            style.zIndex = props.zIndex;
          }

          return style;
        };

        Popup.prototype.getMaskElement = function getMaskElement() {
          var props = this.props;
          var maskElement = void 0;

          if (props.mask) {
            var maskTransition = this.getMaskTransitionName();
            maskElement = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_LazyRenderBox, {
              style: this.getZIndexStyle(),
              key: 'mask',
              className: props.prefixCls + '-mask',
              hiddenClassName: props.prefixCls + '-mask-hidden',
              visible: props.visible
            });

            if (maskTransition) {
              maskElement = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], {
                key: 'mask',
                showProp: 'visible',
                transitionAppear: true,
                component: '',
                transitionName: maskTransition
              }, maskElement);
            }
          }

          return maskElement;
        };

        Popup.prototype.render = function render() {
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', null, this.getMaskElement(), this.getPopupElement());
        };

        return Popup;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Popup_Popup.propTypes = {
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        getClassNameFromAlign: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onAlign: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        getRootDomNode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        align: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        destroyPopupOnHide: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onTouchStart: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        stretch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        point: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          pageX: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          pageY: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
        })
      };

      var Popup_initialiseProps = function _initialiseProps() {
        var _this3 = this;

        this.onAlign = function (popupDomNode, align) {
          var props = _this3.props;
          var currentAlignClassName = props.getClassNameFromAlign(align); // FIX: https://github.com/react-component/trigger/issues/56
          // FIX: https://github.com/react-component/tooltip/issues/79

          if (_this3.currentAlignClassName !== currentAlignClassName) {
            _this3.currentAlignClassName = currentAlignClassName;
            popupDomNode.className = _this3.getClassName(currentAlignClassName);
          }

          props.onAlign(popupDomNode, align);
        };

        this.setStretchSize = function () {
          var _props2 = _this3.props,
              stretch = _props2.stretch,
              getRootDomNode = _props2.getRootDomNode,
              visible = _props2.visible;
          var _state2 = _this3.state,
              stretchChecked = _state2.stretchChecked,
              targetHeight = _state2.targetHeight,
              targetWidth = _state2.targetWidth;

          if (!stretch || !visible) {
            if (stretchChecked) {
              _this3.setState({
                stretchChecked: false
              });
            }

            return;
          }

          var $ele = getRootDomNode();
          if (!$ele) return;
          var height = $ele.offsetHeight;
          var width = $ele.offsetWidth;

          if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
            _this3.setState({
              stretchChecked: true,
              targetHeight: height,
              targetWidth: width
            });
          }
        };

        this.getTargetElement = function () {
          return _this3.props.getRootDomNode();
        };

        this.getAlignTarget = function () {
          var point = _this3.props.point;

          if (point) {
            return point;
          }

          return _this3.getTargetElement;
        };
      };
      /* harmony default export */


      var es_Popup = Popup_Popup; // CONCATENATED MODULE: ./node_modules/rc-trigger/es/index.js

      function es_noop() {}

      function es_returnEmptyString() {
        return '';
      }

      function es_returnDocument() {
        return window.document;
      }

      var es_ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
      var es_IS_REACT_16 = !!external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["createPortal"];
      var es_contextTypes = {
        rcTrigger: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          onPopupMouseDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        })
      };

      var es_Trigger = function (_React$Component) {
        inherits_default()(Trigger, _React$Component);

        function Trigger(props) {
          classCallCheck_default()(this, Trigger);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          es_initialiseProps.call(_this);
          var popupVisible = void 0;

          if ('popupVisible' in props) {
            popupVisible = !!props.popupVisible;
          } else {
            popupVisible = !!props.defaultPopupVisible;
          }

          _this.prevPopupVisible = popupVisible;
          _this.state = {
            popupVisible: popupVisible
          };
          return _this;
        }

        Trigger.prototype.getChildContext = function getChildContext() {
          return {
            rcTrigger: {
              onPopupMouseDown: this.onPopupMouseDown
            }
          };
        };

        Trigger.prototype.componentWillMount = function componentWillMount() {
          var _this2 = this;

          es_ALL_HANDLERS.forEach(function (h) {
            _this2['fire' + h] = function (e) {
              _this2.fireEvents(h, e);
            };
          });
        };

        Trigger.prototype.componentDidMount = function componentDidMount() {
          this.componentDidUpdate({}, {
            popupVisible: this.state.popupVisible
          });
        };

        Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
          var popupVisible = _ref.popupVisible;

          if (popupVisible !== undefined) {
            this.setState({
              popupVisible: popupVisible
            });
          }
        };

        Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
          var props = this.props;
          var state = this.state;

          var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
            if (prevState.popupVisible !== state.popupVisible) {
              props.afterPopupVisibleChange(state.popupVisible);
            }
          };

          if (!es_IS_REACT_16) {
            this.renderComponent(null, triggerAfterPopupVisibleChange);
          }

          this.prevPopupVisible = prevState.popupVisible; // We must listen to `mousedown` or `touchstart`, edge case:
          // https://github.com/ant-design/ant-design/issues/5804
          // https://github.com/react-component/calendar/issues/250
          // https://github.com/react-component/trigger/issues/50

          if (state.popupVisible) {
            var currentDocument = void 0;

            if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
              currentDocument = props.getDocument();
              this.clickOutsideHandler = Object(addEventListener["a"
              /* default */
              ])(currentDocument, 'mousedown', this.onDocumentClick);
            } // always hide on mobile


            if (!this.touchOutsideHandler) {
              currentDocument = currentDocument || props.getDocument();
              this.touchOutsideHandler = Object(addEventListener["a"
              /* default */
              ])(currentDocument, 'touchstart', this.onDocumentClick);
            } // close popup when trigger type contains 'onContextMenu' and document is scrolling.


            if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
              currentDocument = currentDocument || props.getDocument();
              this.contextMenuOutsideHandler1 = Object(addEventListener["a"
              /* default */
              ])(currentDocument, 'scroll', this.onContextMenuClose);
            } // close popup when trigger type contains 'onContextMenu' and window is blur.


            if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
              this.contextMenuOutsideHandler2 = Object(addEventListener["a"
              /* default */
              ])(window, 'blur', this.onContextMenuClose);
            }

            return;
          }

          this.clearOutsideHandler();
        };

        Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
          this.clearDelayTimer();
          this.clearOutsideHandler();
          clearTimeout(this.mouseDownTimeout);
        };

        Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
          // for test
          if (this._component && this._component.getPopupDomNode) {
            return this._component.getPopupDomNode();
          }

          return null;
        };

        Trigger.prototype.getPopupAlign = function getPopupAlign() {
          var props = this.props;
          var popupPlacement = props.popupPlacement,
              popupAlign = props.popupAlign,
              builtinPlacements = props.builtinPlacements;

          if (popupPlacement && builtinPlacements) {
            return utils_getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
          }

          return popupAlign;
        };
        /**
         * @param popupVisible    Show or not the popup element
         * @param event           SyntheticEvent, used for `pointAlign`
         */


        Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
          var alignPoint = this.props.alignPoint;
          this.clearDelayTimer();

          if (this.state.popupVisible !== popupVisible) {
            if (!('popupVisible' in this.props)) {
              this.setState({
                popupVisible: popupVisible
              });
            }

            this.props.onPopupVisibleChange(popupVisible);
          } // Always record the point position since mouseEnterDelay will delay the show


          if (alignPoint && event) {
            this.setPoint(event);
          }
        };

        Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
          var _this3 = this;

          var delay = delayS * 1000;
          this.clearDelayTimer();

          if (delay) {
            var point = event ? {
              pageX: event.pageX,
              pageY: event.pageY
            } : null;
            this.delayTimer = setTimeout(function () {
              _this3.setPopupVisible(visible, point);

              _this3.clearDelayTimer();
            }, delay);
          } else {
            this.setPopupVisible(visible, event);
          }
        };

        Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
          if (this.delayTimer) {
            clearTimeout(this.delayTimer);
            this.delayTimer = null;
          }
        };

        Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
          if (this.clickOutsideHandler) {
            this.clickOutsideHandler.remove();
            this.clickOutsideHandler = null;
          }

          if (this.contextMenuOutsideHandler1) {
            this.contextMenuOutsideHandler1.remove();
            this.contextMenuOutsideHandler1 = null;
          }

          if (this.contextMenuOutsideHandler2) {
            this.contextMenuOutsideHandler2.remove();
            this.contextMenuOutsideHandler2 = null;
          }

          if (this.touchOutsideHandler) {
            this.touchOutsideHandler.remove();
            this.touchOutsideHandler = null;
          }
        };

        Trigger.prototype.createTwoChains = function createTwoChains(event) {
          var childPros = this.props.children.props;
          var props = this.props;

          if (childPros[event] && props[event]) {
            return this['fire' + event];
          }

          return childPros[event] || props[event];
        };

        Trigger.prototype.isClickToShow = function isClickToShow() {
          var _props = this.props,
              action = _props.action,
              showAction = _props.showAction;
          return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
        };

        Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
          var _props2 = this.props,
              action = _props2.action,
              showAction = _props2.showAction;
          return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
        };

        Trigger.prototype.isClickToHide = function isClickToHide() {
          var _props3 = this.props,
              action = _props3.action,
              hideAction = _props3.hideAction;
          return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
        };

        Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
          var _props4 = this.props,
              action = _props4.action,
              showAction = _props4.showAction;
          return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
        };

        Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
          var _props5 = this.props,
              action = _props5.action,
              hideAction = _props5.hideAction;
          return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
        };

        Trigger.prototype.isFocusToShow = function isFocusToShow() {
          var _props6 = this.props,
              action = _props6.action,
              showAction = _props6.showAction;
          return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
        };

        Trigger.prototype.isBlurToHide = function isBlurToHide() {
          var _props7 = this.props,
              action = _props7.action,
              hideAction = _props7.hideAction;
          return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
        };

        Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
          if (this.state.popupVisible && this._component && this._component.alignInstance) {
            this._component.alignInstance.forceAlign();
          }
        };

        Trigger.prototype.fireEvents = function fireEvents(type, e) {
          var childCallback = this.props.children.props[type];

          if (childCallback) {
            childCallback(e);
          }

          var callback = this.props[type];

          if (callback) {
            callback(e);
          }
        };

        Trigger.prototype.close = function close() {
          this.setPopupVisible(false);
        };

        Trigger.prototype.render = function render() {
          var _this4 = this;

          var popupVisible = this.state.popupVisible;
          var _props8 = this.props,
              children = _props8.children,
              forceRender = _props8.forceRender,
              alignPoint = _props8.alignPoint,
              className = _props8.className;
          var child = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.only(children);
          var newChildProps = {
            key: 'trigger'
          };

          if (this.isContextMenuToShow()) {
            newChildProps.onContextMenu = this.onContextMenu;
          } else {
            newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
          }

          if (this.isClickToHide() || this.isClickToShow()) {
            newChildProps.onClick = this.onClick;
            newChildProps.onMouseDown = this.onMouseDown;
            newChildProps.onTouchStart = this.onTouchStart;
          } else {
            newChildProps.onClick = this.createTwoChains('onClick');
            newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
            newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
          }

          if (this.isMouseEnterToShow()) {
            newChildProps.onMouseEnter = this.onMouseEnter;

            if (alignPoint) {
              newChildProps.onMouseMove = this.onMouseMove;
            }
          } else {
            newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
          }

          if (this.isMouseLeaveToHide()) {
            newChildProps.onMouseLeave = this.onMouseLeave;
          } else {
            newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
          }

          if (this.isFocusToShow() || this.isBlurToHide()) {
            newChildProps.onFocus = this.onFocus;
            newChildProps.onBlur = this.onBlur;
          } else {
            newChildProps.onFocus = this.createTwoChains('onFocus');
            newChildProps.onBlur = this.createTwoChains('onBlur');
          }

          var childrenClassName = classnames_default()(child && child.props && child.props.className, className);

          if (childrenClassName) {
            newChildProps.className = childrenClassName;
          }

          var trigger = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(child, newChildProps);

          if (!es_IS_REACT_16) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ContainerRender["a"
            /* default */
            ], {
              parent: this,
              visible: popupVisible,
              autoMount: false,
              forceRender: forceRender,
              getComponent: this.getComponent,
              getContainer: this.getContainer
            }, function (_ref2) {
              var renderComponent = _ref2.renderComponent;
              _this4.renderComponent = renderComponent;
              return trigger;
            });
          }

          var portal = void 0; // prevent unmounting after it's rendered

          if (popupVisible || this._component || forceRender) {
            portal = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Portal["a"
            /* default */
            ], {
              key: 'portal',
              getContainer: this.getContainer,
              didUpdate: this.handlePortalUpdate
            }, this.getComponent());
          }

          return [trigger, portal];
        };

        return Trigger;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      es_Trigger.propTypes = {
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        action: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string)]),
        showAction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        hideAction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        getPopupClassNameFromAlign: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        onPopupVisibleChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        afterPopupVisibleChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        popup: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]).isRequired,
        popupStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        popupClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        popupPlacement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        builtinPlacements: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        popupTransitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        popupAnimation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        mouseEnterDelay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        mouseLeaveDelay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        zIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        focusDelay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        blurDelay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        getPopupContainer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        getDocument: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        forceRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        destroyPopupOnHide: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        mask: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        maskClosable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onPopupAlign: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        popupAlign: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        popupVisible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultPopupVisible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        maskTransitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        maskAnimation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        stretch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        alignPoint: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool // Maybe we can support user pass position in the future

      };
      es_Trigger.contextTypes = es_contextTypes;
      es_Trigger.childContextTypes = es_contextTypes;
      es_Trigger.defaultProps = {
        prefixCls: 'rc-trigger-popup',
        getPopupClassNameFromAlign: es_returnEmptyString,
        getDocument: es_returnDocument,
        onPopupVisibleChange: es_noop,
        afterPopupVisibleChange: es_noop,
        onPopupAlign: es_noop,
        popupClassName: '',
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: []
      };

      var es_initialiseProps = function _initialiseProps() {
        var _this5 = this;

        this.onMouseEnter = function (e) {
          var mouseEnterDelay = _this5.props.mouseEnterDelay;

          _this5.fireEvents('onMouseEnter', e);

          _this5.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
        };

        this.onMouseMove = function (e) {
          _this5.fireEvents('onMouseMove', e);

          _this5.setPoint(e);
        };

        this.onMouseLeave = function (e) {
          _this5.fireEvents('onMouseLeave', e);

          _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
        };

        this.onPopupMouseEnter = function () {
          _this5.clearDelayTimer();
        };

        this.onPopupMouseLeave = function (e) {
          // https://github.com/react-component/trigger/pull/13
          // react bug?
          if (e.relatedTarget && !e.relatedTarget.setTimeout && _this5._component && _this5._component.getPopupDomNode && Object(contains["a"
          /* default */
          ])(_this5._component.getPopupDomNode(), e.relatedTarget)) {
            return;
          }

          _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
        };

        this.onFocus = function (e) {
          _this5.fireEvents('onFocus', e); // incase focusin and focusout


          _this5.clearDelayTimer();

          if (_this5.isFocusToShow()) {
            _this5.focusTime = Date.now();

            _this5.delaySetPopupVisible(true, _this5.props.focusDelay);
          }
        };

        this.onMouseDown = function (e) {
          _this5.fireEvents('onMouseDown', e);

          _this5.preClickTime = Date.now();
        };

        this.onTouchStart = function (e) {
          _this5.fireEvents('onTouchStart', e);

          _this5.preTouchTime = Date.now();
        };

        this.onBlur = function (e) {
          _this5.fireEvents('onBlur', e);

          _this5.clearDelayTimer();

          if (_this5.isBlurToHide()) {
            _this5.delaySetPopupVisible(false, _this5.props.blurDelay);
          }
        };

        this.onContextMenu = function (e) {
          e.preventDefault();

          _this5.fireEvents('onContextMenu', e);

          _this5.setPopupVisible(true, e);
        };

        this.onContextMenuClose = function () {
          if (_this5.isContextMenuToShow()) {
            _this5.close();
          }
        };

        this.onClick = function (event) {
          _this5.fireEvents('onClick', event); // focus will trigger click


          if (_this5.focusTime) {
            var preTime = void 0;

            if (_this5.preClickTime && _this5.preTouchTime) {
              preTime = Math.min(_this5.preClickTime, _this5.preTouchTime);
            } else if (_this5.preClickTime) {
              preTime = _this5.preClickTime;
            } else if (_this5.preTouchTime) {
              preTime = _this5.preTouchTime;
            }

            if (Math.abs(preTime - _this5.focusTime) < 20) {
              return;
            }

            _this5.focusTime = 0;
          }

          _this5.preClickTime = 0;
          _this5.preTouchTime = 0;

          if (event && event.preventDefault) {
            event.preventDefault();
          }

          var nextVisible = !_this5.state.popupVisible;

          if (_this5.isClickToHide() && !nextVisible || nextVisible && _this5.isClickToShow()) {
            _this5.setPopupVisible(!_this5.state.popupVisible, event);
          }
        };

        this.onPopupMouseDown = function () {
          var _context$rcTrigger = _this5.context.rcTrigger,
              rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
          _this5.hasPopupMouseDown = true;
          clearTimeout(_this5.mouseDownTimeout);
          _this5.mouseDownTimeout = setTimeout(function () {
            _this5.hasPopupMouseDown = false;
          }, 0);

          if (rcTrigger.onPopupMouseDown) {
            rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
          }
        };

        this.onDocumentClick = function (event) {
          if (_this5.props.mask && !_this5.props.maskClosable) {
            return;
          }

          var target = event.target;
          var root = Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"])(_this5);

          if (!Object(contains["a"
          /* default */
          ])(root, target) && !_this5.hasPopupMouseDown) {
            _this5.close();
          }
        };

        this.getRootDomNode = function () {
          return Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"])(_this5);
        };

        this.getPopupClassNameFromAlign = function (align) {
          var className = [];
          var _props9 = _this5.props,
              popupPlacement = _props9.popupPlacement,
              builtinPlacements = _props9.builtinPlacements,
              prefixCls = _props9.prefixCls,
              alignPoint = _props9.alignPoint,
              getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

          if (popupPlacement && builtinPlacements) {
            className.push(utils_getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint));
          }

          if (getPopupClassNameFromAlign) {
            className.push(getPopupClassNameFromAlign(align));
          }

          return className.join(' ');
        };

        this.getComponent = function () {
          var _props10 = _this5.props,
              prefixCls = _props10.prefixCls,
              destroyPopupOnHide = _props10.destroyPopupOnHide,
              popupClassName = _props10.popupClassName,
              action = _props10.action,
              onPopupAlign = _props10.onPopupAlign,
              popupAnimation = _props10.popupAnimation,
              popupTransitionName = _props10.popupTransitionName,
              popupStyle = _props10.popupStyle,
              mask = _props10.mask,
              maskAnimation = _props10.maskAnimation,
              maskTransitionName = _props10.maskTransitionName,
              zIndex = _props10.zIndex,
              popup = _props10.popup,
              stretch = _props10.stretch,
              alignPoint = _props10.alignPoint;
          var _state = _this5.state,
              popupVisible = _state.popupVisible,
              point = _state.point;

          var align = _this5.getPopupAlign();

          var mouseProps = {};

          if (_this5.isMouseEnterToShow()) {
            mouseProps.onMouseEnter = _this5.onPopupMouseEnter;
          }

          if (_this5.isMouseLeaveToHide()) {
            mouseProps.onMouseLeave = _this5.onPopupMouseLeave;
          }

          mouseProps.onMouseDown = _this5.onPopupMouseDown;
          mouseProps.onTouchStart = _this5.onPopupMouseDown;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Popup, extends_default()({
            prefixCls: prefixCls,
            destroyPopupOnHide: destroyPopupOnHide,
            visible: popupVisible,
            point: alignPoint && point,
            className: popupClassName,
            action: action,
            align: align,
            onAlign: onPopupAlign,
            animation: popupAnimation,
            getClassNameFromAlign: _this5.getPopupClassNameFromAlign
          }, mouseProps, {
            stretch: stretch,
            getRootDomNode: _this5.getRootDomNode,
            style: popupStyle,
            mask: mask,
            zIndex: zIndex,
            transitionName: popupTransitionName,
            maskAnimation: maskAnimation,
            maskTransitionName: maskTransitionName,
            ref: _this5.savePopup
          }), typeof popup === 'function' ? popup() : popup);
        };

        this.getContainer = function () {
          var props = _this5.props;
          var popupContainer = document.createElement('div'); // Make sure default popup container will never cause scrollbar appearing
          // https://github.com/react-component/trigger/issues/41

          popupContainer.style.position = 'absolute';
          popupContainer.style.top = '0';
          popupContainer.style.left = '0';
          popupContainer.style.width = '100%';
          var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"])(_this5)) : props.getDocument().body;
          mountNode.appendChild(popupContainer);
          return popupContainer;
        };

        this.setPoint = function (point) {
          var alignPoint = _this5.props.alignPoint;
          if (!alignPoint || !point) return;

          _this5.setState({
            point: {
              pageX: point.pageX,
              pageY: point.pageY
            }
          });
        };

        this.handlePortalUpdate = function () {
          if (_this5.prevPopupVisible !== _this5.state.popupVisible) {
            _this5.props.afterPopupVisibleChange(_this5.state.popupVisible);
          }
        };

        this.savePopup = function (node) {
          _this5._component = node;
        };
      };
      /* harmony default export */


      var rc_trigger_es = __webpack_exports__["default"] = es_Trigger;
      /***/
    },
    /* 76 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(881);
      /***/
    },
    /* 77 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39);
      /* harmony import */


      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11);
      /* harmony import */


      var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_10___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_11___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
      /* harmony import */


      var recompose__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26);
      /* harmony import */


      var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25);
      /* harmony import */


      var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_14___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_14__);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_15___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_15__);
      /* harmony import */


      var react_redux__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33);
      /* harmony import */


      var _utils_checkLogic__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(99);
      /* harmony import */


      var _utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(18);

      var withVisibility = function withVisibility(settings) {
        return function (WrappedComponent) {
          var withVisibilityComponent =
          /*#__PURE__*/
          function (_Component) {
            _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(withVisibilityComponent, _Component);

            function withVisibilityComponent(props) {
              var _this;

              _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, withVisibilityComponent);

              _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(withVisibilityComponent).call(this, props)); // assign displayName

              _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7___default()(_this), "shouldComponentBeVisible", function (logic) {
                var submissionValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.submissionFields;
                var formVariables = _this.props.formVariables;
                var isVisible = true;

                if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(submissionValues) === 'object') {
                  Object.keys(submissionValues).forEach(function (key) {
                    submissionValues[key] = Object(_utils__WEBPACK_IMPORTED_MODULE_18__[
                    /* getInputValueAsStringIfAvailable */
                    "e"])(submissionValues[key]);
                  });
                }

                logic.some(function (logicItem) {
                  if (logicItem.operation.operationType === 'visibility' && logicItem.condition.conditionType === 'formLogic') {
                    var values = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, {
                      settings: formVariables
                    }, submissionValues);

                    if (!Object(_utils_checkLogic__WEBPACK_IMPORTED_MODULE_17__[
                    /* default */
                    "a"])(values, logicItem.condition.attributes.logic, _this.props, {
                      flow: 'myCurrentFlow',
                      currentPage: 'myCurrentPage'
                    }, _this.props.tokens)) {
                      isVisible = false;
                    }

                    return true; // stop this loop since it already processed operationType === 'visibility'
                  }

                  return false; // keep looking for the logicItem with operationType === 'visibility'
                });
                return isVisible;
              });

              _this.displayName = Object(recompose__WEBPACK_IMPORTED_MODULE_12__[
              /* wrapDisplayName */
              "d"])(WrappedComponent, 'withVisibility');

              var _logic;

              if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(props.logic)) {
                _logic = props.logic;
              } else if (settings.type === 'field' && props.sectionId && Object.prototype.hasOwnProperty.call(props.mySectionsById, props.sectionId)) {
                var fields = props.mySectionsById[props.sectionId].fields || [];
                var field = fields.filter(function (fieldItem) {
                  return fieldItem.id === props.id;
                });
                _logic = lodash_get__WEBPACK_IMPORTED_MODULE_14___default()(field, '[0].logic', []);
              } else if (settings.type === 'section' && props.pageId && Object.prototype.hasOwnProperty.call(props.myPagesById, props.pageId)) {
                var sections = props.myPagesById[props.pageId].sections || [];
                var section = sections.filter(function (sectionItem) {
                  return sectionItem.id === props.id;
                });
                _logic = lodash_get__WEBPACK_IMPORTED_MODULE_14___default()(section, '[0].logic', []);
              } else if (settings.type === 'page' && props.id && Object.prototype.hasOwnProperty.call(props.myPagesById, props.id)) {
                var page = props.myPagesById[props.id] || [];
                _logic = page.logic || [];
              } else if (settings.type === 'root') {
                _logic = props.logic || [];
              } else {
                _logic = [];
              }

              var _isVisible = _this.shouldComponentBeVisible(_logic); // need to initialise this.isVisible


              _this.isVisible = _isVisible;
              _this.state = {
                logic: _logic,
                isVisible: _isVisible,
                className: ''
              };
              return _this;
            }

            _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(withVisibilityComponent, [{
              key: "componentWillReceiveProps",
              value: function componentWillReceiveProps() {
                var isVisible = this.shouldComponentBeVisible(this.state.logic);

                if (this.state.isVisible !== isVisible) {
                  this.setState({
                    isVisible: isVisible
                  });
                }
              }
              /**
               * Given a component logic and submission values, it returns whether or not this component should be visible.
               */

            }, {
              key: "render",
              value: function render() {
                if (!this.state.isVisible) {
                  return null;
                }

                var props = lodash_omit__WEBPACK_IMPORTED_MODULE_15___default()(this.props, ['formVariables', 'myCurrentFlow', 'myCurrentPage', 'submissionFields']);
                return react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(WrappedComponent, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
                  className: this.state.className
                }, props));
              }
            }]);

            return withVisibilityComponent;
          }(react__WEBPACK_IMPORTED_MODULE_10__["Component"]);

          withVisibilityComponent.defaultProps = {
            data: {},
            formVariables: {},
            id: null,
            logic: [],
            pageId: null,
            sectionId: null,
            submissionFields: {},
            tokens: {}
          };
          withVisibilityComponent.propTypes = {
            data: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,
            formVariables: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,
            id: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,
            logic: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.array,
            myPagesById: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object.isRequired,
            mySectionsById: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object.isRequired,
            pageId: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,
            sectionId: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,
            submissionFields: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,
            tokens: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object
          };
          return settings.connect !== undefined && !settings.connect ? withVisibilityComponent : Object(react_redux__WEBPACK_IMPORTED_MODULE_16__[
          /* connect */
          "a"])(function (_ref) {
            var _ref$formatic = _ref.formatic,
                _ref$formatic$data = _ref$formatic.data,
                _ref$formatic$data$fo = _ref$formatic$data.form,
                myPagesById = _ref$formatic$data$fo.pagesById,
                mySectionsById = _ref$formatic$data$fo.sectionsById,
                fieldsById = _ref$formatic$data.submission.fieldsById,
                form = _ref$formatic.dataForm.attributes.variables.form,
                currentFlow = _ref$formatic.flow.current,
                currentPage = _ref$formatic.currentPage,
                tokens = _ref$formatic.tokens;
            return {
              myCurrentFlow: currentFlow,
              myPagesById: myPagesById,
              mySectionsById: mySectionsById,
              submissionFields: Object.keys(fieldsById).reduce(function (accum, key) {
                accum[fieldsById[key].id] = fieldsById[key].value;
                return accum;
              }, {}),
              formVariables: form,
              tokens: tokens,
              myCurrentPage: currentPage
            };
          })(withVisibilityComponent);
        };
      };
      /* harmony default export */


      __webpack_exports__["a"] = withVisibility;
      /***/
    },
    /* 78 */

    /***/
    function (module, exports) {
      function _taggedTemplateLiteral(strings, raw) {
        if (!raw) {
          raw = strings.slice(0);
        }

        return Object.freeze(Object.defineProperties(strings, {
          raw: {
            value: Object.freeze(raw)
          }
        }));
      }

      module.exports = _taggedTemplateLiteral;
      /***/
    },
    /* 79 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      var formatNumber = __webpack_require__(67).format;

      var formatBigNumber = __webpack_require__(792).format;

      var isBigNumber = __webpack_require__(308);
      /**
       * Test whether value is a string
       * @param {*} value
       * @return {boolean} isString
       */


      exports.isString = function (value) {
        return typeof value === 'string';
      };
      /**
       * Check if a text ends with a certain string.
       * @param {string} text
       * @param {string} search
       */


      exports.endsWith = function (text, search) {
        var start = text.length - search.length;
        var end = text.length;
        return text.substring(start, end) === search;
      };
      /**
       * Format a value of any type into a string.
       *
       * Usage:
       *     math.format(value)
       *     math.format(value, precision)
       *
       * When value is a function:
       *
       * - When the function has a property `syntax`, it returns this
       *   syntax description.
       * - In other cases, a string `'function'` is returned.
       *
       * When `value` is an Object:
       *
       * - When the object contains a property `format` being a function, this
       *   function is invoked as `value.format(options)` and the result is returned.
       * - When the object has its own `toString` method, this method is invoked
       *   and the result is returned.
       * - In other cases the function will loop over all object properties and
       *   return JSON object notation like '{"a": 2, "b": 3}'.
       *
       * Example usage:
       *     math.format(2/7)                // '0.2857142857142857'
       *     math.format(math.pi, 3)         // '3.14'
       *     math.format(new Complex(2, 3))  // '2 + 3i'
       *     math.format('hello')            // '"hello"'
       *
       * @param {*} value             Value to be stringified
       * @param {Object | number | Function} [options]  Formatting options. See
       *                                                lib/utils/number:format for a
       *                                                description of the available
       *                                                options.
       * @return {string} str
       */


      exports.format = function (value, options) {
        if (typeof value === 'number') {
          return formatNumber(value, options);
        }

        if (isBigNumber(value)) {
          return formatBigNumber(value, options);
        } // note: we use unsafe duck-typing here to check for Fractions, this is
        // ok here since we're only invoking toString or concatenating its values


        if (looksLikeFraction(value)) {
          if (!options || options.fraction !== 'decimal') {
            // output as ratio, like '1/3'
            return value.s * value.n + '/' + value.d;
          } else {
            // output as decimal, like '0.(3)'
            return value.toString();
          }
        }

        if (Array.isArray(value)) {
          return formatArray(value, options);
        }

        if (exports.isString(value)) {
          return '"' + value + '"';
        }

        if (typeof value === 'function') {
          return value.syntax ? String(value.syntax) : 'function';
        }

        if (value && _typeof(value) === 'object') {
          if (typeof value.format === 'function') {
            return value.format(options);
          } else if (value && value.toString() !== {}.toString()) {
            // this object has a non-native toString method, use that one
            return value.toString();
          } else {
            var entries = [];

            for (var key in value) {
              if (value.hasOwnProperty(key)) {
                entries.push('"' + key + '": ' + exports.format(value[key], options));
              }
            }

            return '{' + entries.join(', ') + '}';
          }
        }

        return String(value);
      };
      /**
       * Stringify a value into a string enclosed in double quotes.
       * Unescaped double quotes and backslashes inside the value are escaped.
       * @param {*} value
       * @return {string}
       */


      exports.stringify = function (value) {
        var text = String(value);
        var escaped = '';
        var i = 0;

        while (i < text.length) {
          var c = text.charAt(i);

          if (c === '\\') {
            escaped += c;
            i++;
            c = text.charAt(i);

            if (c === '' || '"\\/bfnrtu'.indexOf(c) === -1) {
              escaped += '\\'; // no valid escape character -> escape it
            }

            escaped += c;
          } else if (c === '"') {
            escaped += '\\"';
          } else {
            escaped += c;
          }

          i++;
        }

        return '"' + escaped + '"';
      };
      /**
       * Escape special HTML characters
       * @param {*} value
       * @return {string}
       */


      exports.escape = function (value) {
        var text = String(value);
        text = text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return text;
      };
      /**
       * Recursively format an n-dimensional matrix
       * Example output: "[[1, 2], [3, 4]]"
       * @param {Array} array
       * @param {Object | number | Function} [options]  Formatting options. See
       *                                                lib/utils/number:format for a
       *                                                description of the available
       *                                                options.
       * @returns {string} str
       */


      function formatArray(array, options) {
        if (Array.isArray(array)) {
          var str = '[';
          var len = array.length;

          for (var i = 0; i < len; i++) {
            if (i !== 0) {
              str += ', ';
            }

            str += formatArray(array[i], options);
          }

          str += ']';
          return str;
        } else {
          return exports.format(array, options);
        }
      }
      /**
       * Check whether a value looks like a Fraction (unsafe duck-type check)
       * @param {*} value
       * @return {boolean}
       */


      function looksLikeFraction(value) {
        return value && _typeof(value) === 'object' && typeof value.s === 'number' && typeof value.n === 'number' && typeof value.d === 'number' || false;
      }
      /***/

    },
    /* 80 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Execute the callback function element wise for each element in array and any
       * nested array
       * Returns an array with the results
       * @param {Array | Matrix} array
       * @param {Function} callback   The callback is called with two parameters:
       *                              value1 and value2, which contain the current
       *                              element of both arrays.
       * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
       *
       * @return {Array | Matrix} res
       */

      module.exports = function deepMap(array, callback, skipZeros) {
        if (array && typeof array.map === 'function') {
          // TODO: replace array.map with a for loop to improve performance
          return array.map(function (x) {
            return deepMap(x, callback, skipZeros);
          });
        } else {
          return callback(array);
        }
      };
      /***/

    },
    /* 81 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseMerge = __webpack_require__(1058),
          createAssigner = __webpack_require__(491);
      /**
       * This method is like `_.assign` except that it recursively merges own and
       * inherited enumerable string keyed properties of source objects into the
       * destination object. Source properties that resolve to `undefined` are
       * skipped if a destination value exists. Array and plain object properties
       * are merged recursively. Other objects and value types are overridden by
       * assignment. Source objects are applied from left to right. Subsequent
       * sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {
       *   'a': [{ 'b': 2 }, { 'd': 4 }]
       * };
       *
       * var other = {
       *   'a': [{ 'c': 3 }, { 'e': 5 }]
       * };
       *
       * _.merge(object, other);
       * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
       */


      var merge = createAssigner(function (object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      module.exports = merge;
      /***/
    },
    /* 82 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */

      /* eslint-disable no-unused-vars */

      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var propIsEnumerable = Object.prototype.propertyIsEnumerable;

      function toObject(val) {
        if (val === null || val === undefined) {
          throw new TypeError('Object.assign cannot be called with null or undefined');
        }

        return Object(val);
      }

      function shouldUseNative() {
        try {
          if (!Object.assign) {
            return false;
          } // Detect buggy property enumeration order in older V8 versions.
          // https://bugs.chromium.org/p/v8/issues/detail?id=4118


          var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

          test1[5] = 'de';

          if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
          } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


          var test2 = {};

          for (var i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
          }

          var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
          });

          if (order2.join('') !== '0123456789') {
            return false;
          } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


          var test3 = {};
          'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
          });

          if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
            return false;
          }

          return true;
        } catch (err) {
          // We don't expect any of the above to throw, but better to be safe.
          return false;
        }
      }

      module.exports = shouldUseNative() ? Object.assign : function (target, source) {
        var from;
        var to = toObject(target);
        var symbols;

        for (var s = 1; s < arguments.length; s++) {
          from = Object(arguments[s]);

          for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
              to[key] = from[key];
            }
          }

          if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);

            for (var i = 0; i < symbols.length; i++) {
              if (propIsEnumerable.call(from, symbols[i])) {
                to[symbols[i]] = from[symbols[i]];
              }
            }
          }
        }

        return to;
      };
      /***/
    },
    /* 83 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_7___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_8___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
      /* harmony import */


      var lodash_isArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55);
      /* harmony import */


      var lodash_isArray__WEBPACK_IMPORTED_MODULE_9___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_isArray__WEBPACK_IMPORTED_MODULE_9__);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_10___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_10__);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_11___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_11__);
      /* harmony import */


      var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25);
      /* harmony import */


      var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__);
      /* harmony import */


      var recompose__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26); // Props that can not be mutated


      var OVERRIDE_IMMUTABLE_PROPS = ['component', 'id', 'type'];
      /**
       * [withOverride description]
       * @param  {[type]} overrideSettings [description]
       * @param  {[type]} WrappedComponent   [description]
       * @return {[type]}                  [description]
       */

      var withOverride = function withOverride(overrideSettings) {
        var renderer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return function (WrappedComponent) {
          var WithOverrideComponent =
          /*#__PURE__*/
          function (_Component) {
            _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(WithOverrideComponent, _Component);
            /**
             * constructor
             */


            function WithOverrideComponent(props) {
              var _this;

              _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, WithOverrideComponent);

              _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(WithOverrideComponent).call(this, props)); // assign displayName

              _this.displayName = Object(recompose__WEBPACK_IMPORTED_MODULE_13__[
              /* wrapDisplayName */
              "d"])(WrappedComponent, 'withData');
              return _this;
            }
            /**
             * render
             */


            _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(WithOverrideComponent, [{
              key: "render",
              value: function render() {
                var _this2 = this;

                var ReturnedComponent = WrappedComponent;
                var renderComponent = this.props.renderer || renderer;
                var additionalProps = {};
                var props = this.props;

                if (typeof this.props.overrides[overrideSettings.overrideType] !== 'undefined') {
                  var elementOverride = this.props.overrides[overrideSettings.overrideType].find(function (override) {
                    var overrideType = lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(override, 'type[0]', '').toLowerCase() + lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(override, 'type', '').slice(1);

                    switch (overrideSettings.overrideType) {
                      // TODO: add 'sections' and 'pages' here (see src/core/injectables/Overrides.js and getOverrides in src/core/utils.js)
                      case 'system':
                        if (overrideType === overrideSettings.type) {
                          return true;
                        }

                        break;

                      case 'fieldContainer':
                      case 'fieldComponent':
                        // if the overrideType doesnt match the current rendered, dont override
                        if (overrideType !== renderComponent) {
                          break;
                        }

                        if ( // if override.id is empty, then it is overriding all components/container of this renderer type
                        lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default()(override.id) || // if override.id is not empty and it is an array, and the array includes the current id, then override it
                        lodash_isArray__WEBPACK_IMPORTED_MODULE_9___default()(override.id) && override.id.includes(_this2.props.id) || // if override.id is not empty and it is not an array, and it is equal to the current id, then override it
                        !lodash_isArray__WEBPACK_IMPORTED_MODULE_9___default()(override.id) && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default()(override.id) && override.id === _this2.props.id) {
                          return true;
                        }

                        break;

                      case 'hoc':
                        if (overrideType === overrideSettings.type) {
                          return true;
                        }

                        break;

                      default:
                        if (override.id === _this2.props.id) {
                          return true;
                        }

                    }

                    return false;
                  });

                  if (elementOverride) {
                    // An override was found
                    ReturnedComponent = elementOverride.component; // Add additional props

                    additionalProps = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, additionalProps, lodash_omit__WEBPACK_IMPORTED_MODULE_10___default()(elementOverride, OVERRIDE_IMMUTABLE_PROPS));

                    switch (overrideSettings.overrideType) {
                      case 'fieldContainer':
                        // Add field IDs to field containers
                        additionalProps.fieldId = this.props.id;
                        break;

                      case 'hoc':
                        additionalProps.WrappedHOC = WrappedComponent;
                        additionalProps.WrappedComponent = overrideSettings.WrappedComponent;
                        break;

                      default:
                    }

                    if (additionalProps.flat) {
                      // Flatten the attributes prop
                      props = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, props, lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(props, 'attributes', {}));
                      delete props.attributes;
                    }
                  }
                }

                return react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(ReturnedComponent, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, lodash_omit__WEBPACK_IMPORTED_MODULE_10___default()(props, ['overrides']), additionalProps));
              }
            }]);

            return WithOverrideComponent;
          }(react__WEBPACK_IMPORTED_MODULE_7__["Component"]);

          WithOverrideComponent.defaultProps = {
            id: '',
            overrides: {},
            renderer: ''
          };
          WithOverrideComponent.propTypes = {
            id: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
            overrides: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,
            renderer: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string
          };
          return Object(recompose__WEBPACK_IMPORTED_MODULE_13__[
          /* getContext */
          "b"])({
            overrides: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object
          })(WithOverrideComponent);
        };
      };
      /* harmony default export */


      __webpack_exports__["a"] = withOverride;
      /***/
    },
    /* 84 */

    /***/
    function (module, exports, __webpack_require__) {
      var toString = __webpack_require__(140);
      /**
       * Replaces matches for `pattern` in `string` with `replacement`.
       *
       * **Note:** This method is based on
       * [`String#replace`](https://mdn.io/String/replace).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to modify.
       * @param {RegExp|string} pattern The pattern to replace.
       * @param {Function|string} replacement The match replacement.
       * @returns {string} Returns the modified string.
       * @example
       *
       * _.replace('Hi Fred', 'Fred', 'Barney');
       * // => 'Hi Barney'
       */


      function replace() {
        var args = arguments,
            string = toString(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }

      module.exports = replace;
      /***/
    },
    /* 85 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseAssignValue = __webpack_require__(210),
          createAggregator = __webpack_require__(901);
      /**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The corresponding value of
       * each key is the last element responsible for generating the key. The
       * iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * var array = [
       *   { 'dir': 'left', 'code': 97 },
       *   { 'dir': 'right', 'code': 100 }
       * ];
       *
       * _.keyBy(array, function(o) {
       *   return String.fromCharCode(o.code);
       * });
       * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
       *
       * _.keyBy(array, 'dir');
       * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
       */


      var keyBy = createAggregator(function (result, value, key) {
        baseAssignValue(result, key, value);
      });
      module.exports = keyBy;
      /***/
    },
    /* 86 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "b", function () {
        return goStartMonth;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return goEndMonth;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return goTime;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return includesTime;
      });

      function goStartMonth(time) {
        return time.clone().startOf('month');
      }

      function goEndMonth(time) {
        return time.clone().endOf('month');
      }

      function goTime(time, direction, unit) {
        return time.clone().add(direction, unit);
      }

      function includesTime() {
        var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var time = arguments[1];
        var unit = arguments[2];
        return timeList.some(function (t) {
          return t.isSame(time, unit);
        });
      }
      /***/

    },
    /* 87 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      var keywords = __webpack_require__(410);

      var deepEqual = __webpack_require__(59).deepEqual;

      var hasOwnProperty = __webpack_require__(59).hasOwnProperty;

      function factory(type, config, load, typed, math) {
        /**
         * Node
         */
        function Node() {
          if (!(this instanceof Node)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }
        }
        /**
         * Evaluate the node
         * @param {Object} [scope]  Scope to read/write variables
         * @return {*}              Returns the result
         */


        Node.prototype.eval = function (scope) {
          return this.compile().eval(scope);
        };

        Node.prototype.type = 'Node';
        Node.prototype.isNode = true;
        Node.prototype.comment = '';
        /**
         * Compile the node into an optimized, evauatable JavaScript function
         * @return {{eval: function([Object])}} expr  Returns an object with a function 'eval',
         *                                  which can be invoked as expr.eval([scope: Object]),
         *                                  where scope is an optional object with
         *                                  variables.
         */

        Node.prototype.compile = function () {
          var expr = this._compile(math.expression.mathWithTransform, {});

          var args = {};
          var context = null;
          return {
            eval: function evalNode(scope) {
              var s = scope || {};

              _validateScope(s);

              return expr(s, args, context);
            }
          };
        };
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */


        Node.prototype._compile = function (math, argNames) {
          throw new Error('Method _compile should be implemented by type ' + this.type);
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        Node.prototype.forEach = function (callback) {
          // must be implemented by each of the Node implementations
          throw new Error('Cannot run forEach on a Node interface');
        };
        /**
         * Create a new Node having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {OperatorNode} Returns a transformed copy of the node
         */


        Node.prototype.map = function (callback) {
          // must be implemented by each of the Node implementations
          throw new Error('Cannot run map on a Node interface');
        };
        /**
         * Validate whether an object is a Node, for use with map
         * @param {Node} node
         * @returns {Node} Returns the input if it's a node, else throws an Error
         * @protected
         */


        Node.prototype._ifNode = function (node) {
          if (!type.isNode(node)) {
            throw new TypeError('Callback function must return a Node');
          }

          return node;
        };
        /**
         * Recursively traverse all nodes in a node tree. Executes given callback for
         * this node and each of its child nodes.
         * @param {function(node: Node, path: string, parent: Node)} callback
         *          A callback called for every node in the node tree.
         */


        Node.prototype.traverse = function (callback) {
          // execute callback for itself
          callback(this, null, null); // eslint-disable-line standard/no-callback-literal
          // recursively traverse over all childs of a node

          function _traverse(node, callback) {
            node.forEach(function (child, path, parent) {
              callback(child, path, parent);

              _traverse(child, callback);
            });
          }

          _traverse(this, callback);
        };
        /**
         * Recursively transform a node tree via a transform function.
         *
         * For example, to replace all nodes of type SymbolNode having name 'x' with a
         * ConstantNode with value 2:
         *
         *     const res = Node.transform(function (node, path, parent) {
         *       if (node && node.isSymbolNode) && (node.name === 'x')) {
         *         return new ConstantNode(2)
         *       }
         *       else {
         *         return node
         *       }
         *     })
         *
         * @param {function(node: Node, path: string, parent: Node) : Node} callback
         *          A mapping function accepting a node, and returning
         *          a replacement for the node or the original node.
         *          Signature: callback(node: Node, index: string, parent: Node) : Node
         * @return {Node} Returns the original node or its replacement
         */


        Node.prototype.transform = function (callback) {
          // traverse over all childs
          function _transform(node, callback) {
            return node.map(function (child, path, parent) {
              var replacement = callback(child, path, parent);
              return _transform(replacement, callback);
            });
          }

          var replacement = callback(this, null, null); // eslint-disable-line standard/no-callback-literal

          return _transform(replacement, callback);
        };
        /**
         * Find any node in the node tree matching given filter function. For example, to
         * find all nodes of type SymbolNode having name 'x':
         *
         *     const results = Node.filter(function (node) {
         *       return (node && node.isSymbolNode) && (node.name === 'x')
         *     })
         *
         * @param {function(node: Node, path: string, parent: Node) : Node} callback
         *            A test function returning true when a node matches, and false
         *            otherwise. Function signature:
         *            callback(node: Node, index: string, parent: Node) : boolean
         * @return {Node[]} nodes       An array with nodes matching given filter criteria
         */


        Node.prototype.filter = function (callback) {
          var nodes = [];
          this.traverse(function (node, path, parent) {
            if (callback(node, path, parent)) {
              nodes.push(node);
            }
          });
          return nodes;
        }; // TODO: deprecated since version 1.1.0, remove this some day


        Node.prototype.find = function () {
          throw new Error('Function Node.find is deprecated. Use Node.filter instead.');
        }; // TODO: deprecated since version 1.1.0, remove this some day


        Node.prototype.match = function () {
          throw new Error('Function Node.match is deprecated. See functions Node.filter, Node.transform, Node.traverse.');
        };
        /**
         * Create a shallow clone of this node
         * @return {Node}
         */


        Node.prototype.clone = function () {
          // must be implemented by each of the Node implementations
          throw new Error('Cannot clone a Node interface');
        };
        /**
         * Create a deep clone of this node
         * @return {Node}
         */


        Node.prototype.cloneDeep = function () {
          return this.map(function (node) {
            return node.cloneDeep();
          });
        };
        /**
         * Deep compare this node with another node.
         * @param {Node} other
         * @return {boolean} Returns true when both nodes are of the same type and
         *                   contain the same values (as do their childs)
         */


        Node.prototype.equals = function (other) {
          return other ? deepEqual(this, other) : false;
        };
        /**
         * Get string representation. (wrapper function)
         *
         * This function can get an object of the following form:
         * {
         *    handler: //This can be a callback function of the form
         *             // "function callback(node, options)"or
         *             // a map that maps function names (used in FunctionNodes)
         *             // to callbacks
         *    parenthesis: "keep" //the parenthesis option (This is optional)
         * }
         *
         * @param {Object} [options]
         * @return {string}
         */


        Node.prototype.toString = function (options) {
          var customString;

          if (options && _typeof(options) === 'object') {
            switch (_typeof(options.handler)) {
              case 'object':
              case 'undefined':
                break;

              case 'function':
                customString = options.handler(this, options);
                break;

              default:
                throw new TypeError('Object or function expected as callback');
            }
          }

          if (typeof customString !== 'undefined') {
            return customString;
          }

          return this._toString(options);
        };
        /**
         * Get a JSON representation of the node
         * Both .toJSON() and the static .fromJSON(json) should be implemented by all
         * implementations of Node
         * @returns {Object}
         */


        Node.prototype.toJSON = function () {
          throw new Error('Cannot serialize object: toJSON not implemented by ' + this.type);
        };
        /**
         * Get HTML representation. (wrapper function)
         *
         * This function can get an object of the following form:
         * {
         *    handler: //This can be a callback function of the form
         *             // "function callback(node, options)" or
         *             // a map that maps function names (used in FunctionNodes)
         *             // to callbacks
         *    parenthesis: "keep" //the parenthesis option (This is optional)
         * }
         *
         * @param {Object} [options]
         * @return {string}
         */


        Node.prototype.toHTML = function (options) {
          var customString;

          if (options && _typeof(options) === 'object') {
            switch (_typeof(options.handler)) {
              case 'object':
              case 'undefined':
                break;

              case 'function':
                customString = options.handler(this, options);
                break;

              default:
                throw new TypeError('Object or function expected as callback');
            }
          }

          if (typeof customString !== 'undefined') {
            return customString;
          }

          return this.toHTML(options);
        };
        /**
         * Internal function to generate the string output.
         * This has to be implemented by every Node
         *
         * @throws {Error}
         */


        Node.prototype._toString = function () {
          // must be implemented by each of the Node implementations
          throw new Error('_toString not implemented for ' + this.type);
        };
        /**
         * Get LaTeX representation. (wrapper function)
         *
         * This function can get an object of the following form:
         * {
         *    handler: //This can be a callback function of the form
         *             // "function callback(node, options)"or
         *             // a map that maps function names (used in FunctionNodes)
         *             // to callbacks
         *    parenthesis: "keep" //the parenthesis option (This is optional)
         * }
         *
         * @param {Object} [options]
         * @return {string}
         */


        Node.prototype.toTex = function (options) {
          var customTex;

          if (options && _typeof(options) === 'object') {
            switch (_typeof(options.handler)) {
              case 'object':
              case 'undefined':
                break;

              case 'function':
                customTex = options.handler(this, options);
                break;

              default:
                throw new TypeError('Object or function expected as callback');
            }
          }

          if (typeof customTex !== 'undefined') {
            return customTex;
          }

          return this._toTex(options);
        };
        /**
         * Internal function to generate the LaTeX output.
         * This has to be implemented by every Node
         *
         * @param {Object} [options]
         * @throws {Error}
         */


        Node.prototype._toTex = function (options) {
          // must be implemented by each of the Node implementations
          throw new Error('_toTex not implemented for ' + this.type);
        };
        /**
         * Get identifier.
         * @return {string}
         */


        Node.prototype.getIdentifier = function () {
          return this.type;
        };
        /**
         * Get the content of the current Node.
         * @return {Node} node
         **/


        Node.prototype.getContent = function () {
          return this;
        };
        /**
         * Validate the symbol names of a scope.
         * Throws an error when the scope contains an illegal symbol.
         * @param {Object} scope
         */


        function _validateScope(scope) {
          for (var symbol in scope) {
            if (hasOwnProperty(scope, symbol)) {
              if (symbol in keywords) {
                throw new Error('Scope contains an illegal symbol, "' + symbol + '" is a reserved keyword');
              }
            }
          }
        }

        return Node;
      }

      exports.name = 'Node';
      exports.path = 'expression.node';
      exports.math = true; // request access to the math namespace as 5th argument of the factory function

      exports.factory = factory;
      /***/
    },
    /* 88 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      var hasOwnProperty = __webpack_require__(59).hasOwnProperty;
      /**
       * Get a property of a plain object
       * Throws an error in case the object is not a plain object or the
       * property is not defined on the object itself
       * @param {Object} object
       * @param {string} prop
       * @return {*} Returns the property value when safe
       */


      function getSafeProperty(object, prop) {
        // only allow getting safe properties of a plain object
        if (isPlainObject(object) && isSafeProperty(object, prop)) {
          return object[prop];
        }

        if (typeof object[prop] === 'function' && isSafeMethod(object, prop)) {
          throw new Error('Cannot access method "' + prop + '" as a property');
        }

        throw new Error('No access to property "' + prop + '"');
      }
      /**
       * Set a property on a plain object.
       * Throws an error in case the object is not a plain object or the
       * property would override an inherited property like .constructor or .toString
       * @param {Object} object
       * @param {string} prop
       * @param {*} value
       * @return {*} Returns the value
       */
      // TODO: merge this function into access.js?


      function setSafeProperty(object, prop, value) {
        // only allow setting safe properties of a plain object
        if (isPlainObject(object) && isSafeProperty(object, prop)) {
          object[prop] = value;
          return value;
        }

        throw new Error('No access to property "' + prop + '"');
      }
      /**
       * Test whether a property is safe to use for an object.
       * For example .toString and .constructor are not safe
       * @param {string} prop
       * @return {boolean} Returns true when safe
       */


      function isSafeProperty(object, prop) {
        if (!object || _typeof(object) !== 'object') {
          return false;
        } // SAFE: whitelisted
        // e.g length


        if (hasOwnProperty(safeNativeProperties, prop)) {
          return true;
        } // UNSAFE: inherited from Object prototype
        // e.g constructor


        if (prop in Object.prototype) {
          // 'in' is used instead of hasOwnProperty for nodejs v0.10
          // which is inconsistent on root prototypes. It is safe
          // here because Object.prototype is a root object
          return false;
        } // UNSAFE: inherited from Function prototype
        // e.g call, apply


        if (prop in Function.prototype) {
          // 'in' is used instead of hasOwnProperty for nodejs v0.10
          // which is inconsistent on root prototypes. It is safe
          // here because Function.prototype is a root object
          return false;
        }

        return true;
      }
      /**
       * Validate whether a method is safe.
       * Throws an error when that's not the case.
       * @param {Object} object
       * @param {string} method
       */
      // TODO: merge this function into assign.js?


      function validateSafeMethod(object, method) {
        if (!isSafeMethod(object, method)) {
          throw new Error('No access to method "' + method + '"');
        }
      }
      /**
       * Check whether a method is safe.
       * Throws an error when that's not the case (for example for `constructor`).
       * @param {Object} object
       * @param {string} method
       * @return {boolean} Returns true when safe, false otherwise
       */


      function isSafeMethod(object, method) {
        if (!object || typeof object[method] !== 'function') {
          return false;
        } // UNSAFE: ghosted
        // e.g overridden toString
        // Note that IE10 doesn't support __proto__ and we can't do this check there.


        if (hasOwnProperty(object, method) && Object.getPrototypeOf && method in Object.getPrototypeOf(object)) {
          return false;
        } // SAFE: whitelisted
        // e.g toString


        if (hasOwnProperty(safeNativeMethods, method)) {
          return true;
        } // UNSAFE: inherited from Object prototype
        // e.g constructor


        if (method in Object.prototype) {
          // 'in' is used instead of hasOwnProperty for nodejs v0.10
          // which is inconsistent on root prototypes. It is safe
          // here because Object.prototype is a root object
          return false;
        } // UNSAFE: inherited from Function prototype
        // e.g call, apply


        if (method in Function.prototype) {
          // 'in' is used instead of hasOwnProperty for nodejs v0.10
          // which is inconsistent on root prototypes. It is safe
          // here because Function.prototype is a root object
          return false;
        }

        return true;
      }

      function isPlainObject(object) {
        return _typeof(object) === 'object' && object && object.constructor === Object;
      }

      var safeNativeProperties = {
        length: true,
        name: true
      };
      var safeNativeMethods = {
        toString: true,
        valueOf: true,
        toLocaleString: true
      };
      exports.getSafeProperty = getSafeProperty;
      exports.setSafeProperty = setSafeProperty;
      exports.isSafeProperty = isSafeProperty;
      exports.validateSafeMethod = validateSafeMethod;
      exports.isSafeMethod = isSafeMethod;
      exports.isPlainObject = isPlainObject;
      /***/
    },
    /* 89 */

    /***/
    function (module, exports) {
      var core = module.exports = {
        version: '2.6.6'
      };
      if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

      /***/
    },
    /* 90 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (process) {
        /* unused harmony export getEnv */

        /* unused harmony export isEnv */

        /* harmony export (binding) */
        __webpack_require__.d(__webpack_exports__, "b", function () {
          return isProduction;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "a", function () {
          return isDevelopment;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "c", function () {
          return isTest;
        });

        function getEnv() {
          if (typeof process !== 'undefined' && "production") {
            return "production";
          }

          return 'development';
        }

        function isEnv(env) {
          return getEnv() === env;
        }

        function isProduction() {
          return isEnv('production') === true;
        }

        function isDevelopment() {
          return isEnv('development') === true;
        }

        function isTest() {
          return isEnv('test') === true;
        }
        /* WEBPACK VAR INJECTION */

      }).call(this, __webpack_require__(162));
      /***/
    },
    /* 91 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export getSubmission */

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "b", function () {
        return navigateToPage;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return changeFlow;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return tryToNavigateToNextPage;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return setSubmissionValues;
      });
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29);
      /* harmony import */


      var _RootComponents_helpers_mutations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(112);
      /* harmony import */


      var _graphql_submission__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63);
      /* harmony import */


      var _navigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50);
      /* harmony import */


      var _RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54);
      /**
       * Return submission from local store.
       * @param client
       * @param  store
       */


      function getSubmission(client, store) {
        var state = store.getState();
        var obj = client.readQuery({
          query: _graphql_submission__WEBPACK_IMPORTED_MODULE_6__[
          /* readSubmissionQuery */
          "b"].query,
          variables: {
            branch: state.formatic.environment,
            channel: state.formatic.channel,
            formId: state.formatic.formId,
            initialValues: state.formatic.initialValues,
            submissionId: state.formatic.submissionId
          }
        });
        return obj.Submission;
      }
      /**
       * Navigate to a page without triggering any validation on the current page, it just changes the current page to pageId if pageId exists.
       */


      function navigateToPage(client, store, pageId, channel) {
        var persist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

        var _store$getState = store.getState(),
            formatic = _store$getState.formatic;

        if (!formatic.data.form.pagesById[pageId]) {
          // this pageId does not exist on this form
          return;
        } // Update local store


        store.dispatch(Object(_actions__WEBPACK_IMPORTED_MODULE_4__[
        /* setCurrentPage */
        "O"])(pageId, channel)); // Persist on server

        if (persist) {
          var submission = getSubmission(client, store);

          if (!submission.attributes) {
            // Not found, abort
            return;
          }

          var currentPage = submission.attributes.find(function (attribute) {
            return attribute.id === 'currentPage';
          });

          if (!currentPage || !currentPage.value) {
            // Current page attribute not found, abort
            return;
          } // Update the current page


          var newCurrentPageValue = JSON.parse(JSON.stringify(currentPage.value));
          newCurrentPageValue[channel] = {
            pageId: pageId,
            requestTimestamp: Date.now()
          };
          var options = Object(_graphql_submission__WEBPACK_IMPORTED_MODULE_6__[
          /* getSubmissionOptions */
          "a"])(formatic.formId, formatic.submissionId, [{
            id: 'currentPage',
            value: newCurrentPageValue
          }], [], {
            attributes: submission.attributes,
            fields: submission.fields
          }, Date.now(), formatic.channel, formatic.environment);
          client.mutate(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({
            mutation: _graphql_submission__WEBPACK_IMPORTED_MODULE_6__[
            /* setSubmissionValuesMutation */
            "c"]
          }, options));
        }
      }
      /**
       * Initiates a GraphQL mutation to update the current flow.
       *
       * @param {Object} client redux client
       * @param {Object} store redux store
       * @param {Object} params parameters object
       */


      function changeFlow(client, store, _ref) {
        var channel = _ref.channel,
            flow = _ref.flow;

        var _store$getState2 = store.getState(),
            _store$getState2$form = _store$getState2.formatic,
            currentChannel = _store$getState2$form.channel,
            currentPage = _store$getState2$form.currentPage,
            _store$getState2$form2 = _store$getState2$form.data.submission,
            attributesById = _store$getState2$form2.attributesById,
            fieldsById = _store$getState2$form2.fieldsById,
            formAttributes = _store$getState2$form.dataForm.attributes,
            environment = _store$getState2$form.environment,
            currentFlowName = _store$getState2$form.flow.current,
            formId = _store$getState2$form.formId,
            initialValues = _store$getState2$form.initialValues,
            submissionId = _store$getState2$form.submissionId;

        if (currentChannel !== channel) {
          // channel mismatch, no need to continue
          return;
        }

        var attributes = Object.values(attributesById);
        var fields = Object.values(fieldsById); // retrieve flow details

        var flowAttribute = attributes.find(function (o) {
          return o.id === _RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_8__[
          /* Constants */
          "a"].FlowAttributeKey;
        });
        var currentFlow = flowAttribute ? flowAttribute.value : {}; // fetch the current flow object w/options

        var flowObj = formAttributes.flow.find(function (o) {
          return o.name === currentFlowName;
        }); // a list of all 'exit' pages for flows across all channels

        var currentFlowChannelsAttr = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2___default()(attributes.find(function (o) {
          return o.id === _RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_8__[
          /* Constants */
          "a"].FlowChannelsExitPageKey;
        }) || {
          value: {}
        }).value;

        if (!currentFlowChannelsAttr[channel]) {
          currentFlowChannelsAttr[channel] = {};
        }

        if (flowObj === undefined || flowObj.persistPageTransitions) {
          // preparing to leave the current flow, persist page transitions, remember which page the user exited from
          // flow === undefined caters for the main flow, in which case always persist
          currentFlowChannelsAttr[channel][currentFlowName] = currentPage[channel].pageId;
        } // perform the mutation


        var mutate = Object(_RootComponents_helpers_mutations__WEBPACK_IMPORTED_MODULE_5__[
        /* submissionAttribute */
        "a"])(function (options) {
          return client.mutate(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({
            mutation: _graphql_submission__WEBPACK_IMPORTED_MODULE_6__[
            /* setSubmissionValuesMutation */
            "c"]
          }, options));
        }, {
          channel: currentChannel,
          environment: environment,
          formId: formId,
          submissionId: submissionId
        }, submissionId);
        mutate({
          attributes: [{
            id: _RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_8__[
            /* Constants */
            "a"].FlowAttributeKey,
            value: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, currentFlow, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, channel, flow))
          }, {
            id: _RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_8__[
            /* Constants */
            "a"].FlowChannelsExitPageKey,
            value: currentFlowChannelsAttr
          }]
        }, {
          attributes: attributes,
          fields: fields,
          initialValues: initialValues
        });
      }
      /**
       * It validates the current page, if it is valid then it navigates to the next page, otherwise the page validation is going to show errors.
       */


      function tryToNavigateToNextPage(client, store, channel) {
        var persist = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        var state = store.getState();
        var isPageValid = Object(_navigation__WEBPACK_IMPORTED_MODULE_7__[
        /* pageValidation */
        "b"])(state.formatic.visibleFields, state.formatic.dataForm.attributes);
        var _state$formatic = state.formatic,
            currentPageFlow = _state$formatic.flow.current,
            pageFlow = _state$formatic.pageFlow;

        if (isPageValid) {
          // make sure that the channel is a valid channel and that it was a pageId
          var currentPage = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(state, "formatic.currentPage[".concat(channel, "].pageId")); // currentIndex will be -1 if channel is invalid and currentPage is undefined

          var currentIndex = pageFlow[currentPageFlow].indexOf(currentPage);

          if (currentIndex < 0 || currentIndex === pageFlow[currentPageFlow].length - 1) {
            // currentIndex is negative or is already the last page therefore there isn't a next page to navigate to
            return;
          }

          navigateToPage(client, store, pageFlow[currentPageFlow][currentIndex + 1], channel, persist);
        }
      }
      /**
       * Set new submission attributes values and/or new fields values based on newAttributes and newFields parameters.
       * @param {array} newAttributes Array of objects where every object has the following structure { id, value }
       * @param {array} newFields Array of objects where every object has the following structure { id, value }
       * @param {number} timestamp
       * @param {object} store The redux store object
       * @param {object} client The Apollo Client instance
       */


      var setSubmissionValues = function setSubmissionValues() {
        var newAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var newFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var timestamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
        var store = arguments.length > 3 ? arguments[3] : undefined;
        var client = arguments.length > 4 ? arguments[4] : undefined;
        var state = store.getState();
        var submission = getSubmission(client, store);
        var options = Object(_graphql_submission__WEBPACK_IMPORTED_MODULE_6__[
        /* getSubmissionOptions */
        "a"])(state.formatic.formId, state.formatic.submissionId, newAttributes, newFields, {
          attributes: submission.attributes || [],
          fields: submission.fields || []
        }, timestamp, state.formatic.channel, state.formatic.environment);
        client.mutate(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({
          mutation: _graphql_submission__WEBPACK_IMPORTED_MODULE_6__[
          /* setSubmissionValuesMutation */
          "c"]
        }, options));
      };
      /***/

    },
    /* 92 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Create a range error with the message:
       *     'Dimension mismatch (<actual size> != <expected size>)'
       * @param {number | number[]} actual        The actual size
       * @param {number | number[]} expected      The expected size
       * @param {string} [relation='!=']          Optional relation between actual
       *                                          and expected size: '!=', '<', etc.
       * @extends RangeError
       */

      function DimensionError(actual, expected, relation) {
        if (!(this instanceof DimensionError)) {
          throw new SyntaxError('Constructor must be called with the new operator');
        }

        this.actual = actual;
        this.expected = expected;
        this.relation = relation;
        this.message = 'Dimension mismatch (' + (Array.isArray(actual) ? '[' + actual.join(', ') + ']' : actual) + ' ' + (this.relation || '!=') + ' ' + (Array.isArray(expected) ? '[' + expected.join(', ') + ']' : expected) + ')';
        this.stack = new Error().stack;
      }

      DimensionError.prototype = new RangeError();
      DimensionError.prototype.constructor = RangeError;
      DimensionError.prototype.name = 'DimensionError';
      DimensionError.prototype.isDimensionError = true;
      module.exports = DimensionError;
      /***/
    },
    /* 93 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftModifier
       * @format
       * 
       */

      var CharacterMetadata = __webpack_require__(96);

      var ContentStateInlineStyle = __webpack_require__(1033);

      var DraftFeatureFlags = __webpack_require__(133);

      var Immutable = __webpack_require__(53);

      var applyEntityToContentState = __webpack_require__(1032);

      var getCharacterRemovalRange = __webpack_require__(1030);

      var getContentStateFragment = __webpack_require__(242);

      var insertFragmentIntoContentState = __webpack_require__(1027);

      var insertTextIntoContentState = __webpack_require__(1026);

      var invariant = __webpack_require__(51);

      var modifyBlockForContentState = __webpack_require__(1025);

      var removeEntitiesAtEdges = __webpack_require__(483);

      var removeRangeFromContentState = __webpack_require__(1024);

      var splitBlockInContentState = __webpack_require__(1023);

      var OrderedSet = Immutable.OrderedSet;
      /**
       * `DraftModifier` provides a set of convenience methods that apply
       * modifications to a `ContentState` object based on a target `SelectionState`.
       *
       * Any change to a `ContentState` should be decomposable into a series of
       * transaction functions that apply the required changes and return output
       * `ContentState` objects.
       *
       * These functions encapsulate some of the most common transaction sequences.
       */

      var DraftModifier = {
        replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
          var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
          var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
          var character = CharacterMetadata.create({
            style: inlineStyle || OrderedSet(),
            entity: entityKey || null
          });
          return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
        },
        insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
          !targetRange.isCollapsed() ? false ? undefined : invariant(false) : void 0;
          return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
        },
        moveText: function moveText(contentState, removalRange, targetRange) {
          var movedFragment = getContentStateFragment(contentState, removalRange);
          var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
          return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
        },
        replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
          var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
          var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
          return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
        },
        removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
          var startKey = void 0,
              endKey = void 0,
              startBlock = void 0,
              endBlock = void 0;

          if (rangeToRemove.getIsBackward()) {
            rangeToRemove = rangeToRemove.merge({
              anchorKey: rangeToRemove.getFocusKey(),
              anchorOffset: rangeToRemove.getFocusOffset(),
              focusKey: rangeToRemove.getAnchorKey(),
              focusOffset: rangeToRemove.getAnchorOffset(),
              isBackward: false
            });
          }

          startKey = rangeToRemove.getAnchorKey();
          endKey = rangeToRemove.getFocusKey();
          startBlock = contentState.getBlockForKey(startKey);
          endBlock = contentState.getBlockForKey(endKey);
          var startOffset = rangeToRemove.getStartOffset();
          var endOffset = rangeToRemove.getEndOffset();
          var startEntityKey = startBlock.getEntityAt(startOffset);
          var endEntityKey = endBlock.getEntityAt(endOffset - 1); // Check whether the selection state overlaps with a single entity.
          // If so, try to remove the appropriate substring of the entity text.

          if (startKey === endKey) {
            if (startEntityKey && startEntityKey === endEntityKey) {
              var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);

              return removeRangeFromContentState(contentState, _adjustedRemovalRange);
            }
          }

          var adjustedRemovalRange = rangeToRemove;

          if (DraftFeatureFlags.draft_segmented_entities_behavior) {
            // Adjust the selection to properly delete segemented and immutable
            // entities
            adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
          }

          var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
          return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
        },
        splitBlock: function splitBlock(contentState, selectionState) {
          var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
          var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
          return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
        },
        applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
          return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
        },
        removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
          return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
        },
        setBlockType: function setBlockType(contentState, selectionState, blockType) {
          return modifyBlockForContentState(contentState, selectionState, function (block) {
            return block.merge({
              type: blockType,
              depth: 0
            });
          });
        },
        setBlockData: function setBlockData(contentState, selectionState, blockData) {
          return modifyBlockForContentState(contentState, selectionState, function (block) {
            return block.merge({
              data: blockData
            });
          });
        },
        mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
          return modifyBlockForContentState(contentState, selectionState, function (block) {
            return block.merge({
              data: block.getData().merge(blockData)
            });
          });
        },
        applyEntity: function applyEntity(contentState, selectionState, entityKey) {
          var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
          return applyEntityToContentState(withoutEntities, selectionState, entityKey);
        }
      };
      module.exports = DraftModifier;
      /***/
    },
    /* 94 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/lodash-es/_freeGlobal.js


      var _freeGlobal = __webpack_require__(1197); // CONCATENATED MODULE: ./node_modules/lodash-es/_root.js

      /** Detect free variable `self`. */


      var _root_freeSelf = typeof self == 'object' && self && self.Object === Object && self;
      /** Used as a reference to the global object. */


      var _root_root = _freeGlobal["a"
      /* default */
      ] || _root_freeSelf || Function('return this')();
      /* harmony default export */


      var _root = _root_root; // CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js

      /** Built-in value references. */

      var _Symbol_Symbol = _root.Symbol;
      /* harmony default export */

      var _Symbol = _Symbol_Symbol; // CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js

      /** Used for built-in method references. */

      var _getRawTag_objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var _getRawTag_hasOwnProperty = _getRawTag_objectProto.hasOwnProperty;
      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */

      var _getRawTag_nativeObjectToString = _getRawTag_objectProto.toString;
      /** Built-in value references. */

      var _getRawTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
      /**
       * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the raw `toStringTag`.
       */


      function _getRawTag_getRawTag(value) {
        var isOwn = _getRawTag_hasOwnProperty.call(value, _getRawTag_symToStringTag),
            tag = value[_getRawTag_symToStringTag];

        try {
          value[_getRawTag_symToStringTag] = undefined;
          var unmasked = true;
        } catch (e) {}

        var result = _getRawTag_nativeObjectToString.call(value);

        if (unmasked) {
          if (isOwn) {
            value[_getRawTag_symToStringTag] = tag;
          } else {
            delete value[_getRawTag_symToStringTag];
          }
        }

        return result;
      }
      /* harmony default export */


      var _getRawTag = _getRawTag_getRawTag; // CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js

      /** Used for built-in method references. */

      var _objectToString_objectProto = Object.prototype;
      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */

      var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;
      /**
       * Converts `value` to a string using `Object.prototype.toString`.
       *
       * @private
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       */

      function objectToString(value) {
        return _objectToString_nativeObjectToString.call(value);
      }
      /* harmony default export */


      var _objectToString = objectToString; // CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js

      /** `Object#toString` result references. */

      var _baseGetTag_nullTag = '[object Null]',
          _baseGetTag_undefinedTag = '[object Undefined]';
      /** Built-in value references. */

      var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
      /**
       * The base implementation of `getTag` without fallbacks for buggy environments.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */


      function _baseGetTag_baseGetTag(value) {
        if (value == null) {
          return value === undefined ? _baseGetTag_undefinedTag : _baseGetTag_nullTag;
        }

        return _baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value) ? _getRawTag(value) : _objectToString(value);
      }
      /* harmony default export */


      var _baseGetTag = _baseGetTag_baseGetTag; // CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js

      /**
       * Creates a unary function that invokes `func` with its argument transformed.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {Function} transform The argument transform.
       * @returns {Function} Returns the new function.
       */

      function overArg(func, transform) {
        return function (arg) {
          return func(transform(arg));
        };
      }
      /* harmony default export */


      var _overArg = overArg; // CONCATENATED MODULE: ./node_modules/lodash-es/_getPrototype.js

      /** Built-in value references. */

      var _getPrototype_getPrototype = _overArg(Object.getPrototypeOf, Object);
      /* harmony default export */


      var _getPrototype = _getPrototype_getPrototype; // CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js

      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */

      function isObjectLike(value) {
        return value != null && typeof value == 'object';
      }
      /* harmony default export */


      var lodash_es_isObjectLike = isObjectLike; // CONCATENATED MODULE: ./node_modules/lodash-es/isPlainObject.js

      /** `Object#toString` result references. */

      var isPlainObject_objectTag = '[object Object]';
      /** Used for built-in method references. */

      var isPlainObject_funcProto = Function.prototype,
          isPlainObject_objectProto = Object.prototype;
      /** Used to resolve the decompiled source of functions. */

      var isPlainObject_funcToString = isPlainObject_funcProto.toString;
      /** Used to check objects for own properties. */

      var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;
      /** Used to infer the `Object` constructor. */

      var isPlainObject_objectCtorString = isPlainObject_funcToString.call(Object);
      /**
       * Checks if `value` is a plain object, that is, an object created by the
       * `Object` constructor or one with a `[[Prototype]]` of `null`.
       *
       * @static
       * @memberOf _
       * @since 0.8.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * _.isPlainObject(new Foo);
       * // => false
       *
       * _.isPlainObject([1, 2, 3]);
       * // => false
       *
       * _.isPlainObject({ 'x': 0, 'y': 0 });
       * // => true
       *
       * _.isPlainObject(Object.create(null));
       * // => true
       */

      function isPlainObject_isPlainObject(value) {
        if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != isPlainObject_objectTag) {
          return false;
        }

        var proto = _getPrototype(value);

        if (proto === null) {
          return true;
        }

        var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor && isPlainObject_funcToString.call(Ctor) == isPlainObject_objectCtorString;
      }
      /* harmony default export */


      var lodash_es_isPlainObject = isPlainObject_isPlainObject; // EXTERNAL MODULE: ./node_modules/symbol-observable/es/index.js

      var es = __webpack_require__(122); // CONCATENATED MODULE: ./node_modules/redux/es/createStore.js

      /**
       * These are private action types reserved by Redux.
       * For any unknown actions, you must return the current state.
       * If the current state is undefined, you must return the initial state.
       * Do not reference these action types directly in your code.
       */


      var createStore_ActionTypes = {
        INIT: '@@redux/INIT'
        /**
         * Creates a Redux store that holds the state tree.
         * The only way to change the data in the store is to call `dispatch()` on it.
         *
         * There should only be a single store in your app. To specify how different
         * parts of the state tree respond to actions, you may combine several reducers
         * into a single reducer function by using `combineReducers`.
         *
         * @param {Function} reducer A function that returns the next state tree, given
         * the current state tree and the action to handle.
         *
         * @param {any} [preloadedState] The initial state. You may optionally specify it
         * to hydrate the state from the server in universal apps, or to restore a
         * previously serialized user session.
         * If you use `combineReducers` to produce the root reducer function, this must be
         * an object with the same shape as `combineReducers` keys.
         *
         * @param {Function} [enhancer] The store enhancer. You may optionally specify it
         * to enhance the store with third-party capabilities such as middleware,
         * time travel, persistence, etc. The only store enhancer that ships with Redux
         * is `applyMiddleware()`.
         *
         * @returns {Store} A Redux store that lets you read the state, dispatch actions
         * and subscribe to changes.
         */

      };

      function createStore_createStore(reducer, preloadedState, enhancer) {
        var _ref2;

        if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
          enhancer = preloadedState;
          preloadedState = undefined;
        }

        if (typeof enhancer !== 'undefined') {
          if (typeof enhancer !== 'function') {
            throw new Error('Expected the enhancer to be a function.');
          }

          return enhancer(createStore_createStore)(reducer, preloadedState);
        }

        if (typeof reducer !== 'function') {
          throw new Error('Expected the reducer to be a function.');
        }

        var currentReducer = reducer;
        var currentState = preloadedState;
        var currentListeners = [];
        var nextListeners = currentListeners;
        var isDispatching = false;

        function ensureCanMutateNextListeners() {
          if (nextListeners === currentListeners) {
            nextListeners = currentListeners.slice();
          }
        }
        /**
         * Reads the state tree managed by the store.
         *
         * @returns {any} The current state tree of your application.
         */


        function getState() {
          return currentState;
        }
        /**
         * Adds a change listener. It will be called any time an action is dispatched,
         * and some part of the state tree may potentially have changed. You may then
         * call `getState()` to read the current state tree inside the callback.
         *
         * You may call `dispatch()` from a change listener, with the following
         * caveats:
         *
         * 1. The subscriptions are snapshotted just before every `dispatch()` call.
         * If you subscribe or unsubscribe while the listeners are being invoked, this
         * will not have any effect on the `dispatch()` that is currently in progress.
         * However, the next `dispatch()` call, whether nested or not, will use a more
         * recent snapshot of the subscription list.
         *
         * 2. The listener should not expect to see all state changes, as the state
         * might have been updated multiple times during a nested `dispatch()` before
         * the listener is called. It is, however, guaranteed that all subscribers
         * registered before the `dispatch()` started will be called with the latest
         * state by the time it exits.
         *
         * @param {Function} listener A callback to be invoked on every dispatch.
         * @returns {Function} A function to remove this change listener.
         */


        function subscribe(listener) {
          if (typeof listener !== 'function') {
            throw new Error('Expected listener to be a function.');
          }

          var isSubscribed = true;
          ensureCanMutateNextListeners();
          nextListeners.push(listener);
          return function unsubscribe() {
            if (!isSubscribed) {
              return;
            }

            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
          };
        }
        /**
         * Dispatches an action. It is the only way to trigger a state change.
         *
         * The `reducer` function, used to create the store, will be called with the
         * current state tree and the given `action`. Its return value will
         * be considered the **next** state of the tree, and the change listeners
         * will be notified.
         *
         * The base implementation only supports plain object actions. If you want to
         * dispatch a Promise, an Observable, a thunk, or something else, you need to
         * wrap your store creating function into the corresponding middleware. For
         * example, see the documentation for the `redux-thunk` package. Even the
         * middleware will eventually dispatch plain object actions using this method.
         *
         * @param {Object} action A plain object representing “what changed”. It is
         * a good idea to keep actions serializable so you can record and replay user
         * sessions, or use the time travelling `redux-devtools`. An action must have
         * a `type` property which may not be `undefined`. It is a good idea to use
         * string constants for action types.
         *
         * @returns {Object} For convenience, the same action object you dispatched.
         *
         * Note that, if you use a custom middleware, it may wrap `dispatch()` to
         * return something else (for example, a Promise you can await).
         */


        function dispatch(action) {
          if (!lodash_es_isPlainObject(action)) {
            throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
          }

          if (typeof action.type === 'undefined') {
            throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
          }

          if (isDispatching) {
            throw new Error('Reducers may not dispatch actions.');
          }

          try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
          } finally {
            isDispatching = false;
          }

          var listeners = currentListeners = nextListeners;

          for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            listener();
          }

          return action;
        }
        /**
         * Replaces the reducer currently used by the store to calculate the state.
         *
         * You might need this if your app implements code splitting and you want to
         * load some of the reducers dynamically. You might also need this if you
         * implement a hot reloading mechanism for Redux.
         *
         * @param {Function} nextReducer The reducer for the store to use instead.
         * @returns {void}
         */


        function replaceReducer(nextReducer) {
          if (typeof nextReducer !== 'function') {
            throw new Error('Expected the nextReducer to be a function.');
          }

          currentReducer = nextReducer;
          dispatch({
            type: createStore_ActionTypes.INIT
          });
        }
        /**
         * Interoperability point for observable/reactive libraries.
         * @returns {observable} A minimal observable of state changes.
         * For more information, see the observable proposal:
         * https://github.com/tc39/proposal-observable
         */


        function observable() {
          var _ref;

          var outerSubscribe = subscribe;
          return _ref = {
            /**
             * The minimal observable subscription method.
             * @param {Object} observer Any object that can be used as an observer.
             * The observer object should have a `next` method.
             * @returns {subscription} An object with an `unsubscribe` method that can
             * be used to unsubscribe the observable from the store, and prevent further
             * emission of values from the observable.
             */
            subscribe: function subscribe(observer) {
              if (typeof observer !== 'object') {
                throw new TypeError('Expected the observer to be an object.');
              }

              function observeState() {
                if (observer.next) {
                  observer.next(getState());
                }
              }

              observeState();
              var unsubscribe = outerSubscribe(observeState);
              return {
                unsubscribe: unsubscribe
              };
            }
          }, _ref[es["default"]] = function () {
            return this;
          }, _ref;
        } // When a store is created, an "INIT" action is dispatched so that every
        // reducer returns their initial state. This effectively populates
        // the initial state tree.


        dispatch({
          type: createStore_ActionTypes.INIT
        });
        return _ref2 = {
          dispatch: dispatch,
          subscribe: subscribe,
          getState: getState,
          replaceReducer: replaceReducer
        }, _ref2[es["default"]] = observable, _ref2;
      } // CONCATENATED MODULE: ./node_modules/redux/es/utils/warning.js

      /**
       * Prints a warning in the console if it exists.
       *
       * @param {String} message The warning message.
       * @returns {void}
       */


      function warning(message) {
        /* eslint-disable no-console */
        if (typeof console !== 'undefined' && typeof console.error === 'function') {
          console.error(message);
        }
        /* eslint-enable no-console */


        try {
          // This error was thrown as a convenience so that if you enable
          // "break on all exceptions" in your console,
          // it would pause the execution at this line.
          throw new Error(message);
          /* eslint-disable no-empty */
        } catch (e) {}
        /* eslint-enable no-empty */

      } // CONCATENATED MODULE: ./node_modules/redux/es/combineReducers.js


      function combineReducers_getUndefinedStateErrorMessage(key, action) {
        var actionType = action && action.type;
        var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
        return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
      }

      function combineReducers_getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
        var reducerKeys = Object.keys(reducers);
        var argumentName = action && action.type === createStore_ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

        if (reducerKeys.length === 0) {
          return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
        }

        if (!lodash_es_isPlainObject(inputState)) {
          return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
        }

        var unexpectedKeys = Object.keys(inputState).filter(function (key) {
          return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
        });
        unexpectedKeys.forEach(function (key) {
          unexpectedKeyCache[key] = true;
        });

        if (unexpectedKeys.length > 0) {
          return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
        }
      }

      function combineReducers_assertReducerShape(reducers) {
        Object.keys(reducers).forEach(function (key) {
          var reducer = reducers[key];
          var initialState = reducer(undefined, {
            type: createStore_ActionTypes.INIT
          });

          if (typeof initialState === 'undefined') {
            throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
          }

          var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');

          if (typeof reducer(undefined, {
            type: type
          }) === 'undefined') {
            throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + createStore_ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
          }
        });
      }
      /**
       * Turns an object whose values are different reducer functions, into a single
       * reducer function. It will call every child reducer, and gather their results
       * into a single state object, whose keys correspond to the keys of the passed
       * reducer functions.
       *
       * @param {Object} reducers An object whose values correspond to different
       * reducer functions that need to be combined into one. One handy way to obtain
       * it is to use ES6 `import * as reducers` syntax. The reducers may never return
       * undefined for any action. Instead, they should return their initial state
       * if the state passed to them was undefined, and the current state for any
       * unrecognized action.
       *
       * @returns {Function} A reducer function that invokes every reducer inside the
       * passed object, and builds a state object with the same shape.
       */


      function combineReducers_combineReducers(reducers) {
        var reducerKeys = Object.keys(reducers);
        var finalReducers = {};

        for (var i = 0; i < reducerKeys.length; i++) {
          var key = reducerKeys[i];

          if (false) {}

          if (typeof reducers[key] === 'function') {
            finalReducers[key] = reducers[key];
          }
        }

        var finalReducerKeys = Object.keys(finalReducers);
        var unexpectedKeyCache = void 0;

        if (false) {}

        var shapeAssertionError = void 0;

        try {
          combineReducers_assertReducerShape(finalReducers);
        } catch (e) {
          shapeAssertionError = e;
        }

        return function combination() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var action = arguments[1];

          if (shapeAssertionError) {
            throw shapeAssertionError;
          }

          if (false) {
            var warningMessage;
          }

          var hasChanged = false;
          var nextState = {};

          for (var _i = 0; _i < finalReducerKeys.length; _i++) {
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);

            if (typeof nextStateForKey === 'undefined') {
              var errorMessage = combineReducers_getUndefinedStateErrorMessage(_key, action);
              throw new Error(errorMessage);
            }

            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
          }

          return hasChanged ? nextState : state;
        };
      } // CONCATENATED MODULE: ./node_modules/redux/es/bindActionCreators.js


      function bindActionCreator(actionCreator, dispatch) {
        return function () {
          return dispatch(actionCreator.apply(undefined, arguments));
        };
      }
      /**
       * Turns an object whose values are action creators, into an object with the
       * same keys, but with every function wrapped into a `dispatch` call so they
       * may be invoked directly. This is just a convenience method, as you can call
       * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
       *
       * For convenience, you can also pass a single function as the first argument,
       * and get a function in return.
       *
       * @param {Function|Object} actionCreators An object whose values are action
       * creator functions. One handy way to obtain it is to use ES6 `import * as`
       * syntax. You may also pass a single function.
       *
       * @param {Function} dispatch The `dispatch` function available on your Redux
       * store.
       *
       * @returns {Function|Object} The object mimicking the original object, but with
       * every action creator wrapped into the `dispatch` call. If you passed a
       * function as `actionCreators`, the return value will also be a single
       * function.
       */


      function bindActionCreators(actionCreators, dispatch) {
        if (typeof actionCreators === 'function') {
          return bindActionCreator(actionCreators, dispatch);
        }

        if (typeof actionCreators !== 'object' || actionCreators === null) {
          throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
        }

        var keys = Object.keys(actionCreators);
        var boundActionCreators = {};

        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          var actionCreator = actionCreators[key];

          if (typeof actionCreator === 'function') {
            boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
          }
        }

        return boundActionCreators;
      } // CONCATENATED MODULE: ./node_modules/redux/es/compose.js

      /**
       * Composes single-argument functions from right to left. The rightmost
       * function can take multiple arguments as it provides the signature for
       * the resulting composite function.
       *
       * @param {...Function} funcs The functions to compose.
       * @returns {Function} A function obtained by composing the argument functions
       * from right to left. For example, compose(f, g, h) is identical to doing
       * (...args) => f(g(h(...args))).
       */


      function compose() {
        for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
          funcs[_key] = arguments[_key];
        }

        if (funcs.length === 0) {
          return function (arg) {
            return arg;
          };
        }

        if (funcs.length === 1) {
          return funcs[0];
        }

        return funcs.reduce(function (a, b) {
          return function () {
            return a(b.apply(undefined, arguments));
          };
        });
      } // CONCATENATED MODULE: ./node_modules/redux/es/applyMiddleware.js


      var applyMiddleware_extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };
      /**
       * Creates a store enhancer that applies middleware to the dispatch method
       * of the Redux store. This is handy for a variety of tasks, such as expressing
       * asynchronous actions in a concise manner, or logging every action payload.
       *
       * See `redux-thunk` package as an example of the Redux middleware.
       *
       * Because middleware is potentially asynchronous, this should be the first
       * store enhancer in the composition chain.
       *
       * Note that each middleware will be given the `dispatch` and `getState` functions
       * as named arguments.
       *
       * @param {...Function} middlewares The middleware chain to be applied.
       * @returns {Function} A store enhancer applying the middleware.
       */


      function applyMiddleware_applyMiddleware() {
        for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
          middlewares[_key] = arguments[_key];
        }

        return function (createStore) {
          return function (reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
              getState: store.getState,
              dispatch: function dispatch(action) {
                return _dispatch(action);
              }
            };
            chain = middlewares.map(function (middleware) {
              return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(undefined, chain)(store.dispatch);
            return applyMiddleware_extends({}, store, {
              dispatch: _dispatch
            });
          };
        };
      } // CONCATENATED MODULE: ./node_modules/redux/es/index.js

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "createStore", function () {
        return createStore_createStore;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "combineReducers", function () {
        return combineReducers_combineReducers;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "bindActionCreators", function () {
        return bindActionCreators;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "applyMiddleware", function () {
        return applyMiddleware_applyMiddleware;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "compose", function () {
        return compose;
      });
      /*
      * This is a dummy function to check if the function name has been altered by minification.
      * If the function has been minified and NODE_ENV !== 'production', warn the user.
      */


      function es_isCrushed() {}

      if (false) {}
      /***/

    },
    /* 95 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return HelpTextConstants;
      });
      /* unused harmony export HelpTextDefaultProps */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return HelpTextPositions;
      });
      /* unused harmony export HelpTextPropTypes */

      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11);
      /* harmony import */


      var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_9___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
      /* harmony import */


      var recompose__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_11___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_12___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_12__);
      /* harmony import */


      var antd_lib_popover_index__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(670);
      /* harmony import */


      var antd_lib_popover_index__WEBPACK_IMPORTED_MODULE_13___default =
      /*#__PURE__*/
      __webpack_require__.n(antd_lib_popover_index__WEBPACK_IMPORTED_MODULE_13__);
      /* harmony import */


      var _components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15);
      /* harmony import */


      var _withFieldToken__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(34);

      var HelpTextConstants = {
        DefaultPlacement: 'topRight',
        DefaultPosition: 'right'
      };
      var HelpTextDefaultProps = {
        helpText: '',
        helpTextTitle: '',
        helpTextPosition: HelpTextConstants.DefaultPosition,
        helpTextPlacement: HelpTextConstants.DefaultPlacement
      };
      var HelpTextPositions = {
        topLeft: 'topLeft',
        top: 'top',
        topRight: 'topRight',
        leftTop: 'leftTop',
        left: 'left',
        leftBottom: 'leftBottom',
        rightTop: 'rightTop',
        right: 'right',
        rightBottom: 'rightBottom',
        bottomLeft: 'bottomLeft',
        bottom: 'bottom',
        bottomRight: 'bottomRight'
      };
      var HelpTextPropTypes = {
        helpText: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,
        helpTextTitle: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,
        helpTextPosition: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOf([HelpTextPositions.left, HelpTextPositions.right]),
        helpTextPlacement: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOf([HelpTextPositions.topLeft, HelpTextPositions.top, HelpTextPositions.topRight, HelpTextPositions.leftTop, HelpTextPositions.left, HelpTextPositions.leftBottom, HelpTextPositions.rightTop, HelpTextPositions.right, HelpTextPositions.rightBottom, HelpTextPositions.bottomLeft, HelpTextPositions.bottom, HelpTextPositions.bottomRight])
      };

      var withHelpText = function withHelpText(WrappedComponent) {
        var WithHelpTextComponent =
        /*#__PURE__*/
        function (_Component) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(WithHelpTextComponent, _Component);

          function WithHelpTextComponent(props) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, WithHelpTextComponent);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(WithHelpTextComponent).call(this, props));

            _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "getHelperTip", function () {
              var _this$props$attribute = _this.props.attributes,
                  _this$props$attribute2 = _this$props$attribute.helpText,
                  helpText = _this$props$attribute2 === void 0 ? '' : _this$props$attribute2,
                  _this$props$attribute3 = _this$props$attribute.helpTextPlacement,
                  helpTextPlacement = _this$props$attribute3 === void 0 ? HelpTextPositions.left : _this$props$attribute3,
                  _this$props$attribute4 = _this$props$attribute.helpTextPosition,
                  helpTextPosition = _this$props$attribute4 === void 0 ? HelpTextConstants.DefaultPosition : _this$props$attribute4,
                  helpTextTitle = _this$props$attribute.helpTextTitle;

              if (helpText) {
                var content = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(_components__WEBPACK_IMPORTED_MODULE_14__[
                /* RichTextArea */
                "y"], {
                  html: helpText
                });
                return react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement("div", {
                  className: "formatic-with-help-text__container formatic-with-help-text__container--".concat(helpTextPosition)
                }, react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(antd_lib_popover_index__WEBPACK_IMPORTED_MODULE_13___default.a, {
                  content: content,
                  onVisibleChange: function onVisibleChange(helpIsVisible) {
                    _this.setState({
                      helpIsVisible: helpIsVisible
                    });
                  },
                  overlayClassName: "formatic-with-help-text__popover",
                  placement: helpTextPlacement,
                  title: helpTextTitle,
                  trigger: "hover",
                  visible: _this.state.helpIsVisible
                }, react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement("span", {
                  className: "formatic-with-help-text__question-mark"
                }, "?")));
              }

              return null;
            });

            _this.state = {
              helpIsVisible: false
            };
            _this.displayName = Object(recompose__WEBPACK_IMPORTED_MODULE_10__[
            /* wrapDisplayName */
            "d"])(WrappedComponent, 'withHelpText');
            return _this;
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(WithHelpTextComponent, [{
            key: "render",
            value: function render() {
              return react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(WrappedComponent, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({}, this.props, {
                helpContent: this.getHelperTip(),
                helpTextPosition: lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(this.props, 'attributes.helpTextPosition', HelpTextConstants.DefaultPosition)
              }));
            }
          }]);

          return WithHelpTextComponent;
        }(react__WEBPACK_IMPORTED_MODULE_9__["Component"]);

        WithHelpTextComponent.defaultProps = {
          attributes: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({
            class: '',
            tag: ''
          }, HelpTextDefaultProps)
        };
        WithHelpTextComponent.propTypes = {
          attributes: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.shape(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({
            class: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,
            tag: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string
          }, HelpTextPropTypes))
        };
        return Object(_withFieldToken__WEBPACK_IMPORTED_MODULE_15__[
        /* default */
        "a"])(['attributes.helpText', 'attributes.helpTextTitle'])(WithHelpTextComponent);
      };
      /* harmony default export */


      __webpack_exports__["c"] = withHelpText;
      /***/
    },
    /* 96 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule CharacterMetadata
       * @format
       * 
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var _require = __webpack_require__(53),
          Map = _require.Map,
          OrderedSet = _require.OrderedSet,
          Record = _require.Record; // Immutable.map is typed such that the value for every key in the map
      // must be the same type


      var EMPTY_SET = OrderedSet();
      var defaultRecord = {
        style: EMPTY_SET,
        entity: null
      };
      var CharacterMetadataRecord = Record(defaultRecord);

      var CharacterMetadata = function (_CharacterMetadataRec) {
        _inherits(CharacterMetadata, _CharacterMetadataRec);

        function CharacterMetadata() {
          _classCallCheck(this, CharacterMetadata);

          return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
        }

        CharacterMetadata.prototype.getStyle = function getStyle() {
          return this.get('style');
        };

        CharacterMetadata.prototype.getEntity = function getEntity() {
          return this.get('entity');
        };

        CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
          return this.getStyle().includes(style);
        };

        CharacterMetadata.applyStyle = function applyStyle(record, style) {
          var withStyle = record.set('style', record.getStyle().add(style));
          return CharacterMetadata.create(withStyle);
        };

        CharacterMetadata.removeStyle = function removeStyle(record, style) {
          var withoutStyle = record.set('style', record.getStyle().remove(style));
          return CharacterMetadata.create(withoutStyle);
        };

        CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
          var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
          return CharacterMetadata.create(withEntity);
        };
        /**
         * Use this function instead of the `CharacterMetadata` constructor.
         * Since most content generally uses only a very small number of
         * style/entity permutations, we can reuse these objects as often as
         * possible.
         */


        CharacterMetadata.create = function create(config) {
          if (!config) {
            return EMPTY;
          }

          var defaultConfig = {
            style: EMPTY_SET,
            entity: null
          }; // Fill in unspecified properties, if necessary.

          var configMap = Map(defaultConfig).merge(config);
          var existing = pool.get(configMap);

          if (existing) {
            return existing;
          }

          var newCharacter = new CharacterMetadata(configMap);
          pool = pool.set(configMap, newCharacter);
          return newCharacter;
        };

        return CharacterMetadata;
      }(CharacterMetadataRecord);

      var EMPTY = new CharacterMetadata();
      var pool = Map([[Map(defaultRecord), EMPTY]]);
      CharacterMetadata.EMPTY = EMPTY;
      module.exports = CharacterMetadata;
      /***/
    },
    /* 97 */

    /***/
    function (module, exports) {
      /**
       * Checks if `value` is the
       * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
       * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(_.noop);
       * // => true
       *
       * _.isObject(null);
       * // => false
       */
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
      }

      module.exports = isObject;
      /***/
    },
    /* 98 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15);

      var ButtonContainer = function ButtonContainer(props) {
        return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_components__WEBPACK_IMPORTED_MODULE_5__[
        /* Button */
        "e"], {
          className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('formatic-button', _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, props.className, props.className), {
            'formatic-field-disabled': props.disabled
          }),
          onClick: props.onClick,
          type: props.type,
          disabled: props.disabled,
          label: props.label,
          value: props.value
        });
      };

      ButtonContainer.defaultProps = {
        className: '',
        disabled: false,
        label: '',
        onClick: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        type: 'button',
        value: ''
      };
      ButtonContainer.propTypes = {
        className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        disabled: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
        label: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        onClick: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        type: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
      };
      /* harmony default export */

      __webpack_exports__["a"] = ButtonContainer;
      /***/
    },
    /* 99 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
      /* harmony import */


      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var lodash_mapValues__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(691);
      /* harmony import */


      var lodash_mapValues__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_mapValues__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _formatic_form_logic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(142);
      /* harmony import */


      var _formatic_form_logic__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(_formatic_form_logic__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var lodash_replace__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84);
      /* harmony import */


      var lodash_replace__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_replace__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18);
      /* harmony import */


      var _core_RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54);
      /* harmony import */


      var _core_utils_tokens_tokens__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61);
      /**
       * Replace tokens by its content
       * @param {string} value
       * @param {object} tokensValues
       * @returns {string}
       */


      var replaceAllTokensByItsContent = function replaceAllTokensByItsContent(value, tokens) {
        var matches = Object(_core_utils_tokens_tokens__WEBPACK_IMPORTED_MODULE_9__[
        /* getTokensMatches */
        "b"])(value);

        if (Array.isArray(matches) && matches.length > 0) {
          var token;
          matches.forEach(function (match) {
            token = Object(_core_utils_tokens_tokens__WEBPACK_IMPORTED_MODULE_9__[
            /* removeTokensBrackets */
            "c"])(Object(_core_utils_tokens_tokens__WEBPACK_IMPORTED_MODULE_9__[
            /* replaceValuesAlias */
            "d"])(match));
            value = lodash_replace__WEBPACK_IMPORTED_MODULE_6___default()(value, match, lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(tokens, token, ''));
          });
        }

        return value;
      }; // Check the logic validations and return boolean

      /* harmony default export */


      __webpack_exports__["a"] = function (data, logic, props) {
        var keys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var tokens = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {}; // if the logic is an string then try to convert to object

        if (typeof logic === 'string') {
          logic = Object(_utils__WEBPACK_IMPORTED_MODULE_7__[
          /* safeJSONParse */
          "s"])(logic);
        } // if an input mask is applied against field values, need to validate against the raw value, not the transformed input value


        data = lodash_mapValues__WEBPACK_IMPORTED_MODULE_3___default()(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2___default()(data), function (value) {
          return Object(_utils__WEBPACK_IMPORTED_MODULE_7__[
          /* valueHasInputMask */
          "t"])(value) ? Object(_utils__WEBPACK_IMPORTED_MODULE_7__[
          /* getInputRawValue */
          "d"])(value) : value;
        }); // Allows keys to be overridden

        var defaultKeys = {
          channel: 'data.variables.channel',
          branch: 'data.variables.branch',
          flow: 'flow.current',
          currentPage: 'currentPage'
        };

        var searchKeys = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, defaultKeys, keys); // replace all tokens by its values in logic before being evaluated by formLogic library


        if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(tokens) === 'object' && Object.keys(tokens).length > 0 && typeof logic.rules !== 'undefined' && Array.isArray(logic.rules)) {
          logic = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2___default()(logic);
          logic.rules.forEach(function (rule, index) {
            if (typeof rule.value === 'string') {
              logic.rules[index].value = replaceAllTokensByItsContent(rule.value, tokens);
            }
          });
        }

        var channel = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(props, searchKeys.channel, 'master');
        var branch = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(props, searchKeys.branch, 'Live');
        var flow = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(props, searchKeys.flow, _core_RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_8__[
        /* Constants */
        "a"].DefaultFlow);
        var currentPage = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(props, "".concat(searchKeys.currentPage, ".").concat(channel, ".pageId"), '');
        data = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, data, {
          branch: branch,
          channel: channel,
          flow: flow,
          currentPage: currentPage
        });
        return logic && Object(_formatic_form_logic__WEBPACK_IMPORTED_MODULE_4__["formLogic"])(data, logic);
      };
      /***/

    },
    /* 100 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayWithHoles = __webpack_require__(897);

      var iterableToArrayLimit = __webpack_require__(896);

      var nonIterableRest = __webpack_require__(895);

      function _slicedToArray(arr, i) {
        return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
      }

      module.exports = _slicedToArray;
      /***/
    },
    /* 101 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var bind = __webpack_require__(420);

      var isBuffer = __webpack_require__(824);
      /*global toString:true*/
      // utils is a library of generic helper functions non-specific to axios


      var toString = Object.prototype.toString;
      /**
       * Determine if a value is an Array
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an Array, otherwise false
       */

      function isArray(val) {
        return toString.call(val) === '[object Array]';
      }
      /**
       * Determine if a value is an ArrayBuffer
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an ArrayBuffer, otherwise false
       */


      function isArrayBuffer(val) {
        return toString.call(val) === '[object ArrayBuffer]';
      }
      /**
       * Determine if a value is a FormData
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an FormData, otherwise false
       */


      function isFormData(val) {
        return typeof FormData !== 'undefined' && val instanceof FormData;
      }
      /**
       * Determine if a value is a view on an ArrayBuffer
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
       */


      function isArrayBufferView(val) {
        var result;

        if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
          result = ArrayBuffer.isView(val);
        } else {
          result = val && val.buffer && val.buffer instanceof ArrayBuffer;
        }

        return result;
      }
      /**
       * Determine if a value is a String
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a String, otherwise false
       */


      function isString(val) {
        return typeof val === 'string';
      }
      /**
       * Determine if a value is a Number
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Number, otherwise false
       */


      function isNumber(val) {
        return typeof val === 'number';
      }
      /**
       * Determine if a value is undefined
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if the value is undefined, otherwise false
       */


      function isUndefined(val) {
        return typeof val === 'undefined';
      }
      /**
       * Determine if a value is an Object
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an Object, otherwise false
       */


      function isObject(val) {
        return val !== null && typeof val === 'object';
      }
      /**
       * Determine if a value is a Date
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Date, otherwise false
       */


      function isDate(val) {
        return toString.call(val) === '[object Date]';
      }
      /**
       * Determine if a value is a File
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a File, otherwise false
       */


      function isFile(val) {
        return toString.call(val) === '[object File]';
      }
      /**
       * Determine if a value is a Blob
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Blob, otherwise false
       */


      function isBlob(val) {
        return toString.call(val) === '[object Blob]';
      }
      /**
       * Determine if a value is a Function
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Function, otherwise false
       */


      function isFunction(val) {
        return toString.call(val) === '[object Function]';
      }
      /**
       * Determine if a value is a Stream
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Stream, otherwise false
       */


      function isStream(val) {
        return isObject(val) && isFunction(val.pipe);
      }
      /**
       * Determine if a value is a URLSearchParams object
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a URLSearchParams object, otherwise false
       */


      function isURLSearchParams(val) {
        return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
      }
      /**
       * Trim excess whitespace off the beginning and end of a string
       *
       * @param {String} str The String to trim
       * @returns {String} The String freed of excess whitespace
       */


      function trim(str) {
        return str.replace(/^\s*/, '').replace(/\s*$/, '');
      }
      /**
       * Determine if we're running in a standard browser environment
       *
       * This allows axios to run in a web worker, and react-native.
       * Both environments support XMLHttpRequest, but not fully standard globals.
       *
       * web workers:
       *  typeof window -> undefined
       *  typeof document -> undefined
       *
       * react-native:
       *  navigator.product -> 'ReactNative'
       */


      function isStandardBrowserEnv() {
        if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
          return false;
        }

        return typeof window !== 'undefined' && typeof document !== 'undefined';
      }
      /**
       * Iterate over an Array or an Object invoking a function for each item.
       *
       * If `obj` is an Array callback will be called passing
       * the value, index, and complete array for each item.
       *
       * If 'obj' is an Object callback will be called passing
       * the value, key, and complete object for each property.
       *
       * @param {Object|Array} obj The object to iterate
       * @param {Function} fn The callback to invoke for each item
       */


      function forEach(obj, fn) {
        // Don't bother if no value provided
        if (obj === null || typeof obj === 'undefined') {
          return;
        } // Force an array if not already something iterable


        if (typeof obj !== 'object' && !isArray(obj)) {
          /*eslint no-param-reassign:0*/
          obj = [obj];
        }

        if (isArray(obj)) {
          // Iterate over array values
          for (var i = 0, l = obj.length; i < l; i++) {
            fn.call(null, obj[i], i, obj);
          }
        } else {
          // Iterate over object keys
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
              fn.call(null, obj[key], key, obj);
            }
          }
        }
      }
      /**
       * Accepts varargs expecting each argument to be an object, then
       * immutably merges the properties of each object and returns result.
       *
       * When multiple objects contain the same key the later object in
       * the arguments list will take precedence.
       *
       * Example:
       *
       * ```js
       * var result = merge({foo: 123}, {foo: 456});
       * console.log(result.foo); // outputs 456
       * ```
       *
       * @param {Object} obj1 Object to merge
       * @returns {Object} Result of all merge properties
       */


      function merge()
      /* obj1, obj2, obj3, ... */
      {
        var result = {};

        function assignValue(val, key) {
          if (typeof result[key] === 'object' && typeof val === 'object') {
            result[key] = merge(result[key], val);
          } else {
            result[key] = val;
          }
        }

        for (var i = 0, l = arguments.length; i < l; i++) {
          forEach(arguments[i], assignValue);
        }

        return result;
      }
      /**
       * Extends object a by mutably adding to it the properties of object b.
       *
       * @param {Object} a The object to be extended
       * @param {Object} b The object to copy properties from
       * @param {Object} thisArg The object to bind function to
       * @return {Object} The resulting value of object a
       */


      function extend(a, b, thisArg) {
        forEach(b, function assignValue(val, key) {
          if (thisArg && typeof val === 'function') {
            a[key] = bind(val, thisArg);
          } else {
            a[key] = val;
          }
        });
        return a;
      }

      module.exports = {
        isArray: isArray,
        isArrayBuffer: isArrayBuffer,
        isBuffer: isBuffer,
        isFormData: isFormData,
        isArrayBufferView: isArrayBufferView,
        isString: isString,
        isNumber: isNumber,
        isObject: isObject,
        isUndefined: isUndefined,
        isDate: isDate,
        isFile: isFile,
        isBlob: isBlob,
        isFunction: isFunction,
        isStream: isStream,
        isURLSearchParams: isURLSearchParams,
        isStandardBrowserEnv: isStandardBrowserEnv,
        forEach: forEach,
        merge: merge,
        extend: extend,
        trim: trim
      };
      /***/
    },
    /* 102 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule ContentBlockNode
       * @format
       * 
       *
       * This file is a fork of ContentBlock adding support for nesting references by
       * providing links to children, parent, prevSibling, and nextSibling.
       *
       * This is unstable and not part of the public API and should not be used by
       * production systems. This file may be update/removed without notice.
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var CharacterMetadata = __webpack_require__(96);

      var Immutable = __webpack_require__(53);

      var findRangesImmutable = __webpack_require__(205);

      var List = Immutable.List,
          Map = Immutable.Map,
          OrderedSet = Immutable.OrderedSet,
          Record = Immutable.Record,
          Repeat = Immutable.Repeat;
      var EMPTY_SET = OrderedSet();
      var defaultRecord = {
        parent: null,
        characterList: List(),
        data: Map(),
        depth: 0,
        key: '',
        text: '',
        type: 'unstyled',
        children: List(),
        prevSibling: null,
        nextSibling: null
      };

      var haveEqualStyle = function haveEqualStyle(charA, charB) {
        return charA.getStyle() === charB.getStyle();
      };

      var haveEqualEntity = function haveEqualEntity(charA, charB) {
        return charA.getEntity() === charB.getEntity();
      };

      var decorateCharacterList = function decorateCharacterList(config) {
        if (!config) {
          return config;
        }

        var characterList = config.characterList,
            text = config.text;

        if (text && !characterList) {
          config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
        }

        return config;
      };

      var ContentBlockNode = function (_Record) {
        _inherits(ContentBlockNode, _Record);

        function ContentBlockNode() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;

          _classCallCheck(this, ContentBlockNode);

          return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
        }

        ContentBlockNode.prototype.getKey = function getKey() {
          return this.get('key');
        };

        ContentBlockNode.prototype.getType = function getType() {
          return this.get('type');
        };

        ContentBlockNode.prototype.getText = function getText() {
          return this.get('text');
        };

        ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
          return this.get('characterList');
        };

        ContentBlockNode.prototype.getLength = function getLength() {
          return this.getText().length;
        };

        ContentBlockNode.prototype.getDepth = function getDepth() {
          return this.get('depth');
        };

        ContentBlockNode.prototype.getData = function getData() {
          return this.get('data');
        };

        ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
          var character = this.getCharacterList().get(offset);
          return character ? character.getStyle() : EMPTY_SET;
        };

        ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
          var character = this.getCharacterList().get(offset);
          return character ? character.getEntity() : null;
        };

        ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
          return this.get('children');
        };

        ContentBlockNode.prototype.getParentKey = function getParentKey() {
          return this.get('parent');
        };

        ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
          return this.get('prevSibling');
        };

        ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
          return this.get('nextSibling');
        };

        ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
          findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
        };

        ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
          findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
        };

        return ContentBlockNode;
      }(Record(defaultRecord));

      module.exports = ContentBlockNode;
      /***/
    },
    /* 103 */

    /***/
    function (module, exports, __webpack_require__) {
      var freeGlobal = __webpack_require__(514);
      /** Detect free variable `self`. */


      var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
      /** Used as a reference to the global object. */

      var root = freeGlobal || freeSelf || Function('return this')();
      module.exports = root;
      /***/
    },
    /* 104 */

    /***/
    function (module, exports) {
      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }

      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
              args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }

            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }

            _next(undefined);
          });
        };
      }

      module.exports = _asyncToGenerator;
      /***/
    },
    /* 105 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}


      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_ = __webpack_require__(16);

      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_); // EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js


      var KeyCode = __webpack_require__(19); // EXTERNAL MODULE: ./node_modules/rc-util/es/Children/toArray.js


      var Children_toArray = __webpack_require__(118); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 3 modules


      var Animate = __webpack_require__(43); // EXTERNAL MODULE: ./node_modules/component-classes/index.js


      var component_classes = __webpack_require__(149);

      var component_classes_default =
      /*#__PURE__*/
      __webpack_require__.n(component_classes); // EXTERNAL MODULE: ./node_modules/rc-menu/es/index.js + 10 modules


      var es = __webpack_require__(74); // EXTERNAL MODULE: ./node_modules/warning/browser.js


      var browser = __webpack_require__(73);

      var browser_default =
      /*#__PURE__*/
      __webpack_require__.n(browser); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // CONCATENATED MODULE: ./node_modules/rc-select/es/Option.js


      var Option_Option = function (_React$Component) {
        inherits_default()(Option, _React$Component);

        function Option() {
          classCallCheck_default()(this, Option);
          return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
        }

        return Option;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Option_Option.propTypes = {
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number])
      };
      Option_Option.isSelectOption = true;
      /* harmony default export */

      var es_Option = Option_Option; // CONCATENATED MODULE: ./node_modules/rc-select/es/util.js

      function util_getValuePropValue(child) {
        var props = child.props;

        if ('value' in props) {
          return props.value;
        }

        if (child.key) {
          return child.key;
        }

        if (child.type && child.type.isSelectOptGroup && props.label) {
          return props.label;
        }

        throw new Error('Need at least a key or a value or a label (only for OptGroup) for ' + child);
      }

      function util_getPropValue(child, prop) {
        if (prop === 'value') {
          return util_getValuePropValue(child);
        }

        return child.props[prop];
      }

      function util_isMultiple(props) {
        return props.multiple;
      }

      function util_isCombobox(props) {
        return props.combobox;
      }

      function util_isMultipleOrTags(props) {
        return props.multiple || props.tags;
      }

      function util_isMultipleOrTagsOrCombobox(props) {
        return util_isMultipleOrTags(props) || util_isCombobox(props);
      }

      function util_isSingleMode(props) {
        return !util_isMultipleOrTagsOrCombobox(props);
      }

      function util_toArray(value) {
        var ret = value;

        if (value === undefined) {
          ret = [];
        } else if (!Array.isArray(value)) {
          ret = [value];
        }

        return ret;
      }

      function util_getMapKey(value) {
        return typeof value + '-' + value;
      }

      function util_preventDefaultEvent(e) {
        e.preventDefault();
      }

      function util_findIndexInValueBySingleValue(value, singleValue) {
        var index = -1;

        for (var i = 0; i < value.length; i++) {
          if (value[i] === singleValue) {
            index = i;
            break;
          }
        }

        return index;
      }

      function util_getLabelFromPropsValue(value, key) {
        var label = void 0;
        value = util_toArray(value);

        for (var i = 0; i < value.length; i++) {
          if (value[i].key === key) {
            label = value[i].label;
            break;
          }
        }

        return label;
      }

      function util_getSelectKeys(menuItems, value) {
        if (value === null || value === undefined) {
          return [];
        }

        var selectedKeys = [];
        external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(menuItems, function (item) {
          if (item.type.isMenuItemGroup) {
            selectedKeys = selectedKeys.concat(util_getSelectKeys(item.props.children, value));
          } else {
            var itemValue = util_getValuePropValue(item);
            var itemKey = item.key;

            if (util_findIndexInValueBySingleValue(value, itemValue) !== -1 && itemKey) {
              selectedKeys.push(itemKey);
            }
          }
        });
        return selectedKeys;
      }

      var util_UNSELECTABLE_STYLE = {
        userSelect: 'none',
        WebkitUserSelect: 'none'
      };
      var util_UNSELECTABLE_ATTRIBUTE = {
        unselectable: 'unselectable'
      };

      function util_findFirstMenuItem(children) {
        for (var i = 0; i < children.length; i++) {
          var child = children[i];

          if (child.type.isMenuItemGroup) {
            var found = util_findFirstMenuItem(child.props.children);

            if (found) {
              return found;
            }
          } else if (!child.props.disabled) {
            return child;
          }
        }

        return null;
      }

      function util_includesSeparators(string, separators) {
        for (var i = 0; i < separators.length; ++i) {
          if (string.lastIndexOf(separators[i]) > 0) {
            return true;
          }
        }

        return false;
      }

      function util_splitBySeparators(string, separators) {
        var reg = new RegExp('[' + separators.join() + ']');
        return string.split(reg).filter(function (token) {
          return token;
        });
      }

      function util_defaultFilterFn(input, child) {
        if (child.props.disabled) {
          return false;
        }

        var value = util_toArray(util_getPropValue(child, this.props.optionFilterProp)).join('');
        return value.toLowerCase().indexOf(input.toLowerCase()) > -1;
      }

      function util_validateOptionValue(value, props) {
        if (util_isSingleMode(props) || util_isMultiple(props)) {
          return;
        }

        if (typeof value !== 'string') {
          throw new Error('Invalid `value` of type `' + typeof value + '` supplied to Option, ' + 'expected `string` when `tags/combobox` is `true`.');
        }
      }

      function util_saveRef(instance, name) {
        return function (node) {
          instance[name] = node;
        };
      } // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js


      var objectWithoutProperties = __webpack_require__(42);

      var objectWithoutProperties_default =
      /*#__PURE__*/
      __webpack_require__.n(objectWithoutProperties); // EXTERNAL MODULE: ./node_modules/rc-trigger/es/index.js + 20 modules


      var rc_trigger_es = __webpack_require__(75); // EXTERNAL MODULE: ./node_modules/dom-scroll-into-view/lib/index.js


      var lib = __webpack_require__(146);

      var lib_default =
      /*#__PURE__*/
      __webpack_require__.n(lib); // CONCATENATED MODULE: ./node_modules/rc-select/es/DropdownMenu.js


      var DropdownMenu_DropdownMenu = function (_React$Component) {
        inherits_default()(DropdownMenu, _React$Component);

        function DropdownMenu() {
          var _temp, _this, _ret;

          classCallCheck_default()(this, DropdownMenu);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.scrollActiveItemToView = function () {
            // scroll into view
            var itemComponent = Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"])(_this.firstActiveItem);
            var props = _this.props;

            if (itemComponent) {
              var scrollIntoViewOpts = {
                onlyScrollIfNeeded: true
              };

              if ((!props.value || props.value.length === 0) && props.firstActiveValue) {
                scrollIntoViewOpts.alignWithTop = true;
              }

              lib_default()(itemComponent, Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"])(_this.menuRef), scrollIntoViewOpts);
            }
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        DropdownMenu.prototype.componentWillMount = function componentWillMount() {
          this.lastInputValue = this.props.inputValue;
        };

        DropdownMenu.prototype.componentDidMount = function componentDidMount() {
          this.scrollActiveItemToView();
          this.lastVisible = this.props.visible;
        };

        DropdownMenu.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          if (!nextProps.visible) {
            this.lastVisible = false;
          } // freeze when hide


          return nextProps.visible;
        };

        DropdownMenu.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
          var props = this.props;

          if (!prevProps.visible && props.visible) {
            this.scrollActiveItemToView();
          }

          this.lastVisible = props.visible;
          this.lastInputValue = props.inputValue;
        };

        DropdownMenu.prototype.renderMenu = function renderMenu() {
          var _this2 = this;

          var props = this.props;
          var menuItems = props.menuItems,
              defaultActiveFirstOption = props.defaultActiveFirstOption,
              value = props.value,
              prefixCls = props.prefixCls,
              multiple = props.multiple,
              onMenuSelect = props.onMenuSelect,
              inputValue = props.inputValue,
              firstActiveValue = props.firstActiveValue,
              backfillValue = props.backfillValue;

          if (menuItems && menuItems.length) {
            var menuProps = {};

            if (multiple) {
              menuProps.onDeselect = props.onMenuDeselect;
              menuProps.onSelect = onMenuSelect;
            } else {
              menuProps.onClick = onMenuSelect;
            }

            var selectedKeys = util_getSelectKeys(menuItems, value);
            var activeKeyProps = {};
            var clonedMenuItems = menuItems;

            if (selectedKeys.length || firstActiveValue) {
              if (props.visible && !this.lastVisible) {
                activeKeyProps.activeKey = selectedKeys[0] || firstActiveValue;
              }

              var foundFirst = false; // set firstActiveItem via cloning menus
              // for scroll into view

              var clone = function clone(item) {
                if (!foundFirst && selectedKeys.indexOf(item.key) !== -1 || !foundFirst && !selectedKeys.length && firstActiveValue.indexOf(item.key) !== -1) {
                  foundFirst = true;
                  return Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"])(item, {
                    ref: function ref(_ref) {
                      _this2.firstActiveItem = _ref;
                    }
                  });
                }

                return item;
              };

              clonedMenuItems = menuItems.map(function (item) {
                if (item.type.isMenuItemGroup) {
                  var children = Object(Children_toArray["a"
                  /* default */
                  ])(item.props.children).map(clone);
                  return Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"])(item, {}, children);
                }

                return clone(item);
              });
            } // clear activeKey when inputValue change


            var lastValue = value && value[value.length - 1];

            if (inputValue !== this.lastInputValue && (!lastValue || lastValue !== backfillValue)) {
              activeKeyProps.activeKey = '';
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es["e"
            /* default */
            ], extends_default()({
              ref: util_saveRef(this, 'menuRef'),
              style: this.props.dropdownMenuStyle,
              defaultActiveFirst: defaultActiveFirstOption
            }, activeKeyProps, {
              multiple: multiple
            }, menuProps, {
              selectedKeys: selectedKeys,
              prefixCls: prefixCls + '-menu'
            }), clonedMenuItems);
          }

          return null;
        };

        DropdownMenu.prototype.render = function render() {
          var renderMenu = this.renderMenu();
          return renderMenu ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            style: {
              overflow: 'auto'
            },
            onFocus: this.props.onPopupFocus,
            onMouseDown: util_preventDefaultEvent,
            onScroll: this.props.onPopupScroll
          }, renderMenu) : null;
        };

        return DropdownMenu;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      DropdownMenu_DropdownMenu.propTypes = {
        defaultActiveFirstOption: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        dropdownMenuStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onPopupFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onPopupScroll: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMenuDeSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMenuSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        menuItems: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        inputValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var es_DropdownMenu = DropdownMenu_DropdownMenu;
      DropdownMenu_DropdownMenu.displayName = 'DropdownMenu'; // CONCATENATED MODULE: ./node_modules/rc-select/es/SelectTrigger.js

      rc_trigger_es["default"].displayName = 'Trigger';
      var SelectTrigger_BUILT_IN_PLACEMENTS = {
        bottomLeft: {
          points: ['tl', 'bl'],
          offset: [0, 4],
          overflow: {
            adjustX: 0,
            adjustY: 1
          }
        },
        topLeft: {
          points: ['bl', 'tl'],
          offset: [0, -4],
          overflow: {
            adjustX: 0,
            adjustY: 1
          }
        }
      };

      var SelectTrigger_SelectTrigger = function (_React$Component) {
        inherits_default()(SelectTrigger, _React$Component);

        function SelectTrigger() {
          var _temp, _this, _ret;

          classCallCheck_default()(this, SelectTrigger);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            dropdownWidth: null
          }, _this.setDropdownWidth = function () {
            var width = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(_this).offsetWidth;

            if (width !== _this.state.dropdownWidth) {
              _this.setState({
                dropdownWidth: width
              });
            }
          }, _this.getInnerMenu = function () {
            return _this.dropdownMenuRef && _this.dropdownMenuRef.menuRef;
          }, _this.getPopupDOMNode = function () {
            return _this.triggerRef.getPopupDomNode();
          }, _this.getDropdownElement = function (newProps) {
            var props = _this.props;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_DropdownMenu, extends_default()({
              ref: util_saveRef(_this, 'dropdownMenuRef')
            }, newProps, {
              prefixCls: _this.getDropdownPrefixCls(),
              onMenuSelect: props.onMenuSelect,
              onMenuDeselect: props.onMenuDeselect,
              onPopupScroll: props.onPopupScroll,
              value: props.value,
              backfillValue: props.backfillValue,
              firstActiveValue: props.firstActiveValue,
              defaultActiveFirstOption: props.defaultActiveFirstOption,
              dropdownMenuStyle: props.dropdownMenuStyle
            }));
          }, _this.getDropdownTransitionName = function () {
            var props = _this.props;
            var transitionName = props.transitionName;

            if (!transitionName && props.animation) {
              transitionName = _this.getDropdownPrefixCls() + '-' + props.animation;
            }

            return transitionName;
          }, _this.getDropdownPrefixCls = function () {
            return _this.props.prefixCls + '-dropdown';
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        SelectTrigger.prototype.componentDidMount = function componentDidMount() {
          this.setDropdownWidth();
        };

        SelectTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
          this.setDropdownWidth();
        };

        SelectTrigger.prototype.render = function render() {
          var _popupClassName;

          var _props = this.props,
              onPopupFocus = _props.onPopupFocus,
              props = objectWithoutProperties_default()(_props, ['onPopupFocus']);
          var multiple = props.multiple,
              visible = props.visible,
              inputValue = props.inputValue,
              dropdownAlign = props.dropdownAlign,
              disabled = props.disabled,
              showSearch = props.showSearch,
              dropdownClassName = props.dropdownClassName,
              dropdownStyle = props.dropdownStyle,
              dropdownMatchSelectWidth = props.dropdownMatchSelectWidth;
          var dropdownPrefixCls = this.getDropdownPrefixCls();
          var popupClassName = (_popupClassName = {}, _popupClassName[dropdownClassName] = !!dropdownClassName, _popupClassName[dropdownPrefixCls + '--' + (multiple ? 'multiple' : 'single')] = 1, _popupClassName);
          var popupElement = this.getDropdownElement({
            menuItems: props.options,
            onPopupFocus: onPopupFocus,
            multiple: multiple,
            inputValue: inputValue,
            visible: visible
          });
          var hideAction = void 0;

          if (disabled) {
            hideAction = [];
          } else if (util_isSingleMode(props) && !showSearch) {
            hideAction = ['click'];
          } else {
            hideAction = ['blur'];
          }

          var popupStyle = extends_default()({}, dropdownStyle);
          var widthProp = dropdownMatchSelectWidth ? 'width' : 'minWidth';

          if (this.state.dropdownWidth) {
            popupStyle[widthProp] = this.state.dropdownWidth + 'px';
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_trigger_es["default"], extends_default()({}, props, {
            showAction: disabled ? [] : this.props.showAction,
            hideAction: hideAction,
            ref: util_saveRef(this, 'triggerRef'),
            popupPlacement: 'bottomLeft',
            builtinPlacements: SelectTrigger_BUILT_IN_PLACEMENTS,
            prefixCls: dropdownPrefixCls,
            popupTransitionName: this.getDropdownTransitionName(),
            onPopupVisibleChange: props.onDropdownVisibleChange,
            popup: popupElement,
            popupAlign: dropdownAlign,
            popupVisible: visible,
            getPopupContainer: props.getPopupContainer,
            popupClassName: classnames_default()(popupClassName),
            popupStyle: popupStyle
          }), props.children);
        };

        return SelectTrigger;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      SelectTrigger_SelectTrigger.propTypes = {
        onPopupFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onPopupScroll: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        dropdownMatchSelectWidth: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        dropdownAlign: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        dropdownClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        inputValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        filterOption: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        options: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        popupClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        showAction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string)
      };
      /* harmony default export */

      var es_SelectTrigger = SelectTrigger_SelectTrigger;
      SelectTrigger_SelectTrigger.displayName = 'SelectTrigger'; // CONCATENATED MODULE: ./node_modules/rc-select/es/PropTypes.js

      function PropTypes_valueType(props, propName, componentName) {
        var basicType = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]);
        var labelInValueShape = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          key: basicType.isRequired,
          label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node
        });

        if (props.labelInValue) {
          var validate = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(labelInValueShape), labelInValueShape]);
          var error = validate.apply(undefined, arguments);

          if (error) {
            return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`, ' + ('when you set `labelInValue` to `true`, `' + propName + '` should in ') + 'shape of `{ key: string | number, label?: ReactNode }`.');
          }
        } else if ((props.mode === 'multiple' || props.mode === 'tags' || props.multiple || props.tags) && props[propName] === '') {
          return new Error('Invalid prop `' + propName + '` of type `string` supplied to `' + componentName + '`, ' + 'expected `array` when `multiple` or `tags` is `true`.');
        } else {
          var _validate = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(basicType), basicType]);

          return _validate.apply(undefined, arguments);
        }
      }

      var PropTypes_SelectPropTypes = {
        defaultActiveFirstOption: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        filterOption: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        showSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        allowClear: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showArrow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        tags: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        transitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        optionLabelProp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        optionFilterProp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        animation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        choiceTransitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onPopupScroll: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onInputKeyDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        onDeselect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        labelInValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        value: PropTypes_valueType,
        defaultValue: PropTypes_valueType,
        dropdownStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        maxTagTextLength: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        maxTagCount: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        maxTagPlaceholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        tokenSeparators: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        getInputElement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        showAction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string)
      }; // CONCATENATED MODULE: ./node_modules/rc-select/es/Select.js

      /* eslint func-names: 1 */

      function Select_noop() {}

      function Select_chaining() {
        for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
          fns[_key] = arguments[_key];
        }

        return function () {
          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          } // eslint-disable-line
          // eslint-disable-line


          for (var i = 0; i < fns.length; i++) {
            if (fns[i] && typeof fns[i] === 'function') {
              fns[i].apply(this, args);
            }
          }
        };
      }

      var Select_Select = function (_React$Component) {
        inherits_default()(Select, _React$Component);

        function Select(props) {
          classCallCheck_default()(this, Select);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          Select_initialiseProps.call(_this);

          var value = _this.getValueFromProps(props);

          var optionsInfo = _this.getOptionsInfoFromProps(props);

          var inputValue = '';

          if (props.combobox) {
            inputValue = value.length ? _this.getLabelBySingleValue(value[0], optionsInfo) : '';
          }

          var open = props.open;

          if (open === undefined) {
            open = props.defaultOpen;
          }

          _this.state = {
            value: value,
            inputValue: inputValue,
            open: open,
            optionsInfo: optionsInfo
          };

          _this.adjustOpenState();

          return _this;
        }

        Select.prototype.componentDidMount = function componentDidMount() {
          if (this.props.autoFocus) {
            this.focus();
          }
        };

        Select.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
          this.props = nextProps;
          this.state = nextState;
          this.adjustOpenState();
        };

        Select.prototype.componentDidUpdate = function componentDidUpdate() {
          if (util_isMultipleOrTags(this.props)) {
            var inputNode = this.getInputDOMNode();
            var mirrorNode = this.getInputMirrorDOMNode();

            if (inputNode.value) {
              inputNode.style.width = '';
              inputNode.style.width = mirrorNode.clientWidth + 'px';
            } else {
              inputNode.style.width = '';
            }
          }
        };

        Select.prototype.componentWillUnmount = function componentWillUnmount() {
          this.clearFocusTime();
          this.clearBlurTime();
          this.clearAdjustTimer();

          if (this.dropdownContainer) {
            external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.unmountComponentAtNode(this.dropdownContainer);
            document.body.removeChild(this.dropdownContainer);
            this.dropdownContainer = null;
          }
        }; // combobox ignore


        Select.prototype.focus = function focus() {
          if (util_isSingleMode(this.props)) {
            this.selectionRef.focus();
          } else {
            this.getInputDOMNode().focus();
          }
        };

        Select.prototype.blur = function blur() {
          if (util_isSingleMode(this.props)) {
            this.selectionRef.blur();
          } else {
            this.getInputDOMNode().blur();
          }
        };

        Select.prototype.renderClear = function renderClear() {
          var _props = this.props,
              prefixCls = _props.prefixCls,
              allowClear = _props.allowClear;
          var _state = this.state,
              value = _state.value,
              inputValue = _state.inputValue;
          var clear = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', extends_default()({
            key: 'clear',
            onMouseDown: util_preventDefaultEvent,
            style: util_UNSELECTABLE_STYLE
          }, util_UNSELECTABLE_ATTRIBUTE, {
            className: prefixCls + '-selection__clear',
            onClick: this.onClearSelection
          }));

          if (!allowClear) {
            return null;
          }

          if (util_isCombobox(this.props)) {
            if (inputValue) {
              return clear;
            }

            return null;
          }

          if (inputValue || value.length) {
            return clear;
          }

          return null;
        };

        Select.prototype.render = function render() {
          var _rootCls;

          var props = this.props;
          var multiple = util_isMultipleOrTags(props);
          var state = this.state;
          var className = props.className,
              disabled = props.disabled,
              prefixCls = props.prefixCls;
          var ctrlNode = this.renderTopControlNode();
          var extraSelectionProps = {};
          var open = this.state.open;
          var options = this._options;

          if (!util_isMultipleOrTagsOrCombobox(props)) {
            extraSelectionProps = {
              onKeyDown: this.onKeyDown,
              tabIndex: props.disabled ? -1 : 0
            };
          }

          var rootCls = (_rootCls = {}, _rootCls[className] = !!className, _rootCls[prefixCls] = 1, _rootCls[prefixCls + '-open'] = open, _rootCls[prefixCls + '-focused'] = open || !!this._focused, _rootCls[prefixCls + '-combobox'] = util_isCombobox(props), _rootCls[prefixCls + '-disabled'] = disabled, _rootCls[prefixCls + '-enabled'] = !disabled, _rootCls[prefixCls + '-allow-clear'] = !!props.allowClear, _rootCls);
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_SelectTrigger, {
            onPopupFocus: this.onPopupFocus,
            onMouseEnter: this.props.onMouseEnter,
            onMouseLeave: this.props.onMouseLeave,
            dropdownAlign: props.dropdownAlign,
            dropdownClassName: props.dropdownClassName,
            dropdownMatchSelectWidth: props.dropdownMatchSelectWidth,
            defaultActiveFirstOption: props.defaultActiveFirstOption,
            dropdownMenuStyle: props.dropdownMenuStyle,
            transitionName: props.transitionName,
            animation: props.animation,
            prefixCls: props.prefixCls,
            dropdownStyle: props.dropdownStyle,
            combobox: props.combobox,
            showSearch: props.showSearch,
            options: options,
            multiple: multiple,
            disabled: disabled,
            visible: open,
            inputValue: state.inputValue,
            value: state.value,
            backfillValue: state.backfillValue,
            firstActiveValue: props.firstActiveValue,
            onDropdownVisibleChange: this.onDropdownVisibleChange,
            getPopupContainer: props.getPopupContainer,
            onMenuSelect: this.onMenuSelect,
            onMenuDeselect: this.onMenuDeselect,
            onPopupScroll: props.onPopupScroll,
            showAction: props.showAction,
            ref: util_saveRef(this, 'selectTriggerRef')
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            style: props.style,
            ref: util_saveRef(this, 'rootRef'),
            onBlur: this.onOuterBlur,
            onFocus: this.onOuterFocus,
            className: classnames_default()(rootCls)
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', extends_default()({
            ref: util_saveRef(this, 'selectionRef'),
            key: 'selection',
            className: prefixCls + '-selection\n            ' + prefixCls + '-selection--' + (multiple ? 'multiple' : 'single'),
            role: 'combobox',
            'aria-autocomplete': 'list',
            'aria-haspopup': 'true',
            'aria-expanded': open
          }, extraSelectionProps), ctrlNode, this.renderClear(), multiple || !props.showArrow ? null : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', extends_default()({
            key: 'arrow',
            className: prefixCls + '-arrow',
            style: util_UNSELECTABLE_STYLE
          }, util_UNSELECTABLE_ATTRIBUTE, {
            onClick: this.onArrowClick
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('b', null)))));
        };

        return Select;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Select_Select.propTypes = PropTypes_SelectPropTypes;
      Select_Select.defaultProps = {
        prefixCls: 'rc-select',
        defaultOpen: false,
        labelInValue: false,
        defaultActiveFirstOption: true,
        showSearch: true,
        allowClear: false,
        placeholder: '',
        onChange: Select_noop,
        onFocus: Select_noop,
        onBlur: Select_noop,
        onSelect: Select_noop,
        onSearch: Select_noop,
        onDeselect: Select_noop,
        onInputKeyDown: Select_noop,
        showArrow: true,
        dropdownMatchSelectWidth: true,
        dropdownStyle: {},
        dropdownMenuStyle: {},
        optionFilterProp: 'value',
        optionLabelProp: 'value',
        notFoundContent: 'Not Found',
        backfill: false,
        showAction: ['click'],
        tokenSeparators: []
      };

      var Select_initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.componentWillReceiveProps = function (nextProps) {
          var optionsInfo = _this2.getOptionsInfoFromProps(nextProps);

          _this2.setState({
            optionsInfo: optionsInfo
          });

          if ('value' in nextProps) {
            var value = _this2.getValueFromProps(nextProps);

            _this2.setState({
              value: value
            }, _this2.forcePopupAlign);

            if (nextProps.combobox) {
              _this2.setState({
                inputValue: value.length ? _this2.getLabelBySingleValue(value[0], optionsInfo) : ''
              });
            }
          }
        };

        this.onInputChange = function (event) {
          var tokenSeparators = _this2.props.tokenSeparators;
          var val = event.target.value;

          if (util_isMultipleOrTags(_this2.props) && tokenSeparators.length && util_includesSeparators(val, tokenSeparators)) {
            var nextValue = _this2.getValueByInput(val);

            if (nextValue !== undefined) {
              _this2.fireChange(nextValue);
            }

            _this2.setOpenState(false, true);

            _this2.setInputValue('', false);

            return;
          }

          _this2.setInputValue(val);

          _this2.setState({
            open: true
          });

          if (util_isCombobox(_this2.props)) {
            _this2.fireChange([val]);
          }
        };

        this.onDropdownVisibleChange = function (open) {
          if (open && !_this2._focused) {
            _this2.clearBlurTime();

            _this2.timeoutFocus();

            _this2._focused = true;

            _this2.updateFocusClassName();
          }

          _this2.setOpenState(open);
        };

        this.onKeyDown = function (event) {
          var props = _this2.props;

          if (props.disabled) {
            return;
          }

          var keyCode = event.keyCode;

          if (_this2.state.open && !_this2.getInputDOMNode()) {
            _this2.onInputKeyDown(event);
          } else if (keyCode === KeyCode["a"
          /* default */
          ].ENTER || keyCode === KeyCode["a"
          /* default */
          ].DOWN) {
            _this2.setOpenState(true);

            event.preventDefault();
          }
        };

        this.onInputKeyDown = function (event) {
          var props = _this2.props;

          if (props.disabled) {
            return;
          }

          var state = _this2.state;
          var keyCode = event.keyCode;

          if (util_isMultipleOrTags(props) && !event.target.value && keyCode === KeyCode["a"
          /* default */
          ].BACKSPACE) {
            event.preventDefault();
            var value = state.value;

            if (value.length) {
              _this2.removeSelected(value[value.length - 1]);
            }

            return;
          }

          if (keyCode === KeyCode["a"
          /* default */
          ].DOWN) {
            if (!state.open) {
              _this2.openIfHasChildren();

              event.preventDefault();
              event.stopPropagation();
              return;
            }
          } else if (keyCode === KeyCode["a"
          /* default */
          ].ESC) {
            if (state.open) {
              _this2.setOpenState(false);

              event.preventDefault();
              event.stopPropagation();
            }

            return;
          }

          if (state.open) {
            var menu = _this2.selectTriggerRef.getInnerMenu();

            if (menu && menu.onKeyDown(event, _this2.handleBackfill)) {
              event.preventDefault();
              event.stopPropagation();
            }
          }
        };

        this.onMenuSelect = function (_ref) {
          var item = _ref.item;
          var value = _this2.state.value;
          var props = _this2.props;
          var selectedValue = util_getValuePropValue(item);
          var lastValue = value[value.length - 1];

          _this2.fireSelect(selectedValue);

          if (util_isMultipleOrTags(props)) {
            if (util_findIndexInValueBySingleValue(value, selectedValue) !== -1) {
              return;
            }

            value = value.concat([selectedValue]);
          } else {
            if (util_isCombobox(props)) {
              _this2.skipAdjustOpen = true;

              _this2.clearAdjustTimer();

              _this2.skipAdjustOpenTimer = setTimeout(function () {
                _this2.skipAdjustOpen = false;
              }, 0);
            }

            if (lastValue && lastValue === selectedValue && selectedValue !== _this2.state.backfillValue) {
              _this2.setOpenState(false, true);

              return;
            }

            value = [selectedValue];

            _this2.setOpenState(false, true);
          }

          _this2.fireChange(value);

          var inputValue = void 0;

          if (util_isCombobox(props)) {
            inputValue = util_getPropValue(item, props.optionLabelProp);
          } else {
            inputValue = '';
          }

          _this2.setInputValue(inputValue, false);
        };

        this.onMenuDeselect = function (_ref2) {
          var item = _ref2.item,
              domEvent = _ref2.domEvent;

          if (domEvent.type === 'click') {
            _this2.removeSelected(util_getValuePropValue(item));
          }

          _this2.setInputValue('', false);
        };

        this.onArrowClick = function (e) {
          e.stopPropagation();
          e.preventDefault();

          if (!_this2.props.disabled) {
            _this2.setOpenState(!_this2.state.open, !_this2.state.open);
          }
        };

        this.onPlaceholderClick = function () {
          if (_this2.getInputDOMNode()) {
            _this2.getInputDOMNode().focus();
          }
        };

        this.onOuterFocus = function (e) {
          if (_this2.props.disabled) {
            e.preventDefault();
            return;
          }

          _this2.clearBlurTime();

          if (!util_isMultipleOrTagsOrCombobox(_this2.props) && e.target === _this2.getInputDOMNode()) {
            return;
          }

          if (_this2._focused) {
            return;
          }

          _this2._focused = true;

          _this2.updateFocusClassName();

          _this2.timeoutFocus();
        };

        this.onPopupFocus = function () {
          // fix ie scrollbar, focus element again
          _this2.maybeFocus(true, true);
        };

        this.onOuterBlur = function (e) {
          if (_this2.props.disabled) {
            e.preventDefault();
            return;
          }

          _this2.blurTimer = setTimeout(function () {
            _this2._focused = false;

            _this2.updateFocusClassName();

            var props = _this2.props;
            var value = _this2.state.value;
            var inputValue = _this2.state.inputValue;

            if (util_isSingleMode(props) && props.showSearch && inputValue && props.defaultActiveFirstOption) {
              var options = _this2._options || [];

              if (options.length) {
                var firstOption = util_findFirstMenuItem(options);

                if (firstOption) {
                  value = [util_getValuePropValue(firstOption)];

                  _this2.fireChange(value);
                }
              }
            } else if (util_isMultipleOrTags(props) && inputValue) {
              // why not use setState?
              _this2.state.inputValue = _this2.getInputDOMNode().value = '';
              value = _this2.getValueByInput(inputValue);

              if (value !== undefined) {
                _this2.fireChange(value);
              }
            }

            props.onBlur(_this2.getVLForOnChange(value));

            _this2.setOpenState(false);
          }, 10);
        };

        this.onClearSelection = function (event) {
          var props = _this2.props;
          var state = _this2.state;

          if (props.disabled) {
            return;
          }

          var inputValue = state.inputValue,
              value = state.value;
          event.stopPropagation();

          if (inputValue || value.length) {
            if (value.length) {
              _this2.fireChange([]);
            }

            _this2.setOpenState(false, true);

            if (inputValue) {
              _this2.setInputValue('');
            }
          }
        };

        this.onChoiceAnimationLeave = function () {
          _this2.forcePopupAlign();
        };

        this.getValueFromProps = function (props) {
          var value = [];

          if ('value' in props) {
            value = util_toArray(props.value);
          } else {
            value = util_toArray(props.defaultValue);
          }

          if (props.labelInValue) {
            value = value.map(function (v) {
              return v.key;
            });
          }

          return value;
        };

        this.getOptionsInfoFromProps = function (props) {
          var options = _this2.getOptionsFromChildren(props.children);

          var oldOptionsInfo = _this2.state ? _this2.state.optionsInfo : {};
          var value = _this2.state ? _this2.state.value : [];
          var optionsInfo = {};
          options.forEach(function (option) {
            var singleValue = util_getValuePropValue(option);
            optionsInfo[util_getMapKey(singleValue)] = {
              option: option,
              value: singleValue,
              label: _this2.getLabelFromOption(option),
              title: option.props.title
            };
          });
          value.forEach(function (v) {
            var key = util_getMapKey(v);

            if (!optionsInfo[key]) {
              optionsInfo[key] = oldOptionsInfo[key];
            }
          });
          return optionsInfo;
        };

        this.getOptionInfoBySingleValue = function (value, optionsInfo) {
          var info = void 0;
          optionsInfo = optionsInfo || _this2.state.optionsInfo;

          if (optionsInfo[util_getMapKey(value)]) {
            info = optionsInfo[util_getMapKey(value)];
          }

          if (info) {
            return info;
          }

          var defaultLabel = value;

          if (_this2.props.labelInValue) {
            var label = util_getLabelFromPropsValue(_this2.props.value, value);

            if (label !== undefined) {
              defaultLabel = label;
            }
          }

          var defaultInfo = {
            option: external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Option, {
              value: value,
              key: value
            }, value),
            value: value,
            label: defaultLabel
          };
          return defaultInfo;
        };

        this.getOptionBySingleValue = function (value) {
          var _getOptionInfoBySingl = _this2.getOptionInfoBySingleValue(value),
              option = _getOptionInfoBySingl.option;

          return option;
        };

        this.getOptionsBySingleValue = function (values) {
          return values.map(function (value) {
            return _this2.getOptionBySingleValue(value);
          });
        };

        this.getOptionsFromChildren = function (children) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(children, function (child) {
            if (!child) {
              return;
            }

            if (child.type.isSelectOptGroup) {
              _this2.getOptionsFromChildren(child.props.children, options);
            } else {
              options.push(child);
            }
          });
          return options;
        };

        this.getValueByLabel = function (label) {
          if (label === undefined) {
            return null;
          }

          var value = null;
          Object.keys(_this2.state.optionsInfo).forEach(function (key) {
            var info = _this2.state.optionsInfo[key];

            if (util_toArray(info.label).join('') === label) {
              value = info.value;
            }
          });
          return value;
        };

        this.getLabelFromOption = function (option) {
          return util_getPropValue(option, _this2.props.optionLabelProp);
        };

        this.getVLBySingleValue = function (value) {
          if (_this2.props.labelInValue) {
            return {
              key: value,
              label: _this2.getLabelBySingleValue(value)
            };
          }

          return value;
        };

        this.getVLForOnChange = function (vls_) {
          var vls = vls_;

          if (vls !== undefined) {
            if (!_this2.props.labelInValue) {
              vls = vls.map(function (v) {
                return v;
              });
            } else {
              vls = vls.map(function (vl) {
                return {
                  key: vl,
                  label: _this2.getLabelBySingleValue(vl)
                };
              });
            }

            return util_isMultipleOrTags(_this2.props) ? vls : vls[0];
          }

          return vls;
        };

        this.getLabelBySingleValue = function (value, optionsInfo) {
          var _getOptionInfoBySingl2 = _this2.getOptionInfoBySingleValue(value, optionsInfo),
              label = _getOptionInfoBySingl2.label;

          return label;
        };

        this.getDropdownContainer = function () {
          if (!_this2.dropdownContainer) {
            _this2.dropdownContainer = document.createElement('div');
            document.body.appendChild(_this2.dropdownContainer);
          }

          return _this2.dropdownContainer;
        };

        this.getPlaceholderElement = function () {
          var props = _this2.props,
              state = _this2.state;
          var hidden = false;

          if (state.inputValue) {
            hidden = true;
          }

          if (state.value.length) {
            hidden = true;
          }

          if (util_isCombobox(props) && state.value.length === 1 && !state.value[0]) {
            hidden = false;
          }

          var placeholder = props.placeholder;

          if (placeholder) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', extends_default()({
              onMouseDown: util_preventDefaultEvent,
              style: extends_default()({
                display: hidden ? 'none' : 'block'
              }, util_UNSELECTABLE_STYLE)
            }, util_UNSELECTABLE_ATTRIBUTE, {
              onClick: _this2.onPlaceholderClick,
              className: props.prefixCls + '-selection__placeholder'
            }), placeholder);
          }

          return null;
        };

        this.getInputElement = function () {
          var _classnames;

          var props = _this2.props;
          var inputElement = props.getInputElement ? props.getInputElement() : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('input', {
            id: props.id,
            autoComplete: 'off'
          });
          var inputCls = classnames_default()(inputElement.props.className, (_classnames = {}, _classnames[props.prefixCls + '-search__field'] = true, _classnames)); // https://github.com/ant-design/ant-design/issues/4992#issuecomment-281542159
          // Add space to the end of the inputValue as the width measurement tolerance

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: props.prefixCls + '-search__field__wrap'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(inputElement, {
            ref: util_saveRef(_this2, 'inputRef'),
            onChange: _this2.onInputChange,
            onKeyDown: Select_chaining(_this2.onInputKeyDown, inputElement.props.onKeyDown, _this2.props.onInputKeyDown),
            value: _this2.state.inputValue,
            disabled: props.disabled,
            className: inputCls
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            ref: util_saveRef(_this2, 'inputMirrorRef'),
            className: props.prefixCls + '-search__field__mirror'
          }, _this2.state.inputValue, '\xA0'));
        };

        this.getInputDOMNode = function () {
          return _this2.topCtrlRef ? _this2.topCtrlRef.querySelector('input,textarea,div[contentEditable]') : _this2.inputRef;
        };

        this.getInputMirrorDOMNode = function () {
          return _this2.inputMirrorRef;
        };

        this.getPopupDOMNode = function () {
          return _this2.selectTriggerRef.getPopupDOMNode();
        };

        this.getPopupMenuComponent = function () {
          return _this2.selectTriggerRef.getInnerMenu();
        };

        this.setOpenState = function (open, needFocus) {
          var props = _this2.props,
              state = _this2.state;

          if (state.open === open) {
            _this2.maybeFocus(open, needFocus);

            return;
          }

          var nextState = {
            open: open,
            backfillValue: undefined
          }; // clear search input value when open is false in singleMode.

          if (!open && util_isSingleMode(props) && props.showSearch) {
            _this2.setInputValue('');
          }

          if (!open) {
            _this2.maybeFocus(open, needFocus);
          }

          _this2.setState(nextState, function () {
            if (open) {
              _this2.maybeFocus(open, needFocus);
            }
          });
        };

        this.setInputValue = function (inputValue) {
          var fireSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

          if (inputValue !== _this2.state.inputValue) {
            _this2.setState({
              inputValue: inputValue
            }, _this2.forcePopupAlign);

            if (fireSearch) {
              _this2.props.onSearch(inputValue);
            }
          }
        };

        this.getValueByInput = function (string) {
          var _props2 = _this2.props,
              multiple = _props2.multiple,
              tokenSeparators = _props2.tokenSeparators;
          var nextValue = _this2.state.value;
          var hasNewValue = false;
          util_splitBySeparators(string, tokenSeparators).forEach(function (label) {
            var selectedValue = [label];

            if (multiple) {
              var value = _this2.getValueByLabel(label);

              if (value && util_findIndexInValueBySingleValue(nextValue, value) === -1) {
                nextValue = nextValue.concat(value);
                hasNewValue = true;

                _this2.fireSelect(value);
              }
            } else {
              // tag
              if (util_findIndexInValueBySingleValue(nextValue, label) === -1) {
                nextValue = nextValue.concat(selectedValue);
                hasNewValue = true;

                _this2.fireSelect(label);
              }
            }
          });
          return hasNewValue ? nextValue : undefined;
        };

        this.handleBackfill = function (item) {
          if (!_this2.props.backfill || !(util_isSingleMode(_this2.props) || util_isCombobox(_this2.props))) {
            return;
          }

          var key = util_getValuePropValue(item);

          if (util_isCombobox(_this2.props)) {
            _this2.setInputValue(key, false);
          }

          _this2.setState({
            value: [key],
            backfillValue: key
          });
        };

        this.filterOption = function (input, child) {
          var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : util_defaultFilterFn;
          var value = _this2.state.value;
          var lastValue = value[value.length - 1];

          if (!input || lastValue && lastValue === _this2.state.backfillValue) {
            return true;
          }

          var filterFn = _this2.props.filterOption;

          if ('filterOption' in _this2.props) {
            if (_this2.props.filterOption === true) {
              filterFn = defaultFilter;
            }
          } else {
            filterFn = defaultFilter;
          }

          if (!filterFn) {
            return true;
          } else if (typeof filterFn === 'function') {
            return filterFn.call(_this2, input, child);
          } else if (child.props.disabled) {
            return false;
          }

          return true;
        };

        this.timeoutFocus = function () {
          if (_this2.focusTimer) {
            _this2.clearFocusTime();
          }

          _this2.focusTimer = setTimeout(function () {
            _this2.props.onFocus();
          }, 10);
        };

        this.clearFocusTime = function () {
          if (_this2.focusTimer) {
            clearTimeout(_this2.focusTimer);
            _this2.focusTimer = null;
          }
        };

        this.clearBlurTime = function () {
          if (_this2.blurTimer) {
            clearTimeout(_this2.blurTimer);
            _this2.blurTimer = null;
          }
        };

        this.clearAdjustTimer = function () {
          if (_this2.skipAdjustOpenTimer) {
            clearTimeout(_this2.skipAdjustOpenTimer);
            _this2.skipAdjustOpenTimer = null;
          }
        };

        this.updateFocusClassName = function () {
          var rootRef = _this2.rootRef,
              props = _this2.props; // avoid setState and its side effect

          if (_this2._focused) {
            component_classes_default()(rootRef).add(props.prefixCls + '-focused');
          } else {
            component_classes_default()(rootRef).remove(props.prefixCls + '-focused');
          }
        };

        this.maybeFocus = function (open, needFocus) {
          if (needFocus || open) {
            var input = _this2.getInputDOMNode();

            var _document = document,
                activeElement = _document.activeElement;

            if (input && (open || util_isMultipleOrTagsOrCombobox(_this2.props))) {
              if (activeElement !== input) {
                input.focus();
                _this2._focused = true;
              }
            } else {
              if (activeElement !== _this2.selectionRef) {
                _this2.selectionRef.focus();

                _this2._focused = true;
              }
            }
          }
        };

        this.removeSelected = function (selectedKey) {
          var props = _this2.props;

          if (props.disabled || _this2.isChildDisabled(selectedKey)) {
            return;
          }

          var value = _this2.state.value.filter(function (singleValue) {
            return singleValue !== selectedKey;
          });

          var canMultiple = util_isMultipleOrTags(props);

          if (canMultiple) {
            var event = selectedKey;

            if (props.labelInValue) {
              event = {
                key: selectedKey,
                label: _this2.getLabelBySingleValue(selectedKey)
              };
            }

            props.onDeselect(event, _this2.getOptionBySingleValue(selectedKey));
          }

          _this2.fireChange(value);
        };

        this.openIfHasChildren = function () {
          var props = _this2.props;

          if (external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.count(props.children) || util_isSingleMode(props)) {
            _this2.setOpenState(true);
          }
        };

        this.fireSelect = function (value) {
          _this2.props.onSelect(_this2.getVLBySingleValue(value), _this2.getOptionBySingleValue(value));
        };

        this.fireChange = function (value) {
          var props = _this2.props;

          if (!('value' in props)) {
            _this2.setState({
              value: value
            }, _this2.forcePopupAlign);
          }

          var vls = _this2.getVLForOnChange(value);

          var options = _this2.getOptionsBySingleValue(value);

          props.onChange(vls, util_isMultipleOrTags(_this2.props) ? options : options[0]);
        };

        this.isChildDisabled = function (key) {
          return Object(Children_toArray["a"
          /* default */
          ])(_this2.props.children).some(function (child) {
            var childValue = util_getValuePropValue(child);
            return childValue === key && child.props && child.props.disabled;
          });
        };

        this.adjustOpenState = function () {
          if (_this2.skipAdjustOpen) {
            return;
          }

          var open = _this2.state.open;
          var options = []; // If hidden menu due to no options, then it should be calculated again

          if (open || _this2.hiddenForNoOptions) {
            options = _this2.renderFilterOptions();
          }

          _this2._options = options;

          if (util_isMultipleOrTagsOrCombobox(_this2.props) || !_this2.props.showSearch) {
            if (open && !options.length) {
              open = false;
              _this2.hiddenForNoOptions = true;
            } // Keep menu open if there are options and hidden for no options before


            if (_this2.hiddenForNoOptions && options.length) {
              open = true;
              _this2.hiddenForNoOptions = false;
            }
          }

          _this2.state.open = open;
        };

        this.forcePopupAlign = function () {
          _this2.selectTriggerRef.triggerRef.forcePopupAlign();
        };

        this.renderFilterOptions = function () {
          var inputValue = _this2.state.inputValue;
          var _props3 = _this2.props,
              children = _props3.children,
              tags = _props3.tags,
              filterOption = _props3.filterOption,
              notFoundContent = _props3.notFoundContent;
          var menuItems = [];
          var childrenKeys = [];

          var options = _this2.renderFilterOptionsFromChildren(children, childrenKeys, menuItems);

          if (tags) {
            // tags value must be string
            var value = _this2.state.value || [];
            value = value.filter(function (singleValue) {
              return childrenKeys.indexOf(singleValue) === -1 && (!inputValue || String(singleValue).indexOf(String(inputValue)) > -1);
            });
            value.forEach(function (singleValue) {
              var key = singleValue;
              var menuItem = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es["b"
              /* Item */
              ], {
                style: util_UNSELECTABLE_STYLE,
                attribute: util_UNSELECTABLE_ATTRIBUTE,
                value: key,
                key: key
              }, key);
              options.push(menuItem);
              menuItems.push(menuItem);
            });

            if (inputValue) {
              var notFindInputItem = menuItems.every(function (option) {
                // this.filterOption return true has two meaning,
                // 1, some one exists after filtering
                // 2, filterOption is set to false
                // condition 2 does not mean the option has same value with inputValue
                var filterFn = function filterFn() {
                  return util_getValuePropValue(option) === inputValue;
                };

                if (filterOption !== false) {
                  return !_this2.filterOption.call(_this2, inputValue, option, filterFn);
                }

                return !filterFn();
              });

              if (notFindInputItem) {
                options.unshift(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es["b"
                /* Item */
                ], {
                  style: util_UNSELECTABLE_STYLE,
                  attribute: util_UNSELECTABLE_ATTRIBUTE,
                  value: inputValue,
                  key: inputValue
                }, inputValue));
              }
            }
          }

          if (!options.length && notFoundContent) {
            options = [external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es["b"
            /* Item */
            ], {
              style: util_UNSELECTABLE_STYLE,
              attribute: util_UNSELECTABLE_ATTRIBUTE,
              disabled: true,
              value: 'NOT_FOUND',
              key: 'NOT_FOUND'
            }, notFoundContent)];
          }

          return options;
        };

        this.renderFilterOptionsFromChildren = function (children, childrenKeys, menuItems) {
          var sel = [];
          var props = _this2.props;
          var inputValue = _this2.state.inputValue;
          var tags = props.tags;
          external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(children, function (child) {
            if (!child) {
              return;
            }

            if (child.type.isSelectOptGroup) {
              var innerItems = _this2.renderFilterOptionsFromChildren(child.props.children, childrenKeys, menuItems);

              if (innerItems.length) {
                var label = child.props.label;
                var key = child.key;

                if (!key && typeof label === 'string') {
                  key = label;
                } else if (!label && key) {
                  label = key;
                }

                sel.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es["c"
                /* ItemGroup */
                ], {
                  key: key,
                  title: label
                }, innerItems));
              }

              return;
            }

            browser_default()(child.type.isSelectOption, 'the children of `Select` should be `Select.Option` or `Select.OptGroup`, ' + ('instead of `' + (child.type.name || child.type.displayName || child.type) + '`.'));
            var childValue = util_getValuePropValue(child);
            util_validateOptionValue(childValue, _this2.props);

            if (_this2.filterOption(inputValue, child)) {
              var menuItem = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es["b"
              /* Item */
              ], extends_default()({
                style: util_UNSELECTABLE_STYLE,
                attribute: util_UNSELECTABLE_ATTRIBUTE,
                value: childValue,
                key: childValue
              }, child.props));
              sel.push(menuItem);
              menuItems.push(menuItem);
            }

            if (tags && !child.props.disabled) {
              childrenKeys.push(childValue);
            }
          });
          return sel;
        };

        this.renderTopControlNode = function () {
          var _state2 = _this2.state,
              value = _state2.value,
              open = _state2.open,
              inputValue = _state2.inputValue;
          var props = _this2.props;
          var choiceTransitionName = props.choiceTransitionName,
              prefixCls = props.prefixCls,
              maxTagTextLength = props.maxTagTextLength,
              maxTagCount = props.maxTagCount,
              maxTagPlaceholder = props.maxTagPlaceholder,
              showSearch = props.showSearch;
          var className = prefixCls + '-selection__rendered'; // search input is inside topControlNode in single, multiple & combobox. 2016/04/13

          var innerNode = null;

          if (util_isSingleMode(props)) {
            var selectedValue = null;

            if (value.length) {
              var showSelectedValue = false;
              var opacity = 1;

              if (!showSearch) {
                showSelectedValue = true;
              } else {
                if (open) {
                  showSelectedValue = !inputValue;

                  if (showSelectedValue) {
                    opacity = 0.4;
                  }
                } else {
                  showSelectedValue = true;
                }
              }

              var singleValue = value[0];

              var _getOptionInfoBySingl3 = _this2.getOptionInfoBySingleValue(singleValue),
                  label = _getOptionInfoBySingl3.label,
                  title = _getOptionInfoBySingl3.title;

              selectedValue = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
                key: 'value',
                className: prefixCls + '-selection-selected-value',
                title: title || label,
                style: {
                  display: showSelectedValue ? 'block' : 'none',
                  opacity: opacity
                }
              }, label);
            }

            if (!showSearch) {
              innerNode = [selectedValue];
            } else {
              innerNode = [selectedValue, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
                className: prefixCls + '-search ' + prefixCls + '-search--inline',
                key: 'input',
                style: {
                  display: open ? 'block' : 'none'
                }
              }, _this2.getInputElement())];
            }
          } else {
            var selectedValueNodes = [];
            var limitedCountValue = value;
            var maxTagPlaceholderEl = void 0;

            if (maxTagCount !== undefined && value.length > maxTagCount) {
              limitedCountValue = limitedCountValue.slice(0, maxTagCount);

              var omittedValues = _this2.getVLForOnChange(value.slice(maxTagCount, value.length));

              var content = '+ ' + (value.length - maxTagCount) + ' ...';

              if (maxTagPlaceholder) {
                content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
              }

              maxTagPlaceholderEl = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', extends_default()({
                style: util_UNSELECTABLE_STYLE
              }, util_UNSELECTABLE_ATTRIBUTE, {
                onMouseDown: util_preventDefaultEvent,
                className: prefixCls + '-selection__choice ' + prefixCls + '-selection__choice__disabled',
                key: 'maxTagPlaceholder',
                title: content
              }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
                className: prefixCls + '-selection__choice__content'
              }, content));
            }

            if (util_isMultipleOrTags(props)) {
              selectedValueNodes = limitedCountValue.map(function (singleValue) {
                var info = _this2.getOptionInfoBySingleValue(singleValue);

                var content = info.label;
                var title = info.title || content;

                if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
                  content = content.slice(0, maxTagTextLength) + '...';
                }

                var disabled = _this2.isChildDisabled(singleValue);

                var choiceClassName = disabled ? prefixCls + '-selection__choice ' + prefixCls + '-selection__choice__disabled' : prefixCls + '-selection__choice';
                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', extends_default()({
                  style: util_UNSELECTABLE_STYLE
                }, util_UNSELECTABLE_ATTRIBUTE, {
                  onMouseDown: util_preventDefaultEvent,
                  className: choiceClassName,
                  key: singleValue,
                  title: title
                }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
                  className: prefixCls + '-selection__choice__content'
                }, content), disabled ? null : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                  className: prefixCls + '-selection__choice__remove',
                  onClick: _this2.removeSelected.bind(_this2, singleValue)
                }));
              });
            }

            if (maxTagPlaceholderEl) {
              selectedValueNodes.push(maxTagPlaceholderEl);
            }

            selectedValueNodes.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
              className: prefixCls + '-search ' + prefixCls + '-search--inline',
              key: '__input'
            }, _this2.getInputElement()));

            if (util_isMultipleOrTags(props) && choiceTransitionName) {
              innerNode = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], {
                onLeave: _this2.onChoiceAnimationLeave,
                component: 'ul',
                transitionName: choiceTransitionName
              }, selectedValueNodes);
            } else {
              innerNode = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', null, selectedValueNodes);
            }
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: className,
            ref: util_saveRef(_this2, 'topCtrlRef')
          }, _this2.getPlaceholderElement(), innerNode);
        };
      };
      /* harmony default export */


      var es_Select = Select_Select;
      Select_Select.displayName = 'Select'; // CONCATENATED MODULE: ./node_modules/rc-select/es/OptGroup.js

      var OptGroup_OptGroup = function (_React$Component) {
        inherits_default()(OptGroup, _React$Component);

        function OptGroup() {
          classCallCheck_default()(this, OptGroup);
          return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
        }

        return OptGroup;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      OptGroup_OptGroup.isSelectOptGroup = true;
      /* harmony default export */

      var es_OptGroup = OptGroup_OptGroup; // CONCATENATED MODULE: ./node_modules/rc-select/es/index.js

      /* concated harmony reexport */

      __webpack_require__.d(__webpack_exports__, "Option", function () {
        return es_Option;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "OptGroup", function () {
        return es_OptGroup;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "SelectPropTypes", function () {
        return PropTypes_SelectPropTypes;
      });

      es_Select.Option = es_Option;
      es_Select.OptGroup = es_OptGroup;
      /* harmony default export */

      var rc_select_es = __webpack_exports__["default"] = es_Select;
      /***/
    },
    /* 106 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "e", function () {
        return getValueOrMin;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return getValueOrMax;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return getCalculationValueObject;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "f", function () {
        return isValidNumber;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return getConstructedRepeatableFieldValue;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "g", function () {
        return replaceFieldIdsWithMachineTags;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return getUniqueFieldIdsFromLogicString;
      });
      /* unused harmony export removeScientificNotation */

      /* harmony import */


      var cleave_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(677);
      /* harmony import */


      var cleave_js__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(cleave_js__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var lodash_uniq__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(263);
      /* harmony import */


      var lodash_uniq__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _mathJsBuild__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(219); // Ensure number is not NaN or Infinite, or an empty string


      var isValidNumber = function isValidNumber(number) {
        if (typeof number === 'string' && number.trim() === '') {
          return false;
        }

        number = Number(number);
        return !Number.isNaN(number) && Number.isFinite(number);
      }; // Return the minimum value, checking against specified minValue


      var getValueOrMin = function getValueOrMin(value) {
        var minValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

        if (!isValidNumber(fallback)) {
          throw new Error('fallback must be a valid number');
        }

        var valueValid = isValidNumber(value);
        var minValueValid = isValidNumber(minValue);

        if (!valueValid && !minValueValid) {
          return Number(fallback);
        }

        if (!minValueValid) {
          return Number(value);
        }

        if (!valueValid) {
          return Number(minValue);
        }

        return Math.max(Number(value), Number(minValue));
      }; // Return the maximum value, checking against specified maxValue


      var getValueOrMax = function getValueOrMax(value) {
        var maxValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

        if (!isValidNumber(fallback)) {
          throw new Error('fallback must be a valid number');
        }

        var valueValid = isValidNumber(value);
        var maxValueValid = isValidNumber(maxValue);

        if (!valueValid && !maxValueValid) {
          return Number(fallback);
        }

        if (!maxValueValid) {
          return Number(value);
        }

        if (!valueValid) {
          return Number(maxValue);
        }

        return Math.min(Number(value), Number(maxValue));
      };
      /**
       * Remove scientific notation from our results
       * @param {number|string} value
       */


      var removeScientificNotation = function removeScientificNotation(value) {
        var math = Object(_mathJsBuild__WEBPACK_IMPORTED_MODULE_2__[
        /* getMathJsBuild */
        "a"])();
        var numberValue = math.number(value);
        return math.format(numberValue, {
          notation: 'fixed'
        });
      }; // Format calculation result value object for a given value and cleave config
      // Use the mask options to push through cleave
      // The initial flag is used only when the default value is calculated on the calc component init
      // This way, if someone enters input that results in the same default value, it will recalc with the initial flag not present.
      // Hence the calc field will assume the result is different and process the setSubmissionValues at least once. Resolves FPD-3405


      var getCalculationValueObject = function getCalculationValueObject(rawValue, defaultValue, numeralDecimalMark, numeralDecimalScale, numeralThousandsGroupStyle) {
        var initial = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
        var valueObject;
        rawValue = Number(rawValue);
        defaultValue = Number(defaultValue);
        var rawValueValid = isValidNumber(rawValue);
        var defaultValueValid = isValidNumber(defaultValue);

        if (!rawValueValid && !defaultValueValid) {
          throw new Error('rawValue and defaultValue are not numbers');
        }

        if (!rawValueValid) {
          rawValue = defaultValue;
        }

        if (!defaultValueValid) {
          defaultValue = rawValue;
        }

        try {
          var rawValueString = removeScientificNotation(rawValue.toString());
          valueObject = {
            rawValue: rawValueString,
            maskedValue: rawValueString
          }; // Format via cleave for consistency with InputMask component

          var numeralFormatter = new cleave_js__WEBPACK_IMPORTED_MODULE_0__["NumeralFormatter"](numeralDecimalMark, 0, numeralDecimalScale, numeralThousandsGroupStyle, false, false); // Cleave doesn't round properly, so we do that first

          var roundedRawValue = rawValue.toFixed(numeralDecimalScale);
          valueObject = {
            rawValue: rawValueString,
            maskedValue: numeralFormatter.format(roundedRawValue.toString())
          };
        } catch (err) {
          var defaultValueString = defaultValue.toString();
          valueObject = {
            rawValue: defaultValueString,
            maskedValue: defaultValueString
          };
        }

        if (initial) {
          valueObject.initial = true;
        }

        return valueObject;
      };
      /**
       * Construct a nested array of repeatable values for handlebars template substitution
       * I.e numeric indexed array of objects
       * @todo Recursive nested repeatable fields
       * @param {String} repeatableFieldId
       * @param {Object} fieldsById
       * @param {Object} formFieldsById
       * @return array
       */


      var getConstructedRepeatableFieldValue = function getConstructedRepeatableFieldValue(repeatableFieldId, fieldsById, formFieldsById) {
        // Repeatable field might not have rendered out yet
        if (fieldsById[repeatableFieldId] === undefined) {
          return [];
        }

        var repeatableFieldValue = fieldsById[repeatableFieldId].value;
        var updatedRepeatableFieldValue = [];
        var numRepeatableIterations = repeatableFieldValue instanceof Array ? repeatableFieldValue.length : 0;

        if (numRepeatableIterations > 0) {
          var repeatableInnerFieldIds;

          try {
            repeatableInnerFieldIds = formFieldsById[repeatableFieldId].attributes.fields.map(function (fieldObj) {
              return fieldObj.id;
            });
          } catch (error) {
            repeatableInnerFieldIds = [];
          }

          var numRepeatableInnerFieldIds = repeatableInnerFieldIds.length;

          for (var i = 0; i < numRepeatableIterations; i += 1) {
            var repeatableIterationValue = {};

            if (numRepeatableInnerFieldIds > 0) {
              for (var y = 0; y < numRepeatableInnerFieldIds; y += 1) {
                var constructedRepeatableFieldId = "".concat(repeatableFieldId, "-").concat(repeatableFieldValue[i], "-").concat(repeatableInnerFieldIds[y]);

                if (fieldsById[constructedRepeatableFieldId]) {
                  repeatableIterationValue[repeatableInnerFieldIds[y]] = fieldsById[constructedRepeatableFieldId].value;
                }
              }
            }

            updatedRepeatableFieldValue.push(repeatableIterationValue);
          }
        }

        return updatedRepeatableFieldValue;
      };
      /**
       * Replace field ids with machine tags, allowing formulas to be expressed with {{values.machineTag}} tokens
       * @param {*} values
       * @param {*} replacements
       */


      var replaceFieldIdsWithMachineTags = function replaceFieldIdsWithMachineTags(values, replacements) {
        values = JSON.stringify(values);
        Object.keys(replacements).forEach(function (key) {
          values = values.replace(new RegExp("\"".concat(key, "\":"), 'g'), "\"".concat(replacements[key], "\":"));
        });
        return JSON.parse(values);
      };
      /**
       * Extract field Ids from boolean logic string
       * @param {String} logic
       */


      var getUniqueFieldIdsFromLogicString = function getUniqueFieldIdsFromLogicString(logic) {
        var fieldIds = [];

        if (typeof logic !== 'string') {
          return fieldIds;
        }

        var regex = /("field")([ ]*:[ ]*")([a-f0-9]{1,})(")/gm;
        var matches = regex.exec(logic);

        while (matches !== null) {
          // This is necessary to avoid infinite loops with zero-width matches
          if (matches.index === regex.lastIndex) {
            regex.lastIndex += 1;
          }

          matches.forEach(function (match, groupIndex) {
            // We only need the third matching group
            if (groupIndex === 3) {
              fieldIds.push(match);
            }
          });
          matches = regex.exec(logic);
        }

        return lodash_uniq__WEBPACK_IMPORTED_MODULE_1___default()(fieldIds);
      };
      /***/

    },
    /* 107 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var clone = __webpack_require__(59).clone;

      function factory(type, config, load, typed) {
        var DenseMatrix = type.DenseMatrix;
        /**
         * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b).
         * Callback function invoked MxN times.
         *
         * C(i,j,...z) = f(Aij..z, b)
         *
         * @param {Matrix}   a                 The DenseMatrix instance (A)
         * @param {Scalar}   b                 The Scalar value
         * @param {Function} callback          The f(Aij..z,b) operation to invoke
         * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
         *
         * @return {Matrix}                    DenseMatrix (C)
         *
         * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
         */

        var algorithm14 = function algorithm14(a, b, callback, inverse) {
          // a arrays
          var adata = a._data;
          var asize = a._size;
          var adt = a._datatype; // datatype

          var dt; // callback signature to use

          var cf = callback; // process data types

          if (typeof adt === 'string') {
            // datatype
            dt = adt; // convert b to the same datatype

            b = typed.convert(b, dt); // callback

            cf = typed.find(callback, [dt, dt]);
          } // populate cdata, iterate through dimensions


          var cdata = asize.length > 0 ? _iterate(cf, 0, asize, asize[0], adata, b, inverse) : []; // c matrix

          return new DenseMatrix({
            data: cdata,
            size: clone(asize),
            datatype: dt
          });
        }; // recursive function


        function _iterate(f, level, s, n, av, bv, inverse) {
          // initialize array for this level
          var cv = []; // check we reach the last level

          if (level === s.length - 1) {
            // loop arrays in last level
            for (var i = 0; i < n; i++) {
              // invoke callback and store value
              cv[i] = inverse ? f(bv, av[i]) : f(av[i], bv);
            }
          } else {
            // iterate current level
            for (var j = 0; j < n; j++) {
              // iterate next level
              cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv, inverse);
            }
          }

          return cv;
        }

        return algorithm14;
      }

      exports.name = 'algorithm14';
      exports.factory = factory;
      /***/
    },
    /* 108 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * 
       */

      var nullthrows = function nullthrows(x) {
        if (x != null) {
          return x;
        }

        throw new Error("Got unexpected null or undefined");
      };

      module.exports = nullthrows;
      /***/
    },
    /* 109 */

    /***/
    function (module, exports) {
      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */
      function isObjectLike(value) {
        return value != null && typeof value == 'object';
      }

      module.exports = isObjectLike;
      /***/
    },
    /* 110 */

    /***/
    function (module, exports, __webpack_require__) {
      var store = __webpack_require__(363)('wks');

      var uid = __webpack_require__(258);

      var Symbol = __webpack_require__(138).Symbol;

      var USE_SYMBOL = typeof Symbol == 'function';

      var $exports = module.exports = function (name) {
        return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
      };

      $exports.store = store;
      /***/
    },
    /* 111 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "polyfill", function () {
        return polyfill;
      });
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */


      function componentWillMount() {
        // Call this.constructor.gDSFP to support sub-classes.
        var state = this.constructor.getDerivedStateFromProps(this.props, this.state);

        if (state !== null && state !== undefined) {
          this.setState(state);
        }
      }

      function componentWillReceiveProps(nextProps) {
        // Call this.constructor.gDSFP to support sub-classes.
        // Use the setState() updater to ensure state isn't stale in certain edge cases.
        function updater(prevState) {
          var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
          return state !== null && state !== undefined ? state : null;
        } // Binding "this" is important for shallow renderer support.


        this.setState(updater.bind(this));
      }

      function componentWillUpdate(nextProps, nextState) {
        try {
          var prevProps = this.props;
          var prevState = this.state;
          this.props = nextProps;
          this.state = nextState;
          this.__reactInternalSnapshotFlag = true;
          this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
        } finally {
          this.props = prevProps;
          this.state = prevState;
        }
      } // React may warn about cWM/cWRP/cWU methods being deprecated.
      // Add a flag to suppress these warnings for this special case.


      componentWillMount.__suppressDeprecationWarning = true;
      componentWillReceiveProps.__suppressDeprecationWarning = true;
      componentWillUpdate.__suppressDeprecationWarning = true;

      function polyfill(Component) {
        var prototype = Component.prototype;

        if (!prototype || !prototype.isReactComponent) {
          throw new Error('Can only polyfill class components');
        }

        if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
          return Component;
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Error if any of these lifecycles are present,
        // Because they would work differently between older and newer (16.3+) versions of React.


        var foundWillMountName = null;
        var foundWillReceivePropsName = null;
        var foundWillUpdateName = null;

        if (typeof prototype.componentWillMount === 'function') {
          foundWillMountName = 'componentWillMount';
        } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
          foundWillMountName = 'UNSAFE_componentWillMount';
        }

        if (typeof prototype.componentWillReceiveProps === 'function') {
          foundWillReceivePropsName = 'componentWillReceiveProps';
        } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
          foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
        }

        if (typeof prototype.componentWillUpdate === 'function') {
          foundWillUpdateName = 'componentWillUpdate';
        } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
          foundWillUpdateName = 'UNSAFE_componentWillUpdate';
        }

        if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
          var componentName = Component.displayName || Component.name;
          var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
          throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
        } // React <= 16.2 does not support static getDerivedStateFromProps.
        // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
        // Newer versions of React will ignore these lifecycles if gDSFP exists.


        if (typeof Component.getDerivedStateFromProps === 'function') {
          prototype.componentWillMount = componentWillMount;
          prototype.componentWillReceiveProps = componentWillReceiveProps;
        } // React <= 16.2 does not support getSnapshotBeforeUpdate.
        // As a workaround, use cWU to invoke the new lifecycle.
        // Newer versions of React will ignore that lifecycle if gSBU exists.


        if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
          if (typeof prototype.componentDidUpdate !== 'function') {
            throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
          }

          prototype.componentWillUpdate = componentWillUpdate;
          var componentDidUpdate = prototype.componentDidUpdate;

          prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
          };
        }

        return Component;
      }
      /***/

    },
    /* 112 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return submissionAttribute;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return submissionField;
      });
      /* harmony import */


      var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40);
      /* harmony import */


      var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var lodash_keyBy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85);
      /* harmony import */


      var lodash_keyBy__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_keyBy__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var lodash_toPairs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(686);
      /* harmony import */


      var lodash_toPairs__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_toPairs__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _core_utils_graphql_submission__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63);
      /* harmony import */


      var _core_utils_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69);
      /**
       * Returns a function which mutations a submission attribute.
       * @param {Function} mutate
       * @param {object} ownProps
       * @param {String?} newSubmissionId
       */


      var submissionAttribute = function submissionAttribute(mutate, ownProps, newSubmissionId) {
        return function (_ref) {
          var attributes = _ref.attributes,
              id = _ref.id,
              value = _ref.value,
              _ref$timestamp = _ref.timestamp,
              timestamp = _ref$timestamp === void 0 ? Date.now() : _ref$timestamp;
          var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var initialValues = values.initialValues || (Object.keys(ownProps.initialValues).length > 0 ? lodash_toPairs__WEBPACK_IMPORTED_MODULE_5___default()(ownProps.initialValues).map(function (val) {
            return {
              id: val[0],
              value: val[1]
            };
          }) : []);

          if (!Array.isArray(initialValues)) {
            // fallback to an empty array if unable to retrieve or passed through
            initialValues = [];
          }

          var options = Object(_core_utils_graphql_submission__WEBPACK_IMPORTED_MODULE_6__[
          /* getSubmissionOptions */
          "a"])(ownProps.formId, ownProps.submissionId || newSubmissionId[ownProps.formId], Array.isArray(attributes) && attributes.length > 0 ? attributes : [{
            id: id,
            value: value
          }], [], {
            attributes: values.attributes || lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(ownProps, 'data.Submission.attributes', []),
            fields: values.fields || lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(ownProps, 'data.Submission.fields', [])
          }, timestamp, ownProps.channel, ownProps.environment, 'local');
          return mutate(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, options, {
            update: function update(proxy, _ref2) {
              var SetSubmissionValues = _ref2.data.SetSubmissionValues;
              var variables = {
                branch: options.variables.branch,
                channel: options.variables.channel,
                formId: options.variables.formId,
                initialValues: initialValues,
                submissionId: options.variables.submissionId
              }; // get data currently in the cache

              var clientData = Object(_core_utils_actions__WEBPACK_IMPORTED_MODULE_7__[
              /* getClient */
              "a"])().readQuery({
                query: _core_utils_graphql_submission__WEBPACK_IMPORTED_MODULE_6__[
                /* readSubmissionQuery */
                "b"].query,
                variables: variables
              });
              var currentAttributes = clientData.Submission.attributes;
              var serverAttributes = SetSubmissionValues.attributes;
              var newAttributes = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_3___default()(currentAttributes);
              var currentAttributesByKey = lodash_keyBy__WEBPACK_IMPORTED_MODULE_4___default()(currentAttributes, function (o) {
                return o.id;
              });
              serverAttributes.forEach(function (attribute) {
                if (!currentAttributesByKey[attribute.id]) {
                  // doesn't exist locally, add
                  newAttributes.push(attribute);
                } else if (attribute.requestTimestamp > currentAttributesByKey[attribute.id].requestTimestamp) {
                  // server timestamp is more recent than local timestamp, update locally
                  var index = newAttributes.findIndex(function (o) {
                    return o.id === attribute.id;
                  });
                  newAttributes[index] = attribute;
                }
              }); // Data to update

              var update = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, clientData, {
                Submission: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, clientData.Submission, {
                  attributes: newAttributes
                })
              }); // update local cache with the proper attributes


              proxy.writeQuery({
                query: _core_utils_graphql_submission__WEBPACK_IMPORTED_MODULE_6__[
                /* readSubmissionQuery */
                "b"].query,
                data: update
              });
            }
          }));
        };
      };
      /**
       * Returns a function which mutations a submission field.
       * @param {Function} mutate
       * @param {object} ownProps
       * @param {String?} newSubmissionId
       */


      var submissionField = function submissionField(mutate, ownProps, newSubmissionId) {
        return function (_ref3) {
          var fields = _ref3.fields,
              _ref3$timestamp = _ref3.timestamp,
              timestamp = _ref3$timestamp === void 0 ? Date.now() : _ref3$timestamp;
          var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var options = Object(_core_utils_graphql_submission__WEBPACK_IMPORTED_MODULE_6__[
          /* getSubmissionOptions */
          "a"])(ownProps.formId, ownProps.submissionId || newSubmissionId[ownProps.formId], [], _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(fields), {
            attributes: values.attributes || lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(ownProps, 'data.Submission.attributes', []),
            fields: values.fields || lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(ownProps, 'data.Submission.fields', [])
          }, timestamp, ownProps.channel, ownProps.environment);
          return mutate(options);
        };
      };
      /***/

    },
    /* 113 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      var UserAgentData = __webpack_require__(1012);

      var VersionRange = __webpack_require__(1009);

      var mapObject = __webpack_require__(1008);

      var memoizeStringOnly = __webpack_require__(1007);
      /**
       * Checks to see whether `name` and `version` satisfy `query`.
       *
       * @param {string} name Name of the browser, device, engine or platform
       * @param {?string} version Version of the browser, engine or platform
       * @param {string} query Query of form "Name [range expression]"
       * @param {?function} normalizer Optional pre-processor for range expression
       * @return {boolean}
       */


      function compare(name, version, query, normalizer) {
        // check for exact match with no version
        if (name === query) {
          return true;
        } // check for non-matching names


        if (!query.startsWith(name)) {
          return false;
        } // full comparison with version


        var range = query.slice(name.length);

        if (version) {
          range = normalizer ? normalizer(range) : range;
          return VersionRange.contains(range, version);
        }

        return false;
      }
      /**
       * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
       * platform.
       *
       * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
       *
       * @param {string} version
       * @return {string}
       */


      function normalizePlatformVersion(version) {
        if (UserAgentData.platformName === 'Windows') {
          return version.replace(/^\s*NT/, '');
        }

        return version;
      }
      /**
       * Provides client-side access to the authoritative PHP-generated User Agent
       * information supplied by the server.
       */


      var UserAgent = {
        /**
         * Check if the User Agent browser matches `query`.
         *
         * `query` should be a string like "Chrome" or "Chrome > 33".
         *
         * Valid browser names include:
         *
         * - ACCESS NetFront
         * - AOL
         * - Amazon Silk
         * - Android
         * - BlackBerry
         * - BlackBerry PlayBook
         * - Chrome
         * - Chrome for iOS
         * - Chrome frame
         * - Facebook PHP SDK
         * - Facebook for iOS
         * - Firefox
         * - IE
         * - IE Mobile
         * - Mobile Safari
         * - Motorola Internet Browser
         * - Nokia
         * - Openwave Mobile Browser
         * - Opera
         * - Opera Mini
         * - Opera Mobile
         * - Safari
         * - UIWebView
         * - Unknown
         * - webOS
         * - etc...
         *
         * An authoritative list can be found in the PHP `BrowserDetector` class and
         * related classes in the same file (see calls to `new UserAgentBrowser` here:
         * https://fburl.com/50728104).
         *
         * @note Function results are memoized
         *
         * @param {string} query Query of the form "Name [range expression]"
         * @return {boolean}
         */
        isBrowser: function isBrowser(query) {
          return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
        },

        /**
         * Check if the User Agent browser uses a 32 or 64 bit architecture.
         *
         * @note Function results are memoized
         *
         * @param {string} query Query of the form "32" or "64".
         * @return {boolean}
         */
        isBrowserArchitecture: function isBrowserArchitecture(query) {
          return compare(UserAgentData.browserArchitecture, null, query);
        },

        /**
         * Check if the User Agent device matches `query`.
         *
         * `query` should be a string like "iPhone" or "iPad".
         *
         * Valid device names include:
         *
         * - Kindle
         * - Kindle Fire
         * - Unknown
         * - iPad
         * - iPhone
         * - iPod
         * - etc...
         *
         * An authoritative list can be found in the PHP `DeviceDetector` class and
         * related classes in the same file (see calls to `new UserAgentDevice` here:
         * https://fburl.com/50728332).
         *
         * @note Function results are memoized
         *
         * @param {string} query Query of the form "Name"
         * @return {boolean}
         */
        isDevice: function isDevice(query) {
          return compare(UserAgentData.deviceName, null, query);
        },

        /**
         * Check if the User Agent rendering engine matches `query`.
         *
         * `query` should be a string like "WebKit" or "WebKit >= 537".
         *
         * Valid engine names include:
         *
         * - Gecko
         * - Presto
         * - Trident
         * - WebKit
         * - etc...
         *
         * An authoritative list can be found in the PHP `RenderingEngineDetector`
         * class related classes in the same file (see calls to `new
         * UserAgentRenderingEngine` here: https://fburl.com/50728617).
         *
         * @note Function results are memoized
         *
         * @param {string} query Query of the form "Name [range expression]"
         * @return {boolean}
         */
        isEngine: function isEngine(query) {
          return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
        },

        /**
         * Check if the User Agent platform matches `query`.
         *
         * `query` should be a string like "Windows" or "iOS 5 - 6".
         *
         * Valid platform names include:
         *
         * - Android
         * - BlackBerry OS
         * - Java ME
         * - Linux
         * - Mac OS X
         * - Mac OS X Calendar
         * - Mac OS X Internet Account
         * - Symbian
         * - SymbianOS
         * - Windows
         * - Windows Mobile
         * - Windows Phone
         * - iOS
         * - iOS Facebook Integration Account
         * - iOS Facebook Social Sharing UI
         * - webOS
         * - Chrome OS
         * - etc...
         *
         * An authoritative list can be found in the PHP `PlatformDetector` class and
         * related classes in the same file (see calls to `new UserAgentPlatform`
         * here: https://fburl.com/50729226).
         *
         * @note Function results are memoized
         *
         * @param {string} query Query of the form "Name [range expression]"
         * @return {boolean}
         */
        isPlatform: function isPlatform(query) {
          return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
        },

        /**
         * Check if the User Agent platform is a 32 or 64 bit architecture.
         *
         * @note Function results are memoized
         *
         * @param {string} query Query of the form "32" or "64".
         * @return {boolean}
         */
        isPlatformArchitecture: function isPlatformArchitecture(query) {
          return compare(UserAgentData.platformArchitecture, null, query);
        }
      };
      module.exports = mapObject(UserAgent, memoizeStringOnly);
      /***/
    },
    /* 114 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      /**
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */

      var __DEV__ = "production" !== 'production';

      var warning = function warning() {};

      if (__DEV__) {
        var printWarning = function printWarning(format, args) {
          var len = arguments.length;
          args = new Array(len > 1 ? len - 1 : 0);

          for (var key = 1; key < len; key++) {
            args[key - 1] = arguments[key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.error(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        warning = function warning(condition, format, args) {
          var len = arguments.length;
          args = new Array(len > 2 ? len - 2 : 0);

          for (var key = 2; key < len; key++) {
            args[key - 2] = arguments[key];
          }

          if (format === undefined) {
            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (!condition) {
            printWarning.apply(null, [format].concat(args));
          }
        };
      }

      module.exports = warning;
      /***/
    },
    /* 115 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.print = print;

      var _visitor = __webpack_require__(1193);
      /**
       * Converts an AST into a string, using one set of reasonable
       * formatting rules.
       */


      function print(ast) {
        return (0, _visitor.visit)(ast, {
          leave: printDocASTReducer
        });
      }
      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */


      var printDocASTReducer = {
        Name: function Name(node) {
          return node.value;
        },
        Variable: function Variable(node) {
          return '$' + node.name;
        },
        // Document
        Document: function Document(node) {
          return join(node.definitions, '\n\n') + '\n';
        },
        OperationDefinition: function OperationDefinition(node) {
          var op = node.operation;
          var name = node.name;
          var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
          var directives = join(node.directives, ' ');
          var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
          // the query short form.

          return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
        },
        VariableDefinition: function VariableDefinition(_ref) {
          var variable = _ref.variable,
              type = _ref.type,
              defaultValue = _ref.defaultValue;
          return variable + ': ' + type + wrap(' = ', defaultValue);
        },
        SelectionSet: function SelectionSet(_ref2) {
          var selections = _ref2.selections;
          return block(selections);
        },
        Field: function Field(_ref3) {
          var alias = _ref3.alias,
              name = _ref3.name,
              args = _ref3.arguments,
              directives = _ref3.directives,
              selectionSet = _ref3.selectionSet;
          return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
        },
        Argument: function Argument(_ref4) {
          var name = _ref4.name,
              value = _ref4.value;
          return name + ': ' + value;
        },
        // Fragments
        FragmentSpread: function FragmentSpread(_ref5) {
          var name = _ref5.name,
              directives = _ref5.directives;
          return '...' + name + wrap(' ', join(directives, ' '));
        },
        InlineFragment: function InlineFragment(_ref6) {
          var typeCondition = _ref6.typeCondition,
              directives = _ref6.directives,
              selectionSet = _ref6.selectionSet;
          return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
        },
        FragmentDefinition: function FragmentDefinition(_ref7) {
          var name = _ref7.name,
              typeCondition = _ref7.typeCondition,
              directives = _ref7.directives,
              selectionSet = _ref7.selectionSet;
          return 'fragment ' + name + ' on ' + typeCondition + ' ' + wrap('', join(directives, ' '), ' ') + selectionSet;
        },
        // Value
        IntValue: function IntValue(_ref8) {
          var value = _ref8.value;
          return value;
        },
        FloatValue: function FloatValue(_ref9) {
          var value = _ref9.value;
          return value;
        },
        StringValue: function StringValue(_ref10) {
          var value = _ref10.value;
          return JSON.stringify(value);
        },
        BooleanValue: function BooleanValue(_ref11) {
          var value = _ref11.value;
          return JSON.stringify(value);
        },
        NullValue: function NullValue() {
          return 'null';
        },
        EnumValue: function EnumValue(_ref12) {
          var value = _ref12.value;
          return value;
        },
        ListValue: function ListValue(_ref13) {
          var values = _ref13.values;
          return '[' + join(values, ', ') + ']';
        },
        ObjectValue: function ObjectValue(_ref14) {
          var fields = _ref14.fields;
          return '{' + join(fields, ', ') + '}';
        },
        ObjectField: function ObjectField(_ref15) {
          var name = _ref15.name,
              value = _ref15.value;
          return name + ': ' + value;
        },
        // Directive
        Directive: function Directive(_ref16) {
          var name = _ref16.name,
              args = _ref16.arguments;
          return '@' + name + wrap('(', join(args, ', '), ')');
        },
        // Type
        NamedType: function NamedType(_ref17) {
          var name = _ref17.name;
          return name;
        },
        ListType: function ListType(_ref18) {
          var type = _ref18.type;
          return '[' + type + ']';
        },
        NonNullType: function NonNullType(_ref19) {
          var type = _ref19.type;
          return type + '!';
        },
        // Type System Definitions
        SchemaDefinition: function SchemaDefinition(_ref20) {
          var directives = _ref20.directives,
              operationTypes = _ref20.operationTypes;
          return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
        },
        OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
          var operation = _ref21.operation,
              type = _ref21.type;
          return operation + ': ' + type;
        },
        ScalarTypeDefinition: function ScalarTypeDefinition(_ref22) {
          var name = _ref22.name,
              directives = _ref22.directives;
          return join(['scalar', name, join(directives, ' ')], ' ');
        },
        ObjectTypeDefinition: function ObjectTypeDefinition(_ref23) {
          var name = _ref23.name,
              interfaces = _ref23.interfaces,
              directives = _ref23.directives,
              fields = _ref23.fields;
          return join(['type', name, wrap('implements ', join(interfaces, ', ')), join(directives, ' '), block(fields)], ' ');
        },
        FieldDefinition: function FieldDefinition(_ref24) {
          var name = _ref24.name,
              args = _ref24.arguments,
              type = _ref24.type,
              directives = _ref24.directives;
          return name + wrap('(', join(args, ', '), ')') + ': ' + type + wrap(' ', join(directives, ' '));
        },
        InputValueDefinition: function InputValueDefinition(_ref25) {
          var name = _ref25.name,
              type = _ref25.type,
              defaultValue = _ref25.defaultValue,
              directives = _ref25.directives;
          return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
        },
        InterfaceTypeDefinition: function InterfaceTypeDefinition(_ref26) {
          var name = _ref26.name,
              directives = _ref26.directives,
              fields = _ref26.fields;
          return join(['interface', name, join(directives, ' '), block(fields)], ' ');
        },
        UnionTypeDefinition: function UnionTypeDefinition(_ref27) {
          var name = _ref27.name,
              directives = _ref27.directives,
              types = _ref27.types;
          return join(['union', name, join(directives, ' '), '= ' + join(types, ' | ')], ' ');
        },
        EnumTypeDefinition: function EnumTypeDefinition(_ref28) {
          var name = _ref28.name,
              directives = _ref28.directives,
              values = _ref28.values;
          return join(['enum', name, join(directives, ' '), block(values)], ' ');
        },
        EnumValueDefinition: function EnumValueDefinition(_ref29) {
          var name = _ref29.name,
              directives = _ref29.directives;
          return join([name, join(directives, ' ')], ' ');
        },
        InputObjectTypeDefinition: function InputObjectTypeDefinition(_ref30) {
          var name = _ref30.name,
              directives = _ref30.directives,
              fields = _ref30.fields;
          return join(['input', name, join(directives, ' '), block(fields)], ' ');
        },
        TypeExtensionDefinition: function TypeExtensionDefinition(_ref31) {
          var definition = _ref31.definition;
          return 'extend ' + definition;
        },
        DirectiveDefinition: function DirectiveDefinition(_ref32) {
          var name = _ref32.name,
              args = _ref32.arguments,
              locations = _ref32.locations;
          return 'directive @' + name + wrap('(', join(args, ', '), ')') + ' on ' + join(locations, ' | ');
        }
      };
      /**
       * Given maybeArray, print an empty string if it is null or empty, otherwise
       * print all items together separated by separator if provided
       */

      function join(maybeArray, separator) {
        return maybeArray ? maybeArray.filter(function (x) {
          return x;
        }).join(separator || '') : '';
      }
      /**
       * Given array, print each item on its own line, wrapped in an
       * indented "{ }" block.
       */


      function block(array) {
        return array && array.length !== 0 ? indent('{\n' + join(array, '\n')) + '\n}' : '{}';
      }
      /**
       * If maybeString is not null or empty, then wrap with start and end, otherwise
       * print an empty string.
       */


      function wrap(start, maybeString, end) {
        return maybeString ? start + maybeString + (end || '') : '';
      }

      function indent(maybeString) {
        return maybeString && maybeString.replace(/\n/g, '\n  ');
      }
      /***/

    },
    /* 116 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var antd_lib_spin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(682);
      /* harmony import */


      var antd_lib_spin__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(antd_lib_spin__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _core_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18);
      /**
       * Displays the default form loading screen
       * @return {React.Component}
       */


      var FormLoading = function FormLoading(props) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
          className: "formatic-form-loading-container"
        }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(antd_lib_spin__WEBPACK_IMPORTED_MODULE_2___default.a, {
          tip: props.loadingText || Object(_core_utils__WEBPACK_IMPORTED_MODULE_3__[
          /* getLangValue */
          "g"])('formLoading'),
          className: "formatic-form-loading"
        }));
      };

      FormLoading.defaultProps = {
        loadingText: 'Loading...'
      };
      FormLoading.propTypes = {
        loadingText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
      };
      /* harmony default export */

      __webpack_exports__["a"] = FormLoading;
      /***/
    },
    /* 117 */

    /***/
    function (module, exports, __webpack_require__) {
      /**
       * Copyright 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule ReactComponentWithPureRenderMixin
       */
      var shallowEqual = __webpack_require__(1114);

      function shallowCompare(instance, nextProps, nextState) {
        return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
      }
      /**
       * If your React component's render function is "pure", e.g. it will render the
       * same result given the same props and state, provide this mixin for a
       * considerable performance boost.
       *
       * Most React components have pure render functions.
       *
       * Example:
       *
       *   var ReactComponentWithPureRenderMixin =
       *     require('ReactComponentWithPureRenderMixin');
       *   React.createClass({
       *     mixins: [ReactComponentWithPureRenderMixin],
       *
       *     render: function() {
       *       return <div className={this.props.className}>foo</div>;
       *     }
       *   });
       *
       * Note: This only checks shallow equality for props and state. If these contain
       * complex data structures this mixin may have false-negatives for deeper
       * differences. Only mixin to components which have simple props and state, or
       * use `forceUpdate()` when you know deep data structures have changed.
       *
       * See https://facebook.github.io/react/docs/pure-render-mixin.html
       */


      var ReactComponentWithPureRenderMixin = {
        shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
          return shallowCompare(this, nextProps, nextState);
        }
      };
      module.exports = ReactComponentWithPureRenderMixin;
      /***/
    },
    /* 118 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return toArray;
      });
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

      function toArray(children) {
        var ret = [];
        react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.forEach(children, function (c) {
          ret.push(c);
        });
        return ret;
      }
      /***/

    },
    /* 119 */

    /***/
    function (module, exports, __webpack_require__) {
      var parser = __webpack_require__(1189);

      var parse = parser.parse; // Strip insignificant whitespace
      // Note that this could do a lot more, such as reorder fields etc.

      function normalize(string) {
        return string.replace(/[\s,]+/g, ' ').trim();
      } // A map docString -> graphql document


      var docCache = {}; // A map fragmentName -> [normalized source]

      var fragmentSourceMap = {};

      function cacheKeyFromLoc(loc) {
        return normalize(loc.source.body.substring(loc.start, loc.end));
      } // For testing.


      function resetCaches() {
        docCache = {};
        fragmentSourceMap = {};
      } // Take a unstripped parsed document (query/mutation or even fragment), and
      // check all fragment definitions, checking for name->source uniqueness.
      // We also want to make sure only unique fragments exist in the document.


      var printFragmentWarnings = true;

      function processFragments(ast) {
        var astFragmentMap = {};
        var definitions = [];

        for (var i = 0; i < ast.definitions.length; i++) {
          var fragmentDefinition = ast.definitions[i];

          if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc); // We know something about this fragment

            if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {
              // this is a problem because the app developer is trying to register another fragment with
              // the same name as one previously registered. So, we tell them about it.
              if (printFragmentWarnings) {
                console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
              }

              fragmentSourceMap[fragmentName][sourceKey] = true;
            } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
              fragmentSourceMap[fragmentName] = {};
              fragmentSourceMap[fragmentName][sourceKey] = true;
            }

            if (!astFragmentMap[sourceKey]) {
              astFragmentMap[sourceKey] = true;
              definitions.push(fragmentDefinition);
            }
          } else {
            definitions.push(fragmentDefinition);
          }
        }

        ast.definitions = definitions;
        return ast;
      }

      function disableFragmentWarnings() {
        printFragmentWarnings = false;
      }

      function stripLoc(doc, removeLocAtThisLevel) {
        var docType = Object.prototype.toString.call(doc);

        if (docType === '[object Array]') {
          return doc.map(function (d) {
            return stripLoc(d, removeLocAtThisLevel);
          });
        }

        if (docType !== '[object Object]') {
          throw new Error('Unexpected input.');
        } // We don't want to remove the root loc field so we can use it
        // for fragment substitution (see below)


        if (removeLocAtThisLevel && doc.loc) {
          delete doc.loc;
        } // https://github.com/apollographql/graphql-tag/issues/40


        if (doc.loc) {
          delete doc.loc.startToken;
          delete doc.loc.endToken;
        }

        var keys = Object.keys(doc);
        var key;
        var value;
        var valueType;

        for (key in keys) {
          if (keys.hasOwnProperty(key)) {
            value = doc[keys[key]];
            valueType = Object.prototype.toString.call(value);

            if (valueType === '[object Object]' || valueType === '[object Array]') {
              doc[keys[key]] = stripLoc(value, true);
            }
          }
        }

        return doc;
      }

      var experimentalFragmentVariables = false;

      function parseDocument(doc) {
        var cacheKey = normalize(doc);

        if (docCache[cacheKey]) {
          return docCache[cacheKey];
        }

        var parsed = parse(doc, {
          experimentalFragmentVariables: experimentalFragmentVariables
        });

        if (!parsed || parsed.kind !== 'Document') {
          throw new Error('Not a valid GraphQL document.');
        } // check that all "new" fragments inside the documents are consistent with
        // existing fragments of the same name


        parsed = processFragments(parsed);
        parsed = stripLoc(parsed, false);
        docCache[cacheKey] = parsed;
        return parsed;
      }

      function enableExperimentalFragmentVariables() {
        experimentalFragmentVariables = true;
      }

      function disableExperimentalFragmentVariables() {
        experimentalFragmentVariables = false;
      } // XXX This should eventually disallow arbitrary string interpolation, like Relay does


      function gql()
      /* arguments */
      {
        var args = Array.prototype.slice.call(arguments);
        var literals = args[0]; // We always get literals[0] and then matching post literals for each arg given

        var result = typeof literals === "string" ? literals : literals[0];

        for (var i = 1; i < args.length; i++) {
          if (args[i] && args[i].kind && args[i].kind === 'Document') {
            result += args[i].loc.source.body;
          } else {
            result += args[i];
          }

          result += literals[i];
        }

        return parseDocument(result);
      } // Support typescript, which isn't as nice as Babel about default exports


      gql.default = gql;
      gql.resetCaches = resetCaches;
      gql.disableFragmentWarnings = disableFragmentWarnings;
      gql.enableExperimentalFragmentVariables = enableExperimentalFragmentVariables;
      gql.disableExperimentalFragmentVariables = disableExperimentalFragmentVariables;
      module.exports = gql;
      /***/
    },
    /* 120 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);

      var ErrorMessage = function ErrorMessage(_ref) {
        var text = _ref.text;
        return text && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
          className: "formatic-error-message"
        }, text);
      };

      ErrorMessage.defaultProps = {};
      ErrorMessage.propTypes = {
        text: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
      };
      /* harmony default export */

      __webpack_exports__["a"] = ErrorMessage;
      /***/
    },
    /* 121 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGetTag = __webpack_require__(135),
          isArray = __webpack_require__(55),
          isObjectLike = __webpack_require__(109);
      /** `Object#toString` result references. */


      var stringTag = '[object String]';
      /**
       * Checks if `value` is classified as a `String` primitive or object.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a string, else `false`.
       * @example
       *
       * _.isString('abc');
       * // => true
       *
       * _.isString(1);
       * // => false
       */

      function isString(value) {
        return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }

      module.exports = isString;
      /***/
    },
    /* 122 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* WEBPACK VAR INJECTION */


      (function (global, module) {
        /* harmony import */
        var _ponyfill_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(713);
        /* global window */


        var root;

        if (typeof self !== 'undefined') {
          root = self;
        } else if (typeof window !== 'undefined') {
          root = window;
        } else if (typeof global !== 'undefined') {
          root = global;
        } else if (true) {
          root = module;
        } else {}

        var result = Object(_ponyfill_js__WEBPACK_IMPORTED_MODULE_0__[
        /* default */
        "a"])(root);
        /* harmony default export */

        __webpack_exports__["default"] = result;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71), __webpack_require__(1194)(module));
      /***/
    },
    /* 123 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global, module) {
        var __WEBPACK_AMD_DEFINE_RESULT__;
        /**
        * @license
        * Lodash <https://lodash.com/>
        * Copyright JS Foundation and other contributors <https://js.foundation/>
        * Released under MIT license <https://lodash.com/license>
        * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
        * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
        */


        ;
        (function () {
          /** Used as a safe reference for `undefined` in pre-ES5 environments. */
          var undefined;
          /** Used as the semantic version number. */

          var VERSION = '4.17.11';
          /** Used as the size to enable large array optimizations. */

          var LARGE_ARRAY_SIZE = 200;
          /** Error message constants. */

          var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
              FUNC_ERROR_TEXT = 'Expected a function';
          /** Used to stand-in for `undefined` hash values. */

          var HASH_UNDEFINED = '__lodash_hash_undefined__';
          /** Used as the maximum memoize cache size. */

          var MAX_MEMOIZE_SIZE = 500;
          /** Used as the internal argument placeholder. */

          var PLACEHOLDER = '__lodash_placeholder__';
          /** Used to compose bitmasks for cloning. */

          var CLONE_DEEP_FLAG = 1,
              CLONE_FLAT_FLAG = 2,
              CLONE_SYMBOLS_FLAG = 4;
          /** Used to compose bitmasks for value comparisons. */

          var COMPARE_PARTIAL_FLAG = 1,
              COMPARE_UNORDERED_FLAG = 2;
          /** Used to compose bitmasks for function metadata. */

          var WRAP_BIND_FLAG = 1,
              WRAP_BIND_KEY_FLAG = 2,
              WRAP_CURRY_BOUND_FLAG = 4,
              WRAP_CURRY_FLAG = 8,
              WRAP_CURRY_RIGHT_FLAG = 16,
              WRAP_PARTIAL_FLAG = 32,
              WRAP_PARTIAL_RIGHT_FLAG = 64,
              WRAP_ARY_FLAG = 128,
              WRAP_REARG_FLAG = 256,
              WRAP_FLIP_FLAG = 512;
          /** Used as default options for `_.truncate`. */

          var DEFAULT_TRUNC_LENGTH = 30,
              DEFAULT_TRUNC_OMISSION = '...';
          /** Used to detect hot functions by number of calls within a span of milliseconds. */

          var HOT_COUNT = 800,
              HOT_SPAN = 16;
          /** Used to indicate the type of lazy iteratees. */

          var LAZY_FILTER_FLAG = 1,
              LAZY_MAP_FLAG = 2,
              LAZY_WHILE_FLAG = 3;
          /** Used as references for various `Number` constants. */

          var INFINITY = 1 / 0,
              MAX_SAFE_INTEGER = 9007199254740991,
              MAX_INTEGER = 1.7976931348623157e+308,
              NAN = 0 / 0;
          /** Used as references for the maximum length and index of an array. */

          var MAX_ARRAY_LENGTH = 4294967295,
              MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
              HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
          /** Used to associate wrap methods with their bit flags. */

          var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];
          /** `Object#toString` result references. */

          var argsTag = '[object Arguments]',
              arrayTag = '[object Array]',
              asyncTag = '[object AsyncFunction]',
              boolTag = '[object Boolean]',
              dateTag = '[object Date]',
              domExcTag = '[object DOMException]',
              errorTag = '[object Error]',
              funcTag = '[object Function]',
              genTag = '[object GeneratorFunction]',
              mapTag = '[object Map]',
              numberTag = '[object Number]',
              nullTag = '[object Null]',
              objectTag = '[object Object]',
              promiseTag = '[object Promise]',
              proxyTag = '[object Proxy]',
              regexpTag = '[object RegExp]',
              setTag = '[object Set]',
              stringTag = '[object String]',
              symbolTag = '[object Symbol]',
              undefinedTag = '[object Undefined]',
              weakMapTag = '[object WeakMap]',
              weakSetTag = '[object WeakSet]';
          var arrayBufferTag = '[object ArrayBuffer]',
              dataViewTag = '[object DataView]',
              float32Tag = '[object Float32Array]',
              float64Tag = '[object Float64Array]',
              int8Tag = '[object Int8Array]',
              int16Tag = '[object Int16Array]',
              int32Tag = '[object Int32Array]',
              uint8Tag = '[object Uint8Array]',
              uint8ClampedTag = '[object Uint8ClampedArray]',
              uint16Tag = '[object Uint16Array]',
              uint32Tag = '[object Uint32Array]';
          /** Used to match empty string literals in compiled template source. */

          var reEmptyStringLeading = /\b__p \+= '';/g,
              reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
              reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
          /** Used to match HTML entities and HTML characters. */

          var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
              reUnescapedHtml = /[&<>"']/g,
              reHasEscapedHtml = RegExp(reEscapedHtml.source),
              reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
          /** Used to match template delimiters. */

          var reEscape = /<%-([\s\S]+?)%>/g,
              reEvaluate = /<%([\s\S]+?)%>/g,
              reInterpolate = /<%=([\s\S]+?)%>/g;
          /** Used to match property names within property paths. */

          var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
              reIsPlainProp = /^\w*$/,
              rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
          /**
           * Used to match `RegExp`
           * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
           */

          var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
              reHasRegExpChar = RegExp(reRegExpChar.source);
          /** Used to match leading and trailing whitespace. */

          var reTrim = /^\s+|\s+$/g,
              reTrimStart = /^\s+/,
              reTrimEnd = /\s+$/;
          /** Used to match wrap detail comments. */

          var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
              reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
              reSplitDetails = /,? & /;
          /** Used to match words composed of alphanumeric characters. */

          var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
          /** Used to match backslashes in property paths. */

          var reEscapeChar = /\\(\\)?/g;
          /**
           * Used to match
           * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
           */

          var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
          /** Used to match `RegExp` flags from their coerced string values. */

          var reFlags = /\w*$/;
          /** Used to detect bad signed hexadecimal string values. */

          var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
          /** Used to detect binary string values. */

          var reIsBinary = /^0b[01]+$/i;
          /** Used to detect host constructors (Safari). */

          var reIsHostCtor = /^\[object .+?Constructor\]$/;
          /** Used to detect octal string values. */

          var reIsOctal = /^0o[0-7]+$/i;
          /** Used to detect unsigned integer values. */

          var reIsUint = /^(?:0|[1-9]\d*)$/;
          /** Used to match Latin Unicode letters (excluding mathematical operators). */

          var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
          /** Used to ensure capturing order of template delimiters. */

          var reNoMatch = /($^)/;
          /** Used to match unescaped characters in compiled string literals. */

          var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
          /** Used to compose unicode character classes. */

          var rsAstralRange = "\\ud800-\\udfff",
              rsComboMarksRange = "\\u0300-\\u036f",
              reComboHalfMarksRange = "\\ufe20-\\ufe2f",
              rsComboSymbolsRange = "\\u20d0-\\u20ff",
              rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
              rsDingbatRange = "\\u2700-\\u27bf",
              rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
              rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
              rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
              rsPunctuationRange = "\\u2000-\\u206f",
              rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
              rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
              rsVarRange = "\\ufe0e\\ufe0f",
              rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
          /** Used to compose unicode capture groups. */

          var rsApos = "['\u2019]",
              rsAstral = '[' + rsAstralRange + ']',
              rsBreak = '[' + rsBreakRange + ']',
              rsCombo = '[' + rsComboRange + ']',
              rsDigits = '\\d+',
              rsDingbat = '[' + rsDingbatRange + ']',
              rsLower = '[' + rsLowerRange + ']',
              rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
              rsFitz = "\\ud83c[\\udffb-\\udfff]",
              rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
              rsNonAstral = '[^' + rsAstralRange + ']',
              rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
              rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
              rsUpper = '[' + rsUpperRange + ']',
              rsZWJ = "\\u200d";
          /** Used to compose unicode regexes. */

          var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
              rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
              rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
              rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
              reOptMod = rsModifier + '?',
              rsOptVar = '[' + rsVarRange + ']?',
              rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
              rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
              rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
              rsSeq = rsOptVar + reOptMod + rsOptJoin,
              rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
              rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
          /** Used to match apostrophes. */

          var reApos = RegExp(rsApos, 'g');
          /**
           * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
           * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
           */

          var reComboMark = RegExp(rsCombo, 'g');
          /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

          var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
          /** Used to match complex or compound words. */

          var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');
          /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

          var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
          /** Used to detect strings that need a more robust regexp to match words. */

          var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
          /** Used to assign default `context` object properties. */

          var contextProps = ['Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'];
          /** Used to make template sourceURLs easier to identify. */

          var templateCounter = -1;
          /** Used to identify `toStringTag` values of typed arrays. */

          var typedArrayTags = {};
          typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
          typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
          /** Used to identify `toStringTag` values supported by `_.clone`. */

          var cloneableTags = {};
          cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
          cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
          /** Used to map Latin Unicode letters to basic Latin letters. */

          var deburredLetters = {
            // Latin-1 Supplement block.
            '\xc0': 'A',
            '\xc1': 'A',
            '\xc2': 'A',
            '\xc3': 'A',
            '\xc4': 'A',
            '\xc5': 'A',
            '\xe0': 'a',
            '\xe1': 'a',
            '\xe2': 'a',
            '\xe3': 'a',
            '\xe4': 'a',
            '\xe5': 'a',
            '\xc7': 'C',
            '\xe7': 'c',
            '\xd0': 'D',
            '\xf0': 'd',
            '\xc8': 'E',
            '\xc9': 'E',
            '\xca': 'E',
            '\xcb': 'E',
            '\xe8': 'e',
            '\xe9': 'e',
            '\xea': 'e',
            '\xeb': 'e',
            '\xcc': 'I',
            '\xcd': 'I',
            '\xce': 'I',
            '\xcf': 'I',
            '\xec': 'i',
            '\xed': 'i',
            '\xee': 'i',
            '\xef': 'i',
            '\xd1': 'N',
            '\xf1': 'n',
            '\xd2': 'O',
            '\xd3': 'O',
            '\xd4': 'O',
            '\xd5': 'O',
            '\xd6': 'O',
            '\xd8': 'O',
            '\xf2': 'o',
            '\xf3': 'o',
            '\xf4': 'o',
            '\xf5': 'o',
            '\xf6': 'o',
            '\xf8': 'o',
            '\xd9': 'U',
            '\xda': 'U',
            '\xdb': 'U',
            '\xdc': 'U',
            '\xf9': 'u',
            '\xfa': 'u',
            '\xfb': 'u',
            '\xfc': 'u',
            '\xdd': 'Y',
            '\xfd': 'y',
            '\xff': 'y',
            '\xc6': 'Ae',
            '\xe6': 'ae',
            '\xde': 'Th',
            '\xfe': 'th',
            '\xdf': 'ss',
            // Latin Extended-A block.
            "\u0100": 'A',
            "\u0102": 'A',
            "\u0104": 'A',
            "\u0101": 'a',
            "\u0103": 'a',
            "\u0105": 'a',
            "\u0106": 'C',
            "\u0108": 'C',
            "\u010A": 'C',
            "\u010C": 'C',
            "\u0107": 'c',
            "\u0109": 'c',
            "\u010B": 'c',
            "\u010D": 'c',
            "\u010E": 'D',
            "\u0110": 'D',
            "\u010F": 'd',
            "\u0111": 'd',
            "\u0112": 'E',
            "\u0114": 'E',
            "\u0116": 'E',
            "\u0118": 'E',
            "\u011A": 'E',
            "\u0113": 'e',
            "\u0115": 'e',
            "\u0117": 'e',
            "\u0119": 'e',
            "\u011B": 'e',
            "\u011C": 'G',
            "\u011E": 'G',
            "\u0120": 'G',
            "\u0122": 'G',
            "\u011D": 'g',
            "\u011F": 'g',
            "\u0121": 'g',
            "\u0123": 'g',
            "\u0124": 'H',
            "\u0126": 'H',
            "\u0125": 'h',
            "\u0127": 'h',
            "\u0128": 'I',
            "\u012A": 'I',
            "\u012C": 'I',
            "\u012E": 'I',
            "\u0130": 'I',
            "\u0129": 'i',
            "\u012B": 'i',
            "\u012D": 'i',
            "\u012F": 'i',
            "\u0131": 'i',
            "\u0134": 'J',
            "\u0135": 'j',
            "\u0136": 'K',
            "\u0137": 'k',
            "\u0138": 'k',
            "\u0139": 'L',
            "\u013B": 'L',
            "\u013D": 'L',
            "\u013F": 'L',
            "\u0141": 'L',
            "\u013A": 'l',
            "\u013C": 'l',
            "\u013E": 'l',
            "\u0140": 'l',
            "\u0142": 'l',
            "\u0143": 'N',
            "\u0145": 'N',
            "\u0147": 'N',
            "\u014A": 'N',
            "\u0144": 'n',
            "\u0146": 'n',
            "\u0148": 'n',
            "\u014B": 'n',
            "\u014C": 'O',
            "\u014E": 'O',
            "\u0150": 'O',
            "\u014D": 'o',
            "\u014F": 'o',
            "\u0151": 'o',
            "\u0154": 'R',
            "\u0156": 'R',
            "\u0158": 'R',
            "\u0155": 'r',
            "\u0157": 'r',
            "\u0159": 'r',
            "\u015A": 'S',
            "\u015C": 'S',
            "\u015E": 'S',
            "\u0160": 'S',
            "\u015B": 's',
            "\u015D": 's',
            "\u015F": 's',
            "\u0161": 's',
            "\u0162": 'T',
            "\u0164": 'T',
            "\u0166": 'T',
            "\u0163": 't',
            "\u0165": 't',
            "\u0167": 't',
            "\u0168": 'U',
            "\u016A": 'U',
            "\u016C": 'U',
            "\u016E": 'U',
            "\u0170": 'U',
            "\u0172": 'U',
            "\u0169": 'u',
            "\u016B": 'u',
            "\u016D": 'u',
            "\u016F": 'u',
            "\u0171": 'u',
            "\u0173": 'u',
            "\u0174": 'W',
            "\u0175": 'w',
            "\u0176": 'Y',
            "\u0177": 'y',
            "\u0178": 'Y',
            "\u0179": 'Z',
            "\u017B": 'Z',
            "\u017D": 'Z',
            "\u017A": 'z',
            "\u017C": 'z',
            "\u017E": 'z',
            "\u0132": 'IJ',
            "\u0133": 'ij',
            "\u0152": 'Oe',
            "\u0153": 'oe',
            "\u0149": "'n",
            "\u017F": 's'
          };
          /** Used to map characters to HTML entities. */

          var htmlEscapes = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
          };
          /** Used to map HTML entities to characters. */

          var htmlUnescapes = {
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&quot;': '"',
            '&#39;': "'"
          };
          /** Used to escape characters for inclusion in compiled string literals. */

          var stringEscapes = {
            '\\': '\\',
            "'": "'",
            '\n': 'n',
            '\r': 'r',
            "\u2028": 'u2028',
            "\u2029": 'u2029'
          };
          /** Built-in method references without a dependency on `root`. */

          var freeParseFloat = parseFloat,
              freeParseInt = parseInt;
          /** Detect free variable `global` from Node.js. */

          var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
          /** Detect free variable `self`. */

          var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
          /** Used as a reference to the global object. */

          var root = freeGlobal || freeSelf || Function('return this')();
          /** Detect free variable `exports`. */

          var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
          /** Detect free variable `module`. */

          var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
          /** Detect the popular CommonJS extension `module.exports`. */

          var moduleExports = freeModule && freeModule.exports === freeExports;
          /** Detect free variable `process` from Node.js. */

          var freeProcess = moduleExports && freeGlobal.process;
          /** Used to access faster Node.js helpers. */

          var nodeUtil = function () {
            try {
              // Use `util.types` for Node.js 10+.
              var types = freeModule && freeModule.require && freeModule.require('util').types;

              if (types) {
                return types;
              } // Legacy `process.binding('util')` for Node.js < 10.


              return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
          }();
          /* Node.js helper references. */


          var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
              nodeIsDate = nodeUtil && nodeUtil.isDate,
              nodeIsMap = nodeUtil && nodeUtil.isMap,
              nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
              nodeIsSet = nodeUtil && nodeUtil.isSet,
              nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
          /*--------------------------------------------------------------------------*/

          /**
           * A faster alternative to `Function#apply`, this function invokes `func`
           * with the `this` binding of `thisArg` and the arguments of `args`.
           *
           * @private
           * @param {Function} func The function to invoke.
           * @param {*} thisArg The `this` binding of `func`.
           * @param {Array} args The arguments to invoke `func` with.
           * @returns {*} Returns the result of `func`.
           */

          function apply(func, thisArg, args) {
            switch (args.length) {
              case 0:
                return func.call(thisArg);

              case 1:
                return func.call(thisArg, args[0]);

              case 2:
                return func.call(thisArg, args[0], args[1]);

              case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
            }

            return func.apply(thisArg, args);
          }
          /**
           * A specialized version of `baseAggregator` for arrays.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} setter The function to set `accumulator` values.
           * @param {Function} iteratee The iteratee to transform keys.
           * @param {Object} accumulator The initial aggregated object.
           * @returns {Function} Returns `accumulator`.
           */


          function arrayAggregator(array, setter, iteratee, accumulator) {
            var index = -1,
                length = array == null ? 0 : array.length;

            while (++index < length) {
              var value = array[index];
              setter(accumulator, value, iteratee(value), array);
            }

            return accumulator;
          }
          /**
           * A specialized version of `_.forEach` for arrays without support for
           * iteratee shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @returns {Array} Returns `array`.
           */


          function arrayEach(array, iteratee) {
            var index = -1,
                length = array == null ? 0 : array.length;

            while (++index < length) {
              if (iteratee(array[index], index, array) === false) {
                break;
              }
            }

            return array;
          }
          /**
           * A specialized version of `_.forEachRight` for arrays without support for
           * iteratee shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @returns {Array} Returns `array`.
           */


          function arrayEachRight(array, iteratee) {
            var length = array == null ? 0 : array.length;

            while (length--) {
              if (iteratee(array[length], length, array) === false) {
                break;
              }
            }

            return array;
          }
          /**
           * A specialized version of `_.every` for arrays without support for
           * iteratee shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} predicate The function invoked per iteration.
           * @returns {boolean} Returns `true` if all elements pass the predicate check,
           *  else `false`.
           */


          function arrayEvery(array, predicate) {
            var index = -1,
                length = array == null ? 0 : array.length;

            while (++index < length) {
              if (!predicate(array[index], index, array)) {
                return false;
              }
            }

            return true;
          }
          /**
           * A specialized version of `_.filter` for arrays without support for
           * iteratee shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} predicate The function invoked per iteration.
           * @returns {Array} Returns the new filtered array.
           */


          function arrayFilter(array, predicate) {
            var index = -1,
                length = array == null ? 0 : array.length,
                resIndex = 0,
                result = [];

            while (++index < length) {
              var value = array[index];

              if (predicate(value, index, array)) {
                result[resIndex++] = value;
              }
            }

            return result;
          }
          /**
           * A specialized version of `_.includes` for arrays without support for
           * specifying an index to search from.
           *
           * @private
           * @param {Array} [array] The array to inspect.
           * @param {*} target The value to search for.
           * @returns {boolean} Returns `true` if `target` is found, else `false`.
           */


          function arrayIncludes(array, value) {
            var length = array == null ? 0 : array.length;
            return !!length && baseIndexOf(array, value, 0) > -1;
          }
          /**
           * This function is like `arrayIncludes` except that it accepts a comparator.
           *
           * @private
           * @param {Array} [array] The array to inspect.
           * @param {*} target The value to search for.
           * @param {Function} comparator The comparator invoked per element.
           * @returns {boolean} Returns `true` if `target` is found, else `false`.
           */


          function arrayIncludesWith(array, value, comparator) {
            var index = -1,
                length = array == null ? 0 : array.length;

            while (++index < length) {
              if (comparator(value, array[index])) {
                return true;
              }
            }

            return false;
          }
          /**
           * A specialized version of `_.map` for arrays without support for iteratee
           * shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @returns {Array} Returns the new mapped array.
           */


          function arrayMap(array, iteratee) {
            var index = -1,
                length = array == null ? 0 : array.length,
                result = Array(length);

            while (++index < length) {
              result[index] = iteratee(array[index], index, array);
            }

            return result;
          }
          /**
           * Appends the elements of `values` to `array`.
           *
           * @private
           * @param {Array} array The array to modify.
           * @param {Array} values The values to append.
           * @returns {Array} Returns `array`.
           */


          function arrayPush(array, values) {
            var index = -1,
                length = values.length,
                offset = array.length;

            while (++index < length) {
              array[offset + index] = values[index];
            }

            return array;
          }
          /**
           * A specialized version of `_.reduce` for arrays without support for
           * iteratee shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @param {*} [accumulator] The initial value.
           * @param {boolean} [initAccum] Specify using the first element of `array` as
           *  the initial value.
           * @returns {*} Returns the accumulated value.
           */


          function arrayReduce(array, iteratee, accumulator, initAccum) {
            var index = -1,
                length = array == null ? 0 : array.length;

            if (initAccum && length) {
              accumulator = array[++index];
            }

            while (++index < length) {
              accumulator = iteratee(accumulator, array[index], index, array);
            }

            return accumulator;
          }
          /**
           * A specialized version of `_.reduceRight` for arrays without support for
           * iteratee shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @param {*} [accumulator] The initial value.
           * @param {boolean} [initAccum] Specify using the last element of `array` as
           *  the initial value.
           * @returns {*} Returns the accumulated value.
           */


          function arrayReduceRight(array, iteratee, accumulator, initAccum) {
            var length = array == null ? 0 : array.length;

            if (initAccum && length) {
              accumulator = array[--length];
            }

            while (length--) {
              accumulator = iteratee(accumulator, array[length], length, array);
            }

            return accumulator;
          }
          /**
           * A specialized version of `_.some` for arrays without support for iteratee
           * shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} predicate The function invoked per iteration.
           * @returns {boolean} Returns `true` if any element passes the predicate check,
           *  else `false`.
           */


          function arraySome(array, predicate) {
            var index = -1,
                length = array == null ? 0 : array.length;

            while (++index < length) {
              if (predicate(array[index], index, array)) {
                return true;
              }
            }

            return false;
          }
          /**
           * Gets the size of an ASCII `string`.
           *
           * @private
           * @param {string} string The string inspect.
           * @returns {number} Returns the string size.
           */


          var asciiSize = baseProperty('length');
          /**
           * Converts an ASCII `string` to an array.
           *
           * @private
           * @param {string} string The string to convert.
           * @returns {Array} Returns the converted array.
           */

          function asciiToArray(string) {
            return string.split('');
          }
          /**
           * Splits an ASCII `string` into an array of its words.
           *
           * @private
           * @param {string} The string to inspect.
           * @returns {Array} Returns the words of `string`.
           */


          function asciiWords(string) {
            return string.match(reAsciiWord) || [];
          }
          /**
           * The base implementation of methods like `_.findKey` and `_.findLastKey`,
           * without support for iteratee shorthands, which iterates over `collection`
           * using `eachFunc`.
           *
           * @private
           * @param {Array|Object} collection The collection to inspect.
           * @param {Function} predicate The function invoked per iteration.
           * @param {Function} eachFunc The function to iterate over `collection`.
           * @returns {*} Returns the found element or its key, else `undefined`.
           */


          function baseFindKey(collection, predicate, eachFunc) {
            var result;
            eachFunc(collection, function (value, key, collection) {
              if (predicate(value, key, collection)) {
                result = key;
                return false;
              }
            });
            return result;
          }
          /**
           * The base implementation of `_.findIndex` and `_.findLastIndex` without
           * support for iteratee shorthands.
           *
           * @private
           * @param {Array} array The array to inspect.
           * @param {Function} predicate The function invoked per iteration.
           * @param {number} fromIndex The index to search from.
           * @param {boolean} [fromRight] Specify iterating from right to left.
           * @returns {number} Returns the index of the matched value, else `-1`.
           */


          function baseFindIndex(array, predicate, fromIndex, fromRight) {
            var length = array.length,
                index = fromIndex + (fromRight ? 1 : -1);

            while (fromRight ? index-- : ++index < length) {
              if (predicate(array[index], index, array)) {
                return index;
              }
            }

            return -1;
          }
          /**
           * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
           *
           * @private
           * @param {Array} array The array to inspect.
           * @param {*} value The value to search for.
           * @param {number} fromIndex The index to search from.
           * @returns {number} Returns the index of the matched value, else `-1`.
           */


          function baseIndexOf(array, value, fromIndex) {
            return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
          }
          /**
           * This function is like `baseIndexOf` except that it accepts a comparator.
           *
           * @private
           * @param {Array} array The array to inspect.
           * @param {*} value The value to search for.
           * @param {number} fromIndex The index to search from.
           * @param {Function} comparator The comparator invoked per element.
           * @returns {number} Returns the index of the matched value, else `-1`.
           */


          function baseIndexOfWith(array, value, fromIndex, comparator) {
            var index = fromIndex - 1,
                length = array.length;

            while (++index < length) {
              if (comparator(array[index], value)) {
                return index;
              }
            }

            return -1;
          }
          /**
           * The base implementation of `_.isNaN` without support for number objects.
           *
           * @private
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
           */


          function baseIsNaN(value) {
            return value !== value;
          }
          /**
           * The base implementation of `_.mean` and `_.meanBy` without support for
           * iteratee shorthands.
           *
           * @private
           * @param {Array} array The array to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @returns {number} Returns the mean.
           */


          function baseMean(array, iteratee) {
            var length = array == null ? 0 : array.length;
            return length ? baseSum(array, iteratee) / length : NAN;
          }
          /**
           * The base implementation of `_.property` without support for deep paths.
           *
           * @private
           * @param {string} key The key of the property to get.
           * @returns {Function} Returns the new accessor function.
           */


          function baseProperty(key) {
            return function (object) {
              return object == null ? undefined : object[key];
            };
          }
          /**
           * The base implementation of `_.propertyOf` without support for deep paths.
           *
           * @private
           * @param {Object} object The object to query.
           * @returns {Function} Returns the new accessor function.
           */


          function basePropertyOf(object) {
            return function (key) {
              return object == null ? undefined : object[key];
            };
          }
          /**
           * The base implementation of `_.reduce` and `_.reduceRight`, without support
           * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
           *
           * @private
           * @param {Array|Object} collection The collection to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @param {*} accumulator The initial value.
           * @param {boolean} initAccum Specify using the first or last element of
           *  `collection` as the initial value.
           * @param {Function} eachFunc The function to iterate over `collection`.
           * @returns {*} Returns the accumulated value.
           */


          function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
            eachFunc(collection, function (value, index, collection) {
              accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
            });
            return accumulator;
          }
          /**
           * The base implementation of `_.sortBy` which uses `comparer` to define the
           * sort order of `array` and replaces criteria objects with their corresponding
           * values.
           *
           * @private
           * @param {Array} array The array to sort.
           * @param {Function} comparer The function to define sort order.
           * @returns {Array} Returns `array`.
           */


          function baseSortBy(array, comparer) {
            var length = array.length;
            array.sort(comparer);

            while (length--) {
              array[length] = array[length].value;
            }

            return array;
          }
          /**
           * The base implementation of `_.sum` and `_.sumBy` without support for
           * iteratee shorthands.
           *
           * @private
           * @param {Array} array The array to iterate over.
           * @param {Function} iteratee The function invoked per iteration.
           * @returns {number} Returns the sum.
           */


          function baseSum(array, iteratee) {
            var result,
                index = -1,
                length = array.length;

            while (++index < length) {
              var current = iteratee(array[index]);

              if (current !== undefined) {
                result = result === undefined ? current : result + current;
              }
            }

            return result;
          }
          /**
           * The base implementation of `_.times` without support for iteratee shorthands
           * or max array length checks.
           *
           * @private
           * @param {number} n The number of times to invoke `iteratee`.
           * @param {Function} iteratee The function invoked per iteration.
           * @returns {Array} Returns the array of results.
           */


          function baseTimes(n, iteratee) {
            var index = -1,
                result = Array(n);

            while (++index < n) {
              result[index] = iteratee(index);
            }

            return result;
          }
          /**
           * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
           * of key-value pairs for `object` corresponding to the property names of `props`.
           *
           * @private
           * @param {Object} object The object to query.
           * @param {Array} props The property names to get values for.
           * @returns {Object} Returns the key-value pairs.
           */


          function baseToPairs(object, props) {
            return arrayMap(props, function (key) {
              return [key, object[key]];
            });
          }
          /**
           * The base implementation of `_.unary` without support for storing metadata.
           *
           * @private
           * @param {Function} func The function to cap arguments for.
           * @returns {Function} Returns the new capped function.
           */


          function baseUnary(func) {
            return function (value) {
              return func(value);
            };
          }
          /**
           * The base implementation of `_.values` and `_.valuesIn` which creates an
           * array of `object` property values corresponding to the property names
           * of `props`.
           *
           * @private
           * @param {Object} object The object to query.
           * @param {Array} props The property names to get values for.
           * @returns {Object} Returns the array of property values.
           */


          function baseValues(object, props) {
            return arrayMap(props, function (key) {
              return object[key];
            });
          }
          /**
           * Checks if a `cache` value for `key` exists.
           *
           * @private
           * @param {Object} cache The cache to query.
           * @param {string} key The key of the entry to check.
           * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
           */


          function cacheHas(cache, key) {
            return cache.has(key);
          }
          /**
           * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
           * that is not found in the character symbols.
           *
           * @private
           * @param {Array} strSymbols The string symbols to inspect.
           * @param {Array} chrSymbols The character symbols to find.
           * @returns {number} Returns the index of the first unmatched string symbol.
           */


          function charsStartIndex(strSymbols, chrSymbols) {
            var index = -1,
                length = strSymbols.length;

            while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}

            return index;
          }
          /**
           * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
           * that is not found in the character symbols.
           *
           * @private
           * @param {Array} strSymbols The string symbols to inspect.
           * @param {Array} chrSymbols The character symbols to find.
           * @returns {number} Returns the index of the last unmatched string symbol.
           */


          function charsEndIndex(strSymbols, chrSymbols) {
            var index = strSymbols.length;

            while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}

            return index;
          }
          /**
           * Gets the number of `placeholder` occurrences in `array`.
           *
           * @private
           * @param {Array} array The array to inspect.
           * @param {*} placeholder The placeholder to search for.
           * @returns {number} Returns the placeholder count.
           */


          function countHolders(array, placeholder) {
            var length = array.length,
                result = 0;

            while (length--) {
              if (array[length] === placeholder) {
                ++result;
              }
            }

            return result;
          }
          /**
           * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
           * letters to basic Latin letters.
           *
           * @private
           * @param {string} letter The matched letter to deburr.
           * @returns {string} Returns the deburred letter.
           */


          var deburrLetter = basePropertyOf(deburredLetters);
          /**
           * Used by `_.escape` to convert characters to HTML entities.
           *
           * @private
           * @param {string} chr The matched character to escape.
           * @returns {string} Returns the escaped character.
           */

          var escapeHtmlChar = basePropertyOf(htmlEscapes);
          /**
           * Used by `_.template` to escape characters for inclusion in compiled string literals.
           *
           * @private
           * @param {string} chr The matched character to escape.
           * @returns {string} Returns the escaped character.
           */

          function escapeStringChar(chr) {
            return '\\' + stringEscapes[chr];
          }
          /**
           * Gets the value at `key` of `object`.
           *
           * @private
           * @param {Object} [object] The object to query.
           * @param {string} key The key of the property to get.
           * @returns {*} Returns the property value.
           */


          function getValue(object, key) {
            return object == null ? undefined : object[key];
          }
          /**
           * Checks if `string` contains Unicode symbols.
           *
           * @private
           * @param {string} string The string to inspect.
           * @returns {boolean} Returns `true` if a symbol is found, else `false`.
           */


          function hasUnicode(string) {
            return reHasUnicode.test(string);
          }
          /**
           * Checks if `string` contains a word composed of Unicode symbols.
           *
           * @private
           * @param {string} string The string to inspect.
           * @returns {boolean} Returns `true` if a word is found, else `false`.
           */


          function hasUnicodeWord(string) {
            return reHasUnicodeWord.test(string);
          }
          /**
           * Converts `iterator` to an array.
           *
           * @private
           * @param {Object} iterator The iterator to convert.
           * @returns {Array} Returns the converted array.
           */


          function iteratorToArray(iterator) {
            var data,
                result = [];

            while (!(data = iterator.next()).done) {
              result.push(data.value);
            }

            return result;
          }
          /**
           * Converts `map` to its key-value pairs.
           *
           * @private
           * @param {Object} map The map to convert.
           * @returns {Array} Returns the key-value pairs.
           */


          function mapToArray(map) {
            var index = -1,
                result = Array(map.size);
            map.forEach(function (value, key) {
              result[++index] = [key, value];
            });
            return result;
          }
          /**
           * Creates a unary function that invokes `func` with its argument transformed.
           *
           * @private
           * @param {Function} func The function to wrap.
           * @param {Function} transform The argument transform.
           * @returns {Function} Returns the new function.
           */


          function overArg(func, transform) {
            return function (arg) {
              return func(transform(arg));
            };
          }
          /**
           * Replaces all `placeholder` elements in `array` with an internal placeholder
           * and returns an array of their indexes.
           *
           * @private
           * @param {Array} array The array to modify.
           * @param {*} placeholder The placeholder to replace.
           * @returns {Array} Returns the new array of placeholder indexes.
           */


          function replaceHolders(array, placeholder) {
            var index = -1,
                length = array.length,
                resIndex = 0,
                result = [];

            while (++index < length) {
              var value = array[index];

              if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
              }
            }

            return result;
          }
          /**
           * Converts `set` to an array of its values.
           *
           * @private
           * @param {Object} set The set to convert.
           * @returns {Array} Returns the values.
           */


          function setToArray(set) {
            var index = -1,
                result = Array(set.size);
            set.forEach(function (value) {
              result[++index] = value;
            });
            return result;
          }
          /**
           * Converts `set` to its value-value pairs.
           *
           * @private
           * @param {Object} set The set to convert.
           * @returns {Array} Returns the value-value pairs.
           */


          function setToPairs(set) {
            var index = -1,
                result = Array(set.size);
            set.forEach(function (value) {
              result[++index] = [value, value];
            });
            return result;
          }
          /**
           * A specialized version of `_.indexOf` which performs strict equality
           * comparisons of values, i.e. `===`.
           *
           * @private
           * @param {Array} array The array to inspect.
           * @param {*} value The value to search for.
           * @param {number} fromIndex The index to search from.
           * @returns {number} Returns the index of the matched value, else `-1`.
           */


          function strictIndexOf(array, value, fromIndex) {
            var index = fromIndex - 1,
                length = array.length;

            while (++index < length) {
              if (array[index] === value) {
                return index;
              }
            }

            return -1;
          }
          /**
           * A specialized version of `_.lastIndexOf` which performs strict equality
           * comparisons of values, i.e. `===`.
           *
           * @private
           * @param {Array} array The array to inspect.
           * @param {*} value The value to search for.
           * @param {number} fromIndex The index to search from.
           * @returns {number} Returns the index of the matched value, else `-1`.
           */


          function strictLastIndexOf(array, value, fromIndex) {
            var index = fromIndex + 1;

            while (index--) {
              if (array[index] === value) {
                return index;
              }
            }

            return index;
          }
          /**
           * Gets the number of symbols in `string`.
           *
           * @private
           * @param {string} string The string to inspect.
           * @returns {number} Returns the string size.
           */


          function stringSize(string) {
            return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
          }
          /**
           * Converts `string` to an array.
           *
           * @private
           * @param {string} string The string to convert.
           * @returns {Array} Returns the converted array.
           */


          function stringToArray(string) {
            return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
          }
          /**
           * Used by `_.unescape` to convert HTML entities to characters.
           *
           * @private
           * @param {string} chr The matched character to unescape.
           * @returns {string} Returns the unescaped character.
           */


          var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
          /**
           * Gets the size of a Unicode `string`.
           *
           * @private
           * @param {string} string The string inspect.
           * @returns {number} Returns the string size.
           */

          function unicodeSize(string) {
            var result = reUnicode.lastIndex = 0;

            while (reUnicode.test(string)) {
              ++result;
            }

            return result;
          }
          /**
           * Converts a Unicode `string` to an array.
           *
           * @private
           * @param {string} string The string to convert.
           * @returns {Array} Returns the converted array.
           */


          function unicodeToArray(string) {
            return string.match(reUnicode) || [];
          }
          /**
           * Splits a Unicode `string` into an array of its words.
           *
           * @private
           * @param {string} The string to inspect.
           * @returns {Array} Returns the words of `string`.
           */


          function unicodeWords(string) {
            return string.match(reUnicodeWord) || [];
          }
          /*--------------------------------------------------------------------------*/

          /**
           * Create a new pristine `lodash` function using the `context` object.
           *
           * @static
           * @memberOf _
           * @since 1.1.0
           * @category Util
           * @param {Object} [context=root] The context object.
           * @returns {Function} Returns a new `lodash` function.
           * @example
           *
           * _.mixin({ 'foo': _.constant('foo') });
           *
           * var lodash = _.runInContext();
           * lodash.mixin({ 'bar': lodash.constant('bar') });
           *
           * _.isFunction(_.foo);
           * // => true
           * _.isFunction(_.bar);
           * // => false
           *
           * lodash.isFunction(lodash.foo);
           * // => false
           * lodash.isFunction(lodash.bar);
           * // => true
           *
           * // Create a suped-up `defer` in Node.js.
           * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
           */


          var runInContext = function runInContext(context) {
            context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
            /** Built-in constructor references. */

            var Array = context.Array,
                Date = context.Date,
                Error = context.Error,
                Function = context.Function,
                Math = context.Math,
                Object = context.Object,
                RegExp = context.RegExp,
                String = context.String,
                TypeError = context.TypeError;
            /** Used for built-in method references. */

            var arrayProto = Array.prototype,
                funcProto = Function.prototype,
                objectProto = Object.prototype;
            /** Used to detect overreaching core-js shims. */

            var coreJsData = context['__core-js_shared__'];
            /** Used to resolve the decompiled source of functions. */

            var funcToString = funcProto.toString;
            /** Used to check objects for own properties. */

            var hasOwnProperty = objectProto.hasOwnProperty;
            /** Used to generate unique IDs. */

            var idCounter = 0;
            /** Used to detect methods masquerading as native. */

            var maskSrcKey = function () {
              var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
              return uid ? 'Symbol(src)_1.' + uid : '';
            }();
            /**
             * Used to resolve the
             * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
             * of values.
             */


            var nativeObjectToString = objectProto.toString;
            /** Used to infer the `Object` constructor. */

            var objectCtorString = funcToString.call(Object);
            /** Used to restore the original `_` reference in `_.noConflict`. */

            var oldDash = root._;
            /** Used to detect if a method is native. */

            var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
            /** Built-in value references. */

            var Buffer = moduleExports ? context.Buffer : undefined,
                Symbol = context.Symbol,
                Uint8Array = context.Uint8Array,
                allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
                getPrototype = overArg(Object.getPrototypeOf, Object),
                objectCreate = Object.create,
                propertyIsEnumerable = objectProto.propertyIsEnumerable,
                splice = arrayProto.splice,
                spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
                symIterator = Symbol ? Symbol.iterator : undefined,
                symToStringTag = Symbol ? Symbol.toStringTag : undefined;

            var defineProperty = function () {
              try {
                var func = getNative(Object, 'defineProperty');
                func({}, '', {});
                return func;
              } catch (e) {}
            }();
            /** Mocked built-ins. */


            var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
                ctxNow = Date && Date.now !== root.Date.now && Date.now,
                ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
            /* Built-in method references for those with the same name as other `lodash` methods. */

            var nativeCeil = Math.ceil,
                nativeFloor = Math.floor,
                nativeGetSymbols = Object.getOwnPropertySymbols,
                nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
                nativeIsFinite = context.isFinite,
                nativeJoin = arrayProto.join,
                nativeKeys = overArg(Object.keys, Object),
                nativeMax = Math.max,
                nativeMin = Math.min,
                nativeNow = Date.now,
                nativeParseInt = context.parseInt,
                nativeRandom = Math.random,
                nativeReverse = arrayProto.reverse;
            /* Built-in method references that are verified to be native. */

            var DataView = getNative(context, 'DataView'),
                Map = getNative(context, 'Map'),
                Promise = getNative(context, 'Promise'),
                Set = getNative(context, 'Set'),
                WeakMap = getNative(context, 'WeakMap'),
                nativeCreate = getNative(Object, 'create');
            /** Used to store function metadata. */

            var metaMap = WeakMap && new WeakMap();
            /** Used to lookup unminified function names. */

            var realNames = {};
            /** Used to detect maps, sets, and weakmaps. */

            var dataViewCtorString = toSource(DataView),
                mapCtorString = toSource(Map),
                promiseCtorString = toSource(Promise),
                setCtorString = toSource(Set),
                weakMapCtorString = toSource(WeakMap);
            /** Used to convert symbols to primitives and strings. */

            var symbolProto = Symbol ? Symbol.prototype : undefined,
                symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
                symbolToString = symbolProto ? symbolProto.toString : undefined;
            /*------------------------------------------------------------------------*/

            /**
             * Creates a `lodash` object which wraps `value` to enable implicit method
             * chain sequences. Methods that operate on and return arrays, collections,
             * and functions can be chained together. Methods that retrieve a single value
             * or may return a primitive value will automatically end the chain sequence
             * and return the unwrapped value. Otherwise, the value must be unwrapped
             * with `_#value`.
             *
             * Explicit chain sequences, which must be unwrapped with `_#value`, may be
             * enabled using `_.chain`.
             *
             * The execution of chained methods is lazy, that is, it's deferred until
             * `_#value` is implicitly or explicitly called.
             *
             * Lazy evaluation allows several methods to support shortcut fusion.
             * Shortcut fusion is an optimization to merge iteratee calls; this avoids
             * the creation of intermediate arrays and can greatly reduce the number of
             * iteratee executions. Sections of a chain sequence qualify for shortcut
             * fusion if the section is applied to an array and iteratees accept only
             * one argument. The heuristic for whether a section qualifies for shortcut
             * fusion is subject to change.
             *
             * Chaining is supported in custom builds as long as the `_#value` method is
             * directly or indirectly included in the build.
             *
             * In addition to lodash methods, wrappers have `Array` and `String` methods.
             *
             * The wrapper `Array` methods are:
             * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
             *
             * The wrapper `String` methods are:
             * `replace` and `split`
             *
             * The wrapper methods that support shortcut fusion are:
             * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
             * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
             * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
             *
             * The chainable wrapper methods are:
             * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
             * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
             * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
             * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
             * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
             * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
             * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
             * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
             * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
             * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
             * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
             * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
             * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
             * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
             * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
             * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
             * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
             * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
             * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
             * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
             * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
             * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
             * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
             * `zipObject`, `zipObjectDeep`, and `zipWith`
             *
             * The wrapper methods that are **not** chainable by default are:
             * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
             * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
             * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
             * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
             * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
             * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
             * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
             * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
             * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
             * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
             * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
             * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
             * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
             * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
             * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
             * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
             * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
             * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
             * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
             * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
             * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
             * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
             * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
             * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
             * `upperFirst`, `value`, and `words`
             *
             * @name _
             * @constructor
             * @category Seq
             * @param {*} value The value to wrap in a `lodash` instance.
             * @returns {Object} Returns the new `lodash` wrapper instance.
             * @example
             *
             * function square(n) {
             *   return n * n;
             * }
             *
             * var wrapped = _([1, 2, 3]);
             *
             * // Returns an unwrapped value.
             * wrapped.reduce(_.add);
             * // => 6
             *
             * // Returns a wrapped value.
             * var squares = wrapped.map(square);
             *
             * _.isArray(squares);
             * // => false
             *
             * _.isArray(squares.value());
             * // => true
             */

            function lodash(value) {
              if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) {
                  return value;
                }

                if (hasOwnProperty.call(value, '__wrapped__')) {
                  return wrapperClone(value);
                }
              }

              return new LodashWrapper(value);
            }
            /**
             * The base implementation of `_.create` without support for assigning
             * properties to the created object.
             *
             * @private
             * @param {Object} proto The object to inherit from.
             * @returns {Object} Returns the new object.
             */


            var baseCreate = function () {
              function object() {}

              return function (proto) {
                if (!isObject(proto)) {
                  return {};
                }

                if (objectCreate) {
                  return objectCreate(proto);
                }

                object.prototype = proto;
                var result = new object();
                object.prototype = undefined;
                return result;
              };
            }();
            /**
             * The function whose prototype chain sequence wrappers inherit from.
             *
             * @private
             */


            function baseLodash() {} // No operation performed.

            /**
             * The base constructor for creating `lodash` wrapper objects.
             *
             * @private
             * @param {*} value The value to wrap.
             * @param {boolean} [chainAll] Enable explicit method chain sequences.
             */


            function LodashWrapper(value, chainAll) {
              this.__wrapped__ = value;
              this.__actions__ = [];
              this.__chain__ = !!chainAll;
              this.__index__ = 0;
              this.__values__ = undefined;
            }
            /**
             * By default, the template delimiters used by lodash are like those in
             * embedded Ruby (ERB) as well as ES2015 template strings. Change the
             * following template settings to use alternative delimiters.
             *
             * @static
             * @memberOf _
             * @type {Object}
             */


            lodash.templateSettings = {
              /**
               * Used to detect `data` property values to be HTML-escaped.
               *
               * @memberOf _.templateSettings
               * @type {RegExp}
               */
              'escape': reEscape,

              /**
               * Used to detect code to be evaluated.
               *
               * @memberOf _.templateSettings
               * @type {RegExp}
               */
              'evaluate': reEvaluate,

              /**
               * Used to detect `data` property values to inject.
               *
               * @memberOf _.templateSettings
               * @type {RegExp}
               */
              'interpolate': reInterpolate,

              /**
               * Used to reference the data object in the template text.
               *
               * @memberOf _.templateSettings
               * @type {string}
               */
              'variable': '',

              /**
               * Used to import variables into the compiled template.
               *
               * @memberOf _.templateSettings
               * @type {Object}
               */
              'imports': {
                /**
                 * A reference to the `lodash` function.
                 *
                 * @memberOf _.templateSettings.imports
                 * @type {Function}
                 */
                '_': lodash
              }
            }; // Ensure wrappers are instances of `baseLodash`.

            lodash.prototype = baseLodash.prototype;
            lodash.prototype.constructor = lodash;
            LodashWrapper.prototype = baseCreate(baseLodash.prototype);
            LodashWrapper.prototype.constructor = LodashWrapper;
            /*------------------------------------------------------------------------*/

            /**
             * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
             *
             * @private
             * @constructor
             * @param {*} value The value to wrap.
             */

            function LazyWrapper(value) {
              this.__wrapped__ = value;
              this.__actions__ = [];
              this.__dir__ = 1;
              this.__filtered__ = false;
              this.__iteratees__ = [];
              this.__takeCount__ = MAX_ARRAY_LENGTH;
              this.__views__ = [];
            }
            /**
             * Creates a clone of the lazy wrapper object.
             *
             * @private
             * @name clone
             * @memberOf LazyWrapper
             * @returns {Object} Returns the cloned `LazyWrapper` object.
             */


            function lazyClone() {
              var result = new LazyWrapper(this.__wrapped__);
              result.__actions__ = copyArray(this.__actions__);
              result.__dir__ = this.__dir__;
              result.__filtered__ = this.__filtered__;
              result.__iteratees__ = copyArray(this.__iteratees__);
              result.__takeCount__ = this.__takeCount__;
              result.__views__ = copyArray(this.__views__);
              return result;
            }
            /**
             * Reverses the direction of lazy iteration.
             *
             * @private
             * @name reverse
             * @memberOf LazyWrapper
             * @returns {Object} Returns the new reversed `LazyWrapper` object.
             */


            function lazyReverse() {
              if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
              } else {
                result = this.clone();
                result.__dir__ *= -1;
              }

              return result;
            }
            /**
             * Extracts the unwrapped value from its lazy wrapper.
             *
             * @private
             * @name value
             * @memberOf LazyWrapper
             * @returns {*} Returns the unwrapped value.
             */


            function lazyValue() {
              var array = this.__wrapped__.value(),
                  dir = this.__dir__,
                  isArr = isArray(array),
                  isRight = dir < 0,
                  arrLength = isArr ? array.length : 0,
                  view = getView(0, arrLength, this.__views__),
                  start = view.start,
                  end = view.end,
                  length = end - start,
                  index = isRight ? end : start - 1,
                  iteratees = this.__iteratees__,
                  iterLength = iteratees.length,
                  resIndex = 0,
                  takeCount = nativeMin(length, this.__takeCount__);

              if (!isArr || !isRight && arrLength == length && takeCount == length) {
                return baseWrapperValue(array, this.__actions__);
              }

              var result = [];

              outer: while (length-- && resIndex < takeCount) {
                index += dir;
                var iterIndex = -1,
                    value = array[index];

                while (++iterIndex < iterLength) {
                  var data = iteratees[iterIndex],
                      iteratee = data.iteratee,
                      type = data.type,
                      computed = iteratee(value);

                  if (type == LAZY_MAP_FLAG) {
                    value = computed;
                  } else if (!computed) {
                    if (type == LAZY_FILTER_FLAG) {
                      continue outer;
                    } else {
                      break outer;
                    }
                  }
                }

                result[resIndex++] = value;
              }

              return result;
            } // Ensure `LazyWrapper` is an instance of `baseLodash`.


            LazyWrapper.prototype = baseCreate(baseLodash.prototype);
            LazyWrapper.prototype.constructor = LazyWrapper;
            /*------------------------------------------------------------------------*/

            /**
             * Creates a hash object.
             *
             * @private
             * @constructor
             * @param {Array} [entries] The key-value pairs to cache.
             */

            function Hash(entries) {
              var index = -1,
                  length = entries == null ? 0 : entries.length;
              this.clear();

              while (++index < length) {
                var entry = entries[index];
                this.set(entry[0], entry[1]);
              }
            }
            /**
             * Removes all key-value entries from the hash.
             *
             * @private
             * @name clear
             * @memberOf Hash
             */


            function hashClear() {
              this.__data__ = nativeCreate ? nativeCreate(null) : {};
              this.size = 0;
            }
            /**
             * Removes `key` and its value from the hash.
             *
             * @private
             * @name delete
             * @memberOf Hash
             * @param {Object} hash The hash to modify.
             * @param {string} key The key of the value to remove.
             * @returns {boolean} Returns `true` if the entry was removed, else `false`.
             */


            function hashDelete(key) {
              var result = this.has(key) && delete this.__data__[key];
              this.size -= result ? 1 : 0;
              return result;
            }
            /**
             * Gets the hash value for `key`.
             *
             * @private
             * @name get
             * @memberOf Hash
             * @param {string} key The key of the value to get.
             * @returns {*} Returns the entry value.
             */


            function hashGet(key) {
              var data = this.__data__;

              if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
              }

              return hasOwnProperty.call(data, key) ? data[key] : undefined;
            }
            /**
             * Checks if a hash value for `key` exists.
             *
             * @private
             * @name has
             * @memberOf Hash
             * @param {string} key The key of the entry to check.
             * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
             */


            function hashHas(key) {
              var data = this.__data__;
              return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
            }
            /**
             * Sets the hash `key` to `value`.
             *
             * @private
             * @name set
             * @memberOf Hash
             * @param {string} key The key of the value to set.
             * @param {*} value The value to set.
             * @returns {Object} Returns the hash instance.
             */


            function hashSet(key, value) {
              var data = this.__data__;
              this.size += this.has(key) ? 0 : 1;
              data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
              return this;
            } // Add methods to `Hash`.


            Hash.prototype.clear = hashClear;
            Hash.prototype['delete'] = hashDelete;
            Hash.prototype.get = hashGet;
            Hash.prototype.has = hashHas;
            Hash.prototype.set = hashSet;
            /*------------------------------------------------------------------------*/

            /**
             * Creates an list cache object.
             *
             * @private
             * @constructor
             * @param {Array} [entries] The key-value pairs to cache.
             */

            function ListCache(entries) {
              var index = -1,
                  length = entries == null ? 0 : entries.length;
              this.clear();

              while (++index < length) {
                var entry = entries[index];
                this.set(entry[0], entry[1]);
              }
            }
            /**
             * Removes all key-value entries from the list cache.
             *
             * @private
             * @name clear
             * @memberOf ListCache
             */


            function listCacheClear() {
              this.__data__ = [];
              this.size = 0;
            }
            /**
             * Removes `key` and its value from the list cache.
             *
             * @private
             * @name delete
             * @memberOf ListCache
             * @param {string} key The key of the value to remove.
             * @returns {boolean} Returns `true` if the entry was removed, else `false`.
             */


            function listCacheDelete(key) {
              var data = this.__data__,
                  index = assocIndexOf(data, key);

              if (index < 0) {
                return false;
              }

              var lastIndex = data.length - 1;

              if (index == lastIndex) {
                data.pop();
              } else {
                splice.call(data, index, 1);
              }

              --this.size;
              return true;
            }
            /**
             * Gets the list cache value for `key`.
             *
             * @private
             * @name get
             * @memberOf ListCache
             * @param {string} key The key of the value to get.
             * @returns {*} Returns the entry value.
             */


            function listCacheGet(key) {
              var data = this.__data__,
                  index = assocIndexOf(data, key);
              return index < 0 ? undefined : data[index][1];
            }
            /**
             * Checks if a list cache value for `key` exists.
             *
             * @private
             * @name has
             * @memberOf ListCache
             * @param {string} key The key of the entry to check.
             * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
             */


            function listCacheHas(key) {
              return assocIndexOf(this.__data__, key) > -1;
            }
            /**
             * Sets the list cache `key` to `value`.
             *
             * @private
             * @name set
             * @memberOf ListCache
             * @param {string} key The key of the value to set.
             * @param {*} value The value to set.
             * @returns {Object} Returns the list cache instance.
             */


            function listCacheSet(key, value) {
              var data = this.__data__,
                  index = assocIndexOf(data, key);

              if (index < 0) {
                ++this.size;
                data.push([key, value]);
              } else {
                data[index][1] = value;
              }

              return this;
            } // Add methods to `ListCache`.


            ListCache.prototype.clear = listCacheClear;
            ListCache.prototype['delete'] = listCacheDelete;
            ListCache.prototype.get = listCacheGet;
            ListCache.prototype.has = listCacheHas;
            ListCache.prototype.set = listCacheSet;
            /*------------------------------------------------------------------------*/

            /**
             * Creates a map cache object to store key-value pairs.
             *
             * @private
             * @constructor
             * @param {Array} [entries] The key-value pairs to cache.
             */

            function MapCache(entries) {
              var index = -1,
                  length = entries == null ? 0 : entries.length;
              this.clear();

              while (++index < length) {
                var entry = entries[index];
                this.set(entry[0], entry[1]);
              }
            }
            /**
             * Removes all key-value entries from the map.
             *
             * @private
             * @name clear
             * @memberOf MapCache
             */


            function mapCacheClear() {
              this.size = 0;
              this.__data__ = {
                'hash': new Hash(),
                'map': new (Map || ListCache)(),
                'string': new Hash()
              };
            }
            /**
             * Removes `key` and its value from the map.
             *
             * @private
             * @name delete
             * @memberOf MapCache
             * @param {string} key The key of the value to remove.
             * @returns {boolean} Returns `true` if the entry was removed, else `false`.
             */


            function mapCacheDelete(key) {
              var result = getMapData(this, key)['delete'](key);
              this.size -= result ? 1 : 0;
              return result;
            }
            /**
             * Gets the map value for `key`.
             *
             * @private
             * @name get
             * @memberOf MapCache
             * @param {string} key The key of the value to get.
             * @returns {*} Returns the entry value.
             */


            function mapCacheGet(key) {
              return getMapData(this, key).get(key);
            }
            /**
             * Checks if a map value for `key` exists.
             *
             * @private
             * @name has
             * @memberOf MapCache
             * @param {string} key The key of the entry to check.
             * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
             */


            function mapCacheHas(key) {
              return getMapData(this, key).has(key);
            }
            /**
             * Sets the map `key` to `value`.
             *
             * @private
             * @name set
             * @memberOf MapCache
             * @param {string} key The key of the value to set.
             * @param {*} value The value to set.
             * @returns {Object} Returns the map cache instance.
             */


            function mapCacheSet(key, value) {
              var data = getMapData(this, key),
                  size = data.size;
              data.set(key, value);
              this.size += data.size == size ? 0 : 1;
              return this;
            } // Add methods to `MapCache`.


            MapCache.prototype.clear = mapCacheClear;
            MapCache.prototype['delete'] = mapCacheDelete;
            MapCache.prototype.get = mapCacheGet;
            MapCache.prototype.has = mapCacheHas;
            MapCache.prototype.set = mapCacheSet;
            /*------------------------------------------------------------------------*/

            /**
             *
             * Creates an array cache object to store unique values.
             *
             * @private
             * @constructor
             * @param {Array} [values] The values to cache.
             */

            function SetCache(values) {
              var index = -1,
                  length = values == null ? 0 : values.length;
              this.__data__ = new MapCache();

              while (++index < length) {
                this.add(values[index]);
              }
            }
            /**
             * Adds `value` to the array cache.
             *
             * @private
             * @name add
             * @memberOf SetCache
             * @alias push
             * @param {*} value The value to cache.
             * @returns {Object} Returns the cache instance.
             */


            function setCacheAdd(value) {
              this.__data__.set(value, HASH_UNDEFINED);

              return this;
            }
            /**
             * Checks if `value` is in the array cache.
             *
             * @private
             * @name has
             * @memberOf SetCache
             * @param {*} value The value to search for.
             * @returns {number} Returns `true` if `value` is found, else `false`.
             */


            function setCacheHas(value) {
              return this.__data__.has(value);
            } // Add methods to `SetCache`.


            SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
            SetCache.prototype.has = setCacheHas;
            /*------------------------------------------------------------------------*/

            /**
             * Creates a stack cache object to store key-value pairs.
             *
             * @private
             * @constructor
             * @param {Array} [entries] The key-value pairs to cache.
             */

            function Stack(entries) {
              var data = this.__data__ = new ListCache(entries);
              this.size = data.size;
            }
            /**
             * Removes all key-value entries from the stack.
             *
             * @private
             * @name clear
             * @memberOf Stack
             */


            function stackClear() {
              this.__data__ = new ListCache();
              this.size = 0;
            }
            /**
             * Removes `key` and its value from the stack.
             *
             * @private
             * @name delete
             * @memberOf Stack
             * @param {string} key The key of the value to remove.
             * @returns {boolean} Returns `true` if the entry was removed, else `false`.
             */


            function stackDelete(key) {
              var data = this.__data__,
                  result = data['delete'](key);
              this.size = data.size;
              return result;
            }
            /**
             * Gets the stack value for `key`.
             *
             * @private
             * @name get
             * @memberOf Stack
             * @param {string} key The key of the value to get.
             * @returns {*} Returns the entry value.
             */


            function stackGet(key) {
              return this.__data__.get(key);
            }
            /**
             * Checks if a stack value for `key` exists.
             *
             * @private
             * @name has
             * @memberOf Stack
             * @param {string} key The key of the entry to check.
             * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
             */


            function stackHas(key) {
              return this.__data__.has(key);
            }
            /**
             * Sets the stack `key` to `value`.
             *
             * @private
             * @name set
             * @memberOf Stack
             * @param {string} key The key of the value to set.
             * @param {*} value The value to set.
             * @returns {Object} Returns the stack cache instance.
             */


            function stackSet(key, value) {
              var data = this.__data__;

              if (data instanceof ListCache) {
                var pairs = data.__data__;

                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                  pairs.push([key, value]);
                  this.size = ++data.size;
                  return this;
                }

                data = this.__data__ = new MapCache(pairs);
              }

              data.set(key, value);
              this.size = data.size;
              return this;
            } // Add methods to `Stack`.


            Stack.prototype.clear = stackClear;
            Stack.prototype['delete'] = stackDelete;
            Stack.prototype.get = stackGet;
            Stack.prototype.has = stackHas;
            Stack.prototype.set = stackSet;
            /*------------------------------------------------------------------------*/

            /**
             * Creates an array of the enumerable property names of the array-like `value`.
             *
             * @private
             * @param {*} value The value to query.
             * @param {boolean} inherited Specify returning inherited property names.
             * @returns {Array} Returns the array of property names.
             */

            function arrayLikeKeys(value, inherited) {
              var isArr = isArray(value),
                  isArg = !isArr && isArguments(value),
                  isBuff = !isArr && !isArg && isBuffer(value),
                  isType = !isArr && !isArg && !isBuff && isTypedArray(value),
                  skipIndexes = isArr || isArg || isBuff || isType,
                  result = skipIndexes ? baseTimes(value.length, String) : [],
                  length = result.length;

              for (var key in value) {
                if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
                key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
                isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
                isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
                isIndex(key, length)))) {
                  result.push(key);
                }
              }

              return result;
            }
            /**
             * A specialized version of `_.sample` for arrays.
             *
             * @private
             * @param {Array} array The array to sample.
             * @returns {*} Returns the random element.
             */


            function arraySample(array) {
              var length = array.length;
              return length ? array[baseRandom(0, length - 1)] : undefined;
            }
            /**
             * A specialized version of `_.sampleSize` for arrays.
             *
             * @private
             * @param {Array} array The array to sample.
             * @param {number} n The number of elements to sample.
             * @returns {Array} Returns the random elements.
             */


            function arraySampleSize(array, n) {
              return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
            }
            /**
             * A specialized version of `_.shuffle` for arrays.
             *
             * @private
             * @param {Array} array The array to shuffle.
             * @returns {Array} Returns the new shuffled array.
             */


            function arrayShuffle(array) {
              return shuffleSelf(copyArray(array));
            }
            /**
             * This function is like `assignValue` except that it doesn't assign
             * `undefined` values.
             *
             * @private
             * @param {Object} object The object to modify.
             * @param {string} key The key of the property to assign.
             * @param {*} value The value to assign.
             */


            function assignMergeValue(object, key, value) {
              if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
                baseAssignValue(object, key, value);
              }
            }
            /**
             * Assigns `value` to `key` of `object` if the existing value is not equivalent
             * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * for equality comparisons.
             *
             * @private
             * @param {Object} object The object to modify.
             * @param {string} key The key of the property to assign.
             * @param {*} value The value to assign.
             */


            function assignValue(object, key, value) {
              var objValue = object[key];

              if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
                baseAssignValue(object, key, value);
              }
            }
            /**
             * Gets the index at which the `key` is found in `array` of key-value pairs.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {*} key The key to search for.
             * @returns {number} Returns the index of the matched value, else `-1`.
             */


            function assocIndexOf(array, key) {
              var length = array.length;

              while (length--) {
                if (eq(array[length][0], key)) {
                  return length;
                }
              }

              return -1;
            }
            /**
             * Aggregates elements of `collection` on `accumulator` with keys transformed
             * by `iteratee` and values set by `setter`.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} setter The function to set `accumulator` values.
             * @param {Function} iteratee The iteratee to transform keys.
             * @param {Object} accumulator The initial aggregated object.
             * @returns {Function} Returns `accumulator`.
             */


            function baseAggregator(collection, setter, iteratee, accumulator) {
              baseEach(collection, function (value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
              });
              return accumulator;
            }
            /**
             * The base implementation of `_.assign` without support for multiple sources
             * or `customizer` functions.
             *
             * @private
             * @param {Object} object The destination object.
             * @param {Object} source The source object.
             * @returns {Object} Returns `object`.
             */


            function baseAssign(object, source) {
              return object && copyObject(source, keys(source), object);
            }
            /**
             * The base implementation of `_.assignIn` without support for multiple sources
             * or `customizer` functions.
             *
             * @private
             * @param {Object} object The destination object.
             * @param {Object} source The source object.
             * @returns {Object} Returns `object`.
             */


            function baseAssignIn(object, source) {
              return object && copyObject(source, keysIn(source), object);
            }
            /**
             * The base implementation of `assignValue` and `assignMergeValue` without
             * value checks.
             *
             * @private
             * @param {Object} object The object to modify.
             * @param {string} key The key of the property to assign.
             * @param {*} value The value to assign.
             */


            function baseAssignValue(object, key, value) {
              if (key == '__proto__' && defineProperty) {
                defineProperty(object, key, {
                  'configurable': true,
                  'enumerable': true,
                  'value': value,
                  'writable': true
                });
              } else {
                object[key] = value;
              }
            }
            /**
             * The base implementation of `_.at` without support for individual paths.
             *
             * @private
             * @param {Object} object The object to iterate over.
             * @param {string[]} paths The property paths to pick.
             * @returns {Array} Returns the picked elements.
             */


            function baseAt(object, paths) {
              var index = -1,
                  length = paths.length,
                  result = Array(length),
                  skip = object == null;

              while (++index < length) {
                result[index] = skip ? undefined : get(object, paths[index]);
              }

              return result;
            }
            /**
             * The base implementation of `_.clamp` which doesn't coerce arguments.
             *
             * @private
             * @param {number} number The number to clamp.
             * @param {number} [lower] The lower bound.
             * @param {number} upper The upper bound.
             * @returns {number} Returns the clamped number.
             */


            function baseClamp(number, lower, upper) {
              if (number === number) {
                if (upper !== undefined) {
                  number = number <= upper ? number : upper;
                }

                if (lower !== undefined) {
                  number = number >= lower ? number : lower;
                }
              }

              return number;
            }
            /**
             * The base implementation of `_.clone` and `_.cloneDeep` which tracks
             * traversed objects.
             *
             * @private
             * @param {*} value The value to clone.
             * @param {boolean} bitmask The bitmask flags.
             *  1 - Deep clone
             *  2 - Flatten inherited properties
             *  4 - Clone symbols
             * @param {Function} [customizer] The function to customize cloning.
             * @param {string} [key] The key of `value`.
             * @param {Object} [object] The parent object of `value`.
             * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
             * @returns {*} Returns the cloned value.
             */


            function baseClone(value, bitmask, customizer, key, object, stack) {
              var result,
                  isDeep = bitmask & CLONE_DEEP_FLAG,
                  isFlat = bitmask & CLONE_FLAT_FLAG,
                  isFull = bitmask & CLONE_SYMBOLS_FLAG;

              if (customizer) {
                result = object ? customizer(value, key, object, stack) : customizer(value);
              }

              if (result !== undefined) {
                return result;
              }

              if (!isObject(value)) {
                return value;
              }

              var isArr = isArray(value);

              if (isArr) {
                result = initCloneArray(value);

                if (!isDeep) {
                  return copyArray(value, result);
                }
              } else {
                var tag = getTag(value),
                    isFunc = tag == funcTag || tag == genTag;

                if (isBuffer(value)) {
                  return cloneBuffer(value, isDeep);
                }

                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                  result = isFlat || isFunc ? {} : initCloneObject(value);

                  if (!isDeep) {
                    return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                  }
                } else {
                  if (!cloneableTags[tag]) {
                    return object ? value : {};
                  }

                  result = initCloneByTag(value, tag, isDeep);
                }
              } // Check for circular references and return its corresponding clone.


              stack || (stack = new Stack());
              var stacked = stack.get(value);

              if (stacked) {
                return stacked;
              }

              stack.set(value, result);

              if (isSet(value)) {
                value.forEach(function (subValue) {
                  result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
                });
                return result;
              }

              if (isMap(value)) {
                value.forEach(function (subValue, key) {
                  result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                return result;
              }

              var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
              var props = isArr ? undefined : keysFunc(value);
              arrayEach(props || value, function (subValue, key) {
                if (props) {
                  key = subValue;
                  subValue = value[key];
                } // Recursively populate clone (susceptible to call stack limits).


                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
              });
              return result;
            }
            /**
             * The base implementation of `_.conforms` which doesn't clone `source`.
             *
             * @private
             * @param {Object} source The object of property predicates to conform to.
             * @returns {Function} Returns the new spec function.
             */


            function baseConforms(source) {
              var props = keys(source);
              return function (object) {
                return baseConformsTo(object, source, props);
              };
            }
            /**
             * The base implementation of `_.conformsTo` which accepts `props` to check.
             *
             * @private
             * @param {Object} object The object to inspect.
             * @param {Object} source The object of property predicates to conform to.
             * @returns {boolean} Returns `true` if `object` conforms, else `false`.
             */


            function baseConformsTo(object, source, props) {
              var length = props.length;

              if (object == null) {
                return !length;
              }

              object = Object(object);

              while (length--) {
                var key = props[length],
                    predicate = source[key],
                    value = object[key];

                if (value === undefined && !(key in object) || !predicate(value)) {
                  return false;
                }
              }

              return true;
            }
            /**
             * The base implementation of `_.delay` and `_.defer` which accepts `args`
             * to provide to `func`.
             *
             * @private
             * @param {Function} func The function to delay.
             * @param {number} wait The number of milliseconds to delay invocation.
             * @param {Array} args The arguments to provide to `func`.
             * @returns {number|Object} Returns the timer id or timeout object.
             */


            function baseDelay(func, wait, args) {
              if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              return setTimeout(function () {
                func.apply(undefined, args);
              }, wait);
            }
            /**
             * The base implementation of methods like `_.difference` without support
             * for excluding multiple arrays or iteratee shorthands.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {Array} values The values to exclude.
             * @param {Function} [iteratee] The iteratee invoked per element.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns the new array of filtered values.
             */


            function baseDifference(array, values, iteratee, comparator) {
              var index = -1,
                  includes = arrayIncludes,
                  isCommon = true,
                  length = array.length,
                  result = [],
                  valuesLength = values.length;

              if (!length) {
                return result;
              }

              if (iteratee) {
                values = arrayMap(values, baseUnary(iteratee));
              }

              if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
              } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
              }

              outer: while (++index < length) {
                var value = array[index],
                    computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;

                if (isCommon && computed === computed) {
                  var valuesIndex = valuesLength;

                  while (valuesIndex--) {
                    if (values[valuesIndex] === computed) {
                      continue outer;
                    }
                  }

                  result.push(value);
                } else if (!includes(values, computed, comparator)) {
                  result.push(value);
                }
              }

              return result;
            }
            /**
             * The base implementation of `_.forEach` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Array|Object} Returns `collection`.
             */


            var baseEach = createBaseEach(baseForOwn);
            /**
             * The base implementation of `_.forEachRight` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Array|Object} Returns `collection`.
             */

            var baseEachRight = createBaseEach(baseForOwnRight, true);
            /**
             * The base implementation of `_.every` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} predicate The function invoked per iteration.
             * @returns {boolean} Returns `true` if all elements pass the predicate check,
             *  else `false`
             */

            function baseEvery(collection, predicate) {
              var result = true;
              baseEach(collection, function (value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
              });
              return result;
            }
            /**
             * The base implementation of methods like `_.max` and `_.min` which accepts a
             * `comparator` to determine the extremum value.
             *
             * @private
             * @param {Array} array The array to iterate over.
             * @param {Function} iteratee The iteratee invoked per iteration.
             * @param {Function} comparator The comparator used to compare values.
             * @returns {*} Returns the extremum value.
             */


            function baseExtremum(array, iteratee, comparator) {
              var index = -1,
                  length = array.length;

              while (++index < length) {
                var value = array[index],
                    current = iteratee(value);

                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) {
                  var computed = current,
                      result = value;
                }
              }

              return result;
            }
            /**
             * The base implementation of `_.fill` without an iteratee call guard.
             *
             * @private
             * @param {Array} array The array to fill.
             * @param {*} value The value to fill `array` with.
             * @param {number} [start=0] The start position.
             * @param {number} [end=array.length] The end position.
             * @returns {Array} Returns `array`.
             */


            function baseFill(array, value, start, end) {
              var length = array.length;
              start = toInteger(start);

              if (start < 0) {
                start = -start > length ? 0 : length + start;
              }

              end = end === undefined || end > length ? length : toInteger(end);

              if (end < 0) {
                end += length;
              }

              end = start > end ? 0 : toLength(end);

              while (start < end) {
                array[start++] = value;
              }

              return array;
            }
            /**
             * The base implementation of `_.filter` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} predicate The function invoked per iteration.
             * @returns {Array} Returns the new filtered array.
             */


            function baseFilter(collection, predicate) {
              var result = [];
              baseEach(collection, function (value, index, collection) {
                if (predicate(value, index, collection)) {
                  result.push(value);
                }
              });
              return result;
            }
            /**
             * The base implementation of `_.flatten` with support for restricting flattening.
             *
             * @private
             * @param {Array} array The array to flatten.
             * @param {number} depth The maximum recursion depth.
             * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
             * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
             * @param {Array} [result=[]] The initial result value.
             * @returns {Array} Returns the new flattened array.
             */


            function baseFlatten(array, depth, predicate, isStrict, result) {
              var index = -1,
                  length = array.length;
              predicate || (predicate = isFlattenable);
              result || (result = []);

              while (++index < length) {
                var value = array[index];

                if (depth > 0 && predicate(value)) {
                  if (depth > 1) {
                    // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                  } else {
                    arrayPush(result, value);
                  }
                } else if (!isStrict) {
                  result[result.length] = value;
                }
              }

              return result;
            }
            /**
             * The base implementation of `baseForOwn` which iterates over `object`
             * properties returned by `keysFunc` and invokes `iteratee` for each property.
             * Iteratee functions may exit iteration early by explicitly returning `false`.
             *
             * @private
             * @param {Object} object The object to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @param {Function} keysFunc The function to get the keys of `object`.
             * @returns {Object} Returns `object`.
             */


            var baseFor = createBaseFor();
            /**
             * This function is like `baseFor` except that it iterates over properties
             * in the opposite order.
             *
             * @private
             * @param {Object} object The object to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @param {Function} keysFunc The function to get the keys of `object`.
             * @returns {Object} Returns `object`.
             */

            var baseForRight = createBaseFor(true);
            /**
             * The base implementation of `_.forOwn` without support for iteratee shorthands.
             *
             * @private
             * @param {Object} object The object to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Object} Returns `object`.
             */

            function baseForOwn(object, iteratee) {
              return object && baseFor(object, iteratee, keys);
            }
            /**
             * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
             *
             * @private
             * @param {Object} object The object to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Object} Returns `object`.
             */


            function baseForOwnRight(object, iteratee) {
              return object && baseForRight(object, iteratee, keys);
            }
            /**
             * The base implementation of `_.functions` which creates an array of
             * `object` function property names filtered from `props`.
             *
             * @private
             * @param {Object} object The object to inspect.
             * @param {Array} props The property names to filter.
             * @returns {Array} Returns the function names.
             */


            function baseFunctions(object, props) {
              return arrayFilter(props, function (key) {
                return isFunction(object[key]);
              });
            }
            /**
             * The base implementation of `_.get` without support for default values.
             *
             * @private
             * @param {Object} object The object to query.
             * @param {Array|string} path The path of the property to get.
             * @returns {*} Returns the resolved value.
             */


            function baseGet(object, path) {
              path = castPath(path, object);
              var index = 0,
                  length = path.length;

              while (object != null && index < length) {
                object = object[toKey(path[index++])];
              }

              return index && index == length ? object : undefined;
            }
            /**
             * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
             * `keysFunc` and `symbolsFunc` to get the enumerable property names and
             * symbols of `object`.
             *
             * @private
             * @param {Object} object The object to query.
             * @param {Function} keysFunc The function to get the keys of `object`.
             * @param {Function} symbolsFunc The function to get the symbols of `object`.
             * @returns {Array} Returns the array of property names and symbols.
             */


            function baseGetAllKeys(object, keysFunc, symbolsFunc) {
              var result = keysFunc(object);
              return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
            }
            /**
             * The base implementation of `getTag` without fallbacks for buggy environments.
             *
             * @private
             * @param {*} value The value to query.
             * @returns {string} Returns the `toStringTag`.
             */


            function baseGetTag(value) {
              if (value == null) {
                return value === undefined ? undefinedTag : nullTag;
              }

              return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
            }
            /**
             * The base implementation of `_.gt` which doesn't coerce arguments.
             *
             * @private
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if `value` is greater than `other`,
             *  else `false`.
             */


            function baseGt(value, other) {
              return value > other;
            }
            /**
             * The base implementation of `_.has` without support for deep paths.
             *
             * @private
             * @param {Object} [object] The object to query.
             * @param {Array|string} key The key to check.
             * @returns {boolean} Returns `true` if `key` exists, else `false`.
             */


            function baseHas(object, key) {
              return object != null && hasOwnProperty.call(object, key);
            }
            /**
             * The base implementation of `_.hasIn` without support for deep paths.
             *
             * @private
             * @param {Object} [object] The object to query.
             * @param {Array|string} key The key to check.
             * @returns {boolean} Returns `true` if `key` exists, else `false`.
             */


            function baseHasIn(object, key) {
              return object != null && key in Object(object);
            }
            /**
             * The base implementation of `_.inRange` which doesn't coerce arguments.
             *
             * @private
             * @param {number} number The number to check.
             * @param {number} start The start of the range.
             * @param {number} end The end of the range.
             * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
             */


            function baseInRange(number, start, end) {
              return number >= nativeMin(start, end) && number < nativeMax(start, end);
            }
            /**
             * The base implementation of methods like `_.intersection`, without support
             * for iteratee shorthands, that accepts an array of arrays to inspect.
             *
             * @private
             * @param {Array} arrays The arrays to inspect.
             * @param {Function} [iteratee] The iteratee invoked per element.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns the new array of shared values.
             */


            function baseIntersection(arrays, iteratee, comparator) {
              var includes = comparator ? arrayIncludesWith : arrayIncludes,
                  length = arrays[0].length,
                  othLength = arrays.length,
                  othIndex = othLength,
                  caches = Array(othLength),
                  maxLength = Infinity,
                  result = [];

              while (othIndex--) {
                var array = arrays[othIndex];

                if (othIndex && iteratee) {
                  array = arrayMap(array, baseUnary(iteratee));
                }

                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
              }

              array = arrays[0];
              var index = -1,
                  seen = caches[0];

              outer: while (++index < length && result.length < maxLength) {
                var value = array[index],
                    computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;

                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                  othIndex = othLength;

                  while (--othIndex) {
                    var cache = caches[othIndex];

                    if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                      continue outer;
                    }
                  }

                  if (seen) {
                    seen.push(computed);
                  }

                  result.push(value);
                }
              }

              return result;
            }
            /**
             * The base implementation of `_.invert` and `_.invertBy` which inverts
             * `object` with values transformed by `iteratee` and set by `setter`.
             *
             * @private
             * @param {Object} object The object to iterate over.
             * @param {Function} setter The function to set `accumulator` values.
             * @param {Function} iteratee The iteratee to transform values.
             * @param {Object} accumulator The initial inverted object.
             * @returns {Function} Returns `accumulator`.
             */


            function baseInverter(object, setter, iteratee, accumulator) {
              baseForOwn(object, function (value, key, object) {
                setter(accumulator, iteratee(value), key, object);
              });
              return accumulator;
            }
            /**
             * The base implementation of `_.invoke` without support for individual
             * method arguments.
             *
             * @private
             * @param {Object} object The object to query.
             * @param {Array|string} path The path of the method to invoke.
             * @param {Array} args The arguments to invoke the method with.
             * @returns {*} Returns the result of the invoked method.
             */


            function baseInvoke(object, path, args) {
              path = castPath(path, object);
              object = parent(object, path);
              var func = object == null ? object : object[toKey(last(path))];
              return func == null ? undefined : apply(func, object, args);
            }
            /**
             * The base implementation of `_.isArguments`.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an `arguments` object,
             */


            function baseIsArguments(value) {
              return isObjectLike(value) && baseGetTag(value) == argsTag;
            }
            /**
             * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
             */


            function baseIsArrayBuffer(value) {
              return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
            }
            /**
             * The base implementation of `_.isDate` without Node.js optimizations.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
             */


            function baseIsDate(value) {
              return isObjectLike(value) && baseGetTag(value) == dateTag;
            }
            /**
             * The base implementation of `_.isEqual` which supports partial comparisons
             * and tracks traversed objects.
             *
             * @private
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @param {boolean} bitmask The bitmask flags.
             *  1 - Unordered comparison
             *  2 - Partial comparison
             * @param {Function} [customizer] The function to customize comparisons.
             * @param {Object} [stack] Tracks traversed `value` and `other` objects.
             * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
             */


            function baseIsEqual(value, other, bitmask, customizer, stack) {
              if (value === other) {
                return true;
              }

              if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
                return value !== value && other !== other;
              }

              return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
            }
            /**
             * A specialized version of `baseIsEqual` for arrays and objects which performs
             * deep comparisons and tracks traversed objects enabling objects with circular
             * references to be compared.
             *
             * @private
             * @param {Object} object The object to compare.
             * @param {Object} other The other object to compare.
             * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
             * @param {Function} customizer The function to customize comparisons.
             * @param {Function} equalFunc The function to determine equivalents of values.
             * @param {Object} [stack] Tracks traversed `object` and `other` objects.
             * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
             */


            function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
              var objIsArr = isArray(object),
                  othIsArr = isArray(other),
                  objTag = objIsArr ? arrayTag : getTag(object),
                  othTag = othIsArr ? arrayTag : getTag(other);
              objTag = objTag == argsTag ? objectTag : objTag;
              othTag = othTag == argsTag ? objectTag : othTag;
              var objIsObj = objTag == objectTag,
                  othIsObj = othTag == objectTag,
                  isSameTag = objTag == othTag;

              if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) {
                  return false;
                }

                objIsArr = true;
                objIsObj = false;
              }

              if (isSameTag && !objIsObj) {
                stack || (stack = new Stack());
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
              }

              if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
                    othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

                if (objIsWrapped || othIsWrapped) {
                  var objUnwrapped = objIsWrapped ? object.value() : object,
                      othUnwrapped = othIsWrapped ? other.value() : other;
                  stack || (stack = new Stack());
                  return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
              }

              if (!isSameTag) {
                return false;
              }

              stack || (stack = new Stack());
              return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
            }
            /**
             * The base implementation of `_.isMap` without Node.js optimizations.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a map, else `false`.
             */


            function baseIsMap(value) {
              return isObjectLike(value) && getTag(value) == mapTag;
            }
            /**
             * The base implementation of `_.isMatch` without support for iteratee shorthands.
             *
             * @private
             * @param {Object} object The object to inspect.
             * @param {Object} source The object of property values to match.
             * @param {Array} matchData The property names, values, and compare flags to match.
             * @param {Function} [customizer] The function to customize comparisons.
             * @returns {boolean} Returns `true` if `object` is a match, else `false`.
             */


            function baseIsMatch(object, source, matchData, customizer) {
              var index = matchData.length,
                  length = index,
                  noCustomizer = !customizer;

              if (object == null) {
                return !length;
              }

              object = Object(object);

              while (index--) {
                var data = matchData[index];

                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
                  return false;
                }
              }

              while (++index < length) {
                data = matchData[index];
                var key = data[0],
                    objValue = object[key],
                    srcValue = data[1];

                if (noCustomizer && data[2]) {
                  if (objValue === undefined && !(key in object)) {
                    return false;
                  }
                } else {
                  var stack = new Stack();

                  if (customizer) {
                    var result = customizer(objValue, srcValue, key, object, source, stack);
                  }

                  if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
                    return false;
                  }
                }
              }

              return true;
            }
            /**
             * The base implementation of `_.isNative` without bad shim checks.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a native function,
             *  else `false`.
             */


            function baseIsNative(value) {
              if (!isObject(value) || isMasked(value)) {
                return false;
              }

              var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
              return pattern.test(toSource(value));
            }
            /**
             * The base implementation of `_.isRegExp` without Node.js optimizations.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
             */


            function baseIsRegExp(value) {
              return isObjectLike(value) && baseGetTag(value) == regexpTag;
            }
            /**
             * The base implementation of `_.isSet` without Node.js optimizations.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a set, else `false`.
             */


            function baseIsSet(value) {
              return isObjectLike(value) && getTag(value) == setTag;
            }
            /**
             * The base implementation of `_.isTypedArray` without Node.js optimizations.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
             */


            function baseIsTypedArray(value) {
              return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
            }
            /**
             * The base implementation of `_.iteratee`.
             *
             * @private
             * @param {*} [value=_.identity] The value to convert to an iteratee.
             * @returns {Function} Returns the iteratee.
             */


            function baseIteratee(value) {
              // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
              // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
              if (typeof value == 'function') {
                return value;
              }

              if (value == null) {
                return identity;
              }

              if (typeof value == 'object') {
                return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
              }

              return property(value);
            }
            /**
             * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property names.
             */


            function baseKeys(object) {
              if (!isPrototype(object)) {
                return nativeKeys(object);
              }

              var result = [];

              for (var key in Object(object)) {
                if (hasOwnProperty.call(object, key) && key != 'constructor') {
                  result.push(key);
                }
              }

              return result;
            }
            /**
             * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property names.
             */


            function baseKeysIn(object) {
              if (!isObject(object)) {
                return nativeKeysIn(object);
              }

              var isProto = isPrototype(object),
                  result = [];

              for (var key in object) {
                if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
                  result.push(key);
                }
              }

              return result;
            }
            /**
             * The base implementation of `_.lt` which doesn't coerce arguments.
             *
             * @private
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if `value` is less than `other`,
             *  else `false`.
             */


            function baseLt(value, other) {
              return value < other;
            }
            /**
             * The base implementation of `_.map` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} iteratee The function invoked per iteration.
             * @returns {Array} Returns the new mapped array.
             */


            function baseMap(collection, iteratee) {
              var index = -1,
                  result = isArrayLike(collection) ? Array(collection.length) : [];
              baseEach(collection, function (value, key, collection) {
                result[++index] = iteratee(value, key, collection);
              });
              return result;
            }
            /**
             * The base implementation of `_.matches` which doesn't clone `source`.
             *
             * @private
             * @param {Object} source The object of property values to match.
             * @returns {Function} Returns the new spec function.
             */


            function baseMatches(source) {
              var matchData = getMatchData(source);

              if (matchData.length == 1 && matchData[0][2]) {
                return matchesStrictComparable(matchData[0][0], matchData[0][1]);
              }

              return function (object) {
                return object === source || baseIsMatch(object, source, matchData);
              };
            }
            /**
             * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
             *
             * @private
             * @param {string} path The path of the property to get.
             * @param {*} srcValue The value to match.
             * @returns {Function} Returns the new spec function.
             */


            function baseMatchesProperty(path, srcValue) {
              if (isKey(path) && isStrictComparable(srcValue)) {
                return matchesStrictComparable(toKey(path), srcValue);
              }

              return function (object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
              };
            }
            /**
             * The base implementation of `_.merge` without support for multiple sources.
             *
             * @private
             * @param {Object} object The destination object.
             * @param {Object} source The source object.
             * @param {number} srcIndex The index of `source`.
             * @param {Function} [customizer] The function to customize merged values.
             * @param {Object} [stack] Tracks traversed source values and their merged
             *  counterparts.
             */


            function baseMerge(object, source, srcIndex, customizer, stack) {
              if (object === source) {
                return;
              }

              baseFor(source, function (srcValue, key) {
                if (isObject(srcValue)) {
                  stack || (stack = new Stack());
                  baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                } else {
                  var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

                  if (newValue === undefined) {
                    newValue = srcValue;
                  }

                  assignMergeValue(object, key, newValue);
                }
              }, keysIn);
            }
            /**
             * A specialized version of `baseMerge` for arrays and objects which performs
             * deep merges and tracks traversed objects enabling objects with circular
             * references to be merged.
             *
             * @private
             * @param {Object} object The destination object.
             * @param {Object} source The source object.
             * @param {string} key The key of the value to merge.
             * @param {number} srcIndex The index of `source`.
             * @param {Function} mergeFunc The function to merge values.
             * @param {Function} [customizer] The function to customize assigned values.
             * @param {Object} [stack] Tracks traversed source values and their merged
             *  counterparts.
             */


            function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
              var objValue = safeGet(object, key),
                  srcValue = safeGet(source, key),
                  stacked = stack.get(srcValue);

              if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
              }

              var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
              var isCommon = newValue === undefined;

              if (isCommon) {
                var isArr = isArray(srcValue),
                    isBuff = !isArr && isBuffer(srcValue),
                    isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;

                if (isArr || isBuff || isTyped) {
                  if (isArray(objValue)) {
                    newValue = objValue;
                  } else if (isArrayLikeObject(objValue)) {
                    newValue = copyArray(objValue);
                  } else if (isBuff) {
                    isCommon = false;
                    newValue = cloneBuffer(srcValue, true);
                  } else if (isTyped) {
                    isCommon = false;
                    newValue = cloneTypedArray(srcValue, true);
                  } else {
                    newValue = [];
                  }
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                  newValue = objValue;

                  if (isArguments(objValue)) {
                    newValue = toPlainObject(objValue);
                  } else if (!isObject(objValue) || isFunction(objValue)) {
                    newValue = initCloneObject(srcValue);
                  }
                } else {
                  isCommon = false;
                }
              }

              if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
              }

              assignMergeValue(object, key, newValue);
            }
            /**
             * The base implementation of `_.nth` which doesn't coerce arguments.
             *
             * @private
             * @param {Array} array The array to query.
             * @param {number} n The index of the element to return.
             * @returns {*} Returns the nth element of `array`.
             */


            function baseNth(array, n) {
              var length = array.length;

              if (!length) {
                return;
              }

              n += n < 0 ? length : 0;
              return isIndex(n, length) ? array[n] : undefined;
            }
            /**
             * The base implementation of `_.orderBy` without param guards.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
             * @param {string[]} orders The sort orders of `iteratees`.
             * @returns {Array} Returns the new sorted array.
             */


            function baseOrderBy(collection, iteratees, orders) {
              var index = -1;
              iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
              var result = baseMap(collection, function (value, key, collection) {
                var criteria = arrayMap(iteratees, function (iteratee) {
                  return iteratee(value);
                });
                return {
                  'criteria': criteria,
                  'index': ++index,
                  'value': value
                };
              });
              return baseSortBy(result, function (object, other) {
                return compareMultiple(object, other, orders);
              });
            }
            /**
             * The base implementation of `_.pick` without support for individual
             * property identifiers.
             *
             * @private
             * @param {Object} object The source object.
             * @param {string[]} paths The property paths to pick.
             * @returns {Object} Returns the new object.
             */


            function basePick(object, paths) {
              return basePickBy(object, paths, function (value, path) {
                return hasIn(object, path);
              });
            }
            /**
             * The base implementation of  `_.pickBy` without support for iteratee shorthands.
             *
             * @private
             * @param {Object} object The source object.
             * @param {string[]} paths The property paths to pick.
             * @param {Function} predicate The function invoked per property.
             * @returns {Object} Returns the new object.
             */


            function basePickBy(object, paths, predicate) {
              var index = -1,
                  length = paths.length,
                  result = {};

              while (++index < length) {
                var path = paths[index],
                    value = baseGet(object, path);

                if (predicate(value, path)) {
                  baseSet(result, castPath(path, object), value);
                }
              }

              return result;
            }
            /**
             * A specialized version of `baseProperty` which supports deep paths.
             *
             * @private
             * @param {Array|string} path The path of the property to get.
             * @returns {Function} Returns the new accessor function.
             */


            function basePropertyDeep(path) {
              return function (object) {
                return baseGet(object, path);
              };
            }
            /**
             * The base implementation of `_.pullAllBy` without support for iteratee
             * shorthands.
             *
             * @private
             * @param {Array} array The array to modify.
             * @param {Array} values The values to remove.
             * @param {Function} [iteratee] The iteratee invoked per element.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns `array`.
             */


            function basePullAll(array, values, iteratee, comparator) {
              var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
                  index = -1,
                  length = values.length,
                  seen = array;

              if (array === values) {
                values = copyArray(values);
              }

              if (iteratee) {
                seen = arrayMap(array, baseUnary(iteratee));
              }

              while (++index < length) {
                var fromIndex = 0,
                    value = values[index],
                    computed = iteratee ? iteratee(value) : value;

                while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
                  if (seen !== array) {
                    splice.call(seen, fromIndex, 1);
                  }

                  splice.call(array, fromIndex, 1);
                }
              }

              return array;
            }
            /**
             * The base implementation of `_.pullAt` without support for individual
             * indexes or capturing the removed elements.
             *
             * @private
             * @param {Array} array The array to modify.
             * @param {number[]} indexes The indexes of elements to remove.
             * @returns {Array} Returns `array`.
             */


            function basePullAt(array, indexes) {
              var length = array ? indexes.length : 0,
                  lastIndex = length - 1;

              while (length--) {
                var index = indexes[length];

                if (length == lastIndex || index !== previous) {
                  var previous = index;

                  if (isIndex(index)) {
                    splice.call(array, index, 1);
                  } else {
                    baseUnset(array, index);
                  }
                }
              }

              return array;
            }
            /**
             * The base implementation of `_.random` without support for returning
             * floating-point numbers.
             *
             * @private
             * @param {number} lower The lower bound.
             * @param {number} upper The upper bound.
             * @returns {number} Returns the random number.
             */


            function baseRandom(lower, upper) {
              return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
            }
            /**
             * The base implementation of `_.range` and `_.rangeRight` which doesn't
             * coerce arguments.
             *
             * @private
             * @param {number} start The start of the range.
             * @param {number} end The end of the range.
             * @param {number} step The value to increment or decrement by.
             * @param {boolean} [fromRight] Specify iterating from right to left.
             * @returns {Array} Returns the range of numbers.
             */


            function baseRange(start, end, step, fromRight) {
              var index = -1,
                  length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
                  result = Array(length);

              while (length--) {
                result[fromRight ? length : ++index] = start;
                start += step;
              }

              return result;
            }
            /**
             * The base implementation of `_.repeat` which doesn't coerce arguments.
             *
             * @private
             * @param {string} string The string to repeat.
             * @param {number} n The number of times to repeat the string.
             * @returns {string} Returns the repeated string.
             */


            function baseRepeat(string, n) {
              var result = '';

              if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
                return result;
              } // Leverage the exponentiation by squaring algorithm for a faster repeat.
              // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.


              do {
                if (n % 2) {
                  result += string;
                }

                n = nativeFloor(n / 2);

                if (n) {
                  string += string;
                }
              } while (n);

              return result;
            }
            /**
             * The base implementation of `_.rest` which doesn't validate or coerce arguments.
             *
             * @private
             * @param {Function} func The function to apply a rest parameter to.
             * @param {number} [start=func.length-1] The start position of the rest parameter.
             * @returns {Function} Returns the new function.
             */


            function baseRest(func, start) {
              return setToString(overRest(func, start, identity), func + '');
            }
            /**
             * The base implementation of `_.sample`.
             *
             * @private
             * @param {Array|Object} collection The collection to sample.
             * @returns {*} Returns the random element.
             */


            function baseSample(collection) {
              return arraySample(values(collection));
            }
            /**
             * The base implementation of `_.sampleSize` without param guards.
             *
             * @private
             * @param {Array|Object} collection The collection to sample.
             * @param {number} n The number of elements to sample.
             * @returns {Array} Returns the random elements.
             */


            function baseSampleSize(collection, n) {
              var array = values(collection);
              return shuffleSelf(array, baseClamp(n, 0, array.length));
            }
            /**
             * The base implementation of `_.set`.
             *
             * @private
             * @param {Object} object The object to modify.
             * @param {Array|string} path The path of the property to set.
             * @param {*} value The value to set.
             * @param {Function} [customizer] The function to customize path creation.
             * @returns {Object} Returns `object`.
             */


            function baseSet(object, path, value, customizer) {
              if (!isObject(object)) {
                return object;
              }

              path = castPath(path, object);
              var index = -1,
                  length = path.length,
                  lastIndex = length - 1,
                  nested = object;

              while (nested != null && ++index < length) {
                var key = toKey(path[index]),
                    newValue = value;

                if (index != lastIndex) {
                  var objValue = nested[key];
                  newValue = customizer ? customizer(objValue, key, nested) : undefined;

                  if (newValue === undefined) {
                    newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                  }
                }

                assignValue(nested, key, newValue);
                nested = nested[key];
              }

              return object;
            }
            /**
             * The base implementation of `setData` without support for hot loop shorting.
             *
             * @private
             * @param {Function} func The function to associate metadata with.
             * @param {*} data The metadata.
             * @returns {Function} Returns `func`.
             */


            var baseSetData = !metaMap ? identity : function (func, data) {
              metaMap.set(func, data);
              return func;
            };
            /**
             * The base implementation of `setToString` without support for hot loop shorting.
             *
             * @private
             * @param {Function} func The function to modify.
             * @param {Function} string The `toString` result.
             * @returns {Function} Returns `func`.
             */

            var baseSetToString = !defineProperty ? identity : function (func, string) {
              return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
              });
            };
            /**
             * The base implementation of `_.shuffle`.
             *
             * @private
             * @param {Array|Object} collection The collection to shuffle.
             * @returns {Array} Returns the new shuffled array.
             */

            function baseShuffle(collection) {
              return shuffleSelf(values(collection));
            }
            /**
             * The base implementation of `_.slice` without an iteratee call guard.
             *
             * @private
             * @param {Array} array The array to slice.
             * @param {number} [start=0] The start position.
             * @param {number} [end=array.length] The end position.
             * @returns {Array} Returns the slice of `array`.
             */


            function baseSlice(array, start, end) {
              var index = -1,
                  length = array.length;

              if (start < 0) {
                start = -start > length ? 0 : length + start;
              }

              end = end > length ? length : end;

              if (end < 0) {
                end += length;
              }

              length = start > end ? 0 : end - start >>> 0;
              start >>>= 0;
              var result = Array(length);

              while (++index < length) {
                result[index] = array[index + start];
              }

              return result;
            }
            /**
             * The base implementation of `_.some` without support for iteratee shorthands.
             *
             * @private
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} predicate The function invoked per iteration.
             * @returns {boolean} Returns `true` if any element passes the predicate check,
             *  else `false`.
             */


            function baseSome(collection, predicate) {
              var result;
              baseEach(collection, function (value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
              });
              return !!result;
            }
            /**
             * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
             * performs a binary search of `array` to determine the index at which `value`
             * should be inserted into `array` in order to maintain its sort order.
             *
             * @private
             * @param {Array} array The sorted array to inspect.
             * @param {*} value The value to evaluate.
             * @param {boolean} [retHighest] Specify returning the highest qualified index.
             * @returns {number} Returns the index at which `value` should be inserted
             *  into `array`.
             */


            function baseSortedIndex(array, value, retHighest) {
              var low = 0,
                  high = array == null ? low : array.length;

              if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while (low < high) {
                  var mid = low + high >>> 1,
                      computed = array[mid];

                  if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                    low = mid + 1;
                  } else {
                    high = mid;
                  }
                }

                return high;
              }

              return baseSortedIndexBy(array, value, identity, retHighest);
            }
            /**
             * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
             * which invokes `iteratee` for `value` and each element of `array` to compute
             * their sort ranking. The iteratee is invoked with one argument; (value).
             *
             * @private
             * @param {Array} array The sorted array to inspect.
             * @param {*} value The value to evaluate.
             * @param {Function} iteratee The iteratee invoked per element.
             * @param {boolean} [retHighest] Specify returning the highest qualified index.
             * @returns {number} Returns the index at which `value` should be inserted
             *  into `array`.
             */


            function baseSortedIndexBy(array, value, iteratee, retHighest) {
              value = iteratee(value);
              var low = 0,
                  high = array == null ? 0 : array.length,
                  valIsNaN = value !== value,
                  valIsNull = value === null,
                  valIsSymbol = isSymbol(value),
                  valIsUndefined = value === undefined;

              while (low < high) {
                var mid = nativeFloor((low + high) / 2),
                    computed = iteratee(array[mid]),
                    othIsDefined = computed !== undefined,
                    othIsNull = computed === null,
                    othIsReflexive = computed === computed,
                    othIsSymbol = isSymbol(computed);

                if (valIsNaN) {
                  var setLow = retHighest || othIsReflexive;
                } else if (valIsUndefined) {
                  setLow = othIsReflexive && (retHighest || othIsDefined);
                } else if (valIsNull) {
                  setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                } else if (valIsSymbol) {
                  setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                } else if (othIsNull || othIsSymbol) {
                  setLow = false;
                } else {
                  setLow = retHighest ? computed <= value : computed < value;
                }

                if (setLow) {
                  low = mid + 1;
                } else {
                  high = mid;
                }
              }

              return nativeMin(high, MAX_ARRAY_INDEX);
            }
            /**
             * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
             * support for iteratee shorthands.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {Function} [iteratee] The iteratee invoked per element.
             * @returns {Array} Returns the new duplicate free array.
             */


            function baseSortedUniq(array, iteratee) {
              var index = -1,
                  length = array.length,
                  resIndex = 0,
                  result = [];

              while (++index < length) {
                var value = array[index],
                    computed = iteratee ? iteratee(value) : value;

                if (!index || !eq(computed, seen)) {
                  var seen = computed;
                  result[resIndex++] = value === 0 ? 0 : value;
                }
              }

              return result;
            }
            /**
             * The base implementation of `_.toNumber` which doesn't ensure correct
             * conversions of binary, hexadecimal, or octal string values.
             *
             * @private
             * @param {*} value The value to process.
             * @returns {number} Returns the number.
             */


            function baseToNumber(value) {
              if (typeof value == 'number') {
                return value;
              }

              if (isSymbol(value)) {
                return NAN;
              }

              return +value;
            }
            /**
             * The base implementation of `_.toString` which doesn't convert nullish
             * values to empty strings.
             *
             * @private
             * @param {*} value The value to process.
             * @returns {string} Returns the string.
             */


            function baseToString(value) {
              // Exit early for strings to avoid a performance hit in some environments.
              if (typeof value == 'string') {
                return value;
              }

              if (isArray(value)) {
                // Recursively convert values (susceptible to call stack limits).
                return arrayMap(value, baseToString) + '';
              }

              if (isSymbol(value)) {
                return symbolToString ? symbolToString.call(value) : '';
              }

              var result = value + '';
              return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            /**
             * The base implementation of `_.uniqBy` without support for iteratee shorthands.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {Function} [iteratee] The iteratee invoked per element.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns the new duplicate free array.
             */


            function baseUniq(array, iteratee, comparator) {
              var index = -1,
                  includes = arrayIncludes,
                  length = array.length,
                  isCommon = true,
                  result = [],
                  seen = result;

              if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
              } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);

                if (set) {
                  return setToArray(set);
                }

                isCommon = false;
                includes = cacheHas;
                seen = new SetCache();
              } else {
                seen = iteratee ? [] : result;
              }

              outer: while (++index < length) {
                var value = array[index],
                    computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;

                if (isCommon && computed === computed) {
                  var seenIndex = seen.length;

                  while (seenIndex--) {
                    if (seen[seenIndex] === computed) {
                      continue outer;
                    }
                  }

                  if (iteratee) {
                    seen.push(computed);
                  }

                  result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                  if (seen !== result) {
                    seen.push(computed);
                  }

                  result.push(value);
                }
              }

              return result;
            }
            /**
             * The base implementation of `_.unset`.
             *
             * @private
             * @param {Object} object The object to modify.
             * @param {Array|string} path The property path to unset.
             * @returns {boolean} Returns `true` if the property is deleted, else `false`.
             */


            function baseUnset(object, path) {
              path = castPath(path, object);
              object = parent(object, path);
              return object == null || delete object[toKey(last(path))];
            }
            /**
             * The base implementation of `_.update`.
             *
             * @private
             * @param {Object} object The object to modify.
             * @param {Array|string} path The path of the property to update.
             * @param {Function} updater The function to produce the updated value.
             * @param {Function} [customizer] The function to customize path creation.
             * @returns {Object} Returns `object`.
             */


            function baseUpdate(object, path, updater, customizer) {
              return baseSet(object, path, updater(baseGet(object, path)), customizer);
            }
            /**
             * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
             * without support for iteratee shorthands.
             *
             * @private
             * @param {Array} array The array to query.
             * @param {Function} predicate The function invoked per iteration.
             * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
             * @param {boolean} [fromRight] Specify iterating from right to left.
             * @returns {Array} Returns the slice of `array`.
             */


            function baseWhile(array, predicate, isDrop, fromRight) {
              var length = array.length,
                  index = fromRight ? length : -1;

              while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}

              return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
            }
            /**
             * The base implementation of `wrapperValue` which returns the result of
             * performing a sequence of actions on the unwrapped `value`, where each
             * successive action is supplied the return value of the previous.
             *
             * @private
             * @param {*} value The unwrapped value.
             * @param {Array} actions Actions to perform to resolve the unwrapped value.
             * @returns {*} Returns the resolved value.
             */


            function baseWrapperValue(value, actions) {
              var result = value;

              if (result instanceof LazyWrapper) {
                result = result.value();
              }

              return arrayReduce(actions, function (result, action) {
                return action.func.apply(action.thisArg, arrayPush([result], action.args));
              }, result);
            }
            /**
             * The base implementation of methods like `_.xor`, without support for
             * iteratee shorthands, that accepts an array of arrays to inspect.
             *
             * @private
             * @param {Array} arrays The arrays to inspect.
             * @param {Function} [iteratee] The iteratee invoked per element.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns the new array of values.
             */


            function baseXor(arrays, iteratee, comparator) {
              var length = arrays.length;

              if (length < 2) {
                return length ? baseUniq(arrays[0]) : [];
              }

              var index = -1,
                  result = Array(length);

              while (++index < length) {
                var array = arrays[index],
                    othIndex = -1;

                while (++othIndex < length) {
                  if (othIndex != index) {
                    result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
                  }
                }
              }

              return baseUniq(baseFlatten(result, 1), iteratee, comparator);
            }
            /**
             * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
             *
             * @private
             * @param {Array} props The property identifiers.
             * @param {Array} values The property values.
             * @param {Function} assignFunc The function to assign values.
             * @returns {Object} Returns the new object.
             */


            function baseZipObject(props, values, assignFunc) {
              var index = -1,
                  length = props.length,
                  valsLength = values.length,
                  result = {};

              while (++index < length) {
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
              }

              return result;
            }
            /**
             * Casts `value` to an empty array if it's not an array like object.
             *
             * @private
             * @param {*} value The value to inspect.
             * @returns {Array|Object} Returns the cast array-like object.
             */


            function castArrayLikeObject(value) {
              return isArrayLikeObject(value) ? value : [];
            }
            /**
             * Casts `value` to `identity` if it's not a function.
             *
             * @private
             * @param {*} value The value to inspect.
             * @returns {Function} Returns cast function.
             */


            function castFunction(value) {
              return typeof value == 'function' ? value : identity;
            }
            /**
             * Casts `value` to a path array if it's not one.
             *
             * @private
             * @param {*} value The value to inspect.
             * @param {Object} [object] The object to query keys on.
             * @returns {Array} Returns the cast property path array.
             */


            function castPath(value, object) {
              if (isArray(value)) {
                return value;
              }

              return isKey(value, object) ? [value] : stringToPath(toString(value));
            }
            /**
             * A `baseRest` alias which can be replaced with `identity` by module
             * replacement plugins.
             *
             * @private
             * @type {Function}
             * @param {Function} func The function to apply a rest parameter to.
             * @returns {Function} Returns the new function.
             */


            var castRest = baseRest;
            /**
             * Casts `array` to a slice if it's needed.
             *
             * @private
             * @param {Array} array The array to inspect.
             * @param {number} start The start position.
             * @param {number} [end=array.length] The end position.
             * @returns {Array} Returns the cast slice.
             */

            function castSlice(array, start, end) {
              var length = array.length;
              end = end === undefined ? length : end;
              return !start && end >= length ? array : baseSlice(array, start, end);
            }
            /**
             * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
             *
             * @private
             * @param {number|Object} id The timer id or timeout object of the timer to clear.
             */


            var clearTimeout = ctxClearTimeout || function (id) {
              return root.clearTimeout(id);
            };
            /**
             * Creates a clone of  `buffer`.
             *
             * @private
             * @param {Buffer} buffer The buffer to clone.
             * @param {boolean} [isDeep] Specify a deep clone.
             * @returns {Buffer} Returns the cloned buffer.
             */


            function cloneBuffer(buffer, isDeep) {
              if (isDeep) {
                return buffer.slice();
              }

              var length = buffer.length,
                  result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
              buffer.copy(result);
              return result;
            }
            /**
             * Creates a clone of `arrayBuffer`.
             *
             * @private
             * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
             * @returns {ArrayBuffer} Returns the cloned array buffer.
             */


            function cloneArrayBuffer(arrayBuffer) {
              var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
              new Uint8Array(result).set(new Uint8Array(arrayBuffer));
              return result;
            }
            /**
             * Creates a clone of `dataView`.
             *
             * @private
             * @param {Object} dataView The data view to clone.
             * @param {boolean} [isDeep] Specify a deep clone.
             * @returns {Object} Returns the cloned data view.
             */


            function cloneDataView(dataView, isDeep) {
              var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
              return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
            }
            /**
             * Creates a clone of `regexp`.
             *
             * @private
             * @param {Object} regexp The regexp to clone.
             * @returns {Object} Returns the cloned regexp.
             */


            function cloneRegExp(regexp) {
              var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
              result.lastIndex = regexp.lastIndex;
              return result;
            }
            /**
             * Creates a clone of the `symbol` object.
             *
             * @private
             * @param {Object} symbol The symbol object to clone.
             * @returns {Object} Returns the cloned symbol object.
             */


            function cloneSymbol(symbol) {
              return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
            }
            /**
             * Creates a clone of `typedArray`.
             *
             * @private
             * @param {Object} typedArray The typed array to clone.
             * @param {boolean} [isDeep] Specify a deep clone.
             * @returns {Object} Returns the cloned typed array.
             */


            function cloneTypedArray(typedArray, isDeep) {
              var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
              return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
            }
            /**
             * Compares values to sort them in ascending order.
             *
             * @private
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {number} Returns the sort order indicator for `value`.
             */


            function compareAscending(value, other) {
              if (value !== other) {
                var valIsDefined = value !== undefined,
                    valIsNull = value === null,
                    valIsReflexive = value === value,
                    valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined,
                    othIsNull = other === null,
                    othIsReflexive = other === other,
                    othIsSymbol = isSymbol(other);

                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
                  return 1;
                }

                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
                  return -1;
                }
              }

              return 0;
            }
            /**
             * Used by `_.orderBy` to compare multiple properties of a value to another
             * and stable sort them.
             *
             * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
             * specify an order of "desc" for descending or "asc" for ascending sort order
             * of corresponding values.
             *
             * @private
             * @param {Object} object The object to compare.
             * @param {Object} other The other object to compare.
             * @param {boolean[]|string[]} orders The order to sort by for each property.
             * @returns {number} Returns the sort order indicator for `object`.
             */


            function compareMultiple(object, other, orders) {
              var index = -1,
                  objCriteria = object.criteria,
                  othCriteria = other.criteria,
                  length = objCriteria.length,
                  ordersLength = orders.length;

              while (++index < length) {
                var result = compareAscending(objCriteria[index], othCriteria[index]);

                if (result) {
                  if (index >= ordersLength) {
                    return result;
                  }

                  var order = orders[index];
                  return result * (order == 'desc' ? -1 : 1);
                }
              } // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
              // that causes it, under certain circumstances, to provide the same value for
              // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
              // for more details.
              //
              // This also ensures a stable sort in V8 and other engines.
              // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.


              return object.index - other.index;
            }
            /**
             * Creates an array that is the composition of partially applied arguments,
             * placeholders, and provided arguments into a single array of arguments.
             *
             * @private
             * @param {Array} args The provided arguments.
             * @param {Array} partials The arguments to prepend to those provided.
             * @param {Array} holders The `partials` placeholder indexes.
             * @params {boolean} [isCurried] Specify composing for a curried function.
             * @returns {Array} Returns the new array of composed arguments.
             */


            function composeArgs(args, partials, holders, isCurried) {
              var argsIndex = -1,
                  argsLength = args.length,
                  holdersLength = holders.length,
                  leftIndex = -1,
                  leftLength = partials.length,
                  rangeLength = nativeMax(argsLength - holdersLength, 0),
                  result = Array(leftLength + rangeLength),
                  isUncurried = !isCurried;

              while (++leftIndex < leftLength) {
                result[leftIndex] = partials[leftIndex];
              }

              while (++argsIndex < holdersLength) {
                if (isUncurried || argsIndex < argsLength) {
                  result[holders[argsIndex]] = args[argsIndex];
                }
              }

              while (rangeLength--) {
                result[leftIndex++] = args[argsIndex++];
              }

              return result;
            }
            /**
             * This function is like `composeArgs` except that the arguments composition
             * is tailored for `_.partialRight`.
             *
             * @private
             * @param {Array} args The provided arguments.
             * @param {Array} partials The arguments to append to those provided.
             * @param {Array} holders The `partials` placeholder indexes.
             * @params {boolean} [isCurried] Specify composing for a curried function.
             * @returns {Array} Returns the new array of composed arguments.
             */


            function composeArgsRight(args, partials, holders, isCurried) {
              var argsIndex = -1,
                  argsLength = args.length,
                  holdersIndex = -1,
                  holdersLength = holders.length,
                  rightIndex = -1,
                  rightLength = partials.length,
                  rangeLength = nativeMax(argsLength - holdersLength, 0),
                  result = Array(rangeLength + rightLength),
                  isUncurried = !isCurried;

              while (++argsIndex < rangeLength) {
                result[argsIndex] = args[argsIndex];
              }

              var offset = argsIndex;

              while (++rightIndex < rightLength) {
                result[offset + rightIndex] = partials[rightIndex];
              }

              while (++holdersIndex < holdersLength) {
                if (isUncurried || argsIndex < argsLength) {
                  result[offset + holders[holdersIndex]] = args[argsIndex++];
                }
              }

              return result;
            }
            /**
             * Copies the values of `source` to `array`.
             *
             * @private
             * @param {Array} source The array to copy values from.
             * @param {Array} [array=[]] The array to copy values to.
             * @returns {Array} Returns `array`.
             */


            function copyArray(source, array) {
              var index = -1,
                  length = source.length;
              array || (array = Array(length));

              while (++index < length) {
                array[index] = source[index];
              }

              return array;
            }
            /**
             * Copies properties of `source` to `object`.
             *
             * @private
             * @param {Object} source The object to copy properties from.
             * @param {Array} props The property identifiers to copy.
             * @param {Object} [object={}] The object to copy properties to.
             * @param {Function} [customizer] The function to customize copied values.
             * @returns {Object} Returns `object`.
             */


            function copyObject(source, props, object, customizer) {
              var isNew = !object;
              object || (object = {});
              var index = -1,
                  length = props.length;

              while (++index < length) {
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

                if (newValue === undefined) {
                  newValue = source[key];
                }

                if (isNew) {
                  baseAssignValue(object, key, newValue);
                } else {
                  assignValue(object, key, newValue);
                }
              }

              return object;
            }
            /**
             * Copies own symbols of `source` to `object`.
             *
             * @private
             * @param {Object} source The object to copy symbols from.
             * @param {Object} [object={}] The object to copy symbols to.
             * @returns {Object} Returns `object`.
             */


            function copySymbols(source, object) {
              return copyObject(source, getSymbols(source), object);
            }
            /**
             * Copies own and inherited symbols of `source` to `object`.
             *
             * @private
             * @param {Object} source The object to copy symbols from.
             * @param {Object} [object={}] The object to copy symbols to.
             * @returns {Object} Returns `object`.
             */


            function copySymbolsIn(source, object) {
              return copyObject(source, getSymbolsIn(source), object);
            }
            /**
             * Creates a function like `_.groupBy`.
             *
             * @private
             * @param {Function} setter The function to set accumulator values.
             * @param {Function} [initializer] The accumulator object initializer.
             * @returns {Function} Returns the new aggregator function.
             */


            function createAggregator(setter, initializer) {
              return function (collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator,
                    accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
              };
            }
            /**
             * Creates a function like `_.assign`.
             *
             * @private
             * @param {Function} assigner The function to assign values.
             * @returns {Function} Returns the new assigner function.
             */


            function createAssigner(assigner) {
              return baseRest(function (object, sources) {
                var index = -1,
                    length = sources.length,
                    customizer = length > 1 ? sources[length - 1] : undefined,
                    guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                  customizer = length < 3 ? undefined : customizer;
                  length = 1;
                }

                object = Object(object);

                while (++index < length) {
                  var source = sources[index];

                  if (source) {
                    assigner(object, source, index, customizer);
                  }
                }

                return object;
              });
            }
            /**
             * Creates a `baseEach` or `baseEachRight` function.
             *
             * @private
             * @param {Function} eachFunc The function to iterate over a collection.
             * @param {boolean} [fromRight] Specify iterating from right to left.
             * @returns {Function} Returns the new base function.
             */


            function createBaseEach(eachFunc, fromRight) {
              return function (collection, iteratee) {
                if (collection == null) {
                  return collection;
                }

                if (!isArrayLike(collection)) {
                  return eachFunc(collection, iteratee);
                }

                var length = collection.length,
                    index = fromRight ? length : -1,
                    iterable = Object(collection);

                while (fromRight ? index-- : ++index < length) {
                  if (iteratee(iterable[index], index, iterable) === false) {
                    break;
                  }
                }

                return collection;
              };
            }
            /**
             * Creates a base function for methods like `_.forIn` and `_.forOwn`.
             *
             * @private
             * @param {boolean} [fromRight] Specify iterating from right to left.
             * @returns {Function} Returns the new base function.
             */


            function createBaseFor(fromRight) {
              return function (object, iteratee, keysFunc) {
                var index = -1,
                    iterable = Object(object),
                    props = keysFunc(object),
                    length = props.length;

                while (length--) {
                  var key = props[fromRight ? length : ++index];

                  if (iteratee(iterable[key], key, iterable) === false) {
                    break;
                  }
                }

                return object;
              };
            }
            /**
             * Creates a function that wraps `func` to invoke it with the optional `this`
             * binding of `thisArg`.
             *
             * @private
             * @param {Function} func The function to wrap.
             * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
             * @param {*} [thisArg] The `this` binding of `func`.
             * @returns {Function} Returns the new wrapped function.
             */


            function createBind(func, bitmask, thisArg) {
              var isBind = bitmask & WRAP_BIND_FLAG,
                  Ctor = createCtor(func);

              function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
              }

              return wrapper;
            }
            /**
             * Creates a function like `_.lowerFirst`.
             *
             * @private
             * @param {string} methodName The name of the `String` case method to use.
             * @returns {Function} Returns the new case function.
             */


            function createCaseFirst(methodName) {
              return function (string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
              };
            }
            /**
             * Creates a function like `_.camelCase`.
             *
             * @private
             * @param {Function} callback The function to combine each word.
             * @returns {Function} Returns the new compounder function.
             */


            function createCompounder(callback) {
              return function (string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
              };
            }
            /**
             * Creates a function that produces an instance of `Ctor` regardless of
             * whether it was invoked as part of a `new` expression or by `call` or `apply`.
             *
             * @private
             * @param {Function} Ctor The constructor to wrap.
             * @returns {Function} Returns the new wrapped function.
             */


            function createCtor(Ctor) {
              return function () {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;

                switch (args.length) {
                  case 0:
                    return new Ctor();

                  case 1:
                    return new Ctor(args[0]);

                  case 2:
                    return new Ctor(args[0], args[1]);

                  case 3:
                    return new Ctor(args[0], args[1], args[2]);

                  case 4:
                    return new Ctor(args[0], args[1], args[2], args[3]);

                  case 5:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4]);

                  case 6:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);

                  case 7:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }

                var thisBinding = baseCreate(Ctor.prototype),
                    result = Ctor.apply(thisBinding, args); // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.

                return isObject(result) ? result : thisBinding;
              };
            }
            /**
             * Creates a function that wraps `func` to enable currying.
             *
             * @private
             * @param {Function} func The function to wrap.
             * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
             * @param {number} arity The arity of `func`.
             * @returns {Function} Returns the new wrapped function.
             */


            function createCurry(func, bitmask, arity) {
              var Ctor = createCtor(func);

              function wrapper() {
                var length = arguments.length,
                    args = Array(length),
                    index = length,
                    placeholder = getHolder(wrapper);

                while (index--) {
                  args[index] = arguments[index];
                }

                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;

                if (length < arity) {
                  return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                }

                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
              }

              return wrapper;
            }
            /**
             * Creates a `_.find` or `_.findLast` function.
             *
             * @private
             * @param {Function} findIndexFunc The function to find the collection index.
             * @returns {Function} Returns the new find function.
             */


            function createFind(findIndexFunc) {
              return function (collection, predicate, fromIndex) {
                var iterable = Object(collection);

                if (!isArrayLike(collection)) {
                  var iteratee = getIteratee(predicate, 3);
                  collection = keys(collection);

                  predicate = function predicate(key) {
                    return iteratee(iterable[key], key, iterable);
                  };
                }

                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
              };
            }
            /**
             * Creates a `_.flow` or `_.flowRight` function.
             *
             * @private
             * @param {boolean} [fromRight] Specify iterating from right to left.
             * @returns {Function} Returns the new flow function.
             */


            function createFlow(fromRight) {
              return flatRest(function (funcs) {
                var length = funcs.length,
                    index = length,
                    prereq = LodashWrapper.prototype.thru;

                if (fromRight) {
                  funcs.reverse();
                }

                while (index--) {
                  var func = funcs[index];

                  if (typeof func != 'function') {
                    throw new TypeError(FUNC_ERROR_TEXT);
                  }

                  if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
                    var wrapper = new LodashWrapper([], true);
                  }
                }

                index = wrapper ? index : length;

                while (++index < length) {
                  func = funcs[index];
                  var funcName = getFuncName(func),
                      data = funcName == 'wrapper' ? getData(func) : undefined;

                  if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                    wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                  } else {
                    wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                  }
                }

                return function () {
                  var args = arguments,
                      value = args[0];

                  if (wrapper && args.length == 1 && isArray(value)) {
                    return wrapper.plant(value).value();
                  }

                  var index = 0,
                      result = length ? funcs[index].apply(this, args) : value;

                  while (++index < length) {
                    result = funcs[index].call(this, result);
                  }

                  return result;
                };
              });
            }
            /**
             * Creates a function that wraps `func` to invoke it with optional `this`
             * binding of `thisArg`, partial application, and currying.
             *
             * @private
             * @param {Function|string} func The function or method name to wrap.
             * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
             * @param {*} [thisArg] The `this` binding of `func`.
             * @param {Array} [partials] The arguments to prepend to those provided to
             *  the new function.
             * @param {Array} [holders] The `partials` placeholder indexes.
             * @param {Array} [partialsRight] The arguments to append to those provided
             *  to the new function.
             * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
             * @param {Array} [argPos] The argument positions of the new function.
             * @param {number} [ary] The arity cap of `func`.
             * @param {number} [arity] The arity of `func`.
             * @returns {Function} Returns the new wrapped function.
             */


            function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
              var isAry = bitmask & WRAP_ARY_FLAG,
                  isBind = bitmask & WRAP_BIND_FLAG,
                  isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
                  isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
                  isFlip = bitmask & WRAP_FLIP_FLAG,
                  Ctor = isBindKey ? undefined : createCtor(func);

              function wrapper() {
                var length = arguments.length,
                    args = Array(length),
                    index = length;

                while (index--) {
                  args[index] = arguments[index];
                }

                if (isCurried) {
                  var placeholder = getHolder(wrapper),
                      holdersCount = countHolders(args, placeholder);
                }

                if (partials) {
                  args = composeArgs(args, partials, holders, isCurried);
                }

                if (partialsRight) {
                  args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                }

                length -= holdersCount;

                if (isCurried && length < arity) {
                  var newHolders = replaceHolders(args, placeholder);
                  return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }

                var thisBinding = isBind ? thisArg : this,
                    fn = isBindKey ? thisBinding[func] : func;
                length = args.length;

                if (argPos) {
                  args = reorder(args, argPos);
                } else if (isFlip && length > 1) {
                  args.reverse();
                }

                if (isAry && ary < length) {
                  args.length = ary;
                }

                if (this && this !== root && this instanceof wrapper) {
                  fn = Ctor || createCtor(fn);
                }

                return fn.apply(thisBinding, args);
              }

              return wrapper;
            }
            /**
             * Creates a function like `_.invertBy`.
             *
             * @private
             * @param {Function} setter The function to set accumulator values.
             * @param {Function} toIteratee The function to resolve iteratees.
             * @returns {Function} Returns the new inverter function.
             */


            function createInverter(setter, toIteratee) {
              return function (object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
              };
            }
            /**
             * Creates a function that performs a mathematical operation on two values.
             *
             * @private
             * @param {Function} operator The function to perform the operation.
             * @param {number} [defaultValue] The value used for `undefined` arguments.
             * @returns {Function} Returns the new mathematical operation function.
             */


            function createMathOperation(operator, defaultValue) {
              return function (value, other) {
                var result;

                if (value === undefined && other === undefined) {
                  return defaultValue;
                }

                if (value !== undefined) {
                  result = value;
                }

                if (other !== undefined) {
                  if (result === undefined) {
                    return other;
                  }

                  if (typeof value == 'string' || typeof other == 'string') {
                    value = baseToString(value);
                    other = baseToString(other);
                  } else {
                    value = baseToNumber(value);
                    other = baseToNumber(other);
                  }

                  result = operator(value, other);
                }

                return result;
              };
            }
            /**
             * Creates a function like `_.over`.
             *
             * @private
             * @param {Function} arrayFunc The function to iterate over iteratees.
             * @returns {Function} Returns the new over function.
             */


            function createOver(arrayFunc) {
              return flatRest(function (iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function (args) {
                  var thisArg = this;
                  return arrayFunc(iteratees, function (iteratee) {
                    return apply(iteratee, thisArg, args);
                  });
                });
              });
            }
            /**
             * Creates the padding for `string` based on `length`. The `chars` string
             * is truncated if the number of characters exceeds `length`.
             *
             * @private
             * @param {number} length The padding length.
             * @param {string} [chars=' '] The string used as padding.
             * @returns {string} Returns the padding for `string`.
             */


            function createPadding(length, chars) {
              chars = chars === undefined ? ' ' : baseToString(chars);
              var charsLength = chars.length;

              if (charsLength < 2) {
                return charsLength ? baseRepeat(chars, length) : chars;
              }

              var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
              return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
            }
            /**
             * Creates a function that wraps `func` to invoke it with the `this` binding
             * of `thisArg` and `partials` prepended to the arguments it receives.
             *
             * @private
             * @param {Function} func The function to wrap.
             * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
             * @param {*} thisArg The `this` binding of `func`.
             * @param {Array} partials The arguments to prepend to those provided to
             *  the new function.
             * @returns {Function} Returns the new wrapped function.
             */


            function createPartial(func, bitmask, thisArg, partials) {
              var isBind = bitmask & WRAP_BIND_FLAG,
                  Ctor = createCtor(func);

              function wrapper() {
                var argsIndex = -1,
                    argsLength = arguments.length,
                    leftIndex = -1,
                    leftLength = partials.length,
                    args = Array(leftLength + argsLength),
                    fn = this && this !== root && this instanceof wrapper ? Ctor : func;

                while (++leftIndex < leftLength) {
                  args[leftIndex] = partials[leftIndex];
                }

                while (argsLength--) {
                  args[leftIndex++] = arguments[++argsIndex];
                }

                return apply(fn, isBind ? thisArg : this, args);
              }

              return wrapper;
            }
            /**
             * Creates a `_.range` or `_.rangeRight` function.
             *
             * @private
             * @param {boolean} [fromRight] Specify iterating from right to left.
             * @returns {Function} Returns the new range function.
             */


            function createRange(fromRight) {
              return function (start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
                  end = step = undefined;
                } // Ensure the sign of `-0` is preserved.


                start = toFinite(start);

                if (end === undefined) {
                  end = start;
                  start = 0;
                } else {
                  end = toFinite(end);
                }

                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
              };
            }
            /**
             * Creates a function that performs a relational operation on two values.
             *
             * @private
             * @param {Function} operator The function to perform the operation.
             * @returns {Function} Returns the new relational operation function.
             */


            function createRelationalOperation(operator) {
              return function (value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                  value = toNumber(value);
                  other = toNumber(other);
                }

                return operator(value, other);
              };
            }
            /**
             * Creates a function that wraps `func` to continue currying.
             *
             * @private
             * @param {Function} func The function to wrap.
             * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
             * @param {Function} wrapFunc The function to create the `func` wrapper.
             * @param {*} placeholder The placeholder value.
             * @param {*} [thisArg] The `this` binding of `func`.
             * @param {Array} [partials] The arguments to prepend to those provided to
             *  the new function.
             * @param {Array} [holders] The `partials` placeholder indexes.
             * @param {Array} [argPos] The argument positions of the new function.
             * @param {number} [ary] The arity cap of `func`.
             * @param {number} [arity] The arity of `func`.
             * @returns {Function} Returns the new wrapped function.
             */


            function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
              var isCurry = bitmask & WRAP_CURRY_FLAG,
                  newHolders = isCurry ? holders : undefined,
                  newHoldersRight = isCurry ? undefined : holders,
                  newPartials = isCurry ? partials : undefined,
                  newPartialsRight = isCurry ? undefined : partials;
              bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
              bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

              if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
                bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
              }

              var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
              var result = wrapFunc.apply(undefined, newData);

              if (isLaziable(func)) {
                setData(result, newData);
              }

              result.placeholder = placeholder;
              return setWrapToString(result, func, bitmask);
            }
            /**
             * Creates a function like `_.round`.
             *
             * @private
             * @param {string} methodName The name of the `Math` method to use when rounding.
             * @returns {Function} Returns the new round function.
             */


            function createRound(methodName) {
              var func = Math[methodName];
              return function (number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);

                if (precision) {
                  // Shift with exponential notation to avoid floating-point issues.
                  // See [MDN](https://mdn.io/round#Examples) for more details.
                  var pair = (toString(number) + 'e').split('e'),
                      value = func(pair[0] + 'e' + (+pair[1] + precision));
                  pair = (toString(value) + 'e').split('e');
                  return +(pair[0] + 'e' + (+pair[1] - precision));
                }

                return func(number);
              };
            }
            /**
             * Creates a set object of `values`.
             *
             * @private
             * @param {Array} values The values to add to the set.
             * @returns {Object} Returns the new set.
             */


            var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
              return new Set(values);
            };
            /**
             * Creates a `_.toPairs` or `_.toPairsIn` function.
             *
             * @private
             * @param {Function} keysFunc The function to get the keys of a given object.
             * @returns {Function} Returns the new pairs function.
             */

            function createToPairs(keysFunc) {
              return function (object) {
                var tag = getTag(object);

                if (tag == mapTag) {
                  return mapToArray(object);
                }

                if (tag == setTag) {
                  return setToPairs(object);
                }

                return baseToPairs(object, keysFunc(object));
              };
            }
            /**
             * Creates a function that either curries or invokes `func` with optional
             * `this` binding and partially applied arguments.
             *
             * @private
             * @param {Function|string} func The function or method name to wrap.
             * @param {number} bitmask The bitmask flags.
             *    1 - `_.bind`
             *    2 - `_.bindKey`
             *    4 - `_.curry` or `_.curryRight` of a bound function
             *    8 - `_.curry`
             *   16 - `_.curryRight`
             *   32 - `_.partial`
             *   64 - `_.partialRight`
             *  128 - `_.rearg`
             *  256 - `_.ary`
             *  512 - `_.flip`
             * @param {*} [thisArg] The `this` binding of `func`.
             * @param {Array} [partials] The arguments to be partially applied.
             * @param {Array} [holders] The `partials` placeholder indexes.
             * @param {Array} [argPos] The argument positions of the new function.
             * @param {number} [ary] The arity cap of `func`.
             * @param {number} [arity] The arity of `func`.
             * @returns {Function} Returns the new wrapped function.
             */


            function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
              var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;

              if (!isBindKey && typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              var length = partials ? partials.length : 0;

              if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
              }

              ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
              arity = arity === undefined ? arity : toInteger(arity);
              length -= holders ? holders.length : 0;

              if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials,
                    holdersRight = holders;
                partials = holders = undefined;
              }

              var data = isBindKey ? undefined : getData(func);
              var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

              if (data) {
                mergeData(newData, data);
              }

              func = newData[0];
              bitmask = newData[1];
              thisArg = newData[2];
              partials = newData[3];
              holders = newData[4];
              arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);

              if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
                bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
              }

              if (!bitmask || bitmask == WRAP_BIND_FLAG) {
                var result = createBind(func, bitmask, thisArg);
              } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
                result = createCurry(func, bitmask, arity);
              } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
                result = createPartial(func, bitmask, thisArg, partials);
              } else {
                result = createHybrid.apply(undefined, newData);
              }

              var setter = data ? baseSetData : setData;
              return setWrapToString(setter(result, newData), func, bitmask);
            }
            /**
             * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
             * of source objects to the destination object for all destination properties
             * that resolve to `undefined`.
             *
             * @private
             * @param {*} objValue The destination value.
             * @param {*} srcValue The source value.
             * @param {string} key The key of the property to assign.
             * @param {Object} object The parent object of `objValue`.
             * @returns {*} Returns the value to assign.
             */


            function customDefaultsAssignIn(objValue, srcValue, key, object) {
              if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                return srcValue;
              }

              return objValue;
            }
            /**
             * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
             * objects into destination objects that are passed thru.
             *
             * @private
             * @param {*} objValue The destination value.
             * @param {*} srcValue The source value.
             * @param {string} key The key of the property to merge.
             * @param {Object} object The parent object of `objValue`.
             * @param {Object} source The parent object of `srcValue`.
             * @param {Object} [stack] Tracks traversed source values and their merged
             *  counterparts.
             * @returns {*} Returns the value to assign.
             */


            function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
              if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
              }

              return objValue;
            }
            /**
             * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
             * objects.
             *
             * @private
             * @param {*} value The value to inspect.
             * @param {string} key The key of the property to inspect.
             * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
             */


            function customOmitClone(value) {
              return isPlainObject(value) ? undefined : value;
            }
            /**
             * A specialized version of `baseIsEqualDeep` for arrays with support for
             * partial deep comparisons.
             *
             * @private
             * @param {Array} array The array to compare.
             * @param {Array} other The other array to compare.
             * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
             * @param {Function} customizer The function to customize comparisons.
             * @param {Function} equalFunc The function to determine equivalents of values.
             * @param {Object} stack Tracks traversed `array` and `other` objects.
             * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
             */


            function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                  arrLength = array.length,
                  othLength = other.length;

              if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
                return false;
              } // Assume cyclic values are equal.


              var stacked = stack.get(array);

              if (stacked && stack.get(other)) {
                return stacked == other;
              }

              var index = -1,
                  result = true,
                  seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
              stack.set(array, other);
              stack.set(other, array); // Ignore non-index properties.

              while (++index < arrLength) {
                var arrValue = array[index],
                    othValue = other[index];

                if (customizer) {
                  var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                }

                if (compared !== undefined) {
                  if (compared) {
                    continue;
                  }

                  result = false;
                  break;
                } // Recursively compare arrays (susceptible to call stack limits).


                if (seen) {
                  if (!arraySome(other, function (othValue, othIndex) {
                    if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                      return seen.push(othIndex);
                    }
                  })) {
                    result = false;
                    break;
                  }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  result = false;
                  break;
                }
              }

              stack['delete'](array);
              stack['delete'](other);
              return result;
            }
            /**
             * A specialized version of `baseIsEqualDeep` for comparing objects of
             * the same `toStringTag`.
             *
             * **Note:** This function only supports comparing values with tags of
             * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
             *
             * @private
             * @param {Object} object The object to compare.
             * @param {Object} other The other object to compare.
             * @param {string} tag The `toStringTag` of the objects to compare.
             * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
             * @param {Function} customizer The function to customize comparisons.
             * @param {Function} equalFunc The function to determine equivalents of values.
             * @param {Object} stack Tracks traversed `object` and `other` objects.
             * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
             */


            function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
              switch (tag) {
                case dataViewTag:
                  if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                    return false;
                  }

                  object = object.buffer;
                  other = other.buffer;

                case arrayBufferTag:
                  if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                    return false;
                  }

                  return true;

                case boolTag:
                case dateTag:
                case numberTag:
                  // Coerce booleans to `1` or `0` and dates to milliseconds.
                  // Invalid dates are coerced to `NaN`.
                  return eq(+object, +other);

                case errorTag:
                  return object.name == other.name && object.message == other.message;

                case regexpTag:
                case stringTag:
                  // Coerce regexes to strings and treat strings, primitives and objects,
                  // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                  // for more details.
                  return object == other + '';

                case mapTag:
                  var convert = mapToArray;

                case setTag:
                  var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                  convert || (convert = setToArray);

                  if (object.size != other.size && !isPartial) {
                    return false;
                  } // Assume cyclic values are equal.


                  var stacked = stack.get(object);

                  if (stacked) {
                    return stacked == other;
                  }

                  bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

                  stack.set(object, other);
                  var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                  stack['delete'](object);
                  return result;

                case symbolTag:
                  if (symbolValueOf) {
                    return symbolValueOf.call(object) == symbolValueOf.call(other);
                  }

              }

              return false;
            }
            /**
             * A specialized version of `baseIsEqualDeep` for objects with support for
             * partial deep comparisons.
             *
             * @private
             * @param {Object} object The object to compare.
             * @param {Object} other The other object to compare.
             * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
             * @param {Function} customizer The function to customize comparisons.
             * @param {Function} equalFunc The function to determine equivalents of values.
             * @param {Object} stack Tracks traversed `object` and `other` objects.
             * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
             */


            function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                  objProps = getAllKeys(object),
                  objLength = objProps.length,
                  othProps = getAllKeys(other),
                  othLength = othProps.length;

              if (objLength != othLength && !isPartial) {
                return false;
              }

              var index = objLength;

              while (index--) {
                var key = objProps[index];

                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
                  return false;
                }
              } // Assume cyclic values are equal.


              var stacked = stack.get(object);

              if (stacked && stack.get(other)) {
                return stacked == other;
              }

              var result = true;
              stack.set(object, other);
              stack.set(other, object);
              var skipCtor = isPartial;

              while (++index < objLength) {
                key = objProps[index];
                var objValue = object[key],
                    othValue = other[key];

                if (customizer) {
                  var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                } // Recursively compare objects (susceptible to call stack limits).


                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                  result = false;
                  break;
                }

                skipCtor || (skipCtor = key == 'constructor');
              }

              if (result && !skipCtor) {
                var objCtor = object.constructor,
                    othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
                  result = false;
                }
              }

              stack['delete'](object);
              stack['delete'](other);
              return result;
            }
            /**
             * A specialized version of `baseRest` which flattens the rest array.
             *
             * @private
             * @param {Function} func The function to apply a rest parameter to.
             * @returns {Function} Returns the new function.
             */


            function flatRest(func) {
              return setToString(overRest(func, undefined, flatten), func + '');
            }
            /**
             * Creates an array of own enumerable property names and symbols of `object`.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property names and symbols.
             */


            function getAllKeys(object) {
              return baseGetAllKeys(object, keys, getSymbols);
            }
            /**
             * Creates an array of own and inherited enumerable property names and
             * symbols of `object`.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property names and symbols.
             */


            function getAllKeysIn(object) {
              return baseGetAllKeys(object, keysIn, getSymbolsIn);
            }
            /**
             * Gets metadata for `func`.
             *
             * @private
             * @param {Function} func The function to query.
             * @returns {*} Returns the metadata for `func`.
             */


            var getData = !metaMap ? noop : function (func) {
              return metaMap.get(func);
            };
            /**
             * Gets the name of `func`.
             *
             * @private
             * @param {Function} func The function to query.
             * @returns {string} Returns the function name.
             */

            function getFuncName(func) {
              var result = func.name + '',
                  array = realNames[result],
                  length = hasOwnProperty.call(realNames, result) ? array.length : 0;

              while (length--) {
                var data = array[length],
                    otherFunc = data.func;

                if (otherFunc == null || otherFunc == func) {
                  return data.name;
                }
              }

              return result;
            }
            /**
             * Gets the argument placeholder value for `func`.
             *
             * @private
             * @param {Function} func The function to inspect.
             * @returns {*} Returns the placeholder value.
             */


            function getHolder(func) {
              var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
              return object.placeholder;
            }
            /**
             * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
             * this function returns the custom method, otherwise it returns `baseIteratee`.
             * If arguments are provided, the chosen function is invoked with them and
             * its result is returned.
             *
             * @private
             * @param {*} [value] The value to convert to an iteratee.
             * @param {number} [arity] The arity of the created iteratee.
             * @returns {Function} Returns the chosen function or its result.
             */


            function getIteratee() {
              var result = lodash.iteratee || iteratee;
              result = result === iteratee ? baseIteratee : result;
              return arguments.length ? result(arguments[0], arguments[1]) : result;
            }
            /**
             * Gets the data for `map`.
             *
             * @private
             * @param {Object} map The map to query.
             * @param {string} key The reference key.
             * @returns {*} Returns the map data.
             */


            function getMapData(map, key) {
              var data = map.__data__;
              return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
            }
            /**
             * Gets the property names, values, and compare flags of `object`.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Array} Returns the match data of `object`.
             */


            function getMatchData(object) {
              var result = keys(object),
                  length = result.length;

              while (length--) {
                var key = result[length],
                    value = object[key];
                result[length] = [key, value, isStrictComparable(value)];
              }

              return result;
            }
            /**
             * Gets the native function at `key` of `object`.
             *
             * @private
             * @param {Object} object The object to query.
             * @param {string} key The key of the method to get.
             * @returns {*} Returns the function if it's native, else `undefined`.
             */


            function getNative(object, key) {
              var value = getValue(object, key);
              return baseIsNative(value) ? value : undefined;
            }
            /**
             * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
             *
             * @private
             * @param {*} value The value to query.
             * @returns {string} Returns the raw `toStringTag`.
             */


            function getRawTag(value) {
              var isOwn = hasOwnProperty.call(value, symToStringTag),
                  tag = value[symToStringTag];

              try {
                value[symToStringTag] = undefined;
                var unmasked = true;
              } catch (e) {}

              var result = nativeObjectToString.call(value);

              if (unmasked) {
                if (isOwn) {
                  value[symToStringTag] = tag;
                } else {
                  delete value[symToStringTag];
                }
              }

              return result;
            }
            /**
             * Creates an array of the own enumerable symbols of `object`.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of symbols.
             */


            var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
              if (object == null) {
                return [];
              }

              object = Object(object);
              return arrayFilter(nativeGetSymbols(object), function (symbol) {
                return propertyIsEnumerable.call(object, symbol);
              });
            };
            /**
             * Creates an array of the own and inherited enumerable symbols of `object`.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of symbols.
             */

            var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
              var result = [];

              while (object) {
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
              }

              return result;
            };
            /**
             * Gets the `toStringTag` of `value`.
             *
             * @private
             * @param {*} value The value to query.
             * @returns {string} Returns the `toStringTag`.
             */

            var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

            if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
              getTag = function getTag(value) {
                var result = baseGetTag(value),
                    Ctor = result == objectTag ? value.constructor : undefined,
                    ctorString = Ctor ? toSource(Ctor) : '';

                if (ctorString) {
                  switch (ctorString) {
                    case dataViewCtorString:
                      return dataViewTag;

                    case mapCtorString:
                      return mapTag;

                    case promiseCtorString:
                      return promiseTag;

                    case setCtorString:
                      return setTag;

                    case weakMapCtorString:
                      return weakMapTag;
                  }
                }

                return result;
              };
            }
            /**
             * Gets the view, applying any `transforms` to the `start` and `end` positions.
             *
             * @private
             * @param {number} start The start of the view.
             * @param {number} end The end of the view.
             * @param {Array} transforms The transformations to apply to the view.
             * @returns {Object} Returns an object containing the `start` and `end`
             *  positions of the view.
             */


            function getView(start, end, transforms) {
              var index = -1,
                  length = transforms.length;

              while (++index < length) {
                var data = transforms[index],
                    size = data.size;

                switch (data.type) {
                  case 'drop':
                    start += size;
                    break;

                  case 'dropRight':
                    end -= size;
                    break;

                  case 'take':
                    end = nativeMin(end, start + size);
                    break;

                  case 'takeRight':
                    start = nativeMax(start, end - size);
                    break;
                }
              }

              return {
                'start': start,
                'end': end
              };
            }
            /**
             * Extracts wrapper details from the `source` body comment.
             *
             * @private
             * @param {string} source The source to inspect.
             * @returns {Array} Returns the wrapper details.
             */


            function getWrapDetails(source) {
              var match = source.match(reWrapDetails);
              return match ? match[1].split(reSplitDetails) : [];
            }
            /**
             * Checks if `path` exists on `object`.
             *
             * @private
             * @param {Object} object The object to query.
             * @param {Array|string} path The path to check.
             * @param {Function} hasFunc The function to check properties.
             * @returns {boolean} Returns `true` if `path` exists, else `false`.
             */


            function hasPath(object, path, hasFunc) {
              path = castPath(path, object);
              var index = -1,
                  length = path.length,
                  result = false;

              while (++index < length) {
                var key = toKey(path[index]);

                if (!(result = object != null && hasFunc(object, key))) {
                  break;
                }

                object = object[key];
              }

              if (result || ++index != length) {
                return result;
              }

              length = object == null ? 0 : object.length;
              return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
            }
            /**
             * Initializes an array clone.
             *
             * @private
             * @param {Array} array The array to clone.
             * @returns {Array} Returns the initialized clone.
             */


            function initCloneArray(array) {
              var length = array.length,
                  result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

              if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
              }

              return result;
            }
            /**
             * Initializes an object clone.
             *
             * @private
             * @param {Object} object The object to clone.
             * @returns {Object} Returns the initialized clone.
             */


            function initCloneObject(object) {
              return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
            }
            /**
             * Initializes an object clone based on its `toStringTag`.
             *
             * **Note:** This function only supports cloning values with tags of
             * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
             *
             * @private
             * @param {Object} object The object to clone.
             * @param {string} tag The `toStringTag` of the object to clone.
             * @param {boolean} [isDeep] Specify a deep clone.
             * @returns {Object} Returns the initialized clone.
             */


            function initCloneByTag(object, tag, isDeep) {
              var Ctor = object.constructor;

              switch (tag) {
                case arrayBufferTag:
                  return cloneArrayBuffer(object);

                case boolTag:
                case dateTag:
                  return new Ctor(+object);

                case dataViewTag:
                  return cloneDataView(object, isDeep);

                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                  return cloneTypedArray(object, isDeep);

                case mapTag:
                  return new Ctor();

                case numberTag:
                case stringTag:
                  return new Ctor(object);

                case regexpTag:
                  return cloneRegExp(object);

                case setTag:
                  return new Ctor();

                case symbolTag:
                  return cloneSymbol(object);
              }
            }
            /**
             * Inserts wrapper `details` in a comment at the top of the `source` body.
             *
             * @private
             * @param {string} source The source to modify.
             * @returns {Array} details The details to insert.
             * @returns {string} Returns the modified source.
             */


            function insertWrapDetails(source, details) {
              var length = details.length;

              if (!length) {
                return source;
              }

              var lastIndex = length - 1;
              details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
              details = details.join(length > 2 ? ', ' : ' ');
              return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
            }
            /**
             * Checks if `value` is a flattenable `arguments` object or array.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
             */


            function isFlattenable(value) {
              return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
            }
            /**
             * Checks if `value` is a valid array-like index.
             *
             * @private
             * @param {*} value The value to check.
             * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
             * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
             */


            function isIndex(value, length) {
              var type = typeof value;
              length = length == null ? MAX_SAFE_INTEGER : length;
              return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
            }
            /**
             * Checks if the given arguments are from an iteratee call.
             *
             * @private
             * @param {*} value The potential iteratee value argument.
             * @param {*} index The potential iteratee index or key argument.
             * @param {*} object The potential iteratee object argument.
             * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
             *  else `false`.
             */


            function isIterateeCall(value, index, object) {
              if (!isObject(object)) {
                return false;
              }

              var type = typeof index;

              if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
                return eq(object[index], value);
              }

              return false;
            }
            /**
             * Checks if `value` is a property name and not a property path.
             *
             * @private
             * @param {*} value The value to check.
             * @param {Object} [object] The object to query keys on.
             * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
             */


            function isKey(value, object) {
              if (isArray(value)) {
                return false;
              }

              var type = typeof value;

              if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
                return true;
              }

              return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
            }
            /**
             * Checks if `value` is suitable for use as unique object key.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
             */


            function isKeyable(value) {
              var type = typeof value;
              return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
            }
            /**
             * Checks if `func` has a lazy counterpart.
             *
             * @private
             * @param {Function} func The function to check.
             * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
             *  else `false`.
             */


            function isLaziable(func) {
              var funcName = getFuncName(func),
                  other = lodash[funcName];

              if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
                return false;
              }

              if (func === other) {
                return true;
              }

              var data = getData(other);
              return !!data && func === data[0];
            }
            /**
             * Checks if `func` has its source masked.
             *
             * @private
             * @param {Function} func The function to check.
             * @returns {boolean} Returns `true` if `func` is masked, else `false`.
             */


            function isMasked(func) {
              return !!maskSrcKey && maskSrcKey in func;
            }
            /**
             * Checks if `func` is capable of being masked.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
             */


            var isMaskable = coreJsData ? isFunction : stubFalse;
            /**
             * Checks if `value` is likely a prototype object.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
             */

            function isPrototype(value) {
              var Ctor = value && value.constructor,
                  proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
              return value === proto;
            }
            /**
             * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
             *
             * @private
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` if suitable for strict
             *  equality comparisons, else `false`.
             */


            function isStrictComparable(value) {
              return value === value && !isObject(value);
            }
            /**
             * A specialized version of `matchesProperty` for source values suitable
             * for strict equality comparisons, i.e. `===`.
             *
             * @private
             * @param {string} key The key of the property to get.
             * @param {*} srcValue The value to match.
             * @returns {Function} Returns the new spec function.
             */


            function matchesStrictComparable(key, srcValue) {
              return function (object) {
                if (object == null) {
                  return false;
                }

                return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
              };
            }
            /**
             * A specialized version of `_.memoize` which clears the memoized function's
             * cache when it exceeds `MAX_MEMOIZE_SIZE`.
             *
             * @private
             * @param {Function} func The function to have its output memoized.
             * @returns {Function} Returns the new memoized function.
             */


            function memoizeCapped(func) {
              var result = memoize(func, function (key) {
                if (cache.size === MAX_MEMOIZE_SIZE) {
                  cache.clear();
                }

                return key;
              });
              var cache = result.cache;
              return result;
            }
            /**
             * Merges the function metadata of `source` into `data`.
             *
             * Merging metadata reduces the number of wrappers used to invoke a function.
             * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
             * may be applied regardless of execution order. Methods like `_.ary` and
             * `_.rearg` modify function arguments, making the order in which they are
             * executed important, preventing the merging of metadata. However, we make
             * an exception for a safe combined case where curried functions have `_.ary`
             * and or `_.rearg` applied.
             *
             * @private
             * @param {Array} data The destination metadata.
             * @param {Array} source The source metadata.
             * @returns {Array} Returns `data`.
             */


            function mergeData(data, source) {
              var bitmask = data[1],
                  srcBitmask = source[1],
                  newBitmask = bitmask | srcBitmask,
                  isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
              var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG; // Exit early if metadata can't be merged.

              if (!(isCommon || isCombo)) {
                return data;
              } // Use source `thisArg` if available.


              if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2]; // Set when currying a bound function.

                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
              } // Compose partial arguments.


              var value = source[3];

              if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
              } // Compose partial right arguments.


              value = source[5];

              if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
              } // Use source `argPos` if available.


              value = source[7];

              if (value) {
                data[7] = value;
              } // Use source `ary` if it's smaller.


              if (srcBitmask & WRAP_ARY_FLAG) {
                data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
              } // Use source `arity` if one is not provided.


              if (data[9] == null) {
                data[9] = source[9];
              } // Use source `func` and merge bitmasks.


              data[0] = source[0];
              data[1] = newBitmask;
              return data;
            }
            /**
             * This function is like
             * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
             * except that it includes inherited enumerable properties.
             *
             * @private
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property names.
             */


            function nativeKeysIn(object) {
              var result = [];

              if (object != null) {
                for (var key in Object(object)) {
                  result.push(key);
                }
              }

              return result;
            }
            /**
             * Converts `value` to a string using `Object.prototype.toString`.
             *
             * @private
             * @param {*} value The value to convert.
             * @returns {string} Returns the converted string.
             */


            function objectToString(value) {
              return nativeObjectToString.call(value);
            }
            /**
             * A specialized version of `baseRest` which transforms the rest array.
             *
             * @private
             * @param {Function} func The function to apply a rest parameter to.
             * @param {number} [start=func.length-1] The start position of the rest parameter.
             * @param {Function} transform The rest array transform.
             * @returns {Function} Returns the new function.
             */


            function overRest(func, start, transform) {
              start = nativeMax(start === undefined ? func.length - 1 : start, 0);
              return function () {
                var args = arguments,
                    index = -1,
                    length = nativeMax(args.length - start, 0),
                    array = Array(length);

                while (++index < length) {
                  array[index] = args[start + index];
                }

                index = -1;
                var otherArgs = Array(start + 1);

                while (++index < start) {
                  otherArgs[index] = args[index];
                }

                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
              };
            }
            /**
             * Gets the parent value at `path` of `object`.
             *
             * @private
             * @param {Object} object The object to query.
             * @param {Array} path The path to get the parent value of.
             * @returns {*} Returns the parent value.
             */


            function parent(object, path) {
              return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
            }
            /**
             * Reorder `array` according to the specified indexes where the element at
             * the first index is assigned as the first element, the element at
             * the second index is assigned as the second element, and so on.
             *
             * @private
             * @param {Array} array The array to reorder.
             * @param {Array} indexes The arranged array indexes.
             * @returns {Array} Returns `array`.
             */


            function reorder(array, indexes) {
              var arrLength = array.length,
                  length = nativeMin(indexes.length, arrLength),
                  oldArray = copyArray(array);

              while (length--) {
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
              }

              return array;
            }
            /**
             * Gets the value at `key`, unless `key` is "__proto__".
             *
             * @private
             * @param {Object} object The object to query.
             * @param {string} key The key of the property to get.
             * @returns {*} Returns the property value.
             */


            function safeGet(object, key) {
              if (key == '__proto__') {
                return;
              }

              return object[key];
            }
            /**
             * Sets metadata for `func`.
             *
             * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
             * period of time, it will trip its breaker and transition to an identity
             * function to avoid garbage collection pauses in V8. See
             * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
             * for more details.
             *
             * @private
             * @param {Function} func The function to associate metadata with.
             * @param {*} data The metadata.
             * @returns {Function} Returns `func`.
             */


            var setData = shortOut(baseSetData);
            /**
             * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
             *
             * @private
             * @param {Function} func The function to delay.
             * @param {number} wait The number of milliseconds to delay invocation.
             * @returns {number|Object} Returns the timer id or timeout object.
             */

            var setTimeout = ctxSetTimeout || function (func, wait) {
              return root.setTimeout(func, wait);
            };
            /**
             * Sets the `toString` method of `func` to return `string`.
             *
             * @private
             * @param {Function} func The function to modify.
             * @param {Function} string The `toString` result.
             * @returns {Function} Returns `func`.
             */


            var setToString = shortOut(baseSetToString);
            /**
             * Sets the `toString` method of `wrapper` to mimic the source of `reference`
             * with wrapper details in a comment at the top of the source body.
             *
             * @private
             * @param {Function} wrapper The function to modify.
             * @param {Function} reference The reference function.
             * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
             * @returns {Function} Returns `wrapper`.
             */

            function setWrapToString(wrapper, reference, bitmask) {
              var source = reference + '';
              return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
            }
            /**
             * Creates a function that'll short out and invoke `identity` instead
             * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
             * milliseconds.
             *
             * @private
             * @param {Function} func The function to restrict.
             * @returns {Function} Returns the new shortable function.
             */


            function shortOut(func) {
              var count = 0,
                  lastCalled = 0;
              return function () {
                var stamp = nativeNow(),
                    remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;

                if (remaining > 0) {
                  if (++count >= HOT_COUNT) {
                    return arguments[0];
                  }
                } else {
                  count = 0;
                }

                return func.apply(undefined, arguments);
              };
            }
            /**
             * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
             *
             * @private
             * @param {Array} array The array to shuffle.
             * @param {number} [size=array.length] The size of `array`.
             * @returns {Array} Returns `array`.
             */


            function shuffleSelf(array, size) {
              var index = -1,
                  length = array.length,
                  lastIndex = length - 1;
              size = size === undefined ? length : size;

              while (++index < size) {
                var rand = baseRandom(index, lastIndex),
                    value = array[rand];
                array[rand] = array[index];
                array[index] = value;
              }

              array.length = size;
              return array;
            }
            /**
             * Converts `string` to a property path array.
             *
             * @private
             * @param {string} string The string to convert.
             * @returns {Array} Returns the property path array.
             */


            var stringToPath = memoizeCapped(function (string) {
              var result = [];

              if (string.charCodeAt(0) === 46
              /* . */
              ) {
                  result.push('');
                }

              string.replace(rePropName, function (match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
              });
              return result;
            });
            /**
             * Converts `value` to a string key if it's not a string or symbol.
             *
             * @private
             * @param {*} value The value to inspect.
             * @returns {string|symbol} Returns the key.
             */

            function toKey(value) {
              if (typeof value == 'string' || isSymbol(value)) {
                return value;
              }

              var result = value + '';
              return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            /**
             * Converts `func` to its source code.
             *
             * @private
             * @param {Function} func The function to convert.
             * @returns {string} Returns the source code.
             */


            function toSource(func) {
              if (func != null) {
                try {
                  return funcToString.call(func);
                } catch (e) {}

                try {
                  return func + '';
                } catch (e) {}
              }

              return '';
            }
            /**
             * Updates wrapper `details` based on `bitmask` flags.
             *
             * @private
             * @returns {Array} details The details to modify.
             * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
             * @returns {Array} Returns `details`.
             */


            function updateWrapDetails(details, bitmask) {
              arrayEach(wrapFlags, function (pair) {
                var value = '_.' + pair[0];

                if (bitmask & pair[1] && !arrayIncludes(details, value)) {
                  details.push(value);
                }
              });
              return details.sort();
            }
            /**
             * Creates a clone of `wrapper`.
             *
             * @private
             * @param {Object} wrapper The wrapper to clone.
             * @returns {Object} Returns the cloned wrapper.
             */


            function wrapperClone(wrapper) {
              if (wrapper instanceof LazyWrapper) {
                return wrapper.clone();
              }

              var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
              result.__actions__ = copyArray(wrapper.__actions__);
              result.__index__ = wrapper.__index__;
              result.__values__ = wrapper.__values__;
              return result;
            }
            /*------------------------------------------------------------------------*/

            /**
             * Creates an array of elements split into groups the length of `size`.
             * If `array` can't be split evenly, the final chunk will be the remaining
             * elements.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to process.
             * @param {number} [size=1] The length of each chunk
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Array} Returns the new array of chunks.
             * @example
             *
             * _.chunk(['a', 'b', 'c', 'd'], 2);
             * // => [['a', 'b'], ['c', 'd']]
             *
             * _.chunk(['a', 'b', 'c', 'd'], 3);
             * // => [['a', 'b', 'c'], ['d']]
             */


            function chunk(array, size, guard) {
              if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
                size = 1;
              } else {
                size = nativeMax(toInteger(size), 0);
              }

              var length = array == null ? 0 : array.length;

              if (!length || size < 1) {
                return [];
              }

              var index = 0,
                  resIndex = 0,
                  result = Array(nativeCeil(length / size));

              while (index < length) {
                result[resIndex++] = baseSlice(array, index, index += size);
              }

              return result;
            }
            /**
             * Creates an array with all falsey values removed. The values `false`, `null`,
             * `0`, `""`, `undefined`, and `NaN` are falsey.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to compact.
             * @returns {Array} Returns the new array of filtered values.
             * @example
             *
             * _.compact([0, 1, false, 2, '', 3]);
             * // => [1, 2, 3]
             */


            function compact(array) {
              var index = -1,
                  length = array == null ? 0 : array.length,
                  resIndex = 0,
                  result = [];

              while (++index < length) {
                var value = array[index];

                if (value) {
                  result[resIndex++] = value;
                }
              }

              return result;
            }
            /**
             * Creates a new array concatenating `array` with any additional arrays
             * and/or values.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to concatenate.
             * @param {...*} [values] The values to concatenate.
             * @returns {Array} Returns the new concatenated array.
             * @example
             *
             * var array = [1];
             * var other = _.concat(array, 2, [3], [[4]]);
             *
             * console.log(other);
             * // => [1, 2, 3, [4]]
             *
             * console.log(array);
             * // => [1]
             */


            function concat() {
              var length = arguments.length;

              if (!length) {
                return [];
              }

              var args = Array(length - 1),
                  array = arguments[0],
                  index = length;

              while (index--) {
                args[index - 1] = arguments[index];
              }

              return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
            }
            /**
             * Creates an array of `array` values not included in the other given arrays
             * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * for equality comparisons. The order and references of result values are
             * determined by the first array.
             *
             * **Note:** Unlike `_.pullAll`, this method returns a new array.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {...Array} [values] The values to exclude.
             * @returns {Array} Returns the new array of filtered values.
             * @see _.without, _.xor
             * @example
             *
             * _.difference([2, 1], [2, 3]);
             * // => [1]
             */


            var difference = baseRest(function (array, values) {
              return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
            });
            /**
             * This method is like `_.difference` except that it accepts `iteratee` which
             * is invoked for each element of `array` and `values` to generate the criterion
             * by which they're compared. The order and references of result values are
             * determined by the first array. The iteratee is invoked with one argument:
             * (value).
             *
             * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {...Array} [values] The values to exclude.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {Array} Returns the new array of filtered values.
             * @example
             *
             * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
             * // => [1.2]
             *
             * // The `_.property` iteratee shorthand.
             * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
             * // => [{ 'x': 2 }]
             */

            var differenceBy = baseRest(function (array, values) {
              var iteratee = last(values);

              if (isArrayLikeObject(iteratee)) {
                iteratee = undefined;
              }

              return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
            });
            /**
             * This method is like `_.difference` except that it accepts `comparator`
             * which is invoked to compare elements of `array` to `values`. The order and
             * references of result values are determined by the first array. The comparator
             * is invoked with two arguments: (arrVal, othVal).
             *
             * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {...Array} [values] The values to exclude.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns the new array of filtered values.
             * @example
             *
             * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
             *
             * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
             * // => [{ 'x': 2, 'y': 1 }]
             */

            var differenceWith = baseRest(function (array, values) {
              var comparator = last(values);

              if (isArrayLikeObject(comparator)) {
                comparator = undefined;
              }

              return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
            });
            /**
             * Creates a slice of `array` with `n` elements dropped from the beginning.
             *
             * @static
             * @memberOf _
             * @since 0.5.0
             * @category Array
             * @param {Array} array The array to query.
             * @param {number} [n=1] The number of elements to drop.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Array} Returns the slice of `array`.
             * @example
             *
             * _.drop([1, 2, 3]);
             * // => [2, 3]
             *
             * _.drop([1, 2, 3], 2);
             * // => [3]
             *
             * _.drop([1, 2, 3], 5);
             * // => []
             *
             * _.drop([1, 2, 3], 0);
             * // => [1, 2, 3]
             */

            function drop(array, n, guard) {
              var length = array == null ? 0 : array.length;

              if (!length) {
                return [];
              }

              n = guard || n === undefined ? 1 : toInteger(n);
              return baseSlice(array, n < 0 ? 0 : n, length);
            }
            /**
             * Creates a slice of `array` with `n` elements dropped from the end.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to query.
             * @param {number} [n=1] The number of elements to drop.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Array} Returns the slice of `array`.
             * @example
             *
             * _.dropRight([1, 2, 3]);
             * // => [1, 2]
             *
             * _.dropRight([1, 2, 3], 2);
             * // => [1]
             *
             * _.dropRight([1, 2, 3], 5);
             * // => []
             *
             * _.dropRight([1, 2, 3], 0);
             * // => [1, 2, 3]
             */


            function dropRight(array, n, guard) {
              var length = array == null ? 0 : array.length;

              if (!length) {
                return [];
              }

              n = guard || n === undefined ? 1 : toInteger(n);
              n = length - n;
              return baseSlice(array, 0, n < 0 ? 0 : n);
            }
            /**
             * Creates a slice of `array` excluding elements dropped from the end.
             * Elements are dropped until `predicate` returns falsey. The predicate is
             * invoked with three arguments: (value, index, array).
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to query.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the slice of `array`.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'active': true },
             *   { 'user': 'fred',    'active': false },
             *   { 'user': 'pebbles', 'active': false }
             * ];
             *
             * _.dropRightWhile(users, function(o) { return !o.active; });
             * // => objects for ['barney']
             *
             * // The `_.matches` iteratee shorthand.
             * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
             * // => objects for ['barney', 'fred']
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.dropRightWhile(users, ['active', false]);
             * // => objects for ['barney']
             *
             * // The `_.property` iteratee shorthand.
             * _.dropRightWhile(users, 'active');
             * // => objects for ['barney', 'fred', 'pebbles']
             */


            function dropRightWhile(array, predicate) {
              return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
            }
            /**
             * Creates a slice of `array` excluding elements dropped from the beginning.
             * Elements are dropped until `predicate` returns falsey. The predicate is
             * invoked with three arguments: (value, index, array).
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to query.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the slice of `array`.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'active': false },
             *   { 'user': 'fred',    'active': false },
             *   { 'user': 'pebbles', 'active': true }
             * ];
             *
             * _.dropWhile(users, function(o) { return !o.active; });
             * // => objects for ['pebbles']
             *
             * // The `_.matches` iteratee shorthand.
             * _.dropWhile(users, { 'user': 'barney', 'active': false });
             * // => objects for ['fred', 'pebbles']
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.dropWhile(users, ['active', false]);
             * // => objects for ['pebbles']
             *
             * // The `_.property` iteratee shorthand.
             * _.dropWhile(users, 'active');
             * // => objects for ['barney', 'fred', 'pebbles']
             */


            function dropWhile(array, predicate) {
              return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
            }
            /**
             * Fills elements of `array` with `value` from `start` up to, but not
             * including, `end`.
             *
             * **Note:** This method mutates `array`.
             *
             * @static
             * @memberOf _
             * @since 3.2.0
             * @category Array
             * @param {Array} array The array to fill.
             * @param {*} value The value to fill `array` with.
             * @param {number} [start=0] The start position.
             * @param {number} [end=array.length] The end position.
             * @returns {Array} Returns `array`.
             * @example
             *
             * var array = [1, 2, 3];
             *
             * _.fill(array, 'a');
             * console.log(array);
             * // => ['a', 'a', 'a']
             *
             * _.fill(Array(3), 2);
             * // => [2, 2, 2]
             *
             * _.fill([4, 6, 8, 10], '*', 1, 3);
             * // => [4, '*', '*', 10]
             */


            function fill(array, value, start, end) {
              var length = array == null ? 0 : array.length;

              if (!length) {
                return [];
              }

              if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
              }

              return baseFill(array, value, start, end);
            }
            /**
             * This method is like `_.find` except that it returns the index of the first
             * element `predicate` returns truthy for instead of the element itself.
             *
             * @static
             * @memberOf _
             * @since 1.1.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @param {number} [fromIndex=0] The index to search from.
             * @returns {number} Returns the index of the found element, else `-1`.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'active': false },
             *   { 'user': 'fred',    'active': false },
             *   { 'user': 'pebbles', 'active': true }
             * ];
             *
             * _.findIndex(users, function(o) { return o.user == 'barney'; });
             * // => 0
             *
             * // The `_.matches` iteratee shorthand.
             * _.findIndex(users, { 'user': 'fred', 'active': false });
             * // => 1
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.findIndex(users, ['active', false]);
             * // => 0
             *
             * // The `_.property` iteratee shorthand.
             * _.findIndex(users, 'active');
             * // => 2
             */


            function findIndex(array, predicate, fromIndex) {
              var length = array == null ? 0 : array.length;

              if (!length) {
                return -1;
              }

              var index = fromIndex == null ? 0 : toInteger(fromIndex);

              if (index < 0) {
                index = nativeMax(length + index, 0);
              }

              return baseFindIndex(array, getIteratee(predicate, 3), index);
            }
            /**
             * This method is like `_.findIndex` except that it iterates over elements
             * of `collection` from right to left.
             *
             * @static
             * @memberOf _
             * @since 2.0.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @param {number} [fromIndex=array.length-1] The index to search from.
             * @returns {number} Returns the index of the found element, else `-1`.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'active': true },
             *   { 'user': 'fred',    'active': false },
             *   { 'user': 'pebbles', 'active': false }
             * ];
             *
             * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
             * // => 2
             *
             * // The `_.matches` iteratee shorthand.
             * _.findLastIndex(users, { 'user': 'barney', 'active': true });
             * // => 0
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.findLastIndex(users, ['active', false]);
             * // => 2
             *
             * // The `_.property` iteratee shorthand.
             * _.findLastIndex(users, 'active');
             * // => 0
             */


            function findLastIndex(array, predicate, fromIndex) {
              var length = array == null ? 0 : array.length;

              if (!length) {
                return -1;
              }

              var index = length - 1;

              if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
              }

              return baseFindIndex(array, getIteratee(predicate, 3), index, true);
            }
            /**
             * Flattens `array` a single level deep.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to flatten.
             * @returns {Array} Returns the new flattened array.
             * @example
             *
             * _.flatten([1, [2, [3, [4]], 5]]);
             * // => [1, 2, [3, [4]], 5]
             */


            function flatten(array) {
              var length = array == null ? 0 : array.length;
              return length ? baseFlatten(array, 1) : [];
            }
            /**
             * Recursively flattens `array`.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to flatten.
             * @returns {Array} Returns the new flattened array.
             * @example
             *
             * _.flattenDeep([1, [2, [3, [4]], 5]]);
             * // => [1, 2, 3, 4, 5]
             */


            function flattenDeep(array) {
              var length = array == null ? 0 : array.length;
              return length ? baseFlatten(array, INFINITY) : [];
            }
            /**
             * Recursively flatten `array` up to `depth` times.
             *
             * @static
             * @memberOf _
             * @since 4.4.0
             * @category Array
             * @param {Array} array The array to flatten.
             * @param {number} [depth=1] The maximum recursion depth.
             * @returns {Array} Returns the new flattened array.
             * @example
             *
             * var array = [1, [2, [3, [4]], 5]];
             *
             * _.flattenDepth(array, 1);
             * // => [1, 2, [3, [4]], 5]
             *
             * _.flattenDepth(array, 2);
             * // => [1, 2, 3, [4], 5]
             */


            function flattenDepth(array, depth) {
              var length = array == null ? 0 : array.length;

              if (!length) {
                return [];
              }

              depth = depth === undefined ? 1 : toInteger(depth);
              return baseFlatten(array, depth);
            }
            /**
             * The inverse of `_.toPairs`; this method returns an object composed
             * from key-value `pairs`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} pairs The key-value pairs.
             * @returns {Object} Returns the new object.
             * @example
             *
             * _.fromPairs([['a', 1], ['b', 2]]);
             * // => { 'a': 1, 'b': 2 }
             */


            function fromPairs(pairs) {
              var index = -1,
                  length = pairs == null ? 0 : pairs.length,
                  result = {};

              while (++index < length) {
                var pair = pairs[index];
                result[pair[0]] = pair[1];
              }

              return result;
            }
            /**
             * Gets the first element of `array`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @alias first
             * @category Array
             * @param {Array} array The array to query.
             * @returns {*} Returns the first element of `array`.
             * @example
             *
             * _.head([1, 2, 3]);
             * // => 1
             *
             * _.head([]);
             * // => undefined
             */


            function head(array) {
              return array && array.length ? array[0] : undefined;
            }
            /**
             * Gets the index at which the first occurrence of `value` is found in `array`
             * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * for equality comparisons. If `fromIndex` is negative, it's used as the
             * offset from the end of `array`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {*} value The value to search for.
             * @param {number} [fromIndex=0] The index to search from.
             * @returns {number} Returns the index of the matched value, else `-1`.
             * @example
             *
             * _.indexOf([1, 2, 1, 2], 2);
             * // => 1
             *
             * // Search from the `fromIndex`.
             * _.indexOf([1, 2, 1, 2], 2, 2);
             * // => 3
             */


            function indexOf(array, value, fromIndex) {
              var length = array == null ? 0 : array.length;

              if (!length) {
                return -1;
              }

              var index = fromIndex == null ? 0 : toInteger(fromIndex);

              if (index < 0) {
                index = nativeMax(length + index, 0);
              }

              return baseIndexOf(array, value, index);
            }
            /**
             * Gets all but the last element of `array`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to query.
             * @returns {Array} Returns the slice of `array`.
             * @example
             *
             * _.initial([1, 2, 3]);
             * // => [1, 2]
             */


            function initial(array) {
              var length = array == null ? 0 : array.length;
              return length ? baseSlice(array, 0, -1) : [];
            }
            /**
             * Creates an array of unique values that are included in all given arrays
             * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * for equality comparisons. The order and references of result values are
             * determined by the first array.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {...Array} [arrays] The arrays to inspect.
             * @returns {Array} Returns the new array of intersecting values.
             * @example
             *
             * _.intersection([2, 1], [2, 3]);
             * // => [2]
             */


            var intersection = baseRest(function (arrays) {
              var mapped = arrayMap(arrays, castArrayLikeObject);
              return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
            });
            /**
             * This method is like `_.intersection` except that it accepts `iteratee`
             * which is invoked for each element of each `arrays` to generate the criterion
             * by which they're compared. The order and references of result values are
             * determined by the first array. The iteratee is invoked with one argument:
             * (value).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {...Array} [arrays] The arrays to inspect.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {Array} Returns the new array of intersecting values.
             * @example
             *
             * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
             * // => [2.1]
             *
             * // The `_.property` iteratee shorthand.
             * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
             * // => [{ 'x': 1 }]
             */

            var intersectionBy = baseRest(function (arrays) {
              var iteratee = last(arrays),
                  mapped = arrayMap(arrays, castArrayLikeObject);

              if (iteratee === last(mapped)) {
                iteratee = undefined;
              } else {
                mapped.pop();
              }

              return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
            });
            /**
             * This method is like `_.intersection` except that it accepts `comparator`
             * which is invoked to compare elements of `arrays`. The order and references
             * of result values are determined by the first array. The comparator is
             * invoked with two arguments: (arrVal, othVal).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {...Array} [arrays] The arrays to inspect.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns the new array of intersecting values.
             * @example
             *
             * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
             * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
             *
             * _.intersectionWith(objects, others, _.isEqual);
             * // => [{ 'x': 1, 'y': 2 }]
             */

            var intersectionWith = baseRest(function (arrays) {
              var comparator = last(arrays),
                  mapped = arrayMap(arrays, castArrayLikeObject);
              comparator = typeof comparator == 'function' ? comparator : undefined;

              if (comparator) {
                mapped.pop();
              }

              return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
            });
            /**
             * Converts all elements in `array` into a string separated by `separator`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to convert.
             * @param {string} [separator=','] The element separator.
             * @returns {string} Returns the joined string.
             * @example
             *
             * _.join(['a', 'b', 'c'], '~');
             * // => 'a~b~c'
             */

            function join(array, separator) {
              return array == null ? '' : nativeJoin.call(array, separator);
            }
            /**
             * Gets the last element of `array`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to query.
             * @returns {*} Returns the last element of `array`.
             * @example
             *
             * _.last([1, 2, 3]);
             * // => 3
             */


            function last(array) {
              var length = array == null ? 0 : array.length;
              return length ? array[length - 1] : undefined;
            }
            /**
             * This method is like `_.indexOf` except that it iterates over elements of
             * `array` from right to left.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {*} value The value to search for.
             * @param {number} [fromIndex=array.length-1] The index to search from.
             * @returns {number} Returns the index of the matched value, else `-1`.
             * @example
             *
             * _.lastIndexOf([1, 2, 1, 2], 2);
             * // => 3
             *
             * // Search from the `fromIndex`.
             * _.lastIndexOf([1, 2, 1, 2], 2, 2);
             * // => 1
             */


            function lastIndexOf(array, value, fromIndex) {
              var length = array == null ? 0 : array.length;

              if (!length) {
                return -1;
              }

              var index = length;

              if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
              }

              return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
            }
            /**
             * Gets the element at index `n` of `array`. If `n` is negative, the nth
             * element from the end is returned.
             *
             * @static
             * @memberOf _
             * @since 4.11.0
             * @category Array
             * @param {Array} array The array to query.
             * @param {number} [n=0] The index of the element to return.
             * @returns {*} Returns the nth element of `array`.
             * @example
             *
             * var array = ['a', 'b', 'c', 'd'];
             *
             * _.nth(array, 1);
             * // => 'b'
             *
             * _.nth(array, -2);
             * // => 'c';
             */


            function nth(array, n) {
              return array && array.length ? baseNth(array, toInteger(n)) : undefined;
            }
            /**
             * Removes all given values from `array` using
             * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * for equality comparisons.
             *
             * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
             * to remove elements from an array by predicate.
             *
             * @static
             * @memberOf _
             * @since 2.0.0
             * @category Array
             * @param {Array} array The array to modify.
             * @param {...*} [values] The values to remove.
             * @returns {Array} Returns `array`.
             * @example
             *
             * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
             *
             * _.pull(array, 'a', 'c');
             * console.log(array);
             * // => ['b', 'b']
             */


            var pull = baseRest(pullAll);
            /**
             * This method is like `_.pull` except that it accepts an array of values to remove.
             *
             * **Note:** Unlike `_.difference`, this method mutates `array`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to modify.
             * @param {Array} values The values to remove.
             * @returns {Array} Returns `array`.
             * @example
             *
             * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
             *
             * _.pullAll(array, ['a', 'c']);
             * console.log(array);
             * // => ['b', 'b']
             */

            function pullAll(array, values) {
              return array && array.length && values && values.length ? basePullAll(array, values) : array;
            }
            /**
             * This method is like `_.pullAll` except that it accepts `iteratee` which is
             * invoked for each element of `array` and `values` to generate the criterion
             * by which they're compared. The iteratee is invoked with one argument: (value).
             *
             * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to modify.
             * @param {Array} values The values to remove.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {Array} Returns `array`.
             * @example
             *
             * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
             *
             * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
             * console.log(array);
             * // => [{ 'x': 2 }]
             */


            function pullAllBy(array, values, iteratee) {
              return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
            }
            /**
             * This method is like `_.pullAll` except that it accepts `comparator` which
             * is invoked to compare elements of `array` to `values`. The comparator is
             * invoked with two arguments: (arrVal, othVal).
             *
             * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
             *
             * @static
             * @memberOf _
             * @since 4.6.0
             * @category Array
             * @param {Array} array The array to modify.
             * @param {Array} values The values to remove.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns `array`.
             * @example
             *
             * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
             *
             * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
             * console.log(array);
             * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
             */


            function pullAllWith(array, values, comparator) {
              return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
            }
            /**
             * Removes elements from `array` corresponding to `indexes` and returns an
             * array of removed elements.
             *
             * **Note:** Unlike `_.at`, this method mutates `array`.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to modify.
             * @param {...(number|number[])} [indexes] The indexes of elements to remove.
             * @returns {Array} Returns the new array of removed elements.
             * @example
             *
             * var array = ['a', 'b', 'c', 'd'];
             * var pulled = _.pullAt(array, [1, 3]);
             *
             * console.log(array);
             * // => ['a', 'c']
             *
             * console.log(pulled);
             * // => ['b', 'd']
             */


            var pullAt = flatRest(function (array, indexes) {
              var length = array == null ? 0 : array.length,
                  result = baseAt(array, indexes);
              basePullAt(array, arrayMap(indexes, function (index) {
                return isIndex(index, length) ? +index : index;
              }).sort(compareAscending));
              return result;
            });
            /**
             * Removes all elements from `array` that `predicate` returns truthy for
             * and returns an array of the removed elements. The predicate is invoked
             * with three arguments: (value, index, array).
             *
             * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
             * to pull elements from an array by value.
             *
             * @static
             * @memberOf _
             * @since 2.0.0
             * @category Array
             * @param {Array} array The array to modify.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the new array of removed elements.
             * @example
             *
             * var array = [1, 2, 3, 4];
             * var evens = _.remove(array, function(n) {
             *   return n % 2 == 0;
             * });
             *
             * console.log(array);
             * // => [1, 3]
             *
             * console.log(evens);
             * // => [2, 4]
             */

            function remove(array, predicate) {
              var result = [];

              if (!(array && array.length)) {
                return result;
              }

              var index = -1,
                  indexes = [],
                  length = array.length;
              predicate = getIteratee(predicate, 3);

              while (++index < length) {
                var value = array[index];

                if (predicate(value, index, array)) {
                  result.push(value);
                  indexes.push(index);
                }
              }

              basePullAt(array, indexes);
              return result;
            }
            /**
             * Reverses `array` so that the first element becomes the last, the second
             * element becomes the second to last, and so on.
             *
             * **Note:** This method mutates `array` and is based on
             * [`Array#reverse`](https://mdn.io/Array/reverse).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to modify.
             * @returns {Array} Returns `array`.
             * @example
             *
             * var array = [1, 2, 3];
             *
             * _.reverse(array);
             * // => [3, 2, 1]
             *
             * console.log(array);
             * // => [3, 2, 1]
             */


            function reverse(array) {
              return array == null ? array : nativeReverse.call(array);
            }
            /**
             * Creates a slice of `array` from `start` up to, but not including, `end`.
             *
             * **Note:** This method is used instead of
             * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
             * returned.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to slice.
             * @param {number} [start=0] The start position.
             * @param {number} [end=array.length] The end position.
             * @returns {Array} Returns the slice of `array`.
             */


            function slice(array, start, end) {
              var length = array == null ? 0 : array.length;

              if (!length) {
                return [];
              }

              if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
              } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
              }

              return baseSlice(array, start, end);
            }
            /**
             * Uses a binary search to determine the lowest index at which `value`
             * should be inserted into `array` in order to maintain its sort order.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The sorted array to inspect.
             * @param {*} value The value to evaluate.
             * @returns {number} Returns the index at which `value` should be inserted
             *  into `array`.
             * @example
             *
             * _.sortedIndex([30, 50], 40);
             * // => 1
             */


            function sortedIndex(array, value) {
              return baseSortedIndex(array, value);
            }
            /**
             * This method is like `_.sortedIndex` except that it accepts `iteratee`
             * which is invoked for `value` and each element of `array` to compute their
             * sort ranking. The iteratee is invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The sorted array to inspect.
             * @param {*} value The value to evaluate.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {number} Returns the index at which `value` should be inserted
             *  into `array`.
             * @example
             *
             * var objects = [{ 'x': 4 }, { 'x': 5 }];
             *
             * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
             * // => 0
             *
             * // The `_.property` iteratee shorthand.
             * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
             * // => 0
             */


            function sortedIndexBy(array, value, iteratee) {
              return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
            }
            /**
             * This method is like `_.indexOf` except that it performs a binary
             * search on a sorted `array`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {*} value The value to search for.
             * @returns {number} Returns the index of the matched value, else `-1`.
             * @example
             *
             * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
             * // => 1
             */


            function sortedIndexOf(array, value) {
              var length = array == null ? 0 : array.length;

              if (length) {
                var index = baseSortedIndex(array, value);

                if (index < length && eq(array[index], value)) {
                  return index;
                }
              }

              return -1;
            }
            /**
             * This method is like `_.sortedIndex` except that it returns the highest
             * index at which `value` should be inserted into `array` in order to
             * maintain its sort order.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The sorted array to inspect.
             * @param {*} value The value to evaluate.
             * @returns {number} Returns the index at which `value` should be inserted
             *  into `array`.
             * @example
             *
             * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
             * // => 4
             */


            function sortedLastIndex(array, value) {
              return baseSortedIndex(array, value, true);
            }
            /**
             * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
             * which is invoked for `value` and each element of `array` to compute their
             * sort ranking. The iteratee is invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The sorted array to inspect.
             * @param {*} value The value to evaluate.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {number} Returns the index at which `value` should be inserted
             *  into `array`.
             * @example
             *
             * var objects = [{ 'x': 4 }, { 'x': 5 }];
             *
             * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
             * // => 1
             *
             * // The `_.property` iteratee shorthand.
             * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
             * // => 1
             */


            function sortedLastIndexBy(array, value, iteratee) {
              return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
            }
            /**
             * This method is like `_.lastIndexOf` except that it performs a binary
             * search on a sorted `array`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {*} value The value to search for.
             * @returns {number} Returns the index of the matched value, else `-1`.
             * @example
             *
             * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
             * // => 3
             */


            function sortedLastIndexOf(array, value) {
              var length = array == null ? 0 : array.length;

              if (length) {
                var index = baseSortedIndex(array, value, true) - 1;

                if (eq(array[index], value)) {
                  return index;
                }
              }

              return -1;
            }
            /**
             * This method is like `_.uniq` except that it's designed and optimized
             * for sorted arrays.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @returns {Array} Returns the new duplicate free array.
             * @example
             *
             * _.sortedUniq([1, 1, 2]);
             * // => [1, 2]
             */


            function sortedUniq(array) {
              return array && array.length ? baseSortedUniq(array) : [];
            }
            /**
             * This method is like `_.uniqBy` except that it's designed and optimized
             * for sorted arrays.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {Function} [iteratee] The iteratee invoked per element.
             * @returns {Array} Returns the new duplicate free array.
             * @example
             *
             * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
             * // => [1.1, 2.3]
             */


            function sortedUniqBy(array, iteratee) {
              return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
            }
            /**
             * Gets all but the first element of `array`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to query.
             * @returns {Array} Returns the slice of `array`.
             * @example
             *
             * _.tail([1, 2, 3]);
             * // => [2, 3]
             */


            function tail(array) {
              var length = array == null ? 0 : array.length;
              return length ? baseSlice(array, 1, length) : [];
            }
            /**
             * Creates a slice of `array` with `n` elements taken from the beginning.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to query.
             * @param {number} [n=1] The number of elements to take.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Array} Returns the slice of `array`.
             * @example
             *
             * _.take([1, 2, 3]);
             * // => [1]
             *
             * _.take([1, 2, 3], 2);
             * // => [1, 2]
             *
             * _.take([1, 2, 3], 5);
             * // => [1, 2, 3]
             *
             * _.take([1, 2, 3], 0);
             * // => []
             */


            function take(array, n, guard) {
              if (!(array && array.length)) {
                return [];
              }

              n = guard || n === undefined ? 1 : toInteger(n);
              return baseSlice(array, 0, n < 0 ? 0 : n);
            }
            /**
             * Creates a slice of `array` with `n` elements taken from the end.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to query.
             * @param {number} [n=1] The number of elements to take.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Array} Returns the slice of `array`.
             * @example
             *
             * _.takeRight([1, 2, 3]);
             * // => [3]
             *
             * _.takeRight([1, 2, 3], 2);
             * // => [2, 3]
             *
             * _.takeRight([1, 2, 3], 5);
             * // => [1, 2, 3]
             *
             * _.takeRight([1, 2, 3], 0);
             * // => []
             */


            function takeRight(array, n, guard) {
              var length = array == null ? 0 : array.length;

              if (!length) {
                return [];
              }

              n = guard || n === undefined ? 1 : toInteger(n);
              n = length - n;
              return baseSlice(array, n < 0 ? 0 : n, length);
            }
            /**
             * Creates a slice of `array` with elements taken from the end. Elements are
             * taken until `predicate` returns falsey. The predicate is invoked with
             * three arguments: (value, index, array).
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to query.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the slice of `array`.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'active': true },
             *   { 'user': 'fred',    'active': false },
             *   { 'user': 'pebbles', 'active': false }
             * ];
             *
             * _.takeRightWhile(users, function(o) { return !o.active; });
             * // => objects for ['fred', 'pebbles']
             *
             * // The `_.matches` iteratee shorthand.
             * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
             * // => objects for ['pebbles']
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.takeRightWhile(users, ['active', false]);
             * // => objects for ['fred', 'pebbles']
             *
             * // The `_.property` iteratee shorthand.
             * _.takeRightWhile(users, 'active');
             * // => []
             */


            function takeRightWhile(array, predicate) {
              return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
            }
            /**
             * Creates a slice of `array` with elements taken from the beginning. Elements
             * are taken until `predicate` returns falsey. The predicate is invoked with
             * three arguments: (value, index, array).
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Array
             * @param {Array} array The array to query.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the slice of `array`.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'active': false },
             *   { 'user': 'fred',    'active': false },
             *   { 'user': 'pebbles', 'active': true }
             * ];
             *
             * _.takeWhile(users, function(o) { return !o.active; });
             * // => objects for ['barney', 'fred']
             *
             * // The `_.matches` iteratee shorthand.
             * _.takeWhile(users, { 'user': 'barney', 'active': false });
             * // => objects for ['barney']
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.takeWhile(users, ['active', false]);
             * // => objects for ['barney', 'fred']
             *
             * // The `_.property` iteratee shorthand.
             * _.takeWhile(users, 'active');
             * // => []
             */


            function takeWhile(array, predicate) {
              return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
            }
            /**
             * Creates an array of unique values, in order, from all given arrays using
             * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * for equality comparisons.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {...Array} [arrays] The arrays to inspect.
             * @returns {Array} Returns the new array of combined values.
             * @example
             *
             * _.union([2], [1, 2]);
             * // => [2, 1]
             */


            var union = baseRest(function (arrays) {
              return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
            });
            /**
             * This method is like `_.union` except that it accepts `iteratee` which is
             * invoked for each element of each `arrays` to generate the criterion by
             * which uniqueness is computed. Result values are chosen from the first
             * array in which the value occurs. The iteratee is invoked with one argument:
             * (value).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {...Array} [arrays] The arrays to inspect.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {Array} Returns the new array of combined values.
             * @example
             *
             * _.unionBy([2.1], [1.2, 2.3], Math.floor);
             * // => [2.1, 1.2]
             *
             * // The `_.property` iteratee shorthand.
             * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
             * // => [{ 'x': 1 }, { 'x': 2 }]
             */

            var unionBy = baseRest(function (arrays) {
              var iteratee = last(arrays);

              if (isArrayLikeObject(iteratee)) {
                iteratee = undefined;
              }

              return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
            });
            /**
             * This method is like `_.union` except that it accepts `comparator` which
             * is invoked to compare elements of `arrays`. Result values are chosen from
             * the first array in which the value occurs. The comparator is invoked
             * with two arguments: (arrVal, othVal).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {...Array} [arrays] The arrays to inspect.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns the new array of combined values.
             * @example
             *
             * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
             * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
             *
             * _.unionWith(objects, others, _.isEqual);
             * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
             */

            var unionWith = baseRest(function (arrays) {
              var comparator = last(arrays);
              comparator = typeof comparator == 'function' ? comparator : undefined;
              return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
            });
            /**
             * Creates a duplicate-free version of an array, using
             * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * for equality comparisons, in which only the first occurrence of each element
             * is kept. The order of result values is determined by the order they occur
             * in the array.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @returns {Array} Returns the new duplicate free array.
             * @example
             *
             * _.uniq([2, 1, 2]);
             * // => [2, 1]
             */

            function uniq(array) {
              return array && array.length ? baseUniq(array) : [];
            }
            /**
             * This method is like `_.uniq` except that it accepts `iteratee` which is
             * invoked for each element in `array` to generate the criterion by which
             * uniqueness is computed. The order of result values is determined by the
             * order they occur in the array. The iteratee is invoked with one argument:
             * (value).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {Array} Returns the new duplicate free array.
             * @example
             *
             * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
             * // => [2.1, 1.2]
             *
             * // The `_.property` iteratee shorthand.
             * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
             * // => [{ 'x': 1 }, { 'x': 2 }]
             */


            function uniqBy(array, iteratee) {
              return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
            }
            /**
             * This method is like `_.uniq` except that it accepts `comparator` which
             * is invoked to compare elements of `array`. The order of result values is
             * determined by the order they occur in the array.The comparator is invoked
             * with two arguments: (arrVal, othVal).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns the new duplicate free array.
             * @example
             *
             * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
             *
             * _.uniqWith(objects, _.isEqual);
             * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
             */


            function uniqWith(array, comparator) {
              comparator = typeof comparator == 'function' ? comparator : undefined;
              return array && array.length ? baseUniq(array, undefined, comparator) : [];
            }
            /**
             * This method is like `_.zip` except that it accepts an array of grouped
             * elements and creates an array regrouping the elements to their pre-zip
             * configuration.
             *
             * @static
             * @memberOf _
             * @since 1.2.0
             * @category Array
             * @param {Array} array The array of grouped elements to process.
             * @returns {Array} Returns the new array of regrouped elements.
             * @example
             *
             * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
             * // => [['a', 1, true], ['b', 2, false]]
             *
             * _.unzip(zipped);
             * // => [['a', 'b'], [1, 2], [true, false]]
             */


            function unzip(array) {
              if (!(array && array.length)) {
                return [];
              }

              var length = 0;
              array = arrayFilter(array, function (group) {
                if (isArrayLikeObject(group)) {
                  length = nativeMax(group.length, length);
                  return true;
                }
              });
              return baseTimes(length, function (index) {
                return arrayMap(array, baseProperty(index));
              });
            }
            /**
             * This method is like `_.unzip` except that it accepts `iteratee` to specify
             * how regrouped values should be combined. The iteratee is invoked with the
             * elements of each group: (...group).
             *
             * @static
             * @memberOf _
             * @since 3.8.0
             * @category Array
             * @param {Array} array The array of grouped elements to process.
             * @param {Function} [iteratee=_.identity] The function to combine
             *  regrouped values.
             * @returns {Array} Returns the new array of regrouped elements.
             * @example
             *
             * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
             * // => [[1, 10, 100], [2, 20, 200]]
             *
             * _.unzipWith(zipped, _.add);
             * // => [3, 30, 300]
             */


            function unzipWith(array, iteratee) {
              if (!(array && array.length)) {
                return [];
              }

              var result = unzip(array);

              if (iteratee == null) {
                return result;
              }

              return arrayMap(result, function (group) {
                return apply(iteratee, undefined, group);
              });
            }
            /**
             * Creates an array excluding all given values using
             * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * for equality comparisons.
             *
             * **Note:** Unlike `_.pull`, this method returns a new array.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {Array} array The array to inspect.
             * @param {...*} [values] The values to exclude.
             * @returns {Array} Returns the new array of filtered values.
             * @see _.difference, _.xor
             * @example
             *
             * _.without([2, 1, 2, 3], 1, 2);
             * // => [3]
             */


            var without = baseRest(function (array, values) {
              return isArrayLikeObject(array) ? baseDifference(array, values) : [];
            });
            /**
             * Creates an array of unique values that is the
             * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
             * of the given arrays. The order of result values is determined by the order
             * they occur in the arrays.
             *
             * @static
             * @memberOf _
             * @since 2.4.0
             * @category Array
             * @param {...Array} [arrays] The arrays to inspect.
             * @returns {Array} Returns the new array of filtered values.
             * @see _.difference, _.without
             * @example
             *
             * _.xor([2, 1], [2, 3]);
             * // => [1, 3]
             */

            var xor = baseRest(function (arrays) {
              return baseXor(arrayFilter(arrays, isArrayLikeObject));
            });
            /**
             * This method is like `_.xor` except that it accepts `iteratee` which is
             * invoked for each element of each `arrays` to generate the criterion by
             * which by which they're compared. The order of result values is determined
             * by the order they occur in the arrays. The iteratee is invoked with one
             * argument: (value).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {...Array} [arrays] The arrays to inspect.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {Array} Returns the new array of filtered values.
             * @example
             *
             * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
             * // => [1.2, 3.4]
             *
             * // The `_.property` iteratee shorthand.
             * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
             * // => [{ 'x': 2 }]
             */

            var xorBy = baseRest(function (arrays) {
              var iteratee = last(arrays);

              if (isArrayLikeObject(iteratee)) {
                iteratee = undefined;
              }

              return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
            });
            /**
             * This method is like `_.xor` except that it accepts `comparator` which is
             * invoked to compare elements of `arrays`. The order of result values is
             * determined by the order they occur in the arrays. The comparator is invoked
             * with two arguments: (arrVal, othVal).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Array
             * @param {...Array} [arrays] The arrays to inspect.
             * @param {Function} [comparator] The comparator invoked per element.
             * @returns {Array} Returns the new array of filtered values.
             * @example
             *
             * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
             * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
             *
             * _.xorWith(objects, others, _.isEqual);
             * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
             */

            var xorWith = baseRest(function (arrays) {
              var comparator = last(arrays);
              comparator = typeof comparator == 'function' ? comparator : undefined;
              return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
            });
            /**
             * Creates an array of grouped elements, the first of which contains the
             * first elements of the given arrays, the second of which contains the
             * second elements of the given arrays, and so on.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Array
             * @param {...Array} [arrays] The arrays to process.
             * @returns {Array} Returns the new array of grouped elements.
             * @example
             *
             * _.zip(['a', 'b'], [1, 2], [true, false]);
             * // => [['a', 1, true], ['b', 2, false]]
             */

            var zip = baseRest(unzip);
            /**
             * This method is like `_.fromPairs` except that it accepts two arrays,
             * one of property identifiers and one of corresponding values.
             *
             * @static
             * @memberOf _
             * @since 0.4.0
             * @category Array
             * @param {Array} [props=[]] The property identifiers.
             * @param {Array} [values=[]] The property values.
             * @returns {Object} Returns the new object.
             * @example
             *
             * _.zipObject(['a', 'b'], [1, 2]);
             * // => { 'a': 1, 'b': 2 }
             */

            function zipObject(props, values) {
              return baseZipObject(props || [], values || [], assignValue);
            }
            /**
             * This method is like `_.zipObject` except that it supports property paths.
             *
             * @static
             * @memberOf _
             * @since 4.1.0
             * @category Array
             * @param {Array} [props=[]] The property identifiers.
             * @param {Array} [values=[]] The property values.
             * @returns {Object} Returns the new object.
             * @example
             *
             * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
             * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
             */


            function zipObjectDeep(props, values) {
              return baseZipObject(props || [], values || [], baseSet);
            }
            /**
             * This method is like `_.zip` except that it accepts `iteratee` to specify
             * how grouped values should be combined. The iteratee is invoked with the
             * elements of each group: (...group).
             *
             * @static
             * @memberOf _
             * @since 3.8.0
             * @category Array
             * @param {...Array} [arrays] The arrays to process.
             * @param {Function} [iteratee=_.identity] The function to combine
             *  grouped values.
             * @returns {Array} Returns the new array of grouped elements.
             * @example
             *
             * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
             *   return a + b + c;
             * });
             * // => [111, 222]
             */


            var zipWith = baseRest(function (arrays) {
              var length = arrays.length,
                  iteratee = length > 1 ? arrays[length - 1] : undefined;
              iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
              return unzipWith(arrays, iteratee);
            });
            /*------------------------------------------------------------------------*/

            /**
             * Creates a `lodash` wrapper instance that wraps `value` with explicit method
             * chain sequences enabled. The result of such sequences must be unwrapped
             * with `_#value`.
             *
             * @static
             * @memberOf _
             * @since 1.3.0
             * @category Seq
             * @param {*} value The value to wrap.
             * @returns {Object} Returns the new `lodash` wrapper instance.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'age': 36 },
             *   { 'user': 'fred',    'age': 40 },
             *   { 'user': 'pebbles', 'age': 1 }
             * ];
             *
             * var youngest = _
             *   .chain(users)
             *   .sortBy('age')
             *   .map(function(o) {
             *     return o.user + ' is ' + o.age;
             *   })
             *   .head()
             *   .value();
             * // => 'pebbles is 1'
             */

            function chain(value) {
              var result = lodash(value);
              result.__chain__ = true;
              return result;
            }
            /**
             * This method invokes `interceptor` and returns `value`. The interceptor
             * is invoked with one argument; (value). The purpose of this method is to
             * "tap into" a method chain sequence in order to modify intermediate results.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Seq
             * @param {*} value The value to provide to `interceptor`.
             * @param {Function} interceptor The function to invoke.
             * @returns {*} Returns `value`.
             * @example
             *
             * _([1, 2, 3])
             *  .tap(function(array) {
             *    // Mutate input array.
             *    array.pop();
             *  })
             *  .reverse()
             *  .value();
             * // => [2, 1]
             */


            function tap(value, interceptor) {
              interceptor(value);
              return value;
            }
            /**
             * This method is like `_.tap` except that it returns the result of `interceptor`.
             * The purpose of this method is to "pass thru" values replacing intermediate
             * results in a method chain sequence.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Seq
             * @param {*} value The value to provide to `interceptor`.
             * @param {Function} interceptor The function to invoke.
             * @returns {*} Returns the result of `interceptor`.
             * @example
             *
             * _('  abc  ')
             *  .chain()
             *  .trim()
             *  .thru(function(value) {
             *    return [value];
             *  })
             *  .value();
             * // => ['abc']
             */


            function thru(value, interceptor) {
              return interceptor(value);
            }
            /**
             * This method is the wrapper version of `_.at`.
             *
             * @name at
             * @memberOf _
             * @since 1.0.0
             * @category Seq
             * @param {...(string|string[])} [paths] The property paths to pick.
             * @returns {Object} Returns the new `lodash` wrapper instance.
             * @example
             *
             * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
             *
             * _(object).at(['a[0].b.c', 'a[1]']).value();
             * // => [3, 4]
             */


            var wrapperAt = flatRest(function (paths) {
              var length = paths.length,
                  start = length ? paths[0] : 0,
                  value = this.__wrapped__,
                  interceptor = function interceptor(object) {
                return baseAt(object, paths);
              };

              if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
                return this.thru(interceptor);
              }

              value = value.slice(start, +start + (length ? 1 : 0));

              value.__actions__.push({
                'func': thru,
                'args': [interceptor],
                'thisArg': undefined
              });

              return new LodashWrapper(value, this.__chain__).thru(function (array) {
                if (length && !array.length) {
                  array.push(undefined);
                }

                return array;
              });
            });
            /**
             * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
             *
             * @name chain
             * @memberOf _
             * @since 0.1.0
             * @category Seq
             * @returns {Object} Returns the new `lodash` wrapper instance.
             * @example
             *
             * var users = [
             *   { 'user': 'barney', 'age': 36 },
             *   { 'user': 'fred',   'age': 40 }
             * ];
             *
             * // A sequence without explicit chaining.
             * _(users).head();
             * // => { 'user': 'barney', 'age': 36 }
             *
             * // A sequence with explicit chaining.
             * _(users)
             *   .chain()
             *   .head()
             *   .pick('user')
             *   .value();
             * // => { 'user': 'barney' }
             */

            function wrapperChain() {
              return chain(this);
            }
            /**
             * Executes the chain sequence and returns the wrapped result.
             *
             * @name commit
             * @memberOf _
             * @since 3.2.0
             * @category Seq
             * @returns {Object} Returns the new `lodash` wrapper instance.
             * @example
             *
             * var array = [1, 2];
             * var wrapped = _(array).push(3);
             *
             * console.log(array);
             * // => [1, 2]
             *
             * wrapped = wrapped.commit();
             * console.log(array);
             * // => [1, 2, 3]
             *
             * wrapped.last();
             * // => 3
             *
             * console.log(array);
             * // => [1, 2, 3]
             */


            function wrapperCommit() {
              return new LodashWrapper(this.value(), this.__chain__);
            }
            /**
             * Gets the next value on a wrapped object following the
             * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
             *
             * @name next
             * @memberOf _
             * @since 4.0.0
             * @category Seq
             * @returns {Object} Returns the next iterator value.
             * @example
             *
             * var wrapped = _([1, 2]);
             *
             * wrapped.next();
             * // => { 'done': false, 'value': 1 }
             *
             * wrapped.next();
             * // => { 'done': false, 'value': 2 }
             *
             * wrapped.next();
             * // => { 'done': true, 'value': undefined }
             */


            function wrapperNext() {
              if (this.__values__ === undefined) {
                this.__values__ = toArray(this.value());
              }

              var done = this.__index__ >= this.__values__.length,
                  value = done ? undefined : this.__values__[this.__index__++];
              return {
                'done': done,
                'value': value
              };
            }
            /**
             * Enables the wrapper to be iterable.
             *
             * @name Symbol.iterator
             * @memberOf _
             * @since 4.0.0
             * @category Seq
             * @returns {Object} Returns the wrapper object.
             * @example
             *
             * var wrapped = _([1, 2]);
             *
             * wrapped[Symbol.iterator]() === wrapped;
             * // => true
             *
             * Array.from(wrapped);
             * // => [1, 2]
             */


            function wrapperToIterator() {
              return this;
            }
            /**
             * Creates a clone of the chain sequence planting `value` as the wrapped value.
             *
             * @name plant
             * @memberOf _
             * @since 3.2.0
             * @category Seq
             * @param {*} value The value to plant.
             * @returns {Object} Returns the new `lodash` wrapper instance.
             * @example
             *
             * function square(n) {
             *   return n * n;
             * }
             *
             * var wrapped = _([1, 2]).map(square);
             * var other = wrapped.plant([3, 4]);
             *
             * other.value();
             * // => [9, 16]
             *
             * wrapped.value();
             * // => [1, 4]
             */


            function wrapperPlant(value) {
              var result,
                  parent = this;

              while (parent instanceof baseLodash) {
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;

                if (result) {
                  previous.__wrapped__ = clone;
                } else {
                  result = clone;
                }

                var previous = clone;
                parent = parent.__wrapped__;
              }

              previous.__wrapped__ = value;
              return result;
            }
            /**
             * This method is the wrapper version of `_.reverse`.
             *
             * **Note:** This method mutates the wrapped array.
             *
             * @name reverse
             * @memberOf _
             * @since 0.1.0
             * @category Seq
             * @returns {Object} Returns the new `lodash` wrapper instance.
             * @example
             *
             * var array = [1, 2, 3];
             *
             * _(array).reverse().value()
             * // => [3, 2, 1]
             *
             * console.log(array);
             * // => [3, 2, 1]
             */


            function wrapperReverse() {
              var value = this.__wrapped__;

              if (value instanceof LazyWrapper) {
                var wrapped = value;

                if (this.__actions__.length) {
                  wrapped = new LazyWrapper(this);
                }

                wrapped = wrapped.reverse();

                wrapped.__actions__.push({
                  'func': thru,
                  'args': [reverse],
                  'thisArg': undefined
                });

                return new LodashWrapper(wrapped, this.__chain__);
              }

              return this.thru(reverse);
            }
            /**
             * Executes the chain sequence to resolve the unwrapped value.
             *
             * @name value
             * @memberOf _
             * @since 0.1.0
             * @alias toJSON, valueOf
             * @category Seq
             * @returns {*} Returns the resolved unwrapped value.
             * @example
             *
             * _([1, 2, 3]).value();
             * // => [1, 2, 3]
             */


            function wrapperValue() {
              return baseWrapperValue(this.__wrapped__, this.__actions__);
            }
            /*------------------------------------------------------------------------*/

            /**
             * Creates an object composed of keys generated from the results of running
             * each element of `collection` thru `iteratee`. The corresponding value of
             * each key is the number of times the key was returned by `iteratee`. The
             * iteratee is invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 0.5.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
             * @returns {Object} Returns the composed aggregate object.
             * @example
             *
             * _.countBy([6.1, 4.2, 6.3], Math.floor);
             * // => { '4': 1, '6': 2 }
             *
             * // The `_.property` iteratee shorthand.
             * _.countBy(['one', 'two', 'three'], 'length');
             * // => { '3': 2, '5': 1 }
             */


            var countBy = createAggregator(function (result, value, key) {
              if (hasOwnProperty.call(result, key)) {
                ++result[key];
              } else {
                baseAssignValue(result, key, 1);
              }
            });
            /**
             * Checks if `predicate` returns truthy for **all** elements of `collection`.
             * Iteration is stopped once `predicate` returns falsey. The predicate is
             * invoked with three arguments: (value, index|key, collection).
             *
             * **Note:** This method returns `true` for
             * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
             * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
             * elements of empty collections.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {boolean} Returns `true` if all elements pass the predicate check,
             *  else `false`.
             * @example
             *
             * _.every([true, 1, null, 'yes'], Boolean);
             * // => false
             *
             * var users = [
             *   { 'user': 'barney', 'age': 36, 'active': false },
             *   { 'user': 'fred',   'age': 40, 'active': false }
             * ];
             *
             * // The `_.matches` iteratee shorthand.
             * _.every(users, { 'user': 'barney', 'active': false });
             * // => false
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.every(users, ['active', false]);
             * // => true
             *
             * // The `_.property` iteratee shorthand.
             * _.every(users, 'active');
             * // => false
             */

            function every(collection, predicate, guard) {
              var func = isArray(collection) ? arrayEvery : baseEvery;

              if (guard && isIterateeCall(collection, predicate, guard)) {
                predicate = undefined;
              }

              return func(collection, getIteratee(predicate, 3));
            }
            /**
             * Iterates over elements of `collection`, returning an array of all elements
             * `predicate` returns truthy for. The predicate is invoked with three
             * arguments: (value, index|key, collection).
             *
             * **Note:** Unlike `_.remove`, this method returns a new array.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the new filtered array.
             * @see _.reject
             * @example
             *
             * var users = [
             *   { 'user': 'barney', 'age': 36, 'active': true },
             *   { 'user': 'fred',   'age': 40, 'active': false }
             * ];
             *
             * _.filter(users, function(o) { return !o.active; });
             * // => objects for ['fred']
             *
             * // The `_.matches` iteratee shorthand.
             * _.filter(users, { 'age': 36, 'active': true });
             * // => objects for ['barney']
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.filter(users, ['active', false]);
             * // => objects for ['fred']
             *
             * // The `_.property` iteratee shorthand.
             * _.filter(users, 'active');
             * // => objects for ['barney']
             */


            function filter(collection, predicate) {
              var func = isArray(collection) ? arrayFilter : baseFilter;
              return func(collection, getIteratee(predicate, 3));
            }
            /**
             * Iterates over elements of `collection`, returning the first element
             * `predicate` returns truthy for. The predicate is invoked with three
             * arguments: (value, index|key, collection).
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to inspect.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @param {number} [fromIndex=0] The index to search from.
             * @returns {*} Returns the matched element, else `undefined`.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'age': 36, 'active': true },
             *   { 'user': 'fred',    'age': 40, 'active': false },
             *   { 'user': 'pebbles', 'age': 1,  'active': true }
             * ];
             *
             * _.find(users, function(o) { return o.age < 40; });
             * // => object for 'barney'
             *
             * // The `_.matches` iteratee shorthand.
             * _.find(users, { 'age': 1, 'active': true });
             * // => object for 'pebbles'
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.find(users, ['active', false]);
             * // => object for 'fred'
             *
             * // The `_.property` iteratee shorthand.
             * _.find(users, 'active');
             * // => object for 'barney'
             */


            var find = createFind(findIndex);
            /**
             * This method is like `_.find` except that it iterates over elements of
             * `collection` from right to left.
             *
             * @static
             * @memberOf _
             * @since 2.0.0
             * @category Collection
             * @param {Array|Object} collection The collection to inspect.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @param {number} [fromIndex=collection.length-1] The index to search from.
             * @returns {*} Returns the matched element, else `undefined`.
             * @example
             *
             * _.findLast([1, 2, 3, 4], function(n) {
             *   return n % 2 == 1;
             * });
             * // => 3
             */

            var findLast = createFind(findLastIndex);
            /**
             * Creates a flattened array of values by running each element in `collection`
             * thru `iteratee` and flattening the mapped results. The iteratee is invoked
             * with three arguments: (value, index|key, collection).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the new flattened array.
             * @example
             *
             * function duplicate(n) {
             *   return [n, n];
             * }
             *
             * _.flatMap([1, 2], duplicate);
             * // => [1, 1, 2, 2]
             */

            function flatMap(collection, iteratee) {
              return baseFlatten(map(collection, iteratee), 1);
            }
            /**
             * This method is like `_.flatMap` except that it recursively flattens the
             * mapped results.
             *
             * @static
             * @memberOf _
             * @since 4.7.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the new flattened array.
             * @example
             *
             * function duplicate(n) {
             *   return [[[n, n]]];
             * }
             *
             * _.flatMapDeep([1, 2], duplicate);
             * // => [1, 1, 2, 2]
             */


            function flatMapDeep(collection, iteratee) {
              return baseFlatten(map(collection, iteratee), INFINITY);
            }
            /**
             * This method is like `_.flatMap` except that it recursively flattens the
             * mapped results up to `depth` times.
             *
             * @static
             * @memberOf _
             * @since 4.7.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @param {number} [depth=1] The maximum recursion depth.
             * @returns {Array} Returns the new flattened array.
             * @example
             *
             * function duplicate(n) {
             *   return [[[n, n]]];
             * }
             *
             * _.flatMapDepth([1, 2], duplicate, 2);
             * // => [[1, 1], [2, 2]]
             */


            function flatMapDepth(collection, iteratee, depth) {
              depth = depth === undefined ? 1 : toInteger(depth);
              return baseFlatten(map(collection, iteratee), depth);
            }
            /**
             * Iterates over elements of `collection` and invokes `iteratee` for each element.
             * The iteratee is invoked with three arguments: (value, index|key, collection).
             * Iteratee functions may exit iteration early by explicitly returning `false`.
             *
             * **Note:** As with other "Collections" methods, objects with a "length"
             * property are iterated like arrays. To avoid this behavior use `_.forIn`
             * or `_.forOwn` for object iteration.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @alias each
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Array|Object} Returns `collection`.
             * @see _.forEachRight
             * @example
             *
             * _.forEach([1, 2], function(value) {
             *   console.log(value);
             * });
             * // => Logs `1` then `2`.
             *
             * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
             *   console.log(key);
             * });
             * // => Logs 'a' then 'b' (iteration order is not guaranteed).
             */


            function forEach(collection, iteratee) {
              var func = isArray(collection) ? arrayEach : baseEach;
              return func(collection, getIteratee(iteratee, 3));
            }
            /**
             * This method is like `_.forEach` except that it iterates over elements of
             * `collection` from right to left.
             *
             * @static
             * @memberOf _
             * @since 2.0.0
             * @alias eachRight
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Array|Object} Returns `collection`.
             * @see _.forEach
             * @example
             *
             * _.forEachRight([1, 2], function(value) {
             *   console.log(value);
             * });
             * // => Logs `2` then `1`.
             */


            function forEachRight(collection, iteratee) {
              var func = isArray(collection) ? arrayEachRight : baseEachRight;
              return func(collection, getIteratee(iteratee, 3));
            }
            /**
             * Creates an object composed of keys generated from the results of running
             * each element of `collection` thru `iteratee`. The order of grouped values
             * is determined by the order they occur in `collection`. The corresponding
             * value of each key is an array of elements responsible for generating the
             * key. The iteratee is invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
             * @returns {Object} Returns the composed aggregate object.
             * @example
             *
             * _.groupBy([6.1, 4.2, 6.3], Math.floor);
             * // => { '4': [4.2], '6': [6.1, 6.3] }
             *
             * // The `_.property` iteratee shorthand.
             * _.groupBy(['one', 'two', 'three'], 'length');
             * // => { '3': ['one', 'two'], '5': ['three'] }
             */


            var groupBy = createAggregator(function (result, value, key) {
              if (hasOwnProperty.call(result, key)) {
                result[key].push(value);
              } else {
                baseAssignValue(result, key, [value]);
              }
            });
            /**
             * Checks if `value` is in `collection`. If `collection` is a string, it's
             * checked for a substring of `value`, otherwise
             * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * is used for equality comparisons. If `fromIndex` is negative, it's used as
             * the offset from the end of `collection`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object|string} collection The collection to inspect.
             * @param {*} value The value to search for.
             * @param {number} [fromIndex=0] The index to search from.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
             * @returns {boolean} Returns `true` if `value` is found, else `false`.
             * @example
             *
             * _.includes([1, 2, 3], 1);
             * // => true
             *
             * _.includes([1, 2, 3], 1, 2);
             * // => false
             *
             * _.includes({ 'a': 1, 'b': 2 }, 1);
             * // => true
             *
             * _.includes('abcd', 'bc');
             * // => true
             */

            function includes(collection, value, fromIndex, guard) {
              collection = isArrayLike(collection) ? collection : values(collection);
              fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
              var length = collection.length;

              if (fromIndex < 0) {
                fromIndex = nativeMax(length + fromIndex, 0);
              }

              return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
            }
            /**
             * Invokes the method at `path` of each element in `collection`, returning
             * an array of the results of each invoked method. Any additional arguments
             * are provided to each invoked method. If `path` is a function, it's invoked
             * for, and `this` bound to, each element in `collection`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Array|Function|string} path The path of the method to invoke or
             *  the function invoked per iteration.
             * @param {...*} [args] The arguments to invoke each method with.
             * @returns {Array} Returns the array of results.
             * @example
             *
             * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
             * // => [[1, 5, 7], [1, 2, 3]]
             *
             * _.invokeMap([123, 456], String.prototype.split, '');
             * // => [['1', '2', '3'], ['4', '5', '6']]
             */


            var invokeMap = baseRest(function (collection, path, args) {
              var index = -1,
                  isFunc = typeof path == 'function',
                  result = isArrayLike(collection) ? Array(collection.length) : [];
              baseEach(collection, function (value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
              });
              return result;
            });
            /**
             * Creates an object composed of keys generated from the results of running
             * each element of `collection` thru `iteratee`. The corresponding value of
             * each key is the last element responsible for generating the key. The
             * iteratee is invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
             * @returns {Object} Returns the composed aggregate object.
             * @example
             *
             * var array = [
             *   { 'dir': 'left', 'code': 97 },
             *   { 'dir': 'right', 'code': 100 }
             * ];
             *
             * _.keyBy(array, function(o) {
             *   return String.fromCharCode(o.code);
             * });
             * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
             *
             * _.keyBy(array, 'dir');
             * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
             */

            var keyBy = createAggregator(function (result, value, key) {
              baseAssignValue(result, key, value);
            });
            /**
             * Creates an array of values by running each element in `collection` thru
             * `iteratee`. The iteratee is invoked with three arguments:
             * (value, index|key, collection).
             *
             * Many lodash methods are guarded to work as iteratees for methods like
             * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
             *
             * The guarded methods are:
             * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
             * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
             * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
             * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the new mapped array.
             * @example
             *
             * function square(n) {
             *   return n * n;
             * }
             *
             * _.map([4, 8], square);
             * // => [16, 64]
             *
             * _.map({ 'a': 4, 'b': 8 }, square);
             * // => [16, 64] (iteration order is not guaranteed)
             *
             * var users = [
             *   { 'user': 'barney' },
             *   { 'user': 'fred' }
             * ];
             *
             * // The `_.property` iteratee shorthand.
             * _.map(users, 'user');
             * // => ['barney', 'fred']
             */

            function map(collection, iteratee) {
              var func = isArray(collection) ? arrayMap : baseMap;
              return func(collection, getIteratee(iteratee, 3));
            }
            /**
             * This method is like `_.sortBy` except that it allows specifying the sort
             * orders of the iteratees to sort by. If `orders` is unspecified, all values
             * are sorted in ascending order. Otherwise, specify an order of "desc" for
             * descending or "asc" for ascending sort order of corresponding values.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
             *  The iteratees to sort by.
             * @param {string[]} [orders] The sort orders of `iteratees`.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
             * @returns {Array} Returns the new sorted array.
             * @example
             *
             * var users = [
             *   { 'user': 'fred',   'age': 48 },
             *   { 'user': 'barney', 'age': 34 },
             *   { 'user': 'fred',   'age': 40 },
             *   { 'user': 'barney', 'age': 36 }
             * ];
             *
             * // Sort by `user` in ascending order and by `age` in descending order.
             * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
             * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
             */


            function orderBy(collection, iteratees, orders, guard) {
              if (collection == null) {
                return [];
              }

              if (!isArray(iteratees)) {
                iteratees = iteratees == null ? [] : [iteratees];
              }

              orders = guard ? undefined : orders;

              if (!isArray(orders)) {
                orders = orders == null ? [] : [orders];
              }

              return baseOrderBy(collection, iteratees, orders);
            }
            /**
             * Creates an array of elements split into two groups, the first of which
             * contains elements `predicate` returns truthy for, the second of which
             * contains elements `predicate` returns falsey for. The predicate is
             * invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the array of grouped elements.
             * @example
             *
             * var users = [
             *   { 'user': 'barney',  'age': 36, 'active': false },
             *   { 'user': 'fred',    'age': 40, 'active': true },
             *   { 'user': 'pebbles', 'age': 1,  'active': false }
             * ];
             *
             * _.partition(users, function(o) { return o.active; });
             * // => objects for [['fred'], ['barney', 'pebbles']]
             *
             * // The `_.matches` iteratee shorthand.
             * _.partition(users, { 'age': 1, 'active': false });
             * // => objects for [['pebbles'], ['barney', 'fred']]
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.partition(users, ['active', false]);
             * // => objects for [['barney', 'pebbles'], ['fred']]
             *
             * // The `_.property` iteratee shorthand.
             * _.partition(users, 'active');
             * // => objects for [['fred'], ['barney', 'pebbles']]
             */


            var partition = createAggregator(function (result, value, key) {
              result[key ? 0 : 1].push(value);
            }, function () {
              return [[], []];
            });
            /**
             * Reduces `collection` to a value which is the accumulated result of running
             * each element in `collection` thru `iteratee`, where each successive
             * invocation is supplied the return value of the previous. If `accumulator`
             * is not given, the first element of `collection` is used as the initial
             * value. The iteratee is invoked with four arguments:
             * (accumulator, value, index|key, collection).
             *
             * Many lodash methods are guarded to work as iteratees for methods like
             * `_.reduce`, `_.reduceRight`, and `_.transform`.
             *
             * The guarded methods are:
             * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
             * and `sortBy`
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @param {*} [accumulator] The initial value.
             * @returns {*} Returns the accumulated value.
             * @see _.reduceRight
             * @example
             *
             * _.reduce([1, 2], function(sum, n) {
             *   return sum + n;
             * }, 0);
             * // => 3
             *
             * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
             *   (result[value] || (result[value] = [])).push(key);
             *   return result;
             * }, {});
             * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
             */

            function reduce(collection, iteratee, accumulator) {
              var func = isArray(collection) ? arrayReduce : baseReduce,
                  initAccum = arguments.length < 3;
              return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
            }
            /**
             * This method is like `_.reduce` except that it iterates over elements of
             * `collection` from right to left.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @param {*} [accumulator] The initial value.
             * @returns {*} Returns the accumulated value.
             * @see _.reduce
             * @example
             *
             * var array = [[0, 1], [2, 3], [4, 5]];
             *
             * _.reduceRight(array, function(flattened, other) {
             *   return flattened.concat(other);
             * }, []);
             * // => [4, 5, 2, 3, 0, 1]
             */


            function reduceRight(collection, iteratee, accumulator) {
              var func = isArray(collection) ? arrayReduceRight : baseReduce,
                  initAccum = arguments.length < 3;
              return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
            }
            /**
             * The opposite of `_.filter`; this method returns the elements of `collection`
             * that `predicate` does **not** return truthy for.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the new filtered array.
             * @see _.filter
             * @example
             *
             * var users = [
             *   { 'user': 'barney', 'age': 36, 'active': false },
             *   { 'user': 'fred',   'age': 40, 'active': true }
             * ];
             *
             * _.reject(users, function(o) { return !o.active; });
             * // => objects for ['fred']
             *
             * // The `_.matches` iteratee shorthand.
             * _.reject(users, { 'age': 40, 'active': true });
             * // => objects for ['barney']
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.reject(users, ['active', false]);
             * // => objects for ['fred']
             *
             * // The `_.property` iteratee shorthand.
             * _.reject(users, 'active');
             * // => objects for ['barney']
             */


            function reject(collection, predicate) {
              var func = isArray(collection) ? arrayFilter : baseFilter;
              return func(collection, negate(getIteratee(predicate, 3)));
            }
            /**
             * Gets a random element from `collection`.
             *
             * @static
             * @memberOf _
             * @since 2.0.0
             * @category Collection
             * @param {Array|Object} collection The collection to sample.
             * @returns {*} Returns the random element.
             * @example
             *
             * _.sample([1, 2, 3, 4]);
             * // => 2
             */


            function sample(collection) {
              var func = isArray(collection) ? arraySample : baseSample;
              return func(collection);
            }
            /**
             * Gets `n` random elements at unique keys from `collection` up to the
             * size of `collection`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Collection
             * @param {Array|Object} collection The collection to sample.
             * @param {number} [n=1] The number of elements to sample.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Array} Returns the random elements.
             * @example
             *
             * _.sampleSize([1, 2, 3], 2);
             * // => [3, 1]
             *
             * _.sampleSize([1, 2, 3], 4);
             * // => [2, 3, 1]
             */


            function sampleSize(collection, n, guard) {
              if (guard ? isIterateeCall(collection, n, guard) : n === undefined) {
                n = 1;
              } else {
                n = toInteger(n);
              }

              var func = isArray(collection) ? arraySampleSize : baseSampleSize;
              return func(collection, n);
            }
            /**
             * Creates an array of shuffled values, using a version of the
             * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to shuffle.
             * @returns {Array} Returns the new shuffled array.
             * @example
             *
             * _.shuffle([1, 2, 3, 4]);
             * // => [4, 1, 3, 2]
             */


            function shuffle(collection) {
              var func = isArray(collection) ? arrayShuffle : baseShuffle;
              return func(collection);
            }
            /**
             * Gets the size of `collection` by returning its length for array-like
             * values or the number of own enumerable string keyed properties for objects.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object|string} collection The collection to inspect.
             * @returns {number} Returns the collection size.
             * @example
             *
             * _.size([1, 2, 3]);
             * // => 3
             *
             * _.size({ 'a': 1, 'b': 2 });
             * // => 2
             *
             * _.size('pebbles');
             * // => 7
             */


            function size(collection) {
              if (collection == null) {
                return 0;
              }

              if (isArrayLike(collection)) {
                return isString(collection) ? stringSize(collection) : collection.length;
              }

              var tag = getTag(collection);

              if (tag == mapTag || tag == setTag) {
                return collection.size;
              }

              return baseKeys(collection).length;
            }
            /**
             * Checks if `predicate` returns truthy for **any** element of `collection`.
             * Iteration is stopped once `predicate` returns truthy. The predicate is
             * invoked with three arguments: (value, index|key, collection).
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {boolean} Returns `true` if any element passes the predicate check,
             *  else `false`.
             * @example
             *
             * _.some([null, 0, 'yes', false], Boolean);
             * // => true
             *
             * var users = [
             *   { 'user': 'barney', 'active': true },
             *   { 'user': 'fred',   'active': false }
             * ];
             *
             * // The `_.matches` iteratee shorthand.
             * _.some(users, { 'user': 'barney', 'active': false });
             * // => false
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.some(users, ['active', false]);
             * // => true
             *
             * // The `_.property` iteratee shorthand.
             * _.some(users, 'active');
             * // => true
             */


            function some(collection, predicate, guard) {
              var func = isArray(collection) ? arraySome : baseSome;

              if (guard && isIterateeCall(collection, predicate, guard)) {
                predicate = undefined;
              }

              return func(collection, getIteratee(predicate, 3));
            }
            /**
             * Creates an array of elements, sorted in ascending order by the results of
             * running each element in a collection thru each iteratee. This method
             * performs a stable sort, that is, it preserves the original sort order of
             * equal elements. The iteratees are invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Collection
             * @param {Array|Object} collection The collection to iterate over.
             * @param {...(Function|Function[])} [iteratees=[_.identity]]
             *  The iteratees to sort by.
             * @returns {Array} Returns the new sorted array.
             * @example
             *
             * var users = [
             *   { 'user': 'fred',   'age': 48 },
             *   { 'user': 'barney', 'age': 36 },
             *   { 'user': 'fred',   'age': 40 },
             *   { 'user': 'barney', 'age': 34 }
             * ];
             *
             * _.sortBy(users, [function(o) { return o.user; }]);
             * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
             *
             * _.sortBy(users, ['user', 'age']);
             * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
             */


            var sortBy = baseRest(function (collection, iteratees) {
              if (collection == null) {
                return [];
              }

              var length = iteratees.length;

              if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
                iteratees = [];
              } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
                iteratees = [iteratees[0]];
              }

              return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
            });
            /*------------------------------------------------------------------------*/

            /**
             * Gets the timestamp of the number of milliseconds that have elapsed since
             * the Unix epoch (1 January 1970 00:00:00 UTC).
             *
             * @static
             * @memberOf _
             * @since 2.4.0
             * @category Date
             * @returns {number} Returns the timestamp.
             * @example
             *
             * _.defer(function(stamp) {
             *   console.log(_.now() - stamp);
             * }, _.now());
             * // => Logs the number of milliseconds it took for the deferred invocation.
             */

            var now = ctxNow || function () {
              return root.Date.now();
            };
            /*------------------------------------------------------------------------*/

            /**
             * The opposite of `_.before`; this method creates a function that invokes
             * `func` once it's called `n` or more times.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {number} n The number of calls before `func` is invoked.
             * @param {Function} func The function to restrict.
             * @returns {Function} Returns the new restricted function.
             * @example
             *
             * var saves = ['profile', 'settings'];
             *
             * var done = _.after(saves.length, function() {
             *   console.log('done saving!');
             * });
             *
             * _.forEach(saves, function(type) {
             *   asyncSave({ 'type': type, 'complete': done });
             * });
             * // => Logs 'done saving!' after the two async saves have completed.
             */


            function after(n, func) {
              if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              n = toInteger(n);
              return function () {
                if (--n < 1) {
                  return func.apply(this, arguments);
                }
              };
            }
            /**
             * Creates a function that invokes `func`, with up to `n` arguments,
             * ignoring any additional arguments.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Function
             * @param {Function} func The function to cap arguments for.
             * @param {number} [n=func.length] The arity cap.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Function} Returns the new capped function.
             * @example
             *
             * _.map(['6', '8', '10'], _.ary(parseInt, 1));
             * // => [6, 8, 10]
             */


            function ary(func, n, guard) {
              n = guard ? undefined : n;
              n = func && n == null ? func.length : n;
              return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
            }
            /**
             * Creates a function that invokes `func`, with the `this` binding and arguments
             * of the created function, while it's called less than `n` times. Subsequent
             * calls to the created function return the result of the last `func` invocation.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Function
             * @param {number} n The number of calls at which `func` is no longer invoked.
             * @param {Function} func The function to restrict.
             * @returns {Function} Returns the new restricted function.
             * @example
             *
             * jQuery(element).on('click', _.before(5, addContactToList));
             * // => Allows adding up to 4 contacts to the list.
             */


            function before(n, func) {
              var result;

              if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              n = toInteger(n);
              return function () {
                if (--n > 0) {
                  result = func.apply(this, arguments);
                }

                if (n <= 1) {
                  func = undefined;
                }

                return result;
              };
            }
            /**
             * Creates a function that invokes `func` with the `this` binding of `thisArg`
             * and `partials` prepended to the arguments it receives.
             *
             * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
             * may be used as a placeholder for partially applied arguments.
             *
             * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
             * property of bound functions.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to bind.
             * @param {*} thisArg The `this` binding of `func`.
             * @param {...*} [partials] The arguments to be partially applied.
             * @returns {Function} Returns the new bound function.
             * @example
             *
             * function greet(greeting, punctuation) {
             *   return greeting + ' ' + this.user + punctuation;
             * }
             *
             * var object = { 'user': 'fred' };
             *
             * var bound = _.bind(greet, object, 'hi');
             * bound('!');
             * // => 'hi fred!'
             *
             * // Bound with placeholders.
             * var bound = _.bind(greet, object, _, '!');
             * bound('hi');
             * // => 'hi fred!'
             */


            var bind = baseRest(function (func, thisArg, partials) {
              var bitmask = WRAP_BIND_FLAG;

              if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
              }

              return createWrap(func, bitmask, thisArg, partials, holders);
            });
            /**
             * Creates a function that invokes the method at `object[key]` with `partials`
             * prepended to the arguments it receives.
             *
             * This method differs from `_.bind` by allowing bound functions to reference
             * methods that may be redefined or don't yet exist. See
             * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
             * for more details.
             *
             * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
             * builds, may be used as a placeholder for partially applied arguments.
             *
             * @static
             * @memberOf _
             * @since 0.10.0
             * @category Function
             * @param {Object} object The object to invoke the method on.
             * @param {string} key The key of the method.
             * @param {...*} [partials] The arguments to be partially applied.
             * @returns {Function} Returns the new bound function.
             * @example
             *
             * var object = {
             *   'user': 'fred',
             *   'greet': function(greeting, punctuation) {
             *     return greeting + ' ' + this.user + punctuation;
             *   }
             * };
             *
             * var bound = _.bindKey(object, 'greet', 'hi');
             * bound('!');
             * // => 'hi fred!'
             *
             * object.greet = function(greeting, punctuation) {
             *   return greeting + 'ya ' + this.user + punctuation;
             * };
             *
             * bound('!');
             * // => 'hiya fred!'
             *
             * // Bound with placeholders.
             * var bound = _.bindKey(object, 'greet', _, '!');
             * bound('hi');
             * // => 'hiya fred!'
             */

            var bindKey = baseRest(function (object, key, partials) {
              var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;

              if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
              }

              return createWrap(key, bitmask, object, partials, holders);
            });
            /**
             * Creates a function that accepts arguments of `func` and either invokes
             * `func` returning its result, if at least `arity` number of arguments have
             * been provided, or returns a function that accepts the remaining `func`
             * arguments, and so on. The arity of `func` may be specified if `func.length`
             * is not sufficient.
             *
             * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
             * may be used as a placeholder for provided arguments.
             *
             * **Note:** This method doesn't set the "length" property of curried functions.
             *
             * @static
             * @memberOf _
             * @since 2.0.0
             * @category Function
             * @param {Function} func The function to curry.
             * @param {number} [arity=func.length] The arity of `func`.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Function} Returns the new curried function.
             * @example
             *
             * var abc = function(a, b, c) {
             *   return [a, b, c];
             * };
             *
             * var curried = _.curry(abc);
             *
             * curried(1)(2)(3);
             * // => [1, 2, 3]
             *
             * curried(1, 2)(3);
             * // => [1, 2, 3]
             *
             * curried(1, 2, 3);
             * // => [1, 2, 3]
             *
             * // Curried with placeholders.
             * curried(1)(_, 3)(2);
             * // => [1, 2, 3]
             */

            function curry(func, arity, guard) {
              arity = guard ? undefined : arity;
              var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
              result.placeholder = curry.placeholder;
              return result;
            }
            /**
             * This method is like `_.curry` except that arguments are applied to `func`
             * in the manner of `_.partialRight` instead of `_.partial`.
             *
             * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
             * builds, may be used as a placeholder for provided arguments.
             *
             * **Note:** This method doesn't set the "length" property of curried functions.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Function
             * @param {Function} func The function to curry.
             * @param {number} [arity=func.length] The arity of `func`.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Function} Returns the new curried function.
             * @example
             *
             * var abc = function(a, b, c) {
             *   return [a, b, c];
             * };
             *
             * var curried = _.curryRight(abc);
             *
             * curried(3)(2)(1);
             * // => [1, 2, 3]
             *
             * curried(2, 3)(1);
             * // => [1, 2, 3]
             *
             * curried(1, 2, 3);
             * // => [1, 2, 3]
             *
             * // Curried with placeholders.
             * curried(3)(1, _)(2);
             * // => [1, 2, 3]
             */


            function curryRight(func, arity, guard) {
              arity = guard ? undefined : arity;
              var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
              result.placeholder = curryRight.placeholder;
              return result;
            }
            /**
             * Creates a debounced function that delays invoking `func` until after `wait`
             * milliseconds have elapsed since the last time the debounced function was
             * invoked. The debounced function comes with a `cancel` method to cancel
             * delayed `func` invocations and a `flush` method to immediately invoke them.
             * Provide `options` to indicate whether `func` should be invoked on the
             * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
             * with the last arguments provided to the debounced function. Subsequent
             * calls to the debounced function return the result of the last `func`
             * invocation.
             *
             * **Note:** If `leading` and `trailing` options are `true`, `func` is
             * invoked on the trailing edge of the timeout only if the debounced function
             * is invoked more than once during the `wait` timeout.
             *
             * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
             * until to the next tick, similar to `setTimeout` with a timeout of `0`.
             *
             * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
             * for details over the differences between `_.debounce` and `_.throttle`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to debounce.
             * @param {number} [wait=0] The number of milliseconds to delay.
             * @param {Object} [options={}] The options object.
             * @param {boolean} [options.leading=false]
             *  Specify invoking on the leading edge of the timeout.
             * @param {number} [options.maxWait]
             *  The maximum time `func` is allowed to be delayed before it's invoked.
             * @param {boolean} [options.trailing=true]
             *  Specify invoking on the trailing edge of the timeout.
             * @returns {Function} Returns the new debounced function.
             * @example
             *
             * // Avoid costly calculations while the window size is in flux.
             * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
             *
             * // Invoke `sendMail` when clicked, debouncing subsequent calls.
             * jQuery(element).on('click', _.debounce(sendMail, 300, {
             *   'leading': true,
             *   'trailing': false
             * }));
             *
             * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
             * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
             * var source = new EventSource('/stream');
             * jQuery(source).on('message', debounced);
             *
             * // Cancel the trailing debounced invocation.
             * jQuery(window).on('popstate', debounced.cancel);
             */


            function debounce(func, wait, options) {
              var lastArgs,
                  lastThis,
                  maxWait,
                  result,
                  timerId,
                  lastCallTime,
                  lastInvokeTime = 0,
                  leading = false,
                  maxing = false,
                  trailing = true;

              if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              wait = toNumber(wait) || 0;

              if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
              }

              function invokeFunc(time) {
                var args = lastArgs,
                    thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
              }

              function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time; // Start the timer for the trailing edge.

                timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

                return leading ? invokeFunc(time) : result;
              }

              function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime,
                    timeSinceLastInvoke = time - lastInvokeTime,
                    timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
              }

              function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime,
                    timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.

                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
              }

              function timerExpired() {
                var time = now();

                if (shouldInvoke(time)) {
                  return trailingEdge(time);
                } // Restart the timer.


                timerId = setTimeout(timerExpired, remainingWait(time));
              }

              function trailingEdge(time) {
                timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.

                if (trailing && lastArgs) {
                  return invokeFunc(time);
                }

                lastArgs = lastThis = undefined;
                return result;
              }

              function cancel() {
                if (timerId !== undefined) {
                  clearTimeout(timerId);
                }

                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
              }

              function flush() {
                return timerId === undefined ? result : trailingEdge(now());
              }

              function debounced() {
                var time = now(),
                    isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;

                if (isInvoking) {
                  if (timerId === undefined) {
                    return leadingEdge(lastCallTime);
                  }

                  if (maxing) {
                    // Handle invocations in a tight loop.
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                  }
                }

                if (timerId === undefined) {
                  timerId = setTimeout(timerExpired, wait);
                }

                return result;
              }

              debounced.cancel = cancel;
              debounced.flush = flush;
              return debounced;
            }
            /**
             * Defers invoking the `func` until the current call stack has cleared. Any
             * additional arguments are provided to `func` when it's invoked.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to defer.
             * @param {...*} [args] The arguments to invoke `func` with.
             * @returns {number} Returns the timer id.
             * @example
             *
             * _.defer(function(text) {
             *   console.log(text);
             * }, 'deferred');
             * // => Logs 'deferred' after one millisecond.
             */


            var defer = baseRest(function (func, args) {
              return baseDelay(func, 1, args);
            });
            /**
             * Invokes `func` after `wait` milliseconds. Any additional arguments are
             * provided to `func` when it's invoked.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to delay.
             * @param {number} wait The number of milliseconds to delay invocation.
             * @param {...*} [args] The arguments to invoke `func` with.
             * @returns {number} Returns the timer id.
             * @example
             *
             * _.delay(function(text) {
             *   console.log(text);
             * }, 1000, 'later');
             * // => Logs 'later' after one second.
             */

            var delay = baseRest(function (func, wait, args) {
              return baseDelay(func, toNumber(wait) || 0, args);
            });
            /**
             * Creates a function that invokes `func` with arguments reversed.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Function
             * @param {Function} func The function to flip arguments for.
             * @returns {Function} Returns the new flipped function.
             * @example
             *
             * var flipped = _.flip(function() {
             *   return _.toArray(arguments);
             * });
             *
             * flipped('a', 'b', 'c', 'd');
             * // => ['d', 'c', 'b', 'a']
             */

            function flip(func) {
              return createWrap(func, WRAP_FLIP_FLAG);
            }
            /**
             * Creates a function that memoizes the result of `func`. If `resolver` is
             * provided, it determines the cache key for storing the result based on the
             * arguments provided to the memoized function. By default, the first argument
             * provided to the memoized function is used as the map cache key. The `func`
             * is invoked with the `this` binding of the memoized function.
             *
             * **Note:** The cache is exposed as the `cache` property on the memoized
             * function. Its creation may be customized by replacing the `_.memoize.Cache`
             * constructor with one whose instances implement the
             * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
             * method interface of `clear`, `delete`, `get`, `has`, and `set`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to have its output memoized.
             * @param {Function} [resolver] The function to resolve the cache key.
             * @returns {Function} Returns the new memoized function.
             * @example
             *
             * var object = { 'a': 1, 'b': 2 };
             * var other = { 'c': 3, 'd': 4 };
             *
             * var values = _.memoize(_.values);
             * values(object);
             * // => [1, 2]
             *
             * values(other);
             * // => [3, 4]
             *
             * object.a = 2;
             * values(object);
             * // => [1, 2]
             *
             * // Modify the result cache.
             * values.cache.set(object, ['a', 'b']);
             * values(object);
             * // => ['a', 'b']
             *
             * // Replace `_.memoize.Cache`.
             * _.memoize.Cache = WeakMap;
             */


            function memoize(func, resolver) {
              if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              var memoized = function memoized() {
                var args = arguments,
                    key = resolver ? resolver.apply(this, args) : args[0],
                    cache = memoized.cache;

                if (cache.has(key)) {
                  return cache.get(key);
                }

                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
              };

              memoized.cache = new (memoize.Cache || MapCache)();
              return memoized;
            } // Expose `MapCache`.


            memoize.Cache = MapCache;
            /**
             * Creates a function that negates the result of the predicate `func`. The
             * `func` predicate is invoked with the `this` binding and arguments of the
             * created function.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Function
             * @param {Function} predicate The predicate to negate.
             * @returns {Function} Returns the new negated function.
             * @example
             *
             * function isEven(n) {
             *   return n % 2 == 0;
             * }
             *
             * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
             * // => [1, 3, 5]
             */

            function negate(predicate) {
              if (typeof predicate != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              return function () {
                var args = arguments;

                switch (args.length) {
                  case 0:
                    return !predicate.call(this);

                  case 1:
                    return !predicate.call(this, args[0]);

                  case 2:
                    return !predicate.call(this, args[0], args[1]);

                  case 3:
                    return !predicate.call(this, args[0], args[1], args[2]);
                }

                return !predicate.apply(this, args);
              };
            }
            /**
             * Creates a function that is restricted to invoking `func` once. Repeat calls
             * to the function return the value of the first invocation. The `func` is
             * invoked with the `this` binding and arguments of the created function.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to restrict.
             * @returns {Function} Returns the new restricted function.
             * @example
             *
             * var initialize = _.once(createApplication);
             * initialize();
             * initialize();
             * // => `createApplication` is invoked once
             */


            function once(func) {
              return before(2, func);
            }
            /**
             * Creates a function that invokes `func` with its arguments transformed.
             *
             * @static
             * @since 4.0.0
             * @memberOf _
             * @category Function
             * @param {Function} func The function to wrap.
             * @param {...(Function|Function[])} [transforms=[_.identity]]
             *  The argument transforms.
             * @returns {Function} Returns the new function.
             * @example
             *
             * function doubled(n) {
             *   return n * 2;
             * }
             *
             * function square(n) {
             *   return n * n;
             * }
             *
             * var func = _.overArgs(function(x, y) {
             *   return [x, y];
             * }, [square, doubled]);
             *
             * func(9, 3);
             * // => [81, 6]
             *
             * func(10, 5);
             * // => [100, 10]
             */


            var overArgs = castRest(function (func, transforms) {
              transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
              var funcsLength = transforms.length;
              return baseRest(function (args) {
                var index = -1,
                    length = nativeMin(args.length, funcsLength);

                while (++index < length) {
                  args[index] = transforms[index].call(this, args[index]);
                }

                return apply(func, this, args);
              });
            });
            /**
             * Creates a function that invokes `func` with `partials` prepended to the
             * arguments it receives. This method is like `_.bind` except it does **not**
             * alter the `this` binding.
             *
             * The `_.partial.placeholder` value, which defaults to `_` in monolithic
             * builds, may be used as a placeholder for partially applied arguments.
             *
             * **Note:** This method doesn't set the "length" property of partially
             * applied functions.
             *
             * @static
             * @memberOf _
             * @since 0.2.0
             * @category Function
             * @param {Function} func The function to partially apply arguments to.
             * @param {...*} [partials] The arguments to be partially applied.
             * @returns {Function} Returns the new partially applied function.
             * @example
             *
             * function greet(greeting, name) {
             *   return greeting + ' ' + name;
             * }
             *
             * var sayHelloTo = _.partial(greet, 'hello');
             * sayHelloTo('fred');
             * // => 'hello fred'
             *
             * // Partially applied with placeholders.
             * var greetFred = _.partial(greet, _, 'fred');
             * greetFred('hi');
             * // => 'hi fred'
             */

            var partial = baseRest(function (func, partials) {
              var holders = replaceHolders(partials, getHolder(partial));
              return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
            });
            /**
             * This method is like `_.partial` except that partially applied arguments
             * are appended to the arguments it receives.
             *
             * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
             * builds, may be used as a placeholder for partially applied arguments.
             *
             * **Note:** This method doesn't set the "length" property of partially
             * applied functions.
             *
             * @static
             * @memberOf _
             * @since 1.0.0
             * @category Function
             * @param {Function} func The function to partially apply arguments to.
             * @param {...*} [partials] The arguments to be partially applied.
             * @returns {Function} Returns the new partially applied function.
             * @example
             *
             * function greet(greeting, name) {
             *   return greeting + ' ' + name;
             * }
             *
             * var greetFred = _.partialRight(greet, 'fred');
             * greetFred('hi');
             * // => 'hi fred'
             *
             * // Partially applied with placeholders.
             * var sayHelloTo = _.partialRight(greet, 'hello', _);
             * sayHelloTo('fred');
             * // => 'hello fred'
             */

            var partialRight = baseRest(function (func, partials) {
              var holders = replaceHolders(partials, getHolder(partialRight));
              return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
            });
            /**
             * Creates a function that invokes `func` with arguments arranged according
             * to the specified `indexes` where the argument value at the first index is
             * provided as the first argument, the argument value at the second index is
             * provided as the second argument, and so on.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Function
             * @param {Function} func The function to rearrange arguments for.
             * @param {...(number|number[])} indexes The arranged argument indexes.
             * @returns {Function} Returns the new function.
             * @example
             *
             * var rearged = _.rearg(function(a, b, c) {
             *   return [a, b, c];
             * }, [2, 0, 1]);
             *
             * rearged('b', 'c', 'a')
             * // => ['a', 'b', 'c']
             */

            var rearg = flatRest(function (func, indexes) {
              return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
            });
            /**
             * Creates a function that invokes `func` with the `this` binding of the
             * created function and arguments from `start` and beyond provided as
             * an array.
             *
             * **Note:** This method is based on the
             * [rest parameter](https://mdn.io/rest_parameters).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Function
             * @param {Function} func The function to apply a rest parameter to.
             * @param {number} [start=func.length-1] The start position of the rest parameter.
             * @returns {Function} Returns the new function.
             * @example
             *
             * var say = _.rest(function(what, names) {
             *   return what + ' ' + _.initial(names).join(', ') +
             *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
             * });
             *
             * say('hello', 'fred', 'barney', 'pebbles');
             * // => 'hello fred, barney, & pebbles'
             */

            function rest(func, start) {
              if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              start = start === undefined ? start : toInteger(start);
              return baseRest(func, start);
            }
            /**
             * Creates a function that invokes `func` with the `this` binding of the
             * create function and an array of arguments much like
             * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
             *
             * **Note:** This method is based on the
             * [spread operator](https://mdn.io/spread_operator).
             *
             * @static
             * @memberOf _
             * @since 3.2.0
             * @category Function
             * @param {Function} func The function to spread arguments over.
             * @param {number} [start=0] The start position of the spread.
             * @returns {Function} Returns the new function.
             * @example
             *
             * var say = _.spread(function(who, what) {
             *   return who + ' says ' + what;
             * });
             *
             * say(['fred', 'hello']);
             * // => 'fred says hello'
             *
             * var numbers = Promise.all([
             *   Promise.resolve(40),
             *   Promise.resolve(36)
             * ]);
             *
             * numbers.then(_.spread(function(x, y) {
             *   return x + y;
             * }));
             * // => a Promise of 76
             */


            function spread(func, start) {
              if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              start = start == null ? 0 : nativeMax(toInteger(start), 0);
              return baseRest(function (args) {
                var array = args[start],
                    otherArgs = castSlice(args, 0, start);

                if (array) {
                  arrayPush(otherArgs, array);
                }

                return apply(func, this, otherArgs);
              });
            }
            /**
             * Creates a throttled function that only invokes `func` at most once per
             * every `wait` milliseconds. The throttled function comes with a `cancel`
             * method to cancel delayed `func` invocations and a `flush` method to
             * immediately invoke them. Provide `options` to indicate whether `func`
             * should be invoked on the leading and/or trailing edge of the `wait`
             * timeout. The `func` is invoked with the last arguments provided to the
             * throttled function. Subsequent calls to the throttled function return the
             * result of the last `func` invocation.
             *
             * **Note:** If `leading` and `trailing` options are `true`, `func` is
             * invoked on the trailing edge of the timeout only if the throttled function
             * is invoked more than once during the `wait` timeout.
             *
             * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
             * until to the next tick, similar to `setTimeout` with a timeout of `0`.
             *
             * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
             * for details over the differences between `_.throttle` and `_.debounce`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {Function} func The function to throttle.
             * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
             * @param {Object} [options={}] The options object.
             * @param {boolean} [options.leading=true]
             *  Specify invoking on the leading edge of the timeout.
             * @param {boolean} [options.trailing=true]
             *  Specify invoking on the trailing edge of the timeout.
             * @returns {Function} Returns the new throttled function.
             * @example
             *
             * // Avoid excessively updating the position while scrolling.
             * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
             *
             * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
             * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
             * jQuery(element).on('click', throttled);
             *
             * // Cancel the trailing throttled invocation.
             * jQuery(window).on('popstate', throttled.cancel);
             */


            function throttle(func, wait, options) {
              var leading = true,
                  trailing = true;

              if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }

              if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
              }

              return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
              });
            }
            /**
             * Creates a function that accepts up to one argument, ignoring any
             * additional arguments.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Function
             * @param {Function} func The function to cap arguments for.
             * @returns {Function} Returns the new capped function.
             * @example
             *
             * _.map(['6', '8', '10'], _.unary(parseInt));
             * // => [6, 8, 10]
             */


            function unary(func) {
              return ary(func, 1);
            }
            /**
             * Creates a function that provides `value` to `wrapper` as its first
             * argument. Any additional arguments provided to the function are appended
             * to those provided to the `wrapper`. The wrapper is invoked with the `this`
             * binding of the created function.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Function
             * @param {*} value The value to wrap.
             * @param {Function} [wrapper=identity] The wrapper function.
             * @returns {Function} Returns the new function.
             * @example
             *
             * var p = _.wrap(_.escape, function(func, text) {
             *   return '<p>' + func(text) + '</p>';
             * });
             *
             * p('fred, barney, & pebbles');
             * // => '<p>fred, barney, &amp; pebbles</p>'
             */


            function wrap(value, wrapper) {
              return partial(castFunction(wrapper), value);
            }
            /*------------------------------------------------------------------------*/

            /**
             * Casts `value` as an array if it's not one.
             *
             * @static
             * @memberOf _
             * @since 4.4.0
             * @category Lang
             * @param {*} value The value to inspect.
             * @returns {Array} Returns the cast array.
             * @example
             *
             * _.castArray(1);
             * // => [1]
             *
             * _.castArray({ 'a': 1 });
             * // => [{ 'a': 1 }]
             *
             * _.castArray('abc');
             * // => ['abc']
             *
             * _.castArray(null);
             * // => [null]
             *
             * _.castArray(undefined);
             * // => [undefined]
             *
             * _.castArray();
             * // => []
             *
             * var array = [1, 2, 3];
             * console.log(_.castArray(array) === array);
             * // => true
             */


            function castArray() {
              if (!arguments.length) {
                return [];
              }

              var value = arguments[0];
              return isArray(value) ? value : [value];
            }
            /**
             * Creates a shallow clone of `value`.
             *
             * **Note:** This method is loosely based on the
             * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
             * and supports cloning arrays, array buffers, booleans, date objects, maps,
             * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
             * arrays. The own enumerable properties of `arguments` objects are cloned
             * as plain objects. An empty object is returned for uncloneable values such
             * as error objects, functions, DOM nodes, and WeakMaps.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to clone.
             * @returns {*} Returns the cloned value.
             * @see _.cloneDeep
             * @example
             *
             * var objects = [{ 'a': 1 }, { 'b': 2 }];
             *
             * var shallow = _.clone(objects);
             * console.log(shallow[0] === objects[0]);
             * // => true
             */


            function clone(value) {
              return baseClone(value, CLONE_SYMBOLS_FLAG);
            }
            /**
             * This method is like `_.clone` except that it accepts `customizer` which
             * is invoked to produce the cloned value. If `customizer` returns `undefined`,
             * cloning is handled by the method instead. The `customizer` is invoked with
             * up to four arguments; (value [, index|key, object, stack]).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to clone.
             * @param {Function} [customizer] The function to customize cloning.
             * @returns {*} Returns the cloned value.
             * @see _.cloneDeepWith
             * @example
             *
             * function customizer(value) {
             *   if (_.isElement(value)) {
             *     return value.cloneNode(false);
             *   }
             * }
             *
             * var el = _.cloneWith(document.body, customizer);
             *
             * console.log(el === document.body);
             * // => false
             * console.log(el.nodeName);
             * // => 'BODY'
             * console.log(el.childNodes.length);
             * // => 0
             */


            function cloneWith(value, customizer) {
              customizer = typeof customizer == 'function' ? customizer : undefined;
              return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
            }
            /**
             * This method is like `_.clone` except that it recursively clones `value`.
             *
             * @static
             * @memberOf _
             * @since 1.0.0
             * @category Lang
             * @param {*} value The value to recursively clone.
             * @returns {*} Returns the deep cloned value.
             * @see _.clone
             * @example
             *
             * var objects = [{ 'a': 1 }, { 'b': 2 }];
             *
             * var deep = _.cloneDeep(objects);
             * console.log(deep[0] === objects[0]);
             * // => false
             */


            function cloneDeep(value) {
              return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
            }
            /**
             * This method is like `_.cloneWith` except that it recursively clones `value`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to recursively clone.
             * @param {Function} [customizer] The function to customize cloning.
             * @returns {*} Returns the deep cloned value.
             * @see _.cloneWith
             * @example
             *
             * function customizer(value) {
             *   if (_.isElement(value)) {
             *     return value.cloneNode(true);
             *   }
             * }
             *
             * var el = _.cloneDeepWith(document.body, customizer);
             *
             * console.log(el === document.body);
             * // => false
             * console.log(el.nodeName);
             * // => 'BODY'
             * console.log(el.childNodes.length);
             * // => 20
             */


            function cloneDeepWith(value, customizer) {
              customizer = typeof customizer == 'function' ? customizer : undefined;
              return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
            }
            /**
             * Checks if `object` conforms to `source` by invoking the predicate
             * properties of `source` with the corresponding property values of `object`.
             *
             * **Note:** This method is equivalent to `_.conforms` when `source` is
             * partially applied.
             *
             * @static
             * @memberOf _
             * @since 4.14.0
             * @category Lang
             * @param {Object} object The object to inspect.
             * @param {Object} source The object of property predicates to conform to.
             * @returns {boolean} Returns `true` if `object` conforms, else `false`.
             * @example
             *
             * var object = { 'a': 1, 'b': 2 };
             *
             * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
             * // => true
             *
             * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
             * // => false
             */


            function conformsTo(object, source) {
              return source == null || baseConformsTo(object, source, keys(source));
            }
            /**
             * Performs a
             * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
             * comparison between two values to determine if they are equivalent.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
             * @example
             *
             * var object = { 'a': 1 };
             * var other = { 'a': 1 };
             *
             * _.eq(object, object);
             * // => true
             *
             * _.eq(object, other);
             * // => false
             *
             * _.eq('a', 'a');
             * // => true
             *
             * _.eq('a', Object('a'));
             * // => false
             *
             * _.eq(NaN, NaN);
             * // => true
             */


            function eq(value, other) {
              return value === other || value !== value && other !== other;
            }
            /**
             * Checks if `value` is greater than `other`.
             *
             * @static
             * @memberOf _
             * @since 3.9.0
             * @category Lang
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if `value` is greater than `other`,
             *  else `false`.
             * @see _.lt
             * @example
             *
             * _.gt(3, 1);
             * // => true
             *
             * _.gt(3, 3);
             * // => false
             *
             * _.gt(1, 3);
             * // => false
             */


            var gt = createRelationalOperation(baseGt);
            /**
             * Checks if `value` is greater than or equal to `other`.
             *
             * @static
             * @memberOf _
             * @since 3.9.0
             * @category Lang
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if `value` is greater than or equal to
             *  `other`, else `false`.
             * @see _.lte
             * @example
             *
             * _.gte(3, 1);
             * // => true
             *
             * _.gte(3, 3);
             * // => true
             *
             * _.gte(1, 3);
             * // => false
             */

            var gte = createRelationalOperation(function (value, other) {
              return value >= other;
            });
            /**
             * Checks if `value` is likely an `arguments` object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an `arguments` object,
             *  else `false`.
             * @example
             *
             * _.isArguments(function() { return arguments; }());
             * // => true
             *
             * _.isArguments([1, 2, 3]);
             * // => false
             */

            var isArguments = baseIsArguments(function () {
              return arguments;
            }()) ? baseIsArguments : function (value) {
              return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
            };
            /**
             * Checks if `value` is classified as an `Array` object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an array, else `false`.
             * @example
             *
             * _.isArray([1, 2, 3]);
             * // => true
             *
             * _.isArray(document.body.children);
             * // => false
             *
             * _.isArray('abc');
             * // => false
             *
             * _.isArray(_.noop);
             * // => false
             */

            var isArray = Array.isArray;
            /**
             * Checks if `value` is classified as an `ArrayBuffer` object.
             *
             * @static
             * @memberOf _
             * @since 4.3.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
             * @example
             *
             * _.isArrayBuffer(new ArrayBuffer(2));
             * // => true
             *
             * _.isArrayBuffer(new Array(2));
             * // => false
             */

            var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
            /**
             * Checks if `value` is array-like. A value is considered array-like if it's
             * not a function and has a `value.length` that's an integer greater than or
             * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
             * @example
             *
             * _.isArrayLike([1, 2, 3]);
             * // => true
             *
             * _.isArrayLike(document.body.children);
             * // => true
             *
             * _.isArrayLike('abc');
             * // => true
             *
             * _.isArrayLike(_.noop);
             * // => false
             */

            function isArrayLike(value) {
              return value != null && isLength(value.length) && !isFunction(value);
            }
            /**
             * This method is like `_.isArrayLike` except that it also checks if `value`
             * is an object.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an array-like object,
             *  else `false`.
             * @example
             *
             * _.isArrayLikeObject([1, 2, 3]);
             * // => true
             *
             * _.isArrayLikeObject(document.body.children);
             * // => true
             *
             * _.isArrayLikeObject('abc');
             * // => false
             *
             * _.isArrayLikeObject(_.noop);
             * // => false
             */


            function isArrayLikeObject(value) {
              return isObjectLike(value) && isArrayLike(value);
            }
            /**
             * Checks if `value` is classified as a boolean primitive or object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
             * @example
             *
             * _.isBoolean(false);
             * // => true
             *
             * _.isBoolean(null);
             * // => false
             */


            function isBoolean(value) {
              return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
            }
            /**
             * Checks if `value` is a buffer.
             *
             * @static
             * @memberOf _
             * @since 4.3.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
             * @example
             *
             * _.isBuffer(new Buffer(2));
             * // => true
             *
             * _.isBuffer(new Uint8Array(2));
             * // => false
             */


            var isBuffer = nativeIsBuffer || stubFalse;
            /**
             * Checks if `value` is classified as a `Date` object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
             * @example
             *
             * _.isDate(new Date);
             * // => true
             *
             * _.isDate('Mon April 23 2012');
             * // => false
             */

            var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
            /**
             * Checks if `value` is likely a DOM element.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
             * @example
             *
             * _.isElement(document.body);
             * // => true
             *
             * _.isElement('<body>');
             * // => false
             */

            function isElement(value) {
              return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
            }
            /**
             * Checks if `value` is an empty object, collection, map, or set.
             *
             * Objects are considered empty if they have no own enumerable string keyed
             * properties.
             *
             * Array-like values such as `arguments` objects, arrays, buffers, strings, or
             * jQuery-like collections are considered empty if they have a `length` of `0`.
             * Similarly, maps and sets are considered empty if they have a `size` of `0`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is empty, else `false`.
             * @example
             *
             * _.isEmpty(null);
             * // => true
             *
             * _.isEmpty(true);
             * // => true
             *
             * _.isEmpty(1);
             * // => true
             *
             * _.isEmpty([1, 2, 3]);
             * // => false
             *
             * _.isEmpty({ 'a': 1 });
             * // => false
             */


            function isEmpty(value) {
              if (value == null) {
                return true;
              }

              if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
                return !value.length;
              }

              var tag = getTag(value);

              if (tag == mapTag || tag == setTag) {
                return !value.size;
              }

              if (isPrototype(value)) {
                return !baseKeys(value).length;
              }

              for (var key in value) {
                if (hasOwnProperty.call(value, key)) {
                  return false;
                }
              }

              return true;
            }
            /**
             * Performs a deep comparison between two values to determine if they are
             * equivalent.
             *
             * **Note:** This method supports comparing arrays, array buffers, booleans,
             * date objects, error objects, maps, numbers, `Object` objects, regexes,
             * sets, strings, symbols, and typed arrays. `Object` objects are compared
             * by their own, not inherited, enumerable properties. Functions and DOM
             * nodes are compared by strict equality, i.e. `===`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
             * @example
             *
             * var object = { 'a': 1 };
             * var other = { 'a': 1 };
             *
             * _.isEqual(object, other);
             * // => true
             *
             * object === other;
             * // => false
             */


            function isEqual(value, other) {
              return baseIsEqual(value, other);
            }
            /**
             * This method is like `_.isEqual` except that it accepts `customizer` which
             * is invoked to compare values. If `customizer` returns `undefined`, comparisons
             * are handled by the method instead. The `customizer` is invoked with up to
             * six arguments: (objValue, othValue [, index|key, object, other, stack]).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @param {Function} [customizer] The function to customize comparisons.
             * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
             * @example
             *
             * function isGreeting(value) {
             *   return /^h(?:i|ello)$/.test(value);
             * }
             *
             * function customizer(objValue, othValue) {
             *   if (isGreeting(objValue) && isGreeting(othValue)) {
             *     return true;
             *   }
             * }
             *
             * var array = ['hello', 'goodbye'];
             * var other = ['hi', 'goodbye'];
             *
             * _.isEqualWith(array, other, customizer);
             * // => true
             */


            function isEqualWith(value, other, customizer) {
              customizer = typeof customizer == 'function' ? customizer : undefined;
              var result = customizer ? customizer(value, other) : undefined;
              return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
            }
            /**
             * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
             * `SyntaxError`, `TypeError`, or `URIError` object.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
             * @example
             *
             * _.isError(new Error);
             * // => true
             *
             * _.isError(Error);
             * // => false
             */


            function isError(value) {
              if (!isObjectLike(value)) {
                return false;
              }

              var tag = baseGetTag(value);
              return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
            }
            /**
             * Checks if `value` is a finite primitive number.
             *
             * **Note:** This method is based on
             * [`Number.isFinite`](https://mdn.io/Number/isFinite).
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
             * @example
             *
             * _.isFinite(3);
             * // => true
             *
             * _.isFinite(Number.MIN_VALUE);
             * // => true
             *
             * _.isFinite(Infinity);
             * // => false
             *
             * _.isFinite('3');
             * // => false
             */


            function isFinite(value) {
              return typeof value == 'number' && nativeIsFinite(value);
            }
            /**
             * Checks if `value` is classified as a `Function` object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a function, else `false`.
             * @example
             *
             * _.isFunction(_);
             * // => true
             *
             * _.isFunction(/abc/);
             * // => false
             */


            function isFunction(value) {
              if (!isObject(value)) {
                return false;
              } // The use of `Object#toString` avoids issues with the `typeof` operator
              // in Safari 9 which returns 'object' for typed arrays and other constructors.


              var tag = baseGetTag(value);
              return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
            }
            /**
             * Checks if `value` is an integer.
             *
             * **Note:** This method is based on
             * [`Number.isInteger`](https://mdn.io/Number/isInteger).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
             * @example
             *
             * _.isInteger(3);
             * // => true
             *
             * _.isInteger(Number.MIN_VALUE);
             * // => false
             *
             * _.isInteger(Infinity);
             * // => false
             *
             * _.isInteger('3');
             * // => false
             */


            function isInteger(value) {
              return typeof value == 'number' && value == toInteger(value);
            }
            /**
             * Checks if `value` is a valid array-like length.
             *
             * **Note:** This method is loosely based on
             * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
             * @example
             *
             * _.isLength(3);
             * // => true
             *
             * _.isLength(Number.MIN_VALUE);
             * // => false
             *
             * _.isLength(Infinity);
             * // => false
             *
             * _.isLength('3');
             * // => false
             */


            function isLength(value) {
              return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
            }
            /**
             * Checks if `value` is the
             * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
             * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is an object, else `false`.
             * @example
             *
             * _.isObject({});
             * // => true
             *
             * _.isObject([1, 2, 3]);
             * // => true
             *
             * _.isObject(_.noop);
             * // => true
             *
             * _.isObject(null);
             * // => false
             */


            function isObject(value) {
              var type = typeof value;
              return value != null && (type == 'object' || type == 'function');
            }
            /**
             * Checks if `value` is object-like. A value is object-like if it's not `null`
             * and has a `typeof` result of "object".
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
             * @example
             *
             * _.isObjectLike({});
             * // => true
             *
             * _.isObjectLike([1, 2, 3]);
             * // => true
             *
             * _.isObjectLike(_.noop);
             * // => false
             *
             * _.isObjectLike(null);
             * // => false
             */


            function isObjectLike(value) {
              return value != null && typeof value == 'object';
            }
            /**
             * Checks if `value` is classified as a `Map` object.
             *
             * @static
             * @memberOf _
             * @since 4.3.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a map, else `false`.
             * @example
             *
             * _.isMap(new Map);
             * // => true
             *
             * _.isMap(new WeakMap);
             * // => false
             */


            var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
            /**
             * Performs a partial deep comparison between `object` and `source` to
             * determine if `object` contains equivalent property values.
             *
             * **Note:** This method is equivalent to `_.matches` when `source` is
             * partially applied.
             *
             * Partial comparisons will match empty array and empty object `source`
             * values against any array or object value, respectively. See `_.isEqual`
             * for a list of supported value comparisons.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Lang
             * @param {Object} object The object to inspect.
             * @param {Object} source The object of property values to match.
             * @returns {boolean} Returns `true` if `object` is a match, else `false`.
             * @example
             *
             * var object = { 'a': 1, 'b': 2 };
             *
             * _.isMatch(object, { 'b': 2 });
             * // => true
             *
             * _.isMatch(object, { 'b': 1 });
             * // => false
             */

            function isMatch(object, source) {
              return object === source || baseIsMatch(object, source, getMatchData(source));
            }
            /**
             * This method is like `_.isMatch` except that it accepts `customizer` which
             * is invoked to compare values. If `customizer` returns `undefined`, comparisons
             * are handled by the method instead. The `customizer` is invoked with five
             * arguments: (objValue, srcValue, index|key, object, source).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {Object} object The object to inspect.
             * @param {Object} source The object of property values to match.
             * @param {Function} [customizer] The function to customize comparisons.
             * @returns {boolean} Returns `true` if `object` is a match, else `false`.
             * @example
             *
             * function isGreeting(value) {
             *   return /^h(?:i|ello)$/.test(value);
             * }
             *
             * function customizer(objValue, srcValue) {
             *   if (isGreeting(objValue) && isGreeting(srcValue)) {
             *     return true;
             *   }
             * }
             *
             * var object = { 'greeting': 'hello' };
             * var source = { 'greeting': 'hi' };
             *
             * _.isMatchWith(object, source, customizer);
             * // => true
             */


            function isMatchWith(object, source, customizer) {
              customizer = typeof customizer == 'function' ? customizer : undefined;
              return baseIsMatch(object, source, getMatchData(source), customizer);
            }
            /**
             * Checks if `value` is `NaN`.
             *
             * **Note:** This method is based on
             * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
             * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
             * `undefined` and other non-number values.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
             * @example
             *
             * _.isNaN(NaN);
             * // => true
             *
             * _.isNaN(new Number(NaN));
             * // => true
             *
             * isNaN(undefined);
             * // => true
             *
             * _.isNaN(undefined);
             * // => false
             */


            function isNaN(value) {
              // An `NaN` primitive is the only value that is not equal to itself.
              // Perform the `toStringTag` check first to avoid errors with some
              // ActiveX objects in IE.
              return isNumber(value) && value != +value;
            }
            /**
             * Checks if `value` is a pristine native function.
             *
             * **Note:** This method can't reliably detect native functions in the presence
             * of the core-js package because core-js circumvents this kind of detection.
             * Despite multiple requests, the core-js maintainer has made it clear: any
             * attempt to fix the detection will be obstructed. As a result, we're left
             * with little choice but to throw an error. Unfortunately, this also affects
             * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
             * which rely on core-js.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a native function,
             *  else `false`.
             * @example
             *
             * _.isNative(Array.prototype.push);
             * // => true
             *
             * _.isNative(_);
             * // => false
             */


            function isNative(value) {
              if (isMaskable(value)) {
                throw new Error(CORE_ERROR_TEXT);
              }

              return baseIsNative(value);
            }
            /**
             * Checks if `value` is `null`.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
             * @example
             *
             * _.isNull(null);
             * // => true
             *
             * _.isNull(void 0);
             * // => false
             */


            function isNull(value) {
              return value === null;
            }
            /**
             * Checks if `value` is `null` or `undefined`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
             * @example
             *
             * _.isNil(null);
             * // => true
             *
             * _.isNil(void 0);
             * // => true
             *
             * _.isNil(NaN);
             * // => false
             */


            function isNil(value) {
              return value == null;
            }
            /**
             * Checks if `value` is classified as a `Number` primitive or object.
             *
             * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
             * classified as numbers, use the `_.isFinite` method.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a number, else `false`.
             * @example
             *
             * _.isNumber(3);
             * // => true
             *
             * _.isNumber(Number.MIN_VALUE);
             * // => true
             *
             * _.isNumber(Infinity);
             * // => true
             *
             * _.isNumber('3');
             * // => false
             */


            function isNumber(value) {
              return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
            }
            /**
             * Checks if `value` is a plain object, that is, an object created by the
             * `Object` constructor or one with a `[[Prototype]]` of `null`.
             *
             * @static
             * @memberOf _
             * @since 0.8.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             * }
             *
             * _.isPlainObject(new Foo);
             * // => false
             *
             * _.isPlainObject([1, 2, 3]);
             * // => false
             *
             * _.isPlainObject({ 'x': 0, 'y': 0 });
             * // => true
             *
             * _.isPlainObject(Object.create(null));
             * // => true
             */


            function isPlainObject(value) {
              if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
                return false;
              }

              var proto = getPrototype(value);

              if (proto === null) {
                return true;
              }

              var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
              return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
            }
            /**
             * Checks if `value` is classified as a `RegExp` object.
             *
             * @static
             * @memberOf _
             * @since 0.1.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
             * @example
             *
             * _.isRegExp(/abc/);
             * // => true
             *
             * _.isRegExp('/abc/');
             * // => false
             */


            var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
            /**
             * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
             * double precision number which isn't the result of a rounded unsafe integer.
             *
             * **Note:** This method is based on
             * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
             * @example
             *
             * _.isSafeInteger(3);
             * // => true
             *
             * _.isSafeInteger(Number.MIN_VALUE);
             * // => false
             *
             * _.isSafeInteger(Infinity);
             * // => false
             *
             * _.isSafeInteger('3');
             * // => false
             */

            function isSafeInteger(value) {
              return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
            }
            /**
             * Checks if `value` is classified as a `Set` object.
             *
             * @static
             * @memberOf _
             * @since 4.3.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a set, else `false`.
             * @example
             *
             * _.isSet(new Set);
             * // => true
             *
             * _.isSet(new WeakSet);
             * // => false
             */


            var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
            /**
             * Checks if `value` is classified as a `String` primitive or object.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a string, else `false`.
             * @example
             *
             * _.isString('abc');
             * // => true
             *
             * _.isString(1);
             * // => false
             */

            function isString(value) {
              return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
            }
            /**
             * Checks if `value` is classified as a `Symbol` primitive or object.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
             * @example
             *
             * _.isSymbol(Symbol.iterator);
             * // => true
             *
             * _.isSymbol('abc');
             * // => false
             */


            function isSymbol(value) {
              return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
            }
            /**
             * Checks if `value` is classified as a typed array.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
             * @example
             *
             * _.isTypedArray(new Uint8Array);
             * // => true
             *
             * _.isTypedArray([]);
             * // => false
             */


            var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
            /**
             * Checks if `value` is `undefined`.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
             * @example
             *
             * _.isUndefined(void 0);
             * // => true
             *
             * _.isUndefined(null);
             * // => false
             */

            function isUndefined(value) {
              return value === undefined;
            }
            /**
             * Checks if `value` is classified as a `WeakMap` object.
             *
             * @static
             * @memberOf _
             * @since 4.3.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
             * @example
             *
             * _.isWeakMap(new WeakMap);
             * // => true
             *
             * _.isWeakMap(new Map);
             * // => false
             */


            function isWeakMap(value) {
              return isObjectLike(value) && getTag(value) == weakMapTag;
            }
            /**
             * Checks if `value` is classified as a `WeakSet` object.
             *
             * @static
             * @memberOf _
             * @since 4.3.0
             * @category Lang
             * @param {*} value The value to check.
             * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
             * @example
             *
             * _.isWeakSet(new WeakSet);
             * // => true
             *
             * _.isWeakSet(new Set);
             * // => false
             */


            function isWeakSet(value) {
              return isObjectLike(value) && baseGetTag(value) == weakSetTag;
            }
            /**
             * Checks if `value` is less than `other`.
             *
             * @static
             * @memberOf _
             * @since 3.9.0
             * @category Lang
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if `value` is less than `other`,
             *  else `false`.
             * @see _.gt
             * @example
             *
             * _.lt(1, 3);
             * // => true
             *
             * _.lt(3, 3);
             * // => false
             *
             * _.lt(3, 1);
             * // => false
             */


            var lt = createRelationalOperation(baseLt);
            /**
             * Checks if `value` is less than or equal to `other`.
             *
             * @static
             * @memberOf _
             * @since 3.9.0
             * @category Lang
             * @param {*} value The value to compare.
             * @param {*} other The other value to compare.
             * @returns {boolean} Returns `true` if `value` is less than or equal to
             *  `other`, else `false`.
             * @see _.gte
             * @example
             *
             * _.lte(1, 3);
             * // => true
             *
             * _.lte(3, 3);
             * // => true
             *
             * _.lte(3, 1);
             * // => false
             */

            var lte = createRelationalOperation(function (value, other) {
              return value <= other;
            });
            /**
             * Converts `value` to an array.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Lang
             * @param {*} value The value to convert.
             * @returns {Array} Returns the converted array.
             * @example
             *
             * _.toArray({ 'a': 1, 'b': 2 });
             * // => [1, 2]
             *
             * _.toArray('abc');
             * // => ['a', 'b', 'c']
             *
             * _.toArray(1);
             * // => []
             *
             * _.toArray(null);
             * // => []
             */

            function toArray(value) {
              if (!value) {
                return [];
              }

              if (isArrayLike(value)) {
                return isString(value) ? stringToArray(value) : copyArray(value);
              }

              if (symIterator && value[symIterator]) {
                return iteratorToArray(value[symIterator]());
              }

              var tag = getTag(value),
                  func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
              return func(value);
            }
            /**
             * Converts `value` to a finite number.
             *
             * @static
             * @memberOf _
             * @since 4.12.0
             * @category Lang
             * @param {*} value The value to convert.
             * @returns {number} Returns the converted number.
             * @example
             *
             * _.toFinite(3.2);
             * // => 3.2
             *
             * _.toFinite(Number.MIN_VALUE);
             * // => 5e-324
             *
             * _.toFinite(Infinity);
             * // => 1.7976931348623157e+308
             *
             * _.toFinite('3.2');
             * // => 3.2
             */


            function toFinite(value) {
              if (!value) {
                return value === 0 ? value : 0;
              }

              value = toNumber(value);

              if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
              }

              return value === value ? value : 0;
            }
            /**
             * Converts `value` to an integer.
             *
             * **Note:** This method is loosely based on
             * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to convert.
             * @returns {number} Returns the converted integer.
             * @example
             *
             * _.toInteger(3.2);
             * // => 3
             *
             * _.toInteger(Number.MIN_VALUE);
             * // => 0
             *
             * _.toInteger(Infinity);
             * // => 1.7976931348623157e+308
             *
             * _.toInteger('3.2');
             * // => 3
             */


            function toInteger(value) {
              var result = toFinite(value),
                  remainder = result % 1;
              return result === result ? remainder ? result - remainder : result : 0;
            }
            /**
             * Converts `value` to an integer suitable for use as the length of an
             * array-like object.
             *
             * **Note:** This method is based on
             * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to convert.
             * @returns {number} Returns the converted integer.
             * @example
             *
             * _.toLength(3.2);
             * // => 3
             *
             * _.toLength(Number.MIN_VALUE);
             * // => 0
             *
             * _.toLength(Infinity);
             * // => 4294967295
             *
             * _.toLength('3.2');
             * // => 3
             */


            function toLength(value) {
              return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
            }
            /**
             * Converts `value` to a number.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to process.
             * @returns {number} Returns the number.
             * @example
             *
             * _.toNumber(3.2);
             * // => 3.2
             *
             * _.toNumber(Number.MIN_VALUE);
             * // => 5e-324
             *
             * _.toNumber(Infinity);
             * // => Infinity
             *
             * _.toNumber('3.2');
             * // => 3.2
             */


            function toNumber(value) {
              if (typeof value == 'number') {
                return value;
              }

              if (isSymbol(value)) {
                return NAN;
              }

              if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
              }

              if (typeof value != 'string') {
                return value === 0 ? value : +value;
              }

              value = value.replace(reTrim, '');
              var isBinary = reIsBinary.test(value);
              return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
            }
            /**
             * Converts `value` to a plain object flattening inherited enumerable string
             * keyed properties of `value` to own properties of the plain object.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Lang
             * @param {*} value The value to convert.
             * @returns {Object} Returns the converted plain object.
             * @example
             *
             * function Foo() {
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.assign({ 'a': 1 }, new Foo);
             * // => { 'a': 1, 'b': 2 }
             *
             * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
             * // => { 'a': 1, 'b': 2, 'c': 3 }
             */


            function toPlainObject(value) {
              return copyObject(value, keysIn(value));
            }
            /**
             * Converts `value` to a safe integer. A safe integer can be compared and
             * represented correctly.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to convert.
             * @returns {number} Returns the converted integer.
             * @example
             *
             * _.toSafeInteger(3.2);
             * // => 3
             *
             * _.toSafeInteger(Number.MIN_VALUE);
             * // => 0
             *
             * _.toSafeInteger(Infinity);
             * // => 9007199254740991
             *
             * _.toSafeInteger('3.2');
             * // => 3
             */


            function toSafeInteger(value) {
              return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
            }
            /**
             * Converts `value` to a string. An empty string is returned for `null`
             * and `undefined` values. The sign of `-0` is preserved.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Lang
             * @param {*} value The value to convert.
             * @returns {string} Returns the converted string.
             * @example
             *
             * _.toString(null);
             * // => ''
             *
             * _.toString(-0);
             * // => '-0'
             *
             * _.toString([1, 2, 3]);
             * // => '1,2,3'
             */


            function toString(value) {
              return value == null ? '' : baseToString(value);
            }
            /*------------------------------------------------------------------------*/

            /**
             * Assigns own enumerable string keyed properties of source objects to the
             * destination object. Source objects are applied from left to right.
             * Subsequent sources overwrite property assignments of previous sources.
             *
             * **Note:** This method mutates `object` and is loosely based on
             * [`Object.assign`](https://mdn.io/Object/assign).
             *
             * @static
             * @memberOf _
             * @since 0.10.0
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} [sources] The source objects.
             * @returns {Object} Returns `object`.
             * @see _.assignIn
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             * }
             *
             * function Bar() {
             *   this.c = 3;
             * }
             *
             * Foo.prototype.b = 2;
             * Bar.prototype.d = 4;
             *
             * _.assign({ 'a': 0 }, new Foo, new Bar);
             * // => { 'a': 1, 'c': 3 }
             */


            var assign = createAssigner(function (object, source) {
              if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
              }

              for (var key in source) {
                if (hasOwnProperty.call(source, key)) {
                  assignValue(object, key, source[key]);
                }
              }
            });
            /**
             * This method is like `_.assign` except that it iterates over own and
             * inherited source properties.
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @alias extend
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} [sources] The source objects.
             * @returns {Object} Returns `object`.
             * @see _.assign
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             * }
             *
             * function Bar() {
             *   this.c = 3;
             * }
             *
             * Foo.prototype.b = 2;
             * Bar.prototype.d = 4;
             *
             * _.assignIn({ 'a': 0 }, new Foo, new Bar);
             * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
             */

            var assignIn = createAssigner(function (object, source) {
              copyObject(source, keysIn(source), object);
            });
            /**
             * This method is like `_.assignIn` except that it accepts `customizer`
             * which is invoked to produce the assigned values. If `customizer` returns
             * `undefined`, assignment is handled by the method instead. The `customizer`
             * is invoked with five arguments: (objValue, srcValue, key, object, source).
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @alias extendWith
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} sources The source objects.
             * @param {Function} [customizer] The function to customize assigned values.
             * @returns {Object} Returns `object`.
             * @see _.assignWith
             * @example
             *
             * function customizer(objValue, srcValue) {
             *   return _.isUndefined(objValue) ? srcValue : objValue;
             * }
             *
             * var defaults = _.partialRight(_.assignInWith, customizer);
             *
             * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
             * // => { 'a': 1, 'b': 2 }
             */

            var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
              copyObject(source, keysIn(source), object, customizer);
            });
            /**
             * This method is like `_.assign` except that it accepts `customizer`
             * which is invoked to produce the assigned values. If `customizer` returns
             * `undefined`, assignment is handled by the method instead. The `customizer`
             * is invoked with five arguments: (objValue, srcValue, key, object, source).
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} sources The source objects.
             * @param {Function} [customizer] The function to customize assigned values.
             * @returns {Object} Returns `object`.
             * @see _.assignInWith
             * @example
             *
             * function customizer(objValue, srcValue) {
             *   return _.isUndefined(objValue) ? srcValue : objValue;
             * }
             *
             * var defaults = _.partialRight(_.assignWith, customizer);
             *
             * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
             * // => { 'a': 1, 'b': 2 }
             */

            var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
              copyObject(source, keys(source), object, customizer);
            });
            /**
             * Creates an array of values corresponding to `paths` of `object`.
             *
             * @static
             * @memberOf _
             * @since 1.0.0
             * @category Object
             * @param {Object} object The object to iterate over.
             * @param {...(string|string[])} [paths] The property paths to pick.
             * @returns {Array} Returns the picked values.
             * @example
             *
             * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
             *
             * _.at(object, ['a[0].b.c', 'a[1]']);
             * // => [3, 4]
             */

            var at = flatRest(baseAt);
            /**
             * Creates an object that inherits from the `prototype` object. If a
             * `properties` object is given, its own enumerable string keyed properties
             * are assigned to the created object.
             *
             * @static
             * @memberOf _
             * @since 2.3.0
             * @category Object
             * @param {Object} prototype The object to inherit from.
             * @param {Object} [properties] The properties to assign to the object.
             * @returns {Object} Returns the new object.
             * @example
             *
             * function Shape() {
             *   this.x = 0;
             *   this.y = 0;
             * }
             *
             * function Circle() {
             *   Shape.call(this);
             * }
             *
             * Circle.prototype = _.create(Shape.prototype, {
             *   'constructor': Circle
             * });
             *
             * var circle = new Circle;
             * circle instanceof Circle;
             * // => true
             *
             * circle instanceof Shape;
             * // => true
             */

            function create(prototype, properties) {
              var result = baseCreate(prototype);
              return properties == null ? result : baseAssign(result, properties);
            }
            /**
             * Assigns own and inherited enumerable string keyed properties of source
             * objects to the destination object for all destination properties that
             * resolve to `undefined`. Source objects are applied from left to right.
             * Once a property is set, additional values of the same property are ignored.
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} [sources] The source objects.
             * @returns {Object} Returns `object`.
             * @see _.defaultsDeep
             * @example
             *
             * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
             * // => { 'a': 1, 'b': 2 }
             */


            var defaults = baseRest(function (object, sources) {
              object = Object(object);
              var index = -1;
              var length = sources.length;
              var guard = length > 2 ? sources[2] : undefined;

              if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                length = 1;
              }

              while (++index < length) {
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;

                while (++propsIndex < propsLength) {
                  var key = props[propsIndex];
                  var value = object[key];

                  if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                    object[key] = source[key];
                  }
                }
              }

              return object;
            });
            /**
             * This method is like `_.defaults` except that it recursively assigns
             * default properties.
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 3.10.0
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} [sources] The source objects.
             * @returns {Object} Returns `object`.
             * @see _.defaults
             * @example
             *
             * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
             * // => { 'a': { 'b': 2, 'c': 3 } }
             */

            var defaultsDeep = baseRest(function (args) {
              args.push(undefined, customDefaultsMerge);
              return apply(mergeWith, undefined, args);
            });
            /**
             * This method is like `_.find` except that it returns the key of the first
             * element `predicate` returns truthy for instead of the element itself.
             *
             * @static
             * @memberOf _
             * @since 1.1.0
             * @category Object
             * @param {Object} object The object to inspect.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {string|undefined} Returns the key of the matched element,
             *  else `undefined`.
             * @example
             *
             * var users = {
             *   'barney':  { 'age': 36, 'active': true },
             *   'fred':    { 'age': 40, 'active': false },
             *   'pebbles': { 'age': 1,  'active': true }
             * };
             *
             * _.findKey(users, function(o) { return o.age < 40; });
             * // => 'barney' (iteration order is not guaranteed)
             *
             * // The `_.matches` iteratee shorthand.
             * _.findKey(users, { 'age': 1, 'active': true });
             * // => 'pebbles'
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.findKey(users, ['active', false]);
             * // => 'fred'
             *
             * // The `_.property` iteratee shorthand.
             * _.findKey(users, 'active');
             * // => 'barney'
             */

            function findKey(object, predicate) {
              return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
            }
            /**
             * This method is like `_.findKey` except that it iterates over elements of
             * a collection in the opposite order.
             *
             * @static
             * @memberOf _
             * @since 2.0.0
             * @category Object
             * @param {Object} object The object to inspect.
             * @param {Function} [predicate=_.identity] The function invoked per iteration.
             * @returns {string|undefined} Returns the key of the matched element,
             *  else `undefined`.
             * @example
             *
             * var users = {
             *   'barney':  { 'age': 36, 'active': true },
             *   'fred':    { 'age': 40, 'active': false },
             *   'pebbles': { 'age': 1,  'active': true }
             * };
             *
             * _.findLastKey(users, function(o) { return o.age < 40; });
             * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
             *
             * // The `_.matches` iteratee shorthand.
             * _.findLastKey(users, { 'age': 36, 'active': true });
             * // => 'barney'
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.findLastKey(users, ['active', false]);
             * // => 'fred'
             *
             * // The `_.property` iteratee shorthand.
             * _.findLastKey(users, 'active');
             * // => 'pebbles'
             */


            function findLastKey(object, predicate) {
              return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
            }
            /**
             * Iterates over own and inherited enumerable string keyed properties of an
             * object and invokes `iteratee` for each property. The iteratee is invoked
             * with three arguments: (value, key, object). Iteratee functions may exit
             * iteration early by explicitly returning `false`.
             *
             * @static
             * @memberOf _
             * @since 0.3.0
             * @category Object
             * @param {Object} object The object to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Object} Returns `object`.
             * @see _.forInRight
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.forIn(new Foo, function(value, key) {
             *   console.log(key);
             * });
             * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
             */


            function forIn(object, iteratee) {
              return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
            }
            /**
             * This method is like `_.forIn` except that it iterates over properties of
             * `object` in the opposite order.
             *
             * @static
             * @memberOf _
             * @since 2.0.0
             * @category Object
             * @param {Object} object The object to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Object} Returns `object`.
             * @see _.forIn
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.forInRight(new Foo, function(value, key) {
             *   console.log(key);
             * });
             * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
             */


            function forInRight(object, iteratee) {
              return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
            }
            /**
             * Iterates over own enumerable string keyed properties of an object and
             * invokes `iteratee` for each property. The iteratee is invoked with three
             * arguments: (value, key, object). Iteratee functions may exit iteration
             * early by explicitly returning `false`.
             *
             * @static
             * @memberOf _
             * @since 0.3.0
             * @category Object
             * @param {Object} object The object to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Object} Returns `object`.
             * @see _.forOwnRight
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.forOwn(new Foo, function(value, key) {
             *   console.log(key);
             * });
             * // => Logs 'a' then 'b' (iteration order is not guaranteed).
             */


            function forOwn(object, iteratee) {
              return object && baseForOwn(object, getIteratee(iteratee, 3));
            }
            /**
             * This method is like `_.forOwn` except that it iterates over properties of
             * `object` in the opposite order.
             *
             * @static
             * @memberOf _
             * @since 2.0.0
             * @category Object
             * @param {Object} object The object to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Object} Returns `object`.
             * @see _.forOwn
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.forOwnRight(new Foo, function(value, key) {
             *   console.log(key);
             * });
             * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
             */


            function forOwnRight(object, iteratee) {
              return object && baseForOwnRight(object, getIteratee(iteratee, 3));
            }
            /**
             * Creates an array of function property names from own enumerable properties
             * of `object`.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The object to inspect.
             * @returns {Array} Returns the function names.
             * @see _.functionsIn
             * @example
             *
             * function Foo() {
             *   this.a = _.constant('a');
             *   this.b = _.constant('b');
             * }
             *
             * Foo.prototype.c = _.constant('c');
             *
             * _.functions(new Foo);
             * // => ['a', 'b']
             */


            function functions(object) {
              return object == null ? [] : baseFunctions(object, keys(object));
            }
            /**
             * Creates an array of function property names from own and inherited
             * enumerable properties of `object`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Object
             * @param {Object} object The object to inspect.
             * @returns {Array} Returns the function names.
             * @see _.functions
             * @example
             *
             * function Foo() {
             *   this.a = _.constant('a');
             *   this.b = _.constant('b');
             * }
             *
             * Foo.prototype.c = _.constant('c');
             *
             * _.functionsIn(new Foo);
             * // => ['a', 'b', 'c']
             */


            function functionsIn(object) {
              return object == null ? [] : baseFunctions(object, keysIn(object));
            }
            /**
             * Gets the value at `path` of `object`. If the resolved value is
             * `undefined`, the `defaultValue` is returned in its place.
             *
             * @static
             * @memberOf _
             * @since 3.7.0
             * @category Object
             * @param {Object} object The object to query.
             * @param {Array|string} path The path of the property to get.
             * @param {*} [defaultValue] The value returned for `undefined` resolved values.
             * @returns {*} Returns the resolved value.
             * @example
             *
             * var object = { 'a': [{ 'b': { 'c': 3 } }] };
             *
             * _.get(object, 'a[0].b.c');
             * // => 3
             *
             * _.get(object, ['a', '0', 'b', 'c']);
             * // => 3
             *
             * _.get(object, 'a.b.c', 'default');
             * // => 'default'
             */


            function get(object, path, defaultValue) {
              var result = object == null ? undefined : baseGet(object, path);
              return result === undefined ? defaultValue : result;
            }
            /**
             * Checks if `path` is a direct property of `object`.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The object to query.
             * @param {Array|string} path The path to check.
             * @returns {boolean} Returns `true` if `path` exists, else `false`.
             * @example
             *
             * var object = { 'a': { 'b': 2 } };
             * var other = _.create({ 'a': _.create({ 'b': 2 }) });
             *
             * _.has(object, 'a');
             * // => true
             *
             * _.has(object, 'a.b');
             * // => true
             *
             * _.has(object, ['a', 'b']);
             * // => true
             *
             * _.has(other, 'a');
             * // => false
             */


            function has(object, path) {
              return object != null && hasPath(object, path, baseHas);
            }
            /**
             * Checks if `path` is a direct or inherited property of `object`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Object
             * @param {Object} object The object to query.
             * @param {Array|string} path The path to check.
             * @returns {boolean} Returns `true` if `path` exists, else `false`.
             * @example
             *
             * var object = _.create({ 'a': _.create({ 'b': 2 }) });
             *
             * _.hasIn(object, 'a');
             * // => true
             *
             * _.hasIn(object, 'a.b');
             * // => true
             *
             * _.hasIn(object, ['a', 'b']);
             * // => true
             *
             * _.hasIn(object, 'b');
             * // => false
             */


            function hasIn(object, path) {
              return object != null && hasPath(object, path, baseHasIn);
            }
            /**
             * Creates an object composed of the inverted keys and values of `object`.
             * If `object` contains duplicate values, subsequent values overwrite
             * property assignments of previous values.
             *
             * @static
             * @memberOf _
             * @since 0.7.0
             * @category Object
             * @param {Object} object The object to invert.
             * @returns {Object} Returns the new inverted object.
             * @example
             *
             * var object = { 'a': 1, 'b': 2, 'c': 1 };
             *
             * _.invert(object);
             * // => { '1': 'c', '2': 'b' }
             */


            var invert = createInverter(function (result, value, key) {
              if (value != null && typeof value.toString != 'function') {
                value = nativeObjectToString.call(value);
              }

              result[value] = key;
            }, constant(identity));
            /**
             * This method is like `_.invert` except that the inverted object is generated
             * from the results of running each element of `object` thru `iteratee`. The
             * corresponding inverted value of each inverted key is an array of keys
             * responsible for generating the inverted value. The iteratee is invoked
             * with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 4.1.0
             * @category Object
             * @param {Object} object The object to invert.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {Object} Returns the new inverted object.
             * @example
             *
             * var object = { 'a': 1, 'b': 2, 'c': 1 };
             *
             * _.invertBy(object);
             * // => { '1': ['a', 'c'], '2': ['b'] }
             *
             * _.invertBy(object, function(value) {
             *   return 'group' + value;
             * });
             * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
             */

            var invertBy = createInverter(function (result, value, key) {
              if (value != null && typeof value.toString != 'function') {
                value = nativeObjectToString.call(value);
              }

              if (hasOwnProperty.call(result, value)) {
                result[value].push(key);
              } else {
                result[value] = [key];
              }
            }, getIteratee);
            /**
             * Invokes the method at `path` of `object`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Object
             * @param {Object} object The object to query.
             * @param {Array|string} path The path of the method to invoke.
             * @param {...*} [args] The arguments to invoke the method with.
             * @returns {*} Returns the result of the invoked method.
             * @example
             *
             * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
             *
             * _.invoke(object, 'a[0].b.c.slice', 1, 3);
             * // => [2, 3]
             */

            var invoke = baseRest(baseInvoke);
            /**
             * Creates an array of the own enumerable property names of `object`.
             *
             * **Note:** Non-object values are coerced to objects. See the
             * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
             * for more details.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property names.
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.keys(new Foo);
             * // => ['a', 'b'] (iteration order is not guaranteed)
             *
             * _.keys('hi');
             * // => ['0', '1']
             */

            function keys(object) {
              return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
            }
            /**
             * Creates an array of the own and inherited enumerable property names of `object`.
             *
             * **Note:** Non-object values are coerced to objects.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Object
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property names.
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.keysIn(new Foo);
             * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
             */


            function keysIn(object) {
              return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
            }
            /**
             * The opposite of `_.mapValues`; this method creates an object with the
             * same values as `object` and keys generated by running each own enumerable
             * string keyed property of `object` thru `iteratee`. The iteratee is invoked
             * with three arguments: (value, key, object).
             *
             * @static
             * @memberOf _
             * @since 3.8.0
             * @category Object
             * @param {Object} object The object to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Object} Returns the new mapped object.
             * @see _.mapValues
             * @example
             *
             * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
             *   return key + value;
             * });
             * // => { 'a1': 1, 'b2': 2 }
             */


            function mapKeys(object, iteratee) {
              var result = {};
              iteratee = getIteratee(iteratee, 3);
              baseForOwn(object, function (value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
              });
              return result;
            }
            /**
             * Creates an object with the same keys as `object` and values generated
             * by running each own enumerable string keyed property of `object` thru
             * `iteratee`. The iteratee is invoked with three arguments:
             * (value, key, object).
             *
             * @static
             * @memberOf _
             * @since 2.4.0
             * @category Object
             * @param {Object} object The object to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Object} Returns the new mapped object.
             * @see _.mapKeys
             * @example
             *
             * var users = {
             *   'fred':    { 'user': 'fred',    'age': 40 },
             *   'pebbles': { 'user': 'pebbles', 'age': 1 }
             * };
             *
             * _.mapValues(users, function(o) { return o.age; });
             * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
             *
             * // The `_.property` iteratee shorthand.
             * _.mapValues(users, 'age');
             * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
             */


            function mapValues(object, iteratee) {
              var result = {};
              iteratee = getIteratee(iteratee, 3);
              baseForOwn(object, function (value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
              });
              return result;
            }
            /**
             * This method is like `_.assign` except that it recursively merges own and
             * inherited enumerable string keyed properties of source objects into the
             * destination object. Source properties that resolve to `undefined` are
             * skipped if a destination value exists. Array and plain object properties
             * are merged recursively. Other objects and value types are overridden by
             * assignment. Source objects are applied from left to right. Subsequent
             * sources overwrite property assignments of previous sources.
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 0.5.0
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} [sources] The source objects.
             * @returns {Object} Returns `object`.
             * @example
             *
             * var object = {
             *   'a': [{ 'b': 2 }, { 'd': 4 }]
             * };
             *
             * var other = {
             *   'a': [{ 'c': 3 }, { 'e': 5 }]
             * };
             *
             * _.merge(object, other);
             * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
             */


            var merge = createAssigner(function (object, source, srcIndex) {
              baseMerge(object, source, srcIndex);
            });
            /**
             * This method is like `_.merge` except that it accepts `customizer` which
             * is invoked to produce the merged values of the destination and source
             * properties. If `customizer` returns `undefined`, merging is handled by the
             * method instead. The `customizer` is invoked with six arguments:
             * (objValue, srcValue, key, object, source, stack).
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Object
             * @param {Object} object The destination object.
             * @param {...Object} sources The source objects.
             * @param {Function} customizer The function to customize assigned values.
             * @returns {Object} Returns `object`.
             * @example
             *
             * function customizer(objValue, srcValue) {
             *   if (_.isArray(objValue)) {
             *     return objValue.concat(srcValue);
             *   }
             * }
             *
             * var object = { 'a': [1], 'b': [2] };
             * var other = { 'a': [3], 'b': [4] };
             *
             * _.mergeWith(object, other, customizer);
             * // => { 'a': [1, 3], 'b': [2, 4] }
             */

            var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
              baseMerge(object, source, srcIndex, customizer);
            });
            /**
             * The opposite of `_.pick`; this method creates an object composed of the
             * own and inherited enumerable property paths of `object` that are not omitted.
             *
             * **Note:** This method is considerably slower than `_.pick`.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The source object.
             * @param {...(string|string[])} [paths] The property paths to omit.
             * @returns {Object} Returns the new object.
             * @example
             *
             * var object = { 'a': 1, 'b': '2', 'c': 3 };
             *
             * _.omit(object, ['a', 'c']);
             * // => { 'b': '2' }
             */

            var omit = flatRest(function (object, paths) {
              var result = {};

              if (object == null) {
                return result;
              }

              var isDeep = false;
              paths = arrayMap(paths, function (path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
              });
              copyObject(object, getAllKeysIn(object), result);

              if (isDeep) {
                result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
              }

              var length = paths.length;

              while (length--) {
                baseUnset(result, paths[length]);
              }

              return result;
            });
            /**
             * The opposite of `_.pickBy`; this method creates an object composed of
             * the own and inherited enumerable string keyed properties of `object` that
             * `predicate` doesn't return truthy for. The predicate is invoked with two
             * arguments: (value, key).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Object
             * @param {Object} object The source object.
             * @param {Function} [predicate=_.identity] The function invoked per property.
             * @returns {Object} Returns the new object.
             * @example
             *
             * var object = { 'a': 1, 'b': '2', 'c': 3 };
             *
             * _.omitBy(object, _.isNumber);
             * // => { 'b': '2' }
             */

            function omitBy(object, predicate) {
              return pickBy(object, negate(getIteratee(predicate)));
            }
            /**
             * Creates an object composed of the picked `object` properties.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The source object.
             * @param {...(string|string[])} [paths] The property paths to pick.
             * @returns {Object} Returns the new object.
             * @example
             *
             * var object = { 'a': 1, 'b': '2', 'c': 3 };
             *
             * _.pick(object, ['a', 'c']);
             * // => { 'a': 1, 'c': 3 }
             */


            var pick = flatRest(function (object, paths) {
              return object == null ? {} : basePick(object, paths);
            });
            /**
             * Creates an object composed of the `object` properties `predicate` returns
             * truthy for. The predicate is invoked with two arguments: (value, key).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Object
             * @param {Object} object The source object.
             * @param {Function} [predicate=_.identity] The function invoked per property.
             * @returns {Object} Returns the new object.
             * @example
             *
             * var object = { 'a': 1, 'b': '2', 'c': 3 };
             *
             * _.pickBy(object, _.isNumber);
             * // => { 'a': 1, 'c': 3 }
             */

            function pickBy(object, predicate) {
              if (object == null) {
                return {};
              }

              var props = arrayMap(getAllKeysIn(object), function (prop) {
                return [prop];
              });
              predicate = getIteratee(predicate);
              return basePickBy(object, props, function (value, path) {
                return predicate(value, path[0]);
              });
            }
            /**
             * This method is like `_.get` except that if the resolved value is a
             * function it's invoked with the `this` binding of its parent object and
             * its result is returned.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The object to query.
             * @param {Array|string} path The path of the property to resolve.
             * @param {*} [defaultValue] The value returned for `undefined` resolved values.
             * @returns {*} Returns the resolved value.
             * @example
             *
             * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
             *
             * _.result(object, 'a[0].b.c1');
             * // => 3
             *
             * _.result(object, 'a[0].b.c2');
             * // => 4
             *
             * _.result(object, 'a[0].b.c3', 'default');
             * // => 'default'
             *
             * _.result(object, 'a[0].b.c3', _.constant('default'));
             * // => 'default'
             */


            function result(object, path, defaultValue) {
              path = castPath(path, object);
              var index = -1,
                  length = path.length; // Ensure the loop is entered when path is empty.

              if (!length) {
                length = 1;
                object = undefined;
              }

              while (++index < length) {
                var value = object == null ? undefined : object[toKey(path[index])];

                if (value === undefined) {
                  index = length;
                  value = defaultValue;
                }

                object = isFunction(value) ? value.call(object) : value;
              }

              return object;
            }
            /**
             * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
             * it's created. Arrays are created for missing index properties while objects
             * are created for all other missing properties. Use `_.setWith` to customize
             * `path` creation.
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 3.7.0
             * @category Object
             * @param {Object} object The object to modify.
             * @param {Array|string} path The path of the property to set.
             * @param {*} value The value to set.
             * @returns {Object} Returns `object`.
             * @example
             *
             * var object = { 'a': [{ 'b': { 'c': 3 } }] };
             *
             * _.set(object, 'a[0].b.c', 4);
             * console.log(object.a[0].b.c);
             * // => 4
             *
             * _.set(object, ['x', '0', 'y', 'z'], 5);
             * console.log(object.x[0].y.z);
             * // => 5
             */


            function set(object, path, value) {
              return object == null ? object : baseSet(object, path, value);
            }
            /**
             * This method is like `_.set` except that it accepts `customizer` which is
             * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
             * path creation is handled by the method instead. The `customizer` is invoked
             * with three arguments: (nsValue, key, nsObject).
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Object
             * @param {Object} object The object to modify.
             * @param {Array|string} path The path of the property to set.
             * @param {*} value The value to set.
             * @param {Function} [customizer] The function to customize assigned values.
             * @returns {Object} Returns `object`.
             * @example
             *
             * var object = {};
             *
             * _.setWith(object, '[0][1]', 'a', Object);
             * // => { '0': { '1': 'a' } }
             */


            function setWith(object, path, value, customizer) {
              customizer = typeof customizer == 'function' ? customizer : undefined;
              return object == null ? object : baseSet(object, path, value, customizer);
            }
            /**
             * Creates an array of own enumerable string keyed-value pairs for `object`
             * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
             * entries are returned.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @alias entries
             * @category Object
             * @param {Object} object The object to query.
             * @returns {Array} Returns the key-value pairs.
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.toPairs(new Foo);
             * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
             */


            var toPairs = createToPairs(keys);
            /**
             * Creates an array of own and inherited enumerable string keyed-value pairs
             * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
             * or set, its entries are returned.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @alias entriesIn
             * @category Object
             * @param {Object} object The object to query.
             * @returns {Array} Returns the key-value pairs.
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.toPairsIn(new Foo);
             * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
             */

            var toPairsIn = createToPairs(keysIn);
            /**
             * An alternative to `_.reduce`; this method transforms `object` to a new
             * `accumulator` object which is the result of running each of its own
             * enumerable string keyed properties thru `iteratee`, with each invocation
             * potentially mutating the `accumulator` object. If `accumulator` is not
             * provided, a new object with the same `[[Prototype]]` will be used. The
             * iteratee is invoked with four arguments: (accumulator, value, key, object).
             * Iteratee functions may exit iteration early by explicitly returning `false`.
             *
             * @static
             * @memberOf _
             * @since 1.3.0
             * @category Object
             * @param {Object} object The object to iterate over.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @param {*} [accumulator] The custom accumulator value.
             * @returns {*} Returns the accumulated value.
             * @example
             *
             * _.transform([2, 3, 4], function(result, n) {
             *   result.push(n *= n);
             *   return n % 2 == 0;
             * }, []);
             * // => [4, 9]
             *
             * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
             *   (result[value] || (result[value] = [])).push(key);
             * }, {});
             * // => { '1': ['a', 'c'], '2': ['b'] }
             */

            function transform(object, iteratee, accumulator) {
              var isArr = isArray(object),
                  isArrLike = isArr || isBuffer(object) || isTypedArray(object);
              iteratee = getIteratee(iteratee, 4);

              if (accumulator == null) {
                var Ctor = object && object.constructor;

                if (isArrLike) {
                  accumulator = isArr ? new Ctor() : [];
                } else if (isObject(object)) {
                  accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                } else {
                  accumulator = {};
                }
              }

              (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
                return iteratee(accumulator, value, index, object);
              });
              return accumulator;
            }
            /**
             * Removes the property at `path` of `object`.
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Object
             * @param {Object} object The object to modify.
             * @param {Array|string} path The path of the property to unset.
             * @returns {boolean} Returns `true` if the property is deleted, else `false`.
             * @example
             *
             * var object = { 'a': [{ 'b': { 'c': 7 } }] };
             * _.unset(object, 'a[0].b.c');
             * // => true
             *
             * console.log(object);
             * // => { 'a': [{ 'b': {} }] };
             *
             * _.unset(object, ['a', '0', 'b', 'c']);
             * // => true
             *
             * console.log(object);
             * // => { 'a': [{ 'b': {} }] };
             */


            function unset(object, path) {
              return object == null ? true : baseUnset(object, path);
            }
            /**
             * This method is like `_.set` except that accepts `updater` to produce the
             * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
             * is invoked with one argument: (value).
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 4.6.0
             * @category Object
             * @param {Object} object The object to modify.
             * @param {Array|string} path The path of the property to set.
             * @param {Function} updater The function to produce the updated value.
             * @returns {Object} Returns `object`.
             * @example
             *
             * var object = { 'a': [{ 'b': { 'c': 3 } }] };
             *
             * _.update(object, 'a[0].b.c', function(n) { return n * n; });
             * console.log(object.a[0].b.c);
             * // => 9
             *
             * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
             * console.log(object.x[0].y.z);
             * // => 0
             */


            function update(object, path, updater) {
              return object == null ? object : baseUpdate(object, path, castFunction(updater));
            }
            /**
             * This method is like `_.update` except that it accepts `customizer` which is
             * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
             * path creation is handled by the method instead. The `customizer` is invoked
             * with three arguments: (nsValue, key, nsObject).
             *
             * **Note:** This method mutates `object`.
             *
             * @static
             * @memberOf _
             * @since 4.6.0
             * @category Object
             * @param {Object} object The object to modify.
             * @param {Array|string} path The path of the property to set.
             * @param {Function} updater The function to produce the updated value.
             * @param {Function} [customizer] The function to customize assigned values.
             * @returns {Object} Returns `object`.
             * @example
             *
             * var object = {};
             *
             * _.updateWith(object, '[0][1]', _.constant('a'), Object);
             * // => { '0': { '1': 'a' } }
             */


            function updateWith(object, path, updater, customizer) {
              customizer = typeof customizer == 'function' ? customizer : undefined;
              return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
            }
            /**
             * Creates an array of the own enumerable string keyed property values of `object`.
             *
             * **Note:** Non-object values are coerced to objects.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Object
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property values.
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.values(new Foo);
             * // => [1, 2] (iteration order is not guaranteed)
             *
             * _.values('hi');
             * // => ['h', 'i']
             */


            function values(object) {
              return object == null ? [] : baseValues(object, keys(object));
            }
            /**
             * Creates an array of the own and inherited enumerable string keyed property
             * values of `object`.
             *
             * **Note:** Non-object values are coerced to objects.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Object
             * @param {Object} object The object to query.
             * @returns {Array} Returns the array of property values.
             * @example
             *
             * function Foo() {
             *   this.a = 1;
             *   this.b = 2;
             * }
             *
             * Foo.prototype.c = 3;
             *
             * _.valuesIn(new Foo);
             * // => [1, 2, 3] (iteration order is not guaranteed)
             */


            function valuesIn(object) {
              return object == null ? [] : baseValues(object, keysIn(object));
            }
            /*------------------------------------------------------------------------*/

            /**
             * Clamps `number` within the inclusive `lower` and `upper` bounds.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Number
             * @param {number} number The number to clamp.
             * @param {number} [lower] The lower bound.
             * @param {number} upper The upper bound.
             * @returns {number} Returns the clamped number.
             * @example
             *
             * _.clamp(-10, -5, 5);
             * // => -5
             *
             * _.clamp(10, -5, 5);
             * // => 5
             */


            function clamp(number, lower, upper) {
              if (upper === undefined) {
                upper = lower;
                lower = undefined;
              }

              if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
              }

              if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
              }

              return baseClamp(toNumber(number), lower, upper);
            }
            /**
             * Checks if `n` is between `start` and up to, but not including, `end`. If
             * `end` is not specified, it's set to `start` with `start` then set to `0`.
             * If `start` is greater than `end` the params are swapped to support
             * negative ranges.
             *
             * @static
             * @memberOf _
             * @since 3.3.0
             * @category Number
             * @param {number} number The number to check.
             * @param {number} [start=0] The start of the range.
             * @param {number} end The end of the range.
             * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
             * @see _.range, _.rangeRight
             * @example
             *
             * _.inRange(3, 2, 4);
             * // => true
             *
             * _.inRange(4, 8);
             * // => true
             *
             * _.inRange(4, 2);
             * // => false
             *
             * _.inRange(2, 2);
             * // => false
             *
             * _.inRange(1.2, 2);
             * // => true
             *
             * _.inRange(5.2, 4);
             * // => false
             *
             * _.inRange(-3, -2, -6);
             * // => true
             */


            function inRange(number, start, end) {
              start = toFinite(start);

              if (end === undefined) {
                end = start;
                start = 0;
              } else {
                end = toFinite(end);
              }

              number = toNumber(number);
              return baseInRange(number, start, end);
            }
            /**
             * Produces a random number between the inclusive `lower` and `upper` bounds.
             * If only one argument is provided a number between `0` and the given number
             * is returned. If `floating` is `true`, or either `lower` or `upper` are
             * floats, a floating-point number is returned instead of an integer.
             *
             * **Note:** JavaScript follows the IEEE-754 standard for resolving
             * floating-point values which can produce unexpected results.
             *
             * @static
             * @memberOf _
             * @since 0.7.0
             * @category Number
             * @param {number} [lower=0] The lower bound.
             * @param {number} [upper=1] The upper bound.
             * @param {boolean} [floating] Specify returning a floating-point number.
             * @returns {number} Returns the random number.
             * @example
             *
             * _.random(0, 5);
             * // => an integer between 0 and 5
             *
             * _.random(5);
             * // => also an integer between 0 and 5
             *
             * _.random(5, true);
             * // => a floating-point number between 0 and 5
             *
             * _.random(1.2, 5.2);
             * // => a floating-point number between 1.2 and 5.2
             */


            function random(lower, upper, floating) {
              if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
                upper = floating = undefined;
              }

              if (floating === undefined) {
                if (typeof upper == 'boolean') {
                  floating = upper;
                  upper = undefined;
                } else if (typeof lower == 'boolean') {
                  floating = lower;
                  lower = undefined;
                }
              }

              if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
              } else {
                lower = toFinite(lower);

                if (upper === undefined) {
                  upper = lower;
                  lower = 0;
                } else {
                  upper = toFinite(upper);
                }
              }

              if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
              }

              if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
              }

              return baseRandom(lower, upper);
            }
            /*------------------------------------------------------------------------*/

            /**
             * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to convert.
             * @returns {string} Returns the camel cased string.
             * @example
             *
             * _.camelCase('Foo Bar');
             * // => 'fooBar'
             *
             * _.camelCase('--foo-bar--');
             * // => 'fooBar'
             *
             * _.camelCase('__FOO_BAR__');
             * // => 'fooBar'
             */


            var camelCase = createCompounder(function (result, word, index) {
              word = word.toLowerCase();
              return result + (index ? capitalize(word) : word);
            });
            /**
             * Converts the first character of `string` to upper case and the remaining
             * to lower case.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to capitalize.
             * @returns {string} Returns the capitalized string.
             * @example
             *
             * _.capitalize('FRED');
             * // => 'Fred'
             */

            function capitalize(string) {
              return upperFirst(toString(string).toLowerCase());
            }
            /**
             * Deburrs `string` by converting
             * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
             * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
             * letters to basic Latin letters and removing
             * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to deburr.
             * @returns {string} Returns the deburred string.
             * @example
             *
             * _.deburr('déjà vu');
             * // => 'deja vu'
             */


            function deburr(string) {
              string = toString(string);
              return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
            }
            /**
             * Checks if `string` ends with the given target string.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to inspect.
             * @param {string} [target] The string to search for.
             * @param {number} [position=string.length] The position to search up to.
             * @returns {boolean} Returns `true` if `string` ends with `target`,
             *  else `false`.
             * @example
             *
             * _.endsWith('abc', 'c');
             * // => true
             *
             * _.endsWith('abc', 'b');
             * // => false
             *
             * _.endsWith('abc', 'b', 2);
             * // => true
             */


            function endsWith(string, target, position) {
              string = toString(string);
              target = baseToString(target);
              var length = string.length;
              position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
              var end = position;
              position -= target.length;
              return position >= 0 && string.slice(position, end) == target;
            }
            /**
             * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
             * corresponding HTML entities.
             *
             * **Note:** No other characters are escaped. To escape additional
             * characters use a third-party library like [_he_](https://mths.be/he).
             *
             * Though the ">" character is escaped for symmetry, characters like
             * ">" and "/" don't need escaping in HTML and have no special meaning
             * unless they're part of a tag or unquoted attribute value. See
             * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
             * (under "semi-related fun fact") for more details.
             *
             * When working with HTML you should always
             * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
             * XSS vectors.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category String
             * @param {string} [string=''] The string to escape.
             * @returns {string} Returns the escaped string.
             * @example
             *
             * _.escape('fred, barney, & pebbles');
             * // => 'fred, barney, &amp; pebbles'
             */


            function escape(string) {
              string = toString(string);
              return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
            }
            /**
             * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
             * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to escape.
             * @returns {string} Returns the escaped string.
             * @example
             *
             * _.escapeRegExp('[lodash](https://lodash.com/)');
             * // => '\[lodash\]\(https://lodash\.com/\)'
             */


            function escapeRegExp(string) {
              string = toString(string);
              return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
            }
            /**
             * Converts `string` to
             * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to convert.
             * @returns {string} Returns the kebab cased string.
             * @example
             *
             * _.kebabCase('Foo Bar');
             * // => 'foo-bar'
             *
             * _.kebabCase('fooBar');
             * // => 'foo-bar'
             *
             * _.kebabCase('__FOO_BAR__');
             * // => 'foo-bar'
             */


            var kebabCase = createCompounder(function (result, word, index) {
              return result + (index ? '-' : '') + word.toLowerCase();
            });
            /**
             * Converts `string`, as space separated words, to lower case.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to convert.
             * @returns {string} Returns the lower cased string.
             * @example
             *
             * _.lowerCase('--Foo-Bar--');
             * // => 'foo bar'
             *
             * _.lowerCase('fooBar');
             * // => 'foo bar'
             *
             * _.lowerCase('__FOO_BAR__');
             * // => 'foo bar'
             */

            var lowerCase = createCompounder(function (result, word, index) {
              return result + (index ? ' ' : '') + word.toLowerCase();
            });
            /**
             * Converts the first character of `string` to lower case.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to convert.
             * @returns {string} Returns the converted string.
             * @example
             *
             * _.lowerFirst('Fred');
             * // => 'fred'
             *
             * _.lowerFirst('FRED');
             * // => 'fRED'
             */

            var lowerFirst = createCaseFirst('toLowerCase');
            /**
             * Pads `string` on the left and right sides if it's shorter than `length`.
             * Padding characters are truncated if they can't be evenly divided by `length`.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to pad.
             * @param {number} [length=0] The padding length.
             * @param {string} [chars=' '] The string used as padding.
             * @returns {string} Returns the padded string.
             * @example
             *
             * _.pad('abc', 8);
             * // => '  abc   '
             *
             * _.pad('abc', 8, '_-');
             * // => '_-abc_-_'
             *
             * _.pad('abc', 3);
             * // => 'abc'
             */

            function pad(string, length, chars) {
              string = toString(string);
              length = toInteger(length);
              var strLength = length ? stringSize(string) : 0;

              if (!length || strLength >= length) {
                return string;
              }

              var mid = (length - strLength) / 2;
              return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
            }
            /**
             * Pads `string` on the right side if it's shorter than `length`. Padding
             * characters are truncated if they exceed `length`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to pad.
             * @param {number} [length=0] The padding length.
             * @param {string} [chars=' '] The string used as padding.
             * @returns {string} Returns the padded string.
             * @example
             *
             * _.padEnd('abc', 6);
             * // => 'abc   '
             *
             * _.padEnd('abc', 6, '_-');
             * // => 'abc_-_'
             *
             * _.padEnd('abc', 3);
             * // => 'abc'
             */


            function padEnd(string, length, chars) {
              string = toString(string);
              length = toInteger(length);
              var strLength = length ? stringSize(string) : 0;
              return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
            }
            /**
             * Pads `string` on the left side if it's shorter than `length`. Padding
             * characters are truncated if they exceed `length`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to pad.
             * @param {number} [length=0] The padding length.
             * @param {string} [chars=' '] The string used as padding.
             * @returns {string} Returns the padded string.
             * @example
             *
             * _.padStart('abc', 6);
             * // => '   abc'
             *
             * _.padStart('abc', 6, '_-');
             * // => '_-_abc'
             *
             * _.padStart('abc', 3);
             * // => 'abc'
             */


            function padStart(string, length, chars) {
              string = toString(string);
              length = toInteger(length);
              var strLength = length ? stringSize(string) : 0;
              return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
            }
            /**
             * Converts `string` to an integer of the specified radix. If `radix` is
             * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
             * hexadecimal, in which case a `radix` of `16` is used.
             *
             * **Note:** This method aligns with the
             * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
             *
             * @static
             * @memberOf _
             * @since 1.1.0
             * @category String
             * @param {string} string The string to convert.
             * @param {number} [radix=10] The radix to interpret `value` by.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {number} Returns the converted integer.
             * @example
             *
             * _.parseInt('08');
             * // => 8
             *
             * _.map(['6', '08', '10'], _.parseInt);
             * // => [6, 8, 10]
             */


            function parseInt(string, radix, guard) {
              if (guard || radix == null) {
                radix = 0;
              } else if (radix) {
                radix = +radix;
              }

              return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
            }
            /**
             * Repeats the given string `n` times.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to repeat.
             * @param {number} [n=1] The number of times to repeat the string.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {string} Returns the repeated string.
             * @example
             *
             * _.repeat('*', 3);
             * // => '***'
             *
             * _.repeat('abc', 2);
             * // => 'abcabc'
             *
             * _.repeat('abc', 0);
             * // => ''
             */


            function repeat(string, n, guard) {
              if (guard ? isIterateeCall(string, n, guard) : n === undefined) {
                n = 1;
              } else {
                n = toInteger(n);
              }

              return baseRepeat(toString(string), n);
            }
            /**
             * Replaces matches for `pattern` in `string` with `replacement`.
             *
             * **Note:** This method is based on
             * [`String#replace`](https://mdn.io/String/replace).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to modify.
             * @param {RegExp|string} pattern The pattern to replace.
             * @param {Function|string} replacement The match replacement.
             * @returns {string} Returns the modified string.
             * @example
             *
             * _.replace('Hi Fred', 'Fred', 'Barney');
             * // => 'Hi Barney'
             */


            function replace() {
              var args = arguments,
                  string = toString(args[0]);
              return args.length < 3 ? string : string.replace(args[1], args[2]);
            }
            /**
             * Converts `string` to
             * [snake case](https://en.wikipedia.org/wiki/Snake_case).
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to convert.
             * @returns {string} Returns the snake cased string.
             * @example
             *
             * _.snakeCase('Foo Bar');
             * // => 'foo_bar'
             *
             * _.snakeCase('fooBar');
             * // => 'foo_bar'
             *
             * _.snakeCase('--FOO-BAR--');
             * // => 'foo_bar'
             */


            var snakeCase = createCompounder(function (result, word, index) {
              return result + (index ? '_' : '') + word.toLowerCase();
            });
            /**
             * Splits `string` by `separator`.
             *
             * **Note:** This method is based on
             * [`String#split`](https://mdn.io/String/split).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to split.
             * @param {RegExp|string} separator The separator pattern to split by.
             * @param {number} [limit] The length to truncate results to.
             * @returns {Array} Returns the string segments.
             * @example
             *
             * _.split('a-b-c', '-', 2);
             * // => ['a', 'b']
             */

            function split(string, separator, limit) {
              if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
                separator = limit = undefined;
              }

              limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;

              if (!limit) {
                return [];
              }

              string = toString(string);

              if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);

                if (!separator && hasUnicode(string)) {
                  return castSlice(stringToArray(string), 0, limit);
                }
              }

              return string.split(separator, limit);
            }
            /**
             * Converts `string` to
             * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
             *
             * @static
             * @memberOf _
             * @since 3.1.0
             * @category String
             * @param {string} [string=''] The string to convert.
             * @returns {string} Returns the start cased string.
             * @example
             *
             * _.startCase('--foo-bar--');
             * // => 'Foo Bar'
             *
             * _.startCase('fooBar');
             * // => 'Foo Bar'
             *
             * _.startCase('__FOO_BAR__');
             * // => 'FOO BAR'
             */


            var startCase = createCompounder(function (result, word, index) {
              return result + (index ? ' ' : '') + upperFirst(word);
            });
            /**
             * Checks if `string` starts with the given target string.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to inspect.
             * @param {string} [target] The string to search for.
             * @param {number} [position=0] The position to search from.
             * @returns {boolean} Returns `true` if `string` starts with `target`,
             *  else `false`.
             * @example
             *
             * _.startsWith('abc', 'a');
             * // => true
             *
             * _.startsWith('abc', 'b');
             * // => false
             *
             * _.startsWith('abc', 'b', 1);
             * // => true
             */

            function startsWith(string, target, position) {
              string = toString(string);
              position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
              target = baseToString(target);
              return string.slice(position, position + target.length) == target;
            }
            /**
             * Creates a compiled template function that can interpolate data properties
             * in "interpolate" delimiters, HTML-escape interpolated data properties in
             * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
             * properties may be accessed as free variables in the template. If a setting
             * object is given, it takes precedence over `_.templateSettings` values.
             *
             * **Note:** In the development build `_.template` utilizes
             * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
             * for easier debugging.
             *
             * For more information on precompiling templates see
             * [lodash's custom builds documentation](https://lodash.com/custom-builds).
             *
             * For more information on Chrome extension sandboxes see
             * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category String
             * @param {string} [string=''] The template string.
             * @param {Object} [options={}] The options object.
             * @param {RegExp} [options.escape=_.templateSettings.escape]
             *  The HTML "escape" delimiter.
             * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
             *  The "evaluate" delimiter.
             * @param {Object} [options.imports=_.templateSettings.imports]
             *  An object to import into the template as free variables.
             * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
             *  The "interpolate" delimiter.
             * @param {string} [options.sourceURL='lodash.templateSources[n]']
             *  The sourceURL of the compiled template.
             * @param {string} [options.variable='obj']
             *  The data object variable name.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Function} Returns the compiled template function.
             * @example
             *
             * // Use the "interpolate" delimiter to create a compiled template.
             * var compiled = _.template('hello <%= user %>!');
             * compiled({ 'user': 'fred' });
             * // => 'hello fred!'
             *
             * // Use the HTML "escape" delimiter to escape data property values.
             * var compiled = _.template('<b><%- value %></b>');
             * compiled({ 'value': '<script>' });
             * // => '<b>&lt;script&gt;</b>'
             *
             * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
             * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
             * compiled({ 'users': ['fred', 'barney'] });
             * // => '<li>fred</li><li>barney</li>'
             *
             * // Use the internal `print` function in "evaluate" delimiters.
             * var compiled = _.template('<% print("hello " + user); %>!');
             * compiled({ 'user': 'barney' });
             * // => 'hello barney!'
             *
             * // Use the ES template literal delimiter as an "interpolate" delimiter.
             * // Disable support by replacing the "interpolate" delimiter.
             * var compiled = _.template('hello ${ user }!');
             * compiled({ 'user': 'pebbles' });
             * // => 'hello pebbles!'
             *
             * // Use backslashes to treat delimiters as plain text.
             * var compiled = _.template('<%= "\\<%- value %\\>" %>');
             * compiled({ 'value': 'ignored' });
             * // => '<%- value %>'
             *
             * // Use the `imports` option to import `jQuery` as `jq`.
             * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
             * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
             * compiled({ 'users': ['fred', 'barney'] });
             * // => '<li>fred</li><li>barney</li>'
             *
             * // Use the `sourceURL` option to specify a custom sourceURL for the template.
             * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
             * compiled(data);
             * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
             *
             * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
             * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
             * compiled.source;
             * // => function(data) {
             * //   var __t, __p = '';
             * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
             * //   return __p;
             * // }
             *
             * // Use custom template delimiters.
             * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
             * var compiled = _.template('hello {{ user }}!');
             * compiled({ 'user': 'mustache' });
             * // => 'hello mustache!'
             *
             * // Use the `source` property to inline compiled templates for meaningful
             * // line numbers in error messages and stack traces.
             * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
             *   var JST = {\
             *     "main": ' + _.template(mainText).source + '\
             *   };\
             * ');
             */


            function template(string, options, guard) {
              // Based on John Resig's `tmpl` implementation
              // (http://ejohn.org/blog/javascript-micro-templating/)
              // and Laura Doktorova's doT.js (https://github.com/olado/doT).
              var settings = lodash.templateSettings;

              if (guard && isIterateeCall(string, options, guard)) {
                options = undefined;
              }

              string = toString(string);
              options = assignInWith({}, options, settings, customDefaultsAssignIn);
              var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
                  importsKeys = keys(imports),
                  importsValues = baseValues(imports, importsKeys);
              var isEscaping,
                  isEvaluating,
                  index = 0,
                  interpolate = options.interpolate || reNoMatch,
                  source = "__p += '"; // Compile the regexp to match each delimiter.

              var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g'); // Use a sourceURL for easier debugging.

              var sourceURL = '//# sourceURL=' + ('sourceURL' in options ? options.sourceURL : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
              string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue); // Escape characters that can't be included in string literals.

                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar); // Replace delimiters with snippets.

                if (escapeValue) {
                  isEscaping = true;
                  source += "' +\n__e(" + escapeValue + ") +\n'";
                }

                if (evaluateValue) {
                  isEvaluating = true;
                  source += "';\n" + evaluateValue + ";\n__p += '";
                }

                if (interpolateValue) {
                  source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                }

                index = offset + match.length; // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.

                return match;
              });
              source += "';\n"; // If `variable` is not specified wrap a with-statement around the generated
              // code to add the data object to the top of the scope chain.

              var variable = options.variable;

              if (!variable) {
                source = 'with (obj) {\n' + source + '\n}\n';
              } // Cleanup code by stripping empty strings.


              source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;'); // Frame code as the function body.

              source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
              var result = attempt(function () {
                return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
              }); // Provide the compiled function's source by its `toString` method or
              // the `source` property as a convenience for inlining compiled templates.

              result.source = source;

              if (isError(result)) {
                throw result;
              }

              return result;
            }
            /**
             * Converts `string`, as a whole, to lower case just like
             * [String#toLowerCase](https://mdn.io/toLowerCase).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to convert.
             * @returns {string} Returns the lower cased string.
             * @example
             *
             * _.toLower('--Foo-Bar--');
             * // => '--foo-bar--'
             *
             * _.toLower('fooBar');
             * // => 'foobar'
             *
             * _.toLower('__FOO_BAR__');
             * // => '__foo_bar__'
             */


            function toLower(value) {
              return toString(value).toLowerCase();
            }
            /**
             * Converts `string`, as a whole, to upper case just like
             * [String#toUpperCase](https://mdn.io/toUpperCase).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to convert.
             * @returns {string} Returns the upper cased string.
             * @example
             *
             * _.toUpper('--foo-bar--');
             * // => '--FOO-BAR--'
             *
             * _.toUpper('fooBar');
             * // => 'FOOBAR'
             *
             * _.toUpper('__foo_bar__');
             * // => '__FOO_BAR__'
             */


            function toUpper(value) {
              return toString(value).toUpperCase();
            }
            /**
             * Removes leading and trailing whitespace or specified characters from `string`.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to trim.
             * @param {string} [chars=whitespace] The characters to trim.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {string} Returns the trimmed string.
             * @example
             *
             * _.trim('  abc  ');
             * // => 'abc'
             *
             * _.trim('-_-abc-_-', '_-');
             * // => 'abc'
             *
             * _.map(['  foo  ', '  bar  '], _.trim);
             * // => ['foo', 'bar']
             */


            function trim(string, chars, guard) {
              string = toString(string);

              if (string && (guard || chars === undefined)) {
                return string.replace(reTrim, '');
              }

              if (!string || !(chars = baseToString(chars))) {
                return string;
              }

              var strSymbols = stringToArray(string),
                  chrSymbols = stringToArray(chars),
                  start = charsStartIndex(strSymbols, chrSymbols),
                  end = charsEndIndex(strSymbols, chrSymbols) + 1;
              return castSlice(strSymbols, start, end).join('');
            }
            /**
             * Removes trailing whitespace or specified characters from `string`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to trim.
             * @param {string} [chars=whitespace] The characters to trim.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {string} Returns the trimmed string.
             * @example
             *
             * _.trimEnd('  abc  ');
             * // => '  abc'
             *
             * _.trimEnd('-_-abc-_-', '_-');
             * // => '-_-abc'
             */


            function trimEnd(string, chars, guard) {
              string = toString(string);

              if (string && (guard || chars === undefined)) {
                return string.replace(reTrimEnd, '');
              }

              if (!string || !(chars = baseToString(chars))) {
                return string;
              }

              var strSymbols = stringToArray(string),
                  end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
              return castSlice(strSymbols, 0, end).join('');
            }
            /**
             * Removes leading whitespace or specified characters from `string`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to trim.
             * @param {string} [chars=whitespace] The characters to trim.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {string} Returns the trimmed string.
             * @example
             *
             * _.trimStart('  abc  ');
             * // => 'abc  '
             *
             * _.trimStart('-_-abc-_-', '_-');
             * // => 'abc-_-'
             */


            function trimStart(string, chars, guard) {
              string = toString(string);

              if (string && (guard || chars === undefined)) {
                return string.replace(reTrimStart, '');
              }

              if (!string || !(chars = baseToString(chars))) {
                return string;
              }

              var strSymbols = stringToArray(string),
                  start = charsStartIndex(strSymbols, stringToArray(chars));
              return castSlice(strSymbols, start).join('');
            }
            /**
             * Truncates `string` if it's longer than the given maximum string length.
             * The last characters of the truncated string are replaced with the omission
             * string which defaults to "...".
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to truncate.
             * @param {Object} [options={}] The options object.
             * @param {number} [options.length=30] The maximum string length.
             * @param {string} [options.omission='...'] The string to indicate text is omitted.
             * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
             * @returns {string} Returns the truncated string.
             * @example
             *
             * _.truncate('hi-diddly-ho there, neighborino');
             * // => 'hi-diddly-ho there, neighbo...'
             *
             * _.truncate('hi-diddly-ho there, neighborino', {
             *   'length': 24,
             *   'separator': ' '
             * });
             * // => 'hi-diddly-ho there,...'
             *
             * _.truncate('hi-diddly-ho there, neighborino', {
             *   'length': 24,
             *   'separator': /,? +/
             * });
             * // => 'hi-diddly-ho there...'
             *
             * _.truncate('hi-diddly-ho there, neighborino', {
             *   'omission': ' [...]'
             * });
             * // => 'hi-diddly-ho there, neig [...]'
             */


            function truncate(string, options) {
              var length = DEFAULT_TRUNC_LENGTH,
                  omission = DEFAULT_TRUNC_OMISSION;

              if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
              }

              string = toString(string);
              var strLength = string.length;

              if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
              }

              if (length >= strLength) {
                return string;
              }

              var end = length - stringSize(omission);

              if (end < 1) {
                return omission;
              }

              var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);

              if (separator === undefined) {
                return result + omission;
              }

              if (strSymbols) {
                end += result.length - end;
              }

              if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                  var match,
                      substring = result;

                  if (!separator.global) {
                    separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
                  }

                  separator.lastIndex = 0;

                  while (match = separator.exec(substring)) {
                    var newEnd = match.index;
                  }

                  result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
              } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);

                if (index > -1) {
                  result = result.slice(0, index);
                }
              }

              return result + omission;
            }
            /**
             * The inverse of `_.escape`; this method converts the HTML entities
             * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
             * their corresponding characters.
             *
             * **Note:** No other HTML entities are unescaped. To unescape additional
             * HTML entities use a third-party library like [_he_](https://mths.be/he).
             *
             * @static
             * @memberOf _
             * @since 0.6.0
             * @category String
             * @param {string} [string=''] The string to unescape.
             * @returns {string} Returns the unescaped string.
             * @example
             *
             * _.unescape('fred, barney, &amp; pebbles');
             * // => 'fred, barney, & pebbles'
             */


            function unescape(string) {
              string = toString(string);
              return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
            }
            /**
             * Converts `string`, as space separated words, to upper case.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to convert.
             * @returns {string} Returns the upper cased string.
             * @example
             *
             * _.upperCase('--foo-bar');
             * // => 'FOO BAR'
             *
             * _.upperCase('fooBar');
             * // => 'FOO BAR'
             *
             * _.upperCase('__foo_bar__');
             * // => 'FOO BAR'
             */


            var upperCase = createCompounder(function (result, word, index) {
              return result + (index ? ' ' : '') + word.toUpperCase();
            });
            /**
             * Converts the first character of `string` to upper case.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category String
             * @param {string} [string=''] The string to convert.
             * @returns {string} Returns the converted string.
             * @example
             *
             * _.upperFirst('fred');
             * // => 'Fred'
             *
             * _.upperFirst('FRED');
             * // => 'FRED'
             */

            var upperFirst = createCaseFirst('toUpperCase');
            /**
             * Splits `string` into an array of its words.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category String
             * @param {string} [string=''] The string to inspect.
             * @param {RegExp|string} [pattern] The pattern to match words.
             * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
             * @returns {Array} Returns the words of `string`.
             * @example
             *
             * _.words('fred, barney, & pebbles');
             * // => ['fred', 'barney', 'pebbles']
             *
             * _.words('fred, barney, & pebbles', /[^, ]+/g);
             * // => ['fred', 'barney', '&', 'pebbles']
             */

            function words(string, pattern, guard) {
              string = toString(string);
              pattern = guard ? undefined : pattern;

              if (pattern === undefined) {
                return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
              }

              return string.match(pattern) || [];
            }
            /*------------------------------------------------------------------------*/

            /**
             * Attempts to invoke `func`, returning either the result or the caught error
             * object. Any additional arguments are provided to `func` when it's invoked.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Util
             * @param {Function} func The function to attempt.
             * @param {...*} [args] The arguments to invoke `func` with.
             * @returns {*} Returns the `func` result or error object.
             * @example
             *
             * // Avoid throwing errors for invalid selectors.
             * var elements = _.attempt(function(selector) {
             *   return document.querySelectorAll(selector);
             * }, '>_>');
             *
             * if (_.isError(elements)) {
             *   elements = [];
             * }
             */


            var attempt = baseRest(function (func, args) {
              try {
                return apply(func, undefined, args);
              } catch (e) {
                return isError(e) ? e : new Error(e);
              }
            });
            /**
             * Binds methods of an object to the object itself, overwriting the existing
             * method.
             *
             * **Note:** This method doesn't set the "length" property of bound functions.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @param {Object} object The object to bind and assign the bound methods to.
             * @param {...(string|string[])} methodNames The object method names to bind.
             * @returns {Object} Returns `object`.
             * @example
             *
             * var view = {
             *   'label': 'docs',
             *   'click': function() {
             *     console.log('clicked ' + this.label);
             *   }
             * };
             *
             * _.bindAll(view, ['click']);
             * jQuery(element).on('click', view.click);
             * // => Logs 'clicked docs' when clicked.
             */

            var bindAll = flatRest(function (object, methodNames) {
              arrayEach(methodNames, function (key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
              });
              return object;
            });
            /**
             * Creates a function that iterates over `pairs` and invokes the corresponding
             * function of the first predicate to return truthy. The predicate-function
             * pairs are invoked with the `this` binding and arguments of the created
             * function.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Util
             * @param {Array} pairs The predicate-function pairs.
             * @returns {Function} Returns the new composite function.
             * @example
             *
             * var func = _.cond([
             *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
             *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
             *   [_.stubTrue,                      _.constant('no match')]
             * ]);
             *
             * func({ 'a': 1, 'b': 2 });
             * // => 'matches A'
             *
             * func({ 'a': 0, 'b': 1 });
             * // => 'matches B'
             *
             * func({ 'a': '1', 'b': '2' });
             * // => 'no match'
             */

            function cond(pairs) {
              var length = pairs == null ? 0 : pairs.length,
                  toIteratee = getIteratee();
              pairs = !length ? [] : arrayMap(pairs, function (pair) {
                if (typeof pair[1] != 'function') {
                  throw new TypeError(FUNC_ERROR_TEXT);
                }

                return [toIteratee(pair[0]), pair[1]];
              });
              return baseRest(function (args) {
                var index = -1;

                while (++index < length) {
                  var pair = pairs[index];

                  if (apply(pair[0], this, args)) {
                    return apply(pair[1], this, args);
                  }
                }
              });
            }
            /**
             * Creates a function that invokes the predicate properties of `source` with
             * the corresponding property values of a given object, returning `true` if
             * all predicates return truthy, else `false`.
             *
             * **Note:** The created function is equivalent to `_.conformsTo` with
             * `source` partially applied.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Util
             * @param {Object} source The object of property predicates to conform to.
             * @returns {Function} Returns the new spec function.
             * @example
             *
             * var objects = [
             *   { 'a': 2, 'b': 1 },
             *   { 'a': 1, 'b': 2 }
             * ];
             *
             * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
             * // => [{ 'a': 1, 'b': 2 }]
             */


            function conforms(source) {
              return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
            }
            /**
             * Creates a function that returns `value`.
             *
             * @static
             * @memberOf _
             * @since 2.4.0
             * @category Util
             * @param {*} value The value to return from the new function.
             * @returns {Function} Returns the new constant function.
             * @example
             *
             * var objects = _.times(2, _.constant({ 'a': 1 }));
             *
             * console.log(objects);
             * // => [{ 'a': 1 }, { 'a': 1 }]
             *
             * console.log(objects[0] === objects[1]);
             * // => true
             */


            function constant(value) {
              return function () {
                return value;
              };
            }
            /**
             * Checks `value` to determine whether a default value should be returned in
             * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
             * or `undefined`.
             *
             * @static
             * @memberOf _
             * @since 4.14.0
             * @category Util
             * @param {*} value The value to check.
             * @param {*} defaultValue The default value.
             * @returns {*} Returns the resolved value.
             * @example
             *
             * _.defaultTo(1, 10);
             * // => 1
             *
             * _.defaultTo(undefined, 10);
             * // => 10
             */


            function defaultTo(value, defaultValue) {
              return value == null || value !== value ? defaultValue : value;
            }
            /**
             * Creates a function that returns the result of invoking the given functions
             * with the `this` binding of the created function, where each successive
             * invocation is supplied the return value of the previous.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Util
             * @param {...(Function|Function[])} [funcs] The functions to invoke.
             * @returns {Function} Returns the new composite function.
             * @see _.flowRight
             * @example
             *
             * function square(n) {
             *   return n * n;
             * }
             *
             * var addSquare = _.flow([_.add, square]);
             * addSquare(1, 2);
             * // => 9
             */


            var flow = createFlow();
            /**
             * This method is like `_.flow` except that it creates a function that
             * invokes the given functions from right to left.
             *
             * @static
             * @since 3.0.0
             * @memberOf _
             * @category Util
             * @param {...(Function|Function[])} [funcs] The functions to invoke.
             * @returns {Function} Returns the new composite function.
             * @see _.flow
             * @example
             *
             * function square(n) {
             *   return n * n;
             * }
             *
             * var addSquare = _.flowRight([square, _.add]);
             * addSquare(1, 2);
             * // => 9
             */

            var flowRight = createFlow(true);
            /**
             * This method returns the first argument it receives.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @param {*} value Any value.
             * @returns {*} Returns `value`.
             * @example
             *
             * var object = { 'a': 1 };
             *
             * console.log(_.identity(object) === object);
             * // => true
             */

            function identity(value) {
              return value;
            }
            /**
             * Creates a function that invokes `func` with the arguments of the created
             * function. If `func` is a property name, the created function returns the
             * property value for a given element. If `func` is an array or object, the
             * created function returns `true` for elements that contain the equivalent
             * source properties, otherwise it returns `false`.
             *
             * @static
             * @since 4.0.0
             * @memberOf _
             * @category Util
             * @param {*} [func=_.identity] The value to convert to a callback.
             * @returns {Function} Returns the callback.
             * @example
             *
             * var users = [
             *   { 'user': 'barney', 'age': 36, 'active': true },
             *   { 'user': 'fred',   'age': 40, 'active': false }
             * ];
             *
             * // The `_.matches` iteratee shorthand.
             * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
             * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
             *
             * // The `_.matchesProperty` iteratee shorthand.
             * _.filter(users, _.iteratee(['user', 'fred']));
             * // => [{ 'user': 'fred', 'age': 40 }]
             *
             * // The `_.property` iteratee shorthand.
             * _.map(users, _.iteratee('user'));
             * // => ['barney', 'fred']
             *
             * // Create custom iteratee shorthands.
             * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
             *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
             *     return func.test(string);
             *   };
             * });
             *
             * _.filter(['abc', 'def'], /ef/);
             * // => ['def']
             */


            function iteratee(func) {
              return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
            }
            /**
             * Creates a function that performs a partial deep comparison between a given
             * object and `source`, returning `true` if the given object has equivalent
             * property values, else `false`.
             *
             * **Note:** The created function is equivalent to `_.isMatch` with `source`
             * partially applied.
             *
             * Partial comparisons will match empty array and empty object `source`
             * values against any array or object value, respectively. See `_.isEqual`
             * for a list of supported value comparisons.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Util
             * @param {Object} source The object of property values to match.
             * @returns {Function} Returns the new spec function.
             * @example
             *
             * var objects = [
             *   { 'a': 1, 'b': 2, 'c': 3 },
             *   { 'a': 4, 'b': 5, 'c': 6 }
             * ];
             *
             * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
             * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
             */


            function matches(source) {
              return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
            }
            /**
             * Creates a function that performs a partial deep comparison between the
             * value at `path` of a given object to `srcValue`, returning `true` if the
             * object value is equivalent, else `false`.
             *
             * **Note:** Partial comparisons will match empty array and empty object
             * `srcValue` values against any array or object value, respectively. See
             * `_.isEqual` for a list of supported value comparisons.
             *
             * @static
             * @memberOf _
             * @since 3.2.0
             * @category Util
             * @param {Array|string} path The path of the property to get.
             * @param {*} srcValue The value to match.
             * @returns {Function} Returns the new spec function.
             * @example
             *
             * var objects = [
             *   { 'a': 1, 'b': 2, 'c': 3 },
             *   { 'a': 4, 'b': 5, 'c': 6 }
             * ];
             *
             * _.find(objects, _.matchesProperty('a', 4));
             * // => { 'a': 4, 'b': 5, 'c': 6 }
             */


            function matchesProperty(path, srcValue) {
              return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
            }
            /**
             * Creates a function that invokes the method at `path` of a given object.
             * Any additional arguments are provided to the invoked method.
             *
             * @static
             * @memberOf _
             * @since 3.7.0
             * @category Util
             * @param {Array|string} path The path of the method to invoke.
             * @param {...*} [args] The arguments to invoke the method with.
             * @returns {Function} Returns the new invoker function.
             * @example
             *
             * var objects = [
             *   { 'a': { 'b': _.constant(2) } },
             *   { 'a': { 'b': _.constant(1) } }
             * ];
             *
             * _.map(objects, _.method('a.b'));
             * // => [2, 1]
             *
             * _.map(objects, _.method(['a', 'b']));
             * // => [2, 1]
             */


            var method = baseRest(function (path, args) {
              return function (object) {
                return baseInvoke(object, path, args);
              };
            });
            /**
             * The opposite of `_.method`; this method creates a function that invokes
             * the method at a given path of `object`. Any additional arguments are
             * provided to the invoked method.
             *
             * @static
             * @memberOf _
             * @since 3.7.0
             * @category Util
             * @param {Object} object The object to query.
             * @param {...*} [args] The arguments to invoke the method with.
             * @returns {Function} Returns the new invoker function.
             * @example
             *
             * var array = _.times(3, _.constant),
             *     object = { 'a': array, 'b': array, 'c': array };
             *
             * _.map(['a[2]', 'c[0]'], _.methodOf(object));
             * // => [2, 0]
             *
             * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
             * // => [2, 0]
             */

            var methodOf = baseRest(function (object, args) {
              return function (path) {
                return baseInvoke(object, path, args);
              };
            });
            /**
             * Adds all own enumerable string keyed function properties of a source
             * object to the destination object. If `object` is a function, then methods
             * are added to its prototype as well.
             *
             * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
             * avoid conflicts caused by modifying the original.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @param {Function|Object} [object=lodash] The destination object.
             * @param {Object} source The object of functions to add.
             * @param {Object} [options={}] The options object.
             * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
             * @returns {Function|Object} Returns `object`.
             * @example
             *
             * function vowels(string) {
             *   return _.filter(string, function(v) {
             *     return /[aeiou]/i.test(v);
             *   });
             * }
             *
             * _.mixin({ 'vowels': vowels });
             * _.vowels('fred');
             * // => ['e']
             *
             * _('fred').vowels().value();
             * // => ['e']
             *
             * _.mixin({ 'vowels': vowels }, { 'chain': false });
             * _('fred').vowels();
             * // => ['e']
             */

            function mixin(object, source, options) {
              var props = keys(source),
                  methodNames = baseFunctions(source, props);

              if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
              }

              var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
                  isFunc = isFunction(object);
              arrayEach(methodNames, function (methodName) {
                var func = source[methodName];
                object[methodName] = func;

                if (isFunc) {
                  object.prototype[methodName] = function () {
                    var chainAll = this.__chain__;

                    if (chain || chainAll) {
                      var result = object(this.__wrapped__),
                          actions = result.__actions__ = copyArray(this.__actions__);
                      actions.push({
                        'func': func,
                        'args': arguments,
                        'thisArg': object
                      });
                      result.__chain__ = chainAll;
                      return result;
                    }

                    return func.apply(object, arrayPush([this.value()], arguments));
                  };
                }
              });
              return object;
            }
            /**
             * Reverts the `_` variable to its previous value and returns a reference to
             * the `lodash` function.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @returns {Function} Returns the `lodash` function.
             * @example
             *
             * var lodash = _.noConflict();
             */


            function noConflict() {
              if (root._ === this) {
                root._ = oldDash;
              }

              return this;
            }
            /**
             * This method returns `undefined`.
             *
             * @static
             * @memberOf _
             * @since 2.3.0
             * @category Util
             * @example
             *
             * _.times(2, _.noop);
             * // => [undefined, undefined]
             */


            function noop() {} // No operation performed.

            /**
             * Creates a function that gets the argument at index `n`. If `n` is negative,
             * the nth argument from the end is returned.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Util
             * @param {number} [n=0] The index of the argument to return.
             * @returns {Function} Returns the new pass-thru function.
             * @example
             *
             * var func = _.nthArg(1);
             * func('a', 'b', 'c', 'd');
             * // => 'b'
             *
             * var func = _.nthArg(-2);
             * func('a', 'b', 'c', 'd');
             * // => 'c'
             */


            function nthArg(n) {
              n = toInteger(n);
              return baseRest(function (args) {
                return baseNth(args, n);
              });
            }
            /**
             * Creates a function that invokes `iteratees` with the arguments it receives
             * and returns their results.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Util
             * @param {...(Function|Function[])} [iteratees=[_.identity]]
             *  The iteratees to invoke.
             * @returns {Function} Returns the new function.
             * @example
             *
             * var func = _.over([Math.max, Math.min]);
             *
             * func(1, 2, 3, 4);
             * // => [4, 1]
             */


            var over = createOver(arrayMap);
            /**
             * Creates a function that checks if **all** of the `predicates` return
             * truthy when invoked with the arguments it receives.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Util
             * @param {...(Function|Function[])} [predicates=[_.identity]]
             *  The predicates to check.
             * @returns {Function} Returns the new function.
             * @example
             *
             * var func = _.overEvery([Boolean, isFinite]);
             *
             * func('1');
             * // => true
             *
             * func(null);
             * // => false
             *
             * func(NaN);
             * // => false
             */

            var overEvery = createOver(arrayEvery);
            /**
             * Creates a function that checks if **any** of the `predicates` return
             * truthy when invoked with the arguments it receives.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Util
             * @param {...(Function|Function[])} [predicates=[_.identity]]
             *  The predicates to check.
             * @returns {Function} Returns the new function.
             * @example
             *
             * var func = _.overSome([Boolean, isFinite]);
             *
             * func('1');
             * // => true
             *
             * func(null);
             * // => true
             *
             * func(NaN);
             * // => false
             */

            var overSome = createOver(arraySome);
            /**
             * Creates a function that returns the value at `path` of a given object.
             *
             * @static
             * @memberOf _
             * @since 2.4.0
             * @category Util
             * @param {Array|string} path The path of the property to get.
             * @returns {Function} Returns the new accessor function.
             * @example
             *
             * var objects = [
             *   { 'a': { 'b': 2 } },
             *   { 'a': { 'b': 1 } }
             * ];
             *
             * _.map(objects, _.property('a.b'));
             * // => [2, 1]
             *
             * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
             * // => [1, 2]
             */

            function property(path) {
              return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
            }
            /**
             * The opposite of `_.property`; this method creates a function that returns
             * the value at a given path of `object`.
             *
             * @static
             * @memberOf _
             * @since 3.0.0
             * @category Util
             * @param {Object} object The object to query.
             * @returns {Function} Returns the new accessor function.
             * @example
             *
             * var array = [0, 1, 2],
             *     object = { 'a': array, 'b': array, 'c': array };
             *
             * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
             * // => [2, 0]
             *
             * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
             * // => [2, 0]
             */


            function propertyOf(object) {
              return function (path) {
                return object == null ? undefined : baseGet(object, path);
              };
            }
            /**
             * Creates an array of numbers (positive and/or negative) progressing from
             * `start` up to, but not including, `end`. A step of `-1` is used if a negative
             * `start` is specified without an `end` or `step`. If `end` is not specified,
             * it's set to `start` with `start` then set to `0`.
             *
             * **Note:** JavaScript follows the IEEE-754 standard for resolving
             * floating-point values which can produce unexpected results.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @param {number} [start=0] The start of the range.
             * @param {number} end The end of the range.
             * @param {number} [step=1] The value to increment or decrement by.
             * @returns {Array} Returns the range of numbers.
             * @see _.inRange, _.rangeRight
             * @example
             *
             * _.range(4);
             * // => [0, 1, 2, 3]
             *
             * _.range(-4);
             * // => [0, -1, -2, -3]
             *
             * _.range(1, 5);
             * // => [1, 2, 3, 4]
             *
             * _.range(0, 20, 5);
             * // => [0, 5, 10, 15]
             *
             * _.range(0, -4, -1);
             * // => [0, -1, -2, -3]
             *
             * _.range(1, 4, 0);
             * // => [1, 1, 1]
             *
             * _.range(0);
             * // => []
             */


            var range = createRange();
            /**
             * This method is like `_.range` except that it populates values in
             * descending order.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Util
             * @param {number} [start=0] The start of the range.
             * @param {number} end The end of the range.
             * @param {number} [step=1] The value to increment or decrement by.
             * @returns {Array} Returns the range of numbers.
             * @see _.inRange, _.range
             * @example
             *
             * _.rangeRight(4);
             * // => [3, 2, 1, 0]
             *
             * _.rangeRight(-4);
             * // => [-3, -2, -1, 0]
             *
             * _.rangeRight(1, 5);
             * // => [4, 3, 2, 1]
             *
             * _.rangeRight(0, 20, 5);
             * // => [15, 10, 5, 0]
             *
             * _.rangeRight(0, -4, -1);
             * // => [-3, -2, -1, 0]
             *
             * _.rangeRight(1, 4, 0);
             * // => [1, 1, 1]
             *
             * _.rangeRight(0);
             * // => []
             */

            var rangeRight = createRange(true);
            /**
             * This method returns a new empty array.
             *
             * @static
             * @memberOf _
             * @since 4.13.0
             * @category Util
             * @returns {Array} Returns the new empty array.
             * @example
             *
             * var arrays = _.times(2, _.stubArray);
             *
             * console.log(arrays);
             * // => [[], []]
             *
             * console.log(arrays[0] === arrays[1]);
             * // => false
             */

            function stubArray() {
              return [];
            }
            /**
             * This method returns `false`.
             *
             * @static
             * @memberOf _
             * @since 4.13.0
             * @category Util
             * @returns {boolean} Returns `false`.
             * @example
             *
             * _.times(2, _.stubFalse);
             * // => [false, false]
             */


            function stubFalse() {
              return false;
            }
            /**
             * This method returns a new empty object.
             *
             * @static
             * @memberOf _
             * @since 4.13.0
             * @category Util
             * @returns {Object} Returns the new empty object.
             * @example
             *
             * var objects = _.times(2, _.stubObject);
             *
             * console.log(objects);
             * // => [{}, {}]
             *
             * console.log(objects[0] === objects[1]);
             * // => false
             */


            function stubObject() {
              return {};
            }
            /**
             * This method returns an empty string.
             *
             * @static
             * @memberOf _
             * @since 4.13.0
             * @category Util
             * @returns {string} Returns the empty string.
             * @example
             *
             * _.times(2, _.stubString);
             * // => ['', '']
             */


            function stubString() {
              return '';
            }
            /**
             * This method returns `true`.
             *
             * @static
             * @memberOf _
             * @since 4.13.0
             * @category Util
             * @returns {boolean} Returns `true`.
             * @example
             *
             * _.times(2, _.stubTrue);
             * // => [true, true]
             */


            function stubTrue() {
              return true;
            }
            /**
             * Invokes the iteratee `n` times, returning an array of the results of
             * each invocation. The iteratee is invoked with one argument; (index).
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @param {number} n The number of times to invoke `iteratee`.
             * @param {Function} [iteratee=_.identity] The function invoked per iteration.
             * @returns {Array} Returns the array of results.
             * @example
             *
             * _.times(3, String);
             * // => ['0', '1', '2']
             *
             *  _.times(4, _.constant(0));
             * // => [0, 0, 0, 0]
             */


            function times(n, iteratee) {
              n = toInteger(n);

              if (n < 1 || n > MAX_SAFE_INTEGER) {
                return [];
              }

              var index = MAX_ARRAY_LENGTH,
                  length = nativeMin(n, MAX_ARRAY_LENGTH);
              iteratee = getIteratee(iteratee);
              n -= MAX_ARRAY_LENGTH;
              var result = baseTimes(length, iteratee);

              while (++index < n) {
                iteratee(index);
              }

              return result;
            }
            /**
             * Converts `value` to a property path array.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Util
             * @param {*} value The value to convert.
             * @returns {Array} Returns the new property path array.
             * @example
             *
             * _.toPath('a.b.c');
             * // => ['a', 'b', 'c']
             *
             * _.toPath('a[0].b.c');
             * // => ['a', '0', 'b', 'c']
             */


            function toPath(value) {
              if (isArray(value)) {
                return arrayMap(value, toKey);
              }

              return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
            }
            /**
             * Generates a unique ID. If `prefix` is given, the ID is appended to it.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Util
             * @param {string} [prefix=''] The value to prefix the ID with.
             * @returns {string} Returns the unique ID.
             * @example
             *
             * _.uniqueId('contact_');
             * // => 'contact_104'
             *
             * _.uniqueId();
             * // => '105'
             */


            function uniqueId(prefix) {
              var id = ++idCounter;
              return toString(prefix) + id;
            }
            /*------------------------------------------------------------------------*/

            /**
             * Adds two numbers.
             *
             * @static
             * @memberOf _
             * @since 3.4.0
             * @category Math
             * @param {number} augend The first number in an addition.
             * @param {number} addend The second number in an addition.
             * @returns {number} Returns the total.
             * @example
             *
             * _.add(6, 4);
             * // => 10
             */


            var add = createMathOperation(function (augend, addend) {
              return augend + addend;
            }, 0);
            /**
             * Computes `number` rounded up to `precision`.
             *
             * @static
             * @memberOf _
             * @since 3.10.0
             * @category Math
             * @param {number} number The number to round up.
             * @param {number} [precision=0] The precision to round up to.
             * @returns {number} Returns the rounded up number.
             * @example
             *
             * _.ceil(4.006);
             * // => 5
             *
             * _.ceil(6.004, 2);
             * // => 6.01
             *
             * _.ceil(6040, -2);
             * // => 6100
             */

            var ceil = createRound('ceil');
            /**
             * Divide two numbers.
             *
             * @static
             * @memberOf _
             * @since 4.7.0
             * @category Math
             * @param {number} dividend The first number in a division.
             * @param {number} divisor The second number in a division.
             * @returns {number} Returns the quotient.
             * @example
             *
             * _.divide(6, 4);
             * // => 1.5
             */

            var divide = createMathOperation(function (dividend, divisor) {
              return dividend / divisor;
            }, 1);
            /**
             * Computes `number` rounded down to `precision`.
             *
             * @static
             * @memberOf _
             * @since 3.10.0
             * @category Math
             * @param {number} number The number to round down.
             * @param {number} [precision=0] The precision to round down to.
             * @returns {number} Returns the rounded down number.
             * @example
             *
             * _.floor(4.006);
             * // => 4
             *
             * _.floor(0.046, 2);
             * // => 0.04
             *
             * _.floor(4060, -2);
             * // => 4000
             */

            var floor = createRound('floor');
            /**
             * Computes the maximum value of `array`. If `array` is empty or falsey,
             * `undefined` is returned.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Math
             * @param {Array} array The array to iterate over.
             * @returns {*} Returns the maximum value.
             * @example
             *
             * _.max([4, 2, 8, 6]);
             * // => 8
             *
             * _.max([]);
             * // => undefined
             */

            function max(array) {
              return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
            }
            /**
             * This method is like `_.max` except that it accepts `iteratee` which is
             * invoked for each element in `array` to generate the criterion by which
             * the value is ranked. The iteratee is invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Math
             * @param {Array} array The array to iterate over.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {*} Returns the maximum value.
             * @example
             *
             * var objects = [{ 'n': 1 }, { 'n': 2 }];
             *
             * _.maxBy(objects, function(o) { return o.n; });
             * // => { 'n': 2 }
             *
             * // The `_.property` iteratee shorthand.
             * _.maxBy(objects, 'n');
             * // => { 'n': 2 }
             */


            function maxBy(array, iteratee) {
              return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
            }
            /**
             * Computes the mean of the values in `array`.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Math
             * @param {Array} array The array to iterate over.
             * @returns {number} Returns the mean.
             * @example
             *
             * _.mean([4, 2, 8, 6]);
             * // => 5
             */


            function mean(array) {
              return baseMean(array, identity);
            }
            /**
             * This method is like `_.mean` except that it accepts `iteratee` which is
             * invoked for each element in `array` to generate the value to be averaged.
             * The iteratee is invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 4.7.0
             * @category Math
             * @param {Array} array The array to iterate over.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {number} Returns the mean.
             * @example
             *
             * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
             *
             * _.meanBy(objects, function(o) { return o.n; });
             * // => 5
             *
             * // The `_.property` iteratee shorthand.
             * _.meanBy(objects, 'n');
             * // => 5
             */


            function meanBy(array, iteratee) {
              return baseMean(array, getIteratee(iteratee, 2));
            }
            /**
             * Computes the minimum value of `array`. If `array` is empty or falsey,
             * `undefined` is returned.
             *
             * @static
             * @since 0.1.0
             * @memberOf _
             * @category Math
             * @param {Array} array The array to iterate over.
             * @returns {*} Returns the minimum value.
             * @example
             *
             * _.min([4, 2, 8, 6]);
             * // => 2
             *
             * _.min([]);
             * // => undefined
             */


            function min(array) {
              return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
            }
            /**
             * This method is like `_.min` except that it accepts `iteratee` which is
             * invoked for each element in `array` to generate the criterion by which
             * the value is ranked. The iteratee is invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Math
             * @param {Array} array The array to iterate over.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {*} Returns the minimum value.
             * @example
             *
             * var objects = [{ 'n': 1 }, { 'n': 2 }];
             *
             * _.minBy(objects, function(o) { return o.n; });
             * // => { 'n': 1 }
             *
             * // The `_.property` iteratee shorthand.
             * _.minBy(objects, 'n');
             * // => { 'n': 1 }
             */


            function minBy(array, iteratee) {
              return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
            }
            /**
             * Multiply two numbers.
             *
             * @static
             * @memberOf _
             * @since 4.7.0
             * @category Math
             * @param {number} multiplier The first number in a multiplication.
             * @param {number} multiplicand The second number in a multiplication.
             * @returns {number} Returns the product.
             * @example
             *
             * _.multiply(6, 4);
             * // => 24
             */


            var multiply = createMathOperation(function (multiplier, multiplicand) {
              return multiplier * multiplicand;
            }, 1);
            /**
             * Computes `number` rounded to `precision`.
             *
             * @static
             * @memberOf _
             * @since 3.10.0
             * @category Math
             * @param {number} number The number to round.
             * @param {number} [precision=0] The precision to round to.
             * @returns {number} Returns the rounded number.
             * @example
             *
             * _.round(4.006);
             * // => 4
             *
             * _.round(4.006, 2);
             * // => 4.01
             *
             * _.round(4060, -2);
             * // => 4100
             */

            var round = createRound('round');
            /**
             * Subtract two numbers.
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Math
             * @param {number} minuend The first number in a subtraction.
             * @param {number} subtrahend The second number in a subtraction.
             * @returns {number} Returns the difference.
             * @example
             *
             * _.subtract(6, 4);
             * // => 2
             */

            var subtract = createMathOperation(function (minuend, subtrahend) {
              return minuend - subtrahend;
            }, 0);
            /**
             * Computes the sum of the values in `array`.
             *
             * @static
             * @memberOf _
             * @since 3.4.0
             * @category Math
             * @param {Array} array The array to iterate over.
             * @returns {number} Returns the sum.
             * @example
             *
             * _.sum([4, 2, 8, 6]);
             * // => 20
             */

            function sum(array) {
              return array && array.length ? baseSum(array, identity) : 0;
            }
            /**
             * This method is like `_.sum` except that it accepts `iteratee` which is
             * invoked for each element in `array` to generate the value to be summed.
             * The iteratee is invoked with one argument: (value).
             *
             * @static
             * @memberOf _
             * @since 4.0.0
             * @category Math
             * @param {Array} array The array to iterate over.
             * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
             * @returns {number} Returns the sum.
             * @example
             *
             * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
             *
             * _.sumBy(objects, function(o) { return o.n; });
             * // => 20
             *
             * // The `_.property` iteratee shorthand.
             * _.sumBy(objects, 'n');
             * // => 20
             */


            function sumBy(array, iteratee) {
              return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
            }
            /*------------------------------------------------------------------------*/
            // Add methods that return wrapped values in chain sequences.


            lodash.after = after;
            lodash.ary = ary;
            lodash.assign = assign;
            lodash.assignIn = assignIn;
            lodash.assignInWith = assignInWith;
            lodash.assignWith = assignWith;
            lodash.at = at;
            lodash.before = before;
            lodash.bind = bind;
            lodash.bindAll = bindAll;
            lodash.bindKey = bindKey;
            lodash.castArray = castArray;
            lodash.chain = chain;
            lodash.chunk = chunk;
            lodash.compact = compact;
            lodash.concat = concat;
            lodash.cond = cond;
            lodash.conforms = conforms;
            lodash.constant = constant;
            lodash.countBy = countBy;
            lodash.create = create;
            lodash.curry = curry;
            lodash.curryRight = curryRight;
            lodash.debounce = debounce;
            lodash.defaults = defaults;
            lodash.defaultsDeep = defaultsDeep;
            lodash.defer = defer;
            lodash.delay = delay;
            lodash.difference = difference;
            lodash.differenceBy = differenceBy;
            lodash.differenceWith = differenceWith;
            lodash.drop = drop;
            lodash.dropRight = dropRight;
            lodash.dropRightWhile = dropRightWhile;
            lodash.dropWhile = dropWhile;
            lodash.fill = fill;
            lodash.filter = filter;
            lodash.flatMap = flatMap;
            lodash.flatMapDeep = flatMapDeep;
            lodash.flatMapDepth = flatMapDepth;
            lodash.flatten = flatten;
            lodash.flattenDeep = flattenDeep;
            lodash.flattenDepth = flattenDepth;
            lodash.flip = flip;
            lodash.flow = flow;
            lodash.flowRight = flowRight;
            lodash.fromPairs = fromPairs;
            lodash.functions = functions;
            lodash.functionsIn = functionsIn;
            lodash.groupBy = groupBy;
            lodash.initial = initial;
            lodash.intersection = intersection;
            lodash.intersectionBy = intersectionBy;
            lodash.intersectionWith = intersectionWith;
            lodash.invert = invert;
            lodash.invertBy = invertBy;
            lodash.invokeMap = invokeMap;
            lodash.iteratee = iteratee;
            lodash.keyBy = keyBy;
            lodash.keys = keys;
            lodash.keysIn = keysIn;
            lodash.map = map;
            lodash.mapKeys = mapKeys;
            lodash.mapValues = mapValues;
            lodash.matches = matches;
            lodash.matchesProperty = matchesProperty;
            lodash.memoize = memoize;
            lodash.merge = merge;
            lodash.mergeWith = mergeWith;
            lodash.method = method;
            lodash.methodOf = methodOf;
            lodash.mixin = mixin;
            lodash.negate = negate;
            lodash.nthArg = nthArg;
            lodash.omit = omit;
            lodash.omitBy = omitBy;
            lodash.once = once;
            lodash.orderBy = orderBy;
            lodash.over = over;
            lodash.overArgs = overArgs;
            lodash.overEvery = overEvery;
            lodash.overSome = overSome;
            lodash.partial = partial;
            lodash.partialRight = partialRight;
            lodash.partition = partition;
            lodash.pick = pick;
            lodash.pickBy = pickBy;
            lodash.property = property;
            lodash.propertyOf = propertyOf;
            lodash.pull = pull;
            lodash.pullAll = pullAll;
            lodash.pullAllBy = pullAllBy;
            lodash.pullAllWith = pullAllWith;
            lodash.pullAt = pullAt;
            lodash.range = range;
            lodash.rangeRight = rangeRight;
            lodash.rearg = rearg;
            lodash.reject = reject;
            lodash.remove = remove;
            lodash.rest = rest;
            lodash.reverse = reverse;
            lodash.sampleSize = sampleSize;
            lodash.set = set;
            lodash.setWith = setWith;
            lodash.shuffle = shuffle;
            lodash.slice = slice;
            lodash.sortBy = sortBy;
            lodash.sortedUniq = sortedUniq;
            lodash.sortedUniqBy = sortedUniqBy;
            lodash.split = split;
            lodash.spread = spread;
            lodash.tail = tail;
            lodash.take = take;
            lodash.takeRight = takeRight;
            lodash.takeRightWhile = takeRightWhile;
            lodash.takeWhile = takeWhile;
            lodash.tap = tap;
            lodash.throttle = throttle;
            lodash.thru = thru;
            lodash.toArray = toArray;
            lodash.toPairs = toPairs;
            lodash.toPairsIn = toPairsIn;
            lodash.toPath = toPath;
            lodash.toPlainObject = toPlainObject;
            lodash.transform = transform;
            lodash.unary = unary;
            lodash.union = union;
            lodash.unionBy = unionBy;
            lodash.unionWith = unionWith;
            lodash.uniq = uniq;
            lodash.uniqBy = uniqBy;
            lodash.uniqWith = uniqWith;
            lodash.unset = unset;
            lodash.unzip = unzip;
            lodash.unzipWith = unzipWith;
            lodash.update = update;
            lodash.updateWith = updateWith;
            lodash.values = values;
            lodash.valuesIn = valuesIn;
            lodash.without = without;
            lodash.words = words;
            lodash.wrap = wrap;
            lodash.xor = xor;
            lodash.xorBy = xorBy;
            lodash.xorWith = xorWith;
            lodash.zip = zip;
            lodash.zipObject = zipObject;
            lodash.zipObjectDeep = zipObjectDeep;
            lodash.zipWith = zipWith; // Add aliases.

            lodash.entries = toPairs;
            lodash.entriesIn = toPairsIn;
            lodash.extend = assignIn;
            lodash.extendWith = assignInWith; // Add methods to `lodash.prototype`.

            mixin(lodash, lodash);
            /*------------------------------------------------------------------------*/
            // Add methods that return unwrapped values in chain sequences.

            lodash.add = add;
            lodash.attempt = attempt;
            lodash.camelCase = camelCase;
            lodash.capitalize = capitalize;
            lodash.ceil = ceil;
            lodash.clamp = clamp;
            lodash.clone = clone;
            lodash.cloneDeep = cloneDeep;
            lodash.cloneDeepWith = cloneDeepWith;
            lodash.cloneWith = cloneWith;
            lodash.conformsTo = conformsTo;
            lodash.deburr = deburr;
            lodash.defaultTo = defaultTo;
            lodash.divide = divide;
            lodash.endsWith = endsWith;
            lodash.eq = eq;
            lodash.escape = escape;
            lodash.escapeRegExp = escapeRegExp;
            lodash.every = every;
            lodash.find = find;
            lodash.findIndex = findIndex;
            lodash.findKey = findKey;
            lodash.findLast = findLast;
            lodash.findLastIndex = findLastIndex;
            lodash.findLastKey = findLastKey;
            lodash.floor = floor;
            lodash.forEach = forEach;
            lodash.forEachRight = forEachRight;
            lodash.forIn = forIn;
            lodash.forInRight = forInRight;
            lodash.forOwn = forOwn;
            lodash.forOwnRight = forOwnRight;
            lodash.get = get;
            lodash.gt = gt;
            lodash.gte = gte;
            lodash.has = has;
            lodash.hasIn = hasIn;
            lodash.head = head;
            lodash.identity = identity;
            lodash.includes = includes;
            lodash.indexOf = indexOf;
            lodash.inRange = inRange;
            lodash.invoke = invoke;
            lodash.isArguments = isArguments;
            lodash.isArray = isArray;
            lodash.isArrayBuffer = isArrayBuffer;
            lodash.isArrayLike = isArrayLike;
            lodash.isArrayLikeObject = isArrayLikeObject;
            lodash.isBoolean = isBoolean;
            lodash.isBuffer = isBuffer;
            lodash.isDate = isDate;
            lodash.isElement = isElement;
            lodash.isEmpty = isEmpty;
            lodash.isEqual = isEqual;
            lodash.isEqualWith = isEqualWith;
            lodash.isError = isError;
            lodash.isFinite = isFinite;
            lodash.isFunction = isFunction;
            lodash.isInteger = isInteger;
            lodash.isLength = isLength;
            lodash.isMap = isMap;
            lodash.isMatch = isMatch;
            lodash.isMatchWith = isMatchWith;
            lodash.isNaN = isNaN;
            lodash.isNative = isNative;
            lodash.isNil = isNil;
            lodash.isNull = isNull;
            lodash.isNumber = isNumber;
            lodash.isObject = isObject;
            lodash.isObjectLike = isObjectLike;
            lodash.isPlainObject = isPlainObject;
            lodash.isRegExp = isRegExp;
            lodash.isSafeInteger = isSafeInteger;
            lodash.isSet = isSet;
            lodash.isString = isString;
            lodash.isSymbol = isSymbol;
            lodash.isTypedArray = isTypedArray;
            lodash.isUndefined = isUndefined;
            lodash.isWeakMap = isWeakMap;
            lodash.isWeakSet = isWeakSet;
            lodash.join = join;
            lodash.kebabCase = kebabCase;
            lodash.last = last;
            lodash.lastIndexOf = lastIndexOf;
            lodash.lowerCase = lowerCase;
            lodash.lowerFirst = lowerFirst;
            lodash.lt = lt;
            lodash.lte = lte;
            lodash.max = max;
            lodash.maxBy = maxBy;
            lodash.mean = mean;
            lodash.meanBy = meanBy;
            lodash.min = min;
            lodash.minBy = minBy;
            lodash.stubArray = stubArray;
            lodash.stubFalse = stubFalse;
            lodash.stubObject = stubObject;
            lodash.stubString = stubString;
            lodash.stubTrue = stubTrue;
            lodash.multiply = multiply;
            lodash.nth = nth;
            lodash.noConflict = noConflict;
            lodash.noop = noop;
            lodash.now = now;
            lodash.pad = pad;
            lodash.padEnd = padEnd;
            lodash.padStart = padStart;
            lodash.parseInt = parseInt;
            lodash.random = random;
            lodash.reduce = reduce;
            lodash.reduceRight = reduceRight;
            lodash.repeat = repeat;
            lodash.replace = replace;
            lodash.result = result;
            lodash.round = round;
            lodash.runInContext = runInContext;
            lodash.sample = sample;
            lodash.size = size;
            lodash.snakeCase = snakeCase;
            lodash.some = some;
            lodash.sortedIndex = sortedIndex;
            lodash.sortedIndexBy = sortedIndexBy;
            lodash.sortedIndexOf = sortedIndexOf;
            lodash.sortedLastIndex = sortedLastIndex;
            lodash.sortedLastIndexBy = sortedLastIndexBy;
            lodash.sortedLastIndexOf = sortedLastIndexOf;
            lodash.startCase = startCase;
            lodash.startsWith = startsWith;
            lodash.subtract = subtract;
            lodash.sum = sum;
            lodash.sumBy = sumBy;
            lodash.template = template;
            lodash.times = times;
            lodash.toFinite = toFinite;
            lodash.toInteger = toInteger;
            lodash.toLength = toLength;
            lodash.toLower = toLower;
            lodash.toNumber = toNumber;
            lodash.toSafeInteger = toSafeInteger;
            lodash.toString = toString;
            lodash.toUpper = toUpper;
            lodash.trim = trim;
            lodash.trimEnd = trimEnd;
            lodash.trimStart = trimStart;
            lodash.truncate = truncate;
            lodash.unescape = unescape;
            lodash.uniqueId = uniqueId;
            lodash.upperCase = upperCase;
            lodash.upperFirst = upperFirst; // Add aliases.

            lodash.each = forEach;
            lodash.eachRight = forEachRight;
            lodash.first = head;
            mixin(lodash, function () {
              var source = {};
              baseForOwn(lodash, function (func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) {
                  source[methodName] = func;
                }
              });
              return source;
            }(), {
              'chain': false
            });
            /*------------------------------------------------------------------------*/

            /**
             * The semantic version number.
             *
             * @static
             * @memberOf _
             * @type {string}
             */

            lodash.VERSION = VERSION; // Assign default placeholders.

            arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
              lodash[methodName].placeholder = lodash;
            }); // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.

            arrayEach(['drop', 'take'], function (methodName, index) {
              LazyWrapper.prototype[methodName] = function (n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();

                if (result.__filtered__) {
                  result.__takeCount__ = nativeMin(n, result.__takeCount__);
                } else {
                  result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                  });
                }

                return result;
              };

              LazyWrapper.prototype[methodName + 'Right'] = function (n) {
                return this.reverse()[methodName](n).reverse();
              };
            }); // Add `LazyWrapper` methods that accept an `iteratee` value.

            arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
              var type = index + 1,
                  isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

              LazyWrapper.prototype[methodName] = function (iteratee) {
                var result = this.clone();

                result.__iteratees__.push({
                  'iteratee': getIteratee(iteratee, 3),
                  'type': type
                });

                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
              };
            }); // Add `LazyWrapper` methods for `_.head` and `_.last`.

            arrayEach(['head', 'last'], function (methodName, index) {
              var takeName = 'take' + (index ? 'Right' : '');

              LazyWrapper.prototype[methodName] = function () {
                return this[takeName](1).value()[0];
              };
            }); // Add `LazyWrapper` methods for `_.initial` and `_.tail`.

            arrayEach(['initial', 'tail'], function (methodName, index) {
              var dropName = 'drop' + (index ? '' : 'Right');

              LazyWrapper.prototype[methodName] = function () {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
              };
            });

            LazyWrapper.prototype.compact = function () {
              return this.filter(identity);
            };

            LazyWrapper.prototype.find = function (predicate) {
              return this.filter(predicate).head();
            };

            LazyWrapper.prototype.findLast = function (predicate) {
              return this.reverse().find(predicate);
            };

            LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
              if (typeof path == 'function') {
                return new LazyWrapper(this);
              }

              return this.map(function (value) {
                return baseInvoke(value, path, args);
              });
            });

            LazyWrapper.prototype.reject = function (predicate) {
              return this.filter(negate(getIteratee(predicate)));
            };

            LazyWrapper.prototype.slice = function (start, end) {
              start = toInteger(start);
              var result = this;

              if (result.__filtered__ && (start > 0 || end < 0)) {
                return new LazyWrapper(result);
              }

              if (start < 0) {
                result = result.takeRight(-start);
              } else if (start) {
                result = result.drop(start);
              }

              if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
              }

              return result;
            };

            LazyWrapper.prototype.takeRightWhile = function (predicate) {
              return this.reverse().takeWhile(predicate).reverse();
            };

            LazyWrapper.prototype.toArray = function () {
              return this.take(MAX_ARRAY_LENGTH);
            }; // Add `LazyWrapper` methods to `lodash.prototype`.


            baseForOwn(LazyWrapper.prototype, function (func, methodName) {
              var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
                  isTaker = /^(?:head|last)$/.test(methodName),
                  lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
                  retUnwrapped = isTaker || /^find/.test(methodName);

              if (!lodashFunc) {
                return;
              }

              lodash.prototype[methodName] = function () {
                var value = this.__wrapped__,
                    args = isTaker ? [1] : arguments,
                    isLazy = value instanceof LazyWrapper,
                    iteratee = args[0],
                    useLazy = isLazy || isArray(value);

                var interceptor = function interceptor(value) {
                  var result = lodashFunc.apply(lodash, arrayPush([value], args));
                  return isTaker && chainAll ? result[0] : result;
                };

                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
                  // Avoid lazy use if the iteratee has a "length" value other than `1`.
                  isLazy = useLazy = false;
                }

                var chainAll = this.__chain__,
                    isHybrid = !!this.__actions__.length,
                    isUnwrapped = retUnwrapped && !chainAll,
                    onlyLazy = isLazy && !isHybrid;

                if (!retUnwrapped && useLazy) {
                  value = onlyLazy ? value : new LazyWrapper(this);
                  var result = func.apply(value, args);

                  result.__actions__.push({
                    'func': thru,
                    'args': [interceptor],
                    'thisArg': undefined
                  });

                  return new LodashWrapper(result, chainAll);
                }

                if (isUnwrapped && onlyLazy) {
                  return func.apply(this, args);
                }

                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
              };
            }); // Add `Array` methods to `lodash.prototype`.

            arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
              var func = arrayProto[methodName],
                  chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
                  retUnwrapped = /^(?:pop|shift)$/.test(methodName);

              lodash.prototype[methodName] = function () {
                var args = arguments;

                if (retUnwrapped && !this.__chain__) {
                  var value = this.value();
                  return func.apply(isArray(value) ? value : [], args);
                }

                return this[chainName](function (value) {
                  return func.apply(isArray(value) ? value : [], args);
                });
              };
            }); // Map minified method names to their real names.

            baseForOwn(LazyWrapper.prototype, function (func, methodName) {
              var lodashFunc = lodash[methodName];

              if (lodashFunc) {
                var key = lodashFunc.name + '',
                    names = realNames[key] || (realNames[key] = []);
                names.push({
                  'name': methodName,
                  'func': lodashFunc
                });
              }
            });
            realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
              'name': 'wrapper',
              'func': undefined
            }]; // Add methods to `LazyWrapper`.

            LazyWrapper.prototype.clone = lazyClone;
            LazyWrapper.prototype.reverse = lazyReverse;
            LazyWrapper.prototype.value = lazyValue; // Add chain sequence methods to the `lodash` wrapper.

            lodash.prototype.at = wrapperAt;
            lodash.prototype.chain = wrapperChain;
            lodash.prototype.commit = wrapperCommit;
            lodash.prototype.next = wrapperNext;
            lodash.prototype.plant = wrapperPlant;
            lodash.prototype.reverse = wrapperReverse;
            lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue; // Add lazy aliases.

            lodash.prototype.first = lodash.prototype.head;

            if (symIterator) {
              lodash.prototype[symIterator] = wrapperToIterator;
            }

            return lodash;
          };
          /*--------------------------------------------------------------------------*/
          // Export lodash.


          var _ = runInContext(); // Some AMD build optimizers, like r.js, check for condition patterns like:


          if (true) {
            // Expose Lodash on the global object to prevent errors when Lodash is
            // loaded by a script tag in the presence of an AMD loader.
            // See http://requirejs.org/docs/errors.html#mismatch for more details.
            // Use `_.noConflict` to remove Lodash from the global object.
            root._ = _; // Define as an anonymous module so, through path mapping, it can be
            // referenced as the "underscore" module.

            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return _;
            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } // Check for `exports` after `define` in case a build optimizer adds it.
          else {}
        }).call(this);
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71), __webpack_require__(212)(module));
      /***/
    },
    /* 124 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var extend = __webpack_require__(59).extend;

      var array = __webpack_require__(48);

      function factory(type, config, load, typed) {
        var latex = __webpack_require__(72);

        var matrix = load(__webpack_require__(46));
        var addScalar = load(__webpack_require__(197));
        var multiplyScalar = load(__webpack_require__(303));
        var equalScalar = load(__webpack_require__(125));
        var algorithm11 = load(__webpack_require__(234));
        var algorithm14 = load(__webpack_require__(107));
        var DenseMatrix = type.DenseMatrix;
        var SparseMatrix = type.SparseMatrix;
        /**
         * Multiply two or more values, `x * y`.
         * For matrices, the matrix product is calculated.
         *
         * Syntax:
         *
         *    math.multiply(x, y)
         *    math.multiply(x, y, z, ...)
         *
         * Examples:
         *
         *    math.multiply(4, 5.2)        // returns number 20.8
         *    math.multiply(2, 3, 4)       // returns number 24
         *
         *    const a = math.complex(2, 3)
         *    const b = math.complex(4, 1)
         *    math.multiply(a, b)          // returns Complex 5 + 14i
         *
         *    const c = [[1, 2], [4, 3]]
         *    const d = [[1, 2, 3], [3, -4, 7]]
         *    math.multiply(c, d)          // returns Array [[7, -6, 17], [13, -4, 33]]
         *
         *    const e = math.unit('2.1 km')
         *    math.multiply(3, e)          // returns Unit 6.3 km
         *
         * See also:
         *
         *    divide, prod, cross, dot
         *
         * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
         * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
         * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
         */

        var multiply = typed('multiply', extend({
          // we extend the signatures of multiplyScalar with signatures dealing with matrices
          'Array, Array': function ArrayArray(x, y) {
            // check dimensions
            _validateMatrixDimensions(array.size(x), array.size(y)); // use dense matrix implementation


            var m = multiply(matrix(x), matrix(y)); // return array or scalar

            return type.isMatrix(m) ? m.valueOf() : m;
          },
          'Matrix, Matrix': function MatrixMatrix(x, y) {
            // dimensions
            var xsize = x.size();
            var ysize = y.size(); // check dimensions

            _validateMatrixDimensions(xsize, ysize); // process dimensions


            if (xsize.length === 1) {
              // process y dimensions
              if (ysize.length === 1) {
                // Vector * Vector
                return _multiplyVectorVector(x, y, xsize[0]);
              } // Vector * Matrix


              return _multiplyVectorMatrix(x, y);
            } // process y dimensions


            if (ysize.length === 1) {
              // Matrix * Vector
              return _multiplyMatrixVector(x, y);
            } // Matrix * Matrix


            return _multiplyMatrixMatrix(x, y);
          },
          'Matrix, Array': function MatrixArray(x, y) {
            // use Matrix * Matrix implementation
            return multiply(x, matrix(y));
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            // use Matrix * Matrix implementation
            return multiply(matrix(x, y.storage()), y);
          },
          'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
          },
          'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
          },
          'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
          },
          'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
          },
          'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
          },
          'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
          },
          'any, any': multiplyScalar,
          'any, any, ...any': function anyAnyAny(x, y, rest) {
            var result = multiply(x, y);

            for (var i = 0; i < rest.length; i++) {
              result = multiply(result, rest[i]);
            }

            return result;
          }
        }, multiplyScalar.signatures));

        function _validateMatrixDimensions(size1, size2) {
          // check left operand dimensions
          switch (size1.length) {
            case 1:
              // check size2
              switch (size2.length) {
                case 1:
                  // Vector x Vector
                  if (size1[0] !== size2[0]) {
                    // throw error
                    throw new RangeError('Dimension mismatch in multiplication. Vectors must have the same length');
                  }

                  break;

                case 2:
                  // Vector x Matrix
                  if (size1[0] !== size2[0]) {
                    // throw error
                    throw new RangeError('Dimension mismatch in multiplication. Vector length (' + size1[0] + ') must match Matrix rows (' + size2[0] + ')');
                  }

                  break;

                default:
                  throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has ' + size2.length + ' dimensions)');
              }

              break;

            case 2:
              // check size2
              switch (size2.length) {
                case 1:
                  // Matrix x Vector
                  if (size1[1] !== size2[0]) {
                    // throw error
                    throw new RangeError('Dimension mismatch in multiplication. Matrix columns (' + size1[1] + ') must match Vector length (' + size2[0] + ')');
                  }

                  break;

                case 2:
                  // Matrix x Matrix
                  if (size1[1] !== size2[0]) {
                    // throw error
                    throw new RangeError('Dimension mismatch in multiplication. Matrix A columns (' + size1[1] + ') must match Matrix B rows (' + size2[0] + ')');
                  }

                  break;

                default:
                  throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has ' + size2.length + ' dimensions)');
              }

              break;

            default:
              throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix A has ' + size1.length + ' dimensions)');
          }
        }
        /**
         * C = A * B
         *
         * @param {Matrix} a            Dense Vector   (N)
         * @param {Matrix} b            Dense Vector   (N)
         *
         * @return {number}             Scalar value
         */


        function _multiplyVectorVector(a, b, n) {
          // check empty vector
          if (n === 0) {
            throw new Error('Cannot multiply two empty vectors');
          } // a dense


          var adata = a._data;
          var adt = a._datatype; // b dense

          var bdata = b._data;
          var bdt = b._datatype; // datatype

          var dt; // addScalar signature to use

          var af = addScalar; // multiplyScalar signature to use

          var mf = multiplyScalar; // process data types

          if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)

            af = typed.find(addScalar, [dt, dt]);
            mf = typed.find(multiplyScalar, [dt, dt]);
          } // result (do not initialize it with zero)


          var c = mf(adata[0], bdata[0]); // loop data

          for (var i = 1; i < n; i++) {
            // multiply and accumulate
            c = af(c, mf(adata[i], bdata[i]));
          }

          return c;
        }
        /**
         * C = A * B
         *
         * @param {Matrix} a            Dense Vector   (M)
         * @param {Matrix} b            Matrix         (MxN)
         *
         * @return {Matrix}             Dense Vector   (N)
         */


        function _multiplyVectorMatrix(a, b) {
          // process storage
          if (b.storage() !== 'dense') {
            throw new Error('Support for SparseMatrix not implemented');
          }

          return _multiplyVectorDenseMatrix(a, b);
        }
        /**
         * C = A * B
         *
         * @param {Matrix} a            Dense Vector   (M)
         * @param {Matrix} b            Dense Matrix   (MxN)
         *
         * @return {Matrix}             Dense Vector   (N)
         */


        function _multiplyVectorDenseMatrix(a, b) {
          // a dense
          var adata = a._data;
          var asize = a._size;
          var adt = a._datatype; // b dense

          var bdata = b._data;
          var bsize = b._size;
          var bdt = b._datatype; // rows & columns

          var alength = asize[0];
          var bcolumns = bsize[1]; // datatype

          var dt; // addScalar signature to use

          var af = addScalar; // multiplyScalar signature to use

          var mf = multiplyScalar; // process data types

          if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)

            af = typed.find(addScalar, [dt, dt]);
            mf = typed.find(multiplyScalar, [dt, dt]);
          } // result


          var c = []; // loop matrix columns

          for (var j = 0; j < bcolumns; j++) {
            // sum (do not initialize it with zero)
            var sum = mf(adata[0], bdata[0][j]); // loop vector

            for (var i = 1; i < alength; i++) {
              // multiply & accumulate
              sum = af(sum, mf(adata[i], bdata[i][j]));
            }

            c[j] = sum;
          } // return matrix


          return new DenseMatrix({
            data: c,
            size: [bcolumns],
            datatype: dt
          });
        }
        /**
         * C = A * B
         *
         * @param {Matrix} a            Matrix         (MxN)
         * @param {Matrix} b            Dense Vector   (N)
         *
         * @return {Matrix}             Dense Vector   (M)
         */


        var _multiplyMatrixVector = typed('_multiplyMatrixVector', {
          'DenseMatrix, any': _multiplyDenseMatrixVector,
          'SparseMatrix, any': _multiplySparseMatrixVector
        });
        /**
         * C = A * B
         *
         * @param {Matrix} a            Matrix         (MxN)
         * @param {Matrix} b            Matrix         (NxC)
         *
         * @return {Matrix}             Matrix         (MxC)
         */


        var _multiplyMatrixMatrix = typed('_multiplyMatrixMatrix', {
          'DenseMatrix, DenseMatrix': _multiplyDenseMatrixDenseMatrix,
          'DenseMatrix, SparseMatrix': _multiplyDenseMatrixSparseMatrix,
          'SparseMatrix, DenseMatrix': _multiplySparseMatrixDenseMatrix,
          'SparseMatrix, SparseMatrix': _multiplySparseMatrixSparseMatrix
        });
        /**
         * C = A * B
         *
         * @param {Matrix} a            DenseMatrix  (MxN)
         * @param {Matrix} b            Dense Vector (N)
         *
         * @return {Matrix}             Dense Vector (M)
         */


        function _multiplyDenseMatrixVector(a, b) {
          // a dense
          var adata = a._data;
          var asize = a._size;
          var adt = a._datatype; // b dense

          var bdata = b._data;
          var bdt = b._datatype; // rows & columns

          var arows = asize[0];
          var acolumns = asize[1]; // datatype

          var dt; // addScalar signature to use

          var af = addScalar; // multiplyScalar signature to use

          var mf = multiplyScalar; // process data types

          if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)

            af = typed.find(addScalar, [dt, dt]);
            mf = typed.find(multiplyScalar, [dt, dt]);
          } // result


          var c = []; // loop matrix a rows

          for (var i = 0; i < arows; i++) {
            // current row
            var row = adata[i]; // sum (do not initialize it with zero)

            var sum = mf(row[0], bdata[0]); // loop matrix a columns

            for (var j = 1; j < acolumns; j++) {
              // multiply & accumulate
              sum = af(sum, mf(row[j], bdata[j]));
            }

            c[i] = sum;
          } // return matrix


          return new DenseMatrix({
            data: c,
            size: [arows],
            datatype: dt
          });
        }
        /**
         * C = A * B
         *
         * @param {Matrix} a            DenseMatrix    (MxN)
         * @param {Matrix} b            DenseMatrix    (NxC)
         *
         * @return {Matrix}             DenseMatrix    (MxC)
         */


        function _multiplyDenseMatrixDenseMatrix(a, b) {
          // a dense
          var adata = a._data;
          var asize = a._size;
          var adt = a._datatype; // b dense

          var bdata = b._data;
          var bsize = b._size;
          var bdt = b._datatype; // rows & columns

          var arows = asize[0];
          var acolumns = asize[1];
          var bcolumns = bsize[1]; // datatype

          var dt; // addScalar signature to use

          var af = addScalar; // multiplyScalar signature to use

          var mf = multiplyScalar; // process data types

          if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)

            af = typed.find(addScalar, [dt, dt]);
            mf = typed.find(multiplyScalar, [dt, dt]);
          } // result


          var c = []; // loop matrix a rows

          for (var i = 0; i < arows; i++) {
            // current row
            var row = adata[i]; // initialize row array

            c[i] = []; // loop matrix b columns

            for (var j = 0; j < bcolumns; j++) {
              // sum (avoid initializing sum to zero)
              var sum = mf(row[0], bdata[0][j]); // loop matrix a columns

              for (var x = 1; x < acolumns; x++) {
                // multiply & accumulate
                sum = af(sum, mf(row[x], bdata[x][j]));
              }

              c[i][j] = sum;
            }
          } // return matrix


          return new DenseMatrix({
            data: c,
            size: [arows, bcolumns],
            datatype: dt
          });
        }
        /**
         * C = A * B
         *
         * @param {Matrix} a            DenseMatrix    (MxN)
         * @param {Matrix} b            SparseMatrix   (NxC)
         *
         * @return {Matrix}             SparseMatrix   (MxC)
         */


        function _multiplyDenseMatrixSparseMatrix(a, b) {
          // a dense
          var adata = a._data;
          var asize = a._size;
          var adt = a._datatype; // b sparse

          var bvalues = b._values;
          var bindex = b._index;
          var bptr = b._ptr;
          var bsize = b._size;
          var bdt = b._datatype; // validate b matrix

          if (!bvalues) {
            throw new Error('Cannot multiply Dense Matrix times Pattern only Matrix');
          } // rows & columns


          var arows = asize[0];
          var bcolumns = bsize[1]; // datatype

          var dt; // addScalar signature to use

          var af = addScalar; // multiplyScalar signature to use

          var mf = multiplyScalar; // equalScalar signature to use

          var eq = equalScalar; // zero value

          var zero = 0; // process data types

          if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)

            af = typed.find(addScalar, [dt, dt]);
            mf = typed.find(multiplyScalar, [dt, dt]);
            eq = typed.find(equalScalar, [dt, dt]); // convert 0 to the same datatype

            zero = typed.convert(0, dt);
          } // result


          var cvalues = [];
          var cindex = [];
          var cptr = []; // c matrix

          var c = new SparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [arows, bcolumns],
            datatype: dt
          }); // loop b columns

          for (var jb = 0; jb < bcolumns; jb++) {
            // update ptr
            cptr[jb] = cindex.length; // indeces in column jb

            var kb0 = bptr[jb];
            var kb1 = bptr[jb + 1]; // do not process column jb if no data exists

            if (kb1 > kb0) {
              // last row mark processed
              var last = 0; // loop a rows

              for (var i = 0; i < arows; i++) {
                // column mark
                var mark = i + 1; // C[i, jb]

                var cij = void 0; // values in b column j

                for (var kb = kb0; kb < kb1; kb++) {
                  // row
                  var ib = bindex[kb]; // check value has been initialized

                  if (last !== mark) {
                    // first value in column jb
                    cij = mf(adata[i][ib], bvalues[kb]); // update mark

                    last = mark;
                  } else {
                    // accumulate value
                    cij = af(cij, mf(adata[i][ib], bvalues[kb]));
                  }
                } // check column has been processed and value != 0


                if (last === mark && !eq(cij, zero)) {
                  // push row & value
                  cindex.push(i);
                  cvalues.push(cij);
                }
              }
            }
          } // update ptr


          cptr[bcolumns] = cindex.length; // return sparse matrix

          return c;
        }
        /**
         * C = A * B
         *
         * @param {Matrix} a            SparseMatrix    (MxN)
         * @param {Matrix} b            Dense Vector (N)
         *
         * @return {Matrix}             SparseMatrix    (M, 1)
         */


        function _multiplySparseMatrixVector(a, b) {
          // a sparse
          var avalues = a._values;
          var aindex = a._index;
          var aptr = a._ptr;
          var adt = a._datatype; // validate a matrix

          if (!avalues) {
            throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');
          } // b dense


          var bdata = b._data;
          var bdt = b._datatype; // rows & columns

          var arows = a._size[0];
          var brows = b._size[0]; // result

          var cvalues = [];
          var cindex = [];
          var cptr = []; // datatype

          var dt; // addScalar signature to use

          var af = addScalar; // multiplyScalar signature to use

          var mf = multiplyScalar; // equalScalar signature to use

          var eq = equalScalar; // zero value

          var zero = 0; // process data types

          if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)

            af = typed.find(addScalar, [dt, dt]);
            mf = typed.find(multiplyScalar, [dt, dt]);
            eq = typed.find(equalScalar, [dt, dt]); // convert 0 to the same datatype

            zero = typed.convert(0, dt);
          } // workspace


          var x = []; // vector with marks indicating a value x[i] exists in a given column

          var w = []; // update ptr

          cptr[0] = 0; // rows in b

          for (var ib = 0; ib < brows; ib++) {
            // b[ib]
            var vbi = bdata[ib]; // check b[ib] != 0, avoid loops

            if (!eq(vbi, zero)) {
              // A values & index in ib column
              for (var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
                // a row
                var ia = aindex[ka]; // check value exists in current j

                if (!w[ia]) {
                  // ia is new entry in j
                  w[ia] = true; // add i to pattern of C

                  cindex.push(ia); // x(ia) = A

                  x[ia] = mf(vbi, avalues[ka]);
                } else {
                  // i exists in C already
                  x[ia] = af(x[ia], mf(vbi, avalues[ka]));
                }
              }
            }
          } // copy values from x to column jb of c


          for (var p1 = cindex.length, p = 0; p < p1; p++) {
            // row
            var ic = cindex[p]; // copy value

            cvalues[p] = x[ic];
          } // update ptr


          cptr[1] = cindex.length; // return sparse matrix

          return new SparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [arows, 1],
            datatype: dt
          });
        }
        /**
         * C = A * B
         *
         * @param {Matrix} a            SparseMatrix      (MxN)
         * @param {Matrix} b            DenseMatrix       (NxC)
         *
         * @return {Matrix}             SparseMatrix      (MxC)
         */


        function _multiplySparseMatrixDenseMatrix(a, b) {
          // a sparse
          var avalues = a._values;
          var aindex = a._index;
          var aptr = a._ptr;
          var adt = a._datatype; // validate a matrix

          if (!avalues) {
            throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');
          } // b dense


          var bdata = b._data;
          var bdt = b._datatype; // rows & columns

          var arows = a._size[0];
          var brows = b._size[0];
          var bcolumns = b._size[1]; // datatype

          var dt; // addScalar signature to use

          var af = addScalar; // multiplyScalar signature to use

          var mf = multiplyScalar; // equalScalar signature to use

          var eq = equalScalar; // zero value

          var zero = 0; // process data types

          if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)

            af = typed.find(addScalar, [dt, dt]);
            mf = typed.find(multiplyScalar, [dt, dt]);
            eq = typed.find(equalScalar, [dt, dt]); // convert 0 to the same datatype

            zero = typed.convert(0, dt);
          } // result


          var cvalues = [];
          var cindex = [];
          var cptr = []; // c matrix

          var c = new SparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [arows, bcolumns],
            datatype: dt
          }); // workspace

          var x = []; // vector with marks indicating a value x[i] exists in a given column

          var w = []; // loop b columns

          for (var jb = 0; jb < bcolumns; jb++) {
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column

            var mark = jb + 1; // rows in jb

            for (var ib = 0; ib < brows; ib++) {
              // b[ib, jb]
              var vbij = bdata[ib][jb]; // check b[ib, jb] != 0, avoid loops

              if (!eq(vbij, zero)) {
                // A values & index in ib column
                for (var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
                  // a row
                  var ia = aindex[ka]; // check value exists in current j

                  if (w[ia] !== mark) {
                    // ia is new entry in j
                    w[ia] = mark; // add i to pattern of C

                    cindex.push(ia); // x(ia) = A

                    x[ia] = mf(vbij, avalues[ka]);
                  } else {
                    // i exists in C already
                    x[ia] = af(x[ia], mf(vbij, avalues[ka]));
                  }
                }
              }
            } // copy values from x to column jb of c


            for (var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++) {
              // row
              var ic = cindex[p]; // copy value

              cvalues[p] = x[ic];
            }
          } // update ptr


          cptr[bcolumns] = cindex.length; // return sparse matrix

          return c;
        }
        /**
         * C = A * B
         *
         * @param {Matrix} a            SparseMatrix      (MxN)
         * @param {Matrix} b            SparseMatrix      (NxC)
         *
         * @return {Matrix}             SparseMatrix      (MxC)
         */


        function _multiplySparseMatrixSparseMatrix(a, b) {
          // a sparse
          var avalues = a._values;
          var aindex = a._index;
          var aptr = a._ptr;
          var adt = a._datatype; // b sparse

          var bvalues = b._values;
          var bindex = b._index;
          var bptr = b._ptr;
          var bdt = b._datatype; // rows & columns

          var arows = a._size[0];
          var bcolumns = b._size[1]; // flag indicating both matrices (a & b) contain data

          var values = avalues && bvalues; // datatype

          var dt; // addScalar signature to use

          var af = addScalar; // multiplyScalar signature to use

          var mf = multiplyScalar; // process data types

          if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)

            af = typed.find(addScalar, [dt, dt]);
            mf = typed.find(multiplyScalar, [dt, dt]);
          } // result


          var cvalues = values ? [] : undefined;
          var cindex = [];
          var cptr = []; // c matrix

          var c = new SparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [arows, bcolumns],
            datatype: dt
          }); // workspace

          var x = values ? [] : undefined; // vector with marks indicating a value x[i] exists in a given column

          var w = []; // variables

          var ka, ka0, ka1, kb, kb0, kb1, ia, ib; // loop b columns

          for (var jb = 0; jb < bcolumns; jb++) {
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column

            var mark = jb + 1; // B values & index in j

            for (kb0 = bptr[jb], kb1 = bptr[jb + 1], kb = kb0; kb < kb1; kb++) {
              // b row
              ib = bindex[kb]; // check we need to process values

              if (values) {
                // loop values in a[:,ib]
                for (ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
                  // row
                  ia = aindex[ka]; // check value exists in current j

                  if (w[ia] !== mark) {
                    // ia is new entry in j
                    w[ia] = mark; // add i to pattern of C

                    cindex.push(ia); // x(ia) = A

                    x[ia] = mf(bvalues[kb], avalues[ka]);
                  } else {
                    // i exists in C already
                    x[ia] = af(x[ia], mf(bvalues[kb], avalues[ka]));
                  }
                }
              } else {
                // loop values in a[:,ib]
                for (ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
                  // row
                  ia = aindex[ka]; // check value exists in current j

                  if (w[ia] !== mark) {
                    // ia is new entry in j
                    w[ia] = mark; // add i to pattern of C

                    cindex.push(ia);
                  }
                }
              }
            } // check we need to process matrix values (pattern matrix)


            if (values) {
              // copy values from x to column jb of c
              for (var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++) {
                // row
                var ic = cindex[p]; // copy value

                cvalues[p] = x[ic];
              }
            }
          } // update ptr


          cptr[bcolumns] = cindex.length; // return sparse matrix

          return c;
        }

        multiply.toTex = {
          2: "\\left(${args[0]}".concat(latex.operators['multiply'], "${args[1]}\\right)")
        };
        return multiply;
      }

      exports.name = 'multiply';
      exports.factory = factory;
      /***/
    },
    /* 125 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var nearlyEqual = __webpack_require__(67).nearlyEqual;

      var bigNearlyEqual = __webpack_require__(130);

      function factory(type, config, load, typed) {
        /**
         * Test whether two values are equal.
         *
         * @param  {number | BigNumber | Fraction | boolean | Complex | Unit} x   First value to compare
         * @param  {number | BigNumber | Fraction | boolean | Complex} y          Second value to compare
         * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
         * @private
         */
        var equalScalar = typed('equalScalar', {
          'boolean, boolean': function booleanBoolean(x, y) {
            return x === y;
          },
          'number, number': function numberNumber(x, y) {
            return x === y || nearlyEqual(x, y, config.epsilon);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.eq(y) || bigNearlyEqual(x, y, config.epsilon);
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return x.equals(y);
          },
          'Complex, Complex': function ComplexComplex(x, y) {
            return x.equals(y);
          },
          'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) {
              throw new Error('Cannot compare units with different base');
            }

            return equalScalar(x.value, y.value);
          }
        });
        return equalScalar;
      }

      exports.factory = factory;
      /***/
    },
    /* 126 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _omit = __webpack_require__(45);

      var _omit2 = _interopRequireDefault(_omit);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var Icon = function Icon(props) {
        var type = props.type,
            _props$className = props.className,
            className = _props$className === undefined ? '' : _props$className,
            spin = props.spin;
        var classString = (0, _classnames2['default'])((0, _defineProperty3['default'])({
          anticon: true,
          'anticon-spin': !!spin || type === 'loading'
        }, 'anticon-' + type, true), className);
        return React.createElement('i', (0, _extends3['default'])({}, (0, _omit2['default'])(props, ['type', 'spin']), {
          className: classString
        }));
      };

      exports['default'] = Icon;
      module.exports = exports['default'];
      /***/
    },
    /* 127 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule generateRandomKey
       * @format
       * 
       */

      var seenKeys = {};
      var MULTIPLIER = Math.pow(2, 24);

      function generateRandomKey() {
        var key = void 0;

        while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
          key = Math.floor(Math.random() * MULTIPLIER).toString(32);
        }

        seenKeys[key] = true;
        return key;
      }

      module.exports = generateRandomKey;
      /***/
    },
    /* 128 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js

      var defineProperty = __webpack_require__(6);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js


      var createClass = __webpack_require__(12);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js


      var helpers_typeof = __webpack_require__(49);

      var typeof_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_typeof); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}


      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_ = __webpack_require__(16);

      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/addEventListener.js


      var addEventListener = __webpack_require__(57); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // EXTERNAL MODULE: ./node_modules/shallowequal/index.js


      var shallowequal = __webpack_require__(56);

      var shallowequal_default =
      /*#__PURE__*/
      __webpack_require__.n(shallowequal); // EXTERNAL MODULE: ./node_modules/omit.js/es/index.js


      var es = __webpack_require__(45); // CONCATENATED MODULE: ./node_modules/antd/es/_util/getScroll.js


      function getScroll_getScroll(target, top) {
        if (typeof window === 'undefined') {
          return 0;
        }

        var prop = top ? 'pageYOffset' : 'pageXOffset';
        var method = top ? 'scrollTop' : 'scrollLeft';
        var isWindow = target === window;
        var ret = isWindow ? target[prop] : target[method]; // ie6,7,8 standard mode

        if (isWindow && typeof ret !== 'number') {
          ret = window.document.documentElement[method];
        }

        return ret;
      } // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js


      var toConsumableArray = __webpack_require__(65);

      var toConsumableArray_default =
      /*#__PURE__*/
      __webpack_require__.n(toConsumableArray); // CONCATENATED MODULE: ./node_modules/antd/es/_util/getRequestAnimationFrame.js


      var availablePrefixs = ['moz', 'ms', 'webkit'];

      function requestAnimationFramePolyfill() {
        var lastTime = 0;
        return function (callback) {
          var currTime = new Date().getTime();
          var timeToCall = Math.max(0, 16 - (currTime - lastTime));
          var id = window.setTimeout(function () {
            callback(currTime + timeToCall);
          }, timeToCall);
          lastTime = currTime + timeToCall;
          return id;
        };
      }

      function getRequestAnimationFrame() {
        if (typeof window === 'undefined') {
          return function () {};
        }

        if (window.requestAnimationFrame) {
          // https://github.com/vuejs/vue/issues/4465
          return window.requestAnimationFrame.bind(window);
        }

        var prefix = availablePrefixs.filter(function (key) {
          return key + 'RequestAnimationFrame' in window;
        })[0];
        return prefix ? window[prefix + 'RequestAnimationFrame'] : requestAnimationFramePolyfill();
      }

      function cancelRequestAnimationFrame(id) {
        if (typeof window === 'undefined') {
          return null;
        }

        if (window.cancelAnimationFrame) {
          return window.cancelAnimationFrame(id);
        }

        var prefix = availablePrefixs.filter(function (key) {
          return key + 'CancelAnimationFrame' in window || key + 'CancelRequestAnimationFrame' in window;
        })[0];
        return prefix ? (window[prefix + 'CancelAnimationFrame'] || window[prefix + 'CancelRequestAnimationFrame']).call(this, id) : clearTimeout(id);
      } // CONCATENATED MODULE: ./node_modules/antd/es/_util/throttleByAnimationFrame.js


      var throttleByAnimationFrame_reqAnimFrame = getRequestAnimationFrame();

      function throttleByAnimationFrame_throttleByAnimationFrame(fn) {
        var requestId = void 0;

        var later = function later(args) {
          return function () {
            requestId = null;
            fn.apply(undefined, toConsumableArray_default()(args));
          };
        };

        var throttled = function throttled() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (requestId == null) {
            requestId = throttleByAnimationFrame_reqAnimFrame(later(args));
          }
        };

        throttled.cancel = function () {
          return cancelRequestAnimationFrame(requestId);
        };

        return throttled;
      }

      function throttleByAnimationFrame_throttleByAnimationFrameDecorator() {
        return function (target, key, descriptor) {
          var fn = descriptor.value;
          var definingProperty = false;
          return {
            configurable: true,
            get: function get() {
              if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
                return fn;
              }

              var boundFn = throttleByAnimationFrame_throttleByAnimationFrame(fn.bind(this));
              definingProperty = true;
              Object.defineProperty(this, key, {
                value: boundFn,
                configurable: true,
                writable: true
              });
              definingProperty = false;
              return boundFn;
            }
          };
        };
      } // CONCATENATED MODULE: ./node_modules/antd/es/affix/index.js


      var affix_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if ((typeof Reflect === "undefined" ? "undefined" : typeof_default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
          if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        }
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };

      function affix_getTargetRect(target) {
        return target !== window ? target.getBoundingClientRect() : {
          top: 0,
          left: 0,
          bottom: 0
        };
      }

      function affix_getOffset(element, target) {
        var elemRect = element.getBoundingClientRect();
        var targetRect = affix_getTargetRect(target);
        var scrollTop = getScroll_getScroll(target, true);
        var scrollLeft = getScroll_getScroll(target, false);
        var docElem = window.document.body;
        var clientTop = docElem.clientTop || 0;
        var clientLeft = docElem.clientLeft || 0;
        return {
          top: elemRect.top - targetRect.top + scrollTop - clientTop,
          left: elemRect.left - targetRect.left + scrollLeft - clientLeft,
          width: elemRect.width,
          height: elemRect.height
        };
      }

      function affix_noop() {}

      function affix_getDefaultTarget() {
        return typeof window !== 'undefined' ? window : null;
      }

      var affix_Affix = function (_React$Component) {
        inherits_default()(Affix, _React$Component);

        function Affix() {
          classCallCheck_default()(this, Affix);

          var _this = possibleConstructorReturn_default()(this, (Affix.__proto__ || Object.getPrototypeOf(Affix)).apply(this, arguments));

          _this.events = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'];
          _this.eventHandlers = {};
          _this.state = {
            affixStyle: undefined,
            placeholderStyle: undefined
          };

          _this.saveFixedNode = function (node) {
            _this.fixedNode = node;
          };

          _this.savePlaceholderNode = function (node) {
            _this.placeholderNode = node;
          };

          return _this;
        }

        createClass_default()(Affix, [{
          key: "setAffixStyle",
          value: function setAffixStyle(e, affixStyle) {
            var _this2 = this;

            var _props = this.props,
                _props$onChange = _props.onChange,
                onChange = _props$onChange === undefined ? affix_noop : _props$onChange,
                _props$target = _props.target,
                target = _props$target === undefined ? affix_getDefaultTarget : _props$target;
            var originalAffixStyle = this.state.affixStyle;
            var isWindow = target() === window;

            if (e.type === 'scroll' && originalAffixStyle && affixStyle && isWindow) {
              return;
            }

            if (shallowequal_default()(affixStyle, originalAffixStyle)) {
              return;
            }

            this.setState({
              affixStyle: affixStyle
            }, function () {
              var affixed = !!_this2.state.affixStyle;

              if (affixStyle && !originalAffixStyle || !affixStyle && originalAffixStyle) {
                onChange(affixed);
              }
            });
          }
        }, {
          key: "setPlaceholderStyle",
          value: function setPlaceholderStyle(placeholderStyle) {
            var originalPlaceholderStyle = this.state.placeholderStyle;

            if (shallowequal_default()(placeholderStyle, originalPlaceholderStyle)) {
              return;
            }

            this.setState({
              placeholderStyle: placeholderStyle
            });
          }
        }, {
          key: "syncPlaceholderStyle",
          value: function syncPlaceholderStyle(e) {
            var affixStyle = this.state.affixStyle;

            if (!affixStyle) {
              return;
            }

            this.placeholderNode.style.cssText = '';
            this.setAffixStyle(e, extends_default()({}, affixStyle, {
              width: this.placeholderNode.offsetWidth
            }));
            this.setPlaceholderStyle({
              width: this.placeholderNode.offsetWidth
            });
          }
        }, {
          key: "updatePosition",
          value: function updatePosition(e) {
            var _props2 = this.props,
                offsetTop = _props2.offsetTop,
                offsetBottom = _props2.offsetBottom,
                offset = _props2.offset,
                _props2$target = _props2.target,
                target = _props2$target === undefined ? affix_getDefaultTarget : _props2$target;
            var targetNode = target(); // Backwards support

            offsetTop = offsetTop || offset;
            var scrollTop = getScroll_getScroll(targetNode, true);
            var affixNode = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](this);
            var elemOffset = affix_getOffset(affixNode, targetNode);
            var elemSize = {
              width: this.fixedNode.offsetWidth,
              height: this.fixedNode.offsetHeight
            };
            var offsetMode = {
              top: false,
              bottom: false
            }; // Default to `offsetTop=0`.

            if (typeof offsetTop !== 'number' && typeof offsetBottom !== 'number') {
              offsetMode.top = true;
              offsetTop = 0;
            } else {
              offsetMode.top = typeof offsetTop === 'number';
              offsetMode.bottom = typeof offsetBottom === 'number';
            }

            var targetRect = affix_getTargetRect(targetNode);
            var targetInnerHeight = targetNode.innerHeight || targetNode.clientHeight;

            if (scrollTop > elemOffset.top - offsetTop && offsetMode.top) {
              // Fixed Top
              var width = elemOffset.width;
              var top = targetRect.top + offsetTop;
              this.setAffixStyle(e, {
                position: 'fixed',
                top: top,
                left: targetRect.left + elemOffset.left,
                width: width
              });
              this.setPlaceholderStyle({
                width: width,
                height: elemSize.height
              });
            } else if (scrollTop < elemOffset.top + elemSize.height + offsetBottom - targetInnerHeight && offsetMode.bottom) {
              // Fixed Bottom
              var targetBottomOffet = targetNode === window ? 0 : window.innerHeight - targetRect.bottom;
              var _width = elemOffset.width;
              this.setAffixStyle(e, {
                position: 'fixed',
                bottom: targetBottomOffet + offsetBottom,
                left: targetRect.left + elemOffset.left,
                width: _width
              });
              this.setPlaceholderStyle({
                width: _width,
                height: elemOffset.height
              });
            } else {
              var affixStyle = this.state.affixStyle;

              if (e.type === 'resize' && affixStyle && affixStyle.position === 'fixed' && affixNode.offsetWidth) {
                this.setAffixStyle(e, extends_default()({}, affixStyle, {
                  width: affixNode.offsetWidth
                }));
              } else {
                this.setAffixStyle(e, null);
              }

              this.setPlaceholderStyle(null);
            }

            if (e.type === 'resize') {
              this.syncPlaceholderStyle(e);
            }
          }
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            var _this3 = this;

            var target = this.props.target || affix_getDefaultTarget; // Wait for parent component ref has its value

            this.timeout = setTimeout(function () {
              _this3.setTargetEventListeners(target);
            });
          }
        }, {
          key: "componentWillReceiveProps",
          value: function componentWillReceiveProps(nextProps) {
            if (this.props.target !== nextProps.target) {
              this.clearEventListeners();
              this.setTargetEventListeners(nextProps.target); // Mock Event object.

              this.updatePosition({});
            }
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.clearEventListeners();
            clearTimeout(this.timeout);
            this.updatePosition.cancel();
          }
        }, {
          key: "setTargetEventListeners",
          value: function setTargetEventListeners(getTarget) {
            var _this4 = this;

            var target = getTarget();

            if (!target) {
              return;
            }

            this.clearEventListeners();
            this.events.forEach(function (eventName) {
              _this4.eventHandlers[eventName] = Object(addEventListener["a"
              /* default */
              ])(target, eventName, _this4.updatePosition);
            });
          }
        }, {
          key: "clearEventListeners",
          value: function clearEventListeners() {
            var _this5 = this;

            this.events.forEach(function (eventName) {
              var handler = _this5.eventHandlers[eventName];

              if (handler && handler.remove) {
                handler.remove();
              }
            });
          }
        }, {
          key: "render",
          value: function render() {
            var className = classnames_default()(defineProperty_default()({}, this.props.prefixCls || 'ant-affix', this.state.affixStyle));
            var props = Object(es["default"])(this.props, ['prefixCls', 'offsetTop', 'offsetBottom', 'target', 'onChange']);
            var placeholderStyle = extends_default()({}, this.state.placeholderStyle, this.props.style);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", extends_default()({}, props, {
              style: placeholderStyle,
              ref: this.savePlaceholderNode
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
              className: className,
              ref: this.saveFixedNode,
              style: this.state.affixStyle
            }, this.props.children));
          }
        }]);
        return Affix;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_affix = affix_Affix;
      affix_Affix.propTypes = {
        offsetTop: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        offsetBottom: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        target: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      affix_decorate([throttleByAnimationFrame_throttleByAnimationFrameDecorator()], affix_Affix.prototype, "updatePosition", null); // CONCATENATED MODULE: ./node_modules/antd/es/anchor/Anchor.js

      function Anchor_getDefaultContainer() {
        return window;
      }

      function Anchor_getOffsetTop(element, container) {
        if (!element) {
          return 0;
        }

        if (!element.getClientRects().length) {
          return 0;
        }

        var rect = element.getBoundingClientRect();

        if (rect.width || rect.height) {
          if (container === window) {
            container = element.ownerDocument.documentElement;
            return rect.top - container.clientTop;
          }

          return rect.top - container.getBoundingClientRect().top;
        }

        return rect.top;
      }

      function Anchor_easeInOutCubic(t, b, c, d) {
        var cc = c - b;
        t /= d / 2;

        if (t < 1) {
          return cc / 2 * t * t * t + b;
        }

        return cc / 2 * ((t -= 2) * t * t + 2) + b;
      }

      var Anchor_reqAnimFrame = getRequestAnimationFrame();
      var Anchor_sharpMatcherRegx = /#([^#]+)$/;

      function Anchor_scrollTo(href) {
        var offsetTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var getContainer = arguments[2];
        var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
        var container = getContainer();
        var scrollTop = getScroll_getScroll(container, true);
        var sharpLinkMatch = Anchor_sharpMatcherRegx.exec(href);

        if (!sharpLinkMatch) {
          return;
        }

        var targetElement = document.getElementById(sharpLinkMatch[1]);

        if (!targetElement) {
          return;
        }

        var eleOffsetTop = Anchor_getOffsetTop(targetElement, container);
        var targetScrollTop = scrollTop + eleOffsetTop - offsetTop;
        var startTime = Date.now();

        var frameFunc = function frameFunc() {
          var timestamp = Date.now();
          var time = timestamp - startTime;
          var nextScrollTop = Anchor_easeInOutCubic(time, scrollTop, targetScrollTop, 450);

          if (container === window) {
            window.scrollTo(window.pageXOffset, nextScrollTop);
          } else {
            container.scrollTop = nextScrollTop;
          }

          if (time < 450) {
            Anchor_reqAnimFrame(frameFunc);
          } else {
            callback();
          }
        };

        Anchor_reqAnimFrame(frameFunc);
        history.pushState(null, '', href);
      }

      var Anchor_Anchor = function (_React$Component) {
        inherits_default()(Anchor, _React$Component);

        function Anchor(props) {
          classCallCheck_default()(this, Anchor);

          var _this = possibleConstructorReturn_default()(this, (Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call(this, props));

          _this.handleScroll = function () {
            if (_this.animating) {
              return;
            }

            var _this$props = _this.props,
                offsetTop = _this$props.offsetTop,
                bounds = _this$props.bounds;

            _this.setState({
              activeLink: _this.getCurrentAnchor(offsetTop, bounds)
            });
          };

          _this.handleScrollTo = function (link) {
            var _this$props2 = _this.props,
                offsetTop = _this$props2.offsetTop,
                getContainer = _this$props2.getContainer;
            _this.animating = true;

            _this.setState({
              activeLink: link
            });

            Anchor_scrollTo(link, offsetTop, getContainer, function () {
              _this.animating = false;
            });
          };

          _this.updateInk = function () {
            if (typeof document === 'undefined') {
              return;
            }

            var prefixCls = _this.props.prefixCls;
            var linkNode = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](_this).getElementsByClassName(prefixCls + '-link-title-active')[0];

            if (linkNode) {
              _this.inkNode.style.top = linkNode.offsetTop + linkNode.clientHeight / 2 - 4.5 + 'px';
            }
          };

          _this.saveInkNode = function (node) {
            _this.inkNode = node;
          };

          _this.state = {
            activeLink: null
          };
          _this.links = [];
          return _this;
        }

        createClass_default()(Anchor, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              antAnchor: {
                registerLink: function registerLink(link) {
                  if (!_this2.links.includes(link)) {
                    _this2.links.push(link);
                  }
                },
                unregisterLink: function unregisterLink(link) {
                  var index = _this2.links.indexOf(link);

                  if (index !== -1) {
                    _this2.links.splice(index, 1);
                  }
                },
                activeLink: this.state.activeLink,
                scrollTo: this.handleScrollTo
              }
            };
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            var getContainer = this.props.getContainer;
            this.scrollEvent = Object(addEventListener["a"
            /* default */
            ])(getContainer(), 'scroll', this.handleScroll);
            this.handleScroll();
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.scrollEvent) {
              this.scrollEvent.remove();
            }
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            this.updateInk();
          }
        }, {
          key: 'getCurrentAnchor',
          value: function getCurrentAnchor() {
            var offsetTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var bounds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
            var activeLink = '';

            if (typeof document === 'undefined') {
              return activeLink;
            }

            var linkSections = [];
            var getContainer = this.props.getContainer;
            var container = getContainer();
            this.links.forEach(function (link) {
              var sharpLinkMatch = Anchor_sharpMatcherRegx.exec(link.toString());

              if (!sharpLinkMatch) {
                return;
              }

              var target = document.getElementById(sharpLinkMatch[1]);

              if (target) {
                var top = Anchor_getOffsetTop(target, container);

                if (top < offsetTop + bounds) {
                  linkSections.push({
                    link: link,
                    top: top
                  });
                }
              }
            });

            if (linkSections.length) {
              var maxSection = linkSections.reduce(function (prev, curr) {
                return curr.top > prev.top ? curr : prev;
              });
              return maxSection.link;
            }

            return '';
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                style = _props.style,
                offsetTop = _props.offsetTop,
                affix = _props.affix,
                showInkInFixed = _props.showInkInFixed,
                children = _props.children;
            var activeLink = this.state.activeLink;
            var inkClass = classnames_default()(prefixCls + '-ink-ball', {
              visible: activeLink
            });
            var wrapperClass = classnames_default()(className, prefixCls + '-wrapper');
            var anchorClass = classnames_default()(prefixCls, {
              'fixed': !affix && !showInkInFixed
            });
            var wrapperStyle = extends_default()({
              maxHeight: offsetTop ? 'calc(100vh - ' + offsetTop + 'px)' : '100vh'
            }, style);
            var anchorContent = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: wrapperClass,
              style: wrapperStyle
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: anchorClass
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-ink'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: inkClass,
              ref: this.saveInkNode
            })), children));
            return !affix ? anchorContent : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_affix, {
              offsetTop: offsetTop
            }, anchorContent);
          }
        }]);
        return Anchor;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var anchor_Anchor = Anchor_Anchor;
      Anchor_Anchor.defaultProps = {
        prefixCls: 'ant-anchor',
        affix: true,
        showInkInFixed: false,
        getContainer: Anchor_getDefaultContainer
      };
      Anchor_Anchor.childContextTypes = {
        antAnchor: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      }; // CONCATENATED MODULE: ./node_modules/antd/es/anchor/AnchorLink.js

      var AnchorLink_AnchorLink = function (_React$Component) {
        inherits_default()(AnchorLink, _React$Component);

        function AnchorLink() {
          classCallCheck_default()(this, AnchorLink);

          var _this = possibleConstructorReturn_default()(this, (AnchorLink.__proto__ || Object.getPrototypeOf(AnchorLink)).apply(this, arguments));

          _this.handleClick = function () {
            _this.context.antAnchor.scrollTo(_this.props.href);
          };

          return _this;
        }

        createClass_default()(AnchorLink, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.context.antAnchor.registerLink(this.props.href);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this.context.antAnchor.unregisterLink(this.props.href);
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                href = _props.href,
                title = _props.title,
                children = _props.children;
            var active = this.context.antAnchor.activeLink === href;
            var wrapperClassName = classnames_default()(prefixCls + '-link', defineProperty_default()({}, prefixCls + '-link-active', active));
            var titleClassName = classnames_default()(prefixCls + '-link-title', defineProperty_default()({}, prefixCls + '-link-title-active', active));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: wrapperClassName
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', {
              className: titleClassName,
              href: href,
              title: typeof title === 'string' ? title : '',
              onClick: this.handleClick
            }, title), children);
          }
        }]);
        return AnchorLink;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var anchor_AnchorLink = AnchorLink_AnchorLink;
      AnchorLink_AnchorLink.defaultProps = {
        prefixCls: 'ant-anchor',
        href: '#'
      };
      AnchorLink_AnchorLink.contextTypes = {
        antAnchor: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      }; // CONCATENATED MODULE: ./node_modules/antd/es/anchor/index.js

      anchor_Anchor.Link = anchor_AnchorLink;
      /* harmony default export */

      var es_anchor = anchor_Anchor; // EXTERNAL MODULE: ./node_modules/rc-select/es/index.js + 7 modules

      var rc_select_es = __webpack_require__(105); // CONCATENATED MODULE: ./node_modules/antd/es/locale-provider/LocaleReceiver.js


      var LocaleReceiver_LocaleReceiver = function (_React$Component) {
        inherits_default()(LocaleReceiver, _React$Component);

        function LocaleReceiver() {
          classCallCheck_default()(this, LocaleReceiver);
          return possibleConstructorReturn_default()(this, (LocaleReceiver.__proto__ || Object.getPrototypeOf(LocaleReceiver)).apply(this, arguments));
        }

        createClass_default()(LocaleReceiver, [{
          key: 'getLocale',
          value: function getLocale() {
            var _props = this.props,
                componentName = _props.componentName,
                defaultLocale = _props.defaultLocale;
            var antLocale = this.context.antLocale;
            var localeFromContext = antLocale && antLocale[componentName];
            return extends_default()({}, typeof defaultLocale === 'function' ? defaultLocale() : defaultLocale, localeFromContext || {});
          }
        }, {
          key: 'getLocaleCode',
          value: function getLocaleCode() {
            var antLocale = this.context.antLocale;
            var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale

            if (antLocale && antLocale.exist && !localeCode) {
              return 'en-us';
            }

            return localeCode;
          }
        }, {
          key: 'render',
          value: function render() {
            return this.props.children(this.getLocale(), this.getLocaleCode());
          }
        }]);
        return LocaleReceiver;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var locale_provider_LocaleReceiver = LocaleReceiver_LocaleReceiver;
      LocaleReceiver_LocaleReceiver.contextTypes = {
        antLocale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      }; // CONCATENATED MODULE: ./node_modules/rc-pagination/es/locale/en_US.js

      /* harmony default export */

      var en_US = {
        // Options.jsx
        items_per_page: '/ page',
        jump_to: 'Goto',
        jump_to_confirm: 'confirm',
        page: '',
        // Pagination.jsx
        prev_page: 'Previous Page',
        next_page: 'Next Page',
        prev_5: 'Previous 5 Pages',
        next_5: 'Next 5 Pages',
        prev_3: 'Previous 3 Pages',
        next_3: 'Next 3 Pages'
      }; // EXTERNAL MODULE: ./node_modules/rc-calendar/es/locale/en_US.js

      var locale_en_US = __webpack_require__(292); // CONCATENATED MODULE: ./node_modules/antd/es/time-picker/locale/en_US.js


      var en_US_locale = {
        placeholder: 'Select time'
      };
      /* harmony default export */

      var time_picker_locale_en_US = en_US_locale; // CONCATENATED MODULE: ./node_modules/antd/es/date-picker/locale/en_US.js
      // Merge into a locale object

      var locale_en_US_locale = {
        lang: extends_default()({
          placeholder: 'Select date',
          rangePlaceholder: ['Start date', 'End date']
        }, locale_en_US["a"
        /* default */
        ]),
        timePickerLocale: extends_default()({}, time_picker_locale_en_US)
      }; // All settings at:
      // https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

      /* harmony default export */

      var date_picker_locale_en_US = locale_en_US_locale; // CONCATENATED MODULE: ./node_modules/antd/es/calendar/locale/en_US.js

      /* harmony default export */

      var calendar_locale_en_US = date_picker_locale_en_US; // CONCATENATED MODULE: ./node_modules/antd/es/locale-provider/default.js

      /* harmony default export */

      var locale_provider_default = {
        locale: 'en',
        Pagination: en_US,
        DatePicker: date_picker_locale_en_US,
        TimePicker: time_picker_locale_en_US,
        Calendar: calendar_locale_en_US,
        Table: {
          filterTitle: 'Filter menu',
          filterConfirm: 'OK',
          filterReset: 'Reset',
          emptyText: 'No data',
          selectAll: 'Select current page',
          selectInvert: 'Invert current page'
        },
        Modal: {
          okText: 'OK',
          cancelText: 'Cancel',
          justOkText: 'OK'
        },
        Popconfirm: {
          okText: 'OK',
          cancelText: 'Cancel'
        },
        Transfer: {
          titles: ['', ''],
          notFoundContent: 'Not Found',
          searchPlaceholder: 'Search here',
          itemUnit: 'item',
          itemsUnit: 'items'
        },
        Select: {
          notFoundContent: 'Not Found'
        },
        Upload: {
          uploading: 'Uploading...',
          removeFile: 'Remove file',
          uploadError: 'Upload error',
          previewFile: 'Preview file'
        }
      }; // CONCATENATED MODULE: ./node_modules/antd/es/select/index.js

      var select_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var select_SelectPropTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        size: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['default', 'large', 'small']),
        combobox: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        notFoundContent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        showSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        optionLabelProp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        transitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        choiceTransitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      }; // => It is needless to export the declaration of below two inner components.
      // export { Option, OptGroup };

      var select_Select = function (_React$Component) {
        inherits_default()(Select, _React$Component);

        function Select() {
          classCallCheck_default()(this, Select);

          var _this = possibleConstructorReturn_default()(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));

          _this.saveSelect = function (node) {
            _this.rcSelect = node;
          };

          _this.renderSelect = function (locale) {
            var _classNames;

            var _a = _this.props,
                prefixCls = _a.prefixCls,
                _a$className = _a.className,
                className = _a$className === undefined ? '' : _a$className,
                size = _a.size,
                mode = _a.mode,
                restProps = select_rest(_a, ["prefixCls", "className", "size", "mode"]);
            var cls = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-lg', size === 'large'), defineProperty_default()(_classNames, prefixCls + '-sm', size === 'small'), _classNames), className);
            var optionLabelProp = _this.props.optionLabelProp;
            var isCombobox = mode === 'combobox';

            if (isCombobox) {
              // children 带 dom 结构时，无法填入输入框
              optionLabelProp = optionLabelProp || 'value';
            }

            var modeConfig = {
              multiple: mode === 'multiple',
              tags: mode === 'tags',
              combobox: isCombobox
            };
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_select_es["default"], extends_default()({}, restProps, modeConfig, {
              prefixCls: prefixCls,
              className: cls,
              optionLabelProp: optionLabelProp || 'children',
              notFoundContent: _this.getNotFoundContent(locale),
              ref: _this.saveSelect
            }));
          };

          return _this;
        }

        createClass_default()(Select, [{
          key: 'focus',
          value: function focus() {
            this.rcSelect.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.rcSelect.blur();
          }
        }, {
          key: 'getNotFoundContent',
          value: function getNotFoundContent(locale) {
            var _props = this.props,
                notFoundContent = _props.notFoundContent,
                mode = _props.mode;
            var isCombobox = mode === 'combobox';

            if (isCombobox) {
              // AutoComplete don't have notFoundContent defaultly
              return notFoundContent === undefined ? null : notFoundContent;
            }

            return notFoundContent === undefined ? locale.notFoundContent : notFoundContent;
          }
        }, {
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
              componentName: 'Select',
              defaultLocale: locale_provider_default.Select
            }, this.renderSelect);
          }
        }]);
        return Select;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_select = select_Select;
      select_Select.Option = rc_select_es["Option"];
      select_Select.OptGroup = rc_select_es["OptGroup"];
      select_Select.defaultProps = {
        prefixCls: 'ant-select',
        showSearch: false,
        transitionName: 'slide-up',
        choiceTransitionName: 'zoom'
      };
      select_Select.propTypes = select_SelectPropTypes; // CONCATENATED MODULE: ./node_modules/antd/es/input/Input.js

      function Input_fixControlledValue(value) {
        if (typeof value === 'undefined' || value === null) {
          return '';
        }

        return value;
      }

      var Input_Input = function (_React$Component) {
        inherits_default()(Input, _React$Component);

        function Input() {
          classCallCheck_default()(this, Input);

          var _this = possibleConstructorReturn_default()(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));

          _this.handleKeyDown = function (e) {
            var _this$props = _this.props,
                onPressEnter = _this$props.onPressEnter,
                onKeyDown = _this$props.onKeyDown;

            if (e.keyCode === 13 && onPressEnter) {
              onPressEnter(e);
            }

            if (onKeyDown) {
              onKeyDown(e);
            }
          };

          _this.saveInput = function (node) {
            _this.input = node;
          };

          return _this;
        }

        createClass_default()(Input, [{
          key: 'focus',
          value: function focus() {
            this.input.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.input.blur();
          }
        }, {
          key: 'getInputClassName',
          value: function getInputClassName() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                size = _props.size,
                disabled = _props.disabled;
            return classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-sm', size === 'small'), defineProperty_default()(_classNames, prefixCls + '-lg', size === 'large'), defineProperty_default()(_classNames, prefixCls + '-disabled', disabled), _classNames));
          }
        }, {
          key: 'renderLabeledInput',
          value: function renderLabeledInput(children) {
            var _classNames3;

            var props = this.props; // Not wrap when there is not addons

            if (!props.addonBefore && !props.addonAfter) {
              return children;
            }

            var wrapperClassName = props.prefixCls + '-group';
            var addonClassName = wrapperClassName + '-addon';
            var addonBefore = props.addonBefore ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: addonClassName
            }, props.addonBefore) : null;
            var addonAfter = props.addonAfter ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: addonClassName
            }, props.addonAfter) : null;
            var className = classnames_default()(props.prefixCls + '-wrapper', defineProperty_default()({}, wrapperClassName, addonBefore || addonAfter));
            var groupClassName = classnames_default()(props.prefixCls + '-group-wrapper', (_classNames3 = {}, defineProperty_default()(_classNames3, props.prefixCls + '-group-wrapper-sm', props.size === 'small'), defineProperty_default()(_classNames3, props.prefixCls + '-group-wrapper-lg', props.size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
            // and put style prop in wrapper

            if (addonBefore || addonAfter) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: groupClassName,
                style: props.style
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: className
              }, addonBefore, external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](children, {
                style: null
              }), addonAfter));
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: className
            }, addonBefore, children, addonAfter);
          }
        }, {
          key: 'renderLabeledIcon',
          value: function renderLabeledIcon(children) {
            var _classNames4;

            var props = this.props;

            if (!('prefix' in props || 'suffix' in props)) {
              return children;
            }

            var prefix = props.prefix ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: props.prefixCls + '-prefix'
            }, props.prefix) : null;
            var suffix = props.suffix ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: props.prefixCls + '-suffix'
            }, props.suffix) : null;
            var affixWrapperCls = classnames_default()(props.className, props.prefixCls + '-affix-wrapper', (_classNames4 = {}, defineProperty_default()(_classNames4, props.prefixCls + '-affix-wrapper-sm', props.size === 'small'), defineProperty_default()(_classNames4, props.prefixCls + '-affix-wrapper-lg', props.size === 'large'), _classNames4));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: affixWrapperCls,
              style: props.style
            }, prefix, external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](children, {
              style: null,
              className: this.getInputClassName()
            }), suffix);
          }
        }, {
          key: 'renderInput',
          value: function renderInput() {
            var _props2 = this.props,
                value = _props2.value,
                className = _props2.className; // Fix https://fb.me/react-unknown-prop

            var otherProps = Object(es["default"])(this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix']);

            if ('value' in this.props) {
              otherProps.value = Input_fixControlledValue(value); // Input elements must be either controlled or uncontrolled,
              // specify either the value prop, or the defaultValue prop, but not both.

              delete otherProps.defaultValue;
            }

            return this.renderLabeledIcon(external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('input', extends_default()({}, otherProps, {
              className: classnames_default()(this.getInputClassName(), className),
              onKeyDown: this.handleKeyDown,
              ref: this.saveInput
            })));
          }
        }, {
          key: 'render',
          value: function render() {
            return this.renderLabeledInput(this.renderInput());
          }
        }]);
        return Input;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var input_Input = Input_Input;
      Input_Input.defaultProps = {
        prefixCls: 'ant-input',
        type: 'text',
        disabled: false
      };
      Input_Input.propTypes = {
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        size: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['small', 'default', 'large']),
        maxLength: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        addonBefore: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        addonAfter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        autosize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        onPressEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onKeyDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onKeyUp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        prefix: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        suffix: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node
      }; // CONCATENATED MODULE: ./node_modules/antd/es/input/Group.js

      var Group_Group = function Group(props) {
        var _classNames;

        var _props$prefixCls = props.prefixCls,
            prefixCls = _props$prefixCls === undefined ? 'ant-input-group' : _props$prefixCls,
            _props$className = props.className,
            className = _props$className === undefined ? '' : _props$className;
        var cls = classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-lg', props.size === 'large'), defineProperty_default()(_classNames, prefixCls + '-sm', props.size === 'small'), defineProperty_default()(_classNames, prefixCls + '-compact', props.compact), _classNames), className);
        return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
          className: cls,
          style: props.style
        }, props.children);
      };
      /* harmony default export */


      var input_Group = Group_Group; // CONCATENATED MODULE: ./node_modules/antd/es/icon/index.js

      var icon_Icon = function Icon(props) {
        var type = props.type,
            _props$className = props.className,
            className = _props$className === undefined ? '' : _props$className,
            spin = props.spin;
        var classString = classnames_default()(defineProperty_default()({
          anticon: true,
          'anticon-spin': !!spin || type === 'loading'
        }, 'anticon-' + type, true), className);
        return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('i', extends_default()({}, Object(es["default"])(props, ['type', 'spin']), {
          className: classString
        }));
      };
      /* harmony default export */


      var es_icon = icon_Icon; // CONCATENATED MODULE: ./node_modules/antd/es/button/button.js

      var button_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var button_rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
      var button_isTwoCNChar = button_rxTwoCNChar.test.bind(button_rxTwoCNChar);

      function button_isString(str) {
        return typeof str === 'string';
      } // Insert one space between two chinese characters automatically.


      function button_insertSpace(child, needInserted) {
        // Check the child if is undefined or null.
        if (child == null) {
          return;
        }

        var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.

        if (typeof child !== 'string' && typeof child !== 'number' && button_isString(child.type) && button_isTwoCNChar(child.props.children)) {
          return external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](child, {}, child.props.children.split('').join(SPACE));
        }

        if (typeof child === 'string') {
          if (button_isTwoCNChar(child)) {
            child = child.split('').join(SPACE);
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, child);
        }

        return child;
      }

      var button_Button = function (_React$Component) {
        inherits_default()(Button, _React$Component);

        function Button(props) {
          classCallCheck_default()(this, Button);

          var _this = possibleConstructorReturn_default()(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

          _this.handleClick = function (e) {
            // Add click effect
            _this.setState({
              clicked: true
            });

            clearTimeout(_this.timeout);
            _this.timeout = window.setTimeout(function () {
              return _this.setState({
                clicked: false
              });
            }, 500);
            var onClick = _this.props.onClick;

            if (onClick) {
              onClick(e);
            }
          };

          _this.state = {
            loading: props.loading,
            clicked: false,
            hasTwoCNChar: false
          };
          return _this;
        }

        createClass_default()(Button, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.fixTwoCNChar();
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var currentLoading = this.props.loading;
            var loading = nextProps.loading;

            if (currentLoading) {
              clearTimeout(this.delayTimeout);
            }

            if (typeof loading !== 'boolean' && loading && loading.delay) {
              this.delayTimeout = window.setTimeout(function () {
                return _this2.setState({
                  loading: loading
                });
              }, loading.delay);
            } else {
              this.setState({
                loading: loading
              });
            }
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            this.fixTwoCNChar();
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.timeout) {
              clearTimeout(this.timeout);
            }

            if (this.delayTimeout) {
              clearTimeout(this.delayTimeout);
            }
          }
        }, {
          key: 'fixTwoCNChar',
          value: function fixTwoCNChar() {
            // Fix for HOC usage like <FormatMessage />
            var node = Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"])(this);
            var buttonText = node.textContent || node.innerText;

            if (this.isNeedInserted() && button_isTwoCNChar(buttonText)) {
              if (!this.state.hasTwoCNChar) {
                this.setState({
                  hasTwoCNChar: true
                });
              }
            } else if (this.state.hasTwoCNChar) {
              this.setState({
                hasTwoCNChar: false
              });
            }
          }
        }, {
          key: 'isNeedInserted',
          value: function isNeedInserted() {
            var _props = this.props,
                loading = _props.loading,
                icon = _props.icon,
                children = _props.children;
            var iconType = loading ? 'loading' : icon;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].count(children) === 1 && (!iconType || iconType === 'loading');
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames,
                _this3 = this;

            var _a = this.props,
                type = _a.type,
                shape = _a.shape,
                size = _a.size,
                className = _a.className,
                htmlType = _a.htmlType,
                children = _a.children,
                icon = _a.icon,
                prefixCls = _a.prefixCls,
                ghost = _a.ghost,
                others = button_rest(_a, ["type", "shape", "size", "className", "htmlType", "children", "icon", "prefixCls", "ghost"]);
            var _state = this.state,
                loading = _state.loading,
                clicked = _state.clicked,
                hasTwoCNChar = _state.hasTwoCNChar; // large => lg
            // small => sm

            var sizeCls = '';

            switch (size) {
              case 'large':
                sizeCls = 'lg';
                break;

              case 'small':
                sizeCls = 'sm';

              default:
                break;
            }

            var ComponentProp = others.href ? 'a' : 'button';
            var classes = classnames_default()(prefixCls, className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-' + type, type), defineProperty_default()(_classNames, prefixCls + '-' + shape, shape), defineProperty_default()(_classNames, prefixCls + '-' + sizeCls, sizeCls), defineProperty_default()(_classNames, prefixCls + '-icon-only', !children && icon), defineProperty_default()(_classNames, prefixCls + '-loading', loading), defineProperty_default()(_classNames, prefixCls + '-clicked', clicked), defineProperty_default()(_classNames, prefixCls + '-background-ghost', ghost), defineProperty_default()(_classNames, prefixCls + '-two-chinese-chars', hasTwoCNChar), _classNames));
            var iconType = loading ? 'loading' : icon;
            var iconNode = iconType ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: iconType
            }) : null;
            var kids = children || children === 0 ? external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].map(children, function (child) {
              return button_insertSpace(child, _this3.isNeedInserted());
            }) : null;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](ComponentProp, extends_default()({}, Object(es["default"])(others, ['loading']), {
              type: others.href ? undefined : htmlType || 'button',
              className: classes,
              onClick: this.handleClick
            }), iconNode, kids);
          }
        }]);
        return Button;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var button_button = button_Button;
      button_Button.__ANT_BUTTON = true;
      button_Button.defaultProps = {
        prefixCls: 'ant-btn',
        loading: false,
        ghost: false
      };
      button_Button.propTypes = {
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        shape: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['circle', 'circle-outline']),
        size: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['large', 'default', 'small']),
        htmlType: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['submit', 'button', 'reset']),
        onClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        loading: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        icon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      }; // CONCATENATED MODULE: ./node_modules/antd/es/button/button-group.js

      var button_group_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var button_group_ButtonGroup = function ButtonGroup(props) {
        var _props$prefixCls = props.prefixCls,
            prefixCls = _props$prefixCls === undefined ? 'ant-btn-group' : _props$prefixCls,
            size = props.size,
            className = props.className,
            others = button_group_rest(props, ["prefixCls", "size", "className"]); // large => lg
        // small => sm

        var sizeCls = '';

        switch (size) {
          case 'large':
            sizeCls = 'lg';
            break;

          case 'small':
            sizeCls = 'sm';

          default:
            break;
        }

        var classes = classnames_default()(prefixCls, defineProperty_default()({}, prefixCls + '-' + sizeCls, sizeCls), className);
        return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, others, {
          className: classes
        }));
      };
      /* harmony default export */


      var button_group = button_group_ButtonGroup; // CONCATENATED MODULE: ./node_modules/antd/es/button/index.js

      button_button.Group = button_group;
      /* harmony default export */

      var es_button = button_button; // CONCATENATED MODULE: ./node_modules/antd/es/input/Search.js

      var Search_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var Search_Search = function (_React$Component) {
        inherits_default()(Search, _React$Component);

        function Search() {
          classCallCheck_default()(this, Search);

          var _this = possibleConstructorReturn_default()(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));

          _this.onSearch = function () {
            var onSearch = _this.props.onSearch;

            if (onSearch) {
              onSearch(_this.input.input.value);
            }

            _this.input.focus();
          };

          _this.saveInput = function (node) {
            _this.input = node;
          };

          return _this;
        }

        createClass_default()(Search, [{
          key: 'focus',
          value: function focus() {
            this.input.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.input.blur();
          }
        }, {
          key: 'getButtonOrIcon',
          value: function getButtonOrIcon() {
            var _props = this.props,
                enterButton = _props.enterButton,
                prefixCls = _props.prefixCls,
                size = _props.size;

            if (!enterButton) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                className: prefixCls + '-icon',
                type: 'search',
                key: 'searchIcon'
              });
            }

            var enterButtonAsElement = enterButton;

            if (enterButtonAsElement.type === es_button || enterButtonAsElement.type === 'button') {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](enterButtonAsElement, enterButtonAsElement.type === es_button ? {
                className: prefixCls + '-button',
                size: size,
                onClick: this.onSearch
              } : {
                onClick: this.onSearch
              });
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_button, {
              className: prefixCls + '-button',
              type: 'primary',
              size: size,
              onClick: this.onSearch,
              key: 'enterButton'
            }, enterButton === true ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'search'
            }) : enterButton);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _a = this.props,
                className = _a.className,
                prefixCls = _a.prefixCls,
                inputPrefixCls = _a.inputPrefixCls,
                size = _a.size,
                suffix = _a.suffix,
                enterButton = _a.enterButton,
                others = Search_rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "suffix", "enterButton"]);
            delete others.onSearch;
            var buttonOrIcon = this.getButtonOrIcon();
            var searchSuffix = suffix ? [suffix, buttonOrIcon] : buttonOrIcon;
            var inputClassName = classnames_default()(prefixCls, className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-enter-button', !!enterButton), defineProperty_default()(_classNames, prefixCls + '-' + size, !!size), _classNames));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](input_Input, extends_default()({
              onPressEnter: this.onSearch
            }, others, {
              size: size,
              className: inputClassName,
              prefixCls: inputPrefixCls,
              suffix: searchSuffix,
              ref: this.saveInput
            }));
          }
        }]);
        return Search;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var input_Search = Search_Search;
      Search_Search.defaultProps = {
        inputPrefixCls: 'ant-input',
        prefixCls: 'ant-input-search',
        enterButton: false
      }; // CONCATENATED MODULE: ./node_modules/antd/es/input/calculateNodeHeight.js
      // Thanks to https://github.com/andreypopp/react-textarea-autosize/

      /**
       * calculateNodeHeight(uiTextNode, useCache = false)
       */

      var HIDDEN_TEXTAREA_STYLE = '\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
      var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
      var computedStyleCache = {};
      var hiddenTextarea = void 0;

      function calculateNodeStyling(node) {
        var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

        if (useCache && computedStyleCache[nodeRef]) {
          return computedStyleCache[nodeRef];
        }

        var style = window.getComputedStyle(node);
        var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
        var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
        var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
        var sizingStyle = SIZING_STYLE.map(function (name) {
          return name + ':' + style.getPropertyValue(name);
        }).join(';');
        var nodeInfo = {
          sizingStyle: sizingStyle,
          paddingSize: paddingSize,
          borderSize: borderSize,
          boxSizing: boxSizing
        };

        if (useCache && nodeRef) {
          computedStyleCache[nodeRef] = nodeInfo;
        }

        return nodeInfo;
      }

      function calculateNodeHeight(uiTextNode) {
        var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        if (!hiddenTextarea) {
          hiddenTextarea = document.createElement('textarea');
          document.body.appendChild(hiddenTextarea);
        } // Fix wrap="off" issue
        // https://github.com/ant-design/ant-design/issues/6577


        if (uiTextNode.getAttribute('wrap')) {
          hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
        } else {
          hiddenTextarea.removeAttribute('wrap');
        } // Copy all CSS properties that have an impact on the height of the content in
        // the textbox


        var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
            paddingSize = _calculateNodeStyling.paddingSize,
            borderSize = _calculateNodeStyling.borderSize,
            boxSizing = _calculateNodeStyling.boxSizing,
            sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
        // text-lines will not calculated properly as the shadow will technically be
        // narrower for content


        hiddenTextarea.setAttribute('style', sizingStyle + ';' + HIDDEN_TEXTAREA_STYLE);
        hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
        var minHeight = Number.MIN_SAFE_INTEGER;
        var maxHeight = Number.MAX_SAFE_INTEGER;
        var height = hiddenTextarea.scrollHeight;
        var overflowY = void 0;

        if (boxSizing === 'border-box') {
          // border-box: add border, since height = content + padding + border
          height = height + borderSize;
        } else if (boxSizing === 'content-box') {
          // remove padding, since height = content
          height = height - paddingSize;
        }

        if (minRows !== null || maxRows !== null) {
          // measure height of a textarea with a single row
          hiddenTextarea.value = ' ';
          var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

          if (minRows !== null) {
            minHeight = singleRowHeight * minRows;

            if (boxSizing === 'border-box') {
              minHeight = minHeight + paddingSize + borderSize;
            }

            height = Math.max(minHeight, height);
          }

          if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;

            if (boxSizing === 'border-box') {
              maxHeight = maxHeight + paddingSize + borderSize;
            }

            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
          }
        } // Remove scroll bar flash when autosize without maxRows


        if (!maxRows) {
          overflowY = 'hidden';
        }

        return {
          height: height,
          minHeight: minHeight,
          maxHeight: maxHeight,
          overflowY: overflowY
        };
      } // CONCATENATED MODULE: ./node_modules/antd/es/input/TextArea.js


      function TextArea_onNextFrame(cb) {
        if (window.requestAnimationFrame) {
          return window.requestAnimationFrame(cb);
        }

        return window.setTimeout(cb, 1);
      }

      function TextArea_clearNextFrameAction(nextFrameId) {
        if (window.cancelAnimationFrame) {
          window.cancelAnimationFrame(nextFrameId);
        } else {
          window.clearTimeout(nextFrameId);
        }
      }

      var TextArea_TextArea = function (_React$Component) {
        inherits_default()(TextArea, _React$Component);

        function TextArea() {
          classCallCheck_default()(this, TextArea);

          var _this = possibleConstructorReturn_default()(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).apply(this, arguments));

          _this.state = {
            textareaStyles: {}
          };

          _this.resizeTextarea = function () {
            var autosize = _this.props.autosize;

            if (!autosize || !_this.textAreaRef) {
              return;
            }

            var minRows = autosize ? autosize.minRows : null;
            var maxRows = autosize ? autosize.maxRows : null;
            var textareaStyles = calculateNodeHeight(_this.textAreaRef, false, minRows, maxRows);

            _this.setState({
              textareaStyles: textareaStyles
            });
          };

          _this.handleTextareaChange = function (e) {
            if (!('value' in _this.props)) {
              _this.resizeTextarea();
            }

            var onChange = _this.props.onChange;

            if (onChange) {
              onChange(e);
            }
          };

          _this.handleKeyDown = function (e) {
            var _this$props = _this.props,
                onPressEnter = _this$props.onPressEnter,
                onKeyDown = _this$props.onKeyDown;

            if (e.keyCode === 13 && onPressEnter) {
              onPressEnter(e);
            }

            if (onKeyDown) {
              onKeyDown(e);
            }
          };

          _this.saveTextAreaRef = function (textArea) {
            _this.textAreaRef = textArea;
          };

          return _this;
        }

        createClass_default()(TextArea, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.resizeTextarea();
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            // Re-render with the new content then recalculate the height as required.
            if (this.props.value !== nextProps.value) {
              if (this.nextFrameActionId) {
                TextArea_clearNextFrameAction(this.nextFrameActionId);
              }

              this.nextFrameActionId = TextArea_onNextFrame(this.resizeTextarea);
            }
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.textAreaRef.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.textAreaRef.blur();
          }
        }, {
          key: 'getTextAreaClassName',
          value: function getTextAreaClassName() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                disabled = _props.disabled;
            return classnames_default()(prefixCls, className, defineProperty_default()({}, prefixCls + '-disabled', disabled));
          }
        }, {
          key: 'render',
          value: function render() {
            var props = this.props;
            var otherProps = Object(es["default"])(props, ['prefixCls', 'onPressEnter', 'autosize']);
            var style = extends_default()({}, props.style, this.state.textareaStyles); // Fix https://github.com/ant-design/ant-design/issues/6776
            // Make sure it could be reset when using form.getFieldDecorator

            if ('value' in otherProps) {
              otherProps.value = otherProps.value || '';
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('textarea', extends_default()({}, otherProps, {
              className: this.getTextAreaClassName(),
              style: style,
              onKeyDown: this.handleKeyDown,
              onChange: this.handleTextareaChange,
              ref: this.saveTextAreaRef
            }));
          }
        }]);
        return TextArea;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var input_TextArea = TextArea_TextArea;
      TextArea_TextArea.defaultProps = {
        prefixCls: 'ant-input'
      }; // CONCATENATED MODULE: ./node_modules/antd/es/input/index.js

      input_Input.Group = input_Group;
      input_Input.Search = input_Search;
      input_Input.TextArea = input_TextArea;
      /* harmony default export */

      var es_input = input_Input; // CONCATENATED MODULE: ./node_modules/antd/es/auto-complete/InputElement.js

      var InputElement_InputElement = function (_React$Component) {
        inherits_default()(InputElement, _React$Component);

        function InputElement() {
          classCallCheck_default()(this, InputElement);

          var _this = possibleConstructorReturn_default()(this, (InputElement.__proto__ || Object.getPrototypeOf(InputElement)).apply(this, arguments));

          _this.focus = function () {
            _this.ele.focus ? _this.ele.focus() : external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](_this.ele).focus();
          };

          _this.blur = function () {
            _this.ele.blur ? _this.ele.blur() : external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](_this.ele).blur();
          };

          _this.saveRef = function (ele) {
            _this.ele = ele;
            var childRef = _this.props.children.ref;

            if (typeof childRef === 'function') {
              childRef(ele);
            }
          };

          return _this;
        }

        createClass_default()(InputElement, [{
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](this.props.children, extends_default()({}, this.props, {
              ref: this.saveRef
            }), null);
          }
        }]);
        return InputElement;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var auto_complete_InputElement = InputElement_InputElement; // CONCATENATED MODULE: ./node_modules/antd/es/auto-complete/index.js

      function auto_complete_isSelectOptionOrSelectOptGroup(child) {
        return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
      }

      var auto_complete_AutoComplete = function (_React$Component) {
        inherits_default()(AutoComplete, _React$Component);

        function AutoComplete() {
          classCallCheck_default()(this, AutoComplete);

          var _this = possibleConstructorReturn_default()(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).apply(this, arguments));

          _this.getInputElement = function () {
            var children = _this.props.children;
            var element = children && external_root_React_commonjs2_react_commonjs_react_amd_react_["isValidElement"](children) && children.type !== rc_select_es["Option"] ? external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].only(_this.props.children) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_input, null);
            var elementProps = extends_default()({}, element.props); // https://github.com/ant-design/ant-design/pull/7742

            delete elementProps.children;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](auto_complete_InputElement, elementProps, element);
          };

          _this.saveSelect = function (node) {
            _this.select = node;
          };

          return _this;
        }

        createClass_default()(AutoComplete, [{
          key: 'focus',
          value: function focus() {
            this.select.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.select.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                size = _props.size,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                notFoundContent = _props.notFoundContent,
                prefixCls = _props.prefixCls,
                optionLabelProp = _props.optionLabelProp,
                dataSource = _props.dataSource,
                children = _props.children;
            var cls = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-lg', size === 'large'), defineProperty_default()(_classNames, prefixCls + '-sm', size === 'small'), defineProperty_default()(_classNames, className, !!className), defineProperty_default()(_classNames, prefixCls + '-show-search', true), defineProperty_default()(_classNames, prefixCls + '-auto-complete', true), _classNames));
            var options = void 0;
            var childArray = external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].toArray(children);

            if (childArray.length && auto_complete_isSelectOptionOrSelectOptGroup(childArray[0])) {
              options = children;
            } else {
              options = dataSource ? dataSource.map(function (item) {
                if (external_root_React_commonjs2_react_commonjs_react_amd_react_["isValidElement"](item)) {
                  return item;
                }

                switch (typeof item === 'undefined' ? 'undefined' : typeof_default()(item)) {
                  case 'string':
                    return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_select_es["Option"], {
                      key: item
                    }, item);

                  case 'object':
                    return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_select_es["Option"], {
                      key: item.value
                    }, item.text);

                  default:
                    throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
                }
              }) : [];
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_select, extends_default()({}, this.props, {
              className: cls,
              mode: 'combobox',
              optionLabelProp: optionLabelProp,
              getInputElement: this.getInputElement,
              notFoundContent: notFoundContent,
              ref: this.saveSelect
            }), options);
          }
        }]);
        return AutoComplete;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var auto_complete = auto_complete_AutoComplete;
      auto_complete_AutoComplete.Option = rc_select_es["Option"];
      auto_complete_AutoComplete.OptGroup = rc_select_es["OptGroup"];
      auto_complete_AutoComplete.defaultProps = {
        prefixCls: 'ant-select',
        transitionName: 'slide-up',
        optionLabelProp: 'children',
        choiceTransitionName: 'zoom',
        showSearch: false,
        filterOption: false
      }; // EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 3 modules

      var Animate = __webpack_require__(43); // CONCATENATED MODULE: ./node_modules/antd/es/alert/index.js


      function alert_noop() {}

      var alert_Alert = function (_React$Component) {
        inherits_default()(Alert, _React$Component);

        function Alert(props) {
          classCallCheck_default()(this, Alert);

          var _this = possibleConstructorReturn_default()(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));

          _this.handleClose = function (e) {
            e.preventDefault();
            var dom = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](_this);
            dom.style.height = dom.offsetHeight + 'px'; // Magic code
            // 重复一次后才能正确设置 height

            dom.style.height = dom.offsetHeight + 'px';

            _this.setState({
              closing: false
            });

            (_this.props.onClose || alert_noop)(e);
          };

          _this.animationEnd = function () {
            _this.setState({
              closed: true,
              closing: true
            });

            (_this.props.afterClose || alert_noop)();
          };

          _this.state = {
            closing: true,
            closed: false
          };
          return _this;
        }

        createClass_default()(Alert, [{
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                closable = _props.closable,
                description = _props.description,
                type = _props.type,
                _props$prefixCls = _props.prefixCls,
                prefixCls = _props$prefixCls === undefined ? 'ant-alert' : _props$prefixCls,
                message = _props.message,
                closeText = _props.closeText,
                showIcon = _props.showIcon,
                banner = _props.banner,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                style = _props.style,
                iconType = _props.iconType; // banner模式默认有 Icon

            showIcon = banner && showIcon === undefined ? true : showIcon; // banner模式默认为警告

            type = banner && type === undefined ? 'warning' : type || 'info';

            if (!iconType) {
              switch (type) {
                case 'success':
                  iconType = 'check-circle';
                  break;

                case 'info':
                  iconType = 'info-circle';
                  break;

                case 'error':
                  iconType = 'cross-circle';
                  break;

                case 'warning':
                  iconType = 'exclamation-circle';
                  break;

                default:
                  iconType = 'default';
              } // use outline icon in alert with description


              if (!!description) {
                iconType += '-o';
              }
            }

            var alertCls = classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-' + type, true), defineProperty_default()(_classNames, prefixCls + '-close', !this.state.closing), defineProperty_default()(_classNames, prefixCls + '-with-description', !!description), defineProperty_default()(_classNames, prefixCls + '-no-icon', !showIcon), defineProperty_default()(_classNames, prefixCls + '-banner', !!banner), _classNames), className); // closeable when closeText is assigned

            if (closeText) {
              closable = true;
            }

            var closeIcon = closable ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', {
              onClick: this.handleClose,
              className: prefixCls + '-close-icon'
            }, closeText || external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'cross'
            })) : null;
            return this.state.closed ? null : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], {
              component: '',
              showProp: 'data-show',
              transitionName: prefixCls + '-slide-up',
              onEnd: this.animationEnd
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              'data-show': this.state.closing,
              className: alertCls,
              style: style
            }, showIcon ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              className: prefixCls + '-icon',
              type: iconType
            }) : null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: prefixCls + '-message'
            }, message), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: prefixCls + '-description'
            }, description), closeIcon));
          }
        }]);
        return Alert;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_alert = alert_Alert; // CONCATENATED MODULE: ./node_modules/antd/es/avatar/index.js

      var avatar_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var avatar_Avatar = function (_React$Component) {
        inherits_default()(Avatar, _React$Component);

        function Avatar(props) {
          classCallCheck_default()(this, Avatar);

          var _this = possibleConstructorReturn_default()(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call(this, props));

          _this.setScale = function () {
            var childrenNode = _this.avatarChildren;

            if (childrenNode) {
              var childrenWidth = childrenNode.offsetWidth;
              var avatarWidth = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](_this).getBoundingClientRect().width; // add 4px gap for each side to get better performance

              if (avatarWidth - 8 < childrenWidth) {
                _this.setState({
                  scale: (avatarWidth - 8) / childrenWidth
                });
              } else {
                _this.setState({
                  scale: 1
                });
              }
            }
          };

          _this.handleImgLoadError = function () {
            return _this.setState({
              isImgExist: false
            });
          };

          _this.state = {
            scale: 1,
            isImgExist: true
          };
          return _this;
        }

        createClass_default()(Avatar, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.setScale();
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.children !== this.props.children || prevState.scale !== this.state.scale && this.state.scale === 1) {
              this.setScale();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames,
                _classNames2,
                _this2 = this;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                shape = _a.shape,
                size = _a.size,
                src = _a.src,
                icon = _a.icon,
                className = _a.className,
                others = avatar_rest(_a, ["prefixCls", "shape", "size", "src", "icon", "className"]);
            var sizeCls = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-lg', size === 'large'), defineProperty_default()(_classNames, prefixCls + '-sm', size === 'small'), _classNames));
            var classString = classnames_default()(prefixCls, className, sizeCls, (_classNames2 = {}, defineProperty_default()(_classNames2, prefixCls + '-' + shape, shape), defineProperty_default()(_classNames2, prefixCls + '-image', src && this.state.isImgExist), defineProperty_default()(_classNames2, prefixCls + '-icon', icon), _classNames2));
            var children = this.props.children;

            if (src && this.state.isImgExist) {
              children = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('img', {
                src: src,
                onError: this.handleImgLoadError
              });
            } else if (icon) {
              children = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: icon
              });
            } else {
              var childrenNode = this.avatarChildren;

              if (childrenNode || this.state.scale !== 1) {
                var childrenStyle = {
                  msTransform: 'scale(' + this.state.scale + ')',
                  WebkitTransform: 'scale(' + this.state.scale + ')',
                  transform: 'scale(' + this.state.scale + ')',
                  position: 'absolute',
                  display: 'inline-block',
                  left: 'calc(50% - ' + Math.round(childrenNode.offsetWidth / 2) + 'px)'
                };
                children = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                  className: prefixCls + '-string',
                  ref: function ref(span) {
                    return _this2.avatarChildren = span;
                  },
                  style: childrenStyle
                }, children);
              } else {
                children = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                  className: prefixCls + '-string',
                  ref: function ref(span) {
                    return _this2.avatarChildren = span;
                  }
                }, children);
              }
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', extends_default()({}, others, {
              className: classString
            }), children);
          }
        }]);
        return Avatar;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_avatar = avatar_Avatar;
      avatar_Avatar.defaultProps = {
        prefixCls: 'ant-avatar',
        shape: 'circle',
        size: 'default'
      }; // CONCATENATED MODULE: ./node_modules/antd/es/back-top/index.js

      var back_top_reqAnimFrame = getRequestAnimationFrame();

      var back_top_easeInOutCubic = function easeInOutCubic(t, b, c, d) {
        var cc = c - b;
        t /= d / 2;

        if (t < 1) {
          return cc / 2 * t * t * t + b;
        } else {
          return cc / 2 * ((t -= 2) * t * t + 2) + b;
        }
      };

      function back_top_noop() {}

      function back_top_getDefaultTarget() {
        return window;
      }

      var back_top_BackTop = function (_React$Component) {
        inherits_default()(BackTop, _React$Component);

        function BackTop(props) {
          classCallCheck_default()(this, BackTop);

          var _this = possibleConstructorReturn_default()(this, (BackTop.__proto__ || Object.getPrototypeOf(BackTop)).call(this, props));

          _this.getCurrentScrollTop = function () {
            var getTarget = _this.props.target || back_top_getDefaultTarget;
            var targetNode = getTarget();

            if (targetNode === window) {
              return window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
            }

            return targetNode.scrollTop;
          };

          _this.scrollToTop = function (e) {
            var scrollTop = _this.getCurrentScrollTop();

            var startTime = Date.now();

            var frameFunc = function frameFunc() {
              var timestamp = Date.now();
              var time = timestamp - startTime;

              _this.setScrollTop(back_top_easeInOutCubic(time, scrollTop, 0, 450));

              if (time < 450) {
                back_top_reqAnimFrame(frameFunc);
              }
            };

            back_top_reqAnimFrame(frameFunc);
            (_this.props.onClick || back_top_noop)(e);
          };

          _this.handleScroll = function () {
            var _this$props = _this.props,
                visibilityHeight = _this$props.visibilityHeight,
                _this$props$target = _this$props.target,
                target = _this$props$target === undefined ? back_top_getDefaultTarget : _this$props$target;
            var scrollTop = getScroll_getScroll(target(), true);

            _this.setState({
              visible: scrollTop > visibilityHeight
            });
          };

          _this.state = {
            visible: false
          };
          return _this;
        }

        createClass_default()(BackTop, [{
          key: 'setScrollTop',
          value: function setScrollTop(value) {
            var getTarget = this.props.target || back_top_getDefaultTarget;
            var targetNode = getTarget();

            if (targetNode === window) {
              document.body.scrollTop = value;
              document.documentElement.scrollTop = value;
            } else {
              targetNode.scrollTop = value;
            }
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            var getTarget = this.props.target || back_top_getDefaultTarget;
            this.scrollEvent = Object(addEventListener["a"
            /* default */
            ])(getTarget(), 'scroll', this.handleScroll);
            this.handleScroll();
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.scrollEvent) {
              this.scrollEvent.remove();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                _props$prefixCls = _props.prefixCls,
                prefixCls = _props$prefixCls === undefined ? 'ant-back-top' : _props$prefixCls,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                children = _props.children;
            var classString = classnames_default()(prefixCls, className);
            var defaultElement = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-content'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-icon'
            })); // fix https://fb.me/react-unknown-prop

            var divProps = Object(es["default"])(this.props, ['prefixCls', 'className', 'children', 'visibilityHeight', 'target']);
            var backTopBtn = this.state.visible ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, divProps, {
              className: classString,
              onClick: this.scrollToTop
            }), children || defaultElement) : null;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], {
              component: '',
              transitionName: 'fade'
            }, backTopBtn);
          }
        }]);
        return BackTop;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var back_top = back_top_BackTop;
      back_top_BackTop.defaultProps = {
        visibilityHeight: 400
      }; // CONCATENATED MODULE: ./node_modules/antd/es/badge/ScrollNumber.js

      function ScrollNumber_getNumberArray(num) {
        return num ? num.toString().split('').reverse().map(function (i) {
          return Number(i);
        }) : [];
      }

      var ScrollNumber_ScrollNumber = function (_Component) {
        inherits_default()(ScrollNumber, _Component);

        function ScrollNumber(props) {
          classCallCheck_default()(this, ScrollNumber);

          var _this = possibleConstructorReturn_default()(this, (ScrollNumber.__proto__ || Object.getPrototypeOf(ScrollNumber)).call(this, props));

          _this.state = {
            animateStarted: true,
            count: props.count
          };
          return _this;
        }

        createClass_default()(ScrollNumber, [{
          key: 'getPositionByNum',
          value: function getPositionByNum(num, i) {
            if (this.state.animateStarted) {
              return 10 + num;
            }

            var currentDigit = ScrollNumber_getNumberArray(this.state.count)[i];
            var lastDigit = ScrollNumber_getNumberArray(this.lastCount)[i]; // 同方向则在同一侧切换数字

            if (this.state.count > this.lastCount) {
              if (currentDigit >= lastDigit) {
                return 10 + num;
              }

              return 20 + num;
            }

            if (currentDigit <= lastDigit) {
              return 10 + num;
            }

            return num;
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if ('count' in nextProps) {
              if (this.state.count === nextProps.count) {
                return;
              }

              this.lastCount = this.state.count; // 复原数字初始位置

              this.setState({
                animateStarted: true
              }, function () {
                // 等待数字位置复原完毕
                // 开始设置完整的数字
                setTimeout(function () {
                  _this2.setState({
                    animateStarted: false,
                    count: nextProps.count
                  }, function () {
                    var onAnimated = _this2.props.onAnimated;

                    if (onAnimated) {
                      onAnimated();
                    }
                  });
                }, 5);
              });
            }
          }
        }, {
          key: 'renderNumberList',
          value: function renderNumberList(position) {
            var childrenToReturn = [];

            for (var i = 0; i < 30; i++) {
              var currentClassName = position === i ? 'current' : '';
              childrenToReturn.push(external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('p', {
                key: i.toString(),
                className: currentClassName
              }, i % 10));
            }

            return childrenToReturn;
          }
        }, {
          key: 'renderCurrentNumber',
          value: function renderCurrentNumber(num, i) {
            var position = this.getPositionByNum(num, i);
            var removeTransition = this.state.animateStarted || ScrollNumber_getNumberArray(this.lastCount)[i] === undefined;
            return Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"])('span', {
              className: this.props.prefixCls + '-only',
              style: {
                transition: removeTransition && 'none',
                msTransform: 'translateY(' + -position * 100 + '%)',
                WebkitTransform: 'translateY(' + -position * 100 + '%)',
                transform: 'translateY(' + -position * 100 + '%)'
              },
              key: i
            }, this.renderNumberList(position));
          }
        }, {
          key: 'renderNumberElement',
          value: function renderNumberElement() {
            var _this3 = this;

            var state = this.state;

            if (!state.count || isNaN(state.count)) {
              return state.count;
            }

            return ScrollNumber_getNumberArray(state.count).map(function (num, i) {
              return _this3.renderCurrentNumber(num, i);
            }).reverse();
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                style = _props.style,
                title = _props.title,
                _props$component = _props.component,
                component = _props$component === undefined ? 'sup' : _props$component; // fix https://fb.me/react-unknown-prop

            var restProps = Object(es["default"])(this.props, ['count', 'onAnimated', 'component', 'prefixCls']);
            var newProps = extends_default()({}, restProps, {
              className: classnames_default()(prefixCls, className),
              title: title
            }); // allow specify the border
            // mock border-color by box-shadow for compatible with old usage:
            // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />

            if (style && style.borderColor) {
              newProps.style.boxShadow = '0 0 0 1px ' + style.borderColor + ' inset';
            }

            return Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"])(component, newProps, this.renderNumberElement());
          }
        }]);
        return ScrollNumber;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var badge_ScrollNumber = ScrollNumber_ScrollNumber;
      ScrollNumber_ScrollNumber.defaultProps = {
        prefixCls: 'ant-scroll-number',
        count: null,
        onAnimated: function onAnimated() {}
      }; // CONCATENATED MODULE: ./node_modules/antd/es/badge/index.js

      var badge_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var badge_Badge = function (_React$Component) {
        inherits_default()(Badge, _React$Component);

        function Badge() {
          classCallCheck_default()(this, Badge);
          return possibleConstructorReturn_default()(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
        }

        createClass_default()(Badge, [{
          key: 'render',
          value: function render() {
            var _classNames, _classNames2, _classNames3;

            var _a = this.props,
                count = _a.count,
                showZero = _a.showZero,
                prefixCls = _a.prefixCls,
                scrollNumberPrefixCls = _a.scrollNumberPrefixCls,
                overflowCount = _a.overflowCount,
                className = _a.className,
                style = _a.style,
                children = _a.children,
                dot = _a.dot,
                status = _a.status,
                text = _a.text,
                offset = _a.offset,
                restProps = badge_rest(_a, ["count", "showZero", "prefixCls", "scrollNumberPrefixCls", "overflowCount", "className", "style", "children", "dot", "status", "text", "offset"]);
            var displayCount = count > overflowCount ? overflowCount + '+' : count;
            var isZero = displayCount === '0' || displayCount === 0;
            var isDot = dot && !isZero || status; // dot mode don't need count

            if (isDot) {
              displayCount = '';
            }

            var isEmpty = displayCount === null || displayCount === undefined || displayCount === '';
            var hidden = (isEmpty || isZero && !showZero) && !isDot;
            var statusCls = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-status-dot', !!status), defineProperty_default()(_classNames, prefixCls + '-status-' + status, !!status), _classNames));
            var scrollNumberCls = classnames_default()((_classNames2 = {}, defineProperty_default()(_classNames2, prefixCls + '-dot', isDot), defineProperty_default()(_classNames2, prefixCls + '-count', !isDot), defineProperty_default()(_classNames2, prefixCls + '-multiple-words', !isDot && count && count.toString && count.toString().length > 1), defineProperty_default()(_classNames2, prefixCls + '-status-' + status, !!status), _classNames2));
            var badgeCls = classnames_default()(className, prefixCls, (_classNames3 = {}, defineProperty_default()(_classNames3, prefixCls + '-status', !!status), defineProperty_default()(_classNames3, prefixCls + '-not-a-wrapper', !children), _classNames3));
            var styleWithOffset = offset ? extends_default()({
              marginTop: offset[0],
              marginLeft: offset[1]
            }, style) : style; // <Badge status="success" />

            if (!children && status) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: badgeCls,
                style: styleWithOffset
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: statusCls
              }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: prefixCls + '-status-text'
              }, text));
            }

            var scrollNumber = hidden ? null : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](badge_ScrollNumber, {
              prefixCls: scrollNumberPrefixCls,
              'data-show': !hidden,
              className: scrollNumberCls,
              count: displayCount,
              title: count,
              style: styleWithOffset
            });
            var statusText = hidden || !text ? null : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: prefixCls + '-status-text'
            }, text);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', extends_default()({}, restProps, {
              className: badgeCls
            }), children, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], {
              component: '',
              showProp: 'data-show',
              transitionName: children ? prefixCls + '-zoom' : '',
              transitionAppear: true
            }, scrollNumber), statusText);
          }
        }]);
        return Badge;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var badge = badge_Badge;
      badge_Badge.defaultProps = {
        prefixCls: 'ant-badge',
        scrollNumberPrefixCls: 'ant-scroll-number',
        count: null,
        showZero: false,
        dot: false,
        overflowCount: 99
      };
      badge_Badge.propTypes = {
        count: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        showZero: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        dot: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        overflowCount: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
      }; // EXTERNAL MODULE: ./node_modules/warning/browser.js

      var browser = __webpack_require__(73);

      var browser_default =
      /*#__PURE__*/
      __webpack_require__.n(browser); // CONCATENATED MODULE: ./node_modules/antd/es/_util/warning.js


      var warning_warned = {};
      /* harmony default export */

      var _util_warning = function _util_warning(valid, message) {
        if (!valid && !warning_warned[message]) {
          browser_default()(false, message);
          warning_warned[message] = true;
        }
      }; // CONCATENATED MODULE: ./node_modules/antd/es/breadcrumb/BreadcrumbItem.js


      var BreadcrumbItem_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var BreadcrumbItem_BreadcrumbItem = function (_React$Component) {
        inherits_default()(BreadcrumbItem, _React$Component);

        function BreadcrumbItem() {
          classCallCheck_default()(this, BreadcrumbItem);
          return possibleConstructorReturn_default()(this, (BreadcrumbItem.__proto__ || Object.getPrototypeOf(BreadcrumbItem)).apply(this, arguments));
        }

        createClass_default()(BreadcrumbItem, [{
          key: 'render',
          value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                separator = _a.separator,
                children = _a.children,
                restProps = BreadcrumbItem_rest(_a, ["prefixCls", "separator", "children"]);
            var link = void 0;

            if ('href' in this.props) {
              link = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', extends_default()({
                className: prefixCls + '-link'
              }, restProps), children);
            } else {
              link = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', extends_default()({
                className: prefixCls + '-link'
              }, restProps), children);
            }

            if (children) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, link, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: prefixCls + '-separator'
              }, separator));
            }

            return null;
          }
        }]);
        return BreadcrumbItem;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var breadcrumb_BreadcrumbItem = BreadcrumbItem_BreadcrumbItem;
      BreadcrumbItem_BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
      BreadcrumbItem_BreadcrumbItem.defaultProps = {
        prefixCls: 'ant-breadcrumb',
        separator: '/'
      };
      BreadcrumbItem_BreadcrumbItem.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        separator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.element]),
        href: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      }; // CONCATENATED MODULE: ./node_modules/antd/es/breadcrumb/Breadcrumb.js

      function Breadcrumb_getBreadcrumbName(route, params) {
        if (!route.breadcrumbName) {
          return null;
        }

        var paramsKeys = Object.keys(params).join('|');
        var name = route.breadcrumbName.replace(new RegExp(':(' + paramsKeys + ')', 'g'), function (replacement, key) {
          return params[key] || replacement;
        });
        return name;
      }

      function Breadcrumb_defaultItemRender(route, params, routes, paths) {
        var isLastItem = routes.indexOf(route) === routes.length - 1;
        var name = Breadcrumb_getBreadcrumbName(route, params);
        return isLastItem ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, name) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', {
          href: '#/' + paths.join('/')
        }, name);
      }

      var Breadcrumb_Breadcrumb = function (_React$Component) {
        inherits_default()(Breadcrumb, _React$Component);

        function Breadcrumb() {
          classCallCheck_default()(this, Breadcrumb);
          return possibleConstructorReturn_default()(this, (Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).apply(this, arguments));
        }

        createClass_default()(Breadcrumb, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var props = this.props;

            _util_warning(!('linkRender' in props || 'nameRender' in props), '`linkRender` and `nameRender` are removed, please use `itemRender` instead, ' + 'see: https://u.ant.design/item-render.');
          }
        }, {
          key: 'render',
          value: function render() {
            var crumbs = void 0;
            var _props = this.props,
                separator = _props.separator,
                prefixCls = _props.prefixCls,
                style = _props.style,
                className = _props.className,
                routes = _props.routes,
                _props$params = _props.params,
                params = _props$params === undefined ? {} : _props$params,
                children = _props.children,
                _props$itemRender = _props.itemRender,
                itemRender = _props$itemRender === undefined ? Breadcrumb_defaultItemRender : _props$itemRender;

            if (routes && routes.length > 0) {
              var paths = [];
              crumbs = routes.map(function (route) {
                route.path = route.path || '';
                var path = route.path.replace(/^\//, '');
                Object.keys(params).forEach(function (key) {
                  path = path.replace(':' + key, params[key]);
                });

                if (path) {
                  paths.push(path);
                }

                return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](breadcrumb_BreadcrumbItem, {
                  separator: separator,
                  key: route.breadcrumbName || path
                }, itemRender(route, params, routes, paths));
              });
            } else if (children) {
              crumbs = external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].map(children, function (element, index) {
                if (!element) {
                  return element;
                }

                _util_warning(element.type && element.type.__ANT_BREADCRUMB_ITEM, 'Breadcrumb only accepts Breadcrumb.Item as it\'s children');

                return Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"])(element, {
                  separator: separator,
                  key: index
                });
              });
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: classnames_default()(className, prefixCls),
              style: style
            }, crumbs);
          }
        }]);
        return Breadcrumb;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var breadcrumb_Breadcrumb = Breadcrumb_Breadcrumb;
      Breadcrumb_Breadcrumb.defaultProps = {
        prefixCls: 'ant-breadcrumb',
        separator: '/'
      };
      Breadcrumb_Breadcrumb.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        separator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        routes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        params: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        linkRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        nameRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      }; // CONCATENATED MODULE: ./node_modules/antd/es/breadcrumb/index.js

      breadcrumb_Breadcrumb.Item = breadcrumb_BreadcrumbItem;
      /* harmony default export */

      var breadcrumb = breadcrumb_Breadcrumb; // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js

      var slicedToArray = __webpack_require__(145);

      var slicedToArray_default =
      /*#__PURE__*/
      __webpack_require__.n(slicedToArray); // EXTERNAL MODULE: ./node_modules/moment/moment.js


      var moment = __webpack_require__(14);

      var moment_default =
      /*#__PURE__*/
      __webpack_require__.n(moment); // EXTERNAL MODULE: ./node_modules/create-react-class/index.js


      var create_react_class = __webpack_require__(32);

      var create_react_class_default =
      /*#__PURE__*/
      __webpack_require__.n(create_react_class); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/date/DateTable.js + 3 modules


      var DateTable = __webpack_require__(186); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/month/MonthTable.js


      var MonthTable = __webpack_require__(291); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/mixin/CalendarMixin.js


      var CalendarMixin = __webpack_require__(189); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/mixin/CommonMixin.js


      var CommonMixin = __webpack_require__(144); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/util/index.js


      var util = __webpack_require__(47); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/full-calendar/CalendarHeader.js


      function CalendarHeader_noop() {}

      var CalendarHeader_CalendarHeader = function (_Component) {
        inherits_default()(CalendarHeader, _Component);

        function CalendarHeader() {
          classCallCheck_default()(this, CalendarHeader);
          return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
        }

        CalendarHeader.prototype.onYearChange = function onYearChange(year) {
          var newValue = this.props.value.clone();
          newValue.year(parseInt(year, 10));
          this.props.onValueChange(newValue);
        };

        CalendarHeader.prototype.onMonthChange = function onMonthChange(month) {
          var newValue = this.props.value.clone();
          newValue.month(parseInt(month, 10));
          this.props.onValueChange(newValue);
        };

        CalendarHeader.prototype.yearSelectElement = function yearSelectElement(year) {
          var _props = this.props,
              yearSelectOffset = _props.yearSelectOffset,
              yearSelectTotal = _props.yearSelectTotal,
              prefixCls = _props.prefixCls,
              Select = _props.Select;
          var start = year - yearSelectOffset;
          var end = start + yearSelectTotal;
          var options = [];

          for (var index = start; index < end; index++) {
            options.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Select.Option, {
              key: '' + index
            }, index));
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Select, {
            className: prefixCls + '-header-year-select',
            onChange: this.onYearChange.bind(this),
            dropdownStyle: {
              zIndex: 2000
            },
            dropdownMenuStyle: {
              maxHeight: 250,
              overflow: 'auto',
              fontSize: 12
            },
            optionLabelProp: 'children',
            value: String(year),
            showSearch: false
          }, options);
        };

        CalendarHeader.prototype.monthSelectElement = function monthSelectElement(month) {
          var props = this.props;
          var t = props.value.clone();
          var prefixCls = props.prefixCls;
          var options = [];
          var Select = props.Select;

          for (var index = 0; index < 12; index++) {
            t.month(index);
            options.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Select.Option, {
              key: '' + index
            }, Object(util["a"
            /* getMonthName */
            ])(t)));
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Select, {
            className: prefixCls + '-header-month-select',
            dropdownStyle: {
              zIndex: 2000
            },
            dropdownMenuStyle: {
              maxHeight: 250,
              overflow: 'auto',
              overflowX: 'hidden',
              fontSize: 12
            },
            optionLabelProp: 'children',
            value: String(month),
            showSearch: false,
            onChange: this.onMonthChange.bind(this)
          }, options);
        };

        CalendarHeader.prototype.changeTypeToDate = function changeTypeToDate() {
          this.props.onTypeChange('date');
        };

        CalendarHeader.prototype.changeTypeToMonth = function changeTypeToMonth() {
          this.props.onTypeChange('month');
        };

        CalendarHeader.prototype.render = function render() {
          var _props2 = this.props,
              value = _props2.value,
              locale = _props2.locale,
              prefixCls = _props2.prefixCls,
              type = _props2.type,
              showTypeSwitch = _props2.showTypeSwitch,
              headerComponents = _props2.headerComponents;
          var year = value.year();
          var month = value.month();
          var yearSelect = this.yearSelectElement(year);
          var monthSelect = type === 'month' ? null : this.monthSelectElement(month);
          var switchCls = prefixCls + '-header-switcher';
          var typeSwitcher = showTypeSwitch ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: switchCls
          }, type === 'date' ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: switchCls + '-focus'
          }, locale.month) : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            onClick: this.changeTypeToDate.bind(this),
            className: switchCls + '-normal'
          }, locale.month), type === 'month' ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: switchCls + '-focus'
          }, locale.year) : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            onClick: this.changeTypeToMonth.bind(this),
            className: switchCls + '-normal'
          }, locale.year)) : null;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-header'
          }, typeSwitcher, monthSelect, yearSelect, headerComponents);
        };

        return CalendarHeader;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      CalendarHeader_CalendarHeader.propTypes = {
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        yearSelectOffset: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        yearSelectTotal: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        onValueChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onTypeChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        Select: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showTypeSwitch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        headerComponents: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array
      };
      CalendarHeader_CalendarHeader.defaultProps = {
        yearSelectOffset: 10,
        yearSelectTotal: 20,
        onValueChange: CalendarHeader_noop,
        onTypeChange: CalendarHeader_noop
      };
      /* harmony default export */

      var full_calendar_CalendarHeader = CalendarHeader_CalendarHeader; // CONCATENATED MODULE: ./node_modules/rc-calendar/es/FullCalendar.js

      var FullCalendar_FullCalendar = create_react_class_default()({
        displayName: 'FullCalendar',
        propTypes: {
          defaultType: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          onTypeChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          fullscreen: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          monthCellRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          dateCellRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          showTypeSwitch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          Select: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
          headerComponents: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          headerComponent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          // The whole header component
          headerRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          showHeader: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          disabledDate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        },
        mixins: [CommonMixin["a"
        /* default */
        ], CalendarMixin["a"
        /* default */
        ]],
        getDefaultProps: function getDefaultProps() {
          return {
            defaultType: 'date',
            fullscreen: false,
            showTypeSwitch: true,
            showHeader: true,
            onTypeChange: function onTypeChange() {}
          };
        },
        getInitialState: function getInitialState() {
          var type = void 0;

          if ('type' in this.props) {
            type = this.props.type;
          } else {
            type = this.props.defaultType;
          }

          return {
            type: type
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          if ('type' in nextProps) {
            this.setState({
              type: nextProps.type
            });
          }
        },
        onMonthSelect: function onMonthSelect(value) {
          this.onSelect(value, {
            target: 'month'
          });
        },
        setType: function setType(type) {
          if (!('type' in this.props)) {
            this.setState({
              type: type
            });
          }

          this.props.onTypeChange(type);
        },
        render: function render() {
          var props = this.props;
          var locale = props.locale,
              prefixCls = props.prefixCls,
              fullscreen = props.fullscreen,
              showHeader = props.showHeader,
              headerComponent = props.headerComponent,
              headerRender = props.headerRender,
              disabledDate = props.disabledDate;
          var _state = this.state,
              value = _state.value,
              type = _state.type;
          var header = null;

          if (showHeader) {
            if (headerRender) {
              header = headerRender(value, type, locale);
            } else {
              var TheHeader = headerComponent || full_calendar_CalendarHeader;
              header = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(TheHeader, extends_default()({
                key: 'calendar-header'
              }, props, {
                prefixCls: prefixCls + '-full',
                type: type,
                value: value,
                onTypeChange: this.setType,
                onValueChange: this.setValue
              }));
            }
          }

          var table = type === 'date' ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(DateTable["a"
          /* default */
          ], {
            dateRender: props.dateCellRender,
            contentRender: props.dateCellContentRender,
            locale: locale,
            prefixCls: prefixCls,
            onSelect: this.onSelect,
            value: value,
            disabledDate: disabledDate
          }) : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(MonthTable["a"
          /* default */
          ], {
            cellRender: props.monthCellRender,
            contentRender: props.monthCellContentRender,
            locale: locale,
            onSelect: this.onMonthSelect,
            prefixCls: prefixCls + '-month-panel',
            value: value,
            disabledDate: disabledDate
          });
          var children = [header, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            key: 'calendar-body',
            className: prefixCls + '-calendar-body'
          }, table)];
          var className = [prefixCls + '-full'];

          if (fullscreen) {
            className.push(prefixCls + '-fullscreen');
          }

          return this.renderRoot({
            children: children,
            className: className.join(' ')
          });
        }
      });
      /* harmony default export */

      var es_FullCalendar = FullCalendar_FullCalendar; // CONCATENATED MODULE: ./node_modules/antd/es/calendar/Constants.js

      var PREFIX_CLS = 'ant-fullcalendar'; // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js

      var objectWithoutProperties = __webpack_require__(42);

      var objectWithoutProperties_default =
      /*#__PURE__*/
      __webpack_require__.n(objectWithoutProperties); // EXTERNAL MODULE: ./node_modules/rc-util/es/PureRenderMixin.js


      var PureRenderMixin = __webpack_require__(117);

      var PureRenderMixin_default =
      /*#__PURE__*/
      __webpack_require__.n(PureRenderMixin); // CONCATENATED MODULE: ./node_modules/rc-checkbox/es/Checkbox.js


      var Checkbox_Checkbox = function (_React$Component) {
        inherits_default()(Checkbox, _React$Component);

        function Checkbox(props) {
          classCallCheck_default()(this, Checkbox);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          Checkbox_initialiseProps.call(_this);
          var checked = 'checked' in props ? props.checked : props.defaultChecked;
          _this.state = {
            checked: checked
          };
          return _this;
        }

        Checkbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          if ('checked' in nextProps) {
            this.setState({
              checked: nextProps.checked
            });
          }
        };

        Checkbox.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return PureRenderMixin_default.a.shouldComponentUpdate.apply(this, args);
        };

        Checkbox.prototype.focus = function focus() {
          this.input.focus();
        };

        Checkbox.prototype.blur = function blur() {
          this.input.blur();
        };

        Checkbox.prototype.render = function render() {
          var _classNames;

          var _props = this.props,
              prefixCls = _props.prefixCls,
              className = _props.className,
              style = _props.style,
              name = _props.name,
              id = _props.id,
              type = _props.type,
              disabled = _props.disabled,
              readOnly = _props.readOnly,
              tabIndex = _props.tabIndex,
              onClick = _props.onClick,
              onFocus = _props.onFocus,
              onBlur = _props.onBlur,
              autoFocus = _props.autoFocus,
              value = _props.value,
              others = objectWithoutProperties_default()(_props, ['prefixCls', 'className', 'style', 'name', 'id', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur', 'autoFocus', 'value']);
          var globalProps = Object.keys(others).reduce(function (prev, key) {
            if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
              prev[key] = others[key];
            }

            return prev;
          }, {});
          var checked = this.state.checked;
          var classString = classnames_default()(prefixCls, className, (_classNames = {}, _classNames[prefixCls + '-checked'] = checked, _classNames[prefixCls + '-disabled'] = disabled, _classNames));
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: classString,
            style: style
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('input', extends_default()({
            name: name,
            id: id,
            type: type,
            readOnly: readOnly,
            disabled: disabled,
            tabIndex: tabIndex,
            className: prefixCls + '-input',
            checked: !!checked,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: this.handleChange,
            autoFocus: autoFocus,
            ref: this.saveInput,
            value: value
          }, globalProps)), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: prefixCls + '-inner'
          }));
        };

        return Checkbox;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Checkbox_Checkbox.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        name: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        defaultChecked: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool]),
        checked: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool]),
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        tabIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        autoFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      Checkbox_Checkbox.defaultProps = {
        prefixCls: 'rc-checkbox',
        className: '',
        style: {},
        type: 'checkbox',
        defaultChecked: false,
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onChange: function onChange() {}
      };

      var Checkbox_initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.handleChange = function (e) {
          var props = _this2.props;

          if (props.disabled) {
            return;
          }

          if (!('checked' in props)) {
            _this2.setState({
              checked: e.target.checked
            });
          }

          props.onChange({
            target: extends_default()({}, props, {
              checked: e.target.checked
            }),
            stopPropagation: function stopPropagation() {
              e.stopPropagation();
            },
            preventDefault: function preventDefault() {
              e.preventDefault();
            },
            nativeEvent: e.nativeEvent
          });
        };

        this.saveInput = function (node) {
          _this2.input = node;
        };
      };
      /* harmony default export */


      var es_Checkbox = Checkbox_Checkbox; // CONCATENATED MODULE: ./node_modules/rc-checkbox/es/index.js

      /* harmony default export */

      var rc_checkbox_es = es_Checkbox; // CONCATENATED MODULE: ./node_modules/antd/es/radio/radio.js

      var radio_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var radio_Radio = function (_React$Component) {
        inherits_default()(Radio, _React$Component);

        function Radio() {
          classCallCheck_default()(this, Radio);

          var _this = possibleConstructorReturn_default()(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));

          _this.saveCheckbox = function (node) {
            _this.rcCheckbox = node;
          };

          return _this;
        }

        createClass_default()(Radio, [{
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
            return !shallowequal_default()(this.props, nextProps) || !shallowequal_default()(this.state, nextState) || !shallowequal_default()(this.context.radioGroup, nextContext.radioGroup);
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.rcCheckbox.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.rcCheckbox.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var props = this.props,
                context = this.context;
            var prefixCls = props.prefixCls,
                className = props.className,
                children = props.children,
                style = props.style,
                restProps = radio_rest(props, ["prefixCls", "className", "children", "style"]);
            var radioGroup = context.radioGroup;
            var radioProps = extends_default()({}, restProps);

            if (radioGroup) {
              radioProps.name = radioGroup.name;
              radioProps.onChange = radioGroup.onChange;
              radioProps.checked = props.value === radioGroup.value;
              radioProps.disabled = props.disabled || radioGroup.disabled;
            }

            var wrapperClassString = classnames_default()(className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-wrapper', true), defineProperty_default()(_classNames, prefixCls + '-wrapper-checked', radioProps.checked), defineProperty_default()(_classNames, prefixCls + '-wrapper-disabled', radioProps.disabled), _classNames));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('label', {
              className: wrapperClassString,
              style: style,
              onMouseEnter: props.onMouseEnter,
              onMouseLeave: props.onMouseLeave
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_checkbox_es, extends_default()({}, radioProps, {
              prefixCls: prefixCls,
              ref: this.saveCheckbox
            })), children !== undefined ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, children) : null);
          }
        }]);
        return Radio;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var radio_radio = radio_Radio;
      radio_Radio.defaultProps = {
        prefixCls: 'ant-radio',
        type: 'radio'
      };
      radio_Radio.contextTypes = {
        radioGroup: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/antd/es/radio/group.js

      function group_getCheckedValue(children) {
        var value = null;
        var matched = false;
        external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(children, function (radio) {
          if (radio && radio.props && radio.props.checked) {
            value = radio.props.value;
            matched = true;
          }
        });
        return matched ? {
          value: value
        } : undefined;
      }

      var group_RadioGroup = function (_React$Component) {
        inherits_default()(RadioGroup, _React$Component);

        function RadioGroup(props) {
          classCallCheck_default()(this, RadioGroup);

          var _this = possibleConstructorReturn_default()(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props));

          _this.onRadioChange = function (ev) {
            var lastValue = _this.state.value;
            var value = ev.target.value;

            if (!('value' in _this.props)) {
              _this.setState({
                value: value
              });
            }

            var onChange = _this.props.onChange;

            if (onChange && value !== lastValue) {
              onChange(ev);
            }
          };

          var value = void 0;

          if ('value' in props) {
            value = props.value;
          } else if ('defaultValue' in props) {
            value = props.defaultValue;
          } else {
            var checkedValue = group_getCheckedValue(props.children);
            value = checkedValue && checkedValue.value;
          }

          _this.state = {
            value: value
          };
          return _this;
        }

        createClass_default()(RadioGroup, [{
          key: 'getChildContext',
          value: function getChildContext() {
            return {
              radioGroup: {
                onChange: this.onRadioChange,
                value: this.state.value,
                disabled: this.props.disabled,
                name: this.props.name
              }
            };
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
              this.setState({
                value: nextProps.value
              });
            } else {
              var checkedValue = group_getCheckedValue(nextProps.children);

              if (checkedValue) {
                this.setState({
                  value: checkedValue.value
                });
              }
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps, nextState) {
            return !shallowequal_default()(this.props, nextProps) || !shallowequal_default()(this.state, nextState);
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this;

            var props = this.props;
            var _props$prefixCls = props.prefixCls,
                prefixCls = _props$prefixCls === undefined ? 'ant-radio-group' : _props$prefixCls,
                _props$className = props.className,
                className = _props$className === undefined ? '' : _props$className,
                options = props.options;
            var classString = classnames_default()(prefixCls, defineProperty_default()({}, prefixCls + '-' + props.size, props.size), className);
            var children = props.children; // 如果存在 options, 优先使用

            if (options && options.length > 0) {
              children = options.map(function (option, index) {
                if (typeof option === 'string') {
                  // 此处类型自动推导为 string
                  return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](radio_radio, {
                    key: index,
                    disabled: _this2.props.disabled,
                    value: option,
                    onChange: _this2.onRadioChange,
                    checked: _this2.state.value === option
                  }, option);
                } else {
                  // 此处类型自动推导为 { label: string value: string }
                  return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](radio_radio, {
                    key: index,
                    disabled: option.disabled || _this2.props.disabled,
                    value: option.value,
                    onChange: _this2.onRadioChange,
                    checked: _this2.state.value === option.value
                  }, option.label);
                }
              });
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: classString,
              style: props.style,
              onMouseEnter: props.onMouseEnter,
              onMouseLeave: props.onMouseLeave,
              id: props.id
            }, children);
          }
        }]);
        return RadioGroup;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var group = group_RadioGroup;
      group_RadioGroup.defaultProps = {
        disabled: false
      };
      group_RadioGroup.childContextTypes = {
        radioGroup: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/antd/es/radio/radioButton.js

      var radioButton_RadioButton = function (_React$Component) {
        inherits_default()(RadioButton, _React$Component);

        function RadioButton() {
          classCallCheck_default()(this, RadioButton);
          return possibleConstructorReturn_default()(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
        }

        createClass_default()(RadioButton, [{
          key: 'render',
          value: function render() {
            var radioProps = extends_default()({}, this.props);

            if (this.context.radioGroup) {
              radioProps.onChange = this.context.radioGroup.onChange;
              radioProps.checked = this.props.value === this.context.radioGroup.value;
              radioProps.disabled = this.props.disabled || this.context.radioGroup.disabled;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](radio_radio, radioProps);
          }
        }]);
        return RadioButton;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var radioButton = radioButton_RadioButton;
      radioButton_RadioButton.defaultProps = {
        prefixCls: 'ant-radio-button'
      };
      radioButton_RadioButton.contextTypes = {
        radioGroup: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/antd/es/radio/index.js

      radio_radio.Button = radioButton;
      radio_radio.Group = group;
      /* harmony default export */

      var es_radio = radio_radio; // CONCATENATED MODULE: ./node_modules/antd/es/calendar/Header.js

      var Header_Option = es_select.Option;

      var Header_Header = function (_React$Component) {
        inherits_default()(Header, _React$Component);

        function Header() {
          classCallCheck_default()(this, Header);

          var _this = possibleConstructorReturn_default()(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));

          _this.onYearChange = function (year) {
            var _this$props = _this.props,
                value = _this$props.value,
                validRange = _this$props.validRange;
            var newValue = value.clone();
            newValue.year(parseInt(year, 10)); // switch the month so that it remains within range when year changes

            if (validRange) {
              var _validRange = slicedToArray_default()(validRange, 2),
                  start = _validRange[0],
                  end = _validRange[1];

              var newYear = newValue.get('year');
              var newMonth = newValue.get('month');

              if (newYear === end.get('year') && newMonth > end.get('month')) {
                newValue.month(end.get('month'));
              }

              if (newYear === start.get('year') && newMonth < start.get('month')) {
                newValue.month(start.get('month'));
              }
            }

            var onValueChange = _this.props.onValueChange;

            if (onValueChange) {
              onValueChange(newValue);
            }
          };

          _this.onMonthChange = function (month) {
            var newValue = _this.props.value.clone();

            newValue.month(parseInt(month, 10));
            var onValueChange = _this.props.onValueChange;

            if (onValueChange) {
              onValueChange(newValue);
            }
          };

          _this.onTypeChange = function (e) {
            var onTypeChange = _this.props.onTypeChange;

            if (onTypeChange) {
              onTypeChange(e.target.value);
            }
          };

          _this.getCalenderHeaderNode = function (node) {
            _this.calenderHeaderNode = node;
          };

          return _this;
        }

        createClass_default()(Header, [{
          key: 'getYearSelectElement',
          value: function getYearSelectElement(year) {
            var _this2 = this;

            var _props = this.props,
                yearSelectOffset = _props.yearSelectOffset,
                yearSelectTotal = _props.yearSelectTotal,
                locale = _props.locale,
                prefixCls = _props.prefixCls,
                fullscreen = _props.fullscreen,
                validRange = _props.validRange;
            var start = year - yearSelectOffset;
            var end = start + yearSelectTotal;

            if (validRange) {
              start = validRange[0].get('year');
              end = validRange[1].get('year') + 1;
            }

            var suffix = locale.year === '年' ? '年' : '';
            var options = [];

            for (var index = start; index < end; index++) {
              options.push(external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Header_Option, {
                key: '' + index
              }, index + suffix));
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_select, {
              size: fullscreen ? 'default' : 'small',
              dropdownMatchSelectWidth: false,
              className: prefixCls + '-year-select',
              onChange: this.onYearChange,
              value: String(year),
              getPopupContainer: function getPopupContainer() {
                return _this2.calenderHeaderNode;
              }
            }, options);
          }
        }, {
          key: 'getMonthsLocale',
          value: function getMonthsLocale(value) {
            var current = value.clone();
            var localeData = value.localeData();
            var months = [];

            for (var i = 0; i < 12; i++) {
              current.month(i);
              months.push(localeData.monthsShort(current));
            }

            return months;
          }
        }, {
          key: 'getMonthSelectElement',
          value: function getMonthSelectElement(month, months) {
            var _this3 = this;

            var props = this.props;
            var prefixCls = props.prefixCls,
                fullscreen = props.fullscreen,
                validRange = props.validRange,
                value = props.value;
            var options = [];
            var start = 0;
            var end = 12;

            if (validRange) {
              var _validRange2 = slicedToArray_default()(validRange, 2),
                  rangeStart = _validRange2[0],
                  rangeEnd = _validRange2[1];

              var currentYear = value.get('year');

              if (rangeEnd.get('year') === currentYear) {
                end = rangeEnd.get('month') + 1;
              } else {
                start = rangeStart.get('month');
              }
            }

            for (var index = start; index < end; index++) {
              options.push(external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Header_Option, {
                key: '' + index
              }, months[index]));
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_select, {
              size: fullscreen ? 'default' : 'small',
              dropdownMatchSelectWidth: false,
              className: prefixCls + '-month-select',
              value: String(month),
              onChange: this.onMonthChange,
              getPopupContainer: function getPopupContainer() {
                return _this3.calenderHeaderNode;
              }
            }, options);
          }
        }, {
          key: 'render',
          value: function render() {
            var _props2 = this.props,
                type = _props2.type,
                value = _props2.value,
                prefixCls = _props2.prefixCls,
                locale = _props2.locale,
                fullscreen = _props2.fullscreen;
            var yearSelect = this.getYearSelectElement(value.year());
            var monthSelect = type === 'date' ? this.getMonthSelectElement(value.month(), this.getMonthsLocale(value)) : null;
            var size = fullscreen ? 'default' : 'small';
            var typeSwitch = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](group, {
              onChange: this.onTypeChange,
              value: type,
              size: size
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](radioButton, {
              value: 'date'
            }, locale.month), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](radioButton, {
              value: 'month'
            }, locale.year));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-header',
              ref: this.getCalenderHeaderNode
            }, yearSelect, monthSelect, typeSwitch);
          }
        }]);
        return Header;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var calendar_Header = Header_Header;
      Header_Header.defaultProps = {
        prefixCls: PREFIX_CLS + '-header',
        yearSelectOffset: 10,
        yearSelectTotal: 20
      }; // CONCATENATED MODULE: ./node_modules/antd/es/_util/interopDefault.js
      // https://github.com/moment/moment/issues/3650

      function interopDefault(m) {
        return m["default"] || m;
      } // CONCATENATED MODULE: ./node_modules/antd/es/calendar/index.js


      function calendar_noop() {
        return null;
      }

      function calendar_zerofixed(v) {
        if (v < 10) {
          return '0' + v;
        }

        return '' + v;
      }

      var calendar_Calendar = function (_React$Component) {
        inherits_default()(Calendar, _React$Component);

        function Calendar(props) {
          classCallCheck_default()(this, Calendar);

          var _this = possibleConstructorReturn_default()(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

          _this.monthCellRender = function (value) {
            var _this$props = _this.props,
                prefixCls = _this$props.prefixCls,
                _this$props$monthCell = _this$props.monthCellRender,
                monthCellRender = _this$props$monthCell === undefined ? calendar_noop : _this$props$monthCell;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-month'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-value'
            }, value.localeData().monthsShort(value)), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-content'
            }, monthCellRender(value)));
          };

          _this.dateCellRender = function (value) {
            var _this$props2 = _this.props,
                prefixCls = _this$props2.prefixCls,
                _this$props2$dateCell = _this$props2.dateCellRender,
                dateCellRender = _this$props2$dateCell === undefined ? calendar_noop : _this$props2$dateCell;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-date'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-value'
            }, calendar_zerofixed(value.date())), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-content'
            }, dateCellRender(value)));
          };

          _this.setValue = function (value, way) {
            if (!('value' in _this.props)) {
              _this.setState({
                value: value
              });
            }

            if (way === 'select') {
              if (_this.props.onSelect) {
                _this.props.onSelect(value);
              }
            } else if (way === 'changePanel') {
              _this.onPanelChange(value, _this.state.mode);
            }
          };

          _this.setType = function (type) {
            var mode = type === 'date' ? 'month' : 'year';

            if (_this.state.mode !== mode) {
              _this.setState({
                mode: mode
              });

              _this.onPanelChange(_this.state.value, mode);
            }
          };

          _this.onHeaderValueChange = function (value) {
            _this.setValue(value, 'changePanel');
          };

          _this.onHeaderTypeChange = function (type) {
            _this.setType(type);
          };

          _this.onSelect = function (value) {
            _this.setValue(value, 'select');
          };

          _this.getDateRange = function (validRange, disabledDate) {
            return function (current) {
              if (!current) {
                return false;
              }

              var _validRange = slicedToArray_default()(validRange, 2),
                  startDate = _validRange[0],
                  endDate = _validRange[1];

              var inRange = !current.isBetween(startDate, endDate, 'days', '[]');

              if (disabledDate) {
                return disabledDate(current) || inRange;
              }

              return inRange;
            };
          };

          _this.renderCalendar = function (locale, localeCode) {
            var state = _this.state,
                props = _this.props;
            var value = state.value,
                mode = state.mode;

            if (value && localeCode) {
              value.locale(localeCode);
            }

            var prefixCls = props.prefixCls,
                style = props.style,
                className = props.className,
                fullscreen = props.fullscreen,
                dateFullCellRender = props.dateFullCellRender,
                monthFullCellRender = props.monthFullCellRender;
            var type = mode === 'year' ? 'month' : 'date';
            var cls = className || '';

            if (fullscreen) {
              cls += ' ' + prefixCls + '-fullscreen';
            }

            var monthCellRender = monthFullCellRender || _this.monthCellRender;
            var dateCellRender = dateFullCellRender || _this.dateCellRender;
            var disabledDate = props.disabledDate;

            if (props.validRange) {
              disabledDate = _this.getDateRange(props.validRange, disabledDate);
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: cls,
              style: style
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](calendar_Header, {
              fullscreen: fullscreen,
              type: type,
              value: value,
              locale: locale.lang,
              prefixCls: prefixCls,
              onTypeChange: _this.onHeaderTypeChange,
              onValueChange: _this.onHeaderValueChange,
              validRange: props.validRange
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_FullCalendar, extends_default()({}, props, {
              disabledDate: disabledDate,
              Select: calendar_noop,
              locale: locale.lang,
              type: type,
              prefixCls: prefixCls,
              showHeader: false,
              value: value,
              monthCellRender: monthCellRender,
              dateCellRender: dateCellRender,
              onSelect: _this.onSelect
            })));
          };

          var value = props.value || props.defaultValue || interopDefault(moment)();

          if (!interopDefault(moment).isMoment(value)) {
            throw new Error('The value/defaultValue of Calendar must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/calendar-value');
          }

          _this.state = {
            value: value,
            mode: props.mode
          };
          return _this;
        }

        createClass_default()(Calendar, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
              this.setState({
                value: nextProps.value
              });
            }

            if ('mode' in nextProps && nextProps.mode !== this.props.mode) {
              this.setState({
                mode: nextProps.mode
              });
            }
          }
        }, {
          key: 'onPanelChange',
          value: function onPanelChange(value, mode) {
            var onPanelChange = this.props.onPanelChange;

            if (onPanelChange) {
              onPanelChange(value, mode);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
              componentName: 'Calendar',
              defaultLocale: calendar_locale_en_US
            }, this.renderCalendar);
          }
        }]);
        return Calendar;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_calendar = calendar_Calendar;
      calendar_Calendar.defaultProps = {
        locale: {},
        fullscreen: true,
        prefixCls: PREFIX_CLS,
        mode: 'month',
        onSelect: calendar_noop,
        onPanelChange: calendar_noop
      };
      calendar_Calendar.propTypes = {
        monthCellRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        dateCellRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        monthFullCellRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        dateFullCellRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        fullscreen: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        onPanelChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      }; // CONCATENATED MODULE: ./node_modules/antd/es/card/Grid.js

      var Grid_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };
      /* harmony default export */


      var Grid = function Grid(props) {
        var _props$prefixCls = props.prefixCls,
            prefixCls = _props$prefixCls === undefined ? 'ant-card' : _props$prefixCls,
            className = props.className,
            others = Grid_rest(props, ["prefixCls", "className"]);
        var classString = classnames_default()(prefixCls + '-grid', className);
        return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, others, {
          className: classString
        }));
      }; // CONCATENATED MODULE: ./node_modules/antd/es/card/Meta.js


      var Meta_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };
      /* harmony default export */


      var card_Meta = function card_Meta(props) {
        var _props$prefixCls = props.prefixCls,
            prefixCls = _props$prefixCls === undefined ? 'ant-card' : _props$prefixCls,
            className = props.className,
            avatar = props.avatar,
            title = props.title,
            description = props.description,
            others = Meta_rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
        var classString = classnames_default()(prefixCls + '-meta', className);
        var avatarDom = avatar ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-meta-avatar'
        }, avatar) : null;
        var titleDom = title ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-meta-title'
        }, title) : null;
        var descriptionDom = description ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-meta-description'
        }, description) : null;
        var MetaDetail = titleDom || descriptionDom ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-meta-detail'
        }, titleDom, descriptionDom) : null;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, others, {
          className: classString
        }), avatarDom, MetaDetail);
      }; // CONCATENATED MODULE: ./node_modules/rc-tabs/es/KeyCode.js

      /* harmony default export */


      var KeyCode = {
        /**
         * LEFT
         */
        LEFT: 37,
        // also NUM_WEST

        /**
         * UP
         */
        UP: 38,
        // also NUM_NORTH

        /**
         * RIGHT
         */
        RIGHT: 39,
        // also NUM_EAST

        /**
         * DOWN
         */
        DOWN: 40 // also NUM_SOUTH

      }; // CONCATENATED MODULE: ./node_modules/rc-tabs/es/utils.js

      function utils_toArray(children) {
        // allow [c,[a,b]]
        var c = [];
        external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(children, function (child) {
          if (child) {
            c.push(child);
          }
        });
        return c;
      }

      function utils_getActiveIndex(children, activeKey) {
        var c = utils_toArray(children);

        for (var i = 0; i < c.length; i++) {
          if (c[i].key === activeKey) {
            return i;
          }
        }

        return -1;
      }

      function utils_getActiveKey(children, index) {
        var c = utils_toArray(children);
        return c[index].key;
      }

      function utils_setTransform(style, v) {
        style.transform = v;
        style.webkitTransform = v;
        style.mozTransform = v;
      }

      function utils_isTransformSupported(style) {
        return 'transform' in style || 'webkitTransform' in style || 'MozTransform' in style;
      }

      function utils_setTransition(style, v) {
        style.transition = v;
        style.webkitTransition = v;
        style.MozTransition = v;
      }

      function utils_getTransformPropValue(v) {
        return {
          transform: v,
          WebkitTransform: v,
          MozTransform: v
        };
      }

      function utils_isVertical(tabBarPosition) {
        return tabBarPosition === 'left' || tabBarPosition === 'right';
      }

      function utils_getTransformByIndex(index, tabBarPosition) {
        var translate = utils_isVertical(tabBarPosition) ? 'translateY' : 'translateX';
        return translate + '(' + -index * 100 + '%) translateZ(0)';
      }

      function utils_getMarginStyle(index, tabBarPosition) {
        var marginDirection = utils_isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
        return defineProperty_default()({}, marginDirection, -index * 100 + '%');
      }

      function utils_getStyle(el, property) {
        return +getComputedStyle(el).getPropertyValue(property).replace('px', '');
      }

      function utils_setPxStyle(el, value, vertical) {
        value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
        utils_setTransform(el.style, 'translate3d(' + value + ')');
      }

      function utils_getDataAttr(props) {
        return Object.keys(props).reduce(function (prev, key) {
          if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
            prev[key] = props[key];
          }

          return prev;
        }, {});
      } // CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabPane.js


      var TabPane_TabPane = create_react_class_default()({
        displayName: 'TabPane',
        propTypes: {
          className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          active: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          destroyInactiveTabPane: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          forceRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node
        },
        getDefaultProps: function getDefaultProps() {
          return {
            placeholder: null
          };
        },
        render: function render() {
          var _classnames;

          var _props = this.props,
              className = _props.className,
              destroyInactiveTabPane = _props.destroyInactiveTabPane,
              active = _props.active,
              forceRender = _props.forceRender,
              rootPrefixCls = _props.rootPrefixCls,
              style = _props.style,
              children = _props.children,
              placeholder = _props.placeholder,
              restProps = objectWithoutProperties_default()(_props, ['className', 'destroyInactiveTabPane', 'active', 'forceRender', 'rootPrefixCls', 'style', 'children', 'placeholder']);
          this._isActived = this._isActived || active;
          var prefixCls = rootPrefixCls + '-tabpane';
          var cls = classnames_default()((_classnames = {}, defineProperty_default()(_classnames, prefixCls, 1), defineProperty_default()(_classnames, prefixCls + '-inactive', !active), defineProperty_default()(_classnames, prefixCls + '-active', active), defineProperty_default()(_classnames, className, className), _classnames));
          var isRender = destroyInactiveTabPane ? active : this._isActived;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', extends_default()({
            style: style,
            role: 'tabpanel',
            'aria-hidden': active ? 'false' : 'true',
            className: cls
          }, utils_getDataAttr(restProps)), isRender || forceRender ? children : placeholder);
        }
      });
      /* harmony default export */

      var es_TabPane = TabPane_TabPane; // CONCATENATED MODULE: ./node_modules/rc-tabs/es/Tabs.js

      function Tabs_noop() {}

      function Tabs_getDefaultActiveKey(props) {
        var activeKey = void 0;
        external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(props.children, function (child) {
          if (child && !activeKey && !child.props.disabled) {
            activeKey = child.key;
          }
        });
        return activeKey;
      }

      function Tabs_activeKeyIsValid(props, key) {
        var keys = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.map(props.children, function (child) {
          return child && child.key;
        });
        return keys.indexOf(key) >= 0;
      }

      var Tabs_Tabs = function (_React$Component) {
        inherits_default()(Tabs, _React$Component);

        function Tabs(props) {
          classCallCheck_default()(this, Tabs);

          var _this = possibleConstructorReturn_default()(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

          Tabs_initialiseProps.call(_this);
          var activeKey = void 0;

          if ('activeKey' in props) {
            activeKey = props.activeKey;
          } else if ('defaultActiveKey' in props) {
            activeKey = props.defaultActiveKey;
          } else {
            activeKey = Tabs_getDefaultActiveKey(props);
          }

          _this.state = {
            activeKey: activeKey
          };
          return _this;
        }

        createClass_default()(Tabs, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('activeKey' in nextProps) {
              this.setState({
                activeKey: nextProps.activeKey
              });
            } else if (!Tabs_activeKeyIsValid(nextProps, this.state.activeKey)) {
              // https://github.com/ant-design/ant-design/issues/7093
              this.setState({
                activeKey: Tabs_getDefaultActiveKey(nextProps)
              });
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _classnames;

            var props = this.props;
            var prefixCls = props.prefixCls,
                navWrapper = props.navWrapper,
                tabBarPosition = props.tabBarPosition,
                className = props.className,
                renderTabContent = props.renderTabContent,
                renderTabBar = props.renderTabBar,
                destroyInactiveTabPane = props.destroyInactiveTabPane,
                restProps = objectWithoutProperties_default()(props, ['prefixCls', 'navWrapper', 'tabBarPosition', 'className', 'renderTabContent', 'renderTabBar', 'destroyInactiveTabPane']);
            var cls = classnames_default()((_classnames = {}, defineProperty_default()(_classnames, prefixCls, 1), defineProperty_default()(_classnames, prefixCls + '-' + tabBarPosition, 1), defineProperty_default()(_classnames, className, !!className), _classnames));
            this.tabBar = renderTabBar();
            var contents = [external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(this.tabBar, {
              prefixCls: prefixCls,
              navWrapper: navWrapper,
              key: 'tabBar',
              onKeyDown: this.onNavKeyDown,
              tabBarPosition: tabBarPosition,
              onTabClick: this.onTabClick,
              panels: props.children,
              activeKey: this.state.activeKey
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(renderTabContent(), {
              prefixCls: prefixCls,
              tabBarPosition: tabBarPosition,
              activeKey: this.state.activeKey,
              destroyInactiveTabPane: destroyInactiveTabPane,
              children: props.children,
              onChange: this.setActiveKey,
              key: 'tabContent'
            })];

            if (tabBarPosition === 'bottom') {
              contents.reverse();
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', extends_default()({
              className: cls,
              style: props.style
            }, utils_getDataAttr(restProps)), contents);
          }
        }]);
        return Tabs;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      var Tabs_initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.onTabClick = function (activeKey, e) {
          if (_this2.tabBar.props.onTabClick) {
            _this2.tabBar.props.onTabClick(activeKey, e);
          }

          _this2.setActiveKey(activeKey);
        };

        this.onNavKeyDown = function (e) {
          var eventKeyCode = e.keyCode;

          if (eventKeyCode === KeyCode.RIGHT || eventKeyCode === KeyCode.DOWN) {
            e.preventDefault();

            var nextKey = _this2.getNextActiveKey(true);

            _this2.onTabClick(nextKey);
          } else if (eventKeyCode === KeyCode.LEFT || eventKeyCode === KeyCode.UP) {
            e.preventDefault();

            var previousKey = _this2.getNextActiveKey(false);

            _this2.onTabClick(previousKey);
          }
        };

        this.setActiveKey = function (activeKey) {
          if (_this2.state.activeKey !== activeKey) {
            if (!('activeKey' in _this2.props)) {
              _this2.setState({
                activeKey: activeKey
              });
            }

            _this2.props.onChange(activeKey);
          }
        };

        this.getNextActiveKey = function (next) {
          var activeKey = _this2.state.activeKey;
          var children = [];
          external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(_this2.props.children, function (c) {
            if (c && !c.props.disabled) {
              if (next) {
                children.push(c);
              } else {
                children.unshift(c);
              }
            }
          });
          var length = children.length;
          var ret = length && children[0].key;
          children.forEach(function (child, i) {
            if (child.key === activeKey) {
              if (i === length - 1) {
                ret = children[0].key;
              } else {
                ret = children[i + 1].key;
              }
            }
          });
          return ret;
        };
      };
      /* harmony default export */


      var es_Tabs = Tabs_Tabs;
      Tabs_Tabs.propTypes = {
        destroyInactiveTabPane: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        renderTabBar: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        renderTabContent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        navWrapper: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        tabBarPosition: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        activeKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        defaultActiveKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      Tabs_Tabs.defaultProps = {
        prefixCls: 'rc-tabs',
        destroyInactiveTabPane: false,
        onChange: Tabs_noop,
        navWrapper: function navWrapper(arg) {
          return arg;
        },
        tabBarPosition: 'top',
        style: {}
      };
      Tabs_Tabs.TabPane = es_TabPane; // CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabContent.js

      var TabContent_TabContent = create_react_class_default()({
        displayName: 'TabContent',
        propTypes: {
          animated: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          animatedWithMargin: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          activeKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          tabBarPosition: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        },
        getDefaultProps: function getDefaultProps() {
          return {
            animated: true
          };
        },
        getTabPanes: function getTabPanes() {
          var props = this.props;
          var activeKey = props.activeKey;
          var children = props.children;
          var newChildren = [];
          external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(children, function (child) {
            if (!child) {
              return;
            }

            var key = child.key;
            var active = activeKey === key;
            newChildren.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(child, {
              active: active,
              destroyInactiveTabPane: props.destroyInactiveTabPane,
              rootPrefixCls: props.prefixCls
            }));
          });
          return newChildren;
        },
        render: function render() {
          var _classnames;

          var props = this.props;
          var prefixCls = props.prefixCls,
              children = props.children,
              activeKey = props.activeKey,
              tabBarPosition = props.tabBarPosition,
              animated = props.animated,
              animatedWithMargin = props.animatedWithMargin;
          var style = props.style;
          var classes = classnames_default()((_classnames = {}, defineProperty_default()(_classnames, prefixCls + '-content', true), defineProperty_default()(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames));

          if (animated) {
            var activeIndex = utils_getActiveIndex(children, activeKey);

            if (activeIndex !== -1) {
              var animatedStyle = animatedWithMargin ? utils_getMarginStyle(activeIndex, tabBarPosition) : utils_getTransformPropValue(utils_getTransformByIndex(activeIndex, tabBarPosition));
              style = extends_default()({}, style, animatedStyle);
            } else {
              style = extends_default()({}, style, {
                display: 'none'
              });
            }
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: classes,
            style: style
          }, this.getTabPanes());
        }
      });
      /* harmony default export */

      var es_TabContent = TabContent_TabContent; // CONCATENATED MODULE: ./node_modules/rc-tabs/es/index.js

      /* harmony default export */

      var rc_tabs_es = es_Tabs; // CONCATENATED MODULE: ./node_modules/rc-tabs/es/InkTabBarMixin.js

      var InkTabBarMixin_isDev = "production" !== 'production';

      function InkTabBarMixin_getScroll(w, top) {
        var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
        var method = 'scroll' + (top ? 'Top' : 'Left');

        if (typeof ret !== 'number') {
          var d = w.document; // ie6,7,8 standard mode

          ret = d.documentElement[method];

          if (typeof ret !== 'number') {
            // quirks mode
            ret = d.body[method];
          }
        }

        return ret;
      }

      function InkTabBarMixin_offset(elem) {
        var box = void 0;
        var x = void 0;
        var y = void 0;
        var doc = elem.ownerDocument;
        var body = doc.body;
        var docElem = doc && doc.documentElement;
        box = elem.getBoundingClientRect();
        x = box.left;
        y = box.top;
        x -= docElem.clientLeft || body.clientLeft || 0;
        y -= docElem.clientTop || body.clientTop || 0;
        var w = doc.defaultView || doc.parentWindow;
        x += InkTabBarMixin_getScroll(w);
        y += InkTabBarMixin_getScroll(w, true);
        return {
          left: x,
          top: y
        };
      }

      function InkTabBarMixin_componentDidUpdate(component, init) {
        var styles = component.props.styles;
        var rootNode = component.root;
        var wrapNode = component.nav || rootNode;
        var containerOffset = InkTabBarMixin_offset(wrapNode);
        var inkBarNode = component.inkBar;
        var activeTab = component.activeTab;
        var inkBarNodeStyle = inkBarNode.style;
        var tabBarPosition = component.props.tabBarPosition;

        if (init) {
          // prevent mount animation
          inkBarNodeStyle.display = 'none';
        }

        if (activeTab) {
          var tabNode = activeTab;
          var tabOffset = InkTabBarMixin_offset(tabNode);
          var transformSupported = utils_isTransformSupported(inkBarNodeStyle);

          if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
            var left = tabOffset.left - containerOffset.left;
            var width = tabNode.offsetWidth; // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
            // It means no css working, then ink bar should not have width until css is loaded
            // Fix https://github.com/ant-design/ant-design/issues/7564

            if (width === rootNode.offsetWidth) {
              width = 0;
            } else if (styles.inkBar && styles.inkBar.width !== undefined) {
              width = parseFloat(styles.inkBar.width, 10);

              if (width) {
                left = left + (tabNode.offsetWidth - width) / 2;
              }
            } // use 3d gpu to optimize render


            if (transformSupported) {
              utils_setTransform(inkBarNodeStyle, 'translate3d(' + left + 'px,0,0)');
              inkBarNodeStyle.width = width + 'px';
              inkBarNodeStyle.height = '';
            } else {
              inkBarNodeStyle.left = left + 'px';
              inkBarNodeStyle.top = '';
              inkBarNodeStyle.bottom = '';
              inkBarNodeStyle.right = wrapNode.offsetWidth - left - width + 'px';
            }
          } else {
            var top = tabOffset.top - containerOffset.top;
            var height = tabNode.offsetHeight;

            if (styles.inkBar && styles.inkBar.height !== undefined) {
              height = parseFloat(styles.inkBar.height, 10);

              if (height) {
                top = top + (tabNode.offsetHeight - height) / 2;
              }
            }

            if (transformSupported) {
              utils_setTransform(inkBarNodeStyle, 'translate3d(0,' + top + 'px,0)');
              inkBarNodeStyle.height = height + 'px';
              inkBarNodeStyle.width = '';
            } else {
              inkBarNodeStyle.left = '';
              inkBarNodeStyle.right = '';
              inkBarNodeStyle.top = top + 'px';
              inkBarNodeStyle.bottom = wrapNode.offsetHeight - top - height + 'px';
            }
          }
        }

        inkBarNodeStyle.display = activeTab ? 'block' : 'none';
      }
      /* harmony default export */


      var InkTabBarMixin = {
        getDefaultProps: function getDefaultProps() {
          return {
            inkBarAnimated: true
          };
        },
        componentDidUpdate: function componentDidUpdate() {
          InkTabBarMixin_componentDidUpdate(this);
        },
        componentDidMount: function componentDidMount() {
          var _this = this;

          if (InkTabBarMixin_isDev) {
            // https://github.com/ant-design/ant-design/issues/8678
            this.timeout = setTimeout(function () {
              InkTabBarMixin_componentDidUpdate(_this, true);
            }, 0);
          } else {
            InkTabBarMixin_componentDidUpdate(this, true);
          }
        },
        componentWillUnmount: function componentWillUnmount() {
          clearTimeout(this.timeout);
        },
        getInkBarNode: function getInkBarNode() {
          var _classnames;

          var _props = this.props,
              prefixCls = _props.prefixCls,
              styles = _props.styles,
              inkBarAnimated = _props.inkBarAnimated;
          var className = prefixCls + '-ink-bar';
          var classes = classnames_default()((_classnames = {}, defineProperty_default()(_classnames, className, true), defineProperty_default()(_classnames, inkBarAnimated ? className + '-animated' : className + '-no-animated', true), _classnames));
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            style: styles.inkBar,
            className: classes,
            key: 'inkBar',
            ref: this.saveRef('inkBar')
          });
        }
      }; // EXTERNAL MODULE: ./node_modules/lodash/debounce.js

      var lodash_debounce = __webpack_require__(35);

      var debounce_default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_debounce); // CONCATENATED MODULE: ./node_modules/rc-tabs/es/ScrollableTabBarMixin.js

      /* harmony default export */


      var ScrollableTabBarMixin = {
        getDefaultProps: function getDefaultProps() {
          return {
            scrollAnimated: true,
            onPrevClick: function onPrevClick() {},
            onNextClick: function onNextClick() {}
          };
        },
        getInitialState: function getInitialState() {
          this.offset = 0;
          return {
            next: false,
            prev: false
          };
        },
        componentDidMount: function componentDidMount() {
          var _this = this;

          this.componentDidUpdate();
          this.debouncedResize = debounce_default()(function () {
            _this.setNextPrev();

            _this.scrollToActiveTab();
          }, 200);
          this.resizeEvent = Object(addEventListener["a"
          /* default */
          ])(window, 'resize', this.debouncedResize);
        },
        componentDidUpdate: function componentDidUpdate(prevProps) {
          var props = this.props;

          if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
            this.setOffset(0);
            return;
          }

          var nextPrev = this.setNextPrev();

          if (this.isNextPrevShown(this.state) !== this.isNextPrevShown(nextPrev)) {
            this.setState({}, this.scrollToActiveTab);
          } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
            this.scrollToActiveTab();
          }
        },
        componentWillUnmount: function componentWillUnmount() {
          if (this.resizeEvent) {
            this.resizeEvent.remove();
          }

          if (this.debouncedResize && this.debouncedResize.cancel) {
            this.debouncedResize.cancel();
          }
        },
        setNextPrev: function setNextPrev() {
          var navNode = this.nav;
          var navNodeWH = this.getScrollWH(navNode);
          var containerWH = this.getOffsetWH(this.container);
          var navWrapNodeWH = this.getOffsetWH(this.navWrap);
          var offset = this.offset;
          var minOffset = containerWH - navNodeWH;
          var _state = this.state,
              next = _state.next,
              prev = _state.prev;

          if (minOffset >= 0) {
            next = false;
            this.setOffset(0, false);
            offset = 0;
          } else if (minOffset < offset) {
            next = true;
          } else {
            next = false;
            var realOffset = navWrapNodeWH - navNodeWH;
            this.setOffset(realOffset, false);
            offset = realOffset;
          }

          if (offset < 0) {
            prev = true;
          } else {
            prev = false;
          }

          this.setNext(next);
          this.setPrev(prev);
          return {
            next: next,
            prev: prev
          };
        },
        getOffsetWH: function getOffsetWH(node) {
          var tabBarPosition = this.props.tabBarPosition;
          var prop = 'offsetWidth';

          if (tabBarPosition === 'left' || tabBarPosition === 'right') {
            prop = 'offsetHeight';
          }

          return node[prop];
        },
        getScrollWH: function getScrollWH(node) {
          var tabBarPosition = this.props.tabBarPosition;
          var prop = 'scrollWidth';

          if (tabBarPosition === 'left' || tabBarPosition === 'right') {
            prop = 'scrollHeight';
          }

          return node[prop];
        },
        getOffsetLT: function getOffsetLT(node) {
          var tabBarPosition = this.props.tabBarPosition;
          var prop = 'left';

          if (tabBarPosition === 'left' || tabBarPosition === 'right') {
            prop = 'top';
          }

          return node.getBoundingClientRect()[prop];
        },
        setOffset: function setOffset(offset) {
          var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          var target = Math.min(0, offset);

          if (this.offset !== target) {
            this.offset = target;
            var navOffset = {};
            var tabBarPosition = this.props.tabBarPosition;
            var navStyle = this.nav.style;
            var transformSupported = utils_isTransformSupported(navStyle);

            if (tabBarPosition === 'left' || tabBarPosition === 'right') {
              if (transformSupported) {
                navOffset = {
                  value: 'translate3d(0,' + target + 'px,0)'
                };
              } else {
                navOffset = {
                  name: 'top',
                  value: target + 'px'
                };
              }
            } else {
              if (transformSupported) {
                navOffset = {
                  value: 'translate3d(' + target + 'px,0,0)'
                };
              } else {
                navOffset = {
                  name: 'left',
                  value: target + 'px'
                };
              }
            }

            if (transformSupported) {
              utils_setTransform(navStyle, navOffset.value);
            } else {
              navStyle[navOffset.name] = navOffset.value;
            }

            if (checkNextPrev) {
              this.setNextPrev();
            }
          }
        },
        setPrev: function setPrev(v) {
          if (this.state.prev !== v) {
            this.setState({
              prev: v
            });
          }
        },
        setNext: function setNext(v) {
          if (this.state.next !== v) {
            this.setState({
              next: v
            });
          }
        },
        isNextPrevShown: function isNextPrevShown(state) {
          if (state) {
            return state.next || state.prev;
          }

          return this.state.next || this.state.prev;
        },
        prevTransitionEnd: function prevTransitionEnd(e) {
          if (e.propertyName !== 'opacity') {
            return;
          }

          var container = this.container;
          this.scrollToActiveTab({
            target: container,
            currentTarget: container
          });
        },
        scrollToActiveTab: function scrollToActiveTab(e) {
          var activeTab = this.activeTab,
              navWrap = this.navWrap;

          if (e && e.target !== e.currentTarget || !activeTab) {
            return;
          }

          var needToSroll = this.isNextPrevShown() && this.lastNextPrevShown;
          this.lastNextPrevShown = this.isNextPrevShown();

          if (!needToSroll) {
            return;
          }

          var activeTabWH = this.getScrollWH(activeTab);
          var navWrapNodeWH = this.getOffsetWH(navWrap);
          var offset = this.offset;
          var wrapOffset = this.getOffsetLT(navWrap);
          var activeTabOffset = this.getOffsetLT(activeTab);

          if (wrapOffset > activeTabOffset) {
            offset += wrapOffset - activeTabOffset;
            this.setOffset(offset);
          } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
            offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
            this.setOffset(offset);
          }
        },
        prev: function prev(e) {
          this.props.onPrevClick(e);
          var navWrapNode = this.navWrap;
          var navWrapNodeWH = this.getOffsetWH(navWrapNode);
          var offset = this.offset;
          this.setOffset(offset + navWrapNodeWH);
        },
        next: function next(e) {
          this.props.onNextClick(e);
          var navWrapNode = this.navWrap;
          var navWrapNodeWH = this.getOffsetWH(navWrapNode);
          var offset = this.offset;
          this.setOffset(offset - navWrapNodeWH);
        },
        getScrollBarNode: function getScrollBarNode(content) {
          var _classnames, _classnames2, _classnames3, _classnames4;

          var _state2 = this.state,
              next = _state2.next,
              prev = _state2.prev;
          var _props = this.props,
              prefixCls = _props.prefixCls,
              scrollAnimated = _props.scrollAnimated,
              navWrapper = _props.navWrapper;
          var showNextPrev = prev || next;
          var prevButton = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            onClick: prev ? this.prev : null,
            unselectable: 'unselectable',
            className: classnames_default()((_classnames = {}, defineProperty_default()(_classnames, prefixCls + '-tab-prev', 1), defineProperty_default()(_classnames, prefixCls + '-tab-btn-disabled', !prev), defineProperty_default()(_classnames, prefixCls + '-tab-arrow-show', showNextPrev), _classnames)),
            onTransitionEnd: this.prevTransitionEnd
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: prefixCls + '-tab-prev-icon'
          }));
          var nextButton = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            onClick: next ? this.next : null,
            unselectable: 'unselectable',
            className: classnames_default()((_classnames2 = {}, defineProperty_default()(_classnames2, prefixCls + '-tab-next', 1), defineProperty_default()(_classnames2, prefixCls + '-tab-btn-disabled', !next), defineProperty_default()(_classnames2, prefixCls + '-tab-arrow-show', showNextPrev), _classnames2))
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: prefixCls + '-tab-next-icon'
          }));
          var navClassName = prefixCls + '-nav';
          var navClasses = classnames_default()((_classnames3 = {}, defineProperty_default()(_classnames3, navClassName, true), defineProperty_default()(_classnames3, scrollAnimated ? navClassName + '-animated' : navClassName + '-no-animated', true), _classnames3));
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: classnames_default()((_classnames4 = {}, defineProperty_default()(_classnames4, prefixCls + '-nav-container', 1), defineProperty_default()(_classnames4, prefixCls + '-nav-container-scrolling', showNextPrev), _classnames4)),
            key: 'container',
            ref: this.saveRef('container')
          }, prevButton, nextButton, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-nav-wrap',
            ref: this.saveRef('navWrap')
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-nav-scroll'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: navClasses,
            ref: this.saveRef('nav')
          }, navWrapper(content)))));
        }
      }; // CONCATENATED MODULE: ./node_modules/rc-tabs/es/TabBarMixin.js

      /* harmony default export */

      var TabBarMixin = {
        getDefaultProps: function getDefaultProps() {
          return {
            styles: {}
          };
        },
        onTabClick: function onTabClick(key, e) {
          this.props.onTabClick(key, e);
        },
        getTabs: function getTabs() {
          var _this = this;

          var _props = this.props,
              children = _props.panels,
              activeKey = _props.activeKey,
              prefixCls = _props.prefixCls,
              tabBarGutter = _props.tabBarGutter;
          var rst = [];
          external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(children, function (child, index) {
            if (!child) {
              return;
            }

            var key = child.key;
            var cls = activeKey === key ? prefixCls + '-tab-active' : '';
            cls += ' ' + prefixCls + '-tab';
            var events = {};

            if (child.props.disabled) {
              cls += ' ' + prefixCls + '-tab-disabled';
            } else {
              events = {
                onClick: function onClick(e) {
                  return _this.onTabClick.call(_this, key, e);
                }
              };
            }

            var ref = {};

            if (activeKey === key) {
              ref.ref = _this.saveRef('activeTab');
            }

            browser_default()('tab' in child.props, 'There must be `tab` property on children of Tabs.');
            rst.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', extends_default()({
              role: 'tab',
              'aria-disabled': child.props.disabled ? 'true' : 'false',
              'aria-selected': activeKey === key ? 'true' : 'false'
            }, events, {
              className: cls,
              key: key,
              style: {
                marginRight: tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter
              }
            }, ref), child.props.tab));
          });
          return rst;
        },
        getRootNode: function getRootNode(contents) {
          var _props2 = this.props,
              prefixCls = _props2.prefixCls,
              onKeyDown = _props2.onKeyDown,
              className = _props2.className,
              extraContent = _props2.extraContent,
              style = _props2.style,
              tabBarPosition = _props2.tabBarPosition,
              restProps = objectWithoutProperties_default()(_props2, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition']);
          var cls = classnames_default()(prefixCls + '-bar', defineProperty_default()({}, className, !!className));
          var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
          var tabBarExtraContentStyle = topOrBottom ? {
            float: 'right'
          } : {};
          var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
          var children = contents;

          if (extraContent) {
            children = [Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"])(extraContent, {
              key: 'extra',
              style: extends_default()({}, tabBarExtraContentStyle, extraContentStyle)
            }), Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"])(contents, {
              key: 'content'
            })];
            children = topOrBottom ? children : children.reverse();
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', extends_default()({
            role: 'tablist',
            className: cls,
            tabIndex: '0',
            ref: this.saveRef('root'),
            onKeyDown: onKeyDown,
            style: style
          }, utils_getDataAttr(restProps)), children);
        }
      }; // CONCATENATED MODULE: ./node_modules/rc-tabs/es/RefMixin.js

      /* harmony default export */

      var RefMixin = {
        saveRef: function saveRef(name) {
          var _this = this;

          return function (node) {
            _this[name] = node;
          };
        }
      }; // CONCATENATED MODULE: ./node_modules/rc-tabs/es/ScrollableInkTabBar.js

      var ScrollableInkTabBar_ScrollableInkTabBar = create_react_class_default()({
        displayName: 'ScrollableInkTabBar',
        mixins: [RefMixin, TabBarMixin, InkTabBarMixin, ScrollableTabBarMixin],
        render: function render() {
          var inkBarNode = this.getInkBarNode();
          var tabs = this.getTabs();
          var scrollbarNode = this.getScrollBarNode([inkBarNode, tabs]);
          return this.getRootNode(scrollbarNode);
        }
      });
      /* harmony default export */

      var es_ScrollableInkTabBar = ScrollableInkTabBar_ScrollableInkTabBar; // CONCATENATED MODULE: ./node_modules/antd/es/_util/isFlexSupported.js

      function isFlexSupported() {
        if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
          var documentElement = window.document.documentElement;
          return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
        }

        return false;
      } // CONCATENATED MODULE: ./node_modules/antd/es/tabs/index.js


      var tabs_Tabs = function (_React$Component) {
        inherits_default()(Tabs, _React$Component);

        function Tabs() {
          classCallCheck_default()(this, Tabs);

          var _this = possibleConstructorReturn_default()(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));

          _this.createNewTab = function (targetKey) {
            var onEdit = _this.props.onEdit;

            if (onEdit) {
              onEdit(targetKey, 'add');
            }
          };

          _this.removeTab = function (targetKey, e) {
            e.stopPropagation();

            if (!targetKey) {
              return;
            }

            var onEdit = _this.props.onEdit;

            if (onEdit) {
              onEdit(targetKey, 'remove');
            }
          };

          _this.handleChange = function (activeKey) {
            var onChange = _this.props.onChange;

            if (onChange) {
              onChange(activeKey);
            }
          };

          return _this;
        }

        createClass_default()(Tabs, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var NO_FLEX = ' no-flex';
            var tabNode = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](this);

            if (tabNode && !isFlexSupported() && tabNode.className.indexOf(NO_FLEX) === -1) {
              tabNode.className += NO_FLEX;
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames,
                _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                size = _props.size,
                _props$type = _props.type,
                type = _props$type === undefined ? 'line' : _props$type,
                tabPosition = _props.tabPosition,
                children = _props.children,
                tabBarExtraContent = _props.tabBarExtraContent,
                tabBarStyle = _props.tabBarStyle,
                hideAdd = _props.hideAdd,
                onTabClick = _props.onTabClick,
                onPrevClick = _props.onPrevClick,
                onNextClick = _props.onNextClick,
                _props$animated = _props.animated,
                animated = _props$animated === undefined ? true : _props$animated,
                tabBarGutter = _props.tabBarGutter;

            var _ref = (typeof animated === 'undefined' ? 'undefined' : typeof_default()(animated)) === 'object' ? {
              inkBarAnimated: animated.inkBar,
              tabPaneAnimated: animated.tabPane
            } : {
              inkBarAnimated: animated,
              tabPaneAnimated: animated
            },
                inkBarAnimated = _ref.inkBarAnimated,
                tabPaneAnimated = _ref.tabPaneAnimated; // card tabs should not have animation


            if (type !== 'line') {
              tabPaneAnimated = 'animated' in this.props ? tabPaneAnimated : false;
            }

            _util_warning(!(type.indexOf('card') >= 0 && (size === 'small' || size === 'large')), 'Tabs[type=card|editable-card] doesn\'t have small or large size, it\'s by designed.');

            var cls = classnames_default()(className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-vertical', tabPosition === 'left' || tabPosition === 'right'), defineProperty_default()(_classNames, prefixCls + '-' + size, !!size), defineProperty_default()(_classNames, prefixCls + '-card', type.indexOf('card') >= 0), defineProperty_default()(_classNames, prefixCls + '-' + type, true), defineProperty_default()(_classNames, prefixCls + '-no-animation', !tabPaneAnimated), _classNames)); // only card type tabs can be added and closed

            var childrenWithClose = [];

            if (type === 'editable-card') {
              childrenWithClose = [];
              external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(children, function (child, index) {
                var closable = child.props.closable;
                closable = typeof closable === 'undefined' ? true : closable;
                var closeIcon = closable ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                  type: 'close',
                  onClick: function onClick(e) {
                    return _this2.removeTab(child.key, e);
                  }
                }) : null;
                childrenWithClose.push(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](child, {
                  tab: external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                    className: closable ? undefined : prefixCls + '-tab-unclosable'
                  }, child.props.tab, closeIcon),
                  key: child.key || index
                }));
              }); // Add new tab handler

              if (!hideAdd) {
                tabBarExtraContent = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                  type: 'plus',
                  className: prefixCls + '-new-tab',
                  onClick: this.createNewTab
                }), tabBarExtraContent);
              }
            }

            tabBarExtraContent = tabBarExtraContent ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-extra-content'
            }, tabBarExtraContent) : null;

            var renderTabBar = function renderTabBar() {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_ScrollableInkTabBar, {
                inkBarAnimated: inkBarAnimated,
                extraContent: tabBarExtraContent,
                onTabClick: onTabClick,
                onPrevClick: onPrevClick,
                onNextClick: onNextClick,
                style: tabBarStyle,
                tabBarGutter: tabBarGutter
              });
            };

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_tabs_es, extends_default()({}, this.props, {
              className: cls,
              tabBarPosition: tabPosition,
              renderTabBar: renderTabBar,
              renderTabContent: function renderTabContent() {
                return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_TabContent, {
                  animated: tabPaneAnimated,
                  animatedWithMargin: true
                });
              },
              onChange: this.handleChange
            }), childrenWithClose.length > 0 ? childrenWithClose : children);
          }
        }]);
        return Tabs;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_tabs = tabs_Tabs;
      tabs_Tabs.TabPane = es_TabPane;
      tabs_Tabs.defaultProps = {
        prefixCls: 'ant-tabs',
        hideAdd: false
      }; // CONCATENATED MODULE: ./node_modules/antd/es/card/index.js

      var card_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if ((typeof Reflect === "undefined" ? "undefined" : typeof_default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
          if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        }
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };

      var card_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var card_Card = function (_React$Component) {
        inherits_default()(Card, _React$Component);

        function Card() {
          classCallCheck_default()(this, Card);

          var _this = possibleConstructorReturn_default()(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));

          _this.state = {
            widerPadding: false
          };

          _this.onTabChange = function (key) {
            if (_this.props.onTabChange) {
              _this.props.onTabChange(key);
            }
          };

          _this.saveRef = function (node) {
            _this.container = node;
          };

          return _this;
        }

        createClass_default()(Card, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.updateWiderPadding();
            this.resizeEvent = Object(addEventListener["a"
            /* default */
            ])(window, 'resize', this.updateWiderPadding);

            if ('noHovering' in this.props) {
              _util_warning(!this.props.noHovering, '`noHovering` of Card is deperated, you can remove it safely or use `hoverable` instead.');

              _util_warning(!!this.props.noHovering, '`noHovering={false}` of Card is deperated, use `hoverable` instead.');
            }
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            if (this.resizeEvent) {
              this.resizeEvent.remove();
            }

            this.updateWiderPadding.cancel();
          }
        }, {
          key: "updateWiderPadding",
          value: function updateWiderPadding() {
            var _this2 = this;

            if (!this.container) {
              return;
            } // 936 is a magic card width pixer number indicated by designer


            var WIDTH_BOUDARY_PX = 936;

            if (this.container.offsetWidth >= WIDTH_BOUDARY_PX && !this.state.widerPadding) {
              this.setState({
                widerPadding: true
              }, function () {
                _this2.updateWiderPaddingCalled = true; // first render without css transition
              });
            }

            if (this.container.offsetWidth < WIDTH_BOUDARY_PX && this.state.widerPadding) {
              this.setState({
                widerPadding: false
              }, function () {
                _this2.updateWiderPaddingCalled = true; // first render without css transition
              });
            }
          }
        }, {
          key: "isContainGrid",
          value: function isContainGrid() {
            var containGrid = void 0;
            external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(this.props.children, function (element) {
              if (element && element.type && element.type === Grid) {
                containGrid = true;
              }
            });
            return containGrid;
          }
        }, {
          key: "getAction",
          value: function getAction(actions) {
            if (!actions || !actions.length) {
              return null;
            }

            var actionList = actions.map(function (action, index) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("li", {
                style: {
                  width: 100 / actions.length + "%"
                },
                key: "action-" + index
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", null, action));
            });
            return actionList;
          } // For 2.x compatible

        }, {
          key: "getCompatibleHoverable",
          value: function getCompatibleHoverable() {
            var _props = this.props,
                noHovering = _props.noHovering,
                hoverable = _props.hoverable;

            if ('noHovering' in this.props) {
              return !noHovering || hoverable;
            }

            return !!hoverable;
          }
        }, {
          key: "render",
          value: function render() {
            var _classNames;

            var _a = this.props,
                _a$prefixCls = _a.prefixCls,
                prefixCls = _a$prefixCls === undefined ? 'ant-card' : _a$prefixCls,
                className = _a.className,
                extra = _a.extra,
                bodyStyle = _a.bodyStyle,
                noHovering = _a.noHovering,
                hoverable = _a.hoverable,
                title = _a.title,
                loading = _a.loading,
                _a$bordered = _a.bordered,
                bordered = _a$bordered === undefined ? true : _a$bordered,
                type = _a.type,
                cover = _a.cover,
                actions = _a.actions,
                tabList = _a.tabList,
                children = _a.children,
                activeTabKey = _a.activeTabKey,
                defaultActiveTabKey = _a.defaultActiveTabKey,
                others = card_rest(_a, ["prefixCls", "className", "extra", "bodyStyle", "noHovering", "hoverable", "title", "loading", "bordered", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey"]);
            var classString = classnames_default()(prefixCls, className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + "-loading", loading), defineProperty_default()(_classNames, prefixCls + "-bordered", bordered), defineProperty_default()(_classNames, prefixCls + "-hoverable", this.getCompatibleHoverable()), defineProperty_default()(_classNames, prefixCls + "-wider-padding", this.state.widerPadding), defineProperty_default()(_classNames, prefixCls + "-padding-transition", this.updateWiderPaddingCalled), defineProperty_default()(_classNames, prefixCls + "-contain-grid", this.isContainGrid()), defineProperty_default()(_classNames, prefixCls + "-contain-tabs", tabList && tabList.length), defineProperty_default()(_classNames, prefixCls + "-type-" + type, !!type), _classNames));
            var loadingBlock = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
              className: prefixCls + "-loading-content"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("p", {
              className: prefixCls + "-loading-block",
              style: {
                width: '94%'
              }
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("p", null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", {
              className: prefixCls + "-loading-block",
              style: {
                width: '28%'
              }
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", {
              className: prefixCls + "-loading-block",
              style: {
                width: '62%'
              }
            })), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("p", null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", {
              className: prefixCls + "-loading-block",
              style: {
                width: '22%'
              }
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", {
              className: prefixCls + "-loading-block",
              style: {
                width: '66%'
              }
            })), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("p", null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", {
              className: prefixCls + "-loading-block",
              style: {
                width: '56%'
              }
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", {
              className: prefixCls + "-loading-block",
              style: {
                width: '39%'
              }
            })), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("p", null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", {
              className: prefixCls + "-loading-block",
              style: {
                width: '21%'
              }
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", {
              className: prefixCls + "-loading-block",
              style: {
                width: '15%'
              }
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", {
              className: prefixCls + "-loading-block",
              style: {
                width: '40%'
              }
            })));
            var hasActiveTabKey = activeTabKey !== undefined;
            var extraProps = defineProperty_default()({}, hasActiveTabKey ? 'activeKey' : 'defaultActiveKey', hasActiveTabKey ? activeTabKey : defaultActiveTabKey);
            var head = void 0;
            var tabs = tabList && tabList.length ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_tabs, extends_default()({}, extraProps, {
              className: prefixCls + "-head-tabs",
              size: "large",
              onChange: this.onTabChange
            }), tabList.map(function (item) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_tabs.TabPane, {
                tab: item.tab,
                key: item.key
              });
            })) : null;

            if (title || extra || tabs) {
              head = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
                className: prefixCls + "-head"
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
                className: prefixCls + "-head-wrapper"
              }, title && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
                className: prefixCls + "-head-title"
              }, title), extra && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
                className: prefixCls + "-extra"
              }, extra)), tabs);
            }

            var coverDom = cover ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
              className: prefixCls + "-cover"
            }, cover) : null;
            var body = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
              className: prefixCls + "-body",
              style: bodyStyle
            }, loading ? loadingBlock : children);
            var actionDom = actions && actions.length ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("ul", {
              className: prefixCls + "-actions"
            }, this.getAction(actions)) : null;
            var divProps = Object(es["default"])(others, ['onTabChange']);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", extends_default()({}, divProps, {
              className: classString,
              ref: this.saveRef
            }), head, coverDom, body, actionDom);
          }
        }]);
        return Card;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var card = card_Card;
      card_Card.Grid = Grid;
      card_Card.Meta = card_Meta;
      card_decorate([throttleByAnimationFrame_throttleByAnimationFrameDecorator()], card_Card.prototype, "updateWiderPadding", null); // CONCATENATED MODULE: ./node_modules/rc-collapse/es/PanelContent.js

      var PanelContent_createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function PanelContent_defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function PanelContent_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function PanelContent_possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function PanelContent_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var PanelContent_PanelContent = function (_Component) {
        PanelContent_inherits(PanelContent, _Component);

        function PanelContent() {
          PanelContent_classCallCheck(this, PanelContent);
          return PanelContent_possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
        }

        PanelContent_createClass(PanelContent, [{
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            return this.props.isActive || nextProps.isActive;
          }
        }, {
          key: 'render',
          value: function render() {
            var _classnames;

            this._isActived = this.props.forceRender || this._isActived || this.props.isActive;

            if (!this._isActived) {
              return null;
            }

            var _props = this.props,
                prefixCls = _props.prefixCls,
                isActive = _props.isActive,
                children = _props.children,
                destroyInactivePanel = _props.destroyInactivePanel,
                forceRender = _props.forceRender;
            var contentCls = classnames_default()((_classnames = {}, PanelContent_defineProperty(_classnames, prefixCls + '-content', true), PanelContent_defineProperty(_classnames, prefixCls + '-content-active', isActive), PanelContent_defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
            var child = !forceRender && !isActive && destroyInactivePanel ? null : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-content-box'
            }, children);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: contentCls,
              role: 'tabpanel'
            }, child);
          }
        }]);
        return PanelContent;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      PanelContent_PanelContent.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        isActive: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        destroyInactivePanel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        forceRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var es_PanelContent = PanelContent_PanelContent; // CONCATENATED MODULE: ./node_modules/rc-collapse/es/Panel.js

      var Panel_createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function Panel_defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function Panel_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Panel_possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function Panel_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Panel_CollapsePanel = function (_Component) {
        Panel_inherits(CollapsePanel, _Component);

        function CollapsePanel() {
          Panel_classCallCheck(this, CollapsePanel);
          return Panel_possibleConstructorReturn(this, (CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).apply(this, arguments));
        }

        Panel_createClass(CollapsePanel, [{
          key: 'handleItemClick',
          value: function handleItemClick() {
            if (this.props.onItemClick) {
              this.props.onItemClick();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames2;

            var _props = this.props,
                className = _props.className,
                id = _props.id,
                style = _props.style,
                prefixCls = _props.prefixCls,
                header = _props.header,
                headerClass = _props.headerClass,
                children = _props.children,
                isActive = _props.isActive,
                showArrow = _props.showArrow,
                destroyInactivePanel = _props.destroyInactivePanel,
                disabled = _props.disabled,
                forceRender = _props.forceRender;
            var headerCls = classnames_default()(prefixCls + '-header', Panel_defineProperty({}, headerClass, headerClass));
            var itemCls = classnames_default()((_classNames2 = {}, Panel_defineProperty(_classNames2, prefixCls + '-item', true), Panel_defineProperty(_classNames2, prefixCls + '-item-active', isActive), Panel_defineProperty(_classNames2, prefixCls + '-item-disabled', disabled), _classNames2), className);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: itemCls,
              style: style,
              id: id,
              role: 'tablist'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: headerCls,
              onClick: this.handleItemClick.bind(this),
              role: 'tab',
              'aria-expanded': isActive
            }, showArrow && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('i', {
              className: 'arrow'
            }), header), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], {
              showProp: 'isActive',
              exclusive: true,
              component: '',
              animation: this.props.openAnimation
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_PanelContent, {
              prefixCls: prefixCls,
              isActive: isActive,
              destroyInactivePanel: destroyInactivePanel,
              forceRender: forceRender
            }, children)));
          }
        }]);
        return CollapsePanel;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Panel_CollapsePanel.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        openAnimation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        header: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node]),
        headerClass: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showArrow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        isActive: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onItemClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        destroyInactivePanel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        forceRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      Panel_CollapsePanel.defaultProps = {
        showArrow: true,
        isActive: false,
        destroyInactivePanel: false,
        onItemClick: function onItemClick() {},
        headerClass: '',
        forceRender: false
      };
      /* harmony default export */

      var es_Panel = Panel_CollapsePanel; // EXTERNAL MODULE: ./node_modules/css-animation/es/index.js + 1 modules

      var css_animation_es = __webpack_require__(164); // CONCATENATED MODULE: ./node_modules/rc-collapse/es/openAnimationFactory.js


      function openAnimationFactory_animate(node, show, transitionName, done) {
        var height = void 0;
        return Object(css_animation_es["a"
        /* default */
        ])(node, transitionName, {
          start: function start() {
            if (!show) {
              node.style.height = node.offsetHeight + 'px';
            } else {
              height = node.offsetHeight;
              node.style.height = 0;
            }
          },
          active: function active() {
            node.style.height = (show ? height : 0) + 'px';
          },
          end: function end() {
            node.style.height = '';
            done();
          }
        });
      }

      function openAnimationFactory_animation(prefixCls) {
        return {
          enter: function enter(node, done) {
            return openAnimationFactory_animate(node, true, prefixCls + '-anim', done);
          },
          leave: function leave(node, done) {
            return openAnimationFactory_animate(node, false, prefixCls + '-anim', done);
          }
        };
      }
      /* harmony default export */


      var openAnimationFactory = openAnimationFactory_animation; // CONCATENATED MODULE: ./node_modules/rc-collapse/es/Collapse.js

      var Collapse_createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function Collapse_defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function Collapse_toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        } else {
          return Array.from(arr);
        }
      }

      function Collapse_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Collapse_possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function Collapse_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      function Collapse_toArray(activeKey) {
        var currentActiveKey = activeKey;

        if (!Array.isArray(currentActiveKey)) {
          currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
        }

        return currentActiveKey;
      }

      var Collapse_Collapse = function (_Component) {
        Collapse_inherits(Collapse, _Component);

        function Collapse(props) {
          Collapse_classCallCheck(this, Collapse);

          var _this = Collapse_possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

          var _this$props = _this.props,
              activeKey = _this$props.activeKey,
              defaultActiveKey = _this$props.defaultActiveKey;
          var currentActiveKey = defaultActiveKey;

          if ('activeKey' in _this.props) {
            currentActiveKey = activeKey;
          }

          _this.state = {
            openAnimation: _this.props.openAnimation || openAnimationFactory(_this.props.prefixCls),
            activeKey: Collapse_toArray(currentActiveKey)
          };
          return _this;
        }

        Collapse_createClass(Collapse, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('activeKey' in nextProps) {
              this.setState({
                activeKey: Collapse_toArray(nextProps.activeKey)
              });
            }

            if ('openAnimation' in nextProps) {
              this.setState({
                openAnimation: nextProps.openAnimation
              });
            }
          }
        }, {
          key: 'onClickItem',
          value: function onClickItem(key) {
            var activeKey = this.state.activeKey;

            if (this.props.accordion) {
              activeKey = activeKey[0] === key ? [] : [key];
            } else {
              activeKey = [].concat(Collapse_toConsumableArray(activeKey));
              var index = activeKey.indexOf(key);
              var isActive = index > -1;

              if (isActive) {
                // remove active state
                activeKey.splice(index, 1);
              } else {
                activeKey.push(key);
              }
            }

            this.setActiveKey(activeKey);
          }
        }, {
          key: 'getItems',
          value: function getItems() {
            var _this2 = this;

            var activeKey = this.state.activeKey;
            var _props = this.props,
                prefixCls = _props.prefixCls,
                accordion = _props.accordion,
                destroyInactivePanel = _props.destroyInactivePanel;
            var newChildren = [];
            external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(this.props.children, function (child, index) {
              if (!child) return; // If there is no key provide, use the panel order as default key

              var key = child.key || String(index);
              var _child$props = child.props,
                  header = _child$props.header,
                  headerClass = _child$props.headerClass,
                  disabled = _child$props.disabled;
              var isActive = false;

              if (accordion) {
                isActive = activeKey[0] === key;
              } else {
                isActive = activeKey.indexOf(key) > -1;
              }

              var props = {
                key: key,
                header: header,
                headerClass: headerClass,
                isActive: isActive,
                prefixCls: prefixCls,
                destroyInactivePanel: destroyInactivePanel,
                openAnimation: _this2.state.openAnimation,
                children: child.props.children,
                onItemClick: disabled ? null : function () {
                  return _this2.onClickItem(key);
                }
              };
              newChildren.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(child, props));
            });
            return newChildren;
          }
        }, {
          key: 'setActiveKey',
          value: function setActiveKey(activeKey) {
            if (!('activeKey' in this.props)) {
              this.setState({
                activeKey: activeKey
              });
            }

            this.props.onChange(this.props.accordion ? activeKey[0] : activeKey);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                className = _props2.className,
                style = _props2.style;
            var collapseClassName = classnames_default()((_classNames = {}, Collapse_defineProperty(_classNames, prefixCls, true), Collapse_defineProperty(_classNames, className, !!className), _classNames));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: collapseClassName,
              style: style
            }, this.getItems());
          }
        }]);
        return Collapse;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Collapse_Collapse.propTypes = {
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        activeKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string)]),
        defaultActiveKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string)]),
        openAnimation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        accordion: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        destroyInactivePanel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      Collapse_Collapse.defaultProps = {
        prefixCls: 'rc-collapse',
        onChange: function onChange() {},
        accordion: false,
        destroyInactivePanel: false
      };
      Collapse_Collapse.Panel = es_Panel;
      /* harmony default export */

      var es_Collapse = Collapse_Collapse; // CONCATENATED MODULE: ./node_modules/rc-collapse/es/index.js

      /* harmony default export */

      var rc_collapse_es = es_Collapse;
      var rc_collapse_es_Panel = es_Collapse.Panel; // CONCATENATED MODULE: ./node_modules/antd/es/_util/openAnimation.js

      var openAnimation_reqAnimFrame = getRequestAnimationFrame();

      function openAnimation_animate(node, show, done) {
        var height = void 0;
        var requestAnimationFrameId = void 0;
        return Object(css_animation_es["a"
        /* default */
        ])(node, 'ant-motion-collapse', {
          start: function start() {
            if (!show) {
              node.style.height = node.offsetHeight + 'px';
              node.style.opacity = '1';
            } else {
              height = node.offsetHeight;
              node.style.height = '0px';
              node.style.opacity = '0';
            }
          },
          active: function active() {
            if (requestAnimationFrameId) {
              cancelRequestAnimationFrame(requestAnimationFrameId);
            }

            requestAnimationFrameId = openAnimation_reqAnimFrame(function () {
              node.style.height = (show ? height : 0) + 'px';
              node.style.opacity = show ? '1' : '0';
            });
          },
          end: function end() {
            if (requestAnimationFrameId) {
              cancelRequestAnimationFrame(requestAnimationFrameId);
            }

            node.style.height = '';
            node.style.opacity = '';
            done();
          }
        });
      }

      var openAnimation_animation = {
        enter: function enter(node, done) {
          return openAnimation_animate(node, true, done);
        },
        leave: function leave(node, done) {
          return openAnimation_animate(node, false, done);
        },
        appear: function appear(node, done) {
          return openAnimation_animate(node, true, done);
        }
      };
      /* harmony default export */

      var _util_openAnimation = openAnimation_animation; // CONCATENATED MODULE: ./node_modules/antd/es/collapse/CollapsePanel.js

      var CollapsePanel_CollapsePanel = function (_React$Component) {
        inherits_default()(CollapsePanel, _React$Component);

        function CollapsePanel() {
          classCallCheck_default()(this, CollapsePanel);
          return possibleConstructorReturn_default()(this, (CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).apply(this, arguments));
        }

        createClass_default()(CollapsePanel, [{
          key: 'render',
          value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                _props$showArrow = _props.showArrow,
                showArrow = _props$showArrow === undefined ? true : _props$showArrow;
            var collapsePanelClassName = classnames_default()(defineProperty_default()({}, prefixCls + '-no-arrow', !showArrow), className);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_collapse_es.Panel, extends_default()({}, this.props, {
              className: collapsePanelClassName
            }));
          }
        }]);
        return CollapsePanel;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var collapse_CollapsePanel = CollapsePanel_CollapsePanel; // CONCATENATED MODULE: ./node_modules/antd/es/collapse/Collapse.js

      var collapse_Collapse_Collapse = function (_React$Component) {
        inherits_default()(Collapse, _React$Component);

        function Collapse() {
          classCallCheck_default()(this, Collapse);
          return possibleConstructorReturn_default()(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).apply(this, arguments));
        }

        createClass_default()(Collapse, [{
          key: 'render',
          value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                bordered = _props.bordered;
            var collapseClassName = classnames_default()(defineProperty_default()({}, prefixCls + '-borderless', !bordered), className);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_collapse_es, extends_default()({}, this.props, {
              className: collapseClassName
            }));
          }
        }]);
        return Collapse;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var collapse_Collapse = collapse_Collapse_Collapse;
      collapse_Collapse_Collapse.Panel = collapse_CollapsePanel;
      collapse_Collapse_Collapse.defaultProps = {
        prefixCls: 'ant-collapse',
        bordered: true,
        openAnimation: extends_default()({}, _util_openAnimation, {
          appear: function appear() {}
        })
      }; // CONCATENATED MODULE: ./node_modules/antd/es/collapse/index.js

      /* harmony default export */

      var collapse = collapse_Collapse; // CONCATENATED MODULE: ./node_modules/antd/es/carousel/index.js
      // matchMedia polyfill for
      // https://github.com/WickyNilliams/enquire.js/issues/82

      if (typeof window !== 'undefined') {
        var carousel_matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
          return {
            media: mediaQuery,
            matches: false,
            addListener: function addListener() {},
            removeListener: function removeListener() {}
          };
        };

        window.matchMedia = window.matchMedia || carousel_matchMediaPolyfill;
      } // Use require over import (will be lifted up)
      // make sure matchMedia polyfill run before require('react-slick')
      // Fix https://github.com/ant-design/ant-design/issues/6560
      // Fix https://github.com/ant-design/ant-design/issues/3308


      var carousel_SlickCarousel = __webpack_require__(1106)['default'];

      var carousel_Carousel = function (_React$Component) {
        inherits_default()(Carousel, _React$Component);

        function Carousel(props) {
          classCallCheck_default()(this, Carousel);

          var _this = possibleConstructorReturn_default()(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

          _this.onWindowResized = function () {
            // Fix https://github.com/ant-design/ant-design/issues/2550
            var autoplay = _this.props.autoplay;

            if (autoplay && _this.slick && _this.slick.innerSlider && _this.slick.innerSlider.autoPlay) {
              _this.slick.innerSlider.autoPlay();
            }
          };

          _this.saveSlick = function (node) {
            _this.slick = node;
          };

          _this.onWindowResized = debounce_default()(_this.onWindowResized, 500, {
            leading: false
          });
          return _this;
        }

        createClass_default()(Carousel, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var autoplay = this.props.autoplay;

            if (autoplay) {
              window.addEventListener('resize', this.onWindowResized);
            } // https://github.com/ant-design/ant-design/issues/7191


            this.innerSlider = this.slick && this.slick.innerSlider;
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var autoplay = this.props.autoplay;

            if (autoplay) {
              window.removeEventListener('resize', this.onWindowResized);
              this.onWindowResized.cancel();
            }
          }
        }, {
          key: 'next',
          value: function next() {
            this.slick.slickNext();
          }
        }, {
          key: 'prev',
          value: function prev() {
            this.slick.slickPrev();
          }
        }, {
          key: 'goTo',
          value: function goTo(slide) {
            this.slick.slickGoTo(slide);
          }
        }, {
          key: 'render',
          value: function render() {
            var props = extends_default()({}, this.props);

            if (props.effect === 'fade') {
              props.fade = true;
            }

            var className = props.prefixCls;

            if (props.vertical) {
              className = className + ' ' + className + '-vertical';
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: className
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](carousel_SlickCarousel, extends_default()({
              ref: this.saveSlick
            }, props)));
          }
        }]);
        return Carousel;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var carousel = carousel_Carousel;
      carousel_Carousel.defaultProps = {
        dots: true,
        arrows: false,
        prefixCls: 'ant-carousel',
        draggable: false
      }; // EXTERNAL MODULE: ./node_modules/rc-trigger/es/index.js + 20 modules

      var rc_trigger_es = __webpack_require__(75); // EXTERNAL MODULE: ./node_modules/rc-cascader/node_modules/array-tree-filter/index.js


      var array_tree_filter = __webpack_require__(226);

      var array_tree_filter_default =
      /*#__PURE__*/
      __webpack_require__.n(array_tree_filter); // CONCATENATED MODULE: ./node_modules/rc-cascader/es/Menus.js


      var Menus_extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      function Menus_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Menus_possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function Menus_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Menus_Menus = function (_React$Component) {
        Menus_inherits(Menus, _React$Component);

        function Menus(props) {
          Menus_classCallCheck(this, Menus);

          var _this = Menus_possibleConstructorReturn(this, _React$Component.call(this, props));

          _this.saveMenuItem = function (index) {
            return function (node) {
              _this.menuItems[index] = node;
            };
          };

          _this.menuItems = {};
          return _this;
        }

        Menus.prototype.componentDidMount = function componentDidMount() {
          this.scrollActiveItemToView();
        };

        Menus.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
          if (!prevProps.visible && this.props.visible) {
            this.scrollActiveItemToView();
          }
        };

        Menus.prototype.getOption = function getOption(option, menuIndex) {
          var _props = this.props,
              prefixCls = _props.prefixCls,
              expandTrigger = _props.expandTrigger;
          var onSelect = this.props.onSelect.bind(this, option, menuIndex);
          var expandProps = {
            onClick: onSelect
          };
          var menuItemCls = prefixCls + '-menu-item';
          var hasChildren = option.children && option.children.length > 0;

          if (hasChildren || option.isLeaf === false) {
            menuItemCls += ' ' + prefixCls + '-menu-item-expand';
          }

          if (expandTrigger === 'hover' && hasChildren) {
            expandProps = {
              onMouseEnter: this.delayOnSelect.bind(this, onSelect),
              onMouseLeave: this.delayOnSelect.bind(this),
              onClick: onSelect
            };
          }

          if (this.isActiveOption(option, menuIndex)) {
            menuItemCls += ' ' + prefixCls + '-menu-item-active';
            expandProps.ref = this.saveMenuItem(menuIndex);
          }

          if (option.disabled) {
            menuItemCls += ' ' + prefixCls + '-menu-item-disabled';
          }

          if (option.loading) {
            menuItemCls += ' ' + prefixCls + '-menu-item-loading';
          }

          var title = '';

          if (option.title) {
            title = option.title;
          } else if (typeof option.label === 'string') {
            title = option.label;
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', Menus_extends({
            key: option.value,
            className: menuItemCls,
            title: title
          }, expandProps), option.label);
        };

        Menus.prototype.getActiveOptions = function getActiveOptions(values) {
          var activeValue = values || this.props.activeValue;
          var options = this.props.options;
          return array_tree_filter_default()(options, function (o, level) {
            return o.value === activeValue[level];
          });
        };

        Menus.prototype.getShowOptions = function getShowOptions() {
          var options = this.props.options;
          var result = this.getActiveOptions().map(function (activeOption) {
            return activeOption.children;
          }).filter(function (activeOption) {
            return !!activeOption;
          });
          result.unshift(options);
          return result;
        };

        Menus.prototype.delayOnSelect = function delayOnSelect(onSelect) {
          var _this2 = this;

          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          if (this.delayTimer) {
            clearTimeout(this.delayTimer);
            this.delayTimer = null;
          }

          if (typeof onSelect === 'function') {
            this.delayTimer = setTimeout(function () {
              onSelect(args);
              _this2.delayTimer = null;
            }, 150);
          }
        };

        Menus.prototype.scrollActiveItemToView = function scrollActiveItemToView() {
          // scroll into view
          var optionsLength = this.getShowOptions().length;

          for (var i = 0; i < optionsLength; i++) {
            var itemComponent = this.menuItems[i];

            if (itemComponent) {
              var target = Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"])(itemComponent);
              target.parentNode.scrollTop = target.offsetTop;
            }
          }
        };

        Menus.prototype.isActiveOption = function isActiveOption(option, menuIndex) {
          var _props$activeValue = this.props.activeValue,
              activeValue = _props$activeValue === undefined ? [] : _props$activeValue;
          return activeValue[menuIndex] === option.value;
        };

        Menus.prototype.render = function render() {
          var _this3 = this;

          var _props2 = this.props,
              prefixCls = _props2.prefixCls,
              dropdownMenuColumnStyle = _props2.dropdownMenuColumnStyle;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', null, this.getShowOptions().map(function (options, menuIndex) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', {
              className: prefixCls + '-menu',
              key: menuIndex,
              style: dropdownMenuColumnStyle
            }, options.map(function (option) {
              return _this3.getOption(option, menuIndex);
            }));
          }));
        };

        return Menus;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Menus_Menus.defaultProps = {
        options: [],
        value: [],
        activeValue: [],
        onSelect: function onSelect() {},
        prefixCls: 'rc-cascader-menus',
        visible: false,
        expandTrigger: 'click'
      };
      Menus_Menus.propTypes = {
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        activeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        options: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        expandTrigger: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        dropdownMenuColumnStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };
      /* harmony default export */

      var es_Menus = Menus_Menus; // EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js

      var es_KeyCode = __webpack_require__(19); // EXTERNAL MODULE: ./node_modules/shallow-equal/arrays/index.js


      var arrays = __webpack_require__(709);

      var arrays_default =
      /*#__PURE__*/
      __webpack_require__.n(arrays); // CONCATENATED MODULE: ./node_modules/rc-cascader/es/Cascader.js


      var Cascader_extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      function Cascader_objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      }

      function Cascader_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Cascader_possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function Cascader_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Cascader_BUILT_IN_PLACEMENTS = {
        bottomLeft: {
          points: ['tl', 'bl'],
          offset: [0, 4],
          overflow: {
            adjustX: 1,
            adjustY: 1
          }
        },
        topLeft: {
          points: ['bl', 'tl'],
          offset: [0, -4],
          overflow: {
            adjustX: 1,
            adjustY: 1
          }
        },
        bottomRight: {
          points: ['tr', 'br'],
          offset: [0, 4],
          overflow: {
            adjustX: 1,
            adjustY: 1
          }
        },
        topRight: {
          points: ['br', 'tr'],
          offset: [0, -4],
          overflow: {
            adjustX: 1,
            adjustY: 1
          }
        }
      };

      var Cascader_Cascader = function (_Component) {
        Cascader_inherits(Cascader, _Component);

        function Cascader(props) {
          Cascader_classCallCheck(this, Cascader);

          var _this = Cascader_possibleConstructorReturn(this, _Component.call(this, props));

          _this.setPopupVisible = function (popupVisible) {
            if (!('popupVisible' in _this.props)) {
              _this.setState({
                popupVisible: popupVisible
              });
            } // sync activeValue with value when panel open


            if (popupVisible && !_this.state.visible) {
              _this.setState({
                activeValue: _this.state.value
              });
            }

            _this.props.onPopupVisibleChange(popupVisible);
          };

          _this.handleChange = function (options, setProps, e) {
            if (e.type !== 'keydown' || e.keyCode === es_KeyCode["a"
            /* default */
            ].ENTER) {
              _this.props.onChange(options.map(function (o) {
                return o.value;
              }), options);

              _this.setPopupVisible(setProps.visible);
            }
          };

          _this.handlePopupVisibleChange = function (popupVisible) {
            _this.setPopupVisible(popupVisible);
          };

          _this.handleMenuSelect = function (targetOption, menuIndex, e) {
            // Keep focused state for keyboard support
            var triggerNode = _this.trigger.getRootDomNode();

            if (triggerNode && triggerNode.focus) {
              triggerNode.focus();
            }

            var _this$props = _this.props,
                changeOnSelect = _this$props.changeOnSelect,
                loadData = _this$props.loadData,
                expandTrigger = _this$props.expandTrigger;

            if (!targetOption || targetOption.disabled) {
              return;
            }

            var activeValue = _this.state.activeValue;
            activeValue = activeValue.slice(0, menuIndex + 1);
            activeValue[menuIndex] = targetOption.value;

            var activeOptions = _this.getActiveOptions(activeValue);

            if (targetOption.isLeaf === false && !targetOption.children && loadData) {
              if (changeOnSelect) {
                _this.handleChange(activeOptions, {
                  visible: true
                }, e);
              }

              _this.setState({
                activeValue: activeValue
              });

              loadData(activeOptions);
              return;
            }

            var newState = {};

            if (!targetOption.children || !targetOption.children.length) {
              _this.handleChange(activeOptions, {
                visible: false
              }, e); // set value to activeValue when select leaf option


              newState.value = activeValue; // add e.type judgement to prevent `onChange` being triggered by mouseEnter
            } else if (changeOnSelect && (e.type === 'click' || e.type === 'keydown')) {
              if (expandTrigger === 'hover') {
                _this.handleChange(activeOptions, {
                  visible: false
                }, e);
              } else {
                _this.handleChange(activeOptions, {
                  visible: true
                }, e);
              } // set value to activeValue on every select


              newState.value = activeValue;
            }

            newState.activeValue = activeValue; //  not change the value by keyboard

            if ('value' in _this.props || e.type === 'keydown' && e.keyCode !== es_KeyCode["a"
            /* default */
            ].ENTER) {
              delete newState.value;
            }

            _this.setState(newState);
          };

          _this.handleKeyDown = function (e) {
            var children = _this.props.children; // https://github.com/ant-design/ant-design/issues/6717
            // Don't bind keyboard support when children specify the onKeyDown

            if (children && children.props.onKeyDown) {
              children.props.onKeyDown(e);
              return;
            }

            var activeValue = [].concat(_this.state.activeValue);
            var currentLevel = activeValue.length - 1 < 0 ? 0 : activeValue.length - 1;

            var currentOptions = _this.getCurrentLevelOptions();

            var currentIndex = currentOptions.map(function (o) {
              return o.value;
            }).indexOf(activeValue[currentLevel]);

            if (e.keyCode !== es_KeyCode["a"
            /* default */
            ].DOWN && e.keyCode !== es_KeyCode["a"
            /* default */
            ].UP && e.keyCode !== es_KeyCode["a"
            /* default */
            ].LEFT && e.keyCode !== es_KeyCode["a"
            /* default */
            ].RIGHT && e.keyCode !== es_KeyCode["a"
            /* default */
            ].ENTER && e.keyCode !== es_KeyCode["a"
            /* default */
            ].BACKSPACE && e.keyCode !== es_KeyCode["a"
            /* default */
            ].ESC) {
              return;
            } // Press any keys above to reopen menu


            if (!_this.state.popupVisible && e.keyCode !== es_KeyCode["a"
            /* default */
            ].BACKSPACE && e.keyCode !== es_KeyCode["a"
            /* default */
            ].LEFT && e.keyCode !== es_KeyCode["a"
            /* default */
            ].RIGHT && e.keyCode !== es_KeyCode["a"
            /* default */
            ].ESC) {
              _this.setPopupVisible(true);

              return;
            }

            if (e.keyCode === es_KeyCode["a"
            /* default */
            ].DOWN || e.keyCode === es_KeyCode["a"
            /* default */
            ].UP) {
              var nextIndex = currentIndex;

              if (nextIndex !== -1) {
                if (e.keyCode === es_KeyCode["a"
                /* default */
                ].DOWN) {
                  nextIndex += 1;
                  nextIndex = nextIndex >= currentOptions.length ? 0 : nextIndex;
                } else {
                  nextIndex -= 1;
                  nextIndex = nextIndex < 0 ? currentOptions.length - 1 : nextIndex;
                }
              } else {
                nextIndex = 0;
              }

              activeValue[currentLevel] = currentOptions[nextIndex].value;
            } else if (e.keyCode === es_KeyCode["a"
            /* default */
            ].LEFT || e.keyCode === es_KeyCode["a"
            /* default */
            ].BACKSPACE) {
              activeValue.splice(activeValue.length - 1, 1);
            } else if (e.keyCode === es_KeyCode["a"
            /* default */
            ].RIGHT) {
              if (currentOptions[currentIndex] && currentOptions[currentIndex].children) {
                activeValue.push(currentOptions[currentIndex].children[0].value);
              }
            } else if (e.keyCode === es_KeyCode["a"
            /* default */
            ].ESC) {
              _this.setPopupVisible(false);

              return;
            }

            if (!activeValue || activeValue.length === 0) {
              _this.setPopupVisible(false);
            }

            var activeOptions = _this.getActiveOptions(activeValue);

            var targetOption = activeOptions[activeOptions.length - 1];

            _this.handleMenuSelect(targetOption, activeOptions.length - 1, e);

            if (_this.props.onKeyDown) {
              _this.props.onKeyDown(e);
            }
          };

          _this.saveTrigger = function (node) {
            _this.trigger = node;
          };

          var initialValue = [];

          if ('value' in props) {
            initialValue = props.value || [];
          } else if ('defaultValue' in props) {
            initialValue = props.defaultValue || [];
          }

          _this.state = {
            popupVisible: props.popupVisible,
            activeValue: initialValue,
            value: initialValue
          };
          return _this;
        }

        Cascader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          if ('value' in nextProps && !arrays_default()(this.props.value, nextProps.value)) {
            var newValues = {
              value: nextProps.value || [],
              activeValue: nextProps.value || []
            }; // allow activeValue diff from value
            // https://github.com/ant-design/ant-design/issues/2767

            if ('loadData' in nextProps) {
              delete newValues.activeValue;
            }

            this.setState(newValues);
          }

          if ('popupVisible' in nextProps) {
            this.setState({
              popupVisible: nextProps.popupVisible
            });
          }
        };

        Cascader.prototype.getPopupDOMNode = function getPopupDOMNode() {
          return this.trigger.getPopupDomNode();
        };

        Cascader.prototype.getCurrentLevelOptions = function getCurrentLevelOptions() {
          var options = this.props.options;
          var _state$activeValue = this.state.activeValue,
              activeValue = _state$activeValue === undefined ? [] : _state$activeValue;
          var result = array_tree_filter_default()(options, function (o, level) {
            return o.value === activeValue[level];
          });

          if (result[result.length - 2]) {
            return result[result.length - 2].children;
          }

          return [].concat(options).filter(function (o) {
            return !o.disabled;
          });
        };

        Cascader.prototype.getActiveOptions = function getActiveOptions(activeValue) {
          return array_tree_filter_default()(this.props.options, function (o, level) {
            return o.value === activeValue[level];
          });
        };

        Cascader.prototype.render = function render() {
          var _props = this.props,
              prefixCls = _props.prefixCls,
              transitionName = _props.transitionName,
              popupClassName = _props.popupClassName,
              options = _props.options,
              disabled = _props.disabled,
              builtinPlacements = _props.builtinPlacements,
              popupPlacement = _props.popupPlacement,
              children = _props.children,
              restProps = Cascader_objectWithoutProperties(_props, ['prefixCls', 'transitionName', 'popupClassName', 'options', 'disabled', 'builtinPlacements', 'popupPlacement', 'children']); // Did not show popup when there is no options

          var menus = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', null);
          var emptyMenuClassName = '';

          if (options && options.length > 0) {
            menus = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Menus, Cascader_extends({}, this.props, {
              value: this.state.value,
              activeValue: this.state.activeValue,
              onSelect: this.handleMenuSelect,
              visible: this.state.popupVisible
            }));
          } else {
            emptyMenuClassName = ' ' + prefixCls + '-menus-empty';
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_trigger_es["default"], Cascader_extends({
            ref: this.saveTrigger
          }, restProps, {
            options: options,
            disabled: disabled,
            popupPlacement: popupPlacement,
            builtinPlacements: builtinPlacements,
            popupTransitionName: transitionName,
            action: disabled ? [] : ['click'],
            popupVisible: disabled ? false : this.state.popupVisible,
            onPopupVisibleChange: this.handlePopupVisibleChange,
            prefixCls: prefixCls + '-menus',
            popupClassName: popupClassName + emptyMenuClassName,
            popup: menus
          }), Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"])(children, {
            onKeyDown: this.handleKeyDown,
            tabIndex: disabled ? undefined : 0
          }));
        };

        return Cascader;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Cascader_Cascader.defaultProps = {
        options: [],
        onChange: function onChange() {},
        onPopupVisibleChange: function onPopupVisibleChange() {},
        disabled: false,
        transitionName: '',
        prefixCls: 'rc-cascader',
        popupClassName: '',
        popupPlacement: 'bottomLeft',
        builtinPlacements: Cascader_BUILT_IN_PLACEMENTS,
        expandTrigger: 'click'
      };
      Cascader_Cascader.propTypes = {
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        options: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onPopupVisibleChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        popupVisible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        transitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        popupClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        popupPlacement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        dropdownMenuColumnStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        builtinPlacements: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        loadData: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        changeOnSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        onKeyDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        expandTrigger: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var es_Cascader = Cascader_Cascader; // CONCATENATED MODULE: ./node_modules/rc-cascader/es/index.js
      // export this package's api

      /* harmony default export */

      var rc_cascader_es = es_Cascader; // EXTERNAL MODULE: ./node_modules/array-tree-filter/lib/index.js

      var lib = __webpack_require__(708);

      var lib_default =
      /*#__PURE__*/
      __webpack_require__.n(lib); // CONCATENATED MODULE: ./node_modules/antd/es/cascader/index.js


      var cascader_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      function cascader_highlightKeyword(str, keyword, prefixCls) {
        return str.split(keyword).map(function (node, index) {
          return index === 0 ? node : [external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
            className: prefixCls + '-menu-item-keyword',
            key: 'seperator'
          }, keyword), node];
        });
      }

      function cascader_defaultFilterOption(inputValue, path) {
        return path.some(function (option) {
          return option.label.indexOf(inputValue) > -1;
        });
      }

      function cascader_defaultRenderFilteredOption(inputValue, path, prefixCls) {
        return path.map(function (_ref, index) {
          var label = _ref.label;
          var node = label.indexOf(inputValue) > -1 ? cascader_highlightKeyword(label, inputValue, prefixCls) : label;
          return index === 0 ? node : [' / ', node];
        });
      }

      function cascader_defaultSortFilteredOption(a, b, inputValue) {
        function callback(elem) {
          return elem.label.indexOf(inputValue) > -1;
        }

        return a.findIndex(callback) - b.findIndex(callback);
      }

      var cascader_defaultDisplayRender = function defaultDisplayRender(label) {
        return label.join(' / ');
      };

      var cascader_Cascader = function (_React$Component) {
        inherits_default()(Cascader, _React$Component);

        function Cascader(props) {
          classCallCheck_default()(this, Cascader);

          var _this = possibleConstructorReturn_default()(this, (Cascader.__proto__ || Object.getPrototypeOf(Cascader)).call(this, props));

          _this.handleChange = function (value, selectedOptions) {
            _this.setState({
              inputValue: ''
            });

            if (selectedOptions[0].__IS_FILTERED_OPTION) {
              var unwrappedValue = value[0];
              var unwrappedSelectedOptions = selectedOptions[0].path;

              _this.setValue(unwrappedValue, unwrappedSelectedOptions);

              return;
            }

            _this.setValue(value, selectedOptions);
          };

          _this.handlePopupVisibleChange = function (popupVisible) {
            if (!('popupVisible' in _this.props)) {
              _this.setState({
                popupVisible: popupVisible,
                inputFocused: popupVisible,
                inputValue: popupVisible ? _this.state.inputValue : ''
              });
            }

            var onPopupVisibleChange = _this.props.onPopupVisibleChange;

            if (onPopupVisibleChange) {
              onPopupVisibleChange(popupVisible);
            }
          };

          _this.handleInputBlur = function () {
            _this.setState({
              inputFocused: false
            });
          };

          _this.handleInputClick = function (e) {
            var _this$state = _this.state,
                inputFocused = _this$state.inputFocused,
                popupVisible = _this$state.popupVisible; // Prevent `Trigger` behaviour.

            if (inputFocused || popupVisible) {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
            }
          };

          _this.handleKeyDown = function (e) {
            if (e.keyCode === es_KeyCode["a"
            /* default */
            ].BACKSPACE) {
              e.stopPropagation();
            }
          };

          _this.handleInputChange = function (e) {
            var inputValue = e.target.value;

            _this.setState({
              inputValue: inputValue
            });
          };

          _this.setValue = function (value) {
            var selectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            if (!('value' in _this.props)) {
              _this.setState({
                value: value
              });
            }

            var onChange = _this.props.onChange;

            if (onChange) {
              onChange(value, selectedOptions);
            }
          };

          _this.clearSelection = function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (!_this.state.inputValue) {
              _this.setValue([]);

              _this.handlePopupVisibleChange(false);
            } else {
              _this.setState({
                inputValue: ''
              });
            }
          };

          _this.saveInput = function (node) {
            _this.input = node;
          };

          _this.state = {
            value: props.value || props.defaultValue || [],
            inputValue: '',
            inputFocused: false,
            popupVisible: props.popupVisible,
            flattenOptions: props.showSearch && _this.flattenTree(props.options, props.changeOnSelect)
          };
          return _this;
        }

        createClass_default()(Cascader, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
              this.setState({
                value: nextProps.value || []
              });
            }

            if ('popupVisible' in nextProps) {
              this.setState({
                popupVisible: nextProps.popupVisible
              });
            }

            if (nextProps.showSearch && this.props.options !== nextProps.options) {
              this.setState({
                flattenOptions: this.flattenTree(nextProps.options, nextProps.changeOnSelect)
              });
            }
          }
        }, {
          key: 'getLabel',
          value: function getLabel() {
            var _props = this.props,
                options = _props.options,
                _props$displayRender = _props.displayRender,
                displayRender = _props$displayRender === undefined ? cascader_defaultDisplayRender : _props$displayRender;
            var value = this.state.value;
            var unwrappedValue = Array.isArray(value[0]) ? value[0] : value;
            var selectedOptions = lib_default()(options, function (o, level) {
              return o.value === unwrappedValue[level];
            });
            var label = selectedOptions.map(function (o) {
              return o.label;
            });
            return displayRender(label, selectedOptions);
          }
        }, {
          key: 'flattenTree',
          value: function flattenTree(options, changeOnSelect) {
            var _this2 = this;

            var ancestor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var flattenOptions = [];
            options.forEach(function (option) {
              var path = ancestor.concat(option);

              if (changeOnSelect || !option.children || !option.children.length) {
                flattenOptions.push(path);
              }

              if (option.children) {
                flattenOptions = flattenOptions.concat(_this2.flattenTree(option.children, changeOnSelect, path));
              }
            });
            return flattenOptions;
          }
        }, {
          key: 'generateFilteredOptions',
          value: function generateFilteredOptions(prefixCls) {
            var _this3 = this;

            var _props2 = this.props,
                showSearch = _props2.showSearch,
                notFoundContent = _props2.notFoundContent;
            var _showSearch$filter = showSearch.filter,
                filter = _showSearch$filter === undefined ? cascader_defaultFilterOption : _showSearch$filter,
                _showSearch$render = showSearch.render,
                render = _showSearch$render === undefined ? cascader_defaultRenderFilteredOption : _showSearch$render,
                _showSearch$sort = showSearch.sort,
                sort = _showSearch$sort === undefined ? cascader_defaultSortFilteredOption : _showSearch$sort;
            var _state = this.state,
                flattenOptions = _state.flattenOptions,
                inputValue = _state.inputValue;
            var filtered = flattenOptions.filter(function (path) {
              return filter(_this3.state.inputValue, path);
            }).sort(function (a, b) {
              return sort(a, b, inputValue);
            });

            if (filtered.length > 0) {
              return filtered.map(function (path) {
                return {
                  __IS_FILTERED_OPTION: true,
                  path: path,
                  label: render(inputValue, path, prefixCls),
                  value: path.map(function (o) {
                    return o.value;
                  }),
                  disabled: path.some(function (o) {
                    return o.disabled;
                  })
                };
              });
            }

            return [{
              label: notFoundContent,
              value: 'ANT_CASCADER_NOT_FOUND',
              disabled: true
            }];
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.input.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.input.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames, _classNames2, _classNames3;

            var props = this.props,
                state = this.state;
            var prefixCls = props.prefixCls,
                inputPrefixCls = props.inputPrefixCls,
                children = props.children,
                placeholder = props.placeholder,
                size = props.size,
                disabled = props.disabled,
                className = props.className,
                style = props.style,
                allowClear = props.allowClear,
                _props$showSearch = props.showSearch,
                showSearch = _props$showSearch === undefined ? false : _props$showSearch,
                otherProps = cascader_rest(props, ["prefixCls", "inputPrefixCls", "children", "placeholder", "size", "disabled", "className", "style", "allowClear", "showSearch"]);
            var value = state.value;
            var sizeCls = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, inputPrefixCls + '-lg', size === 'large'), defineProperty_default()(_classNames, inputPrefixCls + '-sm', size === 'small'), _classNames));
            var clearIcon = allowClear && !disabled && value.length > 0 || state.inputValue ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'cross-circle',
              className: prefixCls + '-picker-clear',
              onClick: this.clearSelection
            }) : null;
            var arrowCls = classnames_default()((_classNames2 = {}, defineProperty_default()(_classNames2, prefixCls + '-picker-arrow', true), defineProperty_default()(_classNames2, prefixCls + '-picker-arrow-expand', state.popupVisible), _classNames2));
            var pickerCls = classnames_default()(className, prefixCls + '-picker', (_classNames3 = {}, defineProperty_default()(_classNames3, prefixCls + '-picker-with-value', state.inputValue), defineProperty_default()(_classNames3, prefixCls + '-picker-disabled', disabled), defineProperty_default()(_classNames3, prefixCls + '-picker-' + size, !!size), _classNames3)); // Fix bug of https://github.com/facebook/react/pull/5004
            // and https://fb.me/react-unknown-prop

            var inputProps = Object(es["default"])(otherProps, ['onChange', 'options', 'popupPlacement', 'transitionName', 'displayRender', 'onPopupVisibleChange', 'changeOnSelect', 'expandTrigger', 'popupVisible', 'getPopupContainer', 'loadData', 'popupClassName', 'filterOption', 'renderFilteredOption', 'sortFilteredOption', 'notFoundContent']);
            var options = props.options;

            if (state.inputValue) {
              options = this.generateFilteredOptions(prefixCls);
            } // Dropdown menu should keep previous status until it is fully closed.


            if (!state.popupVisible) {
              options = this.cachedOptions;
            } else {
              this.cachedOptions = options;
            }

            var dropdownMenuColumnStyle = {};
            var isNotFound = (options || []).length === 1 && options[0].value === 'ANT_CASCADER_NOT_FOUND';

            if (isNotFound) {
              dropdownMenuColumnStyle.height = 'auto'; // Height of one row.
            } // The default value of `matchInputWidth` is `true`


            var resultListMatchInputWidth = showSearch.matchInputWidth === false ? false : true;

            if (resultListMatchInputWidth && state.inputValue && this.input) {
              dropdownMenuColumnStyle.width = this.input.input.offsetWidth;
            }

            var input = children || external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              style: style,
              className: pickerCls
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: prefixCls + '-picker-label'
            }, this.getLabel()), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_input, extends_default()({}, inputProps, {
              ref: this.saveInput,
              prefixCls: inputPrefixCls,
              placeholder: value && value.length > 0 ? undefined : placeholder,
              className: prefixCls + '-input ' + sizeCls,
              value: state.inputValue,
              disabled: disabled,
              readOnly: !showSearch,
              autoComplete: 'off',
              onClick: showSearch ? this.handleInputClick : undefined,
              onBlur: showSearch ? this.handleInputBlur : undefined,
              onKeyDown: this.handleKeyDown,
              onChange: showSearch ? this.handleInputChange : undefined
            })), clearIcon, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'down',
              className: arrowCls
            }));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_cascader_es, extends_default()({}, props, {
              options: options,
              value: value,
              popupVisible: state.popupVisible,
              onPopupVisibleChange: this.handlePopupVisibleChange,
              onChange: this.handleChange,
              dropdownMenuColumnStyle: dropdownMenuColumnStyle
            }), input);
          }
        }]);
        return Cascader;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var cascader = cascader_Cascader;
      cascader_Cascader.defaultProps = {
        prefixCls: 'ant-cascader',
        inputPrefixCls: 'ant-input',
        placeholder: 'Please select',
        transitionName: 'slide-up',
        popupPlacement: 'bottomLeft',
        options: [],
        disabled: false,
        allowClear: true,
        notFoundContent: 'Not Found'
      }; // CONCATENATED MODULE: ./node_modules/antd/es/checkbox/Checkbox.js

      var Checkbox_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var checkbox_Checkbox_Checkbox = function (_React$Component) {
        inherits_default()(Checkbox, _React$Component);

        function Checkbox() {
          classCallCheck_default()(this, Checkbox);

          var _this = possibleConstructorReturn_default()(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));

          _this.saveCheckbox = function (node) {
            _this.rcCheckbox = node;
          };

          return _this;
        }

        createClass_default()(Checkbox, [{
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
            return !shallowequal_default()(this.props, nextProps) || !shallowequal_default()(this.state, nextState) || !shallowequal_default()(this.context.checkboxGroup, nextContext.checkboxGroup);
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.rcCheckbox.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.rcCheckbox.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var props = this.props,
                context = this.context;
            var prefixCls = props.prefixCls,
                className = props.className,
                children = props.children,
                indeterminate = props.indeterminate,
                style = props.style,
                onMouseEnter = props.onMouseEnter,
                onMouseLeave = props.onMouseLeave,
                restProps = Checkbox_rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);
            var checkboxGroup = context.checkboxGroup;
            var checkboxProps = extends_default()({}, restProps);

            if (checkboxGroup) {
              checkboxProps.onChange = function () {
                return checkboxGroup.toggleOption({
                  label: children,
                  value: props.value
                });
              };

              checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
              checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
            }

            var classString = classnames_default()(className, defineProperty_default()({}, prefixCls + '-wrapper', true));
            var checkboxClass = classnames_default()(defineProperty_default()({}, prefixCls + '-indeterminate', indeterminate));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('label', {
              className: classString,
              style: style,
              onMouseEnter: onMouseEnter,
              onMouseLeave: onMouseLeave
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_checkbox_es, extends_default()({}, checkboxProps, {
              prefixCls: prefixCls,
              className: checkboxClass,
              ref: this.saveCheckbox
            })), children !== undefined ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, children) : null);
          }
        }]);
        return Checkbox;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var checkbox_Checkbox = checkbox_Checkbox_Checkbox;
      checkbox_Checkbox_Checkbox.defaultProps = {
        prefixCls: 'ant-checkbox',
        indeterminate: false
      };
      checkbox_Checkbox_Checkbox.contextTypes = {
        checkboxGroup: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/antd/es/checkbox/Group.js

      var Group_CheckboxGroup = function (_React$Component) {
        inherits_default()(CheckboxGroup, _React$Component);

        function CheckboxGroup(props) {
          classCallCheck_default()(this, CheckboxGroup);

          var _this = possibleConstructorReturn_default()(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).call(this, props));

          _this.toggleOption = function (option) {
            var optionIndex = _this.state.value.indexOf(option.value);

            var value = [].concat(toConsumableArray_default()(_this.state.value));

            if (optionIndex === -1) {
              value.push(option.value);
            } else {
              value.splice(optionIndex, 1);
            }

            if (!('value' in _this.props)) {
              _this.setState({
                value: value
              });
            }

            var onChange = _this.props.onChange;

            if (onChange) {
              onChange(value);
            }
          };

          _this.state = {
            value: props.value || props.defaultValue || []
          };
          return _this;
        }

        createClass_default()(CheckboxGroup, [{
          key: 'getChildContext',
          value: function getChildContext() {
            return {
              checkboxGroup: {
                toggleOption: this.toggleOption,
                value: this.state.value,
                disabled: this.props.disabled
              }
            };
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
              this.setState({
                value: nextProps.value || []
              });
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps, nextState) {
            return !shallowequal_default()(this.props, nextProps) || !shallowequal_default()(this.state, nextState);
          }
        }, {
          key: 'getOptions',
          value: function getOptions() {
            var options = this.props.options; // https://github.com/Microsoft/TypeScript/issues/7960

            return options.map(function (option) {
              if (typeof option === 'string') {
                return {
                  label: option,
                  value: option
                };
              }

              return option;
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this;

            var props = this.props,
                state = this.state;
            var prefixCls = props.prefixCls,
                className = props.className,
                style = props.style,
                options = props.options;
            var children = props.children;

            if (options && options.length > 0) {
              children = this.getOptions().map(function (option) {
                return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](checkbox_Checkbox, {
                  key: option.value,
                  disabled: 'disabled' in option ? option.disabled : props.disabled,
                  value: option.value,
                  checked: state.value.indexOf(option.value) !== -1,
                  onChange: function onChange() {
                    return _this2.toggleOption(option);
                  },
                  className: prefixCls + '-item'
                }, option.label);
              });
            }

            var classString = classnames_default()(prefixCls, className);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: classString,
              style: style
            }, children);
          }
        }]);
        return CheckboxGroup;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var checkbox_Group = Group_CheckboxGroup;
      Group_CheckboxGroup.defaultProps = {
        options: [],
        prefixCls: 'ant-checkbox-group'
      };
      Group_CheckboxGroup.propTypes = {
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        options: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      Group_CheckboxGroup.childContextTypes = {
        checkboxGroup: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/antd/es/checkbox/index.js

      checkbox_Checkbox.Group = checkbox_Group;
      /* harmony default export */

      var es_checkbox = checkbox_Checkbox; // CONCATENATED MODULE: ./node_modules/antd/es/grid/row.js

      var row_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      }; // matchMedia polyfill for
      // https://github.com/WickyNilliams/enquire.js/issues/82


      var row_enquire = void 0;

      if (typeof window !== 'undefined') {
        var row_matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
          return {
            media: mediaQuery,
            matches: false,
            addListener: function addListener() {},
            removeListener: function removeListener() {}
          };
        };

        window.matchMedia = window.matchMedia || row_matchMediaPolyfill;
        row_enquire = __webpack_require__(511);
      }

      var row_responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
      var row_responsiveMap = {
        xs: '(max-width: 575px)',
        sm: '(min-width: 576px)',
        md: '(min-width: 768px)',
        lg: '(min-width: 992px)',
        xl: '(min-width: 1200px)',
        xxl: '(min-width: 1600px)'
      };

      var row_Row = function (_React$Component) {
        inherits_default()(Row, _React$Component);

        function Row() {
          classCallCheck_default()(this, Row);

          var _this = possibleConstructorReturn_default()(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));

          _this.state = {
            screens: {}
          };
          return _this;
        }

        createClass_default()(Row, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _this2 = this;

            Object.keys(row_responsiveMap).map(function (screen) {
              return row_enquire.register(row_responsiveMap[screen], {
                match: function match() {
                  if (typeof_default()(_this2.props.gutter) !== 'object') {
                    return;
                  }

                  _this2.setState(function (prevState) {
                    return {
                      screens: extends_default()({}, prevState.screens, defineProperty_default()({}, screen, true))
                    };
                  });
                },
                unmatch: function unmatch() {
                  if (typeof_default()(_this2.props.gutter) !== 'object') {
                    return;
                  }

                  _this2.setState(function (prevState) {
                    return {
                      screens: extends_default()({}, prevState.screens, defineProperty_default()({}, screen, false))
                    };
                  });
                },
                // Keep a empty destory to avoid triggering unmatch when unregister
                destroy: function destroy() {}
              });
            });
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            Object.keys(row_responsiveMap).map(function (screen) {
              return row_enquire.unregister(row_responsiveMap[screen]);
            });
          }
        }, {
          key: 'getGutter',
          value: function getGutter() {
            var gutter = this.props.gutter;

            if ((typeof gutter === 'undefined' ? 'undefined' : typeof_default()(gutter)) === 'object') {
              for (var i = 0; i <= row_responsiveArray.length; i++) {
                var breakpoint = row_responsiveArray[i];

                if (this.state.screens[breakpoint] && gutter[breakpoint] !== undefined) {
                  return gutter[breakpoint];
                }
              }
            }

            return gutter;
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _a = this.props,
                type = _a.type,
                justify = _a.justify,
                align = _a.align,
                className = _a.className,
                style = _a.style,
                children = _a.children,
                _a$prefixCls = _a.prefixCls,
                prefixCls = _a$prefixCls === undefined ? 'ant-row' : _a$prefixCls,
                others = row_rest(_a, ["type", "justify", "align", "className", "style", "children", "prefixCls"]);
            var gutter = this.getGutter();
            var classes = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls, !type), defineProperty_default()(_classNames, prefixCls + '-' + type, type), defineProperty_default()(_classNames, prefixCls + '-' + type + '-' + justify, type && justify), defineProperty_default()(_classNames, prefixCls + '-' + type + '-' + align, type && align), _classNames), className);
            var rowStyle = gutter > 0 ? extends_default()({
              marginLeft: gutter / -2,
              marginRight: gutter / -2
            }, style) : style;
            var cols = external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].map(children, function (col) {
              if (!col) {
                return null;
              }

              if (col.props && gutter > 0) {
                return Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"])(col, {
                  style: extends_default()({
                    paddingLeft: gutter / 2,
                    paddingRight: gutter / 2
                  }, col.props.style)
                });
              }

              return col;
            });
            var otherProps = extends_default()({}, others);
            delete otherProps.gutter;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, otherProps, {
              className: classes,
              style: rowStyle
            }), cols);
          }
        }]);
        return Row;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var grid_row = row_Row;
      row_Row.defaultProps = {
        gutter: 0
      };
      row_Row.propTypes = {
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        align: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        justify: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        gutter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      }; // CONCATENATED MODULE: ./node_modules/antd/es/grid/col.js

      var col_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var col_stringOrNumber = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]);
      var col_objectOrNumber = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]);

      var col_Col = function (_React$Component) {
        inherits_default()(Col, _React$Component);

        function Col() {
          classCallCheck_default()(this, Col);
          return possibleConstructorReturn_default()(this, (Col.__proto__ || Object.getPrototypeOf(Col)).apply(this, arguments));
        }

        createClass_default()(Col, [{
          key: 'render',
          value: function render() {
            var _classNames;

            var props = this.props;
            var span = props.span,
                order = props.order,
                offset = props.offset,
                push = props.push,
                pull = props.pull,
                className = props.className,
                children = props.children,
                _props$prefixCls = props.prefixCls,
                prefixCls = _props$prefixCls === undefined ? 'ant-col' : _props$prefixCls,
                others = col_rest(props, ["span", "order", "offset", "push", "pull", "className", "children", "prefixCls"]);
            var sizeClassObj = {};
            ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
              var _extends2;

              var sizeProps = {};

              if (typeof props[size] === 'number') {
                sizeProps.span = props[size];
              } else if (typeof_default()(props[size]) === 'object') {
                sizeProps = props[size] || {};
              }

              delete others[size];
              sizeClassObj = extends_default()({}, sizeClassObj, (_extends2 = {}, defineProperty_default()(_extends2, prefixCls + '-' + size + '-' + sizeProps.span, sizeProps.span !== undefined), defineProperty_default()(_extends2, prefixCls + '-' + size + '-order-' + sizeProps.order, sizeProps.order || sizeProps.order === 0), defineProperty_default()(_extends2, prefixCls + '-' + size + '-offset-' + sizeProps.offset, sizeProps.offset || sizeProps.offset === 0), defineProperty_default()(_extends2, prefixCls + '-' + size + '-push-' + sizeProps.push, sizeProps.push || sizeProps.push === 0), defineProperty_default()(_extends2, prefixCls + '-' + size + '-pull-' + sizeProps.pull, sizeProps.pull || sizeProps.pull === 0), _extends2));
            });
            var classes = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-' + span, span !== undefined), defineProperty_default()(_classNames, prefixCls + '-order-' + order, order), defineProperty_default()(_classNames, prefixCls + '-offset-' + offset, offset), defineProperty_default()(_classNames, prefixCls + '-push-' + push, push), defineProperty_default()(_classNames, prefixCls + '-pull-' + pull, pull), _classNames), className, sizeClassObj);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, others, {
              className: classes
            }), children);
          }
        }]);
        return Col;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var grid_col = col_Col;
      col_Col.propTypes = {
        span: col_stringOrNumber,
        order: col_stringOrNumber,
        offset: col_stringOrNumber,
        push: col_stringOrNumber,
        pull: col_stringOrNumber,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        xs: col_objectOrNumber,
        sm: col_objectOrNumber,
        md: col_objectOrNumber,
        lg: col_objectOrNumber,
        xl: col_objectOrNumber,
        xxl: col_objectOrNumber
      }; // CONCATENATED MODULE: ./node_modules/antd/es/grid/index.js
      // CONCATENATED MODULE: ./node_modules/antd/es/col/index.js

      /* harmony default export */

      var es_col = grid_col; // EXTERNAL MODULE: ./node_modules/rc-calendar/es/index.js + 1 modules

      var rc_calendar_es = __webpack_require__(183); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/calendar/CalendarHeader.js + 3 modules


      var calendar_CalendarHeader = __webpack_require__(185); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/calendar/CalendarFooter.js


      var CalendarFooter = __webpack_require__(289); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/MonthCalendar.js


      var MonthCalendar_MonthCalendar = create_react_class_default()({
        displayName: 'MonthCalendar',
        propTypes: {
          monthCellRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          dateCellRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        },
        mixins: [CommonMixin["a"
        /* default */
        ], CalendarMixin["a"
        /* default */
        ]],
        getInitialState: function getInitialState() {
          return {
            mode: 'month'
          };
        },
        onKeyDown: function onKeyDown(event) {
          var keyCode = event.keyCode;
          var ctrlKey = event.ctrlKey || event.metaKey;
          var stateValue = this.state.value;
          var disabledDate = this.props.disabledDate;
          var value = stateValue;

          switch (keyCode) {
            case es_KeyCode["a"
            /* default */
            ].DOWN:
              value = stateValue.clone();
              value.add(3, 'months');
              break;

            case es_KeyCode["a"
            /* default */
            ].UP:
              value = stateValue.clone();
              value.add(-3, 'months');
              break;

            case es_KeyCode["a"
            /* default */
            ].LEFT:
              value = stateValue.clone();

              if (ctrlKey) {
                value.add(-1, 'years');
              } else {
                value.add(-1, 'months');
              }

              break;

            case es_KeyCode["a"
            /* default */
            ].RIGHT:
              value = stateValue.clone();

              if (ctrlKey) {
                value.add(1, 'years');
              } else {
                value.add(1, 'months');
              }

              break;

            case es_KeyCode["a"
            /* default */
            ].ENTER:
              if (!disabledDate || !disabledDate(stateValue)) {
                this.onSelect(stateValue);
              }

              event.preventDefault();
              return 1;

            default:
              return undefined;
          }

          if (value !== stateValue) {
            this.setValue(value);
            event.preventDefault();
            return 1;
          }
        },
        handlePanelChange: function handlePanelChange(_, mode) {
          if (mode !== 'date') {
            this.setState({
              mode: mode
            });
          }
        },
        render: function render() {
          var props = this.props,
              state = this.state;
          var mode = state.mode,
              value = state.value;
          var children = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: props.prefixCls + '-month-calendar-content'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: props.prefixCls + '-month-header-wrap'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(calendar_CalendarHeader["a"
          /* default */
          ], {
            prefixCls: props.prefixCls,
            mode: mode,
            value: value,
            locale: props.locale,
            disabledMonth: props.disabledDate,
            monthCellRender: props.monthCellRender,
            monthCellContentRender: props.monthCellContentRender,
            onMonthSelect: this.onSelect,
            onValueChange: this.setValue,
            onPanelChange: this.handlePanelChange
          })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(CalendarFooter["a"
          /* default */
          ], {
            prefixCls: props.prefixCls,
            renderFooter: props.renderFooter
          }));
          return this.renderRoot({
            className: props.prefixCls + '-month-calendar',
            children: children
          });
        }
      });
      /* harmony default export */

      var es_MonthCalendar = MonthCalendar_MonthCalendar; // EXTERNAL MODULE: ./node_modules/rc-util/es/createChainedFunction.js

      var createChainedFunction = __webpack_require__(148); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/picker/placements.js


      var placements_autoAdjustOverflow = {
        adjustX: 1,
        adjustY: 1
      };
      var placements_targetOffset = [0, 0];
      var placements = {
        bottomLeft: {
          points: ['tl', 'tl'],
          overflow: placements_autoAdjustOverflow,
          offset: [0, -3],
          targetOffset: placements_targetOffset
        },
        bottomRight: {
          points: ['tr', 'tr'],
          overflow: placements_autoAdjustOverflow,
          offset: [0, -3],
          targetOffset: placements_targetOffset
        },
        topRight: {
          points: ['br', 'br'],
          overflow: placements_autoAdjustOverflow,
          offset: [0, 3],
          targetOffset: placements_targetOffset
        },
        topLeft: {
          points: ['bl', 'bl'],
          overflow: placements_autoAdjustOverflow,
          offset: [0, 3],
          targetOffset: placements_targetOffset
        }
      };
      /* harmony default export */

      var picker_placements = placements; // CONCATENATED MODULE: ./node_modules/rc-calendar/es/Picker.js

      function Picker_noop() {}

      function Picker_refFn(field, component) {
        this[field] = component;
      }

      var Picker_Picker = create_react_class_default()({
        displayName: 'Picker',
        propTypes: {
          animation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
          disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          transitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onOpenChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          getCalendarContainer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          calendar: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.element,
          style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          open: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          defaultOpen: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          placement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array]),
          defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array]),
          align: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
        },
        getDefaultProps: function getDefaultProps() {
          return {
            prefixCls: 'rc-calendar-picker',
            style: {},
            align: {},
            placement: 'bottomLeft',
            defaultOpen: false,
            onChange: Picker_noop,
            onOpenChange: Picker_noop
          };
        },
        getInitialState: function getInitialState() {
          var props = this.props;
          var open = void 0;

          if ('open' in props) {
            open = props.open;
          } else {
            open = props.defaultOpen;
          }

          var value = props.value || props.defaultValue;
          this.saveCalendarRef = Picker_refFn.bind(this, 'calendarInstance');
          return {
            open: open,
            value: value
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          var value = nextProps.value,
              open = nextProps.open;

          if ('value' in nextProps) {
            this.setState({
              value: value
            });
          }

          if (open !== undefined) {
            this.setState({
              open: open
            });
          }
        },
        componentDidUpdate: function componentDidUpdate(_, prevState) {
          if (!prevState.open && this.state.open) {
            // setTimeout is for making sure saveCalendarRef happen before focusCalendar
            this.focusTimeout = setTimeout(this.focusCalendar, 0, this);
          }
        },
        componentWillUnmount: function componentWillUnmount() {
          clearTimeout(this.focusTimeout);
        },
        onCalendarKeyDown: function onCalendarKeyDown(event) {
          if (event.keyCode === es_KeyCode["a"
          /* default */
          ].ESC) {
            event.stopPropagation();
            this.close(this.focus);
          }
        },
        onCalendarSelect: function onCalendarSelect(value) {
          var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var props = this.props;

          if (!('value' in props)) {
            this.setState({
              value: value
            });
          }

          if (cause.source === 'keyboard' || !props.calendar.props.timePicker && cause.source !== 'dateInput' || cause.source === 'todayButton') {
            this.close(this.focus);
          }

          props.onChange(value);
        },
        onKeyDown: function onKeyDown(event) {
          if (event.keyCode === es_KeyCode["a"
          /* default */
          ].DOWN && !this.state.open) {
            this.open();
            event.preventDefault();
          }
        },
        onCalendarOk: function onCalendarOk() {
          this.close(this.focus);
        },
        onCalendarClear: function onCalendarClear() {
          this.close(this.focus);
        },
        onVisibleChange: function onVisibleChange(open) {
          this.setOpen(open);
        },
        getCalendarElement: function getCalendarElement() {
          var props = this.props;
          var state = this.state;
          var calendarProps = props.calendar.props;
          var value = state.value;
          var defaultValue = value;
          var extraProps = {
            ref: this.saveCalendarRef,
            defaultValue: defaultValue || calendarProps.defaultValue,
            selectedValue: value,
            onKeyDown: this.onCalendarKeyDown,
            onOk: Object(createChainedFunction["a"
            /* default */
            ])(calendarProps.onOk, this.onCalendarOk),
            onSelect: Object(createChainedFunction["a"
            /* default */
            ])(calendarProps.onSelect, this.onCalendarSelect),
            onClear: Object(createChainedFunction["a"
            /* default */
            ])(calendarProps.onClear, this.onCalendarClear)
          };
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(props.calendar, extraProps);
        },
        setOpen: function setOpen(open, callback) {
          var onOpenChange = this.props.onOpenChange;

          if (this.state.open !== open) {
            if (!('open' in this.props)) {
              this.setState({
                open: open
              }, callback);
            }

            onOpenChange(open);
          }
        },
        open: function open(callback) {
          this.setOpen(true, callback);
        },
        close: function close(callback) {
          this.setOpen(false, callback);
        },
        focus: function focus() {
          if (!this.state.open) {
            external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this).focus();
          }
        },
        focusCalendar: function focusCalendar() {
          if (this.state.open && !!this.calendarInstance) {
            this.calendarInstance.focus();
          }
        },
        render: function render() {
          var props = this.props;
          var prefixCls = props.prefixCls,
              placement = props.placement,
              style = props.style,
              getCalendarContainer = props.getCalendarContainer,
              align = props.align,
              animation = props.animation,
              disabled = props.disabled,
              dropdownClassName = props.dropdownClassName,
              transitionName = props.transitionName,
              children = props.children;
          var state = this.state;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_trigger_es["default"], {
            popup: this.getCalendarElement(),
            popupAlign: align,
            builtinPlacements: picker_placements,
            popupPlacement: placement,
            action: disabled && !state.open ? [] : ['click'],
            destroyPopupOnHide: true,
            getPopupContainer: getCalendarContainer,
            popupStyle: style,
            popupAnimation: animation,
            popupTransitionName: transitionName,
            popupVisible: state.open,
            onPopupVisibleChange: this.onVisibleChange,
            prefixCls: prefixCls,
            popupClassName: dropdownClassName
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(children(state, props), {
            onKeyDown: this.onKeyDown
          }));
        }
      });
      /* harmony default export */

      var es_Picker = Picker_Picker; // CONCATENATED MODULE: ./node_modules/antd/es/date-picker/createPicker.js

      function createPicker_createPicker(TheCalendar) {
        return _a = function (_React$Component) {
          inherits_default()(CalenderWrapper, _React$Component);

          function CalenderWrapper(props) {
            classCallCheck_default()(this, CalenderWrapper);

            var _this = possibleConstructorReturn_default()(this, (CalenderWrapper.__proto__ || Object.getPrototypeOf(CalenderWrapper)).call(this, props));

            _this.renderFooter = function () {
              var _this$props = _this.props,
                  prefixCls = _this$props.prefixCls,
                  renderExtraFooter = _this$props.renderExtraFooter;
              return renderExtraFooter ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: prefixCls + '-footer-extra'
              }, renderExtraFooter.apply(undefined, arguments)) : null;
            };

            _this.clearSelection = function (e) {
              e.preventDefault();
              e.stopPropagation();

              _this.handleChange(null);
            };

            _this.handleChange = function (value) {
              var props = _this.props;

              if (!('value' in props)) {
                _this.setState({
                  value: value,
                  showDate: value
                });
              }

              props.onChange(value, value && value.format(props.format) || '');
            };

            _this.handleCalendarChange = function (value) {
              _this.setState({
                showDate: value
              });
            };

            _this.saveInput = function (node) {
              _this.input = node;
            };

            var value = props.value || props.defaultValue;

            if (value && !interopDefault(moment).isMoment(value)) {
              throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
            }

            _this.state = {
              value: value,
              showDate: value
            };
            return _this;
          }

          createClass_default()(CalenderWrapper, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
              if ('value' in nextProps) {
                this.setState({
                  value: nextProps.value,
                  showDate: nextProps.value
                });
              }
            }
          }, {
            key: 'focus',
            value: function focus() {
              this.input.focus();
            }
          }, {
            key: 'blur',
            value: function blur() {
              this.input.blur();
            }
          }, {
            key: 'render',
            value: function render() {
              var _classNames,
                  _this2 = this;

              var _state = this.state,
                  value = _state.value,
                  showDate = _state.showDate;
              var props = Object(es["default"])(this.props, ['onChange']);
              var prefixCls = props.prefixCls,
                  locale = props.locale,
                  localeCode = props.localeCode;
              var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
              var disabledTime = props.showTime ? props.disabledTime : null;
              var calendarClassName = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-time', props.showTime), defineProperty_default()(_classNames, prefixCls + '-month', es_MonthCalendar === TheCalendar), _classNames));

              if (value && localeCode) {
                value.locale(localeCode);
              }

              var pickerProps = {};
              var calendarProps = {};

              if (props.showTime) {
                calendarProps = {
                  // fix https://github.com/ant-design/ant-design/issues/1902
                  onSelect: this.handleChange
                };
              } else {
                pickerProps = {
                  onChange: this.handleChange
                };
              }

              if ('mode' in props) {
                calendarProps.mode = props.mode;
              }

              _util_warning(!('onOK' in props), 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');

              var calendar = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](TheCalendar, extends_default()({}, calendarProps, {
                disabledDate: props.disabledDate,
                disabledTime: disabledTime,
                locale: locale.lang,
                timePicker: props.timePicker,
                defaultValue: props.defaultPickerValue || interopDefault(moment)(),
                dateInputPlaceholder: placeholder,
                prefixCls: prefixCls,
                className: calendarClassName,
                onOk: props.onOk,
                dateRender: props.dateRender,
                format: props.format,
                showToday: props.showToday,
                monthCellContentRender: props.monthCellContentRender,
                renderFooter: this.renderFooter,
                onPanelChange: props.onPanelChange,
                onChange: this.handleCalendarChange,
                value: showDate
              }));
              var clearIcon = !props.disabled && props.allowClear && value ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: 'cross-circle',
                className: prefixCls + '-picker-clear',
                onClick: this.clearSelection
              }) : null;

              var input = function input(_ref) {
                var inputValue = _ref.value;
                return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('input', {
                  ref: _this2.saveInput,
                  disabled: props.disabled,
                  readOnly: true,
                  value: inputValue && inputValue.format(props.format) || '',
                  placeholder: placeholder,
                  className: props.pickerInputClass
                }), clearIcon, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                  className: prefixCls + '-picker-icon'
                }));
              };

              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                id: props.id,
                className: classnames_default()(props.className, props.pickerClass),
                style: props.style,
                onFocus: props.onFocus,
                onBlur: props.onBlur
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_Picker, extends_default()({}, props, pickerProps, {
                calendar: calendar,
                value: value,
                prefixCls: prefixCls + '-picker-container',
                style: props.popupStyle
              }), input));
            }
          }]);
          return CalenderWrapper;
        }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]), _a.defaultProps = {
          prefixCls: 'ant-calendar',
          allowClear: true,
          showToday: true
        }, _a;

        var _a;
      } // CONCATENATED MODULE: ./node_modules/rc-time-picker/es/Header.js


      var es_Header_Header = function (_Component) {
        inherits_default()(Header, _Component);

        function Header(props) {
          classCallCheck_default()(this, Header);

          var _this = possibleConstructorReturn_default()(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

          Header_initialiseProps.call(_this);
          var value = props.value,
              format = props.format;
          _this.state = {
            str: value && value.format(format) || '',
            invalid: false
          };
          return _this;
        }

        createClass_default()(Header, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _this2 = this;

            if (this.props.focusOnOpen) {
              // Wait one frame for the panel to be positioned before focusing
              var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
              requestAnimationFrame(function () {
                _this2.refs.input.focus();

                _this2.refs.input.select();
              });
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var value = nextProps.value,
                format = nextProps.format;
            this.setState({
              str: value && value.format(format) || '',
              invalid: false
            });
          }
        }, {
          key: 'getClearButton',
          value: function getClearButton() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                allowEmpty = _props.allowEmpty;

            if (!allowEmpty) {
              return null;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
              className: prefixCls + '-clear-btn',
              role: 'button',
              title: this.props.clearText,
              onMouseDown: this.onClear
            });
          }
        }, {
          key: 'getProtoValue',
          value: function getProtoValue() {
            return this.props.value || this.props.defaultOpenValue;
          }
        }, {
          key: 'getInput',
          value: function getInput() {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                placeholder = _props2.placeholder,
                inputReadOnly = _props2.inputReadOnly;
            var _state = this.state,
                invalid = _state.invalid,
                str = _state.str;
            var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('input', {
              className: prefixCls + '-input  ' + invalidClass,
              ref: 'input',
              onKeyDown: this.onKeyDown,
              value: str,
              placeholder: placeholder,
              onChange: this.onInputChange,
              readOnly: !!inputReadOnly
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var prefixCls = this.props.prefixCls;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-input-wrap'
            }, this.getInput(), this.getClearButton());
          }
        }]);
        return Header;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      es_Header_Header.propTypes = {
        format: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        disabledDate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        clearText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        inputReadOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        hourOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        minuteOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        secondOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        disabledHours: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        disabledMinutes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        disabledSeconds: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onClear: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onEsc: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        allowEmpty: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultOpenValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        currentSelectPanel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        focusOnOpen: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onKeyDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      es_Header_Header.defaultProps = {
        inputReadOnly: false
      };

      var Header_initialiseProps = function _initialiseProps() {
        var _this3 = this;

        this.onInputChange = function (event) {
          var str = event.target.value;

          _this3.setState({
            str: str
          });

          var _props3 = _this3.props,
              format = _props3.format,
              hourOptions = _props3.hourOptions,
              minuteOptions = _props3.minuteOptions,
              secondOptions = _props3.secondOptions,
              disabledHours = _props3.disabledHours,
              disabledMinutes = _props3.disabledMinutes,
              disabledSeconds = _props3.disabledSeconds,
              onChange = _props3.onChange,
              allowEmpty = _props3.allowEmpty;

          if (str) {
            var originalValue = _this3.props.value;

            var value = _this3.getProtoValue().clone();

            var parsed = moment_default()(str, format, true);

            if (!parsed.isValid()) {
              _this3.setState({
                invalid: true
              });

              return;
            }

            value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second()); // if time value not allowed, response warning.

            if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
              _this3.setState({
                invalid: true
              });

              return;
            } // if time value is disabled, response warning.


            var disabledHourOptions = disabledHours();
            var disabledMinuteOptions = disabledMinutes(value.hour());
            var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());

            if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
              _this3.setState({
                invalid: true
              });

              return;
            }

            if (originalValue) {
              if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
                // keep other fields for rc-calendar
                var changedValue = originalValue.clone();
                changedValue.hour(value.hour());
                changedValue.minute(value.minute());
                changedValue.second(value.second());
                onChange(changedValue);
              }
            } else if (originalValue !== value) {
              onChange(value);
            }
          } else if (allowEmpty) {
            onChange(null);
          } else {
            _this3.setState({
              invalid: true
            });

            return;
          }

          _this3.setState({
            invalid: false
          });
        };

        this.onKeyDown = function (e) {
          var _props4 = _this3.props,
              onEsc = _props4.onEsc,
              onKeyDown = _props4.onKeyDown;

          if (e.keyCode === 27) {
            onEsc();
          }

          onKeyDown(e);
        };

        this.onClear = function () {
          _this3.setState({
            str: ''
          });

          _this3.props.onClear();
        };
      };
      /* harmony default export */


      var es_Header = es_Header_Header; // CONCATENATED MODULE: ./node_modules/rc-time-picker/es/Select.js

      var Select_scrollTo = function scrollTo(element, to, duration) {
        var requestAnimationFrame = window.requestAnimationFrame || function requestAnimationFrameTimeout() {
          return setTimeout(arguments[0], 10);
        }; // jump to target if duration zero


        if (duration <= 0) {
          element.scrollTop = to;
          return;
        }

        var difference = to - element.scrollTop;
        var perTick = difference / duration * 10;
        requestAnimationFrame(function () {
          element.scrollTop = element.scrollTop + perTick;
          if (element.scrollTop === to) return;
          scrollTo(element, to, duration - 10);
        });
      };

      var Select_Select = function (_Component) {
        inherits_default()(Select, _Component);

        function Select() {
          var _ref;

          var _temp, _this, _ret;

          classCallCheck_default()(this, Select);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            active: false
          }, _this.onSelect = function (value) {
            var _this$props = _this.props,
                onSelect = _this$props.onSelect,
                type = _this$props.type;
            onSelect(type, value);
          }, _this.handleMouseEnter = function (e) {
            _this.setState({
              active: true
            });

            _this.props.onMouseEnter(e);
          }, _this.handleMouseLeave = function () {
            _this.setState({
              active: false
            });
          }, _this.saveList = function (node) {
            _this.list = node;
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        createClass_default()(Select, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            // jump to selected option
            this.scrollToSelected(0);
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate(prevProps) {
            // smooth scroll to selected option
            if (prevProps.selectedIndex !== this.props.selectedIndex) {
              this.scrollToSelected(120);
            }
          }
        }, {
          key: 'getOptions',
          value: function getOptions() {
            var _this2 = this;

            var _props = this.props,
                options = _props.options,
                selectedIndex = _props.selectedIndex,
                prefixCls = _props.prefixCls;
            return options.map(function (item, index) {
              var _classnames;

              var cls = classnames_default()((_classnames = {}, defineProperty_default()(_classnames, prefixCls + '-select-option-selected', selectedIndex === index), defineProperty_default()(_classnames, prefixCls + '-select-option-disabled', item.disabled), _classnames));
              var onclick = null;

              if (!item.disabled) {
                onclick = _this2.onSelect.bind(_this2, item.value);
              }

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
                className: cls,
                key: index,
                onClick: onclick,
                disabled: item.disabled
              }, item.value);
            });
          }
        }, {
          key: 'scrollToSelected',
          value: function scrollToSelected(duration) {
            // move to selected item
            var select = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this);
            var list = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this.list);

            if (!list) {
              return;
            }

            var index = this.props.selectedIndex;

            if (index < 0) {
              index = 0;
            }

            var topOption = list.children[index];
            var to = topOption.offsetTop;
            Select_scrollTo(select, to, duration);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classnames2;

            if (this.props.options.length === 0) {
              return null;
            }

            var prefixCls = this.props.prefixCls;
            var cls = classnames_default()((_classnames2 = {}, defineProperty_default()(_classnames2, prefixCls + '-select', 1), defineProperty_default()(_classnames2, prefixCls + '-select-active', this.state.active), _classnames2));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: cls,
              onMouseEnter: this.handleMouseEnter,
              onMouseLeave: this.handleMouseLeave
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', {
              ref: this.saveList
            }, this.getOptions()));
          }
        }]);
        return Select;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Select_Select.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        options: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        selectedIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      /* harmony default export */

      var es_Select = Select_Select; // CONCATENATED MODULE: ./node_modules/rc-time-picker/es/Combobox.js

      var Combobox_formatOption = function formatOption(option, disabledOptions) {
        var value = '' + option;

        if (option < 10) {
          value = '0' + option;
        }

        var disabled = false;

        if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
          disabled = true;
        }

        return {
          value: value,
          disabled: disabled
        };
      };

      var Combobox_Combobox = function (_Component) {
        inherits_default()(Combobox, _Component);

        function Combobox() {
          var _ref;

          var _temp, _this, _ret;

          classCallCheck_default()(this, Combobox);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Combobox.__proto__ || Object.getPrototypeOf(Combobox)).call.apply(_ref, [this].concat(args))), _this), _this.onItemChange = function (type, itemValue) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                defaultOpenValue = _this$props.defaultOpenValue,
                use12Hours = _this$props.use12Hours;
            var value = (_this.props.value || defaultOpenValue).clone();

            if (type === 'hour') {
              if (use12Hours) {
                if (_this.props.isAM) {
                  value.hour(+itemValue % 12);
                } else {
                  value.hour(+itemValue % 12 + 12);
                }
              } else {
                value.hour(+itemValue);
              }
            } else if (type === 'minute') {
              value.minute(+itemValue);
            } else if (type === 'ampm') {
              var ampm = itemValue.toUpperCase();

              if (use12Hours) {
                if (ampm === 'PM' && value.hour() < 12) {
                  value.hour(value.hour() % 12 + 12);
                }

                if (ampm === 'AM') {
                  if (value.hour() >= 12) {
                    value.hour(value.hour() - 12);
                  }
                }
              }
            } else {
              value.second(+itemValue);
            }

            onChange(value);
          }, _this.onEnterSelectPanel = function (range) {
            _this.props.onCurrentSelectPanelChange(range);
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        createClass_default()(Combobox, [{
          key: 'getHourSelect',
          value: function getHourSelect(hour) {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                hourOptions = _props.hourOptions,
                disabledHours = _props.disabledHours,
                showHour = _props.showHour,
                use12Hours = _props.use12Hours;

            if (!showHour) {
              return null;
            }

            var disabledOptions = disabledHours();
            var hourOptionsAdj = void 0;
            var hourAdj = void 0;

            if (use12Hours) {
              hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
                return h < 12 && h > 0;
              }));
              hourAdj = hour % 12 || 12;
            } else {
              hourOptionsAdj = hourOptions;
              hourAdj = hour;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Select, {
              prefixCls: prefixCls,
              options: hourOptionsAdj.map(function (option) {
                return Combobox_formatOption(option, disabledOptions);
              }),
              selectedIndex: hourOptionsAdj.indexOf(hourAdj),
              type: 'hour',
              onSelect: this.onItemChange,
              onMouseEnter: this.onEnterSelectPanel.bind(this, 'hour')
            });
          }
        }, {
          key: 'getMinuteSelect',
          value: function getMinuteSelect(minute) {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                minuteOptions = _props2.minuteOptions,
                disabledMinutes = _props2.disabledMinutes,
                defaultOpenValue = _props2.defaultOpenValue,
                showMinute = _props2.showMinute;

            if (!showMinute) {
              return null;
            }

            var value = this.props.value || defaultOpenValue;
            var disabledOptions = disabledMinutes(value.hour());
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Select, {
              prefixCls: prefixCls,
              options: minuteOptions.map(function (option) {
                return Combobox_formatOption(option, disabledOptions);
              }),
              selectedIndex: minuteOptions.indexOf(minute),
              type: 'minute',
              onSelect: this.onItemChange,
              onMouseEnter: this.onEnterSelectPanel.bind(this, 'minute')
            });
          }
        }, {
          key: 'getSecondSelect',
          value: function getSecondSelect(second) {
            var _props3 = this.props,
                prefixCls = _props3.prefixCls,
                secondOptions = _props3.secondOptions,
                disabledSeconds = _props3.disabledSeconds,
                showSecond = _props3.showSecond,
                defaultOpenValue = _props3.defaultOpenValue;

            if (!showSecond) {
              return null;
            }

            var value = this.props.value || defaultOpenValue;
            var disabledOptions = disabledSeconds(value.hour(), value.minute());
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Select, {
              prefixCls: prefixCls,
              options: secondOptions.map(function (option) {
                return Combobox_formatOption(option, disabledOptions);
              }),
              selectedIndex: secondOptions.indexOf(second),
              type: 'second',
              onSelect: this.onItemChange,
              onMouseEnter: this.onEnterSelectPanel.bind(this, 'second')
            });
          }
        }, {
          key: 'getAMPMSelect',
          value: function getAMPMSelect() {
            var _props4 = this.props,
                prefixCls = _props4.prefixCls,
                use12Hours = _props4.use12Hours,
                format = _props4.format;

            if (!use12Hours) {
              return null;
            }

            var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
            .map(function (c) {
              return format.match(/\sA/) ? c.toUpperCase() : c;
            }).map(function (c) {
              return {
                value: c
              };
            });
            var selected = this.props.isAM ? 0 : 1;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Select, {
              prefixCls: prefixCls,
              options: AMPMOptions,
              selectedIndex: selected,
              type: 'ampm',
              onSelect: this.onItemChange,
              onMouseEnter: this.onEnterSelectPanel.bind(this, 'ampm')
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var _props5 = this.props,
                prefixCls = _props5.prefixCls,
                defaultOpenValue = _props5.defaultOpenValue;
            var value = this.props.value || defaultOpenValue;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-combobox'
            }, this.getHourSelect(value.hour()), this.getMinuteSelect(value.minute()), this.getSecondSelect(value.second()), this.getAMPMSelect(value.hour()));
          }
        }]);
        return Combobox;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Combobox_Combobox.propTypes = {
        format: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        defaultOpenValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        showHour: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showMinute: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showSecond: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        hourOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        minuteOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        secondOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        disabledHours: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        disabledMinutes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        disabledSeconds: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onCurrentSelectPanelChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        use12Hours: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        isAM: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var es_Combobox = Combobox_Combobox; // CONCATENATED MODULE: ./node_modules/rc-time-picker/es/Panel.js

      function Panel_noop() {}

      function Panel_generateOptions(length, disabledOptions, hideDisabledOptions) {
        var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var arr = [];

        for (var value = 0; value < length; value += step) {
          if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
            arr.push(value);
          }
        }

        return arr;
      }

      var Panel_Panel = function (_Component) {
        inherits_default()(Panel, _Component);

        function Panel(props) {
          classCallCheck_default()(this, Panel);

          var _this = possibleConstructorReturn_default()(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));

          _this.onChange = function (newValue) {
            _this.setState({
              value: newValue
            });

            _this.props.onChange(newValue);
          };

          _this.onCurrentSelectPanelChange = function (currentSelectPanel) {
            _this.setState({
              currentSelectPanel: currentSelectPanel
            });
          };

          _this.disabledHours = function () {
            var _this$props = _this.props,
                use12Hours = _this$props.use12Hours,
                disabledHours = _this$props.disabledHours;
            var disabledOptions = disabledHours();

            if (use12Hours && Array.isArray(disabledOptions)) {
              if (_this.isAM()) {
                disabledOptions = disabledOptions.filter(function (h) {
                  return h < 12;
                }).map(function (h) {
                  return h === 0 ? 12 : h;
                });
              } else {
                disabledOptions = disabledOptions.map(function (h) {
                  return h === 12 ? 12 : h - 12;
                });
              }
            }

            return disabledOptions;
          };

          _this.state = {
            value: props.value,
            selectionRange: []
          };
          return _this;
        }

        createClass_default()(Panel, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var value = nextProps.value;

            if (value) {
              this.setState({
                value: value
              });
            }
          }
        }, {
          key: 'close',
          // https://github.com/ant-design/ant-design/issues/5829
          value: function close() {
            this.props.onEsc();
          }
        }, {
          key: 'isAM',
          value: function isAM() {
            var value = this.state.value || this.props.defaultOpenValue;
            return value.hour() >= 0 && value.hour() < 12;
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                placeholder = _props.placeholder,
                disabledMinutes = _props.disabledMinutes,
                disabledSeconds = _props.disabledSeconds,
                hideDisabledOptions = _props.hideDisabledOptions,
                allowEmpty = _props.allowEmpty,
                showHour = _props.showHour,
                showMinute = _props.showMinute,
                showSecond = _props.showSecond,
                format = _props.format,
                defaultOpenValue = _props.defaultOpenValue,
                clearText = _props.clearText,
                onEsc = _props.onEsc,
                addon = _props.addon,
                use12Hours = _props.use12Hours,
                onClear = _props.onClear,
                focusOnOpen = _props.focusOnOpen,
                onKeyDown = _props.onKeyDown,
                hourStep = _props.hourStep,
                minuteStep = _props.minuteStep,
                secondStep = _props.secondStep,
                inputReadOnly = _props.inputReadOnly;
            var _state = this.state,
                value = _state.value,
                currentSelectPanel = _state.currentSelectPanel;
            var disabledHourOptions = this.disabledHours();
            var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
            var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
            var hourOptions = Panel_generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
            var minuteOptions = Panel_generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
            var secondOptions = Panel_generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-inner', true), defineProperty_default()(_classNames, className, !!className), _classNames))
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Header, {
              clearText: clearText,
              prefixCls: prefixCls,
              defaultOpenValue: defaultOpenValue,
              value: value,
              currentSelectPanel: currentSelectPanel,
              onEsc: onEsc,
              format: format,
              placeholder: placeholder,
              hourOptions: hourOptions,
              minuteOptions: minuteOptions,
              secondOptions: secondOptions,
              disabledHours: this.disabledHours,
              disabledMinutes: disabledMinutes,
              disabledSeconds: disabledSeconds,
              onChange: this.onChange,
              onClear: onClear,
              allowEmpty: allowEmpty,
              focusOnOpen: focusOnOpen,
              onKeyDown: onKeyDown,
              inputReadOnly: inputReadOnly
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Combobox, {
              prefixCls: prefixCls,
              value: value,
              defaultOpenValue: defaultOpenValue,
              format: format,
              onChange: this.onChange,
              showHour: showHour,
              showMinute: showMinute,
              showSecond: showSecond,
              hourOptions: hourOptions,
              minuteOptions: minuteOptions,
              secondOptions: secondOptions,
              disabledHours: this.disabledHours,
              disabledMinutes: disabledMinutes,
              disabledSeconds: disabledSeconds,
              onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
              use12Hours: use12Hours,
              isAM: this.isAM()
            }), addon(this));
          }
        }]);
        return Panel;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Panel_Panel.propTypes = {
        clearText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        defaultOpenValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        format: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputReadOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabledHours: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        disabledMinutes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        disabledSeconds: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        hideDisabledOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onEsc: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        allowEmpty: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showHour: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showMinute: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showSecond: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onClear: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        use12Hours: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        hourStep: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        minuteStep: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        secondStep: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        addon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        focusOnOpen: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onKeyDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      Panel_Panel.defaultProps = {
        prefixCls: 'rc-time-picker-panel',
        onChange: Panel_noop,
        onClear: Panel_noop,
        disabledHours: Panel_noop,
        disabledMinutes: Panel_noop,
        disabledSeconds: Panel_noop,
        defaultOpenValue: moment_default()(),
        use12Hours: false,
        addon: Panel_noop,
        onKeyDown: Panel_noop,
        inputReadOnly: false
      };
      /* harmony default export */

      var rc_time_picker_es_Panel = Panel_Panel; // CONCATENATED MODULE: ./node_modules/rc-time-picker/es/placements.js

      var es_placements_autoAdjustOverflow = {
        adjustX: 1,
        adjustY: 1
      };
      var es_placements_targetOffset = [0, 0];
      var placements_placements = {
        bottomLeft: {
          points: ['tl', 'tl'],
          overflow: es_placements_autoAdjustOverflow,
          offset: [0, -3],
          targetOffset: es_placements_targetOffset
        },
        bottomRight: {
          points: ['tr', 'tr'],
          overflow: es_placements_autoAdjustOverflow,
          offset: [0, -3],
          targetOffset: es_placements_targetOffset
        },
        topRight: {
          points: ['br', 'br'],
          overflow: es_placements_autoAdjustOverflow,
          offset: [0, 3],
          targetOffset: es_placements_targetOffset
        },
        topLeft: {
          points: ['bl', 'bl'],
          overflow: es_placements_autoAdjustOverflow,
          offset: [0, 3],
          targetOffset: es_placements_targetOffset
        }
      };
      /* harmony default export */

      var es_placements = placements_placements; // CONCATENATED MODULE: ./node_modules/rc-time-picker/es/TimePicker.js

      function TimePicker_noop() {}

      function TimePicker_refFn(field, component) {
        this[field] = component;
      }

      var TimePicker_Picker = function (_Component) {
        inherits_default()(Picker, _Component);

        function Picker(props) {
          classCallCheck_default()(this, Picker);

          var _this = possibleConstructorReturn_default()(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));

          TimePicker_initialiseProps.call(_this);
          _this.saveInputRef = TimePicker_refFn.bind(_this, 'picker');
          _this.savePanelRef = TimePicker_refFn.bind(_this, 'panelInstance');
          var defaultOpen = props.defaultOpen,
              defaultValue = props.defaultValue,
              _props$open = props.open,
              open = _props$open === undefined ? defaultOpen : _props$open,
              _props$value = props.value,
              value = _props$value === undefined ? defaultValue : _props$value;
          _this.state = {
            open: open,
            value: value
          };
          return _this;
        }

        createClass_default()(Picker, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var value = nextProps.value,
                open = nextProps.open;

            if ('value' in nextProps) {
              this.setState({
                value: value
              });
            }

            if (open !== undefined) {
              this.setState({
                open: open
              });
            }
          }
        }, {
          key: 'setValue',
          value: function setValue(value) {
            if (!('value' in this.props)) {
              this.setState({
                value: value
              });
            }

            this.props.onChange(value);
          }
        }, {
          key: 'getFormat',
          value: function getFormat() {
            var _props = this.props,
                format = _props.format,
                showHour = _props.showHour,
                showMinute = _props.showMinute,
                showSecond = _props.showSecond,
                use12Hours = _props.use12Hours;

            if (format) {
              return format;
            }

            if (use12Hours) {
              var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
                return !!item;
              }).join(':');
              return fmtString.concat(' a');
            }

            return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
              return !!item;
            }).join(':');
          }
        }, {
          key: 'getPanelElement',
          value: function getPanelElement() {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                placeholder = _props2.placeholder,
                disabledHours = _props2.disabledHours,
                disabledMinutes = _props2.disabledMinutes,
                disabledSeconds = _props2.disabledSeconds,
                hideDisabledOptions = _props2.hideDisabledOptions,
                inputReadOnly = _props2.inputReadOnly,
                allowEmpty = _props2.allowEmpty,
                showHour = _props2.showHour,
                showMinute = _props2.showMinute,
                showSecond = _props2.showSecond,
                defaultOpenValue = _props2.defaultOpenValue,
                clearText = _props2.clearText,
                addon = _props2.addon,
                use12Hours = _props2.use12Hours,
                focusOnOpen = _props2.focusOnOpen,
                onKeyDown = _props2.onKeyDown,
                hourStep = _props2.hourStep,
                minuteStep = _props2.minuteStep,
                secondStep = _props2.secondStep;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_time_picker_es_Panel, {
              clearText: clearText,
              prefixCls: prefixCls + '-panel',
              ref: this.savePanelRef,
              value: this.state.value,
              inputReadOnly: inputReadOnly,
              onChange: this.onPanelChange,
              onClear: this.onPanelClear,
              defaultOpenValue: defaultOpenValue,
              showHour: showHour,
              showMinute: showMinute,
              showSecond: showSecond,
              onEsc: this.onEsc,
              allowEmpty: allowEmpty,
              format: this.getFormat(),
              placeholder: placeholder,
              disabledHours: disabledHours,
              disabledMinutes: disabledMinutes,
              disabledSeconds: disabledSeconds,
              hideDisabledOptions: hideDisabledOptions,
              use12Hours: use12Hours,
              hourStep: hourStep,
              minuteStep: minuteStep,
              secondStep: secondStep,
              addon: addon,
              focusOnOpen: focusOnOpen,
              onKeyDown: onKeyDown
            });
          }
        }, {
          key: 'getPopupClassName',
          value: function getPopupClassName() {
            var _props3 = this.props,
                showHour = _props3.showHour,
                showMinute = _props3.showMinute,
                showSecond = _props3.showSecond,
                use12Hours = _props3.use12Hours,
                prefixCls = _props3.prefixCls;
            var popupClassName = this.props.popupClassName; // Keep it for old compatibility

            if ((!showHour || !showMinute || !showSecond) && !use12Hours) {
              popupClassName += ' ' + prefixCls + '-panel-narrow';
            }

            var selectColumnCount = 0;

            if (showHour) {
              selectColumnCount += 1;
            }

            if (showMinute) {
              selectColumnCount += 1;
            }

            if (showSecond) {
              selectColumnCount += 1;
            }

            if (use12Hours) {
              selectColumnCount += 1;
            }

            popupClassName += ' ' + prefixCls + '-panel-column-' + selectColumnCount;
            return popupClassName;
          }
        }, {
          key: 'setOpen',
          value: function setOpen(open) {
            var _props4 = this.props,
                onOpen = _props4.onOpen,
                onClose = _props4.onClose;

            if (this.state.open !== open) {
              if (!('open' in this.props)) {
                this.setState({
                  open: open
                });
              }

              if (open) {
                onOpen({
                  open: open
                });
              } else {
                onClose({
                  open: open
                });
              }
            }
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.picker.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.picker.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _props5 = this.props,
                prefixCls = _props5.prefixCls,
                placeholder = _props5.placeholder,
                placement = _props5.placement,
                align = _props5.align,
                disabled = _props5.disabled,
                transitionName = _props5.transitionName,
                style = _props5.style,
                className = _props5.className,
                getPopupContainer = _props5.getPopupContainer,
                name = _props5.name,
                autoComplete = _props5.autoComplete,
                onFocus = _props5.onFocus,
                onBlur = _props5.onBlur,
                autoFocus = _props5.autoFocus,
                inputReadOnly = _props5.inputReadOnly;
            var _state = this.state,
                open = _state.open,
                value = _state.value;
            var popupClassName = this.getPopupClassName();
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_trigger_es["default"], {
              prefixCls: prefixCls + '-panel',
              popupClassName: popupClassName,
              popup: this.getPanelElement(),
              popupAlign: align,
              builtinPlacements: es_placements,
              popupPlacement: placement,
              action: disabled ? [] : ['click'],
              destroyPopupOnHide: true,
              getPopupContainer: getPopupContainer,
              popupTransitionName: transitionName,
              popupVisible: open,
              onPopupVisibleChange: this.onVisibleChange
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + ' ' + className,
              style: style
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('input', {
              className: prefixCls + '-input',
              ref: this.saveInputRef,
              type: 'text',
              placeholder: placeholder,
              name: name,
              onKeyDown: this.onKeyDown,
              disabled: disabled,
              value: value && value.format(this.getFormat()) || '',
              autoComplete: autoComplete,
              onFocus: onFocus,
              onBlur: onBlur,
              autoFocus: autoFocus,
              onChange: TimePicker_noop,
              readOnly: !!inputReadOnly
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-icon'
            })));
          }
        }]);
        return Picker;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      TimePicker_Picker.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        clearText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        defaultOpenValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        inputReadOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        allowEmpty: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        open: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultOpen: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        align: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        placement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        transitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        getPopupContainer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        format: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showHour: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showMinute: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showSecond: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        popupClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        disabledHours: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        disabledMinutes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        disabledSeconds: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        hideDisabledOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onOpen: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onClose: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        addon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        name: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        autoComplete: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        use12Hours: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        hourStep: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        minuteStep: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        secondStep: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        focusOnOpen: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onKeyDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        autoFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      TimePicker_Picker.defaultProps = {
        clearText: 'clear',
        prefixCls: 'rc-time-picker',
        defaultOpen: false,
        inputReadOnly: false,
        style: {},
        className: '',
        popupClassName: '',
        align: {},
        defaultOpenValue: moment_default()(),
        allowEmpty: true,
        showHour: true,
        showMinute: true,
        showSecond: true,
        disabledHours: TimePicker_noop,
        disabledMinutes: TimePicker_noop,
        disabledSeconds: TimePicker_noop,
        hideDisabledOptions: false,
        placement: 'bottomLeft',
        onChange: TimePicker_noop,
        onOpen: TimePicker_noop,
        onClose: TimePicker_noop,
        onFocus: TimePicker_noop,
        onBlur: TimePicker_noop,
        addon: TimePicker_noop,
        use12Hours: false,
        focusOnOpen: false,
        onKeyDown: TimePicker_noop
      };

      var TimePicker_initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.onPanelChange = function (value) {
          _this2.setValue(value);
        };

        this.onPanelClear = function () {
          _this2.setValue(null);

          _this2.setOpen(false);
        };

        this.onVisibleChange = function (open) {
          _this2.setOpen(open);
        };

        this.onEsc = function () {
          _this2.setOpen(false);

          _this2.focus();
        };

        this.onKeyDown = function (e) {
          if (e.keyCode === 40) {
            _this2.setOpen(true);
          }
        };
      };
      /* harmony default export */


      var es_TimePicker = TimePicker_Picker; // CONCATENATED MODULE: ./node_modules/antd/es/time-picker/index.js

      function time_picker_generateShowHourMinuteSecond(format) {
        // Ref: http://momentjs.com/docs/#/parsing/string-format/
        return {
          showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
          showMinute: format.indexOf('m') > -1,
          showSecond: format.indexOf('s') > -1
        };
      }

      var time_picker_TimePicker = function (_React$Component) {
        inherits_default()(TimePicker, _React$Component);

        function TimePicker(props) {
          classCallCheck_default()(this, TimePicker);

          var _this = possibleConstructorReturn_default()(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

          _this.handleChange = function (value) {
            if (!('value' in _this.props)) {
              _this.setState({
                value: value
              });
            }

            var _this$props = _this.props,
                onChange = _this$props.onChange,
                _this$props$format = _this$props.format,
                format = _this$props$format === undefined ? 'HH:mm:ss' : _this$props$format;

            if (onChange) {
              onChange(value, value && value.format(format) || '');
            }
          };

          _this.handleOpenClose = function (_ref) {
            var open = _ref.open;
            var onOpenChange = _this.props.onOpenChange;

            if (onOpenChange) {
              onOpenChange(open);
            }
          };

          _this.saveTimePicker = function (timePickerRef) {
            _this.timePickerRef = timePickerRef;
          };

          _this.renderTimePicker = function (locale) {
            var props = extends_default()({}, _this.props);
            delete props.defaultValue;

            var format = _this.getDefaultFormat();

            var className = classnames_default()(props.className, defineProperty_default()({}, props.prefixCls + '-' + props.size, !!props.size));

            var addon = function addon(panel) {
              return props.addon ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: props.prefixCls + '-panel-addon'
              }, props.addon(panel)) : null;
            };

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_TimePicker, extends_default()({}, time_picker_generateShowHourMinuteSecond(format), props, {
              ref: _this.saveTimePicker,
              format: format,
              className: className,
              value: _this.state.value,
              placeholder: props.placeholder === undefined ? locale.placeholder : props.placeholder,
              onChange: _this.handleChange,
              onOpen: _this.handleOpenClose,
              onClose: _this.handleOpenClose,
              addon: addon
            }));
          };

          var value = props.value || props.defaultValue;

          if (value && !interopDefault(moment).isMoment(value)) {
            throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
          }

          _this.state = {
            value: value
          };
          return _this;
        }

        createClass_default()(TimePicker, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
              this.setState({
                value: nextProps.value
              });
            }
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.timePickerRef.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.timePickerRef.blur();
          }
        }, {
          key: 'getDefaultFormat',
          value: function getDefaultFormat() {
            var _props = this.props,
                format = _props.format,
                use12Hours = _props.use12Hours;

            if (format) {
              return format;
            } else if (use12Hours) {
              return 'h:mm:ss a';
            }

            return 'HH:mm:ss';
          }
        }, {
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
              componentName: 'TimePicker',
              defaultLocale: time_picker_locale_en_US
            }, this.renderTimePicker);
          }
        }]);
        return TimePicker;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var time_picker = time_picker_TimePicker;
      time_picker_TimePicker.defaultProps = {
        prefixCls: 'ant-time-picker',
        align: {
          offset: [0, -2]
        },
        disabled: false,
        disabledHours: undefined,
        disabledMinutes: undefined,
        disabledSeconds: undefined,
        hideDisabledOptions: false,
        placement: 'bottomLeft',
        transitionName: 'slide-up',
        focusOnOpen: true
      }; // CONCATENATED MODULE: ./node_modules/antd/es/date-picker/wrapPicker.js

      function wrapPicker_getColumns(_ref) {
        var showHour = _ref.showHour,
            showMinute = _ref.showMinute,
            showSecond = _ref.showSecond,
            use12Hours = _ref.use12Hours;
        var column = 0;

        if (showHour) {
          column += 1;
        }

        if (showMinute) {
          column += 1;
        }

        if (showSecond) {
          column += 1;
        }

        if (use12Hours) {
          column += 1;
        }

        return column;
      }

      function wrapPicker_wrapPicker(Picker, defaultFormat) {
        return _a = function (_React$Component) {
          inherits_default()(PickerWrapper, _React$Component);

          function PickerWrapper() {
            classCallCheck_default()(this, PickerWrapper);

            var _this = possibleConstructorReturn_default()(this, (PickerWrapper.__proto__ || Object.getPrototypeOf(PickerWrapper)).apply(this, arguments));

            _this.handleOpenChange = function (open) {
              var onOpenChange = _this.props.onOpenChange;
              onOpenChange(open);
            };

            _this.handleFocus = function (e) {
              var onFocus = _this.props.onFocus;

              if (onFocus) {
                onFocus(e);
              }
            };

            _this.handleBlur = function (e) {
              var onBlur = _this.props.onBlur;

              if (onBlur) {
                onBlur(e);
              }
            };

            _this.savePicker = function (node) {
              _this.picker = node;
            };

            _this.getDefaultLocale = function () {
              var result = extends_default()({}, date_picker_locale_en_US, _this.props.locale);
              result.lang = extends_default()({}, result.lang, (_this.props.locale || {}).lang);
              return result;
            };

            _this.renderPicker = function (locale, localeCode) {
              var _classNames2;

              var props = _this.props;
              var prefixCls = props.prefixCls,
                  inputPrefixCls = props.inputPrefixCls;
              var pickerClass = classnames_default()(prefixCls + '-picker', defineProperty_default()({}, prefixCls + '-picker-' + props.size, !!props.size));
              var pickerInputClass = classnames_default()(prefixCls + '-picker-input', inputPrefixCls, (_classNames2 = {}, defineProperty_default()(_classNames2, inputPrefixCls + '-lg', props.size === 'large'), defineProperty_default()(_classNames2, inputPrefixCls + '-sm', props.size === 'small'), defineProperty_default()(_classNames2, inputPrefixCls + '-disabled', props.disabled), _classNames2));
              var timeFormat = props.showTime && props.showTime.format || 'HH:mm:ss';
              var rcTimePickerProps = extends_default()({}, time_picker_generateShowHourMinuteSecond(timeFormat), {
                format: timeFormat,
                use12Hours: props.showTime && props.showTime.use12Hours
              });
              var columns = wrapPicker_getColumns(rcTimePickerProps);
              var timePickerCls = prefixCls + '-time-picker-column-' + columns;
              var timePicker = props.showTime ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_time_picker_es_Panel, extends_default()({}, rcTimePickerProps, props.showTime, {
                prefixCls: prefixCls + '-time-picker',
                className: timePickerCls,
                placeholder: locale.timePickerLocale.placeholder,
                transitionName: 'slide-up'
              })) : null;
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Picker, extends_default()({}, props, {
                ref: _this.savePicker,
                pickerClass: pickerClass,
                pickerInputClass: pickerInputClass,
                locale: locale,
                localeCode: localeCode,
                timePicker: timePicker,
                onOpenChange: _this.handleOpenChange,
                onFocus: _this.handleFocus,
                onBlur: _this.handleBlur
              }));
            };

            return _this;
          }

          createClass_default()(PickerWrapper, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              var _props = this.props,
                  autoFocus = _props.autoFocus,
                  disabled = _props.disabled;

              if (autoFocus && !disabled) {
                this.focus();
              }
            }
          }, {
            key: 'focus',
            value: function focus() {
              this.picker.focus();
            }
          }, {
            key: 'blur',
            value: function blur() {
              this.picker.blur();
            }
          }, {
            key: 'render',
            value: function render() {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
                componentName: 'DatePicker',
                defaultLocale: this.getDefaultLocale
              }, this.renderPicker);
            }
          }]);
          return PickerWrapper;
        }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]), _a.defaultProps = {
          format: defaultFormat || 'YYYY-MM-DD',
          transitionName: 'slide-up',
          popupStyle: {},
          onChange: function onChange() {},
          onOk: function onOk() {},
          onOpenChange: function onOpenChange() {},
          locale: {},
          prefixCls: 'ant-calendar',
          inputPrefixCls: 'ant-input'
        }, _a;

        var _a;
      } // EXTERNAL MODULE: ./node_modules/rc-calendar/es/date/DateInput.js


      var DateInput = __webpack_require__(285); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/range-calendar/CalendarPart.js


      var CalendarPart_CalendarPart = create_react_class_default()({
        displayName: 'CalendarPart',
        propTypes: {
          prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          hoverValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          selectedValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          direction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          showDateInput: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          showTimePicker: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          format: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          disabledDate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          timePicker: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          disabledTime: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          onInputSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          timePickerDisabledTime: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          enableNext: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          enablePrev: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
        },
        render: function render() {
          var props = this.props;
          var prefixCls = props.prefixCls,
              value = props.value,
              hoverValue = props.hoverValue,
              selectedValue = props.selectedValue,
              mode = props.mode,
              direction = props.direction,
              locale = props.locale,
              format = props.format,
              placeholder = props.placeholder,
              disabledDate = props.disabledDate,
              timePicker = props.timePicker,
              disabledTime = props.disabledTime,
              timePickerDisabledTime = props.timePickerDisabledTime,
              showTimePicker = props.showTimePicker,
              onInputSelect = props.onInputSelect,
              enablePrev = props.enablePrev,
              enableNext = props.enableNext;
          var shouldShowTimePicker = showTimePicker && timePicker;
          var disabledTimeConfig = shouldShowTimePicker && disabledTime ? Object(util["b"
          /* getTimeConfig */
          ])(selectedValue, disabledTime) : null;
          var rangeClassName = prefixCls + '-range';
          var newProps = {
            locale: locale,
            value: value,
            prefixCls: prefixCls,
            showTimePicker: showTimePicker
          };
          var index = direction === 'left' ? 0 : 1;
          var timePickerEle = shouldShowTimePicker && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(timePicker, extends_default()({
            showHour: true,
            showMinute: true,
            showSecond: true
          }, timePicker.props, disabledTimeConfig, timePickerDisabledTime, {
            onChange: onInputSelect,
            defaultOpenValue: value,
            value: selectedValue[index]
          }));
          var dateInputElement = props.showDateInput && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(DateInput["a"
          /* default */
          ], {
            format: format,
            locale: locale,
            prefixCls: prefixCls,
            timePicker: timePicker,
            disabledDate: disabledDate,
            placeholder: placeholder,
            disabledTime: disabledTime,
            value: value,
            showClear: false,
            selectedValue: selectedValue[index],
            onChange: onInputSelect
          });
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: rangeClassName + '-part ' + rangeClassName + '-' + direction
          }, dateInputElement, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            style: {
              outline: 'none'
            }
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(calendar_CalendarHeader["a"
          /* default */
          ], extends_default()({}, newProps, {
            mode: mode,
            enableNext: enableNext,
            enablePrev: enablePrev,
            onValueChange: props.onValueChange,
            onPanelChange: props.onPanelChange,
            disabledMonth: props.disabledMonth
          })), showTimePicker ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-time-picker'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-time-picker-panel'
          }, timePickerEle)) : null, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-body'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(DateTable["a"
          /* default */
          ], extends_default()({}, newProps, {
            hoverValue: hoverValue,
            selectedValue: selectedValue,
            dateRender: props.dateRender,
            onSelect: props.onSelect,
            onDayHover: props.onDayHover,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          })))));
        }
      });
      /* harmony default export */

      var range_calendar_CalendarPart = CalendarPart_CalendarPart; // EXTERNAL MODULE: ./node_modules/rc-calendar/es/calendar/TodayButton.js

      var TodayButton = __webpack_require__(288); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/calendar/OkButton.js


      var OkButton = __webpack_require__(287); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/calendar/TimePickerButton.js


      var TimePickerButton = __webpack_require__(286); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/util/toTime.js


      var toTime = __webpack_require__(86); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/RangeCalendar.js


      function RangeCalendar_noop() {}

      function RangeCalendar_isEmptyArray(arr) {
        return Array.isArray(arr) && (arr.length === 0 || arr.every(function (i) {
          return !i;
        }));
      }

      function RangeCalendar_isArraysEqual(a, b) {
        if (a === b) return true;

        if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
          return false;
        }

        if (a.length !== b.length) return false;

        for (var i = 0; i < a.length; ++i) {
          if (a[i] !== b[i]) return false;
        }

        return true;
      }

      function RangeCalendar_getValueFromSelectedValue(selectedValue) {
        var start = selectedValue[0],
            end = selectedValue[1];
        var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
        return [start, newEnd];
      }

      function RangeCalendar_normalizeAnchor(props, init) {
        var selectedValue = props.selectedValue || init && props.defaultSelectedValue;
        var value = props.value || init && props.defaultValue;
        var normalizedValue = value ? RangeCalendar_getValueFromSelectedValue(value) : RangeCalendar_getValueFromSelectedValue(selectedValue);
        return !RangeCalendar_isEmptyArray(normalizedValue) ? normalizedValue : init && [moment_default()(), moment_default()().add(1, 'months')];
      }

      function RangeCalendar_generateOptions(length, extraOptionGen) {
        var arr = extraOptionGen ? extraOptionGen().concat() : [];

        for (var value = 0; value < length; value++) {
          if (arr.indexOf(value) === -1) {
            arr.push(value);
          }
        }

        return arr;
      }

      function RangeCalendar_onInputSelect(direction, value) {
        if (!value) {
          return;
        }

        var originalValue = this.state.selectedValue;
        var selectedValue = originalValue.concat();
        var index = direction === 'left' ? 0 : 1;
        selectedValue[index] = value;

        if (selectedValue[0] && this.compare(selectedValue[0], selectedValue[1]) > 0) {
          selectedValue[1 - index] = this.state.showTimePicker ? selectedValue[index] : undefined;
        }

        this.props.onInputSelect(selectedValue);
        this.fireSelectValueChange(selectedValue);
      }

      var RangeCalendar_RangeCalendar = create_react_class_default()({
        displayName: 'RangeCalendar',
        propTypes: {
          prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          dateInputPlaceholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          hoverValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          mode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['date', 'month', 'year', 'decade'])),
          showDateInput: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          timePicker: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          showOk: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          showToday: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          defaultSelectedValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          selectedValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          onOk: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          showClear: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onValueChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onHoverChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onPanelChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          format: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
          onClear: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          disabledDate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          disabledTime: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        },
        mixins: [CommonMixin["a"
        /* default */
        ]],
        getDefaultProps: function getDefaultProps() {
          return {
            type: 'both',
            defaultSelectedValue: [],
            onValueChange: RangeCalendar_noop,
            onHoverChange: RangeCalendar_noop,
            onPanelChange: RangeCalendar_noop,
            disabledTime: RangeCalendar_noop,
            onInputSelect: RangeCalendar_noop,
            showToday: true,
            showDateInput: true
          };
        },
        getInitialState: function getInitialState() {
          var props = this.props;
          var selectedValue = props.selectedValue || props.defaultSelectedValue;
          var value = RangeCalendar_normalizeAnchor(props, 1);
          return {
            selectedValue: selectedValue,
            prevSelectedValue: selectedValue,
            firstSelectedValue: null,
            hoverValue: props.hoverValue || [],
            value: value,
            showTimePicker: false,
            mode: props.mode || ['date', 'date']
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          var state = this.state;
          var newState = {};

          if ('value' in nextProps) {
            newState.value = RangeCalendar_normalizeAnchor(nextProps, 0);
            this.setState(newState);
          }

          if ('hoverValue' in nextProps && !RangeCalendar_isArraysEqual(state.hoverValue, nextProps.hoverValue)) {
            this.setState({
              hoverValue: nextProps.hoverValue
            });
          }

          if ('selectedValue' in nextProps) {
            newState.selectedValue = nextProps.selectedValue;
            newState.prevSelectedValue = nextProps.selectedValue;
            this.setState(newState);
          }

          if ('mode' in nextProps && !RangeCalendar_isArraysEqual(state.mode, nextProps.mode)) {
            this.setState({
              mode: nextProps.mode
            });
          }
        },
        onDatePanelEnter: function onDatePanelEnter() {
          if (this.hasSelectedValue()) {
            this.fireHoverValueChange(this.state.selectedValue.concat());
          }
        },
        onDatePanelLeave: function onDatePanelLeave() {
          if (this.hasSelectedValue()) {
            this.fireHoverValueChange([]);
          }
        },
        onSelect: function onSelect(value) {
          var type = this.props.type;
          var _state = this.state,
              selectedValue = _state.selectedValue,
              prevSelectedValue = _state.prevSelectedValue,
              firstSelectedValue = _state.firstSelectedValue;
          var nextSelectedValue = void 0;

          if (type === 'both') {
            if (!firstSelectedValue) {
              Object(util["g"
              /* syncTime */
              ])(prevSelectedValue[0], value);
              nextSelectedValue = [value];
            } else if (this.compare(firstSelectedValue, value) < 0) {
              Object(util["g"
              /* syncTime */
              ])(prevSelectedValue[1], value);
              nextSelectedValue = [firstSelectedValue, value];
            } else {
              Object(util["g"
              /* syncTime */
              ])(prevSelectedValue[0], value);
              Object(util["g"
              /* syncTime */
              ])(prevSelectedValue[1], firstSelectedValue);
              nextSelectedValue = [value, firstSelectedValue];
            }
          } else if (type === 'start') {
            Object(util["g"
            /* syncTime */
            ])(prevSelectedValue[0], value);
            var endValue = selectedValue[1];
            nextSelectedValue = endValue && this.compare(endValue, value) > 0 ? [value, endValue] : [value];
          } else {
            // type === 'end'
            var startValue = selectedValue[0];

            if (startValue && this.compare(startValue, value) <= 0) {
              Object(util["g"
              /* syncTime */
              ])(prevSelectedValue[1], value);
              nextSelectedValue = [startValue, value];
            } else {
              Object(util["g"
              /* syncTime */
              ])(prevSelectedValue[0], value);
              nextSelectedValue = [value];
            }
          }

          this.fireSelectValueChange(nextSelectedValue);
        },
        onKeyDown: function onKeyDown(event) {
          var _this = this;

          if (event.target.nodeName.toLowerCase() === 'input') {
            return;
          }

          var keyCode = event.keyCode;
          var ctrlKey = event.ctrlKey || event.metaKey;
          var _state2 = this.state,
              selectedValue = _state2.selectedValue,
              hoverValue = _state2.hoverValue,
              firstSelectedValue = _state2.firstSelectedValue,
              value = _state2.value;
          var _props = this.props,
              onKeyDown = _props.onKeyDown,
              disabledDate = _props.disabledDate; // Update last time of the picker

          var updateHoverPoint = function updateHoverPoint(func) {
            // Change hover to make focus in UI
            var currentHoverTime = void 0;
            var nextHoverTime = void 0;
            var nextHoverValue = void 0;

            if (!firstSelectedValue) {
              currentHoverTime = hoverValue[0] || selectedValue[0] || value[0] || moment_default()();
              nextHoverTime = func(currentHoverTime);
              nextHoverValue = [nextHoverTime];

              _this.fireHoverValueChange(nextHoverValue);
            } else {
              if (hoverValue.length === 1) {
                currentHoverTime = hoverValue[0].clone();
                nextHoverTime = func(currentHoverTime);
                nextHoverValue = _this.onDayHover(nextHoverTime);
              } else {
                currentHoverTime = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
                nextHoverTime = func(currentHoverTime);
                nextHoverValue = _this.onDayHover(nextHoverTime);
              }
            } // Find origin hover time on value index


            if (nextHoverValue.length >= 2) {
              var miss = nextHoverValue.some(function (ht) {
                return !Object(toTime["d"
                /* includesTime */
                ])(value, ht, 'month');
              });

              if (miss) {
                var newValue = nextHoverValue.slice().sort(function (t1, t2) {
                  return t1.valueOf() - t2.valueOf();
                });

                if (newValue[0].isSame(newValue[1], 'month')) {
                  newValue[1] = newValue[0].clone().add(1, 'month');
                }

                _this.fireValueChange(newValue);
              }
            } else if (nextHoverValue.length === 1) {
              // If only one value, let's keep the origin panel
              var oriValueIndex = value.findIndex(function (time) {
                return time.isSame(currentHoverTime, 'month');
              });
              if (oriValueIndex === -1) oriValueIndex = 0;

              if (value.every(function (time) {
                return !time.isSame(nextHoverTime, 'month');
              })) {
                var _newValue = value.slice();

                _newValue[oriValueIndex] = nextHoverTime.clone();

                _this.fireValueChange(_newValue);
              }
            }

            event.preventDefault();
            return nextHoverTime;
          };

          switch (keyCode) {
            case es_KeyCode["a"
            /* default */
            ].DOWN:
              updateHoverPoint(function (time) {
                return Object(toTime["c"
                /* goTime */
                ])(time, 1, 'weeks');
              });
              return;

            case es_KeyCode["a"
            /* default */
            ].UP:
              updateHoverPoint(function (time) {
                return Object(toTime["c"
                /* goTime */
                ])(time, -1, 'weeks');
              });
              return;

            case es_KeyCode["a"
            /* default */
            ].LEFT:
              if (ctrlKey) {
                updateHoverPoint(function (time) {
                  return Object(toTime["c"
                  /* goTime */
                  ])(time, -1, 'years');
                });
              } else {
                updateHoverPoint(function (time) {
                  return Object(toTime["c"
                  /* goTime */
                  ])(time, -1, 'days');
                });
              }

              return;

            case es_KeyCode["a"
            /* default */
            ].RIGHT:
              if (ctrlKey) {
                updateHoverPoint(function (time) {
                  return Object(toTime["c"
                  /* goTime */
                  ])(time, 1, 'years');
                });
              } else {
                updateHoverPoint(function (time) {
                  return Object(toTime["c"
                  /* goTime */
                  ])(time, 1, 'days');
                });
              }

              return;

            case es_KeyCode["a"
            /* default */
            ].HOME:
              updateHoverPoint(function (time) {
                return Object(toTime["b"
                /* goStartMonth */
                ])(time);
              });
              return;

            case es_KeyCode["a"
            /* default */
            ].END:
              updateHoverPoint(function (time) {
                return Object(toTime["a"
                /* goEndMonth */
                ])(time);
              });
              return;

            case es_KeyCode["a"
            /* default */
            ].PAGE_DOWN:
              updateHoverPoint(function (time) {
                return Object(toTime["c"
                /* goTime */
                ])(time, 1, 'month');
              });
              return;

            case es_KeyCode["a"
            /* default */
            ].PAGE_UP:
              updateHoverPoint(function (time) {
                return Object(toTime["c"
                /* goTime */
                ])(time, -1, 'month');
              });
              return;

            case es_KeyCode["a"
            /* default */
            ].ENTER:
              {
                var lastValue = void 0;

                if (hoverValue.length === 0) {
                  lastValue = updateHoverPoint(function (time) {
                    return time;
                  });
                } else if (hoverValue.length === 1) {
                  lastValue = hoverValue[0];
                } else {
                  lastValue = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
                }

                if (lastValue && (!disabledDate || !disabledDate(lastValue))) {
                  this.onSelect(lastValue);
                }

                event.preventDefault();
                return;
              }

            default:
              if (onKeyDown) {
                onKeyDown(event);
              }

          }
        },
        onDayHover: function onDayHover(value) {
          var hoverValue = [];
          var _state3 = this.state,
              selectedValue = _state3.selectedValue,
              firstSelectedValue = _state3.firstSelectedValue;
          var type = this.props.type;

          if (type === 'start' && selectedValue[1]) {
            hoverValue = this.compare(value, selectedValue[1]) < 0 ? [value, selectedValue[1]] : [value];
          } else if (type === 'end' && selectedValue[0]) {
            hoverValue = this.compare(value, selectedValue[0]) > 0 ? [selectedValue[0], value] : [];
          } else {
            if (!firstSelectedValue) {
              if (this.state.hoverValue.length) {
                this.setState({
                  hoverValue: []
                });
              }

              return hoverValue;
            }

            hoverValue = this.compare(value, firstSelectedValue) < 0 ? [value, firstSelectedValue] : [firstSelectedValue, value];
          }

          this.fireHoverValueChange(hoverValue);
          return hoverValue;
        },
        onToday: function onToday() {
          var startValue = Object(util["d"
          /* getTodayTime */
          ])(this.state.value[0]);
          var endValue = startValue.clone().add(1, 'months');
          this.setState({
            value: [startValue, endValue]
          });
        },
        onOpenTimePicker: function onOpenTimePicker() {
          this.setState({
            showTimePicker: true
          });
        },
        onCloseTimePicker: function onCloseTimePicker() {
          this.setState({
            showTimePicker: false
          });
        },
        onOk: function onOk() {
          var selectedValue = this.state.selectedValue;

          if (this.isAllowedDateAndTime(selectedValue)) {
            this.props.onOk(this.state.selectedValue);
          }
        },
        onStartInputSelect: function onStartInputSelect() {
          for (var _len = arguments.length, oargs = Array(_len), _key = 0; _key < _len; _key++) {
            oargs[_key] = arguments[_key];
          }

          var args = ['left'].concat(oargs);
          return RangeCalendar_onInputSelect.apply(this, args);
        },
        onEndInputSelect: function onEndInputSelect() {
          for (var _len2 = arguments.length, oargs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            oargs[_key2] = arguments[_key2];
          }

          var args = ['right'].concat(oargs);
          return RangeCalendar_onInputSelect.apply(this, args);
        },
        onStartValueChange: function onStartValueChange(leftValue) {
          var value = [].concat(this.state.value);
          value[0] = leftValue;
          return this.fireValueChange(value);
        },
        onEndValueChange: function onEndValueChange(rightValue) {
          var value = [].concat(this.state.value);
          value[1] = rightValue;
          return this.fireValueChange(value);
        },
        onStartPanelChange: function onStartPanelChange(value, mode) {
          var props = this.props,
              state = this.state;
          var newMode = [mode, state.mode[1]];

          if (!('mode' in props)) {
            this.setState({
              mode: newMode
            });
          }

          var newValue = [value || state.value[0], state.value[1]];
          props.onPanelChange(newValue, newMode);
        },
        onEndPanelChange: function onEndPanelChange(value, mode) {
          var props = this.props,
              state = this.state;
          var newMode = [state.mode[0], mode];

          if (!('mode' in props)) {
            this.setState({
              mode: newMode
            });
          }

          var newValue = [state.value[0], value || state.value[1]];
          props.onPanelChange(newValue, newMode);
        },
        getStartValue: function getStartValue() {
          var value = this.state.value[0];
          var selectedValue = this.state.selectedValue; // keep selectedTime when select date

          if (selectedValue[0] && this.props.timePicker) {
            value = value.clone();
            Object(util["g"
            /* syncTime */
            ])(selectedValue[0], value);
          }

          if (this.state.showTimePicker && selectedValue[0]) {
            return selectedValue[0];
          }

          return value;
        },
        getEndValue: function getEndValue() {
          var _state4 = this.state,
              value = _state4.value,
              selectedValue = _state4.selectedValue,
              showTimePicker = _state4.showTimePicker;
          var endValue = value[1] ? value[1].clone() : value[0].clone().add(1, 'month'); // keep selectedTime when select date

          if (selectedValue[1] && this.props.timePicker) {
            Object(util["g"
            /* syncTime */
            ])(selectedValue[1], endValue);
          }

          if (showTimePicker) {
            return selectedValue[1] ? selectedValue[1] : this.getStartValue();
          }

          return endValue;
        },
        // get disabled hours for second picker
        getEndDisableTime: function getEndDisableTime() {
          var _state5 = this.state,
              selectedValue = _state5.selectedValue,
              value = _state5.value;
          var disabledTime = this.props.disabledTime;
          var userSettingDisabledTime = disabledTime(selectedValue, 'end') || {};
          var startValue = selectedValue && selectedValue[0] || value[0].clone(); // if startTime and endTime is same day..
          // the second time picker will not able to pick time before first time picker

          if (!selectedValue[1] || startValue.isSame(selectedValue[1], 'day')) {
            var hours = startValue.hour();
            var minutes = startValue.minute();
            var second = startValue.second();
            var _disabledHours = userSettingDisabledTime.disabledHours,
                _disabledMinutes = userSettingDisabledTime.disabledMinutes,
                _disabledSeconds = userSettingDisabledTime.disabledSeconds;
            var oldDisabledMinutes = _disabledMinutes ? _disabledMinutes() : [];
            var olddisabledSeconds = _disabledSeconds ? _disabledSeconds() : [];
            _disabledHours = RangeCalendar_generateOptions(hours, _disabledHours);
            _disabledMinutes = RangeCalendar_generateOptions(minutes, _disabledMinutes);
            _disabledSeconds = RangeCalendar_generateOptions(second, _disabledSeconds);
            return {
              disabledHours: function disabledHours() {
                return _disabledHours;
              },
              disabledMinutes: function disabledMinutes(hour) {
                if (hour === hours) {
                  return _disabledMinutes;
                }

                return oldDisabledMinutes;
              },
              disabledSeconds: function disabledSeconds(hour, minute) {
                if (hour === hours && minute === minutes) {
                  return _disabledSeconds;
                }

                return olddisabledSeconds;
              }
            };
          }

          return userSettingDisabledTime;
        },
        isAllowedDateAndTime: function isAllowedDateAndTime(selectedValue) {
          return Object(util["f"
          /* isAllowedDate */
          ])(selectedValue[0], this.props.disabledDate, this.disabledStartTime) && Object(util["f"
          /* isAllowedDate */
          ])(selectedValue[1], this.props.disabledDate, this.disabledEndTime);
        },
        isMonthYearPanelShow: function isMonthYearPanelShow(mode) {
          return ['month', 'year', 'decade'].indexOf(mode) > -1;
        },
        hasSelectedValue: function hasSelectedValue() {
          var selectedValue = this.state.selectedValue;
          return !!selectedValue[1] && !!selectedValue[0];
        },
        compare: function compare(v1, v2) {
          if (this.props.timePicker) {
            return v1.diff(v2);
          }

          return v1.diff(v2, 'days');
        },
        fireSelectValueChange: function fireSelectValueChange(selectedValue, direct) {
          var timePicker = this.props.timePicker;
          var prevSelectedValue = this.state.prevSelectedValue;

          if (timePicker && timePicker.props.defaultValue) {
            var timePickerDefaultValue = timePicker.props.defaultValue;

            if (!prevSelectedValue[0] && selectedValue[0]) {
              Object(util["g"
              /* syncTime */
              ])(timePickerDefaultValue[0], selectedValue[0]);
            }

            if (!prevSelectedValue[1] && selectedValue[1]) {
              Object(util["g"
              /* syncTime */
              ])(timePickerDefaultValue[1], selectedValue[1]);
            }
          }

          if (!('selectedValue' in this.props)) {
            this.setState({
              selectedValue: selectedValue
            });
          } // 尚未选择过时间，直接输入的话


          if (!this.state.selectedValue[0] || !this.state.selectedValue[1]) {
            var startValue = selectedValue[0] || moment_default()();
            var endValue = selectedValue[1] || startValue.clone().add(1, 'months');
            this.setState({
              selectedValue: selectedValue,
              value: RangeCalendar_getValueFromSelectedValue([startValue, endValue])
            });
          }

          if (selectedValue[0] && !selectedValue[1]) {
            this.setState({
              firstSelectedValue: selectedValue[0]
            });
            this.fireHoverValueChange(selectedValue.concat());
          }

          this.props.onChange(selectedValue);

          if (direct || selectedValue[0] && selectedValue[1]) {
            this.setState({
              prevSelectedValue: selectedValue,
              firstSelectedValue: null
            });
            this.fireHoverValueChange([]);
            this.props.onSelect(selectedValue);
          }
        },
        fireValueChange: function fireValueChange(value) {
          var props = this.props;

          if (!('value' in props)) {
            this.setState({
              value: value
            });
          }

          props.onValueChange(value);
        },
        fireHoverValueChange: function fireHoverValueChange(hoverValue) {
          var props = this.props;

          if (!('hoverValue' in props)) {
            this.setState({
              hoverValue: hoverValue
            });
          }

          props.onHoverChange(hoverValue);
        },
        clear: function clear() {
          this.fireSelectValueChange([], true);
          this.props.onClear();
        },
        disabledStartTime: function disabledStartTime(time) {
          return this.props.disabledTime(time, 'start');
        },
        disabledEndTime: function disabledEndTime(time) {
          return this.props.disabledTime(time, 'end');
        },
        disabledStartMonth: function disabledStartMonth(month) {
          var value = this.state.value;
          return month.isSameOrAfter(value[1], 'month');
        },
        disabledEndMonth: function disabledEndMonth(month) {
          var value = this.state.value;
          return month.isSameOrBefore(value[0], 'month');
        },
        render: function render() {
          var _className, _classnames;

          var props = this.props,
              state = this.state;
          var prefixCls = props.prefixCls,
              dateInputPlaceholder = props.dateInputPlaceholder,
              timePicker = props.timePicker,
              showOk = props.showOk,
              locale = props.locale,
              showClear = props.showClear,
              showToday = props.showToday,
              type = props.type;
          var hoverValue = state.hoverValue,
              selectedValue = state.selectedValue,
              mode = state.mode,
              showTimePicker = state.showTimePicker;
          var className = (_className = {}, _className[props.className] = !!props.className, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[prefixCls + '-range'] = 1, _className[prefixCls + '-show-time-picker'] = showTimePicker, _className[prefixCls + '-week-number'] = props.showWeekNumber, _className);
          var classes = classnames_default()(className);
          var newProps = {
            selectedValue: state.selectedValue,
            onSelect: this.onSelect,
            onDayHover: type === 'start' && selectedValue[1] || type === 'end' && selectedValue[0] || !!hoverValue.length ? this.onDayHover : undefined
          };
          var placeholder1 = void 0;
          var placeholder2 = void 0;

          if (dateInputPlaceholder) {
            if (Array.isArray(dateInputPlaceholder)) {
              placeholder1 = dateInputPlaceholder[0];
              placeholder2 = dateInputPlaceholder[1];
            } else {
              placeholder1 = placeholder2 = dateInputPlaceholder;
            }
          }

          var showOkButton = showOk === true || showOk !== false && !!timePicker;
          var cls = classnames_default()((_classnames = {}, _classnames[prefixCls + '-footer'] = true, _classnames[prefixCls + '-range-bottom'] = true, _classnames[prefixCls + '-footer-show-ok'] = showOkButton, _classnames));
          var startValue = this.getStartValue();
          var endValue = this.getEndValue();
          var todayTime = Object(util["d"
          /* getTodayTime */
          ])(startValue);
          var thisMonth = todayTime.month();
          var thisYear = todayTime.year();
          var isTodayInView = startValue.year() === thisYear && startValue.month() === thisMonth || endValue.year() === thisYear && endValue.month() === thisMonth;
          var nextMonthOfStart = startValue.clone().add(1, 'months');
          var isClosestMonths = nextMonthOfStart.year() === endValue.year() && nextMonthOfStart.month() === endValue.month(); // console.warn('Render:', selectedValue.map(t => t.format('YYYY-MM-DD')).join(', '));
          // console.log('start:', startValue.format('YYYY-MM-DD'));
          // console.log('end:', endValue.format('YYYY-MM-DD'));

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            ref: this.saveRoot,
            className: classes,
            style: props.style,
            tabIndex: '0',
            onKeyDown: this.onKeyDown
          }, props.renderSidebar(), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-panel'
          }, showClear && selectedValue[0] && selectedValue[1] ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-clear-btn',
            role: 'button',
            title: locale.clear,
            onClick: this.clear
          }) : null, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-date-panel',
            onMouseLeave: type !== 'both' ? this.onDatePanelLeave : undefined,
            onMouseEnter: type !== 'both' ? this.onDatePanelEnter : undefined
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(range_calendar_CalendarPart, extends_default()({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'left',
            disabledTime: this.disabledStartTime,
            disabledMonth: this.disabledStartMonth,
            format: this.getFormat(),
            value: startValue,
            mode: mode[0],
            placeholder: placeholder1,
            onInputSelect: this.onStartInputSelect,
            onValueChange: this.onStartValueChange,
            onPanelChange: this.onStartPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker,
            enablePrev: true,
            enableNext: !isClosestMonths || this.isMonthYearPanelShow(mode[1])
          })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: prefixCls + '-range-middle'
          }, '~'), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(range_calendar_CalendarPart, extends_default()({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'right',
            format: this.getFormat(),
            timePickerDisabledTime: this.getEndDisableTime(),
            placeholder: placeholder2,
            value: endValue,
            mode: mode[1],
            onInputSelect: this.onEndInputSelect,
            onValueChange: this.onEndValueChange,
            onPanelChange: this.onEndPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker,
            disabledTime: this.disabledEndTime,
            disabledMonth: this.disabledEndMonth,
            enablePrev: !isClosestMonths || this.isMonthYearPanelShow(mode[0]),
            enableNext: true
          }))), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: cls
          }, props.renderFooter(), showToday || props.timePicker || showOkButton ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-footer-btn'
          }, showToday ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(TodayButton["a"
          /* default */
          ], extends_default()({}, props, {
            disabled: isTodayInView,
            value: state.value[0],
            onToday: this.onToday,
            text: locale.backToToday
          })) : null, props.timePicker ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(TimePickerButton["a"
          /* default */
          ], extends_default()({}, props, {
            showTimePicker: showTimePicker,
            onOpenTimePicker: this.onOpenTimePicker,
            onCloseTimePicker: this.onCloseTimePicker,
            timePickerDisabled: !this.hasSelectedValue() || hoverValue.length
          })) : null, showOkButton ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(OkButton["a"
          /* default */
          ], extends_default()({}, props, {
            onOk: this.onOk,
            okDisabled: !this.isAllowedDateAndTime(selectedValue) || !this.hasSelectedValue() || hoverValue.length
          })) : null) : null)));
        }
      });
      /* harmony default export */

      var es_RangeCalendar = RangeCalendar_RangeCalendar; // CONCATENATED MODULE: ./node_modules/antd/es/date-picker/RangePicker.js

      /* tslint:disable jsx-no-multiline-js */

      function RangePicker_getShowDateFromValue(value) {
        var _value = slicedToArray_default()(value, 2),
            start = _value[0],
            end = _value[1]; // value could be an empty array, then we should not reset showDate


        if (!start && !end) {
          return;
        }

        var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
        return [start, newEnd];
      }

      function RangePicker_formatValue(value, format) {
        return value && value.format(format) || '';
      }

      function RangePicker_pickerValueAdapter(value) {
        if (!value) {
          return;
        }

        if (Array.isArray(value)) {
          return value;
        }

        return [value, value.clone().add(1, 'month')];
      }

      function RangePicker_isEmptyArray(arr) {
        if (Array.isArray(arr)) {
          return arr.length === 0 || arr.every(function (i) {
            return !i;
          });
        }

        return false;
      }

      function RangePicker_fixLocale(value, localeCode) {
        if (!localeCode) {
          return;
        }

        if (!value || value.length === 0) {
          return;
        }

        if (value[0]) {
          value[0].locale(localeCode);
        }

        if (value[1]) {
          value[1].locale(localeCode);
        }
      }

      var RangePicker_RangePicker = function (_React$Component) {
        inherits_default()(RangePicker, _React$Component);

        function RangePicker(props) {
          classCallCheck_default()(this, RangePicker);

          var _this = possibleConstructorReturn_default()(this, (RangePicker.__proto__ || Object.getPrototypeOf(RangePicker)).call(this, props));

          _this.clearSelection = function (e) {
            e.preventDefault();
            e.stopPropagation();

            _this.setState({
              value: []
            });

            _this.handleChange([]);
          };

          _this.clearHoverValue = function () {
            return _this.setState({
              hoverValue: []
            });
          };

          _this.handleChange = function (value) {
            var props = _this.props;

            if (!('value' in props)) {
              _this.setState(function (_ref) {
                var showDate = _ref.showDate;
                return {
                  value: value,
                  showDate: RangePicker_getShowDateFromValue(value) || showDate
                };
              });
            }

            props.onChange(value, [RangePicker_formatValue(value[0], props.format), RangePicker_formatValue(value[1], props.format)]);
          };

          _this.handleOpenChange = function (open) {
            if (!('open' in _this.props)) {
              _this.setState({
                open: open
              });
            }

            if (open === false) {
              _this.clearHoverValue();
            }

            var onOpenChange = _this.props.onOpenChange;

            if (onOpenChange) {
              onOpenChange(open);
            }
          };

          _this.handleShowDateChange = function (showDate) {
            return _this.setState({
              showDate: showDate
            });
          };

          _this.handleHoverChange = function (hoverValue) {
            return _this.setState({
              hoverValue: hoverValue
            });
          };

          _this.handleRangeMouseLeave = function () {
            if (_this.state.open) {
              _this.clearHoverValue();
            }
          };

          _this.handleCalendarInputSelect = function (value) {
            if (!value[0]) {
              return;
            }

            _this.setState(function (_ref2) {
              var showDate = _ref2.showDate;
              return {
                value: value,
                showDate: RangePicker_getShowDateFromValue(value) || showDate
              };
            });
          };

          _this.handleRangeClick = function (value) {
            if (typeof value === 'function') {
              value = value();
            }

            _this.setValue(value, true);

            var onOk = _this.props.onOk;

            if (onOk) {
              onOk(value);
            }
          };

          _this.savePicker = function (node) {
            _this.picker = node;
          };

          _this.renderFooter = function () {
            var _this$props = _this.props,
                prefixCls = _this$props.prefixCls,
                ranges = _this$props.ranges,
                renderExtraFooter = _this$props.renderExtraFooter;

            if (!ranges && !renderExtraFooter) {
              return null;
            }

            var customFooter = renderExtraFooter ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-footer-extra',
              key: 'extra'
            }, renderExtraFooter.apply(undefined, arguments)) : null;
            var operations = Object.keys(ranges || {}).map(function (range) {
              var value = ranges[range];
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', {
                key: range,
                onClick: function onClick() {
                  return _this.handleRangeClick(value);
                },
                onMouseEnter: function onMouseEnter() {
                  return _this.setState({
                    hoverValue: value
                  });
                },
                onMouseLeave: _this.handleRangeMouseLeave
              }, range);
            });
            var rangeNode = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-footer-extra ' + prefixCls + '-range-quick-selector',
              key: 'range'
            }, operations);
            return [rangeNode, customFooter];
          };

          var value = props.value || props.defaultValue || [];

          if (value[0] && !interopDefault(moment).isMoment(value[0]) || value[1] && !interopDefault(moment).isMoment(value[1])) {
            throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
          }

          var pickerValue = !value || RangePicker_isEmptyArray(value) ? props.defaultPickerValue : value;
          _this.state = {
            value: value,
            showDate: RangePicker_pickerValueAdapter(pickerValue || interopDefault(moment)()),
            open: props.open,
            hoverValue: []
          };
          return _this;
        }

        createClass_default()(RangePicker, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
              var state = this.state;
              var value = nextProps.value || [];
              this.setState({
                value: value,
                showDate: RangePicker_getShowDateFromValue(value) || state.showDate
              });
            }

            if ('open' in nextProps) {
              this.setState({
                open: nextProps.open
              });
            }
          }
        }, {
          key: 'setValue',
          value: function setValue(value, hidePanel) {
            this.handleChange(value);

            if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
              this.setState({
                open: false
              });
            }
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.picker.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.picker.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames,
                _this2 = this;

            var state = this.state,
                props = this.props;
            var value = state.value,
                showDate = state.showDate,
                hoverValue = state.hoverValue,
                open = state.open;
            var prefixCls = props.prefixCls,
                popupStyle = props.popupStyle,
                style = props.style,
                disabledDate = props.disabledDate,
                disabledTime = props.disabledTime,
                showTime = props.showTime,
                showToday = props.showToday,
                ranges = props.ranges,
                onOk = props.onOk,
                locale = props.locale,
                localeCode = props.localeCode,
                format = props.format,
                dateRender = props.dateRender,
                onCalendarChange = props.onCalendarChange;
            RangePicker_fixLocale(value, localeCode);
            RangePicker_fixLocale(showDate, localeCode);

            _util_warning(!('onOK' in props), 'It should be `RangePicker[onOk]`, instead of `onOK`!');

            var calendarClassName = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-time', showTime), defineProperty_default()(_classNames, prefixCls + '-range-with-ranges', ranges), _classNames)); // 需要选择时间时，点击 ok 时才触发 onChange

            var pickerChangeHandler = {
              onChange: this.handleChange
            };
            var calendarProps = {
              onOk: this.handleChange
            };

            if (props.timePicker) {
              pickerChangeHandler.onChange = function (changedValue) {
                return _this2.handleChange(changedValue);
              };
            } else {
              calendarProps = {};
            }

            if ('mode' in props) {
              calendarProps.mode = props.mode;
            }

            var startPlaceholder = 'placeholder' in props ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
            var endPlaceholder = 'placeholder' in props ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
            var calendar = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_RangeCalendar, extends_default()({}, calendarProps, {
              onChange: onCalendarChange,
              format: format,
              prefixCls: prefixCls,
              className: calendarClassName,
              renderFooter: this.renderFooter,
              timePicker: props.timePicker,
              disabledDate: disabledDate,
              disabledTime: disabledTime,
              dateInputPlaceholder: [startPlaceholder, endPlaceholder],
              locale: locale.lang,
              onOk: onOk,
              dateRender: dateRender,
              value: showDate,
              onValueChange: this.handleShowDateChange,
              hoverValue: hoverValue,
              onHoverChange: this.handleHoverChange,
              onPanelChange: props.onPanelChange,
              showToday: showToday,
              onInputSelect: this.handleCalendarInputSelect
            })); // default width for showTime

            var pickerStyle = {};

            if (props.showTime) {
              pickerStyle.width = style && style.width || 350;
            }

            var clearIcon = !props.disabled && props.allowClear && value && (value[0] || value[1]) ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'cross-circle',
              className: prefixCls + '-picker-clear',
              onClick: this.clearSelection
            }) : null;

            var input = function input(_ref3) {
              var inputValue = _ref3.value;
              var start = inputValue[0];
              var end = inputValue[1];
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: props.pickerInputClass
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('input', {
                disabled: props.disabled,
                readOnly: true,
                value: start && start.format(props.format) || '',
                placeholder: startPlaceholder,
                className: prefixCls + '-range-picker-input',
                tabIndex: -1
              }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: prefixCls + '-range-picker-separator'
              }, ' ~ '), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('input', {
                disabled: props.disabled,
                readOnly: true,
                value: end && end.format(props.format) || '',
                placeholder: endPlaceholder,
                className: prefixCls + '-range-picker-input',
                tabIndex: -1
              }), clearIcon, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: prefixCls + '-picker-icon'
              }));
            };

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              ref: this.savePicker,
              id: props.id,
              className: classnames_default()(props.className, props.pickerClass),
              style: extends_default()({}, style, pickerStyle),
              tabIndex: props.disabled ? -1 : 0,
              onFocus: props.onFocus,
              onBlur: props.onBlur
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_Picker, extends_default()({}, props, pickerChangeHandler, {
              calendar: calendar,
              value: value,
              open: open,
              onOpenChange: this.handleOpenChange,
              prefixCls: prefixCls + '-picker-container',
              style: popupStyle
            }), input));
          }
        }]);
        return RangePicker;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var date_picker_RangePicker = RangePicker_RangePicker;
      RangePicker_RangePicker.defaultProps = {
        prefixCls: 'ant-calendar',
        allowClear: true,
        showToday: false
      }; // CONCATENATED MODULE: ./node_modules/antd/es/date-picker/WeekPicker.js

      function WeekPicker_formatValue(value, format) {
        return value && value.format(format) || '';
      }

      var WeekPicker_WeekPicker = function (_React$Component) {
        inherits_default()(WeekPicker, _React$Component);

        function WeekPicker(props) {
          classCallCheck_default()(this, WeekPicker);

          var _this = possibleConstructorReturn_default()(this, (WeekPicker.__proto__ || Object.getPrototypeOf(WeekPicker)).call(this, props));

          _this.weekDateRender = function (current) {
            var selectedValue = _this.state.value;
            var prefixCls = _this.props.prefixCls;

            if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: prefixCls + '-selected-day'
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: prefixCls + '-date'
              }, current.date()));
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-calendar-date'
            }, current.date());
          };

          _this.handleChange = function (value) {
            if (!('value' in _this.props)) {
              _this.setState({
                value: value
              });
            }

            _this.props.onChange(value, WeekPicker_formatValue(value, _this.props.format));
          };

          _this.clearSelection = function (e) {
            e.preventDefault();
            e.stopPropagation();

            _this.handleChange(null);
          };

          _this.saveInput = function (node) {
            _this.input = node;
          };

          var value = props.value || props.defaultValue;

          if (value && !interopDefault(moment).isMoment(value)) {
            throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
          }

          _this.state = {
            value: value
          };
          return _this;
        }

        createClass_default()(WeekPicker, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
              this.setState({
                value: nextProps.value
              });
            }
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.input.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.input.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                disabled = _props.disabled,
                pickerClass = _props.pickerClass,
                popupStyle = _props.popupStyle,
                pickerInputClass = _props.pickerInputClass,
                format = _props.format,
                allowClear = _props.allowClear,
                locale = _props.locale,
                localeCode = _props.localeCode,
                disabledDate = _props.disabledDate,
                style = _props.style,
                onFocus = _props.onFocus,
                onBlur = _props.onBlur;
            var pickerValue = this.state.value;

            if (pickerValue && localeCode) {
              pickerValue.locale(localeCode);
            }

            var placeholder = 'placeholder' in this.props ? this.props.placeholder : locale.lang.placeholder;
            var calendar = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_calendar_es["default"], {
              showWeekNumber: true,
              dateRender: this.weekDateRender,
              prefixCls: prefixCls,
              format: format,
              locale: locale.lang,
              showDateInput: false,
              showToday: false,
              disabledDate: disabledDate
            });
            var clearIcon = !disabled && allowClear && this.state.value ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'cross-circle',
              className: prefixCls + '-picker-clear',
              onClick: this.clearSelection
            }) : null;

            var input = function input(_ref) {
              var value = _ref.value;
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('input', {
                ref: _this2.saveInput,
                disabled: disabled,
                readOnly: true,
                value: value && value.format(format) || '',
                placeholder: placeholder,
                className: pickerInputClass,
                onFocus: onFocus,
                onBlur: onBlur,
                style: style
              }), clearIcon, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: prefixCls + '-picker-icon'
              }));
            };

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: classnames_default()(className, pickerClass),
              id: this.props.id
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_Picker, extends_default()({}, this.props, {
              calendar: calendar,
              prefixCls: prefixCls + '-picker-container',
              value: pickerValue,
              onChange: this.handleChange,
              style: popupStyle
            }), input));
          }
        }]);
        return WeekPicker;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var date_picker_WeekPicker = WeekPicker_WeekPicker;
      WeekPicker_WeekPicker.defaultProps = {
        format: 'gggg-wo',
        allowClear: true
      }; // CONCATENATED MODULE: ./node_modules/antd/es/date-picker/index.js

      var date_picker_DatePicker = wrapPicker_wrapPicker(createPicker_createPicker(rc_calendar_es["default"]));
      var date_picker_MonthPicker = wrapPicker_wrapPicker(createPicker_createPicker(es_MonthCalendar), 'YYYY-MM');
      extends_default()(date_picker_DatePicker, {
        RangePicker: wrapPicker_wrapPicker(date_picker_RangePicker),
        MonthPicker: date_picker_MonthPicker,
        WeekPicker: wrapPicker_wrapPicker(date_picker_WeekPicker, 'gggg-wo')
      });
      /* harmony default export */

      var date_picker = date_picker_DatePicker; // CONCATENATED MODULE: ./node_modules/antd/es/divider/index.js

      var divider_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      function divider_Divider(_a) {
        var _classNames;

        var _a$prefixCls = _a.prefixCls,
            prefixCls = _a$prefixCls === undefined ? 'ant' : _a$prefixCls,
            _a$type = _a.type,
            type = _a$type === undefined ? 'horizontal' : _a$type,
            _a$orientation = _a.orientation,
            orientation = _a$orientation === undefined ? '' : _a$orientation,
            className = _a.className,
            children = _a.children,
            dashed = _a.dashed,
            restProps = divider_rest(_a, ["prefixCls", "type", "orientation", "className", "children", "dashed"]);
        var orientationPrefix = orientation.length > 0 ? '-' + orientation : orientation;
        var classString = classnames_default()(className, prefixCls + '-divider', prefixCls + '-divider-' + type, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-divider-with-text' + orientationPrefix, children), defineProperty_default()(_classNames, prefixCls + '-divider-dashed', !!dashed), _classNames));
        return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({
          className: classString
        }, restProps), children && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
          className: prefixCls + '-divider-inner-text'
        }, children));
      } // CONCATENATED MODULE: ./node_modules/rc-dropdown/es/placements.js


      var rc_dropdown_es_placements_autoAdjustOverflow = {
        adjustX: 1,
        adjustY: 1
      };
      var rc_dropdown_es_placements_targetOffset = [0, 0];
      var es_placements_placements = {
        topLeft: {
          points: ['bl', 'tl'],
          overflow: rc_dropdown_es_placements_autoAdjustOverflow,
          offset: [0, -4],
          targetOffset: rc_dropdown_es_placements_targetOffset
        },
        topCenter: {
          points: ['bc', 'tc'],
          overflow: rc_dropdown_es_placements_autoAdjustOverflow,
          offset: [0, -4],
          targetOffset: rc_dropdown_es_placements_targetOffset
        },
        topRight: {
          points: ['br', 'tr'],
          overflow: rc_dropdown_es_placements_autoAdjustOverflow,
          offset: [0, -4],
          targetOffset: rc_dropdown_es_placements_targetOffset
        },
        bottomLeft: {
          points: ['tl', 'bl'],
          overflow: rc_dropdown_es_placements_autoAdjustOverflow,
          offset: [0, 4],
          targetOffset: rc_dropdown_es_placements_targetOffset
        },
        bottomCenter: {
          points: ['tc', 'bc'],
          overflow: rc_dropdown_es_placements_autoAdjustOverflow,
          offset: [0, 4],
          targetOffset: rc_dropdown_es_placements_targetOffset
        },
        bottomRight: {
          points: ['tr', 'br'],
          overflow: rc_dropdown_es_placements_autoAdjustOverflow,
          offset: [0, 4],
          targetOffset: rc_dropdown_es_placements_targetOffset
        }
      };
      /* harmony default export */

      var rc_dropdown_es_placements = es_placements_placements; // EXTERNAL MODULE: ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js

      var react_lifecycles_compat_es = __webpack_require__(111); // CONCATENATED MODULE: ./node_modules/rc-dropdown/es/Dropdown.js


      var Dropdown_extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      function Dropdown_objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      }

      function Dropdown_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Dropdown_possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function Dropdown_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Dropdown_Dropdown = function (_Component) {
        Dropdown_inherits(Dropdown, _Component);

        function Dropdown(props) {
          Dropdown_classCallCheck(this, Dropdown);

          var _this = Dropdown_possibleConstructorReturn(this, _Component.call(this, props));

          Dropdown_initialiseProps.call(_this);

          if ('visible' in props) {
            _this.state = {
              visible: props.visible
            };
          } else {
            _this.state = {
              visible: props.defaultVisible
            };
          }

          return _this;
        }

        Dropdown.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
          if ('visible' in nextProps) {
            return {
              visible: nextProps.visible
            };
          }

          return null;
        };

        Dropdown.prototype.getMenuElement = function getMenuElement() {
          var _props = this.props,
              overlay = _props.overlay,
              prefixCls = _props.prefixCls;
          var extraOverlayProps = {
            prefixCls: prefixCls + '-menu',
            onClick: this.onClick
          };

          if (typeof overlay.type === 'string') {
            delete extraOverlayProps.prefixCls;
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(overlay, extraOverlayProps);
        };

        Dropdown.prototype.getPopupDomNode = function getPopupDomNode() {
          return this.trigger.getPopupDomNode();
        };

        Dropdown.prototype.render = function render() {
          var _props2 = this.props,
              prefixCls = _props2.prefixCls,
              children = _props2.children,
              transitionName = _props2.transitionName,
              animation = _props2.animation,
              align = _props2.align,
              placement = _props2.placement,
              getPopupContainer = _props2.getPopupContainer,
              showAction = _props2.showAction,
              hideAction = _props2.hideAction,
              overlayClassName = _props2.overlayClassName,
              overlayStyle = _props2.overlayStyle,
              trigger = _props2.trigger,
              otherProps = Dropdown_objectWithoutProperties(_props2, ['prefixCls', 'children', 'transitionName', 'animation', 'align', 'placement', 'getPopupContainer', 'showAction', 'hideAction', 'overlayClassName', 'overlayStyle', 'trigger']);
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_trigger_es["default"], Dropdown_extends({}, otherProps, {
            prefixCls: prefixCls,
            ref: this.saveTrigger,
            popupClassName: overlayClassName,
            popupStyle: overlayStyle,
            builtinPlacements: rc_dropdown_es_placements,
            action: trigger,
            showAction: showAction,
            hideAction: hideAction,
            popupPlacement: placement,
            popupAlign: align,
            popupTransitionName: transitionName,
            popupAnimation: animation,
            popupVisible: this.state.visible,
            afterPopupVisibleChange: this.afterVisibleChange,
            popup: this.getMenuElement(),
            onPopupVisibleChange: this.onVisibleChange,
            getPopupContainer: getPopupContainer
          }), children);
        };

        return Dropdown;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Dropdown_Dropdown.propTypes = {
        minOverlayWidthMatchTrigger: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onVisibleChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onOverlayClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        transitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        overlayClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        animation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        align: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        overlayStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        placement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        overlay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        trigger: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        showAction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        hideAction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        getPopupContainer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultVisible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      Dropdown_Dropdown.defaultProps = {
        minOverlayWidthMatchTrigger: true,
        prefixCls: 'rc-dropdown',
        trigger: ['hover'],
        showAction: [],
        hideAction: [],
        overlayClassName: '',
        overlayStyle: {},
        defaultVisible: false,
        onVisibleChange: function onVisibleChange() {},
        placement: 'bottomLeft'
      };

      var Dropdown_initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.onClick = function (e) {
          var props = _this2.props;
          var overlayProps = props.overlay.props; // do no call onVisibleChange, if you need click to hide, use onClick and control visible

          if (!('visible' in props)) {
            _this2.setState({
              visible: false
            });
          }

          if (props.onOverlayClick) {
            props.onOverlayClick(e);
          }

          if (overlayProps.onClick) {
            overlayProps.onClick(e);
          }
        };

        this.onVisibleChange = function (visible) {
          var props = _this2.props;

          if (!('visible' in props)) {
            _this2.setState({
              visible: visible
            });
          }

          props.onVisibleChange(visible);
        };

        this.afterVisibleChange = function (visible) {
          if (visible && _this2.props.minOverlayWidthMatchTrigger) {
            var overlayNode = _this2.getPopupDomNode();

            var rootNode = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(_this2);

            if (rootNode && overlayNode && rootNode.offsetWidth > overlayNode.offsetWidth) {
              overlayNode.style.minWidth = rootNode.offsetWidth + 'px';

              if (_this2.trigger && _this2.trigger._component && _this2.trigger._component.alignInstance) {
                _this2.trigger._component.alignInstance.forceAlign();
              }
            }
          }
        };

        this.saveTrigger = function (node) {
          _this2.trigger = node;
        };
      };

      Object(react_lifecycles_compat_es["polyfill"])(Dropdown_Dropdown);
      /* harmony default export */

      var es_Dropdown = Dropdown_Dropdown; // CONCATENATED MODULE: ./node_modules/rc-dropdown/es/index.js

      /* harmony default export */

      var rc_dropdown_es = es_Dropdown; // CONCATENATED MODULE: ./node_modules/antd/es/dropdown/dropdown.js

      var dropdown_Dropdown = function (_React$Component) {
        inherits_default()(Dropdown, _React$Component);

        function Dropdown() {
          classCallCheck_default()(this, Dropdown);
          return possibleConstructorReturn_default()(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));
        }

        createClass_default()(Dropdown, [{
          key: 'getTransitionName',
          value: function getTransitionName() {
            var _props = this.props,
                _props$placement = _props.placement,
                placement = _props$placement === undefined ? '' : _props$placement,
                transitionName = _props.transitionName;

            if (transitionName !== undefined) {
              return transitionName;
            }

            if (placement.indexOf('top') >= 0) {
              return 'slide-down';
            }

            return 'slide-up';
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            var overlay = this.props.overlay;
            var overlayProps = overlay.props;

            _util_warning(!overlayProps.mode || overlayProps.mode === 'vertical', 'mode="' + overlayProps.mode + '" is not supported for Dropdown\'s Menu.');
          }
        }, {
          key: 'render',
          value: function render() {
            var _props2 = this.props,
                children = _props2.children,
                prefixCls = _props2.prefixCls,
                overlayElements = _props2.overlay,
                trigger = _props2.trigger,
                disabled = _props2.disabled;
            var child = external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].only(children);
            var overlay = external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].only(overlayElements);
            var dropdownTrigger = external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](child, {
              className: classnames_default()(child.props.className, prefixCls + '-trigger'),
              disabled: disabled
            }); // menu cannot be selectable in dropdown defaultly

            var selectable = overlay.props.selectable || false;
            var fixedModeOverlay = external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](overlay, {
              mode: 'vertical',
              selectable: selectable
            });
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_dropdown_es, extends_default()({}, this.props, {
              transitionName: this.getTransitionName(),
              trigger: disabled ? [] : trigger,
              overlay: fixedModeOverlay
            }), dropdownTrigger);
          }
        }]);
        return Dropdown;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var dropdown = dropdown_Dropdown;
      dropdown_Dropdown.defaultProps = {
        prefixCls: 'ant-dropdown',
        mouseEnterDelay: 0.15,
        mouseLeaveDelay: 0.1,
        placement: 'bottomLeft'
      }; // CONCATENATED MODULE: ./node_modules/antd/es/dropdown/dropdown-button.js

      var dropdown_button_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var dropdown_button_ButtonGroup = es_button.Group;

      var dropdown_button_DropdownButton = function (_React$Component) {
        inherits_default()(DropdownButton, _React$Component);

        function DropdownButton() {
          classCallCheck_default()(this, DropdownButton);
          return possibleConstructorReturn_default()(this, (DropdownButton.__proto__ || Object.getPrototypeOf(DropdownButton)).apply(this, arguments));
        }

        createClass_default()(DropdownButton, [{
          key: 'render',
          value: function render() {
            var _a = this.props,
                type = _a.type,
                disabled = _a.disabled,
                onClick = _a.onClick,
                children = _a.children,
                prefixCls = _a.prefixCls,
                className = _a.className,
                overlay = _a.overlay,
                trigger = _a.trigger,
                align = _a.align,
                visible = _a.visible,
                onVisibleChange = _a.onVisibleChange,
                placement = _a.placement,
                getPopupContainer = _a.getPopupContainer,
                restProps = dropdown_button_rest(_a, ["type", "disabled", "onClick", "children", "prefixCls", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer"]);
            var dropdownProps = {
              align: align,
              overlay: overlay,
              disabled: disabled,
              trigger: disabled ? [] : trigger,
              onVisibleChange: onVisibleChange,
              placement: placement,
              getPopupContainer: getPopupContainer
            };

            if ('visible' in this.props) {
              dropdownProps.visible = visible;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](dropdown_button_ButtonGroup, extends_default()({}, restProps, {
              className: classnames_default()(prefixCls, className)
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_button, {
              type: type,
              disabled: disabled,
              onClick: onClick
            }, children), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](dropdown, dropdownProps, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_button, {
              type: type
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'down'
            }))));
          }
        }]);
        return DropdownButton;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var dropdown_button = dropdown_button_DropdownButton;
      dropdown_button_DropdownButton.defaultProps = {
        placement: 'bottomRight',
        type: 'default',
        prefixCls: 'ant-dropdown-button'
      }; // CONCATENATED MODULE: ./node_modules/antd/es/dropdown/index.js

      dropdown.Button = dropdown_button;
      /* harmony default export */

      var es_dropdown = dropdown; // EXTERNAL MODULE: ./node_modules/dom-scroll-into-view/lib/index.js

      var dom_scroll_into_view_lib = __webpack_require__(146);

      var dom_scroll_into_view_lib_default =
      /*#__PURE__*/
      __webpack_require__.n(dom_scroll_into_view_lib); // EXTERNAL MODULE: ./node_modules/lodash/has.js


      var has = __webpack_require__(707);

      var has_default =
      /*#__PURE__*/
      __webpack_require__.n(has); // CONCATENATED MODULE: ./node_modules/async-validator/es/util.js


      var util_formatRegExp = /%[sdj%]/g;

      var util_warning = function warning() {}; // don't print warning message when in production env or node runtime


      if (false) {}

      function util_format() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var i = 1;
        var f = args[0];
        var len = args.length;

        if (typeof f === 'function') {
          return f.apply(null, args.slice(1));
        }

        if (typeof f === 'string') {
          var str = String(f).replace(util_formatRegExp, function (x) {
            if (x === '%%') {
              return '%';
            }

            if (i >= len) {
              return x;
            }

            switch (x) {
              case '%s':
                return String(args[i++]);

              case '%d':
                return Number(args[i++]);

              case '%j':
                try {
                  return JSON.stringify(args[i++]);
                } catch (_) {
                  return '[Circular]';
                }

                break;

              default:
                return x;
            }
          });

          for (var arg = args[i]; i < len; arg = args[++i]) {
            str += ' ' + arg;
          }

          return str;
        }

        return f;
      }

      function util_isNativeStringType(type) {
        return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
      }

      function util_isEmptyValue(value, type) {
        if (value === undefined || value === null) {
          return true;
        }

        if (type === 'array' && Array.isArray(value) && !value.length) {
          return true;
        }

        if (util_isNativeStringType(type) && typeof value === 'string' && !value) {
          return true;
        }

        return false;
      }

      function util_isEmptyObject(obj) {
        return Object.keys(obj).length === 0;
      }

      function util_asyncParallelArray(arr, func, callback) {
        var results = [];
        var total = 0;
        var arrLength = arr.length;

        function count(errors) {
          results.push.apply(results, errors);
          total++;

          if (total === arrLength) {
            callback(results);
          }
        }

        arr.forEach(function (a) {
          func(a, count);
        });
      }

      function util_asyncSerialArray(arr, func, callback) {
        var index = 0;
        var arrLength = arr.length;

        function next(errors) {
          if (errors && errors.length) {
            callback(errors);
            return;
          }

          var original = index;
          index = index + 1;

          if (original < arrLength) {
            func(arr[original], next);
          } else {
            callback([]);
          }
        }

        next([]);
      }

      function util_flattenObjArr(objArr) {
        var ret = [];
        Object.keys(objArr).forEach(function (k) {
          ret.push.apply(ret, objArr[k]);
        });
        return ret;
      }

      function util_asyncMap(objArr, option, func, callback) {
        if (option.first) {
          var flattenArr = util_flattenObjArr(objArr);
          return util_asyncSerialArray(flattenArr, func, callback);
        }

        var firstFields = option.firstFields || [];

        if (firstFields === true) {
          firstFields = Object.keys(objArr);
        }

        var objArrKeys = Object.keys(objArr);
        var objArrLength = objArrKeys.length;
        var total = 0;
        var results = [];

        var next = function next(errors) {
          results.push.apply(results, errors);
          total++;

          if (total === objArrLength) {
            callback(results);
          }
        };

        objArrKeys.forEach(function (key) {
          var arr = objArr[key];

          if (firstFields.indexOf(key) !== -1) {
            util_asyncSerialArray(arr, func, next);
          } else {
            util_asyncParallelArray(arr, func, next);
          }
        });
      }

      function util_complementError(rule) {
        return function (oe) {
          if (oe && oe.message) {
            oe.field = oe.field || rule.fullField;
            return oe;
          }

          return {
            message: oe,
            field: oe.field || rule.fullField
          };
        };
      }

      function util_deepMerge(target, source) {
        if (source) {
          for (var s in source) {
            if (source.hasOwnProperty(s)) {
              var value = source[s];

              if ((typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && typeof_default()(target[s]) === 'object') {
                target[s] = extends_default()({}, target[s], value);
              } else {
                target[s] = value;
              }
            }
          }
        }

        return target;
      } // CONCATENATED MODULE: ./node_modules/async-validator/es/rule/required.js

      /**
       *  Rule for validating required fields.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param source The source object being validated.
       *  @param errors An array of errors that this rule may add
       *  validation errors to.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */


      function required_required(rule, value, source, errors, options, type) {
        if (rule.required && (!source.hasOwnProperty(rule.field) || util_isEmptyValue(value, type || rule.type))) {
          errors.push(util_format(options.messages.required, rule.fullField));
        }
      }
      /* harmony default export */


      var rule_required = required_required; // CONCATENATED MODULE: ./node_modules/async-validator/es/rule/whitespace.js

      /**
       *  Rule for validating whitespace.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param source The source object being validated.
       *  @param errors An array of errors that this rule may add
       *  validation errors to.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function whitespace_whitespace(rule, value, source, errors, options) {
        if (/^\s+$/.test(value) || value === '') {
          errors.push(util_format(options.messages.whitespace, rule.fullField));
        }
      }
      /* harmony default export */


      var rule_whitespace = whitespace_whitespace; // CONCATENATED MODULE: ./node_modules/async-validator/es/rule/type.js

      /* eslint max-len:0 */

      var type_pattern = {
        // http://emailregex.com/
        email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        url: new RegExp("^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$", 'i'),
        hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
      };
      var type_types = {
        integer: function integer(value) {
          return type_types.number(value) && parseInt(value, 10) === value;
        },
        float: function float(value) {
          return type_types.number(value) && !type_types.integer(value);
        },
        array: function array(value) {
          return Array.isArray(value);
        },
        regexp: function regexp(value) {
          if (value instanceof RegExp) {
            return true;
          }

          try {
            return !!new RegExp(value);
          } catch (e) {
            return false;
          }
        },
        date: function date(value) {
          return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
        },
        number: function number(value) {
          if (isNaN(value)) {
            return false;
          }

          return typeof value === 'number';
        },
        object: function object(value) {
          return (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !type_types.array(value);
        },
        method: function method(value) {
          return typeof value === 'function';
        },
        email: function email(value) {
          return typeof value === 'string' && !!value.match(type_pattern.email) && value.length < 255;
        },
        url: function url(value) {
          return typeof value === 'string' && !!value.match(type_pattern.url);
        },
        hex: function hex(value) {
          return typeof value === 'string' && !!value.match(type_pattern.hex);
        }
      };
      /**
       *  Rule for validating the type of a value.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param source The source object being validated.
       *  @param errors An array of errors that this rule may add
       *  validation errors to.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function type_type(rule, value, source, errors, options) {
        if (rule.required && value === undefined) {
          rule_required(rule, value, source, errors, options);
          return;
        }

        var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
        var ruleType = rule.type;

        if (custom.indexOf(ruleType) > -1) {
          if (!type_types[ruleType](value)) {
            errors.push(util_format(options.messages.types[ruleType], rule.fullField, rule.type));
          } // straight typeof check

        } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) !== rule.type) {
          errors.push(util_format(options.messages.types[ruleType], rule.fullField, rule.type));
        }
      }
      /* harmony default export */


      var rule_type = type_type; // CONCATENATED MODULE: ./node_modules/async-validator/es/rule/range.js

      /**
       *  Rule for validating minimum and maximum allowed values.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param source The source object being validated.
       *  @param errors An array of errors that this rule may add
       *  validation errors to.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function range_range(rule, value, source, errors, options) {
        var len = typeof rule.len === 'number';
        var min = typeof rule.min === 'number';
        var max = typeof rule.max === 'number'; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）

        var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
        var val = value;
        var key = null;
        var num = typeof value === 'number';
        var str = typeof value === 'string';
        var arr = Array.isArray(value);

        if (num) {
          key = 'number';
        } else if (str) {
          key = 'string';
        } else if (arr) {
          key = 'array';
        } // if the value is not of a supported type for range validation
        // the validation rule rule should use the
        // type property to also test for a particular type


        if (!key) {
          return false;
        }

        if (arr) {
          val = value.length;
        }

        if (str) {
          // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
          val = value.replace(spRegexp, '_').length;
        }

        if (len) {
          if (val !== rule.len) {
            errors.push(util_format(options.messages[key].len, rule.fullField, rule.len));
          }
        } else if (min && !max && val < rule.min) {
          errors.push(util_format(options.messages[key].min, rule.fullField, rule.min));
        } else if (max && !min && val > rule.max) {
          errors.push(util_format(options.messages[key].max, rule.fullField, rule.max));
        } else if (min && max && (val < rule.min || val > rule.max)) {
          errors.push(util_format(options.messages[key].range, rule.fullField, rule.min, rule.max));
        }
      }
      /* harmony default export */


      var rule_range = range_range; // CONCATENATED MODULE: ./node_modules/async-validator/es/rule/enum.js

      var enum_ENUM = 'enum';
      /**
       *  Rule for validating a value exists in an enumerable list.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param source The source object being validated.
       *  @param errors An array of errors that this rule may add
       *  validation errors to.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function enum_enumerable(rule, value, source, errors, options) {
        rule[enum_ENUM] = Array.isArray(rule[enum_ENUM]) ? rule[enum_ENUM] : [];

        if (rule[enum_ENUM].indexOf(value) === -1) {
          errors.push(util_format(options.messages[enum_ENUM], rule.fullField, rule[enum_ENUM].join(', ')));
        }
      }
      /* harmony default export */


      var rule_enum = enum_enumerable; // CONCATENATED MODULE: ./node_modules/async-validator/es/rule/pattern.js

      /**
       *  Rule for validating a regular expression pattern.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param source The source object being validated.
       *  @param errors An array of errors that this rule may add
       *  validation errors to.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function pattern_pattern(rule, value, source, errors, options) {
        if (rule.pattern) {
          if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;

            if (!rule.pattern.test(value)) {
              errors.push(util_format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
            }
          } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);

            if (!_pattern.test(value)) {
              errors.push(util_format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
            }
          }
        }
      }
      /* harmony default export */


      var rule_pattern = pattern_pattern; // CONCATENATED MODULE: ./node_modules/async-validator/es/rule/index.js

      /* harmony default export */

      var es_rule = {
        required: rule_required,
        whitespace: rule_whitespace,
        type: rule_type,
        range: rule_range,
        'enum': rule_enum,
        pattern: rule_pattern
      }; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/string.js

      /**
       *  Performs validation for string types.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function string_string(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value, 'string') && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options, 'string');

          if (!util_isEmptyValue(value, 'string')) {
            es_rule.type(rule, value, source, errors, options);
            es_rule.range(rule, value, source, errors, options);
            es_rule.pattern(rule, value, source, errors, options);

            if (rule.whitespace === true) {
              es_rule.whitespace(rule, value, source, errors, options);
            }
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_string = string_string; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/method.js

      /**
       *  Validates a function.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function method_method(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value) && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options);

          if (value !== undefined) {
            es_rule.type(rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_method = method_method; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/number.js

      /**
       *  Validates a number.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function number_number(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value) && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options);

          if (value !== undefined) {
            es_rule.type(rule, value, source, errors, options);
            es_rule.range(rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_number = number_number; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/boolean.js

      /**
       *  Validates a boolean.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function boolean_boolean(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value) && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options);

          if (value !== undefined) {
            es_rule.type(rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_boolean = boolean_boolean; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/regexp.js

      /**
       *  Validates the regular expression type.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function regexp_regexp(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value) && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options);

          if (!util_isEmptyValue(value)) {
            es_rule.type(rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_regexp = regexp_regexp; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/integer.js

      /**
       *  Validates a number is an integer.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function integer_integer(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value) && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options);

          if (value !== undefined) {
            es_rule.type(rule, value, source, errors, options);
            es_rule.range(rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_integer = integer_integer; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/float.js

      /**
       *  Validates a number is a floating point number.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function float_floatFn(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value) && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options);

          if (value !== undefined) {
            es_rule.type(rule, value, source, errors, options);
            es_rule.range(rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_float = float_floatFn; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/array.js

      /**
       *  Validates an array.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function array_array(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value, 'array') && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options, 'array');

          if (!util_isEmptyValue(value, 'array')) {
            es_rule.type(rule, value, source, errors, options);
            es_rule.range(rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_array = array_array; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/object.js

      /**
       *  Validates an object.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function object_object(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value) && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options);

          if (value !== undefined) {
            es_rule.type(rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_object = object_object; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/enum.js

      var validator_enum_ENUM = 'enum';
      /**
       *  Validates an enumerable list.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function validator_enum_enumerable(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value) && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options);

          if (value) {
            es_rule[validator_enum_ENUM](rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_enum = validator_enum_enumerable; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/pattern.js

      /**
       *  Validates a regular expression pattern.
       *
       *  Performs validation when a rule only contains
       *  a pattern property but is not declared as a string type.
       *
       *  @param rule The validation rule.
       *  @param value The value of the field on the source object.
       *  @param callback The callback function.
       *  @param source The source object being validated.
       *  @param options The validation options.
       *  @param options.messages The validation messages.
       */

      function validator_pattern_pattern(rule, value, callback, source, options) {
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value, 'string') && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options);

          if (!util_isEmptyValue(value, 'string')) {
            es_rule.pattern(rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_pattern = validator_pattern_pattern; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/date.js

      function date_date(rule, value, callback, source, options) {
        // console.log('integer rule called %j', rule);
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);

        if (validate) {
          if (util_isEmptyValue(value) && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options);

          if (!util_isEmptyValue(value)) {
            var dateObject = void 0;

            if (typeof value === 'number') {
              dateObject = new Date(value);
            } else {
              dateObject = value;
            }

            es_rule.type(rule, dateObject, source, errors, options);

            if (dateObject) {
              es_rule.range(rule, dateObject.getTime(), source, errors, options);
            }
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_date = date_date; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/required.js

      function validator_required_required(rule, value, callback, source, options) {
        var errors = [];
        var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : typeof_default()(value);
        es_rule.required(rule, value, source, errors, options, type);
        callback(errors);
      }
      /* harmony default export */


      var validator_required = validator_required_required; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/type.js

      function validator_type_type(rule, value, callback, source, options) {
        var ruleType = rule.type;
        var errors = [];
        var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

        if (validate) {
          if (util_isEmptyValue(value, ruleType) && !rule.required) {
            return callback();
          }

          es_rule.required(rule, value, source, errors, options, ruleType);

          if (!util_isEmptyValue(value, ruleType)) {
            es_rule.type(rule, value, source, errors, options);
          }
        }

        callback(errors);
      }
      /* harmony default export */


      var validator_type = validator_type_type; // CONCATENATED MODULE: ./node_modules/async-validator/es/validator/index.js

      /* harmony default export */

      var es_validator = {
        string: validator_string,
        method: validator_method,
        number: validator_number,
        boolean: validator_boolean,
        regexp: validator_regexp,
        integer: validator_integer,
        float: validator_float,
        array: validator_array,
        object: validator_object,
        'enum': validator_enum,
        pattern: validator_pattern,
        date: validator_date,
        url: validator_type,
        hex: validator_type,
        email: validator_type,
        required: validator_required
      }; // CONCATENATED MODULE: ./node_modules/async-validator/es/messages.js

      function newMessages() {
        return {
          'default': 'Validation error on field %s',
          required: '%s is required',
          'enum': '%s must be one of %s',
          whitespace: '%s cannot be empty',
          date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
          },
          types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            boolean: '%s is not a %s',
            integer: '%s is not an %s',
            float: '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
          },
          string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
          },
          number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
          },
          array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
          },
          pattern: {
            mismatch: '%s value %s does not match pattern %s'
          },
          clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
          }
        };
      }

      var messages_messages = newMessages(); // CONCATENATED MODULE: ./node_modules/async-validator/es/index.js

      /**
       *  Encapsulates a validation schema.
       *
       *  @param descriptor An object declaring validation rules
       *  for this schema.
       */

      function es_Schema(descriptor) {
        this.rules = null;
        this._messages = messages_messages;
        this.define(descriptor);
      }

      es_Schema.prototype = {
        messages: function messages(_messages) {
          if (_messages) {
            this._messages = util_deepMerge(newMessages(), _messages);
          }

          return this._messages;
        },
        define: function define(rules) {
          if (!rules) {
            throw new Error('Cannot configure a schema with no rules');
          }

          if ((typeof rules === 'undefined' ? 'undefined' : typeof_default()(rules)) !== 'object' || Array.isArray(rules)) {
            throw new Error('Rules must be an object');
          }

          this.rules = {};
          var z = void 0;
          var item = void 0;

          for (z in rules) {
            if (rules.hasOwnProperty(z)) {
              item = rules[z];
              this.rules[z] = Array.isArray(item) ? item : [item];
            }
          }
        },
        validate: function validate(source_) {
          var _this = this;

          var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var oc = arguments[2];
          var source = source_;
          var options = o;
          var callback = oc;

          if (typeof options === 'function') {
            callback = options;
            options = {};
          }

          if (!this.rules || Object.keys(this.rules).length === 0) {
            if (callback) {
              callback();
            }

            return;
          }

          function complete(results) {
            var i = void 0;
            var field = void 0;
            var errors = [];
            var fields = {};

            function add(e) {
              if (Array.isArray(e)) {
                errors = errors.concat.apply(errors, e);
              } else {
                errors.push(e);
              }
            }

            for (i = 0; i < results.length; i++) {
              add(results[i]);
            }

            if (!errors.length) {
              errors = null;
              fields = null;
            } else {
              for (i = 0; i < errors.length; i++) {
                field = errors[i].field;
                fields[field] = fields[field] || [];
                fields[field].push(errors[i]);
              }
            }

            callback(errors, fields);
          }

          if (options.messages) {
            var messages = this.messages();

            if (messages === messages_messages) {
              messages = newMessages();
            }

            util_deepMerge(messages, options.messages);
            options.messages = messages;
          } else {
            options.messages = this.messages();
          }

          var arr = void 0;
          var value = void 0;
          var series = {};
          var keys = options.keys || Object.keys(this.rules);
          keys.forEach(function (z) {
            arr = _this.rules[z];
            value = source[z];
            arr.forEach(function (r) {
              var rule = r;

              if (typeof rule.transform === 'function') {
                if (source === source_) {
                  source = extends_default()({}, source);
                }

                value = source[z] = rule.transform(value);
              }

              if (typeof rule === 'function') {
                rule = {
                  validator: rule
                };
              } else {
                rule = extends_default()({}, rule);
              }

              rule.validator = _this.getValidationMethod(rule);
              rule.field = z;
              rule.fullField = rule.fullField || z;
              rule.type = _this.getType(rule);

              if (!rule.validator) {
                return;
              }

              series[z] = series[z] || [];
              series[z].push({
                rule: rule,
                value: value,
                source: source,
                field: z
              });
            });
          });
          var errorFields = {};
          util_asyncMap(series, options, function (data, doIt) {
            var rule = data.rule;
            var deep = (rule.type === 'object' || rule.type === 'array') && (typeof_default()(rule.fields) === 'object' || typeof_default()(rule.defaultField) === 'object');
            deep = deep && (rule.required || !rule.required && data.value);
            rule.field = data.field;

            function addFullfield(key, schema) {
              return extends_default()({}, schema, {
                fullField: rule.fullField + '.' + key
              });
            }

            function cb() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              var errors = e;

              if (!Array.isArray(errors)) {
                errors = [errors];
              }

              if (errors.length) {
                util_warning('async-validator:', errors);
              }

              if (errors.length && rule.message) {
                errors = [].concat(rule.message);
              }

              errors = errors.map(util_complementError(rule));

              if (options.first && errors.length) {
                errorFields[rule.field] = 1;
                return doIt(errors);
              }

              if (!deep) {
                doIt(errors);
              } else {
                // if rule is required but the target object
                // does not exist fail at the rule level and don't
                // go deeper
                if (rule.required && !data.value) {
                  if (rule.message) {
                    errors = [].concat(rule.message).map(util_complementError(rule));
                  } else if (options.error) {
                    errors = [options.error(rule, util_format(options.messages.required, rule.field))];
                  } else {
                    errors = [];
                  }

                  return doIt(errors);
                }

                var fieldsSchema = {};

                if (rule.defaultField) {
                  for (var k in data.value) {
                    if (data.value.hasOwnProperty(k)) {
                      fieldsSchema[k] = rule.defaultField;
                    }
                  }
                }

                fieldsSchema = extends_default()({}, fieldsSchema, data.rule.fields);

                for (var f in fieldsSchema) {
                  if (fieldsSchema.hasOwnProperty(f)) {
                    var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
                    fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
                  }
                }

                var schema = new es_Schema(fieldsSchema);
                schema.messages(options.messages);

                if (data.rule.options) {
                  data.rule.options.messages = options.messages;
                  data.rule.options.error = options.error;
                }

                schema.validate(data.value, data.rule.options || options, function (errs) {
                  doIt(errs && errs.length ? errors.concat(errs) : errs);
                });
              }
            }

            var res = rule.validator(rule, data.value, cb, data.source, options);

            if (res && res.then) {
              res.then(function () {
                return cb();
              }, function (e) {
                return cb(e);
              });
            }
          }, function (results) {
            complete(results);
          });
        },
        getType: function getType(rule) {
          if (rule.type === undefined && rule.pattern instanceof RegExp) {
            rule.type = 'pattern';
          }

          if (typeof rule.validator !== 'function' && rule.type && !es_validator.hasOwnProperty(rule.type)) {
            throw new Error(util_format('Unknown rule type %s', rule.type));
          }

          return rule.type || 'string';
        },
        getValidationMethod: function getValidationMethod(rule) {
          if (typeof rule.validator === 'function') {
            return rule.validator;
          }

          var keys = Object.keys(rule);
          var messageIndex = keys.indexOf('message');

          if (messageIndex !== -1) {
            keys.splice(messageIndex, 1);
          }

          if (keys.length === 1 && keys[0] === 'required') {
            return es_validator.required;
          }

          return es_validator[this.getType(rule)] || false;
        }
      };

      es_Schema.register = function register(type, validator) {
        if (typeof validator !== 'function') {
          throw new Error('Cannot register a validator by type, validator is not a function');
        }

        es_validator[type] = validator;
      };

      es_Schema.messages = messages_messages;
      /* harmony default export */

      var async_validator_es = es_Schema; // EXTERNAL MODULE: ./node_modules/rc-form/node_modules/warning/warning.js

      var warning_warning = __webpack_require__(379);

      var warning_default =
      /*#__PURE__*/
      __webpack_require__.n(warning_warning); // EXTERNAL MODULE: ./node_modules/lodash/get.js


      var get = __webpack_require__(10);

      var get_default =
      /*#__PURE__*/
      __webpack_require__.n(get); // EXTERNAL MODULE: ./node_modules/lodash/set.js


      var set = __webpack_require__(52);

      var set_default =
      /*#__PURE__*/
      __webpack_require__.n(set); // EXTERNAL MODULE: ./node_modules/lodash/eq.js


      var eq = __webpack_require__(163);

      var eq_default =
      /*#__PURE__*/
      __webpack_require__.n(eq); // CONCATENATED MODULE: ./node_modules/rc-form/es/createFormField.js


      var createFormField_Field = function Field(fields) {
        classCallCheck_default()(this, Field);
        extends_default()(this, fields);
      };

      function createFormField_isFormField(obj) {
        return obj instanceof createFormField_Field;
      }

      function createFormField_createFormField(field) {
        if (createFormField_isFormField(field)) {
          return field;
        }

        return new createFormField_Field(field);
      } // EXTERNAL MODULE: ./node_modules/rc-form/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js


      var hoist_non_react_statics_cjs = __webpack_require__(706);

      var hoist_non_react_statics_cjs_default =
      /*#__PURE__*/
      __webpack_require__.n(hoist_non_react_statics_cjs); // CONCATENATED MODULE: ./node_modules/rc-form/es/utils.js


      function utils_getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
      }

      function utils_argumentContainer(Container, WrappedComponent) {
        /* eslint no-param-reassign:0 */
        Container.displayName = 'Form(' + utils_getDisplayName(WrappedComponent) + ')';
        Container.WrappedComponent = WrappedComponent;
        return hoist_non_react_statics_cjs_default()(Container, WrappedComponent);
      }

      function utils_identity(obj) {
        return obj;
      }

      function utils_flattenArray(arr) {
        return Array.prototype.concat.apply([], arr);
      }

      function utils_treeTraverse() {
        var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var tree = arguments[1];
        var isLeafNode = arguments[2];
        var errorMessage = arguments[3];
        var callback = arguments[4];

        if (isLeafNode(path, tree)) {
          callback(path, tree);
        } else if (tree === undefined || tree === null) {// Do nothing
        } else if (Array.isArray(tree)) {
          tree.forEach(function (subTree, index) {
            return utils_treeTraverse(path + '[' + index + ']', subTree, isLeafNode, errorMessage, callback);
          });
        } else {
          // It's object and not a leaf node
          if (typeof tree !== 'object') {
            warning_default()(false, errorMessage);
            return;
          }

          Object.keys(tree).forEach(function (subTreeKey) {
            var subTree = tree[subTreeKey];
            utils_treeTraverse('' + path + (path ? '.' : '') + subTreeKey, subTree, isLeafNode, errorMessage, callback);
          });
        }
      }

      function utils_flattenFields(maybeNestedFields, isLeafNode, errorMessage) {
        var fields = {};
        utils_treeTraverse(undefined, maybeNestedFields, isLeafNode, errorMessage, function (path, node) {
          fields[path] = node;
        });
        return fields;
      }

      function utils_normalizeValidateRules(validate, rules, validateTrigger) {
        var validateRules = validate.map(function (item) {
          var newItem = extends_default()({}, item, {
            trigger: item.trigger || []
          });

          if (typeof newItem.trigger === 'string') {
            newItem.trigger = [newItem.trigger];
          }

          return newItem;
        });

        if (rules) {
          validateRules.push({
            trigger: validateTrigger ? [].concat(validateTrigger) : [],
            rules: rules
          });
        }

        return validateRules;
      }

      function utils_getValidateTriggers(validateRules) {
        return validateRules.filter(function (item) {
          return !!item.rules && item.rules.length;
        }).map(function (item) {
          return item.trigger;
        }).reduce(function (pre, curr) {
          return pre.concat(curr);
        }, []);
      }

      function utils_getValueFromEvent(e) {
        // To support custom element
        if (!e || !e.target) {
          return e;
        }

        var target = e.target;
        return target.type === 'checkbox' ? target.checked : target.value;
      }

      function utils_getErrorStrs(errors) {
        if (errors) {
          return errors.map(function (e) {
            if (e && e.message) {
              return e.message;
            }

            return e;
          });
        }

        return errors;
      }

      function utils_getParams(ns, opt, cb) {
        var names = ns;
        var options = opt;
        var callback = cb;

        if (cb === undefined) {
          if (typeof names === 'function') {
            callback = names;
            options = {};
            names = undefined;
          } else if (Array.isArray(names)) {
            if (typeof options === 'function') {
              callback = options;
              options = {};
            } else {
              options = options || {};
            }
          } else {
            callback = options;
            options = names || {};
            names = undefined;
          }
        }

        return {
          names: names,
          options: options,
          callback: callback
        };
      }

      function utils_isEmptyObject(obj) {
        return Object.keys(obj).length === 0;
      }

      function utils_hasRules(validate) {
        if (validate) {
          return validate.some(function (item) {
            return item.rules && item.rules.length;
          });
        }

        return false;
      }

      function utils_startsWith(str, prefix) {
        return str.lastIndexOf(prefix, 0) === 0;
      } // CONCATENATED MODULE: ./node_modules/rc-form/es/createFieldsStore.js


      function createFieldsStore_partOf(a, b) {
        return b.indexOf(a) === 0 && ['.', '['].indexOf(b[a.length]) !== -1;
      }

      function createFieldsStore_internalFlattenFields(fields) {
        return utils_flattenFields(fields, function (_, node) {
          return createFormField_isFormField(node);
        }, 'You must wrap field data with `createFormField`.');
      }

      var createFieldsStore_FieldsStore = function () {
        function FieldsStore(fields) {
          classCallCheck_default()(this, FieldsStore);
          createFieldsStore_initialiseProps.call(this);
          this.fields = createFieldsStore_internalFlattenFields(fields);
          this.fieldsMeta = {};
        }

        createClass_default()(FieldsStore, [{
          key: 'updateFields',
          value: function updateFields(fields) {
            this.fields = createFieldsStore_internalFlattenFields(fields);
          }
        }, {
          key: 'flattenRegisteredFields',
          value: function flattenRegisteredFields(fields) {
            var validFieldsName = this.getAllFieldsName();
            return utils_flattenFields(fields, function (path) {
              return validFieldsName.indexOf(path) >= 0;
            }, 'You cannot set a form field before rendering a field associated with the value.');
          }
        }, {
          key: 'setFields',
          value: function setFields(fields) {
            var _this = this;

            var fieldsMeta = this.fieldsMeta;
            var nowFields = extends_default()({}, this.fields, fields);
            var nowValues = {};
            Object.keys(fieldsMeta).forEach(function (f) {
              nowValues[f] = _this.getValueFromFields(f, nowFields);
            });
            Object.keys(nowValues).forEach(function (f) {
              var value = nowValues[f];

              var fieldMeta = _this.getFieldMeta(f);

              if (fieldMeta && fieldMeta.normalize) {
                var nowValue = fieldMeta.normalize(value, _this.getValueFromFields(f, _this.fields), nowValues);

                if (nowValue !== value) {
                  nowFields[f] = extends_default()({}, nowFields[f], {
                    value: nowValue
                  });
                }
              }
            });
            this.fields = nowFields;
          }
        }, {
          key: 'resetFields',
          value: function resetFields(ns) {
            var fields = this.fields;
            var names = ns ? this.getValidFieldsFullName(ns) : this.getAllFieldsName();
            return names.reduce(function (acc, name) {
              var field = fields[name];

              if (field && 'value' in field) {
                acc[name] = {};
              }

              return acc;
            }, {});
          }
        }, {
          key: 'setFieldMeta',
          value: function setFieldMeta(name, meta) {
            this.fieldsMeta[name] = meta;
          }
        }, {
          key: 'setFieldsAsDirty',
          value: function setFieldsAsDirty() {
            var _this2 = this;

            Object.keys(this.fields).forEach(function (name) {
              var field = _this2.fields[name];
              var fieldMeta = _this2.fieldsMeta[name];

              if (field && fieldMeta && utils_hasRules(fieldMeta.validate)) {
                _this2.fields[name] = extends_default()({}, field, {
                  dirty: true
                });
              }
            });
          }
        }, {
          key: 'getFieldMeta',
          value: function getFieldMeta(name) {
            this.fieldsMeta[name] = this.fieldsMeta[name] || {};
            return this.fieldsMeta[name];
          }
        }, {
          key: 'getValueFromFields',
          value: function getValueFromFields(name, fields) {
            var field = fields[name];

            if (field && 'value' in field) {
              return field.value;
            }

            var fieldMeta = this.getFieldMeta(name);
            return fieldMeta && fieldMeta.initialValue;
          }
        }, {
          key: 'getValidFieldsName',
          value: function getValidFieldsName() {
            var _this3 = this;

            var fieldsMeta = this.fieldsMeta;
            return fieldsMeta ? Object.keys(fieldsMeta).filter(function (name) {
              return !_this3.getFieldMeta(name).hidden;
            }) : [];
          }
        }, {
          key: 'getAllFieldsName',
          value: function getAllFieldsName() {
            var fieldsMeta = this.fieldsMeta;
            return fieldsMeta ? Object.keys(fieldsMeta) : [];
          }
        }, {
          key: 'getValidFieldsFullName',
          value: function getValidFieldsFullName(maybePartialName) {
            var maybePartialNames = Array.isArray(maybePartialName) ? maybePartialName : [maybePartialName];
            return this.getValidFieldsName().filter(function (fullName) {
              return maybePartialNames.some(function (partialName) {
                return fullName === partialName || utils_startsWith(fullName, partialName) && ['.', '['].indexOf(fullName[partialName.length]) >= 0;
              });
            });
          }
        }, {
          key: 'getFieldValuePropValue',
          value: function getFieldValuePropValue(fieldMeta) {
            var name = fieldMeta.name,
                getValueProps = fieldMeta.getValueProps,
                valuePropName = fieldMeta.valuePropName;
            var field = this.getField(name);
            var fieldValue = 'value' in field ? field.value : fieldMeta.initialValue;

            if (getValueProps) {
              return getValueProps(fieldValue);
            }

            return defineProperty_default()({}, valuePropName, fieldValue);
          }
        }, {
          key: 'getField',
          value: function getField(name) {
            return extends_default()({}, this.fields[name], {
              name: name
            });
          }
        }, {
          key: 'getNotCollectedFields',
          value: function getNotCollectedFields() {
            var _this4 = this;

            var fieldsName = this.getValidFieldsName();
            return fieldsName.filter(function (name) {
              return !_this4.fields[name];
            }).map(function (name) {
              return {
                name: name,
                dirty: false,
                value: _this4.getFieldMeta(name).initialValue
              };
            }).reduce(function (acc, field) {
              return set_default()(acc, field.name, createFormField_createFormField(field));
            }, {});
          }
        }, {
          key: 'getNestedAllFields',
          value: function getNestedAllFields() {
            var _this5 = this;

            return Object.keys(this.fields).reduce(function (acc, name) {
              return set_default()(acc, name, createFormField_createFormField(_this5.fields[name]));
            }, this.getNotCollectedFields());
          }
        }, {
          key: 'getFieldMember',
          value: function getFieldMember(name, member) {
            return this.getField(name)[member];
          }
        }, {
          key: 'getNestedFields',
          value: function getNestedFields(names, getter) {
            var fields = names || this.getValidFieldsName();
            return fields.reduce(function (acc, f) {
              return set_default()(acc, f, getter(f));
            }, {});
          }
        }, {
          key: 'getNestedField',
          value: function getNestedField(name, getter) {
            var fullNames = this.getValidFieldsFullName(name);

            if (fullNames.length === 0 || // Not registered
            fullNames.length === 1 && fullNames[0] === name // Name already is full name.
            ) {
                return getter(name);
              }

            var isArrayValue = fullNames[0][name.length] === '[';
            var suffixNameStartIndex = isArrayValue ? name.length : name.length + 1;
            return fullNames.reduce(function (acc, fullName) {
              return set_default()(acc, fullName.slice(suffixNameStartIndex), getter(fullName));
            }, isArrayValue ? [] : {});
          }
        }, {
          key: 'isValidNestedFieldName',
          // @private
          // BG: `a` and `a.b` cannot be use in the same form
          value: function isValidNestedFieldName(name) {
            var names = this.getAllFieldsName();
            return names.every(function (n) {
              return !createFieldsStore_partOf(n, name) && !createFieldsStore_partOf(name, n);
            });
          }
        }, {
          key: 'clearField',
          value: function clearField(name) {
            delete this.fields[name];
            delete this.fieldsMeta[name];
          }
        }]);
        return FieldsStore;
      }();

      var createFieldsStore_initialiseProps = function _initialiseProps() {
        var _this6 = this;

        this.setFieldsInitialValue = function (initialValues) {
          var flattenedInitialValues = _this6.flattenRegisteredFields(initialValues);

          var fieldsMeta = _this6.fieldsMeta;
          Object.keys(flattenedInitialValues).forEach(function (name) {
            if (fieldsMeta[name]) {
              _this6.setFieldMeta(name, extends_default()({}, _this6.getFieldMeta(name), {
                initialValue: flattenedInitialValues[name]
              }));
            }
          });
        };

        this.getAllValues = function () {
          var fieldsMeta = _this6.fieldsMeta,
              fields = _this6.fields;
          return Object.keys(fieldsMeta).reduce(function (acc, name) {
            return set_default()(acc, name, _this6.getValueFromFields(name, fields));
          }, {});
        };

        this.getFieldsValue = function (names) {
          return _this6.getNestedFields(names, _this6.getFieldValue);
        };

        this.getFieldValue = function (name) {
          var fields = _this6.fields;
          return _this6.getNestedField(name, function (fullName) {
            return _this6.getValueFromFields(fullName, fields);
          });
        };

        this.getFieldsError = function (names) {
          return _this6.getNestedFields(names, _this6.getFieldError);
        };

        this.getFieldError = function (name) {
          return _this6.getNestedField(name, function (fullName) {
            return utils_getErrorStrs(_this6.getFieldMember(fullName, 'errors'));
          });
        };

        this.isFieldValidating = function (name) {
          return _this6.getFieldMember(name, 'validating');
        };

        this.isFieldsValidating = function (ns) {
          var names = ns || _this6.getValidFieldsName();

          return names.some(function (n) {
            return _this6.isFieldValidating(n);
          });
        };

        this.isFieldTouched = function (name) {
          return _this6.getFieldMember(name, 'touched');
        };

        this.isFieldsTouched = function (ns) {
          var names = ns || _this6.getValidFieldsName();

          return names.some(function (n) {
            return _this6.isFieldTouched(n);
          });
        };
      };

      function createFieldsStore_createFieldsStore(fields) {
        return new createFieldsStore_FieldsStore(fields);
      } // CONCATENATED MODULE: ./node_modules/rc-form/es/createBaseForm.js

      /* eslint-disable react/prefer-es6-class */

      /* eslint-disable prefer-promise-reject-errors */


      var createBaseForm_DEFAULT_TRIGGER = 'onChange';

      function createBaseForm_createBaseForm() {
        var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var validateMessages = option.validateMessages,
            onFieldsChange = option.onFieldsChange,
            onValuesChange = option.onValuesChange,
            _option$mapProps = option.mapProps,
            mapProps = _option$mapProps === undefined ? utils_identity : _option$mapProps,
            mapPropsToFields = option.mapPropsToFields,
            fieldNameProp = option.fieldNameProp,
            fieldMetaProp = option.fieldMetaProp,
            fieldDataProp = option.fieldDataProp,
            _option$formPropName = option.formPropName,
            formPropName = _option$formPropName === undefined ? 'form' : _option$formPropName,
            formName = option.name,
            withRef = option.withRef;
        return function decorate(WrappedComponent) {
          var Form = create_react_class_default()({
            displayName: 'Form',
            mixins: mixins,
            getInitialState: function getInitialState() {
              var _this = this;

              var fields = mapPropsToFields && mapPropsToFields(this.props);
              this.fieldsStore = createFieldsStore_createFieldsStore(fields || {});
              this.instances = {};
              this.cachedBind = {};
              this.clearedFieldMetaCache = {};
              this.renderFields = {};
              this.domFields = {}; // HACK: https://github.com/ant-design/ant-design/issues/6406

              ['getFieldsValue', 'getFieldValue', 'setFieldsInitialValue', 'getFieldsError', 'getFieldError', 'isFieldValidating', 'isFieldsValidating', 'isFieldsTouched', 'isFieldTouched'].forEach(function (key) {
                _this[key] = function () {
                  var _fieldsStore;

                  if (false) {}

                  return (_fieldsStore = _this.fieldsStore)[key].apply(_fieldsStore, arguments);
                };
              });
              return {
                submitting: false
              };
            },
            componentDidMount: function componentDidMount() {
              this.cleanUpUselessFields();
            },
            componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
              if (mapPropsToFields) {
                this.fieldsStore.updateFields(mapPropsToFields(nextProps));
              }
            },
            componentDidUpdate: function componentDidUpdate() {
              this.cleanUpUselessFields();
            },
            onCollectCommon: function onCollectCommon(name, action, args) {
              var fieldMeta = this.fieldsStore.getFieldMeta(name);

              if (fieldMeta[action]) {
                fieldMeta[action].apply(fieldMeta, toConsumableArray_default()(args));
              } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
                var _fieldMeta$originalPr;

                (_fieldMeta$originalPr = fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr, toConsumableArray_default()(args));
              }

              var value = fieldMeta.getValueFromEvent ? fieldMeta.getValueFromEvent.apply(fieldMeta, toConsumableArray_default()(args)) : utils_getValueFromEvent.apply(undefined, toConsumableArray_default()(args));

              if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
                var valuesAll = this.fieldsStore.getAllValues();
                var valuesAllSet = {};
                valuesAll[name] = value;
                Object.keys(valuesAll).forEach(function (key) {
                  return set_default()(valuesAllSet, key, valuesAll[key]);
                });
                onValuesChange(extends_default()(defineProperty_default()({}, formPropName, this.getForm()), this.props), set_default()({}, name, value), valuesAllSet);
              }

              var field = this.fieldsStore.getField(name);
              return {
                name: name,
                field: extends_default()({}, field, {
                  value: value,
                  touched: true
                }),
                fieldMeta: fieldMeta
              };
            },
            onCollect: function onCollect(name_, action) {
              for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = arguments[_key];
              }

              var _onCollectCommon = this.onCollectCommon(name_, action, args),
                  name = _onCollectCommon.name,
                  field = _onCollectCommon.field,
                  fieldMeta = _onCollectCommon.fieldMeta;

              var validate = fieldMeta.validate;
              this.fieldsStore.setFieldsAsDirty();
              var newField = extends_default()({}, field, {
                dirty: utils_hasRules(validate)
              });
              this.setFields(defineProperty_default()({}, name, newField));
            },
            onCollectValidate: function onCollectValidate(name_, action) {
              for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = arguments[_key2];
              }

              var _onCollectCommon2 = this.onCollectCommon(name_, action, args),
                  field = _onCollectCommon2.field,
                  fieldMeta = _onCollectCommon2.fieldMeta;

              var newField = extends_default()({}, field, {
                dirty: true
              });
              this.fieldsStore.setFieldsAsDirty();
              this.validateFieldsInternal([newField], {
                action: action,
                options: {
                  firstFields: !!fieldMeta.validateFirst
                }
              });
            },
            getCacheBind: function getCacheBind(name, action, fn) {
              if (!this.cachedBind[name]) {
                this.cachedBind[name] = {};
              }

              var cache = this.cachedBind[name];

              if (!cache[action] || cache[action].oriFn !== fn) {
                cache[action] = {
                  fn: fn.bind(this, name, action),
                  oriFn: fn
                };
              }

              return cache[action].fn;
            },
            getFieldDecorator: function getFieldDecorator(name, fieldOption) {
              var _this2 = this;

              var props = this.getFieldProps(name, fieldOption);
              return function (fieldElem) {
                // We should put field in record if it is rendered
                _this2.renderFields[name] = true;

                var fieldMeta = _this2.fieldsStore.getFieldMeta(name);

                var originalProps = fieldElem.props;

                if (false) {
                  var defaultValuePropName, valuePropName;
                }

                fieldMeta.originalProps = originalProps;
                fieldMeta.ref = fieldElem.ref;
                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(fieldElem, extends_default()({}, props, _this2.fieldsStore.getFieldValuePropValue(fieldMeta)));
              };
            },
            getFieldProps: function getFieldProps(name) {
              var _this3 = this;

              var usersFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              if (!name) {
                throw new Error('Must call `getFieldProps` with valid name string!');
              }

              if (false) {}

              delete this.clearedFieldMetaCache[name];
              var fieldOption = extends_default()({
                name: name,
                trigger: createBaseForm_DEFAULT_TRIGGER,
                valuePropName: 'value',
                validate: []
              }, usersFieldOption);
              var rules = fieldOption.rules,
                  trigger = fieldOption.trigger,
                  _fieldOption$validate = fieldOption.validateTrigger,
                  validateTrigger = _fieldOption$validate === undefined ? trigger : _fieldOption$validate,
                  validate = fieldOption.validate;
              var fieldMeta = this.fieldsStore.getFieldMeta(name);

              if ('initialValue' in fieldOption) {
                fieldMeta.initialValue = fieldOption.initialValue;
              }

              var inputProps = extends_default()({}, this.fieldsStore.getFieldValuePropValue(fieldOption), {
                ref: this.getCacheBind(name, name + '__ref', this.saveRef)
              });

              if (fieldNameProp) {
                inputProps[fieldNameProp] = formName ? formName + '_' + name : name;
              }

              var validateRules = utils_normalizeValidateRules(validate, rules, validateTrigger);
              var validateTriggers = utils_getValidateTriggers(validateRules);
              validateTriggers.forEach(function (action) {
                if (inputProps[action]) return;
                inputProps[action] = _this3.getCacheBind(name, action, _this3.onCollectValidate);
              }); // make sure that the value will be collect

              if (trigger && validateTriggers.indexOf(trigger) === -1) {
                inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
              }

              var meta = extends_default()({}, fieldMeta, fieldOption, {
                validate: validateRules
              });
              this.fieldsStore.setFieldMeta(name, meta);

              if (fieldMetaProp) {
                inputProps[fieldMetaProp] = meta;
              }

              if (fieldDataProp) {
                inputProps[fieldDataProp] = this.fieldsStore.getField(name);
              } // This field is rendered, record it


              this.renderFields[name] = true;
              return inputProps;
            },
            getFieldInstance: function getFieldInstance(name) {
              return this.instances[name];
            },
            getRules: function getRules(fieldMeta, action) {
              var actionRules = fieldMeta.validate.filter(function (item) {
                return !action || item.trigger.indexOf(action) >= 0;
              }).map(function (item) {
                return item.rules;
              });
              return utils_flattenArray(actionRules);
            },
            setFields: function setFields(maybeNestedFields, callback) {
              var _this4 = this;

              var fields = this.fieldsStore.flattenRegisteredFields(maybeNestedFields);
              this.fieldsStore.setFields(fields);

              if (onFieldsChange) {
                var changedFields = Object.keys(fields).reduce(function (acc, name) {
                  return set_default()(acc, name, _this4.fieldsStore.getField(name));
                }, {});
                onFieldsChange(extends_default()(defineProperty_default()({}, formPropName, this.getForm()), this.props), changedFields, this.fieldsStore.getNestedAllFields());
              }

              this.forceUpdate(callback);
            },
            setFieldsValue: function setFieldsValue(changedValues, callback) {
              var fieldsMeta = this.fieldsStore.fieldsMeta;
              var values = this.fieldsStore.flattenRegisteredFields(changedValues);
              var newFields = Object.keys(values).reduce(function (acc, name) {
                var isRegistered = fieldsMeta[name];

                if (false) {}

                if (isRegistered) {
                  var value = values[name];
                  acc[name] = {
                    value: value
                  };
                }

                return acc;
              }, {});
              this.setFields(newFields, callback);

              if (onValuesChange) {
                var allValues = this.fieldsStore.getAllValues();
                onValuesChange(extends_default()(defineProperty_default()({}, formPropName, this.getForm()), this.props), changedValues, allValues);
              }
            },
            saveRef: function saveRef(name, _, component) {
              if (!component) {
                var _fieldMeta = this.fieldsStore.getFieldMeta(name);

                if (!_fieldMeta.preserve) {
                  // after destroy, delete data
                  this.clearedFieldMetaCache[name] = {
                    field: this.fieldsStore.getField(name),
                    meta: _fieldMeta
                  };
                  this.clearField(name);
                }

                delete this.domFields[name];
                return;
              }

              this.domFields[name] = true;
              this.recoverClearedField(name);
              var fieldMeta = this.fieldsStore.getFieldMeta(name);

              if (fieldMeta) {
                var ref = fieldMeta.ref;

                if (ref) {
                  if (typeof ref === 'string') {
                    throw new Error('can not set ref string for ' + name);
                  } else if (typeof ref === 'function') {
                    ref(component);
                  } else if (Object.prototype.hasOwnProperty.call(ref, 'current')) {
                    ref.current = component;
                  }
                }
              }

              this.instances[name] = component;
            },
            cleanUpUselessFields: function cleanUpUselessFields() {
              var _this5 = this;

              var fieldList = this.fieldsStore.getAllFieldsName();
              var removedList = fieldList.filter(function (field) {
                var fieldMeta = _this5.fieldsStore.getFieldMeta(field);

                return !_this5.renderFields[field] && !_this5.domFields[field] && !fieldMeta.preserve;
              });

              if (removedList.length) {
                removedList.forEach(this.clearField);
              }

              this.renderFields = {};
            },
            clearField: function clearField(name) {
              this.fieldsStore.clearField(name);
              delete this.instances[name];
              delete this.cachedBind[name];
            },
            resetFields: function resetFields(ns) {
              var _this6 = this;

              var newFields = this.fieldsStore.resetFields(ns);

              if (Object.keys(newFields).length > 0) {
                this.setFields(newFields);
              }

              if (ns) {
                var names = Array.isArray(ns) ? ns : [ns];
                names.forEach(function (name) {
                  return delete _this6.clearedFieldMetaCache[name];
                });
              } else {
                this.clearedFieldMetaCache = {};
              }
            },
            recoverClearedField: function recoverClearedField(name) {
              if (this.clearedFieldMetaCache[name]) {
                this.fieldsStore.setFields(defineProperty_default()({}, name, this.clearedFieldMetaCache[name].field));
                this.fieldsStore.setFieldMeta(name, this.clearedFieldMetaCache[name].meta);
                delete this.clearedFieldMetaCache[name];
              }
            },
            validateFieldsInternal: function validateFieldsInternal(fields, _ref, callback) {
              var _this7 = this;

              var fieldNames = _ref.fieldNames,
                  action = _ref.action,
                  _ref$options = _ref.options,
                  options = _ref$options === undefined ? {} : _ref$options;
              var allRules = {};
              var allValues = {};
              var allFields = {};
              var alreadyErrors = {};
              fields.forEach(function (field) {
                var name = field.name;

                if (options.force !== true && field.dirty === false) {
                  if (field.errors) {
                    set_default()(alreadyErrors, name, {
                      errors: field.errors
                    });
                  }

                  return;
                }

                var fieldMeta = _this7.fieldsStore.getFieldMeta(name);

                var newField = extends_default()({}, field);
                newField.errors = undefined;
                newField.validating = true;
                newField.dirty = true;
                allRules[name] = _this7.getRules(fieldMeta, action);
                allValues[name] = newField.value;
                allFields[name] = newField;
              });
              this.setFields(allFields); // in case normalize

              Object.keys(allValues).forEach(function (f) {
                allValues[f] = _this7.fieldsStore.getFieldValue(f);
              });

              if (callback && utils_isEmptyObject(allFields)) {
                callback(utils_isEmptyObject(alreadyErrors) ? null : alreadyErrors, this.fieldsStore.getFieldsValue(fieldNames));
                return;
              }

              var validator = new async_validator_es(allRules);

              if (validateMessages) {
                validator.messages(validateMessages);
              }

              validator.validate(allValues, options, function (errors) {
                var errorsGroup = extends_default()({}, alreadyErrors);

                if (errors && errors.length) {
                  errors.forEach(function (e) {
                    var errorFieldName = e.field;
                    var fieldName = errorFieldName; // Handle using array validation rule.
                    // ref: https://github.com/ant-design/ant-design/issues/14275

                    Object.keys(allRules).some(function (ruleFieldName) {
                      var rules = allRules[ruleFieldName] || []; // Exist if match rule

                      if (ruleFieldName === errorFieldName) {
                        fieldName = ruleFieldName;
                        return true;
                      } // Skip if not match array type


                      if (rules.every(function (_ref2) {
                        var type = _ref2.type;
                        return type !== 'array';
                      }) && errorFieldName.indexOf(ruleFieldName) !== 0) {
                        return false;
                      } // Exist if match the field name


                      var restPath = errorFieldName.slice(ruleFieldName.length + 1);

                      if (/\d+/.test(restPath)) {
                        fieldName = ruleFieldName;
                        return true;
                      }

                      return false;
                    });
                    var field = get_default()(errorsGroup, fieldName);

                    if (typeof field !== 'object' || Array.isArray(field)) {
                      set_default()(errorsGroup, fieldName, {
                        errors: []
                      });
                    }

                    var fieldErrors = get_default()(errorsGroup, fieldName.concat('.errors'));
                    fieldErrors.push(e);
                  });
                }

                var expired = [];
                var nowAllFields = {};
                Object.keys(allRules).forEach(function (name) {
                  var fieldErrors = get_default()(errorsGroup, name);

                  var nowField = _this7.fieldsStore.getField(name); // avoid concurrency problems


                  if (!eq_default()(nowField.value, allValues[name])) {
                    expired.push({
                      name: name
                    });
                  } else {
                    nowField.errors = fieldErrors && fieldErrors.errors;
                    nowField.value = allValues[name];
                    nowField.validating = false;
                    nowField.dirty = false;
                    nowAllFields[name] = nowField;
                  }
                });

                _this7.setFields(nowAllFields);

                if (callback) {
                  if (expired.length) {
                    expired.forEach(function (_ref3) {
                      var name = _ref3.name;
                      var fieldErrors = [{
                        message: name + ' need to revalidate',
                        field: name
                      }];
                      set_default()(errorsGroup, name, {
                        expired: true,
                        errors: fieldErrors
                      });
                    });
                  }

                  callback(utils_isEmptyObject(errorsGroup) ? null : errorsGroup, _this7.fieldsStore.getFieldsValue(fieldNames));
                }
              });
            },
            validateFields: function validateFields(ns, opt, cb) {
              var _this8 = this;

              var pending = new Promise(function (resolve, reject) {
                var _getParams = utils_getParams(ns, opt, cb),
                    names = _getParams.names,
                    options = _getParams.options;

                var _getParams2 = utils_getParams(ns, opt, cb),
                    callback = _getParams2.callback;

                if (!callback || typeof callback === 'function') {
                  var oldCb = callback;

                  callback = function callback(errors, values) {
                    if (oldCb) {
                      oldCb(errors, values);
                    } else if (errors) {
                      reject({
                        errors: errors,
                        values: values
                      });
                    } else {
                      resolve(values);
                    }
                  };
                }

                var fieldNames = names ? _this8.fieldsStore.getValidFieldsFullName(names) : _this8.fieldsStore.getValidFieldsName();
                var fields = fieldNames.filter(function (name) {
                  var fieldMeta = _this8.fieldsStore.getFieldMeta(name);

                  return utils_hasRules(fieldMeta.validate);
                }).map(function (name) {
                  var field = _this8.fieldsStore.getField(name);

                  field.value = _this8.fieldsStore.getFieldValue(name);
                  return field;
                });

                if (!fields.length) {
                  callback(null, _this8.fieldsStore.getFieldsValue(fieldNames));
                  return;
                }

                if (!('firstFields' in options)) {
                  options.firstFields = fieldNames.filter(function (name) {
                    var fieldMeta = _this8.fieldsStore.getFieldMeta(name);

                    return !!fieldMeta.validateFirst;
                  });
                }

                _this8.validateFieldsInternal(fields, {
                  fieldNames: fieldNames,
                  options: options
                }, callback);
              });
              pending['catch'](function (e) {
                if (console.error && "production" !== 'production') {
                  console.error(e);
                }

                return e;
              });
              return pending;
            },
            isSubmitting: function isSubmitting() {
              if (false) {}

              return this.state.submitting;
            },
            submit: function submit(callback) {
              var _this9 = this;

              if (false) {}

              var fn = function fn() {
                _this9.setState({
                  submitting: false
                });
              };

              this.setState({
                submitting: true
              });
              callback(fn);
            },
            render: function render() {
              var _props = this.props,
                  wrappedComponentRef = _props.wrappedComponentRef,
                  restProps = objectWithoutProperties_default()(_props, ['wrappedComponentRef']); // eslint-disable-line

              var formProps = defineProperty_default()({}, formPropName, this.getForm());

              if (withRef) {
                if (false) {}

                formProps.ref = 'wrappedComponent';
              } else if (wrappedComponentRef) {
                formProps.ref = wrappedComponentRef;
              }

              var props = mapProps.call(this, extends_default()({}, formProps, restProps));
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(WrappedComponent, props);
            }
          });
          return utils_argumentContainer(Form, WrappedComponent);
        };
      }
      /* harmony default export */


      var es_createBaseForm = createBaseForm_createBaseForm; // CONCATENATED MODULE: ./node_modules/rc-form/es/createForm.js

      var createForm_mixin = {
        getForm: function getForm() {
          return {
            getFieldsValue: this.fieldsStore.getFieldsValue,
            getFieldValue: this.fieldsStore.getFieldValue,
            getFieldInstance: this.getFieldInstance,
            setFieldsValue: this.setFieldsValue,
            setFields: this.setFields,
            setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
            getFieldDecorator: this.getFieldDecorator,
            getFieldProps: this.getFieldProps,
            getFieldsError: this.fieldsStore.getFieldsError,
            getFieldError: this.fieldsStore.getFieldError,
            isFieldValidating: this.fieldsStore.isFieldValidating,
            isFieldsValidating: this.fieldsStore.isFieldsValidating,
            isFieldsTouched: this.fieldsStore.isFieldsTouched,
            isFieldTouched: this.fieldsStore.isFieldTouched,
            isSubmitting: this.isSubmitting,
            submit: this.submit,
            validateFields: this.validateFields,
            resetFields: this.resetFields
          };
        }
      };

      function createForm_createForm(options) {
        return es_createBaseForm(options, [createForm_mixin]);
      }
      /* harmony default export */


      var es_createForm = createForm_createForm; // CONCATENATED MODULE: ./node_modules/rc-form/es/createDOMForm.js

      function createDOMForm_computedStyle(el, prop) {
        var getComputedStyle = window.getComputedStyle;
        var style = // If we have getComputedStyle
        getComputedStyle ? // Query it
        // TODO: From CSS-Query notes, we might need (node, null) for FF
        getComputedStyle(el) : // Otherwise, we are in IE and use currentStyle
        el.currentStyle;

        if (style) {
          return style[// Switch to camelCase for CSSOM
          // DEV: Grabbed from jQuery
          // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
          // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
          prop.replace(/-(\w)/gi, function (word, letter) {
            return letter.toUpperCase();
          })];
        }

        return undefined;
      }

      function createDOMForm_getScrollableContainer(n) {
        var node = n;
        var nodeName = void 0;
        /* eslint no-cond-assign:0 */

        while ((nodeName = node.nodeName.toLowerCase()) !== 'body') {
          var overflowY = createDOMForm_computedStyle(node, 'overflowY'); // https://stackoverflow.com/a/36900407/3040605

          if (node !== n && (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
            return node;
          }

          node = node.parentNode;
        }

        return nodeName === 'body' ? node.ownerDocument : node;
      }

      var createDOMForm_mixin = {
        getForm: function getForm() {
          return extends_default()({}, createForm_mixin.getForm.call(this), {
            validateFieldsAndScroll: this.validateFieldsAndScroll
          });
        },
        validateFieldsAndScroll: function validateFieldsAndScroll(ns, opt, cb) {
          var _this = this;

          var _getParams = utils_getParams(ns, opt, cb),
              names = _getParams.names,
              callback = _getParams.callback,
              options = _getParams.options;

          var newCb = function newCb(error, values) {
            if (error) {
              var validNames = _this.fieldsStore.getValidFieldsName();

              var firstNode = void 0;
              var firstTop = void 0;
              validNames.forEach(function (name) {
                if (has_default()(error, name)) {
                  var instance = _this.getFieldInstance(name);

                  if (instance) {
                    var node = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(instance);
                    var top = node.getBoundingClientRect().top;

                    if (node.type !== 'hidden' && (firstTop === undefined || firstTop > top)) {
                      firstTop = top;
                      firstNode = node;
                    }
                  }
                }
              });

              if (firstNode) {
                var c = options.container || createDOMForm_getScrollableContainer(firstNode);
                dom_scroll_into_view_lib_default()(firstNode, c, extends_default()({
                  onlyScrollIfNeeded: true
                }, options.scroll));
              }
            }

            if (typeof callback === 'function') {
              callback(error, values);
            }
          };

          return this.validateFields(names, options, newCb);
        }
      };

      function createDOMForm_createDOMForm(option) {
        return es_createBaseForm(extends_default()({}, option), [createDOMForm_mixin]);
      }
      /* harmony default export */


      var es_createDOMForm = createDOMForm_createDOMForm; // CONCATENATED MODULE: ./node_modules/antd/es/form/constants.js

      var FIELD_META_PROP = 'data-__meta';
      var FIELD_DATA_PROP = 'data-__field'; // CONCATENATED MODULE: ./node_modules/antd/es/form/FormItem.js

      var FormItem_FormItem = function (_React$Component) {
        inherits_default()(FormItem, _React$Component);

        function FormItem() {
          classCallCheck_default()(this, FormItem);

          var _this = possibleConstructorReturn_default()(this, (FormItem.__proto__ || Object.getPrototypeOf(FormItem)).apply(this, arguments));

          _this.state = {
            helpShow: false
          };

          _this.onHelpAnimEnd = function (_key, helpShow) {
            _this.setState({
              helpShow: helpShow
            });
          }; // Resolve duplicated ids bug between different forms
          // https://github.com/ant-design/ant-design/issues/7351


          _this.onLabelClick = function (e) {
            var label = _this.props.label;

            var id = _this.props.id || _this.getId();

            if (!id) {
              return;
            }

            var controls = document.querySelectorAll('[id="' + id + '"]');

            if (controls.length !== 1) {
              // Only prevent in default situation
              // Avoid preventing event in `label={<a href="xx">link</a>}``
              if (typeof label === 'string') {
                e.preventDefault();
              }

              var control = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](_this).querySelector('[id="' + id + '"]');

              if (control && control.focus) {
                control.focus();
              }
            }
          };

          return _this;
        }

        createClass_default()(FormItem, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            _util_warning(this.getControls(this.props.children, true).length <= 1, '`Form.Item` cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate() {
            for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
              args[_key2] = arguments[_key2];
            }

            return PureRenderMixin_default.a.shouldComponentUpdate.apply(this, args);
          }
        }, {
          key: 'getHelpMsg',
          value: function getHelpMsg() {
            var props = this.props;
            var onlyControl = this.getOnlyControl();

            if (props.help === undefined && onlyControl) {
              var errors = this.getField().errors;
              return errors ? errors.map(function (e) {
                return e.message;
              }).join(', ') : '';
            }

            return props.help;
          }
        }, {
          key: 'getControls',
          value: function getControls(children, recursively) {
            var controls = [];
            var childrenArray = external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].toArray(children);

            for (var i = 0; i < childrenArray.length; i++) {
              if (!recursively && controls.length > 0) {
                break;
              }

              var child = childrenArray[i];

              if (child.type && (child.type === FormItem || child.type.displayName === 'FormItem')) {
                continue;
              }

              if (!child.props) {
                continue;
              }

              if (FIELD_META_PROP in child.props) {
                // And means FIELD_DATA_PROP in chidl.props, too.
                controls.push(child);
              } else if (child.props.children) {
                controls = controls.concat(this.getControls(child.props.children, recursively));
              }
            }

            return controls;
          }
        }, {
          key: 'getOnlyControl',
          value: function getOnlyControl() {
            var child = this.getControls(this.props.children, false)[0];
            return child !== undefined ? child : null;
          }
        }, {
          key: 'getChildProp',
          value: function getChildProp(prop) {
            var child = this.getOnlyControl();
            return child && child.props && child.props[prop];
          }
        }, {
          key: 'getId',
          value: function getId() {
            return this.getChildProp('id');
          }
        }, {
          key: 'getMeta',
          value: function getMeta() {
            return this.getChildProp(FIELD_META_PROP);
          }
        }, {
          key: 'getField',
          value: function getField() {
            return this.getChildProp(FIELD_DATA_PROP);
          }
        }, {
          key: 'renderHelp',
          value: function renderHelp() {
            var prefixCls = this.props.prefixCls;
            var help = this.getHelpMsg();
            var children = help ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-explain',
              key: 'help'
            }, help) : null;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], {
              transitionName: 'show-help',
              component: '',
              transitionAppear: true,
              key: 'help',
              onEnd: this.onHelpAnimEnd
            }, children);
          }
        }, {
          key: 'renderExtra',
          value: function renderExtra() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                extra = _props.extra;
            return extra ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-extra'
            }, extra) : null;
          }
        }, {
          key: 'getValidateStatus',
          value: function getValidateStatus() {
            var onlyControl = this.getOnlyControl();

            if (!onlyControl) {
              return '';
            }

            var field = this.getField();

            if (field.validating) {
              return 'validating';
            }

            if (field.errors) {
              return 'error';
            }

            var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;

            if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
              return 'success';
            }

            return '';
          }
        }, {
          key: 'renderValidateWrapper',
          value: function renderValidateWrapper(c1, c2, c3) {
            var props = this.props;
            var onlyControl = this.getOnlyControl;
            var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
            var classes = this.props.prefixCls + '-item-control';

            if (validateStatus) {
              classes = classnames_default()(this.props.prefixCls + '-item-control', {
                'has-feedback': props.hasFeedback || validateStatus === 'validating',
                'has-success': validateStatus === 'success',
                'has-warning': validateStatus === 'warning',
                'has-error': validateStatus === 'error',
                'is-validating': validateStatus === 'validating'
              });
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: classes
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: this.props.prefixCls + '-item-children'
            }, c1), c2, c3);
          }
        }, {
          key: 'renderWrapper',
          value: function renderWrapper(children) {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                wrapperCol = _props2.wrapperCol;
            var className = classnames_default()(prefixCls + '-item-control-wrapper', wrapperCol && wrapperCol.className);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](grid_col, extends_default()({}, wrapperCol, {
              className: className,
              key: 'wrapper'
            }), children);
          }
        }, {
          key: 'isRequired',
          value: function isRequired() {
            var required = this.props.required;

            if (required !== undefined) {
              return required;
            }

            if (this.getOnlyControl()) {
              var meta = this.getMeta() || {};
              var validate = meta.validate || [];
              return validate.filter(function (item) {
                return !!item.rules;
              }).some(function (item) {
                return item.rules.some(function (rule) {
                  return rule.required;
                });
              });
            }

            return false;
          }
        }, {
          key: 'renderLabel',
          value: function renderLabel() {
            var _props3 = this.props,
                prefixCls = _props3.prefixCls,
                label = _props3.label,
                labelCol = _props3.labelCol,
                colon = _props3.colon,
                id = _props3.id;
            var context = this.context;
            var required = this.isRequired();
            var labelColClassName = classnames_default()(prefixCls + '-item-label', labelCol && labelCol.className);
            var labelClassName = classnames_default()(defineProperty_default()({}, prefixCls + '-item-required', required));
            var labelChildren = label; // Keep label is original where there should have no colon

            var haveColon = colon && !context.vertical; // Remove duplicated user input colon

            if (haveColon && typeof label === 'string' && label.trim() !== '') {
              labelChildren = label.replace(/[：|:]\s*$/, '');
            }

            return label ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](grid_col, extends_default()({}, labelCol, {
              className: labelColClassName,
              key: 'label'
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('label', {
              htmlFor: id || this.getId(),
              className: labelClassName,
              title: typeof label === 'string' ? label : '',
              onClick: this.onLabelClick
            }, labelChildren)) : null;
          }
        }, {
          key: 'renderChildren',
          value: function renderChildren() {
            var children = this.props.children;
            return [this.renderLabel(), this.renderWrapper(this.renderValidateWrapper(children, this.renderHelp(), this.renderExtra()))];
          }
        }, {
          key: 'renderFormItem',
          value: function renderFormItem(children) {
            var _itemClassName;

            var props = this.props;
            var prefixCls = props.prefixCls;
            var style = props.style;
            var itemClassName = (_itemClassName = {}, defineProperty_default()(_itemClassName, prefixCls + '-item', true), defineProperty_default()(_itemClassName, prefixCls + '-item-with-help', !!this.getHelpMsg() || this.state.helpShow), defineProperty_default()(_itemClassName, prefixCls + '-item-no-colon', !props.colon), defineProperty_default()(_itemClassName, '' + props.className, !!props.className), _itemClassName);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](grid_row, {
              className: classnames_default()(itemClassName),
              style: style
            }, children);
          }
        }, {
          key: 'render',
          value: function render() {
            var children = this.renderChildren();
            return this.renderFormItem(children);
          }
        }]);
        return FormItem;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var form_FormItem = FormItem_FormItem;
      FormItem_FormItem.defaultProps = {
        hasFeedback: false,
        prefixCls: 'ant-form',
        colon: true
      };
      FormItem_FormItem.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node]),
        labelCol: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        help: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool]),
        validateStatus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['', 'success', 'warning', 'error', 'validating']),
        hasFeedback: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        wrapperCol: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        colon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      FormItem_FormItem.contextTypes = {
        vertical: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      }; // CONCATENATED MODULE: ./node_modules/antd/es/form/Form.js

      var Form_Form = function (_React$Component) {
        inherits_default()(Form, _React$Component);

        function Form(props) {
          classCallCheck_default()(this, Form);

          var _this = possibleConstructorReturn_default()(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

          _util_warning(!props.form, 'It is unnecessary to pass `form` to `Form` after antd@1.7.0.');

          return _this;
        }

        createClass_default()(Form, [{
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return PureRenderMixin_default.a.shouldComponentUpdate.apply(this, args);
          }
        }, {
          key: 'getChildContext',
          value: function getChildContext() {
            var layout = this.props.layout;
            return {
              vertical: layout === 'vertical'
            };
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                hideRequiredMark = _props.hideRequiredMark,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                layout = _props.layout;
            var formClassName = classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-horizontal', layout === 'horizontal'), defineProperty_default()(_classNames, prefixCls + '-vertical', layout === 'vertical'), defineProperty_default()(_classNames, prefixCls + '-inline', layout === 'inline'), defineProperty_default()(_classNames, prefixCls + '-hide-required-mark', hideRequiredMark), _classNames), className);
            var formProps = Object(es["default"])(this.props, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark']);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('form', extends_default()({}, formProps, {
              className: formClassName
            }));
          }
        }]);
        return Form;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var form_Form = Form_Form;
      Form_Form.defaultProps = {
        prefixCls: 'ant-form',
        layout: 'horizontal',
        hideRequiredMark: false,
        onSubmit: function onSubmit(e) {
          e.preventDefault();
        }
      };
      Form_Form.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        layout: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['horizontal', 'inline', 'vertical']),
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        onSubmit: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        hideRequiredMark: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      Form_Form.childContextTypes = {
        vertical: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      Form_Form.Item = form_FormItem;
      Form_Form.createFormField = createFormField_createFormField;

      Form_Form.create = function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return es_createDOMForm(extends_default()({
          fieldNameProp: 'id'
        }, options, {
          fieldMetaProp: FIELD_META_PROP,
          fieldDataProp: FIELD_DATA_PROP
        }));
      }; // CONCATENATED MODULE: ./node_modules/antd/es/form/index.js

      /* harmony default export */


      var es_form = form_Form; // EXTERNAL MODULE: ./node_modules/rc-input-number/es/index.js + 3 modules

      var rc_input_number_es = __webpack_require__(375); // CONCATENATED MODULE: ./node_modules/antd/es/input-number/index.js


      var input_number_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var input_number_InputNumber = function (_React$Component) {
        inherits_default()(InputNumber, _React$Component);

        function InputNumber() {
          classCallCheck_default()(this, InputNumber);
          return possibleConstructorReturn_default()(this, (InputNumber.__proto__ || Object.getPrototypeOf(InputNumber)).apply(this, arguments));
        }

        createClass_default()(InputNumber, [{
          key: 'render',
          value: function render() {
            var _classNames,
                _this2 = this;

            var _a = this.props,
                className = _a.className,
                size = _a.size,
                others = input_number_rest(_a, ["className", "size"]);
            var inputNumberClass = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, this.props.prefixCls + '-lg', size === 'large'), defineProperty_default()(_classNames, this.props.prefixCls + '-sm', size === 'small'), _classNames), className);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_input_number_es["default"], extends_default()({
              ref: function ref(c) {
                return _this2.inputNumberRef = c;
              },
              className: inputNumberClass
            }, others));
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.inputNumberRef.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.inputNumberRef.blur();
          }
        }]);
        return InputNumber;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var input_number = input_number_InputNumber;
      input_number_InputNumber.defaultProps = {
        prefixCls: 'ant-input-number',
        step: 1
      }; // CONCATENATED MODULE: ./node_modules/antd/es/layout/layout.js

      var layout_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      function layout_generator(props) {
        return function (BasicComponent) {
          return function (_React$Component) {
            inherits_default()(Adapter, _React$Component);

            function Adapter() {
              classCallCheck_default()(this, Adapter);
              return possibleConstructorReturn_default()(this, (Adapter.__proto__ || Object.getPrototypeOf(Adapter)).apply(this, arguments));
            }

            createClass_default()(Adapter, [{
              key: 'render',
              value: function render() {
                var prefixCls = props.prefixCls;
                return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](BasicComponent, extends_default()({
                  prefixCls: prefixCls
                }, this.props));
              }
            }]);
            return Adapter;
          }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
        };
      }

      var layout_Basic = function (_React$Component2) {
        inherits_default()(Basic, _React$Component2);

        function Basic() {
          classCallCheck_default()(this, Basic);
          return possibleConstructorReturn_default()(this, (Basic.__proto__ || Object.getPrototypeOf(Basic)).apply(this, arguments));
        }

        createClass_default()(Basic, [{
          key: 'render',
          value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                children = _a.children,
                others = layout_rest(_a, ["prefixCls", "className", "children"]);
            var divCls = classnames_default()(className, prefixCls);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({
              className: divCls
            }, others), children);
          }
        }]);
        return Basic;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      var layout_BasicLayout = function (_React$Component3) {
        inherits_default()(BasicLayout, _React$Component3);

        function BasicLayout() {
          classCallCheck_default()(this, BasicLayout);

          var _this3 = possibleConstructorReturn_default()(this, (BasicLayout.__proto__ || Object.getPrototypeOf(BasicLayout)).apply(this, arguments));

          _this3.state = {
            siders: []
          };
          return _this3;
        }

        createClass_default()(BasicLayout, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this4 = this;

            return {
              siderHook: {
                addSider: function addSider(id) {
                  _this4.setState({
                    siders: [].concat(toConsumableArray_default()(_this4.state.siders), [id])
                  });
                },
                removeSider: function removeSider(id) {
                  _this4.setState({
                    siders: _this4.state.siders.filter(function (currentId) {
                      return currentId !== id;
                    })
                  });
                }
              }
            };
          }
        }, {
          key: 'render',
          value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                children = _a.children,
                hasSider = _a.hasSider,
                others = layout_rest(_a, ["prefixCls", "className", "children", "hasSider"]);
            var divCls = classnames_default()(className, prefixCls, defineProperty_default()({}, prefixCls + '-has-sider', hasSider || this.state.siders.length > 0));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({
              className: divCls
            }, others), children);
          }
        }]);
        return BasicLayout;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      layout_BasicLayout.childContextTypes = {
        siderHook: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };
      var layout_Layout = layout_generator({
        prefixCls: 'ant-layout'
      })(layout_BasicLayout);
      var layout_Header = layout_generator({
        prefixCls: 'ant-layout-header'
      })(layout_Basic);
      var layout_Footer = layout_generator({
        prefixCls: 'ant-layout-footer'
      })(layout_Basic);
      var layout_Content = layout_generator({
        prefixCls: 'ant-layout-content'
      })(layout_Basic);
      layout_Layout.Header = layout_Header;
      layout_Layout.Footer = layout_Footer;
      layout_Layout.Content = layout_Content;
      /* harmony default export */

      var layout_layout = layout_Layout; // CONCATENATED MODULE: ./node_modules/antd/es/layout/Sider.js

      var Sider_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      }; // matchMedia polyfill for
      // https://github.com/WickyNilliams/enquire.js/issues/82


      if (typeof window !== 'undefined') {
        var Sider_matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
          return {
            media: mediaQuery,
            matches: false,
            addListener: function addListener() {},
            removeListener: function removeListener() {}
          };
        };

        window.matchMedia = window.matchMedia || Sider_matchMediaPolyfill;
      }

      var Sider_dimensionMap = {
        xs: '480px',
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
        xxl: '1600px'
      };

      var Sider_generateId = function () {
        var i = 0;
        return function () {
          var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          i += 1;
          return '' + prefix + i;
        };
      }();

      var Sider_Sider = function (_React$Component) {
        inherits_default()(Sider, _React$Component);

        function Sider(props) {
          classCallCheck_default()(this, Sider);

          var _this = possibleConstructorReturn_default()(this, (Sider.__proto__ || Object.getPrototypeOf(Sider)).call(this, props));

          _this.responsiveHandler = function (mql) {
            _this.setState({
              below: mql.matches
            });

            if (_this.state.collapsed !== mql.matches) {
              _this.setCollapsed(mql.matches, 'responsive');
            }
          };

          _this.setCollapsed = function (collapsed, type) {
            if (!('collapsed' in _this.props)) {
              _this.setState({
                collapsed: collapsed
              });
            }

            var onCollapse = _this.props.onCollapse;

            if (onCollapse) {
              onCollapse(collapsed, type);
            }
          };

          _this.toggle = function () {
            var collapsed = !_this.state.collapsed;

            _this.setCollapsed(collapsed, 'clickTrigger');
          };

          _this.belowShowChange = function () {
            _this.setState({
              belowShow: !_this.state.belowShow
            });
          };

          _this.uniqueId = Sider_generateId('ant-sider-');
          var matchMedia = void 0;

          if (typeof window !== 'undefined') {
            matchMedia = window.matchMedia;
          }

          if (matchMedia && props.breakpoint && props.breakpoint in Sider_dimensionMap) {
            _this.mql = matchMedia('(max-width: ' + Sider_dimensionMap[props.breakpoint] + ')');
          }

          var collapsed = void 0;

          if ('collapsed' in props) {
            collapsed = props.collapsed;
          } else {
            collapsed = props.defaultCollapsed;
          }

          _this.state = {
            collapsed: collapsed,
            below: false
          };
          return _this;
        }

        createClass_default()(Sider, [{
          key: 'getChildContext',
          value: function getChildContext() {
            return {
              siderCollapsed: this.state.collapsed,
              collapsedWidth: this.props.collapsedWidth
            };
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('collapsed' in nextProps) {
              this.setState({
                collapsed: nextProps.collapsed
              });
            }
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (this.mql) {
              this.mql.addListener(this.responsiveHandler);
              this.responsiveHandler(this.mql);
            }

            if (this.context.siderHook) {
              this.context.siderHook.addSider(this.uniqueId);
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.mql) {
              this.mql.removeListener(this.responsiveHandler);
            }

            if (this.context.siderHook) {
              this.context.siderHook.removeSider(this.uniqueId);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                collapsible = _a.collapsible,
                reverseArrow = _a.reverseArrow,
                trigger = _a.trigger,
                style = _a.style,
                width = _a.width,
                collapsedWidth = _a.collapsedWidth,
                others = Sider_rest(_a, ["prefixCls", "className", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth"]);
            var divProps = Object(es["default"])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint']);
            var siderWidth = this.state.collapsed ? collapsedWidth : width; // special trigger when collapsedWidth == 0

            var zeroWidthTrigger = collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px' ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              onClick: this.toggle,
              className: prefixCls + '-zero-width-trigger'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'bars'
            })) : null;
            var iconObj = {
              'expanded': reverseArrow ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: 'right'
              }) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: 'left'
              }),
              'collapsed': reverseArrow ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: 'left'
              }) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: 'right'
              })
            };
            var status = this.state.collapsed ? 'collapsed' : 'expanded';
            var defaultTrigger = iconObj[status];
            var triggerDom = trigger !== null ? zeroWidthTrigger || external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-trigger',
              onClick: this.toggle,
              style: {
                width: siderWidth
              }
            }, trigger || defaultTrigger) : null;
            var divStyle = extends_default()({}, style, {
              flex: '0 0 ' + siderWidth + 'px',
              maxWidth: siderWidth + 'px',
              minWidth: siderWidth + 'px',
              width: siderWidth + 'px'
            });
            var siderCls = classnames_default()(className, prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-collapsed', !!this.state.collapsed), defineProperty_default()(_classNames, prefixCls + '-has-trigger', collapsible && trigger !== null && !zeroWidthTrigger), defineProperty_default()(_classNames, prefixCls + '-below', !!this.state.below), defineProperty_default()(_classNames, prefixCls + '-zero-width', siderWidth === 0 || siderWidth === '0' || siderWidth === '0px'), _classNames));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({
              className: siderCls
            }, divProps, {
              style: divStyle
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-children'
            }, this.props.children), collapsible || this.state.below && zeroWidthTrigger ? triggerDom : null);
          }
        }]);
        return Sider;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var layout_Sider = Sider_Sider;
      Sider_Sider.__ANT_LAYOUT_SIDER = true;
      Sider_Sider.defaultProps = {
        prefixCls: 'ant-layout-sider',
        collapsible: false,
        defaultCollapsed: false,
        reverseArrow: false,
        width: 200,
        collapsedWidth: 80,
        style: {}
      };
      Sider_Sider.childContextTypes = {
        siderCollapsed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        collapsedWidth: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string])
      };
      Sider_Sider.contextTypes = {
        siderHook: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      }; // CONCATENATED MODULE: ./node_modules/antd/es/layout/index.js

      layout_layout.Sider = layout_Sider;
      /* harmony default export */

      var es_layout = layout_layout; // CONCATENATED MODULE: ./node_modules/antd/es/_util/isCssAnimationSupported.js

      var isCssAnimationSupported_animation = void 0;

      function isCssAnimationSupported() {
        if (isCssAnimationSupported_animation !== undefined) {
          return isCssAnimationSupported_animation;
        }

        var domPrefixes = 'Webkit Moz O ms Khtml'.split(' ');
        var elm = document.createElement('div');

        if (elm.style.animationName !== undefined) {
          isCssAnimationSupported_animation = true;
        }

        if (isCssAnimationSupported_animation !== undefined) {
          for (var i = 0; i < domPrefixes.length; i++) {
            if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
              isCssAnimationSupported_animation = true;
              break;
            }
          }
        }

        isCssAnimationSupported_animation = isCssAnimationSupported_animation || false;
        return isCssAnimationSupported_animation;
      }
      /* harmony default export */


      var _util_isCssAnimationSupported = isCssAnimationSupported; // CONCATENATED MODULE: ./node_modules/antd/es/spin/index.js

      var spin_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var spin_Spin = function (_React$Component) {
        inherits_default()(Spin, _React$Component);

        function Spin(props) {
          classCallCheck_default()(this, Spin);

          var _this = possibleConstructorReturn_default()(this, (Spin.__proto__ || Object.getPrototypeOf(Spin)).call(this, props));

          var spinning = props.spinning;
          _this.state = {
            spinning: spinning
          };
          return _this;
        }

        createClass_default()(Spin, [{
          key: 'isNestedPattern',
          value: function isNestedPattern() {
            return !!(this.props && this.props.children);
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!_util_isCssAnimationSupported()) {
              // Show text in IE9
              this.setState({
                notCssAnimationSupported: true
              });
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.debounceTimeout) {
              clearTimeout(this.debounceTimeout);
            }

            if (this.delayTimeout) {
              clearTimeout(this.delayTimeout);
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var currentSpinning = this.props.spinning;
            var spinning = nextProps.spinning;
            var delay = this.props.delay;

            if (this.debounceTimeout) {
              clearTimeout(this.debounceTimeout);
            }

            if (currentSpinning && !spinning) {
              this.debounceTimeout = window.setTimeout(function () {
                return _this2.setState({
                  spinning: spinning
                });
              }, 200);

              if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
              }
            } else {
              if (spinning && delay && !isNaN(Number(delay))) {
                if (this.delayTimeout) {
                  clearTimeout(this.delayTimeout);
                }

                this.delayTimeout = window.setTimeout(function () {
                  return _this2.setState({
                    spinning: spinning
                  });
                }, delay);
              } else {
                this.setState({
                  spinning: spinning
                });
              }
            }
          }
        }, {
          key: 'renderIndicator',
          value: function renderIndicator() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                indicator = _props.indicator;
            var dotClassName = prefixCls + '-dot';

            if (external_root_React_commonjs2_react_commonjs_react_amd_react_["isValidElement"](indicator)) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](indicator, {
                className: classnames_default()(indicator.props.className, dotClassName)
              });
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: classnames_default()(dotClassName, prefixCls + '-dot-spin')
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('i', null), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('i', null), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('i', null), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('i', null));
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _a = this.props,
                className = _a.className,
                size = _a.size,
                prefixCls = _a.prefixCls,
                tip = _a.tip,
                wrapperClassName = _a.wrapperClassName,
                restProps = spin_rest(_a, ["className", "size", "prefixCls", "tip", "wrapperClassName"]);
            var _state = this.state,
                spinning = _state.spinning,
                notCssAnimationSupported = _state.notCssAnimationSupported;
            var spinClassName = classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-sm', size === 'small'), defineProperty_default()(_classNames, prefixCls + '-lg', size === 'large'), defineProperty_default()(_classNames, prefixCls + '-spinning', spinning), defineProperty_default()(_classNames, prefixCls + '-show-text', !!tip || notCssAnimationSupported), _classNames), className); // fix https://fb.me/react-unknown-prop

            var divProps = Object(es["default"])(restProps, ['spinning', 'delay', 'indicator']);
            var spinElement = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, divProps, {
              className: spinClassName
            }), this.renderIndicator(), tip ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-text'
            }, tip) : null);

            if (this.isNestedPattern()) {
              var _classNames2;

              var animateClassName = prefixCls + '-nested-loading';

              if (wrapperClassName) {
                animateClassName += ' ' + wrapperClassName;
              }

              var containerClassName = classnames_default()((_classNames2 = {}, defineProperty_default()(_classNames2, prefixCls + '-container', true), defineProperty_default()(_classNames2, prefixCls + '-blur', spinning), _classNames2));
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], extends_default()({}, divProps, {
                component: 'div',
                className: animateClassName,
                style: null,
                transitionName: 'fade'
              }), spinning && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                key: 'loading'
              }, spinElement), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: containerClassName,
                key: 'container'
              }, this.props.children));
            }

            return spinElement;
          }
        }]);
        return Spin;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_spin = spin_Spin;
      spin_Spin.defaultProps = {
        prefixCls: 'ant-spin',
        spinning: true,
        size: 'default',
        wrapperClassName: ''
      };
      spin_Spin.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        spinning: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        size: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['small', 'default', 'large']),
        wrapperClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        indicator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node
      }; // CONCATENATED MODULE: ./node_modules/rc-pagination/es/Pager.js

      var Pager_Pager = function Pager(props) {
        var prefixCls = props.rootPrefixCls + '-item';
        var cls = prefixCls + ' ' + prefixCls + '-' + props.page;

        if (props.active) {
          cls = cls + ' ' + prefixCls + '-active';
        }

        if (props.className) {
          cls = cls + ' ' + props.className;
        }

        var handleClick = function handleClick() {
          props.onClick(props.page);
        };

        var handleKeyPress = function handleKeyPress(e) {
          props.onKeyPress(e, props.onClick, props.page);
        };

        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
          title: props.showTitle ? props.page : null,
          className: cls,
          onClick: handleClick,
          onKeyPress: handleKeyPress,
          tabIndex: '0'
        }, props.itemRender(props.page, 'page', external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', null, props.page)));
      };

      Pager_Pager.propTypes = {
        page: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        active: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        last: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showTitle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        rootPrefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onKeyPress: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        itemRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      /* harmony default export */

      var es_Pager = Pager_Pager; // CONCATENATED MODULE: ./node_modules/rc-pagination/es/KeyCode.js

      /* harmony default export */

      var rc_pagination_es_KeyCode = {
        ZERO: 48,
        NINE: 57,
        NUMPAD_ZERO: 96,
        NUMPAD_NINE: 105,
        BACKSPACE: 8,
        DELETE: 46,
        ENTER: 13,
        ARROW_UP: 38,
        ARROW_DOWN: 40
      }; // CONCATENATED MODULE: ./node_modules/rc-pagination/es/Options.js

      var Options_Options = function (_React$Component) {
        inherits_default()(Options, _React$Component);

        function Options(props) {
          classCallCheck_default()(this, Options);

          var _this = possibleConstructorReturn_default()(this, (Options.__proto__ || Object.getPrototypeOf(Options)).call(this, props));

          _this.buildOptionText = function (value) {
            return value + ' ' + _this.props.locale.items_per_page;
          };

          _this.changeSize = function (value) {
            _this.props.changeSize(Number(value));
          };

          _this.handleChange = function (e) {
            _this.setState({
              goInputText: e.target.value
            });
          };

          _this.go = function (e) {
            var val = _this.state.goInputText;

            if (val === '') {
              return;
            }

            val = isNaN(val) ? _this.props.current : Number(val);

            if (e.keyCode === rc_pagination_es_KeyCode.ENTER || e.type === 'click') {
              _this.setState({
                goInputText: ''
              });

              _this.props.quickGo(val);
            }
          };

          _this.state = {
            goInputText: ''
          };
          return _this;
        }

        createClass_default()(Options, [{
          key: 'render',
          value: function render() {
            var props = this.props;
            var state = this.state;
            var locale = props.locale;
            var prefixCls = props.rootPrefixCls + '-options';
            var changeSize = props.changeSize;
            var quickGo = props.quickGo;
            var goButton = props.goButton;
            var buildOptionText = props.buildOptionText || this.buildOptionText;
            var Select = props.selectComponentClass;
            var changeSelect = null;
            var goInput = null;
            var gotoButton = null;

            if (!(changeSize || quickGo)) {
              return null;
            }

            if (changeSize && Select) {
              var Option = Select.Option;
              var pageSize = props.pageSize || props.pageSizeOptions[0];
              var options = props.pageSizeOptions.map(function (opt, i) {
                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Option, {
                  key: i,
                  value: opt
                }, buildOptionText(opt));
              });
              changeSelect = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Select, {
                prefixCls: props.selectPrefixCls,
                showSearch: false,
                className: prefixCls + '-size-changer',
                optionLabelProp: 'children',
                dropdownMatchSelectWidth: false,
                value: pageSize.toString(),
                onChange: this.changeSize,
                getPopupContainer: function getPopupContainer(triggerNode) {
                  return triggerNode.parentNode;
                }
              }, options);
            }

            if (quickGo) {
              if (goButton) {
                if (typeof goButton === 'boolean') {
                  gotoButton = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('button', {
                    type: 'button',
                    onClick: this.go,
                    onKeyUp: this.go
                  }, locale.jump_to_confirm);
                } else {
                  gotoButton = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                    onClick: this.go,
                    onKeyUp: this.go
                  }, goButton);
                }
              }

              goInput = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
                className: prefixCls + '-quick-jumper'
              }, locale.jump_to, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('input', {
                type: 'text',
                value: state.goInputText,
                onChange: this.handleChange,
                onKeyUp: this.go
              }), locale.page, gotoButton);
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
              className: '' + prefixCls
            }, changeSelect, goInput);
          }
        }]);
        return Options;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Options_Options.propTypes = {
        changeSize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        quickGo: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        selectComponentClass: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        current: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        pageSizeOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        pageSize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        buildOptionText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };
      Options_Options.defaultProps = {
        pageSizeOptions: ['10', '20', '30', '40']
      };
      /* harmony default export */

      var es_Options = Options_Options; // CONCATENATED MODULE: ./node_modules/rc-pagination/es/locale/zh_CN.js

      /* harmony default export */

      var zh_CN = {
        // Options.jsx
        items_per_page: '条/页',
        jump_to: '跳至',
        jump_to_confirm: '确定',
        page: '页',
        // Pagination.jsx
        prev_page: '上一页',
        next_page: '下一页',
        prev_5: '向前 5 页',
        next_5: '向后 5 页',
        prev_3: '向前 3 页',
        next_3: '向后 3 页'
      }; // CONCATENATED MODULE: ./node_modules/rc-pagination/es/Pagination.js

      function Pagination_noop() {}

      function Pagination_isInteger(value) {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
      }

      function Pagination_defaultItemRender(page, type, element) {
        return element;
      }

      var Pagination_Pagination = function (_React$Component) {
        inherits_default()(Pagination, _React$Component);

        function Pagination(props) {
          classCallCheck_default()(this, Pagination);

          var _this = possibleConstructorReturn_default()(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

          Pagination_initialiseProps.call(_this);
          var hasOnChange = props.onChange !== Pagination_noop;
          var hasCurrent = 'current' in props;

          if (hasCurrent && !hasOnChange) {
            console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
          }

          var current = props.defaultCurrent;

          if ('current' in props) {
            current = props.current;
          }

          var pageSize = props.defaultPageSize;

          if ('pageSize' in props) {
            pageSize = props.pageSize;
          }

          _this.state = {
            current: current,
            currentInputValue: current,
            pageSize: pageSize
          };
          return _this;
        }

        createClass_default()(Pagination, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('current' in nextProps) {
              this.setState({
                current: nextProps.current,
                currentInputValue: nextProps.current
              });
            }

            if ('pageSize' in nextProps) {
              var newState = {};
              var current = this.state.current;
              var newCurrent = this.calculatePage(nextProps.pageSize);
              current = current > newCurrent ? newCurrent : current;

              if (!('current' in nextProps)) {
                newState.current = current;
                newState.currentInputValue = current;
              }

              newState.pageSize = nextProps.pageSize;
              this.setState(newState);
            }
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate(prevProps, prevState) {
            // When current page change, fix focused style of prev item
            // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
            var prefixCls = this.props.prefixCls;

            if (prevState.current !== this.state.current && this.paginationNode) {
              var lastCurrentNode = this.paginationNode.querySelector('.' + prefixCls + '-item-' + prevState.current);

              if (lastCurrentNode && document.activeElement === lastCurrentNode) {
                lastCurrentNode.blur();
              }
            }
          }
        }, {
          key: 'getJumpPrevPage',
          value: function getJumpPrevPage() {
            return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
          }
        }, {
          key: 'getJumpNextPage',
          value: function getJumpNextPage() {
            return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
          }
        }, {
          key: 'getJumpPrevPage',
          value: function getJumpPrevPage() {
            return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
          }
        }, {
          key: 'getJumpNextPage',
          value: function getJumpNextPage() {
            return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
          }
        }, {
          key: 'render',
          value: function render() {
            // When hideOnSinglePage is true and there is only 1 page, hide the pager
            if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) {
              return null;
            }

            var props = this.props;
            var locale = props.locale;
            var prefixCls = props.prefixCls;
            var allPages = this.calculatePage();
            var pagerList = [];
            var jumpPrev = null;
            var jumpNext = null;
            var firstPager = null;
            var lastPager = null;
            var gotoButton = null;
            var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
            var pageBufferSize = props.showLessItems ? 1 : 2;
            var _state = this.state,
                current = _state.current,
                pageSize = _state.pageSize;
            var prevPage = current - 1 > 0 ? current - 1 : 0;
            var nextPage = current + 1 < allPages ? current + 1 : allPages;
            var dataOrAriaAttributeProps = Object.keys(props).reduce(function (prev, key) {
              if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
                prev[key] = props[key];
              }

              return prev;
            }, {});

            if (props.simple) {
              if (goButton) {
                if (typeof goButton === 'boolean') {
                  gotoButton = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('button', {
                    type: 'button',
                    onClick: this.handleGoTO,
                    onKeyUp: this.handleGoTO
                  }, locale.jump_to_confirm);
                } else {
                  gotoButton = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                    onClick: this.handleGoTO,
                    onKeyUp: this.handleGoTO
                  }, goButton);
                }

                gotoButton = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
                  title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
                  className: prefixCls + '-simple-pager'
                }, gotoButton);
              }

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', extends_default()({
                className: prefixCls + ' ' + prefixCls + '-simple ' + props.className,
                style: props.style,
                ref: this.savePaginationNode
              }, dataOrAriaAttributeProps), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
                title: props.showTitle ? locale.prev_page : null,
                onClick: this.prev,
                tabIndex: this.hasPrev() ? 0 : null,
                onKeyPress: this.runIfEnterPrev,
                className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
                'aria-disabled': !this.hasPrev()
              }, props.itemRender(prevPage, 'prev', external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
                className: prefixCls + '-item-link'
              }))), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
                title: props.showTitle ? this.state.current + '/' + allPages : null,
                className: prefixCls + '-simple-pager'
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('input', {
                type: 'text',
                value: this.state.currentInputValue,
                onKeyDown: this.handleKeyDown,
                onKeyUp: this.handleKeyUp,
                onChange: this.handleKeyUp,
                size: '3'
              }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                className: prefixCls + '-slash'
              }, "\uFF0F"), allPages), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
                title: props.showTitle ? locale.next_page : null,
                onClick: this.next,
                tabIndex: this.hasPrev() ? 0 : null,
                onKeyPress: this.runIfEnterNext,
                className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
                'aria-disabled': !this.hasNext()
              }, props.itemRender(nextPage, 'next', external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
                className: prefixCls + '-item-link'
              }))), gotoButton);
            }

            if (allPages <= 5 + pageBufferSize * 2) {
              for (var i = 1; i <= allPages; i++) {
                var active = this.state.current === i;
                pagerList.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Pager, {
                  locale: locale,
                  rootPrefixCls: prefixCls,
                  onClick: this.handleChange,
                  onKeyPress: this.runIfEnter,
                  key: i,
                  page: i,
                  active: active,
                  showTitle: props.showTitle,
                  itemRender: props.itemRender
                }));
              }
            } else {
              var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
              var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;

              if (props.showPrevNextJumpers) {
                jumpPrev = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
                  title: props.showTitle ? prevItemTitle : null,
                  key: 'prev',
                  onClick: this.jumpPrev,
                  tabIndex: '0',
                  onKeyPress: this.runIfEnterJumpPrev,
                  className: prefixCls + '-jump-prev'
                }, props.itemRender(this.getJumpPrevPage(), 'jump-prev', external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
                  className: prefixCls + '-item-link'
                })));
                jumpNext = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
                  title: props.showTitle ? nextItemTitle : null,
                  key: 'next',
                  tabIndex: '0',
                  onClick: this.jumpNext,
                  onKeyPress: this.runIfEnterJumpNext,
                  className: prefixCls + '-jump-next'
                }, props.itemRender(this.getJumpNextPage(), 'jump-next', external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
                  className: prefixCls + '-item-link'
                })));
              }

              lastPager = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Pager, {
                locale: props.locale,
                last: true,
                rootPrefixCls: prefixCls,
                onClick: this.handleChange,
                onKeyPress: this.runIfEnter,
                key: allPages,
                page: allPages,
                active: false,
                showTitle: props.showTitle,
                itemRender: props.itemRender
              });
              firstPager = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Pager, {
                locale: props.locale,
                rootPrefixCls: prefixCls,
                onClick: this.handleChange,
                onKeyPress: this.runIfEnter,
                key: 1,
                page: 1,
                active: false,
                showTitle: props.showTitle,
                itemRender: props.itemRender
              });
              var left = Math.max(1, current - pageBufferSize);
              var right = Math.min(current + pageBufferSize, allPages);

              if (current - 1 <= pageBufferSize) {
                right = 1 + pageBufferSize * 2;
              }

              if (allPages - current <= pageBufferSize) {
                left = allPages - pageBufferSize * 2;
              }

              for (var _i = left; _i <= right; _i++) {
                var _active = current === _i;

                pagerList.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Pager, {
                  locale: props.locale,
                  rootPrefixCls: prefixCls,
                  onClick: this.handleChange,
                  onKeyPress: this.runIfEnter,
                  key: _i,
                  page: _i,
                  active: _active,
                  showTitle: props.showTitle,
                  itemRender: props.itemRender
                }));
              }

              if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
                pagerList[0] = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(pagerList[0], {
                  className: prefixCls + '-item-after-jump-prev'
                });
                pagerList.unshift(jumpPrev);
              }

              if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
                pagerList[pagerList.length - 1] = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(pagerList[pagerList.length - 1], {
                  className: prefixCls + '-item-before-jump-next'
                });
                pagerList.push(jumpNext);
              }

              if (left !== 1) {
                pagerList.unshift(firstPager);
              }

              if (right !== allPages) {
                pagerList.push(lastPager);
              }
            }

            var totalText = null;

            if (props.showTotal) {
              totalText = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
                className: prefixCls + '-total-text'
              }, props.showTotal(props.total, [(current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize]));
            }

            var prevDisabled = !this.hasPrev();
            var nextDisabled = !this.hasNext();
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', extends_default()({
              className: prefixCls + ' ' + props.className,
              style: props.style,
              unselectable: 'unselectable',
              ref: this.savePaginationNode
            }, dataOrAriaAttributeProps), totalText, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
              title: props.showTitle ? locale.prev_page : null,
              onClick: this.prev,
              tabIndex: prevDisabled ? null : 0,
              onKeyPress: this.runIfEnterPrev,
              className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
              'aria-disabled': prevDisabled
            }, props.itemRender(prevPage, 'prev', external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
              className: prefixCls + '-item-link'
            }))), pagerList, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
              title: props.showTitle ? locale.next_page : null,
              onClick: this.next,
              tabIndex: nextDisabled ? null : 0,
              onKeyPress: this.runIfEnterNext,
              className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
              'aria-disabled': nextDisabled
            }, props.itemRender(nextPage, 'next', external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
              className: prefixCls + '-item-link'
            }))), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Options, {
              locale: props.locale,
              rootPrefixCls: prefixCls,
              selectComponentClass: props.selectComponentClass,
              selectPrefixCls: props.selectPrefixCls,
              changeSize: this.props.showSizeChanger ? this.changePageSize : null,
              current: this.state.current,
              pageSize: this.state.pageSize,
              pageSizeOptions: this.props.pageSizeOptions,
              quickGo: this.props.showQuickJumper ? this.handleChange : null,
              goButton: goButton
            }));
          }
        }]);
        return Pagination;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Pagination_Pagination.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        current: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        defaultCurrent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        total: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        pageSize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        defaultPageSize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        hideOnSinglePage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showSizeChanger: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLessItems: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onShowSizeChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        selectComponentClass: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        showPrevNextJumpers: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showQuickJumper: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        showTitle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        pageSizeOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        showTotal: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        itemRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      Pagination_Pagination.defaultProps = {
        defaultCurrent: 1,
        total: 0,
        defaultPageSize: 10,
        onChange: Pagination_noop,
        className: '',
        selectPrefixCls: 'rc-select',
        prefixCls: 'rc-pagination',
        selectComponentClass: null,
        hideOnSinglePage: false,
        showPrevNextJumpers: true,
        showQuickJumper: false,
        showSizeChanger: false,
        showLessItems: false,
        showTitle: true,
        onShowSizeChange: Pagination_noop,
        locale: zh_CN,
        style: {},
        itemRender: Pagination_defaultItemRender
      };

      var Pagination_initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.savePaginationNode = function (node) {
          _this2.paginationNode = node;
        };

        this.calculatePage = function (p) {
          var pageSize = p;

          if (typeof pageSize === 'undefined') {
            pageSize = _this2.state.pageSize;
          }

          return Math.floor((_this2.props.total - 1) / pageSize) + 1;
        };

        this.isValid = function (page) {
          return Pagination_isInteger(page) && page >= 1 && page !== _this2.state.current;
        };

        this.handleKeyDown = function (e) {
          if (e.keyCode === rc_pagination_es_KeyCode.ARROW_UP || e.keyCode === rc_pagination_es_KeyCode.ARROW_DOWN) {
            e.preventDefault();
          }
        };

        this.handleKeyUp = function (e) {
          var inputValue = e.target.value;
          var currentInputValue = _this2.state.currentInputValue;
          var value = void 0;

          if (inputValue === '') {
            value = inputValue;
          } else if (isNaN(Number(inputValue))) {
            value = currentInputValue;
          } else {
            value = Number(inputValue);
          }

          if (value !== currentInputValue) {
            _this2.setState({
              currentInputValue: value
            });
          }

          if (e.keyCode === rc_pagination_es_KeyCode.ENTER) {
            _this2.handleChange(value);
          } else if (e.keyCode === rc_pagination_es_KeyCode.ARROW_UP) {
            _this2.handleChange(value - 1);
          } else if (e.keyCode === rc_pagination_es_KeyCode.ARROW_DOWN) {
            _this2.handleChange(value + 1);
          }
        };

        this.changePageSize = function (size) {
          var current = _this2.state.current;

          var newCurrent = _this2.calculatePage(size);

          current = current > newCurrent ? newCurrent : current; // fix the issue:
          // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.

          if (newCurrent === 0) {
            current = _this2.state.current;
          }

          if (typeof size === 'number') {
            if (!('pageSize' in _this2.props)) {
              _this2.setState({
                pageSize: size
              });
            }

            if (!('current' in _this2.props)) {
              _this2.setState({
                current: current,
                currentInputValue: current
              });
            }
          }

          _this2.props.onShowSizeChange(current, size);
        };

        this.handleChange = function (p) {
          var page = p;

          if (_this2.isValid(page)) {
            if (page > _this2.calculatePage()) {
              page = _this2.calculatePage();
            }

            if (!('current' in _this2.props)) {
              _this2.setState({
                current: page,
                currentInputValue: page
              });
            }

            var pageSize = _this2.state.pageSize;

            _this2.props.onChange(page, pageSize);

            return page;
          }

          return _this2.state.current;
        };

        this.prev = function () {
          if (_this2.hasPrev()) {
            _this2.handleChange(_this2.state.current - 1);
          }
        };

        this.next = function () {
          if (_this2.hasNext()) {
            _this2.handleChange(_this2.state.current + 1);
          }
        };

        this.jumpPrev = function () {
          _this2.handleChange(_this2.getJumpPrevPage());
        };

        this.jumpNext = function () {
          _this2.handleChange(_this2.getJumpNextPage());
        };

        this.hasPrev = function () {
          return _this2.state.current > 1;
        };

        this.hasNext = function () {
          return _this2.state.current < _this2.calculatePage();
        };

        this.runIfEnter = function (event, callback) {
          for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            restParams[_key - 2] = arguments[_key];
          }

          if (event.key === 'Enter' || event.charCode === 13) {
            callback.apply(undefined, restParams);
          }
        };

        this.runIfEnterPrev = function (e) {
          _this2.runIfEnter(e, _this2.prev);
        };

        this.runIfEnterNext = function (e) {
          _this2.runIfEnter(e, _this2.next);
        };

        this.runIfEnterJumpPrev = function (e) {
          _this2.runIfEnter(e, _this2.jumpPrev);
        };

        this.runIfEnterJumpNext = function (e) {
          _this2.runIfEnter(e, _this2.jumpNext);
        };

        this.handleGoTO = function (e) {
          if (e.keyCode === rc_pagination_es_KeyCode.ENTER || e.type === 'click') {
            _this2.handleChange(_this2.state.currentInputValue);
          }
        };
      };
      /* harmony default export */


      var es_Pagination = Pagination_Pagination; // CONCATENATED MODULE: ./node_modules/rc-pagination/es/index.js
      // CONCATENATED MODULE: ./node_modules/antd/es/pagination/MiniSelect.js

      var MiniSelect_MiniSelect = function (_React$Component) {
        inherits_default()(MiniSelect, _React$Component);

        function MiniSelect() {
          classCallCheck_default()(this, MiniSelect);
          return possibleConstructorReturn_default()(this, (MiniSelect.__proto__ || Object.getPrototypeOf(MiniSelect)).apply(this, arguments));
        }

        createClass_default()(MiniSelect, [{
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_select, extends_default()({
              size: 'small'
            }, this.props));
          }
        }]);
        return MiniSelect;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var pagination_MiniSelect = MiniSelect_MiniSelect;
      MiniSelect_MiniSelect.Option = es_select.Option; // CONCATENATED MODULE: ./node_modules/antd/es/pagination/Pagination.js

      var Pagination_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var pagination_Pagination_Pagination = function (_React$Component) {
        inherits_default()(Pagination, _React$Component);

        function Pagination() {
          classCallCheck_default()(this, Pagination);

          var _this = possibleConstructorReturn_default()(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).apply(this, arguments));

          _this.renderPagination = function (locale) {
            var _a = _this.props,
                className = _a.className,
                size = _a.size,
                restProps = Pagination_rest(_a, ["className", "size"]);
            var isSmall = size === 'small';
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_Pagination, extends_default()({}, restProps, {
              className: classnames_default()(className, {
                mini: isSmall
              }),
              selectComponentClass: isSmall ? pagination_MiniSelect : es_select,
              locale: locale
            }));
          };

          return _this;
        }

        createClass_default()(Pagination, [{
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
              componentName: 'Pagination',
              defaultLocale: en_US
            }, this.renderPagination);
          }
        }]);
        return Pagination;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var pagination_Pagination = pagination_Pagination_Pagination;
      pagination_Pagination_Pagination.defaultProps = {
        prefixCls: 'ant-pagination',
        selectPrefixCls: 'ant-select'
      }; // CONCATENATED MODULE: ./node_modules/antd/es/pagination/index.js

      /* harmony default export */

      var es_pagination = pagination_Pagination; // CONCATENATED MODULE: ./node_modules/antd/es/list/Item.js

      var Item_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var Item_Meta = function Meta(props) {
        var _props$prefixCls = props.prefixCls,
            prefixCls = _props$prefixCls === undefined ? 'ant-list' : _props$prefixCls,
            className = props.className,
            avatar = props.avatar,
            title = props.title,
            description = props.description,
            others = Item_rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
        var classString = classnames_default()(prefixCls + '-item-meta', className);
        var content = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-item-meta-content'
        }, title && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('h4', {
          className: prefixCls + '-item-meta-title'
        }, title), description && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-item-meta-description'
        }, description));
        return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, others, {
          className: classString
        }), avatar && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-item-meta-avatar'
        }, avatar), (title || description) && content);
      };

      function Item_getGrid(grid, t) {
        return grid[t] && Math.floor(24 / grid[t]);
      }

      var Item_GridColumns = ['', 1, 2, 3, 4, 6, 8, 12, 24];

      var Item_Item = function (_React$Component) {
        inherits_default()(Item, _React$Component);

        function Item() {
          classCallCheck_default()(this, Item);
          return possibleConstructorReturn_default()(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
        }

        createClass_default()(Item, [{
          key: 'render',
          value: function render() {
            var grid = this.context.grid;
            var _a = this.props,
                _a$prefixCls = _a.prefixCls,
                prefixCls = _a$prefixCls === undefined ? 'ant-list' : _a$prefixCls,
                children = _a.children,
                actions = _a.actions,
                extra = _a.extra,
                className = _a.className,
                others = Item_rest(_a, ["prefixCls", "children", "actions", "extra", "className"]);
            var classString = classnames_default()(prefixCls + '-item', className);
            var metaContent = [];
            var otherContent = [];
            external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(children, function (element) {
              if (element && element.type && element.type === Item_Meta) {
                metaContent.push(element);
              } else {
                otherContent.push(element);
              }
            });
            var contentClassString = classnames_default()(prefixCls + '-item-content', defineProperty_default()({}, prefixCls + '-item-content-single', metaContent.length < 1));
            var content = otherContent.length > 0 ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: contentClassString
            }, otherContent) : null;
            var actionsContent = void 0;

            if (actions && actions.length > 0) {
              var actionsContentItem = function actionsContentItem(action, i) {
                return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('li', {
                  key: prefixCls + '-item-action-' + i
                }, action, i !== actions.length - 1 && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('em', {
                  className: prefixCls + '-item-action-split'
                }));
              };

              actionsContent = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('ul', {
                className: prefixCls + '-item-action'
              }, actions.map(function (action, i) {
                return actionsContentItem(action, i);
              }));
            }

            var extraContent = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-item-extra-wrap'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-item-main'
            }, metaContent, content, actionsContent), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-item-extra'
            }, extra));
            var mainContent = grid ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](grid_col, {
              span: Item_getGrid(grid, 'column'),
              xs: Item_getGrid(grid, 'xs'),
              sm: Item_getGrid(grid, 'sm'),
              md: Item_getGrid(grid, 'md'),
              lg: Item_getGrid(grid, 'lg'),
              xl: Item_getGrid(grid, 'xl'),
              xxl: Item_getGrid(grid, 'xxl')
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, others, {
              className: classString
            }), extra && extraContent, !extra && metaContent, !extra && content, !extra && actionsContent)) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, others, {
              className: classString
            }), extra && extraContent, !extra && metaContent, !extra && content, !extra && actionsContent);
            return mainContent;
          }
        }]);
        return Item;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var list_Item = Item_Item;
      Item_Item.Meta = Item_Meta;
      Item_Item.propTypes = {
        column: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(Item_GridColumns),
        xs: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(Item_GridColumns),
        sm: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(Item_GridColumns),
        md: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(Item_GridColumns),
        lg: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(Item_GridColumns),
        xl: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(Item_GridColumns),
        xxl: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(Item_GridColumns)
      };
      Item_Item.contextTypes = {
        grid: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/antd/es/list/index.js

      var list_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var list_List = function (_React$Component) {
        inherits_default()(List, _React$Component);

        function List() {
          classCallCheck_default()(this, List);

          var _this = possibleConstructorReturn_default()(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));

          _this.keys = {};

          _this.renderItem = function (item, index) {
            var _this$props = _this.props,
                dataSource = _this$props.dataSource,
                renderItem = _this$props.renderItem,
                rowKey = _this$props.rowKey;
            var key = void 0;

            if (typeof rowKey === 'function') {
              key = rowKey(dataSource[index]);
            } else if (typeof rowKey === 'string') {
              key = dataSource[rowKey];
            } else {
              key = dataSource.key;
            }

            if (!key) {
              key = 'list-item-' + index;
            }

            _this.keys[index] = key;
            return renderItem(item, index);
          };

          _this.renderEmpty = function (contextLocale) {
            var locale = extends_default()({}, contextLocale, _this.props.locale);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: _this.props.prefixCls + '-empty-text'
            }, locale.emptyText);
          };

          return _this;
        }

        createClass_default()(List, [{
          key: 'getChildContext',
          value: function getChildContext() {
            return {
              grid: this.props.grid
            };
          }
        }, {
          key: 'isSomethingAfterLastTtem',
          value: function isSomethingAfterLastTtem() {
            var _props = this.props,
                loadMore = _props.loadMore,
                pagination = _props.pagination,
                footer = _props.footer;
            return !!(loadMore || pagination || footer);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames,
                _this2 = this;

            var _a = this.props,
                bordered = _a.bordered,
                split = _a.split,
                className = _a.className,
                children = _a.children,
                itemLayout = _a.itemLayout,
                loadMore = _a.loadMore,
                pagination = _a.pagination,
                prefixCls = _a.prefixCls,
                grid = _a.grid,
                dataSource = _a.dataSource,
                size = _a.size,
                rowKey = _a.rowKey,
                renderItem = _a.renderItem,
                header = _a.header,
                footer = _a.footer,
                loading = _a.loading,
                rest = list_rest(_a, ["bordered", "split", "className", "children", "itemLayout", "loadMore", "pagination", "prefixCls", "grid", "dataSource", "size", "rowKey", "renderItem", "header", "footer", "loading"]);
            var loadingProp = loading;

            if (typeof loadingProp === 'boolean') {
              loadingProp = {
                spinning: loadingProp
              };
            }

            var isLoading = loadingProp && loadingProp.spinning; // large => lg
            // small => sm

            var sizeCls = '';

            switch (size) {
              case 'large':
                sizeCls = 'lg';
                break;

              case 'small':
                sizeCls = 'sm';

              default:
                break;
            }

            var classString = classnames_default()(prefixCls, className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-vertical', itemLayout === 'vertical'), defineProperty_default()(_classNames, prefixCls + '-' + sizeCls, sizeCls), defineProperty_default()(_classNames, prefixCls + '-split', split), defineProperty_default()(_classNames, prefixCls + '-bordered', bordered), defineProperty_default()(_classNames, prefixCls + '-loading', isLoading), defineProperty_default()(_classNames, prefixCls + '-grid', grid), defineProperty_default()(_classNames, prefixCls + '-something-after-last-item', this.isSomethingAfterLastTtem()), _classNames));
            var paginationContent = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-pagination'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_pagination, pagination));
            var childrenContent = void 0;
            childrenContent = isLoading && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              style: {
                minHeight: 53
              }
            });

            if (dataSource.length > 0) {
              var items = dataSource.map(function (item, index) {
                return _this2.renderItem(item, index);
              });
              var childrenList = external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].map(items, function (child, index) {
                return external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](child, {
                  key: _this2.keys[index]
                });
              });
              childrenContent = grid ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](grid_row, {
                gutter: grid.gutter
              }, childrenList) : childrenList;
            } else if (!children && !isLoading) {
              childrenContent = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
                componentName: 'Table',
                defaultLocale: locale_provider_default.Table
              }, this.renderEmpty);
            }

            var content = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_spin, loadingProp, childrenContent), loadMore, !loadMore && pagination ? paginationContent : null);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({
              className: classString
            }, rest), header && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-header'
            }, header), content, children, footer && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-footer'
            }, footer));
          }
        }]);
        return List;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_list = list_List;
      list_List.Item = list_Item;
      list_List.childContextTypes = {
        grid: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      list_List.defaultProps = {
        dataSource: [],
        prefixCls: 'ant-list',
        bordered: false,
        split: true,
        loading: false,
        pagination: false
      }; // CONCATENATED MODULE: ./node_modules/antd/es/modal/locale.js

      var locale_runtimeLocale = extends_default()({}, locale_provider_default.Modal);

      function locale_changeConfirmLocale(newLocale) {
        if (newLocale) {
          locale_runtimeLocale = extends_default()({}, locale_runtimeLocale, newLocale);
        } else {
          locale_runtimeLocale = extends_default()({}, locale_provider_default.Modal);
        }
      }

      function locale_getConfirmLocale() {
        return locale_runtimeLocale;
      } // CONCATENATED MODULE: ./node_modules/antd/es/locale-provider/index.js


      function locale_provider_setMomentLocale(locale) {
        if (locale && locale.locale) {
          interopDefault(moment).locale(locale.locale);
        } else {
          interopDefault(moment).locale('en');
        }
      }

      var locale_provider_LocaleProvider = function (_React$Component) {
        inherits_default()(LocaleProvider, _React$Component);

        function LocaleProvider() {
          classCallCheck_default()(this, LocaleProvider);
          return possibleConstructorReturn_default()(this, (LocaleProvider.__proto__ || Object.getPrototypeOf(LocaleProvider)).apply(this, arguments));
        }

        createClass_default()(LocaleProvider, [{
          key: 'getChildContext',
          value: function getChildContext() {
            return {
              antLocale: extends_default()({}, this.props.locale, {
                exist: true
              })
            };
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            locale_provider_setMomentLocale(this.props.locale);
            this.componentDidUpdate();
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var locale = this.props.locale;
            var nextLocale = nextProps.locale;

            if (locale !== nextLocale) {
              locale_provider_setMomentLocale(nextProps.locale);
            }
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            var locale = this.props.locale;
            locale_changeConfirmLocale(locale && locale.Modal);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            locale_changeConfirmLocale();
          }
        }, {
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].only(this.props.children);
          }
        }]);
        return LocaleProvider;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var locale_provider = locale_provider_LocaleProvider;
      locale_provider_LocaleProvider.propTypes = {
        locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };
      locale_provider_LocaleProvider.defaultProps = {
        locale: {}
      };
      locale_provider_LocaleProvider.childContextTypes = {
        antLocale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      }; // EXTERNAL MODULE: ./node_modules/rc-notification/es/index.js + 2 modules

      var rc_notification_es = __webpack_require__(215); // CONCATENATED MODULE: ./node_modules/antd/es/message/index.js


      var message_defaultDuration = 3;
      var message_defaultTop = void 0;
      var message_messageInstance = void 0;
      var message_key = 1;
      var message_prefixCls = 'ant-message';
      var message_transitionName = 'move-up';
      var message_getContainer = void 0;

      function message_getMessageInstance(callback) {
        if (message_messageInstance) {
          callback(message_messageInstance);
          return;
        }

        rc_notification_es["default"].newInstance({
          prefixCls: message_prefixCls,
          transitionName: message_transitionName,
          style: {
            top: message_defaultTop
          },
          getContainer: message_getContainer
        }, function (instance) {
          if (message_messageInstance) {
            callback(message_messageInstance);
            return;
          }

          message_messageInstance = instance;
          callback(instance);
        });
      }

      function message_notice(content) {
        var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : message_defaultDuration;
        var type = arguments[2];
        var onClose = arguments[3];
        var iconType = {
          info: 'info-circle',
          success: 'check-circle',
          error: 'cross-circle',
          warning: 'exclamation-circle',
          loading: 'loading'
        }[type];

        if (typeof duration === 'function') {
          onClose = duration;
          duration = message_defaultDuration;
        }

        var target = message_key++;
        message_getMessageInstance(function (instance) {
          instance.notice({
            key: target,
            duration: duration,
            style: {},
            content: external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: message_prefixCls + '-custom-content ' + message_prefixCls + '-' + type
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: iconType
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, content)),
            onClose: onClose
          });
        });
        return function () {
          if (message_messageInstance) {
            message_messageInstance.removeNotice(target);
          }
        };
      }
      /* harmony default export */


      var es_message = {
        info: function info(content, duration, onClose) {
          return message_notice(content, duration, 'info', onClose);
        },
        success: function success(content, duration, onClose) {
          return message_notice(content, duration, 'success', onClose);
        },
        error: function error(content, duration, onClose) {
          return message_notice(content, duration, 'error', onClose);
        },
        // Departed usage, please use warning()
        warn: function warn(content, duration, onClose) {
          return message_notice(content, duration, 'warning', onClose);
        },
        warning: function warning(content, duration, onClose) {
          return message_notice(content, duration, 'warning', onClose);
        },
        loading: function loading(content, duration, onClose) {
          return message_notice(content, duration, 'loading', onClose);
        },
        config: function config(options) {
          if (options.top !== undefined) {
            message_defaultTop = options.top;
            message_messageInstance = null; // delete messageInstance for new defaultTop
          }

          if (options.duration !== undefined) {
            message_defaultDuration = options.duration;
          }

          if (options.prefixCls !== undefined) {
            message_prefixCls = options.prefixCls;
          }

          if (options.getContainer !== undefined) {
            message_getContainer = options.getContainer;
          }

          if (options.transitionName !== undefined) {
            message_transitionName = options.transitionName;
            message_messageInstance = null; // delete messageInstance for new transitionName
          }
        },
        destroy: function destroy() {
          if (message_messageInstance) {
            message_messageInstance.destroy();
            message_messageInstance = null;
          }
        }
      }; // EXTERNAL MODULE: ./node_modules/rc-menu/es/index.js + 10 modules

      var rc_menu_es = __webpack_require__(74); // CONCATENATED MODULE: ./node_modules/antd/es/menu/SubMenu.js


      var SubMenu_SubMenu = function (_React$Component) {
        inherits_default()(SubMenu, _React$Component);

        function SubMenu() {
          classCallCheck_default()(this, SubMenu);

          var _this = possibleConstructorReturn_default()(this, (SubMenu.__proto__ || Object.getPrototypeOf(SubMenu)).apply(this, arguments));

          _this.onKeyDown = function (e) {
            _this.subMenu.onKeyDown(e);
          };

          _this.saveSubMenu = function (subMenu) {
            _this.subMenu = subMenu;
          };

          return _this;
        }

        createClass_default()(SubMenu, [{
          key: 'render',
          value: function render() {
            var _props = this.props,
                rootPrefixCls = _props.rootPrefixCls,
                className = _props.className;
            var theme = this.context.antdMenuTheme;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_menu_es["d"
            /* SubMenu */
            ], extends_default()({}, this.props, {
              ref: this.saveSubMenu,
              popupClassName: classnames_default()(rootPrefixCls + '-' + theme, className)
            }));
          }
        }]);
        return SubMenu;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      SubMenu_SubMenu.contextTypes = {
        antdMenuTheme: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var menu_SubMenu = SubMenu_SubMenu; // EXTERNAL MODULE: ./node_modules/rc-tooltip/es/index.js + 2 modules

      var rc_tooltip_es = __webpack_require__(373); // EXTERNAL MODULE: ./node_modules/rc-tooltip/es/placements.js


      var rc_tooltip_es_placements = __webpack_require__(284); // CONCATENATED MODULE: ./node_modules/antd/es/tooltip/placements.js


      var placements_autoAdjustOverflowEnabled = {
        adjustX: 1,
        adjustY: 1
      };
      var placements_autoAdjustOverflowDisabled = {
        adjustX: 0,
        adjustY: 0
      };
      var tooltip_placements_targetOffset = [0, 0];

      function placements_getOverflowOptions(autoAdjustOverflow) {
        if (typeof autoAdjustOverflow === 'boolean') {
          return autoAdjustOverflow ? placements_autoAdjustOverflowEnabled : placements_autoAdjustOverflowDisabled;
        }

        return extends_default()({}, placements_autoAdjustOverflowDisabled, autoAdjustOverflow);
      }

      function placements_getPlacements() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _config$arrowWidth = config.arrowWidth,
            arrowWidth = _config$arrowWidth === undefined ? 5 : _config$arrowWidth,
            _config$horizontalArr = config.horizontalArrowShift,
            horizontalArrowShift = _config$horizontalArr === undefined ? 16 : _config$horizontalArr,
            _config$verticalArrow = config.verticalArrowShift,
            verticalArrowShift = _config$verticalArrow === undefined ? 12 : _config$verticalArrow,
            _config$autoAdjustOve = config.autoAdjustOverflow,
            autoAdjustOverflow = _config$autoAdjustOve === undefined ? true : _config$autoAdjustOve;
        var placementMap = {
          left: {
            points: ['cr', 'cl'],
            offset: [-4, 0]
          },
          right: {
            points: ['cl', 'cr'],
            offset: [4, 0]
          },
          top: {
            points: ['bc', 'tc'],
            offset: [0, -4]
          },
          bottom: {
            points: ['tc', 'bc'],
            offset: [0, 4]
          },
          topLeft: {
            points: ['bl', 'tc'],
            offset: [-(horizontalArrowShift + arrowWidth), -4]
          },
          leftTop: {
            points: ['tr', 'cl'],
            offset: [-4, -(verticalArrowShift + arrowWidth)]
          },
          topRight: {
            points: ['br', 'tc'],
            offset: [horizontalArrowShift + arrowWidth, -4]
          },
          rightTop: {
            points: ['tl', 'cr'],
            offset: [4, -(verticalArrowShift + arrowWidth)]
          },
          bottomRight: {
            points: ['tr', 'bc'],
            offset: [horizontalArrowShift + arrowWidth, 4]
          },
          rightBottom: {
            points: ['bl', 'cr'],
            offset: [4, verticalArrowShift + arrowWidth]
          },
          bottomLeft: {
            points: ['tl', 'bc'],
            offset: [-(horizontalArrowShift + arrowWidth), 4]
          },
          leftBottom: {
            points: ['br', 'cl'],
            offset: [-4, verticalArrowShift + arrowWidth]
          }
        };
        Object.keys(placementMap).forEach(function (key) {
          placementMap[key] = config.arrowPointAtCenter ? extends_default()({}, placementMap[key], {
            overflow: placements_getOverflowOptions(autoAdjustOverflow),
            targetOffset: tooltip_placements_targetOffset
          }) : extends_default()({}, rc_tooltip_es_placements["a"
          /* placements */
          ][key], {
            overflow: placements_getOverflowOptions(autoAdjustOverflow)
          });
        });
        return placementMap;
      } // CONCATENATED MODULE: ./node_modules/antd/es/tooltip/index.js


      var tooltip_splitObject = function splitObject(obj, keys) {
        var picked = {};
        var omited = extends_default()({}, obj);
        keys.forEach(function (key) {
          if (obj && key in obj) {
            picked[key] = obj[key];
            delete omited[key];
          }
        });
        return {
          picked: picked,
          omited: omited
        };
      };

      var tooltip_Tooltip = function (_React$Component) {
        inherits_default()(Tooltip, _React$Component);

        function Tooltip(props) {
          classCallCheck_default()(this, Tooltip);

          var _this = possibleConstructorReturn_default()(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

          _this.onVisibleChange = function (visible) {
            var onVisibleChange = _this.props.onVisibleChange;

            if (!('visible' in _this.props)) {
              _this.setState({
                visible: _this.isNoTitle() ? false : visible
              });
            }

            if (onVisibleChange && !_this.isNoTitle()) {
              onVisibleChange(visible);
            }
          }; // 动态设置动画点


          _this.onPopupAlign = function (domNode, align) {
            var placements = _this.getPlacements(); // 当前返回的位置


            var placement = Object.keys(placements).filter(function (key) {
              return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
            })[0];

            if (!placement) {
              return;
            } // 根据当前坐标设置动画点


            var rect = domNode.getBoundingClientRect();
            var transformOrigin = {
              top: '50%',
              left: '50%'
            };

            if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
              transformOrigin.top = rect.height - align.offset[1] + 'px';
            } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
              transformOrigin.top = -align.offset[1] + 'px';
            }

            if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
              transformOrigin.left = rect.width - align.offset[0] + 'px';
            } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
              transformOrigin.left = -align.offset[0] + 'px';
            }

            domNode.style.transformOrigin = transformOrigin.left + ' ' + transformOrigin.top;
          };

          _this.saveTooltip = function (node) {
            _this.tooltip = node;
          };

          _this.state = {
            visible: !!props.visible || !!props.defaultVisible
          };
          return _this;
        }

        createClass_default()(Tooltip, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('visible' in nextProps) {
              this.setState({
                visible: nextProps.visible
              });
            }
          }
        }, {
          key: 'getPopupDomNode',
          value: function getPopupDomNode() {
            return this.tooltip.getPopupDomNode();
          }
        }, {
          key: 'getPlacements',
          value: function getPlacements() {
            var _props = this.props,
                builtinPlacements = _props.builtinPlacements,
                arrowPointAtCenter = _props.arrowPointAtCenter,
                autoAdjustOverflow = _props.autoAdjustOverflow;
            return builtinPlacements || placements_getPlacements({
              arrowPointAtCenter: arrowPointAtCenter,
              verticalArrowShift: 8,
              autoAdjustOverflow: autoAdjustOverflow
            });
          }
        }, {
          key: 'isHoverTrigger',
          value: function isHoverTrigger() {
            var trigger = this.props.trigger;

            if (!trigger || trigger === 'hover') {
              return true;
            }

            if (Array.isArray(trigger)) {
              return trigger.indexOf('hover') >= 0;
            }

            return false;
          } // Fix Tooltip won't hide at disabled button
          // mouse events don't trigger at disabled button in Chrome
          // https://github.com/react-component/tooltip/issues/18

        }, {
          key: 'getDisabledCompatibleChildren',
          value: function getDisabledCompatibleChildren(element) {
            if ((element.type.__ANT_BUTTON || element.type === 'button') && element.props.disabled && this.isHoverTrigger()) {
              // Pick some layout related style properties up to span
              // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
              var _splitObject = tooltip_splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
                  picked = _splitObject.picked,
                  omited = _splitObject.omited;

              var spanStyle = extends_default()({
                display: 'inline-block'
              }, picked, {
                cursor: 'not-allowed'
              });
              var buttonStyle = extends_default()({}, omited, {
                pointerEvents: 'none'
              });
              var child = Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"])(element, {
                style: buttonStyle,
                className: null
              });
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                style: spanStyle,
                className: element.props.className
              }, child);
            }

            return element;
          }
        }, {
          key: 'isNoTitle',
          value: function isNoTitle() {
            var _props2 = this.props,
                title = _props2.title,
                overlay = _props2.overlay;
            return !title && !overlay; // overlay for old version compatibility
          }
        }, {
          key: 'render',
          value: function render() {
            var props = this.props,
                state = this.state;
            var prefixCls = props.prefixCls,
                title = props.title,
                overlay = props.overlay,
                openClassName = props.openClassName,
                getPopupContainer = props.getPopupContainer,
                getTooltipContainer = props.getTooltipContainer;
            var children = props.children;
            var visible = state.visible; // Hide tooltip when there is no title

            if (!('visible' in props) && this.isNoTitle()) {
              visible = false;
            }

            var child = this.getDisabledCompatibleChildren(external_root_React_commonjs2_react_commonjs_react_amd_react_["isValidElement"](children) ? children : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, children));
            var childProps = child.props;
            var childCls = classnames_default()(childProps.className, defineProperty_default()({}, openClassName || prefixCls + '-open', true));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_tooltip_es["default"], extends_default()({}, this.props, {
              getTooltipContainer: getPopupContainer || getTooltipContainer,
              ref: this.saveTooltip,
              builtinPlacements: this.getPlacements(),
              overlay: overlay || title || '',
              visible: visible,
              onVisibleChange: this.onVisibleChange,
              onPopupAlign: this.onPopupAlign
            }), visible ? Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"])(child, {
              className: childCls
            }) : child);
          }
        }]);
        return Tooltip;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var tooltip = tooltip_Tooltip;
      tooltip_Tooltip.defaultProps = {
        prefixCls: 'ant-tooltip',
        placement: 'top',
        transitionName: 'zoom-big-fast',
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        arrowPointAtCenter: false,
        autoAdjustOverflow: true
      }; // CONCATENATED MODULE: ./node_modules/antd/es/menu/MenuItem.js

      var MenuItem_MenuItem = function (_React$Component) {
        inherits_default()(MenuItem, _React$Component);

        function MenuItem() {
          classCallCheck_default()(this, MenuItem);

          var _this = possibleConstructorReturn_default()(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).apply(this, arguments));

          _this.onKeyDown = function (e) {
            _this.menuItem.onKeyDown(e);
          };

          _this.saveMenuItem = function (menuItem) {
            _this.menuItem = menuItem;
          };

          return _this;
        }

        createClass_default()(MenuItem, [{
          key: 'render',
          value: function render() {
            var inlineCollapsed = this.context.inlineCollapsed;
            var props = this.props;
            var item = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_menu_es["b"
            /* Item */
            ], extends_default()({}, props, {
              ref: this.saveMenuItem
            }));

            if (inlineCollapsed && props.level === 1) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](tooltip, {
                title: props.children,
                placement: 'right',
                overlayClassName: props.rootPrefixCls + '-inline-collapsed-tooltip'
              }, item);
            }

            return item;
          }
        }]);
        return MenuItem;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      MenuItem_MenuItem.contextTypes = {
        inlineCollapsed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      MenuItem_MenuItem.isMenuItem = 1;
      /* harmony default export */

      var menu_MenuItem = MenuItem_MenuItem; // CONCATENATED MODULE: ./node_modules/antd/es/menu/index.js

      var menu_Menu = function (_React$Component) {
        inherits_default()(Menu, _React$Component);

        function Menu(props) {
          classCallCheck_default()(this, Menu);

          var _this = possibleConstructorReturn_default()(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));

          _this.inlineOpenKeys = [];

          _this.handleClick = function (e) {
            _this.handleOpenChange([]);

            var onClick = _this.props.onClick;

            if (onClick) {
              onClick(e);
            }
          };

          _this.handleOpenChange = function (openKeys) {
            _this.setOpenKeys(openKeys);

            var onOpenChange = _this.props.onOpenChange;

            if (onOpenChange) {
              onOpenChange(openKeys);
            }
          };

          _util_warning(!('onOpen' in props || 'onClose' in props), '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');

          _util_warning(!('inlineCollapsed' in props && props.mode !== 'inline'), '`inlineCollapsed` should only be used when Menu\'s `mode` is inline.');

          var openKeys = void 0;

          if ('defaultOpenKeys' in props) {
            openKeys = props.defaultOpenKeys;
          } else if ('openKeys' in props) {
            openKeys = props.openKeys;
          }

          _this.state = {
            openKeys: openKeys || []
          };
          return _this;
        }

        createClass_default()(Menu, [{
          key: 'getChildContext',
          value: function getChildContext() {
            return {
              inlineCollapsed: this.getInlineCollapsed(),
              antdMenuTheme: this.props.theme
            };
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps, nextContext) {
            var prefixCls = this.props.prefixCls;

            if (this.props.mode === 'inline' && nextProps.mode !== 'inline') {
              this.switchModeFromInline = true;
            }

            if ('openKeys' in nextProps) {
              this.setState({
                openKeys: nextProps.openKeys
              });
              return;
            }

            if (nextProps.inlineCollapsed && !this.props.inlineCollapsed || nextContext.siderCollapsed && !this.context.siderCollapsed) {
              this.switchModeFromInline = !!this.state.openKeys.length && !!Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"])(this).querySelectorAll('.' + prefixCls + '-submenu-open').length;
              this.inlineOpenKeys = this.state.openKeys;
              this.setState({
                openKeys: []
              });
            }

            if (!nextProps.inlineCollapsed && this.props.inlineCollapsed || !nextContext.siderCollapsed && this.context.siderCollapsed) {
              this.setState({
                openKeys: this.inlineOpenKeys
              });
              this.inlineOpenKeys = [];
            }
          }
        }, {
          key: 'setOpenKeys',
          value: function setOpenKeys(openKeys) {
            if (!('openKeys' in this.props)) {
              this.setState({
                openKeys: openKeys
              });
            }
          }
        }, {
          key: 'getRealMenuMode',
          value: function getRealMenuMode() {
            var inlineCollapsed = this.getInlineCollapsed();

            if (this.switchModeFromInline && inlineCollapsed) {
              return 'inline';
            }

            var mode = this.props.mode;
            return inlineCollapsed ? 'vertical' : mode;
          }
        }, {
          key: 'getInlineCollapsed',
          value: function getInlineCollapsed() {
            var inlineCollapsed = this.props.inlineCollapsed;

            if (this.context.siderCollapsed !== undefined) {
              return this.context.siderCollapsed;
            }

            return inlineCollapsed;
          }
        }, {
          key: 'getMenuOpenAnimation',
          value: function getMenuOpenAnimation(menuMode) {
            var _this2 = this;

            var _props = this.props,
                openAnimation = _props.openAnimation,
                openTransitionName = _props.openTransitionName;
            var menuOpenAnimation = openAnimation || openTransitionName;

            if (openAnimation === undefined && openTransitionName === undefined) {
              switch (menuMode) {
                case 'horizontal':
                  menuOpenAnimation = 'slide-up';
                  break;

                case 'vertical':
                case 'vertical-left':
                case 'vertical-right':
                  // When mode switch from inline
                  // submenu should hide without animation
                  if (this.switchModeFromInline) {
                    menuOpenAnimation = '';
                    this.switchModeFromInline = false;
                  } else {
                    menuOpenAnimation = 'zoom-big';
                  }

                  break;

                case 'inline':
                  menuOpenAnimation = extends_default()({}, _util_openAnimation, {
                    leave: function leave(node, done) {
                      return _util_openAnimation.leave(node, function () {
                        // Make sure inline menu leave animation finished before mode is switched
                        _this2.switchModeFromInline = false;

                        _this2.setState({}); // when inlineCollapsed change false to true, all submenu will be unmounted,
                        // so that we don't need handle animation leaving.


                        if (_this2.getRealMenuMode() === 'vertical') {
                          return;
                        }

                        done();
                      });
                    }
                  });
                  break;

                default:
              }
            }

            return menuOpenAnimation;
          }
        }, {
          key: 'render',
          value: function render() {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                className = _props2.className,
                theme = _props2.theme;
            var menuMode = this.getRealMenuMode();
            var menuOpenAnimation = this.getMenuOpenAnimation(menuMode);
            var menuClassName = classnames_default()(className, prefixCls + '-' + theme, defineProperty_default()({}, prefixCls + '-inline-collapsed', this.getInlineCollapsed()));
            var menuProps = {
              openKeys: this.state.openKeys,
              onOpenChange: this.handleOpenChange,
              className: menuClassName,
              mode: menuMode
            };

            if (menuMode !== 'inline') {
              // closing vertical popup submenu after click it
              menuProps.onClick = this.handleClick;
              menuProps.openTransitionName = menuOpenAnimation;
            } else {
              menuProps.openAnimation = menuOpenAnimation;
            } // https://github.com/ant-design/ant-design/issues/8587


            var collapsedWidth = this.context.collapsedWidth;

            if (this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px')) {
              return null;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_menu_es["e"
            /* default */
            ], extends_default()({}, this.props, menuProps));
          }
        }]);
        return Menu;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_menu = menu_Menu;
      menu_Menu.Divider = rc_menu_es["a"
      /* Divider */
      ];
      menu_Menu.Item = menu_MenuItem;
      menu_Menu.SubMenu = menu_SubMenu;
      menu_Menu.ItemGroup = rc_menu_es["c"
      /* ItemGroup */
      ];
      menu_Menu.defaultProps = {
        prefixCls: 'ant-menu',
        className: '',
        theme: 'light'
      };
      menu_Menu.childContextTypes = {
        inlineCollapsed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        antdMenuTheme: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      menu_Menu.contextTypes = {
        siderCollapsed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        collapsedWidth: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string])
      }; // EXTERNAL MODULE: ./node_modules/rc-dialog/es/DialogWrap.js + 3 modules

      var DialogWrap = __webpack_require__(374); // CONCATENATED MODULE: ./node_modules/antd/es/modal/Modal.js


      var Modal_mousePosition = void 0;
      var Modal_mousePositionEventBinded = void 0;

      var Modal_Modal = function (_React$Component) {
        inherits_default()(Modal, _React$Component);

        function Modal() {
          classCallCheck_default()(this, Modal);

          var _this = possibleConstructorReturn_default()(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));

          _this.handleCancel = function (e) {
            var onCancel = _this.props.onCancel;

            if (onCancel) {
              onCancel(e);
            }
          };

          _this.handleOk = function (e) {
            var onOk = _this.props.onOk;

            if (onOk) {
              onOk(e);
            }
          };

          _this.renderFooter = function (locale) {
            var _this$props = _this.props,
                okText = _this$props.okText,
                okType = _this$props.okType,
                cancelText = _this$props.cancelText,
                confirmLoading = _this$props.confirmLoading;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_button, {
              onClick: _this.handleCancel
            }, cancelText || locale.cancelText), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_button, {
              type: okType,
              loading: confirmLoading,
              onClick: _this.handleOk
            }, okText || locale.okText));
          };

          return _this;
        }

        createClass_default()(Modal, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (Modal_mousePositionEventBinded) {
              return;
            } // 只有点击事件支持从鼠标位置动画展开


            Object(addEventListener["a"
            /* default */
            ])(document.documentElement, 'click', function (e) {
              Modal_mousePosition = {
                x: e.pageX,
                y: e.pageY
              }; // 100ms 内发生过点击事件，则从点击位置动画展示
              // 否则直接 zoom 展示
              // 这样可以兼容非点击方式展开

              setTimeout(function () {
                return Modal_mousePosition = null;
              }, 100);
            });
            Modal_mousePositionEventBinded = true;
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                footer = _props.footer,
                visible = _props.visible;
            var defaultFooter = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
              componentName: 'Modal',
              defaultLocale: locale_getConfirmLocale()
            }, this.renderFooter);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](DialogWrap["default"], extends_default()({}, this.props, {
              footer: footer === undefined ? defaultFooter : footer,
              visible: visible,
              mousePosition: Modal_mousePosition,
              onClose: this.handleCancel
            }));
          }
        }]);
        return Modal;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var modal_Modal = Modal_Modal;
      Modal_Modal.defaultProps = {
        prefixCls: 'ant-modal',
        width: 520,
        transitionName: 'zoom',
        maskTransitionName: 'fade',
        confirmLoading: false,
        visible: false,
        okType: 'primary'
      };
      Modal_Modal.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onOk: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onCancel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        okText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        cancelText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        width: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        confirmLoading: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        align: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        footer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        title: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        closable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      }; // CONCATENATED MODULE: ./node_modules/antd/es/modal/ActionButton.js

      var ActionButton_ActionButton = function (_React$Component) {
        inherits_default()(ActionButton, _React$Component);

        function ActionButton(props) {
          classCallCheck_default()(this, ActionButton);

          var _this = possibleConstructorReturn_default()(this, (ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).call(this, props));

          _this.onClick = function () {
            var _this$props = _this.props,
                actionFn = _this$props.actionFn,
                closeModal = _this$props.closeModal;

            if (actionFn) {
              var ret = void 0;

              if (actionFn.length) {
                ret = actionFn(closeModal);
              } else {
                ret = actionFn();

                if (!ret) {
                  closeModal();
                }
              }

              if (ret && ret.then) {
                _this.setState({
                  loading: true
                });

                ret.then(function () {
                  // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
                  // this.setState({ loading: false });
                  closeModal.apply(undefined, arguments);
                }, function () {
                  // See: https://github.com/ant-design/ant-design/issues/6183
                  _this.setState({
                    loading: false
                  });
                });
              }
            } else {
              closeModal();
            }
          };

          _this.state = {
            loading: false
          };
          return _this;
        }

        createClass_default()(ActionButton, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (this.props.autoFocus) {
              var $this = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](this);
              this.timeoutId = setTimeout(function () {
                return $this.focus();
              });
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            clearTimeout(this.timeoutId);
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                type = _props.type,
                children = _props.children;
            var loading = this.state.loading;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_button, {
              type: type,
              onClick: this.onClick,
              loading: loading
            }, children);
          }
        }]);
        return ActionButton;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var modal_ActionButton = ActionButton_ActionButton; // CONCATENATED MODULE: ./node_modules/antd/es/modal/confirm.js

      var confirm_this = undefined;
      var confirm_IS_REACT_16 = !!external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["createPortal"];

      var confirm_ConfirmDialog = function ConfirmDialog(props) {
        var onCancel = props.onCancel,
            onOk = props.onOk,
            close = props.close,
            zIndex = props.zIndex,
            afterClose = props.afterClose,
            visible = props.visible,
            keyboard = props.keyboard;
        var iconType = props.iconType || 'question-circle';
        var okType = props.okType || 'primary';
        var prefixCls = props.prefixCls || 'ant-confirm'; // 默认为 true，保持向下兼容

        var okCancel = 'okCancel' in props ? props.okCancel : true;
        var width = props.width || 416;
        var style = props.style || {}; // 默认为 false，保持旧版默认行为

        var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
        var runtimeLocale = locale_getConfirmLocale();
        var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
        var cancelText = props.cancelText || runtimeLocale.cancelText;
        var classString = classnames_default()(prefixCls, prefixCls + '-' + props.type, props.className);
        var cancelButton = okCancel && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](modal_ActionButton, {
          actionFn: onCancel,
          closeModal: close
        }, cancelText);
        return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](modal_Modal, {
          className: classString,
          onCancel: close.bind(confirm_this, {
            triggerCancel: true
          }),
          visible: visible,
          title: '',
          transitionName: 'zoom',
          footer: '',
          maskTransitionName: 'fade',
          maskClosable: maskClosable,
          style: style,
          width: width,
          zIndex: zIndex,
          afterClose: afterClose,
          keyboard: keyboard
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-body-wrapper'
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-body'
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
          type: iconType
        }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
          className: prefixCls + '-title'
        }, props.title), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-content'
        }, props.content)), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: prefixCls + '-btns'
        }, cancelButton, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](modal_ActionButton, {
          type: okType,
          actionFn: onOk,
          closeModal: close,
          autoFocus: true
        }, okText))));
      };

      function confirm_confirm(config) {
        var div = document.createElement('div');
        document.body.appendChild(div);

        function close() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (confirm_IS_REACT_16) {
            render(extends_default()({}, config, {
              close: close,
              visible: false,
              afterClose: destroy.bind.apply(destroy, [this].concat(args))
            }));
          } else {
            destroy.apply(undefined, args);
          }
        }

        function destroy() {
          var unmountResult = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["unmountComponentAtNode"](div);

          if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
          }

          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          var triggerCancel = args && args.length && args.some(function (param) {
            return param && param.triggerCancel;
          });

          if (config.onCancel && triggerCancel) {
            config.onCancel.apply(config, args);
          }
        }

        function render(props) {
          external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["render"](external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](confirm_ConfirmDialog, props), div);
        }

        render(extends_default()({}, config, {
          visible: true,
          close: close
        }));
        return {
          destroy: close
        };
      } // CONCATENATED MODULE: ./node_modules/antd/es/modal/index.js


      modal_Modal.info = function (props) {
        var config = extends_default()({
          type: 'info',
          iconType: 'info-circle',
          okCancel: false
        }, props);
        return confirm_confirm(config);
      };

      modal_Modal.success = function (props) {
        var config = extends_default()({
          type: 'success',
          iconType: 'check-circle',
          okCancel: false
        }, props);
        return confirm_confirm(config);
      };

      modal_Modal.error = function (props) {
        var config = extends_default()({
          type: 'error',
          iconType: 'cross-circle',
          okCancel: false
        }, props);
        return confirm_confirm(config);
      };

      modal_Modal.warning = modal_Modal.warn = function (props) {
        var config = extends_default()({
          type: 'warning',
          iconType: 'exclamation-circle',
          okCancel: false
        }, props);
        return confirm_confirm(config);
      };

      modal_Modal.confirm = function (props) {
        var config = extends_default()({
          type: 'confirm',
          okCancel: true
        }, props);
        return confirm_confirm(config);
      };
      /* harmony default export */


      var modal = modal_Modal; // CONCATENATED MODULE: ./node_modules/antd/es/notification/index.js

      var notification_notificationInstance = {};
      var notification_defaultDuration = 4.5;
      var notification_defaultTop = 24;
      var notification_defaultBottom = 24;
      var notification_defaultPlacement = 'topRight';
      var notification_defaultGetContainer = void 0;

      function notification_setNotificationConfig(options) {
        var duration = options.duration,
            placement = options.placement,
            bottom = options.bottom,
            top = options.top,
            getContainer = options.getContainer;

        if (duration !== undefined) {
          notification_defaultDuration = duration;
        }

        if (placement !== undefined) {
          notification_defaultPlacement = placement;
        }

        if (bottom !== undefined) {
          notification_defaultBottom = bottom;
        }

        if (top !== undefined) {
          notification_defaultTop = top;
        }

        if (getContainer !== undefined) {
          notification_defaultGetContainer = getContainer;
        }
      }

      function notification_getPlacementStyle(placement) {
        var style = void 0;

        switch (placement) {
          case 'topLeft':
            style = {
              left: 0,
              top: notification_defaultTop,
              bottom: 'auto'
            };
            break;

          case 'topRight':
            style = {
              right: 0,
              top: notification_defaultTop,
              bottom: 'auto'
            };
            break;

          case 'bottomLeft':
            style = {
              left: 0,
              top: 'auto',
              bottom: notification_defaultBottom
            };
            break;

          default:
            style = {
              right: 0,
              top: 'auto',
              bottom: notification_defaultBottom
            };
            break;
        }

        return style;
      }

      function notification_getNotificationInstance(prefixCls, placement, callback) {
        var cacheKey = prefixCls + '-' + placement;

        if (notification_notificationInstance[cacheKey]) {
          callback(notification_notificationInstance[cacheKey]);
          return;
        }

        rc_notification_es["default"].newInstance({
          prefixCls: prefixCls,
          className: prefixCls + '-' + placement,
          style: notification_getPlacementStyle(placement),
          getContainer: notification_defaultGetContainer
        }, function (notification) {
          notification_notificationInstance[cacheKey] = notification;
          callback(notification);
        });
      }

      var notification_typeToIcon = {
        success: 'check-circle-o',
        info: 'info-circle-o',
        error: 'cross-circle-o',
        warning: 'exclamation-circle-o'
      };

      function notification_notice(args) {
        var outerPrefixCls = args.prefixCls || 'ant-notification';
        var prefixCls = outerPrefixCls + '-notice';
        var duration = args.duration === undefined ? notification_defaultDuration : args.duration;
        var iconNode = null;

        if (args.icon) {
          iconNode = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
            className: prefixCls + '-icon'
          }, args.icon);
        } else if (args.type) {
          var iconType = notification_typeToIcon[args.type];
          iconNode = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
            className: prefixCls + '-icon ' + prefixCls + '-icon-' + args.type,
            type: iconType
          });
        }

        var autoMarginTag = !args.description && iconNode ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
          className: prefixCls + '-message-single-line-auto-margin'
        }) : null;
        notification_getNotificationInstance(outerPrefixCls, args.placement || notification_defaultPlacement, function (notification) {
          notification.notice({
            content: external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: iconNode ? prefixCls + '-with-icon' : ''
            }, iconNode, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-message'
            }, autoMarginTag, args.message), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-description'
            }, args.description), args.btn ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: prefixCls + '-btn'
            }, args.btn) : null),
            duration: duration,
            closable: true,
            onClose: args.onClose,
            key: args.key,
            style: args.style || {},
            className: args.className
          });
        });
      }

      var notification_api = {
        open: notification_notice,
        close: function close(key) {
          Object.keys(notification_notificationInstance).forEach(function (cacheKey) {
            return notification_notificationInstance[cacheKey].removeNotice(key);
          });
        },
        config: notification_setNotificationConfig,
        destroy: function destroy() {
          Object.keys(notification_notificationInstance).forEach(function (cacheKey) {
            notification_notificationInstance[cacheKey].destroy();
            delete notification_notificationInstance[cacheKey];
          });
        }
      };
      ['success', 'info', 'warning', 'error'].forEach(function (type) {
        notification_api[type] = function (args) {
          return notification_api.open(extends_default()({}, args, {
            type: type
          }));
        };
      });
      notification_api.warn = notification_api.warning;
      /* harmony default export */

      var es_notification = notification_api; // CONCATENATED MODULE: ./node_modules/antd/es/popconfirm/index.js

      var popconfirm_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var popconfirm_Popconfirm = function (_React$Component) {
        inherits_default()(Popconfirm, _React$Component);

        function Popconfirm(props) {
          classCallCheck_default()(this, Popconfirm);

          var _this = possibleConstructorReturn_default()(this, (Popconfirm.__proto__ || Object.getPrototypeOf(Popconfirm)).call(this, props));

          _this.onConfirm = function (e) {
            _this.setVisible(false);

            var onConfirm = _this.props.onConfirm;

            if (onConfirm) {
              onConfirm.call(_this, e);
            }
          };

          _this.onCancel = function (e) {
            _this.setVisible(false);

            var onCancel = _this.props.onCancel;

            if (onCancel) {
              onCancel.call(_this, e);
            }
          };

          _this.onVisibleChange = function (visible) {
            _this.setVisible(visible);
          };

          _this.saveTooltip = function (node) {
            _this.tooltip = node;
          };

          _this.renderOverlay = function (popconfirmLocale) {
            var _this$props = _this.props,
                prefixCls = _this$props.prefixCls,
                title = _this$props.title,
                cancelText = _this$props.cancelText,
                okText = _this$props.okText,
                okType = _this$props.okType;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-inner-content'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-message'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'exclamation-circle'
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-message-title'
            }, title)), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-buttons'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_button, {
              onClick: _this.onCancel,
              size: 'small'
            }, cancelText || popconfirmLocale.cancelText), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_button, {
              onClick: _this.onConfirm,
              type: okType,
              size: 'small'
            }, okText || popconfirmLocale.okText))));
          };

          _this.state = {
            visible: props.visible
          };
          return _this;
        }

        createClass_default()(Popconfirm, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('visible' in nextProps) {
              this.setState({
                visible: nextProps.visible
              });
            }
          }
        }, {
          key: 'getPopupDomNode',
          value: function getPopupDomNode() {
            return this.tooltip.getPopupDomNode();
          }
        }, {
          key: 'setVisible',
          value: function setVisible(visible) {
            var props = this.props;

            if (!('visible' in props)) {
              this.setState({
                visible: visible
              });
            }

            var onVisibleChange = props.onVisibleChange;

            if (onVisibleChange) {
              onVisibleChange(visible);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                placement = _a.placement,
                restProps = popconfirm_rest(_a, ["prefixCls", "placement"]);
            var overlay = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
              componentName: 'Popconfirm',
              defaultLocale: locale_provider_default.Popconfirm
            }, this.renderOverlay);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](tooltip, extends_default()({}, restProps, {
              prefixCls: prefixCls,
              placement: placement,
              onVisibleChange: this.onVisibleChange,
              visible: this.state.visible,
              overlay: overlay,
              ref: this.saveTooltip
            }));
          }
        }]);
        return Popconfirm;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var popconfirm = popconfirm_Popconfirm;
      popconfirm_Popconfirm.defaultProps = {
        prefixCls: 'ant-popover',
        transitionName: 'zoom-big',
        placement: 'top',
        trigger: 'click',
        okType: 'primary'
      }; // CONCATENATED MODULE: ./node_modules/antd/es/popover/index.js

      var popover_Popover = function (_React$Component) {
        inherits_default()(Popover, _React$Component);

        function Popover() {
          classCallCheck_default()(this, Popover);

          var _this = possibleConstructorReturn_default()(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));

          _this.saveTooltip = function (node) {
            _this.tooltip = node;
          };

          return _this;
        }

        createClass_default()(Popover, [{
          key: 'getPopupDomNode',
          value: function getPopupDomNode() {
            return this.tooltip.getPopupDomNode();
          }
        }, {
          key: 'getOverlay',
          value: function getOverlay() {
            var _props = this.props,
                title = _props.title,
                prefixCls = _props.prefixCls,
                content = _props.content;

            _util_warning(!('overlay' in this.props), 'Popover[overlay] is removed, please use Popover[content] instead, ' + 'see: https://u.ant.design/popover-content');

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', null, title && external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-title'
            }, title), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-inner-content'
            }, content));
          }
        }, {
          key: 'render',
          value: function render() {
            var props = extends_default()({}, this.props);
            delete props.title;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](tooltip, extends_default()({}, props, {
              ref: this.saveTooltip,
              overlay: this.getOverlay()
            }));
          }
        }]);
        return Popover;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var popover = popover_Popover;
      popover_Popover.defaultProps = {
        prefixCls: 'ant-popover',
        placement: 'top',
        transitionName: 'zoom-big',
        trigger: 'hover',
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        overlayStyle: {}
      }; // EXTERNAL MODULE: ./node_modules/rc-progress/es/index.js + 4 modules

      var rc_progress_es = __webpack_require__(376); // CONCATENATED MODULE: ./node_modules/antd/es/progress/progress.js


      var progress_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var progress_statusColorMap = {
        normal: '#108ee9',
        exception: '#ff5500',
        success: '#87d068'
      };

      var progress_Progress = function (_React$Component) {
        inherits_default()(Progress, _React$Component);

        function Progress() {
          classCallCheck_default()(this, Progress);
          return possibleConstructorReturn_default()(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
        }

        createClass_default()(Progress, [{
          key: 'render',
          value: function render() {
            var _classNames;

            var props = this.props;
            var prefixCls = props.prefixCls,
                className = props.className,
                _props$percent = props.percent,
                percent = _props$percent === undefined ? 0 : _props$percent,
                status = props.status,
                format = props.format,
                trailColor = props.trailColor,
                size = props.size,
                successPercent = props.successPercent,
                type = props.type,
                strokeWidth = props.strokeWidth,
                width = props.width,
                showInfo = props.showInfo,
                _props$gapDegree = props.gapDegree,
                gapDegree = _props$gapDegree === undefined ? 0 : _props$gapDegree,
                gapPosition = props.gapPosition,
                restProps = progress_rest(props, ["prefixCls", "className", "percent", "status", "format", "trailColor", "size", "successPercent", "type", "strokeWidth", "width", "showInfo", "gapDegree", "gapPosition"]);
            var progressStatus = parseInt(successPercent ? successPercent.toString() : percent.toString(), 10) >= 100 && !('status' in props) ? 'success' : status || 'normal';
            var progressInfo = void 0;
            var progress = void 0;

            var textFormatter = format || function (percentNumber) {
              return percentNumber + '%';
            };

            if (showInfo) {
              var text = void 0;
              var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';

              if (progressStatus === 'exception') {
                text = format ? textFormatter(percent) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                  type: 'cross' + iconType
                });
              } else if (progressStatus === 'success') {
                text = format ? textFormatter(percent) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                  type: 'check' + iconType
                });
              } else {
                text = textFormatter(percent);
              }

              progressInfo = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: prefixCls + '-text'
              }, text);
            }

            if (type === 'line') {
              var percentStyle = {
                width: percent + '%',
                height: strokeWidth || (size === 'small' ? 6 : 8)
              };
              var successPercentStyle = {
                width: successPercent + '%',
                height: strokeWidth || (size === 'small' ? 6 : 8)
              };
              var successSegment = successPercent !== undefined ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: prefixCls + '-success-bg',
                style: successPercentStyle
              }) : null;
              progress = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: prefixCls + '-outer'
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: prefixCls + '-inner'
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: prefixCls + '-bg',
                style: percentStyle
              }), successSegment)), progressInfo);
            } else if (type === 'circle' || type === 'dashboard') {
              var circleSize = width || 120;
              var circleStyle = {
                width: circleSize,
                height: circleSize,
                fontSize: circleSize * 0.15 + 6
              };
              var circleWidth = strokeWidth || 6;
              var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
              var gapDeg = gapDegree || type === 'dashboard' && 75;
              progress = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: prefixCls + '-inner',
                style: circleStyle
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_progress_es["Circle"], {
                percent: percent,
                strokeWidth: circleWidth,
                trailWidth: circleWidth,
                strokeColor: progress_statusColorMap[progressStatus],
                trailColor: trailColor,
                prefixCls: prefixCls,
                gapDegree: gapDeg,
                gapPosition: gapPos
              }), progressInfo);
            }

            var classString = classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-' + (type === 'dashboard' && 'circle' || type), true), defineProperty_default()(_classNames, prefixCls + '-status-' + progressStatus, true), defineProperty_default()(_classNames, prefixCls + '-show-info', showInfo), defineProperty_default()(_classNames, prefixCls + '-' + size, size), _classNames), className);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, restProps, {
              className: classString
            }), progress);
          }
        }]);
        return Progress;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var progress_progress = progress_Progress;
      progress_Progress.defaultProps = {
        type: 'line',
        percent: 0,
        showInfo: true,
        trailColor: '#f3f3f3',
        prefixCls: 'ant-progress',
        size: 'default'
      };
      progress_Progress.propTypes = {
        status: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['normal', 'exception', 'active', 'success']),
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['line', 'circle', 'dashboard']),
        showInfo: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        percent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        width: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        strokeWidth: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        trailColor: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        format: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        gapDegree: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        'default': external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['default', 'small'])
      }; // CONCATENATED MODULE: ./node_modules/antd/es/progress/index.js

      /* harmony default export */

      var es_progress = progress_progress; // CONCATENATED MODULE: ./node_modules/rc-rate/es/util.js

      function util_getScroll(w, top) {
        var ret = top ? w.pageYOffset : w.pageXOffset;
        var method = top ? 'scrollTop' : 'scrollLeft';

        if (typeof ret !== 'number') {
          var d = w.document; // ie6,7,8 standard mode

          ret = d.documentElement[method];

          if (typeof ret !== 'number') {
            // quirks mode
            ret = d.body[method];
          }
        }

        return ret;
      }

      function getClientPosition(elem) {
        var box = void 0;
        var x = void 0;
        var y = void 0;
        var doc = elem.ownerDocument;
        var body = doc.body;
        var docElem = doc && doc.documentElement;
        box = elem.getBoundingClientRect();
        x = box.left;
        y = box.top;
        x -= docElem.clientLeft || body.clientLeft || 0;
        y -= docElem.clientTop || body.clientTop || 0;
        return {
          left: x,
          top: y
        };
      }

      function getOffsetLeft(el) {
        var pos = getClientPosition(el);
        var doc = el.ownerDocument;
        var w = doc.defaultView || doc.parentWindow;
        pos.left += util_getScroll(w);
        return pos.left;
      } // CONCATENATED MODULE: ./node_modules/rc-rate/es/Star.js


      function Star_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Star_possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function Star_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Star_Star = function (_React$Component) {
        Star_inherits(Star, _React$Component);

        function Star() {
          var _temp, _this, _ret;

          Star_classCallCheck(this, Star);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = Star_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onHover = function (e) {
            var _this$props = _this.props,
                onHover = _this$props.onHover,
                index = _this$props.index;
            onHover(e, index);
          }, _this.onClick = function (e) {
            var _this$props2 = _this.props,
                onClick = _this$props2.onClick,
                index = _this$props2.index;
            onClick(e, index);
          }, _this.onKeyDown = function (e) {
            var _this$props3 = _this.props,
                onClick = _this$props3.onClick,
                index = _this$props3.index;

            if (e.keyCode === 13) {
              onClick(e, index);
            }
          }, _temp), Star_possibleConstructorReturn(_this, _ret);
        }

        Star.prototype.getClassName = function getClassName() {
          var _props = this.props,
              prefixCls = _props.prefixCls,
              index = _props.index,
              value = _props.value,
              allowHalf = _props.allowHalf,
              focused = _props.focused;
          var starValue = index + 1;
          var className = prefixCls;

          if (value === 0 && index === 0 && focused) {
            className += ' ' + prefixCls + '-focused';
          } else if (allowHalf && value + 0.5 === starValue) {
            className += ' ' + prefixCls + '-half ' + prefixCls + '-active';

            if (focused) {
              className += ' ' + prefixCls + '-focused';
            }
          } else {
            className += starValue <= value ? ' ' + prefixCls + '-full' : ' ' + prefixCls + '-zero';

            if (starValue === value && focused) {
              className += ' ' + prefixCls + '-focused';
            }
          }

          return className;
        };

        Star.prototype.render = function render() {
          var onHover = this.onHover,
              onClick = this.onClick,
              onKeyDown = this.onKeyDown;
          var _props2 = this.props,
              disabled = _props2.disabled,
              prefixCls = _props2.prefixCls,
              character = _props2.character,
              index = _props2.index,
              count = _props2.count,
              value = _props2.value;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
            className: this.getClassName(),
            onClick: disabled ? null : onClick,
            onKeyDown: disabled ? null : onKeyDown,
            onMouseMove: disabled ? null : onHover,
            role: 'radio',
            'aria-checked': value > index ? 'true' : 'false',
            'aria-posinset': index + 1,
            'aria-setsize': count,
            tabIndex: 0
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-first'
          }, character), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-second'
          }, character));
        };

        return Star;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Star_Star.propTypes = {
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        index: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        allowHalf: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onHover: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        character: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        focused: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        count: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
      };
      /* harmony default export */

      var es_Star = Star_Star; // CONCATENATED MODULE: ./node_modules/rc-rate/es/Rate.js

      var Rate_extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      function Rate_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Rate_possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function Rate_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      function Rate_noop() {}

      var Rate_Rate = function (_React$Component) {
        Rate_inherits(Rate, _React$Component);

        function Rate(props) {
          Rate_classCallCheck(this, Rate);

          var _this = Rate_possibleConstructorReturn(this, _React$Component.call(this, props));

          Rate_initialiseProps.call(_this);
          var value = props.value;

          if (value === undefined) {
            value = props.defaultValue;
          }

          _this.stars = {};
          _this.state = {
            value: value,
            focused: false,
            cleanedValue: null
          };
          return _this;
        }

        Rate.prototype.componentDidMount = function componentDidMount() {
          if (this.props.autoFocus && !this.props.disabled) {
            this.focus();
          }
        };

        Rate.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
          if ('value' in nextProps && nextProps.value !== undefined) {
            return Rate_extends({}, state, {
              value: nextProps.value
            });
          }

          return state;
        };

        Rate.prototype.getStarDOM = function getStarDOM(index) {
          return external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this.stars[index]);
        };

        Rate.prototype.getStarValue = function getStarValue(index, x) {
          var value = index + 1;

          if (this.props.allowHalf) {
            var starEle = this.getStarDOM(index);
            var leftDis = getOffsetLeft(starEle);
            var width = starEle.clientWidth;

            if (x - leftDis < width / 2) {
              value -= 0.5;
            }
          }

          return value;
        };

        Rate.prototype.focus = function focus() {
          if (!this.props.disabled) {
            this.rate.focus();
          }
        };

        Rate.prototype.blur = function blur() {
          if (!this.props.disabled) {
            this.rate.focus();
          }
        };

        Rate.prototype.changeValue = function changeValue(value) {
          if (!('value' in this.props)) {
            this.setState({
              value: value
            });
          }

          this.props.onChange(value);
        };

        Rate.prototype.render = function render() {
          var _props = this.props,
              count = _props.count,
              allowHalf = _props.allowHalf,
              style = _props.style,
              prefixCls = _props.prefixCls,
              disabled = _props.disabled,
              className = _props.className,
              character = _props.character,
              tabIndex = _props.tabIndex;
          var _state = this.state,
              value = _state.value,
              hoverValue = _state.hoverValue,
              focused = _state.focused;
          var stars = [];
          var disabledClass = disabled ? prefixCls + '-disabled' : '';

          for (var index = 0; index < count; index++) {
            stars.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Star, {
              ref: this.saveRef(index),
              index: index,
              count: count,
              disabled: disabled,
              prefixCls: prefixCls + '-star',
              allowHalf: allowHalf,
              value: hoverValue === undefined ? value : hoverValue,
              onClick: this.onClick,
              onHover: this.onHover,
              key: index,
              character: character,
              focused: focused
            }));
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', {
            className: classnames_default()(prefixCls, disabledClass, className),
            style: style,
            onMouseLeave: disabled ? null : this.onMouseLeave,
            tabIndex: disabled ? -1 : tabIndex,
            onFocus: disabled ? null : this.onFocus,
            onBlur: disabled ? null : this.onBlur,
            onKeyDown: disabled ? null : this.onKeyDown,
            ref: this.saveRate,
            role: 'radiogroup'
          }, stars);
        };

        return Rate;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Rate_Rate.propTypes = {
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        count: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        allowHalf: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        allowClear: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onHoverChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        character: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        tabIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onKeyDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        autoFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      Rate_Rate.defaultProps = {
        defaultValue: 0,
        count: 5,
        allowHalf: false,
        allowClear: true,
        style: {},
        prefixCls: 'rc-rate',
        onChange: Rate_noop,
        character: '★',
        onHoverChange: Rate_noop,
        tabIndex: 0
      };

      var Rate_initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.onHover = function (event, index) {
          var hoverValue = _this2.getStarValue(index, event.pageX);

          var cleanedValue = _this2.state.cleanedValue;

          if (hoverValue !== cleanedValue) {
            _this2.setState({
              hoverValue: hoverValue,
              cleanedValue: null
            });
          }

          _this2.props.onHoverChange(hoverValue);
        };

        this.onMouseLeave = function () {
          _this2.setState({
            hoverValue: undefined,
            cleanedValue: null
          });

          _this2.props.onHoverChange(undefined);
        };

        this.onClick = function (event, index) {
          var value = _this2.getStarValue(index, event.pageX);

          var isReset = false;

          if (_this2.props.allowClear) {
            isReset = value === _this2.state.value;
          }

          _this2.onMouseLeave(true);

          _this2.changeValue(isReset ? 0 : value);

          _this2.setState({
            cleanedValue: isReset ? value : null
          });
        };

        this.onFocus = function () {
          var onFocus = _this2.props.onFocus;

          _this2.setState({
            focused: true
          });

          if (onFocus) {
            onFocus();
          }
        };

        this.onBlur = function () {
          var onBlur = _this2.props.onBlur;

          _this2.setState({
            focused: false
          });

          if (onBlur) {
            onBlur();
          }
        };

        this.onKeyDown = function (event) {
          var keyCode = event.keyCode;
          var _props2 = _this2.props,
              count = _props2.count,
              allowHalf = _props2.allowHalf,
              onKeyDown = _props2.onKeyDown;
          var value = _this2.state.value;

          if (keyCode === es_KeyCode["a"
          /* default */
          ].RIGHT && value < count) {
            if (allowHalf) {
              value += 0.5;
            } else {
              value += 1;
            }

            _this2.changeValue(value);

            event.preventDefault();
          } else if (keyCode === es_KeyCode["a"
          /* default */
          ].LEFT && value > 0) {
            if (allowHalf) {
              value -= 0.5;
            } else {
              value -= 1;
            }

            _this2.changeValue(value);

            event.preventDefault();
          }

          if (onKeyDown) {
            onKeyDown(event);
          }
        };

        this.saveRef = function (index) {
          return function (node) {
            _this2.stars[index] = node;
          };
        };

        this.saveRate = function (node) {
          _this2.rate = node;
        };
      };

      Object(react_lifecycles_compat_es["polyfill"])(Rate_Rate);
      /* harmony default export */

      var es_Rate = Rate_Rate; // CONCATENATED MODULE: ./node_modules/rc-rate/es/index.js

      /* harmony default export */

      var rc_rate_es = es_Rate; // CONCATENATED MODULE: ./node_modules/antd/es/rate/index.js

      var rate_Rate = function (_React$Component) {
        inherits_default()(Rate, _React$Component);

        function Rate() {
          classCallCheck_default()(this, Rate);

          var _this = possibleConstructorReturn_default()(this, (Rate.__proto__ || Object.getPrototypeOf(Rate)).apply(this, arguments));

          _this.saveRate = function (node) {
            _this.rcRate = node;
          };

          return _this;
        }

        createClass_default()(Rate, [{
          key: 'focus',
          value: function focus() {
            this.rcRate.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.rcRate.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_rate_es, extends_default()({
              ref: this.saveRate
            }, this.props));
          }
        }]);
        return Rate;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var rate = rate_Rate;
      rate_Rate.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        character: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node
      };
      rate_Rate.defaultProps = {
        prefixCls: 'ant-rate',
        character: external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
          type: 'star'
        })
      }; // CONCATENATED MODULE: ./node_modules/antd/es/row/index.js

      /* harmony default export */

      var es_row = grid_row; // EXTERNAL MODULE: ./node_modules/rc-slider/node_modules/warning/warning.js

      var node_modules_warning_warning = __webpack_require__(114);

      var warning_warning_default =
      /*#__PURE__*/
      __webpack_require__.n(node_modules_warning_warning); // CONCATENATED MODULE: ./node_modules/rc-slider/es/common/Track.js

      /* eslint-disable react/prop-types */


      var Track_Track = function Track(props) {
        var className = props.className,
            included = props.included,
            vertical = props.vertical,
            offset = props.offset,
            length = props.length,
            style = props.style;
        var positonStyle = vertical ? {
          bottom: offset + '%',
          height: length + '%'
        } : {
          left: offset + '%',
          width: length + '%'
        };
        var elStyle = extends_default()({}, style, positonStyle);
        return included ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
          className: className,
          style: elStyle
        }) : null;
      };
      /* harmony default export */


      var common_Track = Track_Track; // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/get.js

      var helpers_get = __webpack_require__(225);

      var helpers_get_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_get); // CONCATENATED MODULE: ./node_modules/rc-slider/es/common/Steps.js


      var Steps_calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
        warning_warning_default()(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
        var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
          return a - b;
        });

        if (dots && step) {
          for (var i = min; i <= max; i += step) {
            if (points.indexOf(i) === -1) {
              points.push(i);
            }
          }
        }

        return points;
      };

      var Steps_Steps = function Steps(_ref) {
        var prefixCls = _ref.prefixCls,
            vertical = _ref.vertical,
            marks = _ref.marks,
            dots = _ref.dots,
            step = _ref.step,
            included = _ref.included,
            lowerBound = _ref.lowerBound,
            upperBound = _ref.upperBound,
            max = _ref.max,
            min = _ref.min,
            dotStyle = _ref.dotStyle,
            activeDotStyle = _ref.activeDotStyle;
        var range = max - min;
        var elements = Steps_calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
          var _classNames;

          var offset = Math.abs(point - min) / range * 100 + '%';
          var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
          var style = vertical ? extends_default()({
            bottom: offset
          }, dotStyle) : extends_default()({
            left: offset
          }, dotStyle);

          if (isActived) {
            style = extends_default()({}, style, activeDotStyle);
          }

          var pointClassName = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-dot', true), defineProperty_default()(_classNames, prefixCls + '-dot-active', isActived), _classNames));
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: pointClassName,
            style: style,
            key: point
          });
        });
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
          className: prefixCls + '-step'
        }, elements);
      };

      Steps_Steps.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        activeDotStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        dotStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        min: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        max: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        upperBound: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        lowerBound: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        included: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        dots: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        step: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        marks: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        vertical: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var common_Steps = Steps_Steps; // CONCATENATED MODULE: ./node_modules/rc-slider/es/common/Marks.js

      var Marks_Marks = function Marks(_ref) {
        var className = _ref.className,
            vertical = _ref.vertical,
            marks = _ref.marks,
            included = _ref.included,
            upperBound = _ref.upperBound,
            lowerBound = _ref.lowerBound,
            max = _ref.max,
            min = _ref.min,
            onClickLabel = _ref.onClickLabel;
        var marksKeys = Object.keys(marks);
        var range = max - min;
        var elements = marksKeys.map(parseFloat).sort(function (a, b) {
          return a - b;
        }).map(function (point) {
          var _classNames;

          var markPoint = marks[point];
          var markPointIsObject = typeof markPoint === 'object' && !external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.isValidElement(markPoint);
          var markLabel = markPointIsObject ? markPoint.label : markPoint;

          if (!markLabel && markLabel !== 0) {
            return null;
          }

          var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
          var markClassName = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, className + '-text', true), defineProperty_default()(_classNames, className + '-text-active', isActive), _classNames));
          var bottomStyle = {
            marginBottom: '-50%',
            bottom: (point - min) / range * 100 + '%'
          };
          var leftStyle = {
            left: (point - min) / range * 100 + '%',
            transform: 'translateX(-50%)',
            msTransform: 'translateX(-50%)'
          };
          var style = vertical ? bottomStyle : leftStyle;
          var markStyle = markPointIsObject ? extends_default()({}, style, markPoint.style) : style;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: markClassName,
            style: markStyle,
            key: point,
            onMouseDown: function onMouseDown(e) {
              return onClickLabel(e, point);
            },
            onTouchStart: function onTouchStart(e) {
              return onClickLabel(e, point);
            }
          }, markLabel);
        });
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
          className: className
        }, elements);
      };

      Marks_Marks.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        vertical: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        marks: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        included: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        upperBound: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        lowerBound: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        max: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        min: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        onClickLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      /* harmony default export */

      var common_Marks = Marks_Marks; // CONCATENATED MODULE: ./node_modules/rc-slider/es/Handle.js

      var Handle_Handle = function (_React$Component) {
        inherits_default()(Handle, _React$Component);

        function Handle() {
          var _ref;

          var _temp, _this, _ret;

          classCallCheck_default()(this, Handle);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            clickFocused: false
          }, _this.setHandleRef = function (node) {
            _this.handle = node;
          }, _this.handleMouseUp = function () {
            if (document.activeElement === _this.handle) {
              _this.setClickFocus(true);
            }
          }, _this.handleMouseDown = function () {
            // fix https://github.com/ant-design/ant-design/issues/15324
            _this.focus();
          }, _this.handleBlur = function () {
            _this.setClickFocus(false);
          }, _this.handleKeyDown = function () {
            _this.setClickFocus(false);
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        createClass_default()(Handle, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            // mouseup won't trigger if mouse moved out of handle,
            // so we listen on document here.
            this.onMouseUpListener = Object(addEventListener["a"
            /* default */
            ])(document, 'mouseup', this.handleMouseUp);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.onMouseUpListener) {
              this.onMouseUpListener.remove();
            }
          }
        }, {
          key: 'setClickFocus',
          value: function setClickFocus(focused) {
            this.setState({
              clickFocused: focused
            });
          }
        }, {
          key: 'clickFocus',
          value: function clickFocus() {
            this.setClickFocus(true);
            this.focus();
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.handle.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.handle.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                vertical = _props.vertical,
                offset = _props.offset,
                style = _props.style,
                disabled = _props.disabled,
                min = _props.min,
                max = _props.max,
                value = _props.value,
                tabIndex = _props.tabIndex,
                restProps = objectWithoutProperties_default()(_props, ['prefixCls', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);
            var className = classnames_default()(this.props.className, defineProperty_default()({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
            var postionStyle = vertical ? {
              bottom: offset + '%'
            } : {
              left: offset + '%'
            };
            var elStyle = extends_default()({}, style, postionStyle);

            var _tabIndex = tabIndex || 0;

            if (disabled || tabIndex === null) {
              _tabIndex = null;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', extends_default()({
              ref: this.setHandleRef,
              tabIndex: _tabIndex
            }, restProps, {
              className: className,
              style: elStyle,
              onBlur: this.handleBlur,
              onKeyDown: this.handleKeyDown,
              onMouseDown: this.handleMouseDown // aria attribute
              ,
              role: 'slider',
              'aria-valuemin': min,
              'aria-valuemax': max,
              'aria-valuenow': value,
              'aria-disabled': !!disabled
            }));
          }
        }]);
        return Handle;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);
      /* harmony default export */


      var es_Handle = Handle_Handle;
      Handle_Handle.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        vertical: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        offset: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        min: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        max: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        tabIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
      }; // CONCATENATED MODULE: ./node_modules/rc-slider/es/utils.js

      function utils_isDev() {
        return "production" !== 'production';
      }

      function utils_isEventFromHandle(e, handles) {
        try {
          return Object.keys(handles).some(function (key) {
            return e.target === Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"])(handles[key]);
          });
        } catch (error) {
          return false;
        }
      }

      function utils_isValueOutOfRange(value, _ref) {
        var min = _ref.min,
            max = _ref.max;
        return value < min || value > max;
      }

      function utils_isNotTouchEvent(e) {
        return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
      }

      function utils_getClosestPoint(val, _ref2) {
        var marks = _ref2.marks,
            step = _ref2.step,
            min = _ref2.min,
            max = _ref2.max;
        var points = Object.keys(marks).map(parseFloat);

        if (step !== null) {
          var maxSteps = Math.floor((max - min) / step);
          var steps = Math.min((val - min) / step, maxSteps);
          var closestStep = Math.round(steps) * step + min;
          points.push(closestStep);
        }

        var diffs = points.map(function (point) {
          return Math.abs(val - point);
        });
        return points[diffs.indexOf(Math.min.apply(Math, toConsumableArray_default()(diffs)))];
      }

      function utils_getPrecision(step) {
        var stepString = step.toString();
        var precision = 0;

        if (stepString.indexOf('.') >= 0) {
          precision = stepString.length - stepString.indexOf('.') - 1;
        }

        return precision;
      }

      function utils_getMousePosition(vertical, e) {
        return vertical ? e.clientY : e.pageX;
      }

      function utils_getTouchPosition(vertical, e) {
        return vertical ? e.touches[0].clientY : e.touches[0].pageX;
      }

      function utils_getHandleCenterPosition(vertical, handle) {
        var coords = handle.getBoundingClientRect();
        return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
      }

      function utils_ensureValueInRange(val, _ref3) {
        var max = _ref3.max,
            min = _ref3.min;

        if (val <= min) {
          return min;
        }

        if (val >= max) {
          return max;
        }

        return val;
      }

      function utils_ensureValuePrecision(val, props) {
        var step = props.step;
        var closestPoint = isFinite(utils_getClosestPoint(val, props)) ? utils_getClosestPoint(val, props) : 0; // eslint-disable-line

        return step === null ? closestPoint : parseFloat(closestPoint.toFixed(utils_getPrecision(step)));
      }

      function utils_pauseEvent(e) {
        e.stopPropagation();
        e.preventDefault();
      }

      function utils_calculateNextValue(func, value, props) {
        var operations = {
          increase: function increase(a, b) {
            return a + b;
          },
          decrease: function decrease(a, b) {
            return a - b;
          }
        };
        var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
        var keyToGet = Object.keys(props.marks)[indexToGet];

        if (props.step) {
          return operations[func](value, props.step);
        } else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
          return props.marks[keyToGet];
        }

        return value;
      }

      function utils_getKeyboardValueMutator(e) {
        switch (e.keyCode) {
          case es_KeyCode["a"
          /* default */
          ].UP:
          case es_KeyCode["a"
          /* default */
          ].RIGHT:
            return function (value, props) {
              return utils_calculateNextValue('increase', value, props);
            };

          case es_KeyCode["a"
          /* default */
          ].DOWN:
          case es_KeyCode["a"
          /* default */
          ].LEFT:
            return function (value, props) {
              return utils_calculateNextValue('decrease', value, props);
            };

          case es_KeyCode["a"
          /* default */
          ].END:
            return function (value, props) {
              return props.max;
            };

          case es_KeyCode["a"
          /* default */
          ].HOME:
            return function (value, props) {
              return props.min;
            };

          case es_KeyCode["a"
          /* default */
          ].PAGE_UP:
            return function (value, props) {
              return value + props.step * 2;
            };

          case es_KeyCode["a"
          /* default */
          ].PAGE_DOWN:
            return function (value, props) {
              return value - props.step * 2;
            };

          default:
            return undefined;
        }
      } // CONCATENATED MODULE: ./node_modules/rc-slider/es/common/createSlider.js


      function createSlider_noop() {}

      function createSlider_createSlider(Component) {
        var _class, _temp;

        return _temp = _class = function (_Component) {
          inherits_default()(ComponentEnhancer, _Component);

          function ComponentEnhancer(props) {
            classCallCheck_default()(this, ComponentEnhancer);

            var _this = possibleConstructorReturn_default()(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

            _this.onMouseDown = function (e) {
              if (e.button !== 0) {
                return;
              }

              var isVertical = _this.props.vertical;
              var position = utils_getMousePosition(isVertical, e);

              if (!utils_isEventFromHandle(e, _this.handlesRefs)) {
                _this.dragOffset = 0;
              } else {
                var handlePosition = utils_getHandleCenterPosition(isVertical, e.target);
                _this.dragOffset = position - handlePosition;
                position = handlePosition;
              }

              _this.removeDocumentEvents();

              _this.onStart(position);

              _this.addDocumentMouseEvents();
            };

            _this.onTouchStart = function (e) {
              if (utils_isNotTouchEvent(e)) return;
              var isVertical = _this.props.vertical;
              var position = utils_getTouchPosition(isVertical, e);

              if (!utils_isEventFromHandle(e, _this.handlesRefs)) {
                _this.dragOffset = 0;
              } else {
                var handlePosition = utils_getHandleCenterPosition(isVertical, e.target);
                _this.dragOffset = position - handlePosition;
                position = handlePosition;
              }

              _this.onStart(position);

              _this.addDocumentTouchEvents();

              utils_pauseEvent(e);
            };

            _this.onFocus = function (e) {
              var _this$props = _this.props,
                  onFocus = _this$props.onFocus,
                  vertical = _this$props.vertical;

              if (utils_isEventFromHandle(e, _this.handlesRefs)) {
                var handlePosition = utils_getHandleCenterPosition(vertical, e.target);
                _this.dragOffset = 0;

                _this.onStart(handlePosition);

                utils_pauseEvent(e);

                if (onFocus) {
                  onFocus(e);
                }
              }
            };

            _this.onBlur = function (e) {
              var onBlur = _this.props.onBlur;

              _this.onEnd();

              if (onBlur) {
                onBlur(e);
              }
            };

            _this.onMouseUp = function () {
              if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
                _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
              }
            };

            _this.onMouseMove = function (e) {
              if (!_this.sliderRef) {
                _this.onEnd();

                return;
              }

              var position = utils_getMousePosition(_this.props.vertical, e);

              _this.onMove(e, position - _this.dragOffset);
            };

            _this.onTouchMove = function (e) {
              if (utils_isNotTouchEvent(e) || !_this.sliderRef) {
                _this.onEnd();

                return;
              }

              var position = utils_getTouchPosition(_this.props.vertical, e);

              _this.onMove(e, position - _this.dragOffset);
            };

            _this.onKeyDown = function (e) {
              if (_this.sliderRef && utils_isEventFromHandle(e, _this.handlesRefs)) {
                _this.onKeyboard(e);
              }
            };

            _this.onClickMarkLabel = function (e, value) {
              e.stopPropagation();

              _this.onChange({
                value: value
              });

              _this.setState({
                value: value
              }, function () {
                return _this.onEnd(true);
              });
            };

            _this.saveSlider = function (slider) {
              _this.sliderRef = slider;
            };

            if (utils_isDev()) {
              var step = props.step,
                  max = props.max,
                  min = props.min;
              var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line

              warning_warning_default()(step && Math.floor(step) === step ? isPointDiffEven : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
            }

            _this.handlesRefs = {};
            return _this;
          }

          createClass_default()(ComponentEnhancer, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              // Snapshot testing cannot handle refs, so be sure to null-check this.
              this.document = this.sliderRef && this.sliderRef.ownerDocument;
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              if (helpers_get_default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) helpers_get_default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
              this.removeDocumentEvents();
            }
          }, {
            key: 'getSliderStart',
            value: function getSliderStart() {
              var slider = this.sliderRef;
              var rect = slider.getBoundingClientRect();
              return this.props.vertical ? rect.top : rect.left + window.pageXOffset;
            }
          }, {
            key: 'getSliderLength',
            value: function getSliderLength() {
              var slider = this.sliderRef;

              if (!slider) {
                return 0;
              }

              var coords = slider.getBoundingClientRect();
              return this.props.vertical ? coords.height : coords.width;
            }
          }, {
            key: 'addDocumentTouchEvents',
            value: function addDocumentTouchEvents() {
              // just work for Chrome iOS Safari and Android Browser
              this.onTouchMoveListener = Object(addEventListener["a"
              /* default */
              ])(this.document, 'touchmove', this.onTouchMove);
              this.onTouchUpListener = Object(addEventListener["a"
              /* default */
              ])(this.document, 'touchend', this.onEnd);
            }
          }, {
            key: 'addDocumentMouseEvents',
            value: function addDocumentMouseEvents() {
              this.onMouseMoveListener = Object(addEventListener["a"
              /* default */
              ])(this.document, 'mousemove', this.onMouseMove);
              this.onMouseUpListener = Object(addEventListener["a"
              /* default */
              ])(this.document, 'mouseup', this.onEnd);
            }
          }, {
            key: 'removeDocumentEvents',
            value: function removeDocumentEvents() {
              /* eslint-disable no-unused-expressions */
              this.onTouchMoveListener && this.onTouchMoveListener.remove();
              this.onTouchUpListener && this.onTouchUpListener.remove();
              this.onMouseMoveListener && this.onMouseMoveListener.remove();
              this.onMouseUpListener && this.onMouseUpListener.remove();
              /* eslint-enable no-unused-expressions */
            }
          }, {
            key: 'focus',
            value: function focus() {
              if (!this.props.disabled) {
                this.handlesRefs[0].focus();
              }
            }
          }, {
            key: 'blur',
            value: function blur() {
              var _this2 = this;

              if (!this.props.disabled) {
                Object.keys(this.handlesRefs).forEach(function (key) {
                  if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
                    _this2.handlesRefs[key].blur();
                  }
                });
              }
            }
          }, {
            key: 'calcValue',
            value: function calcValue(offset) {
              var _props = this.props,
                  vertical = _props.vertical,
                  min = _props.min,
                  max = _props.max;
              var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
              var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
              return value;
            }
          }, {
            key: 'calcValueByPos',
            value: function calcValueByPos(position) {
              var pixelOffset = position - this.getSliderStart();
              var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
              return nextValue;
            }
          }, {
            key: 'calcOffset',
            value: function calcOffset(value) {
              var _props2 = this.props,
                  min = _props2.min,
                  max = _props2.max;
              var ratio = (value - min) / (max - min);
              return ratio * 100;
            }
          }, {
            key: 'saveHandle',
            value: function saveHandle(index, handle) {
              this.handlesRefs[index] = handle;
            }
          }, {
            key: 'render',
            value: function render() {
              var _classNames;

              var _props3 = this.props,
                  prefixCls = _props3.prefixCls,
                  className = _props3.className,
                  marks = _props3.marks,
                  dots = _props3.dots,
                  step = _props3.step,
                  included = _props3.included,
                  disabled = _props3.disabled,
                  vertical = _props3.vertical,
                  min = _props3.min,
                  max = _props3.max,
                  children = _props3.children,
                  maximumTrackStyle = _props3.maximumTrackStyle,
                  style = _props3.style,
                  railStyle = _props3.railStyle,
                  dotStyle = _props3.dotStyle,
                  activeDotStyle = _props3.activeDotStyle;

              var _get$call = helpers_get_default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
                  tracks = _get$call.tracks,
                  handles = _get$call.handles;

              var sliderClassName = classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), defineProperty_default()(_classNames, prefixCls + '-disabled', disabled), defineProperty_default()(_classNames, prefixCls + '-vertical', vertical), defineProperty_default()(_classNames, className, className), _classNames));
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
                ref: this.saveSlider,
                className: sliderClassName,
                onTouchStart: disabled ? createSlider_noop : this.onTouchStart,
                onMouseDown: disabled ? createSlider_noop : this.onMouseDown,
                onMouseUp: disabled ? createSlider_noop : this.onMouseUp,
                onKeyDown: disabled ? createSlider_noop : this.onKeyDown,
                onFocus: disabled ? createSlider_noop : this.onFocus,
                onBlur: disabled ? createSlider_noop : this.onBlur,
                style: style
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
                className: prefixCls + '-rail',
                style: extends_default()({}, maximumTrackStyle, railStyle)
              }), tracks, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(common_Steps, {
                prefixCls: prefixCls,
                vertical: vertical,
                marks: marks,
                dots: dots,
                step: step,
                included: included,
                lowerBound: this.getLowerBound(),
                upperBound: this.getUpperBound(),
                max: max,
                min: min,
                dotStyle: dotStyle,
                activeDotStyle: activeDotStyle
              }), handles, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(common_Marks, {
                className: prefixCls + '-mark',
                onClickLabel: disabled ? createSlider_noop : this.onClickMarkLabel,
                vertical: vertical,
                marks: marks,
                included: included,
                lowerBound: this.getLowerBound(),
                upperBound: this.getUpperBound(),
                max: max,
                min: min
              }), children);
            }
          }]);
          return ComponentEnhancer;
        }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = extends_default()({}, Component.propTypes, {
          min: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          max: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          step: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          marks: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          included: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          onBeforeChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onAfterChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          handle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          dots: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          vertical: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          minimumTrackStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          // just for compatibility, will be deperecate
          maximumTrackStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          // just for compatibility, will be deperecate
          handleStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object)]),
          trackStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object)]),
          railStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          dotStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          activeDotStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          autoFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        }), _class.defaultProps = extends_default()({}, Component.defaultProps, {
          prefixCls: 'rc-slider',
          className: '',
          min: 0,
          max: 100,
          step: 1,
          marks: {},
          handle: function handle(_ref) {
            var index = _ref.index,
                restProps = objectWithoutProperties_default()(_ref, ['index']);
            delete restProps.dragging;

            if (restProps.value === null) {
              return null;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Handle, extends_default()({}, restProps, {
              key: index
            }));
          },
          onBeforeChange: createSlider_noop,
          onChange: createSlider_noop,
          onAfterChange: createSlider_noop,
          included: true,
          disabled: false,
          dots: false,
          vertical: false,
          trackStyle: [{}],
          handleStyle: [{}],
          railStyle: {},
          dotStyle: {},
          activeDotStyle: {}
        }), _temp;
      } // CONCATENATED MODULE: ./node_modules/rc-slider/es/Slider.js

      /* eslint-disable react/prop-types */


      var Slider_Slider = function (_React$Component) {
        inherits_default()(Slider, _React$Component);

        function Slider(props) {
          classCallCheck_default()(this, Slider);

          var _this = possibleConstructorReturn_default()(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

          _this.onEnd = function (force) {
            var dragging = _this.state.dragging;

            _this.removeDocumentEvents();

            if (dragging || force) {
              _this.props.onAfterChange(_this.getValue());
            }

            _this.setState({
              dragging: false
            });
          };

          var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
          var value = props.value !== undefined ? props.value : defaultValue;
          _this.state = {
            value: _this.trimAlignValue(value),
            dragging: false
          };

          if (utils_isDev()) {
            warning_warning_default()(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
            warning_warning_default()(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
          }

          return _this;
        }

        createClass_default()(Slider, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _props = this.props,
                autoFocus = _props.autoFocus,
                disabled = _props.disabled;

            if (autoFocus && !disabled) {
              this.focus();
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
            var prevValue = this.state.value;
            var value = nextProps.value !== undefined ? nextProps.value : prevValue;
            var nextValue = this.trimAlignValue(value, nextProps);
            if (nextValue === prevValue) return;
            this.setState({
              value: nextValue
            });

            if (utils_isValueOutOfRange(value, nextProps)) {
              this.props.onChange(nextValue);
            }
          }
        }, {
          key: 'onChange',
          value: function onChange(state) {
            var props = this.props;
            var isNotControlled = !('value' in props);
            var nextState = state.value > this.props.max ? extends_default()({}, state, {
              value: this.props.max
            }) : state;

            if (isNotControlled) {
              this.setState(nextState);
            }

            var changedValue = nextState.value;
            props.onChange(changedValue);
          }
        }, {
          key: 'onStart',
          value: function onStart(position) {
            this.setState({
              dragging: true
            });
            var props = this.props;
            var prevValue = this.getValue();
            props.onBeforeChange(prevValue);
            var value = this.calcValueByPos(position);
            this.startValue = value;
            this.startPosition = position;
            if (value === prevValue) return;
            this.prevMovedHandleIndex = 0;
            this.onChange({
              value: value
            });
          }
        }, {
          key: 'onMove',
          value: function onMove(e, position) {
            utils_pauseEvent(e);
            var oldValue = this.state.value;
            var value = this.calcValueByPos(position);
            if (value === oldValue) return;
            this.onChange({
              value: value
            });
          }
        }, {
          key: 'onKeyboard',
          value: function onKeyboard(e) {
            var valueMutator = utils_getKeyboardValueMutator(e);

            if (valueMutator) {
              utils_pauseEvent(e);
              var state = this.state;
              var oldValue = state.value;
              var mutatedValue = valueMutator(oldValue, this.props);
              var value = this.trimAlignValue(mutatedValue);
              if (value === oldValue) return;
              this.onChange({
                value: value
              });
              this.props.onAfterChange(value);
              this.onEnd();
            }
          }
        }, {
          key: 'getValue',
          value: function getValue() {
            return this.state.value;
          }
        }, {
          key: 'getLowerBound',
          value: function getLowerBound() {
            return this.props.min;
          }
        }, {
          key: 'getUpperBound',
          value: function getUpperBound() {
            return this.state.value;
          }
        }, {
          key: 'trimAlignValue',
          value: function trimAlignValue(v) {
            var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (v === null) {
              return null;
            }

            var mergedProps = extends_default()({}, this.props, nextProps);
            var val = utils_ensureValueInRange(v, mergedProps);
            return utils_ensureValuePrecision(val, mergedProps);
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                vertical = _props2.vertical,
                included = _props2.included,
                disabled = _props2.disabled,
                minimumTrackStyle = _props2.minimumTrackStyle,
                trackStyle = _props2.trackStyle,
                handleStyle = _props2.handleStyle,
                tabIndex = _props2.tabIndex,
                min = _props2.min,
                max = _props2.max,
                handleGenerator = _props2.handle;
            var _state = this.state,
                value = _state.value,
                dragging = _state.dragging;
            var offset = this.calcOffset(value);
            var handle = handleGenerator({
              className: prefixCls + '-handle',
              prefixCls: prefixCls,
              vertical: vertical,
              offset: offset,
              value: value,
              dragging: dragging,
              disabled: disabled,
              min: min,
              max: max,
              index: 0,
              tabIndex: tabIndex,
              style: handleStyle[0] || handleStyle,
              ref: function ref(h) {
                return _this2.saveHandle(0, h);
              }
            });

            var _trackStyle = trackStyle[0] || trackStyle;

            var track = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(common_Track, {
              className: prefixCls + '-track',
              vertical: vertical,
              included: included,
              offset: 0,
              length: offset,
              style: extends_default()({}, minimumTrackStyle, _trackStyle)
            });
            return {
              tracks: track,
              handles: handle
            };
          }
        }]);
        return Slider;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Slider_Slider.propTypes = {
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        autoFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        tabIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        min: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        max: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
      };
      /* harmony default export */

      var es_Slider = createSlider_createSlider(Slider_Slider); // CONCATENATED MODULE: ./node_modules/rc-slider/es/Range.js

      /* eslint-disable react/prop-types */

      var Range_Range = function (_React$Component) {
        inherits_default()(Range, _React$Component);

        function Range(props) {
          classCallCheck_default()(this, Range);

          var _this = possibleConstructorReturn_default()(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

          _this.onEnd = function (force) {
            var handle = _this.state.handle;

            _this.removeDocumentEvents();

            if (handle !== null || force) {
              _this.props.onAfterChange(_this.getValue());
            }

            _this.setState({
              handle: null
            });
          };

          var count = props.count,
              min = props.min,
              max = props.max;
          var initialValue = Array.apply(undefined, toConsumableArray_default()(Array(count + 1))).map(function () {
            return min;
          });
          var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
          var value = props.value !== undefined ? props.value : defaultValue;
          var bounds = value.map(function (v, i) {
            return _this.trimAlignValue(v, i);
          });
          var recent = bounds[0] === max ? 0 : bounds.length - 1;
          _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds
          };
          return _this;
        }

        createClass_default()(Range, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;

            if (this.props.min === nextProps.min && this.props.max === nextProps.max && shallowequal_default()(this.props.value, nextProps.value)) {
              return;
            }

            var bounds = this.state.bounds;
            var value = nextProps.value || bounds;
            var nextBounds = value.map(function (v, i) {
              return _this2.trimAlignValue(v, i, nextProps);
            });
            if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
              return v === bounds[i];
            })) return;
            this.setState({
              bounds: nextBounds
            });

            if (value.some(function (v) {
              return utils_isValueOutOfRange(v, nextProps);
            })) {
              var newValues = value.map(function (v) {
                return utils_ensureValueInRange(v, nextProps);
              });
              this.props.onChange(newValues);
            }
          }
        }, {
          key: 'onChange',
          value: function onChange(state) {
            var props = this.props;
            var isNotControlled = !('value' in props);

            if (isNotControlled) {
              this.setState(state);
            } else {
              var controlledState = {};
              ['handle', 'recent'].forEach(function (item) {
                if (state[item] !== undefined) {
                  controlledState[item] = state[item];
                }
              });

              if (Object.keys(controlledState).length) {
                this.setState(controlledState);
              }
            }

            var data = extends_default()({}, this.state, state);
            var changedValue = data.bounds;
            props.onChange(changedValue);
          }
        }, {
          key: 'onStart',
          value: function onStart(position) {
            var props = this.props;
            var state = this.state;
            var bounds = this.getValue();
            props.onBeforeChange(bounds);
            var value = this.calcValueByPos(position);
            this.startValue = value;
            this.startPosition = position;
            var closestBound = this.getClosestBound(value);
            this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
            this.setState({
              handle: this.prevMovedHandleIndex,
              recent: this.prevMovedHandleIndex
            });
            var prevValue = bounds[this.prevMovedHandleIndex];
            if (value === prevValue) return;
            var nextBounds = [].concat(toConsumableArray_default()(state.bounds));
            nextBounds[this.prevMovedHandleIndex] = value;
            this.onChange({
              bounds: nextBounds
            });
          }
        }, {
          key: 'onMove',
          value: function onMove(e, position) {
            utils_pauseEvent(e);
            var state = this.state;
            var value = this.calcValueByPos(position);
            var oldValue = state.bounds[state.handle];
            if (value === oldValue) return;
            this.moveTo(value);
          }
        }, {
          key: 'onKeyboard',
          value: function onKeyboard(e) {
            var valueMutator = utils_getKeyboardValueMutator(e);

            if (valueMutator) {
              utils_pauseEvent(e);
              var state = this.state,
                  props = this.props;
              var bounds = state.bounds,
                  handle = state.handle;
              var oldValue = bounds[handle === null ? state.recent : handle];
              var mutatedValue = valueMutator(oldValue, props);
              var value = this.trimAlignValue(mutatedValue);
              if (value === oldValue) return;
              var isFromKeyboardEvent = true;
              this.moveTo(value, isFromKeyboardEvent);
            }
          }
        }, {
          key: 'getValue',
          value: function getValue() {
            return this.state.bounds;
          }
        }, {
          key: 'getClosestBound',
          value: function getClosestBound(value) {
            var bounds = this.state.bounds;
            var closestBound = 0;

            for (var i = 1; i < bounds.length - 1; ++i) {
              if (value > bounds[i]) {
                closestBound = i;
              }
            }

            if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
              closestBound += 1;
            }

            return closestBound;
          }
        }, {
          key: 'getBoundNeedMoving',
          value: function getBoundNeedMoving(value, closestBound) {
            var _state = this.state,
                bounds = _state.bounds,
                recent = _state.recent;
            var boundNeedMoving = closestBound;
            var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

            if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
              boundNeedMoving = recent;
            }

            if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
              boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
            }

            return boundNeedMoving;
          }
        }, {
          key: 'getLowerBound',
          value: function getLowerBound() {
            return this.state.bounds[0];
          }
        }, {
          key: 'getUpperBound',
          value: function getUpperBound() {
            var bounds = this.state.bounds;
            return bounds[bounds.length - 1];
          }
          /**
           * Returns an array of possible slider points, taking into account both
           * `marks` and `step`. The result is cached.
           */

        }, {
          key: 'getPoints',
          value: function getPoints() {
            var _props = this.props,
                marks = _props.marks,
                step = _props.step,
                min = _props.min,
                max = _props.max;
            var cache = this._getPointsCache;

            if (!cache || cache.marks !== marks || cache.step !== step) {
              var pointsObject = extends_default()({}, marks);

              if (step !== null) {
                for (var point = min; point <= max; point += step) {
                  pointsObject[point] = point;
                }
              }

              var points = Object.keys(pointsObject).map(parseFloat);
              points.sort(function (a, b) {
                return a - b;
              });
              this._getPointsCache = {
                marks: marks,
                step: step,
                points: points
              };
            }

            return this._getPointsCache.points;
          }
        }, {
          key: 'moveTo',
          value: function moveTo(value, isFromKeyboardEvent) {
            var _this3 = this;

            var state = this.state,
                props = this.props;
            var nextBounds = [].concat(toConsumableArray_default()(state.bounds));
            var handle = state.handle === null ? state.recent : state.handle;
            nextBounds[handle] = value;
            var nextHandle = handle;

            if (props.pushable !== false) {
              this.pushSurroundingHandles(nextBounds, nextHandle);
            } else if (props.allowCross) {
              nextBounds.sort(function (a, b) {
                return a - b;
              });
              nextHandle = nextBounds.indexOf(value);
            }

            this.onChange({
              recent: nextHandle,
              handle: nextHandle,
              bounds: nextBounds
            });

            if (isFromKeyboardEvent) {
              // known problem: because setState is async,
              // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
              // cause onBeforeChange and onAfterChange receive wrong value.
              // here use setState callback to hack，but not elegant
              this.props.onAfterChange(nextBounds);
              this.setState({}, function () {
                _this3.handlesRefs[nextHandle].focus();
              });
              this.onEnd();
            }
          }
        }, {
          key: 'pushSurroundingHandles',
          value: function pushSurroundingHandles(bounds, handle) {
            var value = bounds[handle];
            var threshold = this.props.pushable;
            threshold = Number(threshold);
            var direction = 0;

            if (bounds[handle + 1] - value < threshold) {
              direction = +1; // push to right
            }

            if (value - bounds[handle - 1] < threshold) {
              direction = -1; // push to left
            }

            if (direction === 0) {
              return;
            }

            var nextHandle = handle + direction;
            var diffToNext = direction * (bounds[nextHandle] - value);

            if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
              // revert to original value if pushing is impossible
              bounds[handle] = bounds[nextHandle] - direction * threshold;
            }
          }
        }, {
          key: 'pushHandle',
          value: function pushHandle(bounds, handle, direction, amount) {
            var originalValue = bounds[handle];
            var currentValue = bounds[handle];

            while (direction * (currentValue - originalValue) < amount) {
              if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                // can't push handle enough to create the needed `amount` gap, so we
                // revert its position to the original value
                bounds[handle] = originalValue;
                return false;
              }

              currentValue = bounds[handle];
            } // the handle was pushed enough to create the needed `amount` gap


            return true;
          }
        }, {
          key: 'pushHandleOnePoint',
          value: function pushHandleOnePoint(bounds, handle, direction) {
            var points = this.getPoints();
            var pointIndex = points.indexOf(bounds[handle]);
            var nextPointIndex = pointIndex + direction;

            if (nextPointIndex >= points.length || nextPointIndex < 0) {
              // reached the minimum or maximum available point, can't push anymore
              return false;
            }

            var nextHandle = handle + direction;
            var nextValue = points[nextPointIndex];
            var threshold = this.props.pushable;
            var diffToNext = direction * (bounds[nextHandle] - nextValue);

            if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
              // couldn't push next handle, so we won't push this one either
              return false;
            } // push the handle


            bounds[handle] = nextValue;
            return true;
          }
        }, {
          key: 'trimAlignValue',
          value: function trimAlignValue(v, handle) {
            var nextProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var mergedProps = extends_default()({}, this.props, nextProps);
            var valInRange = utils_ensureValueInRange(v, mergedProps);
            var valNotConflict = this.ensureValueNotConflict(handle, valInRange, mergedProps);
            return utils_ensureValuePrecision(valNotConflict, mergedProps);
          }
        }, {
          key: 'ensureValueNotConflict',
          value: function ensureValueNotConflict(handle, val, _ref) {
            var allowCross = _ref.allowCross,
                thershold = _ref.pushable;
            var state = this.state || {};
            var bounds = state.bounds;
            handle = handle === undefined ? state.handle : handle;
            thershold = Number(thershold);
            /* eslint-disable eqeqeq */

            if (!allowCross && handle != null && bounds !== undefined) {
              if (handle > 0 && val <= bounds[handle - 1] + thershold) {
                return bounds[handle - 1] + thershold;
              }

              if (handle < bounds.length - 1 && val >= bounds[handle + 1] - thershold) {
                return bounds[handle + 1] - thershold;
              }
            }
            /* eslint-enable eqeqeq */


            return val;
          }
        }, {
          key: 'render',
          value: function render() {
            var _this4 = this;

            var _state2 = this.state,
                handle = _state2.handle,
                bounds = _state2.bounds;
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                vertical = _props2.vertical,
                included = _props2.included,
                disabled = _props2.disabled,
                min = _props2.min,
                max = _props2.max,
                handleGenerator = _props2.handle,
                trackStyle = _props2.trackStyle,
                handleStyle = _props2.handleStyle,
                tabIndex = _props2.tabIndex;
            var offsets = bounds.map(function (v) {
              return _this4.calcOffset(v);
            });
            var handleClassName = prefixCls + '-handle';
            var handles = bounds.map(function (v, i) {
              var _classNames;

              var _tabIndex = tabIndex[i] || 0;

              if (disabled || tabIndex[i] === null) {
                _tabIndex = null;
              }

              return handleGenerator({
                className: classnames_default()((_classNames = {}, defineProperty_default()(_classNames, handleClassName, true), defineProperty_default()(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
                prefixCls: prefixCls,
                vertical: vertical,
                offset: offsets[i],
                value: v,
                dragging: handle === i,
                index: i,
                tabIndex: _tabIndex,
                min: min,
                max: max,
                disabled: disabled,
                style: handleStyle[i],
                ref: function ref(h) {
                  return _this4.saveHandle(i, h);
                }
              });
            });
            var tracks = bounds.slice(0, -1).map(function (_, index) {
              var _classNames2;

              var i = index + 1;
              var trackClassName = classnames_default()((_classNames2 = {}, defineProperty_default()(_classNames2, prefixCls + '-track', true), defineProperty_default()(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(common_Track, {
                className: trackClassName,
                vertical: vertical,
                included: included,
                offset: offsets[i - 1],
                length: offsets[i] - offsets[i - 1],
                style: trackStyle[index],
                key: i
              });
            });
            return {
              tracks: tracks,
              handles: handles
            };
          }
        }]);
        return Range;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Range_Range.displayName = 'Range';
      Range_Range.propTypes = {
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number),
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number),
        count: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        pushable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        allowCross: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        tabIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number),
        min: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        max: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
      };
      Range_Range.defaultProps = {
        count: 1,
        allowCross: true,
        pushable: false,
        tabIndex: []
      };
      /* harmony default export */

      var es_Range = createSlider_createSlider(Range_Range); // CONCATENATED MODULE: ./node_modules/antd/es/slider/index.js

      var slider_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var slider_Slider = function (_React$Component) {
        inherits_default()(Slider, _React$Component);

        function Slider(props) {
          classCallCheck_default()(this, Slider);

          var _this = possibleConstructorReturn_default()(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

          _this.toggleTooltipVisible = function (index, visible) {
            _this.setState(function (_ref) {
              var visibles = _ref.visibles;
              return {
                visibles: extends_default()({}, visibles, defineProperty_default()({}, index, visible))
              };
            });
          };

          _this.handleWithTooltip = function (_a) {
            var value = _a.value,
                dragging = _a.dragging,
                index = _a.index,
                restProps = slider_rest(_a, ["value", "dragging", "index"]);
            var _this$props = _this.props,
                tooltipPrefixCls = _this$props.tooltipPrefixCls,
                tipFormatter = _this$props.tipFormatter;
            var visibles = _this.state.visibles;
            var visible = tipFormatter ? visibles[index] || dragging : false;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](tooltip, {
              prefixCls: tooltipPrefixCls,
              title: tipFormatter ? tipFormatter(value) : '',
              visible: visible,
              placement: 'top',
              transitionName: 'zoom-down',
              key: index
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_Handle, extends_default()({}, restProps, {
              value: value,
              onMouseEnter: function onMouseEnter() {
                return _this.toggleTooltipVisible(index, true);
              },
              onMouseLeave: function onMouseLeave() {
                return _this.toggleTooltipVisible(index, false);
              }
            })));
          };

          _this.saveSlider = function (node) {
            _this.rcSlider = node;
          };

          _this.state = {
            visibles: {}
          };
          return _this;
        }

        createClass_default()(Slider, [{
          key: 'focus',
          value: function focus() {
            this.rcSlider.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.rcSlider.focus();
          }
        }, {
          key: 'render',
          value: function render() {
            var _a = this.props,
                range = _a.range,
                restProps = slider_rest(_a, ["range"]);

            if (range) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_Range, extends_default()({}, restProps, {
                ref: this.saveSlider,
                handle: this.handleWithTooltip
              }));
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_Slider, extends_default()({}, restProps, {
              ref: this.saveSlider,
              handle: this.handleWithTooltip
            }));
          }
        }]);
        return Slider;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var slider = slider_Slider;
      slider_Slider.defaultProps = {
        prefixCls: 'ant-slider',
        tooltipPrefixCls: 'ant-tooltip',
        tipFormatter: function tipFormatter(value) {
          return value.toString();
        }
      }; // CONCATENATED MODULE: ./node_modules/rc-steps/es/utils.js

      function utils_isFlexSupported() {
        if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
          var documentElement = window.document.documentElement;
          return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
        }

        return false;
      } // CONCATENATED MODULE: ./node_modules/rc-steps/es/Steps.js

      /* eslint react/no-did-mount-set-state: 0 */


      var es_Steps_Steps = function (_Component) {
        inherits_default()(Steps, _Component);

        function Steps(props) {
          classCallCheck_default()(this, Steps);

          var _this = possibleConstructorReturn_default()(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).call(this, props));

          _this.calcStepOffsetWidth = function () {
            if (utils_isFlexSupported()) {
              return;
            } // Just for IE9


            var domNode = Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"])(_this);

            if (domNode.children.length > 0) {
              if (_this.calcTimeout) {
                clearTimeout(_this.calcTimeout);
              }

              _this.calcTimeout = setTimeout(function () {
                // +1 for fit edge bug of digit width, like 35.4px
                var lastStepOffsetWidth = (domNode.lastChild.offsetWidth || 0) + 1; // Reduce shake bug

                if (_this.state.lastStepOffsetWidth === lastStepOffsetWidth || Math.abs(_this.state.lastStepOffsetWidth - lastStepOffsetWidth) <= 3) {
                  return;
                }

                _this.setState({
                  lastStepOffsetWidth: lastStepOffsetWidth
                });
              });
            }
          };

          _this.state = {
            flexSupported: true,
            lastStepOffsetWidth: 0
          };
          _this.calcStepOffsetWidth = debounce_default()(_this.calcStepOffsetWidth, 150);
          return _this;
        }

        createClass_default()(Steps, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.calcStepOffsetWidth();

            if (!utils_isFlexSupported()) {
              this.setState({
                flexSupported: false
              });
            }
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            this.calcStepOffsetWidth();
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.calcTimeout) {
              clearTimeout(this.calcTimeout);
            }

            if (this.calcStepOffsetWidth && this.calcStepOffsetWidth.cancel) {
              this.calcStepOffsetWidth.cancel();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                _props$style = _props.style,
                style = _props$style === undefined ? {} : _props$style,
                className = _props.className,
                children = _props.children,
                direction = _props.direction,
                labelPlacement = _props.labelPlacement,
                iconPrefix = _props.iconPrefix,
                status = _props.status,
                size = _props.size,
                current = _props.current,
                progressDot = _props.progressDot,
                restProps = objectWithoutProperties_default()(_props, ['prefixCls', 'style', 'className', 'children', 'direction', 'labelPlacement', 'iconPrefix', 'status', 'size', 'current', 'progressDot']);
            var _state = this.state,
                lastStepOffsetWidth = _state.lastStepOffsetWidth,
                flexSupported = _state.flexSupported;
            var filteredChildren = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.toArray(children).filter(function (c) {
              return !!c;
            });
            var lastIndex = filteredChildren.length - 1;
            var adjustedlabelPlacement = !!progressDot ? 'vertical' : labelPlacement;
            var classString = classnames_default()(prefixCls, prefixCls + '-' + direction, className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-' + size, size), defineProperty_default()(_classNames, prefixCls + '-label-' + adjustedlabelPlacement, direction === 'horizontal'), defineProperty_default()(_classNames, prefixCls + '-dot', !!progressDot), _classNames));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', extends_default()({
              className: classString,
              style: style
            }, restProps), external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].map(filteredChildren, function (child, index) {
              if (!child) {
                return null;
              }

              var childProps = extends_default()({
                stepNumber: '' + (index + 1),
                prefixCls: prefixCls,
                iconPrefix: iconPrefix,
                wrapperStyle: style,
                progressDot: progressDot
              }, child.props);

              if (!flexSupported && direction !== 'vertical' && index !== lastIndex) {
                childProps.itemWidth = 100 / lastIndex + '%';
                childProps.adjustMarginRight = -Math.round(lastStepOffsetWidth / lastIndex + 1);
              } // fix tail color


              if (status === 'error' && index === current - 1) {
                childProps.className = prefixCls + '-next-error';
              }

              if (!child.props.status) {
                if (index === current) {
                  childProps.status = status;
                } else if (index < current) {
                  childProps.status = 'finish';
                } else {
                  childProps.status = 'wait';
                }
              }

              return Object(external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"])(child, childProps);
            }));
          }
        }]);
        return Steps;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      es_Steps_Steps.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        iconPrefix: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        direction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        labelPlacement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        status: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        size: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        progressDot: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        current: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
      };
      es_Steps_Steps.defaultProps = {
        prefixCls: 'rc-steps',
        iconPrefix: 'rc',
        direction: 'horizontal',
        labelPlacement: 'horizontal',
        current: 0,
        status: 'process',
        size: '',
        progressDot: false
      };
      /* harmony default export */

      var es_Steps = es_Steps_Steps; // CONCATENATED MODULE: ./node_modules/rc-steps/es/Step.js

      function Step_isString(str) {
        return typeof str === 'string';
      }

      var Step_Step = function (_React$Component) {
        inherits_default()(Step, _React$Component);

        function Step() {
          classCallCheck_default()(this, Step);
          return possibleConstructorReturn_default()(this, (Step.__proto__ || Object.getPrototypeOf(Step)).apply(this, arguments));
        }

        createClass_default()(Step, [{
          key: 'renderIconNode',
          value: function renderIconNode() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                progressDot = _props.progressDot,
                stepNumber = _props.stepNumber,
                status = _props.status,
                title = _props.title,
                description = _props.description,
                icon = _props.icon,
                iconPrefix = _props.iconPrefix;
            var iconNode = void 0;
            var iconClassName = classnames_default()(prefixCls + '-icon', iconPrefix + 'icon', (_classNames = {}, defineProperty_default()(_classNames, iconPrefix + 'icon-' + icon, icon && Step_isString(icon)), defineProperty_default()(_classNames, iconPrefix + 'icon-check', !icon && status === 'finish'), defineProperty_default()(_classNames, iconPrefix + 'icon-cross', !icon && status === 'error'), _classNames));
            var iconDot = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-icon-dot'
            }); // `progressDot` enjoy the highest priority

            if (progressDot) {
              if (typeof progressDot === 'function') {
                iconNode = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                  className: prefixCls + '-icon'
                }, progressDot(iconDot, {
                  index: stepNumber - 1,
                  status: status,
                  title: title,
                  description: description
                }));
              } else {
                iconNode = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                  className: prefixCls + '-icon'
                }, iconDot);
              }
            } else if (icon && !Step_isString(icon)) {
              iconNode = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                className: prefixCls + '-icon'
              }, icon);
            } else if (icon || status === 'finish' || status === 'error') {
              iconNode = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                className: iconClassName
              });
            } else {
              iconNode = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                className: prefixCls + '-icon'
              }, stepNumber);
            }

            return iconNode;
          }
        }, {
          key: 'render',
          value: function render() {
            var _props2 = this.props,
                className = _props2.className,
                prefixCls = _props2.prefixCls,
                style = _props2.style,
                itemWidth = _props2.itemWidth,
                _props2$status = _props2.status,
                status = _props2$status === undefined ? 'wait' : _props2$status,
                iconPrefix = _props2.iconPrefix,
                icon = _props2.icon,
                wrapperStyle = _props2.wrapperStyle,
                adjustMarginRight = _props2.adjustMarginRight,
                stepNumber = _props2.stepNumber,
                description = _props2.description,
                title = _props2.title,
                progressDot = _props2.progressDot,
                tailContent = _props2.tailContent,
                restProps = objectWithoutProperties_default()(_props2, ['className', 'prefixCls', 'style', 'itemWidth', 'status', 'iconPrefix', 'icon', 'wrapperStyle', 'adjustMarginRight', 'stepNumber', 'description', 'title', 'progressDot', 'tailContent']);
            var classString = classnames_default()(prefixCls + '-item', prefixCls + '-item-' + status, className, defineProperty_default()({}, prefixCls + '-item-custom', icon));
            var stepItemStyle = extends_default()({}, style);

            if (itemWidth) {
              stepItemStyle.width = itemWidth;
            }

            if (adjustMarginRight) {
              stepItemStyle.marginRight = adjustMarginRight;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', extends_default()({}, restProps, {
              className: classString,
              style: stepItemStyle
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-item-tail'
            }, tailContent), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-item-icon'
            }, this.renderIconNode()), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-item-content'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-item-title'
            }, title), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-item-description'
            }, description)));
          }
        }]);
        return Step;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Step_Step.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        wrapperStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        itemWidth: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        status: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        iconPrefix: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        icon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        adjustMarginRight: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        stepNumber: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        title: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        progressDot: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        tailContent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      /* harmony default export */

      var es_Step = Step_Step; // CONCATENATED MODULE: ./node_modules/rc-steps/es/index.js

      es_Steps.Step = es_Step;
      /* harmony default export */

      var rc_steps_es = es_Steps; // CONCATENATED MODULE: ./node_modules/antd/es/steps/index.js

      var steps_Steps = function (_React$Component) {
        inherits_default()(Steps, _React$Component);

        function Steps() {
          classCallCheck_default()(this, Steps);
          return possibleConstructorReturn_default()(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).apply(this, arguments));
        }

        createClass_default()(Steps, [{
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_steps_es, this.props);
          }
        }]);
        return Steps;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_steps = steps_Steps;
      steps_Steps.Step = rc_steps_es.Step;
      steps_Steps.defaultProps = {
        prefixCls: 'ant-steps',
        iconPrefix: 'ant',
        current: 0
      };
      steps_Steps.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        iconPrefix: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        current: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
      }; // EXTERNAL MODULE: ./node_modules/rc-switch/es/index.js

      var rc_switch_es = __webpack_require__(704);

      var es_default =
      /*#__PURE__*/
      __webpack_require__.n(rc_switch_es); // CONCATENATED MODULE: ./node_modules/antd/es/switch/index.js


      var switch_Switch = function (_React$Component) {
        inherits_default()(Switch, _React$Component);

        function Switch() {
          classCallCheck_default()(this, Switch);

          var _this = possibleConstructorReturn_default()(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));

          _this.saveSwitch = function (node) {
            _this.rcSwitch = node;
          };

          return _this;
        }

        createClass_default()(Switch, [{
          key: 'focus',
          value: function focus() {
            this.rcSwitch.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.rcSwitch.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                size = _props.size,
                loading = _props.loading,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className;
            var classes = classnames_default()(className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-small', size === 'small'), defineProperty_default()(_classNames, prefixCls + '-loading', loading), _classNames));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_default.a, extends_default()({}, Object(es["default"])(this.props, ['loading']), {
              className: classes,
              ref: this.saveSwitch
            }));
          }
        }]);
        return Switch;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_switch = switch_Switch;
      switch_Switch.defaultProps = {
        prefixCls: 'ant-switch'
      };
      switch_Switch.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // HACK: https://github.com/ant-design/ant-design/issues/5368
        // size=default and size=large are the same
        size: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['small', 'default', 'large']),
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      }; // EXTERNAL MODULE: ./node_modules/mini-store/lib/index.js

      var mini_store_lib = __webpack_require__(70); // EXTERNAL MODULE: ./node_modules/lodash/merge.js


      var merge = __webpack_require__(81);

      var merge_default =
      /*#__PURE__*/
      __webpack_require__.n(merge); // EXTERNAL MODULE: ./node_modules/component-classes/index.js


      var component_classes = __webpack_require__(149);

      var component_classes_default =
      /*#__PURE__*/
      __webpack_require__.n(component_classes); // CONCATENATED MODULE: ./node_modules/rc-table/es/utils.js


      var utils_scrollbarSize = void 0; // Measure scrollbar width for padding body during modal show/hide

      var utils_scrollbarMeasure = {
        position: 'absolute',
        top: '-9999px',
        width: '50px',
        height: '50px',
        overflow: 'scroll'
      };

      function utils_measureScrollbar() {
        var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'vertical';

        if (typeof document === 'undefined' || typeof window === 'undefined') {
          return 0;
        }

        if (utils_scrollbarSize) {
          return utils_scrollbarSize;
        }

        var scrollDiv = document.createElement('div');
        Object.keys(utils_scrollbarMeasure).forEach(function (scrollProp) {
          scrollDiv.style[scrollProp] = utils_scrollbarMeasure[scrollProp];
        });
        document.body.appendChild(scrollDiv);
        var size = 0;

        if (direction === 'vertical') {
          size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        } else if (direction === 'horizontal') {
          size = scrollDiv.offsetHeight - scrollDiv.clientHeight;
        }

        document.body.removeChild(scrollDiv);
        utils_scrollbarSize = size;
        return utils_scrollbarSize;
      }

      function utils_debounce(func, wait, immediate) {
        var timeout = void 0;

        function debounceFunc() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var context = this; // https://fb.me/react-event-pooling

          if (args[0] && args[0].persist) {
            args[0].persist();
          }

          var later = function later() {
            timeout = null;

            if (!immediate) {
              func.apply(context, args);
            }
          };

          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);

          if (callNow) {
            func.apply(context, args);
          }
        }

        debounceFunc.cancel = function cancel() {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
        };

        return debounceFunc;
      }

      var utils_warned = {};

      function utils_warningOnce(condition, format, args) {
        if (!utils_warned[format]) {
          browser_default()(condition, format, args);
          utils_warned[format] = !condition;
        }
      }

      function utils_remove(array, item) {
        var index = array.indexOf(item);
        var front = array.slice(0, index);
        var last = array.slice(index + 1, array.length);
        return front.concat(last);
      } // CONCATENATED MODULE: ./node_modules/rc-table/es/ColumnManager.js


      var ColumnManager_ColumnManager = function () {
        function ColumnManager(columns, elements) {
          classCallCheck_default()(this, ColumnManager);
          this._cached = {};
          this.columns = columns || this.normalize(elements);
        }

        ColumnManager.prototype.isAnyColumnsFixed = function isAnyColumnsFixed() {
          var _this = this;

          return this._cache('isAnyColumnsFixed', function () {
            return _this.columns.some(function (column) {
              return !!column.fixed;
            });
          });
        };

        ColumnManager.prototype.isAnyColumnsLeftFixed = function isAnyColumnsLeftFixed() {
          var _this2 = this;

          return this._cache('isAnyColumnsLeftFixed', function () {
            return _this2.columns.some(function (column) {
              return column.fixed === 'left' || column.fixed === true;
            });
          });
        };

        ColumnManager.prototype.isAnyColumnsRightFixed = function isAnyColumnsRightFixed() {
          var _this3 = this;

          return this._cache('isAnyColumnsRightFixed', function () {
            return _this3.columns.some(function (column) {
              return column.fixed === 'right';
            });
          });
        };

        ColumnManager.prototype.leftColumns = function leftColumns() {
          var _this4 = this;

          return this._cache('leftColumns', function () {
            return _this4.groupedColumns().filter(function (column) {
              return column.fixed === 'left' || column.fixed === true;
            });
          });
        };

        ColumnManager.prototype.rightColumns = function rightColumns() {
          var _this5 = this;

          return this._cache('rightColumns', function () {
            return _this5.groupedColumns().filter(function (column) {
              return column.fixed === 'right';
            });
          });
        };

        ColumnManager.prototype.leafColumns = function leafColumns() {
          var _this6 = this;

          return this._cache('leafColumns', function () {
            return _this6._leafColumns(_this6.columns);
          });
        };

        ColumnManager.prototype.leftLeafColumns = function leftLeafColumns() {
          var _this7 = this;

          return this._cache('leftLeafColumns', function () {
            return _this7._leafColumns(_this7.leftColumns());
          });
        };

        ColumnManager.prototype.rightLeafColumns = function rightLeafColumns() {
          var _this8 = this;

          return this._cache('rightLeafColumns', function () {
            return _this8._leafColumns(_this8.rightColumns());
          });
        }; // add appropriate rowspan and colspan to column


        ColumnManager.prototype.groupedColumns = function groupedColumns() {
          var _this9 = this;

          return this._cache('groupedColumns', function () {
            var _groupColumns = function _groupColumns(columns) {
              var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var parentColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : []; // track how many rows we got

              rows[currentRow] = rows[currentRow] || [];
              var grouped = [];

              var setRowSpan = function setRowSpan(column) {
                var rowSpan = rows.length - currentRow;

                if (column && !column.children && // parent columns are supposed to be one row
                rowSpan > 1 && (!column.rowSpan || column.rowSpan < rowSpan)) {
                  column.rowSpan = rowSpan;
                }
              };

              columns.forEach(function (column, index) {
                var newColumn = extends_default()({}, column);
                rows[currentRow].push(newColumn);
                parentColumn.colSpan = parentColumn.colSpan || 0;

                if (newColumn.children && newColumn.children.length > 0) {
                  newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
                  parentColumn.colSpan += newColumn.colSpan;
                } else {
                  parentColumn.colSpan++;
                } // update rowspan to all same row columns


                for (var i = 0; i < rows[currentRow].length - 1; ++i) {
                  setRowSpan(rows[currentRow][i]);
                } // last column, update rowspan immediately


                if (index + 1 === columns.length) {
                  setRowSpan(newColumn);
                }

                grouped.push(newColumn);
              });
              return grouped;
            };

            return _groupColumns(_this9.columns);
          });
        };

        ColumnManager.prototype.normalize = function normalize(elements) {
          var _this10 = this;

          var columns = [];
          external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(elements, function (element) {
            if (!external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.isValidElement(element)) {
              return;
            }

            var column = extends_default()({}, element.props);

            if (element.key) {
              column.key = element.key;
            }

            if (element.type.isTableColumnGroup) {
              column.children = _this10.normalize(column.children);
            }

            columns.push(column);
          });
          return columns;
        };

        ColumnManager.prototype.reset = function reset(columns, elements) {
          this.columns = columns || this.normalize(elements);
          this._cached = {};
        };

        ColumnManager.prototype._cache = function _cache(name, fn) {
          if (name in this._cached) {
            return this._cached[name];
          }

          this._cached[name] = fn();
          return this._cached[name];
        };

        ColumnManager.prototype._leafColumns = function _leafColumns(columns) {
          var _this11 = this;

          var leafColumns = [];
          columns.forEach(function (column) {
            if (!column.children) {
              leafColumns.push(column);
            } else {
              leafColumns.push.apply(leafColumns, _this11._leafColumns(column.children));
            }
          });
          return leafColumns;
        };

        return ColumnManager;
      }();
      /* harmony default export */


      var es_ColumnManager = ColumnManager_ColumnManager; // CONCATENATED MODULE: ./node_modules/rc-table/es/ColGroup.js

      function ColGroup_ColGroup(props, _ref) {
        var table = _ref.table;
        var _table$props = table.props,
            prefixCls = _table$props.prefixCls,
            expandIconAsCell = _table$props.expandIconAsCell;
        var fixed = props.fixed;
        var cols = [];

        if (expandIconAsCell && fixed !== 'right') {
          cols.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('col', {
            className: prefixCls + '-expand-icon-col',
            key: 'rc-table-expand-icon-col'
          }));
        }

        var leafColumns = void 0;

        if (fixed === 'left') {
          leafColumns = table.columnManager.leftLeafColumns();
        } else if (fixed === 'right') {
          leafColumns = table.columnManager.rightLeafColumns();
        } else {
          leafColumns = table.columnManager.leafColumns();
        }

        cols = cols.concat(leafColumns.map(function (c) {
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('col', {
            key: c.key || c.dataIndex,
            style: {
              width: c.width,
              minWidth: c.width
            }
          });
        }));
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('colgroup', null, cols);
      }

      ColGroup_ColGroup.propTypes = {
        fixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      ColGroup_ColGroup.contextTypes = {
        table: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/rc-table/es/TableHeaderRow.js

      function TableHeaderRow_TableHeaderRow(_ref) {
        var row = _ref.row,
            index = _ref.index,
            height = _ref.height,
            components = _ref.components,
            onHeaderRow = _ref.onHeaderRow;
        var HeaderRow = components.header.row;
        var HeaderCell = components.header.cell;
        var rowProps = onHeaderRow(row.map(function (cell) {
          return cell.column;
        }), index);
        var customStyle = rowProps ? rowProps.style : {};
        var style = extends_default()({
          height: height
        }, customStyle);
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(HeaderRow, extends_default()({}, rowProps, {
          style: style
        }), row.map(function (cell, i) {
          var column = cell.column,
              cellProps = objectWithoutProperties_default()(cell, ['column']);
          var customProps = column.onHeaderCell ? column.onHeaderCell(column) : {};

          if (column.align) {
            customProps.style = extends_default()({}, customProps.style, {
              textAlign: column.align
            });
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(HeaderCell, extends_default()({}, cellProps, customProps, {
            key: column.key || column.dataIndex || i
          }));
        }));
      }

      TableHeaderRow_TableHeaderRow.propTypes = {
        row: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        index: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        height: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        components: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        onHeaderRow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };

      function TableHeaderRow_getRowHeight(state, props) {
        var fixedColumnsHeadRowsHeight = state.fixedColumnsHeadRowsHeight;
        var columns = props.columns,
            rows = props.rows,
            fixed = props.fixed;
        var headerHeight = fixedColumnsHeadRowsHeight[0];

        if (!fixed) {
          return null;
        }

        if (headerHeight && columns) {
          if (headerHeight === 'auto') {
            return 'auto';
          }

          return headerHeight / rows.length;
        }

        return null;
      }
      /* harmony default export */


      var es_TableHeaderRow = Object(mini_store_lib["connect"])(function (state, props) {
        return {
          height: TableHeaderRow_getRowHeight(state, props)
        };
      })(TableHeaderRow_TableHeaderRow); // CONCATENATED MODULE: ./node_modules/rc-table/es/TableHeader.js

      function TableHeader_getHeaderRows(columns) {
        var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var rows = arguments[2];
        rows = rows || [];
        rows[currentRow] = rows[currentRow] || [];
        columns.forEach(function (column) {
          if (column.rowSpan && rows.length < column.rowSpan) {
            while (rows.length < column.rowSpan) {
              rows.push([]);
            }
          }

          var cell = {
            key: column.key,
            className: column.className || '',
            children: column.title,
            column: column
          };

          if (column.children) {
            TableHeader_getHeaderRows(column.children, currentRow + 1, rows);
          }

          if ('colSpan' in column) {
            cell.colSpan = column.colSpan;
          }

          if ('rowSpan' in column) {
            cell.rowSpan = column.rowSpan;
          }

          if (cell.colSpan !== 0) {
            rows[currentRow].push(cell);
          }
        });
        return rows.filter(function (row) {
          return row.length > 0;
        });
      }

      function TableHeader_TableHeader(props, _ref) {
        var table = _ref.table;
        var components = table.components;
        var _table$props = table.props,
            prefixCls = _table$props.prefixCls,
            showHeader = _table$props.showHeader,
            onHeaderRow = _table$props.onHeaderRow;
        var expander = props.expander,
            columns = props.columns,
            fixed = props.fixed;

        if (!showHeader) {
          return null;
        }

        var rows = TableHeader_getHeaderRows(columns);
        expander.renderExpandIndentCell(rows, fixed);
        var HeaderWrapper = components.header.wrapper;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(HeaderWrapper, {
          className: prefixCls + '-thead'
        }, rows.map(function (row, index) {
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_TableHeaderRow, {
            key: index,
            index: index,
            fixed: fixed,
            columns: columns,
            rows: rows,
            row: row,
            components: components,
            onHeaderRow: onHeaderRow
          });
        }));
      }

      TableHeader_TableHeader.propTypes = {
        fixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        columns: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        expander: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        onHeaderRow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      TableHeader_TableHeader.contextTypes = {
        table: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/rc-table/es/TableCell.js

      function TableCell_isInvalidRenderCellText(text) {
        return text && !external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
      }

      var TableCell_TableCell = function (_React$Component) {
        inherits_default()(TableCell, _React$Component);

        function TableCell() {
          var _temp, _this, _ret;

          classCallCheck_default()(this, TableCell);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (e) {
            var _this$props = _this.props,
                record = _this$props.record,
                onCellClick = _this$props.column.onCellClick;

            if (onCellClick) {
              onCellClick(record, e);
            }
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        TableCell.prototype.render = function render() {
          var _props = this.props,
              record = _props.record,
              indentSize = _props.indentSize,
              prefixCls = _props.prefixCls,
              indent = _props.indent,
              index = _props.index,
              expandIcon = _props.expandIcon,
              column = _props.column,
              BodyCell = _props.component;
          var dataIndex = column.dataIndex,
              render = column.render,
              _column$className = column.className,
              className = _column$className === undefined ? '' : _column$className; // We should return undefined if no dataIndex is specified, but in order to
          // be compatible with object-path's behavior, we return the record object instead.

          var text = void 0;

          if (typeof dataIndex === 'number') {
            text = get_default()(record, dataIndex);
          } else if (!dataIndex || dataIndex.length === 0) {
            text = record;
          } else {
            text = get_default()(record, dataIndex);
          }

          var tdProps = {};
          var colSpan = void 0;
          var rowSpan = void 0;

          if (render) {
            text = render(text, record, index);

            if (TableCell_isInvalidRenderCellText(text)) {
              tdProps = text.props || tdProps;
              colSpan = tdProps.colSpan;
              rowSpan = tdProps.rowSpan;
              text = text.children;
            }
          }

          if (column.onCell) {
            tdProps = extends_default()({}, tdProps, column.onCell(record));
          } // Fix https://github.com/ant-design/ant-design/issues/1202


          if (TableCell_isInvalidRenderCellText(text)) {
            text = null;
          }

          var indentText = expandIcon ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            style: {
              paddingLeft: indentSize * indent + 'px'
            },
            className: prefixCls + '-indent indent-level-' + indent
          }) : null;

          if (rowSpan === 0 || colSpan === 0) {
            return null;
          }

          if (column.align) {
            tdProps.style = extends_default()({}, tdProps.style, {
              textAlign: column.align
            });
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(BodyCell, extends_default()({
            className: className,
            onClick: this.handleClick
          }, tdProps), indentText, expandIcon, text);
        };

        return TableCell;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      TableCell_TableCell.propTypes = {
        record: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        index: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        indent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        indentSize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        column: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        expandIcon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        component: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      /* harmony default export */

      var es_TableCell = TableCell_TableCell; // CONCATENATED MODULE: ./node_modules/rc-table/es/TableRow.js

      var TableRow_TableRow = function (_React$Component) {
        inherits_default()(TableRow, _React$Component);

        TableRow.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
          if (prevState.visible || !prevState.visible && nextProps.visible) {
            return {
              shouldRender: true,
              visible: nextProps.visible
            };
          }

          return {
            visible: nextProps.visible
          };
        };

        function TableRow(props) {
          classCallCheck_default()(this, TableRow);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          _this.onRowClick = function (event) {
            var _this$props = _this.props,
                record = _this$props.record,
                index = _this$props.index,
                onRowClick = _this$props.onRowClick;

            if (onRowClick) {
              onRowClick(record, index, event);
            }
          };

          _this.onRowDoubleClick = function (event) {
            var _this$props2 = _this.props,
                record = _this$props2.record,
                index = _this$props2.index,
                onRowDoubleClick = _this$props2.onRowDoubleClick;

            if (onRowDoubleClick) {
              onRowDoubleClick(record, index, event);
            }
          };

          _this.onContextMenu = function (event) {
            var _this$props3 = _this.props,
                record = _this$props3.record,
                index = _this$props3.index,
                onRowContextMenu = _this$props3.onRowContextMenu;

            if (onRowContextMenu) {
              onRowContextMenu(record, index, event);
            }
          };

          _this.onMouseEnter = function (event) {
            var _this$props4 = _this.props,
                record = _this$props4.record,
                index = _this$props4.index,
                onRowMouseEnter = _this$props4.onRowMouseEnter,
                onHover = _this$props4.onHover,
                rowKey = _this$props4.rowKey;
            onHover(true, rowKey);

            if (onRowMouseEnter) {
              onRowMouseEnter(record, index, event);
            }
          };

          _this.onMouseLeave = function (event) {
            var _this$props5 = _this.props,
                record = _this$props5.record,
                index = _this$props5.index,
                onRowMouseLeave = _this$props5.onRowMouseLeave,
                onHover = _this$props5.onHover,
                rowKey = _this$props5.rowKey;
            onHover(false, rowKey);

            if (onRowMouseLeave) {
              onRowMouseLeave(record, index, event);
            }
          };

          _this.shouldRender = props.visible;
          _this.state = {};
          return _this;
        }

        TableRow.prototype.componentDidMount = function componentDidMount() {
          if (this.state.shouldRender) {
            this.saveRowRef();
          }
        };

        TableRow.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          return !!(this.props.visible || nextProps.visible);
        };

        TableRow.prototype.componentDidUpdate = function componentDidUpdate() {
          if (this.state.shouldRender && !this.rowRef) {
            this.saveRowRef();
          }
        };

        TableRow.prototype.setExpanedRowHeight = function setExpanedRowHeight() {
          var _extends2;

          var _props = this.props,
              store = _props.store,
              rowKey = _props.rowKey;

          var _store$getState = store.getState(),
              expandedRowsHeight = _store$getState.expandedRowsHeight;

          var height = this.rowRef.getBoundingClientRect().height;
          expandedRowsHeight = extends_default()({}, expandedRowsHeight, (_extends2 = {}, _extends2[rowKey] = height, _extends2));
          store.setState({
            expandedRowsHeight: expandedRowsHeight
          });
        };

        TableRow.prototype.setRowHeight = function setRowHeight() {
          var _props2 = this.props,
              store = _props2.store,
              index = _props2.index;
          var fixedColumnsBodyRowsHeight = store.getState().fixedColumnsBodyRowsHeight.slice();
          var height = this.rowRef.getBoundingClientRect().height;
          fixedColumnsBodyRowsHeight[index] = height;
          store.setState({
            fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight
          });
        };

        TableRow.prototype.getStyle = function getStyle() {
          var _props3 = this.props,
              height = _props3.height,
              visible = _props3.visible;

          if (height && height !== this.style.height) {
            this.style = extends_default()({}, this.style, {
              height: height
            });
          }

          if (!visible && !this.style.display) {
            this.style = extends_default()({}, this.style, {
              display: 'none'
            });
          }

          return this.style;
        };

        TableRow.prototype.saveRowRef = function saveRowRef() {
          this.rowRef = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this);
          var _props4 = this.props,
              isAnyColumnsFixed = _props4.isAnyColumnsFixed,
              fixed = _props4.fixed,
              expandedRow = _props4.expandedRow,
              ancestorKeys = _props4.ancestorKeys;

          if (!isAnyColumnsFixed) {
            return;
          }

          if (!fixed && expandedRow) {
            this.setExpanedRowHeight();
          }

          if (!fixed && ancestorKeys.length >= 0) {
            this.setRowHeight();
          }
        };

        TableRow.prototype.render = function render() {
          if (!this.state.shouldRender) {
            return null;
          }

          var _props5 = this.props,
              prefixCls = _props5.prefixCls,
              columns = _props5.columns,
              record = _props5.record,
              index = _props5.index,
              onRow = _props5.onRow,
              indent = _props5.indent,
              indentSize = _props5.indentSize,
              hovered = _props5.hovered,
              height = _props5.height,
              visible = _props5.visible,
              components = _props5.components,
              hasExpandIcon = _props5.hasExpandIcon,
              renderExpandIcon = _props5.renderExpandIcon,
              renderExpandIconCell = _props5.renderExpandIconCell;
          var BodyRow = components.body.row;
          var BodyCell = components.body.cell;
          var className = this.props.className;

          if (hovered) {
            className += ' ' + prefixCls + '-hover';
          }

          var cells = [];
          renderExpandIconCell(cells);

          for (var i = 0; i < columns.length; i++) {
            var column = columns[i];
            utils_warningOnce(column.onCellClick === undefined, 'column[onCellClick] is deprecated, please use column[onCell] instead.');
            cells.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_TableCell, {
              prefixCls: prefixCls,
              record: record,
              indentSize: indentSize,
              indent: indent,
              index: index,
              column: column,
              key: column.key || column.dataIndex,
              expandIcon: hasExpandIcon(i) && renderExpandIcon(),
              component: BodyCell
            }));
          }

          var rowClassName = (prefixCls + ' ' + className + ' ' + prefixCls + '-level-' + indent).trim();
          var rowProps = onRow(record, index);
          var customStyle = rowProps ? rowProps.style : {};
          var style = {
            height: height
          };

          if (!visible) {
            style.display = 'none';
          }

          style = extends_default()({}, style, customStyle);
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(BodyRow, extends_default()({
            onClick: this.onRowClick,
            onDoubleClick: this.onRowDoubleClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            onContextMenu: this.onContextMenu,
            className: rowClassName
          }, rowProps, {
            style: style
          }), cells);
        };

        return TableRow;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      TableRow_TableRow.propTypes = {
        onRow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRowClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRowDoubleClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRowContextMenu: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRowMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRowMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        record: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onHover: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        columns: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        height: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        index: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        rowKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]).isRequired,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        indent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        indentSize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        hasExpandIcon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        hovered: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool.isRequired,
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool.isRequired,
        store: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        fixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool]),
        renderExpandIcon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        renderExpandIconCell: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        components: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        expandedRow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        isAnyColumnsFixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        ancestorKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired
      };
      TableRow_TableRow.defaultProps = {
        onRow: function onRow() {},
        onHover: function onHover() {},
        hasExpandIcon: function hasExpandIcon() {},
        renderExpandIcon: function renderExpandIcon() {},
        renderExpandIconCell: function renderExpandIconCell() {}
      };

      function TableRow_getRowHeight(state, props) {
        var expandedRowsHeight = state.expandedRowsHeight,
            fixedColumnsBodyRowsHeight = state.fixedColumnsBodyRowsHeight;
        var fixed = props.fixed,
            index = props.index,
            rowKey = props.rowKey;

        if (!fixed) {
          return null;
        }

        if (expandedRowsHeight[rowKey]) {
          return expandedRowsHeight[rowKey];
        }

        if (fixedColumnsBodyRowsHeight[index]) {
          return fixedColumnsBodyRowsHeight[index];
        }

        return null;
      }

      Object(react_lifecycles_compat_es["polyfill"])(TableRow_TableRow);
      /* harmony default export */

      var es_TableRow = Object(mini_store_lib["connect"])(function (state, props) {
        var currentHoverKey = state.currentHoverKey,
            expandedRowKeys = state.expandedRowKeys;
        var rowKey = props.rowKey,
            ancestorKeys = props.ancestorKeys;
        var visible = ancestorKeys.length === 0 || ancestorKeys.every(function (k) {
          return ~expandedRowKeys.indexOf(k);
        });
        return {
          visible: visible,
          hovered: currentHoverKey === rowKey,
          height: TableRow_getRowHeight(state, props)
        };
      })(TableRow_TableRow); // CONCATENATED MODULE: ./node_modules/rc-table/es/ExpandIcon.js

      var ExpandIcon_ExpandIcon = function (_React$Component) {
        inherits_default()(ExpandIcon, _React$Component);

        function ExpandIcon() {
          classCallCheck_default()(this, ExpandIcon);
          return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
        }

        ExpandIcon.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          return !shallowequal_default()(nextProps, this.props);
        };

        ExpandIcon.prototype.render = function render() {
          var _props = this.props,
              expandable = _props.expandable,
              prefixCls = _props.prefixCls,
              onExpand = _props.onExpand,
              needIndentSpaced = _props.needIndentSpaced,
              expanded = _props.expanded,
              record = _props.record;

          if (expandable) {
            var expandClassName = expanded ? 'expanded' : 'collapsed';
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-expand-icon ' + prefixCls + '-' + expandClassName,
              onClick: function onClick(e) {
                return onExpand(record, e);
              }
            });
          } else if (needIndentSpaced) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-expand-icon ' + prefixCls + '-spaced'
            });
          }

          return null;
        };

        return ExpandIcon;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      ExpandIcon_ExpandIcon.propTypes = {
        record: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        expandable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        expanded: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        needIndentSpaced: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onExpand: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      /* harmony default export */

      var es_ExpandIcon = ExpandIcon_ExpandIcon; // CONCATENATED MODULE: ./node_modules/rc-table/es/ExpandableRow.js

      var ExpandableRow_ExpandableRow = function (_React$Component) {
        inherits_default()(ExpandableRow, _React$Component);

        function ExpandableRow() {
          var _temp, _this, _ret;

          classCallCheck_default()(this, ExpandableRow);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.hasExpandIcon = function (columnIndex) {
            var expandRowByClick = _this.props.expandRowByClick;
            return !_this.expandIconAsCell && !expandRowByClick && columnIndex === _this.expandIconColumnIndex;
          }, _this.handleExpandChange = function (record, event) {
            var _this$props = _this.props,
                onExpandedChange = _this$props.onExpandedChange,
                expanded = _this$props.expanded,
                rowKey = _this$props.rowKey;

            if (_this.expandable) {
              onExpandedChange(!expanded, record, event, rowKey);
            }
          }, _this.handleRowClick = function (record, index, event) {
            var _this$props2 = _this.props,
                expandRowByClick = _this$props2.expandRowByClick,
                onRowClick = _this$props2.onRowClick;

            if (expandRowByClick) {
              _this.handleExpandChange(record, event);
            }

            if (onRowClick) {
              onRowClick(record, index, event);
            }
          }, _this.renderExpandIcon = function () {
            var _this$props3 = _this.props,
                prefixCls = _this$props3.prefixCls,
                expanded = _this$props3.expanded,
                record = _this$props3.record,
                needIndentSpaced = _this$props3.needIndentSpaced;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_ExpandIcon, {
              expandable: _this.expandable,
              prefixCls: prefixCls,
              onExpand: _this.handleExpandChange,
              needIndentSpaced: needIndentSpaced,
              expanded: expanded,
              record: record
            });
          }, _this.renderExpandIconCell = function (cells) {
            if (!_this.expandIconAsCell) {
              return;
            }

            var prefixCls = _this.props.prefixCls;
            cells.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('td', {
              className: prefixCls + '-expand-icon-cell',
              key: 'rc-table-expand-icon-cell'
            }, _this.renderExpandIcon()));
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        ExpandableRow.prototype.componentWillUnmount = function componentWillUnmount() {
          this.handleDestroy();
        };

        ExpandableRow.prototype.handleDestroy = function handleDestroy() {
          var _props = this.props,
              onExpandedChange = _props.onExpandedChange,
              rowKey = _props.rowKey,
              record = _props.record;

          if (this.expandable) {
            onExpandedChange(false, record, null, rowKey, true);
          }
        };

        ExpandableRow.prototype.render = function render() {
          var _props2 = this.props,
              childrenColumnName = _props2.childrenColumnName,
              expandedRowRender = _props2.expandedRowRender,
              indentSize = _props2.indentSize,
              record = _props2.record,
              fixed = _props2.fixed;
          this.expandIconAsCell = fixed !== 'right' ? this.props.expandIconAsCell : false;
          this.expandIconColumnIndex = fixed !== 'right' ? this.props.expandIconColumnIndex : -1;
          var childrenData = record[childrenColumnName];
          this.expandable = !!(childrenData || expandedRowRender);
          var expandableRowProps = {
            indentSize: indentSize,
            onRowClick: this.handleRowClick,
            hasExpandIcon: this.hasExpandIcon,
            renderExpandIcon: this.renderExpandIcon,
            renderExpandIconCell: this.renderExpandIconCell
          };
          return this.props.children(expandableRowProps);
        };

        return ExpandableRow;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      ExpandableRow_ExpandableRow.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        rowKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]).isRequired,
        fixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool]),
        record: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        indentSize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        needIndentSpaced: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool.isRequired,
        expandRowByClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        expanded: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool.isRequired,
        expandIconAsCell: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        expandIconColumnIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        childrenColumnName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        expandedRowRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onExpandedChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        onRowClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired
      };
      /* harmony default export */

      var es_ExpandableRow = Object(mini_store_lib["connect"])(function (_ref, _ref2) {
        var expandedRowKeys = _ref.expandedRowKeys;
        var rowKey = _ref2.rowKey;
        return {
          expanded: !!~expandedRowKeys.indexOf(rowKey)
        };
      })(ExpandableRow_ExpandableRow); // CONCATENATED MODULE: ./node_modules/rc-table/es/BaseTable.js

      var BaseTable_BaseTable = function (_React$Component) {
        inherits_default()(BaseTable, _React$Component);

        function BaseTable() {
          var _temp, _this, _ret;

          classCallCheck_default()(this, BaseTable);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleRowHover = function (isHover, key) {
            _this.props.store.setState({
              currentHoverKey: isHover ? key : null
            });
          }, _this.renderRows = function (renderData, indent) {
            var ancestorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var table = _this.context.table;
            var columnManager = table.columnManager,
                components = table.components;
            var _table$props = table.props,
                prefixCls = _table$props.prefixCls,
                childrenColumnName = _table$props.childrenColumnName,
                rowClassName = _table$props.rowClassName,
                rowRef = _table$props.rowRef,
                onRowClick = _table$props.onRowClick,
                onRowDoubleClick = _table$props.onRowDoubleClick,
                onRowContextMenu = _table$props.onRowContextMenu,
                onRowMouseEnter = _table$props.onRowMouseEnter,
                onRowMouseLeave = _table$props.onRowMouseLeave,
                onRow = _table$props.onRow;
            var _this$props = _this.props,
                getRowKey = _this$props.getRowKey,
                fixed = _this$props.fixed,
                expander = _this$props.expander,
                isAnyColumnsFixed = _this$props.isAnyColumnsFixed;
            var rows = [];

            var _loop = function _loop(i) {
              var record = renderData[i];
              var key = getRowKey(record, i);
              var className = typeof rowClassName === 'string' ? rowClassName : rowClassName(record, i, indent);
              var onHoverProps = {};

              if (columnManager.isAnyColumnsFixed()) {
                onHoverProps.onHover = _this.handleRowHover;
              }

              var leafColumns = void 0;

              if (fixed === 'left') {
                leafColumns = columnManager.leftLeafColumns();
              } else if (fixed === 'right') {
                leafColumns = columnManager.rightLeafColumns();
              } else {
                leafColumns = columnManager.leafColumns();
              }

              var rowPrefixCls = prefixCls + '-row';
              var row = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_ExpandableRow, extends_default()({}, expander.props, {
                fixed: fixed,
                index: i,
                prefixCls: rowPrefixCls,
                record: record,
                key: key,
                rowKey: key,
                onRowClick: onRowClick,
                needIndentSpaced: expander.needIndentSpaced,
                onExpandedChange: expander.handleExpandChange
              }), function (expandableRow) {
                return (// eslint-disable-line
                  external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_TableRow, extends_default()({
                    fixed: fixed,
                    indent: indent,
                    className: className,
                    record: record,
                    index: i,
                    prefixCls: rowPrefixCls,
                    childrenColumnName: childrenColumnName,
                    columns: leafColumns,
                    onRow: onRow,
                    onRowDoubleClick: onRowDoubleClick,
                    onRowContextMenu: onRowContextMenu,
                    onRowMouseEnter: onRowMouseEnter,
                    onRowMouseLeave: onRowMouseLeave
                  }, onHoverProps, {
                    rowKey: key,
                    ancestorKeys: ancestorKeys,
                    ref: rowRef(record, i, indent),
                    components: components,
                    isAnyColumnsFixed: isAnyColumnsFixed
                  }, expandableRow))
                );
              });
              rows.push(row);
              expander.renderRows(_this.renderRows, rows, record, i, indent, fixed, key, ancestorKeys);
            };

            for (var i = 0; i < renderData.length; i++) {
              _loop(i);
            }

            return rows;
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        BaseTable.prototype.render = function render() {
          var table = this.context.table;
          var components = table.components;
          var _table$props2 = table.props,
              prefixCls = _table$props2.prefixCls,
              scroll = _table$props2.scroll,
              data = _table$props2.data,
              getBodyWrapper = _table$props2.getBodyWrapper;
          var _props = this.props,
              expander = _props.expander,
              tableClassName = _props.tableClassName,
              hasHead = _props.hasHead,
              hasBody = _props.hasBody,
              fixed = _props.fixed,
              columns = _props.columns;
          var tableStyle = {};

          if (!fixed && scroll.x) {
            // not set width, then use content fixed width
            if (scroll.x === true) {
              tableStyle.tableLayout = 'fixed';
            } else {
              tableStyle.width = scroll.x;
            }
          }

          var Table = hasBody ? components.table : 'table';
          var BodyWrapper = components.body.wrapper;
          var body = void 0;

          if (hasBody) {
            body = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(BodyWrapper, {
              className: prefixCls + '-tbody'
            }, this.renderRows(data, 0));

            if (getBodyWrapper) {
              body = getBodyWrapper(body);
            }
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Table, {
            className: tableClassName,
            style: tableStyle,
            key: 'table'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ColGroup_ColGroup, {
            columns: columns,
            fixed: fixed
          }), hasHead && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(TableHeader_TableHeader, {
            expander: expander,
            columns: columns,
            fixed: fixed
          }), body);
        };

        return BaseTable;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      BaseTable_BaseTable.propTypes = {
        fixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool]),
        columns: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        tableClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        hasHead: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool.isRequired,
        hasBody: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool.isRequired,
        store: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        expander: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        getRowKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        isAnyColumnsFixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      BaseTable_BaseTable.contextTypes = {
        table: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      /* harmony default export */

      var es_BaseTable = Object(mini_store_lib["connect"])()(BaseTable_BaseTable); // CONCATENATED MODULE: ./node_modules/rc-table/es/HeadTable.js

      function HeadTable_HeadTable(props, _ref) {
        var table = _ref.table;
        var _table$props = table.props,
            prefixCls = _table$props.prefixCls,
            scroll = _table$props.scroll,
            showHeader = _table$props.showHeader;
        var columns = props.columns,
            fixed = props.fixed,
            tableClassName = props.tableClassName,
            handleBodyScrollLeft = props.handleBodyScrollLeft,
            expander = props.expander;
        var saveRef = table.saveRef;
        var useFixedHeader = table.props.useFixedHeader;
        var headStyle = {};

        if (scroll.y) {
          useFixedHeader = true; // Add negative margin bottom for scroll bar overflow bug

          var scrollbarWidth = utils_measureScrollbar('horizontal');

          if (scrollbarWidth > 0 && !fixed) {
            headStyle.marginBottom = '-' + scrollbarWidth + 'px';
            headStyle.paddingBottom = '0px';
          }
        }

        if (!useFixedHeader || !showHeader) {
          return null;
        }

        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
          key: 'headTable',
          ref: fixed ? null : saveRef('headTable'),
          className: prefixCls + '-header',
          style: headStyle,
          onScroll: handleBodyScrollLeft
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_BaseTable, {
          tableClassName: tableClassName,
          hasHead: true,
          hasBody: false,
          fixed: fixed,
          columns: columns,
          expander: expander
        }));
      }

      HeadTable_HeadTable.propTypes = {
        fixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool]),
        columns: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        tableClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        handleBodyScrollLeft: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        expander: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired
      };
      HeadTable_HeadTable.contextTypes = {
        table: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/rc-table/es/BodyTable.js

      function BodyTable_BodyTable(props, _ref) {
        var table = _ref.table;
        var _table$props = table.props,
            prefixCls = _table$props.prefixCls,
            scroll = _table$props.scroll;
        var columns = props.columns,
            fixed = props.fixed,
            tableClassName = props.tableClassName,
            getRowKey = props.getRowKey,
            handleBodyScroll = props.handleBodyScroll,
            handleWheel = props.handleWheel,
            expander = props.expander,
            isAnyColumnsFixed = props.isAnyColumnsFixed;
        var saveRef = table.saveRef;
        var useFixedHeader = table.props.useFixedHeader;
        var bodyStyle = extends_default()({}, table.props.bodyStyle);
        var innerBodyStyle = {};

        if (scroll.x || fixed) {
          bodyStyle.overflowX = bodyStyle.overflowX || 'scroll'; // Fix weired webkit render bug
          // https://github.com/ant-design/ant-design/issues/7783

          bodyStyle.WebkitTransform = 'translate3d (0, 0, 0)';
        }

        if (scroll.y) {
          // maxHeight will make fixed-Table scrolling not working
          // so we only set maxHeight to body-Table here
          if (fixed) {
            innerBodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
            innerBodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
          } else {
            bodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
          }

          bodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
          useFixedHeader = true; // Add negative margin bottom for scroll bar overflow bug

          var scrollbarWidth = utils_measureScrollbar();

          if (scrollbarWidth > 0 && fixed) {
            bodyStyle.marginBottom = '-' + scrollbarWidth + 'px';
            bodyStyle.paddingBottom = '0px';
          }
        }

        var baseTable = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_BaseTable, {
          tableClassName: tableClassName,
          hasHead: !useFixedHeader,
          hasBody: true,
          fixed: fixed,
          columns: columns,
          expander: expander,
          getRowKey: getRowKey,
          isAnyColumnsFixed: isAnyColumnsFixed
        });

        if (fixed && columns.length) {
          var refName = void 0;

          if (columns[0].fixed === 'left' || columns[0].fixed === true) {
            refName = 'fixedColumnsBodyLeft';
          } else if (columns[0].fixed === 'right') {
            refName = 'fixedColumnsBodyRight';
          }

          delete bodyStyle.overflowX;
          delete bodyStyle.overflowY;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            key: 'bodyTable',
            className: prefixCls + '-body-outer',
            style: extends_default()({}, bodyStyle)
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-body-inner',
            style: innerBodyStyle,
            ref: saveRef(refName),
            onWheel: handleWheel,
            onScroll: handleBodyScroll
          }, baseTable));
        }

        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
          key: 'bodyTable',
          className: prefixCls + '-body',
          style: bodyStyle,
          ref: saveRef('bodyTable'),
          onWheel: handleWheel,
          onScroll: handleBodyScroll
        }, baseTable);
      }

      BodyTable_BodyTable.propTypes = {
        fixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool]),
        columns: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        tableClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        handleWheel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        handleBodyScroll: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        getRowKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        expander: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        isAnyColumnsFixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      BodyTable_BodyTable.contextTypes = {
        table: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/rc-table/es/ExpandableTable.js

      var ExpandableTable_ExpandableTable = function (_React$Component) {
        inherits_default()(ExpandableTable, _React$Component);

        function ExpandableTable(props) {
          classCallCheck_default()(this, ExpandableTable);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          ExpandableTable_initialiseProps.call(_this);
          var data = props.data,
              childrenColumnName = props.childrenColumnName,
              defaultExpandAllRows = props.defaultExpandAllRows,
              expandedRowKeys = props.expandedRowKeys,
              defaultExpandedRowKeys = props.defaultExpandedRowKeys,
              getRowKey = props.getRowKey;
          var finnalExpandedRowKeys = [];
          var rows = [].concat(data);

          if (defaultExpandAllRows) {
            for (var i = 0; i < rows.length; i++) {
              var row = rows[i];
              finnalExpandedRowKeys.push(getRowKey(row, i));
              rows = rows.concat(row[childrenColumnName] || []);
            }
          } else {
            finnalExpandedRowKeys = expandedRowKeys || defaultExpandedRowKeys;
          }

          _this.columnManager = props.columnManager;
          _this.store = props.store;

          _this.store.setState({
            expandedRowsHeight: {},
            expandedRowKeys: finnalExpandedRowKeys
          });

          return _this;
        }

        ExpandableTable.prototype.componentDidUpdate = function componentDidUpdate() {
          if ('expandedRowKeys' in this.props) {
            this.store.setState({
              expandedRowKeys: this.props.expandedRowKeys
            });
          }
        };

        ExpandableTable.prototype.renderExpandedRow = function renderExpandedRow(record, index, _render, className, ancestorKeys, indent, fixed) {
          var _props = this.props,
              prefixCls = _props.prefixCls,
              expandIconAsCell = _props.expandIconAsCell,
              indentSize = _props.indentSize;
          var colCount = void 0;

          if (fixed === 'left') {
            colCount = this.columnManager.leftLeafColumns().length;
          } else if (fixed === 'right') {
            colCount = this.columnManager.rightLeafColumns().length;
          } else {
            colCount = this.columnManager.leafColumns().length;
          }

          var columns = [{
            key: 'extra-row',
            render: function render() {
              return {
                props: {
                  colSpan: colCount
                },
                children: fixed !== 'right' ? _render(record, index, indent) : '&nbsp;'
              };
            }
          }];

          if (expandIconAsCell && fixed !== 'right') {
            columns.unshift({
              key: 'expand-icon-placeholder',
              render: function render() {
                return null;
              }
            });
          }

          var parentKey = ancestorKeys[ancestorKeys.length - 1];
          var rowKey = parentKey + '-extra-row';
          var components = {
            body: {
              row: 'tr',
              cell: 'td'
            }
          };
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_TableRow, {
            key: rowKey,
            columns: columns,
            className: className,
            rowKey: rowKey,
            ancestorKeys: ancestorKeys,
            prefixCls: prefixCls + '-expanded-row',
            indentSize: indentSize,
            indent: indent,
            fixed: fixed,
            components: components,
            expandedRow: true
          });
        };

        ExpandableTable.prototype.render = function render() {
          var _props2 = this.props,
              data = _props2.data,
              childrenColumnName = _props2.childrenColumnName,
              children = _props2.children;
          var needIndentSpaced = data.some(function (record) {
            return record[childrenColumnName];
          });
          return children({
            props: this.props,
            needIndentSpaced: needIndentSpaced,
            renderRows: this.renderRows,
            handleExpandChange: this.handleExpandChange,
            renderExpandIndentCell: this.renderExpandIndentCell
          });
        };

        return ExpandableTable;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      ExpandableTable_ExpandableTable.propTypes = {
        expandIconAsCell: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        expandedRowKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        expandedRowClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        defaultExpandAllRows: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultExpandedRowKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        expandIconColumnIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        expandedRowRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        childrenColumnName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        indentSize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        onExpand: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onExpandedRowsChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        columnManager: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        store: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        getRowKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired
      };
      ExpandableTable_ExpandableTable.defaultProps = {
        expandIconAsCell: false,
        expandedRowClassName: function expandedRowClassName() {
          return '';
        },
        expandIconColumnIndex: 0,
        defaultExpandAllRows: false,
        defaultExpandedRowKeys: [],
        childrenColumnName: 'children',
        indentSize: 15,
        onExpand: function onExpand() {},
        onExpandedRowsChange: function onExpandedRowsChange() {}
      };

      var ExpandableTable_initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.handleExpandChange = function (expanded, record, event, rowKey) {
          var destroy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }

          var _props3 = _this2.props,
              onExpandedRowsChange = _props3.onExpandedRowsChange,
              onExpand = _props3.onExpand;

          var _store$getState = _this2.store.getState(),
              expandedRowKeys = _store$getState.expandedRowKeys;

          if (expanded) {
            // row was expaned
            expandedRowKeys = [].concat(expandedRowKeys, [rowKey]);
          } else {
            // row was collapse
            var expandedRowIndex = expandedRowKeys.indexOf(rowKey);

            if (expandedRowIndex !== -1) {
              expandedRowKeys = utils_remove(expandedRowKeys, rowKey);
            }
          }

          if (!_this2.props.expandedRowKeys) {
            _this2.store.setState({
              expandedRowKeys: expandedRowKeys
            });
          }

          onExpandedRowsChange(expandedRowKeys);

          if (!destroy) {
            onExpand(expanded, record);
          }
        };

        this.renderExpandIndentCell = function (rows, fixed) {
          var _props4 = _this2.props,
              prefixCls = _props4.prefixCls,
              expandIconAsCell = _props4.expandIconAsCell;

          if (!expandIconAsCell || fixed === 'right' || !rows.length) {
            return;
          }

          var iconColumn = {
            key: 'rc-table-expand-icon-cell',
            className: prefixCls + '-expand-icon-th',
            title: '',
            rowSpan: rows.length
          };
          rows[0].unshift(extends_default()({}, iconColumn, {
            column: iconColumn
          }));
        };

        this.renderRows = function (renderRows, rows, record, index, indent, fixed, parentKey, ancestorKeys) {
          var _props5 = _this2.props,
              expandedRowClassName = _props5.expandedRowClassName,
              expandedRowRender = _props5.expandedRowRender,
              childrenColumnName = _props5.childrenColumnName;
          var childrenData = record[childrenColumnName];
          var nextAncestorKeys = [].concat(ancestorKeys, [parentKey]);
          var nextIndent = indent + 1;

          if (expandedRowRender) {
            rows.push(_this2.renderExpandedRow(record, index, expandedRowRender, expandedRowClassName(record, index, indent), nextAncestorKeys, nextIndent, fixed));
          }

          if (childrenData) {
            rows.push.apply(rows, renderRows(childrenData, nextIndent, nextAncestorKeys));
          }
        };
      };

      Object(react_lifecycles_compat_es["polyfill"])(ExpandableTable_ExpandableTable);
      /* harmony default export */

      var es_ExpandableTable = Object(mini_store_lib["connect"])()(ExpandableTable_ExpandableTable); // CONCATENATED MODULE: ./node_modules/rc-table/es/Table.js

      var Table_Table = function (_React$Component) {
        inherits_default()(Table, _React$Component);

        Table.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
          if (nextProps.columns && nextProps.columns !== prevState.columns) {
            return {
              columns: nextProps.columns,
              children: null
            };
          } else if (nextProps.children !== prevState.children) {
            return {
              columns: null,
              children: nextProps.children
            };
          }

          return null;
        };

        function Table(props) {
          classCallCheck_default()(this, Table);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          _this.state = {};

          _this.getRowKey = function (record, index) {
            var rowKey = _this.props.rowKey;
            var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
            utils_warningOnce(key !== undefined, 'Each record in table should have a unique `key` prop,' + 'or set `rowKey` to an unique primary key.');
            return key === undefined ? index : key;
          };

          _this.handleWindowResize = function () {
            _this.syncFixedTableRowHeight();

            _this.setScrollPositionClassName();
          };

          _this.syncFixedTableRowHeight = function () {
            var tableRect = _this.tableNode.getBoundingClientRect(); // If tableNode's height less than 0, suppose it is hidden and don't recalculate rowHeight.
            // see: https://github.com/ant-design/ant-design/issues/4836


            if (tableRect.height !== undefined && tableRect.height <= 0) {
              return;
            }

            var prefixCls = _this.props.prefixCls;
            var headRows = _this.headTable ? _this.headTable.querySelectorAll('thead') : _this.bodyTable.querySelectorAll('thead');
            var bodyRows = _this.bodyTable.querySelectorAll('.' + prefixCls + '-row') || [];
            var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) {
              return row.getBoundingClientRect().height || 'auto';
            });
            var fixedColumnsBodyRowsHeight = [].map.call(bodyRows, function (row) {
              return row.getBoundingClientRect().height || 'auto';
            });

            var state = _this.store.getState();

            if (shallowequal_default()(state.fixedColumnsHeadRowsHeight, fixedColumnsHeadRowsHeight) && shallowequal_default()(state.fixedColumnsBodyRowsHeight, fixedColumnsBodyRowsHeight)) {
              return;
            }

            _this.store.setState({
              fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
              fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight
            });
          };

          _this.handleBodyScrollLeft = function (e) {
            // Fix https://github.com/ant-design/ant-design/issues/7635
            if (e.currentTarget !== e.target) {
              return;
            }

            var target = e.target;
            var _this$props$scroll = _this.props.scroll,
                scroll = _this$props$scroll === undefined ? {} : _this$props$scroll;
            var headTable = _this.headTable,
                bodyTable = _this.bodyTable;

            if (target.scrollLeft !== _this.lastScrollLeft && scroll.x) {
              if (target === bodyTable && headTable) {
                headTable.scrollLeft = target.scrollLeft;
              } else if (target === headTable && bodyTable) {
                bodyTable.scrollLeft = target.scrollLeft;
              }

              _this.setScrollPositionClassName();
            } // Remember last scrollLeft for scroll direction detecting.


            _this.lastScrollLeft = target.scrollLeft;
          };

          _this.handleBodyScrollTop = function (e) {
            var target = e.target; // Fix https://github.com/ant-design/ant-design/issues/9033

            if (e.currentTarget !== target) {
              return;
            }

            var _this$props$scroll2 = _this.props.scroll,
                scroll = _this$props$scroll2 === undefined ? {} : _this$props$scroll2;
            var headTable = _this.headTable,
                bodyTable = _this.bodyTable,
                fixedColumnsBodyLeft = _this.fixedColumnsBodyLeft,
                fixedColumnsBodyRight = _this.fixedColumnsBodyRight;

            if (target.scrollTop !== _this.lastScrollTop && scroll.y && target !== headTable) {
              var scrollTop = target.scrollTop;

              if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
                fixedColumnsBodyLeft.scrollTop = scrollTop;
              }

              if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
                fixedColumnsBodyRight.scrollTop = scrollTop;
              }

              if (bodyTable && target !== bodyTable) {
                bodyTable.scrollTop = scrollTop;
              }
            } // Remember last scrollTop for scroll direction detecting.


            _this.lastScrollTop = target.scrollTop;
          };

          _this.handleBodyScroll = function (e) {
            _this.handleBodyScrollLeft(e);

            _this.handleBodyScrollTop(e);
          };

          _this.handleWheel = function (event) {
            var _this$props$scroll3 = _this.props.scroll,
                scroll = _this$props$scroll3 === undefined ? {} : _this$props$scroll3;

            if (window.navigator.userAgent.match(/Trident\/7\./) && scroll.y) {
              event.preventDefault();
              var wd = event.deltaY;
              var target = event.target;
              var bodyTable = _this.bodyTable,
                  fixedColumnsBodyLeft = _this.fixedColumnsBodyLeft,
                  fixedColumnsBodyRight = _this.fixedColumnsBodyRight;
              var scrollTop = 0;

              if (_this.lastScrollTop) {
                scrollTop = _this.lastScrollTop + wd;
              } else {
                scrollTop = wd;
              }

              if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
                fixedColumnsBodyLeft.scrollTop = scrollTop;
              }

              if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
                fixedColumnsBodyRight.scrollTop = scrollTop;
              }

              if (bodyTable && target !== bodyTable) {
                bodyTable.scrollTop = scrollTop;
              }
            }
          };

          _this.saveRef = function (name) {
            return function (node) {
              _this[name] = node;
            };
          };

          ['onRowClick', 'onRowDoubleClick', 'onRowContextMenu', 'onRowMouseEnter', 'onRowMouseLeave'].forEach(function (name) {
            utils_warningOnce(props[name] === undefined, name + ' is deprecated, please use onRow instead.');
          });
          utils_warningOnce(props.getBodyWrapper === undefined, 'getBodyWrapper is deprecated, please use custom components instead.');
          _this.columnManager = new es_ColumnManager(props.columns, props.children);
          _this.store = Object(mini_store_lib["create"])({
            currentHoverKey: null,
            fixedColumnsHeadRowsHeight: [],
            fixedColumnsBodyRowsHeight: []
          });

          _this.setScrollPosition('left');

          _this.debouncedWindowResize = utils_debounce(_this.handleWindowResize, 150);
          return _this;
        }

        Table.prototype.getChildContext = function getChildContext() {
          return {
            table: {
              props: this.props,
              columnManager: this.columnManager,
              saveRef: this.saveRef,
              components: merge_default()({
                table: 'table',
                header: {
                  wrapper: 'thead',
                  row: 'tr',
                  cell: 'th'
                },
                body: {
                  wrapper: 'tbody',
                  row: 'tr',
                  cell: 'td'
                }
              }, this.props.components)
            }
          };
        };

        Table.prototype.componentDidMount = function componentDidMount() {
          if (this.columnManager.isAnyColumnsFixed()) {
            this.handleWindowResize();
            this.resizeEvent = Object(addEventListener["a"
            /* default */
            ])(window, 'resize', this.debouncedWindowResize);
          }
        };

        Table.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
          if (this.columnManager.isAnyColumnsFixed()) {
            this.handleWindowResize();

            if (!this.resizeEvent) {
              this.resizeEvent = Object(addEventListener["a"
              /* default */
              ])(window, 'resize', this.debouncedWindowResize);
            }
          } // when table changes to empty, reset scrollLeft


          if (prevProps.data.length > 0 && this.props.data.length === 0 && this.hasScrollX()) {
            this.resetScrollX();
          }
        };

        Table.prototype.componentWillUnmount = function componentWillUnmount() {
          if (this.resizeEvent) {
            this.resizeEvent.remove();
          }

          if (this.debouncedWindowResize) {
            this.debouncedWindowResize.cancel();
          }
        };

        Table.prototype.setScrollPosition = function setScrollPosition(position) {
          this.scrollPosition = position;

          if (this.tableNode) {
            var prefixCls = this.props.prefixCls;

            if (position === 'both') {
              component_classes_default()(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-left').add(prefixCls + '-scroll-position-right');
            } else {
              component_classes_default()(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-' + position);
            }
          }
        };

        Table.prototype.setScrollPositionClassName = function setScrollPositionClassName() {
          var node = this.bodyTable;
          var scrollToLeft = node.scrollLeft === 0;
          var scrollToRight = node.scrollLeft + 1 >= node.children[0].getBoundingClientRect().width - node.getBoundingClientRect().width;

          if (scrollToLeft && scrollToRight) {
            this.setScrollPosition('both');
          } else if (scrollToLeft) {
            this.setScrollPosition('left');
          } else if (scrollToRight) {
            this.setScrollPosition('right');
          } else if (this.scrollPosition !== 'middle') {
            this.setScrollPosition('middle');
          }
        };

        Table.prototype.resetScrollX = function resetScrollX() {
          if (this.headTable) {
            this.headTable.scrollLeft = 0;
          }

          if (this.bodyTable) {
            this.bodyTable.scrollLeft = 0;
          }
        };

        Table.prototype.hasScrollX = function hasScrollX() {
          var _props$scroll = this.props.scroll,
              scroll = _props$scroll === undefined ? {} : _props$scroll;
          return 'x' in scroll;
        };

        Table.prototype.renderMainTable = function renderMainTable() {
          var _props = this.props,
              scroll = _props.scroll,
              prefixCls = _props.prefixCls;
          var isAnyColumnsFixed = this.columnManager.isAnyColumnsFixed();
          var scrollable = isAnyColumnsFixed || scroll.x || scroll.y;
          var table = [this.renderTable({
            columns: this.columnManager.groupedColumns(),
            isAnyColumnsFixed: isAnyColumnsFixed
          }), this.renderEmptyText(), this.renderFooter()];
          return scrollable ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-scroll'
          }, table) : table;
        };

        Table.prototype.renderLeftFixedTable = function renderLeftFixedTable() {
          var prefixCls = this.props.prefixCls;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-fixed-left'
          }, this.renderTable({
            columns: this.columnManager.leftColumns(),
            fixed: 'left'
          }));
        };

        Table.prototype.renderRightFixedTable = function renderRightFixedTable() {
          var prefixCls = this.props.prefixCls;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-fixed-right'
          }, this.renderTable({
            columns: this.columnManager.rightColumns(),
            fixed: 'right'
          }));
        };

        Table.prototype.renderTable = function renderTable(options) {
          var columns = options.columns,
              fixed = options.fixed,
              isAnyColumnsFixed = options.isAnyColumnsFixed;
          var _props2 = this.props,
              prefixCls = _props2.prefixCls,
              _props2$scroll = _props2.scroll,
              scroll = _props2$scroll === undefined ? {} : _props2$scroll;
          var tableClassName = scroll.x || fixed ? prefixCls + '-fixed' : '';
          var headTable = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(HeadTable_HeadTable, {
            key: 'head',
            columns: columns,
            fixed: fixed,
            tableClassName: tableClassName,
            handleBodyScrollLeft: this.handleBodyScrollLeft,
            expander: this.expander
          });
          var bodyTable = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(BodyTable_BodyTable, {
            key: 'body',
            columns: columns,
            fixed: fixed,
            tableClassName: tableClassName,
            getRowKey: this.getRowKey,
            handleWheel: this.handleWheel,
            handleBodyScroll: this.handleBodyScroll,
            expander: this.expander,
            isAnyColumnsFixed: isAnyColumnsFixed
          });
          return [headTable, bodyTable];
        };

        Table.prototype.renderTitle = function renderTitle() {
          var _props3 = this.props,
              title = _props3.title,
              prefixCls = _props3.prefixCls;
          return title ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-title',
            key: 'title'
          }, title(this.props.data)) : null;
        };

        Table.prototype.renderFooter = function renderFooter() {
          var _props4 = this.props,
              footer = _props4.footer,
              prefixCls = _props4.prefixCls;
          return footer ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-footer',
            key: 'footer'
          }, footer(this.props.data)) : null;
        };

        Table.prototype.renderEmptyText = function renderEmptyText() {
          var _props5 = this.props,
              emptyText = _props5.emptyText,
              prefixCls = _props5.prefixCls,
              data = _props5.data;

          if (data.length) {
            return null;
          }

          var emptyClassName = prefixCls + '-placeholder';
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: emptyClassName,
            key: 'emptyText'
          }, typeof emptyText === 'function' ? emptyText() : emptyText);
        };

        Table.prototype.render = function render() {
          var _this2 = this;

          var props = this.props;
          var prefixCls = props.prefixCls;

          if (this.state.columns) {
            this.columnManager.reset(props.columns);
          } else if (this.state.children) {
            this.columnManager.reset(null, props.children);
          }

          var className = props.prefixCls;

          if (props.className) {
            className += ' ' + props.className;
          }

          if (props.useFixedHeader || props.scroll && props.scroll.y) {
            className += ' ' + prefixCls + '-fixed-header';
          }

          if (this.scrollPosition === 'both') {
            className += ' ' + prefixCls + '-scroll-position-left ' + prefixCls + '-scroll-position-right';
          } else {
            className += ' ' + prefixCls + '-scroll-position-' + this.scrollPosition;
          }

          var hasLeftFixed = this.columnManager.isAnyColumnsLeftFixed();
          var hasRightFixed = this.columnManager.isAnyColumnsRightFixed();
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(mini_store_lib["Provider"], {
            store: this.store
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_ExpandableTable, extends_default()({}, props, {
            columnManager: this.columnManager,
            getRowKey: this.getRowKey
          }), function (expander) {
            _this2.expander = expander;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              ref: _this2.saveRef('tableNode'),
              className: className,
              style: props.style,
              id: props.id
            }, _this2.renderTitle(), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-content'
            }, _this2.renderMainTable(), hasLeftFixed && _this2.renderLeftFixedTable(), hasRightFixed && _this2.renderRightFixedTable()));
          }));
        };

        return Table;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Table_Table.propTypes = extends_default()({
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        useFixedHeader: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        columns: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        bodyStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        rowKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        rowClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        onRow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onHeaderRow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRowClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRowDoubleClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRowContextMenu: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRowMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRowMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        showHeader: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        title: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        footer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        emptyText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        scroll: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        rowRef: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        getBodyWrapper: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        components: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          table: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          header: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
            wrapper: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
            row: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
            cell: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
          }),
          body: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
            wrapper: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
            row: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
            cell: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
          })
        })
      }, es_ExpandableTable.PropTypes);
      Table_Table.childContextTypes = {
        table: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        components: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      Table_Table.defaultProps = {
        data: [],
        useFixedHeader: false,
        rowKey: 'key',
        rowClassName: function rowClassName() {
          return '';
        },
        onRow: function onRow() {},
        onHeaderRow: function onHeaderRow() {},
        prefixCls: 'rc-table',
        bodyStyle: {},
        style: {},
        showHeader: true,
        scroll: {},
        rowRef: function rowRef() {
          return null;
        },
        emptyText: function emptyText() {
          return 'No Data';
        }
      };
      Object(react_lifecycles_compat_es["polyfill"])(Table_Table);
      /* harmony default export */

      var es_Table = Table_Table; // CONCATENATED MODULE: ./node_modules/rc-table/es/Column.js

      function Column_Column() {}

      Column_Column.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        colSpan: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        title: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        dataIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        width: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        fixed: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf([true, 'left', 'right']),
        render: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onCellClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onCell: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onHeaderCell: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      /* harmony default export */

      var es_Column = Column_Column; // CONCATENATED MODULE: ./node_modules/rc-table/es/ColumnGroup.js

      var ColumnGroup_ColumnGroup = function (_Component) {
        inherits_default()(ColumnGroup, _Component);

        function ColumnGroup() {
          classCallCheck_default()(this, ColumnGroup);
          return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
        }

        return ColumnGroup;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      ColumnGroup_ColumnGroup.propTypes = {
        title: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node
      };
      ColumnGroup_ColumnGroup.isTableColumnGroup = true;
      /* harmony default export */

      var es_ColumnGroup = ColumnGroup_ColumnGroup; // CONCATENATED MODULE: ./node_modules/rc-table/es/index.js

      es_Table.Column = es_Column;
      es_Table.ColumnGroup = es_ColumnGroup;
      /* harmony default export */

      var rc_table_es = es_Table; // EXTERNAL MODULE: ./node_modules/dom-closest/index.js

      var dom_closest = __webpack_require__(703);

      var dom_closest_default =
      /*#__PURE__*/
      __webpack_require__.n(dom_closest); // CONCATENATED MODULE: ./node_modules/antd/es/table/FilterDropdownMenuWrapper.js

      /* harmony default export */


      var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
          className: props.className,
          onClick: props.onClick
        }, props.children);
      }; // CONCATENATED MODULE: ./node_modules/antd/es/table/filterDropdown.js


      var filterDropdown_FilterMenu = function (_React$Component) {
        inherits_default()(FilterMenu, _React$Component);

        function FilterMenu(props) {
          classCallCheck_default()(this, FilterMenu);

          var _this = possibleConstructorReturn_default()(this, (FilterMenu.__proto__ || Object.getPrototypeOf(FilterMenu)).call(this, props));

          _this.setNeverShown = function (column) {
            var rootNode = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](_this);
            var filterBelongToScrollBody = !!dom_closest_default()(rootNode, '.ant-table-scroll');

            if (filterBelongToScrollBody) {
              // When fixed column have filters, there will be two dropdown menus
              // Filter dropdown menu inside scroll body should never be shown
              // To fix https://github.com/ant-design/ant-design/issues/5010 and
              // https://github.com/ant-design/ant-design/issues/7909
              _this.neverShown = !!column.fixed;
            }
          };

          _this.setSelectedKeys = function (_ref) {
            var selectedKeys = _ref.selectedKeys;

            _this.setState({
              selectedKeys: selectedKeys
            });
          };

          _this.handleClearFilters = function () {
            _this.setState({
              selectedKeys: []
            }, _this.handleConfirm);
          };

          _this.handleConfirm = function () {
            _this.setVisible(false);

            _this.confirmFilter();
          };

          _this.onVisibleChange = function (visible) {
            _this.setVisible(visible);

            if (!visible) {
              _this.confirmFilter();
            }
          };

          _this.handleMenuItemClick = function (info) {
            if (info.keyPath.length <= 1) {
              return;
            }

            var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;

            if (_this.state.selectedKeys.indexOf(info.key) >= 0) {
              // deselect SubMenu child
              delete keyPathOfSelectedItem[info.key];
            } else {
              // select SubMenu child
              keyPathOfSelectedItem[info.key] = info.keyPath;
            }

            _this.setState({
              keyPathOfSelectedItem: keyPathOfSelectedItem
            });
          };

          _this.renderFilterIcon = function () {
            var _this$props = _this.props,
                column = _this$props.column,
                locale = _this$props.locale,
                prefixCls = _this$props.prefixCls;
            var filterIcon = column.filterIcon;
            var dropdownSelectedClass = _this.props.selectedKeys.length > 0 ? prefixCls + '-selected' : '';
            return filterIcon ? external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](filterIcon, {
              title: locale.filterTitle,
              className: classnames_default()(filterIcon.className, defineProperty_default()({}, prefixCls + '-icon', true))
            }) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              title: locale.filterTitle,
              type: 'filter',
              className: dropdownSelectedClass
            });
          };

          var visible = 'filterDropdownVisible' in props.column ? props.column.filterDropdownVisible : false;
          _this.state = {
            selectedKeys: props.selectedKeys,
            keyPathOfSelectedItem: {},
            visible: visible
          };
          return _this;
        }

        createClass_default()(FilterMenu, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var column = this.props.column;
            this.setNeverShown(column);
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var column = nextProps.column;
            this.setNeverShown(column);
            var newState = {};

            if ('selectedKeys' in nextProps) {
              newState.selectedKeys = nextProps.selectedKeys;
            }

            if ('filterDropdownVisible' in column) {
              newState.visible = column.filterDropdownVisible;
            }

            if (Object.keys(newState).length > 0) {
              this.setState(newState);
            }
          }
        }, {
          key: 'setVisible',
          value: function setVisible(visible) {
            var column = this.props.column;

            if (!('filterDropdownVisible' in column)) {
              this.setState({
                visible: visible
              });
            }

            if (column.onFilterDropdownVisibleChange) {
              column.onFilterDropdownVisibleChange(visible);
            }
          }
        }, {
          key: 'confirmFilter',
          value: function confirmFilter() {
            if (this.state.selectedKeys !== this.props.selectedKeys) {
              this.props.confirmFilter(this.props.column, this.state.selectedKeys);
            }
          }
        }, {
          key: 'renderMenuItem',
          value: function renderMenuItem(item) {
            var column = this.props.column;
            var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
            var input = multiple ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_checkbox, {
              checked: this.state.selectedKeys.indexOf(item.value.toString()) >= 0
            }) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_radio, {
              checked: this.state.selectedKeys.indexOf(item.value.toString()) >= 0
            });
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_menu_es["b"
            /* Item */
            ], {
              key: item.value
            }, input, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, item.text));
          }
        }, {
          key: 'hasSubMenu',
          value: function hasSubMenu() {
            var _props$column$filters = this.props.column.filters,
                filters = _props$column$filters === undefined ? [] : _props$column$filters;
            return filters.some(function (item) {
              return !!(item.children && item.children.length > 0);
            });
          }
        }, {
          key: 'renderMenus',
          value: function renderMenus(items) {
            var _this2 = this;

            return items.map(function (item) {
              if (item.children && item.children.length > 0) {
                var keyPathOfSelectedItem = _this2.state.keyPathOfSelectedItem;
                var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
                  return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
                });
                var subMenuCls = containSelected ? _this2.props.dropdownPrefixCls + '-submenu-contain-selected' : '';
                return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_menu_es["d"
                /* SubMenu */
                ], {
                  title: item.text,
                  className: subMenuCls,
                  key: item.value.toString()
                }, _this2.renderMenus(item.children));
              }

              return _this2.renderMenuItem(item);
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                column = _props.column,
                locale = _props.locale,
                prefixCls = _props.prefixCls,
                dropdownPrefixCls = _props.dropdownPrefixCls,
                getPopupContainer = _props.getPopupContainer; // default multiple selection in filter dropdown

            var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
            var dropdownMenuClass = classnames_default()(defineProperty_default()({}, dropdownPrefixCls + '-menu-without-submenu', !this.hasSubMenu()));
            var menus = column.filterDropdown ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](FilterDropdownMenuWrapper, null, column.filterDropdown) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](FilterDropdownMenuWrapper, {
              className: prefixCls + '-dropdown'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_menu_es["e"
            /* default */
            ], {
              multiple: multiple,
              onClick: this.handleMenuItemClick,
              prefixCls: dropdownPrefixCls + '-menu',
              className: dropdownMenuClass,
              onSelect: this.setSelectedKeys,
              onDeselect: this.setSelectedKeys,
              selectedKeys: this.state.selectedKeys,
              getPopupContainer: function getPopupContainer(triggerNode) {
                return triggerNode.parentNode;
              }
            }, this.renderMenus(column.filters)), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-dropdown-btns'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', {
              className: prefixCls + '-dropdown-link confirm',
              onClick: this.handleConfirm
            }, locale.filterConfirm), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', {
              className: prefixCls + '-dropdown-link clear',
              onClick: this.handleClearFilters
            }, locale.filterReset)));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_dropdown, {
              trigger: ['click'],
              overlay: menus,
              visible: this.neverShown ? false : this.state.visible,
              onVisibleChange: this.onVisibleChange,
              getPopupContainer: getPopupContainer,
              forceRender: true
            }, this.renderFilterIcon());
          }
        }]);
        return FilterMenu;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var table_filterDropdown = filterDropdown_FilterMenu;
      filterDropdown_FilterMenu.defaultProps = {
        handleFilter: function handleFilter() {},
        column: {}
      }; // CONCATENATED MODULE: ./node_modules/antd/es/table/createStore.js

      function createStore_createStore(initialState) {
        var state = initialState;
        var listeners = [];

        function setState(partial) {
          state = extends_default()({}, state, partial);

          for (var i = 0; i < listeners.length; i++) {
            listeners[i]();
          }
        }

        function getState() {
          return state;
        }

        function subscribe(listener) {
          listeners.push(listener);
          return function unsubscribe() {
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
          };
        }

        return {
          setState: setState,
          getState: getState,
          subscribe: subscribe
        };
      } // CONCATENATED MODULE: ./node_modules/antd/es/table/SelectionBox.js


      var SelectionBox_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var SelectionBox_SelectionBox = function (_React$Component) {
        inherits_default()(SelectionBox, _React$Component);

        function SelectionBox(props) {
          classCallCheck_default()(this, SelectionBox);

          var _this = possibleConstructorReturn_default()(this, (SelectionBox.__proto__ || Object.getPrototypeOf(SelectionBox)).call(this, props));

          _this.state = {
            checked: _this.getCheckState(props)
          };
          return _this;
        }

        createClass_default()(SelectionBox, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.subscribe();
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.unsubscribe) {
              this.unsubscribe();
            }
          }
        }, {
          key: 'subscribe',
          value: function subscribe() {
            var _this2 = this;

            var store = this.props.store;
            this.unsubscribe = store.subscribe(function () {
              var checked = _this2.getCheckState(_this2.props);

              _this2.setState({
                checked: checked
              });
            });
          }
        }, {
          key: 'getCheckState',
          value: function getCheckState(props) {
            var store = props.store,
                defaultSelection = props.defaultSelection,
                rowIndex = props.rowIndex;
            var checked = false;

            if (store.getState().selectionDirty) {
              checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
            } else {
              checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
            }

            return checked;
          }
        }, {
          key: 'render',
          value: function render() {
            var _a = this.props,
                type = _a.type,
                rowIndex = _a.rowIndex,
                rest = SelectionBox_rest(_a, ["type", "rowIndex"]);
            var checked = this.state.checked;

            if (type === 'radio') {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_radio, extends_default()({
                checked: checked,
                value: rowIndex
              }, rest));
            } else {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_checkbox, extends_default()({
                checked: checked
              }, rest));
            }
          }
        }]);
        return SelectionBox;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var table_SelectionBox = SelectionBox_SelectionBox; // CONCATENATED MODULE: ./node_modules/antd/es/table/SelectionCheckboxAll.js

      var SelectionCheckboxAll_SelectionCheckboxAll = function (_React$Component) {
        inherits_default()(SelectionCheckboxAll, _React$Component);

        function SelectionCheckboxAll(props) {
          classCallCheck_default()(this, SelectionCheckboxAll);

          var _this = possibleConstructorReturn_default()(this, (SelectionCheckboxAll.__proto__ || Object.getPrototypeOf(SelectionCheckboxAll)).call(this, props));

          _this.handleSelectAllChagne = function (e) {
            var checked = e.target.checked;

            _this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
          };

          _this.defaultSelections = props.hideDefaultSelections ? [] : [{
            key: 'all',
            text: props.locale.selectAll,
            onSelect: function onSelect() {}
          }, {
            key: 'invert',
            text: props.locale.selectInvert,
            onSelect: function onSelect() {}
          }];
          _this.state = {
            checked: _this.getCheckState(props),
            indeterminate: _this.getIndeterminateState(props)
          };
          return _this;
        }

        createClass_default()(SelectionCheckboxAll, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.subscribe();
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.setCheckState(nextProps);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.unsubscribe) {
              this.unsubscribe();
            }
          }
        }, {
          key: 'subscribe',
          value: function subscribe() {
            var _this2 = this;

            var store = this.props.store;
            this.unsubscribe = store.subscribe(function () {
              _this2.setCheckState(_this2.props);
            });
          }
        }, {
          key: 'checkSelection',
          value: function checkSelection(data, type, byDefaultChecked) {
            var _props = this.props,
                store = _props.store,
                getCheckboxPropsByItem = _props.getCheckboxPropsByItem,
                getRecordKey = _props.getRecordKey; // type should be 'every' | 'some'

            if (type === 'every' || type === 'some') {
              return byDefaultChecked ? data[type](function (item, i) {
                return getCheckboxPropsByItem(item, i).defaultChecked;
              }) : data[type](function (item, i) {
                return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0;
              });
            }

            return false;
          }
        }, {
          key: 'setCheckState',
          value: function setCheckState(props) {
            var checked = this.getCheckState(props);
            var indeterminate = this.getIndeterminateState(props);

            if (checked !== this.state.checked) {
              this.setState({
                checked: checked
              });
            }

            if (indeterminate !== this.state.indeterminate) {
              this.setState({
                indeterminate: indeterminate
              });
            }
          }
        }, {
          key: 'getCheckState',
          value: function getCheckState(props) {
            var store = props.store,
                data = props.data;
            var checked = void 0;

            if (!data.length) {
              checked = false;
            } else {
              checked = store.getState().selectionDirty ? this.checkSelection(data, 'every', false) : this.checkSelection(data, 'every', false) || this.checkSelection(data, 'every', true);
            }

            return checked;
          }
        }, {
          key: 'getIndeterminateState',
          value: function getIndeterminateState(props) {
            var store = props.store,
                data = props.data;
            var indeterminate = void 0;

            if (!data.length) {
              indeterminate = false;
            } else {
              indeterminate = store.getState().selectionDirty ? this.checkSelection(data, 'some', false) && !this.checkSelection(data, 'every', false) : this.checkSelection(data, 'some', false) && !this.checkSelection(data, 'every', false) || this.checkSelection(data, 'some', true) && !this.checkSelection(data, 'every', true);
            }

            return indeterminate;
          }
        }, {
          key: 'renderMenus',
          value: function renderMenus(selections) {
            var _this3 = this;

            return selections.map(function (selection, index) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_menu.Item, {
                key: selection.key || index
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                onClick: function onClick() {
                  _this3.props.onSelect(selection.key, index, selection.onSelect);
                }
              }, selection.text));
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var _props2 = this.props,
                disabled = _props2.disabled,
                prefixCls = _props2.prefixCls,
                selections = _props2.selections,
                getPopupContainer = _props2.getPopupContainer;
            var _state = this.state,
                checked = _state.checked,
                indeterminate = _state.indeterminate;
            var selectionPrefixCls = prefixCls + '-selection';
            var customSelections = null;

            if (selections) {
              var newSelections = Array.isArray(selections) ? this.defaultSelections.concat(selections) : this.defaultSelections;
              var menu = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_menu, {
                className: selectionPrefixCls + '-menu',
                selectedKeys: []
              }, this.renderMenus(newSelections));
              customSelections = newSelections.length > 0 ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_dropdown, {
                overlay: menu,
                getPopupContainer: getPopupContainer
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: selectionPrefixCls + '-down'
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: 'down'
              }))) : null;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: selectionPrefixCls
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_checkbox, {
              className: classnames_default()(defineProperty_default()({}, selectionPrefixCls + '-select-all-custom', customSelections)),
              checked: checked,
              indeterminate: indeterminate,
              disabled: disabled,
              onChange: this.handleSelectAllChagne
            }), customSelections);
          }
        }]);
        return SelectionCheckboxAll;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var table_SelectionCheckboxAll = SelectionCheckboxAll_SelectionCheckboxAll; // CONCATENATED MODULE: ./node_modules/antd/es/table/Column.js

      var table_Column_Column = function (_React$Component) {
        inherits_default()(Column, _React$Component);

        function Column() {
          classCallCheck_default()(this, Column);
          return possibleConstructorReturn_default()(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
        }

        return Column;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var table_Column = table_Column_Column; // CONCATENATED MODULE: ./node_modules/antd/es/table/ColumnGroup.js

      var table_ColumnGroup_ColumnGroup = function (_React$Component) {
        inherits_default()(ColumnGroup, _React$Component);

        function ColumnGroup() {
          classCallCheck_default()(this, ColumnGroup);
          return possibleConstructorReturn_default()(this, (ColumnGroup.__proto__ || Object.getPrototypeOf(ColumnGroup)).apply(this, arguments));
        }

        return ColumnGroup;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var table_ColumnGroup = table_ColumnGroup_ColumnGroup;
      table_ColumnGroup_ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true; // CONCATENATED MODULE: ./node_modules/antd/es/table/createBodyRow.js

      function createBodyRow_createTableRow() {
        var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tr';

        var BodyRow = function (_React$Component) {
          inherits_default()(BodyRow, _React$Component);

          function BodyRow(props) {
            classCallCheck_default()(this, BodyRow);

            var _this = possibleConstructorReturn_default()(this, (BodyRow.__proto__ || Object.getPrototypeOf(BodyRow)).call(this, props));

            _this.store = props.store;

            var _this$store$getState = _this.store.getState(),
                selectedRowKeys = _this$store$getState.selectedRowKeys;

            _this.state = {
              selected: selectedRowKeys.indexOf(props.rowKey) >= 0
            };
            return _this;
          }

          createClass_default()(BodyRow, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              this.subscribe();
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              if (this.unsubscribe) {
                this.unsubscribe();
              }
            }
          }, {
            key: 'subscribe',
            value: function subscribe() {
              var _this2 = this;

              var _props = this.props,
                  store = _props.store,
                  rowKey = _props.rowKey;
              this.unsubscribe = store.subscribe(function () {
                var _store$getState = _this2.store.getState(),
                    selectedRowKeys = _store$getState.selectedRowKeys;

                var selected = selectedRowKeys.indexOf(rowKey) >= 0;

                if (selected !== _this2.state.selected) {
                  _this2.setState({
                    selected: selected
                  });
                }
              });
            }
          }, {
            key: 'render',
            value: function render() {
              var rowProps = Object(es["default"])(this.props, ['prefixCls', 'rowKey', 'store']);
              var className = classnames_default()(this.props.className, defineProperty_default()({}, this.props.prefixCls + '-row-selected', this.state.selected));
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Component, extends_default()({}, rowProps, {
                className: className
              }), this.props.children);
            }
          }]);
          return BodyRow;
        }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

        return BodyRow;
      } // CONCATENATED MODULE: ./node_modules/antd/es/table/util.js


      function util_flatArray() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var childrenName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
        var result = [];

        var loop = function loop(array) {
          array.forEach(function (item) {
            if (item[childrenName]) {
              var newItem = extends_default()({}, item);
              delete newItem[childrenName];
              result.push(newItem);

              if (item[childrenName].length > 0) {
                loop(item[childrenName]);
              }
            } else {
              result.push(item);
            }
          });
        };

        loop(data);
        return result;
      }

      function util_treeMap(tree, mapper) {
        var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
        return tree.map(function (node, index) {
          var extra = {};

          if (node[childrenName]) {
            extra[childrenName] = util_treeMap(node[childrenName], mapper, childrenName);
          }

          return extends_default()({}, mapper(node, index), extra);
        });
      }

      function util_flatFilter(tree, callback) {
        return tree.reduce(function (acc, node) {
          if (callback(node)) {
            acc.push(node);
          }

          if (node.children) {
            var children = util_flatFilter(node.children, callback);
            acc.push.apply(acc, toConsumableArray_default()(children));
          }

          return acc;
        }, []);
      }

      function util_normalizeColumns(elements) {
        var columns = [];
        external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(elements, function (element) {
          if (!external_root_React_commonjs2_react_commonjs_react_amd_react_["isValidElement"](element)) {
            return;
          }

          var column = extends_default()({}, element.props);

          if (element.key) {
            column.key = element.key;
          }

          if (element.type && element.type.__ANT_TABLE_COLUMN_GROUP) {
            column.children = util_normalizeColumns(column.children);
          }

          columns.push(column);
        });
        return columns;
      } // CONCATENATED MODULE: ./node_modules/antd/es/table/Table.js


      var Table_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      function Table_noop() {}

      function Table_stopPropagation(e) {
        e.stopPropagation();

        if (e.nativeEvent.stopImmediatePropagation) {
          e.nativeEvent.stopImmediatePropagation();
        }
      }

      var Table_defaultPagination = {
        onChange: Table_noop,
        onShowSizeChange: Table_noop
      };
      /**
       * Avoid creating new object, so that parent component's shouldComponentUpdate
       * can works appropriately。
       */

      var Table_emptyObject = {};

      var table_Table_Table = function (_React$Component) {
        inherits_default()(Table, _React$Component);

        function Table(props) {
          classCallCheck_default()(this, Table);

          var _this = possibleConstructorReturn_default()(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

          _this.getCheckboxPropsByItem = function (item, index) {
            var _this$props$rowSelect = _this.props.rowSelection,
                rowSelection = _this$props$rowSelect === undefined ? {} : _this$props$rowSelect;

            if (!rowSelection.getCheckboxProps) {
              return {};
            }

            var key = _this.getRecordKey(item, index); // Cache checkboxProps


            if (!_this.CheckboxPropsCache[key]) {
              _this.CheckboxPropsCache[key] = rowSelection.getCheckboxProps(item);
            }

            return _this.CheckboxPropsCache[key];
          };

          _this.onRow = function (record, index) {
            var _this$props = _this.props,
                onRow = _this$props.onRow,
                prefixCls = _this$props.prefixCls;
            var custom = onRow ? onRow(record, index) : {};
            return extends_default()({}, custom, {
              prefixCls: prefixCls,
              store: _this.store,
              rowKey: _this.getRecordKey(record, index)
            });
          };

          _this.handleFilter = function (column, nextFilters) {
            var props = _this.props;
            var pagination = extends_default()({}, _this.state.pagination);
            var filters = extends_default()({}, _this.state.filters, defineProperty_default()({}, _this.getColumnKey(column), nextFilters)); // Remove filters not in current columns

            var currentColumnKeys = [];
            util_treeMap(_this.columns, function (c) {
              if (!c.children) {
                currentColumnKeys.push(_this.getColumnKey(c));
              }
            });
            Object.keys(filters).forEach(function (columnKey) {
              if (currentColumnKeys.indexOf(columnKey) < 0) {
                delete filters[columnKey];
              }
            });

            if (props.pagination) {
              // Reset current prop
              pagination.current = 1;
              pagination.onChange(pagination.current);
            }

            var newState = {
              pagination: pagination,
              filters: {}
            };
            var filtersToSetState = extends_default()({}, filters); // Remove filters which is controlled

            _this.getFilteredValueColumns().forEach(function (col) {
              var columnKey = _this.getColumnKey(col);

              if (columnKey) {
                delete filtersToSetState[columnKey];
              }
            });

            if (Object.keys(filtersToSetState).length > 0) {
              newState.filters = filtersToSetState;
            } // Controlled current prop will not respond user interaction


            if (typeof_default()(props.pagination) === 'object' && 'current' in props.pagination) {
              newState.pagination = extends_default()({}, pagination, {
                current: _this.state.pagination.current
              });
            }

            _this.setState(newState, function () {
              _this.store.setState({
                selectionDirty: false
              });

              var onChange = _this.props.onChange;

              if (onChange) {
                onChange.apply(null, _this.prepareParamsArguments(extends_default()({}, _this.state, {
                  selectionDirty: false,
                  filters: filters,
                  pagination: pagination
                })));
              }
            });
          };

          _this.handleSelect = function (record, rowIndex, e) {
            var checked = e.target.checked;
            var nativeEvent = e.nativeEvent;
            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();

            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);

            var key = _this.getRecordKey(record, rowIndex);

            if (checked) {
              selectedRowKeys.push(_this.getRecordKey(record, rowIndex));
            } else {
              selectedRowKeys = selectedRowKeys.filter(function (i) {
                return key !== i;
              });
            }

            _this.store.setState({
              selectionDirty: true
            });

            _this.setSelectedRowKeys(selectedRowKeys, {
              selectWay: 'onSelect',
              record: record,
              checked: checked,
              changeRowKeys: void 0,
              nativeEvent: nativeEvent
            });
          };

          _this.handleRadioSelect = function (record, rowIndex, e) {
            var checked = e.target.checked;
            var nativeEvent = e.nativeEvent;
            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();

            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);

            var key = _this.getRecordKey(record, rowIndex);

            selectedRowKeys = [key];

            _this.store.setState({
              selectionDirty: true
            });

            _this.setSelectedRowKeys(selectedRowKeys, {
              selectWay: 'onSelect',
              record: record,
              checked: checked,
              changeRowKeys: void 0,
              nativeEvent: nativeEvent
            });
          };

          _this.handleSelectRow = function (selectionKey, index, onSelectFunc) {
            var data = _this.getFlatCurrentPageData();

            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();

            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);

            var changeableRowKeys = data.filter(function (item, i) {
              return !_this.getCheckboxPropsByItem(item, i).disabled;
            }).map(function (item, i) {
              return _this.getRecordKey(item, i);
            });
            var changeRowKeys = [];
            var selectWay = '';
            var checked = void 0; // handle default selection

            switch (selectionKey) {
              case 'all':
                changeableRowKeys.forEach(function (key) {
                  if (selectedRowKeys.indexOf(key) < 0) {
                    selectedRowKeys.push(key);
                    changeRowKeys.push(key);
                  }
                });
                selectWay = 'onSelectAll';
                checked = true;
                break;

              case 'removeAll':
                changeableRowKeys.forEach(function (key) {
                  if (selectedRowKeys.indexOf(key) >= 0) {
                    selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
                    changeRowKeys.push(key);
                  }
                });
                selectWay = 'onSelectAll';
                checked = false;
                break;

              case 'invert':
                changeableRowKeys.forEach(function (key) {
                  if (selectedRowKeys.indexOf(key) < 0) {
                    selectedRowKeys.push(key);
                  } else {
                    selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
                  }

                  changeRowKeys.push(key);
                  selectWay = 'onSelectInvert';
                });
                break;

              default:
                break;
            }

            _this.store.setState({
              selectionDirty: true
            }); // when select custom selection, callback selections[n].onSelect


            var rowSelection = _this.props.rowSelection;
            var customSelectionStartIndex = 2;

            if (rowSelection && rowSelection.hideDefaultSelections) {
              customSelectionStartIndex = 0;
            }

            if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
              return onSelectFunc(changeableRowKeys);
            }

            _this.setSelectedRowKeys(selectedRowKeys, {
              selectWay: selectWay,
              checked: checked,
              changeRowKeys: changeRowKeys
            });
          };

          _this.handlePageChange = function (current) {
            for (var _len = arguments.length, otherArguments = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              otherArguments[_key - 1] = arguments[_key];
            }

            var props = _this.props;
            var pagination = extends_default()({}, _this.state.pagination);

            if (current) {
              pagination.current = current;
            } else {
              pagination.current = pagination.current || 1;
            }

            pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
            var newState = {
              pagination: pagination
            }; // Controlled current prop will not respond user interaction

            if (props.pagination && typeof_default()(props.pagination) === 'object' && 'current' in props.pagination) {
              newState.pagination = extends_default()({}, pagination, {
                current: _this.state.pagination.current
              });
            }

            _this.setState(newState);

            _this.store.setState({
              selectionDirty: false
            });

            var onChange = _this.props.onChange;

            if (onChange) {
              onChange.apply(null, _this.prepareParamsArguments(extends_default()({}, _this.state, {
                selectionDirty: false,
                pagination: pagination
              })));
            }
          };

          _this.renderSelectionBox = function (type) {
            return function (_, record, index) {
              var rowIndex = _this.getRecordKey(record, index); // 从 1 开始


              var props = _this.getCheckboxPropsByItem(record, index);

              var handleChange = function handleChange(e) {
                type === 'radio' ? _this.handleRadioSelect(record, rowIndex, e) : _this.handleSelect(record, rowIndex, e);
              };

              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                onClick: Table_stopPropagation
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](table_SelectionBox, extends_default()({
                type: type,
                store: _this.store,
                rowIndex: rowIndex,
                onChange: handleChange,
                defaultSelection: _this.getDefaultSelection()
              }, props)));
            };
          };

          _this.getRecordKey = function (record, index) {
            var rowKey = _this.props.rowKey;
            var recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];

            _util_warning(recordKey !== undefined, 'Each record in dataSource of table should have a unique `key` prop, or set `rowKey` to an unique primary key,' + 'see https://u.ant.design/table-row-key');

            return recordKey === undefined ? index : recordKey;
          };

          _this.getPopupContainer = function () {
            return external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](_this);
          };

          _this.handleShowSizeChange = function (current, pageSize) {
            var pagination = _this.state.pagination;
            pagination.onShowSizeChange(current, pageSize);
            var nextPagination = extends_default()({}, pagination, {
              pageSize: pageSize,
              current: current
            });

            _this.setState({
              pagination: nextPagination
            });

            var onChange = _this.props.onChange;

            if (onChange) {
              onChange.apply(null, _this.prepareParamsArguments(extends_default()({}, _this.state, {
                pagination: nextPagination
              })));
            }
          };

          _this.renderTable = function (contextLocale, loading) {
            var _classNames;

            var locale = extends_default()({}, contextLocale, _this.props.locale);
            var _a = _this.props,
                style = _a.style,
                className = _a.className,
                prefixCls = _a.prefixCls,
                showHeader = _a.showHeader,
                restProps = Table_rest(_a, ["style", "className", "prefixCls", "showHeader"]);

            var data = _this.getCurrentPageData();

            var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false;
            var classString = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-' + _this.props.size, true), defineProperty_default()(_classNames, prefixCls + '-bordered', _this.props.bordered), defineProperty_default()(_classNames, prefixCls + '-empty', !data.length), defineProperty_default()(_classNames, prefixCls + '-without-column-header', !showHeader), _classNames));

            var columns = _this.renderRowSelection(locale);

            columns = _this.renderColumnsDropdown(columns, locale);
            columns = columns.map(function (column, i) {
              var newColumn = extends_default()({}, column);
              newColumn.key = _this.getColumnKey(newColumn, i);
              return newColumn;
            });
            var expandIconColumnIndex = columns[0] && columns[0].key === 'selection-column' ? 1 : 0;

            if ('expandIconColumnIndex' in restProps) {
              expandIconColumnIndex = restProps.expandIconColumnIndex;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_table_es, extends_default()({
              key: 'table'
            }, restProps, {
              onRow: _this.onRow,
              components: _this.components,
              prefixCls: prefixCls,
              data: data,
              columns: columns,
              showHeader: showHeader,
              className: classString,
              expandIconColumnIndex: expandIconColumnIndex,
              expandIconAsCell: expandIconAsCell,
              emptyText: !loading.spinning && locale.emptyText
            }));
          };

          _util_warning(!('columnsPageRange' in props || 'columnsPageSize' in props), '`columnsPageRange` and `columnsPageSize` are removed, please use ' + 'fixed columns instead, see: https://u.ant.design/fixed-columns.');

          _this.columns = props.columns || util_normalizeColumns(props.children);

          _this.createComponents(props.components);

          _this.state = extends_default()({}, _this.getDefaultSortOrder(_this.columns), {
            // 减少状态
            filters: _this.getFiltersFromColumns(),
            pagination: _this.getDefaultPagination(props)
          });
          _this.CheckboxPropsCache = {};
          _this.store = createStore_createStore({
            selectedRowKeys: (props.rowSelection || {}).selectedRowKeys || [],
            selectionDirty: false
          });
          return _this;
        }

        createClass_default()(Table, [{
          key: 'getDefaultSelection',
          value: function getDefaultSelection() {
            var _this2 = this;

            var _props$rowSelection = this.props.rowSelection,
                rowSelection = _props$rowSelection === undefined ? {} : _props$rowSelection;

            if (!rowSelection.getCheckboxProps) {
              return [];
            }

            return this.getFlatData().filter(function (item, rowIndex) {
              return _this2.getCheckboxPropsByItem(item, rowIndex).defaultChecked;
            }).map(function (record, rowIndex) {
              return _this2.getRecordKey(record, rowIndex);
            });
          }
        }, {
          key: 'getDefaultPagination',
          value: function getDefaultPagination(props) {
            var pagination = props.pagination || {};
            return this.hasPagination(props) ? extends_default()({}, Table_defaultPagination, pagination, {
              current: pagination.defaultCurrent || pagination.current || 1,
              pageSize: pagination.defaultPageSize || pagination.pageSize || 10
            }) : {};
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.columns = nextProps.columns || util_normalizeColumns(nextProps.children);

            if ('pagination' in nextProps || 'pagination' in this.props) {
              this.setState(function (previousState) {
                var newPagination = extends_default()({}, Table_defaultPagination, previousState.pagination, nextProps.pagination);
                newPagination.current = newPagination.current || 1;
                newPagination.pageSize = newPagination.pageSize || 10;
                return {
                  pagination: nextProps.pagination !== false ? newPagination : Table_emptyObject
                };
              });
            }

            if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
              this.store.setState({
                selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
              });
              var rowSelection = this.props.rowSelection;

              if (rowSelection && nextProps.rowSelection.getCheckboxProps !== rowSelection.getCheckboxProps) {
                this.CheckboxPropsCache = {};
              }
            }

            if ('dataSource' in nextProps && nextProps.dataSource !== this.props.dataSource) {
              this.store.setState({
                selectionDirty: false
              });
              this.CheckboxPropsCache = {};
            }

            if (this.getSortOrderColumns(this.columns).length > 0) {
              var sortState = this.getSortStateFromColumns(this.columns);

              if (sortState.sortColumn !== this.state.sortColumn || sortState.sortOrder !== this.state.sortOrder) {
                this.setState(sortState);
              }
            }

            var filteredValueColumns = this.getFilteredValueColumns(this.columns);

            if (filteredValueColumns.length > 0) {
              var filtersFromColumns = this.getFiltersFromColumns(this.columns);
              var newFilters = extends_default()({}, this.state.filters);
              Object.keys(filtersFromColumns).forEach(function (key) {
                newFilters[key] = filtersFromColumns[key];
              });

              if (this.isFiltersChanged(newFilters)) {
                this.setState({
                  filters: newFilters
                });
              }
            }

            this.createComponents(nextProps.components, this.props.components);
          }
        }, {
          key: 'setSelectedRowKeys',
          value: function setSelectedRowKeys(selectedRowKeys, _ref) {
            var _this3 = this;

            var selectWay = _ref.selectWay,
                record = _ref.record,
                checked = _ref.checked,
                changeRowKeys = _ref.changeRowKeys,
                nativeEvent = _ref.nativeEvent;
            var _props$rowSelection2 = this.props.rowSelection,
                rowSelection = _props$rowSelection2 === undefined ? {} : _props$rowSelection2;

            if (rowSelection && !('selectedRowKeys' in rowSelection)) {
              this.store.setState({
                selectedRowKeys: selectedRowKeys
              });
            }

            var data = this.getFlatData();

            if (!rowSelection.onChange && !rowSelection[selectWay]) {
              return;
            }

            var selectedRows = data.filter(function (row, i) {
              return selectedRowKeys.indexOf(_this3.getRecordKey(row, i)) >= 0;
            });

            if (rowSelection.onChange) {
              rowSelection.onChange(selectedRowKeys, selectedRows);
            }

            if (selectWay === 'onSelect' && rowSelection.onSelect) {
              rowSelection.onSelect(record, checked, selectedRows, nativeEvent);
            } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
              var changeRows = data.filter(function (row, i) {
                return changeRowKeys.indexOf(_this3.getRecordKey(row, i)) >= 0;
              });
              rowSelection.onSelectAll(checked, selectedRows, changeRows);
            } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
              rowSelection.onSelectInvert(selectedRowKeys);
            }
          }
        }, {
          key: 'hasPagination',
          value: function hasPagination(props) {
            return (props || this.props).pagination !== false;
          }
        }, {
          key: 'isFiltersChanged',
          value: function isFiltersChanged(filters) {
            var _this4 = this;

            var filtersChanged = false;

            if (Object.keys(filters).length !== Object.keys(this.state.filters).length) {
              filtersChanged = true;
            } else {
              Object.keys(filters).forEach(function (columnKey) {
                if (filters[columnKey] !== _this4.state.filters[columnKey]) {
                  filtersChanged = true;
                }
              });
            }

            return filtersChanged;
          }
        }, {
          key: 'getSortOrderColumns',
          value: function getSortOrderColumns(columns) {
            return util_flatFilter(columns || this.columns || [], function (column) {
              return 'sortOrder' in column;
            });
          }
        }, {
          key: 'getFilteredValueColumns',
          value: function getFilteredValueColumns(columns) {
            return util_flatFilter(columns || this.columns || [], function (column) {
              return typeof column.filteredValue !== 'undefined';
            });
          }
        }, {
          key: 'getFiltersFromColumns',
          value: function getFiltersFromColumns(columns) {
            var _this5 = this;

            var filters = {};
            this.getFilteredValueColumns(columns).forEach(function (col) {
              var colKey = _this5.getColumnKey(col);

              filters[colKey] = col.filteredValue;
            });
            return filters;
          }
        }, {
          key: 'getDefaultSortOrder',
          value: function getDefaultSortOrder(columns) {
            var definedSortState = this.getSortStateFromColumns(columns);
            var defaultSortedColumn = util_flatFilter(columns || [], function (column) {
              return column.defaultSortOrder != null;
            })[0];

            if (defaultSortedColumn && !definedSortState.sortColumn) {
              return {
                sortColumn: defaultSortedColumn,
                sortOrder: defaultSortedColumn.defaultSortOrder
              };
            }

            return definedSortState;
          }
        }, {
          key: 'getSortStateFromColumns',
          value: function getSortStateFromColumns(columns) {
            // return first column which sortOrder is not falsy
            var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) {
              return col.sortOrder;
            })[0];

            if (sortedColumn) {
              return {
                sortColumn: sortedColumn,
                sortOrder: sortedColumn.sortOrder
              };
            }

            return {
              sortColumn: null,
              sortOrder: null
            };
          }
        }, {
          key: 'getSorterFn',
          value: function getSorterFn() {
            var _state = this.state,
                sortOrder = _state.sortOrder,
                sortColumn = _state.sortColumn;

            if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
              return;
            }

            return function (a, b) {
              var result = sortColumn.sorter(a, b);

              if (result !== 0) {
                return sortOrder === 'descend' ? -result : result;
              }

              return 0;
            };
          }
        }, {
          key: 'toggleSortOrder',
          value: function toggleSortOrder(order, column) {
            var _state2 = this.state,
                sortColumn = _state2.sortColumn,
                sortOrder = _state2.sortOrder; // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题

            var isSortColumn = this.isSortColumn(column);

            if (!isSortColumn) {
              // 当前列未排序
              sortOrder = order;
              sortColumn = column;
            } else {
              // 当前列已排序
              if (sortOrder === order) {
                // 切换为未排序状态
                sortOrder = '';
                sortColumn = null;
              } else {
                // 切换为排序状态
                sortOrder = order;
              }
            }

            var newState = {
              sortOrder: sortOrder,
              sortColumn: sortColumn
            }; // Controlled

            if (this.getSortOrderColumns().length === 0) {
              this.setState(newState);
            }

            var onChange = this.props.onChange;

            if (onChange) {
              onChange.apply(null, this.prepareParamsArguments(extends_default()({}, this.state, newState)));
            }
          }
        }, {
          key: 'renderRowSelection',
          value: function renderRowSelection(locale) {
            var _this6 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                rowSelection = _props.rowSelection;
            var columns = this.columns.concat();

            if (rowSelection) {
              var data = this.getFlatCurrentPageData().filter(function (item, index) {
                if (rowSelection.getCheckboxProps) {
                  return !_this6.getCheckboxPropsByItem(item, index).disabled;
                }

                return true;
              });
              var selectionColumnClass = classnames_default()(prefixCls + '-selection-column', defineProperty_default()({}, prefixCls + '-selection-column-custom', rowSelection.selections));
              var selectionColumn = {
                key: 'selection-column',
                render: this.renderSelectionBox(rowSelection.type),
                className: selectionColumnClass,
                fixed: rowSelection.fixed,
                width: rowSelection.columnWidth
              };

              if (rowSelection.type !== 'radio') {
                var checkboxAllDisabled = data.every(function (item, index) {
                  return _this6.getCheckboxPropsByItem(item, index).disabled;
                });
                selectionColumn.title = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](table_SelectionCheckboxAll, {
                  store: this.store,
                  locale: locale,
                  data: data,
                  getCheckboxPropsByItem: this.getCheckboxPropsByItem,
                  getRecordKey: this.getRecordKey,
                  disabled: checkboxAllDisabled,
                  prefixCls: prefixCls,
                  onSelect: this.handleSelectRow,
                  selections: rowSelection.selections,
                  hideDefaultSelections: rowSelection.hideDefaultSelections,
                  getPopupContainer: this.getPopupContainer
                });
              }

              if ('fixed' in rowSelection) {
                selectionColumn.fixed = rowSelection.fixed;
              } else if (columns.some(function (column) {
                return column.fixed === 'left' || column.fixed === true;
              })) {
                selectionColumn.fixed = 'left';
              }

              if (columns[0] && columns[0].key === 'selection-column') {
                columns[0] = selectionColumn;
              } else {
                columns.unshift(selectionColumn);
              }
            }

            return columns;
          }
        }, {
          key: 'getColumnKey',
          value: function getColumnKey(column, index) {
            return column.key || column.dataIndex || index;
          }
        }, {
          key: 'getMaxCurrent',
          value: function getMaxCurrent(total) {
            var _state$pagination = this.state.pagination,
                current = _state$pagination.current,
                pageSize = _state$pagination.pageSize;

            if ((current - 1) * pageSize >= total) {
              return Math.floor((total - 1) / pageSize) + 1;
            }

            return current;
          }
        }, {
          key: 'isSortColumn',
          value: function isSortColumn(column) {
            var sortColumn = this.state.sortColumn;

            if (!column || !sortColumn) {
              return false;
            }

            return this.getColumnKey(sortColumn) === this.getColumnKey(column);
          }
        }, {
          key: 'renderColumnsDropdown',
          value: function renderColumnsDropdown(columns, locale) {
            var _this7 = this;

            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                dropdownPrefixCls = _props2.dropdownPrefixCls;
            var sortOrder = this.state.sortOrder;
            return util_treeMap(columns, function (originColumn, i) {
              var column = extends_default()({}, originColumn);

              var key = _this7.getColumnKey(column, i);

              var filterDropdown = void 0;
              var sortButton = void 0;

              if (column.filters && column.filters.length > 0 || column.filterDropdown) {
                var colFilters = _this7.state.filters[key] || [];
                filterDropdown = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](table_filterDropdown, {
                  locale: locale,
                  column: column,
                  selectedKeys: colFilters,
                  confirmFilter: _this7.handleFilter,
                  prefixCls: prefixCls + '-filter',
                  dropdownPrefixCls: dropdownPrefixCls || 'ant-dropdown',
                  getPopupContainer: _this7.getPopupContainer
                });
              }

              if (column.sorter) {
                var isSortColumn = _this7.isSortColumn(column);

                if (isSortColumn) {
                  column.className = classnames_default()(column.className, defineProperty_default()({}, prefixCls + '-column-sort', sortOrder));
                }

                var isAscend = isSortColumn && sortOrder === 'ascend';
                var isDescend = isSortColumn && sortOrder === 'descend';
                sortButton = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                  className: prefixCls + '-column-sorter'
                }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                  className: prefixCls + '-column-sorter-up ' + (isAscend ? 'on' : 'off'),
                  title: "\u2191",
                  onClick: function onClick() {
                    return _this7.toggleSortOrder('ascend', column);
                  }
                }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                  type: 'caret-up'
                })), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                  className: prefixCls + '-column-sorter-down ' + (isDescend ? 'on' : 'off'),
                  title: "\u2193",
                  onClick: function onClick() {
                    return _this7.toggleSortOrder('descend', column);
                  }
                }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                  type: 'caret-down'
                })));
              }

              column.title = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                key: key
              }, column.title, sortButton, filterDropdown);

              if (sortButton || filterDropdown) {
                column.className = classnames_default()(prefixCls + '-column-has-filters', column.className);
              }

              return column;
            });
          }
        }, {
          key: 'renderPagination',
          value: function renderPagination(paginationPosition) {
            // 强制不需要分页
            if (!this.hasPagination()) {
              return null;
            }

            var size = 'default';
            var pagination = this.state.pagination;

            if (pagination.size) {
              size = pagination.size;
            } else if (this.props.size === 'middle' || this.props.size === 'small') {
              size = 'small';
            }

            var position = pagination.position || 'bottom';
            var total = pagination.total || this.getLocalData().length;
            return total > 0 && (position === paginationPosition || position === 'both') ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_pagination, extends_default()({
              key: 'pagination-' + paginationPosition
            }, pagination, {
              className: classnames_default()(pagination.className, this.props.prefixCls + '-pagination'),
              onChange: this.handlePageChange,
              total: total,
              size: size,
              current: this.getMaxCurrent(total),
              onShowSizeChange: this.handleShowSizeChange
            })) : null;
          } // Get pagination, filters, sorter

        }, {
          key: 'prepareParamsArguments',
          value: function prepareParamsArguments(state) {
            var pagination = extends_default()({}, state.pagination); // remove useless handle function in Table.onChange

            delete pagination.onChange;
            delete pagination.onShowSizeChange;
            var filters = state.filters;
            var sorter = {};

            if (state.sortColumn && state.sortOrder) {
              sorter.column = state.sortColumn;
              sorter.order = state.sortOrder;
              sorter.field = state.sortColumn.dataIndex;
              sorter.columnKey = this.getColumnKey(state.sortColumn);
            }

            return [pagination, filters, sorter];
          }
        }, {
          key: 'findColumn',
          value: function findColumn(myKey) {
            var _this8 = this;

            var column = void 0;
            util_treeMap(this.columns, function (c) {
              if (_this8.getColumnKey(c) === myKey) {
                column = c;
              }
            });
            return column;
          }
        }, {
          key: 'getCurrentPageData',
          value: function getCurrentPageData() {
            var data = this.getLocalData();
            var current = void 0;
            var pageSize = void 0;
            var state = this.state; // 如果没有分页的话，默认全部展示

            if (!this.hasPagination()) {
              pageSize = Number.MAX_VALUE;
              current = 1;
            } else {
              pageSize = state.pagination.pageSize;
              current = this.getMaxCurrent(state.pagination.total || data.length);
            } // 分页
            // ---
            // 当数据量少于等于每页数量时，直接设置数据
            // 否则进行读取分页数据


            if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
              data = data.filter(function (_, i) {
                return i >= (current - 1) * pageSize && i < current * pageSize;
              });
            }

            return data;
          }
        }, {
          key: 'getFlatData',
          value: function getFlatData() {
            return util_flatArray(this.getLocalData());
          }
        }, {
          key: 'getFlatCurrentPageData',
          value: function getFlatCurrentPageData() {
            return util_flatArray(this.getCurrentPageData());
          }
        }, {
          key: 'recursiveSort',
          value: function recursiveSort(data, sorterFn) {
            var _this9 = this;

            var _props$childrenColumn = this.props.childrenColumnName,
                childrenColumnName = _props$childrenColumn === undefined ? 'children' : _props$childrenColumn;
            return data.sort(sorterFn).map(function (item) {
              return item[childrenColumnName] ? extends_default()({}, item, defineProperty_default()({}, childrenColumnName, _this9.recursiveSort(item[childrenColumnName], sorterFn))) : item;
            });
          }
        }, {
          key: 'getLocalData',
          value: function getLocalData() {
            var _this10 = this;

            var state = this.state;
            var dataSource = this.props.dataSource;
            var data = dataSource || []; // 优化本地排序

            data = data.slice(0);
            var sorterFn = this.getSorterFn();

            if (sorterFn) {
              data = this.recursiveSort(data, sorterFn);
            } // 筛选


            if (state.filters) {
              Object.keys(state.filters).forEach(function (columnKey) {
                var col = _this10.findColumn(columnKey);

                if (!col) {
                  return;
                }

                var values = state.filters[columnKey] || [];

                if (values.length === 0) {
                  return;
                }

                var onFilter = col.onFilter;
                data = onFilter ? data.filter(function (record) {
                  return values.some(function (v) {
                    return onFilter(v, record);
                  });
                }) : data;
              });
            }

            return data;
          }
        }, {
          key: 'createComponents',
          value: function createComponents() {
            var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var prevComponents = arguments[1];
            var bodyRow = components && components.body && components.body.row;
            var preBodyRow = prevComponents && prevComponents.body && prevComponents.body.row;

            if (!this.components || bodyRow !== preBodyRow) {
              this.components = extends_default()({}, components);
              this.components.body = extends_default()({}, components.body, {
                row: createBodyRow_createTableRow(bodyRow)
              });
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this11 = this;

            var _props3 = this.props,
                style = _props3.style,
                className = _props3.className,
                prefixCls = _props3.prefixCls;
            var data = this.getCurrentPageData();
            var loading = this.props.loading;

            if (typeof loading === 'boolean') {
              loading = {
                spinning: loading
              };
            }

            var table = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
              componentName: 'Table',
              defaultLocale: locale_provider_default.Table
            }, function (locale) {
              return _this11.renderTable(locale, loading);
            }); // if there is no pagination or no data,
            // the height of spin should decrease by half of pagination

            var paginationPatchClass = this.hasPagination() && data && data.length !== 0 ? prefixCls + '-with-pagination' : prefixCls + '-without-pagination';
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: classnames_default()(prefixCls + '-wrapper', className),
              style: style
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_spin, extends_default()({}, loading, {
              className: loading.spinning ? paginationPatchClass + ' ' + prefixCls + '-spin-holder' : ''
            }), this.renderPagination('top'), table, this.renderPagination('bottom')));
          }
        }]);
        return Table;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var table_Table = table_Table_Table;
      table_Table_Table.Column = table_Column;
      table_Table_Table.ColumnGroup = table_ColumnGroup;
      table_Table_Table.propTypes = {
        dataSource: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        columns: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        useFixedHeader: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        rowSelection: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        size: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        loading: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        bordered: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        dropdownPrefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      table_Table_Table.defaultProps = {
        dataSource: [],
        prefixCls: 'ant-table',
        useFixedHeader: false,
        rowSelection: null,
        className: '',
        size: 'large',
        loading: false,
        bordered: false,
        indentSize: 20,
        locale: {},
        rowKey: 'key',
        showHeader: true
      }; // CONCATENATED MODULE: ./node_modules/antd/es/table/index.js

      /* harmony default export */

      var es_table = table_Table; // CONCATENATED MODULE: ./node_modules/antd/es/transfer/search.js

      var search_Search = function (_React$Component) {
        inherits_default()(Search, _React$Component);

        function Search() {
          classCallCheck_default()(this, Search);

          var _this = possibleConstructorReturn_default()(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));

          _this.handleChange = function (e) {
            var onChange = _this.props.onChange;

            if (onChange) {
              onChange(e);
            }
          };

          _this.handleClear = function (e) {
            e.preventDefault();
            var handleClear = _this.props.handleClear;

            if (handleClear) {
              handleClear(e);
            }
          };

          return _this;
        }

        createClass_default()(Search, [{
          key: 'render',
          value: function render() {
            var _props = this.props,
                placeholder = _props.placeholder,
                value = _props.value,
                prefixCls = _props.prefixCls;
            var icon = value && value.length > 0 ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', {
              href: '#',
              className: prefixCls + '-action',
              onClick: this.handleClear
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'cross-circle'
            })) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: prefixCls + '-action'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'search'
            }));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', null, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_input, {
              placeholder: placeholder,
              className: prefixCls,
              value: value,
              ref: 'input',
              onChange: this.handleChange
            }), icon);
          }
        }]);
        return Search;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var transfer_search = search_Search;
      search_Search.defaultProps = {
        placeholder: ''
      }; // EXTERNAL MODULE: ./node_modules/react-lazy-load/lib/LazyLoad.js

      var LazyLoad = __webpack_require__(702);

      var LazyLoad_default =
      /*#__PURE__*/
      __webpack_require__.n(LazyLoad); // CONCATENATED MODULE: ./node_modules/antd/es/transfer/item.js


      var item_Item = function (_React$Component) {
        inherits_default()(Item, _React$Component);

        function Item() {
          classCallCheck_default()(this, Item);
          return possibleConstructorReturn_default()(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
        }

        createClass_default()(Item, [{
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return PureRenderMixin_default.a.shouldComponentUpdate.apply(this, args);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                renderedText = _props.renderedText,
                renderedEl = _props.renderedEl,
                item = _props.item,
                lazy = _props.lazy,
                checked = _props.checked,
                prefixCls = _props.prefixCls,
                onClick = _props.onClick;
            var className = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-content-item', true), defineProperty_default()(_classNames, prefixCls + '-content-item-disabled', item.disabled), _classNames));
            var listItem = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('li', {
              className: className,
              title: renderedText,
              onClick: item.disabled ? undefined : function () {
                return onClick(item);
              }
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_checkbox, {
              checked: checked,
              disabled: item.disabled
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, renderedEl));
            var children = null;

            if (lazy) {
              var lazyProps = extends_default()({
                height: 32,
                offset: 500,
                throttle: 0,
                debounce: false
              }, lazy);
              children = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](LazyLoad_default.a, lazyProps, listItem);
            } else {
              children = listItem;
            }

            return children;
          }
        }]);
        return Item;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var transfer_item = item_Item; // CONCATENATED MODULE: ./node_modules/antd/es/_util/triggerEvent.js

      function triggerEvent(el, type) {
        if ('createEvent' in document) {
          // modern browsers, IE9+
          var e = document.createEvent('HTMLEvents');
          e.initEvent(type, false, true);
          el.dispatchEvent(e);
        }
      } // CONCATENATED MODULE: ./node_modules/antd/es/transfer/list.js


      function list_noop() {}

      function list_isRenderResultPlainObject(result) {
        return result && !external_root_React_commonjs2_react_commonjs_react_amd_react_["isValidElement"](result) && Object.prototype.toString.call(result) === '[object Object]';
      }

      var list_TransferList = function (_React$Component) {
        inherits_default()(TransferList, _React$Component);

        function TransferList(props) {
          classCallCheck_default()(this, TransferList);

          var _this = possibleConstructorReturn_default()(this, (TransferList.__proto__ || Object.getPrototypeOf(TransferList)).call(this, props));

          _this.handleSelect = function (selectedItem) {
            var checkedKeys = _this.props.checkedKeys;
            var result = checkedKeys.some(function (key) {
              return key === selectedItem.key;
            });

            _this.props.handleSelect(selectedItem, !result);
          };

          _this.handleFilter = function (e) {
            _this.props.handleFilter(e);

            if (!e.target.value) {
              return;
            } // Manually trigger scroll event for lazy search bug
            // https://github.com/ant-design/ant-design/issues/5631


            _this.triggerScrollTimer = window.setTimeout(function () {
              var listNode = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](_this).querySelectorAll('.ant-transfer-list-content')[0];

              if (listNode) {
                triggerEvent(listNode, 'scroll');
              }
            }, 0);
          };

          _this.handleClear = function () {
            _this.props.handleClear();
          };

          _this.matchFilter = function (text, item) {
            var _this$props = _this.props,
                filter = _this$props.filter,
                filterOption = _this$props.filterOption;

            if (filterOption) {
              return filterOption(filter, item);
            }

            return text.indexOf(filter) >= 0;
          };

          _this.renderItem = function (item) {
            var _this$props$render = _this.props.render,
                render = _this$props$render === undefined ? list_noop : _this$props$render;
            var renderResult = render(item);
            var isRenderResultPlain = list_isRenderResultPlainObject(renderResult);
            return {
              renderedText: isRenderResultPlain ? renderResult.value : renderResult,
              renderedEl: isRenderResultPlain ? renderResult.label : renderResult
            };
          };

          _this.state = {
            mounted: false
          };
          return _this;
        }

        createClass_default()(TransferList, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _this2 = this;

            this.timer = window.setTimeout(function () {
              _this2.setState({
                mounted: true
              });
            }, 0);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            clearTimeout(this.timer);
            clearTimeout(this.triggerScrollTimer);
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return PureRenderMixin_default.a.shouldComponentUpdate.apply(this, args);
          }
        }, {
          key: 'getCheckStatus',
          value: function getCheckStatus(filteredDataSource) {
            var checkedKeys = this.props.checkedKeys;

            if (checkedKeys.length === 0) {
              return 'none';
            } else if (filteredDataSource.every(function (item) {
              return checkedKeys.indexOf(item.key) >= 0;
            })) {
              return 'all';
            }

            return 'part';
          }
        }, {
          key: 'render',
          value: function render() {
            var _this3 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                dataSource = _props.dataSource,
                titleText = _props.titleText,
                checkedKeys = _props.checkedKeys,
                lazy = _props.lazy,
                _props$body = _props.body,
                body = _props$body === undefined ? list_noop : _props$body,
                _props$footer = _props.footer,
                footer = _props$footer === undefined ? list_noop : _props$footer,
                showSearch = _props.showSearch,
                style = _props.style,
                filter = _props.filter,
                searchPlaceholder = _props.searchPlaceholder,
                notFoundContent = _props.notFoundContent,
                itemUnit = _props.itemUnit,
                itemsUnit = _props.itemsUnit,
                onScroll = _props.onScroll; // Custom Layout

            var footerDom = footer(extends_default()({}, this.props));
            var bodyDom = body(extends_default()({}, this.props));
            var listCls = classnames_default()(prefixCls, defineProperty_default()({}, prefixCls + '-with-footer', !!footerDom));
            var filteredDataSource = [];
            var totalDataSource = [];
            var showItems = dataSource.map(function (item) {
              var _renderItem = _this3.renderItem(item),
                  renderedText = _renderItem.renderedText,
                  renderedEl = _renderItem.renderedEl;

              if (filter && filter.trim() && !_this3.matchFilter(renderedText, item)) {
                return null;
              } // all show items


              totalDataSource.push(item);

              if (!item.disabled) {
                // response to checkAll items
                filteredDataSource.push(item);
              }

              var checked = checkedKeys.indexOf(item.key) >= 0;
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](transfer_item, {
                key: item.key,
                item: item,
                lazy: lazy,
                renderedText: renderedText,
                renderedEl: renderedEl,
                checked: checked,
                prefixCls: prefixCls,
                onClick: _this3.handleSelect
              });
            });
            var unit = dataSource.length > 1 ? itemsUnit : itemUnit;
            var search = showSearch ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-body-search-wrapper'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](transfer_search, {
              prefixCls: prefixCls + '-search',
              onChange: this.handleFilter,
              handleClear: this.handleClear,
              placeholder: searchPlaceholder,
              value: filter
            })) : null;
            var listBody = bodyDom || external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: showSearch ? prefixCls + '-body ' + prefixCls + '-body-with-search' : prefixCls + '-body'
            }, search, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], {
              component: 'ul',
              componentProps: {
                onScroll: onScroll
              },
              className: prefixCls + '-content',
              transitionName: this.state.mounted ? prefixCls + '-content-item-highlight' : '',
              transitionLeave: false
            }, showItems), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-body-not-found'
            }, notFoundContent));
            var listFooter = footerDom ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-footer'
            }, footerDom) : null;
            var checkStatus = this.getCheckStatus(filteredDataSource);
            var checkedAll = checkStatus === 'all';
            var checkAllCheckbox = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_checkbox, {
              ref: 'checkbox',
              checked: checkedAll,
              indeterminate: checkStatus === 'part',
              onChange: function onChange() {
                return _this3.props.handleSelectAll(filteredDataSource, checkedAll);
              }
            });
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: listCls,
              style: style
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-header'
            }, checkAllCheckbox, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: prefixCls + '-header-selected'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, (checkedKeys.length > 0 ? checkedKeys.length + '/' : '') + totalDataSource.length, ' ', unit), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: prefixCls + '-header-title'
            }, titleText))), listBody, listFooter);
          }
        }]);
        return TransferList;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var transfer_list = list_TransferList;
      list_TransferList.defaultProps = {
        dataSource: [],
        titleText: '',
        showSearch: false,
        render: list_noop,
        lazy: {}
      }; // CONCATENATED MODULE: ./node_modules/antd/es/transfer/operation.js

      function operation_noop() {}

      var operation_Operation = function (_React$Component) {
        inherits_default()(Operation, _React$Component);

        function Operation() {
          classCallCheck_default()(this, Operation);
          return possibleConstructorReturn_default()(this, (Operation.__proto__ || Object.getPrototypeOf(Operation)).apply(this, arguments));
        }

        createClass_default()(Operation, [{
          key: 'render',
          value: function render() {
            var _props = this.props,
                _props$moveToLeft = _props.moveToLeft,
                moveToLeft = _props$moveToLeft === undefined ? operation_noop : _props$moveToLeft,
                _props$moveToRight = _props.moveToRight,
                moveToRight = _props$moveToRight === undefined ? operation_noop : _props$moveToRight,
                _props$leftArrowText = _props.leftArrowText,
                leftArrowText = _props$leftArrowText === undefined ? '' : _props$leftArrowText,
                _props$rightArrowText = _props.rightArrowText,
                rightArrowText = _props$rightArrowText === undefined ? '' : _props$rightArrowText,
                leftActive = _props.leftActive,
                rightActive = _props.rightActive,
                className = _props.className;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: className
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_button, {
              type: 'primary',
              size: 'small',
              disabled: !leftActive,
              onClick: moveToLeft,
              icon: 'left'
            }, leftArrowText), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_button, {
              type: 'primary',
              size: 'small',
              disabled: !rightActive,
              onClick: moveToRight,
              icon: 'right'
            }, rightArrowText));
          }
        }]);
        return Operation;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var operation = operation_Operation; // CONCATENATED MODULE: ./node_modules/antd/es/transfer/index.js

      function transfer_noop() {}

      var transfer_Transfer = function (_React$Component) {
        inherits_default()(Transfer, _React$Component);

        function Transfer(props) {
          classCallCheck_default()(this, Transfer);

          var _this = possibleConstructorReturn_default()(this, (Transfer.__proto__ || Object.getPrototypeOf(Transfer)).call(this, props));

          _this.moveTo = function (direction) {
            var _this$props = _this.props,
                _this$props$targetKey = _this$props.targetKeys,
                targetKeys = _this$props$targetKey === undefined ? [] : _this$props$targetKey,
                _this$props$dataSourc = _this$props.dataSource,
                dataSource = _this$props$dataSourc === undefined ? [] : _this$props$dataSourc,
                onChange = _this$props.onChange;
            var _this$state = _this.state,
                sourceSelectedKeys = _this$state.sourceSelectedKeys,
                targetSelectedKeys = _this$state.targetSelectedKeys;
            var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys; // filter the disabled options

            var newMoveKeys = moveKeys.filter(function (key) {
              return !dataSource.some(function (data) {
                return !!(key === data.key && data.disabled);
              });
            }); // move items to target box

            var newTargetKeys = direction === 'right' ? newMoveKeys.concat(targetKeys) : targetKeys.filter(function (targetKey) {
              return newMoveKeys.indexOf(targetKey) === -1;
            }); // empty checked keys

            var oppositeDirection = direction === 'right' ? 'left' : 'right';

            _this.setState(defineProperty_default()({}, _this.getSelectedKeysName(oppositeDirection), []));

            _this.handleSelectChange(oppositeDirection, []);

            if (onChange) {
              onChange(newTargetKeys, direction, newMoveKeys);
            }
          };

          _this.moveToLeft = function () {
            return _this.moveTo('left');
          };

          _this.moveToRight = function () {
            return _this.moveTo('right');
          };

          _this.handleSelectAll = function (direction, filteredDataSource, checkAll) {
            var originalSelectedKeys = _this.state[_this.getSelectedKeysName(direction)] || [];
            var currentKeys = filteredDataSource.map(function (item) {
              return item.key;
            }); // Only operate current keys from original selected keys

            var newKeys1 = originalSelectedKeys.filter(function (key) {
              return currentKeys.indexOf(key) === -1;
            });
            var newKeys2 = [].concat(toConsumableArray_default()(originalSelectedKeys));
            currentKeys.forEach(function (key) {
              if (newKeys2.indexOf(key) === -1) {
                newKeys2.push(key);
              }
            });
            var holder = checkAll ? newKeys1 : newKeys2;

            _this.handleSelectChange(direction, holder);

            if (!_this.props.selectedKeys) {
              _this.setState(defineProperty_default()({}, _this.getSelectedKeysName(direction), holder));
            }
          };

          _this.handleLeftSelectAll = function (filteredDataSource, checkAll) {
            return _this.handleSelectAll('left', filteredDataSource, checkAll);
          };

          _this.handleRightSelectAll = function (filteredDataSource, checkAll) {
            return _this.handleSelectAll('right', filteredDataSource, checkAll);
          };

          _this.handleFilter = function (direction, e) {
            _this.setState(defineProperty_default()({}, direction + 'Filter', e.target.value));

            if (_this.props.onSearchChange) {
              _this.props.onSearchChange(direction, e);
            }
          };

          _this.handleLeftFilter = function (e) {
            return _this.handleFilter('left', e);
          };

          _this.handleRightFilter = function (e) {
            return _this.handleFilter('right', e);
          };

          _this.handleClear = function (direction) {
            _this.setState(defineProperty_default()({}, direction + 'Filter', ''));
          };

          _this.handleLeftClear = function () {
            return _this.handleClear('left');
          };

          _this.handleRightClear = function () {
            return _this.handleClear('right');
          };

          _this.handleSelect = function (direction, selectedItem, checked) {
            var _this$state2 = _this.state,
                sourceSelectedKeys = _this$state2.sourceSelectedKeys,
                targetSelectedKeys = _this$state2.targetSelectedKeys;
            var holder = direction === 'left' ? [].concat(toConsumableArray_default()(sourceSelectedKeys)) : [].concat(toConsumableArray_default()(targetSelectedKeys));
            var index = holder.indexOf(selectedItem.key);

            if (index > -1) {
              holder.splice(index, 1);
            }

            if (checked) {
              holder.push(selectedItem.key);
            }

            _this.handleSelectChange(direction, holder);

            if (!_this.props.selectedKeys) {
              _this.setState(defineProperty_default()({}, _this.getSelectedKeysName(direction), holder));
            }
          };

          _this.handleLeftSelect = function (selectedItem, checked) {
            return _this.handleSelect('left', selectedItem, checked);
          };

          _this.handleRightSelect = function (selectedItem, checked) {
            return _this.handleSelect('right', selectedItem, checked);
          };

          _this.handleScroll = function (direction, e) {
            var onScroll = _this.props.onScroll;

            if (onScroll) {
              onScroll(direction, e);
            }
          };

          _this.handleLeftScroll = function (e) {
            return _this.handleScroll('left', e);
          };

          _this.handleRightScroll = function (e) {
            return _this.handleScroll('right', e);
          };

          _this.renderTransfer = function (locale) {
            var _this$props2 = _this.props,
                _this$props2$prefixCl = _this$props2.prefixCls,
                prefixCls = _this$props2$prefixCl === undefined ? 'ant-transfer' : _this$props2$prefixCl,
                className = _this$props2.className,
                _this$props2$operatio = _this$props2.operations,
                operations = _this$props2$operatio === undefined ? [] : _this$props2$operatio,
                showSearch = _this$props2.showSearch,
                notFoundContent = _this$props2.notFoundContent,
                searchPlaceholder = _this$props2.searchPlaceholder,
                body = _this$props2.body,
                footer = _this$props2.footer,
                listStyle = _this$props2.listStyle,
                filterOption = _this$props2.filterOption,
                render = _this$props2.render,
                lazy = _this$props2.lazy;
            var _this$state3 = _this.state,
                leftFilter = _this$state3.leftFilter,
                rightFilter = _this$state3.rightFilter,
                sourceSelectedKeys = _this$state3.sourceSelectedKeys,
                targetSelectedKeys = _this$state3.targetSelectedKeys;

            var _this$splitDataSource = _this.splitDataSource(_this.props),
                leftDataSource = _this$splitDataSource.leftDataSource,
                rightDataSource = _this$splitDataSource.rightDataSource;

            var leftActive = targetSelectedKeys.length > 0;
            var rightActive = sourceSelectedKeys.length > 0;
            var cls = classnames_default()(className, prefixCls);

            var titles = _this.getTitles(locale);

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: cls
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](transfer_list, {
              prefixCls: prefixCls + '-list',
              titleText: titles[0],
              dataSource: leftDataSource,
              filter: leftFilter,
              filterOption: filterOption,
              style: listStyle,
              checkedKeys: sourceSelectedKeys,
              handleFilter: _this.handleLeftFilter,
              handleClear: _this.handleLeftClear,
              handleSelect: _this.handleLeftSelect,
              handleSelectAll: _this.handleLeftSelectAll,
              render: render,
              showSearch: showSearch,
              searchPlaceholder: searchPlaceholder || locale.searchPlaceholder,
              notFoundContent: notFoundContent || locale.notFoundContent,
              itemUnit: locale.itemUnit,
              itemsUnit: locale.itemsUnit,
              body: body,
              footer: footer,
              lazy: lazy,
              onScroll: _this.handleLeftScroll
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](operation, {
              className: prefixCls + '-operation',
              rightActive: rightActive,
              rightArrowText: operations[0],
              moveToRight: _this.moveToRight,
              leftActive: leftActive,
              leftArrowText: operations[1],
              moveToLeft: _this.moveToLeft
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](transfer_list, {
              prefixCls: prefixCls + '-list',
              titleText: titles[1],
              dataSource: rightDataSource,
              filter: rightFilter,
              filterOption: filterOption,
              style: listStyle,
              checkedKeys: targetSelectedKeys,
              handleFilter: _this.handleRightFilter,
              handleClear: _this.handleRightClear,
              handleSelect: _this.handleRightSelect,
              handleSelectAll: _this.handleRightSelectAll,
              render: render,
              showSearch: showSearch,
              searchPlaceholder: searchPlaceholder || locale.searchPlaceholder,
              notFoundContent: notFoundContent || locale.notFoundContent,
              itemUnit: locale.itemUnit,
              itemsUnit: locale.itemsUnit,
              body: body,
              footer: footer,
              lazy: lazy,
              onScroll: _this.handleRightScroll
            }));
          };

          var _props$selectedKeys = props.selectedKeys,
              selectedKeys = _props$selectedKeys === undefined ? [] : _props$selectedKeys,
              _props$targetKeys = props.targetKeys,
              targetKeys = _props$targetKeys === undefined ? [] : _props$targetKeys;
          _this.state = {
            leftFilter: '',
            rightFilter: '',
            sourceSelectedKeys: selectedKeys.filter(function (key) {
              return targetKeys.indexOf(key) === -1;
            }),
            targetSelectedKeys: selectedKeys.filter(function (key) {
              return targetKeys.indexOf(key) > -1;
            })
          };
          return _this;
        }

        createClass_default()(Transfer, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var _state = this.state,
                sourceSelectedKeys = _state.sourceSelectedKeys,
                targetSelectedKeys = _state.targetSelectedKeys;

            if (nextProps.targetKeys !== this.props.targetKeys || nextProps.dataSource !== this.props.dataSource) {
              // clear cached splited dataSource
              this.splitedDataSource = null;

              if (!nextProps.selectedKeys) {
                // clear key nolonger existed
                // clear checkedKeys according to targetKeys
                var dataSource = nextProps.dataSource,
                    _nextProps$targetKeys = nextProps.targetKeys,
                    targetKeys = _nextProps$targetKeys === undefined ? [] : _nextProps$targetKeys;
                var newSourceSelectedKeys = [];
                var newTargetSelectedKeys = [];
                dataSource.forEach(function (_ref) {
                  var key = _ref.key;

                  if (sourceSelectedKeys.includes(key) && !targetKeys.includes(key)) {
                    newSourceSelectedKeys.push(key);
                  }

                  if (targetSelectedKeys.includes(key) && targetKeys.includes(key)) {
                    newTargetSelectedKeys.push(key);
                  }
                });
                this.setState({
                  sourceSelectedKeys: newSourceSelectedKeys,
                  targetSelectedKeys: newTargetSelectedKeys
                });
              }
            }

            if (nextProps.selectedKeys) {
              var _targetKeys = nextProps.targetKeys || [];

              this.setState({
                sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) {
                  return !_targetKeys.includes(key);
                }),
                targetSelectedKeys: nextProps.selectedKeys.filter(function (key) {
                  return _targetKeys.includes(key);
                })
              });
            }
          }
        }, {
          key: 'splitDataSource',
          value: function splitDataSource(props) {
            if (this.splitedDataSource) {
              return this.splitedDataSource;
            }

            var dataSource = props.dataSource,
                rowKey = props.rowKey,
                _props$targetKeys2 = props.targetKeys,
                targetKeys = _props$targetKeys2 === undefined ? [] : _props$targetKeys2;
            var leftDataSource = [];
            var rightDataSource = new Array(targetKeys.length);
            dataSource.forEach(function (record) {
              if (rowKey) {
                record.key = rowKey(record);
              } // rightDataSource should be ordered by targetKeys
              // leftDataSource should be ordered by dataSource


              var indexOfKey = targetKeys.indexOf(record.key);

              if (indexOfKey !== -1) {
                rightDataSource[indexOfKey] = record;
              } else {
                leftDataSource.push(record);
              }
            });
            this.splitedDataSource = {
              leftDataSource: leftDataSource,
              rightDataSource: rightDataSource
            };
            return this.splitedDataSource;
          }
        }, {
          key: 'handleSelectChange',
          value: function handleSelectChange(direction, holder) {
            var _state2 = this.state,
                sourceSelectedKeys = _state2.sourceSelectedKeys,
                targetSelectedKeys = _state2.targetSelectedKeys;
            var onSelectChange = this.props.onSelectChange;

            if (!onSelectChange) {
              return;
            }

            if (direction === 'left') {
              onSelectChange(holder, targetSelectedKeys);
            } else {
              onSelectChange(sourceSelectedKeys, holder);
            }
          }
        }, {
          key: 'getTitles',
          value: function getTitles(transferLocale) {
            var props = this.props;

            if (props.titles) {
              return props.titles;
            }

            return transferLocale.titles;
          }
        }, {
          key: 'getSelectedKeysName',
          value: function getSelectedKeysName(direction) {
            return direction === 'left' ? 'sourceSelectedKeys' : 'targetSelectedKeys';
          }
        }, {
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
              componentName: 'Transfer',
              defaultLocale: locale_provider_default.Transfer
            }, this.renderTransfer);
          }
        }]);
        return Transfer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]); // For high-level customized Transfer @dqaria

      /* harmony default export */


      var transfer = transfer_Transfer;
      transfer_Transfer.List = transfer_list;
      transfer_Transfer.Operation = operation;
      transfer_Transfer.Search = transfer_search;
      transfer_Transfer.defaultProps = {
        dataSource: [],
        render: transfer_noop,
        showSearch: false
      };
      transfer_Transfer.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        dataSource: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        render: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        targetKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        height: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        listStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        titles: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        operations: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        showSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        filterOption: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        searchPlaceholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        notFoundContent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        body: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        footer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        rowKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        lazy: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool])
      }; // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectDestructuringEmpty.js

      var objectDestructuringEmpty = __webpack_require__(701);

      var objectDestructuringEmpty_default =
      /*#__PURE__*/
      __webpack_require__.n(objectDestructuringEmpty); // CONCATENATED MODULE: ./node_modules/rc-tree/es/util.js

      /* eslint no-loop-func: 0*/


      var util_DRAG_SIDE_RANGE = 0.25;
      var util_DRAG_MIN_GAP = 2;

      function util_arrDel(list, value) {
        var clone = list.slice();
        var index = clone.indexOf(value);

        if (index >= 0) {
          clone.splice(index, 1);
        }

        return clone;
      }

      function util_arrAdd(list, value) {
        var clone = list.slice();

        if (clone.indexOf(value) === -1) {
          clone.push(value);
        }

        return clone;
      }

      function util_posToArr(pos) {
        return pos.split('-');
      }

      function util_getPosition(level, index) {
        return level + '-' + index;
      }

      function util_getNodeChildren(children) {
        var childList = Array.isArray(children) ? children : [children];
        return childList.filter(function (child) {
          return child && child.type && child.type.isTreeNode;
        });
      }

      function util_isCheckDisabled(node) {
        var _ref = node.props || {},
            disabled = _ref.disabled,
            disableCheckbox = _ref.disableCheckbox;

        return !!(disabled || disableCheckbox);
      }

      function util_traverseTreeNodes(treeNodes, subTreeData, callback) {
        if (typeof subTreeData === 'function') {
          callback = subTreeData;
          subTreeData = false;
        }

        function processNode(node, index, parent) {
          var children = node ? node.props.children : treeNodes;
          var pos = node ? util_getPosition(parent.pos, index) : 0; // Filter children

          var childList = util_getNodeChildren(children); // Process node if is not root

          if (node) {
            var data = {
              node: node,
              index: index,
              pos: pos,
              key: node.key || pos,
              parentPos: parent.node ? parent.pos : null
            }; // Children data is not must have

            if (subTreeData) {
              // Statistic children
              var subNodes = [];
              external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(childList, function (subNode, subIndex) {
                // Provide limit snapshot
                var subPos = util_getPosition(pos, index);
                subNodes.push({
                  node: subNode,
                  key: subNode.key || subPos,
                  pos: subPos,
                  index: subIndex
                });
              });
              data.subNodes = subNodes;
            } // Can break traverse by return false


            if (callback(data) === false) {
              return;
            }
          } // Process children node


          external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(childList, function (subNode, subIndex) {
            processNode(subNode, subIndex, {
              node: node,
              pos: pos
            });
          });
        }

        processNode(null);
      }
      /**
       * [Legacy] Return halfChecked when it has value.
       * @param checkedKeys
       * @param halfChecked
       * @returns {*}
       */


      function util_getStrictlyValue(checkedKeys, halfChecked) {
        if (halfChecked) {
          return {
            checked: checkedKeys,
            halfChecked: halfChecked
          };
        }

        return checkedKeys;
      }

      function util_getFullKeyList(treeNodes) {
        var keyList = [];
        util_traverseTreeNodes(treeNodes, function (_ref2) {
          var key = _ref2.key;
          keyList.push(key);
        });
        return keyList;
      }
      /**
       * Check position relation.
       * @param parentPos
       * @param childPos
       * @param directly only directly parent can be true
       * @returns {boolean}
       */


      function util_isParent(parentPos, childPos) {
        var directly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        if (!parentPos || !childPos || parentPos.length > childPos.length) return false;
        var parentPath = util_posToArr(parentPos);
        var childPath = util_posToArr(childPos); // Directly check

        if (directly && parentPath.length !== childPath.length - 1) return false;
        var len = parentPath.length;

        for (var i = 0; i < len; i += 1) {
          if (parentPath[i] !== childPath[i]) return false;
        }

        return true;
      }
      /**
       * Statistic TreeNodes info
       * @param treeNodes
       * @returns {{}}
       */


      function util_getNodesStatistic(treeNodes) {
        var statistic = {
          keyNodes: {},
          posNodes: {},
          nodeList: []
        };
        util_traverseTreeNodes(treeNodes, true, function (_ref3) {
          var node = _ref3.node,
              index = _ref3.index,
              pos = _ref3.pos,
              key = _ref3.key,
              subNodes = _ref3.subNodes,
              parentPos = _ref3.parentPos;
          var data = {
            node: node,
            index: index,
            pos: pos,
            key: key,
            subNodes: subNodes,
            parentPos: parentPos
          };
          statistic.keyNodes[key] = data;
          statistic.posNodes[pos] = data;
          statistic.nodeList.push(data);
        });
        return statistic;
      }

      function util_getDragNodesKeys(treeNodes, node) {
        var _node$props = node.props,
            eventKey = _node$props.eventKey,
            pos = _node$props.pos;
        var dragNodesKeys = [];
        util_traverseTreeNodes(treeNodes, function (_ref4) {
          var nodePos = _ref4.pos,
              key = _ref4.key;

          if (util_isParent(pos, nodePos)) {
            dragNodesKeys.push(key);
          }
        });
        dragNodesKeys.push(eventKey || pos);
        return dragNodesKeys;
      } // Only used when drag, not affect SSR.


      function util_calcDropPosition(event, treeNode) {
        var clientY = event.clientY;

        var _treeNode$selectHandl = treeNode.selectHandle.getBoundingClientRect(),
            top = _treeNode$selectHandl.top,
            bottom = _treeNode$selectHandl.bottom,
            height = _treeNode$selectHandl.height;

        var des = Math.max(height * util_DRAG_SIDE_RANGE, util_DRAG_MIN_GAP);

        if (clientY <= top + des) {
          return -1;
        } else if (clientY >= bottom - des) {
          return 1;
        }

        return 0;
      }
      /**
       * Auto expand all related node when sub node is expanded
       * @param keyList
       * @param props
       * @returns [string]
       */


      function util_calcExpandedKeys(keyList, props) {
        if (!keyList) {
          return [];
        }

        var children = props.children; // Fill parent expanded keys

        var _getNodesStatistic = util_getNodesStatistic(children),
            keyNodes = _getNodesStatistic.keyNodes,
            nodeList = _getNodesStatistic.nodeList;

        var needExpandKeys = {};
        var needExpandPathList = []; // Fill expanded nodes

        keyList.forEach(function (key) {
          var node = keyNodes[key];

          if (node) {
            needExpandKeys[key] = true;
            needExpandPathList.push(node.pos);
          }
        }); // Match parent by path

        nodeList.forEach(function (_ref5) {
          var pos = _ref5.pos,
              key = _ref5.key;

          if (needExpandPathList.some(function (childPos) {
            return util_isParent(pos, childPos);
          })) {
            needExpandKeys[key] = true;
          }
        });
        var calcExpandedKeyList = Object.keys(needExpandKeys); // [Legacy] Return origin keyList if calc list is empty

        return calcExpandedKeyList.length ? calcExpandedKeyList : keyList;
      }
      /**
       * Return selectedKeys according with multiple prop
       * @param selectedKeys
       * @param props
       * @returns [string]
       */


      function util_calcSelectedKeys(selectedKeys, props) {
        if (!selectedKeys) {
          return undefined;
        }

        var multiple = props.multiple;

        if (multiple) {
          return selectedKeys.slice();
        }

        if (selectedKeys.length) {
          return [selectedKeys[0]];
        }

        return selectedKeys;
      }
      /**
       * Check conduct is by key level. It pass though up & down.
       * When conduct target node is check means already conducted will be skip.
       * @param treeNodes
       * @param checkedKeys
       * @returns {{checkedKeys: Array, halfCheckedKeys: Array}}
       */


      function util_calcCheckStateConduct(treeNodes, checkedKeys) {
        var _getNodesStatistic2 = util_getNodesStatistic(treeNodes),
            keyNodes = _getNodesStatistic2.keyNodes,
            posNodes = _getNodesStatistic2.posNodes;

        var tgtCheckedKeys = {};
        var tgtHalfCheckedKeys = {}; // Conduct up

        function conductUp(key, halfChecked) {
          if (tgtCheckedKeys[key]) return;
          var _keyNodes$key = keyNodes[key],
              _keyNodes$key$subNode = _keyNodes$key.subNodes,
              subNodes = _keyNodes$key$subNode === undefined ? [] : _keyNodes$key$subNode,
              parentPos = _keyNodes$key.parentPos,
              node = _keyNodes$key.node;
          if (util_isCheckDisabled(node)) return;
          var allSubChecked = !halfChecked && subNodes.filter(function (sub) {
            return !util_isCheckDisabled(sub.node);
          }).every(function (sub) {
            return tgtCheckedKeys[sub.key];
          });

          if (allSubChecked) {
            tgtCheckedKeys[key] = true;
          } else {
            tgtHalfCheckedKeys[key] = true;
          }

          if (parentPos !== null) {
            conductUp(posNodes[parentPos].key, !allSubChecked);
          }
        } // Conduct down


        function conductDown(key) {
          if (tgtCheckedKeys[key]) return;
          var _keyNodes$key2 = keyNodes[key],
              _keyNodes$key2$subNod = _keyNodes$key2.subNodes,
              subNodes = _keyNodes$key2$subNod === undefined ? [] : _keyNodes$key2$subNod,
              node = _keyNodes$key2.node;
          if (util_isCheckDisabled(node)) return;
          tgtCheckedKeys[key] = true;
          subNodes.forEach(function (sub) {
            conductDown(sub.key);
          });
        }

        function conduct(key) {
          if (!keyNodes[key]) {
            browser_default()(false, '\'' + key + '\' does not exist in the tree.');
            return;
          }

          var _keyNodes$key3 = keyNodes[key],
              _keyNodes$key3$subNod = _keyNodes$key3.subNodes,
              subNodes = _keyNodes$key3$subNod === undefined ? [] : _keyNodes$key3$subNod,
              parentPos = _keyNodes$key3.parentPos,
              node = _keyNodes$key3.node;
          tgtCheckedKeys[key] = true;
          if (util_isCheckDisabled(node)) return; // Conduct down

          subNodes.filter(function (sub) {
            return !util_isCheckDisabled(sub.node);
          }).forEach(function (sub) {
            conductDown(sub.key);
          }); // Conduct up

          if (parentPos !== null) {
            conductUp(posNodes[parentPos].key);
          }
        }

        checkedKeys.forEach(function (key) {
          conduct(key);
        });
        return {
          checkedKeys: Object.keys(tgtCheckedKeys),
          halfCheckedKeys: Object.keys(tgtHalfCheckedKeys).filter(function (key) {
            return !tgtCheckedKeys[key];
          })
        };
      }
      /**
       * Calculate the value of checked and halfChecked keys.
       * This should be only run in init or props changed.
       */


      function util_calcCheckedKeys(keys, props) {
        var checkable = props.checkable,
            children = props.children,
            checkStrictly = props.checkStrictly;

        if (!checkable || !keys) {
          return null;
        } // Convert keys to object format


        var keyProps = void 0;

        if (Array.isArray(keys)) {
          // [Legacy] Follow the api doc
          keyProps = {
            checkedKeys: keys,
            halfCheckedKeys: undefined
          };
        } else if (typeof keys === 'object') {
          keyProps = {
            checkedKeys: keys.checked || undefined,
            halfCheckedKeys: keys.halfChecked || undefined
          };
        } else {
          browser_default()(false, '`CheckedKeys` is not an array or an object');
          return null;
        } // Do nothing if is checkStrictly mode


        if (checkStrictly) {
          return keyProps;
        } // Conduct calculate the check status


        var _keyProps = keyProps,
            _keyProps$checkedKeys = _keyProps.checkedKeys,
            checkedKeys = _keyProps$checkedKeys === undefined ? [] : _keyProps$checkedKeys;
        return util_calcCheckStateConduct(children, checkedKeys);
      } // CONCATENATED MODULE: ./node_modules/rc-tree/es/Tree.js

      /**
       * Thought we still use `cloneElement` to pass `key`,
       * other props can pass with context for future refactor.
       */


      var Tree_contextTypes = {
        rcTree: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          root: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          selectable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          showIcon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          icon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
          draggable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          checkable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node]),
          checkStrictly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          openTransitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          openAnimation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
          loadData: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          filterTreeNode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          renderTreeNode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          isKeyChecked: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeExpand: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeContextMenu: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeDragStart: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeDragEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeDragOver: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeDragLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeDragEnd: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onNodeDrop: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onBatchNodeCheck: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onCheckConductFinished: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        })
      };

      var Tree_Tree = function (_React$Component) {
        inherits_default()(Tree, _React$Component);

        function Tree(props) {
          classCallCheck_default()(this, Tree);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          Tree_initialiseProps.call(_this);
          var defaultExpandAll = props.defaultExpandAll,
              defaultExpandParent = props.defaultExpandParent,
              defaultExpandedKeys = props.defaultExpandedKeys,
              defaultCheckedKeys = props.defaultCheckedKeys,
              defaultSelectedKeys = props.defaultSelectedKeys,
              expandedKeys = props.expandedKeys; // Sync state with props

          var _ref = util_calcCheckedKeys(defaultCheckedKeys, props) || {},
              _ref$checkedKeys = _ref.checkedKeys,
              checkedKeys = _ref$checkedKeys === undefined ? [] : _ref$checkedKeys,
              _ref$halfCheckedKeys = _ref.halfCheckedKeys,
              halfCheckedKeys = _ref$halfCheckedKeys === undefined ? [] : _ref$halfCheckedKeys;

          var state = {
            selectedKeys: util_calcSelectedKeys(defaultSelectedKeys, props),
            checkedKeys: checkedKeys,
            halfCheckedKeys: halfCheckedKeys
          };

          if (defaultExpandAll) {
            state.expandedKeys = util_getFullKeyList(props.children);
          } else if (defaultExpandParent) {
            state.expandedKeys = util_calcExpandedKeys(expandedKeys || defaultExpandedKeys, props);
          } else {
            state.expandedKeys = defaultExpandedKeys;
          }

          _this.state = extends_default()({}, state, _this.getSyncProps(props) || {}); // Cache for check status to optimize

          _this.checkedBatch = null;
          return _this;
        }

        Tree.prototype.getChildContext = function getChildContext() {
          var _props = this.props,
              prefixCls = _props.prefixCls,
              selectable = _props.selectable,
              showIcon = _props.showIcon,
              icon = _props.icon,
              draggable = _props.draggable,
              checkable = _props.checkable,
              checkStrictly = _props.checkStrictly,
              disabled = _props.disabled,
              loadData = _props.loadData,
              filterTreeNode = _props.filterTreeNode,
              openTransitionName = _props.openTransitionName,
              openAnimation = _props.openAnimation;
          return {
            rcTree: {
              // root: this,
              prefixCls: prefixCls,
              selectable: selectable,
              showIcon: showIcon,
              icon: icon,
              draggable: draggable,
              checkable: checkable,
              checkStrictly: checkStrictly,
              disabled: disabled,
              openTransitionName: openTransitionName,
              openAnimation: openAnimation,
              loadData: loadData,
              filterTreeNode: filterTreeNode,
              renderTreeNode: this.renderTreeNode,
              isKeyChecked: this.isKeyChecked,
              onNodeExpand: this.onNodeExpand,
              onNodeSelect: this.onNodeSelect,
              onNodeMouseEnter: this.onNodeMouseEnter,
              onNodeMouseLeave: this.onNodeMouseLeave,
              onNodeContextMenu: this.onNodeContextMenu,
              onNodeDragStart: this.onNodeDragStart,
              onNodeDragEnter: this.onNodeDragEnter,
              onNodeDragOver: this.onNodeDragOver,
              onNodeDragLeave: this.onNodeDragLeave,
              onNodeDragEnd: this.onNodeDragEnd,
              onNodeDrop: this.onNodeDrop,
              onBatchNodeCheck: this.onBatchNodeCheck,
              onCheckConductFinished: this.onCheckConductFinished
            }
          };
        };

        Tree.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          var _this2 = this; // React 16 will not trigger update if new state is null


          this.setState(function (prevState) {
            return _this2.getSyncProps(nextProps, _this2.props, prevState);
          });
        };
        /**
         * [Legacy] Select handler is less small than node,
         * so that this will trigger when drag enter node or select handler.
         * This is a little tricky if customize css without padding.
         * Better for use mouse move event to refresh drag state.
         * But let's just keep it to avoid event trigger logic change.
         */

        /**
         * This will cache node check status to optimize update process.
         * When Tree get trigger `onCheckConductFinished` will flush all the update.
         */

        /**
         * When top `onCheckConductFinished` called, will execute all batch update.
         * And trigger `onCheck` event.
         */

        /**
         * Sync state with props if needed
         */

        /**
         * Only update the value which is not in props
         */

        /**
         * [Legacy] Original logic use `key` as tracking clue.
         * We have to use `cloneElement` to pass `key`.
         */


        Tree.prototype.render = function render() {
          var _classNames;

          var _props2 = this.props,
              prefixCls = _props2.prefixCls,
              className = _props2.className,
              focusable = _props2.focusable,
              showLine = _props2.showLine,
              children = _props2.children;
          var domProps = {}; // [Legacy] Commit: 0117f0c9db0e2956e92cb208f51a42387dfcb3d1

          if (focusable) {
            domProps.tabIndex = '0';
            domProps.onKeyDown = this.onKeyDown;
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', extends_default()({}, domProps, {
            className: classnames_default()(prefixCls, className, (_classNames = {}, _classNames[prefixCls + '-show-line'] = showLine, _classNames)),
            role: 'tree-node',
            unselectable: 'on'
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.map(children, this.renderTreeNode, this));
        };

        return Tree;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Tree_Tree.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        showLine: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showIcon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        icon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        focusable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        selectable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        checkable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node]),
        checkStrictly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        draggable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultExpandParent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        autoExpandParent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultExpandAll: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultExpandedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        expandedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        defaultCheckedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        checkedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string), external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        defaultSelectedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        selectedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        onExpand: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onCheck: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        loadData: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRightClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDragStart: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDragEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDragOver: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDragLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDragEnd: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDrop: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        filterTreeNode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        openTransitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        openAnimation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object])
      };
      Tree_Tree.childContextTypes = Tree_contextTypes;
      Tree_Tree.defaultProps = {
        prefixCls: 'rc-tree',
        showLine: false,
        showIcon: true,
        selectable: true,
        multiple: false,
        checkable: false,
        disabled: false,
        checkStrictly: false,
        draggable: false,
        defaultExpandParent: true,
        autoExpandParent: false,
        defaultExpandAll: false,
        defaultExpandedKeys: [],
        defaultCheckedKeys: [],
        defaultSelectedKeys: [],
        onExpand: null,
        onCheck: null,
        onSelect: null,
        onDragStart: null,
        onDragEnter: null,
        onDragOver: null,
        onDragLeave: null,
        onDrop: null,
        onDragEnd: null,
        onMouseEnter: null,
        onMouseLeave: null
      };

      var Tree_initialiseProps = function _initialiseProps() {
        var _this3 = this;

        this.onNodeDragStart = function (event, node) {
          var expandedKeys = _this3.state.expandedKeys;
          var onDragStart = _this3.props.onDragStart;
          var _node$props = node.props,
              eventKey = _node$props.eventKey,
              children = _node$props.children;
          _this3.dragNode = node;

          _this3.setState({
            dragNodesKeys: util_getDragNodesKeys(children, node),
            expandedKeys: util_arrDel(expandedKeys, eventKey)
          });

          if (onDragStart) {
            onDragStart({
              event: event,
              node: node
            });
          }
        };

        this.onNodeDragEnter = function (event, node) {
          var expandedKeys = _this3.state.expandedKeys;
          var onDragEnter = _this3.props.onDragEnter;
          var _node$props2 = node.props,
              pos = _node$props2.pos,
              eventKey = _node$props2.eventKey;
          var dropPosition = util_calcDropPosition(event, node); // Skip if drag node is self

          if (_this3.dragNode.props.eventKey === eventKey && dropPosition === 0) {
            _this3.setState({
              dragOverNodeKey: '',
              dropPosition: null
            });

            return;
          } // Ref: https://github.com/react-component/tree/issues/132
          // Add timeout to let onDragLevel fire before onDragEnter,
          // so that we can clean drag props for onDragLeave node.
          // Macro task for this:
          // https://html.spec.whatwg.org/multipage/webappapis.html#clean-up-after-running-script


          setTimeout(function () {
            // Update drag over node
            _this3.setState({
              dragOverNodeKey: eventKey,
              dropPosition: dropPosition
            }); // Side effect for delay drag


            if (!_this3.delayedDragEnterLogic) {
              _this3.delayedDragEnterLogic = {};
            }

            Object.keys(_this3.delayedDragEnterLogic).forEach(function (key) {
              clearTimeout(_this3.delayedDragEnterLogic[key]);
            });
            _this3.delayedDragEnterLogic[pos] = setTimeout(function () {
              var newExpandedKeys = util_arrAdd(expandedKeys, eventKey);

              _this3.setState({
                expandedKeys: newExpandedKeys
              });

              if (onDragEnter) {
                onDragEnter({
                  event: event,
                  node: node,
                  expandedKeys: newExpandedKeys
                });
              }
            }, 400);
          }, 0);
        };

        this.onNodeDragOver = function (event, node) {
          var onDragOver = _this3.props.onDragOver;
          var eventKey = node.props.eventKey; // Update drag position

          if (_this3.dragNode && eventKey === _this3.state.dragOverNodeKey) {
            var dropPosition = util_calcDropPosition(event, node);
            if (dropPosition === _this3.state.dropPosition) return;

            _this3.setState({
              dropPosition: dropPosition
            });
          }

          if (onDragOver) {
            onDragOver({
              event: event,
              node: node
            });
          }
        };

        this.onNodeDragLeave = function (event, node) {
          var onDragLeave = _this3.props.onDragLeave;

          _this3.setState({
            dragOverNodeKey: ''
          });

          if (onDragLeave) {
            onDragLeave({
              event: event,
              node: node
            });
          }
        };

        this.onNodeDragEnd = function (event, node) {
          var onDragEnd = _this3.props.onDragEnd;

          _this3.setState({
            dragOverNodeKey: ''
          });

          if (onDragEnd) {
            onDragEnd({
              event: event,
              node: node
            });
          }
        };

        this.onNodeDrop = function (event, node) {
          var _state = _this3.state,
              dragNodesKeys = _state.dragNodesKeys,
              dropPosition = _state.dropPosition;
          var onDrop = _this3.props.onDrop;
          var _node$props3 = node.props,
              eventKey = _node$props3.eventKey,
              pos = _node$props3.pos;

          _this3.setState({
            dragOverNodeKey: '',
            dropNodeKey: eventKey
          });

          if (dragNodesKeys.indexOf(eventKey) !== -1) {
            browser_default()(false, 'Can not drop to dragNode(include it\'s children node)');
            return;
          }

          var posArr = util_posToArr(pos);
          var dropResult = {
            event: event,
            node: node,
            dragNode: _this3.dragNode,
            dragNodesKeys: dragNodesKeys.slice(),
            dropPosition: dropPosition + Number(posArr[posArr.length - 1])
          };

          if (dropPosition !== 0) {
            dropResult.dropToGap = true;
          }

          if (onDrop) {
            onDrop(dropResult);
          }
        };

        this.onNodeSelect = function (e, treeNode) {
          var selectedKeys = _this3.state.selectedKeys;
          var _props3 = _this3.props,
              onSelect = _props3.onSelect,
              multiple = _props3.multiple,
              children = _props3.children;
          var _treeNode$props = treeNode.props,
              selected = _treeNode$props.selected,
              eventKey = _treeNode$props.eventKey;
          var targetSelected = !selected; // Update selected keys

          if (!targetSelected) {
            selectedKeys = util_arrDel(selectedKeys, eventKey);
          } else if (!multiple) {
            selectedKeys = [eventKey];
          } else {
            selectedKeys = util_arrAdd(selectedKeys, eventKey);
          } // [Legacy] Not found related usage in doc or upper libs
          // [Legacy] TODO: add optimize prop to skip node process


          var selectedNodes = [];

          if (selectedKeys.length) {
            util_traverseTreeNodes(children, function (_ref2) {
              var node = _ref2.node,
                  key = _ref2.key;

              if (selectedKeys.indexOf(key) !== -1) {
                selectedNodes.push(node);
              }
            });
          }

          _this3.setUncontrolledState({
            selectedKeys: selectedKeys
          });

          if (onSelect) {
            var eventObj = {
              event: 'select',
              selected: targetSelected,
              node: treeNode,
              selectedNodes: selectedNodes
            };
            onSelect(selectedKeys, eventObj);
          }
        };

        this.onBatchNodeCheck = function (key, checked, halfChecked, startNode) {
          if (startNode) {
            _this3.checkedBatch = {
              treeNode: startNode,
              checked: checked,
              list: []
            };
          } // This code should never called


          if (!_this3.checkedBatch) {
            _this3.checkedBatch = {
              list: []
            };
            browser_default()(false, 'Checked batch not init. This should be a bug. Please fire a issue.');
          }

          _this3.checkedBatch.list.push({
            key: key,
            checked: checked,
            halfChecked: halfChecked
          });
        };

        this.onCheckConductFinished = function () {
          var _state2 = _this3.state,
              checkedKeys = _state2.checkedKeys,
              halfCheckedKeys = _state2.halfCheckedKeys;
          var _props4 = _this3.props,
              onCheck = _props4.onCheck,
              checkStrictly = _props4.checkStrictly,
              children = _props4.children; // Use map to optimize update speed

          var checkedKeySet = {};
          var halfCheckedKeySet = {};
          checkedKeys.forEach(function (key) {
            checkedKeySet[key] = true;
          });
          halfCheckedKeys.forEach(function (key) {
            halfCheckedKeySet[key] = true;
          }); // Batch process

          _this3.checkedBatch.list.forEach(function (_ref3) {
            var key = _ref3.key,
                checked = _ref3.checked,
                halfChecked = _ref3.halfChecked;
            checkedKeySet[key] = checked;
            halfCheckedKeySet[key] = halfChecked;
          });

          var newCheckedKeys = Object.keys(checkedKeySet).filter(function (key) {
            return checkedKeySet[key];
          });
          var newHalfCheckedKeys = Object.keys(halfCheckedKeySet).filter(function (key) {
            return halfCheckedKeySet[key];
          }); // Trigger onChecked

          var selectedObj = void 0;
          var eventObj = {
            event: 'check',
            node: _this3.checkedBatch.treeNode,
            checked: _this3.checkedBatch.checked
          };

          if (checkStrictly) {
            selectedObj = util_getStrictlyValue(newCheckedKeys, newHalfCheckedKeys); // [Legacy] TODO: add optimize prop to skip node process

            eventObj.checkedNodes = [];
            util_traverseTreeNodes(children, function (_ref4) {
              var node = _ref4.node,
                  key = _ref4.key;

              if (checkedKeySet[key]) {
                eventObj.checkedNodes.push(node);
              }
            });

            _this3.setUncontrolledState({
              checkedKeys: newCheckedKeys
            });
          } else {
            selectedObj = newCheckedKeys; // [Legacy] TODO: add optimize prop to skip node process

            eventObj.checkedNodes = [];
            eventObj.checkedNodesPositions = []; // [Legacy] TODO: not in API

            eventObj.halfCheckedKeys = newHalfCheckedKeys; // [Legacy] TODO: not in API

            util_traverseTreeNodes(children, function (_ref5) {
              var node = _ref5.node,
                  pos = _ref5.pos,
                  key = _ref5.key;

              if (checkedKeySet[key]) {
                eventObj.checkedNodes.push(node);
                eventObj.checkedNodesPositions.push({
                  node: node,
                  pos: pos
                });
              }
            });

            _this3.setUncontrolledState({
              checkedKeys: newCheckedKeys,
              halfCheckedKeys: newHalfCheckedKeys
            });
          }

          if (onCheck) {
            onCheck(selectedObj, eventObj);
          } // Clean up


          _this3.checkedBatch = null;
        };

        this.onNodeExpand = function (e, treeNode) {
          var expandedKeys = _this3.state.expandedKeys;
          var _props5 = _this3.props,
              onExpand = _props5.onExpand,
              loadData = _props5.loadData;
          var _treeNode$props2 = treeNode.props,
              eventKey = _treeNode$props2.eventKey,
              expanded = _treeNode$props2.expanded; // Update selected keys

          var index = expandedKeys.indexOf(eventKey);
          var targetExpanded = !expanded;
          browser_default()(expanded && index !== -1 || !expanded && index === -1, 'Expand state not sync with index check');

          if (targetExpanded) {
            expandedKeys = util_arrAdd(expandedKeys, eventKey);
          } else {
            expandedKeys = util_arrDel(expandedKeys, eventKey);
          }

          _this3.setUncontrolledState({
            expandedKeys: expandedKeys
          });

          if (onExpand) {
            onExpand(expandedKeys, {
              node: treeNode,
              expanded: targetExpanded
            });
          } // Async Load data


          if (targetExpanded && loadData) {
            return loadData(treeNode).then(function () {
              // [Legacy] Refresh logic
              _this3.setUncontrolledState({
                expandedKeys: expandedKeys
              });
            });
          }

          return null;
        };

        this.onNodeMouseEnter = function (event, node) {
          var onMouseEnter = _this3.props.onMouseEnter;

          if (onMouseEnter) {
            onMouseEnter({
              event: event,
              node: node
            });
          }
        };

        this.onNodeMouseLeave = function (event, node) {
          var onMouseLeave = _this3.props.onMouseLeave;

          if (onMouseLeave) {
            onMouseLeave({
              event: event,
              node: node
            });
          }
        };

        this.onNodeContextMenu = function (event, node) {
          var onRightClick = _this3.props.onRightClick;

          if (onRightClick) {
            event.preventDefault();
            onRightClick({
              event: event,
              node: node
            });
          }
        };

        this.getSyncProps = function () {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var prevProps = arguments[1];
          var preState = arguments[2];
          var needSync = false;
          var oriState = preState || _this3.state;
          var newState = {};
          var myPrevProps = prevProps || {};

          function checkSync(name) {
            if (props[name] !== myPrevProps[name]) {
              needSync = true;
              return true;
            }

            return false;
          } // Children change will affect check box status.
          // And no need to check when prev props not provided


          if (prevProps && checkSync('children')) {
            var newCheckedKeys = util_calcCheckedKeys(props.checkedKeys || oriState.checkedKeys, props);

            var _ref6 = newCheckedKeys || {},
                _ref6$checkedKeys = _ref6.checkedKeys,
                checkedKeys = _ref6$checkedKeys === undefined ? [] : _ref6$checkedKeys,
                _ref6$halfCheckedKeys = _ref6.halfCheckedKeys,
                halfCheckedKeys = _ref6$halfCheckedKeys === undefined ? [] : _ref6$halfCheckedKeys;

            newState.checkedKeys = checkedKeys;
            newState.halfCheckedKeys = halfCheckedKeys;
          } // Re-calculate when autoExpandParent or expandedKeys changed


          if (prevProps && (checkSync('autoExpandParent') || checkSync('expandedKeys'))) {
            newState.expandedKeys = props.autoExpandParent ? util_calcExpandedKeys(props.expandedKeys, props) : props.expandedKeys;
          }

          if (checkSync('selectedKeys')) {
            newState.selectedKeys = util_calcSelectedKeys(props.selectedKeys, props);
          }

          if (checkSync('checkedKeys')) {
            var _ref7 = util_calcCheckedKeys(props.checkedKeys, props) || {},
                _ref7$checkedKeys = _ref7.checkedKeys,
                _checkedKeys = _ref7$checkedKeys === undefined ? [] : _ref7$checkedKeys,
                _ref7$halfCheckedKeys = _ref7.halfCheckedKeys,
                _halfCheckedKeys = _ref7$halfCheckedKeys === undefined ? [] : _ref7$halfCheckedKeys;

            newState.checkedKeys = _checkedKeys;
            newState.halfCheckedKeys = _halfCheckedKeys;
          }

          return needSync ? newState : null;
        };

        this.setUncontrolledState = function (state) {
          var needSync = false;
          var newState = {};
          Object.keys(state).forEach(function (name) {
            if (name in _this3.props) return;
            needSync = true;
            newState[name] = state[name];
          });

          if (needSync) {
            _this3.setState(newState);
          }
        };

        this.isKeyChecked = function (key) {
          var _state$checkedKeys = _this3.state.checkedKeys,
              checkedKeys = _state$checkedKeys === undefined ? [] : _state$checkedKeys;
          return checkedKeys.indexOf(key) !== -1;
        };

        this.renderTreeNode = function (child, index) {
          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          var _state3 = _this3.state,
              _state3$expandedKeys = _state3.expandedKeys,
              expandedKeys = _state3$expandedKeys === undefined ? [] : _state3$expandedKeys,
              _state3$selectedKeys = _state3.selectedKeys,
              selectedKeys = _state3$selectedKeys === undefined ? [] : _state3$selectedKeys,
              _state3$halfCheckedKe = _state3.halfCheckedKeys,
              halfCheckedKeys = _state3$halfCheckedKe === undefined ? [] : _state3$halfCheckedKe,
              dragOverNodeKey = _state3.dragOverNodeKey,
              dropPosition = _state3.dropPosition;
          objectDestructuringEmpty_default()(_this3.props);
          var pos = util_getPosition(level, index);
          var key = child.key || pos;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(child, {
            eventKey: key,
            expanded: expandedKeys.indexOf(key) !== -1,
            selected: selectedKeys.indexOf(key) !== -1,
            checked: _this3.isKeyChecked(key),
            halfChecked: halfCheckedKeys.indexOf(key) !== -1,
            pos: pos,
            // [Legacy] Drag props
            dragOver: dragOverNodeKey === key && dropPosition === 0,
            dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
            dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
          });
        };
      };
      /* harmony default export */


      var es_Tree = Tree_Tree; // EXTERNAL MODULE: ./node_modules/rc-util/es/Children/toArray.js

      var Children_toArray = __webpack_require__(118); // CONCATENATED MODULE: ./node_modules/rc-tree/es/TreeNode.js


      var TreeNode_ICON_OPEN = 'open';
      var TreeNode_ICON_CLOSE = 'close';
      var TreeNode_LOAD_STATUS_NONE = 0;
      var TreeNode_LOAD_STATUS_LOADING = 1;
      var TreeNode_LOAD_STATUS_LOADED = 2;
      var TreeNode_LOAD_STATUS_FAILED = 0; // Action align, let's make failed same as init.

      var TreeNode_defaultTitle = '---';
      var TreeNode_onlyTreeNodeWarned = false; // Only accept TreeNode

      var TreeNode_nodeContextTypes = extends_default()({}, Tree_contextTypes, {
        rcTreeNode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          onUpCheckConduct: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        })
      });

      var TreeNode_TreeNode = function (_React$Component) {
        inherits_default()(TreeNode, _React$Component);

        function TreeNode(props) {
          classCallCheck_default()(this, TreeNode);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          TreeNode_initialiseProps.call(_this);
          _this.state = {
            loadStatus: TreeNode_LOAD_STATUS_NONE,
            dragNodeHighlight: false
          };
          return _this;
        }

        TreeNode.prototype.getChildContext = function getChildContext() {
          return extends_default()({}, this.context, {
            rcTreeNode: {
              onUpCheckConduct: this.onUpCheckConduct
            }
          });
        }; // Isomorphic needn't load data in server side


        TreeNode.prototype.componentDidMount = function componentDidMount() {
          this.syncLoadData(this.props);
        };

        TreeNode.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          this.syncLoadData(nextProps);
        }; // Disabled item still can be switch
        // Drag usage


        TreeNode.prototype.isSelectable = function isSelectable() {
          var selectable = this.props.selectable;
          var treeSelectable = this.context.rcTree.selectable; // Ignore when selectable is undefined or null

          if (typeof selectable === 'boolean') {
            return selectable;
          }

          return treeSelectable;
        }; // Load data to avoid default expanded tree without data
        // Switcher
        // Checkbox
        // Icon + Title
        // Children list wrapped with `Animation`


        TreeNode.prototype.render = function render() {
          var _classNames;

          var _props = this.props,
              className = _props.className,
              dragOver = _props.dragOver,
              dragOverGapTop = _props.dragOverGapTop,
              dragOverGapBottom = _props.dragOverGapBottom;
          var _context$rcTree = this.context.rcTree,
              prefixCls = _context$rcTree.prefixCls,
              filterTreeNode = _context$rcTree.filterTreeNode;
          var disabled = this.isDisabled();
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
            className: classnames_default()(className, (_classNames = {}, _classNames[prefixCls + '-treenode-disabled'] = disabled, _classNames['drag-over'] = !disabled && dragOver, _classNames['drag-over-gap-top'] = !disabled && dragOverGapTop, _classNames['drag-over-gap-bottom'] = !disabled && dragOverGapBottom, _classNames['filter-node'] = filterTreeNode && filterTreeNode(this), _classNames)),
            onDragEnter: this.onDragEnter,
            onDragOver: this.onDragOver,
            onDragLeave: this.onDragLeave,
            onDrop: this.onDrop,
            onDragEnd: this.onDragEnd
          }, this.renderSwitcher(), this.renderCheckbox(), this.renderSelector(), this.renderChildren());
        };

        return TreeNode;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      TreeNode_TreeNode.propTypes = {
        eventKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // Pass by parent `cloneElement`
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        root: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        // By parent
        expanded: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        selected: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        checked: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        halfChecked: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        title: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        pos: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        dragOver: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        dragOverGapTop: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        dragOverGapBottom: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // By user
        isLeaf: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        selectable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disableCheckbox: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        icon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func])
      };
      TreeNode_TreeNode.contextTypes = TreeNode_nodeContextTypes;
      TreeNode_TreeNode.childContextTypes = TreeNode_nodeContextTypes;
      TreeNode_TreeNode.defaultProps = {
        title: TreeNode_defaultTitle
      };

      var TreeNode_initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.onUpCheckConduct = function (treeNode, nodeChecked, nodeHalfChecked) {
          var nodePos = treeNode.props.pos;
          var _props2 = _this2.props,
              eventKey = _props2.eventKey,
              pos = _props2.pos,
              checked = _props2.checked,
              halfChecked = _props2.halfChecked;
          var _context = _this2.context,
              _context$rcTree2 = _context.rcTree,
              checkStrictly = _context$rcTree2.checkStrictly,
              isKeyChecked = _context$rcTree2.isKeyChecked,
              onBatchNodeCheck = _context$rcTree2.onBatchNodeCheck,
              onCheckConductFinished = _context$rcTree2.onCheckConductFinished,
              _context$rcTreeNode = _context.rcTreeNode;
          _context$rcTreeNode = _context$rcTreeNode === undefined ? {} : _context$rcTreeNode;
          var onUpCheckConduct = _context$rcTreeNode.onUpCheckConduct; // Stop conduct when current node is disabled

          if (util_isCheckDisabled(_this2)) {
            onCheckConductFinished();
            return;
          }

          var children = _this2.getNodeChildren();

          var checkedCount = nodeChecked ? 1 : 0; // Statistic checked count

          children.forEach(function (node, index) {
            var childPos = util_getPosition(pos, index);

            if (nodePos === childPos || util_isCheckDisabled(node)) {
              return;
            }

            if (isKeyChecked(node.key || childPos)) {
              checkedCount += 1;
            }
          }); // Static enabled children count

          var enabledChildrenCount = children.filter(function (node) {
            return !util_isCheckDisabled(node);
          }).length; // checkStrictly will not conduct check status

          var nextChecked = checkStrictly ? checked : enabledChildrenCount === checkedCount;
          var nextHalfChecked = checkStrictly ? // propagated or child checked
          halfChecked : nodeHalfChecked || checkedCount > 0 && !nextChecked; // Add into batch update

          if (checked !== nextChecked || halfChecked !== nextHalfChecked) {
            onBatchNodeCheck(eventKey, nextChecked, nextHalfChecked);

            if (onUpCheckConduct) {
              onUpCheckConduct(_this2, nextChecked, nextHalfChecked);
            } else {
              // Flush all the update
              onCheckConductFinished();
            }
          } else {
            // Flush all the update
            onCheckConductFinished();
          }
        };

        this.onDownCheckConduct = function (nodeChecked) {
          var children = _this2.props.children;
          var _context$rcTree3 = _this2.context.rcTree,
              checkStrictly = _context$rcTree3.checkStrictly,
              isKeyChecked = _context$rcTree3.isKeyChecked,
              onBatchNodeCheck = _context$rcTree3.onBatchNodeCheck;
          if (checkStrictly) return;
          util_traverseTreeNodes(children, function (_ref) {
            var node = _ref.node,
                key = _ref.key;
            if (util_isCheckDisabled(node)) return false;

            if (nodeChecked !== isKeyChecked(key)) {
              onBatchNodeCheck(key, nodeChecked, false);
            }
          });
        };

        this.onSelectorClick = function (e) {
          if (_this2.isSelectable()) {
            _this2.onSelect(e);
          } else {
            _this2.onCheck(e);
          }
        };

        this.onSelect = function (e) {
          if (_this2.isDisabled()) return;
          var onNodeSelect = _this2.context.rcTree.onNodeSelect;
          e.preventDefault();
          onNodeSelect(e, _this2);
        };

        this.onCheck = function (e) {
          if (_this2.isDisabled()) return;
          var _props3 = _this2.props,
              disableCheckbox = _props3.disableCheckbox,
              checked = _props3.checked,
              eventKey = _props3.eventKey;
          var _context2 = _this2.context,
              _context2$rcTree = _context2.rcTree,
              checkable = _context2$rcTree.checkable,
              onBatchNodeCheck = _context2$rcTree.onBatchNodeCheck,
              onCheckConductFinished = _context2$rcTree.onCheckConductFinished,
              _context2$rcTreeNode = _context2.rcTreeNode;
          _context2$rcTreeNode = _context2$rcTreeNode === undefined ? {} : _context2$rcTreeNode;
          var onUpCheckConduct = _context2$rcTreeNode.onUpCheckConduct;
          if (!checkable || disableCheckbox) return;
          e.preventDefault();
          var targetChecked = !checked;
          onBatchNodeCheck(eventKey, targetChecked, false, _this2); // Children conduct

          _this2.onDownCheckConduct(targetChecked); // Parent conduct


          if (onUpCheckConduct) {
            onUpCheckConduct(_this2, targetChecked, false);
          } else {
            onCheckConductFinished();
          }
        };

        this.onMouseEnter = function (e) {
          var onNodeMouseEnter = _this2.context.rcTree.onNodeMouseEnter;
          onNodeMouseEnter(e, _this2);
        };

        this.onMouseLeave = function (e) {
          var onNodeMouseLeave = _this2.context.rcTree.onNodeMouseLeave;
          onNodeMouseLeave(e, _this2);
        };

        this.onContextMenu = function (e) {
          var onNodeContextMenu = _this2.context.rcTree.onNodeContextMenu;
          onNodeContextMenu(e, _this2);
        };

        this.onDragStart = function (e) {
          var onNodeDragStart = _this2.context.rcTree.onNodeDragStart;
          e.stopPropagation();

          _this2.setState({
            dragNodeHighlight: true
          });

          onNodeDragStart(e, _this2);

          try {
            // ie throw error
            // firefox-need-it
            e.dataTransfer.setData('text/plain', '');
          } catch (error) {// empty
          }
        };

        this.onDragEnter = function (e) {
          var onNodeDragEnter = _this2.context.rcTree.onNodeDragEnter;
          e.preventDefault();
          e.stopPropagation();
          onNodeDragEnter(e, _this2);
        };

        this.onDragOver = function (e) {
          var onNodeDragOver = _this2.context.rcTree.onNodeDragOver;
          e.preventDefault();
          e.stopPropagation();
          onNodeDragOver(e, _this2);
        };

        this.onDragLeave = function (e) {
          var onNodeDragLeave = _this2.context.rcTree.onNodeDragLeave;
          e.stopPropagation();
          onNodeDragLeave(e, _this2);
        };

        this.onDragEnd = function (e) {
          var onNodeDragEnd = _this2.context.rcTree.onNodeDragEnd;
          e.stopPropagation();

          _this2.setState({
            dragNodeHighlight: false
          });

          onNodeDragEnd(e, _this2);
        };

        this.onDrop = function (e) {
          var onNodeDrop = _this2.context.rcTree.onNodeDrop;
          e.preventDefault();
          e.stopPropagation();

          _this2.setState({
            dragNodeHighlight: false
          });

          onNodeDrop(e, _this2);
        };

        this.onExpand = function (e) {
          var onNodeExpand = _this2.context.rcTree.onNodeExpand;
          var callbackPromise = onNodeExpand(e, _this2); // Promise like

          if (callbackPromise && callbackPromise.then) {
            _this2.setState({
              loadStatus: TreeNode_LOAD_STATUS_LOADING
            });

            callbackPromise.then(function () {
              _this2.setState({
                loadStatus: TreeNode_LOAD_STATUS_LOADED
              });
            })['catch'](function () {
              _this2.setState({
                loadStatus: TreeNode_LOAD_STATUS_FAILED
              });
            });
          }
        };

        this.setSelectHandle = function (node) {
          _this2.selectHandle = node;
        };

        this.getNodeChildren = function () {
          var children = _this2.props.children;
          var originList = Object(Children_toArray["a"
          /* default */
          ])(children).filter(function (node) {
            return node;
          });
          var targetList = util_getNodeChildren(originList);

          if (originList.length !== targetList.length && !TreeNode_onlyTreeNodeWarned) {
            TreeNode_onlyTreeNodeWarned = true;
            browser_default()(false, 'Tree only accept TreeNode as children.');
          }

          return targetList;
        };

        this.getNodeState = function () {
          var expanded = _this2.props.expanded;

          if (_this2.isLeaf()) {
            return null;
          }

          return expanded ? TreeNode_ICON_OPEN : TreeNode_ICON_CLOSE;
        };

        this.isLeaf = function () {
          var loadStatus = _this2.state.loadStatus;
          var isLeaf = _this2.props.isLeaf;
          var loadData = _this2.context.rcTree.loadData;
          var hasChildren = _this2.getNodeChildren().length !== 0;
          return isLeaf || !loadData && !hasChildren || loadData && loadStatus === TreeNode_LOAD_STATUS_LOADED && !hasChildren;
        };

        this.isDisabled = function () {
          var disabled = _this2.props.disabled;
          var treeDisabled = _this2.context.rcTree.disabled; // Follow the logic of Selectable

          if (disabled === false) {
            return false;
          }

          return !!(treeDisabled || disabled);
        };

        this.syncLoadData = function (props) {
          var expanded = props.expanded;
          var loadData = _this2.context.rcTree.loadData; // read from state to avoid loadData at same time

          _this2.setState(function (_ref2) {
            var loadStatus = _ref2.loadStatus;

            if (loadData && loadStatus === TreeNode_LOAD_STATUS_NONE && expanded && !_this2.isLeaf()) {
              loadData(_this2).then(function () {
                _this2.setState({
                  loadStatus: TreeNode_LOAD_STATUS_LOADED
                });
              })['catch'](function () {
                _this2.setState({
                  loadStatus: TreeNode_LOAD_STATUS_FAILED
                });
              });
              return {
                loadStatus: TreeNode_LOAD_STATUS_LOADING
              };
            }

            return null;
          });
        };

        this.renderSwitcher = function () {
          var expanded = _this2.props.expanded;
          var prefixCls = _this2.context.rcTree.prefixCls;

          if (_this2.isLeaf()) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-switcher ' + prefixCls + '-switcher-noop'
            });
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: classnames_default()(prefixCls + '-switcher', prefixCls + '-switcher_' + (expanded ? TreeNode_ICON_OPEN : TreeNode_ICON_CLOSE)),
            onClick: _this2.onExpand
          });
        };

        this.renderCheckbox = function () {
          var _props4 = _this2.props,
              checked = _props4.checked,
              halfChecked = _props4.halfChecked,
              disableCheckbox = _props4.disableCheckbox;
          var _context$rcTree4 = _this2.context.rcTree,
              prefixCls = _context$rcTree4.prefixCls,
              checkable = _context$rcTree4.checkable;

          var disabled = _this2.isDisabled();

          if (!checkable) return null; // [Legacy] Custom element should be separate with `checkable` in future

          var $custom = typeof checkable !== 'boolean' ? checkable : null;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: classnames_default()(prefixCls + '-checkbox', checked && prefixCls + '-checkbox-checked', !checked && halfChecked && prefixCls + '-checkbox-indeterminate', (disabled || disableCheckbox) && prefixCls + '-checkbox-disabled'),
            onClick: _this2.onCheck
          }, $custom);
        };

        this.renderIcon = function () {
          var loadStatus = _this2.state.loadStatus;
          var prefixCls = _this2.context.rcTree.prefixCls;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: classnames_default()(prefixCls + '-iconEle', prefixCls + '-icon__' + (_this2.getNodeState() || 'docu'), loadStatus === TreeNode_LOAD_STATUS_LOADING && prefixCls + '-icon_loading')
          });
        };

        this.renderSelector = function () {
          var _state = _this2.state,
              loadStatus = _state.loadStatus,
              dragNodeHighlight = _state.dragNodeHighlight;
          var _props5 = _this2.props,
              title = _props5.title,
              selected = _props5.selected,
              icon = _props5.icon;
          var _context$rcTree5 = _this2.context.rcTree,
              prefixCls = _context$rcTree5.prefixCls,
              showIcon = _context$rcTree5.showIcon,
              treeIcon = _context$rcTree5.icon,
              draggable = _context$rcTree5.draggable,
              loadData = _context$rcTree5.loadData;

          var disabled = _this2.isDisabled();

          var wrapClass = prefixCls + '-node-content-wrapper'; // Icon - Still show loading icon when loading without showIcon

          var $icon = void 0;

          if (showIcon) {
            var currentIcon = icon || treeIcon;
            $icon = currentIcon ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: classnames_default()(prefixCls + '-iconEle', prefixCls + '-icon__customize')
            }, typeof currentIcon === 'function' ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(currentIcon, _this2.props) : currentIcon) : _this2.renderIcon();
          } else if (loadData && loadStatus === TreeNode_LOAD_STATUS_LOADING) {
            $icon = _this2.renderIcon();
          } // Title


          var $title = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: prefixCls + '-title'
          }, title);
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            ref: _this2.setSelectHandle,
            title: typeof title === 'string' ? title : '',
            className: classnames_default()('' + wrapClass, wrapClass + '-' + (_this2.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && prefixCls + '-node-selected', !disabled && draggable && 'draggable'),
            draggable: !disabled && draggable || undefined,
            'aria-grabbed': !disabled && draggable || undefined,
            onMouseEnter: _this2.onMouseEnter,
            onMouseLeave: _this2.onMouseLeave,
            onContextMenu: _this2.onContextMenu,
            onClick: _this2.onSelectorClick,
            onDragStart: _this2.onDragStart
          }, $icon, $title);
        };

        this.renderChildren = function () {
          var _props6 = _this2.props,
              expanded = _props6.expanded,
              pos = _props6.pos;
          var _context$rcTree6 = _this2.context.rcTree,
              prefixCls = _context$rcTree6.prefixCls,
              openTransitionName = _context$rcTree6.openTransitionName,
              openAnimation = _context$rcTree6.openAnimation,
              renderTreeNode = _context$rcTree6.renderTreeNode; // [Legacy] Animation control

          var renderFirst = _this2.renderFirst;
          _this2.renderFirst = 1;
          var transitionAppear = true;

          if (!renderFirst && expanded) {
            transitionAppear = false;
          }

          var animProps = {};

          if (openTransitionName) {
            animProps.transitionName = openTransitionName;
          } else if (typeof openAnimation === 'object') {
            animProps.animation = extends_default()({}, openAnimation);

            if (!transitionAppear) {
              delete animProps.animation.appear;
            }
          } // Children TreeNode


          var nodeList = _this2.getNodeChildren();

          if (nodeList.length === 0) {
            return null;
          }

          var $children = void 0;

          if (expanded) {
            $children = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', {
              className: classnames_default()(prefixCls + '-child-tree', expanded && prefixCls + '-child-tree-open'),
              'data-expanded': expanded
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.map(nodeList, function (node, index) {
              return renderTreeNode(node, index, pos);
            }));
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], extends_default()({}, animProps, {
            showProp: 'data-expanded',
            transitionAppear: transitionAppear,
            component: ''
          }), $children);
        };
      };

      TreeNode_TreeNode.isTreeNode = 1;
      /* harmony default export */

      var es_TreeNode = TreeNode_TreeNode; // CONCATENATED MODULE: ./node_modules/rc-tree/es/index.js

      es_Tree.TreeNode = es_TreeNode;
      /* harmony default export */

      var rc_tree_es = es_Tree; // CONCATENATED MODULE: ./node_modules/antd/es/tree/index.js

      var tree_Tree = function (_React$Component) {
        inherits_default()(Tree, _React$Component);

        function Tree() {
          classCallCheck_default()(this, Tree);
          return possibleConstructorReturn_default()(this, (Tree.__proto__ || Object.getPrototypeOf(Tree)).apply(this, arguments));
        }

        createClass_default()(Tree, [{
          key: 'render',
          value: function render() {
            var props = this.props;
            var prefixCls = props.prefixCls,
                className = props.className;
            var checkable = props.checkable;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_tree_es, extends_default()({}, props, {
              className: className,
              checkable: checkable ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: prefixCls + '-checkbox-inner'
              }) : checkable
            }), this.props.children);
          }
        }]);
        return Tree;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_tree = tree_Tree;
      tree_Tree.TreeNode = es_TreeNode;
      tree_Tree.defaultProps = {
        prefixCls: 'ant-tree',
        checkable: false,
        showIcon: false,
        openAnimation: _util_openAnimation
      }; // CONCATENATED MODULE: ./node_modules/rc-tree-select/es/util.js

      /* eslint no-loop-func: 0*/

      function util_toTitle(title) {
        if (typeof title === 'string') {
          return title;
        }

        return null;
      }

      function util_getValuePropValue(child) {
        var props = child.props;

        if ('value' in props) {
          return props.value;
        }

        if (child.key) {
          return child.key;
        }

        throw new Error('no key or value for ' + child);
      }

      function util_getPropValue(child, prop) {
        if (prop === 'value') {
          return util_getValuePropValue(child);
        }

        return child.props[prop];
      }

      function util_isMultiple(props) {
        return !!(props.multiple || props.treeCheckable);
      }

      function util_toArray(value) {
        var ret = value;

        if (value === undefined) {
          ret = [];
        } else if (!Array.isArray(value)) {
          ret = [value];
        }

        return ret;
      }

      function util_preventDefaultEvent(e) {
        e.preventDefault();
      }

      var util_UNSELECTABLE_STYLE = {
        userSelect: 'none',
        WebkitUserSelect: 'none'
      };
      var util_UNSELECTABLE_ATTRIBUTE = {
        unselectable: 'unselectable'
      };

      function util_labelCompatible(prop) {
        var newProp = prop;

        if (newProp === 'label') {
          newProp = 'title';
        }

        return newProp;
      }

      function util_isInclude(smallArray, bigArray) {
        // attention: [0,0,1] [0,0,10]
        return smallArray.every(function (ii, i) {
          return ii === bigArray[i];
        });
      }

      function util_isPositionPrefix(smallPos, bigPos) {
        if (!bigPos || !smallPos) {
          // console.log(smallPos, bigPos);
          return false;
        }

        if (bigPos.length < smallPos.length) {
          return false;
        } // attention: "0-0-1" "0-0-10"


        if (bigPos.length > smallPos.length && bigPos.charAt(smallPos.length) !== '-') {
          return false;
        }

        return bigPos.substr(0, smallPos.length) === smallPos;
      }
      /*
      export function getCheckedKeys(node, checkedKeys, allCheckedNodesKeys) {
        const nodeKey = node.props.eventKey;
        let newCks = [...checkedKeys];
        let nodePos;
        const unCheck = allCheckedNodesKeys.some(item => {
          if (item.key === nodeKey) {
            nodePos = item.pos;
            return true;
          }
        });
        if (unCheck) {
          newCks = [];
          allCheckedNodesKeys.forEach(item => {
            if (isPositionPrefix(item.pos, nodePos) || isPositionPrefix(nodePos, item.pos)) {
              return;
            }
            newCks.push(item.key);
          });
        } else {
          newCks.push(nodeKey);
        }
        return newCks;
      }
      */


      function util_getChildrenlength(children) {
        var len = 1;

        if (Array.isArray(children)) {
          len = children.length;
        }

        return len;
      }

      function util_getSiblingPosition(index, len, siblingPosition) {
        if (len === 1) {
          siblingPosition.first = true;
          siblingPosition.last = true;
        } else {
          siblingPosition.first = index === 0;
          siblingPosition.last = index === len - 1;
        }

        return siblingPosition;
      }

      function util_loopAllChildren(childs, callback, parent) {
        var loop = function loop(children, level, _parent) {
          var len = util_getChildrenlength(children);
          external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.forEach(children, function handler(item, index) {
            // eslint-disable-line
            var pos = level + '-' + index;

            if (item && item.props.children && item.type) {
              loop(item.props.children, pos, {
                node: item,
                pos: pos
              });
            }

            if (item) {
              callback(item, index, pos, item.key || pos, util_getSiblingPosition(index, len, {}), _parent);
            }
          });
        };

        loop(childs, 0, parent);
      } // export function loopAllChildren(childs, callback) {
      //   const loop = (children, level) => {
      //     React.Children.forEach(children, (item, index) => {
      //       const pos = `${level}-${index}`;
      //       if (item && item.props.children) {
      //         loop(item.props.children, pos);
      //       }
      //       if (item) {
      //         callback(item, index, pos, getValuePropValue(item));
      //       }
      //     });
      //   };
      //   loop(childs, 0);
      // }
      // TODO: Here has the side effect. Update node children data affect.


      function util_flatToHierarchy(arr) {
        if (!arr.length) {
          return arr;
        }

        var hierarchyNodes = [];
        var levelObj = {};
        arr.forEach(function (item) {
          if (!item.pos) {
            return;
          }

          var posLen = item.pos.split('-').length;

          if (!levelObj[posLen]) {
            levelObj[posLen] = [];
          }

          levelObj[posLen].push(item);
        });
        var levelArr = Object.keys(levelObj).sort(function (a, b) {
          return b - a;
        }); // const s = Date.now();
        // todo: there are performance issues!

        levelArr.reduce(function (pre, cur) {
          if (cur && cur !== pre) {
            levelObj[pre].forEach(function (item) {
              var haveParent = false;
              levelObj[cur].forEach(function (ii) {
                if (util_isPositionPrefix(ii.pos, item.pos)) {
                  haveParent = true;

                  if (!ii.children) {
                    ii.children = [];
                  }

                  ii.children.push(item);
                }
              });

              if (!haveParent) {
                hierarchyNodes.push(item);
              }
            });
          }

          return cur;
        }); // console.log(Date.now() - s);

        return levelObj[levelArr[levelArr.length - 1]].concat(hierarchyNodes);
      } // arr.length === 628, use time: ~20ms


      function util_filterParentPosition(arr) {
        var levelObj = {};
        arr.forEach(function (item) {
          var posLen = item.split('-').length;

          if (!levelObj[posLen]) {
            levelObj[posLen] = [];
          }

          levelObj[posLen].push(item);
        });
        var levelArr = Object.keys(levelObj).sort();

        var _loop = function _loop(i) {
          if (levelArr[i + 1]) {
            levelObj[levelArr[i]].forEach(function (ii) {
              var _loop2 = function _loop2(j) {
                levelObj[levelArr[j]].forEach(function (_i, index) {
                  if (util_isPositionPrefix(ii, _i)) {
                    levelObj[levelArr[j]][index] = null;
                  }
                });
                levelObj[levelArr[j]] = levelObj[levelArr[j]].filter(function (p) {
                  return p;
                });
              };

              for (var j = i + 1; j < levelArr.length; j++) {
                _loop2(j);
              }
            });
          }
        };

        for (var i = 0; i < levelArr.length; i++) {
          _loop(i);
        }

        var nArr = [];
        levelArr.forEach(function (i) {
          nArr = nArr.concat(levelObj[i]);
        });
        return nArr;
      } // console.log(filterParentPosition(
      // ['0-2', '0-3-3', '0-10', '0-10-0', '0-0-1', '0-0', '0-1-1', '0-1']
      // ));


      function util_stripTail(str) {
        var arr = str.match(/(.+)(-[^-]+)$/);
        var st = '';

        if (arr && arr.length === 3) {
          st = arr[1];
        }

        return st;
      }

      function util_splitPosition(pos) {
        return pos.split('-');
      } // todo: do optimization.


      function util_handleCheckState(obj, checkedPositionArr, checkIt) {
        // console.log(stripTail('0-101-000'));
        // let s = Date.now();
        var objKeys = Object.keys(obj);
        objKeys.forEach(function (i, index) {
          var iArr = util_splitPosition(i);
          var saved = false;
          checkedPositionArr.forEach(function (_pos) {
            var _posArr = util_splitPosition(_pos);

            if (iArr.length > _posArr.length && util_isInclude(_posArr, iArr)) {
              obj[i].halfChecked = false;
              obj[i].checked = checkIt;
              objKeys[index] = null;
            }

            if (iArr[0] === _posArr[0] && iArr[1] === _posArr[1]) {
              saved = true;
            }
          });

          if (!saved) {
            objKeys[index] = null;
          }
        });
        objKeys = objKeys.filter(function (i) {
          return i;
        }); // filter non null;

        var _loop3 = function _loop3(_pIndex) {
          // loop to set ancestral nodes's `checked` or `halfChecked`
          var loop = function loop(__pos) {
            var _posLen = util_splitPosition(__pos).length;

            if (_posLen <= 2) {
              // e.g. '0-0', '0-1'
              return;
            }

            var sibling = 0;
            var siblingChecked = 0;
            var parentPosition = util_stripTail(__pos);
            objKeys.forEach(function (i
            /* , index*/
            ) {
              var iArr = util_splitPosition(i);

              if (iArr.length === _posLen && util_isInclude(util_splitPosition(parentPosition), iArr)) {
                sibling++;

                if (obj[i].checked) {
                  siblingChecked++;

                  var _i = checkedPositionArr.indexOf(i);

                  if (_i > -1) {
                    checkedPositionArr.splice(_i, 1);

                    if (_i <= _pIndex) {
                      _pIndex--;
                    }
                  }
                } else if (obj[i].halfChecked) {
                  siblingChecked += 0.5;
                } // objKeys[index] = null;

              }
            }); // objKeys = objKeys.filter(i => i); // filter non null;

            var parent = obj[parentPosition]; // not check, checked, halfChecked

            if (siblingChecked === 0) {
              parent.checked = false;
              parent.halfChecked = false;
            } else if (siblingChecked === sibling) {
              parent.checked = true;
              parent.halfChecked = false;
            } else {
              parent.halfChecked = true;
              parent.checked = false;
            }

            loop(parentPosition);
          };

          loop(checkedPositionArr[_pIndex], _pIndex);
          pIndex = _pIndex;
        };

        for (var pIndex = 0; pIndex < checkedPositionArr.length; pIndex++) {
          _loop3(pIndex);
        } // console.log(Date.now()-s, objKeys.length, checkIt);

      }

      function util_getCheck(treeNodesStates, checkedPositions) {
        var halfCheckedKeys = [];
        var checkedKeys = [];
        var checkedNodes = [];
        Object.keys(treeNodesStates).forEach(function (item) {
          var itemObj = treeNodesStates[item];

          if (itemObj.checked) {
            checkedKeys.push(itemObj.key); // checkedNodes.push(getValuePropValue(itemObj.node));

            checkedNodes.push(extends_default()({}, itemObj, {
              pos: item
            }));
          } else if (itemObj.halfChecked) {
            halfCheckedKeys.push(itemObj.key);
          }
        });
        return {
          halfCheckedKeys: halfCheckedKeys,
          checkedKeys: checkedKeys,
          checkedNodes: checkedNodes,
          treeNodesStates: treeNodesStates,
          checkedPositions: checkedPositions
        };
      }

      function util_getTreeNodesStates(children, values) {
        var checkedPositions = [];
        var treeNodesStates = {};
        util_loopAllChildren(children, function (item, index, pos, keyOrPos, siblingPosition) {
          treeNodesStates[pos] = {
            node: item,
            key: keyOrPos,
            checked: false,
            halfChecked: false,
            siblingPosition: siblingPosition
          };

          if (values.indexOf(util_getValuePropValue(item)) !== -1) {
            treeNodesStates[pos].checked = true;
            checkedPositions.push(pos);
          }
        });
        util_handleCheckState(treeNodesStates, util_filterParentPosition(checkedPositions.sort()), true);
        return util_getCheck(treeNodesStates, checkedPositions);
      } // can add extra prop to every node.


      function util_recursiveCloneChildren(children) {
        var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (ch) {
          return ch;
        }; // return React.Children.map(children, child => {

        return Array.from(children).map(function (child) {
          var newChild = cb(child);

          if (newChild && newChild.props && newChild.props.children) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(newChild, {}, util_recursiveCloneChildren(newChild.props.children, cb));
          }

          return newChild;
        });
      } // const newChildren = recursiveCloneChildren(children, child => {
      //   const extraProps = {};
      //   if (child && child.type && child.type.xxx) {
      //     extraProps._prop = true;
      //     return React.cloneElement(child, extraProps);
      //   }
      //   return child;
      // });


      function util_recursiveGen(children) {
        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.map(children, function (child, index) {
          var pos = level + '-' + index;
          var _child$props = child.props,
              title = _child$props.title,
              label = _child$props.label,
              value = _child$props.value,
              subChildren = _child$props.children,
              rest = objectWithoutProperties_default()(_child$props, ['title', 'label', 'value', 'children']);
          var o = extends_default()({}, rest, {
            title: title,
            label: label || title,
            value: value,
            key: child.key,
            _pos: pos
          });

          if (subChildren) {
            o.children = util_recursiveGen(subChildren, pos);
          }

          return o;
        });
      }

      function util_recursive(children, cb) {
        children.forEach(function (item) {
          cb(item);

          if (item.children) {
            util_recursive(item.children, cb);
          }
        });
      } // Get the tree's checkedNodes (todo: can merge to the `handleCheckState` function)
      // If one node checked, it's all children nodes checked.
      // If sibling nodes all checked, the parent checked.


      function util_filterAllCheckedData(vs, treeNodes) {
        var vals = [].concat(vs);

        if (!vals.length) {
          return vals;
        }

        var data = util_recursiveGen(treeNodes);
        var checkedNodesPositions = [];

        function checkChildren(children) {
          children.forEach(function (item) {
            if (item.__checked) {
              return;
            }

            var ci = vals.indexOf(item.value);
            var childs = item.children;

            if (ci > -1) {
              item.__checked = true;
              checkedNodesPositions.push({
                node: item,
                pos: item._pos
              });
              vals.splice(ci, 1);

              if (childs) {
                util_recursive(childs, function (child) {
                  child.__checked = true;
                  checkedNodesPositions.push({
                    node: child,
                    pos: child._pos
                  });
                });
              }
            } else {
              if (childs) {
                checkChildren(childs);
              }
            }
          });
        }

        function checkParent(children) {
          var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            root: true
          };
          var siblingChecked = 0;
          children.forEach(function (item) {
            var childs = item.children;

            if (childs && !item.__checked && !item.__halfChecked) {
              var p = checkParent(childs, item);

              if (p.__checked) {
                siblingChecked++;
              } else if (p.__halfChecked) {
                siblingChecked += 0.5;
              }
            } else if (item.__checked) {
              siblingChecked++;
            } else if (item.__halfChecked) {
              siblingChecked += 0.5;
            }
          });
          var len = children.length;

          if (siblingChecked === len) {
            parent.__checked = true;
            checkedNodesPositions.push({
              node: parent,
              pos: parent._pos
            });
          } else if (siblingChecked < len && siblingChecked > 0) {
            parent.__halfChecked = true;
          }

          if (parent.root) {
            return children;
          }

          return parent;
        }

        checkChildren(data);
        checkParent(data);
        checkedNodesPositions.forEach(function (i, index) {
          // clear private metadata
          delete checkedNodesPositions[index].node.__checked;
          delete checkedNodesPositions[index].node._pos; // create the same structure of `onCheck`'s return.

          checkedNodesPositions[index].node.props = {
            title: checkedNodesPositions[index].node.title,
            label: checkedNodesPositions[index].node.label || checkedNodesPositions[index].node.title,
            value: checkedNodesPositions[index].node.value
          };

          if (checkedNodesPositions[index].node.children) {
            checkedNodesPositions[index].node.props.children = checkedNodesPositions[index].node.children;
          }

          delete checkedNodesPositions[index].node.title;
          delete checkedNodesPositions[index].node.label;
          delete checkedNodesPositions[index].node.value;
          delete checkedNodesPositions[index].node.children;
        });
        return checkedNodesPositions;
      }

      function util_processSimpleTreeData(treeData, format) {
        function unflatten2(array) {
          var _ref;

          var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (_ref = {}, _ref[format.id] = format.rootPId, _ref);
          var children = [];

          for (var i = 0; i < array.length; i++) {
            array[i] = extends_default()({}, array[i]); // copy, can not corrupts original data

            if (array[i][format.pId] === parent[format.id]) {
              array[i].key = array[i][format.id];
              children.push(array[i]);
              array.splice(i--, 1);
            }
          }

          if (children.length) {
            parent.children = children;
            children.forEach(function (child) {
              return unflatten2(array, child);
            });
          }

          if (parent[format.id] === format.rootPId) {
            return children;
          }
        }

        return unflatten2(treeData);
      }

      function util_saveRef(instance, name) {
        if (!instance.saveRefs) {
          instance.saveRefs = {};
        }

        if (!instance.saveRefs[name]) {
          instance.saveRefs[name] = function (node) {
            instance[name] = node;
          };
        }

        return instance.saveRefs[name];
      } // CONCATENATED MODULE: ./node_modules/rc-tree-select/node_modules/rc-tree/es/util.js

      /* eslint no-loop-func: 0*/


      function util_getOffset(ele) {
        if (!ele.getClientRects().length) {
          return {
            top: 0,
            left: 0
          };
        }

        var rect = ele.getBoundingClientRect();

        if (rect.width || rect.height) {
          var doc = ele.ownerDocument;
          var win = doc.defaultView;
          var docElem = doc.documentElement;
          return {
            top: rect.top + win.pageYOffset - docElem.clientTop,
            left: rect.left + win.pageXOffset - docElem.clientLeft
          };
        }

        return rect;
      }

      function es_util_traverseTreeNodes(treeNodes, callback) {
        var traverse = function traverse(subTreeNodes, level, parentsChildrenPos, parentPos) {
          if (Array.isArray(subTreeNodes)) {
            subTreeNodes = subTreeNodes.filter(function (item) {
              return !!item;
            });
          }

          external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].forEach(subTreeNodes, function (item, index) {
            var pos = level + '-' + index;
            parentsChildrenPos.push(pos); // Note: side effect

            var childrenPos = [];

            if (item.props.children && item.type && item.type.isTreeNode) {
              traverse(item.props.children, pos, childrenPos, pos);
            }

            callback(item, index, pos, item.key || pos, childrenPos, parentPos);
          });
        };

        traverse(treeNodes, 0, []);
      }

      function util_updateCheckState(obj, checkedPosition, checkIt) {
        var childrenLoop = function childrenLoop(parentObj) {
          parentObj.childrenPos.forEach(function (childPos) {
            var childObj = obj[childPos]; // User click don't change disabled item checked state

            if (!childObj.disableCheckbox && !childObj.disabled) {
              childObj.halfChecked = false;
              childObj.checked = checkIt;
            }

            childrenLoop(childObj);
          });
        };

        childrenLoop(obj[checkedPosition]);

        var parentLoop = function parentLoop(childObj) {
          if (!childObj.parentPos) return;
          var parentObj = obj[childObj.parentPos];
          var childrenCount = parentObj.childrenPos.length;
          var checkedChildrenCount = 0;
          parentObj.childrenPos.forEach(function (childPos) {
            if (obj[childPos].disableCheckbox) {
              childrenCount -= 1;
              return;
            }

            if (obj[childPos].checked === true) checkedChildrenCount++;else if (obj[childPos].halfChecked === true) checkedChildrenCount += 0.5;
          });

          if (checkedChildrenCount === childrenCount) {
            parentObj.checked = true;
            parentObj.halfChecked = false;
          } else if (checkedChildrenCount > 0) {
            parentObj.halfChecked = true;
            parentObj.checked = false;
          } else {
            parentObj.checked = false;
            parentObj.halfChecked = false;
          }

          parentLoop(parentObj);
        };

        parentLoop(obj[checkedPosition]);
      }

      function es_util_getCheck(treeNodesStates) {
        var halfCheckedKeys = [];
        var checkedKeys = [];
        var checkedNodes = [];
        var checkedNodesPositions = [];
        Object.keys(treeNodesStates).forEach(function (item) {
          var itemObj = treeNodesStates[item];

          if (itemObj.checked) {
            checkedKeys.push(itemObj.key);
            checkedNodes.push(itemObj.node);
            checkedNodesPositions.push({
              node: itemObj.node,
              pos: item
            });
          } else if (itemObj.halfChecked) {
            halfCheckedKeys.push(itemObj.key);
          }
        });
        return {
          halfCheckedKeys: halfCheckedKeys,
          checkedKeys: checkedKeys,
          checkedNodes: checkedNodes,
          checkedNodesPositions: checkedNodesPositions
        };
      }

      function es_util_getStrictlyValue(checkedKeys, halfChecked) {
        if (halfChecked) {
          return {
            checked: checkedKeys,
            halfChecked: halfChecked
          };
        }

        return checkedKeys;
      }

      function es_util_isPositionPrefix(smallPos, bigPos) {
        if (bigPos.length < smallPos.length) {
          return false;
        } // attention: "0-0-1" "0-0-10"


        if (bigPos.length > smallPos.length && bigPos.charAt(smallPos.length) !== '-') {
          return false;
        }

        return bigPos.substr(0, smallPos.length) === smallPos;
      } // CONCATENATED MODULE: ./node_modules/rc-tree-select/node_modules/rc-tree/es/Tree.js


      function Tree_noop() {}

      var es_Tree_contextTypes = {
        rcTree: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          selectable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
        })
      };

      var es_Tree_Tree = function (_React$Component) {
        inherits_default()(Tree, _React$Component);

        function Tree(props) {
          classCallCheck_default()(this, Tree);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          es_Tree_initialiseProps.call(_this);

          var checkedKeys = _this.calcCheckedKeys(props);

          _this.state = {
            expandedKeys: _this.calcExpandedKeys(props),
            checkedKeys: checkedKeys.checkedKeys,
            halfCheckedKeys: checkedKeys.halfCheckedKeys,
            selectedKeys: _this.calcSelectedKeys(props),
            dragNodesKeys: '',
            dragOverNodeKey: '',
            dropNodeKey: ''
          };
          return _this;
        }

        Tree.prototype.getChildContext = function getChildContext() {
          var selectable = this.props.selectable;
          return {
            rcTree: {
              selectable: selectable
            }
          };
        };

        Tree.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          var props = this.props;
          var newState = {};
          var expandedKeys = nextProps.expandedKeys !== props.expandedKeys ? this.calcExpandedKeys(nextProps, true) : undefined;

          if (expandedKeys) {
            newState.expandedKeys = expandedKeys;
          }

          var checkedKeys = nextProps.checkedKeys !== props.checkedKeys || props.loadData ? this.calcCheckedKeys(nextProps, true) : undefined;

          if (checkedKeys) {
            newState.checkedKeys = checkedKeys.checkedKeys;
            newState.halfCheckedKeys = checkedKeys.halfCheckedKeys;
          }

          var selectedKeys = nextProps.selectedKeys !== props.selectedKeys ? this.calcSelectedKeys(nextProps, true) : undefined;

          if (selectedKeys) {
            newState.selectedKeys = selectedKeys;
          }

          this.setState(newState);
        };

        Tree.prototype.onDragStart = function onDragStart(e, treeNode) {
          this.dragNode = treeNode;
          var newState = {
            dragNodesKeys: this.getDragNodesKeys(treeNode)
          };
          var expandedKeys = this.getExpandedKeys(treeNode, false);

          if (expandedKeys) {
            newState.expandedKeys = expandedKeys;
          }

          this.setState(newState);
          this.props.onDragStart({
            event: e,
            node: treeNode
          });
        };

        Tree.prototype.onDragEnter = function onDragEnter(e, treeNode) {
          var _this2 = this;

          var dropPosition = this.calcDropPosition(e, treeNode);

          if (this.dragNode.props.eventKey === treeNode.props.eventKey && dropPosition === 0) {
            this.setState({
              dragOverNodeKey: '',
              dropPosition: null
            });
            return;
          }

          this.setState({
            dragOverNodeKey: treeNode.props.eventKey,
            dropPosition: dropPosition
          });

          if (!this.delayedDragEnterLogic) {
            this.delayedDragEnterLogic = {};
          }

          Object.keys(this.delayedDragEnterLogic).forEach(function (key) {
            clearTimeout(_this2.delayedDragEnterLogic[key]);
          });
          this.delayedDragEnterLogic[treeNode.props.pos] = setTimeout(function () {
            var expandedKeys = _this2.getExpandedKeys(treeNode, true);

            if (expandedKeys) {
              _this2.setState({
                expandedKeys: expandedKeys
              });
            }

            _this2.props.onDragEnter({
              event: e,
              node: treeNode,
              expandedKeys: expandedKeys && [].concat(expandedKeys) || [].concat(_this2.state.expandedKeys)
            });
          }, 400);
        };

        Tree.prototype.onDragOver = function onDragOver(e, treeNode) {
          this.props.onDragOver({
            event: e,
            node: treeNode
          });
        };

        Tree.prototype.onDragLeave = function onDragLeave(e, treeNode) {
          this.props.onDragLeave({
            event: e,
            node: treeNode
          });
        };

        Tree.prototype.onDrop = function onDrop(e, treeNode) {
          var state = this.state;
          var eventKey = treeNode.props.eventKey;
          this.setState({
            dragOverNodeKey: '',
            dropNodeKey: eventKey
          });

          if (state.dragNodesKeys.indexOf(eventKey) > -1) {
            browser_default()(false, 'Can not drop to dragNode(include it\'s children node)');
            return;
          }

          var posArr = treeNode.props.pos.split('-');
          var res = {
            event: e,
            node: treeNode,
            dragNode: this.dragNode,
            dragNodesKeys: [].concat(state.dragNodesKeys),
            dropPosition: state.dropPosition + Number(posArr[posArr.length - 1])
          };

          if (state.dropPosition !== 0) {
            res.dropToGap = true;
          }

          this.props.onDrop(res);
        };

        Tree.prototype.onDragEnd = function onDragEnd(e, treeNode) {
          this.setState({
            dragOverNodeKey: ''
          });
          this.props.onDragEnd({
            event: e,
            node: treeNode
          });
        };

        Tree.prototype.onExpand = function onExpand(treeNode) {
          var _this3 = this;

          var props = this.props,
              state = this.state;
          var expanded = !treeNode.props.expanded;
          var expandedKeys = [].concat(state.expandedKeys);
          var eventKey = treeNode.props.eventKey;
          var index = expandedKeys.indexOf(eventKey);

          if (expanded && index === -1) {
            expandedKeys.push(eventKey);
          } else if (!expanded && index > -1) {
            expandedKeys.splice(index, 1);
          }

          var controlled = 'expandedKeys' in props;

          if (!controlled) {
            this.setState({
              expandedKeys: expandedKeys
            });
          }

          props.onExpand(expandedKeys, {
            node: treeNode,
            expanded: expanded
          }); // After data loaded, need set new expandedKeys

          if (expanded && props.loadData) {
            return props.loadData(treeNode).then(function () {
              if (!controlled) {
                _this3.setState({
                  expandedKeys: expandedKeys
                });
              }
            });
          }
        };

        Tree.prototype.onSelect = function onSelect(treeNode) {
          var props = this.props,
              state = this.state;
          var eventKey = treeNode.props.eventKey;
          var selected = !treeNode.props.selected;
          var selectedKeys = [].concat(state.selectedKeys);

          if (!selected) {
            var index = selectedKeys.indexOf(eventKey);
            selectedKeys.splice(index, 1);
          } else if (!props.multiple) {
            selectedKeys = [eventKey];
          } else {
            selectedKeys.push(eventKey);
          } // TODO: can be optimized if we remove selectedNodes in API


          var selectedNodes = [];

          if (selectedKeys.length) {
            es_util_traverseTreeNodes(props.children, function (item) {
              if (selectedKeys.indexOf(item.key) !== -1) {
                selectedNodes.push(item);
              }
            });
          }

          if (!('selectedKeys' in props)) {
            this.setState({
              selectedKeys: selectedKeys
            });
          }

          var eventObj = {
            event: 'select',
            selected: selected,
            node: treeNode,
            selectedNodes: selectedNodes
          };
          props.onSelect(selectedKeys, eventObj);
        };

        Tree.prototype.onMouseEnter = function onMouseEnter(e, treeNode) {
          this.props.onMouseEnter({
            event: e,
            node: treeNode
          });
        };

        Tree.prototype.onMouseLeave = function onMouseLeave(e, treeNode) {
          this.props.onMouseLeave({
            event: e,
            node: treeNode
          });
        };

        Tree.prototype.onContextMenu = function onContextMenu(e, treeNode) {
          if (this.props.onRightClick) {
            e.preventDefault();
            this.props.onRightClick({
              event: e,
              node: treeNode
            });
          }
        }; // all keyboard events callbacks run from here at first


        Tree.prototype.getOpenTransitionName = function getOpenTransitionName() {
          var props = this.props;
          var transitionName = props.openTransitionName;
          var animationName = props.openAnimation;

          if (!transitionName && typeof animationName === 'string') {
            return props.prefixCls + '-open-' + animationName;
          }

          return transitionName;
        };

        Tree.prototype.getDragNodesKeys = function getDragNodesKeys(treeNode) {
          var dragNodesKeys = [];
          es_util_traverseTreeNodes(treeNode.props.children, function (item, index, pos, key) {
            if (es_util_isPositionPrefix(treeNode.props.pos, pos)) {
              dragNodesKeys.push(key);
            }
          });
          dragNodesKeys.push(treeNode.props.eventKey || treeNode.props.pos);
          return dragNodesKeys;
        };

        Tree.prototype.getExpandedKeys = function getExpandedKeys(treeNode, expand) {
          var eventKey = treeNode.props.eventKey;
          var expandedKeys = this.state.expandedKeys;
          var expandedIndex = expandedKeys.indexOf(eventKey);

          if (!expand && expandedIndex > -1) {
            var exKeys = [].concat(expandedKeys);
            exKeys.splice(expandedIndex, 1);
            return exKeys;
          }

          if (expand && expandedKeys.indexOf(eventKey) === -1) {
            return expandedKeys.concat([eventKey]);
          }
        };

        Tree.prototype.generateTreeNodesStates = function generateTreeNodesStates(children, checkedKeys) {
          var checkedPositions = [];
          var treeNodesStates = {};
          es_util_traverseTreeNodes(children, function (item, _, pos, key, childrenPos, parentPos) {
            treeNodesStates[pos] = {
              node: item,
              key: key,
              checked: false,
              halfChecked: false,
              disabled: item.props.disabled,
              disableCheckbox: item.props.disableCheckbox,
              childrenPos: childrenPos,
              parentPos: parentPos
            };

            if (checkedKeys.indexOf(key) !== -1) {
              treeNodesStates[pos].checked = true;
              checkedPositions.push(pos);
            }
          });
          checkedPositions.forEach(function (checkedPosition) {
            util_updateCheckState(treeNodesStates, checkedPosition, true);
          });
          return treeNodesStates;
        };

        Tree.prototype.calcExpandedKeys = function calcExpandedKeys(props, isNotInit) {
          var expandedKeys = props.expandedKeys || (isNotInit ? undefined : props.defaultExpandedKeys);

          if (!expandedKeys) {
            return undefined;
          }

          var expandAll = isNotInit ? false : props.defaultExpandAll;

          if (!expandAll && !props.autoExpandParent) {
            return expandedKeys;
          }

          var expandedPositionArr = [];

          if (props.autoExpandParent) {
            es_util_traverseTreeNodes(props.children, function (item, index, pos, key) {
              if (expandedKeys.indexOf(key) > -1) {
                expandedPositionArr.push(pos);
              }
            });
          }

          var filterExpandedKeysSet = {};
          es_util_traverseTreeNodes(props.children, function (item, index, pos, key) {
            if (expandAll) {
              filterExpandedKeysSet[key] = true;
            } else if (props.autoExpandParent) {
              var isCurrentParentOfExpanded = expandedPositionArr.some(function (p) {
                return es_util_isPositionPrefix(pos, p);
              });

              if (isCurrentParentOfExpanded) {
                filterExpandedKeysSet[key] = true;
              }
            }
          });
          var filterExpandedKeys = Object.keys(filterExpandedKeysSet);
          return filterExpandedKeys.length ? filterExpandedKeys : expandedKeys;
        };

        Tree.prototype.calcCheckedKeys = function calcCheckedKeys(props, isNotInit) {
          if (!props.checkable) {
            return {
              checkedKeys: [],
              halfCheckedKeys: []
            };
          }

          var checkedKeys = props.checkedKeys || (isNotInit && !props.loadData ? undefined : props.defaultCheckedKeys);

          if (!checkedKeys) {
            return undefined;
          }

          if (Array.isArray(checkedKeys)) {
            checkedKeys = {
              checkedKeys: checkedKeys,
              halfCheckedKeys: []
            };
          } else if (typeof checkedKeys === 'object') {
            checkedKeys = {
              checkedKeys: checkedKeys.checked,
              halfCheckedKeys: checkedKeys.halfChecked
            };
          }

          if (!props.checkStrictly) {
            var checked = checkedKeys.checkedKeys || [];
            var treeNodesStates = this.generateTreeNodesStates(props.children, checked);
            return es_util_getCheck(treeNodesStates);
          }

          return checkedKeys;
        };

        Tree.prototype.calcSelectedKeys = function calcSelectedKeys(props, isNotInit) {
          var selectedKeys = props.selectedKeys || (isNotInit ? undefined : props.defaultSelectedKeys);

          if (!selectedKeys) {
            return undefined;
          }

          if (props.multiple) {
            return [].concat(selectedKeys);
          }

          if (selectedKeys.length) {
            return [selectedKeys[0]];
          }

          return selectedKeys;
        };

        Tree.prototype.calcDropPosition = function calcDropPosition(e, treeNode) {
          var offsetTop = util_getOffset(treeNode.selectHandle).top;
          var offsetHeight = treeNode.selectHandle.offsetHeight;
          var pageY = e.pageY;
          var gapHeight = 2; // TODO: remove hard code

          if (pageY > offsetTop + offsetHeight - gapHeight) {
            return 1;
          }

          if (pageY < offsetTop + gapHeight) {
            return -1;
          }

          return 0;
        };

        Tree.prototype.renderTreeNode = function renderTreeNode(child, index) {
          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          var state = this.state,
              props = this.props;
          var pos = level + '-' + index;
          var key = child.key || pos;
          var childProps = {
            root: this,
            eventKey: key,
            pos: pos,
            loadData: props.loadData,
            prefixCls: props.prefixCls,
            showIcon: props.showIcon,
            draggable: props.draggable,
            dragOver: state.dragOverNodeKey === key && state.dropPosition === 0,
            dragOverGapTop: state.dragOverNodeKey === key && state.dropPosition === -1,
            dragOverGapBottom: state.dragOverNodeKey === key && state.dropPosition === 1,
            expanded: state.expandedKeys.indexOf(key) !== -1,
            selected: state.selectedKeys.indexOf(key) !== -1,
            openTransitionName: this.getOpenTransitionName(),
            openAnimation: props.openAnimation,
            filterTreeNode: this.filterTreeNode
          };

          if (props.checkable) {
            childProps.checkable = props.checkable;
            childProps.checked = state.checkedKeys.indexOf(key) !== -1;
            childProps.halfChecked = state.halfCheckedKeys.indexOf(key) !== -1;
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(child, childProps);
        };

        Tree.prototype.render = function render() {
          var _classNames;

          var props = this.props;
          var className = classnames_default()(props.prefixCls, props.className, (_classNames = {}, _classNames[props.prefixCls + '-show-line'] = props.showLine, _classNames));
          var domProps = {};

          if (props.focusable) {
            domProps.tabIndex = '0';
            domProps.onKeyDown = this.onKeyDown;
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', extends_default()({}, domProps, {
            className: className,
            role: 'tree-node',
            unselectable: 'on'
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.map(props.children, this.renderTreeNode, this));
        };

        return Tree;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      es_Tree_Tree.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        showLine: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showIcon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        selectable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        checkable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node]),
        checkStrictly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        draggable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        autoExpandParent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultExpandAll: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultExpandedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        expandedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        defaultCheckedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        checkedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string), external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        defaultSelectedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        selectedKeys: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        onExpand: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onCheck: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        loadData: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onRightClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDragStart: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDragEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDragOver: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDragLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDrop: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDragEnd: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        filterTreeNode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        openTransitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        openAnimation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object])
      };
      es_Tree_Tree.childContextTypes = es_Tree_contextTypes;
      es_Tree_Tree.defaultProps = {
        prefixCls: 'rc-tree',
        showLine: false,
        showIcon: true,
        selectable: true,
        multiple: false,
        checkable: false,
        checkStrictly: false,
        draggable: false,
        autoExpandParent: true,
        defaultExpandAll: false,
        defaultExpandedKeys: [],
        defaultCheckedKeys: [],
        defaultSelectedKeys: [],
        onExpand: Tree_noop,
        onCheck: Tree_noop,
        onSelect: Tree_noop,
        onDragStart: Tree_noop,
        onDragEnter: Tree_noop,
        onDragOver: Tree_noop,
        onDragLeave: Tree_noop,
        onDrop: Tree_noop,
        onDragEnd: Tree_noop,
        onMouseEnter: Tree_noop,
        onMouseLeave: Tree_noop
      };

      var es_Tree_initialiseProps = function _initialiseProps() {
        var _this4 = this;

        this.onCheck = function (treeNode) {
          var props = _this4.props,
              state = _this4.state;
          var checked = !treeNode.props.checked || treeNode.props.halfChecked;
          var eventObj = {
            event: 'check',
            node: treeNode,
            checked: checked
          };

          if (props.checkStrictly) {
            var eventKey = treeNode.props.eventKey;
            var checkedKeys = [].concat(state.checkedKeys);
            var index = checkedKeys.indexOf(eventKey);

            if (checked && index === -1) {
              checkedKeys.push(eventKey);
            }

            if (!checked && index > -1) {
              checkedKeys.splice(index, 1);
            }

            eventObj.checkedNodes = [];
            es_util_traverseTreeNodes(props.children, function (item) {
              if (checkedKeys.indexOf(item.key) !== -1) {
                eventObj.checkedNodes.push(item);
              }
            });

            if (!('checkedKeys' in props)) {
              _this4.setState({
                checkedKeys: checkedKeys
              });
            }

            props.onCheck(es_util_getStrictlyValue(checkedKeys, state.halfCheckedKeys), eventObj);
          } else {
            var treeNodesStates = _this4.generateTreeNodesStates(props.children, state.checkedKeys);

            treeNodesStates[treeNode.props.pos].checked = checked;
            treeNodesStates[treeNode.props.pos].halfChecked = false;
            util_updateCheckState(treeNodesStates, treeNode.props.pos, checked);
            var checkKeys = es_util_getCheck(treeNodesStates);
            eventObj.checkedNodes = checkKeys.checkedNodes;
            eventObj.checkedNodesPositions = checkKeys.checkedNodesPositions; // TODO: not in API

            eventObj.halfCheckedKeys = checkKeys.halfCheckedKeys; // TODO: not in API

            if (!('checkedKeys' in props)) {
              _this4.setState({
                checkedKeys: checkKeys.checkedKeys,
                halfCheckedKeys: checkKeys.halfCheckedKeys
              });
            }

            props.onCheck(checkKeys.checkedKeys, eventObj);
          }
        };

        this.onKeyDown = function (e) {
          e.preventDefault();
        };

        this.filterTreeNode = function (treeNode) {
          var filterTreeNode = _this4.props.filterTreeNode;

          if (typeof filterTreeNode !== 'function' || treeNode.props.disabled) {
            return false;
          }

          return filterTreeNode.call(_this4, treeNode);
        };
      };
      /* harmony default export */


      var rc_tree_es_Tree = es_Tree_Tree; // CONCATENATED MODULE: ./node_modules/rc-tree-select/node_modules/rc-tree/es/TreeNode.js

      var es_TreeNode_defaultTitle = '---';

      var es_TreeNode_TreeNode = function (_React$Component) {
        inherits_default()(TreeNode, _React$Component);

        function TreeNode(props) {
          classCallCheck_default()(this, TreeNode);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          _this.onCheck = function () {
            _this.props.root.onCheck(_this);
          };

          _this.onMouseEnter = function (e) {
            e.preventDefault();

            _this.props.root.onMouseEnter(e, _this);
          };

          _this.onMouseLeave = function (e) {
            e.preventDefault();

            _this.props.root.onMouseLeave(e, _this);
          };

          _this.onContextMenu = function (e) {
            _this.props.root.onContextMenu(e, _this);
          };

          _this.onDragStart = function (e) {
            e.stopPropagation();

            _this.setState({
              dragNodeHighlight: true
            });

            _this.props.root.onDragStart(e, _this);

            try {
              // ie throw error
              // firefox-need-it
              e.dataTransfer.setData('text/plain', '');
            } catch (error) {// empty
            }
          };

          _this.onDragEnter = function (e) {
            e.preventDefault();
            e.stopPropagation();

            _this.props.root.onDragEnter(e, _this);
          };

          _this.onDragOver = function (e) {
            e.preventDefault();
            e.stopPropagation();

            _this.props.root.onDragOver(e, _this);
          };

          _this.onDragLeave = function (e) {
            e.stopPropagation();

            _this.props.root.onDragLeave(e, _this);
          };

          _this.onDrop = function (e) {
            e.preventDefault();
            e.stopPropagation();

            _this.setState({
              dragNodeHighlight: false
            });

            _this.props.root.onDrop(e, _this);
          };

          _this.onDragEnd = function (e) {
            e.stopPropagation();

            _this.setState({
              dragNodeHighlight: false
            });

            _this.props.root.onDragEnd(e, _this);
          };

          _this.onExpand = function () {
            var callbackPromise = _this.props.root.onExpand(_this);

            if (callbackPromise && typeof callbackPromise === 'object') {
              var setLoading = function setLoading(dataLoading) {
                _this.setState({
                  dataLoading: dataLoading
                });
              };

              setLoading(true);
              callbackPromise.then(function () {
                setLoading(false);
              }, function () {
                setLoading(false);
              });
            }
          };

          _this.saveSelectHandle = function (node) {
            _this.selectHandle = node;
          };

          _this.state = {
            dataLoading: false,
            dragNodeHighlight: false
          };
          return _this;
        }

        TreeNode.prototype.onSelect = function onSelect() {
          this.props.root.onSelect(this);
        }; // keyboard event support


        TreeNode.prototype.onKeyDown = function onKeyDown(e) {
          e.preventDefault();
        };

        TreeNode.prototype.isSelectable = function isSelectable() {
          var props = this.props,
              context = this.context;
          return 'selectable' in props ? props.selectable : context.rcTree.selectable;
        };

        TreeNode.prototype.renderSwitcher = function renderSwitcher(props, expandedState) {
          var prefixCls = props.prefixCls;
          var switcherCls = classnames_default()(prefixCls + '-switcher', prefixCls + '-switcher_' + expandedState);
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: switcherCls,
            onClick: this.onExpand
          });
        };

        TreeNode.prototype.renderCheckbox = function renderCheckbox(props) {
          var _checkboxCls;

          var prefixCls = props.prefixCls;
          var checkboxCls = (_checkboxCls = {}, _checkboxCls[prefixCls + '-checkbox'] = true, _checkboxCls);

          if (props.checked) {
            checkboxCls[prefixCls + '-checkbox-checked'] = true;
          } else if (props.halfChecked) {
            checkboxCls[prefixCls + '-checkbox-indeterminate'] = true;
          }

          var customEle = null;

          if (typeof props.checkable !== 'boolean') {
            customEle = props.checkable;
          }

          if (props.disabled || props.disableCheckbox) {
            checkboxCls[prefixCls + '-checkbox-disabled'] = true;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: classnames_default()(checkboxCls)
            }, customEle);
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: classnames_default()(checkboxCls),
            onClick: this.onCheck
          }, customEle);
        };

        TreeNode.prototype.renderChildren = function renderChildren(props) {
          var renderFirst = this.renderFirst;
          this.renderFirst = 1;
          var transitionAppear = true;

          if (!renderFirst && props.expanded) {
            transitionAppear = false;
          }

          var children = null;

          if (props.children) {
            children = Object(Children_toArray["a"
            /* default */
            ])(props.children).filter(function (item) {
              return !!item;
            });
          }

          var newChildren = children;

          if (children && (Array.isArray(children) && children.length && children.every(function (item) {
            return item.type && item.type.isTreeNode;
          }) || children.type && children.type.isTreeNode)) {
            var _classNames;

            var animProps = {};

            if (props.openTransitionName) {
              animProps.transitionName = props.openTransitionName;
            } else if (typeof props.openAnimation === 'object') {
              animProps.animation = extends_default()({}, props.openAnimation);

              if (!transitionAppear) {
                delete animProps.animation.appear;
              }
            }

            var cls = classnames_default()(props.prefixCls + '-child-tree', (_classNames = {}, _classNames[props.prefixCls + '-child-tree-open'] = props.expanded, _classNames));
            newChildren = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], extends_default()({}, animProps, {
              showProp: 'data-expanded',
              transitionAppear: transitionAppear,
              component: ''
            }), !props.expanded ? null : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', {
              className: cls,
              'data-expanded': props.expanded
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.map(children, function (item, index) {
              return props.root.renderTreeNode(item, index, props.pos);
            }, props.root)));
          }

          return newChildren;
        };

        TreeNode.prototype.render = function render() {
          var _iconEleCls,
              _this2 = this;

          var props = this.props;
          var prefixCls = props.prefixCls;
          var expandedState = props.expanded ? 'open' : 'close';
          var iconState = expandedState;
          var canRenderSwitcher = true;
          var content = props.title;
          var newChildren = this.renderChildren(props);

          if (!newChildren || newChildren === props.children) {
            // content = newChildren;
            newChildren = null;

            if (!props.loadData || props.isLeaf) {
              canRenderSwitcher = false;
              iconState = 'docu';
            }
          } // For performance, does't render children into dom when `!props.expanded` (move to Animate)
          // if (!props.expanded) {
          //   newChildren = null;
          // }


          var iconEleCls = (_iconEleCls = {}, _iconEleCls[prefixCls + '-iconEle'] = true, _iconEleCls[prefixCls + '-icon_loading'] = this.state.dataLoading, _iconEleCls[prefixCls + '-icon__' + iconState] = true, _iconEleCls);

          var selectHandle = function selectHandle() {
            var icon = props.showIcon || props.loadData && _this2.state.dataLoading ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: classnames_default()(iconEleCls)
            }) : null;
            var title = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-title'
            }, content);
            var wrap = prefixCls + '-node-content-wrapper';
            var domProps = {
              className: wrap + ' ' + wrap + '-' + (iconState === expandedState ? iconState : 'normal'),
              onMouseEnter: _this2.onMouseEnter,
              onMouseLeave: _this2.onMouseLeave,
              onContextMenu: _this2.onContextMenu
            };

            if (!props.disabled) {
              if (props.selected || _this2.state.dragNodeHighlight) {
                domProps.className += ' ' + prefixCls + '-node-selected';
              }

              domProps.onClick = function (e) {
                if (_this2.isSelectable()) {
                  e.preventDefault();

                  _this2.onSelect();
                } else if (props.checkable && !props.disableCheckbox) {
                  e.preventDefault(); // && !props.disabled is checked on line 259

                  _this2.onCheck();
                }
              };

              if (props.draggable) {
                domProps.className += ' draggable';
                domProps.draggable = true;
                domProps['aria-grabbed'] = true;
                domProps.onDragStart = _this2.onDragStart;
              }
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', extends_default()({
              ref: _this2.saveSelectHandle,
              title: typeof content === 'string' ? content : ''
            }, domProps), icon, title);
          };

          var liProps = {};

          if (props.draggable) {
            liProps.onDragEnter = this.onDragEnter;
            liProps.onDragOver = this.onDragOver;
            liProps.onDragLeave = this.onDragLeave;
            liProps.onDrop = this.onDrop;
            liProps.onDragEnd = this.onDragEnd;
          }

          var disabledCls = '';
          var dragOverCls = '';

          if (props.disabled) {
            disabledCls = prefixCls + '-treenode-disabled';
          } else if (props.dragOver) {
            dragOverCls = 'drag-over';
          } else if (props.dragOverGapTop) {
            dragOverCls = 'drag-over-gap-top';
          } else if (props.dragOverGapBottom) {
            dragOverCls = 'drag-over-gap-bottom';
          }

          var filterCls = props.filterTreeNode(this) ? 'filter-node' : '';

          var renderNoopSwitcher = function renderNoopSwitcher() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-switcher ' + prefixCls + '-switcher-noop'
            });
          };

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', extends_default()({}, liProps, {
            className: classnames_default()(props.className, disabledCls, dragOverCls, filterCls)
          }), canRenderSwitcher ? this.renderSwitcher(props, expandedState) : renderNoopSwitcher(), props.checkable ? this.renderCheckbox(props) : null, selectHandle(), newChildren);
        };

        return TreeNode;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      es_TreeNode_TreeNode.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disableCheckbox: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        expanded: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        isLeaf: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        root: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      es_TreeNode_TreeNode.contextTypes = es_Tree_contextTypes;
      es_TreeNode_TreeNode.defaultProps = {
        title: es_TreeNode_defaultTitle
      };
      es_TreeNode_TreeNode.isTreeNode = 1;
      /* harmony default export */

      var rc_tree_es_TreeNode = es_TreeNode_TreeNode; // CONCATENATED MODULE: ./node_modules/rc-tree-select/node_modules/rc-tree/es/index.js

      rc_tree_es_Tree.TreeNode = rc_tree_es_TreeNode;
      /* harmony default export */

      var node_modules_rc_tree_es = rc_tree_es_Tree; // CONCATENATED MODULE: ./node_modules/rc-tree-select/es/SelectTrigger.js

      var SelectTrigger_BUILT_IN_PLACEMENTS = {
        bottomLeft: {
          points: ['tl', 'bl'],
          offset: [0, 4],
          overflow: {
            adjustX: 0,
            adjustY: 1
          }
        },
        topLeft: {
          points: ['bl', 'tl'],
          offset: [0, -4],
          overflow: {
            adjustX: 0,
            adjustY: 1
          }
        }
      };

      var SelectTrigger_SelectTrigger = function (_Component) {
        inherits_default()(SelectTrigger, _Component);

        function SelectTrigger() {
          var _temp, _this, _ret;

          classCallCheck_default()(this, SelectTrigger);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            _expandedKeys: [],
            fireOnExpand: false,
            dropdownWidth: null
          }, _this.onExpand = function (expandedKeys) {
            // rerender
            _this.setState({
              _expandedKeys: expandedKeys,
              fireOnExpand: true
            }, function () {
              // Fix https://github.com/ant-design/ant-design/issues/5689
              if (_this.trigger && _this.trigger.forcePopupAlign) {
                _this.trigger.forcePopupAlign();
              }
            });
          }, _this.highlightTreeNode = function (treeNode) {
            var props = _this.props;
            var filterVal = treeNode.props[util_labelCompatible(props.treeNodeFilterProp)];

            if (typeof filterVal === 'string') {
              return props.inputValue && filterVal.indexOf(props.inputValue) > -1;
            }

            return false;
          }, _this.filterTreeNode = function (input, child) {
            if (!input) {
              return true;
            }

            var filterTreeNode = _this.props.filterTreeNode;

            if (!filterTreeNode) {
              return true;
            }

            if (child.props.disabled) {
              return false;
            }

            return filterTreeNode.call(_this, input, child);
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        SelectTrigger.prototype.componentDidMount = function componentDidMount() {
          this.setDropdownWidth();
        };

        SelectTrigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          if (nextProps.inputValue && nextProps.inputValue !== this.props.inputValue) {
            // set autoExpandParent to true
            this.setState({
              _expandedKeys: [],
              fireOnExpand: false
            });
          }
        };

        SelectTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
          this.setDropdownWidth();
        };

        SelectTrigger.prototype.setDropdownWidth = function setDropdownWidth() {
          var width = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this).offsetWidth;

          if (width !== this.state.dropdownWidth) {
            this.setState({
              dropdownWidth: width
            });
          }
        };

        SelectTrigger.prototype.getPopupEleRefs = function getPopupEleRefs() {
          return this.popupEle;
        };

        SelectTrigger.prototype.getPopupDOMNode = function getPopupDOMNode() {
          return this.trigger.getPopupDomNode();
        };

        SelectTrigger.prototype.getDropdownTransitionName = function getDropdownTransitionName() {
          var props = this.props;
          var transitionName = props.transitionName;

          if (!transitionName && props.animation) {
            transitionName = this.getDropdownPrefixCls() + '-' + props.animation;
          }

          return transitionName;
        };

        SelectTrigger.prototype.getDropdownPrefixCls = function getDropdownPrefixCls() {
          return this.props.prefixCls + '-dropdown';
        };

        SelectTrigger.prototype.processTreeNode = function processTreeNode(treeNodes) {
          var _this2 = this;

          var filterPoss = [];
          this._expandedKeys = [];
          util_loopAllChildren(treeNodes, function (child, index, pos) {
            if (_this2.filterTreeNode(_this2.props.inputValue, child)) {
              filterPoss.push(pos);

              _this2._expandedKeys.push(child.key);
            }
          }); // Include the filtered nodes's ancestral nodes.

          var processedPoss = [];
          filterPoss.forEach(function (pos) {
            var arr = pos.split('-');
            arr.reduce(function (pre, cur) {
              var res = pre + '-' + cur;

              if (processedPoss.indexOf(res) < 0) {
                processedPoss.push(res);
              }

              return res;
            });
          });
          var filterNodesPositions = [];
          util_loopAllChildren(treeNodes, function (child, index, pos) {
            if (processedPoss.indexOf(pos) > -1) {
              filterNodesPositions.push({
                node: child,
                pos: pos
              });
            }
          });
          var hierarchyNodes = util_flatToHierarchy(filterNodesPositions);

          var recursive = function recursive(children) {
            return children.map(function (child) {
              if (child.children) {
                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(child.node, {}, recursive(child.children));
              }

              return child.node;
            });
          };

          return recursive(hierarchyNodes);
        };

        SelectTrigger.prototype.renderTree = function renderTree(keys, halfCheckedKeys, newTreeNodes, multiple) {
          var props = this.props;
          var trProps = {
            multiple: multiple,
            prefixCls: props.prefixCls + '-tree',
            showIcon: props.treeIcon,
            showLine: props.treeLine,
            defaultExpandAll: props.treeDefaultExpandAll,
            defaultExpandedKeys: props.treeDefaultExpandedKeys,
            filterTreeNode: this.highlightTreeNode
          };

          if (props.treeCheckable) {
            trProps.selectable = false;
            trProps.checkable = props.treeCheckable;
            trProps.onCheck = props.onSelect;
            trProps.checkStrictly = props.treeCheckStrictly;

            if (props.inputValue) {
              // enable checkStrictly when search tree.
              trProps.checkStrictly = true;
            } else {
              trProps._treeNodesStates = props._treeNodesStates;
            }

            if (trProps.treeCheckStrictly && halfCheckedKeys.length) {
              trProps.checkedKeys = {
                checked: keys,
                halfChecked: halfCheckedKeys
              };
            } else {
              trProps.checkedKeys = keys;
            }
          } else {
            trProps.selectedKeys = keys;
            trProps.onSelect = props.onSelect;
          } // expand keys


          if (!trProps.defaultExpandAll && !trProps.defaultExpandedKeys && !props.loadData) {
            trProps.expandedKeys = keys;
          }

          trProps.autoExpandParent = true;
          trProps.onExpand = this.onExpand;

          if (this._expandedKeys && this._expandedKeys.length) {
            trProps.expandedKeys = this._expandedKeys;
          }

          if (this.state.fireOnExpand) {
            trProps.expandedKeys = this.state._expandedKeys;
            trProps.autoExpandParent = false;
          } // async loadData


          if (props.loadData) {
            trProps.loadData = props.loadData;
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(node_modules_rc_tree_es, extends_default()({
            ref: util_saveRef(this, 'popupEle')
          }, trProps), newTreeNodes);
        };

        SelectTrigger.prototype.render = function render() {
          var _popupClassName;

          var props = this.props;
          var multiple = props.multiple;
          var dropdownPrefixCls = this.getDropdownPrefixCls();
          var popupClassName = (_popupClassName = {}, _popupClassName[props.dropdownClassName] = !!props.dropdownClassName, _popupClassName[dropdownPrefixCls + '--' + (multiple ? 'multiple' : 'single')] = 1, _popupClassName);
          var visible = props.visible;
          var search = multiple || !props.showSearch ? null : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: dropdownPrefixCls + '-search'
          }, props.inputElement);

          var recursive = function recursive(children) {
            // Note: if use `React.Children.map`, the node's key will be modified.
            return Object(Children_toArray["a"
            /* default */
            ])(children).map(function handler(child) {
              // eslint-disable-line
              if (!child) {
                return null;
              }

              if (child && child.props.children) {
                // null or String has no Prop
                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_tree_es_TreeNode, extends_default()({}, child.props, {
                  key: child.key
                }), recursive(child.props.children));
              }

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_tree_es_TreeNode, extends_default()({}, child.props, {
                key: child.key
              }));
            });
          }; // const s = Date.now();


          var treeNodes = void 0;

          if (props._cachetreeData && this.treeNodes) {
            treeNodes = this.treeNodes;
          } else {
            treeNodes = recursive(props.treeData || props.treeNodes);
            this.treeNodes = treeNodes;
          } // console.log(Date.now()-s);


          if (props.inputValue) {
            treeNodes = this.processTreeNode(treeNodes);
          }

          var keys = [];
          var halfCheckedKeys = [];
          util_loopAllChildren(treeNodes, function (child) {
            if (props.value.some(function (item) {
              return item.value === util_getValuePropValue(child);
            })) {
              keys.push(child.key);
            }

            if (props.halfCheckedValues && props.halfCheckedValues.some(function (item) {
              return item.value === util_getValuePropValue(child);
            })) {
              halfCheckedKeys.push(child.key);
            }
          });
          var notFoundContent = void 0;

          if (!treeNodes.length) {
            if (props.notFoundContent) {
              notFoundContent = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                className: props.prefixCls + '-not-found'
              }, props.notFoundContent);
            } else if (!search) {
              visible = false;
            }
          }

          var popupElement = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', null, search, notFoundContent || this.renderTree(keys, halfCheckedKeys, treeNodes, multiple));
          var popupStyle = extends_default()({}, props.dropdownStyle);
          var widthProp = props.dropdownMatchSelectWidth ? 'width' : 'minWidth';

          if (this.state.dropdownWidth) {
            popupStyle[widthProp] = this.state.dropdownWidth + 'px';
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_trigger_es["default"], {
            action: props.disabled ? [] : ['click'],
            ref: util_saveRef(this, 'trigger'),
            popupPlacement: 'bottomLeft',
            builtinPlacements: SelectTrigger_BUILT_IN_PLACEMENTS,
            popupAlign: props.dropdownPopupAlign,
            prefixCls: dropdownPrefixCls,
            popupTransitionName: this.getDropdownTransitionName(),
            onPopupVisibleChange: props.onDropdownVisibleChange,
            popup: popupElement,
            popupVisible: visible,
            getPopupContainer: props.getPopupContainer,
            popupClassName: classnames_default()(popupClassName),
            popupStyle: popupStyle
          }, this.props.children);
        };

        return SelectTrigger;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      SelectTrigger_SelectTrigger.propTypes = {
        dropdownMatchSelectWidth: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        dropdownPopupAlign: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        filterTreeNode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        treeNodes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        inputValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        popupClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      /* harmony default export */

      var es_SelectTrigger = SelectTrigger_SelectTrigger; // CONCATENATED MODULE: ./node_modules/rc-tree-select/es/TreeNode.js

      var rc_tree_select_es_TreeNode_TreeNode = function (_React$Component) {
        inherits_default()(TreeNode, _React$Component);

        function TreeNode() {
          classCallCheck_default()(this, TreeNode);
          return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
        }

        return TreeNode;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      rc_tree_select_es_TreeNode_TreeNode.propTypes = {
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var rc_tree_select_es_TreeNode = rc_tree_select_es_TreeNode_TreeNode; // CONCATENATED MODULE: ./node_modules/rc-tree-select/es/strategies.js

      var SHOW_ALL = 'SHOW_ALL';
      var SHOW_PARENT = 'SHOW_PARENT';
      var SHOW_CHILD = 'SHOW_CHILD'; // CONCATENATED MODULE: ./node_modules/rc-tree-select/es/PropTypes.js

      function PropTypes_nonEmptyStringType(props, propsName) {
        var value = props[propsName];

        if (typeof value !== 'string' || !value) {
          return new Error(); // Just a flag, so don't need message.
        }
      }

      function PropTypes_valueType(props, propName, componentName) {
        var labelInValueShape = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          value: PropTypes_nonEmptyStringType,
          label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node
        });

        if (props.labelInValue) {
          var validate = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(labelInValueShape), labelInValueShape]);
          var error = validate.apply(undefined, arguments);

          if (error) {
            return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`, ' + ('when `labelInValue` is `true`, `' + propName + '` should in ') + 'shape of `{ value: string, label?: string }`.');
          }
        } else if (props.treeCheckable && props.treeCheckStrictly) {
          var _validate = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(labelInValueShape), labelInValueShape]);

          var _error = _validate.apply(undefined, arguments);

          if (_error) {
            return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`, ' + 'when `treeCheckable` and `treeCheckStrictly` are `true`, ' + ('`' + propName + '` should in shape of `{ value: string, label?: string }`.'));
          }
        } else if (props.multiple && props[propName] === '') {
          return new Error('Invalid prop `' + propName + '` of type `string` supplied to `' + componentName + '`, ' + 'expected `array` when `multiple` is `true`.');
        } else {
          var _validate2 = external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string), external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]);

          return _validate2.apply(undefined, arguments);
        }
      }

      var PropTypes_SelectPropTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        filterTreeNode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        showSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showArrow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        allowClear: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        defaultOpen: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        open: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        transitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        animation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        choiceTransitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onDeselect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        searchPlaceholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        inputValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        value: PropTypes_valueType,
        defaultValue: PropTypes_valueType,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        defaultLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        labelInValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        dropdownStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        dropdownPopupAlign: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        onDropdownVisibleChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        maxTagTextLength: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        showCheckedStrategy: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf([SHOW_ALL, SHOW_PARENT, SHOW_CHILD]),
        treeCheckStrictly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        treeIcon: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        treeLine: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        treeDefaultExpandAll: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        treeCheckable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node]),
        treeNodeLabelProp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        treeNodeFilterProp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        treeData: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        treeDataSimpleMode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        loadData: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      }; // CONCATENATED MODULE: ./node_modules/rc-tree-select/es/Select.js

      function Select_noop() {}

      function Select_filterFn(input, child) {
        return String(util_getPropValue(child, util_labelCompatible(this.props.treeNodeFilterProp))).indexOf(input) > -1;
      }

      function Select_loopTreeData(data) {
        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var treeCheckable = arguments[2];
        return data.map(function (item, index) {
          var pos = level + '-' + index;
          var label = item.label,
              value = item.value,
              disabled = item.disabled,
              key = item.key,
              hasOwnProperty = item.hasOwnProperty,
              selectable = item.selectable,
              children = item.children,
              isLeaf = item.isLeaf,
              otherProps = objectWithoutProperties_default()(item, ['label', 'value', 'disabled', 'key', 'hasOwnProperty', 'selectable', 'children', 'isLeaf']);
          var props = extends_default()({
            value: value,
            title: label,
            // value: value || String(key || label), // cause onChange callback error
            key: key || value || pos,
            disabled: disabled || false,
            selectable: selectable === false ? selectable : !treeCheckable
          }, otherProps);
          var ret = void 0;

          if (children && children.length) {
            ret = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_tree_select_es_TreeNode, props, Select_loopTreeData(children, pos, treeCheckable));
          } else {
            ret = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(rc_tree_select_es_TreeNode, extends_default()({}, props, {
              isLeaf: isLeaf
            }));
          }

          return ret;
        });
      }

      var es_Select_Select = function (_Component) {
        inherits_default()(Select, _Component);

        function Select(props) {
          classCallCheck_default()(this, Select);

          var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

          Select_initialiseProps.call(_this);
          var value = [];

          if ('value' in props) {
            value = util_toArray(props.value);
          } else {
            value = util_toArray(props.defaultValue);
          } // save parsed treeData, for performance (treeData may be very big)


          _this.renderedTreeData = _this.renderTreeData();
          value = _this.addLabelToValue(props, value);
          value = _this.getValue(props, value, props.inputValue ? '__strict' : true);
          var inputValue = props.inputValue || ''; // if (props.combobox) {
          //   inputValue = value.length ? String(value[0].value) : '';
          // }

          _this.state = {
            value: value,
            inputValue: inputValue,
            open: props.open || props.defaultOpen,
            focused: false
          };
          return _this;
        }

        Select.prototype.componentDidMount = function componentDidMount() {
          var _props2 = this.props,
              autoFocus = _props2.autoFocus,
              disabled = _props2.disabled;

          if (util_isMultiple(this.props)) {
            var inputNode = this.getInputDOMNode();

            if (inputNode.value) {
              inputNode.style.width = '';
              inputNode.style.width = this.inputMirrorInstance.clientWidth + 'px';
            } else {
              inputNode.style.width = '';
            }
          }

          if (autoFocus && !disabled) {
            this.focus();
          }
        };

        Select.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          // save parsed treeData, for performance (treeData may be very big)
          this.renderedTreeData = this.renderTreeData(nextProps); // Detecting whether the object of `onChange`'s argument  is old ref.
          // Better to do a deep equal later.

          this._cacheTreeNodesStates = this._cacheTreeNodesStates !== 'no' && this._savedValue && nextProps.value === this._savedValue;

          if (this.props.treeData !== nextProps.treeData || this.props.children !== nextProps.children) {
            // refresh this._treeNodesStates cache
            this._treeNodesStates = util_getTreeNodesStates(this.renderedTreeData || nextProps.children, this.state.value.map(function (item) {
              return item.value;
            }));
          }

          if ('value' in nextProps) {
            var value = util_toArray(nextProps.value);
            value = this.addLabelToValue(nextProps, value);
            value = this.getValue(nextProps, value);
            this.setState({
              value: value
            }, this.forcePopupAlign); // if (nextProps.combobox) {
            //   this.setState({
            //     inputValue: value.length ? String(value[0].key) : '',
            //   });
            // }
          }

          if (nextProps.inputValue !== this.props.inputValue) {
            this.setState({
              inputValue: nextProps.inputValue
            });
          }

          if ('open' in nextProps) {
            this.setState({
              open: nextProps.open
            });
          }
        };

        Select.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
          if (this._savedValue && nextProps.value && nextProps.value !== this._savedValue && nextProps.value === this.props.value) {
            this._cacheTreeNodesStates = false;
            this.getValue(nextProps, this.addLabelToValue(nextProps, util_toArray(nextProps.value)));
          }
        };

        Select.prototype.componentDidUpdate = function componentDidUpdate() {
          var state = this.state;
          var props = this.props;

          if (state.open && util_isMultiple(props)) {
            var inputNode = this.getInputDOMNode();

            if (inputNode.value) {
              inputNode.style.width = '';
              inputNode.style.width = this.inputMirrorInstance.clientWidth + 'px';
            } else {
              inputNode.style.width = '';
            }
          }
        };

        Select.prototype.componentWillUnmount = function componentWillUnmount() {
          this.clearDelayTimer();

          if (this.dropdownContainer) {
            external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.unmountComponentAtNode(this.dropdownContainer);
            document.body.removeChild(this.dropdownContainer);
            this.dropdownContainer = null;
          }
        }; // combobox ignore


        Select.prototype.getLabelFromNode = function getLabelFromNode(child) {
          return util_getPropValue(child, this.props.treeNodeLabelProp);
        };

        Select.prototype.getLabelFromProps = function getLabelFromProps(props, value) {
          var _this2 = this;

          if (value === undefined) {
            return null;
          }

          var label = null;
          util_loopAllChildren(this.renderedTreeData || props.children, function (item) {
            if (util_getValuePropValue(item) === value) {
              label = _this2.getLabelFromNode(item);
            }
          });

          if (label === null) {
            return value;
          }

          return label;
        };

        Select.prototype.getDropdownContainer = function getDropdownContainer() {
          if (!this.dropdownContainer) {
            this.dropdownContainer = document.createElement('div');
            document.body.appendChild(this.dropdownContainer);
          }

          return this.dropdownContainer;
        };

        Select.prototype.getSearchPlaceholderElement = function getSearchPlaceholderElement(hidden) {
          var props = this.props;
          var placeholder = void 0;

          if (util_isMultiple(props)) {
            placeholder = props.placeholder || props.searchPlaceholder;
          } else {
            placeholder = props.searchPlaceholder;
          }

          if (placeholder) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              style: {
                display: hidden ? 'none' : 'block'
              },
              onClick: this.onPlaceholderClick,
              className: props.prefixCls + '-search__field__placeholder'
            }, placeholder);
          }

          return null;
        };

        Select.prototype.getInputElement = function getInputElement() {
          var inputValue = this.state.inputValue;
          var _props3 = this.props,
              prefixCls = _props3.prefixCls,
              disabled = _props3.disabled;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: prefixCls + '-search__field__wrap'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('input', {
            ref: util_saveRef(this, 'inputInstance'),
            onChange: this.onInputChange,
            onKeyDown: this.onInputKeyDown,
            value: inputValue,
            disabled: disabled,
            className: prefixCls + '-search__field',
            role: 'textbox'
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            ref: util_saveRef(this, 'inputMirrorInstance'),
            className: prefixCls + '-search__field__mirror'
          }, inputValue, '\xA0'), util_isMultiple(this.props) ? null : this.getSearchPlaceholderElement(!!inputValue));
        };

        Select.prototype.getInputDOMNode = function getInputDOMNode() {
          return this.inputInstance;
        };

        Select.prototype.getPopupDOMNode = function getPopupDOMNode() {
          return this.trigger.getPopupDOMNode();
        };

        Select.prototype.getPopupComponentRefs = function getPopupComponentRefs() {
          return this.trigger.getPopupEleRefs();
        };

        Select.prototype.getValue = function getValue(_props, val) {
          var _this3 = this;

          var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
          var value = val; // if inputValue existing, tree is checkStrictly

          var _strict = init === '__strict' || init && (this.state && this.state.inputValue || this.props.inputValue !== _props.inputValue);

          if (_props.treeCheckable && (_props.treeCheckStrictly || _strict)) {
            this.halfCheckedValues = [];
            value = [];
            val.forEach(function (i) {
              if (!i.halfChecked) {
                value.push(i);
              } else {
                _this3.halfCheckedValues.push(i);
              }
            });
          } // if (!(_props.treeCheckable && !_props.treeCheckStrictly)) {


          if (!!!_props.treeCheckable || _props.treeCheckable && (_props.treeCheckStrictly || _strict)) {
            return value;
          }

          var checkedTreeNodes = void 0;

          if (this._cachetreeData && this._cacheTreeNodesStates && this._checkedNodes && this.state && !this.state.inputValue) {
            this.checkedTreeNodes = checkedTreeNodes = this._checkedNodes;
          } else {
            /**
             * Note: `this._treeNodesStates`'s treeNodesStates must correspond to nodes of the
             * final tree (`processTreeNode` function from SelectTrigger.jsx produce the final tree).
             *
             * And, `this._treeNodesStates` from `onSelect` is previous value,
             * so it perhaps only have a few nodes, but the newly filtered tree can have many nodes,
             * thus, you cannot use previous _treeNodesStates.
             */
            // getTreeNodesStates is not effective.
            this._treeNodesStates = util_getTreeNodesStates(this.renderedTreeData || _props.children, value.map(function (item) {
              return item.value;
            }));
            this.checkedTreeNodes = checkedTreeNodes = this._treeNodesStates.checkedNodes;
          }

          var mapLabVal = function mapLabVal(arr) {
            return arr.map(function (itemObj) {
              return {
                value: util_getValuePropValue(itemObj.node),
                label: util_getPropValue(itemObj.node, _props.treeNodeLabelProp)
              };
            });
          };

          var props = this.props;
          var checkedValues = [];

          if (props.showCheckedStrategy === SHOW_ALL) {
            checkedValues = mapLabVal(checkedTreeNodes);
          } else if (props.showCheckedStrategy === SHOW_PARENT) {
            var posArr = util_filterParentPosition(checkedTreeNodes.map(function (itemObj) {
              return itemObj.pos;
            }));
            checkedValues = mapLabVal(checkedTreeNodes.filter(function (itemObj) {
              return posArr.indexOf(itemObj.pos) !== -1;
            }));
          } else {
            checkedValues = mapLabVal(checkedTreeNodes.filter(function (itemObj) {
              return !itemObj.node.props.children;
            }));
          }

          return checkedValues;
        };

        Select.prototype.getCheckedNodes = function getCheckedNodes(info, props) {
          // TODO treeCheckable does not support tags/dynamic
          var checkedNodes = info.checkedNodes; // if inputValue existing, tree is checkStrictly

          if (props.treeCheckStrictly || this.state.inputValue) {
            return checkedNodes;
          }

          var checkedNodesPositions = info.checkedNodesPositions;

          if (props.showCheckedStrategy === SHOW_ALL) {
            checkedNodes = checkedNodes;
          } else if (props.showCheckedStrategy === SHOW_PARENT) {
            var posArr = util_filterParentPosition(checkedNodesPositions.map(function (itemObj) {
              return itemObj.pos;
            }));
            checkedNodes = checkedNodesPositions.filter(function (itemObj) {
              return posArr.indexOf(itemObj.pos) !== -1;
            }).map(function (itemObj) {
              return itemObj.node;
            });
          } else {
            checkedNodes = checkedNodes.filter(function (n) {
              return !n.props.children;
            });
          }

          return checkedNodes;
        };

        Select.prototype.getDeselectedValue = function getDeselectedValue(selectedValue) {
          var checkedTreeNodes = this.checkedTreeNodes;
          var unCheckPos = void 0;
          checkedTreeNodes.forEach(function (itemObj) {
            if (itemObj.node.props.value === selectedValue) {
              unCheckPos = itemObj.pos;
            }
          });
          var newVals = [];
          var newCkTns = [];
          checkedTreeNodes.forEach(function (itemObj) {
            if (util_isPositionPrefix(itemObj.pos, unCheckPos) || util_isPositionPrefix(unCheckPos, itemObj.pos)) {
              // Filter ancestral and children nodes when uncheck a node.
              return;
            }

            newCkTns.push(itemObj);
            newVals.push(itemObj.node.props.value);
          });
          this.checkedTreeNodes = this._checkedNodes = newCkTns;
          var nv = this.state.value.filter(function (val) {
            return newVals.indexOf(val.value) !== -1;
          });
          this.fireChange(nv, {
            triggerValue: selectedValue,
            clear: true
          });
        };

        Select.prototype.setOpenState = function setOpenState(open, needFocus) {
          var _this4 = this;

          var documentClickClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          this.clearDelayTimer();
          var props = this.props; // can not optimize, if children is empty
          // if (this.state.open === open) {
          //   return;
          // }

          if (!this.props.onDropdownVisibleChange(open, {
            documentClickClose: documentClickClose
          })) {
            return;
          }

          this.setState({
            open: open
          }, function () {
            if (needFocus || open) {
              // Input dom init after first time component render
              // Add delay for this to get focus
              Promise.resolve().then(function () {
                if (open || util_isMultiple(props)) {
                  var input = _this4.getInputDOMNode();

                  if (input && document.activeElement !== input) {
                    input.focus();
                  }
                } else if (_this4.selection) {
                  _this4.selection.focus();
                }
              });
            }
          });
        };

        Select.prototype.clearSearchInput = function clearSearchInput() {
          this.getInputDOMNode().focus();

          if (!('inputValue' in this.props)) {
            this.setState({
              inputValue: ''
            });
          }
        };

        Select.prototype.addLabelToValue = function addLabelToValue(props, value_) {
          var _this5 = this;

          var value = value_;

          if (this.isLabelInValue()) {
            value.forEach(function (v, i) {
              if (Object.prototype.toString.call(value[i]) !== '[object Object]') {
                value[i] = {
                  value: '',
                  label: ''
                };
                return;
              }

              v.label = v.label || _this5.getLabelFromProps(props, v.value);
            });
          } else {
            value = value.map(function (v) {
              return {
                value: v,
                label: _this5.getLabelFromProps(props, v)
              };
            });
          }

          return value;
        };

        Select.prototype.clearDelayTimer = function clearDelayTimer() {
          if (this.delayTimer) {
            clearTimeout(this.delayTimer);
            this.delayTimer = null;
          }
        };

        Select.prototype.removeSelected = function removeSelected(selectedVal, e) {
          var props = this.props;

          if (props.disabled) {
            return;
          } // Do not trigger Trigger popup


          if (e && e.stopPropagation) {
            e.stopPropagation();
          }

          this._cacheTreeNodesStates = 'no';

          if (props.treeCheckable && (props.showCheckedStrategy === SHOW_ALL || props.showCheckedStrategy === SHOW_PARENT) && !(props.treeCheckStrictly || this.state.inputValue)) {
            this.getDeselectedValue(selectedVal);
            return;
          } // click the node's `x`(in select box), likely trigger the TreeNode's `unCheck` event,
          // cautiously, they are completely different, think about it, the tree may not render at first,
          // but the nodes in select box are ready.


          var label = void 0;
          var value = this.state.value.filter(function (singleValue) {
            if (singleValue.value === selectedVal) {
              label = singleValue.label;
            }

            return singleValue.value !== selectedVal;
          });
          var canMultiple = util_isMultiple(props);

          if (canMultiple) {
            var event = selectedVal;

            if (this.isLabelInValue()) {
              event = {
                value: selectedVal,
                label: label
              };
            }

            props.onDeselect(event);
          }

          if (props.treeCheckable) {
            if (this.checkedTreeNodes && this.checkedTreeNodes.length) {
              this.checkedTreeNodes = this._checkedNodes = this.checkedTreeNodes.filter(function (item) {
                return value.some(function (i) {
                  return i.value === item.node.props.value;
                });
              });
            }
          }

          this.fireChange(value, {
            triggerValue: selectedVal,
            clear: true
          });
        };

        Select.prototype.openIfHasChildren = function openIfHasChildren() {
          var props = this.props;

          if (external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.count(props.children) || !util_isMultiple(props)) {
            this.setOpenState(true);
          }
        };

        Select.prototype.fireChange = function fireChange(value) {
          var _this6 = this;

          var extraInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var props = this.props;
          var vals = value.map(function (i) {
            return i.value;
          });
          var sv = this.state.value.map(function (i) {
            return i.value;
          });

          if (vals.length !== sv.length || !vals.every(function (val, index) {
            return sv[index] === val;
          })) {
            var ex = extends_default()({
              preValue: [].concat(this.state.value)
            }, extraInfo);
            var labs = null;
            var vls = value;

            if (!this.isLabelInValue()) {
              labs = value.map(function (i) {
                return i.label;
              });
              vls = vls.map(function (v) {
                return v.value;
              });
            } else if (this.halfCheckedValues && this.halfCheckedValues.length) {
              this.halfCheckedValues.forEach(function (i) {
                if (!vls.some(function (v) {
                  return v.value === i.value;
                })) {
                  vls.push(i);
                }
              });
            }

            if (props.treeCheckable && ex.clear) {
              var treeData = this.renderedTreeData || props.children;
              ex.allCheckedNodes = util_flatToHierarchy(util_filterAllCheckedData(vals, treeData));
            }

            if (props.treeCheckable && this.state.inputValue) {
              var _vls = [].concat(this.state.value);

              if (ex.checked) {
                value.forEach(function (i) {
                  if (_vls.every(function (ii) {
                    return ii.value !== i.value;
                  })) {
                    _vls.push(extends_default()({}, i));
                  }
                });
              } else {
                var index = void 0;

                var includeVal = _vls.some(function (i, ind) {
                  if (i.value === ex.triggerValue) {
                    index = ind;
                    return true;
                  }
                });

                if (includeVal) {
                  _vls.splice(index, 1);
                }
              }

              vls = _vls;

              if (!this.isLabelInValue()) {
                labs = _vls.map(function (v) {
                  return v.label;
                });
                vls = _vls.map(function (v) {
                  return v.value;
                });
              }
            }

            this._savedValue = util_isMultiple(props) ? vls : vls[0];
            props.onChange(this._savedValue, labs, ex);

            if (!('value' in props)) {
              this._cacheTreeNodesStates = false;
              this.setState({
                value: this.getValue(props, util_toArray(this._savedValue).map(function (v, i) {
                  return _this6.isLabelInValue() ? v : {
                    value: v,
                    label: labs && labs[i]
                  };
                }))
              }, this.forcePopupAlign);
            }
          }
        };

        Select.prototype.isLabelInValue = function isLabelInValue() {
          var _props4 = this.props,
              treeCheckable = _props4.treeCheckable,
              treeCheckStrictly = _props4.treeCheckStrictly,
              labelInValue = _props4.labelInValue;

          if (treeCheckable && treeCheckStrictly) {
            return true;
          }

          return labelInValue || false;
        };

        Select.prototype.focus = function focus() {
          if (!util_isMultiple(this.props)) {
            this.selection.focus();
          } else {
            this.getInputDOMNode().focus();
          }
        };

        Select.prototype.blur = function blur() {
          if (!util_isMultiple(this.props)) {
            this.selection.blur();
          } else {
            this.getInputDOMNode().blur();
          }
        };

        Select.prototype.renderTopControlNode = function renderTopControlNode() {
          var _this7 = this;

          var value = this.state.value;
          var props = this.props;
          var choiceTransitionName = props.choiceTransitionName,
              prefixCls = props.prefixCls,
              maxTagTextLength = props.maxTagTextLength;
          var multiple = util_isMultiple(props); // single and not combobox, input is inside dropdown

          if (!multiple) {
            var innerNode = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              key: 'placeholder',
              className: prefixCls + '-selection__placeholder'
            }, props.placeholder);

            if (value.length) {
              innerNode = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
                key: 'value',
                title: util_toTitle(value[0].label),
                className: prefixCls + '-selection-selected-value'
              }, value[0].label);
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-selection__rendered'
            }, innerNode);
          }

          var selectedValueNodes = value.map(function (singleValue) {
            var content = singleValue.label;
            var title = content;

            if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
              content = content.slice(0, maxTagTextLength) + '...';
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', extends_default()({
              style: util_UNSELECTABLE_STYLE
            }, util_UNSELECTABLE_ATTRIBUTE, {
              onMouseDown: util_preventDefaultEvent,
              className: prefixCls + '-selection__choice',
              key: singleValue.value,
              title: util_toTitle(title)
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-selection__choice__remove',
              onClick: function onClick(event) {
                _this7.removeSelected(singleValue.value, event);
              }
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-selection__choice__content'
            }, content));
          });
          selectedValueNodes.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('li', {
            className: prefixCls + '-search ' + prefixCls + '-search--inline',
            key: '__input'
          }, this.getInputElement()));
          var className = prefixCls + '-selection__rendered';

          if (choiceTransitionName) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], {
              className: className,
              component: 'ul',
              transitionName: choiceTransitionName,
              onLeave: this.onChoiceAnimationLeave
            }, selectedValueNodes);
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('ul', {
            className: className
          }, selectedValueNodes);
        };

        Select.prototype.renderTreeData = function renderTreeData(props) {
          var validProps = props || this.props;

          if (validProps.treeData) {
            if (props && props.treeData === this.props.treeData && this.renderedTreeData) {
              // cache and use pre data.
              this._cachetreeData = true;
              return this.renderedTreeData;
            }

            this._cachetreeData = false;
            var treeData = [].concat(validProps.treeData); // process treeDataSimpleMode

            if (validProps.treeDataSimpleMode) {
              var simpleFormat = {
                id: 'id',
                pId: 'pId',
                rootPId: null
              };

              if (Object.prototype.toString.call(validProps.treeDataSimpleMode) === '[object Object]') {
                simpleFormat = extends_default()({}, simpleFormat, validProps.treeDataSimpleMode);
              }

              treeData = util_processSimpleTreeData(treeData, simpleFormat);
            }

            return Select_loopTreeData(treeData, undefined, this.props.treeCheckable);
          }
        };

        Select.prototype.render = function render() {
          var _rootCls;

          var props = this.props;
          var multiple = util_isMultiple(props);
          var state = this.state;
          var className = props.className,
              disabled = props.disabled,
              allowClear = props.allowClear,
              prefixCls = props.prefixCls;
          var ctrlNode = this.renderTopControlNode();
          var extraSelectionProps = {};

          if (!multiple) {
            extraSelectionProps = {
              onKeyDown: this.onKeyDown,
              tabIndex: 0
            };
          }

          var rootCls = (_rootCls = {}, _rootCls[className] = !!className, _rootCls[prefixCls] = 1, _rootCls[prefixCls + '-open'] = state.open, _rootCls[prefixCls + '-focused'] = state.open || state.focused, _rootCls[prefixCls + '-disabled'] = disabled, _rootCls[prefixCls + '-enabled'] = !disabled, _rootCls[prefixCls + '-allow-clear'] = !!props.allowClear, _rootCls);
          var clear = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            key: 'clear',
            className: prefixCls + '-selection__clear',
            onClick: this.onClearSelection
          });
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_SelectTrigger, extends_default()({}, props, {
            treeNodes: props.children,
            treeData: this.renderedTreeData,
            _cachetreeData: this._cachetreeData,
            _treeNodesStates: this._treeNodesStates,
            halfCheckedValues: this.halfCheckedValues,
            multiple: multiple,
            disabled: disabled,
            visible: state.open,
            inputValue: state.inputValue,
            inputElement: this.getInputElement(),
            value: state.value,
            onDropdownVisibleChange: this.onDropdownVisibleChange,
            getPopupContainer: props.getPopupContainer,
            onSelect: this.onSelect,
            ref: util_saveRef(this, 'trigger')
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            style: props.style,
            onClick: props.onClick,
            className: classnames_default()(rootCls),
            onBlur: props.onBlur,
            onFocus: props.onFocus
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', extends_default()({
            ref: util_saveRef(this, 'selection'),
            key: 'selection',
            className: prefixCls + '-selection\n            ' + prefixCls + '-selection--' + (multiple ? 'multiple' : 'single'),
            role: 'combobox',
            'aria-autocomplete': 'list',
            'aria-haspopup': 'true',
            'aria-expanded': state.open
          }, extraSelectionProps), ctrlNode, allowClear && this.state.value.length && this.state.value[0].value ? clear : null, multiple || !props.showArrow ? null : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            key: 'arrow',
            className: prefixCls + '-arrow',
            style: {
              outline: 'none'
            }
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('b', null)), multiple ? this.getSearchPlaceholderElement(!!this.state.inputValue || this.state.value.length) : null)));
        };

        return Select;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      es_Select_Select.propTypes = PropTypes_SelectPropTypes;
      es_Select_Select.defaultProps = {
        prefixCls: 'rc-tree-select',
        filterTreeNode: Select_filterFn,
        // [Legacy] TODO: Set false and filter not hide?
        showSearch: true,
        allowClear: false,
        placeholder: '',
        searchPlaceholder: '',
        labelInValue: false,
        onClick: Select_noop,
        onChange: Select_noop,
        onSelect: Select_noop,
        onDeselect: Select_noop,
        onSearch: Select_noop,
        showArrow: true,
        dropdownMatchSelectWidth: true,
        dropdownStyle: {},
        onDropdownVisibleChange: function onDropdownVisibleChange() {
          return true;
        },
        notFoundContent: 'Not Found',
        showCheckedStrategy: SHOW_CHILD,
        // skipHandleInitValue: false, // Deprecated (use treeCheckStrictly)
        treeCheckStrictly: false,
        treeIcon: false,
        treeLine: false,
        treeDataSimpleMode: false,
        treeDefaultExpandAll: false,
        treeCheckable: false,
        treeNodeFilterProp: 'value',
        treeNodeLabelProp: 'title'
      };

      var Select_initialiseProps = function _initialiseProps() {
        var _this8 = this;

        this.onInputChange = function (event) {
          var val = event.target.value;
          var props = _this8.props;

          _this8.setState({
            inputValue: val,
            open: true
          }, _this8.forcePopupAlign);

          if (props.treeCheckable && !val) {
            _this8.setState({
              value: _this8.getValue(props, [].concat(_this8.state.value), false)
            });
          }

          props.onSearch(val);
        };

        this.onDropdownVisibleChange = function (open) {
          // selection inside combobox cause click
          if (!open && document.activeElement === _this8.getInputDOMNode()) {// return;
          }

          _this8.setOpenState(open, undefined, !open);
        };

        this.onKeyDown = function (event) {
          var props = _this8.props;

          if (props.disabled) {
            return;
          }

          var keyCode = event.keyCode;

          if (_this8.state.open && !_this8.getInputDOMNode()) {
            _this8.onInputKeyDown(event);
          } else if (keyCode === es_KeyCode["a"
          /* default */
          ].ENTER || keyCode === es_KeyCode["a"
          /* default */
          ].DOWN) {
            _this8.setOpenState(true);

            event.preventDefault();
          }
        };

        this.onInputKeyDown = function (event) {
          var props = _this8.props;

          if (props.disabled) {
            return;
          }

          var state = _this8.state;
          var keyCode = event.keyCode;

          if (util_isMultiple(props) && !event.target.value && keyCode === es_KeyCode["a"
          /* default */
          ].BACKSPACE) {
            var value = state.value.concat();

            if (value.length) {
              var popValue = value.pop();

              _this8.removeSelected(_this8.isLabelInValue() ? popValue : popValue.value);
            }

            return;
          }

          if (keyCode === es_KeyCode["a"
          /* default */
          ].DOWN) {
            if (!state.open) {
              _this8.openIfHasChildren();

              event.preventDefault();
              event.stopPropagation();
              return;
            }
          } else if (keyCode === es_KeyCode["a"
          /* default */
          ].ESC) {
            if (state.open) {
              _this8.setOpenState(false);

              event.preventDefault();
              event.stopPropagation();
            }

            return;
          }
        };

        this.onSelect = function (selectedKeys, info) {
          var item = info.node;
          var value = _this8.state.value;
          var props = _this8.props;
          var selectedValue = util_getValuePropValue(item);

          var selectedLabel = _this8.getLabelFromNode(item);

          var checkableSelect = props.treeCheckable && info.event === 'select';
          var event = selectedValue;

          if (_this8.isLabelInValue()) {
            event = {
              value: event,
              label: selectedLabel
            };
          }

          if (info.selected === false) {
            _this8.onDeselect(info);

            if (!checkableSelect) return;
          }

          props.onSelect(event, item, info);
          var checkEvt = info.event === 'check';

          if (util_isMultiple(props)) {
            _this8.clearSearchInput();

            if (checkEvt) {
              value = _this8.getCheckedNodes(info, props).map(function (n) {
                return {
                  value: util_getValuePropValue(n),
                  label: _this8.getLabelFromNode(n)
                };
              });
            } else {
              if (value.some(function (i) {
                return i.value === selectedValue;
              })) {
                return;
              }

              value = value.concat([{
                value: selectedValue,
                label: selectedLabel
              }]);
            }
          } else {
            if (value.length && value[0].value === selectedValue) {
              _this8.setOpenState(false);

              return;
            }

            value = [{
              value: selectedValue,
              label: selectedLabel
            }];

            _this8.setOpenState(false);
          }

          var extraInfo = {
            triggerValue: selectedValue,
            triggerNode: item
          };

          if (checkEvt) {
            extraInfo.checked = info.checked; // if inputValue existing, tree is checkStrictly

            extraInfo.allCheckedNodes = props.treeCheckStrictly || _this8.state.inputValue ? info.checkedNodes : util_flatToHierarchy(info.checkedNodesPositions);
            _this8._checkedNodes = info.checkedNodesPositions;
            var _tree = _this8.trigger.popupEle;
            _this8._treeNodesStates = _tree.checkKeys;
          } else {
            extraInfo.selected = info.selected;
          }

          _this8.fireChange(value, extraInfo);

          if (props.inputValue === null) {
            _this8.setState({
              inputValue: ''
            });
          }
        };

        this.onDeselect = function (info) {
          _this8.removeSelected(util_getValuePropValue(info.node));

          if (!util_isMultiple(_this8.props)) {
            _this8.setOpenState(false);
          } else {
            _this8.clearSearchInput();
          }
        };

        this.onPlaceholderClick = function () {
          _this8.getInputDOMNode().focus();
        };

        this.onClearSelection = function (event) {
          var props = _this8.props;
          var state = _this8.state;

          if (props.disabled) {
            return;
          }

          event.stopPropagation();
          _this8._cacheTreeNodesStates = 'no';
          _this8._checkedNodes = [];

          if (state.inputValue || state.value.length) {
            _this8.setOpenState(false);

            if (typeof props.inputValue === 'undefined') {
              _this8.setState({
                inputValue: ''
              }, function () {
                _this8.fireChange([]);
              });
            } else {
              _this8.fireChange([]);
            }
          }
        };

        this.onChoiceAnimationLeave = function () {
          _this8.forcePopupAlign();
        };

        this.forcePopupAlign = function () {
          _this8.trigger.trigger.forcePopupAlign();
        };
      };

      es_Select_Select.SHOW_ALL = SHOW_ALL;
      es_Select_Select.SHOW_PARENT = SHOW_PARENT;
      es_Select_Select.SHOW_CHILD = SHOW_CHILD;
      /* harmony default export */

      var rc_tree_select_es_Select = es_Select_Select; // CONCATENATED MODULE: ./node_modules/rc-tree-select/es/index.js
      // export this package's api

      rc_tree_select_es_Select.TreeNode = rc_tree_select_es_TreeNode;
      /* harmony default export */

      var rc_tree_select_es = rc_tree_select_es_Select; // CONCATENATED MODULE: ./node_modules/antd/es/tree-select/index.js

      var tree_select_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var tree_select_TreeSelect = function (_React$Component) {
        inherits_default()(TreeSelect, _React$Component);

        function TreeSelect(props) {
          classCallCheck_default()(this, TreeSelect);

          var _this = possibleConstructorReturn_default()(this, (TreeSelect.__proto__ || Object.getPrototypeOf(TreeSelect)).call(this, props));

          _this.saveTreeSelect = function (node) {
            _this.rcTreeSelect = node;
          };

          _this.renderTreeSelect = function (locale) {
            var _classNames;

            var _a = _this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                size = _a.size,
                notFoundContent = _a.notFoundContent,
                dropdownStyle = _a.dropdownStyle,
                dropdownClassName = _a.dropdownClassName,
                restProps = tree_select_rest(_a, ["prefixCls", "className", "size", "notFoundContent", "dropdownStyle", "dropdownClassName"]);
            var cls = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-lg', size === 'large'), defineProperty_default()(_classNames, prefixCls + '-sm', size === 'small'), _classNames), className);
            var checkable = restProps.treeCheckable;

            if (checkable) {
              checkable = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: prefixCls + '-tree-checkbox-inner'
              });
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_tree_select_es, extends_default()({}, restProps, {
              dropdownClassName: classnames_default()(dropdownClassName, prefixCls + '-tree-dropdown'),
              prefixCls: prefixCls,
              className: cls,
              dropdownStyle: extends_default()({
                maxHeight: '100vh',
                overflow: 'auto'
              }, dropdownStyle),
              treeCheckable: checkable,
              notFoundContent: notFoundContent || locale.notFoundContent,
              ref: _this.saveTreeSelect
            }));
          };

          _util_warning(props.multiple !== false || !props.treeCheckable, '`multiple` will alway be `true` when `treeCheckable` is true');

          return _this;
        }

        createClass_default()(TreeSelect, [{
          key: 'focus',
          value: function focus() {
            this.rcTreeSelect.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.rcTreeSelect.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
              componentName: 'Select',
              defaultLocale: {}
            }, this.renderTreeSelect);
          }
        }]);
        return TreeSelect;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var tree_select = tree_select_TreeSelect;
      tree_select_TreeSelect.TreeNode = rc_tree_select_es_TreeNode;
      tree_select_TreeSelect.SHOW_ALL = SHOW_ALL;
      tree_select_TreeSelect.SHOW_PARENT = SHOW_PARENT;
      tree_select_TreeSelect.SHOW_CHILD = SHOW_CHILD;
      tree_select_TreeSelect.defaultProps = {
        prefixCls: 'ant-select',
        transitionName: 'slide-up',
        choiceTransitionName: 'zoom',
        showSearch: false
      }; // CONCATENATED MODULE: ./node_modules/antd/es/tag/CheckableTag.js

      var CheckableTag_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var CheckableTag_CheckableTag = function (_React$Component) {
        inherits_default()(CheckableTag, _React$Component);

        function CheckableTag() {
          classCallCheck_default()(this, CheckableTag);

          var _this = possibleConstructorReturn_default()(this, (CheckableTag.__proto__ || Object.getPrototypeOf(CheckableTag)).apply(this, arguments));

          _this.handleClick = function () {
            var _this$props = _this.props,
                checked = _this$props.checked,
                onChange = _this$props.onChange;

            if (onChange) {
              onChange(!checked);
            }
          };

          return _this;
        }

        createClass_default()(CheckableTag, [{
          key: 'render',
          value: function render() {
            var _classNames;

            var _a = this.props,
                _a$prefixCls = _a.prefixCls,
                prefixCls = _a$prefixCls === undefined ? 'ant-tag' : _a$prefixCls,
                className = _a.className,
                checked = _a.checked,
                restProps = CheckableTag_rest(_a, ["prefixCls", "className", "checked"]);
            var cls = classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-checkable', true), defineProperty_default()(_classNames, prefixCls + '-checkable-checked', checked), _classNames), className);
            delete restProps.onChange; // TypeScript cannot check delete now.

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({}, restProps, {
              className: cls,
              onClick: this.handleClick
            }));
          }
        }]);
        return CheckableTag;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var tag_CheckableTag = CheckableTag_CheckableTag; // CONCATENATED MODULE: ./node_modules/antd/es/tag/index.js

      var tag_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var tag_Tag = function (_React$Component) {
        inherits_default()(Tag, _React$Component);

        function Tag(props) {
          classCallCheck_default()(this, Tag);

          var _this = possibleConstructorReturn_default()(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).call(this, props));

          _this.close = function (e) {
            var onClose = _this.props.onClose;

            if (onClose) {
              onClose(e);
            }

            if (e.defaultPrevented) {
              return;
            }

            var dom = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](_this);
            dom.style.width = dom.getBoundingClientRect().width + 'px'; // It's Magic Code, don't know why

            dom.style.width = dom.getBoundingClientRect().width + 'px';

            _this.setState({
              closing: true
            });
          };

          _this.animationEnd = function (_, existed) {
            if (!existed && !_this.state.closed) {
              _this.setState({
                closed: true,
                closing: false
              });

              var afterClose = _this.props.afterClose;

              if (afterClose) {
                afterClose();
              }
            }
          };

          _this.state = {
            closing: false,
            closed: false
          };
          return _this;
        }

        createClass_default()(Tag, [{
          key: 'isPresetColor',
          value: function isPresetColor(color) {
            if (!color) {
              return false;
            }

            return /^(pink|red|yellow|orange|cyan|green|blue|purple|geekblue|magenta|volcano|gold|lime)(-inverse)?$/.test(color);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                closable = _a.closable,
                color = _a.color,
                className = _a.className,
                children = _a.children,
                style = _a.style,
                otherProps = tag_rest(_a, ["prefixCls", "closable", "color", "className", "children", "style"]);
            var closeIcon = closable ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'cross',
              onClick: this.close
            }) : '';
            var isPresetColor = this.isPresetColor(color);
            var classString = classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-' + color, isPresetColor), defineProperty_default()(_classNames, prefixCls + '-has-color', color && !isPresetColor), defineProperty_default()(_classNames, prefixCls + '-close', this.state.closing), _classNames), className); // fix https://fb.me/react-unknown-prop

            var divProps = Object(es["default"])(otherProps, ['onClose', 'afterClose']);
            var tagStyle = extends_default()({
              backgroundColor: color && !isPresetColor ? color : null
            }, style);
            var tag = this.state.closed ? null : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', extends_default()({
              'data-show': !this.state.closing
            }, divProps, {
              className: classString,
              style: tagStyle
            }), children, closeIcon);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], {
              component: '',
              showProp: 'data-show',
              transitionName: prefixCls + '-zoom',
              transitionAppear: true,
              onEnd: this.animationEnd
            }, tag);
          }
        }]);
        return Tag;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_tag = tag_Tag;
      tag_Tag.CheckableTag = tag_CheckableTag;
      tag_Tag.defaultProps = {
        prefixCls: 'ant-tag',
        closable: false
      }; // CONCATENATED MODULE: ./node_modules/antd/es/timeline/TimelineItem.js

      var TimelineItem_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var TimelineItem_TimelineItem = function (_React$Component) {
        inherits_default()(TimelineItem, _React$Component);

        function TimelineItem() {
          classCallCheck_default()(this, TimelineItem);
          return possibleConstructorReturn_default()(this, (TimelineItem.__proto__ || Object.getPrototypeOf(TimelineItem)).apply(this, arguments));
        }

        createClass_default()(TimelineItem, [{
          key: 'render',
          value: function render() {
            var _classNames, _classNames2;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                _a$color = _a.color,
                color = _a$color === undefined ? '' : _a$color,
                last = _a.last,
                children = _a.children,
                pending = _a.pending,
                dot = _a.dot,
                restProps = TimelineItem_rest(_a, ["prefixCls", "className", "color", "last", "children", "pending", "dot"]);
            var itemClassName = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-item', true), defineProperty_default()(_classNames, prefixCls + '-item-last', last), defineProperty_default()(_classNames, prefixCls + '-item-pending', pending), _classNames), className);
            var dotClassName = classnames_default()((_classNames2 = {}, defineProperty_default()(_classNames2, prefixCls + '-item-head', true), defineProperty_default()(_classNames2, prefixCls + '-item-head-custom', dot), defineProperty_default()(_classNames2, prefixCls + '-item-head-' + color, true), _classNames2));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('li', extends_default()({}, restProps, {
              className: itemClassName
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-item-tail'
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: dotClassName,
              style: {
                borderColor: /blue|red|green/.test(color) ? null : color
              }
            }, dot), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: prefixCls + '-item-content'
            }, children));
          }
        }]);
        return TimelineItem;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var timeline_TimelineItem = TimelineItem_TimelineItem;
      TimelineItem_TimelineItem.defaultProps = {
        prefixCls: 'ant-timeline',
        color: 'blue',
        last: false,
        pending: false
      }; // CONCATENATED MODULE: ./node_modules/antd/es/timeline/Timeline.js

      var Timeline_rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var Timeline_Timeline = function (_React$Component) {
        inherits_default()(Timeline, _React$Component);

        function Timeline() {
          classCallCheck_default()(this, Timeline);
          return possibleConstructorReturn_default()(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).apply(this, arguments));
        }

        createClass_default()(Timeline, [{
          key: 'render',
          value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                children = _a.children,
                pending = _a.pending,
                pendingDot = _a.pendingDot,
                className = _a.className,
                restProps = Timeline_rest(_a, ["prefixCls", "children", "pending", "pendingDot", "className"]);
            var pendingNode = typeof pending === 'boolean' ? null : pending;
            var classString = classnames_default()(prefixCls, defineProperty_default()({}, prefixCls + '-pending', !!pending), className); // Remove falsy items

            var falsylessItems = external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].toArray(children).filter(function (item) {
              return !!item;
            });
            var items = external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].map(falsylessItems, function (ele, idx) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["cloneElement"](ele, {
                last: idx === external_root_React_commonjs2_react_commonjs_react_amd_react_["Children"].count(falsylessItems) - 1
              });
            });
            var pendingItem = !!pending ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](timeline_TimelineItem, {
              pending: !!pending,
              dot: pendingDot || external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: 'loading'
              })
            }, pendingNode) : null;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('ul', extends_default()({}, restProps, {
              className: classString
            }), items, pendingItem);
          }
        }]);
        return Timeline;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var timeline_Timeline = Timeline_Timeline;
      Timeline_Timeline.Item = timeline_TimelineItem;
      Timeline_Timeline.defaultProps = {
        prefixCls: 'ant-timeline'
      }; // CONCATENATED MODULE: ./node_modules/antd/es/timeline/index.js

      /* harmony default export */

      var timeline = timeline_Timeline; // EXTERNAL MODULE: ./node_modules/draft-js/lib/Draft.js

      var Draft = __webpack_require__(31); // EXTERNAL MODULE: ./node_modules/rc-editor-core/es/EditorCore/index.js


      var EditorCore = __webpack_require__(191); // CONCATENATED MODULE: ./node_modules/rc-editor-core/es/index.js


      var es_GetText = EditorCore["a"
      /* default */
      ].GetText,
          es_GetHTML = EditorCore["a"
      /* default */
      ].GetHTML;
      var es_toEditorState = EditorCore["a"
      /* default */
      ].ToEditorState;
      var es_EditorCorePublic = {
        EditorCore: EditorCore["a"
        /* default */
        ],
        GetText: es_GetText,
        GetHTML: es_GetHTML,
        toEditorState: es_toEditorState
      };
      /* harmony default export */

      var rc_editor_core_es = es_EditorCorePublic; // EXTERNAL MODULE: ./node_modules/draft-js/lib/DraftOffsetKey.js

      var DraftOffsetKey = __webpack_require__(182); // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/component/Nav.react.js


      var Nav_react_Nav = function (_Component) {
        inherits_default()(Nav, _Component);

        function Nav() {
          classCallCheck_default()(this, Nav);
          return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
        }

        Nav.prototype.render = function render() {
          var props = this.props;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', props);
        };

        return Nav;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var Nav_react = Nav_react_Nav; // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/component/SuggestionWrapper.react.js

      var SuggestionWrapper_react_IS_REACT_16 = !!external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["createPortal"];

      var SuggestionWrapper_react_SuggestionWrapper = function (_React$Component) {
        inherits_default()(SuggestionWrapper, _React$Component);

        function SuggestionWrapper() {
          classCallCheck_default()(this, SuggestionWrapper);
          return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
        }

        SuggestionWrapper.prototype.componentDidMount = function componentDidMount() {
          this.renderOrReady();
        };

        SuggestionWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
          this.renderOrReady();
        };

        SuggestionWrapper.prototype.renderOrReady = function renderOrReady() {
          if (SuggestionWrapper_react_IS_REACT_16) {
            this.props.renderReady();
          } else {
            this.renderComponent();
          }
        };

        SuggestionWrapper.prototype.renderComponent = function renderComponent() {
          var _props = this.props,
              children = _props.children,
              container = _props.container,
              renderReady = _props.renderReady;
          Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["unstable_renderSubtreeIntoContainer"])(this, children, container, function callback() {
            if (renderReady) {
              renderReady.call(this);
            }
          });
        };

        SuggestionWrapper.prototype.render = function render() {
          if (SuggestionWrapper_react_IS_REACT_16) {
            var _props2 = this.props,
                children = _props2.children,
                container = _props2.container;
            return Object(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["createPortal"])(children, container);
          }

          return null;
        };

        return SuggestionWrapper;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);
      /* harmony default export */


      var SuggestionWrapper_react = SuggestionWrapper_react_SuggestionWrapper;
      SuggestionWrapper_react_SuggestionWrapper.propTypes = {
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        renderReady: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        container: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      }; // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/utils/getSearchWord.js

      function getWord(text, position) {
        var str = String(text);
        /* eslint no-bitwise:0 */

        var pos = Number(position) >>> 0; // Search for the word's beginning and end.

        var left = str.slice(0, pos + 1).search(/\S+$/);
        var right = str.slice(pos).search(/\s/);

        if (right < 0) {
          return {
            word: str.slice(left),
            begin: left,
            end: str.length
          };
        } // Return the word, using the located bounds to extract it from the string.


        return {
          word: str.slice(left, right + pos),
          begin: left,
          end: right + pos
        };
      }

      function getSearchWord(editorState, selection) {
        var anchorKey = selection.getAnchorKey();
        var anchorOffset = selection.getAnchorOffset() - 1;
        var currentContent = editorState.getCurrentContent();
        var currentBlock = currentContent.getBlockForKey(anchorKey);

        if (currentBlock) {
          var blockText = currentBlock.getText();
          return getWord(blockText, anchorOffset);
        }

        return '';
      } // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/utils/insertMention.js


      function insertMention_insertMention(editorState, mention, data, mode) {
        var entityMode = mode === 'immutable' ? 'IMMUTABLE' : 'MUTABLE';
        var selection = editorState.getSelection();
        var contentState = editorState.getCurrentContent();
        contentState.createEntity('mention', entityMode, data || mention);
        var searchWord = getSearchWord(editorState, selection);
        var begin = searchWord.begin,
            end = searchWord.end;
        var replacedContent = Draft["Modifier"].replaceText(contentState, selection.merge({
          anchorOffset: begin,
          focusOffset: end
        }), mention, null, contentState.getLastCreatedEntityKey());
        var InsertSpaceContent = Draft["Modifier"].insertText(replacedContent, replacedContent.getSelectionAfter(), ' ');
        var newEditorState = Draft["EditorState"].push(editorState, InsertSpaceContent, 'insert-mention');
        return Draft["EditorState"].forceSelection(newEditorState, InsertSpaceContent.getSelectionAfter());
      } // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/utils/clearMention.js


      function clearMention_clearMention(editorState) {
        var selection = editorState.getSelection();
        var searchWord = getSearchWord(editorState, selection);
        var begin = searchWord.begin,
            end = searchWord.end;
        var replacedContent = Draft["Modifier"].replaceText(editorState.getCurrentContent(), selection.merge({
          anchorOffset: begin,
          focusOffset: end
        }), '', null);
        var InsertSpaceContent = Draft["Modifier"].insertText(replacedContent, replacedContent.getSelectionAfter(), ' ');
        var newEditorState = Draft["EditorState"].push(editorState, InsertSpaceContent, 'insert-mention');
        return Draft["EditorState"].forceSelection(newEditorState, InsertSpaceContent.getSelectionAfter());
      } // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/utils/getOffset.js


      function getOffset_getOffset(element, container) {
        var rect = element.getBoundingClientRect();

        if (rect.width || rect.height) {
          var elementContainer = container || element.parentElement;
          return {
            top: rect.top - elementContainer.clientTop,
            left: rect.left - elementContainer.clientLeft
          };
        }

        return rect;
      } // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/utils/getRegExp.js


      function getRegExp(prefix) {
        var prefixArray = Array.isArray(prefix) ? prefix : [prefix];
        var prefixToken = prefixArray.join('').replace(/(\$|\^)/g, '\\$1');

        if (prefixArray.length > 1) {
          prefixToken = '[' + prefixToken + ']';
        }

        return new RegExp('(\\s|^)(' + prefixToken + ')[^\\s]*', 'g');
      } // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/utils/getMentions.js


      function getMentions_getMentions(contentState) {
        var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '@';
        var regex = getRegExp(prefix);
        var entities = [];
        contentState.getBlockMap().forEach(function (block) {
          var blockText = block.getText();
          var matchArr = void 0;

          while ((matchArr = regex.exec(blockText)) !== null) {
            // eslint-disable-line
            entities.push(matchArr[0].trim());
          }
        });
        return entities;
      } // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/component/Suggestions.react.js


      var Suggestions_react_isNotFalse = function isNotFalse(i) {
        return i !== false;
      };

      var Suggestions_react_Suggestions = function (_React$Component) {
        inherits_default()(Suggestions, _React$Component);

        function Suggestions() {
          classCallCheck_default()(this, Suggestions);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this));

          _this.onEditorStateChange = function (editorState) {
            var offset = _this.props.store.getOffset();

            if (offset.size === 0) {
              _this.closeDropDown();

              return editorState;
            }

            var selection = editorState.getSelection(); // 修复: 焦点移出再移入时, dropdown 会闪动一下
            // 原因: https://github.com/facebook/draft-js/blob/67c5e69499e3b0c149ce83b004872afdf4180463/src/component/handlers/edit/editOnFocus.js#L33
            // 此处强制 update 了一下,因此 onEditorStateChange 会 call 两次

            if (!_this.props.callbacks.getEditorState().getSelection().getHasFocus() && selection.getHasFocus()) {
              return editorState;
            }

            var _getSearchWord = getSearchWord(editorState, selection),
                word = _getSearchWord.word;

            if (!word) {
              _this.closeDropDown();

              return editorState;
            }

            var selectionInsideMention = offset.map(function (_ref) {
              var offsetKey = _ref.offsetKey;

              var _decode = Object(DraftOffsetKey["decode"])(offsetKey),
                  blockKey = _decode.blockKey,
                  decoratorKey = _decode.decoratorKey,
                  leafKey = _decode.leafKey;

              if (blockKey !== selection.anchorKey) {
                return false;
              }

              var leaf = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]);

              if (!leaf) {
                return false;
              }

              var startKey = leaf.get('start');
              var endKey = leaf.get('end'); // 处理只有一个 `@` 符号时的情况

              if (!word) {
                return false;
              }

              if (startKey === endKey - 1) {
                return selection.anchorOffset >= startKey + 1 && selection.anchorOffset <= endKey ? offsetKey : false;
              }

              return selection.anchorOffset > startKey + 1 && selection.anchorOffset <= endKey ? offsetKey : false;
            });
            var selectionInText = selectionInsideMention.some(Suggestions_react_isNotFalse);
            _this.activeOffsetKey = selectionInsideMention.find(Suggestions_react_isNotFalse) || _this.activeOffsetKey;

            var trigger = _this.props.store.getTrigger(_this.activeOffsetKey);

            if (!selectionInText || !selection.getHasFocus()) {
              _this.closeDropDown();

              return editorState;
            }

            var searchValue = word.substring(trigger.length, word.length);

            if (_this.lastSearchValue !== searchValue || _this.lastTrigger !== trigger) {
              _this.lastSearchValue = searchValue;
              _this.lastTrigger = trigger;

              _this.props.onSearchChange(searchValue, trigger);
            }

            if (!_this.state.active) {
              // 特例处理 https://github.com/ant-design/ant-design/issues/7838
              // 暂时没有更优雅的方法
              if (!trigger || word.indexOf(trigger) !== -1) {
                _this.openDropDown();
              }
            }

            return editorState;
          };

          _this.onUpArrow = function (ev) {
            ev.preventDefault();

            if (_this.props.suggestions.length > 0) {
              var newIndex = _this.state.focusedIndex - 1;

              _this.setState({
                focusedIndex: Math.max(newIndex, 0)
              });
            }
          };

          _this.onBlur = function (ev) {
            ev.preventDefault();

            _this.closeDropDown();
          };

          _this.onDownArrow = function (ev) {
            ev.preventDefault();
            var newIndex = _this.state.focusedIndex + 1;

            _this.setState({
              focusedIndex: newIndex >= _this.props.suggestions.length ? 0 : newIndex
            });
          };

          _this.getContainer = function () {
            var popupContainer = document.createElement('div');
            var mountNode = void 0;

            if (_this.props.getSuggestionContainer) {
              mountNode = _this.props.getSuggestionContainer();
              popupContainer.style.position = 'relative';
            } else {
              mountNode = document.body;
            }

            mountNode.appendChild(popupContainer);
            return popupContainer;
          };

          _this.handleKeyBinding = function (command) {
            return command === 'split-block';
          };

          _this.handleReturn = function (ev) {
            ev.preventDefault();
            var selectedSuggestion = _this.props.suggestions[_this.state.focusedIndex];

            if (selectedSuggestion) {
              if (external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.isValidElement(selectedSuggestion)) {
                _this.onMentionSelect(selectedSuggestion.props.value, selectedSuggestion.props.data);
              } else {
                _this.onMentionSelect(selectedSuggestion);
              }

              _this.lastSearchValue = null;
              _this.lastTrigger = null;
              return true;
            }

            return false;
          };

          _this.renderReady = function () {
            var container = _this.dropdownContainer;

            if (!container) {
              return;
            }

            var active = _this.state.active;
            var activeOffsetKey = _this.activeOffsetKey;

            var offset = _this.props.store.getOffset();

            var dropDownPosition = offset.get(activeOffsetKey);

            if (active && dropDownPosition) {
              var placement = _this.props.placement;

              var dropDownStyle = _this.getPositionStyle(true, dropDownPosition.position()); // Check if the above space is crowded


              var isTopCrowded = parseFloat(dropDownStyle.top) - window.scrollY - container.offsetHeight < 0; // Check if the under space is crowded

              var isBottomCrowded = (window.innerHeight || document.documentElement.clientHeight) - (parseFloat(dropDownStyle.top) - window.scrollY) - container.offsetHeight < 0;

              if (placement === 'top' && !isTopCrowded) {
                // The above space isn't crowded
                dropDownStyle.top = (parseFloat(dropDownStyle.top) - container.offsetHeight || 0) + 'px';
              }

              if (placement === 'bottom' && isBottomCrowded && !isTopCrowded) {
                // The above space isn't crowded and the under space is crowded.
                dropDownStyle.top = (parseFloat(dropDownStyle.top) - container.offsetHeight || 0) + 'px';
              }

              Object.keys(dropDownStyle).forEach(function (key) {
                container.style[key] = dropDownStyle[key];
              });
            }

            if (!_this.focusItem) {
              return;
            }

            dom_scroll_into_view_lib_default()(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(_this.focusItem), container, {
              onlyScrollIfNeeded: true
            });
          };

          _this.getNavigations = function () {
            var _this$props = _this.props,
                prefixCls = _this$props.prefixCls,
                suggestions = _this$props.suggestions;
            var focusedIndex = _this.state.focusedIndex;
            return suggestions.length ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.map(suggestions, function (element, index) {
              var focusItem = index === focusedIndex;
              var ref = focusItem ? function (node) {
                _this.focusItem = node;
              } : null;
              var mentionClass = classnames_default()(prefixCls + '-dropdown-item', {
                focus: focusItem
              });

              if (external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.isValidElement(element)) {
                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(element, {
                  className: mentionClass,
                  onMouseDown: function onMouseDown() {
                    return _this.onDropdownMentionSelect(element.props.value, element.props.data);
                  },
                  ref: ref
                });
              }

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Nav_react, {
                ref: ref,
                className: mentionClass,
                onMouseDown: function onMouseDown() {
                  return _this.onDropdownMentionSelect(element);
                }
              }, element);
            }, _this) : external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-dropdown-notfound ' + prefixCls + '-dropdown-item'
            }, _this.props.notFoundContent);
          };

          _this.state = {
            isActive: false,
            focusedIndex: 0,
            container: false
          };
          return _this;
        }

        Suggestions.prototype.componentDidMount = function componentDidMount() {
          this.props.callbacks.onChange = this.onEditorStateChange;
        };

        Suggestions.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          if (nextProps.suggestions.length !== this.props.suggestions.length) {
            this.setState({
              focusedIndex: 0
            });
          }
        };

        Suggestions.prototype.onDropdownMentionSelect = function onDropdownMentionSelect(mention, data) {
          var _this2 = this;

          setTimeout(function () {
            _this2.onMentionSelect(mention, data);
          }, 100);
        };

        Suggestions.prototype.onMentionSelect = function onMentionSelect(mention, data) {
          var editorState = this.props.callbacks.getEditorState();
          var _props = this.props,
              store = _props.store,
              onSelect = _props.onSelect;
          var trigger = store.getTrigger(this.activeOffsetKey);

          if (onSelect) {
            onSelect(mention, data || mention);
          }

          if (this.props.noRedup) {
            var mentions = getMentions_getMentions(editorState.getCurrentContent(), trigger);

            if (mentions.indexOf('' + trigger + mention) !== -1) {
              // eslint-disable-next-line
              console.warn('you have specified `noRedup` props but have duplicated mentions.');
              this.closeDropDown();
              this.props.callbacks.setEditorState(clearMention_clearMention(editorState));
              return;
            }
          }

          this.props.callbacks.setEditorState(insertMention_insertMention(editorState, '' + trigger + mention, data, this.props.mode), true);
          this.closeDropDown();
        };

        Suggestions.prototype.getPositionStyle = function getPositionStyle(isActive, position) {
          if (this.props.getSuggestionStyle) {
            return this.props.getSuggestionStyle(isActive, position);
          }

          var container = this.props.getSuggestionContainer ? this.state.container : document.body;
          var offset = getOffset_getOffset(container);
          return position ? extends_default()({
            position: 'absolute',
            left: position.left - offset.left + 'px',
            top: position.top - offset.top + 'px'
          }, this.props.style) : {};
        };

        Suggestions.prototype.openDropDown = function openDropDown() {
          this.props.callbacks.onUpArrow = this.onUpArrow;
          this.props.callbacks.handleReturn = this.handleReturn;
          this.props.callbacks.handleKeyBinding = this.handleKeyBinding;
          this.props.callbacks.onDownArrow = this.onDownArrow;
          this.props.callbacks.onBlur = this.onBlur;
          this.setState({
            active: true,
            container: this.state.container || this.getContainer()
          });
        };

        Suggestions.prototype.closeDropDown = function closeDropDown() {
          this.props.callbacks.onUpArrow = null;
          this.props.callbacks.handleReturn = null;
          this.props.callbacks.handleKeyBinding = null;
          this.props.callbacks.onDownArrow = null;
          this.props.callbacks.onBlur = null;
          this.setState({
            active: false
          });
        };

        Suggestions.prototype.render = function render() {
          var _extends2,
              _this3 = this;

          var _props2 = this.props,
              prefixCls = _props2.prefixCls,
              className = _props2.className,
              placement = _props2.placement;
          var _state = this.state,
              container = _state.container,
              active = _state.active;
          var cls = classnames_default()(extends_default()((_extends2 = {}, _extends2[prefixCls + '-dropdown'] = true, _extends2[prefixCls + '-dropdown-placement-' + placement] = true, _extends2), className));
          var transitionName = placement === 'top' ? 'slide-down' : 'slide-up';
          var navigations = this.getNavigations();
          return container ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(SuggestionWrapper_react, {
            renderReady: this.renderReady,
            container: container
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], {
            transitionName: transitionName
          }, active ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: cls,
            ref: function ref(node) {
              _this3.dropdownContainer = node;
            }
          }, navigations) : null)) : null;
        };

        return Suggestions;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);
      /* harmony default export */


      var Suggestions_react = Suggestions_react_Suggestions;
      Suggestions_react_Suggestions.propTypes = {
        callbacks: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        suggestions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        store: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        onSearchChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        mode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        getSuggestionContainer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        notFoundContent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        getSuggestionStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        noRedup: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        placement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      }; // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/component/SuggestionPortal.react.js

      var SuggestionPortal_react_SuggestionPortal = function (_React$Component) {
        inherits_default()(SuggestionPortal, _React$Component);

        function SuggestionPortal() {
          var _temp, _this, _ret;

          classCallCheck_default()(this, SuggestionPortal);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.matchDecorates = function (props) {
            var callbacks = props.callbacks,
                suggestionRegex = props.suggestionRegex,
                decoratedText = props.decoratedText;
            var matches = suggestionRegex.exec(decoratedText);
            _this.trigger = matches[2];

            _this.updatePortalPosition(_this.props);

            callbacks.setEditorState(callbacks.getEditorState());
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        SuggestionPortal.prototype.componentWillMount = function componentWillMount() {
          this.matchDecorates(this.props);
        };

        SuggestionPortal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          if (nextProps.decoratedText !== this.props.decoratedText) {
            this.matchDecorates(nextProps);
          }

          this.updatePortalPosition(nextProps);
        };

        SuggestionPortal.prototype.componentWillUnmount = function componentWillUnmount() {
          var _props = this.props,
              offsetKey = _props.offsetKey,
              mentionStore = _props.mentionStore;
          mentionStore.inActiveSuggestion({
            offsetKey: offsetKey
          });
        };

        SuggestionPortal.prototype.updatePortalPosition = function updatePortalPosition(props) {
          var _this2 = this;

          var offsetKey = props.offsetKey,
              mentionStore = props.mentionStore;
          mentionStore.updateSuggestion({
            offsetKey: offsetKey,
            trigger: this.trigger,
            position: function position() {
              var element = _this2.searchPortal;
              var rect = getOffset_getOffset(element);
              return {
                left: rect.left,
                top: rect.top,
                width: element.offsetWidth,
                height: element.offsetHeight
              };
            }
          });
        };

        SuggestionPortal.prototype.render = function render() {
          var _this3 = this;

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            ref: function ref(node) {
              _this3.searchPortal = node;
            },
            style: this.props.style
          }, this.props.children);
        };

        return SuggestionPortal;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      SuggestionPortal_react_SuggestionPortal.propTypes = {
        offsetKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        mentionStore: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        decoratedText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        callbacks: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        suggestionRegex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      /* harmony default export */

      var SuggestionPortal_react = SuggestionPortal_react_SuggestionPortal; // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/component/MentionContent.react.js

      var MentionContent_react_MentionContent = function MentionContent(_ref) {
        var children = _ref.children;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
          style: {
            backgroundColor: '#e6f3ff'
          }
        }, children);
      };
      /* harmony default export */


      var MentionContent_react = MentionContent_react_MentionContent; // EXTERNAL MODULE: ./node_modules/immutable/dist/immutable.js

      var immutable = __webpack_require__(66); // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/model/mentionStore.js

      /* eslint new-cap: [2, {capIsNewExceptions: ["Map"]}] */


      var mentionStore_offset = Object(immutable["Map"])();
      var mentionStore_mentionStore = {
        offset: Object(immutable["Map"])(),
        getOffset: function getOffset() {
          return mentionStore_offset;
        },
        getTrigger: function getTrigger(offsetKey) {
          var currentOffset = mentionStore_offset.get(offsetKey);
          return currentOffset && currentOffset.trigger;
        },
        activeSuggestion: function activeSuggestion(_ref) {
          var offsetKey = _ref.offsetKey;
          mentionStore_offset = mentionStore_offset.set(offsetKey, {
            offsetKey: offsetKey
          });
        },
        inActiveSuggestion: function inActiveSuggestion(_ref2) {
          var offsetKey = _ref2.offsetKey;
          mentionStore_offset = mentionStore_offset['delete'](offsetKey);
        },
        updateSuggestion: function updateSuggestion(_ref3) {
          var offsetKey = _ref3.offsetKey,
              position = _ref3.position,
              trigger = _ref3.trigger;
          mentionStore_offset = mentionStore_offset.set(offsetKey, {
            offsetKey: offsetKey,
            position: position,
            trigger: trigger
          });
        }
      };
      /* harmony default export */

      var model_mentionStore = mentionStore_mentionStore; // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/utils/exportContent.js

      function exportContent_encodeContent(text) {
        return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join('<br > \n');
      }

      var exportContent_MentionGenerator = function () {
        function MentionGenerator(contentState, options) {
          classCallCheck_default()(this, MentionGenerator);
          this.contentState = contentState;
          this.options = options;
        }

        MentionGenerator.prototype.generate = function generate() {
          var contentRaw = Object(Draft["convertToRaw"])(this.contentState);
          return this.processContent(contentRaw);
        };

        MentionGenerator.prototype.processContent = function processContent(contentRaw) {
          var blocks = contentRaw.blocks;
          var encode = this.options.encode;
          return blocks.map(function (block) {
            return encode ? exportContent_encodeContent(block.text) : block.text;
          }).join(encode ? '<br />\n' : '\n');
        };

        return MentionGenerator;
      }();

      function exportContent_exportContent(contentState) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new exportContent_MentionGenerator(contentState, options).generate();
      } // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/utils/createMention.js


      function createMention_findWithRegex(regex, contentBlock, callback) {
        // Get the text from the contentBlock
        var text = contentBlock.getText();
        var matchArr = void 0;
        var start = void 0; // eslint-disable-line

        var end = void 0; // Go through all matches in the text and return the indizes to the callback

        while ((matchArr = regex.exec(text)) !== null) {
          // eslint-disable-line
          start = matchArr.index;
          end = start + matchArr[0].length;
          callback(start, end);
          if (start === end) break;
        }
      }

      function createMention_mentionContentStrategy(contentBlock, callback, contentState) {
        contentBlock.findEntityRanges(function (character) {
          var entityKey = character.getEntity();
          return entityKey && contentState.getEntity(entityKey).getType() === 'mention';
        }, callback);
      }

      function createMention_noop() {}

      var createMention_MentionContentComponent = function MentionContentComponent(props) {
        var entityKey = props.entityKey,
            tag = props.tag,
            callbacks = props.callbacks;
        var contentState = callbacks.getEditorState().getCurrentContent();
        var data = contentState.getEntity(entityKey).getData();
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(tag, extends_default()({}, props, {
          data: data
        }));
      };

      function createMention_createMention() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callbacks = {
          onChange: createMention_noop,
          onUpArrow: createMention_noop,
          onDownArrow: createMention_noop,
          getEditorState: createMention_noop,
          setEditorState: createMention_noop,
          handleReturn: createMention_noop,
          onBlur: createMention_noop
        };
        var componentProps = {
          callbacks: callbacks,
          mentionStore: model_mentionStore
        };
        var suggestionRegex = getRegExp(config.prefix);
        var tag = config.tag || MentionContent_react;
        var decorators = [{
          strategy: function strategy(contentBlock, callback) {
            createMention_findWithRegex(suggestionRegex, contentBlock, callback);
          },
          component: function component(props) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(SuggestionPortal_react, extends_default()({}, props, componentProps, {
              style: config.mentionStyle,
              suggestionRegex: getRegExp(config.prefix)
            }));
          }
        }];

        if (config.mode === 'immutable') {
          decorators.unshift({
            strategy: createMention_mentionContentStrategy,
            component: function component(props) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(createMention_MentionContentComponent, extends_default()({
                tag: tag
              }, props, {
                callbacks: callbacks
              }));
            }
          });
        }

        return {
          name: 'mention',
          Suggestions: function Suggestions(props) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Suggestions_react, extends_default()({}, props, componentProps, {
              store: model_mentionStore
            }));
          },
          decorators: decorators,
          onChange: function onChange(editorState) {
            return callbacks.onChange ? callbacks.onChange(editorState) : editorState;
          },
          callbacks: callbacks,
          'export': exportContent_exportContent
        };
      } // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/component/Mention.react.js


      var Mention_react_Mention = function (_React$Component) {
        inherits_default()(Mention, _React$Component);

        function Mention(props) {
          classCallCheck_default()(this, Mention);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          _this.onEditorChange = function (editorState) {
            var selection = editorState.getSelection();
            _this._decorator = editorState.getDecorator();
            var content = editorState.getCurrentContent();

            if (_this.props.onChange) {
              _this.setState({
                selection: selection
              }, function () {
                _this.props.onChange(content, exportContent_exportContent(content));
              });
            } else {
              _this.setState({
                editorState: editorState,
                selection: selection
              });
            }
          };

          _this.onFocus = function (e) {
            if (_this.props.onFocus) {
              _this.props.onFocus(e);
            }
          };

          _this.onBlur = function (e) {
            if (_this.props.onBlur) {
              _this.props.onBlur(e);
            }
          };

          _this.reset = function () {
            /*eslint-disable*/
            _this._editor.Reset();
            /*eslint-enable*/

          };

          _this.mention = createMention_createMention({
            prefix: _this.getPrefix(props),
            tag: props.tag,
            mode: props.mode,
            mentionStyle: props.mentionStyle
          });
          _this.Suggestions = _this.mention.Suggestions;
          _this.plugins = [_this.mention];
          _this.state = {
            suggestions: props.suggestions,
            value: props.value && Draft["EditorState"].createWithContent(props.value, new Draft["CompositeDecorator"](_this.mention.decorators)),
            selection: Draft["SelectionState"].createEmpty()
          };

          if (typeof props.defaultValue === 'string') {
            // eslint-disable-next-line
            console.warn('The property `defaultValue` now allow `EditorState` only, see http://react-component.github.io/editor-mention/examples/defaultValue.html ');
          }

          if (props.value !== undefined) {
            _this.controlledMode = true;
          }

          return _this;
        }

        Mention.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          var suggestions = nextProps.suggestions;
          var selection = this.state.selection;
          var value = nextProps.value;

          if (value && selection) {
            value = Draft["EditorState"].acceptSelection(Draft["EditorState"].createWithContent(value, this._decorator), selection);
          }

          this.setState({
            suggestions: suggestions,
            value: value
          });
        };

        Mention.prototype.getPrefix = function getPrefix() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
          return Array.isArray(props.prefix) ? props.prefix : [props.prefix];
        };

        Mention.prototype.render = function render() {
          var _classnames,
              _this2 = this;

          var _props = this.props,
              prefixCls = _props.prefixCls,
              style = _props.style,
              tag = _props.tag,
              multiLines = _props.multiLines,
              editorKey = _props.editorKey,
              suggestionStyle = _props.suggestionStyle,
              placeholder = _props.placeholder,
              defaultValue = _props.defaultValue,
              className = _props.className,
              notFoundContent = _props.notFoundContent,
              getSuggestionContainer = _props.getSuggestionContainer,
              readOnly = _props.readOnly,
              disabled = _props.disabled,
              placement = _props.placement,
              mode = _props.mode;
          var suggestions = this.state.suggestions;
          var Suggestions = this.Suggestions;
          var editorClass = classnames_default()(className, (_classnames = {}, _classnames[prefixCls + '-wrapper'] = true, _classnames.readonly = readOnly, _classnames.disabled = disabled, _classnames.multilines = multiLines, _classnames));
          var editorProps = this.controlledMode ? {
            value: this.state.value
          } : {};
          var defaultValueState = defaultValue && Draft["EditorState"].createWithContent(typeof defaultValue === 'string' ? Draft["ContentState"].createFromText(defaultValue) : defaultValue, this._decorator);
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: editorClass,
            style: style,
            ref: function ref(wrapper) {
              return _this2._wrapper = wrapper;
            }
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(EditorCore["a"
          /* default */
          ], extends_default()({
            ref: function ref(editor) {
              return _this2._editor = editor;
            },
            prefixCls: prefixCls,
            style: style,
            multiLines: multiLines,
            editorKey: editorKey,
            plugins: this.plugins,
            defaultValue: defaultValueState,
            placeholder: placeholder,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onChange: this.onEditorChange
          }, editorProps, {
            readOnly: readOnly || disabled
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Suggestions, {
            mode: tag ? 'immutable' : mode,
            prefix: this.getPrefix(),
            prefixCls: prefixCls,
            style: suggestionStyle,
            placement: placement,
            notFoundContent: notFoundContent,
            suggestions: suggestions,
            getSuggestionContainer: getSuggestionContainer ? function () {
              return getSuggestionContainer(_this2._wrapper);
            } : null,
            onSearchChange: this.props.onSearchChange,
            onSelect: this.props.onSelect,
            noRedup: this.props.noRedup
          })));
        };

        return Mention;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Mention_react_Mention.propTypes = {
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        suggestions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        prefix: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string)]),
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        tag: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.element,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onSearchChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        mode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        multiLines: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        suggestionStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        notFoundContent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        position: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        getSuggestionContainer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        noRedup: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        mentionStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        placement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        editorKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      Mention_react_Mention.controlledMode = false;
      Mention_react_Mention.defaultProps = {
        prefixCls: 'rc-editor-mention',
        prefix: '@',
        mode: 'mutable',
        suggestions: [],
        multiLines: false,
        className: '',
        suggestionStyle: {},
        notFoundContent: '无法找到',
        position: 'absolute',
        placement: 'bottom',
        // top, bottom
        mentionStyle: {}
      };
      /* harmony default export */

      var Mention_react = Mention_react_Mention; // CONCATENATED MODULE: ./node_modules/rc-editor-mention/es/index.js
      // export this package's api

      function rc_editor_mention_es_toEditorState(text) {
        return Draft["ContentState"].createFromText(text);
      }

      Mention_react.Nav = Nav_react;
      Mention_react.toString = exportContent_exportContent;
      Mention_react.toEditorState = rc_editor_mention_es_toEditorState;
      Mention_react.getMentions = getMentions_getMentions;
      /* harmony default export */

      var rc_editor_mention_es = Mention_react; // CONCATENATED MODULE: ./node_modules/antd/es/mention/index.js

      var mention_Mention = function (_React$Component) {
        inherits_default()(Mention, _React$Component);

        function Mention(props) {
          classCallCheck_default()(this, Mention);

          var _this = possibleConstructorReturn_default()(this, (Mention.__proto__ || Object.getPrototypeOf(Mention)).call(this, props));

          _this.onSearchChange = function (value, prefix) {
            if (_this.props.onSearchChange) {
              return _this.props.onSearchChange(value, prefix);
            }

            return _this.defaultSearchChange(value);
          };

          _this.onChange = function (editorState) {
            if (_this.props.onChange) {
              _this.props.onChange(editorState);
            }
          };

          _this.onFocus = function (ev) {
            _this.setState({
              focus: true
            });

            if (_this.props.onFocus) {
              _this.props.onFocus(ev);
            }
          };

          _this.onBlur = function (ev) {
            _this.setState({
              focus: false
            });

            if (_this.props.onBlur) {
              _this.props.onBlur(ev);
            }
          };

          _this.focus = function () {
            _this.mentionEle._editor.focusEditor();
          };

          _this.mentionRef = function (ele) {
            _this.mentionEle = ele;
          };

          _this.state = {
            suggestions: props.suggestions,
            focus: false
          };
          return _this;
        }

        createClass_default()(Mention, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var suggestions = nextProps.suggestions;

            if (!shallowequal_default()(suggestions, this.props.suggestions)) {
              this.setState({
                suggestions: suggestions
              });
            }
          }
        }, {
          key: 'defaultSearchChange',
          value: function defaultSearchChange(value) {
            var searchValue = value.toLowerCase();
            var filteredSuggestions = (this.props.suggestions || []).filter(function (suggestion) {
              if (suggestion.type && suggestion.type === Nav_react) {
                return suggestion.props.value ? suggestion.props.value.toLowerCase().indexOf(searchValue) !== -1 : true;
              }

              return suggestion.toLowerCase().indexOf(searchValue) !== -1;
            });
            this.setState({
              suggestions: filteredSuggestions
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                prefixCls = _props.prefixCls,
                loading = _props.loading,
                placement = _props.placement;
            var _state = this.state,
                suggestions = _state.suggestions,
                focus = _state.focus;
            var cls = classnames_default()(className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-active', focus), defineProperty_default()(_classNames, prefixCls + '-placement-top', placement === 'top'), _classNames));
            var notFoundContent = loading ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
              type: 'loading'
            }) : this.props.notFoundContent;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_editor_mention_es, extends_default()({}, this.props, {
              className: cls,
              ref: this.mentionRef,
              onSearchChange: this.onSearchChange,
              onChange: this.onChange,
              onFocus: this.onFocus,
              onBlur: this.onBlur,
              suggestions: suggestions,
              notFoundContent: notFoundContent
            }));
          }
        }]);
        return Mention;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_mention = mention_Mention;
      mention_Mention.getMentions = getMentions_getMentions;
      mention_Mention.defaultProps = {
        prefixCls: 'ant-mention',
        notFoundContent: '无匹配结果，轻敲空格完成输入',
        loading: false,
        multiLines: false,
        placement: 'bottom'
      };
      mention_Mention.Nav = Nav_react;
      mention_Mention.toString = exportContent_exportContent;
      mention_Mention.toContentState = rc_editor_mention_es_toEditorState; // EXTERNAL MODULE: ./node_modules/rc-upload/es/index.js + 6 modules

      var rc_upload_es = __webpack_require__(262); // EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js


      var uniqBy = __webpack_require__(217);

      var uniqBy_default =
      /*#__PURE__*/
      __webpack_require__.n(uniqBy); // CONCATENATED MODULE: ./node_modules/antd/es/upload/UploadList.js
      // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL


      var UploadList_previewFile = function previewFile(file, callback) {
        var reader = new FileReader();

        reader.onloadend = function () {
          return callback(reader.result);
        };

        reader.readAsDataURL(file);
      };

      var UploadList_isImageUrl = function isImageUrl(url) {
        return /^data:image\//.test(url) || /\.(webp|svg|png|gif|jpg|jpeg)$/.test(url);
      };

      var UploadList_UploadList = function (_React$Component) {
        inherits_default()(UploadList, _React$Component);

        function UploadList() {
          classCallCheck_default()(this, UploadList);

          var _this = possibleConstructorReturn_default()(this, (UploadList.__proto__ || Object.getPrototypeOf(UploadList)).apply(this, arguments));

          _this.handleClose = function (file) {
            var onRemove = _this.props.onRemove;

            if (onRemove) {
              onRemove(file);
            }
          };

          _this.handlePreview = function (file, e) {
            var onPreview = _this.props.onPreview;

            if (!onPreview) {
              return;
            }

            e.preventDefault();
            return onPreview(file);
          };

          return _this;
        }

        createClass_default()(UploadList, [{
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            var _this2 = this;

            if (this.props.listType !== 'picture' && this.props.listType !== 'picture-card') {
              return;
            }

            (this.props.items || []).forEach(function (file) {
              if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File) || file.thumbUrl !== undefined) {
                return;
              }
              /*eslint-disable */


              file.thumbUrl = '';
              /*eslint-enable */

              UploadList_previewFile(file.originFileObj, function (previewDataUrl) {
                /*eslint-disable */
                file.thumbUrl = previewDataUrl;
                /*eslint-enable */

                _this2.forceUpdate();
              });
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var _this3 = this,
                _classNames2;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                _props$items = _props.items,
                items = _props$items === undefined ? [] : _props$items,
                listType = _props.listType,
                showPreviewIcon = _props.showPreviewIcon,
                showRemoveIcon = _props.showRemoveIcon,
                locale = _props.locale;
            var list = items.map(function (file) {
              var _classNames;

              var progress = void 0;
              var icon = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: file.status === 'uploading' ? 'loading' : 'paper-clip'
              });

              if (listType === 'picture' || listType === 'picture-card') {
                if (listType === 'picture-card' && file.status === 'uploading') {
                  icon = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                    className: prefixCls + '-list-item-uploading-text'
                  }, locale.uploading);
                } else if (!file.thumbUrl && !file.url) {
                  icon = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                    className: prefixCls + '-list-item-thumbnail',
                    type: 'picture'
                  });
                } else {
                  var thumbnail = UploadList_isImageUrl(file.thumbUrl || file.url) ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('img', {
                    src: file.thumbUrl || file.url,
                    alt: file.name
                  }) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                    type: 'file',
                    style: {
                      fontSize: 48,
                      color: 'rgba(0,0,0,0.5)'
                    }
                  });
                  icon = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', {
                    className: prefixCls + '-list-item-thumbnail',
                    onClick: function onClick(e) {
                      return _this3.handlePreview(file, e);
                    },
                    href: file.url || file.thumbUrl,
                    target: '_blank',
                    rel: 'noopener noreferrer'
                  }, thumbnail);
                }
              }

              if (file.status === 'uploading') {
                // show loading icon if upload progress listener is disabled
                var loadingProgress = 'percent' in file ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_progress, extends_default()({
                  type: 'line'
                }, _this3.props.progressAttr, {
                  percent: file.percent
                })) : null;
                progress = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                  className: prefixCls + '-list-item-progress',
                  key: 'progress'
                }, loadingProgress);
              }

              var infoUploadingClass = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-list-item', true), defineProperty_default()(_classNames, prefixCls + '-list-item-' + file.status, true), _classNames));
              var preview = file.url ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', extends_default()({}, file.linkProps, {
                href: file.url,
                target: '_blank',
                rel: 'noopener noreferrer',
                className: prefixCls + '-list-item-name',
                onClick: function onClick(e) {
                  return _this3.handlePreview(file, e);
                },
                title: file.name
              }), file.name) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: prefixCls + '-list-item-name',
                onClick: function onClick(e) {
                  return _this3.handlePreview(file, e);
                },
                title: file.name
              }, file.name);
              var style = file.url || file.thumbUrl ? undefined : {
                pointerEvents: 'none',
                opacity: 0.5
              };
              var previewIcon = showPreviewIcon ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('a', {
                href: file.url || file.thumbUrl,
                target: '_blank',
                rel: 'noopener noreferrer',
                style: style,
                onClick: function onClick(e) {
                  return _this3.handlePreview(file, e);
                },
                title: locale.previewFile
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: 'eye-o'
              })) : null;
              var removeIcon = showRemoveIcon ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: 'delete',
                title: locale.removeFile,
                onClick: function onClick() {
                  return _this3.handleClose(file);
                }
              }) : null;
              var removeIconCross = showRemoveIcon ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_icon, {
                type: 'cross',
                title: locale.removeFile,
                onClick: function onClick() {
                  return _this3.handleClose(file);
                }
              }) : null;
              var actions = listType === 'picture-card' && file.status !== 'uploading' ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: prefixCls + '-list-item-actions'
              }, previewIcon, removeIcon) : removeIconCross;
              var message = void 0;

              if (file.response && typeof file.response === 'string') {
                message = file.response;
              } else {
                message = file.error && file.error.statusText || locale.uploadError;
              }

              var iconAndPreview = file.status === 'error' ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](tooltip, {
                title: message
              }, icon, preview) : external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', null, icon, preview);
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: infoUploadingClass,
                key: file.uid
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: prefixCls + '-list-item-info'
              }, iconAndPreview), actions, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], {
                transitionName: 'fade',
                component: ''
              }, progress));
            });
            var listClassNames = classnames_default()((_classNames2 = {}, defineProperty_default()(_classNames2, prefixCls + '-list', true), defineProperty_default()(_classNames2, prefixCls + '-list-' + listType, true), _classNames2));
            var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], {
              transitionName: prefixCls + '-' + animationDirection,
              component: 'div',
              className: listClassNames
            }, list);
          }
        }]);
        return UploadList;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var upload_UploadList = UploadList_UploadList;
      UploadList_UploadList.defaultProps = {
        listType: 'text',
        progressAttr: {
          strokeWidth: 2,
          showInfo: false
        },
        prefixCls: 'ant-upload',
        showRemoveIcon: true,
        showPreviewIcon: true
      }; // CONCATENATED MODULE: ./node_modules/antd/es/upload/utils.js

      function T() {
        return true;
      } // Fix IE file.status problem
      // via coping a new Object


      function fileToObject(file) {
        return {
          lastModified: file.lastModified,
          lastModifiedDate: file.lastModifiedDate,
          name: file.filename || file.name,
          size: file.size,
          type: file.type,
          uid: file.uid,
          response: file.response,
          error: file.error,
          percent: 0,
          originFileObj: file
        };
      }
      /**
       * 生成Progress percent: 0.1 -> 0.98
       *   - for ie
       */


      function genPercentAdd() {
        var k = 0.1;
        var i = 0.01;
        var end = 0.98;
        return function (s) {
          var start = s;

          if (start >= end) {
            return start;
          }

          start += k;
          k = k - i;

          if (k < 0.001) {
            k = 0.001;
          }

          return start * 100;
        };
      }

      function getFileItem(file, fileList) {
        var matchKey = file.uid !== undefined ? 'uid' : 'name';
        return fileList.filter(function (item) {
          return item[matchKey] === file[matchKey];
        })[0];
      }

      function removeFileItem(file, fileList) {
        var matchKey = file.uid !== undefined ? 'uid' : 'name';
        var removed = fileList.filter(function (item) {
          return item[matchKey] !== file[matchKey];
        });

        if (removed.length === fileList.length) {
          return null;
        }

        return removed;
      } // CONCATENATED MODULE: ./node_modules/antd/es/upload/Upload.js


      var Upload_Upload = function (_React$Component) {
        inherits_default()(Upload, _React$Component);

        function Upload(props) {
          classCallCheck_default()(this, Upload);

          var _this = possibleConstructorReturn_default()(this, (Upload.__proto__ || Object.getPrototypeOf(Upload)).call(this, props));

          _this.onStart = function (file) {
            var targetItem = void 0;

            var nextFileList = _this.state.fileList.concat();

            targetItem = fileToObject(file);
            targetItem.status = 'uploading';
            nextFileList.push(targetItem);

            _this.onChange({
              file: targetItem,
              fileList: nextFileList
            }); // fix ie progress


            if (!window.FormData) {
              _this.autoUpdateProgress(0, targetItem);
            }
          };

          _this.onSuccess = function (response, file) {
            _this.clearProgressTimer();

            try {
              if (typeof response === 'string') {
                response = JSON.parse(response);
              }
            } catch (e) {
              /* do nothing */
            }

            var fileList = _this.state.fileList;
            var targetItem = getFileItem(file, fileList); // removed

            if (!targetItem) {
              return;
            }

            targetItem.status = 'done';
            targetItem.response = response;

            _this.onChange({
              file: extends_default()({}, targetItem),
              fileList: fileList
            });
          };

          _this.onProgress = function (e, file) {
            var fileList = _this.state.fileList;
            var targetItem = getFileItem(file, fileList); // removed

            if (!targetItem) {
              return;
            }

            targetItem.percent = e.percent;

            _this.onChange({
              event: e,
              file: extends_default()({}, targetItem),
              fileList: _this.state.fileList
            });
          };

          _this.onError = function (error, response, file) {
            _this.clearProgressTimer();

            var fileList = _this.state.fileList;
            var targetItem = getFileItem(file, fileList); // removed

            if (!targetItem) {
              return;
            }

            targetItem.error = error;
            targetItem.response = response;
            targetItem.status = 'error';

            _this.onChange({
              file: extends_default()({}, targetItem),
              fileList: fileList
            });
          };

          _this.handleManualRemove = function (file) {
            _this.upload.abort(file);

            file.status = 'removed'; // eslint-disable-line

            _this.handleRemove(file);
          };

          _this.onChange = function (info) {
            if (!('fileList' in _this.props)) {
              _this.setState({
                fileList: info.fileList
              });
            }

            var onChange = _this.props.onChange;

            if (onChange) {
              onChange(info);
            }
          };

          _this.onFileDrop = function (e) {
            _this.setState({
              dragState: e.type
            });
          };

          _this.beforeUpload = function (file, fileList) {
            if (!_this.props.beforeUpload) {
              return true;
            }

            var result = _this.props.beforeUpload(file, fileList);

            if (result === false) {
              _this.onChange({
                file: file,
                fileList: uniqBy_default()(fileList.concat(_this.state.fileList), function (item) {
                  return item.uid;
                })
              });

              return false;
            } else if (result && result.then) {
              return result;
            }

            return true;
          };

          _this.saveUpload = function (node) {
            _this.upload = node;
          };

          _this.renderUploadList = function (locale) {
            var _this$props = _this.props,
                showUploadList = _this$props.showUploadList,
                listType = _this$props.listType,
                onPreview = _this$props.onPreview;
            var showRemoveIcon = showUploadList.showRemoveIcon,
                showPreviewIcon = showUploadList.showPreviewIcon;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](upload_UploadList, {
              listType: listType,
              items: _this.state.fileList,
              onPreview: onPreview,
              onRemove: _this.handleManualRemove,
              showRemoveIcon: showRemoveIcon,
              showPreviewIcon: showPreviewIcon,
              locale: extends_default()({}, locale, _this.props.locale)
            });
          };

          _this.state = {
            fileList: props.fileList || props.defaultFileList || [],
            dragState: 'drop'
          };
          return _this;
        }

        createClass_default()(Upload, [{
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this.clearProgressTimer();
          }
        }, {
          key: 'autoUpdateProgress',
          value: function autoUpdateProgress(_, file) {
            var _this2 = this;

            var getPercent = genPercentAdd();
            var curPercent = 0;
            this.clearProgressTimer();
            this.progressTimer = setInterval(function () {
              curPercent = getPercent(curPercent);

              _this2.onProgress({
                percent: curPercent
              }, file);
            }, 200);
          }
        }, {
          key: 'handleRemove',
          value: function handleRemove(file) {
            var _this3 = this;

            var onRemove = this.props.onRemove;
            Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
              // Prevent removing file
              if (ret === false) {
                return;
              }

              var removedFileList = removeFileItem(file, _this3.state.fileList);

              if (removedFileList) {
                _this3.onChange({
                  file: file,
                  fileList: removedFileList
                });
              }
            });
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('fileList' in nextProps) {
              this.setState({
                fileList: nextProps.fileList || []
              });
            }
          }
        }, {
          key: 'clearProgressTimer',
          value: function clearProgressTimer() {
            clearInterval(this.progressTimer);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames2;

            var _props = this.props,
                _props$prefixCls = _props.prefixCls,
                prefixCls = _props$prefixCls === undefined ? '' : _props$prefixCls,
                className = _props.className,
                showUploadList = _props.showUploadList,
                listType = _props.listType,
                type = _props.type,
                disabled = _props.disabled,
                children = _props.children;
            var rcUploadProps = extends_default()({
              onStart: this.onStart,
              onError: this.onError,
              onProgress: this.onProgress,
              onSuccess: this.onSuccess
            }, this.props, {
              beforeUpload: this.beforeUpload
            });
            delete rcUploadProps.className;
            var uploadList = showUploadList ? external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](locale_provider_LocaleReceiver, {
              componentName: 'Upload',
              defaultLocale: locale_provider_default.Upload
            }, this.renderUploadList) : null;

            if (type === 'drag') {
              var _classNames;

              var dragCls = classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-drag', true), defineProperty_default()(_classNames, prefixCls + '-drag-uploading', this.state.fileList.some(function (file) {
                return file.status === 'uploading';
              })), defineProperty_default()(_classNames, prefixCls + '-drag-hover', this.state.dragState === 'dragover'), defineProperty_default()(_classNames, prefixCls + '-disabled', disabled), _classNames));
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: className
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: dragCls,
                onDrop: this.onFileDrop,
                onDragOver: this.onFileDrop,
                onDragLeave: this.onFileDrop
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_upload_es["default"], extends_default()({}, rcUploadProps, {
                ref: this.saveUpload,
                className: prefixCls + '-btn'
              }), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
                className: prefixCls + '-drag-container'
              }, children))), uploadList);
            }

            var uploadButtonCls = classnames_default()(prefixCls, (_classNames2 = {}, defineProperty_default()(_classNames2, prefixCls + '-select', true), defineProperty_default()(_classNames2, prefixCls + '-select-' + listType, true), defineProperty_default()(_classNames2, prefixCls + '-disabled', disabled), _classNames2));
            var uploadButton = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('div', {
              className: uploadButtonCls,
              style: {
                display: children ? '' : 'none'
              }
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](rc_upload_es["default"], extends_default()({}, rcUploadProps, {
              ref: this.saveUpload
            })));

            if (listType === 'picture-card') {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
                className: className
              }, uploadList, uploadButton);
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]('span', {
              className: className
            }, uploadButton, uploadList);
          }
        }]);
        return Upload;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var upload_Upload = Upload_Upload;
      Upload_Upload.defaultProps = {
        prefixCls: 'ant-upload',
        type: 'select',
        multiple: false,
        action: '',
        data: {},
        accept: '',
        beforeUpload: T,
        showUploadList: true,
        listType: 'text',
        className: '',
        disabled: false,
        supportServerRender: true
      }; // CONCATENATED MODULE: ./node_modules/antd/es/upload/Dragger.js

      var Dragger_Dragger = function (_React$Component) {
        inherits_default()(Dragger, _React$Component);

        function Dragger() {
          classCallCheck_default()(this, Dragger);
          return possibleConstructorReturn_default()(this, (Dragger.__proto__ || Object.getPrototypeOf(Dragger)).apply(this, arguments));
        }

        createClass_default()(Dragger, [{
          key: 'render',
          value: function render() {
            var props = this.props;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](upload_Upload, extends_default()({}, props, {
              type: 'drag',
              style: extends_default()({}, props.style, {
                height: props.height
              })
            }));
          }
        }]);
        return Dragger;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var upload_Dragger = Dragger_Dragger; // CONCATENATED MODULE: ./node_modules/antd/es/upload/index.js

      upload_Upload.Dragger = upload_Dragger;
      /* harmony default export */

      var upload = upload_Upload; // EXTERNAL MODULE: ./node_modules/antd/package.json

      var antd_package = __webpack_require__(696); // CONCATENATED MODULE: ./node_modules/antd/es/version/index.js

      /* harmony default export */


      var version = antd_package["a"
      /* version */
      ]; // CONCATENATED MODULE: ./node_modules/antd/es/index.js

      /* unused concated harmony import Affix */

      /* concated harmony reexport */

      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_affix;
      });
      /* unused concated harmony import Anchor */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_anchor;
      });
      /* unused concated harmony import AutoComplete */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return auto_complete;
      });
      /* unused concated harmony import Alert */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_alert;
      });
      /* unused concated harmony import Avatar */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_avatar;
      });
      /* unused concated harmony import BackTop */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return back_top;
      });
      /* unused concated harmony import Badge */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return badge;
      });
      /* unused concated harmony import Breadcrumb */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return breadcrumb;
      });
      /* unused concated harmony import Button */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_button;
      });
      /* unused concated harmony import Calendar */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_calendar;
      });
      /* unused concated harmony import Card */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return card;
      });
      /* unused concated harmony import Collapse */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return collapse;
      });
      /* unused concated harmony import Carousel */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return carousel;
      });
      /* unused concated harmony import Cascader */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return cascader;
      });
      /* unused concated harmony import Checkbox */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_checkbox;
      });
      /* unused concated harmony import Col */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_col;
      });
      /* unused concated harmony import DatePicker */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return date_picker;
      });
      /* unused concated harmony import Divider */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return divider_Divider;
      });
      /* unused concated harmony import Dropdown */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_dropdown;
      });
      /* unused concated harmony import Form */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_form;
      });
      /* unused concated harmony import Icon */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_icon;
      });
      /* unused concated harmony import Input */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_input;
      });
      /* unused concated harmony import InputNumber */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return input_number;
      });
      /* unused concated harmony import Layout */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_layout;
      });
      /* unused concated harmony import List */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_list;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return locale_provider;
      });
      /* unused concated harmony import message */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_message;
      });
      /* unused concated harmony import Menu */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_menu;
      });
      /* unused concated harmony import Modal */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return modal;
      });
      /* unused concated harmony import notification */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_notification;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return es_pagination;
      });
      /* unused concated harmony import Popconfirm */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return popconfirm;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return popover;
      });
      /* unused concated harmony import Progress */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_progress;
      });
      /* unused concated harmony import Radio */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_radio;
      });
      /* unused concated harmony import Rate */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return rate;
      });
      /* unused concated harmony import Row */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_row;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "d", function () {
        return es_select;
      });
      /* unused concated harmony import Slider */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return slider;
      });
      /* unused concated harmony import Spin */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_spin;
      });
      /* unused concated harmony import Steps */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_steps;
      });
      /* unused concated harmony import Switch */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_switch;
      });
      /* unused concated harmony import Table */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_table;
      });
      /* unused concated harmony import Transfer */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return transfer;
      });
      /* unused concated harmony import Tree */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_tree;
      });
      /* unused concated harmony import TreeSelect */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return tree_select;
      });
      /* unused concated harmony import Tabs */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_tabs;
      });
      /* unused concated harmony import Tag */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_tag;
      });
      /* unused concated harmony import TimePicker */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return time_picker;
      });
      /* unused concated harmony import Timeline */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return timeline;
      });
      /* unused concated harmony import Tooltip */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return tooltip;
      });
      /* unused concated harmony import Mention */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return es_mention;
      });
      /* unused concated harmony import Upload */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return upload;
      });
      /* unused concated harmony import version */

      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, false, function () {
        return version;
      });
      /***/

    },
    /* 129 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var DimensionError = __webpack_require__(92);

      function factory(type, config, load, typed) {
        var DenseMatrix = type.DenseMatrix;
        /**
         * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z).
         * Callback function invoked MxN times.
         *
         * C(i,j,...z) = f(Aij..z, Bij..z)
         *
         * @param {Matrix}   a                 The DenseMatrix instance (A)
         * @param {Matrix}   b                 The DenseMatrix instance (B)
         * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
         *
         * @return {Matrix}                    DenseMatrix (C)
         *
         * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
         */

        var algorithm13 = function algorithm13(a, b, callback) {
          // a arrays
          var adata = a._data;
          var asize = a._size;
          var adt = a._datatype; // b arrays

          var bdata = b._data;
          var bsize = b._size;
          var bdt = b._datatype; // c arrays

          var csize = []; // validate dimensions

          if (asize.length !== bsize.length) {
            throw new DimensionError(asize.length, bsize.length);
          } // validate each one of the dimension sizes


          for (var s = 0; s < asize.length; s++) {
            // must match
            if (asize[s] !== bsize[s]) {
              throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
            } // update dimension in c


            csize[s] = asize[s];
          } // datatype


          var dt; // callback signature to use

          var cf = callback; // process data types

          if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // callback

            cf = typed.find(callback, [dt, dt]);
          } // populate cdata, iterate through dimensions


          var cdata = csize.length > 0 ? _iterate(cf, 0, csize, csize[0], adata, bdata) : []; // c matrix

          return new DenseMatrix({
            data: cdata,
            size: csize,
            datatype: dt
          });
        }; // recursive function


        function _iterate(f, level, s, n, av, bv) {
          // initialize array for this level
          var cv = []; // check we reach the last level

          if (level === s.length - 1) {
            // loop arrays in last level
            for (var i = 0; i < n; i++) {
              // invoke callback and store value
              cv[i] = f(av[i], bv[i]);
            }
          } else {
            // iterate current level
            for (var j = 0; j < n; j++) {
              // iterate next level
              cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv[j]);
            }
          }

          return cv;
        }

        return algorithm13;
      }

      exports.name = 'algorithm13';
      exports.factory = factory;
      /***/
    },
    /* 130 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Compares two BigNumbers.
       * @param {BigNumber} x       First value to compare
       * @param {BigNumber} y       Second value to compare
       * @param {number} [epsilon]  The maximum relative difference between x and y
       *                            If epsilon is undefined or null, the function will
       *                            test whether x and y are exactly equal.
       * @return {boolean} whether the two numbers are nearly equal
       */

      module.exports = function nearlyEqual(x, y, epsilon) {
        // if epsilon is null or undefined, test whether x and y are exactly equal
        if (epsilon === null || epsilon === undefined) {
          return x.eq(y);
        } // use "==" operator, handles infinities


        if (x.eq(y)) {
          return true;
        } // NaN


        if (x.isNaN() || y.isNaN()) {
          return false;
        } // at this point x and y should be finite


        if (x.isFinite() && y.isFinite()) {
          // check numbers are very close, needed when comparing numbers near zero
          var diff = x.minus(y).abs();

          if (diff.isZero()) {
            return true;
          } else {
            // use relative error
            var max = x.constructor.max(x.abs(), y.abs());
            return diff.lte(max.times(epsilon));
          }
        } // Infinite and Number or negative Infinite and positive Infinite cases


        return false;
      };
      /***/

    },
    /* 131 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof2(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof2 = function _typeof2(obj) {
            return typeof obj;
          };
        } else {
          _typeof2 = function _typeof2(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof2(obj);
      }

      function factory(type, config, load, typed) {
        /**
         * Determine the type of a variable.
         *
         * Function `typeof` recognizes the following types of objects:
         *
         * Object                 | Returns       | Example
         * ---------------------- | ------------- | ------------------------------------------
         * null                   | `'null'`      | `math.typeof(null)`
         * number                 | `'number'`    | `math.typeof(3.5)`
         * boolean                | `'boolean'`   | `math.typeof(true)`
         * string                 | `'string'`    | `math.typeof('hello world')`
         * Array                  | `'Array'`     | `math.typeof([1, 2, 3])`
         * Date                   | `'Date'`      | `math.typeof(new Date())`
         * Function               | `'Function'`  | `math.typeof(function () {})`
         * Object                 | `'Object'`    | `math.typeof({a: 2, b: 3})`
         * RegExp                 | `'RegExp'`    | `math.typeof(/a regexp/)`
         * undefined              | `'undefined'` | `math.typeof(undefined)`
         * math.type.BigNumber    | `'BigNumber'` | `math.typeof(math.bignumber('2.3e500'))`
         * math.type.Chain        | `'Chain'`     | `math.typeof(math.chain(2))`
         * math.type.Complex      | `'Complex'`   | `math.typeof(math.complex(2, 3))`
         * math.type.Fraction     | `'Fraction'`  | `math.typeof(math.fraction(1, 3))`
         * math.type.Help         | `'Help'`      | `math.typeof(math.help('sqrt'))`
         * math.type.Help         | `'Help'`      | `math.typeof(math.help('sqrt'))`
         * math.type.Index        | `'Index'`     | `math.typeof(math.index(1, 3))`
         * math.type.Matrix       | `'Matrix'`    | `math.typeof(math.matrix([[1,2], [3, 4]]))`
         * math.type.Range        | `'Range'`     | `math.typeof(math.range(0, 10))`
         * math.type.ResultSet    | `'ResultSet'` | `math.typeof(math.eval('a=2\nb=3'))`
         * math.type.Unit         | `'Unit'`      | `math.typeof(math.unit('45 deg'))`
         * math.expression.node&#8203;.AccessorNode            | `'AccessorNode'`            | `math.typeof(math.parse('A[2]'))`
         * math.expression.node&#8203;.ArrayNode               | `'ArrayNode'`               | `math.typeof(math.parse('[1,2,3]'))`
         * math.expression.node&#8203;.AssignmentNode          | `'AssignmentNode'`          | `math.typeof(math.parse('x=2'))`
         * math.expression.node&#8203;.BlockNode               | `'BlockNode'`               | `math.typeof(math.parse('a=2; b=3'))`
         * math.expression.node&#8203;.ConditionalNode         | `'ConditionalNode'`         | `math.typeof(math.parse('x<0 ? -x : x'))`
         * math.expression.node&#8203;.ConstantNode            | `'ConstantNode'`            | `math.typeof(math.parse('2.3'))`
         * math.expression.node&#8203;.FunctionAssignmentNode  | `'FunctionAssignmentNode'`  | `math.typeof(math.parse('f(x)=x^2'))`
         * math.expression.node&#8203;.FunctionNode            | `'FunctionNode'`            | `math.typeof(math.parse('sqrt(4)'))`
         * math.expression.node&#8203;.IndexNode               | `'IndexNode'`               | `math.typeof(math.parse('A[2]').index)`
         * math.expression.node&#8203;.ObjectNode              | `'ObjectNode'`              | `math.typeof(math.parse('{a:2}'))`
         * math.expression.node&#8203;.ParenthesisNode         | `'ParenthesisNode'`         | `math.typeof(math.parse('(2+3)'))`
         * math.expression.node&#8203;.RangeNode               | `'RangeNode'`               | `math.typeof(math.parse('1:10'))`
         * math.expression.node&#8203;.SymbolNode              | `'SymbolNode'`              | `math.typeof(math.parse('x'))`
         *
         * Syntax:
         *
         *    math.typeof(x)
         *
         * Examples:
         *
         *    math.typeof(3.5)                     // returns 'number'
         *    math.typeof(math.complex('2-4i'))    // returns 'Complex'
         *    math.typeof(math.unit('45 deg'))     // returns 'Unit'
         *    math.typeof('hello world')           // returns 'string'
         *
         * @param {*} x     The variable for which to test the type.
         * @return {string} Returns the name of the type. Primitive types are lower case,
         *                  non-primitive types are upper-camel-case.
         *                  For example 'number', 'string', 'Array', 'Date'.
         */
        var _typeof = typed('_typeof', {
          'any': function any(x) {
            var t = _typeof2(x);

            if (t === 'object') {
              // JavaScript types
              if (x === null) return 'null';
              if (Array.isArray(x)) return 'Array';
              if (x instanceof Date) return 'Date';
              if (x instanceof RegExp) return 'RegExp'; // math.js types

              if (type.isBigNumber(x)) return 'BigNumber';
              if (type.isComplex(x)) return 'Complex';
              if (type.isFraction(x)) return 'Fraction';
              if (type.isMatrix(x)) return 'Matrix';
              if (type.isUnit(x)) return 'Unit';
              if (type.isIndex(x)) return 'Index';
              if (type.isRange(x)) return 'Range';
              if (type.isResultSet(x)) return 'ResultSet';
              if (type.isNode(x)) return x.type;
              if (type.isChain(x)) return 'Chain';
              if (type.isHelp(x)) return 'Help';
              return 'Object';
            }

            if (t === 'function') return 'Function';
            return t; // can be 'string', 'number', 'boolean', ...
          }
        });

        _typeof.toTex = undefined; // use default template

        return _typeof;
      }

      exports.name = 'typeof';
      exports.factory = factory;
      /***/
    },
    /* 132 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayLikeKeys = __webpack_require__(493),
          baseKeys = __webpack_require__(456),
          isArrayLike = __webpack_require__(134);
      /**
       * Creates an array of the own enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects. See the
       * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * for more details.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keys(new Foo);
       * // => ['a', 'b'] (iteration order is not guaranteed)
       *
       * _.keys('hi');
       * // => ['0', '1']
       */


      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }

      module.exports = keys;
      /***/
    },
    /* 133 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftFeatureFlags
       * @format
       * 
       */

      var DraftFeatureFlags = __webpack_require__(1034);

      module.exports = DraftFeatureFlags;
      /***/
    },
    /* 134 */

    /***/
    function (module, exports, __webpack_require__) {
      var isFunction = __webpack_require__(351),
          isLength = __webpack_require__(349);
      /**
       * Checks if `value` is array-like. A value is considered array-like if it's
       * not a function and has a `value.length` that's an integer greater than or
       * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
       * @example
       *
       * _.isArrayLike([1, 2, 3]);
       * // => true
       *
       * _.isArrayLike(document.body.children);
       * // => true
       *
       * _.isArrayLike('abc');
       * // => true
       *
       * _.isArrayLike(_.noop);
       * // => false
       */


      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }

      module.exports = isArrayLike;
      /***/
    },
    /* 135 */

    /***/
    function (module, exports, __webpack_require__) {
      var Symbol = __webpack_require__(158),
          getRawTag = __webpack_require__(1108),
          objectToString = __webpack_require__(1107);
      /** `Object#toString` result references. */


      var nullTag = '[object Null]',
          undefinedTag = '[object Undefined]';
      /** Built-in value references. */

      var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
      /**
       * The base implementation of `getTag` without fallbacks for buggy environments.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */

      function baseGetTag(value) {
        if (value == null) {
          return value === undefined ? undefinedTag : nullTag;
        }

        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
      }

      module.exports = baseGetTag;
      /***/
    },
    /* 136 */

    /***/
    function (module, exports, __webpack_require__) {
      // Thank's IE8 for his funny defineProperty
      module.exports = !__webpack_require__(179)(function () {
        return Object.defineProperty({}, 'a', {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });
      /***/
    },
    /* 137 */

    /***/
    function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(161);

      var IE8_DOM_DEFINE = __webpack_require__(654);

      var toPrimitive = __webpack_require__(368);

      var dP = Object.defineProperty;
      exports.f = __webpack_require__(136) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return dP(O, P, Attributes);
        } catch (e) {
          /* empty */
        }
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
      };
      /***/
    },
    /* 138 */

    /***/
    function (module, exports) {
      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
      : Function('return this')();
      if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

      /***/
    },
    /* 139 */

    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__(138);

      var core = __webpack_require__(89);

      var ctx = __webpack_require__(369);

      var hide = __webpack_require__(181);

      var has = __webpack_require__(160);

      var PROTOTYPE = 'prototype';

      var $export = function $export(type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var IS_WRAP = type & $export.W;
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE];
        var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
        var key, own, out;
        if (IS_GLOBAL) source = name;

        for (key in source) {
          // contains in native
          own = !IS_FORCED && target && target[key] !== undefined;
          if (own && has(exports, key)) continue; // export native or passed

          out = own ? target[key] : source[key]; // prevent global pollution for namespaces

          exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
          : IS_BIND && own ? ctx(out, global) // wrap global constructors for prevent change them in library
          : IS_WRAP && target[key] == out ? function (C) {
            var F = function F(a, b, c) {
              if (this instanceof C) {
                switch (arguments.length) {
                  case 0:
                    return new C();

                  case 1:
                    return new C(a);

                  case 2:
                    return new C(a, b);
                }

                return new C(a, b, c);
              }

              return C.apply(this, arguments);
            };

            F[PROTOTYPE] = C[PROTOTYPE];
            return F; // make static versions for prototype methods
          }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%

          if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out; // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%

            if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
          }
        }
      }; // type bitmap


      $export.F = 1; // forced

      $export.G = 2; // global

      $export.S = 4; // static

      $export.P = 8; // proto

      $export.B = 16; // bind

      $export.W = 32; // wrap

      $export.U = 64; // safe

      $export.R = 128; // real proto method for `library`

      module.exports = $export;
      /***/
    },
    /* 140 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseToString = __webpack_require__(507);
      /**
       * Converts `value` to a string. An empty string is returned for `null`
       * and `undefined` values. The sign of `-0` is preserved.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.toString(null);
       * // => ''
       *
       * _.toString(-0);
       * // => '-0'
       *
       * _.toString([1, 2, 3]);
       * // => '1,2,3'
       */


      function toString(value) {
        return value == null ? '' : baseToString(value);
      }

      module.exports = toString;
      /***/
    },
    /* 141 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      /**
       * Use invariant() to assert state which your program assumes to be true.
       *
       * Provide sprintf-style format (only %s is supported) and arguments
       * to provide information about what broke and what you were
       * expecting.
       *
       * The invariant message will be stripped in production, but the invariant
       * will remain to ensure logic does not differ in production.
       */

      var invariant = function invariant(condition, format, a, b, c, d, e, f) {
        if (false) {}

        if (!condition) {
          var error;

          if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
          } else {
            var args = [a, b, c, d, e, f];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function () {
              return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
          }

          error.framesToPop = 1; // we don't care about invariant's own frame

          throw error;
        }
      };

      module.exports = invariant;
      /***/
    },
    /* 142 */

    /***/
    function (module, exports, __webpack_require__) {
      !function (t, n) {
        true ? module.exports = n() : undefined;
      }("undefined" != typeof self ? self : this, function () {
        return function (t) {
          function n(e) {
            if (r[e]) return r[e].exports;
            var a = r[e] = {
              i: e,
              l: !1,
              exports: {}
            };
            return t[e].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
          }

          var r = {};
          return n.m = t, n.c = r, n.d = function (t, r, e) {
            n.o(t, r) || Object.defineProperty(t, r, {
              configurable: !1,
              enumerable: !0,
              get: e
            });
          }, n.n = function (t) {
            var r = t && t.__esModule ? function () {
              return t.default;
            } : function () {
              return t;
            };
            return n.d(r, "a", r), r;
          }, n.o = function (t, n) {
            return Object.prototype.hasOwnProperty.call(t, n);
          }, n.p = "", n(n.s = 120);
        }([function (t, n, r) {
          "use strict";

          function e(t) {
            return function n(r, e) {
              switch (arguments.length) {
                case 0:
                  return n;

                case 1:
                  return Object(u.a)(r) ? n : Object(a.a)(function (n) {
                    return t(r, n);
                  });

                default:
                  return Object(u.a)(r) && Object(u.a)(e) ? n : Object(u.a)(r) ? Object(a.a)(function (n) {
                    return t(n, e);
                  }) : Object(u.a)(e) ? Object(a.a)(function (n) {
                    return t(r, n);
                  }) : t(r, e);
              }
            };
          }

          n.a = e;
          var a = r(1),
              u = r(27);
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return function n(r) {
              return 0 === arguments.length || Object(a.a)(r) ? n : t.apply(this, arguments);
            };
          }

          n.a = e;
          var a = r(27);
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return function n(r, e, i) {
              switch (arguments.length) {
                case 0:
                  return n;

                case 1:
                  return Object(c.a)(r) ? n : Object(u.a)(function (n, e) {
                    return t(r, n, e);
                  });

                case 2:
                  return Object(c.a)(r) && Object(c.a)(e) ? n : Object(c.a)(r) ? Object(u.a)(function (n, r) {
                    return t(n, e, r);
                  }) : Object(c.a)(e) ? Object(u.a)(function (n, e) {
                    return t(r, n, e);
                  }) : Object(a.a)(function (n) {
                    return t(r, e, n);
                  });

                default:
                  return Object(c.a)(r) && Object(c.a)(e) && Object(c.a)(i) ? n : Object(c.a)(r) && Object(c.a)(e) ? Object(u.a)(function (n, r) {
                    return t(n, r, i);
                  }) : Object(c.a)(r) && Object(c.a)(i) ? Object(u.a)(function (n, r) {
                    return t(n, e, r);
                  }) : Object(c.a)(e) && Object(c.a)(i) ? Object(u.a)(function (n, e) {
                    return t(r, n, e);
                  }) : Object(c.a)(r) ? Object(a.a)(function (n) {
                    return t(n, e, i);
                  }) : Object(c.a)(e) ? Object(a.a)(function (n) {
                    return t(r, n, i);
                  }) : Object(c.a)(i) ? Object(a.a)(function (n) {
                    return t(r, e, n);
                  }) : t(r, e, i);
              }
            };
          }

          n.a = e;
          var a = r(1),
              u = r(0),
              c = r(27);
        }, function (t, n, r) {
          "use strict";

          function e(t, n, r) {
            return function () {
              if (0 === arguments.length) return r();
              var e = Array.prototype.slice.call(arguments, 0),
                  c = e.pop();

              if (!Object(a.a)(c)) {
                for (var i = 0; i < t.length;) {
                  if ("function" == typeof c[t[i]]) return c[t[i]].apply(c, e);
                  i += 1;
                }

                if (Object(u.a)(c)) {
                  return n.apply(null, e)(c);
                }
              }

              return r.apply(this, arguments);
            };
          }

          n.a = e;
          var a = r(15),
              u = r(43);
        }, function (t, n, r) {
          "use strict";

          n.a = {
            init: function init() {
              return this.xf["@@transducer/init"]();
            },
            result: function result(t) {
              return this.xf["@@transducer/result"](t);
            }
          };
        }, function (t, n, r) {
          "use strict";

          var e = r(12),
              a = r(1),
              u = r(0),
              c = r(29),
              i = Object(u.a)(function (t, n) {
            return 1 === t ? Object(a.a)(n) : Object(e.a)(t, Object(c.a)(t, [], n));
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            return Object.prototype.hasOwnProperty.call(n, t);
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(30),
              c = r(8),
              i = r(128),
              o = r(5),
              s = r(13),
              f = Object(e.a)(Object(a.a)(["fantasy-land/map", "map"], i.a, function (t, n) {
            switch (Object.prototype.toString.call(n)) {
              case "[object Function]":
                return Object(o.a)(n.length, function () {
                  return t.call(this, n.apply(this, arguments));
                });

              case "[object Object]":
                return Object(c.a)(function (r, e) {
                  return r[e] = t(n[e]), r;
                }, {}, Object(s.a)(n));

              default:
                return Object(u.a)(t, n);
            }
          }));
          n.a = f;
        }, function (t, n, r) {
          "use strict";

          function e(t, n, r) {
            for (var e = 0, a = r.length; e < a;) {
              if ((n = t["@@transducer/step"](n, r[e])) && n["@@transducer/reduced"]) {
                n = n["@@transducer/value"];
                break;
              }

              e += 1;
            }

            return t["@@transducer/result"](n);
          }

          function a(t, n, r) {
            for (var e = r.next(); !e.done;) {
              if ((n = t["@@transducer/step"](n, e.value)) && n["@@transducer/reduced"]) {
                n = n["@@transducer/value"];
                break;
              }

              e = r.next();
            }

            return t["@@transducer/result"](n);
          }

          function u(t, n, r, e) {
            return t["@@transducer/result"](r[e](Object(s.a)(t["@@transducer/step"], t), n));
          }

          function c(t, n, r) {
            if ("function" == typeof t && (t = Object(o.a)(t)), Object(i.a)(r)) return e(t, n, r);
            if ("function" == typeof r["fantasy-land/reduce"]) return u(t, n, r, "fantasy-land/reduce");
            if (null != r[f]) return a(t, n, r[f]());
            if ("function" == typeof r.next) return a(t, n, r);
            if ("function" == typeof r.reduce) return u(t, n, r, "reduce");
            throw new TypeError("reduce: list must be array or iterable");
          }

          n.a = c;
          var i = r(31),
              o = r(65),
              s = r(66),
              f = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator";
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(151),
              u = Object(e.a)(function (t, n) {
            return Object(a.a)(t, n, [], []);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            t = t || [], n = n || [];
            var r,
                e = t.length,
                a = n.length,
                u = [];

            for (r = 0; r < e;) {
              u[u.length] = t[r], r += 1;
            }

            for (r = 0; r < a;) {
              u[u.length] = n[r], r += 1;
            }

            return u;
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(23),
              a = r(2),
              u = Object(a.a)(Object(e.a)("slice", function (t, n, r) {
            return Array.prototype.slice.call(r, t, n);
          }));
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            switch (t) {
              case 0:
                return function () {
                  return n.apply(this, arguments);
                };

              case 1:
                return function (t) {
                  return n.apply(this, arguments);
                };

              case 2:
                return function (t, r) {
                  return n.apply(this, arguments);
                };

              case 3:
                return function (t, r, e) {
                  return n.apply(this, arguments);
                };

              case 4:
                return function (t, r, e, a) {
                  return n.apply(this, arguments);
                };

              case 5:
                return function (t, r, e, a, u) {
                  return n.apply(this, arguments);
                };

              case 6:
                return function (t, r, e, a, u, c) {
                  return n.apply(this, arguments);
                };

              case 7:
                return function (t, r, e, a, u, c, i) {
                  return n.apply(this, arguments);
                };

              case 8:
                return function (t, r, e, a, u, c, i, o) {
                  return n.apply(this, arguments);
                };

              case 9:
                return function (t, r, e, a, u, c, i, o, s) {
                  return n.apply(this, arguments);
                };

              case 10:
                return function (t, r, e, a, u, c, i, o, s, f) {
                  return n.apply(this, arguments);
                };

              default:
                throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
            }
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(6),
              u = r(67),
              c = !{
            toString: null
          }.propertyIsEnumerable("toString"),
              i = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
              o = function () {
            return arguments.propertyIsEnumerable("length");
          }(),
              s = function s(t, n) {
            for (var r = 0; r < t.length;) {
              if (t[r] === n) return !0;
              r += 1;
            }

            return !1;
          },
              f = "function" != typeof Object.keys || o ? function (t) {
            if (Object(t) !== t) return [];
            var n,
                r,
                e = [],
                f = o && Object(u.a)(t);

            for (n in t) {
              !Object(a.a)(n, t) || f && "length" === n || (e[e.length] = n);
            }

            if (c) for (r = i.length - 1; r >= 0;) {
              n = i[r], Object(a.a)(n, t) && !s(e, n) && (e[e.length] = n), r -= 1;
            }
            return e;
          } : function (t) {
            return Object(t) !== t ? [] : Object.keys(t);
          },
              l = Object(e.a)(f);

          n.a = l;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(8),
              u = Object(e.a)(a.a);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          n.a = Array.isArray || function (t) {
            return null != t && t.length >= 0 && "[object Array]" === Object.prototype.toString.call(t);
          };
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return t && t["@@transducer/reduced"] ? t : {
              "@@transducer/value": t,
              "@@transducer/reduced": !0
            };
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            return function () {
              return t;
            };
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return n > t ? n : t;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r = n, e = 0; e < t.length;) {
              if (null == r) return;
              r = r[t[e]], e += 1;
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            return Object(a.a)(n, t, 0) >= 0;
          }

          n.a = e;
          var a = r(83);
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(7),
              u = r(44),
              c = Object(e.a)(function (t, n) {
            return Object(a.a)(Object(u.a)(t), n);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return "[object String]" === Object.prototype.toString.call(t);
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            return function () {
              var r = arguments.length;
              if (0 === r) return n();
              var e = arguments[r - 1];
              return Object(a.a)(e) || "function" != typeof e[t] ? n.apply(this, arguments) : e[t].apply(e, Array.prototype.slice.call(arguments, 0, r - 1));
            };
          }

          n.a = e;
          var a = r(15);
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(150),
              u = Object(e.a)(function (t) {
            return Object(a.a)(t, []);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(22),
              u = Object(e.a)(function (t, n) {
            var r = t < 0 ? n.length + t : t;
            return Object(a.a)(n) ? n.charAt(r) : n[r];
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(34),
              u = r(5),
              c = r(24),
              i = Object(e.a)(function (t, n) {
            return Object(u.a)(t + 1, function () {
              var r = arguments[t];
              if (null != r && Object(a.a)(r[n])) return r[n].apply(r, Array.prototype.slice.call(arguments, 0, t));
              throw new TypeError(Object(c.a)(r) + ' does not have a method named "' + n + '"');
            });
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return null != t && "object" == typeof t && !0 === t["@@functional/placeholder"];
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return Number(t) + Number(n);
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          function e(t, n, r) {
            return function () {
              for (var c = [], i = 0, o = t, s = 0; s < n.length || i < arguments.length;) {
                var f;
                s < n.length && (!Object(u.a)(n[s]) || i >= arguments.length) ? f = n[s] : (f = arguments[i], i += 1), c[s] = f, Object(u.a)(f) || (o -= 1), s += 1;
              }

              return o <= 0 ? r.apply(this, c) : Object(a.a)(o, e(t, c, r));
            };
          }

          n.a = e;
          var a = r(12),
              u = r(27);
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            for (var r = 0, e = n.length, a = Array(e); r < e;) {
              a[r] = t(n[r]), r += 1;
            }

            return a;
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(15),
              u = r(22),
              c = Object(e.a)(function (t) {
            return !!Object(a.a)(t) || !!t && "object" == typeof t && !Object(u.a)(t) && (1 === t.nodeType ? !!t.length : 0 === t.length || t.length > 0 && t.hasOwnProperty(0) && t.hasOwnProperty(t.length - 1));
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            var e = {};

            for (var a in r) {
              e[a] = r[a];
            }

            return e[t] = n, e;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            switch (t) {
              case 0:
                return function () {
                  return n.call(this);
                };

              case 1:
                return function (t) {
                  return n.call(this, t);
                };

              case 2:
                return function (t, r) {
                  return n.call(this, t, r);
                };

              case 3:
                return function (t, r, e) {
                  return n.call(this, t, r, e);
                };

              case 4:
                return function (t, r, e, a) {
                  return n.call(this, t, r, e, a);
                };

              case 5:
                return function (t, r, e, a, u) {
                  return n.call(this, t, r, e, a, u);
                };

              case 6:
                return function (t, r, e, a, u, c) {
                  return n.call(this, t, r, e, a, u, c);
                };

              case 7:
                return function (t, r, e, a, u, c, i) {
                  return n.call(this, t, r, e, a, u, c, i);
                };

              case 8:
                return function (t, r, e, a, u, c, i, o) {
                  return n.call(this, t, r, e, a, u, c, i, o);
                };

              case 9:
                return function (t, r, e, a, u, c, i, o, s) {
                  return n.call(this, t, r, e, a, u, c, i, o, s);
                };

              case 10:
                return function (t, r, e, a, u, c, i, o, s, f) {
                  return n.call(this, t, r, e, a, u, c, i, o, s, f);
                };

              default:
                throw new Error("First argument to nAry must be a non-negative integer no greater than ten");
            }
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return "[object Function]" === Object.prototype.toString.call(t);
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(75),
              u = Object(e.a)(function (t) {
            return Object(a.a)(t.length, t);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(22),
              u = Object(e.a)(function (t) {
            return Object(a.a)(t) ? t.split("").reverse().join("") : Array.prototype.slice.call(t, 0).reverse();
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          function e(t, n, r) {
            for (var e = 0, a = r.length; e < a;) {
              if (t(n, r[e])) return !0;
              e += 1;
            }

            return !1;
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(85),
              a = r(0),
              u = r(53),
              c = Object(a.a)(function (t, n) {
            return Object(u.a)(Object(e.a)(t), n);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(29),
              a = r(3),
              u = r(6),
              c = r(8),
              i = r(161),
              o = Object(e.a)(4, [], Object(a.a)([], i.a, function (t, n, r, e) {
            return Object(c.a)(function (e, a) {
              var c = r(a);
              return e[c] = t(Object(u.a)(c, e) ? e[c] : n, a), e;
            }, {}, e);
          }));
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(5),
              u = Object(e.a)(function (t) {
            return Object(a.a)(t.length, function (n, r) {
              var e = Array.prototype.slice.call(arguments, 0);
              return e[0] = r, e[1] = n, t.apply(this, e);
            });
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(7),
              u = Object(e.a)(function (t, n) {
            return function (r) {
              return function (e) {
                return Object(a.a)(function (t) {
                  return n(t, e);
                }, r(t(e)));
              };
            };
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(55),
              u = r(62),
              c = Object(e.a)(function t(n, r, e) {
            return Object(u.a)(function (r, e, u) {
              return Object(a.a)(e) && Object(a.a)(u) ? t(n, e, u) : n(r, e, u);
            }, r, e);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return "function" == typeof t["@@transducer/step"];
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(19),
              u = Object(e.a)(function (t, n) {
            return Object(a.a)([t], n);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(10),
              a = r(0),
              u = r(8),
              c = r(7),
              i = Object(a.a)(function (t, n) {
            return "function" == typeof n["fantasy-land/ap"] ? n["fantasy-land/ap"](t) : "function" == typeof t.ap ? t.ap(n) : "function" == typeof t ? function (r) {
              return t(r)(n(r));
            } : Object(u.a)(function (t, r) {
              return Object(e.a)(t, Object(c.a)(r, n));
            }, [], t);
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          n.a = Number.isInteger || function (t) {
            return t << 0 === t;
          };
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(5),
              u = Object(e.a)(function (t) {
            return Object(a.a)(t.length, t);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(76),
              c = r(140),
              i = r(7),
              o = Object(e.a)(Object(a.a)(["fantasy-land/chain", "chain"], c.a, function (t, n) {
            return "function" == typeof n ? function (r) {
              return t(n(r))(r);
            } : Object(u.a)(!1)(Object(i.a)(t, n));
          }));
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            return null === t ? "Null" : void 0 === t ? "Undefined" : Object.prototype.toString.call(t).slice(8, -1);
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          function e() {
            if (0 === arguments.length) throw new Error("compose requires at least one argument");
            return a.a.apply(this, Object(u.a)(arguments));
          }

          n.a = e;
          var a = r(80),
              u = r(36);
        }, function (t, n, r) {
          "use strict";

          var e = r(23),
              a = r(1),
              u = r(11),
              c = Object(a.a)(Object(e.a)("tail", Object(u.a)(1, 1 / 0)));
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(15),
              u = r(34),
              c = r(22),
              i = r(24),
              o = Object(e.a)(function (t, n) {
            if (Object(a.a)(t)) {
              if (Object(a.a)(n)) return t.concat(n);
              throw new TypeError(Object(i.a)(n) + " is not an array");
            }

            if (Object(c.a)(t)) {
              if (Object(c.a)(n)) return t + n;
              throw new TypeError(Object(i.a)(n) + " is not a string");
            }

            if (null != t && Object(u.a)(t["fantasy-land/concat"])) return t["fantasy-land/concat"](n);
            if (null != t && Object(u.a)(t.concat)) return t.concat(n);
            throw new TypeError(Object(i.a)(t) + ' does not have a method named "concat" or "fantasy-land/concat"');
          });
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(54),
              c = r(55),
              i = r(8),
              o = r(156),
              s = r(13),
              f = Object(e.a)(Object(a.a)(["filter"], o.a, function (t, n) {
            return Object(c.a)(n) ? Object(i.a)(function (r, e) {
              return t(n[e]) && (r[e] = n[e]), r;
            }, {}, Object(s.a)(n)) : Object(u.a)(t, n);
          }));
          n.a = f;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            for (var r = 0, e = n.length, a = []; r < e;) {
              t(n[r]) && (a[a.length] = n[r]), r += 1;
            }

            return a;
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return "[object Object]" === Object.prototype.toString.call(t);
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(64),
              u = r(17),
              c = Object(e.a)(function (t, n, r) {
            return Object(a.a)(Object(u.a)(n), t, r);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(169),
              c = r(11),
              i = Object(e.a)(Object(a.a)(["take"], u.a, function (t, n) {
            return Object(c.a)(0, t < 0 ? 1 / 0 : t, n);
          }));
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(59),
              u = Object(e.a)(a.a);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return t;
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(58),
              a = r(100),
              u = Object(a.a)(e.a);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(214);
          n.a = "function" == typeof Object.assign ? Object.assign : e.a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(6),
              u = Object(e.a)(function (t, n, r) {
            var e,
                u = {};

            for (e in n) {
              Object(a.a)(e, n) && (u[e] = Object(a.a)(e, r) ? t(e, n[e], r[e]) : n[e]);
            }

            for (e in r) {
              Object(a.a)(e, r) && !Object(a.a)(e, u) && (u[e] = r[e]);
            }

            return u;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          });
          var e = r(121);
          r.d(n, "F", function () {
            return e.a;
          });
          var a = r(122);
          r.d(n, "T", function () {
            return a.a;
          });
          var u = r(123);
          r.d(n, "__", function () {
            return u.a;
          });
          var c = r(28);
          r.d(n, "add", function () {
            return c.a;
          });
          var i = r(124);
          r.d(n, "addIndex", function () {
            return i.a;
          });
          var o = r(64);
          r.d(n, "adjust", function () {
            return o.a;
          });
          var s = r(125);
          r.d(n, "all", function () {
            return s.a;
          });
          var f = r(127);
          r.d(n, "allPass", function () {
            return f.a;
          });
          var l = r(17);
          r.d(n, "always", function () {
            return l.a;
          });
          var v = r(68);
          r.d(n, "and", function () {
            return v.a;
          });
          var b = r(69);
          r.d(n, "any", function () {
            return b.a;
          });
          var j = r(129);
          r.d(n, "anyPass", function () {
            return j.a;
          });
          var O = r(45);
          r.d(n, "ap", function () {
            return O.a;
          });
          var p = r(130);
          r.d(n, "aperture", function () {
            return p.a;
          });
          var d = r(133);
          r.d(n, "append", function () {
            return d.a;
          });
          var h = r(71);
          r.d(n, "apply", function () {
            return h.a;
          });
          var y = r(134);
          r.d(n, "applySpec", function () {
            return y.a;
          });
          var g = r(135);
          r.d(n, "applyTo", function () {
            return g.a;
          });
          var m = r(136);
          r.d(n, "ascend", function () {
            return m.a;
          });
          var w = r(32);
          r.d(n, "assoc", function () {
            return w.a;
          });
          var x = r(73);
          r.d(n, "assocPath", function () {
            return x.a;
          });

          var _ = r(137);

          r.d(n, "binary", function () {
            return _.a;
          });
          var A = r(66);
          r.d(n, "bind", function () {
            return A.a;
          });
          var E = r(138);
          r.d(n, "both", function () {
            return E.a;
          });
          var S = r(139);
          r.d(n, "call", function () {
            return S.a;
          });
          var q = r(48);
          r.d(n, "chain", function () {
            return q.a;
          });
          var N = r(143);
          r.d(n, "clamp", function () {
            return N.a;
          });
          var I = r(144);
          r.d(n, "clone", function () {
            return I.a;
          });
          var k = r(145);
          r.d(n, "comparator", function () {
            return k.a;
          });
          var P = r(146);
          r.d(n, "complement", function () {
            return P.a;
          });
          var F = r(50);
          r.d(n, "compose", function () {
            return F.a;
          });
          var W = r(81);
          r.d(n, "composeK", function () {
            return W.a;
          });
          var R = r(148);
          r.d(n, "composeP", function () {
            return R.a;
          });
          var T = r(52);
          r.d(n, "concat", function () {
            return T.a;
          });
          var C = r(157);
          r.d(n, "cond", function () {
            return C.a;
          });
          var B = r(158);
          r.d(n, "construct", function () {
            return B.a;
          });
          var M = r(86);
          r.d(n, "constructN", function () {
            return M.a;
          });
          var D = r(159);
          r.d(n, "contains", function () {
            return D.a;
          });
          var U = r(87);
          r.d(n, "converge", function () {
            return U.a;
          });
          var z = r(160);
          r.d(n, "countBy", function () {
            return z.a;
          });
          var L = r(47);
          r.d(n, "curry", function () {
            return L.a;
          });
          var V = r(5);
          r.d(n, "curryN", function () {
            return V.a;
          });
          var K = r(162);
          r.d(n, "dec", function () {
            return K.a;
          });
          var $ = r(88);
          r.d(n, "defaultTo", function () {
            return $.a;
          });
          var H = r(163);
          r.d(n, "descend", function () {
            return H.a;
          });
          var J = r(89);
          r.d(n, "difference", function () {
            return J.a;
          });
          var X = r(90);
          r.d(n, "differenceWith", function () {
            return X.a;
          });
          var Y = r(91);
          r.d(n, "dissoc", function () {
            return Y.a;
          });
          var Z = r(164);
          r.d(n, "dissocPath", function () {
            return Z.a;
          });
          var G = r(165);
          r.d(n, "divide", function () {
            return G.a;
          });
          var Q = r(93);
          r.d(n, "drop", function () {
            return Q.a;
          });
          var tt = r(167);
          r.d(n, "dropLast", function () {
            return tt.a;
          });
          var nt = r(171);
          r.d(n, "dropLastWhile", function () {
            return nt.a;
          });
          var rt = r(174);
          r.d(n, "dropRepeats", function () {
            return rt.a;
          });
          var et = r(95);
          r.d(n, "dropRepeatsWith", function () {
            return et.a;
          });
          var at = r(175);
          r.d(n, "dropWhile", function () {
            return at.a;
          });
          var ut = r(177);
          r.d(n, "either", function () {
            return ut.a;
          });
          var ct = r(98);
          r.d(n, "empty", function () {
            return ct.a;
          });
          var it = r(178);
          r.d(n, "endsWith", function () {
            return it.a;
          });
          var ot = r(179);
          r.d(n, "eqBy", function () {
            return ot.a;
          });
          var st = r(180);
          r.d(n, "eqProps", function () {
            return st.a;
          });
          var ft = r(9);
          r.d(n, "equals", function () {
            return ft.a;
          });
          var lt = r(181);
          r.d(n, "evolve", function () {
            return lt.a;
          });
          var vt = r(53);
          r.d(n, "filter", function () {
            return vt.a;
          });
          var bt = r(182);
          r.d(n, "find", function () {
            return bt.a;
          });
          var jt = r(184);
          r.d(n, "findIndex", function () {
            return jt.a;
          });
          var Ot = r(186);
          r.d(n, "findLast", function () {
            return Ot.a;
          });
          var pt = r(188);
          r.d(n, "findLastIndex", function () {
            return pt.a;
          });
          var dt = r(190);
          r.d(n, "flatten", function () {
            return dt.a;
          });
          var ht = r(40);
          r.d(n, "flip", function () {
            return ht.a;
          });
          var yt = r(191);
          r.d(n, "forEach", function () {
            return yt.a;
          });
          var gt = r(192);
          r.d(n, "forEachObjIndexed", function () {
            return gt.a;
          });
          var mt = r(193);
          r.d(n, "fromPairs", function () {
            return mt.a;
          });
          var wt = r(194);
          r.d(n, "groupBy", function () {
            return wt.a;
          });
          var xt = r(195);
          r.d(n, "groupWith", function () {
            return xt.a;
          });

          var _t = r(196);

          r.d(n, "gt", function () {
            return _t.a;
          });
          var At = r(197);
          r.d(n, "gte", function () {
            return At.a;
          });
          var Et = r(198);
          r.d(n, "has", function () {
            return Et.a;
          });
          var St = r(199);
          r.d(n, "hasIn", function () {
            return St.a;
          });
          var qt = r(200);
          r.d(n, "head", function () {
            return qt.a;
          });
          var Nt = r(84);
          r.d(n, "identical", function () {
            return Nt.a;
          });
          var It = r(58);
          r.d(n, "identity", function () {
            return It.a;
          });
          var kt = r(201);
          r.d(n, "ifElse", function () {
            return kt.a;
          });
          var Pt = r(202);
          r.d(n, "inc", function () {
            return Pt.a;
          });
          var Ft = r(203);
          r.d(n, "indexBy", function () {
            return Ft.a;
          });
          var Wt = r(204);
          r.d(n, "indexOf", function () {
            return Wt.a;
          });
          var Rt = r(205);
          r.d(n, "init", function () {
            return Rt.a;
          });
          var Tt = r(206);
          r.d(n, "innerJoin", function () {
            return Tt.a;
          });
          var Ct = r(207);
          r.d(n, "insert", function () {
            return Ct.a;
          });
          var Bt = r(208);
          r.d(n, "insertAll", function () {
            return Bt.a;
          });
          var Mt = r(209);
          r.d(n, "intersection", function () {
            return Mt.a;
          });
          var Dt = r(211);
          r.d(n, "intersperse", function () {
            return Dt.a;
          });
          var Ut = r(212);
          r.d(n, "into", function () {
            return Ut.a;
          });
          var zt = r(215);
          r.d(n, "invert", function () {
            return zt.a;
          });
          var Lt = r(216);
          r.d(n, "invertObj", function () {
            return Lt.a;
          });
          var Vt = r(26);
          r.d(n, "invoker", function () {
            return Vt.a;
          });
          var Kt = r(102);
          r.d(n, "is", function () {
            return Kt.a;
          });
          var $t = r(217);
          r.d(n, "isEmpty", function () {
            return $t.a;
          });
          var Ht = r(74);
          r.d(n, "isNil", function () {
            return Ht.a;
          });
          var Jt = r(218);
          r.d(n, "join", function () {
            return Jt.a;
          });
          var Xt = r(103);
          r.d(n, "juxt", function () {
            return Xt.a;
          });
          var Yt = r(13);
          r.d(n, "keys", function () {
            return Yt.a;
          });
          var Zt = r(219);
          r.d(n, "keysIn", function () {
            return Zt.a;
          });
          var Gt = r(96);
          r.d(n, "last", function () {
            return Gt.a;
          });
          var Qt = r(220);
          r.d(n, "lastIndexOf", function () {
            return Qt.a;
          });
          var tn = r(104);
          r.d(n, "length", function () {
            return tn.a;
          });
          var nn = r(41);
          r.d(n, "lens", function () {
            return nn.a;
          });
          var rn = r(221);
          r.d(n, "lensIndex", function () {
            return rn.a;
          });
          var en = r(222);
          r.d(n, "lensPath", function () {
            return en.a;
          });
          var an = r(223);
          r.d(n, "lensProp", function () {
            return an.a;
          });
          var un = r(35);
          r.d(n, "lift", function () {
            return un.a;
          });
          var cn = r(75);
          r.d(n, "liftN", function () {
            return cn.a;
          });
          var on = r(224);
          r.d(n, "lt", function () {
            return on.a;
          });
          var sn = r(225);
          r.d(n, "lte", function () {
            return sn.a;
          });
          var fn = r(7);
          r.d(n, "map", function () {
            return fn.a;
          });
          var ln = r(226);
          r.d(n, "mapAccum", function () {
            return ln.a;
          });
          var vn = r(227);
          r.d(n, "mapAccumRight", function () {
            return vn.a;
          });
          var bn = r(228);
          r.d(n, "mapObjIndexed", function () {
            return bn.a;
          });
          var jn = r(229);
          r.d(n, "match", function () {
            return jn.a;
          });
          var On = r(230);
          r.d(n, "mathMod", function () {
            return On.a;
          });
          var pn = r(18);
          r.d(n, "max", function () {
            return pn.a;
          });
          var dn = r(231);
          r.d(n, "maxBy", function () {
            return dn.a;
          });
          var hn = r(106);
          r.d(n, "mean", function () {
            return hn.a;
          });
          var yn = r(232);
          r.d(n, "median", function () {
            return yn.a;
          });
          var gn = r(233);
          r.d(n, "memoize", function () {
            return gn.a;
          });
          var mn = r(108);
          r.d(n, "memoizeWith", function () {
            return mn.a;
          });
          var wn = r(234);
          r.d(n, "merge", function () {
            return wn.a;
          });
          var xn = r(235);
          r.d(n, "mergeAll", function () {
            return xn.a;
          });

          var _n = r(236);

          r.d(n, "mergeDeepLeft", function () {
            return _n.a;
          });
          var An = r(237);
          r.d(n, "mergeDeepRight", function () {
            return An.a;
          });
          var En = r(238);
          r.d(n, "mergeDeepWith", function () {
            return En.a;
          });
          var Sn = r(42);
          r.d(n, "mergeDeepWithKey", function () {
            return Sn.a;
          });
          var qn = r(239);
          r.d(n, "mergeWith", function () {
            return qn.a;
          });
          var Nn = r(62);
          r.d(n, "mergeWithKey", function () {
            return Nn.a;
          });
          var In = r(240);
          r.d(n, "min", function () {
            return In.a;
          });
          var kn = r(241);
          r.d(n, "minBy", function () {
            return kn.a;
          });
          var Pn = r(242);
          r.d(n, "modulo", function () {
            return Pn.a;
          });
          var Fn = r(109);
          r.d(n, "multiply", function () {
            return Fn.a;
          });
          var Wn = r(33);
          r.d(n, "nAry", function () {
            return Wn.a;
          });
          var Rn = r(243);
          r.d(n, "negate", function () {
            return Rn.a;
          });
          var Tn = r(244);
          r.d(n, "none", function () {
            return Tn.a;
          });
          var Cn = r(79);
          r.d(n, "not", function () {
            return Cn.a;
          });
          var Bn = r(25);
          r.d(n, "nth", function () {
            return Bn.a;
          });
          var Mn = r(245);
          r.d(n, "nthArg", function () {
            return Mn.a;
          });
          var Dn = r(246);
          r.d(n, "o", function () {
            return Dn.a;
          });
          var Un = r(101);
          r.d(n, "objOf", function () {
            return Un.a;
          });
          var zn = r(247);
          r.d(n, "of", function () {
            return zn.a;
          });
          var Ln = r(249);
          r.d(n, "omit", function () {
            return Ln.a;
          });
          var Vn = r(250);
          r.d(n, "once", function () {
            return Vn.a;
          });
          var Kn = r(97);
          r.d(n, "or", function () {
            return Kn.a;
          });
          var $n = r(110);
          r.d(n, "over", function () {
            return $n.a;
          });
          var Hn = r(251);
          r.d(n, "pair", function () {
            return Hn.a;
          });
          var Jn = r(252);
          r.d(n, "partial", function () {
            return Jn.a;
          });
          var Xn = r(253);
          r.d(n, "partialRight", function () {
            return Xn.a;
          });
          var Yn = r(254);
          r.d(n, "partition", function () {
            return Yn.a;
          });
          var Zn = r(19);
          r.d(n, "path", function () {
            return Zn.a;
          });
          var Gn = r(255);
          r.d(n, "pathEq", function () {
            return Gn.a;
          });
          var Qn = r(256);
          r.d(n, "pathOr", function () {
            return Qn.a;
          });
          var tr = r(257);
          r.d(n, "pathSatisfies", function () {
            return tr.a;
          });
          var nr = r(258);
          r.d(n, "pick", function () {
            return nr.a;
          });
          var rr = r(112);
          r.d(n, "pickAll", function () {
            return rr.a;
          });
          var er = r(259);
          r.d(n, "pickBy", function () {
            return er.a;
          });
          var ar = r(80);
          r.d(n, "pipe", function () {
            return ar.a;
          });
          var ur = r(260);
          r.d(n, "pipeK", function () {
            return ur.a;
          });
          var cr = r(82);
          r.d(n, "pipeP", function () {
            return cr.a;
          });
          var ir = r(21);
          r.d(n, "pluck", function () {
            return ir.a;
          });
          var or = r(113);
          r.d(n, "prepend", function () {
            return or.a;
          });
          var sr = r(261);
          r.d(n, "product", function () {
            return sr.a;
          });
          var fr = r(262);
          r.d(n, "project", function () {
            return fr.a;
          });
          var lr = r(44);
          r.d(n, "prop", function () {
            return lr.a;
          });
          var vr = r(263);
          r.d(n, "propEq", function () {
            return vr.a;
          });
          var br = r(264);
          r.d(n, "propIs", function () {
            return br.a;
          });
          var jr = r(265);
          r.d(n, "propOr", function () {
            return jr.a;
          });
          var Or = r(266);
          r.d(n, "propSatisfies", function () {
            return Or.a;
          });
          var pr = r(267);
          r.d(n, "props", function () {
            return pr.a;
          });
          var dr = r(268);
          r.d(n, "range", function () {
            return dr.a;
          });
          var hr = r(14);
          r.d(n, "reduce", function () {
            return hr.a;
          });
          var yr = r(39);
          r.d(n, "reduceBy", function () {
            return yr.a;
          });
          var gr = r(115);
          r.d(n, "reduceRight", function () {
            return gr.a;
          });
          var mr = r(269);
          r.d(n, "reduceWhile", function () {
            return mr.a;
          });
          var wr = r(270);
          r.d(n, "reduced", function () {
            return wr.a;
          });
          var xr = r(38);
          r.d(n, "reject", function () {
            return xr.a;
          });

          var _r = r(92);

          r.d(n, "remove", function () {
            return _r.a;
          });
          var Ar = r(271);
          r.d(n, "repeat", function () {
            return Ar.a;
          });
          var Er = r(272);
          r.d(n, "replace", function () {
            return Er.a;
          });
          var Sr = r(36);
          r.d(n, "reverse", function () {
            return Sr.a;
          });
          var qr = r(273);
          r.d(n, "scan", function () {
            return qr.a;
          });
          var Nr = r(117);
          r.d(n, "sequence", function () {
            return Nr.a;
          });
          var Ir = r(274);
          r.d(n, "set", function () {
            return Ir.a;
          });
          var kr = r(11);
          r.d(n, "slice", function () {
            return kr.a;
          });
          var Pr = r(275);
          r.d(n, "sort", function () {
            return Pr.a;
          });
          var Fr = r(276);
          r.d(n, "sortBy", function () {
            return Fr.a;
          });
          var Wr = r(277);
          r.d(n, "sortWith", function () {
            return Wr.a;
          });
          var Rr = r(278);
          r.d(n, "split", function () {
            return Rr.a;
          });
          var Tr = r(279);
          r.d(n, "splitAt", function () {
            return Tr.a;
          });
          var Cr = r(280);
          r.d(n, "splitEvery", function () {
            return Cr.a;
          });
          var Br = r(281);
          r.d(n, "splitWhen", function () {
            return Br.a;
          });
          var Mr = r(282);
          r.d(n, "startsWith", function () {
            return Mr.a;
          });
          var Dr = r(283);
          r.d(n, "subtract", function () {
            return Dr.a;
          });
          var Ur = r(107);
          r.d(n, "sum", function () {
            return Ur.a;
          });
          var zr = r(284);
          r.d(n, "symmetricDifference", function () {
            return zr.a;
          });
          var Lr = r(285);
          r.d(n, "symmetricDifferenceWith", function () {
            return Lr.a;
          });
          var Vr = r(51);
          r.d(n, "tail", function () {
            return Vr.a;
          });
          var Kr = r(57);
          r.d(n, "take", function () {
            return Kr.a;
          });
          var $r = r(99);
          r.d(n, "takeLast", function () {
            return $r.a;
          });
          var Hr = r(286);
          r.d(n, "takeLastWhile", function () {
            return Hr.a;
          });
          var Jr = r(287);
          r.d(n, "takeWhile", function () {
            return Jr.a;
          });
          var Xr = r(289);
          r.d(n, "tap", function () {
            return Xr.a;
          });
          var Yr = r(291);
          r.d(n, "test", function () {
            return Yr.a;
          });
          var Zr = r(116);
          r.d(n, "times", function () {
            return Zr.a;
          });
          var Gr = r(293);
          r.d(n, "toLower", function () {
            return Gr.a;
          });
          var Qr = r(294);
          r.d(n, "toPairs", function () {
            return Qr.a;
          });
          var te = r(295);
          r.d(n, "toPairsIn", function () {
            return te.a;
          });
          var ne = r(24);
          r.d(n, "toString", function () {
            return ne.a;
          });
          var re = r(296);
          r.d(n, "toUpper", function () {
            return re.a;
          });
          var ee = r(297);
          r.d(n, "transduce", function () {
            return ee.a;
          });
          var ae = r(298);
          r.d(n, "transpose", function () {
            return ae.a;
          });
          var ue = r(299);
          r.d(n, "traverse", function () {
            return ue.a;
          });
          var ce = r(300);
          r.d(n, "trim", function () {
            return ce.a;
          });
          var ie = r(301);
          r.d(n, "tryCatch", function () {
            return ie.a;
          });
          var oe = r(49);
          r.d(n, "type", function () {
            return oe.a;
          });
          var se = r(302);
          r.d(n, "unapply", function () {
            return se.a;
          });
          var fe = r(303);
          r.d(n, "unary", function () {
            return fe.a;
          });
          var le = r(304);
          r.d(n, "uncurryN", function () {
            return le.a;
          });
          var ve = r(305);
          r.d(n, "unfold", function () {
            return ve.a;
          });
          var be = r(306);
          r.d(n, "union", function () {
            return be.a;
          });
          var je = r(307);
          r.d(n, "unionWith", function () {
            return je.a;
          });
          var Oe = r(60);
          r.d(n, "uniq", function () {
            return Oe.a;
          });
          var pe = r(100);
          r.d(n, "uniqBy", function () {
            return pe.a;
          });
          var de = r(118);
          r.d(n, "uniqWith", function () {
            return de.a;
          });
          var he = r(308);
          r.d(n, "unless", function () {
            return he.a;
          });
          var ye = r(309);
          r.d(n, "unnest", function () {
            return ye.a;
          });
          var ge = r(310);
          r.d(n, "until", function () {
            return ge.a;
          });
          var me = r(56);
          r.d(n, "update", function () {
            return me.a;
          });
          var we = r(114);
          r.d(n, "useWith", function () {
            return we.a;
          });
          var xe = r(72);
          r.d(n, "values", function () {
            return xe.a;
          });

          var _e = r(311);

          r.d(n, "valuesIn", function () {
            return _e.a;
          });
          var Ae = r(312);
          r.d(n, "view", function () {
            return Ae.a;
          });
          var Ee = r(313);
          r.d(n, "when", function () {
            return Ee.a;
          });
          var Se = r(119);
          r.d(n, "where", function () {
            return Se.a;
          });
          var qe = r(314);
          r.d(n, "whereEq", function () {
            return qe.a;
          });
          var Ne = r(315);
          r.d(n, "without", function () {
            return Ne.a;
          });
          var Ie = r(316);
          r.d(n, "xprod", function () {
            return Ie.a;
          });
          var ke = r(317);
          r.d(n, "zip", function () {
            return ke.a;
          });
          var Pe = r(318);
          r.d(n, "zipObj", function () {
            return Pe.a;
          });
          var Fe = r(319);
          r.d(n, "zipWith", function () {
            return Fe.a;
          });
        }, function (t, n, r) {
          "use strict";

          var e = r(10),
              a = r(2),
              u = Object(a.a)(function (t, n, r) {
            if (n >= r.length || n < -r.length) return r;
            var a = n < 0 ? r.length : 0,
                u = a + n,
                c = Object(e.a)(r);
            return c[u] = t(r[u]), c;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return new a(t);
          }

          n.a = e;

          var a = function () {
            function t(t) {
              this.f = t;
            }

            return t.prototype["@@transducer/init"] = function () {
              throw new Error("init not implemented on XWrap");
            }, t.prototype["@@transducer/result"] = function (t) {
              return t;
            }, t.prototype["@@transducer/step"] = function (t, n) {
              return this.f(t, n);
            }, t;
          }();
        }, function (t, n, r) {
          "use strict";

          var e = r(12),
              a = r(0),
              u = Object(a.a)(function (t, n) {
            return Object(e.a)(t.length, function () {
              return t.apply(n, arguments);
            });
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(6),
              a = Object.prototype.toString,
              u = function u() {
            return "[object Arguments]" === a.call(arguments) ? function (t) {
              return "[object Arguments]" === a.call(t);
            } : function (t) {
              return Object(e.a)("callee", t);
            };
          };

          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t && n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(70),
              c = Object(e.a)(Object(a.a)(["any"], u.a, function (t, n) {
            for (var r = 0; r < n.length;) {
              if (t(n[r])) return !0;
              r += 1;
            }

            return !1;
          }));
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(16),
              u = r(4),
              c = function () {
            function t(t, n) {
              this.xf = n, this.f = t, this.any = !1;
            }

            return t.prototype["@@transducer/init"] = u.a.init, t.prototype["@@transducer/result"] = function (t) {
              return this.any || (t = this.xf["@@transducer/step"](t, !1)), this.xf["@@transducer/result"](t);
            }, t.prototype["@@transducer/step"] = function (t, n) {
              return this.f(n) && (this.any = !0, t = Object(a.a)(this.xf["@@transducer/step"](t, !0))), t;
            }, t;
          }(),
              i = Object(e.a)(function (t, n) {
            return new c(t, n);
          });

          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t.apply(this, n);
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(13),
              u = Object(e.a)(function (t) {
            for (var n = Object(a.a)(t), r = n.length, e = [], u = 0; u < r;) {
              e[u] = t[n[u]], u += 1;
            }

            return e;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(6),
              u = r(15),
              c = r(46),
              i = r(32),
              o = r(74),
              s = Object(e.a)(function t(n, r, e) {
            if (0 === n.length) return r;
            var s = n[0];

            if (n.length > 1) {
              var f = !Object(o.a)(e) && Object(a.a)(s, e) ? e[s] : Object(c.a)(n[1]) ? [] : {};
              r = t(Array.prototype.slice.call(n, 1), r, f);
            }

            if (Object(c.a)(s) && Object(u.a)(e)) {
              var l = [].concat(e);
              return l[s] = r, l;
            }

            return Object(i.a)(s, r, e);
          });
          n.a = s;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            return null == t;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(8),
              u = r(45),
              c = r(5),
              i = r(7),
              o = Object(e.a)(function (t, n) {
            var r = Object(c.a)(t, n);
            return Object(c.a)(t, function () {
              return Object(a.a)(u.a, Object(i.a)(r, arguments[0]), Array.prototype.slice.call(arguments, 1));
            });
          });
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return function n(r) {
              for (var e, u, c, i = [], o = 0, s = r.length; o < s;) {
                if (Object(a.a)(r[o])) for (e = t ? n(r[o]) : r[o], c = 0, u = e.length; c < u;) {
                  i[i.length] = e[c], c += 1;
                } else i[i.length] = r[o];
                o += 1;
              }

              return i;
            };
          }

          n.a = e;
          var a = r(31);
        }, function (t, n, r) {
          "use strict";

          function e(t, n, r, c) {
            var i = function i(a) {
              for (var u = n.length, i = 0; i < u;) {
                if (t === n[i]) return r[i];
                i += 1;
              }

              n[i + 1] = t, r[i + 1] = a;

              for (var o in t) {
                a[o] = c ? e(t[o], n, r, !0) : t[o];
              }

              return a;
            };

            switch (Object(u.a)(t)) {
              case "Object":
                return i({});

              case "Array":
                return i([]);

              case "Date":
                return new Date(t.valueOf());

              case "RegExp":
                return Object(a.a)(t);

              default:
                return t;
            }
          }

          n.a = e;
          var a = r(78),
              u = r(49);
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return new RegExp(t.source, (t.global ? "g" : "") + (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.sticky ? "y" : "") + (t.unicode ? "u" : ""));
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            return !t;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          function e() {
            if (0 === arguments.length) throw new Error("pipe requires at least one argument");
            return Object(a.a)(arguments[0].length, Object(c.a)(u.a, arguments[0], Object(i.a)(arguments)));
          }

          n.a = e;
          var a = r(12),
              u = r(147),
              c = r(14),
              i = r(51);
        }, function (t, n, r) {
          "use strict";

          function e() {
            if (0 === arguments.length) throw new Error("composeK requires at least one argument");
            var t = Array.prototype.slice.call(arguments),
                n = t.pop();
            return Object(u.a)(u.a.apply(this, Object(c.a)(a.a, t)), n);
          }

          n.a = e;
          var a = r(48),
              u = r(50),
              c = r(7);
        }, function (t, n, r) {
          "use strict";

          function e() {
            if (0 === arguments.length) throw new Error("pipeP requires at least one argument");
            return Object(a.a)(arguments[0].length, Object(c.a)(u.a, arguments[0], Object(i.a)(arguments)));
          }

          n.a = e;
          var a = r(12),
              u = r(149),
              c = r(14),
              i = r(51);
        }, function (t, n, r) {
          "use strict";

          function e(t, n, r) {
            var e, u;
            if ("function" == typeof t.indexOf) switch (typeof n) {
              case "number":
                if (0 === n) {
                  for (e = 1 / n; r < t.length;) {
                    if (0 === (u = t[r]) && 1 / u === e) return r;
                    r += 1;
                  }

                  return -1;
                }

                if (n !== n) {
                  for (; r < t.length;) {
                    if ("number" == typeof (u = t[r]) && u !== u) return r;
                    r += 1;
                  }

                  return -1;
                }

                return t.indexOf(n, r);

              case "string":
              case "boolean":
              case "function":
              case "undefined":
                return t.indexOf(n, r);

              case "object":
                if (null === n) return t.indexOf(n, r);
            }

            for (; r < t.length;) {
              if (Object(a.a)(t[r], n)) return r;
              r += 1;
            }

            return -1;
          }

          n.a = e;
          var a = r(9);
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t === n ? 0 !== t || 1 / t == 1 / n : t !== t && n !== n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return function () {
              return !t.apply(this, arguments);
            };
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(47),
              u = r(33),
              c = Object(e.a)(function (t, n) {
            if (t > 10) throw new Error("Constructor with greater than ten arguments");
            return 0 === t ? function () {
              return new n();
            } : Object(a.a)(Object(u.a)(t, function (t, r, e, a, u, c, i, o, s, f) {
              switch (arguments.length) {
                case 1:
                  return new n(t);

                case 2:
                  return new n(t, r);

                case 3:
                  return new n(t, r, e);

                case 4:
                  return new n(t, r, e, a);

                case 5:
                  return new n(t, r, e, a, u);

                case 6:
                  return new n(t, r, e, a, u, c);

                case 7:
                  return new n(t, r, e, a, u, c, i);

                case 8:
                  return new n(t, r, e, a, u, c, i, o);

                case 9:
                  return new n(t, r, e, a, u, c, i, o, s);

                case 10:
                  return new n(t, r, e, a, u, c, i, o, s, f);
              }
            }));
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(30),
              u = r(5),
              c = r(18),
              i = r(21),
              o = r(14),
              s = Object(e.a)(function (t, n) {
            return Object(u.a)(Object(o.a)(c.a, 0, Object(i.a)("length", n)), function () {
              var r = arguments,
                  e = this;
              return t.apply(e, Object(a.a)(function (t) {
                return t.apply(e, r);
              }, n));
            });
          });
          n.a = s;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return null == n || n !== n ? t : n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(20),
              a = r(0),
              u = Object(a.a)(function (t, n) {
            for (var r = [], a = 0, u = t.length; a < u;) {
              Object(e.a)(t[a], n) || Object(e.a)(t[a], r) || (r[r.length] = t[a]), a += 1;
            }

            return r;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(37),
              a = r(2),
              u = Object(a.a)(function (t, n, r) {
            for (var a = [], u = 0, c = n.length; u < c;) {
              Object(e.a)(t, n[u], r) || Object(e.a)(t, n[u], a) || a.push(n[u]), u += 1;
            }

            return a;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            var r = {};

            for (var e in n) {
              r[e] = n[e];
            }

            return delete r[t], r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            var e = Array.prototype.slice.call(r, 0);
            return e.splice(t, n), e;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(166),
              c = r(11),
              i = Object(e.a)(Object(a.a)(["drop"], u.a, function (t, n) {
            return Object(c.a)(Math.max(0, t), 1 / 0, n);
          }));
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(4),
              u = function () {
            function t(t, n) {
              this.xf = n, this.pred = t, this.lastValue = void 0, this.seenFirstValue = !1;
            }

            return t.prototype["@@transducer/init"] = a.a.init, t.prototype["@@transducer/result"] = a.a.result, t.prototype["@@transducer/step"] = function (t, n) {
              var r = !1;
              return this.seenFirstValue ? this.pred(this.lastValue, n) && (r = !0) : this.seenFirstValue = !0, this.lastValue = n, r ? t : this.xf["@@transducer/step"](t, n);
            }, t;
          }(),
              c = Object(e.a)(function (t, n) {
            return new u(t, n);
          });

          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(94),
              c = r(96),
              i = Object(e.a)(Object(a.a)([], u.a, function (t, n) {
            var r = [],
                e = 1,
                a = n.length;
            if (0 !== a) for (r[0] = n[0]; e < a;) {
              t(Object(c.a)(r), n[e]) || (r[r.length] = n[e]), e += 1;
            }
            return r;
          }));
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(25),
              a = Object(e.a)(-1);
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t || n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(67),
              u = r(15),
              c = r(55),
              i = r(22),
              o = Object(e.a)(function (t) {
            return null != t && "function" == typeof t["fantasy-land/empty"] ? t["fantasy-land/empty"]() : null != t && null != t.constructor && "function" == typeof t.constructor["fantasy-land/empty"] ? t.constructor["fantasy-land/empty"]() : null != t && "function" == typeof t.empty ? t.empty() : null != t && null != t.constructor && "function" == typeof t.constructor.empty ? t.constructor.empty() : Object(u.a)(t) ? [] : Object(i.a)(t) ? "" : Object(c.a)(t) ? {} : Object(a.a)(t) ? function () {
              return arguments;
            }() : void 0;
          });
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(93),
              u = Object(e.a)(function (t, n) {
            return Object(a.a)(t >= 0 ? n.length - t : 0, n);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(210),
              a = r(0),
              u = Object(a.a)(function (t, n) {
            for (var r, a, u = new e.a(), c = [], i = 0; i < n.length;) {
              a = n[i], r = t(a), u.add(r) && c.push(a), i += 1;
            }

            return c;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            var r = {};
            return r[t] = n, r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return null != n && n.constructor === t || n instanceof t;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(87),
              u = Object(e.a)(function (t) {
            return Object(a.a)(function () {
              return Array.prototype.slice.call(arguments, 0);
            }, t);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(105),
              u = Object(e.a)(function (t) {
            return null != t && Object(a.a)(t.length) ? t.length : NaN;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return "[object Number]" === Object.prototype.toString.call(t);
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(107),
              u = Object(e.a)(function (t) {
            return Object(a.a)(t) / t.length;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(28),
              a = r(14),
              u = Object(a.a)(e.a, 0);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(12),
              a = r(0),
              u = r(6),
              c = Object(a.a)(function (t, n) {
            var r = {};
            return Object(e.a)(n.length, function () {
              var e = t.apply(this, arguments);
              return Object(u.a)(e, r) || (r[e] = n.apply(this, arguments)), r[e];
            });
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t * n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = function a(t) {
            return {
              value: t,
              map: function map(n) {
                return a(n(t));
              }
            };
          },
              u = Object(e.a)(function (t, n, r) {
            return t(function (t) {
              return a(n(t));
            })(r).value;
          });

          n.a = u;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return Object(u.a)(function (n, r) {
              return Object(a.a)(Math.max(0, n.length - r.length), function () {
                return n.apply(this, t(r, arguments));
              });
            });
          }

          n.a = e;
          var a = r(12),
              u = r(0);
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r = {}, e = 0, a = t.length; e < a;) {
              var u = t[e];
              r[u] = n[u], e += 1;
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(10),
              a = r(0),
              u = Object(a.a)(function (t, n) {
            return Object(e.a)([t], n);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(5),
              u = Object(e.a)(function (t, n) {
            return Object(a.a)(n.length, function () {
              for (var r = [], e = 0; e < n.length;) {
                r.push(n[e].call(this, arguments[e])), e += 1;
              }

              return t.apply(this, r.concat(Array.prototype.slice.call(arguments, n.length)));
            });
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            for (var e = r.length - 1; e >= 0;) {
              n = t(r[e], n), e -= 1;
            }

            return n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            var r,
                e = Number(n),
                a = 0;
            if (e < 0 || isNaN(e)) throw new RangeError("n must be a non-negative number");

            for (r = new Array(e); a < e;) {
              r[a] = t(a), a += 1;
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(45),
              u = r(7),
              c = r(113),
              i = r(115),
              o = Object(e.a)(function (t, n) {
            return "function" == typeof n.sequence ? n.sequence(t) : Object(i.a)(function (t, n) {
              return Object(a.a)(Object(u.a)(c.a, t), n);
            }, t([]), n);
          });
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(37),
              a = r(0),
              u = Object(a.a)(function (t, n) {
            for (var r, a = 0, u = n.length, c = []; a < u;) {
              r = n[a], Object(e.a)(t, r, c) || (c[c.length] = r), a += 1;
            }

            return c;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(6),
              u = Object(e.a)(function (t, n) {
            for (var r in t) {
              if (Object(a.a)(r, t) && !t[r](n[r])) return !1;
            }

            return !0;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(63),
              a = function (t) {
            if (t && t.__esModule) return t;
            var n = {};
            if (null != t) for (var r in t) {
              Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
            }
            return n.default = t, n;
          }(e),
              u = r(320),
              c = function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          }(u),
              i = function i() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".";
            if (a.isEmpty(n) || a.isEmpty(n.rules)) return !0;

            var e = function e(t) {
              return "OR" === t ? "OR" : "AND";
            };

            return n.rules.reduce(function n(u) {
              return function (i, o) {
                if ("AND" === u && !i || "OR" === u && i) return i;
                if (a.is(Object, o.rules)) return o.rules.reduce(n(e(o.condition)), "OR" !== e(o.condition));

                try {
                  var s = a.defaultTo(null)(a.path(o.field.split(r), t));
                  return c.default[o.operator](o.value)(s);
                } catch (t) {
                  return !1;
                }
              };
            }(e(n.condition)), "OR" !== e(n.condition));
          },
              o = function o(t) {
            return /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(t);
          };

          t.exports = {
            formLogic: i,
            isEmailValid: o
          };
        }, function (t, n, r) {
          "use strict";

          var e = r(17),
              a = Object(e.a)(!1);
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(17),
              a = Object(e.a)(!0);
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          n.a = {
            "@@functional/placeholder": !0
          };
        }, function (t, n, r) {
          "use strict";

          var e = r(10),
              a = r(1),
              u = r(5),
              c = Object(a.a)(function (t) {
            return Object(u.a)(t.length, function () {
              var n = 0,
                  r = arguments[0],
                  a = arguments[arguments.length - 1],
                  u = Array.prototype.slice.call(arguments, 0);
              return u[0] = function () {
                var t = r.apply(this, Object(e.a)(arguments, [n, a]));
                return n += 1, t;
              }, t.apply(this, u);
            });
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(126),
              c = Object(e.a)(Object(a.a)(["all"], u.a, function (t, n) {
            for (var r = 0; r < n.length;) {
              if (!t(n[r])) return !1;
              r += 1;
            }

            return !0;
          }));
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(16),
              u = r(4),
              c = function () {
            function t(t, n) {
              this.xf = n, this.f = t, this.all = !0;
            }

            return t.prototype["@@transducer/init"] = u.a.init, t.prototype["@@transducer/result"] = function (t) {
              return this.all && (t = this.xf["@@transducer/step"](t, !0)), this.xf["@@transducer/result"](t);
            }, t.prototype["@@transducer/step"] = function (t, n) {
              return this.f(n) || (this.all = !1, t = Object(a.a)(this.xf["@@transducer/step"](t, !1))), t;
            }, t;
          }(),
              i = Object(e.a)(function (t, n) {
            return new c(t, n);
          });

          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(5),
              u = r(18),
              c = r(21),
              i = r(14),
              o = Object(e.a)(function (t) {
            return Object(a.a)(Object(i.a)(u.a, 0, Object(c.a)("length", t)), function () {
              for (var n = 0, r = t.length; n < r;) {
                if (!t[n].apply(this, arguments)) return !1;
                n += 1;
              }

              return !0;
            });
          });
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(4),
              u = function () {
            function t(t, n) {
              this.xf = n, this.f = t;
            }

            return t.prototype["@@transducer/init"] = a.a.init, t.prototype["@@transducer/result"] = a.a.result, t.prototype["@@transducer/step"] = function (t, n) {
              return this.xf["@@transducer/step"](t, this.f(n));
            }, t;
          }(),
              c = Object(e.a)(function (t, n) {
            return new u(t, n);
          });

          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(5),
              u = r(18),
              c = r(21),
              i = r(14),
              o = Object(e.a)(function (t) {
            return Object(a.a)(Object(i.a)(u.a, 0, Object(c.a)("length", t)), function () {
              for (var n = 0, r = t.length; n < r;) {
                if (t[n].apply(this, arguments)) return !0;
                n += 1;
              }

              return !1;
            });
          });
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(131),
              a = r(0),
              u = r(3),
              c = r(132),
              i = Object(a.a)(Object(u.a)([], c.a, e.a));
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            for (var r = 0, e = n.length - (t - 1), a = new Array(e >= 0 ? e : 0); r < e;) {
              a[r] = Array.prototype.slice.call(n, r, r + t), r += 1;
            }

            return a;
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(10),
              a = r(0),
              u = r(4),
              c = function () {
            function t(t, n) {
              this.xf = n, this.pos = 0, this.full = !1, this.acc = new Array(t);
            }

            return t.prototype["@@transducer/init"] = u.a.init, t.prototype["@@transducer/result"] = function (t) {
              return this.acc = null, this.xf["@@transducer/result"](t);
            }, t.prototype["@@transducer/step"] = function (t, n) {
              return this.store(n), this.full ? this.xf["@@transducer/step"](t, this.getCopy()) : t;
            }, t.prototype.store = function (t) {
              this.acc[this.pos] = t, this.pos += 1, this.pos === this.acc.length && (this.pos = 0, this.full = !0);
            }, t.prototype.getCopy = function () {
              return Object(e.a)(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
            }, t;
          }(),
              i = Object(a.a)(function (t, n) {
            return new c(t, n);
          });

          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(10),
              a = r(0),
              u = Object(a.a)(function (t, n) {
            return Object(e.a)(n, [t]);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(71),
              u = r(5),
              c = r(7),
              i = r(18),
              o = r(21),
              s = r(14),
              f = r(72),
              l = Object(e.a)(function t(n) {
            return n = Object(c.a)(function (n) {
              return "function" == typeof n ? n : t(n);
            }, n), Object(u.a)(Object(s.a)(i.a, 0, Object(o.a)("length", Object(f.a)(n))), function () {
              var t = arguments;
              return Object(c.a)(function (n) {
                return Object(a.a)(n, t);
              }, n);
            });
          });
          n.a = l;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return n(t);
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            var e = t(n),
                a = t(r);
            return e < a ? -1 : e > a ? 1 : 0;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(33),
              u = Object(e.a)(function (t) {
            return Object(a.a)(2, t);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(34),
              u = r(68),
              c = r(35),
              i = Object(e.a)(function (t, n) {
            return Object(a.a)(t) ? function () {
              return t.apply(this, arguments) && n.apply(this, arguments);
            } : Object(c.a)(u.a)(t, n);
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(47),
              a = Object(e.a)(function (t) {
            return t.apply(this, Array.prototype.slice.call(arguments, 1));
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(141),
              u = r(7),
              c = Object(e.a)(function (t, n) {
            return Object(u.a)(t, Object(a.a)(n));
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(142),
              a = r(31),
              u = r(8),
              c = r(4),
              i = function i(t) {
            return {
              "@@transducer/init": c.a.init,
              "@@transducer/result": function transducerResult(n) {
                return t["@@transducer/result"](n);
              },
              "@@transducer/step": function transducerStep(n, r) {
                var a = t["@@transducer/step"](n, r);
                return a["@@transducer/reduced"] ? Object(e.a)(a) : a;
              }
            };
          },
              o = function o(t) {
            var n = i(t);
            return {
              "@@transducer/init": c.a.init,
              "@@transducer/result": function transducerResult(t) {
                return n["@@transducer/result"](t);
              },
              "@@transducer/step": function transducerStep(t, r) {
                return Object(a.a)(r) ? Object(u.a)(n, t, r) : Object(u.a)(n, t, [r]);
              }
            };
          };

          n.a = o;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return {
              "@@transducer/value": t,
              "@@transducer/reduced": !0
            };
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            if (t > n) throw new Error("min must not be greater than max in clamp(min, max, value)");
            return r < t ? t : r > n ? n : r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(77),
              a = r(1),
              u = Object(a.a)(function (t) {
            return null != t && "function" == typeof t.clone ? t.clone() : Object(e.a)(t, [], [], !0);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            return function (n, r) {
              return t(n, r) ? -1 : t(r, n) ? 1 : 0;
            };
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(35),
              a = r(79),
              u = Object(e.a)(a.a);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            return function () {
              return n.call(this, t.apply(this, arguments));
            };
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          function e() {
            if (0 === arguments.length) throw new Error("composeP requires at least one argument");
            return a.a.apply(this, Object(u.a)(arguments));
          }

          n.a = e;
          var a = r(82),
              u = r(36);
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            return function () {
              var r = this;
              return t.apply(r, arguments).then(function (t) {
                return n.call(r, t);
              });
            };
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            var r = function r(_r2) {
              var u = n.concat([t]);
              return Object(a.a)(_r2, u) ? "<Circular>" : e(_r2, u);
            },
                f = function f(t, n) {
              return Object(u.a)(function (n) {
                return Object(c.a)(n) + ": " + r(t[n]);
              }, n.slice().sort());
            };

            switch (Object.prototype.toString.call(t)) {
              case "[object Arguments]":
                return "(function() { return arguments; }(" + Object(u.a)(r, t).join(", ") + "))";

              case "[object Array]":
                return "[" + Object(u.a)(r, t).concat(f(t, Object(s.a)(function (t) {
                  return /^\d+$/.test(t);
                }, Object(o.a)(t)))).join(", ") + "]";

              case "[object Boolean]":
                return "object" == typeof t ? "new Boolean(" + r(t.valueOf()) + ")" : t.toString();

              case "[object Date]":
                return "new Date(" + (isNaN(t.valueOf()) ? r(NaN) : Object(c.a)(Object(i.a)(t))) + ")";

              case "[object Null]":
                return "null";

              case "[object Number]":
                return "object" == typeof t ? "new Number(" + r(t.valueOf()) + ")" : 1 / t == -1 / 0 ? "-0" : t.toString(10);

              case "[object String]":
                return "object" == typeof t ? "new String(" + r(t.valueOf()) + ")" : Object(c.a)(t);

              case "[object Undefined]":
                return "undefined";

              default:
                if ("function" == typeof t.toString) {
                  var l = t.toString();
                  if ("[object Object]" !== l) return l;
                }

                return "{" + f(t, Object(o.a)(t)).join(", ") + "}";
            }
          }

          n.a = e;
          var a = r(20),
              u = r(30),
              c = r(154),
              i = r(155),
              o = r(13),
              s = r(38);
        }, function (t, n, r) {
          "use strict";

          function e(t, n, r, e) {
            function i(t, n) {
              return a(t, n, r.slice(), e.slice());
            }

            var o = Object(u.a)(t),
                s = Object(u.a)(n);
            return !Object(c.a)(function (t, n) {
              return !Object(c.a)(i, n, t);
            }, s, o);
          }

          function a(t, n, r, u) {
            if (Object(s.a)(t, n)) return !0;
            var c = Object(l.a)(t);
            if (c !== Object(l.a)(n)) return !1;
            if (null == t || null == n) return !1;
            if ("function" == typeof t["fantasy-land/equals"] || "function" == typeof n["fantasy-land/equals"]) return "function" == typeof t["fantasy-land/equals"] && t["fantasy-land/equals"](n) && "function" == typeof n["fantasy-land/equals"] && n["fantasy-land/equals"](t);
            if ("function" == typeof t.equals || "function" == typeof n.equals) return "function" == typeof t.equals && t.equals(n) && "function" == typeof n.equals && n.equals(t);

            switch (c) {
              case "Arguments":
              case "Array":
              case "Object":
                if ("function" == typeof t.constructor && "Promise" === Object(i.a)(t.constructor)) return t === n;
                break;

              case "Boolean":
              case "Number":
              case "String":
                if (typeof t != typeof n || !Object(s.a)(t.valueOf(), n.valueOf())) return !1;
                break;

              case "Date":
                if (!Object(s.a)(t.valueOf(), n.valueOf())) return !1;
                break;

              case "Error":
                return t.name === n.name && t.message === n.message;

              case "RegExp":
                if (t.source !== n.source || t.global !== n.global || t.ignoreCase !== n.ignoreCase || t.multiline !== n.multiline || t.sticky !== n.sticky || t.unicode !== n.unicode) return !1;
            }

            for (var v = r.length - 1; v >= 0;) {
              if (r[v] === t) return u[v] === n;
              v -= 1;
            }

            switch (c) {
              case "Map":
                return t.size === n.size && e(t.entries(), n.entries(), r.concat([t]), u.concat([n]));

              case "Set":
                return t.size === n.size && e(t.values(), n.values(), r.concat([t]), u.concat([n]));

              case "Arguments":
              case "Array":
              case "Object":
              case "Boolean":
              case "Number":
              case "String":
              case "Date":
              case "Error":
              case "RegExp":
              case "Int8Array":
              case "Uint8Array":
              case "Uint8ClampedArray":
              case "Int16Array":
              case "Uint16Array":
              case "Int32Array":
              case "Uint32Array":
              case "Float32Array":
              case "Float64Array":
              case "ArrayBuffer":
                break;

              default:
                return !1;
            }

            var b = Object(f.a)(t);
            if (b.length !== Object(f.a)(n).length) return !1;
            var j = r.concat([t]),
                O = u.concat([n]);

            for (v = b.length - 1; v >= 0;) {
              var p = b[v];
              if (!Object(o.a)(p, n) || !a(n[p], t[p], j, O)) return !1;
              v -= 1;
            }

            return !0;
          }

          n.a = a;
          var u = r(152),
              c = r(37),
              i = r(153),
              o = r(6),
              s = r(84),
              f = r(13),
              l = r(49);
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            for (var n, r = []; !(n = t.next()).done;) {
              r.push(n.value);
            }

            return r;
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            var n = String(t).match(/^function (\w*)/);
            return null == n ? "" : n[1];
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return '"' + t.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0").replace(/"/g, '\\"') + '"';
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = function e(t) {
            return (t < 10 ? "0" : "") + t;
          },
              a = "function" == typeof Date.prototype.toISOString ? function (t) {
            return t.toISOString();
          } : function (t) {
            return t.getUTCFullYear() + "-" + e(t.getUTCMonth() + 1) + "-" + e(t.getUTCDate()) + "T" + e(t.getUTCHours()) + ":" + e(t.getUTCMinutes()) + ":" + e(t.getUTCSeconds()) + "." + (t.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
          };

          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(4),
              u = function () {
            function t(t, n) {
              this.xf = n, this.f = t;
            }

            return t.prototype["@@transducer/init"] = a.a.init, t.prototype["@@transducer/result"] = a.a.result, t.prototype["@@transducer/step"] = function (t, n) {
              return this.f(n) ? this.xf["@@transducer/step"](t, n) : t;
            }, t;
          }(),
              c = Object(e.a)(function (t, n) {
            return new u(t, n);
          });

          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(12),
              a = r(1),
              u = r(7),
              c = r(18),
              i = r(14),
              o = Object(a.a)(function (t) {
            var n = Object(i.a)(c.a, 0, Object(u.a)(function (t) {
              return t[0].length;
            }, t));
            return Object(e.a)(n, function () {
              for (var n = 0; n < t.length;) {
                if (t[n][0].apply(this, arguments)) return t[n][1].apply(this, arguments);
                n += 1;
              }
            });
          });
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(86),
              u = Object(e.a)(function (t) {
            return Object(a.a)(t.length, t);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(20),
              a = r(0),
              u = Object(a.a)(e.a);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(39),
              a = Object(e.a)(function (t, n) {
            return t + 1;
          }, 0);
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(29),
              a = r(6),
              u = r(4),
              c = function () {
            function t(t, n, r, e) {
              this.valueFn = t, this.valueAcc = n, this.keyFn = r, this.xf = e, this.inputs = {};
            }

            return t.prototype["@@transducer/init"] = u.a.init, t.prototype["@@transducer/result"] = function (t) {
              var n;

              for (n in this.inputs) {
                if (Object(a.a)(n, this.inputs) && (t = this.xf["@@transducer/step"](t, this.inputs[n]), t["@@transducer/reduced"])) {
                  t = t["@@transducer/value"];
                  break;
                }
              }

              return this.inputs = null, this.xf["@@transducer/result"](t);
            }, t.prototype["@@transducer/step"] = function (t, n) {
              var r = this.keyFn(n);
              return this.inputs[r] = this.inputs[r] || [r, this.valueAcc], this.inputs[r][1] = this.valueFn(this.inputs[r][1], n), t;
            }, t;
          }(),
              i = Object(e.a)(4, [], function (t, n, r, e) {
            return new c(t, n, r, e);
          });

          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(28),
              a = Object(e.a)(-1);
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            var e = t(n),
                a = t(r);
            return e > a ? -1 : e < a ? 1 : 0;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(46),
              u = r(32),
              c = r(91),
              i = r(92),
              o = r(56),
              s = Object(e.a)(function t(n, r) {
            switch (n.length) {
              case 0:
                return r;

              case 1:
                return Object(a.a)(n[0]) ? Object(i.a)(n[0], 1, r) : Object(c.a)(n[0], r);

              default:
                var e = n[0],
                    s = Array.prototype.slice.call(n, 1);
                return null == r[e] ? r : Object(a.a)(n[0]) ? Object(o.a)(e, t(s, r[e]), r) : Object(u.a)(e, t(s, r[e]), r);
            }
          });
          n.a = s;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t / n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(4),
              u = function () {
            function t(t, n) {
              this.xf = n, this.n = t;
            }

            return t.prototype["@@transducer/init"] = a.a.init, t.prototype["@@transducer/result"] = a.a.result, t.prototype["@@transducer/step"] = function (t, n) {
              return this.n > 0 ? (this.n -= 1, t) : this.xf["@@transducer/step"](t, n);
            }, t;
          }(),
              c = Object(e.a)(function (t, n) {
            return new u(t, n);
          });

          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(168),
              c = r(170),
              i = Object(e.a)(Object(a.a)([], c.a, u.a));
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            return Object(a.a)(t < n.length ? n.length - t : 0, n);
          }

          n.a = e;
          var a = r(57);
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(16),
              u = r(4),
              c = function () {
            function t(t, n) {
              this.xf = n, this.n = t, this.i = 0;
            }

            return t.prototype["@@transducer/init"] = u.a.init, t.prototype["@@transducer/result"] = u.a.result, t.prototype["@@transducer/step"] = function (t, n) {
              this.i += 1;
              var r = 0 === this.n ? t : this.xf["@@transducer/step"](t, n);
              return this.n >= 0 && this.i >= this.n ? Object(a.a)(r) : r;
            }, t;
          }(),
              i = Object(e.a)(function (t, n) {
            return new c(t, n);
          });

          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(4),
              u = function () {
            function t(t, n) {
              this.xf = n, this.pos = 0, this.full = !1, this.acc = new Array(t);
            }

            return t.prototype["@@transducer/init"] = a.a.init, t.prototype["@@transducer/result"] = function (t) {
              return this.acc = null, this.xf["@@transducer/result"](t);
            }, t.prototype["@@transducer/step"] = function (t, n) {
              return this.full && (t = this.xf["@@transducer/step"](t, this.acc[this.pos])), this.store(n), t;
            }, t.prototype.store = function (t) {
              this.acc[this.pos] = t, this.pos += 1, this.pos === this.acc.length && (this.pos = 0, this.full = !0);
            }, t;
          }(),
              c = Object(e.a)(function (t, n) {
            return new u(t, n);
          });

          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(172),
              c = r(173),
              i = Object(e.a)(Object(a.a)([], c.a, u.a));
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          function e(t, n) {
            for (var r = n.length - 1; r >= 0 && t(n[r]);) {
              r -= 1;
            }

            return Object(a.a)(0, r + 1, n);
          }

          n.a = e;
          var a = r(11);
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(8),
              u = r(4),
              c = function () {
            function t(t, n) {
              this.f = t, this.retained = [], this.xf = n;
            }

            return t.prototype["@@transducer/init"] = u.a.init, t.prototype["@@transducer/result"] = function (t) {
              return this.retained = null, this.xf["@@transducer/result"](t);
            }, t.prototype["@@transducer/step"] = function (t, n) {
              return this.f(n) ? this.retain(t, n) : this.flush(t, n);
            }, t.prototype.flush = function (t, n) {
              return t = Object(a.a)(this.xf["@@transducer/step"], t, this.retained), this.retained = [], this.xf["@@transducer/step"](t, n);
            }, t.prototype.retain = function (t, n) {
              return this.retained.push(n), t;
            }, t;
          }(),
              i = Object(e.a)(function (t, n) {
            return new c(t, n);
          });

          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(3),
              u = r(94),
              c = r(95),
              i = r(9),
              o = Object(e.a)(Object(a.a)([], Object(u.a)(i.a), Object(c.a)(i.a)));
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(176),
              c = r(11),
              i = Object(e.a)(Object(a.a)(["dropWhile"], u.a, function (t, n) {
            for (var r = 0, e = n.length; r < e && t(n[r]);) {
              r += 1;
            }

            return Object(c.a)(r, 1 / 0, n);
          }));
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(4),
              u = function () {
            function t(t, n) {
              this.xf = n, this.f = t;
            }

            return t.prototype["@@transducer/init"] = a.a.init, t.prototype["@@transducer/result"] = a.a.result, t.prototype["@@transducer/step"] = function (t, n) {
              if (this.f) {
                if (this.f(n)) return t;
                this.f = null;
              }

              return this.xf["@@transducer/step"](t, n);
            }, t;
          }(),
              c = Object(e.a)(function (t, n) {
            return new u(t, n);
          });

          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(34),
              u = r(35),
              c = r(97),
              i = Object(e.a)(function (t, n) {
            return Object(a.a)(t) ? function () {
              return t.apply(this, arguments) || n.apply(this, arguments);
            } : Object(u.a)(c.a)(t, n);
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(9),
              u = r(99),
              c = Object(e.a)(function (t, n) {
            return Object(a.a)(Object(u.a)(t.length, n), t);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(9),
              u = Object(e.a)(function (t, n, r) {
            return Object(a.a)(t(n), t(r));
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(9),
              u = Object(e.a)(function (t, n, r) {
            return Object(a.a)(n[t], r[t]);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function t(n, r) {
            var e,
                a,
                u,
                c = {};

            for (a in r) {
              e = n[a], u = typeof e, c[a] = "function" === u ? e(r[a]) : e && "object" === u ? t(e, r[a]) : r[a];
            }

            return c;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(183),
              c = Object(e.a)(Object(a.a)(["find"], u.a, function (t, n) {
            for (var r = 0, e = n.length; r < e;) {
              if (t(n[r])) return n[r];
              r += 1;
            }
          }));
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(16),
              u = r(4),
              c = function () {
            function t(t, n) {
              this.xf = n, this.f = t, this.found = !1;
            }

            return t.prototype["@@transducer/init"] = u.a.init, t.prototype["@@transducer/result"] = function (t) {
              return this.found || (t = this.xf["@@transducer/step"](t, void 0)), this.xf["@@transducer/result"](t);
            }, t.prototype["@@transducer/step"] = function (t, n) {
              return this.f(n) && (this.found = !0, t = Object(a.a)(this.xf["@@transducer/step"](t, n))), t;
            }, t;
          }(),
              i = Object(e.a)(function (t, n) {
            return new c(t, n);
          });

          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(185),
              c = Object(e.a)(Object(a.a)([], u.a, function (t, n) {
            for (var r = 0, e = n.length; r < e;) {
              if (t(n[r])) return r;
              r += 1;
            }

            return -1;
          }));
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(16),
              u = r(4),
              c = function () {
            function t(t, n) {
              this.xf = n, this.f = t, this.idx = -1, this.found = !1;
            }

            return t.prototype["@@transducer/init"] = u.a.init, t.prototype["@@transducer/result"] = function (t) {
              return this.found || (t = this.xf["@@transducer/step"](t, -1)), this.xf["@@transducer/result"](t);
            }, t.prototype["@@transducer/step"] = function (t, n) {
              return this.idx += 1, this.f(n) && (this.found = !0, t = Object(a.a)(this.xf["@@transducer/step"](t, this.idx))), t;
            }, t;
          }(),
              i = Object(e.a)(function (t, n) {
            return new c(t, n);
          });

          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(187),
              c = Object(e.a)(Object(a.a)([], u.a, function (t, n) {
            for (var r = n.length - 1; r >= 0;) {
              if (t(n[r])) return n[r];
              r -= 1;
            }
          }));
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(4),
              u = function () {
            function t(t, n) {
              this.xf = n, this.f = t;
            }

            return t.prototype["@@transducer/init"] = a.a.init, t.prototype["@@transducer/result"] = function (t) {
              return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t, this.last));
            }, t.prototype["@@transducer/step"] = function (t, n) {
              return this.f(n) && (this.last = n), t;
            }, t;
          }(),
              c = Object(e.a)(function (t, n) {
            return new u(t, n);
          });

          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(189),
              c = Object(e.a)(Object(a.a)([], u.a, function (t, n) {
            for (var r = n.length - 1; r >= 0;) {
              if (t(n[r])) return r;
              r -= 1;
            }

            return -1;
          }));
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(4),
              u = function () {
            function t(t, n) {
              this.xf = n, this.f = t, this.idx = -1, this.lastIdx = -1;
            }

            return t.prototype["@@transducer/init"] = a.a.init, t.prototype["@@transducer/result"] = function (t) {
              return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t, this.lastIdx));
            }, t.prototype["@@transducer/step"] = function (t, n) {
              return this.idx += 1, this.f(n) && (this.lastIdx = this.idx), t;
            }, t;
          }(),
              c = Object(e.a)(function (t, n) {
            return new u(t, n);
          });

          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(76),
              u = Object(e.a)(Object(a.a)(!0));
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(23),
              a = r(0),
              u = Object(a.a)(Object(e.a)("forEach", function (t, n) {
            for (var r = n.length, e = 0; e < r;) {
              t(n[e]), e += 1;
            }

            return n;
          }));
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(13),
              u = Object(e.a)(function (t, n) {
            for (var r = Object(a.a)(n), e = 0; e < r.length;) {
              var u = r[e];
              t(n[u], u, n), e += 1;
            }

            return n;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            for (var n = {}, r = 0; r < t.length;) {
              n[t[r][0]] = t[r][1], r += 1;
            }

            return n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(23),
              a = r(0),
              u = r(39),
              c = Object(a.a)(Object(e.a)("groupBy", Object(u.a)(function (t, n) {
            return null == t && (t = []), t.push(n), t;
          }, null)));
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r = [], e = 0, a = n.length; e < a;) {
              for (var u = e + 1; u < a && t(n[u - 1], n[u]);) {
                u += 1;
              }

              r.push(n.slice(e, u)), e = u;
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t > n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t >= n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(6),
              u = Object(e.a)(a.a);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t in n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(25),
              a = Object(e.a)(0);
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(5),
              u = Object(e.a)(function (t, n, r) {
            return Object(a.a)(Math.max(t.length, n.length, r.length), function () {
              return t.apply(this, arguments) ? n.apply(this, arguments) : r.apply(this, arguments);
            });
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(28),
              a = Object(e.a)(1);
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(39),
              a = Object(e.a)(function (t, n) {
            return n;
          }, null);
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(83),
              u = r(15),
              c = Object(e.a)(function (t, n) {
            return "function" != typeof n.indexOf || Object(u.a)(n) ? Object(a.a)(n, t, 0) : n.indexOf(t);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(11),
              a = Object(e.a)(0, -1);
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(37),
              a = r(2),
              u = r(54),
              c = Object(a.a)(function (t, n, r) {
            return Object(u.a)(function (n) {
              return Object(e.a)(t, n, r);
            }, n);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            t = t < r.length && t >= 0 ? t : r.length;
            var e = Array.prototype.slice.call(r, 0);
            return e.splice(t, 0, n), e;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            return t = t < r.length && t >= 0 ? t : r.length, [].concat(Array.prototype.slice.call(r, 0, t), n, Array.prototype.slice.call(r, t));
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(20),
              a = r(0),
              u = r(54),
              c = r(40),
              i = r(60),
              o = Object(a.a)(function (t, n) {
            var r, a;
            return t.length > n.length ? (r = t, a = n) : (r = n, a = t), Object(i.a)(Object(u.a)(Object(c.a)(e.a)(r), a));
          });
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          function e(t, n, r) {
            var e,
                u = typeof t;

            switch (u) {
              case "string":
              case "number":
                return 0 === t && 1 / t == -1 / 0 ? !!r._items["-0"] || (n && (r._items["-0"] = !0), !1) : null !== r._nativeSet ? n ? (e = r._nativeSet.size, r._nativeSet.add(t), r._nativeSet.size === e) : r._nativeSet.has(t) : u in r._items ? t in r._items[u] || (n && (r._items[u][t] = !0), !1) : (n && (r._items[u] = {}, r._items[u][t] = !0), !1);

              case "boolean":
                if (u in r._items) {
                  var c = t ? 1 : 0;
                  return !!r._items[u][c] || (n && (r._items[u][c] = !0), !1);
                }

                return n && (r._items[u] = t ? [!1, !0] : [!0, !1]), !1;

              case "function":
                return null !== r._nativeSet ? n ? (e = r._nativeSet.size, r._nativeSet.add(t), r._nativeSet.size === e) : r._nativeSet.has(t) : u in r._items ? !!Object(a.a)(t, r._items[u]) || (n && r._items[u].push(t), !1) : (n && (r._items[u] = [t]), !1);

              case "undefined":
                return !!r._items[u] || (n && (r._items[u] = !0), !1);

              case "object":
                if (null === t) return !!r._items.null || (n && (r._items.null = !0), !1);

              default:
                return u = Object.prototype.toString.call(t), u in r._items ? !!Object(a.a)(t, r._items[u]) || (n && r._items[u].push(t), !1) : (n && (r._items[u] = [t]), !1);
            }
          }

          var a = r(20),
              u = function () {
            function t() {
              this._nativeSet = "function" == typeof Set ? new Set() : null, this._items = {};
            }

            return t.prototype.add = function (t) {
              return !e(t, !0, this);
            }, t.prototype.has = function (t) {
              return e(t, !1, this);
            }, t;
          }();

          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(23),
              a = r(0),
              u = Object(a.a)(Object(e.a)("intersperse", function (t, n) {
            for (var r = [], e = 0, a = n.length; e < a;) {
              e === a - 1 ? r.push(n[e]) : r.push(n[e], t), e += 1;
            }

            return r;
          }));
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(77),
              a = r(2),
              u = r(43),
              c = r(8),
              i = r(213),
              o = Object(a.a)(function (t, n, r) {
            return Object(u.a)(t) ? Object(c.a)(n(t), t["@@transducer/init"](), r) : Object(c.a)(n(Object(i.a)(t)), Object(e.a)(t, [], [], !1), r);
          });
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            if (Object(i.a)(t)) return t;
            if (Object(c.a)(t)) return s;
            if ("string" == typeof t) return f;
            if ("object" == typeof t) return l;
            throw new Error("Cannot create transformer for " + t);
          }

          n.a = e;
          var a = r(61),
              u = r(59),
              c = r(31),
              i = r(43),
              o = r(101),
              s = {
            "@@transducer/init": Array,
            "@@transducer/step": function transducerStep(t, n) {
              return t.push(n), t;
            },
            "@@transducer/result": u.a
          },
              f = {
            "@@transducer/init": String,
            "@@transducer/step": function transducerStep(t, n) {
              return t + n;
            },
            "@@transducer/result": u.a
          },
              l = {
            "@@transducer/init": Object,
            "@@transducer/step": function transducerStep(t, n) {
              return Object(a.a)(t, Object(c.a)(n) ? Object(o.a)(n[0], n[1]) : n);
            },
            "@@transducer/result": u.a
          };
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            if (null == t) throw new TypeError("Cannot convert undefined or null to object");

            for (var n = Object(t), r = 1, e = arguments.length; r < e;) {
              var u = arguments[r];
              if (null != u) for (var c in u) {
                Object(a.a)(c, u) && (n[c] = u[c]);
              }
              r += 1;
            }

            return n;
          }

          n.a = e;
          var a = r(6);
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(6),
              u = r(13),
              c = Object(e.a)(function (t) {
            for (var n = Object(u.a)(t), r = n.length, e = 0, c = {}; e < r;) {
              var i = n[e],
                  o = t[i],
                  s = Object(a.a)(o, c) ? c[o] : c[o] = [];
              s[s.length] = i, e += 1;
            }

            return c;
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(13),
              u = Object(e.a)(function (t) {
            for (var n = Object(a.a)(t), r = n.length, e = 0, u = {}; e < r;) {
              var c = n[e];
              u[t[c]] = c, e += 1;
            }

            return u;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(98),
              u = r(9),
              c = Object(e.a)(function (t) {
            return null != t && Object(u.a)(t, Object(a.a)(t));
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(26),
              a = Object(e.a)(1, "join");
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            var n,
                r = [];

            for (n in t) {
              r[r.length] = n;
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(15),
              u = r(9),
              c = Object(e.a)(function (t, n) {
            if ("function" != typeof n.lastIndexOf || Object(a.a)(n)) {
              for (var r = n.length - 1; r >= 0;) {
                if (Object(u.a)(n[r], t)) return r;
                r -= 1;
              }

              return -1;
            }

            return n.lastIndexOf(t);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(41),
              u = r(25),
              c = r(56),
              i = Object(e.a)(function (t) {
            return Object(a.a)(Object(u.a)(t), Object(c.a)(t));
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(73),
              u = r(41),
              c = r(19),
              i = Object(e.a)(function (t) {
            return Object(u.a)(Object(c.a)(t), Object(a.a)(t));
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(32),
              u = r(41),
              c = r(44),
              i = Object(e.a)(function (t) {
            return Object(u.a)(Object(c.a)(t), Object(a.a)(t));
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t < n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t <= n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            for (var e = 0, a = r.length, u = [], c = [n]; e < a;) {
              c = t(c[0], r[e]), u[e] = c[1], e += 1;
            }

            return [c[0], u];
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            for (var e = r.length - 1, a = [], u = [n]; e >= 0;) {
              u = t(r[e], u[0]), a[e] = u[1], e -= 1;
            }

            return [a, u[0]];
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(8),
              u = r(13),
              c = Object(e.a)(function (t, n) {
            return Object(a.a)(function (r, e) {
              return r[e] = t(n[e], e, n), r;
            }, {}, Object(u.a)(n));
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return n.match(t) || [];
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(46),
              u = Object(e.a)(function (t, n) {
            return Object(a.a)(t) ? !Object(a.a)(n) || n < 1 ? NaN : (t % n + n) % n : NaN;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            return t(r) > t(n) ? r : n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(106),
              u = Object(e.a)(function (t) {
            var n = t.length;
            if (0 === n) return NaN;
            var r = 2 - n % 2,
                e = (n - r) / 2;
            return Object(a.a)(Array.prototype.slice.call(t, 0).sort(function (t, n) {
              return t < n ? -1 : t > n ? 1 : 0;
            }).slice(e, e + r));
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(108),
              a = r(24),
              u = Object(e.a)(function () {
            return Object(a.a)(arguments);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(61),
              a = r(0),
              u = Object(a.a)(function (t, n) {
            return Object(e.a)({}, t, n);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(61),
              a = r(1),
              u = Object(a.a)(function (t) {
            return e.a.apply(null, [{}].concat(t));
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(42),
              u = Object(e.a)(function (t, n) {
            return Object(a.a)(function (t, n, r) {
              return n;
            }, t, n);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(42),
              u = Object(e.a)(function (t, n) {
            return Object(a.a)(function (t, n, r) {
              return r;
            }, t, n);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(42),
              u = Object(e.a)(function (t, n, r) {
            return Object(a.a)(function (n, r, e) {
              return t(r, e);
            }, n, r);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(62),
              u = Object(e.a)(function (t, n, r) {
            return Object(a.a)(function (n, r, e) {
              return t(r, e);
            }, n, r);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return n < t ? n : t;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            return t(r) < t(n) ? r : n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return t % n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            return -t;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(85),
              a = r(0),
              u = r(3),
              c = r(70),
              i = r(69),
              o = Object(a.a)(Object(e.a)(Object(u.a)(["any"], c.a, i.a)));
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(5),
              u = r(25),
              c = Object(e.a)(function (t) {
            var n = t < 0 ? 1 : t + 1;
            return Object(a.a)(n, function () {
              return Object(u.a)(t, arguments);
            });
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            return t(n(r));
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(248),
              u = Object(e.a)(a.a);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return [t];
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r = {}, e = {}, a = 0, u = t.length; a < u;) {
              e[t[a]] = 1, a += 1;
            }

            for (var c in n) {
              e.hasOwnProperty(c) || (r[c] = n[c]);
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(12),
              a = r(1),
              u = Object(a.a)(function (t) {
            var n,
                r = !1;
            return Object(e.a)(t.length, function () {
              return r ? n : (r = !0, n = t.apply(this, arguments));
            });
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return [t, n];
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(10),
              a = r(111),
              u = Object(a.a)(e.a);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(10),
              a = r(111),
              u = r(40),
              c = Object(a.a)(Object(u.a)(e.a));
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(53),
              a = r(103),
              u = r(38),
              c = Object(a.a)([e.a, u.a]);
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(9),
              u = r(19),
              c = Object(e.a)(function (t, n, r) {
            return Object(a.a)(Object(u.a)(t, r), n);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(88),
              u = r(19),
              c = Object(e.a)(function (t, n, r) {
            return Object(a.a)(t, Object(u.a)(n, r));
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(19),
              u = Object(e.a)(function (t, n, r) {
            return n.length > 0 && t(Object(a.a)(n, r));
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r = {}, e = 0; e < t.length;) {
              t[e] in n && (r[t[e]] = n[t[e]]), e += 1;
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            var r = {};

            for (var e in n) {
              t(n[e], e, n) && (r[e] = n[e]);
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          function e() {
            if (0 === arguments.length) throw new Error("pipeK requires at least one argument");
            return a.a.apply(this, Object(u.a)(arguments));
          }

          n.a = e;
          var a = r(81),
              u = r(36);
        }, function (t, n, r) {
          "use strict";

          var e = r(109),
              a = r(14),
              u = Object(a.a)(e.a, 1);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(30),
              a = r(58),
              u = r(112),
              c = r(114),
              i = Object(c.a)(e.a, [u.a, a.a]);
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(9),
              u = Object(e.a)(function (t, n, r) {
            return Object(a.a)(n, r[t]);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(102),
              u = Object(e.a)(function (t, n, r) {
            return Object(a.a)(t, r[n]);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(6),
              u = Object(e.a)(function (t, n, r) {
            return null != r && Object(a.a)(n, r) ? r[n] : t;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            return t(r[n]);
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r = t.length, e = [], a = 0; a < r;) {
              e[a] = n[t[a]], a += 1;
            }

            return e;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(105),
              u = Object(e.a)(function (t, n) {
            if (!Object(a.a)(t) || !Object(a.a)(n)) throw new TypeError("Both arguments to range must be numbers");

            for (var r = [], e = t; e < n;) {
              r.push(e), e += 1;
            }

            return r;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(29),
              a = r(8),
              u = r(16),
              c = Object(e.a)(4, [], function (t, n, r, e) {
            return Object(a.a)(function (r, e) {
              return t(r, e) ? n(r, e) : Object(u.a)(r);
            }, r, e);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(16),
              u = Object(e.a)(a.a);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(17),
              u = r(116),
              c = Object(e.a)(function (t, n) {
            return Object(u.a)(Object(a.a)(t), n);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            return r.replace(t, n);
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            for (var e = 0, a = r.length, u = [n]; e < a;) {
              n = t(n, r[e]), u[e + 1] = n, e += 1;
            }

            return u;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(17),
              u = r(110),
              c = Object(e.a)(function (t, n, r) {
            return Object(u.a)(t, Object(a.a)(n), r);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return Array.prototype.slice.call(n, 0).sort(t);
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return Array.prototype.slice.call(n, 0).sort(function (n, r) {
              var e = t(n),
                  a = t(r);
              return e < a ? -1 : e > a ? 1 : 0;
            });
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return Array.prototype.slice.call(n, 0).sort(function (n, r) {
              for (var e = 0, a = 0; 0 === e && a < t.length;) {
                e = t[a](n, r), a += 1;
              }

              return e;
            });
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(26),
              a = Object(e.a)(1, "split");
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(104),
              u = r(11),
              c = Object(e.a)(function (t, n) {
            return [Object(u.a)(0, t, n), Object(u.a)(t, Object(a.a)(n), n)];
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(11),
              u = Object(e.a)(function (t, n) {
            if (t <= 0) throw new Error("First argument to splitEvery must be a positive integer");

            for (var r = [], e = 0; e < n.length;) {
              r.push(Object(a.a)(e, e += t, n));
            }

            return r;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r = 0, e = n.length, a = []; r < e && !t(n[r]);) {
              a.push(n[r]), r += 1;
            }

            return [a, Array.prototype.slice.call(n, r)];
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(9),
              u = r(57),
              c = Object(e.a)(function (t, n) {
            return Object(a.a)(Object(u.a)(t.length, n), t);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            return Number(t) - Number(n);
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(52),
              u = r(89),
              c = Object(e.a)(function (t, n) {
            return Object(a.a)(Object(u.a)(t, n), Object(u.a)(n, t));
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(52),
              u = r(90),
              c = Object(e.a)(function (t, n, r) {
            return Object(a.a)(Object(u.a)(t, n, r), Object(u.a)(t, r, n));
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(11),
              u = Object(e.a)(function (t, n) {
            for (var r = n.length - 1; r >= 0 && t(n[r]);) {
              r -= 1;
            }

            return Object(a.a)(r + 1, 1 / 0, n);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(288),
              c = r(11),
              i = Object(e.a)(Object(a.a)(["takeWhile"], u.a, function (t, n) {
            for (var r = 0, e = n.length; r < e && t(n[r]);) {
              r += 1;
            }

            return Object(c.a)(0, r, n);
          }));
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(16),
              u = r(4),
              c = function () {
            function t(t, n) {
              this.xf = n, this.f = t;
            }

            return t.prototype["@@transducer/init"] = u.a.init, t.prototype["@@transducer/result"] = u.a.result, t.prototype["@@transducer/step"] = function (t, n) {
              return this.f(n) ? this.xf["@@transducer/step"](t, n) : Object(a.a)(t);
            }, t;
          }(),
              i = Object(e.a)(function (t, n) {
            return new c(t, n);
          });

          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(3),
              u = r(290),
              c = Object(e.a)(Object(a.a)([], u.a, function (t, n) {
            return t(n), n;
          }));
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(4),
              u = function () {
            function t(t, n) {
              this.xf = n, this.f = t;
            }

            return t.prototype["@@transducer/init"] = a.a.init, t.prototype["@@transducer/result"] = a.a.result, t.prototype["@@transducer/step"] = function (t, n) {
              return this.f(n), this.xf["@@transducer/step"](t, n);
            }, t;
          }(),
              c = Object(e.a)(function (t, n) {
            return new u(t, n);
          });

          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(78),
              a = r(0),
              u = r(292),
              c = r(24),
              i = Object(a.a)(function (t, n) {
            if (!Object(u.a)(t)) throw new TypeError("‘test’ requires a value of type RegExp as its first argument; received " + Object(c.a)(t));
            return Object(e.a)(t).test(n);
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          function e(t) {
            return "[object RegExp]" === Object.prototype.toString.call(t);
          }

          n.a = e;
        }, function (t, n, r) {
          "use strict";

          var e = r(26),
              a = Object(e.a)(0, "toLowerCase");
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(6),
              u = Object(e.a)(function (t) {
            var n = [];

            for (var r in t) {
              Object(a.a)(r, t) && (n[n.length] = [r, t[r]]);
            }

            return n;
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            var n = [];

            for (var r in t) {
              n[n.length] = [r, t[r]];
            }

            return n;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(26),
              a = Object(e.a)(0, "toUpperCase");
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(8),
              a = r(65),
              u = r(5),
              c = Object(u.a)(4, function (t, n, r, u) {
            return Object(e.a)(t("function" == typeof n ? Object(a.a)(n) : n), r, u);
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            for (var n = 0, r = []; n < t.length;) {
              for (var e = t[n], a = 0; a < e.length;) {
                void 0 === r[a] && (r[a] = []), r[a].push(e[a]), a += 1;
              }

              n += 1;
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = r(7),
              u = r(117),
              c = Object(e.a)(function (t, n, r) {
            return "function" == typeof r["fantasy-land/traverse"] ? r["fantasy-land/traverse"](n, t) : Object(u.a)(t, Object(a.a)(n, r));
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
              u = "​",
              c = "function" == typeof String.prototype.trim,
              i = c && !a.trim() && u.trim() ? function (t) {
            return t.trim();
          } : function (t) {
            var n = new RegExp("^[" + a + "][" + a + "]*"),
                r = new RegExp("[" + a + "][" + a + "]*$");
            return t.replace(n, "").replace(r, "");
          },
              o = Object(e.a)(i);
          n.a = o;
        }, function (t, n, r) {
          "use strict";

          var e = r(12),
              a = r(10),
              u = r(0),
              c = Object(u.a)(function (t, n) {
            return Object(e.a)(t.length, function () {
              try {
                return t.apply(this, arguments);
              } catch (t) {
                return n.apply(this, Object(a.a)([t], arguments));
              }
            });
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            return function () {
              return t(Array.prototype.slice.call(arguments, 0));
            };
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = r(33),
              u = Object(e.a)(function (t) {
            return Object(a.a)(1, t);
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(5),
              u = Object(e.a)(function (t, n) {
            return Object(a.a)(t, function () {
              for (var r, e = 1, a = n, u = 0; e <= t && "function" == typeof a;) {
                r = e === t ? arguments.length : u + a.length, a = a.apply(this, Array.prototype.slice.call(arguments, u, r)), e += 1, u = r;
              }

              return a;
            });
          });
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r = t(n), e = []; r && r.length;) {
              e[e.length] = r[0], r = t(r[1]);
            }

            return e;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(10),
              a = r(0),
              u = r(50),
              c = r(60),
              i = Object(a.a)(Object(u.a)(c.a, e.a));
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(10),
              a = r(2),
              u = r(118),
              c = Object(a.a)(function (t, n, r) {
            return Object(u.a)(t, Object(e.a)(n, r));
          });
          n.a = c;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            return t(r) ? r : n(r);
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(59),
              a = r(48),
              u = Object(a.a)(e.a);
          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            for (var e = r; !t(e);) {
              e = n(e);
            }

            return e;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(1),
              a = Object(e.a)(function (t) {
            var n,
                r = [];

            for (n in t) {
              r[r.length] = t[n];
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = function a(t) {
            return {
              value: t,
              "fantasy-land/map": function fantasyLandMap() {
                return this;
              }
            };
          },
              u = Object(e.a)(function (t, n) {
            return t(a)(n).value;
          });

          n.a = u;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            return t(r) ? n(r) : r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = r(9),
              u = r(7),
              c = r(119),
              i = Object(e.a)(function (t, n) {
            return Object(c.a)(Object(u.a)(a.a, t), n);
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(20),
              a = r(0),
              u = r(40),
              c = r(38),
              i = Object(a.a)(function (t, n) {
            return Object(c.a)(Object(u.a)(e.a)(t), n);
          });
          n.a = i;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r, e = 0, a = t.length, u = n.length, c = []; e < a;) {
              for (r = 0; r < u;) {
                c[c.length] = [t[e], n[r]], r += 1;
              }

              e += 1;
            }

            return c;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r = [], e = 0, a = Math.min(t.length, n.length); e < a;) {
              r[e] = [t[e], n[e]], e += 1;
            }

            return r;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(0),
              a = Object(e.a)(function (t, n) {
            for (var r = 0, e = Math.min(t.length, n.length), a = {}; r < e;) {
              a[t[r]] = n[r], r += 1;
            }

            return a;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          var e = r(2),
              a = Object(e.a)(function (t, n, r) {
            for (var e = [], a = 0, u = Math.min(n.length, r.length); a < u;) {
              e[a] = t(n[a], r[a]), a += 1;
            }

            return e;
          });
          n.a = a;
        }, function (t, n, r) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          });

          var e = r(63),
              a = function (t) {
            if (t && t.__esModule) return t;
            var n = {};
            if (null != t) for (var r in t) {
              Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
            }
            return n.default = t, n;
          }(e),
              u = a.equals,
              c = a.complement(a.equals),
              i = function i(t) {
            return function (n) {
              return Array.isArray(n) ? a.intersection(t, n).length > 0 : a.contains(a.__, t)(n);
            };
          },
              o = function o(t) {
            return a.complement(i(t));
          },
              s = function s(t) {
            return a.lt(a.__, parseFloat(t));
          },
              f = function f(t) {
            return a.lte(a.__, parseFloat(t));
          },
              l = function l(t) {
            return a.gt(a.__, parseFloat(t));
          },
              v = function v(t) {
            return a.gte(a.__, parseFloat(t));
          },
              b = function b(t, n) {
            return a.both(a.gte(a.__, parseFloat(t)), a.lte(a.__, parseFloat(n)));
          },
              j = function j(t, n) {
            return a.complement(b(t, n));
          },
              O = a.isEmpty,
              p = a.complement(a.isEmpty),
              d = a.isNil,
              h = a.complement(a.isNil),
              y = function y(t) {
            return function (n) {
              return n.substr(0, t.length) === t;
            };
          },
              g = function g(t) {
            return a.complement(y(t));
          },
              m = function m(t) {
            return function (n) {
              return n.search(t) > -1;
            };
          },
              w = function w(t) {
            return a.complement(m(t));
          },
              x = function x(t) {
            return function (n) {
              var r = n.length - t.length,
                  e = n.lastIndexOf(t, r);
              return -1 !== e && e === r;
            };
          },
              _ = function _(t) {
            return a.complement(x(t));
          },
              A = function A(t, n, r) {
            var e = a.lastIndexOf("/", t),
                u = "boolean" != typeof r || r;

            if (e > 1) {
              var c = t.substr(1, e - 1),
                  i = t.substr(a.min(e + 1, t.length - 1));
              return i = "/" === i ? "" : i, new RegExp(c, i).test(n) === u;
            }

            return new RegExp(t).test(n) === u;
          },
              E = function E(t) {
            return function (n) {
              return A(t, n, !0);
            };
          },
              S = function S(t) {
            return function (n) {
              return A(t, n, !1);
            };
          },
              q = {
            equal: u,
            not_equal: c,
            in: i,
            not_in: o,
            less: s,
            less_or_equal: f,
            greater: l,
            greater_or_equal: v,
            between: b,
            not_between: j,
            is_empty: function () {
              function t() {
                return O;
              }

              return t;
            }(),
            is_not_empty: function () {
              function t() {
                return p;
              }

              return t;
            }(),
            is_null: function () {
              function t() {
                return d;
              }

              return t;
            }(),
            is_not_null: function () {
              function t() {
                return h;
              }

              return t;
            }(),
            begins_with: y,
            not_begins_with: g,
            contains: m,
            not_contains: w,
            ends_with: x,
            not_ends_with: _,
            regex: E,
            not_regex: S
          };

          n.default = q;
        }]);
      });
      /***/
    },
    /* 143 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

      var _Link = __webpack_require__(887);

      var _Link2 = _interopRequireDefault(_Link);

      var _Button = __webpack_require__(884);

      var _Button2 = _interopRequireDefault(_Button);

      var _Element = __webpack_require__(883);

      var _Element2 = _interopRequireDefault(_Element);

      var _scroller = __webpack_require__(237);

      var _scroller2 = _interopRequireDefault(_scroller);

      var _scrollEvents = __webpack_require__(314);

      var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

      var _scrollSpy = __webpack_require__(316);

      var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

      var _animateScroll = __webpack_require__(439);

      var _animateScroll2 = _interopRequireDefault(_animateScroll);

      var _scrollLink = __webpack_require__(317);

      var _scrollLink2 = _interopRequireDefault(_scrollLink);

      var _scrollElement = __webpack_require__(437);

      var _scrollElement2 = _interopRequireDefault(_scrollElement);

      var _Helpers = __webpack_require__(882);

      var _Helpers2 = _interopRequireDefault(_Helpers);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.Link = _Link2.default;
      exports.Button = _Button2.default;
      exports.Element = _Element2.default;
      exports.scroller = _scroller2.default;
      exports.Events = _scrollEvents2.default;
      exports.scrollSpy = _scrollSpy2.default;
      exports.animateScroll = _animateScroll2.default;
      exports.ScrollLink = _scrollLink2.default;
      exports.ScrollElement = _scrollElement2.default;
      exports.Helpers = _Helpers2.default;
      exports.default = {
        Link: _Link2.default,
        Button: _Button2.default,
        Element: _Element2.default,
        scroller: _scroller2.default,
        Events: _scrollEvents2.default,
        scrollSpy: _scrollSpy2.default,
        animateScroll: _animateScroll2.default,
        ScrollLink: _scrollLink2.default,
        ScrollElement: _scrollElement2.default,
        Helpers: _Helpers2.default
      };
      /***/
    },
    /* 144 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _locale_en_US__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(292);

      function noop() {}
      /* harmony default export */


      __webpack_exports__["a"] = {
        propTypes: {
          className: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
          locale: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.object,
          style: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.object,
          visible: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
          onSelect: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
          prefixCls: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
          onChange: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
          onOk: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func
        },
        getDefaultProps: function getDefaultProps() {
          return {
            locale: _locale_en_US__WEBPACK_IMPORTED_MODULE_1__[
            /* default */
            "a"],
            style: {},
            visible: true,
            prefixCls: 'rc-calendar',
            className: '',
            onSelect: noop,
            onChange: noop,
            onClear: noop,
            renderFooter: function renderFooter() {
              return null;
            },
            renderSidebar: function renderSidebar() {
              return null;
            }
          };
        },
        shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
          return this.props.visible || nextProps.visible;
        },
        getFormat: function getFormat() {
          var format = this.props.format;
          var _props = this.props,
              locale = _props.locale,
              timePicker = _props.timePicker;

          if (!format) {
            if (timePicker) {
              format = locale.dateTimeFormat;
            } else {
              format = locale.dateFormat;
            }
          }

          return format;
        },
        focus: function focus() {
          if (this.rootInstance) {
            this.rootInstance.focus();
          }
        },
        saveRoot: function saveRoot(root) {
          this.rootInstance = root;
        }
      };
      /***/
    },
    /* 145 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _isIterable2 = __webpack_require__(1121);

      var _isIterable3 = _interopRequireDefault(_isIterable2);

      var _getIterator2 = __webpack_require__(1118);

      var _getIterator3 = _interopRequireDefault(_getIterator2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;

          try {
            for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if ((0, _isIterable3.default)(Object(arr))) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();
      /***/

    },
    /* 146 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      module.exports = __webpack_require__(1123);
      /***/
    },
    /* 147 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/slicedToArray.js

      var slicedToArray = __webpack_require__(100);

      var slicedToArray_default =
      /*#__PURE__*/
      __webpack_require__.n(slicedToArray); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(21);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/createClass.js


      var createClass = __webpack_require__(20);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(24);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/getPrototypeOf.js


      var getPrototypeOf = __webpack_require__(23);

      var getPrototypeOf_default =
      /*#__PURE__*/
      __webpack_require__.n(getPrototypeOf); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/assertThisInitialized.js


      var assertThisInitialized = __webpack_require__(11);

      var assertThisInitialized_default =
      /*#__PURE__*/
      __webpack_require__.n(assertThisInitialized); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/inherits.js


      var inherits = __webpack_require__(22);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js


      var defineProperty = __webpack_require__(4);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: ./node_modules/lodash/isEqual.js


      var isEqual = __webpack_require__(30);

      var isEqual_default =
      /*#__PURE__*/
      __webpack_require__.n(isEqual); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js


      var Recompose = __webpack_require__(26); // EXTERNAL MODULE: ./node_modules/lodash/noop.js


      var noop = __webpack_require__(9);

      var noop_default =
      /*#__PURE__*/
      __webpack_require__.n(noop); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // EXTERNAL MODULE: ./node_modules/lodash/debounce.js


      var debounce = __webpack_require__(35);

      var debounce_default =
      /*#__PURE__*/
      __webpack_require__.n(debounce); // EXTERNAL MODULE: ./node_modules/cleave.js/dist/cleave-react-node.js


      var cleave_react_node = __webpack_require__(377);

      var cleave_react_node_default =
      /*#__PURE__*/
      __webpack_require__.n(cleave_react_node); // EXTERNAL MODULE: ./src/config/index.js


      var src_config = __webpack_require__(28); // EXTERNAL MODULE: ./src/core/utils/constants.js


      var constants = __webpack_require__(27); // EXTERNAL MODULE: ./src/core/utils/analytics.js + 1 modules


      var analytics = __webpack_require__(17); // EXTERNAL MODULE: ./src/core/utils.js + 1 modules


      var utils = __webpack_require__(18); // EXTERNAL MODULE: ./src/hocs/withFieldSync.js + 1 modules


      var withFieldSync = __webpack_require__(37); // EXTERNAL MODULE: ./src/hocs/withFieldValidation.js + 1 modules


      var withFieldValidation = __webpack_require__(38); // EXTERNAL MODULE: ./src/hocs/withAnalytics.js


      var withAnalytics = __webpack_require__(41); // EXTERNAL MODULE: ./src/hocs/withFieldToken.js


      var withFieldToken = __webpack_require__(34); // EXTERNAL MODULE: ./src/components/index.js + 13 modules


      var components = __webpack_require__(15); // CONCATENATED MODULE: ./src/containers/AutoCompleteContainer.js


      var AutoCompleteContainer_AutoCompleteContainer = function AutoCompleteContainer(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()(defineProperty_default()({}, props.className, props.className))
        }, props.showLabel && props.label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
        /* Label */
        ], {
          labelFor: props.inputId,
          className: props.labelClassName,
          label: props.label,
          isRequired: props.required,
          optionalSuffixLabel: props.optionalSuffixLabel,
          requiredSuffixLabel: props.requiredSuffixLabel,
          showOptionalSuffixLabel: props.showOptionalSuffixLabel,
          showRequiredSuffixLabel: props.showRequiredSuffixLabel,
          suffixLabel: props.required && props.showRequiredSuffixLabel && props.requiredSuffixLabel
        }), props.description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["y"
        /* RichTextArea */
        ], {
          className: props.descriptionClassName,
          html: props.description
        }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["c"
        /* AutoComplete */
        ], {
          className: props.autoCompleteClassName,
          dataSource: props.autoCompleteDataSource,
          readOnly: props.readOnly,
          dropdownClassName: props.autoCompleteDropdownClassName,
          filterOption: props.autoCompleteFilterOption,
          onBlur: props.autoCompleteHandleBlur,
          onFocus: props.autoCompleteHandleFocus,
          onChange: props.autoCompleteHandleOnChange,
          onSearch: props.autoCompleteHandleOnSearch,
          onSelect: props.autoCompleteHandleOnSelect,
          inputClassName: props.autoCompleteInputClassName,
          inputId: props.autoCompleteInputId,
          optionLabelProp: props.autoCompleteOptionLabelProp,
          placeholder: props.autoCompletePlaceholder,
          value: props.autoCompleteValue,
          input: props.input,
          inputOptions: props.inputOptions
        }), props.errorMessage);
      };

      AutoCompleteContainer_AutoCompleteContainer.defaultProps = {
        autoCompleteClassName: '',
        autoCompleteDataSource: [],
        autoCompleteDropdownClassName: '',
        autoCompleteFilterOption: false,
        autoCompleteHandleBlur: noop_default.a,
        autoCompleteHandleFocus: noop_default.a,
        autoCompleteHandleOnChange: noop_default.a,
        autoCompleteHandleOnSearch: noop_default.a,
        autoCompleteHandleOnSelect: noop_default.a,
        autoCompleteInputClassName: '',
        autoCompleteInputId: '',
        autoCompleteOptionLabelProp: '',
        autoCompletePlaceholder: '',
        autoCompleteValue: '',
        className: '',
        description: '',
        descriptionClassName: '',
        errorMessage: null,
        input: 'input',
        inputId: '',
        inputOptions: {},
        label: '',
        labelClassName: '',
        readOnly: false,
        required: false,
        showLabel: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      AutoCompleteContainer_AutoCompleteContainer.propTypes = {
        autoCompleteClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        autoCompleteDataSource: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        autoCompleteDropdownClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        autoCompleteFilterOption: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        autoCompleteHandleBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        autoCompleteHandleFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        autoCompleteHandleOnChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        autoCompleteHandleOnSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        autoCompleteHandleOnSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        autoCompleteInputClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        autoCompleteInputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        autoCompleteOptionLabelProp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        autoCompletePlaceholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        autoCompleteValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        descriptionClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        input: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.element, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        labelClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_AutoCompleteContainer = AutoCompleteContainer_AutoCompleteContainer; // CONCATENATED MODULE: ./src/containers/AbnAcnContainer.js

      var AbnAcnContainer_AbnAcnContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(AbnAcnContainer, _Component);

        function AbnAcnContainer(props) {
          var _this;

          classCallCheck_default()(this, AbnAcnContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(AbnAcnContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "AbnValidator", function (value) {
            // https://abr.business.gov.au/Help/AbnFormat
            var validationString = value.toString();
            var weightings = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
            var abnSum = 0;

            for (var i = 0; i < validationString.length; i += 1) {
              var digit = Number(validationString.charAt(i));

              if (i === 0) {
                digit -= 1;
              }

              abnSum += digit * weightings[i];
            }

            return abnSum % 89 === 0;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "AcnValidator", function (value) {
            // https://asic.gov.au/for-business/registering-a-company/
            // steps-to-register-a-company/australian-company-numbers/australian-company-number-digit-check/
            var validationString = value.toString();
            var weightings = [8, 7, 6, 5, 4, 3, 2, 1];
            var acnSum = 0;
            var checkDigit = 0;

            for (var i = 0; i < validationString.length; i += 1) {
              var digit = Number(validationString.charAt(i));

              if (i === 8) {
                checkDigit = digit;
              } else {
                acnSum += digit * weightings[i];
              }
            }

            var acnModulus = acnSum % 10;
            var complement = 10 - acnModulus;

            if (complement === 10) {
              complement = 0;
            }

            return complement === checkDigit;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "validator", function (value) {
            var displayErrorMessage = '';
            var isValid = true;

            if (_this.props.required) {
              isValid = value.toString().length > 0;

              if (!isValid) {
                displayErrorMessage = _this.props.requiredMessage;
              }
            } else if (value.toString().length === 0) {
              return {
                isValid: isValid,
                displayErrorMessage: displayErrorMessage
              };
            }

            if (isValid) {
              isValid = value.toString().length === 9 || value.toString().length === 11;

              if (!isValid) {
                displayErrorMessage = _this.props.lengthMessage;
              }
            }

            if (isValid) {
              if (value.toString().length === 11) {
                isValid = _this.AbnValidator(value);

                if (!isValid) {
                  displayErrorMessage = _this.props.abnInvalidMessage;
                }
              }

              if (value.toString().length === 9) {
                isValid = _this.AcnValidator(value);

                if (!isValid) {
                  displayErrorMessage = _this.props.acnInvalidMessage;
                }
              }
            }

            return {
              isValid: isValid,
              displayErrorMessage: displayErrorMessage
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "changeValueAndValidate", function (value) {
            var _this$props = _this.props,
                analyticsInteraction = _this$props.analyticsInteraction,
                changeValue = _this$props.changeValue,
                realTimeValidation = _this$props.realTimeValidation;
            changeValue(value, true);

            if (realTimeValidation) {
              // need to trigger validate after the fieldUpdateTimeout, otherwise it'll not have the correct value to run the validation
              _this.debouncedValidate();
            }

            analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].ValueChange);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleTextChange", function (e) {
            e = e.replace(/\s/g, ''); // strip spaces

            _this.changeValueAndValidate(e);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleBlur", function (event) {
            _this.props.onBlur(event);

            _this.props.validate();

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Blur, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Blur);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleFocus", function (event) {
            _this.props.onFocus(event);

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Focus, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Focus);
          });
          _this.debouncedValidate = debounce_default()(_this.props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          return _this;
        }

        createClass_default()(AbnAcnContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            if (this.props.fieldId) {
              this.props.registerValidator(this.validator, this.props.fieldId, constants["Validator"].Custom, false);
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props2 = this.props,
                id = _this$props2.id,
                showLabel = _this$props2.showLabel,
                label = _this$props2.label,
                description = _this$props2.description,
                errorMessage = _this$props2.errorMessage,
                className = _this$props2.className,
                required = _this$props2.required,
                inputId = _this$props2.inputId,
                type = _this$props2.type,
                readOnly = _this$props2.readOnly,
                placeholder = _this$props2.placeholder,
                value = _this$props2.value,
                showError = _this$props2.showError;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              id: id,
              className: classnames_default()('formatic-abn-acn', defineProperty_default()({}, className, className))
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_AutoCompleteContainer, {
              showLabel: showLabel,
              label: label,
              labelClassName: "formatic-field-label formatic-abn-acn__label",
              descriptionClassName: "formatic-abn-acn__description",
              description: description,
              autoCompleteClassName: "formatic-abn-acn__input",
              autoCompleteInputId: inputId,
              required: required,
              maxLength: 11,
              autoCompleteHandleOnChange: this.handleTextChange,
              autoCompleteHandleBlur: this.handleBlur,
              autoCompleteHandleFocus: this.handleFocus,
              autoCompletePlaceholder: placeholder,
              readOnly: readOnly,
              type: type,
              autoCompleteValue: value,
              input: cleave_react_node_default.a,
              inputOptions: {
                options: {
                  delimiter: ' ',
                  blocks: [3, 3, 3, 2],
                  numericOnly: true
                }
              }
            }), showError && errorMessage);
          }
        }]);
        return AbnAcnContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      AbnAcnContainer_AbnAcnContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        fieldId: '',
        parentFieldId: '',
        id: Object(utils["k"
        /* getRandomId */
        ])(),
        inputId: Object(utils["k"
        /* getRandomId */
        ])(),
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        registerValidator: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        type: 'text',
        validate: noop_default.a,
        value: '',
        // attributes from dashboard
        description: '',
        label: '',
        placeholder: '',
        readOnly: false,
        realTimeValidation: false,
        required: false,
        requiredMessage: constants["DefaultRequiredMessage"],
        lengthMessage: 'Must be either 9 digits (ACN) or 11 digits (ABN).',
        abnInvalidMessage: 'Invalid ABN number. Please check again.',
        acnInvalidMessage: 'Invalid ACN number. Please check again.',
        sensitiveMask: '',
        showLabel: true,
        showError: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      AbnAcnContainer_AbnAcnContainer.propTypes = {
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        parentFieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        showError: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        realTimeValidation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        lengthMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        abnInvalidMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        acnInvalidMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        sensitiveMask: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_AbnAcnContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(AbnAcnContainer_AbnAcnContainer); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectSpread.js

      var objectSpread = __webpack_require__(13);

      var objectSpread_default =
      /*#__PURE__*/
      __webpack_require__.n(objectSpread); // EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules


      var es = __webpack_require__(33); // EXTERNAL MODULE: ./node_modules/lodash/get.js


      var get = __webpack_require__(10);

      var get_default =
      /*#__PURE__*/
      __webpack_require__.n(get); // EXTERNAL MODULE: ./node_modules/lodash/replace.js


      var replace = __webpack_require__(84);

      var replace_default =
      /*#__PURE__*/
      __webpack_require__.n(replace); // EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js


      var cloneDeep = __webpack_require__(68);

      var cloneDeep_default =
      /*#__PURE__*/
      __webpack_require__.n(cloneDeep); // EXTERNAL MODULE: ./node_modules/react-apollo/react-apollo.browser.umd.js


      var react_apollo_browser_umd = __webpack_require__(58); // EXTERNAL MODULE: ./src/core/utils/navigation.js


      var navigation = __webpack_require__(50); // EXTERNAL MODULE: ./src/core/utils/requestData.js


      var utils_requestData = __webpack_require__(64); // EXTERNAL MODULE: ./src/core/utils/actions/index.js + 4 modules


      var actions = __webpack_require__(69); // EXTERNAL MODULE: ./src/core/utils/data/helpers.js


      var helpers = __webpack_require__(91); // EXTERNAL MODULE: ./src/core/utils/tokens/tokens.js + 4 modules


      var tokens_tokens = __webpack_require__(61); // EXTERNAL MODULE: ./src/core/RootComponents/helpers/mutations.js


      var mutations = __webpack_require__(112); // EXTERNAL MODULE: ./src/core/utils/graphql/submission.js


      var submission = __webpack_require__(63); // EXTERNAL MODULE: ./src/core/actions/index.js


      var core_actions = __webpack_require__(29); // EXTERNAL MODULE: ./src/core/RootComponents/helpers/pageFlow.js


      var helpers_pageFlow = __webpack_require__(54); // CONCATENATED MODULE: ./src/containers/ActionButtonContainer.js


      var ActionButtonContainer_EMITTER_ACTION = 'ButtonClicked';
      var ActionButtonContainer_SUBMISSION_ID_LENGTH = 40;

      var ActionButtonContainer_ActionButtonContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(ActionButtonContainer, _Component);

        function ActionButtonContainer(props) {
          var _this;

          classCallCheck_default()(this, ActionButtonContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(ActionButtonContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "onClick", function () {
            var _this$props = _this.props,
                afterClick = _this$props.afterClick,
                apiKey = _this$props.apiKey,
                beforeClick = _this$props.beforeClick,
                buttonId = _this$props.buttonId,
                channel = _this$props.channel,
                emitter = _this$props.emitter,
                environment = _this$props.environment,
                fieldId = _this$props.fieldId,
                flows = _this$props.flows,
                formAttributes = _this$props.formAttributes,
                formId = _this$props.formId,
                navigateToPage = _this$props.navigateToPage,
                runPageNavigation = _this$props.runPageNavigation,
                currentFlowName = _this$props.currentFlowName,
                setFlow = _this$props.setFlow,
                pageFlow = _this$props.pageFlow,
                setLocalValues = _this$props.setLocalValues,
                submissionId = _this$props.submissionId,
                visibleFields = _this$props.visibleFields;
            beforeClick();

            if (runPageNavigation && !Object(navigation["b"
            /* pageValidation */
            ])(visibleFields, formAttributes)) {
              return;
            }

            if (_this.props.submissionCompleted && typeof navigateToPage === 'string' && navigateToPage.length > 0 && pageFlow[currentFlowName || helpers_pageFlow["a"
            /* Constants */
            ].DefaultFlow] && pageFlow[currentFlowName || helpers_pageFlow["a"
            /* Constants */
            ].DefaultFlow].indexOf(navigateToPage) === 0) {
              var subId = Object(utils["r"
              /* randomString */
              ])(ActionButtonContainer_SUBMISSION_ID_LENGTH);

              _this.props.setSubmissionId(subId);

              _this.props.removeDataSubmissionById(); // Redux flush


              return;
            }

            Object(utils_requestData["d"
            /* requestData */
            ])({
              method: 'post',
              url: "".concat(src_config["a"
              /* default */
              ].getApiServer(), "/button/click"),
              data: {
                branch: environment,
                channel: channel,
                fieldId: fieldId,
                formId: formId,
                submissionId: submissionId
              },
              headers: {
                Authorization: "Bearer ".concat(apiKey),
                'Content-Type': 'application/json'
              }
            });

            if (Object.keys(setLocalValues).length > 0) {
              _this.setLocalValues();
            }

            if (typeof navigateToPage === 'string' && navigateToPage.length > 0) {
              _this.goToPage(navigateToPage);
            }

            if (setFlow.length > 0 && (setFlow === helpers_pageFlow["a"
            /* Constants */
            ].DefaultFlow || flows[setFlow])) {
              _this.setFlow(setFlow);
            }

            emitter.emit(ActionButtonContainer_EMITTER_ACTION, {
              buttonId: buttonId,
              fieldId: fieldId
            });
            afterClick();
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "goToPage", function (pageId) {
            var _this$props2 = _this.props,
                attributes = _this$props2.attributes,
                channel = _this$props2.channel,
                currentPage = _this$props2.currentPage,
                fields = _this$props2.fields,
                initialValues = _this$props2.initialValues,
                setCurrentPage = _this$props2.setCurrentPage,
                setSubmissionAttribute = _this$props2.setSubmissionAttribute; // Update local store

            setCurrentPage(pageId, channel); // Send mutation to server

            setSubmissionAttribute({
              attributes: [{
                id: 'currentPage',
                value: objectSpread_default()({}, currentPage, defineProperty_default()({}, channel, {
                  pageId: pageId,
                  requestTimestamp: Date.now()
                }))
              }]
            }, {
              attributes: attributes,
              fields: fields,
              initialValues: initialValues
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "setFlow", function (name) {
            var _this$props3 = _this.props,
                attributes = _this$props3.attributes,
                channel = _this$props3.channel,
                currentFlowName = _this$props3.currentFlowName,
                currentPage = _this$props3.currentPage,
                fields = _this$props3.fields,
                formAttributes = _this$props3.formAttributes,
                initialValues = _this$props3.initialValues,
                setSubmissionAttribute = _this$props3.setSubmissionAttribute;
            var flowAttribute = attributes.find(function (o) {
              return o.id === helpers_pageFlow["a"
              /* Constants */
              ].FlowAttributeKey;
            });
            var currentFlow = flowAttribute ? flowAttribute.value : {};
            var flow = formAttributes.flow.find(function (o) {
              return o.name === currentFlowName;
            });
            var currentFlowChannelsAttr = cloneDeep_default()(attributes.find(function (o) {
              return o.id === helpers_pageFlow["a"
              /* Constants */
              ].FlowChannelsExitPageKey;
            }) || {
              value: {}
            }).value;

            if (!currentFlowChannelsAttr[channel]) {
              currentFlowChannelsAttr[channel] = {};
            }

            if (flow === undefined || flow.persistPageTransitions) {
              // persist page transitions, remember which page the user exited from
              // flow === undefined caters for the main flow, in which case always persist
              currentFlowChannelsAttr[channel][currentFlowName] = currentPage[channel].pageId;
            }

            setSubmissionAttribute({
              attributes: [{
                id: helpers_pageFlow["a"
                /* Constants */
                ].FlowAttributeKey,
                value: objectSpread_default()({}, currentFlow, defineProperty_default()({}, channel, name))
              }, {
                id: helpers_pageFlow["a"
                /* Constants */
                ].FlowChannelsExitPageKey,
                value: currentFlowChannelsAttr
              }]
            }, {
              attributes: attributes,
              fields: fields,
              initialValues: initialValues
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "setLocalValues", function () {
            var _this$props4 = _this.props,
                setLocalValues = _this$props4.setLocalValues,
                tokens = _this$props4.tokens;
            var values = Object.keys(setLocalValues).map(function (key) {
              var value = setLocalValues[key];
              var matches = Object(tokens_tokens["b"
              /* getTokensMatches */
              ])(value);

              if (matches) {
                var token;
                matches.forEach(function (match) {
                  token = Object(tokens_tokens["c"
                  /* removeTokensBrackets */
                  ])(match);
                  value = replace_default()(value, match, get_default()(tokens, token, ''));
                });
              }

              return {
                id: key,
                value: value
              };
            }); // Send server-side mutation

            Object(helpers["c"
            /* setSubmissionValues */
            ])([], values, Date.now(), Object(actions["d"
            /* getStore */
            ])(), Object(actions["a"
            /* getClient */
            ])());
          });
          var shouldDebounce = props.debounce,
              debounceWait = props.debounceWait;
          _this.onDebounceClick = shouldDebounce ? debounce_default()(_this.onClick, debounceWait, {
            leading: true,
            trailing: false
          }) : _this.onClick;
          return _this;
        }
        /**
         * Button click event handler
         */


        createClass_default()(ActionButtonContainer, [{
          key: "render",
          value: function render() {
            var _this$props5 = this.props,
                className = _this$props5.className,
                disabled = _this$props5.disabled,
                label = _this$props5.label;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-action-button', defineProperty_default()({}, className, className))
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["e"
            /* Button */
            ], {
              className: classnames_default()('formatic-button', defineProperty_default()({}, className, className)),
              disabled: disabled,
              label: label,
              onClick: this.onDebounceClick
            }));
          }
        }]);
        return ActionButtonContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      ActionButtonContainer_ActionButtonContainer.defaultProps = {
        afterClick: noop_default.a,
        beforeClick: noop_default.a,
        buttonId: '',
        className: '',
        debounce: true,
        debounceWait: 1000,
        disabled: false,
        label: '',
        navigateToPage: '',
        runPageNavigation: false,
        setFlow: '',
        setLocalValues: {},
        tokens: {},
        pageFlow: {},
        visibleFields: {},
        submissionCompleted: false,
        removeDataSubmissionById: noop_default.a,
        setSubmissionId: noop_default.a
      };
      ActionButtonContainer_ActionButtonContainer.propTypes = {
        // formatic props
        buttonId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        debounce: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        debounceWait: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        navigateToPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        runPageNavigation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        setFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        setLocalValues: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // redux
        apiKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        attributes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        currentFlowName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        currentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        emitter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        environment: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        fields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        flows: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        formAttributes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        formId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number.isRequired,
        initialValues: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        setCurrentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        submissionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        tokens: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        pageFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        visibleFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        submissionCompleted: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        removeDataSubmissionById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setSubmissionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        // graphql
        setSubmissionAttribute: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        // misc,
        afterClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        beforeClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };

      var ActionButtonContainer_mapStateToProps = function mapStateToProps(_ref) {
        var _ref$formatic = _ref.formatic,
            apiKey = _ref$formatic.apiKey,
            channel = _ref$formatic.channel,
            currentPage = _ref$formatic.currentPage,
            _ref$formatic$data$su = _ref$formatic.data.submission,
            attributesById = _ref$formatic$data$su.attributesById,
            fieldsById = _ref$formatic$data$su.fieldsById,
            attributes = _ref$formatic.dataForm.attributes,
            emitter = _ref$formatic.emitter,
            environment = _ref$formatic.environment,
            _ref$formatic$flow = _ref$formatic.flow,
            currentFlowName = _ref$formatic$flow.current,
            flows = _ref$formatic$flow.flows,
            formId = _ref$formatic.formId,
            initialValues = _ref$formatic.initialValues,
            submissionId = _ref$formatic.submissionId,
            tokens = _ref$formatic.tokens,
            pageFlow = _ref$formatic.pageFlow,
            visibleFields = _ref$formatic.visibleFields,
            submissionCompleted = _ref$formatic.submissionCompleted;
        return {
          apiKey: apiKey,
          attributes: Object.values(attributesById),
          channel: channel,
          currentFlowName: currentFlowName,
          currentPage: currentPage,
          emitter: emitter,
          environment: environment,
          fields: Object.values(fieldsById),
          flows: flows,
          formAttributes: attributes,
          formId: formId,
          initialValues: initialValues,
          submissionId: submissionId,
          tokens: tokens,
          pageFlow: pageFlow,
          visibleFields: visibleFields,
          submissionCompleted: submissionCompleted
        };
      };

      var ActionButtonContainer_mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
          setCurrentPage: function setCurrentPage(pageId, channel) {
            return dispatch(Object(core_actions["O"
            /* setCurrentPage */
            ])(pageId, channel));
          },
          setSubmissionId: function setSubmissionId(submissionId) {
            return dispatch(Object(core_actions["Aa"
            /* setSubmissionId */
            ])(submissionId));
          },
          removeDataSubmissionById: function removeDataSubmissionById() {
            return dispatch(Object(core_actions["K"
            /* removeDataSubmissionById */
            ])());
          }
        };
      };
      /* harmony default export */


      var containers_ActionButtonContainer = Object(react_apollo_browser_umd["compose"])(Object(es["a"
      /* connect */
      ])(ActionButtonContainer_mapStateToProps, ActionButtonContainer_mapDispatchToProps), Object(react_apollo_browser_umd["graphql"])(submission["c"
      /* setSubmissionValuesMutation */
      ], {
        props: function props(_ref2) {
          var mutate = _ref2.mutate,
              ownProps = _ref2.ownProps;
          return {
            setSubmissionAttribute: Object(mutations["a"
            /* submissionAttribute */
            ])(mutate, ownProps)
          };
        }
      }))(ActionButtonContainer_ActionButtonContainer); // EXTERNAL MODULE: ./node_modules/lodash/omit.js

      var omit = __webpack_require__(62);

      var omit_default =
      /*#__PURE__*/
      __webpack_require__.n(omit); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/toConsumableArray.js


      var toConsumableArray = __webpack_require__(40);

      var toConsumableArray_default =
      /*#__PURE__*/
      __webpack_require__.n(toConsumableArray); // EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js


      var isEmpty = __webpack_require__(25);

      var isEmpty_default =
      /*#__PURE__*/
      __webpack_require__.n(isEmpty); // CONCATENATED MODULE: ./src/containers/AddressLookupContainer/validator.js


      var validator_MANUAL_FIELDS = ['address', 'suburb', 'postcode', 'state', 'country'];
      var validator_ALL_COUNTRIES_MANUAL_FIELDS = ['address', 'suburb', 'postcode', 'country'];

      var validator_emptyValidator = function emptyValidator(isRequired, props) {
        return function (value, internalFieldKey) {
          var errors = {};
          var requiredMessage = get_default()(props, 'requiredMessage', constants["DefaultRequiredMessage"]);
          var manualFields = validator_MANUAL_FIELDS;

          if (props.allowAllCountriesInManualMode) {
            manualFields = validator_ALL_COUNTRIES_MANUAL_FIELDS;
          }

          if (!isRequired) {
            return {
              isValid: true,
              displayErrorMessage: ''
            };
          }

          if (internalFieldKey && [].concat(toConsumableArray_default()(manualFields), ['fullAddress']).includes(internalFieldKey)) {
            if (isEmpty_default()(get_default()(value, internalFieldKey, ''))) {
              errors[internalFieldKey] = requiredMessage;
              return {
                isValid: false,
                displayErrorMessage: requiredMessage,
                errors: errors
              };
            }

            return {
              isValid: true,
              displayErrorMessage: '',
              errors: errors
            };
          }

          var fields = value.isManual ? toConsumableArray_default()(manualFields) : ['fullAddress'];
          var lastKey;
          fields.reverse().forEach(function (key) {
            if (isEmpty_default()(get_default()(value, key, ''))) {
              errors[key] = requiredMessage;
              lastKey = key;
            }
          });
          return {
            isValid: !Object.keys(errors).length,
            displayErrorMessage: get_default()(errors, lastKey, ''),
            errors: errors
          };
        };
      }; // EXTERNAL MODULE: ./node_modules/antd/es/index.js + 278 modules


      var antd_es = __webpack_require__(128); // EXTERNAL MODULE: ./src/components/Button.js


      var Button = __webpack_require__(165); // EXTERNAL MODULE: ./src/components/FormLoading.js


      var FormLoading = __webpack_require__(116); // CONCATENATED MODULE: ./src/containers/AddressLookupContainer/dataSource.js


      var dataSource_renderTextMessageOption = function renderTextMessageOption(text) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(antd_es["d"
        /* Select */
        ].Option, {
          disabled: true,
          key: "message",
          className: "formatic-address-lookup__message"
        }, text);
      };

      var dataSource_renderEnterManually = function renderEnterManually(enterManuallyButtonLabel, handleEnterManuallyClick) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(antd_es["d"
        /* Select */
        ].Option, {
          disabled: true,
          key: "enter_manually",
          className: "formatic-address-lookup__option-enter-manually"
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Button["a"
        /* default */
        ], {
          label: enterManuallyButtonLabel,
          className: "formatic-address-lookup__button-enter-manually",
          onClick: handleEnterManuallyClick
        }));
      };

      var dataSource_handleSearchErrorResult = function handleSearchErrorResult(searchErrorMessage, enterManuallyButtonLabel, handleEnterManuallyClick) {
        return [dataSource_renderTextMessageOption(searchErrorMessage), dataSource_renderEnterManually(enterManuallyButtonLabel, handleEnterManuallyClick)];
      };

      var dataSource_getStatusMessage = function getStatusMessage(waitingResponseMessage, noResultsMessage) {
        var fullAddress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        var minCharsToSearch = arguments.length > 3 ? arguments[3] : undefined;
        var isWaitingResponse = arguments.length > 4 ? arguments[4] : undefined;
        var message = '';

        if (fullAddress && fullAddress.length >= minCharsToSearch) {
          if (isWaitingResponse) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-address-lookup__loading"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(FormLoading["a"
            /* default */
            ], {
              loadingText: waitingResponseMessage
            }));
          }

          message = noResultsMessage;
        }

        return message;
      };

      var dataSource_handleSearchResult = function handleSearchResult(addresses, waitingResponseMessage, noResultsMessage, fullAddress, minCharsToSearch, isWaitingResponse, enterManuallyButtonLabel, handleEnterManuallyClick) {
        var checkStatus = addresses.length < 1;
        var statusMessage;

        if (checkStatus) {
          statusMessage = dataSource_getStatusMessage(waitingResponseMessage, noResultsMessage, fullAddress, minCharsToSearch, isWaitingResponse);
        }

        return checkStatus ? [dataSource_renderTextMessageOption(statusMessage), dataSource_renderEnterManually(enterManuallyButtonLabel, handleEnterManuallyClick)] : addresses.map(function (address) {
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(antd_es["d"
          /* Select */
          ].Option, {
            key: address.id,
            value: address.fullAddress
          }, address.fullAddress);
        }).concat([dataSource_renderEnterManually(enterManuallyButtonLabel, handleEnterManuallyClick)]);
      };

      var dataSource_getDataSource = function getDataSource(exception, searchErrorMessage, enterManuallyButtonLabel, handleEnterManuallyClick, addresses, waitingResponseMessage, noResultsMessage, fullAddress, minCharsToSearch, isWaitingResponse) {
        if (exception) {
          return dataSource_handleSearchErrorResult(searchErrorMessage, enterManuallyButtonLabel, handleEnterManuallyClick);
        }

        return dataSource_handleSearchResult(addresses, waitingResponseMessage, noResultsMessage, fullAddress, minCharsToSearch, isWaitingResponse, enterManuallyButtonLabel, handleEnterManuallyClick);
      }; // EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js


      var uniqBy = __webpack_require__(217);

      var uniqBy_default =
      /*#__PURE__*/
      __webpack_require__.n(uniqBy); // CONCATENATED MODULE: ./src/containers/AddressLookupContainer/search.js

      /**
       * Search the address/search/query api
       * @param value
       */


      var search_handleSearch = function handleSearch(requestData, maxResults, minCharsToSearch, setStateCallback, setInstanceVariableCallback) {
        return function (value) {
          if (value.length >= minCharsToSearch) {
            requestData({
              method: 'post',
              url: src_config["a"
              /* default */
              ].getApiServer().concat('/address/search/query'),
              data: "address=".concat(encodeURI(value), "&limit=").concat(maxResults)
            }).then(function (result) {
              var addresses = uniqBy_default()(get_default()(result, 'data', []), 'fullAddress');
              setStateCallback({
                addresses: addresses
              });
              setInstanceVariableCallback({
                isWaitingResponse: false
              });
            }).catch(function () {
              setStateCallback({
                addresses: [],
                exception: true
              });
              setInstanceVariableCallback({
                isWaitingResponse: false
              });
            });
          } else {
            setStateCallback({
              addresses: []
            });
          }
        };
      }; // CONCATENATED MODULE: ./src/containers/AddressLookupContainer/analytics.js

      /**
       * Analytics handler
       * @param value
       */


      var handleAnalytics = function handleAnalytics(analyticsInteraction, AnalyticsEvent) {
        return function () {
          analyticsInteraction(AnalyticsEvent);
        };
      }; // CONCATENATED MODULE: ./src/containers/AddressLookupContainer/handleChangeValue.js


      var handleChangeValue_handleOnSelectAndOnChange = function handleOnSelectAndOnChange(value, addresses, changeValueCallback) {
        var onSelect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var currentValue = arguments.length > 4 ? arguments[4] : undefined;
        var debouncedValidateCallback = arguments.length > 5 ? arguments[5] : undefined;
        var selectedAddress = addresses.filter(function (address) {
          return address.fullAddress === value;
        });
        var updatedValue = {
          address: onSelect ? get_default()(selectedAddress, '[0].address') : get_default()(currentValue, 'address', ''),
          suburb: onSelect ? get_default()(selectedAddress, '[0].suburb') : get_default()(currentValue, 'suburb', ''),
          state: onSelect ? get_default()(selectedAddress, '[0].state') : get_default()(currentValue, 'state', ''),
          postcode: onSelect ? get_default()(selectedAddress, '[0].postcode') : get_default()(currentValue, 'postcode', ''),
          country: onSelect ? get_default()(selectedAddress, '[0].country') : get_default()(currentValue, 'country', ''),
          fullAddress: value,
          isManual: currentValue.isManual,
          isAuto: onSelect
        };
        changeValueCallback(updatedValue, true);
        debouncedValidateCallback();
        return updatedValue;
      };

      var handleChangeValue_getHandleEnterManuallyClickCallback = function getHandleEnterManuallyClickCallback(changeValueCallback, currentValue) {
        return function () {
          var value = {
            isManual: true,
            fullAddress: '',
            isAuto: false
          };
          changeValueCallback(objectSpread_default()({}, currentValue, value), true, objectSpread_default()({}, Object(analytics["d"
          /* getAnalyticsParam */
          ])(value)));
        };
      };

      var handleChangeValue_getHandleBackClickCallback = function getHandleBackClickCallback(changeValueCallback, currentValue, clearAddressesCallBack) {
        return function () {
          clearAddressesCallBack();
          var value = {
            isManual: false,
            address: '',
            suburb: '',
            state: '',
            postcode: '',
            country: '',
            fullAddress: '',
            isAuto: false
          };
          changeValueCallback(objectSpread_default()({}, currentValue, value), true, objectSpread_default()({}, Object(analytics["d"
          /* getAnalyticsParam */
          ])(value)));
        };
      };

      var handleChangeValue_getFullAddress = function getFullAddress(currentValue, changes) {
        var currentValueWithChanges = objectSpread_default()({}, currentValue, changes);
        return validator_MANUAL_FIELDS.reduce(function (accum, key) {
          if (currentValueWithChanges[key] && currentValueWithChanges[key].length) {
            accum.push(currentValueWithChanges[key]);
          }

          return accum;
        }, []).join(', ');
      };

      var handleChangeValue_getOnValueChangeCallback = function getOnValueChangeCallback(changeValueCallback, currentValue, changes) {
        var value = objectSpread_default()({}, currentValue, changes, {
          fullAddress: handleChangeValue_getFullAddress(currentValue, changes)
        });
        changeValueCallback(objectSpread_default()({}, currentValue, value), true, objectSpread_default()({}, Object(analytics["d"
        /* getAnalyticsParam */
        ])(value)));
      }; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js


      var helpers_typeof = __webpack_require__(39);

      var typeof_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_typeof); // CONCATENATED MODULE: ./src/core/utils/inputMask.js

      /**
       * It applies the sensitiveMask on maskedValue and then returns it.
       * It'll combine both values and it'll only keep the maskedValue values
       * where, in the same index position of sensitiveMask, it has the character '_'.
       *   e.g. considering maskedValue = '5231 4561 8546 7893' and sensitiveMask = '**** **** **** ____'
       *   the returned value is '**** **** **** 7893'
       */


      var inputMask_getMaskedSensitiveValue = function getMaskedSensitiveValue() {
        var maskedValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var sensitiveMask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        if (isEmpty_default()(sensitiveMask)) {
          return maskedValue;
        }

        var matches = sensitiveMask.split('_');
        var index = 0;
        return matches.reduce(function (maskedSensitiveValue, match, matchesIndex) {
          if (match.length > 0) {
            maskedSensitiveValue += sensitiveMask.substr(index, match.length);
            index += match.length;
          } // if it is not the last item


          if (matchesIndex < matches.length - 1) {
            maskedSensitiveValue += index < maskedValue.length ? maskedValue[index] : sensitiveMask[index];
            index += 1;
          }

          return maskedSensitiveValue;
        }, '');
      };
      /**
       * If isCreditCard is false, then it returns rawValue without modifying it.
       * Otherwise it'll return a sensitive mask according to which credit card rawValue contains.
       * That's required since Cleave.js changes its mask depending on the input.
       * The sensitiveMask masks below only shows the last 4 digits of it.
       * We could customise it and get this from the dashboard, but it was decided that showing the last 4 digits
       * is something standard and it should take care of 99% of the cases. If we need to show more/less characters
       * then we'd have at least three options:
       *  1- Making sensitiveMask a json/array containing 4 different sensitiveMasks according to the different credit card masks.
       *  2- Informing how many characters from the credit card we should display and then build those masks dynamically.
       *  3- Update getSensitiveMask accordingly without changing the dashboard.
       */


      var inputMask_getSensitiveMask = function getSensitiveMask(rawValue, sensitiveMask) {
        var isCreditCard = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (isCreditCard) {
          if (/^4/.test(rawValue) || // visa
          /(^5[1-5])|(^2[2-7])/.test(rawValue) || // master
          /(^2131)|(^1800)|(^35)/.test(rawValue) || // JCB
          /(^6011)|(^65)|(^64[4-9])/.test(rawValue) // Discover
          ) {
              sensitiveMask = '**** **** **** ____';
            } else if (/(^34)|(^37)/.test(rawValue)) {
            sensitiveMask = '**** ****** *____'; // american express
          } else if (/(^30[0-5])|(^309)/.test(rawValue)) {
            sensitiveMask = '**** ****** ____'; // diners club
          } else if (/(^1)/.test(rawValue)) {
            sensitiveMask = '**** ***** **____'; // mask used by cleave.js when it starts with 1
          }
        }

        return sensitiveMask;
      }; // CONCATENATED MODULE: ./src/containers/TextContainer.js


      var TextContainer_TextContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(TextContainer, _Component);

        function TextContainer(props) {
          var _this;

          classCallCheck_default()(this, TextContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(TextContainer).call(this, props)); // TODO: once componentDidMount is removed, follow approach in DropdownContainer to make debouncedValidate

          defineProperty_default()(assertThisInitialized_default()(_this), "validator", function (value) {
            var displayErrorMessage = '';

            if (!_this.props.required) {
              return {
                isValid: true,
                displayErrorMessage: displayErrorMessage
              };
            }

            var isValid = false;
            var maskOptions = _this.props.maskOptions;

            if (maskOptions) {
              // then it's a InputMask component
              isValid = get_default()(value, 'rawValue', '').length > 0;
            } else {
              // then it's a Text component
              isValid = value.length > 0;
            }

            if (!isValid) {
              displayErrorMessage = _this.props.requiredMessage;
            }

            return {
              isValid: isValid,
              displayErrorMessage: displayErrorMessage
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getValueLength", function () {
            return typeof_default()(_this.props.value) === 'object' ? _this.props.value.maskedValue.length : _this.props.value.length;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "shouldTruncateNewValue", function (newValueLength) {
            return _this.props.maxLength > 0 && newValueLength > _this.getValueLength() && newValueLength > _this.props.maxLength;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "changeValueAndValidate", function (value) {
            var _this$props = _this.props,
                analyticsInteraction = _this$props.analyticsInteraction,
                changeValue = _this$props.changeValue,
                realTimeValidation = _this$props.realTimeValidation;
            changeValue(value, true);

            if (realTimeValidation) {
              // need to trigger validate after the fieldUpdateTimeout, otherwise it'll not have the correct value to run the validation
              _this.debouncedValidate();
            }

            analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].ValueChange);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleTextChange", function (e) {
            var value = e.target.value;

            if (_this.shouldTruncateNewValue(value.length)) {
              value = value.substr(0, _this.props.maxLength);
            }

            _this.changeValueAndValidate(value);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleInputMaskChange", function (value) {
            var maskOptions = _this.props.maskOptions;

            if (_this.shouldTruncateNewValue(value.maskedValue.length)) {
              value.rawValue = value.rawValue.substr(0, _this.props.maxLength);
              value.maskedValue = value.maskedValue.substr(0, _this.props.maxLength);
            }

            _this.changeValueAndValidate({
              rawValue: value.rawValue,
              maskedValue: value.maskedValue,
              maskedSensitiveValue: inputMask_getMaskedSensitiveValue(value.maskedValue, inputMask_getSensitiveMask(value.rawValue, _this.props.sensitiveMask, get_default()(maskOptions, 'creditCard')))
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleBlur", function (event) {
            _this.props.onBlur(event);

            _this.props.validate();

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Blur, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Blur);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleFocus", function (event) {
            _this.props.onFocus(event);

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Focus, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Focus);
          });
          _this.debouncedValidate = debounce_default()(_this.props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          return _this;
        }

        createClass_default()(TextContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            if (this.props.fieldId) {
              this.props.registerValidator(this.validator, this.props.fieldId, constants["Validator"].Empty, false);
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props2 = this.props,
                autoComplete = _this$props2.autoComplete,
                id = _this$props2.id,
                showLabel = _this$props2.showLabel,
                label = _this$props2.label,
                maskOptions = _this$props2.maskOptions,
                description = _this$props2.description,
                errorMessage = _this$props2.errorMessage,
                maxLength = _this$props2.maxLength,
                className = _this$props2.className,
                required = _this$props2.required,
                inputId = _this$props2.inputId,
                type = _this$props2.type,
                readOnly = _this$props2.readOnly,
                placeholder = _this$props2.placeholder,
                requiredSuffixLabel = _this$props2.requiredSuffixLabel,
                showRequiredSuffixLabel = _this$props2.showRequiredSuffixLabel,
                value = _this$props2.value,
                showError = _this$props2.showError;
            var autoCompleteDisabledValue = src_config["a"
            /* default */
            ].autoCompleteDisabledValue,
                autoCompleteBrowserValue = src_config["a"
            /* default */
            ].autoCompleteBrowserValue;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              id: id,
              className: classnames_default()('formatic-text', defineProperty_default()({}, className, className))
            }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              labelFor: inputId,
              className: "formatic-field-label formatic-text__label",
              label: label,
              isRequired: required,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-text__description",
              description: description
            }), maskOptions && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["r"
            /* InputMask */
            ], {
              changeValue: this.handleInputMaskChange,
              className: "formatic-text__input",
              id: inputId,
              maskOptions: maskOptions,
              maxLength: maxLength > 0 ? maxLength : undefined,
              onBlur: this.handleBlur,
              onFocus: this.handleFocus,
              placeholder: placeholder,
              readOnly: readOnly,
              type: type,
              value: value.rawValue
            }), !maskOptions && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
            /* Text */
            ], {
              autoComplete: autoComplete === autoCompleteDisabledValue ? autoCompleteBrowserValue : autoComplete,
              onChange: this.handleTextChange,
              className: "formatic-text__input",
              id: inputId,
              maxLength: maxLength > 0 ? maxLength : undefined,
              onBlur: this.handleBlur,
              onFocus: this.handleFocus,
              placeholder: placeholder,
              readOnly: readOnly,
              type: type,
              value: value
            }), showError && errorMessage);
          }
        }]);
        return TextContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      TextContainer_TextContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        fieldId: '',
        parentFieldId: '',
        id: Object(utils["k"
        /* getRandomId */
        ])(),
        inputId: Object(utils["k"
        /* getRandomId */
        ])(),
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        registerValidator: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        type: 'text',
        validate: noop_default.a,
        value: '',
        // attributes from dashboard
        description: '',
        label: '',
        maskOptions: '',
        maxLength: '',
        placeholder: '',
        readOnly: false,
        realTimeValidation: false,
        required: false,
        requiredMessage: constants["DefaultRequiredMessage"],
        sensitiveMask: '',
        showLabel: true,
        showError: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      TextContainer_TextContainer.propTypes = {
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        autoComplete: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        parentFieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        showError: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          rawValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          maskedValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          maskedSensitiveValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        }), external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // Cleave's options prop: https://github.com/nosir/cleave.js/blob/master/doc/options.md
        maskOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        maxLength: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        realTimeValidation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        sensitiveMask: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_TextContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(TextContainer_TextContainer); // CONCATENATED MODULE: ./src/containers/DropdownContainer.js

      var DropdownContainer_debouncedValidate = function debouncedValidate(validate) {
        return debounce_default()(validate, src_config["a"
        /* default */
        ].getFieldUpdateTimeout());
      };

      var DropdownContainer_handleChange = function handleChange(changeValue, validate, analyticsInteraction) {
        return function (value) {
          changeValue(value, false); // need to trigger validate after the fieldUpdateTimeout, otherwise it'll not have the correct value to run the validation

          DropdownContainer_debouncedValidate(validate);
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].ValueChange);
        };
      };

      var DropdownContainer_handleNativeChange = function handleNativeChange(changeValue, validate, analyticsInteraction) {
        return function (event) {
          changeValue(event.target.value, false); // need to trigger validate after the fieldUpdateTimeout, otherwise it'll not have the correct value to run the validation

          DropdownContainer_debouncedValidate(validate);
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].ValueChange);
        };
      };

      var DropdownContainer_handleBlur = function handleBlur(onBlur, validate, sendAnalytics, analyticsParams, analyticsInteraction) {
        return function (event) {
          onBlur(event); // we must also validate on blur event in order to trigger validation if the user clicked on the dropdown but didn't select a value

          validate();
          sendAnalytics(analytics["a"
          /* AnalyticsEvents */
          ].Blur, analyticsParams);
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].Blur);
        };
      };

      var DropdownContainer_handleFocus = function handleFocus(onFocus, sendAnalytics, analyticsParams, analyticsInteraction) {
        return function (event) {
          onFocus(event);
          sendAnalytics(analytics["a"
          /* AnalyticsEvents */
          ].Focus, analyticsParams);
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].Focus);
        };
      };

      var DropdownContainer_DropdownContainer = function DropdownContainer(props) {
        var description = props.description,
            errorMessage = props.errorMessage,
            label = props.label,
            placeholder = props.placeholder,
            required = props.required,
            requiredSuffixLabel = props.requiredSuffixLabel,
            showError = props.showError,
            showSearch = props.showSearch,
            showRequiredSuffixLabel = props.showRequiredSuffixLabel,
            showLabel = props.showLabel,
            options = props.options,
            value = props.value,
            mobileUseNative = props.mobileUseNative;
        var renderNative = mobileUseNative && Object(utils["p"
        /* mobileAndTabletcheck */
        ])();
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()('formatic-dropdown', defineProperty_default()({}, props.className, props.className))
        }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
        /* Label */
        ], {
          className: "formatic-field-label formatic-dropdown__label",
          label: label,
          labelFor: props.inputId,
          isRequired: required,
          suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
        }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
        /* FieldDescription */
        ], {
          className: "formatic-dropdown__description",
          description: description
        }), !renderNative && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["j"
        /* Dropdown */
        ], {
          default: props.default,
          options: options,
          placeholder: placeholder,
          showSearch: showSearch,
          id: props.inputId,
          selectClassName: "formatic-dropdown__select",
          dropdownClassName: "formatic-ant-dropdown formatic-dropdown__select-menu",
          selectOptionClassName: "formatic-dropdown__option",
          onBlur: DropdownContainer_handleBlur(props.onBlur, props.validate, props.sendAnalytics, props.analyticsParams, props.analyticsInteraction),
          onChange: DropdownContainer_handleChange(props.changeValue, props.validate, props.analyticsInteraction),
          onFocus: DropdownContainer_handleFocus(props.onFocus, props.sendAnalytics, props.analyticsParams, props.analyticsInteraction),
          value: value
        }), renderNative && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["k"
        /* DropdownNative */
        ], {
          defaultValue: props.default,
          options: options,
          placeholder: placeholder,
          id: props.inputId,
          className: "formatic-dropdown-native__select",
          onBlur: DropdownContainer_handleBlur(props.onBlur, props.validate, props.sendAnalytics, props.analyticsParams, props.analyticsInteraction),
          onChange: DropdownContainer_handleNativeChange(props.changeValue, props.validate, props.analyticsInteraction),
          onFocus: DropdownContainer_handleFocus(props.onFocus, props.sendAnalytics, props.analyticsParams, props.analyticsInteraction),
          value: value
        }), showError && errorMessage);
      };

      DropdownContainer_DropdownContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        errorMessage: null,
        className: '',
        inputId: '',
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        value: '',
        validate: noop_default.a,
        // attributes from dashboard
        default: '',
        description: '',
        label: '',
        mobileUseNative: false,
        options: [],
        placeholder: 'Please select',
        required: false,
        showLabel: true,
        showSearch: false,
        showError: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      DropdownContainer_DropdownContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        showError: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        // attributes from dashboard
        default: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        mobileUseNative: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        options: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_DropdownContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(DropdownContainer_DropdownContainer); // CONCATENATED MODULE: ./src/containers/AddressLookupContainer/config.js

      /**
       * Analytics Australian states
       */

      var australianStates = ['NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'ACT', 'NT'];
      /**
       * Analytics New Zealand states
       */

      var newZealandStates = ['NTL', 'AUK', 'WKO', 'BOP', 'GIS', 'HKB', 'TKI', 'MWT', 'WGN', 'TAS', 'NSN', 'MBH', 'WTC', 'CAN', 'OTA', 'STL'];
      /**
       * Countries List (AU and NZ only)
       */

      var countryList = [{
        name: 'Australia',
        code: 'AU',
        stateList: australianStates
      }, {
        name: 'New Zealand',
        code: 'NZ',
        stateList: newZealandStates
      }];
      /**
       * Countries List (All countries)
       */

      var allCountriesList = [{
        code: 'AF',
        name: 'Afghanistan',
        stateList: false
      }, {
        code: 'AX',
        name: 'Åland Islands',
        stateList: false
      }, {
        code: 'AL',
        name: 'Albania',
        stateList: false
      }, {
        code: 'DZ',
        name: 'Algeria',
        stateList: false
      }, {
        code: 'AS',
        name: 'American Samoa',
        stateList: false
      }, {
        code: 'AD',
        name: 'Andorra',
        stateList: false
      }, {
        code: 'AO',
        name: 'Angola',
        stateList: false
      }, {
        code: 'AI',
        name: 'Anguilla',
        stateList: false
      }, {
        code: 'AQ',
        name: 'Antarctica',
        stateList: false
      }, {
        code: 'AG',
        name: 'Antigua and Barbuda',
        stateList: false
      }, {
        code: 'AR',
        name: 'Argentina',
        stateList: false
      }, {
        code: 'AM',
        name: 'Armenia',
        stateList: false
      }, {
        code: 'AW',
        name: 'Aruba',
        stateList: false
      }, {
        code: 'AU',
        name: 'Australia',
        stateList: australianStates
      }, {
        code: 'AT',
        name: 'Austria',
        stateList: false
      }, {
        code: 'AZ',
        name: 'Azerbaijan',
        stateList: false
      }, {
        code: 'BS',
        name: 'Bahamas',
        stateList: false
      }, {
        code: 'BH',
        name: 'Bahrain',
        stateList: false
      }, {
        code: 'BD',
        name: 'Bangladesh',
        stateList: false
      }, {
        code: 'BB',
        name: 'Barbados',
        stateList: false
      }, {
        code: 'BY',
        name: 'Belarus',
        stateList: false
      }, {
        code: 'BE',
        name: 'Belgium',
        stateList: false
      }, {
        code: 'BZ',
        name: 'Belize',
        stateList: false
      }, {
        code: 'BJ',
        name: 'Benin',
        stateList: false
      }, {
        code: 'BM',
        name: 'Bermuda',
        stateList: false
      }, {
        code: 'BT',
        name: 'Bhutan',
        stateList: false
      }, {
        code: 'BO',
        name: 'Bolivia, Plurinational State of',
        stateList: false
      }, {
        code: 'BQ',
        name: 'Bonaire, Sint Eustatius and Saba',
        stateList: false
      }, {
        code: 'BA',
        name: 'Bosnia and Herzegovina',
        stateList: false
      }, {
        code: 'BW',
        name: 'Botswana',
        stateList: false
      }, {
        code: 'BV',
        name: 'Bouvet Island',
        stateList: false
      }, {
        code: 'BR',
        name: 'Brazil',
        stateList: false
      }, {
        code: 'IO',
        name: 'British Indian Ocean Territory',
        stateList: false
      }, {
        code: 'BN',
        name: 'Brunei Darussalam',
        stateList: false
      }, {
        code: 'BG',
        name: 'Bulgaria',
        stateList: false
      }, {
        code: 'BF',
        name: 'Burkina Faso',
        stateList: false
      }, {
        code: 'BI',
        name: 'Burundi',
        stateList: false
      }, {
        code: 'KH',
        name: 'Cambodia',
        stateList: false
      }, {
        code: 'CM',
        name: 'Cameroon',
        stateList: false
      }, {
        code: 'CA',
        name: 'Canada',
        stateList: false
      }, {
        code: 'CV',
        name: 'Cape Verde',
        stateList: false
      }, {
        code: 'KY',
        name: 'Cayman Islands',
        stateList: false
      }, {
        code: 'CF',
        name: 'Central African Republic',
        stateList: false
      }, {
        code: 'TD',
        name: 'Chad',
        stateList: false
      }, {
        code: 'CL',
        name: 'Chile',
        stateList: false
      }, {
        code: 'CN',
        name: 'China',
        stateList: false
      }, {
        code: 'CX',
        name: 'Christmas Island',
        stateList: false
      }, {
        code: 'CC',
        name: 'Cocos (Keeling) Islands',
        stateList: false
      }, {
        code: 'CO',
        name: 'Colombia',
        stateList: false
      }, {
        code: 'KM',
        name: 'Comoros',
        stateList: false
      }, {
        code: 'CG',
        name: 'Congo',
        stateList: false
      }, {
        code: 'CD',
        name: 'Congo, the Democratic Republic of the',
        stateList: false
      }, {
        code: 'CK',
        name: 'Cook Islands',
        stateList: false
      }, {
        code: 'CR',
        name: 'Costa Rica',
        stateList: false
      }, {
        code: 'CI',
        name: "Côte d' Ivoire",
        stateList: false
      }, {
        code: 'HR',
        name: 'Croatia',
        stateList: false
      }, {
        code: 'CU',
        name: 'Cuba',
        stateList: false
      }, {
        code: 'CW',
        name: 'Curaçao',
        stateList: false
      }, {
        code: 'CY',
        name: 'Cyprus',
        stateList: false
      }, {
        code: 'CZ',
        name: 'Czech Republic',
        stateList: false
      }, {
        code: 'DK',
        name: 'Denmark',
        stateList: false
      }, {
        code: 'DJ',
        name: 'Djibouti',
        stateList: false
      }, {
        code: 'DM',
        name: 'Dominica',
        stateList: false
      }, {
        code: 'DO',
        name: 'Dominican Republic',
        stateList: false
      }, {
        code: 'EC',
        name: 'Ecuador',
        stateList: false
      }, {
        code: 'EG',
        name: 'Egypt',
        stateList: false
      }, {
        code: 'SV',
        name: 'El Salvador',
        stateList: false
      }, {
        code: 'GQ',
        name: 'Equatorial Guinea',
        stateList: false
      }, {
        code: 'ER',
        name: 'Eritrea',
        stateList: false
      }, {
        code: 'EE',
        name: 'Estonia',
        stateList: false
      }, {
        code: 'ET',
        name: 'Ethiopia',
        stateList: false
      }, {
        code: 'FK',
        name: 'Falkland Islands (Malvinas)',
        stateList: false
      }, {
        code: 'FO',
        name: 'Faroe Islands',
        stateList: false
      }, {
        code: 'FJ',
        name: 'Fiji',
        stateList: false
      }, {
        code: 'FI',
        name: 'Finland',
        stateList: false
      }, {
        code: 'FR',
        name: 'France',
        stateList: false
      }, {
        code: 'GF',
        name: 'French Guiana',
        stateList: false
      }, {
        code: 'PF',
        name: 'French Polynesia',
        stateList: false
      }, {
        code: 'TF',
        name: 'French Southern Territories',
        stateList: false
      }, {
        code: 'GA',
        name: 'Gabon',
        stateList: false
      }, {
        code: 'GM',
        name: 'Gambia',
        stateList: false
      }, {
        code: 'GE',
        name: 'Georgia',
        stateList: false
      }, {
        code: 'DE',
        name: 'Germany',
        stateList: false
      }, {
        code: 'GH',
        name: 'Ghana',
        stateList: false
      }, {
        code: 'GI',
        name: 'Gibraltar',
        stateList: false
      }, {
        code: 'GR',
        name: 'Greece',
        stateList: false
      }, {
        code: 'GL',
        name: 'Greenland',
        stateList: false
      }, {
        code: 'GD',
        name: 'Grenada',
        stateList: false
      }, {
        code: 'GP',
        name: 'Guadeloupe',
        stateList: false
      }, {
        code: 'GU',
        name: 'Guam',
        stateList: false
      }, {
        code: 'GT',
        name: 'Guatemala',
        stateList: false
      }, {
        code: 'GG',
        name: 'Guernsey',
        stateList: false
      }, {
        code: 'GN',
        name: 'Guinea',
        stateList: false
      }, {
        code: 'GW',
        name: 'Guinea-Bissau',
        stateList: false
      }, {
        code: 'GY',
        name: 'Guyana',
        stateList: false
      }, {
        code: 'HT',
        name: 'Haiti',
        stateList: false
      }, {
        code: 'HM',
        name: 'Heard Island and McDonald Islands',
        stateList: false
      }, {
        code: 'VA',
        name: 'Holy See (Vatican City State)',
        stateList: false
      }, {
        code: 'HN',
        name: 'Honduras',
        stateList: false
      }, {
        code: 'HK',
        name: 'Hong Kong',
        stateList: false
      }, {
        code: 'HU',
        name: 'Hungary',
        stateList: false
      }, {
        code: 'IS',
        name: 'Iceland',
        stateList: false
      }, {
        code: 'IN',
        name: 'India',
        stateList: false
      }, {
        code: 'ID',
        name: 'Indonesia',
        stateList: false
      }, {
        code: 'IR',
        name: 'Iran, Islamic Republic of',
        stateList: false
      }, {
        code: 'IQ',
        name: 'Iraq',
        stateList: false
      }, {
        code: 'IE',
        name: 'Ireland',
        stateList: false
      }, {
        code: 'IM',
        name: 'Isle of Man',
        stateList: false
      }, {
        code: 'IL',
        name: 'Israel',
        stateList: false
      }, {
        code: 'IT',
        name: 'Italy',
        stateList: false
      }, {
        code: 'JM',
        name: 'Jamaica',
        stateList: false
      }, {
        code: 'JP',
        name: 'Japan',
        stateList: false
      }, {
        code: 'JE',
        name: 'Jersey',
        stateList: false
      }, {
        code: 'JO',
        name: 'Jordan',
        stateList: false
      }, {
        code: 'KZ',
        name: 'Kazakhstan',
        stateList: false
      }, {
        code: 'KE',
        name: 'Kenya',
        stateList: false
      }, {
        code: 'KI',
        name: 'Kiribati',
        stateList: false
      }, {
        code: 'KP',
        name: "Korea, Democratic People's Republic of",
        stateList: false
      }, {
        code: 'KR',
        name: 'Korea, Republic of',
        stateList: false
      }, {
        code: 'KW',
        name: 'Kuwait',
        stateList: false
      }, {
        code: 'KG',
        name: 'Kyrgyzstan',
        stateList: false
      }, {
        code: 'LA',
        name: "Lao People's Democratic Republic",
        stateList: false
      }, {
        code: 'LV',
        name: 'Latvia',
        stateList: false
      }, {
        code: 'LB',
        name: 'Lebanon',
        stateList: false
      }, {
        code: 'LS',
        name: 'Lesotho',
        stateList: false
      }, {
        code: 'LR',
        name: 'Liberia',
        stateList: false
      }, {
        code: 'LY',
        name: 'Libya',
        stateList: false
      }, {
        code: 'LI',
        name: 'Liechtenstein',
        stateList: false
      }, {
        code: 'LT',
        name: 'Lithuania',
        stateList: false
      }, {
        code: 'LU',
        name: 'Luxembourg',
        stateList: false
      }, {
        code: 'MO',
        name: 'Macao',
        stateList: false
      }, {
        code: 'MK',
        name: 'Macedonia, the Former Yugoslav Republic of',
        stateList: false
      }, {
        code: 'MG',
        name: 'Madagascar',
        stateList: false
      }, {
        code: 'MW',
        name: 'Malawi',
        stateList: false
      }, {
        code: 'MY',
        name: 'Malaysia',
        stateList: false
      }, {
        code: 'MV',
        name: 'Maldives',
        stateList: false
      }, {
        code: 'ML',
        name: 'Mali',
        stateList: false
      }, {
        code: 'MT',
        name: 'Malta',
        stateList: false
      }, {
        code: 'MH',
        name: 'Marshall Islands',
        stateList: false
      }, {
        code: 'MQ',
        name: 'Martinique',
        stateList: false
      }, {
        code: 'MR',
        name: 'Mauritania',
        stateList: false
      }, {
        code: 'MU',
        name: 'Mauritius',
        stateList: false
      }, {
        code: 'YT',
        name: 'Mayotte',
        stateList: false
      }, {
        code: 'MX',
        name: 'Mexico',
        stateList: false
      }, {
        code: 'FM',
        name: 'Micronesia, Federated States of',
        stateList: false
      }, {
        code: 'MD',
        name: 'Moldova, Republic of',
        stateList: false
      }, {
        code: 'MC',
        name: 'Monaco',
        stateList: false
      }, {
        code: 'MN',
        name: 'Mongolia',
        stateList: false
      }, {
        code: 'ME',
        name: 'Montenegro',
        stateList: false
      }, {
        code: 'MS',
        name: 'Montserrat',
        stateList: false
      }, {
        code: 'MA',
        name: 'Morocco',
        stateList: false
      }, {
        code: 'MZ',
        name: 'Mozambique',
        stateList: false
      }, {
        code: 'MM',
        name: 'Myanmar',
        stateList: false
      }, {
        code: 'NA',
        name: 'Namibia',
        stateList: false
      }, {
        code: 'NR',
        name: 'Nauru',
        stateList: false
      }, {
        code: 'NP',
        name: 'Nepal',
        stateList: false
      }, {
        code: 'NL',
        name: 'Netherlands',
        stateList: false
      }, {
        code: 'NC',
        name: 'New Caledonia',
        stateList: false
      }, {
        code: 'NZ',
        name: 'New Zealand',
        stateList: newZealandStates
      }, {
        code: 'NI',
        name: 'Nicaragua',
        stateList: false
      }, {
        code: 'NE',
        name: 'Niger',
        stateList: false
      }, {
        code: 'NG',
        name: 'Nigeria',
        stateList: false
      }, {
        code: 'NU',
        name: 'Niue',
        stateList: false
      }, {
        code: 'NF',
        name: 'Norfolk Island',
        stateList: false
      }, {
        code: 'MP',
        name: 'Northern Mariana Islands',
        stateList: false
      }, {
        code: 'NO',
        name: 'Norway',
        stateList: false
      }, {
        code: 'OM',
        name: 'Oman',
        stateList: false
      }, {
        code: 'PK',
        name: 'Pakistan',
        stateList: false
      }, {
        code: 'PW',
        name: 'Palau',
        stateList: false
      }, {
        code: 'PS',
        name: 'Palestine, State of',
        stateList: false
      }, {
        code: 'PA',
        name: 'Panama',
        stateList: false
      }, {
        code: 'PG',
        name: 'Papua New Guinea',
        stateList: false
      }, {
        code: 'PY',
        name: 'Paraguay',
        stateList: false
      }, {
        code: 'PE',
        name: 'Peru',
        stateList: false
      }, {
        code: 'PH',
        name: 'Philippines',
        stateList: false
      }, {
        code: 'PN',
        name: 'Pitcairn',
        stateList: false
      }, {
        code: 'PL',
        name: 'Poland',
        stateList: false
      }, {
        code: 'PT',
        name: 'Portugal',
        stateList: false
      }, {
        code: 'PR',
        name: 'Puerto Rico',
        stateList: false
      }, {
        code: 'QA',
        name: 'Qatar',
        stateList: false
      }, {
        code: 'RE',
        name: 'Réunion',
        stateList: false
      }, {
        code: 'RO',
        name: 'Romania',
        stateList: false
      }, {
        code: 'RU',
        name: 'Russian Federation',
        stateList: false
      }, {
        code: 'RW',
        name: 'Rwanda',
        stateList: false
      }, {
        code: 'BL',
        name: 'Saint Barthélemy',
        stateList: false
      }, {
        code: 'SH',
        name: 'Saint Helena, Ascension and Tristan da Cunha',
        stateList: false
      }, {
        code: 'KN',
        name: 'Saint Kitts and Nevis',
        stateList: false
      }, {
        code: 'LC',
        name: 'Saint Lucia',
        stateList: false
      }, {
        code: 'MF',
        name: 'Saint Martin (French part)',
        stateList: false
      }, {
        code: 'PM',
        name: 'Saint Pierre and Miquelon',
        stateList: false
      }, {
        code: 'VC',
        name: 'Saint Vincent and the Grenadines',
        stateList: false
      }, {
        code: 'WS',
        name: 'Samoa',
        stateList: false
      }, {
        code: 'SM',
        name: 'San Marino',
        stateList: false
      }, {
        code: 'ST',
        name: 'Sao Tome and Principe',
        stateList: false
      }, {
        code: 'SA',
        name: 'Saudi Arabia',
        stateList: false
      }, {
        code: 'SN',
        name: 'Senegal',
        stateList: false
      }, {
        code: 'RS',
        name: 'Serbia',
        stateList: false
      }, {
        code: 'SC',
        name: 'Seychelles',
        stateList: false
      }, {
        code: 'SL',
        name: 'Sierra Leone',
        stateList: false
      }, {
        code: 'SG',
        name: 'Singapore',
        stateList: false
      }, {
        code: 'SX',
        name: 'Sint Maarten (Dutch part)',
        stateList: false
      }, {
        code: 'SK',
        name: 'Slovakia',
        stateList: false
      }, {
        code: 'SI',
        name: 'Slovenia',
        stateList: false
      }, {
        code: 'SB',
        name: 'Solomon Islands',
        stateList: false
      }, {
        code: 'SO',
        name: 'Somalia',
        stateList: false
      }, {
        code: 'ZA',
        name: 'South Africa',
        stateList: false
      }, {
        code: 'GS',
        name: 'South Georgia and the South Sandwich Islands',
        stateList: false
      }, {
        code: 'SS',
        name: 'South Sudan',
        stateList: false
      }, {
        code: 'ES',
        name: 'Spain',
        stateList: false
      }, {
        code: 'LK',
        name: 'Sri Lanka',
        stateList: false
      }, {
        code: 'SD',
        name: 'Sudan',
        stateList: false
      }, {
        code: 'SR',
        name: 'Suriname',
        stateList: false
      }, {
        code: 'SJ',
        name: 'Svalbard and Jan Mayen',
        stateList: false
      }, {
        code: 'SZ',
        name: 'Swaziland',
        stateList: false
      }, {
        code: 'SE',
        name: 'Sweden',
        stateList: false
      }, {
        code: 'CH',
        name: 'Switzerland',
        stateList: false
      }, {
        code: 'SY',
        name: 'Syrian Arab Republic',
        stateList: false
      }, {
        code: 'TW',
        name: 'Taiwan, Province of China',
        stateList: false
      }, {
        code: 'TJ',
        name: 'Tajikistan',
        stateList: false
      }, {
        code: 'TZ',
        name: 'Tanzania, United Republic of',
        stateList: false
      }, {
        code: 'TH',
        name: 'Thailand',
        stateList: false
      }, {
        code: 'TL',
        name: 'Timor-Leste',
        stateList: false
      }, {
        code: 'TG',
        name: 'Togo',
        stateList: false
      }, {
        code: 'TK',
        name: 'Tokelau',
        stateList: false
      }, {
        code: 'TO',
        name: 'Tonga',
        stateList: false
      }, {
        code: 'TT',
        name: 'Trinidad and Tobago',
        stateList: false
      }, {
        code: 'TN',
        name: 'Tunisia',
        stateList: false
      }, {
        code: 'TR',
        name: 'Turkey',
        stateList: false
      }, {
        code: 'TM',
        name: 'Turkmenistan',
        stateList: false
      }, {
        code: 'TC',
        name: 'Turks and Caicos Islands',
        stateList: false
      }, {
        code: 'TV',
        name: 'Tuvalu',
        stateList: false
      }, {
        code: 'UG',
        name: 'Uganda',
        stateList: false
      }, {
        code: 'UA',
        name: 'Ukraine',
        stateList: false
      }, {
        code: 'AE',
        name: 'United Arab Emirates',
        stateList: false
      }, {
        code: 'GB',
        name: 'United Kingdom',
        stateList: false
      }, {
        code: 'US',
        name: 'United States',
        stateList: false
      }, {
        code: 'UM',
        name: 'United States Minor Outlying Islands',
        stateList: false
      }, {
        code: 'UY',
        name: 'Uruguay',
        stateList: false
      }, {
        code: 'UZ',
        name: 'Uzbekistan',
        stateList: false
      }, {
        code: 'VU',
        name: 'Vanuatu',
        stateList: false
      }, {
        code: 'VE',
        name: 'Venezuela, Bolivarian Republic of',
        stateList: false
      }, {
        code: 'VN',
        name: 'Viet Nam',
        stateList: false
      }, {
        code: 'VG',
        name: 'Virgin Islands, British',
        stateList: false
      }, {
        code: 'VI',
        name: 'Virgin Islands, U.S.',
        stateList: false
      }, {
        code: 'WF',
        name: 'Wallis and Futuna',
        stateList: false
      }, {
        code: 'EH',
        name: 'Western Sahara',
        stateList: false
      }, {
        code: 'YE',
        name: 'Yemen',
        stateList: false
      }, {
        code: 'ZM',
        name: 'Zambia',
        stateList: false
      }, {
        code: 'ZW',
        name: 'Zimbabwe',
        stateList: false
      }]; // CONCATENATED MODULE: ./src/containers/AddressLookupContainer/manuallyInputAddress.js

      var manuallyInputAddress_getStateList = function getStateList(country, allCountries) {
        var countries = {};

        if (allCountries) {
          countries = allCountriesList.filter(function (countryItem) {
            return countryItem.name === country;
          });
        } else {
          countries = countryList.filter(function (countryItem) {
            return countryItem.name === country;
          });
        }

        return get_default()(countries, '[0].stateList', false);
      };

      var manuallyInputAddress_getCountryList = function getCountryList(allCountries) {
        if (allCountries) {
          return allCountriesList.map(function (country) {
            return country.name;
          });
        }

        return countryList.map(function (country) {
          return country.name;
        });
      };

      var manuallyInputAddress_ManuallyInputAddress = function ManuallyInputAddress(props) {
        var _props$value = props.value,
            address = _props$value.address,
            suburb = _props$value.suburb,
            state = _props$value.state,
            postcode = _props$value.postcode,
            country = _props$value.country;
        var stateList = manuallyInputAddress_getStateList(get_default()(props.value, 'country', 'Australia'), props.allowAllCountriesInManualMode);
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-manually-input-address"
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()('formatic-manually-input-address__address-container', {
            'formatic-field-error': props.errors.address,
            'formatic-field-valid': !props.errors.address && !isEmpty_default()(address)
          })
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(TextContainer_TextContainer, {
          id: "".concat(props.parentFieldId, "-manually-input-address__address"),
          inputId: Object(utils["k"
          /* getRandomId */
          ])(),
          autoComplete: "off",
          className: "formatic-manually-input-address__address",
          value: address,
          label: props.addressLabel || 'Address:',
          required: props.isRequired,
          changeValue: function changeValue(value) {
            props.changeValue({
              address: value
            });
          },
          validate: function validate() {
            props.validate('address');
          },
          analyticsParams: {
            fieldId: "".concat(props.parentFieldId, "-manually-input-address__address"),
            parentFieldId: "".concat(props.parentFieldId),
            component: 'manually-input-address__address'
          },
          optionalSuffixLabel: props.optionalSuffixLabel,
          requiredSuffixLabel: props.requiredSuffixLabel,
          showOptionalSuffixLabel: props.showOptionalSuffixLabel,
          showRequiredSuffixLabel: props.showRequiredSuffixLabel,
          showError: false
        }), props.errors.address && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
        /* ErrorMessage */
        ], {
          text: props.errors.address
        })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()('formatic-manually-input-address__suburb-container', {
            'formatic-field-error': props.errors.suburb,
            'formatic-field-valid': !props.errors.suburb && !isEmpty_default()(suburb)
          })
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(TextContainer_TextContainer, {
          id: "".concat(props.parentFieldId, "-manually-input-address__suburb"),
          inputId: Object(utils["k"
          /* getRandomId */
          ])(),
          autoComplete: "off",
          className: "formatic-manually-input-address__suburb",
          value: suburb,
          label: props.suburbLabel || 'Suburb:',
          showLabel: true,
          required: props.isRequired,
          changeValue: function changeValue(value) {
            return props.changeValue({
              suburb: value
            });
          },
          validate: function validate() {
            props.validate('suburb');
          },
          analyticsParams: {
            fieldId: "".concat(props.parentFieldId, "-manually-input-address__suburb"),
            parentFieldId: "".concat(props.parentFieldId),
            component: 'manually-input-address__suburb'
          },
          optionalSuffixLabel: props.optionalSuffixLabel,
          requiredSuffixLabel: props.requiredSuffixLabel,
          showOptionalSuffixLabel: props.showOptionalSuffixLabel,
          showRequiredSuffixLabel: props.showRequiredSuffixLabel,
          showError: false
        }), props.errors.suburb && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
        /* ErrorMessage */
        ], {
          text: props.errors.suburb
        })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()('formatic-manually-input-address__postcode-container', {
            'formatic-field-error': props.errors.postcode,
            'formatic-field-valid': !props.errors.postcode && !isEmpty_default()(postcode)
          })
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(TextContainer_TextContainer, {
          id: "".concat(props.parentFieldId, "-manually-input-address__postcode"),
          inputId: Object(utils["k"
          /* getRandomId */
          ])(),
          autoComplete: "off",
          className: "formatic-manually-input-address__postcode",
          value: postcode,
          label: props.postcodeLabel || 'Postcode:',
          required: props.isRequired,
          changeValue: function changeValue(value) {
            return props.changeValue({
              postcode: value
            });
          },
          validate: function validate() {
            props.validate('postcode');
          },
          analyticsParams: {
            fieldId: "".concat(props.parentFieldId, "-manually-input-address__postcode"),
            parentFieldId: "".concat(props.parentFieldId),
            component: 'manually-input-address__postcode'
          },
          parentFieldId: props.parentFieldId,
          optionalSuffixLabel: props.optionalSuffixLabel,
          requiredSuffixLabel: props.requiredSuffixLabel,
          showOptionalSuffixLabel: props.showOptionalSuffixLabel,
          showRequiredSuffixLabel: props.showRequiredSuffixLabel,
          showError: false
        }), props.errors.postcode && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
        /* ErrorMessage */
        ], {
          text: props.errors.postcode
        })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()('formatic-manually-input-address__country-container', {
            'formatic-field-error': props.errors.country,
            'formatic-field-valid': !props.errors.country && !isEmpty_default()(country)
          })
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(DropdownContainer_DropdownContainer, {
          id: "".concat(props.parentFieldId, "-manually-input-address__country"),
          className: "formatic-manually-input-address__country",
          value: country,
          changeValue: function changeValue(value) {
            // if the previous country value was undefined, then it'll make sure that whatever state was previously selected
            // will continue to be selected if the new country value has that state
            // otherwise it'll set newState to undefined
            var newState = country === undefined ? manuallyInputAddress_getStateList(value).find(function (stateItem) {
              return stateItem === state;
            }) : undefined;
            props.changeValue({
              country: value,
              state: newState
            });
          },
          parentFieldId: props.parentFieldId,
          label: props.countryLabel || 'Country:',
          placeholder: "Please select a country",
          options: manuallyInputAddress_getCountryList(props.allowAllCountriesInManualMode),
          default: "Please select a country",
          required: props.isRequired,
          validate: function validate() {
            props.validate('country');
          },
          analyticsParams: {
            fieldId: "".concat(props.parentFieldId, "-manually-input-address__country"),
            parentFieldId: "".concat(props.parentFieldId),
            component: 'manually-input-address__country'
          },
          optionalSuffixLabel: props.optionalSuffixLabel,
          requiredSuffixLabel: props.requiredSuffixLabel,
          showOptionalSuffixLabel: props.showOptionalSuffixLabel,
          showRequiredSuffixLabel: props.showRequiredSuffixLabel,
          showError: false
        }), props.errors.country && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
        /* ErrorMessage */
        ], {
          text: props.errors.country
        })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()('formatic-manually-input-address__state-container', {
            'formatic-field-error': props.errors.state,
            'formatic-field-valid': !props.errors.state && !isEmpty_default()(state)
          })
        }, stateList && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(DropdownContainer_DropdownContainer, {
          id: "".concat(props.parentFieldId, "-manually-input-address__state"),
          className: "formatic-manually-input-address__state",
          value: state,
          changeValue: function changeValue(value) {
            props.changeValue({
              state: value
            });
          },
          parentFieldId: props.parentFieldId,
          label: props.stateLabel || 'State:',
          placeholder: "Please select a state",
          options: stateList,
          default: "Please select a state",
          required: props.isRequired,
          validate: function validate() {
            props.validate('state');
          },
          analyticsParams: {
            fieldId: "".concat(props.parentFieldId, "-manually-input-address__state"),
            parentFieldId: "".concat(props.parentFieldId),
            component: 'manually-input-address__state'
          },
          optionalSuffixLabel: props.optionalSuffixLabel,
          requiredSuffixLabel: props.requiredSuffixLabel,
          showOptionalSuffixLabel: props.showOptionalSuffixLabel,
          showRequiredSuffixLabel: props.showRequiredSuffixLabel,
          showError: false
        }), !stateList && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(TextContainer_TextContainer, {
          id: "".concat(props.parentFieldId, "-manually-input-address__state"),
          inputId: Object(utils["k"
          /* getRandomId */
          ])(),
          autoComplete: "off",
          className: "formatic-manually-input-address__state",
          value: state,
          label: props.stateLabel || 'State:',
          required: false,
          changeValue: function changeValue(value) {
            return props.changeValue({
              state: value
            });
          },
          validate: function validate() {
            props.validate('state');
          },
          analyticsParams: {
            fieldId: "".concat(props.parentFieldId, "-manually-input-address__state"),
            parentFieldId: "".concat(props.parentFieldId),
            component: 'manually-input-address__state'
          },
          parentFieldId: props.parentFieldId,
          optionalSuffixLabel: props.optionalSuffixLabel,
          requiredSuffixLabel: props.requiredSuffixLabel,
          showOptionalSuffixLabel: props.showOptionalSuffixLabel,
          showRequiredSuffixLabel: props.showRequiredSuffixLabel,
          showError: false
        }), props.errors.state && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
        /* ErrorMessage */
        ], {
          text: props.errors.state
        })));
      };

      manuallyInputAddress_ManuallyInputAddress.defaultProps = {
        changeValue: noop_default.a,
        errors: {},
        isRequired: false,
        validate: noop_default.a,
        value: {},
        parentFieldId: '',
        // attributes from dashboard
        addressLabel: false,
        allowAllCountriesInManualMode: false,
        countryLabel: false,
        postcodeLabel: false,
        stateLabel: false,
        suburbLabel: false,
        // form attributes from dashboard
        optionalSuffixLabel: false,
        requiredSuffixLabel: false,
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      manuallyInputAddress_ManuallyInputAddress.propTypes = {
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        errors: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        isRequired: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          address: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          suburb: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          state: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          postcode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          country: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        }),
        parentFieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // attributes from dashboard
        addressLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        allowAllCountriesInManualMode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        countryLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        postcodeLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        stateLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        suburbLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var manuallyInputAddress = manuallyInputAddress_ManuallyInputAddress; // EXTERNAL MODULE: ./src/containers/ButtonContainer.js

      var ButtonContainer = __webpack_require__(98); // CONCATENATED MODULE: ./src/containers/AddressLookupContainer/index.js


      var AddressLookupContainer_InvalidErrorMessage = 'Please select a valid address';
      /**
       * AddressLookupContainer
       * Request from the server from the addresses when user input characters
       */

      var AddressLookupContainer_AddressLookupContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(AddressLookupContainer, _Component); // maintain a map of address strings to address objects for validation

        function AddressLookupContainer(props) {
          var _this;

          classCallCheck_default()(this, AddressLookupContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(AddressLookupContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "setLocalState", function (newState) {
            _this.setState(objectSpread_default()({}, newState));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getCurrentState", function () {
            return _this.state;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "clearAddresses", function () {
            _this.setLocalState({
              addresses: []
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleSuccessReport", function () {
            Object(utils_requestData["d"
            /* requestData */
            ])({
              method: 'get',
              url: src_config["a"
              /* default */
              ].getApiServer().concat("/address/report/success?formId=".concat(_this.props.formId))
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "autoCompleteHandleFocus", function () {
            _this.debounced.push(_this.debouncedAnalyticsInteractionOnFocus());
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "autoCompleteHandleBlur", function () {
            _this.debounced.push(_this.debouncedValidate());

            _this.debounced.push(_this.debouncedAnalyticsInteractionOnBlur());
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "autoCompleteHandleOnChange", function (value) {
            handleChangeValue_handleOnSelectAndOnChange(value, _this.state.addresses, _this.props.changeValue, _this.onSelect, _this.props.value, _this.debouncedValidateCallback);
            _this.onSelect = false;

            _this.debounced.push(_this.debouncedAnalyticsInteractionOnChange());
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "autoCompleteHandleOnSearch", function (value) {
            if (value.length >= _this.props.minCharsToSearch) {
              _this.isWaitingResponse = true;
            }

            _this.debounced.push(_this.debouncedHandleSearch(value));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "autoCompleteHandleOnSelect", function (value) {
            _this.onSelect = true;
            var updatedValue = handleChangeValue_handleOnSelectAndOnChange(value, _this.state.addresses, _this.props.changeValue, _this.onSelect, _this.props.value, _this.debouncedValidateCallback);
            var fullAddress = updatedValue.fullAddress;
            AddressLookupContainer.addressMap[fullAddress] = updatedValue;

            _this.handleSuccessReport();
          });

          var _fullAddress = get_default()(props, 'value.fullAddress', false);

          if (_fullAddress) {
            AddressLookupContainer.addressMap[_fullAddress] = props.value;
          }

          _this.state = {
            addresses: [],
            exception: false
          };
          _this.debounced = [];
          _this.debouncedAnalyticsInteractionOnFocus = debounce_default()(handleAnalytics(_this.props.analyticsInteraction, analytics["a"
          /* AnalyticsEvents */
          ].autoCompleteHandleFocus), src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          _this.debouncedAnalyticsInteractionOnBlur = debounce_default()(handleAnalytics(_this.props.analyticsInteraction, analytics["a"
          /* AnalyticsEvents */
          ].autoCompleteHandleBlur), src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          _this.debouncedAnalyticsInteractionOnChange = debounce_default()(handleAnalytics(_this.props.analyticsInteraction, analytics["a"
          /* AnalyticsEvents */
          ].autoCompleteHandleOnChange), src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          _this.debouncedHandleSearch = debounce_default()(search_handleSearch(utils_requestData["d"
          /* requestData */
          ], props.maxResults, props.minCharsToSearch, _this.setLocalState, function () {
            var instanceVariables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            Object.keys(instanceVariables).forEach(function (key) {
              _this[key] = instanceVariables[key];
            });
          }), src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          _this.debouncedValidate = debounce_default()(_this.props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());

          _this.debouncedValidateCallback = function () {
            _this.debounced.push(_this.debouncedValidate);
          };

          return _this;
        }

        createClass_default()(AddressLookupContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            if (this.props.fieldId) {
              this.props.registerValidator(validator_emptyValidator(this.props.required, this.props), this.props.fieldId, constants["Validator"].Empty, false);
              this.props.registerValidator(AddressLookupContainer.validator, this.props.fieldId, constants["Validator"].Custom, false);
            }
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            // cancel all debounced operations to avoid react warinings
            if (typeof this.debounced !== 'undefined' && this.debounced.length > 0) {
              this.debounced.forEach(function (debounced) {
                if (typeof debounced !== 'undefined') {
                  if (typeof debounced.cancel === 'function') {
                    debounced.cancel();
                  }
                }
              });
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this2 = this;

            var _this$props = this.props,
                value = _this$props.value,
                errors = _this$props.errors,
                errorMessage = _this$props.errorMessage;
            var handleEnterManuallyClickCallback = handleChangeValue_getHandleEnterManuallyClickCallback(this.props.changeValue, value);
            var dataSource = dataSource_getDataSource(this.state.exception, this.props.searchErrorMessage, this.props.enterManuallyButtonLabel, handleEnterManuallyClickCallback, this.state.addresses, this.props.waitingResponseMessage, this.props.noResultsMessage, value.fullAddress, this.props.minCharsToSearch, this.isWaitingResponse);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-address-lookup"
            }, !value.isManual && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_AutoCompleteContainer, {
              autoCompleteClassName: "formatic-address-lookup__auto-complete",
              autoCompleteDataSource: dataSource,
              autoCompleteDropdownClassName: "formatic-ant-dropdown formatic-address-lookup__auto-complete-dropdown",
              autoCompleteFilterOption: false,
              autoCompleteHandleBlur: this.autoCompleteHandleBlur,
              autoCompleteHandleFocus: this.autoCompleteHandleFocus,
              autoCompleteHandleOnChange: this.autoCompleteHandleOnChange,
              autoCompleteHandleOnSearch: this.autoCompleteHandleOnSearch,
              autoCompleteHandleOnSelect: this.autoCompleteHandleOnSelect,
              autoCompleteInputClassName: "formatic-address-lookup__auto-complete-input",
              autoCompleteInputId: this.props.inputId,
              autoCompleteOptionLabelProp: "value",
              autoCompletePlaceholder: this.props.placeholder,
              autoCompleteValue: value.fullAddress || '',
              className: classnames_default()('formatic-address-lookup__auto-complete-container', defineProperty_default()({}, this.props.className, this.props.className)),
              description: this.props.description,
              descriptionClassName: "formatic-address-lookup__description",
              errorMessage: errorMessage,
              inputId: this.props.inputId,
              label: this.props.label,
              labelClassName: "formatic-field-label formatic-address-lookup__label",
              required: this.props.required,
              showLabel: this.props.showLabel,
              optionalSuffixLabel: this.props.optionalSuffixLabel,
              requiredSuffixLabel: this.props.requiredSuffixLabel,
              showOptionalSuffixLabel: this.props.showOptionalSuffixLabel,
              showRequiredSuffixLabel: this.props.showRequiredSuffixLabel
            }), value.isManual && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-address-lookup__details"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ButtonContainer["a"
            /* default */
            ], {
              label: get_default()(this.props, 'attributes.backButtonLabel', 'Back'),
              className: "formatic-address-lookup__back",
              onClick: handleChangeValue_getHandleBackClickCallback(this.props.changeValue, this.props.value, this.clearAddresses)
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(manuallyInputAddress, {
              allowAllCountriesInManualMode: this.props.allowAllCountriesInManualMode,
              errors: errors,
              value: omit_default()(this.props.value, 'fullAddress'),
              validate: this.props.validate,
              changeValue: function changeValue(changes) {
                handleChangeValue_getOnValueChangeCallback(_this2.props.changeValue, _this2.props.value, changes);
              } // @Todo find props to send? data={this.props.data}
              ,
              isRequired: this.props.required,
              addressLabel: this.props.addressLabel,
              countryLabel: this.props.countryLabel,
              postcodeLabel: this.props.postcodeLabel,
              stateLabel: this.props.stateLabel,
              suburbLabel: this.props.suburbLabel,
              optionalSuffixLabel: this.props.optionalSuffixLabel,
              requiredSuffixLabel: this.props.requiredSuffixLabel,
              showOptionalSuffixLabel: this.props.showOptionalSuffixLabel,
              showRequiredSuffixLabel: this.props.showRequiredSuffixLabel,
              parentFieldId: this.props.fieldId
            })));
          }
        }]);
        return AddressLookupContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      defineProperty_default()(AddressLookupContainer_AddressLookupContainer, "addressMap", {});

      AddressLookupContainer_AddressLookupContainer.validator = function (value) {
        var isManual = value.isManual,
            isAuto = value.isAuto;

        if (isManual) {
          // manual, defer to regular validation
          return {
            isValid: true,
            errors: [],
            undefined: undefined
          };
        }

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var props = args[2];
        var invalidText = props.invalidText,
            required = props.required;
        var fullAddress = value.fullAddress;

        if ((required || fullAddress !== '') && !AddressLookupContainer_AddressLookupContainer.addressMap[fullAddress]) {
          var errors = {
            value: invalidText || AddressLookupContainer_InvalidErrorMessage
          };
          return {
            isValid: false,
            errors: errors,
            displayErrorMessage: errors.value
          };
        }

        if (required && !isManual && !isAuto) {
          var _errors = {
            value: invalidText || AddressLookupContainer_InvalidErrorMessage
          };
          return {
            isValid: false,
            errors: _errors,
            displayErrorMessage: _errors.value
          };
        }

        return {
          isValid: true,
          errors: []
        };
      };

      AddressLookupContainer_AddressLookupContainer.toSummaryNode = function (_ref) {
        var fullAddress = _ref.fullAddress;
        return fullAddress;
      };

      AddressLookupContainer_AddressLookupContainer.defaultProps = {
        changeValue: noop_default.a,
        className: '',
        errors: {},
        errorMessage: null,
        inputId: '',
        registerValidator: noop_default.a,
        validate: noop_default.a,
        value: {
          fullAddress: '',
          address: '',
          suburb: '',
          state: '',
          postcode: '',
          country: '',
          isManual: false,
          isAuto: false
        },
        analyticsInteraction: noop_default.a,
        // attributes from dashboard
        allowAllCountriesInManualMode: false,
        fieldId: '',
        addressLabel: 'Address',
        // used in ManuallyInputAddress
        backButtonLabel: '',
        countryLabel: 'Country',
        // used in ManuallyInputAddress
        description: '',
        enterManuallyButtonLabel: 'Enter manually',
        formId: '',
        label: '',
        maxResults: 5,
        minCharsToSearch: 3,
        noResultsMessage: 'Sorry, no results found',
        placeholder: 'Please, start typing an address...',
        postcodeLabel: 'Postcode',
        // used in ManuallyInputAddress
        required: false,
        requiredMessage: constants["DefaultRequiredMessage"],
        showLabel: true,
        searchErrorMessage: 'Sorry, the address look-up is currently offline. Please enter manually.',
        stateLabel: 'State',
        // used in ManuallyInputAddress
        suburbLabel: 'Suburb',
        // used in ManuallyInputAddress
        waitingResponseMessage: 'Searching for address',
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      AddressLookupContainer_AddressLookupContainer.propTypes = {
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        errors: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          address: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          country: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          fullAddress: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          isManual: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          postcode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          state: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          suburb: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          isAuto: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
        }),
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        // attributes from dashboard
        allowAllCountriesInManualMode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        addressLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // used in ManuallyInputAddress
        backButtonLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        countryLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // used in ManuallyInputAddress
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        enterManuallyButtonLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        formId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        maxResults: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        minCharsToSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        noResultsMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        postcodeLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // used in ManuallyInputAddress
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        searchErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        stateLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // used in ManuallyInputAddress
        suburbLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // used in ManuallyInputAddress
        waitingResponseMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_AddressLookupContainer = Object(Recompose["a"
      /* compose */
      ])(Object(es["a"
      /* connect */
      ])(function (_ref2) {
        var formatic = _ref2.formatic;
        return {
          formId: formatic.formId
        };
      }), withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(AddressLookupContainer_AddressLookupContainer); // CONCATENATED MODULE: ./src/components/AdvancedReviewTable/AdvancedReviewTableItem.js

      /* eslint-disable react/no-danger */

      var AdvancedReviewTableItem_AdvancedReviewTableItem = function AdvancedReviewTableItem(props) {
        var fieldValue = props.fieldValue,
            label = props.label,
            tagleConfig = props.tagleConfig;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-advanced-field-container"
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-advanced-field-label",
          dangerouslySetInnerHTML: {
            __html: Object(utils["m"
            /* getSafeHTML */
            ])(label, tagleConfig.allowHtmlAtt)
          }
        }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-advanced-field-value",
          dangerouslySetInnerHTML: {
            __html: Object(utils["m"
            /* getSafeHTML */
            ])(fieldValue, tagleConfig.allowHtmlAtt)
          }
        }));
      };

      AdvancedReviewTableItem_AdvancedReviewTableItem.defaultProps = {
        tagleConfig: {},
        fieldValue: '',
        label: ''
      };
      AdvancedReviewTableItem_AdvancedReviewTableItem.propTypes = {
        fieldValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        tagleConfig: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          allowHtmlAtt: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array
        })
      };
      /* harmony default export */

      var AdvancedReviewTable_AdvancedReviewTableItem = AdvancedReviewTableItem_AdvancedReviewTableItem; // EXTERNAL MODULE: ./src/core/hoc/withVisibility.js

      var withVisibility = __webpack_require__(77); // CONCATENATED MODULE: ./src/containers/AdvancedReviewTable/AdvancedReviewTableItemContainer.js


      var AdvancedReviewTableItemContainer_AdvancedReviewTableItemContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(AdvancedReviewTableItemContainer, _Component);

        function AdvancedReviewTableItemContainer() {
          var _this;

          classCallCheck_default()(this, AdvancedReviewTableItemContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(AdvancedReviewTableItemContainer).call(this));
          defineProperty_default()(assertThisInitialized_default()(_this), "getValueFromToken", function (fieldTokenValues, tokenPattern) {
            return Object(tokens_tokens["e"
            /* tokenizer */
            ])(fieldTokenValues)(tokenPattern);
          });
          _this.state = {};
          return _this;
        }

        createClass_default()(AdvancedReviewTableItemContainer, [{
          key: "render",
          value: function render() {
            var _this$props = this.props,
                field = _this$props.field,
                tagleConfig = _this$props.tagleConfig,
                fieldTokenValues = _this$props.fieldTokenValues;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(AdvancedReviewTable_AdvancedReviewTableItem, {
              fieldValue: this.getValueFromToken(fieldTokenValues, field.html),
              label: this.getValueFromToken(fieldTokenValues, field.label),
              tagleConfig: tagleConfig
            });
          }
        }]);
        return AdvancedReviewTableItemContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      AdvancedReviewTableItemContainer_AdvancedReviewTableItemContainer.defaultProps = {
        tagleConfig: {}
      };
      AdvancedReviewTableItemContainer_AdvancedReviewTableItemContainer.propTypes = {
        field: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        tagleConfig: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        fieldTokenValues: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired
      };
      /* harmony default export */

      var AdvancedReviewTable_AdvancedReviewTableItemContainer = Object(withVisibility["a"
      /* default */
      ])({
        type: 'field'
      })(AdvancedReviewTableItemContainer_AdvancedReviewTableItemContainer); // CONCATENATED MODULE: ./src/components/AdvancedReviewTable/AdvancedReviewTableHeader.js

      var AdvancedReviewTableHeader_AdvancedRieviewTableHeader = function AdvancedRieviewTableHeader(props) {
        var header = props.header,
            navigate = props.navigate,
            type = props.type,
            channel = props.channel;

        var navigateToSection = function navigateToSection() {
          navigate(header.editPageId, channel);
        };

        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-advanced-section-heading formatic-review-table-advanced-section-heading-".concat(type)
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-advanced-section-heading-label"
        }, header.html), header && header.edit && header.editPageId && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("button", {
          className: "formatic-review-table-advanced-section-heading-edit-container",
          onClick: navigateToSection
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-advanced-section-heading-edit-text"
        }, header.editLabelText), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("span", {
          className: "formatic-review-table-advanced-section-heading-edit-icon"
        })));
      };

      AdvancedReviewTableHeader_AdvancedRieviewTableHeader.defaultProps = {
        header: '',
        type: 'field',
        navigate: noop_default.a
      };
      AdvancedReviewTableHeader_AdvancedRieviewTableHeader.propTypes = {
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        navigate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        header: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          html: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          edit: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          editPageId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          editLabelText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        })
      };
      /* harmony default export */

      var AdvancedReviewTableHeader = AdvancedReviewTableHeader_AdvancedRieviewTableHeader; // CONCATENATED MODULE: ./src/containers/AdvancedReviewTable/AdvancedReviewTableRepeatableContainer.js

      /**
       * Adds repeition index for tokenization, i.e. converts
       * {{fields.machinetag.repetition.innerMachineTag}} to
       * {{fields.machinetag.repetition.0.innerMachineTag}}
       */

      var AdvancedReviewTableRepeatableContainer_updateTokensForRepetition = function updateTokensForRepetition(token, repetition) {
        var regex = /{{fields\.([a-zA-Z]{1})([a-zA-Z0-9_]*)\.repetition\.([a-zA-Z]{1})([a-zA-Z0-9_]*)}}/gm;
        var replacedToken = token;
        var matches; // eslint-disable-next-line

        while ((matches = regex.exec(token)) !== null) {
          if (matches.index === regex.lastIndex) {
            regex.lastIndex += 1;
          }

          if (matches[0] !== undefined) {
            var replace = matches[0].replace('repetition.', "repetition.".concat(repetition, "."));
            replacedToken = replacedToken.replace(matches[0], replace);
          }
        }

        return replacedToken;
      };

      var AdvancedReviewTableRepeatableContainer_getValueFromToken = function getValueFromToken(fieldTokenValues, tokenPattern) {
        return Object(tokens_tokens["e"
        /* tokenizer */
        ])(fieldTokenValues)(tokenPattern);
      };

      var AdvancedReviewTableRepeatableContainer_AdvancedReviewTableRepeatableContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(AdvancedReviewTableRepeatableContainer, _Component);

        function AdvancedReviewTableRepeatableContainer() {
          classCallCheck_default()(this, AdvancedReviewTableRepeatableContainer);
          return possibleConstructorReturn_default()(this, getPrototypeOf_default()(AdvancedReviewTableRepeatableContainer).apply(this, arguments));
        }

        createClass_default()(AdvancedReviewTableRepeatableContainer, [{
          key: "render",
          value: function render() {
            var _this$props = this.props,
                machineTag = _this$props.machineTag,
                fields = _this$props.fields,
                sectionId = _this$props.sectionId,
                fieldTokenValues = _this$props.fieldTokenValues,
                tagleConfig = _this$props.tagleConfig;
            var hasRepetitions = false;

            if (fieldTokenValues.fields[machineTag] && fieldTokenValues.fields[machineTag].repetition) {
              hasRepetitions = fieldTokenValues.fields[machineTag].repetition.length > 0;
            }

            if (!hasRepetitions) {
              return null;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-review-table-advanced-repeatable-container formatic-review-table-advanced-repeatable-container-".concat(machineTag)
            }, fieldTokenValues.fields[machineTag].repetition.map(function (value, repetition) {
              return fields.map(function (field, index) {
                var key = "".concat(machineTag, "-").concat(repetition, "-").concat(index); // Add usable repetition, repetitionDisplay tokens

                fieldTokenValues.fields[machineTag].currentRepetition = repetition;
                fieldTokenValues.fields[machineTag].currentRepetitionDisplay = repetition + 1; // Clone and tokenize here, as otherwise object passed by reference so currentRepetition etc will not increment on output

                var tokenizedField = objectSpread_default()({}, field);
                tokenizedField.html = AdvancedReviewTableRepeatableContainer_updateTokensForRepetition(tokenizedField.html, repetition);
                tokenizedField.html = AdvancedReviewTableRepeatableContainer_getValueFromToken(fieldTokenValues, tokenizedField.html);
                tokenizedField.label = AdvancedReviewTableRepeatableContainer_updateTokensForRepetition(tokenizedField.label, repetition);
                tokenizedField.label = AdvancedReviewTableRepeatableContainer_getValueFromToken(fieldTokenValues, tokenizedField.label); // Note we should reference some kind of item mapping here so can just use a single return statement

                if (field.type === 'heading') {
                  return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Fragment, {
                    key: key
                  }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(AdvancedReviewTableHeader, {
                    header: tokenizedField
                  }));
                }

                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Fragment, {
                  key: key
                }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(AdvancedReviewTable_AdvancedReviewTableItemContainer, {
                  key: key,
                  field: tokenizedField,
                  sectionId: sectionId,
                  logic: field.logic,
                  id: field.id,
                  fieldTokenValues: fieldTokenValues,
                  tagleConfig: tagleConfig
                }));
              });
            }));
          }
        }]);
        return AdvancedReviewTableRepeatableContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      AdvancedReviewTableRepeatableContainer_AdvancedReviewTableRepeatableContainer.defaultProps = {
        tagleConfig: {}
      };
      AdvancedReviewTableRepeatableContainer_AdvancedReviewTableRepeatableContainer.propTypes = {
        machineTag: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        fields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        sectionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        fieldTokenValues: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        tagleConfig: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };
      /* harmony default export */

      var AdvancedReviewTable_AdvancedReviewTableRepeatableContainer = Object(withVisibility["a"
      /* default */
      ])({
        type: 'field'
      })(AdvancedReviewTableRepeatableContainer_AdvancedReviewTableRepeatableContainer); // CONCATENATED MODULE: ./src/containers/AdvancedReviewTable/AdvancedReviewTableSectionContainer.js

      var AdvancedReviewTableSectionContainer_AdvancedReviewTableSectionContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(AdvancedReviewTableSectionContainer, _Component);

        function AdvancedReviewTableSectionContainer() {
          var _this;

          classCallCheck_default()(this, AdvancedReviewTableSectionContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(AdvancedReviewTableSectionContainer).call(this));
          _this.state = {};
          return _this;
        }

        createClass_default()(AdvancedReviewTableSectionContainer, [{
          key: "render",
          value: function render() {
            var _this2 = this;

            var _this$props = this.props,
                fields = _this$props.fields,
                sectionId = _this$props.sectionId,
                section = _this$props.section,
                fieldTokenValues = _this$props.fieldTokenValues,
                tagleConfig = _this$props.tagleConfig;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              key: section.id,
              className: "formatic-review-table-advanced-section-container formatic-review-table-advanced-section-container-".concat(section.id)
            }, fields.map(function (field, index) {
              if (field.type === 'heading') {
                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Fragment, {
                  key: index
                }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(AdvancedReviewTableHeader, {
                  header: field,
                  navigate: _this2.props.setCurrentPage,
                  channel: _this2.props.channel
                }));
              }

              if (field.type === 'repeatable') {
                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Fragment, {
                  key: index
                }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(AdvancedReviewTable_AdvancedReviewTableRepeatableContainer, {
                  id: field.id,
                  fields: field.items // fields should be items?
                  ,
                  machineTag: field.machineTag,
                  belongToSectionId: section.belongToSectionId,
                  logic: field.logic,
                  fieldTokenValues: _this2.props.fieldTokenValues,
                  tagleConfig: tagleConfig
                }));
              }

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Fragment, {
                key: index
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(AdvancedReviewTable_AdvancedReviewTableItemContainer, {
                key: index,
                field: field,
                sectionId: sectionId,
                logic: field.logic,
                id: field.id,
                fieldTokenValues: fieldTokenValues,
                tagleConfig: tagleConfig
              }));
            }));
          }
        }]);
        return AdvancedReviewTableSectionContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      AdvancedReviewTableSectionContainer_AdvancedReviewTableSectionContainer.defaultProps = {
        tagleConfig: {},
        sectionId: ''
      };
      AdvancedReviewTableSectionContainer_AdvancedReviewTableSectionContainer.propTypes = {
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        fields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        sectionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        section: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        fieldTokenValues: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        tagleConfig: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        setCurrentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired
      };
      /* harmony default export */

      var AdvancedReviewTable_AdvancedReviewTableSectionContainer = Object(es["a"
      /* connect */
      ])(function (_ref) {
        var channel = _ref.formatic.channel;
        return {
          channel: channel
        };
      }, function (dispatch) {
        return {
          setCurrentPage: function setCurrentPage(pageId, channel) {
            return dispatch(Object(core_actions["O"
            /* setCurrentPage */
            ])(pageId, channel));
          }
        };
      })(Object(withVisibility["a"
      /* default */
      ])({
        type: 'section'
      })(AdvancedReviewTableSectionContainer_AdvancedReviewTableSectionContainer)); // CONCATENATED MODULE: ./src/containers/AdvancedReviewTable/AdvancedReviewTableContainer.js

      var AdvancedReviewTableContainer_AdvancedReviewTableContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(AdvancedReviewTableContainer, _Component);

        function AdvancedReviewTableContainer(props) {
          var _this;

          classCallCheck_default()(this, AdvancedReviewTableContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(AdvancedReviewTableContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "getSectionStructure", function () {
            var _this$props = _this.props,
                sections = _this$props.sections,
                flow = _this$props.flow,
                pageFlow = _this$props.pageFlow;
            var sectionWithLogic = [];

            if (!sections) {
              return [];
            }

            sections.forEach(function (section) {
              var formSection = get_default()(_this.props, "pagesById.".concat(section.belongToPageId, ".sections"), []); // Dont show sections which dont belong to pageflow

              if (section.belongToPageId && !pageFlow[flow.current].includes(section.belongToPageId)) {
                return;
              }

              if (section.id && !isEmpty_default()(formSection)) {
                // check if section is referenced to the form section and add logic
                formSection.forEach(function (sectionSchema) {
                  if (section.id === sectionSchema.id) {
                    sectionWithLogic.push(objectSpread_default()({}, section, {
                      logic: get_default()(sectionSchema, 'logic', []),
                      items: _this.getFieldsWithLogic(section.id, section.items)
                    }));
                  }
                });
              } else {
                sectionWithLogic.push(objectSpread_default()({}, section, {
                  logic: [],
                  items: _this.getFieldsWithLogic(section.id, section.items)
                }));
              }
            });
            return sectionWithLogic;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getFieldsWithLogic", function (sectionId, items) {
            if (!items) {
              return [];
            }

            var fieldsWithLogic = [];
            items.forEach(function (item) {
              var formField = get_default()(_this.props, "sectionsById.".concat(sectionId || item.belongToSectionId, ".fields"), []);

              if (!isEmpty_default()(formField) && item.id) {
                formField.forEach(function (fieldSchema) {
                  if (item.id === fieldSchema.id) {
                    fieldsWithLogic.push(objectSpread_default()({}, item, {
                      logic: fieldSchema.logic || []
                    }));
                  }
                });
              } else {
                fieldsWithLogic.push(objectSpread_default()({}, item, {
                  logic: []
                }));
              }
            });
            return fieldsWithLogic;
          });
          _this.state = {};
          return _this;
        }

        createClass_default()(AdvancedReviewTableContainer, [{
          key: "componentWillMount",
          value: function componentWillMount() {
            var _this$props2 = this.props,
                flow = _this$props2.flow,
                pageFlow = _this$props2.pageFlow;

            if (flow) {
              this.props.changeValue({
                pageFlow: toConsumableArray_default()(pageFlow[flow.current])
              });
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this2 = this;

            var sections = this.getSectionStructure();
            var config = this.props.config;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-review-table-advanced"
            }, sections.map(function (section, index) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Fragment, {
                key: index
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(AdvancedReviewTable_AdvancedReviewTableSectionContainer, {
                fields: section.items || [] // fields should be items?
                ,
                sectionId: section.id,
                pageId: section.belongToPageId,
                section: section,
                logic: section.logic,
                fieldTokenValues: _this2.props.fieldTokenValues,
                tagleConfig: config
              }));
            }));
          }
        }]);
        return AdvancedReviewTableContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      AdvancedReviewTableContainer_AdvancedReviewTableContainer.defaultProps = {
        config: {},
        sections: []
      };
      AdvancedReviewTableContainer_AdvancedReviewTableContainer.propTypes = {
        config: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        fieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        pagesById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        sectionsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        sections: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        pageFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        fieldTokenValues: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        flow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          current: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        }).isRequired
      };
      /* harmony default export */

      var AdvancedReviewTable_AdvancedReviewTableContainer = Object(es["a"
      /* connect */
      ])(function (_ref) {
        var _ref$formatic = _ref.formatic,
            fieldsById = _ref$formatic.data.submission,
            tokens = _ref$formatic.tokens,
            flow = _ref$formatic.flow,
            pageFlow = _ref$formatic.pageFlow,
            _ref$formatic$dataFor = _ref$formatic.dataForm,
            pagesById = _ref$formatic$dataFor.pagesById,
            sectionsById = _ref$formatic$dataFor.sectionsById;
        return {
          fieldsById: fieldsById,
          pagesById: pagesById,
          sectionsById: sectionsById,
          flow: flow,
          pageFlow: pageFlow,
          fieldTokenValues: tokens
        };
      })(Object(withFieldSync["a"
      /* default */
      ])(AdvancedReviewTableContainer_AdvancedReviewTableContainer)); // CONCATENATED MODULE: ./src/containers/AlertContainer.js

      var AlertContainer_AlertContainer = function AlertContainer(_ref) {
        var className = _ref.className,
            title = _ref.title,
            body = _ref.body,
            color = _ref.color;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["a"
        /* Alert */
        ], {
          className: classnames_default()(defineProperty_default()({}, className, className)),
          body: body,
          color: color,
          title: title
        });
      };

      AlertContainer_AlertContainer.defaultProps = {
        className: 'formatic-alert',
        color: 'success',
        title: ''
      };
      AlertContainer_AlertContainer.propTypes = {
        body: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        color: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        title: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var containers_AlertContainer = AlertContainer_AlertContainer; // EXTERNAL MODULE: ./node_modules/lodash/lodash.js

      var lodash = __webpack_require__(123); // EXTERNAL MODULE: ./src/core/utils/handlebars.js


      var handlebars = __webpack_require__(166); // CONCATENATED MODULE: ./src/containers/ApiDropdownContainer.js


      var ApiDropdownContainer_template = function template(content, data) {
        if (typeof content !== 'string') {
          // can only perform a template replacement on a string
          return content;
        }

        return handlebars["a"
        /* default */
        ].compile(content)(data);
      };

      var ApiDropdownContainer_recurse = function recurse(obj, data) {
        var objClone = Object(lodash["cloneDeep"])(obj);

        if (typeof objClone === 'string') {
          return ApiDropdownContainer_template(objClone, data);
        }

        if (typeof_default()(obj) === 'object') {
          if (Array.isArray(objClone)) {
            // array
            return objClone.map(function (item) {
              return recurse(item, data);
            });
          } // object


          Object.keys(objClone).forEach(function (key) {
            objClone[key] = recurse(objClone[key], data);
          });
          return objClone;
        } // just return unchanged


        return objClone;
      };

      var ApiDropdownContainer_ApiDropdownContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(ApiDropdownContainer, _Component);

        function ApiDropdownContainer() {
          var _getPrototypeOf2;

          var _this;

          classCallCheck_default()(this, ApiDropdownContainer);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(ApiDropdownContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
          defineProperty_default()(assertThisInitialized_default()(_this), "state", {
            options: [],
            results: []
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "search", function () {
            var _this$props = _this.props,
                apiKey = _this$props.apiKey,
                _this$props$body = _this$props.body,
                body = _this$props$body === void 0 ? {} : _this$props$body,
                formatter = _this$props.formatter,
                _this$props$method = _this$props.method,
                method = _this$props$method === void 0 ? '' : _this$props$method,
                resultSearchKey = _this$props.resultSearchKey,
                _this$props$tokens = _this$props.tokens,
                tokens = _this$props$tokens === void 0 ? {} : _this$props$tokens,
                url = _this$props.url,
                valueFormatter = _this$props.valueFormatter,
                valueSearchKey = _this$props.valueSearchKey; // eslint-disable-next-line

            fetch(ApiDropdownContainer_recurse(url, tokens), {
              method: method,
              mode: 'cors',
              headers: {
                Accept: 'application/json',
                Authorization: "Bearer ".concat(apiKey),
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(ApiDropdownContainer_recurse(body, tokens))
            }).then(function (result) {
              return result.json();
            }).then(function (data) {
              var options = Object(lodash["get"])(data, resultSearchKey, []).map(function (result) {
                return {
                  text: ApiDropdownContainer_recurse(formatter, Object(lodash["get"])(result, valueSearchKey, '')),
                  value: ApiDropdownContainer_recurse(valueFormatter || formatter, Object(lodash["get"])(result, valueSearchKey, ''))
                };
              }).filter(function (result) {
                return result.value.length > 0;
              });

              _this.setState({
                options: options,
                results: Object(lodash["get"])(data, resultSearchKey, [])
              });
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onChangeUpdate", function (value) {
            var _this$props2 = _this.props,
                afterChangeUpdate = _this$props2.afterChangeUpdate,
                formatter = _this$props2.formatter,
                tokens = _this$props2.tokens,
                valueFormatter = _this$props2.valueFormatter,
                valueSearchKey = _this$props2.valueSearchKey;
            var results = _this.state.results;

            if (Object.keys(afterChangeUpdate).length > 0) {
              // make data from the result available
              var result = Object(lodash["get"])(results.find(function (row) {
                return ApiDropdownContainer_recurse(valueFormatter || formatter, Object(lodash["get"])(row, valueSearchKey, '')) === value;
              }), valueSearchKey);
              var values = Object.keys(afterChangeUpdate).map(function (key) {
                return {
                  id: key,
                  value: ApiDropdownContainer_recurse(afterChangeUpdate[key], objectSpread_default()({}, tokens, {
                    result: result
                  }))
                };
              });
              Object(helpers["c"
              /* setSubmissionValues */
              ])([], values, Date.now(), Object(actions["d"
              /* getStore */
              ])(), Object(actions["a"
              /* getClient */
              ])());
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleOnChange", function (value) {
            var changeValue = _this.props.changeValue;
            changeValue(value, false);

            _this.onChangeUpdate(value);
          });
          return _this;
        }

        createClass_default()(ApiDropdownContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.search();
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(prevProps) {
            var _this$props3 = this.props,
                currentBody = _this$props3.body,
                _this$props3$tokens = _this$props3.tokens,
                currentTokens = _this$props3$tokens === void 0 ? {} : _this$props3$tokens,
                currentUrl = _this$props3.url;
            var prevBody = prevProps.body,
                _prevProps$tokens = prevProps.tokens,
                prevTokens = _prevProps$tokens === void 0 ? {} : _prevProps$tokens,
                prevUrl = prevProps.url;

            if (!Object(lodash["isEqual"])(ApiDropdownContainer_recurse(currentBody, currentTokens), ApiDropdownContainer_recurse(prevBody, prevTokens))) {
              this.search();
            } else if (!Object(lodash["isEqual"])(ApiDropdownContainer_recurse(currentUrl, currentTokens), ApiDropdownContainer_recurse(prevUrl, prevTokens))) {
              this.search();
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props4 = this.props,
                description = _this$props4.description,
                inputId = _this$props4.inputId,
                label = _this$props4.label,
                placeholder = _this$props4.placeholder,
                required = _this$props4.required,
                requiredSuffixLabel = _this$props4.requiredSuffixLabel,
                showLabel = _this$props4.showLabel,
                showRequiredSuffixLabel = _this$props4.showRequiredSuffixLabel,
                value = _this$props4.value;
            var options = this.state.options;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-api-dropdown"
            }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              className: "formatic-field-label formatic-api-dropdown__label",
              label: label,
              labelFor: inputId,
              isRequired: required,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-api-dropdown__description",
              description: description
            }), options && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["j"
            /* Dropdown */
            ], {
              options: options,
              placeholder: placeholder,
              id: inputId,
              selectClassName: "formatic-dropdown__select",
              dropdownClassName: "formatic-ant-dropdown formatic-dropdown__select-menu",
              selectOptionClassName: "formatic-dropdown__option",
              onBlur: function onBlur() {},
              onChange: this.handleOnChange,
              value: value
            }));
          }
        }]);
        return ApiDropdownContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      ApiDropdownContainer_ApiDropdownContainer.renderer = 'apiDropdown';
      ApiDropdownContainer_ApiDropdownContainer.defaultProps = {
        afterChangeUpdate: {},
        body: {},
        description: '',
        label: '',
        method: 'get',
        placeholder: '',
        required: false,
        resultSearchKey: '',
        showLabel: true,
        value: '',
        valueFormatter: '',
        valueSearchKey: ''
      };
      ApiDropdownContainer_ApiDropdownContainer.propTypes = {
        afterChangeUpdate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // eslint-disable-line
        apiKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        body: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // eslint-disable-line
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        formatter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        method: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        resultSearchKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        tokens: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        // eslint-disable-line
        url: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        valueFormatter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        valueSearchKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // form attributes from dashboard
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool.isRequired
      };
      /* harmony default export */

      var containers_ApiDropdownContainer = Object(Recompose["a"
      /* compose */
      ])(Object(es["a"
      /* connect */
      ])(function (_ref) {
        var _ref$formatic = _ref.formatic,
            apiKey = _ref$formatic.apiKey,
            tokens = _ref$formatic.tokens;
        return {
          apiKey: apiKey,
          tokens: tokens
        };
      }), Object(react_apollo_browser_umd["graphql"])(submission["c"
      /* setSubmissionValuesMutation */
      ], {
        props: function props(_ref2) {
          var mutate = _ref2.mutate,
              ownProps = _ref2.ownProps;
          return {
            setSubmissionAttribute: Object(mutations["a"
            /* submissionAttribute */
            ])(mutate, ownProps)
          };
        }
      }), withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ])(ApiDropdownContainer_ApiDropdownContainer); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/extends.js

      var helpers_extends = __webpack_require__(36);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/cleave.js/react.js


      var react = __webpack_require__(265);

      var react_default =
      /*#__PURE__*/
      __webpack_require__.n(react); // CONCATENATED MODULE: ./src/containers/BSBContainer.js


      var BSBContainer_BSB_VALUE_KEY = 'bsb';
      var BSBContainer_BRANCH_VALUE_KEY = 'branch';
      var BSBContainer_BANK_VALUE_KEY = 'bank';
      var BSBContainer_invalidBSBMessage = 'You have entered an invalid BSB.';
      /**
       * BSB Component
       * Request from the server the possible bsb numbers
       * @class BSB
       * @extends {Component}
       */

      var BSBContainer_BSBContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(BSBContainer, _Component);

        function BSBContainer(props) {
          var _this;

          classCallCheck_default()(this, BSBContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(BSBContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "validator", function (value, internalFieldKey) {
            var errors = {};

            if (!get_default()(_this.props, 'required')) {
              return {
                isValid: true,
                errors: errors,
                displayErrorMessage: ''
              };
            }

            var requiredMessage = _this.props.requiredMessage;
            var fields = [BSBContainer_BSB_VALUE_KEY];

            if (get_default()(_this.props, 'showBranchField')) {
              fields.push(BSBContainer_BRANCH_VALUE_KEY);
            }

            if (get_default()(_this.props, 'showBankField')) {
              fields.push(BSBContainer_BANK_VALUE_KEY);
            }

            if (!isEmpty_default()(get_default()(value, BSBContainer_BSB_VALUE_KEY, '')) && value[BSBContainer_BSB_VALUE_KEY].match(/\d{3}-\d{3}/) === null) {
              errors[BSBContainer_BSB_VALUE_KEY] = BSBContainer_invalidBSBMessage;
              return {
                isValid: false,
                displayErrorMessage: BSBContainer_invalidBSBMessage,
                errors: errors
              };
            }

            if (internalFieldKey) {
              // validator function is called with an internalFieldKey by internal fields on blur event
              errors = objectSpread_default()({}, _this.props.errors);

              if (isEmpty_default()(get_default()(value, internalFieldKey, ''))) {
                errors[internalFieldKey] = requiredMessage;
                return {
                  isValid: false,
                  displayErrorMessage: requiredMessage,
                  errors: errors
                };
              } else if (errors[internalFieldKey]) {
                delete errors[internalFieldKey];
              }

              return {
                isValid: !Object.keys(errors).length,
                displayErrorMessage: get_default()(errors, internalFieldKey, ''),
                errors: errors
              };
            }

            fields.forEach(function (key) {
              if (isEmpty_default()(value[key])) {
                errors[key] = requiredMessage;
              }
            });
            return {
              isValid: !Object.keys(errors).length,
              displayErrorMessage: '',
              errors: errors
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onValueChangeEvent", function (field) {
            return function (value) {
              _this.changeValue(field, value);
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onValueChange", function (field) {
            return function (_ref) {
              var value = _ref.target.value;

              _this.changeValue(field, value);
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "changeValue", function (field, value) {
            // only call changeValue if the last time it was called was not from handleSelect
            // since it also sets bank and branch and calling it here again just for BSB_VALUE_KEY would delete those values
            if (!_this.isLastChangeValueFromHandleSelect) {
              _this.props.changeValue(objectSpread_default()({}, _this.props.value, defineProperty_default()({}, field, value)), true, {
                valueLength: value.length,
                component: field // component is set since this changeValue is only changing a subvalue of props.value

              });

              _this.debouncedValidate(field);
            }

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].ValueChange);

            _this.isLastChangeValueFromHandleSelect = false;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleSearch", function (value) {
            // TODO: add a spinner while we wait for the server response
            var stringOnlyWithNumbers = replace_default()(value, '-', '');

            if (stringOnlyWithNumbers.length < _this.props.minCharsToSearch) {
              _this.setState({
                bsbData: {}
              });

              return;
            }

            Object(utils_requestData["d"
            /* requestData */
            ])({
              method: 'get',
              url: src_config["a"
              /* default */
              ].getApiServer().concat('/bsb/lookup/', stringOnlyWithNumbers).concat("?limit=".concat(encodeURI(_this.props.maxResults)))
            }).then(function (response) {
              var bsbData = {};

              if (get_default()(response, 'data.success', true)) {
                get_default()(response, 'data', []).forEach(function (element) {
                  bsbData[element.bsb] = {
                    bank: element.bank_code,
                    branch: element.name
                  };
                });
              }

              _this.setState({
                bsbData: bsbData
              });
            }).catch(function () {
              _this.setState({
                bsbData: {}
              });
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleBlur", function (element) {
            return function () {
              _this.props.validate(element);

              _this.props.sendAnalytics(analytics["a"
              /* AnalyticsEvents */
              ].Blur, {
                fieldId: _this.props.fieldId,
                component: element
              });

              _this.props.analyticsInteraction(analytics["a"
              /* AnalyticsEvents */
              ].Blur);
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleFocus", function () {
            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Focus, {
              fieldId: _this.props.fieldId,
              component: BSBContainer_BSB_VALUE_KEY
            });

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Focus);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleSelect", function (value) {
            var bank = get_default()(_this.state, "bsbData[".concat(value, "][").concat(BSBContainer_BANK_VALUE_KEY, "]"), '');
            var branch = get_default()(_this.state, "bsbData[".concat(value, "][").concat(BSBContainer_BRANCH_VALUE_KEY, "]"), '');
            var bsb = value || '';

            _this.props.changeValue({
              bank: bank,
              branch: branch,
              bsb: bsb
            });

            _this.isLastChangeValueFromHandleSelect = true; // not specifying a internalFieldKey in order to validate all internal fields

            _this.debouncedValidate();
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getDataSource", function () {
            return Object.keys(_this.state.bsbData).map(function (key, index) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["d"
              /* AutoCompleteOption */
              ], {
                key: index,
                value: key,
                text: key
              }, "".concat(key, " - ").concat(_this.state.bsbData[key][BSBContainer_BANK_VALUE_KEY], " - ").concat(_this.state.bsbData[key][BSBContainer_BRANCH_VALUE_KEY]));
            });
          });
          _this.state = {
            bsbData: {}
          };
          _this.handleSearch = debounce_default()(_this.handleSearch, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          _this.debouncedValidate = debounce_default()(_this.props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          return _this;
        }

        createClass_default()(BSBContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.props.registerValidator(this.validator, this.props.fieldId, constants["Validator"].Custom, true);
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props = this.props,
                bankLabel = _this$props.bankLabel,
                bankReadOnly = _this$props.bankReadOnly,
                branchLabel = _this$props.branchLabel,
                branchReadOnly = _this$props.branchReadOnly,
                description = _this$props.description,
                inputId = _this$props.inputId,
                label = _this$props.label,
                readOnly = _this$props.readOnly,
                required = _this$props.required,
                errors = _this$props.errors,
                showLabel = _this$props.showLabel,
                placeholder = _this$props.placeholder,
                value = _this$props.value,
                optionalSuffixLabel = _this$props.optionalSuffixLabel,
                requiredSuffixLabel = _this$props.requiredSuffixLabel,
                showOptionalSuffixLabel = _this$props.showOptionalSuffixLabel,
                showRequiredSuffixLabel = _this$props.showRequiredSuffixLabel,
                showBankField = _this$props.showBankField,
                showBranchField = _this$props.showBranchField;
            var formAttributes = {
              optionalSuffixLabel: optionalSuffixLabel,
              requiredSuffixLabel: requiredSuffixLabel,
              showOptionalSuffixLabel: showOptionalSuffixLabel,
              showRequiredSuffixLabel: showRequiredSuffixLabel
            };
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-bsb"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_AutoCompleteContainer, extends_default()({
              className: classnames_default()('formatic-bsb__bsb-container', {
                'formatic-field-error': errors[BSBContainer_BSB_VALUE_KEY],
                'formatic-field-valid': !errors[BSBContainer_BSB_VALUE_KEY] && !isEmpty_default()(value[BSBContainer_BSB_VALUE_KEY])
              }),
              showLabel: showLabel,
              label: label,
              inputId: inputId,
              labelClassName: "formatic-field-label formatic-bsb__label",
              required: required
            }, formAttributes, {
              description: description,
              descriptionClassName: "formatic-bsb__description",
              autoCompleteClassName: "formatic-bsb__auto-complete",
              autoCompleteDataSource: this.getDataSource(),
              autoCompleteDropdownClassName: "formatic-ant-dropdown formatic-bsb__auto-complete-dropdown",
              autoCompleteHandleBlur: this.handleBlur(BSBContainer_BSB_VALUE_KEY),
              autoCompleteHandleFocus: this.handleFocus,
              autoCompleteHandleOnChange: this.onValueChangeEvent(BSBContainer_BSB_VALUE_KEY),
              autoCompleteHandleOnSearch: this.handleSearch,
              autoCompleteHandleOnSelect: this.handleSelect,
              autoCompleteInputClassName: "formatic-bsb__auto-complete-input",
              autoCompleteInputId: inputId,
              autoCompleteOptionLabelProp: "value",
              autoCompletePlaceholder: placeholder,
              autoCompleteValue: get_default()(value, BSBContainer_BSB_VALUE_KEY, ''),
              errorMessage: errors[BSBContainer_BSB_VALUE_KEY] && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
              /* ErrorMessage */
              ], {
                text: errors[BSBContainer_BSB_VALUE_KEY]
              }),
              readOnly: readOnly,
              input: react_default.a,
              inputOptions: {
                options: {
                  delimiter: '-',
                  blocks: [3, 3],
                  numericOnly: true
                }
              }
            })), showBankField && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-bsb__bank-container', {
                'formatic-field-error': errors[BSBContainer_BANK_VALUE_KEY],
                'formatic-field-valid': !errors[BSBContainer_BANK_VALUE_KEY] && !isEmpty_default()(value[BSBContainer_BANK_VALUE_KEY])
              })
            }, showLabel && bankLabel && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              labelFor: inputId,
              className: "formatic-field-label formatic-text__label formatic-bsb__bank-label",
              label: bankLabel,
              isRequired: required,
              optionalSuffixLabel: optionalSuffixLabel,
              requiredSuffixLabel: requiredSuffixLabel,
              showOptionalSuffixLabel: showOptionalSuffixLabel,
              showRequiredSuffixLabel: showRequiredSuffixLabel,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["y"
            /* RichTextArea */
            ], {
              className: "formatic-text__description formatic-bsb__bank-description",
              rich: description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
            /* Text */
            ], {
              id: Object(utils["k"
              /* getRandomId */
              ])(),
              className: "formatic-bsb__bank",
              label: bankLabel,
              onBlur: this.handleBlur(BSBContainer_BANK_VALUE_KEY),
              onChange: this.onValueChange(BSBContainer_BANK_VALUE_KEY),
              required: required,
              value: value[BSBContainer_BANK_VALUE_KEY],
              readOnly: bankReadOnly
            }), errors[BSBContainer_BANK_VALUE_KEY] && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: errors[BSBContainer_BANK_VALUE_KEY]
            })), showBranchField && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-bsb__branch-container', {
                'formatic-field-error': errors[BSBContainer_BRANCH_VALUE_KEY],
                'formatic-field-valid': !errors[BSBContainer_BRANCH_VALUE_KEY] && !isEmpty_default()(value[BSBContainer_BRANCH_VALUE_KEY])
              })
            }, showLabel && branchLabel && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              labelFor: inputId,
              className: "formatic-field-label formatic-text__label formatic-bsb__branch-label",
              label: branchLabel,
              isRequired: required,
              optionalSuffixLabel: optionalSuffixLabel,
              requiredSuffixLabel: requiredSuffixLabel,
              showOptionalSuffixLabel: showOptionalSuffixLabel,
              showRequiredSuffixLabel: showRequiredSuffixLabel,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["y"
            /* RichTextArea */
            ], {
              className: "formatic-text__description formatic-bsb__branch-description",
              rich: description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
            /* Text */
            ], {
              id: Object(utils["k"
              /* getRandomId */
              ])(),
              className: "formatic-bsb__branch",
              label: branchLabel,
              onBlur: this.handleBlur(BSBContainer_BRANCH_VALUE_KEY),
              onChange: this.onValueChange(BSBContainer_BRANCH_VALUE_KEY),
              required: required,
              value: value[BSBContainer_BRANCH_VALUE_KEY],
              readOnly: branchReadOnly
            }), errors[BSBContainer_BRANCH_VALUE_KEY] && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: errors[BSBContainer_BRANCH_VALUE_KEY]
            })));
          }
        }]);
        return BSBContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      BSBContainer_BSBContainer.defaultProps = {
        changeValue: noop_default.a,
        errors: {},
        fieldId: '',
        inputId: '',
        registerValidator: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        validate: noop_default.a,
        value: {
          bank: '',
          branch: '',
          bsb: ''
        },
        // attributes from dashboard
        bankLabel: 'Bank/Institution:',
        bankReadOnly: true,
        branchLabel: 'Branch:',
        branchReadOnly: true,
        description: '',
        label: '',
        maxResults: 5,
        minCharsToSearch: 3,
        placeholder: '',
        readOnly: false,
        required: false,
        requiredMessage: constants["DefaultRequiredMessage"],
        showBankField: true,
        showBranchField: true,
        showLabel: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      BSBContainer_BSBContainer.propTypes = {
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        errors: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          bank: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          branch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          bsb: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        })]),
        // attributes from dashboard
        bankLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        bankReadOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        branchLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        branchReadOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        maxResults: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        minCharsToSearch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showBankField: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showBranchField: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_BSBContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(BSBContainer_BSBContainer); // CONCATENATED MODULE: ./src/containers/ButtonListContainer.js

      var ButtonListContainer_ButtonListContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(ButtonListContainer, _Component);

        function ButtonListContainer(props) {
          var _this;

          classCallCheck_default()(this, ButtonListContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(ButtonListContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "addRemoveOption", function (option) {
            var selected = toConsumableArray_default()(_this.state.selected);

            if (!selected.includes(option)) {
              selected.push(option);
            } else {
              selected.splice(selected.indexOf(option), 1);
            }

            return selected;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleClick", function (e) {
            var value = _this.props.multiple ? _this.addRemoveOption(e.target.value) : [e.target.value];

            _this.setState({
              selected: value
            });

            _this.props.changeValue(value, false);

            _this.debouncedValidate();
          });
          var _selected = [];

          if (typeof props.value === 'string' && props.options.includes(props.value)) {
            _selected = [props.value];
          } else if (Array.isArray(props.value)) {
            _selected = props.value;
          }

          _this.state = {
            selected: _selected
          };
          _this.debouncedValidate = debounce_default()(props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          return _this;
        }

        createClass_default()(ButtonListContainer, [{
          key: "componentWillReceiveProps",
          value: function componentWillReceiveProps(nextProps) {
            if (!isEqual_default()(nextProps.value, this.props.value)) {
              this.setState({
                selected: nextProps.value
              });
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props = this.props,
                className = _this$props.className,
                errorMessage = _this$props.errorMessage,
                required = _this$props.required,
                requiredSuffixLabel = _this$props.requiredSuffixLabel,
                showLabel = _this$props.showLabel,
                showRequiredSuffixLabel = _this$props.showRequiredSuffixLabel,
                label = _this$props.label,
                description = _this$props.description;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-button-list', defineProperty_default()({}, className, className))
            }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              className: "formatic-field-label formatic-button-list__label",
              label: label,
              isRequired: this.props.required,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-button-list__description",
              description: description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["f"
            /* ButtonList */
            ], {
              className: classnames_default()('formatic-button-list__items-container', {
                'formatic-button-list__items-container--inline': this.props.inline
              }),
              handleBlur: this.handleBlur,
              handleFocus: this.handleFocus,
              onClick: this.handleClick,
              options: this.props.options,
              button: ButtonContainer["a"
              /* default */
              ],
              default: this.props.default,
              value: this.state.selected
            }), errorMessage);
          }
        }]);
        return ButtonListContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      ButtonListContainer_ButtonListContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        sendAnalytics: noop_default.a,
        validate: noop_default.a,
        value: [],
        // attributes from dashboard
        default: [],
        description: '',
        inline: false,
        label: '',
        multiple: false,
        options: [],
        required: false,
        showLabel: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      ButtonListContainer_ButtonListContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array]),
        // attributes from dashboard
        default: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string), external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inline: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        options: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_ButtonListContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(ButtonListContainer_ButtonListContainer); // EXTERNAL MODULE: ./node_modules/qs/lib/index.js

      var lib = __webpack_require__(681);

      var lib_default =
      /*#__PURE__*/
      __webpack_require__.n(lib); // EXTERNAL MODULE: ./src/core/utils/index.js


      var core_utils = __webpack_require__(216); // EXTERNAL MODULE: ./src/core/utils/localStorage.js


      var localStorage = __webpack_require__(44); // EXTERNAL MODULE: ./node_modules/antd/lib/modal/index.js


      var modal = __webpack_require__(283);

      var modal_default =
      /*#__PURE__*/
      __webpack_require__.n(modal); // CONCATENATED MODULE: ./src/components/Modal.js

      /* eslint-disable react/no-danger */


      var Modal_ModalComponent = function ModalComponent(props) {
        var visible = props.visible,
            handleOk = props.handleOk,
            handleCancel = props.handleCancel,
            content = props.content,
            titleModal = props.titleModal;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(modal_default.a, {
          title: titleModal,
          visible: visible,
          onOk: handleOk,
          onCancel: handleCancel
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-modal-content",
          dangerouslySetInnerHTML: {
            __html: Object(utils["m"
            /* getSafeHTML */
            ])(content)
          }
        }));
      };

      Modal_ModalComponent.defaultProps = {
        content: '',
        visible: false,
        handleOk: noop_default.a,
        handleCancel: noop_default.a,
        titleModal: ''
      };
      Modal_ModalComponent.propTypes = {
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        handleOk: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        handleCancel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        content: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        titleModal: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var Modal = Modal_ModalComponent; // CONCATENATED MODULE: ./src/containers/ButtonRootContainer.js

      var ButtonRootContainer_ButtonRootContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(ButtonRootContainer, _Component);

        function ButtonRootContainer(props) {
          var _this;

          classCallCheck_default()(this, ButtonRootContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(ButtonRootContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "shouldComponentUpdate", function (nextProps, nextState) {
            var propsAreEqual = isEqual_default()(nextProps, _this.props);
            var stateIsEqual = isEqual_default()(nextState, _this.state);

            if (!isEqual_default()(nextProps.bodyClass, _this.props.bodyClass)) {
              // body class updated, irrelevant for our render, do not update
              return false;
            }

            return !propsAreEqual || !stateIsEqual;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getLastReviewTableId", function () {
            var _this$props = _this.props,
                reviewTableId = _this$props.attributes.reviewTableId,
                fieldsById = _this$props.fieldsById,
                flow = _this$props.flow,
                myPagesById = _this$props.myPagesById,
                mySectionsById = _this$props.mySectionsById,
                pageFlow = _this$props.pageFlow;
            var getCurrentFlow = pageFlow[flow.current];
            var lastReviewTableId = reviewTableId;

            if (Array.isArray(reviewTableId)) {
              lastReviewTableId = reviewTableId.reduce(function (lastId, id) {
                var reviewTablePageId = _this.getPageIdByFieldID(id, mySectionsById, myPagesById);

                var inPageFlow = getCurrentFlow.includes(reviewTablePageId);
                var isVisible = inPageFlow && get_default()(fieldsById, "".concat(id, ".value.pageFlow"), false) !== false;

                if (isVisible && (lastId === null || reviewTableId.indexOf(id) > reviewTableId.indexOf(lastId))) {
                  lastId = id;
                }

                return lastId;
              }, null);
            }

            return lastReviewTableId;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleClick", function () {
            var _this$props2 = _this.props,
                attributes = _this$props2.attributes,
                channel = _this$props2.channel,
                formId = _this$props2.formId,
                visibleFields = _this$props2.visibleFields,
                formBehaviours = _this$props2.formBehaviours,
                myPagesById = _this$props2.myPagesById,
                mySectionsById = _this$props2.mySectionsById;

            if (attributes.apiActionEndpoint) {
              _this.apiRequest();
            }

            if (attributes.reviewTableUsage && attributes.reviewTableId) {
              var reviewTableId = _this.getLastReviewTableId(attributes.reviewTableId);

              var reviewTablePageId = _this.getPageIdByFieldID(reviewTableId, mySectionsById, myPagesById);

              if (Object(navigation["b"
              /* pageValidation */
              ])(visibleFields, formBehaviours)) {
                _this.props.setCurrentPage(reviewTablePageId, channel);

                _this.saveCurrentPage(reviewTablePageId);
              }
            }

            if (attributes.navigateToPage) {
              _this.props.setCurrentPage(attributes.navigateToPage, channel);

              if (attributes.saveNavigateToPage) {
                _this.saveCurrentPage(attributes.navigateToPage).then(function () {
                  if (attributes.clearSession) {
                    var localStorageId = Object(localStorage["c"
                    /* getLocalStorageSubmissionKey */
                    ])(formId);
                    Object(localStorage["g"
                    /* localStorageRemoveItem */
                    ])(localStorageId);
                  }
                });
              }
            }

            if (attributes.clearSession) {
              var localStorageId = Object(localStorage["c"
              /* getLocalStorageSubmissionKey */
              ])(formId);
              Object(localStorage["g"
              /* localStorageRemoveItem */
              ])(localStorageId);
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "saveCurrentPage", function (pageId) {
            var _this$props3 = _this.props,
                channel = _this$props3.channel,
                currentPage = _this$props3.currentPage,
                setSubmissionAttribute = _this$props3.setSubmissionAttribute,
                formAttributes = _this$props3.formAttributes,
                fields = _this$props3.fields,
                initialValues = _this$props3.initialValues; // Send mutation to server

            return setSubmissionAttribute({
              attributes: [{
                id: 'currentPage',
                value: objectSpread_default()({}, currentPage, defineProperty_default()({}, channel, {
                  pageId: pageId,
                  requestTimestamp: Date.now()
                }))
              }]
            }, {
              attributes: formAttributes,
              fields: fields,
              initialValues: initialValues
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "apiRequest", function () {
            var _this$props4 = _this.props,
                attributes = _this$props4.attributes,
                apiKey = _this$props4.apiKey,
                channel = _this$props4.channel,
                environment = _this$props4.environment,
                formId = _this$props4.formId,
                submissionId = _this$props4.submissionId;
            core_utils["a"
            /* default */
            ].http.request({
              method: 'post',
              mode: 'cors',
              'Access-Control - Allow - Origin': '*',
              url: core_utils["a"
              /* default */
              ].http.apiServerUrl(attributes.apiActionEndpoint),
              headers: {
                Authorization: "Bearer ".concat(apiKey),
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              data: lib_default.a.stringify({
                form_id: formId,
                sessionId: submissionId,
                branch: environment,
                channel: channel
              })
            }).catch(function () {
              return _this.setState({
                success: false
              });
            }).then(function () {
              return _this.setState({
                success: true,
                showMessage: true
              });
            });

            if (!attributes.persistantMessage) {
              setTimeout(function () {
                return _this.setState({
                  showMessage: false
                });
              }, attributes.messageTimeOut);
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getCurrentPageId", function () {
            return get_default()(_this.props.currentPage, "[".concat(_this.props.channel, "].pageId"));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "showButton", function () {
            var attributes = _this.props.attributes;

            var currentPage = _this.getCurrentPageId();

            if (attributes.reviewTableUsage) {
              return _this.showReviewTableButton();
            }

            return !(attributes.excludeFromPage && Array.isArray(attributes.excludeFromPage) && attributes.excludeFromPage.includes(currentPage));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getPageIdByFieldID", function (fieldId) {
            var _this$props5 = _this.props,
                myPagesById = _this$props5.myPagesById,
                mySectionsById = _this$props5.mySectionsById;
            var pageId = Object.entries(myPagesById).find(function (_ref) {
              var _ref2 = slicedToArray_default()(_ref, 2),
                  page = _ref2[1];

              return page.sections.some(function (_ref3) {
                var sectionId = _ref3.id;
                return mySectionsById[sectionId].fields.map(function (_ref4) {
                  var sectionFieldId = _ref4.id;
                  return sectionFieldId;
                }).includes(fieldId);
              });
            });
            return pageId ? pageId[0] : null;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleClickModal", function () {
            _this.setState({
              showModalReviewTable: false
            });
          });
          _this.state = {
            success: null,
            showMessage: null,
            showModalReviewTable: false
          };
          return _this;
        }

        createClass_default()(ButtonRootContainer, [{
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            var _this$props6 = this.props,
                myAddBodyClass = _this$props6.myAddBodyClass,
                _this$props6$attribut = _this$props6.attributes,
                reviewTableUsage = _this$props6$attribut.reviewTableUsage,
                inReviewClass = _this$props6$attribut.inReviewClass,
                bodyClass = _this$props6.bodyClass,
                myRemoveBodyClass = _this$props6.myRemoveBodyClass;

            if (reviewTableUsage && inReviewClass) {
              var buttonIsVisible = this.showReviewTableButton();

              if (buttonIsVisible && !bodyClass.includes(inReviewClass)) {
                // button is visible, and body class does not contain review class
                myAddBodyClass(inReviewClass);
              } else if (!buttonIsVisible && bodyClass.includes(inReviewClass)) {
                // button is not visible, remove the review class
                myRemoveBodyClass(inReviewClass);
              }
            }
          }
          /**
           * Review table ID can accept as a prop either a Review Table as a String,
           * or an array of Review Table IDs. If an array is passed through, logic
           * is needed to determine which review table the user should be allowed to
           * jump back to.
           */

        }, {
          key: "showReviewTableButton",
          value: function showReviewTableButton() {
            var _this$props7 = this.props,
                reviewTableId = _this$props7.attributes.reviewTableId,
                fieldsById = _this$props7.fieldsById,
                pageFlow = _this$props7.pageFlow,
                flow = _this$props7.flow,
                currentPage = _this$props7.currentPage,
                channel = _this$props7.channel,
                mySectionsById = _this$props7.mySectionsById,
                myPagesById = _this$props7.myPagesById;
            var getCurrentFlow = pageFlow[flow.current];
            var lastReviewTableId = this.getLastReviewTableId(reviewTableId);
            var reviewTablePageId = this.getPageIdByFieldID(lastReviewTableId, mySectionsById, myPagesById);

            if (fieldsById[lastReviewTableId] && currentPage[channel]) {
              return isEqual_default()(fieldsById[lastReviewTableId].value.pageFlow, getCurrentFlow) && reviewTablePageId !== currentPage[channel].pageId && getCurrentFlow.indexOf(currentPage[channel].pageId) < getCurrentFlow.indexOf(reviewTablePageId);
            }

            return false;
          }
        }, {
          key: "render",
          value: function render() {
            var _classNames2;

            var _this$state = this.state,
                success = _this$state.success,
                showMessage = _this$state.showMessage;
            var attributes = this.props.attributes;

            if (!this.showButton()) {
              return null;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Fragment, null, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-button-root-container', defineProperty_default()({}, "formatic-button-root-container-".concat(attributes.parentClass), attributes.parentClass))
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Button["a"
            /* default */
            ], {
              id: this.props.id,
              onClick: this.handleClick,
              className: classnames_default()('formatic-button formatic-button-root', (_classNames2 = {}, defineProperty_default()(_classNames2, "formatic-button-root-".concat(attributes.class), attributes.class), defineProperty_default()(_classNames2, 'formatic-button-root--clicked', success), _classNames2)),
              label: attributes.label
            }), (success && attributes.persistantMessage || !attributes.persistantMessage && success && showMessage) && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-button-root-message"
            }, attributes.message)), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Modal, {
              visible: this.state.showModalReviewTable,
              handleOk: this.handleClickModal,
              handleCancel: this.handleClickModal,
              content: attributes.contentModal,
              titleModal: attributes.titleModal
            }));
          }
        }]);
        return ButtonRootContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      ButtonRootContainer_ButtonRootContainer.defaultProps = {
        attributes: {},
        bodyClass: [],
        currentPage: {},
        id: '',
        initialValues: []
      };
      ButtonRootContainer_ButtonRootContainer.propTypes = {
        apiKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        attributes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          apiActionEndpoint: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          clearSession: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          class: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          excludeFromPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          inReviewClass: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          message: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          navigateToPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          persistantMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          saveNavigateToPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          messageTimeOut: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          parentClass: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          reviewTableId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string)]),
          reviewTableUsage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          contentModal: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          titleModal: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        }),
        bodyClass: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        myAddBodyClass: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        myRemoveBodyClass: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        currentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        environment: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        formId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number.isRequired,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        initialValues: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        setCurrentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        submissionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        setSubmissionAttribute: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        fieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        fields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        formAttributes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        mySectionsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        myPagesById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        pageFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        flow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        visibleFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        formBehaviours: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired
      };
      /* harmony default export */

      var containers_ButtonRootContainer = Object(react_apollo_browser_umd["compose"])(Object(es["a"
      /* connect */
      ])(function (_ref5) {
        var formatic = _ref5.formatic;
        return {
          submissionId: formatic.submissionId,
          formId: formatic.formId,
          channel: formatic.channel,
          environment: formatic.environment,
          initialValues: formatic.initialValues,
          apiKey: formatic.apiKey,
          currentPage: formatic.currentPage,
          flow: formatic.flow,
          pageFlow: formatic.pageFlow,
          fieldsById: formatic.data.submission.fieldsById,
          visibleFields: formatic.visibleFields,
          formBehaviours: formatic.dataForm.attributes,
          fields: Object.values(formatic.data.submission.fieldsById),
          formAttributes: Object.values(formatic.data.submission.attributesById),
          bodyClass: formatic.bodyClass
        };
      }, function (dispatch) {
        return {
          setCurrentPage: function setCurrentPage(pageId, channel) {
            return dispatch(Object(core_actions["O"
            /* setCurrentPage */
            ])(pageId, channel));
          },
          myAddBodyClass: function myAddBodyClass(className) {
            return dispatch(Object(core_actions["F"
            /* addBodyClass */
            ])(className));
          },
          myRemoveBodyClass: function myRemoveBodyClass(className) {
            return dispatch(Object(core_actions["J"
            /* removeBodyClass */
            ])(className));
          }
        };
      }), Object(react_apollo_browser_umd["graphql"])(submission["c"
      /* setSubmissionValuesMutation */
      ], {
        props: function props(_ref6) {
          var mutate = _ref6.mutate,
              ownProps = _ref6.ownProps;
          return {
            setSubmissionAttribute: Object(mutations["a"
            /* submissionAttribute */
            ])(mutate, ownProps)
          };
        }
      }))(ButtonRootContainer_ButtonRootContainer); // CONCATENATED MODULE: ./src/containers/LabelContainer.js

      var LabelContainer_getSuffixLabel = function getSuffixLabel(props) {
        if (props.isRequired && props.showRequiredSuffixLabel) {
          return props.requiredSuffixLabel;
        } else if ( // checking if isRequired is equals to false because if it undefined it will not add the optional label
        props.isRequired === false && props.showOptionalSuffixLabel) {
          return props.optionalSuffixLabel;
        }

        return undefined;
      };

      var LabelContainer_isRequiredSuffix = function isRequiredSuffix(props, suffixLabel) {
        if (isEmpty_default()(suffixLabel)) {
          return false;
        }

        return props.isRequired;
      };

      var LabelContainer_LabelContainer = function LabelContainer(props) {
        var className = props.className,
            label = props.label,
            labelFor = props.labelFor;
        var suffixLabel = LabelContainer_getSuffixLabel(props);
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
        /* Label */
        ], {
          className: className,
          label: label,
          suffixLabel: suffixLabel,
          isRequiredSuffix: LabelContainer_isRequiredSuffix(props, suffixLabel),
          labelFor: labelFor
        });
      };

      LabelContainer_LabelContainer.defaultProps = {
        className: '',
        labelFor: '',
        isRequired: false,
        // form attributes from dashboard
        optionalSuffixLabel: ' (optional)',
        requiredSuffixLabel: ' *',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: true
      };
      LabelContainer_LabelContainer.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        labelFor: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        isRequired: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_LabelContainer = LabelContainer_LabelContainer; // CONCATENATED MODULE: ./src/containers/CheckboxListContainer.js

      var CheckboxListContainer_handleOnFocus = function handleOnFocus(onFocus, sendAnalytics, analyticsInteraction) {
        return function (event) {
          onFocus(event);
          sendAnalytics(analytics["a"
          /* AnalyticsEvents */
          ].Focus, {
            option: event.target.value
          });
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].Focus);
        };
      };

      var CheckboxListContainer_handleOnBlur = function handleOnBlur(onBlur, validate, sendAnalytics, analyticsInteraction) {
        return function (event) {
          onBlur(event);
          validate();
          sendAnalytics(analytics["a"
          /* AnalyticsEvents */
          ].Blur, {
            option: event.target.value
          });
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].Blur);
        };
      };

      var CheckboxListContainer_handleOnChange = function handleOnChange(onChange, validate, value, analyticsInteraction) {
        return function (event) {
          onChange(event.target.checked ? value.concat(event.target.value) : value.filter(function (v) {
            return v !== event.target.value;
          }), false);
          validate();
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].ValueChange);
        };
      };

      var CheckboxListContainer_getValue = function getValue(value) {
        if (Array.isArray(value)) {
          return value;
        } // Default value and populate value are coming as string


        return [value];
      };

      var CheckboxListContainer_CheckboxListContainer = function CheckboxListContainer(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()('formatic-checkbox-list', defineProperty_default()({}, props.className, props.className))
        }, props.showLabel && props.label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
        /* Label */
        ], {
          className: "formatic-field-label formatic-checkbox-list__label",
          label: props.label,
          isRequired: props.required // todo suffix

        }), props.description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
        /* FieldDescription */
        ], {
          className: "formatic-checkbox-list__description",
          description: props.description
        }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["g"
        /* CheckboxList */
        ], {
          className: classnames_default()('formatic-checkbox-list__items-container', {
            'formatic-checkbox-list__items-container--inline': props.inline
          }),
          id: props.inputId,
          label: containers_LabelContainer,
          onBlur: CheckboxListContainer_handleOnBlur(props.onBlur, props.validate, props.sendAnalytics, props.analyticsInteraction),
          onChange: CheckboxListContainer_handleOnChange(props.changeValue, props.validate, props.value, props.analyticsInteraction),
          onFocus: CheckboxListContainer_handleOnFocus(props.onFocus, props.sendAnalytics, props.analyticsInteraction),
          options: props.options,
          value: CheckboxListContainer_getValue(props.value)
        }), props.errorMessage);
      };

      CheckboxListContainer_CheckboxListContainer.defaultProps = {
        // attributes from dashboard
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        inputId: '',
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        validate: noop_default.a,
        value: [],
        // attributes from dashboard
        description: '',
        inline: false,
        label: '',
        options: [],
        required: false,
        showLabel: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      CheckboxListContainer_CheckboxListContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string), external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inline: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        options: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_CheckboxListContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])([].concat(toConsumableArray_default()(withFieldToken["b"
      /* defaultPropsToVerify */
      ]), ['options'])))(CheckboxListContainer_CheckboxListContainer); // EXTERNAL MODULE: ./node_modules/moment/moment.js

      var moment = __webpack_require__(14);

      var moment_default =
      /*#__PURE__*/
      __webpack_require__.n(moment); // EXTERNAL MODULE: ./src/components/InputMask.js


      var InputMask = __webpack_require__(266); // CONCATENATED MODULE: ./src/containers/DatePickerContainer.js
      // Message for the invalid date entry


      var DatePickerContainer_invalidText = 'Please enter valid date'; // constant definition to replace string in render method

      var DatePickerContainer_modeInputOnly = 'inputOnly';
      var DatePickerContainer_modeInputCalendar = 'calendarInput';
      var DatePickerContainer_modeCalendar = 'calendar'; // Default date format in backend and incoming attributes

      var DatePickerContainer_defaultDateFormat = 'DD/MM/YYYY'; // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date

      var DatePickerContainer_nativeDateFormatDefault = 'YYYY-MM-DD'; // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/month

      var DatePickerContainer_nativeMonthDateFormatDefault = 'YYYY-MM';
      var DatePickerContainer_defaultMonthDateFormat = 'YYYY/MM';
      var DatePickerContainer_readableMonthDateFormat = 'MMMM, YYYY';
      var DatePickerContainer_invalidDate = 'Invalid date';
      /**
       * Create a moment object, if a valid dd/mm/yyyy date or expression like -1 days, 5 months was set
       * @param {String} disabledProp
       * @param {String} defaultFormat
       */

      var DatePickerContainer_getMomentObjectFromDateProp = function getMomentObjectFromDateProp(disabledPropValue, defaultFormat) {
        if (!disabledPropValue || disabledPropValue.toString().trim() === '') {
          return '';
        }

        var date; // Attempt to match a pattern like -1 month, +5 day, 4 year etc

        var patternRegex = /([-+\s]*)([0-9]{1,}[.]{0,1}[0-9]*)([\s]*)(day|week|month|year)/;
        var matches = patternRegex.exec(disabledPropValue);

        if (matches !== null) {
          date = moment_default()(new Date(), defaultFormat);
          var numberModifier = Number(matches[2]); // We should only match on the singular but moment needs plural, so day => days etc

          var periodModifier = "".concat(matches[4], "s");

          if (matches[1].trim() === '-') {
            date = date.subtract(numberModifier, periodModifier);
          } else {
            date = date.add(numberModifier, periodModifier);
          }

          return date;
        } // Otherwise try the dd/mm/yyyy static date
        // Do a basic 99/99/9999 check, we will validate later


        patternRegex = /([0-9]{2})\/([0-9]{2})\/[0-9]{4}/gm;
        matches = patternRegex.exec(disabledPropValue);

        if (matches !== null) {
          date = moment_default()(disabledPropValue, defaultFormat);

          if (date.isValid()) {
            return date;
          }
        }

        return '';
      };

      var DatePickerContainer_DatePickerContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(DatePickerContainer, _Component);

        function DatePickerContainer(props) {
          var _this;

          classCallCheck_default()(this, DatePickerContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(DatePickerContainer).call(this, props)); // convert disabled props from string to moment object

          defineProperty_default()(assertThisInitialized_default()(_this), "state", {
            calendarOpen: false
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "componentDidMount", function () {
            _this.props.registerValidator(function (value) {
              for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }

              return DatePickerContainer.validator.apply(DatePickerContainer, [{
                date: value,
                format: _this.getFormat()
              }].concat(args));
            }, _this.props.fieldId, constants["Validator"].Custom, false);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "setDatePickerRef", function (ref) {
            _this.datePickerRef = ref;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleOnFocus", function (event) {
            _this.props.onFocus(event);

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Focus, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Focus);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleOnBlur", function (event) {
            _this.props.onBlur(event);

            if (!_this.isDatePickerOpen) {
              _this.props.validate();
            }

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Blur, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Blur);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getFormat", function () {
            var prioritizeReadability = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false; // prioritizeReadability must be TRUE only for rendering purposes and FALSE in any other case!!

            if (prioritizeReadability) {
              return _this.props.isMonthPicker ? DatePickerContainer_readableMonthDateFormat : _this.props.format.toUpperCase();
            }

            return _this.props.isMonthPicker ? DatePickerContainer_defaultMonthDateFormat : _this.props.format.toUpperCase();
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getNativeFormat", function () {
            return _this.props.isMonthPicker ? DatePickerContainer_nativeMonthDateFormatDefault : DatePickerContainer_nativeDateFormatDefault;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleOnChange", function (value) {
            var isMoment = moment_default.a.isMoment(value);
            var isInputMask = !isMoment ? value : false; // make sure that value is always a moment instance if possible.

            if (value !== null && !isMoment) {
              if (value.target.value !== '') {
                _this.newFormat = value.target.name === 'mask' ? _this.getFormat() : _this.getNativeFormat();
                value = moment_default()(value.target.value, _this.newFormat);
                isMoment = true;
              } else {
                value = null;
              }
            } // proceed only if value is a moment instance


            if (isMoment) {
              _this.props.changeValue(value ? value.format(_this.getFormat()) : ''); // NOTE: it is required to add 'value === null' as a condition to trigger the validation
              //       because Ant Design Date Picker component has a delete button that once the user clicks on it it sets the value to null
              //       and it does not trigger the blur event (which would trigger the validation)


              if (_this.props.realTimeValidation || value === null) {
                // need to trigger validate after the fieldUpdateTimeout, otherwise it'll not have the correct value to run the validation
                _this.debouncedValidate();
              }

              _this.props.analyticsInteraction(analytics["a"
              /* AnalyticsEvents */
              ].ValueChange);
            } else if (value === '' || value === null) {
              if (value === null) {
                value = '';
              }

              _this.props.changeValue(value);

              _this.props.analyticsInteraction(analytics["a"
              /* AnalyticsEvents */
              ].ValueChange);
            } // if the date input comes form the plain dom element then it'll come on blur event
            // so need to this is for validation of  date on blur


            if (isInputMask) {
              _this.handleOnBlur(isInputMask);
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getValue", function () {
            if (_this.props.value && !isEqual_default()(_this.props.value, DatePickerContainer_invalidDate)) {
              return moment_default()(_this.props.value, _this.getFormat());
            }

            return null; // returning 'null' here in order to display placeholder
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getNativeValue", function () {
            if (_this.props.value && !isEqual_default()(_this.props.value, DatePickerContainer_invalidDate)) {
              return moment_default()(_this.props.value, _this.getFormat()).format(_this.getNativeFormat());
            }

            return null; // returning 'null' here in order to display placeholder
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getDisabledBeforeNative", function () {
            var date = DatePickerContainer_getMomentObjectFromDateProp(_this.props.disabledBefore, DatePickerContainer_defaultDateFormat);
            return moment_default.a.isMoment(date) ? date.format(_this.getNativeFormat()) : '';
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getDisabledAfterNative", function () {
            var date = DatePickerContainer_getMomentObjectFromDateProp(_this.props.disabledAfter, DatePickerContainer_defaultDateFormat);
            return moment_default.a.isMoment(date) ? date.format(_this.getNativeFormat()) : '';
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "shouldDateBeDisabled", function (precision) {
            return function (momentDate) {
              if (momentDate) {
                return _this.disabledBefore && momentDate.isBefore(_this.disabledBefore, precision) || _this.disabledAfter && momentDate.isAfter(_this.disabledAfter, precision);
              }

              return false;
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleOnOpenChange", function (open) {
            _this.setState({
              calendarOpen: !_this.state.calendarOpen
            });

            if (!open) {
              _this.isDatePickerOpen = false;

              _this.handleOnBlur({
                target: {
                  value: _this.getValue()
                }
              }); // make sure the date picker is focused after closing the calendar so the user can continue to navigate using the keyboard


              _this.datePickerRef.focus();
            } else {
              _this.isDatePickerOpen = true;
            }

            _this.props.sendAnalytics(open ? analytics["a"
            /* AnalyticsEvents */
            ].Focus : analytics["a"
            /* AnalyticsEvents */
            ].Blur, _this.props.analyticsParams);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "renderCalendarInput", function () {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Fragment, null, _this.renderInputOnly(), _this.renderNormalDatePicker());
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "renderInputOnly", function () {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(InputMask["a"
            /* default */
            ], {
              maskOptions: {
                delimiter: _this.datePattern.seperator,
                blocks: _this.datePattern.pattern,
                numericOnly: true
              },
              value: moment_default.a.isMoment(_this.getValue()) ? _this.getValue().format(_this.getFormat()) : false,
              placeholder: _this.getFormat(),
              onBlur: _this.handleOnChange,
              onFocus: _this.handleOnFocus,
              name: "mask",
              className: classnames_default()({
                'formatic-date-picker__month-picker': _this.props.isMonthPicker,
                'formatic-date-picker__date-picker': !_this.props.isMonthPicker
              })
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "renderNormalDatePicker", function () {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["b"
            /* AntDesignDatePicker */
            ], {
              isMonthPicker: _this.props.isMonthPicker,
              className: classnames_default()({
                'formatic-date-picker__month-picker': _this.props.isMonthPicker,
                'formatic-date-picker__date-picker': !_this.props.isMonthPicker
              }),
              dropdownClassName: classnames_default()('formatic-date-picker__popup-calendar', defineProperty_default()({}, _this.props.class, _this.props.class)),
              format: _this.getFormat(true),
              value: _this.getValue(),
              reference: _this.setDatePickerRef,
              placeholder: _this.props.placeholder,
              onChange: _this.handleOnChange,
              onBlur: _this.handleOnBlur,
              onFocus: _this.handleOnFocus,
              disabledDate: _this.shouldDateBeDisabled(_this.props.isMonthPicker ? 'month' : 'day'),
              onOpenChange: _this.handleOnOpenChange,
              defaultPickerValue: _this.defaultCalendarDate,
              open: _this.state.calendarOpen
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "renderNativeDatePicker", function () {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["h"
            /* DatePicker */
            ], {
              id: _this.props.inputId,
              type: _this.props.isMonthPicker ? 'month' : 'date',
              className: classnames_default()({
                'formatic-date-picker__native-month': _this.props.isMonthPicker,
                'formatic-date-picker__native-date': !_this.props.isMonthPicker
              }),
              value: _this.getNativeValue(),
              min: _this.props.disabledBefore && _this.getDisabledBeforeNative(),
              max: _this.props.disabledAfter && _this.getDisabledAfterNative(),
              onBlur: _this.handleOnBlur,
              onFocus: _this.handleOnFocus,
              onChange: _this.handleOnChange
            });
          });
          _this.disabledBefore = DatePickerContainer_getMomentObjectFromDateProp(props.disabledBefore, DatePickerContainer_defaultDateFormat);
          _this.disabledAfter = DatePickerContainer_getMomentObjectFromDateProp(props.disabledAfter, DatePickerContainer_defaultDateFormat);
          _this.defaultCalendarDate = DatePickerContainer_getMomentObjectFromDateProp(props.defaultCalendarDate, DatePickerContainer_defaultDateFormat);
          _this.debouncedValidate = debounce_default()(_this.props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          _this.isDatePickerOpen = false; // date pattern generator

          _this.datePattern = Object(utils["c"
          /* getDatePattern */
          ])(_this.getFormat());
          return _this;
        }

        createClass_default()(DatePickerContainer, [{
          key: "render",
          value: function render() {
            // TODO: AntdDatePicker and MonthPicker do not accept id, so labelFor from Label component does not work for those cases
            //       There is a 'open' function that could be used to open the ant design components once the user clicks on the label.
            //       Feature to be developed later.
            //       --> consider to use ref in order to add labelFor
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-date-picker', defineProperty_default()({}, this.props.className, this.props.className))
            }, this.props.showLabel && this.props.label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_LabelContainer, {
              labelFor: this.props.inputId,
              className: "formatic-field-label formatic-date-picker__label",
              label: this.props.label,
              isRequired: this.props.required,
              optionalSuffixLabel: this.props.optionalSuffixLabel,
              requiredSuffixLabel: this.props.requiredSuffixLabel,
              showOptionalSuffixLabel: this.props.showOptionalSuffixLabel,
              showRequiredSuffixLabel: this.props.showRequiredSuffixLabel
            }), this.props.description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-date-picker__description",
              description: this.props.description
            }), Object(utils["p"
            /* mobileAndTabletcheck */
            ])() && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-date-picker__native"
            }, this.renderNativeDatePicker()), !Object(utils["p"
            /* mobileAndTabletcheck */
            ])() && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-date-picker__normal formatic-date-picker-mode-".concat(this.props.desktopRenderMode)
            }, this.props.desktopRenderMode === DatePickerContainer_modeInputOnly && this.renderInputOnly(), this.props.desktopRenderMode === DatePickerContainer_modeInputCalendar && this.renderCalendarInput(), this.props.desktopRenderMode === DatePickerContainer_modeCalendar && this.renderNormalDatePicker()), this.props.errorMessage);
          }
        }]);
        return DatePickerContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      DatePickerContainer_DatePickerContainer.validator = function (value) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        var props = args[2];
        var format = value.format,
            rawDate = value.date;
        var disabledBefore = props.disabledBefore,
            disabledAfter = props.disabledAfter,
            required = props.required;
        var date = moment_default()(value.date, format);
        var isValid = true; // If the field has no value, and is not marked as required, then assume no error

        if (rawDate === '' && !required) {
          return {
            isValid: true,
            invalidText: '',
            displayErrorMessage: ''
          };
        } // returns error if date format is invalid


        if (!date.isValid()) {
          return {
            isValid: !isValid,
            invalidText: DatePickerContainer_invalidText,
            displayErrorMessage: DatePickerContainer_invalidText
          };
        }

        var inputError = false;

        if (disabledBefore || disabledAfter) {
          var disabledAfterMoment = disabledBefore ? DatePickerContainer_getMomentObjectFromDateProp(disabledBefore, DatePickerContainer_defaultDateFormat) : null;
          var disabledBeforeMoment = disabledAfter ? DatePickerContainer_getMomentObjectFromDateProp(disabledAfter, DatePickerContainer_defaultDateFormat) : null;
          var errorMessagePieces = [];

          if (disabledBeforeMoment) {
            disabledBeforeMoment.set({
              hour: 0,
              minute: 0,
              second: 0,
              millisecond: 0
            });

            if (!date.isSameOrBefore(disabledBeforeMoment)) {
              errorMessagePieces.push("on or before ".concat(disabledBeforeMoment.format(DatePickerContainer_defaultDateFormat)));
            }
          }

          if (disabledAfterMoment) {
            disabledAfterMoment.set({
              hour: 0,
              minute: 0,
              second: 0,
              millisecond: 0
            });
            date.set({
              second: 1
            });

            if (!date.isSameOrAfter(disabledAfterMoment)) {
              if (errorMessagePieces.length > 0) {
                errorMessagePieces.push('and');
              }

              errorMessagePieces.push("on or after ".concat(disabledAfterMoment.format(DatePickerContainer_defaultDateFormat)));
            }
          }

          if (errorMessagePieces.length > 0) {
            isValid = false;
            inputError = "Please enter a date ".concat(errorMessagePieces.join(' '));
          }
        } // returns error


        return {
          isValid: isValid,
          inputError: inputError,
          displayErrorMessage: inputError
        };
      };

      DatePickerContainer_DatePickerContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        inputId: '',
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        validate: noop_default.a,
        value: '',
        fieldId: '',
        registerValidator: noop_default.a,
        // attributes from dashboard
        class: '',
        description: '',
        disabledAfter: '',
        disabledBefore: '',
        defaultCalendarDate: '',
        format: DatePickerContainer_defaultDateFormat,
        isMonthPicker: false,
        label: '',
        placeholder: 'Please choose a date',
        readOnly: false,
        realTimeValidation: false,
        required: false,
        showLabel: true,
        desktopRenderMode: 'calendar',
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      DatePickerContainer_DatePickerContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        // attributes from dashboard
        class: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        disabledAfter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        disabledBefore: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        defaultCalendarDate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        format: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        isMonthPicker: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        realTimeValidation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        desktopRenderMode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_DatePickerContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(DatePickerContainer_DatePickerContainer); // EXTERNAL MODULE: ./node_modules/signature_pad/dist/signature_pad.js

      var signature_pad = __webpack_require__(680);

      var signature_pad_default =
      /*#__PURE__*/
      __webpack_require__.n(signature_pad); // CONCATENATED MODULE: ./src/containers/DigitalSignatureContainer.js


      var DigitalSignatureContainer_DigitalSignatureContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(DigitalSignatureContainer, _Component);

        function DigitalSignatureContainer(props) {
          var _this;

          classCallCheck_default()(this, DigitalSignatureContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(DigitalSignatureContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "updateDimensions", function () {
            _this.state.canvas.width = _this.state.canvas.parentNode.offsetWidth;
            _this.state.signaturePad = new signature_pad_default.a(_this.state.canvas, {
              backgroundColor: _this.props.backgroundColor,
              onEnd: _this.onChange,
              penColor: _this.props.penColor
            });
            var value = get_default()(_this.props.value, 'path', []);

            if (value.length > 0) {
              _this.state.signaturePad.fromData(toConsumableArray_default()(value));
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "validator", function (value) {
            var displayErrorMessage = '';

            if (!_this.props.required) {
              return {
                isValid: true,
                displayErrorMessage: displayErrorMessage
              };
            }

            var isValid = get_default()(value, 'path', '').length > 0;

            if (!isValid) {
              displayErrorMessage = _this.props.requiredMessage;
            }

            return {
              isValid: isValid,
              displayErrorMessage: displayErrorMessage
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onChange", function () {
            var value = {
              path: toConsumableArray_default()(_this.state.signaturePad.toData()),
              value: _this.state.signaturePad.toDataURL()
            };

            _this.props.changeValue(value, true);

            _this.props.validate();
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onReset", function () {
            _this.state.signaturePad.clear();

            _this.onChange();
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onUndo", function () {
            var data = toConsumableArray_default()(_this.state.signaturePad.toData());

            if (data) {
              data.pop(); // remove the last dot or line

              _this.state.signaturePad.fromData(data);

              _this.onChange();
            }
          });
          _this.state = {
            signaturePad: undefined,
            canvas: undefined
          };
          _this.debouncedupdateDimensions = debounce_default()(_this.updateDimensions, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          return _this;
        }

        createClass_default()(DigitalSignatureContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.state.canvas = document.getElementById(this.props.inputId);
            this.updateDimensions();

            if (this.props.readOnly) {
              this.state.signaturePad.off();
            }

            if (this.props.fieldId) {
              this.props.registerValidator(this.validator, this.props.fieldId, constants["Validator"].Empty, false);
            }

            window.addEventListener('resize', this.debouncedupdateDimensions);
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            window.removeEventListener('resize', this.debouncedupdateDimensions);
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props = this.props,
                className = _this$props.className,
                description = _this$props.description,
                errorMessage = _this$props.errorMessage,
                id = _this$props.id,
                inputId = _this$props.inputId,
                label = _this$props.label,
                optionalSuffixLabel = _this$props.optionalSuffixLabel,
                required = _this$props.required,
                requiredSuffixLabel = _this$props.requiredSuffixLabel,
                showError = _this$props.showError,
                showLabel = _this$props.showLabel,
                showOptionalSuffixLabel = _this$props.showOptionalSuffixLabel,
                showRequiredSuffixLabel = _this$props.showRequiredSuffixLabel;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              id: id,
              className: classnames_default()('formatic-digital-signature', defineProperty_default()({}, className, className))
            }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              labelFor: inputId,
              className: "formatic-field-label formatic-digital-signature__label",
              label: label,
              isRequired: required,
              optionalSuffixLabel: optionalSuffixLabel,
              requiredSuffixLabel: requiredSuffixLabel,
              showOptionalSuffixLabel: showOptionalSuffixLabel,
              showRequiredSuffixLabel: showRequiredSuffixLabel,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-digital-signature__description",
              description: description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["i"
            /* DigitalSignature */
            ], {
              className: "formatic-digital-signature__input",
              id: this.props.inputId,
              onChange: this.onChange,
              onReset: this.onReset,
              onUndo: this.onUndo,
              readOnly: this.props.readOnly,
              enableUndo: this.props.enableUndo,
              enableReset: this.props.enableReset,
              undoLabel: this.props.undoLabel,
              resetLabel: this.props.resetLabel
            }), showError && errorMessage);
          }
        }]);
        return DigitalSignatureContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      DigitalSignatureContainer_DigitalSignatureContainer.defaultProps = {
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        fieldId: '',
        id: Object(utils["k"
        /* getRandomId */
        ])(),
        inputId: Object(utils["k"
        /* getRandomId */
        ])(),
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        registerValidator: noop_default.a,
        showError: true,
        validate: noop_default.a,
        value: {
          path: [],
          value: ''
        },
        // attributes from dashboard
        backgroundColor: 'rbg(255, 255, 255)',
        description: '',
        enableUndo: true,
        enableReset: true,
        label: '',
        penColor: 'rgb (0, 0, 0)',
        readOnly: false,
        resetLabel: 'Reset',
        requiredMessage: constants["DefaultRequiredMessage"],
        required: false,
        showLabel: true,
        undoLabel: 'Undo',
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      DigitalSignatureContainer_DigitalSignatureContainer.propTypes = {
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          path: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        }), external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        showError: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        enableUndo: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        enableReset: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        penColor: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        backgroundColor: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        undoLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        resetLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_DigitalSignatureContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(DigitalSignatureContainer_DigitalSignatureContainer); // EXTERNAL MODULE: ./node_modules/@formatic/form-logic/dist/index.js

      var dist = __webpack_require__(142); // EXTERNAL MODULE: ./src/components/Email.js


      var Email = __webpack_require__(275); // CONCATENATED MODULE: ./src/containers/EmailContainer.js


      var EmailContainer_EmailContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(EmailContainer, _Component);

        function EmailContainer(props) {
          var _this;

          classCallCheck_default()(this, EmailContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(EmailContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "getValueLength", function () {
            return typeof_default()(_this.props.value) === 'object' ? _this.props.value.maskedValue.length : _this.props.value.length;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "shouldTruncateNewValue", function (newValueLength) {
            return _this.props.maxLength > 0 && newValueLength > _this.getValueLength() && newValueLength > _this.props.maxLength;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleTextChange", function (e) {
            var value = e.target.value;

            if (_this.shouldTruncateNewValue(value.length)) {
              value = value.substr(0, _this.props.maxLength);
            }

            _this.changeValueAndValidate(value);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "changeValueAndValidate", function (value) {
            _this.props.changeValue(value, true);

            if (_this.props.realTimeValidation) {
              // need to trigger validate after the fieldUpdateTimeout, otherwise it'll not have the correct value to run the validation
              _this.debouncedValidate();
            }

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].ValueChange);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleBlur", function (event) {
            _this.props.onBlur(event);

            _this.props.validate();

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Blur, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Blur);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleFocus", function (event) {
            _this.props.onFocus(event);

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Focus, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Focus);
          });
          _this.debouncedValidate = debounce_default()(_this.props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          return _this;
        }

        createClass_default()(EmailContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            if (this.props.fieldId) {
              this.props.registerValidator(EmailContainer.validator, this.props.fieldId, constants["Validator"].Custom, false);
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props = this.props,
                autoComplete = _this$props.autoComplete,
                id = _this$props.id,
                showLabel = _this$props.showLabel,
                errorMessage = _this$props.errorMessage,
                label = _this$props.label,
                description = _this$props.description,
                maxLength = _this$props.maxLength,
                className = _this$props.className,
                required = _this$props.required,
                inputId = _this$props.inputId,
                type = _this$props.type,
                readOnly = _this$props.readOnly,
                placeholder = _this$props.placeholder,
                value = _this$props.value,
                optionalSuffixLabel = _this$props.optionalSuffixLabel,
                requiredSuffixLabel = _this$props.requiredSuffixLabel,
                showOptionalSuffixLabel = _this$props.showOptionalSuffixLabel,
                showRequiredSuffixLabel = _this$props.showRequiredSuffixLabel;
            var autoCompleteDisabledValue = src_config["a"
            /* default */
            ].autoCompleteDisabledValue,
                autoCompleteBrowserValue = src_config["a"
            /* default */
            ].autoCompleteBrowserValue;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              id: id,
              className: classnames_default()('formatic-email', defineProperty_default()({}, className, className))
            }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_LabelContainer, {
              labelFor: inputId,
              className: "formatic-field-label formatic-text__label",
              label: label,
              isRequired: required,
              optionalSuffixLabel: optionalSuffixLabel,
              requiredSuffixLabel: requiredSuffixLabel,
              showOptionalSuffixLabel: showOptionalSuffixLabel,
              showRequiredSuffixLabel: showRequiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-text__description",
              description: description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
            /* Text */
            ], {
              autoComplete: autoComplete === autoCompleteDisabledValue ? autoCompleteBrowserValue : autoComplete,
              onChange: this.handleTextChange,
              onBlur: this.handleBlur,
              onFocus: this.handleFocus,
              className: "formatic-text__input",
              id: inputId,
              maxLength: maxLength > 0 ? maxLength : undefined,
              placeholder: placeholder,
              readOnly: readOnly,
              type: type,
              value: value
            }), errorMessage);
          }
        }]);
        return EmailContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      EmailContainer_EmailContainer.validator = function (value) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var props = args[2];
        var invalidText = props.invalidText; // When the value is empty this should render the required message if this was enabled

        var isValid = value.length > 0 ? Object(dist["isEmailValid"])(value) : true;
        var errors = isValid ? {} : {
          value: invalidText || Email["a"
          /* InvalidErrorMessage */
          ]
        };
        return {
          isValid: isValid,
          errors: errors,
          displayErrorMessage: errors.value
        };
      };

      EmailContainer_EmailContainer.defaultProps = {
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        fieldId: '',
        id: Object(utils["k"
        /* getRandomId */
        ])(),
        inputId: Object(utils["k"
        /* getRandomId */
        ])(),
        registerValidator: noop_default.a,
        type: 'email',
        value: '',
        validate: noop_default.a,
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        analyticsParams: {},
        // attributes from dashboard
        description: '',
        label: '',
        maxLength: '',
        placeholder: '',
        realTimeValidation: false,
        readOnly: false,
        required: false,
        showLabel: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      EmailContainer_EmailContainer.propTypes = {
        autoComplete: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        maxLength: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        realTimeValidation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      /* harmony default export */

      var containers_EmailContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(EmailContainer_EmailContainer); // EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js

      var regenerator = __webpack_require__(76);

      var regenerator_default =
      /*#__PURE__*/
      __webpack_require__.n(regenerator); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/asyncToGenerator.js


      var asyncToGenerator = __webpack_require__(104);

      var asyncToGenerator_default =
      /*#__PURE__*/
      __webpack_require__.n(asyncToGenerator); // EXTERNAL MODULE: ./node_modules/lodash/isString.js


      var isString = __webpack_require__(121);

      var isString_default =
      /*#__PURE__*/
      __webpack_require__.n(isString); // CONCATENATED MODULE: ./src/containers/EmailVerificationContainer.js


      var EmailVerificationContainer_API_REQUEST_TIMEOUT = 2000; // 2 seconds

      var EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS = {
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        status: {
          notVerified: 'notVerified',
          sendingVerificationCode: 'sendingVerificationCode',
          verificationCodeSent: 'verificationCodeSent',
          validatingVerificationCode: 'validatingVerificationCode',
          verified: 'verified'
        },
        version: 4
      };

      var EmailVerificationContainer_EmailVerificationContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(EmailVerificationContainer, _Component);

        function EmailVerificationContainer(props) {
          var _this;

          classCallCheck_default()(this, EmailVerificationContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(EmailVerificationContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "validator", function (value, internalFieldKey, isFromPageNavigation) {
            var errors = {};

            if (!Object(dist["isEmailValid"])(value.email)) {
              errors.email = _this.props.invalidEmailAddressErrorMessage;
            }

            if (isEmpty_default()(value.email) && value.status !== EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verified) {
              errors.email = _this.props.emptyEmailAddressErrorMessage;
            }

            if (isEmpty_default()(errors) && isFromPageNavigation && value.status !== EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verified) {
              errors.componentError = _this.props.emailNotVerifiedOnNavigationErrorMessage;
            }

            _this.setState({
              errors: errors
            });

            return {
              isValid: !Object.keys(errors).length,
              errors: errors
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getHeaders", function () {
            return {
              Authorization: "Bearer ".concat(_this.props.apiKey),
              'Content-Type': EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.contentType
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getPostData", function () {
            return {
              branch: _this.props.environment,
              field: _this.props.fieldId,
              form_id: _this.props.formId,
              sessionId: _this.props.submissionId,
              // TODO impact in standardising to submissionId ?
              email: get_default()(_this.props.fields, _this.props.emailToken, '')
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "sendVerificationEmail",
          /*#__PURE__*/
          asyncToGenerator_default()(
          /*#__PURE__*/
          regenerator_default.a.mark(function _callee() {
            var emailValue, data, emailSentTo, response, errors;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    emailValue = get_default()(_this.props, 'value.email', '');

                    if (!isEmpty_default()(emailValue.trim())) {
                      _context.next = 4;
                      break;
                    }

                    _this.setState({
                      errors: {
                        email: _this.props.emptyEmailAddressErrorMessage
                      }
                    });

                    return _context.abrupt("return");

                  case 4:
                    _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                      blockedEmail: true,
                      code: '',
                      status: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.sendingVerificationCode
                    }));

                    data = Object(utils_requestData["c"
                    /* queryEncode */
                    ])(_this.getPostData()); // getting the email value here in order to make sure that we know what the user has type at this point (since the user could change it)

                    emailSentTo = _this.props.value.email;
                    _context.prev = 7;
                    _context.next = 10;
                    return new Promise(function (resolve, reject) {
                      setTimeout(function () {
                        reject(new Error('timeout'));
                      }, EmailVerificationContainer_API_REQUEST_TIMEOUT);
                      resolve(Object(utils_requestData["d"
                      /* requestData */
                      ])({
                        method: 'post',
                        url: "".concat(src_config["a"
                        /* default */
                        ].getApiServer(), "/verification/callback"),
                        data: data,
                        headers: _this.getHeaders()
                      }));
                    });

                  case 10:
                    response = _context.sent;
                    errors = {};

                    if (response.data.success) {
                      _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                        status: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verificationCodeSent,
                        emailSentTo: emailSentTo
                      }));
                    } else {
                      if (response.data.message === 'The tokenised value could not be found' || response.data.message === 'No token to validate against. Confirm field settings') {
                        errors.sendEmail = _this.props.checkValidateAgainstMessage;
                      } else {
                        errors.sendEmail = response.data.message.split('.')[0] || _this.props.genericAPIErrorMessage;
                      }

                      _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                        blockedEmail: false,
                        status: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified
                      }));
                    } // need to remove any componentError since the user interacted with the component
                    // otherwise it'll continue to show a componentError in the bottom of this component


                    _this.setState({
                      errors: objectSpread_default()({}, _this.state.errors, {
                        componentError: undefined
                      }, errors)
                    });

                    _context.next = 20;
                    break;

                  case 16:
                    _context.prev = 16;
                    _context.t0 = _context["catch"](7);

                    if (_context.t0 === 'timeout') {
                      _this.setState({
                        errors: {
                          sendEmail: _this.props.apiTimeoutErrorMessage
                        }
                      });
                    } else {
                      _this.setState({
                        errors: {
                          sendEmail: _this.props.serverUnavailableErrorMessage
                        }
                      });
                    }

                    _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                      status: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified
                    }));

                  case 20:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[7, 16]]);
          })));
          defineProperty_default()(assertThisInitialized_default()(_this), "changeEmailAddress", function () {
            _this.setState({
              errors: {}
            });

            _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
              blockedEmail: false,
              checksum: '',
              code: '',
              email: '',
              emailSentTo: '',
              status: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified,
              verifiedEmail: '',
              version: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.version
            }));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "verifyCode",
          /*#__PURE__*/
          asyncToGenerator_default()(
          /*#__PURE__*/
          regenerator_default.a.mark(function _callee2() {
            var data, verifiedEmail, response, dataResponse;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (get_default()(_this.props, 'value.code.length', 0)) {
                      _context2.next = 3;
                      break;
                    }

                    _this.setState({
                      errors: {
                        code: _this.props.emptyVerificationCodeErrorMessage
                      }
                    });

                    return _context2.abrupt("return");

                  case 3:
                    _this.setState({
                      errors: {}
                    });

                    data = Object(utils_requestData["c"
                    /* queryEncode */
                    ])(objectSpread_default()({}, _this.getPostData(), {
                      code: _this.props.value.code
                    })); // getting the email value here in order to make sure that we know what the user has type at this point (since the user could change it)

                    verifiedEmail = _this.props.value.email;

                    _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                      status: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.validatingVerificationCode
                    }));

                    _context2.next = 9;
                    return Object(utils_requestData["d"
                    /* requestData */
                    ])({
                      url: "".concat(src_config["a"
                      /* default */
                      ].getApiServer(), "/verification/verify"),
                      data: data,
                      method: 'post',
                      headers: _this.getHeaders()
                    });

                  case 9:
                    response = _context2.sent;
                    dataResponse = get_default()(response, 'data.success');

                    if (!(dataResponse === true)) {
                      _context2.next = 16;
                      break;
                    }

                    _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                      checksum: get_default()(response, 'data.verificationCode', ''),
                      status: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verified,
                      verifiedEmail: verifiedEmail,
                      version: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.version
                    }));

                    _this.debouncedValidate();

                    _context2.next = 20;
                    break;

                  case 16:
                    if (!(typeof dataResponse === 'undefined')) {
                      _context2.next = 20;
                      break;
                    } // An unknown response was sent back by the server


                    _this.setState({
                      errors: {
                        code: _this.props.unknownVerificationErrorMessage
                      }
                    });

                    _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                      status: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified
                    }));

                    return _context2.abrupt("return");

                  case 20:
                    if (!response.data.success) {
                      _this.setState({
                        errors: {
                          code: _this.props.invalidCodeErrorMessage
                        }
                      });

                      _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                        status: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified
                      }));
                    }

                  case 21:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })));
          defineProperty_default()(assertThisInitialized_default()(_this), "handleCodeChangeValue", function (event) {
            var value = event.target.value;

            _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
              code: value
            }));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleEmailChangeValue", function (event) {
            var value = event.target.value;
            var status = _this.props.value.status;

            _this.setState({
              errors: {}
            });

            _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
              code: ''
            }));

            if (!isEmpty_default()(_this.props.value.verifiedEmail) && isEqual_default()(_this.props.value.verifiedEmail, value) && _this.props.value.status !== EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verified) {
              status = EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verified;
            } else if (!isEmpty_default()(_this.props.value.emailSentTo)) {
              if (isEqual_default()(_this.props.value.emailSentTo, value) && _this.props.value.status !== EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verificationCodeSent) {
                status = EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verificationCodeSent;
              }

              if (!isEqual_default()(_this.props.value.emailSentTo, value) && _this.props.value.status !== EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified) {
                status = EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified;
              }
            }

            _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
              email: value,
              status: status
            }));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getSendEmailButton", function (status, sendEmailLabel) {
            if (status !== EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verified && status !== EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.validatingVerificationCode) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
                className: "formatic-email-verification__send-email-container"
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["e"
              /* Button */
              ], {
                className: "formatic-email-verification__send-button",
                label: status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.sendingVerificationCode ? _this.props.sendingEmailMessageText : sendEmailLabel,
                onClick: _this.sendVerificationEmail,
                disabled: status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.sendingVerificationCode || status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.validatingVerificationCode
              }));
            }

            return '';
          });
          _this.state = {
            errors: {}
          };

          if (isString_default()(_this.props.value.email) && _this.props.value.email.length > 0) {
            _this.props.validate();
          }

          _this.debouncedValidate = debounce_default()(_this.props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          return _this;
        }

        createClass_default()(EmailVerificationContainer, [{
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate(nextProps) {
            var didFieldsPropUpdate = !isEqual_default()(nextProps.fields, this.props.fields);

            if (didFieldsPropUpdate) {
              var didEmailTokenUpdate = get_default()(nextProps.fields, this.props.emailToken, '') !== get_default()(this.props.fields, this.props.emailToken, '');
              return didEmailTokenUpdate;
            }

            return true;
          }
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            var _this2 = this;

            this.props.registerValidator(this.validator, get_default()(this.props, 'fieldId'), constants["Validator"].Custom, true); // if we've got the email address already, we sent the email directly

            var prepopulatedEmail = get_default()(this.props.fields, this.props.emailToken, '');

            if (prepopulatedEmail) {
              this.props.changeValue(objectSpread_default()({}, this.props.value, {
                email: prepopulatedEmail
              }), false, {}, function () {
                var userChangedSendingEmailAddress = _this2.props.value.email !== _this2.props.value.emailSentTo && (_this2.props.value.status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verificationCodeSent || _this2.props.value.status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.sendingVerificationCode);

                if (_this2.props.value.status === '' || _this2.props.value.status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified || userChangedSendingEmailAddress) {
                  _this2.sendVerificationEmail();
                }
              });
            }
          }
        }, {
          key: "render",
          value: function render() {
            var status = this.props.value.status || EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified;
            var inputInvalidVerificationCodeAfterSentEmail = status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified && isString_default()(this.state.errors.code) && this.state.errors.code.length > 0;
            var sendEmailLabel = status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verificationCodeSent || inputInvalidVerificationCodeAfterSentEmail ? this.props.resendButtonText : this.props.sendButtonText;
            var hasPopulatedEmailAddress = get_default()(this.props.fields, this.props.emailToken, '') !== '';
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-email-verification', {
                'formatic-field-error': this.state.errors.componentError,
                'formatic-field-valid': !this.state.errors.componentError && status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verified
              })
            }, !hasPopulatedEmailAddress && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", null, this.props.showLabel && this.props.label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              className: "formatic-field-label formatic-email-verification__label",
              labelFor: this.props.inputId,
              label: this.props.label,
              isRequired: this.props.required,
              optionalSuffixLabel: this.props.optionalSuffixLabel,
              requiredSuffixLabel: this.props.requiredSuffixLabel,
              showOptionalSuffixLabel: this.props.showOptionalSuffixLabel,
              showRequiredSuffixLabel: this.props.showRequiredSuffixLabel,
              suffixLabel: this.props.required && this.props.showRequiredSuffixLabel && this.props.requiredSuffixLabel
            }), this.props.description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-email-verification__description",
              description: this.props.description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-email-verification__email-container', {
                'formatic-field-error': this.state.errors.email || this.state.errors.sendEmail,
                'formatic-field-valid': !this.state.errors.email && !isEmpty_default()(this.props.value.email) && !this.state.errors.sendEmail,
                'formatic-email-verification__email-sending': status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.sendingVerificationCode
              })
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-email-verification__email-field-container', {
                'formatic-email-verification__email-sending': status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.sendingVerificationCode
              })
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
            /* Text */
            ], {
              placeholder: this.props.placeholder,
              className: "formatic-email-verification__email",
              onChange: this.handleEmailChangeValue,
              value: this.props.value.email,
              readOnly: this.props.value.blockedEmail
            }), this.state.errors.email && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: this.state.errors.email
            }), this.state.errors.Email && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: this.state.errors.sendEmail
            })), this.getSendEmailButton(status, sendEmailLabel), this.props.value.status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verificationCodeSent && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-email-verification__sent-success"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("p", null, this.props.emailMessageSentText)), status !== EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.sendingVerificationCode && status !== EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.validatingVerificationCode && this.props.value.blockedEmail === true && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-email-verification__change-email-container"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["e"
            /* Button */
            ], {
              className: "formatic-email-verification__change-email-button",
              label: this.props.changeEmailButtonText,
              onClick: this.changeEmailAddress,
              disabled: status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.validatingVerificationCode
            })))), status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.sendingVerificationCode && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(FormLoading["a"
            /* default */
            ], {
              loadingText: ""
            }), (status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verificationCodeSent || status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.validatingVerificationCode || inputInvalidVerificationCodeAfterSentEmail) && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-email-verification__sent-container"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-email-verification__sent', {
                'formatic-field-error': this.state.errors.code
              })
            }, hasPopulatedEmailAddress && this.props.value.status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verificationCodeSent && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-email-verification__sent-success"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("p", null, this.props.emailMessageSentTextForEmailToken)), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              label: this.props.verificationCodeText,
              className: "formatic-email-verification__code-label"
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
            /* Text */
            ], {
              className: "formatic-email-verification__code-input",
              value: this.props.value.code,
              onChange: this.handleCodeChangeValue,
              readOnly: status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.validatingVerificationCode
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-email-verification__code-button"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["e"
            /* Button */
            ], {
              className: "formatic-email-verification__verify-button",
              label: status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.validatingVerificationCode ? this.props.validatingCodeText : this.props.verificationButtonText,
              onClick: this.verifyCode,
              disabled: isEmpty_default()(this.props.value.code) || status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.validatingVerificationCode
            })), hasPopulatedEmailAddress && this.getSendEmailButton(status, sendEmailLabel)), this.state.errors.code && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: this.state.errors.code
            })), status === EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.verified && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-email-verification__verified"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("p", null, this.props.successfullyVerifiedText)), this.state.errors.componentError && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: this.state.errors.componentError
            }));
          }
        }]);
        return EmailVerificationContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      EmailVerificationContainer_EmailVerificationContainer.toSummaryNode = function (_ref3) {
        var email = _ref3.email,
            status = _ref3.status;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Fragment, null, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-item-advanced__row"
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("span", {
          className: "formatic-review-table-item__label formatic-review-table-item-advanced__label"
        }, "Status:"), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("span", {
          className: "formatic-review-table-item-advanced__value"
        }, Object(utils["b"
        /* formatWord */
        ])(status))), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-item-advanced__row"
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("span", {
          className: "formatic-review-table-item__label formatic-review-table-item-advanced__label"
        }, "Email:"), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("span", {
          className: "formatic-review-table-item-advanced__value"
        }, email)));
      };

      EmailVerificationContainer_EmailVerificationContainer.toSummaryNode.propTypes = {
        email: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        status: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired
      };
      EmailVerificationContainer_EmailVerificationContainer.defaultProps = {
        emailMessageSentTextForEmailToken: 'Email message successfully sent',
        changeValue: noop_default.a,
        checkValidateAgainstMessage: 'The information to be validated can not be found',
        emailRequired: true,
        environment: '',
        fieldId: '',
        fields: {},
        formId: 0,
        genericAPIErrorMessage: 'Something went wrong, please try again later!',
        inputId: '',
        registerValidator: noop_default.a,
        submissionId: '',
        validate: noop_default.a,
        value: {
          blockedEmail: false,
          checksum: '',
          code: '',
          email: '',
          emailSentTo: '',
          status: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.status.notVerified,
          verifiedEmail: '',
          version: EmailVerificationContainer_EMAIL_VERIFICATION_CONSTANTS.version
        },
        // attributes from dashboard
        apiTimeoutErrorMessage: 'Connection timed out',
        changeEmailButtonText: 'Change email address',
        description: '',
        emailToken: '',
        emptyEmailAddressErrorMessage: 'The email address can not be empty',
        emptyVerificationCodeErrorMessage: 'Please enter the verification code',
        invalidCodeErrorMessage: 'The verification code you entered was incorrect',
        invalidEmailAddressErrorMessage: 'The email address you untered was incorrect',
        label: '',
        emailNotVerifiedOnNavigationErrorMessage: 'You must go through email verification before continue',
        placeholder: '',
        sendButtonText: 'Send Email',
        sendingEmailMessageText: 'Sending...',
        emailMessageSentText: 'Email message successfully sent',
        serverUnavailableErrorMessage: 'Sorry, the email verification service is not available, please try again later',
        showLabel: true,
        successfullyVerifiedText: 'Successfully verified',
        resendButtonText: 'Re-send Email',
        required: true,
        validatingCodeText: 'Validating your code, please wait',
        verificationButtonText: 'Verify',
        verificationCodeText: 'Verification code',
        unknownVerificationErrorMessage: 'An unknown error occurred during verification',
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      EmailVerificationContainer_EmailVerificationContainer.propTypes = {
        apiKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        checkValidateAgainstMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        environment: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        formId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        emailRequired: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        emailToken: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        submissionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          blockedEmail: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          checksum: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          code: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          email: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          emailSentTo: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          status: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          verifiedEmail: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          version: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
        }),
        // attributes from dashboard
        apiTimeoutErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        changeEmailButtonText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        emailNotVerifiedOnNavigationErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        emailMessageSentText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        emailMessageSentTextForEmailToken: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        genericAPIErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        invalidCodeErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        invalidEmailAddressErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        emptyEmailAddressErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        emptyVerificationCodeErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        resendButtonText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        sendButtonText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        sendingEmailMessageText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        serverUnavailableErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        successfullyVerifiedText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        unknownVerificationErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        validatingCodeText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        verificationButtonText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        verificationCodeText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };

      var EmailVerificationContainer_mapStateToProps = function mapStateToProps(_ref4) {
        var _ref4$formatic = _ref4.formatic,
            apiKey = _ref4$formatic.apiKey,
            environment = _ref4$formatic.environment,
            formId = _ref4$formatic.formId,
            submissionId = _ref4$formatic.submissionId,
            fields = _ref4$formatic.tokens.fields;
        return {
          apiKey: apiKey,
          environment: environment,
          fields: fields,
          formId: formId,
          submissionId: submissionId
        };
      };
      /* harmony default export */


      var containers_EmailVerificationContainer = Object(Recompose["a"
      /* compose */
      ])(Object(es["a"
      /* connect */
      ])(EmailVerificationContainer_mapStateToProps), withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(EmailVerificationContainer_EmailVerificationContainer); // EXTERNAL MODULE: ./node_modules/antd/lib/message/index.js

      var lib_message = __webpack_require__(227);

      var message_default =
      /*#__PURE__*/
      __webpack_require__.n(lib_message); // EXTERNAL MODULE: ./node_modules/lodash/isArray.js


      var isArray = __webpack_require__(55);

      var isArray_default =
      /*#__PURE__*/
      __webpack_require__.n(isArray); // CONCATENATED MODULE: ./src/containers/FileUploadContainer.js


      var FileUploadContainer_imageDataAsURLTimeoutFrequencyInMs = 100; // 100ms is enougth to generate the imageDataAsURL and save it locally

      var FileUploadContainer_FileUploadContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(FileUploadContainer, _Component);

        function FileUploadContainer(props) {
          var _this;

          classCallCheck_default()(this, FileUploadContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(FileUploadContainer).call(this, props)); // Saving the pageId here because now currentPage is the page where this FileUpload field is in.
          // If the user is in a single page form and clicks next, then currentPage will be a different pageId

          defineProperty_default()(assertThisInitialized_default()(_this), "getFileExtension", function () {
            var fileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            return fileName.substr(fileName.lastIndexOf('.') + 1);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "processImageDataAsURL", function (file) {
            var dataObj = {
              form_id: _this.props.formId,
              page_id: _this.state.pageId,
              file: {
                filename: file.name,
                extension: _this.getFileExtension(file.name),
                size: file.size,
                field_id: _this.props.fieldId,
                contents: encodeURIComponent(_this.imageDataAsURL)
              }
            };

            var getStringifiedObject = function getStringifiedObject(obj) {
              var subElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var parentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
              return Object.keys(obj).map(function (key) {
                if (typeof_default()(obj[key]) === 'object') {
                  return getStringifiedObject(obj[key], true, key);
                }

                var keyPart = subElement ? "".concat(parentName, "%5B").concat(key, "%5D") : key;
                return "".concat(keyPart, "=").concat(obj[key]);
              }).join('&');
            };

            return getStringifiedObject(dataObj);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "uploadFile", function (data) {
            return Object(utils_requestData["d"
            /* requestData */
            ])({
              method: 'post',
              url: "".concat(src_config["a"
              /* default */
              ].getApiServer(), "/page/store-upload"),
              headers: {
                Authorization: "Bearer ".concat(_this.props.apiKey),
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              },
              data: data
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getMaxFileSizeInKb", function () {
            return _this.props.maxFileSize;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getFileSizeInKb", function () {
            var sizeInBytes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            return parseInt(sizeInBytes / 1000, 10);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "customRequest", function (_ref) {
            var onSuccess = _ref.onSuccess,
                file = _ref.file;

            if (_this.getFileSizeInKb(file.size) < _this.getMaxFileSizeInKb()) {
              _this.checkInfo(onSuccess, file);
            } else if (!_this.props.hideFailedFiles) {
              _this.props.changeValue(_this.props.value.concat([{
                extension: _this.getFileExtension(file.name),
                field_id: _this.props.fieldId,
                filename: file.name,
                size: file.size,
                upload_id: '',
                uid: file.uid,
                status: 'error'
              }]));
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "checkInfo", function (onSuccess, file) {
            setTimeout(function () {
              if (!_this.imageDataAsURL) {
                // check file status to avoid infinite loop
                if (file.status !== undefined) {
                  _this.checkInfo(onSuccess, file);
                } else if (!_this.props.hideFailedFiles) {
                  _this.props.changeValue(_this.props.value.concat([{
                    extension: _this.getFileExtension(file.name),
                    field_id: _this.props.fieldId,
                    filename: file.name,
                    size: file.size,
                    upload_id: _this.uploadId,
                    uid: file.uid,
                    status: 'error'
                  }]));
                }
              } else {
                var data = _this.processImageDataAsURL(file);

                _this.uploadFile(data).then(function (apiData) {
                  var uploadId = get_default()(apiData, 'data.submission_values.upload_id.$id', '');

                  _this.props.changeValue(_this.props.value.concat([{
                    extension: _this.getFileExtension(file.name),
                    field_id: _this.props.fieldId,
                    filename: file.name,
                    size: file.size,
                    upload_id: uploadId,
                    uid: file.uid,
                    status: 'done'
                  }]));

                  onSuccess(null, file);

                  _this.props.validate();
                }).catch(function () {// TODO: do something here
                });
              }
            }, FileUploadContainer_imageDataAsURLTimeoutFrequencyInMs);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "uploadingFileValidation", function (info) {
            var extension = _this.getFileExtension(info.file.name); // TODO: replace "tempWhileServerIsChanged" by "this.props.fileTypes" once the server is updated and fileTypes is an array


            var tempWhileServerIsChanged = _this.props.fileTypes.split(',').filter(function (item) {
              return !isEmpty_default()(item);
            });

            var fileSize = _this.getFileSizeInKb(info.file.size);

            if (tempWhileServerIsChanged.length > 0 && tempWhileServerIsChanged.indexOf(extension) < 0) {
              var acceptedFileTypes = tempWhileServerIsChanged.reduce(function (acc, type, index) {
                if (index + 2 < tempWhileServerIsChanged.length) {
                  return "".concat(acc).concat(type, ", ");
                } else if (index + 1 < tempWhileServerIsChanged.length) {
                  return "".concat(acc).concat(type, " or "); // penultimate item
                }

                return "".concat(acc).concat(type); // last item
              }, '');
              message_default.a.error("The ".concat(extension, " is not a valid extension. Accepted file types: ").concat(acceptedFileTypes, "."));
              return false;
            } else if (fileSize > _this.getMaxFileSizeInKb()) {
              var format = function format(number) {
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              };

              message_default.a.error("".concat(info.file.name, " has ").concat(format(fileSize), "Kb and max file size allowed is ").concat(format(_this.getMaxFileSizeInKb()), "Kb."));
              return false;
            }

            return true;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onChange", function (info) {
            // TODO: show the ant design progress bar for the file upload. current status is in 'info.file.status'
            if (info.file.status === 'uploading') {
              var fileValidationResult = _this.uploadingFileValidation(info);

              if (fileValidationResult) {
                // FileReader is partially supported by IE11, we might need to use polyfill
                var reader = new window.FileReader();

                reader.onloadend = function (obj) {
                  // save the output of reader into 'this.imageDataAsURL' so 'customRequest' function can access it
                  _this.imageDataAsURL = obj.srcElement.result;
                };

                reader.readAsDataURL(info.file.originFileObj);
              }
            } else if (info.file.status === 'done') {
              message_default.a.success("".concat(info.file.name, " file uploaded successfully."));
            } else if (info.file.status === 'error') {
              message_default.a.error("".concat(info.file.name, " file upload failed."));
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getFileListFromValue", function () {
            if (isEmpty_default()(_this.props.value)) {
              return null;
            }

            return _this.props.value.map(function (file) {
              return {
                uid: file.uid,
                name: file.filename,
                status: file.status,
                // TODO: fill the url of the uploaded file so the user can click on it and open a new tab with the file url.
                // TODO: make this configurable through the dashboard.
                url: ''
              };
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onRemove", function (removedFile) {
            _this.props.changeValue(_this.props.value.filter(function (file) {
              return file.uid !== removedFile.uid;
            })); // TODO: do we want to delete the file on server through an API call ? the latest decision was "not yet".

          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleBlur", function (event) {
            _this.props.onBlur(event);

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Blur, _this.props.analyticsParams);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleFocus", function (event) {
            _this.props.onFocus(event);

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Focus, _this.props.analyticsParams);
          });
          _this.state = {
            pageId: get_default()(props.currentPage, "[".concat(props.channel, "].pageId"), '')
          };
          return _this;
        }

        createClass_default()(FileUploadContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            if (this.props.fieldId) {
              this.props.registerValidator(FileUploadContainer.validator, this.props.fieldId, constants["Validator"].Custom, false);
            }
          }
        }, {
          key: "render",
          value: function render() {
            var singleFileUpload = this.props.multiple !== true;
            var isButtonDisabled = singleFileUpload && this.props.value.length > 0;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-file-upload', defineProperty_default()({}, this.props.className, this.props.className))
            }, this.props.showLabel && this.props.label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_LabelContainer, {
              labelFor: this.props.inputId,
              className: "formatic-field-label formatic-file-upload__label",
              label: this.props.label,
              isRequired: this.props.required,
              optionalSuffixLabel: this.props.optionalSuffixLabel,
              requiredSuffixLabel: this.props.requiredSuffixLabel,
              showOptionalSuffixLabel: this.props.showOptionalSuffixLabel,
              showRequiredSuffixLabel: this.props.showRequiredSuffixLabel,
              suffixLabel: this.props.required && this.props.showRequiredSuffixLabel && this.props.requiredSuffixLabel
            }), this.props.description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-file-upload__description",
              description: this.props.description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["n"
            /* FileUpload */
            ], {
              className: "formatic-file-upload__upload",
              name: "file",
              customRequest: this.customRequest,
              onChange: this.onChange,
              fileList: this.getFileListFromValue(),
              onRemove: this.onRemove,
              onBlur: this.handleBlur,
              onFocus: this.handleFocus,
              isButtonDisabled: isButtonDisabled,
              button: ButtonContainer["a"
              /* default */
              ],
              buttonLabel: this.props.buttonLabel
            }), this.props.errorMessage);
          }
        }]);
        return FileUploadContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      FileUploadContainer_FileUploadContainer.validator = function (value) {
        var isValid = isArray_default()(value) && (value.length === 0 || value.find(function (file) {
          return file.status === 'done';
        }));
        var errors = isValid ? {} : {
          value: 'You have entered an invalid document.'
        };
        return {
          isValid: isValid,
          errors: errors,
          displayErrorMessage: errors.value
        };
      };

      FileUploadContainer_FileUploadContainer.defaultProps = {
        analyticsParams: {},
        apiKey: null,
        className: '',
        changeValue: noop_default.a,
        channel: '',
        currentPage: {},
        errorMessage: null,
        fieldId: '',
        formId: 0,
        inputId: '',
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        registerValidator: noop_default.a,
        sendAnalytics: noop_default.a,
        validate: noop_default.a,
        value: [],
        // attributes from dashboard
        buttonLabel: 'Click to Upload',
        description: '',
        fileTypes: '',
        hideFailedFiles: false,
        label: '',
        multiple: true,
        maxFileSize: 2 * 1024,
        // default is 2mb
        required: true,
        showLabel: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      FileUploadContainer_FileUploadContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        apiKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        currentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        formId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          extension: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          field_id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          filename: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          size: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          status: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          upload_id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          uid: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        })),
        // attributes from dashboard
        buttonLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fileTypes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // TODO: change this once the server is changed to return an array
        hideFailedFiles: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        maxFileSize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        // maxFileSize in Kb
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_FileUploadContainer = Object(Recompose["a"
      /* compose */
      ])(Object(es["a"
      /* connect */
      ])(function (_ref2) {
        var _ref2$formatic = _ref2.formatic,
            apiKey = _ref2$formatic.apiKey,
            channel = _ref2$formatic.channel,
            currentPage = _ref2$formatic.currentPage,
            formId = _ref2$formatic.formId;
        return {
          apiKey: apiKey,
          channel: channel,
          currentPage: currentPage,
          formId: formId
        };
      }), withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(FileUploadContainer_FileUploadContainer); // CONCATENATED MODULE: ./src/containers/HeadingContainer.js

      var HeadingContainer_mapping;
      var HeadingContainer_FORM_HEADING = 'form-heading';
      var HeadingContainer_MAIN_PAGE = 'main-page';
      var HeadingContainer_SUB_PAGE = 'sub-page';
      var HeadingContainer_SECTION = 'section';
      var HeadingContainer_SUB_SECTION = 'sub-section';
      var containers_HeadingContainer_mapping = (HeadingContainer_mapping = {}, defineProperty_default()(HeadingContainer_mapping, HeadingContainer_FORM_HEADING, 'h1'), defineProperty_default()(HeadingContainer_mapping, HeadingContainer_MAIN_PAGE, 'h2'), defineProperty_default()(HeadingContainer_mapping, HeadingContainer_SUB_PAGE, 'h3'), defineProperty_default()(HeadingContainer_mapping, HeadingContainer_SECTION, 'h4'), defineProperty_default()(HeadingContainer_mapping, HeadingContainer_SUB_SECTION, 'h5'), HeadingContainer_mapping);

      var HeadingContainer_HeadingContainer = function HeadingContainer(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["p"
        /* Heading */
        ], {
          className: classnames_default()(defineProperty_default()({}, props.className, props.className)),
          headingLevel: containers_HeadingContainer_mapping[props.headingLevel] || 'h1',
          label: props.label
        });
      };

      HeadingContainer_HeadingContainer.defaultProps = {
        className: 'formatic-heading',
        // attributes from dashboard
        label: '',
        headingLevel: HeadingContainer_FORM_HEADING
      };
      HeadingContainer_HeadingContainer.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // attributes from dashboard
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        headingLevel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf([HeadingContainer_FORM_HEADING, HeadingContainer_MAIN_PAGE, HeadingContainer_SUB_PAGE, HeadingContainer_SECTION, HeadingContainer_SUB_SECTION])
      };
      /* harmony default export */

      var containers_HeadingContainer = Object(withFieldToken["a"
      /* default */
      ])()(HeadingContainer_HeadingContainer); // CONCATENATED MODULE: ./src/containers/ImageContainer.js

      var ImageContainer_ImageContainer = function ImageContainer(props) {
        var showLabel = props.showLabel,
            label = props.label;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-image"
        }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_LabelContainer, {
          className: "formatic-field-label formatic-image__label",
          label: label
        }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["q"
        /* Image */
        ], {
          alt: props.alt,
          className: "formatic-image__img",
          height: props.height,
          url: props.url,
          width: props.width
        }));
      };

      ImageContainer_ImageContainer.defaultProps = {
        alt: '',
        height: '',
        width: '',
        label: '',
        showLabel: true
      };
      ImageContainer_ImageContainer.propTypes = {
        // attributes from dashboard
        alt: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        url: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        height: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        width: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_ImageContainer = ImageContainer_ImageContainer; // CONCATENATED MODULE: ./src/containers/PasswordContainer.js

      var PasswordContainer_PasswordContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(PasswordContainer, _Component);

        function PasswordContainer(props) {
          var _this;

          classCallCheck_default()(this, PasswordContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(PasswordContainer).call(this, props)); // TODO: once componentDidMount is removed, follow approach in DropdownContainer to make debouncedValidate

          defineProperty_default()(assertThisInitialized_default()(_this), "validator", function (value) {
            var displayErrorMessage = '';

            if (!_this.props.required) {
              return {
                isValid: true,
                displayErrorMessage: displayErrorMessage
              };
            }

            var isValid = value.length > 0;

            if (!isValid) {
              displayErrorMessage = _this.props.requiredMessage;
            }

            var minSize = parseInt(_this.props.minLength, 10);

            if (isValid && minSize > 0 && value.length < minSize) {
              displayErrorMessage = constants["DefaultTooSmallMessage"].replace('{0}', minSize);
            }

            return {
              isValid: isValid,
              displayErrorMessage: displayErrorMessage
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "shouldTruncateNewValue", function (newValueLength) {
            return _this.props.maxLength > 0 && newValueLength > _this.props.value.length && newValueLength > _this.props.maxLength;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "changeValueAndValidate", function (value) {
            _this.props.changeValue(value, true);

            if (_this.props.realTimeValidation) {
              // need to trigger validate after the fieldUpdateTimeout, otherwise it'll not have the correct value to run the validation
              _this.debouncedValidate();
            }

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].ValueChange);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleTextChange", function (e) {
            var value = e.target.value;

            if (_this.shouldTruncateNewValue(value.length)) {
              value = value.substr(0, _this.props.maxLength);
            }

            _this.changeValueAndValidate(value);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleBlur", function (event) {
            _this.props.onBlur(event);

            _this.props.validate();

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Blur, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Blur);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleFocus", function (event) {
            _this.props.onFocus(event);

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Focus, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Focus);
          });
          _this.debouncedValidate = debounce_default()(_this.props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          return _this;
        }

        createClass_default()(PasswordContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            // TODO: create a file with the mapping of all components and validators
            //       so this can be done in the FieldContainer instead of doing it here
            //       once that's done, then PasswordContainer can be stateless
            if (this.props.fieldId) {
              this.props.registerValidator(this.validator, this.props.fieldId, constants["Validator"].Empty, false);
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props = this.props,
                id = _this$props.id,
                showLabel = _this$props.showLabel,
                showError = _this$props.showError,
                label = _this$props.label,
                description = _this$props.description,
                maxLength = _this$props.maxLength,
                className = _this$props.className,
                required = _this$props.required,
                inputId = _this$props.inputId,
                type = _this$props.type,
                readOnly = _this$props.readOnly,
                placeholder = _this$props.placeholder,
                value = _this$props.value,
                errorMessage = _this$props.errorMessage,
                optionalSuffixLabel = _this$props.optionalSuffixLabel,
                requiredSuffixLabel = _this$props.requiredSuffixLabel,
                showOptionalSuffixLabel = _this$props.showOptionalSuffixLabel,
                showRequiredSuffixLabel = _this$props.showRequiredSuffixLabel;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              id: id,
              className: classnames_default()('formatic-password', defineProperty_default()({}, className, className))
            }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              labelFor: inputId,
              className: "formatic-field-label formatic-password__label",
              label: label,
              isRequired: required,
              optionalSuffixLabel: optionalSuffixLabel,
              requiredSuffixLabel: requiredSuffixLabel,
              showOptionalSuffixLabel: showOptionalSuffixLabel,
              showRequiredSuffixLabel: showRequiredSuffixLabel,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-password__description",
              description: description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
            /* Text */
            ], {
              autoComplete: "off",
              onChange: this.handleTextChange,
              className: "formatic-password__input",
              id: inputId,
              maxLength: maxLength > 0 ? maxLength : undefined,
              onBlur: this.handleBlur,
              onFocus: this.handleFocus,
              placeholder: placeholder,
              readOnly: readOnly,
              type: type,
              value: value
            }), showError && errorMessage);
          }
        }]);
        return PasswordContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      PasswordContainer_PasswordContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        fieldId: '',
        parentFieldId: '',
        id: Object(utils["k"
        /* getRandomId */
        ])(),
        inputId: Object(utils["k"
        /* getRandomId */
        ])(),
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        registerValidator: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        type: 'password',
        validate: noop_default.a,
        value: '',
        // attributes from dashboard
        description: '',
        label: '',
        maxLength: '',
        minLength: '',
        placeholder: '',
        readOnly: false,
        realTimeValidation: false,
        required: false,
        requiredMessage: constants["DefaultRequiredMessage"],
        showLabel: true,
        showError: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      PasswordContainer_PasswordContainer.propTypes = {
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        parentFieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        showError: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        maxLength: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        minLength: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        realTimeValidation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_PasswordContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(PasswordContainer_PasswordContainer); // CONCATENATED MODULE: ./src/containers/RadioListContainer.js

      var RadioListContainer_handleOnFocus = function handleOnFocus(onFocus, sendAnalytics, analyticsInteraction) {
        return function (event) {
          onFocus(event);
          sendAnalytics(analytics["a"
          /* AnalyticsEvents */
          ].Focus, {
            option: event.target.value
          });
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].Focus);
        };
      };

      var RadioListContainer_handleOnBlur = function handleOnBlur(onBlur, validate, sendAnalytics, analyticsInteraction) {
        return function (event) {
          onBlur(event);
          validate();
          sendAnalytics(analytics["a"
          /* AnalyticsEvents */
          ].Blur, {
            option: event.target.value
          });
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].Blur);
        };
      };

      var RadioListContainer_handleOnChange = function handleOnChange(onChange, validate, analyticsInteraction) {
        return function (event) {
          onChange(event.target.value, false);
          validate();
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].ValueChange);
        };
      };

      var RadioListContainer_RadioListContainer = function RadioListContainer(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()('formatic-radio-list', defineProperty_default()({}, props.className, props.className))
        }, props.showLabel && props.label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
        /* Label */
        ], {
          className: "formatic-field-label formatic-radio-list__label",
          label: props.label,
          isRequired: props.required,
          optionalSuffixLabel: props.optionalSuffixLabel,
          requiredSuffixLabel: props.requiredSuffixLabel,
          showOptionalSuffixLabel: props.showOptionalSuffixLabel,
          showRequiredSuffixLabel: props.showRequiredSuffixLabel,
          suffixLabel: props.required && props.showRequiredSuffixLabel && props.requiredSuffixLabel
        }), props.description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
        /* FieldDescription */
        ], {
          className: "formatic-radio-list__description",
          description: props.description
        }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["w"
        /* RadioList */
        ], {
          className: classnames_default()('formatic-radio-list__items-container', {
            'formatic-radio-list__items-container--inline': props.inline
          }),
          id: props.inputId,
          label: components["s"
          /* Label */
          ],
          onBlur: RadioListContainer_handleOnBlur(props.onBlur, props.validate, props.sendAnalytics, props.analyticsInteraction),
          onChange: RadioListContainer_handleOnChange(props.changeValue, props.validate, props.analyticsInteraction),
          onFocus: RadioListContainer_handleOnFocus(props.onFocus, props.sendAnalytics, props.analyticsInteraction),
          options: props.options,
          value: props.value
        }), props.errorMessage);
      };

      RadioListContainer_RadioListContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        inputId: '',
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        validate: noop_default.a,
        value: '',
        // attributes from dashboard
        description: '',
        inline: false,
        label: '',
        options: [],
        required: false,
        showLabel: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      RadioListContainer_RadioListContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inline: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        options: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_RadioListContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(RadioListContainer_RadioListContainer); // CONCATENATED MODULE: ./src/containers/NetPromoterScoreContainer.js

      var NetPromoterScoreContainer_hasValue = function hasValue(value) {
        var numericValue = Number(value);

        if (Number.isNaN(numericValue) || value === null) {
          return false;
        }

        var numericMatch = numericValue.toString() === value.toString();
        return numericMatch && numericValue >= 0;
      };

      var NetPromoterScoreContainer_NetPromoterScoreContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(NetPromoterScoreContainer, _Component);

        function NetPromoterScoreContainer(props) {
          var _this;

          classCallCheck_default()(this, NetPromoterScoreContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(NetPromoterScoreContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "range", function (value) {
            if (!value || value < 0) {
              return [];
            }

            return Array(value + 1).fill().map(function (item, idx) {
              return idx;
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onMouseClick", function () {
            _this.props.changeValue(_this.state.virtualValue.toString());

            _this.props.validate();

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Click, _this.props.analyticsParams);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onMouseEnter", function (virtualValue) {
            _this.setState({
              virtualValue: virtualValue.toString()
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleOnMouseEnter", function (value) {
            return function () {
              return _this.onMouseEnter(value);
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onMouseLeave", function (virtualValue) {
            _this.setState({
              virtualValue: virtualValue.toString()
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleOnMouseLeave", function () {
            return function () {
              return _this.onMouseLeave(_this.props.value);
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "isValid", function () {
            if (NetPromoterScoreContainer_hasValue(_this.props.value) && Number(_this.props.value) <= _this.props.scoreUpTo) {
              return {
                isValid: true,
                displayErrorMessage: ''
              };
            }

            return {
              isValid: true,
              errors: {
                value: 'Invalid Score'
              },
              displayErrorMessage: 'Please enter a score'
            };
          });
          _this.state = {
            virtualValue: props.value.toString()
          };
          return _this;
        }

        createClass_default()(NetPromoterScoreContainer, [{
          key: "componentWillReceiveProps",
          value: function componentWillReceiveProps(newProps) {
            if (newProps.value !== this.props.value) {
              // Value has changed, update virtualValue
              this.setState({
                virtualValue: newProps.value.toString()
              });
            }
          }
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            this.props.registerValidator(this.isValid, this.props.fieldId, constants["Validator"].Custom, false);
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props = this.props,
                description = _this$props.description,
                errorMessage = _this$props.errorMessage,
                hideOnComplete = _this$props.hideOnComplete,
                inputId = _this$props.inputId,
                label = _this$props.label,
                message = _this$props.message,
                negativeDescription = _this$props.negativeDescription,
                positiveDescription = _this$props.positiveDescription,
                required = _this$props.required,
                requiredSuffixLabel = _this$props.requiredSuffixLabel,
                scoreUpTo = _this$props.scoreUpTo,
                showLabel = _this$props.showLabel,
                showRequiredSuffixLabel = _this$props.showRequiredSuffixLabel,
                value = _this$props.value;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-net-promoter-score', {
                'formatic-net-promoter-score--completed': NetPromoterScoreContainer_hasValue(value)
              })
            }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_LabelContainer, {
              labelFor: inputId,
              className: "formatic-field-label formatic-net-promoter-score__label",
              label: label,
              isRequired: required,
              optionalSuffixLabel: this.props.optionalSuffixLabel,
              requiredSuffixLabel: this.props.requiredSuffixLabel,
              showOptionalSuffixLabel: this.props.showOptionalSuffixLabel,
              showRequiredSuffixLabel: this.props.showRequiredSuffixLabel,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-text__description",
              description: description
            }), (!hideOnComplete || !NetPromoterScoreContainer_hasValue(value)) && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["t"
            /* NetPromoterScore */
            ], {
              id: inputId,
              className: "formatic-net-promoter-score__container",
              listOfScores: this.range(scoreUpTo),
              onMouseLeave: this.handleOnMouseLeave,
              onMouseEnter: this.handleOnMouseEnter,
              onMouseClick: this.onMouseClick,
              virtualValue: this.state.virtualValue,
              value: this.props.value,
              buttonLabeIsRequired: this.props.required,
              hasValue: NetPromoterScoreContainer_hasValue(value),
              label: containers_LabelContainer,
              button: ButtonContainer["a"
              /* default */
              ],
              positiveDescription: positiveDescription,
              negativeDescription: negativeDescription
            }), NetPromoterScoreContainer_hasValue(value) && !errorMessage === '' && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-net-promoter-score__message"
            }, message), errorMessage && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-net-promoter-score__error-message"
            }, errorMessage));
          }
        }]);
        return NetPromoterScoreContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      NetPromoterScoreContainer_NetPromoterScoreContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        fieldId: '',
        inputId: '',
        registerValidator: noop_default.a,
        sendAnalytics: noop_default.a,
        value: '',
        validate: noop_default.a,
        // attributes from dashboard
        description: '',
        hideOnComplete: false,
        label: '',
        message: '',
        negativeDescription: '',
        optionalSuffixLabel: '',
        positiveDescription: '',
        required: false,
        requiredSuffixLabel: '',
        scoreUpTo: 2,
        showLabel: true,
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      NetPromoterScoreContainer_NetPromoterScoreContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        hideOnComplete: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        message: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        negativeDescription: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        positiveDescription: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        scoreUpTo: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_NetPromoterScoreContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(NetPromoterScoreContainer_NetPromoterScoreContainer); // CONCATENATED MODULE: ./src/containers/NumericInputContainer.js

      var NumericInputContainer_parsers = {
        dollar: {
          formatter: function formatter(value) {
            return "$ ".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          },
          parser: function parser(value) {
            return value.replace(/\$\s?|(,*)|[0-9]/g, '');
          }
        },
        percentage: {
          formatter: function formatter(value) {
            return "".concat(value, "%");
          },
          parser: function parser(value) {
            return value.replace('%', '');
          }
        },
        default: {
          formatter: function formatter(value) {
            return value;
          },
          parser: function parser(value) {
            return value;
          }
        }
      };

      var NumericInputContainer_NumericInputContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(NumericInputContainer, _Component);

        function NumericInputContainer() {
          var _getPrototypeOf2;

          var _this;

          classCallCheck_default()(this, NumericInputContainer);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(NumericInputContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
          defineProperty_default()(assertThisInitialized_default()(_this), "changeValue", function (value) {
            _this.props.changeValue(value);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].ValueChange);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "addClassOnInput", function () {
            var disable = _this.props.disable;
            var getInputRef = get_default()(_this.inputNumber, 'inputNumberRef.input.classList');

            if (typeof getInputRef === 'undefined') {
              return;
            }

            getInputRef.add('formatic-numeric-input__input');
            getInputRef.add("formatic-numeric-input__input--".concat(_this.props.type));

            if (disable) {
              getInputRef.add('formatic-field-disabled');
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "setInputNumberRef", function (inputNumber) {
            _this.inputNumber = inputNumber;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleBlur", function (event) {
            _this.props.onBlur(event);

            _this.props.validate();

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Blur, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Blur);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleFocus", function (event) {
            _this.props.onFocus(event);

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Focus, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Focus);
          });
          return _this;
        }

        createClass_default()(NumericInputContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            if (this.props.required) {
              this.props.registerValidator(NumericInputContainer.isEmpty, this.props.fieldId, constants["Validator"].Empty, false);
            }

            this.addClassOnInput();
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props = this.props,
                className = _this$props.className,
                description = _this$props.description,
                errorMessage = _this$props.errorMessage,
                inputId = _this$props.inputId,
                label = _this$props.label,
                required = _this$props.required,
                requiredSuffixLabel = _this$props.requiredSuffixLabel,
                showLabel = _this$props.showLabel,
                showRequiredSuffixLabel = _this$props.showRequiredSuffixLabel;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-numeric-input', defineProperty_default()({}, className, className))
            }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              labelFor: inputId,
              className: "formatic-field-label formatic-textarea__label",
              label: label,
              isRequired: required,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-text__description",
              description: description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["u"
            /* NumericInput */
            ], {
              id: inputId,
              refInput: this.setInputNumberRef,
              changeValue: this.changeValue,
              className: "formatic-numeric-input__input-container",
              onBlur: this.handleBlur,
              onFocus: this.handleFocus,
              disable: this.props.disable,
              value: this.props.value,
              min: this.props.min,
              max: this.props.max,
              step: this.props.step,
              placeholder: this.props.placeholder,
              formatter: NumericInputContainer_parsers[this.props.type].formatter,
              parser: NumericInputContainer_parsers[this.props.type].parser
            }), errorMessage);
          }
        }]);
        return NumericInputContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      NumericInputContainer_NumericInputContainer.isEmpty = function (value) {
        var isValid = value.toString().length > 0;
        var displayErrorMessage = '';

        if (!isValid) {
          displayErrorMessage = constants["DefaultRequiredMessage"];
        }

        return {
          isValid: isValid,
          displayErrorMessage: displayErrorMessage
        };
      };

      NumericInputContainer_NumericInputContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        fieldId: '',
        inputId: '',
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        registerValidator: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        validate: noop_default.a,
        value: 0,
        // attributes from dashboard
        description: '',
        disable: false,
        label: '',
        max: 5,
        min: 0,
        optionalSuffixLabel: '',
        placeholder: '',
        required: false,
        requiredSuffixLabel: '',
        showLabel: true,
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false,
        step: 1,
        type: 'default'
      };
      NumericInputContainer_NumericInputContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        disable: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        max: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        min: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        step: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        type: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var containers_NumericInputContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(NumericInputContainer_NumericInputContainer); // CONCATENATED MODULE: ./src/containers/NumericSliderContainer.js

      var NumericSliderContainer_HORIZONTAL_FORMAT = 'horizontal';
      var NumericSliderContainer_VERTICAL_FORMAT = 'vertical';

      var NumericSliderContainer_NumericSliderContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(NumericSliderContainer, _Component);

        function NumericSliderContainer() {
          var _getPrototypeOf2;

          var _this;

          classCallCheck_default()(this, NumericSliderContainer);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(NumericSliderContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
          defineProperty_default()(assertThisInitialized_default()(_this), "changeValue", function (value) {
            _this.props.changeValue(value);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].ValueChange);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "setInputNumberRef", function (inputNumber) {
            _this.inputNumber = inputNumber;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleBlur", function (event) {
            _this.props.onBlur(event);

            _this.props.validate();

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Blur, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Blur);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleFocus", function (event) {
            _this.props.onFocus(event);

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Focus, _this.props.analyticsParams);

            _this.props.analyticsInteraction(analytics["a"
            /* AnalyticsEvents */
            ].Focus);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "marksFilter", function (marks) {
            var _this$props = _this.props,
                step = _this$props.step,
                min = _this$props.min,
                max = _this$props.max;
            var marksValue = marks;

            if (typeof_default()(marksValue) !== 'object') {
              marksValue = {};
            }

            if (Object.keys(marksValue).length > 0) {
              var filteredMarksArray = [];
              Object.keys(marksValue).map(function (key) {
                if (Number(key) % step === 0 && Number(key) >= min && Number(key) <= max) {
                  filteredMarksArray[Number(key)] = marksValue[key];
                }

                return null;
              });
              var filteredMarks = Object.assign({}, filteredMarksArray);
              return filteredMarks;
            }

            return marks;
          });
          return _this;
        }

        createClass_default()(NumericSliderContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            if (this.props.required) {
              this.props.registerValidator(NumericSliderContainer.isEmpty, this.props.fieldId, constants["Validator"].Empty, false);
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props2 = this.props,
                className = _this$props2.className,
                description = _this$props2.description,
                dragOverTicksOnly = _this$props2.dragOverTicksOnly,
                errorMessage = _this$props2.errorMessage,
                format = _this$props2.format,
                inputId = _this$props2.inputId,
                label = _this$props2.label,
                marks = _this$props2.marks,
                max = _this$props2.max,
                min = _this$props2.min,
                required = _this$props2.required,
                requiredSuffixLabel = _this$props2.requiredSuffixLabel,
                showLabel = _this$props2.showLabel,
                showRequiredSuffixLabel = _this$props2.showRequiredSuffixLabel,
                step = _this$props2.step,
                value = _this$props2.value;
            var needsSpaceAboveSlider = showLabel && label || description;
            var verticalSidebar = format === NumericSliderContainer_VERTICAL_FORMAT;
            var conditionalDefaultValue = this.props.default;

            if (this.props.default < min) {
              conditionalDefaultValue = min;
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-numeric-slider', defineProperty_default()({}, className, className))
            }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              labelFor: inputId,
              className: "formatic-field-label formatic-numeric-slider__label",
              label: label,
              isRequired: required,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-numeric-slider__description",
              description: description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-numeric-slider__input-container', {
                'formatic-numeric-slider__input-container-spacing': needsSpaceAboveSlider,
                'formatic-numeric-slider__input-container-vertical': verticalSidebar
              })
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["v"
            /* NumericSlider */
            ], {
              id: inputId,
              refInput: this.setInputNumberRef,
              changeValue: this.changeValue,
              className: "formatic-numeric-slider__input",
              onBlur: this.handleBlur,
              onFocus: this.handleFocus,
              readOnly: this.props.readOnly,
              default: conditionalDefaultValue,
              value: parseFloat(value),
              marks: this.marksFilter(marks),
              max: max,
              min: min,
              step: step,
              vertical: verticalSidebar,
              dragOverTicksOnly: dragOverTicksOnly
            })), errorMessage);
          }
        }]);
        return NumericSliderContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      NumericSliderContainer_NumericSliderContainer.isEmpty = function (value) {
        var isValid = value.toString().length > 0;
        var displayErrorMessage = '';

        if (!isValid) {
          displayErrorMessage = constants["DefaultRequiredMessage"];
        }

        return {
          isValid: isValid,
          displayErrorMessage: displayErrorMessage
        };
      };

      NumericSliderContainer_NumericSliderContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        fieldId: '',
        inputId: '',
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        registerValidator: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        validate: noop_default.a,
        value: 0,
        // attributes from dashboard
        default: 0,
        description: '',
        dragOverTicksOnly: false,
        format: NumericSliderContainer_HORIZONTAL_FORMAT,
        label: '',
        marks: {},
        max: 5,
        min: 0,
        optionalSuffixLabel: '',
        readOnly: false,
        required: false,
        requiredSuffixLabel: '',
        showLabel: true,
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false,
        step: 1
      };
      NumericSliderContainer_NumericSliderContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        // attributes from dashboard
        default: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        dragOverTicksOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        format: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        marks: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        max: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        min: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        step: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
      };
      /* harmony default export */

      var containers_NumericSliderContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(NumericSliderContainer_NumericSliderContainer); // EXTERNAL MODULE: ./node_modules/lodash/times.js

      var times = __webpack_require__(679);

      var times_default =
      /*#__PURE__*/
      __webpack_require__.n(times); // EXTERNAL MODULE: ./node_modules/lodash/random.js


      var random = __webpack_require__(678);

      var random_default =
      /*#__PURE__*/
      __webpack_require__.n(random); // EXTERNAL MODULE: ./node_modules/lodash/startsWith.js


      var startsWith = __webpack_require__(269);

      var startsWith_default =
      /*#__PURE__*/
      __webpack_require__.n(startsWith); // EXTERNAL MODULE: ./src/containers/FieldContainer/FieldContainer.js


      var FieldContainer = __webpack_require__(223); // EXTERNAL MODULE: ./src/core/utils/repeatable.js


      var repeatable = __webpack_require__(282); // CONCATENATED MODULE: ./src/containers/RepeatableContainer.js
      // the flag {iterator} and {index} will be replaced only in the following attributes
      // {iterator} contains a repetitions 1-based index
      // {index} contains a repetitions 0-based index


      var RepeatableContainer_attributesToVerify = ['description', 'helpText', 'helpTextTitle', 'label', 'rich', 'tag']; // {repetitionId} is replaced in logic of fields[index].logic (for every field)

      var RepeatableContainer_addRepetitionTransitionClass = 'formatic-repetition-transition--add';
      var RepeatableContainer_removeRepetitionTransitionClass = 'formatic-repetition-transition--remove';

      var RepeatableContainer_randomKey = function randomKey() {
        var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
        return times_default()(length, function () {
          return random_default()(35).toString(36);
        }).join('');
      };

      var RepeatableContainer_RepeatableContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(RepeatableContainer, _Component);

        function RepeatableContainer(_props) {
          var _this;

          classCallCheck_default()(this, RepeatableContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(RepeatableContainer).call(this, _props));
          defineProperty_default()(assertThisInitialized_default()(_this), "shouldComponentUpdate", function (nextProps, nextState) {
            if (!isEqual_default()(_this.props.value, nextProps.value)) {
              _this.fieldsToUpdate = _this.getFieldsToUpdate(undefined, nextProps);

              if (_this.fieldsToUpdate.length > 0) {
                nextProps.updateSubmissionField({
                  fields: _this.fieldsToUpdate
                });
              }
            } // it needs to re render when a child component has its value updated
            // since a child X visibility may depend on the value of another child component


            var shouldComponentUpdate = // checks if there was a change in fieldsById from the current props comparing with new
            !isEqual_default()(_this.props.fieldsById, nextProps.fieldsById) || // checks if of those new submission fields is the repeatable itself or any child of it
            Object.keys(nextProps.fieldsById).some(function (fieldId) {
              return startsWith_default()(fieldId, nextProps.fieldId);
            }) || // checks if there is a new class name in the local state
            !isEqual_default()(_this.state.className, nextState.className);
            return shouldComponentUpdate;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "componentWillMount", function () {
            if (_this.props.repetitionsFromRepeatableId) {
              var value = get_default()(_this.props.fieldsById, "[".concat(_this.props.repetitionsFromRepeatableId, "].value"), []);

              _this.props.changeValue(value);
            } else if (!isArray_default()(_this.props.value) || _this.props.value.length === 0) {
              var newRepetition = RepeatableContainer_randomKey();

              _this.props.changeValue([newRepetition]);

              if (_this.props.shouldRepetitionsTransition) {
                _this.isVisible[newRepetition] = true;
              }
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getFieldDefaultValues", function () {
            var iterationId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props;
            var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state;
            return props.value.reduce(function (fieldsDefault, iteration) {
              var fieldsWithDefault = state.attributes.objects.reduce(function (fields, field) {
                if (field.attributes.default && (!iterationId || iterationId === iteration)) {
                  fields["".concat(props.fieldId, "-").concat(iteration, "-").concat(field.id)] = field.attributes.default;
                }

                return fields;
              }, {});

              if (Object.keys(fieldsWithDefault).length > 0) {
                return objectSpread_default()({}, fieldsDefault, fieldsWithDefault);
              }

              return fieldsDefault;
            }, {});
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getFieldsToUpdate", function () {
            var iterationId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props;
            var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state;

            var fieldDefaults = _this.getFieldDefaultValues(iterationId, props, state);

            return Object.keys(fieldDefaults).reduce(function (accum, fieldId) {
              var value = fieldDefaults[fieldId];

              if (!props.fieldsById[fieldId]) {
                // Value not yet initialized
                return [].concat(toConsumableArray_default()(accum), [{
                  id: fieldId,
                  value: value
                }]);
              }

              return accum;
            }, []);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getField", function (id) {
            return _this.props.objects.find(function (obj) {
              return obj.id === id;
            }) || _this.props.data.Form.fieldsById[id];
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getLogicWithContext", function (logic) {
            var repetitionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            var fieldMapper = function fieldMapper(rules) {
              return rules.map(function (n) {
                if (n.rules) {
                  return objectSpread_default()({}, n, {
                    rules: fieldMapper(n.rules)
                  });
                }

                var id = n.id,
                    field = n.field;

                if (id.match(/^\w+/g) && parent.includes(id.match(/^\w+/g)[0])) {
                  // Cases where the field is in a nested repeatable
                  id = replace_default()(id, /^\w+/g, parent);
                  field = replace_default()(field, /^\w+/g, parent);
                }

                return objectSpread_default()({}, n, {
                  field: replace_default()(field, new RegExp(/{repetitionId}/, 'g'), repetitionId),
                  id: replace_default()(id, new RegExp(/{repetitionId}/, 'g'), repetitionId)
                });
              });
            };

            return logic.map(function (k) {
              if (k.condition.conditionType !== 'formLogic') {
                return k;
              }

              return objectSpread_default()({}, k, {
                condition: objectSpread_default()({}, k.condition, {
                  attributes: objectSpread_default()({}, k.condition.attributes, {
                    logic: objectSpread_default()({}, k.condition.attributes.logic, {
                      rules: fieldMapper(k.condition.attributes.logic.rules)
                    })
                  })
                })
              });
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "addRepetition", function (e) {
            e.preventDefault(); // contains an object with the button operation (add) and how many repetitions it had when it was clicked

            _this.lastButtonClicked = {
              add: _this.props.value.length
            };
            var newRepetition = RepeatableContainer_randomKey();

            if (_this.props.shouldRepetitionsTransition) {
              _this.transitionLogic(newRepetition, true);
            } else {
              _this.props.changeValue([].concat(toConsumableArray_default()(_this.props.value), [newRepetition]));
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "removeRepetition", function (repetitionId) {
            return function () {
              if (_this.props.value.length === 1) {
                return null;
              } // contains an object with the button operation (remove) and how many repetitions it had when it was clicked


              _this.lastButtonClicked = {
                remove: _this.props.value.length
              };

              if (_this.props.shouldRepetitionsTransition) {
                _this.transitionLogic(repetitionId, false);
              } else {
                _this.props.changeValue(_this.props.value.filter(function (n) {
                  return n !== repetitionId;
                }));
              }

              return true;
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "transitionLogic", function (repetitionId, newVisibilityValue) {
            if (_this.isVisible[repetitionId] !== newVisibilityValue) {
              var className = _this.state.className;
              className[repetitionId] = newVisibilityValue ? RepeatableContainer_addRepetitionTransitionClass : RepeatableContainer_removeRepetitionTransitionClass;
              _this.isVisible[repetitionId] = newVisibilityValue;

              _this.setState({
                className: className
              });

              if (!newVisibilityValue) {
                // if the new visibility is false, then we need to remove the repetitionId from its value after the transition duration
                // once the repetitionId is removed from this repeatable value, then it'll remove the repetition from the DOM
                // meanwhile it's doing a removal transition animation
                setTimeout(function () {
                  if (!_this.isVisible[repetitionId]) {
                    // remove repetition
                    _this.setState({
                      className: Object.keys(_this.state.className).reduce(function (acc, classRepetitionId) {
                        if (classRepetitionId !== repetitionId) {
                          acc[classRepetitionId] = _this.state.className[classRepetitionId];
                        }

                        return acc;
                      }, {})
                    });

                    _this.props.changeValue(_this.props.value.filter(function (n) {
                      return n !== repetitionId;
                    }));
                  }
                }, _this.props.repetitionTransitionDuration);
              } else {
                // add repetition
                _this.props.changeValue([].concat(toConsumableArray_default()(_this.props.value), [repetitionId]));
              }
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getAttributes", function (attributes, repetitionIndex) {
            RepeatableContainer_attributesToVerify.forEach(function (attribute) {
              // verify if the attribute is in attributesToVerify list and if it is a string
              if (attributes[attribute] && typeof attributes[attribute] === 'string') {
                // replace {iterator} by its number (repetitionIndex + 1)
                attributes[attribute] = replace_default()(attributes[attribute], new RegExp(/{iterator}/, 'g'), repetitionIndex + 1); // replace {index} by its repetitionIndex

                attributes[attribute] = replace_default()(attributes[attribute], new RegExp(/{index}/, 'g'), repetitionIndex);
              }
            });
            return attributes;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "renderRepeatableSectionFields", function (repeatableSectionField, repetitionIndex, fieldContext, repetitionId) {
            var sectionFields = Object(repeatable["a"
            /* getSectionFields */
            ])(repeatableSectionField, _this.props.data.Form.sectionsById);
            var internalObjects = get_default()(repeatableSectionField, 'attributes.objects', []);

            var getField = function getField(sectionField) {
              var filtered = internalObjects.filter(function (object) {
                return object.id === sectionField.id;
              });

              if (filtered.length) {
                return filtered[0];
              }

              return _this.getField(sectionField.id);
            };

            return sectionFields && sectionFields.map(function (sectionField) {
              var sectionFieldData = sectionField.insertAt !== undefined ? getField(sectionField) : _this.getField(sectionField.id);

              var sectionFieldAttributes = _this.getAttributes(objectSpread_default()({}, get_default()(sectionFieldData, 'attributes', {}), sectionField.overrideAttributes, {
                populate: _this.getPopulateAttribute(repetitionIndex, sectionField.id)
              }), repetitionIndex);

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(FieldContainer["a"
              /* default */
              ], {
                key: "".concat(fieldContext).concat(sectionField.id),
                id: "".concat(fieldContext).concat(sectionField.id),
                sectionId: _this.props.sectionId,
                renderer: sectionFieldData.renderer,
                attributes: sectionFieldAttributes,
                logic: _this.getLogicWithContext(sectionField.logic || [], repetitionId),
                data: _this.props.data,
                dataLoading: _this.props.dataLoading,
                repeatableFieldTag: "".concat(_this.props.tag, ".repetition[").concat(repetitionIndex, "].").concat(sectionFieldAttributes.tag)
              });
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getPopulateAttribute", function (repetitionIndex, fieldId) {
            var populate = [];
            get_default()(_this.props, 'attributes.repeatablePopulateFields', []).some(function (item, index) {
              if (repetitionIndex === index) {
                return Object.keys(item || {}).some(function (key) {
                  if (key === fieldId) {
                    populate = item[key];
                    return true;
                  }

                  return false;
                });
              }

              return false;
            });
            return populate;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "renderRepeatableFields", function (repetitionId, fields, repetitionIndex) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-repeatable__item-fields"
            }, fields.map(function (field) {
              var fieldContext = "".concat(_this.props.fieldId, "-").concat(repetitionId, "-");

              var fieldChild = _this.getField(field.id);

              var attributes = _this.getAttributes(objectSpread_default()({}, get_default()(fieldChild, 'attributes', {}), field.overrideAttributes, {
                populate: _this.getPopulateAttribute(repetitionIndex, field.id)
              }), repetitionIndex);

              var isRepeatableSection = fieldChild && fieldChild.renderer === 'repeatableSection';

              if (isRepeatableSection) {
                return _this.renderRepeatableSectionFields(fieldChild, repetitionIndex, fieldContext, repetitionId);
              }

              var analyticsParams = objectSpread_default()({}, _this.props.analyticsParams, {
                parentFieldId: _this.props.fieldId,
                repetitionId: repetitionId,
                isRepeatable: true
              });
              var repeatableTag = "".concat(_this.props.tag, ".repetition[").concat(repetitionIndex, "]");
              return fieldChild && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(FieldContainer["a"
              /* default */
              ], {
                key: "".concat(fieldContext).concat(field.id),
                id: "".concat(fieldContext).concat(field.id),
                sectionId: _this.props.sectionId,
                renderer: fieldChild.renderer,
                attributes: attributes,
                logic: _this.getLogicWithContext(field.logic, repetitionId, _this.props.fieldId),
                data: _this.props.data,
                dataLoading: _this.props.dataLoading,
                repeatableTag: repeatableTag,
                repeatableFieldTag: "".concat(repeatableTag, ".").concat(attributes.tag),
                analyticsParams: analyticsParams
              });
            }));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "shouldRenderRemoveRepetitionButton", function () {
            var isIteratorFunctionality = _this.props.repetitionsFromRepeatableId;
            var hasMoreThanOneRepetition = _this.props.value.length > 1;

            if (isIteratorFunctionality || !hasMoreThanOneRepetition) {
              return false;
            }

            return true;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "valueHasAtLeastOneRepetitionWithTransitionClass", function (transitionClass) {
            var atLeastOneRepetitionHasRemoveTransitionClass = Object.keys(_this.state.className).reduce(function (acc, classRepetitionId) {
              if (_this.props.value.includes(classRepetitionId) && _this.state.className[classRepetitionId] === transitionClass) {
                acc = true;
              }

              return acc;
            }, false);
            return atLeastOneRepetitionHasRemoveTransitionClass;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getRemoveButtonContainerClassName", function () {
            var defaultClassName = 'formatic-repeatable__item-remove-button-container';

            var hasAddClass = _this.valueHasAtLeastOneRepetitionWithTransitionClass(RepeatableContainer_addRepetitionTransitionClass);

            var hasRemoveClass = _this.valueHasAtLeastOneRepetitionWithTransitionClass(RepeatableContainer_removeRepetitionTransitionClass);

            if (_this.props.shouldRepetitionsTransition && _this.props.value.length === 2 && _this.lastButtonClicked && // do not add transition class if the last button clicked was the remove button and it had 3 repetitions
            _this.lastButtonClicked.remove !== 3) {
              // first check if it has a remove class
              if (hasRemoveClass) {
                return "".concat(defaultClassName, " formatic-remove-repetition-button-transition--remove");
              } else if (hasAddClass) {
                return "".concat(defaultClassName, " formatic-remove-repetition-button-transition--add");
              }
            }

            return defaultClassName;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "renderItems", function () {
            if (isArray_default()(_this.props.value)) {
              return _this.props.value.map(function (repetitionId, index) {
                var transitionClass = _this.state.className[repetitionId] || '';
                var repetitionClassNames = "formatic-repeatable__item formatic-repeatable__item--".concat(repetitionId, " ").concat(transitionClass);
                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
                  key: repetitionId,
                  className: repetitionClassNames
                }, _this.shouldRenderRemoveRepetitionButton() && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
                  className: _this.getRemoveButtonContainerClassName()
                }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("button", {
                  type: "button",
                  className: "formatic-repeatable__item-remove-button",
                  onClick: _this.removeRepetition(repetitionId)
                }, get_default()(_this.props, 'attributes.removeRepetitionButtonLabel', 'x'))), _this.renderRepeatableFields(repetitionId, _this.state.attributes.fields, index));
              });
            }

            return null;
          });

          if (_this.props.shouldRepetitionsTransition) {
            // need to initialise it
            _this.isVisible = get_default()(_props, 'value', []).reduce(function (acc, repetitionId) {
              acc[repetitionId] = true;
              return acc;
            }, {});
          }

          _this.state = {
            attributes: {
              fields: _props.fields,
              label: _props.label,
              objects: _props.objects,
              populate: _props.populate,
              tag: _props.tag
            },
            className: {}
          };
          return _this;
        }

        createClass_default()(RepeatableContainer, [{
          key: "render",
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-repeatable"
            }, this.props.showLabel && this.props.label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_LabelContainer, {
              className: "formatic-field-label formatic-repeatable__label",
              label: this.props.label,
              optionalSuffixLabel: this.props.optionalSuffixLabel,
              requiredSuffixLabel: this.props.requiredSuffixLabel,
              showOptionalSuffixLabel: this.props.showOptionalSuffixLabel,
              showRequiredSuffixLabel: this.props.showRequiredSuffixLabel
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["x"
            /* Repeatable */
            ], {
              items: this.renderItems
            }), !this.props.repetitionsFromRepeatableId && this.props.maxRepetition > this.props.value.length && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-repeatable__actions"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["e"
            /* Button */
            ], {
              className: "formatic-repeatable__add-repeatable-button",
              onClick: this.addRepetition,
              type: "button",
              disabled: false,
              label: this.props.addRepetitionButtonLabel
            })));
          }
        }]);
        return RepeatableContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      RepeatableContainer_RepeatableContainer.defaultProps = {
        // === extra ===
        form: {},
        // === extra ===
        changeValue: noop_default.a,
        data: {},
        dataLoading: false,
        fieldId: '',
        sectionId: '',
        value: [],
        analyticsParams: noop_default.a,
        // values from redux store
        fieldsById: {},
        // attributes from dashboard
        fields: [],
        label: '',
        objects: {},
        populate: [],
        addRepetitionButtonLabel: 'Add',
        removeRepetitionButtonLabel: 'x',
        maxRepetition: 9999,
        repeatablePopulateFields: [],
        repetitionsFromRepeatableId: '',
        showLabel: true,
        updateSubmissionField: noop_default.a,
        tag: '',
        // form attributes from dashboard
        shouldRepetitionsTransition: true,
        repetitionTransitionDuration: 1000,
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      RepeatableContainer_RepeatableContainer.propTypes = {
        // === extra ===
        form: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // === extra ===
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        dataLoading: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        sectionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        populate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // values from redux store
        fieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // attributes from dashboard
        maxRepetition: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        addRepetitionButtonLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          logic: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object),
          overrideAttributes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
        })),
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        objects: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          attributes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          renderer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
        })),
        removeRepetitionButtonLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,

        /**
           * repeatablePopulateFields has the following structure:
           * [ // where the index of this array matches the repetition of this repeatable
           *  {
           *    'fieldIdFromThisRepeatable': [ // the key 'fieldIdFromThisRepeatable' is a dynamic string
                  {
                    fieldId: "destinationFieldId1",
                    fromSubValue: "subValuePath",
                    toSubValue: "subValuePath",
                    forcePopulation: true/false,
                  },
                  {
                    fieldId: "destinationFieldId2",
                    fromSubValue: "subValuePath",
                    toSubValue: "subValuePath",
                    forcePopulation: true/false,
                  }
                ]
           *  }
           * ]
           * therefore having repeatablePopulateFields = [ { 'abc': ['xyz'] } ] means that the field 'abc' of the first repetition
           * (first repetition since it's on the index 0 of the array) of this repeatable will populate the field 'xyz' of the form
           *
           * NOTE: since repeatablePopulateFields is an array of object which contains dynamic keys, its structure is described above
           */
        repeatablePopulateFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object),

        /**
         * the repatable will act as an interator and it'll have as many repetitions as the repeatable informed in repetitionsFromRepeatableId.
         * this repeatable will not have the add/remove repetitions functionality when repetitionsFromRepeatableId is specified
         */
        repetitionsFromRepeatableId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        updateSubmissionField: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        tag: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // form attributes from dashboard
        repetitionTransitionDuration: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        shouldRepetitionsTransition: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };

      var RepeatableContainer_mapStateToProps = function mapStateToProps(_ref) {
        var fieldsById = _ref.formatic.data.submission.fieldsById;
        return {
          fieldsById: fieldsById
        };
      };
      /* harmony default export */


      var containers_RepeatableContainer = Object(Recompose["a"
      /* compose */
      ])(Object(es["a"
      /* connect */
      ])(RepeatableContainer_mapStateToProps), withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])(), Object(Recompose["b"
      /* getContext */
      ])({
        updateSubmissionField: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      }))(RepeatableContainer_RepeatableContainer); // CONCATENATED MODULE: ./src/components/ReviewTable/ReviewTableSection.js

      var ReviewTableSection_ReviewTableSection = function ReviewTableSection(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-section formatic-review-table-section--".concat(props.id)
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-section__label"
        }, props.label), props.fields.map(function (field, index) {
          return props.reviewTableItemContainer && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(props.reviewTableItemContainer, extends_default()({}, props, {
            key: index,
            field: field,
            id: field.id,
            label: field.label,
            logic: field.logic,
            sectionId: field.sectionId,
            value: field.value,
            dataSubmission: props.dataSubmission,
            labelForAdvancedComponent: props.labelForAdvancedComponent
          }));
        }));
      };

      ReviewTableSection_ReviewTableSection.defaultProps = {
        label: '',
        labelForAdvancedComponent: '',
        fields: [],
        reviewTableItemContainer: noop_default.a
      };
      ReviewTableSection_ReviewTableSection.propTypes = {
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        labelForAdvancedComponent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          logic: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          sectionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
        })),
        reviewTableItemContainer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        // props below are used by withVisibility
        logic: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array.isRequired,
        pageId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        dataSubmission: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired
      };
      /* harmony default export */

      var ReviewTable_ReviewTableSection = ReviewTableSection_ReviewTableSection; // CONCATENATED MODULE: ./src/components/ReviewTable/ReviewTableItem.js

      var ReviewTableItem_ReviewTableItem = function ReviewTableItem(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-item formatic-review-table-item__".concat(props.id)
        }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-review-table-item__label"
        }, props.label), props.value);
      };

      ReviewTableItem_ReviewTableItem.defaultProps = {
        label: '',
        value: ''
      };
      ReviewTableItem_ReviewTableItem.propTypes = {
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node
      };
      /* harmony default export */

      var ReviewTable_ReviewTableItem = ReviewTableItem_ReviewTableItem; // CONCATENATED MODULE: ./src/containers/ReviewTableContainer/ReviewTableItemContainer.js

      var ReviewTableItemContainer_ReviewTableItemContainer = function ReviewTableItemContainer(props) {
        var fieldValue = get_default()(props, 'value', '');
        var overrides = props.overrides;

        var nestedValues = function nestedValues(value, showLabel, path) {
          var renders = [];

          if (isArray_default()(value)) {
            var subRenders = [];
            value.forEach(function (element) {
              subRenders = [].concat(toConsumableArray_default()(subRenders), toConsumableArray_default()(nestedValues(element, showLabel)));
            });
            renders.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              key: Object(utils["k"
              /* getRandomId */
              ])(),
              className: "formatic-review-table-item-advanced__row-container formatic-review-table-item-advanced__row-container-iteration"
            }, subRenders));
          } else if (value !== null && typeof_default()(value) === 'object') {
            Object.keys(value).forEach(function (key) {
              renders = [].concat(toConsumableArray_default()(renders), toConsumableArray_default()(nestedValues(get_default()(value, key, ''), showLabel, path !== undefined ? "".concat(path, ".").concat(key) : String(key))));
            });
          } else {
            if (!path && typeof value === 'string') {
              path = value;
            }

            renders.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              key: Object(utils["k"
              /* getRandomId */
              ])(),
              className: "formatic-review-table-item-advanced__row-container formatic-review-table-item-advanced__row-container-".concat(path)
            }, props.labelForAdvancedComponent && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("span", {
              className: "formatic-review-table-item__label formatic-review-table-item-advanced__label"
            }, path, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("span", {
              className: "formatic-review-table-item__colon"
            }, ":")), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("span", {
              className: "formatic-review-table-item-object__value formatic-review-table-item-advanced__value"
            }, value)));
          }

          return renders;
        };

        var getValueFromField = function getValueFromField() {
          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fieldValue;
          var container = arguments.length > 1 ? arguments[1] : undefined;

          if (container && typeof container.toSummaryNode === 'function') {
            // use this if container has static method "toSummaryNode" defined
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-review-table-item-advanced formatic-review-table-item-advanced-".concat(props.field.renderer)
            }, container.toSummaryNode(value));
          } else if (typeof_default()(value) !== 'object') {
            // this is for standard field where value is simple string
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-review-table-item__value"
            }, value);
          } else if (typeof_default()(value) === 'object' && value.maskedValue) {
            // this is specific case for input mask
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-review-table-item__value"
            }, value.maskedValue);
          } // do if the field is an object who dosnt have any of above


          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
            className: "formatic-review-table-item-advanced"
          }, nestedValues(value));
        };

        var override = overrides.fieldContainer.find(function (_ref) {
          var type = _ref.type;
          return type === props.field.renderer;
        });
        var container = override ? override.component : containerMap_containerMapWithoutHOCs[props.field.renderer];

        if (props.field.renderer === 'repeatable') {
          var items = [];
          var repeatableFieldDefs = {};
          props.field.attributes.objects.forEach(function (field) {
            repeatableFieldDefs[field.id] = field;
          });
          props.value.forEach(function (iteration, interationIndex) {
            Object.keys(iteration).forEach(function (element) {
              var label = get_default()(repeatableFieldDefs, "".concat(element, ".attributes.label"), element);
              var repeatableInsideFieldRenderer = get_default()(repeatableFieldDefs, "".concat(element, ".renderer"), element);
              override = overrides.fieldContainer.find(function (_ref2) {
                var type = _ref2.type;
                return type === repeatableInsideFieldRenderer;
              });
              container = override ? override.component : containerMap_containerMapWithoutHOCs[repeatableInsideFieldRenderer];
              var repeatableInsideFieldValue = get_default()(iteration, element, '');
              items.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ReviewTable_ReviewTableItem, {
                key: "".concat(props.id, "-").concat(interationIndex, "-").concat(element),
                id: props.id,
                label: "".concat(props.label, " - ").concat(interationIndex + 1, " - ").concat(label),
                value: getValueFromField(repeatableInsideFieldValue, container)
              }));
            });
          });
          return items;
        }

        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ReviewTable_ReviewTableItem, {
          id: props.id,
          label: props.label,
          value: getValueFromField(fieldValue, container)
        });
      };

      ReviewTableItemContainer_ReviewTableItemContainer.defaultProps = {
        id: Math.random().toString(36).substr(7),
        field: {},
        key: Math.random(),
        label: '',
        labelForAdvancedComponent: '',
        overrides: {},
        value: '',
        // props below are used by withVisibility
        logic: [],
        sectionId: ''
      };
      ReviewTableItemContainer_ReviewTableItemContainer.propTypes = {
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        field: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        key: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        labelForAdvancedComponent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        overrides: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        // props below are used by withVisibility
        logic: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        sectionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var ReviewTableContainer_ReviewTableItemContainer = Object(Recompose["a"
      /* compose */
      ])(Object(withVisibility["a"
      /* default */
      ])({
        type: 'field'
      }), Object(Recompose["b"
      /* getContext */
      ])({
        overrides: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      }))(ReviewTableItemContainer_ReviewTableItemContainer); // CONCATENATED MODULE: ./src/containers/ReviewTableContainer/ReviewTableSectionContainer.js

      var ReviewTableSectionContainer_ReviewTableSectionContainer = function ReviewTableSectionContainer(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ReviewTable_ReviewTableSection, extends_default()({}, props, {
          id: props.id,
          label: props.label,
          fields: props.fields,
          dataSubmission: props.dataSubmission,
          reviewTableItemContainer: ReviewTableContainer_ReviewTableItemContainer,
          labelForAdvancedComponent: props.labelForAdvancedComponent
        }));
      };

      ReviewTableSectionContainer_ReviewTableSectionContainer.defaultProps = {
        fields: [{
          id: '',
          label: '',
          logic: [],
          sectionId: '',
          value: ''
        }],
        id: Math.random().toString(36).substr(7),
        key: Math.random(),
        label: '',
        labelForAdvancedComponent: '',
        // props below are used by withVisibility
        dataSubmission: {},
        logic: [],
        pageId: ''
      };
      ReviewTableSectionContainer_ReviewTableSectionContainer.propTypes = {
        fields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          logic: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          sectionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
        })),
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        key: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        labelForAdvancedComponent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // props below are used by withVisibility
        dataSubmission: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        logic: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        pageId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var ReviewTableContainer_ReviewTableSectionContainer = Object(Recompose["a"
      /* compose */
      ])(Object(withVisibility["a"
      /* default */
      ])({
        type: 'section'
      }))(ReviewTableSectionContainer_ReviewTableSectionContainer); // EXTERNAL MODULE: ./src/components/ReviewTable/ReviewTable.js

      var ReviewTable = __webpack_require__(264); // EXTERNAL MODULE: ./src/core/calculations/index.js


      var calculations = __webpack_require__(106); // CONCATENATED MODULE: ./src/containers/ReviewTableContainer/ReviewTableContainer.js
      // fields which are omitted and dosnt have any value to display


      var ReviewTableContainer_defaultOmitfieldTypes = ['richTextArea', 'reviewTable', 'reviewTableNew', 'heading', 'alert'];

      var ReviewTableContainer_ReviewTableContainer = function ReviewTableContainer(props) {
        var pages = props.myPageFlow[props.myFlow.current] || Object.keys(get_default()(props, 'myPagesById', {}));
        var omitFieldTypes = [].concat(ReviewTableContainer_defaultOmitfieldTypes, toConsumableArray_default()(get_default()(props, 'omitFieldTypes', [])));
        var sections = [];
        pages.forEach(function (pageId) {
          var _sections;

          if (get_default()(props, 'hidePages', []).indexOf(pageId) >= 0) {
            // this page will not be displayed on the review table
            return;
          }

          var pageSections = get_default()(props, "myPagesById.".concat(pageId, ".sections"), []).map(function (section) {
            return {
              id: section.id,
              logic: section.logic,
              pageId: pageId
            };
          }); // filter/remove the sections that are supposed to be hidden

          pageSections = pageSections.filter(function (section) {
            return get_default()(props, 'hideSections', []).indexOf(section.id) < 0;
          });

          (_sections = sections).push.apply(_sections, toConsumableArray_default()(pageSections));
        });
        var sectionIndexById = sections.map(function (item) {
          return item.id;
        }).reduce(function (obj, value, key) {
          obj[value] = key;
          return obj;
        }, {});
        Object.keys(get_default()(props, 'mySectionsById', {})).forEach(function (sectionId) {
          if (sections[sectionIndexById[sectionId]]) {
            sections[sectionIndexById[sectionId]].label = get_default()(props, "mySectionsById.".concat(sectionId, ".attributes.label"), '');
            sections[sectionIndexById[sectionId]].fields = get_default()(props, "mySectionsById.".concat(sectionId, ".fields"), []).reduce(function (acc, field) {
              if (get_default()(props, 'hideFields', []).includes(field.id) || omitFieldTypes.includes(props.myFieldsById[field.id].renderer)) {
                // this field will not be displayed on the review table
                return acc;
              }

              var fieldDef = get_default()(props, "myFieldsById.".concat(field.id));
              var value;

              if (fieldDef && fieldDef.renderer === 'repeatable') {
                value = Object(calculations["b"
                /* getConstructedRepeatableFieldValue */
                ])(fieldDef.id, props.mySubmissionFieldsById, props.myFieldsById);
              } else {
                value = get_default()(props.mySubmissionFieldsById, "".concat(field.id, ".value"), '');
              }

              var tableField = {
                id: field.id,
                logic: field.logic,
                sectionId: sectionId,
                label: get_default()(fieldDef, 'attributes.shortLabel', '') || get_default()(fieldDef, 'attributes.label', ''),
                value: value,
                renderer: get_default()(fieldDef, 'renderer', '')
              };

              if (fieldDef.renderer === 'repeatable') {
                tableField.attributes = fieldDef.attributes;
              }

              acc.push(tableField);
              return acc;
            }, []);
          }
        });
        sections = sections.filter(function (item) {
          return item.fields.length > 0;
        });
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ReviewTable["a"
        /* default */
        ], {
          sections: sections,
          dataSubmission: props.dataSubmission,
          reviewTableSectionContainer: ReviewTableContainer_ReviewTableSectionContainer,
          labelForAdvancedComponent: props.labelForAdvancedComponent
        });
      };

      ReviewTableContainer_ReviewTableContainer.defaultProps = {
        dataSubmission: {},
        hidePages: [],
        hideSections: [],
        hideFields: [],
        labelForAdvancedComponent: '',
        myPageFlow: {},
        myFlow: {}
      };
      ReviewTableContainer_ReviewTableContainer.propTypes = {
        dataSubmission: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        hidePages: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        hideSections: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        hideFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        labelForAdvancedComponent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        myPageFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        myFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };

      var ReviewTableContainer_mapStateToProps = function mapStateToProps(_ref) {
        var _ref$formatic = _ref.formatic,
            _ref$formatic$data = _ref$formatic.data,
            _ref$formatic$data$fo = _ref$formatic$data.form,
            myFieldsDefById = _ref$formatic$data$fo.fieldsById,
            mySectionsDefById = _ref$formatic$data$fo.sectionsById,
            myPagesDefById = _ref$formatic$data$fo.pagesById,
            _ref$formatic$data$su = _ref$formatic$data.submission,
            attributesById = _ref$formatic$data$su.attributesById,
            fieldsById = _ref$formatic$data$su.fieldsById,
            pageFlow = _ref$formatic.pageFlow,
            flow = _ref$formatic.flow;
        return {
          myAttributesById: attributesById,
          mySubmissionFieldsById: fieldsById,
          myFieldsById: myFieldsDefById,
          mySectionsById: mySectionsDefById,
          myPagesById: myPagesDefById,
          myPageFlow: pageFlow,
          myFlow: flow
        };
      };
      /* harmony default export */


      var containers_ReviewTableContainer_ReviewTableContainer = Object(Recompose["a"
      /* compose */
      ])(Object(es["a"
      /* connect */
      ])(ReviewTableContainer_mapStateToProps))(ReviewTableContainer_ReviewTableContainer); // EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js

      var modules = __webpack_require__(143); // CONCATENATED MODULE: ./src/containers/RichTextAreaContainer.js


      var RichTextAreaContainer_READ_MORE_REGEX = '\\#\\#READMORE([\\(]{0,1}([a-zA-Z0-9\\,]{0,})[\\)]{0,1})\\#\\#';
      var RichTextAreaContainer_ScrollDuration = 300;
      var RichTextAreaContainer_ReadMoreOptions = {
        ScrollToTop: 'scrollToTop'
      };

      var RichTextAreaContainer_RichTextAreaContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(RichTextAreaContainer, _Component);

        function RichTextAreaContainer(props) {
          var _this;

          classCallCheck_default()(this, RichTextAreaContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(RichTextAreaContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "readMoreToggleHandler", function () {
            _this.setState(function (prevState) {
              return _this.toggledStateGenerator(prevState);
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "readLess", function () {
            var readMoreOptions = _this.state.readMoreOptions;
            var fieldId = _this.props.fieldId;

            if (readMoreOptions.includes(RichTextAreaContainer_ReadMoreOptions.ScrollToTop)) {
              modules["scroller"].scrollTo(fieldId, {
                duration: RichTextAreaContainer_ScrollDuration,
                delay: 0
              });
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "initialStateGenerator", function () {
            var originalRichText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.rich;
            var re = new RegExp(RichTextAreaContainer_READ_MORE_REGEX);
            var readMore = originalRichText.match(re);
            var state = {
              readMore: false,
              readMoreOptions: [],
              readMoreToken: null,
              toggleReadMore: false,
              finalRichText: originalRichText
            };

            if (readMore) {
              var _readMore = slicedToArray_default()(readMore, 1);

              state.readMoreToken = _readMore[0];
              state.readMoreOptions = readMore[2].split(',');
              state.readMore = true;

              var _originalRichText$spl = originalRichText.split(state.readMoreToken);

              var _originalRichText$spl2 = slicedToArray_default()(_originalRichText$spl, 1);

              state.finalRichText = _originalRichText$spl2[0];
            }

            return state;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "richTextUpdate", function () {
            var finalRichText = _this.props.rich;
            var _this$state = _this.state,
                readMoreToken = _this$state.readMoreToken,
                toggleReadMore = _this$state.toggleReadMore;

            if (readMoreToken) {
              var parts = finalRichText.split(readMoreToken);

              if (!toggleReadMore) {
                var _parts = slicedToArray_default()(parts, 1);

                finalRichText = _parts[0];
              } else {
                finalRichText = parts.join('');
              }
            }

            _this.setState({
              finalRichText: finalRichText
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "toggledStateGenerator", function (prevState) {
            var originalRichText = _this.props.rich;
            var readMoreToken = _this.state.readMoreToken;

            if (readMoreToken) {
              var originalRichTextArray = originalRichText.split(readMoreToken);
              return {
                readMore: true,
                toggleReadMore: !prevState.toggleReadMore,
                finalRichText: !prevState.toggleReadMore ? originalRichTextArray.join('') : originalRichTextArray[0]
              };
            }

            return {
              readMore: false,
              toggleReadMore: false,
              finalRichText: _this.props.rich
            };
          });
          _this.state = _this.initialStateGenerator();
          return _this;
        }

        createClass_default()(RichTextAreaContainer, [{
          key: "componentDidUpdate",
          value: function componentDidUpdate(prevProps, prevState) {
            if (prevState.toggleReadMore !== this.state.toggleReadMore && !this.state.toggleReadMore) {
              this.readLess();
            }

            if (prevProps.rich !== this.props.rich) {
              this.richTextUpdate();
            }
          }
        }, {
          key: "render",
          value: function render() {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-rich-text-area', defineProperty_default()({}, this.props.className, this.props.className))
            }, this.props.showLabel && this.props.label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              className: "formatic-field-label formatic-rich-text-area__label",
              label: this.props.label,
              optionalSuffixLabel: this.props.optionalSuffixLabel,
              requiredSuffixLabel: this.props.requiredSuffixLabel,
              showOptionalSuffixLabel: this.props.showOptionalSuffixLabel,
              showRequiredSuffixLabel: this.props.showRequiredSuffixLabel
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["y"
            /* RichTextArea */
            ], {
              className: "formatic-rich-text-area__content",
              html: this.state.finalRichText
            }), this.state.readMore && !this.state.toggleReadMore && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("button", {
              className: "formatic-rich-text-area__read_more",
              onClick: this.readMoreToggleHandler
            }, this.props.readMoreButtonText), this.state.readMore && this.state.toggleReadMore && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("button", {
              className: "formatic-rich-text-area__read_less",
              onClick: this.readMoreToggleHandler
            }, this.props.readLessButtonText));
          }
        }]);
        return RichTextAreaContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      RichTextAreaContainer_RichTextAreaContainer.defaultProps = {
        className: '',
        // attributes from dashboard
        label: '',
        showLabel: true,
        readMoreButtonText: 'Read More...',
        readLessButtonText: 'Read Less...',
        rich: '',
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      RichTextAreaContainer_RichTextAreaContainer.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        // attributes from dashboard
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        readMoreButtonText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readLessButtonText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        rich: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_RichTextAreaContainer = Object(withFieldToken["a"
      /* default */
      ])()(RichTextAreaContainer_RichTextAreaContainer); // EXTERNAL MODULE: ./node_modules/react-stickynode/index.js

      var react_stickynode = __webpack_require__(675);

      var react_stickynode_default =
      /*#__PURE__*/
      __webpack_require__.n(react_stickynode); // EXTERNAL MODULE: ./src/components/Label.js


      var Label = __webpack_require__(187); // CONCATENATED MODULE: ./src/components/ProgresBar.js


      var ProgresBar_ProgressBar = function ProgressBar(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: props.className
        }, props.stages.map(function (block, blockPos) {
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
            className: classnames_default()({
              'formatic-progress-bar__block': true,
              'formatic-progress-bar__block--completion-block': isEqual_default()(block, props.lastBlock),
              'formatic-progress-bar__block--start-block': blockPos === 0
            }),
            key: "progress-bar-".concat(props.id, "_block-").concat(blockPos)
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
            key: "progress-bar-".concat(props.id, "_stage-").concat(blockPos),
            className: classnames_default()({
              'formatic-progress-bar__stage formatic-progress-bar__stage--selected': props.getProgress(blockPos) >= 0 && props.getProgress(block, blockPos) < 1,
              'formatic-progress-bar__stage formatic-progress-bar__stage--complete': props.getProgress(blockPos) === 1,
              'formatic-progress-bar__stage formatic-progress-bar__stage--incomplete': props.getProgress(blockPos) < 0
            })
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Label["a"
          /* default */
          ], {
            labelFor: props.id,
            className: "formatic-progress-bar__label-block",
            label: block.title
          }), props.lastBlock !== block && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
            className: classnames_default()('formatic-progress-bar__progress', {
              'formatic-progress-bar__progress--selected': props.getProgress(blockPos) >= 0 && props.getProgress(blockPos) < 1,
              'formatic-progress-bar__progress--complete': props.getProgress(blockPos) === 1,
              'formatic-progress-bar__progress--incomplete': props.getProgress(blockPos) < 0
            }, props.getPercentageClassName(blockPos)),
            style: props.getInlineStyle(blockPos)
          }));
        }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: "formatic-progress-bar__line"
        }));
      };

      ProgresBar_ProgressBar.defaultProps = {
        className: 'formatic-progress-bar__container',
        stages: [],
        getInlineStyle: noop_default.a,
        getPercentageClassName: noop_default.a,
        getProgress: noop_default.a,
        lastBlock: {}
      };
      ProgresBar_ProgressBar.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        getProgress: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        getPercentageClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        getInlineStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        lastBlock: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        stages: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array
      };
      /* harmony default export */

      var ProgresBar = ProgresBar_ProgressBar; // CONCATENATED MODULE: ./src/containers/ProgressBarContainer.js

      var ProgressBarContainer_ProgressBarContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(ProgressBarContainer, _Component);
        /**
         * Creates an instance of ProgressBar
         * @param {any} props
         */

        function ProgressBarContainer(props) {
          var _this;

          classCallCheck_default()(this, ProgressBarContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(ProgressBarContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "getCurrentPageId", function () {
            return get_default()(_this.props.currentPage, "[".concat(_this.props.channel, "].pageId"));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getProgress", function () {
            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            var currentPageId = _this.getCurrentPageId();

            var pages = get_default()(_this.props, 'attributes.pages', {});
            /**
             * Prevents to break the progressbar if it is not possible to get something from pages[currentPageId]
             */

            if (isEmpty_default()(pages) || currentPageId === undefined || pages[currentPageId] === undefined) {
              return 0;
            }

            if (pages[currentPageId].stageIndex === position) {
              return pages[currentPageId].percentage;
            } else if (position < pages[currentPageId].stageIndex) {
              return 1;
            }

            return -1;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getPercentageClassName", function (blockPos) {
            if (_this.props.attributes.removeInlineStyles) {
              return "formatic-progress-bar__progress-percentage--".concat(parseInt(_this.getProgress(blockPos) * 100, 10));
            }

            return '';
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getInlineStyle", function (blockPos) {
            if (_this.props.attributes.removeInlineStyles) {
              return {};
            }

            return {
              width: "".concat(_this.getProgress(blockPos) * 100, "%")
            };
          });
          var attributes = get_default()(_this.props, 'attributes', ProgressBarContainer.defaultProps.attributes);
          _this.state = {
            lastBlock: typeof attributes.stages !== 'undefined' && attributes.stages.length > 0 ? attributes.stages[attributes.stages.length - 1] : undefined
          };
          return _this;
        }
        /**
         * Returns the current page id.
         *
         * note: the current page depends on the channel.
         */


        createClass_default()(ProgressBarContainer, [{
          key: "render",
          value: function render() {
            var stages = get_default()(this.props, 'attributes.stages', []);
            var _this$props$attribute = this.props.attributes,
                bottomBoundary = _this$props$attribute.bottomBoundary,
                innerZ = _this$props$attribute.innerZ,
                offsetTop = _this$props$attribute.offsetTop,
                sticky = _this$props$attribute.sticky;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(react_stickynode_default.a, {
              enabled: sticky,
              top: offsetTop,
              bottomBoundary: bottomBoundary,
              innerZ: innerZ
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-progress-bar"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ProgresBar, {
              className: "formatic-progress-bar__container",
              getProgress: this.getProgress,
              getPercentageClassName: this.getPercentageClassName,
              getInlineStyle: this.getInlineStyle,
              id: this.props.id,
              lastBlock: this.state.lastBlock,
              stages: stages
            })));
          }
        }]);
        return ProgressBarContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      ProgressBarContainer_ProgressBarContainer.defaultProps = {
        currentPage: {},
        channel: ''
      };
      ProgressBarContainer_ProgressBarContainer.propTypes = {
        attributes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          bottomBoundary: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          innerZ: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          offsetTop: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          pages: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          removeInlineStyles: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          stages: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
          sticky: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
        }).isRequired,
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        currentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired
      };
      /* harmony default export */

      var containers_ProgressBarContainer = Object(es["a"
      /* connect */
      ])(function (_ref) {
        var _ref$formatic = _ref.formatic,
            channel = _ref$formatic.channel,
            currentPage = _ref$formatic.currentPage;
        return {
          channel: channel,
          currentPage: currentPage
        };
      })(ProgressBarContainer_ProgressBarContainer); // EXTERNAL MODULE: ./node_modules/lodash/toString.js

      var lodash_toString = __webpack_require__(140);

      var toString_default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_toString); // EXTERNAL MODULE: ./src/hocs/withHelpText.js


      var withHelpText = __webpack_require__(95); // CONCATENATED MODULE: ./src/containers/SearchContainer.js


      var SearchContainer_ENTER_KEY = 'Enter';

      var SearchContainer_SearchContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(SearchContainer, _Component);

        function SearchContainer(props) {
          var _this;

          classCallCheck_default()(this, SearchContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(SearchContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "handleTextChange", function () {
            return function (_ref) {
              var value = _ref.target.value;

              _this.setState({
                searchValue: value
              });
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleInputMaskChange", function (value) {
            _this.setState({
              searchValue: value
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleBlur", function () {
            _this.props.validate();

            _this.props.onBlur(_this.state.searchValue);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleSearchClick",
          /*#__PURE__*/
          asyncToGenerator_default()(
          /*#__PURE__*/
          regenerator_default.a.mark(function _callee() {
            var onSearchClick, data, paginationData;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this.setState({
                      loading: true
                    });

                    onSearchClick = _this.props.onSearchClick;

                    if (!onSearchClick) {
                      _context.next = 10;
                      break;
                    }

                    _context.next = 5;
                    return _this.props.onSearchClick(_this.state.searchValue);

                  case 5:
                    data = _context.sent;
                    paginationData = _this.getPaginationData(data, _this.state.current);

                    _this.setState({
                      data: data,
                      paginationData: paginationData,
                      fetchSourceSuccess: true,
                      loading: false,
                      total: data.length,
                      toggleResults: true
                    });

                    _context.next = 11;
                    break;

                  case 10:
                    _this.setState({
                      data: [],
                      fetchSourceSuccess: true,
                      loading: false,
                      total: 0,
                      toggleResults: true
                    });

                  case 11:
                    return _context.abrupt("return", true);

                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })));
          defineProperty_default()(assertThisInitialized_default()(_this), "getPaginationData", function (data, currentPage) {
            if (!isEmpty_default()(data)) {
              return data.filter(function (item, index) {
                var pageFromIndex = _this.props.defaultPageSize * (currentPage - 1);
                var pageToIndex = _this.props.defaultPageSize * currentPage;
                return index >= pageFromIndex && index < pageToIndex;
              });
            }

            return [];
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleOnChange", function (onChange, validate, value, analyticsInteraction) {
            return function (event) {
              var saveValue;

              if (event.target.checked) {
                saveValue = _this.props.multiple ? value.concat(event.target.value) : [].concat(event.target.value);
              } else {
                saveValue = value.filter(function (v) {
                  return v !== event.target.value;
                });
              }

              _this.setState(function (state) {
                return {
                  toggleResults: !state.toggleResults
                };
              });

              onChange(saveValue, false);
              validate();
              analyticsInteraction(analytics["a"
              /* AnalyticsEvents */
              ].ValueChange);
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "onPageChange", function (page) {
            var paginationData = _this.getPaginationData(_this.state.data, page);

            _this.setState({
              current: page,
              paginationData: paginationData
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleKeyPress", function (_ref3) {
            var key = _ref3.key;

            if (key === SearchContainer_ENTER_KEY) {
              _this.handleSearchClick();
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getHelperTip", function () {
            var _this$props = _this.props,
                _this$props$helpText = _this$props.helpText,
                helpText = _this$props$helpText === void 0 ? '' : _this$props$helpText,
                _this$props$helpTextP = _this$props.helpTextPlacement,
                helpTextPlacement = _this$props$helpTextP === void 0 ? withHelpText["b"
            /* HelpTextPositions */
            ].left : _this$props$helpTextP,
                _this$props$helpTextP2 = _this$props.helpTextPosition,
                helpTextPosition = _this$props$helpTextP2 === void 0 ? withHelpText["a"
            /* HelpTextConstants */
            ].DefaultPosition : _this$props$helpTextP2,
                helpTextTitle = _this$props.helpTextTitle;

            if (helpText) {
              var content = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["y"
              /* RichTextArea */
              ], {
                html: helpText
              });
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
                className: "formatic-with-help-text__container formatic-with-help-text__container--".concat(helpTextPosition)
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(antd_es["c"
              /* Popover */
              ], {
                content: content,
                onVisibleChange: function onVisibleChange(helpIsVisible) {
                  _this.setState({
                    helpIsVisible: helpIsVisible
                  });
                },
                overlayClassName: "formatic-with-help-text__popover",
                placement: helpTextPlacement,
                title: helpTextTitle,
                trigger: "hover",
                visible: _this.state.helpIsVisible
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("span", {
                className: "formatic-with-help-text__question-mark"
              }, "?")));
            }

            return null;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getShowPagination", function () {
            var _this$props2 = _this.props,
                defaultPageSize = _this$props2.defaultPageSize,
                showPagination = _this$props2.showPagination;
            var total = _this.state.total;
            return total <= defaultPageSize && showPagination || total > defaultPageSize;
          });
          var dataFromProps = props.data || [];
          _this.state = {
            current: 1,
            data: dataFromProps,
            fetchSourceSuccess: dataFromProps.length > 0,
            helpIsVisible: false,
            loading: false,
            paginationData: _this.getPaginationData(dataFromProps, 1),
            searchValue: props.search || '',
            total: dataFromProps.length,
            toggleResults: true
          };
          return _this;
        }

        createClass_default()(SearchContainer, [{
          key: "render",
          value: function render() {
            var _this2 = this;

            var _this$props3 = this.props,
                buttonLabel = _this$props3.buttonLabel,
                className = _this$props3.className,
                description = _this$props3.description,
                emptyInfo = _this$props3.emptyInfo,
                error = _this$props3.error,
                errorMessage = _this$props3.errorMessage,
                fieldId = _this$props3.fieldId,
                helpTextPosition = _this$props3.helpTextPosition,
                inputId = _this$props3.inputId,
                maskOptions = _this$props3.maskOptions,
                multiple = _this$props3.multiple,
                placeholder = _this$props3.placeholder,
                searchResultTitle = _this$props3.searchResultTitle,
                searchTitle = _this$props3.searchTitle,
                showError = _this$props3.showError,
                toggleResults = _this$props3.toggleResults;
            var _this$state = this.state,
                data = _this$state.data,
                searchValue = _this$state.searchValue,
                fetchSourceSuccess = _this$state.fetchSourceSuccess,
                loading = _this$state.loading,
                paginationData = _this$state.paginationData;
            var helpContent = this.getHelperTip();
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-search-container"
            }, error && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-search-error"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: error
            })), helpTextPosition === withHelpText["b"
            /* HelpTextPositions */
            ].left && helpContent, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              labelFor: inputId,
              className: "formatic-field-label formatic-search__label",
              label: searchTitle,
              isRequired: false
            }), helpTextPosition === withHelpText["b"
            /* HelpTextPositions */
            ].right && helpContent, description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-text__description",
              description: description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-search-input', 'formatic-text', defineProperty_default()({}, className, className), {
                'formatic-search-input-with-error': error.length > 0
              })
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-text__input-container formatic-text"
            }, isEmpty_default()(maskOptions) && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
            /* Text */
            ], {
              className: "formatic-text__input",
              id: inputId,
              onBlur: this.handleBlur,
              onChange: this.handleTextChange(),
              onFocus: this.props.handleFocus,
              placeholder: placeholder,
              value: searchValue,
              onKeyPress: this.handleKeyPress
            }), maskOptions && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["r"
            /* InputMask */
            ], {
              changeValue: this.handleInputMaskChange,
              className: "formatic-text__input",
              id: inputId,
              maskOptions: maskOptions,
              onBlur: this.handleBlur,
              placeholder: placeholder,
              value: searchValue.rawValue,
              onKeyPress: this.handleKeyPress
            })), showError && errorMessage, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["e"
            /* Button */
            ], {
              className: "formatic-search__button",
              label: buttonLabel,
              onClick: this.handleSearchClick,
              type: "button"
            })), loading && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["o"
            /* FormLoading */
            ], null), fetchSourceSuccess && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-search-result"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("p", {
              className: "formatic-search-result__title"
            }, searchResultTitle), isEmpty_default()(data) && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-search-result-empty"
            }, emptyInfo), !isEmpty_default()(paginationData) && paginationData.map(function (result, i) {
              var resultId = toString_default()(get_default()(result, 'id', ''));

              if (toggleResults && !_this2.state.toggleResults && !_this2.props.value.includes(resultId)) {
                return null;
              }

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
                className: classnames_default()('formatic-search-result-item', {
                  'formatic-search-result-item-checked': _this2.props.value.includes(resultId)
                }),
                key: i
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
                className: "formatic-search-result-selection"
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
              /* Text */
              ], {
                checked: _this2.props.value.includes(resultId),
                className: "formatic-search-option__input",
                id: "".concat(fieldId, "_").concat(toString_default()(i)),
                name: "".concat(fieldId, "_searchResult"),
                onClick: _this2.handleOnChange(_this2.props.changeValue, _this2.props.validate, _this2.props.value, _this2.props.analyticsInteraction),
                type: multiple ? 'checkbox' : 'radio',
                value: resultId
              }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
              /* Label */
              ], {
                className: "formatic-search-option__label",
                isRequired: false,
                label: "",
                labelFor: "".concat(fieldId, "_").concat(toString_default()(i))
              })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
                className: "formatic-search-result-item-detail"
              }, get_default()(result, 'content', '')));
            }), this.getShowPagination() && !isEmpty_default()(this.state.paginationData) && toggleResults && this.state.toggleResults && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(antd_es["b"
            /* Pagination */
            ], {
              current: this.state.current,
              defaultCurrent: this.props.defaultPageCurrent,
              defaultPageSize: this.props.defaultPageSize,
              onChange: this.onPageChange,
              total: this.state.total
            })));
          }
        }]);
        return SearchContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      SearchContainer_SearchContainer.defaultProps = {
        analyticsInteraction: noop_default.a,
        analyticsParams: {},
        buttonLabel: 'Search',
        changeValue: noop_default.a,
        className: '',
        data: [],
        defaultPageCurrent: 1,
        defaultPageSize: 10,
        description: '',
        emptyInfo: 'No Result Found',
        error: '',
        errorMessage: null,
        handleBlur: noop_default.a,
        handleFocus: noop_default.a,
        helpText: '',
        helpTextPlacement: withHelpText["b"
        /* HelpTextPositions */
        ].right,
        helpTextPosition: withHelpText["b"
        /* HelpTextPositions */
        ].right,
        helpTextTitle: '',
        inputId: Object(utils["k"
        /* getRandomId */
        ])(),
        maskOptions: '',
        maxLength: 255,
        multiple: false,
        onBlur: noop_default.a,
        onSearchClick: noop_default.a,
        placeholder: 'Please input search text',
        required: true,
        search: '',
        searchTitle: 'title',
        searchResultTitle: 'SEARCH RESULT:',
        sendAnalytics: noop_default.a,
        showError: true,
        showPagination: true,
        showSearchTitle: true,
        toggleResults: false,
        validate: noop_default.a,
        value: []
      };
      SearchContainer_SearchContainer.propTypes = {
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        buttonLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        defaultPageCurrent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        defaultPageSize: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        emptyInfo: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        error: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        handleBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        handleFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        helpText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        helpTextPlacement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        helpTextPosition: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        helpTextTitle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        maskOptions: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        maxLength: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSearchClick: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        search: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        searchTitle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        searchResultTitle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        showError: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showPagination: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showSearchTitle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        toggleResults: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string), external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object])
      };
      /* harmony default export */

      var containers_SearchContainer = SearchContainer_SearchContainer; // CONCATENATED MODULE: ./src/containers/SMSVerificationContainer.js

      var SMSVerificationContainer_API_REQUEST_TIMEOUT = 2000; // 2 seconds

      var SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS = {
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        status: {
          notVerified: 'notVerified',
          sendingVerificationCode: 'sendingVerificationCode',
          verificationCodeSent: 'verificationCodeSent',
          validatingVerificationCode: 'validatingVerificationCode',
          verified: 'verified'
        },
        version: 4
      };

      var SMSVerificationContainer_SMSVerificationContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(SMSVerificationContainer, _Component);

        function SMSVerificationContainer(props) {
          var _this;

          classCallCheck_default()(this, SMSVerificationContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(SMSVerificationContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "validator", function (value, internalFieldKey, isFromPageNavigation) {
            var errors = {};

            if (isEmpty_default()(value.phone) && value.status !== SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verified) {
              errors.phone = _this.props.emptyPhoneNumberErrorMessage;
            }

            if (isEmpty_default()(errors) && isFromPageNavigation && value.status !== SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verified) {
              errors.componentError = _this.props.phoneNotVerifiedOnNavigationErrorMessage;
            }

            _this.setState({
              errors: errors
            });

            return {
              isValid: !Object.keys(errors).length,
              errors: errors
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getHeaders", function () {
            return {
              Authorization: "Bearer ".concat(_this.props.apiKey),
              'Content-Type': SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.contentType
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getPostData", function () {
            return {
              branch: _this.props.environment,
              field: _this.props.fieldId,
              form_id: _this.props.formId,
              sessionId: _this.props.submissionId // TODO impact in standardising to submissionId ?

            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "sendVerificationSMS",
          /*#__PURE__*/
          asyncToGenerator_default()(
          /*#__PURE__*/
          regenerator_default.a.mark(function _callee() {
            var phoneValue, data, smsSentTo, response, errors;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    phoneValue = get_default()(_this.props, 'value.phone', '');

                    _this.setState({
                      errors: {}
                    });

                    if (!isEmpty_default()(phoneValue.trim())) {
                      _context.next = 5;
                      break;
                    }

                    _this.setState({
                      errors: {
                        phone: _this.props.emptyPhoneNumberErrorMessage
                      }
                    });

                    return _context.abrupt("return");

                  case 5:
                    _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                      blockedPhone: true,
                      code: '',
                      status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.sendingVerificationCode
                    }));

                    data = Object(utils_requestData["c"
                    /* queryEncode */
                    ])(_this.getPostData()); // getting the phone value here in order to make sure that we know what the user has type at this point (since the user could change it)

                    smsSentTo = _this.props.value.phone;
                    _context.prev = 8;
                    _context.next = 11;
                    return new Promise(function (resolve, reject) {
                      setTimeout(function () {
                        reject(new Error('timeout'));
                      }, SMSVerificationContainer_API_REQUEST_TIMEOUT);
                      resolve(Object(utils_requestData["d"
                      /* requestData */
                      ])({
                        method: 'post',
                        url: "".concat(src_config["a"
                        /* default */
                        ].getApiServer(), "/verification/callback"),
                        data: data,
                        headers: _this.getHeaders()
                      }));
                    });

                  case 11:
                    response = _context.sent;
                    errors = {};

                    if (response.data.success) {
                      _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                        status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verificationCodeSent,
                        smsSentTo: smsSentTo
                      }));
                    } else {
                      if (response.data.message === 'The tokenised value could not be found' || response.data.message === 'No token to validate against. Confirm field settings') {
                        errors.sendSMS = _this.props.checkValidateAgainstMessage;
                      } else {
                        errors.sendSMS = response.data.message.split('.')[0] || _this.props.genericAPIErrorMessage;
                      }

                      _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                        blockedPhone: false,
                        status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified
                      }));
                    } // need to remove any componentError since the user interacted with the component
                    // otherwise it'll continue to show a componentError in the bottom of this component


                    _this.setState({
                      errors: objectSpread_default()({}, _this.state.errors, {
                        componentError: undefined
                      }, errors)
                    });

                    _context.next = 21;
                    break;

                  case 17:
                    _context.prev = 17;
                    _context.t0 = _context["catch"](8);

                    if (_context.t0 === 'timeout') {
                      _this.setState({
                        errors: {
                          sendSMS: _this.props.apiTimeoutErrorMessage
                        }
                      });
                    } else {
                      _this.setState({
                        errors: {
                          sendSMS: _this.props.serverUnavailableErrorMessage
                        }
                      });
                    }

                    _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                      status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified
                    }));

                  case 21:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[8, 17]]);
          })));
          defineProperty_default()(assertThisInitialized_default()(_this), "changePhoneNumber", function () {
            _this.setState({
              errors: {}
            });

            _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
              checksum: '',
              code: '',
              phone: '',
              blockedPhone: false,
              smsSentTo: '',
              status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified,
              verifiedPhone: '',
              version: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.version
            }));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "verifyCode",
          /*#__PURE__*/
          asyncToGenerator_default()(
          /*#__PURE__*/
          regenerator_default.a.mark(function _callee2() {
            var data, verifiedPhone, response, dataResponse;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (get_default()(_this.props, 'value.code.length', 0)) {
                      _context2.next = 3;
                      break;
                    }

                    _this.setState({
                      errors: {
                        code: _this.props.emptyVerificationCodeErrorMessage
                      }
                    });

                    return _context2.abrupt("return");

                  case 3:
                    _this.setState({
                      errors: {}
                    });

                    data = Object(utils_requestData["c"
                    /* queryEncode */
                    ])(objectSpread_default()({}, _this.getPostData(), {
                      code: _this.props.value.code
                    })); // getting the phone value here in order to make sure that we know what the user has type at this point (since the user could change it)

                    verifiedPhone = _this.props.value.phone;

                    _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                      status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.validatingVerificationCode
                    }));

                    _context2.next = 9;
                    return Object(utils_requestData["d"
                    /* requestData */
                    ])({
                      url: "".concat(src_config["a"
                      /* default */
                      ].getApiServer(), "/verification/verify"),
                      data: data,
                      method: 'post',
                      headers: _this.getHeaders()
                    });

                  case 9:
                    response = _context2.sent;
                    dataResponse = get_default()(response, 'data.success');

                    if (!(dataResponse === true)) {
                      _context2.next = 16;
                      break;
                    }

                    _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                      checksum: get_default()(response, 'data.verificationCode', ''),
                      status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verified,
                      verifiedPhone: verifiedPhone,
                      version: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.version
                    }));

                    _this.debouncedValidate();

                    _context2.next = 20;
                    break;

                  case 16:
                    if (!(typeof dataResponse === 'undefined')) {
                      _context2.next = 20;
                      break;
                    } // An unknown response was sent back by the server


                    _this.setState({
                      errors: {
                        code: _this.props.unknownVerificationErrorMessage
                      }
                    });

                    _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                      status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified
                    }));

                    return _context2.abrupt("return");

                  case 20:
                    if (!response.data.success) {
                      _this.setState({
                        errors: {
                          code: _this.props.invalidCodeErrorMessage
                        }
                      });

                      _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
                        status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified
                      }));
                    }

                  case 21:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })));
          defineProperty_default()(assertThisInitialized_default()(_this), "handleCodeChangeValue", function (event) {
            var value = event.target.value;

            _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
              code: value
            }));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handlePhoneChangeValue", function (event) {
            var value = event.target.value;
            var status = _this.props.value.status;

            _this.setState({
              errors: {}
            });

            _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
              code: ''
            })); // do not allow anything else than numbers and +


            value = value.replace(/[^\d+]/g, '');

            if (!isEmpty_default()(_this.props.value.verifiedPhone) && isEqual_default()(_this.props.value.verifiedPhone, value) && _this.props.value.status !== SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verified) {
              status = SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verified;
            } else if (!isEmpty_default()(_this.props.value.smsSentTo)) {
              if (isEqual_default()(_this.props.value.smsSentTo, value) && _this.props.value.status !== SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verificationCodeSent) {
                status = SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verificationCodeSent;
              }

              if (!isEqual_default()(_this.props.value.smsSentTo, value) && _this.props.value.status !== SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified) {
                status = SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified;
              }
            }

            _this.props.changeValue(objectSpread_default()({}, _this.props.value, {
              status: status,
              phone: value
            }));
          });
          _this.state = {
            errors: {}
          };

          if (isString_default()(_this.props.value.phone) && _this.props.value.phone.length > 0) {
            _this.props.validate();
          }

          var AllowReValidatingWhenPopulateAndVerifyOnly = props.AllowReValidatingWhenPopulateAndVerifyOnly,
              populateAndVerifyOnly = props.populateAndVerifyOnly;

          if (populateAndVerifyOnly && AllowReValidatingWhenPopulateAndVerifyOnly) {
            props.changeValue(objectSpread_default()({}, props.value, {
              blockedPhone: true,
              checksum: '',
              code: '',
              smsSentTo: '',
              status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified,
              verifiedPhone: ''
            }));
          }

          _this.debouncedValidate = debounce_default()(_this.props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          return _this;
        }

        createClass_default()(SMSVerificationContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.props.registerValidator(this.validator, get_default()(this.props, 'fieldId'), constants["Validator"].Custom, true);
          }
        }, {
          key: "render",
          value: function render() {
            var status = this.props.value.status || SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified;
            var _this$props = this.props,
                populateAndVerifyOnly = _this$props.populateAndVerifyOnly,
                maskPhoneNumber = _this$props.maskPhoneNumber,
                maskPhoneNumberMessage = _this$props.maskPhoneNumberMessage;
            var inputInvalidVerificationCodeAfterSentSMS = status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified && isString_default()(this.state.errors.code) && this.state.errors.code.length > 0;
            var sendSMSLabel = status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verificationCodeSent || inputInvalidVerificationCodeAfterSentSMS ? this.props.resendButtonText : this.props.sendButtonText;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-sms-verification', {
                'formatic-field-error': this.state.errors.componentError,
                'formatic-field-valid': !this.state.errors.componentError && status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verified
              })
            }, this.props.showLabel && this.props.label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              className: "formatic-field-label formatic-sms-verification__label",
              labelFor: this.props.inputId,
              label: this.props.label,
              isRequired: this.props.required,
              optionalSuffixLabel: this.props.optionalSuffixLabel,
              requiredSuffixLabel: this.props.requiredSuffixLabel,
              showOptionalSuffixLabel: this.props.showOptionalSuffixLabel,
              showRequiredSuffixLabel: this.props.showRequiredSuffixLabel,
              suffixLabel: this.props.required && this.props.showRequiredSuffixLabel && this.props.requiredSuffixLabel
            }), this.props.description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-sms-verification__description",
              description: this.props.description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-sms-verification__phone-container', {
                'formatic-field-error': this.state.errors.phone || this.state.errors.sendSMS,
                'formatic-field-valid': !this.state.errors.phone && !isEmpty_default()(this.props.value.phone) && !this.state.errors.sendSMS,
                'formatic-sms-verification__sms-sending': status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.sendingVerificationCode
              })
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-sms-verification__phone-field-container', {
                'formatic-sms-verification__sms-sending': status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.sendingVerificationCode
              })
            }, populateAndVerifyOnly && maskPhoneNumber && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-sms-verification__maskedPhone"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("p", null, maskPhoneNumberMessage.replace('{phone}', this.props.value.phone.slice(-3)))), (!populateAndVerifyOnly || !maskPhoneNumber) && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
            /* Text */
            ], {
              id: "".concat(this.props.fieldId, "-phone"),
              placeholder: this.props.placeholder,
              className: "formatic-sms-verification__phone",
              onChange: this.handlePhoneChangeValue,
              value: this.props.value.phone,
              readOnly: this.props.value.blockedPhone
            }), this.state.errors.phone && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: this.state.errors.phone
            }), this.state.errors.sendSMS && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: this.state.errors.sendSMS
            })), status !== SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verified && status !== SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.validatingVerificationCode && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-sms-verification__send-sms-container"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["e"
            /* Button */
            ], {
              className: "formatic-sms-verification__send-button",
              label: status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.sendingVerificationCode ? this.props.sendingSMSText : sendSMSLabel,
              onClick: this.sendVerificationSMS,
              disabled: status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.sendingVerificationCode || status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.validatingVerificationCode
            })), this.props.value.status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verificationCodeSent && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-sms-verification__sent-success"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("p", null, this.props.smsSentText)), status !== SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.sendingVerificationCode && status !== SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.validatingVerificationCode && this.props.value.blockedPhone === true && !populateAndVerifyOnly && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-sms-verification__change-phone-container"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["e"
            /* Button */
            ], {
              className: "formatic-sms-verification__change-phone-button",
              label: this.props.changePhoneButtonText,
              onClick: this.changePhoneNumber,
              disabled: status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.validatingVerificationCode
            })), status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.sendingVerificationCode && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(FormLoading["a"
            /* default */
            ], {
              loadingText: ""
            })), (status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verificationCodeSent || status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.validatingVerificationCode || inputInvalidVerificationCodeAfterSentSMS) && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-sms-verification__sent-container"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-sms-verification__sent', {
                'formatic-field-error': this.state.errors.code
              })
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              label: this.props.verificationCodeText,
              className: "formatic-sms-verification__code-label"
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["z"
            /* Text */
            ], {
              id: "".concat(this.props.fieldId, "-code-input"),
              className: "formatic-sms-verification__code-input",
              value: this.props.value.code,
              onChange: this.handleCodeChangeValue,
              readOnly: status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.validatingVerificationCode
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-sms-verification__code-button"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["e"
            /* Button */
            ], {
              className: "formatic-sms-verification__verify-button",
              label: status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.validatingVerificationCode ? this.props.validatingCodeText : this.props.verificationButtonText,
              onClick: this.verifyCode,
              disabled: isEmpty_default()(this.props.value.code) || status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.validatingVerificationCode
            }))), this.state.errors.code && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: this.state.errors.code
            })), status === SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.verified && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-sms-verification__verified"
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("p", null, this.props.successfullyVerifiedText)), this.state.errors.componentError && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["l"
            /* ErrorMessage */
            ], {
              text: this.state.errors.componentError
            }));
          }
        }]);
        return SMSVerificationContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      SMSVerificationContainer_SMSVerificationContainer.defaultProps = {
        changeValue: noop_default.a,
        checkValidateAgainstMessage: 'The information to be validated can not be found',
        phoneRequired: true,
        environment: '',
        fieldId: '',
        formId: 0,
        genericAPIErrorMessage: 'Something went wrong, please try again later!',
        inputId: '',
        registerValidator: noop_default.a,
        submissionId: '',
        validate: noop_default.a,
        value: {
          checksum: '',
          code: '',
          phone: '',
          blockedPhone: false,
          smsSentTo: '',
          status: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.status.notVerified,
          verifiedPhone: '',
          version: SMSVerificationContainer_SMS_VERIFICATION_CONSTANTS.version
        },
        // attributes from dashboard
        AllowReValidatingWhenPopulateAndVerifyOnly: false,
        apiTimeoutErrorMessage: 'Connection timed out',
        changePhoneButtonText: 'Change Phone Number',
        description: '',
        emptyPhoneNumberErrorMessage: 'The phone number can not be empty',
        emptyVerificationCodeErrorMessage: 'Please enter the verification code',
        invalidCodeErrorMessage: 'The verification code you entered was incorrect',
        label: '',
        maskPhoneNumber: false,
        maskPhoneNumberMessage: 'We will send an SMS to the number ending in {phone}',
        optionalSuffixLabel: '',
        phoneNotVerifiedOnNavigationErrorMessage: 'You must go through SMS verification before continue',
        placeholder: '',
        populateAndVerifyOnly: false,
        resendButtonText: 'Re-send SMS',
        required: true,
        requiredSuffixLabel: '',
        sendButtonText: 'Send SMS',
        sendingSMSText: 'Sending...',
        smsSentText: 'SMS message successfully sent',
        serverUnavailableErrorMessage: 'Sorry, the SMS verification service is not available, please try again later',
        showLabel: true,
        successfullyVerifiedText: 'Successfully verified',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false,
        validatingCodeText: 'Validating your code, please wait',
        verificationButtonText: 'Verify',
        verificationCodeText: 'Verification code',
        unknownVerificationErrorMessage: 'An unknown error occurred during verification'
      };
      SMSVerificationContainer_SMSVerificationContainer.propTypes = {
        apiKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        checkValidateAgainstMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        environment: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        formId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        phoneRequired: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        submissionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          checksum: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          code: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          phone: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          blockedPhone: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          smsSentTo: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          status: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          verifiedPhone: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          version: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
        }),
        // attributes from dashboard
        AllowReValidatingWhenPopulateAndVerifyOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        apiTimeoutErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        changePhoneButtonText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        emptyPhoneNumberErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        emptyVerificationCodeErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        genericAPIErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        invalidCodeErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        maskPhoneNumber: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        maskPhoneNumberMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        phoneNotVerifiedOnNavigationErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        populateAndVerifyOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        resendButtonText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        smsSentText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        sendButtonText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        sendingSMSText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        serverUnavailableErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        successfullyVerifiedText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        unknownVerificationErrorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        validatingCodeText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        verificationButtonText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        verificationCodeText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var containers_SMSVerificationContainer = Object(Recompose["a"
      /* compose */
      ])(Object(es["a"
      /* connect */
      ])(function (_ref3) {
        var formatic = _ref3.formatic;
        return {
          apiKey: formatic.apiKey,
          environment: formatic.environment,
          formId: formatic.formId,
          submissionId: formatic.submissionId
        };
      }), withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(SMSVerificationContainer_SMSVerificationContainer); // CONCATENATED MODULE: ./src/containers/TextareaContainer.js

      var TextareaContainer_DEFAULT_ROWS_NUMBER = 5;

      var TextareaContainer_TextareaContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(TextareaContainer, _Component);

        function TextareaContainer(props) {
          var _this;

          classCallCheck_default()(this, TextareaContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(TextareaContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "handleTextareaChange", function (value) {
            if (_this.props.maxLength > 0 && value.length > _this.props.value.length && value.length > _this.props.maxLength) {
              _this.props.changeValue(value.substr(0, _this.props.maxLength), true);
            } else {
              _this.props.changeValue(value, true);
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleBlur", function (event) {
            _this.props.onBlur(event);

            _this.props.validate();

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Blur, _this.props.analyticsParams);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleFocus", function (event) {
            _this.props.onFocus(event);

            _this.props.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].Focus, _this.props.analyticsParams);
          });
          _this.debouncedValidate = debounce_default()(_this.props.validate, src_config["a"
          /* default */
          ].getFieldUpdateTimeout());
          return _this;
        }

        createClass_default()(TextareaContainer, [{
          key: "render",
          value: function render() {
            var _this$props = this.props,
                showLabel = _this$props.showLabel,
                label = _this$props.label,
                description = _this$props.description,
                errorMessage = _this$props.errorMessage,
                maxLength = _this$props.maxLength,
                className = _this$props.className,
                rows = _this$props.rows,
                required = _this$props.required,
                showRequiredSuffixLabel = _this$props.showRequiredSuffixLabel,
                requiredSuffixLabel = _this$props.requiredSuffixLabel;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: classnames_default()('formatic-textarea', defineProperty_default()({}, className, className))
            }, showLabel && label && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["s"
            /* Label */
            ], {
              labelFor: this.props.inputId,
              className: "formatic-field-label formatic-textarea__label",
              label: label,
              isRequired: this.props.required,
              suffixLabel: required && showRequiredSuffixLabel && requiredSuffixLabel
            }), description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["m"
            /* FieldDescription */
            ], {
              className: "formatic-textarea__description",
              description: description
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["A"
            /* Textarea */
            ], {
              changeValue: this.handleTextareaChange,
              className: "formatic-textarea__textarea",
              id: this.props.inputId,
              maxLength: maxLength > 0 ? maxLength : undefined,
              onBlur: this.handleBlur,
              onFocus: this.handleFocus,
              placeholder: this.props.placeholder,
              readOnly: this.props.readOnly,
              value: this.props.value,
              rows: rows > 0 ? rows : TextareaContainer_DEFAULT_ROWS_NUMBER
            }), errorMessage);
          }
        }]);
        return TextareaContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      TextareaContainer_TextareaContainer.defaultProps = {
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        fieldId: '',
        inputId: '',
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        registerValidator: noop_default.a,
        sendAnalytics: noop_default.a,
        validate: noop_default.a,
        value: '',
        // attributes from dashboard
        description: '',
        label: '',
        maxLength: '',
        placeholder: '',
        readOnly: false,
        required: false,
        requiredMessage: constants["DefaultRequiredMessage"],
        rows: 5,
        showLabel: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false
      };
      TextareaContainer_TextareaContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        registerValidator: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        maxLength: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        placeholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        requiredMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        rows: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var containers_TextareaContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(TextareaContainer_TextareaContainer); // CONCATENATED MODULE: ./src/containers/TrueFalseContainer.js

      var TrueFalseContainer_handleOnFocus = function handleOnFocus(onFocus, sendAnalytics, analyticsInteraction) {
        return function (event) {
          onFocus(event);
          sendAnalytics(analytics["a"
          /* AnalyticsEvents */
          ].Focus, {
            selected: event.target.checked
          });
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].Focus);
        };
      };

      var TrueFalseContainer_handleOnBlur = function handleOnBlur(onBlur, validate, sendAnalytics, analyticsInteraction) {
        return function (event) {
          onBlur(event);
          validate();
          sendAnalytics(analytics["a"
          /* AnalyticsEvents */
          ].Blur, {
            selected: event.target.checked
          });
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].Blur);
        };
      };

      var TrueFalseContainer_handleOnChange = function handleOnChange(onChange, validate, analyticsInteraction) {
        return function (event) {
          onChange(event.target.checked, false);
          validate();
          analyticsInteraction(analytics["a"
          /* AnalyticsEvents */
          ].ValueChange);
        };
      };

      var TrueFalseContainer_getValue = function getValue(value) {
        if (value === true) {
          return true;
        }

        return false;
      };

      var TrueFalseContainer_TrueFalseContainer = function TrueFalseContainer(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
          className: classnames_default()('formatic-checkbox-list', defineProperty_default()({}, props.className, props.className))
        }, props.description && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["y"
        /* RichTextArea */
        ], {
          className: "formatic-checkbox-list__description",
          html: props.description
        }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components["B"
        /* TrueFalse */
        ], {
          className: "formatic-checkbox-list__checkbox-item-container",
          id: props.inputId,
          onBlur: TrueFalseContainer_handleOnBlur(props.onBlur, props.validate, props.sendAnalytics, props.analyticsInteraction),
          onChange: TrueFalseContainer_handleOnChange(props.changeValue, props.validate, props.analyticsInteraction),
          onFocus: TrueFalseContainer_handleOnFocus(props.onFocus, props.sendAnalytics, props.analyticsInteraction),
          label: props.showLabel ? props.label : '',
          required: props.required,
          selected: TrueFalseContainer_getValue(props.value)
        }), props.errorMessage);
      };

      TrueFalseContainer_TrueFalseContainer.defaultProps = {
        // attributes from dashboard
        analyticsParams: {},
        changeValue: noop_default.a,
        className: '',
        errorMessage: null,
        inputId: '',
        onBlur: noop_default.a,
        onFocus: noop_default.a,
        sendAnalytics: noop_default.a,
        analyticsInteraction: noop_default.a,
        validate: noop_default.a,
        // attributes from dashboard
        description: '',
        label: '',
        required: false,
        showLabel: true,
        // form attributes from dashboard
        optionalSuffixLabel: '',
        requiredSuffixLabel: '',
        showOptionalSuffixLabel: false,
        showRequiredSuffixLabel: false,
        selected: false
      };
      TrueFalseContainer_TrueFalseContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        changeValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        errorMessage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        inputId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        analyticsInteraction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        validate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        // attributes from dashboard
        description: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        label: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // form attributes from dashboard
        optionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        requiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        showOptionalSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        showRequiredSuffixLabel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        selected: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]).isRequired
      };
      /* harmony default export */

      var containers_TrueFalseContainer = Object(Recompose["a"
      /* compose */
      ])(withAnalytics["a"
      /* default */
      ], withFieldSync["a"
      /* default */
      ], withFieldValidation["a"
      /* default */
      ], Object(withFieldToken["a"
      /* default */
      ])())(TrueFalseContainer_TrueFalseContainer); // CONCATENATED MODULE: ./src/config/containerMap.js

      /* unused harmony export containerMap */

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return containerMap_containerMapWithoutHOCs;
      });

      var containerMap_preventUpdatingUnnecessarily = function preventUpdatingUnnecessarily(WrappedComponent) {
        var PreventUpdatingUnnecessarilyComponent =
        /*#__PURE__*/
        function (_Component) {
          inherits_default()(PreventUpdatingUnnecessarilyComponent, _Component);

          function PreventUpdatingUnnecessarilyComponent() {
            var _getPrototypeOf2;

            var _this;

            classCallCheck_default()(this, PreventUpdatingUnnecessarilyComponent);

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(PreventUpdatingUnnecessarilyComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
            defineProperty_default()(assertThisInitialized_default()(_this), "shouldComponentUpdate", function (nextProps, nextState) {
              return !isEqual_default()(nextProps, _this.props) || !isEqual_default()(nextState, _this.state);
            });
            return _this;
          }

          createClass_default()(PreventUpdatingUnnecessarilyComponent, [{
            key: "render",
            value: function render() {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(WrappedComponent, this.props);
            }
          }]);
          return PreventUpdatingUnnecessarilyComponent;
        }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

        return PreventUpdatingUnnecessarilyComponent;
      }; // below container map is in the format of:
      // [key]: [ContainerWithHOCs, ContainerWithoutHOCs]


      var containerMap_containerMap = {
        abnAcn: [containers_AbnAcnContainer, AbnAcnContainer_AbnAcnContainer],
        actionButton: [containers_ActionButtonContainer],
        addressLookup: [containers_AddressLookupContainer, AddressLookupContainer_AddressLookupContainer],
        advancedReviewTable: [AdvancedReviewTable_AdvancedReviewTableContainer, AdvancedReviewTableContainer_AdvancedReviewTableContainer],
        alert: [containers_AlertContainer, containers_AlertContainer],
        apiDropdown: [containers_ApiDropdownContainer, ApiDropdownContainer_ApiDropdownContainer],
        bsb: [containers_BSBContainer, BSBContainer_BSBContainer],
        button: [ButtonContainer["a"
        /* default */
        ], ButtonContainer["a"
        /* default */
        ]],
        buttonList: [containers_ButtonListContainer, ButtonListContainer_ButtonListContainer],
        buttonRootComponent: [containers_ButtonRootContainer, ButtonRootContainer_ButtonRootContainer],
        checkboxList: [containers_CheckboxListContainer, CheckboxListContainer_CheckboxListContainer],
        datePicker: [containers_DatePickerContainer, DatePickerContainer_DatePickerContainer],
        dropdown: [containers_DropdownContainer, DropdownContainer_DropdownContainer],
        email: [containers_EmailContainer, EmailContainer_EmailContainer],
        emailVerification: [containers_EmailVerificationContainer, EmailVerificationContainer_EmailVerificationContainer],
        fileUpload: [containers_FileUploadContainer, FileUploadContainer_FileUploadContainer],
        heading: [containers_HeadingContainer, containers_HeadingContainer],
        image: [containers_ImageContainer, containers_ImageContainer],
        netPromoterScore: [containers_NetPromoterScoreContainer, NetPromoterScoreContainer_NetPromoterScoreContainer],
        smsVerification: [containers_SMSVerificationContainer, SMSVerificationContainer_SMSVerificationContainer],
        progressBar: [containers_ProgressBarContainer, ProgressBarContainer_ProgressBarContainer],
        password: [containers_PasswordContainer, PasswordContainer_PasswordContainer],
        radioList: [containers_RadioListContainer, RadioListContainer_RadioListContainer],
        repeatable: [containers_RepeatableContainer, RepeatableContainer_RepeatableContainer],
        reviewTableNew: [containers_ReviewTableContainer_ReviewTableContainer, ReviewTableContainer_ReviewTableContainer],
        richTextArea: [containers_RichTextAreaContainer, RichTextAreaContainer_RichTextAreaContainer],
        numericInput: [containers_NumericInputContainer, NumericInputContainer_NumericInputContainer],
        numericSlider: [containers_NumericSliderContainer, NumericSliderContainer_NumericSliderContainer],
        text: [containers_TextContainer, TextContainer_TextContainer],
        textarea: [containers_TextareaContainer, TextareaContainer_TextareaContainer],
        search: [containers_SearchContainer, containers_SearchContainer],
        digitalSignature: [containers_DigitalSignatureContainer, DigitalSignatureContainer_DigitalSignatureContainer],
        trueFalse: [containers_TrueFalseContainer, TrueFalseContainer_TrueFalseContainer]
      };
      /**
       * Mapping between containers (using its renderer value as key) and the react container map without hocs
       * @type {Object}
       */

      var containerMap_containerMapWithoutHOCs = {};
      Object.entries(containerMap_containerMap).forEach(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            _ref2$ = slicedToArray_default()(_ref2[1], 2),
            containerMapWithoutHOC = _ref2$[1];

        containerMap_containerMapWithoutHOCs[key] = containerMapWithoutHOC;
      });
      /**
       * Mapping between containers (using its renderer value as key) and the react component
       * @type {Object}
       */

      var containerMap_containerMapWithPreventDefault = {};
      Object.entries(containerMap_containerMap).forEach(function (_ref3) {
        var _ref4 = slicedToArray_default()(_ref3, 2),
            key = _ref4[0],
            _ref4$ = slicedToArray_default()(_ref4[1], 1),
            containerWithHOC = _ref4$[0];

        containerMap_containerMapWithPreventDefault[key] = containerMap_preventUpdatingUnnecessarily(containerWithHOC);
      });
      /* harmony default export */

      var config_containerMap = __webpack_exports__["b"] = containerMap_containerMapWithPreventDefault;
      /***/
    },
    /* 148 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return createChainedFunction;
      });
      /**
       * Safe chained function
       *
       * Will only create a new function if needed,
       * otherwise will pass back existing functions or null.
       *
       * @returns {function|null}
       */


      function createChainedFunction() {
        var args = [].slice.call(arguments, 0);

        if (args.length === 1) {
          return args[0];
        }

        return function chainedFunction() {
          for (var i = 0; i < args.length; i++) {
            if (args[i] && args[i].apply) {
              args[i].apply(this, arguments);
            }
          }
        };
      }
      /***/

    },
    /* 149 */

    /***/
    function (module, exports, __webpack_require__) {
      /**
       * Module dependencies.
       */
      try {
        var index = __webpack_require__(643);
      } catch (err) {
        var index = __webpack_require__(643);
      }
      /**
       * Whitespace regexp.
       */


      var re = /\s+/;
      /**
       * toString reference.
       */

      var toString = Object.prototype.toString;
      /**
       * Wrap `el` in a `ClassList`.
       *
       * @param {Element} el
       * @return {ClassList}
       * @api public
       */

      module.exports = function (el) {
        return new ClassList(el);
      };
      /**
       * Initialize a new ClassList for `el`.
       *
       * @param {Element} el
       * @api private
       */


      function ClassList(el) {
        if (!el || !el.nodeType) {
          throw new Error('A DOM element reference is required');
        }

        this.el = el;
        this.list = el.classList;
      }
      /**
       * Add class `name` if not already present.
       *
       * @param {String} name
       * @return {ClassList}
       * @api public
       */


      ClassList.prototype.add = function (name) {
        // classList
        if (this.list) {
          this.list.add(name);
          return this;
        } // fallback


        var arr = this.array();
        var i = index(arr, name);
        if (!~i) arr.push(name);
        this.el.className = arr.join(' ');
        return this;
      };
      /**
       * Remove class `name` when present, or
       * pass a regular expression to remove
       * any which match.
       *
       * @param {String|RegExp} name
       * @return {ClassList}
       * @api public
       */


      ClassList.prototype.remove = function (name) {
        if ('[object RegExp]' == toString.call(name)) {
          return this.removeMatching(name);
        } // classList


        if (this.list) {
          this.list.remove(name);
          return this;
        } // fallback


        var arr = this.array();
        var i = index(arr, name);
        if (~i) arr.splice(i, 1);
        this.el.className = arr.join(' ');
        return this;
      };
      /**
       * Remove all classes matching `re`.
       *
       * @param {RegExp} re
       * @return {ClassList}
       * @api private
       */


      ClassList.prototype.removeMatching = function (re) {
        var arr = this.array();

        for (var i = 0; i < arr.length; i++) {
          if (re.test(arr[i])) {
            this.remove(arr[i]);
          }
        }

        return this;
      };
      /**
       * Toggle class `name`, can force state via `force`.
       *
       * For browsers that support classList, but do not support `force` yet,
       * the mistake will be detected and corrected.
       *
       * @param {String} name
       * @param {Boolean} force
       * @return {ClassList}
       * @api public
       */


      ClassList.prototype.toggle = function (name, force) {
        // classList
        if (this.list) {
          if ("undefined" !== typeof force) {
            if (force !== this.list.toggle(name, force)) {
              this.list.toggle(name); // toggle again to correct
            }
          } else {
            this.list.toggle(name);
          }

          return this;
        } // fallback


        if ("undefined" !== typeof force) {
          if (!force) {
            this.remove(name);
          } else {
            this.add(name);
          }
        } else {
          if (this.has(name)) {
            this.remove(name);
          } else {
            this.add(name);
          }
        }

        return this;
      };
      /**
       * Return an array of classes.
       *
       * @return {Array}
       * @api public
       */


      ClassList.prototype.array = function () {
        var className = this.el.getAttribute('class') || '';
        var str = className.replace(/^\s+|\s+$/g, '');
        var arr = str.split(re);
        if ('' === arr[0]) arr.shift();
        return arr;
      };
      /**
       * Check if class `name` is present.
       *
       * @param {String} name
       * @return {ClassList}
       * @api public
       */


      ClassList.prototype.has = ClassList.prototype.contains = function (name) {
        return this.list ? this.list.contains(name) : !!~index(this.array(), name);
      };
      /***/

    },
    /* 150 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var DenseMatrix = type.DenseMatrix;
        /**
         * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
         * Callback function invoked MxN times.
         *
         *
         *          ┌  f(Sij, b)  ; S(i,j) !== 0
         * C(i,j) = ┤
         *          └  f(0, b)    ; otherwise
         *
         *
         * @param {Matrix}   s                 The SparseMatrix instance (S)
         * @param {Scalar}   b                 The Scalar value
         * @param {Function} callback          The f(Aij,b) operation to invoke
         * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
         *
         * @return {Matrix}                    DenseMatrix (C)
         *
         * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
         */

        var algorithm12 = function algorithm12(s, b, callback, inverse) {
          // sparse matrix arrays
          var avalues = s._values;
          var aindex = s._index;
          var aptr = s._ptr;
          var asize = s._size;
          var adt = s._datatype; // sparse matrix cannot be a Pattern matrix

          if (!avalues) {
            throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
          } // rows & columns


          var rows = asize[0];
          var columns = asize[1]; // datatype

          var dt; // callback signature to use

          var cf = callback; // process data types

          if (typeof adt === 'string') {
            // datatype
            dt = adt; // convert b to the same datatype

            b = typed.convert(b, dt); // callback

            cf = typed.find(callback, [dt, dt]);
          } // result arrays


          var cdata = []; // matrix

          var c = new DenseMatrix({
            data: cdata,
            size: [rows, columns],
            datatype: dt
          }); // workspaces

          var x = []; // marks indicating we have a value in x for a given column

          var w = []; // loop columns

          for (var j = 0; j < columns; j++) {
            // columns mark
            var mark = j + 1; // values in j

            for (var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
              // row
              var r = aindex[k]; // update workspace

              x[r] = avalues[k];
              w[r] = mark;
            } // loop rows


            for (var i = 0; i < rows; i++) {
              // initialize C on first column
              if (j === 0) {
                // create row array
                cdata[i] = [];
              } // check sparse matrix has a value @ i,j


              if (w[i] === mark) {
                // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
              } else {
                // dense matrix value @ i, j
                cdata[i][j] = inverse ? cf(b, 0) : cf(0, b);
              }
            }
          } // return sparse matrix


          return c;
        };

        return algorithm12;
      }

      exports.name = 'algorithm12';
      exports.factory = factory;
      /***/
    },
    /* 151 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.array = __webpack_require__(48);
      exports['boolean'] = __webpack_require__(773);
      exports['function'] = __webpack_require__(232);
      exports.number = __webpack_require__(67);
      exports.object = __webpack_require__(59);
      exports.string = __webpack_require__(79);
      exports.emitter = __webpack_require__(413);
      /***/
    },
    /* 152 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var DimensionError = __webpack_require__(92);

      function factory(type, config, load, typed) {
        var DenseMatrix = type.DenseMatrix;
        /**
         * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
         * Callback function invoked M*N times.
         *
         *
         *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
         * C(i,j) = ┤
         *          └  f(Dij, 0)    ; otherwise
         *
         *
         * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
         * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
         * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
         * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
         *
         * @return {Matrix}                    DenseMatrix (C)
         *
         * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
         */

        var algorithm03 = function algorithm03(denseMatrix, sparseMatrix, callback, inverse) {
          // dense matrix arrays
          var adata = denseMatrix._data;
          var asize = denseMatrix._size;
          var adt = denseMatrix._datatype; // sparse matrix arrays

          var bvalues = sparseMatrix._values;
          var bindex = sparseMatrix._index;
          var bptr = sparseMatrix._ptr;
          var bsize = sparseMatrix._size;
          var bdt = sparseMatrix._datatype; // validate dimensions

          if (asize.length !== bsize.length) {
            throw new DimensionError(asize.length, bsize.length);
          } // check rows & columns


          if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) {
            throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
          } // sparse matrix cannot be a Pattern matrix


          if (!bvalues) {
            throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
          } // rows & columns


          var rows = asize[0];
          var columns = asize[1]; // datatype

          var dt; // zero value

          var zero = 0; // callback signature to use

          var cf = callback; // process data types

          if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype

            zero = typed.convert(0, dt); // callback

            cf = typed.find(callback, [dt, dt]);
          } // result (DenseMatrix)


          var cdata = []; // initialize dense matrix

          for (var z = 0; z < rows; z++) {
            // initialize row
            cdata[z] = [];
          } // workspace


          var x = []; // marks indicating we have a value in x for a given column

          var w = []; // loop columns in b

          for (var j = 0; j < columns; j++) {
            // column mark
            var mark = j + 1; // values in column j

            for (var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
              // row
              var i = bindex[k]; // update workspace

              x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
              w[i] = mark;
            } // process workspace


            for (var y = 0; y < rows; y++) {
              // check we have a calculated value for current row
              if (w[y] === mark) {
                // use calculated value
                cdata[y][j] = x[y];
              } else {
                // calculate value
                cdata[y][j] = inverse ? cf(zero, adata[y][j]) : cf(adata[y][j], zero);
              }
            }
          } // return dense matrix


          return new DenseMatrix({
            data: cdata,
            size: [rows, columns],
            datatype: dt
          });
        };

        return algorithm03;
      }

      exports.name = 'algorithm03';
      exports.factory = factory;
      /***/
    },
    /* 153 */

    /***/
    function (module, exports, __webpack_require__) {
      var DataView = __webpack_require__(947),
          Map = __webpack_require__(350),
          Promise = __webpack_require__(946),
          Set = __webpack_require__(457),
          WeakMap = __webpack_require__(945),
          baseGetTag = __webpack_require__(135),
          toSource = __webpack_require__(508);
      /** `Object#toString` result references. */


      var mapTag = '[object Map]',
          objectTag = '[object Object]',
          promiseTag = '[object Promise]',
          setTag = '[object Set]',
          weakMapTag = '[object WeakMap]';
      var dataViewTag = '[object DataView]';
      /** Used to detect maps, sets, and weakmaps. */

      var dataViewCtorString = toSource(DataView),
          mapCtorString = toSource(Map),
          promiseCtorString = toSource(Promise),
          setCtorString = toSource(Set),
          weakMapCtorString = toSource(WeakMap);
      /**
       * Gets the `toStringTag` of `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */

      var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
        getTag = function getTag(value) {
          var result = baseGetTag(value),
              Ctor = result == objectTag ? value.constructor : undefined,
              ctorString = Ctor ? toSource(Ctor) : '';

          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;

              case mapCtorString:
                return mapTag;

              case promiseCtorString:
                return promiseTag;

              case setCtorString:
                return setTag;

              case weakMapCtorString:
                return weakMapTag;
            }
          }

          return result;
        };
      }

      module.exports = getTag;
      /***/
    },
    /* 154 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      /**
       * Unicode-enabled replacesments for basic String functions.
       *
       * All the functions in this module assume that the input string is a valid
       * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
       * will be undefined.
       *
       * WARNING: Since this module is typechecks-enforced, you may find new bugs
       * when replacing normal String functions with ones provided here.
       */

      var invariant = __webpack_require__(51); // These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
      // surrogate code unit.


      var SURROGATE_HIGH_START = 0xD800;
      var SURROGATE_HIGH_END = 0xDBFF;
      var SURROGATE_LOW_START = 0xDC00;
      var SURROGATE_LOW_END = 0xDFFF;
      var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
      /**
       * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
       * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
       */

      function isCodeUnitInSurrogateRange(codeUnit) {
        return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
      }
      /**
       * Returns whether the two characters starting at `index` form a surrogate pair.
       * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
       * (s, 1) returns false.
       *
       * @param {string} str
       * @param {number} index
       * @return {boolean}
       */


      function isSurrogatePair(str, index) {
        !(0 <= index && index < str.length) ? false ? undefined : invariant(false) : void 0;

        if (index + 1 === str.length) {
          return false;
        }

        var first = str.charCodeAt(index);
        var second = str.charCodeAt(index + 1);
        return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
      }
      /**
       * @param {string} str  Non-empty string
       * @return {boolean}    True if the input includes any surrogate code units
       */


      function hasSurrogateUnit(str) {
        return SURROGATE_UNITS_REGEX.test(str);
      }
      /**
       * Return the length of the original Unicode character at given position in the
       * String by looking into the UTF-16 code unit; that is equal to 1 for any
       * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
       * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
       * representing non-BMP characters ([U+10000..U+10FFFF]).
       *
       * Examples:
       * - '\u0020' => 1
       * - '\u3020' => 1
       * - '\uD835' => 2
       * - '\uD835\uDDEF' => 2
       * - '\uDDEF' => 2
       *
       * @param {string} str  Non-empty string
       * @param {number} pos  Position in the string to look for one code unit
       * @return {number}      Number 1 or 2
       */


      function getUTF16Length(str, pos) {
        return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
      }
      /**
       * Fully Unicode-enabled replacement for String#length
       *
       * @param {string} str  Valid Unicode string
       * @return {number}     The number of Unicode characters in the string
       */


      function strlen(str) {
        // Call the native functions if there's no surrogate char
        if (!hasSurrogateUnit(str)) {
          return str.length;
        }

        var len = 0;

        for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
          len++;
        }

        return len;
      }
      /**
       * Fully Unicode-enabled replacement for String#substr()
       *
       * @param {string} str      Valid Unicode string
       * @param {number} start    Location in Unicode sequence to begin extracting
       * @param {?number} length  The number of Unicode characters to extract
       *                          (default: to the end of the string)
       * @return {string}         Extracted sub-string
       */


      function substr(str, start, length) {
        start = start || 0;
        length = length === undefined ? Infinity : length || 0; // Call the native functions if there's no surrogate char

        if (!hasSurrogateUnit(str)) {
          return str.substr(start, length);
        } // Obvious cases


        var size = str.length;

        if (size <= 0 || start > size || length <= 0) {
          return '';
        } // Find the actual starting position


        var posA = 0;

        if (start > 0) {
          for (; start > 0 && posA < size; start--) {
            posA += getUTF16Length(str, posA);
          }

          if (posA >= size) {
            return '';
          }
        } else if (start < 0) {
          for (posA = size; start < 0 && 0 < posA; start++) {
            posA -= getUTF16Length(str, posA - 1);
          }

          if (posA < 0) {
            posA = 0;
          }
        } // Find the actual ending position


        var posB = size;

        if (length < size) {
          for (posB = posA; length > 0 && posB < size; length--) {
            posB += getUTF16Length(str, posB);
          }
        }

        return str.substring(posA, posB);
      }
      /**
       * Fully Unicode-enabled replacement for String#substring()
       *
       * @param {string} str    Valid Unicode string
       * @param {number} start  Location in Unicode sequence to begin extracting
       * @param {?number} end   Location in Unicode sequence to end extracting
       *                        (default: end of the string)
       * @return {string}       Extracted sub-string
       */


      function substring(str, start, end) {
        start = start || 0;
        end = end === undefined ? Infinity : end || 0;

        if (start < 0) {
          start = 0;
        }

        if (end < 0) {
          end = 0;
        }

        var length = Math.abs(end - start);
        start = start < end ? start : end;
        return substr(str, start, length);
      }
      /**
       * Get a list of Unicode code-points from a String
       *
       * @param {string} str        Valid Unicode string
       * @return {array<number>}    A list of code-points in [0..0x10FFFF]
       */


      function getCodePoints(str) {
        var codePoints = [];

        for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
          codePoints.push(str.codePointAt(pos));
        }

        return codePoints;
      }

      var UnicodeUtils = {
        getCodePoints: getCodePoints,
        getUTF16Length: getUTF16Length,
        hasSurrogateUnit: hasSurrogateUnit,
        isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
        isSurrogatePair: isSurrogatePair,
        strlen: strlen,
        substring: substring,
        substr: substr
      };
      module.exports = UnicodeUtils;
      /***/
    },
    /* 155 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule ContentBlock
       * @format
       * 
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var CharacterMetadata = __webpack_require__(96);

      var Immutable = __webpack_require__(53);

      var findRangesImmutable = __webpack_require__(205);

      var List = Immutable.List,
          Map = Immutable.Map,
          OrderedSet = Immutable.OrderedSet,
          Record = Immutable.Record,
          Repeat = Immutable.Repeat;
      var EMPTY_SET = OrderedSet();
      var defaultRecord = {
        key: '',
        type: 'unstyled',
        text: '',
        characterList: List(),
        depth: 0,
        data: Map()
      };
      var ContentBlockRecord = Record(defaultRecord);

      var decorateCharacterList = function decorateCharacterList(config) {
        if (!config) {
          return config;
        }

        var characterList = config.characterList,
            text = config.text;

        if (text && !characterList) {
          config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
        }

        return config;
      };

      var ContentBlock = function (_ContentBlockRecord) {
        _inherits(ContentBlock, _ContentBlockRecord);

        function ContentBlock(config) {
          _classCallCheck(this, ContentBlock);

          return _possibleConstructorReturn(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
        }

        ContentBlock.prototype.getKey = function getKey() {
          return this.get('key');
        };

        ContentBlock.prototype.getType = function getType() {
          return this.get('type');
        };

        ContentBlock.prototype.getText = function getText() {
          return this.get('text');
        };

        ContentBlock.prototype.getCharacterList = function getCharacterList() {
          return this.get('characterList');
        };

        ContentBlock.prototype.getLength = function getLength() {
          return this.getText().length;
        };

        ContentBlock.prototype.getDepth = function getDepth() {
          return this.get('depth');
        };

        ContentBlock.prototype.getData = function getData() {
          return this.get('data');
        };

        ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
          var character = this.getCharacterList().get(offset);
          return character ? character.getStyle() : EMPTY_SET;
        };

        ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
          var character = this.getCharacterList().get(offset);
          return character ? character.getEntity() : null;
        };
        /**
         * Execute a callback for every contiguous range of styles within the block.
         */


        ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
          findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
        };
        /**
         * Execute a callback for every contiguous range of entities within the block.
         */


        ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
          findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
        };

        return ContentBlock;
      }(ContentBlockRecord);

      function haveEqualStyle(charA, charB) {
        return charA.getStyle() === charB.getStyle();
      }

      function haveEqualEntity(charA, charB) {
        return charA.getEntity() === charB.getEntity();
      }

      module.exports = ContentBlock;
      /***/
    },
    /* 156 */

    /***/
    function (module, exports, __webpack_require__) {
      var assignValue = __webpack_require__(248),
          baseAssignValue = __webpack_require__(210);
      /**
       * Copies properties of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy properties from.
       * @param {Array} props The property identifiers to copy.
       * @param {Object} [object={}] The object to copy properties to.
       * @param {Function} [customizer] The function to customize copied values.
       * @returns {Object} Returns `object`.
       */


      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index = -1,
            length = props.length;

        while (++index < length) {
          var key = props[index];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

          if (newValue === undefined) {
            newValue = source[key];
          }

          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }

        return object;
      }

      module.exports = copyObject;
      /***/
    },
    /* 157 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIsNative = __webpack_require__(1085),
          getValue = __webpack_require__(1082);
      /**
       * Gets the native function at `key` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the method to get.
       * @returns {*} Returns the function if it's native, else `undefined`.
       */


      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined;
      }

      module.exports = getNative;
      /***/
    },
    /* 158 */

    /***/
    function (module, exports, __webpack_require__) {
      var root = __webpack_require__(103);
      /** Built-in value references. */


      var Symbol = root.Symbol;
      module.exports = Symbol;
      /***/
    },
    /* 159 */

    /***/
    function (module, exports, __webpack_require__) {
      // to indexed object, toObject with fallback for non-array-like ES3 strings
      var IObject = __webpack_require__(651);

      var defined = __webpack_require__(366);

      module.exports = function (it) {
        return IObject(defined(it));
      };
      /***/

    },
    /* 160 */

    /***/
    function (module, exports) {
      var hasOwnProperty = {}.hasOwnProperty;

      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };
      /***/

    },
    /* 161 */

    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(180);

      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + ' is not an object!');
        return it;
      };
      /***/

    },
    /* 162 */

    /***/
    function (module, exports) {
      // shim for using process in browser
      var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
      // don't break things.  But we need to wrap it in a try catch in case it is
      // wrapped in strict mode code which doesn't define any globals.  It's inside a
      // function because try/catches deoptimize in certain engines.

      var cachedSetTimeout;
      var cachedClearTimeout;

      function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
      }

      function defaultClearTimeout() {
        throw new Error('clearTimeout has not been defined');
      }

      (function () {
        try {
          if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
          } else {
            cachedSetTimeout = defaultSetTimout;
          }
        } catch (e) {
          cachedSetTimeout = defaultSetTimout;
        }

        try {
          if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
          } else {
            cachedClearTimeout = defaultClearTimeout;
          }
        } catch (e) {
          cachedClearTimeout = defaultClearTimeout;
        }
      })();

      function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
        } // if setTimeout wasn't available but was latter defined


        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
        }

        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
          }
        }
      }

      function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
        } // if clearTimeout wasn't available but was latter defined


        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
        }

        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
          }
        }
      }

      var queue = [];
      var draining = false;
      var currentQueue;
      var queueIndex = -1;

      function cleanUpNextTick() {
        if (!draining || !currentQueue) {
          return;
        }

        draining = false;

        if (currentQueue.length) {
          queue = currentQueue.concat(queue);
        } else {
          queueIndex = -1;
        }

        if (queue.length) {
          drainQueue();
        }
      }

      function drainQueue() {
        if (draining) {
          return;
        }

        var timeout = runTimeout(cleanUpNextTick);
        draining = true;
        var len = queue.length;

        while (len) {
          currentQueue = queue;
          queue = [];

          while (++queueIndex < len) {
            if (currentQueue) {
              currentQueue[queueIndex].run();
            }
          }

          queueIndex = -1;
          len = queue.length;
        }

        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
      }

      process.nextTick = function (fun) {
        var args = new Array(arguments.length - 1);

        if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
          }
        }

        queue.push(new Item(fun, args));

        if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
        }
      }; // v8 likes predictible objects


      function Item(fun, array) {
        this.fun = fun;
        this.array = array;
      }

      Item.prototype.run = function () {
        this.fun.apply(null, this.array);
      };

      process.title = 'browser';
      process.browser = true;
      process.env = {};
      process.argv = [];
      process.version = ''; // empty string to avoid regexp issues

      process.versions = {};

      function noop() {}

      process.on = noop;
      process.addListener = noop;
      process.once = noop;
      process.off = noop;
      process.removeListener = noop;
      process.removeAllListeners = noop;
      process.emit = noop;
      process.prependListener = noop;
      process.prependOnceListener = noop;

      process.listeners = function (name) {
        return [];
      };

      process.binding = function (name) {
        throw new Error('process.binding is not supported');
      };

      process.cwd = function () {
        return '/';
      };

      process.chdir = function (dir) {
        throw new Error('process.chdir is not supported');
      };

      process.umask = function () {
        return 0;
      };
      /***/

    },
    /* 163 */

    /***/
    function (module, exports) {
      /**
       * Performs a
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * comparison between two values to determine if they are equivalent.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * var object = { 'a': 1 };
       * var other = { 'a': 1 };
       *
       * _.eq(object, object);
       * // => true
       *
       * _.eq(object, other);
       * // => false
       *
       * _.eq('a', 'a');
       * // => true
       *
       * _.eq('a', Object('a'));
       * // => false
       *
       * _.eq(NaN, NaN);
       * // => true
       */
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }

      module.exports = eq;
      /***/
    },
    /* 164 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js

      var helpers_typeof = __webpack_require__(49);

      var typeof_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_typeof); // CONCATENATED MODULE: ./node_modules/css-animation/es/Event.js


      var START_EVENT_NAME_MAP = {
        transitionstart: {
          transition: 'transitionstart',
          WebkitTransition: 'webkitTransitionStart',
          MozTransition: 'mozTransitionStart',
          OTransition: 'oTransitionStart',
          msTransition: 'MSTransitionStart'
        },
        animationstart: {
          animation: 'animationstart',
          WebkitAnimation: 'webkitAnimationStart',
          MozAnimation: 'mozAnimationStart',
          OAnimation: 'oAnimationStart',
          msAnimation: 'MSAnimationStart'
        }
      };
      var END_EVENT_NAME_MAP = {
        transitionend: {
          transition: 'transitionend',
          WebkitTransition: 'webkitTransitionEnd',
          MozTransition: 'mozTransitionEnd',
          OTransition: 'oTransitionEnd',
          msTransition: 'MSTransitionEnd'
        },
        animationend: {
          animation: 'animationend',
          WebkitAnimation: 'webkitAnimationEnd',
          MozAnimation: 'mozAnimationEnd',
          OAnimation: 'oAnimationEnd',
          msAnimation: 'MSAnimationEnd'
        }
      };
      var startEvents = [];
      var endEvents = [];

      function detectEvents() {
        var testEl = document.createElement('div');
        var style = testEl.style;

        if (!('AnimationEvent' in window)) {
          delete START_EVENT_NAME_MAP.animationstart.animation;
          delete END_EVENT_NAME_MAP.animationend.animation;
        }

        if (!('TransitionEvent' in window)) {
          delete START_EVENT_NAME_MAP.transitionstart.transition;
          delete END_EVENT_NAME_MAP.transitionend.transition;
        }

        function process(EVENT_NAME_MAP, events) {
          for (var baseEventName in EVENT_NAME_MAP) {
            if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
              var baseEvents = EVENT_NAME_MAP[baseEventName];

              for (var styleName in baseEvents) {
                if (styleName in style) {
                  events.push(baseEvents[styleName]);
                  break;
                }
              }
            }
          }
        }

        process(START_EVENT_NAME_MAP, startEvents);
        process(END_EVENT_NAME_MAP, endEvents);
      }

      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        detectEvents();
      }

      function addEventListener(node, eventName, eventListener) {
        node.addEventListener(eventName, eventListener, false);
      }

      function removeEventListener(node, eventName, eventListener) {
        node.removeEventListener(eventName, eventListener, false);
      }

      var TransitionEvents = {
        // Start events
        startEvents: startEvents,
        addStartEventListener: function addStartEventListener(node, eventListener) {
          if (startEvents.length === 0) {
            window.setTimeout(eventListener, 0);
            return;
          }

          startEvents.forEach(function (startEvent) {
            addEventListener(node, startEvent, eventListener);
          });
        },
        removeStartEventListener: function removeStartEventListener(node, eventListener) {
          if (startEvents.length === 0) {
            return;
          }

          startEvents.forEach(function (startEvent) {
            removeEventListener(node, startEvent, eventListener);
          });
        },
        // End events
        endEvents: endEvents,
        addEndEventListener: function addEndEventListener(node, eventListener) {
          if (endEvents.length === 0) {
            window.setTimeout(eventListener, 0);
            return;
          }

          endEvents.forEach(function (endEvent) {
            addEventListener(node, endEvent, eventListener);
          });
        },
        removeEndEventListener: function removeEndEventListener(node, eventListener) {
          if (endEvents.length === 0) {
            return;
          }

          endEvents.forEach(function (endEvent) {
            removeEventListener(node, endEvent, eventListener);
          });
        }
      };
      /* harmony default export */

      var Event = TransitionEvents; // EXTERNAL MODULE: ./node_modules/component-classes/index.js

      var component_classes = __webpack_require__(149);

      var component_classes_default =
      /*#__PURE__*/
      __webpack_require__.n(component_classes); // CONCATENATED MODULE: ./node_modules/css-animation/es/index.js

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return es_isCssAnimationSupported;
      });

      var es_isCssAnimationSupported = Event.endEvents.length !== 0;
      var es_capitalPrefixes = ['Webkit', 'Moz', 'O', // ms is special .... !
      'ms'];
      var es_prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

      function es_getStyleProperty(node, name) {
        // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
        var style = window.getComputedStyle(node, null);
        var ret = '';

        for (var i = 0; i < es_prefixes.length; i++) {
          ret = style.getPropertyValue(es_prefixes[i] + name);

          if (ret) {
            break;
          }
        }

        return ret;
      }

      function es_fixBrowserByTimeout(node) {
        if (es_isCssAnimationSupported) {
          var transitionDelay = parseFloat(es_getStyleProperty(node, 'transition-delay')) || 0;
          var transitionDuration = parseFloat(es_getStyleProperty(node, 'transition-duration')) || 0;
          var animationDelay = parseFloat(es_getStyleProperty(node, 'animation-delay')) || 0;
          var animationDuration = parseFloat(es_getStyleProperty(node, 'animation-duration')) || 0;
          var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay); // sometimes, browser bug

          node.rcEndAnimTimeout = setTimeout(function () {
            node.rcEndAnimTimeout = null;

            if (node.rcEndListener) {
              node.rcEndListener();
            }
          }, time * 1000 + 200);
        }
      }

      function es_clearBrowserBugTimeout(node) {
        if (node.rcEndAnimTimeout) {
          clearTimeout(node.rcEndAnimTimeout);
          node.rcEndAnimTimeout = null;
        }
      }

      var es_cssAnimation = function cssAnimation(node, transitionName, endCallback) {
        var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : typeof_default()(transitionName)) === 'object';
        var className = nameIsObj ? transitionName.name : transitionName;
        var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
        var end = endCallback;
        var start = void 0;
        var active = void 0;
        var nodeClasses = component_classes_default()(node);

        if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
          end = endCallback.end;
          start = endCallback.start;
          active = endCallback.active;
        }

        if (node.rcEndListener) {
          node.rcEndListener();
        }

        node.rcEndListener = function (e) {
          if (e && e.target !== node) {
            return;
          }

          if (node.rcAnimTimeout) {
            clearTimeout(node.rcAnimTimeout);
            node.rcAnimTimeout = null;
          }

          es_clearBrowserBugTimeout(node);
          nodeClasses.remove(className);
          nodeClasses.remove(activeClassName);
          Event.removeEndEventListener(node, node.rcEndListener);
          node.rcEndListener = null; // Usually this optional end is used for informing an owner of
          // a leave animation and telling it to remove the child.

          if (end) {
            end();
          }
        };

        Event.addEndEventListener(node, node.rcEndListener);

        if (start) {
          start();
        }

        nodeClasses.add(className);
        node.rcAnimTimeout = setTimeout(function () {
          node.rcAnimTimeout = null;
          nodeClasses.add(activeClassName);

          if (active) {
            setTimeout(active, 0);
          }

          es_fixBrowserByTimeout(node); // 30ms for firefox
        }, 30);
        return {
          stop: function stop() {
            if (node.rcEndListener) {
              node.rcEndListener();
            }
          }
        };
      };

      es_cssAnimation.style = function (node, style, callback) {
        if (node.rcEndListener) {
          node.rcEndListener();
        }

        node.rcEndListener = function (e) {
          if (e && e.target !== node) {
            return;
          }

          if (node.rcAnimTimeout) {
            clearTimeout(node.rcAnimTimeout);
            node.rcAnimTimeout = null;
          }

          es_clearBrowserBugTimeout(node);
          Event.removeEndEventListener(node, node.rcEndListener);
          node.rcEndListener = null; // Usually this optional callback is used for informing an owner of
          // a leave animation and telling it to remove the child.

          if (callback) {
            callback();
          }
        };

        Event.addEndEventListener(node, node.rcEndListener);
        node.rcAnimTimeout = setTimeout(function () {
          for (var s in style) {
            if (style.hasOwnProperty(s)) {
              node.style[s] = style[s];
            }
          }

          node.rcAnimTimeout = null;
          es_fixBrowserByTimeout(node);
        }, 0);
      };

      es_cssAnimation.setTransition = function (node, p, value) {
        var property = p;
        var v = value;

        if (value === undefined) {
          v = property;
          property = '';
        }

        property = property || '';
        es_capitalPrefixes.forEach(function (prefix) {
          node.style[prefix + 'Transition' + property] = v;
        });
      };

      es_cssAnimation.isCssAnimationSupported = es_isCssAnimationSupported;
      /* harmony default export */

      var es = __webpack_exports__["a"] = es_cssAnimation;
      /***/
    },
    /* 165 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);

      var Button = function Button(props) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", {
          className: props.className,
          onClick: props.onClick,
          type: props.type,
          disabled: props.disabled,
          value: props.value
        }, props.label);
      };

      Button.defaultProps = {
        className: 'formatic-button',
        disabled: false,
        label: '',
        onClick: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        type: 'button',
        value: ''
      };
      Button.propTypes = {
        className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
        label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        type: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
      };
      /* harmony default export */

      __webpack_exports__["a"] = Button;
      /***/
    },
    /* 166 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var handlebars__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(384);
      /* harmony import */


      var handlebars__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(handlebars__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);

      handlebars__WEBPACK_IMPORTED_MODULE_0___default.a.registerHelper('dynamicVariable', function (source, key, _ref) {
        var data = _ref.data.root;

        if (!source) {
          return '';
        }

        return lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(data, "variables.form.".concat(source, ".").concat(key), '');
      });
      /* harmony default export */

      __webpack_exports__["a"] = handlebars__WEBPACK_IMPORTED_MODULE_0___default.a;
      /***/
    },
    /* 167 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _core_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18);

      var Text = function Text(props) {
        return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("input", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, props, {
          autoComplete: props.autoComplete,
          id: props.id,
          className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, props.className, props.className), {
            'formatic-field-read-only': props.readOnly
          }),
          type: props.type,
          value: props.value,
          onChange: props.onChange,
          onBlur: props.onBlur,
          onFocus: props.onFocus,
          placeholder: props.placeholder,
          maxLength: props.maxLength,
          readOnly: props.readOnly
        }));
      };

      Text.defaultProps = {
        autoComplete: 'on',
        className: '',
        id: Object(_core_utils__WEBPACK_IMPORTED_MODULE_6__[
        /* getRandomId */
        "k"])(),
        maxLength: 255,
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_4___default.a,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_4___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_4___default.a,
        placeholder: '',
        type: 'text',
        value: '',
        // attributes from dashboard
        readOnly: false
      };
      Text.propTypes = {
        autoComplete: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        type: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        value: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        // attributes from dashboard
        maxLength: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string]),
        placeholder: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        readOnly: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool
      };
      /* harmony default export */

      __webpack_exports__["a"] = Text;
      /***/
    },
    /* 168 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return contains;
      });

      function contains(root, n) {
        var node = n;

        while (node) {
          if (node === root) {
            return true;
          }

          node = node.parentNode;
        }

        return false;
      }
      /***/

    },
    /* 169 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony default export */

      __webpack_exports__["a"] = {
        AutoComplete: 'on',
        RequiredSuffixLabel: '',
        ShowRequiredSuffixLabel: false
      };
      /***/
    },
    /* 170 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var extend = __webpack_require__(59).extend;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var addScalar = load(__webpack_require__(197));

        var latex = __webpack_require__(72);

        var algorithm01 = load(__webpack_require__(405));
        var algorithm04 = load(__webpack_require__(775));
        var algorithm10 = load(__webpack_require__(404));
        var algorithm13 = load(__webpack_require__(129));
        var algorithm14 = load(__webpack_require__(107));
        /**
         * Add two or more values, `x + y`.
         * For matrices, the function is evaluated element wise.
         *
         * Syntax:
         *
         *    math.add(x, y)
         *    math.add(x, y, z, ...)
         *
         * Examples:
         *
         *    math.add(2, 3)               // returns number 5
         *    math.add(2, 3, 4)            // returns number 9
         *
         *    const a = math.complex(2, 3)
         *    const b = math.complex(-4, 1)
         *    math.add(a, b)               // returns Complex -2 + 4i
         *
         *    math.add([1, 2, 3], 4)       // returns Array [5, 6, 7]
         *
         *    const c = math.unit('5 cm')
         *    const d = math.unit('2.1 mm')
         *    math.add(c, d)               // returns Unit 52.1 mm
         *
         *    math.add("2.3", "4")         // returns number 6.3
         *
         * See also:
         *
         *    subtract, sum
         *
         * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to add
         * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to add
         * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
         */

        var add = typed('add', extend({
          // we extend the signatures of addScalar with signatures dealing with matrices
          'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, addScalar);
          },
          'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, addScalar, false);
          },
          'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, addScalar, true);
          },
          'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, addScalar);
          },
          'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return add(matrix(x), matrix(y)).valueOf();
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return add(matrix(x), y);
          },
          'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return add(x, matrix(y));
          },
          'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, addScalar, false);
          },
          'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm10(x, y, addScalar, false);
          },
          'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, addScalar, true);
          },
          'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm10(y, x, addScalar, true);
          },
          'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, addScalar, false).valueOf();
          },
          'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, addScalar, true).valueOf();
          },
          'any, any': addScalar,
          'any, any, ...any': function anyAnyAny(x, y, rest) {
            var result = add(x, y);

            for (var i = 0; i < rest.length; i++) {
              result = add(result, rest[i]);
            }

            return result;
          }
        }, addScalar.signatures));
        add.toTex = {
          2: "\\left(${args[0]}".concat(latex.operators['add'], "${args[1]}\\right)")
        };
        return add;
      }

      exports.name = 'add';
      exports.factory = factory;
      /***/
    },
    /* 171 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // list of identifiers of nodes in order of their precedence
      // also contains information about left/right associativity
      // and which other operator the operator is associative with
      // Example:
      // addition is associative with addition and subtraction, because:
      // (a+b)+c=a+(b+c)
      // (a+b)-c=a+(b-c)
      //
      // postfix operators are left associative, prefix operators
      // are right associative
      //
      // It's also possible to set the following properties:
      // latexParens: if set to false, this node doesn't need to be enclosed
      //              in parentheses when using LaTeX
      // latexLeftParens: if set to false, this !OperatorNode's!
      //                  left argument doesn't need to be enclosed
      //                  in parentheses
      // latexRightParens: the same for the right argument

      var properties = [{
        // assignment
        'AssignmentNode': {},
        'FunctionAssignmentNode': {}
      }, {
        // conditional expression
        'ConditionalNode': {
          latexLeftParens: false,
          latexRightParens: false,
          latexParens: false // conditionals don't need parentheses in LaTeX because
          // they are 2 dimensional

        }
      }, {
        // logical or
        'OperatorNode:or': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // logical xor
        'OperatorNode:xor': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // logical and
        'OperatorNode:and': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // bitwise or
        'OperatorNode:bitOr': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // bitwise xor
        'OperatorNode:bitXor': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // bitwise and
        'OperatorNode:bitAnd': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // relational operators
        'OperatorNode:equal': {
          associativity: 'left',
          associativeWith: []
        },
        'OperatorNode:unequal': {
          associativity: 'left',
          associativeWith: []
        },
        'OperatorNode:smaller': {
          associativity: 'left',
          associativeWith: []
        },
        'OperatorNode:larger': {
          associativity: 'left',
          associativeWith: []
        },
        'OperatorNode:smallerEq': {
          associativity: 'left',
          associativeWith: []
        },
        'OperatorNode:largerEq': {
          associativity: 'left',
          associativeWith: []
        },
        'RelationalNode': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // bitshift operators
        'OperatorNode:leftShift': {
          associativity: 'left',
          associativeWith: []
        },
        'OperatorNode:rightArithShift': {
          associativity: 'left',
          associativeWith: []
        },
        'OperatorNode:rightLogShift': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // unit conversion
        'OperatorNode:to': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // range
        'RangeNode': {}
      }, {
        // addition, subtraction
        'OperatorNode:add': {
          associativity: 'left',
          associativeWith: ['OperatorNode:add', 'OperatorNode:subtract']
        },
        'OperatorNode:subtract': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // multiply, divide, modulus
        'OperatorNode:multiply': {
          associativity: 'left',
          associativeWith: ['OperatorNode:multiply', 'OperatorNode:divide', 'Operator:dotMultiply', 'Operator:dotDivide']
        },
        'OperatorNode:divide': {
          associativity: 'left',
          associativeWith: [],
          latexLeftParens: false,
          latexRightParens: false,
          latexParens: false // fractions don't require parentheses because
          // they're 2 dimensional, so parens aren't needed
          // in LaTeX

        },
        'OperatorNode:dotMultiply': {
          associativity: 'left',
          associativeWith: ['OperatorNode:multiply', 'OperatorNode:divide', 'OperatorNode:dotMultiply', 'OperatorNode:doDivide']
        },
        'OperatorNode:dotDivide': {
          associativity: 'left',
          associativeWith: []
        },
        'OperatorNode:mod': {
          associativity: 'left',
          associativeWith: []
        }
      }, {
        // unary prefix operators
        'OperatorNode:unaryPlus': {
          associativity: 'right'
        },
        'OperatorNode:unaryMinus': {
          associativity: 'right'
        },
        'OperatorNode:bitNot': {
          associativity: 'right'
        },
        'OperatorNode:not': {
          associativity: 'right'
        }
      }, {
        // exponentiation
        'OperatorNode:pow': {
          associativity: 'right',
          associativeWith: [],
          latexRightParens: false // the exponent doesn't need parentheses in
          // LaTeX because it's 2 dimensional
          // (it's on top)

        },
        'OperatorNode:dotPow': {
          associativity: 'right',
          associativeWith: []
        }
      }, {
        // factorial
        'OperatorNode:factorial': {
          associativity: 'left'
        }
      }, {
        // matrix transpose
        'OperatorNode:transpose': {
          associativity: 'left'
        }
      }];
      /**
       * Get the precedence of a Node.
       * Higher number for higher precedence, starting with 0.
       * Returns null if the precedence is undefined.
       *
       * @param {Node}
       * @param {string} parenthesis
       * @return {number|null}
       */

      function getPrecedence(_node, parenthesis) {
        var node = _node;

        if (parenthesis !== 'keep') {
          // ParenthesisNodes are only ignored when not in 'keep' mode
          node = _node.getContent();
        }

        var identifier = node.getIdentifier();

        for (var i = 0; i < properties.length; i++) {
          if (identifier in properties[i]) {
            return i;
          }
        }

        return null;
      }
      /**
       * Get the associativity of an operator (left or right).
       * Returns a string containing 'left' or 'right' or null if
       * the associativity is not defined.
       *
       * @param {Node}
       * @param {string} parenthesis
       * @return {string|null}
       * @throws {Error}
       */


      function getAssociativity(_node, parenthesis) {
        var node = _node;

        if (parenthesis !== 'keep') {
          // ParenthesisNodes are only ignored when not in 'keep' mode
          node = _node.getContent();
        }

        var identifier = node.getIdentifier();
        var index = getPrecedence(node, parenthesis);

        if (index === null) {
          // node isn't in the list
          return null;
        }

        var property = properties[index][identifier];

        if (property.hasOwnProperty('associativity')) {
          if (property.associativity === 'left') {
            return 'left';
          }

          if (property.associativity === 'right') {
            return 'right';
          } // associativity is invalid


          throw Error('\'' + identifier + '\' has the invalid associativity \'' + property.associativity + '\'.');
        } // associativity is undefined


        return null;
      }
      /**
       * Check if an operator is associative with another operator.
       * Returns either true or false or null if not defined.
       *
       * @param {Node} nodeA
       * @param {Node} nodeB
       * @param {string} parenthesis
       * @return {bool|null}
       */


      function isAssociativeWith(nodeA, nodeB, parenthesis) {
        // ParenthesisNodes are only ignored when not in 'keep' mode
        var a = parenthesis !== 'keep' ? nodeA.getContent() : nodeA;
        var b = parenthesis !== 'keep' ? nodeA.getContent() : nodeB;
        var identifierA = a.getIdentifier();
        var identifierB = b.getIdentifier();
        var index = getPrecedence(a, parenthesis);

        if (index === null) {
          // node isn't in the list
          return null;
        }

        var property = properties[index][identifierA];

        if (property.hasOwnProperty('associativeWith') && property.associativeWith instanceof Array) {
          for (var i = 0; i < property.associativeWith.length; i++) {
            if (property.associativeWith[i] === identifierB) {
              return true;
            }
          }

          return false;
        } // associativeWith is not defined


        return null;
      }

      module.exports.properties = properties;
      module.exports.getPrecedence = getPrecedence;
      module.exports.getAssociativity = getAssociativity;
      module.exports.isAssociativeWith = isAssociativeWith;
      /***/
    },
    /* 172 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      exports.getTodayTime = getTodayTime;
      exports.getTitleString = getTitleString;
      exports.getTodayTimeStr = getTodayTimeStr;
      exports.getMonthName = getMonthName;
      exports.syncTime = syncTime;
      exports.getTimeConfig = getTimeConfig;
      exports.isTimeValidByConfig = isTimeValidByConfig;
      exports.isTimeValid = isTimeValid;
      exports.isAllowedDate = isAllowedDate;

      var _moment = __webpack_require__(14);

      var _moment2 = _interopRequireDefault(_moment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var defaultDisabledTime = {
        disabledHours: function disabledHours() {
          return [];
        },
        disabledMinutes: function disabledMinutes() {
          return [];
        },
        disabledSeconds: function disabledSeconds() {
          return [];
        }
      };

      function getTodayTime(value) {
        var today = (0, _moment2['default'])();
        today.locale(value.locale()).utcOffset(value.utcOffset());
        return today;
      }

      function getTitleString(value) {
        return value.format('LL');
      }

      function getTodayTimeStr(value) {
        var today = getTodayTime(value);
        return getTitleString(today);
      }

      function getMonthName(month) {
        var locale = month.locale();
        var localeData = month.localeData();
        return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
      }

      function syncTime(from, to) {
        if (!_moment2['default'].isMoment(from) || !_moment2['default'].isMoment(to)) return;
        to.hour(from.hour());
        to.minute(from.minute());
        to.second(from.second());
      }

      function getTimeConfig(value, disabledTime) {
        var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
        disabledTimeConfig = (0, _extends3['default'])({}, defaultDisabledTime, disabledTimeConfig);
        return disabledTimeConfig;
      }

      function isTimeValidByConfig(value, disabledTimeConfig) {
        var invalidTime = false;

        if (value) {
          var hour = value.hour();
          var minutes = value.minute();
          var seconds = value.second();
          var disabledHours = disabledTimeConfig.disabledHours();

          if (disabledHours.indexOf(hour) === -1) {
            var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);

            if (disabledMinutes.indexOf(minutes) === -1) {
              var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
              invalidTime = disabledSeconds.indexOf(seconds) !== -1;
            } else {
              invalidTime = true;
            }
          } else {
            invalidTime = true;
          }
        }

        return !invalidTime;
      }

      function isTimeValid(value, disabledTime) {
        var disabledTimeConfig = getTimeConfig(value, disabledTime);
        return isTimeValidByConfig(value, disabledTimeConfig);
      }

      function isAllowedDate(value, disabledDate, disabledTime) {
        if (disabledDate) {
          if (disabledDate(value)) {
            return false;
          }
        }

        if (disabledTime) {
          if (!isTimeValid(value, disabledTime)) {
            return false;
          }
        }

        return true;
      }
      /***/

    },
    /* 173 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      /**
       * This function is used to mark string literals representing CSS class names
       * so that they can be transformed statically. This allows for modularization
       * and minification of CSS class names.
       *
       * In static_upstream, this function is actually implemented, but it should
       * eventually be replaced with something more descriptive, and the transform
       * that is used in the main stack should be ported for use elsewhere.
       *
       * @param string|object className to modularize, or an object of key/values.
       *                      In the object case, the values are conditions that
       *                      determine if the className keys should be included.
       * @param [string ...]  Variable list of classNames in the string case.
       * @return string       Renderable space-separated CSS className.
       */

      function cx(classNames) {
        if (typeof classNames == 'object') {
          return Object.keys(classNames).filter(function (className) {
            return classNames[className];
          }).map(replace).join(' ');
        }

        return Array.prototype.map.call(arguments, replace).join(' ');
      }

      function replace(str) {
        return str.replace(/\//g, '-');
      }

      module.exports = cx;
      /***/
    },
    /* 174 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule SelectionState
       * @format
       * 
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Immutable = __webpack_require__(53);

      var Record = Immutable.Record;
      var defaultRecord = {
        anchorKey: '',
        anchorOffset: 0,
        focusKey: '',
        focusOffset: 0,
        isBackward: false,
        hasFocus: false
      };
      var SelectionStateRecord = Record(defaultRecord);

      var SelectionState = function (_SelectionStateRecord) {
        _inherits(SelectionState, _SelectionStateRecord);

        function SelectionState() {
          _classCallCheck(this, SelectionState);

          return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
        }

        SelectionState.prototype.serialize = function serialize() {
          return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
        };

        SelectionState.prototype.getAnchorKey = function getAnchorKey() {
          return this.get('anchorKey');
        };

        SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
          return this.get('anchorOffset');
        };

        SelectionState.prototype.getFocusKey = function getFocusKey() {
          return this.get('focusKey');
        };

        SelectionState.prototype.getFocusOffset = function getFocusOffset() {
          return this.get('focusOffset');
        };

        SelectionState.prototype.getIsBackward = function getIsBackward() {
          return this.get('isBackward');
        };

        SelectionState.prototype.getHasFocus = function getHasFocus() {
          return this.get('hasFocus');
        };
        /**
         * Return whether the specified range overlaps with an edge of the
         * SelectionState.
         */


        SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
          var anchorKey = this.getAnchorKey();
          var focusKey = this.getFocusKey();

          if (anchorKey === focusKey && anchorKey === blockKey) {
            var selectionStart = this.getStartOffset();
            var selectionEnd = this.getEndOffset();
            return start <= selectionEnd && selectionStart <= end;
          }

          if (blockKey !== anchorKey && blockKey !== focusKey) {
            return false;
          }

          var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
          return start <= offsetToCheck && end >= offsetToCheck;
        };

        SelectionState.prototype.isCollapsed = function isCollapsed() {
          return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
        };

        SelectionState.prototype.getStartKey = function getStartKey() {
          return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
        };

        SelectionState.prototype.getStartOffset = function getStartOffset() {
          return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
        };

        SelectionState.prototype.getEndKey = function getEndKey() {
          return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
        };

        SelectionState.prototype.getEndOffset = function getEndOffset() {
          return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
        };

        SelectionState.createEmpty = function createEmpty(key) {
          return new SelectionState({
            anchorKey: key,
            anchorOffset: 0,
            focusKey: key,
            focusOffset: 0,
            isBackward: false,
            hasFocus: false
          });
        };

        return SelectionState;
      }(SelectionStateRecord);

      module.exports = SelectionState;
      /***/
    },
    /* 175 */

    /***/
    function (module, exports, __webpack_require__) {
      var isSymbol = __webpack_require__(255);
      /** Used as references for various `Number` constants. */


      var INFINITY = 1 / 0;
      /**
       * Converts `value` to a string key if it's not a string or symbol.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {string|symbol} Returns the key.
       */

      function toKey(value) {
        if (typeof value == 'string' || isSymbol(value)) {
          return value;
        }

        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }

      module.exports = toKey;
      /***/
    },
    /* 176 */

    /***/
    function (module, exports) {
      /**
       * A specialized version of `_.map` for arrays without support for iteratee
       * shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       */
      function arrayMap(array, iteratee) {
        var index = -1,
            length = array == null ? 0 : array.length,
            result = Array(length);

        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }

        return result;
      }

      module.exports = arrayMap;
      /***/
    },
    /* 177 */

    /***/
    function (module, exports, __webpack_require__) {
      var isArray = __webpack_require__(55),
          isKey = __webpack_require__(353),
          stringToPath = __webpack_require__(1091),
          toString = __webpack_require__(140);
      /**
       * Casts `value` to a path array if it's not one.
       *
       * @private
       * @param {*} value The value to inspect.
       * @param {Object} [object] The object to query keys on.
       * @returns {Array} Returns the cast property path array.
       */


      function castPath(value, object) {
        if (isArray(value)) {
          return value;
        }

        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }

      module.exports = castPath;
      /***/
    },
    /* 178 */

    /***/
    function (module, exports) {
      module.exports = {};
      /***/
    },
    /* 179 */

    /***/
    function (module, exports) {
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };
      /***/

    },
    /* 180 */

    /***/
    function (module, exports) {
      module.exports = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
      };
      /***/

    },
    /* 181 */

    /***/
    function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(137);

      var createDesc = __webpack_require__(214);

      module.exports = __webpack_require__(136) ? function (object, key, value) {
        return dP.f(object, key, createDesc(1, value));
      } : function (object, key, value) {
        object[key] = value;
        return object;
      };
      /***/
    },
    /* 182 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftOffsetKey
       * @format
       * 
       */

      var KEY_DELIMITER = '-';
      var DraftOffsetKey = {
        encode: function encode(blockKey, decoratorKey, leafKey) {
          return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
        },
        decode: function decode(offsetKey) {
          var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
              blockKey = _offsetKey$split[0],
              decoratorKey = _offsetKey$split[1],
              leafKey = _offsetKey$split[2];

          return {
            blockKey: blockKey,
            decoratorKey: parseInt(decoratorKey, 10),
            leafKey: parseInt(leafKey, 10)
          };
        }
      };
      module.exports = DraftOffsetKey;
      /***/
    },
    /* 183 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}


      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_ = __webpack_require__(16);

      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_); // EXTERNAL MODULE: ./node_modules/create-react-class/index.js


      var create_react_class = __webpack_require__(32);

      var create_react_class_default =
      /*#__PURE__*/
      __webpack_require__.n(create_react_class); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js


      var KeyCode = __webpack_require__(19); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/date/DateTable.js + 3 modules


      var DateTable = __webpack_require__(186); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/calendar/CalendarHeader.js + 3 modules


      var CalendarHeader = __webpack_require__(185); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/calendar/CalendarFooter.js


      var CalendarFooter = __webpack_require__(289); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/mixin/CalendarMixin.js


      var CalendarMixin = __webpack_require__(189); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/mixin/CommonMixin.js


      var CommonMixin = __webpack_require__(144); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/date/DateInput.js


      var DateInput = __webpack_require__(285); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/util/index.js


      var util = __webpack_require__(47); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/util/toTime.js


      var toTime = __webpack_require__(86); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/Calendar.js


      function Calendar_noop() {}

      var Calendar_Calendar = create_react_class_default()({
        displayName: 'Calendar',
        propTypes: {
          prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          selectedValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          mode: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['time', 'date', 'month', 'year', 'decade']),
          locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          showDateInput: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          showWeekNumber: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          showToday: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          showOk: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onOk: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onKeyDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          timePicker: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.element,
          dateInputPlaceholder: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          onClear: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onPanelChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          disabledDate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          disabledTime: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          renderFooter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          renderSidebar: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        },
        mixins: [CommonMixin["a"
        /* default */
        ], CalendarMixin["a"
        /* default */
        ]],
        getDefaultProps: function getDefaultProps() {
          return {
            showToday: true,
            showDateInput: true,
            timePicker: null,
            onOk: Calendar_noop,
            onPanelChange: Calendar_noop
          };
        },
        getInitialState: function getInitialState() {
          return {
            mode: this.props.mode || 'date'
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          if ('mode' in nextProps && this.state.mode !== nextProps.mode) {
            this.setState({
              mode: nextProps.mode
            });
          }
        },
        onKeyDown: function onKeyDown(event) {
          if (event.target.nodeName.toLowerCase() === 'input') {
            return undefined;
          }

          var keyCode = event.keyCode; // mac

          var ctrlKey = event.ctrlKey || event.metaKey;
          var disabledDate = this.props.disabledDate;
          var value = this.state.value;

          switch (keyCode) {
            case KeyCode["a"
            /* default */
            ].DOWN:
              this.goTime(1, 'weeks');
              event.preventDefault();
              return 1;

            case KeyCode["a"
            /* default */
            ].UP:
              this.goTime(-1, 'weeks');
              event.preventDefault();
              return 1;

            case KeyCode["a"
            /* default */
            ].LEFT:
              if (ctrlKey) {
                this.goTime(-1, 'years');
              } else {
                this.goTime(-1, 'days');
              }

              event.preventDefault();
              return 1;

            case KeyCode["a"
            /* default */
            ].RIGHT:
              if (ctrlKey) {
                this.goTime(1, 'years');
              } else {
                this.goTime(1, 'days');
              }

              event.preventDefault();
              return 1;

            case KeyCode["a"
            /* default */
            ].HOME:
              this.setValue(Object(toTime["b"
              /* goStartMonth */
              ])(this.state.value));
              event.preventDefault();
              return 1;

            case KeyCode["a"
            /* default */
            ].END:
              this.setValue(Object(toTime["a"
              /* goEndMonth */
              ])(this.state.value));
              event.preventDefault();
              return 1;

            case KeyCode["a"
            /* default */
            ].PAGE_DOWN:
              this.goTime(1, 'month');
              event.preventDefault();
              return 1;

            case KeyCode["a"
            /* default */
            ].PAGE_UP:
              this.goTime(-1, 'month');
              event.preventDefault();
              return 1;

            case KeyCode["a"
            /* default */
            ].ENTER:
              if (!disabledDate || !disabledDate(value)) {
                this.onSelect(value, {
                  source: 'keyboard'
                });
              }

              event.preventDefault();
              return 1;

            default:
              this.props.onKeyDown(event);
              return 1;
          }
        },
        onClear: function onClear() {
          this.onSelect(null);
          this.props.onClear();
        },
        onOk: function onOk() {
          var selectedValue = this.state.selectedValue;

          if (this.isAllowedDate(selectedValue)) {
            this.props.onOk(selectedValue);
          }
        },
        onDateInputChange: function onDateInputChange(value) {
          this.onSelect(value, {
            source: 'dateInput'
          });
        },
        onDateTableSelect: function onDateTableSelect(value) {
          var timePicker = this.props.timePicker;
          var selectedValue = this.state.selectedValue;

          if (!selectedValue && timePicker) {
            var timePickerDefaultValue = timePicker.props.defaultValue;

            if (timePickerDefaultValue) {
              Object(util["g"
              /* syncTime */
              ])(timePickerDefaultValue, value);
            }
          }

          this.onSelect(value);
        },
        onToday: function onToday() {
          var value = this.state.value;
          var now = Object(util["d"
          /* getTodayTime */
          ])(value);
          this.onSelect(now, {
            source: 'todayButton'
          });
        },
        onPanelChange: function onPanelChange(value, mode) {
          var props = this.props,
              state = this.state;

          if (!('mode' in props)) {
            this.setState({
              mode: mode
            });
          }

          props.onPanelChange(value || state.value, mode);
        },
        getRootDOMNode: function getRootDOMNode() {
          return external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this);
        },
        openTimePicker: function openTimePicker() {
          this.onPanelChange(null, 'time');
        },
        closeTimePicker: function closeTimePicker() {
          this.onPanelChange(null, 'date');
        },
        goTime: function goTime(direction, unit) {
          this.setValue(Object(toTime["c"
          /* goTime */
          ])(this.state.value, direction, unit));
        },
        render: function render() {
          var props = this.props,
              state = this.state;
          var locale = props.locale,
              prefixCls = props.prefixCls,
              disabledDate = props.disabledDate,
              dateInputPlaceholder = props.dateInputPlaceholder,
              timePicker = props.timePicker,
              disabledTime = props.disabledTime;
          var value = state.value,
              selectedValue = state.selectedValue,
              mode = state.mode;
          var showTimePicker = mode === 'time';
          var disabledTimeConfig = showTimePicker && disabledTime && timePicker ? Object(util["b"
          /* getTimeConfig */
          ])(selectedValue, disabledTime) : null;
          var timePickerEle = null;

          if (timePicker && showTimePicker) {
            var timePickerProps = extends_default()({
              showHour: true,
              showSecond: true,
              showMinute: true
            }, timePicker.props, disabledTimeConfig, {
              onChange: this.onDateInputChange,
              value: selectedValue,
              disabledTime: disabledTime
            });

            if (timePicker.props.defaultValue !== undefined) {
              timePickerProps.defaultOpenValue = timePicker.props.defaultValue;
            }

            timePickerEle = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(timePicker, timePickerProps);
          }

          var dateInputElement = props.showDateInput ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(DateInput["a"
          /* default */
          ], {
            format: this.getFormat(),
            key: 'date-input',
            value: value,
            locale: locale,
            placeholder: dateInputPlaceholder,
            showClear: true,
            disabledTime: disabledTime,
            disabledDate: disabledDate,
            onClear: this.onClear,
            prefixCls: prefixCls,
            selectedValue: selectedValue,
            onChange: this.onDateInputChange
          }) : null;
          var children = [props.renderSidebar(), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-panel',
            key: 'panel'
          }, dateInputElement, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-date-panel'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(CalendarHeader["a"
          /* default */
          ], {
            locale: locale,
            mode: mode,
            value: value,
            onValueChange: this.setValue,
            onPanelChange: this.onPanelChange,
            showTimePicker: showTimePicker,
            prefixCls: prefixCls
          }), timePicker && showTimePicker ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-time-picker'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-time-picker-panel'
          }, timePickerEle)) : null, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-body'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(DateTable["a"
          /* default */
          ], {
            locale: locale,
            value: value,
            selectedValue: selectedValue,
            prefixCls: prefixCls,
            dateRender: props.dateRender,
            onSelect: this.onDateTableSelect,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(CalendarFooter["a"
          /* default */
          ], {
            showOk: props.showOk,
            renderFooter: props.renderFooter,
            locale: locale,
            prefixCls: prefixCls,
            showToday: props.showToday,
            disabledTime: disabledTime,
            showTimePicker: showTimePicker,
            showDateInput: props.showDateInput,
            timePicker: timePicker,
            selectedValue: selectedValue,
            value: value,
            disabledDate: disabledDate,
            okDisabled: !this.isAllowedDate(selectedValue),
            onOk: this.onOk,
            onSelect: this.onSelect,
            onToday: this.onToday,
            onOpenTimePicker: this.openTimePicker,
            onCloseTimePicker: this.closeTimePicker
          })))];
          return this.renderRoot({
            children: children,
            className: props.showWeekNumber ? prefixCls + '-week-number' : ''
          });
        }
      });
      /* harmony default export */

      var es_Calendar = Calendar_Calendar; // CONCATENATED MODULE: ./node_modules/rc-calendar/es/index.js

      /* harmony default export */

      var es = __webpack_exports__["default"] = es_Calendar;
      /***/
    },
    /* 184 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js

      var defineProperty = __webpack_require__(4);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectSpread.js


      var objectSpread = __webpack_require__(13);

      var objectSpread_default =
      /*#__PURE__*/
      __webpack_require__.n(objectSpread); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js


      var helpers_typeof = __webpack_require__(39);

      var typeof_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_typeof); // EXTERNAL MODULE: ./node_modules/lodash/get.js


      var get = __webpack_require__(10);

      var get_default =
      /*#__PURE__*/
      __webpack_require__.n(get); // EXTERNAL MODULE: ./src/core/utils.js + 1 modules


      var utils = __webpack_require__(18); // EXTERNAL MODULE: ./src/core/utils/checkLogic.js


      var checkLogic = __webpack_require__(99); // EXTERNAL MODULE: ./node_modules/lodash/isArray.js


      var isArray = __webpack_require__(55);

      var isArray_default =
      /*#__PURE__*/
      __webpack_require__.n(isArray); // CONCATENATED MODULE: ./src/core/utils/transformer.js


      var transformer_arraySeparators = [', ', ',', ';'];
      var transformer_fieldsToTranform = {
        text: [{
          array: 'string'
        }],
        textArea: [{
          array: 'string'
        }, {
          object: 'string'
        }],
        radioList: [{
          array: 'string'
        }, {
          object: 'string'
        }],
        password: [{
          array: 'string'
        }, {
          object: 'string'
        }],
        dropdown: [{
          array: 'string'
        }, {
          object: 'string'
        }],
        checkboxList: [{
          string: 'array'
        }, {
          object: 'array'
        }],
        buttonList: [{
          string: 'array'
        }, {
          object: 'array'
        }]
      };
      /**
       * This method us used to transform the data from one type to another.
       * @param {*} fromValue
       * @param {string} toType
       * @param {object} field
       */

      var transformer_transform = function transform(fromValue, toType, field) {
        if (typeof fromValue === 'string') {
          switch (toType) {
            case 'array':
              {
                var options = get_default()(field, 'attributes.options', []);
                var values = [];
                transformer_arraySeparators.forEach(function (separator) {
                  if (values.length === 0 && fromValue.includes(separator)) {
                    fromValue.split(separator).forEach(function (item) {
                      if (options.includes(item)) {
                        values.push(item);
                      }
                    });
                  }
                });

                if (options.includes(fromValue)) {
                  return [fromValue];
                } else if (values.length > 0) {
                  return values;
                }

                return [];
              }

            case 'object':
              return JSON.parse(fromValue);

            default:
              {
                var _options = get_default()(field, 'attributes.options');

                if (_options) {
                  if (_options.includes(fromValue)) {
                    return fromValue;
                  }

                  return '';
                }

                return fromValue;
              }
          }
        } else if (typeof_default()(fromValue) === 'object' && isArray_default()(fromValue)) {
          switch (toType) {
            case 'string':
              return fromValue.join(',');

            default:
              {
                var _options2 = get_default()(field, 'attributes.options', []);

                var _values = [];
                fromValue.forEach(function (element) {
                  if (_options2.includes(element)) {
                    _values.push(element);
                  }
                });
                return _values;
              }
          }
        } else if (typeof_default()(fromValue) === 'object') {
          switch (toType) {
            case 'string':
              return JSON.stringify(fromValue);

            default:
              return fromValue;
          }
        }

        return fromValue;
      };
      /**
       * Method to process the fields to be transformed.
       * @param {object} props
       *
       */


      var transformer_transformer = function transformer(props) {
        return function (fromValue, toField) {
          var toRenderer = get_default()(props, "myFieldsById.".concat(toField, ".renderer"));

          if (toRenderer) {
            if (transformer_fieldsToTranform[toRenderer]) {
              var keys = Object.keys(transformer_fieldsToTranform[toRenderer]);
              var toValue = get_default()(props, "myFieldsById.".concat(toField));
              keys.forEach(function (key) {
                var transformation = transformer_fieldsToTranform[toRenderer][key];
                var toType;

                if (typeof_default()(fromValue) === 'object' && isArray_default()(fromValue)) {
                  toType = get_default()(transformation, 'array', undefined);
                } else {
                  toType = get_default()(transformation, typeof_default()(fromValue), typeof_default()(fromValue));
                }

                if (toType) {
                  fromValue = transformer_transform(fromValue, toType, toValue);
                }
              });
            }
          }

          return fromValue;
        };
      };
      /* harmony default export */


      var utils_transformer = transformer_transformer; // CONCATENATED MODULE: ./src/core/utils/populate.js

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return populate_getFieldsToBePopulated;
      });
      /**
       * Returns 'value' if 'subPath' does not exist as a sub path of 'value', otherwise it returns the value of its sub path.
       *
       * e.g.
       *  value = { abc: 123, dfg: 546 } subPath = 'xyz'     returns { abc: 123, dfg: 546 }
       *  value = { abc: 123, dfg: 546 } subPath = undefined returns { abc: 123, dfg: 546 }
       *  value = { abc: 123, dfg: 546 } subPath = 'abc'     returns 123
       */


      var populate_getValue = function getValue(value, subPath) {
        return subPath ? get_default()(value, subPath, value) : value;
      };
      /**
       * Method to verify if we should replace or not the value for the new one
       */


      var populate_shouldReplace = function shouldReplace(forcePopulation, receptorValue, fieldValue, fieldOldValue, toSubValue) {
        return forcePopulation || Object(utils["o"
        /* isEmpty */
        ])(receptorValue) || Object(utils["a"
        /* equalOrEmpty */
        ])(populate_getValue(receptorValue, toSubValue), fieldValue) || Object(utils["a"
        /* equalOrEmpty */
        ])(populate_getValue(receptorValue, toSubValue), fieldOldValue);
      };
      /**
       * Returns an array of objects where every object contains the following structure: { id, value }
       * Those objects are the new values of other fields based on the 'populate' attribute of this field.
       */


      var populate_getFieldsToBePopulated = function getFieldsToBePopulated(props, fromFieldId, value) {
        var fields = [];
        var oldValue = get_default()(props, "mySubmissionFieldsById[".concat(fromFieldId, "].value"));
        get_default()(props, 'populate', []).forEach(function (item) {
          var fieldId = item.fieldId;
          var fieldValue = populate_getValue(value, item.fromSubValue);
          var fieldOldValue = populate_getValue(oldValue, item.fromSubValue);
          var receptorValue = get_default()(props, "mySubmissionFieldsById[".concat(fieldId, "].value"));

          if (Object(utils["o"
          /* isEmpty */
          ])(receptorValue)) {
            receptorValue = populate_getValue(get_default()(props, "myFieldsById[".concat(fieldId, "].attributes.default"), ''), item.toSubValue);
          } // if there are conditions, only execute the conditional field population lo


          var fieldToUpdate;

          if (!Object(utils["a"
          /* equalOrEmpty */
          ])(receptorValue, fieldValue) || !Object(utils["a"
          /* equalOrEmpty */
          ])(receptorValue, fieldOldValue)) {
            if (item.toSubValue) {
              if (typeof_default()(receptorValue) === 'object') {
                fieldValue = objectSpread_default()({}, receptorValue, defineProperty_default()({}, item.toSubValue, fieldValue));
              } else {
                fieldValue = defineProperty_default()({}, item.toSubValue, fieldValue);
              }
            }

            if (fieldOldValue) {
              fieldOldValue = utils_transformer(props)(fieldOldValue, fieldId);
            }

            fieldValue = utils_transformer(props)(fieldValue, fieldId);

            if (populate_shouldReplace(item.forcePopulation, receptorValue, fieldValue, fieldOldValue, item.toSubValue)) {
              if (typeof item.conditions === 'undefined' || Object(utils["o"
              /* isEmpty */
              ])(item.conditions)) {
                fieldToUpdate = {
                  id: fieldId,
                  value: fieldValue
                };
              } else {
                var values = {};
                Object.keys(props.mySubmissionFieldsById).forEach(function (id) {
                  values[id] = id === props.fieldId ? value : props.mySubmissionFieldsById[id].value;
                });

                if (Object(checkLogic["a"
                /* default */
                ])(values, item.conditions, props, {}, props.myTokens)) {
                  if (!Object(utils["o"
                  /* isEmpty */
                  ])(item.destinationValue)) {
                    if (fieldOldValue) {
                      fieldValue = utils_transformer(props)(item.destinationValue, fieldId);
                    }

                    fieldToUpdate = {
                      id: fieldId,
                      value: fieldValue
                    };
                  } else {
                    fieldToUpdate = {
                      id: fieldId,
                      value: fieldValue
                    };
                  }
                }
              }
            }

            if (fieldToUpdate) {
              fields.push(fieldToUpdate); // Populate nested field1 -> field2 -> ... -> fieldN

              var nestedField = get_default()(props, "myFieldsById[".concat(fieldId, "]"));

              if (nestedField !== undefined) {
                getFieldsToBePopulated(objectSpread_default()({}, props, {
                  fieldId: nestedField.id
                }, get_default()(nestedField, 'attributes', {}), {
                  populate: get_default()(nestedField, 'attributes.populate', [])
                }), fieldId, fieldToUpdate.value).forEach(function (element) {
                  fields.push(element);
                });
              }
            }
          }
        });
        return fields;
      };
      /***/

    },
    /* 185 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}

      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: ./node_modules/create-react-class/index.js


      var create_react_class = __webpack_require__(32);

      var create_react_class_default =
      /*#__PURE__*/
      __webpack_require__.n(create_react_class); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/rc-util/es/Children/mapSelf.js


      var mapSelf = __webpack_require__(290); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/month/MonthTable.js


      var MonthTable = __webpack_require__(291); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/month/MonthPanel.js


      function MonthPanel_goYear(direction) {
        var next = this.state.value.clone();
        next.add(direction, 'year');
        this.setAndChangeValue(next);
      }

      function MonthPanel_noop() {}

      var MonthPanel_MonthPanel = create_react_class_default()({
        displayName: 'MonthPanel',
        propTypes: {
          onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          disabledDate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          onSelect: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        },
        getDefaultProps: function getDefaultProps() {
          return {
            onChange: MonthPanel_noop,
            onSelect: MonthPanel_noop
          };
        },
        getInitialState: function getInitialState() {
          var props = this.props; // bind methods

          this.nextYear = MonthPanel_goYear.bind(this, 1);
          this.previousYear = MonthPanel_goYear.bind(this, -1);
          this.prefixCls = props.rootPrefixCls + '-month-panel';
          return {
            value: props.value || props.defaultValue
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          if ('value' in nextProps) {
            this.setState({
              value: nextProps.value
            });
          }
        },
        setAndChangeValue: function setAndChangeValue(value) {
          this.setValue(value);
          this.props.onChange(value);
        },
        setAndSelectValue: function setAndSelectValue(value) {
          this.setValue(value);
          this.props.onSelect(value);
        },
        setValue: function setValue(value) {
          if (!('value' in this.props)) {
            this.setState({
              value: value
            });
          }
        },
        render: function render() {
          var props = this.props;
          var value = this.state.value;
          var cellRender = props.cellRender;
          var contentRender = props.contentRender;
          var locale = props.locale;
          var year = value.year();
          var prefixCls = this.prefixCls;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls,
            style: props.style
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', null, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-header'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-year-select',
            role: 'button',
            onClick: props.onYearPanelShow,
            title: locale.yearSelect
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: prefixCls + '-year-select-content'
          }, year), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: prefixCls + '-year-select-arrow'
          }, 'x')), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-next-year-btn',
            role: 'button',
            onClick: this.nextYear,
            title: locale.nextYear
          })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-body'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(MonthTable["a"
          /* default */
          ], {
            disabledDate: props.disabledDate,
            onSelect: this.setAndSelectValue,
            locale: locale,
            value: value,
            cellRender: cellRender,
            contentRender: contentRender,
            prefixCls: prefixCls
          }))));
        }
      });
      /* harmony default export */

      var month_MonthPanel = MonthPanel_MonthPanel; // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js

      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/year/YearPanel.js


      var YearPanel_ROW = 4;
      var YearPanel_COL = 3;

      function YearPanel_goYear(direction) {
        var value = this.state.value.clone();
        value.add(direction, 'year');
        this.setState({
          value: value
        });
      }

      function YearPanel_chooseYear(year) {
        var value = this.state.value.clone();
        value.year(year);
        value.month(this.state.value.month());
        this.props.onSelect(value);
      }

      var YearPanel_YearPanel = function (_React$Component) {
        inherits_default()(YearPanel, _React$Component);

        function YearPanel(props) {
          classCallCheck_default()(this, YearPanel);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          _this.prefixCls = props.rootPrefixCls + '-year-panel';
          _this.state = {
            value: props.value || props.defaultValue
          };
          _this.nextDecade = YearPanel_goYear.bind(_this, 10);
          _this.previousDecade = YearPanel_goYear.bind(_this, -10);
          return _this;
        }

        YearPanel.prototype.years = function years() {
          var value = this.state.value;
          var currentYear = value.year();
          var startYear = parseInt(currentYear / 10, 10) * 10;
          var previousYear = startYear - 1;
          var years = [];
          var index = 0;

          for (var rowIndex = 0; rowIndex < YearPanel_ROW; rowIndex++) {
            years[rowIndex] = [];

            for (var colIndex = 0; colIndex < YearPanel_COL; colIndex++) {
              var year = previousYear + index;
              var content = String(year);
              years[rowIndex][colIndex] = {
                content: content,
                year: year,
                title: content
              };
              index++;
            }
          }

          return years;
        };

        YearPanel.prototype.render = function render() {
          var _this2 = this;

          var props = this.props;
          var value = this.state.value;
          var locale = props.locale;
          var years = this.years();
          var currentYear = value.year();
          var startYear = parseInt(currentYear / 10, 10) * 10;
          var endYear = startYear + 9;
          var prefixCls = this.prefixCls;
          var yeasEls = years.map(function (row, index) {
            var tds = row.map(function (yearData) {
              var _classNameMap;

              var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
              var clickHandler = void 0;

              if (yearData.year < startYear) {
                clickHandler = _this2.previousDecade;
              } else if (yearData.year > endYear) {
                clickHandler = _this2.nextDecade;
              } else {
                clickHandler = YearPanel_chooseYear.bind(_this2, yearData.year);
              }

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('td', {
                role: 'gridcell',
                title: yearData.title,
                key: yearData.content,
                onClick: clickHandler,
                className: classnames_default()(classNameMap)
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
                className: prefixCls + '-year'
              }, yearData.content));
            });
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('tr', {
              key: index,
              role: 'row'
            }, tds);
          });
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: this.prefixCls
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', null, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-header'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-prev-decade-btn',
            role: 'button',
            onClick: this.previousDecade,
            title: locale.previousDecade
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-decade-select',
            role: 'button',
            onClick: props.onDecadePanelShow,
            title: locale.decadeSelect
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: prefixCls + '-decade-select-content'
          }, startYear, '-', endYear), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: prefixCls + '-decade-select-arrow'
          }, 'x')), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-next-decade-btn',
            role: 'button',
            onClick: this.nextDecade,
            title: locale.nextDecade
          })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-body'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('table', {
            className: prefixCls + '-table',
            cellSpacing: '0',
            role: 'grid'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('tbody', {
            className: prefixCls + '-tbody'
          }, yeasEls)))));
        };

        return YearPanel;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);
      /* harmony default export */


      var year_YearPanel = YearPanel_YearPanel;
      YearPanel_YearPanel.propTypes = {
        rootPrefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };
      YearPanel_YearPanel.defaultProps = {
        onSelect: function onSelect() {}
      }; // CONCATENATED MODULE: ./node_modules/rc-calendar/es/decade/DecadePanel.js

      var DecadePanel_ROW = 4;
      var DecadePanel_COL = 3;

      function DecadePanel_goYear(direction) {
        var next = this.state.value.clone();
        next.add(direction, 'years');
        this.setState({
          value: next
        });
      }

      function DecadePanel_chooseDecade(year, event) {
        var next = this.state.value.clone();
        next.year(year);
        next.month(this.state.value.month());
        this.props.onSelect(next);
        event.preventDefault();
      }

      var DecadePanel_DecadePanel = function (_React$Component) {
        inherits_default()(DecadePanel, _React$Component);

        function DecadePanel(props) {
          classCallCheck_default()(this, DecadePanel);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          _this.state = {
            value: props.value || props.defaultValue
          }; // bind methods

          _this.prefixCls = props.rootPrefixCls + '-decade-panel';
          _this.nextCentury = DecadePanel_goYear.bind(_this, 100);
          _this.previousCentury = DecadePanel_goYear.bind(_this, -100);
          return _this;
        }

        DecadePanel.prototype.render = function render() {
          var _this2 = this;

          var value = this.state.value;
          var locale = this.props.locale;
          var currentYear = value.year();
          var startYear = parseInt(currentYear / 100, 10) * 100;
          var preYear = startYear - 10;
          var endYear = startYear + 99;
          var decades = [];
          var index = 0;
          var prefixCls = this.prefixCls;

          for (var rowIndex = 0; rowIndex < DecadePanel_ROW; rowIndex++) {
            decades[rowIndex] = [];

            for (var colIndex = 0; colIndex < DecadePanel_COL; colIndex++) {
              var startDecade = preYear + index * 10;
              var endDecade = preYear + index * 10 + 9;
              decades[rowIndex][colIndex] = {
                startDecade: startDecade,
                endDecade: endDecade
              };
              index++;
            }
          }

          var decadesEls = decades.map(function (row, decadeIndex) {
            var tds = row.map(function (decadeData) {
              var _classNameMap;

              var dStartDecade = decadeData.startDecade;
              var dEndDecade = decadeData.endDecade;
              var isLast = dStartDecade < startYear;
              var isNext = dEndDecade > endYear;
              var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
              var content = dStartDecade + '-' + dEndDecade;
              var clickHandler = void 0;

              if (isLast) {
                clickHandler = _this2.previousCentury;
              } else if (isNext) {
                clickHandler = _this2.nextCentury;
              } else {
                clickHandler = DecadePanel_chooseDecade.bind(_this2, dStartDecade);
              }

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('td', {
                key: dStartDecade,
                onClick: clickHandler,
                role: 'gridcell',
                className: classnames_default()(classNameMap)
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
                className: prefixCls + '-decade'
              }, content));
            });
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('tr', {
              key: decadeIndex,
              role: 'row'
            }, tds);
          });
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: this.prefixCls
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-header'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-prev-century-btn',
            role: 'button',
            onClick: this.previousCentury,
            title: locale.previousCentury
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-century'
          }, startYear, '-', endYear), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-next-century-btn',
            role: 'button',
            onClick: this.nextCentury,
            title: locale.nextCentury
          })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-body'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('table', {
            className: prefixCls + '-table',
            cellSpacing: '0',
            role: 'grid'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('tbody', {
            className: prefixCls + '-tbody'
          }, decadesEls))));
        };

        return DecadePanel;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);
      /* harmony default export */


      var decade_DecadePanel = DecadePanel_DecadePanel;
      DecadePanel_DecadePanel.propTypes = {
        locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        rootPrefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      DecadePanel_DecadePanel.defaultProps = {
        onSelect: function onSelect() {}
      }; // CONCATENATED MODULE: ./node_modules/rc-calendar/es/calendar/CalendarHeader.js

      function CalendarHeader_goMonth(direction) {
        var next = this.props.value.clone();
        next.add(direction, 'months');
        this.props.onValueChange(next);
      }

      function CalendarHeader_goYear(direction) {
        var next = this.props.value.clone();
        next.add(direction, 'years');
        this.props.onValueChange(next);
      }

      function CalendarHeader_showIf(condition, el) {
        return condition ? el : null;
      }

      var CalendarHeader_CalendarHeader = create_react_class_default()({
        displayName: 'CalendarHeader',
        propTypes: {
          prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          onValueChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          showTimePicker: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          onPanelChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          locale: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          enablePrev: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          enableNext: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          disabledMonth: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
        },
        getDefaultProps: function getDefaultProps() {
          return {
            enableNext: 1,
            enablePrev: 1,
            onPanelChange: function onPanelChange() {},
            onValueChange: function onValueChange() {}
          };
        },
        getInitialState: function getInitialState() {
          this.nextMonth = CalendarHeader_goMonth.bind(this, 1);
          this.previousMonth = CalendarHeader_goMonth.bind(this, -1);
          this.nextYear = CalendarHeader_goYear.bind(this, 1);
          this.previousYear = CalendarHeader_goYear.bind(this, -1);
          return {
            yearPanelReferer: null
          };
        },
        onMonthSelect: function onMonthSelect(value) {
          this.props.onPanelChange(value, 'date');

          if (this.props.onMonthSelect) {
            this.props.onMonthSelect(value);
          } else {
            this.props.onValueChange(value);
          }
        },
        onYearSelect: function onYearSelect(value) {
          var referer = this.state.yearPanelReferer;
          this.setState({
            yearPanelReferer: null
          });
          this.props.onPanelChange(value, referer);
          this.props.onValueChange(value);
        },
        onDecadeSelect: function onDecadeSelect(value) {
          this.props.onPanelChange(value, 'year');
          this.props.onValueChange(value);
        },
        monthYearElement: function monthYearElement(showTimePicker) {
          var _this = this;

          var props = this.props;
          var prefixCls = props.prefixCls;
          var locale = props.locale;
          var value = props.value;
          var localeData = value.localeData();
          var monthBeforeYear = locale.monthBeforeYear;
          var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
          var year = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-year-select',
            role: 'button',
            onClick: showTimePicker ? null : function () {
              return _this.showYearPanel('date');
            },
            title: locale.yearSelect
          }, value.format(locale.yearFormat));
          var month = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-month-select',
            role: 'button',
            onClick: showTimePicker ? null : this.showMonthPanel,
            title: locale.monthSelect
          }, locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value));
          var day = void 0;

          if (showTimePicker) {
            day = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
              className: prefixCls + '-day-select',
              role: 'button'
            }, value.format(locale.dayFormat));
          }

          var my = [];

          if (monthBeforeYear) {
            my = [month, day, year];
          } else {
            my = [year, month, day];
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            className: selectClassName
          }, Object(mapSelf["a"
          /* default */
          ])(my));
        },
        showMonthPanel: function showMonthPanel() {
          // null means that users' interaction doesn't change value
          this.props.onPanelChange(null, 'month');
        },
        showYearPanel: function showYearPanel(referer) {
          this.setState({
            yearPanelReferer: referer
          });
          this.props.onPanelChange(null, 'year');
        },
        showDecadePanel: function showDecadePanel() {
          this.props.onPanelChange(null, 'decade');
        },
        render: function render() {
          var _this2 = this;

          var props = this.props;
          var prefixCls = props.prefixCls,
              locale = props.locale,
              mode = props.mode,
              value = props.value,
              showTimePicker = props.showTimePicker,
              enableNext = props.enableNext,
              enablePrev = props.enablePrev,
              disabledMonth = props.disabledMonth;
          var panel = null;

          if (mode === 'month') {
            panel = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(month_MonthPanel, {
              locale: locale,
              defaultValue: value,
              rootPrefixCls: prefixCls,
              onSelect: this.onMonthSelect,
              onYearPanelShow: function onYearPanelShow() {
                return _this2.showYearPanel('month');
              },
              disabledDate: disabledMonth,
              cellRender: props.monthCellRender,
              contentRender: props.monthCellContentRender
            });
          }

          if (mode === 'year') {
            panel = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(year_YearPanel, {
              locale: locale,
              defaultValue: value,
              rootPrefixCls: prefixCls,
              onSelect: this.onYearSelect,
              onDecadePanelShow: this.showDecadePanel
            });
          }

          if (mode === 'decade') {
            panel = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(decade_DecadePanel, {
              locale: locale,
              defaultValue: value,
              rootPrefixCls: prefixCls,
              onSelect: this.onDecadeSelect
            });
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-header'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            style: {
              position: 'relative'
            }
          }, CalendarHeader_showIf(enablePrev && !showTimePicker, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          })), CalendarHeader_showIf(enablePrev && !showTimePicker, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-prev-month-btn',
            role: 'button',
            onClick: this.previousMonth,
            title: locale.previousMonth
          })), this.monthYearElement(showTimePicker), CalendarHeader_showIf(enableNext && !showTimePicker, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-next-month-btn',
            onClick: this.nextMonth,
            title: locale.nextMonth
          })), CalendarHeader_showIf(enableNext && !showTimePicker, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
            className: prefixCls + '-next-year-btn',
            onClick: this.nextYear,
            title: locale.nextYear
          }))), panel);
        }
      });
      /* harmony default export */

      var calendar_CalendarHeader = __webpack_exports__["a"] = CalendarHeader_CalendarHeader;
      /***/
    },
    /* 186 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js

      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/date/DateConstants.js

      /* harmony default export */


      var DateConstants = {
        DATE_ROW_COUNT: 6,
        DATE_COL_COUNT: 7
      }; // EXTERNAL MODULE: ./node_modules/moment/moment.js

      var moment = __webpack_require__(14);

      var moment_default =
      /*#__PURE__*/
      __webpack_require__.n(moment); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/date/DateTHead.js


      var DateTHead_DateTHead = function (_React$Component) {
        inherits_default()(DateTHead, _React$Component);

        function DateTHead() {
          classCallCheck_default()(this, DateTHead);
          return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
        }

        DateTHead.prototype.render = function render() {
          var props = this.props;
          var value = props.value;
          var localeData = value.localeData();
          var prefixCls = props.prefixCls;
          var veryShortWeekdays = [];
          var weekDays = [];
          var firstDayOfWeek = localeData.firstDayOfWeek();
          var showWeekNumberEl = void 0;
          var now = moment_default()();

          for (var dateColIndex = 0; dateColIndex < DateConstants.DATE_COL_COUNT; dateColIndex++) {
            var index = (firstDayOfWeek + dateColIndex) % DateConstants.DATE_COL_COUNT;
            now.day(index);
            veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
            weekDays[dateColIndex] = localeData.weekdaysShort(now);
          }

          if (props.showWeekNumber) {
            showWeekNumberEl = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('th', {
              role: 'columnheader',
              className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-column-header-inner'
            }, 'x'));
          }

          var weekDaysEls = weekDays.map(function (day, xindex) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('th', {
              key: xindex,
              role: 'columnheader',
              title: day,
              className: prefixCls + '-column-header'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: prefixCls + '-column-header-inner'
            }, veryShortWeekdays[xindex]));
          });
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('thead', null, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('tr', {
            role: 'row'
          }, showWeekNumberEl, weekDaysEls));
        };

        return DateTHead;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);
      /* harmony default export */


      var date_DateTHead = DateTHead_DateTHead; // EXTERNAL MODULE: ./node_modules/create-react-class/index.js

      var create_react_class = __webpack_require__(32);

      var create_react_class_default =
      /*#__PURE__*/
      __webpack_require__.n(create_react_class); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // EXTERNAL MODULE: ./node_modules/rc-calendar/es/util/index.js


      var util = __webpack_require__(47); // CONCATENATED MODULE: ./node_modules/rc-calendar/es/date/DateTBody.js


      function DateTBody_isSameDay(one, two) {
        return one && two && one.isSame(two, 'day');
      }

      function DateTBody_beforeCurrentMonthYear(current, today) {
        if (current.year() < today.year()) {
          return 1;
        }

        return current.year() === today.year() && current.month() < today.month();
      }

      function DateTBody_afterCurrentMonthYear(current, today) {
        if (current.year() > today.year()) {
          return 1;
        }

        return current.year() === today.year() && current.month() > today.month();
      }

      function DateTBody_getIdFromDate(date) {
        return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
      }

      var DateTBody_DateTBody = create_react_class_default()({
        displayName: 'DateTBody',
        propTypes: {
          contentRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          dateRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          disabledDate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
          prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          selectedValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object)]),
          value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
          hoverValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
          showWeekNumber: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
        },
        getDefaultProps: function getDefaultProps() {
          return {
            hoverValue: []
          };
        },
        render: function render() {
          var props = this.props;
          var contentRender = props.contentRender,
              prefixCls = props.prefixCls,
              selectedValue = props.selectedValue,
              value = props.value,
              showWeekNumber = props.showWeekNumber,
              dateRender = props.dateRender,
              disabledDate = props.disabledDate,
              hoverValue = props.hoverValue;
          var iIndex = void 0;
          var jIndex = void 0;
          var current = void 0;
          var dateTable = [];
          var today = Object(util["d"
          /* getTodayTime */
          ])(value);
          var cellClass = prefixCls + '-cell';
          var weekNumberCellClass = prefixCls + '-week-number-cell';
          var dateClass = prefixCls + '-date';
          var todayClass = prefixCls + '-today';
          var selectedClass = prefixCls + '-selected-day';
          var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation

          var selectedStartDateClass = prefixCls + '-selected-start-date';
          var selectedEndDateClass = prefixCls + '-selected-end-date';
          var inRangeClass = prefixCls + '-in-range-cell';
          var lastMonthDayClass = prefixCls + '-last-month-cell';
          var nextMonthDayClass = prefixCls + '-next-month-btn-day';
          var disabledClass = prefixCls + '-disabled-cell';
          var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
          var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
          var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
          var month1 = value.clone();
          month1.date(1);
          var day = month1.day();
          var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7; // calculate last month

          var lastMonth1 = month1.clone();
          lastMonth1.add(0 - lastMonthDiffDay, 'days');
          var passed = 0;

          for (iIndex = 0; iIndex < DateConstants.DATE_ROW_COUNT; iIndex++) {
            for (jIndex = 0; jIndex < DateConstants.DATE_COL_COUNT; jIndex++) {
              current = lastMonth1;

              if (passed) {
                current = current.clone();
                current.add(passed, 'days');
              }

              dateTable.push(current);
              passed++;
            }
          }

          var tableHtml = [];
          passed = 0;

          for (iIndex = 0; iIndex < DateConstants.DATE_ROW_COUNT; iIndex++) {
            var _cx;

            var isCurrentWeek = void 0;
            var weekNumberCell = void 0;
            var isActiveWeek = false;
            var dateCells = [];

            if (showWeekNumber) {
              weekNumberCell = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('td', {
                key: dateTable[passed].week(),
                role: 'gridcell',
                className: weekNumberCellClass
              }, dateTable[passed].week());
            }

            for (jIndex = 0; jIndex < DateConstants.DATE_COL_COUNT; jIndex++) {
              var next = null;
              var last = null;
              current = dateTable[passed];

              if (jIndex < DateConstants.DATE_COL_COUNT - 1) {
                next = dateTable[passed + 1];
              }

              if (jIndex > 0) {
                last = dateTable[passed - 1];
              }

              var cls = cellClass;
              var disabled = false;
              var selected = false;

              if (DateTBody_isSameDay(current, today)) {
                cls += ' ' + todayClass;
                isCurrentWeek = true;
              }

              var isBeforeCurrentMonthYear = DateTBody_beforeCurrentMonthYear(current, value);
              var isAfterCurrentMonthYear = DateTBody_afterCurrentMonthYear(current, value);

              if (selectedValue && Array.isArray(selectedValue)) {
                var rangeValue = hoverValue.length ? hoverValue : selectedValue;

                if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
                  var startValue = rangeValue[0];
                  var endValue = rangeValue[1];

                  if (startValue) {
                    if (DateTBody_isSameDay(current, startValue)) {
                      selected = true;
                      isActiveWeek = true;
                      cls += ' ' + selectedStartDateClass;
                    }
                  }

                  if (startValue && endValue) {
                    if (DateTBody_isSameDay(current, endValue)) {
                      selected = true;
                      isActiveWeek = true;
                      cls += ' ' + selectedEndDateClass;
                    } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                      cls += ' ' + inRangeClass;
                    }
                  }
                }
              } else if (DateTBody_isSameDay(current, value)) {
                // keyboard change value, highlight works
                selected = true;
                isActiveWeek = true;
              }

              if (DateTBody_isSameDay(current, selectedValue)) {
                cls += ' ' + selectedDateClass;
              }

              if (isBeforeCurrentMonthYear) {
                cls += ' ' + lastMonthDayClass;
              }

              if (isAfterCurrentMonthYear) {
                cls += ' ' + nextMonthDayClass;
              }

              if (current.clone().endOf('month').date() === current.date()) {
                cls += ' ' + lastDayOfMonthClass;
              }

              if (disabledDate) {
                if (disabledDate(current, value)) {
                  disabled = true;

                  if (!last || !disabledDate(last, value)) {
                    cls += ' ' + firstDisableClass;
                  }

                  if (!next || !disabledDate(next, value)) {
                    cls += ' ' + lastDisableClass;
                  }
                }
              }

              if (selected) {
                cls += ' ' + selectedClass;
              }

              if (disabled) {
                cls += ' ' + disabledClass;
              }

              var dateHtml = void 0;

              if (dateRender) {
                dateHtml = dateRender(current, value);
              } else {
                var content = contentRender ? contentRender(current, value) : current.date();
                dateHtml = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
                  key: DateTBody_getIdFromDate(current),
                  className: dateClass,
                  'aria-selected': selected,
                  'aria-disabled': disabled
                }, content);
              }

              dateCells.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('td', {
                key: passed,
                onClick: disabled ? undefined : props.onSelect.bind(null, current),
                onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
                role: 'gridcell',
                title: Object(util["c"
                /* getTitleString */
                ])(current),
                className: cls
              }, dateHtml));
              passed++;
            }

            tableHtml.push(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('tr', {
              key: iIndex,
              role: 'row',
              className: classnames_default()((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
            }, weekNumberCell, dateCells));
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('tbody', {
            className: prefixCls + '-tbody'
          }, tableHtml);
        }
      });
      /* harmony default export */

      var date_DateTBody = DateTBody_DateTBody; // CONCATENATED MODULE: ./node_modules/rc-calendar/es/date/DateTable.js

      var DateTable_DateTable = function (_React$Component) {
        inherits_default()(DateTable, _React$Component);

        function DateTable() {
          classCallCheck_default()(this, DateTable);
          return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
        }

        DateTable.prototype.render = function render() {
          var props = this.props;
          var prefixCls = props.prefixCls;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('table', {
            className: prefixCls + '-table',
            cellSpacing: '0',
            role: 'grid'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(date_DateTHead, props), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(date_DateTBody, props));
        };

        return DateTable;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);
      /* harmony default export */


      var date_DateTable = __webpack_exports__["a"] = DateTable_DateTable;
      /***/
    },
    /* 187 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);

      var getSuffixClassName = function getSuffixClassName(props) {
        if (props.isRequiredSuffix === true) {
          return 'formatic-label__required';
        } else if (props.isRequiredSuffix === false) {
          return 'formatic-label__optional';
        }

        return undefined;
      };

      var Label = function Label(props) {
        return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("label", {
          className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('formatic-label', _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, props.className, props.className)),
          htmlFor: props.labelFor
        }, props.prefixLabel && props.prefixLabel, react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", {
          className: "formatic-label__content"
        }, props.label), props.suffixLabel && react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", {
          className: getSuffixClassName(props)
        }, props.suffixLabel));
      };

      Label.defaultProps = {
        className: '',
        isRequiredSuffix: true,
        label: '',
        labelFor: '',
        prefixLabel: '',
        suffixLabel: ''
      };
      Label.propTypes = {
        className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        isRequiredSuffix: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
        label: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        labelFor: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        prefixLabel: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node]),
        suffixLabel: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool])
      };
      /* harmony default export */

      __webpack_exports__["a"] = Label;
      /***/
    },
    /* 188 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _Label__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(187);

      var Checkbox = function Checkbox(props) {
        return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Label__WEBPACK_IMPORTED_MODULE_6__[
        /* default */
        "a"], {
          className: "formatic-checkbox-list__checkbox-item-label",
          label: props.label,
          prefixLabel: [react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("input", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, props, {
            checked: props.checked,
            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('formatic-checkbox-list__checkbox-item', _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, props.className, props.className)),
            id: props.id,
            onBlur: props.onBlur,
            onChange: props.onChange,
            onFocus: props.onFocus,
            type: "checkbox",
            value: props.value,
            key: "".concat(props.id, "-input")
          })), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("span", {
            className: "formatic-checkbox-list__checkbox-item-checkmark",
            key: "".concat(props.id, "-span")
          }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("span", {
            className: "formatic-checkbox-list__checkbox-item-checkmark--checked"
          }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("i", {
            className: "material-icons"
          }, "check")))],
          labelFor: props.id
        });
      };

      Checkbox.defaultProps = {
        checked: false,
        className: '',
        label: '',
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_4___default.a,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_4___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_4___default.a
      };
      Checkbox.propTypes = {
        checked: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
        className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string.isRequired,
        label: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        value: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string.isRequired
      };
      /* harmony default export */

      __webpack_exports__["a"] = Checkbox;
      /***/
    },
    /* 189 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14);
      /* harmony import */


      var moment__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _util_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47);

      function noop() {}

      function getNow() {
        return moment__WEBPACK_IMPORTED_MODULE_3___default()();
      }

      function getNowByCurrentStateValue(value) {
        var ret = void 0;

        if (value) {
          ret = Object(_util_index__WEBPACK_IMPORTED_MODULE_4__[
          /* getTodayTime */
          "d"])(value);
        } else {
          ret = getNow();
        }

        return ret;
      }

      var CalendarMixin = {
        propTypes: {
          value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
          defaultValue: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
          onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
        },
        getDefaultProps: function getDefaultProps() {
          return {
            onKeyDown: noop
          };
        },
        getInitialState: function getInitialState() {
          var props = this.props;
          var value = props.value || props.defaultValue || getNow();
          return {
            value: value,
            selectedValue: props.selectedValue || props.defaultSelectedValue
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          var value = nextProps.value;
          var selectedValue = nextProps.selectedValue;

          if ('value' in nextProps) {
            value = value || nextProps.defaultValue || getNowByCurrentStateValue(this.state.value);
            this.setState({
              value: value
            });
          }

          if ('selectedValue' in nextProps) {
            this.setState({
              selectedValue: selectedValue
            });
          }
        },
        onSelect: function onSelect(value, cause) {
          if (value) {
            this.setValue(value);
          }

          this.setSelectedValue(value, cause);
        },
        renderRoot: function renderRoot(newProps) {
          var _className;

          var props = this.props;
          var prefixCls = props.prefixCls;
          var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('div', {
            ref: this.saveRoot,
            className: '' + classnames__WEBPACK_IMPORTED_MODULE_2___default()(className),
            style: this.props.style,
            tabIndex: '0',
            onKeyDown: this.onKeyDown
          }, newProps.children);
        },
        setSelectedValue: function setSelectedValue(selectedValue, cause) {
          // if (this.isAllowedDate(selectedValue)) {
          if (!('selectedValue' in this.props)) {
            this.setState({
              selectedValue: selectedValue
            });
          }

          this.props.onSelect(selectedValue, cause); // }
        },
        setValue: function setValue(value) {
          var originalValue = this.state.value;

          if (!('value' in this.props)) {
            this.setState({
              value: value
            });
          }

          if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
            this.props.onChange(value);
          }
        },
        isAllowedDate: function isAllowedDate(value) {
          var disabledDate = this.props.disabledDate;
          var disabledTime = this.props.disabledTime;
          return Object(_util_index__WEBPACK_IMPORTED_MODULE_4__[
          /* isAllowedDate */
          "f"])(value, disabledDate, disabledTime);
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = CalendarMixin;
      /***/
    },
    /* 190 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       * 
       */

      /*eslint-disable no-self-compare */

      var hasOwnProperty = Object.prototype.hasOwnProperty;
      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */

      function is(x, y) {
        // SameValue algorithm
        if (x === y) {
          // Steps 1-5, 7-10
          // Steps 6.b-6.e: +0 != -0
          // Added the nonzero y check to make Flow happy, but it is redundant
          return x !== 0 || y !== 0 || 1 / x === 1 / y;
        } else {
          // Step 6.a: NaN == NaN
          return x !== x && y !== y;
        }
      }
      /**
       * Performs equality by iterating through keys on an object and returning false
       * when any key has values which are not strictly equal between the arguments.
       * Returns true when the values of all keys are strictly equal.
       */


      function shallowEqual(objA, objB) {
        if (is(objA, objB)) {
          return true;
        }

        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
          return false;
        }

        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);

        if (keysA.length !== keysB.length) {
          return false;
        } // Test for A's keys different from B.


        for (var i = 0; i < keysA.length; i++) {
          if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
          }
        }

        return true;
      }

      module.exports = shallowEqual;
      /***/
    },
    /* 191 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (clearImmediate, setImmediate) {
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var draft_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31);
        /* harmony import */


        var draft_js__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(draft_js__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var immutable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66);
        /* harmony import */


        var immutable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var setimmediate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(334);
        /* harmony import */


        var setimmediate__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(setimmediate__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
        /* harmony import */


        var classnames__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Toolbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(666);
        /* harmony import */


        var _ConfigStore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(700);
        /* harmony import */


        var _export_getHTML__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(665);
        /* harmony import */


        var _export_exportText__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(386);
        /* harmony import */


        var _customHTML2Content__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(699);

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        /* tslint:disable:member-ordering interface-name */


        var hasCommandModifier = draft_js__WEBPACK_IMPORTED_MODULE_2__["KeyBindingUtil"].hasCommandModifier;

        function noop() {}

        ;
        var defaultPluginConfig = {};
        var focusDummyStyle = {
          width: 0,
          opacity: 0,
          border: 0,
          position: 'absolute',
          left: 0,
          top: 0
        };
        var toolbar = Object(_Toolbar__WEBPACK_IMPORTED_MODULE_6__[
        /* createToolbar */
        "a"])();
        var configStore = new _ConfigStore__WEBPACK_IMPORTED_MODULE_7__[
        /* default */
        "a"]();

        var EditorCore = function (_React$Component) {
          _inherits(EditorCore, _React$Component);

          function EditorCore(props) {
            _classCallCheck(this, EditorCore);

            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

            _this.cancelForceUpdateImmediate = function () {
              clearImmediate(_this.forceUpdateImmediate);
              _this.forceUpdateImmediate = null;
            };

            _this.handlePastedText = function (text, html) {
              var editorState = _this.state.editorState;

              if (html) {
                var contentState = editorState.getCurrentContent();
                var selection = editorState.getSelection();
                var fragment = Object(_customHTML2Content__WEBPACK_IMPORTED_MODULE_10__[
                /* default */
                "a"])(html, contentState);
                var pastedContent = draft_js__WEBPACK_IMPORTED_MODULE_2__["Modifier"].replaceWithFragment(contentState, selection, fragment);
                var newContent = pastedContent.merge({
                  selectionBefore: selection,
                  selectionAfter: pastedContent.getSelectionAfter().set('hasFocus', true)
                });

                _this.setEditorState(draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].push(editorState, newContent, 'insert-fragment'), true);

                return 'handled';
              }

              return 'not-handled';
            };

            _this.plugins = Object(immutable__WEBPACK_IMPORTED_MODULE_3__["List"])(Object(immutable__WEBPACK_IMPORTED_MODULE_3__["List"])(props.plugins).flatten(true));
            var editorState = void 0;

            if (props.value !== undefined) {
              if (props.value instanceof draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"]) {
                editorState = props.value || draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].createEmpty();
              } else {
                editorState = draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].createEmpty();
              }
            } else {
              editorState = draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].createEmpty();
            }

            editorState = _this.generatorDefaultValue(editorState);
            _this.state = {
              plugins: _this.reloadPlugins(),
              editorState: editorState,
              customStyleMap: {},
              customBlockStyleMap: {},
              compositeDecorator: null
            };

            if (props.value !== undefined) {
              _this.controlledMode = true;
              console.warn('this component is in controllred mode');
            }

            return _this;
          }

          EditorCore.ToEditorState = function ToEditorState(text) {
            var createEmptyContentState = draft_js__WEBPACK_IMPORTED_MODULE_2__["ContentState"].createFromText(Object(_export_exportText__WEBPACK_IMPORTED_MODULE_9__[
            /* decodeContent */
            "a"])(text) || '');
            var editorState = draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].createWithContent(createEmptyContentState);
            return draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].forceSelection(editorState, createEmptyContentState.getSelectionAfter());
          };

          EditorCore.prototype.getDefaultValue = function getDefaultValue() {
            var _props = this.props,
                defaultValue = _props.defaultValue,
                value = _props.value;
            return value || defaultValue;
          };

          EditorCore.prototype.Reset = function Reset() {
            var defaultValue = this.getDefaultValue();
            var contentState = defaultValue ? defaultValue.getCurrentContent() : draft_js__WEBPACK_IMPORTED_MODULE_2__["ContentState"].createFromText('');
            var updatedEditorState = draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].push(this.state.editorState, contentState, 'remove-range');
            this.setEditorState(draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].forceSelection(updatedEditorState, contentState.getSelectionBefore()));
          };

          EditorCore.prototype.SetText = function SetText(text) {
            var createTextContentState = draft_js__WEBPACK_IMPORTED_MODULE_2__["ContentState"].createFromText(text || '');
            var editorState = draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].push(this.state.editorState, createTextContentState, 'change-block-data');
            this.setEditorState(draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].moveFocusToEnd(editorState), true);
          };

          EditorCore.prototype.getChildContext = function getChildContext() {
            return {
              getEditorState: this.getEditorState,
              setEditorState: this.setEditorState
            };
          };

          EditorCore.prototype.reloadPlugins = function reloadPlugins() {
            var _this2 = this;

            return this.plugins && this.plugins.size ? this.plugins.map(function (plugin) {
              // 如果插件有 callbacks 方法,则认为插件已经加载。
              if (plugin.callbacks) {
                return plugin;
              } // 如果插件有 constructor 方法,则构造插件


              if (plugin.hasOwnProperty('constructor')) {
                var pluginConfig = _extends(_this2.props.pluginConfig, plugin.config || {}, defaultPluginConfig);

                return plugin.constructor(pluginConfig);
              } // else 无效插件


              console.warn('>> 插件: [', plugin.name, '] 无效。插件或许已经过期。');
              return false;
            }).filter(function (plugin) {
              return plugin;
            }).toArray() : [];
          };

          EditorCore.prototype.componentWillMount = function componentWillMount() {
            var plugins = this.initPlugins().concat([toolbar]);
            var customStyleMap = {};
            var customBlockStyleMap = {};
            var customBlockRenderMap = Object(immutable__WEBPACK_IMPORTED_MODULE_3__["Map"])(draft_js__WEBPACK_IMPORTED_MODULE_2__["DefaultDraftBlockRenderMap"]);
            var toHTMLList = Object(immutable__WEBPACK_IMPORTED_MODULE_3__["List"])([]); // initialize compositeDecorator

            var compositeDecorator = new draft_js__WEBPACK_IMPORTED_MODULE_2__["CompositeDecorator"](plugins.filter(function (plugin) {
              return plugin.decorators !== undefined;
            }).map(function (plugin) {
              return plugin.decorators;
            }).reduce(function (prev, curr) {
              return prev.concat(curr);
            }, [])); // initialize Toolbar

            var toolbarPlugins = Object(immutable__WEBPACK_IMPORTED_MODULE_3__["List"])(plugins.filter(function (plugin) {
              return !!plugin.component && plugin.name !== 'toolbar';
            })); // load inline styles...

            plugins.forEach(function (plugin) {
              var styleMap = plugin.styleMap,
                  blockStyleMap = plugin.blockStyleMap,
                  blockRenderMap = plugin.blockRenderMap,
                  toHtml = plugin.toHtml;

              if (styleMap) {
                for (var key in styleMap) {
                  if (styleMap.hasOwnProperty(key)) {
                    customStyleMap[key] = styleMap[key];
                  }
                }
              }

              if (blockStyleMap) {
                for (var _key in blockStyleMap) {
                  if (blockStyleMap.hasOwnProperty(_key)) {
                    customBlockStyleMap[_key] = blockStyleMap[_key];
                    customBlockRenderMap = customBlockRenderMap.set(_key, {
                      element: null
                    });
                  }
                }
              }

              if (toHtml) {
                toHTMLList = toHTMLList.push(toHtml);
              }

              if (blockRenderMap) {
                for (var _key2 in blockRenderMap) {
                  if (blockRenderMap.hasOwnProperty(_key2)) {
                    customBlockRenderMap = customBlockRenderMap.set(_key2, blockRenderMap[_key2]);
                  }
                }
              }
            });
            configStore.set('customStyleMap', customStyleMap);
            configStore.set('customBlockStyleMap', customBlockStyleMap);
            configStore.set('blockRenderMap', customBlockRenderMap);
            configStore.set('customStyleFn', this.customStyleFn.bind(this));
            configStore.set('toHTMLList', toHTMLList);
            this.setState({
              toolbarPlugins: toolbarPlugins,
              compositeDecorator: compositeDecorator
            });
            this.setEditorState(draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].set(this.state.editorState, {
              decorator: compositeDecorator
            }), false, false);
          };

          EditorCore.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.forceUpdateImmediate) {
              this.cancelForceUpdateImmediate();
            }

            if (this.controlledMode) {
              var decorators = nextProps.value.getDecorator();
              var editorState = decorators ? nextProps.value : draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].set(nextProps.value, {
                decorator: this.state.compositeDecorator
              });
              this.setState({
                editorState: editorState
              });
            }
          };

          EditorCore.prototype.componentWillUnmount = function componentWillUnmount() {
            this.cancelForceUpdateImmediate();
          }; // 处理 value


          EditorCore.prototype.generatorDefaultValue = function generatorDefaultValue(editorState) {
            var defaultValue = this.getDefaultValue();

            if (defaultValue) {
              return defaultValue;
            }

            return editorState;
          };

          EditorCore.prototype.getStyleMap = function getStyleMap() {
            return configStore.get('customStyleMap');
          };

          EditorCore.prototype.setStyleMap = function setStyleMap(customStyleMap) {
            configStore.set('customStyleMap', customStyleMap);
            this.render();
          };

          EditorCore.prototype.initPlugins = function initPlugins() {
            var _this3 = this;

            var enableCallbacks = ['focus', 'getEditorState', 'setEditorState', 'getStyleMap', 'setStyleMap'];
            return this.getPlugins().map(function (plugin) {
              enableCallbacks.forEach(function (callbackName) {
                if (plugin.callbacks.hasOwnProperty(callbackName)) {
                  plugin.callbacks[callbackName] = _this3[callbackName].bind(_this3);
                }
              });
              return plugin;
            });
          };

          EditorCore.prototype.focusEditor = function focusEditor(ev) {
            this.refs.editor.focus(ev);

            if (this.props.readOnly) {
              this._focusDummy.focus();
            }

            if (this.props.onFocus) {
              this.props.onFocus(ev);
            }
          };

          EditorCore.prototype._focus = function _focus(ev) {
            if (!ev || !ev.nativeEvent || !ev.nativeEvent.target) {
              return;
            }

            if (document.activeElement && document.activeElement.getAttribute('contenteditable') === 'true') {
              return;
            }

            return this.focus(ev);
          };

          EditorCore.prototype.focus = function focus(ev) {
            var _this4 = this;

            var event = ev && ev.nativeEvent;

            if (event && event.target === this._editorWrapper) {
              var editorState = this.state.editorState;
              var selection = editorState.getSelection();

              if (!selection.getHasFocus()) {
                if (selection.isCollapsed()) {
                  return this.setState({
                    editorState: draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"].moveSelectionToEnd(editorState)
                  }, function () {
                    _this4.focusEditor(ev);
                  });
                }
              }
            }

            this.focusEditor(ev);
          };

          EditorCore.prototype.getPlugins = function getPlugins() {
            return this.state.plugins.slice();
          };

          EditorCore.prototype.getEventHandler = function getEventHandler() {
            var _this5 = this;

            var enabledEvents = ['onUpArrow', 'onDownArrow', 'handleReturn', 'onFocus', 'onBlur', 'onTab', 'handlePastedText'];
            var eventHandler = {};
            enabledEvents.forEach(function (event) {
              eventHandler[event] = _this5.generatorEventHandler(event);
            });
            return eventHandler;
          };

          EditorCore.prototype.getEditorState = function getEditorState() {
            var needFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (needFocus) {
              this.refs.editor.focus();
            }

            return this.state.editorState;
          };

          EditorCore.prototype.setEditorState = function setEditorState(editorState) {
            var _this6 = this;

            var focusEditor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var triggerChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var newEditorState = editorState;
            this.getPlugins().forEach(function (plugin) {
              if (plugin.onChange) {
                var updatedEditorState = plugin.onChange(newEditorState);

                if (updatedEditorState) {
                  newEditorState = updatedEditorState;
                }
              }
            });

            if (this.props.onChange && triggerChange) {
              this.props.onChange(newEditorState); // close this issue https://github.com/ant-design/ant-design/issues/5788
              // when onChange not take any effect
              // `<Editor />` won't rerender cause no props is changed.
              // add an timeout here,
              // if props.onChange not trigger componentWillReceiveProps,
              // we will force render Editor with previous editorState,

              if (this.controlledMode) {
                this.forceUpdateImmediate = setImmediate(function () {
                  return _this6.setState({
                    editorState: new draft_js__WEBPACK_IMPORTED_MODULE_2__["EditorState"](_this6.state.editorState.getImmutable())
                  });
                });
              }
            }

            if (!this.controlledMode) {
              this.setState({
                editorState: newEditorState
              }, focusEditor ? function () {
                return setImmediate(function () {
                  return _this6.refs.editor.focus();
                });
              } : noop);
            }
          };

          EditorCore.prototype.handleKeyBinding = function handleKeyBinding(ev) {
            if (this.props.onKeyDown) {
              ev.ctrlKey = hasCommandModifier(ev);
              var keyDownResult = this.props.onKeyDown(ev);

              if (keyDownResult) {
                return keyDownResult;
              }

              return Object(draft_js__WEBPACK_IMPORTED_MODULE_2__["getDefaultKeyBinding"])(ev);
            }

            return Object(draft_js__WEBPACK_IMPORTED_MODULE_2__["getDefaultKeyBinding"])(ev);
          };

          EditorCore.prototype.handleKeyCommand = function handleKeyCommand(command) {
            if (this.props.multiLines) {
              return this.eventHandle('handleKeyBinding', command);
            }

            return command === 'split-block' ? 'handled' : 'not-handled';
          };

          EditorCore.prototype.getBlockStyle = function getBlockStyle(contentBlock) {
            var customBlockStyleMap = configStore.get('customBlockStyleMap');
            var type = contentBlock.getType();

            if (customBlockStyleMap.hasOwnProperty(type)) {
              return customBlockStyleMap[type];
            }

            return '';
          };

          EditorCore.prototype.blockRendererFn = function blockRendererFn(contentBlock) {
            var blockRenderResult = null;
            this.getPlugins().forEach(function (plugin) {
              if (plugin.blockRendererFn) {
                var result = plugin.blockRendererFn(contentBlock);

                if (result) {
                  blockRenderResult = result;
                }
              }
            });
            return blockRenderResult;
          };

          EditorCore.prototype.eventHandle = function eventHandle(eventName) {
            var _props2;

            var plugins = this.getPlugins();

            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key3 = 1; _key3 < _len; _key3++) {
              args[_key3 - 1] = arguments[_key3];
            }

            for (var i = 0; i < plugins.length; i++) {
              var plugin = plugins[i];

              if (plugin.callbacks[eventName] && typeof plugin.callbacks[eventName] === 'function') {
                var _plugin$callbacks;

                var result = (_plugin$callbacks = plugin.callbacks)[eventName].apply(_plugin$callbacks, args);

                if (result === true) {
                  return 'handled';
                }
              }
            }

            return this.props.hasOwnProperty(eventName) && (_props2 = this.props)[eventName].apply(_props2, args) === true ? 'handled' : 'not-handled';
          };

          EditorCore.prototype.generatorEventHandler = function generatorEventHandler(eventName) {
            var _this7 = this;

            return function () {
              for (var _len2 = arguments.length, args = Array(_len2), _key4 = 0; _key4 < _len2; _key4++) {
                args[_key4] = arguments[_key4];
              }

              return _this7.eventHandle.apply(_this7, [eventName].concat(args));
            };
          };

          EditorCore.prototype.customStyleFn = function customStyleFn(styleSet) {
            if (styleSet.size === 0) {
              return {};
            }

            var plugins = this.getPlugins();
            var resultStyle = {};

            for (var i = 0; i < plugins.length; i++) {
              if (plugins[i].customStyleFn) {
                var styled = plugins[i].customStyleFn(styleSet);

                if (styled) {
                  _extends(resultStyle, styled);
                }
              }
            }

            return resultStyle;
          };

          EditorCore.prototype.render = function render() {
            var _classnames,
                _this8 = this;

            var _props3 = this.props,
                prefixCls = _props3.prefixCls,
                toolbars = _props3.toolbars,
                style = _props3.style,
                readOnly = _props3.readOnly,
                multiLines = _props3.multiLines;
            var _state = this.state,
                editorState = _state.editorState,
                toolbarPlugins = _state.toolbarPlugins;
            var customStyleMap = configStore.get('customStyleMap');
            var blockRenderMap = configStore.get('blockRenderMap');
            var eventHandler = this.getEventHandler();
            var Toolbar = toolbar.component;
            var cls = classnames__WEBPACK_IMPORTED_MODULE_5___default()((_classnames = {}, _classnames[prefixCls + '-editor'] = true, _classnames.readonly = readOnly, _classnames.oneline = !multiLines, _classnames));
            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('div', {
              style: style,
              className: cls,
              onClick: this._focus.bind(this)
            }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Toolbar, {
              editorState: editorState,
              prefixCls: prefixCls,
              className: prefixCls + '-toolbar',
              plugins: toolbarPlugins,
              toolbars: toolbars
            }), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('div', {
              className: prefixCls + '-editor-wrapper',
              ref: function ref(ele) {
                return _this8._editorWrapper = ele;
              },
              style: style,
              onClick: function onClick(ev) {
                return ev.preventDefault();
              }
            }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(draft_js__WEBPACK_IMPORTED_MODULE_2__["Editor"], _extends({}, this.props, eventHandler, {
              ref: 'editor',
              customStyleMap: customStyleMap,
              customStyleFn: this.customStyleFn.bind(this),
              editorState: editorState,
              handleKeyCommand: this.handleKeyCommand.bind(this),
              keyBindingFn: this.handleKeyBinding.bind(this),
              onChange: this.setEditorState.bind(this),
              blockStyleFn: this.getBlockStyle.bind(this),
              blockRenderMap: blockRenderMap,
              handlePastedText: this.handlePastedText,
              blockRendererFn: this.blockRendererFn.bind(this)
            })), readOnly ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('input', {
              style: focusDummyStyle,
              ref: function ref(ele) {
                return _this8._focusDummy = ele;
              },
              onBlur: eventHandler.onBlur
            }) : null, this.props.children));
          };

          return EditorCore;
        }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

        EditorCore.GetText = _export_exportText__WEBPACK_IMPORTED_MODULE_9__[
        /* default */
        "b"];
        EditorCore.GetHTML = Object(_export_getHTML__WEBPACK_IMPORTED_MODULE_8__[
        /* default */
        "a"])(configStore);
        EditorCore.defaultProps = {
          multiLines: true,
          plugins: [],
          prefixCls: 'rc-editor-core',
          pluginConfig: {},
          toolbars: [],
          spilitLine: 'enter'
        };
        EditorCore.childContextTypes = {
          getEditorState: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          setEditorState: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
        };
        /* harmony default export */

        __webpack_exports__["a"] = EditorCore;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(458).clearImmediate, __webpack_require__(458).setImmediate);
      /***/
    },
    /* 192 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "b", function () {
        return initialState;
      });
      /* harmony import */


      var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40);
      /* harmony import */


      var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29);
      /* harmony import */


      var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27);
      /* harmony import */


      var _RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54);

      var _validators;

      var initialState = {
        apiKey: null,
        channel: 'default',
        config: 'default',
        currentPage: {},
        // { 'channel-name': { pageId: 'current-page-id', timestamp: null } }
        custom: {},
        data: {
          submission: {
            fieldsById: {}
          },
          form: {
            fieldsById: {},
            pagesById: {},
            sectionsById: {}
          }
        },
        emitter: null,
        environment: null,
        fieldsImpactingPageFlow: {},
        flow: {
          current: _RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_6__[
          /* Constants */
          "a"].DefaultFlow,
          flows: _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, _RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_6__[
          /* Constants */
          "a"].DefaultFlow, [])
        },
        formLoading: true,
        submissionCompleted: false,
        formId: null,
        initialValues: [],
        // contains all the fieldIds in the order of the form defition across sections and pages
        // NOTE: it does NOT contain the field ids that are inside of a repeatable, only the repeatable id
        orderedFields: [],
        pageFlow: _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, _RootComponents_helpers_pageFlow__WEBPACK_IMPORTED_MODULE_6__[
        /* Constants */
        "a"].DefaultFlow, []),
        pageNavigation: {
          navigate: null,
          submitForm: null
        },
        bodyClass: [],
        submissionId: null,
        tokens: {},
        validators: (_validators = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_validators, _utils_constants__WEBPACK_IMPORTED_MODULE_5__["Validator"].Custom, {}), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_validators, _utils_constants__WEBPACK_IMPORTED_MODULE_5__["Validator"].Empty, {}), _validators),
        // all fields in visibleFields that are in a repeatable will have the same fieldIndexInForm. More info on withFieldValidation
        visibleFields: {},
        // its keys are fields id. Every object has { errors: {}, validate: () => {}, fieldIndexInForm: 0 }
        dataForm: {
          attributes: {
            variables: {}
          }
        }
      };

      var setCustomSubItem = function setCustomSubItem(state, _ref) {
        var data = _ref.data,
            key = _ref.key,
            merge = _ref.merge;
        var newData = merge === true && state.custom[key] ? _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.custom[key], data) : data;
        return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
          custom: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.custom, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, key, newData))
        });
      };
      /* harmony default export */


      __webpack_exports__["a"] = function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
        var action = arguments.length > 1 ? arguments[1] : undefined;

        switch (action.type) {
          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_SUBMISSION_COMPLETION */
          "y"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              submissionCompleted: action.submissionCompleted
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* REMOVE_DATA_SUBMISSION_BY_ID */
          "f"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              data: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data, {
                submission: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.submission, {
                  fieldsById: {}
                }),
                Submission: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.Submission, {
                  fields: []
                })
              })
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* REGISTER_NAVIGATE */
          "c"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              pageNavigation: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.pageNavigation, {
                navigate: action.navigate
              })
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* REGISTER_SUBMIT_FORM */
          "d"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              pageNavigation: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.pageNavigation, {
                submitForm: action.submitForm
              })
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* ADD_VALIDATOR */
          "b"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              validators: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.validators, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, action.actionType, _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.validators[action.actionType], _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, action.fieldId, action.validator))))
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* STORE_FIELDS_IMPACTING_PAGE_FLOW */
          "E"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              fieldsImpactingPageFlow: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.fieldsImpactingPageFlow, action.fields)
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* STORE_DATA_FORM */
          "D"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              dataForm: action.dataForm
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* REMOVE_VALIDATOR */
          "g"]:
            if (action.actionType === null) {
              Object.keys(_utils_constants__WEBPACK_IMPORTED_MODULE_5__["Validator"]).forEach(function (type) {
                return delete state.validators[type][action.fieldId];
              });
            } else {
              delete state.validators[action.actionType][action.fieldId];
            }

            return state;

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_API_KEY */
          "i"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              apiKey: action.apiKey
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_CURRENT_PAGE */
          "k"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              currentPage: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.currentPage, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, action.channel, {
                pageId: action.pageId,
                timestamp: action.requestTimestamp
              }))
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_CURRENT_FLOW */
          "j"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              flow: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.flow, {
                current: action.name
              })
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_FORM_FLOWS */
          "r"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              flow: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.flow, {
                flows: action.flows
              })
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_SUBMISSION_ID */
          "z"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              submissionId: action.submissionId
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_ORDERED_FIELDS */
          "w"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              orderedFields: action.orderedFields
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_FIELD_ERRORS */
          "q"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              visibleFields: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.visibleFields, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, action.fieldId, _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.visibleFields[action.fieldId], {
                errors: action.errors
              })))
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_VISIBLE_FIELDS */
          "C"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              visibleFields: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.visibleFields, action.visibleFields)
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* REMOVE_VISIBLE_FIELDS */
          "h"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              visibleFields: lodash_omit__WEBPACK_IMPORTED_MODULE_3___default()(state.visibleFields, action.visibleFields)
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_TOKENS */
          "B"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              tokens: action.tokens
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_TOKEN */
          "A"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              tokens: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.tokens, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, action.path, action.value))
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_PAGE_FLOW */
          "x"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              pageFlow: action.pageFlow
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_FORM_ID */
          "s"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              formId: action.formId
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_FORM_LOADING */
          "t"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              formLoading: action.formLoading
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_DATA_SUBMISSION_BY_ID */
          "p"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              data: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data, {
                submission: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.submission, {
                  attributesById: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.submission.attributesById, action.submissionAttributesById),
                  fieldsById: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.submission.fieldsById, action.submissionFieldsById)
                })
              })
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_DATA_SUBMISSION */
          "o"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              data: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data, {
                Submission: action.submission
              })
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_DATA_FORM_BY_ID */
          "m"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              data: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data, {
                form: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.form, {
                  fieldsById: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.form.fieldsById, action.fieldsById),
                  sectionsById: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.form.sectionsById, action.sectionsById),
                  pagesById: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.form.pagesById, action.pagesById)
                })
              })
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_DATA_MACHINE_TAGS_TO_FIELD_IDS */
          "n"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              data: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data, {
                form: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.form, {
                  machineTagsToFieldIds: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state.data.form.machineTagsToFieldIds, action.machineTagsToFieldIds)
                })
              })
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_INTERACTIONS */
          "v"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              interactions: action.interactions
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_CUSTOM_SUBITEM */
          "l"]:
            return setCustomSubItem(state, action);

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* REMOVE_BODY_CLASS */
          "e"]:
            {
              if (!state.bodyClass.includes(action.className)) {
                return state;
              }

              var bodyClass = state.bodyClass;
              var classPosition = bodyClass.indexOf(action.className);
              bodyClass.splice(classPosition, 1);
              return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
                bodyClass: bodyClass
              });
            }

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* ADD_BODY_CLASS */
          "a"]:
            if (state.bodyClass.includes(action.className)) {
              return state;
            }

            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              bodyClass: [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(state.bodyClass), [action.className])
            });

          case _actions__WEBPACK_IMPORTED_MODULE_4__[
          /* SET_INITIAL_VALUES */
          "u"]:
            return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, {
              initialValues: action.initialValues
            });

          default:
            return state;
        }
      };
      /***/

    },
    /* 193 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var array = __webpack_require__(48);

      var isInteger = __webpack_require__(67).isInteger;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        /**
         * Create a 2-dimensional identity matrix with size m x n or n x n.
         * The matrix has ones on the diagonal and zeros elsewhere.
         *
         * Syntax:
         *
         *    math.identity(n)
         *    math.identity(n, format)
         *    math.identity(m, n)
         *    math.identity(m, n, format)
         *    math.identity([m, n])
         *    math.identity([m, n], format)
         *
         * Examples:
         *
         *    math.identity(3)                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
         *    math.identity(3, 2)                 // returns [[1, 0], [0, 1], [0, 0]]
         *
         *    const A = [[1, 2, 3], [4, 5, 6]]
         *    math.identity(math.size(A))         // returns [[1, 0, 0], [0, 1, 0]]
         *
         * See also:
         *
         *    diag, ones, zeros, size, range
         *
         * @param {...number | Matrix | Array} size   The size for the matrix
         * @param {string} [format]                   The Matrix storage format
         *
         * @return {Matrix | Array | number} A matrix with ones on the diagonal.
         */

        var identity = typed('identity', {
          '': function _() {
            return config.matrix === 'Matrix' ? matrix([]) : [];
          },
          'string': function string(format) {
            return matrix(format);
          },
          'number | BigNumber': function numberBigNumber(rows) {
            return _identity(rows, rows, config.matrix === 'Matrix' ? 'default' : undefined);
          },
          'number | BigNumber, string': function numberBigNumberString(rows, format) {
            return _identity(rows, rows, format);
          },
          'number | BigNumber, number | BigNumber': function numberBigNumberNumberBigNumber(rows, cols) {
            return _identity(rows, cols, config.matrix === 'Matrix' ? 'default' : undefined);
          },
          'number | BigNumber, number | BigNumber, string': function numberBigNumberNumberBigNumberString(rows, cols, format) {
            return _identity(rows, cols, format);
          },
          'Array': function Array(size) {
            return _identityVector(size);
          },
          'Array, string': function ArrayString(size, format) {
            return _identityVector(size, format);
          },
          'Matrix': function Matrix(size) {
            return _identityVector(size.valueOf(), size.storage());
          },
          'Matrix, string': function MatrixString(size, format) {
            return _identityVector(size.valueOf(), format);
          }
        });
        identity.toTex = undefined; // use default template

        return identity;

        function _identityVector(size, format) {
          switch (size.length) {
            case 0:
              return format ? matrix(format) : [];

            case 1:
              return _identity(size[0], size[0], format);

            case 2:
              return _identity(size[0], size[1], format);

            default:
              throw new Error('Vector containing two values expected');
          }
        }
        /**
         * Create an identity matrix
         * @param {number | BigNumber} rows
         * @param {number | BigNumber} cols
         * @param {string} [format]
         * @returns {Matrix}
         * @private
         */


        function _identity(rows, cols, format) {
          // BigNumber constructor with the right precision
          var Big = type.isBigNumber(rows) || type.isBigNumber(cols) ? type.BigNumber : null;
          if (type.isBigNumber(rows)) rows = rows.toNumber();
          if (type.isBigNumber(cols)) cols = cols.toNumber();

          if (!isInteger(rows) || rows < 1) {
            throw new Error('Parameters in function identity must be positive integers');
          }

          if (!isInteger(cols) || cols < 1) {
            throw new Error('Parameters in function identity must be positive integers');
          }

          var one = Big ? new type.BigNumber(1) : 1;
          var defaultValue = Big ? new Big(0) : 0;
          var size = [rows, cols]; // check we need to return a matrix

          if (format) {
            // get matrix storage constructor
            var F = type.Matrix.storage(format); // create diagonal matrix (use optimized implementation for storage format)

            return F.diagonal(size, one, 0, defaultValue);
          } // create and resize array


          var res = array.resize([], size, defaultValue); // fill in ones on the diagonal

          var minimum = rows < cols ? rows : cols; // fill diagonal

          for (var d = 0; d < minimum; d++) {
            res[d][d] = one;
          }

          return res;
        }
      }

      exports.name = 'identity';
      exports.factory = factory;
      /***/
    },
    /* 194 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        /**
         * Calculate the absolute value of a number. For matrices, the function is
         * evaluated element wise.
         *
         * Syntax:
         *
         *    math.abs(x)
         *
         * Examples:
         *
         *    math.abs(3.5)                // returns number 3.5
         *    math.abs(-4.2)               // returns number 4.2
         *
         *    math.abs([3, -5, -1, 0, 2])  // returns Array [3, 5, 1, 0, 2]
         *
         * See also:
         *
         *    sign
         *
         * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
         *            A number or matrix for which to get the absolute value
         * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
         *            Absolute value of `x`
         */
        var abs = typed('abs', {
          'number': Math.abs,
          'Complex': function Complex(x) {
            return x.abs();
          },
          'BigNumber': function BigNumber(x) {
            return x.abs();
          },
          'Fraction': function Fraction(x) {
            return x.abs();
          },
          'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since abs(0) = 0
            return deepMap(x, abs, true);
          },
          'Unit': function Unit(x) {
            return x.abs();
          }
        });
        abs.toTex = {
          1: "\\left|${args[0]}\\right|"
        };
        return abs;
      }

      exports.name = 'abs';
      exports.factory = factory;
      /***/
    },
    /* 195 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        var latex = __webpack_require__(72);
        /**
         * Inverse the sign of a value, apply a unary minus operation.
         *
         * For matrices, the function is evaluated element wise. Boolean values and
         * strings will be converted to a number. For complex numbers, both real and
         * complex value are inverted.
         *
         * Syntax:
         *
         *    math.unaryMinus(x)
         *
         * Examples:
         *
         *    math.unaryMinus(3.5)      // returns -3.5
         *    math.unaryMinus(-4.2)     // returns 4.2
         *
         * See also:
         *
         *    add, subtract, unaryPlus
         *
         * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Number to be inverted.
         * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Returns the value with inverted sign.
         */


        var unaryMinus = typed('unaryMinus', {
          'number': function number(x) {
            return -x;
          },
          'Complex': function Complex(x) {
            return x.neg();
          },
          'BigNumber': function BigNumber(x) {
            return x.neg();
          },
          'Fraction': function Fraction(x) {
            return x.neg();
          },
          'Unit': function Unit(x) {
            var res = x.clone();
            res.value = unaryMinus(x.value);
            return res;
          },
          'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryMinus(0) = 0
            return deepMap(x, unaryMinus, true);
          } // TODO: add support for string

        });
        unaryMinus.toTex = {
          1: "".concat(latex.operators['unaryMinus'], "\\left(${args[0]}\\right)")
        };
        return unaryMinus;
      }

      exports.name = 'unaryMinus';
      exports.factory = factory;
      /***/
    },
    /* 196 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var DimensionError = __webpack_require__(92);

      function factory(type, config, load, typed) {
        var latex = __webpack_require__(72);

        var matrix = load(__webpack_require__(46));
        var addScalar = load(__webpack_require__(197));
        var unaryMinus = load(__webpack_require__(195));
        var algorithm01 = load(__webpack_require__(405));
        var algorithm03 = load(__webpack_require__(152));
        var algorithm05 = load(__webpack_require__(304));
        var algorithm10 = load(__webpack_require__(404));
        var algorithm13 = load(__webpack_require__(129));
        var algorithm14 = load(__webpack_require__(107)); // TODO: split function subtract in two: subtract and subtractScalar

        /**
         * Subtract two values, `x - y`.
         * For matrices, the function is evaluated element wise.
         *
         * Syntax:
         *
         *    math.subtract(x, y)
         *
         * Examples:
         *
         *    math.subtract(5.3, 2)        // returns number 3.3
         *
         *    const a = math.complex(2, 3)
         *    const b = math.complex(4, 1)
         *    math.subtract(a, b)          // returns Complex -2 + 2i
         *
         *    math.subtract([5, 7, 4], 4)  // returns Array [1, 3, 0]
         *
         *    const c = math.unit('2.1 km')
         *    const d = math.unit('500m')
         *    math.subtract(c, d)          // returns Unit 1.6 km
         *
         * See also:
         *
         *    add
         *
         * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x
         *            Initial value
         * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y
         *            Value to subtract from `x`
         * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
         *            Subtraction of `x` and `y`
         */

        var subtract = typed('subtract', {
          'number, number': function numberNumber(x, y) {
            return x - y;
          },
          'Complex, Complex': function ComplexComplex(x, y) {
            return x.sub(y);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.minus(y);
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return x.sub(y);
          },
          'Unit, Unit': function UnitUnit(x, y) {
            if (x.value === null) {
              throw new Error('Parameter x contains a unit with undefined value');
            }

            if (y.value === null) {
              throw new Error('Parameter y contains a unit with undefined value');
            }

            if (!x.equalBase(y)) {
              throw new Error('Units do not match');
            }

            var res = x.clone();
            res.value = subtract(res.value, y.value);
            res.fixPrefix = false;
            return res;
          },
          'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            checkEqualDimensions(x, y);
            return algorithm05(x, y, subtract);
          },
          'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            checkEqualDimensions(x, y);
            return algorithm03(y, x, subtract, true);
          },
          'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            checkEqualDimensions(x, y);
            return algorithm01(x, y, subtract, false);
          },
          'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            checkEqualDimensions(x, y);
            return algorithm13(x, y, subtract);
          },
          'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return subtract(matrix(x), matrix(y)).valueOf();
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return subtract(matrix(x), y);
          },
          'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return subtract(x, matrix(y));
          },
          'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm10(x, unaryMinus(y), addScalar);
          },
          'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, subtract);
          },
          'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm10(y, x, subtract, true);
          },
          'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, subtract, true);
          },
          'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, subtract, false).valueOf();
          },
          'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, subtract, true).valueOf();
          }
        });
        subtract.toTex = {
          2: "\\left(${args[0]}".concat(latex.operators['subtract'], "${args[1]}\\right)")
        };
        return subtract;
      }
      /**
       * Check whether matrix x and y have the same number of dimensions.
       * Throws a DimensionError when dimensions are not equal
       * @param {Matrix} x
       * @param {Matrix} y
       */


      function checkEqualDimensions(x, y) {
        var xsize = x.size();
        var ysize = y.size();

        if (xsize.length !== ysize.length) {
          throw new DimensionError(xsize.length, ysize.length);
        }
      }

      exports.name = 'subtract';
      exports.factory = factory;
      /***/
    },
    /* 197 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        /**
         * Add two scalar values, `x + y`.
         * This function is meant for internal use: it is used by the public function
         * `add`
         *
         * This function does not support collections (Array or Matrix), and does
         * not validate the number of of inputs.
         *
         * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to add
         * @param  {number | BigNumber | Fraction | Complex} y          Second value to add
         * @return {number | BigNumber | Fraction | Complex | Unit}                      Sum of `x` and `y`
         * @private
         */
        var add = typed('add', {
          'number, number': function numberNumber(x, y) {
            return x + y;
          },
          'Complex, Complex': function ComplexComplex(x, y) {
            return x.add(y);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.plus(y);
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return x.add(y);
          },
          'Unit, Unit': function UnitUnit(x, y) {
            if (x.value === null || x.value === undefined) throw new Error('Parameter x contains a unit with undefined value');
            if (y.value === null || y.value === undefined) throw new Error('Parameter y contains a unit with undefined value');
            if (!x.equalBase(y)) throw new Error('Units do not match');
            var res = x.clone();
            res.value = add(res.value, y.value);
            res.fixPrefix = false;
            return res;
          }
        });
        return add;
      }

      exports.factory = factory;
      /***/
    },
    /* 198 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Create a range error with the message:
       *     'Index out of range (index < min)'
       *     'Index out of range (index < max)'
       *
       * @param {number} index     The actual index
       * @param {number} [min=0]   Minimum index (included)
       * @param {number} [max]     Maximum index (excluded)
       * @extends RangeError
       */

      function IndexError(index, min, max) {
        if (!(this instanceof IndexError)) {
          throw new SyntaxError('Constructor must be called with the new operator');
        }

        this.index = index;

        if (arguments.length < 3) {
          this.min = 0;
          this.max = min;
        } else {
          this.min = min;
          this.max = max;
        }

        if (this.min !== undefined && this.index < this.min) {
          this.message = 'Index out of range (' + this.index + ' < ' + this.min + ')';
        } else if (this.max !== undefined && this.index >= this.max) {
          this.message = 'Index out of range (' + this.index + ' > ' + (this.max - 1) + ')';
        } else {
          this.message = 'Index out of range (' + this.index + ')';
        }

        this.stack = new Error().stack;
      }

      IndexError.prototype = new RangeError();
      IndexError.prototype.constructor = RangeError;
      IndexError.prototype.name = 'IndexError';
      IndexError.prototype.isIndexError = true;
      module.exports = IndexError;
      /***/
    },
    /* 199 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Test whether a value is a Matrix
       * @param {*} x
       * @returns {boolean} returns true with input is a Matrix
       *                    (like a DenseMatrix or SparseMatrix)
       */

      module.exports = function isMatrix(x) {
        return x && x.constructor.prototype.isMatrix || false;
      };
      /***/

    },
    /* 200 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var pushHash = function pushHash(hash) {
        hash = hash ? hash.indexOf('#') === 0 ? hash : '#' + hash : '';

        if (history.pushState) {
          var loc = window.location;
          history.pushState(null, null, hash ? loc.pathname + loc.search + hash // remove hash
          : loc.pathname + loc.search);
        } else {
          location.hash = hash;
        }
      };

      var getHash = function getHash() {
        return window.location.hash.replace(/^#/, '');
      };

      var filterElementInContainer = function filterElementInContainer(container) {
        return function (element) {
          return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
        };
      };

      var scrollOffset = function scrollOffset(c, t) {
        return c === document ? t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) : getComputedStyle(c).position !== "static" ? t.offsetTop : t.getBoundingClientRect().top + c.scrollTop;
      };

      exports.default = {
        pushHash: pushHash,
        getHash: getHash,
        filterElementInContainer: filterElementInContainer,
        scrollOffset: scrollOffset
      };
      /***/
    },
    /* 201 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var LocaleReceiver = function (_React$Component) {
        (0, _inherits3['default'])(LocaleReceiver, _React$Component);

        function LocaleReceiver() {
          (0, _classCallCheck3['default'])(this, LocaleReceiver);
          return (0, _possibleConstructorReturn3['default'])(this, (LocaleReceiver.__proto__ || Object.getPrototypeOf(LocaleReceiver)).apply(this, arguments));
        }

        (0, _createClass3['default'])(LocaleReceiver, [{
          key: 'getLocale',
          value: function getLocale() {
            var _props = this.props,
                componentName = _props.componentName,
                defaultLocale = _props.defaultLocale;
            var antLocale = this.context.antLocale;
            var localeFromContext = antLocale && antLocale[componentName];
            return (0, _extends3['default'])({}, typeof defaultLocale === 'function' ? defaultLocale() : defaultLocale, localeFromContext || {});
          }
        }, {
          key: 'getLocaleCode',
          value: function getLocaleCode() {
            var antLocale = this.context.antLocale;
            var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale

            if (antLocale && antLocale.exist && !localeCode) {
              return 'en-us';
            }

            return localeCode;
          }
        }, {
          key: 'render',
          value: function render() {
            return this.props.children(this.getLocale(), this.getLocaleCode());
          }
        }]);
        return LocaleReceiver;
      }(React.Component);

      exports['default'] = LocaleReceiver;
      LocaleReceiver.contextTypes = {
        antLocale: _propTypes2['default'].object
      };
      module.exports = exports['default'];
      /***/
    },
    /* 202 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseMatches = __webpack_require__(937),
          baseMatchesProperty = __webpack_require__(927),
          identity = __webpack_require__(207),
          isArray = __webpack_require__(55),
          property = __webpack_require__(925);
      /**
       * The base implementation of `_.iteratee`.
       *
       * @private
       * @param {*} [value=_.identity] The value to convert to an iteratee.
       * @returns {Function} Returns the iteratee.
       */


      function baseIteratee(value) {
        // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
        // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
        if (typeof value == 'function') {
          return value;
        }

        if (value == null) {
          return identity;
        }

        if (typeof value == 'object') {
          return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }

        return property(value);
      }

      module.exports = baseIteratee;
      /***/
    },
    /* 203 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule removeTextWithStrategy
       * @format
       * 
       */

      var DraftModifier = __webpack_require__(93);
      /**
       * For a collapsed selection state, remove text based on the specified strategy.
       * If the selection state is not collapsed, remove the entire selected range.
       */


      function removeTextWithStrategy(editorState, strategy, direction) {
        var selection = editorState.getSelection();
        var content = editorState.getCurrentContent();
        var target = selection;

        if (selection.isCollapsed()) {
          if (direction === 'forward') {
            if (editorState.isSelectionAtEndOfContent()) {
              return content;
            }
          } else if (editorState.isSelectionAtStartOfContent()) {
            return content;
          }

          target = strategy(editorState);

          if (target === selection) {
            return content;
          }
        }

        return DraftModifier.removeRange(content, target, direction);
      }

      module.exports = removeTextWithStrategy;
      /***/
    },
    /* 204 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule isEventHandled
       * @format
       * 
       */

      /**
       * Utility method for determining whether or not the value returned
       * from a handler indicates that it was handled.
       */

      function isEventHandled(value) {
        return value === 'handled' || value === true;
      }

      module.exports = isEventHandled;
      /***/
    },
    /* 205 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule findRangesImmutable
       * @format
       * 
       */

      /**
       * Search through an array to find contiguous stretches of elements that
       * match a specified filter function.
       *
       * When ranges are found, execute a specified `found` function to supply
       * the values to the caller.
       */

      function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
        if (!haystack.size) {
          return;
        }

        var cursor = 0;
        haystack.reduce(function (value, nextValue, nextIndex) {
          if (!areEqualFn(value, nextValue)) {
            if (filterFn(value)) {
              foundFn(cursor, nextIndex);
            }

            cursor = nextIndex;
          }

          return nextValue;
        });
        filterFn(haystack.last()) && foundFn(cursor, haystack.count());
      }

      module.exports = findRangesImmutable;
      /***/
    },
    /* 206 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule BlockMapBuilder
       * @format
       * 
       */

      var Immutable = __webpack_require__(53);

      var OrderedMap = Immutable.OrderedMap;
      var BlockMapBuilder = {
        createFromArray: function createFromArray(blocks) {
          return OrderedMap(blocks.map(function (block) {
            return [block.getKey(), block];
          }));
        }
      };
      module.exports = BlockMapBuilder;
      /***/
    },
    /* 207 */

    /***/
    function (module, exports) {
      /**
       * This method returns the first argument it receives.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {*} value Any value.
       * @returns {*} Returns `value`.
       * @example
       *
       * var object = { 'a': 1 };
       *
       * console.log(_.identity(object) === object);
       * // => true
       */
      function identity(value) {
        return value;
      }

      module.exports = identity;
      /***/
    },
    /* 208 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (module) {
        var root = __webpack_require__(103),
            stubFalse = __webpack_require__(1049);
        /** Detect free variable `exports`. */


        var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
        /** Detect free variable `module`. */

        var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
        /** Detect the popular CommonJS extension `module.exports`. */

        var moduleExports = freeModule && freeModule.exports === freeExports;
        /** Built-in value references. */

        var Buffer = moduleExports ? root.Buffer : undefined;
        /* Built-in method references for those with the same name as other `lodash` methods. */

        var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
        /**
         * Checks if `value` is a buffer.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
         * @example
         *
         * _.isBuffer(new Buffer(2));
         * // => true
         *
         * _.isBuffer(new Uint8Array(2));
         * // => false
         */

        var isBuffer = nativeIsBuffer || stubFalse;
        module.exports = isBuffer;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(212)(module));
      /***/
    },
    /* 209 */

    /***/
    function (module, exports) {
      /** Used for built-in method references. */
      var objectProto = Object.prototype;
      /**
       * Checks if `value` is likely a prototype object.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
       */

      function isPrototype(value) {
        var Ctor = value && value.constructor,
            proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
        return value === proto;
      }

      module.exports = isPrototype;
      /***/
    },
    /* 210 */

    /***/
    function (module, exports, __webpack_require__) {
      var defineProperty = __webpack_require__(505);
      /**
       * The base implementation of `assignValue` and `assignMergeValue` without
       * value checks.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */


      function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) {
          defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
          });
        } else {
          object[key] = value;
        }
      }

      module.exports = baseAssignValue;
      /***/
    },
    /* 211 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIsArguments = __webpack_require__(1067),
          isObjectLike = __webpack_require__(109);
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /** Built-in value references. */

      var propertyIsEnumerable = objectProto.propertyIsEnumerable;
      /**
       * Checks if `value` is likely an `arguments` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       *  else `false`.
       * @example
       *
       * _.isArguments(function() { return arguments; }());
       * // => true
       *
       * _.isArguments([1, 2, 3]);
       * // => false
       */

      var isArguments = baseIsArguments(function () {
        return arguments;
      }()) ? baseIsArguments : function (value) {
        return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
      };
      module.exports = isArguments;
      /***/
    },
    /* 212 */

    /***/
    function (module, exports) {
      module.exports = function (module) {
        if (!module.webpackPolyfill) {
          module.deprecate = function () {};

          module.paths = []; // module.parent = undefined by default

          if (!module.children) module.children = [];
          Object.defineProperty(module, "loaded", {
            enumerable: true,
            get: function get() {
              return module.l;
            }
          });
          Object.defineProperty(module, "id", {
            enumerable: true,
            get: function get() {
              return module.i;
            }
          });
          module.webpackPolyfill = 1;
        }

        return module;
      };
      /***/

    },
    /* 213 */

    /***/
    function (module, exports, __webpack_require__) {
      // 7.1.13 ToObject(argument)
      var defined = __webpack_require__(366);

      module.exports = function (it) {
        return Object(defined(it));
      };
      /***/

    },
    /* 214 */

    /***/
    function (module, exports) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };
      /***/

    },
    /* 215 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js


      var objectWithoutProperties = __webpack_require__(42);

      var objectWithoutProperties_default =
      /*#__PURE__*/
      __webpack_require__.n(objectWithoutProperties); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js


      var defineProperty = __webpack_require__(6);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js


      var createClass = __webpack_require__(12);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}


      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_ = __webpack_require__(16);

      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_); // EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 3 modules


      var Animate = __webpack_require__(43); // EXTERNAL MODULE: ./node_modules/rc-util/es/createChainedFunction.js


      var createChainedFunction = __webpack_require__(148); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // CONCATENATED MODULE: ./node_modules/rc-notification/es/Notice.js


      var Notice_Notice = function (_Component) {
        inherits_default()(Notice, _Component);

        function Notice() {
          var _ref;

          var _temp, _this, _ret;

          classCallCheck_default()(this, Notice);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
            _this.clearCloseTimer();

            _this.props.onClose();
          }, _this.startCloseTimer = function () {
            if (_this.props.duration) {
              _this.closeTimer = setTimeout(function () {
                _this.close();
              }, _this.props.duration * 1000);
            }
          }, _this.clearCloseTimer = function () {
            if (_this.closeTimer) {
              clearTimeout(_this.closeTimer);
              _this.closeTimer = null;
            }
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        createClass_default()(Notice, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.startCloseTimer();
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this.clearCloseTimer();
          }
        }, {
          key: 'render',
          value: function render() {
            var _className;

            var props = this.props;
            var componentClass = props.prefixCls + '-notice';
            var className = (_className = {}, defineProperty_default()(_className, '' + componentClass, 1), defineProperty_default()(_className, componentClass + '-closable', props.closable), defineProperty_default()(_className, props.className, !!props.className), _className);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: classnames_default()(className),
              style: props.style,
              onMouseEnter: this.clearCloseTimer,
              onMouseLeave: this.startCloseTimer
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: componentClass + '-content'
            }, props.children), props.closable ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('a', {
              tabIndex: '0',
              onClick: this.close,
              className: componentClass + '-close'
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
              className: componentClass + '-close-x'
            })) : null);
          }
        }]);
        return Notice;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Notice_Notice.propTypes = {
        duration: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        onClose: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      Notice_Notice.defaultProps = {
        onEnd: function onEnd() {},
        onClose: function onClose() {},
        duration: 1.5,
        style: {
          right: '50%'
        }
      };
      /* harmony default export */

      var es_Notice = Notice_Notice; // CONCATENATED MODULE: ./node_modules/rc-notification/es/Notification.js

      var Notification_seed = 0;
      var Notification_now = Date.now();

      function Notification_getUuid() {
        return 'rcNotification_' + Notification_now + '_' + Notification_seed++;
      }

      var Notification_Notification = function (_Component) {
        inherits_default()(Notification, _Component);

        function Notification() {
          var _ref;

          var _temp, _this, _ret;

          classCallCheck_default()(this, Notification);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            notices: []
          }, _this.add = function (notice) {
            var key = notice.key = notice.key || Notification_getUuid();

            _this.setState(function (previousState) {
              var notices = previousState.notices;

              if (!notices.filter(function (v) {
                return v.key === key;
              }).length) {
                return {
                  notices: notices.concat(notice)
                };
              }
            });
          }, _this.remove = function (key) {
            _this.setState(function (previousState) {
              return {
                notices: previousState.notices.filter(function (notice) {
                  return notice.key !== key;
                })
              };
            });
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        createClass_default()(Notification, [{
          key: 'getTransitionName',
          value: function getTransitionName() {
            var props = this.props;
            var transitionName = props.transitionName;

            if (!transitionName && props.animation) {
              transitionName = props.prefixCls + '-' + props.animation;
            }

            return transitionName;
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this,
                _className;

            var props = this.props;
            var noticeNodes = this.state.notices.map(function (notice) {
              var onClose = Object(createChainedFunction["a"
              /* default */
              ])(_this2.remove.bind(_this2, notice.key), notice.onClose);
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Notice, extends_default()({
                prefixCls: props.prefixCls
              }, notice, {
                onClose: onClose
              }), notice.content);
            });
            var className = (_className = {}, defineProperty_default()(_className, props.prefixCls, 1), defineProperty_default()(_className, props.className, !!props.className), _className);
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: classnames_default()(className),
              style: props.style
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Animate["default"], {
              transitionName: this.getTransitionName()
            }, noticeNodes));
          }
        }]);
        return Notification;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Notification_Notification.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        transitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        animation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };
      Notification_Notification.defaultProps = {
        prefixCls: 'rc-notification',
        animation: 'fade',
        style: {
          top: 65,
          left: '50%'
        }
      };

      Notification_Notification.newInstance = function newNotificationInstance(properties, callback) {
        var _ref2 = properties || {},
            getContainer = _ref2.getContainer,
            props = objectWithoutProperties_default()(_ref2, ['getContainer']);

        var div = document.createElement('div');

        if (getContainer) {
          var root = getContainer();
          root.appendChild(div);
        } else {
          document.body.appendChild(div);
        }

        var called = false;

        function ref(notification) {
          if (called) {
            return;
          }

          called = true;
          callback({
            notice: function notice(noticeProps) {
              notification.add(noticeProps);
            },
            removeNotice: function removeNotice(key) {
              notification.remove(key);
            },
            component: notification,
            destroy: function destroy() {
              external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.unmountComponentAtNode(div);
              div.parentNode.removeChild(div);
            }
          });
        }

        external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.render(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Notification_Notification, extends_default()({}, props, {
          ref: ref
        })), div);
      };
      /* harmony default export */


      var es_Notification = Notification_Notification; // CONCATENATED MODULE: ./node_modules/rc-notification/es/index.js

      /* harmony default export */

      var es = __webpack_exports__["default"] = es_Notification;
      /***/
    },
    /* 216 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(143);
      /* harmony import */


      var react_scroll__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react_scroll__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _requestData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64);
      /* harmony import */


      var _localStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44);
      /* harmony import */


      var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);
      /* harmony import */


      var _tokens_tokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61);
      /* harmony import */


      var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18);
      /* harmony default export */


      __webpack_exports__["a"] = {
        constants: {
          Analytics: _constants__WEBPACK_IMPORTED_MODULE_3__["Analytics"],
          Events: _constants__WEBPACK_IMPORTED_MODULE_3__["Events"],
          Validator: _constants__WEBPACK_IMPORTED_MODULE_3__["Validator"]
        },
        http: {
          apiServerUrl: _requestData__WEBPACK_IMPORTED_MODULE_1__[
          /* apiServerUrl */
          "a"],
          contentType: _requestData__WEBPACK_IMPORTED_MODULE_1__[
          /* contentType */
          "b"],
          queryEncode: _requestData__WEBPACK_IMPORTED_MODULE_1__[
          /* queryEncode */
          "c"],
          request: _requestData__WEBPACK_IMPORTED_MODULE_1__[
          /* requestData */
          "d"],
          requestData: _requestData__WEBPACK_IMPORTED_MODULE_1__[
          /* requestData */
          "d"],
          requestMethod: _requestData__WEBPACK_IMPORTED_MODULE_1__[
          /* requestMethod */
          "e"]
        },
        localStorage: {
          getLocalSubmissionId: _localStorage__WEBPACK_IMPORTED_MODULE_2__[
          /* getLocalSubmissionId */
          "d"]
        },
        scroller: react_scroll__WEBPACK_IMPORTED_MODULE_0__["scroller"],
        getSafeHTML: _utils__WEBPACK_IMPORTED_MODULE_5__[
        /* getSafeHTML */
        "m"],
        tokens: {
          tokenizer: _tokens_tokens__WEBPACK_IMPORTED_MODULE_4__[
          /* tokenizer */
          "e"]
        }
      };
      /***/
    },
    /* 217 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIteratee = __webpack_require__(202),
          baseUniq = __webpack_require__(326);
      /**
       * This method is like `_.uniq` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the criterion by which
       * uniqueness is computed. The order of result values is determined by the
       * order they occur in the array. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
       * // => [2.1, 1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }, { 'x': 2 }]
       */


      function uniqBy(array, iteratee) {
        return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
      }

      module.exports = uniqBy;
      /***/
    },
    /* 218 */

    /***/
    function (module, exports, __webpack_require__) {
      var constant = __webpack_require__(487),
          createInverter = __webpack_require__(720),
          identity = __webpack_require__(207);
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */

      var nativeObjectToString = objectProto.toString;
      /**
       * Creates an object composed of the inverted keys and values of `object`.
       * If `object` contains duplicate values, subsequent values overwrite
       * property assignments of previous values.
       *
       * @static
       * @memberOf _
       * @since 0.7.0
       * @category Object
       * @param {Object} object The object to invert.
       * @returns {Object} Returns the new inverted object.
       * @example
       *
       * var object = { 'a': 1, 'b': 2, 'c': 1 };
       *
       * _.invert(object);
       * // => { '1': 'c', '2': 'b' }
       */

      var invert = createInverter(function (result, value, key) {
        if (value != null && typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }

        result[value] = key;
      }, constant(identity));
      module.exports = invert;
      /***/
    },
    /* 219 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return getMathJsBuild;
      });
      /* harmony import */


      var mathjs_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(676);
      /* harmony import */


      var mathjs_core__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(mathjs_core__WEBPACK_IMPORTED_MODULE_0__);

      var math = mathjs_core__WEBPACK_IMPORTED_MODULE_0___default.a.create(); // We need to eval

      math.import(__webpack_require__(796)); // Need basic arithmatic

      math.import(__webpack_require__(170));
      math.import(__webpack_require__(196));
      math.import(__webpack_require__(124));
      math.import(__webpack_require__(774)); // Some additional useful functions

      math.import(__webpack_require__(194));
      math.import(__webpack_require__(771));
      math.import(__webpack_require__(770));
      math.import(__webpack_require__(769));
      math.import(__webpack_require__(768));
      math.import(__webpack_require__(766));
      math.import(__webpack_require__(400)); // Needed for string parsing of +-

      math.import(__webpack_require__(195));
      math.import(__webpack_require__(765)); // Will allow us to do some basic logic in the formula

      math.import(__webpack_require__(399));
      math.import(__webpack_require__(763)); // Matrix to allow array / set results

      math.import(__webpack_require__(762));
      math.import(__webpack_require__(755)); // Needed to determine type of result

      math.import(__webpack_require__(131)); // Needed to be able to convert scientific notation to numbers

      math.import(__webpack_require__(723));
      math.import(__webpack_require__(306)); // Get the build of math.js required to parse our supported calcs

      var getMathJsBuild = function getMathJsBuild() {
        return math;
      };
      /***/

    },
    /* 220 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _rcSelect = __webpack_require__(105);

      var _rcSelect2 = _interopRequireDefault(_rcSelect);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _LocaleReceiver = __webpack_require__(201);

      var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

      var _default = __webpack_require__(238);

      var _default2 = _interopRequireDefault(_default);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var __rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var SelectPropTypes = {
        prefixCls: _propTypes2['default'].string,
        className: _propTypes2['default'].string,
        size: _propTypes2['default'].oneOf(['default', 'large', 'small']),
        combobox: _propTypes2['default'].bool,
        notFoundContent: _propTypes2['default'].any,
        showSearch: _propTypes2['default'].bool,
        optionLabelProp: _propTypes2['default'].string,
        transitionName: _propTypes2['default'].string,
        choiceTransitionName: _propTypes2['default'].string
      }; // => It is needless to export the declaration of below two inner components.
      // export { Option, OptGroup };

      var Select = function (_React$Component) {
        (0, _inherits3['default'])(Select, _React$Component);

        function Select() {
          (0, _classCallCheck3['default'])(this, Select);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));

          _this.saveSelect = function (node) {
            _this.rcSelect = node;
          };

          _this.renderSelect = function (locale) {
            var _classNames;

            var _a = _this.props,
                prefixCls = _a.prefixCls,
                _a$className = _a.className,
                className = _a$className === undefined ? '' : _a$className,
                size = _a.size,
                mode = _a.mode,
                restProps = __rest(_a, ["prefixCls", "className", "size", "mode"]);

            var cls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), _classNames), className);
            var optionLabelProp = _this.props.optionLabelProp;
            var isCombobox = mode === 'combobox';

            if (isCombobox) {
              // children 带 dom 结构时，无法填入输入框
              optionLabelProp = optionLabelProp || 'value';
            }

            var modeConfig = {
              multiple: mode === 'multiple',
              tags: mode === 'tags',
              combobox: isCombobox
            };
            return React.createElement(_rcSelect2['default'], (0, _extends3['default'])({}, restProps, modeConfig, {
              prefixCls: prefixCls,
              className: cls,
              optionLabelProp: optionLabelProp || 'children',
              notFoundContent: _this.getNotFoundContent(locale),
              ref: _this.saveSelect
            }));
          };

          return _this;
        }

        (0, _createClass3['default'])(Select, [{
          key: 'focus',
          value: function focus() {
            this.rcSelect.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.rcSelect.blur();
          }
        }, {
          key: 'getNotFoundContent',
          value: function getNotFoundContent(locale) {
            var _props = this.props,
                notFoundContent = _props.notFoundContent,
                mode = _props.mode;
            var isCombobox = mode === 'combobox';

            if (isCombobox) {
              // AutoComplete don't have notFoundContent defaultly
              return notFoundContent === undefined ? null : notFoundContent;
            }

            return notFoundContent === undefined ? locale.notFoundContent : notFoundContent;
          }
        }, {
          key: 'render',
          value: function render() {
            return React.createElement(_LocaleReceiver2['default'], {
              componentName: 'Select',
              defaultLocale: _default2['default'].Select
            }, this.renderSelect);
          }
        }]);
        return Select;
      }(React.Component);

      exports['default'] = Select;
      Select.Option = _rcSelect.Option;
      Select.OptGroup = _rcSelect.OptGroup;
      Select.defaultProps = {
        prefixCls: 'ant-select',
        showSearch: false,
        transitionName: 'slide-up',
        choiceTransitionName: 'zoom'
      };
      Select.propTypes = SelectPropTypes;
      module.exports = exports['default'];
      /***/
    },
    /* 221 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _Checkbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(188);

      var CheckboxList = function CheckboxList(props) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
          id: props.id,
          className: props.className
        }, props.options.map(function (option, i) {
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
            className: "formatic-checkbox-list__checkbox-item-container",
            key: i
          }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Checkbox__WEBPACK_IMPORTED_MODULE_3__[
          /* default */
          "a"], {
            checked: props.value.includes(option),
            id: "".concat(props.id, "_").concat(i),
            label: option,
            key: "".concat(props.id, "-").concat(i),
            onBlur: props.onBlur,
            onChange: props.onChange,
            onFocus: props.onFocus,
            value: option
          }));
        }));
      };

      CheckboxList.defaultProps = {
        className: '',
        id: '',
        label: undefined,
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        options: [],
        value: []
      };
      CheckboxList.propTypes = {
        className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func]),
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        options: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string),
        value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string)
      };
      /* harmony default export */

      __webpack_exports__["a"] = CheckboxList;
      /***/
    },
    /* 222 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "b", function () {
        return subscriptionOnFormAction;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return subscriptionAttributeChanged;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "c", function () {
        return subscriptionValueChanged;
      });
      /* harmony import */


      var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78);
      /* harmony import */


      var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var react_apollo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58);
      /* harmony import */


      var react_apollo__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(react_apollo__WEBPACK_IMPORTED_MODULE_1__);

      function _templateObject3() {
        var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n  subscription valueChanged($submission: String!) {\n    valueChanged(id: $submission) {\n      id\n      value\n      requestTimestamp\n    }\n  }\n"]);

        _templateObject3 = function _templateObject3() {
          return data;
        };

        return data;
      }

      function _templateObject2() {
        var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n  subscription attributeChanged($submission: String!, $formId: Int!) {\n    attributeChanged(id: $submission, formId: $formId) {\n      id\n      value\n      requestTimestamp\n      type\n    }\n  }\n"]);

        _templateObject2 = function _templateObject2() {
          return data;
        };

        return data;
      }

      function _templateObject() {
        var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n  subscription onFormAction($submission: String!) {\n    formActionFired(id: $submission) {\n      type\n      params\n    }\n  }\n"]);

        _templateObject = function _templateObject() {
          return data;
        };

        return data;
      }

      var subscriptionOnFormAction = Object(react_apollo__WEBPACK_IMPORTED_MODULE_1__["gql"])(_templateObject());
      var subscriptionAttributeChanged = Object(react_apollo__WEBPACK_IMPORTED_MODULE_1__["gql"])(_templateObject2());
      var subscriptionValueChanged = Object(react_apollo__WEBPACK_IMPORTED_MODULE_1__["gql"])(_templateObject3());
      /***/
    },
    /* 223 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export FieldContainerWithoutHOC */

      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39);
      /* harmony import */


      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11);
      /* harmony import */


      var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_9___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_10___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
      /* harmony import */


      var recompose__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_12___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_12__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_13___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_13__);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(62);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_14___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_14__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_15___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_15__);
      /* harmony import */


      var react_redux__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33);
      /* harmony import */


      var _core_hoc_withOverride__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(83);
      /* harmony import */


      var _core_hoc_withVisibility__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(77);
      /* harmony import */


      var _config_containerMap__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(147);
      /* harmony import */


      var _core_utils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(18);
      /* harmony import */


      var _config_behaviorDefaults__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(169);
      /* harmony import */


      var _hocs_withHelpText__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(95);

      var propsToOmit = ['id', 'data', 'attributes', 'helpContent', 'helpTextPosition'];

      var FieldContainer =
      /*#__PURE__*/
      function (_Component) {
        _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(FieldContainer, _Component);

        function FieldContainer(props) {
          var _this;

          _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, FieldContainer);

          _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(FieldContainer).call(this, props));

          _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleOnFocus", function () {
            return _this.setState({
              inFocus: true
            });
          });

          _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleOnBlur", function () {
            return _this.setState({
              inFocus: false
            });
          });

          _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "fieldIsEmpty", function () {
            var value = _this.props.value;

            if (value === undefined) {
              return true;
            }

            if (typeof value === 'string' || Array.isArray(value)) {
              return value.length === 0;
            }

            if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(value) === 'object' && value.rawValue) {
              return value.rawValue.length === 0;
            } // safely default to false


            return false;
          });

          _this.state = {
            inFocus: false,
            inputId: Object(_core_utils__WEBPACK_IMPORTED_MODULE_20__[
            /* getRandomId */
            "k"])()
          };
          return _this;
        }

        _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(FieldContainer, [{
          key: "render",
          value: function render() {
            var _classNames;

            if (!_config_containerMap__WEBPACK_IMPORTED_MODULE_19__[
            /* default */
            "b"][this.props.renderer]) {
              return null; // unknown renderer
            }

            var fieldId = this.props.id;
            var Container = _config_containerMap__WEBPACK_IMPORTED_MODULE_19__[
            /* default */
            "b"][this.props.renderer];
            var _this$props = this.props,
                autoComplete = _this$props.autoComplete,
                helpContent = _this$props.helpContent,
                helpTextPosition = _this$props.helpTextPosition,
                className = _this$props.className,
                attributes = _this$props.attributes,
                renderer = _this$props.renderer,
                requiredSuffixLabel = _this$props.requiredSuffixLabel,
                showRequiredSuffixLabel = _this$props.showRequiredSuffixLabel,
                sectionId = _this$props.sectionId,
                logic = _this$props.logic;
            var _this$state = this.state,
                inFocus = _this$state.inFocus,
                inputId = _this$state.inputId;
            var isEmpty = this.fieldIsEmpty();
            return react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement("div", {
              className: classnames__WEBPACK_IMPORTED_MODULE_13___default()('formatic-field-container', (_classNames = {
                'formatic-with-help-text': helpContent
              }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_classNames, className, className), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_classNames, attributes.class, attributes.class), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_classNames, 'formatic-field-container--focused', inFocus), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_classNames, 'formatic-field-container--empty', isEmpty), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_classNames, 'formatic-field-container--non-empty', !isEmpty), _classNames)),
              "data-id": fieldId,
              "data-renderer": renderer,
              name: fieldId,
              "data-tag": attributes.tag
            }, helpTextPosition === _hocs_withHelpText__WEBPACK_IMPORTED_MODULE_22__[
            /* HelpTextPositions */
            "b"].left && helpContent, react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement("div", {
              className: classnames__WEBPACK_IMPORTED_MODULE_13___default()('formatic-field-container__field', {
                'formatic-field-container__field--with-help': helpContent
              })
            }, renderer !== 'repeatable' && react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(Container, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
              autoComplete: autoComplete,
              inputId: inputId,
              fieldId: fieldId,
              renderer: renderer,
              requiredSuffixLabel: requiredSuffixLabel,
              sectionId: sectionId,
              showRequiredSuffixLabel: showRequiredSuffixLabel
            }, attributes, {
              onFocus: this.handleOnFocus,
              onBlur: this.handleOnBlur,
              logic: logic
            })), renderer === 'repeatable' && react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(Container, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, lodash_omit__WEBPACK_IMPORTED_MODULE_14___default()(this.props, [].concat(propsToOmit)), {
              inputId: inputId,
              fieldId: fieldId,
              data: lodash_omit__WEBPACK_IMPORTED_MODULE_14___default()(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(this.props, 'data', {}), 'data.Form.attributes')
            }, attributes))), helpTextPosition === _hocs_withHelpText__WEBPACK_IMPORTED_MODULE_22__[
            /* HelpTextPositions */
            "b"].right && helpContent);
          }
        }]);

        return FieldContainer;
      }(react__WEBPACK_IMPORTED_MODULE_9__["Component"]);

      FieldContainer.defaultProps = {
        analyticsParams: {},
        attributes: {
          class: '',
          tag: ''
        },
        autoComplete: _config_behaviorDefaults__WEBPACK_IMPORTED_MODULE_21__[
        /* default */
        "a"].AutoComplete,
        changeValue: lodash_noop__WEBPACK_IMPORTED_MODULE_15___default.a,
        className: '',
        data: {},
        formId: 0,
        helpContent: null,
        helpTextPosition: _hocs_withHelpText__WEBPACK_IMPORTED_MODULE_22__[
        /* HelpTextConstants */
        "a"].DefaultPosition,
        id: '',
        key: '',
        registerValidator: lodash_noop__WEBPACK_IMPORTED_MODULE_15___default.a,
        logic: [],
        renderer: '',
        sectionId: '',
        sendAnalytics: lodash_noop__WEBPACK_IMPORTED_MODULE_15___default.a,
        analyticsInteraction: lodash_noop__WEBPACK_IMPORTED_MODULE_15___default.a,
        tokens: {},
        validate: lodash_noop__WEBPACK_IMPORTED_MODULE_15___default.a,
        value: undefined
      };
      FieldContainer.propTypes = {
        analyticsParams: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.object,
        attributes: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.shape({
          class: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
          tag: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string
        }),
        autoComplete: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
        changeValue: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.func,
        className: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
        data: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.object,
        formId: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.number,
        helpContent: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.node,
        helpTextPosition: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
        key: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
        logic: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.array,
        registerValidator: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.func,
        renderer: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
        sectionId: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,
        sendAnalytics: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.func,
        analyticsInteraction: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.func,
        tokens: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.object,
        validate: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.func,
        value: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.any,
        // behaviors
        requiredSuffixLabel: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string.isRequired,
        showRequiredSuffixLabel: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.bool.isRequired
      };

      var mapStateToProps = function mapStateToProps(_ref, _ref2) {
        var _ref$formatic = _ref.formatic,
            fieldsById = _ref$formatic.data.submission.fieldsById,
            _ref$formatic$dataFor = _ref$formatic.dataForm.attributes,
            _ref$formatic$dataFor2 = _ref$formatic$dataFor.allowAutoComplete,
            allowAutoComplete = _ref$formatic$dataFor2 === void 0 ? _config_behaviorDefaults__WEBPACK_IMPORTED_MODULE_21__[
        /* default */
        "a"].AutoComplete : _ref$formatic$dataFor2,
            _ref$formatic$dataFor3 = _ref$formatic$dataFor.requiredSuffixLabel,
            requiredSuffixLabel = _ref$formatic$dataFor3 === void 0 ? _config_behaviorDefaults__WEBPACK_IMPORTED_MODULE_21__[
        /* default */
        "a"].RequiredSuffixLabel : _ref$formatic$dataFor3,
            _ref$formatic$dataFor4 = _ref$formatic$dataFor.showRequiredSuffixLabel,
            showRequiredSuffixLabel = _ref$formatic$dataFor4 === void 0 ? _config_behaviorDefaults__WEBPACK_IMPORTED_MODULE_21__[
        /* default */
        "a"].ShowRequiredSuffixLabel : _ref$formatic$dataFor4;
        var id = _ref2.id;
        return {
          autoComplete: allowAutoComplete,
          requiredSuffixLabel: requiredSuffixLabel,
          showRequiredSuffixLabel: showRequiredSuffixLabel,
          value: fieldsById[id] && fieldsById[id].value ? fieldsById[id].value : undefined
        };
      };
      /* harmony default export */


      __webpack_exports__["a"] = Object(recompose__WEBPACK_IMPORTED_MODULE_11__[
      /* compose */
      "a"])(Object(react_redux__WEBPACK_IMPORTED_MODULE_16__[
      /* connect */
      "a"])(mapStateToProps), Object(_core_hoc_withVisibility__WEBPACK_IMPORTED_MODULE_18__[
      /* default */
      "a"])({
        type: 'field'
      }), Object(_core_hoc_withOverride__WEBPACK_IMPORTED_MODULE_17__[
      /* default */
      "a"])({
        overrideType: 'fieldContainer'
      }), _hocs_withHelpText__WEBPACK_IMPORTED_MODULE_22__[
      /* default */
      "c"])(FieldContainer);
      /***/
    },
    /* 224 */

    /***/
    function (module, exports, __webpack_require__) {
      var basePick = __webpack_require__(894),
          flatRest = __webpack_require__(442);
      /**
       * Creates an object composed of the picked `object` properties.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The source object.
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.pick(object, ['a', 'c']);
       * // => { 'a': 1, 'c': 3 }
       */


      var pick = flatRest(function (object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      module.exports = pick;
      /***/
    },
    /* 225 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _getPrototypeOf = __webpack_require__(1065);

      var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

      var _getOwnPropertyDescriptor = __webpack_require__(1062);

      var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;
        var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

        if (desc === undefined) {
          var parent = (0, _getPrototypeOf2.default)(object);

          if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;

          if (getter === undefined) {
            return undefined;
          }

          return getter.call(receiver);
        }
      };
      /***/

    },
    /* 226 */

    /***/
    function (module, exports) {
      function arrayTreeFilter(data, filterFn, options) {
        options = options || {};
        options.childrenKeyName = options.childrenKeyName || 'children';
        var children = data || [];
        var result = [];
        var level = 0;
        var foundItem;

        do {
          var foundItem = children.filter(function (item) {
            return filterFn(item, level);
          })[0];

          if (!foundItem) {
            break;
          }

          result.push(foundItem);
          children = foundItem[options.childrenKeyName] || [];
          level += 1;
        } while (children.length > 0);

        return result;
      }

      module.exports = arrayTreeFilter;
      /***/
    },
    /* 227 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _rcNotification = __webpack_require__(215);

      var _rcNotification2 = _interopRequireDefault(_rcNotification);

      var _icon = __webpack_require__(126);

      var _icon2 = _interopRequireDefault(_icon);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      var defaultDuration = 3;
      var defaultTop = void 0;
      var messageInstance = void 0;
      var key = 1;
      var prefixCls = 'ant-message';
      var transitionName = 'move-up';
      var getContainer = void 0;

      function getMessageInstance(callback) {
        if (messageInstance) {
          callback(messageInstance);
          return;
        }

        _rcNotification2['default'].newInstance({
          prefixCls: prefixCls,
          transitionName: transitionName,
          style: {
            top: defaultTop
          },
          getContainer: getContainer
        }, function (instance) {
          if (messageInstance) {
            callback(messageInstance);
            return;
          }

          messageInstance = instance;
          callback(instance);
        });
      }

      function notice(content) {
        var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDuration;
        var type = arguments[2];
        var onClose = arguments[3];
        var iconType = {
          info: 'info-circle',
          success: 'check-circle',
          error: 'cross-circle',
          warning: 'exclamation-circle',
          loading: 'loading'
        }[type];

        if (typeof duration === 'function') {
          onClose = duration;
          duration = defaultDuration;
        }

        var target = key++;
        getMessageInstance(function (instance) {
          instance.notice({
            key: target,
            duration: duration,
            style: {},
            content: React.createElement('div', {
              className: prefixCls + '-custom-content ' + prefixCls + '-' + type
            }, React.createElement(_icon2['default'], {
              type: iconType
            }), React.createElement('span', null, content)),
            onClose: onClose
          });
        });
        return function () {
          if (messageInstance) {
            messageInstance.removeNotice(target);
          }
        };
      }

      exports['default'] = {
        info: function info(content, duration, onClose) {
          return notice(content, duration, 'info', onClose);
        },
        success: function success(content, duration, onClose) {
          return notice(content, duration, 'success', onClose);
        },
        error: function error(content, duration, onClose) {
          return notice(content, duration, 'error', onClose);
        },
        // Departed usage, please use warning()
        warn: function warn(content, duration, onClose) {
          return notice(content, duration, 'warning', onClose);
        },
        warning: function warning(content, duration, onClose) {
          return notice(content, duration, 'warning', onClose);
        },
        loading: function loading(content, duration, onClose) {
          return notice(content, duration, 'loading', onClose);
        },
        config: function config(options) {
          if (options.top !== undefined) {
            defaultTop = options.top;
            messageInstance = null; // delete messageInstance for new defaultTop
          }

          if (options.duration !== undefined) {
            defaultDuration = options.duration;
          }

          if (options.prefixCls !== undefined) {
            prefixCls = options.prefixCls;
          }

          if (options.getContainer !== undefined) {
            getContainer = options.getContainer;
          }

          if (options.transitionName !== undefined) {
            transitionName = options.transitionName;
            messageInstance = null; // delete messageInstance for new transitionName
          }
        },
        destroy: function destroy() {
          if (messageInstance) {
            messageInstance.destroy();
            messageInstance = null;
          }
        }
      };
      module.exports = exports['default'];
      /***/
    },
    /* 228 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var _typeof = load(__webpack_require__(131));

        function getArrayDataType(array) {
          var _type; // to hold type info


          var _length = 0; // to hold length value to ensure it has consistent sizes

          for (var i = 0; i < array.length; i++) {
            var item = array[i];
            var isArray = Array.isArray(item); // Saving the target matrix row size

            if (i === 0 && isArray) {
              _length = item.length;
            } // If the current item is an array but the length does not equal the targetVectorSize


            if (isArray && item.length !== _length) {
              return undefined;
            }

            var itemType = isArray ? getArrayDataType(item) // recurse into a nested array
            : _typeof(item);

            if (_type === undefined) {
              _type = itemType; // first item
            } else if (_type !== itemType) {
              return 'mixed';
            } else {// we're good, everything has the same type so far
            }
          }

          return _type;
        }

        return getArrayDataType;
      }
      /**
       * Check the datatype of a given object
       * This is a low level implementation that should only be used by
       * parent Matrix classes such as SparseMatrix or DenseMatrix
       * This method does not validate Array Matrix shape
       * @param array
       * @return string
       */


      exports.factory = factory;
      /***/
    },
    /* 229 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var nearlyEqual = __webpack_require__(67).nearlyEqual;

      var bigNearlyEqual = __webpack_require__(130);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var algorithm03 = load(__webpack_require__(152));
        var algorithm07 = load(__webpack_require__(230));
        var algorithm12 = load(__webpack_require__(150));
        var algorithm13 = load(__webpack_require__(129));
        var algorithm14 = load(__webpack_require__(107));

        var latex = __webpack_require__(72);
        /**
         * Test whether value x is smaller than y.
         *
         * The function returns true when x is smaller than y and the relative
         * difference between x and y is smaller than the configured epsilon. The
         * function cannot be used to compare values smaller than approximately 2.22e-16.
         *
         * For matrices, the function is evaluated element wise.
         * Strings are compared by their numerical value.
         *
         * Syntax:
         *
         *    math.smaller(x, y)
         *
         * Examples:
         *
         *    math.smaller(2, 3)            // returns true
         *    math.smaller(5, 2 * 2)        // returns false
         *
         *    const a = math.unit('5 cm')
         *    const b = math.unit('2 inch')
         *    math.smaller(a, b)            // returns true
         *
         * See also:
         *
         *    equal, unequal, smallerEq, smaller, smallerEq, compare
         *
         * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
         * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
         * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
         */


        var smaller = typed('smaller', {
          'boolean, boolean': function booleanBoolean(x, y) {
            return x < y;
          },
          'number, number': function numberNumber(x, y) {
            return x < y && !nearlyEqual(x, y, config.epsilon);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.lt(y) && !bigNearlyEqual(x, y, config.epsilon);
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return x.compare(y) === -1;
          },
          'Complex, Complex': function ComplexComplex(x, y) {
            throw new TypeError('No ordering relation is defined for complex numbers');
          },
          'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) {
              throw new Error('Cannot compare units with different base');
            }

            return smaller(x.value, y.value);
          },
          'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, smaller);
          },
          'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, smaller, true);
          },
          'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, smaller, false);
          },
          'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, smaller);
          },
          'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return smaller(matrix(x), matrix(y)).valueOf();
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return smaller(matrix(x), y);
          },
          'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return smaller(x, matrix(y));
          },
          'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, smaller, false);
          },
          'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, smaller, false);
          },
          'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, smaller, true);
          },
          'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, smaller, true);
          },
          'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, smaller, false).valueOf();
          },
          'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, smaller, true).valueOf();
          }
        });
        smaller.toTex = {
          2: "\\left(${args[0]}".concat(latex.operators['smaller'], "${args[1]}\\right)")
        };
        return smaller;
      }

      exports.name = 'smaller';
      exports.factory = factory;
      /***/
    },
    /* 230 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var DimensionError = __webpack_require__(92);

      function factory(type, config, load, typed) {
        var DenseMatrix = type.DenseMatrix;
        /**
         * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij).
         * Callback function invoked MxN times.
         *
         * C(i,j) = f(Aij, Bij)
         *
         * @param {Matrix}   a                 The SparseMatrix instance (A)
         * @param {Matrix}   b                 The SparseMatrix instance (B)
         * @param {Function} callback          The f(Aij,Bij) operation to invoke
         *
         * @return {Matrix}                    DenseMatrix (C)
         *
         * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
         */

        var algorithm07 = function algorithm07(a, b, callback) {
          // sparse matrix arrays
          var asize = a._size;
          var adt = a._datatype; // sparse matrix arrays

          var bsize = b._size;
          var bdt = b._datatype; // validate dimensions

          if (asize.length !== bsize.length) {
            throw new DimensionError(asize.length, bsize.length);
          } // check rows & columns


          if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) {
            throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
          } // rows & columns


          var rows = asize[0];
          var columns = asize[1]; // datatype

          var dt; // zero value

          var zero = 0; // callback signature to use

          var cf = callback; // process data types

          if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype

            zero = typed.convert(0, dt); // callback

            cf = typed.find(callback, [dt, dt]);
          } // vars


          var i, j; // result arrays

          var cdata = []; // initialize c

          for (i = 0; i < rows; i++) {
            cdata[i] = [];
          } // matrix


          var c = new DenseMatrix({
            data: cdata,
            size: [rows, columns],
            datatype: dt
          }); // workspaces

          var xa = [];
          var xb = []; // marks indicating we have a value in x for a given column

          var wa = [];
          var wb = []; // loop columns

          for (j = 0; j < columns; j++) {
            // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace

            _scatter(a, j, wa, xa, mark); // scatter the values of B(:,j) into workspace


            _scatter(b, j, wb, xb, mark); // loop rows


            for (i = 0; i < rows; i++) {
              // matrix values @ i,j
              var va = wa[i] === mark ? xa[i] : zero;
              var vb = wb[i] === mark ? xb[i] : zero; // invoke callback

              cdata[i][j] = cf(va, vb);
            }
          } // return sparse matrix


          return c;
        };

        function _scatter(m, j, w, x, mark) {
          // a arrays
          var values = m._values;
          var index = m._index;
          var ptr = m._ptr; // loop values in column j

          for (var k = ptr[j], k1 = ptr[j + 1]; k < k1; k++) {
            // row
            var i = index[k]; // update workspace

            w[i] = mark;
            x[i] = values[k];
          }
        }

        return algorithm07;
      }

      exports.name = 'algorithm07';
      exports.factory = factory;
      /***/
    },
    /* 231 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var nearlyEqual = __webpack_require__(67).nearlyEqual;

      var bigNearlyEqual = __webpack_require__(130);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var algorithm03 = load(__webpack_require__(152));
        var algorithm07 = load(__webpack_require__(230));
        var algorithm12 = load(__webpack_require__(150));
        var algorithm13 = load(__webpack_require__(129));
        var algorithm14 = load(__webpack_require__(107));

        var latex = __webpack_require__(72);
        /**
         * Test whether value x is larger than y.
         *
         * The function returns true when x is larger than y and the relative
         * difference between x and y is larger than the configured epsilon. The
         * function cannot be used to compare values smaller than approximately 2.22e-16.
         *
         * For matrices, the function is evaluated element wise.
         * Strings are compared by their numerical value.
         *
         * Syntax:
         *
         *    math.larger(x, y)
         *
         * Examples:
         *
         *    math.larger(2, 3)             // returns false
         *    math.larger(5, 2 + 2)         // returns true
         *
         *    const a = math.unit('5 cm')
         *    const b = math.unit('2 inch')
         *    math.larger(a, b)             // returns false
         *
         * See also:
         *
         *    equal, unequal, smaller, smallerEq, largerEq, compare
         *
         * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
         * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
         * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
         */


        var larger = typed('larger', {
          'boolean, boolean': function booleanBoolean(x, y) {
            return x > y;
          },
          'number, number': function numberNumber(x, y) {
            return x > y && !nearlyEqual(x, y, config.epsilon);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.gt(y) && !bigNearlyEqual(x, y, config.epsilon);
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return x.compare(y) === 1;
          },
          'Complex, Complex': function ComplexComplex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
          },
          'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) {
              throw new Error('Cannot compare units with different base');
            }

            return larger(x.value, y.value);
          },
          'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, larger);
          },
          'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, larger, true);
          },
          'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, larger, false);
          },
          'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, larger);
          },
          'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return larger(matrix(x), matrix(y)).valueOf();
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return larger(matrix(x), y);
          },
          'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return larger(x, matrix(y));
          },
          'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, larger, false);
          },
          'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, larger, false);
          },
          'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, larger, true);
          },
          'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, larger, true);
          },
          'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, larger, false).valueOf();
          },
          'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, larger, true).valueOf();
          }
        });
        larger.toTex = {
          2: "\\left(${args[0]}".concat(latex.operators['larger'], "${args[1]}\\right)")
        };
        return larger;
      }

      exports.name = 'larger';
      exports.factory = factory;
      /***/
    },
    /* 232 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // function utils

      /**
       * Memoize a given function by caching the computed result.
       * The cache of a memoized function can be cleared by deleting the `cache`
       * property of the function.
       *
       * @param {function} fn                     The function to be memoized.
       *                                          Must be a pure function.
       * @param {function(args: Array)} [hasher]  A custom hash builder.
       *                                          Is JSON.stringify by default.
       * @return {function}                       Returns the memoized function
       */

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      exports.memoize = function (fn, hasher) {
        return function memoize() {
          if (_typeof(memoize.cache) !== 'object') {
            memoize.cache = {};
          }

          var args = [];

          for (var i = 0; i < arguments.length; i++) {
            args[i] = arguments[i];
          }

          var hash = hasher ? hasher(args) : JSON.stringify(args);

          if (!(hash in memoize.cache)) {
            memoize.cache[hash] = fn.apply(fn, args);
          }

          return memoize.cache[hash];
        };
      };
      /**
       * Find the maximum number of arguments expected by a typed function.
       * @param {function} fn   A typed function
       * @return {number} Returns the maximum number of expected arguments.
       *                  Returns -1 when no signatures where found on the function.
       */


      exports.maxArgumentCount = function (fn) {
        return Object.keys(fn.signatures || {}).reduce(function (args, signature) {
          var count = (signature.match(/,/g) || []).length + 1;
          return Math.max(args, count);
        }, -1);
      };
      /**
       * Call a typed function with the
       * @param {function} fn   A function or typed function
       * @return {number} Returns the maximum number of expected arguments.
       *                  Returns -1 when no signatures where found on the function.
       */


      exports.callWithRightArgumentCount = function (fn, args, argCount) {
        return Object.keys(fn.signatures || {}).reduce(function (args, signature) {
          var count = (signature.match(/,/g) || []).length + 1;
          return Math.max(args, count);
        }, -1);
      };
      /***/

    },
    /* 233 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var util = __webpack_require__(151);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var divideScalar = load(__webpack_require__(302));
        var addScalar = load(__webpack_require__(197));
        var multiply = load(__webpack_require__(124));
        var unaryMinus = load(__webpack_require__(195));
        var det = load(__webpack_require__(403));
        var identity = load(__webpack_require__(193));
        var abs = load(__webpack_require__(194));
        /**
         * Calculate the inverse of a square matrix.
         *
         * Syntax:
         *
         *     math.inv(x)
         *
         * Examples:
         *
         *     math.inv([[1, 2], [3, 4]])  // returns [[-2, 1], [1.5, -0.5]]
         *     math.inv(4)                 // returns 0.25
         *     1 / 4                       // returns 0.25
         *
         * See also:
         *
         *     det, transpose
         *
         * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
         * @return {number | Complex | Array | Matrix} The inverse of `x`.
         */

        var inv = typed('inv', {
          'Array | Matrix': function ArrayMatrix(x) {
            var size = type.isMatrix(x) ? x.size() : util.array.size(x);

            switch (size.length) {
              case 1:
                // vector
                if (size[0] === 1) {
                  if (type.isMatrix(x)) {
                    return matrix([divideScalar(1, x.valueOf()[0])]);
                  } else {
                    return [divideScalar(1, x[0])];
                  }
                } else {
                  throw new RangeError('Matrix must be square ' + '(size: ' + util.string.format(size) + ')');
                }

              case 2:
                // two dimensional array
                var rows = size[0];
                var cols = size[1];

                if (rows === cols) {
                  if (type.isMatrix(x)) {
                    return matrix(_inv(x.valueOf(), rows, cols), x.storage());
                  } else {
                    // return an Array
                    return _inv(x, rows, cols);
                  }
                } else {
                  throw new RangeError('Matrix must be square ' + '(size: ' + util.string.format(size) + ')');
                }

              default:
                // multi dimensional array
                throw new RangeError('Matrix must be two dimensional ' + '(size: ' + util.string.format(size) + ')');
            }
          },
          'any': function any(x) {
            // scalar
            return divideScalar(1, x); // FIXME: create a BigNumber one when configured for bignumbers
          }
        });
        /**
         * Calculate the inverse of a square matrix
         * @param {Array[]} mat     A square matrix
         * @param {number} rows     Number of rows
         * @param {number} cols     Number of columns, must equal rows
         * @return {Array[]} inv    Inverse matrix
         * @private
         */

        function _inv(mat, rows, cols) {
          var r, s, f, value, temp;

          if (rows === 1) {
            // this is a 1 x 1 matrix
            value = mat[0][0];

            if (value === 0) {
              throw Error('Cannot calculate inverse, determinant is zero');
            }

            return [[divideScalar(1, value)]];
          } else if (rows === 2) {
            // this is a 2 x 2 matrix
            var d = det(mat);

            if (d === 0) {
              throw Error('Cannot calculate inverse, determinant is zero');
            }

            return [[divideScalar(mat[1][1], d), divideScalar(unaryMinus(mat[0][1]), d)], [divideScalar(unaryMinus(mat[1][0]), d), divideScalar(mat[0][0], d)]];
          } else {
            // this is a matrix of 3 x 3 or larger
            // calculate inverse using gauss-jordan elimination
            //      https://en.wikipedia.org/wiki/Gaussian_elimination
            //      http://mathworld.wolfram.com/MatrixInverse.html
            //      http://math.uww.edu/~mcfarlat/inverse.htm
            // make a copy of the matrix (only the arrays, not of the elements)
            var A = mat.concat();

            for (r = 0; r < rows; r++) {
              A[r] = A[r].concat();
            } // create an identity matrix which in the end will contain the
            // matrix inverse


            var B = identity(rows).valueOf(); // loop over all columns, and perform row reductions

            for (var c = 0; c < cols; c++) {
              // Pivoting: Swap row c with row r, where row r contains the largest element A[r][c]
              var ABig = abs(A[c][c]);
              var rBig = c;
              r = c + 1;

              while (r < rows) {
                if (abs(A[r][c]) > ABig) {
                  ABig = abs(A[r][c]);
                  rBig = r;
                }

                r++;
              }

              if (ABig === 0) {
                throw Error('Cannot calculate inverse, determinant is zero');
              }

              r = rBig;

              if (r !== c) {
                temp = A[c];
                A[c] = A[r];
                A[r] = temp;
                temp = B[c];
                B[c] = B[r];
                B[r] = temp;
              } // eliminate non-zero values on the other rows at column c


              var Ac = A[c];
              var Bc = B[c];

              for (r = 0; r < rows; r++) {
                var Ar = A[r];
                var Br = B[r];

                if (r !== c) {
                  // eliminate value at column c and row r
                  if (Ar[c] !== 0) {
                    f = divideScalar(unaryMinus(Ar[c]), Ac[c]); // add (f * row c) to row r to eliminate the value
                    // at column c

                    for (s = c; s < cols; s++) {
                      Ar[s] = addScalar(Ar[s], multiply(f, Ac[s]));
                    }

                    for (s = 0; s < cols; s++) {
                      Br[s] = addScalar(Br[s], multiply(f, Bc[s]));
                    }
                  }
                } else {
                  // normalize value at Acc to 1,
                  // divide each value on row r with the value at Acc
                  f = Ac[c];

                  for (s = c; s < cols; s++) {
                    Ar[s] = divideScalar(Ar[s], f);
                  }

                  for (s = 0; s < cols; s++) {
                    Br[s] = divideScalar(Br[s], f);
                  }
                }
              }
            }

            return B;
          }
        }

        inv.toTex = {
          1: "\\left(${args[0]}\\right)^{-1}"
        };
        return inv;
      }

      exports.name = 'inv';
      exports.factory = factory;
      /***/
    },
    /* 234 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var equalScalar = load(__webpack_require__(125));
        var SparseMatrix = type.SparseMatrix;
        /**
         * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
         * Callback function invoked NZ times (number of nonzero items in S).
         *
         *
         *          ┌  f(Sij, b)  ; S(i,j) !== 0
         * C(i,j) = ┤
         *          └  0          ; otherwise
         *
         *
         * @param {Matrix}   s                 The SparseMatrix instance (S)
         * @param {Scalar}   b                 The Scalar value
         * @param {Function} callback          The f(Aij,b) operation to invoke
         * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
         *
         * @return {Matrix}                    SparseMatrix (C)
         *
         * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
         */

        var algorithm11 = function algorithm11(s, b, callback, inverse) {
          // sparse matrix arrays
          var avalues = s._values;
          var aindex = s._index;
          var aptr = s._ptr;
          var asize = s._size;
          var adt = s._datatype; // sparse matrix cannot be a Pattern matrix

          if (!avalues) {
            throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
          } // rows & columns


          var rows = asize[0];
          var columns = asize[1]; // datatype

          var dt; // equal signature to use

          var eq = equalScalar; // zero value

          var zero = 0; // callback signature to use

          var cf = callback; // process data types

          if (typeof adt === 'string') {
            // datatype
            dt = adt; // find signature that matches (dt, dt)

            eq = typed.find(equalScalar, [dt, dt]); // convert 0 to the same datatype

            zero = typed.convert(0, dt); // convert b to the same datatype

            b = typed.convert(b, dt); // callback

            cf = typed.find(callback, [dt, dt]);
          } // result arrays


          var cvalues = [];
          var cindex = [];
          var cptr = []; // matrix

          var c = new SparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [rows, columns],
            datatype: dt
          }); // loop columns

          for (var j = 0; j < columns; j++) {
            // initialize ptr
            cptr[j] = cindex.length; // values in j

            for (var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
              // row
              var i = aindex[k]; // invoke callback

              var v = inverse ? cf(b, avalues[k]) : cf(avalues[k], b); // check value is zero

              if (!eq(v, zero)) {
                // push index & value
                cindex.push(i);
                cvalues.push(v);
              }
            }
          } // update ptr


          cptr[columns] = cindex.length; // return sparse matrix

          return c;
        };

        return algorithm11;
      }

      exports.name = 'algorithm11';
      exports.factory = factory;
      /***/
    },
    /* 235 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports["default"] = interopDefault; // https://github.com/moment/moment/issues/3650

      function interopDefault(m) {
        return m["default"] || m;
      }

      module.exports = exports["default"];
      /***/
    },
    /* 236 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      /**
       * @ignore
       * some key-codes definition and utils from closure-library
       * @author yiminghe@gmail.com
       */

      var KeyCode = {
        /**
         * MAC_ENTER
         */
        MAC_ENTER: 3,

        /**
         * BACKSPACE
         */
        BACKSPACE: 8,

        /**
         * TAB
         */
        TAB: 9,

        /**
         * NUMLOCK on FF/Safari Mac
         */
        NUM_CENTER: 12,
        // NUMLOCK on FF/Safari Mac

        /**
         * ENTER
         */
        ENTER: 13,

        /**
         * SHIFT
         */
        SHIFT: 16,

        /**
         * CTRL
         */
        CTRL: 17,

        /**
         * ALT
         */
        ALT: 18,

        /**
         * PAUSE
         */
        PAUSE: 19,

        /**
         * CAPS_LOCK
         */
        CAPS_LOCK: 20,

        /**
         * ESC
         */
        ESC: 27,

        /**
         * SPACE
         */
        SPACE: 32,

        /**
         * PAGE_UP
         */
        PAGE_UP: 33,
        // also NUM_NORTH_EAST

        /**
         * PAGE_DOWN
         */
        PAGE_DOWN: 34,
        // also NUM_SOUTH_EAST

        /**
         * END
         */
        END: 35,
        // also NUM_SOUTH_WEST

        /**
         * HOME
         */
        HOME: 36,
        // also NUM_NORTH_WEST

        /**
         * LEFT
         */
        LEFT: 37,
        // also NUM_WEST

        /**
         * UP
         */
        UP: 38,
        // also NUM_NORTH

        /**
         * RIGHT
         */
        RIGHT: 39,
        // also NUM_EAST

        /**
         * DOWN
         */
        DOWN: 40,
        // also NUM_SOUTH

        /**
         * PRINT_SCREEN
         */
        PRINT_SCREEN: 44,

        /**
         * INSERT
         */
        INSERT: 45,
        // also NUM_INSERT

        /**
         * DELETE
         */
        DELETE: 46,
        // also NUM_DELETE

        /**
         * ZERO
         */
        ZERO: 48,

        /**
         * ONE
         */
        ONE: 49,

        /**
         * TWO
         */
        TWO: 50,

        /**
         * THREE
         */
        THREE: 51,

        /**
         * FOUR
         */
        FOUR: 52,

        /**
         * FIVE
         */
        FIVE: 53,

        /**
         * SIX
         */
        SIX: 54,

        /**
         * SEVEN
         */
        SEVEN: 55,

        /**
         * EIGHT
         */
        EIGHT: 56,

        /**
         * NINE
         */
        NINE: 57,

        /**
         * QUESTION_MARK
         */
        QUESTION_MARK: 63,
        // needs localization

        /**
         * A
         */
        A: 65,

        /**
         * B
         */
        B: 66,

        /**
         * C
         */
        C: 67,

        /**
         * D
         */
        D: 68,

        /**
         * E
         */
        E: 69,

        /**
         * F
         */
        F: 70,

        /**
         * G
         */
        G: 71,

        /**
         * H
         */
        H: 72,

        /**
         * I
         */
        I: 73,

        /**
         * J
         */
        J: 74,

        /**
         * K
         */
        K: 75,

        /**
         * L
         */
        L: 76,

        /**
         * M
         */
        M: 77,

        /**
         * N
         */
        N: 78,

        /**
         * O
         */
        O: 79,

        /**
         * P
         */
        P: 80,

        /**
         * Q
         */
        Q: 81,

        /**
         * R
         */
        R: 82,

        /**
         * S
         */
        S: 83,

        /**
         * T
         */
        T: 84,

        /**
         * U
         */
        U: 85,

        /**
         * V
         */
        V: 86,

        /**
         * W
         */
        W: 87,

        /**
         * X
         */
        X: 88,

        /**
         * Y
         */
        Y: 89,

        /**
         * Z
         */
        Z: 90,

        /**
         * META
         */
        META: 91,
        // WIN_KEY_LEFT

        /**
         * WIN_KEY_RIGHT
         */
        WIN_KEY_RIGHT: 92,

        /**
         * CONTEXT_MENU
         */
        CONTEXT_MENU: 93,

        /**
         * NUM_ZERO
         */
        NUM_ZERO: 96,

        /**
         * NUM_ONE
         */
        NUM_ONE: 97,

        /**
         * NUM_TWO
         */
        NUM_TWO: 98,

        /**
         * NUM_THREE
         */
        NUM_THREE: 99,

        /**
         * NUM_FOUR
         */
        NUM_FOUR: 100,

        /**
         * NUM_FIVE
         */
        NUM_FIVE: 101,

        /**
         * NUM_SIX
         */
        NUM_SIX: 102,

        /**
         * NUM_SEVEN
         */
        NUM_SEVEN: 103,

        /**
         * NUM_EIGHT
         */
        NUM_EIGHT: 104,

        /**
         * NUM_NINE
         */
        NUM_NINE: 105,

        /**
         * NUM_MULTIPLY
         */
        NUM_MULTIPLY: 106,

        /**
         * NUM_PLUS
         */
        NUM_PLUS: 107,

        /**
         * NUM_MINUS
         */
        NUM_MINUS: 109,

        /**
         * NUM_PERIOD
         */
        NUM_PERIOD: 110,

        /**
         * NUM_DIVISION
         */
        NUM_DIVISION: 111,

        /**
         * F1
         */
        F1: 112,

        /**
         * F2
         */
        F2: 113,

        /**
         * F3
         */
        F3: 114,

        /**
         * F4
         */
        F4: 115,

        /**
         * F5
         */
        F5: 116,

        /**
         * F6
         */
        F6: 117,

        /**
         * F7
         */
        F7: 118,

        /**
         * F8
         */
        F8: 119,

        /**
         * F9
         */
        F9: 120,

        /**
         * F10
         */
        F10: 121,

        /**
         * F11
         */
        F11: 122,

        /**
         * F12
         */
        F12: 123,

        /**
         * NUMLOCK
         */
        NUMLOCK: 144,

        /**
         * SEMICOLON
         */
        SEMICOLON: 186,
        // needs localization

        /**
         * DASH
         */
        DASH: 189,
        // needs localization

        /**
         * EQUALS
         */
        EQUALS: 187,
        // needs localization

        /**
         * COMMA
         */
        COMMA: 188,
        // needs localization

        /**
         * PERIOD
         */
        PERIOD: 190,
        // needs localization

        /**
         * SLASH
         */
        SLASH: 191,
        // needs localization

        /**
         * APOSTROPHE
         */
        APOSTROPHE: 192,
        // needs localization

        /**
         * SINGLE_QUOTE
         */
        SINGLE_QUOTE: 222,
        // needs localization

        /**
         * OPEN_SQUARE_BRACKET
         */
        OPEN_SQUARE_BRACKET: 219,
        // needs localization

        /**
         * BACKSLASH
         */
        BACKSLASH: 220,
        // needs localization

        /**
         * CLOSE_SQUARE_BRACKET
         */
        CLOSE_SQUARE_BRACKET: 221,
        // needs localization

        /**
         * WIN_KEY
         */
        WIN_KEY: 224,

        /**
         * MAC_FF_META
         */
        MAC_FF_META: 224,
        // Firefox (Gecko) fires this for the meta key instead of 91

        /**
         * WIN_IME
         */
        WIN_IME: 229
      };
      /*
       whether text and modified key is entered at the same time.
       */

      KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;

        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
          return false;
        } // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.


        switch (keyCode) {
          case KeyCode.ALT:
          case KeyCode.CAPS_LOCK:
          case KeyCode.CONTEXT_MENU:
          case KeyCode.CTRL:
          case KeyCode.DOWN:
          case KeyCode.END:
          case KeyCode.ESC:
          case KeyCode.HOME:
          case KeyCode.INSERT:
          case KeyCode.LEFT:
          case KeyCode.MAC_FF_META:
          case KeyCode.META:
          case KeyCode.NUMLOCK:
          case KeyCode.NUM_CENTER:
          case KeyCode.PAGE_DOWN:
          case KeyCode.PAGE_UP:
          case KeyCode.PAUSE:
          case KeyCode.PRINT_SCREEN:
          case KeyCode.RIGHT:
          case KeyCode.SHIFT:
          case KeyCode.UP:
          case KeyCode.WIN_KEY:
          case KeyCode.WIN_KEY_RIGHT:
            return false;

          default:
            return true;
        }
      };
      /*
       whether character is entered.
       */


      KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
        if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
          return true;
        }

        if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
          return true;
        }

        if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
          return true;
        } // Safari sends zero key code for non-latin characters.


        if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
          return true;
        }

        switch (keyCode) {
          case KeyCode.SPACE:
          case KeyCode.QUESTION_MARK:
          case KeyCode.NUM_PLUS:
          case KeyCode.NUM_MINUS:
          case KeyCode.NUM_PERIOD:
          case KeyCode.NUM_DIVISION:
          case KeyCode.SEMICOLON:
          case KeyCode.DASH:
          case KeyCode.EQUALS:
          case KeyCode.COMMA:
          case KeyCode.PERIOD:
          case KeyCode.SLASH:
          case KeyCode.APOSTROPHE:
          case KeyCode.SINGLE_QUOTE:
          case KeyCode.OPEN_SQUARE_BRACKET:
          case KeyCode.BACKSLASH:
          case KeyCode.CLOSE_SQUARE_BRACKET:
            return true;

          default:
            return false;
        }
      };

      exports['default'] = KeyCode;
      module.exports = exports['default'];
      /***/
    },
    /* 237 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _utils = __webpack_require__(200);

      var _utils2 = _interopRequireDefault(_utils);

      var _animateScroll = __webpack_require__(439);

      var _animateScroll2 = _interopRequireDefault(_animateScroll);

      var _scrollEvents = __webpack_require__(314);

      var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var __mapped = {};

      var __activeLink = void 0;

      exports.default = {
        unmount: function unmount() {
          __mapped = {};
        },
        register: function register(name, element) {
          __mapped[name] = element;
        },
        unregister: function unregister(name) {
          delete __mapped[name];
        },
        get: function get(name) {
          return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
        },
        setActiveLink: function setActiveLink(link) {
          return __activeLink = link;
        },
        getActiveLink: function getActiveLink() {
          return __activeLink;
        },
        scrollTo: function scrollTo(to, props) {
          var target = this.get(to);

          if (!target) {
            console.warn("target Element not found");
            return;
          }

          props = _extends({}, props, {
            absolute: false
          });
          var containerId = props.containerId;
          var container = props.container;
          var containerElement = void 0;

          if (containerId) {
            containerElement = document.getElementById(containerId);
          } else if (container && container.nodeType) {
            containerElement = container;
          } else {
            containerElement = document;
          }

          if (_scrollEvents2.default.registered.begin) {
            _scrollEvents2.default.registered.begin(to, target);
          }

          props.absolute = true;
          var scrollOffset = _utils2.default.scrollOffset(containerElement, target) + (props.offset || 0);
          /*
           * if animate is not provided just scroll into the view
           */

          if (!props.smooth) {
            if (containerElement === document) {
              window.scrollTo(0, scrollOffset);
            } else {
              containerElement.scrollTop = scrollOffset;
            }

            if (_scrollEvents2.default.registered['end']) {
              _scrollEvents2.default.registered['end'](to, target);
            }

            return;
          }
          /*
           * Animate scrolling
           */


          _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
        }
      };
      /***/
    },
    /* 238 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _en_US = __webpack_require__(917);

      var _en_US2 = _interopRequireDefault(_en_US);

      var _en_US3 = __webpack_require__(325);

      var _en_US4 = _interopRequireDefault(_en_US3);

      var _en_US5 = __webpack_require__(324);

      var _en_US6 = _interopRequireDefault(_en_US5);

      var _en_US7 = __webpack_require__(916);

      var _en_US8 = _interopRequireDefault(_en_US7);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      exports['default'] = {
        locale: 'en',
        Pagination: _en_US2['default'],
        DatePicker: _en_US4['default'],
        TimePicker: _en_US6['default'],
        Calendar: _en_US8['default'],
        Table: {
          filterTitle: 'Filter menu',
          filterConfirm: 'OK',
          filterReset: 'Reset',
          emptyText: 'No data',
          selectAll: 'Select current page',
          selectInvert: 'Invert current page'
        },
        Modal: {
          okText: 'OK',
          cancelText: 'Cancel',
          justOkText: 'OK'
        },
        Popconfirm: {
          okText: 'OK',
          cancelText: 'Cancel'
        },
        Transfer: {
          titles: ['', ''],
          notFoundContent: 'Not Found',
          searchPlaceholder: 'Search here',
          itemUnit: 'item',
          itemsUnit: 'items'
        },
        Select: {
          notFoundContent: 'Not Found'
        },
        Upload: {
          uploading: 'Uploading...',
          removeFile: 'Remove file',
          uploadError: 'Upload error',
          previewFile: 'Preview file'
        }
      };
      module.exports = exports['default'];
      /***/
    },
    /* 239 */

    /***/
    function (module, exports) {
      /**
       * Appends the elements of `values` to `array`.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {Array} values The values to append.
       * @returns {Array} Returns `array`.
       */
      function arrayPush(array, values) {
        var index = -1,
            length = values.length,
            offset = array.length;

        while (++index < length) {
          array[offset + index] = values[index];
        }

        return array;
      }

      module.exports = arrayPush;
      /***/
    },
    /* 240 */

    /***/
    function (module, exports) {
      /**
       * Converts `set` to an array of its values.
       *
       * @private
       * @param {Object} set The set to convert.
       * @returns {Array} Returns the values.
       */
      function setToArray(set) {
        var index = -1,
            result = Array(set.size);
        set.forEach(function (value) {
          result[++index] = value;
        });
        return result;
      }

      module.exports = setToArray;
      /***/
    },
    /* 241 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var _assign = __webpack_require__(82);

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEntity
       * @format
       * 
       */


      var DraftEntityInstance = __webpack_require__(479);

      var Immutable = __webpack_require__(53);

      var invariant = __webpack_require__(51);

      var Map = Immutable.Map;
      var instances = Map();
      var instanceKey = 0;
      /**
       * Temporary utility for generating the warnings
       */

      function logWarning(oldMethodCall, newMethodCall) {
        console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
      }
      /**
       * A "document entity" is an object containing metadata associated with a
       * piece of text in a ContentBlock.
       *
       * For example, a `link` entity might include a `uri` property. When a
       * ContentBlock is rendered in the browser, text that refers to that link
       * entity may be rendered as an anchor, with the `uri` as the href value.
       *
       * In a ContentBlock, every position in the text may correspond to zero
       * or one entities. This correspondence is tracked using a key string,
       * generated via DraftEntity.create() and used to obtain entity metadata
       * via DraftEntity.get().
       */


      var DraftEntity = {
        /**
         * WARNING: This method will be deprecated soon!
         * Please use 'contentState.getLastCreatedEntityKey' instead.
         * ---
         * Get the random key string from whatever entity was last created.
         * We need this to support the new API, as part of transitioning to put Entity
         * storage in contentState.
         */
        getLastCreatedEntityKey: function getLastCreatedEntityKey() {
          logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
          return DraftEntity.__getLastCreatedEntityKey();
        },

        /**
         * WARNING: This method will be deprecated soon!
         * Please use 'contentState.createEntity' instead.
         * ---
         * Create a DraftEntityInstance and store it for later retrieval.
         *
         * A random key string will be generated and returned. This key may
         * be used to track the entity's usage in a ContentBlock, and for
         * retrieving data about the entity at render time.
         */
        create: function create(type, mutability, data) {
          logWarning('DraftEntity.create', 'contentState.createEntity');
          return DraftEntity.__create(type, mutability, data);
        },

        /**
         * WARNING: This method will be deprecated soon!
         * Please use 'contentState.addEntity' instead.
         * ---
         * Add an existing DraftEntityInstance to the DraftEntity map. This is
         * useful when restoring instances from the server.
         */
        add: function add(instance) {
          logWarning('DraftEntity.add', 'contentState.addEntity');
          return DraftEntity.__add(instance);
        },

        /**
         * WARNING: This method will be deprecated soon!
         * Please use 'contentState.getEntity' instead.
         * ---
         * Retrieve the entity corresponding to the supplied key string.
         */
        get: function get(key) {
          logWarning('DraftEntity.get', 'contentState.getEntity');
          return DraftEntity.__get(key);
        },

        /**
         * WARNING: This method will be deprecated soon!
         * Please use 'contentState.mergeEntityData' instead.
         * ---
         * Entity instances are immutable. If you need to update the data for an
         * instance, this method will merge your data updates and return a new
         * instance.
         */
        mergeData: function mergeData(key, toMerge) {
          logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
          return DraftEntity.__mergeData(key, toMerge);
        },

        /**
         * WARNING: This method will be deprecated soon!
         * Please use 'contentState.replaceEntityData' instead.
         * ---
         * Completely replace the data for a given instance.
         */
        replaceData: function replaceData(key, newData) {
          logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
          return DraftEntity.__replaceData(key, newData);
        },
        // ***********************************WARNING******************************
        // --- the above public API will be deprecated in the next version of Draft!
        // The methods below this line are private - don't call them directly.

        /**
         * Get the random key string from whatever entity was last created.
         * We need this to support the new API, as part of transitioning to put Entity
         * storage in contentState.
         */
        __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
          return '' + instanceKey;
        },

        /**
         * Create a DraftEntityInstance and store it for later retrieval.
         *
         * A random key string will be generated and returned. This key may
         * be used to track the entity's usage in a ContentBlock, and for
         * retrieving data about the entity at render time.
         */
        __create: function __create(type, mutability, data) {
          return DraftEntity.__add(new DraftEntityInstance({
            type: type,
            mutability: mutability,
            data: data || {}
          }));
        },

        /**
         * Add an existing DraftEntityInstance to the DraftEntity map. This is
         * useful when restoring instances from the server.
         */
        __add: function __add(instance) {
          var key = '' + ++instanceKey;
          instances = instances.set(key, instance);
          return key;
        },

        /**
         * Retrieve the entity corresponding to the supplied key string.
         */
        __get: function __get(key) {
          var instance = instances.get(key);
          !!!instance ? false ? undefined : invariant(false) : void 0;
          return instance;
        },

        /**
         * Entity instances are immutable. If you need to update the data for an
         * instance, this method will merge your data updates and return a new
         * instance.
         */
        __mergeData: function __mergeData(key, toMerge) {
          var instance = DraftEntity.__get(key);

          var newData = _extends({}, instance.getData(), toMerge);

          var newInstance = instance.set('data', newData);
          instances = instances.set(key, newInstance);
          return newInstance;
        },

        /**
         * Completely replace the data for a given instance.
         */
        __replaceData: function __replaceData(key, newData) {
          var instance = DraftEntity.__get(key);

          var newInstance = instance.set('data', newData);
          instances = instances.set(key, newInstance);
          return newInstance;
        }
      };
      module.exports = DraftEntity;
      /***/
    },
    /* 242 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getContentStateFragment
       * @format
       * 
       */

      var randomizeBlockMapKeys = __webpack_require__(484);

      var removeEntitiesAtEdges = __webpack_require__(483);

      var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
        var startKey = selectionState.getStartKey();
        var startOffset = selectionState.getStartOffset();
        var endKey = selectionState.getEndKey();
        var endOffset = selectionState.getEndOffset(); // Edge entities should be stripped to ensure that we don't preserve
        // invalid partial entities when the fragment is reused. We do, however,
        // preserve entities that are entirely within the selection range.

        var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
        var blockMap = contentWithoutEdgeEntities.getBlockMap();
        var blockKeys = blockMap.keySeq();
        var startIndex = blockKeys.indexOf(startKey);
        var endIndex = blockKeys.indexOf(endKey) + 1;
        return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
          var text = block.getText();
          var chars = block.getCharacterList();

          if (startKey === endKey) {
            return block.merge({
              text: text.slice(startOffset, endOffset),
              characterList: chars.slice(startOffset, endOffset)
            });
          }

          if (blockKey === startKey) {
            return block.merge({
              text: text.slice(startOffset),
              characterList: chars.slice(startOffset)
            });
          }

          if (blockKey === endKey) {
            return block.merge({
              text: text.slice(0, endOffset),
              characterList: chars.slice(0, endOffset)
            });
          }

          return block;
        }));
      };

      module.exports = getContentStateFragment;
      /***/
    },
    /* 243 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayLikeKeys = __webpack_require__(493),
          baseKeysIn = __webpack_require__(1046),
          isArrayLike = __webpack_require__(134);
      /**
       * Creates an array of the own and inherited enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keysIn(new Foo);
       * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
       */


      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }

      module.exports = keysIn;
      /***/
    },
    /* 244 */

    /***/
    function (module, exports) {
      /**
       * The base implementation of `_.unary` without support for storing metadata.
       *
       * @private
       * @param {Function} func The function to cap arguments for.
       * @returns {Function} Returns the new capped function.
       */
      function baseUnary(func) {
        return function (value) {
          return func(value);
        };
      }

      module.exports = baseUnary;
      /***/
    },
    /* 245 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIsTypedArray = __webpack_require__(1048),
          baseUnary = __webpack_require__(244),
          nodeUtil = __webpack_require__(346);
      /* Node.js helper references. */


      var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      /**
       * Checks if `value` is classified as a typed array.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       * @example
       *
       * _.isTypedArray(new Uint8Array);
       * // => true
       *
       * _.isTypedArray([]);
       * // => false
       */

      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      module.exports = isTypedArray;
      /***/
    },
    /* 246 */

    /***/
    function (module, exports) {
      /**
       * Copies the values of `source` to `array`.
       *
       * @private
       * @param {Array} source The array to copy values from.
       * @param {Array} [array=[]] The array to copy values to.
       * @returns {Array} Returns `array`.
       */
      function copyArray(source, array) {
        var index = -1,
            length = source.length;
        array || (array = Array(length));

        while (++index < length) {
          array[index] = source[index];
        }

        return array;
      }

      module.exports = copyArray;
      /***/
    },
    /* 247 */

    /***/
    function (module, exports, __webpack_require__) {
      var ListCache = __webpack_require__(253),
          stackClear = __webpack_require__(1057),
          stackDelete = __webpack_require__(1056),
          stackGet = __webpack_require__(1055),
          stackHas = __webpack_require__(1054),
          stackSet = __webpack_require__(1053);
      /**
       * Creates a stack cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */


      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      } // Add methods to `Stack`.


      Stack.prototype.clear = stackClear;
      Stack.prototype['delete'] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      module.exports = Stack;
      /***/
    },
    /* 248 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseAssignValue = __webpack_require__(210),
          eq = __webpack_require__(163);
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Assigns `value` to `key` of `object` if the existing value is not equivalent
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */

      function assignValue(object, key, value) {
        var objValue = object[key];

        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }

      module.exports = assignValue;
      /***/
    },
    /* 249 */

    /***/
    function (module, exports, __webpack_require__) {
      var castPath = __webpack_require__(177),
          toKey = __webpack_require__(175);
      /**
       * The base implementation of `_.get` without support for default values.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to get.
       * @returns {*} Returns the resolved value.
       */


      function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0,
            length = path.length;

        while (object != null && index < length) {
          object = object[toKey(path[index++])];
        }

        return index && index == length ? object : undefined;
      }

      module.exports = baseGet;
      /***/
    },
    /* 250 */

    /***/
    function (module, exports) {
      /** Used as references for various `Number` constants. */
      var MAX_SAFE_INTEGER = 9007199254740991;
      /** Used to detect unsigned integer values. */

      var reIsUint = /^(?:0|[1-9]\d*)$/;
      /**
       * Checks if `value` is a valid array-like index.
       *
       * @private
       * @param {*} value The value to check.
       * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
       * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
       */

      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
      }

      module.exports = isIndex;
      /***/
    },
    /* 251 */

    /***/
    function (module, exports, __webpack_require__) {
      var isKeyable = __webpack_require__(1071);
      /**
       * Gets the data for `map`.
       *
       * @private
       * @param {Object} map The map to query.
       * @param {string} key The reference key.
       * @returns {*} Returns the map data.
       */


      function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
      }

      module.exports = getMapData;
      /***/
    },
    /* 252 */

    /***/
    function (module, exports, __webpack_require__) {
      var eq = __webpack_require__(163);
      /**
       * Gets the index at which the `key` is found in `array` of key-value pairs.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} key The key to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */


      function assocIndexOf(array, key) {
        var length = array.length;

        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }

        return -1;
      }

      module.exports = assocIndexOf;
      /***/
    },
    /* 253 */

    /***/
    function (module, exports, __webpack_require__) {
      var listCacheClear = __webpack_require__(1077),
          listCacheDelete = __webpack_require__(1076),
          listCacheGet = __webpack_require__(1075),
          listCacheHas = __webpack_require__(1074),
          listCacheSet = __webpack_require__(1073);
      /**
       * Creates an list cache object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */


      function ListCache(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;
        this.clear();

        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      } // Add methods to `ListCache`.


      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype['delete'] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      module.exports = ListCache;
      /***/
    },
    /* 254 */

    /***/
    function (module, exports, __webpack_require__) {
      var getNative = __webpack_require__(157);
      /* Built-in method references that are verified to be native. */


      var nativeCreate = getNative(Object, 'create');
      module.exports = nativeCreate;
      /***/
    },
    /* 255 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGetTag = __webpack_require__(135),
          isObjectLike = __webpack_require__(109);
      /** `Object#toString` result references. */


      var symbolTag = '[object Symbol]';
      /**
       * Checks if `value` is classified as a `Symbol` primitive or object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
       * @example
       *
       * _.isSymbol(Symbol.iterator);
       * // => true
       *
       * _.isSymbol('abc');
       * // => false
       */

      function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }

      module.exports = isSymbol;
      /***/
    },
    /* 256 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var $at = __webpack_require__(1161)(true); // 21.1.3.27 String.prototype[@@iterator]()


      __webpack_require__(649)(String, 'String', function (iterated) {
        this._t = String(iterated); // target

        this._i = 0; // next index
        // 21.1.5.2.1 %StringIteratorPrototype%.next()
      }, function () {
        var O = this._t;
        var index = this._i;
        var point;
        if (index >= O.length) return {
          value: undefined,
          done: true
        };
        point = $at(O, index);
        this._i += point.length;
        return {
          value: point,
          done: false
        };
      });
      /***/

    },
    /* 257 */

    /***/
    function (module, exports) {
      exports.f = {}.propertyIsEnumerable;
      /***/
    },
    /* 258 */

    /***/
    function (module, exports) {
      var id = 0;
      var px = Math.random();

      module.exports = function (key) {
        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
      };
      /***/

    },
    /* 259 */

    /***/
    function (module, exports) {
      module.exports = true;
      /***/
    },
    /* 260 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.14 / 15.2.3.14 Object.keys(O)
      var $keys = __webpack_require__(652);

      var enumBugKeys = __webpack_require__(362);

      module.exports = Object.keys || function keys(O) {
        return $keys(O, enumBugKeys);
      };
      /***/

    },
    /* 261 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      if (true) {
        module.exports = __webpack_require__(1066);
      } else {}
      /***/

    },
    /* 262 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js


      var createClass = __webpack_require__(12);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js


      var defineProperty = __webpack_require__(6);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // CONCATENATED MODULE: ./node_modules/rc-upload/es/request.js


      function getError(option, xhr) {
        var msg = 'cannot post ' + option.action + ' ' + xhr.status + '\'';
        var err = new Error(msg);
        err.status = xhr.status;
        err.method = 'post';
        err.url = option.action;
        return err;
      }

      function getBody(xhr) {
        var text = xhr.responseText || xhr.response;

        if (!text) {
          return text;
        }

        try {
          return JSON.parse(text);
        } catch (e) {
          return text;
        }
      } // option {
      //  onProgress: (event: { percent: number }): void,
      //  onError: (event: Error, body?: Object): void,
      //  onSuccess: (body: Object): void,
      //  data: Object,
      //  filename: String,
      //  file: File,
      //  withCredentials: Boolean,
      //  action: String,
      //  headers: Object,
      // }


      function upload(option) {
        var xhr = new XMLHttpRequest();

        if (option.onProgress && xhr.upload) {
          xhr.upload.onprogress = function progress(e) {
            if (e.total > 0) {
              e.percent = e.loaded / e.total * 100;
            }

            option.onProgress(e);
          };
        }

        var formData = new FormData();

        if (option.data) {
          Object.keys(option.data).map(function (key) {
            formData.append(key, option.data[key]);
          });
        }

        formData.append(option.filename, option.file);

        xhr.onerror = function error(e) {
          option.onError(e);
        };

        xhr.onload = function onload() {
          // allow success when 2xx status
          // see https://github.com/react-component/upload/issues/34
          if (xhr.status < 200 || xhr.status >= 300) {
            return option.onError(getError(option, xhr), getBody(xhr));
          }

          option.onSuccess(getBody(xhr), xhr);
        };

        xhr.open('post', option.action, true); // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179

        if (option.withCredentials && 'withCredentials' in xhr) {
          xhr.withCredentials = true;
        }

        var headers = option.headers || {}; // when set headers['X-Requested-With'] = null , can close default XHR header
        // see https://github.com/react-component/upload/issues/33

        if (headers['X-Requested-With'] !== null) {
          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        }

        for (var h in headers) {
          if (headers.hasOwnProperty(h) && headers[h] !== null) {
            xhr.setRequestHeader(h, headers[h]);
          }
        }

        xhr.send(formData);
        return {
          abort: function abort() {
            xhr.abort();
          }
        };
      } // CONCATENATED MODULE: ./node_modules/rc-upload/es/uid.js


      var now = +new Date();
      var index = 0;

      function uid_uid() {
        return "rc-upload-" + now + "-" + ++index;
      } // CONCATENATED MODULE: ./node_modules/rc-upload/es/attr-accept.js


      function endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
      }
      /* harmony default export */


      var attr_accept = function attr_accept(file, acceptedFiles) {
        if (file && acceptedFiles) {
          var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
          var fileName = file.name || '';
          var mimeType = file.type || '';
          var baseMimeType = mimeType.replace(/\/.*$/, '');
          return acceptedFilesArray.some(function (type) {
            var validType = type.trim();

            if (validType.charAt(0) === '.') {
              return endsWith(fileName.toLowerCase(), validType.toLowerCase());
            } else if (/\/\*$/.test(validType)) {
              // This is something like a image/* mime type
              return baseMimeType === validType.replace(/\/.*$/, '');
            }

            return mimeType === validType;
          });
        }

        return true;
      }; // CONCATENATED MODULE: ./node_modules/rc-upload/es/AjaxUploader.js

      /* eslint react/no-is-mounted:0 react/sort-comp:0 */


      var AjaxUploader_AjaxUploader = function (_Component) {
        inherits_default()(AjaxUploader, _Component);

        function AjaxUploader() {
          var _ref;

          var _temp, _this, _ret;

          classCallCheck_default()(this, AjaxUploader);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = AjaxUploader.__proto__ || Object.getPrototypeOf(AjaxUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            uid: uid_uid()
          }, _this.reqs = {}, _this.onChange = function (e) {
            var files = e.target.files;

            _this.uploadFiles(files);

            _this.reset();
          }, _this.onClick = function () {
            var el = _this.fileInput;

            if (!el) {
              return;
            }

            el.click();
          }, _this.onKeyDown = function (e) {
            if (e.key === 'Enter') {
              _this.onClick();
            }
          }, _this.onFileDrop = function (e) {
            if (e.type === 'dragover') {
              e.preventDefault();
              return;
            }

            var files = Array.prototype.slice.call(e.dataTransfer.files).filter(function (file) {
              return attr_accept(file, _this.props.accept);
            });

            _this.uploadFiles(files);

            e.preventDefault();
          }, _this.saveFileInput = function (node) {
            _this.fileInput = node;
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        createClass_default()(AjaxUploader, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this._isMounted = true;
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this._isMounted = false;
            this.abort();
          }
        }, {
          key: 'uploadFiles',
          value: function uploadFiles(files) {
            var _this2 = this;

            var postFiles = Array.prototype.slice.call(files);
            postFiles.forEach(function (file) {
              file.uid = uid_uid();

              _this2.upload(file, postFiles);
            });
          }
        }, {
          key: 'upload',
          value: function upload(file, fileList) {
            var _this3 = this;

            var props = this.props;

            if (!props.beforeUpload) {
              // always async in case use react state to keep fileList
              return setTimeout(function () {
                return _this3.post(file);
              }, 0);
            }

            var before = props.beforeUpload(file, fileList);

            if (before && before.then) {
              before.then(function (processedFile) {
                var processedFileType = Object.prototype.toString.call(processedFile);

                if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
                  _this3.post(processedFile);
                } else {
                  _this3.post(file);
                }
              })['catch'](function (e) {
                console && console.log(e); // eslint-disable-line
              });
            } else if (before !== false) {
              setTimeout(function () {
                return _this3.post(file);
              }, 0);
            }
          }
        }, {
          key: 'post',
          value: function post(file) {
            var _this4 = this;

            if (!this._isMounted) {
              return;
            }

            var props = this.props;
            var data = props.data;
            var onStart = props.onStart,
                onProgress = props.onProgress;

            if (typeof data === 'function') {
              data = data(file);
            }

            var uid = file.uid;
            var request = props.customRequest || upload;
            this.reqs[uid] = request({
              action: props.action,
              filename: props.name,
              file: file,
              data: data,
              headers: props.headers,
              withCredentials: props.withCredentials,
              onProgress: onProgress ? function (e) {
                onProgress(e, file);
              } : null,
              onSuccess: function onSuccess(ret, xhr) {
                delete _this4.reqs[uid];
                props.onSuccess(ret, file, xhr);
              },
              onError: function onError(err, ret) {
                delete _this4.reqs[uid];
                props.onError(err, ret, file);
              }
            });
            onStart(file);
          }
        }, {
          key: 'reset',
          value: function reset() {
            this.setState({
              uid: uid_uid()
            });
          }
        }, {
          key: 'abort',
          value: function abort(file) {
            var reqs = this.reqs;

            if (file) {
              var uid = file;

              if (file && file.uid) {
                uid = file.uid;
              }

              if (reqs[uid]) {
                reqs[uid].abort();
                delete reqs[uid];
              }
            } else {
              Object.keys(reqs).forEach(function (uid) {
                if (reqs[uid]) {
                  reqs[uid].abort();
                }

                delete reqs[uid];
              });
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                Tag = _props.component,
                prefixCls = _props.prefixCls,
                className = _props.className,
                disabled = _props.disabled,
                style = _props.style,
                multiple = _props.multiple,
                accept = _props.accept,
                children = _props.children;
            var cls = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls, true), defineProperty_default()(_classNames, prefixCls + '-disabled', disabled), defineProperty_default()(_classNames, className, className), _classNames));
            var events = disabled ? {} : {
              onClick: this.onClick,
              onKeyDown: this.onKeyDown,
              onDrop: this.onFileDrop,
              onDragOver: this.onFileDrop,
              tabIndex: '0'
            };
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Tag, extends_default()({}, events, {
              className: cls,
              role: 'button',
              style: style
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('input', {
              type: 'file',
              ref: this.saveFileInput,
              key: this.state.uid,
              style: {
                display: 'none'
              },
              accept: accept,
              multiple: multiple,
              onChange: this.onChange
            }), children);
          }
        }]);
        return AjaxUploader;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      AjaxUploader_AjaxUploader.propTypes = {
        component: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        accept: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        onStart: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        headers: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        beforeUpload: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        customRequest: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onProgress: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        withCredentials: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      /* harmony default export */

      var es_AjaxUploader = AjaxUploader_AjaxUploader; // EXTERNAL MODULE: external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}

      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_ = __webpack_require__(16);

      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_); // EXTERNAL MODULE: ./node_modules/rc-upload/node_modules/warning/browser.js


      var browser = __webpack_require__(697);

      var browser_default =
      /*#__PURE__*/
      __webpack_require__.n(browser); // CONCATENATED MODULE: ./node_modules/rc-upload/es/IframeUploader.js

      /* eslint react/sort-comp:0 */


      var IframeUploader_IFRAME_STYLE = {
        position: 'absolute',
        top: 0,
        opacity: 0,
        filter: 'alpha(opacity=0)',
        left: 0,
        zIndex: 9999
      }; // diferent from AjaxUpload, can only upload on at one time, serial seriously

      var IframeUploader_IframeUploader = function (_Component) {
        inherits_default()(IframeUploader, _Component);

        function IframeUploader() {
          var _ref;

          var _temp, _this, _ret;

          classCallCheck_default()(this, IframeUploader);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = IframeUploader.__proto__ || Object.getPrototypeOf(IframeUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            uploading: false
          }, _this.file = {}, _this.onLoad = function () {
            if (!_this.state.uploading) {
              return;
            }

            var _this2 = _this,
                props = _this2.props,
                file = _this2.file;
            var response = void 0;

            try {
              var doc = _this.getIframeDocument();

              var script = doc.getElementsByTagName('script')[0];

              if (script && script.parentNode === doc.body) {
                doc.body.removeChild(script);
              }

              response = doc.body.innerHTML;
              props.onSuccess(response, file);
            } catch (err) {
              browser_default()(false, 'cross domain error for Upload. Maybe server should return document.domain script. see Note from https://github.com/react-component/upload');
              response = 'cross-domain';
              props.onError(err, null, file);
            }

            _this.endUpload();
          }, _this.onChange = function () {
            var target = _this.getFormInputNode(); // ie8/9 don't support FileList Object
            // http://stackoverflow.com/questions/12830058/ie8-input-type-file-get-files


            var file = _this.file = {
              uid: uid_uid(),
              name: target.value
            };

            _this.startUpload();

            var _this3 = _this,
                props = _this3.props;

            if (!props.beforeUpload) {
              return _this.post(file);
            }

            var before = props.beforeUpload(file);

            if (before && before.then) {
              before.then(function () {
                _this.post(file);
              }, function () {
                _this.endUpload();
              });
            } else if (before !== false) {
              _this.post(file);
            } else {
              _this.endUpload();
            }
          }, _this.saveIframe = function (node) {
            _this.iframe = node;
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        createClass_default()(IframeUploader, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.updateIframeWH();
            this.initIframe();
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            this.updateIframeWH();
          }
        }, {
          key: 'getIframeNode',
          value: function getIframeNode() {
            return this.iframe;
          }
        }, {
          key: 'getIframeDocument',
          value: function getIframeDocument() {
            return this.getIframeNode().contentDocument;
          }
        }, {
          key: 'getFormNode',
          value: function getFormNode() {
            return this.getIframeDocument().getElementById('form');
          }
        }, {
          key: 'getFormInputNode',
          value: function getFormInputNode() {
            return this.getIframeDocument().getElementById('input');
          }
        }, {
          key: 'getFormDataNode',
          value: function getFormDataNode() {
            return this.getIframeDocument().getElementById('data');
          }
        }, {
          key: 'getFileForMultiple',
          value: function getFileForMultiple(file) {
            return this.props.multiple ? [file] : file;
          }
        }, {
          key: 'getIframeHTML',
          value: function getIframeHTML(domain) {
            var domainScript = '';
            var domainInput = '';

            if (domain) {
              var script = 'script';
              domainScript = '<' + script + '>document.domain="' + domain + '";</' + script + '>';
              domainInput = '<input name="_documentDomain" value="' + domain + '" />';
            }

            return '\n    <!DOCTYPE html>\n    <html>\n    <head>\n    <meta http-equiv="X-UA-Compatible" content="IE=edge" />\n    <style>\n    body,html {padding:0;margin:0;border:0;overflow:hidden;}\n    </style>\n    ' + domainScript + '\n    </head>\n    <body>\n    <form method="post"\n    encType="multipart/form-data"\n    action="' + this.props.action + '" id="form"\n    style="display:block;height:9999px;position:relative;overflow:hidden;">\n    <input id="input" type="file"\n     name="' + this.props.name + '"\n     style="position:absolute;top:0;right:0;height:9999px;font-size:9999px;cursor:pointer;"/>\n    ' + domainInput + '\n    <span id="data"></span>\n    </form>\n    </body>\n    </html>\n    ';
          }
        }, {
          key: 'initIframeSrc',
          value: function initIframeSrc() {
            if (this.domain) {
              this.getIframeNode().src = 'javascript:void((function(){\n        var d = document;\n        d.open();\n        d.domain=\'' + this.domain + '\';\n        d.write(\'\');\n        d.close();\n      })())';
            }
          }
        }, {
          key: 'initIframe',
          value: function initIframe() {
            var iframeNode = this.getIframeNode();
            var win = iframeNode.contentWindow;
            var doc = void 0;
            this.domain = this.domain || '';
            this.initIframeSrc();

            try {
              doc = win.document;
            } catch (e) {
              this.domain = document.domain;
              this.initIframeSrc();
              win = iframeNode.contentWindow;
              doc = win.document;
            }

            doc.open('text/html', 'replace');
            doc.write(this.getIframeHTML(this.domain));
            doc.close();
            this.getFormInputNode().onchange = this.onChange;
          }
        }, {
          key: 'endUpload',
          value: function endUpload() {
            if (this.state.uploading) {
              this.file = {}; // hack avoid batch

              this.state.uploading = false;
              this.setState({
                uploading: false
              });
              this.initIframe();
            }
          }
        }, {
          key: 'startUpload',
          value: function startUpload() {
            if (!this.state.uploading) {
              this.state.uploading = true;
              this.setState({
                uploading: true
              });
            }
          }
        }, {
          key: 'updateIframeWH',
          value: function updateIframeWH() {
            var rootNode = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_default.a.findDOMNode(this);
            var iframeNode = this.getIframeNode();
            iframeNode.style.height = rootNode.offsetHeight + 'px';
            iframeNode.style.width = rootNode.offsetWidth + 'px';
          }
        }, {
          key: 'abort',
          value: function abort(file) {
            if (file) {
              var uid = file;

              if (file && file.uid) {
                uid = file.uid;
              }

              if (uid === this.file.uid) {
                this.endUpload();
              }
            } else {
              this.endUpload();
            }
          }
        }, {
          key: 'post',
          value: function post(file) {
            var formNode = this.getFormNode();
            var dataSpan = this.getFormDataNode();
            var data = this.props.data;
            var onStart = this.props.onStart;

            if (typeof data === 'function') {
              data = data(file);
            }

            var inputs = document.createDocumentFragment();

            for (var key in data) {
              if (data.hasOwnProperty(key)) {
                var input = document.createElement('input');
                input.setAttribute('name', key);
                input.value = data[key];
                inputs.appendChild(input);
              }
            }

            dataSpan.appendChild(inputs);
            formNode.submit();
            dataSpan.innerHTML = '';
            onStart(file);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                Tag = _props.component,
                disabled = _props.disabled,
                className = _props.className,
                prefixCls = _props.prefixCls,
                children = _props.children,
                style = _props.style;
            var iframeStyle = extends_default()({}, IframeUploader_IFRAME_STYLE, {
              display: this.state.uploading || disabled ? 'none' : ''
            });
            var cls = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls, true), defineProperty_default()(_classNames, prefixCls + '-disabled', disabled), defineProperty_default()(_classNames, className, className), _classNames));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Tag, {
              className: cls,
              style: extends_default()({
                position: 'relative',
                zIndex: 0
              }, style)
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('iframe', {
              ref: this.saveIframe,
              onLoad: this.onLoad,
              style: iframeStyle
            }), children);
          }
        }]);
        return IframeUploader;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      IframeUploader_IframeUploader.propTypes = {
        component: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        accept: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onStart: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        action: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        name: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var es_IframeUploader = IframeUploader_IframeUploader; // CONCATENATED MODULE: ./node_modules/rc-upload/es/Upload.js

      function Upload_empty() {}

      var Upload_Upload = function (_Component) {
        inherits_default()(Upload, _Component);

        function Upload() {
          var _ref;

          var _temp, _this, _ret;

          classCallCheck_default()(this, Upload);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Upload.__proto__ || Object.getPrototypeOf(Upload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            Component: null
          }, _this.saveUploader = function (node) {
            _this.uploader = node;
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        createClass_default()(Upload, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (this.props.supportServerRender) {
              /* eslint react/no-did-mount-set-state:0 */
              this.setState({
                Component: this.getComponent()
              }, this.props.onReady);
            }
          }
        }, {
          key: 'getComponent',
          value: function getComponent() {
            return typeof File !== 'undefined' ? es_AjaxUploader : es_IframeUploader;
          }
        }, {
          key: 'abort',
          value: function abort(file) {
            this.uploader.abort(file);
          }
        }, {
          key: 'render',
          value: function render() {
            if (this.props.supportServerRender) {
              var _ComponentUploader = this.state.Component;

              if (_ComponentUploader) {
                return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(_ComponentUploader, extends_default()({}, this.props, {
                  ref: this.saveUploader
                }));
              }

              return null;
            }

            var ComponentUploader = this.getComponent();
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ComponentUploader, extends_default()({}, this.props, {
              ref: this.saveUploader
            }));
          }
        }]);
        return Upload;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Upload_Upload.propTypes = {
        component: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        action: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        name: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        multipart: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onError: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onSuccess: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onProgress: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onStart: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]),
        headers: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        accept: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        multiple: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        beforeUpload: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        customRequest: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onReady: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        withCredentials: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        supportServerRender: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
      };
      Upload_Upload.defaultProps = {
        component: 'span',
        prefixCls: 'rc-upload',
        data: {},
        headers: {},
        name: 'file',
        multipart: false,
        onReady: Upload_empty,
        onStart: Upload_empty,
        onError: Upload_empty,
        onSuccess: Upload_empty,
        supportServerRender: false,
        multiple: false,
        beforeUpload: null,
        customRequest: null,
        withCredentials: false
      };
      /* harmony default export */

      var es_Upload = Upload_Upload; // CONCATENATED MODULE: ./node_modules/rc-upload/es/index.js
      // export this package's api

      /* harmony default export */

      var es = __webpack_exports__["default"] = es_Upload;
      /***/
    },
    /* 263 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseUniq = __webpack_require__(326);
      /**
       * Creates a duplicate-free version of an array, using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons, in which only the first occurrence of each element
       * is kept. The order of result values is determined by the order they occur
       * in the array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.uniq([2, 1, 2]);
       * // => [2, 1]
       */


      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }

      module.exports = uniq;
      /***/
    },
    /* 264 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);

      var ReviewTable = function ReviewTable(props) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
          className: "formatic-review-table"
        }, props.sections.map(function (section, index) {
          return props.reviewTableSectionContainer && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(props.reviewTableSectionContainer, {
            key: index,
            id: section.id,
            label: section.label,
            logic: section.logic,
            pageId: section.pageId,
            fields: section.fields,
            dataSubmission: props.dataSubmission,
            labelForAdvancedComponent: props.labelForAdvancedComponent
          });
        }));
      };

      ReviewTable.defaultProps = {
        dataSubmission: {},
        labelForAdvancedComponent: '',
        reviewTableSectionContainer: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        sections: []
      };
      ReviewTable.propTypes = {
        dataSubmission: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
        labelForAdvancedComponent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        reviewTableSectionContainer: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        sections: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array
      };
      /* harmony default export */

      __webpack_exports__["a"] = ReviewTable;
      /***/
    },
    /* 265 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(377);
      /***/
    },
    /* 266 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
      /* harmony import */


      var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_7___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_7__);
      /* harmony import */


      var cleave_js_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(265);
      /* harmony import */


      var cleave_js_react__WEBPACK_IMPORTED_MODULE_8___default =
      /*#__PURE__*/
      __webpack_require__.n(cleave_js_react__WEBPACK_IMPORTED_MODULE_8__);
      /* harmony import */


      var _core_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18);

      var handleCleaveChange = function handleCleaveChange(props, e) {
        var rawValue = e.target.rawValue;
        var maskedValue = e.target.value;
        var changeValue = props.changeValue;
        changeValue({
          rawValue: rawValue,
          maskedValue: maskedValue
        });
      }; // cleaveHandleChange only calls handleCleaveChange without exposing handleCleaveChange logic on DOM structure


      var cleaveHandleChange = function cleaveHandleChange(props) {
        return function (e) {
          handleCleaveChange(props, e);
        };
      };

      var handleBlur = function handleBlur(props, event) {
        props.onBlur(event);
      }; // cleaveHandleBlur only calls handleBlur without exposing handleBlur logic on DOM structure


      var cleaveHandleBlur = function cleaveHandleBlur(props) {
        return function (event) {
          handleBlur(props, event);
        };
      };

      var handleFocus = function handleFocus(props, event) {
        props.onFocus(props, event);
      }; // cleaveHandleFocus only calls handleFocus without exposing handleFocus logic on DOM structure


      var cleaveHandleFocus = function cleaveHandleFocus(props) {
        return function (events) {
          handleFocus(props, events);
        };
      };

      var InputMask = function InputMask(props) {
        var maskOptions = props.maskOptions;
        return react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(cleave_js_react__WEBPACK_IMPORTED_MODULE_8___default.a, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, lodash_omit__WEBPACK_IMPORTED_MODULE_7___default()(props, ['changeValue', 'maskOptions']), {
          id: props.id,
          className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, props.className, props.className), {
            'formatic-field-read-only': props.readOnly
          }),
          options: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, maskOptions),
          type: props.type,
          value: props.value,
          onChange: props.onChange === lodash_noop__WEBPACK_IMPORTED_MODULE_6___default.a ? cleaveHandleChange(props) : props.onChange,
          onBlur: cleaveHandleBlur(props),
          onFocus: cleaveHandleFocus(props),
          placeholder: props.placeholder,
          maxLength: props.maxLength > 0 ? props.maxLength : undefined,
          readOnly: props.readOnly
        }));
      };

      InputMask.defaultProps = {
        changeValue: lodash_noop__WEBPACK_IMPORTED_MODULE_6___default.a,
        className: '',
        id: Object(_core_utils__WEBPACK_IMPORTED_MODULE_9__[
        /* getRandomId */
        "k"])(),
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_6___default.a,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_6___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_6___default.a,
        type: 'text',
        value: '',
        // that's the Cleave's rawValue
        // attributes from dashboard
        maskOptions: {},
        maxLength: 0,
        placeholder: '',
        readOnly: false
      };
      InputMask.propTypes = {
        changeValue: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
        className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
        id: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
        type: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
        value: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
        // that's the Cleave's rawValue
        // attributes from dashboard
        maskOptions: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,
        // Cleave's options prop: https://github.com/nosir/cleave.js/blob/master/doc/options.md
        maxLength: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string]),
        placeholder: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
        readOnly: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool
      };
      /* harmony default export */

      __webpack_exports__["a"] = InputMask;
      /***/
    },
    /* 267 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof2 = __webpack_require__(49);

      var _typeof3 = _interopRequireDefault(_typeof2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _rcSelect = __webpack_require__(105);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _select = __webpack_require__(220);

      var _select2 = _interopRequireDefault(_select);

      var _input = __webpack_require__(857);

      var _input2 = _interopRequireDefault(_input);

      var _InputElement = __webpack_require__(852);

      var _InputElement2 = _interopRequireDefault(_InputElement);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function isSelectOptionOrSelectOptGroup(child) {
        return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
      }

      var AutoComplete = function (_React$Component) {
        (0, _inherits3['default'])(AutoComplete, _React$Component);

        function AutoComplete() {
          (0, _classCallCheck3['default'])(this, AutoComplete);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).apply(this, arguments));

          _this.getInputElement = function () {
            var children = _this.props.children;
            var element = children && React.isValidElement(children) && children.type !== _rcSelect.Option ? React.Children.only(_this.props.children) : React.createElement(_input2['default'], null);
            var elementProps = (0, _extends3['default'])({}, element.props); // https://github.com/ant-design/ant-design/pull/7742

            delete elementProps.children;
            return React.createElement(_InputElement2['default'], elementProps, element);
          };

          _this.saveSelect = function (node) {
            _this.select = node;
          };

          return _this;
        }

        (0, _createClass3['default'])(AutoComplete, [{
          key: 'focus',
          value: function focus() {
            this.select.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.select.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                size = _props.size,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                notFoundContent = _props.notFoundContent,
                prefixCls = _props.prefixCls,
                optionLabelProp = _props.optionLabelProp,
                dataSource = _props.dataSource,
                children = _props.children;
            var cls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-show-search', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-auto-complete', true), _classNames));
            var options = void 0;
            var childArray = React.Children.toArray(children);

            if (childArray.length && isSelectOptionOrSelectOptGroup(childArray[0])) {
              options = children;
            } else {
              options = dataSource ? dataSource.map(function (item) {
                if (React.isValidElement(item)) {
                  return item;
                }

                switch (typeof item === 'undefined' ? 'undefined' : (0, _typeof3['default'])(item)) {
                  case 'string':
                    return React.createElement(_rcSelect.Option, {
                      key: item
                    }, item);

                  case 'object':
                    return React.createElement(_rcSelect.Option, {
                      key: item.value
                    }, item.text);

                  default:
                    throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
                }
              }) : [];
            }

            return React.createElement(_select2['default'], (0, _extends3['default'])({}, this.props, {
              className: cls,
              mode: 'combobox',
              optionLabelProp: optionLabelProp,
              getInputElement: this.getInputElement,
              notFoundContent: notFoundContent,
              ref: this.saveSelect
            }), options);
          }
        }]);
        return AutoComplete;
      }(React.Component);

      exports['default'] = AutoComplete;
      AutoComplete.Option = _rcSelect.Option;
      AutoComplete.OptGroup = _rcSelect.OptGroup;
      AutoComplete.defaultProps = {
        prefixCls: 'ant-select',
        transitionName: 'slide-up',
        optionLabelProp: 'children',
        choiceTransitionName: 'zoom',
        showSearch: false,
        filterOption: false
      };
      module.exports = exports['default'];
      /***/
    },
    /* 268 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony default export */


      __webpack_exports__["a"] = Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({});
      /***/
    },
    /* 269 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseClamp = __webpack_require__(858),
          baseToString = __webpack_require__(507),
          toInteger = __webpack_require__(432),
          toString = __webpack_require__(140);
      /**
       * Checks if `string` starts with the given target string.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {string} [target] The string to search for.
       * @param {number} [position=0] The position to search from.
       * @returns {boolean} Returns `true` if `string` starts with `target`,
       *  else `false`.
       * @example
       *
       * _.startsWith('abc', 'a');
       * // => true
       *
       * _.startsWith('abc', 'b');
       * // => false
       *
       * _.startsWith('abc', 'b', 1);
       * // => true
       */


      function startsWith(string, target, position) {
        string = toString(string);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }

      module.exports = startsWith;
      /***/
    },
    /* 270 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62);
      /* harmony import */


      var lodash_omit__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var _Checkbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(188);

      var TrueFalse = function TrueFalse(props) {
        return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
          className: props.className
        }, react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Checkbox__WEBPACK_IMPORTED_MODULE_5__[
        /* default */
        "a"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, lodash_omit__WEBPACK_IMPORTED_MODULE_4___default()(props, ['className']), {
          checked: props.selected,
          value: props.label
        })));
      };

      TrueFalse.defaultProps = {
        className: 'formatic-true-false',
        id: '',
        label: '',
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        selected: false,
        // attributes from dashboard
        required: false
      };
      TrueFalse.propTypes = {
        className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        label: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        required: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
        selected: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string])
      };
      /* harmony default export */

      __webpack_exports__["a"] = TrueFalse;
      /***/
    },
    /* 271 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _core_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18);

      var AbnAcn = function AbnAcn(props) {
        return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("input", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, props, {
          id: props.id,
          className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, props.className, props.className), {
            'formatic-field-read-only': props.readOnly
          }),
          type: "number"
        }));
      };

      AbnAcn.defaultProps = {
        className: '',
        id: Object(_core_utils__WEBPACK_IMPORTED_MODULE_6__[
        /* getRandomId */
        "k"])(),
        maxLength: 11,
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_4___default.a,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_4___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_4___default.a,
        placeholder: '',
        type: 'text',
        value: '',
        // attributes from dashboard
        readOnly: false
      };
      AbnAcn.propTypes = {
        className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        type: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        value: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        maxLength: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number,
        // attributes from dashboard
        placeholder: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        readOnly: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool
      };
      /* harmony default export */

      __webpack_exports__["a"] = AbnAcn;
      /***/
    },
    /* 272 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);

      var isSelected = function isSelected(option, value) {
        return value.includes(option);
      };

      var ButtonList = function ButtonList(props) {
        return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, props.className, props.className))
        }, props.options.map(function (option, i) {
          var options = {
            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('formatic-button-list__button', {
              'formatic-button-list__button--selected': isSelected(option, props.value)
            }),
            onClick: props.onClick,
            type: props.type,
            disabled: props.disabled,
            value: option
          };
          return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
            key: i,
            className: "formatic-button-list__button-item-container"
          }, props.button && react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(props.button, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, options, {
            label: option
          })), !props.button && react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("button", options, option));
        }));
      };

      ButtonList.defaultProps = {
        button: undefined,
        className: '',
        default: [],
        disabled: false,
        onClick: lodash_noop__WEBPACK_IMPORTED_MODULE_4___default.a,
        options: [],
        type: 'button',
        value: []
      };
      ButtonList.propTypes = {
        button: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node, prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func]),
        className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        default: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string), prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string]),
        disabled: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,
        onClick: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        options: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.array,
        type: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        value: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.array])
      };
      /* harmony default export */

      __webpack_exports__["a"] = ButtonList;
      /***/
    },
    /* 273 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_3__);

      var NetPromoterScore = function NetPromoterScore(props) {
        var virtualValueNumericForComparison = Number(props.virtualValue).toString() === props.virtualValue.toString() ? Number(props.virtualValue) : NaN;
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
          className: props.className
        }, props.listOfScores.map(function (item) {
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
            className: "formatic-net-promoter-score__button-container formatic-net-promoter-score__button-container--item-id-".concat(item),
            onMouseLeave: props.onMouseLeave(props.virtualValue),
            onMouseEnter: props.onMouseEnter(item),
            key: item
          }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(props.button, {
            key: item,
            onClick: props.onMouseClick,
            label: item.toString(),
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("formatic-net-promoter-score__item formatic-net-promoter-score__item--item-id-".concat(item), {
              'formatic-net-promoter-score__item--scored': virtualValueNumericForComparison > item,
              'formatic-net-promoter-score__item--hovered': virtualValueNumericForComparison === item
            })
          }));
        }), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
          className: "formatic-net-promoter-score__description-container"
        }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
          className: "formatic-net-promoter-score__negative-description"
        }, props.negativeDescription), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
          className: "formatic-net-promoter-score__positive-description"
        }, props.positiveDescription)));
      };

      NetPromoterScore.defaultProps = {
        className: '',
        negativeDescription: 'Not likely to recommend',
        listOfScores: [],
        onMouseClick: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        onMouseEnter: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        onMouseLeave: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        positiveDescription: 'Extremely likely to recommend',
        range: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        scoreUpTo: 2,
        virtualValue: ''
      };
      NetPromoterScore.propTypes = {
        className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        negativeDescription: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        listOfScores: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.array,
        onMouseClick: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        onMouseEnter: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        onMouseLeave: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        positiveDescription: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        range: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        scoreUpTo: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
        virtualValue: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number])
      };
      /* harmony default export */

      __webpack_exports__["a"] = NetPromoterScore;
      /***/
    },
    /* 274 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var antd_lib_upload_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(683);
      /* harmony import */


      var antd_lib_upload_index__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(antd_lib_upload_index__WEBPACK_IMPORTED_MODULE_3__);

      var FileUpload = function FileUpload(props) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
          className: props.className
        }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(antd_lib_upload_index__WEBPACK_IMPORTED_MODULE_3___default.a, {
          name: props.name,
          customRequest: props.customRequest,
          fileList: props.fileList,
          onChange: props.onChange,
          onRemove: props.onRemove,
          onBlur: props.onBlur,
          onFocus: props.onFocus
        }, props.buttonLabel && props.button && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(props.button, {
          label: props.buttonLabel,
          disabled: props.isButtonDisabled
        }), !props.button && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", {
          type: "button",
          value: props.buttonLabel
        }, props.buttonLabel)));
      };

      FileUpload.defaultProps = {
        button: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        name: 'file',
        className: 'formatic-file-upload__upload',
        customRequest: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        fileList: [],
        isButtonDisabled: false,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onRemove: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        // attributes from dashboard
        buttonLabel: 'Click to Upload',
        value: []
      };
      FileUpload.propTypes = {
        name: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        button: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        customRequest: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        fileList: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array,
        isButtonDisabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onRemove: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        // attributes from dashboard
        buttonLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
          extension: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          field_id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          filename: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          size: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
          status: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          upload_id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          uid: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
        }))
      };
      /* harmony default export */

      __webpack_exports__["a"] = FileUpload;
      /***/
    },
    /* 275 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return InvalidErrorMessage;
      });
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
      /* harmony import */


      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20);
      /* harmony import */


      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24);
      /* harmony import */


      var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23);
      /* harmony import */


      var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11);
      /* harmony import */


      var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22);
      /* harmony import */


      var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_8___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_9___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_10___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_10__);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_11___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_11__);
      /* harmony import */


      var lodash_isEqual__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30);
      /* harmony import */


      var lodash_isEqual__WEBPACK_IMPORTED_MODULE_12___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_12__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_13___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_13__);
      /* harmony import */


      var _formatic_form_logic__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(142);
      /* harmony import */


      var _formatic_form_logic__WEBPACK_IMPORTED_MODULE_14___default =
      /*#__PURE__*/
      __webpack_require__.n(_formatic_form_logic__WEBPACK_IMPORTED_MODULE_14__);
      /* harmony import */


      var _Text__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(167);
      /* harmony import */


      var _core_utils_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(27);

      var InvalidErrorMessage = 'You have entered an invalid e-mail.';
      /**
       * Email Widget
       * Includes custom validation.
       *
       * @class Email
       * @extends {Component}
       */

      var Email =
      /*#__PURE__*/
      function (_Component) {
        _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Email, _Component);

        function Email() {
          var _getPrototypeOf2;

          var _this;

          _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Email);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, (_getPrototypeOf2 = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Email)).call.apply(_getPrototypeOf2, [this].concat(args)));

          _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this), "shouldComponentUpdate", function (nextProps) {
            // it should only re render if the value is different from previous props
            return !lodash_isEqual__WEBPACK_IMPORTED_MODULE_12___default()(lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(_this.props, 'value'), lodash_get__WEBPACK_IMPORTED_MODULE_11___default()(nextProps, 'value'));
          });

          return _this;
        }

        _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Email, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.props.registerValidator(Email.validator, this.props.fieldId, _core_utils_constants__WEBPACK_IMPORTED_MODULE_16__["Validator"].Custom, false);
          }
        }, {
          key: "render",
          value: function render() {
            return react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement("div", {
              className: classnames__WEBPACK_IMPORTED_MODULE_13___default()('formatic-email', _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()({}, this.props.className, this.props.className))
            }, react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement(_Text__WEBPACK_IMPORTED_MODULE_15__[
            /* default */
            "a"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
              type: "email"
            }, this.props)));
          }
        }]);

        return Email;
      }(react__WEBPACK_IMPORTED_MODULE_8__["Component"]);

      Email.validator = function (value) {
        var isValid = Object(_formatic_form_logic__WEBPACK_IMPORTED_MODULE_14__["isEmailValid"])(value);
        var errors = isValid ? {} : {
          value: InvalidErrorMessage
        };
        return {
          isValid: isValid,
          errors: errors,
          displayErrorMessage: errors.value
        };
      };

      Email.defaultProps = {
        attributes: {},
        changeValue: lodash_noop__WEBPACK_IMPORTED_MODULE_10___default.a,
        className: '',
        data: {},
        fieldId: '',
        id: '',
        registerValidator: lodash_noop__WEBPACK_IMPORTED_MODULE_10___default.a,
        type: 'email',
        validate: lodash_noop__WEBPACK_IMPORTED_MODULE_10___default.a,
        value: ''
      };
      Email.propTypes = {
        attributes: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.shape({
          description: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,
          label: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,
          maxLength: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.number,
          placeholder: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.bool,
          required: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.bool,
          showLabel: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.bool,
          realTimeValidation: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.bool
        }),
        changeValue: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.func,
        className: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,
        data: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.object,
        fieldId: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,
        registerValidator: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.func,
        type: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,
        validate: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.func,
        value: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string
      };
      /* harmony default export */

      __webpack_exports__["b"] = Email;
      /***/
    },
    /* 276 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var antd_lib_slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684);
      /* harmony import */


      var antd_lib_slider__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(antd_lib_slider__WEBPACK_IMPORTED_MODULE_3__);

      var NumericSlider = function NumericSlider(props) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(antd_lib_slider__WEBPACK_IMPORTED_MODULE_3___default.a, {
          className: props.className,
          defaultValue: props.default,
          disabled: props.readOnly,
          dots: props.dragOverTicksOnly,
          id: props.id,
          marks: props.marks,
          max: props.max,
          min: props.min,
          onChange: props.changeValue,
          step: props.step,
          value: props.value,
          vertical: props.vertical
        });
      };

      NumericSlider.defaultProps = {
        changeValue: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        className: '',
        formatter: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        id: '',
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        parser: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        refInput: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        value: 0,
        // attributes from dashboard
        default: 0,
        description: '',
        dragOverTicksOnly: false,
        label: '',
        marks: {},
        max: 5,
        min: 0,
        readOnly: false,
        required: false,
        step: 1,
        vertical: false
      };
      NumericSlider.propTypes = {
        changeValue: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        formatter: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        parser: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        refInput: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        // attributes from dashboard
        default: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        description: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        dragOverTicksOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
        label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        marks: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
        max: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        min: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
        required: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
        step: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        vertical: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
      };
      /* harmony default export */

      __webpack_exports__["a"] = NumericSlider;
      /***/
    },
    /* 277 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var antd_lib_input_number__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(685);
      /* harmony import */


      var antd_lib_input_number__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(antd_lib_input_number__WEBPACK_IMPORTED_MODULE_3__);

      var NumericInput = function NumericInput(props) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(antd_lib_input_number__WEBPACK_IMPORTED_MODULE_3___default.a, {
          ref: props.refInput,
          id: props.id,
          className: props.className,
          type: "tel",
          value: props.value,
          onChange: props.changeValue,
          min: props.min,
          max: props.max,
          step: props.step,
          onBlur: props.onBlur,
          onFocus: props.onFocus,
          formatter: props.formatter,
          parser: props.parser,
          disabled: props.disable
        });
      };

      NumericInput.defaultProps = {
        changeValue: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        className: '',
        formatter: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        id: '',
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        parser: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        refInput: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        value: 0,
        // attributes from dashboard
        description: '',
        disable: false,
        label: '',
        max: 3,
        min: 0,
        placeholder: '',
        required: false,
        step: 1,
        type: ''
      };
      NumericInput.propTypes = {
        changeValue: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        formatter: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        parser: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        refInput: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
        // attributes from dashboard
        description: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        disable: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
        label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        max: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        min: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        placeholder: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        required: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
        step: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        type: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
      };
      /* harmony default export */

      __webpack_exports__["a"] = NumericInput;
      /***/
    },
    /* 278 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);

      var DatePicker = function DatePicker(props) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("input", {
          id: props.id,
          type: props.type,
          className: props.className,
          value: props.value,
          min: props.min,
          max: props.max,
          onChange: props.onChange,
          onBlur: props.onBlur,
          onFocus: props.onFocus
        });
      };

      DatePicker.defaultProps = {
        className: '',
        id: '',
        max: '',
        min: '',
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        type: '',
        value: ''
      };
      DatePicker.propTypes = {
        className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        max: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        min: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        type: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
      };
      /* harmony default export */

      __webpack_exports__["a"] = DatePicker;
      /***/
    },
    /* 279 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
      /* harmony import */


      var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39);
      /* harmony import */


      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var antd_lib_select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(220);
      /* harmony import */


      var antd_lib_select__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(antd_lib_select__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_5__); // NOTE: I just noticed that "id={props.id}" works for the first Dropdown in the page only.
      //       This defect is reproducible before the decoupling components refactor
      //       This is an issue with Select from Ant Design.
      //       It is used in conjunction with labelFor from Label, so once the user clicks on the label, it selects the dropdown.
      // TODO: investigate it and fix it


      var Dropdown = function Dropdown(props) {
        return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_4___default.a, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, props, {
          id: props.id,
          name: props.id,
          className: props.selectClassName,
          dropdownClassName: props.dropdownClassName,
          value: props.value === '' ? undefined : props.value,
          showSearch: props.showSearch,
          defaultValue: props.default,
          placeholder: props.placeholder
        }), props.options.map(function (option, index) {
          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(option) === 'object' && option.value && option.text) {
            return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_4___default.a.Option, {
              value: option.value,
              key: index,
              className: props.selectOptionClassName
            }, option.text);
          }

          return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_4___default.a.Option, {
            value: option,
            key: index,
            className: props.selectOptionClassName
          }, option);
        }));
      };

      Dropdown.defaultProps = {
        selectClassName: 'formatic-dropdown__select',
        dropdownClassName: 'formatic-ant-dropdown formatic-dropdown__select-menu',
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_5___default.a,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_5___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_5___default.a,
        id: '',
        selectOptionClassName: 'formatic-dropdown__option',
        value: '',
        // attributes from dashboard
        default: '',
        options: [],
        placeholder: 'Please select',
        showSearch: true
      };
      Dropdown.propTypes = {
        selectClassName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        dropdownClassName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
        id: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        selectOptionClassName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        value: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        // attributes from dashboard
        default: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        options: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.shape({
          text: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
          value: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
        })])),
        placeholder: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
        showSearch: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool
      };
      /* harmony default export */

      __webpack_exports__["a"] = Dropdown;
      /***/
    },
    /* 280 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);

      var RadioList = function RadioList(props) {
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
          className: props.className
        }, props.options.map(function (option, i) {
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
            className: "formatic-radio-list__radio-item-container",
            key: i
          }, props.label && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(props.label, {
            className: "formatic-radio-list__radio-item-label",
            label: option,
            prefixLabel: [react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("input", {
              checked: option === props.value,
              className: "formatic-radio-list__radio-item",
              id: "".concat(props.id, "_").concat(i),
              key: "".concat(props.id, "-").concat(i),
              onBlur: props.onBlur,
              onChange: props.onChange,
              onFocus: props.onFocus,
              type: "radio",
              value: option
            }), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
              className: "formatic-radio-list__radio-item-checkmark",
              key: "".concat(props.id, "-").concat(i, "-span")
            }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
              className: "formatic-radio-list__radio-item-checkmark--checked"
            }))],
            labelFor: "".concat(props.id, "_").concat(i)
          }), !props.label && option);
        }));
      };

      RadioList.defaultProps = {
        className: '',
        id: '',
        label: undefined,
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_2___default.a,
        value: '',
        // attributes from dashboard
        options: []
      };
      RadioList.propTypes = {
        className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func]),
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        // attributes from dashboard
        options: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string)
      };
      /* harmony default export */

      __webpack_exports__["a"] = RadioList;
      /***/
    },
    /* 281 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
      /* harmony import */


      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);

      var handleTextareaChange = function handleTextareaChange(props) {
        return function (e) {
          props.changeValue(e.target.value);
        };
      };

      var Textarea = function Textarea(props) {
        return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("textarea", {
          id: props.id,
          className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, props.className, props.className), {
            'formatic-field-read-only': props.readOnly
          }),
          value: props.value,
          onChange: props.onChange === lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a ? handleTextareaChange(props) : props.onChange,
          onBlur: props.onBlur,
          onFocus: props.onFocus,
          placeholder: props.placeholder,
          maxLength: props.maxLength,
          rows: props.rows > 0 ? props.rows : 5,
          readOnly: props.readOnly
        });
      };

      Textarea.defaultProps = {
        changeValue: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        className: '',
        id: '',
        onBlur: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        onChange: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        onFocus: lodash_noop__WEBPACK_IMPORTED_MODULE_3___default.a,
        maxLength: 255,
        placeholder: '',
        rows: 5,
        value: '',
        // attributes from dashboard
        readOnly: false
      };
      Textarea.propTypes = {
        changeValue: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        onBlur: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        onFocus: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
        value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        // attributes from dashboard
        maxLength: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string]),
        placeholder: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
        readOnly: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
        rows: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string])
      };
      /* harmony default export */

      __webpack_exports__["a"] = Textarea;
      /***/
    },
    /* 282 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export getRepeatableFieldTag */

      /* unused harmony export getRepeatableFieldTagAndFieldId */

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return getSectionFields;
      });
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
      /* harmony import */


      var lodash_get__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25);
      /* harmony import */


      var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68);
      /* harmony import */


      var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var _tokens_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61);
      /**
       * It returns the tag of a field that is in a repeatable
       *
       * repeatableId is the id of the repeatable component
       * fieldId is the id of the field that is rendered in the repeatable
       * dataFormFieldsById is the object present at this.props.data.From.fieldsById
       */


      var getRepeatableFieldTag = function getRepeatableFieldTag(repeatableId, fieldId, dataFormFieldsById) {
        var tag; // try to get the field's tag in dataFormFieldsById
        // NOTE: that'll only work if the field is defined outside of the repeatable,
        //       but's faster to do this check first rather than looping through the repeatable attributes.objects

        tag = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(dataFormFieldsById, "[".concat(fieldId, "].attributes.tag")); // if tag is empty, that means that it will be defined in the repeatable internal objects definition

        if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(tag)) {
          // look in repeatable internal objects definition if there is a component with 'fieldId' and then get its tag
          lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(dataFormFieldsById, "[".concat(repeatableId, "].attributes.objects"), []).some(function (field) {
            if (lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(field, 'id') === fieldId) {
              tag = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(field, 'attributes.tag');
              return true;
            }

            return false;
          });
        }

        return tag;
      };
      /**
       * It returns the tag of a field that is in a repeatable and its id (which contains the random repetition part on it)
       *
       * fieldId is the id of the field that is rendered in the repeatable. It contains a token like {{[0]}}.
       *         e.g. 5a165ce9c097260010568734-{{[0]}}-5a165cc3c09726000f2a6b82
       *         the token {{[0]}} on this example will be replaced by the first random repetition id of this repeatable
       * dataFormFieldsById is the object present at this.props.data.From.fieldsById
       * tokens is the object present at this.props.tokens
       */


      var getRepeatableFieldTagAndFieldId = function getRepeatableFieldTagAndFieldId(fieldId, dataFormFieldsById, tokens) {
        var matches = Object(_tokens_tokens__WEBPACK_IMPORTED_MODULE_3__[
        /* getTokensMatches */
        "b"])(fieldId);
        var fieldTag;
        matches.some(function (match) {
          // the token here would be just brackets with an index on it e.g. '[0]'
          var token = Object(_tokens_tokens__WEBPACK_IMPORTED_MODULE_3__[
          /* removeTokensBrackets */
          "c"])(match); // fieldId would have a content with the following structure: <repeatableId>-<token>-<repeatableFieldId>

          var idParts = fieldId.split('-');
          var repeatableId = idParts[0];
          var repeatableFieldId = idParts[2];
          var repeatableFieldTag = getRepeatableFieldTag(repeatableId, repeatableFieldId, dataFormFieldsById);
          var repeatableTag = dataFormFieldsById[repeatableId].attributes.tag; // set the fieldTag before returning it

          fieldTag = "".concat(repeatableTag, ".repetition").concat(token, ".").concat(repeatableFieldTag); // get the random repetitionId in order to replace the token by it

          var repetitionId = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(tokens, "fields.".concat(repeatableTag, ".value").concat(token)); // set the fieldId before returning it

          fieldId = fieldId.replace(match, repetitionId);
          return true;
        });
        return {
          fieldId: fieldId,
          fieldTag: fieldTag
        };
      };

      var getSectionFields = function getSectionFields(repeatableField, dataFormSectionsById) {
        var sectionIdToRepeat = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(repeatableField, 'attributes.sectionIdToRepeat');
        var sectionFields = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_2___default()(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(dataFormSectionsById, "[".concat(sectionIdToRepeat, "].fields"), []));
        var insertFieldsInSection = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(repeatableField, 'attributes.insertFieldsInSection', []);
        var updatedIndexes = sectionFields.map(function (item, i) {
          return i;
        });
        insertFieldsInSection.forEach(function (insertField) {
          if (updatedIndexes[insertField.insertAt] === undefined) {
            sectionFields.push(insertField);
          } else {
            sectionFields.splice(updatedIndexes[insertField.insertAt], 0, insertField); // update indexes considering where the new element was inserted

            updatedIndexes = updatedIndexes.map(function (i, arrayIndex) {
              return insertField.insertAt <= arrayIndex ? i + 1 : i;
            });
          }
        });
        return sectionFields;
      };
      /***/

    },
    /* 283 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _Modal = __webpack_require__(441);

      var _Modal2 = _interopRequireDefault(_Modal);

      var _confirm = __webpack_require__(889);

      var _confirm2 = _interopRequireDefault(_confirm);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      _Modal2['default'].info = function (props) {
        var config = (0, _extends3['default'])({
          type: 'info',
          iconType: 'info-circle',
          okCancel: false
        }, props);
        return (0, _confirm2['default'])(config);
      };

      _Modal2['default'].success = function (props) {
        var config = (0, _extends3['default'])({
          type: 'success',
          iconType: 'check-circle',
          okCancel: false
        }, props);
        return (0, _confirm2['default'])(config);
      };

      _Modal2['default'].error = function (props) {
        var config = (0, _extends3['default'])({
          type: 'error',
          iconType: 'cross-circle',
          okCancel: false
        }, props);
        return (0, _confirm2['default'])(config);
      };

      _Modal2['default'].warning = _Modal2['default'].warn = function (props) {
        var config = (0, _extends3['default'])({
          type: 'warning',
          iconType: 'exclamation-circle',
          okCancel: false
        }, props);
        return (0, _confirm2['default'])(config);
      };

      _Modal2['default'].confirm = function (props) {
        var config = (0, _extends3['default'])({
          type: 'confirm',
          okCancel: true
        }, props);
        return (0, _confirm2['default'])(config);
      };

      exports['default'] = _Modal2['default'];
      module.exports = exports['default'];
      /***/
    },
    /* 284 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return placements;
      });

      var autoAdjustOverflow = {
        adjustX: 1,
        adjustY: 1
      };
      var targetOffset = [0, 0];
      var placements = {
        left: {
          points: ['cr', 'cl'],
          overflow: autoAdjustOverflow,
          offset: [-4, 0],
          targetOffset: targetOffset
        },
        right: {
          points: ['cl', 'cr'],
          overflow: autoAdjustOverflow,
          offset: [4, 0],
          targetOffset: targetOffset
        },
        top: {
          points: ['bc', 'tc'],
          overflow: autoAdjustOverflow,
          offset: [0, -4],
          targetOffset: targetOffset
        },
        bottom: {
          points: ['tc', 'bc'],
          overflow: autoAdjustOverflow,
          offset: [0, 4],
          targetOffset: targetOffset
        },
        topLeft: {
          points: ['bl', 'tl'],
          overflow: autoAdjustOverflow,
          offset: [0, -4],
          targetOffset: targetOffset
        },
        leftTop: {
          points: ['tr', 'tl'],
          overflow: autoAdjustOverflow,
          offset: [-4, 0],
          targetOffset: targetOffset
        },
        topRight: {
          points: ['br', 'tr'],
          overflow: autoAdjustOverflow,
          offset: [0, -4],
          targetOffset: targetOffset
        },
        rightTop: {
          points: ['tl', 'tr'],
          overflow: autoAdjustOverflow,
          offset: [4, 0],
          targetOffset: targetOffset
        },
        bottomRight: {
          points: ['tr', 'br'],
          overflow: autoAdjustOverflow,
          offset: [0, 4],
          targetOffset: targetOffset
        },
        rightBottom: {
          points: ['bl', 'br'],
          overflow: autoAdjustOverflow,
          offset: [4, 0],
          targetOffset: targetOffset
        },
        bottomLeft: {
          points: ['tl', 'bl'],
          overflow: autoAdjustOverflow,
          offset: [0, 4],
          targetOffset: targetOffset
        },
        leftBottom: {
          points: ['br', 'bl'],
          overflow: autoAdjustOverflow,
          offset: [-4, 0],
          targetOffset: targetOffset
        }
      };
      /* unused harmony default export */

      var _unused_webpack_default_export = placements;
      /***/
    },
    /* 285 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16);
      /* harmony import */


      var react_dom__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var create_react_class__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32);
      /* harmony import */


      var create_react_class__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(create_react_class__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14);
      /* harmony import */


      var moment__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);

      var DateInput = create_react_class__WEBPACK_IMPORTED_MODULE_2___default()({
        displayName: 'DateInput',
        propTypes: {
          prefixCls: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
          timePicker: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,
          value: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,
          disabledTime: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.any,
          format: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
          locale: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,
          disabledDate: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
          onChange: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
          onClear: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
          placeholder: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,
          onSelect: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,
          selectedValue: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object
        },
        getInitialState: function getInitialState() {
          var selectedValue = this.props.selectedValue;
          return {
            str: selectedValue && selectedValue.format(this.props.format) || '',
            invalid: false
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          this.cachedSelectionStart = this.dateInputInstance.selectionStart;
          this.cachedSelectionEnd = this.dateInputInstance.selectionEnd; // when popup show, click body will call this, bug!

          var selectedValue = nextProps.selectedValue;
          this.setState({
            str: selectedValue && selectedValue.format(nextProps.format) || '',
            invalid: false
          });
        },
        componentDidUpdate: function componentDidUpdate() {
          if (!this.state.invalid) {
            this.dateInputInstance.setSelectionRange(this.cachedSelectionStart, this.cachedSelectionEnd);
          }
        },
        onInputChange: function onInputChange(event) {
          var str = event.target.value;
          this.setState({
            str: str
          });
          var value = void 0;
          var _props = this.props,
              disabledDate = _props.disabledDate,
              format = _props.format,
              onChange = _props.onChange;

          if (str) {
            var parsed = moment__WEBPACK_IMPORTED_MODULE_4___default()(str, format, true);

            if (!parsed.isValid()) {
              this.setState({
                invalid: true
              });
              return;
            }

            value = this.props.value.clone();
            value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

            if (value && (!disabledDate || !disabledDate(value))) {
              var originalValue = this.props.selectedValue;

              if (originalValue && value) {
                if (!originalValue.isSame(value)) {
                  onChange(value);
                }
              } else if (originalValue !== value) {
                onChange(value);
              }
            } else {
              this.setState({
                invalid: true
              });
              return;
            }
          } else {
            onChange(null);
          }

          this.setState({
            invalid: false
          });
        },
        onClear: function onClear() {
          this.setState({
            str: ''
          });
          this.props.onClear(null);
        },
        getRootDOMNode: function getRootDOMNode() {
          return react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);
        },
        focus: function focus() {
          if (this.dateInputInstance) {
            this.dateInputInstance.focus();
          }
        },
        saveDateInput: function saveDateInput(dateInput) {
          this.dateInputInstance = dateInput;
        },
        render: function render() {
          var props = this.props;
          var _state = this.state,
              invalid = _state.invalid,
              str = _state.str;
          var locale = props.locale,
              prefixCls = props.prefixCls,
              placeholder = props.placeholder;
          var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('div', {
            className: prefixCls + '-input-wrap'
          }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('div', {
            className: prefixCls + '-date-input-wrap'
          }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('input', {
            ref: this.saveDateInput,
            className: prefixCls + '-input ' + invalidClass,
            value: str,
            disabled: props.disabled,
            placeholder: placeholder,
            onChange: this.onInputChange
          })), props.showClear ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('a', {
            className: prefixCls + '-clear-btn',
            role: 'button',
            title: locale.clear,
            onClick: this.onClear
          }) : null);
        }
      });
      /* harmony default export */

      __webpack_exports__["a"] = DateInput;
      /***/
    },
    /* 286 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return TimePickerButton;
      });
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);

      function TimePickerButton(_ref) {
        var _classnames;

        var prefixCls = _ref.prefixCls,
            locale = _ref.locale,
            showTimePicker = _ref.showTimePicker,
            onOpenTimePicker = _ref.onOpenTimePicker,
            onCloseTimePicker = _ref.onCloseTimePicker,
            timePickerDisabled = _ref.timePickerDisabled;
        var className = classnames__WEBPACK_IMPORTED_MODULE_1___default()((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
        var onClick = null;

        if (!timePickerDisabled) {
          onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
        }

        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('a', {
          className: className,
          role: 'button',
          onClick: onClick
        }, showTimePicker ? locale.dateSelect : locale.timeSelect);
      }
      /***/

    },
    /* 287 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return OkButton;
      });
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

      function OkButton(_ref) {
        var prefixCls = _ref.prefixCls,
            locale = _ref.locale,
            okDisabled = _ref.okDisabled,
            onOk = _ref.onOk;
        var className = prefixCls + "-ok-btn";

        if (okDisabled) {
          className += " " + prefixCls + "-ok-btn-disabled";
        }

        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("a", {
          className: className,
          role: "button",
          onClick: okDisabled ? null : onOk
        }, locale.ok);
      }
      /***/

    },
    /* 288 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return TodayButton;
      });
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var _util___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47);

      function TodayButton(_ref) {
        var prefixCls = _ref.prefixCls,
            locale = _ref.locale,
            value = _ref.value,
            timePicker = _ref.timePicker,
            disabled = _ref.disabled,
            disabledDate = _ref.disabledDate,
            onToday = _ref.onToday,
            text = _ref.text;
        var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
        var disabledToday = disabledDate && !Object(_util___WEBPACK_IMPORTED_MODULE_1__[
        /* isAllowedDate */
        "f"])(Object(_util___WEBPACK_IMPORTED_MODULE_1__[
        /* getTodayTime */
        "d"])(value), disabledDate);
        var isDisabled = disabledToday || disabled;
        var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('a', {
          className: prefixCls + '-today-btn ' + disabledTodayClass,
          role: 'button',
          onClick: isDisabled ? null : onToday,
          title: Object(_util___WEBPACK_IMPORTED_MODULE_1__[
          /* getTodayTimeStr */
          "e"])(value)
        }, localeNow);
      }
      /***/

    },
    /* 289 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
      /* harmony import */


      var babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
      /* harmony import */


      var react_dom__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var create_react_class__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32);
      /* harmony import */


      var create_react_class__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(create_react_class__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var rc_util_es_Children_mapSelf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(290);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var _calendar_TodayButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(288);
      /* harmony import */


      var _calendar_OkButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(287);
      /* harmony import */


      var _calendar_TimePickerButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(286);

      var CalendarFooter = create_react_class__WEBPACK_IMPORTED_MODULE_3___default()({
        displayName: 'CalendarFooter',
        propTypes: {
          prefixCls: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
          showDateInput: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
          disabledTime: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.any,
          timePicker: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.element,
          selectedValue: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.any,
          showOk: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
          onSelect: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
          value: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,
          renderFooter: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
          defaultValue: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object
        },
        onSelect: function onSelect(value) {
          this.props.onSelect(value);
        },
        getRootDOMNode: function getRootDOMNode() {
          return react_dom__WEBPACK_IMPORTED_MODULE_2___default.a.findDOMNode(this);
        },
        render: function render() {
          var props = this.props;
          var value = props.value,
              prefixCls = props.prefixCls,
              showOk = props.showOk,
              timePicker = props.timePicker,
              renderFooter = props.renderFooter;
          var footerEl = null;
          var extraFooter = renderFooter();

          if (props.showToday || timePicker || extraFooter) {
            var _cx;

            var nowEl = void 0;

            if (props.showToday) {
              nowEl = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_calendar_TodayButton__WEBPACK_IMPORTED_MODULE_7__[
              /* default */
              "a"], babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, props, {
                value: value
              }));
            }

            var okBtn = void 0;

            if (showOk === true || showOk !== false && !!props.timePicker) {
              okBtn = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_calendar_OkButton__WEBPACK_IMPORTED_MODULE_8__[
              /* default */
              "a"], props);
            }

            var timePickerBtn = void 0;

            if (!!props.timePicker) {
              timePickerBtn = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_calendar_TimePickerButton__WEBPACK_IMPORTED_MODULE_9__[
              /* default */
              "a"], props);
            }

            var footerBtn = void 0;

            if (nowEl || timePickerBtn || okBtn) {
              footerBtn = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement('span', {
                className: prefixCls + '-footer-btn'
              }, Object(rc_util_es_Children_mapSelf__WEBPACK_IMPORTED_MODULE_5__[
              /* default */
              "a"])([nowEl, timePickerBtn, okBtn]));
            }

            var cls = classnames__WEBPACK_IMPORTED_MODULE_6___default()((_cx = {}, _cx[prefixCls + '-footer'] = true, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
            footerEl = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement('div', {
              className: cls
            }, extraFooter, footerBtn);
          }

          return footerEl;
        }
      });
      /* harmony default export */

      __webpack_exports__["a"] = CalendarFooter;
      /***/
    },
    /* 290 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return mapSelf;
      });
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

      function mirror(o) {
        return o;
      }

      function mapSelf(children) {
        // return ReactFragment
        return react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.map(children, mirror);
      }
      /***/

    },
    /* 291 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
      /* harmony import */


      var babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
      /* harmony import */


      var babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
      /* harmony import */


      var babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
      /* harmony import */


      var classnames__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var _util_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47);

      var ROW = 4;
      var COL = 3;

      function chooseMonth(month) {
        var next = this.state.value.clone();
        next.month(month);
        this.setAndSelectValue(next);
      }

      function noop() {}

      var MonthTable = function (_Component) {
        babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_2___default()(MonthTable, _Component);

        function MonthTable(props) {
          babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, MonthTable);

          var _this = babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _Component.call(this, props));

          _this.state = {
            value: props.value
          };
          return _this;
        }

        MonthTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          if ('value' in nextProps) {
            this.setState({
              value: nextProps.value
            });
          }
        };

        MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
          this.setState({
            value: value
          });
          this.props.onSelect(value);
        };

        MonthTable.prototype.months = function months() {
          var value = this.state.value;
          var current = value.clone();
          var months = [];
          var index = 0;

          for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
            months[rowIndex] = [];

            for (var colIndex = 0; colIndex < COL; colIndex++) {
              current.month(index);
              var content = Object(_util_index__WEBPACK_IMPORTED_MODULE_6__[
              /* getMonthName */
              "a"])(current);
              months[rowIndex][colIndex] = {
                value: index,
                content: content,
                title: content
              };
              index++;
            }
          }

          return months;
        };

        MonthTable.prototype.render = function render() {
          var _this2 = this;

          var props = this.props;
          var value = this.state.value;
          var today = Object(_util_index__WEBPACK_IMPORTED_MODULE_6__[
          /* getTodayTime */
          "d"])(value);
          var months = this.months();
          var currentMonth = value.month();
          var prefixCls = props.prefixCls,
              locale = props.locale,
              contentRender = props.contentRender,
              cellRender = props.cellRender;
          var monthsEls = months.map(function (month, index) {
            var tds = month.map(function (monthData) {
              var _classNameMap;

              var disabled = false;

              if (props.disabledDate) {
                var testValue = value.clone();
                testValue.month(monthData.value);
                disabled = props.disabledDate(testValue);
              }

              var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
              var cellEl = void 0;

              if (cellRender) {
                var currentValue = value.clone();
                currentValue.month(monthData.value);
                cellEl = cellRender(currentValue, locale);
              } else {
                var content = void 0;

                if (contentRender) {
                  var _currentValue = value.clone();

                  _currentValue.month(monthData.value);

                  content = contentRender(_currentValue, locale);
                } else {
                  content = monthData.content;
                }

                cellEl = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement('a', {
                  className: prefixCls + '-month'
                }, content);
              }

              return react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement('td', {
                role: 'gridcell',
                key: monthData.value,
                onClick: disabled ? null : chooseMonth.bind(_this2, monthData.value),
                title: monthData.title,
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(classNameMap)
              }, cellEl);
            });
            return react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement('tr', {
              key: index,
              role: 'row'
            }, tds);
          });
          return react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement('table', {
            className: prefixCls + '-table',
            cellSpacing: '0',
            role: 'grid'
          }, react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement('tbody', {
            className: prefixCls + '-tbody'
          }, monthsEls));
        };

        return MonthTable;
      }(react__WEBPACK_IMPORTED_MODULE_3__["Component"]);

      MonthTable.defaultProps = {
        onSelect: noop
      };
      MonthTable.propTypes = {
        onSelect: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
        cellRender: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
        prefixCls: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
        value: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object
      };
      /* harmony default export */

      __webpack_exports__["a"] = MonthTable;
      /***/
    },
    /* 292 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony default export */

      __webpack_exports__["a"] = {
        today: 'Today',
        now: 'Now',
        backToToday: 'Back to today',
        ok: 'Ok',
        clear: 'Clear',
        month: 'Month',
        year: 'Year',
        timeSelect: 'select time',
        dateSelect: 'select date',
        weekSelect: 'Choose a week',
        monthSelect: 'Choose a month',
        yearSelect: 'Choose a year',
        decadeSelect: 'Choose a decade',
        yearFormat: 'YYYY',
        dateFormat: 'M/D/YYYY',
        dayFormat: 'D',
        dateTimeFormat: 'M/D/YYYY HH:mm:ss',
        monthBeforeYear: true,
        previousMonth: 'Previous month (PageUp)',
        nextMonth: 'Next month (PageDown)',
        previousYear: 'Last year (Control + left)',
        nextYear: 'Next year (Control + right)',
        previousDecade: 'Last decade',
        nextDecade: 'Next decade',
        previousCentury: 'Last century',
        nextCentury: 'Next century'
      };
      /***/
    },
    /* 293 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
      /* harmony import */


      var babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12);
      /* harmony import */


      var babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
      /* harmony import */


      var babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8);
      /* harmony import */


      var babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16);
      /* harmony import */


      var react_dom__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);

      var Portal = function (_React$Component) {
        babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default()(Portal, _React$Component);

        function Portal() {
          babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Portal);
          return babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
        }

        babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Portal, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.createContainer();
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate(prevProps) {
            var didUpdate = this.props.didUpdate;

            if (didUpdate) {
              didUpdate(prevProps);
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this.removeContainer();
          }
        }, {
          key: 'createContainer',
          value: function createContainer() {
            this._container = this.props.getContainer();
            this.forceUpdate();
          }
        }, {
          key: 'removeContainer',
          value: function removeContainer() {
            if (this._container) {
              this._container.parentNode.removeChild(this._container);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            if (this._container) {
              return react_dom__WEBPACK_IMPORTED_MODULE_5___default.a.createPortal(this.props.children, this._container);
            }

            return null;
          }
        }]);
        return Portal;
      }(react__WEBPACK_IMPORTED_MODULE_4___default.a.Component);

      Portal.propTypes = {
        getContainer: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.func.isRequired,
        children: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.node.isRequired,
        didUpdate: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.func
      };
      /* harmony default export */

      __webpack_exports__["a"] = Portal;
      /***/
    },
    /* 294 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
      /* harmony import */


      var babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12);
      /* harmony import */


      var babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
      /* harmony import */


      var babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8);
      /* harmony import */


      var babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16);
      /* harmony import */


      var react_dom__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);

      var ContainerRender = function (_React$Component) {
        babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default()(ContainerRender, _React$Component);

        function ContainerRender() {
          var _ref;

          var _temp, _this, _ret;

          babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ContainerRender);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, (_ref = ContainerRender.__proto__ || Object.getPrototypeOf(ContainerRender)).call.apply(_ref, [this].concat(args))), _this), _this.removeContainer = function () {
            if (_this.container) {
              react_dom__WEBPACK_IMPORTED_MODULE_5___default.a.unmountComponentAtNode(_this.container);

              _this.container.parentNode.removeChild(_this.container);

              _this.container = null;
            }
          }, _this.renderComponent = function (props, ready) {
            var _this$props = _this.props,
                visible = _this$props.visible,
                getComponent = _this$props.getComponent,
                forceRender = _this$props.forceRender,
                getContainer = _this$props.getContainer,
                parent = _this$props.parent;

            if (visible || parent._component || forceRender) {
              if (!_this.container) {
                _this.container = getContainer();
              }

              react_dom__WEBPACK_IMPORTED_MODULE_5___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
                if (ready) {
                  ready.call(this);
                }
              });
            }
          }, _temp), babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(_this, _ret);
        }

        babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ContainerRender, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (this.props.autoMount) {
              this.renderComponent();
            }
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            if (this.props.autoMount) {
              this.renderComponent();
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.props.autoDestroy) {
              this.removeContainer();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            return this.props.children({
              renderComponent: this.renderComponent,
              removeContainer: this.removeContainer
            });
          }
        }]);
        return ContainerRender;
      }(react__WEBPACK_IMPORTED_MODULE_4___default.a.Component);

      ContainerRender.propTypes = {
        autoMount: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.bool,
        autoDestroy: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.bool,
        visible: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.bool,
        forceRender: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.bool,
        parent: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.any,
        getComponent: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.func.isRequired,
        getContainer: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.func.isRequired,
        children: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.func.isRequired
      };
      ContainerRender.defaultProps = {
        autoMount: true,
        autoDestroy: true,
        forceRender: false
      };
      /* harmony default export */

      __webpack_exports__["a"] = ContainerRender;
      /***/
    },
    /* 295 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayMap = __webpack_require__(176),
          baseIteratee = __webpack_require__(202),
          basePickBy = __webpack_require__(443),
          getAllKeysIn = __webpack_require__(322);
      /**
       * Creates an object composed of the `object` properties `predicate` returns
       * truthy for. The predicate is invoked with two arguments: (value, key).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The source object.
       * @param {Function} [predicate=_.identity] The function invoked per property.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.pickBy(object, _.isNumber);
       * // => { 'a': 1, 'c': 3 }
       */


      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }

        var props = arrayMap(getAllKeysIn(object), function (prop) {
          return [prop];
        });
        predicate = baseIteratee(predicate);
        return basePickBy(object, props, function (value, path) {
          return predicate(value, path[0]);
        });
      }

      module.exports = pickBy;
      /***/
    },
    /* 296 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function __export(m) {
        for (var p in m) {
          if (!exports.hasOwnProperty(p)) exports[p] = m[p];
        }
      }

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var link_1 = __webpack_require__(661);

      exports.execute = link_1.execute;
      exports.ApolloLink = link_1.ApolloLink;

      var linkUtils_1 = __webpack_require__(660);

      exports.makePromise = linkUtils_1.makePromise;

      var zen_observable_ts_1 = __webpack_require__(371);

      exports.Observable = zen_observable_ts_1.default;

      __export(__webpack_require__(371));

      exports.default = link_1.ApolloLink;
      /***/
    },
    /* 297 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var nearlyEqual = __webpack_require__(67).nearlyEqual;

      var bigNearlyEqual = __webpack_require__(130);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var algorithm03 = load(__webpack_require__(152));
        var algorithm05 = load(__webpack_require__(304));
        var algorithm12 = load(__webpack_require__(150));
        var algorithm13 = load(__webpack_require__(129));
        var algorithm14 = load(__webpack_require__(107));
        /**
         * Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.
         *
         * x and y are considered equal when the relative difference between x and y
         * is smaller than the configured epsilon. The function cannot be used to
         * compare values smaller than approximately 2.22e-16.
         *
         * For matrices, the function is evaluated element wise.
         * Strings are compared by their numerical value.
         *
         * Syntax:
         *
         *    math.compare(x, y)
         *
         * Examples:
         *
         *    math.compare(6, 1)           // returns 1
         *    math.compare(2, 3)           // returns -1
         *    math.compare(7, 7)           // returns 0
         *    math.compare('10', '2')      // returns 1
         *    math.compare('1000', '1e3')  // returns 0
         *
         *    const a = math.unit('5 cm')
         *    const b = math.unit('40 mm')
         *    math.compare(a, b)           // returns 1
         *
         *    math.compare(2, [1, 2, 3])   // returns [1, 0, -1]
         *
         * See also:
         *
         *    equal, unequal, smaller, smallerEq, larger, largerEq, compareNatural, compareText
         *
         * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} x First value to compare
         * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} y Second value to compare
         * @return {number | BigNumber | Fraction | Array | Matrix} Returns the result of the comparison:
         *                                                          1 when x > y, -1 when x < y, and 0 when x == y.
         */

        var compare = typed('compare', {
          'boolean, boolean': function booleanBoolean(x, y) {
            return x === y ? 0 : x > y ? 1 : -1;
          },
          'number, number': function numberNumber(x, y) {
            return x === y || nearlyEqual(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.eq(y) || bigNearlyEqual(x, y, config.epsilon) ? new type.BigNumber(0) : new type.BigNumber(x.cmp(y));
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return new type.Fraction(x.compare(y));
          },
          'Complex, Complex': function ComplexComplex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
          },
          'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) {
              throw new Error('Cannot compare units with different base');
            }

            return compare(x.value, y.value);
          },
          'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, compare);
          },
          'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, compare, true);
          },
          'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, compare, false);
          },
          'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, compare);
          },
          'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return compare(matrix(x), matrix(y)).valueOf();
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return compare(matrix(x), y);
          },
          'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return compare(x, matrix(y));
          },
          'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, compare, false);
          },
          'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, compare, false);
          },
          'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, compare, true);
          },
          'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, compare, true);
          },
          'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, compare, false).valueOf();
          },
          'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, compare, true).valueOf();
          }
        });
        compare.toTex = undefined; // use default template

        return compare;
      }

      exports.name = 'compare';
      exports.factory = factory;
      /***/
    },
    /* 298 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var smaller = load(__webpack_require__(229));
        var larger = load(__webpack_require__(231));
        var smallerEq = load(__webpack_require__(752));
        var largerEq = load(__webpack_require__(751));
        var ZERO = new type.BigNumber(0);
        var ONE = new type.BigNumber(1);
        /**
         * Create an array from a range.
         * By default, the range end is excluded. This can be customized by providing
         * an extra parameter `includeEnd`.
         *
         * Syntax:
         *
         *     math.range(str [, includeEnd])               // Create a range from a string,
         *                                                  // where the string contains the
         *                                                  // start, optional step, and end,
         *                                                  // separated by a colon.
         *     math.range(start, end [, includeEnd])        // Create a range with start and
         *                                                  // end and a step size of 1.
         *     math.range(start, end, step [, includeEnd])  // Create a range with start, step,
         *                                                  // and end.
         *
         * Where:
         *
         * - `str: string`
         *   A string 'start:end' or 'start:step:end'
         * - `start: {number | BigNumber}`
         *   Start of the range
         * - `end: number | BigNumber`
         *   End of the range, excluded by default, included when parameter includeEnd=true
         * - `step: number | BigNumber`
         *   Step size. Default value is 1.
         * - `includeEnd: boolean`
         *   Option to specify whether to include the end or not. False by default.
         *
         * Examples:
         *
         *     math.range(2, 6)        // [2, 3, 4, 5]
         *     math.range(2, -3, -1)   // [2, 1, 0, -1, -2]
         *     math.range('2:1:6')     // [2, 3, 4, 5]
         *     math.range(2, 6, true)  // [2, 3, 4, 5, 6]
         *
         * See also:
         *
         *     ones, zeros, size, subset
         *
         * @param {*} args   Parameters describing the ranges `start`, `end`, and optional `step`.
         * @return {Array | Matrix} range
         */

        var range = typed('range', {
          // TODO: simplify signatures when typed-function supports default values and optional arguments
          // TODO: a number or boolean should not be converted to string here
          'string': _strRange,
          'string, boolean': _strRange,
          'number, number': function numberNumber(start, end) {
            return _out(_rangeEx(start, end, 1));
          },
          'number, number, number': function numberNumberNumber(start, end, step) {
            return _out(_rangeEx(start, end, step));
          },
          'number, number, boolean': function numberNumberBoolean(start, end, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, 1)) : _out(_rangeEx(start, end, 1));
          },
          'number, number, number, boolean': function numberNumberNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, step)) : _out(_rangeEx(start, end, step));
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(start, end) {
            return _out(_bigRangeEx(start, end, ONE));
          },
          'BigNumber, BigNumber, BigNumber': function BigNumberBigNumberBigNumber(start, end, step) {
            return _out(_bigRangeEx(start, end, step));
          },
          'BigNumber, BigNumber, boolean': function BigNumberBigNumberBoolean(start, end, includeEnd) {
            return includeEnd ? _out(_bigRangeInc(start, end, ONE)) : _out(_bigRangeEx(start, end, ONE));
          },
          'BigNumber, BigNumber, BigNumber, boolean': function BigNumberBigNumberBigNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_bigRangeInc(start, end, step)) : _out(_bigRangeEx(start, end, step));
          }
        });
        range.toTex = undefined; // use default template

        return range;

        function _out(arr) {
          return config.matrix === 'Array' ? arr : matrix(arr);
        }

        function _strRange(str, includeEnd) {
          var r = _parse(str);

          if (!r) {
            throw new SyntaxError('String "' + str + '" is no valid range');
          }

          var fn;

          if (config.number === 'BigNumber') {
            fn = includeEnd ? _bigRangeInc : _bigRangeEx;
            return _out(fn(new type.BigNumber(r.start), new type.BigNumber(r.end), new type.BigNumber(r.step)));
          } else {
            fn = includeEnd ? _rangeInc : _rangeEx;
            return _out(fn(r.start, r.end, r.step));
          }
        }
        /**
         * Create a range with numbers. End is excluded
         * @param {number} start
         * @param {number} end
         * @param {number} step
         * @returns {Array} range
         * @private
         */


        function _rangeEx(start, end, step) {
          var array = [];
          var x = start;

          if (step > 0) {
            while (smaller(x, end)) {
              array.push(x);
              x += step;
            }
          } else if (step < 0) {
            while (larger(x, end)) {
              array.push(x);
              x += step;
            }
          }

          return array;
        }
        /**
         * Create a range with numbers. End is included
         * @param {number} start
         * @param {number} end
         * @param {number} step
         * @returns {Array} range
         * @private
         */


        function _rangeInc(start, end, step) {
          var array = [];
          var x = start;

          if (step > 0) {
            while (smallerEq(x, end)) {
              array.push(x);
              x += step;
            }
          } else if (step < 0) {
            while (largerEq(x, end)) {
              array.push(x);
              x += step;
            }
          }

          return array;
        }
        /**
         * Create a range with big numbers. End is excluded
         * @param {BigNumber} start
         * @param {BigNumber} end
         * @param {BigNumber} step
         * @returns {Array} range
         * @private
         */


        function _bigRangeEx(start, end, step) {
          var array = [];
          var x = start;

          if (step.gt(ZERO)) {
            while (smaller(x, end)) {
              array.push(x);
              x = x.plus(step);
            }
          } else if (step.lt(ZERO)) {
            while (larger(x, end)) {
              array.push(x);
              x = x.plus(step);
            }
          }

          return array;
        }
        /**
         * Create a range with big numbers. End is included
         * @param {BigNumber} start
         * @param {BigNumber} end
         * @param {BigNumber} step
         * @returns {Array} range
         * @private
         */


        function _bigRangeInc(start, end, step) {
          var array = [];
          var x = start;

          if (step.gt(ZERO)) {
            while (smallerEq(x, end)) {
              array.push(x);
              x = x.plus(step);
            }
          } else if (step.lt(ZERO)) {
            while (largerEq(x, end)) {
              array.push(x);
              x = x.plus(step);
            }
          }

          return array;
        }
        /**
         * Parse a string into a range,
         * The string contains the start, optional step, and end, separated by a colon.
         * If the string does not contain a valid range, null is returned.
         * For example str='0:2:11'.
         * @param {string} str
         * @return {{start: number, end: number, step: number} | null} range Object containing properties start, end, step
         * @private
         */


        function _parse(str) {
          var args = str.split(':'); // number

          var nums = args.map(function (arg) {
            // use Number and not parseFloat as Number returns NaN on invalid garbage in the string
            return Number(arg);
          });
          var invalid = nums.some(function (num) {
            return isNaN(num);
          });

          if (invalid) {
            return null;
          }

          switch (nums.length) {
            case 2:
              return {
                start: nums[0],
                end: nums[1],
                step: 1
              };

            case 3:
              return {
                start: nums[0],
                end: nums[2],
                step: nums[1]
              };

            default:
              return null;
          }
        }
      }

      exports.name = 'range';
      exports.factory = factory;
      /***/
    },
    /* 299 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      var number = __webpack_require__(67);

      function factory(type, config, load, typed) {
        /**
         * Test whether a value is an integer number.
         * The function supports `number`, `BigNumber`, and `Fraction`.
         *
         * The function is evaluated element-wise in case of Array or Matrix input.
         *
         * Syntax:
         *
         *     math.isInteger(x)
         *
         * Examples:
         *
         *    math.isInteger(2)                     // returns true
         *    math.isInteger(0)                     // returns true
         *    math.isInteger(0.5)                   // returns false
         *    math.isInteger(math.bignumber(500))   // returns true
         *    math.isInteger(math.fraction(4))      // returns true
         *    math.isInteger('3')                   // returns true
         *    math.isInteger([3, 0.5, -2])          // returns [true, false, true]
         *    math.isInteger(math.complex('2-4i')   // throws an error
         *
         * See also:
         *
         *    isNumeric, isPositive, isNegative, isZero
         *
         * @param {number | BigNumber | Fraction | Array | Matrix} x   Value to be tested
         * @return {boolean}  Returns true when `x` contains a numeric, integer value.
         *                    Throws an error in case of an unknown data type.
         */
        var isInteger = typed('isInteger', {
          'number': number.isInteger,
          // TODO: what to do with isInteger(add(0.1, 0.2))  ?
          'BigNumber': function BigNumber(x) {
            return x.isInt();
          },
          'Fraction': function Fraction(x) {
            return x.d === 1 && isFinite(x.n);
          },
          'Array | Matrix': function ArrayMatrix(x) {
            return deepMap(x, isInteger);
          }
        });
        return isInteger;
      }

      exports.name = 'isInteger';
      exports.factory = factory;
      /***/
    },
    /* 300 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var clone = __webpack_require__(59).clone;

      var isInteger = __webpack_require__(67).isInteger;

      function factory(type) {
        /**
         * Create an index. An Index can store ranges and sets for multiple dimensions.
         * Matrix.get, Matrix.set, and math.subset accept an Index as input.
         *
         * Usage:
         *     const index = new Index(range1, range2, matrix1, array1, ...)
         *
         * Where each parameter can be any of:
         *     A number
         *     A string (containing a name of an object property)
         *     An instance of Range
         *     An Array with the Set values
         *     A Matrix with the Set values
         *
         * The parameters start, end, and step must be integer numbers.
         *
         * @class Index
         * @Constructor Index
         * @param {...*} ranges
         */
        function Index(ranges) {
          if (!(this instanceof Index)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          this._dimensions = [];
          this._isScalar = true;

          for (var i = 0, ii = arguments.length; i < ii; i++) {
            var arg = arguments[i];

            if (type.isRange(arg)) {
              this._dimensions.push(arg);

              this._isScalar = false;
            } else if (Array.isArray(arg) || type.isMatrix(arg)) {
              // create matrix
              var m = _createImmutableMatrix(arg.valueOf());

              this._dimensions.push(m); // size


              var size = m.size(); // scalar

              if (size.length !== 1 || size[0] !== 1) {
                this._isScalar = false;
              }
            } else if (typeof arg === 'number') {
              this._dimensions.push(_createImmutableMatrix([arg]));
            } else if (typeof arg === 'string') {
              // object property (arguments.count should be 1)
              this._dimensions.push(arg);
            } else {
              throw new TypeError('Dimension must be an Array, Matrix, number, string, or Range');
            } // TODO: implement support for wildcard '*'

          }
        }
        /**
         * Attach type information
         */


        Index.prototype.type = 'Index';
        Index.prototype.isIndex = true;

        function _createImmutableMatrix(arg) {
          // loop array elements
          for (var i = 0, l = arg.length; i < l; i++) {
            if (typeof arg[i] !== 'number' || !isInteger(arg[i])) {
              throw new TypeError('Index parameters must be positive integer numbers');
            }
          } // create matrix


          return new type.ImmutableDenseMatrix(arg);
        }
        /**
         * Create a clone of the index
         * @memberof Index
         * @return {Index} clone
         */


        Index.prototype.clone = function () {
          var index = new Index();
          index._dimensions = clone(this._dimensions);
          index._isScalar = this._isScalar;
          return index;
        };
        /**
         * Create an index from an array with ranges/numbers
         * @memberof Index
         * @param {Array.<Array | number>} ranges
         * @return {Index} index
         * @private
         */


        Index.create = function (ranges) {
          var index = new Index();
          Index.apply(index, ranges);
          return index;
        };
        /**
         * Retrieve the size of the index, the number of elements for each dimension.
         * @memberof Index
         * @returns {number[]} size
         */


        Index.prototype.size = function () {
          var size = [];

          for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
            var d = this._dimensions[i];
            size[i] = typeof d === 'string' ? 1 : d.size()[0];
          }

          return size;
        };
        /**
         * Get the maximum value for each of the indexes ranges.
         * @memberof Index
         * @returns {number[]} max
         */


        Index.prototype.max = function () {
          var values = [];

          for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
            var range = this._dimensions[i];
            values[i] = typeof range === 'string' ? range : range.max();
          }

          return values;
        };
        /**
         * Get the minimum value for each of the indexes ranges.
         * @memberof Index
         * @returns {number[]} min
         */


        Index.prototype.min = function () {
          var values = [];

          for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
            var range = this._dimensions[i];
            values[i] = typeof range === 'string' ? range : range.min();
          }

          return values;
        };
        /**
         * Loop over each of the ranges of the index
         * @memberof Index
         * @param {Function} callback   Called for each range with a Range as first
         *                              argument, the dimension as second, and the
         *                              index object as third.
         */


        Index.prototype.forEach = function (callback) {
          for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
            callback(this._dimensions[i], i, this);
          }
        };
        /**
         * Retrieve the dimension for the given index
         * @memberof Index
         * @param {Number} dim                  Number of the dimension
         * @returns {Range | null} range
         */


        Index.prototype.dimension = function (dim) {
          return this._dimensions[dim] || null;
        };
        /**
         * Test whether this index contains an object property
         * @returns {boolean} Returns true if the index is an object property
         */


        Index.prototype.isObjectProperty = function () {
          return this._dimensions.length === 1 && typeof this._dimensions[0] === 'string';
        };
        /**
         * Returns the object property name when the Index holds a single object property,
         * else returns null
         * @returns {string | null}
         */


        Index.prototype.getObjectProperty = function () {
          return this.isObjectProperty() ? this._dimensions[0] : null;
        };
        /**
         * Test whether this index contains only a single value.
         *
         * This is the case when the index is created with only scalar values as ranges,
         * not for ranges resolving into a single value.
         * @memberof Index
         * @return {boolean} isScalar
         */


        Index.prototype.isScalar = function () {
          return this._isScalar;
        };
        /**
         * Expand the Index into an array.
         * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
         * @memberof Index
         * @returns {Array} array
         */


        Index.prototype.toArray = function () {
          var array = [];

          for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
            var dimension = this._dimensions[i];
            array.push(typeof dimension === 'string' ? dimension : dimension.toArray());
          }

          return array;
        };
        /**
         * Get the primitive value of the Index, a two dimensional array.
         * Equivalent to Index.toArray().
         * @memberof Index
         * @returns {Array} array
         */


        Index.prototype.valueOf = Index.prototype.toArray;
        /**
         * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
         * @memberof Index
         * @returns {String} str
         */

        Index.prototype.toString = function () {
          var strings = [];

          for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
            var dimension = this._dimensions[i];

            if (typeof dimension === 'string') {
              strings.push(JSON.stringify(dimension));
            } else {
              strings.push(dimension.toString());
            }
          }

          return '[' + strings.join(', ') + ']';
        };
        /**
         * Get a JSON representation of the Index
         * @memberof Index
         * @returns {Object} Returns a JSON object structured as:
         *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
         */


        Index.prototype.toJSON = function () {
          return {
            mathjs: 'Index',
            dimensions: this._dimensions
          };
        };
        /**
         * Instantiate an Index from a JSON object
         * @memberof Index
         * @param {Object} json A JSON object structured as:
         *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
         * @return {Index}
         */


        Index.fromJSON = function (json) {
          return Index.create(json.dimensions);
        };

        return Index;
      }

      exports.name = 'Index';
      exports.path = 'type';
      exports.factory = factory;
      /***/
    },
    /* 301 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var util = __webpack_require__(151);

      var string = util.string;
      var isString = string.isString;

      function factory(type, config, load, typed) {
        /**
         * @constructor Matrix
         *
         * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
         * array. A matrix can be constructed as:
         *
         *     let matrix = math.matrix(data)
         *
         * Matrix contains the functions to resize, get and set values, get the size,
         * clone the matrix and to convert the matrix to a vector, array, or scalar.
         * Furthermore, one can iterate over the matrix using map and forEach.
         * The internal Array of the Matrix can be accessed using the function valueOf.
         *
         * Example usage:
         *
         *     let matrix = math.matrix([[1, 2], [3, 4]])
         *     matix.size()              // [2, 2]
         *     matrix.resize([3, 2], 5)
         *     matrix.valueOf()          // [[1, 2], [3, 4], [5, 5]]
         *     matrix.subset([1,2])       // 3 (indexes are zero-based)
         *
         */
        function Matrix() {
          if (!(this instanceof Matrix)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }
        }
        /**
         * Attach type information
         */


        Matrix.prototype.type = 'Matrix';
        Matrix.prototype.isMatrix = true;
        /**
         * Get the Matrix storage constructor for the given format.
         *
         * @param {string} format       The Matrix storage format.
         *
         * @return {Function}           The Matrix storage constructor.
         */

        Matrix.storage = function (format) {
          // check storage format is a string
          if (!isString(format)) {
            throw new TypeError('format must be a string value');
          } // get storage format constructor


          var constructor = Matrix._storage[format];

          if (!constructor) {
            throw new SyntaxError('Unsupported matrix storage format: ' + format);
          } // return storage constructor


          return constructor;
        }; // a map with all constructors for all storage types


        Matrix._storage = {};
        /**
         * Get the storage format used by the matrix.
         *
         * Usage:
         *     const format = matrix.storage()   // retrieve storage format
         *
         * @return {string}           The storage format.
         */

        Matrix.prototype.storage = function () {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke storage on a Matrix interface');
        };
        /**
         * Get the datatype of the data stored in the matrix.
         *
         * Usage:
         *     const format = matrix.datatype()    // retrieve matrix datatype
         *
         * @return {string}           The datatype.
         */


        Matrix.prototype.datatype = function () {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke datatype on a Matrix interface');
        };
        /**
         * Create a new Matrix With the type of the current matrix instance
         * @param {Array | Object} data
         * @param {string} [datatype]
         */


        Matrix.prototype.create = function (data, datatype) {
          throw new Error('Cannot invoke create on a Matrix interface');
        };
        /**
         * Get a subset of the matrix, or replace a subset of the matrix.
         *
         * Usage:
         *     const subset = matrix.subset(index)               // retrieve subset
         *     const value = matrix.subset(index, replacement)   // replace subset
         *
         * @param {Index} index
         * @param {Array | Matrix | *} [replacement]
         * @param {*} [defaultValue=0]      Default value, filled in on new entries when
         *                                  the matrix is resized. If not provided,
         *                                  new matrix elements will be filled with zeros.
         */


        Matrix.prototype.subset = function (index, replacement, defaultValue) {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke subset on a Matrix interface');
        };
        /**
         * Get a single element from the matrix.
         * @param {number[]} index   Zero-based index
         * @return {*} value
         */


        Matrix.prototype.get = function (index) {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke get on a Matrix interface');
        };
        /**
         * Replace a single element in the matrix.
         * @param {number[]} index   Zero-based index
         * @param {*} value
         * @param {*} [defaultValue]        Default value, filled in on new entries when
         *                                  the matrix is resized. If not provided,
         *                                  new matrix elements will be left undefined.
         * @return {Matrix} self
         */


        Matrix.prototype.set = function (index, value, defaultValue) {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke set on a Matrix interface');
        };
        /**
         * Resize the matrix to the given size. Returns a copy of the matrix when
         * `copy=true`, otherwise return the matrix itself (resize in place).
         *
         * @param {number[]} size           The new size the matrix should have.
         * @param {*} [defaultValue=0]      Default value, filled in on new entries.
         *                                  If not provided, the matrix elements will
         *                                  be filled with zeros.
         * @param {boolean} [copy]          Return a resized copy of the matrix
         *
         * @return {Matrix}                 The resized matrix
         */


        Matrix.prototype.resize = function (size, defaultValue) {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke resize on a Matrix interface');
        };
        /**
         * Reshape the matrix to the given size. Returns a copy of the matrix when
         * `copy=true`, otherwise return the matrix itself (reshape in place).
         *
         * @param {number[]} size           The new size the matrix should have.
         * @param {boolean} [copy]          Return a reshaped copy of the matrix
         *
         * @return {Matrix}                 The reshaped matrix
         */


        Matrix.prototype.reshape = function (size, defaultValue) {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke reshape on a Matrix interface');
        };
        /**
         * Create a clone of the matrix
         * @return {Matrix} clone
         */


        Matrix.prototype.clone = function () {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke clone on a Matrix interface');
        };
        /**
         * Retrieve the size of the matrix.
         * @returns {number[]} size
         */


        Matrix.prototype.size = function () {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke size on a Matrix interface');
        };
        /**
         * Create a new matrix with the results of the callback function executed on
         * each entry of the matrix.
         * @param {Function} callback   The callback function is invoked with three
         *                              parameters: the value of the element, the index
         *                              of the element, and the Matrix being traversed.
         * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
         *
         * @return {Matrix} matrix
         */


        Matrix.prototype.map = function (callback, skipZeros) {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke map on a Matrix interface');
        };
        /**
         * Execute a callback function on each entry of the matrix.
         * @param {Function} callback   The callback function is invoked with three
         *                              parameters: the value of the element, the index
         *                              of the element, and the Matrix being traversed.
         */


        Matrix.prototype.forEach = function (callback) {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke forEach on a Matrix interface');
        };
        /**
         * Create an Array with a copy of the data of the Matrix
         * @returns {Array} array
         */


        Matrix.prototype.toArray = function () {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke toArray on a Matrix interface');
        };
        /**
         * Get the primitive value of the Matrix: a multidimensional array
         * @returns {Array} array
         */


        Matrix.prototype.valueOf = function () {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke valueOf on a Matrix interface');
        };
        /**
         * Get a string representation of the matrix, with optional formatting options.
         * @param {Object | number | Function} [options]  Formatting options. See
         *                                                lib/utils/number:format for a
         *                                                description of the available
         *                                                options.
         * @returns {string} str
         */


        Matrix.prototype.format = function (options) {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke format on a Matrix interface');
        };
        /**
         * Get a string representation of the matrix
         * @returns {string} str
         */


        Matrix.prototype.toString = function () {
          // must be implemented by each of the Matrix implementations
          throw new Error('Cannot invoke toString on a Matrix interface');
        }; // exports


        return Matrix;
      }

      exports.name = 'Matrix';
      exports.path = 'type';
      exports.factory = factory;
      /***/
    },
    /* 302 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var numeric = load(__webpack_require__(412));
        var getTypeOf = load(__webpack_require__(131));
        /**
         * Divide two scalar values, `x / y`.
         * This function is meant for internal use: it is used by the public functions
         * `divide` and `inv`.
         *
         * This function does not support collections (Array or Matrix), and does
         * not validate the number of of inputs.
         *
         * @param  {number | BigNumber | Fraction | Complex | Unit} x   Numerator
         * @param  {number | BigNumber | Fraction | Complex} y          Denominator
         * @return {number | BigNumber | Fraction | Complex | Unit}                      Quotient, `x / y`
         * @private
         */

        var divideScalar = typed('divide', {
          'number, number': function numberNumber(x, y) {
            return x / y;
          },
          'Complex, Complex': function ComplexComplex(x, y) {
            return x.div(y);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.div(y);
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return x.div(y);
          },
          'Unit, number | Fraction | BigNumber': function UnitNumberFractionBigNumber(x, y) {
            var res = x.clone(); // TODO: move the divide function to Unit.js, it uses internals of Unit

            var one = numeric(1, getTypeOf(y));
            res.value = divideScalar(res.value === null ? res._normalize(one) : res.value, y);
            return res;
          },
          'number | Fraction | BigNumber, Unit': function numberFractionBigNumberUnit(x, y) {
            var res = y.clone();
            res = res.pow(-1); // TODO: move the divide function to Unit.js, it uses internals of Unit

            var one = numeric(1, getTypeOf(x));
            res.value = divideScalar(x, y.value === null ? y._normalize(one) : y.value);
            return res;
          },
          'Unit, Unit': function UnitUnit(x, y) {
            return x.divide(y);
          }
        });
        return divideScalar;
      }

      exports.factory = factory;
      /***/
    },
    /* 303 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        /**
         * Multiply two scalar values, `x * y`.
         * This function is meant for internal use: it is used by the public function
         * `multiply`
         *
         * This function does not support collections (Array or Matrix), and does
         * not validate the number of of inputs.
         *
         * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to multiply
         * @param  {number | BigNumber | Fraction | Complex} y          Second value to multiply
         * @return {number | BigNumber | Fraction | Complex | Unit}                      Multiplication of `x` and `y`
         * @private
         */
        var multiplyScalar = typed('multiplyScalar', {
          'number, number': function numberNumber(x, y) {
            return x * y;
          },
          'Complex, Complex': function ComplexComplex(x, y) {
            return x.mul(y);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.times(y);
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return x.mul(y);
          },
          'number | Fraction | BigNumber | Complex, Unit': function numberFractionBigNumberComplexUnit(x, y) {
            var res = y.clone();
            res.value = res.value === null ? res._normalize(x) : multiplyScalar(res.value, x);
            return res;
          },
          'Unit, number | Fraction | BigNumber | Complex': function UnitNumberFractionBigNumberComplex(x, y) {
            var res = x.clone();
            res.value = res.value === null ? res._normalize(y) : multiplyScalar(res.value, y);
            return res;
          },
          'Unit, Unit': function UnitUnit(x, y) {
            return x.multiply(y);
          }
        });
        return multiplyScalar;
      }

      exports.factory = factory;
      /***/
    },
    /* 304 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var DimensionError = __webpack_require__(92);

      function factory(type, config, load, typed) {
        var equalScalar = load(__webpack_require__(125));
        var SparseMatrix = type.SparseMatrix;
        /**
         * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
         * Callback function invoked MAX(NNZA, NNZB) times
         *
         *
         *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 || B(i,j) !== 0
         * C(i,j) = ┤
         *          └  0            ; otherwise
         *
         *
         * @param {Matrix}   a                 The SparseMatrix instance (A)
         * @param {Matrix}   b                 The SparseMatrix instance (B)
         * @param {Function} callback          The f(Aij,Bij) operation to invoke
         *
         * @return {Matrix}                    SparseMatrix (C)
         *
         * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
         */

        var algorithm05 = function algorithm05(a, b, callback) {
          // sparse matrix arrays
          var avalues = a._values;
          var aindex = a._index;
          var aptr = a._ptr;
          var asize = a._size;
          var adt = a._datatype; // sparse matrix arrays

          var bvalues = b._values;
          var bindex = b._index;
          var bptr = b._ptr;
          var bsize = b._size;
          var bdt = b._datatype; // validate dimensions

          if (asize.length !== bsize.length) {
            throw new DimensionError(asize.length, bsize.length);
          } // check rows & columns


          if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) {
            throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
          } // rows & columns


          var rows = asize[0];
          var columns = asize[1]; // datatype

          var dt; // equal signature to use

          var eq = equalScalar; // zero value

          var zero = 0; // callback signature to use

          var cf = callback; // process data types

          if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)

            eq = typed.find(equalScalar, [dt, dt]); // convert 0 to the same datatype

            zero = typed.convert(0, dt); // callback

            cf = typed.find(callback, [dt, dt]);
          } // result arrays


          var cvalues = avalues && bvalues ? [] : undefined;
          var cindex = [];
          var cptr = []; // matrix

          var c = new SparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [rows, columns],
            datatype: dt
          }); // workspaces

          var xa = cvalues ? [] : undefined;
          var xb = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column

          var wa = [];
          var wb = []; // vars

          var i, j, k, k1; // loop columns

          for (j = 0; j < columns; j++) {
            // update cptr
            cptr[j] = cindex.length; // columns mark

            var mark = j + 1; // loop values A(:,j)

            for (k = aptr[j], k1 = aptr[j + 1]; k < k1; k++) {
              // row
              i = aindex[k]; // push index

              cindex.push(i); // update workspace

              wa[i] = mark; // check we need to process values

              if (xa) {
                xa[i] = avalues[k];
              }
            } // loop values B(:,j)


            for (k = bptr[j], k1 = bptr[j + 1]; k < k1; k++) {
              // row
              i = bindex[k]; // check row existed in A

              if (wa[i] !== mark) {
                // push index
                cindex.push(i);
              } // update workspace


              wb[i] = mark; // check we need to process values

              if (xb) {
                xb[i] = bvalues[k];
              }
            } // check we need to process values (non pattern matrix)


            if (cvalues) {
              // initialize first index in j
              k = cptr[j]; // loop index in j

              while (k < cindex.length) {
                // row
                i = cindex[k]; // marks

                var wai = wa[i];
                var wbi = wb[i]; // check Aij or Bij are nonzero

                if (wai === mark || wbi === mark) {
                  // matrix values @ i,j
                  var va = wai === mark ? xa[i] : zero;
                  var vb = wbi === mark ? xb[i] : zero; // Cij

                  var vc = cf(va, vb); // check for zero

                  if (!eq(vc, zero)) {
                    // push value
                    cvalues.push(vc); // increment pointer

                    k++;
                  } else {
                    // remove value @ i, do not increment pointer
                    cindex.splice(k, 1);
                  }
                }
              }
            }
          } // update cptr


          cptr[columns] = cindex.length; // return sparse matrix

          return c;
        };

        return algorithm05;
      }

      exports.name = 'algorithm05';
      exports.factory = factory;
      /***/
    },
    /* 305 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var clone = __webpack_require__(59).clone;

      var validateIndex = __webpack_require__(48).validateIndex;

      var getSafeProperty = __webpack_require__(88).getSafeProperty;

      var setSafeProperty = __webpack_require__(88).setSafeProperty;

      var DimensionError = __webpack_require__(92);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        /**
         * Get or set a subset of a matrix or string.
         *
         * Syntax:
         *     math.subset(value, index)                                // retrieve a subset
         *     math.subset(value, index, replacement [, defaultValue])  // replace a subset
         *
         * Examples:
         *
         *     // get a subset
         *     const d = [[1, 2], [3, 4]]
         *     math.subset(d, math.index(1, 0))        // returns 3
         *     math.subset(d, math.index([0, 1], 1))   // returns [[2], [4]]
         *
         *     // replace a subset
         *     const e = []
         *     const f = math.subset(e, math.index(0, [0, 2]), [5, 6])  // f = [[5, 6]]
         *     const g = math.subset(f, math.index(1, 1), 7, 0)         // g = [[5, 6], [0, 7]]
         *
         * See also:
         *
         *     size, resize, squeeze, index
         *
         * @param {Array | Matrix | string} matrix  An array, matrix, or string
         * @param {Index} index                     An index containing ranges for each
         *                                          dimension
         * @param {*} [replacement]                 An array, matrix, or scalar.
         *                                          If provided, the subset is replaced with replacement.
         *                                          If not provided, the subset is returned
         * @param {*} [defaultValue=undefined]      Default value, filled in on new entries when
         *                                          the matrix is resized. If not provided,
         *                                          math.matrix elements will be left undefined.
         * @return {Array | Matrix | string} Either the retrieved subset or the updated matrix.
         */

        var subset = typed('subset', {
          // get subset
          'Array, Index': function ArrayIndex(value, index) {
            var m = matrix(value);
            var subset = m.subset(index); // returns a Matrix

            return index.isScalar() ? subset : subset.valueOf(); // return an Array (like the input)
          },
          'Matrix, Index': function MatrixIndex(value, index) {
            return value.subset(index);
          },
          'Object, Index': _getObjectProperty,
          'string, Index': _getSubstring,
          // set subset
          'Array, Index, any': function ArrayIndexAny(value, index, replacement) {
            return matrix(clone(value)).subset(index, replacement, undefined).valueOf();
          },
          'Array, Index, any, any': function ArrayIndexAnyAny(value, index, replacement, defaultValue) {
            return matrix(clone(value)).subset(index, replacement, defaultValue).valueOf();
          },
          'Matrix, Index, any': function MatrixIndexAny(value, index, replacement) {
            return value.clone().subset(index, replacement);
          },
          'Matrix, Index, any, any': function MatrixIndexAnyAny(value, index, replacement, defaultValue) {
            return value.clone().subset(index, replacement, defaultValue);
          },
          'string, Index, string': _setSubstring,
          'string, Index, string, string': _setSubstring,
          'Object, Index, any': _setObjectProperty
        });
        subset.toTex = undefined; // use default template

        return subset;
        /**
         * Retrieve a subset of a string
         * @param {string} str            string from which to get a substring
         * @param {Index} index           An index containing ranges for each dimension
         * @returns {string} substring
         * @private
         */

        function _getSubstring(str, index) {
          if (!type.isIndex(index)) {
            // TODO: better error message
            throw new TypeError('Index expected');
          }

          if (index.size().length !== 1) {
            throw new DimensionError(index.size().length, 1);
          } // validate whether the range is out of range


          var strLen = str.length;
          validateIndex(index.min()[0], strLen);
          validateIndex(index.max()[0], strLen);
          var range = index.dimension(0);
          var substr = '';
          range.forEach(function (v) {
            substr += str.charAt(v);
          });
          return substr;
        }
        /**
         * Replace a substring in a string
         * @param {string} str            string to be replaced
         * @param {Index} index           An index containing ranges for each dimension
         * @param {string} replacement    Replacement string
         * @param {string} [defaultValue] Default value to be uses when resizing
         *                                the string. is ' ' by default
         * @returns {string} result
         * @private
         */


        function _setSubstring(str, index, replacement, defaultValue) {
          if (!index || index.isIndex !== true) {
            // TODO: better error message
            throw new TypeError('Index expected');
          }

          if (index.size().length !== 1) {
            throw new DimensionError(index.size().length, 1);
          }

          if (defaultValue !== undefined) {
            if (typeof defaultValue !== 'string' || defaultValue.length !== 1) {
              throw new TypeError('Single character expected as defaultValue');
            }
          } else {
            defaultValue = ' ';
          }

          var range = index.dimension(0);
          var len = range.size()[0];

          if (len !== replacement.length) {
            throw new DimensionError(range.size()[0], replacement.length);
          } // validate whether the range is out of range


          var strLen = str.length;
          validateIndex(index.min()[0]);
          validateIndex(index.max()[0]); // copy the string into an array with characters

          var chars = [];

          for (var i = 0; i < strLen; i++) {
            chars[i] = str.charAt(i);
          }

          range.forEach(function (v, i) {
            chars[v] = replacement.charAt(i[0]);
          }); // initialize undefined characters with a space

          if (chars.length > strLen) {
            for (var _i = strLen - 1, _len = chars.length; _i < _len; _i++) {
              if (!chars[_i]) {
                chars[_i] = defaultValue;
              }
            }
          }

          return chars.join('');
        }
      }
      /**
       * Retrieve a property from an object
       * @param {Object} object
       * @param {Index} index
       * @return {*} Returns the value of the property
       * @private
       */


      function _getObjectProperty(object, index) {
        if (index.size().length !== 1) {
          throw new DimensionError(index.size(), 1);
        }

        var key = index.dimension(0);

        if (typeof key !== 'string') {
          throw new TypeError('String expected as index to retrieve an object property');
        }

        return getSafeProperty(object, key);
      }
      /**
       * Set a property on an object
       * @param {Object} object
       * @param {Index} index
       * @param {*} replacement
       * @return {*} Returns the updated object
       * @private
       */


      function _setObjectProperty(object, index, replacement) {
        if (index.size().length !== 1) {
          throw new DimensionError(index.size(), 1);
        }

        var key = index.dimension(0);

        if (typeof key !== 'string') {
          throw new TypeError('String expected as index to retrieve an object property');
        } // clone the object, and apply the property to the clone


        var updated = clone(object);
        setSafeProperty(updated, key, replacement);
        return updated;
      }

      exports.name = 'subset';
      exports.factory = factory;
      /***/
    },
    /* 306 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        /**
         * Create a number or convert a string, boolean, or unit to a number.
         * When value is a matrix, all elements will be converted to number.
         *
         * Syntax:
         *
         *    math.number(value)
         *    math.number(unit, valuelessUnit)
         *
         * Examples:
         *
         *    math.number(2)                         // returns number 2
         *    math.number('7.2')                     // returns number 7.2
         *    math.number(true)                      // returns number 1
         *    math.number([true, false, true, true]) // returns [1, 0, 1, 1]
         *    math.number(math.unit('52cm'), 'm')    // returns 0.52
         *
         * See also:
         *
         *    bignumber, boolean, complex, index, matrix, string, unit
         *
         * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
         * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
         * @return {number | Array | Matrix} The created number
         */
        var number = typed('number', {
          '': function _() {
            return 0;
          },
          'number': function number(x) {
            return x;
          },
          'string': function string(x) {
            if (x === 'NaN') return NaN;
            var num = Number(x);

            if (isNaN(num)) {
              throw new SyntaxError('String "' + x + '" is no valid number');
            }

            return num;
          },
          'BigNumber': function BigNumber(x) {
            return x.toNumber();
          },
          'Fraction': function Fraction(x) {
            return x.valueOf();
          },
          'Unit': function Unit(x) {
            throw new Error('Second argument with valueless unit expected');
          },
          'null': function _null(x) {
            return 0;
          },
          'Unit, string | Unit': function UnitStringUnit(unit, valuelessUnit) {
            return unit.toNumber(valuelessUnit);
          },
          'Array | Matrix': function ArrayMatrix(x) {
            return deepMap(x, number);
          }
        });
        number.toTex = {
          0: "0",
          1: "\\left(${args[0]}\\right)",
          2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
        };
        return number;
      }

      exports.name = 'number';
      exports.factory = factory;
      /***/
    },
    /* 307 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Create a syntax error with the message:
       *     'Wrong number of arguments in function <fn> (<count> provided, <min>-<max> expected)'
       * @param {string} fn     Function name
       * @param {number} count  Actual argument count
       * @param {number} min    Minimum required argument count
       * @param {number} [max]  Maximum required argument count
       * @extends Error
       */

      function ArgumentsError(fn, count, min, max) {
        if (!(this instanceof ArgumentsError)) {
          throw new SyntaxError('Constructor must be called with the new operator');
        }

        this.fn = fn;
        this.count = count;
        this.min = min;
        this.max = max;
        this.message = 'Wrong number of arguments in function ' + fn + ' (' + count + ' provided, ' + min + (max !== undefined && max !== null ? '-' + max : '') + ' expected)';
        this.stack = new Error().stack;
      }

      ArgumentsError.prototype = new Error();
      ArgumentsError.prototype.constructor = Error;
      ArgumentsError.prototype.name = 'ArgumentsError';
      ArgumentsError.prototype.isArgumentsError = true;
      module.exports = ArgumentsError;
      /***/
    },
    /* 308 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Test whether a value is a BigNumber
       * @param {*} x
       * @return {boolean}
       */

      module.exports = function isBigNumber(x) {
        return x && x.constructor.prototype.isBigNumber || false;
      };
      /***/

    },
    /* 309 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (process) {
        var utils = __webpack_require__(101);

        var normalizeHeaderName = __webpack_require__(822);

        var DEFAULT_CONTENT_TYPE = {
          'Content-Type': 'application/x-www-form-urlencoded'
        };

        function setContentTypeIfUnset(headers, value) {
          if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
            headers['Content-Type'] = value;
          }
        }

        function getDefaultAdapter() {
          var adapter;

          if (typeof XMLHttpRequest !== 'undefined') {
            // For browsers use XHR adapter
            adapter = __webpack_require__(419);
          } else if (typeof process !== 'undefined') {
            // For node use HTTP adapter
            adapter = __webpack_require__(419);
          }

          return adapter;
        }

        var defaults = {
          adapter: getDefaultAdapter(),
          transformRequest: [function transformRequest(data, headers) {
            normalizeHeaderName(headers, 'Content-Type');

            if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
              return data;
            }

            if (utils.isArrayBufferView(data)) {
              return data.buffer;
            }

            if (utils.isURLSearchParams(data)) {
              setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
              return data.toString();
            }

            if (utils.isObject(data)) {
              setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
              return JSON.stringify(data);
            }

            return data;
          }],
          transformResponse: [function transformResponse(data) {
            /*eslint no-param-reassign:0*/
            if (typeof data === 'string') {
              try {
                data = JSON.parse(data);
              } catch (e) {
                /* Ignore */
              }
            }

            return data;
          }],
          timeout: 0,
          xsrfCookieName: 'XSRF-TOKEN',
          xsrfHeaderName: 'X-XSRF-TOKEN',
          maxContentLength: -1,
          validateStatus: function validateStatus(status) {
            return status >= 200 && status < 300;
          }
        };
        defaults.headers = {
          common: {
            'Accept': 'application/json, text/plain, */*'
          }
        };
        utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
          defaults.headers[method] = {};
        });
        utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
          defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
        });
        module.exports = defaults;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(162));
      /***/
    },
    /* 310 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _warning = __webpack_require__(73);

      var _warning2 = _interopRequireDefault(_warning);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var warned = {};

      exports['default'] = function (valid, message) {
        if (!valid && !warned[message]) {
          (0, _warning2['default'])(false, message);
          warned[message] = true;
        }
      };

      module.exports = exports['default'];
      /***/
    },
    /* 311 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _reactDom = __webpack_require__(16);

      var _reactDom2 = _interopRequireDefault(_reactDom);

      var _createReactClass = __webpack_require__(32);

      var _createReactClass2 = _interopRequireDefault(_createReactClass);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _createChainedFunction = __webpack_require__(844);

      var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

      var _KeyCode = __webpack_require__(236);

      var _KeyCode2 = _interopRequireDefault(_KeyCode);

      var _placements = __webpack_require__(843);

      var _placements2 = _interopRequireDefault(_placements);

      var _rcTrigger = __webpack_require__(75);

      var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function noop() {}

      function refFn(field, component) {
        this[field] = component;
      }

      var Picker = (0, _createReactClass2['default'])({
        displayName: 'Picker',
        propTypes: {
          animation: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].string]),
          disabled: _propTypes2['default'].bool,
          transitionName: _propTypes2['default'].string,
          onChange: _propTypes2['default'].func,
          onOpenChange: _propTypes2['default'].func,
          children: _propTypes2['default'].func,
          getCalendarContainer: _propTypes2['default'].func,
          calendar: _propTypes2['default'].element,
          style: _propTypes2['default'].object,
          open: _propTypes2['default'].bool,
          defaultOpen: _propTypes2['default'].bool,
          prefixCls: _propTypes2['default'].string,
          placement: _propTypes2['default'].any,
          value: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
          defaultValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
          align: _propTypes2['default'].object
        },
        getDefaultProps: function getDefaultProps() {
          return {
            prefixCls: 'rc-calendar-picker',
            style: {},
            align: {},
            placement: 'bottomLeft',
            defaultOpen: false,
            onChange: noop,
            onOpenChange: noop
          };
        },
        getInitialState: function getInitialState() {
          var props = this.props;
          var open = void 0;

          if ('open' in props) {
            open = props.open;
          } else {
            open = props.defaultOpen;
          }

          var value = props.value || props.defaultValue;
          this.saveCalendarRef = refFn.bind(this, 'calendarInstance');
          return {
            open: open,
            value: value
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          var value = nextProps.value,
              open = nextProps.open;

          if ('value' in nextProps) {
            this.setState({
              value: value
            });
          }

          if (open !== undefined) {
            this.setState({
              open: open
            });
          }
        },
        componentDidUpdate: function componentDidUpdate(_, prevState) {
          if (!prevState.open && this.state.open) {
            // setTimeout is for making sure saveCalendarRef happen before focusCalendar
            this.focusTimeout = setTimeout(this.focusCalendar, 0, this);
          }
        },
        componentWillUnmount: function componentWillUnmount() {
          clearTimeout(this.focusTimeout);
        },
        onCalendarKeyDown: function onCalendarKeyDown(event) {
          if (event.keyCode === _KeyCode2['default'].ESC) {
            event.stopPropagation();
            this.close(this.focus);
          }
        },
        onCalendarSelect: function onCalendarSelect(value) {
          var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var props = this.props;

          if (!('value' in props)) {
            this.setState({
              value: value
            });
          }

          if (cause.source === 'keyboard' || !props.calendar.props.timePicker && cause.source !== 'dateInput' || cause.source === 'todayButton') {
            this.close(this.focus);
          }

          props.onChange(value);
        },
        onKeyDown: function onKeyDown(event) {
          if (event.keyCode === _KeyCode2['default'].DOWN && !this.state.open) {
            this.open();
            event.preventDefault();
          }
        },
        onCalendarOk: function onCalendarOk() {
          this.close(this.focus);
        },
        onCalendarClear: function onCalendarClear() {
          this.close(this.focus);
        },
        onVisibleChange: function onVisibleChange(open) {
          this.setOpen(open);
        },
        getCalendarElement: function getCalendarElement() {
          var props = this.props;
          var state = this.state;
          var calendarProps = props.calendar.props;
          var value = state.value;
          var defaultValue = value;
          var extraProps = {
            ref: this.saveCalendarRef,
            defaultValue: defaultValue || calendarProps.defaultValue,
            selectedValue: value,
            onKeyDown: this.onCalendarKeyDown,
            onOk: (0, _createChainedFunction2['default'])(calendarProps.onOk, this.onCalendarOk),
            onSelect: (0, _createChainedFunction2['default'])(calendarProps.onSelect, this.onCalendarSelect),
            onClear: (0, _createChainedFunction2['default'])(calendarProps.onClear, this.onCalendarClear)
          };
          return _react2['default'].cloneElement(props.calendar, extraProps);
        },
        setOpen: function setOpen(open, callback) {
          var onOpenChange = this.props.onOpenChange;

          if (this.state.open !== open) {
            if (!('open' in this.props)) {
              this.setState({
                open: open
              }, callback);
            }

            onOpenChange(open);
          }
        },
        open: function open(callback) {
          this.setOpen(true, callback);
        },
        close: function close(callback) {
          this.setOpen(false, callback);
        },
        focus: function focus() {
          if (!this.state.open) {
            _reactDom2['default'].findDOMNode(this).focus();
          }
        },
        focusCalendar: function focusCalendar() {
          if (this.state.open && !!this.calendarInstance) {
            this.calendarInstance.focus();
          }
        },
        render: function render() {
          var props = this.props;
          var prefixCls = props.prefixCls,
              placement = props.placement,
              style = props.style,
              getCalendarContainer = props.getCalendarContainer,
              align = props.align,
              animation = props.animation,
              disabled = props.disabled,
              dropdownClassName = props.dropdownClassName,
              transitionName = props.transitionName,
              children = props.children;
          var state = this.state;
          return _react2['default'].createElement(_rcTrigger2['default'], {
            popup: this.getCalendarElement(),
            popupAlign: align,
            builtinPlacements: _placements2['default'],
            popupPlacement: placement,
            action: disabled && !state.open ? [] : ['click'],
            destroyPopupOnHide: true,
            getPopupContainer: getCalendarContainer,
            popupStyle: style,
            popupAnimation: animation,
            popupTransitionName: transitionName,
            popupVisible: state.open,
            onPopupVisibleChange: this.onVisibleChange,
            prefixCls: prefixCls,
            popupClassName: dropdownClassName
          }, _react2['default'].cloneElement(children(state, props), {
            onKeyDown: this.onKeyDown
          }));
        }
      });
      exports['default'] = Picker;
      module.exports = exports['default'];
      /***/
    },
    /* 312 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _rcTooltip = __webpack_require__(373);

      var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _placements = __webpack_require__(865);

      var _placements2 = _interopRequireDefault(_placements);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var splitObject = function splitObject(obj, keys) {
        var picked = {};
        var omited = (0, _extends3['default'])({}, obj);
        keys.forEach(function (key) {
          if (obj && key in obj) {
            picked[key] = obj[key];
            delete omited[key];
          }
        });
        return {
          picked: picked,
          omited: omited
        };
      };

      var Tooltip = function (_React$Component) {
        (0, _inherits3['default'])(Tooltip, _React$Component);

        function Tooltip(props) {
          (0, _classCallCheck3['default'])(this, Tooltip);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

          _this.onVisibleChange = function (visible) {
            var onVisibleChange = _this.props.onVisibleChange;

            if (!('visible' in _this.props)) {
              _this.setState({
                visible: _this.isNoTitle() ? false : visible
              });
            }

            if (onVisibleChange && !_this.isNoTitle()) {
              onVisibleChange(visible);
            }
          }; // 动态设置动画点


          _this.onPopupAlign = function (domNode, align) {
            var placements = _this.getPlacements(); // 当前返回的位置


            var placement = Object.keys(placements).filter(function (key) {
              return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
            })[0];

            if (!placement) {
              return;
            } // 根据当前坐标设置动画点


            var rect = domNode.getBoundingClientRect();
            var transformOrigin = {
              top: '50%',
              left: '50%'
            };

            if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
              transformOrigin.top = rect.height - align.offset[1] + 'px';
            } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
              transformOrigin.top = -align.offset[1] + 'px';
            }

            if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
              transformOrigin.left = rect.width - align.offset[0] + 'px';
            } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
              transformOrigin.left = -align.offset[0] + 'px';
            }

            domNode.style.transformOrigin = transformOrigin.left + ' ' + transformOrigin.top;
          };

          _this.saveTooltip = function (node) {
            _this.tooltip = node;
          };

          _this.state = {
            visible: !!props.visible || !!props.defaultVisible
          };
          return _this;
        }

        (0, _createClass3['default'])(Tooltip, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('visible' in nextProps) {
              this.setState({
                visible: nextProps.visible
              });
            }
          }
        }, {
          key: 'getPopupDomNode',
          value: function getPopupDomNode() {
            return this.tooltip.getPopupDomNode();
          }
        }, {
          key: 'getPlacements',
          value: function getPlacements() {
            var _props = this.props,
                builtinPlacements = _props.builtinPlacements,
                arrowPointAtCenter = _props.arrowPointAtCenter,
                autoAdjustOverflow = _props.autoAdjustOverflow;
            return builtinPlacements || (0, _placements2['default'])({
              arrowPointAtCenter: arrowPointAtCenter,
              verticalArrowShift: 8,
              autoAdjustOverflow: autoAdjustOverflow
            });
          }
        }, {
          key: 'isHoverTrigger',
          value: function isHoverTrigger() {
            var trigger = this.props.trigger;

            if (!trigger || trigger === 'hover') {
              return true;
            }

            if (Array.isArray(trigger)) {
              return trigger.indexOf('hover') >= 0;
            }

            return false;
          } // Fix Tooltip won't hide at disabled button
          // mouse events don't trigger at disabled button in Chrome
          // https://github.com/react-component/tooltip/issues/18

        }, {
          key: 'getDisabledCompatibleChildren',
          value: function getDisabledCompatibleChildren(element) {
            if ((element.type.__ANT_BUTTON || element.type === 'button') && element.props.disabled && this.isHoverTrigger()) {
              // Pick some layout related style properties up to span
              // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
              var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
                  picked = _splitObject.picked,
                  omited = _splitObject.omited;

              var spanStyle = (0, _extends3['default'])({
                display: 'inline-block'
              }, picked, {
                cursor: 'not-allowed'
              });
              var buttonStyle = (0, _extends3['default'])({}, omited, {
                pointerEvents: 'none'
              });
              var child = (0, _react.cloneElement)(element, {
                style: buttonStyle,
                className: null
              });
              return React.createElement('span', {
                style: spanStyle,
                className: element.props.className
              }, child);
            }

            return element;
          }
        }, {
          key: 'isNoTitle',
          value: function isNoTitle() {
            var _props2 = this.props,
                title = _props2.title,
                overlay = _props2.overlay;
            return !title && !overlay; // overlay for old version compatibility
          }
        }, {
          key: 'render',
          value: function render() {
            var props = this.props,
                state = this.state;
            var prefixCls = props.prefixCls,
                title = props.title,
                overlay = props.overlay,
                openClassName = props.openClassName,
                getPopupContainer = props.getPopupContainer,
                getTooltipContainer = props.getTooltipContainer;
            var children = props.children;
            var visible = state.visible; // Hide tooltip when there is no title

            if (!('visible' in props) && this.isNoTitle()) {
              visible = false;
            }

            var child = this.getDisabledCompatibleChildren(React.isValidElement(children) ? children : React.createElement('span', null, children));
            var childProps = child.props;
            var childCls = (0, _classnames2['default'])(childProps.className, (0, _defineProperty3['default'])({}, openClassName || prefixCls + '-open', true));
            return React.createElement(_rcTooltip2['default'], (0, _extends3['default'])({}, this.props, {
              getTooltipContainer: getPopupContainer || getTooltipContainer,
              ref: this.saveTooltip,
              builtinPlacements: this.getPlacements(),
              overlay: overlay || title || '',
              visible: visible,
              onVisibleChange: this.onVisibleChange,
              onPopupAlign: this.onPopupAlign
            }), visible ? (0, _react.cloneElement)(child, {
              className: childCls
            }) : child);
          }
        }]);
        return Tooltip;
      }(React.Component);

      exports['default'] = Tooltip;
      Tooltip.defaultProps = {
        prefixCls: 'ant-tooltip',
        placement: 'top',
        transitionName: 'zoom-big-fast',
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        arrowPointAtCenter: false,
        autoAdjustOverflow: true
      };
      module.exports = exports['default'];
      /***/
    },
    /* 313 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _toConsumableArray2 = __webpack_require__(65);

      var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

      exports.isDev = isDev;
      exports.isEventFromHandle = isEventFromHandle;
      exports.isValueOutOfRange = isValueOutOfRange;
      exports.isNotTouchEvent = isNotTouchEvent;
      exports.getClosestPoint = getClosestPoint;
      exports.getPrecision = getPrecision;
      exports.getMousePosition = getMousePosition;
      exports.getTouchPosition = getTouchPosition;
      exports.getHandleCenterPosition = getHandleCenterPosition;
      exports.ensureValueInRange = ensureValueInRange;
      exports.ensureValuePrecision = ensureValuePrecision;
      exports.pauseEvent = pauseEvent;
      exports.calculateNextValue = calculateNextValue;
      exports.getKeyboardValueMutator = getKeyboardValueMutator;

      var _reactDom = __webpack_require__(16);

      var _KeyCode = __webpack_require__(236);

      var _KeyCode2 = _interopRequireDefault(_KeyCode);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function isDev() {
        return "production" !== 'production';
      }

      function isEventFromHandle(e, handles) {
        try {
          return Object.keys(handles).some(function (key) {
            return e.target === (0, _reactDom.findDOMNode)(handles[key]);
          });
        } catch (error) {
          return false;
        }
      }

      function isValueOutOfRange(value, _ref) {
        var min = _ref.min,
            max = _ref.max;
        return value < min || value > max;
      }

      function isNotTouchEvent(e) {
        return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
      }

      function getClosestPoint(val, _ref2) {
        var marks = _ref2.marks,
            step = _ref2.step,
            min = _ref2.min,
            max = _ref2.max;
        var points = Object.keys(marks).map(parseFloat);

        if (step !== null) {
          var maxSteps = Math.floor((max - min) / step);
          var steps = Math.min((val - min) / step, maxSteps);
          var closestStep = Math.round(steps) * step + min;
          points.push(closestStep);
        }

        var diffs = points.map(function (point) {
          return Math.abs(val - point);
        });
        return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray3['default'])(diffs)))];
      }

      function getPrecision(step) {
        var stepString = step.toString();
        var precision = 0;

        if (stepString.indexOf('.') >= 0) {
          precision = stepString.length - stepString.indexOf('.') - 1;
        }

        return precision;
      }

      function getMousePosition(vertical, e) {
        return vertical ? e.clientY : e.pageX;
      }

      function getTouchPosition(vertical, e) {
        return vertical ? e.touches[0].clientY : e.touches[0].pageX;
      }

      function getHandleCenterPosition(vertical, handle) {
        var coords = handle.getBoundingClientRect();
        return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
      }

      function ensureValueInRange(val, _ref3) {
        var max = _ref3.max,
            min = _ref3.min;

        if (val <= min) {
          return min;
        }

        if (val >= max) {
          return max;
        }

        return val;
      }

      function ensureValuePrecision(val, props) {
        var step = props.step;
        var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line

        return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
      }

      function pauseEvent(e) {
        e.stopPropagation();
        e.preventDefault();
      }

      function calculateNextValue(func, value, props) {
        var operations = {
          increase: function increase(a, b) {
            return a + b;
          },
          decrease: function decrease(a, b) {
            return a - b;
          }
        };
        var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
        var keyToGet = Object.keys(props.marks)[indexToGet];

        if (props.step) {
          return operations[func](value, props.step);
        } else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
          return props.marks[keyToGet];
        }

        return value;
      }

      function getKeyboardValueMutator(e) {
        switch (e.keyCode) {
          case _KeyCode2['default'].UP:
          case _KeyCode2['default'].RIGHT:
            return function (value, props) {
              return calculateNextValue('increase', value, props);
            };

          case _KeyCode2['default'].DOWN:
          case _KeyCode2['default'].LEFT:
            return function (value, props) {
              return calculateNextValue('decrease', value, props);
            };

          case _KeyCode2['default'].END:
            return function (value, props) {
              return props.max;
            };

          case _KeyCode2['default'].HOME:
            return function (value, props) {
              return props.min;
            };

          case _KeyCode2['default'].PAGE_UP:
            return function (value, props) {
              return value + props.step * 2;
            };

          case _KeyCode2['default'].PAGE_DOWN:
            return function (value, props) {
              return value - props.step * 2;
            };

          default:
            return undefined;
        }
      }
      /***/

    },
    /* 314 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var Events = {
        registered: {},
        scrollEvent: {
          register: function register(evtName, callback) {
            Events.registered[evtName] = callback;
          },
          remove: function remove(evtName) {
            Events.registered[evtName] = null;
          }
        }
      };
      exports.default = Events;
      /***/
    },
    /* 315 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      /*
       * Tell the browser that the event listener won't prevent a scroll.
       * Allowing the browser to continue scrolling without having to
       * to wait for the listener to return.
       */

      var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
        var supportsPassiveOption = function () {
          var supportsPassiveOption = false;

          try {
            var opts = Object.defineProperty({}, 'passive', {
              get: function get() {
                supportsPassiveOption = true;
              }
            });
            window.addEventListener('test', null, opts);
          } catch (e) {}

          return supportsPassiveOption;
        }();

        target.addEventListener(eventName, listener, supportsPassiveOption ? {
          passive: true
        } : false);
      };

      var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
        target.removeEventListener(eventName, listener);
      };
      /***/

    },
    /* 316 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _lodash = __webpack_require__(485);

      var _lodash2 = _interopRequireDefault(_lodash);

      var _passiveEventListeners = __webpack_require__(315);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      } // The eventHandler will execute at a rate of 15fps


      var eventThrottler = function eventThrottler(eventHandler) {
        return (0, _lodash2.default)(eventHandler, 66);
      };

      var scrollSpy = {
        spyCallbacks: [],
        spySetState: [],
        scrollSpyContainers: [],
        mount: function mount(scrollSpyContainer) {
          if (scrollSpyContainer) {
            var eventHandler = eventThrottler(function (event) {
              scrollSpy.scrollHandler(scrollSpyContainer);
            });
            scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
            (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
          }
        },
        isMounted: function isMounted(scrollSpyContainer) {
          return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
        },
        currentPositionY: function currentPositionY(scrollSpyContainer) {
          if (scrollSpyContainer === document) {
            var supportPageOffset = window.pageXOffset !== undefined;
            var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
            return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
          } else {
            return scrollSpyContainer.scrollTop;
          }
        },
        scrollHandler: function scrollHandler(scrollSpyContainer) {
          var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
          callbacks.forEach(function (c) {
            return c(scrollSpy.currentPositionY(scrollSpyContainer));
          });
        },
        addStateHandler: function addStateHandler(handler) {
          scrollSpy.spySetState.push(handler);
        },
        addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
          var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

          if (!container.spyCallbacks) {
            container.spyCallbacks = [];
          }

          container.spyCallbacks.push(handler);
          handler(scrollSpy.currentPositionY(scrollSpyContainer));
        },
        updateStates: function updateStates() {
          scrollSpy.spySetState.forEach(function (s) {
            return s();
          });
        },
        unmount: function unmount(stateHandler, spyHandler) {
          scrollSpy.scrollSpyContainers.forEach(function (c) {
            return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
          });

          if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
            scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
          }

          document.removeEventListener('scroll', scrollSpy.scrollHandler);
        },
        update: function update() {
          return scrollSpy.scrollSpyContainers.forEach(function (c) {
            return scrollSpy.scrollHandler(c);
          });
        }
      };
      exports.default = scrollSpy;
      /***/
    },
    /* 317 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _reactDom = __webpack_require__(16);

      var _reactDom2 = _interopRequireDefault(_reactDom);

      var _utils = __webpack_require__(200);

      var _utils2 = _interopRequireDefault(_utils);

      var _scrollSpy = __webpack_require__(316);

      var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

      var _scroller = __webpack_require__(237);

      var _scroller2 = _interopRequireDefault(_scroller);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _scrollHash = __webpack_require__(438);

      var _scrollHash2 = _interopRequireDefault(_scrollHash);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var protoTypes = {
        to: _propTypes2.default.string.isRequired,
        containerId: _propTypes2.default.string,
        container: _propTypes2.default.object,
        activeClass: _propTypes2.default.string,
        spy: _propTypes2.default.bool,
        smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
        offset: _propTypes2.default.number,
        delay: _propTypes2.default.number,
        isDynamic: _propTypes2.default.bool,
        onClick: _propTypes2.default.func,
        duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
        absolute: _propTypes2.default.bool,
        onSetActive: _propTypes2.default.func,
        onSetInactive: _propTypes2.default.func,
        ignoreCancelEvents: _propTypes2.default.bool,
        hashSpy: _propTypes2.default.bool
      };

      exports.default = function (Component, customScroller) {
        var scroller = customScroller || _scroller2.default;

        var Link = function (_React$PureComponent) {
          _inherits(Link, _React$PureComponent);

          function Link(props) {
            _classCallCheck(this, Link);

            var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

            _initialiseProps.call(_this);

            _this.state = {
              active: false
            };
            return _this;
          }

          _createClass(Link, [{
            key: 'getScrollSpyContainer',
            value: function getScrollSpyContainer() {
              var containerId = this.props.containerId;
              var container = this.props.container;

              if (containerId && !container) {
                return document.getElementById(containerId);
              }

              if (container && container.nodeType) {
                return container;
              }

              return document;
            }
          }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
              if (this.props.spy || this.props.hashSpy) {
                var scrollSpyContainer = this.getScrollSpyContainer();

                if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
                  _scrollSpy2.default.mount(scrollSpyContainer);
                }

                if (this.props.hashSpy) {
                  if (!_scrollHash2.default.isMounted()) {
                    _scrollHash2.default.mount(scroller);
                  }

                  _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
                }

                _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

                this.setState({
                  container: scrollSpyContainer
                });
              }
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
            }
          }, {
            key: 'render',
            value: function render() {
              var className = "";

              if (this.state && this.state.active) {
                className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
              } else {
                className = this.props.className;
              }

              var props = _extends({}, this.props);

              for (var prop in protoTypes) {
                if (props.hasOwnProperty(prop)) {
                  delete props[prop];
                }
              }

              props.className = className;
              props.onClick = this.handleClick;
              return _react2.default.createElement(Component, props);
            }
          }]);

          return Link;
        }(_react2.default.PureComponent);

        var _initialiseProps = function _initialiseProps() {
          var _this2 = this;

          this.scrollTo = function (to, props) {
            scroller.scrollTo(to, _extends({}, _this2.state, props));
          };

          this.handleClick = function (event) {
            /*
             * give the posibility to override onClick
             */
            if (_this2.props.onClick) {
              _this2.props.onClick(event);
            }
            /*
             * dont bubble the navigation
             */


            if (event.stopPropagation) event.stopPropagation();
            if (event.preventDefault) event.preventDefault();
            /*
             * do the magic!
             */

            _this2.scrollTo(_this2.props.to, _this2.props);
          };

          this.spyHandler = function (y) {
            var scrollSpyContainer = _this2.getScrollSpyContainer();

            if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
              return;
            }

            var to = _this2.props.to;
            var element = null;
            var elemTopBound = 0;
            var elemBottomBound = 0;
            var containerTop = 0;

            if (scrollSpyContainer.getBoundingClientRect) {
              var containerCords = scrollSpyContainer.getBoundingClientRect();
              containerTop = containerCords.top;
            }

            if (!element || _this2.props.isDynamic) {
              element = scroller.get(to);

              if (!element) {
                return;
              }

              var cords = element.getBoundingClientRect();
              elemTopBound = cords.top - containerTop + y;
              elemBottomBound = elemTopBound + cords.height;
            }

            var offsetY = y - _this2.props.offset;
            var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
            var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
            var activeLink = scroller.getActiveLink();

            if (isOutside) {
              if (to === activeLink) {
                scroller.setActiveLink(void 0);
              }

              if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
                _scrollHash2.default.changeHash();
              }

              if (_this2.props.spy && _this2.state.active) {
                _this2.setState({
                  active: false
                });

                _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
              }
            }

            if (isInside && (activeLink !== to || _this2.state.active === false)) {
              scroller.setActiveLink(to);
              _this2.props.hashSpy && _scrollHash2.default.changeHash(to);

              if (_this2.props.spy) {
                _this2.setState({
                  active: true
                });

                _this2.props.onSetActive && _this2.props.onSetActive(to, element);
              }
            }
          };
        };

        ;
        Link.propTypes = protoTypes;
        Link.defaultProps = {
          offset: 0
        };
        return Link;
      };
      /***/

    },
    /* 318 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _button = __webpack_require__(891);

      var _button2 = _interopRequireDefault(_button);

      var _buttonGroup = __webpack_require__(890);

      var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      _button2['default'].Group = _buttonGroup2['default'];
      exports['default'] = _button2['default'];
      module.exports = exports['default'];
      /***/
    },
    /* 319 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports['default'] = addEventListenerWrap;

      var _addDomEventListener = __webpack_require__(380);

      var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);

      var _reactDom = __webpack_require__(16);

      var _reactDom2 = _interopRequireDefault(_reactDom);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function addEventListenerWrap(target, eventType, cb, option) {
        /* eslint camelcase: 2 */
        var callback = _reactDom2['default'].unstable_batchedUpdates ? function run(e) {
          _reactDom2['default'].unstable_batchedUpdates(cb, e);
        } : cb;
        return (0, _addDomEventListener2['default'])(target, eventType, callback, option);
      }

      module.exports = exports['default'];
      /***/
    },
    /* 320 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayPush = __webpack_require__(239),
          isFlattenable = __webpack_require__(892);
      /**
       * The base implementation of `_.flatten` with support for restricting flattening.
       *
       * @private
       * @param {Array} array The array to flatten.
       * @param {number} depth The maximum recursion depth.
       * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
       * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
       * @param {Array} [result=[]] The initial result value.
       * @returns {Array} Returns the new flattened array.
       */


      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index = -1,
            length = array.length;
        predicate || (predicate = isFlattenable);
        result || (result = []);

        while (++index < length) {
          var value = array[index];

          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              // Recursively flatten arrays (susceptible to call stack limits).
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }

        return result;
      }

      module.exports = baseFlatten;
      /***/
    },
    /* 321 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseFor = __webpack_require__(502),
          keys = __webpack_require__(132);
      /**
       * The base implementation of `_.forOwn` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Object} Returns `object`.
       */


      function baseForOwn(object, iteratee) {
        return object && baseFor(object, iteratee, keys);
      }

      module.exports = baseForOwn;
      /***/
    },
    /* 322 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGetAllKeys = __webpack_require__(453),
          getSymbolsIn = __webpack_require__(445),
          keysIn = __webpack_require__(243);
      /**
       * Creates an array of own and inherited enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */


      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }

      module.exports = getAllKeysIn;
      /***/
    },
    /* 323 */

    /***/
    function (module, exports, __webpack_require__) {
      var Stack = __webpack_require__(247),
          arrayEach = __webpack_require__(915),
          assignValue = __webpack_require__(248),
          baseAssign = __webpack_require__(914),
          baseAssignIn = __webpack_require__(913),
          cloneBuffer = __webpack_require__(501),
          copyArray = __webpack_require__(246),
          copySymbols = __webpack_require__(912),
          copySymbolsIn = __webpack_require__(911),
          getAllKeys = __webpack_require__(454),
          getAllKeysIn = __webpack_require__(322),
          getTag = __webpack_require__(153),
          initCloneArray = __webpack_require__(910),
          initCloneByTag = __webpack_require__(909),
          initCloneObject = __webpack_require__(498),
          isArray = __webpack_require__(55),
          isBuffer = __webpack_require__(208),
          isMap = __webpack_require__(905),
          isObject = __webpack_require__(97),
          isSet = __webpack_require__(903),
          keys = __webpack_require__(132);
      /** Used to compose bitmasks for cloning. */


      var CLONE_DEEP_FLAG = 1,
          CLONE_FLAT_FLAG = 2,
          CLONE_SYMBOLS_FLAG = 4;
      /** `Object#toString` result references. */

      var argsTag = '[object Arguments]',
          arrayTag = '[object Array]',
          boolTag = '[object Boolean]',
          dateTag = '[object Date]',
          errorTag = '[object Error]',
          funcTag = '[object Function]',
          genTag = '[object GeneratorFunction]',
          mapTag = '[object Map]',
          numberTag = '[object Number]',
          objectTag = '[object Object]',
          regexpTag = '[object RegExp]',
          setTag = '[object Set]',
          stringTag = '[object String]',
          symbolTag = '[object Symbol]',
          weakMapTag = '[object WeakMap]';
      var arrayBufferTag = '[object ArrayBuffer]',
          dataViewTag = '[object DataView]',
          float32Tag = '[object Float32Array]',
          float64Tag = '[object Float64Array]',
          int8Tag = '[object Int8Array]',
          int16Tag = '[object Int16Array]',
          int32Tag = '[object Int32Array]',
          uint8Tag = '[object Uint8Array]',
          uint8ClampedTag = '[object Uint8ClampedArray]',
          uint16Tag = '[object Uint16Array]',
          uint32Tag = '[object Uint32Array]';
      /** Used to identify `toStringTag` values supported by `_.clone`. */

      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      /**
       * The base implementation of `_.clone` and `_.cloneDeep` which tracks
       * traversed objects.
       *
       * @private
       * @param {*} value The value to clone.
       * @param {boolean} bitmask The bitmask flags.
       *  1 - Deep clone
       *  2 - Flatten inherited properties
       *  4 - Clone symbols
       * @param {Function} [customizer] The function to customize cloning.
       * @param {string} [key] The key of `value`.
       * @param {Object} [object] The parent object of `value`.
       * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
       * @returns {*} Returns the cloned value.
       */

      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result,
            isDeep = bitmask & CLONE_DEEP_FLAG,
            isFlat = bitmask & CLONE_FLAT_FLAG,
            isFull = bitmask & CLONE_SYMBOLS_FLAG;

        if (customizer) {
          result = object ? customizer(value, key, object, stack) : customizer(value);
        }

        if (result !== undefined) {
          return result;
        }

        if (!isObject(value)) {
          return value;
        }

        var isArr = isArray(value);

        if (isArr) {
          result = initCloneArray(value);

          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value),
              isFunc = tag == funcTag || tag == genTag;

          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }

          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);

            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }

            result = initCloneByTag(value, tag, isDeep);
          }
        } // Check for circular references and return its corresponding clone.


        stack || (stack = new Stack());
        var stacked = stack.get(value);

        if (stacked) {
          return stacked;
        }

        stack.set(value, result);

        if (isSet(value)) {
          value.forEach(function (subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
          return result;
        }

        if (isMap(value)) {
          value.forEach(function (subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
          });
          return result;
        }

        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined : keysFunc(value);
        arrayEach(props || value, function (subValue, key) {
          if (props) {
            key = subValue;
            subValue = value[key];
          } // Recursively populate clone (susceptible to call stack limits).


          assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
        return result;
      }

      module.exports = baseClone;
      /***/
    },
    /* 324 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var locale = {
        placeholder: 'Select time'
      };
      exports['default'] = locale;
      module.exports = exports['default'];
      /***/
    },
    /* 325 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _en_US = __webpack_require__(446);

      var _en_US2 = _interopRequireDefault(_en_US);

      var _en_US3 = __webpack_require__(324);

      var _en_US4 = _interopRequireDefault(_en_US3);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      } // Merge into a locale object


      var locale = {
        lang: (0, _extends3['default'])({
          placeholder: 'Select date',
          rangePlaceholder: ['Start date', 'End date']
        }, _en_US2['default']),
        timePickerLocale: (0, _extends3['default'])({}, _en_US4['default'])
      }; // All settings at:
      // https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

      exports['default'] = locale;
      module.exports = exports['default'];
      /***/
    },
    /* 326 */

    /***/
    function (module, exports, __webpack_require__) {
      var SetCache = __webpack_require__(329),
          arrayIncludes = __webpack_require__(448),
          arrayIncludesWith = __webpack_require__(447),
          cacheHas = __webpack_require__(328),
          createSet = __webpack_require__(918),
          setToArray = __webpack_require__(240);
      /** Used as the size to enable large array optimizations. */


      var LARGE_ARRAY_SIZE = 200;
      /**
       * The base implementation of `_.uniqBy` without support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       */

      function baseUniq(array, iteratee, comparator) {
        var index = -1,
            includes = arrayIncludes,
            length = array.length,
            isCommon = true,
            result = [],
            seen = result;

        if (comparator) {
          isCommon = false;
          includes = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set = iteratee ? null : createSet(array);

          if (set) {
            return setToArray(set);
          }

          isCommon = false;
          includes = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee ? [] : result;
        }

        outer: while (++index < length) {
          var value = array[index],
              computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;

          if (isCommon && computed === computed) {
            var seenIndex = seen.length;

            while (seenIndex--) {
              if (seen[seenIndex] === computed) {
                continue outer;
              }
            }

            if (iteratee) {
              seen.push(computed);
            }

            result.push(value);
          } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) {
              seen.push(computed);
            }

            result.push(value);
          }
        }

        return result;
      }

      module.exports = baseUniq;
      /***/
    },
    /* 327 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayFilter = __webpack_require__(929),
          stubArray = __webpack_require__(452);
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /** Built-in value references. */

      var propertyIsEnumerable = objectProto.propertyIsEnumerable;
      /* Built-in method references for those with the same name as other `lodash` methods. */

      var nativeGetSymbols = Object.getOwnPropertySymbols;
      /**
       * Creates an array of the own enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */

      var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
        if (object == null) {
          return [];
        }

        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), function (symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      module.exports = getSymbols;
      /***/
    },
    /* 328 */

    /***/
    function (module, exports) {
      /**
       * Checks if a `cache` value for `key` exists.
       *
       * @private
       * @param {Object} cache The cache to query.
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function cacheHas(cache, key) {
        return cache.has(key);
      }

      module.exports = cacheHas;
      /***/
    },
    /* 329 */

    /***/
    function (module, exports, __webpack_require__) {
      var MapCache = __webpack_require__(352),
          setCacheAdd = __webpack_require__(934),
          setCacheHas = __webpack_require__(933);
      /**
       *
       * Creates an array cache object to store unique values.
       *
       * @private
       * @constructor
       * @param {Array} [values] The values to cache.
       */


      function SetCache(values) {
        var index = -1,
            length = values == null ? 0 : values.length;
        this.__data__ = new MapCache();

        while (++index < length) {
          this.add(values[index]);
        }
      } // Add methods to `SetCache`.


      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      module.exports = SetCache;
      /***/
    },
    /* 330 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIsEqualDeep = __webpack_require__(935),
          isObjectLike = __webpack_require__(109);
      /**
       * The base implementation of `_.isEqual` which supports partial comparisons
       * and tracks traversed objects.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @param {boolean} bitmask The bitmask flags.
       *  1 - Unordered comparison
       *  2 - Partial comparison
       * @param {Function} [customizer] The function to customize comparisons.
       * @param {Object} [stack] Tracks traversed `value` and `other` objects.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       */


      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }

        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }

        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }

      module.exports = baseIsEqual;
      /***/
    },
    /* 331 */

    /***/
    function (module, exports) {
      /**
       * Converts `map` to its key-value pairs.
       *
       * @private
       * @param {Object} map The map to convert.
       * @returns {Array} Returns the key-value pairs.
       */
      function mapToArray(map) {
        var index = -1,
            result = Array(map.size);
        map.forEach(function (value, key) {
          result[++index] = [key, value];
        });
        return result;
      }

      module.exports = mapToArray;
      /***/
    },
    /* 332 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule moveSelectionBackward
       * @format
       * 
       */

      /**
       * Given a collapsed selection, move the focus `maxDistance` backward within
       * the selected block. If the selection will go beyond the start of the block,
       * move focus to the end of the previous block, but no further.
       *
       * This function is not Unicode-aware, so surrogate pairs will be treated
       * as having length 2.
       */

      function moveSelectionBackward(editorState, maxDistance) {
        var selection = editorState.getSelection();
        var content = editorState.getCurrentContent();
        var key = selection.getStartKey();
        var offset = selection.getStartOffset();
        var focusKey = key;
        var focusOffset = 0;

        if (maxDistance > offset) {
          var keyBefore = content.getKeyBefore(key);

          if (keyBefore == null) {
            focusKey = key;
          } else {
            focusKey = keyBefore;
            var blockBefore = content.getBlockForKey(keyBefore);
            focusOffset = blockBefore.getText().length;
          }
        } else {
          focusOffset = offset - maxDistance;
        }

        return selection.merge({
          focusKey: focusKey,
          focusOffset: focusOffset,
          isBackward: true
        });
      }

      module.exports = moveSelectionBackward;
      /***/
    },
    /* 333 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule KeyBindingUtil
       * @format
       * 
       */

      var UserAgent = __webpack_require__(113);

      var isOSX = UserAgent.isPlatform('Mac OS X');
      var KeyBindingUtil = {
        /**
         * Check whether the ctrlKey modifier is *not* being used in conjunction with
         * the altKey modifier. If they are combined, the result is an `altGraph`
         * key modifier, which should not be handled by this set of key bindings.
         */
        isCtrlKeyCommand: function isCtrlKeyCommand(e) {
          return !!e.ctrlKey && !e.altKey;
        },
        isOptionKeyCommand: function isOptionKeyCommand(e) {
          return isOSX && e.altKey;
        },
        hasCommandModifier: function hasCommandModifier(e) {
          return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
        }
      };
      module.exports = KeyBindingUtil;
      /***/
    },
    /* 334 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global, process) {
        (function (global, undefined) {
          "use strict";

          if (global.setImmediate) {
            return;
          }

          var nextHandle = 1; // Spec says greater than zero

          var tasksByHandle = {};
          var currentlyRunningATask = false;
          var doc = global.document;
          var registerImmediate;

          function setImmediate(callback) {
            // Callback can either be a function or a string
            if (typeof callback !== "function") {
              callback = new Function("" + callback);
            } // Copy function arguments


            var args = new Array(arguments.length - 1);

            for (var i = 0; i < args.length; i++) {
              args[i] = arguments[i + 1];
            } // Store and register the task


            var task = {
              callback: callback,
              args: args
            };
            tasksByHandle[nextHandle] = task;
            registerImmediate(nextHandle);
            return nextHandle++;
          }

          function clearImmediate(handle) {
            delete tasksByHandle[handle];
          }

          function run(task) {
            var callback = task.callback;
            var args = task.args;

            switch (args.length) {
              case 0:
                callback();
                break;

              case 1:
                callback(args[0]);
                break;

              case 2:
                callback(args[0], args[1]);
                break;

              case 3:
                callback(args[0], args[1], args[2]);
                break;

              default:
                callback.apply(undefined, args);
                break;
            }
          }

          function runIfPresent(handle) {
            // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
            // So if we're currently running a task, we'll need to delay this invocation.
            if (currentlyRunningATask) {
              // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
              // "too much recursion" error.
              setTimeout(runIfPresent, 0, handle);
            } else {
              var task = tasksByHandle[handle];

              if (task) {
                currentlyRunningATask = true;

                try {
                  run(task);
                } finally {
                  clearImmediate(handle);
                  currentlyRunningATask = false;
                }
              }
            }
          }

          function installNextTickImplementation() {
            registerImmediate = function registerImmediate(handle) {
              process.nextTick(function () {
                runIfPresent(handle);
              });
            };
          }

          function canUsePostMessage() {
            // The test against `importScripts` prevents this implementation from being installed inside a web worker,
            // where `global.postMessage` means something completely different and can't be used for this purpose.
            if (global.postMessage && !global.importScripts) {
              var postMessageIsAsynchronous = true;
              var oldOnMessage = global.onmessage;

              global.onmessage = function () {
                postMessageIsAsynchronous = false;
              };

              global.postMessage("", "*");
              global.onmessage = oldOnMessage;
              return postMessageIsAsynchronous;
            }
          }

          function installPostMessageImplementation() {
            // Installs an event handler on `global` for the `message` event: see
            // * https://developer.mozilla.org/en/DOM/window.postMessage
            // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
            var messagePrefix = "setImmediate$" + Math.random() + "$";

            var onGlobalMessage = function onGlobalMessage(event) {
              if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
              }
            };

            if (global.addEventListener) {
              global.addEventListener("message", onGlobalMessage, false);
            } else {
              global.attachEvent("onmessage", onGlobalMessage);
            }

            registerImmediate = function registerImmediate(handle) {
              global.postMessage(messagePrefix + handle, "*");
            };
          }

          function installMessageChannelImplementation() {
            var channel = new MessageChannel();

            channel.port1.onmessage = function (event) {
              var handle = event.data;
              runIfPresent(handle);
            };

            registerImmediate = function registerImmediate(handle) {
              channel.port2.postMessage(handle);
            };
          }

          function installReadyStateChangeImplementation() {
            var html = doc.documentElement;

            registerImmediate = function registerImmediate(handle) {
              // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
              // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
              var script = doc.createElement("script");

              script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
              };

              html.appendChild(script);
            };
          }

          function installSetTimeoutImplementation() {
            registerImmediate = function registerImmediate(handle) {
              setTimeout(runIfPresent, 0, handle);
            };
          } // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.


          var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
          attachTo = attachTo && attachTo.setTimeout ? attachTo : global; // Don't get fooled by e.g. browserify environments.

          if ({}.toString.call(global.process) === "[object process]") {
            // For Node.js before 0.9
            installNextTickImplementation();
          } else if (canUsePostMessage()) {
            // For non-IE10 modern browsers
            installPostMessageImplementation();
          } else if (global.MessageChannel) {
            // For web workers, where supported
            installMessageChannelImplementation();
          } else if (doc && "onreadystatechange" in doc.createElement("script")) {
            // For IE 6–8
            installReadyStateChangeImplementation();
          } else {
            // For older browsers
            installSetTimeoutImplementation();
          }

          attachTo.setImmediate = setImmediate;
          attachTo.clearImmediate = clearImmediate;
        })(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
        /* WEBPACK VAR INJECTION */

      }).call(this, __webpack_require__(71), __webpack_require__(162));
      /***/
    },
    /* 335 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule findAncestorOffsetKey
       * @format
       * 
       */

      var getSelectionOffsetKeyForNode = __webpack_require__(471);
      /**
       * Get the key from the node's nearest offset-aware ancestor.
       */


      function findAncestorOffsetKey(node) {
        var searchNode = node;

        while (searchNode && searchNode !== document.documentElement) {
          var key = getSelectionOffsetKeyForNode(searchNode);

          if (key != null) {
            return key;
          }

          searchNode = searchNode.parentNode;
        }

        return null;
      }

      module.exports = findAncestorOffsetKey;
      /***/
    },
    /* 336 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      var getDocumentScrollElement = __webpack_require__(997);

      var getUnboundedScrollPosition = __webpack_require__(996);
      /**
       * Gets the scroll position of the supplied element or window.
       *
       * The return values are bounded. This means that if the scroll position is
       * negative or exceeds the element boundaries (which is possible using inertial
       * scrolling), you will get zero or the maximum scroll position, respectively.
       *
       * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
       *
       * @param {DOMWindow|DOMElement} scrollable
       * @return {object} Map with `x` and `y` keys.
       */


      function getScrollPosition(scrollable) {
        var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);

        if (scrollable.Window && scrollable instanceof scrollable.Window) {
          scrollable = documentScrollElement;
        }

        var scrollPosition = getUnboundedScrollPosition(scrollable);
        var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
        var xMax = scrollable.scrollWidth - viewport.clientWidth;
        var yMax = scrollable.scrollHeight - viewport.clientHeight;
        scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
        scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
        return scrollPosition;
      }

      module.exports = getScrollPosition;
      /***/
    },
    /* 337 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      var getStyleProperty = __webpack_require__(1002);
      /**
       * @param {DOMNode} element [description]
       * @param {string} name Overflow style property name.
       * @return {boolean} True if the supplied ndoe is scrollable.
       */


      function _isNodeScrollable(element, name) {
        var overflow = Style.get(element, name);
        return overflow === 'auto' || overflow === 'scroll';
      }
      /**
       * Utilities for querying and mutating style properties.
       */


      var Style = {
        /**
         * Gets the style property for the supplied node. This will return either the
         * computed style, if available, or the declared style.
         *
         * @param {DOMNode} node
         * @param {string} name Style property name.
         * @return {?string} Style property value.
         */
        get: getStyleProperty,

        /**
         * Determines the nearest ancestor of a node that is scrollable.
         *
         * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
         *
         * @param {?DOMNode} node Node from which to start searching.
         * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
         */
        getScrollParent: function getScrollParent(node) {
          if (!node) {
            return null;
          }

          var ownerDocument = node.ownerDocument;

          while (node && node !== ownerDocument.body) {
            if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
              return node;
            }

            node = node.parentNode;
          }

          return ownerDocument.defaultView || ownerDocument.parentWindow;
        }
      };
      module.exports = Style;
      /***/
    },
    /* 338 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * 
       */

      var isTextNode = __webpack_require__(1004);
      /*eslint-disable no-bitwise */

      /**
       * Checks if a given DOM node contains or is another DOM node.
       */


      function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) {
          return false;
        } else if (outerNode === innerNode) {
          return true;
        } else if (isTextNode(outerNode)) {
          return false;
        } else if (isTextNode(innerNode)) {
          return containsNode(outerNode, innerNode.parentNode);
        } else if ('contains' in outerNode) {
          return outerNode.contains(innerNode);
        } else if (outerNode.compareDocumentPosition) {
          return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        } else {
          return false;
        }
      }

      module.exports = containsNode;
      /***/
    },
    /* 339 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getEntityKeyForSelection
       * @format
       * 
       */

      /**
       * Return the entity key that should be used when inserting text for the
       * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
       * and `SEGMENTED` entities should not be used for insertion behavior.
       */

      function getEntityKeyForSelection(contentState, targetSelection) {
        var entityKey;

        if (targetSelection.isCollapsed()) {
          var key = targetSelection.getAnchorKey();
          var offset = targetSelection.getAnchorOffset();

          if (offset > 0) {
            entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);

            if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
              return null;
            }

            return filterKey(contentState.getEntityMap(), entityKey);
          }

          return null;
        }

        var startKey = targetSelection.getStartKey();
        var startOffset = targetSelection.getStartOffset();
        var startBlock = contentState.getBlockForKey(startKey);
        entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
        return filterKey(contentState.getEntityMap(), entityKey);
      }
      /**
       * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
       * return it. If not, return null.
       */


      function filterKey(entityMap, entityKey) {
        if (entityKey) {
          var entity = entityMap.__get(entityKey);

          return entity.getMutability() === 'MUTABLE' ? entityKey : null;
        }

        return null;
      }

      module.exports = getEntityKeyForSelection;
      /***/
    },
    /* 340 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      module.exports = {
        BACKSPACE: 8,
        TAB: 9,
        RETURN: 13,
        ALT: 18,
        ESC: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        DELETE: 46,
        COMMA: 188,
        PERIOD: 190,
        A: 65,
        Z: 90,
        ZERO: 48,
        NUMPAD_0: 96,
        NUMPAD_9: 105
      };
      /***/
    },
    /* 341 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DefaultDraftBlockRenderMap
       * @format
       * 
       */

      var _require = __webpack_require__(53),
          Map = _require.Map;

      var React = __webpack_require__(1);

      var cx = __webpack_require__(173);

      var UL_WRAP = React.createElement('ul', {
        className: cx('public/DraftStyleDefault/ul')
      });
      var OL_WRAP = React.createElement('ol', {
        className: cx('public/DraftStyleDefault/ol')
      });
      var PRE_WRAP = React.createElement('pre', {
        className: cx('public/DraftStyleDefault/pre')
      });
      var DefaultDraftBlockRenderMap = Map({
        'header-one': {
          element: 'h1'
        },
        'header-two': {
          element: 'h2'
        },
        'header-three': {
          element: 'h3'
        },
        'header-four': {
          element: 'h4'
        },
        'header-five': {
          element: 'h5'
        },
        'header-six': {
          element: 'h6'
        },
        'unordered-list-item': {
          element: 'li',
          wrapper: UL_WRAP
        },
        'ordered-list-item': {
          element: 'li',
          wrapper: OL_WRAP
        },
        blockquote: {
          element: 'blockquote'
        },
        atomic: {
          element: 'figure'
        },
        'code-block': {
          element: 'pre',
          wrapper: PRE_WRAP
        },
        unstyled: {
          element: 'div',
          aliasedElements: ['p']
        }
      });
      module.exports = DefaultDraftBlockRenderMap;
      /***/
    },
    /* 342 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       * 
       */

      /**
       * Constants to represent text directionality
       *
       * Also defines a *global* direciton, to be used in bidi algorithms as a
       * default fallback direciton, when no better direction is found or provided.
       *
       * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
       *       global direction value based on the application.
       *
       * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
       * Unicode Standard Annex #9 (UAX9)
       * http://www.unicode.org/reports/tr9/
       */

      var invariant = __webpack_require__(51);

      var NEUTRAL = 'NEUTRAL'; // No strong direction

      var LTR = 'LTR'; // Left-to-Right direction

      var RTL = 'RTL'; // Right-to-Left direction

      var globalDir = null; // == Helpers ==

      /**
       * Check if a directionality value is a Strong one
       */

      function isStrong(dir) {
        return dir === LTR || dir === RTL;
      }
      /**
       * Get string value to be used for `dir` HTML attribute or `direction` CSS
       * property.
       */


      function getHTMLDir(dir) {
        !isStrong(dir) ? false ? undefined : invariant(false) : void 0;
        return dir === LTR ? 'ltr' : 'rtl';
      }
      /**
       * Get string value to be used for `dir` HTML attribute or `direction` CSS
       * property, but returns null if `dir` has same value as `otherDir`.
       * `null`.
       */


      function getHTMLDirIfDifferent(dir, otherDir) {
        !isStrong(dir) ? false ? undefined : invariant(false) : void 0;
        !isStrong(otherDir) ? false ? undefined : invariant(false) : void 0;
        return dir === otherDir ? null : getHTMLDir(dir);
      } // == Global Direction ==

      /**
       * Set the global direction.
       */


      function setGlobalDir(dir) {
        globalDir = dir;
      }
      /**
       * Initialize the global direction
       */


      function initGlobalDir() {
        setGlobalDir(LTR);
      }
      /**
       * Get the global direction
       */


      function getGlobalDir() {
        if (!globalDir) {
          this.initGlobalDir();
        }

        !globalDir ? false ? undefined : invariant(false) : void 0;
        return globalDir;
      }

      var UnicodeBidiDirection = {
        // Values
        NEUTRAL: NEUTRAL,
        LTR: LTR,
        RTL: RTL,
        // Helpers
        isStrong: isStrong,
        getHTMLDir: getHTMLDir,
        getHTMLDirIfDifferent: getHTMLDirIfDifferent,
        // Global Direction
        setGlobalDir: setGlobalDir,
        initGlobalDir: initGlobalDir,
        getGlobalDir: getGlobalDir
      };
      module.exports = UnicodeBidiDirection;
      /***/
    },
    /* 343 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule sanitizeDraftText
       * @format
       * 
       */

      var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

      function sanitizeDraftText(input) {
        return input.replace(REGEX_BLOCK_DELIMITER, '');
      }

      module.exports = sanitizeDraftText;
      /***/
    },
    /* 344 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule ContentState
       * @format
       * 
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var BlockMapBuilder = __webpack_require__(206);

      var CharacterMetadata = __webpack_require__(96);

      var ContentBlock = __webpack_require__(155);

      var ContentBlockNode = __webpack_require__(102);

      var DraftEntity = __webpack_require__(241);

      var DraftFeatureFlags = __webpack_require__(133);

      var Immutable = __webpack_require__(53);

      var SelectionState = __webpack_require__(174);

      var generateRandomKey = __webpack_require__(127);

      var sanitizeDraftText = __webpack_require__(343);

      var List = Immutable.List,
          Record = Immutable.Record,
          Repeat = Immutable.Repeat;
      var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
      var defaultRecord = {
        entityMap: null,
        blockMap: null,
        selectionBefore: null,
        selectionAfter: null
      };
      var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
      var ContentStateRecord = Record(defaultRecord);

      var ContentState = function (_ContentStateRecord) {
        _inherits(ContentState, _ContentStateRecord);

        function ContentState() {
          _classCallCheck(this, ContentState);

          return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
        }

        ContentState.prototype.getEntityMap = function getEntityMap() {
          // TODO: update this when we fully remove DraftEntity
          return DraftEntity;
        };

        ContentState.prototype.getBlockMap = function getBlockMap() {
          return this.get('blockMap');
        };

        ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
          return this.get('selectionBefore');
        };

        ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
          return this.get('selectionAfter');
        };

        ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
          var block = this.getBlockMap().get(key);
          return block;
        };

        ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
          return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
            return v === key;
          }).skip(1).first();
        };

        ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
          return this.getBlockMap().keySeq().skipUntil(function (v) {
            return v === key;
          }).skip(1).first();
        };

        ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
          return this.getBlockMap().skipUntil(function (_, k) {
            return k === key;
          }).skip(1).first();
        };

        ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
          return this.getBlockMap().reverse().skipUntil(function (_, k) {
            return k === key;
          }).skip(1).first();
        };

        ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
          return this.getBlockMap().toArray();
        };

        ContentState.prototype.getFirstBlock = function getFirstBlock() {
          return this.getBlockMap().first();
        };

        ContentState.prototype.getLastBlock = function getLastBlock() {
          return this.getBlockMap().last();
        };

        ContentState.prototype.getPlainText = function getPlainText(delimiter) {
          return this.getBlockMap().map(function (block) {
            return block ? block.getText() : '';
          }).join(delimiter || '\n');
        };

        ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
          // TODO: update this when we fully remove DraftEntity
          return DraftEntity.__getLastCreatedEntityKey();
        };

        ContentState.prototype.hasText = function hasText() {
          var blockMap = this.getBlockMap();
          return blockMap.size > 1 || blockMap.first().getLength() > 0;
        };

        ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
          // TODO: update this when we fully remove DraftEntity
          DraftEntity.__create(type, mutability, data);

          return this;
        };

        ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
          // TODO: update this when we fully remove DraftEntity
          DraftEntity.__mergeData(key, toMerge);

          return this;
        };

        ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
          // TODO: update this when we fully remove DraftEntity
          DraftEntity.__replaceData(key, newData);

          return this;
        };

        ContentState.prototype.addEntity = function addEntity(instance) {
          // TODO: update this when we fully remove DraftEntity
          DraftEntity.__add(instance);

          return this;
        };

        ContentState.prototype.getEntity = function getEntity(key) {
          // TODO: update this when we fully remove DraftEntity
          return DraftEntity.__get(key);
        };

        ContentState.createFromBlockArray = function createFromBlockArray( // TODO: update flow type when we completely deprecate the old entity API
        blocks, entityMap) {
          // TODO: remove this when we completely deprecate the old entity API
          var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
          var blockMap = BlockMapBuilder.createFromArray(theBlocks);
          var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
          return new ContentState({
            blockMap: blockMap,
            entityMap: entityMap || DraftEntity,
            selectionBefore: selectionState,
            selectionAfter: selectionState
          });
        };

        ContentState.createFromText = function createFromText(text) {
          var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
          var strings = text.split(delimiter);
          var blocks = strings.map(function (block) {
            block = sanitizeDraftText(block);
            return new ContentBlockNodeRecord({
              key: generateRandomKey(),
              text: block,
              type: 'unstyled',
              characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
            });
          });
          return ContentState.createFromBlockArray(blocks);
        };

        return ContentState;
      }(ContentStateRecord);

      module.exports = ContentState;
      /***/
    },
    /* 345 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * 
       */

      function makeEmptyFunction(arg) {
        return function () {
          return arg;
        };
      }
      /**
       * This function accepts and discards inputs; it has no side effects. This is
       * primarily useful idiomatically for overridable function endpoints which
       * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
       */


      var emptyFunction = function emptyFunction() {};

      emptyFunction.thatReturns = makeEmptyFunction;
      emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
      emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
      emptyFunction.thatReturnsNull = makeEmptyFunction(null);

      emptyFunction.thatReturnsThis = function () {
        return this;
      };

      emptyFunction.thatReturnsArgument = function (arg) {
        return arg;
      };

      module.exports = emptyFunction;
      /***/
    },
    /* 346 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (module) {
        var freeGlobal = __webpack_require__(514);
        /** Detect free variable `exports`. */


        var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
        /** Detect free variable `module`. */

        var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
        /** Detect the popular CommonJS extension `module.exports`. */

        var moduleExports = freeModule && freeModule.exports === freeExports;
        /** Detect free variable `process` from Node.js. */

        var freeProcess = moduleExports && freeGlobal.process;
        /** Used to access faster Node.js helpers. */

        var nodeUtil = function () {
          try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;

            if (types) {
              return types;
            } // Legacy `process.binding('util')` for Node.js < 10.


            return freeProcess && freeProcess.binding && freeProcess.binding('util');
          } catch (e) {}
        }();

        module.exports = nodeUtil;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(212)(module));
      /***/
    },
    /* 347 */

    /***/
    function (module, exports, __webpack_require__) {
      var overArg = __webpack_require__(497);
      /** Built-in value references. */


      var getPrototype = overArg(Object.getPrototypeOf, Object);
      module.exports = getPrototype;
      /***/
    },
    /* 348 */

    /***/
    function (module, exports, __webpack_require__) {
      var Uint8Array = __webpack_require__(499);
      /**
       * Creates a clone of `arrayBuffer`.
       *
       * @private
       * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
       * @returns {ArrayBuffer} Returns the cloned array buffer.
       */


      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result).set(new Uint8Array(arrayBuffer));
        return result;
      }

      module.exports = cloneArrayBuffer;
      /***/
    },
    /* 349 */

    /***/
    function (module, exports) {
      /** Used as references for various `Number` constants. */
      var MAX_SAFE_INTEGER = 9007199254740991;
      /**
       * Checks if `value` is a valid array-like length.
       *
       * **Note:** This method is loosely based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
       * @example
       *
       * _.isLength(3);
       * // => true
       *
       * _.isLength(Number.MIN_VALUE);
       * // => false
       *
       * _.isLength(Infinity);
       * // => false
       *
       * _.isLength('3');
       * // => false
       */

      function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }

      module.exports = isLength;
      /***/
    },
    /* 350 */

    /***/
    function (module, exports, __webpack_require__) {
      var getNative = __webpack_require__(157),
          root = __webpack_require__(103);
      /* Built-in method references that are verified to be native. */


      var Map = getNative(root, 'Map');
      module.exports = Map;
      /***/
    },
    /* 351 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGetTag = __webpack_require__(135),
          isObject = __webpack_require__(97);
      /** `Object#toString` result references. */


      var asyncTag = '[object AsyncFunction]',
          funcTag = '[object Function]',
          genTag = '[object GeneratorFunction]',
          proxyTag = '[object Proxy]';
      /**
       * Checks if `value` is classified as a `Function` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a function, else `false`.
       * @example
       *
       * _.isFunction(_);
       * // => true
       *
       * _.isFunction(/abc/);
       * // => false
       */

      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        } // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 9 which returns 'object' for typed arrays and other constructors.


        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }

      module.exports = isFunction;
      /***/
    },
    /* 352 */

    /***/
    function (module, exports, __webpack_require__) {
      var mapCacheClear = __webpack_require__(1088),
          mapCacheDelete = __webpack_require__(1072),
          mapCacheGet = __webpack_require__(1070),
          mapCacheHas = __webpack_require__(1069),
          mapCacheSet = __webpack_require__(1068);
      /**
       * Creates a map cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */


      function MapCache(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;
        this.clear();

        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      } // Add methods to `MapCache`.


      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype['delete'] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      module.exports = MapCache;
      /***/
    },
    /* 353 */

    /***/
    function (module, exports, __webpack_require__) {
      var isArray = __webpack_require__(55),
          isSymbol = __webpack_require__(255);
      /** Used to match property names within property paths. */


      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          reIsPlainProp = /^\w*$/;
      /**
       * Checks if `value` is a property name and not a property path.
       *
       * @private
       * @param {*} value The value to check.
       * @param {Object} [object] The object to query keys on.
       * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
       */

      function isKey(value, object) {
        if (isArray(value)) {
          return false;
        }

        var type = typeof value;

        if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
          return true;
        }

        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
      }

      module.exports = isKey;
      /***/
    },
    /* 354 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _reactDom = __webpack_require__(16);

      var _reactDom2 = _interopRequireDefault(_reactDom);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
        var onDemandSlides = [];
        var startIndex = lazyStartIndex(spec);
        var endIndex = lazyEndIndex(spec);

        for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
          if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
            onDemandSlides.push(slideIndex);
          }
        }

        return onDemandSlides;
      }; // return list of slides that need to be present


      var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
        var requiredSlides = [];
        var startIndex = lazyStartIndex(spec);
        var endIndex = lazyEndIndex(spec);

        for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
          requiredSlides.push(slideIndex);
        }

        return requiredSlides;
      }; // startIndex that needs to be present


      var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
        return spec.currentSlide - lazySlidesOnLeft(spec);
      };

      var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
        return spec.currentSlide + lazySlidesOnRight(spec);
      };

      var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
        return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
      };

      var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
        return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
      }; // get width of an element


      var getWidth = exports.getWidth = function getWidth(elem) {
        return elem && elem.offsetWidth || 0;
      };

      var getHeight = exports.getHeight = function getHeight(elem) {
        return elem && elem.offsetHeight || 0;
      };

      var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
        var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var xDist, yDist, r, swipeAngle;
        xDist = touchObject.startX - touchObject.curX;
        yDist = touchObject.startY - touchObject.curY;
        r = Math.atan2(yDist, xDist);
        swipeAngle = Math.round(r * 180 / Math.PI);

        if (swipeAngle < 0) {
          swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
          return 'left';
        }

        if (swipeAngle >= 135 && swipeAngle <= 225) {
          return 'right';
        }

        if (verticalSwiping === true) {
          if (swipeAngle >= 35 && swipeAngle <= 135) {
            return 'up';
          } else {
            return 'down';
          }
        }

        return 'vertical';
      }; // whether or not we can go next


      var canGoNext = exports.canGoNext = function canGoNext(spec) {
        var canGo = true;

        if (!spec.infinite) {
          if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
            canGo = false;
          } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
            canGo = false;
          }
        }

        return canGo;
      }; // given an object and a list of keys, return new object with given keys


      var extractObject = exports.extractObject = function extractObject(spec, keys) {
        var newObject = {};
        keys.forEach(function (key) {
          return newObject[key] = spec[key];
        });
        return newObject;
      }; // get initialized state


      var initializedState = exports.initializedState = function initializedState(spec) {
        // spec also contains listRef, trackRef
        var slideCount = _react2.default.Children.count(spec.children);

        var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
        var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
        var slideWidth = void 0;

        if (!spec.vertical) {
          var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

          if (typeof spec.centerPadding === 'string' && spec.centerPadding.slice(-1) === '%') {
            centerPaddingAdj *= listWidth / 100;
          }

          slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
        } else {
          slideWidth = listWidth;
        }

        var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
        var listHeight = slideHeight * spec.slidesToShow;
        var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

        if (spec.rtl && spec.currentSlide === undefined) {
          currentSlide = slideCount - 1 - spec.initialSlide;
        }

        var lazyLoadedList = spec.lazyLoadedList || [];
        var slidesToLoad = getOnDemandLazySlides({
          currentSlide: currentSlide,
          lazyLoadedList: lazyLoadedList
        }, spec);
        lazyLoadedList.concat(slidesToLoad);
        var state = {
          slideCount: slideCount,
          slideWidth: slideWidth,
          listWidth: listWidth,
          trackWidth: trackWidth,
          currentSlide: currentSlide,
          slideHeight: slideHeight,
          listHeight: listHeight,
          lazyLoadedList: lazyLoadedList
        };

        if (spec.autoplaying === null && spec.autoplay) {
          state['autoplaying'] = 'playing';
        }

        return state;
      };

      var slideHandler = exports.slideHandler = function slideHandler(spec) {
        var waitForAnimate = spec.waitForAnimate,
            animating = spec.animating,
            fade = spec.fade,
            infinite = spec.infinite,
            index = spec.index,
            slideCount = spec.slideCount,
            lazyLoadedList = spec.lazyLoadedList,
            lazyLoad = spec.lazyLoad,
            onLazyLoad = spec.onLazyLoad,
            asNavFor = spec.asNavFor,
            currentSlide = spec.currentSlide,
            speed = spec.speed,
            centerMode = spec.centerMode,
            slidesToScroll = spec.slidesToScroll,
            slidesToShow = spec.slidesToShow,
            useCSS = spec.useCSS;
        if (waitForAnimate && animating) return {};
        var animationSlide = index,
            finalSlide = void 0,
            animationLeft = void 0,
            finalLeft = void 0;
        var state = {},
            nextState = {};

        if (fade) {
          if (!infinite && (index < 0 || index >= slideCount)) return {};

          if (index < 0) {
            animationSlide = index + slideCount;
          } else if (index >= slideCount) {
            animationSlide = index - slideCount;
          }

          if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
            lazyLoadedList.push(animationSlide);
          }

          state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList
          };
          nextState = {
            animating: false
          };
        } else {
          finalSlide = animationSlide;

          if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
          } else if (!canGoNext(spec) && animationSlide > currentSlide) {
            animationSlide = finalSlide = currentSlide;
          } else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
          } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
          }

          animationLeft = getTrackLeft(_extends({}, spec, {
            slideIndex: animationSlide
          }));
          finalLeft = getTrackLeft(_extends({}, spec, {
            slideIndex: finalSlide
          }));

          if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
          }

          lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, {
            currentSlide: animationSlide
          })));

          if (!useCSS) {
            state = {
              currentSlide: finalSlide,
              trackStyle: getTrackCSS(_extends({}, spec, {
                left: finalLeft
              })),
              lazyLoadedList: lazyLoadedList
            };
          } else {
            state = {
              animating: true,
              currentSlide: finalSlide,
              trackStyle: getTrackAnimateCSS(_extends({}, spec, {
                left: animationLeft
              })),
              lazyLoadedList: lazyLoadedList
            };
            nextState = {
              animating: false,
              currentSlide: finalSlide,
              trackStyle: getTrackCSS(_extends({}, spec, {
                left: finalLeft
              })),
              swipeLeft: null
            };
          }
        }

        return {
          state: state,
          nextState: nextState
        };
      };

      var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
        var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
        var slidesToScroll = spec.slidesToScroll,
            slidesToShow = spec.slidesToShow,
            centerMode = spec.centerMode,
            rtl = spec.rtl,
            slideCount = spec.slideCount,
            currentSlide = spec.currentSlide,
            lazyLoad = spec.lazyLoad,
            infinite = spec.infinite;
        unevenOffset = slideCount % slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

        if (options.message === 'previous') {
          slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
          targetSlide = currentSlide - slideOffset;

          if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
          }
        } else if (options.message === 'next') {
          slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
          targetSlide = currentSlide + slideOffset;

          if (lazyLoad && !infinite) {
            targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
          }
        } else if (options.message === 'dots') {
          // Click on dots
          targetSlide = options.index * options.slidesToScroll;

          if (targetSlide === options.currentSlide) {
            return null;
          }
        } else if (options.message === 'children') {
          // Click on the slides
          targetSlide = options.index;

          if (targetSlide === options.currentSlide) {
            return null;
          }

          if (infinite) {
            var direction = siblingDirection(_extends({}, spec, {
              targetSlide: targetSlide
            }));

            if (targetSlide > options.currentSlide && direction === 'left') {
              targetSlide = targetSlide - slideCount;
            } else if (targetSlide < options.currentSlide && direction === 'right') {
              targetSlide = targetSlide + slideCount;
            }
          }
        } else if (options.message === 'index') {
          targetSlide = Number(options.index);

          if (targetSlide === options.currentSlide) {
            return null;
          }
        }

        return targetSlide;
      };

      var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
        if (e.target.tagName.match('TEXTAREA|INPUT|SELECT') || !accessibility) return '';
        if (e.keyCode === 37) return rtl ? 'next' : 'previous';
        if (e.keyCode === 39) return rtl ? 'previous' : 'next';
        return '';
      };

      var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
        e.target.tagName === 'IMG' && e.preventDefault();
        if (!swipe || !draggable && e.type.indexOf('mouse') !== -1) return '';
        return {
          dragging: true,
          touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
          }
        };
      };

      var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
        // spec also contains, trackRef and slideIndex
        var scrolling = spec.scrolling,
            animating = spec.animating,
            vertical = spec.vertical,
            swipeToSlide = spec.swipeToSlide,
            verticalSwiping = spec.verticalSwiping,
            rtl = spec.rtl,
            currentSlide = spec.currentSlide,
            edgeFriction = spec.edgeFriction,
            edgeDragged = spec.edgeDragged,
            onEdge = spec.onEdge,
            swiped = spec.swiped,
            swiping = spec.swiping,
            slideCount = spec.slideCount,
            slidesToScroll = spec.slidesToScroll,
            infinite = spec.infinite,
            touchObject = spec.touchObject,
            swipeEvent = spec.swipeEvent,
            listHeight = spec.listHeight,
            listWidth = spec.listWidth;
        if (scrolling) return;
        if (animating) return e.preventDefault();
        if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
        var swipeLeft = void 0,
            state = {};
        var curLeft = getTrackLeft(spec);
        touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
        touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
        touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
        var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

        if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
          return {
            scrolling: true
          };
        }

        if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
        var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
        if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
        var dotCount = Math.ceil(slideCount / slidesToScroll);
        var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
        var touchSwipeLength = touchObject.swipeLength;

        if (!infinite) {
          if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left' || !canGoNext(spec) && swipeDirection === 'left') {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;

            if (edgeDragged === false && onEdge) {
              onEdge(swipeDirection);
              state['edgeDragged'] = true;
            }
          }
        }

        if (!swiped && swipeEvent) {
          swipeEvent(swipeDirection);
          state['swiped'] = true;
        }

        if (!vertical) {
          if (!rtl) {
            swipeLeft = curLeft + touchSwipeLength * positionOffset;
          } else {
            swipeLeft = curLeft - touchSwipeLength * positionOffset;
          }
        } else {
          swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
        }

        if (verticalSwiping) {
          swipeLeft = curLeft + touchSwipeLength * positionOffset;
        }

        state = _extends({}, state, {
          touchObject: touchObject,
          swipeLeft: swipeLeft,
          trackStyle: getTrackCSS(_extends({}, spec, {
            left: swipeLeft
          }))
        });

        if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
          return state;
        }

        if (touchObject.swipeLength > 10) {
          state['swiping'] = true;
          e.preventDefault();
        }

        return state;
      };

      var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
        var dragging = spec.dragging,
            swipe = spec.swipe,
            touchObject = spec.touchObject,
            listWidth = spec.listWidth,
            touchThreshold = spec.touchThreshold,
            verticalSwiping = spec.verticalSwiping,
            listHeight = spec.listHeight,
            currentSlide = spec.currentSlide,
            swipeToSlide = spec.swipeToSlide,
            scrolling = spec.scrolling,
            onSwipe = spec.onSwipe;

        if (!dragging) {
          if (swipe) e.preventDefault();
          return {};
        }

        var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
        var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

        var state = {
          dragging: false,
          edgeDragged: false,
          scrolling: false,
          swiping: false,
          swiped: false,
          swipeLeft: null,
          touchObject: {}
        };

        if (scrolling) {
          return state;
        }

        if (!touchObject.swipeLength) {
          return state;
        }

        if (touchObject.swipeLength > minSwipe) {
          e.preventDefault();

          if (onSwipe) {
            onSwipe(swipeDirection);
          }

          var slideCount = void 0,
              newSlide = void 0;

          switch (swipeDirection) {
            case 'left':
            case 'up':
              newSlide = currentSlide + getSlideCount(spec);
              slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
              state['currentDirection'] = 0;
              break;

            case 'right':
            case 'down':
              newSlide = currentSlide - getSlideCount(spec);
              slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
              state['currentDirection'] = 1;
              break;

            default:
              slideCount = currentSlide;
          }

          state['triggerSlideHandler'] = slideCount;
        } else {
          // Adjust the track back to it's original position.
          var currentLeft = getTrackLeft(spec);
          state['trackStyle'] = getTrackAnimateCSS(_extends({}, spec, {
            left: currentLeft
          }));
        }

        return state;
      };

      var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
        var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
        var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
        var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
        var indexes = [];

        while (breakpoint < max) {
          indexes.push(breakpoint);
          breakpoint = counter + spec.slidesToScroll;
          counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
        }

        return indexes;
      };

      var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
        var navigables = getNavigableIndexes(spec);
        var prevNavigable = 0;

        if (index > navigables[navigables.length - 1]) {
          index = navigables[navigables.length - 1];
        } else {
          for (var n in navigables) {
            if (index < navigables[n]) {
              index = prevNavigable;
              break;
            }

            prevNavigable = navigables[n];
          }
        }

        return index;
      };

      var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
        var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

        if (spec.swipeToSlide) {
          var swipedSlide = void 0;

          var slickList = _reactDom2.default.findDOMNode(spec.listRef);

          var slides = slickList.querySelectorAll('.slick-slide');
          Array.from(slides).every(function (slide) {
            if (!spec.vertical) {
              if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
              }
            } else {
              if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
              }
            }

            return true;
          });

          if (!swipedSlide) {
            return 0;
          }

          var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
          var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
          return slidesTraversed;
        } else {
          return spec.slidesToScroll;
        }
      };

      var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
        return keysArray.reduce(function (value, key) {
          return value && spec.hasOwnProperty(key);
        }, true) ? null : console.error('Keys Missing:', spec);
      };

      var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
        checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
        var trackWidth = void 0,
            trackHeight = void 0;
        var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

        if (!spec.vertical) {
          trackWidth = getTotalSlides(spec) * spec.slideWidth;
        } else {
          trackHeight = trackChildren * spec.slideHeight;
        }

        var style = {
          opacity: 1,
          transition: '',
          WebkitTransition: ''
        };

        if (spec.useTransform) {
          var WebkitTransform = !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)';
          var transform = !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)';
          var msTransform = !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)';
          style = _extends({}, style, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
          });
        } else {
          if (spec.vertical) {
            style['top'] = spec.left;
          } else {
            style['left'] = spec.left;
          }
        }

        if (spec.fade) style = {
          opacity: 1
        };
        if (trackWidth) style.width = trackWidth;
        if (trackHeight) style.height = trackHeight; // Fallback for IE8

        if (window && !window.addEventListener && window.attachEvent) {
          if (!spec.vertical) {
            style.marginLeft = spec.left + 'px';
          } else {
            style.marginTop = spec.left + 'px';
          }
        }

        return style;
      };

      var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
        checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
        var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

        if (spec.useTransform) {
          style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
          style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
        } else {
          if (spec.vertical) {
            style.transition = 'top ' + spec.speed + 'ms ' + spec.cssEase;
          } else {
            style.transition = 'left ' + spec.speed + 'ms ' + spec.cssEase;
          }
        }

        return style;
      };

      var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
        if (spec.unslick) {
          return 0;
        }

        checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
        var slideIndex = spec.slideIndex,
            trackRef = spec.trackRef,
            infinite = spec.infinite,
            centerMode = spec.centerMode,
            slideCount = spec.slideCount,
            slidesToShow = spec.slidesToShow,
            slidesToScroll = spec.slidesToScroll,
            slideWidth = spec.slideWidth,
            listWidth = spec.listWidth,
            variableWidth = spec.variableWidth,
            slideHeight = spec.slideHeight,
            fade = spec.fade,
            vertical = spec.vertical;
        var slideOffset = 0;
        var targetLeft;
        var targetSlide;
        var verticalOffset = 0;

        if (fade || spec.slideCount === 1) {
          return 0;
        }

        var slidesToOffset = 0;

        if (infinite) {
          slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
          // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

          if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
            slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
          } // shift current slide to center of the frame


          if (centerMode) {
            slidesToOffset += parseInt(slidesToShow / 2);
          }
        } else {
          if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
            slidesToOffset = slidesToShow - slideCount % slidesToScroll;
          }

          if (centerMode) {
            slidesToOffset = parseInt(slidesToShow / 2);
          }
        }

        slideOffset = slidesToOffset * slideWidth;
        verticalOffset = slidesToOffset * slideHeight;

        if (!vertical) {
          targetLeft = slideIndex * slideWidth * -1 + slideOffset;
        } else {
          targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
        }

        if (variableWidth === true) {
          var targetSlideIndex;

          var trackElem = _reactDom2.default.findDOMNode(trackRef);

          var lastSlide = trackElem && trackElem.children[slideCount - 1];
          targetSlideIndex = slideIndex + getPreClones(spec);
          targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
          targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

          if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;

            for (var slide = 0; slide < targetSlideIndex; slide++) {
              targetLeft -= trackElem && trackElem.children[slide].offsetWidth;
            }

            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += (listWidth - targetSlide.offsetWidth) / 2;
          }
        }

        return targetLeft;
      };

      var getPreClones = exports.getPreClones = function getPreClones(spec) {
        if (spec.unslick || !spec.infinite) {
          return 0;
        }

        if (spec.variableWidth) {
          return spec.slideCount;
        }

        return spec.slidesToShow + (spec.centerMode ? 1 : 0);
      };

      var getPostClones = exports.getPostClones = function getPostClones(spec) {
        if (spec.unslick || !spec.infinite) {
          return 0;
        }

        return spec.slideCount;
      };

      var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
        return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
      };

      var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
        if (spec.targetSlide > spec.currentSlide) {
          if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
            return 'left';
          }

          return 'right';
        } else {
          if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
            return 'right';
          }

          return 'left';
        }
      };

      var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
        var slidesToShow = _ref.slidesToShow,
            centerMode = _ref.centerMode,
            rtl = _ref.rtl,
            centerPadding = _ref.centerPadding; // returns no of slides on the right of active slide

        if (centerMode) {
          var right = (slidesToShow - 1) / 2 + 1;
          if (parseInt(centerPadding) > 0) right += 1;
          if (rtl && slidesToShow % 2 === 0) right += 1;
          return right;
        }

        if (rtl) {
          return 0;
        }

        return slidesToShow - 1;
      };

      var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
        var slidesToShow = _ref2.slidesToShow,
            centerMode = _ref2.centerMode,
            rtl = _ref2.rtl,
            centerPadding = _ref2.centerPadding; // returns no of slides on the left of active slide

        if (centerMode) {
          var left = (slidesToShow - 1) / 2 + 1;
          if (parseInt(centerPadding) > 0) left += 1;
          if (!rtl && slidesToShow % 2 === 0) left += 1;
          return left;
        }

        if (rtl) {
          return slidesToShow - 1;
        }

        return 0;
      };
      /***/

    },
    /* 355 */

    /***/
    function (module, exports, __webpack_require__) {
      var pIE = __webpack_require__(257);

      var createDesc = __webpack_require__(214);

      var toIObject = __webpack_require__(159);

      var toPrimitive = __webpack_require__(368);

      var has = __webpack_require__(160);

      var IE8_DOM_DEFINE = __webpack_require__(654);

      var gOPD = Object.getOwnPropertyDescriptor;
      exports.f = __webpack_require__(136) ? gOPD : function getOwnPropertyDescriptor(O, P) {
        O = toIObject(O);
        P = toPrimitive(P, true);
        if (IE8_DOM_DEFINE) try {
          return gOPD(O, P);
        } catch (e) {
          /* empty */
        }
        if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
      };
      /***/
    },
    /* 356 */

    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__(138);

      var core = __webpack_require__(89);

      var LIBRARY = __webpack_require__(259);

      var wksExt = __webpack_require__(357);

      var defineProperty = __webpack_require__(137).f;

      module.exports = function (name) {
        var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
        if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
          value: wksExt.f(name)
        });
      };
      /***/

    },
    /* 357 */

    /***/
    function (module, exports, __webpack_require__) {
      exports.f = __webpack_require__(110);
      /***/
    },
    /* 358 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(1157);

      var global = __webpack_require__(138);

      var hide = __webpack_require__(181);

      var Iterators = __webpack_require__(178);

      var TO_STRING_TAG = __webpack_require__(110)('toStringTag');

      var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

      for (var i = 0; i < DOMIterables.length; i++) {
        var NAME = DOMIterables[i];
        var Collection = global[NAME];
        var proto = Collection && Collection.prototype;
        if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
        Iterators[NAME] = Iterators.Array;
      }
      /***/

    },
    /* 359 */

    /***/
    function (module, exports, __webpack_require__) {
      var def = __webpack_require__(137).f;

      var has = __webpack_require__(160);

      var TAG = __webpack_require__(110)('toStringTag');

      module.exports = function (it, tag, stat) {
        if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
          configurable: true,
          value: tag
        });
      };
      /***/

    },
    /* 360 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
      var anObject = __webpack_require__(161);

      var dPs = __webpack_require__(1159);

      var enumBugKeys = __webpack_require__(362);

      var IE_PROTO = __webpack_require__(364)('IE_PROTO');

      var Empty = function Empty() {
        /* empty */
      };

      var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

      var _createDict = function createDict() {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = __webpack_require__(653)('iframe');

        var i = enumBugKeys.length;
        var lt = '<';
        var gt = '>';
        var iframeDocument;
        iframe.style.display = 'none';

        __webpack_require__(1158).appendChild(iframe);

        iframe.src = 'javascript:'; // eslint-disable-line no-script-url
        // createDict = iframe.contentWindow.Object;
        // html.removeChild(iframe);

        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
        iframeDocument.close();
        _createDict = iframeDocument.F;

        while (i--) {
          delete _createDict[PROTOTYPE][enumBugKeys[i]];
        }

        return _createDict();
      };

      module.exports = Object.create || function create(O, Properties) {
        var result;

        if (O !== null) {
          Empty[PROTOTYPE] = anObject(O);
          result = new Empty();
          Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

          result[IE_PROTO] = O;
        } else result = _createDict();

        return Properties === undefined ? result : dPs(result, Properties);
      };
      /***/

    },
    /* 361 */

    /***/
    function (module, exports) {
      exports.f = Object.getOwnPropertySymbols;
      /***/
    },
    /* 362 */

    /***/
    function (module, exports) {
      // IE 8- don't enum bug keys
      module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
      /***/
    },
    /* 363 */

    /***/
    function (module, exports, __webpack_require__) {
      var core = __webpack_require__(89);

      var global = __webpack_require__(138);

      var SHARED = '__core-js_shared__';
      var store = global[SHARED] || (global[SHARED] = {});
      (module.exports = function (key, value) {
        return store[key] || (store[key] = value !== undefined ? value : {});
      })('versions', []).push({
        version: core.version,
        mode: __webpack_require__(259) ? 'pure' : 'global',
        copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
      });
      /***/
    },
    /* 364 */

    /***/
    function (module, exports, __webpack_require__) {
      var shared = __webpack_require__(363)('keys');

      var uid = __webpack_require__(258);

      module.exports = function (key) {
        return shared[key] || (shared[key] = uid(key));
      };
      /***/

    },
    /* 365 */

    /***/
    function (module, exports) {
      // 7.1.4 ToInteger
      var ceil = Math.ceil;
      var floor = Math.floor;

      module.exports = function (it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
      };
      /***/

    },
    /* 366 */

    /***/
    function (module, exports) {
      // 7.2.1 RequireObjectCoercible(argument)
      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
      };
      /***/

    },
    /* 367 */

    /***/
    function (module, exports) {
      var toString = {}.toString;

      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };
      /***/

    },
    /* 368 */

    /***/
    function (module, exports, __webpack_require__) {
      // 7.1.1 ToPrimitive(input [, PreferredType])
      var isObject = __webpack_require__(180); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string


      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
      };
      /***/

    },
    /* 369 */

    /***/
    function (module, exports, __webpack_require__) {
      // optional / simple context binding
      var aFunction = __webpack_require__(1170);

      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;

        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };

          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };

          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }

        return function ()
        /* ...args */
        {
          return fn.apply(that, arguments);
        };
      };
      /***/

    },
    /* 370 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
      };
      var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
      };
      var defineProperty = Object.defineProperty;
      var getOwnPropertyNames = Object.getOwnPropertyNames;
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      var getPrototypeOf = Object.getPrototypeOf;
      var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

      function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') {
          // don't hoist over string (html) components
          if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);

            if (inheritedComponent && inheritedComponent !== objectPrototype) {
              hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
          }

          var keys = getOwnPropertyNames(sourceComponent);

          if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
          }

          for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];

            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
              var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

              try {
                // Avoid failures from read-only properties
                defineProperty(targetComponent, key, descriptor);
              } catch (e) {}
            }
          }

          return targetComponent;
        }

        return targetComponent;
      }

      module.exports = hoistNonReactStatics;
      /***/
    },
    /* 371 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      function cleanupSubscription(subscription) {
        var cleanup = subscription._cleanup;

        if (!cleanup) {
          return;
        }

        subscription._cleanup = undefined;
        cleanup();
      }

      function subscriptionClosed(subscription) {
        return subscription._observer === undefined;
      }

      function closeSubscription(subscription) {
        if (subscriptionClosed(subscription)) {
          return;
        }

        subscription._observer = undefined;
        cleanupSubscription(subscription);
      }

      function cleanupFromSubscription(subscription) {
        return function () {
          subscription.unsubscribe();
        };
      }

      var Subscription = function () {
        function Subscription(observer, subscriber) {
          if (Object(observer) !== observer) {
            throw new TypeError('Observer must be an object');
          }

          this._cleanup = undefined;
          this._observer = observer;

          if (observer.start) {
            observer.start(this);
          }

          if (subscriptionClosed(this)) {
            return;
          }

          var _observer = new SubscriptionObserver(this);

          try {
            var cleanup = subscriber(_observer);

            if (cleanup != null) {
              if (typeof cleanup.unsubscribe === 'function') {
                cleanup = cleanupFromSubscription(cleanup);
              } else if (typeof cleanup !== 'function') {
                throw new TypeError(cleanup + ' is not a function');
              }

              this._cleanup = cleanup;
            }
          } catch (e) {
            if (_observer.error) {
              _observer.error(e);
            }

            return;
          }

          if (subscriptionClosed(this)) {
            cleanupSubscription(this);
          }
        }

        Object.defineProperty(Subscription.prototype, "closed", {
          get: function get() {
            return subscriptionClosed(this);
          },
          enumerable: true,
          configurable: true
        });

        Subscription.prototype.unsubscribe = function () {
          closeSubscription(this);
        };

        return Subscription;
      }();

      exports.Subscription = Subscription;

      var SubscriptionObserver = function () {
        function SubscriptionObserver(subscription) {
          this._subscription = subscription;
        }

        Object.defineProperty(SubscriptionObserver.prototype, "closed", {
          get: function get() {
            return subscriptionClosed(this._subscription);
          },
          enumerable: true,
          configurable: true
        });

        SubscriptionObserver.prototype.next = function (value) {
          var subscription = this._subscription;

          if (subscriptionClosed(subscription)) {
            return;
          }

          var observer = subscription._observer;

          if (!observer.next) {
            return;
          }

          observer.next(value);
          return;
        };

        SubscriptionObserver.prototype.error = function (value) {
          var subscription = this._subscription;

          if (subscriptionClosed(subscription)) {
            throw value;
          }

          var observer = subscription._observer;
          subscription._observer = undefined;

          try {
            if (!observer.error) {
              throw value;
            }

            observer.error(value);
          } catch (e) {
            try {
              cleanupSubscription(subscription);
            } finally {
              throw e;
            }
          }

          cleanupSubscription(subscription);
        };

        SubscriptionObserver.prototype.complete = function () {
          var subscription = this._subscription;

          if (subscriptionClosed(subscription)) {
            return;
          }

          var observer = subscription._observer;
          subscription._observer = undefined;

          try {
            if (observer.complete) {
              observer.complete();
            }
          } catch (e) {
            try {
              cleanupSubscription(subscription);
            } finally {
              throw e;
            }
          }

          cleanupSubscription(subscription);
        };

        return SubscriptionObserver;
      }();

      exports.SubscriptionObserver = SubscriptionObserver;

      var Observable = function () {
        function Observable(subscriber) {
          if (typeof subscriber !== 'function') {
            throw new TypeError('Observable initializer must be a function');
          }

          this._subscriber = subscriber;
        }

        Observable.from = function (observable) {
          if (observable.subscribe) {
            return new Observable(function (observer) {
              return observable.subscribe(observer);
            });
          }

          if (Array.isArray(observable)) {
            return new Observable(function (observer) {
              for (var i = 0; i < observable.length; ++i) {
                observer.next(observable[i]);

                if (observer.closed) {
                  return;
                }
              }

              if (observer.complete) {
                observer.complete();
              }
            });
          }

          throw new TypeError(observable + ' is not observable');
        };

        Observable.of = function () {
          var items = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
          }

          return new Observable(function (observer) {
            for (var i = 0; i < items.length; ++i) {
              observer.next(items[i]);

              if (observer.closed) {
                return;
              }
            }

            if (observer.complete) {
              observer.complete();
            }
          });
        };

        Observable.prototype.subscribe = function (observerOrNext, error, complete) {
          if (typeof observerOrNext === 'function') {
            return new Subscription({
              next: observerOrNext,
              error: error,
              complete: complete
            }, this._subscriber);
          }

          return new Subscription(observerOrNext, this._subscriber);
        };

        Observable.prototype.forEach = function (fn) {
          var _this = this;

          return new Promise(function (resolve, reject) {
            if (typeof fn !== 'function') {
              return Promise.reject(new TypeError(fn + ' is not a function'));
            }

            _this.subscribe({
              start: function start(subscription) {
                this._subscription = subscription;
              },
              next: function next(value) {
                var subscription = this._subscription;

                if (subscription.closed) {
                  return;
                }

                try {
                  fn(value);
                  return;
                } catch (err) {
                  reject(err);
                  subscription.unsubscribe();
                }
              },
              error: reject,
              complete: resolve
            });
          });
        };

        Observable.prototype.map = function (fn) {
          var _this = this;

          if (typeof fn !== 'function') {
            throw new TypeError(fn + ' is not a function');
          }

          return new Observable(function (observer) {
            return _this.subscribe({
              next: function next(value) {
                if (observer.closed) {
                  return;
                }

                var _value;

                try {
                  _value = fn(value);
                } catch (e) {
                  observer.error(e);
                  return;
                }

                observer.next(_value);
              },
              error: function error(e) {
                observer.error(e);
              },
              complete: function complete() {
                observer.complete();
              }
            });
          });
        };

        Observable.prototype.filter = function (fn) {
          var _this = this;

          if (typeof fn !== 'function') {
            throw new TypeError(fn + ' is not a function');
          }

          return new Observable(function (observer) {
            _this.subscribe({
              next: function next(value) {
                if (observer.closed) {
                  return;
                }

                try {
                  if (!fn(value)) {
                    return;
                  }
                } catch (e) {
                  if (observer.error) {
                    observer.error(e);
                  }

                  return;
                }

                observer.next(value);
              },
              error: function error(e) {
                observer.error(e);
              },
              complete: function complete() {
                observer.complete();
              }
            });
          });
        };

        Observable.prototype.reduce = function (fn, initialValue) {
          var _this = this;

          if (typeof fn !== 'function') {
            throw new TypeError(fn + ' is not a function');
          }

          var hasSeed = arguments.length > 1;
          var hasValue = false;
          var seed = arguments[1];
          var acc = seed;
          return new Observable(function (observer) {
            _this.subscribe({
              next: function next(value) {
                if (observer.closed) {
                  return;
                }

                var first = !hasValue;
                hasValue = true;

                if (!first || hasSeed) {
                  try {
                    acc = fn(acc, value);
                  } catch (e) {
                    observer.error(e);
                    return;
                  }
                } else {
                  acc = value;
                }
              },
              error: function error(e) {
                observer.error(e);
              },
              complete: function complete() {
                if (!hasValue && !hasSeed) {
                  observer.error(new TypeError('Cannot reduce an empty sequence'));
                  return;
                }

                observer.next(acc);
                observer.complete();
              }
            });
          });
        };

        Observable.prototype.flatMap = function (fn) {
          var _this = this;

          if (typeof fn !== 'function') {
            throw new TypeError(fn + ' is not a function');
          }

          return new Observable(function (observer) {
            var completed = false;
            var subscriptions = [];

            var outer = _this.subscribe({
              next: function next(value) {
                var _value;

                if (fn) {
                  try {
                    _value = fn(value);
                  } catch (x) {
                    observer.error(x);
                    return;
                  }
                }

                Observable.from(_value).subscribe({
                  start: function start(s) {
                    subscriptions.push(this._subscription = s);
                  },
                  next: function next(data) {
                    observer.next(data);
                  },
                  error: function error(e) {
                    observer.error(e);
                  },
                  complete: function complete() {
                    var i = subscriptions.indexOf(this._subscription);

                    if (i >= 0) {
                      subscriptions.splice(i, 1);
                    }

                    closeIfDone();
                  }
                });
              },
              error: function error(e) {
                observer.error(e);
              },
              complete: function complete() {
                completed = true;
                closeIfDone();
              }
            });

            function closeIfDone() {
              if (completed && subscriptions.length === 0) {
                observer.complete();
              }
            }

            return function () {
              subscriptions.forEach(function (s) {
                return s.unsubscribe();
              });
              outer.unsubscribe();
            };
          });
        };

        return Observable;
      }();

      exports.default = Observable;
      /***/
    },
    /* 372 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.GraphQLError = GraphQLError;

      var _location = __webpack_require__(657);
      /**
       * A GraphQLError describes an Error found during the parse, validate, or
       * execute phases of performing a GraphQL operation. In addition to a message
       * and stack trace, it also includes information about the locations in a
       * GraphQL document and/or execution result that correspond to the Error.
       */


      function GraphQLError( // eslint-disable-line no-redeclare
      message, nodes, source, positions, path, originalError) {
        // Compute locations in the source for the given nodes/positions.
        var _source = source;

        if (!_source && nodes && nodes.length > 0) {
          var node = nodes[0];
          _source = node && node.loc && node.loc.source;
        }

        var _positions = positions;

        if (!_positions && nodes) {
          _positions = nodes.filter(function (node) {
            return Boolean(node.loc);
          }).map(function (node) {
            return node.loc.start;
          });
        }

        if (_positions && _positions.length === 0) {
          _positions = undefined;
        }

        var _locations = void 0;

        var _source2 = _source; // seems here Flow need a const to resolve type.

        if (_source2 && _positions) {
          _locations = _positions.map(function (pos) {
            return (0, _location.getLocation)(_source2, pos);
          });
        }

        Object.defineProperties(this, {
          message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
          },
          locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true
          },
          path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true
          },
          nodes: {
            value: nodes || undefined
          },
          source: {
            value: _source || undefined
          },
          positions: {
            value: _positions || undefined
          },
          originalError: {
            value: originalError
          }
        }); // Include (non-enumerable) stack trace.

        if (originalError && originalError.stack) {
          Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
          });
        } else if (Error.captureStackTrace) {
          Error.captureStackTrace(this, GraphQLError);
        } else {
          Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
          });
        }
      }
      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */


      GraphQLError.prototype = Object.create(Error.prototype, {
        constructor: {
          value: GraphQLError
        },
        name: {
          value: 'GraphQLError'
        }
      });
      /***/
    },
    /* 373 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js


      var objectWithoutProperties = __webpack_require__(42);

      var objectWithoutProperties_default =
      /*#__PURE__*/
      __webpack_require__.n(objectWithoutProperties); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/rc-trigger/es/index.js + 20 modules


      var es = __webpack_require__(75); // EXTERNAL MODULE: ./node_modules/rc-tooltip/es/placements.js


      var placements = __webpack_require__(284); // CONCATENATED MODULE: ./node_modules/rc-tooltip/es/Content.js


      var Content_Content = function (_React$Component) {
        inherits_default()(Content, _React$Component);

        function Content() {
          classCallCheck_default()(this, Content);
          return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
        }

        Content.prototype.componentDidUpdate = function componentDidUpdate() {
          var trigger = this.props.trigger;

          if (trigger) {
            trigger.forcePopupAlign();
          }
        };

        Content.prototype.render = function render() {
          var _props = this.props,
              overlay = _props.overlay,
              prefixCls = _props.prefixCls,
              id = _props.id;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-inner',
            id: id,
            role: 'tooltip'
          }, typeof overlay === 'function' ? overlay() : overlay);
        };

        return Content;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      Content_Content.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        overlay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]).isRequired,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        trigger: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any
      };
      /* harmony default export */

      var es_Content = Content_Content; // CONCATENATED MODULE: ./node_modules/rc-tooltip/es/Tooltip.js

      var Tooltip_Tooltip = function (_Component) {
        inherits_default()(Tooltip, _Component);

        function Tooltip() {
          var _temp, _this, _ret;

          classCallCheck_default()(this, Tooltip);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
            var _this$props = _this.props,
                arrowContent = _this$props.arrowContent,
                overlay = _this$props.overlay,
                prefixCls = _this$props.prefixCls,
                id = _this$props.id;
            return [external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
              className: prefixCls + '-arrow',
              key: 'arrow'
            }, arrowContent), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_Content, {
              key: 'content',
              trigger: _this.trigger,
              prefixCls: prefixCls,
              id: id,
              overlay: overlay
            })];
          }, _this.saveTrigger = function (node) {
            _this.trigger = node;
          }, _temp), possibleConstructorReturn_default()(_this, _ret);
        }

        Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
          return this.trigger.getPopupDomNode();
        };

        Tooltip.prototype.render = function render() {
          var _props = this.props,
              overlayClassName = _props.overlayClassName,
              trigger = _props.trigger,
              mouseEnterDelay = _props.mouseEnterDelay,
              mouseLeaveDelay = _props.mouseLeaveDelay,
              overlayStyle = _props.overlayStyle,
              prefixCls = _props.prefixCls,
              children = _props.children,
              onVisibleChange = _props.onVisibleChange,
              afterVisibleChange = _props.afterVisibleChange,
              transitionName = _props.transitionName,
              animation = _props.animation,
              placement = _props.placement,
              align = _props.align,
              destroyTooltipOnHide = _props.destroyTooltipOnHide,
              defaultVisible = _props.defaultVisible,
              getTooltipContainer = _props.getTooltipContainer,
              restProps = objectWithoutProperties_default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
          var extraProps = extends_default()({}, restProps);

          if ('visible' in this.props) {
            extraProps.popupVisible = this.props.visible;
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es["default"], extends_default()({
            popupClassName: overlayClassName,
            ref: this.saveTrigger,
            prefixCls: prefixCls,
            popup: this.getPopupElement,
            action: trigger,
            builtinPlacements: placements["a"
            /* placements */
            ],
            popupPlacement: placement,
            popupAlign: align,
            getPopupContainer: getTooltipContainer,
            onPopupVisibleChange: onVisibleChange,
            afterPopupVisibleChange: afterVisibleChange,
            popupTransitionName: transitionName,
            popupAnimation: animation,
            defaultPopupVisible: defaultVisible,
            destroyPopupOnHide: destroyTooltipOnHide,
            mouseLeaveDelay: mouseLeaveDelay,
            popupStyle: overlayStyle,
            mouseEnterDelay: mouseEnterDelay
          }, extraProps), children);
        };

        return Tooltip;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Tooltip_Tooltip.propTypes = {
        trigger: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        defaultVisible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        visible: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        placement: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        transitionName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object]),
        animation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        onVisibleChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        afterVisibleChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        overlay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func]).isRequired,
        overlayStyle: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        overlayClassName: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        mouseEnterDelay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        mouseLeaveDelay: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        getTooltipContainer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        destroyTooltipOnHide: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        align: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        arrowContent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.any,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      Tooltip_Tooltip.defaultProps = {
        prefixCls: 'rc-tooltip',
        mouseEnterDelay: 0,
        destroyTooltipOnHide: false,
        mouseLeaveDelay: 0.1,
        align: {},
        placement: 'right',
        trigger: ['hover'],
        arrowContent: null
      };
      /* harmony default export */

      var es_Tooltip = Tooltip_Tooltip; // CONCATENATED MODULE: ./node_modules/rc-tooltip/es/index.js

      /* harmony default export */

      var rc_tooltip_es = __webpack_exports__["default"] = es_Tooltip;
      /***/
    },
    /* 374 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1); // EXTERNAL MODULE: external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}


      var external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_ = __webpack_require__(16); // EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js


      var KeyCode = __webpack_require__(19); // EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/contains.js


      var contains = __webpack_require__(168); // EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 3 modules


      var Animate = __webpack_require__(43); // CONCATENATED MODULE: ./node_modules/rc-dialog/es/LazyRenderBox.js


      var LazyRenderBox_LazyRenderBox = function (_React$Component) {
        inherits_default()(LazyRenderBox, _React$Component);

        function LazyRenderBox() {
          classCallCheck_default()(this, LazyRenderBox);
          return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
        }

        LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          return !!nextProps.hiddenClassName || !!nextProps.visible;
        };

        LazyRenderBox.prototype.render = function render() {
          var className = this.props.className;

          if (!!this.props.hiddenClassName && !this.props.visible) {
            className += " " + this.props.hiddenClassName;
          }

          var props = extends_default()({}, this.props);
          delete props.hiddenClassName;
          delete props.visible;
          props.className = className;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", extends_default()({}, props));
        };

        return LazyRenderBox;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_LazyRenderBox = LazyRenderBox_LazyRenderBox; // CONCATENATED MODULE: ./node_modules/rc-util/es/getScrollBarSize.js

      var cached = void 0;

      function getScrollBarSize(fresh) {
        if (fresh || cached === undefined) {
          var inner = document.createElement('div');
          inner.style.width = '100%';
          inner.style.height = '200px';
          var outer = document.createElement('div');
          var outerStyle = outer.style;
          outerStyle.position = 'absolute';
          outerStyle.top = 0;
          outerStyle.left = 0;
          outerStyle.pointerEvents = 'none';
          outerStyle.visibility = 'hidden';
          outerStyle.width = '200px';
          outerStyle.height = '150px';
          outerStyle.overflow = 'hidden';
          outer.appendChild(inner);
          document.body.appendChild(outer);
          var widthContained = inner.offsetWidth;
          outer.style.overflow = 'scroll';
          var widthScroll = inner.offsetWidth;

          if (widthContained === widthScroll) {
            widthScroll = outer.clientWidth;
          }

          document.body.removeChild(outer);
          cached = widthContained - widthScroll;
        }

        return cached;
      } // CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog.js


      var Dialog_uuid = 0;
      var Dialog_openCount = 0;
      /* eslint react/no-is-mounted:0 */

      function Dialog_getScroll(w, top) {
        var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
        var method = 'scroll' + (top ? 'Top' : 'Left');

        if (typeof ret !== 'number') {
          var d = w.document;
          ret = d.documentElement[method];

          if (typeof ret !== 'number') {
            ret = d.body[method];
          }
        }

        return ret;
      }

      function Dialog_setTransformOrigin(node, value) {
        var style = node.style;
        ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
          style[prefix + 'TransformOrigin'] = value;
        });
        style['transformOrigin'] = value;
      }

      function Dialog_offset(el) {
        var rect = el.getBoundingClientRect();
        var pos = {
          left: rect.left,
          top: rect.top
        };
        var doc = el.ownerDocument;
        var w = doc.defaultView || doc.parentWindow;
        pos.left += Dialog_getScroll(w);
        pos.top += Dialog_getScroll(w, true);
        return pos;
      }

      var Dialog_Dialog = function (_React$Component) {
        inherits_default()(Dialog, _React$Component);

        function Dialog() {
          classCallCheck_default()(this, Dialog);

          var _this = possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));

          _this.onAnimateLeave = function () {
            var afterClose = _this.props.afterClose; // need demo?
            // https://github.com/react-component/dialog/pull/28

            if (_this.wrap) {
              _this.wrap.style.display = 'none';
            }

            _this.inTransition = false;

            _this.removeScrollingEffect();

            if (afterClose) {
              afterClose();
            }
          };

          _this.onMaskClick = function (e) {
            // android trigger click on open (fastclick??)
            if (Date.now() - _this.openTime < 300) {
              return;
            }

            if (e.target === e.currentTarget) {
              _this.close(e);
            }
          };

          _this.onKeyDown = function (e) {
            var props = _this.props;

            if (props.keyboard && e.keyCode === KeyCode["a"
            /* default */
            ].ESC) {
              e.stopPropagation();

              _this.close(e);

              return;
            } // keep focus inside dialog


            if (props.visible) {
              if (e.keyCode === KeyCode["a"
              /* default */
              ].TAB) {
                var activeElement = document.activeElement;
                var dialogRoot = _this.wrap;

                if (e.shiftKey) {
                  if (activeElement === dialogRoot) {
                    _this.sentinel.focus();
                  }
                } else if (activeElement === _this.sentinel) {
                  dialogRoot.focus();
                }
              }
            }
          };

          _this.getDialogElement = function () {
            var props = _this.props;
            var closable = props.closable;
            var prefixCls = props.prefixCls;
            var dest = {};

            if (props.width !== undefined) {
              dest.width = props.width;
            }

            if (props.height !== undefined) {
              dest.height = props.height;
            }

            var footer = void 0;

            if (props.footer) {
              footer = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
                className: prefixCls + '-footer',
                ref: _this.saveRef('footer')
              }, props.footer);
            }

            var header = void 0;

            if (props.title) {
              header = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
                className: prefixCls + '-header',
                ref: _this.saveRef('header')
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
                className: prefixCls + '-title',
                id: _this.titleId
              }, props.title));
            }

            var closer = void 0;

            if (closable) {
              closer = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("button", {
                onClick: _this.close,
                "aria-label": "Close",
                className: prefixCls + '-close'
              }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("span", {
                className: prefixCls + '-close-x'
              }));
            }

            var style = extends_default()({}, props.style, dest);

            var transitionName = _this.getTransitionName();

            var dialogElement = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_LazyRenderBox, {
              key: "dialog-element",
              role: "document",
              ref: _this.saveRef('dialog'),
              style: style,
              className: prefixCls + ' ' + (props.className || ''),
              visible: props.visible
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
              className: prefixCls + '-content'
            }, closer, header, external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", extends_default()({
              className: prefixCls + '-body',
              style: props.bodyStyle,
              ref: _this.saveRef('body')
            }, props.bodyProps), props.children), footer), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", {
              tabIndex: 0,
              ref: _this.saveRef('sentinel'),
              style: {
                width: 0,
                height: 0,
                overflow: 'hidden'
              }
            }, "sentinel"));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], {
              key: "dialog",
              showProp: "visible",
              onLeave: _this.onAnimateLeave,
              transitionName: transitionName,
              component: "",
              transitionAppear: true
            }, props.visible || !props.destroyOnClose ? dialogElement : null);
          };

          _this.getZIndexStyle = function () {
            var style = {};
            var props = _this.props;

            if (props.zIndex !== undefined) {
              style.zIndex = props.zIndex;
            }

            return style;
          };

          _this.getWrapStyle = function () {
            return extends_default()({}, _this.getZIndexStyle(), _this.props.wrapStyle);
          };

          _this.getMaskStyle = function () {
            return extends_default()({}, _this.getZIndexStyle(), _this.props.maskStyle);
          };

          _this.getMaskElement = function () {
            var props = _this.props;
            var maskElement = void 0;

            if (props.mask) {
              var maskTransition = _this.getMaskTransitionName();

              maskElement = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_LazyRenderBox, extends_default()({
                style: _this.getMaskStyle(),
                key: "mask",
                className: props.prefixCls + '-mask',
                hiddenClassName: props.prefixCls + '-mask-hidden',
                visible: props.visible
              }, props.maskProps));

              if (maskTransition) {
                maskElement = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Animate["default"], {
                  key: "mask",
                  showProp: "visible",
                  transitionAppear: true,
                  component: "",
                  transitionName: maskTransition
                }, maskElement);
              }
            }

            return maskElement;
          };

          _this.getMaskTransitionName = function () {
            var props = _this.props;
            var transitionName = props.maskTransitionName;
            var animation = props.maskAnimation;

            if (!transitionName && animation) {
              transitionName = props.prefixCls + '-' + animation;
            }

            return transitionName;
          };

          _this.getTransitionName = function () {
            var props = _this.props;
            var transitionName = props.transitionName;
            var animation = props.animation;

            if (!transitionName && animation) {
              transitionName = props.prefixCls + '-' + animation;
            }

            return transitionName;
          };

          _this.setScrollbar = function () {
            if (_this.bodyIsOverflowing && _this.scrollbarWidth !== undefined) {
              document.body.style.paddingRight = _this.scrollbarWidth + 'px';
            }
          };

          _this.addScrollingEffect = function () {
            Dialog_openCount++;

            if (Dialog_openCount !== 1) {
              return;
            }

            _this.checkScrollbar();

            _this.setScrollbar();

            document.body.style.overflow = 'hidden'; // this.adjustDialog();
          };

          _this.removeScrollingEffect = function () {
            Dialog_openCount--;

            if (Dialog_openCount !== 0) {
              return;
            }

            document.body.style.overflow = '';

            _this.resetScrollbar(); // this.resetAdjustments();

          };

          _this.close = function (e) {
            var onClose = _this.props.onClose;

            if (onClose) {
              onClose(e);
            }
          };

          _this.checkScrollbar = function () {
            var fullWindowWidth = window.innerWidth;

            if (!fullWindowWidth) {
              // workaround for missing window.innerWidth in IE8
              var documentElementRect = document.documentElement.getBoundingClientRect();
              fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
            }

            _this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;

            if (_this.bodyIsOverflowing) {
              _this.scrollbarWidth = getScrollBarSize();
            }
          };

          _this.resetScrollbar = function () {
            document.body.style.paddingRight = '';
          };

          _this.adjustDialog = function () {
            if (_this.wrap && _this.scrollbarWidth !== undefined) {
              var modalIsOverflowing = _this.wrap.scrollHeight > document.documentElement.clientHeight;
              _this.wrap.style.paddingLeft = (!_this.bodyIsOverflowing && modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
              _this.wrap.style.paddingRight = (_this.bodyIsOverflowing && !modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
            }
          };

          _this.resetAdjustments = function () {
            if (_this.wrap) {
              _this.wrap.style.paddingLeft = _this.wrap.style.paddingLeft = '';
            }
          };

          _this.saveRef = function (name) {
            return function (node) {
              _this[name] = node;
            };
          };

          return _this;
        }

        Dialog.prototype.componentWillMount = function componentWillMount() {
          this.inTransition = false;
          this.titleId = 'rcDialogTitle' + Dialog_uuid++;
        };

        Dialog.prototype.componentDidMount = function componentDidMount() {
          this.componentDidUpdate({});
        };

        Dialog.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
          var props = this.props;
          var mousePosition = this.props.mousePosition;

          if (props.visible) {
            // first show
            if (!prevProps.visible) {
              this.openTime = Date.now();
              this.addScrollingEffect();
              this.tryFocus();
              var dialogNode = external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_["findDOMNode"](this.dialog);

              if (mousePosition) {
                var elOffset = Dialog_offset(dialogNode);
                Dialog_setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
              } else {
                Dialog_setTransformOrigin(dialogNode, '');
              }
            }
          } else if (prevProps.visible) {
            this.inTransition = true;

            if (props.mask && this.lastOutSideFocusNode) {
              try {
                this.lastOutSideFocusNode.focus();
              } catch (e) {
                this.lastOutSideFocusNode = null;
              }

              this.lastOutSideFocusNode = null;
            }
          }
        };

        Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
          if (this.props.visible || this.inTransition) {
            this.removeScrollingEffect();
          }
        };

        Dialog.prototype.tryFocus = function tryFocus() {
          if (!Object(contains["a"
          /* default */
          ])(this.wrap, document.activeElement)) {
            this.lastOutSideFocusNode = document.activeElement;
            this.wrap.focus();
          }
        };

        Dialog.prototype.render = function render() {
          var props = this.props;
          var prefixCls = props.prefixCls,
              maskClosable = props.maskClosable;
          var style = this.getWrapStyle(); // clear hide display
          // and only set display after async anim, not here for hide

          if (props.visible) {
            style.display = null;
          }

          return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", null, this.getMaskElement(), external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"]("div", extends_default()({
            tabIndex: -1,
            onKeyDown: this.onKeyDown,
            className: prefixCls + '-wrap ' + (props.wrapClassName || ''),
            ref: this.saveRef('wrap'),
            onClick: maskClosable ? this.onMaskClick : undefined,
            role: "dialog",
            "aria-labelledby": props.title ? this.titleId : null,
            style: style
          }, props.wrapProps), this.getDialogElement()));
        };

        return Dialog;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);
      /* harmony default export */


      var es_Dialog = Dialog_Dialog;
      Dialog_Dialog.defaultProps = {
        className: '',
        mask: true,
        visible: false,
        keyboard: true,
        closable: true,
        maskClosable: true,
        destroyOnClose: false,
        prefixCls: 'rc-dialog'
      }; // EXTERNAL MODULE: ./node_modules/rc-util/es/ContainerRender.js

      var ContainerRender = __webpack_require__(294); // EXTERNAL MODULE: ./node_modules/rc-util/es/Portal.js


      var Portal = __webpack_require__(293); // CONCATENATED MODULE: ./node_modules/rc-dialog/es/DialogWrap.js


      var DialogWrap_IS_REACT_16 = 'createPortal' in external_root_ReactDOM_commonjs2_react_dom_commonjs_react_dom_amd_react_dom_;

      var DialogWrap_DialogWrap = function (_React$Component) {
        inherits_default()(DialogWrap, _React$Component);

        function DialogWrap() {
          classCallCheck_default()(this, DialogWrap);

          var _this = possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));

          _this.saveDialog = function (node) {
            _this._component = node;
          };

          _this.getComponent = function () {
            var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](es_Dialog, extends_default()({
              ref: _this.saveDialog
            }, _this.props, extra, {
              key: "dialog"
            }));
          }; // fix issue #10656

          /*
          * Custom container should not be return, because in the Portal component, it will remove the
          * return container element here, if the custom container is the only child of it's component,
          * like issue #10656, It will has a conflict with removeChild method in react-dom.
          * So here should add a child (div element) to custom container.
          * */


          _this.getContainer = function () {
            var container = document.createElement('div');

            if (_this.props.getContainer) {
              _this.props.getContainer().appendChild(container);
            } else {
              document.body.appendChild(container);
            }

            return container;
          };

          return _this;
        }

        DialogWrap.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref) {
          var visible = _ref.visible;
          return !!(this.props.visible || visible);
        };

        DialogWrap.prototype.componentWillUnmount = function componentWillUnmount() {
          if (DialogWrap_IS_REACT_16) {
            return;
          }

          if (this.props.visible) {
            this.renderComponent({
              afterClose: this.removeContainer,
              onClose: function onClose() {},
              visible: false
            });
          } else {
            this.removeContainer();
          }
        };

        DialogWrap.prototype.render = function render() {
          var _this2 = this;

          var visible = this.props.visible;
          var portal = null;

          if (!DialogWrap_IS_REACT_16) {
            return external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](ContainerRender["a"
            /* default */
            ], {
              parent: this,
              visible: visible,
              autoDestroy: false,
              getComponent: this.getComponent,
              getContainer: this.getContainer
            }, function (_ref2) {
              var renderComponent = _ref2.renderComponent,
                  removeContainer = _ref2.removeContainer;
              _this2.renderComponent = renderComponent;
              _this2.removeContainer = removeContainer;
              return null;
            });
          }

          if (visible || this._component) {
            portal = external_root_React_commonjs2_react_commonjs_react_amd_react_["createElement"](Portal["a"
            /* default */
            ], {
              getContainer: this.getContainer
            }, this.getComponent());
          }

          return portal;
        };

        return DialogWrap;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      DialogWrap_DialogWrap.defaultProps = {
        visible: false
      };
      /* harmony default export */

      var es_DialogWrap = __webpack_exports__["default"] = DialogWrap_DialogWrap;
      /***/
    },
    /* 375 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // EXTERNAL MODULE: ./node_modules/is-negative-zero/index.js


      var is_negative_zero = __webpack_require__(705);

      var is_negative_zero_default =
      /*#__PURE__*/
      __webpack_require__.n(is_negative_zero); // EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js


      var KeyCode = __webpack_require__(19); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js


      var objectWithoutProperties = __webpack_require__(42);

      var objectWithoutProperties_default =
      /*#__PURE__*/
      __webpack_require__.n(objectWithoutProperties); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js


      var createClass = __webpack_require__(12);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // CONCATENATED MODULE: ./node_modules/rmc-feedback/es/TouchFeedback.js


      var TouchFeedback_TouchFeedback = function (_React$Component) {
        inherits_default()(TouchFeedback, _React$Component);

        function TouchFeedback() {
          classCallCheck_default()(this, TouchFeedback);

          var _this = possibleConstructorReturn_default()(this, (TouchFeedback.__proto__ || Object.getPrototypeOf(TouchFeedback)).apply(this, arguments));

          _this.state = {
            active: false
          };

          _this.onTouchStart = function (e) {
            _this.triggerEvent('TouchStart', true, e);
          };

          _this.onTouchMove = function (e) {
            _this.triggerEvent('TouchMove', false, e);
          };

          _this.onTouchEnd = function (e) {
            _this.triggerEvent('TouchEnd', false, e);
          };

          _this.onTouchCancel = function (e) {
            _this.triggerEvent('TouchCancel', false, e);
          };

          _this.onMouseDown = function (e) {
            // pc simulate mobile
            _this.triggerEvent('MouseDown', true, e);
          };

          _this.onMouseUp = function (e) {
            _this.triggerEvent('MouseUp', false, e);
          };

          _this.onMouseLeave = function (e) {
            _this.triggerEvent('MouseLeave', false, e);
          };

          return _this;
        }

        createClass_default()(TouchFeedback, [{
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            if (this.props.disabled && this.state.active) {
              this.setState({
                active: false
              });
            }
          }
        }, {
          key: 'triggerEvent',
          value: function triggerEvent(type, isActive, ev) {
            var eventType = 'on' + type;
            var children = this.props.children;

            if (children.props[eventType]) {
              children.props[eventType](ev);
            }

            if (isActive !== this.state.active) {
              this.setState({
                active: isActive
              });
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                activeClassName = _props.activeClassName,
                activeStyle = _props.activeStyle;
            var events = disabled ? undefined : {
              onTouchStart: this.onTouchStart,
              onTouchMove: this.onTouchMove,
              onTouchEnd: this.onTouchEnd,
              onTouchCancel: this.onTouchCancel,
              onMouseDown: this.onMouseDown,
              onMouseUp: this.onMouseUp,
              onMouseLeave: this.onMouseLeave
            };
            var child = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.only(children);

            if (!disabled && this.state.active) {
              var _child$props = child.props,
                  style = _child$props.style,
                  className = _child$props.className;

              if (activeStyle !== false) {
                if (activeStyle) {
                  style = extends_default()({}, style, activeStyle);
                }

                className = classnames_default()(className, activeClassName);
              }

              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(child, extends_default()({
                className: className,
                style: style
              }, events));
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(child, events);
          }
        }]);
        return TouchFeedback;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);
      /* harmony default export */


      var es_TouchFeedback = TouchFeedback_TouchFeedback;
      TouchFeedback_TouchFeedback.defaultProps = {
        disabled: false
      }; // CONCATENATED MODULE: ./node_modules/rmc-feedback/es/index.js
      // CONCATENATED MODULE: ./node_modules/rc-input-number/es/InputHandler.js

      var InputHandler_InputHandler = function (_Component) {
        inherits_default()(InputHandler, _Component);

        function InputHandler() {
          classCallCheck_default()(this, InputHandler);
          return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
        }

        InputHandler.prototype.render = function render() {
          var _props = this.props,
              prefixCls = _props.prefixCls,
              disabled = _props.disabled,
              otherProps = objectWithoutProperties_default()(_props, ['prefixCls', 'disabled']);
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_TouchFeedback, {
            disabled: disabled,
            activeClassName: prefixCls + '-handler-active'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', otherProps));
        };

        return InputHandler;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      InputHandler_InputHandler.propTypes = {
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onTouchStart: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onTouchEnd: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseUp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };
      /* harmony default export */

      var es_InputHandler = InputHandler_InputHandler; // CONCATENATED MODULE: ./node_modules/rc-input-number/es/index.js

      function es_noop() {}

      function es_preventDefault(e) {
        e.preventDefault();
      }

      function es_defaultParser(input) {
        return input.replace(/[^\w\.-]+/g, '');
      }
      /**
       * When click and hold on a button - the speed of auto changin the value.
       */


      var es_SPEED = 200;
      /**
       * When click and hold on a button - the delay before auto changin the value.
       */

      var es_DELAY = 600;
      /**
       * Max Safe Integer -- on IE this is not available, so manually set the number in that case.
       * The reason this is used, instead of Infinity is because numbers above the MSI are unstable
       */

      var es_MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

      var es_InputNumber = function (_React$Component) {
        inherits_default()(InputNumber, _React$Component);

        function InputNumber(props) {
          classCallCheck_default()(this, InputNumber);

          var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

          es_initialiseProps.call(_this);
          var value = void 0;

          if ('value' in props) {
            value = props.value;
          } else {
            value = props.defaultValue;
          }

          value = _this.toNumber(value);
          _this.state = {
            inputValue: _this.toPrecisionAsStep(value),
            value: value,
            focused: props.autoFocus
          };
          return _this;
        }

        InputNumber.prototype.componentDidMount = function componentDidMount() {
          this.componentDidUpdate();
        };

        InputNumber.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          if ('value' in nextProps) {
            var value = this.state.focused ? nextProps.value : this.getValidValue(nextProps.value, nextProps.min, nextProps.max);
            this.setState({
              value: value,
              inputValue: this.inputting ? value : this.toPrecisionAsStep(value)
            });
          } // Trigger onChange when max or min change
          // https://github.com/ant-design/ant-design/issues/11574


          var nextValue = 'value' in nextProps ? nextProps.value : this.state.value;
          var _props = this.props,
              onChange = _props.onChange,
              max = _props.max,
              min = _props.min;

          if ('max' in nextProps && nextProps.max !== max && nextValue > nextProps.max && onChange) {
            onChange(nextProps.max);
          }

          if ('min' in nextProps && nextProps.min !== min && nextValue < nextProps.min && onChange) {
            onChange(nextProps.min);
          }
        };

        InputNumber.prototype.componentDidUpdate = function componentDidUpdate() {
          // Restore cursor
          try {
            // Firefox set the input cursor after it get focused.
            // This caused that if an input didn't init with the selection,
            // set will cause cursor not correct when first focus.
            // Safari will focus input if set selection. We need skip this.
            if (this.cursorStart !== undefined && this.state.focused) {
              // In most cases, the string after cursor is stable.
              // We can move the cursor before it
              if ( // If not match full str, try to match part of str
              !this.partRestoreByAfter(this.cursorAfter)) {
                // If not match any of then, let's just keep the position
                // TODO: Logic should not reach here, need check if happens
                var pos = this.cursorStart + 1; // If not have last string, just position to the end

                if (!this.cursorAfter) {
                  pos = this.input.value.length;
                } else if (this.lastKeyCode === KeyCode["a"
                /* default */
                ].BACKSPACE) {
                  pos = this.cursorStart - 1;
                } else if (this.lastKeyCode === KeyCode["a"
                /* default */
                ].DELETE) {
                  pos = this.cursorStart;
                }

                this.fixCaret(pos, pos);
              } else if (this.currentValue === this.input.value) {
                // Handle some special key code
                switch (this.lastKeyCode) {
                  case KeyCode["a"
                  /* default */
                  ].BACKSPACE:
                    this.fixCaret(this.cursorStart - 1, this.cursorStart - 1);
                    break;

                  case KeyCode["a"
                  /* default */
                  ].DELETE:
                    this.fixCaret(this.cursorStart + 1, this.cursorStart + 1);
                    break;

                  default: // Do nothing

                }
              }
            }
          } catch (e) {} // Do nothing
          // Reset last key


          this.lastKeyCode = null; // pressingUpOrDown is true means that someone just click up or down button

          if (!this.pressingUpOrDown) {
            return;
          }

          if (this.props.focusOnUpDown && this.state.focused) {
            if (document.activeElement !== this.input) {
              this.focus();
            }
          }

          this.pressingUpOrDown = false;
        };

        InputNumber.prototype.componentWillUnmount = function componentWillUnmount() {
          this.stop();
        };

        InputNumber.prototype.getCurrentValidValue = function getCurrentValidValue(value) {
          var val = value;

          if (val === '') {
            val = '';
          } else if (!this.isNotCompleteNumber(val)) {
            val = this.getValidValue(val);
          } else {
            val = this.state.value;
          }

          return this.toNumber(val);
        };

        InputNumber.prototype.getRatio = function getRatio(e) {
          var ratio = 1;

          if (e.metaKey || e.ctrlKey) {
            ratio = 0.1;
          } else if (e.shiftKey) {
            ratio = 10;
          }

          return ratio;
        };

        InputNumber.prototype.getValueFromEvent = function getValueFromEvent(e) {
          // optimize for chinese input expierence
          // https://github.com/ant-design/ant-design/issues/8196
          return e.target.value.trim().replace(/。/g, '.');
        };

        InputNumber.prototype.getValidValue = function getValidValue(value) {
          var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.min;
          var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.max;
          var val = parseFloat(value, 10); // https://github.com/ant-design/ant-design/issues/7358

          if (isNaN(val)) {
            return value;
          }

          if (val < min) {
            val = min;
          }

          if (val > max) {
            val = max;
          }

          return val;
        };

        InputNumber.prototype.setValue = function setValue(v, callback) {
          // trigger onChange
          var newValue = this.isNotCompleteNumber(parseFloat(v, 10)) ? undefined : parseFloat(v, 10);
          var changed = newValue !== this.state.value || '' + newValue !== '' + this.state.inputValue; // https://github.com/ant-design/ant-design/issues/7363

          if (!('value' in this.props)) {
            this.setState({
              value: newValue,
              inputValue: this.toPrecisionAsStep(v)
            }, callback);
          } else {
            // always set input value same as value
            this.setState({
              inputValue: this.toPrecisionAsStep(this.state.value)
            }, callback);
          }

          if (changed) {
            this.props.onChange(newValue);
          }
        };

        InputNumber.prototype.getPrecision = function getPrecision(value) {
          if ('precision' in this.props) {
            return this.props.precision;
          }

          var valueString = value.toString();

          if (valueString.indexOf('e-') >= 0) {
            return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
          }

          var precision = 0;

          if (valueString.indexOf('.') >= 0) {
            precision = valueString.length - valueString.indexOf('.') - 1;
          }

          return precision;
        }; // step={1.0} value={1.51}
        // press +
        // then value should be 2.51, rather than 2.5
        // if this.props.precision is undefined
        // https://github.com/react-component/input-number/issues/39


        InputNumber.prototype.getMaxPrecision = function getMaxPrecision(currentValue) {
          var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          if ('precision' in this.props) {
            return this.props.precision;
          }

          var step = this.props.step;
          var ratioPrecision = this.getPrecision(ratio);
          var stepPrecision = this.getPrecision(step);
          var currentValuePrecision = this.getPrecision(currentValue);

          if (!currentValue) {
            return ratioPrecision + stepPrecision;
          }

          return Math.max(currentValuePrecision, ratioPrecision + stepPrecision);
        };

        InputNumber.prototype.getPrecisionFactor = function getPrecisionFactor(currentValue) {
          var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          var precision = this.getMaxPrecision(currentValue, ratio);
          return Math.pow(10, precision);
        };

        InputNumber.prototype.fixCaret = function fixCaret(start, end) {
          if (start === undefined || end === undefined || !this.input || !this.input.value) {
            return;
          }

          try {
            var currentStart = this.input.selectionStart;
            var currentEnd = this.input.selectionEnd;

            if (start !== currentStart || end !== currentEnd) {
              this.input.setSelectionRange(start, end);
            }
          } catch (e) {// Fix error in Chrome:
            // Failed to read the 'selectionStart' property from 'HTMLInputElement'
            // http://stackoverflow.com/q/21177489/3040605
          }
        };

        InputNumber.prototype.focus = function focus() {
          this.input.focus();
          this.recordCursorPosition();
        };

        InputNumber.prototype.blur = function blur() {
          this.input.blur();
        };

        InputNumber.prototype.formatWrapper = function formatWrapper(num) {
          // http://2ality.com/2012/03/signedzero.html
          // https://github.com/ant-design/ant-design/issues/9439
          if (is_negative_zero_default()(num)) {
            return '-0';
          }

          if (this.props.formatter) {
            return this.props.formatter(num);
          }

          return num;
        };

        InputNumber.prototype.toPrecisionAsStep = function toPrecisionAsStep(num) {
          if (this.isNotCompleteNumber(num) || num === '') {
            return num;
          }

          var precision = Math.abs(this.getMaxPrecision(num));

          if (precision === 0) {
            return num.toString();
          }

          if (!isNaN(precision)) {
            return Number(num).toFixed(precision);
          }

          return num.toString();
        }; // '1.' '1x' 'xx' '' => are not complete numbers


        InputNumber.prototype.isNotCompleteNumber = function isNotCompleteNumber(num) {
          return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
        };

        InputNumber.prototype.toNumber = function toNumber(num) {
          if (this.isNotCompleteNumber(num)) {
            return num;
          }

          if ('precision' in this.props) {
            return Number(Number(num).toFixed(this.props.precision));
          }

          return Number(num);
        }; // '1.0' '1.00'  => may be a inputing number


        InputNumber.prototype.toNumberWhenUserInput = function toNumberWhenUserInput(num) {
          // num.length > 16 => prevent input large number will became Infinity
          if ((/\.\d*0$/.test(num) || num.length > 16) && this.state.focused) {
            return num;
          }

          return this.toNumber(num);
        };

        InputNumber.prototype.upStep = function upStep(val, rat) {
          var _props2 = this.props,
              step = _props2.step,
              min = _props2.min;
          var precisionFactor = this.getPrecisionFactor(val, rat);
          var precision = Math.abs(this.getMaxPrecision(val, rat));
          var result = void 0;

          if (typeof val === 'number') {
            result = ((precisionFactor * val + precisionFactor * step * rat) / precisionFactor).toFixed(precision);
          } else {
            result = min === -Infinity ? step : min;
          }

          return this.toNumber(result);
        };

        InputNumber.prototype.downStep = function downStep(val, rat) {
          var _props3 = this.props,
              step = _props3.step,
              min = _props3.min;
          var precisionFactor = this.getPrecisionFactor(val, rat);
          var precision = Math.abs(this.getMaxPrecision(val, rat));
          var result = void 0;

          if (typeof val === 'number') {
            result = ((precisionFactor * val - precisionFactor * step * rat) / precisionFactor).toFixed(precision);
          } else {
            result = min === -Infinity ? -step : min;
          }

          return this.toNumber(result);
        };

        InputNumber.prototype.step = function step(type, e) {
          var _this2 = this;

          var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
          var recursive = arguments[3];
          this.stop();

          if (e) {
            e.persist();
            e.preventDefault();
          }

          var props = this.props;

          if (props.disabled) {
            return;
          }

          var value = this.getCurrentValidValue(this.state.inputValue) || 0;

          if (this.isNotCompleteNumber(value)) {
            return;
          }

          var val = this[type + 'Step'](value, ratio);
          var outOfRange = val > props.max || val < props.min;

          if (val > props.max) {
            val = props.max;
          } else if (val < props.min) {
            val = props.min;
          }

          this.setValue(val);
          this.setState({
            focused: true
          });

          if (outOfRange) {
            return;
          }

          this.autoStepTimer = setTimeout(function () {
            _this2[type](e, ratio, true);
          }, recursive ? es_SPEED : es_DELAY);
        };

        InputNumber.prototype.render = function render() {
          var _classNames;

          var props = extends_default()({}, this.props);
          var prefixCls = props.prefixCls,
              disabled = props.disabled,
              readOnly = props.readOnly,
              useTouch = props.useTouch;
          var classes = classnames_default()((_classNames = {}, _classNames[prefixCls] = true, _classNames[props.className] = !!props.className, _classNames[prefixCls + '-disabled'] = disabled, _classNames[prefixCls + '-focused'] = this.state.focused, _classNames));
          var upDisabledClass = '';
          var downDisabledClass = '';
          var value = this.state.value;

          if (value || value === 0) {
            if (!isNaN(value)) {
              var val = Number(value);

              if (val >= props.max) {
                upDisabledClass = prefixCls + '-handler-up-disabled';
              }

              if (val <= props.min) {
                downDisabledClass = prefixCls + '-handler-down-disabled';
              }
            } else {
              upDisabledClass = prefixCls + '-handler-up-disabled';
              downDisabledClass = prefixCls + '-handler-down-disabled';
            }
          }

          var dataOrAriaAttributeProps = {};

          for (var key in props) {
            if (props.hasOwnProperty(key) && (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')) {
              dataOrAriaAttributeProps[key] = props[key];
            }
          }

          var editable = !props.readOnly && !props.disabled; // focus state, show input value
          // unfocus state, show valid value

          var inputDisplayValue = this.getInputDisplayValue();
          var upEvents = void 0;
          var downEvents = void 0;

          if (useTouch) {
            upEvents = {
              onTouchStart: editable && !upDisabledClass ? this.up : es_noop,
              onTouchEnd: this.stop
            };
            downEvents = {
              onTouchStart: editable && !downDisabledClass ? this.down : es_noop,
              onTouchEnd: this.stop
            };
          } else {
            upEvents = {
              onMouseDown: editable && !upDisabledClass ? this.up : es_noop,
              onMouseUp: this.stop,
              onMouseLeave: this.stop
            };
            downEvents = {
              onMouseDown: editable && !downDisabledClass ? this.down : es_noop,
              onMouseUp: this.stop,
              onMouseLeave: this.stop
            };
          }

          var inputDisplayValueFormat = this.formatWrapper(inputDisplayValue);
          var isUpDisabled = !!upDisabledClass || disabled || readOnly;
          var isDownDisabled = !!downDisabledClass || disabled || readOnly; // ref for test

          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: classes,
            style: props.style,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            onMouseOver: props.onMouseOver,
            onMouseOut: props.onMouseOut
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-handler-wrap'
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_InputHandler, extends_default()({
            ref: this.saveUp,
            disabled: isUpDisabled,
            prefixCls: prefixCls,
            unselectable: 'unselectable'
          }, upEvents, {
            role: 'button',
            'aria-label': 'Increase Value',
            'aria-disabled': !!isUpDisabled,
            className: prefixCls + '-handler ' + prefixCls + '-handler-up ' + upDisabledClass
          }), this.props.upHandler || external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            unselectable: 'unselectable',
            className: prefixCls + '-handler-up-inner',
            onClick: es_preventDefault
          })), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(es_InputHandler, extends_default()({
            ref: this.saveDown,
            disabled: isDownDisabled,
            prefixCls: prefixCls,
            unselectable: 'unselectable'
          }, downEvents, {
            role: 'button',
            'aria-label': 'Decrease Value',
            'aria-disabled': !!isDownDisabled,
            className: prefixCls + '-handler ' + prefixCls + '-handler-down ' + downDisabledClass
          }), this.props.downHandler || external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('span', {
            unselectable: 'unselectable',
            className: prefixCls + '-handler-down-inner',
            onClick: es_preventDefault
          }))), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-input-wrap',
            role: 'spinbutton',
            'aria-valuemin': props.min,
            'aria-valuemax': props.max,
            'aria-valuenow': value
          }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('input', extends_default()({
            required: props.required,
            type: props.type,
            placeholder: props.placeholder,
            onClick: props.onClick,
            onMouseUp: this.onMouseUp,
            className: prefixCls + '-input',
            tabIndex: props.tabIndex,
            autoComplete: 'off',
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: editable ? this.onKeyDown : es_noop,
            onKeyUp: editable ? this.onKeyUp : es_noop,
            autoFocus: props.autoFocus,
            maxLength: props.maxLength,
            readOnly: props.readOnly,
            disabled: props.disabled,
            max: props.max,
            min: props.min,
            step: props.step,
            name: props.name,
            id: props.id,
            onChange: this.onChange,
            ref: this.saveInput,
            value: inputDisplayValueFormat,
            pattern: props.pattern
          }, dataOrAriaAttributeProps))));
        };

        return InputNumber;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);

      es_InputNumber.propTypes = {
        value: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        defaultValue: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        focusOnUpDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        autoFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onChange: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onKeyDown: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onKeyUp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        tabIndex: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number]),
        disabled: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        onFocus: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onBlur: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        readOnly: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        max: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        min: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        step: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        upHandler: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        downHandler: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node,
        useTouch: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        formatter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        parser: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseEnter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseLeave: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseOver: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseOut: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        onMouseUp: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        precision: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        required: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        pattern: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      es_InputNumber.defaultProps = {
        focusOnUpDown: true,
        useTouch: false,
        prefixCls: 'rc-input-number',
        min: -es_MAX_SAFE_INTEGER,
        step: 1,
        style: {},
        onChange: es_noop,
        onKeyDown: es_noop,
        onFocus: es_noop,
        onBlur: es_noop,
        parser: es_defaultParser,
        required: false
      };

      var es_initialiseProps = function _initialiseProps() {
        var _this3 = this;

        this.onKeyDown = function (e) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var onKeyDown = _this3.props.onKeyDown;

          if (e.keyCode === KeyCode["a"
          /* default */
          ].UP) {
            var ratio = _this3.getRatio(e);

            _this3.up(e, ratio);

            _this3.stop();
          } else if (e.keyCode === KeyCode["a"
          /* default */
          ].DOWN) {
            var _ratio = _this3.getRatio(e);

            _this3.down(e, _ratio);

            _this3.stop();
          } // Trigger user key down


          _this3.recordCursorPosition();

          _this3.lastKeyCode = e.keyCode;

          if (onKeyDown) {
            onKeyDown.apply(undefined, [e].concat(args));
          }
        };

        this.onKeyUp = function (e) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          var onKeyUp = _this3.props.onKeyUp;

          _this3.stop();

          _this3.recordCursorPosition(); // Trigger user key up


          if (onKeyUp) {
            onKeyUp.apply(undefined, [e].concat(args));
          }
        };

        this.onChange = function (e) {
          if (_this3.state.focused) {
            _this3.inputting = true;
          }

          var input = _this3.props.parser(_this3.getValueFromEvent(e));

          _this3.setState({
            inputValue: input
          });

          _this3.props.onChange(_this3.toNumberWhenUserInput(input)); // valid number or invalid string

        };

        this.onMouseUp = function () {
          var onMouseUp = _this3.props.onMouseUp;

          _this3.recordCursorPosition();

          if (onMouseUp) {
            onMouseUp.apply(undefined, arguments);
          }
        };

        this.onFocus = function () {
          var _props4;

          _this3.setState({
            focused: true
          });

          (_props4 = _this3.props).onFocus.apply(_props4, arguments);
        };

        this.onBlur = function (e) {
          for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
          }

          _this3.inputting = false;

          _this3.setState({
            focused: false
          });

          var value = _this3.getCurrentValidValue(_this3.state.inputValue);

          e.persist(); // fix https://github.com/react-component/input-number/issues/51

          _this3.setValue(value, function () {
            var _props5;

            (_props5 = _this3.props).onBlur.apply(_props5, [e].concat(args));
          });
        };

        this.getInputDisplayValue = function () {
          var _state = _this3.state,
              focused = _state.focused,
              inputValue = _state.inputValue,
              value = _state.value;
          var inputDisplayValue = void 0;

          if (focused) {
            inputDisplayValue = inputValue;
          } else {
            inputDisplayValue = _this3.toPrecisionAsStep(value);
          }

          if (inputDisplayValue === undefined || inputDisplayValue === null) {
            inputDisplayValue = '';
          }

          return inputDisplayValue;
        };

        this.recordCursorPosition = function () {
          // Record position
          try {
            _this3.cursorStart = _this3.input.selectionStart;
            _this3.cursorEnd = _this3.input.selectionEnd;
            _this3.currentValue = _this3.input.value;
            _this3.cursorBefore = _this3.input.value.substring(0, _this3.cursorStart);
            _this3.cursorAfter = _this3.input.value.substring(_this3.cursorEnd);
          } catch (e) {// Fix error in Chrome:
            // Failed to read the 'selectionStart' property from 'HTMLInputElement'
            // http://stackoverflow.com/q/21177489/3040605
          }
        };

        this.restoreByAfter = function (str) {
          if (str === undefined) return false;
          var fullStr = _this3.input.value;
          var index = fullStr.lastIndexOf(str);
          if (index === -1) return false;

          if (index + str.length === fullStr.length) {
            _this3.fixCaret(index, index);

            return true;
          }

          return false;
        };

        this.partRestoreByAfter = function (str) {
          if (str === undefined) return false; // For loop from full str to the str with last char to map. e.g. 123
          // -> 123
          // -> 23
          // -> 3

          return Array.prototype.some.call(str, function (_, start) {
            var partStr = str.substring(start);
            return _this3.restoreByAfter(partStr);
          });
        };

        this.stop = function () {
          if (_this3.autoStepTimer) {
            clearTimeout(_this3.autoStepTimer);
          }
        };

        this.down = function (e, ratio, recursive) {
          _this3.pressingUpOrDown = true;

          _this3.step('down', e, ratio, recursive);
        };

        this.up = function (e, ratio, recursive) {
          _this3.pressingUpOrDown = true;

          _this3.step('up', e, ratio, recursive);
        };

        this.saveUp = function (node) {
          _this3.upHandler = node;
        };

        this.saveDown = function (node) {
          _this3.downHandler = node;
        };

        this.saveInput = function (node) {
          _this3.input = node;
        };
      };
      /* harmony default export */


      var es = __webpack_exports__["default"] = es_InputNumber;
      /***/
    },
    /* 376 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js


      var helpers_extends = __webpack_require__(2);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js


      var objectWithoutProperties = __webpack_require__(42);

      var objectWithoutProperties_default =
      /*#__PURE__*/
      __webpack_require__.n(objectWithoutProperties); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(7);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(5);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js


      var inherits = __webpack_require__(8);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // CONCATENATED MODULE: ./node_modules/rc-progress/es/enhancer.js


      var enhancer_enhancer = function enhancer(WrappedComponent) {
        return function (_WrappedComponent) {
          inherits_default()(Progress, _WrappedComponent);

          function Progress() {
            classCallCheck_default()(this, Progress);
            return possibleConstructorReturn_default()(this, _WrappedComponent.apply(this, arguments));
          }

          Progress.prototype.componentDidUpdate = function componentDidUpdate() {
            if (!this.path) {
              return;
            }

            var pathStyle = this.path.style;
            pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
            var now = Date.now();

            if (this.prevTimeStamp && now - this.prevTimeStamp < 100) {
              pathStyle.transitionDuration = '0s, 0s';
            }

            this.prevTimeStamp = Date.now();
          };

          Progress.prototype.render = function render() {
            return _WrappedComponent.prototype.render.call(this);
          };

          return Progress;
        }(WrappedComponent);
      };
      /* harmony default export */


      var es_enhancer = enhancer_enhancer; // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // CONCATENATED MODULE: ./node_modules/rc-progress/es/types.js


      var types_defaultProps = {
        className: '',
        percent: 0,
        prefixCls: 'rc-progress',
        strokeColor: '#2db7f5',
        strokeLinecap: 'round',
        strokeWidth: 1,
        style: {},
        trailColor: '#D9D9D9',
        trailWidth: 1
      };
      var types_propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        percent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        prefixCls: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        strokeColor: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        strokeLinecap: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['butt', 'round', 'square']),
        strokeWidth: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string]),
        style: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        trailColor: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        trailWidth: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number, external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string])
      }; // CONCATENATED MODULE: ./node_modules/rc-progress/es/Line.js

      var Line_Line = function (_Component) {
        inherits_default()(Line, _Component);

        function Line() {
          classCallCheck_default()(this, Line);
          return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
        }

        Line.prototype.render = function render() {
          var _this2 = this;

          var _props = this.props,
              className = _props.className,
              percent = _props.percent,
              prefixCls = _props.prefixCls,
              strokeColor = _props.strokeColor,
              strokeLinecap = _props.strokeLinecap,
              strokeWidth = _props.strokeWidth,
              style = _props.style,
              trailColor = _props.trailColor,
              trailWidth = _props.trailWidth,
              restProps = objectWithoutProperties_default()(_props, ['className', 'percent', 'prefixCls', 'strokeColor', 'strokeLinecap', 'strokeWidth', 'style', 'trailColor', 'trailWidth']);
          delete restProps.gapPosition;
          var pathStyle = {
            strokeDasharray: '100px, 100px',
            strokeDashoffset: 100 - percent + 'px',
            transition: 'stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear'
          };
          var center = strokeWidth / 2;
          var right = 100 - strokeWidth / 2;
          var pathString = 'M ' + (strokeLinecap === 'round' ? center : 0) + ',' + center + '\n           L ' + (strokeLinecap === 'round' ? right : 100) + ',' + center;
          var viewBoxString = '0 0 100 ' + strokeWidth;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('svg', extends_default()({
            className: prefixCls + '-line ' + className,
            viewBox: viewBoxString,
            preserveAspectRatio: 'none',
            style: style
          }, restProps), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('path', {
            className: prefixCls + '-line-trail',
            d: pathString,
            strokeLinecap: strokeLinecap,
            stroke: trailColor,
            strokeWidth: trailWidth || strokeWidth,
            fillOpacity: '0'
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('path', {
            className: prefixCls + '-line-path',
            d: pathString,
            strokeLinecap: strokeLinecap,
            stroke: strokeColor,
            strokeWidth: strokeWidth,
            fillOpacity: '0',
            ref: function ref(path) {
              _this2.path = path;
            },
            style: pathStyle
          }));
        };

        return Line;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Line_Line.propTypes = types_propTypes;
      Line_Line.defaultProps = types_defaultProps;
      /* harmony default export */

      var es_Line = es_enhancer(Line_Line); // CONCATENATED MODULE: ./node_modules/rc-progress/es/Circle.js

      /* eslint react/prop-types: 0 */

      var Circle_Circle = function (_Component) {
        inherits_default()(Circle, _Component);

        function Circle() {
          classCallCheck_default()(this, Circle);
          return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
        }

        Circle.prototype.getPathStyles = function getPathStyles() {
          var _props = this.props,
              percent = _props.percent,
              strokeWidth = _props.strokeWidth,
              strokeColor = _props.strokeColor,
              _props$gapDegree = _props.gapDegree,
              gapDegree = _props$gapDegree === undefined ? 0 : _props$gapDegree,
              gapPosition = _props.gapPosition;
          var radius = 50 - strokeWidth / 2;
          var beginPositionX = 0;
          var beginPositionY = -radius;
          var endPositionX = 0;
          var endPositionY = -2 * radius;

          switch (gapPosition) {
            case 'left':
              beginPositionX = -radius;
              beginPositionY = 0;
              endPositionX = 2 * radius;
              endPositionY = 0;
              break;

            case 'right':
              beginPositionX = radius;
              beginPositionY = 0;
              endPositionX = -2 * radius;
              endPositionY = 0;
              break;

            case 'bottom':
              beginPositionY = radius;
              endPositionY = 2 * radius;
              break;

            default:
          }

          var pathString = 'M 50,50 m ' + beginPositionX + ',' + beginPositionY + '\n     a ' + radius + ',' + radius + ' 0 1 1 ' + endPositionX + ',' + -endPositionY + '\n     a ' + radius + ',' + radius + ' 0 1 1 ' + -endPositionX + ',' + endPositionY;
          var len = Math.PI * 2 * radius;
          var trailPathStyle = {
            strokeDasharray: len - gapDegree + 'px ' + len + 'px',
            strokeDashoffset: '-' + gapDegree / 2 + 'px',
            transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s'
          };
          var strokePathStyle = {
            stroke: strokeColor,
            strokeDasharray: percent / 100 * (len - gapDegree) + 'px ' + len + 'px',
            strokeDashoffset: '-' + gapDegree / 2 + 'px',
            transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s' // eslint-disable-line

          };
          return {
            pathString: pathString,
            trailPathStyle: trailPathStyle,
            strokePathStyle: strokePathStyle
          };
        };

        Circle.prototype.render = function render() {
          var _this2 = this;

          var _props2 = this.props,
              prefixCls = _props2.prefixCls,
              strokeWidth = _props2.strokeWidth,
              trailWidth = _props2.trailWidth,
              percent = _props2.percent,
              trailColor = _props2.trailColor,
              strokeLinecap = _props2.strokeLinecap,
              style = _props2.style,
              className = _props2.className,
              restProps = objectWithoutProperties_default()(_props2, ['prefixCls', 'strokeWidth', 'trailWidth', 'percent', 'trailColor', 'strokeLinecap', 'style', 'className']);

          var _getPathStyles = this.getPathStyles(),
              pathString = _getPathStyles.pathString,
              trailPathStyle = _getPathStyles.trailPathStyle,
              strokePathStyle = _getPathStyles.strokePathStyle;

          delete restProps.percent;
          delete restProps.gapDegree;
          delete restProps.gapPosition;
          delete restProps.strokeColor;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('svg', extends_default()({
            className: prefixCls + '-circle ' + className,
            viewBox: '0 0 100 100',
            style: style
          }, restProps), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('path', {
            className: prefixCls + '-circle-trail',
            d: pathString,
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            strokeWidth: trailWidth || strokeWidth,
            fillOpacity: '0',
            style: trailPathStyle
          }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('path', {
            className: prefixCls + '-circle-path',
            d: pathString,
            strokeLinecap: strokeLinecap,
            strokeWidth: this.props.percent === 0 ? 0 : strokeWidth,
            fillOpacity: '0',
            ref: function ref(path) {
              _this2.path = path;
            },
            style: strokePathStyle
          }));
        };

        return Circle;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      Circle_Circle.propTypes = extends_default()({}, types_propTypes, {
        gapPosition: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.oneOf(['top', 'bottom', 'left', 'right'])
      });
      Circle_Circle.defaultProps = extends_default()({}, types_defaultProps, {
        gapPosition: 'top'
      });
      /* harmony default export */

      var es_Circle = es_enhancer(Circle_Circle); // CONCATENATED MODULE: ./node_modules/rc-progress/es/index.js

      /* concated harmony reexport */

      __webpack_require__.d(__webpack_exports__, "Line", function () {
        return es_Line;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "Circle", function () {
        return es_Circle;
      });
      /* harmony default export */


      var es = __webpack_exports__["default"] = {
        Line: es_Line,
        Circle: es_Circle
      };
      /***/
    },
    /* 377 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global) {
        (function webpackUniversalModuleDefinition(root, factory) {
          if (true) module.exports = factory(__webpack_require__(1));else {}
        })(this, function (__WEBPACK_EXTERNAL_MODULE_1__) {
          return (
            /******/
            function (modules) {
              // webpackBootstrap

              /******/
              // The module cache

              /******/
              var installedModules = {};
              /******/
              // The require function

              /******/

              function __webpack_require__(moduleId) {
                /******/
                // Check if module is in cache

                /******/
                if (installedModules[moduleId])
                  /******/
                  return installedModules[moduleId].exports;
                /******/
                // Create a new module (and put it into the cache)

                /******/

                var module = installedModules[moduleId] = {
                  /******/
                  exports: {},

                  /******/
                  id: moduleId,

                  /******/
                  loaded: false
                  /******/

                };
                /******/
                // Execute the module function

                /******/

                modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
                /******/
                // Flag the module as loaded

                /******/

                module.loaded = true;
                /******/
                // Return the exports of the module

                /******/

                return module.exports;
                /******/
              }
              /******/
              // expose the modules object (__webpack_modules__)

              /******/


              __webpack_require__.m = modules;
              /******/
              // expose the module cache

              /******/

              __webpack_require__.c = installedModules;
              /******/
              // __webpack_public_path__

              /******/

              __webpack_require__.p = "";
              /******/
              // Load entry module and return exports

              /******/

              return __webpack_require__(0);
              /******/
            }(
            /************************************************************************/

            /******/
            [
            /* 0 */

            /***/
            function (module, exports, __webpack_require__) {
              'use strict';

              var _extends = Object.assign || function (target) {
                for (var i = 1; i < arguments.length; i++) {
                  var source = arguments[i];

                  for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                      target[key] = source[key];
                    }
                  }
                }

                return target;
              };

              function _objectWithoutProperties(obj, keys) {
                var target = {};

                for (var i in obj) {
                  if (keys.indexOf(i) >= 0) continue;
                  if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
                  target[i] = obj[i];
                }

                return target;
              }

              var React = __webpack_require__(1); // eslint-disable-line no-unused-vars


              var CreateReactClass = __webpack_require__(2);

              var NumeralFormatter = __webpack_require__(9);

              var DateFormatter = __webpack_require__(10);

              var TimeFormatter = __webpack_require__(11);

              var PhoneFormatter = __webpack_require__(12);

              var CreditCardDetector = __webpack_require__(13);

              var Util = __webpack_require__(14);

              var DefaultProperties = __webpack_require__(15);

              var cleaveReactClass = CreateReactClass({
                componentDidMount: function componentDidMount() {
                  this.init();
                },
                componentDidUpdate: function componentDidUpdate() {
                  var owner = this,
                      pps = owner.properties;
                  Util.setSelection(owner.element, owner.state.cursorPosition, pps.document);
                },
                componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
                  var owner = this,
                      phoneRegionCode = (nextProps.options || {}).phoneRegionCode,
                      newValue = nextProps.value;

                  if (newValue !== undefined) {
                    newValue = newValue.toString();

                    if (newValue !== owner.properties.initValue && newValue !== owner.properties.result) {
                      owner.properties.initValue = newValue;
                      owner.onInput(newValue, true);
                    }
                  } // update phone region code


                  if (phoneRegionCode && phoneRegionCode !== owner.properties.phoneRegionCode) {
                    owner.properties.phoneRegionCode = phoneRegionCode;
                    owner.initPhoneFormatter();
                    owner.onInput(owner.properties.result);
                  }
                },
                getInitialState: function getInitialState() {
                  var owner = this,
                      _owner$props = owner.props,
                      value = _owner$props.value,
                      options = _owner$props.options,
                      onKeyDown = _owner$props.onKeyDown,
                      onChange = _owner$props.onChange,
                      onFocus = _owner$props.onFocus,
                      onBlur = _owner$props.onBlur,
                      onInit = _owner$props.onInit;
                  owner.registeredEvents = {
                    onInit: onInit || Util.noop,
                    onChange: onChange || Util.noop,
                    onFocus: onFocus || Util.noop,
                    onBlur: onBlur || Util.noop,
                    onKeyDown: onKeyDown || Util.noop
                  };

                  if (!options) {
                    options = {};
                  }

                  options.initValue = value;
                  owner.properties = DefaultProperties.assign({}, options);
                  return {
                    value: owner.properties.result,
                    cursorPosition: 0
                  };
                },
                init: function init() {
                  var owner = this,
                      pps = owner.properties; // so no need for this lib at all

                  if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && pps.blocksLength === 0 && !pps.prefix) {
                    owner.onInput(pps.initValue);
                    owner.registeredEvents.onInit(owner);
                    return;
                  }

                  pps.maxLength = Util.getMaxLength(pps.blocks);
                  owner.isAndroid = Util.isAndroid();
                  owner.initPhoneFormatter();
                  owner.initDateFormatter();
                  owner.initTimeFormatter();
                  owner.initNumeralFormatter(); // avoid touch input field if value is null
                  // otherwise Firefox will add red box-shadow for <input required />

                  if (pps.initValue || pps.prefix && !pps.noImmediatePrefix) {
                    owner.onInput(pps.initValue);
                  }

                  owner.registeredEvents.onInit(owner);
                },
                initNumeralFormatter: function initNumeralFormatter() {
                  var owner = this,
                      pps = owner.properties;

                  if (!pps.numeral) {
                    return;
                  }

                  pps.numeralFormatter = new NumeralFormatter(pps.numeralDecimalMark, pps.numeralIntegerScale, pps.numeralDecimalScale, pps.numeralThousandsGroupStyle, pps.numeralPositiveOnly, pps.stripLeadingZeroes, pps.delimiter);
                },
                initTimeFormatter: function initTimeFormatter() {
                  var owner = this,
                      pps = owner.properties;

                  if (!pps.time) {
                    return;
                  }

                  pps.timeFormatter = new TimeFormatter(pps.timePattern, pps.timeFormat);
                  pps.blocks = pps.timeFormatter.getBlocks();
                  pps.blocksLength = pps.blocks.length;
                  pps.maxLength = Util.getMaxLength(pps.blocks);
                },
                initDateFormatter: function initDateFormatter() {
                  var owner = this,
                      pps = owner.properties;

                  if (!pps.date) {
                    return;
                  }

                  pps.dateFormatter = new DateFormatter(pps.datePattern);
                  pps.blocks = pps.dateFormatter.getBlocks();
                  pps.blocksLength = pps.blocks.length;
                  pps.maxLength = Util.getMaxLength(pps.blocks);
                },
                initPhoneFormatter: function initPhoneFormatter() {
                  var owner = this,
                      pps = owner.properties;

                  if (!pps.phone) {
                    return;
                  } // Cleave.AsYouTypeFormatter should be provided by
                  // external google closure lib


                  try {
                    pps.phoneFormatter = new PhoneFormatter(new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode), pps.delimiter);
                  } catch (ex) {
                    throw new Error('Please include phone-type-formatter.{country}.js lib');
                  }
                },
                setRawValue: function setRawValue(value) {
                  var owner = this,
                      pps = owner.properties;
                  value = value !== undefined && value !== null ? value.toString() : '';

                  if (pps.numeral) {
                    value = value.replace('.', pps.numeralDecimalMark);
                  }

                  pps.postDelimiterBackspace = false;
                  owner.onChange({
                    target: {
                      value: value
                    },
                    // Methods to better resemble a SyntheticEvent
                    stopPropagation: Util.noop,
                    preventDefault: Util.noop,
                    persist: Util.noop
                  });
                },
                getRawValue: function getRawValue() {
                  var owner = this,
                      pps = owner.properties,
                      rawValue = pps.result;

                  if (pps.rawValueTrimPrefix) {
                    rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters);
                  }

                  if (pps.numeral) {
                    rawValue = pps.numeralFormatter ? pps.numeralFormatter.getRawValue(rawValue) : '';
                  } else {
                    rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
                  }

                  return rawValue;
                },
                getISOFormatDate: function getISOFormatDate() {
                  var owner = this,
                      pps = owner.properties;
                  return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
                },
                getISOFormatTime: function getISOFormatTime() {
                  var owner = this,
                      pps = owner.properties;
                  return pps.time ? pps.timeFormatter.getISOFormatTime() : '';
                },
                onInit: function onInit(owner) {
                  return owner;
                },
                onKeyDown: function onKeyDown(event) {
                  var owner = this,
                      pps = owner.properties,
                      charCode = event.which || event.keyCode; // if we got any charCode === 8, this means, that this device correctly
                  // sends backspace keys in event, so we do not need to apply any hacks

                  owner.hasBackspaceSupport = owner.hasBackspaceSupport || charCode === 8;

                  if (!owner.hasBackspaceSupport && Util.isAndroidBackspaceKeydown(owner.lastInputValue, pps.result)) {
                    charCode = 8;
                  } // hit backspace when last character is delimiter


                  var postDelimiter = Util.getPostDelimiter(pps.result, pps.delimiter, pps.delimiters);

                  if (charCode === 8 && postDelimiter) {
                    pps.postDelimiterBackspace = postDelimiter;
                  } else {
                    pps.postDelimiterBackspace = false;
                  }

                  owner.registeredEvents.onKeyDown(event);
                },
                onFocus: function onFocus(event) {
                  var owner = this,
                      pps = owner.properties;
                  event.target.rawValue = owner.getRawValue();
                  event.target.value = pps.result;
                  owner.registeredEvents.onFocus(event);
                  Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
                },
                onBlur: function onBlur(event) {
                  var owner = this,
                      pps = owner.properties;
                  event.target.rawValue = owner.getRawValue();
                  event.target.value = pps.result;
                  owner.registeredEvents.onBlur(event);
                },
                onChange: function onChange(event) {
                  var owner = this,
                      pps = owner.properties;
                  owner.onInput(event.target.value);
                  event.target.rawValue = owner.getRawValue();
                  event.target.value = pps.result;
                  owner.registeredEvents.onChange(event);
                },
                onInput: function onInput(value, fromProps) {
                  var owner = this,
                      pps = owner.properties; // case 1: delete one more character "4"
                  // 1234*| -> hit backspace -> 123|
                  // case 2: last character is not delimiter which is:
                  // 12|34* -> hit backspace -> 1|34*

                  var postDelimiterAfter = Util.getPostDelimiter(value, pps.delimiter, pps.delimiters);

                  if (!fromProps && !pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
                    value = Util.headStr(value, value.length - pps.postDelimiterBackspace.length);
                  } // phone formatter


                  if (pps.phone) {
                    if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
                      pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
                    } else {
                      pps.result = pps.phoneFormatter.format(value);
                    }

                    owner.updateValueState();
                    return;
                  } // numeral formatter


                  if (pps.numeral) {
                    if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
                      pps.result = pps.prefix + pps.numeralFormatter.format(value);
                    } else {
                      pps.result = pps.numeralFormatter.format(value);
                    }

                    owner.updateValueState();
                    return;
                  } // date


                  if (pps.date) {
                    value = pps.dateFormatter.getValidatedDate(value);
                  } // time


                  if (pps.time) {
                    value = pps.timeFormatter.getValidatedTime(value);
                  } // strip delimiters


                  value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters); // strip prefix

                  value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters); // strip non-numeric characters

                  value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value; // convert case

                  value = pps.uppercase ? value.toUpperCase() : value;
                  value = pps.lowercase ? value.toLowerCase() : value; // prefix

                  if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
                    value = pps.prefix + value; // no blocks specified, no need to do formatting

                    if (pps.blocksLength === 0) {
                      pps.result = value;
                      owner.updateValueState();
                      return;
                    }
                  } // update credit card props


                  if (pps.creditCard) {
                    owner.updateCreditCardPropsByValue(value);
                  } // strip over length characters


                  value = pps.maxLength > 0 ? Util.headStr(value, pps.maxLength) : value; // apply blocks

                  pps.result = Util.getFormattedValue(value, pps.blocks, pps.blocksLength, pps.delimiter, pps.delimiters, pps.delimiterLazyShow);
                  owner.updateValueState();
                },
                updateCreditCardPropsByValue: function updateCreditCardPropsByValue(value) {
                  var owner = this,
                      pps = owner.properties,
                      creditCardInfo; // At least one of the first 4 characters has changed

                  if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
                    return;
                  }

                  creditCardInfo = CreditCardDetector.getInfo(value, pps.creditCardStrictMode);
                  pps.blocks = creditCardInfo.blocks;
                  pps.blocksLength = pps.blocks.length;
                  pps.maxLength = Util.getMaxLength(pps.blocks); // credit card type changed

                  if (pps.creditCardType !== creditCardInfo.type) {
                    pps.creditCardType = creditCardInfo.type;
                    pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
                  }
                },
                updateValueState: function updateValueState() {
                  var owner = this,
                      pps = owner.properties;

                  if (!owner.element) {
                    owner.setState({
                      value: pps.result
                    });
                  }

                  var endPos = owner.element.selectionEnd;
                  var oldValue = owner.element.value;
                  var newValue = pps.result;
                  owner.lastInputValue = newValue;
                  endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);

                  if (owner.isAndroid) {
                    window.setTimeout(function () {
                      owner.setState({
                        value: newValue,
                        cursorPosition: endPos
                      });
                    }, 1);
                    return;
                  }

                  owner.setState({
                    value: newValue,
                    cursorPosition: endPos
                  });
                },
                render: function render() {
                  var owner = this; // eslint-disable-next-line

                  var _owner$props2 = owner.props,
                      value = _owner$props2.value,
                      options = _owner$props2.options,
                      onKeyDown = _owner$props2.onKeyDown,
                      onFocus = _owner$props2.onFocus,
                      onBlur = _owner$props2.onBlur,
                      onChange = _owner$props2.onChange,
                      onInit = _owner$props2.onInit,
                      htmlRef = _owner$props2.htmlRef,
                      propsToTransfer = _objectWithoutProperties(_owner$props2, ['value', 'options', 'onKeyDown', 'onFocus', 'onBlur', 'onChange', 'onInit', 'htmlRef']);

                  return React.createElement('input', _extends({
                    type: 'text',
                    ref: function ref(_ref) {
                      owner.element = _ref;

                      if (!htmlRef) {
                        return;
                      }

                      htmlRef.apply(this, arguments);
                    },
                    value: owner.state.value,
                    onKeyDown: owner.onKeyDown,
                    onChange: owner.onChange,
                    onFocus: owner.onFocus,
                    onBlur: owner.onBlur
                  }, propsToTransfer));
                }
              });
              module.exports = cleaveReactClass;
              /***/
            },
            /* 1 */

            /***/
            function (module, exports) {
              module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
              /***/
            },
            /* 2 */

            /***/
            function (module, exports, __webpack_require__) {
              /**
               * Copyright 2013-present, Facebook, Inc.
               * All rights reserved.
               *
               * This source code is licensed under the BSD-style license found in the
               * LICENSE file in the root directory of this source tree. An additional grant
               * of patent rights can be found in the PATENTS file in the same directory.
               *
               */
              'use strict';

              var React = __webpack_require__(1);

              var factory = __webpack_require__(3);

              if (typeof React === 'undefined') {
                throw Error('create-react-class could not find the React object. If you are using script tags, ' + 'make sure that React is being loaded before create-react-class.');
              } // Hack to grab NoopUpdateQueue from isomorphic React


              var ReactNoopUpdateQueue = new React.Component().updater;
              module.exports = factory(React.Component, React.isValidElement, ReactNoopUpdateQueue);
              /***/
            },
            /* 3 */

            /***/
            function (module, exports, __webpack_require__) {
              /**
               * Copyright 2013-present, Facebook, Inc.
               * All rights reserved.
               *
               * This source code is licensed under the BSD-style license found in the
               * LICENSE file in the root directory of this source tree. An additional grant
               * of patent rights can be found in the PATENTS file in the same directory.
               *
               */
              'use strict';

              var _assign = __webpack_require__(4);

              var emptyObject = __webpack_require__(5);

              var _invariant = __webpack_require__(6);

              if (false) {
                var warning;
              }

              var MIXINS_KEY = 'mixins'; // Helper function to allow the creation of anonymous functions which do not
              // have .name set to the name of the variable being assigned to.

              function identity(fn) {
                return fn;
              }

              var ReactPropTypeLocationNames;

              if (false) {} else {
                ReactPropTypeLocationNames = {};
              }

              function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
                /**
                 * Policies that describe methods in `ReactClassInterface`.
                 */
                var injectedMixins = [];
                /**
                 * Composite components are higher-level components that compose other composite
                 * or host components.
                 *
                 * To create a new type of `ReactClass`, pass a specification of
                 * your new class to `React.createClass`. The only requirement of your class
                 * specification is that you implement a `render` method.
                 *
                 *   var MyComponent = React.createClass({
                 *     render: function() {
                 *       return <div>Hello World</div>;
                 *     }
                 *   });
                 *
                 * The class specification supports a specific protocol of methods that have
                 * special meaning (e.g. `render`). See `ReactClassInterface` for
                 * more the comprehensive protocol. Any other properties and methods in the
                 * class specification will be available on the prototype.
                 *
                 * @interface ReactClassInterface
                 * @internal
                 */

                var ReactClassInterface = {
                  /**
                   * An array of Mixin objects to include when defining your component.
                   *
                   * @type {array}
                   * @optional
                   */
                  mixins: 'DEFINE_MANY',

                  /**
                   * An object containing properties and methods that should be defined on
                   * the component's constructor instead of its prototype (static methods).
                   *
                   * @type {object}
                   * @optional
                   */
                  statics: 'DEFINE_MANY',

                  /**
                   * Definition of prop types for this component.
                   *
                   * @type {object}
                   * @optional
                   */
                  propTypes: 'DEFINE_MANY',

                  /**
                   * Definition of context types for this component.
                   *
                   * @type {object}
                   * @optional
                   */
                  contextTypes: 'DEFINE_MANY',

                  /**
                   * Definition of context types this component sets for its children.
                   *
                   * @type {object}
                   * @optional
                   */
                  childContextTypes: 'DEFINE_MANY',
                  // ==== Definition methods ====

                  /**
                   * Invoked when the component is mounted. Values in the mapping will be set on
                   * `this.props` if that prop is not specified (i.e. using an `in` check).
                   *
                   * This method is invoked before `getInitialState` and therefore cannot rely
                   * on `this.state` or use `this.setState`.
                   *
                   * @return {object}
                   * @optional
                   */
                  getDefaultProps: 'DEFINE_MANY_MERGED',

                  /**
                   * Invoked once before the component is mounted. The return value will be used
                   * as the initial value of `this.state`.
                   *
                   *   getInitialState: function() {
                   *     return {
                   *       isOn: false,
                   *       fooBaz: new BazFoo()
                   *     }
                   *   }
                   *
                   * @return {object}
                   * @optional
                   */
                  getInitialState: 'DEFINE_MANY_MERGED',

                  /**
                   * @return {object}
                   * @optional
                   */
                  getChildContext: 'DEFINE_MANY_MERGED',

                  /**
                   * Uses props from `this.props` and state from `this.state` to render the
                   * structure of the component.
                   *
                   * No guarantees are made about when or how often this method is invoked, so
                   * it must not have side effects.
                   *
                   *   render: function() {
                   *     var name = this.props.name;
                   *     return <div>Hello, {name}!</div>;
                   *   }
                   *
                   * @return {ReactComponent}
                   * @required
                   */
                  render: 'DEFINE_ONCE',
                  // ==== Delegate methods ====

                  /**
                   * Invoked when the component is initially created and about to be mounted.
                   * This may have side effects, but any external subscriptions or data created
                   * by this method must be cleaned up in `componentWillUnmount`.
                   *
                   * @optional
                   */
                  componentWillMount: 'DEFINE_MANY',

                  /**
                   * Invoked when the component has been mounted and has a DOM representation.
                   * However, there is no guarantee that the DOM node is in the document.
                   *
                   * Use this as an opportunity to operate on the DOM when the component has
                   * been mounted (initialized and rendered) for the first time.
                   *
                   * @param {DOMElement} rootNode DOM element representing the component.
                   * @optional
                   */
                  componentDidMount: 'DEFINE_MANY',

                  /**
                   * Invoked before the component receives new props.
                   *
                   * Use this as an opportunity to react to a prop transition by updating the
                   * state using `this.setState`. Current props are accessed via `this.props`.
                   *
                   *   componentWillReceiveProps: function(nextProps, nextContext) {
                   *     this.setState({
                   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
                   *     });
                   *   }
                   *
                   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
                   * transition may cause a state change, but the opposite is not true. If you
                   * need it, you are probably looking for `componentWillUpdate`.
                   *
                   * @param {object} nextProps
                   * @optional
                   */
                  componentWillReceiveProps: 'DEFINE_MANY',

                  /**
                   * Invoked while deciding if the component should be updated as a result of
                   * receiving new props, state and/or context.
                   *
                   * Use this as an opportunity to `return false` when you're certain that the
                   * transition to the new props/state/context will not require a component
                   * update.
                   *
                   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
                   *     return !equal(nextProps, this.props) ||
                   *       !equal(nextState, this.state) ||
                   *       !equal(nextContext, this.context);
                   *   }
                   *
                   * @param {object} nextProps
                   * @param {?object} nextState
                   * @param {?object} nextContext
                   * @return {boolean} True if the component should update.
                   * @optional
                   */
                  shouldComponentUpdate: 'DEFINE_ONCE',

                  /**
                   * Invoked when the component is about to update due to a transition from
                   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
                   * and `nextContext`.
                   *
                   * Use this as an opportunity to perform preparation before an update occurs.
                   *
                   * NOTE: You **cannot** use `this.setState()` in this method.
                   *
                   * @param {object} nextProps
                   * @param {?object} nextState
                   * @param {?object} nextContext
                   * @param {ReactReconcileTransaction} transaction
                   * @optional
                   */
                  componentWillUpdate: 'DEFINE_MANY',

                  /**
                   * Invoked when the component's DOM representation has been updated.
                   *
                   * Use this as an opportunity to operate on the DOM when the component has
                   * been updated.
                   *
                   * @param {object} prevProps
                   * @param {?object} prevState
                   * @param {?object} prevContext
                   * @param {DOMElement} rootNode DOM element representing the component.
                   * @optional
                   */
                  componentDidUpdate: 'DEFINE_MANY',

                  /**
                   * Invoked when the component is about to be removed from its parent and have
                   * its DOM representation destroyed.
                   *
                   * Use this as an opportunity to deallocate any external resources.
                   *
                   * NOTE: There is no `componentDidUnmount` since your component will have been
                   * destroyed by that point.
                   *
                   * @optional
                   */
                  componentWillUnmount: 'DEFINE_MANY',
                  // ==== Advanced methods ====

                  /**
                   * Updates the component's currently mounted DOM representation.
                   *
                   * By default, this implements React's rendering and reconciliation algorithm.
                   * Sophisticated clients may wish to override this.
                   *
                   * @param {ReactReconcileTransaction} transaction
                   * @internal
                   * @overridable
                   */
                  updateComponent: 'OVERRIDE_BASE'
                };
                /**
                 * Mapping from class specification keys to special processing functions.
                 *
                 * Although these are declared like instance properties in the specification
                 * when defining classes using `React.createClass`, they are actually static
                 * and are accessible on the constructor instead of the prototype. Despite
                 * being static, they must be defined outside of the "statics" key under
                 * which all other static methods are defined.
                 */

                var RESERVED_SPEC_KEYS = {
                  displayName: function displayName(Constructor, _displayName) {
                    Constructor.displayName = _displayName;
                  },
                  mixins: function mixins(Constructor, _mixins) {
                    if (_mixins) {
                      for (var i = 0; i < _mixins.length; i++) {
                        mixSpecIntoComponent(Constructor, _mixins[i]);
                      }
                    }
                  },
                  childContextTypes: function childContextTypes(Constructor, _childContextTypes2) {
                    if (false) {}

                    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, _childContextTypes2);
                  },
                  contextTypes: function contextTypes(Constructor, _contextTypes2) {
                    if (false) {}

                    Constructor.contextTypes = _assign({}, Constructor.contextTypes, _contextTypes2);
                  },

                  /**
                   * Special case getDefaultProps which should move into statics but requires
                   * automatic merging.
                   */
                  getDefaultProps: function getDefaultProps(Constructor, _getDefaultProps) {
                    if (Constructor.getDefaultProps) {
                      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, _getDefaultProps);
                    } else {
                      Constructor.getDefaultProps = _getDefaultProps;
                    }
                  },
                  propTypes: function propTypes(Constructor, _propTypes3) {
                    if (false) {}

                    Constructor.propTypes = _assign({}, Constructor.propTypes, _propTypes3);
                  },
                  statics: function statics(Constructor, _statics) {
                    mixStaticSpecIntoComponent(Constructor, _statics);
                  },
                  autobind: function autobind() {}
                };

                function validateTypeDef(Constructor, typeDef, location) {
                  for (var propName in typeDef) {
                    if (typeDef.hasOwnProperty(propName)) {
                      // use a warning instead of an _invariant so components
                      // don't show up in prod but only in __DEV__
                      if (false) {}
                    }
                  }
                }

                function validateMethodOverride(isAlreadyDefined, name) {
                  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null; // Disallow overriding of base class methods unless explicitly allowed.

                  if (ReactClassMixin.hasOwnProperty(name)) {
                    _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
                  } // Disallow defining methods more than once unless explicitly allowed.


                  if (isAlreadyDefined) {
                    _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
                  }
                }
                /**
                 * Mixin helper which handles policy validation and reserved
                 * specification keys when building React classes.
                 */


                function mixSpecIntoComponent(Constructor, spec) {
                  if (!spec) {
                    if (false) {
                      var isMixinValid, typeofSpec;
                    }

                    return;
                  }

                  _invariant(typeof spec !== 'function', "ReactClass: You're attempting to " + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');

                  _invariant(!isValidElement(spec), "ReactClass: You're attempting to " + 'use a component as a mixin. Instead, just use a regular object.');

                  var proto = Constructor.prototype;
                  var autoBindPairs = proto.__reactAutoBindPairs; // By handling mixins before any other properties, we ensure the same
                  // chaining order is applied to methods with DEFINE_MANY policy, whether
                  // mixins are listed before or after these methods in the spec.

                  if (spec.hasOwnProperty(MIXINS_KEY)) {
                    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
                  }

                  for (var name in spec) {
                    if (!spec.hasOwnProperty(name)) {
                      continue;
                    }

                    if (name === MIXINS_KEY) {
                      // We have already handled mixins in a special case above.
                      continue;
                    }

                    var property = spec[name];
                    var isAlreadyDefined = proto.hasOwnProperty(name);
                    validateMethodOverride(isAlreadyDefined, name);

                    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
                      RESERVED_SPEC_KEYS[name](Constructor, property);
                    } else {
                      // Setup methods on prototype:
                      // The following member methods should not be automatically bound:
                      // 1. Expected ReactClass methods (in the "interface").
                      // 2. Overridden methods (that were mixed in).
                      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
                      var isFunction = typeof property === 'function';
                      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

                      if (shouldAutoBind) {
                        autoBindPairs.push(name, property);
                        proto[name] = property;
                      } else {
                        if (isAlreadyDefined) {
                          var specPolicy = ReactClassInterface[name]; // These cases should already be caught by validateMethodOverride.

                          _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name); // For methods which are defined more than once, call the existing
                          // methods before calling the new property, merging if appropriate.


                          if (specPolicy === 'DEFINE_MANY_MERGED') {
                            proto[name] = createMergedResultFunction(proto[name], property);
                          } else if (specPolicy === 'DEFINE_MANY') {
                            proto[name] = createChainedFunction(proto[name], property);
                          }
                        } else {
                          proto[name] = property;

                          if (false) {}
                        }
                      }
                    }
                  }
                }

                function mixStaticSpecIntoComponent(Constructor, statics) {
                  if (!statics) {
                    return;
                  }

                  for (var name in statics) {
                    var property = statics[name];

                    if (!statics.hasOwnProperty(name)) {
                      continue;
                    }

                    var isReserved = name in RESERVED_SPEC_KEYS;

                    _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);

                    var isInherited = name in Constructor;

                    _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);

                    Constructor[name] = property;
                  }
                }
                /**
                 * Merge two objects, but throw if both contain the same key.
                 *
                 * @param {object} one The first object, which is mutated.
                 * @param {object} two The second object
                 * @return {object} one after it has been mutated to contain everything in two.
                 */


                function mergeIntoWithNoDuplicateKeys(one, two) {
                  _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

                  for (var key in two) {
                    if (two.hasOwnProperty(key)) {
                      _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);

                      one[key] = two[key];
                    }
                  }

                  return one;
                }
                /**
                 * Creates a function that invokes two functions and merges their return values.
                 *
                 * @param {function} one Function to invoke first.
                 * @param {function} two Function to invoke second.
                 * @return {function} Function that invokes the two argument functions.
                 * @private
                 */


                function createMergedResultFunction(one, two) {
                  return function mergedResult() {
                    var a = one.apply(this, arguments);
                    var b = two.apply(this, arguments);

                    if (a == null) {
                      return b;
                    } else if (b == null) {
                      return a;
                    }

                    var c = {};
                    mergeIntoWithNoDuplicateKeys(c, a);
                    mergeIntoWithNoDuplicateKeys(c, b);
                    return c;
                  };
                }
                /**
                 * Creates a function that invokes two functions and ignores their return vales.
                 *
                 * @param {function} one Function to invoke first.
                 * @param {function} two Function to invoke second.
                 * @return {function} Function that invokes the two argument functions.
                 * @private
                 */


                function createChainedFunction(one, two) {
                  return function chainedFunction() {
                    one.apply(this, arguments);
                    two.apply(this, arguments);
                  };
                }
                /**
                 * Binds a method to the component.
                 *
                 * @param {object} component Component whose method is going to be bound.
                 * @param {function} method Method to be bound.
                 * @return {function} The bound method.
                 */


                function bindAutoBindMethod(component, method) {
                  var boundMethod = method.bind(component);

                  if (false) {
                    var _bind, componentName;
                  }

                  return boundMethod;
                }
                /**
                 * Binds all auto-bound methods in a component.
                 *
                 * @param {object} component Component whose method is going to be bound.
                 */


                function bindAutoBindMethods(component) {
                  var pairs = component.__reactAutoBindPairs;

                  for (var i = 0; i < pairs.length; i += 2) {
                    var autoBindKey = pairs[i];
                    var method = pairs[i + 1];
                    component[autoBindKey] = bindAutoBindMethod(component, method);
                  }
                }

                var IsMountedPreMixin = {
                  componentDidMount: function componentDidMount() {
                    this.__isMounted = true;
                  }
                };
                var IsMountedPostMixin = {
                  componentWillUnmount: function componentWillUnmount() {
                    this.__isMounted = false;
                  }
                };
                /**
                 * Add more to the ReactClass base class. These are all legacy features and
                 * therefore not already part of the modern ReactComponent.
                 */

                var ReactClassMixin = {
                  /**
                   * TODO: This will be deprecated because state should always keep a consistent
                   * type signature and the only use case for this, is to avoid that.
                   */
                  replaceState: function replaceState(newState, callback) {
                    this.updater.enqueueReplaceState(this, newState, callback);
                  },

                  /**
                   * Checks whether or not this composite component is mounted.
                   * @return {boolean} True if mounted, false otherwise.
                   * @protected
                   * @final
                   */
                  isMounted: function isMounted() {
                    if (false) {}

                    return !!this.__isMounted;
                  }
                };

                var ReactClassComponent = function ReactClassComponent() {};

                _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
                /**
                 * Creates a composite component class given a class specification.
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
                 *
                 * @param {object} spec Class specification (which must define `render`).
                 * @return {function} Component constructor function.
                 * @public
                 */


                function createClass(spec) {
                  // To keep our warnings more understandable, we'll use a little hack here to
                  // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
                  // unnecessarily identify a class without displayName as 'Constructor'.
                  var Constructor = identity(function (props, context, updater) {
                    // This constructor gets overridden by mocks. The argument is used
                    // by mocks to assert on what gets mounted.
                    if (false) {} // Wire up auto-binding


                    if (this.__reactAutoBindPairs.length) {
                      bindAutoBindMethods(this);
                    }

                    this.props = props;
                    this.context = context;
                    this.refs = emptyObject;
                    this.updater = updater || ReactNoopUpdateQueue;
                    this.state = null; // ReactClasses doesn't have constructors. Instead, they use the
                    // getInitialState and componentWillMount methods for initialization.

                    var initialState = this.getInitialState ? this.getInitialState() : null;

                    if (false) {}

                    _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');

                    this.state = initialState;
                  });
                  Constructor.prototype = new ReactClassComponent();
                  Constructor.prototype.constructor = Constructor;
                  Constructor.prototype.__reactAutoBindPairs = [];
                  injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
                  mixSpecIntoComponent(Constructor, IsMountedPreMixin);
                  mixSpecIntoComponent(Constructor, spec);
                  mixSpecIntoComponent(Constructor, IsMountedPostMixin); // Initialize the defaultProps property after all mixins have been merged.

                  if (Constructor.getDefaultProps) {
                    Constructor.defaultProps = Constructor.getDefaultProps();
                  }

                  if (false) {}

                  _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

                  if (false) {} // Reduce time spent doing lookups by setting these on the prototype.


                  for (var methodName in ReactClassInterface) {
                    if (!Constructor.prototype[methodName]) {
                      Constructor.prototype[methodName] = null;
                    }
                  }

                  return Constructor;
                }

                return createClass;
              }

              module.exports = factory;
              /***/
            },
            /* 4 */

            /***/
            function (module, exports) {
              /*
              object-assign
              (c) Sindre Sorhus
              @license MIT
              */
              'use strict';
              /* eslint-disable no-unused-vars */

              var getOwnPropertySymbols = Object.getOwnPropertySymbols;
              var hasOwnProperty = Object.prototype.hasOwnProperty;
              var propIsEnumerable = Object.prototype.propertyIsEnumerable;

              function toObject(val) {
                if (val === null || val === undefined) {
                  throw new TypeError('Object.assign cannot be called with null or undefined');
                }

                return Object(val);
              }

              function shouldUseNative() {
                try {
                  if (!Object.assign) {
                    return false;
                  } // Detect buggy property enumeration order in older V8 versions.
                  // https://bugs.chromium.org/p/v8/issues/detail?id=4118


                  var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

                  test1[5] = 'de';

                  if (Object.getOwnPropertyNames(test1)[0] === '5') {
                    return false;
                  } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


                  var test2 = {};

                  for (var i = 0; i < 10; i++) {
                    test2['_' + String.fromCharCode(i)] = i;
                  }

                  var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
                    return test2[n];
                  });

                  if (order2.join('') !== '0123456789') {
                    return false;
                  } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


                  var test3 = {};
                  'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
                    test3[letter] = letter;
                  });

                  if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
                    return false;
                  }

                  return true;
                } catch (err) {
                  // We don't expect any of the above to throw, but better to be safe.
                  return false;
                }
              }

              module.exports = shouldUseNative() ? Object.assign : function (target, source) {
                var from;
                var to = toObject(target);
                var symbols;

                for (var s = 1; s < arguments.length; s++) {
                  from = Object(arguments[s]);

                  for (var key in from) {
                    if (hasOwnProperty.call(from, key)) {
                      to[key] = from[key];
                    }
                  }

                  if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from);

                    for (var i = 0; i < symbols.length; i++) {
                      if (propIsEnumerable.call(from, symbols[i])) {
                        to[symbols[i]] = from[symbols[i]];
                      }
                    }
                  }
                }

                return to;
              };
              /***/
            },
            /* 5 */

            /***/
            function (module, exports) {
              /**
               * Copyright (c) 2013-present, Facebook, Inc.
               * All rights reserved.
               *
               * This source code is licensed under the BSD-style license found in the
               * LICENSE file in the root directory of this source tree. An additional grant
               * of patent rights can be found in the PATENTS file in the same directory.
               *
               */
              'use strict';

              var emptyObject = {};

              if (false) {}

              module.exports = emptyObject;
              /***/
            },
            /* 6 */

            /***/
            function (module, exports) {
              /**
               * Copyright (c) 2013-present, Facebook, Inc.
               * All rights reserved.
               *
               * This source code is licensed under the BSD-style license found in the
               * LICENSE file in the root directory of this source tree. An additional grant
               * of patent rights can be found in the PATENTS file in the same directory.
               *
               */
              'use strict';
              /**
               * Use invariant() to assert state which your program assumes to be true.
               *
               * Provide sprintf-style format (only %s is supported) and arguments
               * to provide information about what broke and what you were
               * expecting.
               *
               * The invariant message will be stripped in production, but the invariant
               * will remain to ensure logic does not differ in production.
               */

              var validateFormat = function validateFormat(format) {};

              if (false) {}

              function invariant(condition, format, a, b, c, d, e, f) {
                validateFormat(format);

                if (!condition) {
                  var error;

                  if (format === undefined) {
                    error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
                  } else {
                    var args = [a, b, c, d, e, f];
                    var argIndex = 0;
                    error = new Error(format.replace(/%s/g, function () {
                      return args[argIndex++];
                    }));
                    error.name = 'Invariant Violation';
                  }

                  error.framesToPop = 1; // we don't care about invariant's own frame

                  throw error;
                }
              }

              module.exports = invariant;
              /***/
            },
            /* 7 */

            /***/
            function (module, exports, __webpack_require__) {
              /**
               * Copyright 2014-2015, Facebook, Inc.
               * All rights reserved.
               *
               * This source code is licensed under the BSD-style license found in the
               * LICENSE file in the root directory of this source tree. An additional grant
               * of patent rights can be found in the PATENTS file in the same directory.
               *
               */
              'use strict';

              var emptyFunction = __webpack_require__(8);
              /**
               * Similar to invariant but only logs a warning if the condition is not met.
               * This can be used to log issues in development environments in critical
               * paths. Removing the logging code for production environments will keep the
               * same logic and follow the same code paths.
               */


              var warning = emptyFunction;

              if (false) {
                var printWarning;
              }

              module.exports = warning;
              /***/
            },
            /* 8 */

            /***/
            function (module, exports) {
              "use strict";
              /**
               * Copyright (c) 2013-present, Facebook, Inc.
               * All rights reserved.
               *
               * This source code is licensed under the BSD-style license found in the
               * LICENSE file in the root directory of this source tree. An additional grant
               * of patent rights can be found in the PATENTS file in the same directory.
               *
               * 
               */

              function makeEmptyFunction(arg) {
                return function () {
                  return arg;
                };
              }
              /**
               * This function accepts and discards inputs; it has no side effects. This is
               * primarily useful idiomatically for overridable function endpoints which
               * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
               */


              var emptyFunction = function emptyFunction() {};

              emptyFunction.thatReturns = makeEmptyFunction;
              emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
              emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
              emptyFunction.thatReturnsNull = makeEmptyFunction(null);

              emptyFunction.thatReturnsThis = function () {
                return this;
              };

              emptyFunction.thatReturnsArgument = function (arg) {
                return arg;
              };

              module.exports = emptyFunction;
              /***/
            },
            /* 9 */

            /***/
            function (module, exports) {
              'use strict';

              var NumeralFormatter = function NumeralFormatter(numeralDecimalMark, numeralIntegerScale, numeralDecimalScale, numeralThousandsGroupStyle, numeralPositiveOnly, stripLeadingZeroes, delimiter) {
                var owner = this;
                owner.numeralDecimalMark = numeralDecimalMark || '.';
                owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
                owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
                owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
                owner.numeralPositiveOnly = !!numeralPositiveOnly;
                owner.stripLeadingZeroes = stripLeadingZeroes !== false;
                owner.delimiter = delimiter || delimiter === '' ? delimiter : ',';
                owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
              };

              NumeralFormatter.groupStyle = {
                thousand: 'thousand',
                lakh: 'lakh',
                wan: 'wan',
                none: 'none'
              };
              NumeralFormatter.prototype = {
                getRawValue: function getRawValue(value) {
                  return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
                },
                format: function format(value) {
                  var owner = this,
                      parts,
                      partInteger,
                      partDecimal = ''; // strip alphabet letters

                  value = value.replace(/[A-Za-z]/g, '') // replace the first decimal mark with reserved placeholder
                  .replace(owner.numeralDecimalMark, 'M') // strip non numeric letters except minus and "M"
                  // this is to ensure prefix has been stripped
                  .replace(/[^\dM-]/g, '') // replace the leading minus with reserved placeholder
                  .replace(/^\-/, 'N') // strip the other minus sign (if present)
                  .replace(/\-/g, '') // replace the minus sign (if present)
                  .replace('N', owner.numeralPositiveOnly ? '' : '-') // replace decimal mark
                  .replace('M', owner.numeralDecimalMark); // strip any leading zeros

                  if (owner.stripLeadingZeroes) {
                    value = value.replace(/^(-)?0+(?=\d)/, '$1');
                  }

                  partInteger = value;

                  if (value.indexOf(owner.numeralDecimalMark) >= 0) {
                    parts = value.split(owner.numeralDecimalMark);
                    partInteger = parts[0];
                    partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
                  }

                  if (owner.numeralIntegerScale > 0) {
                    partInteger = partInteger.slice(0, owner.numeralIntegerScale + (value.slice(0, 1) === '-' ? 1 : 0));
                  }

                  switch (owner.numeralThousandsGroupStyle) {
                    case NumeralFormatter.groupStyle.lakh:
                      partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);
                      break;

                    case NumeralFormatter.groupStyle.wan:
                      partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);
                      break;

                    case NumeralFormatter.groupStyle.thousand:
                      partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);
                      break;
                  }

                  return partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
                }
              };
              module.exports = NumeralFormatter;
              /***/
            },
            /* 10 */

            /***/
            function (module, exports) {
              'use strict';

              var DateFormatter = function DateFormatter(datePattern) {
                var owner = this;
                owner.date = [];
                owner.blocks = [];
                owner.datePattern = datePattern;
                owner.initBlocks();
              };

              DateFormatter.prototype = {
                initBlocks: function initBlocks() {
                  var owner = this;
                  owner.datePattern.forEach(function (value) {
                    if (value === 'Y') {
                      owner.blocks.push(4);
                    } else {
                      owner.blocks.push(2);
                    }
                  });
                },
                getISOFormatDate: function getISOFormatDate() {
                  var owner = this,
                      date = owner.date;
                  return date[2] ? date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0]) : '';
                },
                getBlocks: function getBlocks() {
                  return this.blocks;
                },
                getValidatedDate: function getValidatedDate(value) {
                  var owner = this,
                      result = '';
                  value = value.replace(/[^\d]/g, '');
                  owner.blocks.forEach(function (length, index) {
                    if (value.length > 0) {
                      var sub = value.slice(0, length),
                          sub0 = sub.slice(0, 1),
                          rest = value.slice(length);

                      switch (owner.datePattern[index]) {
                        case 'd':
                          if (sub === '00') {
                            sub = '01';
                          } else if (parseInt(sub0, 10) > 3) {
                            sub = '0' + sub0;
                          } else if (parseInt(sub, 10) > 31) {
                            sub = '31';
                          }

                          break;

                        case 'm':
                          if (sub === '00') {
                            sub = '01';
                          } else if (parseInt(sub0, 10) > 1) {
                            sub = '0' + sub0;
                          } else if (parseInt(sub, 10) > 12) {
                            sub = '12';
                          }

                          break;
                      }

                      result += sub; // update remaining string

                      value = rest;
                    }
                  });
                  return this.getFixedDateString(result);
                },
                getFixedDateString: function getFixedDateString(value) {
                  var owner = this,
                      datePattern = owner.datePattern,
                      date = [],
                      dayIndex = 0,
                      monthIndex = 0,
                      yearIndex = 0,
                      dayStartIndex = 0,
                      monthStartIndex = 0,
                      yearStartIndex = 0,
                      day,
                      month,
                      year,
                      fullYearDone = false; // mm-dd || dd-mm

                  if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
                    dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
                    monthStartIndex = 2 - dayStartIndex;
                    day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
                    month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
                    date = this.getFixedDate(day, month, 0);
                  } // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd


                  if (value.length === 8) {
                    datePattern.forEach(function (type, index) {
                      switch (type) {
                        case 'd':
                          dayIndex = index;
                          break;

                        case 'm':
                          monthIndex = index;
                          break;

                        default:
                          yearIndex = index;
                          break;
                      }
                    });
                    yearStartIndex = yearIndex * 2;
                    dayStartIndex = dayIndex <= yearIndex ? dayIndex * 2 : dayIndex * 2 + 2;
                    monthStartIndex = monthIndex <= yearIndex ? monthIndex * 2 : monthIndex * 2 + 2;
                    day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
                    month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
                    year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
                    fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
                    date = this.getFixedDate(day, month, year);
                  }

                  owner.date = date;
                  return date.length === 0 ? value : datePattern.reduce(function (previous, current) {
                    switch (current) {
                      case 'd':
                        return previous + owner.addLeadingZero(date[0]);

                      case 'm':
                        return previous + owner.addLeadingZero(date[1]);

                      default:
                        return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2]) : '');
                    }
                  }, '');
                },
                getFixedDate: function getFixedDate(day, month, year) {
                  day = Math.min(day, 31);
                  month = Math.min(month, 12);
                  year = parseInt(year || 0, 10);

                  if (month < 7 && month % 2 === 0 || month > 8 && month % 2 === 1) {
                    day = Math.min(day, month === 2 ? this.isLeapYear(year) ? 29 : 28 : 30);
                  }

                  return [day, month, year];
                },
                isLeapYear: function isLeapYear(year) {
                  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
                },
                addLeadingZero: function addLeadingZero(number) {
                  return (number < 10 ? '0' : '') + number;
                },
                addLeadingZeroForYear: function addLeadingZeroForYear(number) {
                  return (number < 10 ? '000' : number < 100 ? '00' : number < 1000 ? '0' : '') + number;
                }
              };
              module.exports = DateFormatter;
              /***/
            },
            /* 11 */

            /***/
            function (module, exports) {
              'use strict';

              var TimeFormatter = function TimeFormatter(timePattern, timeFormat) {
                var owner = this;
                owner.time = [];
                owner.blocks = [];
                owner.timePattern = timePattern;
                owner.timeFormat = timeFormat;
                owner.initBlocks();
              };

              TimeFormatter.prototype = {
                initBlocks: function initBlocks() {
                  var owner = this;
                  owner.timePattern.forEach(function () {
                    owner.blocks.push(2);
                  });
                },
                getISOFormatTime: function getISOFormatTime() {
                  var owner = this,
                      time = owner.time;
                  return time[2] ? owner.addLeadingZero(time[0]) + ':' + owner.addLeadingZero(time[1]) + ':' + owner.addLeadingZero(time[2]) : '';
                },
                getBlocks: function getBlocks() {
                  return this.blocks;
                },
                getTimeFormatOptions: function getTimeFormatOptions() {
                  var owner = this;

                  if (String(owner.timeFormat) === '12') {
                    return {
                      maxHourFirstDigit: 1,
                      maxHours: 12,
                      maxMinutesFirstDigit: 5,
                      maxMinutes: 60
                    };
                  }

                  return {
                    maxHourFirstDigit: 2,
                    maxHours: 23,
                    maxMinutesFirstDigit: 5,
                    maxMinutes: 60
                  };
                },
                getValidatedTime: function getValidatedTime(value) {
                  var owner = this,
                      result = '';
                  value = value.replace(/[^\d]/g, '');
                  var timeFormatOptions = owner.getTimeFormatOptions();
                  owner.blocks.forEach(function (length, index) {
                    if (value.length > 0) {
                      var sub = value.slice(0, length),
                          sub0 = sub.slice(0, 1),
                          rest = value.slice(length);

                      switch (owner.timePattern[index]) {
                        case 'h':
                          if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
                            sub = '0' + sub0;
                          } else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
                            sub = timeFormatOptions.maxHours + '';
                          }

                          break;

                        case 'm':
                        case 's':
                          if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
                            sub = '0' + sub0;
                          } else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
                            sub = timeFormatOptions.maxMinutes + '';
                          }

                          break;
                      }

                      result += sub; // update remaining string

                      value = rest;
                    }
                  });
                  return this.getFixedTimeString(result);
                },
                getFixedTimeString: function getFixedTimeString(value) {
                  var owner = this,
                      timePattern = owner.timePattern,
                      time = [],
                      secondIndex = 0,
                      minuteIndex = 0,
                      hourIndex = 0,
                      secondStartIndex = 0,
                      minuteStartIndex = 0,
                      hourStartIndex = 0,
                      second,
                      minute,
                      hour;

                  if (value.length === 6) {
                    timePattern.forEach(function (type, index) {
                      switch (type) {
                        case 's':
                          secondIndex = index * 2;
                          break;

                        case 'm':
                          minuteIndex = index * 2;
                          break;

                        case 'h':
                          hourIndex = index * 2;
                          break;
                      }
                    });
                    hourStartIndex = hourIndex;
                    minuteStartIndex = minuteIndex;
                    secondStartIndex = secondIndex;
                    second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
                    minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
                    hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
                    time = this.getFixedTime(hour, minute, second);
                  }

                  if (value.length === 4 && owner.timePattern.indexOf('s') < 0) {
                    timePattern.forEach(function (type, index) {
                      switch (type) {
                        case 'm':
                          minuteIndex = index * 2;
                          break;

                        case 'h':
                          hourIndex = index * 2;
                          break;
                      }
                    });
                    hourStartIndex = hourIndex;
                    minuteStartIndex = minuteIndex;
                    second = 0;
                    minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
                    hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
                    time = this.getFixedTime(hour, minute, second);
                  }

                  owner.time = time;
                  return time.length === 0 ? value : timePattern.reduce(function (previous, current) {
                    switch (current) {
                      case 's':
                        return previous + owner.addLeadingZero(time[2]);

                      case 'm':
                        return previous + owner.addLeadingZero(time[1]);

                      case 'h':
                        return previous + owner.addLeadingZero(time[0]);
                    }
                  }, '');
                },
                getFixedTime: function getFixedTime(hour, minute, second) {
                  second = Math.min(parseInt(second || 0, 10), 60);
                  minute = Math.min(minute, 60);
                  hour = Math.min(hour, 60);
                  return [hour, minute, second];
                },
                addLeadingZero: function addLeadingZero(number) {
                  return (number < 10 ? '0' : '') + number;
                }
              };
              module.exports = TimeFormatter;
              /***/
            },
            /* 12 */

            /***/
            function (module, exports) {
              'use strict';

              var PhoneFormatter = function PhoneFormatter(formatter, delimiter) {
                var owner = this;
                owner.delimiter = delimiter || delimiter === '' ? delimiter : ' ';
                owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
                owner.formatter = formatter;
              };

              PhoneFormatter.prototype = {
                setFormatter: function setFormatter(formatter) {
                  this.formatter = formatter;
                },
                format: function format(phoneNumber) {
                  var owner = this;
                  owner.formatter.clear(); // only keep number and +

                  phoneNumber = phoneNumber.replace(/[^\d+]/g, ''); // strip non-leading +

                  phoneNumber = phoneNumber.replace(/^\+/, 'B').replace(/\+/g, '').replace('B', '+'); // strip delimiter

                  phoneNumber = phoneNumber.replace(owner.delimiterRE, '');
                  var result = '',
                      current,
                      validated = false;

                  for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
                    current = owner.formatter.inputDigit(phoneNumber.charAt(i)); // has ()- or space inside

                    if (/[\s()-]/g.test(current)) {
                      result = current;
                      validated = true;
                    } else {
                      if (!validated) {
                        result = current;
                      } // else: over length input
                      // it turns to invalid number again

                    }
                  } // strip ()
                  // e.g. US: 7161234567 returns (716) 123-4567


                  result = result.replace(/[()]/g, ''); // replace library delimiter with user customized delimiter

                  result = result.replace(/[\s-]/g, owner.delimiter);
                  return result;
                }
              };
              module.exports = PhoneFormatter;
              /***/
            },
            /* 13 */

            /***/
            function (module, exports) {
              'use strict';

              var CreditCardDetector = {
                blocks: {
                  uatp: [4, 5, 6],
                  amex: [4, 6, 5],
                  diners: [4, 6, 4],
                  discover: [4, 4, 4, 4],
                  mastercard: [4, 4, 4, 4],
                  dankort: [4, 4, 4, 4],
                  instapayment: [4, 4, 4, 4],
                  jcb15: [4, 6, 5],
                  jcb: [4, 4, 4, 4],
                  maestro: [4, 4, 4, 4],
                  visa: [4, 4, 4, 4],
                  mir: [4, 4, 4, 4],
                  unionPay: [4, 4, 4, 4],
                  general: [4, 4, 4, 4],
                  generalStrict: [4, 4, 4, 7]
                },
                re: {
                  // starts with 1; 15 digits, not starts with 1800 (jcb card)
                  uatp: /^(?!1800)1\d{0,14}/,
                  // starts with 34/37; 15 digits
                  amex: /^3[47]\d{0,13}/,
                  // starts with 6011/65/644-649; 16 digits
                  discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,
                  // starts with 300-305/309 or 36/38/39; 14 digits
                  diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
                  // starts with 51-55/2221–2720; 16 digits
                  mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
                  // starts with 5019/4175/4571; 16 digits
                  dankort: /^(5019|4175|4571)\d{0,12}/,
                  // starts with 637-639; 16 digits
                  instapayment: /^63[7-9]\d{0,13}/,
                  // starts with 2131/1800; 15 digits
                  jcb15: /^(?:2131|1800)\d{0,11}/,
                  // starts with 2131/1800/35; 16 digits
                  jcb: /^(?:35\d{0,2})\d{0,12}/,
                  // starts with 50/56-58/6304/67; 16 digits
                  maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
                  // starts with 22; 16 digits
                  mir: /^220[0-4]\d{0,12}/,
                  // starts with 4; 16 digits
                  visa: /^4\d{0,15}/,
                  // starts with 62; 16 digits
                  unionPay: /^62\d{0,14}/
                },
                getInfo: function getInfo(value, strictMode) {
                  var blocks = CreditCardDetector.blocks,
                      re = CreditCardDetector.re; // Some credit card can have up to 19 digits number.
                  // Set strictMode to true will remove the 16 max-length restrain,
                  // however, I never found any website validate card number like
                  // this, hence probably you don't want to enable this option.

                  strictMode = !!strictMode;

                  for (var key in re) {
                    if (re[key].test(value)) {
                      var block;

                      if (strictMode) {
                        block = blocks.generalStrict;
                      } else {
                        block = blocks[key];
                      }

                      return {
                        type: key,
                        blocks: block
                      };
                    }
                  }

                  return {
                    type: 'unknown',
                    blocks: strictMode ? blocks.generalStrict : blocks.general
                  };
                }
              };
              module.exports = CreditCardDetector;
              /***/
            },
            /* 14 */

            /***/
            function (module, exports) {
              'use strict';

              var Util = {
                noop: function noop() {},
                strip: function strip(value, re) {
                  return value.replace(re, '');
                },
                getPostDelimiter: function getPostDelimiter(value, delimiter, delimiters) {
                  // single delimiter
                  if (delimiters.length === 0) {
                    return value.slice(-delimiter.length) === delimiter ? delimiter : '';
                  } // multiple delimiters


                  var matchedDelimiter = '';
                  delimiters.forEach(function (current) {
                    if (value.slice(-current.length) === current) {
                      matchedDelimiter = current;
                    }
                  });
                  return matchedDelimiter;
                },
                getDelimiterREByDelimiter: function getDelimiterREByDelimiter(delimiter) {
                  return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
                },
                getNextCursorPosition: function getNextCursorPosition(prevPos, oldValue, newValue, delimiter, delimiters) {
                  // If cursor was at the end of value, just place it back.
                  // Because new value could contain additional chars.
                  if (oldValue.length === prevPos) {
                    return newValue.length;
                  }

                  return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters);
                },
                getPositionOffset: function getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters) {
                  var oldRawValue, newRawValue, lengthOffset;
                  oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
                  newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
                  lengthOffset = oldRawValue.length - newRawValue.length;
                  return lengthOffset !== 0 ? lengthOffset / Math.abs(lengthOffset) : 0;
                },
                stripDelimiters: function stripDelimiters(value, delimiter, delimiters) {
                  var owner = this; // single delimiter

                  if (delimiters.length === 0) {
                    var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';
                    return value.replace(delimiterRE, '');
                  } // multiple delimiters


                  delimiters.forEach(function (current) {
                    current.split('').forEach(function (letter) {
                      value = value.replace(owner.getDelimiterREByDelimiter(letter), '');
                    });
                  });
                  return value;
                },
                headStr: function headStr(str, length) {
                  return str.slice(0, length);
                },
                getMaxLength: function getMaxLength(blocks) {
                  return blocks.reduce(function (previous, current) {
                    return previous + current;
                  }, 0);
                },
                // strip prefix
                // Before type  |   After type    |     Return value
                // PEFIX-...    |   PEFIX-...     |     ''
                // PREFIX-123   |   PEFIX-123     |     123
                // PREFIX-123   |   PREFIX-23     |     23
                // PREFIX-123   |   PREFIX-1234   |     1234
                getPrefixStrippedValue: function getPrefixStrippedValue(value, prefix, prefixLength, prevResult, delimiter, delimiters) {
                  // No prefix
                  if (prefixLength === 0) {
                    return value;
                  } // Pre result has issue
                  // Revert to raw prefix


                  if (prevResult.slice(0, prefixLength) !== prefix) {
                    return '';
                  }

                  var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters); // New value has issue, someone typed in between prefix letters
                  // Revert to pre value

                  if (value.slice(0, prefixLength) !== prefix) {
                    return prevValue.slice(prefixLength);
                  } // No issue, strip prefix for new value


                  return value.slice(prefixLength);
                },
                getFirstDiffIndex: function getFirstDiffIndex(prev, current) {
                  var index = 0;

                  while (prev.charAt(index) === current.charAt(index)) {
                    if (prev.charAt(index++) === '') {
                      return -1;
                    }
                  }

                  return index;
                },
                getFormattedValue: function getFormattedValue(value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
                  var result = '',
                      multipleDelimiters = delimiters.length > 0,
                      currentDelimiter; // no options, normal input

                  if (blocksLength === 0) {
                    return value;
                  }

                  blocks.forEach(function (length, index) {
                    if (value.length > 0) {
                      var sub = value.slice(0, length),
                          rest = value.slice(length);

                      if (multipleDelimiters) {
                        currentDelimiter = delimiters[delimiterLazyShow ? index - 1 : index] || currentDelimiter;
                      } else {
                        currentDelimiter = delimiter;
                      }

                      if (delimiterLazyShow) {
                        if (index > 0) {
                          result += currentDelimiter;
                        }

                        result += sub;
                      } else {
                        result += sub;

                        if (sub.length === length && index < blocksLength - 1) {
                          result += currentDelimiter;
                        }
                      } // update remaining string


                      value = rest;
                    }
                  });
                  return result;
                },
                // move cursor to the end
                // the first time user focuses on an input with prefix
                fixPrefixCursor: function fixPrefixCursor(el, prefix, delimiter, delimiters) {
                  if (!el) {
                    return;
                  }

                  var val = el.value,
                      appendix = delimiter || delimiters[0] || ' ';

                  if (!el.setSelectionRange || !prefix || prefix.length + appendix.length < val.length) {
                    return;
                  }

                  var len = val.length * 2; // set timeout to avoid blink

                  setTimeout(function () {
                    el.setSelectionRange(len, len);
                  }, 1);
                },
                setSelection: function setSelection(element, position, doc) {
                  if (element !== this.getActiveElement(doc)) {
                    return;
                  } // cursor is already in the end


                  if (element && element.value.length <= position) {
                    return;
                  }

                  if (element.createTextRange) {
                    var range = element.createTextRange();
                    range.move('character', position);
                    range.select();
                  } else {
                    try {
                      element.setSelectionRange(position, position);
                    } catch (e) {
                      // eslint-disable-next-line
                      console.warn('The input element type does not support selection');
                    }
                  }
                },
                getActiveElement: function getActiveElement(parent) {
                  var activeElement = parent.activeElement;

                  if (activeElement && activeElement.shadowRoot) {
                    return this.getActiveElement(activeElement.shadowRoot);
                  }

                  return activeElement;
                },
                isAndroid: function isAndroid() {
                  return navigator && /android/i.test(navigator.userAgent);
                },
                // On Android chrome, the keyup and keydown events
                // always return key code 229 as a composition that
                // buffers the user’s keystrokes
                // see https://github.com/nosir/cleave.js/issues/147
                isAndroidBackspaceKeydown: function isAndroidBackspaceKeydown(lastInputValue, currentInputValue) {
                  if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
                    return false;
                  }

                  return currentInputValue === lastInputValue.slice(0, -1);
                }
              };
              module.exports = Util;
              /***/
            },
            /* 15 */

            /***/
            function (module, exports) {
              'use strict';
              /**
               * Props Assignment
               *
               * Separate this, so react module can share the usage
               */

              var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
                return typeof obj;
              } : function (obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
              };

              var DefaultProperties = {
                // Maybe change to object-assign
                // for now just keep it as simple
                assign: function assign(target, opts) {
                  target = target || {};
                  opts = opts || {}; // credit card

                  target.creditCard = !!opts.creditCard;
                  target.creditCardStrictMode = !!opts.creditCardStrictMode;
                  target.creditCardType = '';

                  target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || function () {}; // phone


                  target.phone = !!opts.phone;
                  target.phoneRegionCode = opts.phoneRegionCode || 'AU';
                  target.phoneFormatter = {}; // time

                  target.time = !!opts.time;
                  target.timePattern = opts.timePattern || ['h', 'm', 's'];
                  target.timeFormat = opts.timeFormat || '24';
                  target.timeFormatter = {}; // date

                  target.date = !!opts.date;
                  target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
                  target.dateFormatter = {}; // numeral

                  target.numeral = !!opts.numeral;
                  target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
                  target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
                  target.numeralDecimalMark = opts.numeralDecimalMark || '.';
                  target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
                  target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
                  target.stripLeadingZeroes = opts.stripLeadingZeroes !== false; // others

                  target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;
                  target.uppercase = !!opts.uppercase;
                  target.lowercase = !!opts.lowercase;
                  target.prefix = target.creditCard || target.date ? '' : opts.prefix || '';
                  target.noImmediatePrefix = !!opts.noImmediatePrefix;
                  target.prefixLength = target.prefix.length;
                  target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
                  target.copyDelimiter = !!opts.copyDelimiter;
                  target.initValue = opts.initValue !== undefined && opts.initValue !== null ? opts.initValue.toString() : '';
                  target.delimiter = opts.delimiter || opts.delimiter === '' ? opts.delimiter : opts.date ? '/' : opts.time ? ':' : opts.numeral ? ',' : opts.phone ? ' ' : ' ';
                  target.delimiterLength = target.delimiter.length;
                  target.delimiterLazyShow = !!opts.delimiterLazyShow;
                  target.delimiters = opts.delimiters || [];
                  target.blocks = opts.blocks || [];
                  target.blocksLength = target.blocks.length;
                  target.root = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global ? global : window;
                  target.document = opts.document || target.root.document;
                  target.maxLength = 0;
                  target.backspace = false;
                  target.result = '';

                  target.onValueChanged = opts.onValueChanged || function () {};

                  return target;
                }
              };
              module.exports = DefaultProperties;
              /***/
            }])
          );
        });

        ;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 378 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseValues = __webpack_require__(939),
          keys = __webpack_require__(132);
      /**
       * Creates an array of the own enumerable string keyed property values of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property values.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.values(new Foo);
       * // => [1, 2] (iteration order is not guaranteed)
       *
       * _.values('hi');
       * // => ['h', 'i']
       */


      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }

      module.exports = values;
      /***/
    },
    /* 379 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      /**
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */

      var __DEV__ = "production" !== 'production';

      var warning = function warning() {};

      if (__DEV__) {
        var printWarning = function printWarning(format, args) {
          var len = arguments.length;
          args = new Array(len > 1 ? len - 1 : 0);

          for (var key = 1; key < len; key++) {
            args[key - 1] = arguments[key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.error(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        warning = function warning(condition, format, args) {
          var len = arguments.length;
          args = new Array(len > 2 ? len - 2 : 0);

          for (var key = 2; key < len; key++) {
            args[key - 2] = arguments[key];
          }

          if (format === undefined) {
            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (!condition) {
            printWarning.apply(null, [format].concat(args));
          }
        };
      }

      module.exports = warning;
      /***/
    },
    /* 380 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, '__esModule', {
        value: true
      });
      exports['default'] = addEventListener;

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var _EventObject = __webpack_require__(1137);

      var _EventObject2 = _interopRequireDefault(_EventObject);

      function addEventListener(target, eventType, callback, option) {
        function wrapCallback(e) {
          var ne = new _EventObject2['default'](e);
          callback.call(target, ne);
        }

        if (target.addEventListener) {
          var _ret = function () {
            var useCapture = false;

            if (typeof option === 'object') {
              useCapture = option.capture || false;
            } else if (typeof option === 'boolean') {
              useCapture = option;
            }

            target.addEventListener(eventType, wrapCallback, option || false);
            return {
              v: {
                remove: function remove() {
                  target.removeEventListener(eventType, wrapCallback, useCapture);
                }
              }
            };
          }();

          if (typeof _ret === 'object') return _ret.v;
        } else if (target.attachEvent) {
          target.attachEvent('on' + eventType, wrapCallback);
          return {
            remove: function remove() {
              target.detachEvent('on' + eventType, wrapCallback);
            }
          };
        }
      }

      module.exports = exports['default'];
      /***/
    },
    /* 381 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global) {
        var now = __webpack_require__(721),
            root = typeof window === 'undefined' ? global : window,
            vendors = ['moz', 'webkit'],
            suffix = 'AnimationFrame',
            raf = root['request' + suffix],
            caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

        for (var i = 0; !raf && i < vendors.length; i++) {
          raf = root[vendors[i] + 'Request' + suffix];
          caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
        } // Some versions of FF have rAF but not cAF


        if (!raf || !caf) {
          var last = 0,
              id = 0,
              queue = [],
              frameDuration = 1000 / 60;

          raf = function raf(callback) {
            if (queue.length === 0) {
              var _now = now(),
                  next = Math.max(0, frameDuration - (_now - last));

              last = next + _now;
              setTimeout(function () {
                var cp = queue.slice(0); // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue

                queue.length = 0;

                for (var i = 0; i < cp.length; i++) {
                  if (!cp[i].cancelled) {
                    try {
                      cp[i].callback(last);
                    } catch (e) {
                      setTimeout(function () {
                        throw e;
                      }, 0);
                    }
                  }
                }
              }, Math.round(next));
            }

            queue.push({
              handle: ++id,
              callback: callback,
              cancelled: false
            });
            return id;
          };

          caf = function caf(handle) {
            for (var i = 0; i < queue.length; i++) {
              if (queue[i].handle === handle) {
                queue[i].cancelled = true;
              }
            }
          };
        }

        module.exports = function (fn) {
          // Wrap in a new function to prevent
          // `cancel` potentially being assigned
          // to the native rAF function
          return raf.call(root, fn);
        };

        module.exports.cancel = function () {
          caf.apply(root, arguments);
        };

        module.exports.polyfill = function (object) {
          if (!object) {
            object = root;
          }

          object.requestAnimationFrame = raf;
          object.cancelAnimationFrame = caf;
        };
        /* WEBPACK VAR INJECTION */

      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 382 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(825);
      /***/
    },
    /* 383 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _rcCalendar = __webpack_require__(183);

      var _rcCalendar2 = _interopRequireDefault(_rcCalendar);

      var _MonthCalendar = __webpack_require__(429);

      var _MonthCalendar2 = _interopRequireDefault(_MonthCalendar);

      var _createPicker = __webpack_require__(845);

      var _createPicker2 = _interopRequireDefault(_createPicker);

      var _wrapPicker = __webpack_require__(842);

      var _wrapPicker2 = _interopRequireDefault(_wrapPicker);

      var _RangePicker = __webpack_require__(835);

      var _RangePicker2 = _interopRequireDefault(_RangePicker);

      var _WeekPicker = __webpack_require__(827);

      var _WeekPicker2 = _interopRequireDefault(_WeekPicker);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var DatePicker = (0, _wrapPicker2['default'])((0, _createPicker2['default'])(_rcCalendar2['default']));
      var MonthPicker = (0, _wrapPicker2['default'])((0, _createPicker2['default'])(_MonthCalendar2['default']), 'YYYY-MM');
      (0, _extends3['default'])(DatePicker, {
        RangePicker: (0, _wrapPicker2['default'])(_RangePicker2['default']),
        MonthPicker: MonthPicker,
        WeekPicker: (0, _wrapPicker2['default'])(_WeekPicker2['default'], 'gggg-wo')
      });
      exports['default'] = DatePicker;
      module.exports = exports['default'];
      /***/
    },
    /* 384 */

    /***/
    function (module, exports, __webpack_require__) {
      /**!
      
       @license
       handlebars v4.1.2
      
      Copyright (C) 2011-2017 by Yehuda Katz
      
      Permission is hereby granted, free of charge, to any person obtaining a copy
      of this software and associated documentation files (the "Software"), to deal
      in the Software without restriction, including without limitation the rights
      to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the Software is
      furnished to do so, subject to the following conditions:
      
      The above copyright notice and this permission notice shall be included in
      all copies or substantial portions of the Software.
      
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      THE SOFTWARE.
      
      */
      !function (a, b) {
        true ? module.exports = b() : undefined;
      }(this, function () {
        return function (a) {
          function b(d) {
            if (c[d]) return c[d].exports;
            var e = c[d] = {
              exports: {},
              id: d,
              loaded: !1
            };
            return a[d].call(e.exports, e, e.exports, b), e.loaded = !0, e.exports;
          }

          var c = {};
          return b.m = a, b.c = c, b.p = "", b(0);
        }([function (a, b, c) {
          "use strict";

          function d() {
            var a = r();
            return a.compile = function (b, c) {
              return k.compile(b, c, a);
            }, a.precompile = function (b, c) {
              return k.precompile(b, c, a);
            }, a.AST = i["default"], a.Compiler = k.Compiler, a.JavaScriptCompiler = m["default"], a.Parser = j.parser, a.parse = j.parse, a;
          }

          var e = c(1)["default"];
          b.__esModule = !0;
          var f = c(2),
              g = e(f),
              h = c(35),
              i = e(h),
              j = c(36),
              k = c(41),
              l = c(42),
              m = e(l),
              n = c(39),
              o = e(n),
              p = c(34),
              q = e(p),
              r = g["default"].create,
              s = d();
          s.create = d, q["default"](s), s.Visitor = o["default"], s["default"] = s, b["default"] = s, a.exports = b["default"];
        }, function (a, b) {
          "use strict";

          b["default"] = function (a) {
            return a && a.__esModule ? a : {
              "default": a
            };
          }, b.__esModule = !0;
        }, function (a, b, c) {
          "use strict";

          function d() {
            var a = new h.HandlebarsEnvironment();
            return n.extend(a, h), a.SafeString = j["default"], a.Exception = l["default"], a.Utils = n, a.escapeExpression = n.escapeExpression, a.VM = p, a.template = function (b) {
              return p.template(b, a);
            }, a;
          }

          var e = c(3)["default"],
              f = c(1)["default"];
          b.__esModule = !0;
          var g = c(4),
              h = e(g),
              i = c(21),
              j = f(i),
              k = c(6),
              l = f(k),
              m = c(5),
              n = e(m),
              o = c(22),
              p = e(o),
              q = c(34),
              r = f(q),
              s = d();
          s.create = d, r["default"](s), s["default"] = s, b["default"] = s, a.exports = b["default"];
        }, function (a, b) {
          "use strict";

          b["default"] = function (a) {
            if (a && a.__esModule) return a;
            var b = {};
            if (null != a) for (var c in a) {
              Object.prototype.hasOwnProperty.call(a, c) && (b[c] = a[c]);
            }
            return b["default"] = a, b;
          }, b.__esModule = !0;
        }, function (a, b, c) {
          "use strict";

          function d(a, b, c) {
            this.helpers = a || {}, this.partials = b || {}, this.decorators = c || {}, i.registerDefaultHelpers(this), j.registerDefaultDecorators(this);
          }

          var e = c(1)["default"];
          b.__esModule = !0, b.HandlebarsEnvironment = d;
          var f = c(5),
              g = c(6),
              h = e(g),
              i = c(10),
              j = c(18),
              k = c(20),
              l = e(k),
              m = "4.1.2";
          b.VERSION = m;
          var n = 7;
          b.COMPILER_REVISION = n;
          var o = {
            1: "<= 1.0.rc.2",
            2: "== 1.0.0-rc.3",
            3: "== 1.0.0-rc.4",
            4: "== 1.x.x",
            5: "== 2.0.0-alpha.x",
            6: ">= 2.0.0-beta.1",
            7: ">= 4.0.0"
          };
          b.REVISION_CHANGES = o;
          var p = "[object Object]";
          d.prototype = {
            constructor: d,
            logger: l["default"],
            log: l["default"].log,
            registerHelper: function registerHelper(a, b) {
              if (f.toString.call(a) === p) {
                if (b) throw new h["default"]("Arg not supported with multiple helpers");
                f.extend(this.helpers, a);
              } else this.helpers[a] = b;
            },
            unregisterHelper: function unregisterHelper(a) {
              delete this.helpers[a];
            },
            registerPartial: function registerPartial(a, b) {
              if (f.toString.call(a) === p) f.extend(this.partials, a);else {
                if ("undefined" == typeof b) throw new h["default"]('Attempting to register a partial called "' + a + '" as undefined');
                this.partials[a] = b;
              }
            },
            unregisterPartial: function unregisterPartial(a) {
              delete this.partials[a];
            },
            registerDecorator: function registerDecorator(a, b) {
              if (f.toString.call(a) === p) {
                if (b) throw new h["default"]("Arg not supported with multiple decorators");
                f.extend(this.decorators, a);
              } else this.decorators[a] = b;
            },
            unregisterDecorator: function unregisterDecorator(a) {
              delete this.decorators[a];
            }
          };
          var q = l["default"].log;
          b.log = q, b.createFrame = f.createFrame, b.logger = l["default"];
        }, function (a, b) {
          "use strict";

          function c(a) {
            return k[a];
          }

          function d(a) {
            for (var b = 1; b < arguments.length; b++) {
              for (var c in arguments[b]) {
                Object.prototype.hasOwnProperty.call(arguments[b], c) && (a[c] = arguments[b][c]);
              }
            }

            return a;
          }

          function e(a, b) {
            for (var c = 0, d = a.length; c < d; c++) {
              if (a[c] === b) return c;
            }

            return -1;
          }

          function f(a) {
            if ("string" != typeof a) {
              if (a && a.toHTML) return a.toHTML();
              if (null == a) return "";
              if (!a) return a + "";
              a = "" + a;
            }

            return m.test(a) ? a.replace(l, c) : a;
          }

          function g(a) {
            return !a && 0 !== a || !(!p(a) || 0 !== a.length);
          }

          function h(a) {
            var b = d({}, a);
            return b._parent = a, b;
          }

          function i(a, b) {
            return a.path = b, a;
          }

          function j(a, b) {
            return (a ? a + "." : "") + b;
          }

          b.__esModule = !0, b.extend = d, b.indexOf = e, b.escapeExpression = f, b.isEmpty = g, b.createFrame = h, b.blockParams = i, b.appendContextPath = j;
          var k = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;",
            "=": "&#x3D;"
          },
              l = /[&<>"'`=]/g,
              m = /[&<>"'`=]/,
              n = Object.prototype.toString;
          b.toString = n;

          var o = function o(a) {
            return "function" == typeof a;
          };

          o(/x/) && (b.isFunction = o = function o(a) {
            return "function" == typeof a && "[object Function]" === n.call(a);
          }), b.isFunction = o;

          var p = Array.isArray || function (a) {
            return !(!a || "object" != typeof a) && "[object Array]" === n.call(a);
          };

          b.isArray = p;
        }, function (a, b, c) {
          "use strict";

          function d(a, b) {
            var c = b && b.loc,
                g = void 0,
                h = void 0;
            c && (g = c.start.line, h = c.start.column, a += " - " + g + ":" + h);

            for (var i = Error.prototype.constructor.call(this, a), j = 0; j < f.length; j++) {
              this[f[j]] = i[f[j]];
            }

            Error.captureStackTrace && Error.captureStackTrace(this, d);

            try {
              c && (this.lineNumber = g, e ? Object.defineProperty(this, "column", {
                value: h,
                enumerable: !0
              }) : this.column = h);
            } catch (k) {}
          }

          var e = c(7)["default"];
          b.__esModule = !0;
          var f = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
          d.prototype = new Error(), b["default"] = d, a.exports = b["default"];
        }, function (a, b, c) {
          a.exports = {
            "default": c(8),
            __esModule: !0
          };
        }, function (a, b, c) {
          var d = c(9);

          a.exports = function (a, b, c) {
            return d.setDesc(a, b, c);
          };
        }, function (a, b) {
          var c = Object;
          a.exports = {
            create: c.create,
            getProto: c.getPrototypeOf,
            isEnum: {}.propertyIsEnumerable,
            getDesc: c.getOwnPropertyDescriptor,
            setDesc: c.defineProperty,
            setDescs: c.defineProperties,
            getKeys: c.keys,
            getNames: c.getOwnPropertyNames,
            getSymbols: c.getOwnPropertySymbols,
            each: [].forEach
          };
        }, function (a, b, c) {
          "use strict";

          function d(a) {
            g["default"](a), i["default"](a), k["default"](a), m["default"](a), o["default"](a), q["default"](a), s["default"](a);
          }

          var e = c(1)["default"];
          b.__esModule = !0, b.registerDefaultHelpers = d;
          var f = c(11),
              g = e(f),
              h = c(12),
              i = e(h),
              j = c(13),
              k = e(j),
              l = c(14),
              m = e(l),
              n = c(15),
              o = e(n),
              p = c(16),
              q = e(p),
              r = c(17),
              s = e(r);
        }, function (a, b, c) {
          "use strict";

          b.__esModule = !0;
          var d = c(5);
          b["default"] = function (a) {
            a.registerHelper("blockHelperMissing", function (b, c) {
              var e = c.inverse,
                  f = c.fn;
              if (b === !0) return f(this);
              if (b === !1 || null == b) return e(this);
              if (d.isArray(b)) return b.length > 0 ? (c.ids && (c.ids = [c.name]), a.helpers.each(b, c)) : e(this);

              if (c.data && c.ids) {
                var g = d.createFrame(c.data);
                g.contextPath = d.appendContextPath(c.data.contextPath, c.name), c = {
                  data: g
                };
              }

              return f(b, c);
            });
          }, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          var d = c(1)["default"];
          b.__esModule = !0;
          var e = c(5),
              f = c(6),
              g = d(f);
          b["default"] = function (a) {
            a.registerHelper("each", function (a, b) {
              function c(b, c, f) {
                j && (j.key = b, j.index = c, j.first = 0 === c, j.last = !!f, k && (j.contextPath = k + b)), i += d(a[b], {
                  data: j,
                  blockParams: e.blockParams([a[b], b], [k + b, null])
                });
              }

              if (!b) throw new g["default"]("Must pass iterator to #each");
              var d = b.fn,
                  f = b.inverse,
                  h = 0,
                  i = "",
                  j = void 0,
                  k = void 0;
              if (b.data && b.ids && (k = e.appendContextPath(b.data.contextPath, b.ids[0]) + "."), e.isFunction(a) && (a = a.call(this)), b.data && (j = e.createFrame(b.data)), a && "object" == typeof a) if (e.isArray(a)) for (var l = a.length; h < l; h++) {
                h in a && c(h, h, h === a.length - 1);
              } else {
                var m = void 0;

                for (var n in a) {
                  a.hasOwnProperty(n) && (void 0 !== m && c(m, h - 1), m = n, h++);
                }

                void 0 !== m && c(m, h - 1, !0);
              }
              return 0 === h && (i = f(this)), i;
            });
          }, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          var d = c(1)["default"];
          b.__esModule = !0;
          var e = c(6),
              f = d(e);
          b["default"] = function (a) {
            a.registerHelper("helperMissing", function () {
              if (1 !== arguments.length) throw new f["default"]('Missing helper: "' + arguments[arguments.length - 1].name + '"');
            });
          }, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          b.__esModule = !0;
          var d = c(5);
          b["default"] = function (a) {
            a.registerHelper("if", function (a, b) {
              return d.isFunction(a) && (a = a.call(this)), !b.hash.includeZero && !a || d.isEmpty(a) ? b.inverse(this) : b.fn(this);
            }), a.registerHelper("unless", function (b, c) {
              return a.helpers["if"].call(this, b, {
                fn: c.inverse,
                inverse: c.fn,
                hash: c.hash
              });
            });
          }, a.exports = b["default"];
        }, function (a, b) {
          "use strict";

          b.__esModule = !0, b["default"] = function (a) {
            a.registerHelper("log", function () {
              for (var b = [void 0], c = arguments[arguments.length - 1], d = 0; d < arguments.length - 1; d++) {
                b.push(arguments[d]);
              }

              var e = 1;
              null != c.hash.level ? e = c.hash.level : c.data && null != c.data.level && (e = c.data.level), b[0] = e, a.log.apply(a, b);
            });
          }, a.exports = b["default"];
        }, function (a, b) {
          "use strict";

          b.__esModule = !0, b["default"] = function (a) {
            a.registerHelper("lookup", function (a, b) {
              if (!a) return a;
              if ("constructor" !== b || a.propertyIsEnumerable(b)) return a[b];
            });
          }, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          b.__esModule = !0;
          var d = c(5);
          b["default"] = function (a) {
            a.registerHelper("with", function (a, b) {
              d.isFunction(a) && (a = a.call(this));
              var c = b.fn;
              if (d.isEmpty(a)) return b.inverse(this);
              var e = b.data;
              return b.data && b.ids && (e = d.createFrame(b.data), e.contextPath = d.appendContextPath(b.data.contextPath, b.ids[0])), c(a, {
                data: e,
                blockParams: d.blockParams([a], [e && e.contextPath])
              });
            });
          }, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          function d(a) {
            g["default"](a);
          }

          var e = c(1)["default"];
          b.__esModule = !0, b.registerDefaultDecorators = d;
          var f = c(19),
              g = e(f);
        }, function (a, b, c) {
          "use strict";

          b.__esModule = !0;
          var d = c(5);
          b["default"] = function (a) {
            a.registerDecorator("inline", function (a, b, c, e) {
              var f = a;
              return b.partials || (b.partials = {}, f = function f(e, _f2) {
                var g = c.partials;
                c.partials = d.extend({}, g, b.partials);
                var h = a(e, _f2);
                return c.partials = g, h;
              }), b.partials[e.args[0]] = e.fn, f;
            });
          }, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          b.__esModule = !0;
          var d = c(5),
              e = {
            methodMap: ["debug", "info", "warn", "error"],
            level: "info",
            lookupLevel: function lookupLevel(a) {
              if ("string" == typeof a) {
                var b = d.indexOf(e.methodMap, a.toLowerCase());
                a = b >= 0 ? b : parseInt(a, 10);
              }

              return a;
            },
            log: function log(a) {
              if (a = e.lookupLevel(a), "undefined" != typeof console && e.lookupLevel(e.level) <= a) {
                var b = e.methodMap[a];
                console[b] || (b = "log");

                for (var c = arguments.length, d = Array(c > 1 ? c - 1 : 0), f = 1; f < c; f++) {
                  d[f - 1] = arguments[f];
                }

                console[b].apply(console, d);
              }
            }
          };
          b["default"] = e, a.exports = b["default"];
        }, function (a, b) {
          "use strict";

          function c(a) {
            this.string = a;
          }

          b.__esModule = !0, c.prototype.toString = c.prototype.toHTML = function () {
            return "" + this.string;
          }, b["default"] = c, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          function d(a) {
            var b = a && a[0] || 1,
                c = s.COMPILER_REVISION;

            if (b !== c) {
              if (b < c) {
                var d = s.REVISION_CHANGES[c],
                    e = s.REVISION_CHANGES[b];
                throw new r["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + d + ") or downgrade your runtime to an older version (" + e + ").");
              }

              throw new r["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + a[1] + ").");
            }
          }

          function e(a, b) {
            function c(c, d, e) {
              e.hash && (d = p.extend({}, d, e.hash), e.ids && (e.ids[0] = !0)), c = b.VM.resolvePartial.call(this, c, d, e);
              var f = b.VM.invokePartial.call(this, c, d, e);

              if (null == f && b.compile && (e.partials[e.name] = b.compile(c, a.compilerOptions, b), f = e.partials[e.name](d, e)), null != f) {
                if (e.indent) {
                  for (var g = f.split("\n"), h = 0, i = g.length; h < i && (g[h] || h + 1 !== i); h++) {
                    g[h] = e.indent + g[h];
                  }

                  f = g.join("\n");
                }

                return f;
              }

              throw new r["default"]("The partial " + e.name + " could not be compiled when running in runtime-only mode");
            }

            function d(b) {
              function c(b) {
                return "" + a.main(e, b, e.helpers, e.partials, g, i, h);
              }

              var f = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                  g = f.data;
              d._setup(f), !f.partial && a.useData && (g = j(b, g));
              var h = void 0,
                  i = a.useBlockParams ? [] : void 0;
              return a.useDepths && (h = f.depths ? b != f.depths[0] ? [b].concat(f.depths) : f.depths : [b]), (c = k(a.main, c, e, f.depths || [], g, i))(b, f);
            }

            if (!b) throw new r["default"]("No environment passed to template");
            if (!a || !a.main) throw new r["default"]("Unknown template object: " + typeof a);
            a.main.decorator = a.main_d, b.VM.checkRevision(a.compiler);
            var e = {
              strict: function strict(a, b) {
                if (!(b in a)) throw new r["default"]('"' + b + '" not defined in ' + a);
                return a[b];
              },
              lookup: function lookup(a, b) {
                for (var c = a.length, d = 0; d < c; d++) {
                  if (a[d] && null != a[d][b]) return a[d][b];
                }
              },
              lambda: function lambda(a, b) {
                return "function" == typeof a ? a.call(b) : a;
              },
              escapeExpression: p.escapeExpression,
              invokePartial: c,
              fn: function fn(b) {
                var c = a[b];
                return c.decorator = a[b + "_d"], c;
              },
              programs: [],
              program: function program(a, b, c, d, e) {
                var g = this.programs[a],
                    h = this.fn(a);
                return b || e || d || c ? g = f(this, a, h, b, c, d, e) : g || (g = this.programs[a] = f(this, a, h)), g;
              },
              data: function data(a, b) {
                for (; a && b--;) {
                  a = a._parent;
                }

                return a;
              },
              merge: function merge(a, b) {
                var c = a || b;
                return a && b && a !== b && (c = p.extend({}, b, a)), c;
              },
              nullContext: l({}),
              noop: b.VM.noop,
              compilerInfo: a.compiler
            };
            return d.isTop = !0, d._setup = function (c) {
              c.partial ? (e.helpers = c.helpers, e.partials = c.partials, e.decorators = c.decorators) : (e.helpers = e.merge(c.helpers, b.helpers), a.usePartial && (e.partials = e.merge(c.partials, b.partials)), (a.usePartial || a.useDecorators) && (e.decorators = e.merge(c.decorators, b.decorators)));
            }, d._child = function (b, c, d, g) {
              if (a.useBlockParams && !d) throw new r["default"]("must pass block params");
              if (a.useDepths && !g) throw new r["default"]("must pass parent depths");
              return f(e, b, a[b], c, 0, d, g);
            }, d;
          }

          function f(a, b, c, d, e, f, g) {
            function h(b) {
              var e = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                  h = g;
              return !g || b == g[0] || b === a.nullContext && null === g[0] || (h = [b].concat(g)), c(a, b, a.helpers, a.partials, e.data || d, f && [e.blockParams].concat(f), h);
            }

            return h = k(c, h, a, g, d, f), h.program = b, h.depth = g ? g.length : 0, h.blockParams = e || 0, h;
          }

          function g(a, b, c) {
            return a ? a.call || c.name || (c.name = a, a = c.partials[a]) : a = "@partial-block" === c.name ? c.data["partial-block"] : c.partials[c.name], a;
          }

          function h(a, b, c) {
            var d = c.data && c.data["partial-block"];
            c.partial = !0, c.ids && (c.data.contextPath = c.ids[0] || c.data.contextPath);
            var e = void 0;
            if (c.fn && c.fn !== i && !function () {
              c.data = s.createFrame(c.data);
              var a = c.fn;
              e = c.data["partial-block"] = function (b) {
                var c = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
                return c.data = s.createFrame(c.data), c.data["partial-block"] = d, a(b, c);
              }, a.partials && (c.partials = p.extend({}, c.partials, a.partials));
            }(), void 0 === a && e && (a = e), void 0 === a) throw new r["default"]("The partial " + c.name + " could not be found");
            if (a instanceof Function) return a(b, c);
          }

          function i() {
            return "";
          }

          function j(a, b) {
            return b && "root" in b || (b = b ? s.createFrame(b) : {}, b.root = a), b;
          }

          function k(a, b, c, d, e, f) {
            if (a.decorator) {
              var g = {};
              b = a.decorator(b, g, c, d && d[0], e, f, d), p.extend(b, g);
            }

            return b;
          }

          var l = c(23)["default"],
              m = c(3)["default"],
              n = c(1)["default"];
          b.__esModule = !0, b.checkRevision = d, b.template = e, b.wrapProgram = f, b.resolvePartial = g, b.invokePartial = h, b.noop = i;
          var o = c(5),
              p = m(o),
              q = c(6),
              r = n(q),
              s = c(4);
        }, function (a, b, c) {
          a.exports = {
            "default": c(24),
            __esModule: !0
          };
        }, function (a, b, c) {
          c(25), a.exports = c(30).Object.seal;
        }, function (a, b, c) {
          var d = c(26);
          c(27)("seal", function (a) {
            return function (b) {
              return a && d(b) ? a(b) : b;
            };
          });
        }, function (a, b) {
          a.exports = function (a) {
            return "object" == typeof a ? null !== a : "function" == typeof a;
          };
        }, function (a, b, c) {
          var d = c(28),
              e = c(30),
              f = c(33);

          a.exports = function (a, b) {
            var c = (e.Object || {})[a] || Object[a],
                g = {};
            g[a] = b(c), d(d.S + d.F * f(function () {
              c(1);
            }), "Object", g);
          };
        }, function (a, b, c) {
          var d = c(29),
              e = c(30),
              f = c(31),
              g = "prototype",
              h = function h(a, b, c) {
            var i,
                j,
                k,
                l = a & h.F,
                m = a & h.G,
                n = a & h.S,
                o = a & h.P,
                p = a & h.B,
                q = a & h.W,
                r = m ? e : e[b] || (e[b] = {}),
                s = m ? d : n ? d[b] : (d[b] || {})[g];
            m && (c = b);

            for (i in c) {
              j = !l && s && i in s, j && i in r || (k = j ? s[i] : c[i], r[i] = m && "function" != typeof s[i] ? c[i] : p && j ? f(k, d) : q && s[i] == k ? function (a) {
                var b = function b(_b2) {
                  return this instanceof a ? new a(_b2) : a(_b2);
                };

                return b[g] = a[g], b;
              }(k) : o && "function" == typeof k ? f(Function.call, k) : k, o && ((r[g] || (r[g] = {}))[i] = k));
            }
          };

          h.F = 1, h.G = 2, h.S = 4, h.P = 8, h.B = 16, h.W = 32, a.exports = h;
        }, function (a, b) {
          var c = a.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
          "number" == typeof __g && (__g = c);
        }, function (a, b) {
          var c = a.exports = {
            version: "1.2.6"
          };
          "number" == typeof __e && (__e = c);
        }, function (a, b, c) {
          var d = c(32);

          a.exports = function (a, b, c) {
            if (d(a), void 0 === b) return a;

            switch (c) {
              case 1:
                return function (c) {
                  return a.call(b, c);
                };

              case 2:
                return function (c, d) {
                  return a.call(b, c, d);
                };

              case 3:
                return function (c, d, e) {
                  return a.call(b, c, d, e);
                };
            }

            return function () {
              return a.apply(b, arguments);
            };
          };
        }, function (a, b) {
          a.exports = function (a) {
            if ("function" != typeof a) throw TypeError(a + " is not a function!");
            return a;
          };
        }, function (a, b) {
          a.exports = function (a) {
            try {
              return !!a();
            } catch (b) {
              return !0;
            }
          };
        }, function (a, b) {
          (function (c) {
            "use strict";

            b.__esModule = !0, b["default"] = function (a) {
              var b = "undefined" != typeof c ? c : window,
                  d = b.Handlebars;

              a.noConflict = function () {
                return b.Handlebars === a && (b.Handlebars = d), a;
              };
            }, a.exports = b["default"];
          }).call(b, function () {
            return this;
          }());
        }, function (a, b) {
          "use strict";

          b.__esModule = !0;
          var c = {
            helpers: {
              helperExpression: function helperExpression(a) {
                return "SubExpression" === a.type || ("MustacheStatement" === a.type || "BlockStatement" === a.type) && !!(a.params && a.params.length || a.hash);
              },
              scopedId: function scopedId(a) {
                return /^\.|this\b/.test(a.original);
              },
              simpleId: function simpleId(a) {
                return 1 === a.parts.length && !c.helpers.scopedId(a) && !a.depth;
              }
            }
          };
          b["default"] = c, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          function d(a, b) {
            if ("Program" === a.type) return a;
            h["default"].yy = n, n.locInfo = function (a) {
              return new n.SourceLocation(b && b.srcName, a);
            };
            var c = new j["default"](b);
            return c.accept(h["default"].parse(a));
          }

          var e = c(1)["default"],
              f = c(3)["default"];
          b.__esModule = !0, b.parse = d;
          var g = c(37),
              h = e(g),
              i = c(38),
              j = e(i),
              k = c(40),
              l = f(k),
              m = c(5);
          b.parser = h["default"];
          var n = {};
          m.extend(n, l);
        }, function (a, b) {
          "use strict";

          b.__esModule = !0;

          var c = function () {
            function a() {
              this.yy = {};
            }

            var b = {
              trace: function trace() {},
              yy: {},
              symbols_: {
                error: 2,
                root: 3,
                program: 4,
                EOF: 5,
                program_repetition0: 6,
                statement: 7,
                mustache: 8,
                block: 9,
                rawBlock: 10,
                partial: 11,
                partialBlock: 12,
                content: 13,
                COMMENT: 14,
                CONTENT: 15,
                openRawBlock: 16,
                rawBlock_repetition_plus0: 17,
                END_RAW_BLOCK: 18,
                OPEN_RAW_BLOCK: 19,
                helperName: 20,
                openRawBlock_repetition0: 21,
                openRawBlock_option0: 22,
                CLOSE_RAW_BLOCK: 23,
                openBlock: 24,
                block_option0: 25,
                closeBlock: 26,
                openInverse: 27,
                block_option1: 28,
                OPEN_BLOCK: 29,
                openBlock_repetition0: 30,
                openBlock_option0: 31,
                openBlock_option1: 32,
                CLOSE: 33,
                OPEN_INVERSE: 34,
                openInverse_repetition0: 35,
                openInverse_option0: 36,
                openInverse_option1: 37,
                openInverseChain: 38,
                OPEN_INVERSE_CHAIN: 39,
                openInverseChain_repetition0: 40,
                openInverseChain_option0: 41,
                openInverseChain_option1: 42,
                inverseAndProgram: 43,
                INVERSE: 44,
                inverseChain: 45,
                inverseChain_option0: 46,
                OPEN_ENDBLOCK: 47,
                OPEN: 48,
                mustache_repetition0: 49,
                mustache_option0: 50,
                OPEN_UNESCAPED: 51,
                mustache_repetition1: 52,
                mustache_option1: 53,
                CLOSE_UNESCAPED: 54,
                OPEN_PARTIAL: 55,
                partialName: 56,
                partial_repetition0: 57,
                partial_option0: 58,
                openPartialBlock: 59,
                OPEN_PARTIAL_BLOCK: 60,
                openPartialBlock_repetition0: 61,
                openPartialBlock_option0: 62,
                param: 63,
                sexpr: 64,
                OPEN_SEXPR: 65,
                sexpr_repetition0: 66,
                sexpr_option0: 67,
                CLOSE_SEXPR: 68,
                hash: 69,
                hash_repetition_plus0: 70,
                hashSegment: 71,
                ID: 72,
                EQUALS: 73,
                blockParams: 74,
                OPEN_BLOCK_PARAMS: 75,
                blockParams_repetition_plus0: 76,
                CLOSE_BLOCK_PARAMS: 77,
                path: 78,
                dataName: 79,
                STRING: 80,
                NUMBER: 81,
                BOOLEAN: 82,
                UNDEFINED: 83,
                NULL: 84,
                DATA: 85,
                pathSegments: 86,
                SEP: 87,
                $accept: 0,
                $end: 1
              },
              terminals_: {
                2: "error",
                5: "EOF",
                14: "COMMENT",
                15: "CONTENT",
                18: "END_RAW_BLOCK",
                19: "OPEN_RAW_BLOCK",
                23: "CLOSE_RAW_BLOCK",
                29: "OPEN_BLOCK",
                33: "CLOSE",
                34: "OPEN_INVERSE",
                39: "OPEN_INVERSE_CHAIN",
                44: "INVERSE",
                47: "OPEN_ENDBLOCK",
                48: "OPEN",
                51: "OPEN_UNESCAPED",
                54: "CLOSE_UNESCAPED",
                55: "OPEN_PARTIAL",
                60: "OPEN_PARTIAL_BLOCK",
                65: "OPEN_SEXPR",
                68: "CLOSE_SEXPR",
                72: "ID",
                73: "EQUALS",
                75: "OPEN_BLOCK_PARAMS",
                77: "CLOSE_BLOCK_PARAMS",
                80: "STRING",
                81: "NUMBER",
                82: "BOOLEAN",
                83: "UNDEFINED",
                84: "NULL",
                85: "DATA",
                87: "SEP"
              },
              productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 1], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
              performAction: function performAction(a, b, c, d, e, f, g) {
                var h = f.length - 1;

                switch (e) {
                  case 1:
                    return f[h - 1];

                  case 2:
                    this.$ = d.prepareProgram(f[h]);
                    break;

                  case 3:
                    this.$ = f[h];
                    break;

                  case 4:
                    this.$ = f[h];
                    break;

                  case 5:
                    this.$ = f[h];
                    break;

                  case 6:
                    this.$ = f[h];
                    break;

                  case 7:
                    this.$ = f[h];
                    break;

                  case 8:
                    this.$ = f[h];
                    break;

                  case 9:
                    this.$ = {
                      type: "CommentStatement",
                      value: d.stripComment(f[h]),
                      strip: d.stripFlags(f[h], f[h]),
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 10:
                    this.$ = {
                      type: "ContentStatement",
                      original: f[h],
                      value: f[h],
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 11:
                    this.$ = d.prepareRawBlock(f[h - 2], f[h - 1], f[h], this._$);
                    break;

                  case 12:
                    this.$ = {
                      path: f[h - 3],
                      params: f[h - 2],
                      hash: f[h - 1]
                    };
                    break;

                  case 13:
                    this.$ = d.prepareBlock(f[h - 3], f[h - 2], f[h - 1], f[h], !1, this._$);
                    break;

                  case 14:
                    this.$ = d.prepareBlock(f[h - 3], f[h - 2], f[h - 1], f[h], !0, this._$);
                    break;

                  case 15:
                    this.$ = {
                      open: f[h - 5],
                      path: f[h - 4],
                      params: f[h - 3],
                      hash: f[h - 2],
                      blockParams: f[h - 1],
                      strip: d.stripFlags(f[h - 5], f[h])
                    };
                    break;

                  case 16:
                    this.$ = {
                      path: f[h - 4],
                      params: f[h - 3],
                      hash: f[h - 2],
                      blockParams: f[h - 1],
                      strip: d.stripFlags(f[h - 5], f[h])
                    };
                    break;

                  case 17:
                    this.$ = {
                      path: f[h - 4],
                      params: f[h - 3],
                      hash: f[h - 2],
                      blockParams: f[h - 1],
                      strip: d.stripFlags(f[h - 5], f[h])
                    };
                    break;

                  case 18:
                    this.$ = {
                      strip: d.stripFlags(f[h - 1], f[h - 1]),
                      program: f[h]
                    };
                    break;

                  case 19:
                    var i = d.prepareBlock(f[h - 2], f[h - 1], f[h], f[h], !1, this._$),
                        j = d.prepareProgram([i], f[h - 1].loc);
                    j.chained = !0, this.$ = {
                      strip: f[h - 2].strip,
                      program: j,
                      chain: !0
                    };
                    break;

                  case 20:
                    this.$ = f[h];
                    break;

                  case 21:
                    this.$ = {
                      path: f[h - 1],
                      strip: d.stripFlags(f[h - 2], f[h])
                    };
                    break;

                  case 22:
                    this.$ = d.prepareMustache(f[h - 3], f[h - 2], f[h - 1], f[h - 4], d.stripFlags(f[h - 4], f[h]), this._$);
                    break;

                  case 23:
                    this.$ = d.prepareMustache(f[h - 3], f[h - 2], f[h - 1], f[h - 4], d.stripFlags(f[h - 4], f[h]), this._$);
                    break;

                  case 24:
                    this.$ = {
                      type: "PartialStatement",
                      name: f[h - 3],
                      params: f[h - 2],
                      hash: f[h - 1],
                      indent: "",
                      strip: d.stripFlags(f[h - 4], f[h]),
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 25:
                    this.$ = d.preparePartialBlock(f[h - 2], f[h - 1], f[h], this._$);
                    break;

                  case 26:
                    this.$ = {
                      path: f[h - 3],
                      params: f[h - 2],
                      hash: f[h - 1],
                      strip: d.stripFlags(f[h - 4], f[h])
                    };
                    break;

                  case 27:
                    this.$ = f[h];
                    break;

                  case 28:
                    this.$ = f[h];
                    break;

                  case 29:
                    this.$ = {
                      type: "SubExpression",
                      path: f[h - 3],
                      params: f[h - 2],
                      hash: f[h - 1],
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 30:
                    this.$ = {
                      type: "Hash",
                      pairs: f[h],
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 31:
                    this.$ = {
                      type: "HashPair",
                      key: d.id(f[h - 2]),
                      value: f[h],
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 32:
                    this.$ = d.id(f[h - 1]);
                    break;

                  case 33:
                    this.$ = f[h];
                    break;

                  case 34:
                    this.$ = f[h];
                    break;

                  case 35:
                    this.$ = {
                      type: "StringLiteral",
                      value: f[h],
                      original: f[h],
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 36:
                    this.$ = {
                      type: "NumberLiteral",
                      value: Number(f[h]),
                      original: Number(f[h]),
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 37:
                    this.$ = {
                      type: "BooleanLiteral",
                      value: "true" === f[h],
                      original: "true" === f[h],
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 38:
                    this.$ = {
                      type: "UndefinedLiteral",
                      original: void 0,
                      value: void 0,
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 39:
                    this.$ = {
                      type: "NullLiteral",
                      original: null,
                      value: null,
                      loc: d.locInfo(this._$)
                    };
                    break;

                  case 40:
                    this.$ = f[h];
                    break;

                  case 41:
                    this.$ = f[h];
                    break;

                  case 42:
                    this.$ = d.preparePath(!0, f[h], this._$);
                    break;

                  case 43:
                    this.$ = d.preparePath(!1, f[h], this._$);
                    break;

                  case 44:
                    f[h - 2].push({
                      part: d.id(f[h]),
                      original: f[h],
                      separator: f[h - 1]
                    }), this.$ = f[h - 2];
                    break;

                  case 45:
                    this.$ = [{
                      part: d.id(f[h]),
                      original: f[h]
                    }];
                    break;

                  case 46:
                    this.$ = [];
                    break;

                  case 47:
                    f[h - 1].push(f[h]);
                    break;

                  case 48:
                    this.$ = [f[h]];
                    break;

                  case 49:
                    f[h - 1].push(f[h]);
                    break;

                  case 50:
                    this.$ = [];
                    break;

                  case 51:
                    f[h - 1].push(f[h]);
                    break;

                  case 58:
                    this.$ = [];
                    break;

                  case 59:
                    f[h - 1].push(f[h]);
                    break;

                  case 64:
                    this.$ = [];
                    break;

                  case 65:
                    f[h - 1].push(f[h]);
                    break;

                  case 70:
                    this.$ = [];
                    break;

                  case 71:
                    f[h - 1].push(f[h]);
                    break;

                  case 78:
                    this.$ = [];
                    break;

                  case 79:
                    f[h - 1].push(f[h]);
                    break;

                  case 82:
                    this.$ = [];
                    break;

                  case 83:
                    f[h - 1].push(f[h]);
                    break;

                  case 86:
                    this.$ = [];
                    break;

                  case 87:
                    f[h - 1].push(f[h]);
                    break;

                  case 90:
                    this.$ = [];
                    break;

                  case 91:
                    f[h - 1].push(f[h]);
                    break;

                  case 94:
                    this.$ = [];
                    break;

                  case 95:
                    f[h - 1].push(f[h]);
                    break;

                  case 98:
                    this.$ = [f[h]];
                    break;

                  case 99:
                    f[h - 1].push(f[h]);
                    break;

                  case 100:
                    this.$ = [f[h]];
                    break;

                  case 101:
                    f[h - 1].push(f[h]);
                }
              },
              table: [{
                3: 1,
                4: 2,
                5: [2, 46],
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                1: [3]
              }, {
                5: [1, 4]
              }, {
                5: [2, 2],
                7: 5,
                8: 6,
                9: 7,
                10: 8,
                11: 9,
                12: 10,
                13: 11,
                14: [1, 12],
                15: [1, 20],
                16: 17,
                19: [1, 23],
                24: 15,
                27: 16,
                29: [1, 21],
                34: [1, 22],
                39: [2, 2],
                44: [2, 2],
                47: [2, 2],
                48: [1, 13],
                51: [1, 14],
                55: [1, 18],
                59: 19,
                60: [1, 24]
              }, {
                1: [2, 1]
              }, {
                5: [2, 47],
                14: [2, 47],
                15: [2, 47],
                19: [2, 47],
                29: [2, 47],
                34: [2, 47],
                39: [2, 47],
                44: [2, 47],
                47: [2, 47],
                48: [2, 47],
                51: [2, 47],
                55: [2, 47],
                60: [2, 47]
              }, {
                5: [2, 3],
                14: [2, 3],
                15: [2, 3],
                19: [2, 3],
                29: [2, 3],
                34: [2, 3],
                39: [2, 3],
                44: [2, 3],
                47: [2, 3],
                48: [2, 3],
                51: [2, 3],
                55: [2, 3],
                60: [2, 3]
              }, {
                5: [2, 4],
                14: [2, 4],
                15: [2, 4],
                19: [2, 4],
                29: [2, 4],
                34: [2, 4],
                39: [2, 4],
                44: [2, 4],
                47: [2, 4],
                48: [2, 4],
                51: [2, 4],
                55: [2, 4],
                60: [2, 4]
              }, {
                5: [2, 5],
                14: [2, 5],
                15: [2, 5],
                19: [2, 5],
                29: [2, 5],
                34: [2, 5],
                39: [2, 5],
                44: [2, 5],
                47: [2, 5],
                48: [2, 5],
                51: [2, 5],
                55: [2, 5],
                60: [2, 5]
              }, {
                5: [2, 6],
                14: [2, 6],
                15: [2, 6],
                19: [2, 6],
                29: [2, 6],
                34: [2, 6],
                39: [2, 6],
                44: [2, 6],
                47: [2, 6],
                48: [2, 6],
                51: [2, 6],
                55: [2, 6],
                60: [2, 6]
              }, {
                5: [2, 7],
                14: [2, 7],
                15: [2, 7],
                19: [2, 7],
                29: [2, 7],
                34: [2, 7],
                39: [2, 7],
                44: [2, 7],
                47: [2, 7],
                48: [2, 7],
                51: [2, 7],
                55: [2, 7],
                60: [2, 7]
              }, {
                5: [2, 8],
                14: [2, 8],
                15: [2, 8],
                19: [2, 8],
                29: [2, 8],
                34: [2, 8],
                39: [2, 8],
                44: [2, 8],
                47: [2, 8],
                48: [2, 8],
                51: [2, 8],
                55: [2, 8],
                60: [2, 8]
              }, {
                5: [2, 9],
                14: [2, 9],
                15: [2, 9],
                19: [2, 9],
                29: [2, 9],
                34: [2, 9],
                39: [2, 9],
                44: [2, 9],
                47: [2, 9],
                48: [2, 9],
                51: [2, 9],
                55: [2, 9],
                60: [2, 9]
              }, {
                20: 25,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 36,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                4: 37,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                4: 38,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                13: 40,
                15: [1, 20],
                17: 39
              }, {
                20: 42,
                56: 41,
                64: 43,
                65: [1, 44],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                4: 45,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                5: [2, 10],
                14: [2, 10],
                15: [2, 10],
                18: [2, 10],
                19: [2, 10],
                29: [2, 10],
                34: [2, 10],
                39: [2, 10],
                44: [2, 10],
                47: [2, 10],
                48: [2, 10],
                51: [2, 10],
                55: [2, 10],
                60: [2, 10]
              }, {
                20: 46,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 47,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 48,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 42,
                56: 49,
                64: 43,
                65: [1, 44],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                33: [2, 78],
                49: 50,
                65: [2, 78],
                72: [2, 78],
                80: [2, 78],
                81: [2, 78],
                82: [2, 78],
                83: [2, 78],
                84: [2, 78],
                85: [2, 78]
              }, {
                23: [2, 33],
                33: [2, 33],
                54: [2, 33],
                65: [2, 33],
                68: [2, 33],
                72: [2, 33],
                75: [2, 33],
                80: [2, 33],
                81: [2, 33],
                82: [2, 33],
                83: [2, 33],
                84: [2, 33],
                85: [2, 33]
              }, {
                23: [2, 34],
                33: [2, 34],
                54: [2, 34],
                65: [2, 34],
                68: [2, 34],
                72: [2, 34],
                75: [2, 34],
                80: [2, 34],
                81: [2, 34],
                82: [2, 34],
                83: [2, 34],
                84: [2, 34],
                85: [2, 34]
              }, {
                23: [2, 35],
                33: [2, 35],
                54: [2, 35],
                65: [2, 35],
                68: [2, 35],
                72: [2, 35],
                75: [2, 35],
                80: [2, 35],
                81: [2, 35],
                82: [2, 35],
                83: [2, 35],
                84: [2, 35],
                85: [2, 35]
              }, {
                23: [2, 36],
                33: [2, 36],
                54: [2, 36],
                65: [2, 36],
                68: [2, 36],
                72: [2, 36],
                75: [2, 36],
                80: [2, 36],
                81: [2, 36],
                82: [2, 36],
                83: [2, 36],
                84: [2, 36],
                85: [2, 36]
              }, {
                23: [2, 37],
                33: [2, 37],
                54: [2, 37],
                65: [2, 37],
                68: [2, 37],
                72: [2, 37],
                75: [2, 37],
                80: [2, 37],
                81: [2, 37],
                82: [2, 37],
                83: [2, 37],
                84: [2, 37],
                85: [2, 37]
              }, {
                23: [2, 38],
                33: [2, 38],
                54: [2, 38],
                65: [2, 38],
                68: [2, 38],
                72: [2, 38],
                75: [2, 38],
                80: [2, 38],
                81: [2, 38],
                82: [2, 38],
                83: [2, 38],
                84: [2, 38],
                85: [2, 38]
              }, {
                23: [2, 39],
                33: [2, 39],
                54: [2, 39],
                65: [2, 39],
                68: [2, 39],
                72: [2, 39],
                75: [2, 39],
                80: [2, 39],
                81: [2, 39],
                82: [2, 39],
                83: [2, 39],
                84: [2, 39],
                85: [2, 39]
              }, {
                23: [2, 43],
                33: [2, 43],
                54: [2, 43],
                65: [2, 43],
                68: [2, 43],
                72: [2, 43],
                75: [2, 43],
                80: [2, 43],
                81: [2, 43],
                82: [2, 43],
                83: [2, 43],
                84: [2, 43],
                85: [2, 43],
                87: [1, 51]
              }, {
                72: [1, 35],
                86: 52
              }, {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45]
              }, {
                52: 53,
                54: [2, 82],
                65: [2, 82],
                72: [2, 82],
                80: [2, 82],
                81: [2, 82],
                82: [2, 82],
                83: [2, 82],
                84: [2, 82],
                85: [2, 82]
              }, {
                25: 54,
                38: 56,
                39: [1, 58],
                43: 57,
                44: [1, 59],
                45: 55,
                47: [2, 54]
              }, {
                28: 60,
                43: 61,
                44: [1, 59],
                47: [2, 56]
              }, {
                13: 63,
                15: [1, 20],
                18: [1, 62]
              }, {
                15: [2, 48],
                18: [2, 48]
              }, {
                33: [2, 86],
                57: 64,
                65: [2, 86],
                72: [2, 86],
                80: [2, 86],
                81: [2, 86],
                82: [2, 86],
                83: [2, 86],
                84: [2, 86],
                85: [2, 86]
              }, {
                33: [2, 40],
                65: [2, 40],
                72: [2, 40],
                80: [2, 40],
                81: [2, 40],
                82: [2, 40],
                83: [2, 40],
                84: [2, 40],
                85: [2, 40]
              }, {
                33: [2, 41],
                65: [2, 41],
                72: [2, 41],
                80: [2, 41],
                81: [2, 41],
                82: [2, 41],
                83: [2, 41],
                84: [2, 41],
                85: [2, 41]
              }, {
                20: 65,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                26: 66,
                47: [1, 67]
              }, {
                30: 68,
                33: [2, 58],
                65: [2, 58],
                72: [2, 58],
                75: [2, 58],
                80: [2, 58],
                81: [2, 58],
                82: [2, 58],
                83: [2, 58],
                84: [2, 58],
                85: [2, 58]
              }, {
                33: [2, 64],
                35: 69,
                65: [2, 64],
                72: [2, 64],
                75: [2, 64],
                80: [2, 64],
                81: [2, 64],
                82: [2, 64],
                83: [2, 64],
                84: [2, 64],
                85: [2, 64]
              }, {
                21: 70,
                23: [2, 50],
                65: [2, 50],
                72: [2, 50],
                80: [2, 50],
                81: [2, 50],
                82: [2, 50],
                83: [2, 50],
                84: [2, 50],
                85: [2, 50]
              }, {
                33: [2, 90],
                61: 71,
                65: [2, 90],
                72: [2, 90],
                80: [2, 90],
                81: [2, 90],
                82: [2, 90],
                83: [2, 90],
                84: [2, 90],
                85: [2, 90]
              }, {
                20: 75,
                33: [2, 80],
                50: 72,
                63: 73,
                64: 76,
                65: [1, 44],
                69: 74,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                72: [1, 80]
              }, {
                23: [2, 42],
                33: [2, 42],
                54: [2, 42],
                65: [2, 42],
                68: [2, 42],
                72: [2, 42],
                75: [2, 42],
                80: [2, 42],
                81: [2, 42],
                82: [2, 42],
                83: [2, 42],
                84: [2, 42],
                85: [2, 42],
                87: [1, 51]
              }, {
                20: 75,
                53: 81,
                54: [2, 84],
                63: 82,
                64: 76,
                65: [1, 44],
                69: 83,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                26: 84,
                47: [1, 67]
              }, {
                47: [2, 55]
              }, {
                4: 85,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                47: [2, 20]
              }, {
                20: 86,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                4: 87,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46]
              }, {
                26: 88,
                47: [1, 67]
              }, {
                47: [2, 57]
              }, {
                5: [2, 11],
                14: [2, 11],
                15: [2, 11],
                19: [2, 11],
                29: [2, 11],
                34: [2, 11],
                39: [2, 11],
                44: [2, 11],
                47: [2, 11],
                48: [2, 11],
                51: [2, 11],
                55: [2, 11],
                60: [2, 11]
              }, {
                15: [2, 49],
                18: [2, 49]
              }, {
                20: 75,
                33: [2, 88],
                58: 89,
                63: 90,
                64: 76,
                65: [1, 44],
                69: 91,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                65: [2, 94],
                66: 92,
                68: [2, 94],
                72: [2, 94],
                80: [2, 94],
                81: [2, 94],
                82: [2, 94],
                83: [2, 94],
                84: [2, 94],
                85: [2, 94]
              }, {
                5: [2, 25],
                14: [2, 25],
                15: [2, 25],
                19: [2, 25],
                29: [2, 25],
                34: [2, 25],
                39: [2, 25],
                44: [2, 25],
                47: [2, 25],
                48: [2, 25],
                51: [2, 25],
                55: [2, 25],
                60: [2, 25]
              }, {
                20: 93,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 75,
                31: 94,
                33: [2, 60],
                63: 95,
                64: 76,
                65: [1, 44],
                69: 96,
                70: 77,
                71: 78,
                72: [1, 79],
                75: [2, 60],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 75,
                33: [2, 66],
                36: 97,
                63: 98,
                64: 76,
                65: [1, 44],
                69: 99,
                70: 77,
                71: 78,
                72: [1, 79],
                75: [2, 66],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 75,
                22: 100,
                23: [2, 52],
                63: 101,
                64: 76,
                65: [1, 44],
                69: 102,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                20: 75,
                33: [2, 92],
                62: 103,
                63: 104,
                64: 76,
                65: [1, 44],
                69: 105,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                33: [1, 106]
              }, {
                33: [2, 79],
                65: [2, 79],
                72: [2, 79],
                80: [2, 79],
                81: [2, 79],
                82: [2, 79],
                83: [2, 79],
                84: [2, 79],
                85: [2, 79]
              }, {
                33: [2, 81]
              }, {
                23: [2, 27],
                33: [2, 27],
                54: [2, 27],
                65: [2, 27],
                68: [2, 27],
                72: [2, 27],
                75: [2, 27],
                80: [2, 27],
                81: [2, 27],
                82: [2, 27],
                83: [2, 27],
                84: [2, 27],
                85: [2, 27]
              }, {
                23: [2, 28],
                33: [2, 28],
                54: [2, 28],
                65: [2, 28],
                68: [2, 28],
                72: [2, 28],
                75: [2, 28],
                80: [2, 28],
                81: [2, 28],
                82: [2, 28],
                83: [2, 28],
                84: [2, 28],
                85: [2, 28]
              }, {
                23: [2, 30],
                33: [2, 30],
                54: [2, 30],
                68: [2, 30],
                71: 107,
                72: [1, 108],
                75: [2, 30]
              }, {
                23: [2, 98],
                33: [2, 98],
                54: [2, 98],
                68: [2, 98],
                72: [2, 98],
                75: [2, 98]
              }, {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                73: [1, 109],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45]
              }, {
                23: [2, 44],
                33: [2, 44],
                54: [2, 44],
                65: [2, 44],
                68: [2, 44],
                72: [2, 44],
                75: [2, 44],
                80: [2, 44],
                81: [2, 44],
                82: [2, 44],
                83: [2, 44],
                84: [2, 44],
                85: [2, 44],
                87: [2, 44]
              }, {
                54: [1, 110]
              }, {
                54: [2, 83],
                65: [2, 83],
                72: [2, 83],
                80: [2, 83],
                81: [2, 83],
                82: [2, 83],
                83: [2, 83],
                84: [2, 83],
                85: [2, 83]
              }, {
                54: [2, 85]
              }, {
                5: [2, 13],
                14: [2, 13],
                15: [2, 13],
                19: [2, 13],
                29: [2, 13],
                34: [2, 13],
                39: [2, 13],
                44: [2, 13],
                47: [2, 13],
                48: [2, 13],
                51: [2, 13],
                55: [2, 13],
                60: [2, 13]
              }, {
                38: 56,
                39: [1, 58],
                43: 57,
                44: [1, 59],
                45: 112,
                46: 111,
                47: [2, 76]
              }, {
                33: [2, 70],
                40: 113,
                65: [2, 70],
                72: [2, 70],
                75: [2, 70],
                80: [2, 70],
                81: [2, 70],
                82: [2, 70],
                83: [2, 70],
                84: [2, 70],
                85: [2, 70]
              }, {
                47: [2, 18]
              }, {
                5: [2, 14],
                14: [2, 14],
                15: [2, 14],
                19: [2, 14],
                29: [2, 14],
                34: [2, 14],
                39: [2, 14],
                44: [2, 14],
                47: [2, 14],
                48: [2, 14],
                51: [2, 14],
                55: [2, 14],
                60: [2, 14]
              }, {
                33: [1, 114]
              }, {
                33: [2, 87],
                65: [2, 87],
                72: [2, 87],
                80: [2, 87],
                81: [2, 87],
                82: [2, 87],
                83: [2, 87],
                84: [2, 87],
                85: [2, 87]
              }, {
                33: [2, 89]
              }, {
                20: 75,
                63: 116,
                64: 76,
                65: [1, 44],
                67: 115,
                68: [2, 96],
                69: 117,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                33: [1, 118]
              }, {
                32: 119,
                33: [2, 62],
                74: 120,
                75: [1, 121]
              }, {
                33: [2, 59],
                65: [2, 59],
                72: [2, 59],
                75: [2, 59],
                80: [2, 59],
                81: [2, 59],
                82: [2, 59],
                83: [2, 59],
                84: [2, 59],
                85: [2, 59]
              }, {
                33: [2, 61],
                75: [2, 61]
              }, {
                33: [2, 68],
                37: 122,
                74: 123,
                75: [1, 121]
              }, {
                33: [2, 65],
                65: [2, 65],
                72: [2, 65],
                75: [2, 65],
                80: [2, 65],
                81: [2, 65],
                82: [2, 65],
                83: [2, 65],
                84: [2, 65],
                85: [2, 65]
              }, {
                33: [2, 67],
                75: [2, 67]
              }, {
                23: [1, 124]
              }, {
                23: [2, 51],
                65: [2, 51],
                72: [2, 51],
                80: [2, 51],
                81: [2, 51],
                82: [2, 51],
                83: [2, 51],
                84: [2, 51],
                85: [2, 51]
              }, {
                23: [2, 53]
              }, {
                33: [1, 125]
              }, {
                33: [2, 91],
                65: [2, 91],
                72: [2, 91],
                80: [2, 91],
                81: [2, 91],
                82: [2, 91],
                83: [2, 91],
                84: [2, 91],
                85: [2, 91]
              }, {
                33: [2, 93]
              }, {
                5: [2, 22],
                14: [2, 22],
                15: [2, 22],
                19: [2, 22],
                29: [2, 22],
                34: [2, 22],
                39: [2, 22],
                44: [2, 22],
                47: [2, 22],
                48: [2, 22],
                51: [2, 22],
                55: [2, 22],
                60: [2, 22]
              }, {
                23: [2, 99],
                33: [2, 99],
                54: [2, 99],
                68: [2, 99],
                72: [2, 99],
                75: [2, 99]
              }, {
                73: [1, 109]
              }, {
                20: 75,
                63: 126,
                64: 76,
                65: [1, 44],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                5: [2, 23],
                14: [2, 23],
                15: [2, 23],
                19: [2, 23],
                29: [2, 23],
                34: [2, 23],
                39: [2, 23],
                44: [2, 23],
                47: [2, 23],
                48: [2, 23],
                51: [2, 23],
                55: [2, 23],
                60: [2, 23]
              }, {
                47: [2, 19]
              }, {
                47: [2, 77]
              }, {
                20: 75,
                33: [2, 72],
                41: 127,
                63: 128,
                64: 76,
                65: [1, 44],
                69: 129,
                70: 77,
                71: 78,
                72: [1, 79],
                75: [2, 72],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33
              }, {
                5: [2, 24],
                14: [2, 24],
                15: [2, 24],
                19: [2, 24],
                29: [2, 24],
                34: [2, 24],
                39: [2, 24],
                44: [2, 24],
                47: [2, 24],
                48: [2, 24],
                51: [2, 24],
                55: [2, 24],
                60: [2, 24]
              }, {
                68: [1, 130]
              }, {
                65: [2, 95],
                68: [2, 95],
                72: [2, 95],
                80: [2, 95],
                81: [2, 95],
                82: [2, 95],
                83: [2, 95],
                84: [2, 95],
                85: [2, 95]
              }, {
                68: [2, 97]
              }, {
                5: [2, 21],
                14: [2, 21],
                15: [2, 21],
                19: [2, 21],
                29: [2, 21],
                34: [2, 21],
                39: [2, 21],
                44: [2, 21],
                47: [2, 21],
                48: [2, 21],
                51: [2, 21],
                55: [2, 21],
                60: [2, 21]
              }, {
                33: [1, 131]
              }, {
                33: [2, 63]
              }, {
                72: [1, 133],
                76: 132
              }, {
                33: [1, 134]
              }, {
                33: [2, 69]
              }, {
                15: [2, 12]
              }, {
                14: [2, 26],
                15: [2, 26],
                19: [2, 26],
                29: [2, 26],
                34: [2, 26],
                47: [2, 26],
                48: [2, 26],
                51: [2, 26],
                55: [2, 26],
                60: [2, 26]
              }, {
                23: [2, 31],
                33: [2, 31],
                54: [2, 31],
                68: [2, 31],
                72: [2, 31],
                75: [2, 31]
              }, {
                33: [2, 74],
                42: 135,
                74: 136,
                75: [1, 121]
              }, {
                33: [2, 71],
                65: [2, 71],
                72: [2, 71],
                75: [2, 71],
                80: [2, 71],
                81: [2, 71],
                82: [2, 71],
                83: [2, 71],
                84: [2, 71],
                85: [2, 71]
              }, {
                33: [2, 73],
                75: [2, 73]
              }, {
                23: [2, 29],
                33: [2, 29],
                54: [2, 29],
                65: [2, 29],
                68: [2, 29],
                72: [2, 29],
                75: [2, 29],
                80: [2, 29],
                81: [2, 29],
                82: [2, 29],
                83: [2, 29],
                84: [2, 29],
                85: [2, 29]
              }, {
                14: [2, 15],
                15: [2, 15],
                19: [2, 15],
                29: [2, 15],
                34: [2, 15],
                39: [2, 15],
                44: [2, 15],
                47: [2, 15],
                48: [2, 15],
                51: [2, 15],
                55: [2, 15],
                60: [2, 15]
              }, {
                72: [1, 138],
                77: [1, 137]
              }, {
                72: [2, 100],
                77: [2, 100]
              }, {
                14: [2, 16],
                15: [2, 16],
                19: [2, 16],
                29: [2, 16],
                34: [2, 16],
                44: [2, 16],
                47: [2, 16],
                48: [2, 16],
                51: [2, 16],
                55: [2, 16],
                60: [2, 16]
              }, {
                33: [1, 139]
              }, {
                33: [2, 75]
              }, {
                33: [2, 32]
              }, {
                72: [2, 101],
                77: [2, 101]
              }, {
                14: [2, 17],
                15: [2, 17],
                19: [2, 17],
                29: [2, 17],
                34: [2, 17],
                39: [2, 17],
                44: [2, 17],
                47: [2, 17],
                48: [2, 17],
                51: [2, 17],
                55: [2, 17],
                60: [2, 17]
              }],
              defaultActions: {
                4: [2, 1],
                55: [2, 55],
                57: [2, 20],
                61: [2, 57],
                74: [2, 81],
                83: [2, 85],
                87: [2, 18],
                91: [2, 89],
                102: [2, 53],
                105: [2, 93],
                111: [2, 19],
                112: [2, 77],
                117: [2, 97],
                120: [2, 63],
                123: [2, 69],
                124: [2, 12],
                136: [2, 75],
                137: [2, 32]
              },
              parseError: function parseError(a, b) {
                throw new Error(a);
              },
              parse: function parse(a) {
                function b() {
                  var a;
                  return a = c.lexer.lex() || 1, "number" != typeof a && (a = c.symbols_[a] || a), a;
                }

                var c = this,
                    d = [0],
                    e = [null],
                    f = [],
                    g = this.table,
                    h = "",
                    i = 0,
                    j = 0,
                    k = 0;
                this.lexer.setInput(a), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, "undefined" == typeof this.lexer.yylloc && (this.lexer.yylloc = {});
                var l = this.lexer.yylloc;
                f.push(l);
                var m = this.lexer.options && this.lexer.options.ranges;
                "function" == typeof this.yy.parseError && (this.parseError = this.yy.parseError);

                for (var n, o, p, q, r, s, t, u, v, w = {};;) {
                  if (p = d[d.length - 1], this.defaultActions[p] ? q = this.defaultActions[p] : (null !== n && "undefined" != typeof n || (n = b()), q = g[p] && g[p][n]), "undefined" == typeof q || !q.length || !q[0]) {
                    var x = "";

                    if (!k) {
                      v = [];

                      for (s in g[p]) {
                        this.terminals_[s] && s > 2 && v.push("'" + this.terminals_[s] + "'");
                      }

                      x = this.lexer.showPosition ? "Parse error on line " + (i + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + v.join(", ") + ", got '" + (this.terminals_[n] || n) + "'" : "Parse error on line " + (i + 1) + ": Unexpected " + (1 == n ? "end of input" : "'" + (this.terminals_[n] || n) + "'"), this.parseError(x, {
                        text: this.lexer.match,
                        token: this.terminals_[n] || n,
                        line: this.lexer.yylineno,
                        loc: l,
                        expected: v
                      });
                    }
                  }

                  if (q[0] instanceof Array && q.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + p + ", token: " + n);

                  switch (q[0]) {
                    case 1:
                      d.push(n), e.push(this.lexer.yytext), f.push(this.lexer.yylloc), d.push(q[1]), n = null, o ? (n = o, o = null) : (j = this.lexer.yyleng, h = this.lexer.yytext, i = this.lexer.yylineno, l = this.lexer.yylloc, k > 0 && k--);
                      break;

                    case 2:
                      if (t = this.productions_[q[1]][1], w.$ = e[e.length - t], w._$ = {
                        first_line: f[f.length - (t || 1)].first_line,
                        last_line: f[f.length - 1].last_line,
                        first_column: f[f.length - (t || 1)].first_column,
                        last_column: f[f.length - 1].last_column
                      }, m && (w._$.range = [f[f.length - (t || 1)].range[0], f[f.length - 1].range[1]]), r = this.performAction.call(w, h, j, i, this.yy, q[1], e, f), "undefined" != typeof r) return r;
                      t && (d = d.slice(0, -1 * t * 2), e = e.slice(0, -1 * t), f = f.slice(0, -1 * t)), d.push(this.productions_[q[1]][0]), e.push(w.$), f.push(w._$), u = g[d[d.length - 2]][d[d.length - 1]], d.push(u);
                      break;

                    case 3:
                      return !0;
                  }
                }

                return !0;
              }
            },
                c = function () {
              var a = {
                EOF: 1,
                parseError: function parseError(a, b) {
                  if (!this.yy.parser) throw new Error(a);
                  this.yy.parser.parseError(a, b);
                },
                setInput: function setInput(a) {
                  return this._input = a, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                  }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
                },
                input: function input() {
                  var a = this._input[0];
                  this.yytext += a, this.yyleng++, this.offset++, this.match += a, this.matched += a;
                  var b = a.match(/(?:\r\n?|\n).*/g);
                  return b ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), a;
                },
                unput: function unput(a) {
                  var b = a.length,
                      c = a.split(/(?:\r\n?|\n)/g);
                  this._input = a + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - b - 1), this.offset -= b;
                  var d = this.match.split(/(?:\r\n?|\n)/g);
                  this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), c.length - 1 && (this.yylineno -= c.length - 1);
                  var e = this.yylloc.range;
                  return this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: c ? (c.length === d.length ? this.yylloc.first_column : 0) + d[d.length - c.length].length - c[0].length : this.yylloc.first_column - b
                  }, this.options.ranges && (this.yylloc.range = [e[0], e[0] + this.yyleng - b]), this;
                },
                more: function more() {
                  return this._more = !0, this;
                },
                less: function less(a) {
                  this.unput(this.match.slice(a));
                },
                pastInput: function pastInput() {
                  var a = this.matched.substr(0, this.matched.length - this.match.length);
                  return (a.length > 20 ? "..." : "") + a.substr(-20).replace(/\n/g, "");
                },
                upcomingInput: function upcomingInput() {
                  var a = this.match;
                  return a.length < 20 && (a += this._input.substr(0, 20 - a.length)), (a.substr(0, 20) + (a.length > 20 ? "..." : "")).replace(/\n/g, "");
                },
                showPosition: function showPosition() {
                  var a = this.pastInput(),
                      b = new Array(a.length + 1).join("-");
                  return a + this.upcomingInput() + "\n" + b + "^";
                },
                next: function next() {
                  if (this.done) return this.EOF;
                  this._input || (this.done = !0);
                  var a, b, c, d, e;
                  this._more || (this.yytext = "", this.match = "");

                  for (var f = this._currentRules(), g = 0; g < f.length && (c = this._input.match(this.rules[f[g]]), !c || b && !(c[0].length > b[0].length) || (b = c, d = g, this.options.flex)); g++) {
                    ;
                  }

                  return b ? (e = b[0].match(/(?:\r\n?|\n).*/g), e && (this.yylineno += e.length), this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: e ? e[e.length - 1].length - e[e.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + b[0].length
                  }, this.yytext += b[0], this.match += b[0], this.matches = b, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._input = this._input.slice(b[0].length), this.matched += b[0], a = this.performAction.call(this, this.yy, this, f[d], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), a ? a : void 0) : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                  });
                },
                lex: function lex() {
                  var a = this.next();
                  return "undefined" != typeof a ? a : this.lex();
                },
                begin: function begin(a) {
                  this.conditionStack.push(a);
                },
                popState: function popState() {
                  return this.conditionStack.pop();
                },
                _currentRules: function _currentRules() {
                  return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                },
                topState: function topState() {
                  return this.conditionStack[this.conditionStack.length - 2];
                },
                pushState: function pushState(a) {
                  this.begin(a);
                }
              };
              return a.options = {}, a.performAction = function (a, b, c, d) {
                function e(a, c) {
                  return b.yytext = b.yytext.substring(a, b.yyleng - c + a);
                }

                switch (c) {
                  case 0:
                    if ("\\\\" === b.yytext.slice(-2) ? (e(0, 1), this.begin("mu")) : "\\" === b.yytext.slice(-1) ? (e(0, 1), this.begin("emu")) : this.begin("mu"), b.yytext) return 15;
                    break;

                  case 1:
                    return 15;

                  case 2:
                    return this.popState(), 15;

                  case 3:
                    return this.begin("raw"), 15;

                  case 4:
                    return this.popState(), "raw" === this.conditionStack[this.conditionStack.length - 1] ? 15 : (e(5, 9), "END_RAW_BLOCK");

                  case 5:
                    return 15;

                  case 6:
                    return this.popState(), 14;

                  case 7:
                    return 65;

                  case 8:
                    return 68;

                  case 9:
                    return 19;

                  case 10:
                    return this.popState(), this.begin("raw"), 23;

                  case 11:
                    return 55;

                  case 12:
                    return 60;

                  case 13:
                    return 29;

                  case 14:
                    return 47;

                  case 15:
                    return this.popState(), 44;

                  case 16:
                    return this.popState(), 44;

                  case 17:
                    return 34;

                  case 18:
                    return 39;

                  case 19:
                    return 51;

                  case 20:
                    return 48;

                  case 21:
                    this.unput(b.yytext), this.popState(), this.begin("com");
                    break;

                  case 22:
                    return this.popState(), 14;

                  case 23:
                    return 48;

                  case 24:
                    return 73;

                  case 25:
                    return 72;

                  case 26:
                    return 72;

                  case 27:
                    return 87;

                  case 28:
                    break;

                  case 29:
                    return this.popState(), 54;

                  case 30:
                    return this.popState(), 33;

                  case 31:
                    return b.yytext = e(1, 2).replace(/\\"/g, '"'), 80;

                  case 32:
                    return b.yytext = e(1, 2).replace(/\\'/g, "'"), 80;

                  case 33:
                    return 85;

                  case 34:
                    return 82;

                  case 35:
                    return 82;

                  case 36:
                    return 83;

                  case 37:
                    return 84;

                  case 38:
                    return 81;

                  case 39:
                    return 75;

                  case 40:
                    return 77;

                  case 41:
                    return 72;

                  case 42:
                    return b.yytext = b.yytext.replace(/\\([\\\]])/g, "$1"), 72;

                  case 43:
                    return "INVALID";

                  case 44:
                    return 5;
                }
              }, a.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]*?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/], a.conditions = {
                mu: {
                  rules: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44],
                  inclusive: !1
                },
                emu: {
                  rules: [2],
                  inclusive: !1
                },
                com: {
                  rules: [6],
                  inclusive: !1
                },
                raw: {
                  rules: [3, 4, 5],
                  inclusive: !1
                },
                INITIAL: {
                  rules: [0, 1, 44],
                  inclusive: !0
                }
              }, a;
            }();

            return b.lexer = c, a.prototype = b, b.Parser = a, new a();
          }();

          b["default"] = c, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          function d() {
            var a = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
            this.options = a;
          }

          function e(a, b, c) {
            void 0 === b && (b = a.length);
            var d = a[b - 1],
                e = a[b - 2];
            return d ? "ContentStatement" === d.type ? (e || !c ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(d.original) : void 0 : c;
          }

          function f(a, b, c) {
            void 0 === b && (b = -1);
            var d = a[b + 1],
                e = a[b + 2];
            return d ? "ContentStatement" === d.type ? (e || !c ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(d.original) : void 0 : c;
          }

          function g(a, b, c) {
            var d = a[null == b ? 0 : b + 1];

            if (d && "ContentStatement" === d.type && (c || !d.rightStripped)) {
              var e = d.value;
              d.value = d.value.replace(c ? /^\s+/ : /^[ \t]*\r?\n?/, ""), d.rightStripped = d.value !== e;
            }
          }

          function h(a, b, c) {
            var d = a[null == b ? a.length - 1 : b - 1];

            if (d && "ContentStatement" === d.type && (c || !d.leftStripped)) {
              var e = d.value;
              return d.value = d.value.replace(c ? /\s+$/ : /[ \t]+$/, ""), d.leftStripped = d.value !== e, d.leftStripped;
            }
          }

          var i = c(1)["default"];
          b.__esModule = !0;
          var j = c(39),
              k = i(j);
          d.prototype = new k["default"](), d.prototype.Program = function (a) {
            var b = !this.options.ignoreStandalone,
                c = !this.isRootSeen;
            this.isRootSeen = !0;

            for (var d = a.body, i = 0, j = d.length; i < j; i++) {
              var k = d[i],
                  l = this.accept(k);

              if (l) {
                var m = e(d, i, c),
                    n = f(d, i, c),
                    o = l.openStandalone && m,
                    p = l.closeStandalone && n,
                    q = l.inlineStandalone && m && n;
                l.close && g(d, i, !0), l.open && h(d, i, !0), b && q && (g(d, i), h(d, i) && "PartialStatement" === k.type && (k.indent = /([ \t]+$)/.exec(d[i - 1].original)[1])), b && o && (g((k.program || k.inverse).body), h(d, i)), b && p && (g(d, i), h((k.inverse || k.program).body));
              }
            }

            return a;
          }, d.prototype.BlockStatement = d.prototype.DecoratorBlock = d.prototype.PartialBlockStatement = function (a) {
            this.accept(a.program), this.accept(a.inverse);
            var b = a.program || a.inverse,
                c = a.program && a.inverse,
                d = c,
                i = c;
            if (c && c.chained) for (d = c.body[0].program; i.chained;) {
              i = i.body[i.body.length - 1].program;
            }
            var j = {
              open: a.openStrip.open,
              close: a.closeStrip.close,
              openStandalone: f(b.body),
              closeStandalone: e((d || b).body)
            };

            if (a.openStrip.close && g(b.body, null, !0), c) {
              var k = a.inverseStrip;
              k.open && h(b.body, null, !0), k.close && g(d.body, null, !0), a.closeStrip.open && h(i.body, null, !0), !this.options.ignoreStandalone && e(b.body) && f(d.body) && (h(b.body), g(d.body));
            } else a.closeStrip.open && h(b.body, null, !0);

            return j;
          }, d.prototype.Decorator = d.prototype.MustacheStatement = function (a) {
            return a.strip;
          }, d.prototype.PartialStatement = d.prototype.CommentStatement = function (a) {
            var b = a.strip || {};
            return {
              inlineStandalone: !0,
              open: b.open,
              close: b.close
            };
          }, b["default"] = d, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          function d() {
            this.parents = [];
          }

          function e(a) {
            this.acceptRequired(a, "path"), this.acceptArray(a.params), this.acceptKey(a, "hash");
          }

          function f(a) {
            e.call(this, a), this.acceptKey(a, "program"), this.acceptKey(a, "inverse");
          }

          function g(a) {
            this.acceptRequired(a, "name"), this.acceptArray(a.params), this.acceptKey(a, "hash");
          }

          var h = c(1)["default"];
          b.__esModule = !0;
          var i = c(6),
              j = h(i);
          d.prototype = {
            constructor: d,
            mutating: !1,
            acceptKey: function acceptKey(a, b) {
              var c = this.accept(a[b]);

              if (this.mutating) {
                if (c && !d.prototype[c.type]) throw new j["default"]('Unexpected node type "' + c.type + '" found when accepting ' + b + " on " + a.type);
                a[b] = c;
              }
            },
            acceptRequired: function acceptRequired(a, b) {
              if (this.acceptKey(a, b), !a[b]) throw new j["default"](a.type + " requires " + b);
            },
            acceptArray: function acceptArray(a) {
              for (var b = 0, c = a.length; b < c; b++) {
                this.acceptKey(a, b), a[b] || (a.splice(b, 1), b--, c--);
              }
            },
            accept: function accept(a) {
              if (a) {
                if (!this[a.type]) throw new j["default"]("Unknown type: " + a.type, a);
                this.current && this.parents.unshift(this.current), this.current = a;
                var b = this[a.type](a);
                return this.current = this.parents.shift(), !this.mutating || b ? b : b !== !1 ? a : void 0;
              }
            },
            Program: function Program(a) {
              this.acceptArray(a.body);
            },
            MustacheStatement: e,
            Decorator: e,
            BlockStatement: f,
            DecoratorBlock: f,
            PartialStatement: g,
            PartialBlockStatement: function PartialBlockStatement(a) {
              g.call(this, a), this.acceptKey(a, "program");
            },
            ContentStatement: function ContentStatement() {},
            CommentStatement: function CommentStatement() {},
            SubExpression: e,
            PathExpression: function PathExpression() {},
            StringLiteral: function StringLiteral() {},
            NumberLiteral: function NumberLiteral() {},
            BooleanLiteral: function BooleanLiteral() {},
            UndefinedLiteral: function UndefinedLiteral() {},
            NullLiteral: function NullLiteral() {},
            Hash: function Hash(a) {
              this.acceptArray(a.pairs);
            },
            HashPair: function HashPair(a) {
              this.acceptRequired(a, "value");
            }
          }, b["default"] = d, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          function d(a, b) {
            if (b = b.path ? b.path.original : b, a.path.original !== b) {
              var c = {
                loc: a.path.loc
              };
              throw new q["default"](a.path.original + " doesn't match " + b, c);
            }
          }

          function e(a, b) {
            this.source = a, this.start = {
              line: b.first_line,
              column: b.first_column
            }, this.end = {
              line: b.last_line,
              column: b.last_column
            };
          }

          function f(a) {
            return /^\[.*\]$/.test(a) ? a.substring(1, a.length - 1) : a;
          }

          function g(a, b) {
            return {
              open: "~" === a.charAt(2),
              close: "~" === b.charAt(b.length - 3)
            };
          }

          function h(a) {
            return a.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
          }

          function i(a, b, c) {
            c = this.locInfo(c);

            for (var d = a ? "@" : "", e = [], f = 0, g = 0, h = b.length; g < h; g++) {
              var i = b[g].part,
                  j = b[g].original !== i;
              if (d += (b[g].separator || "") + i, j || ".." !== i && "." !== i && "this" !== i) e.push(i);else {
                if (e.length > 0) throw new q["default"]("Invalid path: " + d, {
                  loc: c
                });
                ".." === i && f++;
              }
            }

            return {
              type: "PathExpression",
              data: a,
              depth: f,
              parts: e,
              original: d,
              loc: c
            };
          }

          function j(a, b, c, d, e, f) {
            var g = d.charAt(3) || d.charAt(2),
                h = "{" !== g && "&" !== g,
                i = /\*/.test(d);
            return {
              type: i ? "Decorator" : "MustacheStatement",
              path: a,
              params: b,
              hash: c,
              escaped: h,
              strip: e,
              loc: this.locInfo(f)
            };
          }

          function k(a, b, c, e) {
            d(a, c), e = this.locInfo(e);
            var f = {
              type: "Program",
              body: b,
              strip: {},
              loc: e
            };
            return {
              type: "BlockStatement",
              path: a.path,
              params: a.params,
              hash: a.hash,
              program: f,
              openStrip: {},
              inverseStrip: {},
              closeStrip: {},
              loc: e
            };
          }

          function l(a, b, c, e, f, g) {
            e && e.path && d(a, e);
            var h = /\*/.test(a.open);
            b.blockParams = a.blockParams;
            var i = void 0,
                j = void 0;

            if (c) {
              if (h) throw new q["default"]("Unexpected inverse block on decorator", c);
              c.chain && (c.program.body[0].closeStrip = e.strip), j = c.strip, i = c.program;
            }

            return f && (f = i, i = b, b = f), {
              type: h ? "DecoratorBlock" : "BlockStatement",
              path: a.path,
              params: a.params,
              hash: a.hash,
              program: b,
              inverse: i,
              openStrip: a.strip,
              inverseStrip: j,
              closeStrip: e && e.strip,
              loc: this.locInfo(g)
            };
          }

          function m(a, b) {
            if (!b && a.length) {
              var c = a[0].loc,
                  d = a[a.length - 1].loc;
              c && d && (b = {
                source: c.source,
                start: {
                  line: c.start.line,
                  column: c.start.column
                },
                end: {
                  line: d.end.line,
                  column: d.end.column
                }
              });
            }

            return {
              type: "Program",
              body: a,
              strip: {},
              loc: b
            };
          }

          function n(a, b, c, e) {
            return d(a, c), {
              type: "PartialBlockStatement",
              name: a.path,
              params: a.params,
              hash: a.hash,
              program: b,
              openStrip: a.strip,
              closeStrip: c && c.strip,
              loc: this.locInfo(e)
            };
          }

          var o = c(1)["default"];
          b.__esModule = !0, b.SourceLocation = e, b.id = f, b.stripFlags = g, b.stripComment = h, b.preparePath = i, b.prepareMustache = j, b.prepareRawBlock = k, b.prepareBlock = l, b.prepareProgram = m, b.preparePartialBlock = n;
          var p = c(6),
              q = o(p);
        }, function (a, b, c) {
          "use strict";

          function d() {}

          function e(a, b, c) {
            if (null == a || "string" != typeof a && "Program" !== a.type) throw new k["default"]("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + a);
            b = b || {}, "data" in b || (b.data = !0), b.compat && (b.useDepths = !0);
            var d = c.parse(a, b),
                e = new c.Compiler().compile(d, b);
            return new c.JavaScriptCompiler().compile(e, b);
          }

          function f(a, b, c) {
            function d() {
              var d = c.parse(a, b),
                  e = new c.Compiler().compile(d, b),
                  f = new c.JavaScriptCompiler().compile(e, b, void 0, !0);
              return c.template(f);
            }

            function e(a, b) {
              return f || (f = d()), f.call(this, a, b);
            }

            if (void 0 === b && (b = {}), null == a || "string" != typeof a && "Program" !== a.type) throw new k["default"]("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + a);
            b = l.extend({}, b), "data" in b || (b.data = !0), b.compat && (b.useDepths = !0);
            var f = void 0;
            return e._setup = function (a) {
              return f || (f = d()), f._setup(a);
            }, e._child = function (a, b, c, e) {
              return f || (f = d()), f._child(a, b, c, e);
            }, e;
          }

          function g(a, b) {
            if (a === b) return !0;

            if (l.isArray(a) && l.isArray(b) && a.length === b.length) {
              for (var c = 0; c < a.length; c++) {
                if (!g(a[c], b[c])) return !1;
              }

              return !0;
            }
          }

          function h(a) {
            if (!a.path.parts) {
              var b = a.path;
              a.path = {
                type: "PathExpression",
                data: !1,
                depth: 0,
                parts: [b.original + ""],
                original: b.original + "",
                loc: b.loc
              };
            }
          }

          var i = c(1)["default"];
          b.__esModule = !0, b.Compiler = d, b.precompile = e, b.compile = f;
          var j = c(6),
              k = i(j),
              l = c(5),
              m = c(35),
              n = i(m),
              o = [].slice;
          d.prototype = {
            compiler: d,
            equals: function equals(a) {
              var b = this.opcodes.length;
              if (a.opcodes.length !== b) return !1;

              for (var c = 0; c < b; c++) {
                var d = this.opcodes[c],
                    e = a.opcodes[c];
                if (d.opcode !== e.opcode || !g(d.args, e.args)) return !1;
              }

              b = this.children.length;

              for (var c = 0; c < b; c++) {
                if (!this.children[c].equals(a.children[c])) return !1;
              }

              return !0;
            },
            guid: 0,
            compile: function compile(a, b) {
              this.sourceNode = [], this.opcodes = [], this.children = [], this.options = b, this.stringParams = b.stringParams, this.trackIds = b.trackIds, b.blockParams = b.blockParams || [];
              var c = b.knownHelpers;
              if (b.knownHelpers = {
                helperMissing: !0,
                blockHelperMissing: !0,
                each: !0,
                "if": !0,
                unless: !0,
                "with": !0,
                log: !0,
                lookup: !0
              }, c) for (var d in c) {
                this.options.knownHelpers[d] = c[d];
              }
              return this.accept(a);
            },
            compileProgram: function compileProgram(a) {
              var b = new this.compiler(),
                  c = b.compile(a, this.options),
                  d = this.guid++;
              return this.usePartial = this.usePartial || c.usePartial, this.children[d] = c, this.useDepths = this.useDepths || c.useDepths, d;
            },
            accept: function accept(a) {
              if (!this[a.type]) throw new k["default"]("Unknown type: " + a.type, a);
              this.sourceNode.unshift(a);
              var b = this[a.type](a);
              return this.sourceNode.shift(), b;
            },
            Program: function Program(a) {
              this.options.blockParams.unshift(a.blockParams);

              for (var b = a.body, c = b.length, d = 0; d < c; d++) {
                this.accept(b[d]);
              }

              return this.options.blockParams.shift(), this.isSimple = 1 === c, this.blockParams = a.blockParams ? a.blockParams.length : 0, this;
            },
            BlockStatement: function BlockStatement(a) {
              h(a);
              var b = a.program,
                  c = a.inverse;
              b = b && this.compileProgram(b), c = c && this.compileProgram(c);
              var d = this.classifySexpr(a);
              "helper" === d ? this.helperSexpr(a, b, c) : "simple" === d ? (this.simpleSexpr(a), this.opcode("pushProgram", b), this.opcode("pushProgram", c), this.opcode("emptyHash"), this.opcode("blockValue", a.path.original)) : (this.ambiguousSexpr(a, b, c), this.opcode("pushProgram", b), this.opcode("pushProgram", c), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")), this.opcode("append");
            },
            DecoratorBlock: function DecoratorBlock(a) {
              var b = a.program && this.compileProgram(a.program),
                  c = this.setupFullMustacheParams(a, b, void 0),
                  d = a.path;
              this.useDecorators = !0, this.opcode("registerDecorator", c.length, d.original);
            },
            PartialStatement: function PartialStatement(a) {
              this.usePartial = !0;
              var b = a.program;
              b && (b = this.compileProgram(a.program));
              var c = a.params;
              if (c.length > 1) throw new k["default"]("Unsupported number of partial arguments: " + c.length, a);
              c.length || (this.options.explicitPartialContext ? this.opcode("pushLiteral", "undefined") : c.push({
                type: "PathExpression",
                parts: [],
                depth: 0
              }));
              var d = a.name.original,
                  e = "SubExpression" === a.name.type;
              e && this.accept(a.name), this.setupFullMustacheParams(a, b, void 0, !0);
              var f = a.indent || "";
              this.options.preventIndent && f && (this.opcode("appendContent", f), f = ""), this.opcode("invokePartial", e, d, f), this.opcode("append");
            },
            PartialBlockStatement: function PartialBlockStatement(a) {
              this.PartialStatement(a);
            },
            MustacheStatement: function MustacheStatement(a) {
              this.SubExpression(a), a.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append");
            },
            Decorator: function Decorator(a) {
              this.DecoratorBlock(a);
            },
            ContentStatement: function ContentStatement(a) {
              a.value && this.opcode("appendContent", a.value);
            },
            CommentStatement: function CommentStatement() {},
            SubExpression: function SubExpression(a) {
              h(a);
              var b = this.classifySexpr(a);
              "simple" === b ? this.simpleSexpr(a) : "helper" === b ? this.helperSexpr(a) : this.ambiguousSexpr(a);
            },
            ambiguousSexpr: function ambiguousSexpr(a, b, c) {
              var d = a.path,
                  e = d.parts[0],
                  f = null != b || null != c;
              this.opcode("getContext", d.depth), this.opcode("pushProgram", b), this.opcode("pushProgram", c), d.strict = !0, this.accept(d), this.opcode("invokeAmbiguous", e, f);
            },
            simpleSexpr: function simpleSexpr(a) {
              var b = a.path;
              b.strict = !0, this.accept(b), this.opcode("resolvePossibleLambda");
            },
            helperSexpr: function helperSexpr(a, b, c) {
              var d = this.setupFullMustacheParams(a, b, c),
                  e = a.path,
                  f = e.parts[0];
              if (this.options.knownHelpers[f]) this.opcode("invokeKnownHelper", d.length, f);else {
                if (this.options.knownHelpersOnly) throw new k["default"]("You specified knownHelpersOnly, but used the unknown helper " + f, a);
                e.strict = !0, e.falsy = !0, this.accept(e), this.opcode("invokeHelper", d.length, e.original, n["default"].helpers.simpleId(e));
              }
            },
            PathExpression: function PathExpression(a) {
              this.addDepth(a.depth), this.opcode("getContext", a.depth);
              var b = a.parts[0],
                  c = n["default"].helpers.scopedId(a),
                  d = !a.depth && !c && this.blockParamIndex(b);
              d ? this.opcode("lookupBlockParam", d, a.parts) : b ? a.data ? (this.options.data = !0, this.opcode("lookupData", a.depth, a.parts, a.strict)) : this.opcode("lookupOnContext", a.parts, a.falsy, a.strict, c) : this.opcode("pushContext");
            },
            StringLiteral: function StringLiteral(a) {
              this.opcode("pushString", a.value);
            },
            NumberLiteral: function NumberLiteral(a) {
              this.opcode("pushLiteral", a.value);
            },
            BooleanLiteral: function BooleanLiteral(a) {
              this.opcode("pushLiteral", a.value);
            },
            UndefinedLiteral: function UndefinedLiteral() {
              this.opcode("pushLiteral", "undefined");
            },
            NullLiteral: function NullLiteral() {
              this.opcode("pushLiteral", "null");
            },
            Hash: function Hash(a) {
              var b = a.pairs,
                  c = 0,
                  d = b.length;

              for (this.opcode("pushHash"); c < d; c++) {
                this.pushParam(b[c].value);
              }

              for (; c--;) {
                this.opcode("assignToHash", b[c].key);
              }

              this.opcode("popHash");
            },
            opcode: function opcode(a) {
              this.opcodes.push({
                opcode: a,
                args: o.call(arguments, 1),
                loc: this.sourceNode[0].loc
              });
            },
            addDepth: function addDepth(a) {
              a && (this.useDepths = !0);
            },
            classifySexpr: function classifySexpr(a) {
              var b = n["default"].helpers.simpleId(a.path),
                  c = b && !!this.blockParamIndex(a.path.parts[0]),
                  d = !c && n["default"].helpers.helperExpression(a),
                  e = !c && (d || b);

              if (e && !d) {
                var f = a.path.parts[0],
                    g = this.options;
                g.knownHelpers[f] ? d = !0 : g.knownHelpersOnly && (e = !1);
              }

              return d ? "helper" : e ? "ambiguous" : "simple";
            },
            pushParams: function pushParams(a) {
              for (var b = 0, c = a.length; b < c; b++) {
                this.pushParam(a[b]);
              }
            },
            pushParam: function pushParam(a) {
              var b = null != a.value ? a.value : a.original || "";
              if (this.stringParams) b.replace && (b = b.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")), a.depth && this.addDepth(a.depth), this.opcode("getContext", a.depth || 0), this.opcode("pushStringParam", b, a.type), "SubExpression" === a.type && this.accept(a);else {
                if (this.trackIds) {
                  var c = void 0;

                  if (!a.parts || n["default"].helpers.scopedId(a) || a.depth || (c = this.blockParamIndex(a.parts[0])), c) {
                    var d = a.parts.slice(1).join(".");
                    this.opcode("pushId", "BlockParam", c, d);
                  } else b = a.original || b, b.replace && (b = b.replace(/^this(?:\.|$)/, "").replace(/^\.\//, "").replace(/^\.$/, "")), this.opcode("pushId", a.type, b);
                }

                this.accept(a);
              }
            },
            setupFullMustacheParams: function setupFullMustacheParams(a, b, c, d) {
              var e = a.params;
              return this.pushParams(e), this.opcode("pushProgram", b), this.opcode("pushProgram", c), a.hash ? this.accept(a.hash) : this.opcode("emptyHash", d), e;
            },
            blockParamIndex: function blockParamIndex(a) {
              for (var b = 0, c = this.options.blockParams.length; b < c; b++) {
                var d = this.options.blockParams[b],
                    e = d && l.indexOf(d, a);
                if (d && e >= 0) return [b, e];
              }
            }
          };
        }, function (a, b, c) {
          "use strict";

          function d(a) {
            this.value = a;
          }

          function e() {}

          function f(a, b, c, d) {
            var e = b.popStack(),
                f = 0,
                g = c.length;

            for (a && g--; f < g; f++) {
              e = b.nameLookup(e, c[f], d);
            }

            return a ? [b.aliasable("container.strict"), "(", e, ", ", b.quotedString(c[f]), ")"] : e;
          }

          var g = c(1)["default"];
          b.__esModule = !0;
          var h = c(4),
              i = c(6),
              j = g(i),
              k = c(5),
              l = c(43),
              m = g(l);
          e.prototype = {
            nameLookup: function nameLookup(a, b) {
              return "constructor" === b ? ["(", a, ".propertyIsEnumerable('constructor') ? ", a, ".constructor : undefined", ")"] : e.isValidJavaScriptVariableName(b) ? [a, ".", b] : [a, "[", JSON.stringify(b), "]"];
            },
            depthedLookup: function depthedLookup(a) {
              return [this.aliasable("container.lookup"), '(depths, "', a, '")'];
            },
            compilerInfo: function compilerInfo() {
              var a = h.COMPILER_REVISION,
                  b = h.REVISION_CHANGES[a];
              return [a, b];
            },
            appendToBuffer: function appendToBuffer(a, b, c) {
              return k.isArray(a) || (a = [a]), a = this.source.wrap(a, b), this.environment.isSimple ? ["return ", a, ";"] : c ? ["buffer += ", a, ";"] : (a.appendToBuffer = !0, a);
            },
            initializeBuffer: function initializeBuffer() {
              return this.quotedString("");
            },
            compile: function compile(a, b, c, d) {
              this.environment = a, this.options = b, this.stringParams = this.options.stringParams, this.trackIds = this.options.trackIds, this.precompile = !d, this.name = this.environment.name, this.isChild = !!c, this.context = c || {
                decorators: [],
                programs: [],
                environments: []
              }, this.preamble(), this.stackSlot = 0, this.stackVars = [], this.aliases = {}, this.registers = {
                list: []
              }, this.hashes = [], this.compileStack = [], this.inlineStack = [], this.blockParams = [], this.compileChildren(a, b), this.useDepths = this.useDepths || a.useDepths || a.useDecorators || this.options.compat, this.useBlockParams = this.useBlockParams || a.useBlockParams;
              var e = a.opcodes,
                  f = void 0,
                  g = void 0,
                  h = void 0,
                  i = void 0;

              for (h = 0, i = e.length; h < i; h++) {
                f = e[h], this.source.currentLocation = f.loc, g = g || f.loc, this[f.opcode].apply(this, f.args);
              }

              if (this.source.currentLocation = g, this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length) throw new j["default"]("Compile completed with content left on stack");
              this.decorators.isEmpty() ? this.decorators = void 0 : (this.useDecorators = !0, this.decorators.prepend("var decorators = container.decorators;\n"), this.decorators.push("return fn;"), d ? this.decorators = Function.apply(this, ["fn", "props", "container", "depth0", "data", "blockParams", "depths", this.decorators.merge()]) : (this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"), this.decorators.push("}\n"), this.decorators = this.decorators.merge()));
              var k = this.createFunctionContext(d);
              if (this.isChild) return k;
              var l = {
                compiler: this.compilerInfo(),
                main: k
              };
              this.decorators && (l.main_d = this.decorators, l.useDecorators = !0);
              var m = this.context,
                  n = m.programs,
                  o = m.decorators;

              for (h = 0, i = n.length; h < i; h++) {
                n[h] && (l[h] = n[h], o[h] && (l[h + "_d"] = o[h], l.useDecorators = !0));
              }

              return this.environment.usePartial && (l.usePartial = !0), this.options.data && (l.useData = !0), this.useDepths && (l.useDepths = !0), this.useBlockParams && (l.useBlockParams = !0), this.options.compat && (l.compat = !0), d ? l.compilerOptions = this.options : (l.compiler = JSON.stringify(l.compiler), this.source.currentLocation = {
                start: {
                  line: 1,
                  column: 0
                }
              }, l = this.objectLiteral(l), b.srcName ? (l = l.toStringWithSourceMap({
                file: b.destName
              }), l.map = l.map && l.map.toString()) : l = l.toString()), l;
            },
            preamble: function preamble() {
              this.lastContext = 0, this.source = new m["default"](this.options.srcName), this.decorators = new m["default"](this.options.srcName);
            },
            createFunctionContext: function createFunctionContext(a) {
              var b = "",
                  c = this.stackVars.concat(this.registers.list);
              c.length > 0 && (b += ", " + c.join(", "));
              var d = 0;

              for (var e in this.aliases) {
                var f = this.aliases[e];
                this.aliases.hasOwnProperty(e) && f.children && f.referenceCount > 1 && (b += ", alias" + ++d + "=" + e, f.children[0] = "alias" + d);
              }

              var g = ["container", "depth0", "helpers", "partials", "data"];
              (this.useBlockParams || this.useDepths) && g.push("blockParams"), this.useDepths && g.push("depths");
              var h = this.mergeSource(b);
              return a ? (g.push(h), Function.apply(this, g)) : this.source.wrap(["function(", g.join(","), ") {\n  ", h, "}"]);
            },
            mergeSource: function mergeSource(a) {
              var b = this.environment.isSimple,
                  c = !this.forceBuffer,
                  d = void 0,
                  e = void 0,
                  f = void 0,
                  g = void 0;
              return this.source.each(function (a) {
                a.appendToBuffer ? (f ? a.prepend("  + ") : f = a, g = a) : (f && (e ? f.prepend("buffer += ") : d = !0, g.add(";"), f = g = void 0), e = !0, b || (c = !1));
              }), c ? f ? (f.prepend("return "), g.add(";")) : e || this.source.push('return "";') : (a += ", buffer = " + (d ? "" : this.initializeBuffer()), f ? (f.prepend("return buffer + "), g.add(";")) : this.source.push("return buffer;")), a && this.source.prepend("var " + a.substring(2) + (d ? "" : ";\n")), this.source.merge();
            },
            blockValue: function blockValue(a) {
              var b = this.aliasable("helpers.blockHelperMissing"),
                  c = [this.contextName(0)];
              this.setupHelperArgs(a, 0, c);
              var d = this.popStack();
              c.splice(1, 0, d), this.push(this.source.functionCall(b, "call", c));
            },
            ambiguousBlockValue: function ambiguousBlockValue() {
              var a = this.aliasable("helpers.blockHelperMissing"),
                  b = [this.contextName(0)];
              this.setupHelperArgs("", 0, b, !0), this.flushInline();
              var c = this.topStack();
              b.splice(1, 0, c), this.pushSource(["if (!", this.lastHelper, ") { ", c, " = ", this.source.functionCall(a, "call", b), "}"]);
            },
            appendContent: function appendContent(a) {
              this.pendingContent ? a = this.pendingContent + a : this.pendingLocation = this.source.currentLocation, this.pendingContent = a;
            },
            append: function append() {
              if (this.isInline()) this.replaceStack(function (a) {
                return [" != null ? ", a, ' : ""'];
              }), this.pushSource(this.appendToBuffer(this.popStack()));else {
                var a = this.popStack();
                this.pushSource(["if (", a, " != null) { ", this.appendToBuffer(a, void 0, !0), " }"]), this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"]);
              }
            },
            appendEscaped: function appendEscaped() {
              this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]));
            },
            getContext: function getContext(a) {
              this.lastContext = a;
            },
            pushContext: function pushContext() {
              this.pushStackLiteral(this.contextName(this.lastContext));
            },
            lookupOnContext: function lookupOnContext(a, b, c, d) {
              var e = 0;
              d || !this.options.compat || this.lastContext ? this.pushContext() : this.push(this.depthedLookup(a[e++])), this.resolvePath("context", a, e, b, c);
            },
            lookupBlockParam: function lookupBlockParam(a, b) {
              this.useBlockParams = !0, this.push(["blockParams[", a[0], "][", a[1], "]"]), this.resolvePath("context", b, 1);
            },
            lookupData: function lookupData(a, b, c) {
              a ? this.pushStackLiteral("container.data(data, " + a + ")") : this.pushStackLiteral("data"), this.resolvePath("data", b, 0, !0, c);
            },
            resolvePath: function resolvePath(a, b, c, d, e) {
              var g = this;
              if (this.options.strict || this.options.assumeObjects) return void this.push(f(this.options.strict && e, this, b, a));

              for (var h = b.length; c < h; c++) {
                this.replaceStack(function (e) {
                  var f = g.nameLookup(e, b[c], a);
                  return d ? [" && ", f] : [" != null ? ", f, " : ", e];
                });
              }
            },
            resolvePossibleLambda: function resolvePossibleLambda() {
              this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"]);
            },
            pushStringParam: function pushStringParam(a, b) {
              this.pushContext(), this.pushString(b), "SubExpression" !== b && ("string" == typeof a ? this.pushString(a) : this.pushStackLiteral(a));
            },
            emptyHash: function emptyHash(a) {
              this.trackIds && this.push("{}"), this.stringParams && (this.push("{}"), this.push("{}")), this.pushStackLiteral(a ? "undefined" : "{}");
            },
            pushHash: function pushHash() {
              this.hash && this.hashes.push(this.hash), this.hash = {
                values: [],
                types: [],
                contexts: [],
                ids: []
              };
            },
            popHash: function popHash() {
              var a = this.hash;
              this.hash = this.hashes.pop(), this.trackIds && this.push(this.objectLiteral(a.ids)), this.stringParams && (this.push(this.objectLiteral(a.contexts)), this.push(this.objectLiteral(a.types))), this.push(this.objectLiteral(a.values));
            },
            pushString: function pushString(a) {
              this.pushStackLiteral(this.quotedString(a));
            },
            pushLiteral: function pushLiteral(a) {
              this.pushStackLiteral(a);
            },
            pushProgram: function pushProgram(a) {
              null != a ? this.pushStackLiteral(this.programExpression(a)) : this.pushStackLiteral(null);
            },
            registerDecorator: function registerDecorator(a, b) {
              var c = this.nameLookup("decorators", b, "decorator"),
                  d = this.setupHelperArgs(b, a);
              this.decorators.push(["fn = ", this.decorators.functionCall(c, "", ["fn", "props", "container", d]), " || fn;"]);
            },
            invokeHelper: function invokeHelper(a, b, c) {
              var d = this.popStack(),
                  e = this.setupHelper(a, b),
                  f = c ? [e.name, " || "] : "",
                  g = ["("].concat(f, d);
              this.options.strict || g.push(" || ", this.aliasable("helpers.helperMissing")), g.push(")"), this.push(this.source.functionCall(g, "call", e.callParams));
            },
            invokeKnownHelper: function invokeKnownHelper(a, b) {
              var c = this.setupHelper(a, b);
              this.push(this.source.functionCall(c.name, "call", c.callParams));
            },
            invokeAmbiguous: function invokeAmbiguous(a, b) {
              this.useRegister("helper");
              var c = this.popStack();
              this.emptyHash();
              var d = this.setupHelper(0, a, b),
                  e = this.lastHelper = this.nameLookup("helpers", a, "helper"),
                  f = ["(", "(helper = ", e, " || ", c, ")"];
              this.options.strict || (f[0] = "(helper = ", f.push(" != null ? helper : ", this.aliasable("helpers.helperMissing"))), this.push(["(", f, d.paramsInit ? ["),(", d.paramsInit] : [], "),", "(typeof helper === ", this.aliasable('"function"'), " ? ", this.source.functionCall("helper", "call", d.callParams), " : helper))"]);
            },
            invokePartial: function invokePartial(a, b, c) {
              var d = [],
                  e = this.setupParams(b, 1, d);
              a && (b = this.popStack(), delete e.name), c && (e.indent = JSON.stringify(c)), e.helpers = "helpers", e.partials = "partials", e.decorators = "container.decorators", a ? d.unshift(b) : d.unshift(this.nameLookup("partials", b, "partial")), this.options.compat && (e.depths = "depths"), e = this.objectLiteral(e), d.push(e), this.push(this.source.functionCall("container.invokePartial", "", d));
            },
            assignToHash: function assignToHash(a) {
              var b = this.popStack(),
                  c = void 0,
                  d = void 0,
                  e = void 0;
              this.trackIds && (e = this.popStack()), this.stringParams && (d = this.popStack(), c = this.popStack());
              var f = this.hash;
              c && (f.contexts[a] = c), d && (f.types[a] = d), e && (f.ids[a] = e), f.values[a] = b;
            },
            pushId: function pushId(a, b, c) {
              "BlockParam" === a ? this.pushStackLiteral("blockParams[" + b[0] + "].path[" + b[1] + "]" + (c ? " + " + JSON.stringify("." + c) : "")) : "PathExpression" === a ? this.pushString(b) : "SubExpression" === a ? this.pushStackLiteral("true") : this.pushStackLiteral("null");
            },
            compiler: e,
            compileChildren: function compileChildren(a, b) {
              for (var c = a.children, d = void 0, e = void 0, f = 0, g = c.length; f < g; f++) {
                d = c[f], e = new this.compiler();
                var h = this.matchExistingProgram(d);

                if (null == h) {
                  this.context.programs.push("");
                  var i = this.context.programs.length;
                  d.index = i, d.name = "program" + i, this.context.programs[i] = e.compile(d, b, this.context, !this.precompile), this.context.decorators[i] = e.decorators, this.context.environments[i] = d, this.useDepths = this.useDepths || e.useDepths, this.useBlockParams = this.useBlockParams || e.useBlockParams, d.useDepths = this.useDepths, d.useBlockParams = this.useBlockParams;
                } else d.index = h.index, d.name = "program" + h.index, this.useDepths = this.useDepths || h.useDepths, this.useBlockParams = this.useBlockParams || h.useBlockParams;
              }
            },
            matchExistingProgram: function matchExistingProgram(a) {
              for (var b = 0, c = this.context.environments.length; b < c; b++) {
                var d = this.context.environments[b];
                if (d && d.equals(a)) return d;
              }
            },
            programExpression: function programExpression(a) {
              var b = this.environment.children[a],
                  c = [b.index, "data", b.blockParams];
              return (this.useBlockParams || this.useDepths) && c.push("blockParams"), this.useDepths && c.push("depths"), "container.program(" + c.join(", ") + ")";
            },
            useRegister: function useRegister(a) {
              this.registers[a] || (this.registers[a] = !0, this.registers.list.push(a));
            },
            push: function push(a) {
              return a instanceof d || (a = this.source.wrap(a)), this.inlineStack.push(a), a;
            },
            pushStackLiteral: function pushStackLiteral(a) {
              this.push(new d(a));
            },
            pushSource: function pushSource(a) {
              this.pendingContent && (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)), this.pendingContent = void 0), a && this.source.push(a);
            },
            replaceStack: function replaceStack(a) {
              var b = ["("],
                  c = void 0,
                  e = void 0,
                  f = void 0;
              if (!this.isInline()) throw new j["default"]("replaceStack on non-inline");
              var g = this.popStack(!0);
              if (g instanceof d) c = [g.value], b = ["(", c], f = !0;else {
                e = !0;
                var h = this.incrStack();
                b = ["((", this.push(h), " = ", g, ")"], c = this.topStack();
              }
              var i = a.call(this, c);
              f || this.popStack(), e && this.stackSlot--, this.push(b.concat(i, ")"));
            },
            incrStack: function incrStack() {
              return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName();
            },
            topStackName: function topStackName() {
              return "stack" + this.stackSlot;
            },
            flushInline: function flushInline() {
              var a = this.inlineStack;
              this.inlineStack = [];

              for (var b = 0, c = a.length; b < c; b++) {
                var e = a[b];
                if (e instanceof d) this.compileStack.push(e);else {
                  var f = this.incrStack();
                  this.pushSource([f, " = ", e, ";"]), this.compileStack.push(f);
                }
              }
            },
            isInline: function isInline() {
              return this.inlineStack.length;
            },
            popStack: function popStack(a) {
              var b = this.isInline(),
                  c = (b ? this.inlineStack : this.compileStack).pop();
              if (!a && c instanceof d) return c.value;

              if (!b) {
                if (!this.stackSlot) throw new j["default"]("Invalid stack pop");
                this.stackSlot--;
              }

              return c;
            },
            topStack: function topStack() {
              var a = this.isInline() ? this.inlineStack : this.compileStack,
                  b = a[a.length - 1];
              return b instanceof d ? b.value : b;
            },
            contextName: function contextName(a) {
              return this.useDepths && a ? "depths[" + a + "]" : "depth" + a;
            },
            quotedString: function quotedString(a) {
              return this.source.quotedString(a);
            },
            objectLiteral: function objectLiteral(a) {
              return this.source.objectLiteral(a);
            },
            aliasable: function aliasable(a) {
              var b = this.aliases[a];
              return b ? (b.referenceCount++, b) : (b = this.aliases[a] = this.source.wrap(a), b.aliasable = !0, b.referenceCount = 1, b);
            },
            setupHelper: function setupHelper(a, b, c) {
              var d = [],
                  e = this.setupHelperArgs(b, a, d, c),
                  f = this.nameLookup("helpers", b, "helper"),
                  g = this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})");
              return {
                params: d,
                paramsInit: e,
                name: f,
                callParams: [g].concat(d)
              };
            },
            setupParams: function setupParams(a, b, c) {
              var d = {},
                  e = [],
                  f = [],
                  g = [],
                  h = !c,
                  i = void 0;
              h && (c = []), d.name = this.quotedString(a), d.hash = this.popStack(), this.trackIds && (d.hashIds = this.popStack()), this.stringParams && (d.hashTypes = this.popStack(), d.hashContexts = this.popStack());
              var j = this.popStack(),
                  k = this.popStack();
              (k || j) && (d.fn = k || "container.noop", d.inverse = j || "container.noop");

              for (var l = b; l--;) {
                i = this.popStack(), c[l] = i, this.trackIds && (g[l] = this.popStack()), this.stringParams && (f[l] = this.popStack(), e[l] = this.popStack());
              }

              return h && (d.args = this.source.generateArray(c)), this.trackIds && (d.ids = this.source.generateArray(g)), this.stringParams && (d.types = this.source.generateArray(f), d.contexts = this.source.generateArray(e)), this.options.data && (d.data = "data"), this.useBlockParams && (d.blockParams = "blockParams"), d;
            },
            setupHelperArgs: function setupHelperArgs(a, b, c, d) {
              var e = this.setupParams(a, b, c);
              return e = this.objectLiteral(e), d ? (this.useRegister("options"), c.push("options"), ["options=", e]) : c ? (c.push(e), "") : e;
            }
          }, function () {
            for (var a = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "), b = e.RESERVED_WORDS = {}, c = 0, d = a.length; c < d; c++) {
              b[a[c]] = !0;
            }
          }(), e.isValidJavaScriptVariableName = function (a) {
            return !e.RESERVED_WORDS[a] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(a);
          }, b["default"] = e, a.exports = b["default"];
        }, function (a, b, c) {
          "use strict";

          function d(a, b, c) {
            if (f.isArray(a)) {
              for (var d = [], e = 0, g = a.length; e < g; e++) {
                d.push(b.wrap(a[e], c));
              }

              return d;
            }

            return "boolean" == typeof a || "number" == typeof a ? a + "" : a;
          }

          function e(a) {
            this.srcFile = a, this.source = [];
          }

          b.__esModule = !0;
          var f = c(5),
              g = void 0;

          try {} catch (h) {}

          g || (g = function g(a, b, c, d) {
            this.src = "", d && this.add(d);
          }, g.prototype = {
            add: function add(a) {
              f.isArray(a) && (a = a.join("")), this.src += a;
            },
            prepend: function prepend(a) {
              f.isArray(a) && (a = a.join("")), this.src = a + this.src;
            },
            toStringWithSourceMap: function toStringWithSourceMap() {
              return {
                code: this.toString()
              };
            },
            toString: function toString() {
              return this.src;
            }
          }), e.prototype = {
            isEmpty: function isEmpty() {
              return !this.source.length;
            },
            prepend: function prepend(a, b) {
              this.source.unshift(this.wrap(a, b));
            },
            push: function push(a, b) {
              this.source.push(this.wrap(a, b));
            },
            merge: function merge() {
              var a = this.empty();
              return this.each(function (b) {
                a.add(["  ", b, "\n"]);
              }), a;
            },
            each: function each(a) {
              for (var b = 0, c = this.source.length; b < c; b++) {
                a(this.source[b]);
              }
            },
            empty: function empty() {
              var a = this.currentLocation || {
                start: {}
              };
              return new g(a.start.line, a.start.column, this.srcFile);
            },
            wrap: function wrap(a) {
              var b = arguments.length <= 1 || void 0 === arguments[1] ? this.currentLocation || {
                start: {}
              } : arguments[1];
              return a instanceof g ? a : (a = d(a, this, b), new g(b.start.line, b.start.column, this.srcFile, a));
            },
            functionCall: function functionCall(a, b, c) {
              return c = this.generateList(c), this.wrap([a, b ? "." + b + "(" : "(", c, ")"]);
            },
            quotedString: function quotedString(a) {
              return '"' + (a + "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") + '"';
            },
            objectLiteral: function objectLiteral(a) {
              var b = [];

              for (var c in a) {
                if (a.hasOwnProperty(c)) {
                  var e = d(a[c], this);
                  "undefined" !== e && b.push([this.quotedString(c), ":", e]);
                }
              }

              var f = this.generateList(b);
              return f.prepend("{"), f.add("}"), f;
            },
            generateList: function generateList(a) {
              for (var b = this.empty(), c = 0, e = a.length; c < e; c++) {
                c && b.add(","), b.add(d(a[c], this));
              }

              return b;
            },
            generateArray: function generateArray(a) {
              var b = this.generateList(a);
              return b.prepend("["), b.add("]"), b;
            }
          }, b["default"] = e, a.exports = b["default"];
        }]);
      });
      /***/
    },
    /* 385 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
        var currentListeners = [];
        var nextListeners = currentListeners;

        function ensureCanMutateNextListeners() {
          if (nextListeners === currentListeners) {
            nextListeners = currentListeners.slice();
          }
        }

        function listen(listener) {
          if (typeof listener !== 'function') {
            throw new Error('Expected listener to be a function.');
          }

          var isSubscribed = true;
          ensureCanMutateNextListeners();
          nextListeners.push(listener);
          return function () {
            if (!isSubscribed) {
              return;
            }

            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
          };
        }

        function emit() {
          currentListeners = nextListeners;
          var listeners = currentListeners;

          for (var i = 0; i < listeners.length; i++) {
            listeners[i].apply(listeners, arguments);
          }
        }

        return {
          listen: listen,
          emit: emit
        };
      };
      /***/

    },
    /* 386 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* unused harmony export encodeContent */

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return decodeContent;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return exportText;
      });

      function encodeContent(text) {
        return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join('<br />' + '\n');
      }

      function decodeContent(text) {
        return text.split('<br />' + '\n').join('\n');
      }

      function exportText(editorState) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          encode: false
        };
        var content = editorState.getCurrentContent();
        var blockMap = content.getBlockMap();
        var encode = options.encode;
        return blockMap.map(function (block) {
          var resultText = '';
          var lastPosition = 0;
          var text = block.getText();
          block.findEntityRanges(function (character) {
            return !!character.getEntity();
          }, function (start, end) {
            var key = block.getEntityAt(start);
            var entityData = content.getEntity(key).getData();
            resultText += text.slice(lastPosition, start);
            resultText += entityData && entityData['export'] ? entityData['export'](entityData) : text.slice(start, end);
            lastPosition = end;
          });
          resultText += text.slice(lastPosition);
          return encode ? encodeContent(resultText) : resultText;
        }).join(encode ? '<br />\n' : '\n');
      }
      /***/

    },
    /* 387 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (global, process) {
        var __assign = this && this.__assign || Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        function __export(m) {
          for (var p in m) {
            if (!exports.hasOwnProperty(p)) exports[p] = m[p];
          }
        }

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _global = typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : {};

        var NativeWebSocket = _global.WebSocket || _global.MozWebSocket;

        var Backoff = __webpack_require__(1182);

        var eventemitter3_1 = __webpack_require__(1181);

        var isString = __webpack_require__(1180);

        var isObject = __webpack_require__(1179);

        var printer_1 = __webpack_require__(115);

        var getOperationAST_1 = __webpack_require__(1178);

        var symbol_observable_1 = __webpack_require__(122);

        var protocol_1 = __webpack_require__(1177);

        var defaults_1 = __webpack_require__(1176);

        var message_types_1 = __webpack_require__(1175);

        __export(__webpack_require__(1174));

        var SubscriptionClient = function () {
          function SubscriptionClient(url, options, webSocketImpl) {
            var _a = options || {},
                _b = _a.connectionCallback,
                connectionCallback = _b === void 0 ? undefined : _b,
                _c = _a.connectionParams,
                connectionParams = _c === void 0 ? {} : _c,
                _d = _a.timeout,
                timeout = _d === void 0 ? defaults_1.WS_TIMEOUT : _d,
                _e = _a.reconnect,
                reconnect = _e === void 0 ? false : _e,
                _f = _a.reconnectionAttempts,
                reconnectionAttempts = _f === void 0 ? Infinity : _f,
                _g = _a.lazy,
                lazy = _g === void 0 ? false : _g;

            this.wsImpl = webSocketImpl || NativeWebSocket;

            if (!this.wsImpl) {
              throw new Error('Unable to find native implementation, or alternative implementation for WebSocket!');
            }

            this.connectionParams = connectionParams;
            this.connectionCallback = connectionCallback;
            this.url = url;
            this.operations = {};
            this.nextOperationId = 0;
            this.wsTimeout = timeout;
            this.unsentMessagesQueue = [];
            this.reconnect = reconnect;
            this.reconnecting = false;
            this.reconnectionAttempts = reconnectionAttempts;
            this.lazy = !!lazy;
            this.closedByUser = false;
            this.backoff = new Backoff({
              jitter: 0.5
            });
            this.eventEmitter = new eventemitter3_1.EventEmitter();
            this.middlewares = [];
            this.client = null;
            this.maxConnectTimeGenerator = this.createMaxConnectTimeGenerator();

            if (!this.lazy) {
              this.connect();
            }
          }

          Object.defineProperty(SubscriptionClient.prototype, "status", {
            get: function get() {
              if (this.client === null) {
                return this.wsImpl.CLOSED;
              }

              return this.client.readyState;
            },
            enumerable: true,
            configurable: true
          });

          SubscriptionClient.prototype.close = function (isForced, closedByUser) {
            if (isForced === void 0) {
              isForced = true;
            }

            if (closedByUser === void 0) {
              closedByUser = true;
            }

            if (this.client !== null) {
              this.closedByUser = closedByUser;

              if (isForced) {
                this.clearCheckConnectionInterval();
                this.clearMaxConnectTimeout();
                this.clearTryReconnectTimeout();
                this.unsubscribeAll();
                this.sendMessage(undefined, message_types_1.default.GQL_CONNECTION_TERMINATE, null);
              }

              this.client.close();
              this.client = null;
              this.eventEmitter.emit('disconnected');

              if (!isForced) {
                this.tryReconnect();
              }
            }
          };

          SubscriptionClient.prototype.request = function (request) {
            var getObserver = this.getObserver.bind(this);
            var executeOperation = this.executeOperation.bind(this);

            var _unsubscribe = this.unsubscribe.bind(this);

            var opId;
            return _a = {}, _a[symbol_observable_1.default] = function () {
              return this;
            }, _a.subscribe = function (observerOrNext, onError, onComplete) {
              var observer = getObserver(observerOrNext, onError, onComplete);
              opId = executeOperation({
                query: request.query,
                variables: request.variables,
                operationName: request.operationName
              }, function (error, result) {
                if (error === null && result === null) {
                  if (observer.complete) {
                    observer.complete();
                  }
                } else if (error) {
                  if (observer.error) {
                    observer.error(error[0]);
                  }
                } else {
                  if (observer.next) {
                    observer.next(result);
                  }
                }
              });
              return {
                unsubscribe: function unsubscribe() {
                  if (opId) {
                    _unsubscribe(opId);

                    opId = null;
                  }
                }
              };
            }, _a;

            var _a;
          };

          SubscriptionClient.prototype.query = function (options) {
            var _this = this;

            return new Promise(function (resolve, reject) {
              var handler = function handler(error, result) {
                if (result) {
                  resolve(result);
                } else {
                  reject(error);
                }
              };

              _this.executeOperation(options, handler);
            });
          };

          SubscriptionClient.prototype.subscribe = function (options, handler) {
            var legacyHandler = function legacyHandler(error, result) {
              var operationPayloadData = result && result.data || null;
              var operationPayloadErrors = result && result.errors || null;

              if (error) {
                operationPayloadErrors = error;
                operationPayloadData = null;
              }

              if (error !== null || result !== null) {
                handler(operationPayloadErrors, operationPayloadData);
              }
            };

            if (this.client === null) {
              this.connect();
            }

            if (!handler) {
              throw new Error('Must provide an handler.');
            }

            return this.executeOperation(options, legacyHandler);
          };

          SubscriptionClient.prototype.on = function (eventName, callback, context) {
            var handler = this.eventEmitter.on(eventName, callback, context);
            return function () {
              handler.off(eventName, callback, context);
            };
          };

          SubscriptionClient.prototype.onConnect = function (callback, context) {
            this.logWarningOnNonProductionEnv('This method will become deprecated in the next release. ' + 'You can use onConnecting and onConnected instead.');
            return this.onConnecting(callback, context);
          };

          SubscriptionClient.prototype.onDisconnect = function (callback, context) {
            this.logWarningOnNonProductionEnv('This method will become deprecated in the next release. ' + 'You can use onDisconnected instead.');
            return this.onDisconnected(callback, context);
          };

          SubscriptionClient.prototype.onReconnect = function (callback, context) {
            this.logWarningOnNonProductionEnv('This method will become deprecated in the next release. ' + 'You can use onReconnecting and onReconnected instead.');
            return this.onReconnecting(callback, context);
          };

          SubscriptionClient.prototype.onConnected = function (callback, context) {
            return this.on('connected', callback, context);
          };

          SubscriptionClient.prototype.onConnecting = function (callback, context) {
            return this.on('connecting', callback, context);
          };

          SubscriptionClient.prototype.onDisconnected = function (callback, context) {
            return this.on('disconnected', callback, context);
          };

          SubscriptionClient.prototype.onReconnected = function (callback, context) {
            return this.on('reconnected', callback, context);
          };

          SubscriptionClient.prototype.onReconnecting = function (callback, context) {
            return this.on('reconnecting', callback, context);
          };

          SubscriptionClient.prototype.unsubscribe = function (opId) {
            if (this.operations[opId]) {
              delete this.operations[opId];
              this.sendMessage(opId, message_types_1.default.GQL_STOP, undefined);
            }
          };

          SubscriptionClient.prototype.unsubscribeAll = function () {
            var _this = this;

            Object.keys(this.operations).forEach(function (subId) {
              _this.unsubscribe(subId);
            });
          };

          SubscriptionClient.prototype.applyMiddlewares = function (options) {
            var _this = this;

            return new Promise(function (resolve, reject) {
              var queue = function queue(funcs, scope) {
                var next = function next(error) {
                  if (error) {
                    reject(error);
                  } else {
                    if (funcs.length > 0) {
                      var f = funcs.shift();

                      if (f) {
                        f.applyMiddleware.apply(scope, [options, next]);
                      }
                    } else {
                      resolve(options);
                    }
                  }
                };

                next();
              };

              queue(_this.middlewares.slice(), _this);
            });
          };

          SubscriptionClient.prototype.use = function (middlewares) {
            var _this = this;

            middlewares.map(function (middleware) {
              if (typeof middleware.applyMiddleware === 'function') {
                _this.middlewares.push(middleware);
              } else {
                throw new Error('Middleware must implement the applyMiddleware function.');
              }
            });
            return this;
          };

          SubscriptionClient.prototype.executeOperation = function (options, handler) {
            var _this = this;

            var opId = this.generateOperationId();
            this.operations[opId] = {
              options: options,
              handler: handler
            };
            this.applyMiddlewares(options).then(function (processedOptions) {
              _this.checkOperationOptions(processedOptions, handler);

              if (_this.operations[opId]) {
                _this.operations[opId] = {
                  options: processedOptions,
                  handler: handler
                };

                _this.sendMessage(opId, message_types_1.default.GQL_START, processedOptions);
              }
            }).catch(function (error) {
              _this.unsubscribe(opId);

              handler(_this.formatErrors(error));
            });
            return opId;
          };

          SubscriptionClient.prototype.getObserver = function (observerOrNext, _error3, _complete) {
            if (typeof observerOrNext === 'function') {
              return {
                next: function next(v) {
                  return observerOrNext(v);
                },
                error: function error(e) {
                  return _error3 && _error3(e);
                },
                complete: function complete() {
                  return _complete && _complete();
                }
              };
            }

            return observerOrNext;
          };

          SubscriptionClient.prototype.createMaxConnectTimeGenerator = function () {
            var minValue = 1000;
            var maxValue = this.wsTimeout;
            return new Backoff({
              min: minValue,
              max: maxValue,
              factor: 1.2
            });
          };

          SubscriptionClient.prototype.clearCheckConnectionInterval = function () {
            if (this.checkConnectionIntervalId) {
              clearInterval(this.checkConnectionIntervalId);
              this.checkConnectionIntervalId = null;
            }
          };

          SubscriptionClient.prototype.clearMaxConnectTimeout = function () {
            if (this.maxConnectTimeoutId) {
              clearTimeout(this.maxConnectTimeoutId);
              this.maxConnectTimeoutId = null;
            }
          };

          SubscriptionClient.prototype.clearTryReconnectTimeout = function () {
            if (this.tryReconnectTimeoutId) {
              clearTimeout(this.tryReconnectTimeoutId);
              this.tryReconnectTimeoutId = null;
            }
          };

          SubscriptionClient.prototype.logWarningOnNonProductionEnv = function (warning) {
            if (process && process.env && "production" !== 'production') {
              console.warn(warning);
            }
          };

          SubscriptionClient.prototype.checkOperationOptions = function (options, handler) {
            var query = options.query,
                variables = options.variables,
                operationName = options.operationName;

            if (!query) {
              throw new Error('Must provide a query.');
            }

            if (!handler) {
              throw new Error('Must provide an handler.');
            }

            if (!isString(query) && !getOperationAST_1.getOperationAST(query, operationName) || operationName && !isString(operationName) || variables && !isObject(variables)) {
              throw new Error('Incorrect option types. query must be a string or a document,' + '`operationName` must be a string, and `variables` must be an object.');
            }
          };

          SubscriptionClient.prototype.buildMessage = function (id, type, payload) {
            var payloadToReturn = payload && payload.query ? __assign({}, payload, {
              query: typeof payload.query === 'string' ? payload.query : printer_1.print(payload.query)
            }) : payload;
            return {
              id: id,
              type: type,
              payload: payloadToReturn
            };
          };

          SubscriptionClient.prototype.formatErrors = function (errors) {
            if (Array.isArray(errors)) {
              return errors;
            }

            if (errors && errors.errors) {
              return this.formatErrors(errors.errors);
            }

            if (errors && errors.message) {
              return [errors];
            }

            return [{
              name: 'FormatedError',
              message: 'Unknown error',
              originalError: errors
            }];
          };

          SubscriptionClient.prototype.sendMessage = function (id, type, payload) {
            this.sendMessageRaw(this.buildMessage(id, type, payload));
          };

          SubscriptionClient.prototype.sendMessageRaw = function (message) {
            switch (this.status) {
              case this.wsImpl.OPEN:
                var serializedMessage = JSON.stringify(message);
                var parsedMessage = void 0;

                try {
                  parsedMessage = JSON.parse(serializedMessage);
                } catch (e) {
                  throw new Error("Message must be JSON-serializable. Got: " + message);
                }

                this.client.send(serializedMessage);
                break;

              case this.wsImpl.CONNECTING:
                this.unsentMessagesQueue.push(message);
                break;

              default:
                if (!this.reconnecting) {
                  throw new Error('A message was not sent because socket is not connected, is closing or ' + 'is already closed. Message was: ' + JSON.stringify(message));
                }

            }
          };

          SubscriptionClient.prototype.generateOperationId = function () {
            return String(++this.nextOperationId);
          };

          SubscriptionClient.prototype.tryReconnect = function () {
            var _this = this;

            if (!this.reconnect || this.backoff.attempts >= this.reconnectionAttempts) {
              return;
            }

            if (!this.reconnecting) {
              Object.keys(this.operations).forEach(function (key) {
                _this.unsentMessagesQueue.push(_this.buildMessage(key, message_types_1.default.GQL_START, _this.operations[key].options));
              });
              this.reconnecting = true;
            }

            this.clearTryReconnectTimeout();
            var delay = this.backoff.duration();
            this.tryReconnectTimeoutId = setTimeout(function () {
              _this.connect();
            }, delay);
          };

          SubscriptionClient.prototype.flushUnsentMessagesQueue = function () {
            var _this = this;

            this.unsentMessagesQueue.forEach(function (message) {
              _this.sendMessageRaw(message);
            });
            this.unsentMessagesQueue = [];
          };

          SubscriptionClient.prototype.checkConnection = function () {
            if (this.wasKeepAliveReceived) {
              this.wasKeepAliveReceived = false;
              return;
            }

            if (!this.reconnecting) {
              this.close(false, true);
            }
          };

          SubscriptionClient.prototype.checkMaxConnectTimeout = function () {
            var _this = this;

            this.clearMaxConnectTimeout();
            this.maxConnectTimeoutId = setTimeout(function () {
              if (_this.status !== _this.wsImpl.OPEN) {
                _this.close(false, true);
              }
            }, this.maxConnectTimeGenerator.duration());
          };

          SubscriptionClient.prototype.connect = function () {
            var _this = this;

            this.client = new this.wsImpl(this.url, protocol_1.GRAPHQL_WS);
            this.checkMaxConnectTimeout();

            this.client.onopen = function () {
              _this.clearMaxConnectTimeout();

              _this.closedByUser = false;

              _this.eventEmitter.emit(_this.reconnecting ? 'reconnecting' : 'connecting');

              var payload = typeof _this.connectionParams === 'function' ? _this.connectionParams() : _this.connectionParams;

              _this.sendMessage(undefined, message_types_1.default.GQL_CONNECTION_INIT, payload);

              _this.flushUnsentMessagesQueue();
            };

            this.client.onclose = function () {
              if (!_this.closedByUser) {
                _this.close(false, false);
              }
            };

            this.client.onerror = function () {};

            this.client.onmessage = function (_a) {
              var data = _a.data;

              _this.processReceivedData(data);
            };
          };

          SubscriptionClient.prototype.processReceivedData = function (receivedData) {
            var parsedMessage;
            var opId;

            try {
              parsedMessage = JSON.parse(receivedData);
              opId = parsedMessage.id;
            } catch (e) {
              throw new Error("Message must be JSON-parseable. Got: " + receivedData);
            }

            if ([message_types_1.default.GQL_DATA, message_types_1.default.GQL_COMPLETE, message_types_1.default.GQL_ERROR].indexOf(parsedMessage.type) !== -1 && !this.operations[opId]) {
              this.unsubscribe(opId);
              return;
            }

            switch (parsedMessage.type) {
              case message_types_1.default.GQL_CONNECTION_ERROR:
                if (this.connectionCallback) {
                  this.connectionCallback(parsedMessage.payload);
                }

                break;

              case message_types_1.default.GQL_CONNECTION_ACK:
                this.eventEmitter.emit(this.reconnecting ? 'reconnected' : 'connected');
                this.reconnecting = false;
                this.backoff.reset();
                this.maxConnectTimeGenerator.reset();

                if (this.connectionCallback) {
                  this.connectionCallback();
                }

                break;

              case message_types_1.default.GQL_COMPLETE:
                this.operations[opId].handler(null, null);
                delete this.operations[opId];
                break;

              case message_types_1.default.GQL_ERROR:
                this.operations[opId].handler(this.formatErrors(parsedMessage.payload), null);
                delete this.operations[opId];
                break;

              case message_types_1.default.GQL_DATA:
                var parsedPayload = !parsedMessage.payload.errors ? parsedMessage.payload : __assign({}, parsedMessage.payload, {
                  errors: this.formatErrors(parsedMessage.payload.errors)
                });
                this.operations[opId].handler(null, parsedPayload);
                break;

              case message_types_1.default.GQL_CONNECTION_KEEP_ALIVE:
                var firstKA = typeof this.wasKeepAliveReceived === 'undefined';
                this.wasKeepAliveReceived = true;

                if (firstKA) {
                  this.checkConnection();
                }

                if (this.checkConnectionIntervalId) {
                  clearInterval(this.checkConnectionIntervalId);
                  this.checkConnection();
                }

                this.checkConnectionIntervalId = setInterval(this.checkConnection.bind(this), this.wsTimeout);
                break;

              default:
                throw new Error('Invalid message type!');
            }
          };

          return SubscriptionClient;
        }();

        exports.SubscriptionClient = SubscriptionClient;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71), __webpack_require__(162));
      /***/
    },
    /* 388 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectSpread.js

      var objectSpread = __webpack_require__(13);

      var objectSpread_default =
      /*#__PURE__*/
      __webpack_require__.n(objectSpread); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(21);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/createClass.js


      var createClass = __webpack_require__(20);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // EXTERNAL MODULE: ./node_modules/lodash/get.js


      var get = __webpack_require__(10);

      var get_default =
      /*#__PURE__*/
      __webpack_require__.n(get); // EXTERNAL MODULE: ./node_modules/lodash/invert.js


      var invert = __webpack_require__(218);

      var invert_default =
      /*#__PURE__*/
      __webpack_require__.n(invert); // EXTERNAL MODULE: ./node_modules/lodash/pickBy.js


      var pickBy = __webpack_require__(295);

      var pickBy_default =
      /*#__PURE__*/
      __webpack_require__.n(pickBy); // EXTERNAL MODULE: ./src/core/utils/graphql/submission.js


      var submission = __webpack_require__(63); // CONCATENATED MODULE: ./src/core/utils/data/utils.js


      function utils_getFieldValuesAsId(client) {
        var state = client.store.getState();
        var data = client.readQuery({
          query: submission["b"
          /* readSubmissionQuery */
          ].query,
          variables: {
            branch: state.formatic.environment,
            formId: state.formatic.formId,
            initialValues: state.formatic.initialValues,
            submissionId: state.formatic.submissionId,
            channel: state.formatic.channel
          }
        }); // Return an object by field ID

        return data.Submission.fields.reduce(function (values, field) {
          values[field.id] = field.value;
          return values;
        }, {});
      } // EXTERNAL MODULE: ./src/core/utils/constants.js


      var constants = __webpack_require__(27); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js


      var taggedTemplateLiteral = __webpack_require__(78);

      var taggedTemplateLiteral_default =
      /*#__PURE__*/
      __webpack_require__.n(taggedTemplateLiteral); // EXTERNAL MODULE: ./node_modules/react-apollo/react-apollo.browser.umd.js


      var react_apollo_browser_umd = __webpack_require__(58); // CONCATENATED MODULE: ./src/core/utils/data/queries.js


      function queries_templateObject5() {
        var data = taggedTemplateLiteral_default()(["\n  query ReadSubmission(\n    $formId: Int!\n    $submissionId: String\n    $branch: String\n    $channel: String\n    $initialValues: [ValueInput]\n  ) {\n    Submission(id: $submissionId, formId: $formId, branch: $branch, channel: $channel, initialValues: $initialValues) {\n      id\n      attributes {\n        id\n        value\n        type\n      }\n    }\n  }\n"]);

        queries_templateObject5 = function _templateObject5() {
          return data;
        };

        return data;
      }

      function queries_templateObject4() {
        var data = taggedTemplateLiteral_default()(["\n  query getForm(\n    $formId: Int!\n    $branch: String = \"Live\"\n    $channel: String = \"master\"\n    $config: String = \"default\"\n  ) {\n    Form(id: $formId, branch: $branch, channel: $channel, config: $config) {\n      id\n      attributes\n    }\n  }\n"]);

        queries_templateObject4 = function _templateObject4() {
          return data;
        };

        return data;
      }

      function queries_templateObject3() {
        var data = taggedTemplateLiteral_default()(["\n  query getForm(\n    $formId: Int!\n    $branch: String = \"Live\"\n    $channel: String = \"master\"\n    $config: String = \"default\"\n  ) {\n    Form(id: $formId, branch: $branch, channel: $channel, config: $config) {\n      id\n      pages {\n        id\n        attributes\n        sections {\n          id\n        }\n      }\n    }\n  }\n\n  ", "\n"]);

        queries_templateObject3 = function _templateObject3() {
          return data;
        };

        return data;
      }

      function queries_templateObject2() {
        var data = taggedTemplateLiteral_default()(["\n  query getForm(\n    $formId: Int!\n    $branch: String = \"Live\"\n    $channel: String = \"master\"\n    $config: String = \"default\"\n  ) {\n    Form(id: $formId, branch: $branch, channel: $channel, config: $config) {\n      sections {\n        id\n        attributes\n        fields {\n          id\n        }\n      }\n    }\n  }\n\n  ", "\n"]);

        queries_templateObject2 = function _templateObject2() {
          return data;
        };

        return data;
      }

      function queries_templateObject() {
        var data = taggedTemplateLiteral_default()(["\n  query getForm(\n    $formId: Int!\n    $branch: String = \"Live\"\n    $channel: String = \"master\"\n    $config: String = \"default\"\n  ) {\n    Form(id: $formId, branch: $branch, channel: $channel, config: $config) {\n      id\n      fields {\n        id\n        renderer\n        attributes\n      }\n    }\n  }\n"]);

        queries_templateObject = function _templateObject() {
          return data;
        };

        return data;
      }

      var queries_logicFragment = "\n  fragment logicOperationDetails on Logic {\n    operation {\n      operationType\n      attributes\n    }\n    condition {\n      conditionType\n      attributes\n    }\n  }\n";
      var queries_formFieldQuery = Object(react_apollo_browser_umd["gql"])(queries_templateObject());
      var queries_formSectionQuery = Object(react_apollo_browser_umd["gql"])(queries_templateObject2(), queries_logicFragment);
      var queries_getFormPagesQuery = Object(react_apollo_browser_umd["gql"])(queries_templateObject3(), queries_logicFragment);
      var queries_formAttributesQuery = Object(react_apollo_browser_umd["gql"])(queries_templateObject4());
      var queries_submissionAttributesQuery = Object(react_apollo_browser_umd["gql"])(queries_templateObject5()); // EXTERNAL MODULE: ./src/core/utils/analytics.js + 1 modules

      var analytics = __webpack_require__(17); // EXTERNAL MODULE: ./src/core/utils/data/helpers.js


      var helpers = __webpack_require__(91); // CONCATENATED MODULE: ./src/core/utils/data/index.js

      /* unused harmony export isApiKeyValid */

      /* unused harmony export getPropsError */

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "a", function () {
        return data_Data;
      });

      var data_isApiKeyValid = function isApiKeyValid(props) {
        var isValid = true;
        get_default()(props, 'data.error.graphQLErrors', []).some(function (error) {
          var result = error.message === 'Unable to authorise request. Check public/private key';

          if (result) {
            isValid = false;
          }

          return result;
        });
        return isValid;
      };

      var data_getPropsError = function getPropsError(props) {
        var error;

        if (!data_isApiKeyValid(props)) {
          error = "The api key provided is not valid or it is not correctly associated with form id ".concat(props.formId);
        } else if (get_default()(props, 'data.error.message') === 'Network error: Failed to fetch') {
          error = "There was an error to fetch the form, please make sure the environment '".concat(props.environment, "' exists and the form id ").concat(props.formId, " was correctly published to it.");
        }

        return error;
      };
      /**
       * Class Data
       * Safely exports out helper functions to interact with the data layer under the form.
       */


      var data_Data =
      /*#__PURE__*/
      function () {
        function Data() {
          classCallCheck_default()(this, Data);
        }

        createClass_default()(Data, [{
          key: "initialise",
          value: function initialise(client, store) {
            if (this.client === undefined && this.store === undefined) {
              // initialise only once
              this.client = client;
              this.store = store;

              var _this$store$getState = this.store.getState(),
                  formatic = _this$store$getState.formatic;

              this.sendAnalytics = Object(analytics["c"
              /* analyticsCallback */
              ])({
                submissionId: formatic.submissionId,
                formId: formatic.formId,
                branch: formatic.environment,
                channel: formatic.channel
              }, formatic.emitter);
            }
          }
          /**
           * @return {String} The page ID of the current active user section.
           */

        }, {
          key: "getCurrentPageID",
          value: function getCurrentPageID() {
            var channel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.store.getState().formatic.channel;
            return get_default()(this.store.getState().formatic.currentPage, "[".concat(channel, "].pageId"));
          }
          /**
           * @return {Object} An instance of the pubsub emitter.
           */

        }, {
          key: "getEmitter",
          value: function getEmitter() {
            return this.store.getState().formatic.emitter;
          }
          /**
           * @return {String} The active session ID.
           */

        }, {
          key: "getSubmissionID",
          value: function getSubmissionID() {
            return this.store.getState().formatic.submissionId;
          }
          /**
           * @param {bool} idAsKey If true, the key of the returned object is set to the field ID. If false, set to field tag.
           * @return {Object} Object containing key value pairs of the active session field values.
           */

        }, {
          key: "getFieldValues",
          value: function getFieldValues() {
            var idAsKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (!idAsKey) {
              // Return by field tag (which already exists within the store)
              return this.store.getState().formatic.tokens.fields || {};
            }

            return utils_getFieldValuesAsId(this.client);
          }
          /**
           * @return {String} The environment the form was loaded from
           */

        }, {
          key: "getEnvironment",
          value: function getEnvironment() {
            return this.store.getState().formatic.environment;
          }
          /**
           * @param {String} id The field ID or tag whose value should be returned
           * @return {*} The field value, null if value not set
           */

        }, {
          key: "getFieldValue",
          value: function getFieldValue(id) {
            var values = utils_getFieldValuesAsId(this.client);

            if (typeof values[id] !== 'undefined') {
              // The supplied ID matched a field ID
              return values[id];
            }

            var valuesByTag = this.store.getState().formatic.tokens.fields || {};

            if (typeof valuesByTag[id] !== 'undefined') {
              // The supplied ID matched a field tag
              return valuesByTag[id];
            }

            return null;
          }
          /**
           * @param {bool} idAsKey If true, key of the object is set to the field ID, if false, set to field tag
           * @return {Object} Key value pair of current, visible field errors
           */

        }, {
          key: "getFieldErrors",
          value: function getFieldErrors() {
            var idAsKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var tags = {};

            if (!idAsKey) {
              tags = this.getFieldTags();
            }

            var fields = Object.entries(this.store.getState().formatic.visibleFields);
            return fields.reduce(function (accum, value) {
              if (typeof value[1].errorMessage === 'string' && value[1].errorMessage.length) {
                // Field has a visible error
                var error = value[1].errorMessage;
                var fieldID = value[0];

                if (idAsKey) {
                  accum[fieldID] = error;
                } else if (typeof tags[fieldID] === 'string') {
                  accum[tags[fieldID]] = error;
                }
              }

              return accum;
            }, {});
          }
          /**
           * @param {bool} idAsKey If true, key of the object is set to the field ID, if false, set to field tag
           * @return {Object} Key value object, with field tags stored against IDs
           */

        }, {
          key: "getFieldTags",
          value: function getFieldTags() {
            var idAsKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var state = this.store.getState();
            var obj = this.client.readQuery({
              query: queries_formFieldQuery,
              variables: {
                branch: state.formatic.environment,
                channel: state.formatic.channel,
                config: state.formatic.config,
                formId: state.formatic.formId,
                submissionId: state.formatic.submissionId
              }
            });
            var tags = obj.Form.fields.reduce(function (accum, field) {
              var tag = get_default()(field, 'attributes.tag', '');

              if (typeof tag === 'string' && tag.length) {
                accum[field.id] = tag;
              }

              return accum;
            }, {});
            return idAsKey ? tags : invert_default()(tags);
          }
          /**
           * @param {String} id ID or tag of field to look for errors for
           * @return {String|bool} The error as a string if found, false if not
           */

        }, {
          key: "getFieldError",
          value: function getFieldError(id) {
            // First, look for errors by ID
            var errors = this.getFieldErrors();

            if (typeof errors[id] !== 'undefined') {
              return errors[id];
            } // If not found, look for errors by tag


            var errorsByTag = invert_default()(errors);

            if (typeof errorsByTag[id] !== 'undefined') {
              return errorsByTag[id];
            }

            return false;
          }
          /**
           * @return {String} The name of the channel the user is currently on
           */

        }, {
          key: "getChannel",
          value: function getChannel() {
            return this.store.getState().formatic.channel;
          }
          /**
           * @return {Object} Key value object of form attributes
           */

        }, {
          key: "getFormAttributes",
          value: function getFormAttributes() {
            var state = this.store.getState();
            var obj = this.client.readQuery({
              query: queries_formAttributesQuery,
              variables: {
                branch: state.formatic.environment,
                channel: state.formatic.channel,
                config: state.formatic.config,
                formId: state.formatic.formId,
                submissionId: state.formatic.submissionId
              }
            });
            return obj.Form.attributes || {};
          }
          /**
           * @param {String} key Key to look up
           * @param {*} defaultValue Value to return when the attribute is not found
           */

        }, {
          key: "getFormAttribute",
          value: function getFormAttribute(key) {
            var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var attributes = this.getFormAttributes();
            return attributes[key] || defaultValue;
          }
          /**
           * @param {String} id The ID or tag of the field to select
           * @return {Object|null} The field object if found, null if not
           */

        }, {
          key: "getField",
          value: function getField(id) {
            var state = this.store.getState();
            var obj = this.client.readQuery({
              query: queries_formFieldQuery,
              variables: {
                branch: state.formatic.environment,
                channel: state.formatic.channel,
                config: state.formatic.config,
                formId: state.formatic.formId,
                submissionId: state.formatic.submissionId
              }
            });
            var tags = this.getFieldTags();
            var field = obj.Form.fields.find(function (f) {
              return id === f.id || id === tags[f.id];
            });

            if (typeof field !== 'undefined') {
              return pickBy_default()(field, function (value, key) {
                return ['attributes', 'id', 'renderer'].includes(key);
              });
            }

            return null;
          }
          /**
           * @param {String} id The ID of the section
           * @return {Object|null} The section object if found, null if not
           */

        }, {
          key: "getSection",
          value: function getSection(id) {
            var state = this.store.getState();
            var obj = this.client.readQuery({
              query: queries_formSectionQuery,
              variables: {
                branch: state.formatic.environment,
                channel: state.formatic.channel,
                config: state.formatic.config,
                formId: state.formatic.formId,
                submissionId: state.formatic.submissionId
              }
            });
            var section = obj.Form.sections.find(function (s) {
              return id === s.id;
            });

            if (typeof section !== 'undefined') {
              return pickBy_default()(section, function (value, key) {
                return ['attributes', 'fields', 'id'].includes(key);
              });
            }

            return null;
          }
          /**
           * @param {String} id The ID of the page
           * @return {Object|null} The page object if found, null if not
           */

        }, {
          key: "getPage",
          value: function getPage(id) {
            var state = this.store.getState();
            var obj = this.client.readQuery({
              query: queries_getFormPagesQuery,
              variables: {
                branch: state.formatic.environment,
                channel: state.formatic.channel,
                config: state.formatic.config,
                formId: state.formatic.formId,
                submissionId: state.formatic.submissionId
              }
            });
            var page = obj.Form.pages.find(function (p) {
              return id === p.id;
            });

            if (typeof page !== 'undefined') {
              return pickBy_default()(page, function (value, key) {
                return ['attributes', 'id', 'sections'].includes(key);
              });
            }

            return null;
          }
          /**
           * @return {Array} List of IDs corresponding to fields that are currently rendered on the page
           */

        }, {
          key: "getRenderedFields",
          value: function getRenderedFields() {
            return Object.keys(this.store.getState().formatic.visibleFields);
          }
          /**
           * Navigate to a page on the form.
           * @param {String} pageId
           * @param {String?} channel
           * @param {bool?} persist
           */

        }, {
          key: "navigateToPage",
          value: function navigateToPage(pageId, channel) {
            var persist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            if (!channel) {
              // eslint-disable-next-line prefer-destructuring
              channel = this.store.getState().formatic.channel;
            }

            Object(helpers["b"
            /* navigateToPage */
            ])(this.client, this.store, pageId, channel, persist);
          }
          /**
           * Mutate form submission values.
           * @param {String} Field ID
           * @param {mixed} Field value
           * @param {int?} Update timestamp, defaults to current time
           */

        }, {
          key: "setFieldValue",
          value: function setFieldValue(id, value) {
            var timestamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
            var state = this.store.getState();

            if (!get_default()(state.formatic, "data.form.fieldsById[".concat(id, "]"))) {
              var tags = this.getFieldTags(false);

              if (tags[id]) {
                // Machine name/tag was passed through
                id = tags.id;
              } else {
                throw new Error("Field id [".concat(id, "] doesn't exist in form [").concat(state.formatic.formId, "]."));
              }
            } // Retrieve from local apollo store


            var data = this.client.readQuery({
              query: submission["b"
              /* readSubmissionQuery */
              ].query,
              variables: {
                formId: state.formatic.formId,
                submissionId: state.formatic.submissionId,
                branch: state.formatic.environment,
                channel: state.formatic.channel,
                initialValues: state.formatic.initialValues
              }
            }); // Mutate the data on the server

            var options = Object(submission["a"
            /* getSubmissionOptions */
            ])(state.formatic.formId, state.formatic.submissionId, [], [{
              id: id,
              value: value
            }], {
              attributes: data.Submission.attributes || [],
              fields: data.Submission.fields || []
            }, timestamp, state.formatic.channel, state.formatic.environment);
            var mutateResult = this.client.mutate(objectSpread_default()({
              mutation: submission["c"
              /* setSubmissionValuesMutation */
              ]
            }, options));
            var emitter = this.getEmitter();
            emitter.emit(constants["Events"].ValueChanged, {
              fieldID: id,
              oldValue: get_default()(state.formatic, "data.submission.fieldsById[".concat(id, "].value")),
              newValue: value
            });
            this.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].ValueChange, objectSpread_default()({}, Object(analytics["d"
            /* getAnalyticsParam */
            ])(value), {
              fieldId: id,
              source: 'data-layer' // in order to indicate that this record came from the Data layer being used by external app/developers

            }));
            return mutateResult;
          }
        }]);
        return Data;
      }();
      /***/

    },
    /* 389 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_1__);
      /**
       * RootComponent
       */


      var RootComponent = function RootComponent() {
        return null;
      };

      RootComponent.defaultProps = {
        injectableType: 'RootComponent',
        placement: 'top',
        component: lodash_noop__WEBPACK_IMPORTED_MODULE_1___default.a
      };
      RootComponent.propTypes = {
        injectableType: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        placement: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        component: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.element]).isRequired
      };
      /* harmony default export */

      __webpack_exports__["a"] = RootComponent;
      /***/
    },
    /* 390 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "OverrideFieldContainer", function () {
        return OverrideFieldContainer;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "OverrideFieldComponent", function () {
        return OverrideFieldComponent;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "OverrideSystem", function () {
        return OverrideSystem;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "OverrideSection", function () {
        return OverrideSection;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "OverridePage", function () {
        return OverridePage;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "OverrideHOC", function () {
        return OverrideHOC;
      });
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
      /* harmony import */


      var lodash_noop__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_1__);

      var OverrideFieldComponent = function OverrideFieldComponent() {
        return null;
      };

      OverrideFieldComponent.defaultProps = {
        type: '',
        id: '',
        component: lodash_noop__WEBPACK_IMPORTED_MODULE_1___default.a,
        overrideType: 'OverrideFieldComponent'
      };
      OverrideFieldComponent.propTypes = {
        overrideType: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        type: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        component: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.element]).isRequired
      };

      var OverrideFieldContainer = function OverrideFieldContainer() {
        return null;
      };

      OverrideFieldContainer.defaultProps = {
        type: '',
        id: '',
        component: lodash_noop__WEBPACK_IMPORTED_MODULE_1___default.a,
        overrideType: 'OverrideFieldContainer',
        flat: false
      };
      OverrideFieldContainer.propTypes = {
        overrideType: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        type: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        component: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.element]).isRequired,
        flat: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool
      };

      var OverrideSection = function OverrideSection() {
        return null;
      };

      OverrideSection.defaultProps = {
        id: '',
        component: lodash_noop__WEBPACK_IMPORTED_MODULE_1___default.a,
        overrideType: 'OverrideSection'
      };
      OverrideSection.propTypes = {
        overrideType: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        component: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.element]).isRequired
      };

      var OverridePage = function OverridePage() {
        return null;
      };

      OverridePage.defaultProps = {
        id: '',
        component: lodash_noop__WEBPACK_IMPORTED_MODULE_1___default.a,
        overrideType: 'OverridePage'
      };
      OverridePage.propTypes = {
        overrideType: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        component: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.element]).isRequired
      };

      var OverrideSystem = function OverrideSystem() {
        return null;
      };

      OverrideSystem.defaultProps = {
        type: '',
        component: lodash_noop__WEBPACK_IMPORTED_MODULE_1___default.a,
        overrideType: 'OverrideSystem'
      };
      OverrideSystem.propTypes = {
        overrideType: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        type: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        component: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.element]).isRequired
      };

      var OverrideHOC = function OverrideHOC() {
        return null;
      };

      OverrideHOC.defaultProps = {
        type: '',
        component: lodash_noop__WEBPACK_IMPORTED_MODULE_1___default.a,
        overrideType: 'OverrideHOC'
      };
      OverrideHOC.propTypes = {
        overrideType: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        type: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
        component: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.element]).isRequired
      };
      /***/
    },
    /* 391 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var _config_containerMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(147);
      /**
       * @file ./containers/index.js
       * Exports out the containers map to later be exported by the library.
       *
       * Capitalises the first letter of each key within the config container map
       * for improved readability (Containers.RadioListContainer vs. Containers.radioListContainer)
       */


      var containers = {};
      Object.keys(_config_containerMap__WEBPACK_IMPORTED_MODULE_0__[
      /* default */
      "b"]).forEach(function (key) {
        var containerName = key[0].toUpperCase() + key.slice(1);
        containers[containerName] = _config_containerMap__WEBPACK_IMPORTED_MODULE_0__[
        /* default */
        "b"][key];
      });
      /* harmony default export */

      __webpack_exports__["a"] = containers;
      /***/
    },
    /* 392 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var array = __webpack_require__(48);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        /**
         * Calculate the size of a matrix or scalar.
         *
         * Syntax:
         *
         *     math.size(x)
         *
         * Examples:
         *
         *     math.size(2.3)                  // returns []
         *     math.size('hello world')        // returns [11]
         *
         *     const A = [[1, 2, 3], [4, 5, 6]]
         *     math.size(A)                    // returns [2, 3]
         *     math.size(math.range(1,6))      // returns [5]
         *
         * See also:
         *
         *     resize, squeeze, subset
         *
         * @param {boolean | number | Complex | Unit | string | Array | Matrix} x  A matrix
         * @return {Array | Matrix} A vector with size of `x`.
         */

        var size = typed('size', {
          'Matrix': function Matrix(x) {
            // TODO: return the same matrix type as the input
            return matrix(x.size());
          },
          'Array': array.size,
          'string': function string(x) {
            return config.matrix === 'Array' ? [x.length] : matrix([x.length]);
          },
          'number | Complex | BigNumber | Unit | boolean | null': function numberComplexBigNumberUnitBooleanNull(x) {
            // scalar
            return config.matrix === 'Array' ? [] : matrix([]);
          }
        });
        size.toTex = undefined; // use default template

        return size;
      }

      exports.name = 'size';
      exports.factory = factory;
      /***/
    },
    /* 393 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var clone = __webpack_require__(59).clone;

      var format = __webpack_require__(79).format;

      function factory(type, config, load, typed) {
        var latex = __webpack_require__(72);

        var matrix = load(__webpack_require__(46));
        var DenseMatrix = type.DenseMatrix;
        var SparseMatrix = type.SparseMatrix;
        /**
         * Transpose a matrix. All values of the matrix are reflected over its
         * main diagonal. Only applicable to two dimensional matrices containing
         * a vector (i.e. having size `[1,n]` or `[n,1]`). One dimensional
         * vectors and scalars return the input unchanged.
         *
         * Syntax:
         *
         *     math.transpose(x)
         *
         * Examples:
         *
         *     const A = [[1, 2, 3], [4, 5, 6]]
         *     math.transpose(A)               // returns [[1, 4], [2, 5], [3, 6]]
         *
         * See also:
         *
         *     diag, inv, subset, squeeze
         *
         * @param {Array | Matrix} x  Matrix to be transposed
         * @return {Array | Matrix}   The transposed matrix
         */

        var transpose = typed('transpose', {
          'Array': function Array(x) {
            // use dense matrix implementation
            return transpose(matrix(x)).valueOf();
          },
          'Matrix': function Matrix(x) {
            // matrix size
            var size = x.size(); // result

            var c; // process dimensions

            switch (size.length) {
              case 1:
                // vector
                c = x.clone();
                break;

              case 2:
                // rows and columns
                var rows = size[0];
                var columns = size[1]; // check columns

                if (columns === 0) {
                  // throw exception
                  throw new RangeError('Cannot transpose a 2D matrix with no columns (size: ' + format(size) + ')');
                } // process storage format


                switch (x.storage()) {
                  case 'dense':
                    c = _denseTranspose(x, rows, columns);
                    break;

                  case 'sparse':
                    c = _sparseTranspose(x, rows, columns);
                    break;
                }

                break;

              default:
                // multi dimensional
                throw new RangeError('Matrix must be a vector or two dimensional (size: ' + format(this._size) + ')');
            }

            return c;
          },
          // scalars
          'any': function any(x) {
            return clone(x);
          }
        });

        function _denseTranspose(m, rows, columns) {
          // matrix array
          var data = m._data; // transposed matrix data

          var transposed = [];
          var transposedRow; // loop columns

          for (var j = 0; j < columns; j++) {
            // initialize row
            transposedRow = transposed[j] = []; // loop rows

            for (var i = 0; i < rows; i++) {
              // set data
              transposedRow[i] = clone(data[i][j]);
            }
          } // return matrix


          return new DenseMatrix({
            data: transposed,
            size: [columns, rows],
            datatype: m._datatype
          });
        }

        function _sparseTranspose(m, rows, columns) {
          // matrix arrays
          var values = m._values;
          var index = m._index;
          var ptr = m._ptr; // result matrices

          var cvalues = values ? [] : undefined;
          var cindex = [];
          var cptr = []; // row counts

          var w = [];

          for (var x = 0; x < rows; x++) {
            w[x] = 0;
          } // vars


          var p, l, j; // loop values in matrix

          for (p = 0, l = index.length; p < l; p++) {
            // number of values in row
            w[index[p]]++;
          } // cumulative sum


          var sum = 0; // initialize cptr with the cummulative sum of row counts

          for (var i = 0; i < rows; i++) {
            // update cptr
            cptr.push(sum); // update sum

            sum += w[i]; // update w

            w[i] = cptr[i];
          } // update cptr


          cptr.push(sum); // loop columns

          for (j = 0; j < columns; j++) {
            // values & index in column
            for (var k0 = ptr[j], k1 = ptr[j + 1], k = k0; k < k1; k++) {
              // C values & index
              var q = w[index[k]]++; // C[j, i] = A[i, j]

              cindex[q] = j; // check we need to process values (pattern matrix)

              if (values) {
                cvalues[q] = clone(values[k]);
              }
            }
          } // return matrix


          return new SparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [columns, rows],
            datatype: m._datatype
          });
        }

        transpose.toTex = {
          1: "\\left(${args[0]}\\right)".concat(latex.operators['transpose'])
        };
        return transpose;
      }

      exports.name = 'transpose';
      exports.factory = factory;
      /***/
    },
    /* 394 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var util = __webpack_require__(151);

      var DimensionError = __webpack_require__(92);

      var string = util.string;
      var array = util.array;
      var object = util.object;
      var number = util.number;
      var isArray = Array.isArray;
      var isNumber = number.isNumber;
      var isInteger = number.isInteger;
      var isString = string.isString;
      var validateIndex = array.validateIndex;

      function factory(type, config, load, typed) {
        var getArrayDataType = load(__webpack_require__(228));
        var Matrix = load(__webpack_require__(301)); // force loading Matrix (do not use via type.Matrix)

        /**
         * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
         * @class DenseMatrix
         */

        function DenseMatrix(data, datatype) {
          if (!(this instanceof DenseMatrix)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          if (datatype && !isString(datatype)) {
            throw new Error('Invalid datatype: ' + datatype);
          }

          if (type.isMatrix(data)) {
            // check data is a DenseMatrix
            if (data.type === 'DenseMatrix') {
              // clone data & size
              this._data = object.clone(data._data);
              this._size = object.clone(data._size);
              this._datatype = datatype || data._datatype;
            } else {
              // build data from existing matrix
              this._data = data.toArray();
              this._size = data.size();
              this._datatype = datatype || data._datatype;
            }
          } else if (data && isArray(data.data) && isArray(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            this._datatype = datatype || data.datatype;
          } else if (isArray(data)) {
            // replace nested Matrices with Arrays
            this._data = preprocess(data); // get the dimensions of the array

            this._size = array.size(this._data); // verify the dimensions of the array, TODO: compute size while processing array

            array.validate(this._data, this._size); // data type unknown

            this._datatype = datatype;
          } else if (data) {
            // unsupported type
            throw new TypeError('Unsupported type of data (' + util.types.type(data) + ')');
          } else {
            // nothing provided
            this._data = [];
            this._size = [0];
            this._datatype = datatype;
          }
        }

        DenseMatrix.prototype = new Matrix();
        /**
         * Attach type information
         */

        DenseMatrix.prototype.type = 'DenseMatrix';
        DenseMatrix.prototype.isDenseMatrix = true;
        /**
         * Get the matrix type
         *
         * Usage:
         *    const matrixType = matrix.getDataType()  // retrieves the matrix type
         *
         * @memberOf DenseMatrix
         * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
         */

        DenseMatrix.prototype.getDataType = function () {
          return getArrayDataType(this._data);
        };
        /**
         * Get the storage format used by the matrix.
         *
         * Usage:
         *     const format = matrix.storage()  // retrieve storage format
         *
         * @memberof DenseMatrix
         * @return {string}           The storage format.
         */


        DenseMatrix.prototype.storage = function () {
          return 'dense';
        };
        /**
         * Get the datatype of the data stored in the matrix.
         *
         * Usage:
         *     const format = matrix.datatype()   // retrieve matrix datatype
         *
         * @memberof DenseMatrix
         * @return {string}           The datatype.
         */


        DenseMatrix.prototype.datatype = function () {
          return this._datatype;
        };
        /**
         * Create a new DenseMatrix
         * @memberof DenseMatrix
         * @param {Array} data
         * @param {string} [datatype]
         */


        DenseMatrix.prototype.create = function (data, datatype) {
          return new DenseMatrix(data, datatype);
        };
        /**
         * Get a subset of the matrix, or replace a subset of the matrix.
         *
         * Usage:
         *     const subset = matrix.subset(index)               // retrieve subset
         *     const value = matrix.subset(index, replacement)   // replace subset
         *
         * @memberof DenseMatrix
         * @param {Index} index
         * @param {Array | Matrix | *} [replacement]
         * @param {*} [defaultValue=0]      Default value, filled in on new entries when
         *                                  the matrix is resized. If not provided,
         *                                  new matrix elements will be filled with zeros.
         */


        DenseMatrix.prototype.subset = function (index, replacement, defaultValue) {
          switch (arguments.length) {
            case 1:
              return _get(this, index);
            // intentional fall through

            case 2:
            case 3:
              return _set(this, index, replacement, defaultValue);

            default:
              throw new SyntaxError('Wrong number of arguments');
          }
        };
        /**
         * Get a single element from the matrix.
         * @memberof DenseMatrix
         * @param {number[]} index   Zero-based index
         * @return {*} value
         */


        DenseMatrix.prototype.get = function (index) {
          if (!isArray(index)) {
            throw new TypeError('Array expected');
          }

          if (index.length !== this._size.length) {
            throw new DimensionError(index.length, this._size.length);
          } // check index


          for (var x = 0; x < index.length; x++) {
            validateIndex(index[x], this._size[x]);
          }

          var data = this._data;

          for (var i = 0, ii = index.length; i < ii; i++) {
            var indexI = index[i];
            validateIndex(indexI, data.length);
            data = data[indexI];
          }

          return data;
        };
        /**
         * Replace a single element in the matrix.
         * @memberof DenseMatrix
         * @param {number[]} index   Zero-based index
         * @param {*} value
         * @param {*} [defaultValue]        Default value, filled in on new entries when
         *                                  the matrix is resized. If not provided,
         *                                  new matrix elements will be left undefined.
         * @return {DenseMatrix} self
         */


        DenseMatrix.prototype.set = function (index, value, defaultValue) {
          if (!isArray(index)) {
            throw new TypeError('Array expected');
          }

          if (index.length < this._size.length) {
            throw new DimensionError(index.length, this._size.length, '<');
          }

          var i, ii, indexI; // enlarge matrix when needed

          var size = index.map(function (i) {
            return i + 1;
          });

          _fit(this, size, defaultValue); // traverse over the dimensions


          var data = this._data;

          for (i = 0, ii = index.length - 1; i < ii; i++) {
            indexI = index[i];
            validateIndex(indexI, data.length);
            data = data[indexI];
          } // set new value


          indexI = index[index.length - 1];
          validateIndex(indexI, data.length);
          data[indexI] = value;
          return this;
        };
        /**
         * Get a submatrix of this matrix
         * @memberof DenseMatrix
         * @param {DenseMatrix} matrix
         * @param {Index} index   Zero-based index
         * @private
         */


        function _get(matrix, index) {
          if (!type.isIndex(index)) {
            throw new TypeError('Invalid index');
          }

          var isScalar = index.isScalar();

          if (isScalar) {
            // return a scalar
            return matrix.get(index.min());
          } else {
            // validate dimensions
            var size = index.size();

            if (size.length !== matrix._size.length) {
              throw new DimensionError(size.length, matrix._size.length);
            } // validate if any of the ranges in the index is out of range


            var min = index.min();
            var max = index.max();

            for (var i = 0, ii = matrix._size.length; i < ii; i++) {
              validateIndex(min[i], matrix._size[i]);
              validateIndex(max[i], matrix._size[i]);
            } // retrieve submatrix
            // TODO: more efficient when creating an empty matrix and setting _data and _size manually


            return new DenseMatrix(_getSubmatrix(matrix._data, index, size.length, 0), matrix._datatype);
          }
        }
        /**
         * Recursively get a submatrix of a multi dimensional matrix.
         * Index is not checked for correct number or length of dimensions.
         * @memberof DenseMatrix
         * @param {Array} data
         * @param {Index} index
         * @param {number} dims   Total number of dimensions
         * @param {number} dim    Current dimension
         * @return {Array} submatrix
         * @private
         */


        function _getSubmatrix(data, index, dims, dim) {
          var last = dim === dims - 1;
          var range = index.dimension(dim);

          if (last) {
            return range.map(function (i) {
              validateIndex(i, data.length);
              return data[i];
            }).valueOf();
          } else {
            return range.map(function (i) {
              validateIndex(i, data.length);
              var child = data[i];
              return _getSubmatrix(child, index, dims, dim + 1);
            }).valueOf();
          }
        }
        /**
         * Replace a submatrix in this matrix
         * Indexes are zero-based.
         * @memberof DenseMatrix
         * @param {DenseMatrix} matrix
         * @param {Index} index
         * @param {DenseMatrix | Array | *} submatrix
         * @param {*} defaultValue          Default value, filled in on new entries when
         *                                  the matrix is resized.
         * @return {DenseMatrix} matrix
         * @private
         */


        function _set(matrix, index, submatrix, defaultValue) {
          if (!index || index.isIndex !== true) {
            throw new TypeError('Invalid index');
          } // get index size and check whether the index contains a single value


          var iSize = index.size();
          var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed

          var sSize;

          if (type.isMatrix(submatrix)) {
            sSize = submatrix.size();
            submatrix = submatrix.valueOf();
          } else {
            sSize = array.size(submatrix);
          }

          if (isScalar) {
            // set a scalar
            // check whether submatrix is a scalar
            if (sSize.length !== 0) {
              throw new TypeError('Scalar expected');
            }

            matrix.set(index.min(), submatrix, defaultValue);
          } else {
            // set a submatrix
            // validate dimensions
            if (iSize.length < matrix._size.length) {
              throw new DimensionError(iSize.length, matrix._size.length, '<');
            }

            if (sSize.length < iSize.length) {
              // calculate number of missing outer dimensions
              var i = 0;
              var outer = 0;

              while (iSize[i] === 1 && sSize[i] === 1) {
                i++;
              }

              while (iSize[i] === 1) {
                outer++;
                i++;
              } // unsqueeze both outer and inner dimensions


              submatrix = array.unsqueeze(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size


            if (!object.deepEqual(iSize, sSize)) {
              throw new DimensionError(iSize, sSize, '>');
            } // enlarge matrix when needed


            var size = index.max().map(function (i) {
              return i + 1;
            });

            _fit(matrix, size, defaultValue); // insert the sub matrix


            var dims = iSize.length;
            var dim = 0;

            _setSubmatrix(matrix._data, index, submatrix, dims, dim);
          }

          return matrix;
        }
        /**
         * Replace a submatrix of a multi dimensional matrix.
         * @memberof DenseMatrix
         * @param {Array} data
         * @param {Index} index
         * @param {Array} submatrix
         * @param {number} dims   Total number of dimensions
         * @param {number} dim
         * @private
         */


        function _setSubmatrix(data, index, submatrix, dims, dim) {
          var last = dim === dims - 1;
          var range = index.dimension(dim);

          if (last) {
            range.forEach(function (dataIndex, subIndex) {
              validateIndex(dataIndex);
              data[dataIndex] = submatrix[subIndex[0]];
            });
          } else {
            range.forEach(function (dataIndex, subIndex) {
              validateIndex(dataIndex);

              _setSubmatrix(data[dataIndex], index, submatrix[subIndex[0]], dims, dim + 1);
            });
          }
        }
        /**
         * Resize the matrix to the given size. Returns a copy of the matrix when
         * `copy=true`, otherwise return the matrix itself (resize in place).
         *
         * @memberof DenseMatrix
         * @param {number[]} size           The new size the matrix should have.
         * @param {*} [defaultValue=0]      Default value, filled in on new entries.
         *                                  If not provided, the matrix elements will
         *                                  be filled with zeros.
         * @param {boolean} [copy]          Return a resized copy of the matrix
         *
         * @return {Matrix}                 The resized matrix
         */


        DenseMatrix.prototype.resize = function (size, defaultValue, copy) {
          // validate arguments
          if (!isArray(size)) {
            throw new TypeError('Array expected');
          } // matrix to resize


          var m = copy ? this.clone() : this; // resize matrix

          return _resize(m, size, defaultValue);
        };

        function _resize(matrix, size, defaultValue) {
          // check size
          if (size.length === 0) {
            // first value in matrix
            var v = matrix._data; // go deep

            while (isArray(v)) {
              v = v[0];
            }

            return v;
          } // resize matrix


          matrix._size = size.slice(0); // copy the array

          matrix._data = array.resize(matrix._data, matrix._size, defaultValue); // return matrix

          return matrix;
        }
        /**
         * Reshape the matrix to the given size. Returns a copy of the matrix when
         * `copy=true`, otherwise return the matrix itself (reshape in place).
         *
         * NOTE: This might be better suited to copy by default, instead of modifying
         *       in place. For now, it operates in place to remain consistent with
         *       resize().
         *
         * @memberof DenseMatrix
         * @param {number[]} size           The new size the matrix should have.
         * @param {boolean} [copy]          Return a reshaped copy of the matrix
         *
         * @return {Matrix}                 The reshaped matrix
         */


        DenseMatrix.prototype.reshape = function (size, copy) {
          var m = copy ? this.clone() : this;
          m._data = array.reshape(m._data, size);
          m._size = size.slice(0);
          return m;
        };
        /**
         * Enlarge the matrix when it is smaller than given size.
         * If the matrix is larger or equal sized, nothing is done.
         * @memberof DenseMatrix
         * @param {DenseMatrix} matrix           The matrix to be resized
         * @param {number[]} size
         * @param {*} defaultValue          Default value, filled in on new entries.
         * @private
         */


        function _fit(matrix, size, defaultValue) {
          var // copy the array
          newSize = matrix._size.slice(0);

          var changed = false; // add dimensions when needed

          while (newSize.length < size.length) {
            newSize.push(0);
            changed = true;
          } // enlarge size when needed


          for (var i = 0, ii = size.length; i < ii; i++) {
            if (size[i] > newSize[i]) {
              newSize[i] = size[i];
              changed = true;
            }
          }

          if (changed) {
            // resize only when size is changed
            _resize(matrix, newSize, defaultValue);
          }
        }
        /**
         * Create a clone of the matrix
         * @memberof DenseMatrix
         * @return {DenseMatrix} clone
         */


        DenseMatrix.prototype.clone = function () {
          var m = new DenseMatrix({
            data: object.clone(this._data),
            size: object.clone(this._size),
            datatype: this._datatype
          });
          return m;
        };
        /**
         * Retrieve the size of the matrix.
         * @memberof DenseMatrix
         * @returns {number[]} size
         */


        DenseMatrix.prototype.size = function () {
          return this._size.slice(0); // return a clone of _size
        };
        /**
         * Create a new matrix with the results of the callback function executed on
         * each entry of the matrix.
         * @memberof DenseMatrix
         * @param {Function} callback   The callback function is invoked with three
         *                              parameters: the value of the element, the index
         *                              of the element, and the Matrix being traversed.
         *
         * @return {DenseMatrix} matrix
         */


        DenseMatrix.prototype.map = function (callback) {
          // matrix instance
          var me = this;

          var recurse = function recurse(value, index) {
            if (isArray(value)) {
              return value.map(function (child, i) {
                return recurse(child, index.concat(i));
              });
            } else {
              return callback(value, index, me);
            }
          }; // return dense format


          return new DenseMatrix({
            data: recurse(this._data, []),
            size: object.clone(this._size),
            datatype: this._datatype
          });
        };
        /**
         * Execute a callback function on each entry of the matrix.
         * @memberof DenseMatrix
         * @param {Function} callback   The callback function is invoked with three
         *                              parameters: the value of the element, the index
         *                              of the element, and the Matrix being traversed.
         */


        DenseMatrix.prototype.forEach = function (callback) {
          // matrix instance
          var me = this;

          var recurse = function recurse(value, index) {
            if (isArray(value)) {
              value.forEach(function (child, i) {
                recurse(child, index.concat(i));
              });
            } else {
              callback(value, index, me);
            }
          };

          recurse(this._data, []);
        };
        /**
         * Create an Array with a copy of the data of the DenseMatrix
         * @memberof DenseMatrix
         * @returns {Array} array
         */


        DenseMatrix.prototype.toArray = function () {
          return object.clone(this._data);
        };
        /**
         * Get the primitive value of the DenseMatrix: a multidimensional array
         * @memberof DenseMatrix
         * @returns {Array} array
         */


        DenseMatrix.prototype.valueOf = function () {
          return this._data;
        };
        /**
         * Get a string representation of the matrix, with optional formatting options.
         * @memberof DenseMatrix
         * @param {Object | number | Function} [options]  Formatting options. See
         *                                                lib/utils/number:format for a
         *                                                description of the available
         *                                                options.
         * @returns {string} str
         */


        DenseMatrix.prototype.format = function (options) {
          return string.format(this._data, options);
        };
        /**
         * Get a string representation of the matrix
         * @memberof DenseMatrix
         * @returns {string} str
         */


        DenseMatrix.prototype.toString = function () {
          return string.format(this._data);
        };
        /**
         * Get a JSON representation of the matrix
         * @memberof DenseMatrix
         * @returns {Object}
         */


        DenseMatrix.prototype.toJSON = function () {
          return {
            mathjs: 'DenseMatrix',
            data: this._data,
            size: this._size,
            datatype: this._datatype
          };
        };
        /**
         * Get the kth Matrix diagonal.
         *
         * @memberof DenseMatrix
         * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
         *
         * @returns {Matrix}                     The matrix with the diagonal values.
         */


        DenseMatrix.prototype.diagonal = function (k) {
          // validate k if any
          if (k) {
            // convert BigNumber to a number
            if (type.isBigNumber(k)) {
              k = k.toNumber();
            } // is must be an integer


            if (!isNumber(k) || !isInteger(k)) {
              throw new TypeError('The parameter k must be an integer number');
            }
          } else {
            // default value
            k = 0;
          }

          var kSuper = k > 0 ? k : 0;
          var kSub = k < 0 ? -k : 0; // rows & columns

          var rows = this._size[0];
          var columns = this._size[1]; // number diagonal values

          var n = Math.min(rows - kSub, columns - kSuper); // x is a matrix get diagonal from matrix

          var data = []; // loop rows

          for (var i = 0; i < n; i++) {
            data[i] = this._data[i + kSub][i + kSuper];
          } // create DenseMatrix


          return new DenseMatrix({
            data: data,
            size: [n],
            datatype: this._datatype
          });
        };
        /**
         * Create a diagonal matrix.
         *
         * @memberof DenseMatrix
         * @param {Array} size                     The matrix size.
         * @param {number | Matrix | Array } value The values for the diagonal.
         * @param {number | BigNumber} [k=0]       The kth diagonal where the vector will be filled in.
         * @param {number} [defaultValue]          The default value for non-diagonal
         * @param {string} [datatype]              The datatype for the diagonal
         *
         * @returns {DenseMatrix}
         */


        DenseMatrix.diagonal = function (size, value, k, defaultValue, datatype) {
          if (!isArray(size)) {
            throw new TypeError('Array expected, size parameter');
          }

          if (size.length !== 2) {
            throw new Error('Only two dimensions matrix are supported');
          } // map size & validate


          size = size.map(function (s) {
            // check it is a big number
            if (type.isBigNumber(s)) {
              // convert it
              s = s.toNumber();
            } // validate arguments


            if (!isNumber(s) || !isInteger(s) || s < 1) {
              throw new Error('Size values must be positive integers');
            }

            return s;
          }); // validate k if any

          if (k) {
            // convert BigNumber to a number
            if (type.isBigNumber(k)) {
              k = k.toNumber();
            } // is must be an integer


            if (!isNumber(k) || !isInteger(k)) {
              throw new TypeError('The parameter k must be an integer number');
            }
          } else {
            // default value
            k = 0;
          }

          if (defaultValue && isString(datatype)) {
            // convert defaultValue to the same datatype
            defaultValue = typed.convert(defaultValue, datatype);
          }

          var kSuper = k > 0 ? k : 0;
          var kSub = k < 0 ? -k : 0; // rows and columns

          var rows = size[0];
          var columns = size[1]; // number of non-zero items

          var n = Math.min(rows - kSub, columns - kSuper); // value extraction function

          var _value; // check value


          if (isArray(value)) {
            // validate array
            if (value.length !== n) {
              // number of values in array must be n
              throw new Error('Invalid value array length');
            } // define function


            _value = function _value(i) {
              // return value @ i
              return value[i];
            };
          } else if (type.isMatrix(value)) {
            // matrix size
            var ms = value.size(); // validate matrix

            if (ms.length !== 1 || ms[0] !== n) {
              // number of values in array must be n
              throw new Error('Invalid matrix length');
            } // define function


            _value = function _value(i) {
              // return value @ i
              return value.get([i]);
            };
          } else {
            // define function
            _value = function _value() {
              // return value
              return value;
            };
          } // discover default value if needed


          if (!defaultValue) {
            // check first value in array
            defaultValue = type.isBigNumber(_value(0)) ? new type.BigNumber(0) : 0;
          } // empty array


          var data = []; // check we need to resize array

          if (size.length > 0) {
            // resize array
            data = array.resize(data, size, defaultValue); // fill diagonal

            for (var d = 0; d < n; d++) {
              data[d + kSub][d + kSuper] = _value(d);
            }
          } // create DenseMatrix


          return new DenseMatrix({
            data: data,
            size: [rows, columns]
          });
        };
        /**
         * Generate a matrix from a JSON object
         * @memberof DenseMatrix
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
         *                       where mathjs is optional
         * @returns {DenseMatrix}
         */


        DenseMatrix.fromJSON = function (json) {
          return new DenseMatrix(json);
        };
        /**
         * Swap rows i and j in Matrix.
         *
         * @memberof DenseMatrix
         * @param {number} i       Matrix row index 1
         * @param {number} j       Matrix row index 2
         *
         * @return {Matrix}        The matrix reference
         */


        DenseMatrix.prototype.swapRows = function (i, j) {
          // check index
          if (!isNumber(i) || !isInteger(i) || !isNumber(j) || !isInteger(j)) {
            throw new Error('Row index must be positive integers');
          } // check dimensions


          if (this._size.length !== 2) {
            throw new Error('Only two dimensional matrix is supported');
          } // validate index


          validateIndex(i, this._size[0]);
          validateIndex(j, this._size[0]); // swap rows

          DenseMatrix._swapRows(i, j, this._data); // return current instance


          return this;
        };
        /**
         * Swap rows i and j in Dense Matrix data structure.
         *
         * @param {number} i       Matrix row index 1
         * @param {number} j       Matrix row index 2
         * @param {Array} data     Matrix data
         */


        DenseMatrix._swapRows = function (i, j, data) {
          // swap values i <-> j
          var vi = data[i];
          data[i] = data[j];
          data[j] = vi;
        };
        /**
         * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
         * Matrices. Replaces all nested Matrices with Arrays
         * @memberof DenseMatrix
         * @param {Array} data
         * @return {Array} data
         */


        function preprocess(data) {
          for (var i = 0, ii = data.length; i < ii; i++) {
            var elem = data[i];

            if (isArray(elem)) {
              data[i] = preprocess(elem);
            } else if (elem && elem.isMatrix === true) {
              data[i] = preprocess(elem.valueOf());
            }
          }

          return data;
        } // register this type in the base class Matrix


        type.Matrix._storage.dense = DenseMatrix;
        type.Matrix._storage['default'] = DenseMatrix; // exports

        return DenseMatrix;
      }

      exports.name = 'DenseMatrix';
      exports.path = 'type';
      exports.factory = factory;
      exports.lazy = false; // no lazy loading, as we alter type.Matrix._storage

      /***/
    },
    /* 395 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var getType = load(__webpack_require__(131));
        /**
         * Improve error messages for statistics functions. Errors are typically
         * thrown in an internally used function like larger, causing the error
         * not to mention the function (like max) which is actually used by the user.
         *
         * @param {Error} err
         * @param {String} fnName
         * @param {*} [value]
         * @return {Error}
         */

        return function improveErrorMessage(err, fnName, value) {
          // TODO: add information with the index (also needs transform in expression parser)
          var details;

          if (String(err).indexOf('Unexpected type') !== -1) {
            details = arguments.length > 2 ? ' (type: ' + getType(value) + ', value: ' + JSON.stringify(value) + ')' : ' (type: ' + err.data.actual + ')';
            return new TypeError('Cannot calculate ' + fnName + ', unexpected type of argument' + details);
          }

          if (String(err).indexOf('complex numbers') !== -1) {
            details = arguments.length > 2 ? ' (type: ' + getType(value) + ', value: ' + JSON.stringify(value) + ')' : '';
            return new TypeError('Cannot calculate ' + fnName + ', no ordering relation is defined for complex numbers' + details);
          }

          return err;
        };
      }

      exports.factory = factory;
      /***/
    },
    /* 396 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var isCollection = __webpack_require__(764);
      /**
       * Test whether an array contains collections
       * @param {Array} array
       * @returns {boolean} Returns true when the array contains one or multiple
       *                    collections (Arrays or Matrices). Returns false otherwise.
       */


      module.exports = function containsCollections(array) {
        for (var i = 0; i < array.length; i++) {
          if (isCollection(array[i])) {
            return true;
          }
        }

        return false;
      };
      /***/

    },
    /* 397 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var arraySize = __webpack_require__(48).size;

      var isMatrix = __webpack_require__(199);

      var IndexError = __webpack_require__(198);
      /**
       * Reduce a given matrix or array to a new matrix or
       * array with one less dimension, applying the given
       * callback in the selected dimension.
       * @param {Array | Matrix} mat
       * @param {number} dim
       * @param {Function} callback
       * @return {Array | Matrix} res
       */


      module.exports = function (mat, dim, callback) {
        var size = Array.isArray(mat) ? arraySize(mat) : mat.size();

        if (dim < 0 || dim >= size.length) {
          // TODO: would be more clear when throwing a DimensionError here
          throw new IndexError(dim, size.length);
        }

        if (isMatrix(mat)) {
          return mat.create(_reduce(mat.valueOf(), dim, callback));
        } else {
          return _reduce(mat, dim, callback);
        }
      };
      /**
       * Recursively reduce a matrix
       * @param {Array} mat
       * @param {number} dim
       * @param {Function} callback
       * @returns {Array} ret
       * @private
       */


      function _reduce(mat, dim, callback) {
        var i, ret, val, tran;

        if (dim <= 0) {
          if (!Array.isArray(mat[0])) {
            val = mat[0];

            for (i = 1; i < mat.length; i++) {
              val = callback(val, mat[i]);
            }

            return val;
          } else {
            tran = _switch(mat);
            ret = [];

            for (i = 0; i < tran.length; i++) {
              ret[i] = _reduce(tran[i], dim - 1, callback);
            }

            return ret;
          }
        } else {
          ret = [];

          for (i = 0; i < mat.length; i++) {
            ret[i] = _reduce(mat[i], dim - 1, callback);
          }

          return ret;
        }
      }
      /**
       * Transpose a matrix
       * @param {Array} mat
       * @returns {Array} ret
       * @private
       */


      function _switch(mat) {
        var I = mat.length;
        var J = mat[0].length;
        var i, j;
        var ret = [];

        for (j = 0; j < J; j++) {
          var tmp = [];

          for (i = 0; i < I; i++) {
            tmp.push(mat[i][j]);
          }

          ret.push(tmp);
        }

        return ret;
      }
      /***/

    },
    /* 398 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var isMatrix = __webpack_require__(199);
      /**
       * Recursively loop over all elements in a given multi dimensional array
       * and invoke the callback on each of the elements.
       * @param {Array | Matrix} array
       * @param {Function} callback     The callback method is invoked with one
       *                                parameter: the current element in the array
       */


      module.exports = function deepForEach(array, callback) {
        if (isMatrix(array)) {
          array = array.valueOf();
        }

        for (var i = 0, ii = array.length; i < ii; i++) {
          var value = array[i];

          if (Array.isArray(value)) {
            deepForEach(value, callback);
          } else {
            callback(value);
          }
        }
      };
      /***/

    },
    /* 399 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepForEach = __webpack_require__(398);

      var reduce = __webpack_require__(397);

      var containsCollections = __webpack_require__(396);

      function factory(type, config, load, typed) {
        var larger = load(__webpack_require__(231));
        var improveErrorMessage = load(__webpack_require__(395));
        /**
         * Compute the maximum value of a matrix or a  list with values.
         * In case of a multi dimensional array, the maximum of the flattened array
         * will be calculated. When `dim` is provided, the maximum over the selected
         * dimension will be calculated. Parameter `dim` is zero-based.
         *
         * Syntax:
         *
         *     math.max(a, b, c, ...)
         *     math.max(A)
         *     math.max(A, dim)
         *
         * Examples:
         *
         *     math.max(2, 1, 4, 3)                  // returns 4
         *     math.max([2, 1, 4, 3])                // returns 4
         *
         *     // maximum over a specified dimension (zero-based)
         *     math.max([[2, 5], [4, 3], [1, 7]], 0) // returns [4, 7]
         *     math.max([[2, 5], [4, 3]], [1, 7], 1) // returns [5, 4, 7]
         *
         *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
         *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
         *
         * See also:
         *
         *    mean, median, min, prod, std, sum, var
         *
         * @param {... *} args  A single matrix or or multiple scalar values
         * @return {*} The maximum value
         */

        var max = typed('max', {
          // max([a, b, c, d, ...])
          'Array | Matrix': _max,
          // max([a, b, c, d, ...], dim)
          'Array | Matrix, number | BigNumber': function ArrayMatrixNumberBigNumber(array, dim) {
            return reduce(array, dim.valueOf(), _largest);
          },
          // max(a, b, c, d, ...)
          '...': function _(args) {
            if (containsCollections(args)) {
              throw new TypeError('Scalar values expected in function max');
            }

            return _max(args);
          }
        });
        max.toTex = "\\max\\left(${args}\\right)";
        return max;
        /**
         * Return the largest of two values
         * @param {*} x
         * @param {*} y
         * @returns {*} Returns x when x is largest, or y when y is largest
         * @private
         */

        function _largest(x, y) {
          try {
            return larger(x, y) ? x : y;
          } catch (err) {
            throw improveErrorMessage(err, 'max', y);
          }
        }
        /**
         * Recursively calculate the maximum value in an n-dimensional array
         * @param {Array} array
         * @return {number} max
         * @private
         */


        function _max(array) {
          var max;
          deepForEach(array, function (value) {
            try {
              if (isNaN(value) && typeof value === 'number') {
                max = NaN;
              } else if (max === undefined || larger(value, max)) {
                max = value;
              }
            } catch (err) {
              throw improveErrorMessage(err, 'max', value);
            }
          });

          if (max === undefined) {
            throw new Error('Cannot calculate max of an empty array');
          }

          return max;
        }
      }

      exports.name = 'max';
      exports.factory = factory;
      /***/
    },
    /* 400 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        /**
         * Calculate the square root of a value.
         *
         * For matrices, the function is evaluated element wise.
         *
         * Syntax:
         *
         *    math.sqrt(x)
         *
         * Examples:
         *
         *    math.sqrt(25)                // returns 5
         *    math.square(5)               // returns 25
         *    math.sqrt(-4)                // returns Complex 2i
         *
         * See also:
         *
         *    square, multiply, cube, cbrt, sqrtm
         *
         * @param {number | BigNumber | Complex | Array | Matrix | Unit} x
         *            Value for which to calculate the square root.
         * @return {number | BigNumber | Complex | Array | Matrix | Unit}
         *            Returns the square root of `x`
         */
        var sqrt = typed('sqrt', {
          'number': _sqrtNumber,
          'Complex': function Complex(x) {
            return x.sqrt();
          },
          'BigNumber': function BigNumber(x) {
            if (!x.isNegative() || config.predictable) {
              return x.sqrt();
            } else {
              // negative value -> downgrade to number to do complex value computation
              return _sqrtNumber(x.toNumber());
            }
          },
          'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since sqrt(0) = 0
            return deepMap(x, sqrt, true);
          },
          'Unit': function Unit(x) {
            // Someday will work for complex units when they are implemented
            return x.pow(0.5);
          }
        });
        /**
         * Calculate sqrt for a number
         * @param {number} x
         * @returns {number | Complex} Returns the square root of x
         * @private
         */

        function _sqrtNumber(x) {
          if (isNaN(x)) {
            return NaN;
          } else if (x >= 0 || config.predictable) {
            return Math.sqrt(x);
          } else {
            return new type.Complex(x, 0).sqrt();
          }
        }

        sqrt.toTex = {
          1: "\\sqrt{${args[0]}}"
        };
        return sqrt;
      }

      exports.name = 'sqrt';
      exports.factory = factory;
      /***/
    },
    /* 401 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var isInteger = __webpack_require__(67).isInteger;

      var resize = __webpack_require__(48).resize;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        /**
         * Create a matrix filled with zeros. The created matrix can have one or
         * multiple dimensions.
         *
         * Syntax:
         *
         *    math.zeros(m)
         *    math.zeros(m, format)
         *    math.zeros(m, n)
         *    math.zeros(m, n, format)
         *    math.zeros([m, n])
         *    math.zeros([m, n], format)
         *
         * Examples:
         *
         *    math.zeros(3)                  // returns [0, 0, 0]
         *    math.zeros(3, 2)               // returns [[0, 0], [0, 0], [0, 0]]
         *    math.zeros(3, 'dense')         // returns [0, 0, 0]
         *
         *    const A = [[1, 2, 3], [4, 5, 6]]
         *    math.zeros(math.size(A))       // returns [[0, 0, 0], [0, 0, 0]]
         *
         * See also:
         *
         *    ones, identity, size, range
         *
         * @param {...number | Array} size    The size of each dimension of the matrix
         * @param {string} [format]           The Matrix storage format
         *
         * @return {Array | Matrix}           A matrix filled with zeros
         */

        var zeros = typed('zeros', {
          '': function _() {
            return config.matrix === 'Array' ? _zeros([]) : _zeros([], 'default');
          },
          // math.zeros(m, n, p, ..., format)
          // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
          '...number | BigNumber | string': function numberBigNumberString(size) {
            var last = size[size.length - 1];

            if (typeof last === 'string') {
              var format = size.pop();
              return _zeros(size, format);
            } else if (config.matrix === 'Array') {
              return _zeros(size);
            } else {
              return _zeros(size, 'default');
            }
          },
          'Array': _zeros,
          'Matrix': function Matrix(size) {
            var format = size.storage();
            return _zeros(size.valueOf(), format);
          },
          'Array | Matrix, string': function ArrayMatrixString(size, format) {
            return _zeros(size.valueOf(), format);
          }
        });
        zeros.toTex = undefined; // use default template

        return zeros;
        /**
         * Create an Array or Matrix with zeros
         * @param {Array} size
         * @param {string} [format='default']
         * @return {Array | Matrix}
         * @private
         */

        function _zeros(size, format) {
          var hasBigNumbers = _normalize(size);

          var defaultValue = hasBigNumbers ? new type.BigNumber(0) : 0;

          _validate(size);

          if (format) {
            // return a matrix
            var m = matrix(format);

            if (size.length > 0) {
              return m.resize(size, defaultValue);
            }

            return m;
          } else {
            // return an Array
            var arr = [];

            if (size.length > 0) {
              return resize(arr, size, defaultValue);
            }

            return arr;
          }
        } // replace BigNumbers with numbers, returns true if size contained BigNumbers


        function _normalize(size) {
          var hasBigNumbers = false;
          size.forEach(function (value, index, arr) {
            if (type.isBigNumber(value)) {
              hasBigNumbers = true;
              arr[index] = value.toNumber();
            }
          });
          return hasBigNumbers;
        } // validate arguments


        function _validate(size) {
          size.forEach(function (value) {
            if (typeof value !== 'number' || !isInteger(value) || value < 0) {
              throw new Error('Parameters in function zeros must be positive integers');
            }
          });
        }
      } // TODO: zeros contains almost the same code as ones. Reuse this?


      exports.name = 'zeros';
      exports.factory = factory;
      /***/
    },
    /* 402 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var isInteger = __webpack_require__(67).isInteger;

      var toFixed = __webpack_require__(67).toFixed;

      var deepMap = __webpack_require__(80);

      var NO_INT = 'Number of decimals in function round must be an integer';

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var equalScalar = load(__webpack_require__(125));
        var zeros = load(__webpack_require__(401));
        var algorithm11 = load(__webpack_require__(234));
        var algorithm12 = load(__webpack_require__(150));
        var algorithm14 = load(__webpack_require__(107));
        /**
         * Round a value towards the nearest integer.
         * For matrices, the function is evaluated element wise.
         *
         * Syntax:
         *
         *    math.round(x)
         *    math.round(x, n)
         *
         * Examples:
         *
         *    math.round(3.2)              // returns number 3
         *    math.round(3.8)              // returns number 4
         *    math.round(-4.2)             // returns number -4
         *    math.round(-4.7)             // returns number -5
         *    math.round(math.pi, 3)       // returns number 3.142
         *    math.round(123.45678, 2)     // returns number 123.46
         *
         *    const c = math.complex(3.2, -2.7)
         *    math.round(c)                // returns Complex 3 - 3i
         *
         *    math.round([3.2, 3.8, -4.7]) // returns Array [3, 4, -5]
         *
         * See also:
         *
         *    ceil, fix, floor
         *
         * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
         * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
         * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
         */

        var round = typed('round', {
          'number': function number(x) {
            return _round(x, 0);
          },
          'number, number': function numberNumber(x, n) {
            if (!isInteger(n)) {
              throw new TypeError(NO_INT);
            }

            if (n < 0 || n > 15) {
              throw new Error('Number of decimals in function round must be in te range of 0-15');
            }

            return _round(x, n);
          },
          'Complex': function Complex(x) {
            return x.round();
          },
          'Complex, number': function ComplexNumber(x, n) {
            if (n % 1) {
              throw new TypeError(NO_INT);
            }

            return x.round(n);
          },
          'Complex, BigNumber': function ComplexBigNumber(x, n) {
            if (!n.isInteger()) {
              throw new TypeError(NO_INT);
            }

            var _n = n.toNumber();

            return x.round(_n);
          },
          'number, BigNumber': function numberBigNumber(x, n) {
            if (!n.isInteger()) {
              throw new TypeError(NO_INT);
            }

            return new type.BigNumber(x).toDecimalPlaces(n.toNumber());
          },
          'BigNumber': function BigNumber(x) {
            return x.toDecimalPlaces(0);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, n) {
            if (!n.isInteger()) {
              throw new TypeError(NO_INT);
            }

            return x.toDecimalPlaces(n.toNumber());
          },
          'Fraction': function Fraction(x) {
            return x.round();
          },
          'Fraction, number': function FractionNumber(x, n) {
            if (n % 1) {
              throw new TypeError(NO_INT);
            }

            return x.round(n);
          },
          'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since round(0) = 0
            return deepMap(x, round, true);
          },
          'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, round, false);
          },
          'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, round, false);
          },
          'number | Complex | BigNumber, SparseMatrix': function numberComplexBigNumberSparseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) {
              // do not execute algorithm, result will be a zero matrix
              return zeros(y.size(), y.storage());
            }

            return algorithm12(y, x, round, true);
          },
          'number | Complex | BigNumber, DenseMatrix': function numberComplexBigNumberDenseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) {
              // do not execute algorithm, result will be a zero matrix
              return zeros(y.size(), y.storage());
            }

            return algorithm14(y, x, round, true);
          },
          'Array, number | BigNumber': function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, round, false).valueOf();
          },
          'number | Complex | BigNumber, Array': function numberComplexBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, round, true).valueOf();
          }
        });
        round.toTex = {
          1: "\\left\\lfloor${args[0]}\\right\\rceil",
          2: undefined // use default template

        };
        return round;
      }
      /**
       * round a number to the given number of decimals, or to zero if decimals is
       * not provided
       * @param {number} value
       * @param {number} decimals       number of decimals, between 0 and 15 (0 by default)
       * @return {number} roundedValue
       * @private
       */


      function _round(value, decimals) {
        return parseFloat(toFixed(value, decimals));
      }

      exports.name = 'round';
      exports.factory = factory;
      /***/
    },
    /* 403 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var util = __webpack_require__(151);

      var object = util.object;
      var string = util.string;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var subtract = load(__webpack_require__(196));
        var multiply = load(__webpack_require__(124));
        var unaryMinus = load(__webpack_require__(195));
        var lup = load(__webpack_require__(772));
        /**
         * Calculate the determinant of a matrix.
         *
         * Syntax:
         *
         *    math.det(x)
         *
         * Examples:
         *
         *    math.det([[1, 2], [3, 4]]) // returns -2
         *
         *    const A = [
         *      [-2, 2, 3],
         *      [-1, 1, 3],
         *      [2, 0, -1]
         *    ]
         *    math.det(A) // returns 6
         *
         * See also:
         *
         *    inv
         *
         * @param {Array | Matrix} x  A matrix
         * @return {number} The determinant of `x`
         */

        var det = typed('det', {
          'any': function any(x) {
            return object.clone(x);
          },
          'Array | Matrix': function det(x) {
            var size;

            if (type.isMatrix(x)) {
              size = x.size();
            } else if (Array.isArray(x)) {
              x = matrix(x);
              size = x.size();
            } else {
              // a scalar
              size = [];
            }

            switch (size.length) {
              case 0:
                // scalar
                return object.clone(x);

              case 1:
                // vector
                if (size[0] === 1) {
                  return object.clone(x.valueOf()[0]);
                } else {
                  throw new RangeError('Matrix must be square ' + '(size: ' + string.format(size) + ')');
                }

              case 2:
                // two dimensional array
                var rows = size[0];
                var cols = size[1];

                if (rows === cols) {
                  return _det(x.clone().valueOf(), rows, cols);
                } else {
                  throw new RangeError('Matrix must be square ' + '(size: ' + string.format(size) + ')');
                }

              default:
                // multi dimensional array
                throw new RangeError('Matrix must be two dimensional ' + '(size: ' + string.format(size) + ')');
            }
          }
        });
        det.toTex = {
          1: "\\det\\left(${args[0]}\\right)"
        };
        return det;
        /**
         * Calculate the determinant of a matrix
         * @param {Array[]} matrix  A square, two dimensional matrix
         * @param {number} rows     Number of rows of the matrix (zero-based)
         * @param {number} cols     Number of columns of the matrix (zero-based)
         * @returns {number} det
         * @private
         */

        function _det(matrix, rows, cols) {
          if (rows === 1) {
            // this is a 1 x 1 matrix
            return object.clone(matrix[0][0]);
          } else if (rows === 2) {
            // this is a 2 x 2 matrix
            // the determinant of [a11,a12;a21,a22] is det = a11*a22-a21*a12
            return subtract(multiply(matrix[0][0], matrix[1][1]), multiply(matrix[1][0], matrix[0][1]));
          } else {
            // Compute the LU decomposition
            var decomp = lup(matrix); // The determinant is the product of the diagonal entries of U (and those of L, but they are all 1)

            var _det2 = decomp.U[0][0];

            for (var _i = 1; _i < rows; _i++) {
              _det2 = multiply(_det2, decomp.U[_i][_i]);
            } // The determinant will be multiplied by 1 or -1 depending on the parity of the permutation matrix.
            // This can be determined by counting the cycles. This is roughly a linear time algorithm.


            var evenCycles = 0;
            var i = 0;
            var visited = [];

            while (true) {
              while (visited[i]) {
                i++;
              }

              if (i >= rows) break;
              var j = i;
              var cycleLen = 0;

              while (!visited[decomp.p[j]]) {
                visited[decomp.p[j]] = true;
                j = decomp.p[j];
                cycleLen++;
              }

              if (cycleLen % 2 === 0) {
                evenCycles++;
              }
            }

            return evenCycles % 2 === 0 ? _det2 : unaryMinus(_det2);
          }
        }
      }

      exports.name = 'det';
      exports.factory = factory;
      /***/
    },
    /* 404 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var DenseMatrix = type.DenseMatrix;
        /**
         * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
         * Callback function invoked NZ times (number of nonzero items in S).
         *
         *
         *          ┌  f(Sij, b)  ; S(i,j) !== 0
         * C(i,j) = ┤
         *          └  b          ; otherwise
         *
         *
         * @param {Matrix}   s                 The SparseMatrix instance (S)
         * @param {Scalar}   b                 The Scalar value
         * @param {Function} callback          The f(Aij,b) operation to invoke
         * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
         *
         * @return {Matrix}                    DenseMatrix (C)
         *
         * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
         */

        var algorithm10 = function algorithm10(s, b, callback, inverse) {
          // sparse matrix arrays
          var avalues = s._values;
          var aindex = s._index;
          var aptr = s._ptr;
          var asize = s._size;
          var adt = s._datatype; // sparse matrix cannot be a Pattern matrix

          if (!avalues) {
            throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
          } // rows & columns


          var rows = asize[0];
          var columns = asize[1]; // datatype

          var dt; // callback signature to use

          var cf = callback; // process data types

          if (typeof adt === 'string') {
            // datatype
            dt = adt; // convert b to the same datatype

            b = typed.convert(b, dt); // callback

            cf = typed.find(callback, [dt, dt]);
          } // result arrays


          var cdata = []; // matrix

          var c = new DenseMatrix({
            data: cdata,
            size: [rows, columns],
            datatype: dt
          }); // workspaces

          var x = []; // marks indicating we have a value in x for a given column

          var w = []; // loop columns

          for (var j = 0; j < columns; j++) {
            // columns mark
            var mark = j + 1; // values in j

            for (var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
              // row
              var r = aindex[k]; // update workspace

              x[r] = avalues[k];
              w[r] = mark;
            } // loop rows


            for (var i = 0; i < rows; i++) {
              // initialize C on first column
              if (j === 0) {
                // create row array
                cdata[i] = [];
              } // check sparse matrix has a value @ i,j


              if (w[i] === mark) {
                // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
              } else {
                // dense matrix value @ i, j
                cdata[i][j] = b;
              }
            }
          } // return sparse matrix


          return c;
        };

        return algorithm10;
      }

      exports.name = 'algorithm10';
      exports.factory = factory;
      /***/
    },
    /* 405 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var DimensionError = __webpack_require__(92);

      function factory(type, config, load, typed) {
        var DenseMatrix = type.DenseMatrix;
        /**
         * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
         * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
         *
         *
         *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
         * C(i,j) = ┤
         *          └  Dij          ; otherwise
         *
         *
         * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
         * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
         * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
         * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
         *
         * @return {Matrix}                    DenseMatrix (C)
         *
         * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
         */

        var algorithm01 = function algorithm01(denseMatrix, sparseMatrix, callback, inverse) {
          // dense matrix arrays
          var adata = denseMatrix._data;
          var asize = denseMatrix._size;
          var adt = denseMatrix._datatype; // sparse matrix arrays

          var bvalues = sparseMatrix._values;
          var bindex = sparseMatrix._index;
          var bptr = sparseMatrix._ptr;
          var bsize = sparseMatrix._size;
          var bdt = sparseMatrix._datatype; // validate dimensions

          if (asize.length !== bsize.length) {
            throw new DimensionError(asize.length, bsize.length);
          } // check rows & columns


          if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) {
            throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
          } // sparse matrix cannot be a Pattern matrix


          if (!bvalues) {
            throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
          } // rows & columns


          var rows = asize[0];
          var columns = asize[1]; // process data types

          var dt = typeof adt === 'string' && adt === bdt ? adt : undefined; // callback function

          var cf = dt ? typed.find(callback, [dt, dt]) : callback; // vars

          var i, j; // result (DenseMatrix)

          var cdata = []; // initialize c

          for (i = 0; i < rows; i++) {
            cdata[i] = [];
          } // workspace


          var x = []; // marks indicating we have a value in x for a given column

          var w = []; // loop columns in b

          for (j = 0; j < columns; j++) {
            // column mark
            var mark = j + 1; // values in column j

            for (var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
              // row
              i = bindex[k]; // update workspace

              x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // mark i as updated

              w[i] = mark;
            } // loop rows


            for (i = 0; i < rows; i++) {
              // check row is in workspace
              if (w[i] === mark) {
                // c[i][j] was already calculated
                cdata[i][j] = x[i];
              } else {
                // item does not exist in S
                cdata[i][j] = adata[i][j];
              }
            }
          } // return dense matrix


          return new DenseMatrix({
            data: cdata,
            size: [rows, columns],
            datatype: dt
          });
        };

        return algorithm01;
      }

      exports.name = 'algorithm01';
      exports.factory = factory;
      /***/
    },
    /* 406 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var latex = __webpack_require__(72);

      var escape = __webpack_require__(79).escape;

      var hasOwnProperty = __webpack_require__(59).hasOwnProperty;

      var getSafeProperty = __webpack_require__(88).getSafeProperty;

      function factory(type, config, load, typed, math) {
        var Node = load(__webpack_require__(87));
        /**
         * Check whether some name is a valueless unit like "inch".
         * @param {string} name
         * @return {boolean}
         */

        function isValuelessUnit(name) {
          return type.Unit ? type.Unit.isValuelessUnit(name) : false;
        }
        /**
         * @constructor SymbolNode
         * @extends {Node}
         * A symbol node can hold and resolve a symbol
         * @param {string} name
         * @extends {Node}
         */


        function SymbolNode(name) {
          if (!(this instanceof SymbolNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          } // validate input


          if (typeof name !== 'string') throw new TypeError('String expected for parameter "name"');
          this.name = name;
        }

        SymbolNode.prototype = new Node();
        SymbolNode.prototype.type = 'SymbolNode';
        SymbolNode.prototype.isSymbolNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        SymbolNode.prototype._compile = function (math, argNames) {
          var name = this.name;

          if (hasOwnProperty(argNames, name)) {
            // this is a FunctionAssignment argument
            // (like an x when inside the expression of a function assignment `f(x) = ...`)
            return function (scope, args, context) {
              return args[name];
            };
          } else if (name in math) {
            return function (scope, args, context) {
              return name in scope ? getSafeProperty(scope, name) : getSafeProperty(math, name);
            };
          } else {
            var isUnit = isValuelessUnit(name);
            return function (scope, args, context) {
              return name in scope ? getSafeProperty(scope, name) : isUnit ? new type.Unit(null, name) : undef(name);
            };
          }
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        SymbolNode.prototype.forEach = function (callback) {} // nothing to do, we don't have childs

        /**
         * Create a new SymbolNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node) : Node} callback
         * @returns {SymbolNode} Returns a clone of the node
         */
        ;

        SymbolNode.prototype.map = function (callback) {
          return this.clone();
        };
        /**
         * Throws an error 'Undefined symbol {name}'
         * @param {string} name
         */


        function undef(name) {
          throw new Error('Undefined symbol ' + name);
        }
        /**
         * Create a clone of this node, a shallow copy
         * @return {SymbolNode}
         */


        SymbolNode.prototype.clone = function () {
          return new SymbolNode(this.name);
        };
        /**
         * Get string representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        SymbolNode.prototype._toString = function (options) {
          return this.name;
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        SymbolNode.prototype.toHTML = function (options) {
          var name = escape(this.name);

          if (name === 'true' || name === 'false') {
            return '<span class="math-symbol math-boolean">' + name + '</span>';
          } else if (name === 'i') {
            return '<span class="math-symbol math-imaginary-symbol">' + name + '</span>';
          } else if (name === 'Infinity') {
            return '<span class="math-symbol math-infinity-symbol">' + name + '</span>';
          } else if (name === 'NaN') {
            return '<span class="math-symbol math-nan-symbol">' + name + '</span>';
          } else if (name === 'null') {
            return '<span class="math-symbol math-null-symbol">' + name + '</span>';
          } else if (name === 'undefined') {
            return '<span class="math-symbol math-undefined-symbol">' + name + '</span>';
          }

          return '<span class="math-symbol">' + name + '</span>';
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        SymbolNode.prototype.toJSON = function () {
          return {
            mathjs: 'SymbolNode',
            name: this.name
          };
        };
        /**
         * Instantiate a SymbolNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "SymbolNode", name: "x"}`,
         *                       where mathjs is optional
         * @returns {SymbolNode}
         */


        SymbolNode.fromJSON = function (json) {
          return new SymbolNode(json.name);
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        SymbolNode.prototype._toTex = function (options) {
          var isUnit = false;

          if (typeof math[this.name] === 'undefined' && isValuelessUnit(this.name)) {
            isUnit = true;
          }

          var symbol = latex.toSymbol(this.name, isUnit);

          if (symbol[0] === '\\') {
            // no space needed if the symbol starts with '\'
            return symbol;
          } // the space prevents symbols from breaking stuff like '\cdot' if it's written right before the symbol


          return ' ' + symbol;
        };

        return SymbolNode;
      }

      exports.name = 'SymbolNode';
      exports.path = 'expression.node';
      exports.math = true; // request access to the math namespace as 5th argument of the factory function

      exports.factory = factory;
      /***/
    },
    /* 407 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var number = __webpack_require__(67);

      function factory(type, config, load, typed) {
        /**
         * Create a range. A range has a start, step, and end, and contains functions
         * to iterate over the range.
         *
         * A range can be constructed as:
         *
         *     const range = new Range(start, end)
         *     const range = new Range(start, end, step)
         *
         * To get the result of the range:
         *     range.forEach(function (x) {
         *         console.log(x)
         *     })
         *     range.map(function (x) {
         *         return math.sin(x)
         *     })
         *     range.toArray()
         *
         * Example usage:
         *
         *     const c = new Range(2, 6)       // 2:1:5
         *     c.toArray()                     // [2, 3, 4, 5]
         *     const d = new Range(2, -3, -1)  // 2:-1:-2
         *     d.toArray()                     // [2, 1, 0, -1, -2]
         *
         * @class Range
         * @constructor Range
         * @param {number} start  included lower bound
         * @param {number} end    excluded upper bound
         * @param {number} [step] step size, default value is 1
         */
        function Range(start, end, step) {
          if (!(this instanceof Range)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          var hasStart = start !== null && start !== undefined;
          var hasEnd = end !== null && end !== undefined;
          var hasStep = step !== null && step !== undefined;

          if (hasStart) {
            if (type.isBigNumber(start)) {
              start = start.toNumber();
            } else if (typeof start !== 'number') {
              throw new TypeError('Parameter start must be a number');
            }
          }

          if (hasEnd) {
            if (type.isBigNumber(end)) {
              end = end.toNumber();
            } else if (typeof end !== 'number') {
              throw new TypeError('Parameter end must be a number');
            }
          }

          if (hasStep) {
            if (type.isBigNumber(step)) {
              step = step.toNumber();
            } else if (typeof step !== 'number') {
              throw new TypeError('Parameter step must be a number');
            }
          }

          this.start = hasStart ? parseFloat(start) : 0;
          this.end = hasEnd ? parseFloat(end) : 0;
          this.step = hasStep ? parseFloat(step) : 1;
        }
        /**
         * Attach type information
         */


        Range.prototype.type = 'Range';
        Range.prototype.isRange = true;
        /**
         * Parse a string into a range,
         * The string contains the start, optional step, and end, separated by a colon.
         * If the string does not contain a valid range, null is returned.
         * For example str='0:2:11'.
         * @memberof Range
         * @param {string} str
         * @return {Range | null} range
         */

        Range.parse = function (str) {
          if (typeof str !== 'string') {
            return null;
          }

          var args = str.split(':');
          var nums = args.map(function (arg) {
            return parseFloat(arg);
          });
          var invalid = nums.some(function (num) {
            return isNaN(num);
          });

          if (invalid) {
            return null;
          }

          switch (nums.length) {
            case 2:
              return new Range(nums[0], nums[1]);

            case 3:
              return new Range(nums[0], nums[2], nums[1]);

            default:
              return null;
          }
        };
        /**
         * Create a clone of the range
         * @return {Range} clone
         */


        Range.prototype.clone = function () {
          return new Range(this.start, this.end, this.step);
        };
        /**
         * Retrieve the size of the range.
         * Returns an array containing one number, the number of elements in the range.
         * @memberof Range
         * @returns {number[]} size
         */


        Range.prototype.size = function () {
          var len = 0;
          var start = this.start;
          var step = this.step;
          var end = this.end;
          var diff = end - start;

          if (number.sign(step) === number.sign(diff)) {
            len = Math.ceil(diff / step);
          } else if (diff === 0) {
            len = 0;
          }

          if (isNaN(len)) {
            len = 0;
          }

          return [len];
        };
        /**
         * Calculate the minimum value in the range
         * @memberof Range
         * @return {number | undefined} min
         */


        Range.prototype.min = function () {
          var size = this.size()[0];

          if (size > 0) {
            if (this.step > 0) {
              // positive step
              return this.start;
            } else {
              // negative step
              return this.start + (size - 1) * this.step;
            }
          } else {
            return undefined;
          }
        };
        /**
         * Calculate the maximum value in the range
         * @memberof Range
         * @return {number | undefined} max
         */


        Range.prototype.max = function () {
          var size = this.size()[0];

          if (size > 0) {
            if (this.step > 0) {
              // positive step
              return this.start + (size - 1) * this.step;
            } else {
              // negative step
              return this.start;
            }
          } else {
            return undefined;
          }
        };
        /**
         * Execute a callback function for each value in the range.
         * @memberof Range
         * @param {function} callback   The callback method is invoked with three
         *                              parameters: the value of the element, the index
         *                              of the element, and the Range being traversed.
         */


        Range.prototype.forEach = function (callback) {
          var x = this.start;
          var step = this.step;
          var end = this.end;
          var i = 0;

          if (step > 0) {
            while (x < end) {
              callback(x, [i], this);
              x += step;
              i++;
            }
          } else if (step < 0) {
            while (x > end) {
              callback(x, [i], this);
              x += step;
              i++;
            }
          }
        };
        /**
         * Execute a callback function for each value in the Range, and return the
         * results as an array
         * @memberof Range
         * @param {function} callback   The callback method is invoked with three
         *                              parameters: the value of the element, the index
         *                              of the element, and the Matrix being traversed.
         * @returns {Array} array
         */


        Range.prototype.map = function (callback) {
          var array = [];
          this.forEach(function (value, index, obj) {
            array[index[0]] = callback(value, index, obj);
          });
          return array;
        };
        /**
         * Create an Array with a copy of the Ranges data
         * @memberof Range
         * @returns {Array} array
         */


        Range.prototype.toArray = function () {
          var array = [];
          this.forEach(function (value, index) {
            array[index[0]] = value;
          });
          return array;
        };
        /**
         * Get the primitive value of the Range, a one dimensional array
         * @memberof Range
         * @returns {Array} array
         */


        Range.prototype.valueOf = function () {
          // TODO: implement a caching mechanism for range.valueOf()
          return this.toArray();
        };
        /**
         * Get a string representation of the range, with optional formatting options.
         * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
         * @memberof Range
         * @param {Object | number | function} [options]  Formatting options. See
         *                                                lib/utils/number:format for a
         *                                                description of the available
         *                                                options.
         * @returns {string} str
         */


        Range.prototype.format = function (options) {
          var str = number.format(this.start, options);

          if (this.step !== 1) {
            str += ':' + number.format(this.step, options);
          }

          str += ':' + number.format(this.end, options);
          return str;
        };
        /**
         * Get a string representation of the range.
         * @memberof Range
         * @returns {string}
         */


        Range.prototype.toString = function () {
          return this.format();
        };
        /**
         * Get a JSON representation of the range
         * @memberof Range
         * @returns {Object} Returns a JSON object structured as:
         *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
         */


        Range.prototype.toJSON = function () {
          return {
            mathjs: 'Range',
            start: this.start,
            end: this.end,
            step: this.step
          };
        };
        /**
         * Instantiate a Range from a JSON object
         * @memberof Range
         * @param {Object} json A JSON object structured as:
         *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
         * @return {Range}
         */


        Range.fromJSON = function (json) {
          return new Range(json.start, json.end, json.step);
        };

        return Range;
      }

      exports.name = 'Range';
      exports.path = 'type';
      exports.factory = factory;
      /***/
    },
    /* 408 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var IndexError = __webpack_require__(198);
      /**
       * Transform zero-based indices to one-based indices in errors
       * @param {Error} err
       * @returns {Error} Returns the transformed error
       */


      exports.transform = function (err) {
        if (err && err.isIndexError) {
          return new IndexError(err.index + 1, err.min + 1, err.max !== undefined ? err.max + 1 : undefined);
        }

        return err;
      };
      /***/

    },
    /* 409 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      var errorTransform = __webpack_require__(408).transform;

      var getSafeProperty = __webpack_require__(88).getSafeProperty;

      function factory(type, config, load, typed) {
        var subset = load(__webpack_require__(305));
        /**
         * Retrieve part of an object:
         *
         * - Retrieve a property from an object
         * - Retrieve a part of a string
         * - Retrieve a matrix subset
         *
         * @param {Object | Array | Matrix | string} object
         * @param {Index} index
         * @return {Object | Array | Matrix | string} Returns the subset
         */

        return function access(object, index) {
          try {
            if (Array.isArray(object)) {
              return subset(object, index);
            } else if (object && typeof object.subset === 'function') {
              // Matrix
              return object.subset(index);
            } else if (typeof object === 'string') {
              // TODO: move getStringSubset into a separate util file, use that
              return subset(object, index);
            } else if (_typeof(object) === 'object') {
              if (!index.isObjectProperty()) {
                throw new TypeError('Cannot apply a numeric index as object property');
              }

              return getSafeProperty(object, index.getObjectProperty());
            } else {
              throw new TypeError('Cannot apply index: unsupported type of object');
            }
          } catch (err) {
            throw errorTransform(err);
          }
        };
      }

      exports.factory = factory;
      /***/
    },
    /* 410 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // Reserved keywords not allowed to use in the parser

      module.exports = {
        end: true
      };
      /***/
    },
    /* 411 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        /**
         * Create a fraction convert a value to a fraction.
         *
         * Syntax:
         *     math.fraction(numerator, denominator)
         *     math.fraction({n: numerator, d: denominator})
         *     math.fraction(matrix: Array | Matrix)         Turn all matrix entries
         *                                                   into fractions
         *
         * Examples:
         *
         *     math.fraction(1, 3)
         *     math.fraction('2/3')
         *     math.fraction({n: 2, d: 3})
         *     math.fraction([0.2, 0.25, 1.25])
         *
         * See also:
         *
         *    bignumber, number, string, unit
         *
         * @param {number | string | Fraction | BigNumber | Array | Matrix} [args]
         *            Arguments specifying the numerator and denominator of
         *            the fraction
         * @return {Fraction | Array | Matrix} Returns a fraction
         */
        var fraction = typed('fraction', {
          'number': function number(x) {
            if (!isFinite(x) || isNaN(x)) {
              throw new Error(x + ' cannot be represented as a fraction');
            }

            return new type.Fraction(x);
          },
          'string': function string(x) {
            return new type.Fraction(x);
          },
          'number, number': function numberNumber(numerator, denominator) {
            return new type.Fraction(numerator, denominator);
          },
          'null': function _null(x) {
            return new type.Fraction(0);
          },
          'BigNumber': function BigNumber(x) {
            return new type.Fraction(x.toString());
          },
          'Fraction': function Fraction(x) {
            return x; // fractions are immutable
          },
          'Object': function Object(x) {
            return new type.Fraction(x);
          },
          'Array | Matrix': function ArrayMatrix(x) {
            return deepMap(x, fraction);
          }
        });
        return fraction;
      }

      exports.name = 'fraction';
      exports.factory = factory;
      /***/
    },
    /* 412 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var getTypeOf = load(__webpack_require__(131));
        var validInputTypes = {
          'string': true,
          'number': true,
          'BigNumber': true,
          'Fraction': true // Load the conversion functions for each output type

        };
        var validOutputTypes = {
          'number': load(__webpack_require__(306)),
          'BigNumber': load(__webpack_require__(794)),
          'Fraction': load(__webpack_require__(411))
          /**
           * Convert a numeric value to a specific type: number, BigNumber, or Fraction
           *
           * @param {string | number | BigNumber | Fraction } value
           * @param {'number' | 'BigNumber' | 'Fraction'} outputType
           * @return {number | BigNumber | Fraction} Returns an instance of the
           *                                         numeric in the requested type
           */

        };

        var numeric = function numeric(value, outputType) {
          var inputType = getTypeOf(value);

          if (!(inputType in validInputTypes)) {
            throw new TypeError('Cannot convert ' + value + ' of type "' + inputType + '"; valid input types are ' + Object.keys(validInputTypes).join(', '));
          }

          if (!(outputType in validOutputTypes)) {
            throw new TypeError('Cannot convert ' + value + ' to type "' + outputType + '"; valid output types are ' + Object.keys(validOutputTypes).join(', '));
          }

          if (outputType === inputType) {
            return value;
          } else {
            return validOutputTypes[outputType](value);
          }
        };

        numeric.toTex = function (node, options) {
          // Not sure if this is strictly right but should work correctly for the vast majority of use cases.
          return node.args[0].toTex();
        };

        return numeric;
      } // FIXME: expose numeric in the math namespace after we've decided on a name and have written proper docs for this function. See https://github.com/josdejong/mathjs/pull/1270
      // exports.name = 'type._numeric'


      exports.path = 'type';
      exports.name = '_numeric';
      exports.factory = factory;
      /***/
    },
    /* 413 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var Emitter = __webpack_require__(799);
      /**
       * Extend given object with emitter functions `on`, `off`, `once`, `emit`
       * @param {Object} obj
       * @return {Object} obj
       */


      exports.mixin = function (obj) {
        // create event emitter
        var emitter = new Emitter(); // bind methods to obj (we don't want to expose the emitter.e Array...)

        obj.on = emitter.on.bind(emitter);
        obj.off = emitter.off.bind(emitter);
        obj.once = emitter.once.bind(emitter);
        obj.emit = emitter.emit.bind(emitter);
        return obj;
      };
      /***/

    },
    /* 414 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var replace = String.prototype.replace;
      var percentTwenties = /%20/g;
      module.exports = {
        'default': 'RFC3986',
        formatters: {
          RFC1738: function RFC1738(value) {
            return replace.call(value, percentTwenties, '+');
          },
          RFC3986: function RFC3986(value) {
            return value;
          }
        },
        RFC1738: 'RFC1738',
        RFC3986: 'RFC3986'
      };
      /***/
    },
    /* 415 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var has = Object.prototype.hasOwnProperty;
      var isArray = Array.isArray;

      var hexTable = function () {
        var array = [];

        for (var i = 0; i < 256; ++i) {
          array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
        }

        return array;
      }();

      var compactQueue = function compactQueue(queue) {
        while (queue.length > 1) {
          var item = queue.pop();
          var obj = item.obj[item.prop];

          if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
              if (typeof obj[j] !== 'undefined') {
                compacted.push(obj[j]);
              }
            }

            item.obj[item.prop] = compacted;
          }
        }
      };

      var arrayToObject = function arrayToObject(source, options) {
        var obj = options && options.plainObjects ? Object.create(null) : {};

        for (var i = 0; i < source.length; ++i) {
          if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
          }
        }

        return obj;
      };

      var merge = function merge(target, source, options) {
        if (!source) {
          return target;
        }

        if (typeof source !== 'object') {
          if (isArray(target)) {
            target.push(source);
          } else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
              target[source] = true;
            }
          } else {
            return [target, source];
          }

          return target;
        }

        if (!target || typeof target !== 'object') {
          return [target].concat(source);
        }

        var mergeTarget = target;

        if (isArray(target) && !isArray(source)) {
          mergeTarget = arrayToObject(target, options);
        }

        if (isArray(target) && isArray(source)) {
          source.forEach(function (item, i) {
            if (has.call(target, i)) {
              var targetItem = target[i];

              if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                target[i] = merge(targetItem, item, options);
              } else {
                target.push(item);
              }
            } else {
              target[i] = item;
            }
          });
          return target;
        }

        return Object.keys(source).reduce(function (acc, key) {
          var value = source[key];

          if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
          } else {
            acc[key] = value;
          }

          return acc;
        }, mergeTarget);
      };

      var assign = function assignSingleSource(target, source) {
        return Object.keys(source).reduce(function (acc, key) {
          acc[key] = source[key];
          return acc;
        }, target);
      };

      var decode = function decode(str, decoder, charset) {
        var strWithoutPlus = str.replace(/\+/g, ' ');

        if (charset === 'iso-8859-1') {
          // unescape never throws, no try...catch needed:
          return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
        } // utf-8


        try {
          return decodeURIComponent(strWithoutPlus);
        } catch (e) {
          return strWithoutPlus;
        }
      };

      var encode = function encode(str, defaultEncoder, charset) {
        // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
        // It has been adapted here for stricter adherence to RFC 3986
        if (str.length === 0) {
          return str;
        }

        var string = typeof str === 'string' ? str : String(str);

        if (charset === 'iso-8859-1') {
          return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
          });
        }

        var out = '';

        for (var i = 0; i < string.length; ++i) {
          var c = string.charCodeAt(i);

          if (c === 0x2D // -
          || c === 0x2E // .
          || c === 0x5F // _
          || c === 0x7E // ~
          || c >= 0x30 && c <= 0x39 // 0-9
          || c >= 0x41 && c <= 0x5A // a-z
          || c >= 0x61 && c <= 0x7A // A-Z
          ) {
              out += string.charAt(i);
              continue;
            }

          if (c < 0x80) {
            out = out + hexTable[c];
            continue;
          }

          if (c < 0x800) {
            out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
            continue;
          }

          if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
            continue;
          }

          i += 1;
          c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
          out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
        }

        return out;
      };

      var compact = function compact(value) {
        var queue = [{
          obj: {
            o: value
          },
          prop: 'o'
        }];
        var refs = [];

        for (var i = 0; i < queue.length; ++i) {
          var item = queue[i];
          var obj = item.obj[item.prop];
          var keys = Object.keys(obj);

          for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];

            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
              queue.push({
                obj: obj,
                prop: key
              });
              refs.push(val);
            }
          }
        }

        compactQueue(queue);
        return value;
      };

      var isRegExp = function isRegExp(obj) {
        return Object.prototype.toString.call(obj) === '[object RegExp]';
      };

      var isBuffer = function isBuffer(obj) {
        if (!obj || typeof obj !== 'object') {
          return false;
        }

        return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
      };

      var combine = function combine(a, b) {
        return [].concat(a, b);
      };

      module.exports = {
        arrayToObject: arrayToObject,
        assign: assign,
        combine: combine,
        compact: compact,
        decode: decode,
        encode: encode,
        isBuffer: isBuffer,
        isRegExp: isRegExp,
        merge: merge
      };
      /***/
    },
    /* 416 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * A `Cancel` is an object that is thrown when an operation is canceled.
       *
       * @class
       * @param {string=} message The message.
       */

      function Cancel(message) {
        this.message = message;
      }

      Cancel.prototype.toString = function toString() {
        return 'Cancel' + (this.message ? ': ' + this.message : '');
      };

      Cancel.prototype.__CANCEL__ = true;
      module.exports = Cancel;
      /***/
    },
    /* 417 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      module.exports = function isCancel(value) {
        return !!(value && value.__CANCEL__);
      };
      /***/

    },
    /* 418 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var enhanceError = __webpack_require__(820);
      /**
       * Create an Error with the specified message, config, error code, request and response.
       *
       * @param {string} message The error message.
       * @param {Object} config The config.
       * @param {string} [code] The error code (for example, 'ECONNABORTED').
       * @param {Object} [request] The request.
       * @param {Object} [response] The response.
       * @returns {Error} The created error.
       */


      module.exports = function createError(message, config, code, request, response) {
        var error = new Error(message);
        return enhanceError(error, config, code, request, response);
      };
      /***/

    },
    /* 419 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(101);

      var settle = __webpack_require__(821);

      var buildURL = __webpack_require__(819);

      var parseHeaders = __webpack_require__(818);

      var isURLSameOrigin = __webpack_require__(817);

      var createError = __webpack_require__(418);

      var btoa = typeof window !== 'undefined' && window.btoa && window.btoa.bind(window) || __webpack_require__(816);

      module.exports = function xhrAdapter(config) {
        return new Promise(function dispatchXhrRequest(resolve, reject) {
          var requestData = config.data;
          var requestHeaders = config.headers;

          if (utils.isFormData(requestData)) {
            delete requestHeaders['Content-Type']; // Let the browser set it
          }

          var request = new XMLHttpRequest();
          var loadEvent = 'onreadystatechange';
          var xDomain = false; // For IE 8/9 CORS support
          // Only supports POST and GET calls and doesn't returns the response headers.
          // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.

          if ("production" !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
            request = new window.XDomainRequest();
            loadEvent = 'onload';
            xDomain = true;

            request.onprogress = function handleProgress() {};

            request.ontimeout = function handleTimeout() {};
          } // HTTP basic authentication


          if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password || '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
          }

          request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true); // Set the request timeout in MS

          request.timeout = config.timeout; // Listen for ready state

          request[loadEvent] = function handleLoad() {
            if (!request || request.readyState !== 4 && !xDomain) {
              return;
            } // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request


            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
              return;
            } // Prepare the response


            var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
              data: responseData,
              // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
              status: request.status === 1223 ? 204 : request.status,
              statusText: request.status === 1223 ? 'No Content' : request.statusText,
              headers: responseHeaders,
              config: config,
              request: request
            };
            settle(resolve, reject, response); // Clean up request

            request = null;
          }; // Handle low level network errors


          request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(createError('Network Error', config, null, request)); // Clean up request

            request = null;
          }; // Handle timeout


          request.ontimeout = function handleTimeout() {
            reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request)); // Clean up request

            request = null;
          }; // Add xsrf header
          // This is only done if running in a standard browser environment.
          // Specifically not if we're in a web worker, or react-native.


          if (utils.isStandardBrowserEnv()) {
            var cookies = __webpack_require__(815); // Add xsrf header


            var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

            if (xsrfValue) {
              requestHeaders[config.xsrfHeaderName] = xsrfValue;
            }
          } // Add headers to the request


          if ('setRequestHeader' in request) {
            utils.forEach(requestHeaders, function setRequestHeader(val, key) {
              if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
                // Remove Content-Type if data is undefined
                delete requestHeaders[key];
              } else {
                // Otherwise add header to the request
                request.setRequestHeader(key, val);
              }
            });
          } // Add withCredentials to request if needed


          if (config.withCredentials) {
            request.withCredentials = true;
          } // Add responseType to request if needed


          if (config.responseType) {
            try {
              request.responseType = config.responseType;
            } catch (e) {
              // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
              // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
              if (config.responseType !== 'json') {
                throw e;
              }
            }
          } // Handle progress if needed


          if (typeof config.onDownloadProgress === 'function') {
            request.addEventListener('progress', config.onDownloadProgress);
          } // Not all browsers support upload events


          if (typeof config.onUploadProgress === 'function' && request.upload) {
            request.upload.addEventListener('progress', config.onUploadProgress);
          }

          if (config.cancelToken) {
            // Handle cancellation
            config.cancelToken.promise.then(function onCanceled(cancel) {
              if (!request) {
                return;
              }

              request.abort();
              reject(cancel); // Clean up request

              request = null;
            });
          }

          if (requestData === undefined) {
            requestData = null;
          } // Send the request


          request.send(requestData);
        });
      };
      /***/

    },
    /* 420 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      module.exports = function bind(fn, thisArg) {
        return function wrap() {
          var args = new Array(arguments.length);

          for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i];
          }

          return fn.apply(thisArg, args);
        };
      };
      /***/

    },
    /* 421 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports["default"] = {
        DATE_ROW_COUNT: 6,
        DATE_COL_COUNT: 7
      };
      module.exports = exports['default'];
      /***/
    },
    /* 422 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _Header = __webpack_require__(841);

      var _Header2 = _interopRequireDefault(_Header);

      var _Combobox = __webpack_require__(840);

      var _Combobox2 = _interopRequireDefault(_Combobox);

      var _moment = __webpack_require__(14);

      var _moment2 = _interopRequireDefault(_moment);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function noop() {}

      function generateOptions(length, disabledOptions, hideDisabledOptions) {
        var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var arr = [];

        for (var value = 0; value < length; value += step) {
          if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
            arr.push(value);
          }
        }

        return arr;
      }

      var Panel = function (_Component) {
        (0, _inherits3['default'])(Panel, _Component);

        function Panel(props) {
          (0, _classCallCheck3['default'])(this, Panel);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));

          _this.onChange = function (newValue) {
            _this.setState({
              value: newValue
            });

            _this.props.onChange(newValue);
          };

          _this.onCurrentSelectPanelChange = function (currentSelectPanel) {
            _this.setState({
              currentSelectPanel: currentSelectPanel
            });
          };

          _this.disabledHours = function () {
            var _this$props = _this.props,
                use12Hours = _this$props.use12Hours,
                disabledHours = _this$props.disabledHours;
            var disabledOptions = disabledHours();

            if (use12Hours && Array.isArray(disabledOptions)) {
              if (_this.isAM()) {
                disabledOptions = disabledOptions.filter(function (h) {
                  return h < 12;
                }).map(function (h) {
                  return h === 0 ? 12 : h;
                });
              } else {
                disabledOptions = disabledOptions.map(function (h) {
                  return h === 12 ? 12 : h - 12;
                });
              }
            }

            return disabledOptions;
          };

          _this.state = {
            value: props.value,
            selectionRange: []
          };
          return _this;
        }

        (0, _createClass3['default'])(Panel, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var value = nextProps.value;

            if (value) {
              this.setState({
                value: value
              });
            }
          }
        }, {
          key: 'close',
          // https://github.com/ant-design/ant-design/issues/5829
          value: function close() {
            this.props.onEsc();
          }
        }, {
          key: 'isAM',
          value: function isAM() {
            var value = this.state.value || this.props.defaultOpenValue;
            return value.hour() >= 0 && value.hour() < 12;
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                placeholder = _props.placeholder,
                disabledMinutes = _props.disabledMinutes,
                disabledSeconds = _props.disabledSeconds,
                hideDisabledOptions = _props.hideDisabledOptions,
                allowEmpty = _props.allowEmpty,
                showHour = _props.showHour,
                showMinute = _props.showMinute,
                showSecond = _props.showSecond,
                format = _props.format,
                defaultOpenValue = _props.defaultOpenValue,
                clearText = _props.clearText,
                onEsc = _props.onEsc,
                addon = _props.addon,
                use12Hours = _props.use12Hours,
                onClear = _props.onClear,
                focusOnOpen = _props.focusOnOpen,
                onKeyDown = _props.onKeyDown,
                hourStep = _props.hourStep,
                minuteStep = _props.minuteStep,
                secondStep = _props.secondStep,
                inputReadOnly = _props.inputReadOnly;
            var _state = this.state,
                value = _state.value,
                currentSelectPanel = _state.currentSelectPanel;
            var disabledHourOptions = this.disabledHours();
            var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
            var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
            var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
            var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
            var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
            return _react2['default'].createElement('div', {
              className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-inner', true), (0, _defineProperty3['default'])(_classNames, className, !!className), _classNames))
            }, _react2['default'].createElement(_Header2['default'], {
              clearText: clearText,
              prefixCls: prefixCls,
              defaultOpenValue: defaultOpenValue,
              value: value,
              currentSelectPanel: currentSelectPanel,
              onEsc: onEsc,
              format: format,
              placeholder: placeholder,
              hourOptions: hourOptions,
              minuteOptions: minuteOptions,
              secondOptions: secondOptions,
              disabledHours: this.disabledHours,
              disabledMinutes: disabledMinutes,
              disabledSeconds: disabledSeconds,
              onChange: this.onChange,
              onClear: onClear,
              allowEmpty: allowEmpty,
              focusOnOpen: focusOnOpen,
              onKeyDown: onKeyDown,
              inputReadOnly: inputReadOnly
            }), _react2['default'].createElement(_Combobox2['default'], {
              prefixCls: prefixCls,
              value: value,
              defaultOpenValue: defaultOpenValue,
              format: format,
              onChange: this.onChange,
              showHour: showHour,
              showMinute: showMinute,
              showSecond: showSecond,
              hourOptions: hourOptions,
              minuteOptions: minuteOptions,
              secondOptions: secondOptions,
              disabledHours: this.disabledHours,
              disabledMinutes: disabledMinutes,
              disabledSeconds: disabledSeconds,
              onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
              use12Hours: use12Hours,
              isAM: this.isAM()
            }), addon(this));
          }
        }]);
        return Panel;
      }(_react.Component);

      Panel.propTypes = {
        clearText: _propTypes2['default'].string,
        prefixCls: _propTypes2['default'].string,
        className: _propTypes2['default'].string,
        defaultOpenValue: _propTypes2['default'].object,
        value: _propTypes2['default'].object,
        placeholder: _propTypes2['default'].string,
        format: _propTypes2['default'].string,
        inputReadOnly: _propTypes2['default'].bool,
        disabledHours: _propTypes2['default'].func,
        disabledMinutes: _propTypes2['default'].func,
        disabledSeconds: _propTypes2['default'].func,
        hideDisabledOptions: _propTypes2['default'].bool,
        onChange: _propTypes2['default'].func,
        onEsc: _propTypes2['default'].func,
        allowEmpty: _propTypes2['default'].bool,
        showHour: _propTypes2['default'].bool,
        showMinute: _propTypes2['default'].bool,
        showSecond: _propTypes2['default'].bool,
        onClear: _propTypes2['default'].func,
        use12Hours: _propTypes2['default'].bool,
        hourStep: _propTypes2['default'].number,
        minuteStep: _propTypes2['default'].number,
        secondStep: _propTypes2['default'].number,
        addon: _propTypes2['default'].func,
        focusOnOpen: _propTypes2['default'].bool,
        onKeyDown: _propTypes2['default'].func
      };
      Panel.defaultProps = {
        prefixCls: 'rc-time-picker-panel',
        onChange: noop,
        onClear: noop,
        disabledHours: noop,
        disabledMinutes: noop,
        disabledSeconds: noop,
        defaultOpenValue: (0, _moment2['default'])(),
        use12Hours: false,
        addon: noop,
        onKeyDown: noop,
        inputReadOnly: false
      };
      exports['default'] = Panel;
      module.exports = exports['default'];
      /***/
    },
    /* 423 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _en_US = __webpack_require__(446);

      var _en_US2 = _interopRequireDefault(_en_US);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function noop() {}

      exports['default'] = {
        propTypes: {
          className: _propTypes2['default'].string,
          locale: _propTypes2['default'].object,
          style: _propTypes2['default'].object,
          visible: _propTypes2['default'].bool,
          onSelect: _propTypes2['default'].func,
          prefixCls: _propTypes2['default'].string,
          onChange: _propTypes2['default'].func,
          onOk: _propTypes2['default'].func
        },
        getDefaultProps: function getDefaultProps() {
          return {
            locale: _en_US2['default'],
            style: {},
            visible: true,
            prefixCls: 'rc-calendar',
            className: '',
            onSelect: noop,
            onChange: noop,
            onClear: noop,
            renderFooter: function renderFooter() {
              return null;
            },
            renderSidebar: function renderSidebar() {
              return null;
            }
          };
        },
        shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
          return this.props.visible || nextProps.visible;
        },
        getFormat: function getFormat() {
          var format = this.props.format;
          var _props = this.props,
              locale = _props.locale,
              timePicker = _props.timePicker;

          if (!format) {
            if (timePicker) {
              format = locale.dateTimeFormat;
            } else {
              format = locale.dateFormat;
            }
          }

          return format;
        },
        focus: function focus() {
          if (this.rootInstance) {
            this.rootInstance.focus();
          }
        },
        saveRoot: function saveRoot(root) {
          this.rootInstance = root;
        }
      };
      module.exports = exports['default'];
      /***/
    },
    /* 424 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports['default'] = TimePickerButton;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _classnames2 = __webpack_require__(3);

      var _classnames3 = _interopRequireDefault(_classnames2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function TimePickerButton(_ref) {
        var _classnames;

        var prefixCls = _ref.prefixCls,
            locale = _ref.locale,
            showTimePicker = _ref.showTimePicker,
            onOpenTimePicker = _ref.onOpenTimePicker,
            onCloseTimePicker = _ref.onCloseTimePicker,
            timePickerDisabled = _ref.timePickerDisabled;
        var className = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
        var onClick = null;

        if (!timePickerDisabled) {
          onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
        }

        return _react2['default'].createElement('a', {
          className: className,
          role: 'button',
          onClick: onClick
        }, showTimePicker ? locale.dateSelect : locale.timeSelect);
      }

      module.exports = exports['default'];
      /***/
    },
    /* 425 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports["default"] = OkButton;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          "default": obj
        };
      }

      function OkButton(_ref) {
        var prefixCls = _ref.prefixCls,
            locale = _ref.locale,
            okDisabled = _ref.okDisabled,
            onOk = _ref.onOk;
        var className = prefixCls + "-ok-btn";

        if (okDisabled) {
          className += " " + prefixCls + "-ok-btn-disabled";
        }

        return _react2["default"].createElement("a", {
          className: className,
          role: "button",
          onClick: okDisabled ? null : onOk
        }, locale.ok);
      }

      module.exports = exports['default'];
      /***/
    },
    /* 426 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports['default'] = TodayButton;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _util = __webpack_require__(172);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function TodayButton(_ref) {
        var prefixCls = _ref.prefixCls,
            locale = _ref.locale,
            value = _ref.value,
            timePicker = _ref.timePicker,
            disabled = _ref.disabled,
            disabledDate = _ref.disabledDate,
            onToday = _ref.onToday,
            text = _ref.text;
        var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
        var disabledToday = disabledDate && !(0, _util.isAllowedDate)((0, _util.getTodayTime)(value), disabledDate);
        var isDisabled = disabledToday || disabled;
        var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
        return _react2['default'].createElement('a', {
          className: prefixCls + '-today-btn ' + disabledTodayClass,
          role: 'button',
          onClick: isDisabled ? null : onToday,
          title: (0, _util.getTodayTimeStr)(value)
        }, localeNow);
      }

      module.exports = exports['default'];
      /***/
    },
    /* 427 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports['default'] = mapSelf;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function mirror(o) {
        return o;
      }

      function mapSelf(children) {
        // return ReactFragment
        return _react2['default'].Children.map(children, mirror);
      }

      module.exports = exports['default'];
      /***/
    },
    /* 428 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _createReactClass = __webpack_require__(32);

      var _createReactClass2 = _interopRequireDefault(_createReactClass);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _mapSelf = __webpack_require__(427);

      var _mapSelf2 = _interopRequireDefault(_mapSelf);

      var _MonthPanel = __webpack_require__(851);

      var _MonthPanel2 = _interopRequireDefault(_MonthPanel);

      var _YearPanel = __webpack_require__(849);

      var _YearPanel2 = _interopRequireDefault(_YearPanel);

      var _DecadePanel = __webpack_require__(848);

      var _DecadePanel2 = _interopRequireDefault(_DecadePanel);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function goMonth(direction) {
        var next = this.props.value.clone();
        next.add(direction, 'months');
        this.props.onValueChange(next);
      }

      function goYear(direction) {
        var next = this.props.value.clone();
        next.add(direction, 'years');
        this.props.onValueChange(next);
      }

      function showIf(condition, el) {
        return condition ? el : null;
      }

      var CalendarHeader = (0, _createReactClass2['default'])({
        displayName: 'CalendarHeader',
        propTypes: {
          prefixCls: _propTypes2['default'].string,
          value: _propTypes2['default'].object,
          onValueChange: _propTypes2['default'].func,
          showTimePicker: _propTypes2['default'].bool,
          onPanelChange: _propTypes2['default'].func,
          locale: _propTypes2['default'].object,
          enablePrev: _propTypes2['default'].any,
          enableNext: _propTypes2['default'].any,
          disabledMonth: _propTypes2['default'].func
        },
        getDefaultProps: function getDefaultProps() {
          return {
            enableNext: 1,
            enablePrev: 1,
            onPanelChange: function onPanelChange() {},
            onValueChange: function onValueChange() {}
          };
        },
        getInitialState: function getInitialState() {
          this.nextMonth = goMonth.bind(this, 1);
          this.previousMonth = goMonth.bind(this, -1);
          this.nextYear = goYear.bind(this, 1);
          this.previousYear = goYear.bind(this, -1);
          return {
            yearPanelReferer: null
          };
        },
        onMonthSelect: function onMonthSelect(value) {
          this.props.onPanelChange(value, 'date');

          if (this.props.onMonthSelect) {
            this.props.onMonthSelect(value);
          } else {
            this.props.onValueChange(value);
          }
        },
        onYearSelect: function onYearSelect(value) {
          var referer = this.state.yearPanelReferer;
          this.setState({
            yearPanelReferer: null
          });
          this.props.onPanelChange(value, referer);
          this.props.onValueChange(value);
        },
        onDecadeSelect: function onDecadeSelect(value) {
          this.props.onPanelChange(value, 'year');
          this.props.onValueChange(value);
        },
        monthYearElement: function monthYearElement(showTimePicker) {
          var _this = this;

          var props = this.props;
          var prefixCls = props.prefixCls;
          var locale = props.locale;
          var value = props.value;
          var localeData = value.localeData();
          var monthBeforeYear = locale.monthBeforeYear;
          var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');

          var year = _react2['default'].createElement('a', {
            className: prefixCls + '-year-select',
            role: 'button',
            onClick: showTimePicker ? null : function () {
              return _this.showYearPanel('date');
            },
            title: locale.yearSelect
          }, value.format(locale.yearFormat));

          var month = _react2['default'].createElement('a', {
            className: prefixCls + '-month-select',
            role: 'button',
            onClick: showTimePicker ? null : this.showMonthPanel,
            title: locale.monthSelect
          }, locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value));

          var day = void 0;

          if (showTimePicker) {
            day = _react2['default'].createElement('a', {
              className: prefixCls + '-day-select',
              role: 'button'
            }, value.format(locale.dayFormat));
          }

          var my = [];

          if (monthBeforeYear) {
            my = [month, day, year];
          } else {
            my = [year, month, day];
          }

          return _react2['default'].createElement('span', {
            className: selectClassName
          }, (0, _mapSelf2['default'])(my));
        },
        showMonthPanel: function showMonthPanel() {
          // null means that users' interaction doesn't change value
          this.props.onPanelChange(null, 'month');
        },
        showYearPanel: function showYearPanel(referer) {
          this.setState({
            yearPanelReferer: referer
          });
          this.props.onPanelChange(null, 'year');
        },
        showDecadePanel: function showDecadePanel() {
          this.props.onPanelChange(null, 'decade');
        },
        render: function render() {
          var _this2 = this;

          var props = this.props;
          var prefixCls = props.prefixCls,
              locale = props.locale,
              mode = props.mode,
              value = props.value,
              showTimePicker = props.showTimePicker,
              enableNext = props.enableNext,
              enablePrev = props.enablePrev,
              disabledMonth = props.disabledMonth;
          var panel = null;

          if (mode === 'month') {
            panel = _react2['default'].createElement(_MonthPanel2['default'], {
              locale: locale,
              defaultValue: value,
              rootPrefixCls: prefixCls,
              onSelect: this.onMonthSelect,
              onYearPanelShow: function onYearPanelShow() {
                return _this2.showYearPanel('month');
              },
              disabledDate: disabledMonth,
              cellRender: props.monthCellRender,
              contentRender: props.monthCellContentRender
            });
          }

          if (mode === 'year') {
            panel = _react2['default'].createElement(_YearPanel2['default'], {
              locale: locale,
              defaultValue: value,
              rootPrefixCls: prefixCls,
              onSelect: this.onYearSelect,
              onDecadePanelShow: this.showDecadePanel
            });
          }

          if (mode === 'decade') {
            panel = _react2['default'].createElement(_DecadePanel2['default'], {
              locale: locale,
              defaultValue: value,
              rootPrefixCls: prefixCls,
              onSelect: this.onDecadeSelect
            });
          }

          return _react2['default'].createElement('div', {
            className: prefixCls + '-header'
          }, _react2['default'].createElement('div', {
            style: {
              position: 'relative'
            }
          }, showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          })), showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
            className: prefixCls + '-prev-month-btn',
            role: 'button',
            onClick: this.previousMonth,
            title: locale.previousMonth
          })), this.monthYearElement(showTimePicker), showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
            className: prefixCls + '-next-month-btn',
            onClick: this.nextMonth,
            title: locale.nextMonth
          })), showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
            className: prefixCls + '-next-year-btn',
            onClick: this.nextYear,
            title: locale.nextYear
          }))), panel);
        }
      });
      exports['default'] = CalendarHeader;
      module.exports = exports['default'];
      /***/
    },
    /* 429 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _createReactClass = __webpack_require__(32);

      var _createReactClass2 = _interopRequireDefault(_createReactClass);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _KeyCode = __webpack_require__(236);

      var _KeyCode2 = _interopRequireDefault(_KeyCode);

      var _CalendarHeader = __webpack_require__(428);

      var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

      var _CalendarFooter = __webpack_require__(847);

      var _CalendarFooter2 = _interopRequireDefault(_CalendarFooter);

      var _CalendarMixin = __webpack_require__(846);

      var _CalendarMixin2 = _interopRequireDefault(_CalendarMixin);

      var _CommonMixin = __webpack_require__(423);

      var _CommonMixin2 = _interopRequireDefault(_CommonMixin);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var MonthCalendar = (0, _createReactClass2['default'])({
        displayName: 'MonthCalendar',
        propTypes: {
          monthCellRender: _propTypes2['default'].func,
          dateCellRender: _propTypes2['default'].func
        },
        mixins: [_CommonMixin2['default'], _CalendarMixin2['default']],
        getInitialState: function getInitialState() {
          return {
            mode: 'month'
          };
        },
        onKeyDown: function onKeyDown(event) {
          var keyCode = event.keyCode;
          var ctrlKey = event.ctrlKey || event.metaKey;
          var stateValue = this.state.value;
          var disabledDate = this.props.disabledDate;
          var value = stateValue;

          switch (keyCode) {
            case _KeyCode2['default'].DOWN:
              value = stateValue.clone();
              value.add(3, 'months');
              break;

            case _KeyCode2['default'].UP:
              value = stateValue.clone();
              value.add(-3, 'months');
              break;

            case _KeyCode2['default'].LEFT:
              value = stateValue.clone();

              if (ctrlKey) {
                value.add(-1, 'years');
              } else {
                value.add(-1, 'months');
              }

              break;

            case _KeyCode2['default'].RIGHT:
              value = stateValue.clone();

              if (ctrlKey) {
                value.add(1, 'years');
              } else {
                value.add(1, 'months');
              }

              break;

            case _KeyCode2['default'].ENTER:
              if (!disabledDate || !disabledDate(stateValue)) {
                this.onSelect(stateValue);
              }

              event.preventDefault();
              return 1;

            default:
              return undefined;
          }

          if (value !== stateValue) {
            this.setValue(value);
            event.preventDefault();
            return 1;
          }
        },
        handlePanelChange: function handlePanelChange(_, mode) {
          if (mode !== 'date') {
            this.setState({
              mode: mode
            });
          }
        },
        render: function render() {
          var props = this.props,
              state = this.state;
          var mode = state.mode,
              value = state.value;

          var children = _react2['default'].createElement('div', {
            className: props.prefixCls + '-month-calendar-content'
          }, _react2['default'].createElement('div', {
            className: props.prefixCls + '-month-header-wrap'
          }, _react2['default'].createElement(_CalendarHeader2['default'], {
            prefixCls: props.prefixCls,
            mode: mode,
            value: value,
            locale: props.locale,
            disabledMonth: props.disabledDate,
            monthCellRender: props.monthCellRender,
            monthCellContentRender: props.monthCellContentRender,
            onMonthSelect: this.onSelect,
            onValueChange: this.setValue,
            onPanelChange: this.handlePanelChange
          })), _react2['default'].createElement(_CalendarFooter2['default'], {
            prefixCls: props.prefixCls,
            renderFooter: props.renderFooter
          }));

          return this.renderRoot({
            className: props.prefixCls + '-month-calendar',
            children: children
          });
        }
      });
      exports['default'] = MonthCalendar;
      module.exports = exports['default'];
      /***/
    },
    /* 430 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _omit = __webpack_require__(45);

      var _omit2 = _interopRequireDefault(_omit);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function fixControlledValue(value) {
        if (typeof value === 'undefined' || value === null) {
          return '';
        }

        return value;
      }

      var Input = function (_React$Component) {
        (0, _inherits3['default'])(Input, _React$Component);

        function Input() {
          (0, _classCallCheck3['default'])(this, Input);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));

          _this.handleKeyDown = function (e) {
            var _this$props = _this.props,
                onPressEnter = _this$props.onPressEnter,
                onKeyDown = _this$props.onKeyDown;

            if (e.keyCode === 13 && onPressEnter) {
              onPressEnter(e);
            }

            if (onKeyDown) {
              onKeyDown(e);
            }
          };

          _this.saveInput = function (node) {
            _this.input = node;
          };

          return _this;
        }

        (0, _createClass3['default'])(Input, [{
          key: 'focus',
          value: function focus() {
            this.input.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.input.blur();
          }
        }, {
          key: 'getInputClassName',
          value: function getInputClassName() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                size = _props.size,
                disabled = _props.disabled;
            return (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), _classNames));
          }
        }, {
          key: 'renderLabeledInput',
          value: function renderLabeledInput(children) {
            var _classNames3;

            var props = this.props; // Not wrap when there is not addons

            if (!props.addonBefore && !props.addonAfter) {
              return children;
            }

            var wrapperClassName = props.prefixCls + '-group';
            var addonClassName = wrapperClassName + '-addon';
            var addonBefore = props.addonBefore ? React.createElement('span', {
              className: addonClassName
            }, props.addonBefore) : null;
            var addonAfter = props.addonAfter ? React.createElement('span', {
              className: addonClassName
            }, props.addonAfter) : null;
            var className = (0, _classnames2['default'])(props.prefixCls + '-wrapper', (0, _defineProperty3['default'])({}, wrapperClassName, addonBefore || addonAfter));
            var groupClassName = (0, _classnames2['default'])(props.prefixCls + '-group-wrapper', (_classNames3 = {}, (0, _defineProperty3['default'])(_classNames3, props.prefixCls + '-group-wrapper-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames3, props.prefixCls + '-group-wrapper-lg', props.size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
            // and put style prop in wrapper

            if (addonBefore || addonAfter) {
              return React.createElement('span', {
                className: groupClassName,
                style: props.style
              }, React.createElement('span', {
                className: className
              }, addonBefore, React.cloneElement(children, {
                style: null
              }), addonAfter));
            }

            return React.createElement('span', {
              className: className
            }, addonBefore, children, addonAfter);
          }
        }, {
          key: 'renderLabeledIcon',
          value: function renderLabeledIcon(children) {
            var _classNames4;

            var props = this.props;

            if (!('prefix' in props || 'suffix' in props)) {
              return children;
            }

            var prefix = props.prefix ? React.createElement('span', {
              className: props.prefixCls + '-prefix'
            }, props.prefix) : null;
            var suffix = props.suffix ? React.createElement('span', {
              className: props.prefixCls + '-suffix'
            }, props.suffix) : null;
            var affixWrapperCls = (0, _classnames2['default'])(props.className, props.prefixCls + '-affix-wrapper', (_classNames4 = {}, (0, _defineProperty3['default'])(_classNames4, props.prefixCls + '-affix-wrapper-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames4, props.prefixCls + '-affix-wrapper-lg', props.size === 'large'), _classNames4));
            return React.createElement('span', {
              className: affixWrapperCls,
              style: props.style
            }, prefix, React.cloneElement(children, {
              style: null,
              className: this.getInputClassName()
            }), suffix);
          }
        }, {
          key: 'renderInput',
          value: function renderInput() {
            var _props2 = this.props,
                value = _props2.value,
                className = _props2.className; // Fix https://fb.me/react-unknown-prop

            var otherProps = (0, _omit2['default'])(this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix']);

            if ('value' in this.props) {
              otherProps.value = fixControlledValue(value); // Input elements must be either controlled or uncontrolled,
              // specify either the value prop, or the defaultValue prop, but not both.

              delete otherProps.defaultValue;
            }

            return this.renderLabeledIcon(React.createElement('input', (0, _extends3['default'])({}, otherProps, {
              className: (0, _classnames2['default'])(this.getInputClassName(), className),
              onKeyDown: this.handleKeyDown,
              ref: this.saveInput
            })));
          }
        }, {
          key: 'render',
          value: function render() {
            return this.renderLabeledInput(this.renderInput());
          }
        }]);
        return Input;
      }(React.Component);

      exports['default'] = Input;
      Input.defaultProps = {
        prefixCls: 'ant-input',
        type: 'text',
        disabled: false
      };
      Input.propTypes = {
        type: _propTypes2['default'].string,
        id: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
        size: _propTypes2['default'].oneOf(['small', 'default', 'large']),
        maxLength: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
        disabled: _propTypes2['default'].bool,
        value: _propTypes2['default'].any,
        defaultValue: _propTypes2['default'].any,
        className: _propTypes2['default'].string,
        addonBefore: _propTypes2['default'].node,
        addonAfter: _propTypes2['default'].node,
        prefixCls: _propTypes2['default'].string,
        autosize: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
        onPressEnter: _propTypes2['default'].func,
        onKeyDown: _propTypes2['default'].func,
        onKeyUp: _propTypes2['default'].func,
        onFocus: _propTypes2['default'].func,
        onBlur: _propTypes2['default'].func,
        prefix: _propTypes2['default'].node,
        suffix: _propTypes2['default'].node
      };
      module.exports = exports['default'];
      /***/
    },
    /* 431 */

    /***/
    function (module, exports, __webpack_require__) {
      var toNumber = __webpack_require__(513);
      /** Used as references for various `Number` constants. */


      var INFINITY = 1 / 0,
          MAX_INTEGER = 1.7976931348623157e+308;
      /**
       * Converts `value` to a finite number.
       *
       * @static
       * @memberOf _
       * @since 4.12.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted number.
       * @example
       *
       * _.toFinite(3.2);
       * // => 3.2
       *
       * _.toFinite(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toFinite(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toFinite('3.2');
       * // => 3.2
       */

      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }

        value = toNumber(value);

        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }

        return value === value ? value : 0;
      }

      module.exports = toFinite;
      /***/
    },
    /* 432 */

    /***/
    function (module, exports, __webpack_require__) {
      var toFinite = __webpack_require__(431);
      /**
       * Converts `value` to an integer.
       *
       * **Note:** This method is loosely based on
       * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toInteger(3.2);
       * // => 3
       *
       * _.toInteger(Number.MIN_VALUE);
       * // => 0
       *
       * _.toInteger(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toInteger('3.2');
       * // => 3
       */


      function toInteger(value) {
        var result = toFinite(value),
            remainder = result % 1;
        return result === result ? remainder ? result - remainder : result : 0;
      }

      module.exports = toInteger;
      /***/
    },
    /* 433 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _rcUpload = __webpack_require__(262);

      var _rcUpload2 = _interopRequireDefault(_rcUpload);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _uniqBy = __webpack_require__(217);

      var _uniqBy2 = _interopRequireDefault(_uniqBy);

      var _LocaleReceiver = __webpack_require__(201);

      var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

      var _default = __webpack_require__(238);

      var _default2 = _interopRequireDefault(_default);

      var _UploadList = __webpack_require__(863);

      var _UploadList2 = _interopRequireDefault(_UploadList);

      var _utils = __webpack_require__(860);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var Upload = function (_React$Component) {
        (0, _inherits3['default'])(Upload, _React$Component);

        function Upload(props) {
          (0, _classCallCheck3['default'])(this, Upload);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Upload.__proto__ || Object.getPrototypeOf(Upload)).call(this, props));

          _this.onStart = function (file) {
            var targetItem = void 0;

            var nextFileList = _this.state.fileList.concat();

            targetItem = (0, _utils.fileToObject)(file);
            targetItem.status = 'uploading';
            nextFileList.push(targetItem);

            _this.onChange({
              file: targetItem,
              fileList: nextFileList
            }); // fix ie progress


            if (!window.FormData) {
              _this.autoUpdateProgress(0, targetItem);
            }
          };

          _this.onSuccess = function (response, file) {
            _this.clearProgressTimer();

            try {
              if (typeof response === 'string') {
                response = JSON.parse(response);
              }
            } catch (e) {
              /* do nothing */
            }

            var fileList = _this.state.fileList;
            var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

            if (!targetItem) {
              return;
            }

            targetItem.status = 'done';
            targetItem.response = response;

            _this.onChange({
              file: (0, _extends3['default'])({}, targetItem),
              fileList: fileList
            });
          };

          _this.onProgress = function (e, file) {
            var fileList = _this.state.fileList;
            var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

            if (!targetItem) {
              return;
            }

            targetItem.percent = e.percent;

            _this.onChange({
              event: e,
              file: (0, _extends3['default'])({}, targetItem),
              fileList: _this.state.fileList
            });
          };

          _this.onError = function (error, response, file) {
            _this.clearProgressTimer();

            var fileList = _this.state.fileList;
            var targetItem = (0, _utils.getFileItem)(file, fileList); // removed

            if (!targetItem) {
              return;
            }

            targetItem.error = error;
            targetItem.response = response;
            targetItem.status = 'error';

            _this.onChange({
              file: (0, _extends3['default'])({}, targetItem),
              fileList: fileList
            });
          };

          _this.handleManualRemove = function (file) {
            _this.upload.abort(file);

            file.status = 'removed'; // eslint-disable-line

            _this.handleRemove(file);
          };

          _this.onChange = function (info) {
            if (!('fileList' in _this.props)) {
              _this.setState({
                fileList: info.fileList
              });
            }

            var onChange = _this.props.onChange;

            if (onChange) {
              onChange(info);
            }
          };

          _this.onFileDrop = function (e) {
            _this.setState({
              dragState: e.type
            });
          };

          _this.beforeUpload = function (file, fileList) {
            if (!_this.props.beforeUpload) {
              return true;
            }

            var result = _this.props.beforeUpload(file, fileList);

            if (result === false) {
              _this.onChange({
                file: file,
                fileList: (0, _uniqBy2['default'])(fileList.concat(_this.state.fileList), function (item) {
                  return item.uid;
                })
              });

              return false;
            } else if (result && result.then) {
              return result;
            }

            return true;
          };

          _this.saveUpload = function (node) {
            _this.upload = node;
          };

          _this.renderUploadList = function (locale) {
            var _this$props = _this.props,
                showUploadList = _this$props.showUploadList,
                listType = _this$props.listType,
                onPreview = _this$props.onPreview;
            var showRemoveIcon = showUploadList.showRemoveIcon,
                showPreviewIcon = showUploadList.showPreviewIcon;
            return React.createElement(_UploadList2['default'], {
              listType: listType,
              items: _this.state.fileList,
              onPreview: onPreview,
              onRemove: _this.handleManualRemove,
              showRemoveIcon: showRemoveIcon,
              showPreviewIcon: showPreviewIcon,
              locale: (0, _extends3['default'])({}, locale, _this.props.locale)
            });
          };

          _this.state = {
            fileList: props.fileList || props.defaultFileList || [],
            dragState: 'drop'
          };
          return _this;
        }

        (0, _createClass3['default'])(Upload, [{
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this.clearProgressTimer();
          }
        }, {
          key: 'autoUpdateProgress',
          value: function autoUpdateProgress(_, file) {
            var _this2 = this;

            var getPercent = (0, _utils.genPercentAdd)();
            var curPercent = 0;
            this.clearProgressTimer();
            this.progressTimer = setInterval(function () {
              curPercent = getPercent(curPercent);

              _this2.onProgress({
                percent: curPercent
              }, file);
            }, 200);
          }
        }, {
          key: 'handleRemove',
          value: function handleRemove(file) {
            var _this3 = this;

            var onRemove = this.props.onRemove;
            Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
              // Prevent removing file
              if (ret === false) {
                return;
              }

              var removedFileList = (0, _utils.removeFileItem)(file, _this3.state.fileList);

              if (removedFileList) {
                _this3.onChange({
                  file: file,
                  fileList: removedFileList
                });
              }
            });
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('fileList' in nextProps) {
              this.setState({
                fileList: nextProps.fileList || []
              });
            }
          }
        }, {
          key: 'clearProgressTimer',
          value: function clearProgressTimer() {
            clearInterval(this.progressTimer);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames2;

            var _props = this.props,
                _props$prefixCls = _props.prefixCls,
                prefixCls = _props$prefixCls === undefined ? '' : _props$prefixCls,
                className = _props.className,
                showUploadList = _props.showUploadList,
                listType = _props.listType,
                type = _props.type,
                disabled = _props.disabled,
                children = _props.children;
            var rcUploadProps = (0, _extends3['default'])({
              onStart: this.onStart,
              onError: this.onError,
              onProgress: this.onProgress,
              onSuccess: this.onSuccess
            }, this.props, {
              beforeUpload: this.beforeUpload
            });
            delete rcUploadProps.className;
            var uploadList = showUploadList ? React.createElement(_LocaleReceiver2['default'], {
              componentName: 'Upload',
              defaultLocale: _default2['default'].Upload
            }, this.renderUploadList) : null;

            if (type === 'drag') {
              var _classNames;

              var dragCls = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-drag', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-drag-uploading', this.state.fileList.some(function (file) {
                return file.status === 'uploading';
              })), (0, _defineProperty3['default'])(_classNames, prefixCls + '-drag-hover', this.state.dragState === 'dragover'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), _classNames));
              return React.createElement('span', {
                className: className
              }, React.createElement('div', {
                className: dragCls,
                onDrop: this.onFileDrop,
                onDragOver: this.onFileDrop,
                onDragLeave: this.onFileDrop
              }, React.createElement(_rcUpload2['default'], (0, _extends3['default'])({}, rcUploadProps, {
                ref: this.saveUpload,
                className: prefixCls + '-btn'
              }), React.createElement('div', {
                className: prefixCls + '-drag-container'
              }, children))), uploadList);
            }

            var uploadButtonCls = (0, _classnames2['default'])(prefixCls, (_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-select', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-select-' + listType, true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-disabled', disabled), _classNames2));
            var uploadButton = React.createElement('div', {
              className: uploadButtonCls,
              style: {
                display: children ? '' : 'none'
              }
            }, React.createElement(_rcUpload2['default'], (0, _extends3['default'])({}, rcUploadProps, {
              ref: this.saveUpload
            })));

            if (listType === 'picture-card') {
              return React.createElement('span', {
                className: className
              }, uploadList, uploadButton);
            }

            return React.createElement('span', {
              className: className
            }, uploadButton, uploadList);
          }
        }]);
        return Upload;
      }(React.Component);

      exports['default'] = Upload;
      Upload.defaultProps = {
        prefixCls: 'ant-upload',
        type: 'select',
        multiple: false,
        action: '',
        data: {},
        accept: '',
        beforeUpload: _utils.T,
        showUploadList: true,
        listType: 'text',
        className: '',
        disabled: false,
        supportServerRender: true
      };
      module.exports = exports['default'];
      /***/
    },
    /* 434 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _objectWithoutProperties2 = __webpack_require__(42);

      var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _addEventListener = __webpack_require__(319);

      var _addEventListener2 = _interopRequireDefault(_addEventListener);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var Handle = function (_React$Component) {
        (0, _inherits3['default'])(Handle, _React$Component);

        function Handle() {
          var _ref;

          var _temp, _this, _ret;

          (0, _classCallCheck3['default'])(this, Handle);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            clickFocused: false
          }, _this.setHandleRef = function (node) {
            _this.handle = node;
          }, _this.handleMouseUp = function () {
            if (document.activeElement === _this.handle) {
              _this.setClickFocus(true);
            }
          }, _this.handleMouseDown = function () {
            // fix https://github.com/ant-design/ant-design/issues/15324
            _this.focus();
          }, _this.handleBlur = function () {
            _this.setClickFocus(false);
          }, _this.handleKeyDown = function () {
            _this.setClickFocus(false);
          }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
        }

        (0, _createClass3['default'])(Handle, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            // mouseup won't trigger if mouse moved out of handle,
            // so we listen on document here.
            this.onMouseUpListener = (0, _addEventListener2['default'])(document, 'mouseup', this.handleMouseUp);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.onMouseUpListener) {
              this.onMouseUpListener.remove();
            }
          }
        }, {
          key: 'setClickFocus',
          value: function setClickFocus(focused) {
            this.setState({
              clickFocused: focused
            });
          }
        }, {
          key: 'clickFocus',
          value: function clickFocus() {
            this.setClickFocus(true);
            this.focus();
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.handle.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.handle.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                vertical = _props.vertical,
                offset = _props.offset,
                style = _props.style,
                disabled = _props.disabled,
                min = _props.min,
                max = _props.max,
                value = _props.value,
                tabIndex = _props.tabIndex,
                restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);
            var className = (0, _classnames2['default'])(this.props.className, (0, _defineProperty3['default'])({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
            var postionStyle = vertical ? {
              bottom: offset + '%'
            } : {
              left: offset + '%'
            };
            var elStyle = (0, _extends3['default'])({}, style, postionStyle);

            var _tabIndex = tabIndex || 0;

            if (disabled || tabIndex === null) {
              _tabIndex = null;
            }

            return _react2['default'].createElement('div', (0, _extends3['default'])({
              ref: this.setHandleRef,
              tabIndex: _tabIndex
            }, restProps, {
              className: className,
              style: elStyle,
              onBlur: this.handleBlur,
              onKeyDown: this.handleKeyDown,
              onMouseDown: this.handleMouseDown // aria attribute
              ,
              role: 'slider',
              'aria-valuemin': min,
              'aria-valuemax': max,
              'aria-valuenow': value,
              'aria-disabled': !!disabled
            }));
          }
        }]);
        return Handle;
      }(_react2['default'].Component);

      exports['default'] = Handle;
      Handle.propTypes = {
        prefixCls: _propTypes2['default'].string,
        className: _propTypes2['default'].string,
        vertical: _propTypes2['default'].bool,
        offset: _propTypes2['default'].number,
        style: _propTypes2['default'].object,
        disabled: _propTypes2['default'].bool,
        min: _propTypes2['default'].number,
        max: _propTypes2['default'].number,
        value: _propTypes2['default'].number,
        tabIndex: _propTypes2['default'].number
      };
      module.exports = exports['default'];
      /***/
    },
    /* 435 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _objectWithoutProperties2 = __webpack_require__(42);

      var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _get2 = __webpack_require__(225);

      var _get3 = _interopRequireDefault(_get2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      exports['default'] = createSlider;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _addEventListener = __webpack_require__(319);

      var _addEventListener2 = _interopRequireDefault(_addEventListener);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _warning = __webpack_require__(114);

      var _warning2 = _interopRequireDefault(_warning);

      var _Steps = __webpack_require__(868);

      var _Steps2 = _interopRequireDefault(_Steps);

      var _Marks = __webpack_require__(867);

      var _Marks2 = _interopRequireDefault(_Marks);

      var _Handle = __webpack_require__(434);

      var _Handle2 = _interopRequireDefault(_Handle);

      var _utils = __webpack_require__(313);

      var utils = _interopRequireWildcard(_utils);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function noop() {}

      function createSlider(Component) {
        var _class, _temp;

        return _temp = _class = function (_Component) {
          (0, _inherits3['default'])(ComponentEnhancer, _Component);

          function ComponentEnhancer(props) {
            (0, _classCallCheck3['default'])(this, ComponentEnhancer);

            var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

            _this.onMouseDown = function (e) {
              if (e.button !== 0) {
                return;
              }

              var isVertical = _this.props.vertical;
              var position = utils.getMousePosition(isVertical, e);

              if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
                _this.dragOffset = 0;
              } else {
                var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
                _this.dragOffset = position - handlePosition;
                position = handlePosition;
              }

              _this.removeDocumentEvents();

              _this.onStart(position);

              _this.addDocumentMouseEvents();
            };

            _this.onTouchStart = function (e) {
              if (utils.isNotTouchEvent(e)) return;
              var isVertical = _this.props.vertical;
              var position = utils.getTouchPosition(isVertical, e);

              if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
                _this.dragOffset = 0;
              } else {
                var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
                _this.dragOffset = position - handlePosition;
                position = handlePosition;
              }

              _this.onStart(position);

              _this.addDocumentTouchEvents();

              utils.pauseEvent(e);
            };

            _this.onFocus = function (e) {
              var _this$props = _this.props,
                  onFocus = _this$props.onFocus,
                  vertical = _this$props.vertical;

              if (utils.isEventFromHandle(e, _this.handlesRefs)) {
                var handlePosition = utils.getHandleCenterPosition(vertical, e.target);
                _this.dragOffset = 0;

                _this.onStart(handlePosition);

                utils.pauseEvent(e);

                if (onFocus) {
                  onFocus(e);
                }
              }
            };

            _this.onBlur = function (e) {
              var onBlur = _this.props.onBlur;

              _this.onEnd();

              if (onBlur) {
                onBlur(e);
              }
            };

            _this.onMouseUp = function () {
              if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
                _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
              }
            };

            _this.onMouseMove = function (e) {
              if (!_this.sliderRef) {
                _this.onEnd();

                return;
              }

              var position = utils.getMousePosition(_this.props.vertical, e);

              _this.onMove(e, position - _this.dragOffset);
            };

            _this.onTouchMove = function (e) {
              if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
                _this.onEnd();

                return;
              }

              var position = utils.getTouchPosition(_this.props.vertical, e);

              _this.onMove(e, position - _this.dragOffset);
            };

            _this.onKeyDown = function (e) {
              if (_this.sliderRef && utils.isEventFromHandle(e, _this.handlesRefs)) {
                _this.onKeyboard(e);
              }
            };

            _this.onClickMarkLabel = function (e, value) {
              e.stopPropagation();

              _this.onChange({
                value: value
              });

              _this.setState({
                value: value
              }, function () {
                return _this.onEnd(true);
              });
            };

            _this.saveSlider = function (slider) {
              _this.sliderRef = slider;
            };

            if (utils.isDev()) {
              var step = props.step,
                  max = props.max,
                  min = props.min;
              var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line

              (0, _warning2['default'])(step && Math.floor(step) === step ? isPointDiffEven : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
            }

            _this.handlesRefs = {};
            return _this;
          }

          (0, _createClass3['default'])(ComponentEnhancer, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              // Snapshot testing cannot handle refs, so be sure to null-check this.
              this.document = this.sliderRef && this.sliderRef.ownerDocument;
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              if ((0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
              this.removeDocumentEvents();
            }
          }, {
            key: 'getSliderStart',
            value: function getSliderStart() {
              var slider = this.sliderRef;
              var rect = slider.getBoundingClientRect();
              return this.props.vertical ? rect.top : rect.left + window.pageXOffset;
            }
          }, {
            key: 'getSliderLength',
            value: function getSliderLength() {
              var slider = this.sliderRef;

              if (!slider) {
                return 0;
              }

              var coords = slider.getBoundingClientRect();
              return this.props.vertical ? coords.height : coords.width;
            }
          }, {
            key: 'addDocumentTouchEvents',
            value: function addDocumentTouchEvents() {
              // just work for Chrome iOS Safari and Android Browser
              this.onTouchMoveListener = (0, _addEventListener2['default'])(this.document, 'touchmove', this.onTouchMove);
              this.onTouchUpListener = (0, _addEventListener2['default'])(this.document, 'touchend', this.onEnd);
            }
          }, {
            key: 'addDocumentMouseEvents',
            value: function addDocumentMouseEvents() {
              this.onMouseMoveListener = (0, _addEventListener2['default'])(this.document, 'mousemove', this.onMouseMove);
              this.onMouseUpListener = (0, _addEventListener2['default'])(this.document, 'mouseup', this.onEnd);
            }
          }, {
            key: 'removeDocumentEvents',
            value: function removeDocumentEvents() {
              /* eslint-disable no-unused-expressions */
              this.onTouchMoveListener && this.onTouchMoveListener.remove();
              this.onTouchUpListener && this.onTouchUpListener.remove();
              this.onMouseMoveListener && this.onMouseMoveListener.remove();
              this.onMouseUpListener && this.onMouseUpListener.remove();
              /* eslint-enable no-unused-expressions */
            }
          }, {
            key: 'focus',
            value: function focus() {
              if (!this.props.disabled) {
                this.handlesRefs[0].focus();
              }
            }
          }, {
            key: 'blur',
            value: function blur() {
              var _this2 = this;

              if (!this.props.disabled) {
                Object.keys(this.handlesRefs).forEach(function (key) {
                  if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
                    _this2.handlesRefs[key].blur();
                  }
                });
              }
            }
          }, {
            key: 'calcValue',
            value: function calcValue(offset) {
              var _props = this.props,
                  vertical = _props.vertical,
                  min = _props.min,
                  max = _props.max;
              var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
              var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
              return value;
            }
          }, {
            key: 'calcValueByPos',
            value: function calcValueByPos(position) {
              var pixelOffset = position - this.getSliderStart();
              var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
              return nextValue;
            }
          }, {
            key: 'calcOffset',
            value: function calcOffset(value) {
              var _props2 = this.props,
                  min = _props2.min,
                  max = _props2.max;
              var ratio = (value - min) / (max - min);
              return ratio * 100;
            }
          }, {
            key: 'saveHandle',
            value: function saveHandle(index, handle) {
              this.handlesRefs[index] = handle;
            }
          }, {
            key: 'render',
            value: function render() {
              var _classNames;

              var _props3 = this.props,
                  prefixCls = _props3.prefixCls,
                  className = _props3.className,
                  marks = _props3.marks,
                  dots = _props3.dots,
                  step = _props3.step,
                  included = _props3.included,
                  disabled = _props3.disabled,
                  vertical = _props3.vertical,
                  min = _props3.min,
                  max = _props3.max,
                  children = _props3.children,
                  maximumTrackStyle = _props3.maximumTrackStyle,
                  style = _props3.style,
                  railStyle = _props3.railStyle,
                  dotStyle = _props3.dotStyle,
                  activeDotStyle = _props3.activeDotStyle;

              var _get$call = (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
                  tracks = _get$call.tracks,
                  handles = _get$call.handles;

              var sliderClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', vertical), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
              return _react2['default'].createElement('div', {
                ref: this.saveSlider,
                className: sliderClassName,
                onTouchStart: disabled ? noop : this.onTouchStart,
                onMouseDown: disabled ? noop : this.onMouseDown,
                onMouseUp: disabled ? noop : this.onMouseUp,
                onKeyDown: disabled ? noop : this.onKeyDown,
                onFocus: disabled ? noop : this.onFocus,
                onBlur: disabled ? noop : this.onBlur,
                style: style
              }, _react2['default'].createElement('div', {
                className: prefixCls + '-rail',
                style: (0, _extends3['default'])({}, maximumTrackStyle, railStyle)
              }), tracks, _react2['default'].createElement(_Steps2['default'], {
                prefixCls: prefixCls,
                vertical: vertical,
                marks: marks,
                dots: dots,
                step: step,
                included: included,
                lowerBound: this.getLowerBound(),
                upperBound: this.getUpperBound(),
                max: max,
                min: min,
                dotStyle: dotStyle,
                activeDotStyle: activeDotStyle
              }), handles, _react2['default'].createElement(_Marks2['default'], {
                className: prefixCls + '-mark',
                onClickLabel: disabled ? noop : this.onClickMarkLabel,
                vertical: vertical,
                marks: marks,
                included: included,
                lowerBound: this.getLowerBound(),
                upperBound: this.getUpperBound(),
                max: max,
                min: min
              }), children);
            }
          }]);
          return ComponentEnhancer;
        }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3['default'])({}, Component.propTypes, {
          min: _propTypes2['default'].number,
          max: _propTypes2['default'].number,
          step: _propTypes2['default'].number,
          marks: _propTypes2['default'].object,
          included: _propTypes2['default'].bool,
          className: _propTypes2['default'].string,
          prefixCls: _propTypes2['default'].string,
          disabled: _propTypes2['default'].bool,
          children: _propTypes2['default'].any,
          onBeforeChange: _propTypes2['default'].func,
          onChange: _propTypes2['default'].func,
          onAfterChange: _propTypes2['default'].func,
          handle: _propTypes2['default'].func,
          dots: _propTypes2['default'].bool,
          vertical: _propTypes2['default'].bool,
          style: _propTypes2['default'].object,
          minimumTrackStyle: _propTypes2['default'].object,
          // just for compatibility, will be deperecate
          maximumTrackStyle: _propTypes2['default'].object,
          // just for compatibility, will be deperecate
          handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
          trackStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
          railStyle: _propTypes2['default'].object,
          dotStyle: _propTypes2['default'].object,
          activeDotStyle: _propTypes2['default'].object,
          autoFocus: _propTypes2['default'].bool,
          onFocus: _propTypes2['default'].func,
          onBlur: _propTypes2['default'].func
        }), _class.defaultProps = (0, _extends3['default'])({}, Component.defaultProps, {
          prefixCls: 'rc-slider',
          className: '',
          min: 0,
          max: 100,
          step: 1,
          marks: {},
          handle: function handle(_ref) {
            var index = _ref.index,
                restProps = (0, _objectWithoutProperties3['default'])(_ref, ['index']);
            delete restProps.dragging;

            if (restProps.value === null) {
              return null;
            }

            return _react2['default'].createElement(_Handle2['default'], (0, _extends3['default'])({}, restProps, {
              key: index
            }));
          },
          onBeforeChange: noop,
          onChange: noop,
          onAfterChange: noop,
          included: true,
          disabled: false,
          dots: false,
          vertical: false,
          trackStyle: [{}],
          handleStyle: [{}],
          railStyle: {},
          dotStyle: {},
          activeDotStyle: {}
        }), _temp;
      }

      module.exports = exports['default'];
      /***/
    },
    /* 436 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var Track = function Track(props) {
        var className = props.className,
            included = props.included,
            vertical = props.vertical,
            offset = props.offset,
            length = props.length,
            style = props.style;
        var positonStyle = vertical ? {
          bottom: offset + '%',
          height: length + '%'
        } : {
          left: offset + '%',
          width: length + '%'
        };
        var elStyle = (0, _extends3['default'])({}, style, positonStyle);
        return included ? _react2['default'].createElement('div', {
          className: className,
          style: elStyle
        }) : null;
      };
      /* eslint-disable react/prop-types */


      exports['default'] = Track;
      module.exports = exports['default'];
      /***/
    },
    /* 437 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _reactDom = __webpack_require__(16);

      var _reactDom2 = _interopRequireDefault(_reactDom);

      var _scroller = __webpack_require__(237);

      var _scroller2 = _interopRequireDefault(_scroller);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      exports.default = function (Component) {
        var Element = function (_React$Component) {
          _inherits(Element, _React$Component);

          function Element(props) {
            _classCallCheck(this, Element);

            var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

            _this.childBindings = {
              domNode: null
            };
            return _this;
          }

          _createClass(Element, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              if (typeof window === 'undefined') {
                return false;
              }

              this.registerElems(this.props.name);
            }
          }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
              if (this.props.name !== nextProps.name) {
                this.registerElems(nextProps.name);
              }
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              if (typeof window === 'undefined') {
                return false;
              }

              _scroller2.default.unregister(this.props.name);
            }
          }, {
            key: 'registerElems',
            value: function registerElems(name) {
              _scroller2.default.register(name, this.childBindings.domNode);
            }
          }, {
            key: 'render',
            value: function render() {
              return _react2.default.createElement(Component, _extends({}, this.props, {
                parentBindings: this.childBindings
              }));
            }
          }]);

          return Element;
        }(_react2.default.Component);

        ;
        Element.propTypes = {
          name: _propTypes2.default.string,
          id: _propTypes2.default.string
        };
        return Element;
      };
      /***/

    },
    /* 438 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _passiveEventListeners = __webpack_require__(315);

      var _utils = __webpack_require__(200);

      var _utils2 = _interopRequireDefault(_utils);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var scrollHash = {
        mountFlag: false,
        initialized: false,
        scroller: null,
        containers: {},
        mount: function mount(scroller) {
          this.scroller = scroller;
          this.handleHashChange = this.handleHashChange.bind(this);
          window.addEventListener('hashchange', this.handleHashChange);
          this.initStateFromHash();
          this.mountFlag = true;
        },
        mapContainer: function mapContainer(to, container) {
          this.containers[to] = container;
        },
        isMounted: function isMounted() {
          return this.mountFlag;
        },
        isInitialized: function isInitialized() {
          return this.initialized;
        },
        initStateFromHash: function initStateFromHash() {
          var _this = this;

          var hash = this.getHash();

          if (hash) {
            window.setTimeout(function () {
              _this.scrollTo(hash, true);

              _this.initialized = true;
            }, 10);
          } else {
            this.initialized = true;
          }
        },
        scrollTo: function scrollTo(to, isInit) {
          var scroller = this.scroller;
          var element = scroller.get(to);

          if (element && (isInit || to !== scroller.getActiveLink())) {
            var container = this.containers[to] || document;
            scroller.scrollTo(to, {
              container: container
            });
          }
        },
        getHash: function getHash() {
          return _utils2.default.getHash();
        },
        changeHash: function changeHash(to) {
          if (this.isInitialized() && _utils2.default.getHash() !== to) {
            _utils2.default.pushHash(to);
          }
        },
        handleHashChange: function handleHashChange() {
          this.scrollTo(this.getHash());
        },
        unmount: function unmount() {
          this.scroller = null;
          this.containers = null;
          window.removeEventListener('hashchange', this.handleHashChange);
        }
      };
      exports.default = scrollHash;
      /***/
    },
    /* 439 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _utils = __webpack_require__(200);

      var _utils2 = _interopRequireDefault(_utils);

      var _smooth = __webpack_require__(886);

      var _smooth2 = _interopRequireDefault(_smooth);

      var _cancelEvents = __webpack_require__(885);

      var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

      var _scrollEvents = __webpack_require__(314);

      var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /*
       * Gets the easing type from the smooth prop within options.
       */


      var getAnimationType = function getAnimationType(options) {
        return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
      };
      /*
       * Function helper
       */


      var functionWrapper = function functionWrapper(value) {
        return typeof value === 'function' ? value : function () {
          return value;
        };
      };
      /*
       * Wraps window properties to allow server side rendering
       */


      var currentWindowProperties = function currentWindowProperties() {
        if (typeof window !== 'undefined') {
          return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
        }
      };
      /*
       * Helper function to never extend 60fps on the webpage.
       */


      var requestAnimationFrameHelper = function () {
        return currentWindowProperties() || function (callback, element, delay) {
          window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
        };
      }();

      var makeData = function makeData() {
        return {
          currentPositionY: 0,
          startPositionY: 0,
          targetPositionY: 0,
          progress: 0,
          duration: 0,
          cancel: false,
          target: null,
          containerElement: null,
          to: null,
          start: null,
          deltaTop: null,
          percent: null,
          delayTimeout: null
        };
      };

      var currentPositionY = function currentPositionY(options) {
        var containerElement = options.data.containerElement;

        if (containerElement && containerElement !== document && containerElement !== document.body) {
          return containerElement.scrollTop;
        } else {
          var supportPageOffset = window.pageXOffset !== undefined;
          var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
          return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
        }
      };

      var scrollContainerHeight = function scrollContainerHeight(options) {
        var containerElement = options.data.containerElement;

        if (containerElement && containerElement !== document && containerElement !== document.body) {
          return Math.max(containerElement.scrollHeight, containerElement.offsetHeight, containerElement.clientHeight);
        } else {
          var body = document.body;
          var html = document.documentElement;
          return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        }
      };

      var animateScroll = function animateScroll(easing, options, timestamp) {
        var data = options.data; // Cancel on specific events

        if (!options.ignoreCancelEvents && data.cancel) {
          if (_scrollEvents2.default.registered['end']) {
            _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
          }

          return;
        }

        ;
        data.deltaTop = Math.round(data.targetPositionY - data.startPositionY);

        if (data.start === null) {
          data.start = timestamp;
        }

        data.progress = timestamp - data.start;
        data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);
        data.currentPositionY = data.startPositionY + Math.ceil(data.deltaTop * data.percent);

        if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
          data.containerElement.scrollTop = data.currentPositionY;
        } else {
          window.scrollTo(0, data.currentPositionY);
        }

        if (data.percent < 1) {
          var easedAnimate = animateScroll.bind(null, easing, options);
          requestAnimationFrameHelper.call(window, easedAnimate);
          return;
        }

        if (_scrollEvents2.default.registered['end']) {
          _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
        }
      };

      var setContainer = function setContainer(options) {
        options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
      };

      var animateTopScroll = function animateTopScroll(y, options, to, target) {
        options.data = options.data || makeData();
        window.clearTimeout(options.data.delayTimeout);

        _cancelEvents2.default.subscribe(function () {
          options.data.cancel = true;
        });

        setContainer(options);
        options.data.start = null;
        options.data.cancel = false;
        options.data.startPositionY = currentPositionY(options);
        options.data.targetPositionY = options.absolute ? y : y + options.data.startPositionY;

        if (options.data.startPositionY === options.data.targetPositionY) {
          if (_scrollEvents2.default.registered['end']) {
            _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPositionY);
          }

          return;
        }

        options.data.deltaTop = Math.round(options.data.targetPositionY - options.data.startPositionY);
        options.data.duration = functionWrapper(options.duration)(options.data.deltaTop);
        options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
        options.data.to = to;
        options.data.target = target;
        var easing = getAnimationType(options);
        var easedAnimate = animateScroll.bind(null, easing, options);

        if (options && options.delay > 0) {
          options.data.delayTimeout = window.setTimeout(function () {
            requestAnimationFrameHelper.call(window, easedAnimate);
          }, options.delay);
          return;
        }

        requestAnimationFrameHelper.call(window, easedAnimate);
      };

      var proceedOptions = function proceedOptions(options) {
        options = _extends({}, options);
        options.data = options.data || makeData();
        options.absolute = true;
        return options;
      };

      var scrollToTop = function scrollToTop(options) {
        animateTopScroll(0, proceedOptions(options));
      };

      var scrollTo = function scrollTo(toY, options) {
        animateTopScroll(toY, proceedOptions(options));
      };

      var scrollToBottom = function scrollToBottom(options) {
        options = proceedOptions(options);
        setContainer(options);
        animateTopScroll(scrollContainerHeight(options), options);
      };

      var scrollMore = function scrollMore(toY, options) {
        options = proceedOptions(options);
        setContainer(options);
        animateTopScroll(currentPositionY(options) + toY, options);
      };

      exports.default = {
        animateTopScroll: animateTopScroll,
        getAnimationType: getAnimationType,
        scrollToTop: scrollToTop,
        scrollToBottom: scrollToBottom,
        scrollTo: scrollTo,
        scrollMore: scrollMore
      };
      /***/
    },
    /* 440 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      exports.changeConfirmLocale = changeConfirmLocale;
      exports.getConfirmLocale = getConfirmLocale;

      var _default = __webpack_require__(238);

      var _default2 = _interopRequireDefault(_default);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var runtimeLocale = (0, _extends3['default'])({}, _default2['default'].Modal);

      function changeConfirmLocale(newLocale) {
        if (newLocale) {
          runtimeLocale = (0, _extends3['default'])({}, runtimeLocale, newLocale);
        } else {
          runtimeLocale = (0, _extends3['default'])({}, _default2['default'].Modal);
        }
      }

      function getConfirmLocale() {
        return runtimeLocale;
      }
      /***/

    },
    /* 441 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _rcDialog = __webpack_require__(374);

      var _rcDialog2 = _interopRequireDefault(_rcDialog);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _addEventListener = __webpack_require__(319);

      var _addEventListener2 = _interopRequireDefault(_addEventListener);

      var _button = __webpack_require__(318);

      var _button2 = _interopRequireDefault(_button);

      var _LocaleReceiver = __webpack_require__(201);

      var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

      var _locale = __webpack_require__(440);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var mousePosition = void 0;
      var mousePositionEventBinded = void 0;

      var Modal = function (_React$Component) {
        (0, _inherits3['default'])(Modal, _React$Component);

        function Modal() {
          (0, _classCallCheck3['default'])(this, Modal);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));

          _this.handleCancel = function (e) {
            var onCancel = _this.props.onCancel;

            if (onCancel) {
              onCancel(e);
            }
          };

          _this.handleOk = function (e) {
            var onOk = _this.props.onOk;

            if (onOk) {
              onOk(e);
            }
          };

          _this.renderFooter = function (locale) {
            var _this$props = _this.props,
                okText = _this$props.okText,
                okType = _this$props.okType,
                cancelText = _this$props.cancelText,
                confirmLoading = _this$props.confirmLoading;
            return React.createElement('div', null, React.createElement(_button2['default'], {
              onClick: _this.handleCancel
            }, cancelText || locale.cancelText), React.createElement(_button2['default'], {
              type: okType,
              loading: confirmLoading,
              onClick: _this.handleOk
            }, okText || locale.okText));
          };

          return _this;
        }

        (0, _createClass3['default'])(Modal, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (mousePositionEventBinded) {
              return;
            } // 只有点击事件支持从鼠标位置动画展开


            (0, _addEventListener2['default'])(document.documentElement, 'click', function (e) {
              mousePosition = {
                x: e.pageX,
                y: e.pageY
              }; // 100ms 内发生过点击事件，则从点击位置动画展示
              // 否则直接 zoom 展示
              // 这样可以兼容非点击方式展开

              setTimeout(function () {
                return mousePosition = null;
              }, 100);
            });
            mousePositionEventBinded = true;
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                footer = _props.footer,
                visible = _props.visible;
            var defaultFooter = React.createElement(_LocaleReceiver2['default'], {
              componentName: 'Modal',
              defaultLocale: (0, _locale.getConfirmLocale)()
            }, this.renderFooter);
            return React.createElement(_rcDialog2['default'], (0, _extends3['default'])({}, this.props, {
              footer: footer === undefined ? defaultFooter : footer,
              visible: visible,
              mousePosition: mousePosition,
              onClose: this.handleCancel
            }));
          }
        }]);
        return Modal;
      }(React.Component);

      exports['default'] = Modal;
      Modal.defaultProps = {
        prefixCls: 'ant-modal',
        width: 520,
        transitionName: 'zoom',
        maskTransitionName: 'fade',
        confirmLoading: false,
        visible: false,
        okType: 'primary'
      };
      Modal.propTypes = {
        prefixCls: _propTypes2['default'].string,
        onOk: _propTypes2['default'].func,
        onCancel: _propTypes2['default'].func,
        okText: _propTypes2['default'].node,
        cancelText: _propTypes2['default'].node,
        width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
        confirmLoading: _propTypes2['default'].bool,
        visible: _propTypes2['default'].bool,
        align: _propTypes2['default'].object,
        footer: _propTypes2['default'].node,
        title: _propTypes2['default'].node,
        closable: _propTypes2['default'].bool
      };
      module.exports = exports['default'];
      /***/
    },
    /* 442 */

    /***/
    function (module, exports, __webpack_require__) {
      var flatten = __webpack_require__(893),
          overRest = __webpack_require__(489),
          setToString = __webpack_require__(488);
      /**
       * A specialized version of `baseRest` which flattens the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @returns {Function} Returns the new function.
       */


      function flatRest(func) {
        return setToString(overRest(func, undefined, flatten), func + '');
      }

      module.exports = flatRest;
      /***/
    },
    /* 443 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGet = __webpack_require__(249),
          baseSet = __webpack_require__(506),
          castPath = __webpack_require__(177);
      /**
       * The base implementation of  `_.pickBy` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The source object.
       * @param {string[]} paths The property paths to pick.
       * @param {Function} predicate The function invoked per property.
       * @returns {Object} Returns the new object.
       */


      function basePickBy(object, paths, predicate) {
        var index = -1,
            length = paths.length,
            result = {};

        while (++index < length) {
          var path = paths[index],
              value = baseGet(object, path);

          if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
          }
        }

        return result;
      }

      module.exports = basePickBy;
      /***/
    },
    /* 444 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseForOwn = __webpack_require__(321),
          createBaseEach = __webpack_require__(898);
      /**
       * The base implementation of `_.forEach` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       */


      var baseEach = createBaseEach(baseForOwn);
      module.exports = baseEach;
      /***/
    },
    /* 445 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayPush = __webpack_require__(239),
          getPrototype = __webpack_require__(347),
          getSymbols = __webpack_require__(327),
          stubArray = __webpack_require__(452);
      /* Built-in method references for those with the same name as other `lodash` methods. */


      var nativeGetSymbols = Object.getOwnPropertySymbols;
      /**
       * Creates an array of the own and inherited enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */

      var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
        var result = [];

        while (object) {
          arrayPush(result, getSymbols(object));
          object = getPrototype(object);
        }

        return result;
      };
      module.exports = getSymbolsIn;
      /***/
    },
    /* 446 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports['default'] = {
        today: 'Today',
        now: 'Now',
        backToToday: 'Back to today',
        ok: 'Ok',
        clear: 'Clear',
        month: 'Month',
        year: 'Year',
        timeSelect: 'select time',
        dateSelect: 'select date',
        weekSelect: 'Choose a week',
        monthSelect: 'Choose a month',
        yearSelect: 'Choose a year',
        decadeSelect: 'Choose a decade',
        yearFormat: 'YYYY',
        dateFormat: 'M/D/YYYY',
        dayFormat: 'D',
        dateTimeFormat: 'M/D/YYYY HH:mm:ss',
        monthBeforeYear: true,
        previousMonth: 'Previous month (PageUp)',
        nextMonth: 'Next month (PageDown)',
        previousYear: 'Last year (Control + left)',
        nextYear: 'Next year (Control + right)',
        previousDecade: 'Last decade',
        nextDecade: 'Next decade',
        previousCentury: 'Last century',
        nextCentury: 'Next century'
      };
      module.exports = exports['default'];
      /***/
    },
    /* 447 */

    /***/
    function (module, exports) {
      /**
       * This function is like `arrayIncludes` except that it accepts a comparator.
       *
       * @private
       * @param {Array} [array] The array to inspect.
       * @param {*} target The value to search for.
       * @param {Function} comparator The comparator invoked per element.
       * @returns {boolean} Returns `true` if `target` is found, else `false`.
       */
      function arrayIncludesWith(array, value, comparator) {
        var index = -1,
            length = array == null ? 0 : array.length;

        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }

        return false;
      }

      module.exports = arrayIncludesWith;
      /***/
    },
    /* 448 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIndexOf = __webpack_require__(922);
      /**
       * A specialized version of `_.includes` for arrays without support for
       * specifying an index to search from.
       *
       * @private
       * @param {Array} [array] The array to inspect.
       * @param {*} target The value to search for.
       * @returns {boolean} Returns `true` if `target` is found, else `false`.
       */


      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }

      module.exports = arrayIncludes;
      /***/
    },
    /* 449 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseHasIn = __webpack_require__(926),
          hasPath = __webpack_require__(509);
      /**
       * Checks if `path` is a direct or inherited property of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       * @example
       *
       * var object = _.create({ 'a': _.create({ 'b': 2 }) });
       *
       * _.hasIn(object, 'a');
       * // => true
       *
       * _.hasIn(object, 'a.b');
       * // => true
       *
       * _.hasIn(object, ['a', 'b']);
       * // => true
       *
       * _.hasIn(object, 'b');
       * // => false
       */


      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }

      module.exports = hasIn;
      /***/
    },
    /* 450 */

    /***/
    function (module, exports) {
      /**
       * A specialized version of `matchesProperty` for source values suitable
       * for strict equality comparisons, i.e. `===`.
       *
       * @private
       * @param {string} key The key of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       */
      function matchesStrictComparable(key, srcValue) {
        return function (object) {
          if (object == null) {
            return false;
          }

          return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
        };
      }

      module.exports = matchesStrictComparable;
      /***/
    },
    /* 451 */

    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(97);
      /**
       * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` if suitable for strict
       *  equality comparisons, else `false`.
       */


      function isStrictComparable(value) {
        return value === value && !isObject(value);
      }

      module.exports = isStrictComparable;
      /***/
    },
    /* 452 */

    /***/
    function (module, exports) {
      /**
       * This method returns a new empty array.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {Array} Returns the new empty array.
       * @example
       *
       * var arrays = _.times(2, _.stubArray);
       *
       * console.log(arrays);
       * // => [[], []]
       *
       * console.log(arrays[0] === arrays[1]);
       * // => false
       */
      function stubArray() {
        return [];
      }

      module.exports = stubArray;
      /***/
    },
    /* 453 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayPush = __webpack_require__(239),
          isArray = __webpack_require__(55);
      /**
       * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
       * `keysFunc` and `symbolsFunc` to get the enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @param {Function} symbolsFunc The function to get the symbols of `object`.
       * @returns {Array} Returns the array of property names and symbols.
       */


      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
      }

      module.exports = baseGetAllKeys;
      /***/
    },
    /* 454 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGetAllKeys = __webpack_require__(453),
          getSymbols = __webpack_require__(327),
          keys = __webpack_require__(132);
      /**
       * Creates an array of own enumerable property names and symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */


      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }

      module.exports = getAllKeys;
      /***/
    },
    /* 455 */

    /***/
    function (module, exports, __webpack_require__) {
      var SetCache = __webpack_require__(329),
          arraySome = __webpack_require__(932),
          cacheHas = __webpack_require__(328);
      /** Used to compose bitmasks for value comparisons. */


      var COMPARE_PARTIAL_FLAG = 1,
          COMPARE_UNORDERED_FLAG = 2;
      /**
       * A specialized version of `baseIsEqualDeep` for arrays with support for
       * partial deep comparisons.
       *
       * @private
       * @param {Array} array The array to compare.
       * @param {Array} other The other array to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `array` and `other` objects.
       * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
       */

      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
            arrLength = array.length,
            othLength = other.length;

        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        } // Assume cyclic values are equal.


        var stacked = stack.get(array);

        if (stacked && stack.get(other)) {
          return stacked == other;
        }

        var index = -1,
            result = true,
            seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
        stack.set(array, other);
        stack.set(other, array); // Ignore non-index properties.

        while (++index < arrLength) {
          var arrValue = array[index],
              othValue = other[index];

          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
          }

          if (compared !== undefined) {
            if (compared) {
              continue;
            }

            result = false;
            break;
          } // Recursively compare arrays (susceptible to call stack limits).


          if (seen) {
            if (!arraySome(other, function (othValue, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
          }
        }

        stack['delete'](array);
        stack['delete'](other);
        return result;
      }

      module.exports = equalArrays;
      /***/
    },
    /* 456 */

    /***/
    function (module, exports, __webpack_require__) {
      var isPrototype = __webpack_require__(209),
          nativeKeys = __webpack_require__(938);
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */

      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }

        var result = [];

        for (var key in Object(object)) {
          if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
          }
        }

        return result;
      }

      module.exports = baseKeys;
      /***/
    },
    /* 457 */

    /***/
    function (module, exports, __webpack_require__) {
      var getNative = __webpack_require__(157),
          root = __webpack_require__(103);
      /* Built-in method references that are verified to be native. */


      var Set = getNative(root, 'Set');
      module.exports = Set;
      /***/
    },
    /* 458 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global) {
        var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
        var apply = Function.prototype.apply; // DOM APIs, for completeness

        exports.setTimeout = function () {
          return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
        };

        exports.setInterval = function () {
          return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
        };

        exports.clearTimeout = exports.clearInterval = function (timeout) {
          if (timeout) {
            timeout.close();
          }
        };

        function Timeout(id, clearFn) {
          this._id = id;
          this._clearFn = clearFn;
        }

        Timeout.prototype.unref = Timeout.prototype.ref = function () {};

        Timeout.prototype.close = function () {
          this._clearFn.call(scope, this._id);
        }; // Does not start the time, just sets up the members needed.


        exports.enroll = function (item, msecs) {
          clearTimeout(item._idleTimeoutId);
          item._idleTimeout = msecs;
        };

        exports.unenroll = function (item) {
          clearTimeout(item._idleTimeoutId);
          item._idleTimeout = -1;
        };

        exports._unrefActive = exports.active = function (item) {
          clearTimeout(item._idleTimeoutId);
          var msecs = item._idleTimeout;

          if (msecs >= 0) {
            item._idleTimeoutId = setTimeout(function onTimeout() {
              if (item._onTimeout) item._onTimeout();
            }, msecs);
          }
        }; // setimmediate attaches itself to the global object


        __webpack_require__(334); // On some exotic environments, it's not clear which object `setimmediate` was
        // able to install onto.  Search each possibility in the same order as the
        // `setimmediate` library.


        exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
        exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 459 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftStringKey
       * @format
       * 
       */

      var DraftStringKey = {
        stringify: function stringify(key) {
          return '_' + String(key);
        },
        unstringify: function unstringify(key) {
          return key.slice(1);
        }
      };
      module.exports = DraftStringKey;
      /***/
    },
    /* 460 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getDefaultKeyBinding
       * @format
       * 
       */

      var KeyBindingUtil = __webpack_require__(333);

      var Keys = __webpack_require__(340);

      var UserAgent = __webpack_require__(113);

      var isOSX = UserAgent.isPlatform('Mac OS X');
      var isWindows = UserAgent.isPlatform('Windows'); // Firefox on OSX had a bug resulting in navigation instead of cursor movement.
      // This bug was fixed in Firefox 29. Feature detection is virtually impossible
      // so we just check the version number. See #342765.

      var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
      var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
          isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;

      function shouldRemoveWord(e) {
        return isOSX && e.altKey || isCtrlKeyCommand(e);
      }
      /**
       * Get the appropriate undo/redo command for a Z key command.
       */


      function getZCommand(e) {
        if (!hasCommandModifier(e)) {
          return null;
        }

        return e.shiftKey ? 'redo' : 'undo';
      }

      function getDeleteCommand(e) {
        // Allow default "cut" behavior for Windows on Shift + Delete.
        if (isWindows && e.shiftKey) {
          return null;
        }

        return shouldRemoveWord(e) ? 'delete-word' : 'delete';
      }

      function getBackspaceCommand(e) {
        if (hasCommandModifier(e) && isOSX) {
          return 'backspace-to-start-of-line';
        }

        return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
      }
      /**
       * Retrieve a bound key command for the given event.
       */


      function getDefaultKeyBinding(e) {
        switch (e.keyCode) {
          case 66:
            // B
            return hasCommandModifier(e) ? 'bold' : null;

          case 68:
            // D
            return isCtrlKeyCommand(e) ? 'delete' : null;

          case 72:
            // H
            return isCtrlKeyCommand(e) ? 'backspace' : null;

          case 73:
            // I
            return hasCommandModifier(e) ? 'italic' : null;

          case 74:
            // J
            return hasCommandModifier(e) ? 'code' : null;

          case 75:
            // K
            return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;

          case 77:
            // M
            return isCtrlKeyCommand(e) ? 'split-block' : null;

          case 79:
            // O
            return isCtrlKeyCommand(e) ? 'split-block' : null;

          case 84:
            // T
            return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;

          case 85:
            // U
            return hasCommandModifier(e) ? 'underline' : null;

          case 87:
            // W
            return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;

          case 89:
            // Y
            if (isCtrlKeyCommand(e)) {
              return isWindows ? 'redo' : 'secondary-paste';
            }

            return null;

          case 90:
            // Z
            return getZCommand(e) || null;

          case Keys.RETURN:
            return 'split-block';

          case Keys.DELETE:
            return getDeleteCommand(e);

          case Keys.BACKSPACE:
            return getBackspaceCommand(e);
          // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.

          case Keys.LEFT:
            return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;

          case Keys.RIGHT:
            return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;

          default:
            return null;
        }
      }

      module.exports = getDefaultKeyBinding;
      /***/
    },
    /* 461 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule RichTextEditorUtil
       * @format
       * 
       */

      var DraftModifier = __webpack_require__(93);

      var EditorState = __webpack_require__(60);

      var SelectionState = __webpack_require__(174);

      var adjustBlockDepthForContentState = __webpack_require__(962);

      var nullthrows = __webpack_require__(108);

      var RichTextEditorUtil = {
        currentBlockContainsLink: function currentBlockContainsLink(editorState) {
          var selection = editorState.getSelection();
          var contentState = editorState.getCurrentContent();
          var entityMap = contentState.getEntityMap();
          return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
            var entity = v.getEntity();
            return !!entity && entityMap.__get(entity).getType() === 'LINK';
          });
        },
        getCurrentBlockType: function getCurrentBlockType(editorState) {
          var selection = editorState.getSelection();
          return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
        },
        getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
          return {
            url: uri.toString()
          };
        },
        handleKeyCommand: function handleKeyCommand(editorState, command) {
          switch (command) {
            case 'bold':
              return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');

            case 'italic':
              return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');

            case 'underline':
              return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');

            case 'code':
              return RichTextEditorUtil.toggleCode(editorState);

            case 'backspace':
            case 'backspace-word':
            case 'backspace-to-start-of-line':
              return RichTextEditorUtil.onBackspace(editorState);

            case 'delete':
            case 'delete-word':
            case 'delete-to-end-of-block':
              return RichTextEditorUtil.onDelete(editorState);

            default:
              // they may have custom editor commands; ignore those
              return null;
          }
        },
        insertSoftNewline: function insertSoftNewline(editorState) {
          var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
          var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
          return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
        },

        /**
         * For collapsed selections at the start of styled blocks, backspace should
         * just remove the existing style.
         */
        onBackspace: function onBackspace(editorState) {
          var selection = editorState.getSelection();

          if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
            return null;
          } // First, try to remove a preceding atomic block.


          var content = editorState.getCurrentContent();
          var startKey = selection.getStartKey();
          var blockBefore = content.getBlockBefore(startKey);

          if (blockBefore && blockBefore.getType() === 'atomic') {
            var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
            var withoutAtomicBlock = content.merge({
              blockMap: blockMap,
              selectionAfter: selection
            });

            if (withoutAtomicBlock !== content) {
              return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
            }
          } // If that doesn't succeed, try to remove the current block style.


          var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

          if (withoutBlockStyle) {
            return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
          }

          return null;
        },
        onDelete: function onDelete(editorState) {
          var selection = editorState.getSelection();

          if (!selection.isCollapsed()) {
            return null;
          }

          var content = editorState.getCurrentContent();
          var startKey = selection.getStartKey();
          var block = content.getBlockForKey(startKey);
          var length = block.getLength(); // The cursor is somewhere within the text. Behave normally.

          if (selection.getStartOffset() < length) {
            return null;
          }

          var blockAfter = content.getBlockAfter(startKey);

          if (!blockAfter || blockAfter.getType() !== 'atomic') {
            return null;
          }

          var atomicBlockTarget = selection.merge({
            focusKey: blockAfter.getKey(),
            focusOffset: blockAfter.getLength()
          });
          var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');

          if (withoutAtomicBlock !== content) {
            return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
          }

          return null;
        },
        onTab: function onTab(event, editorState, maxDepth) {
          var selection = editorState.getSelection();
          var key = selection.getAnchorKey();

          if (key !== selection.getFocusKey()) {
            return editorState;
          }

          var content = editorState.getCurrentContent();
          var block = content.getBlockForKey(key);
          var type = block.getType();

          if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
            return editorState;
          }

          event.preventDefault(); // Only allow indenting one level beyond the block above, and only if
          // the block above is a list item as well.

          var blockAbove = content.getBlockBefore(key);

          if (!blockAbove) {
            return editorState;
          }

          var typeAbove = blockAbove.getType();

          if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
            return editorState;
          }

          var depth = block.getDepth();

          if (!event.shiftKey && depth === maxDepth) {
            return editorState;
          }

          maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);
          var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
          return EditorState.push(editorState, withAdjustment, 'adjust-depth');
        },
        toggleBlockType: function toggleBlockType(editorState, blockType) {
          var selection = editorState.getSelection();
          var startKey = selection.getStartKey();
          var endKey = selection.getEndKey();
          var content = editorState.getCurrentContent();
          var target = selection; // Triple-click can lead to a selection that includes offset 0 of the
          // following block. The `SelectionState` for this case is accurate, but
          // we should avoid toggling block type for the trailing block because it
          // is a confusing interaction.

          if (startKey !== endKey && selection.getEndOffset() === 0) {
            var blockBefore = nullthrows(content.getBlockBefore(endKey));
            endKey = blockBefore.getKey();
            target = target.merge({
              anchorKey: startKey,
              anchorOffset: selection.getStartOffset(),
              focusKey: endKey,
              focusOffset: blockBefore.getLength(),
              isBackward: false
            });
          }

          var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
            return k !== startKey;
          }).reverse().skipWhile(function (_, k) {
            return k !== endKey;
          }).some(function (v) {
            return v.getType() === 'atomic';
          });

          if (hasAtomicBlock) {
            return editorState;
          }

          var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
          return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
        },
        toggleCode: function toggleCode(editorState) {
          var selection = editorState.getSelection();
          var anchorKey = selection.getAnchorKey();
          var focusKey = selection.getFocusKey();

          if (selection.isCollapsed() || anchorKey !== focusKey) {
            return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
          }

          return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
        },

        /**
         * Toggle the specified inline style for the selection. If the
         * user's selection is collapsed, apply or remove the style for the
         * internal state. If it is not collapsed, apply the change directly
         * to the document state.
         */
        toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
          var selection = editorState.getSelection();
          var currentStyle = editorState.getCurrentInlineStyle(); // If the selection is collapsed, toggle the specified style on or off and
          // set the result as the new inline style override. This will then be
          // used as the inline style for the next character to be inserted.

          if (selection.isCollapsed()) {
            return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
          } // If characters are selected, immediately apply or remove the
          // inline style on the document state itself.


          var content = editorState.getCurrentContent();
          var newContent; // If the style is already present for the selection range, remove it.
          // Otherwise, apply it.

          if (currentStyle.has(inlineStyle)) {
            newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
          } else {
            newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
          }

          return EditorState.push(editorState, newContent, 'change-inline-style');
        },
        toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
          var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
          return EditorState.push(editorState, withoutLink, 'apply-entity');
        },

        /**
         * When a collapsed cursor is at the start of the first styled block, or
         * an empty styled block, changes block to 'unstyled'. Returns null if
         * block or selection does not meet that criteria.
         */
        tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
          var selection = editorState.getSelection();
          var offset = selection.getAnchorOffset();

          if (selection.isCollapsed() && offset === 0) {
            var key = selection.getAnchorKey();
            var content = editorState.getCurrentContent();
            var block = content.getBlockForKey(key);
            var firstBlock = content.getFirstBlock();

            if (block.getLength() > 0 && block !== firstBlock) {
              return null;
            }

            var type = block.getType();
            var blockBefore = content.getBlockBefore(key);

            if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
              return null;
            }

            if (type !== 'unstyled') {
              return DraftModifier.setBlockType(content, selection, 'unstyled');
            }
          }

          return null;
        }
      };
      module.exports = RichTextEditorUtil;
      /***/
    },
    /* 462 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getSafeBodyFromHTML
       * @format
       * 
       */

      var UserAgent = __webpack_require__(113);

      var invariant = __webpack_require__(51);

      var isOldIE = UserAgent.isBrowser('IE <= 9'); // Provides a dom node that will not execute scripts
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
      // https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

      function getSafeBodyFromHTML(html) {
        var doc;
        var root = null; // Provides a safe context

        if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
          doc = document.implementation.createHTMLDocument('foo');
          !doc.documentElement ? false ? undefined : invariant(false) : void 0;
          doc.documentElement.innerHTML = html;
          root = doc.getElementsByTagName('body')[0];
        }

        return root;
      }

      module.exports = getSafeBodyFromHTML;
      /***/
    },
    /* 463 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule convertFromHTMLToContentBlocks
       * @format
       * 
       */

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _knownListItemDepthCl,
          _assign = __webpack_require__(82);

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      var CharacterMetadata = __webpack_require__(96);

      var ContentBlock = __webpack_require__(155);

      var ContentBlockNode = __webpack_require__(102);

      var DefaultDraftBlockRenderMap = __webpack_require__(341);

      var DraftEntity = __webpack_require__(241);

      var DraftFeatureFlags = __webpack_require__(133);

      var Immutable = __webpack_require__(53);

      var _require = __webpack_require__(53),
          Set = _require.Set;

      var URI = __webpack_require__(963);

      var cx = __webpack_require__(173);

      var generateRandomKey = __webpack_require__(127);

      var getSafeBodyFromHTML = __webpack_require__(462);

      var invariant = __webpack_require__(51);

      var sanitizeDraftText = __webpack_require__(343);

      var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
      var List = Immutable.List,
          OrderedSet = Immutable.OrderedSet;
      var NBSP = '&nbsp;';
      var SPACE = ' '; // Arbitrary max indent

      var MAX_DEPTH = 4; // used for replacing characters in HTML

      var REGEX_CR = new RegExp('\r', 'g');
      var REGEX_LF = new RegExp('\n', 'g');
      var REGEX_NBSP = new RegExp(NBSP, 'g');
      var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
      var REGEX_ZWS = new RegExp('&#8203;?', 'g'); // https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight

      var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
      var notBoldValues = ['light', 'lighter', '100', '200', '300', '400']; // Block tag flow is different because LIs do not have
      // a deterministic style ;_;

      var inlineTags = {
        b: 'BOLD',
        code: 'CODE',
        del: 'STRIKETHROUGH',
        em: 'ITALIC',
        i: 'ITALIC',
        s: 'STRIKETHROUGH',
        strike: 'STRIKETHROUGH',
        strong: 'BOLD',
        u: 'UNDERLINE'
      };
      var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
      var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
      var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
      var lastBlock = void 0;
      var EMPTY_CHUNK = {
        text: '',
        inlines: [],
        entities: [],
        blocks: []
      };
      var EMPTY_BLOCK = {
        children: List(),
        depth: 0,
        key: '',
        type: ''
      };

      var getListBlockType = function getListBlockType(tag, lastList) {
        if (tag === 'li') {
          return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
        }

        return null;
      };

      var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
        var unstyledElement = blockRenderMap.get('unstyled').element;
        var tags = Set([]);
        blockRenderMap.forEach(function (draftBlock) {
          if (draftBlock.aliasedElements) {
            draftBlock.aliasedElements.forEach(function (tag) {
              tags = tags.add(tag);
            });
          }

          tags = tags.add(draftBlock.element);
        });
        return tags.filter(function (tag) {
          return tag && tag !== unstyledElement;
        }).toArray().sort();
      }; // custom element conversions


      var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
        for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
          var matchType = multiMatchExtractor[ii](tag, lastList);

          if (matchType) {
            return matchType;
          }
        }

        return null;
      };

      var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
        var matchedTypes = blockRenderMap.filter(function (draftBlock) {
          return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
            return alias === tag;
          });
        }).keySeq().toSet().toArray().sort(); // if we dont have any matched type, return unstyled
        // if we have one matched type return it
        // if we have multi matched types use the multi-match function to gather type

        switch (matchedTypes.length) {
          case 0:
            return 'unstyled';

          case 1:
            return matchedTypes[0];

          default:
            return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
        }
      };

      var processInlineTag = function processInlineTag(tag, node, currentStyle) {
        var styleToCheck = inlineTags[tag];

        if (styleToCheck) {
          currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
        } else if (node instanceof HTMLElement) {
          var htmlElement = node;
          currentStyle = currentStyle.withMutations(function (style) {
            var fontWeight = htmlElement.style.fontWeight;
            var fontStyle = htmlElement.style.fontStyle;
            var textDecoration = htmlElement.style.textDecoration;

            if (boldValues.indexOf(fontWeight) >= 0) {
              style.add('BOLD');
            } else if (notBoldValues.indexOf(fontWeight) >= 0) {
              style.remove('BOLD');
            }

            if (fontStyle === 'italic') {
              style.add('ITALIC');
            } else if (fontStyle === 'normal') {
              style.remove('ITALIC');
            }

            if (textDecoration === 'underline') {
              style.add('UNDERLINE');
            }

            if (textDecoration === 'line-through') {
              style.add('STRIKETHROUGH');
            }

            if (textDecoration === 'none') {
              style.remove('UNDERLINE');
              style.remove('STRIKETHROUGH');
            }
          }).toOrderedSet();
        }

        return currentStyle;
      };

      var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
        // Sometimes two blocks will touch in the DOM and we need to strip the
        // extra delimiter to preserve niceness.
        var lastInA = A.text.slice(-1);
        var firstInB = B.text.slice(0, 1);

        if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
          A.text = A.text.slice(0, -1);
          A.inlines.pop();
          A.entities.pop();
          A.blocks.pop();
        } // Kill whitespace after blocks


        if (lastInA === '\r') {
          if (B.text === SPACE || B.text === '\n') {
            return A;
          } else if (firstInB === SPACE || firstInB === '\n') {
            B.text = B.text.slice(1);
            B.inlines.shift();
            B.entities.shift();
          }
        }

        return {
          text: A.text + B.text,
          inlines: A.inlines.concat(B.inlines),
          entities: A.entities.concat(B.entities),
          blocks: A.blocks.concat(B.blocks)
        };
      };
      /**
       * Check to see if we have anything like <p> <blockquote> <h1>... to create
       * block tags from. If we do, we can use those and ignore <div> tags. If we
       * don't, we can treat <div> tags as meaningful (unstyled) blocks.
       */


      var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
        return blockTags.some(function (tag) {
          return html.indexOf('<' + tag) !== -1;
        });
      };

      var hasValidLinkText = function hasValidLinkText(link) {
        !(link instanceof HTMLAnchorElement) ? false ? undefined : invariant(false) : void 0;
        var protocol = link.protocol;
        return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
      };

      var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
        var entities = new Array(1);

        if (inEntity) {
          entities[0] = inEntity;
        }

        return _extends({}, EMPTY_CHUNK, {
          text: SPACE,
          inlines: [OrderedSet()],
          entities: entities
        });
      };

      var getSoftNewlineChunk = function getSoftNewlineChunk() {
        return _extends({}, EMPTY_CHUNK, {
          text: '\n',
          inlines: [OrderedSet()],
          entities: new Array(1)
        });
      };

      var getChunkedBlock = function getChunkedBlock() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _extends({}, EMPTY_BLOCK, props);
      };

      var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
        var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        return {
          text: '\r',
          inlines: [OrderedSet()],
          entities: new Array(1),
          blocks: [getChunkedBlock({
            parent: parentKey,
            key: generateRandomKey(),
            type: block,
            depth: Math.max(0, Math.min(MAX_DEPTH, depth))
          })]
        };
      };
      /**
       *  If we're pasting from one DraftEditor to another we can check to see if
       *  existing list item depth classes are being used and preserve this style
       */


      var getListItemDepth = function getListItemDepth(node) {
        var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        Object.keys(knownListItemDepthClasses).some(function (depthClass) {
          if (node.classList.contains(depthClass)) {
            depth = knownListItemDepthClasses[depthClass];
          }
        });
        return depth;
      };

      var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
        var lastLastBlock = lastBlock;
        var nodeName = node.nodeName.toLowerCase();
        var newEntityMap = entityMap;
        var nextBlockType = 'unstyled';
        var newBlock = false;
        var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);

        var chunk = _extends({}, EMPTY_CHUNK);

        var newChunk = null;
        var blockKey = void 0; // Base Case

        if (nodeName === '#text') {
          var _text = node.textContent;

          var nodeTextContent = _text.trim(); // We should not create blocks for leading spaces that are
          // existing around ol/ul and their children list items


          if (lastList && nodeTextContent === '' && node.parentElement) {
            var parentNodeName = node.parentElement.nodeName.toLowerCase();

            if (parentNodeName === 'ol' || parentNodeName === 'ul') {
              return {
                chunk: _extends({}, EMPTY_CHUNK),
                entityMap: entityMap
              };
            }
          }

          if (nodeTextContent === '' && inBlock !== 'pre') {
            return {
              chunk: getWhitespaceChunk(inEntity),
              entityMap: entityMap
            };
          }

          if (inBlock !== 'pre') {
            // Can't use empty string because MSWord
            _text = _text.replace(REGEX_LF, SPACE);
          } // save the last block so we can use it later


          lastBlock = nodeName;
          return {
            chunk: {
              text: _text,
              inlines: Array(_text.length).fill(inlineStyle),
              entities: Array(_text.length).fill(inEntity),
              blocks: []
            },
            entityMap: entityMap
          };
        } // save the last block so we can use it later


        lastBlock = nodeName; // BR tags

        if (nodeName === 'br') {
          if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
            return {
              chunk: getBlockDividerChunk('unstyled', depth, parentKey),
              entityMap: entityMap
            };
          }

          return {
            chunk: getSoftNewlineChunk(),
            entityMap: entityMap
          };
        } // IMG tags


        if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
          var image = node;
          var entityConfig = {};
          imgAttr.forEach(function (attr) {
            var imageAttribute = image.getAttribute(attr);

            if (imageAttribute) {
              entityConfig[attr] = imageAttribute;
            }
          }); // Forcing this node to have children because otherwise no entity will be
          // created for this node.
          // The child text node cannot just have a space or return as content -
          // we strip those out.
          // See https://github.com/facebook/draft-js/issues/231 for some context.

          node.textContent = "\uD83D\uDCF7"; // TODO: update this when we remove DraftEntity entirely

          inEntity = DraftEntity.__create('IMAGE', 'MUTABLE', entityConfig || {});
        } // Inline tags


        inlineStyle = processInlineTag(nodeName, node, inlineStyle); // Handle lists

        if (nodeName === 'ul' || nodeName === 'ol') {
          if (lastList) {
            depth += 1;
          }

          lastList = nodeName;
        }

        if (!experimentalTreeDataSupport && nodeName === 'li' && node instanceof HTMLElement) {
          depth = getListItemDepth(node, depth);
        }

        var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
        var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
        var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport) && blockTags.indexOf(nodeName) !== -1; // Block Tags

        if (inListBlock || inBlockOrHasNestedBlocks) {
          chunk = getBlockDividerChunk(blockType, depth, parentKey);
          blockKey = chunk.blocks[0].key;
          inBlock = nodeName;
          newBlock = !experimentalTreeDataSupport;
        } // this is required so that we can handle 'ul' and 'ol'


        if (inListBlock) {
          nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
        } // Recurse through children


        var child = node.firstChild;

        if (child != null) {
          nodeName = child.nodeName.toLowerCase();
        }

        var entityId = null;

        while (child) {
          if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
            (function () {
              var anchor = child;
              var entityConfig = {};
              anchorAttr.forEach(function (attr) {
                var anchorAttribute = anchor.getAttribute(attr);

                if (anchorAttribute) {
                  entityConfig[attr] = anchorAttribute;
                }
              });
              entityConfig.url = new URI(anchor.href).toString(); // TODO: update this when we remove DraftEntity completely

              entityId = DraftEntity.__create('LINK', 'MUTABLE', entityConfig || {});
            })();
          } else {
            entityId = undefined;
          }

          var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport ? blockKey : null),
              generatedChunk = _genFragment.chunk,
              maybeUpdatedEntityMap = _genFragment.entityMap;

          newChunk = generatedChunk;
          newEntityMap = maybeUpdatedEntityMap;
          chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport);
          var sibling = child.nextSibling; // Put in a newline to break up blocks inside blocks

          if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
            chunk = joinChunks(chunk, getSoftNewlineChunk());
          }

          if (sibling) {
            nodeName = sibling.nodeName.toLowerCase();
          }

          child = sibling;
        }

        if (newBlock) {
          chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
        }

        return {
          chunk: chunk,
          entityMap: newEntityMap
        };
      };

      var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
        html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');
        var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);
        var safeBody = DOMBuilder(html);

        if (!safeBody) {
          return null;
        }

        lastBlock = null; // Sometimes we aren't dealing with content that contains nice semantic
        // tags. In this case, use divs to separate everything out into paragraphs
        // and hope for the best.

        var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div']; // Start with -1 block depth to offset the fact that we are passing in a fake
        // UL block to start with.

        var fragment = genFragment(entityMap, safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);
        var chunk = fragment.chunk;
        var newEntityMap = fragment.entityMap; // join with previous block to prevent weirdness on paste

        if (chunk.text.indexOf('\r') === 0) {
          chunk = {
            text: chunk.text.slice(1),
            inlines: chunk.inlines.slice(1),
            entities: chunk.entities.slice(1),
            blocks: chunk.blocks
          };
        } // Kill block delimiter at the end


        if (chunk.text.slice(-1) === '\r') {
          chunk.text = chunk.text.slice(0, -1);
          chunk.inlines = chunk.inlines.slice(0, -1);
          chunk.entities = chunk.entities.slice(0, -1);
          chunk.blocks.pop();
        } // If we saw no block tags, put an unstyled one in


        if (chunk.blocks.length === 0) {
          chunk.blocks.push(_extends({}, EMPTY_CHUNK, {
            type: 'unstyled',
            depth: 0
          }));
        } // Sometimes we start with text that isn't in a block, which is then
        // followed by blocks. Need to fix up the blocks to add in
        // an unstyled block for this content


        if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
          chunk.blocks.unshift({
            type: 'unstyled',
            depth: 0
          });
        }

        return {
          chunk: chunk,
          entityMap: newEntityMap
        };
      };

      var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
        if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
          return null;
        }

        var initialState = {
          cacheRef: {},
          contentBlocks: []
        };
        var start = 0;
        var rawBlocks = chunk.blocks,
            rawInlines = chunk.inlines,
            rawEntities = chunk.entities;
        var BlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
        return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
          // Make absolutely certain that our text is acceptable.
          textBlock = sanitizeDraftText(textBlock);
          var block = rawBlocks[index];
          var end = start + textBlock.length;
          var inlines = rawInlines.slice(start, end);
          var entities = rawEntities.slice(start, end);
          var characterList = List(inlines.map(function (style, index) {
            var data = {
              style: style,
              entity: null
            };

            if (entities[index]) {
              data.entity = entities[index];
            }

            return CharacterMetadata.create(data);
          }));
          start = end + 1;
          var depth = block.depth,
              type = block.type,
              parent = block.parent;
          var key = block.key || generateRandomKey();
          var parentTextNodeKey = null; // will be used to store container text nodes
          // childrens add themselves to their parents since we are iterating in order

          if (parent) {
            var parentIndex = acc.cacheRef[parent];
            var parentRecord = acc.contentBlocks[parentIndex]; // if parent has text we need to split it into a separate unstyled element

            if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
              var parentCharacterList = parentRecord.getCharacterList();
              var parentText = parentRecord.getText();
              parentTextNodeKey = generateRandomKey();
              var textNode = new ContentBlockNode({
                key: parentTextNodeKey,
                text: parentText,
                characterList: parentCharacterList,
                parent: parent,
                nextSibling: key
              });
              acc.contentBlocks.push(textNode);
              parentRecord = parentRecord.withMutations(function (block) {
                block.set('characterList', List()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
              });
            }

            acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
          }

          var blockNode = new BlockNodeRecord({
            key: key,
            parent: parent,
            type: type,
            depth: depth,
            text: textBlock,
            characterList: characterList,
            prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
            nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
          }); // insert node

          acc.contentBlocks.push(blockNode); // cache ref for building links

          acc.cacheRef[blockNode.key] = index;
          return acc;
        }, initialState).contentBlocks;
      };

      var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
        var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
        var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap; // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
        // arbitrary code in whatever environment you're running this in. For an
        // example of how we try to do this in-browser, see getSafeBodyFromHTML.
        // TODO: replace DraftEntity with an OrderedMap here

        var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);

        if (chunkData == null) {
          return null;
        }

        var chunk = chunkData.chunk,
            entityMap = chunkData.entityMap;
        var contentBlocks = convertChunkToContentBlocks(chunk);
        return {
          contentBlocks: contentBlocks,
          entityMap: entityMap
        };
      };

      module.exports = convertFromHTMLtoContentBlocks;
      /***/
    },
    /* 464 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule moveSelectionForward
       * @format
       * 
       */

      /**
       * Given a collapsed selection, move the focus `maxDistance` forward within
       * the selected block. If the selection will go beyond the end of the block,
       * move focus to the start of the next block, but no further.
       *
       * This function is not Unicode-aware, so surrogate pairs will be treated
       * as having length 2.
       */

      function moveSelectionForward(editorState, maxDistance) {
        var selection = editorState.getSelection();
        var key = selection.getStartKey();
        var offset = selection.getStartOffset();
        var content = editorState.getCurrentContent();
        var focusKey = key;
        var focusOffset;
        var block = content.getBlockForKey(key);

        if (maxDistance > block.getText().length - offset) {
          focusKey = content.getKeyAfter(key);
          focusOffset = 0;
        } else {
          focusOffset = offset + maxDistance;
        }

        return selection.merge({
          focusKey: focusKey,
          focusOffset: focusOffset
        });
      }

      module.exports = moveSelectionForward;
      /***/
    },
    /* 465 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftRemovableWord
       * @format
       * 
       */

      var TokenizeUtil = __webpack_require__(974);

      var punctuation = TokenizeUtil.getPunctuation(); // The apostrophe and curly single quotes behave in a curious way: when
      // surrounded on both sides by word characters, they behave as word chars; when
      // either neighbor is punctuation or an end of the string, they behave as
      // punctuation.

      var CHAMELEON_CHARS = "['\u2018\u2019]"; // Remove the underscore, which should count as part of the removable word. The
      // "chameleon chars" also count as punctuation in this regex.

      var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
      var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
      var DELETE_REGEX = new RegExp(DELETE_STRING);
      var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
      var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

      function getRemovableWord(text, isBackward) {
        var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
        return matches ? matches[0] : text;
      }

      var DraftRemovableWord = {
        getBackward: function getBackward(text) {
          return getRemovableWord(text, true);
        },
        getForward: function getForward(text) {
          return getRemovableWord(text, false);
        }
      };
      module.exports = DraftRemovableWord;
      /***/
    },
    /* 466 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getDraftEditorSelectionWithNodes
       * @format
       * 
       */

      var findAncestorOffsetKey = __webpack_require__(335);

      var getSelectionOffsetKeyForNode = __webpack_require__(471);

      var getUpdatedSelectionState = __webpack_require__(469);

      var invariant = __webpack_require__(51);

      var nullthrows = __webpack_require__(108);
      /**
       * Convert the current selection range to an anchor/focus pair of offset keys
       * and values that can be interpreted by components.
       */


      function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
        var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
        var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE; // If the selection range lies only on text nodes, the task is simple.
        // Find the nearest offset-aware elements and use the
        // offset values supplied by the selection range.

        if (anchorIsTextNode && focusIsTextNode) {
          return {
            selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
            needsRecovery: false
          };
        }

        var anchorPoint = null;
        var focusPoint = null;
        var needsRecovery = true; // An element is selected. Convert this selection range into leaf offset
        // keys and offset values for consumption at the component level. This
        // is common in Firefox, where select-all and triple click behavior leads
        // to entire elements being selected.
        //
        // Note that we use the `needsRecovery` parameter in the callback here. This
        // is because when certain elements are selected, the behavior for subsequent
        // cursor movement (e.g. via arrow keys) is uncertain and may not match
        // expectations at the component level. For example, if an entire <div> is
        // selected and the user presses the right arrow, Firefox keeps the selection
        // on the <div>. If we allow subsequent keypresses to insert characters
        // natively, they will be inserted into a browser-created text node to the
        // right of that <div>. This is obviously undesirable.
        //
        // With the `needsRecovery` flag, we inform the caller that it is responsible
        // for manually setting the selection state on the rendered document to
        // ensure proper selection state maintenance.

        if (anchorIsTextNode) {
          anchorPoint = {
            key: nullthrows(findAncestorOffsetKey(anchorNode)),
            offset: anchorOffset
          };
          focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
        } else if (focusIsTextNode) {
          focusPoint = {
            key: nullthrows(findAncestorOffsetKey(focusNode)),
            offset: focusOffset
          };
          anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
        } else {
          anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
          focusPoint = getPointForNonTextNode(root, focusNode, focusOffset); // If the selection is collapsed on an empty block, don't force recovery.
          // This way, on arrow key selection changes, the browser can move the
          // cursor from a non-zero offset on one block, through empty blocks,
          // to a matching non-zero offset on other text blocks.

          if (anchorNode === focusNode && anchorOffset === focusOffset) {
            needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
          }
        }

        return {
          selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
          needsRecovery: needsRecovery
        };
      }
      /**
       * Identify the first leaf descendant for the given node.
       */


      function getFirstLeaf(node) {
        while (node.firstChild && ( // data-blocks has no offset
        node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
          node = node.firstChild;
        }

        return node;
      }
      /**
       * Identify the last leaf descendant for the given node.
       */


      function getLastLeaf(node) {
        while (node.lastChild && ( // data-blocks has no offset
        node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
          node = node.lastChild;
        }

        return node;
      }

      function getPointForNonTextNode(editorRoot, startNode, childOffset) {
        var node = startNode;
        var offsetKey = findAncestorOffsetKey(node);
        !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ? false ? undefined : invariant(false) : void 0; // If the editorRoot is the selection, step downward into the content
        // wrapper.

        if (editorRoot === node) {
          node = node.firstChild;
          !(node instanceof Element && node.getAttribute('data-contents') === 'true') ? false ? undefined : invariant(false) : void 0;

          if (childOffset > 0) {
            childOffset = node.childNodes.length;
          }
        } // If the child offset is zero and we have an offset key, we're done.
        // If there's no offset key because the entire editor is selected,
        // find the leftmost ("first") leaf in the tree and use that as the offset
        // key.


        if (childOffset === 0) {
          var key = null;

          if (offsetKey != null) {
            key = offsetKey;
          } else {
            var firstLeaf = getFirstLeaf(node);
            key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
          }

          return {
            key: key,
            offset: 0
          };
        }

        var nodeBeforeCursor = node.childNodes[childOffset - 1];
        var leafKey = null;
        var textLength = null;

        if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
          // Our target node may be a leaf or a text node, in which case we're
          // already where we want to be and can just use the child's length as
          // our offset.
          leafKey = nullthrows(offsetKey);
          textLength = getTextContentLength(nodeBeforeCursor);
        } else {
          // Otherwise, we'll look at the child to the left of the cursor and find
          // the last leaf node in its subtree.
          var lastLeaf = getLastLeaf(nodeBeforeCursor);
          leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
          textLength = getTextContentLength(lastLeaf);
        }

        return {
          key: leafKey,
          offset: textLength
        };
      }
      /**
       * Return the length of a node's textContent, regarding single newline
       * characters as zero-length. This allows us to avoid problems with identifying
       * the correct selection offset for empty blocks in IE, in which we
       * render newlines instead of break tags.
       */


      function getTextContentLength(node) {
        var textContent = node.textContent;
        return textContent === '\n' ? 0 : textContent.length;
      }

      module.exports = getDraftEditorSelectionWithNodes;
      /***/
    },
    /* 467 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getRangeClientRects
       * @format
       * 
       */

      var UserAgent = __webpack_require__(113);

      var invariant = __webpack_require__(51);

      var isChrome = UserAgent.isBrowser('Chrome'); // In Chrome, the client rects will include the entire bounds of all nodes that
      // begin (have a start tag) within the selection, even if the selection does
      // not overlap the entire node. To resolve this, we split the range at each
      // start tag and join the client rects together.
      // https://code.google.com/p/chromium/issues/detail?id=324437

      /* eslint-disable consistent-return */

      function getRangeClientRectsChrome(range) {
        var tempRange = range.cloneRange();
        var clientRects = [];

        for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
          // If we've climbed up to the common ancestor, we can now use the
          // original start point and stop climbing the tree.
          var atCommonAncestor = ancestor === range.commonAncestorContainer;

          if (atCommonAncestor) {
            tempRange.setStart(range.startContainer, range.startOffset);
          } else {
            tempRange.setStart(tempRange.endContainer, 0);
          }

          var rects = Array.from(tempRange.getClientRects());
          clientRects.push(rects);

          if (atCommonAncestor) {
            var _ref;

            clientRects.reverse();
            return (_ref = []).concat.apply(_ref, clientRects);
          }

          tempRange.setEndBefore(ancestor);
        }

        true ? false ? undefined : invariant(false) : undefined;
      }
      /* eslint-enable consistent-return */

      /**
       * Like range.getClientRects() but normalizes for browser bugs.
       */


      var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
        return Array.from(range.getClientRects());
      };
      module.exports = getRangeClientRects;
      /***/
    },
    /* 468 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getFragmentFromSelection
       * @format
       * 
       */

      var getContentStateFragment = __webpack_require__(242);

      function getFragmentFromSelection(editorState) {
        var selectionState = editorState.getSelection();

        if (selectionState.isCollapsed()) {
          return null;
        }

        return getContentStateFragment(editorState.getCurrentContent(), selectionState);
      }

      module.exports = getFragmentFromSelection;
      /***/
    },
    /* 469 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getUpdatedSelectionState
       * @format
       * 
       */

      var DraftOffsetKey = __webpack_require__(182);

      var nullthrows = __webpack_require__(108);

      function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
        var selection = nullthrows(editorState.getSelection());

        if (false) {}

        var anchorPath = DraftOffsetKey.decode(anchorKey);
        var anchorBlockKey = anchorPath.blockKey;
        var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
        var focusPath = DraftOffsetKey.decode(focusKey);
        var focusBlockKey = focusPath.blockKey;
        var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);
        var anchorLeafStart = anchorLeaf.get('start');
        var focusLeafStart = focusLeaf.get('start');
        var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
        var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
        var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

        if (areEqual) {
          return selection;
        }

        var isBackward = false;

        if (anchorBlockKey === focusBlockKey) {
          var anchorLeafEnd = anchorLeaf.get('end');
          var focusLeafEnd = focusLeaf.get('end');

          if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
            isBackward = focusOffset < anchorOffset;
          } else {
            isBackward = focusLeafStart < anchorLeafStart;
          }
        } else {
          var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
            return v === anchorBlockKey || v === focusBlockKey;
          }).first();
          isBackward = startKey === focusBlockKey;
        }

        return selection.merge({
          anchorKey: anchorBlockKey,
          anchorOffset: anchorBlockOffset,
          focusKey: focusBlockKey,
          focusOffset: focusBlockOffset,
          isBackward: isBackward
        });
      }

      module.exports = getUpdatedSelectionState;
      /***/
    },
    /* 470 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (global) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        * All rights reserved.
        *
        * This source code is licensed under the BSD-style license found in the
        * LICENSE file in the root directory of this source tree. An additional grant
        * of patent rights can be found in the PATENTS file in the same directory.
        *
        * @providesModule getTextContentFromFiles
        * @format
        * 
        */
        var invariant = __webpack_require__(51);

        var TEXT_CLIPPING_REGEX = /\.textClipping$/;
        var TEXT_TYPES = {
          'text/plain': true,
          'text/html': true,
          'text/rtf': true
        }; // Somewhat arbitrary upper bound on text size. Let's not lock up the browser.

        var TEXT_SIZE_UPPER_BOUND = 5000;
        /**
         * Extract the text content from a file list.
         */

        function getTextContentFromFiles(files, callback) {
          var readCount = 0;
          var results = [];
          files.forEach(function (
          /*blob*/
          file) {
            readFile(file, function (
            /*string*/
            text) {
              readCount++;
              text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));

              if (readCount == files.length) {
                callback(results.join('\r'));
              }
            });
          });
        }
        /**
         * todo isaac: Do work to turn html/rtf into a content fragment.
         */


        function readFile(file, callback) {
          if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
            callback('');
            return;
          }

          if (file.type === '') {
            var contents = ''; // Special-case text clippings, which have an empty type but include
            // `.textClipping` in the file name. `readAsText` results in an empty
            // string for text clippings, so we force the file name to serve
            // as the text value for the file.

            if (TEXT_CLIPPING_REGEX.test(file.name)) {
              contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
            }

            callback(contents);
            return;
          }

          var reader = new FileReader();

          reader.onload = function () {
            var result = reader.result;
            !(typeof result === 'string') ? false ? undefined : invariant(false) : void 0;
            callback(result);
          };

          reader.onerror = function () {
            callback('');
          };

          reader.readAsText(file);
        }

        module.exports = getTextContentFromFiles;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 471 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getSelectionOffsetKeyForNode
       * @format
       * 
       */

      /**
       * Get offset key from a node or it's child nodes. Return the first offset key
       * found on the DOM tree of given node.
       */

      function getSelectionOffsetKeyForNode(node) {
        if (node instanceof Element) {
          var offsetKey = node.getAttribute('data-offset-key');

          if (offsetKey) {
            return offsetKey;
          }

          for (var ii = 0; ii < node.childNodes.length; ii++) {
            var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);

            if (childOffsetKey) {
              return childOffsetKey;
            }
          }
        }

        return null;
      }

      module.exports = getSelectionOffsetKeyForNode;
      /***/
    },
    /* 472 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */


      var PhotosMimeType = __webpack_require__(992);

      var createArrayFromMixed = __webpack_require__(991);

      var emptyFunction = __webpack_require__(345);

      var CR_LF_REGEX = new RegExp('\r\n', 'g');
      var LF_ONLY = '\n';
      var RICH_TEXT_TYPES = {
        'text/rtf': 1,
        'text/html': 1
      };
      /**
       * If DataTransferItem is a file then return the Blob of data.
       *
       * @param {object} item
       * @return {?blob}
       */

      function getFileFromDataTransfer(item) {
        if (item.kind == 'file') {
          return item.getAsFile();
        }
      }

      var DataTransfer = function () {
        /**
         * @param {object} data
         */
        function DataTransfer(data) {
          _classCallCheck(this, DataTransfer);

          this.data = data; // Types could be DOMStringList or array

          this.types = data.types ? createArrayFromMixed(data.types) : [];
        }
        /**
         * Is this likely to be a rich text data transfer?
         *
         * @return {boolean}
         */


        DataTransfer.prototype.isRichText = function isRichText() {
          // If HTML is available, treat this data as rich text. This way, we avoid
          // using a pasted image if it is packaged with HTML -- this may occur with
          // pastes from MS Word, for example.  However this is only rich text if
          // there's accompanying text.
          if (this.getHTML() && this.getText()) {
            return true;
          } // When an image is copied from a preview window, you end up with two
          // DataTransferItems one of which is a file's metadata as text.  Skip those.


          if (this.isImage()) {
            return false;
          }

          return this.types.some(function (type) {
            return RICH_TEXT_TYPES[type];
          });
        };
        /**
         * Get raw text.
         *
         * @return {?string}
         */


        DataTransfer.prototype.getText = function getText() {
          var text;

          if (this.data.getData) {
            if (!this.types.length) {
              text = this.data.getData('Text');
            } else if (this.types.indexOf('text/plain') != -1) {
              text = this.data.getData('text/plain');
            }
          }

          return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
        };
        /**
         * Get HTML paste data
         *
         * @return {?string}
         */


        DataTransfer.prototype.getHTML = function getHTML() {
          if (this.data.getData) {
            if (!this.types.length) {
              return this.data.getData('Text');
            } else if (this.types.indexOf('text/html') != -1) {
              return this.data.getData('text/html');
            }
          }
        };
        /**
         * Is this a link data transfer?
         *
         * @return {boolean}
         */


        DataTransfer.prototype.isLink = function isLink() {
          return this.types.some(function (type) {
            return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
          });
        };
        /**
         * Get a link url.
         *
         * @return {?string}
         */


        DataTransfer.prototype.getLink = function getLink() {
          if (this.data.getData) {
            if (this.types.indexOf('text/x-moz-url') != -1) {
              var url = this.data.getData('text/x-moz-url').split('\n');
              return url[0];
            }

            return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
          }

          return null;
        };
        /**
         * Is this an image data transfer?
         *
         * @return {boolean}
         */


        DataTransfer.prototype.isImage = function isImage() {
          var isImage = this.types.some(function (type) {
            // Firefox will have a type of application/x-moz-file for images during
            // dragging
            return type.indexOf('application/x-moz-file') != -1;
          });

          if (isImage) {
            return true;
          }

          var items = this.getFiles();

          for (var i = 0; i < items.length; i++) {
            var type = items[i].type;

            if (!PhotosMimeType.isImage(type)) {
              return false;
            }
          }

          return true;
        };

        DataTransfer.prototype.getCount = function getCount() {
          if (this.data.hasOwnProperty('items')) {
            return this.data.items.length;
          } else if (this.data.hasOwnProperty('mozItemCount')) {
            return this.data.mozItemCount;
          } else if (this.data.files) {
            return this.data.files.length;
          }

          return null;
        };
        /**
         * Get files.
         *
         * @return {array}
         */


        DataTransfer.prototype.getFiles = function getFiles() {
          if (this.data.items) {
            // createArrayFromMixed doesn't properly handle DataTransferItemLists.
            return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
          } else if (this.data.files) {
            return Array.prototype.slice.call(this.data.files);
          } else {
            return [];
          }
        };
        /**
         * Are there any files to fetch?
         *
         * @return {boolean}
         */


        DataTransfer.prototype.hasFiles = function hasFiles() {
          return this.getFiles().length > 0;
        };

        return DataTransfer;
      }();

      module.exports = DataTransfer;
      /***/
    },
    /* 473 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      /**
       * @param {DOMElement} element
       * @param {DOMDocument} doc
       * @return {boolean}
       */

      function _isViewportScrollElement(element, doc) {
        return !!doc && (element === doc.documentElement || element === doc.body);
      }
      /**
       * Scroll Module. This class contains 4 simple static functions
       * to be used to access Element.scrollTop/scrollLeft properties.
       * To solve the inconsistencies between browsers when either
       * document.body or document.documentElement is supplied,
       * below logic will be used to alleviate the issue:
       *
       * 1. If 'element' is either 'document.body' or 'document.documentElement,
       *    get whichever element's 'scroll{Top,Left}' is larger.
       * 2. If 'element' is either 'document.body' or 'document.documentElement',
       *    set the 'scroll{Top,Left}' on both elements.
       */


      var Scroll = {
        /**
         * @param {DOMElement} element
         * @return {number}
         */
        getTop: function getTop(element) {
          var doc = element.ownerDocument;
          return _isViewportScrollElement(element, doc) ? // In practice, they will either both have the same value,
          // or one will be zero and the other will be the scroll position
          // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
          doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
        },

        /**
         * @param {DOMElement} element
         * @param {number} newTop
         */
        setTop: function setTop(element, newTop) {
          var doc = element.ownerDocument;

          if (_isViewportScrollElement(element, doc)) {
            doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
          } else {
            element.scrollTop = newTop;
          }
        },

        /**
         * @param {DOMElement} element
         * @return {number}
         */
        getLeft: function getLeft(element) {
          var doc = element.ownerDocument;
          return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
        },

        /**
         * @param {DOMElement} element
         * @param {number} newLeft
         */
        setLeft: function setLeft(element, newLeft) {
          var doc = element.ownerDocument;

          if (_isViewportScrollElement(element, doc)) {
            doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
          } else {
            element.scrollLeft = newLeft;
          }
        }
      };
      module.exports = Scroll;
      /***/
    },
    /* 474 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      /* eslint-disable fb-www/typeof-undefined */

      /**
       * Same as document.activeElement but wraps in a try-catch block. In IE it is
       * not safe to call document.activeElement if there is nothing focused.
       *
       * The activeElement will be null only if the document or document body is not
       * yet defined.
       *
       * @param {?DOMDocument} doc Defaults to current document.
       * @return {?DOMElement}
       */

      function getActiveElement(doc)
      /*?DOMElement*/
      {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);

        if (typeof doc === 'undefined') {
          return null;
        }

        try {
          return doc.activeElement || doc.body;
        } catch (e) {
          return doc.body;
        }
      }

      module.exports = getActiveElement;
      /***/
    },
    /* 475 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEditorBlock.react
       * @format
       * 
       */

      var _assign = __webpack_require__(82);

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var DraftEditorLeaf = __webpack_require__(1014);

      var DraftOffsetKey = __webpack_require__(182);

      var React = __webpack_require__(1);

      var ReactDOM = __webpack_require__(16);

      var Scroll = __webpack_require__(473);

      var Style = __webpack_require__(337);

      var UnicodeBidi = __webpack_require__(478);

      var UnicodeBidiDirection = __webpack_require__(342);

      var cx = __webpack_require__(173);

      var getElementPosition = __webpack_require__(999);

      var getScrollPosition = __webpack_require__(336);

      var getViewportDimensions = __webpack_require__(995);

      var invariant = __webpack_require__(51);

      var nullthrows = __webpack_require__(108);

      var SCROLL_BUFFER = 10;
      /**
       * Return whether a block overlaps with either edge of the `SelectionState`.
       */

      var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
        return selection.getAnchorKey() === key || selection.getFocusKey() === key;
      };
      /**
       * The default block renderer for a `DraftEditor` component.
       *
       * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
       * appropriate decorator and inline style components.
       */


      var DraftEditorBlock = function (_React$Component) {
        _inherits(DraftEditorBlock, _React$Component);

        function DraftEditorBlock() {
          _classCallCheck(this, DraftEditorBlock);

          return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
        };
        /**
         * When a block is mounted and overlaps the selection state, we need to make
         * sure that the cursor is visible to match native behavior. This may not
         * be the case if the user has pressed `RETURN` or pasted some content, since
         * programatically creating these new blocks and setting the DOM selection
         * will miss out on the browser natively scrolling to that position.
         *
         * To replicate native behavior, if the block overlaps the selection state
         * on mount, force the scroll position. Check the scroll state of the scroll
         * parent, and adjust it to align the entire block to the bottom of the
         * scroll parent.
         */


        DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
          var selection = this.props.selection;
          var endKey = selection.getEndKey();

          if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
            return;
          }

          var blockNode = ReactDOM.findDOMNode(this);
          var scrollParent = Style.getScrollParent(blockNode);
          var scrollPosition = getScrollPosition(scrollParent);
          var scrollDelta = void 0;

          if (scrollParent === window) {
            var nodePosition = getElementPosition(blockNode);
            var nodeBottom = nodePosition.y + nodePosition.height;
            var viewportHeight = getViewportDimensions().height;
            scrollDelta = nodeBottom - viewportHeight;

            if (scrollDelta > 0) {
              window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
            }
          } else {
            !(blockNode instanceof HTMLElement) ? false ? undefined : invariant(false) : void 0;
            var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
            var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
            scrollDelta = blockBottom - scrollBottom;

            if (scrollDelta > 0) {
              Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
            }
          }
        };

        DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
          var _this2 = this;

          var block = this.props.block;
          var blockKey = block.getKey();
          var text = block.getText();
          var lastLeafSet = this.props.tree.size - 1;
          var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
          return this.props.tree.map(function (leafSet, ii) {
            var leavesForLeafSet = leafSet.get('leaves');
            var lastLeaf = leavesForLeafSet.size - 1;
            var leaves = leavesForLeafSet.map(function (leaf, jj) {
              var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
              var start = leaf.get('start');
              var end = leaf.get('end');
              return React.createElement(DraftEditorLeaf, {
                key: offsetKey,
                offsetKey: offsetKey,
                block: block,
                start: start,
                selection: hasSelection ? _this2.props.selection : null,
                forceSelection: _this2.props.forceSelection,
                text: text.slice(start, end),
                styleSet: block.getInlineStyleAt(start),
                customStyleMap: _this2.props.customStyleMap,
                customStyleFn: _this2.props.customStyleFn,
                isLast: ii === lastLeafSet && jj === lastLeaf
              });
            }).toArray();
            var decoratorKey = leafSet.get('decoratorKey');

            if (decoratorKey == null) {
              return leaves;
            }

            if (!_this2.props.decorator) {
              return leaves;
            }

            var decorator = nullthrows(_this2.props.decorator);
            var DecoratorComponent = decorator.getComponentForKey(decoratorKey);

            if (!DecoratorComponent) {
              return leaves;
            }

            var decoratorProps = decorator.getPropsForKey(decoratorKey);
            var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
            var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end')); // Resetting dir to the same value on a child node makes Chrome/Firefox
            // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/

            var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
            return React.createElement(DecoratorComponent, _extends({}, decoratorProps, {
              contentState: _this2.props.contentState,
              decoratedText: decoratedText,
              dir: dir,
              key: decoratorOffsetKey,
              entityKey: block.getEntityAt(leafSet.get('start')),
              offsetKey: decoratorOffsetKey
            }), leaves);
          }).toArray();
        };

        DraftEditorBlock.prototype.render = function render() {
          var _props = this.props,
              direction = _props.direction,
              offsetKey = _props.offsetKey;
          var className = cx({
            'public/DraftStyleDefault/block': true,
            'public/DraftStyleDefault/ltr': direction === 'LTR',
            'public/DraftStyleDefault/rtl': direction === 'RTL'
          });
          return React.createElement('div', {
            'data-offset-key': offsetKey,
            className: className
          }, this._renderChildren());
        };

        return DraftEditorBlock;
      }(React.Component);

      module.exports = DraftEditorBlock;
      /***/
    },
    /* 476 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule isSelectionAtLeafStart
       * @format
       * 
       */

      function isSelectionAtLeafStart(editorState) {
        var selection = editorState.getSelection();
        var anchorKey = selection.getAnchorKey();
        var blockTree = editorState.getBlockTree(anchorKey);
        var offset = selection.getStartOffset();
        var isAtStart = false;
        blockTree.some(function (leafSet) {
          if (offset === leafSet.get('start')) {
            isAtStart = true;
            return true;
          }

          if (offset < leafSet.get('end')) {
            return leafSet.get('leaves').some(function (leaf) {
              var leafStart = leaf.get('start');

              if (offset === leafStart) {
                isAtStart = true;
                return true;
              }

              return false;
            });
          }

          return false;
        });
        return isAtStart;
      }

      module.exports = isSelectionAtLeafStart;
      /***/
    },
    /* 477 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DefaultDraftInlineStyle
       * @format
       * 
       */

      module.exports = {
        BOLD: {
          fontWeight: 'bold'
        },
        CODE: {
          fontFamily: 'monospace',
          wordWrap: 'break-word'
        },
        ITALIC: {
          fontStyle: 'italic'
        },
        STRIKETHROUGH: {
          textDecoration: 'line-through'
        },
        UNDERLINE: {
          textDecoration: 'underline'
        }
      };
      /***/
    },
    /* 478 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       * 
       */

      /**
       * Basic (stateless) API for text direction detection
       *
       * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
       * Unicode Standard Annex #9 (UAX9)
       * http://www.unicode.org/reports/tr9/
       */

      var UnicodeBidiDirection = __webpack_require__(342);

      var invariant = __webpack_require__(51);
      /**
       * RegExp ranges of characters with a *Strong* Bidi_Class value.
       *
       * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
       *
       * NOTE: For performance reasons, we only support Unicode's
       *       Basic Multilingual Plane (BMP) for now.
       */


      var RANGE_BY_BIDI_TYPE = {
        L: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB" + "\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8" + "\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377" + "\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1" + "\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559" + "\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D" + "\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965" + "\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C" + "\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD" + "\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD" + "\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03" + "\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33" + "\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F" + "\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0" + "\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0" + "\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10" + "\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40" + "\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F" + "\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95" + "\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9" + "\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7" + "\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10" + "\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61" + "\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8" + "\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6" + "\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF" + "\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D" + "\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61" + "\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96" + "\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF" + "\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45" + "\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88" + "\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7" + "\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6" + "\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14" + "\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38" + "\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C" + "\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8" + "\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F" + "\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061" + "\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081" + "\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C" + "\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC" + "\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288" + "\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5" + "\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368" + "\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E" + "\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0" + "\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736" + "\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5" + "\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9" + "\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA" + "\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931" + "\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB" + "\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16" + "\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64" + "\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD" + "\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B" + "\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0" + "\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7" + "\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B" + "\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59" + "\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1" + "\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B" + "\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15" + "\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D" + "\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC" + "\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E" + "\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D" + "\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139" + "\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184" + "\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF" + "\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4" + "\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F" + "\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE" + "\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007" + "\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C" + "\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF" + "\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F" + "\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247" + "\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB" + "\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5" + "\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD" + "\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B" + "\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF" + "\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E" + "\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801" + "\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835" + "\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3" + "\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909" + "\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C" + "\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD" + "\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF" + "\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34" + "\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F" + "\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1" + "\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF" + "\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5" + "\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E" + "\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4" + "\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3" + "\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9" + "\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70" + "\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF" + "\uFFD2-\uFFD7\uFFDA-\uFFDC",
        R: "\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF" + "\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA" + "\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828" + "\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E" + "\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C" + "\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F",
        AL: "\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640" + "\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6" + "\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F" + "\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF" + "\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2" + "\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7" + "\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75" + "\uFE76-\uFEFC\uFEFD-\uFEFE"
      };
      var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
      var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
      /**
       * Returns the first strong character (has Bidi_Class value of L, R, or AL).
       *
       * @param str  A text block; e.g. paragraph, table cell, tag
       * @return     A character with strong bidi direction, or null if not found
       */

      function firstStrongChar(str) {
        var match = REGEX_STRONG.exec(str);
        return match == null ? null : match[0];
      }
      /**
       * Returns the direction of a block of text, based on the direction of its
       * first strong character (has Bidi_Class value of L, R, or AL).
       *
       * @param str  A text block; e.g. paragraph, table cell, tag
       * @return     The resolved direction
       */


      function firstStrongCharDir(str) {
        var strongChar = firstStrongChar(str);

        if (strongChar == null) {
          return UnicodeBidiDirection.NEUTRAL;
        }

        return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
      }
      /**
       * Returns the direction of a block of text, based on the direction of its
       * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
       * direction, if no strong character is found.
       *
       * This function is supposed to be used in respect to Higher-Level Protocol
       * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
       *
       * @param str       A text block; e.g. paragraph, table cell, tag
       * @param fallback  Fallback direction, used if no strong direction detected
       *                  for the block (default = NEUTRAL)
       * @return          The resolved direction
       */


      function resolveBlockDir(str, fallback) {
        fallback = fallback || UnicodeBidiDirection.NEUTRAL;

        if (!str.length) {
          return fallback;
        }

        var blockDir = firstStrongCharDir(str);
        return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
      }
      /**
       * Returns the direction of a block of text, based on the direction of its
       * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
       * direction, if no strong character is found.
       *
       * NOTE: This function is similar to resolveBlockDir(), but uses the global
       * direction as the fallback, so it *always* returns a Strong direction,
       * making it useful for integration in places that you need to make the final
       * decision, like setting some CSS class.
       *
       * This function is supposed to be used in respect to Higher-Level Protocol
       * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
       *
       * @param str             A text block; e.g. paragraph, table cell
       * @param strongFallback  Fallback direction, used if no strong direction
       *                        detected for the block (default = global direction)
       * @return                The resolved Strong direction
       */


      function getDirection(str, strongFallback) {
        if (!strongFallback) {
          strongFallback = UnicodeBidiDirection.getGlobalDir();
        }

        !UnicodeBidiDirection.isStrong(strongFallback) ? false ? undefined : invariant(false) : void 0;
        return resolveBlockDir(str, strongFallback);
      }
      /**
       * Returns true if getDirection(arguments...) returns LTR.
       *
       * @param str             A text block; e.g. paragraph, table cell
       * @param strongFallback  Fallback direction, used if no strong direction
       *                        detected for the block (default = global direction)
       * @return                True if the resolved direction is LTR
       */


      function isDirectionLTR(str, strongFallback) {
        return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
      }
      /**
       * Returns true if getDirection(arguments...) returns RTL.
       *
       * @param str             A text block; e.g. paragraph, table cell
       * @param strongFallback  Fallback direction, used if no strong direction
       *                        detected for the block (default = global direction)
       * @return                True if the resolved direction is RTL
       */


      function isDirectionRTL(str, strongFallback) {
        return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
      }

      var UnicodeBidi = {
        firstStrongChar: firstStrongChar,
        firstStrongCharDir: firstStrongCharDir,
        resolveBlockDir: resolveBlockDir,
        getDirection: getDirection,
        isDirectionLTR: isDirectionLTR,
        isDirectionRTL: isDirectionRTL
      };
      module.exports = UnicodeBidi;
      /***/
    },
    /* 479 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEntityInstance
       * @legacyServerCallableInstance
       * @format
       * 
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Immutable = __webpack_require__(53);

      var Record = Immutable.Record;
      var DraftEntityInstanceRecord = Record({
        type: 'TOKEN',
        mutability: 'IMMUTABLE',
        data: Object
      });
      /**
       * An instance of a document entity, consisting of a `type` and relevant
       * `data`, metadata about the entity.
       *
       * For instance, a "link" entity might provide a URI, and a "mention"
       * entity might provide the mentioned user's ID. These pieces of data
       * may be used when rendering the entity as part of a ContentBlock DOM
       * representation. For a link, the data would be used as an href for
       * the rendered anchor. For a mention, the ID could be used to retrieve
       * a hovercard.
       */

      var DraftEntityInstance = function (_DraftEntityInstanceR) {
        _inherits(DraftEntityInstance, _DraftEntityInstanceR);

        function DraftEntityInstance() {
          _classCallCheck(this, DraftEntityInstance);

          return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
        }

        DraftEntityInstance.prototype.getType = function getType() {
          return this.get('type');
        };

        DraftEntityInstance.prototype.getMutability = function getMutability() {
          return this.get('mutability');
        };

        DraftEntityInstance.prototype.getData = function getData() {
          return this.get('data');
        };

        return DraftEntityInstance;
      }(DraftEntityInstanceRecord);

      module.exports = DraftEntityInstance;
      /***/
    },
    /* 480 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule BlockTree
       * @format
       * 
       */

      var Immutable = __webpack_require__(53);

      var emptyFunction = __webpack_require__(345);

      var findRangesImmutable = __webpack_require__(205);

      var List = Immutable.List,
          Repeat = Immutable.Repeat,
          Record = Immutable.Record;
      var returnTrue = emptyFunction.thatReturnsTrue;
      var FINGERPRINT_DELIMITER = '-';
      var defaultLeafRange = {
        start: null,
        end: null
      };
      var LeafRange = Record(defaultLeafRange);
      var defaultDecoratorRange = {
        start: null,
        end: null,
        decoratorKey: null,
        leaves: null
      };
      var DecoratorRange = Record(defaultDecoratorRange);
      var BlockTree = {
        /**
         * Generate a block tree for a given ContentBlock/decorator pair.
         */
        generate: function generate(contentState, block, decorator) {
          var textLength = block.getLength();

          if (!textLength) {
            return List.of(new DecoratorRange({
              start: 0,
              end: 0,
              decoratorKey: null,
              leaves: List.of(new LeafRange({
                start: 0,
                end: 0
              }))
            }));
          }

          var leafSets = [];
          var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));
          var chars = block.getCharacterList();
          findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
            leafSets.push(new DecoratorRange({
              start: start,
              end: end,
              decoratorKey: decorations.get(start),
              leaves: generateLeaves(chars.slice(start, end).toList(), start)
            }));
          });
          return List(leafSets);
        },

        /**
         * Create a string representation of the given tree map. This allows us
         * to rapidly determine whether a tree has undergone a significant
         * structural change.
         */
        getFingerprint: function getFingerprint(tree) {
          return tree.map(function (leafSet) {
            var decoratorKey = leafSet.get('decoratorKey');
            var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
            return '' + fingerprintString + '.' + leafSet.get('leaves').size;
          }).join(FINGERPRINT_DELIMITER);
        }
      };
      /**
       * Generate LeafRange records for a given character list.
       */

      function generateLeaves(characters, offset) {
        var leaves = [];
        var inlineStyles = characters.map(function (c) {
          return c.getStyle();
        }).toList();
        findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
          leaves.push(new LeafRange({
            start: start + offset,
            end: end + offset
          }));
        });
        return List(leaves);
      }

      function areEqual(a, b) {
        return a === b;
      }

      module.exports = BlockTree;
      /***/
    },
    /* 481 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getNextDelimiterBlockKey
       * @format
       * 
       *
       * This is unstable and not part of the public API and should not be used by
       * production systems. This file may be update/removed without notice.
       */

      var ContentBlockNode = __webpack_require__(102);

      var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
        var isExperimentalTreeBlock = block instanceof ContentBlockNode;

        if (!isExperimentalTreeBlock) {
          return null;
        }

        var nextSiblingKey = block.getNextSiblingKey();

        if (nextSiblingKey) {
          return nextSiblingKey;
        }

        var parent = block.getParentKey();

        if (!parent) {
          return null;
        }

        var nextNonDescendantBlock = blockMap.get(parent);

        while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
          var parentKey = nextNonDescendantBlock.getParentKey();
          nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
        }

        if (!nextNonDescendantBlock) {
          return null;
        }

        return nextNonDescendantBlock.getNextSiblingKey();
      };

      module.exports = getNextDelimiterBlockKey;
      /***/
    },
    /* 482 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule insertIntoList
       * @format
       * 
       */

      /**
       * Maintain persistence for target list when appending and prepending.
       */

      function insertIntoList(targetList, toInsert, offset) {
        if (offset === targetList.count()) {
          toInsert.forEach(function (c) {
            targetList = targetList.push(c);
          });
        } else if (offset === 0) {
          toInsert.reverse().forEach(function (c) {
            targetList = targetList.unshift(c);
          });
        } else {
          var head = targetList.slice(0, offset);
          var tail = targetList.slice(offset);
          targetList = head.concat(toInsert, tail).toList();
        }

        return targetList;
      }

      module.exports = insertIntoList;
      /***/
    },
    /* 483 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule removeEntitiesAtEdges
       * @format
       * 
       */

      var CharacterMetadata = __webpack_require__(96);

      var findRangesImmutable = __webpack_require__(205);

      var invariant = __webpack_require__(51);

      function removeEntitiesAtEdges(contentState, selectionState) {
        var blockMap = contentState.getBlockMap();
        var entityMap = contentState.getEntityMap();
        var updatedBlocks = {};
        var startKey = selectionState.getStartKey();
        var startOffset = selectionState.getStartOffset();
        var startBlock = blockMap.get(startKey);
        var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

        if (updatedStart !== startBlock) {
          updatedBlocks[startKey] = updatedStart;
        }

        var endKey = selectionState.getEndKey();
        var endOffset = selectionState.getEndOffset();
        var endBlock = blockMap.get(endKey);

        if (startKey === endKey) {
          endBlock = updatedStart;
        }

        var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

        if (updatedEnd !== endBlock) {
          updatedBlocks[endKey] = updatedEnd;
        }

        if (!Object.keys(updatedBlocks).length) {
          return contentState.set('selectionAfter', selectionState);
        }

        return contentState.merge({
          blockMap: blockMap.merge(updatedBlocks),
          selectionAfter: selectionState
        });
      }

      function getRemovalRange(characters, key, offset) {
        var removalRange;
        findRangesImmutable(characters, function (a, b) {
          return a.getEntity() === b.getEntity();
        }, function (element) {
          return element.getEntity() === key;
        }, function (start, end) {
          if (start <= offset && end >= offset) {
            removalRange = {
              start: start,
              end: end
            };
          }
        });
        !(typeof removalRange === 'object') ? false ? undefined : invariant(false) : void 0;
        return removalRange;
      }

      function removeForBlock(entityMap, block, offset) {
        var chars = block.getCharacterList();
        var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
        var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
        var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
        var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

        if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
          var entity = entityMap.__get(entityAfterCursor);

          if (entity.getMutability() !== 'MUTABLE') {
            var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
                start = _getRemovalRange.start,
                end = _getRemovalRange.end;

            var current;

            while (start < end) {
              current = chars.get(start);
              chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
              start++;
            }

            return block.set('characterList', chars);
          }
        }

        return block;
      }

      module.exports = removeEntitiesAtEdges;
      /***/
    },
    /* 484 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule randomizeBlockMapKeys
       * @format
       * 
       */

      var ContentBlockNode = __webpack_require__(102);

      var Immutable = __webpack_require__(53);

      var generateRandomKey = __webpack_require__(127);

      var OrderedMap = Immutable.OrderedMap;

      var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
        var newKeysRef = {}; // we keep track of root blocks in order to update subsequent sibling links

        var lastRootBlock = void 0;
        return OrderedMap(blockMap.withMutations(function (blockMapState) {
          blockMapState.forEach(function (block, index) {
            var oldKey = block.getKey();
            var nextKey = block.getNextSiblingKey();
            var prevKey = block.getPrevSiblingKey();
            var childrenKeys = block.getChildKeys();
            var parentKey = block.getParentKey(); // new key that we will use to build linking

            var key = generateRandomKey(); // we will add it here to re-use it later

            newKeysRef[oldKey] = key;

            if (nextKey) {
              var nextBlock = blockMapState.get(nextKey);

              if (nextBlock) {
                blockMapState.setIn([nextKey, 'prevSibling'], key);
              } else {
                // this can happen when generating random keys for fragments
                blockMapState.setIn([oldKey, 'nextSibling'], null);
              }
            }

            if (prevKey) {
              var prevBlock = blockMapState.get(prevKey);

              if (prevBlock) {
                blockMapState.setIn([prevKey, 'nextSibling'], key);
              } else {
                // this can happen when generating random keys for fragments
                blockMapState.setIn([oldKey, 'prevSibling'], null);
              }
            }

            if (parentKey && blockMapState.get(parentKey)) {
              var parentBlock = blockMapState.get(parentKey);
              var parentChildrenList = parentBlock.getChildKeys();
              blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
            } else {
              // blocks will then be treated as root block nodes
              blockMapState.setIn([oldKey, 'parent'], null);

              if (lastRootBlock) {
                blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
                blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
              }

              lastRootBlock = blockMapState.get(oldKey);
            }

            childrenKeys.forEach(function (childKey) {
              var childBlock = blockMapState.get(childKey);

              if (childBlock) {
                blockMapState.setIn([childKey, 'parent'], key);
              } else {
                blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
                  return child !== childKey;
                }));
              }
            });
          });
        }).toArray().map(function (block) {
          return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
        }));
      };

      var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
        return OrderedMap(blockMap.toArray().map(function (block) {
          var key = generateRandomKey();
          return [key, block.set('key', key)];
        }));
      };

      var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
        var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;

        if (!isTreeBasedBlockMap) {
          return randomizeContentBlockKeys(blockMap);
        }

        return randomizeContentBlockNodeKeys(blockMap);
      };

      module.exports = randomizeBlockMapKeys;
      /***/
    },
    /* 485 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global) {
        /**
        * lodash (Custom Build) <https://lodash.com/>
        * Build: `lodash modularize exports="npm" -o ./`
        * Copyright jQuery Foundation and other contributors <https://jquery.org/>
        * Released under MIT license <https://lodash.com/license>
        * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
        * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
        */

        /** Used as the `TypeError` message for "Functions" methods. */
        var FUNC_ERROR_TEXT = 'Expected a function';
        /** Used as references for various `Number` constants. */

        var NAN = 0 / 0;
        /** `Object#toString` result references. */

        var symbolTag = '[object Symbol]';
        /** Used to match leading and trailing whitespace. */

        var reTrim = /^\s+|\s+$/g;
        /** Used to detect bad signed hexadecimal string values. */

        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
        /** Used to detect binary string values. */

        var reIsBinary = /^0b[01]+$/i;
        /** Used to detect octal string values. */

        var reIsOctal = /^0o[0-7]+$/i;
        /** Built-in method references without a dependency on `root`. */

        var freeParseInt = parseInt;
        /** Detect free variable `global` from Node.js. */

        var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
        /** Detect free variable `self`. */

        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        /** Used as a reference to the global object. */

        var root = freeGlobal || freeSelf || Function('return this')();
        /** Used for built-in method references. */

        var objectProto = Object.prototype;
        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */

        var objectToString = objectProto.toString;
        /* Built-in method references for those with the same name as other `lodash` methods. */

        var nativeMax = Math.max,
            nativeMin = Math.min;
        /**
         * Gets the timestamp of the number of milliseconds that have elapsed since
         * the Unix epoch (1 January 1970 00:00:00 UTC).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Date
         * @returns {number} Returns the timestamp.
         * @example
         *
         * _.defer(function(stamp) {
         *   console.log(_.now() - stamp);
         * }, _.now());
         * // => Logs the number of milliseconds it took for the deferred invocation.
         */

        var now = function now() {
          return root.Date.now();
        };
        /**
         * Creates a debounced function that delays invoking `func` until after `wait`
         * milliseconds have elapsed since the last time the debounced function was
         * invoked. The debounced function comes with a `cancel` method to cancel
         * delayed `func` invocations and a `flush` method to immediately invoke them.
         * Provide `options` to indicate whether `func` should be invoked on the
         * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
         * with the last arguments provided to the debounced function. Subsequent
         * calls to the debounced function return the result of the last `func`
         * invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the debounced function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.debounce` and `_.throttle`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to debounce.
         * @param {number} [wait=0] The number of milliseconds to delay.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=false]
         *  Specify invoking on the leading edge of the timeout.
         * @param {number} [options.maxWait]
         *  The maximum time `func` is allowed to be delayed before it's invoked.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new debounced function.
         * @example
         *
         * // Avoid costly calculations while the window size is in flux.
         * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
         *
         * // Invoke `sendMail` when clicked, debouncing subsequent calls.
         * jQuery(element).on('click', _.debounce(sendMail, 300, {
         *   'leading': true,
         *   'trailing': false
         * }));
         *
         * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
         * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
         * var source = new EventSource('/stream');
         * jQuery(source).on('message', debounced);
         *
         * // Cancel the trailing debounced invocation.
         * jQuery(window).on('popstate', debounced.cancel);
         */


        function debounce(func, wait, options) {
          var lastArgs,
              lastThis,
              maxWait,
              result,
              timerId,
              lastCallTime,
              lastInvokeTime = 0,
              leading = false,
              maxing = false,
              trailing = true;

          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          wait = toNumber(wait) || 0;

          if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
          }

          function invokeFunc(time) {
            var args = lastArgs,
                thisArg = lastThis;
            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
          }

          function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time; // Start the timer for the trailing edge.

            timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

            return leading ? invokeFunc(time) : result;
          }

          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime,
                timeSinceLastInvoke = time - lastInvokeTime,
                result = wait - timeSinceLastCall;
            return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
          }

          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime,
                timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.

            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }

          function timerExpired() {
            var time = now();

            if (shouldInvoke(time)) {
              return trailingEdge(time);
            } // Restart the timer.


            timerId = setTimeout(timerExpired, remainingWait(time));
          }

          function trailingEdge(time) {
            timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.

            if (trailing && lastArgs) {
              return invokeFunc(time);
            }

            lastArgs = lastThis = undefined;
            return result;
          }

          function cancel() {
            if (timerId !== undefined) {
              clearTimeout(timerId);
            }

            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
          }

          function flush() {
            return timerId === undefined ? result : trailingEdge(now());
          }

          function debounced() {
            var time = now(),
                isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;

            if (isInvoking) {
              if (timerId === undefined) {
                return leadingEdge(lastCallTime);
              }

              if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }

            if (timerId === undefined) {
              timerId = setTimeout(timerExpired, wait);
            }

            return result;
          }

          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        /**
         * Creates a throttled function that only invokes `func` at most once per
         * every `wait` milliseconds. The throttled function comes with a `cancel`
         * method to cancel delayed `func` invocations and a `flush` method to
         * immediately invoke them. Provide `options` to indicate whether `func`
         * should be invoked on the leading and/or trailing edge of the `wait`
         * timeout. The `func` is invoked with the last arguments provided to the
         * throttled function. Subsequent calls to the throttled function return the
         * result of the last `func` invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the throttled function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.throttle` and `_.debounce`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to throttle.
         * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=true]
         *  Specify invoking on the leading edge of the timeout.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new throttled function.
         * @example
         *
         * // Avoid excessively updating the position while scrolling.
         * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
         *
         * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
         * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
         * jQuery(element).on('click', throttled);
         *
         * // Cancel the trailing throttled invocation.
         * jQuery(window).on('popstate', throttled.cancel);
         */


        function throttle(func, wait, options) {
          var leading = true,
              trailing = true;

          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          if (isObject(options)) {
            leading = 'leading' in options ? !!options.leading : leading;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
          }

          return debounce(func, wait, {
            'leading': leading,
            'maxWait': wait,
            'trailing': trailing
          });
        }
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */


        function isObject(value) {
          var type = typeof value;
          return !!value && (type == 'object' || type == 'function');
        }
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */


        function isObjectLike(value) {
          return !!value && typeof value == 'object';
        }
        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */


        function isSymbol(value) {
          return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
        }
        /**
         * Converts `value` to a number.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         * @example
         *
         * _.toNumber(3.2);
         * // => 3.2
         *
         * _.toNumber(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toNumber(Infinity);
         * // => Infinity
         *
         * _.toNumber('3.2');
         * // => 3.2
         */


        function toNumber(value) {
          if (typeof value == 'number') {
            return value;
          }

          if (isSymbol(value)) {
            return NAN;
          }

          if (isObject(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject(other) ? other + '' : other;
          }

          if (typeof value != 'string') {
            return value === 0 ? value : +value;
          }

          value = value.replace(reTrim, '');
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }

        module.exports = throttle;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 486 */

    /***/
    function (module, exports, __webpack_require__) {
      var eq = __webpack_require__(163),
          isArrayLike = __webpack_require__(134),
          isIndex = __webpack_require__(250),
          isObject = __webpack_require__(97);
      /**
       * Checks if the given arguments are from an iteratee call.
       *
       * @private
       * @param {*} value The potential iteratee value argument.
       * @param {*} index The potential iteratee index or key argument.
       * @param {*} object The potential iteratee object argument.
       * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
       *  else `false`.
       */


      function isIterateeCall(value, index, object) {
        if (!isObject(object)) {
          return false;
        }

        var type = typeof index;

        if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
          return eq(object[index], value);
        }

        return false;
      }

      module.exports = isIterateeCall;
      /***/
    },
    /* 487 */

    /***/
    function (module, exports) {
      /**
       * Creates a function that returns `value`.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Util
       * @param {*} value The value to return from the new function.
       * @returns {Function} Returns the new constant function.
       * @example
       *
       * var objects = _.times(2, _.constant({ 'a': 1 }));
       *
       * console.log(objects);
       * // => [{ 'a': 1 }, { 'a': 1 }]
       *
       * console.log(objects[0] === objects[1]);
       * // => true
       */
      function constant(value) {
        return function () {
          return value;
        };
      }

      module.exports = constant;
      /***/
    },
    /* 488 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseSetToString = __webpack_require__(1043),
          shortOut = __webpack_require__(1042);
      /**
       * Sets the `toString` method of `func` to return `string`.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */


      var setToString = shortOut(baseSetToString);
      module.exports = setToString;
      /***/
    },
    /* 489 */

    /***/
    function (module, exports, __webpack_require__) {
      var apply = __webpack_require__(1044);
      /* Built-in method references for those with the same name as other `lodash` methods. */


      var nativeMax = Math.max;
      /**
       * A specialized version of `baseRest` which transforms the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @param {Function} transform The rest array transform.
       * @returns {Function} Returns the new function.
       */

      function overRest(func, start, transform) {
        start = nativeMax(start === undefined ? func.length - 1 : start, 0);
        return function () {
          var args = arguments,
              index = -1,
              length = nativeMax(args.length - start, 0),
              array = Array(length);

          while (++index < length) {
            array[index] = args[start + index];
          }

          index = -1;
          var otherArgs = Array(start + 1);

          while (++index < start) {
            otherArgs[index] = args[index];
          }

          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }

      module.exports = overRest;
      /***/
    },
    /* 490 */

    /***/
    function (module, exports, __webpack_require__) {
      var identity = __webpack_require__(207),
          overRest = __webpack_require__(489),
          setToString = __webpack_require__(488);
      /**
       * The base implementation of `_.rest` which doesn't validate or coerce arguments.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       */


      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + '');
      }

      module.exports = baseRest;
      /***/
    },
    /* 491 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseRest = __webpack_require__(490),
          isIterateeCall = __webpack_require__(486);
      /**
       * Creates a function like `_.assign`.
       *
       * @private
       * @param {Function} assigner The function to assign values.
       * @returns {Function} Returns the new assigner function.
       */


      function createAssigner(assigner) {
        return baseRest(function (object, sources) {
          var index = -1,
              length = sources.length,
              customizer = length > 1 ? sources[length - 1] : undefined,
              guard = length > 2 ? sources[2] : undefined;
          customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
          }

          object = Object(object);

          while (++index < length) {
            var source = sources[index];

            if (source) {
              assigner(object, source, index, customizer);
            }
          }

          return object;
        });
      }

      module.exports = createAssigner;
      /***/
    },
    /* 492 */

    /***/
    function (module, exports) {
      /**
       * The base implementation of `_.times` without support for iteratee shorthands
       * or max array length checks.
       *
       * @private
       * @param {number} n The number of times to invoke `iteratee`.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the array of results.
       */
      function baseTimes(n, iteratee) {
        var index = -1,
            result = Array(n);

        while (++index < n) {
          result[index] = iteratee(index);
        }

        return result;
      }

      module.exports = baseTimes;
      /***/
    },
    /* 493 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseTimes = __webpack_require__(492),
          isArguments = __webpack_require__(211),
          isArray = __webpack_require__(55),
          isBuffer = __webpack_require__(208),
          isIndex = __webpack_require__(250),
          isTypedArray = __webpack_require__(245);
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Creates an array of the enumerable property names of the array-like `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @param {boolean} inherited Specify returning inherited property names.
       * @returns {Array} Returns the array of property names.
       */

      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value),
            isArg = !isArr && isArguments(value),
            isBuff = !isArr && !isArg && isBuffer(value),
            isType = !isArr && !isArg && !isBuff && isTypedArray(value),
            skipIndexes = isArr || isArg || isBuff || isType,
            result = skipIndexes ? baseTimes(value.length, String) : [],
            length = result.length;

        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
          key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
          isIndex(key, length)))) {
            result.push(key);
          }
        }

        return result;
      }

      module.exports = arrayLikeKeys;
      /***/
    },
    /* 494 */

    /***/
    function (module, exports) {
      /**
       * Gets the value at `key`, unless `key` is "__proto__".
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the property to get.
       * @returns {*} Returns the property value.
       */
      function safeGet(object, key) {
        if (key == '__proto__') {
          return;
        }

        return object[key];
      }

      module.exports = safeGet;
      /***/
    },
    /* 495 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGetTag = __webpack_require__(135),
          getPrototype = __webpack_require__(347),
          isObjectLike = __webpack_require__(109);
      /** `Object#toString` result references. */


      var objectTag = '[object Object]';
      /** Used for built-in method references. */

      var funcProto = Function.prototype,
          objectProto = Object.prototype;
      /** Used to resolve the decompiled source of functions. */

      var funcToString = funcProto.toString;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /** Used to infer the `Object` constructor. */

      var objectCtorString = funcToString.call(Object);
      /**
       * Checks if `value` is a plain object, that is, an object created by the
       * `Object` constructor or one with a `[[Prototype]]` of `null`.
       *
       * @static
       * @memberOf _
       * @since 0.8.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * _.isPlainObject(new Foo);
       * // => false
       *
       * _.isPlainObject([1, 2, 3]);
       * // => false
       *
       * _.isPlainObject({ 'x': 0, 'y': 0 });
       * // => true
       *
       * _.isPlainObject(Object.create(null));
       * // => true
       */

      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }

        var proto = getPrototype(value);

        if (proto === null) {
          return true;
        }

        var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }

      module.exports = isPlainObject;
      /***/
    },
    /* 496 */

    /***/
    function (module, exports, __webpack_require__) {
      var isArrayLike = __webpack_require__(134),
          isObjectLike = __webpack_require__(109);
      /**
       * This method is like `_.isArrayLike` except that it also checks if `value`
       * is an object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array-like object,
       *  else `false`.
       * @example
       *
       * _.isArrayLikeObject([1, 2, 3]);
       * // => true
       *
       * _.isArrayLikeObject(document.body.children);
       * // => true
       *
       * _.isArrayLikeObject('abc');
       * // => false
       *
       * _.isArrayLikeObject(_.noop);
       * // => false
       */


      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }

      module.exports = isArrayLikeObject;
      /***/
    },
    /* 497 */

    /***/
    function (module, exports) {
      /**
       * Creates a unary function that invokes `func` with its argument transformed.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {Function} transform The argument transform.
       * @returns {Function} Returns the new function.
       */
      function overArg(func, transform) {
        return function (arg) {
          return func(transform(arg));
        };
      }

      module.exports = overArg;
      /***/
    },
    /* 498 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseCreate = __webpack_require__(1050),
          getPrototype = __webpack_require__(347),
          isPrototype = __webpack_require__(209);
      /**
       * Initializes an object clone.
       *
       * @private
       * @param {Object} object The object to clone.
       * @returns {Object} Returns the initialized clone.
       */


      function initCloneObject(object) {
        return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }

      module.exports = initCloneObject;
      /***/
    },
    /* 499 */

    /***/
    function (module, exports, __webpack_require__) {
      var root = __webpack_require__(103);
      /** Built-in value references. */


      var Uint8Array = root.Uint8Array;
      module.exports = Uint8Array;
      /***/
    },
    /* 500 */

    /***/
    function (module, exports, __webpack_require__) {
      var cloneArrayBuffer = __webpack_require__(348);
      /**
       * Creates a clone of `typedArray`.
       *
       * @private
       * @param {Object} typedArray The typed array to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned typed array.
       */


      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }

      module.exports = cloneTypedArray;
      /***/
    },
    /* 501 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (module) {
        var root = __webpack_require__(103);
        /** Detect free variable `exports`. */


        var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
        /** Detect free variable `module`. */

        var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
        /** Detect the popular CommonJS extension `module.exports`. */

        var moduleExports = freeModule && freeModule.exports === freeExports;
        /** Built-in value references. */

        var Buffer = moduleExports ? root.Buffer : undefined,
            allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
        /**
         * Creates a clone of  `buffer`.
         *
         * @private
         * @param {Buffer} buffer The buffer to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Buffer} Returns the cloned buffer.
         */

        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }

          var length = buffer.length,
              result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result);
          return result;
        }

        module.exports = cloneBuffer;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(212)(module));
      /***/
    },
    /* 502 */

    /***/
    function (module, exports, __webpack_require__) {
      var createBaseFor = __webpack_require__(1052);
      /**
       * The base implementation of `baseForOwn` which iterates over `object`
       * properties returned by `keysFunc` and invokes `iteratee` for each property.
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @returns {Object} Returns `object`.
       */


      var baseFor = createBaseFor();
      module.exports = baseFor;
      /***/
    },
    /* 503 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseAssignValue = __webpack_require__(210),
          eq = __webpack_require__(163);
      /**
       * This function is like `assignValue` except that it doesn't assign
       * `undefined` values.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */


      function assignMergeValue(object, key, value) {
        if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }

      module.exports = assignMergeValue;
      /***/
    },
    /* 504 */

    /***/
    function (module, exports, __webpack_require__) {
      // most Object methods by ES6 should accept primitives
      var $export = __webpack_require__(139);

      var core = __webpack_require__(89);

      var fails = __webpack_require__(179);

      module.exports = function (KEY, exec) {
        var fn = (core.Object || {})[KEY] || Object[KEY];
        var exp = {};
        exp[KEY] = exec(fn);
        $export($export.S + $export.F * fails(function () {
          fn(1);
        }), 'Object', exp);
      };
      /***/

    },
    /* 505 */

    /***/
    function (module, exports, __webpack_require__) {
      var getNative = __webpack_require__(157);

      var defineProperty = function () {
        try {
          var func = getNative(Object, 'defineProperty');
          func({}, '', {});
          return func;
        } catch (e) {}
      }();

      module.exports = defineProperty;
      /***/
    },
    /* 506 */

    /***/
    function (module, exports, __webpack_require__) {
      var assignValue = __webpack_require__(248),
          castPath = __webpack_require__(177),
          isIndex = __webpack_require__(250),
          isObject = __webpack_require__(97),
          toKey = __webpack_require__(175);
      /**
       * The base implementation of `_.set`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @param {Function} [customizer] The function to customize path creation.
       * @returns {Object} Returns `object`.
       */


      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }

        path = castPath(path, object);
        var index = -1,
            length = path.length,
            lastIndex = length - 1,
            nested = object;

        while (nested != null && ++index < length) {
          var key = toKey(path[index]),
              newValue = value;

          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;

            if (newValue === undefined) {
              newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
          }

          assignValue(nested, key, newValue);
          nested = nested[key];
        }

        return object;
      }

      module.exports = baseSet;
      /***/
    },
    /* 507 */

    /***/
    function (module, exports, __webpack_require__) {
      var Symbol = __webpack_require__(158),
          arrayMap = __webpack_require__(176),
          isArray = __webpack_require__(55),
          isSymbol = __webpack_require__(255);
      /** Used as references for various `Number` constants. */


      var INFINITY = 1 / 0;
      /** Used to convert symbols to primitives and strings. */

      var symbolProto = Symbol ? Symbol.prototype : undefined,
          symbolToString = symbolProto ? symbolProto.toString : undefined;
      /**
       * The base implementation of `_.toString` which doesn't convert nullish
       * values to empty strings.
       *
       * @private
       * @param {*} value The value to process.
       * @returns {string} Returns the string.
       */

      function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == 'string') {
          return value;
        }

        if (isArray(value)) {
          // Recursively convert values (susceptible to call stack limits).
          return arrayMap(value, baseToString) + '';
        }

        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : '';
        }

        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }

      module.exports = baseToString;
      /***/
    },
    /* 508 */

    /***/
    function (module, exports) {
      /** Used for built-in method references. */
      var funcProto = Function.prototype;
      /** Used to resolve the decompiled source of functions. */

      var funcToString = funcProto.toString;
      /**
       * Converts `func` to its source code.
       *
       * @private
       * @param {Function} func The function to convert.
       * @returns {string} Returns the source code.
       */

      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {}

          try {
            return func + '';
          } catch (e) {}
        }

        return '';
      }

      module.exports = toSource;
      /***/
    },
    /* 509 */

    /***/
    function (module, exports, __webpack_require__) {
      var castPath = __webpack_require__(177),
          isArguments = __webpack_require__(211),
          isArray = __webpack_require__(55),
          isIndex = __webpack_require__(250),
          isLength = __webpack_require__(349),
          toKey = __webpack_require__(175);
      /**
       * Checks if `path` exists on `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @param {Function} hasFunc The function to check properties.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       */


      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index = -1,
            length = path.length,
            result = false;

        while (++index < length) {
          var key = toKey(path[index]);

          if (!(result = object != null && hasFunc(object, key))) {
            break;
          }

          object = object[key];
        }

        if (result || ++index != length) {
          return result;
        }

        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
      }

      module.exports = hasPath;
      /***/
    },
    /* 510 */

    /***/
    function (module, exports) {
      /**
       * Helper function for iterating over a collection
       *
       * @param collection
       * @param fn
       */
      function each(collection, fn) {
        var i = 0,
            length = collection.length,
            cont;

        for (i; i < length; i++) {
          cont = fn(collection[i], i);

          if (cont === false) {
            break; //allow early exit
          }
        }
      }
      /**
       * Helper function for determining whether target object is an array
       *
       * @param target the object under test
       * @return {Boolean} true if array, false otherwise
       */


      function isArray(target) {
        return Object.prototype.toString.apply(target) === '[object Array]';
      }
      /**
       * Helper function for determining whether target object is a function
       *
       * @param target the object under test
       * @return {Boolean} true if function, false otherwise
       */


      function isFunction(target) {
        return typeof target === 'function';
      }

      module.exports = {
        isFunction: isFunction,
        isArray: isArray,
        each: each
      };
      /***/
    },
    /* 511 */

    /***/
    function (module, exports, __webpack_require__) {
      var MediaQueryDispatch = __webpack_require__(1095);

      module.exports = new MediaQueryDispatch();
      /***/
    },
    /* 512 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var defaultProps = {
        accessibility: true,
        adaptiveHeight: false,
        afterChange: null,
        appendDots: function appendDots(dots) {
          return _react2.default.createElement('ul', {
            style: {
              display: 'block'
            }
          }, dots);
        },
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        beforeChange: null,
        centerMode: false,
        centerPadding: '50px',
        className: '',
        cssEase: 'ease',
        customPaging: function customPaging(i) {
          return _react2.default.createElement('button', null, i + 1);
        },
        dots: false,
        dotsClass: 'slick-dots',
        draggable: true,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: false,
        focusOnSelect: false,
        infinite: true,
        initialSlide: 0,
        lazyLoad: null,
        nextArrow: null,
        onEdge: null,
        onInit: null,
        onLazyLoadError: null,
        onReInit: null,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        pauseOnHover: true,
        prevArrow: null,
        responsive: null,
        rtl: false,
        slide: 'div',
        slidesToScroll: 1,
        slidesToShow: 1,
        speed: 500,
        swipe: true,
        swipeEvent: null,
        swipeToSlide: false,
        touchMove: true,
        touchThreshold: 5,
        useCSS: true,
        useTransform: true,
        variableWidth: false,
        vertical: false,
        waitForAnimate: true
      };
      exports.default = defaultProps;
      /***/
    },
    /* 513 */

    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(97),
          isSymbol = __webpack_require__(255);
      /** Used as references for various `Number` constants. */


      var NAN = 0 / 0;
      /** Used to match leading and trailing whitespace. */

      var reTrim = /^\s+|\s+$/g;
      /** Used to detect bad signed hexadecimal string values. */

      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      /** Used to detect binary string values. */

      var reIsBinary = /^0b[01]+$/i;
      /** Used to detect octal string values. */

      var reIsOctal = /^0o[0-7]+$/i;
      /** Built-in method references without a dependency on `root`. */

      var freeParseInt = parseInt;
      /**
       * Converts `value` to a number.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       * @example
       *
       * _.toNumber(3.2);
       * // => 3.2
       *
       * _.toNumber(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toNumber(Infinity);
       * // => Infinity
       *
       * _.toNumber('3.2');
       * // => 3.2
       */

      function toNumber(value) {
        if (typeof value == 'number') {
          return value;
        }

        if (isSymbol(value)) {
          return NAN;
        }

        if (isObject(value)) {
          var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
          value = isObject(other) ? other + '' : other;
        }

        if (typeof value != 'string') {
          return value === 0 ? value : +value;
        }

        value = value.replace(reTrim, '');
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }

      module.exports = toNumber;
      /***/
    },
    /* 514 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global) {
        /** Detect free variable `global` from Node.js. */
        var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
        module.exports = freeGlobal;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 515 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var zhTw = moment.defineLocale('zh-tw', {
          months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
          monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
          weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
          weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
          weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
          },
          meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
              return hour;
            } else if (meridiem === '中午') {
              return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;

            if (hm < 600) {
              return '凌晨';
            } else if (hm < 900) {
              return '早上';
            } else if (hm < 1130) {
              return '上午';
            } else if (hm < 1230) {
              return '中午';
            } else if (hm < 1800) {
              return '下午';
            } else {
              return '晚上';
            }
          },
          calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'd':
              case 'D':
              case 'DDD':
                return number + '日';

              case 'M':
                return number + '月';

              case 'w':
              case 'W':
                return number + '週';

              default:
                return number;
            }
          },
          relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
          }
        });
        return zhTw;
      });
      /***/

    },
    /* 516 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var zhHk = moment.defineLocale('zh-hk', {
          months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
          monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
          weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
          weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
          weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
          },
          meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
              return hour;
            } else if (meridiem === '中午') {
              return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;

            if (hm < 600) {
              return '凌晨';
            } else if (hm < 900) {
              return '早上';
            } else if (hm < 1130) {
              return '上午';
            } else if (hm < 1230) {
              return '中午';
            } else if (hm < 1800) {
              return '下午';
            } else {
              return '晚上';
            }
          },
          calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'd':
              case 'D':
              case 'DDD':
                return number + '日';

              case 'M':
                return number + '月';

              case 'w':
              case 'W':
                return number + '週';

              default:
                return number;
            }
          },
          relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
          }
        });
        return zhHk;
      });
      /***/

    },
    /* 517 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var zhCn = moment.defineLocale('zh-cn', {
          months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
          monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
          weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
          weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
          weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
          },
          meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
              return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
              return hour + 12;
            } else {
              // '中午'
              return hour >= 11 ? hour : hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;

            if (hm < 600) {
              return '凌晨';
            } else if (hm < 900) {
              return '早上';
            } else if (hm < 1130) {
              return '上午';
            } else if (hm < 1230) {
              return '中午';
            } else if (hm < 1800) {
              return '下午';
            } else {
              return '晚上';
            }
          },
          calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'd':
              case 'D':
              case 'DDD':
                return number + '日';

              case 'M':
                return number + '月';

              case 'w':
              case 'W':
                return number + '周';

              default:
                return number;
            }
          },
          relativeTime: {
            future: '%s内',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年'
          },
          week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return zhCn;
      });
      /***/

    },
    /* 518 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var yo = moment.defineLocale('yo', {
          months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
          monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
          weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
          weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
          weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
          longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
          },
          calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d'
          },
          dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
          ordinal: 'ọjọ́ %d',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return yo;
      });
      /***/

    },
    /* 519 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var xPseudo = moment.defineLocale('x-pseudo', {
          months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
          monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
          monthsParseExact: true,
          weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
          weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
          weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
          ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return xPseudo;
      });
      /***/

    },
    /* 520 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var vi = moment.defineLocale('vi', {
          months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
          monthsShort: 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
          monthsParseExact: true,
          weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
          weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
          weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
          weekdaysParseExact: true,
          meridiemParse: /sa|ch/i,
          isPM: function isPM(input) {
            return /^ch$/i.test(input);
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
              return isLower ? 'sa' : 'SA';
            } else {
              return isLower ? 'ch' : 'CH';
            }
          },
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm'
          },
          dayOfMonthOrdinalParse: /\d{1,2}/,
          ordinal: function ordinal(number) {
            return number;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return vi;
      });
      /***/

    },
    /* 521 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var uzLatn = moment.defineLocale('uz-latn', {
          months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
          monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
          weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
          weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
          weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
          },
          calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil'
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return uzLatn;
      });
      /***/

    },
    /* 522 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var uz = moment.defineLocale('uz', {
          months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
          monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
          weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
          weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
          weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
          },
          calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил'
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return uz;
      });
      /***/

    },
    /* 523 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var months = ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'];
        var days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
        var ur = moment.defineLocale('ur', {
          months: months,
          monthsShort: months,
          weekdays: days,
          weekdaysShort: days,
          weekdaysMin: days,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm'
          },
          meridiemParse: /صبح|شام/,
          isPM: function isPM(input) {
            return 'شام' === input;
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'صبح';
            }

            return 'شام';
          },
          calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال'
          },
          preparse: function preparse(string) {
            return string.replace(/،/g, ',');
          },
          postformat: function postformat(string) {
            return string.replace(/,/g, '،');
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return ur;
      });
      /***/

    },
    /* 524 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function plural(word, num) {
          var forms = word.split('_');
          return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
        }

        function relativeTimeWithPlural(number, withoutSuffix, key) {
          var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
          };

          if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
          } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
          } else {
            return number + ' ' + plural(format[key], +number);
          }
        }

        function weekdaysCaseReplace(m, format) {
          var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
          };

          if (m === true) {
            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
          }

          if (!m) {
            return weekdays['nominative'];
          }

          var nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? 'genitive' : 'nominative';
          return weekdays[nounCase][m.day()];
        }

        function processHoursFunction(str) {
          return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
          };
        }

        var uk = moment.defineLocale('uk', {
          months: {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
          },
          monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
          weekdays: weekdaysCaseReplace,
          weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
          weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm'
          },
          calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                  return processHoursFunction('[Минулої] dddd [').call(this);

                case 1:
                case 2:
                case 4:
                  return processHoursFunction('[Минулого] dddd [').call(this);
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural
          },
          // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
          meridiemParse: /ночі|ранку|дня|вечора/,
          isPM: function isPM(input) {
            return /^(дня|вечора)$/.test(input);
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'ночі';
            } else if (hour < 12) {
              return 'ранку';
            } else if (hour < 17) {
              return 'дня';
            } else {
              return 'вечора';
            }
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'M':
              case 'd':
              case 'DDD':
              case 'w':
              case 'W':
                return number + '-й';

              case 'D':
                return number + '-го';

              default:
                return number;
            }
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return uk;
      });
      /***/

    },
    /* 525 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js language configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var ugCn = moment.defineLocale('ug-cn', {
          months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split('_'),
          monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split('_'),
          weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split('_'),
          weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
          weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
          },
          meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'يېرىم كېچە' || meridiem === 'سەھەر' || meridiem === 'چۈشتىن بۇرۇن') {
              return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
              return hour + 12;
            } else {
              return hour >= 11 ? hour : hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;

            if (hm < 600) {
              return 'يېرىم كېچە';
            } else if (hm < 900) {
              return 'سەھەر';
            } else if (hm < 1130) {
              return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
              return 'چۈش';
            } else if (hm < 1800) {
              return 'چۈشتىن كېيىن';
            } else {
              return 'كەچ';
            }
          },
          calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'd':
              case 'D':
              case 'DDD':
                return number + '-كۈنى';

              case 'w':
              case 'W':
                return number + '-ھەپتە';

              default:
                return number;
            }
          },
          preparse: function preparse(string) {
            return string.replace(/،/g, ',');
          },
          postformat: function postformat(string) {
            return string.replace(/,/g, '،');
          },
          week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.

          }
        });
        return ugCn;
      });
      /***/

    },
    /* 526 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var tzmLatn = moment.defineLocale('tzm-latn', {
          months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
          monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
          weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
          weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
          weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn'
          },
          week: {
            dow: 6,
            // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.

          }
        });
        return tzmLatn;
      });
      /***/

    },
    /* 527 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var tzm = moment.defineLocale('tzm', {
          months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
          monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
          weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
          weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
          weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ'
          },
          week: {
            dow: 6,
            // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.

          }
        });
        return tzm;
      });
      /***/

    },
    /* 528 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict'; // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
        // This is currently too difficult (maybe even impossible) to add.

        var tzl = moment.defineLocale('tzl', {
          months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
          monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
          weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
          weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
          weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
          longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
          },
          meridiemParse: /d\'o|d\'a/i,
          isPM: function isPM(input) {
            return 'd\'o' === input.toLowerCase();
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
              return isLower ? 'd\'o' : 'D\'O';
            } else {
              return isLower ? 'd\'a' : 'D\'A';
            }
          },
          calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });

        function processRelativeTime(number, withoutSuffix, key, isFuture) {
          var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
          };
          return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1];
        }

        return tzl;
      });
      /***/

    },
    /* 529 */

    /***/
    function (module, exports, __webpack_require__) {
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var suffixes = {
          1: '\'inci',
          5: '\'inci',
          8: '\'inci',
          70: '\'inci',
          80: '\'inci',
          2: '\'nci',
          7: '\'nci',
          20: '\'nci',
          50: '\'nci',
          3: '\'üncü',
          4: '\'üncü',
          100: '\'üncü',
          6: '\'ncı',
          9: '\'uncu',
          10: '\'uncu',
          30: '\'uncu',
          60: '\'ıncı',
          90: '\'ıncı'
        };
        var tr = moment.defineLocale('tr', {
          months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
          monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
          weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
          weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
          weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl'
          },
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'd':
              case 'D':
              case 'Do':
              case 'DD':
                return number;

              default:
                if (number === 0) {
                  // special case for zero
                  return number + '\'ıncı';
                }

                var a = number % 10,
                    b = number % 100 - a,
                    c = number >= 100 ? 100 : null;
                return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return tr;
      });
      /***/

    },
    /* 530 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

        function translateFuture(output) {
          var time = output;
          time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'leS' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'waQ' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'nem' : time + ' pIq';
          return time;
        }

        function translatePast(output) {
          var time = output;
          time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'Hu’' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'wen' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'ben' : time + ' ret';
          return time;
        }

        function translate(number, withoutSuffix, string, isFuture) {
          var numberNoun = numberAsNoun(number);

          switch (string) {
            case 'ss':
              return numberNoun + ' lup';

            case 'mm':
              return numberNoun + ' tup';

            case 'hh':
              return numberNoun + ' rep';

            case 'dd':
              return numberNoun + ' jaj';

            case 'MM':
              return numberNoun + ' jar';

            case 'yy':
              return numberNoun + ' DIS';
          }
        }

        function numberAsNoun(number) {
          var hundred = Math.floor(number % 1000 / 100),
              ten = Math.floor(number % 100 / 10),
              one = number % 10,
              word = '';

          if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
          }

          if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
          }

          if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
          }

          return word === '' ? 'pagh' : word;
        }

        var tlh = moment.defineLocale('tlh', {
          months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
          monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
          monthsParseExact: true,
          weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
          weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
          weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
          },
          relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return tlh;
      });
      /***/

    },
    /* 531 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var tlPh = moment.defineLocale('tl-ph', {
          months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
          monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
          weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
          weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
          weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
          },
          calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon'
          },
          dayOfMonthOrdinalParse: /\d{1,2}/,
          ordinal: function ordinal(number) {
            return number;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return tlPh;
      });
      /***/

    },
    /* 532 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var th = moment.defineLocale('th', {
          months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
          monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
          monthsParseExact: true,
          weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
          weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'),
          // yes, three characters difference
          weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm'
          },
          meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
          isPM: function isPM(input) {
            return input === 'หลังเที่ยง';
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'ก่อนเที่ยง';
            } else {
              return 'หลังเที่ยง';
            }
          },
          calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี'
          }
        });
        return th;
      });
      /***/

    },
    /* 533 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var suffixes = {
          0: '-ум',
          1: '-ум',
          2: '-юм',
          3: '-юм',
          4: '-ум',
          5: '-ум',
          6: '-ум',
          7: '-ум',
          8: '-ум',
          9: '-ум',
          10: '-ум',
          12: '-ум',
          13: '-ум',
          20: '-ум',
          30: '-юм',
          40: '-ум',
          50: '-ум',
          60: '-ум',
          70: '-ум',
          80: '-ум',
          90: '-ум',
          100: '-ум'
        };
        var tg = moment.defineLocale('tg', {
          months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
          monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
          weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
          weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
          weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Пагоҳ соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол'
          },
          meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'шаб') {
              return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
              return hour;
            } else if (meridiem === 'рӯз') {
              return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'шаб';
            } else if (hour < 11) {
              return 'субҳ';
            } else if (hour < 16) {
              return 'рӯз';
            } else if (hour < 19) {
              return 'бегоҳ';
            } else {
              return 'шаб';
            }
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
          ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1th is the first week of the year.

          }
        });
        return tg;
      });
      /***/

    },
    /* 534 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var tet = moment.defineLocale('tet', {
          months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
          monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
          weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
          weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
          weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'minutu balun',
            ss: 'minutu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return tet;
      });
      /***/

    },
    /* 535 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var te = moment.defineLocale('te', {
          months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
          monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
          monthsParseExact: true,
          weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
          weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
          weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
          longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
          },
          calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు'
          },
          dayOfMonthOrdinalParse: /\d{1,2}వ/,
          ordinal: '%dవ',
          meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'రాత్రి') {
              return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
              return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
              return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'రాత్రి';
            } else if (hour < 10) {
              return 'ఉదయం';
            } else if (hour < 17) {
              return 'మధ్యాహ్నం';
            } else if (hour < 20) {
              return 'సాయంత్రం';
            } else {
              return 'రాత్రి';
            }
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return te;
      });
      /***/

    },
    /* 536 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '௧',
          '2': '௨',
          '3': '௩',
          '4': '௪',
          '5': '௫',
          '6': '௬',
          '7': '௭',
          '8': '௮',
          '9': '௯',
          '0': '௦'
        },
            numberMap = {
          '௧': '1',
          '௨': '2',
          '௩': '3',
          '௪': '4',
          '௫': '5',
          '௬': '6',
          '௭': '7',
          '௮': '8',
          '௯': '9',
          '௦': '0'
        };
        var ta = moment.defineLocale('ta', {
          months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
          monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
          weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
          weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
          weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm'
          },
          calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்'
          },
          dayOfMonthOrdinalParse: /\d{1,2}வது/,
          ordinal: function ordinal(number) {
            return number + 'வது';
          },
          preparse: function preparse(string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          // refer http://ta.wikipedia.org/s/1er1
          meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 2) {
              return ' யாமம்';
            } else if (hour < 6) {
              return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
              return ' காலை'; // காலை
            } else if (hour < 14) {
              return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
              return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
              return ' மாலை'; // மாலை
            } else {
              return ' யாமம்';
            }
          },
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'யாமம்') {
              return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
              return hour;
            } else if (meridiem === 'நண்பகல்') {
              return hour >= 10 ? hour : hour + 12;
            } else {
              return hour + 12;
            }
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return ta;
      });
      /***/

    },
    /* 537 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var sw = moment.defineLocale('sw', {
          months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
          monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
          weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
          weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
          weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'masiku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d'
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return sw;
      });
      /***/

    },
    /* 538 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var sv = moment.defineLocale('sv', {
          months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
          monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
          weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
          weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
          weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
          ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'e' : b === 1 ? 'a' : b === 2 ? 'a' : b === 3 ? 'e' : 'e';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return sv;
      });
      /***/

    },
    /* 539 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var ss = moment.defineLocale('ss', {
          months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
          monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
          weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
          weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
          weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
          },
          calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka'
          },
          meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
              return 'ekuseni';
            } else if (hours < 15) {
              return 'emini';
            } else if (hours < 19) {
              return 'entsambama';
            } else {
              return 'ebusuku';
            }
          },
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'ekuseni') {
              return hour;
            } else if (meridiem === 'emini') {
              return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
              if (hour === 0) {
                return 0;
              }

              return hour + 12;
            }
          },
          dayOfMonthOrdinalParse: /\d{1,2}/,
          ordinal: '%d',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return ss;
      });
      /***/

    },
    /* 540 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var translator = {
          words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
          },
          correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
          },
          translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];

            if (key.length === 1) {
              return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
              return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
          }
        };
        var srCyrl = moment.defineLocale('sr-cyrl', {
          months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
          monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
          monthsParseExact: true,
          weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
          weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
          weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function nextWeek() {
              switch (this.day()) {
                case 0:
                  return '[у] [недељу] [у] LT';

                case 3:
                  return '[у] [среду] [у] LT';

                case 6:
                  return '[у] [суботу] [у] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[у] dddd [у] LT';
              }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function lastWeek() {
              var lastWeekDays = ['[прошле] [недеље] [у] LT', '[прошлог] [понедељка] [у] LT', '[прошлог] [уторка] [у] LT', '[прошле] [среде] [у] LT', '[прошлог] [четвртка] [у] LT', '[прошлог] [петка] [у] LT', '[прошле] [суботе] [у] LT'];
              return lastWeekDays[this.day()];
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'дан',
            dd: translator.translate,
            M: 'месец',
            MM: translator.translate,
            y: 'годину',
            yy: translator.translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return srCyrl;
      });
      /***/

    },
    /* 541 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var translator = {
          words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
          },
          correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
          },
          translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];

            if (key.length === 1) {
              return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
              return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
          }
        };
        var sr = moment.defineLocale('sr', {
          months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
          monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
          monthsParseExact: true,
          weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
          weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
          weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
              switch (this.day()) {
                case 0:
                  return '[u] [nedelju] [u] LT';

                case 3:
                  return '[u] [sredu] [u] LT';

                case 6:
                  return '[u] [subotu] [u] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[u] dddd [u] LT';
              }
            },
            lastDay: '[juče u] LT',
            lastWeek: function lastWeek() {
              var lastWeekDays = ['[prošle] [nedelje] [u] LT', '[prošlog] [ponedeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
              return lastWeekDays[this.day()];
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return sr;
      });
      /***/

    },
    /* 542 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var sq = moment.defineLocale('sq', {
          months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
          monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
          weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
          weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
          weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
          weekdaysParseExact: true,
          meridiemParse: /PD|MD/,
          isPM: function isPM(input) {
            return input.charAt(0) === 'M';
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
          },
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite'
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return sq;
      });
      /***/

    },
    /* 543 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function processRelativeTime(number, withoutSuffix, key, isFuture) {
          var result = number + ' ';

          switch (key) {
            case 's':
              return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';

            case 'ss':
              if (number === 1) {
                result += withoutSuffix ? 'sekundo' : 'sekundi';
              } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
              } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
              } else {
                result += 'sekund';
              }

              return result;

            case 'm':
              return withoutSuffix ? 'ena minuta' : 'eno minuto';

            case 'mm':
              if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
              } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
              } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
              } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
              }

              return result;

            case 'h':
              return withoutSuffix ? 'ena ura' : 'eno uro';

            case 'hh':
              if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
              } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
              } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
              } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
              }

              return result;

            case 'd':
              return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';

            case 'dd':
              if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
              } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
              } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
              }

              return result;

            case 'M':
              return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';

            case 'MM':
              if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
              } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
              } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
              } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
              }

              return result;

            case 'y':
              return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';

            case 'yy':
              if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
              } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
              } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
              } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
              }

              return result;
          }
        }

        var sl = moment.defineLocale('sl', {
          months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
          monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
          monthsParseExact: true,
          weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
          weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
          weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',
            nextWeek: function nextWeek() {
              switch (this.day()) {
                case 0:
                  return '[v] [nedeljo] [ob] LT';

                case 3:
                  return '[v] [sredo] [ob] LT';

                case 6:
                  return '[v] [soboto] [ob] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[v] dddd [ob] LT';
              }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                  return '[prejšnjo] [nedeljo] [ob] LT';

                case 3:
                  return '[prejšnjo] [sredo] [ob] LT';

                case 6:
                  return '[prejšnjo] [soboto] [ob] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[prejšnji] dddd [ob] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return sl;
      });
      /***/

    },
    /* 544 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
            monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');

        function plural(n) {
          return n > 1 && n < 5;
        }

        function translate(number, withoutSuffix, key, isFuture) {
          var result = number + ' ';

          switch (key) {
            case 's':
              // a few seconds / in a few seconds / a few seconds ago
              return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';

            case 'ss':
              // 9 seconds / in 9 seconds / 9 seconds ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekúnd');
              } else {
                return result + 'sekundami';
              }

              break;

            case 'm':
              // a minute / in a minute / a minute ago
              return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';

            case 'mm':
              // 9 minutes / in 9 minutes / 9 minutes ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
              } else {
                return result + 'minútami';
              }

              break;

            case 'h':
              // an hour / in an hour / an hour ago
              return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';

            case 'hh':
              // 9 hours / in 9 hours / 9 hours ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
              } else {
                return result + 'hodinami';
              }

              break;

            case 'd':
              // a day / in a day / a day ago
              return withoutSuffix || isFuture ? 'deň' : 'dňom';

            case 'dd':
              // 9 days / in 9 days / 9 days ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
              } else {
                return result + 'dňami';
              }

              break;

            case 'M':
              // a month / in a month / a month ago
              return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';

            case 'MM':
              // 9 months / in 9 months / 9 months ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
              } else {
                return result + 'mesiacmi';
              }

              break;

            case 'y':
              // a year / in a year / a year ago
              return withoutSuffix || isFuture ? 'rok' : 'rokom';

            case 'yy':
              // 9 years / in 9 years / 9 years ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
              } else {
                return result + 'rokmi';
              }

              break;
          }
        }

        var sk = moment.defineLocale('sk', {
          months: months,
          monthsShort: monthsShort,
          weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
          weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
          weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function nextWeek() {
              switch (this.day()) {
                case 0:
                  return '[v nedeľu o] LT';

                case 1:
                case 2:
                  return '[v] dddd [o] LT';

                case 3:
                  return '[v stredu o] LT';

                case 4:
                  return '[vo štvrtok o] LT';

                case 5:
                  return '[v piatok o] LT';

                case 6:
                  return '[v sobotu o] LT';
              }
            },
            lastDay: '[včera o] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                  return '[minulú nedeľu o] LT';

                case 1:
                case 2:
                  return '[minulý] dddd [o] LT';

                case 3:
                  return '[minulú stredu o] LT';

                case 4:
                case 5:
                  return '[minulý] dddd [o] LT';

                case 6:
                  return '[minulú sobotu o] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return sk;
      });
      /***/

    },
    /* 545 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';
        /*jshint -W100*/

        var si = moment.defineLocale('si', {
          months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
          monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
          weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
          weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
          weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
          },
          calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d'
          },
          dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
          ordinal: function ordinal(number) {
            return number + ' වැනි';
          },
          meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
          isPM: function isPM(input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
              return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
              return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
          }
        });
        return si;
      });
      /***/

    },
    /* 546 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var se = moment.defineLocale('se', {
          months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
          monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
          weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
          weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
          weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
          },
          calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit'
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return se;
      });
      /***/

    },
    /* 547 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var months = ['جنوري', 'فيبروري', 'مارچ', 'اپريل', 'مئي', 'جون', 'جولاءِ', 'آگسٽ', 'سيپٽمبر', 'آڪٽوبر', 'نومبر', 'ڊسمبر'];
        var days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
        var sd = moment.defineLocale('sd', {
          months: months,
          monthsShort: months,
          weekdays: days,
          weekdaysShort: days,
          weekdaysMin: days,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm'
          },
          meridiemParse: /صبح|شام/,
          isPM: function isPM(input) {
            return 'شام' === input;
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'صبح';
            }

            return 'شام';
          },
          calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال'
          },
          preparse: function preparse(string) {
            return string.replace(/،/g, ',');
          },
          postformat: function postformat(string) {
            return string.replace(/,/g, '،');
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return sd;
      });
      /***/

    },
    /* 548 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function plural(word, num) {
          var forms = word.split('_');
          return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
        }

        function relativeTimeWithPlural(number, withoutSuffix, key) {
          var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
          };

          if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
          } else {
            return number + ' ' + plural(format[key], +number);
          }
        }

        var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i]; // http://new.gramota.ru/spravka/rules/139-prop : § 103
        // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
        // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753

        var ru = moment.defineLocale('ru', {
          months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
          },
          monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
          },
          weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
          },
          weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
          weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
          monthsParse: monthsParse,
          longMonthsParse: monthsParse,
          shortMonthsParse: monthsParse,
          // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
          monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
          // копия предыдущего
          monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
          // полные названия с падежами
          monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
          // Выражение, которое соотвествует только сокращённым формам
          monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm'
          },
          calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function nextWeek(now) {
              if (now.week() !== this.week()) {
                switch (this.day()) {
                  case 0:
                    return '[В следующее] dddd, [в] LT';

                  case 1:
                  case 2:
                  case 4:
                    return '[В следующий] dddd, [в] LT';

                  case 3:
                  case 5:
                  case 6:
                    return '[В следующую] dddd, [в] LT';
                }
              } else {
                if (this.day() === 2) {
                  return '[Во] dddd, [в] LT';
                } else {
                  return '[В] dddd, [в] LT';
                }
              }
            },
            lastWeek: function lastWeek(now) {
              if (now.week() !== this.week()) {
                switch (this.day()) {
                  case 0:
                    return '[В прошлое] dddd, [в] LT';

                  case 1:
                  case 2:
                  case 4:
                    return '[В прошлый] dddd, [в] LT';

                  case 3:
                  case 5:
                  case 6:
                    return '[В прошлую] dddd, [в] LT';
                }
              } else {
                if (this.day() === 2) {
                  return '[Во] dddd, [в] LT';
                } else {
                  return '[В] dddd, [в] LT';
                }
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural
          },
          meridiemParse: /ночи|утра|дня|вечера/i,
          isPM: function isPM(input) {
            return /^(дня|вечера)$/.test(input);
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'ночи';
            } else if (hour < 12) {
              return 'утра';
            } else if (hour < 17) {
              return 'дня';
            } else {
              return 'вечера';
            }
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'M':
              case 'd':
              case 'DDD':
                return number + '-й';

              case 'D':
                return number + '-го';

              case 'w':
              case 'W':
                return number + '-я';

              default:
                return number;
            }
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return ru;
      });
      /***/

    },
    /* 549 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function relativeTimeWithPlural(number, withoutSuffix, key) {
          var format = {
            'ss': 'secunde',
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
          },
              separator = ' ';

          if (number % 100 >= 20 || number >= 100 && number % 100 === 0) {
            separator = ' de ';
          }

          return number + separator + format[key];
        }

        var ro = moment.defineLocale('ro', {
          months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
          monthsShort: 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
          monthsParseExact: true,
          weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
          weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
          weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return ro;
      });
      /***/

    },
    /* 550 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var ptBr = moment.defineLocale('pt-br', {
          months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
          monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
          weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
          weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
          weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
          },
          calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function lastWeek() {
              return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
              '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: '%dº'
        });
        return ptBr;
      });
      /***/

    },
    /* 551 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var pt = moment.defineLocale('pt', {
          months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
          monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
          weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
          weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
          weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function lastWeek() {
              return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
              '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: '%dº',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return pt;
      });
      /***/

    },
    /* 552 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
            monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');

        function plural(n) {
          return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
        }

        function translate(number, withoutSuffix, key) {
          var result = number + ' ';

          switch (key) {
            case 'ss':
              return result + (plural(number) ? 'sekundy' : 'sekund');

            case 'm':
              return withoutSuffix ? 'minuta' : 'minutę';

            case 'mm':
              return result + (plural(number) ? 'minuty' : 'minut');

            case 'h':
              return withoutSuffix ? 'godzina' : 'godzinę';

            case 'hh':
              return result + (plural(number) ? 'godziny' : 'godzin');

            case 'MM':
              return result + (plural(number) ? 'miesiące' : 'miesięcy');

            case 'yy':
              return result + (plural(number) ? 'lata' : 'lat');
          }
        }

        var pl = moment.defineLocale('pl', {
          months: function months(momentToFormat, format) {
            if (!momentToFormat) {
              return monthsNominative;
            } else if (format === '') {
              // Hack: if format empty we know this is used to generate
              // RegExp by moment. Give then back both valid forms of months
              // in RegExp ready format.
              return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
              return monthsSubjective[momentToFormat.month()];
            } else {
              return monthsNominative[momentToFormat.month()];
            }
          },
          monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
          weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
          weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
          weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function nextWeek() {
              switch (this.day()) {
                case 0:
                  return '[W niedzielę o] LT';

                case 2:
                  return '[We wtorek o] LT';

                case 3:
                  return '[W środę o] LT';

                case 6:
                  return '[W sobotę o] LT';

                default:
                  return '[W] dddd [o] LT';
              }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                  return '[W zeszłą niedzielę o] LT';

                case 3:
                  return '[W zeszłą środę o] LT';

                case 6:
                  return '[W zeszłą sobotę o] LT';

                default:
                  return '[W zeszły] dddd [o] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return pl;
      });
      /***/

    },
    /* 553 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '੧',
          '2': '੨',
          '3': '੩',
          '4': '੪',
          '5': '੫',
          '6': '੬',
          '7': '੭',
          '8': '੮',
          '9': '੯',
          '0': '੦'
        },
            numberMap = {
          '੧': '1',
          '੨': '2',
          '੩': '3',
          '੪': '4',
          '੫': '5',
          '੬': '6',
          '੭': '7',
          '੮': '8',
          '੯': '9',
          '੦': '0'
        };
        var paIn = moment.defineLocale('pa-in', {
          // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
          months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
          monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
          weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
          weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
          weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
          longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
          },
          calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ'
          },
          preparse: function preparse(string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
          // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
          meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'ਰਾਤ') {
              return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
              return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
              return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'ਰਾਤ';
            } else if (hour < 10) {
              return 'ਸਵੇਰ';
            } else if (hour < 17) {
              return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
              return 'ਸ਼ਾਮ';
            } else {
              return 'ਰਾਤ';
            }
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return paIn;
      });
      /***/

    },
    /* 554 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var nn = moment.defineLocale('nn', {
          months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
          monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
          weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
          weekdaysShort: 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
          weekdaysMin: 'su_må_ty_on_to_fr_lø'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
          },
          calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år'
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return nn;
      });
      /***/

    },
    /* 555 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
            monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
        var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
        var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
        var nlBe = moment.defineLocale('nl-be', {
          months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
          monthsShort: function monthsShort(m, format) {
            if (!m) {
              return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
              return monthsShortWithoutDots[m.month()];
            } else {
              return monthsShortWithDots[m.month()];
            }
          },
          monthsRegex: monthsRegex,
          monthsShortRegex: monthsRegex,
          monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
          monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
          monthsParse: monthsParse,
          longMonthsParse: monthsParse,
          shortMonthsParse: monthsParse,
          weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
          weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
          weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
          ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return nlBe;
      });
      /***/

    },
    /* 556 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
            monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
        var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
        var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
        var nl = moment.defineLocale('nl', {
          months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
          monthsShort: function monthsShort(m, format) {
            if (!m) {
              return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
              return monthsShortWithoutDots[m.month()];
            } else {
              return monthsShortWithDots[m.month()];
            }
          },
          monthsRegex: monthsRegex,
          monthsShortRegex: monthsRegex,
          monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
          monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
          monthsParse: monthsParse,
          longMonthsParse: monthsParse,
          shortMonthsParse: monthsParse,
          weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
          weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
          weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
          ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return nl;
      });
      /***/

    },
    /* 557 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '१',
          '2': '२',
          '3': '३',
          '4': '४',
          '5': '५',
          '6': '६',
          '7': '७',
          '8': '८',
          '9': '९',
          '0': '०'
        },
            numberMap = {
          '१': '1',
          '२': '2',
          '३': '3',
          '४': '4',
          '५': '5',
          '६': '6',
          '७': '7',
          '८': '8',
          '९': '9',
          '०': '0'
        };
        var ne = moment.defineLocale('ne', {
          months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
          monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
          monthsParseExact: true,
          weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
          weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
          weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे'
          },
          preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'राति') {
              return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
              return hour;
            } else if (meridiem === 'दिउँसो') {
              return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 3) {
              return 'राति';
            } else if (hour < 12) {
              return 'बिहान';
            } else if (hour < 16) {
              return 'दिउँसो';
            } else if (hour < 20) {
              return 'साँझ';
            } else {
              return 'राति';
            }
          },
          calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष'
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return ne;
      });
      /***/

    },
    /* 558 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var nb = moment.defineLocale('nb', {
          months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
          monthsShort: 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
          monthsParseExact: true,
          weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
          weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
          weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
          },
          calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år'
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return nb;
      });
      /***/

    },
    /* 559 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '၁',
          '2': '၂',
          '3': '၃',
          '4': '၄',
          '5': '၅',
          '6': '၆',
          '7': '၇',
          '8': '၈',
          '9': '၉',
          '0': '၀'
        },
            numberMap = {
          '၁': '1',
          '၂': '2',
          '၃': '3',
          '၄': '4',
          '၅': '5',
          '၆': '6',
          '၇': '7',
          '၈': '8',
          '၉': '9',
          '၀': '0'
        };
        var my = moment.defineLocale('my', {
          months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
          monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
          weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
          weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
          weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
          },
          preparse: function preparse(string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return my;
      });
      /***/

    },
    /* 560 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var mt = moment.defineLocale('mt', {
          months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
          monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
          weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
          weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
          weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni'
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: '%dº',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return mt;
      });
      /***/

    },
    /* 561 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var msMy = moment.defineLocale('ms-my', {
          months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
          monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
          weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
          weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
          weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
          longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
          },
          meridiemParse: /pagi|tengahari|petang|malam/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'pagi') {
              return hour;
            } else if (meridiem === 'tengahari') {
              return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
              return 'pagi';
            } else if (hours < 15) {
              return 'tengahari';
            } else if (hours < 19) {
              return 'petang';
            } else {
              return 'malam';
            }
          },
          calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return msMy;
      });
      /***/

    },
    /* 562 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var ms = moment.defineLocale('ms', {
          months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
          monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
          weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
          weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
          weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
          longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
          },
          meridiemParse: /pagi|tengahari|petang|malam/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'pagi') {
              return hour;
            } else if (meridiem === 'tengahari') {
              return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
              return 'pagi';
            } else if (hours < 15) {
              return 'tengahari';
            } else if (hours < 19) {
              return 'petang';
            } else {
              return 'malam';
            }
          },
          calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return ms;
      });
      /***/

    },
    /* 563 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '१',
          '2': '२',
          '3': '३',
          '4': '४',
          '5': '५',
          '6': '६',
          '7': '७',
          '8': '८',
          '9': '९',
          '0': '०'
        },
            numberMap = {
          '१': '1',
          '२': '2',
          '३': '3',
          '४': '4',
          '५': '5',
          '६': '6',
          '७': '7',
          '८': '8',
          '९': '9',
          '०': '0'
        };

        function relativeTimeMr(number, withoutSuffix, string, isFuture) {
          var output = '';

          if (withoutSuffix) {
            switch (string) {
              case 's':
                output = 'काही सेकंद';
                break;

              case 'ss':
                output = '%d सेकंद';
                break;

              case 'm':
                output = 'एक मिनिट';
                break;

              case 'mm':
                output = '%d मिनिटे';
                break;

              case 'h':
                output = 'एक तास';
                break;

              case 'hh':
                output = '%d तास';
                break;

              case 'd':
                output = 'एक दिवस';
                break;

              case 'dd':
                output = '%d दिवस';
                break;

              case 'M':
                output = 'एक महिना';
                break;

              case 'MM':
                output = '%d महिने';
                break;

              case 'y':
                output = 'एक वर्ष';
                break;

              case 'yy':
                output = '%d वर्षे';
                break;
            }
          } else {
            switch (string) {
              case 's':
                output = 'काही सेकंदां';
                break;

              case 'ss':
                output = '%d सेकंदां';
                break;

              case 'm':
                output = 'एका मिनिटा';
                break;

              case 'mm':
                output = '%d मिनिटां';
                break;

              case 'h':
                output = 'एका तासा';
                break;

              case 'hh':
                output = '%d तासां';
                break;

              case 'd':
                output = 'एका दिवसा';
                break;

              case 'dd':
                output = '%d दिवसां';
                break;

              case 'M':
                output = 'एका महिन्या';
                break;

              case 'MM':
                output = '%d महिन्यां';
                break;

              case 'y':
                output = 'एका वर्षा';
                break;

              case 'yy':
                output = '%d वर्षां';
                break;
            }
          }

          return output.replace(/%d/i, number);
        }

        var mr = moment.defineLocale('mr', {
          months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
          monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
          monthsParseExact: true,
          weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
          weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
          weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
          longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता'
          },
          calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
          },
          preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'रात्री') {
              return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
              return hour;
            } else if (meridiem === 'दुपारी') {
              return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'रात्री';
            } else if (hour < 10) {
              return 'सकाळी';
            } else if (hour < 17) {
              return 'दुपारी';
            } else if (hour < 20) {
              return 'सायंकाळी';
            } else {
              return 'रात्री';
            }
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return mr;
      });
      /***/

    },
    /* 564 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function translate(number, withoutSuffix, key, isFuture) {
          switch (key) {
            case 's':
              return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';

            case 'ss':
              return number + (withoutSuffix ? ' секунд' : ' секундын');

            case 'm':
            case 'mm':
              return number + (withoutSuffix ? ' минут' : ' минутын');

            case 'h':
            case 'hh':
              return number + (withoutSuffix ? ' цаг' : ' цагийн');

            case 'd':
            case 'dd':
              return number + (withoutSuffix ? ' өдөр' : ' өдрийн');

            case 'M':
            case 'MM':
              return number + (withoutSuffix ? ' сар' : ' сарын');

            case 'y':
            case 'yy':
              return number + (withoutSuffix ? ' жил' : ' жилийн');

            default:
              return number;
          }
        }

        var mn = moment.defineLocale('mn', {
          months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
          monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
          monthsParseExact: true,
          weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
          weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
          weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm'
          },
          meridiemParse: /ҮӨ|ҮХ/i,
          isPM: function isPM(input) {
            return input === 'ҮХ';
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'ҮӨ';
            } else {
              return 'ҮХ';
            }
          },
          calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'd':
              case 'D':
              case 'DDD':
                return number + ' өдөр';

              default:
                return number;
            }
          }
        });
        return mn;
      });
      /***/

    },
    /* 565 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var ml = moment.defineLocale('ml', {
          months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
          monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
          monthsParseExact: true,
          weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
          weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
          weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
          longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു'
          },
          calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം'
          },
          meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'രാത്രി' && hour >= 4 || meridiem === 'ഉച്ച കഴിഞ്ഞ്' || meridiem === 'വൈകുന്നേരം') {
              return hour + 12;
            } else {
              return hour;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'രാത്രി';
            } else if (hour < 12) {
              return 'രാവിലെ';
            } else if (hour < 17) {
              return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
              return 'വൈകുന്നേരം';
            } else {
              return 'രാത്രി';
            }
          }
        });
        return ml;
      });
      /***/

    },
    /* 566 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var mk = moment.defineLocale('mk', {
          months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
          monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
          weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
          weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
          weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                case 3:
                case 6:
                  return '[Изминатата] dddd [во] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[Изминатиот] dddd [во] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'после %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            M: 'месец',
            MM: '%d месеци',
            y: 'година',
            yy: '%d години'
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
          ordinal: function ordinal(number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;

            if (number === 0) {
              return number + '-ев';
            } else if (last2Digits === 0) {
              return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
              return number + '-ти';
            } else if (lastDigit === 1) {
              return number + '-ви';
            } else if (lastDigit === 2) {
              return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
              return number + '-ми';
            } else {
              return number + '-ти';
            }
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return mk;
      });
      /***/

    },
    /* 567 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var mi = moment.defineLocale('mi', {
          months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
          monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
          monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
          monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
          monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
          monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
          weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
          weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
          weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
          },
          calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: '%dº',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return mi;
      });
      /***/

    },
    /* 568 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var translator = {
          words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
          },
          correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
          },
          translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];

            if (key.length === 1) {
              return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
              return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
          }
        };
        var me = moment.defineLocale('me', {
          months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
          monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
          monthsParseExact: true,
          weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
          weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
          weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',
            nextWeek: function nextWeek() {
              switch (this.day()) {
                case 0:
                  return '[u] [nedjelju] [u] LT';

                case 3:
                  return '[u] [srijedu] [u] LT';

                case 6:
                  return '[u] [subotu] [u] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[u] dddd [u] LT';
              }
            },
            lastDay: '[juče u] LT',
            lastWeek: function lastWeek() {
              var lastWeekDays = ['[prošle] [nedjelje] [u] LT', '[prošlog] [ponedjeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srijede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
              return lastWeekDays[this.day()];
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return me;
      });
      /***/

    },
    /* 569 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var units = {
          'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
          'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
          'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
          'h': 'stundas_stundām_stunda_stundas'.split('_'),
          'hh': 'stundas_stundām_stunda_stundas'.split('_'),
          'd': 'dienas_dienām_diena_dienas'.split('_'),
          'dd': 'dienas_dienām_diena_dienas'.split('_'),
          'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
          'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
          'y': 'gada_gadiem_gads_gadi'.split('_'),
          'yy': 'gada_gadiem_gads_gadi'.split('_')
        };
        /**
         * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
         */

        function format(forms, number, withoutSuffix) {
          if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
          } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
          }
        }

        function relativeTimeWithPlural(number, withoutSuffix, key) {
          return number + ' ' + format(units[key], number, withoutSuffix);
        }

        function relativeTimeWithSingular(number, withoutSuffix, key) {
          return format(units[key], number, withoutSuffix);
        }

        function relativeSeconds(number, withoutSuffix) {
          return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
        }

        var lv = moment.defineLocale('lv', {
          months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
          monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
          weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
          weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
          weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
          },
          calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return lv;
      });
      /***/

    },
    /* 570 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var units = {
          'ss': 'sekundė_sekundžių_sekundes',
          'm': 'minutė_minutės_minutę',
          'mm': 'minutės_minučių_minutes',
          'h': 'valanda_valandos_valandą',
          'hh': 'valandos_valandų_valandas',
          'd': 'diena_dienos_dieną',
          'dd': 'dienos_dienų_dienas',
          'M': 'mėnuo_mėnesio_mėnesį',
          'MM': 'mėnesiai_mėnesių_mėnesius',
          'y': 'metai_metų_metus',
          'yy': 'metai_metų_metus'
        };

        function translateSeconds(number, withoutSuffix, key, isFuture) {
          if (withoutSuffix) {
            return 'kelios sekundės';
          } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
          }
        }

        function translateSingular(number, withoutSuffix, key, isFuture) {
          return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
        }

        function special(number) {
          return number % 10 === 0 || number > 10 && number < 20;
        }

        function forms(key) {
          return units[key].split('_');
        }

        function translate(number, withoutSuffix, key, isFuture) {
          var result = number + ' ';

          if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
          } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
          } else {
            if (isFuture) {
              return result + forms(key)[1];
            } else {
              return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
          }
        }

        var lt = moment.defineLocale('lt', {
          months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
          },
          monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
          weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
          },
          weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
          weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
          },
          calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}-oji/,
          ordinal: function ordinal(number) {
            return number + '-oji';
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return lt;
      });
      /***/

    },
    /* 571 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var lo = moment.defineLocale('lo', {
          months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
          monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
          weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
          weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
          weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm'
          },
          meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
          isPM: function isPM(input) {
            return input === 'ຕອນແລງ';
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'ຕອນເຊົ້າ';
            } else {
              return 'ຕອນແລງ';
            }
          },
          calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ'
          },
          dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
          ordinal: function ordinal(number) {
            return 'ທີ່' + number;
          }
        });
        return lo;
      });
      /***/

    },
    /* 572 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function processRelativeTime(number, withoutSuffix, key, isFuture) {
          var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
          };
          return withoutSuffix ? format[key][0] : format[key][1];
        }

        function processFutureTime(string) {
          var number = string.substr(0, string.indexOf(' '));

          if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
          }

          return 'an ' + string;
        }

        function processPastTime(string) {
          var number = string.substr(0, string.indexOf(' '));

          if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
          }

          return 'virun ' + string;
        }
        /**
         * Returns true if the word before the given number loses the '-n' ending.
         * e.g. 'an 10 Deeg' but 'a 5 Deeg'
         *
         * @param number {integer}
         * @returns {boolean}
         */


        function eifelerRegelAppliesToNumber(number) {
          number = parseInt(number, 10);

          if (isNaN(number)) {
            return false;
          }

          if (number < 0) {
            // Negative Number --> always true
            return true;
          } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
              return true;
            }

            return false;
          } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;

            if (lastDigit === 0) {
              return eifelerRegelAppliesToNumber(firstDigit);
            }

            return eifelerRegelAppliesToNumber(lastDigit);
          } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
              number = number / 10;
            }

            return eifelerRegelAppliesToNumber(number);
          } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
          }
        }

        var lb = moment.defineLocale('lb', {
          months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
          monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
          monthsParseExact: true,
          weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
          weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
          weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
          },
          calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function lastWeek() {
              // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
              switch (this.day()) {
                case 2:
                case 4:
                  return '[Leschten] dddd [um] LT';

                default:
                  return '[Leschte] dddd [um] LT';
              }
            }
          },
          relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer'
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return lb;
      });
      /***/

    },
    /* 573 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var suffixes = {
          0: '-чү',
          1: '-чи',
          2: '-чи',
          3: '-чү',
          4: '-чү',
          5: '-чи',
          6: '-чы',
          7: '-чи',
          8: '-чи',
          9: '-чу',
          10: '-чу',
          20: '-чы',
          30: '-чу',
          40: '-чы',
          50: '-чү',
          60: '-чы',
          70: '-чи',
          80: '-чи',
          90: '-чу',
          100: '-чү'
        };
        var ky = moment.defineLocale('ky', {
          months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
          monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
          weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
          weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
          weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл'
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
          ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return ky;
      });
      /***/

    },
    /* 574 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '١',
          '2': '٢',
          '3': '٣',
          '4': '٤',
          '5': '٥',
          '6': '٦',
          '7': '٧',
          '8': '٨',
          '9': '٩',
          '0': '٠'
        },
            numberMap = {
          '١': '1',
          '٢': '2',
          '٣': '3',
          '٤': '4',
          '٥': '5',
          '٦': '6',
          '٧': '7',
          '٨': '8',
          '٩': '9',
          '٠': '0'
        },
            months = ['کانونی دووەم', 'شوبات', 'ئازار', 'نیسان', 'ئایار', 'حوزەیران', 'تەمموز', 'ئاب', 'ئەیلوول', 'تشرینی یەكەم', 'تشرینی دووەم', 'كانونی یەکەم'];
        var ku = moment.defineLocale('ku', {
          months: months,
          monthsShort: months,
          weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
          weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
          weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          meridiemParse: /ئێواره‌|به‌یانی/,
          isPM: function isPM(input) {
            return /ئێواره‌/.test(input);
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'به‌یانی';
            } else {
              return 'ئێواره‌';
            }
          },
          calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ'
          },
          preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
              return numberMap[match];
            }).replace(/،/g, ',');
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            }).replace(/,/g, '،');
          },
          week: {
            dow: 6,
            // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.

          }
        });
        return ku;
      });
      /***/

    },
    /* 575 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var ko = moment.defineLocale('ko', {
          months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
          monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
          weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
          weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
          weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
          longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm'
          },
          calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'd':
              case 'D':
              case 'DDD':
                return number + '일';

              case 'M':
                return number + '월';

              case 'w':
              case 'W':
                return number + '주';

              default:
                return number;
            }
          },
          meridiemParse: /오전|오후/,
          isPM: function isPM(token) {
            return token === '오후';
          },
          meridiem: function meridiem(hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
          }
        });
        return ko;
      });
      /***/

    },
    /* 576 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '೧',
          '2': '೨',
          '3': '೩',
          '4': '೪',
          '5': '೫',
          '6': '೬',
          '7': '೭',
          '8': '೮',
          '9': '೯',
          '0': '೦'
        },
            numberMap = {
          '೧': '1',
          '೨': '2',
          '೩': '3',
          '೪': '4',
          '೫': '5',
          '೬': '6',
          '೭': '7',
          '೮': '8',
          '೯': '9',
          '೦': '0'
        };
        var kn = moment.defineLocale('kn', {
          months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
          monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
          monthsParseExact: true,
          weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
          weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
          weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
          longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
          },
          calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ'
          },
          preparse: function preparse(string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'ರಾತ್ರಿ') {
              return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
              return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
              return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
              return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
              return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
              return 'ಸಂಜೆ';
            } else {
              return 'ರಾತ್ರಿ';
            }
          },
          dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
          ordinal: function ordinal(number) {
            return number + 'ನೇ';
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return kn;
      });
      /***/

    },
    /* 577 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '១',
          '2': '២',
          '3': '៣',
          '4': '៤',
          '5': '៥',
          '6': '៦',
          '7': '៧',
          '8': '៨',
          '9': '៩',
          '0': '០'
        },
            numberMap = {
          '១': '1',
          '២': '2',
          '៣': '3',
          '៤': '4',
          '៥': '5',
          '៦': '6',
          '៧': '7',
          '៨': '8',
          '៩': '9',
          '០': '0'
        };
        var km = moment.defineLocale('km', {
          months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
          monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
          weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
          weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
          weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          meridiemParse: /ព្រឹក|ល្ងាច/,
          isPM: function isPM(input) {
            return input === 'ល្ងាច';
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'ព្រឹក';
            } else {
              return 'ល្ងាច';
            }
          },
          calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
          },
          dayOfMonthOrdinalParse: /ទី\d{1,2}/,
          ordinal: 'ទី%d',
          preparse: function preparse(string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return km;
      });
      /***/

    },
    /* 578 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var suffixes = {
          0: '-ші',
          1: '-ші',
          2: '-ші',
          3: '-ші',
          4: '-ші',
          5: '-ші',
          6: '-шы',
          7: '-ші',
          8: '-ші',
          9: '-шы',
          10: '-шы',
          20: '-шы',
          30: '-шы',
          40: '-шы',
          50: '-ші',
          60: '-шы',
          70: '-ші',
          80: '-ші',
          90: '-шы',
          100: '-ші'
        };
        var kk = moment.defineLocale('kk', {
          months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
          monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
          weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
          weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
          weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл'
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
          ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return kk;
      });
      /***/

    },
    /* 579 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var ka = moment.defineLocale('ka', {
          months: {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
          },
          monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
          weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
          },
          weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
          weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
          longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
          },
          calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L'
          },
          relativeTime: {
            future: function future(s) {
              return /(წამი|წუთი|საათი|წელი)/.test(s) ? s.replace(/ი$/, 'ში') : s + 'ში';
            },
            past: function past(s) {
              if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                return s.replace(/(ი|ე)$/, 'ის წინ');
              }

              if (/წელი/.test(s)) {
                return s.replace(/წელი$/, 'წლის წინ');
              }
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი'
          },
          dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
          ordinal: function ordinal(number) {
            if (number === 0) {
              return number;
            }

            if (number === 1) {
              return number + '-ლი';
            }

            if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) {
              return 'მე-' + number;
            }

            return number + '-ე';
          },
          week: {
            dow: 1,
            doy: 7
          }
        });
        return ka;
      });
      /***/

    },
    /* 580 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var jv = moment.defineLocale('jv', {
          months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
          monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
          weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
          weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
          weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
          longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
          },
          meridiemParse: /enjing|siyang|sonten|ndalu/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'enjing') {
              return hour;
            } else if (meridiem === 'siyang') {
              return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
              return 'enjing';
            } else if (hours < 15) {
              return 'siyang';
            } else if (hours < 19) {
              return 'sonten';
            } else {
              return 'ndalu';
            }
          },
          calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun'
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return jv;
      });
      /***/

    },
    /* 581 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var ja = moment.defineLocale('ja', {
          months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
          monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
          weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
          weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
          weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm'
          },
          meridiemParse: /午前|午後/i,
          isPM: function isPM(input) {
            return input === '午後';
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return '午前';
            } else {
              return '午後';
            }
          },
          calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function nextWeek(now) {
              if (now.week() < this.week()) {
                return '[来週]dddd LT';
              } else {
                return 'dddd LT';
              }
            },
            lastDay: '[昨日] LT',
            lastWeek: function lastWeek(now) {
              if (this.week() < now.week()) {
                return '[先週]dddd LT';
              } else {
                return 'dddd LT';
              }
            },
            sameElse: 'L'
          },
          dayOfMonthOrdinalParse: /\d{1,2}日/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'd':
              case 'D':
              case 'DDD':
                return number + '日';

              default:
                return number;
            }
          },
          relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年'
          }
        });
        return ja;
      });
      /***/

    },
    /* 582 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var itCh = moment.defineLocale('it-ch', {
          months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
          monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
          weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
          weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
          weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                  return '[la scorsa] dddd [alle] LT';

                default:
                  return '[lo scorso] dddd [alle] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: function future(s) {
              return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: 'un\'ora',
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni'
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: '%dº',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return itCh;
      });
      /***/

    },
    /* 583 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var it = moment.defineLocale('it', {
          months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
          monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
          weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
          weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
          weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                  return '[la scorsa] dddd [alle] LT';

                default:
                  return '[lo scorso] dddd [alle] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: function future(s) {
              return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: 'un\'ora',
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni'
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: '%dº',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return it;
      });
      /***/

    },
    /* 584 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function plural(n) {
          if (n % 100 === 11) {
            return true;
          } else if (n % 10 === 1) {
            return false;
          }

          return true;
        }

        function translate(number, withoutSuffix, key, isFuture) {
          var result = number + ' ';

          switch (key) {
            case 's':
              return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';

            case 'ss':
              if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
              }

              return result + 'sekúnda';

            case 'm':
              return withoutSuffix ? 'mínúta' : 'mínútu';

            case 'mm':
              if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
              } else if (withoutSuffix) {
                return result + 'mínúta';
              }

              return result + 'mínútu';

            case 'hh':
              if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
              }

              return result + 'klukkustund';

            case 'd':
              if (withoutSuffix) {
                return 'dagur';
              }

              return isFuture ? 'dag' : 'degi';

            case 'dd':
              if (plural(number)) {
                if (withoutSuffix) {
                  return result + 'dagar';
                }

                return result + (isFuture ? 'daga' : 'dögum');
              } else if (withoutSuffix) {
                return result + 'dagur';
              }

              return result + (isFuture ? 'dag' : 'degi');

            case 'M':
              if (withoutSuffix) {
                return 'mánuður';
              }

              return isFuture ? 'mánuð' : 'mánuði';

            case 'MM':
              if (plural(number)) {
                if (withoutSuffix) {
                  return result + 'mánuðir';
                }

                return result + (isFuture ? 'mánuði' : 'mánuðum');
              } else if (withoutSuffix) {
                return result + 'mánuður';
              }

              return result + (isFuture ? 'mánuð' : 'mánuði');

            case 'y':
              return withoutSuffix || isFuture ? 'ár' : 'ári';

            case 'yy':
              if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
              }

              return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
          }
        }

        var is = moment.defineLocale('is', {
          months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
          monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
          weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
          weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
          weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
          },
          calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return is;
      });
      /***/

    },
    /* 585 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var id = moment.defineLocale('id', {
          months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
          monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
          weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
          weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
          weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
          longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
          },
          meridiemParse: /pagi|siang|sore|malam/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'pagi') {
              return hour;
            } else if (meridiem === 'siang') {
              return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
              return 'pagi';
            } else if (hours < 15) {
              return 'siang';
            } else if (hours < 19) {
              return 'sore';
            } else {
              return 'malam';
            }
          },
          calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return id;
      });
      /***/

    },
    /* 586 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var hyAm = moment.defineLocale('hy-am', {
          months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
          },
          monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
          weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
          weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
          weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm'
          },
          calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function nextWeek() {
              return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function lastWeek() {
              return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի'
          },
          meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
          isPM: function isPM(input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
          },
          meridiem: function meridiem(hour) {
            if (hour < 4) {
              return 'գիշերվա';
            } else if (hour < 12) {
              return 'առավոտվա';
            } else if (hour < 17) {
              return 'ցերեկվա';
            } else {
              return 'երեկոյան';
            }
          },
          dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'DDD':
              case 'w':
              case 'W':
              case 'DDDo':
                if (number === 1) {
                  return number + '-ին';
                }

                return number + '-րդ';

              default:
                return number;
            }
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return hyAm;
      });
      /***/

    },
    /* 587 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');

        function translate(number, withoutSuffix, key, isFuture) {
          var num = number;

          switch (key) {
            case 's':
              return isFuture || withoutSuffix ? 'néhány másodperc' : 'néhány másodperce';

            case 'ss':
              return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';

            case 'm':
              return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');

            case 'mm':
              return num + (isFuture || withoutSuffix ? ' perc' : ' perce');

            case 'h':
              return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');

            case 'hh':
              return num + (isFuture || withoutSuffix ? ' óra' : ' órája');

            case 'd':
              return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');

            case 'dd':
              return num + (isFuture || withoutSuffix ? ' nap' : ' napja');

            case 'M':
              return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');

            case 'MM':
              return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');

            case 'y':
              return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');

            case 'yy':
              return num + (isFuture || withoutSuffix ? ' év' : ' éve');
          }

          return '';
        }

        function week(isFuture) {
          return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
        }

        var hu = moment.defineLocale('hu', {
          months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
          monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
          weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
          weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
          weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm'
          },
          meridiemParse: /de|du/i,
          isPM: function isPM(input) {
            return input.charAt(1).toLowerCase() === 'u';
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
              return isLower === true ? 'de' : 'DE';
            } else {
              return isLower === true ? 'du' : 'DU';
            }
          },
          calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function nextWeek() {
              return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function lastWeek() {
              return week.call(this, false);
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return hu;
      });
      /***/

    },
    /* 588 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function translate(number, withoutSuffix, key) {
          var result = number + ' ';

          switch (key) {
            case 'ss':
              if (number === 1) {
                result += 'sekunda';
              } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
              } else {
                result += 'sekundi';
              }

              return result;

            case 'm':
              return withoutSuffix ? 'jedna minuta' : 'jedne minute';

            case 'mm':
              if (number === 1) {
                result += 'minuta';
              } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
              } else {
                result += 'minuta';
              }

              return result;

            case 'h':
              return withoutSuffix ? 'jedan sat' : 'jednog sata';

            case 'hh':
              if (number === 1) {
                result += 'sat';
              } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
              } else {
                result += 'sati';
              }

              return result;

            case 'dd':
              if (number === 1) {
                result += 'dan';
              } else {
                result += 'dana';
              }

              return result;

            case 'MM':
              if (number === 1) {
                result += 'mjesec';
              } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
              } else {
                result += 'mjeseci';
              }

              return result;

            case 'yy':
              if (number === 1) {
                result += 'godina';
              } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
              } else {
                result += 'godina';
              }

              return result;
          }
        }

        var hr = moment.defineLocale('hr', {
          months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
          },
          monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
          monthsParseExact: true,
          weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
          weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
          weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
              switch (this.day()) {
                case 0:
                  return '[u] [nedjelju] [u] LT';

                case 3:
                  return '[u] [srijedu] [u] LT';

                case 6:
                  return '[u] [subotu] [u] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[u] dddd [u] LT';
              }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                case 3:
                  return '[prošlu] dddd [u] LT';

                case 6:
                  return '[prošle] [subote] [u] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[prošli] dddd [u] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return hr;
      });
      /***/

    },
    /* 589 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '१',
          '2': '२',
          '3': '३',
          '4': '४',
          '5': '५',
          '6': '६',
          '7': '७',
          '8': '८',
          '9': '९',
          '0': '०'
        },
            numberMap = {
          '१': '1',
          '२': '2',
          '३': '3',
          '४': '4',
          '५': '5',
          '६': '6',
          '७': '7',
          '८': '8',
          '९': '9',
          '०': '0'
        };
        var hi = moment.defineLocale('hi', {
          months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
          monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
          monthsParseExact: true,
          weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
          weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
          weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
          longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
          },
          calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष'
          },
          preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          // Hindi notation for meridiems are quite fuzzy in practice. While there exists
          // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
          meridiemParse: /रात|सुबह|दोपहर|शाम/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'रात') {
              return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
              return hour;
            } else if (meridiem === 'दोपहर') {
              return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'रात';
            } else if (hour < 10) {
              return 'सुबह';
            } else if (hour < 17) {
              return 'दोपहर';
            } else if (hour < 20) {
              return 'शाम';
            } else {
              return 'रात';
            }
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return hi;
      });
      /***/

    },
    /* 590 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var he = moment.defineLocale('he', {
          months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
          monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
          weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
          weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
          weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function hh(number) {
              if (number === 2) {
                return 'שעתיים';
              }

              return number + ' שעות';
            },
            d: 'יום',
            dd: function dd(number) {
              if (number === 2) {
                return 'יומיים';
              }

              return number + ' ימים';
            },
            M: 'חודש',
            MM: function MM(number) {
              if (number === 2) {
                return 'חודשיים';
              }

              return number + ' חודשים';
            },
            y: 'שנה',
            yy: function yy(number) {
              if (number === 2) {
                return 'שנתיים';
              } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
              }

              return number + ' שנים';
            }
          },
          meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
          isPM: function isPM(input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 5) {
              return 'לפנות בוקר';
            } else if (hour < 10) {
              return 'בבוקר';
            } else if (hour < 12) {
              return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
              return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
              return 'בערב';
            }
          }
        });
        return he;
      });
      /***/

    },
    /* 591 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '૧',
          '2': '૨',
          '3': '૩',
          '4': '૪',
          '5': '૫',
          '6': '૬',
          '7': '૭',
          '8': '૮',
          '9': '૯',
          '0': '૦'
        },
            numberMap = {
          '૧': '1',
          '૨': '2',
          '૩': '3',
          '૪': '4',
          '૫': '5',
          '૬': '6',
          '૭': '7',
          '૮': '8',
          '૯': '9',
          '૦': '0'
        };
        var gu = moment.defineLocale('gu', {
          months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
          monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
          monthsParseExact: true,
          weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
          weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
          weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
          longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
          },
          calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
          },
          preparse: function preparse(string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
          // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
          meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'રાત') {
              return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
              return hour;
            } else if (meridiem === 'બપોર') {
              return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'રાત';
            } else if (hour < 10) {
              return 'સવાર';
            } else if (hour < 17) {
              return 'બપોર';
            } else if (hour < 20) {
              return 'સાંજ';
            } else {
              return 'રાત';
            }
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return gu;
      });
      /***/

    },
    /* 592 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function processRelativeTime(number, withoutSuffix, key, isFuture) {
          var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka voran', 'ek vor'],
            'hh': [number + ' voranim', number + ' voram'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
          };
          return withoutSuffix ? format[key][0] : format[key][1];
        }

        var gomLatn = moment.defineLocale('gom-latn', {
          months: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
          monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
          monthsParseExact: true,
          weekdays: 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
          weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
          weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
          },
          calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
          },
          dayOfMonthOrdinalParse: /\d{1,2}(er)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              // the ordinal 'er' only applies to day of the month
              case 'D':
                return number + 'er';

              default:
              case 'M':
              case 'Q':
              case 'DDD':
              case 'd':
              case 'w':
              case 'W':
                return number;
            }
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          },
          meridiemParse: /rati|sokalli|donparam|sanje/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'rati') {
              return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
              return hour;
            } else if (meridiem === 'donparam') {
              return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
              return hour + 12;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'rati';
            } else if (hour < 12) {
              return 'sokalli';
            } else if (hour < 16) {
              return 'donparam';
            } else if (hour < 20) {
              return 'sanje';
            } else {
              return 'rati';
            }
          }
        });
        return gomLatn;
      });
      /***/

    },
    /* 593 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var gl = moment.defineLocale('gl', {
          months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
          monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
          monthsParseExact: true,
          weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
          weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
          weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
          },
          calendar: {
            sameDay: function sameDay() {
              return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function nextDay() {
              return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function nextWeek() {
              return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function lastDay() {
              return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function lastWeek() {
              return '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: function future(str) {
              if (str.indexOf('un') === 0) {
                return 'n' + str;
              }

              return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos'
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: '%dº',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return gl;
      });
      /***/

    },
    /* 594 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var months = ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'];
        var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
        var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
        var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
        var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
        var gd = moment.defineLocale('gd', {
          months: months,
          monthsShort: monthsShort,
          monthsParseExact: true,
          weekdays: weekdays,
          weekdaysShort: weekdaysShort,
          weekdaysMin: weekdaysMin,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
          ordinal: function ordinal(number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return gd;
      });
      /***/

    },
    /* 595 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var months = ['Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'];
        var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
        var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
        var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
        var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
        var ga = moment.defineLocale('ga', {
          months: months,
          monthsShort: monthsShort,
          monthsParseExact: true,
          weekdays: weekdays,
          weekdaysShort: weekdaysShort,
          weekdaysMin: weekdaysMin,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné aig] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d mí',
            y: 'bliain',
            yy: '%d bliain'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
          ordinal: function ordinal(number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return ga;
      });
      /***/

    },
    /* 596 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
            monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
        var fy = moment.defineLocale('fy', {
          months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
          monthsShort: function monthsShort(m, format) {
            if (!m) {
              return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
              return monthsShortWithoutDots[m.month()];
            } else {
              return monthsShortWithDots[m.month()];
            }
          },
          monthsParseExact: true,
          weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
          weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
          weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
          ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return fy;
      });
      /***/

    },
    /* 597 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var frCh = moment.defineLocale('fr-ch', {
          months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
          monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
          monthsParseExact: true,
          weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
          weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
          weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              // Words with masculine grammatical gender: mois, trimestre, jour
              default:
              case 'M':
              case 'Q':
              case 'D':
              case 'DDD':
              case 'd':
                return number + (number === 1 ? 'er' : 'e');
              // Words with feminine grammatical gender: semaine

              case 'w':
              case 'W':
                return number + (number === 1 ? 're' : 'e');
            }
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return frCh;
      });
      /***/

    },
    /* 598 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var frCa = moment.defineLocale('fr-ca', {
          months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
          monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
          monthsParseExact: true,
          weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
          weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
          weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              // Words with masculine grammatical gender: mois, trimestre, jour
              default:
              case 'M':
              case 'Q':
              case 'D':
              case 'DDD':
              case 'd':
                return number + (number === 1 ? 'er' : 'e');
              // Words with feminine grammatical gender: semaine

              case 'w':
              case 'W':
                return number + (number === 1 ? 're' : 'e');
            }
          }
        });
        return frCa;
      });
      /***/

    },
    /* 599 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var fr = moment.defineLocale('fr', {
          months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
          monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
          monthsParseExact: true,
          weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
          weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
          weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              // TODO: Return 'e' when day of month > 1. Move this case inside
              // block for masculine words below.
              // See https://github.com/moment/moment/issues/3375
              case 'D':
                return number + (number === 1 ? 'er' : '');
              // Words with masculine grammatical gender: mois, trimestre, jour

              default:
              case 'M':
              case 'Q':
              case 'DDD':
              case 'd':
                return number + (number === 1 ? 'er' : 'e');
              // Words with feminine grammatical gender: semaine

              case 'w':
              case 'W':
                return number + (number === 1 ? 're' : 'e');
            }
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return fr;
      });
      /***/

    },
    /* 600 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var fo = moment.defineLocale('fo', {
          months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
          monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
          weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
          weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
          weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár'
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return fo;
      });
      /***/

    },
    /* 601 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
            numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', numbersPast[7], numbersPast[8], numbersPast[9]];

        function translate(number, withoutSuffix, key, isFuture) {
          var result = '';

          switch (key) {
            case 's':
              return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';

            case 'ss':
              return isFuture ? 'sekunnin' : 'sekuntia';

            case 'm':
              return isFuture ? 'minuutin' : 'minuutti';

            case 'mm':
              result = isFuture ? 'minuutin' : 'minuuttia';
              break;

            case 'h':
              return isFuture ? 'tunnin' : 'tunti';

            case 'hh':
              result = isFuture ? 'tunnin' : 'tuntia';
              break;

            case 'd':
              return isFuture ? 'päivän' : 'päivä';

            case 'dd':
              result = isFuture ? 'päivän' : 'päivää';
              break;

            case 'M':
              return isFuture ? 'kuukauden' : 'kuukausi';

            case 'MM':
              result = isFuture ? 'kuukauden' : 'kuukautta';
              break;

            case 'y':
              return isFuture ? 'vuoden' : 'vuosi';

            case 'yy':
              result = isFuture ? 'vuoden' : 'vuotta';
              break;
          }

          result = verbalNumber(number, isFuture) + ' ' + result;
          return result;
        }

        function verbalNumber(number, isFuture) {
          return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
        }

        var fi = moment.defineLocale('fi', {
          months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
          monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
          weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
          weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
          weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
          longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
          },
          calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return fi;
      });
      /***/

    },
    /* 602 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '۱',
          '2': '۲',
          '3': '۳',
          '4': '۴',
          '5': '۵',
          '6': '۶',
          '7': '۷',
          '8': '۸',
          '9': '۹',
          '0': '۰'
        },
            numberMap = {
          '۱': '1',
          '۲': '2',
          '۳': '3',
          '۴': '4',
          '۵': '5',
          '۶': '6',
          '۷': '7',
          '۸': '8',
          '۹': '9',
          '۰': '0'
        };
        var fa = moment.defineLocale('fa', {
          months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
          monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
          weekdays: "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split('_'),
          weekdaysShort: "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split('_'),
          weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          meridiemParse: /قبل از ظهر|بعد از ظهر/,
          isPM: function isPM(input) {
            return /بعد از ظهر/.test(input);
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'قبل از ظهر';
            } else {
              return 'بعد از ظهر';
            }
          },
          calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: 'ثانیه d%',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال'
          },
          preparse: function preparse(string) {
            return string.replace(/[۰-۹]/g, function (match) {
              return numberMap[match];
            }).replace(/،/g, ',');
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            }).replace(/,/g, '،');
          },
          dayOfMonthOrdinalParse: /\d{1,2}م/,
          ordinal: '%dم',
          week: {
            dow: 6,
            // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.

          }
        });
        return fa;
      });
      /***/

    },
    /* 603 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var eu = moment.defineLocale('eu', {
          months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
          monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
          monthsParseExact: true,
          weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
          weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
          weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
          },
          calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte'
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return eu;
      });
      /***/

    },
    /* 604 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function processRelativeTime(number, withoutSuffix, key, isFuture) {
          var format = {
            's': ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm': ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h': ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd': ['ühe päeva', 'üks päev'],
            'M': ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y': ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
          };

          if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
          }

          return isFuture ? format[key][0] : format[key][1];
        }

        var et = moment.defineLocale('et', {
          months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
          monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
          weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
          weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
          weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return et;
      });
      /***/

    },
    /* 605 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
            _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

        var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
        var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        var esUs = moment.defineLocale('es-us', {
          months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
          monthsShort: function monthsShort(m, format) {
            if (!m) {
              return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
              return _monthsShort[m.month()];
            } else {
              return monthsShortDot[m.month()];
            }
          },
          monthsRegex: monthsRegex,
          monthsShortRegex: monthsRegex,
          monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
          monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
          monthsParse: monthsParse,
          longMonthsParse: monthsParse,
          shortMonthsParse: monthsParse,
          weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
          weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
          weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
          },
          calendar: {
            sameDay: function sameDay() {
              return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
              return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
              return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
              return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
              return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: '%dº',
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return esUs;
      });
      /***/

    },
    /* 606 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
            _monthsShort2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

        var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
        var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        var esDo = moment.defineLocale('es-do', {
          months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
          monthsShort: function monthsShort(m, format) {
            if (!m) {
              return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
              return _monthsShort2[m.month()];
            } else {
              return monthsShortDot[m.month()];
            }
          },
          monthsRegex: monthsRegex,
          monthsShortRegex: monthsRegex,
          monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
          monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
          monthsParse: monthsParse,
          longMonthsParse: monthsParse,
          shortMonthsParse: monthsParse,
          weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
          weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
          weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
          },
          calendar: {
            sameDay: function sameDay() {
              return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
              return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
              return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
              return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
              return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: '%dº',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return esDo;
      });
      /***/

    },
    /* 607 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
            _monthsShort3 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

        var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
        var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        var es = moment.defineLocale('es', {
          months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
          monthsShort: function monthsShort(m, format) {
            if (!m) {
              return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
              return _monthsShort3[m.month()];
            } else {
              return monthsShortDot[m.month()];
            }
          },
          monthsRegex: monthsRegex,
          monthsShortRegex: monthsRegex,
          monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
          monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
          monthsParse: monthsParse,
          longMonthsParse: monthsParse,
          shortMonthsParse: monthsParse,
          weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
          weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
          weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
          },
          calendar: {
            sameDay: function sameDay() {
              return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
              return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
              return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
              return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
              return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
          },
          dayOfMonthOrdinalParse: /\d{1,2}º/,
          ordinal: '%dº',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return es;
      });
      /***/

    },
    /* 608 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var eo = moment.defineLocale('eo', {
          months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
          monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
          weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
          weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
          weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D[-a de] MMMM, YYYY',
            LLL: 'D[-a de] MMMM, YYYY HH:mm',
            LLLL: 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
          },
          meridiemParse: /[ap]\.t\.m/i,
          isPM: function isPM(input) {
            return input.charAt(0).toLowerCase() === 'p';
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
              return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
              return isLower ? 'a.t.m.' : 'A.T.M.';
            }
          },
          calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd [je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasinta] dddd [je] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'sekundoj',
            ss: '%d sekundoj',
            m: 'minuto',
            mm: '%d minutoj',
            h: 'horo',
            hh: '%d horoj',
            d: 'tago',
            //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'monato',
            MM: '%d monatoj',
            y: 'jaro',
            yy: '%d jaroj'
          },
          dayOfMonthOrdinalParse: /\d{1,2}a/,
          ordinal: '%da',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return eo;
      });
      /***/

    },
    /* 609 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var enNz = moment.defineLocale('en-nz', {
          months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
          monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
          weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
          weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
          weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
          longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
          },
          calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return enNz;
      });
      /***/

    },
    /* 610 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var enIl = moment.defineLocale('en-il', {
          months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
          monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
          weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
          weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
          weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
          }
        });
        return enIl;
      });
      /***/

    },
    /* 611 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var enIe = moment.defineLocale('en-ie', {
          months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
          monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
          weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
          weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
          weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return enIe;
      });
      /***/

    },
    /* 612 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var enGb = moment.defineLocale('en-gb', {
          months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
          monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
          weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
          weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
          weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return enGb;
      });
      /***/

    },
    /* 613 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var enCa = moment.defineLocale('en-ca', {
          months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
          monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
          weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
          weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
          weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
          longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A'
          },
          calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
          }
        });
        return enCa;
      });
      /***/

    },
    /* 614 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var enAu = moment.defineLocale('en-au', {
          months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
          monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
          weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
          weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
          weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
          longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
          },
          calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return enAu;
      });
      /***/

    },
    /* 615 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var enSG = moment.defineLocale('en-SG', {
          months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
          monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
          weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
          weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
          weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
          ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return enSG;
      });
      /***/

    },
    /* 616 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function isFunction(input) {
          return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
        }

        var el = moment.defineLocale('el', {
          monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
          monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
          months: function months(momentToFormat, format) {
            if (!momentToFormat) {
              return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) {
              // if there is a day number before 'MMMM'
              return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
              return this._monthsNominativeEl[momentToFormat.month()];
            }
          },
          monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
          weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
          weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
          weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
              return isLower ? 'μμ' : 'ΜΜ';
            } else {
              return isLower ? 'πμ' : 'ΠΜ';
            }
          },
          isPM: function isPM(input) {
            return (input + '').toLowerCase()[0] === 'μ';
          },
          meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
          longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
          },
          calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 6:
                  return '[το προηγούμενο] dddd [{}] LT';

                default:
                  return '[την προηγούμενη] dddd [{}] LT';
              }
            },
            sameElse: 'L'
          },
          calendar: function calendar(key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();

            if (isFunction(output)) {
              output = output.apply(mom);
            }

            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
          },
          relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια'
          },
          dayOfMonthOrdinalParse: /\d{1,2}η/,
          ordinal: '%dη',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4st is the first week of the year.

          }
        });
        return el;
      });
      /***/

    },
    /* 617 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var months = ['ޖެނުއަރީ', 'ފެބްރުއަރީ', 'މާރިޗު', 'އޭޕްރީލު', 'މޭ', 'ޖޫން', 'ޖުލައި', 'އޯގަސްޓު', 'ސެޕްޓެމްބަރު', 'އޮކްޓޯބަރު', 'ނޮވެމްބަރު', 'ޑިސެމްބަރު'],
            weekdays = ['އާދިއްތަ', 'ހޯމަ', 'އަންގާރަ', 'ބުދަ', 'ބުރާސްފަތި', 'ހުކުރު', 'ހޮނިހިރު'];
        var dv = moment.defineLocale('dv', {
          months: months,
          monthsShort: months,
          weekdays: weekdays,
          weekdaysShort: weekdays,
          weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          meridiemParse: /މކ|މފ/,
          isPM: function isPM(input) {
            return 'މފ' === input;
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'މކ';
            } else {
              return 'މފ';
            }
          },
          calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d'
          },
          preparse: function preparse(string) {
            return string.replace(/،/g, ',');
          },
          postformat: function postformat(string) {
            return string.replace(/,/g, '،');
          },
          week: {
            dow: 7,
            // Sunday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.

          }
        });
        return dv;
      });
      /***/

    },
    /* 618 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function processRelativeTime(number, withoutSuffix, key, isFuture) {
          var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
          };
          return withoutSuffix ? format[key][0] : format[key][1];
        }

        var deCh = moment.defineLocale('de-ch', {
          months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
          monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
          monthsParseExact: true,
          weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
          weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
          weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
          },
          relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return deCh;
      });
      /***/

    },
    /* 619 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function processRelativeTime(number, withoutSuffix, key, isFuture) {
          var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
          };
          return withoutSuffix ? format[key][0] : format[key][1];
        }

        var deAt = moment.defineLocale('de-at', {
          months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
          monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
          monthsParseExact: true,
          weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
          weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
          weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
          },
          relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return deAt;
      });
      /***/

    },
    /* 620 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function processRelativeTime(number, withoutSuffix, key, isFuture) {
          var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
          };
          return withoutSuffix ? format[key][0] : format[key][1];
        }

        var de = moment.defineLocale('de', {
          months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
          monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
          monthsParseExact: true,
          weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
          weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
          weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
          },
          relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return de;
      });
      /***/

    },
    /* 621 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var da = moment.defineLocale('da', {
          months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
          monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
          weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
          weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
          weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
          },
          calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år'
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return da;
      });
      /***/

    },
    /* 622 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var cy = moment.defineLocale('cy', {
          months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
          monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
          weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
          weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
          weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
          weekdaysParseExact: true,
          // time formats are the same as en-gb
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
          // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
          ordinal: function ordinal(number) {
            var b = number,
                output = '',
                lookup = ['', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
            'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];

            if (b > 20) {
              if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
              } else {
                output = 'ain';
              }
            } else if (b > 0) {
              output = lookup[b];
            }

            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return cy;
      });
      /***/

    },
    /* 623 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var cv = moment.defineLocale('cv', {
          months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
          monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
          weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
          weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
          weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
          },
          calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
          },
          relativeTime: {
            future: function future(output) {
              var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
              return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул'
          },
          dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
          ordinal: '%d-мӗш',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return cv;
      });
      /***/

    },
    /* 624 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
            monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
        var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i]; // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.

        var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

        function plural(n) {
          return n > 1 && n < 5 && ~~(n / 10) !== 1;
        }

        function translate(number, withoutSuffix, key, isFuture) {
          var result = number + ' ';

          switch (key) {
            case 's':
              // a few seconds / in a few seconds / a few seconds ago
              return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';

            case 'ss':
              // 9 seconds / in 9 seconds / 9 seconds ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekund');
              } else {
                return result + 'sekundami';
              }

              break;

            case 'm':
              // a minute / in a minute / a minute ago
              return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';

            case 'mm':
              // 9 minutes / in 9 minutes / 9 minutes ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
              } else {
                return result + 'minutami';
              }

              break;

            case 'h':
              // an hour / in an hour / an hour ago
              return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';

            case 'hh':
              // 9 hours / in 9 hours / 9 hours ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
              } else {
                return result + 'hodinami';
              }

              break;

            case 'd':
              // a day / in a day / a day ago
              return withoutSuffix || isFuture ? 'den' : 'dnem';

            case 'dd':
              // 9 days / in 9 days / 9 days ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
              } else {
                return result + 'dny';
              }

              break;

            case 'M':
              // a month / in a month / a month ago
              return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';

            case 'MM':
              // 9 months / in 9 months / 9 months ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
              } else {
                return result + 'měsíci';
              }

              break;

            case 'y':
              // a year / in a year / a year ago
              return withoutSuffix || isFuture ? 'rok' : 'rokem';

            case 'yy':
              // 9 years / in 9 years / 9 years ago
              if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
              } else {
                return result + 'lety';
              }

              break;
          }
        }

        var cs = moment.defineLocale('cs', {
          months: months,
          monthsShort: monthsShort,
          monthsRegex: monthsRegex,
          monthsShortRegex: monthsRegex,
          // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
          // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
          monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
          monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
          monthsParse: monthsParse,
          longMonthsParse: monthsParse,
          shortMonthsParse: monthsParse,
          weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
          weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
          weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY'
          },
          calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function nextWeek() {
              switch (this.day()) {
                case 0:
                  return '[v neděli v] LT';

                case 1:
                case 2:
                  return '[v] dddd [v] LT';

                case 3:
                  return '[ve středu v] LT';

                case 4:
                  return '[ve čtvrtek v] LT';

                case 5:
                  return '[v pátek v] LT';

                case 6:
                  return '[v sobotu v] LT';
              }
            },
            lastDay: '[včera v] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                  return '[minulou neděli v] LT';

                case 1:
                case 2:
                  return '[minulé] dddd [v] LT';

                case 3:
                  return '[minulou středu v] LT';

                case 4:
                case 5:
                  return '[minulý] dddd [v] LT';

                case 6:
                  return '[minulou sobotu v] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return cs;
      });
      /***/

    },
    /* 625 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var ca = moment.defineLocale('ca', {
          months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
          },
          monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
          monthsParseExact: true,
          weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
          weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
          weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm'
          },
          calendar: {
            sameDay: function sameDay() {
              return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function nextDay() {
              return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function nextWeek() {
              return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function lastDay() {
              return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function lastWeek() {
              return '[el] dddd [passat a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'd\'aquí %s',
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
          ordinal: function ordinal(number, period) {
            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';

            if (period === 'w' || period === 'W') {
              output = 'a';
            }

            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return ca;
      });
      /***/

    },
    /* 626 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function translate(number, withoutSuffix, key) {
          var result = number + ' ';

          switch (key) {
            case 'ss':
              if (number === 1) {
                result += 'sekunda';
              } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
              } else {
                result += 'sekundi';
              }

              return result;

            case 'm':
              return withoutSuffix ? 'jedna minuta' : 'jedne minute';

            case 'mm':
              if (number === 1) {
                result += 'minuta';
              } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
              } else {
                result += 'minuta';
              }

              return result;

            case 'h':
              return withoutSuffix ? 'jedan sat' : 'jednog sata';

            case 'hh':
              if (number === 1) {
                result += 'sat';
              } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
              } else {
                result += 'sati';
              }

              return result;

            case 'dd':
              if (number === 1) {
                result += 'dan';
              } else {
                result += 'dana';
              }

              return result;

            case 'MM':
              if (number === 1) {
                result += 'mjesec';
              } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
              } else {
                result += 'mjeseci';
              }

              return result;

            case 'yy':
              if (number === 1) {
                result += 'godina';
              } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
              } else {
                result += 'godina';
              }

              return result;
          }
        }

        var bs = moment.defineLocale('bs', {
          months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
          monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
          monthsParseExact: true,
          weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
          weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
          weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
              switch (this.day()) {
                case 0:
                  return '[u] [nedjelju] [u] LT';

                case 3:
                  return '[u] [srijedu] [u] LT';

                case 6:
                  return '[u] [subotu] [u] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[u] dddd [u] LT';
              }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                case 3:
                  return '[prošlu] dddd [u] LT';

                case 6:
                  return '[prošle] [subote] [u] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[prošli] dddd [u] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
          },
          dayOfMonthOrdinalParse: /\d{1,2}\./,
          ordinal: '%d.',
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return bs;
      });
      /***/

    },
    /* 627 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function relativeTimeWithMutation(number, withoutSuffix, key) {
          var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
          };
          return number + ' ' + mutation(format[key], number);
        }

        function specialMutationForYears(number) {
          switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
              return number + ' bloaz';

            default:
              return number + ' vloaz';
          }
        }

        function lastNumber(number) {
          if (number > 9) {
            return lastNumber(number % 10);
          }

          return number;
        }

        function mutation(text, number) {
          if (number === 2) {
            return softMutation(text);
          }

          return text;
        }

        function softMutation(text) {
          var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
          };

          if (mutationTable[text.charAt(0)] === undefined) {
            return text;
          }

          return mutationTable[text.charAt(0)] + text.substring(1);
        }

        var br = moment.defineLocale('br', {
          months: 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
          monthsShort: 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
          weekdays: 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
          weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
          weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'h[e]mm A',
            LTS: 'h[e]mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL: 'dddd, D [a viz] MMMM YYYY h[e]mm A'
          },
          calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warc\'hoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Dec\'h da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'a-benn %s',
            past: '%s \'zo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears
          },
          dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
          ordinal: function ordinal(number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return br;
      });
      /***/

    },
    /* 628 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '༡',
          '2': '༢',
          '3': '༣',
          '4': '༤',
          '5': '༥',
          '6': '༦',
          '7': '༧',
          '8': '༨',
          '9': '༩',
          '0': '༠'
        },
            numberMap = {
          '༡': '1',
          '༢': '2',
          '༣': '3',
          '༤': '4',
          '༥': '5',
          '༦': '6',
          '༧': '7',
          '༨': '8',
          '༩': '9',
          '༠': '0'
        };
        var bo = moment.defineLocale('bo', {
          months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
          monthsShort: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
          weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
          weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
          weekdaysMin: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
          longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
          },
          calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ'
          },
          preparse: function preparse(string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'མཚན་མོ' && hour >= 4 || meridiem === 'ཉིན་གུང' && hour < 5 || meridiem === 'དགོང་དག') {
              return hour + 12;
            } else {
              return hour;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'མཚན་མོ';
            } else if (hour < 10) {
              return 'ཞོགས་ཀས';
            } else if (hour < 17) {
              return 'ཉིན་གུང';
            } else if (hour < 20) {
              return 'དགོང་དག';
            } else {
              return 'མཚན་མོ';
            }
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return bo;
      });
      /***/

    },
    /* 629 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '১',
          '2': '২',
          '3': '৩',
          '4': '৪',
          '5': '৫',
          '6': '৬',
          '7': '৭',
          '8': '৮',
          '9': '৯',
          '0': '০'
        },
            numberMap = {
          '১': '1',
          '২': '2',
          '৩': '3',
          '৪': '4',
          '৫': '5',
          '৬': '6',
          '৭': '7',
          '৮': '8',
          '৯': '9',
          '০': '0'
        };
        var bn = moment.defineLocale('bn', {
          months: 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
          monthsShort: 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
          weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
          weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
          weekdaysMin: 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
          longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
          },
          calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর'
          },
          preparse: function preparse(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
              return numberMap[match];
            });
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            });
          },
          meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
          meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
              hour = 0;
            }

            if (meridiem === 'রাত' && hour >= 4 || meridiem === 'দুপুর' && hour < 5 || meridiem === 'বিকাল') {
              return hour + 12;
            } else {
              return hour;
            }
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'রাত';
            } else if (hour < 10) {
              return 'সকাল';
            } else if (hour < 17) {
              return 'দুপুর';
            } else if (hour < 20) {
              return 'বিকাল';
            } else {
              return 'রাত';
            }
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return bn;
      });
      /***/

    },
    /* 630 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var bm = moment.defineLocale('bm', {
          months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
          monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
          weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
          weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
          weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
          },
          calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d'
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return bm;
      });
      /***/

    },
    /* 631 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var bg = moment.defineLocale('bg', {
          months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
          monthsShort: 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
          weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
          weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
          weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
          longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
          },
          calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                case 3:
                case 6:
                  return '[В изминалата] dddd [в] LT';

                case 1:
                case 2:
                case 4:
                case 5:
                  return '[В изминалия] dddd [в] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дни',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години'
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
          ordinal: function ordinal(number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;

            if (number === 0) {
              return number + '-ев';
            } else if (last2Digits === 0) {
              return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
              return number + '-ти';
            } else if (lastDigit === 1) {
              return number + '-ви';
            } else if (lastDigit === 2) {
              return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
              return number + '-ми';
            } else {
              return number + '-ти';
            }
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return bg;
      });
      /***/

    },
    /* 632 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        function plural(word, num) {
          var forms = word.split('_');
          return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
        }

        function relativeTimeWithPlural(number, withoutSuffix, key) {
          var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
          };

          if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
          } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
          } else {
            return number + ' ' + plural(format[key], +number);
          }
        }

        var be = moment.defineLocale('be', {
          months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
          },
          monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
          weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
          },
          weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
          weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
          },
          calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function nextWeek() {
              return '[У] dddd [ў] LT';
            },
            lastWeek: function lastWeek() {
              switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                  return '[У мінулую] dddd [ў] LT';

                case 1:
                case 2:
                case 4:
                  return '[У мінулы] dddd [ў] LT';
              }
            },
            sameElse: 'L'
          },
          relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural
          },
          meridiemParse: /ночы|раніцы|дня|вечара/,
          isPM: function isPM(input) {
            return /^(дня|вечара)$/.test(input);
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'ночы';
            } else if (hour < 12) {
              return 'раніцы';
            } else if (hour < 17) {
              return 'дня';
            } else {
              return 'вечара';
            }
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
          ordinal: function ordinal(number, period) {
            switch (period) {
              case 'M':
              case 'd':
              case 'DDD':
              case 'w':
              case 'W':
                return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + '-і' : number + '-ы';

              case 'D':
                return number + '-га';

              default:
                return number;
            }
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return be;
      });
      /***/

    },
    /* 633 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var suffixes = {
          1: '-inci',
          5: '-inci',
          8: '-inci',
          70: '-inci',
          80: '-inci',
          2: '-nci',
          7: '-nci',
          20: '-nci',
          50: '-nci',
          3: '-üncü',
          4: '-üncü',
          100: '-üncü',
          6: '-ncı',
          9: '-uncu',
          10: '-uncu',
          30: '-uncu',
          60: '-ıncı',
          90: '-ıncı'
        };
        var az = moment.defineLocale('az', {
          months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
          monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
          weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
          weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
          weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'birneçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il'
          },
          meridiemParse: /gecə|səhər|gündüz|axşam/,
          isPM: function isPM(input) {
            return /^(gündüz|axşam)$/.test(input);
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
              return 'gecə';
            } else if (hour < 12) {
              return 'səhər';
            } else if (hour < 17) {
              return 'gündüz';
            } else {
              return 'axşam';
            }
          },
          dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
          ordinal: function ordinal(number) {
            if (number === 0) {
              // special case for zero
              return number + '-ıncı';
            }

            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.

          }
        });
        return az;
      });
      /***/

    },
    /* 634 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var arTn = moment.defineLocale('ar-tn', {
          months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
          monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
          weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
          weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
          weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
          },
          week: {
            dow: 1,
            // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return arTn;
      });
      /***/

    },
    /* 635 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '١',
          '2': '٢',
          '3': '٣',
          '4': '٤',
          '5': '٥',
          '6': '٦',
          '7': '٧',
          '8': '٨',
          '9': '٩',
          '0': '٠'
        },
            numberMap = {
          '١': '1',
          '٢': '2',
          '٣': '3',
          '٤': '4',
          '٥': '5',
          '٦': '6',
          '٧': '7',
          '٨': '8',
          '٩': '9',
          '٠': '0'
        };
        var arSa = moment.defineLocale('ar-sa', {
          months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
          monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
          weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
          weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
          weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          meridiemParse: /ص|م/,
          isPM: function isPM(input) {
            return 'م' === input;
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'ص';
            } else {
              return 'م';
            }
          },
          calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
          },
          preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
              return numberMap[match];
            }).replace(/،/g, ',');
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            }).replace(/,/g, '،');
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.

          }
        });
        return arSa;
      });
      /***/

    },
    /* 636 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var arMa = moment.defineLocale('ar-ma', {
          months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
          monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
          weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
          weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
          weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
          },
          week: {
            dow: 6,
            // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.

          }
        });
        return arMa;
      });
      /***/

    },
    /* 637 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '1',
          '2': '2',
          '3': '3',
          '4': '4',
          '5': '5',
          '6': '6',
          '7': '7',
          '8': '8',
          '9': '9',
          '0': '0'
        },
            pluralForm = function pluralForm(n) {
          return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
        },
            plurals = {
          s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
          m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
          h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
          d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
          M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
          y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
        },
            pluralize = function pluralize(u) {
          return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];

            if (f === 2) {
              str = str[withoutSuffix ? 0 : 1];
            }

            return str.replace(/%d/i, number);
          };
        },
            months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

        var arLy = moment.defineLocale('ar-ly', {
          months: months,
          monthsShort: months,
          weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
          weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
          weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: "D/\u200FM/\u200FYYYY",
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          meridiemParse: /ص|م/,
          isPM: function isPM(input) {
            return 'م' === input;
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'ص';
            } else {
              return 'م';
            }
          },
          calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
          },
          preparse: function preparse(string) {
            return string.replace(/،/g, ',');
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            }).replace(/,/g, '،');
          },
          week: {
            dow: 6,
            // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.

          }
        });
        return arLy;
      });
      /***/

    },
    /* 638 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var arKw = moment.defineLocale('ar-kw', {
          months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
          monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
          weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
          weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
          weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.

          }
        });
        return arKw;
      });
      /***/

    },
    /* 639 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var arDz = moment.defineLocale('ar-dz', {
          months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
          monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
          weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
          weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
          weekdaysMin: 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
          },
          week: {
            dow: 0,
            // Sunday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.

          }
        });
        return arDz;
      });
      /***/

    },
    /* 640 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var symbolMap = {
          '1': '١',
          '2': '٢',
          '3': '٣',
          '4': '٤',
          '5': '٥',
          '6': '٦',
          '7': '٧',
          '8': '٨',
          '9': '٩',
          '0': '٠'
        },
            numberMap = {
          '١': '1',
          '٢': '2',
          '٣': '3',
          '٤': '4',
          '٥': '5',
          '٦': '6',
          '٧': '7',
          '٨': '8',
          '٩': '9',
          '٠': '0'
        },
            pluralForm = function pluralForm(n) {
          return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
        },
            plurals = {
          s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
          m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
          h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
          d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
          M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
          y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
        },
            pluralize = function pluralize(u) {
          return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];

            if (f === 2) {
              str = str[withoutSuffix ? 0 : 1];
            }

            return str.replace(/%d/i, number);
          };
        },
            months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

        var ar = moment.defineLocale('ar', {
          months: months,
          monthsShort: months,
          weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
          weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
          weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
          weekdaysParseExact: true,
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: "D/\u200FM/\u200FYYYY",
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
          },
          meridiemParse: /ص|م/,
          isPM: function isPM(input) {
            return 'م' === input;
          },
          meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
              return 'ص';
            } else {
              return 'م';
            }
          },
          calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
          },
          preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
              return numberMap[match];
            }).replace(/،/g, ',');
          },
          postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
              return symbolMap[match];
            }).replace(/,/g, '،');
          },
          week: {
            dow: 6,
            // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.

          }
        });
        return ar;
      });
      /***/

    },
    /* 641 */

    /***/
    function (module, exports, __webpack_require__) {
      //! moment.js locale configuration
      ;

      (function (global, factory) {
        true ? factory(__webpack_require__(14)) : undefined;
      })(this, function (moment) {
        'use strict';

        var af = moment.defineLocale('af', {
          months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
          monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
          weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
          weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
          weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
          meridiemParse: /vm|nm/i,
          isPM: function isPM(input) {
            return /^nm$/i.test(input);
          },
          meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
              return isLower ? 'vm' : 'VM';
            } else {
              return isLower ? 'nm' : 'NM';
            }
          },
          longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
          },
          calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L'
          },
          relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: '\'n paar sekondes',
            ss: '%d sekondes',
            m: '\'n minuut',
            mm: '%d minute',
            h: '\'n uur',
            hh: '%d ure',
            d: '\'n dag',
            dd: '%d dae',
            M: '\'n maand',
            MM: '%d maande',
            y: '\'n jaar',
            yy: '%d jaar'
          },
          dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
          ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
          },
          week: {
            dow: 1,
            // Maandag is die eerste dag van die week.
            doy: 4 // Die week wat die 4de Januarie bevat is die eerste week van die jaar.

          }
        });
        return af;
      });
      /***/

    },
    /* 642 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.storeShape = undefined;

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var storeShape = exports.storeShape = _propTypes2.default.shape({
        subscribe: _propTypes2.default.func.isRequired,
        setState: _propTypes2.default.func.isRequired,
        getState: _propTypes2.default.func.isRequired
      });
      /***/

    },
    /* 643 */

    /***/
    function (module, exports) {
      module.exports = function (arr, obj) {
        if (arr.indexOf) return arr.indexOf(obj);

        for (var i = 0; i < arr.length; ++i) {
          if (arr[i] === obj) return i;
        }

        return -1;
      };
      /***/

    },
    /* 644 */

    /***/
    function (module, exports, __webpack_require__) {
      // getting tag from 19.1.3.6 Object.prototype.toString()
      var cof = __webpack_require__(367);

      var TAG = __webpack_require__(110)('toStringTag'); // ES3 wrong here


      var ARG = cof(function () {
        return arguments;
      }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

      var tryGet = function tryGet(it, key) {
        try {
          return it[key];
        } catch (e) {
          /* empty */
        }
      };

      module.exports = function (it) {
        var O, T, B;
        return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
        : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
        : ARG ? cof(O) // ES3 arguments fallback
        : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
      };
      /***/

    },
    /* 645 */

    /***/
    function (module, exports, __webpack_require__) {
      var classof = __webpack_require__(644);

      var ITERATOR = __webpack_require__(110)('iterator');

      var Iterators = __webpack_require__(178);

      module.exports = __webpack_require__(89).getIteratorMethod = function (it) {
        if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
      };
      /***/

    },
    /* 646 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
      var $keys = __webpack_require__(652);

      var hiddenKeys = __webpack_require__(362).concat('length', 'prototype');

      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return $keys(O, hiddenKeys);
      };
      /***/

    },
    /* 647 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
      var has = __webpack_require__(160);

      var toObject = __webpack_require__(213);

      var IE_PROTO = __webpack_require__(364)('IE_PROTO');

      var ObjectProto = Object.prototype;

      module.exports = Object.getPrototypeOf || function (O) {
        O = toObject(O);
        if (has(O, IE_PROTO)) return O[IE_PROTO];

        if (typeof O.constructor == 'function' && O instanceof O.constructor) {
          return O.constructor.prototype;
        }

        return O instanceof Object ? ObjectProto : null;
      };
      /***/

    },
    /* 648 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(181);
      /***/
    },
    /* 649 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var LIBRARY = __webpack_require__(259);

      var $export = __webpack_require__(139);

      var redefine = __webpack_require__(648);

      var hide = __webpack_require__(181);

      var Iterators = __webpack_require__(178);

      var $iterCreate = __webpack_require__(1160);

      var setToStringTag = __webpack_require__(359);

      var getPrototypeOf = __webpack_require__(647);

      var ITERATOR = __webpack_require__(110)('iterator');

      var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

      var FF_ITERATOR = '@@iterator';
      var KEYS = 'keys';
      var VALUES = 'values';

      var returnThis = function returnThis() {
        return this;
      };

      module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $iterCreate(Constructor, NAME, next);

        var getMethod = function getMethod(kind) {
          if (!BUGGY && kind in proto) return proto[kind];

          switch (kind) {
            case KEYS:
              return function keys() {
                return new Constructor(this, kind);
              };

            case VALUES:
              return function values() {
                return new Constructor(this, kind);
              };
          }

          return function entries() {
            return new Constructor(this, kind);
          };
        };

        var TAG = NAME + ' Iterator';
        var DEF_VALUES = DEFAULT == VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
        var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype; // Fix native

        if ($anyNative) {
          IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

          if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

            if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
          }
        } // fix Array#{values, @@iterator}.name in V8 / FF


        if (DEF_VALUES && $native && $native.name !== VALUES) {
          VALUES_BUG = true;

          $default = function values() {
            return $native.call(this);
          };
        } // Define iterator


        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
          hide(proto, ITERATOR, $default);
        } // Plug for library


        Iterators[NAME] = $default;
        Iterators[TAG] = returnThis;

        if (DEFAULT) {
          methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
          };
          if (FORCED) for (key in methods) {
            if (!(key in proto)) redefine(proto, key, methods[key]);
          } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
        }

        return methods;
      };
      /***/

    },
    /* 650 */

    /***/
    function (module, exports, __webpack_require__) {
      // 7.1.15 ToLength
      var toInteger = __webpack_require__(365);

      var min = Math.min;

      module.exports = function (it) {
        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
      };
      /***/

    },
    /* 651 */

    /***/
    function (module, exports, __webpack_require__) {
      // fallback for non-array-like ES3 and non-enumerable old V8 strings
      var cof = __webpack_require__(367); // eslint-disable-next-line no-prototype-builtins


      module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
        return cof(it) == 'String' ? it.split('') : Object(it);
      };
      /***/
    },
    /* 652 */

    /***/
    function (module, exports, __webpack_require__) {
      var has = __webpack_require__(160);

      var toIObject = __webpack_require__(159);

      var arrayIndexOf = __webpack_require__(1165)(false);

      var IE_PROTO = __webpack_require__(364)('IE_PROTO');

      module.exports = function (object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;

        for (key in O) {
          if (key != IE_PROTO) has(O, key) && result.push(key);
        } // Don't enum bug & hidden keys


        while (names.length > i) {
          if (has(O, key = names[i++])) {
            ~arrayIndexOf(result, key) || result.push(key);
          }
        }

        return result;
      };
      /***/

    },
    /* 653 */

    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(180);

      var document = __webpack_require__(138).document; // typeof document.createElement is 'object' in old IE


      var is = isObject(document) && isObject(document.createElement);

      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };
      /***/

    },
    /* 654 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = !__webpack_require__(136) && !__webpack_require__(179)(function () {
        return Object.defineProperty(__webpack_require__(653)('div'), 'a', {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });
      /***/
    },
    /* 655 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1172),
        __esModule: true
      };
      /***/
    },
    /* 656 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */
      // Name

      var NAME = exports.NAME = 'Name'; // Document

      var DOCUMENT = exports.DOCUMENT = 'Document';
      var OPERATION_DEFINITION = exports.OPERATION_DEFINITION = 'OperationDefinition';
      var VARIABLE_DEFINITION = exports.VARIABLE_DEFINITION = 'VariableDefinition';
      var VARIABLE = exports.VARIABLE = 'Variable';
      var SELECTION_SET = exports.SELECTION_SET = 'SelectionSet';
      var FIELD = exports.FIELD = 'Field';
      var ARGUMENT = exports.ARGUMENT = 'Argument'; // Fragments

      var FRAGMENT_SPREAD = exports.FRAGMENT_SPREAD = 'FragmentSpread';
      var INLINE_FRAGMENT = exports.INLINE_FRAGMENT = 'InlineFragment';
      var FRAGMENT_DEFINITION = exports.FRAGMENT_DEFINITION = 'FragmentDefinition'; // Values

      var INT = exports.INT = 'IntValue';
      var FLOAT = exports.FLOAT = 'FloatValue';
      var STRING = exports.STRING = 'StringValue';
      var BOOLEAN = exports.BOOLEAN = 'BooleanValue';
      var NULL = exports.NULL = 'NullValue';
      var ENUM = exports.ENUM = 'EnumValue';
      var LIST = exports.LIST = 'ListValue';
      var OBJECT = exports.OBJECT = 'ObjectValue';
      var OBJECT_FIELD = exports.OBJECT_FIELD = 'ObjectField'; // Directives

      var DIRECTIVE = exports.DIRECTIVE = 'Directive'; // Types

      var NAMED_TYPE = exports.NAMED_TYPE = 'NamedType';
      var LIST_TYPE = exports.LIST_TYPE = 'ListType';
      var NON_NULL_TYPE = exports.NON_NULL_TYPE = 'NonNullType'; // Type System Definitions

      var SCHEMA_DEFINITION = exports.SCHEMA_DEFINITION = 'SchemaDefinition';
      var OPERATION_TYPE_DEFINITION = exports.OPERATION_TYPE_DEFINITION = 'OperationTypeDefinition'; // Type Definitions

      var SCALAR_TYPE_DEFINITION = exports.SCALAR_TYPE_DEFINITION = 'ScalarTypeDefinition';
      var OBJECT_TYPE_DEFINITION = exports.OBJECT_TYPE_DEFINITION = 'ObjectTypeDefinition';
      var FIELD_DEFINITION = exports.FIELD_DEFINITION = 'FieldDefinition';
      var INPUT_VALUE_DEFINITION = exports.INPUT_VALUE_DEFINITION = 'InputValueDefinition';
      var INTERFACE_TYPE_DEFINITION = exports.INTERFACE_TYPE_DEFINITION = 'InterfaceTypeDefinition';
      var UNION_TYPE_DEFINITION = exports.UNION_TYPE_DEFINITION = 'UnionTypeDefinition';
      var ENUM_TYPE_DEFINITION = exports.ENUM_TYPE_DEFINITION = 'EnumTypeDefinition';
      var ENUM_VALUE_DEFINITION = exports.ENUM_VALUE_DEFINITION = 'EnumValueDefinition';
      var INPUT_OBJECT_TYPE_DEFINITION = exports.INPUT_OBJECT_TYPE_DEFINITION = 'InputObjectTypeDefinition'; // Type Extensions

      var TYPE_EXTENSION_DEFINITION = exports.TYPE_EXTENSION_DEFINITION = 'TypeExtensionDefinition'; // Directive Definitions

      var DIRECTIVE_DEFINITION = exports.DIRECTIVE_DEFINITION = 'DirectiveDefinition';
      /***/
    },
    /* 657 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getLocation = getLocation;
      /**
       * Takes a Source and a UTF-8 character offset, and returns the corresponding
       * line and column as a SourceLocation.
       */

      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */

      function getLocation(source, position) {
        var lineRegexp = /\r\n|[\n\r]/g;
        var line = 1;
        var column = position + 1;
        var match = void 0;

        while ((match = lineRegexp.exec(source.body)) && match.index < position) {
          line += 1;
          column = position + 1 - (match.index + match[0].length);
        }

        return {
          line: line,
          column: column
        };
      }
      /**
       * Represents a location in a Source.
       */

      /***/

    },
    /* 658 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _GraphQLError = __webpack_require__(372);

      Object.defineProperty(exports, 'GraphQLError', {
        enumerable: true,
        get: function get() {
          return _GraphQLError.GraphQLError;
        }
      });

      var _syntaxError = __webpack_require__(1187);

      Object.defineProperty(exports, 'syntaxError', {
        enumerable: true,
        get: function get() {
          return _syntaxError.syntaxError;
        }
      });

      var _locatedError = __webpack_require__(1186);

      Object.defineProperty(exports, 'locatedError', {
        enumerable: true,
        get: function get() {
          return _locatedError.locatedError;
        }
      });

      var _formatError = __webpack_require__(1185);

      Object.defineProperty(exports, 'formatError', {
        enumerable: true,
        get: function get() {
          return _formatError.formatError;
        }
      });
      /***/
    },
    /* 659 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = invariant;
      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */

      function invariant(condition, message) {
        if (!condition) {
          throw new Error(message);
        }
      }
      /***/

    },
    /* 660 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };

        return function (d, b) {
          extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var link_1 = __webpack_require__(661);

      function validateLink(link) {
        if (link instanceof link_1.ApolloLink && typeof link.request === 'function') {
          return link;
        } else {
          throw new LinkError('Link does not extend ApolloLink and implement request', link);
        }
      }

      exports.validateLink = validateLink;

      function validateOperation(operation) {
        var OPERATION_FIELDS = ['query', 'operationName', 'variables', 'context'];

        for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
          var key = _a[_i];

          if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw new Error("illegal argument: " + key);
          }
        }

        return operation;
      }

      exports.validateOperation = validateOperation;

      var LinkError = function (_super) {
        __extends(LinkError, _super);

        function LinkError(message, link) {
          var _this = _super.call(this, message) || this;

          _this.link = link;
          return _this;
        }

        return LinkError;
      }(Error);

      exports.LinkError = LinkError;

      function toLink(link) {
        if (typeof link === 'function') {
          return new link_1.FunctionLink(link);
        } else {
          return link;
        }
      }

      exports.toLink = toLink;

      function isTerminating(link) {
        return link.request.length <= 1;
      }

      exports.isTerminating = isTerminating;

      function makePromise(observable) {
        var completed = false;
        return new Promise(function (resolve, reject) {
          observable.subscribe({
            next: function next(data) {
              if (completed) {
                console.warn("Promise Wrapper does not support multiple results from Observable");
              } else {
                completed = true;
                resolve(data);
              }
            },
            error: reject
          });
        });
      }

      exports.makePromise = makePromise;
      /***/
    },
    /* 661 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };

        return function (d, b) {
          extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      var __assign = this && this.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var linkUtils_1 = __webpack_require__(660);

      var graphql_tag_1 = __webpack_require__(119);

      var zen_observable_ts_1 = __webpack_require__(371);

      var ApolloLink = function () {
        function ApolloLink() {}

        ApolloLink.from = function (links) {
          if (links.length === 0) {
            return ApolloLink.empty();
          }

          return links.map(linkUtils_1.toLink).reduce(function (x, y) {
            return x.concat(y);
          });
        };

        ApolloLink.empty = function () {
          return new FunctionLink(function (op, forward) {
            return zen_observable_ts_1.default.of();
          });
        };

        ApolloLink.passthrough = function () {
          return new FunctionLink(function (op, forward) {
            return forward ? forward(op) : zen_observable_ts_1.default.of();
          });
        };

        ApolloLink.split = function (test, left, right) {
          if (right === void 0) {
            right = ApolloLink.passthrough();
          }

          var leftLink = linkUtils_1.validateLink(linkUtils_1.toLink(left));
          var rightLink = linkUtils_1.validateLink(linkUtils_1.toLink(right));

          if (linkUtils_1.isTerminating(leftLink) && linkUtils_1.isTerminating(rightLink)) {
            return new FunctionLink(function (operation) {
              return test(operation) ? leftLink.request(operation) || zen_observable_ts_1.default.of() : rightLink.request(operation) || zen_observable_ts_1.default.of();
            });
          } else {
            return new FunctionLink(function (operation, forward) {
              return test(operation) ? leftLink.request(operation, forward) || zen_observable_ts_1.default.of() : rightLink.request(operation, forward) || zen_observable_ts_1.default.of();
            });
          }
        };

        ApolloLink.prototype.split = function (test, left, right) {
          if (right === void 0) {
            right = ApolloLink.passthrough();
          }

          return this.concat(ApolloLink.split(test, left, right));
        };

        ApolloLink.prototype.concat = function (next) {
          var _this = this;

          linkUtils_1.validateLink(this);

          if (linkUtils_1.isTerminating(this)) {
            console.warn(new linkUtils_1.LinkError("You are calling concat on a terminating link, which will have no effect", this));
            return this;
          }

          var nextLink = linkUtils_1.validateLink(linkUtils_1.toLink(next));

          if (linkUtils_1.isTerminating(nextLink)) {
            return new FunctionLink(function (operation) {
              return _this.request(operation, function (op) {
                return nextLink.request(op) || zen_observable_ts_1.default.of();
              }) || zen_observable_ts_1.default.of();
            });
          } else {
            return new FunctionLink(function (operation, forward) {
              return _this.request(operation, function (op) {
                return nextLink.request(op, forward) || zen_observable_ts_1.default.of();
              }) || zen_observable_ts_1.default.of();
            });
          }
        };

        return ApolloLink;
      }();

      exports.ApolloLink = ApolloLink;

      function execute(link, operation) {
        var copy = __assign({}, operation);

        linkUtils_1.validateOperation(copy);

        if (!copy.context) {
          copy.context = {};
        }

        if (!copy.variables) {
          copy.variables = {};
        }

        if (!copy.query) {
          console.warn("query should either be a string or GraphQL AST");
          copy.query = {};
        }

        return link.request(transformOperation(copy)) || zen_observable_ts_1.default.of();
      }

      exports.execute = execute;

      function getName(node) {
        return node && node.name && node.name.kind === 'Name' && node.name.value;
      }

      function transformOperation(operation) {
        var transformedOperation;

        if (typeof operation.query === 'string') {
          transformedOperation = __assign({}, operation, {
            query: graphql_tag_1.default(operation.query)
          });
        } else {
          transformedOperation = __assign({}, operation);
        }

        if (transformedOperation.query && transformedOperation.query.definitions) {
          if (!transformedOperation.operationName) {
            var operationTypes_1 = ['query', 'mutation', 'subscription'];
            var definitions = transformedOperation.query.definitions.filter(function (x) {
              return x.kind === 'OperationDefinition' && operationTypes_1.indexOf(x.operation) >= 0;
            });
            transformedOperation.operationName = getName(definitions[0]) || '';
          }
        } else if (!transformedOperation.operationName) {
          transformedOperation.operationName = '';
        }

        return transformedOperation;
      }

      var FunctionLink = function (_super) {
        __extends(FunctionLink, _super);

        function FunctionLink(f) {
          var _this = _super.call(this) || this;

          _this.f = f;
          _this.request = f;
          return _this;
        }

        FunctionLink.prototype.request = function (operation, forward) {
          throw Error('should be overridden');
        };

        return FunctionLink;
      }(ApolloLink);

      exports.FunctionLink = FunctionLink;
      /***/
    },
    /* 662 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var SCALAR_TYPES = {
        StringValue: true,
        BooleanValue: true,
        EnumValue: true
      };

      function isScalarValue(value) {
        return !!SCALAR_TYPES[value.kind];
      }

      var NUMBER_TYPES = {
        IntValue: true,
        FloatValue: true
      };

      function isNumberValue(value) {
        return NUMBER_TYPES[value.kind];
      }

      function isVariable(value) {
        return value.kind === 'Variable';
      }

      function isObject(value) {
        return value.kind === 'ObjectValue';
      }

      function isList(value) {
        return value.kind === 'ListValue';
      }

      function valueToObjectRepresentation(argObj, name, value, variables) {
        if (variables === void 0) {
          variables = {};
        }

        if (isNumberValue(value)) {
          argObj[name.value] = Number(value.value);
        } else if (isScalarValue(value)) {
          argObj[name.value] = value.value;
        } else if (isObject(value)) {
          var nestedArgObj_1 = {};
          value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
          });
          argObj[name.value] = nestedArgObj_1;
        } else if (isVariable(value)) {
          var variableValue = variables[value.name.value];
          argObj[name.value] = variableValue;
        } else if (isList(value)) {
          argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
          });
        } else {
          throw new Error("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\" is not supported. Use variables instead of inline arguments to overcome this limitation.");
        }
      }

      function argumentsObjectFromField(field, variables) {
        if (field.arguments && field.arguments.length) {
          var argObj_1 = {};
          field.arguments.forEach(function (_a) {
            var name = _a.name,
                value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
          });
          return argObj_1;
        }

        return null;
      }

      exports.argumentsObjectFromField = argumentsObjectFromField;

      function resultKeyNameFromField(field) {
        return field.alias ? field.alias.value : field.name.value;
      }

      exports.resultKeyNameFromField = resultKeyNameFromField;

      function isField(selection) {
        return selection.kind === 'Field';
      }

      exports.isField = isField;

      function isInlineFragment(selection) {
        return selection.kind === 'InlineFragment';
      }

      exports.isInlineFragment = isInlineFragment;

      function graphQLResultHasError(result) {
        return result.errors && result.errors.length;
      }

      exports.graphQLResultHasError = graphQLResultHasError;
      /***/
    },
    /* 663 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var getFromAST_1 = __webpack_require__(1191);

      var directives_1 = __webpack_require__(1190);

      var storeUtils_1 = __webpack_require__(662);

      function graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (execOptions === void 0) {
          execOptions = {};
        }

        var mainDefinition = getFromAST_1.getMainDefinition(document);
        var fragments = getFromAST_1.getFragmentDefinitions(document);
        var fragmentMap = getFromAST_1.createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;

        var fragmentMatcher = execOptions.fragmentMatcher || function () {
          return true;
        };

        var execContext = {
          fragmentMap: fragmentMap,
          contextValue: contextValue,
          variableValues: variableValues,
          resultMapper: resultMapper,
          resolver: resolver,
          fragmentMatcher: fragmentMatcher
        };
        return executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
      }

      exports.graphql = graphql;

      function executeSelectionSet(selectionSet, rootValue, execContext) {
        var fragmentMap = execContext.fragmentMap,
            contextValue = execContext.contextValue,
            variables = execContext.variableValues;
        var result = {};
        selectionSet.selections.forEach(function (selection) {
          if (!directives_1.shouldInclude(selection, variables)) {
            return;
          }

          if (storeUtils_1.isField(selection)) {
            var fieldResult = executeField(selection, rootValue, execContext);
            var resultFieldKey = storeUtils_1.resultKeyNameFromField(selection);

            if (fieldResult !== undefined) {
              if (result[resultFieldKey] === undefined) {
                result[resultFieldKey] = fieldResult;
              } else {
                merge(result[resultFieldKey], fieldResult);
              }
            }
          } else {
            var fragment = void 0;

            if (storeUtils_1.isInlineFragment(selection)) {
              fragment = selection;
            } else {
              fragment = fragmentMap[selection.name.value];

              if (!fragment) {
                throw new Error("No fragment named " + selection.name.value);
              }
            }

            var typeCondition = fragment.typeCondition.name.value;

            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
              var fragmentResult = executeSelectionSet(fragment.selectionSet, rootValue, execContext);
              merge(result, fragmentResult);
            }
          }
        });

        if (execContext.resultMapper) {
          return execContext.resultMapper(result, rootValue);
        }

        return result;
      }

      function executeField(field, rootValue, execContext) {
        var variables = execContext.variableValues,
            contextValue = execContext.contextValue,
            resolver = execContext.resolver;
        var fieldName = field.name.value;
        var args = storeUtils_1.argumentsObjectFromField(field, variables);
        var info = {
          isLeaf: !field.selectionSet,
          resultKey: storeUtils_1.resultKeyNameFromField(field),
          directives: directives_1.getDirectiveInfoFromField(field, variables)
        };
        var result = resolver(fieldName, rootValue, args, contextValue, info);

        if (!field.selectionSet) {
          return result;
        }

        if (result == null) {
          return result;
        }

        if (Array.isArray(result)) {
          return executeSubSelectedArray(field, result, execContext);
        }

        return executeSelectionSet(field.selectionSet, result, execContext);
      }

      function executeSubSelectedArray(field, result, execContext) {
        return result.map(function (item) {
          if (item === null) {
            return null;
          }

          if (Array.isArray(item)) {
            return executeSubSelectedArray(field, item, execContext);
          }

          return executeSelectionSet(field.selectionSet, item, execContext);
        });
      }

      function merge(dest, src) {
        if (src === null || typeof src !== 'object') {
          return src;
        }

        Object.keys(dest).forEach(function (destKey) {
          if (src.hasOwnProperty(destKey)) {
            merge(dest[destKey], src[destKey]);
          }
        });
        Object.keys(src).forEach(function (srcKey) {
          if (!dest.hasOwnProperty(srcKey)) {
            dest[srcKey] = src[srcKey];
          }
        });
      }
      /***/

    },
    /* 664 */

    /***/
    function (module, exports) {
      (function (self) {
        'use strict';

        if (self.fetch) {
          return;
        }

        var support = {
          searchParams: 'URLSearchParams' in self,
          iterable: 'Symbol' in self && 'iterator' in Symbol,
          blob: 'FileReader' in self && 'Blob' in self && function () {
            try {
              new Blob();
              return true;
            } catch (e) {
              return false;
            }
          }(),
          formData: 'FormData' in self,
          arrayBuffer: 'ArrayBuffer' in self
        };

        if (support.arrayBuffer) {
          var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

          var isDataView = function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
          };

          var isArrayBufferView = ArrayBuffer.isView || function (obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
          };
        }

        function normalizeName(name) {
          if (typeof name !== 'string') {
            name = String(name);
          }

          if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
            throw new TypeError('Invalid character in header field name');
          }

          return name.toLowerCase();
        }

        function normalizeValue(value) {
          if (typeof value !== 'string') {
            value = String(value);
          }

          return value;
        } // Build a destructive iterator for the value list


        function iteratorFor(items) {
          var iterator = {
            next: function next() {
              var value = items.shift();
              return {
                done: value === undefined,
                value: value
              };
            }
          };

          if (support.iterable) {
            iterator[Symbol.iterator] = function () {
              return iterator;
            };
          }

          return iterator;
        }

        function Headers(headers) {
          this.map = {};

          if (headers instanceof Headers) {
            headers.forEach(function (value, name) {
              this.append(name, value);
            }, this);
          } else if (Array.isArray(headers)) {
            headers.forEach(function (header) {
              this.append(header[0], header[1]);
            }, this);
          } else if (headers) {
            Object.getOwnPropertyNames(headers).forEach(function (name) {
              this.append(name, headers[name]);
            }, this);
          }
        }

        Headers.prototype.append = function (name, value) {
          name = normalizeName(name);
          value = normalizeValue(value);
          var oldValue = this.map[name];
          this.map[name] = oldValue ? oldValue + ',' + value : value;
        };

        Headers.prototype['delete'] = function (name) {
          delete this.map[normalizeName(name)];
        };

        Headers.prototype.get = function (name) {
          name = normalizeName(name);
          return this.has(name) ? this.map[name] : null;
        };

        Headers.prototype.has = function (name) {
          return this.map.hasOwnProperty(normalizeName(name));
        };

        Headers.prototype.set = function (name, value) {
          this.map[normalizeName(name)] = normalizeValue(value);
        };

        Headers.prototype.forEach = function (callback, thisArg) {
          for (var name in this.map) {
            if (this.map.hasOwnProperty(name)) {
              callback.call(thisArg, this.map[name], name, this);
            }
          }
        };

        Headers.prototype.keys = function () {
          var items = [];
          this.forEach(function (value, name) {
            items.push(name);
          });
          return iteratorFor(items);
        };

        Headers.prototype.values = function () {
          var items = [];
          this.forEach(function (value) {
            items.push(value);
          });
          return iteratorFor(items);
        };

        Headers.prototype.entries = function () {
          var items = [];
          this.forEach(function (value, name) {
            items.push([name, value]);
          });
          return iteratorFor(items);
        };

        if (support.iterable) {
          Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        }

        function consumed(body) {
          if (body.bodyUsed) {
            return Promise.reject(new TypeError('Already read'));
          }

          body.bodyUsed = true;
        }

        function fileReaderReady(reader) {
          return new Promise(function (resolve, reject) {
            reader.onload = function () {
              resolve(reader.result);
            };

            reader.onerror = function () {
              reject(reader.error);
            };
          });
        }

        function readBlobAsArrayBuffer(blob) {
          var reader = new FileReader();
          var promise = fileReaderReady(reader);
          reader.readAsArrayBuffer(blob);
          return promise;
        }

        function readBlobAsText(blob) {
          var reader = new FileReader();
          var promise = fileReaderReady(reader);
          reader.readAsText(blob);
          return promise;
        }

        function readArrayBufferAsText(buf) {
          var view = new Uint8Array(buf);
          var chars = new Array(view.length);

          for (var i = 0; i < view.length; i++) {
            chars[i] = String.fromCharCode(view[i]);
          }

          return chars.join('');
        }

        function bufferClone(buf) {
          if (buf.slice) {
            return buf.slice(0);
          } else {
            var view = new Uint8Array(buf.byteLength);
            view.set(new Uint8Array(buf));
            return view.buffer;
          }
        }

        function Body() {
          this.bodyUsed = false;

          this._initBody = function (body) {
            this._bodyInit = body;

            if (!body) {
              this._bodyText = '';
            } else if (typeof body === 'string') {
              this._bodyText = body;
            } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
              this._bodyBlob = body;
            } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
              this._bodyFormData = body;
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this._bodyText = body.toString();
            } else if (support.arrayBuffer && support.blob && isDataView(body)) {
              this._bodyArrayBuffer = bufferClone(body.buffer); // IE 10-11 can't handle a DataView body.

              this._bodyInit = new Blob([this._bodyArrayBuffer]);
            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
              this._bodyArrayBuffer = bufferClone(body);
            } else {
              throw new Error('unsupported BodyInit type');
            }

            if (!this.headers.get('content-type')) {
              if (typeof body === 'string') {
                this.headers.set('content-type', 'text/plain;charset=UTF-8');
              } else if (this._bodyBlob && this._bodyBlob.type) {
                this.headers.set('content-type', this._bodyBlob.type);
              } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
              }
            }
          };

          if (support.blob) {
            this.blob = function () {
              var rejected = consumed(this);

              if (rejected) {
                return rejected;
              }

              if (this._bodyBlob) {
                return Promise.resolve(this._bodyBlob);
              } else if (this._bodyArrayBuffer) {
                return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              } else if (this._bodyFormData) {
                throw new Error('could not read FormData body as blob');
              } else {
                return Promise.resolve(new Blob([this._bodyText]));
              }
            };

            this.arrayBuffer = function () {
              if (this._bodyArrayBuffer) {
                return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
              } else {
                return this.blob().then(readBlobAsArrayBuffer);
              }
            };
          }

          this.text = function () {
            var rejected = consumed(this);

            if (rejected) {
              return rejected;
            }

            if (this._bodyBlob) {
              return readBlobAsText(this._bodyBlob);
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
            } else if (this._bodyFormData) {
              throw new Error('could not read FormData body as text');
            } else {
              return Promise.resolve(this._bodyText);
            }
          };

          if (support.formData) {
            this.formData = function () {
              return this.text().then(decode);
            };
          }

          this.json = function () {
            return this.text().then(JSON.parse);
          };

          return this;
        } // HTTP methods whose capitalization should be normalized


        var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

        function normalizeMethod(method) {
          var upcased = method.toUpperCase();
          return methods.indexOf(upcased) > -1 ? upcased : method;
        }

        function Request(input, options) {
          options = options || {};
          var body = options.body;

          if (input instanceof Request) {
            if (input.bodyUsed) {
              throw new TypeError('Already read');
            }

            this.url = input.url;
            this.credentials = input.credentials;

            if (!options.headers) {
              this.headers = new Headers(input.headers);
            }

            this.method = input.method;
            this.mode = input.mode;

            if (!body && input._bodyInit != null) {
              body = input._bodyInit;
              input.bodyUsed = true;
            }
          } else {
            this.url = String(input);
          }

          this.credentials = options.credentials || this.credentials || 'omit';

          if (options.headers || !this.headers) {
            this.headers = new Headers(options.headers);
          }

          this.method = normalizeMethod(options.method || this.method || 'GET');
          this.mode = options.mode || this.mode || null;
          this.referrer = null;

          if ((this.method === 'GET' || this.method === 'HEAD') && body) {
            throw new TypeError('Body not allowed for GET or HEAD requests');
          }

          this._initBody(body);
        }

        Request.prototype.clone = function () {
          return new Request(this, {
            body: this._bodyInit
          });
        };

        function decode(body) {
          var form = new FormData();
          body.trim().split('&').forEach(function (bytes) {
            if (bytes) {
              var split = bytes.split('=');
              var name = split.shift().replace(/\+/g, ' ');
              var value = split.join('=').replace(/\+/g, ' ');
              form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
          });
          return form;
        }

        function parseHeaders(rawHeaders) {
          var headers = new Headers(); // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
          // https://tools.ietf.org/html/rfc7230#section-3.2

          var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
          preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
            var parts = line.split(':');
            var key = parts.shift().trim();

            if (key) {
              var value = parts.join(':').trim();
              headers.append(key, value);
            }
          });
          return headers;
        }

        Body.call(Request.prototype);

        function Response(bodyInit, options) {
          if (!options) {
            options = {};
          }

          this.type = 'default';
          this.status = options.status === undefined ? 200 : options.status;
          this.ok = this.status >= 200 && this.status < 300;
          this.statusText = 'statusText' in options ? options.statusText : 'OK';
          this.headers = new Headers(options.headers);
          this.url = options.url || '';

          this._initBody(bodyInit);
        }

        Body.call(Response.prototype);

        Response.prototype.clone = function () {
          return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url
          });
        };

        Response.error = function () {
          var response = new Response(null, {
            status: 0,
            statusText: ''
          });
          response.type = 'error';
          return response;
        };

        var redirectStatuses = [301, 302, 303, 307, 308];

        Response.redirect = function (url, status) {
          if (redirectStatuses.indexOf(status) === -1) {
            throw new RangeError('Invalid status code');
          }

          return new Response(null, {
            status: status,
            headers: {
              location: url
            }
          });
        };

        self.Headers = Headers;
        self.Request = Request;
        self.Response = Response;

        self.fetch = function (input, init) {
          return new Promise(function (resolve, reject) {
            var request = new Request(input, init);
            var xhr = new XMLHttpRequest();

            xhr.onload = function () {
              var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || '')
              };
              options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
              var body = 'response' in xhr ? xhr.response : xhr.responseText;
              resolve(new Response(body, options));
            };

            xhr.onerror = function () {
              reject(new TypeError('Network request failed'));
            };

            xhr.ontimeout = function () {
              reject(new TypeError('Network request failed'));
            };

            xhr.open(request.method, request.url, true);

            if (request.credentials === 'include') {
              xhr.withCredentials = true;
            } else if (request.credentials === 'omit') {
              xhr.withCredentials = false;
            }

            if ('responseType' in xhr && support.blob) {
              xhr.responseType = 'blob';
            }

            request.headers.forEach(function (value, name) {
              xhr.setRequestHeader(name, value);
            });
            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
          });
        };

        self.fetch.polyfill = true;
      })(typeof self !== 'undefined' ? self : this);
      /***/

    },
    /* 665 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/draft-js/lib/Draft.js

      var Draft = __webpack_require__(31); // EXTERNAL MODULE: ./node_modules/immutable/dist/immutable.js


      var immutable = __webpack_require__(66); // CONCATENATED MODULE: ./node_modules/rc-editor-core/es/EditorCore/export/isUnitlessNumber.js


      var isUnitlessNumber = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridRow: true,
        gridColumn: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
      };

      function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
      }

      var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
      Object.keys(isUnitlessNumber).forEach(function (prop) {
        prefixes.forEach(function (prefix) {
          isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
      });
      /* harmony default export */

      var export_isUnitlessNumber = isUnitlessNumber; // CONCATENATED MODULE: ./node_modules/rc-editor-core/es/EditorCore/export/getHTML.js

      /* unused harmony export EMPTY_SET */

      /* unused harmony export DEFAULT_ELEMENT */

      /* unused harmony export DEFAULT_INLINE_STYLE */

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return getHTML_GetHTML;
      });

      var getHTML_extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var getHTML_EMPTY_SET = Object(immutable["OrderedSet"])();
      var getHTML_DEFAULT_ELEMENT = 'span';
      var getHTML_DEFAULT_INLINE_STYLE = Draft["DefaultDraftInlineStyle"];

      function getHTML_encodeContent(text) {
        return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join('<br >' + '\n');
      }

      function getHTML_encodeAttr(text) {
        return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
      }

      var getHTML_VENDOR_PREFIX = /^(moz|ms|o|webkit)-/;
      var getHTML_NUMERIC_STRING = /^\d+$/;
      var getHTML_UPPERCASE_PATTERN = /([A-Z])/g; // Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/CSSPropertyOperations.js

      function getHTML_processStyleName(name) {
        return name.replace(getHTML_UPPERCASE_PATTERN, '-$1').toLowerCase().replace(getHTML_VENDOR_PREFIX, '-$1-');
      } // Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/dangerousStyleValue.js


      function getHTML_processStyleValue(name, value) {
        var isNumeric = void 0;

        if (typeof value === 'string') {
          isNumeric = getHTML_NUMERIC_STRING.test(value);
        } else {
          isNumeric = true;
          value = String(value);
        }

        if (!isNumeric || value === '0' || export_isUnitlessNumber[name] === true) {
          return value;
        } else {
          return value + 'px';
        }
      }

      function getHTML_getStyleText(styleObject) {
        if (!styleObject) {
          return '';
        }

        return Object.keys(styleObject).map(function (name) {
          var styleName = getHTML_processStyleName(name);
          var styleValue = getHTML_processStyleValue(name, styleObject[name]);
          return styleName + ':' + styleValue;
        }).join(';');
      }

      function getHTML_getEntityContent(contentState, entityKey, content) {
        if (entityKey) {
          var entity = contentState.getEntity(entityKey);
          var entityData = entity.getData();

          if (entityData && entityData['export']) {
            return entityData['export'](content, entityData);
          }
        }

        return content;
      }

      function getHTML_GetHTML(configStore) {
        return function exportHtml(editorState) {
          var contentState = editorState.getCurrentContent();
          var blockMap = contentState.getBlockMap();
          var customStyleMap = configStore.get('customStyleMap') || {};
          var customBlockRenderMap = configStore.get('blockRenderMap') || {};
          var customStyleFn = configStore.get('customStyleFn');
          var toHTMLList = configStore.get('toHTMLList');
          getHTML_extends(customStyleMap, getHTML_DEFAULT_INLINE_STYLE);
          return blockMap.map(function (block) {
            var resultText = '<div>';
            var closeTag = '</div>';
            var lastPosition = 0;
            var text = block.getText();
            var blockType = block.getType();
            var blockRender = customBlockRenderMap.get(blockType);

            if (blockRender) {
              var element = typeof blockRender.element === 'function' ? blockRender.elementTag || 'div' : 'div';
              resultText = '<' + (element || 'div') + ' style="' + getHTML_getStyleText(customBlockRenderMap.get(blockType).style || {}) + '">';
              closeTag = '</' + (element || 'div') + '>';
            }

            var charMetaList = block.getCharacterList();
            var charEntity = null;
            var prevCharEntity = null;
            var ranges = [];
            var rangeStart = 0;

            for (var i = 0, len = text.length; i < len; i++) {
              prevCharEntity = charEntity;
              var meta = charMetaList.get(i);
              charEntity = meta ? meta.getEntity() : null;

              if (i > 0 && charEntity !== prevCharEntity) {
                ranges.push([prevCharEntity, getHTML_getStyleRanges(text.slice(rangeStart, i), charMetaList.slice(rangeStart, i))]);
                rangeStart = i;
              }
            }

            ranges.push([charEntity, getHTML_getStyleRanges(text.slice(rangeStart), charMetaList.slice(rangeStart))]);
            ranges.map(function (_ref) {
              var entityKey = _ref[0],
                  stylePieces = _ref[1];
              var element = getHTML_DEFAULT_ELEMENT;
              var rawContent = stylePieces.map(function (_ref2) {
                var text = _ref2[0];
                return text;
              }).join('');
              var content = stylePieces.map(function (_ref3) {
                var text = _ref3[0],
                    styleSet = _ref3[1];
                var encodedContent = getHTML_encodeContent(text);

                if (styleSet.size) {
                  var inlineStyle = {};
                  styleSet.forEach(function (item) {
                    if (customStyleMap.hasOwnProperty(item)) {
                      var currentStyle = customStyleMap[item];
                      inlineStyle = getHTML_extends(inlineStyle, currentStyle);
                    }
                  });
                  var customedStyle = customStyleFn(styleSet);
                  inlineStyle = getHTML_extends(inlineStyle, customedStyle);
                  return '<span style="' + getHTML_getStyleText(inlineStyle) + '">' + encodedContent + '</span>';
                }

                return '<span>' + encodedContent + '</span>';
              }).join('');

              if (entityKey) {
                var entity = contentState.getEntity(entityKey);
                var entityData = entity.getData();

                if (entityData && entityData['export']) {
                  resultText += entityData['export'](content, entityData);
                } else {
                  var HTMLText = '';
                  toHTMLList.forEach(function (toHTML) {
                    var text = toHTML(rawContent, entity, contentState);

                    if (text) {
                      HTMLText = text;
                    }
                  });

                  if (HTMLText) {
                    resultText += HTMLText;
                  }
                }
              } else {
                resultText += content;
              }
            });
            resultText += closeTag;
            return resultText;
          }).join('\n');
        };
      }

      function getHTML_getStyleRanges(text, charMetaList) {
        var charStyle = getHTML_EMPTY_SET;
        var prevCharStyle = getHTML_EMPTY_SET;
        var ranges = [];
        var rangeStart = 0;

        for (var i = 0, len = text.length; i < len; i++) {
          prevCharStyle = charStyle;
          var meta = charMetaList.get(i);
          charStyle = meta ? meta.getStyle() : getHTML_EMPTY_SET;

          if (i > 0 && !Object(immutable["is"])(charStyle, prevCharStyle)) {
            ranges.push([text.slice(rangeStart, i), prevCharStyle]);
            rangeStart = i;
          }
        }

        ranges.push([text.slice(rangeStart), charStyle]);
        return ranges;
      }
      /***/

    },
    /* 666 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}

      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: ./node_modules/immutable/dist/immutable.js


      var immutable = __webpack_require__(66); // CONCATENATED MODULE: ./node_modules/rc-editor-core/es/Toolbar/ToolbarLine.js


      function ToolbarLine_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ToolbarLine_possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function ToolbarLine_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ToolbarLine_ToolbarLine = function (_React$Component) {
        ToolbarLine_inherits(ToolbarLine, _React$Component);

        function ToolbarLine() {
          ToolbarLine_classCallCheck(this, ToolbarLine);
          return ToolbarLine_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        ToolbarLine.prototype.render = function render() {
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', null, this.props.children);
        };

        return ToolbarLine;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);
      /* harmony default export */


      var Toolbar_ToolbarLine = ToolbarLine_ToolbarLine; // CONCATENATED MODULE: ./node_modules/rc-editor-core/es/Toolbar/Toolbar.js

      function Toolbar_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Toolbar_possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function Toolbar_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }
      /* tslint:disable:interface-name */


      function Toolbar_noop() {}

      var Toolbar_Toolbar = function (_React$Component) {
        Toolbar_inherits(Toolbar, _React$Component);

        function Toolbar(props) {
          Toolbar_classCallCheck(this, Toolbar);

          var _this = Toolbar_possibleConstructorReturn(this, _React$Component.call(this, props));

          var map = {};
          props.plugins.forEach(function (plugin) {
            map[plugin.name] = plugin;
          });
          _this.pluginsMap = Object(immutable["Map"])(map);
          _this.state = {
            editorState: props.editorState,
            toolbars: []
          };
          return _this;
        }

        Toolbar.prototype.renderToolbarItem = function renderToolbarItem(pluginName, idx) {
          var element = this.pluginsMap.get(pluginName);

          if (element && element.component) {
            var component = element.component;
            var props = {
              key: 'toolbar-item-' + idx,
              onClick: component.props ? component.props.onClick : Toolbar_noop
            };

            if (external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.isValidElement(component)) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.cloneElement(component, props);
            }

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(component, props);
          }

          return null;
        };

        Toolbar.prototype.conpomentWillReceiveProps = function conpomentWillReceiveProps(nextProps) {
          this.render();
        };

        Toolbar.prototype.render = function render() {
          var _this2 = this;

          var _props = this.props,
              toolbars = _props.toolbars,
              prefixCls = _props.prefixCls;
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement('div', {
            className: prefixCls + '-toolbar'
          }, toolbars.map(function (toolbar, idx) {
            var children = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Children.map(toolbar, _this2.renderToolbarItem.bind(_this2));
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Toolbar_ToolbarLine, {
              key: 'toolbar-' + idx
            }, children);
          }));
        };

        return Toolbar;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.Component);
      /* harmony default export */


      var es_Toolbar_Toolbar = Toolbar_Toolbar; // CONCATENATED MODULE: ./node_modules/rc-editor-core/es/Toolbar/index.js

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return Toolbar_createToolbar;
      });

      function es_Toolbar_noop(_) {}

      ;

      function Toolbar_createToolbar() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        function editorStateChange(editorState) {// console.log('>> editorStateChange', editorState);
        }

        var callbacks = {
          onChange: editorStateChange,
          onUpArrow: es_Toolbar_noop,
          onDownArrow: es_Toolbar_noop,
          getEditorState: es_Toolbar_noop,
          setEditorState: es_Toolbar_noop,
          handleReturn: es_Toolbar_noop
        };
        return {
          name: 'toolbar',
          decorators: [],
          callbacks: callbacks,
          onChange: function onChange(editorState) {
            return callbacks.onChange ? callbacks.onChange(editorState) : editorState;
          },
          component: es_Toolbar_Toolbar
        };
      }
      /***/

    },
    /* 667 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/extends.js

      var helpers_extends = __webpack_require__(36);

      var extends_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_extends); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectSpread.js


      var objectSpread = __webpack_require__(13);

      var objectSpread_default =
      /*#__PURE__*/
      __webpack_require__.n(objectSpread); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/classCallCheck.js


      var classCallCheck = __webpack_require__(21);

      var classCallCheck_default =
      /*#__PURE__*/
      __webpack_require__.n(classCallCheck); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/createClass.js


      var createClass = __webpack_require__(20);

      var createClass_default =
      /*#__PURE__*/
      __webpack_require__.n(createClass); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js


      var possibleConstructorReturn = __webpack_require__(24);

      var possibleConstructorReturn_default =
      /*#__PURE__*/
      __webpack_require__.n(possibleConstructorReturn); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/getPrototypeOf.js


      var getPrototypeOf = __webpack_require__(23);

      var getPrototypeOf_default =
      /*#__PURE__*/
      __webpack_require__.n(getPrototypeOf); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/assertThisInitialized.js


      var assertThisInitialized = __webpack_require__(11);

      var assertThisInitialized_default =
      /*#__PURE__*/
      __webpack_require__.n(assertThisInitialized); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/inherits.js


      var inherits = __webpack_require__(22);

      var inherits_default =
      /*#__PURE__*/
      __webpack_require__.n(inherits); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js


      var defineProperty = __webpack_require__(4);

      var defineProperty_default =
      /*#__PURE__*/
      __webpack_require__.n(defineProperty); // EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}


      var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(1);

      var external_root_React_commonjs2_react_commonjs_react_amd_react_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_); // EXTERNAL MODULE: external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}


      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_ = __webpack_require__(0);

      var external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default =
      /*#__PURE__*/
      __webpack_require__.n(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_); // EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules


      var es = __webpack_require__(33); // EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js


      var isEmpty = __webpack_require__(25);

      var isEmpty_default =
      /*#__PURE__*/
      __webpack_require__.n(isEmpty); // EXTERNAL MODULE: ./node_modules/lodash/isEqual.js


      var isEqual = __webpack_require__(30);

      var isEqual_default =
      /*#__PURE__*/
      __webpack_require__.n(isEqual); // EXTERNAL MODULE: ./node_modules/lodash/keyBy.js


      var keyBy = __webpack_require__(85);

      var keyBy_default =
      /*#__PURE__*/
      __webpack_require__.n(keyBy); // EXTERNAL MODULE: ./node_modules/react-apollo/react-apollo.browser.umd.js


      var react_apollo_browser_umd = __webpack_require__(58); // EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js


      var cloneDeep = __webpack_require__(68);

      var cloneDeep_default =
      /*#__PURE__*/
      __webpack_require__.n(cloneDeep); // EXTERNAL MODULE: ./node_modules/lodash/noop.js


      var noop = __webpack_require__(9);

      var noop_default =
      /*#__PURE__*/
      __webpack_require__.n(noop); // EXTERNAL MODULE: ./node_modules/lodash/get.js


      var get = __webpack_require__(10);

      var get_default =
      /*#__PURE__*/
      __webpack_require__.n(get); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/slicedToArray.js


      var slicedToArray = __webpack_require__(100);

      var slicedToArray_default =
      /*#__PURE__*/
      __webpack_require__.n(slicedToArray); // EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js


      var Recompose = __webpack_require__(26); // EXTERNAL MODULE: ./node_modules/lodash/pick.js


      var pick = __webpack_require__(224);

      var pick_default =
      /*#__PURE__*/
      __webpack_require__.n(pick); // EXTERNAL MODULE: ./node_modules/lodash/parseInt.js


      var lodash_parseInt = __webpack_require__(692);

      var parseInt_default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_parseInt); // EXTERNAL MODULE: ./node_modules/classnames/index.js


      var classnames = __webpack_require__(3);

      var classnames_default =
      /*#__PURE__*/
      __webpack_require__.n(classnames); // EXTERNAL MODULE: ./node_modules/antd/lib/modal/index.js


      var modal = __webpack_require__(283);

      var modal_default =
      /*#__PURE__*/
      __webpack_require__.n(modal); // EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js


      var modules = __webpack_require__(143); // EXTERNAL MODULE: ./src/components/ErrorMessage.js


      var ErrorMessage = __webpack_require__(120); // EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js


      var regenerator = __webpack_require__(76);

      var regenerator_default =
      /*#__PURE__*/
      __webpack_require__.n(regenerator); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/asyncToGenerator.js


      var asyncToGenerator = __webpack_require__(104);

      var asyncToGenerator_default =
      /*#__PURE__*/
      __webpack_require__.n(asyncToGenerator); // EXTERNAL MODULE: ./src/core/hoc/withOverride.js


      var withOverride = __webpack_require__(83); // EXTERNAL MODULE: ./src/core/hoc/withVisibility.js


      var withVisibility = __webpack_require__(77); // EXTERNAL MODULE: ./src/containers/FieldContainer/FieldContainer.js


      var FieldContainer = __webpack_require__(223); // CONCATENATED MODULE: ./src/core/utils/error.js


      var getErrorFromFormErrors = function getErrorFromFormErrors(id, errorType, formErrors) {
        var hasAnError = Object.keys(formErrors).includes(id);

        var getPropertyFromPageError = function getPropertyFromPageError(property) {
          if (hasAnError && errorType === formErrors[id].type) {
            return formErrors[id][property];
          }

          return '';
        };

        return {
          position: getPropertyFromPageError('position'),
          errorMessage: getPropertyFromPageError('errorMessage'),
          errorTitle: getPropertyFromPageError('errorTitle')
        };
      }; // CONCATENATED MODULE: ./src/containers/SectionContainer.js


      var SectionContainer_SectionContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(SectionContainer, _Component);

        function SectionContainer(props) {
          var _this;

          classCallCheck_default()(this, SectionContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(SectionContainer).call(this, props));
          var section = props.sectionsById[props.id];
          var page = props.pagesById[props.pageId] || {
            sections: []
          };
          page.sections.some(function (pageSection) {
            var foundSection = pageSection.id === props.id;
            return foundSection;
          }, {});
          _this.state = {
            section: section // attributes: {
            //   ...section.attributes,
            //   ...overrideAttributes,
            // },

          };
          return _this;
        }

        createClass_default()(SectionContainer, [{
          key: "render",
          value: function render() {
            var _this2 = this;

            var sectionClass = get_default()(this.state.section, 'attributes.class');
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              id: "formatic-section-container-".concat(this.props.id),
              className: classnames_default()('formatic-section-container', defineProperty_default()({}, sectionClass, sectionClass), defineProperty_default()({}, this.props.className, this.props.className))
            }, get_default()(this.state, 'section.fields', []).map(function (field, index) {
              var fieldError = getErrorFromFormErrors(field.id, 'field', _this2.props.formErrors);
              var fieldData = _this2.props.fieldsById[field.id];
              return [fieldError.position === 'top' ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ErrorMessage["a"
              /* default */
              ], {
                text: fieldError.errorMessage
              }) : null, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(FieldContainer["a"
              /* default */
              ], extends_default()({
                key: index,
                sectionId: _this2.props.id,
                data: _this2.props.data,
                dataLoading: _this2.props.dataLoading
              }, fieldData)), fieldError.position === 'bottom' ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ErrorMessage["a"
              /* default */
              ], {
                text: fieldError.errorMessage
              }) : null];
            }));
          }
        }]);
        return SectionContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      SectionContainer_SectionContainer.defaultProps = {
        className: null,
        id: '',
        pageId: '',
        data: {},
        dataLoading: false,
        formErrors: {}
      };
      SectionContainer_SectionContainer.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        dataLoading: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        fieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        formErrors: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        pageId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        pagesById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        sectionsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired
      };

      var SectionContainer_mapStateToProps = function mapStateToProps(_ref) {
        var _ref$formatic$data$fo = _ref.formatic.data.form,
            fieldsById = _ref$formatic$data$fo.fieldsById,
            pagesById = _ref$formatic$data$fo.pagesById,
            sectionsById = _ref$formatic$data$fo.sectionsById;
        return {
          fieldsById: fieldsById,
          pagesById: pagesById,
          sectionsById: sectionsById
        };
      };
      /* harmony default export */


      var containers_SectionContainer = Object(Recompose["a"
      /* compose */
      ])(Object(es["a"
      /* connect */
      ])(SectionContainer_mapStateToProps), Object(withVisibility["a"
      /* default */
      ])({
        type: 'section'
      }), Object(withOverride["a"
      /* default */
      ])({
        overrideType: 'sections'
      }))(SectionContainer_SectionContainer); // EXTERNAL MODULE: ./src/core/utils/constants.js

      var constants = __webpack_require__(27); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/toConsumableArray.js


      var toConsumableArray = __webpack_require__(40);

      var toConsumableArray_default =
      /*#__PURE__*/
      __webpack_require__.n(toConsumableArray); // EXTERNAL MODULE: ./src/core/utils/populate.js + 1 modules


      var populate = __webpack_require__(184); // CONCATENATED MODULE: ./src/containers/PageContainer/PageContainerHelper.js


      var PageContainerHelper_this = undefined;
      /**
       * Get default values for all fields to be rendered on the page.
       * Needed to determine whether or not any values need to be set prior to render.
       */

      var PageContainerHelper_getPageFieldDefaultValues = function getPageFieldDefaultValues(props) {
        return props.pagesById[props.id].sections.reduce(function (accum, _ref) {
          var sectionId = _ref.id;
          var section = props.sectionsById[sectionId];
          var defaults = section && section.fields ? section.fields.reduce(function (fieldDefaults, _ref2) {
            var fieldId = _ref2.id,
                overrideAttributes = _ref2.overrideAttributes;
            var field = props.myFieldsById[fieldId];

            if (field === undefined) {
              // Fields inside repeatables will return undefined
              return fieldDefaults;
            }

            var attributes = objectSpread_default()({}, overrideAttributes, field.attributes);
            var defaultPopulates = {};

            if (attributes.default) {
              fieldDefaults[fieldId] = attributes.default;
              defaultPopulates = Object(populate["a"
              /* getFieldsToBePopulated */
              ])(props, field, attributes.default);
            }

            return objectSpread_default()({}, fieldDefaults, defaultPopulates);
          }, {}) : {};

          if (Object.keys(defaults).length > 0) {
            return objectSpread_default()({}, accum, defaults);
          }

          return accum;
        }, {});
      };
      /**
       * Get fields that need to be updated before render.
       * This is generally fields that have a default value that need to be set
       * before the page is initially rendered.
       */


      var PageContainerHelper_getFieldsToUpdate = function getFieldsToUpdate() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PageContainerHelper_this.props;
        var pageFieldDefaults = PageContainerHelper_getPageFieldDefaultValues(props);
        return Object.keys(pageFieldDefaults).reduce(function (accum, fieldId) {
          var value = pageFieldDefaults[fieldId];
          var currentValue = props.mySubmissionFieldsById[fieldId];

          if (!currentValue) {
            // Value not yet initialized
            return [].concat(toConsumableArray_default()(accum), [{
              id: fieldId,
              value: value
            }]);
          }

          return accum;
        }, []);
      }; // CONCATENATED MODULE: ./src/containers/PageContainer/index.js


      var PageContainer_PageContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(PageContainer, _Component);

        function PageContainer(props) {
          var _this;

          classCallCheck_default()(this, PageContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(PageContainer).call(this, props));
          var page = props.pagesById[props.id]; // Update local fields if required

          _this.fieldsToUpdate = PageContainerHelper_getFieldsToUpdate(props);
          _this.state = {
            page: page
          };
          return _this;
        }

        createClass_default()(PageContainer, [{
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate(nextProps) {
            return !isEqual_default()(this.props.mySubmissionFieldsById, nextProps.mySubmissionFieldsById);
          }
        }, {
          key: "componentWillMount",
          value: function () {
            var _componentWillMount = asyncToGenerator_default()(
            /*#__PURE__*/
            regenerator_default.a.mark(function _callee() {
              return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!(this.fieldsToUpdate.length > 0)) {
                        _context.next = 3;
                        break;
                      }

                      _context.next = 3;
                      return this.props.updateSubmissionField({
                        fields: this.fieldsToUpdate
                      });

                    case 3:
                      this.props.emitter.emit(constants["Events"].BeforePageRender, {
                        id: this.props.id
                      });

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

            function componentWillMount() {
              return _componentWillMount.apply(this, arguments);
            }

            return componentWillMount;
          }()
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            this.props.emitter.emit(constants["Events"].PageRender, {
              id: this.props.id
            });
            this.props.onInit(this.props.id);
          }
        }, {
          key: "render",
          value: function render() {
            var _this2 = this;

            var pageClass = get_default()(this.state.page, 'attributes.class');
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              id: "formatic-page-container-".concat(this.props.id),
              className: classnames_default()('formatic-page-container', defineProperty_default()({}, this.props.className, this.props.className), defineProperty_default()({}, pageClass, pageClass)),
              "data-page-id": this.props.id,
              name: this.props.id
            }, get_default()(this.state, 'page.sections', []).map(function (section) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_SectionContainer, {
                key: section.id,
                id: section.id,
                pageId: _this2.props.id,
                data: _this2.props.data,
                dataLoading: _this2.props.dataLoading,
                formErrors: _this2.props.formErrors
              });
            }));
          }
        }]);
        return PageContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      PageContainer_PageContainer.defaultProps = {
        className: '',
        id: '',
        onInit: noop_default.a,
        data: {},
        dataLoading: false,
        emitter: {},
        formErrors: {},
        updateSubmissionField: noop_default.a,
        tokens: {}
      };
      PageContainer_PageContainer.propTypes = {
        className: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        dataLoading: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        emitter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        myFieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        formErrors: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        onInit: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        pagesById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        sectionsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        updateSubmissionField: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        mySubmissionFieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired,
        tokens: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };
      /* harmony default export */

      var containers_PageContainer = Object(Recompose["a"
      /* compose */
      ])(Object(withVisibility["a"
      /* default */
      ])({
        type: 'page'
      }), Object(withOverride["a"
      /* default */
      ])({
        overrideType: 'pages'
      }), Object(es["a"
      /* connect */
      ])(function (_ref) {
        var _ref$formatic = _ref.formatic,
            _ref$formatic$data = _ref$formatic.data,
            _ref$formatic$data$fo = _ref$formatic$data.form,
            myFieldsById = _ref$formatic$data$fo.fieldsById,
            pagesById = _ref$formatic$data$fo.pagesById,
            sectionsById = _ref$formatic$data$fo.sectionsById,
            mySubmissionFieldsById = _ref$formatic$data.submission.fieldsById,
            emitter = _ref$formatic.emitter,
            tokens = _ref$formatic.tokens;
        return {
          emitter: emitter,
          myFieldsById: myFieldsById,
          pagesById: pagesById,
          sectionsById: sectionsById,
          mySubmissionFieldsById: mySubmissionFieldsById,
          tokens: tokens
        };
      }), Object(Recompose["b"
      /* getContext */
      ])({
        updateSubmissionField: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      }))(PageContainer_PageContainer); // CONCATENATED MODULE: ./src/components/Form.js

      var Form_handleOnSubmit = function handleOnSubmit(e) {
        e.preventDefault();
      };

      var Form_Form = function Form(props) {
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("form", {
          autoComplete: props.autoComplete,
          className: "formatic-form formatic-form-".concat(props.formId),
          id: props.formId,
          onSubmit: Form_handleOnSubmit
        }, props.children);
      };

      Form_Form.defaultProps = {
        autoComplete: 'on',
        children: [],
        formId: null
      };
      Form_Form.propTypes = {
        autoComplete: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        formId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number
      };
      /* harmony default export */

      var components_Form = Form_Form; // EXTERNAL MODULE: ./src/config/index.js

      var src_config = __webpack_require__(28); // EXTERNAL MODULE: ./src/core/utils/navigation.js


      var navigation = __webpack_require__(50); // EXTERNAL MODULE: ./src/core/RootComponents/helpers/pageFlow.js


      var helpers_pageFlow = __webpack_require__(54); // EXTERNAL MODULE: ./src/config/behaviorDefaults.js


      var behaviorDefaults = __webpack_require__(169); // CONCATENATED MODULE: ./src/containers/FormContainer.js


      var FormContainer_FormContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(FormContainer, _Component);

        function FormContainer() {
          var _getPrototypeOf2;

          var _this;

          classCallCheck_default()(this, FormContainer);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(FormContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
          defineProperty_default()(assertThisInitialized_default()(_this), "onPageInit", function (pageId) {
            var multiPage = _this.props.formBehaviours.multiPage;

            if (multiPage) {
              _this.scrollToPage(pageId);
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "scrollToPage", function (pageId) {
            var _this$props$formBehav = _this.props.formBehaviours,
                scrollOnNextPage = _this$props$formBehav.scrollOnNextPage,
                scrollAnimation = _this$props$formBehav.scrollAnimation,
                scrollDuration = _this$props$formBehav.scrollDuration,
                scrollOffsetPage = _this$props$formBehav.scrollOffsetPage,
                scrollDelayPage = _this$props$formBehav.scrollDelayPage;

            if (scrollOnNextPage) {
              modules["scroller"].scrollTo(pageId, {
                duration: scrollDuration,
                delay: scrollDelayPage,
                smooth: scrollAnimation,
                offset: scrollOffsetPage
              });
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getCurrentPageId", function () {
            return get_default()(_this.props.currentPage, "[".concat(_this.props.channel, "].pageId"));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getFromPageId", function (currentPageIndex) {
            var fromPageId;

            if (_this.props.navigateDirection === navigation["a"
            /* NavigationDirection */
            ].Prev || _this.props.navigateDirection === navigation["a"
            /* NavigationDirection */
            ].NewFlow) {
              // from page is the next page
              fromPageId = _this.props.pageFlow[currentPageIndex + 1];
            } else if (_this.props.navigateDirection === navigation["a"
            /* NavigationDirection */
            ].Next) {
              // from page is the previous page
              fromPageId = _this.props.pageFlow[currentPageIndex - 1];
            }

            return fromPageId;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "isNavigating", function () {
            return _this.props.navigateDirection === navigation["a"
            /* NavigationDirection */
            ].Next || _this.props.navigateDirection === navigation["a"
            /* NavigationDirection */
            ].Prev;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "isMultiPageForm", function () {
            // in order to correct get multiPage value this undefined check is required,
            // since multiPage is a boolean value and, therefore, it can be false
            return _this.props.data.Form.attributes.multiPage !== undefined ? _this.props.data.Form.attributes.multiPage : src_config["a"
            /* default */
            ].defaultMultiPage;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "shouldPagesTransition", function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            return _this.isMultiPageForm() && (props.data.Form.attributes.shouldPagesTransition || true);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getPageFlow", function () {
            var _this$props = _this.props,
                currentFlow = _this$props.flow.current,
                pageFlow = _this$props.pageFlow;

            var currentPageId = _this.getCurrentPageId();

            if (!currentPageId) {
              // No ID
              return [];
            }

            if (!Array.isArray(pageFlow[currentFlow])) {
              // Doesn't exist or not yet initialized
              return [];
            }

            if (!pageFlow[currentFlow].includes(currentPageId)) {
              // If the current page is not in the page flow, it's a dangling page - just render it
              return [currentPageId];
            }

            return pageFlow[currentFlow];
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getVisiblePages", function () {
            var _this$props2 = _this.props,
                currentFlow = _this$props2.flow.current,
                pageFlow = _this$props2.pageFlow;

            var currentPageId = _this.getCurrentPageId();

            var multiPage = _this.isMultiPageForm();

            if (!Array.isArray(pageFlow[currentFlow])) {
              // Doesn't exist or not yet initialized
              return [];
            }

            if (!pageFlow[currentFlow].includes(currentPageId)) {
              // If the current page is not in the page flow, it's a dangling page - just render it
              return [currentPageId];
            }

            var currentPage = _this.props.data.Form.pages.find(function (page) {
              return page.id === currentPageId;
            });

            var currentPageIndex;
            var visiblePages = pageFlow[currentFlow].filter(function (pageId, i) {
              currentPageIndex = pageId === currentPageId ? i : currentPageIndex;

              if (get_default()(currentPage, 'attributes.isCompletionPage', false)) {
                return pageId === currentPageId;
              } else if (multiPage) {
                return pageId === currentPageId;
              }

              return i <= pageFlow[currentFlow].indexOf(currentPageId);
            });
            return visiblePages;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getPageContainerClassName", function (pageId) {
            if (!_this.shouldPagesTransition()) {
              return '';
            }

            var isNavigating = _this.isNavigating();

            var currentPageId = _this.getCurrentPageId();

            var positionClass = 'formatic-page-transition--next-page';

            if (_this.props.navigateDirection === navigation["a"
            /* NavigationDirection */
            ].Prev) {
              positionClass = 'formatic-page-transition--previous-page';
            }

            return classnames_default()(defineProperty_default()({}, "formatic-page-transition ".concat(positionClass), isNavigating && currentPageId === pageId));
          });
          return _this;
        }

        createClass_default()(FormContainer, [{
          key: "componentWillMount",
          value: function componentWillMount() {
            var _this$props3 = this.props,
                tokens = _this$props3.tokens,
                data = _this$props3.data,
                flow = _this$props3.flow,
                emitter = _this$props3.emitter;

            if (emitter.emit) {
              emitter.emit(constants["Events"].BeforeFormRender, {
                values: tokens.fields || {},
                details: objectSpread_default()({}, data.variables, {
                  flow: flow.current
                })
              });
            }
          }
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            var _this$props4 = this.props,
                tokens = _this$props4.tokens,
                data = _this$props4.data,
                flow = _this$props4.flow,
                emitter = _this$props4.emitter;

            if (emitter.emit) {
              emitter.emit(constants["Events"].FormRender, {
                values: tokens.fields || {},
                details: objectSpread_default()({}, data.variables, {
                  flow: flow.current
                })
              });
            }
          }
          /**
           * When current page changes, scrolls to the new page
           *
           * note: the current page depends on the channel.
           */

        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(prevProps) {
            var multiPage = this.props.formBehaviours.multiPage;
            var currentPage = this.props.currentPage[this.props.channel];
            var prevPage = prevProps.currentPage ? prevProps.currentPage[prevProps.channel] : false;

            if (!multiPage && prevPage && prevPage !== currentPage) {
              this.scrollToPage(currentPage.pageId);
            }
          }
        }, {
          key: "render",
          value: function render() {
            var _this2 = this;

            var visiblePages = this.getVisiblePages();
            var renderedPages = [];
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(components_Form, {
              autoComplete: this.props.formBehaviours.allowAutoComplete || behaviorDefaults["a"
              /* default */
              ].AutoComplete,
              className: "formatic-form-container",
              formId: parseInt_default()(this.props.data.Form.id)
            }, this.getPageFlow().map(function (pageId) {
              if (!renderedPages.includes(pageId) && visiblePages.includes(pageId)) {
                var pageError = getErrorFromFormErrors(pageId, 'page', _this2.props.formErrors);
                var modalPageError = getErrorFromFormErrors(pageId, 'modal', _this2.props.formErrors);

                if (modalPageError.errorMessage && !_this2.modalIsShowing) {
                  _this2.modalIsShowing = true;
                  modal_default.a.error({
                    title: modalPageError.errorTitle || 'Error',
                    content: modalPageError.errorMessage,
                    onOk: function onOk() {
                      _this2.modalIsShowing = false;
                    }
                  });
                }

                renderedPages.push(pageId);
                return [pageError.position === 'top' ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ErrorMessage["a"
                /* default */
                ], {
                  text: pageError.errorMessage
                }) : null, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_PageContainer, {
                  className: _this2.getPageContainerClassName(pageId),
                  key: pageId,
                  id: pageId,
                  data: _this2.props.data,
                  dataLoading: _this2.props.dataLoading,
                  formErrors: _this2.props.formErrors,
                  onInit: _this2.onPageInit
                }), pageError.position === 'bottom' ? external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ErrorMessage["a"
                /* default */
                ], {
                  text: pageError.errorMessage
                }) : null];
              }

              return null;
            }));
          }
        }]);
        return FormContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      FormContainer_FormContainer.defaultProps = {
        analyticsParams: {},
        channel: '',
        currentPage: {},
        data: {},
        dataLoading: false,
        formBehaviours: {},
        formErrors: {},
        emitter: {},
        navigateDirection: null,
        pageFlow: helpers_pageFlow["a"
        /* Constants */
        ].DefaultPageFlow,
        sendAnalytics: noop_default.a,
        visibleFields: {},
        tokens: {}
      };
      FormContainer_FormContainer.propTypes = {
        analyticsParams: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        dataLoading: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        navigateDirection: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        sendAnalytics: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        emitter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // connected from formatic redux
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        currentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        flow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          current: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
          flows: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired
        }).isRequired,
        formBehaviours: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          allowAutoComplete: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          scrollOnNextPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
          scrollAnimation: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
          scrollDuration: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          scrollOffsetPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          scrollDelayPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
          multiPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool
        }),
        formErrors: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        pageFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        visibleFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        tokens: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };

      var FormContainer_mapStateToProps = function mapStateToProps(_ref) {
        var _ref$formatic = _ref.formatic,
            channel = _ref$formatic.channel,
            currentPage = _ref$formatic.currentPage,
            formErrors = _ref$formatic.data.submission.attributesById.formErrors,
            emitter = _ref$formatic.emitter,
            flow = _ref$formatic.flow,
            pageFlow = _ref$formatic.pageFlow,
            visibleFields = _ref$formatic.visibleFields,
            attributes = _ref$formatic.dataForm.attributes,
            tokens = _ref$formatic.tokens;
        return {
          channel: channel,
          currentPage: currentPage,
          emitter: emitter,
          flow: flow,
          formErrors: formErrors,
          pageFlow: pageFlow,
          visibleFields: visibleFields,
          formBehaviours: attributes,
          tokens: tokens
        };
      };
      /* harmony default export */


      var containers_FormContainer = Object(es["a"
      /* connect */
      ])(FormContainer_mapStateToProps)(FormContainer_FormContainer); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js

      var helpers_typeof = __webpack_require__(39);

      var typeof_default =
      /*#__PURE__*/
      __webpack_require__.n(helpers_typeof); // EXTERNAL MODULE: ./node_modules/lodash/invert.js


      var invert = __webpack_require__(218);

      var invert_default =
      /*#__PURE__*/
      __webpack_require__.n(invert); // EXTERNAL MODULE: ./node_modules/lodash/uniq.js


      var uniq = __webpack_require__(263);

      var uniq_default =
      /*#__PURE__*/
      __webpack_require__.n(uniq); // EXTERNAL MODULE: ./node_modules/lodash/debounce.js


      var debounce = __webpack_require__(35);

      var debounce_default =
      /*#__PURE__*/
      __webpack_require__.n(debounce); // EXTERNAL MODULE: ./node_modules/lodash/reduce.js


      var reduce = __webpack_require__(669);

      var reduce_default =
      /*#__PURE__*/
      __webpack_require__.n(reduce); // EXTERNAL MODULE: ./src/core/utils/checkLogic.js


      var checkLogic = __webpack_require__(99); // EXTERNAL MODULE: ./src/core/calculations/index.js


      var core_calculations = __webpack_require__(106); // EXTERNAL MODULE: ./src/core/utils/tokens/tokens.js + 4 modules


      var tokens_tokens = __webpack_require__(61); // CONCATENATED MODULE: ./src/core/calculations/tokens.js


      var tokens_DEFAULT_TOKEN_VALUE = '';
      /**
       * Allows setSubmission values to use {{calculations}} tokens, supported formats are
       * - {{calculations.machineTag.rawValue}}
       * - {{calculations.machineTag.maskedValue}}
       * - {{calculations.machineTag}}
       * - {{calculations.machineTag.1}} // Matrix result
       * - {{calculations.machineTag.0.1}} // Matrix multidimensional result
       * - {{calculations.machineTag.0.1.rawValue}} // Matrix result rawValue only
       * @param {*} token
       */

      var tokens_getLocalTokenValue = function getLocalTokenValue(token, calculationResultsByTag) {
        var tokenPieces = Object(tokens_tokens["c"
        /* removeTokensBrackets */
        ])(token).split('.');
        var tokenPiecesLength = tokenPieces.length;
        var value = tokens_DEFAULT_TOKEN_VALUE; // The object should match the maskedInput value format, so {{calculations.machineTag}} could be used to
        // set a completed inputMask field value

        if (tokenPiecesLength > 0 && tokenPieces[0] === 'calculations') {
          tokenPieces.shift();
          value = get_default()(calculationResultsByTag, tokenPieces.join('.'), tokens_DEFAULT_TOKEN_VALUE);
        }

        return value;
      }; // EXTERNAL MODULE: ./src/core/utils/handlebars.js


      var handlebars = __webpack_require__(166); // CONCATENATED MODULE: ./src/core/calculations/constants.js


      var LOOKUP_DELIM = '@'; // CONCATENATED MODULE: ./src/core/calculations/compile.js

      /**
       * Compile a calculation through handlebars, with form values and optional lookup values
       * @param {String} calculation
       * @param {Object} values
       * @param {Object} lookupValues
       */

      var compile_compileCalculationTemplate = function compileCalculationTemplate(calculation) {
        var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var lookupValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}; // Wrap any substitutions with LOOKUP_DELIM -- this way we can drop in our lookup values before parsing

        calculation = calculation.replace(new RegExp('{{', 'g'), "".concat(LOOKUP_DELIM, "{{"));
        calculation = calculation.replace(new RegExp('}}', 'g'), "}}".concat(LOOKUP_DELIM)); // Run through handlebars

        calculation = handlebars["a"
        /* default */
        ].compile(calculation)({
          values: values
        }); // Sub in lookup values using LOOKUP_DELIM delim

        Object.keys(lookupValues).forEach(function (key) {
          var keyEscaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          calculation = calculation.replace(new RegExp("".concat(LOOKUP_DELIM).concat(keyEscaped).concat(LOOKUP_DELIM), 'g'), String(lookupValues[key]));
        }); // Break calculation up into multi lines with ; for better math.js parsing
        // Extra steps to trim newline chars as this can affect the parser as well.
        // Remove redundant lines

        calculation = calculation.split('\n').map(function (line) {
          return line.trim();
        }).filter(function (line) {
          // Strip out delims per line, as we might have empty remnants from repeatable containers
          var filteredLine = line.replace(new RegExp(LOOKUP_DELIM, 'g'), '');
          return filteredLine.trim() !== '';
        }).join(';\n'); // Special case, while default values in repeatables are not being sent, sub in 0 for missing values to
        // attempt to not break the calculation
        // I.e we might be left with something like a = a + (b * @@), so try to convert to a = (b * 0)
        // This way will likely ignore that row in the repeatable (since should eval to 0, depending on how calc set up)
        // Should remove this once default values in repeatables are fixed

        calculation = calculation.replace(new RegExp("".concat(LOOKUP_DELIM).concat(LOOKUP_DELIM), 'g'), 0); // Remove all LOOKUP_DELIM to clean up calc

        calculation = calculation.replace(new RegExp(LOOKUP_DELIM, 'g'), '');
        return calculation;
      }; // EXTERNAL MODULE: ./src/core/calculations/mathJsBuild.js


      var mathJsBuild = __webpack_require__(219); // CONCATENATED MODULE: ./src/core/calculations/calculate.js


      var calculate_RESULT_TYPE_NUMBER = 'number';
      var calculate_RESULT_TYPE_MATRIX = 'matrix';
      var calculate_ALLOWED_RESULT_TYPES = [calculate_RESULT_TYPE_NUMBER, calculate_RESULT_TYPE_MATRIX];
      /**
       * Perform a math.js calculation, or return a defaultValue on failure
       * @param {string} formula
       * @param {Number} defaultValue
       */

      var calculate_calculate = function calculate(formula, defaultValue) {
        var math = Object(mathJsBuild["a"
        /* getMathJsBuild */
        ])();
        var calculateResult;

        try {
          var mathResult = Object(mathJsBuild["a"
          /* getMathJsBuild */
          ])().eval(formula); // Math.js can either provide a result as a number or an array,
          // depending on the type of calculation it has parsed

          if (typeof mathResult === 'number') {
            calculateResult = mathResult;
          } else {
            calculateResult = mathResult.entries.pop();
          }

          var resultType = math.typeof(calculateResult).toLowerCase();

          if (calculate_ALLOWED_RESULT_TYPES.indexOf(resultType) < 0) {
            throw new Error("Result type ".concat(resultType, " not supported. Allowed: ").concat(calculate_ALLOWED_RESULT_TYPES.join(', ')));
          } // If matrix, simplify to array


          if (resultType === calculate_RESULT_TYPE_MATRIX) {
            calculateResult = calculateResult.toArray();
          }
        } catch (err) {
          if (!Object(core_calculations["f"
          /* isValidNumber */
          ])(defaultValue)) {
            throw new Error('defaultValue is not a valid number');
          }

          calculateResult = Number(defaultValue);
        }

        return calculateResult;
      }; // EXTERNAL MODULE: ./src/core/utils/actions/index.js + 4 modules


      var actions = __webpack_require__(69); // EXTERNAL MODULE: ./src/core/utils/data/helpers.js


      var helpers = __webpack_require__(91); // CONCATENATED MODULE: ./src/containers/CalculatedFieldsContainer.js
      // import debug from '../core/utils/debug';


      var CalculatedFieldsContainer_CalculatedFieldsContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(CalculatedFieldsContainer, _Component);

        function CalculatedFieldsContainer(props) {
          var _this;

          classCallCheck_default()(this, CalculatedFieldsContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(CalculatedFieldsContainer).call(this, props));
          _this.state = {
            initialised: false,
            currentValues: {},
            currentValuesTimestamps: {},
            changedFieldIds: {},
            usedFieldTagToIdMap: {},
            usedFieldIdToTagMap: {},
            calculations: {},
            calculationDebounces: {},
            calculationResultsByTag: {},
            formFieldTagCalculationMap: {},
            repeatableFieldTags: [],
            hasRepeatableCalculations: false
          };
          return _this;
        }

        createClass_default()(CalculatedFieldsContainer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            if (!this.state.initialised) {
              this.initialiseCalculations();
            }
          }
          /**
           * Determine tokens used in calculations
           * Ensure these tokens exist in the form schema
           * Prepeare a mapping of fieldTag => fieldId for quicker substituion
           */

        }, {
          key: "initialiseCalculations",
          value: function initialiseCalculations() {
            var _this2 = this;

            var calculations = {};
            var usedFieldTagToIdMap = {};
            var calculationFormFields = [];
            var formFieldTagCalculationMap = {};
            var currentValues = {};
            var calculationDebounces = {};
            var calculationResultsByTag = {};
            var repeatableFieldTags = [];
            var repeatableFieldTagsToCheck = [];
            var haveFormFieldsById = !isEmpty_default()(this.props.formFieldsById);
            var hasRepeatableCalculations = false; // Pull out tags used in calcs
            // Build map of fieldIds to calculations

            var _loop = function _loop(i) {
              var calculation = objectSpread_default()({}, _this2.props.calculations[i]); // Decode json attributes

              ['lookupValues', 'setSubmissionValues'].forEach(function (attribute) {
                try {
                  calculation[attribute] = JSON.parse(calculation[attribute]) || {};
                } catch (error) {
                  calculation[attribute] = {};
                }
              });
              var tokenMatches = Object(tokens_tokens["b"
              /* getTokensMatches */
              ])(calculation.calculation); // Prefill state with default values

              calculationResultsByTag[calculation.tag] = Object(core_calculations["a"
              /* getCalculationValueObject */
              ])(parseFloat(calculation.defaultValue), calculation.defaultValue, calculation.numeralDecimalMark, calculation.numeralDecimalScale, calculation.numeralThousandsGroupStyle, true); // Set up debounces for running calcs, each calc can have it's own debounce timeout

              calculationDebounces[calculation.id] = debounce_default()(function () {
                return _this2.performCalculation(calculation.id);
              }, calculation.debounce);
              var numTokenMatches = Array.isArray(tokenMatches) ? tokenMatches.length : 0; // Build array of { fieldTag : machineTag, repeatableCheck : bool }

              var calculationFieldTags = []; // Extract the tokens / machineTags from the calculation

              for (var _y = 0; _y < numTokenMatches; _y += 1) {
                var tokenPieces = Object(tokens_tokens["c"
                /* removeTokensBrackets */
                ])(tokenMatches[_y]).split('.'); // We are expecting tokens like these:
                // {{values.fieldOne}}
                // {{values.fieldOne.rawValue}} - field with an object value
                // {{#values.repeatableField}}

                if (tokenPieces.length > 1 && tokenPieces[0].includes('values')) {
                  // If field has # in its handlebars template it may be a repeatable
                  // So we should try and map any sub field id <=> tags as well
                  calculationFieldTags.push({
                    fieldTag: tokenPieces[1],
                    repeatableCheck: tokenPieces[0].includes('#values')
                  });
                }
              } // Extract the fieldIds from the disable logic. Find the machine tag and push into mapping so can be handled below


              var disableLogicFieldIds = Object(core_calculations["c"
              /* getUniqueFieldIdsFromLogicString */
              ])(calculation.disableConditions);
              var numDisableLogicFieldIds = disableLogicFieldIds.length;

              if (haveFormFieldsById) {
                for (var _y2 = 0; _y2 < numDisableLogicFieldIds; _y2 += 1) {
                  var formFieldById = _this2.props.formFieldsById[disableLogicFieldIds[_y2]];

                  if (formFieldById && formFieldById.attributes.tag) {
                    var fieldTag = formFieldById.attributes.tag;
                    calculationFieldTags.push({
                      fieldTag: fieldTag,
                      repeatableCheck: formFieldById.renderer === 'repeatable'
                    });
                  }
                }
              }

              var numCalculationFieldTags = calculationFieldTags.length;

              for (var _y3 = 0; _y3 < numCalculationFieldTags; _y3 += 1) {
                if (calculationFormFields.indexOf(calculationFieldTags[_y3].fieldTag) < 0) {
                  calculationFormFields.push(calculationFieldTags[_y3].fieldTag);
                }

                if (formFieldTagCalculationMap[calculationFieldTags[_y3].fieldTag] === undefined) {
                  formFieldTagCalculationMap[calculationFieldTags[_y3].fieldTag] = [];
                }

                if (formFieldTagCalculationMap[calculationFieldTags[_y3].fieldTag].indexOf(calculation.id) < 0) {
                  formFieldTagCalculationMap[calculationFieldTags[_y3].fieldTag].push(calculation.id);
                }

                if (calculationFieldTags[_y3].repeatableCheck) {
                  repeatableFieldTagsToCheck.push(calculationFieldTags[_y3].fieldTag);
                }
              }

              calculations[calculation.id] = calculation; // Add flags for disable logic and decode condition

              calculations[calculation.id].hasDisableConditions = calculations[calculation.id].disableConditions.length > 0;

              if (calculations[calculation.id].hasDisableConditions) {
                calculations[calculation.id].disableConditions = JSON.parse(calculations[calculation.id].disableConditions);
              }
            };

            for (var i = 0; i < this.props.calculations.length; i += 1) {
              _loop(i);
            }

            var numFieldsToMap = calculationFormFields.length;

            if (haveFormFieldsById && numFieldsToMap > 0) {
              var formFieldsById = Object.keys(this.props.formFieldsById);
              var numFormFieldsById = formFieldsById.length;

              for (var i = 0; i < numFormFieldsById; i += 1) {
                if (numFieldsToMap === 0) {
                  break;
                }

                var fieldId = formFieldsById[i];
                var field = this.props.formFieldsById[fieldId];
                var fieldTagIndex = calculationFormFields.indexOf(field.attributes.tag);

                if (fieldTagIndex >= 0) {
                  usedFieldTagToIdMap[field.attributes.tag] = fieldId;
                  currentValues[fieldId] = null;
                  numFieldsToMap -= 1; // If this field was marked as a repeatable, grab the inner fields from attributes as well
                  // As we need to build the nested object for handlebars parsing

                  if (field.renderer === 'repeatable' && repeatableFieldTagsToCheck.indexOf(field.attributes.tag) >= 0) {
                    hasRepeatableCalculations = true;
                    repeatableFieldTags.push(field.attributes.tag);
                    var numRepeatableFields = field.attributes.objects.length;

                    if (numRepeatableFields > 0) {
                      for (var y = 0; y < numRepeatableFields; y += 1) {
                        var repeatableField = field.attributes.objects[y];

                        if (repeatableField.id && repeatableField.attributes && repeatableField.attributes.tag) {
                          calculationFormFields.push(repeatableField.attributes.tag);
                          usedFieldTagToIdMap[repeatableField.attributes.tag] = repeatableField.id;
                        }
                      }
                    }
                  }
                }
              }
            }

            this.setState({
              initialised: true,
              calculations: calculations,
              usedFieldTagToIdMap: usedFieldTagToIdMap,
              usedFieldIdToTagMap: invert_default()(usedFieldTagToIdMap),
              currentValues: currentValues,
              formFieldTagCalculationMap: formFieldTagCalculationMap,
              calculationDebounces: calculationDebounces,
              calculationResultsByTag: calculationResultsByTag,
              hasRepeatableCalculations: hasRepeatableCalculations,
              repeatableFieldTags: repeatableFieldTags
            });
          }
          /**
           * This triggers when field value change
           * Calculated fields should retrigger if our mapped fields have value changes
           * Otherwise, we rebuild our local value cache for watched fields, if it changes change state which will trigger calc
           * @param {Object} nextProps
           * @param {Object} nextState
           * @return bool
           */

        }, {
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate(nextProps, nextState) {
            var _this3 = this; // If our local current values cache changed, yes update to run calcs


            if (!isEqual_default()(this.state.currentValues, nextState.currentValues)) {
              return true;
            } // If no prop changes in fieldsById, do not update


            if (isEqual_default()(this.props.fieldsById, nextProps.fieldsById)) {
              return false;
            }

            var newValues = Object.assign({}, nextState.currentValues);
            var currentValuesTimestamps = Object.assign({}, nextState.currentValuesTimestamps); // We have to check requestTimestamps as well since seeing issue where older defaultValues being sent out of sync

            Object.keys(nextProps.fieldsById).forEach(function (fieldId) {
              if (newValues[fieldId] !== undefined) {
                if (!_this3.state.currentValuesTimestamps[fieldId] || _this3.state.currentValuesTimestamps[fieldId] < nextProps.fieldsById[fieldId].requestTimestamp) {
                  currentValuesTimestamps[fieldId] = nextProps.fieldsById[fieldId].requestTimestamp;
                  newValues[fieldId] = nextProps.fieldsById[fieldId].value;
                }
              }
            }); // For our repeatable fields we need to construct an array of sub values to check against

            if (this.state.hasRepeatableCalculations) {
              var numRepeatableFieldTags = this.state.repeatableFieldTags.length;

              for (var i = 0; i < numRepeatableFieldTags; i += 1) {
                var repeatableFieldId = this.state.usedFieldTagToIdMap[this.state.repeatableFieldTags[i]];

                if (repeatableFieldId) {
                  newValues[repeatableFieldId] = Object(core_calculations["b"
                  /* getConstructedRepeatableFieldValue */
                  ])(repeatableFieldId, nextProps.fieldsById, this.props.formFieldsById);
                }
              }
            } // Figure out which fieldIds have changed, to determine which related calcs need to rerun


            var changedFieldIds = reduce_default()(this.state.currentValues, function (result, value, key) {
              return isEqual_default()(value, newValues[key]) ? result : result.concat(key);
            }, []); // Only trigger state change (and hence calc updates) if we have new values

            if (changedFieldIds.length > 0) {
              this.setState({
                currentValues: newValues,
                changedFieldIds: changedFieldIds,
                currentValuesTimestamps: currentValuesTimestamps
              });
            }

            return false;
          }
          /**
           * If the component updated, we have to run any calcs where mapped fields have changed
           */

        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            if (!this.state.initialised) {
              return;
            }

            var numChangedFields = this.state.changedFieldIds.length;

            if (numChangedFields === 0) {
              return;
            }

            var calculationIdsToRun = []; // Determine which calculations we need to run

            for (var i = 0; i < numChangedFields; i += 1) {
              var changedFieldId = this.state.changedFieldIds[i];
              var changedFieldTag = this.state.usedFieldIdToTagMap[changedFieldId];
              calculationIdsToRun = calculationIdsToRun.concat(this.state.formFieldTagCalculationMap[changedFieldTag]);
            }

            calculationIdsToRun = uniq_default()(calculationIdsToRun);
            var numCalculationIdsToRun = calculationIdsToRun.length;

            if (numCalculationIdsToRun > 0) {
              for (var _i = 0; _i < numCalculationIdsToRun; _i += 1) {
                var fn = this.state.calculationDebounces[calculationIdsToRun[_i]];

                if (typeof fn === 'function') {
                  try {
                    fn();
                  } catch (e) {// debug('Exception raised while executing calculation update function.');
                  }
                } else {// debug(
                    //   `Calculation debounce not a valid function. Expected: function, found: ${typeof fn}. Check calculation configuration.`,
                    // );
                  }
              }
            }
          }
          /**
           * Perform the calculation, update state
           * @param {String} calculationId
           */

        }, {
          key: "performCalculation",
          value: function performCalculation(calculationId) {
            var calculation = this.state.calculations[calculationId].calculation;

            if (!calculation) {
              return;
            } // Is the calc disabled? If so do not run
            // Currently dashboard supports disable logic on values and channel only


            if (this.state.calculations[calculationId].hasDisableConditions) {
              var logicProps = {
                data: {
                  variables: {
                    channel: this.props.channel
                  }
                }
              };
              var isDisabled = Object(checkLogic["a"
              /* default */
              ])(this.state.currentValues, this.state.calculations[calculationId].disableConditions, logicProps);

              if (isDisabled) {
                return;
              }
            }

            var _this$state$calculati = this.state.calculations[calculationId],
                lookupValues = _this$state$calculati.lookupValues,
                tag = _this$state$calculati.tag; // Replace ids with machine tags for template parsing

            var currentValues = Object(core_calculations["g"
            /* replaceFieldIdsWithMachineTags */
            ])(this.state.currentValues, this.state.usedFieldIdToTagMap);
            var defaultValue = parseFloat(this.state.calculations[calculationId].defaultValue);
            var calculationResult;

            try {
              // Compile the handlebars calculation template
              calculation = compile_compileCalculationTemplate(calculation, currentValues, lookupValues); // Run the calculation

              calculationResult = calculate_calculate(calculation, defaultValue);
            } catch (error) {
              // Set to default value
              calculationResult = defaultValue;
            }

            var calculationResultsByTag = this.state.calculationResultsByTag; // Our result will be either a matrix (js array) or simple number
            // For arrays, we must recursively apply the min/max, raw/masked value to each item

            var newCalcResult = this.processResultRecursively(calculationId, calculationResult); // If calc results are equal, nothing to change

            if (isEqual_default()(newCalcResult, calculationResultsByTag[tag])) {
              return;
            }

            calculationResultsByTag[tag] = newCalcResult; // Do we need to set values

            if (!isEmpty_default()(this.state.calculations[calculationId].setSubmissionValues)) {
              this.setSubmissionValues(this.state.calculations[calculationId].setSubmissionValues, Date.now());
            }

            this.setState({
              calculationResultsByTag: calculationResultsByTag
            });
          }
          /**
           * Result is either number or (nested) array matrix. So we need to recursively apply to all.
           * @param {number} calculationId
           * @param {string|array} calculationResult
           */

        }, {
          key: "processResultRecursively",
          value: function processResultRecursively(calculationId, calculationResult) {
            var _this$state$calculati2 = this.state.calculations[calculationId],
                maxValue = _this$state$calculati2.maxValue,
                minValue = _this$state$calculati2.minValue,
                numeralDecimalMark = _this$state$calculati2.numeralDecimalMark,
                numeralDecimalScale = _this$state$calculati2.numeralDecimalScale,
                numeralThousandsGroupStyle = _this$state$calculati2.numeralThousandsGroupStyle;
            var defaultValue = this.state.calculations[calculationId].defaultValue;
            var calculationResultIteration = calculationResult;
            defaultValue = parseFloat(defaultValue);

            if (Array.isArray(calculationResultIteration)) {
              var iterationLength = calculationResultIteration.length;

              for (var x = 0; x < iterationLength; x += 1) {
                calculationResultIteration[x] = this.processResultRecursively(calculationId, calculationResultIteration[x]);
              }
            } else {
              // Get max or min values, if set
              calculationResultIteration = Object(core_calculations["d"
              /* getValueOrMax */
              ])(calculationResultIteration, maxValue);
              calculationResultIteration = Object(core_calculations["e"
              /* getValueOrMin */
              ])(calculationResultIteration, minValue); // raw and maskedValue

              calculationResultIteration = Object(core_calculations["a"
              /* getCalculationValueObject */
              ])(calculationResultIteration, defaultValue, numeralDecimalMark, numeralDecimalScale, numeralThousandsGroupStyle);
            }

            return calculationResultIteration;
          } // The whole point of calculated fields is to set the result to a form field, e.g a virtual field
          // This way calculations can sit to the side, and actions / pdf / email template logic etc can all work off
          // existing virtual / office fields, without having to introduce calculations as a new field type (and thus
          // integrate into many different places)

        }, {
          key: "setSubmissionValues",
          value: function setSubmissionValues(submissionValues, updateTimestamp) {
            var _this4 = this;

            var machineTagsToFieldIds = this.props.machineTagsToFieldIds;
            var calculationResultsByTag = this.state.calculationResultsByTag;
            var submissionValuesArray = [];
            Object.keys(submissionValues).forEach(function (fieldTag) {
              var tokenMatches = Object(tokens_tokens["b"
              /* getTokensMatches */
              ])(submissionValues[fieldTag]);
              var numTokenMatches = Array.isArray(tokenMatches) ? tokenMatches.length : 0;
              var value = submissionValues[fieldTag];

              if (numTokenMatches > 0) {
                // If there is only a single token and we have an object, ensure object is sent. Otherwise string.
                // Objects may be used to set inputMask values
                tokenMatches.forEach(function (token) {
                  var replacementValue = tokens_getLocalTokenValue(token, calculationResultsByTag);

                  if (numTokenMatches === 1 && typeof_default()(replacementValue) === 'object') {
                    value = replacementValue;
                  } else {
                    value = value.replace(token, tokens_getLocalTokenValue(token, calculationResultsByTag));
                  }
                });
              }

              var valueHasChanged = true;

              if (_this4.props.fieldsById[fieldTag]) {
                valueHasChanged = !isEqual_default()(_this4.props.fieldsById[fieldTag].value, value);
              } // If setSubmissionValues uses a machine tag there is a noticable delay in updating fields, so attempt to figure out fieldId directly


              var fieldTagOrFieldId = get_default()(machineTagsToFieldIds, fieldTag, null) || fieldTag;

              if (valueHasChanged) {
                submissionValuesArray.push({
                  id: fieldTagOrFieldId,
                  value: value
                });
              }
            }); // Send server-side mutation, if we have different values

            if (submissionValuesArray.length > 0) {
              Object(helpers["c"
              /* setSubmissionValues */
              ])([], submissionValuesArray, updateTimestamp, Object(actions["d"
              /* getStore */
              ])(), Object(actions["a"
              /* getClient */
              ])());
            }
          }
        }, {
          key: "render",
          value: function render() {
            return null;
          }
        }]);
        return CalculatedFieldsContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      CalculatedFieldsContainer_CalculatedFieldsContainer.defaultProps = {
        calculations: [],
        channel: '',
        children: {},
        fieldsById: {},
        formFieldsById: {},
        machineTagsToFieldIds: {}
      };
      CalculatedFieldsContainer_CalculatedFieldsContainer.propTypes = {
        calculations: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        fieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        formFieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        machineTagsToFieldIds: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };
      /* harmony default export */

      var containers_CalculatedFieldsContainer = Object(es["a"
      /* connect */
      ])(function (_ref) {
        var _ref$formatic = _ref.formatic,
            _ref$formatic$data = _ref$formatic.data,
            fieldsById = _ref$formatic$data.submission.fieldsById,
            _ref$formatic$data$fo = _ref$formatic$data.form,
            formFieldsById = _ref$formatic$data$fo.fieldsById,
            machineTagsToFieldIds = _ref$formatic$data$fo.machineTagsToFieldIds,
            channel = _ref$formatic.channel;
        return {
          fieldsById: fieldsById,
          formFieldsById: formFieldsById,
          machineTagsToFieldIds: machineTagsToFieldIds,
          channel: channel
        };
      })(CalculatedFieldsContainer_CalculatedFieldsContainer); // EXTERNAL MODULE: ./src/components/FormLoading.js

      var FormLoading = __webpack_require__(116); // CONCATENATED MODULE: ./src/containers/FormLoadingContainer.js


      var FormLoadingContainer_FormLoadingContainer = function FormLoadingContainer(_ref) {
        var loadingText = _ref.loadingText;
        return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(FormLoading["a"
        /* default */
        ], {
          loadingText: loadingText
        });
      };

      FormLoadingContainer_FormLoadingContainer.defaultProps = {
        loadingText: 'Loading...'
      };
      FormLoadingContainer_FormLoadingContainer.propTypes = {
        loadingText: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var containers_FormLoadingContainer = Object(withOverride["a"
      /* default */
      ])({
        overrideType: 'system',
        type: 'formLoading'
      })(FormLoadingContainer_FormLoadingContainer); // EXTERNAL MODULE: ./src/core/utils/graphql/submission.js

      var graphql_submission = __webpack_require__(63); // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js


      var taggedTemplateLiteral = __webpack_require__(78);

      var taggedTemplateLiteral_default =
      /*#__PURE__*/
      __webpack_require__.n(taggedTemplateLiteral); // EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js


      var src = __webpack_require__(119);

      var src_default =
      /*#__PURE__*/
      __webpack_require__.n(src); // CONCATENATED MODULE: ./src/core/utils/graphql/form.js


      function form_templateObject2() {
        var data = taggedTemplateLiteral_default()(["\n  query getForm(\n    $formId: Int!\n    $branch: String = \"Live\"\n    $channel: String = \"master\"\n    $config: String = \"default\"\n    $submissionId: String\n    $initialValues: [ValueInput]\n  ) {\n    Form(id: $formId, branch: $branch, channel: $channel, config: $config) {\n      id\n      attributes\n      fields {\n        id\n        renderer\n        attributes\n      }\n      sections {\n        id\n        attributes\n        fields {\n          id\n          overrideAttributes\n          logic {\n            ...logicOperationDetails\n          }\n        }\n      }\n      pages {\n        id\n        attributes\n        logic {\n          ...logicOperationDetails\n        }\n        sections {\n          id\n          overrideAttributes\n          logic {\n            ...logicOperationDetails\n          }\n        }\n      }\n      server {\n        timestamp\n      }\n      rootComponents {\n        id\n        fieldId\n        renderer\n        attributes\n        logic {\n          ...logicOperationDetails\n        }\n        childOf\n        meta\n      }\n      frontEndActions {\n        eventType\n        triggersAndActions {\n          triggerId\n          triggerParamsAndActions {\n            triggerDataId\n            actions {\n              actionId\n              actionParams {\n                id\n                value\n              }\n            }\n          }\n        }\n      }\n      calculations {\n        id\n        name\n        tag\n        calculation\n        debounce\n        defaultValue\n        minValue\n        maxValue\n        setSubmissionValues\n        lookupValues\n        numeralDecimalScale\n        numeralDecimalMark\n        numeralThousandsGroupStyle\n        disableConditions\n      }\n    }\n    Submission(id: $submissionId, formId: $formId, branch: $branch, channel: $channel, initialValues: $initialValues) {\n      id\n      branch\n      attributes {\n        id\n        value\n        requestTimestamp\n        type\n      }\n      fields {\n        id\n        value\n        requestTimestamp\n      }\n    }\n  }\n\n  fragment logicOperationDetails on Logic {\n    operation {\n      operationType\n      attributes\n    }\n    condition {\n      conditionType\n      attributes\n    }\n  }\n"]);

        form_templateObject2 = function _templateObject2() {
          return data;
        };

        return data;
      }

      function form_templateObject() {
        var data = taggedTemplateLiteral_default()(["\n  query getForm(\n    $formId: Int!\n    $branch: String = \"Live\"\n    $channel: String = \"master\"\n    $config: String = \"default\"\n  ) {\n    Form(id: $formId, branch: $branch, channel: $channel, config: $config) {\n      id\n      attributes\n      fields {\n        id\n        renderer\n        attributes\n      }\n      sections {\n        id\n        attributes\n        fields {\n          id\n          overrideAttributes\n          logic {\n            ...logicOperationDetails\n          }\n        }\n      }\n      pages {\n        id\n        attributes\n        logic {\n          ...logicOperationDetails\n        }\n        sections {\n          id\n          overrideAttributes\n          logic {\n            ...logicOperationDetails\n          }\n        }\n      }\n      server {\n        timestamp\n      }\n      rootComponents {\n        id\n        fieldId\n        renderer\n        attributes\n        logic {\n          ...logicOperationDetails\n        }\n        childOf\n        meta\n      }\n      frontEndActions {\n        eventType\n        triggersAndActions {\n          triggerId\n          triggerParamsAndActions {\n            triggerDataId\n            actions {\n              actionId\n              actionParams {\n                id\n                value\n              }\n            }\n          }\n        }\n      }\n      calculations {\n        id\n        name\n        tag\n        calculation\n        debounce\n        defaultValue\n        minValue\n        maxValue\n        setSubmissionValues\n        lookupValues\n        numeralDecimalScale\n        numeralDecimalMark\n        numeralThousandsGroupStyle\n        disableConditions\n      }\n    }\n  }\n\n  fragment logicOperationDetails on Logic {\n    operation {\n      operationType\n      attributes\n    }\n    condition {\n      conditionType\n      attributes\n    }\n  }\n"]);

        form_templateObject = function _templateObject() {
          return data;
        };

        return data;
      }

      var form_getFormQuery = src_default()(form_templateObject());
      var form_getFullFormWithDetailsQuery = src_default()(form_templateObject2()); // EXTERNAL MODULE: ./src/core/actions/index.js

      var core_actions = __webpack_require__(29); // EXTERNAL MODULE: ./src/core/utils/analytics.js + 1 modules


      var analytics = __webpack_require__(17); // EXTERNAL MODULE: ./node_modules/lodash/difference.js


      var difference = __webpack_require__(668);

      var difference_default =
      /*#__PURE__*/
      __webpack_require__.n(difference); // EXTERNAL MODULE: ./node_modules/lodash/set.js


      var set = __webpack_require__(52);

      var set_default =
      /*#__PURE__*/
      __webpack_require__.n(set); // EXTERNAL MODULE: ./src/core/utils/localStorage.js


      var localStorage = __webpack_require__(44); // CONCATENATED MODULE: ./src/core/RootComponents/helpers/formData.js


      var formData_getCurrentPageId = function getCurrentPageId(currentPage, channel) {
        return get_default()(currentPage, "[".concat(channel, "].pageId"));
      };

      var formData_convertArrayToObjectById = function convertArrayToObjectById(object, path) {
        return objectSpread_default()({}, get_default()(object, path, []).reduce(function (acc, item) {
          return objectSpread_default()({}, acc, defineProperty_default()({}, item.id, item));
        }, {}));
      };

      var formData_generateDataSubmission = function generateDataSubmission(props) {
        var dataSubmission = objectSpread_default()({}, get_default()(props.data, ['Submission']));
        dataSubmission.fieldsById = formData_convertArrayToObjectById(props.data, 'Submission.fields');
        dataSubmission.attributesById = formData_convertArrayToObjectById(props.data, 'Submission.attributes');
        return dataSubmission;
      };

      var formData_setOrderedFields = function setOrderedFields(props) {
        if (isEmpty_default()(props.orderedFields) && !isEmpty_default()(props.data.Form)) {
          var fields = [];
          get_default()(props, 'data.Form.pages', []).forEach(function (page) {
            get_default()(page, 'sections', []).forEach(function (section) {
              get_default()(props, "data.Form.sectionsById[".concat(section.id, "].fields"), []).forEach(function (field) {
                fields.push(field.id);
              });
            });
          });

          if (!isEmpty_default()(fields)) {
            props.setOrderedFields(fields);
          }
        }
      };

      var formData_initializeForm = function initializeForm(state, nextProps) {
        var localStorageId = Object(localStorage["c"
        /* getLocalStorageSubmissionKey */
        ])(nextProps.formId);
        var nextPropsCurrentPageId = formData_getCurrentPageId(nextProps.currentPage, nextProps.channel);

        if ( // if the branch of the submission values is different from the props, then clear localstorage
        !isEqual_default()(nextProps.data.Submission.branch, nextProps.environment) || // if clearSessionOnComplete is true and the current page is a completion page, then clear localstorage
        get_default()(nextProps, 'data.Form.attributes.clearSessionOnComplete') && get_default()(state, "dataForm.pagesById[".concat(nextPropsCurrentPageId, "].attributes.isCompletionPage"))) {
          // since the submission value belongs to a branch different to environment received in props, it needs to delete submissionId
          // from localstorage value in order to prevent the user to have access to submission values from a different environment
          Object(localStorage["g"
          /* localStorageRemoveItem */
          ])(localStorageId);
        }

        var newDataSubmission = formData_generateDataSubmission(nextProps);
        var verifiedIds = {};
        var fieldsByIdDiff = {};
        var attributesByIdDiff = {};

        var compare = function compare(id, path, diffObject) {
          verifiedIds[id] = true;
          var currentValue = get_default()(state.dataSubmission, path);
          var newValue = get_default()(newDataSubmission, path);

          if (!isEqual_default()(currentValue, newValue)) {
            currentValue = Array.isArray(currentValue) ? currentValue : [currentValue];
            newValue = Array.isArray(newValue) ? newValue : [newValue];
            diffObject[id] = difference_default()(newValue, currentValue);
            diffObject[id] = diffObject[id].length === 1 ? diffObject[id][0] : diffObject[id];
          }
        };

        var compareOldAndNewObjects = function compareOldAndNewObjects(oldObject, newObject, getPathToCompare, diffObject) {
          Object.keys(oldObject).forEach(function (id) {
            return compare(id, getPathToCompare(id), diffObject);
          });
          Object.keys(newObject).forEach(function (id) {
            if (verifiedIds[id] === undefined) {
              compare(id, getPathToCompare(id), diffObject);
            }
          });
        };

        compareOldAndNewObjects(state.dataSubmission.fieldsById, newDataSubmission.fieldsById, function (id) {
          return "fieldsById[".concat(id, "].value");
        }, fieldsByIdDiff);
        compareOldAndNewObjects(state.dataSubmission.attributesById, newDataSubmission.attributesById, function (id) {
          return "attributesById[".concat(id, "].value");
        }, attributesByIdDiff);
        newDataSubmission.fieldsByIdDiff = fieldsByIdDiff;
        newDataSubmission.attributesByIdDiff = attributesByIdDiff;
        var dataForm = objectSpread_default()({}, nextProps.data.Form);
        set_default()(dataForm, 'fieldsById', formData_convertArrayToObjectById(nextProps.data, 'Form.fields'));
        set_default()(dataForm, 'sectionsById', formData_convertArrayToObjectById(nextProps.data, 'Form.sections'));
        set_default()(dataForm, 'pagesById', formData_convertArrayToObjectById(nextProps.data, 'Form.pages'));
        var newState = {
          dataSubmission: newDataSubmission,
          dataLoading: nextProps.data.loading
        }; // only rebuild mappings if dataForm changed (it should not change actually, therefore it'd be only one time execution)

        if (!isEqual_default()(pick_default()(dataForm, ['fieldsById', 'sectionsById', 'pagesById']), pick_default()(state.dataForm, ['fieldsById', 'sectionsById', 'pagesById']))) {
          // mapping of all sections in a page
          dataForm.sectionsByPageId = {}; // mapping of all fields in a page

          dataForm.fieldByPageId = {}; // mapping of pageId for every fieldId

          dataForm.pageIdByFieldId = {};
          var fields = {};
          get_default()(nextProps.data, 'Form.pages', []).forEach(function (page) {
            dataForm.sectionsByPageId[page.id] = [];
            dataForm.fieldByPageId[page.id] = [];
            get_default()(page, 'sections', []).forEach(function (section) {
              dataForm.sectionsByPageId[page.id].push(section.id);
              get_default()(dataForm, "sectionsById[".concat(section.id, "].fields"), []).forEach(function (field) {
                dataForm.fieldByPageId[page.id].push(field.id);
                dataForm.pageIdByFieldId[field.id] = page.id;
              });
            });
            get_default()(page, 'logic', []).forEach(function (logicItem) {
              if (logicItem.operation.operationType === 'nextPage') {
                get_default()(logicItem, 'condition.attributes.logic.rules', []).forEach(function (rule) {
                  fields[rule.field] = true;
                });
              }
            });
          });
          nextProps.storeFieldsImpactingPageFlow(fields);
          nextProps.storeDataForm(dataForm);
          newState.dataForm = dataForm;
        }

        nextProps.setDataFormById(dataForm.fieldsById, dataForm.sectionsById, dataForm.pagesById);
        nextProps.setDataSubmissionById(newDataSubmission.fieldsById, newDataSubmission.attributesByIdDiff);
        nextProps.setDataSubmission(nextProps.data.Submission);
        return {
          newState: newState
        };
      };

      var formData_startSession = function startSession(currentProps, nextProps) {
        var localStorageId = Object(localStorage["c"
        /* getLocalStorageSubmissionKey */
        ])(nextProps.formId);
        var nextPropsSubmissionId = nextProps.data.Submission.id;
        var storageEngine = get_default()(nextProps, 'data.Form.attributes.storage', null);
        Object(localStorage["h"
        /* localStorageSetItem */
        ])("".concat(localStorage["b"
        /* StorageEngineKey */
        ]).concat(nextProps.formId), storageEngine, localStorage["a"
        /* Engine */
        ].LocalStorage);

        if (get_default()(nextProps, 'data.Form.attributes.sessionPersistOnReload', true)) {
          Object(localStorage["h"
          /* localStorageSetItem */
          ])(localStorageId, nextPropsSubmissionId, storageEngine);
        } else {
          Object(localStorage["g"
          /* localStorageRemoveItem */
          ])(localStorageId, storageEngine);
        } // Fire session started event


        var isNew = nextProps.submissionId === null;
        nextProps.emitter.emit(constants["Events"].SessionStarted, {
          isNew: isNew,
          submissionID: nextPropsSubmissionId
        }); // Hook on to form behavior events

        Object(actions["e"
        /* initialiseTriggerData */
        ])(nextProps.data.Form.frontEndActions);
        Object(actions["i"
        /* setSubmissionId */
        ])(nextPropsSubmissionId);
        Object(actions["j"
        /* subscribeOnFormAction */
        ])(); // realign submission ID if different, usually on new submissions

        if (currentProps.submissionId !== nextPropsSubmissionId) {
          // don't keep the previous formId newSubmissionId,
          // so just assign a new object only containing the new submissionId by the new form
          return defineProperty_default()({}, currentProps.formId, nextPropsSubmissionId);
        }

        return false;
      };

      var formData_finishSession = function finishSession(props) {
        var _props$data$Form$attr = props.data.Form.attributes.storage,
            storage = _props$data$Form$attr === void 0 ? null : _props$data$Form$attr;
        var localStorageId = Object(localStorage["c"
        /* getLocalStorageSubmissionKey */
        ])(props.formId);

        if (get_default()(props, 'data.Form.attributes.clearSessionOnComplete', true)) {
          Object(localStorage["g"
          /* localStorageRemoveItem */
          ])(localStorageId, storage);
          Object(localStorage["g"
          /* localStorageRemoveItem */
          ])("formaticAnalytics-".concat(props.formId), storage);
          Object(localStorage["g"
          /* localStorageRemoveItem */
          ])("formaticAnalyticsSent-".concat(props.formId), storage);
        }
      }; // EXTERNAL MODULE: ./src/core/utils.js + 1 modules


      var utils = __webpack_require__(18); // EXTERNAL MODULE: ./src/core/utils/graphql/subscription.js


      var subscription = __webpack_require__(222); // CONCATENATED MODULE: ./src/core/RootComponents/helpers/subscriptions.js


      var subscriptions_attributesSubscribeToMore = function attributesSubscribeToMore(submissionId, formId) {
        return {
          document: subscription["a"
          /* subscriptionAttributeChanged */
          ],
          variables: {
            submission: submissionId,
            formId: formId
          },
          updateQuery: function updateQuery(previousState, _ref) {
            var subscriptionData = _ref.subscriptionData;

            if (isEmpty_default()(previousState) || isEmpty_default()(subscriptionData)) {
              return previousState;
            }

            var attributes;

            if (Object(utils["n"
            /* getValueFromList */
            ])(subscriptionData.data.attributeChanged.id, previousState.Submission.attributes)) {
              attributes = previousState.Submission.attributes.map(function (x) {
                // update previous entry
                if (x.id !== subscriptionData.data.attributeChanged.id) {
                  return x;
                }

                return objectSpread_default()({}, x, {
                  type: 'subscription',
                  value: subscriptionData.data.attributeChanged.value
                });
              });
            } else {
              attributes = [].concat(toConsumableArray_default()(previousState.Submission.attributes), [objectSpread_default()({}, subscriptionData.data.attributeChanged, {
                type: 'subscription'
              })]);
            }

            return objectSpread_default()({}, previousState, {
              Submission: objectSpread_default()({}, previousState.Submission, {
                attributes: attributes
              })
            });
          },
          onError: function onError(err) {
            return console.error(err);
          }
        };
      };

      var subscriptions_fieldsSubscribeToMore = function fieldsSubscribeToMore(submissionId) {
        return {
          document: subscription["c"
          /* subscriptionValueChanged */
          ],
          variables: {
            submission: submissionId // tightly coupled withFormData for now

          },
          updateQuery: function updateQuery(previousState, _ref2) {
            var subscriptionData = _ref2.subscriptionData;
            var fieldId = get_default()(subscriptionData, 'data.valueChanged.id');

            if (isEmpty_default()(previousState) || isEmpty_default()(subscriptionData)) {
              return previousState;
            }

            var fields;

            if (Object(utils["n"
            /* getValueFromList */
            ])(fieldId, previousState.Submission.fields)) {
              fields = previousState.Submission.fields.map(function (x) {
                // update previous entry
                if (x.id !== fieldId) {
                  return x;
                }

                return objectSpread_default()({}, x, {
                  value: subscriptionData.data.valueChanged.value,
                  requestTimestamp: subscriptionData.data.valueChanged.requestTimestamp
                });
              });
            } else {
              fields = [].concat(toConsumableArray_default()(previousState.Submission.fields), [objectSpread_default()({}, subscriptionData.data.valueChanged)]);
            }

            return objectSpread_default()({}, previousState, {
              Submission: objectSpread_default()({}, previousState.Submission, {
                fields: fields
              })
            });
          },
          onError: function onError(err) {
            return console.error(err);
          }
        };
      }; // CONCATENATED MODULE: ./src/core/RootComponents/helpers/pageNavigation.js


      var pageNavigation_getFieldImpactingPageFlow = function getFieldImpactingPageFlow(fieldsByIdDiff, fieldsImpactingPageFlow) {
        var shouldCallPageNavigation;
        var fieldImpactingPageFlow;
        Object.keys(fieldsByIdDiff).some(function (fieldId) {
          shouldCallPageNavigation = Object.keys(fieldsImpactingPageFlow).indexOf(fieldId) >= 0;

          if (shouldCallPageNavigation) {
            fieldImpactingPageFlow = fieldId;
          }

          return shouldCallPageNavigation; // it'll stop to loop through once shouldCallPageNavigation is true
        });
        return fieldImpactingPageFlow;
      };

      var pageNavigation_triggerNextPageEvent = function triggerNextPageEvent(direction, oldPageId, newPageId, emitter) {
        var jsEvent = direction === navigation["a"
        /* NavigationDirection */
        ].Next ? constants["Events"].NextPage : constants["Events"].PrevPage;
        emitter.emit(jsEvent, {
          oldPage: oldPageId,
          newPage: newPageId
        });
      };
      /**
       * Returns the current page id.
       *
       * note: the current page depends on the channel.
       */


      var pageNavigation_getCurrentPageId = function getCurrentPageId(currentPage, channel) {
        return get_default()(currentPage, "[".concat(channel, "].pageId"));
      };
      /**
       * Returns the new page index.
       *
       * It does the normal calculation increase/descrease index according to its direction if page flow didn't change.
       *
       * When page flow changed, then it does the same normal calculation if the current page has the same index in the old and new page flow.
       * However if the current page has a different index in the old and new page flows, then it'll get the page index of the field that
       * impacted the page flow (fieldImpactingPageFlow contains this field id).
       *
       */


      var pageNavigation_getNewPageIndex = function getNewPageIndex(props, didPageFlowChange, pageFlow, direction, fieldImpactingPageFlow, pageIdByFieldId) {
        var currentPageId = pageNavigation_getCurrentPageId(props.currentPage, props.channel);
        var newPageIndex;

        var calculatePageIndexBasedOnDirection = function calculatePageIndexBasedOnDirection() {
          var val = 0; // direction can be NewFlow as well

          if (direction === navigation["a"
          /* NavigationDirection */
          ].Prev) {
            val = -1;
          } else if (direction === navigation["a"
          /* NavigationDirection */
          ].Next) {
            val = 1;
          }

          var index = pageFlow[props.flow.current].indexOf(currentPageId) + val;
          return index < 0 ? 0 : index;
        };

        if (didPageFlowChange && props.pageFlow[props.flow.current]) {
          // it means that pageFlow has changed (probably because of an user input) and now we need re re-evaluate the whole pageFlow
          // since there might be pages in props.pageFlow that are not present in pageFlow
          // therefore we need to get the lastCommonPageInBothPageFlows
          var lastCommonPageInBothPageFlows = '';
          props.pageFlow[props.flow.current].some(function (page, index) {
            var result = index === pageFlow[props.flow.current].indexOf(page);

            if (result) {
              lastCommonPageInBothPageFlows = page;
            }

            return !result;
          });

          if (pageFlow[props.flow.current].indexOf(currentPageId) === pageFlow[props.flow.current].indexOf(lastCommonPageInBothPageFlows) || !fieldImpactingPageFlow) {
            // it's the same currentPage (despite that pageFlow is different), therefore execute the next/back button logic
            newPageIndex = calculatePageIndexBasedOnDirection();
          } else {
            // get the pageId which contains the fieldImpactingPageFlow
            var pageId = pageIdByFieldId[fieldImpactingPageFlow]; // find the index of that pageId

            var index = pageFlow[props.flow.current].indexOf(pageId); // double check if that is a valid index

            newPageIndex = index < 0 ? 0 : index;
          }
        } else {
          // currentPage is still in pageFlow and the pageFlow was not changed, therefore execute the next/back button logic
          newPageIndex = calculatePageIndexBasedOnDirection();
        }

        return newPageIndex;
      };
      /**
       * It indicates whether or not backend should be updated with a new pageId and channel.
       *
       * The current page depends on the current channel, therefore if the channel or the pageId is different, then backend should be updated
       * @todo: do we allow channel change?
       */


      var pageNavigation_shouldBackendBeUpdated = function shouldBackendBeUpdated(newPageId, oldPageId, newChannel, oldChannel) {
        return newPageId !== oldPageId || newChannel !== oldChannel;
      };
      /**
       * Retrieves the page flow for a given flow/starting point
       * @param {string} pageId
       * @param {object} dataSubmission
       * @param {object} props
       * @return {Array} The page flow that was build and set in Redux store
       */


      var pageNavigation_getPageFlowForPage = function getPageFlowForPage(pageId, props) {
        var pageFlow = [];
        var page = pageId;
        var pages = keyBy_default()(props.data.Form.pages, 'id');

        while (page !== null) {
          pageFlow.push(page);
          var pageData = pages[page];
          var isCompletionPage = get_default()(pageData, 'attributes.isCompletionPage');
          var nextPage = null;

          if (!isCompletionPage) {
            nextPage = pageData.attributes.nextPageDefault || null; // eslint-disable-next-line no-loop-func

            pageData.logic.forEach(function (logicItem) {
              // the only handler right now...
              if (logicItem.condition.conditionType === 'formLogic' && Object(checkLogic["a"
              /* default */
              ])(Object(utils["f"
              /* getKVObjectFromList */
              ])(props.data.Submission.fields), logicItem.condition.attributes.logic, props, {}, props.tokens) && logicItem.operation.operationType === 'nextPage') {
                nextPage = logicItem.operation.attributes.pageId;
              }
            });
          }

          if (pageFlow.includes(nextPage)) {
            // Circular dependency, page is already in the flow, need to break else will loop forever
            // Add the page and then break, so page flow knows where to go next
            pageFlow.push(nextPage);
            break;
          }

          page = nextPage;
        }

        return pageFlow;
      };
      /**
       * Builds the page flow model as an array
       * @param  {object} [props=props]
       * @return {Array} The page flow that was build and set in Redux store
       */


      var pageNavigation_mapPageFlow = function mapPageFlow(state, props) {
        var page = props.data.Form.pages[0].id;

        if (props.data.Form.attributes.channel.page) {
          page = props.data.Form.attributes.channel.page;
        } // Calculate main page flow


        var pageFlow = pageNavigation_getPageFlowForPage(page, props); // Calculate additional page flows

        var additionalFlows = get_default()(props, 'data.Form.attributes.flow', []).reduce(function (accum, flow) {
          var startId = flow.default,
              name = flow.name;
          accum[name] = pageNavigation_getPageFlowForPage(startId, props);
          return accum;
        }, {});
        var formPageFlow = objectSpread_default()(defineProperty_default()({}, helpers_pageFlow["a"
        /* Constants */
        ].DefaultFlow, pageFlow), additionalFlows);

        if (!isEqual_default()(formPageFlow, props.pageFlow)) {
          props.setPageFlow(formPageFlow);
        }

        return formPageFlow;
      };
      /**
       * handles page jumps to IDs
       * @param  {string} pageId Page ID to jump to
       * @param  {object} [props=props] Custom props instead of the default
       * @return {boolean}
       */


      var pageNavigation_goToPage = function goToPage(pageId, pagesById1, props, state) {
        var updateBackend = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        var pagesById = keyBy_default()(props.data.Form.pages, 'id');

        if (!pagesById[pageId]) {
          return false;
        }

        var channel = props.channel,
            currentPage = props.currentPage;
        var requestTimestamp = Date.now();
        var oldPage = pageNavigation_getCurrentPageId(currentPage, channel);
        props.setCurrentPage(pageId, channel, requestTimestamp);

        if (updateBackend && pageNavigation_shouldBackendBeUpdated(pageId, oldPage, channel, channel)) {
          var attributes = get_default()(props.data, 'Submission.attributes', []);
          var currentPageValue;
          attributes.some(function (attribute) {
            if (attribute.id === 'currentPage') {
              currentPageValue = attribute.value;
              return true;
            }

            return false;
          }); // update backend

          props.submissionAttribute({
            id: 'currentPage',
            value: objectSpread_default()({}, currentPageValue, defineProperty_default()({}, channel, {
              pageId: pageId,
              requestTimestamp: requestTimestamp
            }))
          });
        }

        return true;
      }; // EXTERNAL MODULE: ./src/core/RootComponents/helpers/mutations.js


      var mutations = __webpack_require__(112); // EXTERNAL MODULE: ./src/containers/ButtonContainer.js


      var ButtonContainer = __webpack_require__(98); // CONCATENATED MODULE: ./src/containers/ActionbarRootContainer.js


      var ActionbarRootContainer_ChildPositions = {
        BeforePrev: 'BEFORE_PREV',
        AfterPrev: 'AFTER_PREV',
        BeforeNext: 'BEFORE_NEXT',
        AfterNext: 'AFTER_NEXT'
      };

      var ActionbarRootContainer_ActionbarRootContainer =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(ActionbarRootContainer, _Component);

        function ActionbarRootContainer(props) {
          var _this;

          classCallCheck_default()(this, ActionbarRootContainer);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(ActionbarRootContainer).call(this, props));
          defineProperty_default()(assertThisInitialized_default()(_this), "shouldComponentUpdate", function (nextProps, nextState) {
            // Always on page change, and reset checked state
            if (!isEqual_default()(nextProps.currentPage, _this.props.currentPage)) {
              _this.setState({
                checkedForPageNavigationVisibilityConditions: false
              });

              return true;
            } // Verify if the pageFlow haven't change


            if (!isEqual_default()(nextProps.pageFlow, _this.props.pageFlow)) {
              return true;
            } // No need if values haven't changed


            if (isEqual_default()(_this.props.fieldsById, nextProps.fieldsById)) {
              return false;
            }

            var currentPageId = get_default()(_this.props.currentPage, "[".concat(_this.props.channel, "].pageId")); // Check for conditions if not done for this page

            if (!nextState.checkedForPageNavigationVisibilityConditions) {
              var hasConditions = _this.pageHasNavigationVisibilityConditions(currentPageId);

              _this.setState({
                checkedForPageNavigationVisibilityConditions: true,
                pageHasNavigationVisibilityConditions: hasConditions
              });

              return hasConditions;
            }

            return _this.state.checkedForPageNavigationVisibilityConditions && _this.state.pageHasNavigationVisibilityConditions;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getCurrentPageId", function () {
            return get_default()(_this.props.currentPage, "[".concat(_this.props.channel, "].pageId"));
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleOnNextClick", function () {
            if (!_this.props.preventOnNextPageEvent) {
              _this.props.navigate(navigation["a"
              /* NavigationDirection */
              ].Next);
            }

            _this.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].NextPageClick, {
              currentPage: _this.getCurrentPageId()
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "handleOnBackClick", function () {
            _this.props.navigate(navigation["a"
            /* NavigationDirection */
            ].Prev);

            _this.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].PrevPageClick, {
              currentPage: _this.getCurrentPageId()
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "renderButton", function (direction) {
            var _this$props = _this.props,
                currentPageFlow = _this$props.flow.current,
                pageFlow = _this$props.pageFlow;

            var pageId = _this.getCurrentPageId();

            var page = _this.props.pages[pageId];

            var isNextPageCompletionPage = _this.nextPageIsCompletionPage();

            var nextTextDefault = isNextPageCompletionPage ? 'Submit' : 'Next';
            var nextButtonCssClass = isNextPageCompletionPage ? 'formatic-action-bar-root__submit' : 'formatic-action-bar-root__next';
            var backTextDefault = 'Back';
            var nextText = typeof_default()(page) === 'object' ? get_default()(page, 'attributes.nextButtonText', '') : '';
            var backText = typeof_default()(page) === 'object' ? get_default()(page, 'attributes.prevButtonText', '') : '';
            var isNextButton = direction === navigation["a"
            /* NavigationDirection */
            ].Next;
            var isPrevButton = pageFlow[currentPageFlow].indexOf(pageId) !== 0;
            var nextButtonLabel = nextText.length > 0 ? nextText : nextTextDefault;
            var prevButtonLabel = backText.length > 0 ? backText : backTextDefault;
            var label = isNextButton ? nextButtonLabel : prevButtonLabel;
            var buttonClassName = isNextButton ? nextButtonCssClass : 'formatic-action-bar-root__back';
            var onClickHandler = isNextButton ? _this.handleOnNextClick : _this.handleOnBackClick;

            if (isNextButton || isPrevButton) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(ButtonContainer["a"
              /* default */
              ], {
                label: label,
                type: "button",
                className: buttonClassName,
                onClick: onClickHandler
              });
            }

            return null;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "getChildrenForPosition", function (pos) {
            return _this.props.childComponents.filter(function (_ref) {
              var position = _ref.props.meta.position;
              return position === pos;
            }).map(function (_ref2) {
              var component = _ref2.component;
              return component;
            });
          });
          _this.state = {
            pageHasNavigationVisibilityConditions: false,
            checkedForPageNavigationVisibilityConditions: false
          };
          _this.sendAnalytics = Object(analytics["c"
          /* analyticsCallback */
          ])({
            submissionId: props.submissionId,
            formId: props.formId,
            branch: props.environment,
            channel: props.channel
          }, props.emitter);
          return _this;
        }

        createClass_default()(ActionbarRootContainer, [{
          key: "isCompletionPage",

          /**
           * Checks if a page is marked as a completion page
           * @param {String?} pageId
           * @returns {boolean}
           */
          value: function isCompletionPage() {
            var pageId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (pageId === null) {
              pageId = get_default()(this.props.currentPage, "[".concat(this.props.channel, "].pageId"));
            }

            var currentPage = this.props.pages[pageId];
            return get_default()(currentPage, 'attributes.isCompletionPage', false);
          }
          /**
           * Checks if a page has configured boolean logic to hide navigation
           */

        }, {
          key: "isNavigationVisible",
          value: function isNavigationVisible() {
            var _this2 = this;

            var _this$props2 = this.props,
                currentPageFlow = _this$props2.flow.current,
                pageFlow = _this$props2.pageFlow;
            var currentPageId = get_default()(this.props.currentPage, "[".concat(this.props.channel, "].pageId")); // Avoid repeating checks

            if (this.state.checkedForPageNavigationVisibilityConditions && !this.state.pageHasNavigationVisibilityConditions) {
              return true;
            }

            var currentPage = this.props.pages[currentPageId];

            if (!currentPage) {
              return true;
            }

            if (Array.isArray(pageFlow[currentPageFlow]) && !pageFlow[currentPageFlow].includes(currentPage.id)) {
              // Dangling page, doesn't exist within defined page flow, nowhere to go
              return false;
            }

            var pageNavigationVisibilityConditions = this.getPageNavigationVisibilityConditions(currentPageId); // Format the required props as checkLogic requires

            var logicProps = {
              data: {
                variables: {
                  channel: this.props.channel,
                  branch: this.props.environment
                }
              }
            }; // Format values into a fieldId : value object

            var fieldValues = {};
            Object.keys(this.props.fieldsById).forEach(function (fieldId) {
              fieldValues[fieldId] = _this2.props.fieldsById[fieldId].value;
            });
            var numPageNavigationVisibilityConditions = pageNavigationVisibilityConditions.length; // If any of the conditions pass, the action bar should not be visible.

            for (var x = 0; x < numPageNavigationVisibilityConditions; x += 1) {
              var conditionJson = Object(utils["s"
              /* safeJSONParse */
              ])(pageNavigationVisibilityConditions[x]);

              if (conditionJson && Object(checkLogic["a"
              /* default */
              ])(fieldValues, conditionJson, logicProps, {}, this.props.tokens)) {
                return false;
              }
            }

            return true;
          }
          /**
           * Check if a given pageId has pageNavigationVisibilityConditions
           * @param {string} pageId
           */

        }, {
          key: "pageHasNavigationVisibilityConditions",
          value: function pageHasNavigationVisibilityConditions(pageId) {
            return !isEqual_default()(this.getPageNavigationVisibilityConditions(pageId), []);
          }
          /**
           * Retrieve the pageNavigationVisibilityConditions for a given pageId
           * @param {string} pageId
           */

        }, {
          key: "getPageNavigationVisibilityConditions",
          value: function getPageNavigationVisibilityConditions(pageId) {
            var page = this.props.pages[pageId];
            return get_default()(page, 'attributes.pageNavigationVisibilityConditions', []);
          }
          /**
           * Checks to see if the next page in the page flow is a completion page or not.
           * @returns {boolean}
           */

        }, {
          key: "nextPageIsCompletionPage",
          value: function nextPageIsCompletionPage() {
            var _this$props3 = this.props,
                currentPageFlow = _this$props3.flow.current,
                pageFlow = _this$props3.pageFlow;
            var currentPageIndex = pageFlow[currentPageFlow].indexOf(this.getCurrentPageId());

            if (currentPageIndex < 0) {
              return false;
            }

            var nextPageId = pageFlow[currentPageFlow][currentPageIndex + 1];
            return nextPageId ? this.isCompletionPage(nextPageId) : pageFlow[currentPageFlow].length - 1 === pageFlow[currentPageFlow].indexOf(this.getCurrentPageId());
          }
        }, {
          key: "render",
          value: function render() {
            return !this.isCompletionPage() && this.isNavigationVisible() && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-action-bar-root"
            }, this.getChildrenForPosition(ActionbarRootContainer_ChildPositions.BeforePrev), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic__float-left formatic-action-bar-root__previous-container"
            }, this.renderButton(navigation["a"
            /* NavigationDirection */
            ].Prev)), this.getChildrenForPosition(ActionbarRootContainer_ChildPositions.AfterPrev), this.getChildrenForPosition(ActionbarRootContainer_ChildPositions.BeforeNext), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic__float-right formatic-action-bar-root__next-container"
            }, this.renderButton(navigation["a"
            /* NavigationDirection */
            ].Next)), this.getChildrenForPosition(ActionbarRootContainer_ChildPositions.AfterNext));
          }
        }]);
        return ActionbarRootContainer;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      ActionbarRootContainer_ActionbarRootContainer.defaultProps = {
        preventOnNextPageEvent: false,
        // props from connect formatic store
        apiKey: '',
        channel: '',
        childComponents: [],
        currentPage: {},
        emitter: {},
        environment: '',
        fieldsById: {},
        formId: 0,
        navigate: noop_default.a,
        pageFlow: helpers_pageFlow["a"
        /* Constants */
        ].DefaultPageFlow,
        pages: {},
        submissionId: '',
        tokens: {}
      };
      ActionbarRootContainer_ActionbarRootContainer.propTypes = {
        preventOnNextPageEvent: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        // props from connect formatic store
        apiKey: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        childComponents: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          childOf: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
          component: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node.isRequired,
          id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
          props: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired
        })),
        currentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        emitter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        environment: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        fieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        flow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          current: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
          flows: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired
        }).isRequired,
        formId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number,
        navigate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        pageFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        pages: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        submissionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        tokens: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };

      var ActionbarRootContainer_mapStateToProps = function mapStateToProps(_ref3) {
        var _ref3$formatic = _ref3.formatic,
            apiKey = _ref3$formatic.apiKey,
            channel = _ref3$formatic.channel,
            currentPage = _ref3$formatic.currentPage,
            _ref3$formatic$data = _ref3$formatic.data,
            pagesById = _ref3$formatic$data.form.pagesById,
            fieldsById = _ref3$formatic$data.submission.fieldsById,
            emitter = _ref3$formatic.emitter,
            environment = _ref3$formatic.environment,
            flow = _ref3$formatic.flow,
            formId = _ref3$formatic.formId,
            navigate = _ref3$formatic.pageNavigation.navigate,
            pageFlow = _ref3$formatic.pageFlow,
            submissionId = _ref3$formatic.submissionId,
            tokens = _ref3$formatic.tokens;
        return {
          apiKey: apiKey,
          channel: channel,
          currentPage: currentPage,
          emitter: emitter,
          environment: environment,
          fieldsById: fieldsById,
          flow: flow,
          formId: formId,
          navigate: navigate,
          pageFlow: pageFlow,
          pages: pagesById,
          submissionId: submissionId,
          tokens: tokens
        };
      };
      /* harmony default export */


      var containers_ActionbarRootContainer = Object(es["a"
      /* connect */
      ])(ActionbarRootContainer_mapStateToProps)(ActionbarRootContainer_ActionbarRootContainer); // CONCATENATED MODULE: ./src/config/rootComponents.js

      var rootComponents_parent;
      /**
       * The list of supported positions for root level components
       */

      var rootComponents_rootLevelComponentsPositions = ['top', 'bottom'];
      /**
       * Export the list of root level components by its position.
       */

      /* harmony default export */

      var config_rootComponents = {
        child: [],
        parent: (rootComponents_parent = {}, defineProperty_default()(rootComponents_parent, rootComponents_rootLevelComponentsPositions[0], []), defineProperty_default()(rootComponents_parent, rootComponents_rootLevelComponentsPositions[1], [{
          name: 'ActionBar',
          component: containers_ActionbarRootContainer
        }]), rootComponents_parent)
      }; // EXTERNAL MODULE: ./src/config/containerMap.js + 53 modules

      var containerMap = __webpack_require__(147); // CONCATENATED MODULE: ./src/core/RootComponents/RootComponent.js


      var RootComponent_RootComponent = function RootComponent(props) {
        var Container = containerMap["b"
        /* default */
        ][props.renderer] || props.component;
        return Container && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(Container, props);
      };

      RootComponent_RootComponent.defaultProps = {
        attributes: {},
        component: null,
        fieldId: '',
        id: '',
        logic: [],
        renderer: ''
      };
      RootComponent_RootComponent.propTypes = {
        attributes: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        component: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        fieldId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        id: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        logic: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        renderer: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string
      };
      /* harmony default export */

      var RootComponents_RootComponent = Object(Recompose["a"
      /* compose */
      ])(Object(withOverride["a"
      /* default */
      ])({
        overrideType: 'fieldContainer'
      }), Object(withVisibility["a"
      /* default */
      ])({
        type: 'root'
      }))(RootComponent_RootComponent); // CONCATENATED MODULE: ./src/core/RootComponents/helpers/rootComponents.js

      var rootComponents_ComponentLevel = {
        Child: 'child',
        Parent: 'parent'
      };
      var rootComponents_defaultEmptyRootComponentsObject = {
        parent: {
          top: [],
          bottom: []
        },
        child: []
      };

      var rootComponents_createRootComponent = function createRootComponent(children) {
        return function (rootComponent, index) {
          var childComponents = [];

          if (children) {
            childComponents = children.filter(function (_ref) {
              var childOf = _ref.childOf;
              return childOf === rootComponent.id;
            }).map(function (child) {
              var component = child.component;

              if (component === null) {
                child.component = createRootComponent(false)(child);
              }

              return child;
            });
          }

          var props = rootComponent.props || {};
          return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(RootComponents_RootComponent, extends_default()({
            key: index,
            component: rootComponent.component,
            childComponents: childComponents
          }, props));
        };
      };

      var rootComponents_getServerRootComponentsObject = function getServerRootComponentsObject(rootComponents) {
        return rootComponents.reduce(function (acc, serverRootComponent) {
          var attributes = serverRootComponent.attributes,
              id = serverRootComponent.id,
              fieldId = serverRootComponent.fieldId,
              renderer = serverRootComponent.renderer,
              logic = serverRootComponent.logic,
              _serverRootComponent$ = serverRootComponent.meta,
              meta = _serverRootComponent$ === void 0 ? {} : _serverRootComponent$,
              _serverRootComponent$2 = serverRootComponent.childOf,
              childOf = _serverRootComponent$2 === void 0 ? null : _serverRootComponent$2;
          var level = childOf === null ? rootComponents_ComponentLevel.Parent : rootComponents_ComponentLevel.Child;
          var rlc = {
            id: id,
            component: null,
            props: {
              id: id,
              fieldId: fieldId,
              attributes: attributes,
              logic: logic,
              renderer: renderer,
              childOf: childOf,
              meta: meta
            }
          };

          if (level === rootComponents_ComponentLevel.Parent) {
            acc[level][attributes.position].push(rlc);
          } else {
            acc[level].push(objectSpread_default()({}, rlc, {
              childOf: childOf
            }));
          }

          return acc;
        }, cloneDeep_default()(rootComponents_defaultEmptyRootComponentsObject));
      };

      var rootComponents_createDefaultRootComponentWithProps = function createDefaultRootComponentWithProps(_ref2) {
        var name = _ref2.name,
            component = _ref2.component;
        return {
          id: name,
          component: component,
          props: {}
        };
      };

      var rootComponents_getLocalRootComponents = function getLocalRootComponents(rootComponents) {
        var serverRootComponentsObject = rootComponents_getServerRootComponentsObject(rootComponents);
        var defaultRootComponentsWithProps = cloneDeep_default()(rootComponents_defaultEmptyRootComponentsObject);
        defaultRootComponentsWithProps.parent.top = config_rootComponents.parent.top.map(rootComponents_createDefaultRootComponentWithProps);
        defaultRootComponentsWithProps.parent.bottom = config_rootComponents.parent.bottom.map(rootComponents_createDefaultRootComponentWithProps);
        var rootComponentsList = cloneDeep_default()(rootComponents_defaultEmptyRootComponentsObject); // for top root level components, add the server root level components first

        rootComponentsList.parent.top = [].concat(toConsumableArray_default()(serverRootComponentsObject.parent.top), toConsumableArray_default()(defaultRootComponentsWithProps.parent.top)); // for bottom root level components, add the server root level components last

        rootComponentsList.parent.bottom = [].concat(toConsumableArray_default()(defaultRootComponentsWithProps.parent.bottom), toConsumableArray_default()(serverRootComponentsObject.parent.bottom)); // add children components

        rootComponentsList.child = [].concat(toConsumableArray_default()(defaultRootComponentsWithProps.child), toConsumableArray_default()(serverRootComponentsObject.child));
        var createRootComponentWithChildren = rootComponents_createRootComponent(rootComponentsList.child);
        var components = cloneDeep_default()(rootComponents_defaultEmptyRootComponentsObject);
        components.parent.top = rootComponentsList.parent.top.map(createRootComponentWithChildren);
        components.parent.bottom = rootComponentsList.parent.bottom.map(createRootComponentWithChildren);
        return components;
      }; // EXTERNAL MODULE: ./src/core/RootComponents/context/RootContext.js


      var RootContext = __webpack_require__(268); // CONCATENATED MODULE: ./src/core/RootComponents/context/RootProvider.js


      var RootProvider_RootProvider =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(RootProvider, _Component);

        function RootProvider(props) {
          var _this;

          classCallCheck_default()(this, RootProvider);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(RootProvider).call(this, props));
          var data = props.data;
          _this.state = {
            data: data,
            // eslint-disable-line react/no-unused-state
            // eslint-disable-next-line react/no-unused-state
            setData: function setData(obj) {
              _this.data = obj;
            }
          };
          return _this;
        }

        createClass_default()(RootProvider, [{
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate() {
            return false;
          }
        }, {
          key: "render",
          value: function render() {
            var children = this.props.children;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(RootContext["a"
            /* default */
            ].Provider, {
              value: this.state
            }, children);
          }
        }]);
        return RootProvider;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      RootProvider_RootProvider.defaultProps = {
        data: {}
      };
      RootProvider_RootProvider.propTypes = {
        children: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.node.isRequired,
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      };
      /* harmony default export */

      var context_RootProvider = RootProvider_RootProvider; // CONCATENATED MODULE: ./src/core/RootComponents/RootComponents.js

      var RootComponents_newSubmissionId = {};

      var RootComponents_getAttribute = function getAttribute(id, props) {
        return props.data.Submission ? props.data.Submission.attributes.find(function (o) {
          return o.id === id;
        }) : null;
      };

      var RootComponents_RootComponents =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(RootComponents, _Component);

        function RootComponents(_props) {
          var _this;

          classCallCheck_default()(this, RootComponents);
          _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(RootComponents).call(this, _props));
          defineProperty_default()(assertThisInitialized_default()(_this), "componentDidUpdate", function (prevProps, prevState) {
            var channel = _this.props.channel;

            if (_this.props.data.Submission) {
              // check for new submission attributes
              var NewSubmission = _this.props.data.Submission;
              var OldSubmission = prevProps.data.Submission ? prevProps.data.Submission : null;

              if (!isEqual_default()(NewSubmission, OldSubmission)) {
                // attributes or fields have changed, update the local formatic store
                var attributesById = keyBy_default()(NewSubmission.attributes, 'id');
                var fieldsById = keyBy_default()(NewSubmission.fields, 'id');

                _this.props.setDataSubmissionById(fieldsById, attributesById);

                _this.props.setDataSubmission(NewSubmission);

                _this.setState({
                  dataSubmission: objectSpread_default()({}, NewSubmission, {
                    attributesById: attributesById,
                    fieldsById: fieldsById
                  })
                }, _this.updateTokens); // re-map the page flow


                pageNavigation_mapPageFlow(_this.state, _this.props);

                if (OldSubmission && OldSubmission.id !== NewSubmission.id) {
                  _this.setState({
                    sessionStarted: false
                  });

                  _this.state.sessionStarted = false;
                  _this.initialPage = undefined;

                  _this.props.setDataSubmissionById({}, attributesById);

                  _this.props.setSubmissionCompletion(false);
                }
              }
            }

            if (_this.props.data.Form) {
              // check for new form attributes
              var NewForm = _this.props.data.Form;
              var OldForm = prevProps.data.Form ? prevProps.data.Form : null;

              if (!isEqual_default()(OldForm, NewForm)) {
                // form has changed within apollo, need to transform and re-save within formatic store
                var formDataById = {
                  fieldsById: keyBy_default()(NewForm.fields, 'id'),
                  pagesById: keyBy_default()(NewForm.pages, 'id'),
                  sectionsById: keyBy_default()(NewForm.sections, 'id')
                };
                var formData = objectSpread_default()({}, NewForm, formDataById);

                _this.props.storeDataForm(formData);

                _this.props.setDataFormById(formDataById.fieldsById, formDataById.sectionsById, formDataById.pagesById);

                _this.setState({
                  dataForm: formData
                });
              }
            }

            var finishedLoading = !_this.props.data.loading && prevProps.data.loading;

            if (finishedLoading) {
              // Apollo networkStatus 8 is congruent to CORS error
              if (_this.props.data.error && _this.props.data.networkStatus && _this.props.data.networkStatus === 8) {
                var error = "Origin ".concat(Object(utils["h"
                /* getOrigin */
                ])(), " is not within the list of allowed hosts.");

                _this.setState({
                  error: error
                });

                return;
              }

              if (isEmpty_default()(_this.props.data) || isEmpty_default()(_this.props.data.Form)) {
                var _error = 'Connection error: experience data cannot be retrieved.';

                _this.setState({
                  error: _error
                });

                return;
              }

              if (isEmpty_default()(_this.props.data.Form.pages)) {
                var _error2 = 'Form requires at least one page to render.';

                _this.setState({
                  error: _error2
                });

                return;
              }

              if (!_this.state.sessionStarted) {
                // Start the session
                var session = formData_startSession(prevProps, _this.props);

                if (session) {
                  RootComponents_newSubmissionId = session;
                }

                if (_this.props.submissionId) {
                  // Submission ID already set, session is ready
                  _this.setState({
                    sessionStarted: true
                  });
                } else {
                  // Submission ID prop attribute not set, set now
                  _this.props.setSubmissionIdReduxAction(Object.values(session)[0]);
                }

                return;
              }
            }

            var initializedSession = _this.state.sessionStarted && !prevState.sessionStarted;

            if (initializedSession) {
              // session has been properly initialized, ready to start loading the form
              if (!_this.initialPage) {
                // Navigate to first page
                _this.firstLoad();
              }

              _this.initializeRootComponents(_this.props);

              return;
            } // Check to see if currentFlow _within apollo_ updated (everything else depends on formatic store, so need to do this in two parts)


            var newFlow = RootComponents_getAttribute('currentFlow', _this.props);
            var oldFlow = RootComponents_getAttribute('currentFlow', prevProps);

            if (newFlow && !isEqual_default()(newFlow, oldFlow)) {
              // flow changed within apollo
              _this.props.setCurrentFlow(newFlow.value[channel]);

              return;
            } // Check to see if currentFlow _within formatic redux_ updated


            var thisCurrentFlow = _this.props.flow.current;
            var prevCurrentFlow = prevProps.flow.current;

            if (!isEqual_default()(thisCurrentFlow, prevCurrentFlow)) {
              // formatic flow object changed, check to see if user is on the right page
              if (_this.initializedFlow) {
                var exitPages = _this.props.data.Submission.attributes.find(function (o) {
                  return o.id === helpers_pageFlow["a"
                  /* Constants */
                  ].FlowChannelsExitPageKey;
                });

                var exitPage = get_default()(exitPages, "value[".concat(channel, "][").concat(_this.props.flow.current, "]"), false);

                if (exitPage) {
                  // User has previously come from the flow they are returning to, send them back to the page they came from
                  pageNavigation_goToPage(exitPage, _this.state.dataForm.pagesById, _this.props, _this.state);
                  return;
                }
              } // User navigating to flow for the first time, re-calculate the page navigation logic


              _this.pageNavigationLogic(navigation["a"
              /* NavigationDirection */
              ].NewFlow, undefined, undefined, true);

              _this.initializedFlow = true;
              return;
            } // Check to see if the current page updated from a subscription


            var newPage = RootComponents_getAttribute('currentPage', _this.props);
            var oldPage = RootComponents_getAttribute('currentPage', prevProps);

            if (newPage && newPage.type && newPage.type === 'subscription' && (!oldPage || newPage.value[channel].pageId !== oldPage.value[channel].pageId)) {
              // currentPage attribute changed from a subscription, need to navigate to the new page
              pageNavigation_goToPage(newPage.value[channel].pageId, _this.state.dataForm.pagesById, _this.props, _this.state);
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "updateTokens", function () {
            var getAllTokens = function getAllTokens(props) {
              var fields = get_default()(props, 'data.Form.fields', []);
              var sections = get_default()(props, 'data.Form.sections', []);
              var submissionFields = get_default()(props, 'data.Submission.fields', []);
              var formVariables = get_default()(props, 'data.Form.attributes.variables.form', {});
              var globalVariables = get_default()(props, 'data.Form.attributes.variables.global', {});
              return Object(tokens_tokens["a"
              /* default */
              ])(fields, sections, submissionFields, formVariables, globalVariables, props.formId);
            };

            var tokens = getAllTokens(_this.props);

            _this.props.setTokens(tokens);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "initializeAnalytics", function () {
            _this.analyticsInitialized = true;
            var _this$props = _this.props,
                channel = _this$props.channel,
                emitter = _this$props.emitter,
                environment = _this$props.environment,
                formId = _this$props.formId,
                submissionId = _this$props.submissionId;
            _this.sendAnalytics = Object(analytics["c"
            /* analyticsCallback */
            ])({
              submissionId: submissionId,
              formId: formId,
              branch: environment,
              channel: channel
            }, emitter);

            _this.sendAnalytics(analytics["a"
            /* AnalyticsEvents */
            ].FormInit, {
              pageId: _this.initialPage
            });
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "shouldCallPageNavigationFromNewProps", function (nextProps) {
            var fieldImpactingPageFlow = pageNavigation_getFieldImpactingPageFlow(get_default()(_this.state, 'dataSubmission.fieldsByIdDiff', {}), nextProps.fieldsImpactingPageFlow);
            var shouldCallPageNavigationLogic = false;
            var pageFlow; // checks if there is a field impacting page flow in nextProps

            if (fieldImpactingPageFlow && !isEmpty_default()(_this.state.dataSubmission.fieldsById) && _this.state.dataSubmission.fieldsById[fieldImpactingPageFlow]) {
              pageFlow = pageNavigation_mapPageFlow(_this.state, nextProps);
              var didPageFlowChange = !isEqual_default()(nextProps.pageFlow, pageFlow); // checks if the page flow changed

              if (didPageFlowChange) {
                // get new field's value that impacts the page flow
                var fieldImpactingPageFlowValue = get_default()(_this.state, "dataSubmission.fieldsById[".concat(fieldImpactingPageFlow, "].value")); // get new field's timestamp

                var fieldImpactingPageFlowRequestTimestamp = _this.state.dataSubmission.fieldsById[fieldImpactingPageFlow].requestTimestamp; // checks if this field id (fieldImpactingPageFlow) is the same of the last field that impacted the page flow

                var isTheSameField = isEqual_default()(fieldImpactingPageFlow, _this.lastFieldImpactingPageFlow); // checks if new field's value is different from previous value that impacted page flow

                var isDifferentValue = !isEqual_default()(fieldImpactingPageFlowValue, _this.lastFieldImpactingPageFlowValue); // checks if the new field's value has a more recent timestamp than the previous timestamp

                var isCurrentTimestampMoreRecentThanLastTimestamp = _this.lastFieldImpactingPageFlowRequestTimestamp < fieldImpactingPageFlowRequestTimestamp; // it should call pageNavigationLogic function from componentWillReceiveProps if
                // 1- it's not the same field
                // OR
                // 2- it is the same field with a different value and the timestamp of the new field's value is more recent

                if (!isTheSameField || isTheSameField && isDifferentValue && isCurrentTimestampMoreRecentThanLastTimestamp) {
                  // updates last field id
                  _this.lastFieldImpactingPageFlow = fieldImpactingPageFlow; // updates last field value

                  _this.lastFieldImpactingPageFlowValue = fieldImpactingPageFlowValue; // updates last field timestamp

                  _this.lastFieldImpactingPageFlowRequestTimestamp = fieldImpactingPageFlowRequestTimestamp;
                  shouldCallPageNavigationLogic = true;
                }
              }
            }

            return {
              shouldCallPageNavigationLogic: shouldCallPageNavigationLogic,
              fieldImpactingPageFlow: fieldImpactingPageFlow,
              pageFlow: pageFlow
            };
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "pageNavigationLogic", function () {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigation["a"
            /* NavigationDirection */
            ].Next;
            var pageFlowParam = arguments.length > 1 ? arguments[1] : undefined;
            var fieldImpactingPageFlow = arguments.length > 2 ? arguments[2] : undefined;
            var didFlowUpdate = arguments.length > 3 ? arguments[3] : undefined;
            var currentFlow = _this.props.flow.current;
            var currentPageId = formData_getCurrentPageId(_this.props.currentPage, _this.props.channel);
            var pageFlow = pageFlowParam || pageNavigation_mapPageFlow(_this.state, _this.props);
            var didPageFlowChange = !isEqual_default()(_this.props.pageFlow, pageFlow) || didFlowUpdate; // only validates the page if the direction is Next. It shouldn't show errors when trying to navigate Back

            if (!didPageFlowChange && direction === navigation["a"
            /* NavigationDirection */
            ].Next && !Object(navigation["b"
            /* pageValidation */
            ])(_this.props.visibleFields, _this.props.data.Form.attributes)) {
              // Only trigger page validation on next page (if pageFlow didn't change). User should be able to go to previous
              return false;
            } // only set navigateDirection after validating the page (otherwise it'll set it even when the page is invalid)


            _this.setState({
              navigateDirection: direction
            });

            var localFieldImpactingPageFlow = fieldImpactingPageFlow;

            if (didPageFlowChange && !localFieldImpactingPageFlow) {
              localFieldImpactingPageFlow = pageNavigation_getFieldImpactingPageFlow(get_default()(_this.state, 'dataSubmission.fieldsByIdDiff', {}), _this.props.fieldsImpactingPageFlow);
            }

            var newPageIndex = didFlowUpdate ? 0 // go to the start of the flow
            : pageNavigation_getNewPageIndex(_this.props, didPageFlowChange, pageFlow, direction, localFieldImpactingPageFlow, _this.state.dataForm.pageIdByFieldId);

            if (navigation["a"
            /* NavigationDirection */
            ][direction]) {
              _this.sendAnalytics(direction === navigation["a"
              /* NavigationDirection */
              ].Prev ? analytics["a"
              /* AnalyticsEvents */
              ].PrevPage : analytics["a"
              /* AnalyticsEvents */
              ].NextPage, {
                to: pageFlow[currentFlow][newPageIndex],
                from: currentPageId
              });

              pageNavigation_triggerNextPageEvent(direction, currentPageId, pageFlow[currentFlow][newPageIndex], _this.props.emitter);
            }

            pageNavigation_goToPage(pageFlow[currentFlow][newPageIndex], _this.state.dataForm.pagesById, _this.props, _this.state);

            if (direction === navigation["a"
            /* NavigationDirection */
            ].NewFlow) {
              return true;
            } // if pageFlow was not change and if the currentPage is the last page in pageFlow, then submit it


            var nextPageId = pageFlow[currentFlow][pageFlow[currentFlow].indexOf(currentPageId) + 1];
            var isSubmitPage = nextPageId ? get_default()(_this.state.dataForm.pagesById[nextPageId], 'attributes.isCompletionPage', false) : pageFlow[currentFlow].length - 1 === pageFlow[currentFlow].indexOf(currentPageId);
            var isSubmitted = get_default()(_this.state.dataSubmission, 'attributesById.submit', false);

            if (!didPageFlowChange && isSubmitPage && !isSubmitted && direction === navigation["a"
            /* NavigationDirection */
            ].Next) {
              var submitResult = _this.submitFormLogic(!didPageFlowChange);

              if (submitResult) {
                // @todo when we dont have completionPage we should display a generic thank you page
                formData_finishSession(_this.props);
              }
            }

            return true;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "firstLoad", function () {
            var _this$props2 = _this.props,
                channel = _this$props2.channel,
                _this$props2$data = _this$props2.data,
                formId = _this$props2$data.Form.id,
                _this$props2$data$Sub = _this$props2$data.Submission,
                attributes = _this$props2$data$Sub.attributes,
                submissionId = _this$props2$data$Sub.id,
                subscribeToMore = _this$props2$data.subscribeToMore; // Set flow

            var formFlows = keyBy_default()(get_default()(_this.props, 'data.Form.attributes.flow', []), 'name');

            if (Object.keys(formFlows).length > 0) {
              _this.props.setFormFlows(formFlows);
            }

            var currentFlowAttr = attributes.find(function (o) {
              return o.id === helpers_pageFlow["a"
              /* Constants */
              ].FlowAttributeKey;
            });
            var currentFlow = helpers_pageFlow["a"
            /* Constants */
            ].DefaultFlow;

            if (currentFlowAttr && currentFlowAttr.value[channel]) {
              // Flow has been previously set for this channel, update within redux
              currentFlow = currentFlowAttr.value[channel];
            }

            _this.props.setCurrentFlow(currentFlow);

            var pageFlow = pageNavigation_mapPageFlow(_this.state, _this.props);
            var serverCurrentPage = RootComponents_getAttribute('currentPage', _this.props);

            if (serverCurrentPage && serverCurrentPage.value[channel]) {
              pageNavigation_goToPage(serverCurrentPage.value[channel].pageId, _this.state.dataForm.pagesById, _this.props, _this.state, false);
            } else {
              var _pageFlow$currentFlow = slicedToArray_default()(pageFlow[currentFlow], 1);

              _this.initialPage = _pageFlow$currentFlow[0];
              pageNavigation_goToPage(_this.initialPage, _this.state.dataForm.pagesById, _this.props, _this.state);
            } // Initialize the subscriptions


            _this.fieldSubscription = subscribeToMore(subscriptions_fieldsSubscribeToMore(submissionId));
            _this.attributeSubscription = subscribeToMore(subscriptions_attributesSubscribeToMore(submissionId, formId)); // Initialize the analytics

            _this.initializeAnalytics();
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "navigate", function (direction) {
            return _this.pageNavigationLogic(direction);
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "submitForm", function () {
            if (_this.submitFormLogic(false)) {
              formData_finishSession(_this.props);
            }
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "submitFormLogic", function (pageFlowDidntChange) {
            if (!pageFlowDidntChange) {
              // double check if the pageFlow didn't change meanwhile
              var pageFlow = pageNavigation_mapPageFlow(_this.state, _this.props);

              if (!isEqual_default()(_this.props.pageFlow, pageFlow)) {
                // the pageFlow was changed, therefore navigate to the next valid page
                _this.pageNavigationLogic(navigation["a"
                /* NavigationDirection */
                ].Next, pageFlow);

                return false;
              }
            }

            if (!Object(navigation["b"
            /* pageValidation */
            ])(_this.props.visibleFields, _this.props.data.Form.attributes)) {
              return false;
            }

            _this.sendAnalytics('onFormComplete', {
              pageId: formData_getCurrentPageId(_this.props.currentPage, _this.props.channel)
            });

            _this.props.emitter.emit(constants["Events"].SessionComplete, {
              submissionId: _this.props.submissionId
            }); // redirect the user


            var _this$props$data$Form = _this.props.data.Form.attributes,
                _this$props$data$Form2 = _this$props$data$Form.redirectOnCompletion,
                redirectOnCompletion = _this$props$data$Form2 === void 0 ? false : _this$props$data$Form2,
                _this$props$data$Form3 = _this$props$data$Form.redirectOnCompletionUrl,
                redirectOnCompletionUrl = _this$props$data$Form3 === void 0 ? '' : _this$props$data$Form3;

            if (redirectOnCompletion && redirectOnCompletionUrl) {
              window.location.href = redirectOnCompletionUrl;
            }

            _this.props.setSubmissionCompletion(true);

            return true;
          });
          defineProperty_default()(assertThisInitialized_default()(_this), "initializeRootComponents", function (nextProps) {
            // do not initialize if it was already initialized or if nextProps.Form is empty or if data.Form.rootComponents is not defined
            if (_this.state.rootComponents !== null || isEmpty_default()(nextProps.data.Form) || nextProps.data.Form.rootComponents === undefined) {
              return;
            }

            _this.setState({
              rootComponents: rootComponents_getLocalRootComponents(nextProps.data.Form.rootComponents)
            }, function () {
              // root components initialized, finally ready to render
              _this.setState({
                ready: true
              });
            });
          });
          _this.lastFieldImpactingPageFlowRequestTimestamp = 0;
          _this.analyticsInitialized = false;
          _this.sendAnalytics = noop_default.a;
          _this.state = {
            dataForm: {},
            dataSubmission: formData_generateDataSubmission(_props),
            dataLoading: _props.data.loading,
            navigateDirection: null,
            ready: false,
            rootComponents: null,
            sessionStarted: false
          };
          return _this;
        }

        createClass_default()(RootComponents, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.props.registerNavigate(this.navigate);
            this.props.registerSubmitForm(this.submitForm);
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            // if the value is not reset to default, then if the component is recreated, the values will persist
            // and a previous session ID will be recycled causing rendering issues
            RootComponents_newSubmissionId = {};
          }
          /**
           * Update the tokens within the formatic redux store.
           */

        }, {
          key: "render",
          value: function render() {
            if (this.state.error) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("p", null, this.state.error);
            } else if (!this.state.ready) {
              return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_FormLoadingContainer, null);
            }

            var data = objectSpread_default()({}, pick_default()(this.props.data, ['variables', 'subscribeToMore', 'Form']));
            var hasCalculations;

            try {
              hasCalculations = this.props.data.Form.calculations.length > 0;
            } catch (err) {
              hasCalculations = false;
            } // data.Form = this.props.data.Form;


            formData_setOrderedFields(this.props); // const formLoading = get(this.state.dataSubmission, 'attributesById.formLoading.value', false);

            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(context_RootProvider, {
              data: data
            }, !isEmpty_default()(this.state.rootComponents.parent.top) && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-root-components__container formatic-root-components__container--top"
            }, this.state.rootComponents.parent.top), hasCalculations && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_CalculatedFieldsContainer, {
              calculations: this.props.data.Form.calculations
            }), external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(containers_FormContainer, {
              data: data,
              dataSubmission: this.props.data.Submission,
              dataLoading: this.state.dataLoading,
              navigateDirection: this.state.navigateDirection
            }), !isEmpty_default()(this.state.rootComponents.parent.bottom) && external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic-root-components__container formatic-root-components__container--bottom"
            }, this.state.rootComponents.parent.bottom));
          }
        }]);
        return RootComponents;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      RootComponents_RootComponents.defaultProps = {
        rootComponents: [],
        data: {},
        error: null,
        formLoading: null,
        environment: '',
        // default props from connect
        setDataFormById: noop_default.a,
        setDataSubmissionById: noop_default.a,
        setDataSubmission: noop_default.a,
        setFormLoading: noop_default.a,
        setOrderedFields: noop_default.a,
        setSubmissionIdReduxAction: noop_default.a,
        setTokens: noop_default.a,
        storeFieldsImpactingPageFlow: noop_default.a,
        // props from connect formatic store
        channel: '',
        currentPage: {},
        emitter: {},
        orderedFields: [],
        submissionId: '',
        fieldsImpactingPageFlow: {},
        registerNavigate: noop_default.a,
        registerSubmitForm: noop_default.a,
        setCurrentPage: noop_default.a,
        setPageFlow: noop_default.a,
        setSubmissionCompletion: noop_default.a,
        pageFlow: helpers_pageFlow["a"
        /* Constants */
        ].DefaultPageFlow,
        visibleFields: {},
        submissionAttribute: noop_default.a,
        tokens: {},
        // props from getContext
        updateSubmissionAttribute: noop_default.a
      };
      RootComponents_RootComponents.propTypes = {
        formId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.number.isRequired,
        rootComponents: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        // props from withFormData
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        environment: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        error: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        // props from connect formatic store
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        currentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        emitter: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        orderedFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string),
        fieldsImpactingPageFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        flow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.shape({
          current: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string.isRequired,
          flows: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object.isRequired
        }).isRequired,
        // props from connect dispatch
        setCurrentFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        setDataFormById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setDataSubmissionById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setDataSubmission: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setFormLoading: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setOrderedFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setSubmissionIdReduxAction: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setTokens: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        storeFieldsImpactingPageFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        submissionId: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        formLoading: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.bool,
        submissionAttribute: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        tokens: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // props from connect dispatch
        registerNavigate: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        registerSubmitForm: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setCurrentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setFormFlows: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        setPageFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setSubmissionCompletion: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        storeDataForm: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func.isRequired,
        pageFlow: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        visibleFields: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // props from getContext
        updateSubmissionAttribute: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };

      var RootComponents_mapStateToProps = function mapStateToProps(_ref) {
        var _ref$formatic = _ref.formatic,
            channel = _ref$formatic.channel,
            currentPage = _ref$formatic.currentPage,
            emitter = _ref$formatic.emitter,
            fieldsImpactingPageFlow = _ref$formatic.fieldsImpactingPageFlow,
            flow = _ref$formatic.flow,
            formLoading = _ref$formatic.formLoading,
            orderedFields = _ref$formatic.orderedFields,
            pageFlow = _ref$formatic.pageFlow,
            submissionId = _ref$formatic.submissionId,
            visibleFields = _ref$formatic.visibleFields,
            tokens = _ref$formatic.tokens;
        return {
          channel: channel,
          currentPage: currentPage,
          emitter: emitter,
          fieldsImpactingPageFlow: fieldsImpactingPageFlow,
          flow: flow,
          formLoading: formLoading,
          orderedFields: orderedFields,
          pageFlow: pageFlow,
          submissionId: submissionId,
          visibleFields: visibleFields,
          tokens: tokens
        };
      };

      var RootComponents_mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
          registerNavigate: function registerNavigate(navigate) {
            return dispatch(Object(core_actions["H"
            /* registerNavigate */
            ])(navigate));
          },
          registerSubmitForm: function registerSubmitForm(submitForm) {
            return dispatch(Object(core_actions["I"
            /* registerSubmitForm */
            ])(submitForm));
          },
          setCurrentFlow: function setCurrentFlow(name) {
            return dispatch(Object(core_actions["N"
            /* setCurrentFlow */
            ])(name));
          },
          setCurrentPage: function setCurrentPage(pageId, channel) {
            var requestTimestamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
            return dispatch(Object(core_actions["O"
            /* setCurrentPage */
            ])(pageId, channel, requestTimestamp));
          },
          setDataFormById: function setDataFormById(formFieldsById, sectionsById, pagesById) {
            return dispatch(Object(core_actions["P"
            /* setDataFormById */
            ])(formFieldsById, sectionsById, pagesById));
          },
          setDataSubmission: function setDataSubmission(submission) {
            return dispatch(Object(core_actions["R"
            /* setDataSubmission */
            ])(submission));
          },
          setDataSubmissionById: function setDataSubmissionById(submissionFieldsById, submissionAttributesById) {
            return dispatch(Object(core_actions["S"
            /* setDataSubmissionById */
            ])(submissionFieldsById, submissionAttributesById));
          },
          setFormLoading: function setFormLoading(loading) {
            return dispatch(Object(core_actions["V"
            /* setFormLoading */
            ])(loading));
          },
          setFormFlows: function setFormFlows(flows) {
            return dispatch(Object(core_actions["U"
            /* setFormFlows */
            ])(flows));
          },
          setOrderedFields: function setOrderedFields(orderedFields) {
            return dispatch(Object(core_actions["X"
            /* setOrderedFields */
            ])(orderedFields));
          },
          setPageFlow: function setPageFlow(pageFlow) {
            return dispatch(Object(core_actions["Y"
            /* setPageFlow */
            ])(pageFlow));
          },
          setSubmissionIdReduxAction: function setSubmissionIdReduxAction(id) {
            return dispatch(Object(core_actions["Aa"
            /* setSubmissionId */
            ])(id));
          },
          setTokens: function setTokens(tokens) {
            dispatch(Object(core_actions["Ba"
            /* setTokens */
            ])(tokens));
          },
          storeDataForm: function storeDataForm(dataForm) {
            return dispatch(Object(core_actions["Da"
            /* storeDataForm */
            ])(dataForm));
          },
          storeFieldsImpactingPageFlow: function storeFieldsImpactingPageFlow(fields) {
            return dispatch(Object(core_actions["Ea"
            /* storeFieldsImpactingPageFlow */
            ])(fields));
          },
          setSubmissionCompletion: function setSubmissionCompletion(submissionCompleted) {
            return dispatch(Object(core_actions["Z"
            /* setSubmissionCompletion */
            ])(submissionCompleted));
          }
        };
      };
      /* harmony default export */


      var core_RootComponents_RootComponents = Object(react_apollo_browser_umd["compose"])(Object(es["a"
      /* connect */
      ])(RootComponents_mapStateToProps, RootComponents_mapDispatchToProps), Object(react_apollo_browser_umd["graphql"])(form_getFullFormWithDetailsQuery, {
        options: function options(_ref2) {
          var channel = _ref2.channel,
              config = _ref2.config,
              environment = _ref2.environment,
              formId = _ref2.formId,
              submissionId = _ref2.submissionId;
          return {
            fetchPolicy: 'network-only',
            variables: {
              formId: formId,
              branch: environment,
              channel: channel,
              config: config,
              initialValues: src_config["a"
              /* default */
              ].getInitialValues(),
              submissionId: submissionId || RootComponents_newSubmissionId[formId]
            }
          };
        }
      }), Object(react_apollo_browser_umd["graphql"])(graphql_submission["c"
      /* setSubmissionValuesMutation */
      ], {
        props: function props(_ref3) {
          var mutate = _ref3.mutate,
              ownProps = _ref3.ownProps;
          return {
            submissionAttribute: Object(mutations["a"
            /* submissionAttribute */
            ])(mutate, ownProps, RootComponents_newSubmissionId),
            submissionField: Object(mutations["b"
            /* submissionField */
            ])(mutate, ownProps, RootComponents_newSubmissionId)
          };
        }
      }), Object(Recompose["c"
      /* withContext */
      ])({
        updateSubmissionAttribute: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        updateSubmissionField: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        overrides: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object
      }, function (props) {
        return {
          updateSubmissionAttribute: props.submissionAttribute,
          updateSubmissionField: props.submissionField,
          overrides: props.overrides
        };
      }))(RootComponents_RootComponents); // CONCATENATED MODULE: ./src/core/RootComponents/index.js
      // CONCATENATED MODULE: ./src/App.js

      var App_App =
      /*#__PURE__*/
      function (_Component) {
        inherits_default()(App, _Component);

        function App() {
          var _getPrototypeOf2;

          var _this;

          classCallCheck_default()(this, App);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(App)).call.apply(_getPrototypeOf2, [this].concat(args)));
          defineProperty_default()(assertThisInitialized_default()(_this), "componentDidUpdate", function (prevProps) {
            if (_this.props.data.Form) {
              // check for new form attributes
              var oldForm = prevProps.data.Form || null;

              if (!isEqual_default()(oldForm, _this.props.data.Form)) {
                var form = _this.props.data.Form; // form has changed within apollo, need to transform and re-save within formatic store

                var fieldsById = keyBy_default()(form.fields, 'id');
                var formDataById = {
                  fieldsById: fieldsById,
                  pagesById: keyBy_default()(form.pages, 'id'),
                  sectionsById: keyBy_default()(form.sections, 'id')
                };
                var formData = objectSpread_default()({}, form, formDataById);
                var machineTagsToFieldIds = {};
                Object.keys(fieldsById).forEach(function (fieldId) {
                  var machineTag = get_default()(fieldsById, "".concat(fieldId, ".attributes.tag"), null);

                  if (machineTag !== null) {
                    machineTagsToFieldIds[machineTag] = fieldId;
                  }
                });

                _this.props.storeDataForm(formData);

                _this.props.setDataFormById(formDataById.fieldsById, formDataById.sectionsById, formDataById.pagesById);

                _this.props.setDataMachineTagsToFieldIds(machineTagsToFieldIds); // Set InitialValues with Populated fields


                var initialValues = cloneDeep_default()(_this.props.propsToLoad.initialValues);

                if (initialValues && !isEmpty_default()(initialValues)) {
                  var populateValues = {};
                  Object.keys(initialValues).forEach(function (key) {
                    var field = form.fields.find(function (f) {
                      return key === f.id || key === f.attributes.tag;
                    });

                    if (typeof field !== 'undefined') {
                      populateValues[field.id] = {
                        id: field.id,
                        value: initialValues[key]
                      };
                    }
                  });
                  Object.keys(initialValues).forEach(function (key) {
                    var field = form.fields.find(function (f) {
                      return key === f.id || key === f.attributes.tag;
                    });

                    if (typeof field !== 'undefined') {
                      var fieldsToPopulate = Object(populate["a"
                      /* getFieldsToBePopulated */
                      ])(objectSpread_default()({}, field.attributes, {
                        myFieldsById: formDataById.fieldsById,
                        mySubmissionFieldsById: populateValues
                      }), field.id, initialValues[key]);
                      fieldsToPopulate.forEach(function (fieldToPopulate) {
                        field = form.fields.find(function (f) {
                          return fieldToPopulate.id === f.id;
                        });

                        if (typeof field !== 'undefined') {
                          initialValues[field.attributes.tag] = fieldToPopulate.value;
                          populateValues[field.id] = {
                            id: field.id,
                            value: fieldToPopulate.value
                          };
                        }
                      });
                    }
                  });
                } // Store in config to be used when we call getSubmission in GraphQL


                src_config["a"
                /* default */
                ].setConfigFromProps(objectSpread_default()({}, src_config["a"
                /* default */
                ].getConfig(), {
                  initialValues: initialValues
                })); // Store initial values in the local redux store to later query against directly

                var localInitialValues = Object.keys(initialValues).map(function (key) {
                  return {
                    id: key,
                    value: initialValues[key]
                  };
                });
                _this.props.propsToLoad.initialValues = initialValues;

                _this.props.setInitialValues(localInitialValues);
              }
            }
          });
          return _this;
        }

        createClass_default()(App, [{
          key: "render",
          value: function render() {
            var _this$props = this.props,
                bodyClass = _this$props.bodyClass,
                channel = _this$props.channel,
                currentPage = _this$props.currentPage,
                overrides = _this$props.overrides,
                propsToLoad = _this$props.propsToLoad,
                rootComponents = _this$props.rootComponents;
            var activePage = channel && currentPage && currentPage[channel] ? currentPage[channel].pageId : false;
            return external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement("div", {
              className: "formatic formatic--".concat(propsToLoad.theme, " ").concat(bodyClass),
              "data-current-page": activePage
            }, external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(core_RootComponents_RootComponents, extends_default()({}, propsToLoad, {
              overrides: overrides,
              rootComponents: rootComponents
            })));
          }
        }]);
        return App;
      }(external_root_React_commonjs2_react_commonjs_react_amd_react_["Component"]);

      App_App.defaultProps = {
        bodyClass: '',
        channel: '',
        currentPage: {},
        overrides: {},
        propsToLoad: {},
        rootComponents: [],
        // props from withFormData
        data: {},
        mySubmissionFieldsById: {},
        // props from connect dispatch
        storeDataForm: noop_default.a,
        setDataFormById: noop_default.a,
        setInitialValues: noop_default.a,
        setDataMachineTagsToFieldIds: noop_default.a
      };
      App_App.propTypes = {
        bodyClass: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        channel: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.string,
        currentPage: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        overrides: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        propsToLoad: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        rootComponents: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.array,
        // props from withFormData
        data: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        mySubmissionFieldsById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.object,
        // props from connect dispatch
        storeDataForm: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setDataFormById: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setInitialValues: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func,
        setDataMachineTagsToFieldIds: external_root_PropTypes_commonjs2_prop_types_commonjs_prop_types_amd_prop_types_default.a.func
      };

      var App_mapStateToProps = function mapStateToProps(_ref) {
        var _ref$formatic = _ref.formatic,
            bodyClass = _ref$formatic.bodyClass,
            channel = _ref$formatic.channel,
            currentPage = _ref$formatic.currentPage,
            fieldsById = _ref$formatic.data.submission.fieldsById;
        return {
          bodyClass: bodyClass.join(' '),
          channel: channel,
          currentPage: currentPage,
          mySubmissionFieldsById: fieldsById
        };
      };

      var App_mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
          setInitialValues: function setInitialValues(values) {
            return dispatch(Object(core_actions["W"
            /* setInitialValues */
            ])(values));
          },
          storeDataForm: function storeDataForm(dataForm) {
            return dispatch(Object(core_actions["Da"
            /* storeDataForm */
            ])(dataForm));
          },
          setDataFormById: function setDataFormById(formFieldsById, sectionsById, pagesById) {
            return dispatch(Object(core_actions["P"
            /* setDataFormById */
            ])(formFieldsById, sectionsById, pagesById));
          },
          setDataMachineTagsToFieldIds: function setDataMachineTagsToFieldIds(machineTagsToFieldIds) {
            return dispatch(Object(core_actions["Q"
            /* setDataMachineTagsToFieldIds */
            ])(machineTagsToFieldIds));
          }
        };
      };
      /* harmony default export */


      var src_App = __webpack_exports__["a"] = Object(react_apollo_browser_umd["compose"])(Object(es["a"
      /* connect */
      ])(App_mapStateToProps, App_mapDispatchToProps), Object(react_apollo_browser_umd["graphql"])(form_getFormQuery, {
        options: function options(_ref2) {
          var propsToLoad = _ref2.propsToLoad;
          return {
            fetchPolicy: 'network-only',
            variables: {
              formId: propsToLoad.formId,
              branch: propsToLoad.environment,
              channel: propsToLoad.channel,
              config: propsToLoad.config
            }
          };
        }
      }))(App_App);
      /***/
    },
    /* 668 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseDifference = __webpack_require__(716),
          baseFlatten = __webpack_require__(320),
          baseRest = __webpack_require__(490),
          isArrayLikeObject = __webpack_require__(496);
      /**
       * Creates an array of `array` values not included in the other given arrays
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. The order and references of result values are
       * determined by the first array.
       *
       * **Note:** Unlike `_.pullAll`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.without, _.xor
       * @example
       *
       * _.difference([2, 1], [2, 3]);
       * // => [1]
       */


      var difference = baseRest(function (array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
      });
      module.exports = difference;
      /***/
    },
    /* 669 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayReduce = __webpack_require__(718),
          baseEach = __webpack_require__(444),
          baseIteratee = __webpack_require__(202),
          baseReduce = __webpack_require__(717),
          isArray = __webpack_require__(55);
      /**
       * Reduces `collection` to a value which is the accumulated result of running
       * each element in `collection` thru `iteratee`, where each successive
       * invocation is supplied the return value of the previous. If `accumulator`
       * is not given, the first element of `collection` is used as the initial
       * value. The iteratee is invoked with four arguments:
       * (accumulator, value, index|key, collection).
       *
       * Many lodash methods are guarded to work as iteratees for methods like
       * `_.reduce`, `_.reduceRight`, and `_.transform`.
       *
       * The guarded methods are:
       * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
       * and `sortBy`
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @returns {*} Returns the accumulated value.
       * @see _.reduceRight
       * @example
       *
       * _.reduce([1, 2], function(sum, n) {
       *   return sum + n;
       * }, 0);
       * // => 3
       *
       * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
       *   (result[value] || (result[value] = [])).push(key);
       *   return result;
       * }, {});
       * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
       */


      function reduce(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduce : baseReduce,
            initAccum = arguments.length < 3;
        return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
      }

      module.exports = reduce;
      /***/
    },
    /* 670 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _tooltip = __webpack_require__(312);

      var _tooltip2 = _interopRequireDefault(_tooltip);

      var _warning = __webpack_require__(310);

      var _warning2 = _interopRequireDefault(_warning);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var Popover = function (_React$Component) {
        (0, _inherits3['default'])(Popover, _React$Component);

        function Popover() {
          (0, _classCallCheck3['default'])(this, Popover);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));

          _this.saveTooltip = function (node) {
            _this.tooltip = node;
          };

          return _this;
        }

        (0, _createClass3['default'])(Popover, [{
          key: 'getPopupDomNode',
          value: function getPopupDomNode() {
            return this.tooltip.getPopupDomNode();
          }
        }, {
          key: 'getOverlay',
          value: function getOverlay() {
            var _props = this.props,
                title = _props.title,
                prefixCls = _props.prefixCls,
                content = _props.content;
            (0, _warning2['default'])(!('overlay' in this.props), 'Popover[overlay] is removed, please use Popover[content] instead, ' + 'see: https://u.ant.design/popover-content');
            return React.createElement('div', null, title && React.createElement('div', {
              className: prefixCls + '-title'
            }, title), React.createElement('div', {
              className: prefixCls + '-inner-content'
            }, content));
          }
        }, {
          key: 'render',
          value: function render() {
            var props = (0, _extends3['default'])({}, this.props);
            delete props.title;
            return React.createElement(_tooltip2['default'], (0, _extends3['default'])({}, props, {
              ref: this.saveTooltip,
              overlay: this.getOverlay()
            }));
          }
        }]);
        return Popover;
      }(React.Component);

      exports['default'] = Popover;
      Popover.defaultProps = {
        prefixCls: 'ant-popover',
        placement: 'top',
        transitionName: 'zoom-big',
        trigger: 'hover',
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        overlayStyle: {}
      };
      module.exports = exports['default'];
      /***/
    },
    /* 671 */

    /***/
    function (module, exports, __webpack_require__) {
      var debounce = __webpack_require__(35),
          isObject = __webpack_require__(97);
      /** Error message constants. */


      var FUNC_ERROR_TEXT = 'Expected a function';
      /**
       * Creates a throttled function that only invokes `func` at most once per
       * every `wait` milliseconds. The throttled function comes with a `cancel`
       * method to cancel delayed `func` invocations and a `flush` method to
       * immediately invoke them. Provide `options` to indicate whether `func`
       * should be invoked on the leading and/or trailing edge of the `wait`
       * timeout. The `func` is invoked with the last arguments provided to the
       * throttled function. Subsequent calls to the throttled function return the
       * result of the last `func` invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the throttled function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.throttle` and `_.debounce`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to throttle.
       * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=true]
       *  Specify invoking on the leading edge of the timeout.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new throttled function.
       * @example
       *
       * // Avoid excessively updating the position while scrolling.
       * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
       *
       * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
       * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
       * jQuery(element).on('click', throttled);
       *
       * // Cancel the trailing throttled invocation.
       * jQuery(window).on('popstate', throttled.cancel);
       */

      function throttle(func, wait, options) {
        var leading = true,
            trailing = true;

        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        if (isObject(options)) {
          leading = 'leading' in options ? !!options.leading : leading;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }

        return debounce(func, wait, {
          'leading': leading,
          'maxWait': wait,
          'trailing': trailing
        });
      }

      module.exports = throttle;
      /***/
    },
    /* 672 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseClone = __webpack_require__(323);
      /** Used to compose bitmasks for cloning. */


      var CLONE_SYMBOLS_FLAG = 4;
      /**
       * Creates a shallow clone of `value`.
       *
       * **Note:** This method is loosely based on the
       * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
       * and supports cloning arrays, array buffers, booleans, date objects, maps,
       * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
       * arrays. The own enumerable properties of `arguments` objects are cloned
       * as plain objects. An empty object is returned for uncloneable values such
       * as error objects, functions, DOM nodes, and WeakMaps.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to clone.
       * @returns {*} Returns the cloned value.
       * @see _.cloneDeep
       * @example
       *
       * var objects = [{ 'a': 1 }, { 'b': 2 }];
       *
       * var shallow = _.clone(objects);
       * console.log(shallow[0] === objects[0]);
       * // => true
       */

      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }

      module.exports = clone;
      /***/
    },
    /* 673 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var has = Object.prototype.hasOwnProperty,
          prefix = '~';
      /**
       * Constructor to create a storage for our `EE` objects.
       * An `Events` instance is a plain object whose properties are event names.
       *
       * @constructor
       * @private
       */

      function Events() {} //
      // We try to not inherit from `Object.prototype`. In some engines creating an
      // instance in this way is faster than calling `Object.create(null)` directly.
      // If `Object.create(null)` is not supported we prefix the event names with a
      // character to make sure that the built-in object properties are not
      // overridden or used as an attack vector.
      //


      if (Object.create) {
        Events.prototype = Object.create(null); //
        // This hack is needed because the `__proto__` property is still inherited in
        // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
        //

        if (!new Events().__proto__) prefix = false;
      }
      /**
       * Representation of a single event listener.
       *
       * @param {Function} fn The listener function.
       * @param {*} context The context to invoke the listener with.
       * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
       * @constructor
       * @private
       */


      function EE(fn, context, once) {
        this.fn = fn;
        this.context = context;
        this.once = once || false;
      }
      /**
       * Add a listener for a given event.
       *
       * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
       * @param {(String|Symbol)} event The event name.
       * @param {Function} fn The listener function.
       * @param {*} context The context to invoke the listener with.
       * @param {Boolean} once Specify if the listener is a one-time listener.
       * @returns {EventEmitter}
       * @private
       */


      function addListener(emitter, event, fn, context, once) {
        if (typeof fn !== 'function') {
          throw new TypeError('The listener must be a function');
        }

        var listener = new EE(fn, context || emitter, once),
            evt = prefix ? prefix + event : event;
        if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);else emitter._events[evt] = [emitter._events[evt], listener];
        return emitter;
      }
      /**
       * Clear event by name.
       *
       * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
       * @param {(String|Symbol)} evt The Event name.
       * @private
       */


      function clearEvent(emitter, evt) {
        if (--emitter._eventsCount === 0) emitter._events = new Events();else delete emitter._events[evt];
      }
      /**
       * Minimal `EventEmitter` interface that is molded against the Node.js
       * `EventEmitter` interface.
       *
       * @constructor
       * @public
       */


      function EventEmitter() {
        this._events = new Events();
        this._eventsCount = 0;
      }
      /**
       * Return an array listing the events for which the emitter has registered
       * listeners.
       *
       * @returns {Array}
       * @public
       */


      EventEmitter.prototype.eventNames = function eventNames() {
        var names = [],
            events,
            name;
        if (this._eventsCount === 0) return names;

        for (name in events = this._events) {
          if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
        }

        if (Object.getOwnPropertySymbols) {
          return names.concat(Object.getOwnPropertySymbols(events));
        }

        return names;
      };
      /**
       * Return the listeners registered for a given event.
       *
       * @param {(String|Symbol)} event The event name.
       * @returns {Array} The registered listeners.
       * @public
       */


      EventEmitter.prototype.listeners = function listeners(event) {
        var evt = prefix ? prefix + event : event,
            handlers = this._events[evt];
        if (!handlers) return [];
        if (handlers.fn) return [handlers.fn];

        for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
          ee[i] = handlers[i].fn;
        }

        return ee;
      };
      /**
       * Return the number of listeners listening to a given event.
       *
       * @param {(String|Symbol)} event The event name.
       * @returns {Number} The number of listeners.
       * @public
       */


      EventEmitter.prototype.listenerCount = function listenerCount(event) {
        var evt = prefix ? prefix + event : event,
            listeners = this._events[evt];
        if (!listeners) return 0;
        if (listeners.fn) return 1;
        return listeners.length;
      };
      /**
       * Calls each of the listeners registered for a given event.
       *
       * @param {(String|Symbol)} event The event name.
       * @returns {Boolean} `true` if the event had listeners, else `false`.
       * @public
       */


      EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return false;
        var listeners = this._events[evt],
            len = arguments.length,
            args,
            i;

        if (listeners.fn) {
          if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

          switch (len) {
            case 1:
              return listeners.fn.call(listeners.context), true;

            case 2:
              return listeners.fn.call(listeners.context, a1), true;

            case 3:
              return listeners.fn.call(listeners.context, a1, a2), true;

            case 4:
              return listeners.fn.call(listeners.context, a1, a2, a3), true;

            case 5:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;

            case 6:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
          }

          for (i = 1, args = new Array(len - 1); i < len; i++) {
            args[i - 1] = arguments[i];
          }

          listeners.fn.apply(listeners.context, args);
        } else {
          var length = listeners.length,
              j;

          for (i = 0; i < length; i++) {
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

            switch (len) {
              case 1:
                listeners[i].fn.call(listeners[i].context);
                break;

              case 2:
                listeners[i].fn.call(listeners[i].context, a1);
                break;

              case 3:
                listeners[i].fn.call(listeners[i].context, a1, a2);
                break;

              case 4:
                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                break;

              default:
                if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                  args[j - 1] = arguments[j];
                }
                listeners[i].fn.apply(listeners[i].context, args);
            }
          }
        }

        return true;
      };
      /**
       * Add a listener for a given event.
       *
       * @param {(String|Symbol)} event The event name.
       * @param {Function} fn The listener function.
       * @param {*} [context=this] The context to invoke the listener with.
       * @returns {EventEmitter} `this`.
       * @public
       */


      EventEmitter.prototype.on = function on(event, fn, context) {
        return addListener(this, event, fn, context, false);
      };
      /**
       * Add a one-time listener for a given event.
       *
       * @param {(String|Symbol)} event The event name.
       * @param {Function} fn The listener function.
       * @param {*} [context=this] The context to invoke the listener with.
       * @returns {EventEmitter} `this`.
       * @public
       */


      EventEmitter.prototype.once = function once(event, fn, context) {
        return addListener(this, event, fn, context, true);
      };
      /**
       * Remove the listeners of a given event.
       *
       * @param {(String|Symbol)} event The event name.
       * @param {Function} fn Only remove the listeners that match this function.
       * @param {*} context Only remove the listeners that have this context.
       * @param {Boolean} once Only remove one-time listeners.
       * @returns {EventEmitter} `this`.
       * @public
       */


      EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return this;

        if (!fn) {
          clearEvent(this, evt);
          return this;
        }

        var listeners = this._events[evt];

        if (listeners.fn) {
          if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
            clearEvent(this, evt);
          }
        } else {
          for (var i = 0, events = [], length = listeners.length; i < length; i++) {
            if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
              events.push(listeners[i]);
            }
          } //
          // Reset the array, or remove it completely if we have no more listeners.
          //


          if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else clearEvent(this, evt);
        }

        return this;
      };
      /**
       * Remove all listeners, or those of the specified event.
       *
       * @param {(String|Symbol)} [event] The event name.
       * @returns {EventEmitter} `this`.
       * @public
       */


      EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
        var evt;

        if (event) {
          evt = prefix ? prefix + event : event;
          if (this._events[evt]) clearEvent(this, evt);
        } else {
          this._events = new Events();
          this._eventsCount = 0;
        }

        return this;
      }; //
      // Alias methods names because people roll like that.
      //


      EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
      EventEmitter.prototype.addListener = EventEmitter.prototype.on; //
      // Expose the prefix.
      //

      EventEmitter.prefixed = prefix; //
      // Allow `EventEmitter` to be imported as module namespace.
      //

      EventEmitter.EventEmitter = EventEmitter; //
      // Expose the module.
      //

      if (true) {
        module.exports = EventEmitter;
      }
      /***/

    },
    /* 674 */

    /***/
    function (module, exports, __webpack_require__) {
      var assignValue = __webpack_require__(248),
          copyObject = __webpack_require__(156),
          createAssigner = __webpack_require__(491),
          isArrayLike = __webpack_require__(134),
          isPrototype = __webpack_require__(209),
          keys = __webpack_require__(132);
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Assigns own enumerable string keyed properties of source objects to the
       * destination object. Source objects are applied from left to right.
       * Subsequent sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object` and is loosely based on
       * [`Object.assign`](https://mdn.io/Object/assign).
       *
       * @static
       * @memberOf _
       * @since 0.10.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.assignIn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * function Bar() {
       *   this.c = 3;
       * }
       *
       * Foo.prototype.b = 2;
       * Bar.prototype.d = 4;
       *
       * _.assign({ 'a': 0 }, new Foo, new Bar);
       * // => { 'a': 1, 'c': 3 }
       */

      var assign = createAssigner(function (object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }

        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      module.exports = assign;
      /***/
    },
    /* 675 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(722);
      /***/
    },
    /* 676 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(803);
      /***/
    },
    /* 677 */

    /***/
    function (module, exports, __webpack_require__) {
      (function webpackUniversalModuleDefinition(root, factory) {
        if (true) module.exports = factory();else {}
      })(this, function () {
        return (
          /******/
          function (modules) {
            // webpackBootstrap

            /******/
            // The module cache

            /******/
            var installedModules = {};
            /******/
            // The require function

            /******/

            function __webpack_require__(moduleId) {
              /******/
              // Check if module is in cache

              /******/
              if (installedModules[moduleId])
                /******/
                return installedModules[moduleId].exports;
              /******/
              // Create a new module (and put it into the cache)

              /******/

              var module = installedModules[moduleId] = {
                /******/
                exports: {},

                /******/
                id: moduleId,

                /******/
                loaded: false
                /******/

              };
              /******/
              // Execute the module function

              /******/

              modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
              /******/
              // Flag the module as loaded

              /******/

              module.loaded = true;
              /******/
              // Return the exports of the module

              /******/

              return module.exports;
              /******/
            }
            /******/
            // expose the modules object (__webpack_modules__)

            /******/


            __webpack_require__.m = modules;
            /******/
            // expose the module cache

            /******/

            __webpack_require__.c = installedModules;
            /******/
            // __webpack_public_path__

            /******/

            __webpack_require__.p = "";
            /******/
            // Load entry module and return exports

            /******/

            return __webpack_require__(0);
            /******/
          }(
          /************************************************************************/

          /******/
          [
          /* 0 */

          /***/
          function (module, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */
            (function (global) {
              'use strict';
              /**
               * Construct a new Cleave instance by passing the configuration object
               *
               * @param {String | HTMLElement} element
               * @param {Object} opts
               */

              var Cleave = function Cleave(element, opts) {
                var owner = this;
                var hasMultipleElements = false;

                if (typeof element === 'string') {
                  owner.element = document.querySelector(element);
                  hasMultipleElements = document.querySelectorAll(element).length > 1;
                } else {
                  if (typeof element.length !== 'undefined' && element.length > 0) {
                    owner.element = element[0];
                    hasMultipleElements = element.length > 1;
                  } else {
                    owner.element = element;
                  }
                }

                if (!owner.element) {
                  throw new Error('[cleave.js] Please check the element');
                }

                if (hasMultipleElements) {
                  try {
                    // eslint-disable-next-line
                    console.warn('[cleave.js] Multiple input fields matched, cleave.js will only take the first one.');
                  } catch (e) {// Old IE
                  }
                }

                opts.initValue = owner.element.value;
                owner.properties = Cleave.DefaultProperties.assign({}, opts);
                owner.init();
              };

              Cleave.prototype = {
                init: function init() {
                  var owner = this,
                      pps = owner.properties; // no need to use this lib

                  if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && pps.blocksLength === 0 && !pps.prefix) {
                    owner.onInput(pps.initValue);
                    return;
                  }

                  pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
                  owner.isAndroid = Cleave.Util.isAndroid();
                  owner.lastInputValue = '';
                  owner.onChangeListener = owner.onChange.bind(owner);
                  owner.onKeyDownListener = owner.onKeyDown.bind(owner);
                  owner.onFocusListener = owner.onFocus.bind(owner);
                  owner.onCutListener = owner.onCut.bind(owner);
                  owner.onCopyListener = owner.onCopy.bind(owner);
                  owner.element.addEventListener('input', owner.onChangeListener);
                  owner.element.addEventListener('keydown', owner.onKeyDownListener);
                  owner.element.addEventListener('focus', owner.onFocusListener);
                  owner.element.addEventListener('cut', owner.onCutListener);
                  owner.element.addEventListener('copy', owner.onCopyListener);
                  owner.initPhoneFormatter();
                  owner.initDateFormatter();
                  owner.initTimeFormatter();
                  owner.initNumeralFormatter(); // avoid touch input field if value is null
                  // otherwise Firefox will add red box-shadow for <input required />

                  if (pps.initValue || pps.prefix && !pps.noImmediatePrefix) {
                    owner.onInput(pps.initValue);
                  }
                },
                initNumeralFormatter: function initNumeralFormatter() {
                  var owner = this,
                      pps = owner.properties;

                  if (!pps.numeral) {
                    return;
                  }

                  pps.numeralFormatter = new Cleave.NumeralFormatter(pps.numeralDecimalMark, pps.numeralIntegerScale, pps.numeralDecimalScale, pps.numeralThousandsGroupStyle, pps.numeralPositiveOnly, pps.stripLeadingZeroes, pps.delimiter);
                },
                initTimeFormatter: function initTimeFormatter() {
                  var owner = this,
                      pps = owner.properties;

                  if (!pps.time) {
                    return;
                  }

                  pps.timeFormatter = new Cleave.TimeFormatter(pps.timePattern, pps.timeFormat);
                  pps.blocks = pps.timeFormatter.getBlocks();
                  pps.blocksLength = pps.blocks.length;
                  pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
                },
                initDateFormatter: function initDateFormatter() {
                  var owner = this,
                      pps = owner.properties;

                  if (!pps.date) {
                    return;
                  }

                  pps.dateFormatter = new Cleave.DateFormatter(pps.datePattern);
                  pps.blocks = pps.dateFormatter.getBlocks();
                  pps.blocksLength = pps.blocks.length;
                  pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
                },
                initPhoneFormatter: function initPhoneFormatter() {
                  var owner = this,
                      pps = owner.properties;

                  if (!pps.phone) {
                    return;
                  } // Cleave.AsYouTypeFormatter should be provided by
                  // external google closure lib


                  try {
                    pps.phoneFormatter = new Cleave.PhoneFormatter(new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode), pps.delimiter);
                  } catch (ex) {
                    throw new Error('[cleave.js] Please include phone-type-formatter.{country}.js lib');
                  }
                },
                onKeyDown: function onKeyDown(event) {
                  var owner = this,
                      pps = owner.properties,
                      charCode = event.which || event.keyCode,
                      Util = Cleave.Util,
                      currentValue = owner.element.value; // if we got any charCode === 8, this means, that this device correctly
                  // sends backspace keys in event, so we do not need to apply any hacks

                  owner.hasBackspaceSupport = owner.hasBackspaceSupport || charCode === 8;

                  if (!owner.hasBackspaceSupport && Util.isAndroidBackspaceKeydown(owner.lastInputValue, currentValue)) {
                    charCode = 8;
                  }

                  owner.lastInputValue = currentValue; // hit backspace when last character is delimiter

                  var postDelimiter = Util.getPostDelimiter(currentValue, pps.delimiter, pps.delimiters);

                  if (charCode === 8 && postDelimiter) {
                    pps.postDelimiterBackspace = postDelimiter;
                  } else {
                    pps.postDelimiterBackspace = false;
                  }
                },
                onChange: function onChange() {
                  this.onInput(this.element.value);
                },
                onFocus: function onFocus() {
                  var owner = this,
                      pps = owner.properties;
                  Cleave.Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
                },
                onCut: function onCut(e) {
                  this.copyClipboardData(e);
                  this.onInput('');
                },
                onCopy: function onCopy(e) {
                  this.copyClipboardData(e);
                },
                copyClipboardData: function copyClipboardData(e) {
                  var owner = this,
                      pps = owner.properties,
                      Util = Cleave.Util,
                      inputValue = owner.element.value,
                      textToCopy = '';

                  if (!pps.copyDelimiter) {
                    textToCopy = Util.stripDelimiters(inputValue, pps.delimiter, pps.delimiters);
                  } else {
                    textToCopy = inputValue;
                  }

                  try {
                    if (e.clipboardData) {
                      e.clipboardData.setData('Text', textToCopy);
                    } else {
                      window.clipboardData.setData('Text', textToCopy);
                    }

                    e.preventDefault();
                  } catch (ex) {//  empty
                  }
                },
                onInput: function onInput(value) {
                  var owner = this,
                      pps = owner.properties,
                      Util = Cleave.Util; // case 1: delete one more character "4"
                  // 1234*| -> hit backspace -> 123|
                  // case 2: last character is not delimiter which is:
                  // 12|34* -> hit backspace -> 1|34*
                  // note: no need to apply this for numeral mode

                  var postDelimiterAfter = Util.getPostDelimiter(value, pps.delimiter, pps.delimiters);

                  if (!pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
                    value = Util.headStr(value, value.length - pps.postDelimiterBackspace.length);
                  } // phone formatter


                  if (pps.phone) {
                    if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
                      pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
                    } else {
                      pps.result = pps.phoneFormatter.format(value);
                    }

                    owner.updateValueState();
                    return;
                  } // numeral formatter


                  if (pps.numeral) {
                    if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
                      pps.result = pps.prefix + pps.numeralFormatter.format(value);
                    } else {
                      pps.result = pps.numeralFormatter.format(value);
                    }

                    owner.updateValueState();
                    return;
                  } // date


                  if (pps.date) {
                    value = pps.dateFormatter.getValidatedDate(value);
                  } // time


                  if (pps.time) {
                    value = pps.timeFormatter.getValidatedTime(value);
                  } // strip delimiters


                  value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters); // strip prefix
                  // var strippedPreviousResult = Util.stripDelimiters(pps.result, pps.delimiter, pps.delimiters);

                  value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters); // strip non-numeric characters

                  value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value; // convert case

                  value = pps.uppercase ? value.toUpperCase() : value;
                  value = pps.lowercase ? value.toLowerCase() : value; // prefix

                  if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
                    value = pps.prefix + value; // no blocks specified, no need to do formatting

                    if (pps.blocksLength === 0) {
                      pps.result = value;
                      owner.updateValueState();
                      return;
                    }
                  } // update credit card props


                  if (pps.creditCard) {
                    owner.updateCreditCardPropsByValue(value);
                  } // strip over length characters


                  value = Util.headStr(value, pps.maxLength); // apply blocks

                  pps.result = Util.getFormattedValue(value, pps.blocks, pps.blocksLength, pps.delimiter, pps.delimiters, pps.delimiterLazyShow);
                  owner.updateValueState();
                },
                updateCreditCardPropsByValue: function updateCreditCardPropsByValue(value) {
                  var owner = this,
                      pps = owner.properties,
                      Util = Cleave.Util,
                      creditCardInfo; // At least one of the first 4 characters has changed

                  if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
                    return;
                  }

                  creditCardInfo = Cleave.CreditCardDetector.getInfo(value, pps.creditCardStrictMode);
                  pps.blocks = creditCardInfo.blocks;
                  pps.blocksLength = pps.blocks.length;
                  pps.maxLength = Util.getMaxLength(pps.blocks); // credit card type changed

                  if (pps.creditCardType !== creditCardInfo.type) {
                    pps.creditCardType = creditCardInfo.type;
                    pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
                  }
                },
                updateValueState: function updateValueState() {
                  var owner = this,
                      Util = Cleave.Util,
                      pps = owner.properties;

                  if (!owner.element) {
                    return;
                  }

                  var endPos = owner.element.selectionEnd;
                  var oldValue = owner.element.value;
                  var newValue = pps.result;
                  endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters); // fix Android browser type="text" input field
                  // cursor not jumping issue

                  if (owner.isAndroid) {
                    window.setTimeout(function () {
                      owner.element.value = newValue;
                      Util.setSelection(owner.element, endPos, pps.document, false);
                      owner.callOnValueChanged();
                    }, 1);
                    return;
                  }

                  owner.element.value = newValue;
                  Util.setSelection(owner.element, endPos, pps.document, false);
                  owner.callOnValueChanged();
                },
                callOnValueChanged: function callOnValueChanged() {
                  var owner = this,
                      pps = owner.properties;
                  pps.onValueChanged.call(owner, {
                    target: {
                      value: pps.result,
                      rawValue: owner.getRawValue()
                    }
                  });
                },
                setPhoneRegionCode: function setPhoneRegionCode(phoneRegionCode) {
                  var owner = this,
                      pps = owner.properties;
                  pps.phoneRegionCode = phoneRegionCode;
                  owner.initPhoneFormatter();
                  owner.onChange();
                },
                setRawValue: function setRawValue(value) {
                  var owner = this,
                      pps = owner.properties;
                  value = value !== undefined && value !== null ? value.toString() : '';

                  if (pps.numeral) {
                    value = value.replace('.', pps.numeralDecimalMark);
                  }

                  pps.postDelimiterBackspace = false;
                  owner.element.value = value;
                  owner.onInput(value);
                },
                getRawValue: function getRawValue() {
                  var owner = this,
                      pps = owner.properties,
                      Util = Cleave.Util,
                      rawValue = owner.element.value;

                  if (pps.rawValueTrimPrefix) {
                    rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters);
                  }

                  if (pps.numeral) {
                    rawValue = pps.numeralFormatter.getRawValue(rawValue);
                  } else {
                    rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
                  }

                  return rawValue;
                },
                getISOFormatDate: function getISOFormatDate() {
                  var owner = this,
                      pps = owner.properties;
                  return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
                },
                getISOFormatTime: function getISOFormatTime() {
                  var owner = this,
                      pps = owner.properties;
                  return pps.time ? pps.timeFormatter.getISOFormatTime() : '';
                },
                getFormattedValue: function getFormattedValue() {
                  return this.element.value;
                },
                destroy: function destroy() {
                  var owner = this;
                  owner.element.removeEventListener('input', owner.onChangeListener);
                  owner.element.removeEventListener('keydown', owner.onKeyDownListener);
                  owner.element.removeEventListener('focus', owner.onFocusListener);
                  owner.element.removeEventListener('cut', owner.onCutListener);
                  owner.element.removeEventListener('copy', owner.onCopyListener);
                },
                toString: function toString() {
                  return '[Cleave Object]';
                }
              };
              Cleave.NumeralFormatter = __webpack_require__(1);
              Cleave.DateFormatter = __webpack_require__(2);
              Cleave.TimeFormatter = __webpack_require__(3);
              Cleave.PhoneFormatter = __webpack_require__(4);
              Cleave.CreditCardDetector = __webpack_require__(5);
              Cleave.Util = __webpack_require__(6);
              Cleave.DefaultProperties = __webpack_require__(7); // for angular directive

              (typeof global === 'object' && global ? global : window)['Cleave'] = Cleave; // CommonJS

              module.exports = Cleave;
              /* WEBPACK VAR INJECTION */
            }).call(exports, function () {
              return this;
            }());
            /***/
          },
          /* 1 */

          /***/
          function (module, exports) {
            'use strict';

            var NumeralFormatter = function NumeralFormatter(numeralDecimalMark, numeralIntegerScale, numeralDecimalScale, numeralThousandsGroupStyle, numeralPositiveOnly, stripLeadingZeroes, delimiter) {
              var owner = this;
              owner.numeralDecimalMark = numeralDecimalMark || '.';
              owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
              owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
              owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
              owner.numeralPositiveOnly = !!numeralPositiveOnly;
              owner.stripLeadingZeroes = stripLeadingZeroes !== false;
              owner.delimiter = delimiter || delimiter === '' ? delimiter : ',';
              owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
            };

            NumeralFormatter.groupStyle = {
              thousand: 'thousand',
              lakh: 'lakh',
              wan: 'wan',
              none: 'none'
            };
            NumeralFormatter.prototype = {
              getRawValue: function getRawValue(value) {
                return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
              },
              format: function format(value) {
                var owner = this,
                    parts,
                    partInteger,
                    partDecimal = ''; // strip alphabet letters

                value = value.replace(/[A-Za-z]/g, '') // replace the first decimal mark with reserved placeholder
                .replace(owner.numeralDecimalMark, 'M') // strip non numeric letters except minus and "M"
                // this is to ensure prefix has been stripped
                .replace(/[^\dM-]/g, '') // replace the leading minus with reserved placeholder
                .replace(/^\-/, 'N') // strip the other minus sign (if present)
                .replace(/\-/g, '') // replace the minus sign (if present)
                .replace('N', owner.numeralPositiveOnly ? '' : '-') // replace decimal mark
                .replace('M', owner.numeralDecimalMark); // strip any leading zeros

                if (owner.stripLeadingZeroes) {
                  value = value.replace(/^(-)?0+(?=\d)/, '$1');
                }

                partInteger = value;

                if (value.indexOf(owner.numeralDecimalMark) >= 0) {
                  parts = value.split(owner.numeralDecimalMark);
                  partInteger = parts[0];
                  partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
                }

                if (owner.numeralIntegerScale > 0) {
                  partInteger = partInteger.slice(0, owner.numeralIntegerScale + (value.slice(0, 1) === '-' ? 1 : 0));
                }

                switch (owner.numeralThousandsGroupStyle) {
                  case NumeralFormatter.groupStyle.lakh:
                    partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);
                    break;

                  case NumeralFormatter.groupStyle.wan:
                    partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);
                    break;

                  case NumeralFormatter.groupStyle.thousand:
                    partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);
                    break;
                }

                return partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
              }
            };
            module.exports = NumeralFormatter;
            /***/
          },
          /* 2 */

          /***/
          function (module, exports) {
            'use strict';

            var DateFormatter = function DateFormatter(datePattern) {
              var owner = this;
              owner.date = [];
              owner.blocks = [];
              owner.datePattern = datePattern;
              owner.initBlocks();
            };

            DateFormatter.prototype = {
              initBlocks: function initBlocks() {
                var owner = this;
                owner.datePattern.forEach(function (value) {
                  if (value === 'Y') {
                    owner.blocks.push(4);
                  } else {
                    owner.blocks.push(2);
                  }
                });
              },
              getISOFormatDate: function getISOFormatDate() {
                var owner = this,
                    date = owner.date;
                return date[2] ? date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0]) : '';
              },
              getBlocks: function getBlocks() {
                return this.blocks;
              },
              getValidatedDate: function getValidatedDate(value) {
                var owner = this,
                    result = '';
                value = value.replace(/[^\d]/g, '');
                owner.blocks.forEach(function (length, index) {
                  if (value.length > 0) {
                    var sub = value.slice(0, length),
                        sub0 = sub.slice(0, 1),
                        rest = value.slice(length);

                    switch (owner.datePattern[index]) {
                      case 'd':
                        if (sub === '00') {
                          sub = '01';
                        } else if (parseInt(sub0, 10) > 3) {
                          sub = '0' + sub0;
                        } else if (parseInt(sub, 10) > 31) {
                          sub = '31';
                        }

                        break;

                      case 'm':
                        if (sub === '00') {
                          sub = '01';
                        } else if (parseInt(sub0, 10) > 1) {
                          sub = '0' + sub0;
                        } else if (parseInt(sub, 10) > 12) {
                          sub = '12';
                        }

                        break;
                    }

                    result += sub; // update remaining string

                    value = rest;
                  }
                });
                return this.getFixedDateString(result);
              },
              getFixedDateString: function getFixedDateString(value) {
                var owner = this,
                    datePattern = owner.datePattern,
                    date = [],
                    dayIndex = 0,
                    monthIndex = 0,
                    yearIndex = 0,
                    dayStartIndex = 0,
                    monthStartIndex = 0,
                    yearStartIndex = 0,
                    day,
                    month,
                    year,
                    fullYearDone = false; // mm-dd || dd-mm

                if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
                  dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
                  monthStartIndex = 2 - dayStartIndex;
                  day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
                  month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
                  date = this.getFixedDate(day, month, 0);
                } // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd


                if (value.length === 8) {
                  datePattern.forEach(function (type, index) {
                    switch (type) {
                      case 'd':
                        dayIndex = index;
                        break;

                      case 'm':
                        monthIndex = index;
                        break;

                      default:
                        yearIndex = index;
                        break;
                    }
                  });
                  yearStartIndex = yearIndex * 2;
                  dayStartIndex = dayIndex <= yearIndex ? dayIndex * 2 : dayIndex * 2 + 2;
                  monthStartIndex = monthIndex <= yearIndex ? monthIndex * 2 : monthIndex * 2 + 2;
                  day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
                  month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
                  year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
                  fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
                  date = this.getFixedDate(day, month, year);
                }

                owner.date = date;
                return date.length === 0 ? value : datePattern.reduce(function (previous, current) {
                  switch (current) {
                    case 'd':
                      return previous + owner.addLeadingZero(date[0]);

                    case 'm':
                      return previous + owner.addLeadingZero(date[1]);

                    default:
                      return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2]) : '');
                  }
                }, '');
              },
              getFixedDate: function getFixedDate(day, month, year) {
                day = Math.min(day, 31);
                month = Math.min(month, 12);
                year = parseInt(year || 0, 10);

                if (month < 7 && month % 2 === 0 || month > 8 && month % 2 === 1) {
                  day = Math.min(day, month === 2 ? this.isLeapYear(year) ? 29 : 28 : 30);
                }

                return [day, month, year];
              },
              isLeapYear: function isLeapYear(year) {
                return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
              },
              addLeadingZero: function addLeadingZero(number) {
                return (number < 10 ? '0' : '') + number;
              },
              addLeadingZeroForYear: function addLeadingZeroForYear(number) {
                return (number < 10 ? '000' : number < 100 ? '00' : number < 1000 ? '0' : '') + number;
              }
            };
            module.exports = DateFormatter;
            /***/
          },
          /* 3 */

          /***/
          function (module, exports) {
            'use strict';

            var TimeFormatter = function TimeFormatter(timePattern, timeFormat) {
              var owner = this;
              owner.time = [];
              owner.blocks = [];
              owner.timePattern = timePattern;
              owner.timeFormat = timeFormat;
              owner.initBlocks();
            };

            TimeFormatter.prototype = {
              initBlocks: function initBlocks() {
                var owner = this;
                owner.timePattern.forEach(function () {
                  owner.blocks.push(2);
                });
              },
              getISOFormatTime: function getISOFormatTime() {
                var owner = this,
                    time = owner.time;
                return time[2] ? owner.addLeadingZero(time[0]) + ':' + owner.addLeadingZero(time[1]) + ':' + owner.addLeadingZero(time[2]) : '';
              },
              getBlocks: function getBlocks() {
                return this.blocks;
              },
              getTimeFormatOptions: function getTimeFormatOptions() {
                var owner = this;

                if (String(owner.timeFormat) === '12') {
                  return {
                    maxHourFirstDigit: 1,
                    maxHours: 12,
                    maxMinutesFirstDigit: 5,
                    maxMinutes: 60
                  };
                }

                return {
                  maxHourFirstDigit: 2,
                  maxHours: 23,
                  maxMinutesFirstDigit: 5,
                  maxMinutes: 60
                };
              },
              getValidatedTime: function getValidatedTime(value) {
                var owner = this,
                    result = '';
                value = value.replace(/[^\d]/g, '');
                var timeFormatOptions = owner.getTimeFormatOptions();
                owner.blocks.forEach(function (length, index) {
                  if (value.length > 0) {
                    var sub = value.slice(0, length),
                        sub0 = sub.slice(0, 1),
                        rest = value.slice(length);

                    switch (owner.timePattern[index]) {
                      case 'h':
                        if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
                          sub = '0' + sub0;
                        } else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
                          sub = timeFormatOptions.maxHours + '';
                        }

                        break;

                      case 'm':
                      case 's':
                        if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
                          sub = '0' + sub0;
                        } else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
                          sub = timeFormatOptions.maxMinutes + '';
                        }

                        break;
                    }

                    result += sub; // update remaining string

                    value = rest;
                  }
                });
                return this.getFixedTimeString(result);
              },
              getFixedTimeString: function getFixedTimeString(value) {
                var owner = this,
                    timePattern = owner.timePattern,
                    time = [],
                    secondIndex = 0,
                    minuteIndex = 0,
                    hourIndex = 0,
                    secondStartIndex = 0,
                    minuteStartIndex = 0,
                    hourStartIndex = 0,
                    second,
                    minute,
                    hour;

                if (value.length === 6) {
                  timePattern.forEach(function (type, index) {
                    switch (type) {
                      case 's':
                        secondIndex = index * 2;
                        break;

                      case 'm':
                        minuteIndex = index * 2;
                        break;

                      case 'h':
                        hourIndex = index * 2;
                        break;
                    }
                  });
                  hourStartIndex = hourIndex;
                  minuteStartIndex = minuteIndex;
                  secondStartIndex = secondIndex;
                  second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
                  minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
                  hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
                  time = this.getFixedTime(hour, minute, second);
                }

                if (value.length === 4 && owner.timePattern.indexOf('s') < 0) {
                  timePattern.forEach(function (type, index) {
                    switch (type) {
                      case 'm':
                        minuteIndex = index * 2;
                        break;

                      case 'h':
                        hourIndex = index * 2;
                        break;
                    }
                  });
                  hourStartIndex = hourIndex;
                  minuteStartIndex = minuteIndex;
                  second = 0;
                  minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
                  hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
                  time = this.getFixedTime(hour, minute, second);
                }

                owner.time = time;
                return time.length === 0 ? value : timePattern.reduce(function (previous, current) {
                  switch (current) {
                    case 's':
                      return previous + owner.addLeadingZero(time[2]);

                    case 'm':
                      return previous + owner.addLeadingZero(time[1]);

                    case 'h':
                      return previous + owner.addLeadingZero(time[0]);
                  }
                }, '');
              },
              getFixedTime: function getFixedTime(hour, minute, second) {
                second = Math.min(parseInt(second || 0, 10), 60);
                minute = Math.min(minute, 60);
                hour = Math.min(hour, 60);
                return [hour, minute, second];
              },
              addLeadingZero: function addLeadingZero(number) {
                return (number < 10 ? '0' : '') + number;
              }
            };
            module.exports = TimeFormatter;
            /***/
          },
          /* 4 */

          /***/
          function (module, exports) {
            'use strict';

            var PhoneFormatter = function PhoneFormatter(formatter, delimiter) {
              var owner = this;
              owner.delimiter = delimiter || delimiter === '' ? delimiter : ' ';
              owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
              owner.formatter = formatter;
            };

            PhoneFormatter.prototype = {
              setFormatter: function setFormatter(formatter) {
                this.formatter = formatter;
              },
              format: function format(phoneNumber) {
                var owner = this;
                owner.formatter.clear(); // only keep number and +

                phoneNumber = phoneNumber.replace(/[^\d+]/g, ''); // strip non-leading +

                phoneNumber = phoneNumber.replace(/^\+/, 'B').replace(/\+/g, '').replace('B', '+'); // strip delimiter

                phoneNumber = phoneNumber.replace(owner.delimiterRE, '');
                var result = '',
                    current,
                    validated = false;

                for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
                  current = owner.formatter.inputDigit(phoneNumber.charAt(i)); // has ()- or space inside

                  if (/[\s()-]/g.test(current)) {
                    result = current;
                    validated = true;
                  } else {
                    if (!validated) {
                      result = current;
                    } // else: over length input
                    // it turns to invalid number again

                  }
                } // strip ()
                // e.g. US: 7161234567 returns (716) 123-4567


                result = result.replace(/[()]/g, ''); // replace library delimiter with user customized delimiter

                result = result.replace(/[\s-]/g, owner.delimiter);
                return result;
              }
            };
            module.exports = PhoneFormatter;
            /***/
          },
          /* 5 */

          /***/
          function (module, exports) {
            'use strict';

            var CreditCardDetector = {
              blocks: {
                uatp: [4, 5, 6],
                amex: [4, 6, 5],
                diners: [4, 6, 4],
                discover: [4, 4, 4, 4],
                mastercard: [4, 4, 4, 4],
                dankort: [4, 4, 4, 4],
                instapayment: [4, 4, 4, 4],
                jcb15: [4, 6, 5],
                jcb: [4, 4, 4, 4],
                maestro: [4, 4, 4, 4],
                visa: [4, 4, 4, 4],
                mir: [4, 4, 4, 4],
                unionPay: [4, 4, 4, 4],
                general: [4, 4, 4, 4],
                generalStrict: [4, 4, 4, 7]
              },
              re: {
                // starts with 1; 15 digits, not starts with 1800 (jcb card)
                uatp: /^(?!1800)1\d{0,14}/,
                // starts with 34/37; 15 digits
                amex: /^3[47]\d{0,13}/,
                // starts with 6011/65/644-649; 16 digits
                discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,
                // starts with 300-305/309 or 36/38/39; 14 digits
                diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
                // starts with 51-55/2221–2720; 16 digits
                mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
                // starts with 5019/4175/4571; 16 digits
                dankort: /^(5019|4175|4571)\d{0,12}/,
                // starts with 637-639; 16 digits
                instapayment: /^63[7-9]\d{0,13}/,
                // starts with 2131/1800; 15 digits
                jcb15: /^(?:2131|1800)\d{0,11}/,
                // starts with 2131/1800/35; 16 digits
                jcb: /^(?:35\d{0,2})\d{0,12}/,
                // starts with 50/56-58/6304/67; 16 digits
                maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
                // starts with 22; 16 digits
                mir: /^220[0-4]\d{0,12}/,
                // starts with 4; 16 digits
                visa: /^4\d{0,15}/,
                // starts with 62; 16 digits
                unionPay: /^62\d{0,14}/
              },
              getInfo: function getInfo(value, strictMode) {
                var blocks = CreditCardDetector.blocks,
                    re = CreditCardDetector.re; // Some credit card can have up to 19 digits number.
                // Set strictMode to true will remove the 16 max-length restrain,
                // however, I never found any website validate card number like
                // this, hence probably you don't want to enable this option.

                strictMode = !!strictMode;

                for (var key in re) {
                  if (re[key].test(value)) {
                    var block;

                    if (strictMode) {
                      block = blocks.generalStrict;
                    } else {
                      block = blocks[key];
                    }

                    return {
                      type: key,
                      blocks: block
                    };
                  }
                }

                return {
                  type: 'unknown',
                  blocks: strictMode ? blocks.generalStrict : blocks.general
                };
              }
            };
            module.exports = CreditCardDetector;
            /***/
          },
          /* 6 */

          /***/
          function (module, exports) {
            'use strict';

            var Util = {
              noop: function noop() {},
              strip: function strip(value, re) {
                return value.replace(re, '');
              },
              getPostDelimiter: function getPostDelimiter(value, delimiter, delimiters) {
                // single delimiter
                if (delimiters.length === 0) {
                  return value.slice(-delimiter.length) === delimiter ? delimiter : '';
                } // multiple delimiters


                var matchedDelimiter = '';
                delimiters.forEach(function (current) {
                  if (value.slice(-current.length) === current) {
                    matchedDelimiter = current;
                  }
                });
                return matchedDelimiter;
              },
              getDelimiterREByDelimiter: function getDelimiterREByDelimiter(delimiter) {
                return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
              },
              getNextCursorPosition: function getNextCursorPosition(prevPos, oldValue, newValue, delimiter, delimiters) {
                // If cursor was at the end of value, just place it back.
                // Because new value could contain additional chars.
                if (oldValue.length === prevPos) {
                  return newValue.length;
                }

                return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters);
              },
              getPositionOffset: function getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters) {
                var oldRawValue, newRawValue, lengthOffset;
                oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
                newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
                lengthOffset = oldRawValue.length - newRawValue.length;
                return lengthOffset !== 0 ? lengthOffset / Math.abs(lengthOffset) : 0;
              },
              stripDelimiters: function stripDelimiters(value, delimiter, delimiters) {
                var owner = this; // single delimiter

                if (delimiters.length === 0) {
                  var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';
                  return value.replace(delimiterRE, '');
                } // multiple delimiters


                delimiters.forEach(function (current) {
                  current.split('').forEach(function (letter) {
                    value = value.replace(owner.getDelimiterREByDelimiter(letter), '');
                  });
                });
                return value;
              },
              headStr: function headStr(str, length) {
                return str.slice(0, length);
              },
              getMaxLength: function getMaxLength(blocks) {
                return blocks.reduce(function (previous, current) {
                  return previous + current;
                }, 0);
              },
              // strip prefix
              // Before type  |   After type    |     Return value
              // PEFIX-...    |   PEFIX-...     |     ''
              // PREFIX-123   |   PEFIX-123     |     123
              // PREFIX-123   |   PREFIX-23     |     23
              // PREFIX-123   |   PREFIX-1234   |     1234
              getPrefixStrippedValue: function getPrefixStrippedValue(value, prefix, prefixLength, prevResult, delimiter, delimiters) {
                // No prefix
                if (prefixLength === 0) {
                  return value;
                } // Pre result has issue
                // Revert to raw prefix


                if (prevResult.slice(0, prefixLength) !== prefix) {
                  return '';
                }

                var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters); // New value has issue, someone typed in between prefix letters
                // Revert to pre value

                if (value.slice(0, prefixLength) !== prefix) {
                  return prevValue.slice(prefixLength);
                } // No issue, strip prefix for new value


                return value.slice(prefixLength);
              },
              getFirstDiffIndex: function getFirstDiffIndex(prev, current) {
                var index = 0;

                while (prev.charAt(index) === current.charAt(index)) {
                  if (prev.charAt(index++) === '') {
                    return -1;
                  }
                }

                return index;
              },
              getFormattedValue: function getFormattedValue(value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
                var result = '',
                    multipleDelimiters = delimiters.length > 0,
                    currentDelimiter; // no options, normal input

                if (blocksLength === 0) {
                  return value;
                }

                blocks.forEach(function (length, index) {
                  if (value.length > 0) {
                    var sub = value.slice(0, length),
                        rest = value.slice(length);

                    if (multipleDelimiters) {
                      currentDelimiter = delimiters[delimiterLazyShow ? index - 1 : index] || currentDelimiter;
                    } else {
                      currentDelimiter = delimiter;
                    }

                    if (delimiterLazyShow) {
                      if (index > 0) {
                        result += currentDelimiter;
                      }

                      result += sub;
                    } else {
                      result += sub;

                      if (sub.length === length && index < blocksLength - 1) {
                        result += currentDelimiter;
                      }
                    } // update remaining string


                    value = rest;
                  }
                });
                return result;
              },
              // move cursor to the end
              // the first time user focuses on an input with prefix
              fixPrefixCursor: function fixPrefixCursor(el, prefix, delimiter, delimiters) {
                if (!el) {
                  return;
                }

                var val = el.value,
                    appendix = delimiter || delimiters[0] || ' ';

                if (!el.setSelectionRange || !prefix || prefix.length + appendix.length < val.length) {
                  return;
                }

                var len = val.length * 2; // set timeout to avoid blink

                setTimeout(function () {
                  el.setSelectionRange(len, len);
                }, 1);
              },
              setSelection: function setSelection(element, position, doc) {
                if (element !== this.getActiveElement(doc)) {
                  return;
                } // cursor is already in the end


                if (element && element.value.length <= position) {
                  return;
                }

                if (element.createTextRange) {
                  var range = element.createTextRange();
                  range.move('character', position);
                  range.select();
                } else {
                  try {
                    element.setSelectionRange(position, position);
                  } catch (e) {
                    // eslint-disable-next-line
                    console.warn('The input element type does not support selection');
                  }
                }
              },
              getActiveElement: function getActiveElement(parent) {
                var activeElement = parent.activeElement;

                if (activeElement && activeElement.shadowRoot) {
                  return this.getActiveElement(activeElement.shadowRoot);
                }

                return activeElement;
              },
              isAndroid: function isAndroid() {
                return navigator && /android/i.test(navigator.userAgent);
              },
              // On Android chrome, the keyup and keydown events
              // always return key code 229 as a composition that
              // buffers the user’s keystrokes
              // see https://github.com/nosir/cleave.js/issues/147
              isAndroidBackspaceKeydown: function isAndroidBackspaceKeydown(lastInputValue, currentInputValue) {
                if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
                  return false;
                }

                return currentInputValue === lastInputValue.slice(0, -1);
              }
            };
            module.exports = Util;
            /***/
          },
          /* 7 */

          /***/
          function (module, exports) {
            /* WEBPACK VAR INJECTION */
            (function (global) {
              'use strict';
              /**
               * Props Assignment
               *
               * Separate this, so react module can share the usage
               */

              var DefaultProperties = {
                // Maybe change to object-assign
                // for now just keep it as simple
                assign: function assign(target, opts) {
                  target = target || {};
                  opts = opts || {}; // credit card

                  target.creditCard = !!opts.creditCard;
                  target.creditCardStrictMode = !!opts.creditCardStrictMode;
                  target.creditCardType = '';

                  target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || function () {}; // phone


                  target.phone = !!opts.phone;
                  target.phoneRegionCode = opts.phoneRegionCode || 'AU';
                  target.phoneFormatter = {}; // time

                  target.time = !!opts.time;
                  target.timePattern = opts.timePattern || ['h', 'm', 's'];
                  target.timeFormat = opts.timeFormat || '24';
                  target.timeFormatter = {}; // date

                  target.date = !!opts.date;
                  target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
                  target.dateFormatter = {}; // numeral

                  target.numeral = !!opts.numeral;
                  target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
                  target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
                  target.numeralDecimalMark = opts.numeralDecimalMark || '.';
                  target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
                  target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
                  target.stripLeadingZeroes = opts.stripLeadingZeroes !== false; // others

                  target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;
                  target.uppercase = !!opts.uppercase;
                  target.lowercase = !!opts.lowercase;
                  target.prefix = target.creditCard || target.date ? '' : opts.prefix || '';
                  target.noImmediatePrefix = !!opts.noImmediatePrefix;
                  target.prefixLength = target.prefix.length;
                  target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
                  target.copyDelimiter = !!opts.copyDelimiter;
                  target.initValue = opts.initValue !== undefined && opts.initValue !== null ? opts.initValue.toString() : '';
                  target.delimiter = opts.delimiter || opts.delimiter === '' ? opts.delimiter : opts.date ? '/' : opts.time ? ':' : opts.numeral ? ',' : opts.phone ? ' ' : ' ';
                  target.delimiterLength = target.delimiter.length;
                  target.delimiterLazyShow = !!opts.delimiterLazyShow;
                  target.delimiters = opts.delimiters || [];
                  target.blocks = opts.blocks || [];
                  target.blocksLength = target.blocks.length;
                  target.root = typeof global === 'object' && global ? global : window;
                  target.document = opts.document || target.root.document;
                  target.maxLength = 0;
                  target.backspace = false;
                  target.result = '';

                  target.onValueChanged = opts.onValueChanged || function () {};

                  return target;
                }
              };
              module.exports = DefaultProperties;
              /* WEBPACK VAR INJECTION */
            }).call(exports, function () {
              return this;
            }());
            /***/
          }])
        );
      });

      ;
      /***/
    },
    /* 678 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseRandom = __webpack_require__(804),
          isIterateeCall = __webpack_require__(486),
          toFinite = __webpack_require__(431);
      /** Built-in method references without a dependency on `root`. */


      var freeParseFloat = parseFloat;
      /* Built-in method references for those with the same name as other `lodash` methods. */

      var nativeMin = Math.min,
          nativeRandom = Math.random;
      /**
       * Produces a random number between the inclusive `lower` and `upper` bounds.
       * If only one argument is provided a number between `0` and the given number
       * is returned. If `floating` is `true`, or either `lower` or `upper` are
       * floats, a floating-point number is returned instead of an integer.
       *
       * **Note:** JavaScript follows the IEEE-754 standard for resolving
       * floating-point values which can produce unexpected results.
       *
       * @static
       * @memberOf _
       * @since 0.7.0
       * @category Number
       * @param {number} [lower=0] The lower bound.
       * @param {number} [upper=1] The upper bound.
       * @param {boolean} [floating] Specify returning a floating-point number.
       * @returns {number} Returns the random number.
       * @example
       *
       * _.random(0, 5);
       * // => an integer between 0 and 5
       *
       * _.random(5);
       * // => also an integer between 0 and 5
       *
       * _.random(5, true);
       * // => a floating-point number between 0 and 5
       *
       * _.random(1.2, 5.2);
       * // => a floating-point number between 1.2 and 5.2
       */

      function random(lower, upper, floating) {
        if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined;
        }

        if (floating === undefined) {
          if (typeof upper == 'boolean') {
            floating = upper;
            upper = undefined;
          } else if (typeof lower == 'boolean') {
            floating = lower;
            lower = undefined;
          }
        }

        if (lower === undefined && upper === undefined) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);

          if (upper === undefined) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }

        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }

        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
        }

        return baseRandom(lower, upper);
      }

      module.exports = random;
      /***/
    },
    /* 679 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseTimes = __webpack_require__(492),
          castFunction = __webpack_require__(805),
          toInteger = __webpack_require__(432);
      /** Used as references for various `Number` constants. */


      var MAX_SAFE_INTEGER = 9007199254740991;
      /** Used as references for the maximum length and index of an array. */

      var MAX_ARRAY_LENGTH = 4294967295;
      /* Built-in method references for those with the same name as other `lodash` methods. */

      var nativeMin = Math.min;
      /**
       * Invokes the iteratee `n` times, returning an array of the results of
       * each invocation. The iteratee is invoked with one argument; (index).
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {number} n The number of times to invoke `iteratee`.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the array of results.
       * @example
       *
       * _.times(3, String);
       * // => ['0', '1', '2']
       *
       *  _.times(4, _.constant(0));
       * // => [0, 0, 0, 0]
       */

      function times(n, iteratee) {
        n = toInteger(n);

        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }

        var index = MAX_ARRAY_LENGTH,
            length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee = castFunction(iteratee);
        n -= MAX_ARRAY_LENGTH;
        var result = baseTimes(length, iteratee);

        while (++index < n) {
          iteratee(index);
        }

        return result;
      }

      module.exports = times;
      /***/
    },
    /* 680 */

    /***/
    function (module, exports, __webpack_require__) {
      /*!
       * Signature Pad v2.3.2
       * https://github.com/szimek/signature_pad
       *
       * Copyright 2017 Szymon Nowak
       * Released under the MIT license
       *
       * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
       * http://corner.squareup.com/2012/07/smoother-signatures.html
       *
       * Implementation of interpolation using cubic Bézier curves is taken from:
       * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
       *
       * Algorithm for approximated length of a Bézier curve is taken from:
       * http://www.lemoda.net/maths/bezier-length/index.html
       *
       */
      (function (global, factory) {
        true ? module.exports = factory() : undefined;
      })(this, function () {
        'use strict';

        function Point(x, y, time) {
          this.x = x;
          this.y = y;
          this.time = time || new Date().getTime();
        }

        Point.prototype.velocityFrom = function (start) {
          return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
        };

        Point.prototype.distanceTo = function (start) {
          return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
        };

        Point.prototype.equals = function (other) {
          return this.x === other.x && this.y === other.y && this.time === other.time;
        };

        function Bezier(startPoint, control1, control2, endPoint) {
          this.startPoint = startPoint;
          this.control1 = control1;
          this.control2 = control2;
          this.endPoint = endPoint;
        } // Returns approximated length.


        Bezier.prototype.length = function () {
          var steps = 10;
          var length = 0;
          var px = void 0;
          var py = void 0;

          for (var i = 0; i <= steps; i += 1) {
            var t = i / steps;

            var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);

            var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);

            if (i > 0) {
              var xdiff = cx - px;
              var ydiff = cy - py;
              length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
            }

            px = cx;
            py = cy;
          }

          return length;
        };
        /* eslint-disable no-multi-spaces, space-in-parens */


        Bezier.prototype._point = function (t, start, c1, c2, end) {
          return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
        };
        /* eslint-disable */
        // http://stackoverflow.com/a/27078401/815507


        function throttle(func, wait, options) {
          var context, args, result;
          var timeout = null;
          var previous = 0;
          if (!options) options = {};

          var later = function later() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
          };

          return function () {
            var now = Date.now();
            if (!previous && options.leading === false) previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;

            if (remaining <= 0 || remaining > wait) {
              if (timeout) {
                clearTimeout(timeout);
                timeout = null;
              }

              previous = now;
              result = func.apply(context, args);
              if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) {
              timeout = setTimeout(later, remaining);
            }

            return result;
          };
        }

        function SignaturePad(canvas, options) {
          var self = this;
          var opts = options || {};
          this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
          this.minWidth = opts.minWidth || 0.5;
          this.maxWidth = opts.maxWidth || 2.5;
          this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds

          this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

          if (this.throttle) {
            this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
          } else {
            this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
          }

          this.dotSize = opts.dotSize || function () {
            return (this.minWidth + this.maxWidth) / 2;
          };

          this.penColor = opts.penColor || 'black';
          this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
          this.onBegin = opts.onBegin;
          this.onEnd = opts.onEnd;
          this._canvas = canvas;
          this._ctx = canvas.getContext('2d');
          this.clear(); // We need add these inline so they are available to unbind while still having
          // access to 'self' we could use _.bind but it's not worth adding a dependency.

          this._handleMouseDown = function (event) {
            if (event.which === 1) {
              self._mouseButtonDown = true;

              self._strokeBegin(event);
            }
          };

          this._handleMouseMove = function (event) {
            if (self._mouseButtonDown) {
              self._strokeMoveUpdate(event);
            }
          };

          this._handleMouseUp = function (event) {
            if (event.which === 1 && self._mouseButtonDown) {
              self._mouseButtonDown = false;

              self._strokeEnd(event);
            }
          };

          this._handleTouchStart = function (event) {
            if (event.targetTouches.length === 1) {
              var touch = event.changedTouches[0];

              self._strokeBegin(touch);
            }
          };

          this._handleTouchMove = function (event) {
            // Prevent scrolling.
            event.preventDefault();
            var touch = event.targetTouches[0];

            self._strokeMoveUpdate(touch);
          };

          this._handleTouchEnd = function (event) {
            var wasCanvasTouched = event.target === self._canvas;

            if (wasCanvasTouched) {
              event.preventDefault();

              self._strokeEnd(event);
            }
          }; // Enable mouse and touch event handlers


          this.on();
        } // Public methods


        SignaturePad.prototype.clear = function () {
          var ctx = this._ctx;
          var canvas = this._canvas;
          ctx.fillStyle = this.backgroundColor;
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          this._data = [];

          this._reset();

          this._isEmpty = true;
        };

        SignaturePad.prototype.fromDataURL = function (dataUrl) {
          var _this = this;

          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var image = new Image();
          var ratio = options.ratio || window.devicePixelRatio || 1;
          var width = options.width || this._canvas.width / ratio;
          var height = options.height || this._canvas.height / ratio;

          this._reset();

          image.src = dataUrl;

          image.onload = function () {
            _this._ctx.drawImage(image, 0, 0, width, height);
          };

          this._isEmpty = false;
        };

        SignaturePad.prototype.toDataURL = function (type) {
          var _canvas;

          switch (type) {
            case 'image/svg+xml':
              return this._toSVG();

            default:
              for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                options[_key - 1] = arguments[_key];
              }

              return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
          }
        };

        SignaturePad.prototype.on = function () {
          this._handleMouseEvents();

          this._handleTouchEvents();
        };

        SignaturePad.prototype.off = function () {
          this._canvas.removeEventListener('mousedown', this._handleMouseDown);

          this._canvas.removeEventListener('mousemove', this._handleMouseMove);

          document.removeEventListener('mouseup', this._handleMouseUp);

          this._canvas.removeEventListener('touchstart', this._handleTouchStart);

          this._canvas.removeEventListener('touchmove', this._handleTouchMove);

          this._canvas.removeEventListener('touchend', this._handleTouchEnd);
        };

        SignaturePad.prototype.isEmpty = function () {
          return this._isEmpty;
        }; // Private methods


        SignaturePad.prototype._strokeBegin = function (event) {
          this._data.push([]);

          this._reset();

          this._strokeUpdate(event);

          if (typeof this.onBegin === 'function') {
            this.onBegin(event);
          }
        };

        SignaturePad.prototype._strokeUpdate = function (event) {
          var x = event.clientX;
          var y = event.clientY;

          var point = this._createPoint(x, y);

          var lastPointGroup = this._data[this._data.length - 1];
          var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
          var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance; // Skip this point if it's too close to the previous one

          if (!(lastPoint && isLastPointTooClose)) {
            var _addPoint = this._addPoint(point),
                curve = _addPoint.curve,
                widths = _addPoint.widths;

            if (curve && widths) {
              this._drawCurve(curve, widths.start, widths.end);
            }

            this._data[this._data.length - 1].push({
              x: point.x,
              y: point.y,
              time: point.time,
              color: this.penColor
            });
          }
        };

        SignaturePad.prototype._strokeEnd = function (event) {
          var canDrawCurve = this.points.length > 2;
          var point = this.points[0]; // Point instance

          if (!canDrawCurve && point) {
            this._drawDot(point);
          }

          if (point) {
            var lastPointGroup = this._data[this._data.length - 1];
            var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object
            // When drawing a dot, there's only one point in a group, so without this check
            // such group would end up with exactly the same 2 points.

            if (!point.equals(lastPoint)) {
              lastPointGroup.push({
                x: point.x,
                y: point.y,
                time: point.time,
                color: this.penColor
              });
            }
          }

          if (typeof this.onEnd === 'function') {
            this.onEnd(event);
          }
        };

        SignaturePad.prototype._handleMouseEvents = function () {
          this._mouseButtonDown = false;

          this._canvas.addEventListener('mousedown', this._handleMouseDown);

          this._canvas.addEventListener('mousemove', this._handleMouseMove);

          document.addEventListener('mouseup', this._handleMouseUp);
        };

        SignaturePad.prototype._handleTouchEvents = function () {
          // Pass touch events to canvas element on mobile IE11 and Edge.
          this._canvas.style.msTouchAction = 'none';
          this._canvas.style.touchAction = 'none';

          this._canvas.addEventListener('touchstart', this._handleTouchStart);

          this._canvas.addEventListener('touchmove', this._handleTouchMove);

          this._canvas.addEventListener('touchend', this._handleTouchEnd);
        };

        SignaturePad.prototype._reset = function () {
          this.points = [];
          this._lastVelocity = 0;
          this._lastWidth = (this.minWidth + this.maxWidth) / 2;
          this._ctx.fillStyle = this.penColor;
        };

        SignaturePad.prototype._createPoint = function (x, y, time) {
          var rect = this._canvas.getBoundingClientRect();

          return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
        };

        SignaturePad.prototype._addPoint = function (point) {
          var points = this.points;
          var tmp = void 0;
          points.push(point);

          if (points.length > 2) {
            // To reduce the initial lag make it work with 3 points
            // by copying the first point to the beginning.
            if (points.length === 3) points.unshift(points[0]);
            tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
            var c2 = tmp.c2;
            tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
            var c3 = tmp.c1;
            var curve = new Bezier(points[1], c2, c3, points[2]);

            var widths = this._calculateCurveWidths(curve); // Remove the first element from the list,
            // so that we always have no more than 4 points in points array.


            points.shift();
            return {
              curve: curve,
              widths: widths
            };
          }

          return {};
        };

        SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
          var dx1 = s1.x - s2.x;
          var dy1 = s1.y - s2.y;
          var dx2 = s2.x - s3.x;
          var dy2 = s2.y - s3.y;
          var m1 = {
            x: (s1.x + s2.x) / 2.0,
            y: (s1.y + s2.y) / 2.0
          };
          var m2 = {
            x: (s2.x + s3.x) / 2.0,
            y: (s2.y + s3.y) / 2.0
          };
          var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
          var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
          var dxm = m1.x - m2.x;
          var dym = m1.y - m2.y;
          var k = l2 / (l1 + l2);
          var cm = {
            x: m2.x + dxm * k,
            y: m2.y + dym * k
          };
          var tx = s2.x - cm.x;
          var ty = s2.y - cm.y;
          return {
            c1: new Point(m1.x + tx, m1.y + ty),
            c2: new Point(m2.x + tx, m2.y + ty)
          };
        };

        SignaturePad.prototype._calculateCurveWidths = function (curve) {
          var startPoint = curve.startPoint;
          var endPoint = curve.endPoint;
          var widths = {
            start: null,
            end: null
          };

          var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

          var newWidth = this._strokeWidth(velocity);

          widths.start = this._lastWidth;
          widths.end = newWidth;
          this._lastVelocity = velocity;
          this._lastWidth = newWidth;
          return widths;
        };

        SignaturePad.prototype._strokeWidth = function (velocity) {
          return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
        };

        SignaturePad.prototype._drawPoint = function (x, y, size) {
          var ctx = this._ctx;
          ctx.moveTo(x, y);
          ctx.arc(x, y, size, 0, 2 * Math.PI, false);
          this._isEmpty = false;
        };

        SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
          var ctx = this._ctx;
          var widthDelta = endWidth - startWidth;
          var drawSteps = Math.floor(curve.length());
          ctx.beginPath();

          for (var i = 0; i < drawSteps; i += 1) {
            // Calculate the Bezier (x, y) coordinate for this step.
            var t = i / drawSteps;
            var tt = t * t;
            var ttt = tt * t;
            var u = 1 - t;
            var uu = u * u;
            var uuu = uu * u;
            var x = uuu * curve.startPoint.x;
            x += 3 * uu * t * curve.control1.x;
            x += 3 * u * tt * curve.control2.x;
            x += ttt * curve.endPoint.x;
            var y = uuu * curve.startPoint.y;
            y += 3 * uu * t * curve.control1.y;
            y += 3 * u * tt * curve.control2.y;
            y += ttt * curve.endPoint.y;
            var width = startWidth + ttt * widthDelta;

            this._drawPoint(x, y, width);
          }

          ctx.closePath();
          ctx.fill();
        };

        SignaturePad.prototype._drawDot = function (point) {
          var ctx = this._ctx;
          var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
          ctx.beginPath();

          this._drawPoint(point.x, point.y, width);

          ctx.closePath();
          ctx.fill();
        };

        SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
          for (var i = 0; i < pointGroups.length; i += 1) {
            var group = pointGroups[i];

            if (group.length > 1) {
              for (var j = 0; j < group.length; j += 1) {
                var rawPoint = group[j];
                var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
                var color = rawPoint.color;

                if (j === 0) {
                  // First point in a group. Nothing to draw yet.
                  // All points in the group have the same color, so it's enough to set
                  // penColor just at the beginning.
                  this.penColor = color;

                  this._reset();

                  this._addPoint(point);
                } else if (j !== group.length - 1) {
                  // Middle point in a group.
                  var _addPoint2 = this._addPoint(point),
                      curve = _addPoint2.curve,
                      widths = _addPoint2.widths;

                  if (curve && widths) {
                    drawCurve(curve, widths, color);
                  }
                } else {// Last point in a group. Do nothing.
                }
              }
            } else {
              this._reset();

              var _rawPoint = group[0];
              drawDot(_rawPoint);
            }
          }
        };

        SignaturePad.prototype._toSVG = function () {
          var _this2 = this;

          var pointGroups = this._data;
          var canvas = this._canvas;
          var ratio = Math.max(window.devicePixelRatio || 1, 1);
          var minX = 0;
          var minY = 0;
          var maxX = canvas.width / ratio;
          var maxY = canvas.height / ratio;
          var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttributeNS(null, 'width', canvas.width);
          svg.setAttributeNS(null, 'height', canvas.height);

          this._fromData(pointGroups, function (curve, widths, color) {
            var path = document.createElement('path'); // Need to check curve for NaN values, these pop up when drawing
            // lines on the canvas that are not continuous. E.g. Sharp corners
            // or stopping mid-stroke and than continuing without lifting mouse.

            if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
              var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));
              path.setAttribute('d', attr);
              path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
              path.setAttribute('stroke', color);
              path.setAttribute('fill', 'none');
              path.setAttribute('stroke-linecap', 'round');
              svg.appendChild(path);
            }
          }, function (rawPoint) {
            var circle = document.createElement('circle');
            var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
            circle.setAttribute('r', dotSize);
            circle.setAttribute('cx', rawPoint.x);
            circle.setAttribute('cy', rawPoint.y);
            circle.setAttribute('fill', rawPoint.color);
            svg.appendChild(circle);
          });

          var prefix = 'data:image/svg+xml;base64,';
          var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
          var body = svg.innerHTML; // IE hack for missing innerHTML property on SVGElement

          if (body === undefined) {
            var dummy = document.createElement('dummy');
            var nodes = svg.childNodes;
            dummy.innerHTML = '';

            for (var i = 0; i < nodes.length; i += 1) {
              dummy.appendChild(nodes[i].cloneNode(true));
            }

            body = dummy.innerHTML;
          }

          var footer = '</svg>';
          var data = header + body + footer;
          return prefix + btoa(data);
        };

        SignaturePad.prototype.fromData = function (pointGroups) {
          var _this3 = this;

          this.clear();

          this._fromData(pointGroups, function (curve, widths) {
            return _this3._drawCurve(curve, widths.start, widths.end);
          }, function (rawPoint) {
            return _this3._drawDot(rawPoint);
          });

          this._data = pointGroups;
        };

        SignaturePad.prototype.toData = function () {
          return this._data;
        };

        return SignaturePad;
      });
      /***/

    },
    /* 681 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var stringify = __webpack_require__(807);

      var parse = __webpack_require__(806);

      var formats = __webpack_require__(414);

      module.exports = {
        formats: formats,
        parse: parse,
        stringify: stringify
      };
      /***/
    },
    /* 682 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _rcAnimate = __webpack_require__(43);

      var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

      var _isCssAnimationSupported = __webpack_require__(826);

      var _isCssAnimationSupported2 = _interopRequireDefault(_isCssAnimationSupported);

      var _omit = __webpack_require__(45);

      var _omit2 = _interopRequireDefault(_omit);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var __rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var Spin = function (_React$Component) {
        (0, _inherits3['default'])(Spin, _React$Component);

        function Spin(props) {
          (0, _classCallCheck3['default'])(this, Spin);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Spin.__proto__ || Object.getPrototypeOf(Spin)).call(this, props));

          var spinning = props.spinning;
          _this.state = {
            spinning: spinning
          };
          return _this;
        }

        (0, _createClass3['default'])(Spin, [{
          key: 'isNestedPattern',
          value: function isNestedPattern() {
            return !!(this.props && this.props.children);
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!(0, _isCssAnimationSupported2['default'])()) {
              // Show text in IE9
              this.setState({
                notCssAnimationSupported: true
              });
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.debounceTimeout) {
              clearTimeout(this.debounceTimeout);
            }

            if (this.delayTimeout) {
              clearTimeout(this.delayTimeout);
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var currentSpinning = this.props.spinning;
            var spinning = nextProps.spinning;
            var delay = this.props.delay;

            if (this.debounceTimeout) {
              clearTimeout(this.debounceTimeout);
            }

            if (currentSpinning && !spinning) {
              this.debounceTimeout = window.setTimeout(function () {
                return _this2.setState({
                  spinning: spinning
                });
              }, 200);

              if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
              }
            } else {
              if (spinning && delay && !isNaN(Number(delay))) {
                if (this.delayTimeout) {
                  clearTimeout(this.delayTimeout);
                }

                this.delayTimeout = window.setTimeout(function () {
                  return _this2.setState({
                    spinning: spinning
                  });
                }, delay);
              } else {
                this.setState({
                  spinning: spinning
                });
              }
            }
          }
        }, {
          key: 'renderIndicator',
          value: function renderIndicator() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                indicator = _props.indicator;
            var dotClassName = prefixCls + '-dot';

            if (React.isValidElement(indicator)) {
              return React.cloneElement(indicator, {
                className: (0, _classnames2['default'])(indicator.props.className, dotClassName)
              });
            }

            return React.createElement('span', {
              className: (0, _classnames2['default'])(dotClassName, prefixCls + '-dot-spin')
            }, React.createElement('i', null), React.createElement('i', null), React.createElement('i', null), React.createElement('i', null));
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _a = this.props,
                className = _a.className,
                size = _a.size,
                prefixCls = _a.prefixCls,
                tip = _a.tip,
                wrapperClassName = _a.wrapperClassName,
                restProps = __rest(_a, ["className", "size", "prefixCls", "tip", "wrapperClassName"]);

            var _state = this.state,
                spinning = _state.spinning,
                notCssAnimationSupported = _state.notCssAnimationSupported;
            var spinClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-spinning', spinning), (0, _defineProperty3['default'])(_classNames, prefixCls + '-show-text', !!tip || notCssAnimationSupported), _classNames), className); // fix https://fb.me/react-unknown-prop

            var divProps = (0, _omit2['default'])(restProps, ['spinning', 'delay', 'indicator']);
            var spinElement = React.createElement('div', (0, _extends3['default'])({}, divProps, {
              className: spinClassName
            }), this.renderIndicator(), tip ? React.createElement('div', {
              className: prefixCls + '-text'
            }, tip) : null);

            if (this.isNestedPattern()) {
              var _classNames2;

              var animateClassName = prefixCls + '-nested-loading';

              if (wrapperClassName) {
                animateClassName += ' ' + wrapperClassName;
              }

              var containerClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-container', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-blur', spinning), _classNames2));
              return React.createElement(_rcAnimate2['default'], (0, _extends3['default'])({}, divProps, {
                component: 'div',
                className: animateClassName,
                style: null,
                transitionName: 'fade'
              }), spinning && React.createElement('div', {
                key: 'loading'
              }, spinElement), React.createElement('div', {
                className: containerClassName,
                key: 'container'
              }, this.props.children));
            }

            return spinElement;
          }
        }]);
        return Spin;
      }(React.Component);

      exports['default'] = Spin;
      Spin.defaultProps = {
        prefixCls: 'ant-spin',
        spinning: true,
        size: 'default',
        wrapperClassName: ''
      };
      Spin.propTypes = {
        prefixCls: _propTypes2['default'].string,
        className: _propTypes2['default'].string,
        spinning: _propTypes2['default'].bool,
        size: _propTypes2['default'].oneOf(['small', 'default', 'large']),
        wrapperClassName: _propTypes2['default'].string,
        indicator: _propTypes2['default'].node
      };
      module.exports = exports['default'];
      /***/
    },
    /* 683 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _Upload = __webpack_require__(433);

      var _Upload2 = _interopRequireDefault(_Upload);

      var _Dragger = __webpack_require__(859);

      var _Dragger2 = _interopRequireDefault(_Dragger);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      _Upload2['default'].Dragger = _Dragger2['default'];
      exports['default'] = _Upload2['default'];
      module.exports = exports['default'];
      /***/
    },
    /* 684 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _extends3 = __webpack_require__(2);

      var _extends4 = _interopRequireDefault(_extends3);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _Slider = __webpack_require__(869);

      var _Slider2 = _interopRequireDefault(_Slider);

      var _Range = __webpack_require__(866);

      var _Range2 = _interopRequireDefault(_Range);

      var _Handle = __webpack_require__(434);

      var _Handle2 = _interopRequireDefault(_Handle);

      var _tooltip = __webpack_require__(312);

      var _tooltip2 = _interopRequireDefault(_tooltip);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var __rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var Slider = function (_React$Component) {
        (0, _inherits3['default'])(Slider, _React$Component);

        function Slider(props) {
          (0, _classCallCheck3['default'])(this, Slider);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

          _this.toggleTooltipVisible = function (index, visible) {
            _this.setState(function (_ref) {
              var visibles = _ref.visibles;
              return {
                visibles: (0, _extends4['default'])({}, visibles, (0, _defineProperty3['default'])({}, index, visible))
              };
            });
          };

          _this.handleWithTooltip = function (_a) {
            var value = _a.value,
                dragging = _a.dragging,
                index = _a.index,
                restProps = __rest(_a, ["value", "dragging", "index"]);

            var _this$props = _this.props,
                tooltipPrefixCls = _this$props.tooltipPrefixCls,
                tipFormatter = _this$props.tipFormatter;
            var visibles = _this.state.visibles;
            var visible = tipFormatter ? visibles[index] || dragging : false;
            return React.createElement(_tooltip2['default'], {
              prefixCls: tooltipPrefixCls,
              title: tipFormatter ? tipFormatter(value) : '',
              visible: visible,
              placement: 'top',
              transitionName: 'zoom-down',
              key: index
            }, React.createElement(_Handle2['default'], (0, _extends4['default'])({}, restProps, {
              value: value,
              onMouseEnter: function onMouseEnter() {
                return _this.toggleTooltipVisible(index, true);
              },
              onMouseLeave: function onMouseLeave() {
                return _this.toggleTooltipVisible(index, false);
              }
            })));
          };

          _this.saveSlider = function (node) {
            _this.rcSlider = node;
          };

          _this.state = {
            visibles: {}
          };
          return _this;
        }

        (0, _createClass3['default'])(Slider, [{
          key: 'focus',
          value: function focus() {
            this.rcSlider.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.rcSlider.focus();
          }
        }, {
          key: 'render',
          value: function render() {
            var _a = this.props,
                range = _a.range,
                restProps = __rest(_a, ["range"]);

            if (range) {
              return React.createElement(_Range2['default'], (0, _extends4['default'])({}, restProps, {
                ref: this.saveSlider,
                handle: this.handleWithTooltip
              }));
            }

            return React.createElement(_Slider2['default'], (0, _extends4['default'])({}, restProps, {
              ref: this.saveSlider,
              handle: this.handleWithTooltip
            }));
          }
        }]);
        return Slider;
      }(React.Component);

      exports['default'] = Slider;
      Slider.defaultProps = {
        prefixCls: 'ant-slider',
        tooltipPrefixCls: 'ant-tooltip',
        tipFormatter: function tipFormatter(value) {
          return value.toString();
        }
      };
      module.exports = exports['default'];
      /***/
    },
    /* 685 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _rcInputNumber = __webpack_require__(375);

      var _rcInputNumber2 = _interopRequireDefault(_rcInputNumber);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var __rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var InputNumber = function (_React$Component) {
        (0, _inherits3['default'])(InputNumber, _React$Component);

        function InputNumber() {
          (0, _classCallCheck3['default'])(this, InputNumber);
          return (0, _possibleConstructorReturn3['default'])(this, (InputNumber.__proto__ || Object.getPrototypeOf(InputNumber)).apply(this, arguments));
        }

        (0, _createClass3['default'])(InputNumber, [{
          key: 'render',
          value: function render() {
            var _classNames,
                _this2 = this;

            var _a = this.props,
                className = _a.className,
                size = _a.size,
                others = __rest(_a, ["className", "size"]);

            var inputNumberClass = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, this.props.prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, this.props.prefixCls + '-sm', size === 'small'), _classNames), className);
            return React.createElement(_rcInputNumber2['default'], (0, _extends3['default'])({
              ref: function ref(c) {
                return _this2.inputNumberRef = c;
              },
              className: inputNumberClass
            }, others));
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.inputNumberRef.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.inputNumberRef.blur();
          }
        }]);
        return InputNumber;
      }(React.Component);

      exports['default'] = InputNumber;
      InputNumber.defaultProps = {
        prefixCls: 'ant-input-number',
        step: 1
      };
      module.exports = exports['default'];
      /***/
    },
    /* 686 */

    /***/
    function (module, exports, __webpack_require__) {
      var createToPairs = __webpack_require__(872),
          keys = __webpack_require__(132);
      /**
       * Creates an array of own enumerable string keyed-value pairs for `object`
       * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
       * entries are returned.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias entries
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the key-value pairs.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.toPairs(new Foo);
       * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
       */


      var toPairs = createToPairs(keys);
      module.exports = toPairs;
      /***/
    },
    /* 687 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseUniq = __webpack_require__(326);
      /**
       * This method is like `_.uniq` except that it accepts `comparator` which
       * is invoked to compare elements of `array`. The order of result values is
       * determined by the order they occur in the array.The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.uniqWith(objects, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
       */


      function uniqWith(array, comparator) {
        comparator = typeof comparator == 'function' ? comparator : undefined;
        return array && array.length ? baseUniq(array, undefined, comparator) : [];
      }

      module.exports = uniqWith;
      /***/
    },
    /* 688 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayPush = __webpack_require__(239),
          baseFlatten = __webpack_require__(320),
          copyArray = __webpack_require__(246),
          isArray = __webpack_require__(55);
      /**
       * Creates a new array concatenating `array` with any additional arrays
       * and/or values.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to concatenate.
       * @param {...*} [values] The values to concatenate.
       * @returns {Array} Returns the new concatenated array.
       * @example
       *
       * var array = [1];
       * var other = _.concat(array, 2, [3], [[4]]);
       *
       * console.log(other);
       * // => [1, 2, 3, [4]]
       *
       * console.log(array);
       * // => [1]
       */


      function concat() {
        var length = arguments.length;

        if (!length) {
          return [];
        }

        var args = Array(length - 1),
            array = arguments[0],
            index = length;

        while (index--) {
          args[index - 1] = arguments[index];
        }

        return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }

      module.exports = concat;
      /***/
    },
    /* 689 */

    /***/
    function (module, exports, __webpack_require__) {
      (function (global, factory) {
        true ? module.exports = factory() : undefined;
      })(this, function () {
        'use strict';

        var freeze$1 = Object.freeze || function (x) {
          return x;
        };

        var html = freeze$1(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

        var svg = freeze$1(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'audio', 'canvas', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'video', 'view', 'vkern']);
        var svgFilters = freeze$1(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
        var mathMl = freeze$1(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);
        var text = freeze$1(['#text']);

        var freeze$2 = Object.freeze || function (x) {
          return x;
        };

        var html$1 = freeze$2(['accept', 'action', 'align', 'alt', 'autocomplete', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'coords', 'crossorigin', 'datetime', 'default', 'dir', 'disabled', 'download', 'enctype', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'integrity', 'ismap', 'label', 'lang', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'multiple', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns']);
        var svg$1 = freeze$2(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
        var mathMl$1 = freeze$2(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
        var xml = freeze$2(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);
        var hasOwnProperty = Object.hasOwnProperty;
        var setPrototypeOf = Object.setPrototypeOf;

        var _ref$1 = typeof Reflect !== 'undefined' && Reflect;

        var apply$1 = _ref$1.apply;

        if (!apply$1) {
          apply$1 = function apply(fun, thisValue, args) {
            return fun.apply(thisValue, args);
          };
        }
        /* Add properties to a lookup table */


        function addToSet(set, array) {
          if (setPrototypeOf) {
            // Make 'in' and truthy checks like Boolean(set.constructor)
            // independent of any properties defined on Object.prototype.
            // Prevent prototype setters from intercepting set as a this value.
            setPrototypeOf(set, null);
          }

          var l = array.length;

          while (l--) {
            var element = array[l];

            if (typeof element === 'string') {
              var lcElement = element.toLowerCase();

              if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!Object.isFrozen(array)) {
                  array[l] = lcElement;
                }

                element = lcElement;
              }
            }

            set[element] = true;
          }

          return set;
        }
        /* Shallow clone an object */


        function clone(object) {
          var newObject = {};
          var property = void 0;

          for (property in object) {
            if (apply$1(hasOwnProperty, object, [property])) {
              newObject[property] = object[property];
            }
          }

          return newObject;
        }

        var seal = Object.seal || function (x) {
          return x;
        };

        var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

        var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
        var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

        var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

        var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
        );
        var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
        var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g // eslint-disable-line no-control-regex
        );

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        function _toConsumableArray(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          } else {
            return Array.from(arr);
          }
        }

        var _ref = typeof Reflect !== 'undefined' && Reflect;

        var apply = _ref.apply;
        var arraySlice = Array.prototype.slice;
        var freeze = Object.freeze;

        var getGlobal = function getGlobal() {
          return typeof window === 'undefined' ? null : window;
        };

        if (!apply) {
          apply = function apply(fun, thisValue, args) {
            return fun.apply(thisValue, args);
          };
        }
        /**
         * Creates a no-op policy for internal use only.
         * Don't export this function outside this module!
         * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
         * @param {Document} document The document object (to determine policy name suffix)
         * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
         * are not supported).
         */


        var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
          if ((typeof trustedTypes === 'undefined' ? 'undefined' : _typeof(trustedTypes)) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
            return null;
          } // Allow the callers to control the unique policy name
          // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
          // Policy creation with duplicate names throws in Trusted Types.


          var suffix = null;
          var ATTR_NAME = 'data-tt-policy-suffix';

          if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
            suffix = document.currentScript.getAttribute(ATTR_NAME);
          }

          var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

          try {
            return trustedTypes.createPolicy(policyName, {
              createHTML: function createHTML(html$$1) {
                return html$$1;
              }
            });
          } catch (error) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
          }
        };

        function createDOMPurify() {
          var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

          var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
          };
          /**
           * Version label, exposed for easier checks
           * if DOMPurify is up to date or not
           */


          DOMPurify.version = '1.0.10';
          /**
           * Array of elements that DOMPurify removed during sanitation.
           * Empty if nothing was removed.
           */

          DOMPurify.removed = [];

          if (!window || !window.document || window.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
          }

          var originalDocument = window.document;
          var useDOMParser = false;
          var removeTitle = false;
          var document = window.document;
          var DocumentFragment = window.DocumentFragment,
              HTMLTemplateElement = window.HTMLTemplateElement,
              Node = window.Node,
              NodeFilter = window.NodeFilter,
              _window$NamedNodeMap = window.NamedNodeMap,
              NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
              Text = window.Text,
              Comment = window.Comment,
              DOMParser = window.DOMParser,
              TrustedTypes = window.TrustedTypes; // As per issue #47, the web-components registry is inherited by a
          // new document created via createHTMLDocument. As per the spec
          // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
          // a new empty registry is used when creating a template contents owner
          // document, so we use that as our parent document to ensure nothing
          // is inherited.

          if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');

            if (template.content && template.content.ownerDocument) {
              document = template.content.ownerDocument;
            }
          }

          var trustedTypesPolicy = _createTrustedTypesPolicy(TrustedTypes, originalDocument);

          var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
          var _document = document,
              implementation = _document.implementation,
              createNodeIterator = _document.createNodeIterator,
              getElementsByTagName = _document.getElementsByTagName,
              createDocumentFragment = _document.createDocumentFragment;
          var importNode = originalDocument.importNode;
          var hooks = {};
          /**
           * Expose whether this browser supports running the full DOMPurify.
           */

          DOMPurify.isSupported = implementation && typeof implementation.createHTMLDocument !== 'undefined' && document.documentMode !== 9;
          var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR,
              ERB_EXPR$$1 = ERB_EXPR,
              DATA_ATTR$$1 = DATA_ATTR,
              ARIA_ATTR$$1 = ARIA_ATTR,
              IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA,
              ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
          var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;
          /**
           * We consider the elements and attributes below to be safe. Ideally
           * don't add any new ones but feel free to remove unwanted ones.
           */

          /* allowed element names */

          var ALLOWED_TAGS = null;
          var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(svgFilters), _toConsumableArray(mathMl), _toConsumableArray(text)));
          /* Allowed attribute names */

          var ALLOWED_ATTR = null;
          var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(mathMl$1), _toConsumableArray(xml)));
          /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

          var FORBID_TAGS = null;
          /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

          var FORBID_ATTR = null;
          /* Decide if ARIA attributes are okay */

          var ALLOW_ARIA_ATTR = true;
          /* Decide if custom data attributes are okay */

          var ALLOW_DATA_ATTR = true;
          /* Decide if unknown protocols are okay */

          var ALLOW_UNKNOWN_PROTOCOLS = false;
          /* Output should be safe for jQuery's $() factory? */

          var SAFE_FOR_JQUERY = false;
          /* Output should be safe for common template engines.
           * This means, DOMPurify removes data attributes, mustaches and ERB
           */

          var SAFE_FOR_TEMPLATES = false;
          /* Decide if document with <html>... should be returned */

          var WHOLE_DOCUMENT = false;
          /* Track whether config is already set on this instance of DOMPurify. */

          var SET_CONFIG = false;
          /* Decide if all elements (e.g. style, script) must be children of
           * document.body. By default, browsers might move them to document.head */

          var FORCE_BODY = false;
          /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
           * string (or a TrustedHTML object if Trusted Types are supported).
           * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
           */

          var RETURN_DOM = false;
          /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
           * string  (or a TrustedHTML object if Trusted Types are supported) */

          var RETURN_DOM_FRAGMENT = false;
          /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
           * `Node` is imported into the current `Document`. If this flag is not enabled the
           * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
           * DOMPurify. */

          var RETURN_DOM_IMPORT = false;
          /* Output should be free from DOM clobbering attacks? */

          var SANITIZE_DOM = true;
          /* Keep element content when removing element? */

          var KEEP_CONTENT = true;
          /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
           * of importing it into a new Document and returning a sanitized copy */

          var IN_PLACE = false;
          /* Allow usage of profiles like html, svg and mathMl */

          var USE_PROFILES = {};
          /* Tags to ignore content of when KEEP_CONTENT is true */

          var FORBID_CONTENTS = addToSet({}, ['audio', 'head', 'math', 'script', 'style', 'template', 'svg', 'video']);
          /* Tags that are safe for data: URIs */

          var DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image']);
          /* Attributes safe for values like "javascript:" */

          var URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'summary', 'title', 'value', 'style', 'xmlns']);
          /* Keep a reference to config to pass to hooks */

          var CONFIG = null;
          /* Ideally, do not touch anything below this line */

          /* ______________________________________________ */

          var formElement = document.createElement('form');
          /**
           * _parseConfig
           *
           * @param  {Object} cfg optional config literal
           */
          // eslint-disable-next-line complexity

          var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) {
              return;
            }
            /* Shield configuration object from tampering */


            if (!cfg || (typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
              cfg = {};
            }
            /* Set configuration parameters */


            ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

            SAFE_FOR_JQUERY = cfg.SAFE_FOR_JQUERY || false; // Default false

            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

            RETURN_DOM = cfg.RETURN_DOM || false; // Default false

            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

            RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT || false; // Default false

            FORCE_BODY = cfg.FORCE_BODY || false; // Default false

            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

            IN_PLACE = cfg.IN_PLACE || false; // Default false

            IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;

            if (SAFE_FOR_TEMPLATES) {
              ALLOW_DATA_ATTR = false;
            }

            if (RETURN_DOM_FRAGMENT) {
              RETURN_DOM = true;
            }
            /* Parse profile info */


            if (USE_PROFILES) {
              ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(text)));
              ALLOWED_ATTR = [];

              if (USE_PROFILES.html === true) {
                addToSet(ALLOWED_TAGS, html);
                addToSet(ALLOWED_ATTR, html$1);
              }

              if (USE_PROFILES.svg === true) {
                addToSet(ALLOWED_TAGS, svg);
                addToSet(ALLOWED_ATTR, svg$1);
                addToSet(ALLOWED_ATTR, xml);
              }

              if (USE_PROFILES.svgFilters === true) {
                addToSet(ALLOWED_TAGS, svgFilters);
                addToSet(ALLOWED_ATTR, svg$1);
                addToSet(ALLOWED_ATTR, xml);
              }

              if (USE_PROFILES.mathMl === true) {
                addToSet(ALLOWED_TAGS, mathMl);
                addToSet(ALLOWED_ATTR, mathMl$1);
                addToSet(ALLOWED_ATTR, xml);
              }
            }
            /* Merge configuration parameters */


            if (cfg.ADD_TAGS) {
              if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
                ALLOWED_TAGS = clone(ALLOWED_TAGS);
              }

              addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
            }

            if (cfg.ADD_ATTR) {
              if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
                ALLOWED_ATTR = clone(ALLOWED_ATTR);
              }

              addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
            }

            if (cfg.ADD_URI_SAFE_ATTR) {
              addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
            }
            /* Add #text in case KEEP_CONTENT is set to true */


            if (KEEP_CONTENT) {
              ALLOWED_TAGS['#text'] = true;
            }
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


            if (WHOLE_DOCUMENT) {
              addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
            }
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286 */


            if (ALLOWED_TAGS.table) {
              addToSet(ALLOWED_TAGS, ['tbody']);
            } // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.


            if (freeze) {
              freeze(cfg);
            }

            CONFIG = cfg;
          };
          /**
           * _forceRemove
           *
           * @param  {Node} node a DOM node
           */


          var _forceRemove = function _forceRemove(node) {
            DOMPurify.removed.push({
              element: node
            });

            try {
              node.parentNode.removeChild(node);
            } catch (error) {
              node.outerHTML = emptyHTML;
            }
          };
          /**
           * _removeAttribute
           *
           * @param  {String} name an Attribute name
           * @param  {Node} node a DOM node
           */


          var _removeAttribute = function _removeAttribute(name, node) {
            try {
              DOMPurify.removed.push({
                attribute: node.getAttributeNode(name),
                from: node
              });
            } catch (error) {
              DOMPurify.removed.push({
                attribute: null,
                from: node
              });
            }

            node.removeAttribute(name);
          };
          /**
           * _initDocument
           *
           * @param  {String} dirty a string of dirty markup
           * @return {Document} a DOM, filled with the dirty markup
           */


          var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */
            var doc = void 0;
            var leadingWhitespace = void 0;

            if (FORCE_BODY) {
              dirty = '<remove></remove>' + dirty;
            } else {
              /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
              var matches = dirty.match(/^[\s]+/);
              leadingWhitespace = matches && matches[0];

              if (leadingWhitespace) {
                dirty = dirty.slice(leadingWhitespace.length);
              }
            }
            /* Use DOMParser to workaround Firefox bug (see comment below) */


            if (useDOMParser) {
              try {
                doc = new DOMParser().parseFromString(dirty, 'text/html');
              } catch (error) {}
            }
            /* Remove title to fix a mXSS bug in older MS Edge */


            if (removeTitle) {
              addToSet(FORBID_TAGS, ['title']);
            }
            /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
            Safari (see comment below) */


            if (!doc || !doc.documentElement) {
              doc = implementation.createHTMLDocument('');
              var _doc = doc,
                  body = _doc.body;
              body.parentNode.removeChild(body.parentNode.firstElementChild);
              body.outerHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            }

            if (leadingWhitespace) {
              doc.body.insertBefore(document.createTextNode(leadingWhitespace), doc.body.childNodes[0] || null);
            }
            /* Work on whole document or just its body */


            return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
          }; // Firefox uses a different parser for innerHTML rather than
          // DOMParser (see https://bugzilla.mozilla.org/show_bug.cgi?id=1205631)
          // which means that you *must* use DOMParser, otherwise the output may
          // not be safe if used in a document.write context later.
          //
          // So we feature detect the Firefox bug and use the DOMParser if necessary.
          //
          // MS Edge, in older versions, is affected by an mXSS behavior. The second
          // check tests for the behavior and fixes it if necessary.


          if (DOMPurify.isSupported) {
            (function () {
              try {
                var doc = _initDocument('<svg><p><style><img src="</style><img src=x onerror=1//">');

                if (doc.querySelector('svg img')) {
                  useDOMParser = true;
                }
              } catch (error) {}
            })();

            (function () {
              try {
                var doc = _initDocument('<x/><title>&lt;/title&gt;&lt;img&gt;');

                if (doc.querySelector('title').innerHTML.match(/<\/title/)) {
                  removeTitle = true;
                }
              } catch (error) {}
            })();
          }
          /**
           * _createIterator
           *
           * @param  {Document} root document/fragment to create iterator for
           * @return {Iterator} iterator instance
           */


          var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, function () {
              return NodeFilter.FILTER_ACCEPT;
            }, false);
          };
          /**
           * _isClobbered
           *
           * @param  {Node} elm element to check for clobbering attacks
           * @return {Boolean} true if clobbered, false if safe
           */


          var _isClobbered = function _isClobbered(elm) {
            if (elm instanceof Text || elm instanceof Comment) {
              return false;
            }

            if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function') {
              return true;
            }

            return false;
          };
          /**
           * _isNode
           *
           * @param  {Node} obj object to check whether it's a DOM node
           * @return {Boolean} true is object is a DOM node
           */


          var _isNode = function _isNode(obj) {
            return (typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? obj instanceof Node : obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string';
          };
          /**
           * _executeHook
           * Execute user configurable hooks
           *
           * @param  {String} entryPoint  Name of the hook's entry point
           * @param  {Node} currentNode node to work on with the hook
           * @param  {Object} data additional hook parameters
           */


          var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) {
              return;
            }

            hooks[entryPoint].forEach(function (hook) {
              hook.call(DOMPurify, currentNode, data, CONFIG);
            });
          };
          /**
           * _sanitizeElements
           *
           * @protect nodeName
           * @protect textContent
           * @protect removeChild
           *
           * @param   {Node} currentNode to check for permission to exist
           * @return  {Boolean} true if node was killed, false if left alive
           */
          // eslint-disable-next-line complexity


          var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content = void 0;
            /* Execute a hook if present */

            _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */


            if (_isClobbered(currentNode)) {
              _forceRemove(currentNode);

              return true;
            }
            /* Now let's check the element's type and name */


            var tagName = currentNode.nodeName.toLowerCase();
            /* Execute a hook if present */

            _executeHook('uponSanitizeElement', currentNode, {
              tagName: tagName,
              allowedTags: ALLOWED_TAGS
            });
            /* Remove element if anything forbids its presence */


            if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
              /* Keep content except for black-listed elements */
              if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && typeof currentNode.insertAdjacentHTML === 'function') {
                try {
                  var htmlToInsert = currentNode.innerHTML;
                  currentNode.insertAdjacentHTML('AfterEnd', trustedTypesPolicy ? trustedTypesPolicy.createHTML(htmlToInsert) : htmlToInsert);
                } catch (error) {}
              }

              _forceRemove(currentNode);

              return true;
            }
            /* Remove in case a noscript/noembed XSS is suspected */


            if (tagName === 'noscript' && currentNode.innerHTML.match(/<\/noscript/i)) {
              _forceRemove(currentNode);

              return true;
            }

            if (tagName === 'noembed' && currentNode.innerHTML.match(/<\/noembed/i)) {
              _forceRemove(currentNode);

              return true;
            }
            /* Convert markup to cover jQuery behavior */


            if (SAFE_FOR_JQUERY && !currentNode.firstElementChild && (!currentNode.content || !currentNode.content.firstElementChild) && /</g.test(currentNode.textContent)) {
              DOMPurify.removed.push({
                element: currentNode.cloneNode()
              });

              if (currentNode.innerHTML) {
                currentNode.innerHTML = currentNode.innerHTML.replace(/</g, '&lt;');
              } else {
                currentNode.innerHTML = currentNode.textContent.replace(/</g, '&lt;');
              }
            }
            /* Sanitize element content to be template-safe */


            if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
              /* Get the element's text content */
              content = currentNode.textContent;
              content = content.replace(MUSTACHE_EXPR$$1, ' ');
              content = content.replace(ERB_EXPR$$1, ' ');

              if (currentNode.textContent !== content) {
                DOMPurify.removed.push({
                  element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
              }
            }
            /* Execute a hook if present */


            _executeHook('afterSanitizeElements', currentNode, null);

            return false;
          };
          /**
           * _isValidAttribute
           *
           * @param  {string} lcTag Lowercase tag name of containing element.
           * @param  {string} lcName Lowercase attribute name.
           * @param  {string} value Attribute value.
           * @return {Boolean} Returns true if `value` is valid, otherwise false.
           */
          // eslint-disable-next-line complexity


          var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */
            if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
              return false;
            }
            /* Allow valid data-* attributes: At least one character after "-"
                (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
                XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
                We don't need to check the value; it's always URI safe. */


            if (ALLOW_DATA_ATTR && DATA_ATTR$$1.test(lcName)) {// This attribute is safe
            } else if (ALLOW_ARIA_ATTR && ARIA_ATTR$$1.test(lcName)) {// This attribute is safe

              /* Otherwise, check the name is permitted */
            } else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
              return false;
              /* Check value is safe. First, is attr inert? If so, is safe */
            } else if (URI_SAFE_ATTRIBUTES[lcName]) {// This attribute is safe

              /* Check no script, data or unknown possibly unsafe URI
                unless we know URI values are safe for that attribute */
            } else if (IS_ALLOWED_URI$$1.test(value.replace(ATTR_WHITESPACE$$1, ''))) {// This attribute is safe

              /* Keep image data URIs alive if src/xlink:href is allowed */

              /* Further prevent gadget XSS for dynamically built script tags */
            } else if ((lcName === 'src' || lcName === 'xlink:href') && lcTag !== 'script' && value.indexOf('data:') === 0 && DATA_URI_TAGS[lcTag]) {// This attribute is safe

              /* Allow unknown protocols: This provides support for links that
                are handled by protocol handlers which may be unknown ahead of
                time, e.g. fb:, spotify: */
            } else if (ALLOW_UNKNOWN_PROTOCOLS && !IS_SCRIPT_OR_DATA$$1.test(value.replace(ATTR_WHITESPACE$$1, ''))) {// This attribute is safe

              /* Check for binary attributes */
              // eslint-disable-next-line no-negated-condition
            } else if (!value) {// Binary attributes are safe at this point

              /* Anything else, presume unsafe, do not add it back */
            } else {
              return false;
            }

            return true;
          };
          /**
           * _sanitizeAttributes
           *
           * @protect attributes
           * @protect nodeName
           * @protect removeAttribute
           * @protect setAttribute
           *
           * @param  {Node} currentNode to sanitize
           */


          var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr = void 0;
            var value = void 0;
            var lcName = void 0;
            var idAttr = void 0;
            var l = void 0;
            /* Execute a hook if present */

            _executeHook('beforeSanitizeAttributes', currentNode, null);

            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */

            if (!attributes) {
              return;
            }

            var hookEvent = {
              attrName: '',
              attrValue: '',
              keepAttr: true,
              allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */

            while (l--) {
              attr = attributes[l];
              var _attr = attr,
                  name = _attr.name,
                  namespaceURI = _attr.namespaceURI;
              value = attr.value.trim();
              lcName = name.toLowerCase();
              /* Execute a hook if present */

              hookEvent.attrName = lcName;
              hookEvent.attrValue = value;
              hookEvent.keepAttr = true;

              _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

              value = hookEvent.attrValue;
              /* Remove attribute */
              // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
              // remove a "name" attribute from an <img> tag that has an "id"
              // attribute at the time.

              if (lcName === 'name' && currentNode.nodeName === 'IMG' && attributes.id) {
                idAttr = attributes.id;
                attributes = apply(arraySlice, attributes, []);

                _removeAttribute('id', currentNode);

                _removeAttribute(name, currentNode);

                if (attributes.indexOf(idAttr) > l) {
                  currentNode.setAttribute('id', idAttr.value);
                }
              } else if ( // This works around a bug in Safari, where input[type=file]
              // cannot be dynamically set after type has been removed
              currentNode.nodeName === 'INPUT' && lcName === 'type' && value === 'file' && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
                continue;
              } else {
                // This avoids a crash in Safari v9.0 with double-ids.
                // The trick is to first set the id to be empty and then to
                // remove the attribute
                if (name === 'id') {
                  currentNode.setAttribute(name, '');
                }

                _removeAttribute(name, currentNode);
              }
              /* Did the hooks approve of the attribute? */


              if (!hookEvent.keepAttr) {
                continue;
              }
              /* Sanitize attribute content to be template-safe */


              if (SAFE_FOR_TEMPLATES) {
                value = value.replace(MUSTACHE_EXPR$$1, ' ');
                value = value.replace(ERB_EXPR$$1, ' ');
              }
              /* Is `value` valid for this attribute? */


              var lcTag = currentNode.nodeName.toLowerCase();

              if (!_isValidAttribute(lcTag, lcName, value)) {
                continue;
              }
              /* Handle invalid data-* attribute set by try-catching it */


              try {
                if (namespaceURI) {
                  currentNode.setAttributeNS(namespaceURI, name, value);
                } else {
                  /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
                  currentNode.setAttribute(name, value);
                }

                DOMPurify.removed.pop();
              } catch (error) {}
            }
            /* Execute a hook if present */


            _executeHook('afterSanitizeAttributes', currentNode, null);
          };
          /**
           * _sanitizeShadowDOM
           *
           * @param  {DocumentFragment} fragment to iterate over recursively
           */


          var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode = void 0;

            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */


            _executeHook('beforeSanitizeShadowDOM', fragment, null);

            while (shadowNode = shadowIterator.nextNode()) {
              /* Execute a hook if present */
              _executeHook('uponSanitizeShadowNode', shadowNode, null);
              /* Sanitize tags and elements */


              if (_sanitizeElements(shadowNode)) {
                continue;
              }
              /* Deep shadow DOM detected */


              if (shadowNode.content instanceof DocumentFragment) {
                _sanitizeShadowDOM(shadowNode.content);
              }
              /* Check attributes, sanitize if necessary */


              _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */


            _executeHook('afterSanitizeShadowDOM', fragment, null);
          };
          /**
           * Sanitize
           * Public method providing core sanitation functionality
           *
           * @param {String|Node} dirty string or DOM node
           * @param {Object} configuration object
           */
          // eslint-disable-next-line complexity


          DOMPurify.sanitize = function (dirty, cfg) {
            var body = void 0;
            var importedNode = void 0;
            var currentNode = void 0;
            var oldNode = void 0;
            var returnNode = void 0;
            /* Make sure we have a string to sanitize.
              DO NOT return early, as this will return the wrong type if
              the user has requested a DOM object rather than a string */

            if (!dirty) {
              dirty = '<!-->';
            }
            /* Stringify, in case dirty is an object */


            if (typeof dirty !== 'string' && !_isNode(dirty)) {
              // eslint-disable-next-line no-negated-condition
              if (typeof dirty.toString !== 'function') {
                throw new TypeError('toString is not a function');
              } else {
                dirty = dirty.toString();

                if (typeof dirty !== 'string') {
                  throw new TypeError('dirty is not a string, aborting');
                }
              }
            }
            /* Check we can run. Otherwise fall back or ignore */


            if (!DOMPurify.isSupported) {
              if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
                if (typeof dirty === 'string') {
                  return window.toStaticHTML(dirty);
                }

                if (_isNode(dirty)) {
                  return window.toStaticHTML(dirty.outerHTML);
                }
              }

              return dirty;
            }
            /* Assign config vars */


            if (!SET_CONFIG) {
              _parseConfig(cfg);
            }
            /* Clean up removed elements */


            DOMPurify.removed = [];

            if (IN_PLACE) {
              /* No special handling necessary for in-place sanitization */
            } else if (dirty instanceof Node) {
              /* If dirty is a DOM element, append to an empty document to avoid
                 elements being stripped by the parser */
              body = _initDocument('<!-->');
              importedNode = body.ownerDocument.importNode(dirty, true);

              if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
                /* Node is already a body, use as is */
                body = importedNode;
              } else {
                // eslint-disable-next-line unicorn/prefer-node-append
                body.appendChild(importedNode);
              }
            } else {
              /* Exit directly if we have nothing to do */
              if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
                return trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
              }
              /* Initialize the document to work on */


              body = _initDocument(dirty);
              /* Check we have a DOM node from the data */

              if (!body) {
                return RETURN_DOM ? null : emptyHTML;
              }
            }
            /* Remove first element node (ours) if FORCE_BODY is set */


            if (body && FORCE_BODY) {
              _forceRemove(body.firstChild);
            }
            /* Get node iterator */


            var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */


            while (currentNode = nodeIterator.nextNode()) {
              /* Fix IE's strange behavior with manipulated textNodes #89 */
              if (currentNode.nodeType === 3 && currentNode === oldNode) {
                continue;
              }
              /* Sanitize tags and elements */


              if (_sanitizeElements(currentNode)) {
                continue;
              }
              /* Shadow DOM detected, sanitize it */


              if (currentNode.content instanceof DocumentFragment) {
                _sanitizeShadowDOM(currentNode.content);
              }
              /* Check attributes, sanitize if necessary */


              _sanitizeAttributes(currentNode);

              oldNode = currentNode;
            }

            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */

            if (IN_PLACE) {
              return dirty;
            }
            /* Return sanitized string or DOM */


            if (RETURN_DOM) {
              if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);

                while (body.firstChild) {
                  // eslint-disable-next-line unicorn/prefer-node-append
                  returnNode.appendChild(body.firstChild);
                }
              } else {
                returnNode = body;
              }

              if (RETURN_DOM_IMPORT) {
                /* AdoptNode() is not used because internal state is not reset
                       (e.g. the past names map of a HTMLFormElement), this is safe
                       in theory but we would rather not risk another attack vector.
                       The state that is cloned by importNode() is explicitly defined
                       by the specs. */
                returnNode = importNode.call(originalDocument, returnNode, true);
              }

              return returnNode;
            }

            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Sanitize final string template-safe */

            if (SAFE_FOR_TEMPLATES) {
              serializedHTML = serializedHTML.replace(MUSTACHE_EXPR$$1, ' ');
              serializedHTML = serializedHTML.replace(ERB_EXPR$$1, ' ');
            }

            return trustedTypesPolicy ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
          };
          /**
           * Public method to set the configuration once
           * setConfig
           *
           * @param {Object} cfg configuration object
           */


          DOMPurify.setConfig = function (cfg) {
            _parseConfig(cfg);

            SET_CONFIG = true;
          };
          /**
           * Public method to remove the configuration
           * clearConfig
           *
           */


          DOMPurify.clearConfig = function () {
            CONFIG = null;
            SET_CONFIG = false;
          };
          /**
           * Public method to check if an attribute value is valid.
           * Uses last set config, if any. Otherwise, uses config defaults.
           * isValidAttribute
           *
           * @param  {string} tag Tag name of containing element.
           * @param  {string} attr Attribute name.
           * @param  {string} value Attribute value.
           * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
           */


          DOMPurify.isValidAttribute = function (tag, attr, value) {
            /* Initialize shared config vars if necessary. */
            if (!CONFIG) {
              _parseConfig({});
            }

            var lcTag = tag.toLowerCase();
            var lcName = attr.toLowerCase();
            return _isValidAttribute(lcTag, lcName, value);
          };
          /**
           * AddHook
           * Public method to add DOMPurify hooks
           *
           * @param {String} entryPoint entry point for the hook to add
           * @param {Function} hookFunction function to execute
           */


          DOMPurify.addHook = function (entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') {
              return;
            }

            hooks[entryPoint] = hooks[entryPoint] || [];
            hooks[entryPoint].push(hookFunction);
          };
          /**
           * RemoveHook
           * Public method to remove a DOMPurify hook at a given entryPoint
           * (pops it from the stack of hooks if more are present)
           *
           * @param {String} entryPoint entry point for the hook to remove
           */


          DOMPurify.removeHook = function (entryPoint) {
            if (hooks[entryPoint]) {
              hooks[entryPoint].pop();
            }
          };
          /**
           * RemoveHooks
           * Public method to remove all DOMPurify hooks at a given entryPoint
           *
           * @param  {String} entryPoint entry point for the hooks to remove
           */


          DOMPurify.removeHooks = function (entryPoint) {
            if (hooks[entryPoint]) {
              hooks[entryPoint] = [];
            }
          };
          /**
           * RemoveAllHooks
           * Public method to remove all DOMPurify hooks
           *
           */


          DOMPurify.removeAllHooks = function () {
            hooks = {};
          };

          return DOMPurify;
        }

        var purify = createDOMPurify();
        return purify;
      });
      /***/

    },
    /* 690 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGetTag = __webpack_require__(135),
          isObjectLike = __webpack_require__(109);
      /** `Object#toString` result references. */


      var numberTag = '[object Number]';
      /**
       * Checks if `value` is classified as a `Number` primitive or object.
       *
       * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
       * classified as numbers, use the `_.isFinite` method.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a number, else `false`.
       * @example
       *
       * _.isNumber(3);
       * // => true
       *
       * _.isNumber(Number.MIN_VALUE);
       * // => true
       *
       * _.isNumber(Infinity);
       * // => true
       *
       * _.isNumber('3');
       * // => false
       */

      function isNumber(value) {
        return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
      }

      module.exports = isNumber;
      /***/
    },
    /* 691 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseAssignValue = __webpack_require__(210),
          baseForOwn = __webpack_require__(321),
          baseIteratee = __webpack_require__(202);
      /**
       * Creates an object with the same keys as `object` and values generated
       * by running each own enumerable string keyed property of `object` thru
       * `iteratee`. The iteratee is invoked with three arguments:
       * (value, key, object).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns the new mapped object.
       * @see _.mapKeys
       * @example
       *
       * var users = {
       *   'fred':    { 'user': 'fred',    'age': 40 },
       *   'pebbles': { 'user': 'pebbles', 'age': 1 }
       * };
       *
       * _.mapValues(users, function(o) { return o.age; });
       * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
       *
       * // The `_.property` iteratee shorthand.
       * _.mapValues(users, 'age');
       * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
       */


      function mapValues(object, iteratee) {
        var result = {};
        iteratee = baseIteratee(iteratee, 3);
        baseForOwn(object, function (value, key, object) {
          baseAssignValue(result, key, iteratee(value, key, object));
        });
        return result;
      }

      module.exports = mapValues;
      /***/
    },
    /* 692 */

    /***/
    function (module, exports, __webpack_require__) {
      var root = __webpack_require__(103),
          toString = __webpack_require__(140);
      /** Used to match leading and trailing whitespace. */


      var reTrimStart = /^\s+/;
      /* Built-in method references for those with the same name as other `lodash` methods. */

      var nativeParseInt = root.parseInt;
      /**
       * Converts `string` to an integer of the specified radix. If `radix` is
       * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
       * hexadecimal, in which case a `radix` of `16` is used.
       *
       * **Note:** This method aligns with the
       * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category String
       * @param {string} string The string to convert.
       * @param {number} [radix=10] The radix to interpret `value` by.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.parseInt('08');
       * // => 8
       *
       * _.map(['6', '08', '10'], _.parseInt);
       * // => [6, 8, 10]
       */

      function parseInt(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }

        return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
      }

      module.exports = parseInt;
      /***/
    },
    /* 693 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        mixins: true,
        propTypes: true,
        type: true
      };
      var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        arguments: true,
        arity: true
      };
      var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

      module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
        if (typeof sourceComponent !== 'string') {
          // don't hoist over string (html) components
          var keys = Object.getOwnPropertyNames(sourceComponent);
          /* istanbul ignore else */

          if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
          }

          for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
              try {
                targetComponent[keys[i]] = sourceComponent[keys[i]];
              } catch (error) {}
            }
          }
        }

        return targetComponent;
      };
      /***/

    },
    /* 694 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      var ReactIs = __webpack_require__(261);

      var REACT_STATICS = {
        childContextTypes: true,
        contextType: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromError: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
      };
      var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
      };
      var FORWARD_REF_STATICS = {
        '$$typeof': true,
        render: true,
        defaultProps: true,
        displayName: true,
        propTypes: true
      };
      var MEMO_STATICS = {
        '$$typeof': true,
        compare: true,
        defaultProps: true,
        displayName: true,
        propTypes: true,
        type: true
      };
      var TYPE_STATICS = {};
      TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

      function getStatics(component) {
        if (ReactIs.isMemo(component)) {
          return MEMO_STATICS;
        }

        return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
      }

      var defineProperty = Object.defineProperty;
      var getOwnPropertyNames = Object.getOwnPropertyNames;
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      var getPrototypeOf = Object.getPrototypeOf;
      var objectPrototype = Object.prototype;

      function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') {
          // don't hoist over string (html) components
          if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);

            if (inheritedComponent && inheritedComponent !== objectPrototype) {
              hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
          }

          var keys = getOwnPropertyNames(sourceComponent);

          if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
          }

          var targetStatics = getStatics(targetComponent);
          var sourceStatics = getStatics(sourceComponent);

          for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];

            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
              var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

              try {
                // Avoid failures from read-only properties
                defineProperty(targetComponent, key, descriptor);
              } catch (e) {}
            }
          }

          return targetComponent;
        }

        return targetComponent;
      }

      module.exports = hoistNonReactStatics;
      /***/
    },
    /* 695 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _default = __webpack_require__(238);

      var _default2 = _interopRequireDefault(_default);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      exports['default'] = _default2['default'];
      module.exports = exports['default'];
      /***/
    },
    /* 696 */

    /***/
    function (module) {
      module.exports = {
        "a": "3.4.0"
      };
      /***/
    },
    /* 697 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright 2014-2015, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       */

      /**
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */

      var warning = function warning() {};

      if (false) {}

      module.exports = warning;
      /***/
    },
    /* 698 */

    /***/
    function (module, exports, __webpack_require__) {
      var Symbol = __webpack_require__(158),
          copyArray = __webpack_require__(246),
          getTag = __webpack_require__(153),
          isArrayLike = __webpack_require__(134),
          isString = __webpack_require__(121),
          iteratorToArray = __webpack_require__(944),
          mapToArray = __webpack_require__(331),
          setToArray = __webpack_require__(240),
          stringToArray = __webpack_require__(943),
          values = __webpack_require__(378);
      /** `Object#toString` result references. */


      var mapTag = '[object Map]',
          setTag = '[object Set]';
      /** Built-in value references. */

      var symIterator = Symbol ? Symbol.iterator : undefined;
      /**
       * Converts `value` to an array.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Array} Returns the converted array.
       * @example
       *
       * _.toArray({ 'a': 1, 'b': 2 });
       * // => [1, 2]
       *
       * _.toArray('abc');
       * // => ['a', 'b', 'c']
       *
       * _.toArray(1);
       * // => []
       *
       * _.toArray(null);
       * // => []
       */

      function toArray(value) {
        if (!value) {
          return [];
        }

        if (isArrayLike(value)) {
          return isString(value) ? stringToArray(value) : copyArray(value);
        }

        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }

        var tag = getTag(value),
            func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }

      module.exports = toArray;
      /***/
    },
    /* 699 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return customHTML2Content;
      });
      /* harmony import */


      var draft_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31);
      /* harmony import */


      var draft_js__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(draft_js__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var lodash_toArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(698);
      /* harmony import */


      var lodash_toArray__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_toArray__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var immutable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66);
      /* harmony import */


      var immutable__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_2__);

      function compose() {
        for (var _len = arguments.length, argument = Array(_len), _key = 0; _key < _len; _key++) {
          argument[_key] = arguments[_key];
        }

        var args = arguments;
        var start = args.length - 1;
        return function () {
          var i = start;
          var result = args[start].apply(this, arguments);

          while (i--) {
            result = args[i].call(this, result);
          }

          return result;
        };
      }

      ;
      /*
       * Helpers
       */
      // Prepares img meta data object based on img attributes

      var getBlockSpecForElement = function getBlockSpecForElement(imgElement) {
        return {
          contentType: 'image',
          src: imgElement.getAttribute('src'),
          width: imgElement.getAttribute('width'),
          height: imgElement.getAttribute('height'),
          align: imgElement.style.cssFloat
        };
      }; // Wraps meta data in HTML element which is 'understandable' by Draft, I used <blockquote />.


      var wrapBlockSpec = function wrapBlockSpec(blockSpec) {
        if (blockSpec == null) {
          return null;
        }

        var tempEl = document.createElement('blockquote'); // stringify meta data and insert it as text content of temp HTML element. We will later extract
        // and parse it.

        tempEl.innerText = JSON.stringify(blockSpec);
        return tempEl;
      }; // Replaces <img> element with our temp element


      var replaceElement = function replaceElement(oldEl, newEl) {
        if (!(newEl instanceof HTMLElement)) {
          return;
        }

        var parentNode = oldEl.parentNode;
        return parentNode.replaceChild(newEl, oldEl);
      };

      var elementToBlockSpecElement = compose(wrapBlockSpec, getBlockSpecForElement);

      var imgReplacer = function imgReplacer(imgElement) {
        return replaceElement(imgElement, elementToBlockSpecElement(imgElement));
      }; // creates ContentBlock based on provided spec


      var createContentBlock = function createContentBlock(blockData, contentState) {
        var key = blockData.key,
            type = blockData.type,
            text = blockData.text,
            data = blockData.data,
            inlineStyles = blockData.inlineStyles,
            entityData = blockData.entityData;
        var blockSpec = {
          type: type != null ? type : 'unstyled',
          text: text != null ? text : '',
          key: key != null ? key : Object(draft_js__WEBPACK_IMPORTED_MODULE_0__["genKey"])(),
          data: null,
          characterList: Object(immutable__WEBPACK_IMPORTED_MODULE_2__["List"])([])
        };

        if (data) {
          blockSpec.data = Object(immutable__WEBPACK_IMPORTED_MODULE_2__["fromJS"])(data);
        }

        if (inlineStyles || entityData) {
          var entityKey = void 0;

          if (entityData) {
            var _type = entityData.type,
                mutability = entityData.mutability,
                _data = entityData.data;
            contentState.createEntity(_type, mutability, _data);
            entityKey = contentState.getLastCreatedEntityKey();
          } else {
            entityKey = null;
          }

          var style = Object(immutable__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"])(inlineStyles || []);
          var charData = draft_js__WEBPACK_IMPORTED_MODULE_0__["CharacterMetadata"].create({
            style: style,
            entityKey: entityKey
          });
          blockSpec.characterList = Object(immutable__WEBPACK_IMPORTED_MODULE_2__["List"])(Object(immutable__WEBPACK_IMPORTED_MODULE_2__["Repeat"])(charData, text.length));
        }

        return new draft_js__WEBPACK_IMPORTED_MODULE_0__["ContentBlock"](blockSpec);
      }; // takes HTML string and returns DraftJS ContentState


      function customHTML2Content(HTML, contentState) {
        var tempDoc = new DOMParser().parseFromString(HTML, 'text/html'); // replace all <img /> with <blockquote /> elements

        lodash_toArray__WEBPACK_IMPORTED_MODULE_1___default()(tempDoc.querySelectorAll('img')).forEach(imgReplacer); // use DraftJS converter to do initial conversion. I don't provide DOMBuilder and
        // blockRenderMap arguments here since it should fall back to its default ones, which are fine

        var _convertFromHTML = Object(draft_js__WEBPACK_IMPORTED_MODULE_0__["convertFromHTML"])(tempDoc.body.innerHTML),
            contentBlocks = _convertFromHTML.contentBlocks; // now replace <blockquote /> ContentBlocks with 'atomic' ones


        contentBlocks = contentBlocks.reduce(function (contentBlocks, block) {
          if (block.getType() !== 'blockquote') {
            return contentBlocks.concat(block);
          }

          var image = JSON.parse(block.getText());
          contentState.createEntity('IMAGE-ENTITY', 'IMMUTABLE', image);
          var entityKey = contentState.getLastCreatedEntityKey();
          var charData = draft_js__WEBPACK_IMPORTED_MODULE_0__["CharacterMetadata"].create({
            entity: entityKey
          }); // const blockSpec = Object.assign({ type: 'atomic', text: ' ' }, { entityData })
          // const atomicBlock = createContentBlock(blockSpec)
          // const spacerBlock = createContentBlock({});

          var fragmentArray = [new draft_js__WEBPACK_IMPORTED_MODULE_0__["ContentBlock"]({
            key: Object(draft_js__WEBPACK_IMPORTED_MODULE_0__["genKey"])(),
            type: 'image-block',
            text: ' ',
            characterList: Object(immutable__WEBPACK_IMPORTED_MODULE_2__["List"])(Object(immutable__WEBPACK_IMPORTED_MODULE_2__["Repeat"])(charData, charData.count()))
          }), new draft_js__WEBPACK_IMPORTED_MODULE_0__["ContentBlock"]({
            key: Object(draft_js__WEBPACK_IMPORTED_MODULE_0__["genKey"])(),
            type: 'unstyled',
            text: '',
            characterList: Object(immutable__WEBPACK_IMPORTED_MODULE_2__["List"])()
          })];
          return contentBlocks.concat(fragmentArray);
        }, []); // console.log('>> customHTML2Content contentBlocks', contentBlocks);

        tempDoc = null;
        return draft_js__WEBPACK_IMPORTED_MODULE_0__["BlockMapBuilder"].createFromArray(contentBlocks);
      }
      /***/

    },
    /* 700 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var immutable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66);
      /* harmony import */


      var immutable__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_0__);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var ConfigStore = function () {
        function ConfigStore() {
          _classCallCheck(this, ConfigStore);

          this._store = Object(immutable__WEBPACK_IMPORTED_MODULE_0__["Map"])();
        }

        ConfigStore.prototype.set = function set(key, value) {
          this._store = this._store.set(key, value);
        };

        ConfigStore.prototype.get = function get(key) {
          return this._store.get(key);
        };

        return ConfigStore;
      }();
      /* harmony default export */


      __webpack_exports__["a"] = ConfigStore;
      /***/
    },
    /* 701 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      exports.default = function (obj) {
        if (obj == null) throw new TypeError("Cannot destructure undefined");
      };
      /***/

    },
    /* 702 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _reactDom = __webpack_require__(16);

      var _eventlistener = __webpack_require__(1040);

      var _lodash = __webpack_require__(1039);

      var _lodash2 = _interopRequireDefault(_lodash);

      var _lodash3 = __webpack_require__(485);

      var _lodash4 = _interopRequireDefault(_lodash3);

      var _parentScroll = __webpack_require__(1038);

      var _parentScroll2 = _interopRequireDefault(_parentScroll);

      var _inViewport = __webpack_require__(1037);

      var _inViewport2 = _interopRequireDefault(_inViewport);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var LazyLoad = function (_Component) {
        _inherits(LazyLoad, _Component);

        function LazyLoad(props) {
          _classCallCheck(this, LazyLoad);

          var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

          _this.lazyLoadHandler = _this.lazyLoadHandler.bind(_this);

          if (props.throttle > 0) {
            if (props.debounce) {
              _this.lazyLoadHandler = (0, _lodash2.default)(_this.lazyLoadHandler, props.throttle);
            } else {
              _this.lazyLoadHandler = (0, _lodash4.default)(_this.lazyLoadHandler, props.throttle);
            }
          }

          _this.state = {
            visible: false
          };
          return _this;
        }

        _createClass(LazyLoad, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this._mounted = true;
            var eventNode = this.getEventNode();
            this.lazyLoadHandler();

            if (this.lazyLoadHandler.flush) {
              this.lazyLoadHandler.flush();
            }

            (0, _eventlistener.add)(window, 'resize', this.lazyLoadHandler);
            (0, _eventlistener.add)(eventNode, 'scroll', this.lazyLoadHandler);
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps() {
            if (!this.state.visible) {
              this.lazyLoadHandler();
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(_nextProps, nextState) {
            return nextState.visible;
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this._mounted = false;

            if (this.lazyLoadHandler.cancel) {
              this.lazyLoadHandler.cancel();
            }

            this.detachListeners();
          }
        }, {
          key: 'getEventNode',
          value: function getEventNode() {
            return (0, _parentScroll2.default)((0, _reactDom.findDOMNode)(this));
          }
        }, {
          key: 'getOffset',
          value: function getOffset() {
            var _props = this.props,
                offset = _props.offset,
                offsetVertical = _props.offsetVertical,
                offsetHorizontal = _props.offsetHorizontal,
                offsetTop = _props.offsetTop,
                offsetBottom = _props.offsetBottom,
                offsetLeft = _props.offsetLeft,
                offsetRight = _props.offsetRight,
                threshold = _props.threshold;

            var _offsetAll = threshold || offset;

            var _offsetVertical = offsetVertical || _offsetAll;

            var _offsetHorizontal = offsetHorizontal || _offsetAll;

            return {
              top: offsetTop || _offsetVertical,
              bottom: offsetBottom || _offsetVertical,
              left: offsetLeft || _offsetHorizontal,
              right: offsetRight || _offsetHorizontal
            };
          }
        }, {
          key: 'lazyLoadHandler',
          value: function lazyLoadHandler() {
            if (!this._mounted) {
              return;
            }

            var offset = this.getOffset();
            var node = (0, _reactDom.findDOMNode)(this);
            var eventNode = this.getEventNode();

            if ((0, _inViewport2.default)(node, eventNode, offset)) {
              var onContentVisible = this.props.onContentVisible;
              this.setState({
                visible: true
              }, function () {
                if (onContentVisible) {
                  onContentVisible();
                }
              });
              this.detachListeners();
            }
          }
        }, {
          key: 'detachListeners',
          value: function detachListeners() {
            var eventNode = this.getEventNode();
            (0, _eventlistener.remove)(window, 'resize', this.lazyLoadHandler);
            (0, _eventlistener.remove)(eventNode, 'scroll', this.lazyLoadHandler);
          }
        }, {
          key: 'render',
          value: function render() {
            var _props2 = this.props,
                children = _props2.children,
                className = _props2.className,
                height = _props2.height,
                width = _props2.width;
            var visible = this.state.visible;
            var elStyles = {
              height: height,
              width: width
            };
            var elClasses = 'LazyLoad' + (visible ? ' is-visible' : '') + (className ? ' ' + className : '');
            return _react2.default.createElement(this.props.elementType, {
              className: elClasses,
              style: elStyles
            }, visible && _react.Children.only(children));
          }
        }]);

        return LazyLoad;
      }(_react.Component);

      exports.default = LazyLoad;
      LazyLoad.propTypes = {
        children: _propTypes2.default.node.isRequired,
        className: _propTypes2.default.string,
        debounce: _propTypes2.default.bool,
        elementType: _propTypes2.default.string,
        height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        offset: _propTypes2.default.number,
        offsetBottom: _propTypes2.default.number,
        offsetHorizontal: _propTypes2.default.number,
        offsetLeft: _propTypes2.default.number,
        offsetRight: _propTypes2.default.number,
        offsetTop: _propTypes2.default.number,
        offsetVertical: _propTypes2.default.number,
        threshold: _propTypes2.default.number,
        throttle: _propTypes2.default.number,
        width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        onContentVisible: _propTypes2.default.func
      };
      LazyLoad.defaultProps = {
        elementType: 'div',
        debounce: true,
        offset: 0,
        offsetBottom: 0,
        offsetHorizontal: 0,
        offsetLeft: 0,
        offsetRight: 0,
        offsetTop: 0,
        offsetVertical: 0,
        throttle: 250
      };
      /***/
    },
    /* 703 */

    /***/
    function (module, exports, __webpack_require__) {
      /**
       * Module dependencies
       */
      var matches = __webpack_require__(1041);
      /**
       * @param element {Element}
       * @param selector {String}
       * @param context {Element}
       * @return {Element}
       */


      module.exports = function (element, selector, context) {
        context = context || document; // guard against orphans

        element = {
          parentNode: element
        };

        while ((element = element.parentNode) && element !== context) {
          if (matches(element, selector)) {
            return element;
          }
        }
      };
      /***/

    },
    /* 704 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(1059);
      /***/
    },
    /* 705 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      module.exports = function isNegativeZero(number) {
        return number === 0 && 1 / number === -Infinity;
      };
      /***/

    },
    /* 706 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      var ReactIs = __webpack_require__(261);

      var REACT_STATICS = {
        childContextTypes: true,
        contextType: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromError: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
      };
      var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
      };
      var FORWARD_REF_STATICS = {
        '$$typeof': true,
        render: true,
        defaultProps: true,
        displayName: true,
        propTypes: true
      };
      var MEMO_STATICS = {
        '$$typeof': true,
        compare: true,
        defaultProps: true,
        displayName: true,
        propTypes: true,
        type: true
      };
      var TYPE_STATICS = {};
      TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

      function getStatics(component) {
        if (ReactIs.isMemo(component)) {
          return MEMO_STATICS;
        }

        return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
      }

      var defineProperty = Object.defineProperty;
      var getOwnPropertyNames = Object.getOwnPropertyNames;
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      var getPrototypeOf = Object.getPrototypeOf;
      var objectPrototype = Object.prototype;

      function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') {
          // don't hoist over string (html) components
          if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);

            if (inheritedComponent && inheritedComponent !== objectPrototype) {
              hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
          }

          var keys = getOwnPropertyNames(sourceComponent);

          if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
          }

          var targetStatics = getStatics(targetComponent);
          var sourceStatics = getStatics(sourceComponent);

          for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];

            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
              var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

              try {
                // Avoid failures from read-only properties
                defineProperty(targetComponent, key, descriptor);
              } catch (e) {}
            }
          }

          return targetComponent;
        }

        return targetComponent;
      }

      module.exports = hoistNonReactStatics;
      /***/
    },
    /* 707 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseHas = __webpack_require__(1092),
          hasPath = __webpack_require__(509);
      /**
       * Checks if `path` is a direct property of `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       * @example
       *
       * var object = { 'a': { 'b': 2 } };
       * var other = _.create({ 'a': _.create({ 'b': 2 }) });
       *
       * _.has(object, 'a');
       * // => true
       *
       * _.has(object, 'a.b');
       * // => true
       *
       * _.has(object, ['a', 'b']);
       * // => true
       *
       * _.has(other, 'a');
       * // => false
       */


      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }

      module.exports = has;
      /***/
    },
    /* 708 */

    /***/
    function (module, exports, __webpack_require__) {
      (function (global, factory) {
        true ? module.exports = factory() : undefined;
      })(this, function () {
        'use strict';

        function arrayTreeFilter(data, filterFn, options) {
          options = options || {};
          options.childrenKeyName = options.childrenKeyName || "children";
          var children = data || [];
          var result = [];
          var level = 0;

          do {
            var foundItem = children.filter(function (item) {
              return filterFn(item, level);
            })[0];

            if (!foundItem) {
              break;
            }

            result.push(foundItem);
            children = foundItem[options.childrenKeyName] || [];
            level += 1;
          } while (children.length > 0);

          return result;
        }

        return arrayTreeFilter;
      });
      /***/

    },
    /* 709 */

    /***/
    function (module, exports) {
      module.exports = function shallowEqualArrays(arrA, arrB) {
        if (arrA === arrB) {
          return true;
        }

        if (!arrA || !arrB) {
          return false;
        }

        var len = arrA.length;

        if (arrB.length !== len) {
          return false;
        }

        for (var i = 0; i < len; i++) {
          if (arrA[i] !== arrB[i]) {
            return false;
          }
        }

        return true;
      };
      /***/

    },
    /* 710 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict"; //      
      // An event handler can take an optional event argument
      // and should not return a value
      // An array of all currently registered event handlers for a type
      // A map of event types and their corresponding event handlers.

      /** Mitt: Tiny (~200b) functional event emitter / pubsub.
       *  @name mitt
       *  @returns {Mitt}
       */

      function mitt(all) {
        all = all || Object.create(null);
        return {
          /**
           * Register an event handler for the given type.
           *
           * @param  {String} type	Type of event to listen for, or `"*"` for all events
           * @param  {Function} handler Function to call in response to given event
           * @memberOf mitt
           */
          on: function on(type, handler) {
            (all[type] || (all[type] = [])).push(handler);
          },

          /**
           * Remove an event handler for the given type.
           *
           * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
           * @param  {Function} handler Handler function to remove
           * @memberOf mitt
           */
          off: function off(type, handler) {
            if (all[type]) {
              all[type].splice(all[type].indexOf(handler) >>> 0, 1);
            }
          },

          /**
           * Invoke all handlers for the given type.
           * If present, `"*"` handlers are invoked after type-matched handlers.
           *
           * @param {String} type  The event type to invoke
           * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
           * @memberOf mitt
           */
          emit: function emit(type, evt) {
            (all[type] || []).slice().map(function (handler) {
              handler(evt);
            });
            (all['*'] || []).slice().map(function (handler) {
              handler(type, evt);
            });
          }
        };
      }
      /* harmony default export */


      __webpack_exports__["a"] = mitt;
      /***/
    },
    /* 711 */

    /***/
    function (module, exports) {
      exports.version = "1.9.3";
      /***/
    },
    /* 712 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utilities_1 = __webpack_require__(1192);

      exports.filter = utilities_1.filter;
      exports.check = utilities_1.check;
      exports.propType = utilities_1.propType;

      var graphql_1 = __webpack_require__(663);

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = graphql_1.graphql;
      /***/
    },
    /* 713 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return symbolObservablePonyfill;
      });

      function symbolObservablePonyfill(root) {
        var result;
        var Symbol = root.Symbol;

        if (typeof Symbol === 'function') {
          if (Symbol.observable) {
            result = Symbol.observable;
          } else {
            result = Symbol('observable');
            Symbol.observable = result;
          }
        } else {
          result = '@@observable';
        }

        return result;
      }

      ;
      /***/
    },
    /* 714 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/lodash/assign.js


      var lodash_assign = __webpack_require__(674);

      var assign_default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_assign); // EXTERNAL MODULE: ./node_modules/eventemitter3/index.js


      var eventemitter3 = __webpack_require__(673);

      var eventemitter3_default =
      /*#__PURE__*/
      __webpack_require__.n(eventemitter3); // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/dist-es/lib/supportPassiveEvent.js

      /* global window */


      var passiveSupported = false; // eslint-disable-line import/no-mutable-exports

      if (typeof window !== 'undefined') {
        try {
          var supportPassiveEvent_options = Object.defineProperty({}, 'passive', {
            get: function get() {
              passiveSupported = true;
            }
          });
          window.addEventListener('test', null, supportPassiveEvent_options);
        } catch (err) {} // eslint-disable-line no-empty

      }
      /* harmony default export */


      var lib_supportPassiveEvent = passiveSupported; // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/dist-es/globalVars.js

      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      /* harmony default export */

      var globalVars = {
        connections: {},
        EE: new eventemitter3_default.a(),
        enableResizeInfo: false,
        enableScrollInfo: false,
        listeners: {},
        removers: [],
        supportPassiveEvent: lib_supportPassiveEvent
      }; // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/dist-es/lib/listen.js

      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      var listen_supportPassiveEvent = globalVars.supportPassiveEvent;
      var listen_defaultEventOption = {
        capture: false,
        passive: false
      };
      /**
       * Cross-browser addEventListener.
       * @method listen
       * @param {Object} target - The target to add event listener.
       * @param {String} eventType - The event type.
       * @param {Function} handler - The event handler.
       * @param {Object} handler - The options object that specifies
       * characteristics about the event listener.
       * @return {Object} The object to be able to remove the handler.
       */

      function listen_listen(target, eventType, handler, options) {
        var add = 'addEventListener';
        var _remove = 'removeEventListener';
        var type = eventType;
        var eventOptions = listen_supportPassiveEvent ? assign_default()({}, listen_defaultEventOption, options) : false;

        if (!target.addEventListener && target.attachEvent) {
          add = 'attachEvent';
          _remove = 'detachEvent';
          type = 'on' + eventType;
        }

        target[add](type, handler, eventOptions);
        return {
          remove: function remove() {
            target[_remove](eventType, handler);
          }
        };
      }
      /* harmony default export */


      var lib_listen = listen_listen; // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/dist-es/lib/leIE8.js

      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      /* global navigator, parseFloat */
      // less then or equal to IE8

      var leIE8 = false; // eslint-disable-line import/no-mutable-exports

      if (typeof navigator !== 'undefined') {
        var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);

        if (matches) {
          leIE8 = parseFloat(matches[1], 10) < 9;
        }
      }
      /* harmony default export */


      var lib_leIE8 = leIE8; // EXTERNAL MODULE: ./node_modules/lodash/clone.js

      var clone = __webpack_require__(672);

      var clone_default =
      /*#__PURE__*/
      __webpack_require__.n(clone); // EXTERNAL MODULE: ./node_modules/lodash/throttle.js


      var lodash_throttle = __webpack_require__(671);

      var throttle_default =
      /*#__PURE__*/
      __webpack_require__.n(lodash_throttle); // EXTERNAL MODULE: ./node_modules/lodash/noop.js


      var noop = __webpack_require__(9);

      var noop_default =
      /*#__PURE__*/
      __webpack_require__.n(noop); // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/dist-es/AugmentedEvent.js


      var AugmentedEvent_createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function AugmentedEvent_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      /* global window, document */


      var AugmentedEvent_resize = {
        // eslint-disable-line prefer-const
        width: 0,
        height: 0
      };
      var AugmentedEvent_scroll = {
        // eslint-disable-line prefer-const
        delta: 0,
        top: 0
      };
      var AugmentedEvent_touch = {
        // eslint-disable-line prefer-const
        axisIntention: '',
        startX: 0,
        startY: 0,
        deltaX: 0,
        deltaY: 0
      };
      var AugmentedEvent_INTENTION_THRESHOLD = 5;

      var AugmentedEvent_getXY = function getXY(pos) {
        var t = {
          x: 0,
          y: 0
        }; // eslint-disable-line prefer-const

        var docBody = document.body;
        var docEl = document.documentElement;

        if (pos.pageX || pos.pageY) {
          t.x = pos.pageX;
          t.y = pos.pageY;
        } else {
          t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
          t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
        }

        return t;
      };
      /**
       * ArgmentedEvent will hold some global information, such like window scroll postion,
       * so that those information is only calculated once.
       * @param {Object} option - The option for SyntheticEvent
       */


      var AugmentedEvent_AugmentedEvent = function () {
        function AugmentedEvent() {
          var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          AugmentedEvent_classCallCheck(this, AugmentedEvent);
          var mainType = (option.mainType || '').toLowerCase();
          var subType = (option.subType || '').toLowerCase();
          this.mainType = mainType;
          this.subType = subType;
          this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
          this.scroll = AugmentedEvent_scroll;
          this.resize = AugmentedEvent_resize;
          this.touch = AugmentedEvent_touch;
        }

        AugmentedEvent_createClass(AugmentedEvent, [{
          key: 'update',
          value: function update(e) {
            var mainType = this.mainType,
                subType = this.subType;
            var docEl = document.documentElement;

            if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
              var top = docEl.scrollTop + document.body.scrollTop; // Prevent delta from being 0

              if (top !== this.scroll.top) {
                this.scroll.delta = top - this.scroll.top;
                this.scroll.top = top;
              }
            }

            if (globalVars.enableResizeInfo && mainType === 'resize') {
              this.resize.width = window.innerWidth || docEl.clientWidth;
              this.resize.height = window.innerHeight || docEl.clientHeight;
            }

            if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
              var pos = void 0;
              var absX = void 0;
              var absY = void 0;

              if (mainType === 'touchstart' || subType === 'start') {
                pos = AugmentedEvent_getXY(e.touches[0]);
                this.touch.axisIntention = '';
                this.touch.startX = pos.x;
                this.touch.startY = pos.y;
                this.touch.deltaX = 0;
                this.touch.deltaY = 0;
              } else if (mainType === 'touchmove') {
                pos = AugmentedEvent_getXY(e.touches[0]);
                this.touch.deltaX = pos.x - this.touch.startX;
                this.touch.deltaY = pos.y - this.touch.startY;

                if (this.touch.axisIntention === '') {
                  absX = Math.abs(this.touch.deltaX);
                  absY = Math.abs(this.touch.deltaY);

                  if (absX > AugmentedEvent_INTENTION_THRESHOLD && absX >= absY) {
                    this.touch.axisIntention = 'x';
                  } else if (absY > AugmentedEvent_INTENTION_THRESHOLD && absY > absX) {
                    this.touch.axisIntention = 'y';
                  }
                }
              }
            }
          }
        }]);
        return AugmentedEvent;
      }();
      /* harmony default export */


      var dist_es_AugmentedEvent = AugmentedEvent_AugmentedEvent; // EXTERNAL MODULE: ./node_modules/raf/index.js

      var raf = __webpack_require__(381);

      var raf_default =
      /*#__PURE__*/
      __webpack_require__.n(raf); // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/dist-es/lib/rAFThrottle.js

      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */


      var rAFThrottle_getTime = Date.now ||
      /* istanbul ignore next */
      function () {
        return new Date().getTime();
      };

      function rAFThrottle_rAFThrottle(func) {
        var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
        var context = void 0;
        var args = void 0;
        var last = 0;
        var requestId = 0;

        var later = function later() {
          var now = rAFThrottle_getTime();
          var remaining = throttle - (now - last);

          if (remaining <= 0) {
            last = now;
            requestId = 0;
            func.apply(context, args);
          } else {
            requestId = raf_default()(later);
          }
        };

        return function throttledFunc() {
          context = this;
          args = arguments; // eslint-disable-line prefer-rest-params

          if (!requestId) {
            requestId = raf_default()(later);
          }
        };
      }
      /* harmony default export */


      var lib_rAFThrottle = rAFThrottle_rAFThrottle; // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/dist-es/constants.js

      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      var EVENT_END_DELAY = 100;
      var DEFAULT_THROTTLE_RATE = 50; // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/dist-es/mainEventConnectors.js

      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      /* global window, document, setTimeout */
      // constants

      var mainEventConnectors_connections = globalVars.connections,
          mainEventConnectors_EE = globalVars.EE,
          mainEventConnectors_listeners = globalVars.listeners,
          mainEventConnectors_removers = globalVars.removers; // global variables

      var mainEventConnectors_doc = void 0;
      var mainEventConnectors_win = void 0;
      var mainEventConnectors_body = void 0;
      var mainEventConnectors_hashId = 0;

      if (typeof window !== 'undefined') {
        mainEventConnectors_win = window;
        mainEventConnectors_doc = mainEventConnectors_win.document || document;
        mainEventConnectors_body = mainEventConnectors_doc.body;
      }

      function mainEventConnectors_getHash(domNode) {
        return domNode.id || 'target-id-' + mainEventConnectors_hashId++; // eslint-disable-line
      }
      /**
       * Connect a throttled event to a throttled main event, and return an event remover.
       * The number of connections to a throttled main event will be kept. If all throttled events
       * are removed, then remove throttled main event.
       * @method connectThrottle
       * @param {String} throttledEvent - A throttled event
       * @param {Function} cb - Callback function
       * @param {Object} ctx - The "this"
       * @param {String} throttledMainEvent - A throttled main event
       * @return {Object} An event remover
       */


      function mainEventConnectors_connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
        mainEventConnectors_EE.on(throttledEvent, cb || noop_default.a, ctx);
        throttledMainEvent = throttledMainEvent || throttledEvent;
        mainEventConnectors_connections[throttledMainEvent] = (mainEventConnectors_connections[throttledMainEvent] || 0) + 1;
        return {
          _type: throttledEvent,
          _cb: cb,
          _ctx: ctx,
          unsubscribe: function unsubscribe() {
            if (!this._type) {
              return;
            }

            mainEventConnectors_EE.removeListener(throttledEvent, cb, ctx);
            mainEventConnectors_connections[throttledMainEvent]--;

            if (mainEventConnectors_connections[throttledMainEvent] === 0) {
              mainEventConnectors_listeners[throttledMainEvent].remove();
              mainEventConnectors_listeners[throttledMainEvent] = undefined;
            }

            this._type = undefined;
            this._cb = undefined;
            this._ctx = undefined; // remove the remover from removers array

            for (var i = mainEventConnectors_removers.length - 1; i >= 0; i--) {
              var remover = mainEventConnectors_removers[i];

              if (remover === this) {
                mainEventConnectors_removers.splice(i, 1);
                break;
              }
            }
          }
        };
      }
      /**
       * Connect to event, event start and event end.
       * @method connectContinuousEvent
       * @param {Object} target - The target of a main event, window or document.
       * @param {String} mainEvent - A browser event, like scroll or resize.
       * @param {String} event - A subscribe event.
       * @param {Object} eventOptions - An options pass to event listener
       */


      function mainEventConnectors_connectContinuousEvent(target, mainEvent, event) {
        return function throttleEvent(throttleRate, cb, options, eventOptions) {
          var context = options.context;
          var domTarget = options.target;
          var domId = domTarget && mainEventConnectors_getHash(domTarget);
          var targetPart = domId ? ':' + domId : '';
          var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
          var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
          var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
          var throttledEvent = event + ':' + throttleRate + targetPart;
          var remover = mainEventConnectors_connectThrottle(throttledEvent, cb, context, throttledMainEvent);
          mainEventConnectors_removers.push(remover);

          if (mainEventConnectors_listeners[throttledMainEvent]) {
            return remover;
          }

          var ae = {
            start: new dist_es_AugmentedEvent({
              mainType: mainEvent,
              subType: 'start'
            }),
            // start
            main: new dist_es_AugmentedEvent({
              mainType: mainEvent
            }),
            // main
            end: new dist_es_AugmentedEvent({
              mainType: mainEvent,
              subType: 'end'
            })
          }; // No throttle for throttleRate = 0
          // end

          if (throttleRate === 'raf') {
            throttleRate = 16; // Set as a number for setTimeout later.

            handler = lib_rAFThrottle(handler);
          } else if (throttleRate > 0) {
            handler = throttle_default()(handler, throttleRate);
          }

          var timer = void 0;

          function endCallback(e) {
            ae.end.update(e);
            mainEventConnectors_EE.emit(throttledEndEvent, e, ae.end);
            timer = null;
          }

          function handler(e) {
            if (!timer) {
              ae.start.update(e);
              mainEventConnectors_EE.emit(throttledStartEvent, e, ae.start);
            }

            clearTimeout(timer);
            ae.main.update(e);
            mainEventConnectors_EE.emit(throttledMainEvent, e, ae.main);

            if (!lib_leIE8) {
              timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
            } else {
              // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
              timer = setTimeout(function () {
                endCallback(clone_default()(e));
              }, throttleRate + EVENT_END_DELAY);
            }
          }

          mainEventConnectors_listeners[throttledMainEvent] = lib_listen(domTarget || target, mainEvent, handler, eventOptions);
          return remover;
        };
      }

      function mainEventConnectors_connectDiscreteEvent(target, event) {
        return function throttleEvent(throttleRate, cb, options, eventOptions) {
          var context = options.context;
          var domTarget = options.target;
          var domId = domTarget && mainEventConnectors_getHash(domTarget); // no throttling for discrete event

          var throttledEvent = event + ':0' + (domId ? ':' + domId : '');
          var remover = mainEventConnectors_connectThrottle(throttledEvent, cb, context);
          mainEventConnectors_removers.push(remover);

          if (mainEventConnectors_listeners[throttledEvent]) {
            return remover;
          }

          var ae = new dist_es_AugmentedEvent({
            mainType: event
          });

          function handler(e) {
            ae.update(e);
            mainEventConnectors_EE.emit(throttledEvent, e, ae);
          }

          mainEventConnectors_listeners[throttledEvent] = lib_listen(domTarget || target, event, handler, eventOptions);
          return remover;
        };
      }
      /* harmony default export */


      var mainEventConnectors = {
        scrollStart: mainEventConnectors_connectContinuousEvent(mainEventConnectors_win, 'scroll', 'scrollStart'),
        scrollEnd: mainEventConnectors_connectContinuousEvent(mainEventConnectors_win, 'scroll', 'scrollEnd'),
        scroll: mainEventConnectors_connectContinuousEvent(mainEventConnectors_win, 'scroll', 'scroll'),
        resizeStart: mainEventConnectors_connectContinuousEvent(mainEventConnectors_win, 'resize', 'resizeStart'),
        resizeEnd: mainEventConnectors_connectContinuousEvent(mainEventConnectors_win, 'resize', 'resizeEnd'),
        resize: mainEventConnectors_connectContinuousEvent(mainEventConnectors_win, 'resize', 'resize'),
        visibilitychange: mainEventConnectors_connectDiscreteEvent(mainEventConnectors_doc, 'visibilitychange'),
        touchmoveStart: mainEventConnectors_connectContinuousEvent(mainEventConnectors_body, 'touchmove', 'touchmoveStart'),
        touchmoveEnd: mainEventConnectors_connectContinuousEvent(mainEventConnectors_body, 'touchmove', 'touchmoveEnd'),
        touchmove: mainEventConnectors_connectContinuousEvent(mainEventConnectors_body, 'touchmove', 'touchmove'),
        touchstart: mainEventConnectors_connectDiscreteEvent(mainEventConnectors_body, 'touchstart'),
        touchend: mainEventConnectors_connectDiscreteEvent(mainEventConnectors_body, 'touchend')
      }; // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/dist-es/subscribe.js

      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */
      // less then or equal to IE8
      // constants

      /**
       * Subscribe to UI events.
       * @method subscribe
       * @param {String} type - The type of event.
       * @param {Function} cb - The callback function.
       * @param {Object} options.context - The caller.
       * @param {Number} options.throttleRate - The amount of time for throttling.
       * @param {Boolean} options.useRAF - Use rAF for throttling if true.
       * @param {Object} options.eventOptions - Option to pass to event listener
       * @return {Object} The object with unsubscribe function.
       */

      function subscribe_subscribe(type, cb) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var useRAF = options.useRAF || false;
        var throttleRate = parseInt(options.throttleRate, 10);
        var eventOptions = options.eventOptions;

        if (isNaN(throttleRate)) {
          throttleRate = DEFAULT_THROTTLE_RATE;
        }

        if (useRAF) {
          throttleRate = 'raf';
        } // turn off throttle if the browser is IE8 or less, because window.event will be reset
        // when using any delayed function, i.g., setTimeout, or rAF.


        if (lib_leIE8) {
          throttleRate = 0;
        } // once those variables enabled, then never disabled.


        globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
        globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
        globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;
        return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
      }
      /* harmony default export */


      var dist_es_subscribe = subscribe_subscribe; // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/dist-es/unsubscribe.js

      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      var unsubscribe_removers = globalVars.removers;
      /**
       * Unsubscribe to UI events.
       * @method unsubscribe
       * @param {String} type - The type of event.
       * @param {Function} cb - The callback function.
       */

      function unsubscribe_unsubscribe(type, cb) {
        var remover = void 0;

        for (var i = unsubscribe_removers.length - 1; i >= 0; i -= 1) {
          remover = unsubscribe_removers[i];

          if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
            remover.unsubscribe();
            unsubscribe_removers.splice(i, 1);
          }
        }
      }
      /* harmony default export */


      var dist_es_unsubscribe = unsubscribe_unsubscribe; // CONCATENATED MODULE: ./node_modules/subscribe-ui-event/index.es.js

      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "listen", function () {
        return index_es_listen;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "subscribe", function () {
        return index_es_subscribe;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "unsubscribe", function () {
        return index_es_unsubscribe;
      });
      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */


      var index_es_IS_CLIENT = typeof window !== 'undefined';

      function index_es_warn() {
        if (false) {}
      }

      var index_es_listen = index_es_IS_CLIENT ? lib_listen : index_es_warn;
      var index_es_subscribe = index_es_IS_CLIENT ? dist_es_subscribe : index_es_warn;
      var index_es_unsubscribe = index_es_IS_CLIENT ? dist_es_unsubscribe : index_es_warn;
      /***/
    },
    /* 715 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js


      var whatwg_fetch_fetch = __webpack_require__(664); // EXTERNAL MODULE: ./node_modules/graphql/language/printer.js


      var printer = __webpack_require__(115); // CONCATENATED MODULE: ./node_modules/apollo-client/data/storeUtils.js


      function isStringValue(value) {
        return value.kind === 'StringValue';
      }

      function isBooleanValue(value) {
        return value.kind === 'BooleanValue';
      }

      function isIntValue(value) {
        return value.kind === 'IntValue';
      }

      function isFloatValue(value) {
        return value.kind === 'FloatValue';
      }

      function isVariable(value) {
        return value.kind === 'Variable';
      }

      function isObjectValue(value) {
        return value.kind === 'ObjectValue';
      }

      function isListValue(value) {
        return value.kind === 'ListValue';
      }

      function isEnumValue(value) {
        return value.kind === 'EnumValue';
      }

      function valueToObjectRepresentation(argObj, name, value, variables) {
        if (isIntValue(value) || isFloatValue(value)) {
          argObj[name.value] = Number(value.value);
        } else if (isBooleanValue(value) || isStringValue(value)) {
          argObj[name.value] = value.value;
        } else if (isObjectValue(value)) {
          var nestedArgObj_1 = {};
          value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
          });
          argObj[name.value] = nestedArgObj_1;
        } else if (isVariable(value)) {
          var variableValue = (variables || {})[value.name.value];
          argObj[name.value] = variableValue;
        } else if (isListValue(value)) {
          argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
          });
        } else if (isEnumValue(value)) {
          argObj[name.value] = value.value;
        } else {
          throw new Error("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\" is not supported.\n                    Use variables instead of inline arguments to overcome this limitation.");
        }
      }

      function storeKeyNameFromField(field, variables) {
        var directivesObj = null;

        if (field.directives) {
          directivesObj = {};
          field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};

            if (directive.arguments) {
              directive.arguments.forEach(function (_a) {
                var name = _a.name,
                    value = _a.value;
                return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
              });
            }
          });
        }

        var argObj = null;

        if (field.arguments && field.arguments.length) {
          argObj = {};
          field.arguments.forEach(function (_a) {
            var name = _a.name,
                value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
          });
        }

        return getStoreKeyName(field.name.value, argObj, directivesObj);
      }

      function getStoreKeyName(fieldName, args, directives) {
        if (directives && directives['connection'] && directives['connection']['key']) {
          if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
              filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
          } else {
            return directives['connection']['key'];
          }
        }

        if (args) {
          var stringifiedArgs = JSON.stringify(args);
          return fieldName + "(" + stringifiedArgs + ")";
        }

        return fieldName;
      }

      function resultKeyNameFromField(field) {
        return field.alias ? field.alias.value : field.name.value;
      }

      function isField(selection) {
        return selection.kind === 'Field';
      }

      function isInlineFragment(selection) {
        return selection.kind === 'InlineFragment';
      }

      function graphQLResultHasError(result) {
        return result.errors && result.errors.length;
      }

      function isIdValue(idObject) {
        return idObject != null && typeof idObject === 'object' && idObject.type === 'id';
      }

      function toIdValue(id, generated) {
        if (generated === void 0) {
          generated = false;
        }

        return {
          type: 'id',
          id: id,
          generated: generated
        };
      }

      function isJsonValue(jsonObject) {
        return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
      } // CONCATENATED MODULE: ./node_modules/apollo-client/util/assign.js


      function assign_assign(target) {
        var sources = [];

        for (var _i = 1; _i < arguments.length; _i++) {
          sources[_i - 1] = arguments[_i];
        }

        sources.forEach(function (source) {
          if (typeof source === 'undefined' || source === null) {
            return;
          }

          Object.keys(source).forEach(function (key) {
            target[key] = source[key];
          });
        });
        return target;
      } // CONCATENATED MODULE: ./node_modules/apollo-client/queries/getFromAST.js


      var getFromAST_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      function getFromAST_getMutationDefinition(doc) {
        getFromAST_checkDocument(doc);
        var mutationDef = null;
        doc.definitions.forEach(function (definition) {
          if (definition.kind === 'OperationDefinition' && definition.operation === 'mutation') {
            mutationDef = definition;
          }
        });

        if (!mutationDef) {
          throw new Error('Must contain a mutation definition.');
        }

        return mutationDef;
      }

      function getFromAST_checkDocument(doc) {
        if (doc.kind !== 'Document') {
          throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
        }

        var foundOperation = false;
        doc.definitions.forEach(function (definition) {
          switch (definition.kind) {
            case 'FragmentDefinition':
              break;

            case 'OperationDefinition':
              if (foundOperation) {
                throw new Error('Queries must have exactly one operation definition.');
              }

              foundOperation = true;
              break;

            default:
              throw new Error("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
          }
        });
      }

      function getFromAST_getOperationName(doc) {
        var res = null;
        doc.definitions.forEach(function (definition) {
          if (definition.kind === 'OperationDefinition' && definition.name) {
            res = definition.name.value;
          }
        });
        return res;
      }

      function getFromAST_getFragmentDefinitions(doc) {
        var fragmentDefinitions = doc.definitions.filter(function (definition) {
          if (definition.kind === 'FragmentDefinition') {
            return true;
          } else {
            return false;
          }
        });
        return fragmentDefinitions;
      }

      function getFromAST_getQueryDefinition(doc) {
        getFromAST_checkDocument(doc);
        var queryDef = null;
        doc.definitions.map(function (definition) {
          if (definition.kind === 'OperationDefinition' && definition.operation === 'query') {
            queryDef = definition;
          }
        });

        if (!queryDef) {
          throw new Error('Must contain a query definition.');
        }

        return queryDef;
      }

      function getFromAST_getOperationDefinition(doc) {
        getFromAST_checkDocument(doc);
        var opDef = null;
        doc.definitions.map(function (definition) {
          if (definition.kind === 'OperationDefinition') {
            opDef = definition;
          }
        });

        if (!opDef) {
          throw new Error('Must contain a query definition.');
        }

        return opDef;
      }

      function getFromAST_getFragmentDefinition(doc) {
        if (doc.kind !== 'Document') {
          throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
        }

        if (doc.definitions.length > 1) {
          throw new Error('Fragment must have exactly one definition.');
        }

        var fragmentDef = doc.definitions[0];

        if (fragmentDef.kind !== 'FragmentDefinition') {
          throw new Error('Must be a fragment definition.');
        }

        return fragmentDef;
      }

      function getFromAST_createFragmentMap(fragments) {
        if (fragments === void 0) {
          fragments = [];
        }

        var symTable = {};
        fragments.forEach(function (fragment) {
          symTable[fragment.name.value] = fragment;
        });
        return symTable;
      }

      function getFromAST_getFragmentQueryDocument(document, fragmentName) {
        var actualFragmentName = fragmentName;
        var fragments = [];
        document.definitions.forEach(function (definition) {
          if (definition.kind === 'OperationDefinition') {
            throw new Error("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " + 'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
          }

          if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
          }
        });

        if (typeof actualFragmentName === 'undefined') {
          if (fragments.length !== 1) {
            throw new Error("Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
          }

          actualFragmentName = fragments[0].name.value;
        }

        var query = getFromAST_assign({}, document, {
          definitions: [{
            kind: 'OperationDefinition',
            operation: 'query',
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'FragmentSpread',
                name: {
                  kind: 'Name',
                  value: actualFragmentName
                }
              }]
            }
          }].concat(document.definitions)
        });
        return query;
      }

      function getFromAST_getDefaultValues(definition) {
        if (definition.variableDefinitions && definition.variableDefinitions.length) {
          var defaultValues = definition.variableDefinitions.filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
          }).map(function (_a) {
            var variable = _a.variable,
                defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
          });
          return assign_assign.apply(void 0, [{}].concat(defaultValues));
        }

        return {};
      } // CONCATENATED MODULE: ./node_modules/apollo-client/util/cloneDeep.js


      function cloneDeep(value) {
        if (Array.isArray(value)) {
          return value.map(function (item) {
            return cloneDeep(item);
          });
        }

        if (value !== null && typeof value === 'object') {
          var nextValue = {};

          for (var key in value) {
            if (value.hasOwnProperty(key)) {
              nextValue[key] = cloneDeep(value[key]);
            }
          }

          return nextValue;
        }

        return value;
      } // CONCATENATED MODULE: ./node_modules/apollo-client/queries/queryTransform.js


      var queryTransform_TYPENAME_FIELD = {
        kind: 'Field',
        name: {
          kind: 'Name',
          value: '__typename'
        }
      };

      function queryTransform_addTypenameToSelectionSet(selectionSet, isRoot) {
        if (isRoot === void 0) {
          isRoot = false;
        }

        if (selectionSet.selections) {
          if (!isRoot) {
            var alreadyHasThisField = selectionSet.selections.some(function (selection) {
              return selection.kind === 'Field' && selection.name.value === '__typename';
            });

            if (!alreadyHasThisField) {
              selectionSet.selections.push(queryTransform_TYPENAME_FIELD);
            }
          }

          selectionSet.selections.forEach(function (selection) {
            if (selection.kind === 'Field') {
              if (selection.name.value.lastIndexOf('__', 0) !== 0 && selection.selectionSet) {
                queryTransform_addTypenameToSelectionSet(selection.selectionSet);
              }
            } else if (selection.kind === 'InlineFragment') {
              if (selection.selectionSet) {
                queryTransform_addTypenameToSelectionSet(selection.selectionSet);
              }
            }
          });
        }
      }

      function queryTransform_removeConnectionDirectiveFromSelectionSet(selectionSet) {
        if (selectionSet.selections) {
          selectionSet.selections.forEach(function (selection) {
            if (selection.kind === 'Field' && selection && selection.directives) {
              selection.directives = selection.directives.filter(function (directive) {
                var willRemove = directive.name.value === 'connection';

                if (willRemove) {
                  if (!directive.arguments || !directive.arguments.some(function (arg) {
                    return arg.name.value === 'key';
                  })) {
                    console.warn('Removing an @connection directive even though it does not have a key. ' + 'You may want to use the key parameter to specify a store key.');
                  }
                }

                return !willRemove;
              });
            }
          });
          selectionSet.selections.forEach(function (selection) {
            if (selection.kind === 'Field') {
              if (selection.selectionSet) {
                queryTransform_removeConnectionDirectiveFromSelectionSet(selection.selectionSet);
              }
            } else if (selection.kind === 'InlineFragment') {
              if (selection.selectionSet) {
                queryTransform_removeConnectionDirectiveFromSelectionSet(selection.selectionSet);
              }
            }
          });
        }
      }

      function queryTransform_addTypenameToDocument(doc) {
        getFromAST_checkDocument(doc);
        var docClone = cloneDeep(doc);
        docClone.definitions.forEach(function (definition) {
          var isRoot = definition.kind === 'OperationDefinition';
          queryTransform_addTypenameToSelectionSet(definition.selectionSet, isRoot);
        });
        return docClone;
      }

      function queryTransform_removeConnectionDirectiveFromDocument(doc) {
        getFromAST_checkDocument(doc);
        var docClone = cloneDeep(doc);
        docClone.definitions.forEach(function (definition) {
          queryTransform_removeConnectionDirectiveFromSelectionSet(definition.selectionSet);
        });
        return docClone;
      } // CONCATENATED MODULE: ./node_modules/apollo-client/transport/networkInterface.js


      var networkInterface_extends = undefined && undefined.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };

        return function (d, b) {
          extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      var networkInterface_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      function networkInterface_printRequest(request) {
        return networkInterface_assign({}, request, {
          query: Object(printer["print"])(request.query)
        });
      }

      var networkInterface_BaseNetworkInterface = function () {
        function BaseNetworkInterface(uri, opts) {
          if (opts === void 0) {
            opts = {};
          }

          if (!uri) {
            throw new Error('A remote endpoint is required for a network layer');
          }

          if (typeof uri !== 'string') {
            throw new Error('Remote endpoint must be a string');
          }

          this._uri = uri;
          this._opts = networkInterface_assign({}, opts);
          this._middlewares = [];
          this._afterwares = [];
        }

        BaseNetworkInterface.prototype.query = function (request) {
          return new Promise(function (resolve, reject) {
            reject(new Error('BaseNetworkInterface should not be used directly'));
          });
        };

        return BaseNetworkInterface;
      }();

      var networkInterface_HTTPFetchNetworkInterface = function (_super) {
        networkInterface_extends(HTTPFetchNetworkInterface, _super);

        function HTTPFetchNetworkInterface() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        HTTPFetchNetworkInterface.prototype.applyMiddlewares = function (requestAndOptions) {
          var _this = this;

          return new Promise(function (resolve, reject) {
            var request = requestAndOptions.request,
                options = requestAndOptions.options;

            var queue = function queue(funcs, scope) {
              var next = function next(err) {
                if (err) {
                  reject(err);
                } else if (funcs.length > 0) {
                  var f = funcs.shift();

                  if (f) {
                    f.applyMiddleware.apply(scope, [{
                      request: request,
                      options: options
                    }, next]);
                  }
                } else {
                  resolve({
                    request: request,
                    options: options
                  });
                }
              };

              next();
            };

            queue(_this._middlewares.slice(), _this);
          });
        };

        HTTPFetchNetworkInterface.prototype.applyAfterwares = function (_a) {
          var _this = this;

          var response = _a.response,
              options = _a.options;
          return new Promise(function (resolve, reject) {
            var responseObject = {
              response: response,
              options: options
            };

            var queue = function queue(funcs, scope) {
              var next = function next() {
                if (funcs.length > 0) {
                  var f = funcs.shift();

                  if (f) {
                    f.applyAfterware.apply(scope, [responseObject, next]);
                  }
                } else {
                  resolve(responseObject);
                }
              };

              next();
            };

            queue(_this._afterwares.slice(), _this);
          });
        };

        HTTPFetchNetworkInterface.prototype.fetchFromRemoteEndpoint = function (_a) {
          var request = _a.request,
              options = _a.options;
          return fetch(this._uri, networkInterface_assign({}, this._opts, {
            body: JSON.stringify(networkInterface_printRequest(request)),
            method: 'POST'
          }, options, {
            headers: networkInterface_assign({
              Accept: '*/*',
              'Content-Type': 'application/json'
            }, options.headers)
          }));
        };

        HTTPFetchNetworkInterface.prototype.query = function (request) {
          var _this = this;

          var options = networkInterface_assign({}, this._opts);
          return this.applyMiddlewares({
            request: request,
            options: options
          }).then(function (rao) {
            if (rao.request.query) {
              rao.request.query = queryTransform_removeConnectionDirectiveFromDocument(rao.request.query);
            }

            return rao;
          }).then(function (rao) {
            return _this.fetchFromRemoteEndpoint.call(_this, rao);
          }).then(function (response) {
            return _this.applyAfterwares({
              response: response,
              options: options
            });
          }).then(function (_a) {
            var response = _a.response;
            var httpResponse = response;
            return httpResponse.json().catch(function (error) {
              var httpError = new Error("Network request failed with status " + response.status + " - \"" + response.statusText + "\"");
              httpError.response = httpResponse;
              httpError.parseError = error;
              throw httpError;
            });
          }).then(function (payload) {
            if (!payload.hasOwnProperty('data') && !payload.hasOwnProperty('errors')) {
              throw new Error("Server response was missing for query '" + request.debugName + "'.");
            } else {
              return payload;
            }
          });
        };

        HTTPFetchNetworkInterface.prototype.use = function (middlewares) {
          var _this = this;

          middlewares.map(function (middleware) {
            if (typeof middleware.applyMiddleware === 'function') {
              _this._middlewares.push(middleware);
            } else {
              throw new Error('Middleware must implement the applyMiddleware function');
            }
          });
          return this;
        };

        HTTPFetchNetworkInterface.prototype.useAfter = function (afterwares) {
          var _this = this;

          afterwares.map(function (afterware) {
            if (typeof afterware.applyAfterware === 'function') {
              _this._afterwares.push(afterware);
            } else {
              throw new Error('Afterware must implement the applyAfterware function');
            }
          });
          return this;
        };

        return HTTPFetchNetworkInterface;
      }(networkInterface_BaseNetworkInterface);

      function networkInterface_createNetworkInterface(uriOrInterfaceOpts, secondArgOpts) {
        if (secondArgOpts === void 0) {
          secondArgOpts = {};
        }

        if (!uriOrInterfaceOpts) {
          throw new Error('You must pass an options argument to createNetworkInterface.');
        }

        var uri;
        var opts;

        if (typeof uriOrInterfaceOpts === 'string') {
          console.warn("Passing the URI as the first argument to createNetworkInterface is deprecated as of Apollo Client 0.5. Please pass it as the \"uri\" property of the network interface options.");
          opts = secondArgOpts.opts;
          uri = uriOrInterfaceOpts;
        } else {
          opts = uriOrInterfaceOpts.opts;
          uri = uriOrInterfaceOpts.uri;
        }

        return new networkInterface_HTTPFetchNetworkInterface(uri, opts);
      } // CONCATENATED MODULE: ./node_modules/apollo-client/transport/batching.js


      var QueryBatcher = function () {
        function QueryBatcher(_a) {
          var batchInterval = _a.batchInterval,
              _b = _a.batchMax,
              batchMax = _b === void 0 ? 0 : _b,
              batchFetchFunction = _a.batchFetchFunction;
          this.queuedRequests = [];
          this.queuedRequests = [];
          this.batchInterval = batchInterval;
          this.batchMax = batchMax;
          this.batchFetchFunction = batchFetchFunction;
        }

        QueryBatcher.prototype.enqueueRequest = function (request) {
          var fetchRequest = {
            request: request
          };
          this.queuedRequests.push(fetchRequest);
          fetchRequest.promise = new Promise(function (resolve, reject) {
            fetchRequest.resolve = resolve;
            fetchRequest.reject = reject;
          });

          if (this.queuedRequests.length === 1) {
            this.scheduleQueueConsumption();
          }

          if (this.queuedRequests.length === this.batchMax) {
            this.consumeQueue();
          }

          return fetchRequest.promise;
        };

        QueryBatcher.prototype.consumeQueue = function () {
          var requests = this.queuedRequests.map(function (queuedRequest) {
            return queuedRequest.request;
          });
          var promises = [];
          var resolvers = [];
          var rejecters = [];
          this.queuedRequests.forEach(function (fetchRequest, index) {
            promises.push(fetchRequest.promise);
            resolvers.push(fetchRequest.resolve);
            rejecters.push(fetchRequest.reject);
          });
          this.queuedRequests = [];
          var batchedPromise = this.batchFetchFunction(requests);
          batchedPromise.then(function (results) {
            results.forEach(function (result, index) {
              resolvers[index](result);
            });
          }).catch(function (error) {
            rejecters.forEach(function (rejecter, index) {
              rejecters[index](error);
            });
          });
          return promises;
        };

        QueryBatcher.prototype.scheduleQueueConsumption = function () {
          var _this = this;

          setTimeout(function () {
            if (_this.queuedRequests.length) {
              _this.consumeQueue();
            }
          }, this.batchInterval);
        };

        return QueryBatcher;
      }(); // CONCATENATED MODULE: ./node_modules/apollo-client/transport/batchedNetworkInterface.js


      var batchedNetworkInterface_extends = undefined && undefined.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };

        return function (d, b) {
          extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      var batchedNetworkInterface_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var batchedNetworkInterface_HTTPBatchedNetworkInterface = function (_super) {
        batchedNetworkInterface_extends(HTTPBatchedNetworkInterface, _super);

        function HTTPBatchedNetworkInterface(_a) {
          var uri = _a.uri,
              _b = _a.batchInterval,
              batchInterval = _b === void 0 ? 10 : _b,
              _c = _a.batchMax,
              batchMax = _c === void 0 ? 0 : _c,
              fetchOpts = _a.fetchOpts;

          var _this = _super.call(this, uri, fetchOpts) || this;

          if (typeof batchInterval !== 'number') {
            throw new Error("batchInterval must be a number, got " + batchInterval);
          }

          if (typeof batchMax !== 'number') {
            throw new Error("batchMax must be a number, got " + batchMax);
          }

          _this.batcher = new QueryBatcher({
            batchInterval: batchInterval,
            batchMax: batchMax,
            batchFetchFunction: _this.batchQuery.bind(_this)
          });
          return _this;
        }

        HTTPBatchedNetworkInterface.prototype.query = function (request) {
          return this.batcher.enqueueRequest(request);
        };

        HTTPBatchedNetworkInterface.prototype.batchQuery = function (requests) {
          var _this = this;

          var options = batchedNetworkInterface_assign({}, this._opts);
          var middlewarePromise = this.applyBatchMiddlewares({
            requests: requests,
            options: options
          });
          return new Promise(function (resolve, reject) {
            middlewarePromise.then(function (batchRequestAndOptions) {
              batchRequestAndOptions.requests.forEach(function (r) {
                if (r.query) r.query = queryTransform_removeConnectionDirectiveFromDocument(r.query);
              });
              return _this.batchedFetchFromRemoteEndpoint(batchRequestAndOptions).then(function (result) {
                var httpResponse = result;

                if (!httpResponse.ok) {
                  return _this.applyBatchAfterwares({
                    responses: [httpResponse],
                    options: batchRequestAndOptions.options
                  }).then(function () {
                    var httpError = new Error("Network request failed with status " + httpResponse.status + " - \"" + httpResponse.statusText + "\"");
                    httpError.response = httpResponse;
                    throw httpError;
                  });
                }

                return result.json();
              }).then(function (responses) {
                if (typeof responses.map !== 'function') {
                  throw new Error('BatchingNetworkInterface: server response is not an array');
                }

                _this.applyBatchAfterwares({
                  responses: responses,
                  options: batchRequestAndOptions.options
                }).then(function (responseAndOptions) {
                  resolve(responseAndOptions.responses);
                }).catch(function (error) {
                  reject(error);
                });
              });
            }).catch(function (error) {
              reject(error);
            });
          });
        };

        HTTPBatchedNetworkInterface.prototype.applyBatchMiddlewares = function (_a) {
          var _this = this;

          var requests = _a.requests,
              options = _a.options;
          return new Promise(function (resolve, reject) {
            var queue = function queue(funcs, scope) {
              var next = function next() {
                if (funcs.length > 0) {
                  var f = funcs.shift();

                  if (f) {
                    f.applyBatchMiddleware.apply(scope, [{
                      requests: requests,
                      options: options
                    }, next]);
                  }
                } else {
                  resolve({
                    requests: requests,
                    options: options
                  });
                }
              };

              next();
            };

            queue(_this._middlewares.slice(), _this);
          });
        };

        HTTPBatchedNetworkInterface.prototype.applyBatchAfterwares = function (_a) {
          var _this = this;

          var responses = _a.responses,
              options = _a.options;
          return new Promise(function (resolve, reject) {
            var responseObject = {
              responses: responses,
              options: options
            };

            var queue = function queue(funcs, scope) {
              var next = function next() {
                if (funcs.length > 0) {
                  var f = funcs.shift();

                  if (f) {
                    f.applyBatchAfterware.apply(scope, [responseObject, next]);
                  }
                } else {
                  resolve(responseObject);
                }
              };

              next();
            };

            queue(_this._afterwares.slice(), _this);
          });
        };

        HTTPBatchedNetworkInterface.prototype.use = function (middlewares) {
          var _this = this;

          middlewares.map(function (middleware) {
            if (typeof middleware.applyBatchMiddleware === 'function') {
              _this._middlewares.push(middleware);
            } else {
              throw new Error('Batch middleware must implement the applyBatchMiddleware function');
            }
          });
          return this;
        };

        HTTPBatchedNetworkInterface.prototype.useAfter = function (afterwares) {
          var _this = this;

          afterwares.map(function (afterware) {
            if (typeof afterware.applyBatchAfterware === 'function') {
              _this._afterwares.push(afterware);
            } else {
              throw new Error('Batch afterware must implement the applyBatchAfterware function');
            }
          });
          return this;
        };

        HTTPBatchedNetworkInterface.prototype.batchedFetchFromRemoteEndpoint = function (batchRequestAndOptions) {
          var options = {};
          assign_assign(options, batchRequestAndOptions.options);
          var printedRequests = batchRequestAndOptions.requests.map(function (request) {
            return networkInterface_printRequest(request);
          });
          return fetch(this._uri, batchedNetworkInterface_assign({}, this._opts, {
            body: JSON.stringify(printedRequests),
            method: 'POST'
          }, options, {
            headers: batchedNetworkInterface_assign({
              Accept: '*/*',
              'Content-Type': 'application/json'
            }, options.headers)
          }));
        };

        return HTTPBatchedNetworkInterface;
      }(networkInterface_BaseNetworkInterface);

      function batchedNetworkInterface_createBatchingNetworkInterface(options) {
        if (!options) {
          throw new Error('You must pass an options argument to createNetworkInterface.');
        }

        return new batchedNetworkInterface_HTTPBatchedNetworkInterface({
          uri: options.uri,
          batchInterval: options.batchInterval,
          batchMax: options.batchMax,
          fetchOpts: options.opts || {}
        });
      } // EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules


      var es = __webpack_require__(94); // CONCATENATED MODULE: ./node_modules/apollo-client/actions.js


      function isQueryResultAction(action) {
        return action.type === 'APOLLO_QUERY_RESULT';
      }

      function isQueryErrorAction(action) {
        return action.type === 'APOLLO_QUERY_ERROR';
      }

      function isQueryInitAction(action) {
        return action.type === 'APOLLO_QUERY_INIT';
      }

      function isQueryResultClientAction(action) {
        return action.type === 'APOLLO_QUERY_RESULT_CLIENT';
      }

      function isQueryStopAction(action) {
        return action.type === 'APOLLO_QUERY_STOP';
      }

      function isMutationInitAction(action) {
        return action.type === 'APOLLO_MUTATION_INIT';
      }

      function isMutationResultAction(action) {
        return action.type === 'APOLLO_MUTATION_RESULT';
      }

      function isMutationErrorAction(action) {
        return action.type === 'APOLLO_MUTATION_ERROR';
      }

      function isUpdateQueryResultAction(action) {
        return action.type === 'APOLLO_UPDATE_QUERY_RESULT';
      }

      function isStoreResetAction(action) {
        return action.type === 'APOLLO_STORE_RESET';
      }

      function isSubscriptionResultAction(action) {
        return action.type === 'APOLLO_SUBSCRIPTION_RESULT';
      }

      function isWriteAction(action) {
        return action.type === 'APOLLO_WRITE';
      } // CONCATENATED MODULE: ./node_modules/apollo-client/queries/directives.js


      function shouldInclude(selection, variables) {
        if (variables === void 0) {
          variables = {};
        }

        if (!selection.directives) {
          return true;
        }

        var res = true;
        selection.directives.forEach(function (directive) {
          if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
            return;
          }

          var directiveArguments = directive.arguments || [];
          var directiveName = directive.name.value;

          if (directiveArguments.length !== 1) {
            throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
          }

          var ifArgument = directiveArguments[0];

          if (!ifArgument.name || ifArgument.name.value !== 'if') {
            throw new Error("Invalid argument for the @" + directiveName + " directive.");
          }

          var ifValue = directiveArguments[0].value;
          var evaledValue = false;

          if (!ifValue || ifValue.kind !== 'BooleanValue') {
            if (ifValue.kind !== 'Variable') {
              throw new Error("Argument for the @" + directiveName + " directive must be a variable or a bool ean value.");
            } else {
              evaledValue = variables[ifValue.name.value];

              if (evaledValue === undefined) {
                throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
              }
            }
          } else {
            evaledValue = ifValue.value;
          }

          if (directiveName === 'skip') {
            evaledValue = !evaledValue;
          }

          if (!evaledValue) {
            res = false;
          }
        });
        return res;
      } // EXTERNAL MODULE: ./node_modules/apollo-client/util/environment.js


      var environment = __webpack_require__(90); // CONCATENATED MODULE: ./node_modules/apollo-client/data/writeToStore.js


      var writeToStore_extends = undefined && undefined.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };

        return function (d, b) {
          extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      var writeToStore_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var writeToStore_WriteError = function (_super) {
        writeToStore_extends(WriteError, _super);

        function WriteError() {
          var _this = _super !== null && _super.apply(this, arguments) || this;

          _this.type = 'WriteError';
          return _this;
        }

        return WriteError;
      }(Error);

      function writeToStore_enhanceErrorWithDocument(error, document) {
        var enhancedError = new writeToStore_WriteError("Error writing result to store for query " + (document.loc && document.loc.source && document.loc.source.body));
        enhancedError.message += '/n' + error.message;
        enhancedError.stack = error.stack;
        return enhancedError;
      }

      function writeToStore_writeQueryToStore(_a) {
        var result = _a.result,
            query = _a.query,
            _b = _a.store,
            store = _b === void 0 ? {} : _b,
            variables = _a.variables,
            dataIdFromObject = _a.dataIdFromObject,
            _c = _a.fragmentMap,
            fragmentMap = _c === void 0 ? {} : _c,
            fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var queryDefinition = getFromAST_getQueryDefinition(query);
        variables = assign_assign({}, getFromAST_getDefaultValues(queryDefinition), variables);

        try {
          return writeToStore_writeSelectionSetToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            selectionSet: queryDefinition.selectionSet,
            context: {
              store: store,
              processedData: {},
              variables: variables,
              dataIdFromObject: dataIdFromObject,
              fragmentMap: fragmentMap,
              fragmentMatcherFunction: fragmentMatcherFunction
            }
          });
        } catch (e) {
          throw writeToStore_enhanceErrorWithDocument(e, query);
        }
      }

      function writeToStore_writeResultToStore(_a) {
        var dataId = _a.dataId,
            result = _a.result,
            document = _a.document,
            _b = _a.store,
            store = _b === void 0 ? {} : _b,
            variables = _a.variables,
            dataIdFromObject = _a.dataIdFromObject,
            fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = getFromAST_getOperationDefinition(document);
        var selectionSet = operationDefinition.selectionSet;
        var fragmentMap = getFromAST_createFragmentMap(getFromAST_getFragmentDefinitions(document));
        variables = assign_assign({}, getFromAST_getDefaultValues(operationDefinition), variables);

        try {
          return writeToStore_writeSelectionSetToStore({
            result: result,
            dataId: dataId,
            selectionSet: selectionSet,
            context: {
              store: store,
              processedData: {},
              variables: variables,
              dataIdFromObject: dataIdFromObject,
              fragmentMap: fragmentMap,
              fragmentMatcherFunction: fragmentMatcherFunction
            }
          });
        } catch (e) {
          throw writeToStore_enhanceErrorWithDocument(e, document);
        }
      }

      function writeToStore_writeSelectionSetToStore(_a) {
        var result = _a.result,
            dataId = _a.dataId,
            selectionSet = _a.selectionSet,
            context = _a.context;
        var variables = context.variables,
            store = context.store,
            dataIdFromObject = context.dataIdFromObject,
            fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function (selection) {
          var included = shouldInclude(selection, variables);

          if (isField(selection)) {
            var resultFieldKey = resultKeyNameFromField(selection);
            var value = result[resultFieldKey];

            if (included) {
              if (typeof value !== 'undefined') {
                writeToStore_writeFieldToStore({
                  dataId: dataId,
                  value: value,
                  field: selection,
                  context: context
                });
              } else {
                if (context.fragmentMatcherFunction) {
                  if (!Object(environment["b"
                  /* isProduction */
                  ])()) {
                    console.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
                  }
                }
              }
            }
          } else {
            var fragment = void 0;

            if (isInlineFragment(selection)) {
              fragment = selection;
            } else {
              fragment = (fragmentMap || {})[selection.name.value];

              if (!fragment) {
                throw new Error("No fragment named " + selection.name.value + ".");
              }
            }

            var matches = true;

            if (context.fragmentMatcherFunction && fragment.typeCondition) {
              var idValue = {
                type: 'id',
                id: 'self',
                generated: false
              };
              var fakeContext = {
                store: {
                  self: result
                },
                returnPartialData: false,
                hasMissingField: false,
                customResolvers: {}
              };
              matches = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);

              if (fakeContext.returnPartialData) {
                console.error('WARNING: heuristic fragment matching going on!');
              }
            }

            if (included && matches) {
              writeToStore_writeSelectionSetToStore({
                result: result,
                selectionSet: fragment.selectionSet,
                dataId: dataId,
                context: context
              });
            }
          }
        });
        return store;
      }

      function writeToStore_isGeneratedId(id) {
        return id[0] === '$';
      }

      function writeToStore_mergeWithGenerated(generatedKey, realKey, cache) {
        var generated = cache[generatedKey];
        var real = cache[realKey];
        Object.keys(generated).forEach(function (key) {
          var value = generated[key];
          var realValue = real[key];

          if (isIdValue(value) && writeToStore_isGeneratedId(value.id) && isIdValue(realValue)) {
            writeToStore_mergeWithGenerated(value.id, realValue.id, cache);
          }

          delete cache[generatedKey];
          cache[realKey] = writeToStore_assign({}, generated, real);
        });
      }

      function writeToStore_isDataProcessed(dataId, field, processedData) {
        if (!processedData) {
          return false;
        }

        if (processedData[dataId]) {
          if (processedData[dataId].indexOf(field) >= 0) {
            return true;
          } else {
            processedData[dataId].push(field);
          }
        } else {
          processedData[dataId] = [field];
        }

        return false;
      }

      function writeToStore_writeFieldToStore(_a) {
        var field = _a.field,
            value = _a.value,
            dataId = _a.dataId,
            context = _a.context;
        var variables = context.variables,
            dataIdFromObject = context.dataIdFromObject,
            store = context.store,
            fragmentMap = context.fragmentMap;
        var storeValue;
        var storeFieldName = storeKeyNameFromField(field, variables);
        var shouldMerge = false;
        var generatedKey = '';

        if (!field.selectionSet || value === null) {
          storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
          } : value;
        } else if (Array.isArray(value)) {
          var generatedId = dataId + "." + storeFieldName;
          storeValue = writeToStore_processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
          var valueDataId = dataId + "." + storeFieldName;
          var generated = true;

          if (!writeToStore_isGeneratedId(valueDataId)) {
            valueDataId = '$' + valueDataId;
          }

          if (dataIdFromObject) {
            var semanticId = dataIdFromObject(value);

            if (semanticId && writeToStore_isGeneratedId(semanticId)) {
              throw new Error('IDs returned by dataIdFromObject cannot begin with the "$" character.');
            }

            if (semanticId) {
              valueDataId = semanticId;
              generated = false;
            }
          }

          if (!writeToStore_isDataProcessed(valueDataId, field, context.processedData)) {
            writeToStore_writeSelectionSetToStore({
              dataId: valueDataId,
              result: value,
              selectionSet: field.selectionSet,
              context: context
            });
          }

          storeValue = {
            type: 'id',
            id: valueDataId,
            generated: generated
          };

          if (store[dataId] && store[dataId][storeFieldName] !== storeValue) {
            var escapedId = store[dataId][storeFieldName];

            if (isIdValue(storeValue) && storeValue.generated && isIdValue(escapedId) && !escapedId.generated) {
              throw new Error("Store error: the application attempted to write an object with no provided id" + (" but the store already contains an id of " + escapedId.id + " for this object."));
            }

            if (isIdValue(escapedId) && escapedId.generated) {
              generatedKey = escapedId.id;
              shouldMerge = true;
            }
          }
        }

        var newStoreObj = writeToStore_assign({}, store[dataId], (_b = {}, _b[storeFieldName] = storeValue, _b));

        if (shouldMerge) {
          writeToStore_mergeWithGenerated(generatedKey, storeValue.id, store);
        }

        if (!store[dataId] || storeValue !== store[dataId][storeFieldName]) {
          store[dataId] = newStoreObj;
        }

        var _b;
      }

      function writeToStore_processArrayValue(value, generatedId, selectionSet, context) {
        return value.map(function (item, index) {
          if (item === null) {
            return null;
          }

          var itemDataId = generatedId + "." + index;

          if (Array.isArray(item)) {
            return writeToStore_processArrayValue(item, itemDataId, selectionSet, context);
          }

          var generated = true;

          if (context.dataIdFromObject) {
            var semanticId = context.dataIdFromObject(item);

            if (semanticId) {
              itemDataId = semanticId;
              generated = false;
            }
          }

          if (!writeToStore_isDataProcessed(itemDataId, selectionSet, context.processedData)) {
            writeToStore_writeSelectionSetToStore({
              dataId: itemDataId,
              result: item,
              selectionSet: selectionSet,
              context: context
            });
          }

          var idStoreValue = {
            type: 'id',
            id: itemDataId,
            generated: generated
          };
          return idStoreValue;
        });
      } // CONCATENATED MODULE: ./node_modules/apollo-client/optimistic-data/store.js


      var store_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var store_optimisticDefaultState = [];

      function store_getDataWithOptimisticResults(store) {
        if (store.optimistic.length === 0) {
          return store.data;
        }

        var patches = store.optimistic.map(function (opt) {
          return opt.data;
        });
        return assign_assign.apply(void 0, [{}, store.data].concat(patches));
      }

      function store_optimistic(previousState, action, store, config) {
        if (previousState === void 0) {
          previousState = store_optimisticDefaultState;
        }

        if (isMutationInitAction(action) && action.optimisticResponse) {
          var optimisticResponse = void 0;

          if (typeof action.optimisticResponse === 'function') {
            optimisticResponse = action.optimisticResponse(action.variables);
          } else {
            optimisticResponse = action.optimisticResponse;
          }

          var fakeMutationResultAction = {
            type: 'APOLLO_MUTATION_RESULT',
            result: {
              data: optimisticResponse
            },
            document: action.mutation,
            operationName: action.operationName,
            variables: action.variables,
            mutationId: action.mutationId,
            extraReducers: action.extraReducers,
            updateQueries: action.updateQueries,
            update: action.update
          };
          var optimisticData = store_getDataWithOptimisticResults(store_assign({}, store, {
            optimistic: previousState
          }));
          var patch = store_getOptimisticDataPatch(optimisticData, fakeMutationResultAction, store.queries, store.mutations, config);
          var optimisticState = {
            action: fakeMutationResultAction,
            data: patch,
            mutationId: action.mutationId
          };
          var newState = previousState.concat([optimisticState]);
          return newState;
        } else if ((isMutationErrorAction(action) || isMutationResultAction(action)) && previousState.some(function (change) {
          return change.mutationId === action.mutationId;
        })) {
          return store_rollbackOptimisticData(function (change) {
            return change.mutationId === action.mutationId;
          }, previousState, store, config);
        }

        return previousState;
      }

      function store_getOptimisticDataPatch(previousData, optimisticAction, queries, mutations, config) {
        var optimisticData = store_data(previousData, optimisticAction, config);
        var patch = {};
        Object.keys(optimisticData).forEach(function (key) {
          if (optimisticData[key] !== previousData[key]) {
            patch[key] = optimisticData[key];
          }
        });
        return patch;
      }

      function store_rollbackOptimisticData(filterFn, previousState, store, config) {
        if (previousState === void 0) {
          previousState = store_optimisticDefaultState;
        }

        var optimisticData = assign_assign({}, store.data);
        var newState = previousState.filter(function (item) {
          return !filterFn(item);
        }).map(function (change) {
          var patch = store_getOptimisticDataPatch(optimisticData, change.action, store.queries, store.mutations, config);
          assign_assign(optimisticData, patch);
          return store_assign({}, change, {
            data: patch
          });
        });
        return newState;
      } // EXTERNAL MODULE: ./node_modules/graphql-anywhere/lib/src/index.js


      var src = __webpack_require__(712);

      var src_default =
      /*#__PURE__*/
      __webpack_require__.n(src); // CONCATENATED MODULE: ./node_modules/apollo-client/util/isEqual.js


      function isEqual(a, b) {
        if (a === b) {
          return true;
        }

        if (a instanceof Date && b instanceof Date) {
          return a.getTime() === b.getTime();
        }

        if (a != null && typeof a === 'object' && b != null && typeof b === 'object') {
          for (var key in a) {
            if (Object.prototype.hasOwnProperty.call(a, key)) {
              if (!Object.prototype.hasOwnProperty.call(b, key)) {
                return false;
              }

              if (!isEqual(a[key], b[key])) {
                return false;
              }
            }
          }

          for (var key in b) {
            if (!Object.prototype.hasOwnProperty.call(a, key)) {
              return false;
            }
          }

          return true;
        }

        return false;
      } // CONCATENATED MODULE: ./node_modules/apollo-client/data/readFromStore.js


      var readFromStore_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var readFromStore_ID_KEY = typeof Symbol !== 'undefined' ? Symbol('id') : '@@id';

      function readFromStore_readQueryFromStore(options) {
        var optsPatch = {
          returnPartialData: false
        };
        return readFromStore_diffQueryAgainstStore(readFromStore_assign({}, options, optsPatch)).result;
      }

      var readFromStore_readStoreResolver = function readFromStore_readStoreResolver(fieldName, idValue, args, context, _a) {
        var resultKey = _a.resultKey,
            directives = _a.directives;
        readFromStore_assertIdValue(idValue);
        var objId = idValue.id;
        var obj = context.store[objId];
        var storeKeyName = getStoreKeyName(fieldName, args, directives);
        var fieldValue = (obj || {})[storeKeyName];

        if (typeof fieldValue === 'undefined') {
          if (context.customResolvers && obj && (obj.__typename || objId === 'ROOT_QUERY')) {
            var typename = obj.__typename || 'Query';
            var type = context.customResolvers[typename];

            if (type) {
              var resolver = type[fieldName];

              if (resolver) {
                fieldValue = resolver(obj, args);
              }
            }
          }

          if (typeof fieldValue === 'undefined') {
            if (!context.returnPartialData) {
              throw new Error("Can't find field " + storeKeyName + " on object (" + objId + ") " + JSON.stringify(obj, null, 2) + ".");
            }

            context.hasMissingField = true;
            return fieldValue;
          }
        }

        if (isJsonValue(fieldValue)) {
          if (idValue.previousResult && isEqual(idValue.previousResult[resultKey], fieldValue.json)) {
            return idValue.previousResult[resultKey];
          }

          return fieldValue.json;
        }

        if (idValue.previousResult) {
          fieldValue = readFromStore_addPreviousResultToIdValues(fieldValue, idValue.previousResult[resultKey]);
        }

        return fieldValue;
      };

      function readFromStore_diffQueryAgainstStore(_a) {
        var store = _a.store,
            query = _a.query,
            variables = _a.variables,
            previousResult = _a.previousResult,
            _b = _a.returnPartialData,
            returnPartialData = _b === void 0 ? true : _b,
            _c = _a.rootId,
            rootId = _c === void 0 ? 'ROOT_QUERY' : _c,
            fragmentMatcherFunction = _a.fragmentMatcherFunction,
            config = _a.config;
        var queryDefinition = getFromAST_getQueryDefinition(query);
        variables = assign_assign({}, getFromAST_getDefaultValues(queryDefinition), variables);
        var context = {
          store: store,
          returnPartialData: returnPartialData,
          customResolvers: config && config.customResolvers || {},
          hasMissingField: false
        };
        var rootIdValue = {
          type: 'id',
          id: rootId,
          previousResult: previousResult
        };
        var result = src_default()(readFromStore_readStoreResolver, query, rootIdValue, context, variables, {
          fragmentMatcher: fragmentMatcherFunction,
          resultMapper: readFromStore_resultMapper
        });
        return {
          result: result,
          isMissing: context.hasMissingField
        };
      }

      function readFromStore_assertIdValue(idValue) {
        if (!isIdValue(idValue)) {
          throw new Error("Encountered a sub-selection on the query, but the store doesn't have an object reference. This should never happen during normal use unless you have custom code that is directly manipulating the store; please file an issue.");
        }
      }

      function readFromStore_addPreviousResultToIdValues(value, previousResult) {
        if (isIdValue(value)) {
          return readFromStore_assign({}, value, {
            previousResult: previousResult
          });
        } else if (Array.isArray(value)) {
          var idToPreviousResult_1 = {};

          if (Array.isArray(previousResult)) {
            previousResult.forEach(function (item) {
              if (item && item[readFromStore_ID_KEY]) {
                idToPreviousResult_1[item[readFromStore_ID_KEY]] = item;
              }
            });
          }

          return value.map(function (item, i) {
            var itemPreviousResult = previousResult && previousResult[i];

            if (isIdValue(item)) {
              itemPreviousResult = idToPreviousResult_1[item.id] || itemPreviousResult;
            }

            return readFromStore_addPreviousResultToIdValues(item, itemPreviousResult);
          });
        }

        return value;
      }

      function readFromStore_resultMapper(resultFields, idValue) {
        if (idValue.previousResult) {
          var currentResultKeys_1 = Object.keys(resultFields);
          var sameAsPreviousResult = Object.keys(idValue.previousResult).reduce(function (sameKeys, key) {
            return sameKeys && currentResultKeys_1.indexOf(key) > -1;
          }, true) && currentResultKeys_1.reduce(function (same, key) {
            return same && readFromStore_areNestedArrayItemsStrictlyEqual(resultFields[key], idValue.previousResult[key]);
          }, true);

          if (sameAsPreviousResult) {
            return idValue.previousResult;
          }
        }

        Object.defineProperty(resultFields, readFromStore_ID_KEY, {
          enumerable: false,
          configurable: false,
          writable: false,
          value: idValue.id
        });
        return resultFields;
      }

      function readFromStore_areNestedArrayItemsStrictlyEqual(a, b) {
        if (a === b) {
          return true;
        }

        if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
          return false;
        }

        return a.reduce(function (same, item, i) {
          return same && readFromStore_areNestedArrayItemsStrictlyEqual(item, b[i]);
        }, true);
      } // CONCATENATED MODULE: ./node_modules/apollo-client/data/proxy.js


      var proxy_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var proxy_ReduxDataProxy = function () {
        function ReduxDataProxy(store, reduxRootSelector, fragmentMatcher, reducerConfig) {
          this.store = store;
          this.reduxRootSelector = reduxRootSelector;
          this.reducerConfig = reducerConfig;
          this.fragmentMatcher = fragmentMatcher;
        }

        ReduxDataProxy.prototype.readQuery = function (_a) {
          var query = _a.query,
              variables = _a.variables;

          if (this.reducerConfig.addTypename) {
            query = queryTransform_addTypenameToDocument(query);
          }

          return readFromStore_readQueryFromStore({
            rootId: 'ROOT_QUERY',
            store: store_getDataWithOptimisticResults(this.reduxRootSelector(this.store.getState())),
            query: query,
            variables: variables,
            fragmentMatcherFunction: this.fragmentMatcher.match,
            config: this.reducerConfig
          });
        };

        ReduxDataProxy.prototype.readFragment = function (_a) {
          var id = _a.id,
              fragment = _a.fragment,
              fragmentName = _a.fragmentName,
              variables = _a.variables;
          var query = getFromAST_getFragmentQueryDocument(fragment, fragmentName);
          var data = store_getDataWithOptimisticResults(this.reduxRootSelector(this.store.getState()));

          if (typeof data[id] === 'undefined') {
            return null;
          }

          if (this.reducerConfig.addTypename) {
            query = queryTransform_addTypenameToDocument(query);
          }

          return readFromStore_readQueryFromStore({
            rootId: id,
            store: data,
            query: query,
            variables: variables,
            fragmentMatcherFunction: this.fragmentMatcher.match,
            config: this.reducerConfig
          });
        };

        ReduxDataProxy.prototype.writeQuery = function (_a) {
          var data = _a.data,
              query = _a.query,
              variables = _a.variables;

          if (this.reducerConfig.addTypename) {
            query = queryTransform_addTypenameToDocument(query);
          }

          this.store.dispatch({
            type: 'APOLLO_WRITE',
            writes: [{
              rootId: 'ROOT_QUERY',
              result: data,
              document: query,
              operationName: getFromAST_getOperationName(query),
              variables: variables || {}
            }]
          });
        };

        ReduxDataProxy.prototype.writeFragment = function (_a) {
          var data = _a.data,
              id = _a.id,
              fragment = _a.fragment,
              fragmentName = _a.fragmentName,
              variables = _a.variables;
          var document = getFromAST_getFragmentQueryDocument(fragment, fragmentName);

          if (this.reducerConfig.addTypename) {
            document = queryTransform_addTypenameToDocument(document);
          }

          this.store.dispatch({
            type: 'APOLLO_WRITE',
            writes: [{
              rootId: id,
              result: data,
              document: document,
              operationName: getFromAST_getOperationName(document),
              variables: variables || {}
            }]
          });
        };

        return ReduxDataProxy;
      }();

      var proxy_TransactionDataProxy = function () {
        function TransactionDataProxy(data, reducerConfig) {
          this.data = proxy_assign({}, data);
          this.reducerConfig = reducerConfig;
          this.writes = [];
          this.isFinished = false;
        }

        TransactionDataProxy.prototype.finish = function () {
          this.assertNotFinished();
          var writes = this.writes;
          this.writes = [];
          this.isFinished = true;
          return writes;
        };

        TransactionDataProxy.prototype.readQuery = function (_a) {
          var query = _a.query,
              variables = _a.variables;
          this.assertNotFinished();

          if (this.reducerConfig.addTypename) {
            query = queryTransform_addTypenameToDocument(query);
          }

          return readFromStore_readQueryFromStore({
            rootId: 'ROOT_QUERY',
            store: this.data,
            query: query,
            variables: variables,
            config: this.reducerConfig,
            fragmentMatcherFunction: this.reducerConfig.fragmentMatcher
          });
        };

        TransactionDataProxy.prototype.readFragment = function (_a) {
          var id = _a.id,
              fragment = _a.fragment,
              fragmentName = _a.fragmentName,
              variables = _a.variables;
          this.assertNotFinished();

          if (!fragment) {
            throw new Error('fragment option is required. Please pass a GraphQL fragment to readFragment.');
          }

          var data = this.data;
          var query = getFromAST_getFragmentQueryDocument(fragment, fragmentName);

          if (this.reducerConfig.addTypename) {
            query = queryTransform_addTypenameToDocument(query);
          }

          if (typeof data[id] === 'undefined') {
            return null;
          }

          return readFromStore_readQueryFromStore({
            rootId: id,
            store: data,
            query: query,
            variables: variables,
            config: this.reducerConfig,
            fragmentMatcherFunction: this.reducerConfig.fragmentMatcher
          });
        };

        TransactionDataProxy.prototype.writeQuery = function (_a) {
          var data = _a.data,
              query = _a.query,
              variables = _a.variables;
          this.assertNotFinished();

          if (this.reducerConfig.addTypename) {
            query = queryTransform_addTypenameToDocument(query);
          }

          this.applyWrite({
            rootId: 'ROOT_QUERY',
            result: data,
            document: query,
            operationName: getFromAST_getOperationName(query),
            variables: variables || {}
          });
        };

        TransactionDataProxy.prototype.writeFragment = function (_a) {
          var data = _a.data,
              id = _a.id,
              fragment = _a.fragment,
              fragmentName = _a.fragmentName,
              variables = _a.variables;
          this.assertNotFinished();

          if (!fragment) {
            throw new Error('fragment option is required. Please pass a GraphQL fragment to writeFragment.');
          }

          var query = getFromAST_getFragmentQueryDocument(fragment, fragmentName);

          if (this.reducerConfig.addTypename) {
            query = queryTransform_addTypenameToDocument(query);
          }

          this.applyWrite({
            rootId: id,
            result: data,
            document: query,
            operationName: getFromAST_getOperationName(query),
            variables: variables || {}
          });
        };

        TransactionDataProxy.prototype.assertNotFinished = function () {
          if (this.isFinished) {
            throw new Error('Cannot call transaction methods after the transaction has finished.');
          }
        };

        TransactionDataProxy.prototype.applyWrite = function (write) {
          writeToStore_writeResultToStore({
            result: write.result,
            dataId: write.rootId,
            document: write.document,
            variables: write.variables,
            store: this.data,
            dataIdFromObject: this.reducerConfig.dataIdFromObject || function () {
              return null;
            },
            fragmentMatcherFunction: this.reducerConfig.fragmentMatcher
          });
          this.writes.push(write);
        };

        return TransactionDataProxy;
      }(); // CONCATENATED MODULE: ./node_modules/apollo-client/data/replaceQueryResults.js


      var replaceQueryResults_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      function replaceQueryResults_replaceQueryResults(state, _a, config) {
        var variables = _a.variables,
            document = _a.document,
            newResult = _a.newResult;
        var clonedState = replaceQueryResults_assign({}, state);
        return writeToStore_writeResultToStore({
          result: newResult,
          dataId: 'ROOT_QUERY',
          variables: variables,
          document: document,
          store: clonedState,
          dataIdFromObject: config.dataIdFromObject,
          fragmentMatcherFunction: config.fragmentMatcher
        });
      } // CONCATENATED MODULE: ./node_modules/apollo-client/util/errorHandling.js


      function tryFunctionOrLogError(f) {
        try {
          return f();
        } catch (e) {
          if (console.error) {
            console.error(e);
          }
        }
      } // CONCATENATED MODULE: ./node_modules/apollo-client/data/store.js


      var data_store_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      function store_data(previousState, action, config) {
        if (previousState === void 0) {
          previousState = {};
        }

        var constAction = action;

        if (isQueryResultAction(action)) {
          if (action.fetchMoreForQueryId) {
            return previousState;
          }

          if (!graphQLResultHasError(action.result)) {
            var clonedState = data_store_assign({}, previousState);
            var newState_1 = writeToStore_writeResultToStore({
              result: action.result.data,
              dataId: 'ROOT_QUERY',
              document: action.document,
              variables: action.variables,
              store: clonedState,
              dataIdFromObject: config.dataIdFromObject,
              fragmentMatcherFunction: config.fragmentMatcher
            });

            if (action.extraReducers) {
              action.extraReducers.forEach(function (reducer) {
                newState_1 = reducer(newState_1, constAction);
              });
            }

            return newState_1;
          }
        } else if (isSubscriptionResultAction(action)) {
          if (!graphQLResultHasError(action.result)) {
            var clonedState = data_store_assign({}, previousState);
            var newState_2 = writeToStore_writeResultToStore({
              result: action.result.data,
              dataId: 'ROOT_SUBSCRIPTION',
              document: action.document,
              variables: action.variables,
              store: clonedState,
              dataIdFromObject: config.dataIdFromObject,
              fragmentMatcherFunction: config.fragmentMatcher
            });

            if (action.extraReducers) {
              action.extraReducers.forEach(function (reducer) {
                newState_2 = reducer(newState_2, constAction);
              });
            }

            return newState_2;
          }
        } else if (isMutationResultAction(constAction)) {
          if (!constAction.result.errors) {
            var clonedState = data_store_assign({}, previousState);
            var newState_3 = writeToStore_writeResultToStore({
              result: constAction.result.data,
              dataId: 'ROOT_MUTATION',
              document: constAction.document,
              variables: constAction.variables,
              store: clonedState,
              dataIdFromObject: config.dataIdFromObject,
              fragmentMatcherFunction: config.fragmentMatcher
            });
            var updateQueries_1 = constAction.updateQueries;

            if (updateQueries_1) {
              Object.keys(updateQueries_1).filter(function (id) {
                return updateQueries_1[id];
              }).forEach(function (queryId) {
                var _a = updateQueries_1[queryId],
                    query = _a.query,
                    reducer = _a.reducer;

                var _b = readFromStore_diffQueryAgainstStore({
                  store: previousState,
                  query: query.document,
                  variables: query.variables,
                  returnPartialData: true,
                  fragmentMatcherFunction: config.fragmentMatcher,
                  config: config
                }),
                    currentQueryResult = _b.result,
                    isMissing = _b.isMissing;

                if (isMissing) {
                  return;
                }

                var nextQueryResult = tryFunctionOrLogError(function () {
                  return reducer(currentQueryResult, {
                    mutationResult: constAction.result,
                    queryName: getFromAST_getOperationName(query.document),
                    queryVariables: query.variables
                  });
                });

                if (nextQueryResult) {
                  newState_3 = writeToStore_writeResultToStore({
                    result: nextQueryResult,
                    dataId: 'ROOT_QUERY',
                    document: query.document,
                    variables: query.variables,
                    store: newState_3,
                    dataIdFromObject: config.dataIdFromObject,
                    fragmentMatcherFunction: config.fragmentMatcher
                  });
                }
              });
            }

            if (constAction.update) {
              var update_1 = constAction.update;
              var proxy_1 = new proxy_TransactionDataProxy(newState_3, config);
              tryFunctionOrLogError(function () {
                return update_1(proxy_1, constAction.result);
              });
              var writes = proxy_1.finish();
              newState_3 = store_data(newState_3, {
                type: 'APOLLO_WRITE',
                writes: writes
              }, config);
            }

            if (constAction.extraReducers) {
              constAction.extraReducers.forEach(function (reducer) {
                newState_3 = reducer(newState_3, constAction);
              });
            }

            return newState_3;
          }
        } else if (isUpdateQueryResultAction(constAction)) {
          return replaceQueryResults_replaceQueryResults(previousState, constAction, config);
        } else if (isStoreResetAction(action)) {
          return {};
        } else if (isWriteAction(action)) {
          return action.writes.reduce(function (currentState, write) {
            return writeToStore_writeResultToStore({
              result: write.result,
              dataId: write.rootId,
              document: write.document,
              variables: write.variables,
              store: currentState,
              dataIdFromObject: config.dataIdFromObject,
              fragmentMatcherFunction: config.fragmentMatcher
            });
          }, data_store_assign({}, previousState));
        }

        return previousState;
      } // CONCATENATED MODULE: ./node_modules/apollo-client/store.js


      var apollo_client_store_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var store_crashReporter = function store_crashReporter(store) {
        return function (next) {
          return function (action) {
            try {
              return next(action);
            } catch (err) {
              console.error('Caught an exception!', err);
              console.error(err.stack);
              throw err;
            }
          };
        };
      };

      var store_createReducerError = function store_createReducerError(error, action) {
        var reducerError = {
          error: error
        };

        if (isQueryResultAction(action)) {
          reducerError.queryId = action.queryId;
        } else if (isSubscriptionResultAction(action)) {
          reducerError.subscriptionId = action.subscriptionId;
        } else if (isMutationResultAction(action)) {
          reducerError.mutationId = action.mutationId;
        }

        return reducerError;
      };

      function store_createApolloReducer(config) {
        return function apolloReducer(state, action) {
          if (state === void 0) {
            state = {};
          }

          try {
            var newState = {
              data: store_data(state.data, action, config),
              optimistic: [],
              reducerError: null
            };
            newState.optimistic = store_optimistic(state.optimistic, action, newState, config);

            if (state.data === newState.data && state.optimistic === newState.optimistic && state.reducerError === newState.reducerError) {
              return state;
            }

            return newState;
          } catch (reducerError) {
            return apollo_client_store_assign({}, state, {
              reducerError: store_createReducerError(reducerError, action)
            });
          }
        };
      }

      function store_createApolloStore(_a) {
        var _b = _a === void 0 ? {} : _a,
            _c = _b.reduxRootKey,
            reduxRootKey = _c === void 0 ? 'apollo' : _c,
            initialState = _b.initialState,
            _d = _b.config,
            config = _d === void 0 ? {} : _d,
            _e = _b.reportCrashes,
            reportCrashes = _e === void 0 ? true : _e,
            logger = _b.logger;

        var enhancers = [];
        var middlewares = [];

        if (reportCrashes) {
          middlewares.push(store_crashReporter);
        }

        if (logger) {
          middlewares.push(logger);
        }

        if (middlewares.length > 0) {
          enhancers.push(es["applyMiddleware"].apply(void 0, middlewares));
        }

        if (typeof window !== 'undefined') {
          var anyWindow = window;

          if (anyWindow.devToolsExtension) {
            enhancers.push(anyWindow.devToolsExtension());
          }
        }

        var compose = es["compose"];

        if (initialState && initialState[reduxRootKey] && initialState[reduxRootKey]['queries']) {
          throw new Error('Apollo initial state may not contain queries, only data');
        }

        if (initialState && initialState[reduxRootKey] && initialState[reduxRootKey]['mutations']) {
          throw new Error('Apollo initial state may not contain mutations, only data');
        }

        return Object(es["createStore"])(Object(es["combineReducers"])((_f = {}, _f[reduxRootKey] = store_createApolloReducer(config), _f)), initialState, compose.apply(void 0, enhancers));

        var _f;
      } // EXTERNAL MODULE: ./node_modules/symbol-observable/es/index.js


      var symbol_observable_es = __webpack_require__(122); // CONCATENATED MODULE: ./node_modules/apollo-client/util/Observable.js


      function Observable_isSubscription(subscription) {
        return subscription.unsubscribe !== undefined;
      }

      var Observable_Observable = function () {
        function Observable(subscriberFunction) {
          this.subscriberFunction = subscriberFunction;
        }

        Observable.prototype[symbol_observable_es["default"]] = function () {
          return this;
        };

        Observable.prototype.subscribe = function (observer) {
          var subscriptionOrCleanupFunction = this.subscriberFunction(observer);

          if (Observable_isSubscription(subscriptionOrCleanupFunction)) {
            return subscriptionOrCleanupFunction;
          } else {
            return {
              unsubscribe: subscriptionOrCleanupFunction
            };
          }
        };

        return Observable;
      }(); // CONCATENATED MODULE: ./node_modules/apollo-client/errors/ApolloError.js


      var ApolloError_extends = undefined && undefined.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };

        return function (d, b) {
          extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      function isApolloError(err) {
        return err.hasOwnProperty('graphQLErrors');
      }

      var generateErrorMessage = function generateErrorMessage(err) {
        var message = '';

        if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) {
          err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
          });
        }

        if (err.networkError) {
          message += 'Network error: ' + err.networkError.message + '\n';
        }

        message = message.replace(/\n$/, '');
        return message;
      };

      var ApolloError = function (_super) {
        ApolloError_extends(ApolloError, _super);

        function ApolloError(_a) {
          var graphQLErrors = _a.graphQLErrors,
              networkError = _a.networkError,
              errorMessage = _a.errorMessage,
              extraInfo = _a.extraInfo;

          var _this = _super.call(this, errorMessage) || this;

          _this.graphQLErrors = graphQLErrors || [];
          _this.networkError = networkError || null;

          if (!errorMessage) {
            _this.message = generateErrorMessage(_this);
          } else {
            _this.message = errorMessage;
          }

          _this.extraInfo = extraInfo;
          return _this;
        }

        return ApolloError;
      }(Error); // CONCATENATED MODULE: ./node_modules/apollo-client/core/types.js


      var FetchType;

      (function (FetchType) {
        FetchType[FetchType["normal"] = 1] = "normal";
        FetchType[FetchType["refetch"] = 2] = "refetch";
        FetchType[FetchType["poll"] = 3] = "poll";
      })(FetchType || (FetchType = {})); // CONCATENATED MODULE: ./node_modules/apollo-client/util/maybeDeepFreeze.js


      function maybeDeepFreeze_deepFreeze(o) {
        Object.freeze(o);
        Object.getOwnPropertyNames(o).forEach(function (prop) {
          if (o.hasOwnProperty(prop) && o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) {
            maybeDeepFreeze_deepFreeze(o[prop]);
          }
        });
        return o;
      }

      function maybeDeepFreeze_maybeDeepFreeze(obj) {
        if (Object(environment["a"
        /* isDevelopment */
        ])() || Object(environment["c"
        /* isTest */
        ])()) {
          return maybeDeepFreeze_deepFreeze(obj);
        }

        return obj;
      } // CONCATENATED MODULE: ./node_modules/apollo-client/queries/networkStatus.js


      var NetworkStatus;

      (function (NetworkStatus) {
        NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
        NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
        NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
        NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
        NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
        NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
        NetworkStatus[NetworkStatus["error"] = 8] = "error";
      })(NetworkStatus || (NetworkStatus = {}));

      function isNetworkRequestInFlight(networkStatus) {
        return networkStatus < 7;
      } // CONCATENATED MODULE: ./node_modules/apollo-client/core/ObservableQuery.js


      var ObservableQuery_extends = undefined && undefined.__extends || function () {
        var extendStatics = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };

        return function (d, b) {
          extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      var ObservableQuery_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var ObservableQuery_ObservableQuery = function (_super) {
        ObservableQuery_extends(ObservableQuery, _super);

        function ObservableQuery(_a) {
          var scheduler = _a.scheduler,
              options = _a.options,
              _b = _a.shouldSubscribe,
              shouldSubscribe = _b === void 0 ? true : _b;

          var _this = this;

          var queryManager = scheduler.queryManager;
          var queryId = queryManager.generateQueryId();

          var subscriberFunction = function subscriberFunction(observer) {
            return _this.onSubscribe(observer);
          };

          _this = _super.call(this, subscriberFunction) || this;
          _this.isCurrentlyPolling = false;
          _this.options = options;
          _this.variables = _this.options.variables || {};
          _this.scheduler = scheduler;
          _this.queryManager = queryManager;
          _this.queryId = queryId;
          _this.shouldSubscribe = shouldSubscribe;
          _this.observers = [];
          _this.subscriptionHandles = [];
          return _this;
        }

        ObservableQuery.prototype.result = function () {
          var that = this;
          return new Promise(function (resolve, reject) {
            var subscription = null;
            var observer = {
              next: function next(result) {
                resolve(result);
                var selectedObservers = that.observers.filter(function (obs) {
                  return obs !== observer;
                });

                if (selectedObservers.length === 0) {
                  that.queryManager.removeQuery(that.queryId);
                }

                setTimeout(function () {
                  subscription.unsubscribe();
                }, 0);
              },
              error: function error(_error4) {
                reject(_error4);
              }
            };
            subscription = that.subscribe(observer);
          });
        };

        ObservableQuery.prototype.currentResult = function () {
          var _a = this.queryManager.getCurrentQueryResult(this, true),
              data = _a.data,
              partial = _a.partial;

          var queryStoreValue = this.queryManager.queryStore.get(this.queryId);

          if (queryStoreValue && (queryStoreValue.graphQLErrors && queryStoreValue.graphQLErrors.length > 0 || queryStoreValue.networkError)) {
            var error = new ApolloError({
              graphQLErrors: queryStoreValue.graphQLErrors,
              networkError: queryStoreValue.networkError
            });
            return {
              data: {},
              loading: false,
              networkStatus: queryStoreValue.networkStatus,
              error: error
            };
          }

          var queryLoading = !queryStoreValue || queryStoreValue.networkStatus === NetworkStatus.loading;
          var loading = this.options.fetchPolicy === 'network-only' && queryLoading || partial && this.options.fetchPolicy !== 'cache-only';
          var networkStatus;

          if (queryStoreValue) {
            networkStatus = queryStoreValue.networkStatus;
          } else {
            networkStatus = loading ? NetworkStatus.loading : NetworkStatus.ready;
          }

          var result = {
            data: data,
            loading: isNetworkRequestInFlight(networkStatus),
            networkStatus: networkStatus
          };

          if (!partial) {
            var stale = false;
            this.lastResult = ObservableQuery_assign({}, result, {
              stale: stale
            });
          }

          return ObservableQuery_assign({}, result, {
            partial: partial
          });
        };

        ObservableQuery.prototype.getLastResult = function () {
          return this.lastResult;
        };

        ObservableQuery.prototype.refetch = function (variables) {
          this.variables = ObservableQuery_assign({}, this.variables, variables);

          if (this.options.fetchPolicy === 'cache-only') {
            return Promise.reject(new Error('cache-only fetchPolicy option should not be used together with query refetch.'));
          }

          this.options.variables = ObservableQuery_assign({}, this.options.variables, this.variables);
          var combinedOptions = ObservableQuery_assign({}, this.options, {
            fetchPolicy: 'network-only'
          });
          return this.queryManager.fetchQuery(this.queryId, combinedOptions, FetchType.refetch).then(function (result) {
            return maybeDeepFreeze_maybeDeepFreeze(result);
          });
        };

        ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
          var _this = this;

          if (!fetchMoreOptions.updateQuery) {
            throw new Error('updateQuery option is required. This function defines how to update the query data with the new results.');
          }

          return Promise.resolve().then(function () {
            var qid = _this.queryManager.generateQueryId();

            var combinedOptions = null;

            if (fetchMoreOptions.query) {
              combinedOptions = fetchMoreOptions;
            } else {
              var variables = ObservableQuery_assign({}, _this.variables, fetchMoreOptions.variables);
              combinedOptions = ObservableQuery_assign({}, _this.options, fetchMoreOptions, {
                variables: variables
              });
            }

            combinedOptions = ObservableQuery_assign({}, combinedOptions, {
              query: combinedOptions.query,
              fetchPolicy: 'network-only'
            });
            return _this.queryManager.fetchQuery(qid, combinedOptions, FetchType.normal, _this.queryId);
          }).then(function (fetchMoreResult) {
            var data = fetchMoreResult.data;
            var reducer = fetchMoreOptions.updateQuery;

            var mapFn = function mapFn(previousResult, _a) {
              var variables = _a.variables;
              var queryVariables = variables;
              return reducer(previousResult, {
                fetchMoreResult: data,
                queryVariables: queryVariables
              });
            };

            _this.updateQuery(mapFn);

            return fetchMoreResult;
          });
        };

        ObservableQuery.prototype.subscribeToMore = function (options) {
          var _this = this;

          var observable = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
          });
          var subscription = observable.subscribe({
            next: function next(data) {
              if (options.updateQuery) {
                var reducer_1 = options.updateQuery;

                var mapFn = function mapFn(previousResult, _a) {
                  var variables = _a.variables;
                  return reducer_1(previousResult, {
                    subscriptionData: {
                      data: data
                    },
                    variables: variables
                  });
                };

                _this.updateQuery(mapFn);
              }
            },
            error: function error(err) {
              if (options.onError) {
                options.onError(err);
              } else {
                console.error('Unhandled GraphQL subscription error', err);
              }
            }
          });
          this.subscriptionHandles.push(subscription);
          return function () {
            var i = _this.subscriptionHandles.indexOf(subscription);

            if (i >= 0) {
              _this.subscriptionHandles.splice(i, 1);

              subscription.unsubscribe();
            }
          };
        };

        ObservableQuery.prototype.setOptions = function (opts) {
          var oldOptions = this.options;
          this.options = ObservableQuery_assign({}, this.options, opts);

          if (opts.pollInterval) {
            this.startPolling(opts.pollInterval);
          } else if (opts.pollInterval === 0) {
            this.stopPolling();
          }

          var tryFetch = oldOptions.fetchPolicy !== 'network-only' && opts.fetchPolicy === 'network-only' || oldOptions.fetchPolicy === 'cache-only' && opts.fetchPolicy !== 'cache-only' || oldOptions.fetchPolicy === 'standby' && opts.fetchPolicy !== 'standby' || false;
          return this.setVariables(this.options.variables, tryFetch, opts.fetchResults);
        };

        ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
          if (tryFetch === void 0) {
            tryFetch = false;
          }

          if (fetchResults === void 0) {
            fetchResults = true;
          }

          var newVariables = ObservableQuery_assign({}, this.variables, variables);

          if (isEqual(newVariables, this.variables) && !tryFetch) {
            if (this.observers.length === 0 || !fetchResults) {
              return new Promise(function (resolve) {
                return resolve();
              });
            }

            return this.result();
          } else {
            this.variables = newVariables;
            this.options.variables = newVariables;

            if (this.observers.length === 0) {
              return new Promise(function (resolve) {
                return resolve();
              });
            }

            return this.queryManager.fetchQuery(this.queryId, ObservableQuery_assign({}, this.options, {
              variables: this.variables
            })).then(function (result) {
              return maybeDeepFreeze_maybeDeepFreeze(result);
            });
          }
        };

        ObservableQuery.prototype.updateQuery = function (mapFn) {
          var _a = this.queryManager.getQueryWithPreviousResult(this.queryId),
              previousResult = _a.previousResult,
              variables = _a.variables,
              document = _a.document;

          var newResult = tryFunctionOrLogError(function () {
            return mapFn(previousResult, {
              variables: variables
            });
          });

          if (newResult) {
            this.queryManager.store.dispatch({
              type: 'APOLLO_UPDATE_QUERY_RESULT',
              newResult: newResult,
              variables: variables,
              document: document,
              operationName: getFromAST_getOperationName(document)
            });
          }
        };

        ObservableQuery.prototype.stopPolling = function () {
          if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.options.pollInterval = undefined;
            this.isCurrentlyPolling = false;
          }
        };

        ObservableQuery.prototype.startPolling = function (pollInterval) {
          if (this.options.fetchPolicy === 'cache-first' || this.options.fetchPolicy === 'cache-only') {
            throw new Error('Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
          }

          if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.isCurrentlyPolling = false;
          }

          this.options.pollInterval = pollInterval;
          this.isCurrentlyPolling = true;
          this.scheduler.startPollingQuery(this.options, this.queryId);
        };

        ObservableQuery.prototype.onSubscribe = function (observer) {
          var _this = this;

          this.observers.push(observer);

          if (observer.next && this.lastResult) {
            observer.next(this.lastResult);
          }

          if (observer.error && this.lastError) {
            observer.error(this.lastError);
          }

          if (this.observers.length === 1) {
            this.setUpQuery();
          }

          var retQuerySubscription = {
            unsubscribe: function unsubscribe() {
              if (!_this.observers.some(function (el) {
                return el === observer;
              })) {
                return;
              }

              _this.observers = _this.observers.filter(function (obs) {
                return obs !== observer;
              });

              if (_this.observers.length === 0) {
                _this.tearDownQuery();
              }
            }
          };
          return retQuerySubscription;
        };

        ObservableQuery.prototype.setUpQuery = function () {
          var _this = this;

          if (this.shouldSubscribe) {
            this.queryManager.addObservableQuery(this.queryId, this);
          }

          if (!!this.options.pollInterval) {
            if (this.options.fetchPolicy === 'cache-first' || this.options.fetchPolicy === 'cache-only') {
              throw new Error('Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
            }

            this.isCurrentlyPolling = true;
            this.scheduler.startPollingQuery(this.options, this.queryId);
          }

          var observer = {
            next: function next(result) {
              _this.lastResult = result;

              _this.observers.forEach(function (obs) {
                if (obs.next) {
                  obs.next(result);
                }
              });
            },
            error: function error(_error5) {
              _this.observers.forEach(function (obs) {
                if (obs.error) {
                  obs.error(_error5);
                } else {
                  console.error('Unhandled error', _error5.message, _error5.stack);
                }
              });

              _this.lastError = _error5;
            }
          };
          this.queryManager.startQuery(this.queryId, this.options, this.queryManager.queryListenerForObserver(this.queryId, this.options, observer));
        };

        ObservableQuery.prototype.tearDownQuery = function () {
          if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.isCurrentlyPolling = false;
          }

          this.subscriptionHandles.forEach(function (sub) {
            return sub.unsubscribe();
          });
          this.subscriptionHandles = [];
          this.queryManager.stopQuery(this.queryId);

          if (this.shouldSubscribe) {
            this.queryManager.removeObservableQuery(this.queryId);
          }

          this.observers = [];
        };

        return ObservableQuery;
      }(Observable_Observable); // EXTERNAL MODULE: ./node_modules/apollo-link-core/lib/index.js


      var lib = __webpack_require__(296); // CONCATENATED MODULE: ./node_modules/apollo-client/util/warnOnce.js


      var warnOnce_haveWarned = Object.create({});

      function warnOnce_warnOnceInDevelopment(msg, type) {
        if (type === void 0) {
          type = 'warn';
        }

        if (Object(environment["b"
        /* isProduction */
        ])()) {
          return;
        }

        if (!warnOnce_haveWarned[msg]) {
          if (!Object(environment["c"
          /* isTest */
          ])()) {
            warnOnce_haveWarned[msg] = true;
          }

          switch (type) {
            case 'error':
              console.error(msg);
              break;

            default:
              console.warn(msg);
          }
        }
      } // CONCATENATED MODULE: ./node_modules/apollo-client/data/fragmentMatcher.js


      var fragmentMatcher_IntrospectionFragmentMatcher = function () {
        function IntrospectionFragmentMatcher(options) {
          if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
          } else {
            this.isReady = false;
          }

          this.match = this.match.bind(this);
        }

        IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
          if (!this.isReady) {
            throw new Error('FragmentMatcher.match() was called before FragmentMatcher.init()');
          }

          var obj = context.store[idValue.id];

          if (!obj) {
            return false;
          }

          if (!obj.__typename) {
            throw new Error("Cannot match fragment because __typename property is missing: " + JSON.stringify(obj));
          }

          if (obj.__typename === typeCondition) {
            return true;
          }

          var implementingTypes = this.possibleTypesMap[typeCondition];

          if (implementingTypes && implementingTypes.indexOf(obj.__typename) > -1) {
            return true;
          }

          return false;
        };

        IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
          var typeMap = {};

          introspectionResultData.__schema.types.forEach(function (type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
              typeMap[type.name] = type.possibleTypes.map(function (implementingType) {
                return implementingType.name;
              });
            }
          });

          return typeMap;
        };

        return IntrospectionFragmentMatcher;
      }();

      var fragmentMatcher_haveWarned = false;

      var fragmentMatcher_HeuristicFragmentMatcher = function () {
        function HeuristicFragmentMatcher() {}

        HeuristicFragmentMatcher.prototype.ensureReady = function () {
          return Promise.resolve();
        };

        HeuristicFragmentMatcher.prototype.canBypassInit = function () {
          return true;
        };

        HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
          var obj = context.store[idValue.id];

          if (!obj) {
            return false;
          }

          if (!obj.__typename) {
            if (!fragmentMatcher_haveWarned) {
              console.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
              console.warn('Could not find __typename on Fragment ', typeCondition, obj);
              console.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior " + "and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");

              if (!Object(environment["c"
              /* isTest */
              ])()) {
                fragmentMatcher_haveWarned = true;
              }
            }

            context.returnPartialData = true;
            return true;
          }

          if (obj.__typename === typeCondition) {
            return true;
          }

          warnOnce_warnOnceInDevelopment("You are using the simple (heuristic) fragment matcher, but your queries contain union or interface types.\n     Apollo Client will not be able to able to accurately map fragments." + "To make this error go away, use the IntrospectionFragmentMatcher as described in the docs: " + "http://dev.apollodata.com/react/initialization.html#fragment-matcher", 'error');
          context.returnPartialData = true;
          return true;
        };

        return HeuristicFragmentMatcher;
      }(); // CONCATENATED MODULE: ./node_modules/apollo-client/transport/Deduplicator.js


      var Deduplicator_Deduplicator = function () {
        function Deduplicator(networkInterface) {
          this.networkInterface = networkInterface;
          this.inFlightRequestPromises = {};
        }

        Deduplicator.prototype.query = function (request, deduplicate) {
          var _this = this;

          if (deduplicate === void 0) {
            deduplicate = true;
          }

          if (!deduplicate) {
            return this.networkInterface.query(request);
          }

          var key = this.getKey(request);

          if (!this.inFlightRequestPromises[key]) {
            this.inFlightRequestPromises[key] = this.networkInterface.query(request);
          }

          return this.inFlightRequestPromises[key].then(function (res) {
            delete _this.inFlightRequestPromises[key];
            return res;
          }).catch(function (err) {
            delete _this.inFlightRequestPromises[key];
            throw err;
          });
        };

        Deduplicator.prototype.getKey = function (request) {
          return Object(printer["print"])(request.query) + "|" + JSON.stringify(request.variables) + "|" + request.operationName;
        };

        return Deduplicator;
      }(); // CONCATENATED MODULE: ./node_modules/apollo-client/queries/store.js


      var queries_store_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var store_QueryStore = function () {
        function QueryStore() {
          this.store = {};
        }

        QueryStore.prototype.getStore = function () {
          return this.store;
        };

        QueryStore.prototype.get = function (queryId) {
          return this.store[queryId];
        };

        QueryStore.prototype.initQuery = function (query) {
          var previousQuery = this.store[query.queryId];

          if (previousQuery && previousQuery.queryString !== query.queryString) {
            throw new Error('Internal Error: may not update existing query string in store');
          }

          var isSetVariables = false;
          var previousVariables = null;

          if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== NetworkStatus.loading) {
            if (!isEqual(previousQuery.variables, query.variables)) {
              isSetVariables = true;
              previousVariables = previousQuery.variables;
            }
          }

          var networkStatus;

          if (isSetVariables) {
            networkStatus = NetworkStatus.setVariables;
          } else if (query.isPoll) {
            networkStatus = NetworkStatus.poll;
          } else if (query.isRefetch) {
            networkStatus = NetworkStatus.refetch;
          } else {
            networkStatus = NetworkStatus.loading;
          }

          this.store[query.queryId] = {
            queryString: query.queryString,
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: [],
            networkStatus: networkStatus,
            metadata: query.metadata
          };

          if (typeof query.fetchMoreForQueryId === 'string') {
            this.store[query.fetchMoreForQueryId].networkStatus = NetworkStatus.fetchMore;
          }
        };

        QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
          if (!this.store[queryId]) {
            return;
          }

          this.store[queryId].networkError = null;
          this.store[queryId].graphQLErrors = result.errors && result.errors.length ? result.errors : [];
          this.store[queryId].previousVariables = null;
          this.store[queryId].networkStatus = NetworkStatus.ready;

          if (typeof fetchMoreForQueryId === 'string') {
            this.store[fetchMoreForQueryId].networkStatus = NetworkStatus.ready;
          }
        };

        QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
          if (!this.store[queryId]) {
            return;
          }

          this.store[queryId].networkError = error;
          this.store[queryId].networkStatus = NetworkStatus.error;

          if (typeof fetchMoreForQueryId === 'string') {
            this.markQueryError(fetchMoreForQueryId, error, undefined);
          }
        };

        QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
          if (!this.store[queryId]) {
            return;
          }

          this.store[queryId].networkError = null;
          this.store[queryId].previousVariables = null;
          this.store[queryId].networkStatus = complete ? NetworkStatus.ready : NetworkStatus.loading;
        };

        QueryStore.prototype.stopQuery = function (queryId) {
          delete this.store[queryId];
        };

        QueryStore.prototype.reset = function (observableQueryIds) {
          var _this = this;

          this.store = Object.keys(this.store).filter(function (queryId) {
            return observableQueryIds.indexOf(queryId) > -1;
          }).reduce(function (res, key) {
            res[key] = queries_store_assign({}, _this.store[key], {
              networkStatus: NetworkStatus.loading
            });
            return res;
          }, {});
        };

        return QueryStore;
      }(); // CONCATENATED MODULE: ./node_modules/apollo-client/data/resultReducers.js


      function resultReducers_createStoreReducer(resultReducer, document, variables, config) {
        return function (store, action) {
          var _a = readFromStore_diffQueryAgainstStore({
            store: store,
            query: document,
            variables: variables,
            returnPartialData: true,
            fragmentMatcherFunction: config.fragmentMatcher,
            config: config
          }),
              result = _a.result,
              isMissing = _a.isMissing;

          if (isMissing) {
            return store;
          }

          var nextResult;

          try {
            nextResult = resultReducer(result, action, variables);
          } catch (err) {
            console.warn('Unhandled error in result reducer', err);
            throw err;
          }

          if (result !== nextResult) {
            return writeToStore_writeResultToStore({
              dataId: 'ROOT_QUERY',
              result: nextResult,
              store: store,
              document: document,
              variables: variables,
              dataIdFromObject: config.dataIdFromObject,
              fragmentMatcherFunction: config.fragmentMatcher
            });
          }

          return store;
        };
      } // CONCATENATED MODULE: ./node_modules/apollo-client/mutations/store.js


      var MutationStore = function () {
        function MutationStore() {
          this.store = {};
        }

        MutationStore.prototype.getStore = function () {
          return this.store;
        };

        MutationStore.prototype.get = function (mutationId) {
          return this.store[mutationId];
        };

        MutationStore.prototype.initMutation = function (mutationId, mutationString, variables) {
          this.store[mutationId] = {
            mutationString: mutationString,
            variables: variables || {},
            loading: true,
            error: null
          };
        };

        MutationStore.prototype.markMutationError = function (mutationId, error) {
          this.store[mutationId].loading = false;
          this.store[mutationId].error = error;
        };

        MutationStore.prototype.markMutationResult = function (mutationId) {
          this.store[mutationId].loading = false;
          this.store[mutationId].error = null;
        };

        MutationStore.prototype.reset = function () {
          this.store = {};
        };

        return MutationStore;
      }(); // CONCATENATED MODULE: ./node_modules/apollo-client/scheduler/scheduler.js


      var scheduler_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var scheduler_QueryScheduler = function () {
        function QueryScheduler(_a) {
          var queryManager = _a.queryManager;
          this.queryManager = queryManager;
          this.pollingTimers = {};
          this.inFlightQueries = {};
          this.registeredQueries = {};
          this.intervalQueries = {};
        }

        QueryScheduler.prototype.checkInFlight = function (queryId) {
          var query = this.queryManager.queryStore.get(queryId);
          return query && query.networkStatus !== NetworkStatus.ready && query.networkStatus !== NetworkStatus.error;
        };

        QueryScheduler.prototype.fetchQuery = function (queryId, options, fetchType) {
          var _this = this;

          return new Promise(function (resolve, reject) {
            _this.queryManager.fetchQuery(queryId, options, fetchType).then(function (result) {
              resolve(result);
            }).catch(function (error) {
              reject(error);
            });
          });
        };

        QueryScheduler.prototype.startPollingQuery = function (options, queryId, listener) {
          if (!options.pollInterval) {
            throw new Error('Attempted to start a polling query without a polling interval.');
          }

          if (this.queryManager.ssrMode) {
            return queryId;
          }

          this.registeredQueries[queryId] = options;

          if (listener) {
            this.queryManager.addQueryListener(queryId, listener);
          }

          this.addQueryOnInterval(queryId, options);
          return queryId;
        };

        QueryScheduler.prototype.stopPollingQuery = function (queryId) {
          delete this.registeredQueries[queryId];
        };

        QueryScheduler.prototype.fetchQueriesOnInterval = function (interval) {
          var _this = this;

          this.intervalQueries[interval] = this.intervalQueries[interval].filter(function (queryId) {
            if (!_this.registeredQueries.hasOwnProperty(queryId)) {
              return false;
            }

            if (_this.checkInFlight(queryId)) {
              return true;
            }

            var queryOptions = _this.registeredQueries[queryId];
            var pollingOptions = scheduler_assign({}, queryOptions);
            pollingOptions.fetchPolicy = 'network-only';

            _this.fetchQuery(queryId, pollingOptions, FetchType.poll);

            return true;
          });

          if (this.intervalQueries[interval].length === 0) {
            clearInterval(this.pollingTimers[interval]);
            delete this.intervalQueries[interval];
          }
        };

        QueryScheduler.prototype.addQueryOnInterval = function (queryId, queryOptions) {
          var _this = this;

          var interval = queryOptions.pollInterval;

          if (!interval) {
            throw new Error("A poll interval is required to start polling query with id '" + queryId + "'.");
          }

          if (this.intervalQueries.hasOwnProperty(interval.toString()) && this.intervalQueries[interval].length > 0) {
            this.intervalQueries[interval].push(queryId);
          } else {
            this.intervalQueries[interval] = [queryId];
            this.pollingTimers[interval] = setInterval(function () {
              _this.fetchQueriesOnInterval(interval);
            }, interval);
          }
        };

        QueryScheduler.prototype.registerPollingQuery = function (queryOptions) {
          if (!queryOptions.pollInterval) {
            throw new Error('Attempted to register a non-polling query with the scheduler.');
          }

          return new ObservableQuery_ObservableQuery({
            scheduler: this,
            options: queryOptions
          });
        };

        return QueryScheduler;
      }(); // CONCATENATED MODULE: ./node_modules/apollo-client/core/QueryManager.js


      var QueryManager_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var QueryManager_QueryManager = function () {
        function QueryManager(_a) {
          var networkInterface = _a.networkInterface,
              store = _a.store,
              reduxRootSelector = _a.reduxRootSelector,
              _b = _a.reducerConfig,
              reducerConfig = _b === void 0 ? {} : _b,
              fragmentMatcher = _a.fragmentMatcher,
              _c = _a.addTypename,
              addTypename = _c === void 0 ? true : _c,
              _d = _a.queryDeduplication,
              queryDeduplication = _d === void 0 ? false : _d,
              _e = _a.ssrMode,
              ssrMode = _e === void 0 ? false : _e;

          var _this = this;

          this.mutationStore = new MutationStore();
          this.queryStore = new store_QueryStore();
          this.idCounter = 1;
          this.lastRequestId = {};
          this.disableBroadcasting = false;
          this.networkInterface = networkInterface;
          this.deduplicator = new Deduplicator_Deduplicator(networkInterface);
          this.store = store;
          this.reduxRootSelector = reduxRootSelector;
          this.reducerConfig = reducerConfig;
          this.pollingTimers = {};
          this.queryListeners = {};
          this.queryDocuments = {};
          this.addTypename = addTypename;
          this.queryDeduplication = queryDeduplication;
          this.ssrMode = ssrMode;

          if (typeof fragmentMatcher === 'undefined') {
            this.fragmentMatcher = new fragmentMatcher_HeuristicFragmentMatcher();
          } else {
            this.fragmentMatcher = fragmentMatcher;
          }

          this.scheduler = new scheduler_QueryScheduler({
            queryManager: this
          });
          this.fetchQueryPromises = {};
          this.observableQueries = {};
          this.queryIdsByName = {};

          if (this.store['subscribe']) {
            var currentStoreData_1;
            this.store['subscribe'](function () {
              var previousStoreData = currentStoreData_1 || {};
              var previousStoreHasData = Object.keys(previousStoreData).length;
              currentStoreData_1 = _this.getApolloState();

              if (isEqual(previousStoreData, currentStoreData_1) && previousStoreHasData) {
                return;
              }

              _this.broadcastQueries();
            });
          }
        }

        QueryManager.prototype.broadcastNewStore = function (store) {
          this.broadcastQueries();
        };

        QueryManager.prototype.mutate = function (_a) {
          var _this = this;

          var mutation = _a.mutation,
              variables = _a.variables,
              optimisticResponse = _a.optimisticResponse,
              updateQueriesByName = _a.updateQueries,
              _b = _a.refetchQueries,
              refetchQueries = _b === void 0 ? [] : _b,
              updateWithProxyFn = _a.update;

          if (!mutation) {
            throw new Error('mutation option is required. You must specify your GraphQL document in the mutation option.');
          }

          var mutationId = this.generateQueryId();

          if (this.addTypename) {
            mutation = queryTransform_addTypenameToDocument(mutation);
          }

          variables = assign_assign({}, getFromAST_getDefaultValues(getFromAST_getMutationDefinition(mutation)), variables);
          var mutationString = Object(printer["print"])(mutation);
          var request = {
            query: mutation,
            variables: variables,
            operationName: getFromAST_getOperationName(mutation)
          };
          this.queryDocuments[mutationId] = mutation;

          var generateUpdateQueriesInfo = function generateUpdateQueriesInfo() {
            var ret = {};

            if (updateQueriesByName) {
              Object.keys(updateQueriesByName).forEach(function (queryName) {
                return (_this.queryIdsByName[queryName] || []).forEach(function (queryId) {
                  ret[queryId] = {
                    reducer: updateQueriesByName[queryName],
                    query: _this.queryStore.get(queryId)
                  };
                });
              });
            }

            return ret;
          };

          this.store.dispatch({
            type: 'APOLLO_MUTATION_INIT',
            mutationString: mutationString,
            mutation: mutation,
            variables: variables || {},
            operationName: getFromAST_getOperationName(mutation),
            mutationId: mutationId,
            optimisticResponse: optimisticResponse,
            extraReducers: this.getExtraReducers(),
            updateQueries: generateUpdateQueriesInfo(),
            update: updateWithProxyFn
          });
          this.mutationStore.initMutation(mutationId, mutationString, variables);
          return new Promise(function (resolve, reject) {
            _this.networkInterface.query(request).then(function (result) {
              if (result.errors) {
                var error = new ApolloError({
                  graphQLErrors: result.errors
                });

                _this.store.dispatch({
                  type: 'APOLLO_MUTATION_ERROR',
                  error: error,
                  mutationId: mutationId
                });

                _this.mutationStore.markMutationError(mutationId, error);

                delete _this.queryDocuments[mutationId];
                reject(error);
                return;
              }

              _this.store.dispatch({
                type: 'APOLLO_MUTATION_RESULT',
                result: result,
                mutationId: mutationId,
                document: mutation,
                operationName: getFromAST_getOperationName(mutation),
                variables: variables || {},
                extraReducers: _this.getExtraReducers(),
                updateQueries: generateUpdateQueriesInfo(),
                update: updateWithProxyFn
              });

              _this.mutationStore.markMutationResult(mutationId);

              var reducerError = _this.getApolloState().reducerError;

              if (reducerError && reducerError.mutationId === mutationId) {
                reject(reducerError.error);
                return;
              }

              if (typeof refetchQueries[0] === 'string') {
                refetchQueries.forEach(function (name) {
                  _this.refetchQueryByName(name);
                });
              } else {
                refetchQueries.forEach(function (pureQuery) {
                  _this.query({
                    query: pureQuery.query,
                    variables: pureQuery.variables,
                    fetchPolicy: 'network-only'
                  });
                });
              }

              delete _this.queryDocuments[mutationId];
              resolve(result);
            }).catch(function (err) {
              _this.store.dispatch({
                type: 'APOLLO_MUTATION_ERROR',
                error: err,
                mutationId: mutationId
              });

              delete _this.queryDocuments[mutationId];
              reject(new ApolloError({
                networkError: err
              }));
            });
          });
        };

        QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, fetchMoreForQueryId) {
          var _this = this;

          var _a = options.variables,
              variables = _a === void 0 ? {} : _a,
              _b = options.metadata,
              metadata = _b === void 0 ? null : _b,
              _c = options.fetchPolicy,
              fetchPolicy = _c === void 0 ? 'cache-first' : _c;
          var queryDoc = this.transformQueryDocument(options).queryDoc;
          var queryString = Object(printer["print"])(queryDoc);
          var storeResult;
          var needToFetch = fetchPolicy === 'network-only';

          if (fetchType !== FetchType.refetch && fetchPolicy !== 'network-only') {
            var _d = readFromStore_diffQueryAgainstStore({
              query: queryDoc,
              store: this.reduxRootSelector(this.store.getState()).data,
              variables: variables,
              returnPartialData: true,
              fragmentMatcherFunction: this.fragmentMatcher.match,
              config: this.reducerConfig
            }),
                isMissing = _d.isMissing,
                result = _d.result;

            needToFetch = isMissing || fetchPolicy === 'cache-and-network';
            storeResult = result;
          }

          var shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
          var requestId = this.generateRequestId();
          this.queryDocuments[queryId] = queryDoc;
          this.queryStore.initQuery({
            queryId: queryId,
            queryString: queryString,
            document: queryDoc,
            storePreviousVariables: shouldFetch,
            variables: variables,
            isPoll: fetchType === FetchType.poll,
            isRefetch: fetchType === FetchType.refetch,
            metadata: metadata,
            fetchMoreForQueryId: fetchMoreForQueryId
          });
          this.broadcastQueries();

          if (QueryManager.EMIT_REDUX_ACTIONS) {
            this.store.dispatch({
              type: 'APOLLO_QUERY_INIT',
              queryString: queryString,
              document: queryDoc,
              operationName: getFromAST_getOperationName(queryDoc),
              variables: variables,
              fetchPolicy: fetchPolicy,
              queryId: queryId,
              requestId: requestId,
              storePreviousVariables: shouldFetch,
              isPoll: fetchType === FetchType.poll,
              isRefetch: fetchType === FetchType.refetch,
              fetchMoreForQueryId: fetchMoreForQueryId,
              metadata: metadata
            });
          }

          this.lastRequestId[queryId] = requestId;
          var shouldDispatchClientResult = !shouldFetch || fetchPolicy === 'cache-and-network';

          if (shouldDispatchClientResult) {
            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
            this.broadcastQueries();

            if (QueryManager.EMIT_REDUX_ACTIONS) {
              this.store.dispatch({
                type: 'APOLLO_QUERY_RESULT_CLIENT',
                result: {
                  data: storeResult
                },
                variables: variables,
                document: queryDoc,
                operationName: getFromAST_getOperationName(queryDoc),
                complete: !shouldFetch,
                queryId: queryId,
                requestId: requestId
              });
            }
          }

          if (shouldFetch) {
            var networkResult = this.fetchRequest({
              requestId: requestId,
              queryId: queryId,
              document: queryDoc,
              options: options,
              fetchMoreForQueryId: fetchMoreForQueryId
            }).catch(function (error) {
              if (isApolloError(error)) {
                throw error;
              } else {
                if (requestId >= (_this.lastRequestId[queryId] || 1)) {
                  if (QueryManager.EMIT_REDUX_ACTIONS) {
                    _this.store.dispatch({
                      type: 'APOLLO_QUERY_ERROR',
                      error: error,
                      queryId: queryId,
                      requestId: requestId,
                      fetchMoreForQueryId: fetchMoreForQueryId
                    });
                  }

                  _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);

                  _this.broadcastQueries();
                }

                _this.removeFetchQueryPromise(requestId);

                throw new ApolloError({
                  networkError: error
                });
              }
            });

            if (fetchPolicy !== 'cache-and-network') {
              return networkResult;
            }
          }

          return Promise.resolve({
            data: storeResult
          });
        };

        QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
          var _this = this;

          var previouslyHadError = false;
          return function (queryStoreValue) {
            if (!queryStoreValue) {
              return;
            }

            queryStoreValue = _this.queryStore.get(queryId);
            var storedQuery = _this.observableQueries[queryId];
            var observableQuery = storedQuery ? storedQuery.observableQuery : null;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;

            if (fetchPolicy === 'standby') {
              return;
            }

            var lastResult = observableQuery ? observableQuery.getLastResult() : null;
            var shouldNotifyIfLoading = queryStoreValue.previousVariables || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            var networkStatusChanged = lastResult && queryStoreValue.networkStatus !== lastResult.networkStatus;

            if (!isNetworkRequestInFlight(queryStoreValue.networkStatus) || networkStatusChanged && options.notifyOnNetworkStatusChange || shouldNotifyIfLoading) {
              if (queryStoreValue.graphQLErrors && queryStoreValue.graphQLErrors.length > 0 || queryStoreValue.networkError) {
                var apolloError_1 = new ApolloError({
                  graphQLErrors: queryStoreValue.graphQLErrors,
                  networkError: queryStoreValue.networkError
                });
                previouslyHadError = true;

                if (observer.error) {
                  try {
                    observer.error(apolloError_1);
                  } catch (e) {
                    setTimeout(function () {
                      throw e;
                    }, 0);
                  }
                } else {
                  setTimeout(function () {
                    throw apolloError_1;
                  }, 0);

                  if (!Object(environment["b"
                  /* isProduction */
                  ])()) {
                    console.info('An unhandled error was thrown because no error handler is registered ' + 'for the query ' + queryStoreValue.queryString);
                  }
                }
              } else {
                try {
                  var _a = readFromStore_diffQueryAgainstStore({
                    store: _this.getDataWithOptimisticResults(),
                    query: _this.queryDocuments[queryId],
                    variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                    config: _this.reducerConfig,
                    fragmentMatcherFunction: _this.fragmentMatcher.match,
                    previousResult: lastResult && lastResult.data
                  }),
                      data = _a.result,
                      isMissing = _a.isMissing;

                  var resultFromStore = void 0;

                  if (isMissing && fetchPolicy !== 'cache-only') {
                    resultFromStore = {
                      data: lastResult && lastResult.data,
                      loading: isNetworkRequestInFlight(queryStoreValue.networkStatus),
                      networkStatus: queryStoreValue.networkStatus,
                      stale: true
                    };
                  } else {
                    resultFromStore = {
                      data: data,
                      loading: isNetworkRequestInFlight(queryStoreValue.networkStatus),
                      networkStatus: queryStoreValue.networkStatus,
                      stale: false
                    };
                  }

                  if (observer.next) {
                    var isDifferentResult = !(lastResult && resultFromStore && lastResult.networkStatus === resultFromStore.networkStatus && lastResult.stale === resultFromStore.stale && lastResult.data === resultFromStore.data);

                    if (isDifferentResult || previouslyHadError) {
                      try {
                        observer.next(maybeDeepFreeze_maybeDeepFreeze(resultFromStore));
                      } catch (e) {
                        setTimeout(function () {
                          throw e;
                        }, 0);
                      }
                    }
                  }

                  previouslyHadError = false;
                } catch (error) {
                  previouslyHadError = true;

                  if (observer.error) {
                    observer.error(new ApolloError({
                      networkError: error
                    }));
                  }

                  return;
                }
              }
            }
          };
        };

        QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
          if (shouldSubscribe === void 0) {
            shouldSubscribe = true;
          }

          if (options.returnPartialData) {
            throw new Error('returnPartialData option is no longer supported since Apollo Client 1.0.');
          }

          if (options.forceFetch) {
            throw new Error('forceFetch option is no longer supported since Apollo Client 1.0. Use fetchPolicy instead.');
          }

          if (options.noFetch) {
            throw new Error('noFetch option is no longer supported since Apollo Client 1.0. Use fetchPolicy instead.');
          }

          if (options.fetchPolicy === 'standby') {
            throw new Error('client.watchQuery cannot be called with fetchPolicy set to "standby"');
          }

          var queryDefinition = getFromAST_getQueryDefinition(options.query);

          if (queryDefinition.variableDefinitions && queryDefinition.variableDefinitions.length) {
            var defaultValues = getFromAST_getDefaultValues(queryDefinition);
            options.variables = assign_assign({}, defaultValues, options.variables);
          }

          if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
          }

          var transformedOptions = QueryManager_assign({}, options);
          var observableQuery = new ObservableQuery_ObservableQuery({
            scheduler: this.scheduler,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
          });
          return observableQuery;
        };

        QueryManager.prototype.query = function (options) {
          var _this = this;

          if (!options.query) {
            throw new Error('query option is required. You must specify your GraphQL document in the query option.');
          }

          if (options.query.kind !== 'Document') {
            throw new Error('You must wrap the query string in a "gql" tag.');
          }

          if (options.returnPartialData) {
            throw new Error('returnPartialData option only supported on watchQuery.');
          }

          if (options.pollInterval) {
            throw new Error('pollInterval option only supported on watchQuery.');
          }

          if (options.forceFetch) {
            throw new Error('forceFetch option is no longer supported since Apollo Client 1.0. Use fetchPolicy instead.');
          }

          if (options.noFetch) {
            throw new Error('noFetch option is no longer supported since Apollo Client 1.0. Use fetchPolicy instead.');
          }

          if (typeof options.notifyOnNetworkStatusChange !== 'undefined') {
            throw new Error('Cannot call "query" with "notifyOnNetworkStatusChange" option. Only "watchQuery" has that option.');
          }

          options.notifyOnNetworkStatusChange = false;
          var requestId = this.idCounter;
          var resPromise = new Promise(function (resolve, reject) {
            _this.addFetchQueryPromise(requestId, resPromise, resolve, reject);

            return _this.watchQuery(options, false).result().then(function (result) {
              _this.removeFetchQueryPromise(requestId);

              resolve(result);
            }).catch(function (error) {
              _this.removeFetchQueryPromise(requestId);

              reject(error);
            });
          });
          return resPromise;
        };

        QueryManager.prototype.generateQueryId = function () {
          var queryId = this.idCounter.toString();
          this.idCounter++;
          return queryId;
        };

        QueryManager.prototype.stopQueryInStore = function (queryId) {
          this.queryStore.stopQuery(queryId);
          this.broadcastQueries();

          if (QueryManager.EMIT_REDUX_ACTIONS) {
            this.store.dispatch({
              type: 'APOLLO_QUERY_STOP',
              queryId: queryId
            });
          }
        };

        QueryManager.prototype.getApolloState = function () {
          return this.reduxRootSelector(this.store.getState());
        };

        QueryManager.prototype.selectApolloState = function (store) {
          return this.reduxRootSelector(store.getState());
        };

        QueryManager.prototype.getInitialState = function () {
          return {
            data: this.getApolloState().data
          };
        };

        QueryManager.prototype.getDataWithOptimisticResults = function () {
          return store_getDataWithOptimisticResults(this.getApolloState());
        };

        QueryManager.prototype.addQueryListener = function (queryId, listener) {
          this.queryListeners[queryId] = this.queryListeners[queryId] || [];
          this.queryListeners[queryId].push(listener);
        };

        QueryManager.prototype.addFetchQueryPromise = function (requestId, promise, resolve, reject) {
          this.fetchQueryPromises[requestId.toString()] = {
            promise: promise,
            resolve: resolve,
            reject: reject
          };
        };

        QueryManager.prototype.removeFetchQueryPromise = function (requestId) {
          delete this.fetchQueryPromises[requestId.toString()];
        };

        QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
          this.observableQueries[queryId] = {
            observableQuery: observableQuery
          };
          var queryDef = getFromAST_getQueryDefinition(observableQuery.options.query);

          if (queryDef.name && queryDef.name.value) {
            var queryName = queryDef.name.value;
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName] || [];
            this.queryIdsByName[queryName].push(observableQuery.queryId);
          }
        };

        QueryManager.prototype.removeObservableQuery = function (queryId) {
          var observableQuery = this.observableQueries[queryId].observableQuery;
          var definition = getFromAST_getQueryDefinition(observableQuery.options.query);
          var queryName = definition.name ? definition.name.value : null;
          delete this.observableQueries[queryId];

          if (queryName) {
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName].filter(function (val) {
              return !(observableQuery.queryId === val);
            });
          }
        };

        QueryManager.prototype.resetStore = function () {
          var _this = this;

          Object.keys(this.fetchQueryPromises).forEach(function (key) {
            var reject = _this.fetchQueryPromises[key].reject;
            reject(new Error('Store reset while query was in flight.'));
          });
          this.queryStore.reset(Object.keys(this.observableQueries));
          this.store.dispatch({
            type: 'APOLLO_STORE_RESET',
            observableQueryIds: Object.keys(this.observableQueries)
          });
          this.mutationStore.reset();
          var observableQueryPromises = [];
          Object.keys(this.observableQueries).forEach(function (queryId) {
            var storeQuery = _this.queryStore.get(queryId);

            var fetchPolicy = _this.observableQueries[queryId].observableQuery.options.fetchPolicy;

            if (fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby') {
              observableQueryPromises.push(_this.observableQueries[queryId].observableQuery.refetch());
            }
          });
          return Promise.all(observableQueryPromises);
        };

        QueryManager.prototype.startQuery = function (queryId, options, listener) {
          this.addQueryListener(queryId, listener);
          this.fetchQuery(queryId, options).catch(function (error) {
            return undefined;
          });
          return queryId;
        };

        QueryManager.prototype.startGraphQLSubscription = function (options) {
          var _this = this;

          var query = options.query;
          var transformedDoc = query;

          if (this.addTypename) {
            transformedDoc = queryTransform_addTypenameToDocument(transformedDoc);
          }

          var variables = assign_assign({}, getFromAST_getDefaultValues(getFromAST_getOperationDefinition(query)), options.variables);
          var request = {
            query: transformedDoc,
            variables: variables,
            operationName: getFromAST_getOperationName(transformedDoc)
          };
          var subId;
          var observers = [];
          return new Observable_Observable(function (observer) {
            observers.push(observer);

            if (observers.length === 1) {
              var handler = function handler(error, result) {
                if (error) {
                  observers.forEach(function (obs) {
                    if (obs.error) {
                      obs.error(error);
                    }
                  });
                } else {
                  _this.store.dispatch({
                    type: 'APOLLO_SUBSCRIPTION_RESULT',
                    document: transformedDoc,
                    operationName: getFromAST_getOperationName(transformedDoc),
                    result: {
                      data: result
                    },
                    variables: variables,
                    subscriptionId: subId,
                    extraReducers: _this.getExtraReducers()
                  });

                  observers.forEach(function (obs) {
                    if (obs.next) {
                      obs.next(result);
                    }
                  });
                }
              };

              subId = _this.networkInterface.subscribe(request, handler);
            }

            return {
              unsubscribe: function unsubscribe() {
                observers = observers.filter(function (obs) {
                  return obs !== observer;
                });

                if (observers.length === 0) {
                  _this.networkInterface.unsubscribe(subId);
                }
              },
              _networkSubscriptionId: subId
            };
          });
        };

        QueryManager.prototype.removeQuery = function (queryId) {
          delete this.queryListeners[queryId];
          delete this.queryDocuments[queryId];
        };

        QueryManager.prototype.stopQuery = function (queryId) {
          this.removeQuery(queryId);
          this.stopQueryInStore(queryId);
        };

        QueryManager.prototype.getCurrentQueryResult = function (observableQuery, isOptimistic) {
          if (isOptimistic === void 0) {
            isOptimistic = false;
          }

          var _a = this.getQueryParts(observableQuery),
              variables = _a.variables,
              document = _a.document;

          var lastResult = observableQuery.getLastResult();
          var queryOptions = observableQuery.options;
          var readOptions = {
            store: isOptimistic ? this.getDataWithOptimisticResults() : this.getApolloState().data,
            query: document,
            variables: variables,
            config: this.reducerConfig,
            previousResult: lastResult ? lastResult.data : undefined,
            fragmentMatcherFunction: this.fragmentMatcher.match
          };

          try {
            var data = readFromStore_readQueryFromStore(readOptions);
            return maybeDeepFreeze_maybeDeepFreeze({
              data: data,
              partial: false
            });
          } catch (e) {
            return maybeDeepFreeze_maybeDeepFreeze({
              data: {},
              partial: true
            });
          }
        };

        QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable, isOptimistic) {
          if (isOptimistic === void 0) {
            isOptimistic = false;
          }

          var observableQuery;

          if (typeof queryIdOrObservable === 'string') {
            if (!this.observableQueries[queryIdOrObservable]) {
              throw new Error("ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
            }

            observableQuery = this.observableQueries[queryIdOrObservable].observableQuery;
          } else {
            observableQuery = queryIdOrObservable;
          }

          var _a = this.getQueryParts(observableQuery),
              variables = _a.variables,
              document = _a.document;

          var data = this.getCurrentQueryResult(observableQuery, isOptimistic).data;
          return {
            previousResult: data,
            variables: variables,
            document: document
          };
        };

        QueryManager.prototype.getQueryParts = function (observableQuery) {
          var queryOptions = observableQuery.options;
          var transformedDoc = observableQuery.options.query;

          if (this.addTypename) {
            transformedDoc = queryTransform_addTypenameToDocument(transformedDoc);
          }

          return {
            variables: queryOptions.variables,
            document: transformedDoc
          };
        };

        QueryManager.prototype.transformQueryDocument = function (options) {
          var queryDoc = options.query;

          if (this.addTypename) {
            queryDoc = queryTransform_addTypenameToDocument(queryDoc);
          }

          return {
            queryDoc: queryDoc
          };
        };

        QueryManager.prototype.getExtraReducers = function () {
          var _this = this;

          return Object.keys(this.observableQueries).map(function (obsQueryId) {
            var query = _this.observableQueries[obsQueryId].observableQuery;
            var queryOptions = query.options;

            if (queryOptions.reducer) {
              return resultReducers_createStoreReducer(queryOptions.reducer, _this.addTypename ? queryTransform_addTypenameToDocument(queryOptions.query) : queryOptions.query, query.variables || {}, _this.reducerConfig);
            }

            return null;
          }).filter(function (reducer) {
            return reducer !== null;
          });
        };

        QueryManager.prototype.fetchRequest = function (_a) {
          var _this = this;

          var requestId = _a.requestId,
              queryId = _a.queryId,
              document = _a.document,
              options = _a.options,
              fetchMoreForQueryId = _a.fetchMoreForQueryId;
          var variables = options.variables;
          var request = {
            query: document,
            variables: variables,
            operationName: getFromAST_getOperationName(document)
          };
          var retPromise = new Promise(function (resolve, reject) {
            _this.addFetchQueryPromise(requestId, retPromise, resolve, reject);

            _this.deduplicator.query(request, _this.queryDeduplication).then(function (result) {
              var extraReducers = _this.getExtraReducers();

              if (requestId >= (_this.lastRequestId[queryId] || 1)) {
                _this.disableBroadcasting = true;

                _this.store.dispatch({
                  type: 'APOLLO_QUERY_RESULT',
                  document: document,
                  variables: variables ? variables : {},
                  operationName: getFromAST_getOperationName(document),
                  result: result,
                  queryId: queryId,
                  requestId: requestId,
                  fetchMoreForQueryId: fetchMoreForQueryId,
                  extraReducers: extraReducers
                });

                _this.disableBroadcasting = false;

                var reducerError = _this.getApolloState().reducerError;

                if (!reducerError || reducerError.queryId !== queryId) {
                  _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);

                  _this.broadcastQueries();
                }
              }

              _this.removeFetchQueryPromise(requestId);

              if (result.errors) {
                throw new ApolloError({
                  graphQLErrors: result.errors
                });
              }

              return result;
            }).then(function (result) {
              var resultFromStore;

              if (fetchMoreForQueryId) {
                resultFromStore = result.data;
              } else {
                try {
                  resultFromStore = readFromStore_readQueryFromStore({
                    store: _this.getApolloState().data,
                    variables: variables,
                    query: document,
                    config: _this.reducerConfig,
                    fragmentMatcherFunction: _this.fragmentMatcher.match
                  });
                } catch (e) {}
              }

              var reducerError = _this.getApolloState().reducerError;

              if (reducerError && reducerError.queryId === queryId) {
                return Promise.reject(reducerError.error);
              }

              _this.removeFetchQueryPromise(requestId);

              resolve({
                data: resultFromStore,
                loading: false,
                networkStatus: NetworkStatus.ready,
                stale: false
              });
              return Promise.resolve();
            }).catch(function (error) {
              reject(error);
            });
          });
          return retPromise;
        };

        QueryManager.prototype.refetchQueryByName = function (queryName) {
          var _this = this;

          var refetchedQueries = this.queryIdsByName[queryName];

          if (refetchedQueries === undefined) {
            console.warn("Warning: unknown query with name " + queryName + " asked to refetch");
            return;
          } else {
            return Promise.all(refetchedQueries.map(function (queryId) {
              return _this.observableQueries[queryId].observableQuery.refetch();
            }));
          }
        };

        QueryManager.prototype.broadcastQueries = function () {
          var _this = this;

          if (this.disableBroadcasting) {
            return;
          }

          Object.keys(this.queryListeners).forEach(function (queryId) {
            var listeners = _this.queryListeners[queryId];

            if (listeners) {
              listeners.forEach(function (listener) {
                if (listener) {
                  var queryStoreValue = _this.queryStore.get(queryId);

                  listener(queryStoreValue);
                }
              });
            }
          });
        };

        QueryManager.prototype.generateRequestId = function () {
          var requestId = this.idCounter;
          this.idCounter++;
          return requestId;
        };

        QueryManager.EMIT_REDUX_ACTIONS = true;
        return QueryManager;
      }(); // EXTERNAL MODULE: ./node_modules/apollo-client/version.js


      var version = __webpack_require__(711); // CONCATENATED MODULE: ./node_modules/apollo-client/ApolloClient.js


      var ApolloClient_assign = undefined && undefined.__assign || Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

      var ApolloClient_DEFAULT_REDUX_ROOT_KEY = 'apollo';

      function ApolloClient_defaultReduxRootSelector(state) {
        return state[ApolloClient_DEFAULT_REDUX_ROOT_KEY];
      }

      function ApolloClient_defaultDataIdFromObject(result) {
        if (result.__typename) {
          if (result.id !== undefined) {
            return result.__typename + ":" + result.id;
          }

          if (result._id !== undefined) {
            return result.__typename + ":" + result._id;
          }
        }

        return null;
      }

      var ApolloClient_hasSuggestedDevtools = false;

      var ApolloClient_ApolloClient = function () {
        function ApolloClient(options) {
          if (options === void 0) {
            options = {};
          }

          var _this = this;

          this.middleware = function () {
            return function (store) {
              _this.setStore(store);

              return function (next) {
                return function (action) {
                  var previousApolloState = _this.queryManager.selectApolloState(store);

                  var returnValue = next(action);

                  var newApolloState = _this.queryManager.selectApolloState(store);

                  if (newApolloState !== previousApolloState) {
                    _this.queryManager.broadcastNewStore(store.getState());
                  }

                  if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                      action: action,
                      state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                      },
                      dataWithOptimisticResults: _this.queryManager.getDataWithOptimisticResults()
                    });
                  }

                  return returnValue;
                };
              };
            };
          };

          var dataIdFromObject = options.dataIdFromObject;
          var networkInterface = options.networkInterface,
              reduxRootSelector = options.reduxRootSelector,
              initialState = options.initialState,
              _a = options.ssrMode,
              ssrMode = _a === void 0 ? false : _a,
              _b = options.ssrForceFetchDelay,
              ssrForceFetchDelay = _b === void 0 ? 0 : _b,
              _c = options.addTypename,
              addTypename = _c === void 0 ? true : _c,
              customResolvers = options.customResolvers,
              connectToDevTools = options.connectToDevTools,
              fragmentMatcher = options.fragmentMatcher,
              _d = options.queryDeduplication,
              queryDeduplication = _d === void 0 ? true : _d;

          if (typeof reduxRootSelector === 'function') {
            this.reduxRootSelector = reduxRootSelector;
          } else if (typeof reduxRootSelector !== 'undefined') {
            throw new Error('"reduxRootSelector" must be a function.');
          }

          if (typeof fragmentMatcher === 'undefined') {
            this.fragmentMatcher = new fragmentMatcher_HeuristicFragmentMatcher();
          } else {
            this.fragmentMatcher = fragmentMatcher;
          }

          var createQuery = function createQuery(getResult) {
            return function (request) {
              return new Promise(function (resolve, reject) {
                var resolved = false;
                var subscription = getResult(request).subscribe({
                  next: function next(data) {
                    if (!resolved) {
                      resolve(data);
                      resolved = true;
                    } else {
                      console.warn('Apollo Client does not support multiple results from an Observable');
                    }
                  },
                  error: reject,
                  complete: function complete() {
                    return subscription.unsubscribe();
                  }
                });
              });
            };
          };

          if (networkInterface instanceof lib["ApolloLink"]) {
            var count_1 = 0;
            this.networkInterface = {
              query: createQuery(function (request) {
                return Object(lib["execute"])(networkInterface, request);
              }),
              subscribe: function subscribe(request, handler) {
                if (!_this.subscriptionMap) {
                  _this.subscriptionMap = new Map();
                }

                var subscription = Object(lib["execute"])(networkInterface, request).subscribe({
                  next: function next(data) {
                    return handler(undefined, data);
                  },
                  error: function error(_error6) {
                    return handler([_error6]);
                  },
                  complete: handler
                });
                var id = count_1.toString();

                _this.subscriptionMap.set(id, subscription);

                count_1++;
                return id;
              },
              unsubscribe: function unsubscribe(id) {
                if (_this.subscriptionMap) {
                  var subscription = _this.subscriptionMap.get(id);

                  if (subscription) {
                    subscription.unsubscribe();
                  }
                }
              }
            };
          } else {
            this.networkInterface = networkInterface ? networkInterface : networkInterface_createNetworkInterface({
              uri: '/graphql'
            });
          }

          this.initialState = initialState ? initialState : {};
          this.addTypename = addTypename;
          this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
          this.dataId = dataIdFromObject = dataIdFromObject || ApolloClient_defaultDataIdFromObject;
          this.dataIdFromObject = this.dataId;
          this.fieldWithArgs = getStoreKeyName;
          this.queryDeduplication = queryDeduplication;
          this.ssrMode = ssrMode;

          if (ssrForceFetchDelay) {
            setTimeout(function () {
              return _this.disableNetworkFetches = false;
            }, ssrForceFetchDelay);
          }

          this.reducerConfig = {
            dataIdFromObject: dataIdFromObject,
            customResolvers: customResolvers,
            addTypename: addTypename,
            fragmentMatcher: this.fragmentMatcher.match
          };
          this.watchQuery = this.watchQuery.bind(this);
          this.query = this.query.bind(this);
          this.mutate = this.mutate.bind(this);
          this.setStore = this.setStore.bind(this);
          this.resetStore = this.resetStore.bind(this);
          var defaultConnectToDevTools = !Object(environment["b"
          /* isProduction */
          ])() && typeof window !== 'undefined' && !window.__APOLLO_CLIENT__;

          if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools) {
            window.__APOLLO_CLIENT__ = this;
          }

          if (!ApolloClient_hasSuggestedDevtools && !Object(environment["b"
          /* isProduction */
          ])()) {
            ApolloClient_hasSuggestedDevtools = true;

            if (typeof window !== 'undefined' && window.document && window.top === window.self) {
              if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                if (navigator.userAgent.indexOf('Chrome') > -1) {
                  console.debug('Download the Apollo DevTools ' + 'for a better development experience: ' + 'https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm');
                }
              }
            }
          }

          this.version = version["version"];
        }

        ApolloClient.prototype.watchQuery = function (options) {
          this.initStore();

          if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = ApolloClient_assign({}, options, {
              fetchPolicy: 'cache-first'
            });
          }

          return this.queryManager.watchQuery(options);
        };

        ApolloClient.prototype.query = function (options) {
          this.initStore();

          if (options.fetchPolicy === 'cache-and-network') {
            throw new Error('cache-and-network fetchPolicy can only be used with watchQuery');
          }

          if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = ApolloClient_assign({}, options, {
              fetchPolicy: 'cache-first'
            });
          }

          return this.queryManager.query(options);
        };

        ApolloClient.prototype.mutate = function (options) {
          this.initStore();
          return this.queryManager.mutate(options);
        };

        ApolloClient.prototype.subscribe = function (options) {
          this.initStore();
          return this.queryManager.startGraphQLSubscription(options);
        };

        ApolloClient.prototype.readQuery = function (options) {
          return this.initProxy().readQuery(options);
        };

        ApolloClient.prototype.readFragment = function (options) {
          return this.initProxy().readFragment(options);
        };

        ApolloClient.prototype.writeQuery = function (options) {
          return this.initProxy().writeQuery(options);
        };

        ApolloClient.prototype.writeFragment = function (options) {
          return this.initProxy().writeFragment(options);
        };

        ApolloClient.prototype.reducer = function () {
          return store_createApolloReducer(this.reducerConfig);
        };

        ApolloClient.prototype.__actionHookForDevTools = function (cb) {
          this.devToolsHookCb = cb;
        };

        ApolloClient.prototype.initStore = function () {
          var _this = this;

          if (this.store) {
            return;
          }

          if (this.reduxRootSelector) {
            throw new Error('Cannot initialize the store because "reduxRootSelector" is provided. ' + 'reduxRootSelector should only be used when the store is created outside of the client. ' + 'This may lead to unexpected results when querying the store internally. ' + "Please remove that option from ApolloClient constructor.");
          }

          this.setStore(store_createApolloStore({
            reduxRootKey: ApolloClient_DEFAULT_REDUX_ROOT_KEY,
            initialState: this.initialState,
            config: this.reducerConfig,
            logger: function logger(store) {
              return function (next) {
                return function (action) {
                  var result = next(action);

                  if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                      action: action,
                      state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                      },
                      dataWithOptimisticResults: _this.queryManager.getDataWithOptimisticResults()
                    });
                  }

                  return result;
                };
              };
            }
          }));
        };

        ApolloClient.prototype.resetStore = function () {
          return this.queryManager ? this.queryManager.resetStore() : null;
        };

        ApolloClient.prototype.getInitialState = function () {
          this.initStore();
          return this.queryManager.getInitialState();
        };

        ApolloClient.prototype.setStore = function (store) {
          var reduxRootSelector;

          if (this.reduxRootSelector) {
            reduxRootSelector = this.reduxRootSelector;
          } else {
            reduxRootSelector = ApolloClient_defaultReduxRootSelector;
          }

          if (typeof reduxRootSelector(store.getState()) === 'undefined') {
            throw new Error('Existing store does not use apolloReducer. Please make sure the store ' + 'is properly configured and "reduxRootSelector" is correctly specified.');
          }

          this.store = store;
          this.queryManager = new QueryManager_QueryManager({
            networkInterface: this.networkInterface,
            reduxRootSelector: reduxRootSelector,
            store: store,
            addTypename: this.addTypename,
            reducerConfig: this.reducerConfig,
            queryDeduplication: this.queryDeduplication,
            fragmentMatcher: this.fragmentMatcher,
            ssrMode: this.ssrMode
          });
        };

        ApolloClient.prototype.initProxy = function () {
          if (!this.proxy) {
            this.initStore();
            this.proxy = new proxy_ReduxDataProxy(this.store, this.reduxRootSelector || ApolloClient_defaultReduxRootSelector, this.fragmentMatcher, this.reducerConfig);
          }

          return this.proxy;
        };

        return ApolloClient;
      }();
      /* harmony default export */


      var apollo_client_ApolloClient = ApolloClient_ApolloClient; // CONCATENATED MODULE: ./node_modules/apollo-client/index.js

      /* concated harmony reexport */

      __webpack_require__.d(__webpack_exports__, "createNetworkInterface", function () {
        return networkInterface_createNetworkInterface;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "createBatchingNetworkInterface", function () {
        return batchedNetworkInterface_createBatchingNetworkInterface;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "createApolloStore", function () {
        return store_createApolloStore;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "createApolloReducer", function () {
        return store_createApolloReducer;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "readQueryFromStore", function () {
        return readFromStore_readQueryFromStore;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "writeQueryToStore", function () {
        return writeToStore_writeQueryToStore;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "addTypenameToDocument", function () {
        return queryTransform_addTypenameToDocument;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "createFragmentMap", function () {
        return getFromAST_createFragmentMap;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "NetworkStatus", function () {
        return NetworkStatus;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "ApolloError", function () {
        return ApolloError;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "getQueryDefinition", function () {
        return getFromAST_getQueryDefinition;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "getMutationDefinition", function () {
        return getFromAST_getMutationDefinition;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "getFragmentDefinitions", function () {
        return getFromAST_getFragmentDefinitions;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "toIdValue", function () {
        return toIdValue;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "IntrospectionFragmentMatcher", function () {
        return fragmentMatcher_IntrospectionFragmentMatcher;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "printAST", function () {
        return printer["print"];
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "HTTPFetchNetworkInterface", function () {
        return networkInterface_HTTPFetchNetworkInterface;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "HTTPBatchedNetworkInterface", function () {
        return batchedNetworkInterface_HTTPBatchedNetworkInterface;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "ObservableQuery", function () {
        return ObservableQuery_ObservableQuery;
      });
      /* concated harmony reexport */


      __webpack_require__.d(__webpack_exports__, "ApolloClient", function () {
        return apollo_client_ApolloClient;
      });
      /* harmony default export */


      var apollo_client = __webpack_exports__["default"] = apollo_client_ApolloClient;
      /***/
    },
    /* 716 */

    /***/
    function (module, exports, __webpack_require__) {
      var SetCache = __webpack_require__(329),
          arrayIncludes = __webpack_require__(448),
          arrayIncludesWith = __webpack_require__(447),
          arrayMap = __webpack_require__(176),
          baseUnary = __webpack_require__(244),
          cacheHas = __webpack_require__(328);
      /** Used as the size to enable large array optimizations. */


      var LARGE_ARRAY_SIZE = 200;
      /**
       * The base implementation of methods like `_.difference` without support
       * for excluding multiple arrays or iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Array} values The values to exclude.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       */

      function baseDifference(array, values, iteratee, comparator) {
        var index = -1,
            includes = arrayIncludes,
            isCommon = true,
            length = array.length,
            result = [],
            valuesLength = values.length;

        if (!length) {
          return result;
        }

        if (iteratee) {
          values = arrayMap(values, baseUnary(iteratee));
        }

        if (comparator) {
          includes = arrayIncludesWith;
          isCommon = false;
        } else if (values.length >= LARGE_ARRAY_SIZE) {
          includes = cacheHas;
          isCommon = false;
          values = new SetCache(values);
        }

        outer: while (++index < length) {
          var value = array[index],
              computed = iteratee == null ? value : iteratee(value);
          value = comparator || value !== 0 ? value : 0;

          if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;

            while (valuesIndex--) {
              if (values[valuesIndex] === computed) {
                continue outer;
              }
            }

            result.push(value);
          } else if (!includes(values, computed, comparator)) {
            result.push(value);
          }
        }

        return result;
      }

      module.exports = baseDifference;
      /***/
    },
    /* 717 */

    /***/
    function (module, exports) {
      /**
       * The base implementation of `_.reduce` and `_.reduceRight`, without support
       * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {*} accumulator The initial value.
       * @param {boolean} initAccum Specify using the first or last element of
       *  `collection` as the initial value.
       * @param {Function} eachFunc The function to iterate over `collection`.
       * @returns {*} Returns the accumulated value.
       */
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function (value, index, collection) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
      }

      module.exports = baseReduce;
      /***/
    },
    /* 718 */

    /***/
    function (module, exports) {
      /**
       * A specialized version of `_.reduce` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @param {boolean} [initAccum] Specify using the first element of `array` as
       *  the initial value.
       * @returns {*} Returns the accumulated value.
       */
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1,
            length = array == null ? 0 : array.length;

        if (initAccum && length) {
          accumulator = array[++index];
        }

        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }

        return accumulator;
      }

      module.exports = arrayReduce;
      /***/
    },
    /* 719 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseForOwn = __webpack_require__(321);
      /**
       * The base implementation of `_.invert` and `_.invertBy` which inverts
       * `object` with values transformed by `iteratee` and set by `setter`.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform values.
       * @param {Object} accumulator The initial inverted object.
       * @returns {Function} Returns `accumulator`.
       */


      function baseInverter(object, setter, iteratee, accumulator) {
        baseForOwn(object, function (value, key, object) {
          setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
      }

      module.exports = baseInverter;
      /***/
    },
    /* 720 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseInverter = __webpack_require__(719);
      /**
       * Creates a function like `_.invertBy`.
       *
       * @private
       * @param {Function} setter The function to set accumulator values.
       * @param {Function} toIteratee The function to resolve iteratees.
       * @returns {Function} Returns the new inverter function.
       */


      function createInverter(setter, toIteratee) {
        return function (object, iteratee) {
          return baseInverter(object, setter, toIteratee(iteratee), {});
        };
      }

      module.exports = createInverter;
      /***/
    },
    /* 721 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (process) {
        // Generated by CoffeeScript 1.12.2
        (function () {
          var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

          if (typeof performance !== "undefined" && performance !== null && performance.now) {
            module.exports = function () {
              return performance.now();
            };
          } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
            module.exports = function () {
              return (getNanoSeconds() - nodeLoadTime) / 1e6;
            };

            hrtime = process.hrtime;

            getNanoSeconds = function getNanoSeconds() {
              var hr;
              hr = hrtime();
              return hr[0] * 1e9 + hr[1];
            };

            moduleLoadTime = getNanoSeconds();
            upTime = process.uptime() * 1e9;
            nodeLoadTime = moduleLoadTime - upTime;
          } else if (Date.now) {
            module.exports = function () {
              return Date.now() - loadTime;
            };

            loadTime = Date.now();
          } else {
            module.exports = function () {
              return new Date().getTime() - loadTime;
            };

            loadTime = new Date().getTime();
          }
        }).call(this);
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(162));
      /***/
    },
    /* 722 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */

      /* global window, document */

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _get = function get(_x, _x2, _x3) {
        var _again = true;

        _function: while (_again) {
          var object = _x,
              property = _x2,
              receiver = _x3;
          _again = false;
          if (object === null) object = Function.prototype;
          var desc = Object.getOwnPropertyDescriptor(object, property);

          if (desc === undefined) {
            var parent = Object.getPrototypeOf(object);

            if (parent === null) {
              return undefined;
            } else {
              _x = parent;
              _x2 = property;
              _x3 = receiver;
              _again = true;
              desc = parent = undefined;
              continue _function;
            }
          } else if ('value' in desc) {
            return desc.value;
          } else {
            var getter = desc.get;

            if (getter === undefined) {
              return undefined;
            }

            return getter.call(receiver);
          }
        }
      };

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError('Cannot call a class as a function');
        }
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== 'function' && superClass !== null) {
          throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _subscribeUiEvent = __webpack_require__(714);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _shallowequal = __webpack_require__(56);

      var _shallowequal2 = _interopRequireDefault(_shallowequal); // constants


      var STATUS_ORIGINAL = 0; // The default status, locating at the original position.

      var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.

      var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

      var TRANSFORM_PROP = 'transform'; // global variable for all instances

      var doc;
      var docBody;
      var docEl;
      var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr

      var M;
      var scrollDelta = 0;
      var win;
      var winHeight = -1;

      var Sticky = function (_Component) {
        _inherits(Sticky, _Component);

        function Sticky(props, context) {
          _classCallCheck(this, Sticky);

          _get(Object.getPrototypeOf(Sticky.prototype), 'constructor', this).call(this, props, context);

          this.handleResize = this.handleResize.bind(this);
          this.handleScroll = this.handleScroll.bind(this);
          this.handleScrollStart = this.handleScrollStart.bind(this);
          this.delta = 0;
          this.stickyTop = 0;
          this.stickyBottom = 0;
          this.frozen = false;
          this.skipNextScrollEvent = false;
          this.scrollTop = -1;
          this.bottomBoundaryTarget;
          this.topTarget;
          this.subscribers;
          this.state = {
            top: 0,
            // A top offset from viewport top where Sticky sticks to when scrolling up
            bottom: 0,
            // A bottom offset from viewport top where Sticky sticks to when scrolling down
            width: 0,
            // Sticky width
            height: 0,
            // Sticky height
            x: 0,
            // The original x of Sticky
            y: 0,
            // The original y of Sticky
            topBoundary: 0,
            // The top boundary on document
            bottomBoundary: Infinity,
            // The bottom boundary on document
            status: STATUS_ORIGINAL,
            // The Sticky status
            pos: 0,
            // Real y-axis offset for rendering position-fixed and position-relative
            activated: false // once browser info is available after mounted, it becomes true to avoid checksum error

          };
        }

        _createClass(Sticky, [{
          key: 'getTargetHeight',
          value: function getTargetHeight(target) {
            return target && target.offsetHeight || 0;
          }
        }, {
          key: 'getTopPosition',
          value: function getTopPosition(top) {
            // TODO, topTarget is for current layout, may remove
            // a top argument can be provided to override reading from the props
            top = top || this.props.top || this.props.topTarget || 0;

            if (typeof top === 'string') {
              if (!this.topTarget) {
                this.topTarget = doc.querySelector(top);
              }

              top = this.getTargetHeight(this.topTarget);
            }

            return top;
          }
        }, {
          key: 'getTargetBottom',
          value: function getTargetBottom(target) {
            if (!target) {
              return -1;
            }

            var rect = target.getBoundingClientRect();
            return this.scrollTop + rect.bottom;
          }
        }, {
          key: 'getBottomBoundary',
          value: function getBottomBoundary(bottomBoundary) {
            // a bottomBoundary can be provided to avoid reading from the props
            var boundary = bottomBoundary || this.props.bottomBoundary; // TODO, bottomBoundary was an object, depricate it later.

            if (typeof boundary === 'object') {
              boundary = boundary.value || boundary.target || 0;
            }

            if (typeof boundary === 'string') {
              if (!this.bottomBoundaryTarget) {
                this.bottomBoundaryTarget = doc.querySelector(boundary);
              }

              boundary = this.getTargetBottom(this.bottomBoundaryTarget);
            }

            return boundary && boundary > 0 ? boundary : Infinity;
          }
        }, {
          key: 'reset',
          value: function reset() {
            this.setState({
              status: STATUS_ORIGINAL,
              pos: 0
            });
          }
        }, {
          key: 'release',
          value: function release(pos) {
            this.setState({
              status: STATUS_RELEASED,
              pos: pos - this.state.y
            });
          }
        }, {
          key: 'fix',
          value: function fix(pos) {
            this.setState({
              status: STATUS_FIXED,
              pos: pos
            });
          }
          /**
           * Update the initial position, width, and height. It should update whenever children change.
           * @param {Object} options optional top and bottomBoundary new values
           */

        }, {
          key: 'updateInitialDimension',
          value: function updateInitialDimension(options) {
            options = options || {};
            var outerRect = this.outerElement.getBoundingClientRect();
            var innerRect = this.innerElement.getBoundingClientRect();
            var width = outerRect.width || outerRect.right - outerRect.left;
            var height = innerRect.height || innerRect.bottom - innerRect.top;
            ;
            var outerY = outerRect.top + this.scrollTop;
            this.setState({
              top: this.getTopPosition(options.top),
              bottom: Math.min(this.state.top + height, winHeight),
              width: width,
              height: height,
              x: outerRect.left,
              y: outerY,
              bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
              topBoundary: outerY
            });
          }
        }, {
          key: 'handleResize',
          value: function handleResize(e, ae) {
            if (this.props.shouldFreeze()) {
              return;
            }

            winHeight = ae.resize.height;
            this.updateInitialDimension();
            this.update();
          }
        }, {
          key: 'handleScrollStart',
          value: function handleScrollStart(e, ae) {
            this.frozen = this.props.shouldFreeze();

            if (this.frozen) {
              return;
            }

            if (this.scrollTop === ae.scroll.top) {
              // Scroll position hasn't changed,
              // do nothing
              this.skipNextScrollEvent = true;
            } else {
              this.scrollTop = ae.scroll.top;
              this.updateInitialDimension();
            }
          }
        }, {
          key: 'handleScroll',
          value: function handleScroll(e, ae) {
            // Scroll doesn't need to be handled
            if (this.skipNextScrollEvent) {
              this.skipNextScrollEvent = false;
              return;
            }

            scrollDelta = ae.scroll.delta;
            this.scrollTop = ae.scroll.top;
            this.update();
          }
          /**
           * Update Sticky position.
           */

        }, {
          key: 'update',
          value: function update() {
            var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

            if (disabled) {
              if (this.state.status !== STATUS_ORIGINAL) {
                this.reset();
              }

              return;
            }

            var delta = scrollDelta; // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
            // on document from viewport.

            var top = this.scrollTop + this.state.top;
            var bottom = this.scrollTop + this.state.bottom; // There are 2 principles to make sure Sticky won't get wrong so much:
            // 1. Reset Sticky to the original postion when "top" <= topBoundary
            // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary

            if (top <= this.state.topBoundary) {
              // #1
              this.reset();
            } else if (bottom >= this.state.bottomBoundary) {
              // #2
              this.stickyBottom = this.state.bottomBoundary;
              this.stickyTop = this.stickyBottom - this.state.height;
              this.release(this.stickyTop);
            } else {
              if (this.state.height > winHeight - this.state.top) {
                // In this case, Sticky is higher then viewport minus top offset
                switch (this.state.status) {
                  case STATUS_ORIGINAL:
                    this.release(this.state.y);
                    this.stickyTop = this.state.y;
                    this.stickyBottom = this.stickyTop + this.state.height;
                  // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
                  // from ORIGINAL when calling window.scrollTo().
                  // break;

                  case STATUS_RELEASED:
                    // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
                    // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
                    // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
                    this.stickyBottom = this.stickyTop + this.state.height;

                    if (delta > 0 && bottom > this.stickyBottom) {
                      this.fix(this.state.bottom - this.state.height);
                    } else if (delta < 0 && top < this.stickyTop) {
                      this.fix(this.state.top);
                    }

                    break;

                  case STATUS_FIXED:
                    var toRelease = true;
                    var pos = this.state.pos;
                    var height = this.state.height; // In regular cases, when Sticky is in FIXED status,
                    // 1. it's top will stick to the screen top,
                    // 2. it's bottom will stick to the screen bottom,
                    // 3. if not the cases above, then it's height gets changed

                    if (delta > 0 && pos === this.state.top) {
                      // case 1, and scrolling down
                      this.stickyTop = top - delta;
                      this.stickyBottom = this.stickyTop + height;
                    } else if (delta < 0 && pos === this.state.bottom - height) {
                      // case 2, and scrolling up
                      this.stickyBottom = bottom - delta;
                      this.stickyTop = this.stickyBottom - height;
                    } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                      // case 3
                      // This case only happens when Sticky's bottom sticks to the screen bottom and
                      // its height gets changed. Sticky should be in RELEASE status and update its
                      // sticky bottom by calculating how much height it changed.
                      var deltaHeight = pos + height - this.state.bottom;
                      this.stickyBottom = bottom - delta + deltaHeight;
                      this.stickyTop = this.stickyBottom - height;
                    } else {
                      toRelease = false;
                    }

                    if (toRelease) {
                      this.release(this.stickyTop);
                    }

                    break;
                }
              } else {
                // In this case, Sticky is shorter then viewport minus top offset
                // and will always fix to the top offset of viewport
                this.fix(this.state.top);
              }
            }

            this.delta = delta;
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.updateInitialDimension(nextProps);
            this.update();
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate(prevProps, prevState) {
            var _this = this;

            if (prevState.status !== this.state.status && this.props.onStateChange) {
              this.props.onStateChange({
                status: this.state.status
              });
            } // if the props for enabling are toggled, then trigger the update or reset depending on the current props


            if (prevProps.enabled !== this.props.enabled) {
              if (this.props.enabled) {
                this.setState({
                  activated: true
                }, function () {
                  _this.updateInitialDimension();

                  _this.update();
                });
              } else {
                this.setState({
                  activated: false
                }, function () {
                  _this.reset();
                });
              }
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var subscribers = this.subscribers || [];

            for (var i = subscribers.length - 1; i >= 0; i--) {
              this.subscribers[i].unsubscribe();
            }
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            // Only initialize the globals if this is the first
            // time this component type has been mounted
            if (!win) {
              win = window;
              doc = document;
              docEl = doc.documentElement;
              docBody = doc.body;
              winHeight = win.innerHeight || docEl.clientHeight;
              M = window.Modernizr; // No Sticky on lower-end browser when no Modernizr

              if (M && M.prefixed) {
                canEnableTransforms = M.csstransforms3d;
                TRANSFORM_PROP = M.prefixed('transform');
              }
            } // when mount, the scrollTop is not necessary on the top


            this.scrollTop = docBody.scrollTop + docEl.scrollTop;

            if (this.props.enabled) {
              this.setState({
                activated: true
              });
              this.updateInitialDimension();
              this.update();
            } // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality


            this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), {
              useRAF: true
            }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), {
              useRAF: true,
              enableScrollInfo: true
            }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), {
              enableResizeInfo: true
            })];
          }
        }, {
          key: 'translate',
          value: function translate(style, pos) {
            var enableTransforms = canEnableTransforms && this.props.enableTransforms;

            if (enableTransforms && this.state.activated) {
              style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
            } else {
              style.top = pos + 'px';
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps, nextState) {
            return !this.props.shouldFreeze() && !((0, _shallowequal2['default'])(this.props, nextProps) && (0, _shallowequal2['default'])(this.state, nextState));
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames,
                _this2 = this; // TODO, "overflow: auto" prevents collapse, need a good way to get children height


            var innerStyle = {
              position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
              top: this.state.status === STATUS_FIXED ? '0px' : '',
              zIndex: this.props.innerZ
            };
            var outerStyle = {}; // always use translate3d to enhance the performance

            this.translate(innerStyle, this.state.pos);

            if (this.state.status !== STATUS_ORIGINAL) {
              innerStyle.width = this.state.width + 'px';
              outerStyle.height = this.state.height + 'px';
            }

            var outerClasses = (0, _classnames2['default'])('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));
            var children = this.props.children;
            return _react2['default'].createElement('div', {
              ref: function ref(outer) {
                _this2.outerElement = outer;
              },
              className: outerClasses,
              style: outerStyle
            }, _react2['default'].createElement('div', {
              ref: function ref(inner) {
                _this2.innerElement = inner;
              },
              className: 'sticky-inner-wrapper',
              style: innerStyle
            }, typeof children === 'function' ? children({
              status: this.state.status
            }) : children));
          }
        }]);

        return Sticky;
      }(_react.Component);

      Sticky.displayName = 'Sticky';
      Sticky.defaultProps = {
        shouldFreeze: function shouldFreeze() {
          return false;
        },
        enabled: true,
        top: 0,
        bottomBoundary: 0,
        enableTransforms: true,
        activeClass: 'active',
        releasedClass: 'released',
        onStateChange: null
      };
      /**
       * @param {Bool} enabled A switch to enable or disable Sticky.
       * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
       *        whose height should serve as the top offset.
       * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
       *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
       */

      Sticky.propTypes = {
        enabled: _propTypes2['default'].bool,
        top: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
        bottomBoundary: _propTypes2['default'].oneOfType([_propTypes2['default'].object, // TODO, may remove
        _propTypes2['default'].string, _propTypes2['default'].number]),
        enableTransforms: _propTypes2['default'].bool,
        activeClass: _propTypes2['default'].string,
        releasedClass: _propTypes2['default'].string,
        onStateChange: _propTypes2['default'].func,
        shouldFreeze: _propTypes2['default'].func,
        innerZ: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
      };
      Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
      Sticky.STATUS_RELEASED = STATUS_RELEASED;
      Sticky.STATUS_FIXED = STATUS_FIXED;
      module.exports = Sticky;
      /***/
    },
    /* 723 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var string = __webpack_require__(79);

      function factory(type, config, load, typed) {
        /**
         * Format a value of any type into a string.
         *
         * Syntax:
         *
         *    math.format(value)
         *    math.format(value, options)
         *    math.format(value, precision)
         *    math.format(value, callback)
         *
         * Where:
         *
         *  - `value: *`
         *    The value to be formatted
         *  - `options: Object`
         *    An object with formatting options. Available options:
         *    - `notation: string`
         *      Number notation. Choose from:
         *      - 'fixed'
         *        Always use regular number notation.
         *        For example '123.40' and '14000000'
         *      - 'exponential'
         *        Always use exponential notation.
         *        For example '1.234e+2' and '1.4e+7'
         *      - 'engineering'
         *        Always use engineering notation.
         *        For example '123.4e+0' and '14.0e+6'
         *      - 'auto' (default)
         *        Regular number notation for numbers having an absolute value between
         *        `lower` and `upper` bounds, and uses exponential notation elsewhere.
         *        Lower bound is included, upper bound is excluded.
         *        For example '123.4' and '1.4e7'.
         *    - `precision: number`
         *      A number between 0 and 16 to round the digits of the number. In case
         *      of notations 'exponential', 'engineering', and 'auto', `precision`
         *      defines the total number of significant digits returned.
         *      In case of notation 'fixed', `precision` defines the number of
         *      significant digits after the decimal point.
         *      `precision` is undefined by default.
         *    - `lowerExp: number`
         *      Exponent determining the lower boundary for formatting a value with
         *      an exponent when `notation='auto`. Default value is `-3`.
         *    - `upperExp: number`
         *      Exponent determining the upper boundary for formatting a value with
         *      an exponent when `notation='auto`. Default value is `5`.
         *    - `fraction: string`. Available values: 'ratio' (default) or 'decimal'.
         *      For example `format(fraction(1, 3))` will output '1/3' when 'ratio' is
         *      configured, and will output `0.(3)` when 'decimal' is configured.
         * - `callback: function`
         *   A custom formatting function, invoked for all numeric elements in `value`,
         *   for example all elements of a matrix, or the real and imaginary
         *   parts of a complex number. This callback can be used to override the
         *   built-in numeric notation with any type of formatting. Function `callback`
         *   is called with `value` as parameter and must return a string.
         *
         * When `value` is an Object:
         *
         * - When the object contains a property `format` being a function, this function
         *   is invoked as `value.format(options)` and the result is returned.
         * - When the object has its own `toString` method, this method is invoked
         *   and the result is returned.
         * - In other cases the function will loop over all object properties and
         *   return JSON object notation like '{"a": 2, "b": 3}'.
         *
         * When value is a function:
         *
         * - When the function has a property `syntax`, it returns this
         *   syntax description.
         * - In other cases, a string `'function'` is returned.
         *
         * Examples:
         *
         *    math.format(6.4)                                        // returns '6.4'
         *    math.format(1240000)                                    // returns '1.24e6'
         *    math.format(1/3)                                        // returns '0.3333333333333333'
         *    math.format(1/3, 3)                                     // returns '0.333'
         *    math.format(21385, 2)                                   // returns '21000'
         *    math.format(12e8, {notation: 'fixed'})                  // returns '1200000000'
         *    math.format(2.3,  {notation: 'fixed', precision: 4})    // returns '2.3000'
         *    math.format(52.8, {notation: 'exponential'})            // returns '5.28e+1'
         *    math.format(12400,{notation: 'engineering'})            // returns '12.400e+3'
         *    math.format(2000, {lowerExp: -2, upperExp: 2})          // returns '2e+3'
         *
         *    function formatCurrency(value) {
         *      // return currency notation with two digits:
         *      return '$' + value.toFixed(2)
         *
         *      // you could also use math.format inside the callback:
         *      // return '$' + math.format(value, {notation: 'fixed', precision: 2})
         *    }
         *    math.format([2.1, 3, 0.016], formatCurrency}            // returns '[$2.10, $3.00, $0.02]'
         *
         * See also:
         *
         *    print
         *
         * @param {*} value                               Value to be stringified
         * @param {Object | Function | number} [options]  Formatting options
         * @return {string} The formatted value
         */
        var format = typed('format', {
          'any': string.format,
          'any, Object | function | number': string.format
        });
        format.toTex = undefined; // use default template

        return format;
      }

      exports.name = 'format';
      exports.factory = factory;
      /***/
    },
    /* 724 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var getArrayDataType = load(__webpack_require__(228));
        /**
         * Find the data type of all elements in a matrix or array,
         * for example 'number' if all items are a number and 'Complex' if all values
         * are complex numbers.
         * If a matrix contains more than one data type, it will return 'mixed'.
         *
         * Syntax:
         *
         *    math.getMatrixDataType(x)
         *
         * Examples:
         *
         *    const x = [ [1, 2, 3], [4, 5, 6] ]
         *    const mixedX = [ [1, true], [2, 3] ]
         *    const fractionX = [ [math.fraction(1, 3)], [math.fraction(1, 3] ]
         *    const unitX = [ [math.unit('5cm')], [math.unit('5cm')] ]
         *    const bigNumberX = [ [math.bignumber(1)], [math.bignumber(0)] ]
         *    const sparse = math.sparse(x)
         *    const dense = math.matrix(x)
         *    math.getMatrixDataType(x)   // returns 'number'
         *    math.getMatrixDataType(sparse)   // returns 'number'
         *    math.getMatrixDataType(dense)   // returns 'number'
         *    math.getMatrixDataType(mixedX) // returns 'mixed'
         *    math.getMatrixDataType(fractionX) // returns 'Fraction'
         *    math.getMatrixDataType(unitX) // returns 'Unit'
         *    math.getMatrixDataType(bigNumberX) // return 'BigNumber'
         *
         * See also:
         *  SparseMatrix, DenseMatrix
         *
         * @param {...Matrix | Array} x   The Matrix with values.
         *
         * @return {string} A string representation of the matrix type
         */

        var getMatrixDataType = typed('getMatrixDataType', {
          'Array': function Array(x) {
            return getArrayDataType(x);
          },
          'Matrix': function Matrix(x) {
            return x.getDataType();
          }
        });
        return getMatrixDataType;
      }

      exports.name = 'getMatrixDataType';
      exports.factory = factory;
      /***/
    },
    /* 725 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var clone = __webpack_require__(59).clone;

      var format = __webpack_require__(79).format;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var add = load(__webpack_require__(170));
        /**
         * Calculate the trace of a matrix: the sum of the elements on the main
         * diagonal of a square matrix.
         *
         * Syntax:
         *
         *    math.trace(x)
         *
         * Examples:
         *
         *    math.trace([[1, 2], [3, 4]]) // returns 5
         *
         *    const A = [
         *      [1, 2, 3],
         *      [-1, 2, 3],
         *      [2, 0, 3]
         *    ]
         *    math.trace(A) // returns 6
         *
         * See also:
         *
         *    diag
         *
         * @param {Array | Matrix} x  A matrix
         *
         * @return {number} The trace of `x`
         */

        var trace = typed('trace', {
          'Array': function _arrayTrace(x) {
            // use dense matrix implementation
            return _denseTrace(matrix(x));
          },
          'SparseMatrix': _sparseTrace,
          'DenseMatrix': _denseTrace,
          'any': clone
        });

        function _denseTrace(m) {
          // matrix size & data
          var size = m._size;
          var data = m._data; // process dimensions

          switch (size.length) {
            case 1:
              // vector
              if (size[0] === 1) {
                // return data[0]
                return clone(data[0]);
              }

              throw new RangeError('Matrix must be square (size: ' + format(size) + ')');

            case 2:
              // two dimensional
              var rows = size[0];
              var cols = size[1];

              if (rows === cols) {
                // calulate sum
                var sum = 0; // loop diagonal

                for (var i = 0; i < rows; i++) {
                  sum = add(sum, data[i][i]);
                } // return trace


                return sum;
              }

              throw new RangeError('Matrix must be square (size: ' + format(size) + ')');

            default:
              // multi dimensional
              throw new RangeError('Matrix must be two dimensional (size: ' + format(size) + ')');
          }
        }

        function _sparseTrace(m) {
          // matrix arrays
          var values = m._values;
          var index = m._index;
          var ptr = m._ptr;
          var size = m._size; // check dimensions

          var rows = size[0];
          var columns = size[1]; // matrix must be square

          if (rows === columns) {
            // calulate sum
            var sum = 0; // check we have data (avoid looping columns)

            if (values.length > 0) {
              // loop columns
              for (var j = 0; j < columns; j++) {
                // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
                var k0 = ptr[j];
                var k1 = ptr[j + 1]; // loop k within [k0, k1[

                for (var k = k0; k < k1; k++) {
                  // row index
                  var i = index[k]; // check row

                  if (i === j) {
                    // accumulate value
                    sum = add(sum, values[k]); // exit loop

                    break;
                  }

                  if (i > j) {
                    // exit loop, no value on the diagonal for column j
                    break;
                  }
                }
              }
            } // return trace


            return sum;
          }

          throw new RangeError('Matrix must be square (size: ' + format(size) + ')');
        }

        trace.toTex = {
          1: "\\mathrm{tr}\\left(${args[0]}\\right)"
        };
        return trace;
      }

      exports.name = 'trace';
      exports.factory = factory;
      /***/
    },
    /* 726 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var object = __webpack_require__(59);

      var array = __webpack_require__(48);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        /**
         * Squeeze a matrix, remove inner and outer singleton dimensions from a matrix.
         *
         * Syntax:
         *
         *     math.squeeze(x)
         *
         * Examples:
         *
         *     math.squeeze([3])           // returns 3
         *     math.squeeze([[3]])         // returns 3
         *
         *     const A = math.zeros(3, 1)    // returns [[0], [0], [0]] (size 3x1)
         *     math.squeeze(A)             // returns [0, 0, 0] (size 3)
         *
         *     const B = math.zeros(1, 3)    // returns [[0, 0, 0]] (size 1x3)
         *     math.squeeze(B)             // returns [0, 0, 0] (size 3)
         *
         *     // only inner and outer dimensions are removed
         *     const C = math.zeros(2, 1, 3) // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
         *     math.squeeze(C)             // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
         *
         * See also:
         *
         *     subset
         *
         * @param {Matrix | Array} x      Matrix to be squeezed
         * @return {Matrix | Array} Squeezed matrix
         */

        var squeeze = typed('squeeze', {
          'Array': function Array(x) {
            return array.squeeze(object.clone(x));
          },
          'Matrix': function Matrix(x) {
            var res = array.squeeze(x.toArray()); // FIXME: return the same type of matrix as the input

            return Array.isArray(res) ? matrix(res) : res;
          },
          'any': function any(x) {
            // scalar
            return object.clone(x);
          }
        });
        squeeze.toTex = undefined; // use default template

        return squeeze;
      }

      exports.name = 'squeeze';
      exports.factory = factory;
      /***/
    },
    /* 727 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var array = __webpack_require__(48);

      var latex = __webpack_require__(72);

      var string = __webpack_require__(79);

      function factory(type, config, load, typed) {
        var abs = load(__webpack_require__(194));
        var add = load(__webpack_require__(170));
        var multiply = load(__webpack_require__(124));
        var sqrt = load(__webpack_require__(400));
        var subtract = load(__webpack_require__(196));
        var inv = load(__webpack_require__(233));
        var size = load(__webpack_require__(392));
        var max = load(__webpack_require__(399));
        var identity = load(__webpack_require__(193));
        /**
         * Calculate the principal square root of a square matrix.
         * The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.
         *
         * https://en.wikipedia.org/wiki/Square_root_of_a_matrix
         *
         * Syntax:
         *
         *     X = math.sqrtm(A)
         *
         * Examples:
         *
         *     math.sqrtm([[1, 2], [3, 4]]) // returns [[-2, 1], [1.5, -0.5]]
         *
         * See also:
         *
         *     sqrt, pow
         *
         * @param  {Array | Matrix} A   The square matrix `A`
         * @return {Array | Matrix}     The principal square root of matrix `A`
         */

        var sqrtm = typed('sqrtm', {
          'Array | Matrix': function ArrayMatrix(A) {
            var size = type.isMatrix(A) ? A.size() : array.size(A);

            switch (size.length) {
              case 1:
                // Single element Array | Matrix
                if (size[0] === 1) {
                  return sqrt(A);
                } else {
                  throw new RangeError('Matrix must be square ' + '(size: ' + string.format(size) + ')');
                }

              case 2:
                // Two-dimensional Array | Matrix
                var rows = size[0];
                var cols = size[1];

                if (rows === cols) {
                  return _denmanBeavers(A);
                } else {
                  throw new RangeError('Matrix must be square ' + '(size: ' + string.format(size) + ')');
                }

            }
          }
        });
        var _maxIterations = 1e3;
        var _tolerance = 1e-6;
        /**
         * Calculate the principal square root matrix using the Denman–Beavers iterative method
         *
         * https://en.wikipedia.org/wiki/Square_root_of_a_matrix#By_Denman–Beavers_iteration
         *
         * @param  {Array | Matrix} A   The square matrix `A`
         * @return {Array | Matrix}     The principal square root of matrix `A`
         * @private
         */

        function _denmanBeavers(A) {
          var error;
          var iterations = 0;
          var Y = A;
          var Z = identity(size(A));

          do {
            var Yk = Y;
            Y = multiply(0.5, add(Yk, inv(Z)));
            Z = multiply(0.5, add(Z, inv(Yk)));
            error = max(abs(subtract(Y, Yk)));

            if (error > _tolerance && ++iterations > _maxIterations) {
              throw new Error('computing square root of matrix: iterative method could not converge');
            }
          } while (error > _tolerance);

          return Y;
        }

        sqrtm.toTex = {
          1: "{${args[0]}}".concat(latex.operators['pow'], "{\\frac{1}{2}}")
        };
        return sqrtm;
      }

      exports.name = 'sqrtm';
      exports.factory = factory;
      /***/
    },
    /* 728 */

    /***/
    function (module, exports) {
      /*
       * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
       * Author: Jim Palmer (based on chunking idea from Dave Koelle)
       */

      /*jshint unused:false */
      module.exports = function naturalSort(a, b) {
        "use strict";

        var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,
            sre = /(^[ ]*|[ ]*$)/g,
            dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
            hre = /^0x[0-9a-f]+$/i,
            ore = /^0/,
            i = function i(s) {
          return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s;
        },
            // convert all to strings strip whitespace
        x = i(a).replace(sre, '') || '',
            y = i(b).replace(sre, '') || '',
            // chunk/tokenize
        xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
            yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
            // numeric, hex or date detection
        xD = parseInt(x.match(hre), 16) || xN.length !== 1 && x.match(dre) && Date.parse(x),
            yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null,
            oFxNcL,
            oFyNcL; // first try and sort Hex codes or Dates


        if (yD) {
          if (xD < yD) {
            return -1;
          } else if (xD > yD) {
            return 1;
          }
        } // natural sorting through split numeric strings and default strings


        for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
          // find floats not starting with '0', string or 0 if not defined (Clint Priest)
          oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
          oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0; // handle numeric vs string comparison - number < string - (Kyle Adams)

          if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
            return isNaN(oFxNcL) ? 1 : -1;
          } // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
          else if (typeof oFxNcL !== typeof oFyNcL) {
              oFxNcL += '';
              oFyNcL += '';
            }

          if (oFxNcL < oFyNcL) {
            return -1;
          }

          if (oFxNcL > oFyNcL) {
            return 1;
          }
        }

        return 0;
      };
      /***/

    },
    /* 729 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var naturalSort = __webpack_require__(728);

      function factory(type, config, load, typed) {
        var getTypeOf = load(__webpack_require__(131));
        var compare = load(__webpack_require__(297));
        var compareBooleans = compare.signatures['boolean,boolean'];
        /**
         * Compare two values of any type in a deterministic, natural way.
         *
         * For numeric values, the function works the same as `math.compare`.
         * For types of values that can't be compared mathematically,
         * the function compares in a natural way.
         *
         * For numeric values, x and y are considered equal when the relative
         * difference between x and y is smaller than the configured epsilon.
         * The function cannot be used to compare values smaller than
         * approximately 2.22e-16.
         *
         * For Complex numbers, first the real parts are compared. If equal,
         * the imaginary parts are compared.
         *
         * Strings are compared with a natural sorting algorithm, which
         * orders strings in a "logic" way following some heuristics.
         * This differs from the function `compare`, which converts the string
         * into a numeric value and compares that. The function `compareText`
         * on the other hand compares text lexically.
         *
         * Arrays and Matrices are compared value by value until there is an
         * unequal pair of values encountered. Objects are compared by sorted
         * keys until the keys or their values are unequal.
         *
         * Syntax:
         *
         *    math.compareNatural(x, y)
         *
         * Examples:
         *
         *    math.compareNatural(6, 1)              // returns 1
         *    math.compareNatural(2, 3)              // returns -1
         *    math.compareNatural(7, 7)              // returns 0
         *
         *    math.compareNatural('10', '2')         // returns 1
         *    math.compareText('10', '2')            // returns -1
         *    math.compare('10', '2')                // returns 1
         *
         *    math.compareNatural('Answer: 10', 'Answer: 2') // returns 1
         *    math.compareText('Answer: 10', 'Answer: 2')    // returns -1
         *    math.compare('Answer: 10', 'Answer: 2')
         *        // Error: Cannot convert "Answer: 10" to a number
         *
         *    const a = math.unit('5 cm')
         *    const b = math.unit('40 mm')
         *    math.compareNatural(a, b)              // returns 1
         *
         *    const c = math.complex('2 + 3i')
         *    const d = math.complex('2 + 4i')
         *    math.compareNatural(c, d)              // returns -1
         *
         *    math.compareNatural([1, 2, 4], [1, 2, 3]) // returns 1
         *    math.compareNatural([1, 2, 3], [1, 2])    // returns 1
         *    math.compareNatural([1, 5], [1, 2, 3])    // returns 1
         *    math.compareNatural([1, 2], [1, 2])       // returns 0
         *
         *    math.compareNatural({a: 2}, {a: 4})       // returns -1
         *
         * See also:
         *
         *    compare, compareText
         *
         * @param  {*} x First value to compare
         * @param  {*} y Second value to compare
         * @return {number} Returns the result of the comparison:
         *                  1 when x > y, -1 when x < y, and 0 when x == y.
         */

        var compareNatural = typed('compareNatural', {
          'any, any': function anyAny(x, y) {
            var typeX = getTypeOf(x);
            var typeY = getTypeOf(y);
            var c; // numeric types

            if ((typeX === 'number' || typeX === 'BigNumber' || typeX === 'Fraction') && (typeY === 'number' || typeY === 'BigNumber' || typeY === 'Fraction')) {
              c = compare(x, y);

              if (c.toString() !== '0') {
                // c can be number, BigNumber, or Fraction
                return c > 0 ? 1 : -1; // return a number
              } else {
                return naturalSort(typeX, typeY);
              }
            } // matrix types


            if (typeX === 'Array' || typeX === 'Matrix' || typeY === 'Array' || typeY === 'Matrix') {
              c = compareMatricesAndArrays(x, y);

              if (c !== 0) {
                return c;
              } else {
                return naturalSort(typeX, typeY);
              }
            } // in case of different types, order by name of type, i.e. 'BigNumber' < 'Complex'


            if (typeX !== typeY) {
              return naturalSort(typeX, typeY);
            }

            if (typeX === 'Complex') {
              return compareComplexNumbers(x, y);
            }

            if (typeX === 'Unit') {
              if (x.equalBase(y)) {
                return compareNatural(x.value, y.value);
              } // compare by units


              return compareArrays(x.formatUnits(), y.formatUnits());
            }

            if (typeX === 'boolean') {
              return compareBooleans(x, y);
            }

            if (typeX === 'string') {
              return naturalSort(x, y);
            }

            if (typeX === 'Object') {
              return compareObjects(x, y);
            }

            if (typeX === 'null') {
              return 0;
            }

            if (typeX === 'undefined') {
              return 0;
            } // this should not occur...


            throw new TypeError('Unsupported type of value "' + typeX + '"');
          }
        });
        compareNatural.toTex = undefined; // use default template

        /**
         * Compare mixed matrix/array types, by converting to same-shaped array.
         * This comparator is non-deterministic regarding input types.
         * @param {Array | SparseMatrix | DenseMatrix | *} x
         * @param {Array | SparseMatrix | DenseMatrix | *} y
         * @returns {number} Returns the comparison result: -1, 0, or 1
         */

        function compareMatricesAndArrays(x, y) {
          if (type.isSparseMatrix(x) && type.isSparseMatrix(y)) {
            return compareArrays(x.toJSON().values, y.toJSON().values);
          }

          if (type.isSparseMatrix(x)) {
            // note: convert to array is expensive
            return compareMatricesAndArrays(x.toArray(), y);
          }

          if (type.isSparseMatrix(y)) {
            // note: convert to array is expensive
            return compareMatricesAndArrays(x, y.toArray());
          } // convert DenseArray into Array


          if (type.isDenseMatrix(x)) {
            return compareMatricesAndArrays(x.toJSON().data, y);
          }

          if (type.isDenseMatrix(y)) {
            return compareMatricesAndArrays(x, y.toJSON().data);
          } // convert scalars to array


          if (!Array.isArray(x)) {
            return compareMatricesAndArrays([x], y);
          }

          if (!Array.isArray(y)) {
            return compareMatricesAndArrays(x, [y]);
          }

          return compareArrays(x, y);
        }
        /**
         * Compare two Arrays
         *
         * - First, compares value by value
         * - Next, if all corresponding values are equal,
         *   look at the length: longest array will be considered largest
         *
         * @param {Array} x
         * @param {Array} y
         * @returns {number} Returns the comparison result: -1, 0, or 1
         */


        function compareArrays(x, y) {
          // compare each value
          for (var i = 0, ii = Math.min(x.length, y.length); i < ii; i++) {
            var v = compareNatural(x[i], y[i]);

            if (v !== 0) {
              return v;
            }
          } // compare the size of the arrays


          if (x.length > y.length) {
            return 1;
          }

          if (x.length < y.length) {
            return -1;
          } // both Arrays have equal size and content


          return 0;
        }
        /**
         * Compare two objects
         *
         * - First, compare sorted property names
         * - Next, compare the property values
         *
         * @param {Object} x
         * @param {Object} y
         * @returns {number} Returns the comparison result: -1, 0, or 1
         */


        function compareObjects(x, y) {
          var keysX = Object.keys(x);
          var keysY = Object.keys(y); // compare keys

          keysX.sort(naturalSort);
          keysY.sort(naturalSort);
          var c = compareArrays(keysX, keysY);

          if (c !== 0) {
            return c;
          } // compare values


          for (var i = 0; i < keysX.length; i++) {
            var v = compareNatural(x[keysX[i]], y[keysY[i]]);

            if (v !== 0) {
              return v;
            }
          }

          return 0;
        }

        return compareNatural;
      }
      /**
       * Compare two complex numbers, `x` and `y`:
       *
       * - First, compare the real values of `x` and `y`
       * - If equal, compare the imaginary values of `x` and `y`
       *
       * @params {Complex} x
       * @params {Complex} y
       * @returns {number} Returns the comparison result: -1, 0, or 1
       */


      function compareComplexNumbers(x, y) {
        if (x.re > y.re) {
          return 1;
        }

        if (x.re < y.re) {
          return -1;
        }

        if (x.im > y.im) {
          return 1;
        }

        if (x.im < y.im) {
          return -1;
        }

        return 0;
      }

      exports.name = 'compareNatural';
      exports.factory = factory;
      /***/
    },
    /* 730 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var size = __webpack_require__(48).size;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var compareAsc = load(__webpack_require__(297));

        var compareDesc = function compareDesc(a, b) {
          return -compareAsc(a, b);
        };

        var compareNatural = load(__webpack_require__(729));
        /**
         * Sort the items in a matrix.
         *
         * Syntax:
         *
         *    math.sort(x)
         *    math.sort(x, compare)
         *
         * Examples:
         *
         *    math.sort([5, 10, 1]) // returns [1, 5, 10]
         *    math.sort(['C', 'B', 'A', 'D'], math.compareNatural)
         *    // returns ['A', 'B', 'C', 'D']
         *
         *    function sortByLength (a, b) {
         *      return a.length - b.length
         *    }
         *    math.sort(['Langdon', 'Tom', 'Sara'], sortByLength)
         *    // returns ['Tom', 'Sara', 'Langdon']
         *
         * See also:
         *
         *    filter, forEach, map, compare, compareNatural
         *
         * @param {Matrix | Array} x    A one dimensional matrix or array to sort
         * @param {Function | 'asc' | 'desc' | 'natural'} [compare='asc']
         *        An optional _comparator function or name. The function is called as
         *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
         *        and 0 when a == b.
         * @return {Matrix | Array} Returns the sorted matrix.
         */

        var sort = typed('sort', {
          'Array': function Array(x) {
            _arrayIsVector(x);

            return x.sort(compareAsc);
          },
          'Matrix': function Matrix(x) {
            _matrixIsVector(x);

            return matrix(x.toArray().sort(compareAsc), x.storage());
          },
          'Array, function': function ArrayFunction(x, _comparator) {
            _arrayIsVector(x);

            return x.sort(_comparator);
          },
          'Matrix, function': function MatrixFunction(x, _comparator) {
            _matrixIsVector(x);

            return matrix(x.toArray().sort(_comparator), x.storage());
          },
          'Array, string': function ArrayString(x, order) {
            _arrayIsVector(x);

            return x.sort(_comparator(order));
          },
          'Matrix, string': function MatrixString(x, order) {
            _matrixIsVector(x);

            return matrix(x.toArray().sort(_comparator(order)), x.storage());
          }
        });
        sort.toTex = undefined; // use default template

        /**
         * Get the comparator for given order ('asc', 'desc', 'natural')
         * @param {'asc' | 'desc' | 'natural'} order
         * @return {Function} Returns a _comparator function
         */

        function _comparator(order) {
          if (order === 'asc') {
            return compareAsc;
          } else if (order === 'desc') {
            return compareDesc;
          } else if (order === 'natural') {
            return compareNatural;
          } else {
            throw new Error('String "asc", "desc", or "natural" expected');
          }
        }
        /**
         * Validate whether an array is one dimensional
         * Throws an error when this is not the case
         * @param {Array} array
         * @private
         */


        function _arrayIsVector(array) {
          if (size(array).length !== 1) {
            throw new Error('One dimensional array expected');
          }
        }
        /**
         * Validate whether a matrix is one dimensional
         * Throws an error when this is not the case
         * @param {Matrix} matrix
         * @private
         */


        function _matrixIsVector(matrix) {
          if (matrix.size().length !== 1) {
            throw new Error('One dimensional matrix expected');
          }
        }

        return sort;
      }

      exports.name = 'sort';
      exports.factory = factory;
      /***/
    },
    /* 731 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var clone = __webpack_require__(59).clone;

      var validateIndex = __webpack_require__(48).validateIndex;

      function factory(type, config, load, typed) {
        var MatrixIndex = load(__webpack_require__(300));
        var matrix = load(__webpack_require__(46));
        var range = load(__webpack_require__(298));
        /**
         * Return a row from a Matrix.
         *
         * Syntax:
         *
         *     math.row(value, index)
         *
         * Example:
         *
         *     // get a row
         *     const d = [[1, 2], [3, 4]]
         *     math.row(d, 1) // returns [3, 4]
         *
         * See also:
         *
         *     column
         *
         * @param {Array | Matrix } value   An array or matrix
         * @param {number} row              The index of the row
         * @return {Array | Matrix}         The retrieved row
         */

        var row = typed('row', {
          'Matrix, number': _row,
          'Array, number': function ArrayNumber(value, row) {
            return _row(matrix(clone(value)), row).valueOf();
          }
        });
        row.toTex = undefined; // use default template

        return row;
        /**
         * Retrieve a row of a matrix
         * @param {Matrix } value  A matrix
         * @param {number} row     The index of the row
         * @return {Matrix}        The retrieved row
         */

        function _row(value, row) {
          // check dimensions
          if (value.size().length !== 2) {
            throw new Error('Only two dimensional matrix is supported');
          }

          validateIndex(row, value.size()[0]);
          var columnRange = range(0, value.size()[1]);
          var index = new MatrixIndex(row, columnRange);
          return value.subset(index);
        }
      }

      exports.name = 'row';
      exports.factory = factory;
      /***/
    },
    /* 732 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var DimensionError = __webpack_require__(92);

      var ArgumentsError = __webpack_require__(307);

      var isInteger = __webpack_require__(67).isInteger;

      var format = __webpack_require__(79).format;

      var clone = __webpack_require__(59).clone;

      var array = __webpack_require__(48);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        /**
         * Resize a matrix
         *
         * Syntax:
         *
         *     math.resize(x, size)
         *     math.resize(x, size, defaultValue)
         *
         * Examples:
         *
         *     math.resize([1, 2, 3, 4, 5], [3]) // returns Array  [1, 2, 3]
         *     math.resize([1, 2, 3], [5], 0)    // returns Array  [1, 2, 3, 0, 0]
         *     math.resize(2, [2, 3], 0)         // returns Matrix [[2, 0, 0], [0, 0, 0]]
         *     math.resize("hello", [8], "!")    // returns string 'hello!!!'
         *
         * See also:
         *
         *     size, squeeze, subset, reshape
         *
         * @param {Array | Matrix | *} x             Matrix to be resized
         * @param {Array | Matrix} size              One dimensional array with numbers
         * @param {number | string} [defaultValue=0] Zero by default, except in
         *                                           case of a string, in that case
         *                                           defaultValue = ' '
         * @return {* | Array | Matrix} A resized clone of matrix `x`
         */
        // TODO: rework resize to a typed-function

        var resize = function resize(x, size, defaultValue) {
          if (arguments.length !== 2 && arguments.length !== 3) {
            throw new ArgumentsError('resize', arguments.length, 2, 3);
          }

          if (type.isMatrix(size)) {
            size = size.valueOf(); // get Array
          }

          if (type.isBigNumber(size[0])) {
            // convert bignumbers to numbers
            size = size.map(function (value) {
              return type.isBigNumber(value) ? value.toNumber() : value;
            });
          } // check x is a Matrix


          if (type.isMatrix(x)) {
            // use optimized matrix implementation, return copy
            return x.resize(size, defaultValue, true);
          }

          if (typeof x === 'string') {
            // resize string
            return _resizeString(x, size, defaultValue);
          } // check result should be a matrix


          var asMatrix = Array.isArray(x) ? false : config.matrix !== 'Array';

          if (size.length === 0) {
            // output a scalar
            while (Array.isArray(x)) {
              x = x[0];
            }

            return clone(x);
          } else {
            // output an array/matrix
            if (!Array.isArray(x)) {
              x = [x];
            }

            x = clone(x);
            var res = array.resize(x, size, defaultValue);
            return asMatrix ? matrix(res) : res;
          }
        };

        resize.toTex = undefined; // use default template

        return resize;
        /**
         * Resize a string
         * @param {string} str
         * @param {number[]} size
         * @param {string} [defaultChar=' ']
         * @private
         */

        function _resizeString(str, size, defaultChar) {
          if (defaultChar !== undefined) {
            if (typeof defaultChar !== 'string' || defaultChar.length !== 1) {
              throw new TypeError('Single character expected as defaultValue');
            }
          } else {
            defaultChar = ' ';
          }

          if (size.length !== 1) {
            throw new DimensionError(size.length, 1);
          }

          var len = size[0];

          if (typeof len !== 'number' || !isInteger(len)) {
            throw new TypeError('Invalid size, must contain positive integers ' + '(size: ' + format(size) + ')');
          }

          if (str.length > len) {
            return str.substring(0, len);
          } else if (str.length < len) {
            var res = str;

            for (var i = 0, ii = len - str.length; i < ii; i++) {
              res += defaultChar;
            }

            return res;
          } else {
            return str;
          }
        }
      }

      exports.name = 'resize';
      exports.factory = factory;
      /***/
    },
    /* 733 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var array = __webpack_require__(48);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var isInteger = load(__webpack_require__(299));
        /**
         * Reshape a multi dimensional array to fit the specified dimensions
         *
         * Syntax:
         *
         *     math.reshape(x, sizes)
         *
         * Examples:
         *
         *     math.reshape([1, 2, 3, 4, 5, 6], [2, 3])
         *     // returns Array  [[1, 2, 3], [4, 5, 6]]
         *
         *     math.reshape([[1, 2], [3, 4]], [1, 4])
         *     // returns Array  [[1, 2, 3, 4]]
         *
         *     math.reshape([[1, 2], [3, 4]], [4])
         *     // returns Array [1, 2, 3, 4]
         *
         *     const x = math.matrix([1, 2, 3, 4, 5, 6, 7, 8])
         *     math.reshape(x, [2, 2, 2])
         *     // returns Matrix [[[1, 2], [3, 4]], [[5, 6], [7, 8]]]
         *
         * See also:
         *
         *     size, squeeze, resize
         *
         * @param {Array | Matrix | *} x  Matrix to be reshaped
         * @param {number[]} sizes        One dimensional array with integral sizes for
         *                                each dimension
         *
         * @return {* | Array | Matrix}   A reshaped clone of matrix `x`
         *
         * @throws {TypeError}            If `sizes` does not contain solely integers
         * @throws {DimensionError}       If the product of the new dimension sizes does
         *                                not equal that of the old ones
         */

        var reshape = typed('reshape', {
          'Matrix, Array': function MatrixArray(x, sizes) {
            if (x.reshape) {
              return x.reshape(sizes);
            } else {
              return matrix(array.reshape(x.valueOf(), sizes));
            }
          },
          'Array, Array': function ArrayArray(x, sizes) {
            sizes.forEach(function (size) {
              if (!isInteger(size)) {
                throw new TypeError('Invalid size for dimension: ' + size);
              }
            });
            return array.reshape(x, sizes);
          }
        });
        reshape.toTex = undefined; // use default template

        return reshape;
      }

      exports.name = 'reshape';
      exports.factory = factory;
      /***/
    },
    /* 734 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        /**
         * Test whether a value is NaN (not a number).
         * The function supports types `number`, `BigNumber`, `Fraction`, `Unit` and `Complex`.
         *
         * The function is evaluated element-wise in case of Array or Matrix input.
         *
         * Syntax:
         *
         *     math.isNaN(x)
         *
         * Examples:
         *
         *    math.isNaN(3)                     // returns false
         *    math.isNaN(NaN)                   // returns true
         *    math.isNaN(0)                     // returns false
         *    math.isNaN(math.bignumber(NaN))   // returns true
         *    math.isNaN(math.bignumber(0))     // returns false
         *    math.isNaN(math.fraction(-2, 5))  // returns false
         *    math.isNaN('-2')                  // returns false
         *    math.isNaN([2, 0, -3, NaN]')      // returns [false, false, false, true]
         *
         * See also:
         *
         *    isNumeric, isNegative, isPositive, isZero, isInteger
         *
         * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
         * @return {boolean}  Returns true when `x` is NaN.
         *                    Throws an error in case of an unknown data type.
         */
        var isNaN = typed('isNaN', {
          'number': function number(x) {
            return Number.isNaN(x);
          },
          'BigNumber': function BigNumber(x) {
            return x.isNaN();
          },
          'Fraction': function Fraction(x) {
            return false;
          },
          'Complex': function Complex(x) {
            return x.isNaN();
          },
          'Unit': function Unit(x) {
            return Number.isNaN(x.value);
          },
          'Array | Matrix': function ArrayMatrix(x) {
            return deepMap(x, Number.isNaN);
          }
        });
        return isNaN;
      }

      exports.name = 'isNaN';
      exports.factory = factory;
      /***/
    },
    /* 735 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        /**
         * Test whether a value is an numeric value.
         *
         * The function is evaluated element-wise in case of Array or Matrix input.
         *
         * Syntax:
         *
         *     math.isNumeric(x)
         *
         * Examples:
         *
         *    math.isNumeric(2)                     // returns true
         *    math.isNumeric('2')                   // returns true
         *    math.hasNumericValue('2')             // returns true
         *    math.isNumeric(0)                     // returns true
         *    math.isNumeric(math.bignumber(500))   // returns true
         *    math.isNumeric(math.fraction(4))      // returns true
         *    math.isNumeric(math.complex('2-4i')   // returns false
         *    math.isNumeric([2.3, 'foo', false])   // returns [true, false, true]
         *
         * See also:
         *
         *    isZero, isPositive, isNegative, isInteger, hasNumericValue
         *
         * @param {*} x       Value to be tested
         * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
         *                    `Fraction`, or `boolean`. Returns false for other types.
         *                    Throws an error in case of unknown types.
         */
        var isNumeric = typed('isNumeric', {
          'number | BigNumber | Fraction | boolean': function numberBigNumberFractionBoolean() {
            return true;
          },
          'Complex | Unit | string | null | undefined | Node': function ComplexUnitStringNullUndefinedNode() {
            return false;
          },
          'Array | Matrix': function ArrayMatrix(x) {
            return deepMap(x, isNumeric);
          }
        });
        return isNumeric;
      }

      exports.name = 'isNumeric';
      exports.factory = factory;
      /***/
    },
    /* 736 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var isInteger = __webpack_require__(67).isInteger;

      function factory(type, config, load, typed) {
        var isNumeric = load(__webpack_require__(735));
        var isNaN = load(__webpack_require__(734));
        var asc = load(__webpack_require__(297));

        function desc(a, b) {
          return -asc(a, b);
        }
        /**
         * Partition-based selection of an array or 1D matrix.
         * Will find the kth smallest value, and mutates the input array.
         * Uses Quickselect.
         *
         * Syntax:
         *
         *    math.partitionSelect(x, k)
         *    math.partitionSelect(x, k, compare)
         *
         * Examples:
         *
         *    math.partitionSelect([5, 10, 1], 2)           // returns 10
         *    math.partitionSelect(['C', 'B', 'A', 'D'], 1) // returns 'B'
         *
         *    function sortByLength (a, b) {
         *      return a.length - b.length
         *    }
         *    math.partitionSelect(['Langdon', 'Tom', 'Sara'], 2, sortByLength) // returns 'Langdon'
         *
         * See also:
         *
         *    sort
         *
         * @param {Matrix | Array} x    A one dimensional matrix or array to sort
         * @param {Number} k            The kth smallest value to be retrieved zero-based index
         * @param {Function | 'asc' | 'desc'} [compare='asc']
         *        An optional comparator function. The function is called as
         *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
         *        and 0 when a == b.
         * @return {*} Returns the kth lowest value.
         */


        return typed('partitionSelect', {
          'Array | Matrix, number': function ArrayMatrixNumber(x, k) {
            return _partitionSelect(x, k, asc);
          },
          'Array | Matrix, number, string': function ArrayMatrixNumberString(x, k, compare) {
            if (compare === 'asc') {
              return _partitionSelect(x, k, asc);
            } else if (compare === 'desc') {
              return _partitionSelect(x, k, desc);
            } else {
              throw new Error('Compare string must be "asc" or "desc"');
            }
          },
          'Array | Matrix, number, function': _partitionSelect
        });

        function _partitionSelect(x, k, compare) {
          if (!isInteger(k) || k < 0) {
            throw new Error('k must be a non-negative integer');
          }

          if (type.isMatrix(x)) {
            var size = x.size();

            if (size.length > 1) {
              throw new Error('Only one dimensional matrices supported');
            }

            return quickSelect(x.valueOf(), k, compare);
          }

          if (Array.isArray(x)) {
            return quickSelect(x, k, compare);
          }
        }
        /**
         * Quickselect algorithm.
         * Code adapted from:
         * https://blog.teamleadnet.com/2012/07/quick-select-algorithm-find-kth-element.html
         *
         * @param {Array} arr
         * @param {Number} k
         * @param {Function} compare
         * @private
         */


        function quickSelect(arr, k, compare) {
          if (k >= arr.length) {
            throw new Error('k out of bounds');
          } // check for NaN values since these can cause an infinite while loop


          for (var i = 0; i < arr.length; i++) {
            if (isNumeric(arr[i]) && isNaN(arr[i])) {
              return arr[i]; // return NaN
            }
          }

          var from = 0;
          var to = arr.length - 1; // if from == to we reached the kth element

          while (from < to) {
            var r = from;
            var w = to;
            var pivot = arr[Math.floor(Math.random() * (to - from + 1)) + from]; // stop if the reader and writer meets

            while (r < w) {
              // arr[r] >= pivot
              if (compare(arr[r], pivot) >= 0) {
                // put the large values at the end
                var tmp = arr[w];
                arr[w] = arr[r];
                arr[r] = tmp;
                --w;
              } else {
                // the value is smaller than the pivot, skip
                ++r;
              }
            } // if we stepped up (r++) we need to step one down (arr[r] > pivot)


            if (compare(arr[r], pivot) > 0) {
              --r;
            } // the r pointer is on the end of the first k elements


            if (k <= r) {
              to = r;
            } else {
              from = r + 1;
            }
          }

          return arr[k];
        }
      }

      exports.name = 'partitionSelect';
      exports.factory = factory;
      /***/
    },
    /* 737 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var isInteger = __webpack_require__(67).isInteger;

      var resize = __webpack_require__(48).resize;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        /**
         * Create a matrix filled with ones. The created matrix can have one or
         * multiple dimensions.
         *
         * Syntax:
         *
         *    math.ones(m)
         *    math.ones(m, format)
         *    math.ones(m, n)
         *    math.ones(m, n, format)
         *    math.ones([m, n])
         *    math.ones([m, n], format)
         *    math.ones([m, n, p, ...])
         *    math.ones([m, n, p, ...], format)
         *
         * Examples:
         *
         *    math.ones(3)                   // returns [1, 1, 1]
         *    math.ones(3, 2)                // returns [[1, 1], [1, 1], [1, 1]]
         *    math.ones(3, 2, 'dense')       // returns Dense Matrix [[1, 1], [1, 1], [1, 1]]
         *
         *    const A = [[1, 2, 3], [4, 5, 6]]
         *    math.ones(math.size(A))       // returns [[1, 1, 1], [1, 1, 1]]
         *
         * See also:
         *
         *    zeros, identity, size, range
         *
         * @param {...number | Array} size    The size of each dimension of the matrix
         * @param {string} [format]           The Matrix storage format
         *
         * @return {Array | Matrix | number}  A matrix filled with ones
         */

        var ones = typed('ones', {
          '': function _() {
            return config.matrix === 'Array' ? _ones([]) : _ones([], 'default');
          },
          // math.ones(m, n, p, ..., format)
          // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
          '...number | BigNumber | string': function numberBigNumberString(size) {
            var last = size[size.length - 1];

            if (typeof last === 'string') {
              var format = size.pop();
              return _ones(size, format);
            } else if (config.matrix === 'Array') {
              return _ones(size);
            } else {
              return _ones(size, 'default');
            }
          },
          'Array': _ones,
          'Matrix': function Matrix(size) {
            var format = size.storage();
            return _ones(size.valueOf(), format);
          },
          'Array | Matrix, string': function ArrayMatrixString(size, format) {
            return _ones(size.valueOf(), format);
          }
        });
        ones.toTex = undefined; // use default template

        return ones;
        /**
         * Create an Array or Matrix with ones
         * @param {Array} size
         * @param {string} [format='default']
         * @return {Array | Matrix}
         * @private
         */

        function _ones(size, format) {
          var hasBigNumbers = _normalize(size);

          var defaultValue = hasBigNumbers ? new type.BigNumber(1) : 1;

          _validate(size);

          if (format) {
            // return a matrix
            var m = matrix(format);

            if (size.length > 0) {
              return m.resize(size, defaultValue);
            }

            return m;
          } else {
            // return an Array
            var arr = [];

            if (size.length > 0) {
              return resize(arr, size, defaultValue);
            }

            return arr;
          }
        } // replace BigNumbers with numbers, returns true if size contained BigNumbers


        function _normalize(size) {
          var hasBigNumbers = false;
          size.forEach(function (value, index, arr) {
            if (type.isBigNumber(value)) {
              hasBigNumbers = true;
              arr[index] = value.toNumber();
            }
          });
          return hasBigNumbers;
        } // validate arguments


        function _validate(size) {
          size.forEach(function (value) {
            if (typeof value !== 'number' || !isInteger(value) || value < 0) {
              throw new Error('Parameters in function ones must be positive integers');
            }
          });
        }
      }

      exports.name = 'ones';
      exports.factory = factory;
      /***/
    },
    /* 738 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var maxArgumentCount = __webpack_require__(232).maxArgumentCount;

      function factory(type, config, load, typed) {
        /**
         * Create a new matrix or array with the results of the callback function executed on
         * each entry of the matrix/array.
         *
         * Syntax:
         *
         *    math.map(x, callback)
         *
         * Examples:
         *
         *    math.map([1, 2, 3], function(value) {
         *      return value * value
         *    })  // returns [1, 4, 9]
         *
         * See also:
         *
         *    filter, forEach, sort
         *
         * @param {Matrix | Array} x    The matrix to iterate on.
         * @param {Function} callback   The callback method is invoked with three
         *                              parameters: the value of the element, the index
         *                              of the element, and the matrix being traversed.
         * @return {Matrix | array}     Transformed map of x
         */
        var map = typed('map', {
          'Array, function': _map,
          'Matrix, function': function MatrixFunction(x, callback) {
            return x.map(callback);
          }
        });
        map.toTex = undefined; // use default template

        return map;
      }
      /**
       * Map for a multi dimensional array
       * @param {Array} array
       * @param {Function} callback
       * @return {Array}
       * @private
       */


      function _map(array, callback) {
        // figure out what number of arguments the callback function expects
        var args = maxArgumentCount(callback);

        var recurse = function recurse(value, index) {
          if (Array.isArray(value)) {
            return value.map(function (child, i) {
              // we create a copy of the index array and append the new index value
              return recurse(child, index.concat(i));
            });
          } else {
            // invoke the callback function with the right number of arguments
            if (args === 1) {
              return callback(value);
            } else if (args === 2) {
              return callback(value, index);
            } else {
              // 3 or -1
              return callback(value, index, array);
            }
          }
        };

        return recurse(array, []);
      }

      exports.name = 'map';
      exports.factory = factory;
      /***/
    },
    /* 739 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var size = __webpack_require__(48).size;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var multiplyScalar = load(__webpack_require__(303));
        /**
           * Calculates the kronecker product of 2 matrices or vectors.
           *
           * NOTE: If a one dimensional vector / matrix is given, it will be
           * wrapped so its two dimensions.
           * See the examples.
           *
           * Syntax:
           *
           *    math.kron(x, y)
           *
           * Examples:
           *
           *    math.kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])
           *    // returns [ [ 1, 2, 0, 0 ], [ 3, 4, 0, 0 ], [ 0, 0, 1, 2 ], [ 0, 0, 3, 4 ] ]
           *
           *    math.kron([1,1], [2,3,4])
           *    // returns [ [ 2, 3, 4, 2, 3, 4 ] ]
           *
           * See also:
           *
           *    multiply, dot, cross
           *
           * @param  {Array | Matrix} x     First vector
           * @param  {Array | Matrix} y     Second vector
           * @return {Array | Matrix}       Returns the kronecker product of `x` and `y`
           */

        var kron = typed('kron', {
          'Matrix, Matrix': function MatrixMatrix(x, y) {
            return matrix(_kron(x.toArray(), y.toArray()));
          },
          'Matrix, Array': function MatrixArray(x, y) {
            return matrix(_kron(x.toArray(), y));
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            return matrix(_kron(x, y.toArray()));
          },
          'Array, Array': _kron
        });
        return kron;
        /**
           * Calculate the kronecker product of two matrices / vectors
           * @param {Array} a  First vector
           * @param {Array} b  Second vector
           * @returns {Array} Returns the kronecker product of x and y
           * @private
           */

        function _kron(a, b) {
          // Deal with the dimensions of the matricies.
          if (size(a).length === 1) {
            // Wrap it in a 2D Matrix
            a = [a];
          }

          if (size(b).length === 1) {
            // Wrap it in a 2D Matrix
            b = [b];
          }

          if (size(a).length > 2 || size(b).length > 2) {
            throw new RangeError('Vectors with dimensions greater then 2 are not supported expected ' + '(Size x = ' + JSON.stringify(a.length) + ', y = ' + JSON.stringify(b.length) + ')');
          }

          var t = [];
          var r = [];
          return a.map(function (a) {
            return b.map(function (b) {
              r = [];
              t.push(r);
              return a.map(function (y) {
                return b.map(function (x) {
                  return r.push(multiplyScalar(y, x));
                });
              });
            });
          }) && t;
        }
      }

      exports.name = 'kron';
      exports.factory = factory;
      /***/
    },
    /* 740 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var maxArgumentCount = __webpack_require__(232).maxArgumentCount;

      var forEach = __webpack_require__(48).forEach;

      function factory(type, config, load, typed) {
        /**
         * Iterate over all elements of a matrix/array, and executes the given callback function.
         *
         * Syntax:
         *
         *    math.forEach(x, callback)
         *
         * Examples:
         *
         *    math.forEach([1, 2, 3], function(value) {
         *      console.log(value)
         *    })
         *    // outputs 1, 2, 3
         *
         * See also:
         *
         *    filter, map, sort
         *
         * @param {Matrix | Array} x    The matrix to iterate on.
         * @param {Function} callback   The callback function is invoked with three
         *                              parameters: the value of the element, the index
         *                              of the element, and the Matrix/array being traversed.
         */
        var forEach = typed('forEach', {
          'Array, function': _forEach,
          'Matrix, function': function MatrixFunction(x, callback) {
            return x.forEach(callback);
          }
        });
        forEach.toTex = undefined; // use default template

        return forEach;
      }
      /**
       * forEach for a multi dimensional array
       * @param {Array} array
       * @param {Function} callback
       * @private
       */


      function _forEach(array, callback) {
        // figure out what number of arguments the callback function expects
        var args = maxArgumentCount(callback);

        var recurse = function recurse(value, index) {
          if (Array.isArray(value)) {
            forEach(value, function (child, i) {
              // we create a copy of the index array and append the new index value
              recurse(child, index.concat(i));
            });
          } else {
            // invoke the callback function with the right number of arguments
            if (args === 1) {
              callback(value);
            } else if (args === 2) {
              callback(value, index);
            } else {
              // 3 or -1
              callback(value, index, array);
            }
          }
        };

        recurse(array, []);
      }

      exports.name = 'forEach';
      exports.factory = factory;
      /***/
    },
    /* 741 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var clone = __webpack_require__(59).clone;

      var _flatten = __webpack_require__(48).flatten;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        /**
         * Flatten a multi dimensional matrix into a single dimensional matrix.
         *
         * Syntax:
         *
         *    math.flatten(x)
         *
         * Examples:
         *
         *    math.flatten([[1,2], [3,4]])   // returns [1, 2, 3, 4]
         *
         * See also:
         *
         *    concat, resize, size, squeeze
         *
         * @param {Matrix | Array} x   Matrix to be flattened
         * @return {Matrix | Array} Returns the flattened matrix
         */

        var flatten = typed('flatten', {
          'Array': function Array(x) {
            return _flatten(clone(x));
          },
          'Matrix': function Matrix(x) {
            var flat = _flatten(clone(x.toArray())); // TODO: return the same matrix type as x


            return matrix(flat);
          }
        });
        flatten.toTex = undefined; // use default template

        return flatten;
      }

      exports.name = 'flatten';
      exports.factory = factory;
      /***/
    },
    /* 742 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var filter = __webpack_require__(48).filter;

      var filterRegExp = __webpack_require__(48).filterRegExp;

      var maxArgumentCount = __webpack_require__(232).maxArgumentCount;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        /**
         * Filter the items in an array or one dimensional matrix.
         *
         * Syntax:
         *
         *    math.filter(x, test)
         *
         * Examples:
         *
         *    function isPositive (x) {
         *      return x > 0
         *    }
         *    math.filter([6, -2, -1, 4, 3], isPositive) // returns [6, 4, 3]
         *
         *    math.filter(["23", "foo", "100", "55", "bar"], /[0-9]+/) // returns ["23", "100", "55"]
         *
         * See also:
         *
         *    forEach, map, sort
         *
         * @param {Matrix | Array} x    A one dimensional matrix or array to filter
         * @param {Function | RegExp} test
         *        A function or regular expression to test items.
         *        All entries for which `test` returns true are returned.
         *        When `test` is a function, it is invoked with three parameters:
         *        the value of the element, the index of the element, and the
         *        matrix/array being traversed. The function must return a boolean.
         * @return {Matrix | Array} Returns the filtered matrix.
         */

        var filter = typed('filter', {
          'Array, function': _filterCallback,
          'Matrix, function': function MatrixFunction(x, test) {
            return matrix(_filterCallback(x.toArray(), test));
          },
          'Array, RegExp': filterRegExp,
          'Matrix, RegExp': function MatrixRegExp(x, test) {
            return matrix(filterRegExp(x.toArray(), test));
          }
        });
        filter.toTex = undefined; // use default template

        return filter;
      }
      /**
       * Filter values in a callback given a callback function
       * @param {Array} x
       * @param {Function} callback
       * @return {Array} Returns the filtered array
       * @private
       */


      function _filterCallback(x, callback) {
        // figure out what number of arguments the callback function expects
        var args = maxArgumentCount(callback);
        return filter(x, function (value, index, array) {
          // invoke the callback function with the right number of arguments
          if (args === 1) {
            return callback(value);
          } else if (args === 2) {
            return callback(value, [index]);
          } else {
            // 3 or -1
            return callback(value, [index], array);
          }
        });
      }

      exports.name = 'filter';
      exports.factory = factory;
      /***/
    },
    /* 743 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var format = __webpack_require__(79).format;

      function factory(type, config, load, typed) {
        var abs = load(__webpack_require__(194));
        var add = load(__webpack_require__(170));
        var identity = load(__webpack_require__(193));
        var inv = load(__webpack_require__(233));
        var multiply = load(__webpack_require__(124));
        var SparseMatrix = type.SparseMatrix;
        /**
         * Compute the matrix exponential, expm(A) = e^A. The matrix must be square.
         * Not to be confused with exp(a), which performs element-wise
         * exponentiation.
         *
         * The exponential is calculated using the Padé approximant with scaling and
         * squaring; see "Nineteen Dubious Ways to Compute the Exponential of a
         * Matrix," by Moler and Van Loan.
         *
         * Syntax:
         *
         *     math.expm(x)
         *
         * Examples:
         *
         *     const A = [[0,2],[0,0]]
         *     math.expm(A)        // returns [[1,2],[0,1]]
         *
         * See also:
         *
         *     exp
         *
         * @param {Matrix} x  A square Matrix
         * @return {Matrix}   The exponential of x
         */

        var expm = typed('expm', {
          'Matrix': function Matrix(A) {
            // Check matrix size
            var size = A.size();

            if (size.length !== 2 || size[0] !== size[1]) {
              throw new RangeError('Matrix must be square ' + '(size: ' + format(size) + ')');
            }

            var n = size[0]; // Desired accuracy of the approximant (The actual accuracy
            // will be affected by round-off error)

            var eps = 1e-15; // The Padé approximant is not so accurate when the values of A
            // are "large", so scale A by powers of two. Then compute the
            // exponential, and square the result repeatedly according to
            // the identity e^A = (e^(A/m))^m
            // Compute infinity-norm of A, ||A||, to see how "big" it is

            var infNorm = infinityNorm(A); // Find the optimal scaling factor and number of terms in the
            // Padé approximant to reach the desired accuracy

            var params = findParams(infNorm, eps);
            var q = params.q;
            var j = params.j; // The Pade approximation to e^A is:
            // Rqq(A) = Dqq(A) ^ -1 * Nqq(A)
            // where
            // Nqq(A) = sum(i=0, q, (2q-i)!p! / [ (2q)!i!(q-i)! ] A^i
            // Dqq(A) = sum(i=0, q, (2q-i)!q! / [ (2q)!i!(q-i)! ] (-A)^i
            // Scale A by 1 / 2^j

            var Apos = multiply(A, Math.pow(2, -j)); // The i=0 term is just the identity matrix

            var N = identity(n);
            var D = identity(n); // Initialization (i=0)

            var factor = 1; // Initialization (i=1)

            var AposToI = Apos; // Cloning not necessary

            var alternate = -1;

            for (var i = 1; i <= q; i++) {
              if (i > 1) {
                AposToI = multiply(AposToI, Apos);
                alternate = -alternate;
              }

              factor = factor * (q - i + 1) / ((2 * q - i + 1) * i);
              N = add(N, multiply(factor, AposToI));
              D = add(D, multiply(factor * alternate, AposToI));
            }

            var R = multiply(inv(D), N); // Square j times

            for (var _i = 0; _i < j; _i++) {
              R = multiply(R, R);
            }

            return type.isSparseMatrix(A) ? new SparseMatrix(R) : R;
          }
        });

        function infinityNorm(A) {
          var n = A.size()[0];
          var infNorm = 0;

          for (var i = 0; i < n; i++) {
            var rowSum = 0;

            for (var j = 0; j < n; j++) {
              rowSum += abs(A.get([i, j]));
            }

            infNorm = Math.max(rowSum, infNorm);
          }

          return infNorm;
        }
        /**
         * Find the best parameters for the Pade approximant given
         * the matrix norm and desired accuracy. Returns the first acceptable
         * combination in order of increasing computational load.
         */


        function findParams(infNorm, eps) {
          var maxSearchSize = 30;

          for (var k = 0; k < maxSearchSize; k++) {
            for (var q = 0; q <= k; q++) {
              var j = k - q;

              if (errorEstimate(infNorm, q, j) < eps) {
                return {
                  q: q,
                  j: j
                };
              }
            }
          }

          throw new Error('Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)');
        }
        /**
         * Returns the estimated error of the Pade approximant for the given
         * parameters.
         */


        function errorEstimate(infNorm, q, j) {
          var qfac = 1;

          for (var i = 2; i <= q; i++) {
            qfac *= i;
          }

          var twoqfac = qfac;

          for (var _i2 = q + 1; _i2 <= 2 * q; _i2++) {
            twoqfac *= _i2;
          }

          var twoqp1fac = twoqfac * (2 * q + 1);
          return 8.0 * Math.pow(infNorm / Math.pow(2, j), 2 * q) * qfac * qfac / (twoqfac * twoqp1fac);
        }

        expm.toTex = {
          1: "\\exp\\left(${args[0]}\\right)"
        };
        return expm;
      }

      exports.name = 'expm';
      exports.factory = factory;
      /***/
    },
    /* 744 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // TODO: function eye is removed since v5.0.0 (June 2018). Remove it some day.

      function factory(type, config, load, typed) {
        return function eye() {
          throw new Error('Function "eye" is renamed to "identity" since mathjs version 5.0.0. ' + 'To keep eye working, create an alias for it using "math.import({eye: math.identity}, {override: true})"');
        };
      }

      exports.name = 'eye';
      exports.factory = factory;
      /***/
    },
    /* 745 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var size = __webpack_require__(48).size;

      function factory(type, config, load, typed) {
        var add = load(__webpack_require__(170));
        var multiply = load(__webpack_require__(124));
        /**
         * Calculate the dot product of two vectors. The dot product of
         * `A = [a1, a2, a3, ..., an]` and `B = [b1, b2, b3, ..., bn]` is defined as:
         *
         *    dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn
         *
         * Syntax:
         *
         *    math.dot(x, y)
         *
         * Examples:
         *
         *    math.dot([2, 4, 1], [2, 2, 3])       // returns number 15
         *    math.multiply([2, 4, 1], [2, 2, 3])  // returns number 15
         *
         * See also:
         *
         *    multiply, cross
         *
         * @param  {Array | Matrix} x     First vector
         * @param  {Array | Matrix} y     Second vector
         * @return {number}               Returns the dot product of `x` and `y`
         */

        var dot = typed('dot', {
          'Matrix, Matrix': function MatrixMatrix(x, y) {
            return _dot(x.toArray(), y.toArray());
          },
          'Matrix, Array': function MatrixArray(x, y) {
            return _dot(x.toArray(), y);
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            return _dot(x, y.toArray());
          },
          'Array, Array': _dot
        });
        dot.toTex = {
          2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
        };
        return dot;
        /**
         * Calculate the dot product for two arrays
         * @param {Array} x  First vector
         * @param {Array} y  Second vector
         * @returns {number} Returns the dot product of x and y
         * @private
         */
        // TODO: double code with math.multiply

        function _dot(x, y) {
          var xSize = size(x);
          var ySize = size(y);
          var len = xSize[0];
          if (xSize.length !== 1 || ySize.length !== 1) throw new RangeError('Vector expected'); // TODO: better error message

          if (xSize[0] !== ySize[0]) throw new RangeError('Vectors must have equal length (' + xSize[0] + ' != ' + ySize[0] + ')');
          if (len === 0) throw new RangeError('Cannot calculate the dot product of empty vectors');
          var prod = 0;

          for (var i = 0; i < len; i++) {
            prod = add(prod, multiply(x[i], y[i]));
          }

          return prod;
        }
      }

      exports.name = 'dot';
      exports.factory = factory;
      /***/
    },
    /* 746 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var array = __webpack_require__(48);

      var isInteger = __webpack_require__(67).isInteger;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        /**
         * Create a diagonal matrix or retrieve the diagonal of a matrix
         *
         * When `x` is a vector, a matrix with vector `x` on the diagonal will be returned.
         * When `x` is a two dimensional matrix, the matrixes `k`th diagonal will be returned as vector.
         * When k is positive, the values are placed on the super diagonal.
         * When k is negative, the values are placed on the sub diagonal.
         *
         * Syntax:
         *
         *     math.diag(X)
         *     math.diag(X, format)
         *     math.diag(X, k)
         *     math.diag(X, k, format)
         *
         * Examples:
         *
         *     // create a diagonal matrix
         *     math.diag([1, 2, 3])      // returns [[1, 0, 0], [0, 2, 0], [0, 0, 3]]
         *     math.diag([1, 2, 3], 1)   // returns [[0, 1, 0, 0], [0, 0, 2, 0], [0, 0, 0, 3]]
         *     math.diag([1, 2, 3], -1)  // returns [[0, 0, 0], [1, 0, 0], [0, 2, 0], [0, 0, 3]]
         *
         *    // retrieve the diagonal from a matrix
         *    const a = [[1, 2, 3], [4, 5, 6], [7, 8, 9]]
         *    math.diag(a)   // returns [1, 5, 9]
         *
         * See also:
         *
         *     ones, zeros, identity
         *
         * @param {Matrix | Array} x          A two dimensional matrix or a vector
         * @param {number | BigNumber} [k=0]  The diagonal where the vector will be filled
         *                                    in or retrieved.
         * @param {string} [format='dense']   The matrix storage format.
         *
         * @returns {Matrix | Array} Diagonal matrix from input vector, or diagonal from input matrix.
         */

        var diag = typed('diag', {
          // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
          'Array': function Array(x) {
            return _diag(x, 0, array.size(x), null);
          },
          'Array, number': function ArrayNumber(x, k) {
            return _diag(x, k, array.size(x), null);
          },
          'Array, BigNumber': function ArrayBigNumber(x, k) {
            return _diag(x, k.toNumber(), array.size(x), null);
          },
          'Array, string': function ArrayString(x, format) {
            return _diag(x, 0, array.size(x), format);
          },
          'Array, number, string': function ArrayNumberString(x, k, format) {
            return _diag(x, k, array.size(x), format);
          },
          'Array, BigNumber, string': function ArrayBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), array.size(x), format);
          },
          'Matrix': function Matrix(x) {
            return _diag(x, 0, x.size(), x.storage());
          },
          'Matrix, number': function MatrixNumber(x, k) {
            return _diag(x, k, x.size(), x.storage());
          },
          'Matrix, BigNumber': function MatrixBigNumber(x, k) {
            return _diag(x, k.toNumber(), x.size(), x.storage());
          },
          'Matrix, string': function MatrixString(x, format) {
            return _diag(x, 0, x.size(), format);
          },
          'Matrix, number, string': function MatrixNumberString(x, k, format) {
            return _diag(x, k, x.size(), format);
          },
          'Matrix, BigNumber, string': function MatrixBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), x.size(), format);
          }
        });
        diag.toTex = undefined; // use default template

        return diag;
        /**
         * Creeate diagonal matrix from a vector or vice versa
         * @param {Array | Matrix} x
         * @param {number} k
         * @param {string} format Storage format for matrix. If null,
         *                          an Array is returned
         * @returns {Array | Matrix}
         * @private
         */

        function _diag(x, k, size, format) {
          if (!isInteger(k)) {
            throw new TypeError('Second parameter in function diag must be an integer');
          }

          var kSuper = k > 0 ? k : 0;
          var kSub = k < 0 ? -k : 0; // check dimensions

          switch (size.length) {
            case 1:
              return _createDiagonalMatrix(x, k, format, size[0], kSub, kSuper);

            case 2:
              return _getDiagonal(x, k, format, size, kSub, kSuper);
          }

          throw new RangeError('Matrix for function diag must be 2 dimensional');
        }

        function _createDiagonalMatrix(x, k, format, l, kSub, kSuper) {
          // matrix size
          var ms = [l + kSub, l + kSuper]; // get matrix constructor

          var F = type.Matrix.storage(format || 'dense'); // create diagonal matrix

          var m = F.diagonal(ms, x, k); // check we need to return a matrix

          return format !== null ? m : m.valueOf();
        }

        function _getDiagonal(x, k, format, s, kSub, kSuper) {
          // check x is a Matrix
          if (type.isMatrix(x)) {
            // get diagonal matrix
            var dm = x.diagonal(k); // check we need to return a matrix

            if (format !== null) {
              // check we need to change matrix format
              if (format !== dm.storage()) {
                return matrix(dm, format);
              }

              return dm;
            }

            return dm.valueOf();
          } // vector size


          var n = Math.min(s[0] - kSub, s[1] - kSuper); // diagonal values

          var vector = []; // loop diagonal

          for (var i = 0; i < n; i++) {
            vector[i] = x[i + kSub][i + kSuper];
          } // check we need to return a matrix


          return format !== null ? matrix(vector) : vector;
        }
      }

      exports.name = 'diag';
      exports.factory = factory;
      /***/
    },
    /* 747 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        /**
         * Compute the complex conjugate of a complex value.
         * If `x = a+bi`, the complex conjugate of `x` is `a - bi`.
         *
         * For matrices, the function is evaluated element wise.
         *
         * Syntax:
         *
         *    math.conj(x)
         *
         * Examples:
         *
         *    math.conj(math.complex('2 + 3i'))  // returns Complex 2 - 3i
         *    math.conj(math.complex('2 - 3i'))  // returns Complex 2 + 3i
         *    math.conj(math.complex('-5.2i'))  // returns Complex 5.2i
         *
         * See also:
         *
         *    re, im, arg, abs
         *
         * @param {number | BigNumber | Complex | Array | Matrix} x
         *            A complex number or array with complex numbers
         * @return {number | BigNumber | Complex | Array | Matrix}
         *            The complex conjugate of x
         */
        var conj = typed('conj', {
          'number': function number(x) {
            return x;
          },
          'BigNumber': function BigNumber(x) {
            return x;
          },
          'Complex': function Complex(x) {
            return x.conjugate();
          },
          'Array | Matrix': function ArrayMatrix(x) {
            return deepMap(x, conj);
          }
        });
        conj.toTex = {
          1: "\\left(${args[0]}\\right)^*"
        };
        return conj;
      }

      exports.name = 'conj';
      exports.factory = factory;
      /***/
    },
    /* 748 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var transpose = load(__webpack_require__(393));
        var conj = load(__webpack_require__(747));

        var latex = __webpack_require__(72);
        /**
         * Transpose and complex conjugate a matrix. All values of the matrix are
         * reflected over its main diagonal and then the complex conjugate is
         * taken. This is equivalent to complex conjugation for scalars and
         * vectors.
         *
         * Syntax:
         *
         *     math.ctranspose(x)
         *
         * Examples:
         *
         *     const A = [[1, 2, 3], [4, 5, math.complex(6,7)]]
         *     math.ctranspose(A)               // returns [[1, 4], [2, 5], [3, {re:6,im:7}]]
         *
         * See also:
         *
         *     transpose, diag, inv, subset, squeeze
         *
         * @param {Array | Matrix} x  Matrix to be ctransposed
         * @return {Array | Matrix}   The ctransposed matrix
         */


        var ctranspose = typed('ctranspose', {
          'any': function any(x) {
            return conj(transpose(x));
          }
        });
        ctranspose.toTex = {
          1: "\\left(${args[0]}\\right)".concat(latex.operators['ctranspose'])
        };
        return ctranspose;
      }

      exports.name = 'ctranspose';
      exports.factory = factory;
      /***/
    },
    /* 749 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var array = __webpack_require__(48);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var subtract = load(__webpack_require__(196));
        var multiply = load(__webpack_require__(124));
        /**
         * Calculate the cross product for two vectors in three dimensional space.
         * The cross product of `A = [a1, a2, a3]` and `B = [b1, b2, b3]` is defined
         * as:
         *
         *    cross(A, B) = [
         *      a2 * b3 - a3 * b2,
         *      a3 * b1 - a1 * b3,
         *      a1 * b2 - a2 * b1
         *    ]
         *
         * If one of the input vectors has a dimension greater than 1, the output
         * vector will be a 1x3 (2-dimensional) matrix.
         *
         * Syntax:
         *
         *    math.cross(x, y)
         *
         * Examples:
         *
         *    math.cross([1, 1, 0],   [0, 1, 1])       // Returns [1, -1, 1]
         *    math.cross([3, -3, 1],  [4, 9, 2])       // Returns [-15, -2, 39]
         *    math.cross([2, 3, 4],   [5, 6, 7])       // Returns [-3, 6, -3]
         *    math.cross([[1, 2, 3]], [[4], [5], [6]]) // Returns [[-3, 6, -3]]
         *
         * See also:
         *
         *    dot, multiply
         *
         * @param  {Array | Matrix} x   First vector
         * @param  {Array | Matrix} y   Second vector
         * @return {Array | Matrix}     Returns the cross product of `x` and `y`
         */

        var cross = typed('cross', {
          'Matrix, Matrix': function MatrixMatrix(x, y) {
            return matrix(_cross(x.toArray(), y.toArray()));
          },
          'Matrix, Array': function MatrixArray(x, y) {
            return matrix(_cross(x.toArray(), y));
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            return matrix(_cross(x, y.toArray()));
          },
          'Array, Array': _cross
        });
        cross.toTex = {
          2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
        };
        return cross;
        /**
         * Calculate the cross product for two arrays
         * @param {Array} x  First vector
         * @param {Array} y  Second vector
         * @returns {Array} Returns the cross product of x and y
         * @private
         */

        function _cross(x, y) {
          var highestDimension = Math.max(array.size(x).length, array.size(y).length);
          x = array.squeeze(x);
          y = array.squeeze(y);
          var xSize = array.size(x);
          var ySize = array.size(y);

          if (xSize.length !== 1 || ySize.length !== 1 || xSize[0] !== 3 || ySize[0] !== 3) {
            throw new RangeError('Vectors with length 3 expected ' + '(Size A = [' + xSize.join(', ') + '], B = [' + ySize.join(', ') + '])');
          }

          var product = [subtract(multiply(x[1], y[2]), multiply(x[2], y[1])), subtract(multiply(x[2], y[0]), multiply(x[0], y[2])), subtract(multiply(x[0], y[1]), multiply(x[1], y[0]))];

          if (highestDimension > 1) {
            return [product];
          } else {
            return product;
          }
        }
      }

      exports.name = 'cross';
      exports.factory = factory;
      /***/
    },
    /* 750 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var clone = __webpack_require__(59).clone;

      var array = __webpack_require__(48);

      var IndexError = __webpack_require__(198);

      var DimensionError = __webpack_require__(92);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var isInteger = load(__webpack_require__(299));
        /**
         * Concatenate two or more matrices.
         *
         * Syntax:
         *
         *     math.concat(A, B, C, ...)
         *     math.concat(A, B, C, ..., dim)
         *
         * Where:
         *
         * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
         *   By default the last dimension of the matrices.
         *
         * Examples:
         *
         *    const A = [[1, 2], [5, 6]]
         *    const B = [[3, 4], [7, 8]]
         *
         *    math.concat(A, B)                  // returns [[1, 2, 3, 4], [5, 6, 7, 8]]
         *    math.concat(A, B, 0)               // returns [[1, 2], [5, 6], [3, 4], [7, 8]]
         *    math.concat('hello', ' ', 'world') // returns 'hello world'
         *
         * See also:
         *
         *    size, squeeze, subset, transpose
         *
         * @param {... Array | Matrix} args     Two or more matrices
         * @return {Array | Matrix} Concatenated matrix
         */

        var concat = typed('concat', {
          // TODO: change signature to '...Array | Matrix, dim?' when supported
          '...Array | Matrix | number | BigNumber': function ArrayMatrixNumberBigNumber(args) {
            var i;
            var len = args.length;
            var dim = -1; // zero-based dimension

            var prevDim;
            var asMatrix = false;
            var matrices = []; // contains multi dimensional arrays

            for (i = 0; i < len; i++) {
              var arg = args[i]; // test whether we need to return a Matrix (if not we return an Array)

              if (type.isMatrix(arg)) {
                asMatrix = true;
              }

              if (type.isNumber(arg) || type.isBigNumber(arg)) {
                if (i !== len - 1) {
                  throw new Error('Dimension must be specified as last argument');
                } // last argument contains the dimension on which to concatenate


                prevDim = dim;
                dim = arg.valueOf(); // change BigNumber to number

                if (!isInteger(dim)) {
                  throw new TypeError('Integer number expected for dimension');
                }

                if (dim < 0 || i > 0 && dim > prevDim) {
                  // TODO: would be more clear when throwing a DimensionError here
                  throw new IndexError(dim, prevDim + 1);
                }
              } else {
                // this is a matrix or array
                var m = clone(arg).valueOf();
                var size = array.size(m);
                matrices[i] = m;
                prevDim = dim;
                dim = size.length - 1; // verify whether each of the matrices has the same number of dimensions

                if (i > 0 && dim !== prevDim) {
                  throw new DimensionError(prevDim + 1, dim + 1);
                }
              }
            }

            if (matrices.length === 0) {
              throw new SyntaxError('At least one matrix expected');
            }

            var res = matrices.shift();

            while (matrices.length) {
              res = _concat(res, matrices.shift(), dim, 0);
            }

            return asMatrix ? matrix(res) : res;
          },
          '...string': function string(args) {
            return args.join('');
          }
        });
        concat.toTex = undefined; // use default template

        return concat;
      }
      /**
       * Recursively concatenate two matrices.
       * The contents of the matrices is not cloned.
       * @param {Array} a             Multi dimensional array
       * @param {Array} b             Multi dimensional array
       * @param {number} concatDim    The dimension on which to concatenate (zero-based)
       * @param {number} dim          The current dim (zero-based)
       * @return {Array} c            The concatenated matrix
       * @private
       */


      function _concat(a, b, concatDim, dim) {
        if (dim < concatDim) {
          // recurse into next dimension
          if (a.length !== b.length) {
            throw new DimensionError(a.length, b.length);
          }

          var c = [];

          for (var i = 0; i < a.length; i++) {
            c[i] = _concat(a[i], b[i], concatDim, dim + 1);
          }

          return c;
        } else {
          // concatenate this dimension
          return a.concat(b);
        }
      }

      exports.name = 'concat';
      exports.factory = factory;
      /***/
    },
    /* 751 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var nearlyEqual = __webpack_require__(67).nearlyEqual;

      var bigNearlyEqual = __webpack_require__(130);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var algorithm03 = load(__webpack_require__(152));
        var algorithm07 = load(__webpack_require__(230));
        var algorithm12 = load(__webpack_require__(150));
        var algorithm13 = load(__webpack_require__(129));
        var algorithm14 = load(__webpack_require__(107));

        var latex = __webpack_require__(72);
        /**
         * Test whether value x is larger or equal to y.
         *
         * The function returns true when x is larger than y or the relative
         * difference between x and y is smaller than the configured epsilon. The
         * function cannot be used to compare values smaller than approximately 2.22e-16.
         *
         * For matrices, the function is evaluated element wise.
         * Strings are compared by their numerical value.
         *
         * Syntax:
         *
         *    math.largerEq(x, y)
         *
         * Examples:
         *
         *    math.larger(2, 1 + 1)         // returns false
         *    math.largerEq(2, 1 + 1)       // returns true
         *
         * See also:
         *
         *    equal, unequal, smaller, smallerEq, larger, compare
         *
         * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
         * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
         * @return {boolean | Array | Matrix} Returns true when the x is larger or equal to y, else returns false
         */


        var largerEq = typed('largerEq', {
          'boolean, boolean': function booleanBoolean(x, y) {
            return x >= y;
          },
          'number, number': function numberNumber(x, y) {
            return x >= y || nearlyEqual(x, y, config.epsilon);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.gte(y) || bigNearlyEqual(x, y, config.epsilon);
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return x.compare(y) !== -1;
          },
          'Complex, Complex': function ComplexComplex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
          },
          'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) {
              throw new Error('Cannot compare units with different base');
            }

            return largerEq(x.value, y.value);
          },
          'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, largerEq);
          },
          'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, largerEq, true);
          },
          'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, largerEq, false);
          },
          'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, largerEq);
          },
          'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return largerEq(matrix(x), matrix(y)).valueOf();
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return largerEq(matrix(x), y);
          },
          'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return largerEq(x, matrix(y));
          },
          'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, largerEq, false);
          },
          'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, largerEq, false);
          },
          'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, largerEq, true);
          },
          'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, largerEq, true);
          },
          'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, largerEq, false).valueOf();
          },
          'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, largerEq, true).valueOf();
          }
        });
        largerEq.toTex = {
          2: "\\left(${args[0]}".concat(latex.operators['largerEq'], "${args[1]}\\right)")
        };
        return largerEq;
      }

      exports.name = 'largerEq';
      exports.factory = factory;
      /***/
    },
    /* 752 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var nearlyEqual = __webpack_require__(67).nearlyEqual;

      var bigNearlyEqual = __webpack_require__(130);

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var algorithm03 = load(__webpack_require__(152));
        var algorithm07 = load(__webpack_require__(230));
        var algorithm12 = load(__webpack_require__(150));
        var algorithm13 = load(__webpack_require__(129));
        var algorithm14 = load(__webpack_require__(107));

        var latex = __webpack_require__(72);
        /**
         * Test whether value x is smaller or equal to y.
         *
         * The function returns true when x is smaller than y or the relative
         * difference between x and y is smaller than the configured epsilon. The
         * function cannot be used to compare values smaller than approximately 2.22e-16.
         *
         * For matrices, the function is evaluated element wise.
         * Strings are compared by their numerical value.
         *
         * Syntax:
         *
         *    math.smallerEq(x, y)
         *
         * Examples:
         *
         *    math.smaller(1 + 2, 3)        // returns false
         *    math.smallerEq(1 + 2, 3)      // returns true
         *
         * See also:
         *
         *    equal, unequal, smaller, larger, largerEq, compare
         *
         * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
         * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
         * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
         */


        var smallerEq = typed('smallerEq', {
          'boolean, boolean': function booleanBoolean(x, y) {
            return x <= y;
          },
          'number, number': function numberNumber(x, y) {
            return x <= y || nearlyEqual(x, y, config.epsilon);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.lte(y) || bigNearlyEqual(x, y, config.epsilon);
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return x.compare(y) !== 1;
          },
          'Complex, Complex': function ComplexComplex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
          },
          'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) {
              throw new Error('Cannot compare units with different base');
            }

            return smallerEq(x.value, y.value);
          },
          'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, smallerEq);
          },
          'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, smallerEq, true);
          },
          'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, smallerEq, false);
          },
          'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, smallerEq);
          },
          'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return smallerEq(matrix(x), matrix(y)).valueOf();
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return smallerEq(matrix(x), y);
          },
          'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return smallerEq(x, matrix(y));
          },
          'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, smallerEq, false);
          },
          'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, smallerEq, false);
          },
          'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, smallerEq, true);
          },
          'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, smallerEq, true);
          },
          'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, smallerEq, false).valueOf();
          },
          'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, smallerEq, true).valueOf();
          }
        });
        smallerEq.toTex = {
          2: "\\left(${args[0]}".concat(latex.operators['smallerEq'], "${args[1]}\\right)")
        };
        return smallerEq;
      }

      exports.name = 'smallerEq';
      exports.factory = factory;
      /***/
    },
    /* 753 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var clone = __webpack_require__(59).clone;

      var validateIndex = __webpack_require__(48).validateIndex;

      function factory(type, config, load, typed) {
        var MatrixIndex = load(__webpack_require__(300));
        var matrix = load(__webpack_require__(46));
        var range = load(__webpack_require__(298));
        /**
         * Return a column from a Matrix.
         *
         * Syntax:
         *
         *     math.column(value, index)
         *
         * Example:
         *
         *     // get a column
         *     const d = [[1, 2], [3, 4]]
         *     math.column(d, 1) // returns [2, 4]
         *
         * See also:
         *
         *     row
         *
         * @param {Array | Matrix } value   An array or matrix
         * @param {number} column           The index of the column
         * @return {Array | Matrix}         The retrieved column
         */

        var column = typed('column', {
          'Matrix, number': _column,
          'Array, number': function ArrayNumber(value, column) {
            return _column(matrix(clone(value)), column).valueOf();
          }
        });
        column.toTex = undefined; // use default template

        return column;
        /**
         * Retrieve a column of a matrix
         * @param {Matrix } value  A matrix
         * @param {number} column  The index of the column
         * @return {Matrix}        The retrieved column
         */

        function _column(value, column) {
          // check dimensions
          if (value.size().length !== 2) {
            throw new Error('Only two dimensional matrix is supported');
          }

          validateIndex(column, value.size()[1]);
          var rowRange = range(0, value.size()[0]);
          var index = new MatrixIndex(rowRange, column);
          return value.subset(index);
        }
      }

      exports.name = 'column';
      exports.factory = factory;
      /***/
    },
    /* 754 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var arraySize = __webpack_require__(48).size;

      var isMatrix = __webpack_require__(199);

      var IndexError = __webpack_require__(198);

      function factory(type, config, load, typed) {
        var isInteger = load(__webpack_require__(299));
        /**
         * Apply a function that maps an array to a scalar
         * along a given axis of a matrix or array.
         * Returns a new matrix or array with one less dimension than the input.
         *
         * Syntax:
         *
         *     math.apply(A, dim, callback)
         *
         * Where:
         *
         * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
         *
         * Examples:
         *
         *    const A = [[1, 2], [3, 4]]
         *    const sum = math.sum
         *
         *    math.apply(A, 0, sum)             // returns [4, 6]
         *    math.apply(A, 1, sum)             // returns [3, 7]
         *
         * See also:
         *
         *    map, filter, forEach
         *
         * @param {Array | Matrix} array   The input Matrix
         * @param {number} dim             The dimension along which the callback is applied
         * @param {Function} callback      The callback function that is applied. This Function
         *                                 should take an array or 1-d matrix as an input and
         *                                 return a number.
         * @return {Array | Matrix} res    The residual matrix with the function applied over some dimension.
         */

        var apply = typed('apply', {
          'Array | Matrix, number | BigNumber, function': function ArrayMatrixNumberBigNumberFunction(mat, dim, callback) {
            if (!isInteger(dim)) {
              throw new TypeError('Integer number expected for dimension');
            }

            var size = Array.isArray(mat) ? arraySize(mat) : mat.size();

            if (dim < 0 || dim >= size.length) {
              throw new IndexError(dim, size.length);
            }

            if (isMatrix(mat)) {
              return mat.create(_apply(mat.valueOf(), dim, callback));
            } else {
              return _apply(mat, dim, callback);
            }
          }
        });
        apply.toTex = undefined; // use default template

        return apply;
      }
      /**
       * Recursively reduce a matrix
       * @param {Array} mat
       * @param {number} dim
       * @param {Function} callback
       * @returns {Array} ret
       * @private
       */


      function _apply(mat, dim, callback) {
        var i, ret, tran;

        if (dim <= 0) {
          if (!Array.isArray(mat[0])) {
            return callback(mat);
          } else {
            tran = _switch(mat);
            ret = [];

            for (i = 0; i < tran.length; i++) {
              ret[i] = _apply(tran[i], dim - 1, callback);
            }

            return ret;
          }
        } else {
          ret = [];

          for (i = 0; i < mat.length; i++) {
            ret[i] = _apply(mat[i], dim - 1, callback);
          }

          return ret;
        }
      }
      /**
       * Transpose a matrix
       * @param {Array} mat
       * @returns {Array} ret
       * @private
       */


      function _switch(mat) {
        var I = mat.length;
        var J = mat[0].length;
        var i, j;
        var ret = [];

        for (j = 0; j < J; j++) {
          var tmp = [];

          for (i = 0; i < I; i++) {
            tmp.push(mat[i][j]);
          }

          ret.push(tmp);
        }

        return ret;
      }

      exports.name = 'apply';
      exports.factory = factory;
      /***/
    },
    /* 755 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      module.exports = [__webpack_require__(754), __webpack_require__(753), __webpack_require__(750), __webpack_require__(749), __webpack_require__(748), __webpack_require__(403), __webpack_require__(746), __webpack_require__(745), __webpack_require__(744), __webpack_require__(743), __webpack_require__(742), __webpack_require__(741), __webpack_require__(740), __webpack_require__(193), __webpack_require__(233), __webpack_require__(739), __webpack_require__(738), __webpack_require__(737), __webpack_require__(736), __webpack_require__(298), __webpack_require__(733), __webpack_require__(732), __webpack_require__(731), __webpack_require__(392), __webpack_require__(730), __webpack_require__(727), __webpack_require__(726), __webpack_require__(305), __webpack_require__(725), __webpack_require__(393), __webpack_require__(401), __webpack_require__(724)];
      /***/
    },
    /* 756 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var SparseMatrix = type.SparseMatrix;
        /**
         * Create a Sparse Matrix. The function creates a new `math.type.Matrix` object from
         * an `Array`. A Matrix has utility functions to manipulate the data in the
         * matrix, like getting the size and getting or setting values in the matrix.
         *
         * Syntax:
         *
         *    math.sparse()               // creates an empty sparse matrix.
         *    math.sparse(data)           // creates a sparse matrix with initial data.
         *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
         *
         * Examples:
         *
         *    let m = math.sparse([[1, 2], [3, 4]])
         *    m.size()                        // Array [2, 2]
         *    m.resize([3, 2], 5)
         *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
         *    m.get([1, 0])                    // number 3
         *
         * See also:
         *
         *    bignumber, boolean, complex, index, number, string, unit, matrix
         *
         * @param {Array | Matrix} [data]    A two dimensional array
         *
         * @return {Matrix} The created matrix
         */

        var sparse = typed('sparse', {
          '': function _() {
            return new SparseMatrix([]);
          },
          'string': function string(datatype) {
            return new SparseMatrix([], datatype);
          },
          'Array | Matrix': function ArrayMatrix(data) {
            return new SparseMatrix(data);
          },
          'Array | Matrix, string': function ArrayMatrixString(data, datatype) {
            return new SparseMatrix(data, datatype);
          }
        });
        sparse.toTex = {
          0: '\\begin{bsparse}\\end{bsparse}',
          1: "\\left(${args[0]}\\right)"
        };
        return sparse;
      }

      exports.name = 'sparse';
      exports.factory = factory;
      /***/
    },
    /* 757 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        /**
         * Create an index. An Index can store ranges having start, step, and end
         * for multiple dimensions.
         * Matrix.get, Matrix.set, and math.subset accept an Index as input.
         *
         * Syntax:
         *
         *     math.index(range1, range2, ...)
         *
         * Where each range can be any of:
         *
         * - A number
         * - A string for getting/setting an object property
         * - An instance of `Range`
         * - A one-dimensional Array or a Matrix with numbers
         *
         * Indexes must be zero-based, integer numbers.
         *
         * Examples:
         *
         *    const math = require('mathjs')
         *
         *    const b = [1, 2, 3, 4, 5]
         *    math.subset(b, math.index([1, 2, 3]))     // returns [2, 3, 4]
         *
         *    const a = math.matrix([[1, 2], [3, 4]])
         *    a.subset(math.index(0, 1))             // returns 2
         *
         * See also:
         *
         *    bignumber, boolean, complex, matrix, number, string, unit
         *
         * @param {...*} ranges   Zero or more ranges or numbers.
         * @return {Index}        Returns the created index
         */
        return typed('index', {
          '...number | string | BigNumber | Range | Array | Matrix': function numberStringBigNumberRangeArrayMatrix(args) {
            var ranges = args.map(function (arg) {
              if (type.isBigNumber(arg)) {
                return arg.toNumber(); // convert BigNumber to Number
              } else if (Array.isArray(arg) || type.isMatrix(arg)) {
                return arg.map(function (elem) {
                  // convert BigNumber to Number
                  return type.isBigNumber(elem) ? elem.toNumber() : elem;
                });
              } else {
                return arg;
              }
            });
            var res = new type.Index();
            type.Index.apply(res, ranges);
            return res;
          }
        });
      }

      exports.name = 'index';
      exports.factory = factory;
      /***/
    },
    /* 758 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var util = __webpack_require__(151);

      var string = util.string;
      var object = util.object;
      var isArray = Array.isArray;
      var isString = string.isString;

      function factory(type, config, load) {
        var DenseMatrix = load(__webpack_require__(394));
        var smaller = load(__webpack_require__(229));

        function ImmutableDenseMatrix(data, datatype) {
          if (!(this instanceof ImmutableDenseMatrix)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          if (datatype && !isString(datatype)) {
            throw new Error('Invalid datatype: ' + datatype);
          }

          if (type.isMatrix(data) || isArray(data)) {
            // use DenseMatrix implementation
            var matrix = new DenseMatrix(data, datatype); // internal structures

            this._data = matrix._data;
            this._size = matrix._size;
            this._datatype = matrix._datatype;
            this._min = null;
            this._max = null;
          } else if (data && isArray(data.data) && isArray(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            this._datatype = data.datatype;
            this._min = typeof data.min !== 'undefined' ? data.min : null;
            this._max = typeof data.max !== 'undefined' ? data.max : null;
          } else if (data) {
            // unsupported type
            throw new TypeError('Unsupported type of data (' + util.types.type(data) + ')');
          } else {
            // nothing provided
            this._data = [];
            this._size = [0];
            this._datatype = datatype;
            this._min = null;
            this._max = null;
          }
        }

        ImmutableDenseMatrix.prototype = new DenseMatrix();
        /**
         * Attach type information
         */

        ImmutableDenseMatrix.prototype.type = 'ImmutableDenseMatrix';
        ImmutableDenseMatrix.prototype.isImmutableDenseMatrix = true;
        /**
         * Get a subset of the matrix, or replace a subset of the matrix.
         *
         * Usage:
         *     const subset = matrix.subset(index)               // retrieve subset
         *     const value = matrix.subset(index, replacement)   // replace subset
         *
         * @param {Index} index
         * @param {Array | ImmutableDenseMatrix | *} [replacement]
         * @param {*} [defaultValue=0]      Default value, filled in on new entries when
         *                                  the matrix is resized. If not provided,
         *                                  new matrix elements will be filled with zeros.
         */

        ImmutableDenseMatrix.prototype.subset = function (index) {
          switch (arguments.length) {
            case 1:
              // use base implementation
              var m = DenseMatrix.prototype.subset.call(this, index); // check result is a matrix

              if (type.isMatrix(m)) {
                // return immutable matrix
                return new ImmutableDenseMatrix({
                  data: m._data,
                  size: m._size,
                  datatype: m._datatype
                });
              }

              return m;
            // intentional fall through

            case 2:
            case 3:
              throw new Error('Cannot invoke set subset on an Immutable Matrix instance');

            default:
              throw new SyntaxError('Wrong number of arguments');
          }
        };
        /**
         * Replace a single element in the matrix.
         * @param {Number[]} index   Zero-based index
         * @param {*} value
         * @param {*} [defaultValue]        Default value, filled in on new entries when
         *                                  the matrix is resized. If not provided,
         *                                  new matrix elements will be left undefined.
         * @return {ImmutableDenseMatrix} self
         */


        ImmutableDenseMatrix.prototype.set = function () {
          throw new Error('Cannot invoke set on an Immutable Matrix instance');
        };
        /**
         * Resize the matrix to the given size. Returns a copy of the matrix when
         * `copy=true`, otherwise return the matrix itself (resize in place).
         *
         * @param {Number[]} size           The new size the matrix should have.
         * @param {*} [defaultValue=0]      Default value, filled in on new entries.
         *                                  If not provided, the matrix elements will
         *                                  be filled with zeros.
         * @param {boolean} [copy]          Return a resized copy of the matrix
         *
         * @return {Matrix}                 The resized matrix
         */


        ImmutableDenseMatrix.prototype.resize = function () {
          throw new Error('Cannot invoke resize on an Immutable Matrix instance');
        };
        /**
         * Disallows reshaping in favor of immutability.
         *
         * @throws {Error} Operation not allowed
         */


        ImmutableDenseMatrix.prototype.reshape = function () {
          throw new Error('Cannot invoke reshape on an Immutable Matrix instance');
        };
        /**
         * Create a clone of the matrix
         * @return {ImmutableDenseMatrix} clone
         */


        ImmutableDenseMatrix.prototype.clone = function () {
          var m = new ImmutableDenseMatrix({
            data: object.clone(this._data),
            size: object.clone(this._size),
            datatype: this._datatype
          });
          return m;
        };
        /**
         * Get a JSON representation of the matrix
         * @returns {Object}
         */


        ImmutableDenseMatrix.prototype.toJSON = function () {
          return {
            mathjs: 'ImmutableDenseMatrix',
            data: this._data,
            size: this._size,
            datatype: this._datatype
          };
        };
        /**
         * Generate a matrix from a JSON object
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
         *                       where mathjs is optional
         * @returns {ImmutableDenseMatrix}
         */


        ImmutableDenseMatrix.fromJSON = function (json) {
          return new ImmutableDenseMatrix(json);
        };
        /**
         * Swap rows i and j in Matrix.
         *
         * @param {Number} i       Matrix row index 1
         * @param {Number} j       Matrix row index 2
         *
         * @return {Matrix}        The matrix reference
         */


        ImmutableDenseMatrix.prototype.swapRows = function () {
          throw new Error('Cannot invoke swapRows on an Immutable Matrix instance');
        };
        /**
         * Calculate the minimum value in the set
         * @return {Number | undefined} min
         */


        ImmutableDenseMatrix.prototype.min = function () {
          // check min has been calculated before
          if (this._min === null) {
            // minimum
            var m = null; // compute min

            this.forEach(function (v) {
              if (m === null || smaller(v, m)) {
                m = v;
              }
            });
            this._min = m !== null ? m : undefined;
          }

          return this._min;
        };
        /**
         * Calculate the maximum value in the set
         * @return {Number | undefined} max
         */


        ImmutableDenseMatrix.prototype.max = function () {
          // check max has been calculated before
          if (this._max === null) {
            // maximum
            var m = null; // compute max

            this.forEach(function (v) {
              if (m === null || smaller(m, v)) {
                m = v;
              }
            });
            this._max = m !== null ? m : undefined;
          }

          return this._max;
        }; // exports


        return ImmutableDenseMatrix;
      }

      exports.name = 'ImmutableDenseMatrix';
      exports.path = 'type';
      exports.factory = factory;
      /***/
    },
    /* 759 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var smaller = load(__webpack_require__(229));
        var larger = load(__webpack_require__(231));
        var oneOverLogPhi = 1.0 / Math.log((1.0 + Math.sqrt(5.0)) / 2.0);
        /**
         * Fibonacci Heap implementation, used interally for Matrix math.
         * @class FibonacciHeap
         * @constructor FibonacciHeap
         */

        function FibonacciHeap() {
          if (!(this instanceof FibonacciHeap)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          } // initialize fields


          this._minimum = null;
          this._size = 0;
        }
        /**
         * Attach type information
         */


        FibonacciHeap.prototype.type = 'FibonacciHeap';
        FibonacciHeap.prototype.isFibonacciHeap = true;
        /**
         * Inserts a new data element into the heap. No heap consolidation is
         * performed at this time, the new node is simply inserted into the root
         * list of this heap. Running time: O(1) actual.
         * @memberof FibonacciHeap
         */

        FibonacciHeap.prototype.insert = function (key, value) {
          // create node
          var node = {
            key: key,
            value: value,
            degree: 0 // check we have a node in the minimum

          };

          if (this._minimum) {
            // minimum node
            var minimum = this._minimum; // update left & right of node

            node.left = minimum;
            node.right = minimum.right;
            minimum.right = node;
            node.right.left = node; // update minimum node in heap if needed

            if (smaller(key, minimum.key)) {
              // node has a smaller key, use it as minimum
              this._minimum = node;
            }
          } else {
            // set left & right
            node.left = node;
            node.right = node; // this is the first node

            this._minimum = node;
          } // increment number of nodes in heap


          this._size++; // return node

          return node;
        };
        /**
         * Returns the number of nodes in heap. Running time: O(1) actual.
         * @memberof FibonacciHeap
         */


        FibonacciHeap.prototype.size = function () {
          return this._size;
        };
        /**
         * Removes all elements from this heap.
         * @memberof FibonacciHeap
         */


        FibonacciHeap.prototype.clear = function () {
          this._minimum = null;
          this._size = 0;
        };
        /**
         * Returns true if the heap is empty, otherwise false.
         * @memberof FibonacciHeap
         */


        FibonacciHeap.prototype.isEmpty = function () {
          return this._size === 0;
        };
        /**
         * Extracts the node with minimum key from heap. Amortized running
         * time: O(log n).
         * @memberof FibonacciHeap
         */


        FibonacciHeap.prototype.extractMinimum = function () {
          // node to remove
          var node = this._minimum; // check we have a minimum

          if (node === null) {
            return node;
          } // current minimum


          var minimum = this._minimum; // get number of children

          var numberOfChildren = node.degree; // pointer to the first child

          var x = node.child; // for each child of node do...

          while (numberOfChildren > 0) {
            // store node in right side
            var tempRight = x.right; // remove x from child list

            x.left.right = x.right;
            x.right.left = x.left; // add x to root list of heap

            x.left = minimum;
            x.right = minimum.right;
            minimum.right = x;
            x.right.left = x; // set Parent[x] to null

            x.parent = null;
            x = tempRight;
            numberOfChildren--;
          } // remove node from root list of heap


          node.left.right = node.right;
          node.right.left = node.left; // update minimum

          if (node === node.right) {
            // empty
            minimum = null;
          } else {
            // update minimum
            minimum = node.right; // we need to update the pointer to the root with minimum key

            minimum = _findMinimumNode(minimum, this._size);
          } // decrement size of heap


          this._size--; // update minimum

          this._minimum = minimum; // return node

          return node;
        };
        /**
         * Removes a node from the heap given the reference to the node. The trees
         * in the heap will be consolidated, if necessary. This operation may fail
         * to remove the correct element if there are nodes with key value -Infinity.
         * Running time: O(log n) amortized.
         * @memberof FibonacciHeap
         */


        FibonacciHeap.prototype.remove = function (node) {
          // decrease key value
          this._minimum = _decreaseKey(this._minimum, node, -1); // remove the smallest

          this.extractMinimum();
        };
        /**
         * Decreases the key value for a heap node, given the new value to take on.
         * The structure of the heap may be changed and will not be consolidated.
         * Running time: O(1) amortized.
         * @memberof FibonacciHeap
         */


        function _decreaseKey(minimum, node, key) {
          // set node key
          node.key = key; // get parent node

          var parent = node.parent;

          if (parent && smaller(node.key, parent.key)) {
            // remove node from parent
            _cut(minimum, node, parent); // remove all nodes from parent to the root parent


            _cascadingCut(minimum, parent);
          } // update minimum node if needed


          if (smaller(node.key, minimum.key)) {
            minimum = node;
          } // return minimum


          return minimum;
        }
        /**
         * The reverse of the link operation: removes node from the child list of parent.
         * This method assumes that min is non-null. Running time: O(1).
         * @memberof FibonacciHeap
         */


        function _cut(minimum, node, parent) {
          // remove node from parent children and decrement Degree[parent]
          node.left.right = node.right;
          node.right.left = node.left;
          parent.degree--; // reset y.child if necessary

          if (parent.child === node) {
            parent.child = node.right;
          } // remove child if degree is 0


          if (parent.degree === 0) {
            parent.child = null;
          } // add node to root list of heap


          node.left = minimum;
          node.right = minimum.right;
          minimum.right = node;
          node.right.left = node; // set parent[node] to null

          node.parent = null; // set mark[node] to false

          node.mark = false;
        }
        /**
         * Performs a cascading cut operation. This cuts node from its parent and then
         * does the same for its parent, and so on up the tree.
         * Running time: O(log n); O(1) excluding the recursion.
         * @memberof FibonacciHeap
         */


        function _cascadingCut(minimum, node) {
          // store parent node
          var parent = node.parent; // if there's a parent...

          if (!parent) {
            return;
          } // if node is unmarked, set it marked


          if (!node.mark) {
            node.mark = true;
          } else {
            // it's marked, cut it from parent
            _cut(minimum, node, parent); // cut its parent as well


            _cascadingCut(parent);
          }
        }
        /**
         * Make the first node a child of the second one. Running time: O(1) actual.
         * @memberof FibonacciHeap
         */


        var _linkNodes = function _linkNodes(node, parent) {
          // remove node from root list of heap
          node.left.right = node.right;
          node.right.left = node.left; // make node a Child of parent

          node.parent = parent;

          if (!parent.child) {
            parent.child = node;
            node.right = node;
            node.left = node;
          } else {
            node.left = parent.child;
            node.right = parent.child.right;
            parent.child.right = node;
            node.right.left = node;
          } // increase degree[parent]


          parent.degree++; // set mark[node] false

          node.mark = false;
        };

        function _findMinimumNode(minimum, size) {
          // to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
          var arraySize = Math.floor(Math.log(size) * oneOverLogPhi) + 1; // create list with initial capacity

          var array = new Array(arraySize); // find the number of root nodes.

          var numRoots = 0;
          var x = minimum;

          if (x) {
            numRoots++;
            x = x.right;

            while (x !== minimum) {
              numRoots++;
              x = x.right;
            }
          } // vars


          var y; // For each node in root list do...

          while (numRoots > 0) {
            // access this node's degree..
            var d = x.degree; // get next node

            var next = x.right; // check if there is a node already in array with the same degree

            while (true) {
              // get node with the same degree is any
              y = array[d];

              if (!y) {
                break;
              } // make one node with the same degree a child of the other, do this based on the key value.


              if (larger(x.key, y.key)) {
                var temp = y;
                y = x;
                x = temp;
              } // make y a child of x


              _linkNodes(y, x); // we have handled this degree, go to next one.


              array[d] = null;
              d++;
            } // save this node for later when we might encounter another of the same degree.


            array[d] = x; // move forward through list.

            x = next;
            numRoots--;
          } // Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].


          minimum = null; // loop nodes in array

          for (var i = 0; i < arraySize; i++) {
            // get current node
            y = array[i];

            if (!y) {
              continue;
            } // check if we have a linked list


            if (minimum) {
              // First remove node from root list.
              y.left.right = y.right;
              y.right.left = y.left; // now add to root list, again.

              y.left = minimum;
              y.right = minimum.right;
              minimum.right = y;
              y.right.left = y; // check if this is a new min.

              if (smaller(y.key, minimum.key)) {
                minimum = y;
              }
            } else {
              minimum = y;
            }
          }

          return minimum;
        }

        return FibonacciHeap;
      }

      exports.name = 'FibonacciHeap';
      exports.path = 'type';
      exports.factory = factory;
      /***/
    },
    /* 760 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load) {
        var add = load(__webpack_require__(170));
        var equalScalar = load(__webpack_require__(125));
        /**
         * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array
         * of the vector elements and an ordered list of non-zero elements.
         */

        function Spa() {
          if (!(this instanceof Spa)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          } // allocate vector, TODO use typed arrays


          this._values = [];
          this._heap = new type.FibonacciHeap();
        }
        /**
         * Attach type information
         */


        Spa.prototype.type = 'Spa';
        Spa.prototype.isSpa = true;
        /**
         * Set the value for index i.
         *
         * @param {number} i                       The index
         * @param {number | BigNumber | Complex}   The value at index i
         */

        Spa.prototype.set = function (i, v) {
          // check we have a value @ i
          if (!this._values[i]) {
            // insert in heap
            var node = this._heap.insert(i, v); // set the value @ i


            this._values[i] = node;
          } else {
            // update the value @ i
            this._values[i].value = v;
          }
        };

        Spa.prototype.get = function (i) {
          var node = this._values[i];

          if (node) {
            return node.value;
          }

          return 0;
        };

        Spa.prototype.accumulate = function (i, v) {
          // node @ i
          var node = this._values[i];

          if (!node) {
            // insert in heap
            node = this._heap.insert(i, v); // initialize value

            this._values[i] = node;
          } else {
            // accumulate value
            node.value = add(node.value, v);
          }
        };

        Spa.prototype.forEach = function (from, to, callback) {
          // references
          var heap = this._heap;
          var values = this._values; // nodes

          var nodes = []; // node with minimum key, save it

          var node = heap.extractMinimum();

          if (node) {
            nodes.push(node);
          } // extract nodes from heap (ordered)


          while (node && node.key <= to) {
            // check it is in range
            if (node.key >= from) {
              // check value is not zero
              if (!equalScalar(node.value, 0)) {
                // invoke callback
                callback(node.key, node.value, this);
              }
            } // extract next node, save it


            node = heap.extractMinimum();

            if (node) {
              nodes.push(node);
            }
          } // reinsert all nodes in heap


          for (var i = 0; i < nodes.length; i++) {
            // current node
            var n = nodes[i]; // insert node in heap

            node = heap.insert(n.key, n.value); // update values

            values[node.key] = node;
          }
        };

        Spa.prototype.swap = function (i, j) {
          // node @ i and j
          var nodei = this._values[i];
          var nodej = this._values[j]; // check we need to insert indeces

          if (!nodei && nodej) {
            // insert in heap
            nodei = this._heap.insert(i, nodej.value); // remove from heap

            this._heap.remove(nodej); // set values


            this._values[i] = nodei;
            this._values[j] = undefined;
          } else if (nodei && !nodej) {
            // insert in heap
            nodej = this._heap.insert(j, nodei.value); // remove from heap

            this._heap.remove(nodei); // set values


            this._values[j] = nodej;
            this._values[i] = undefined;
          } else if (nodei && nodej) {
            // swap values
            var v = nodei.value;
            nodei.value = nodej.value;
            nodej.value = v;
          }
        };

        return Spa;
      }

      exports.name = 'Spa';
      exports.path = 'type';
      exports.factory = factory;
      /***/
    },
    /* 761 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var util = __webpack_require__(151);

      var DimensionError = __webpack_require__(92);

      var array = util.array;
      var object = util.object;
      var string = util.string;
      var number = util.number;
      var isArray = Array.isArray;
      var isNumber = number.isNumber;
      var isInteger = number.isInteger;
      var isString = string.isString;
      var validateIndex = array.validateIndex;

      function factory(type, config, load, typed) {
        var Matrix = load(__webpack_require__(301)); // force loading Matrix (do not use via type.Matrix)

        var equalScalar = load(__webpack_require__(125));
        var getArrayDataType = load(__webpack_require__(228));
        /**
         * Sparse Matrix implementation. This type implements a Compressed Column Storage format
         * for sparse matrices.
         * @class SparseMatrix
         */

        function SparseMatrix(data, datatype) {
          if (!(this instanceof SparseMatrix)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          if (datatype && !isString(datatype)) {
            throw new Error('Invalid datatype: ' + datatype);
          }

          if (type.isMatrix(data)) {
            // create from matrix
            _createFromMatrix(this, data, datatype);
          } else if (data && isArray(data.index) && isArray(data.ptr) && isArray(data.size)) {
            // initialize fields
            this._values = data.values;
            this._index = data.index;
            this._ptr = data.ptr;
            this._size = data.size;
            this._datatype = datatype || data.datatype;
          } else if (isArray(data)) {
            // create from array
            _createFromArray(this, data, datatype);
          } else if (data) {
            // unsupported type
            throw new TypeError('Unsupported type of data (' + util.types.type(data) + ')');
          } else {
            // nothing provided
            this._values = [];
            this._index = [];
            this._ptr = [0];
            this._size = [0, 0];
            this._datatype = datatype;
          }
        }

        function _createFromMatrix(matrix, source, datatype) {
          // check matrix type
          if (source.type === 'SparseMatrix') {
            // clone arrays
            matrix._values = source._values ? object.clone(source._values) : undefined;
            matrix._index = object.clone(source._index);
            matrix._ptr = object.clone(source._ptr);
            matrix._size = object.clone(source._size);
            matrix._datatype = datatype || source._datatype;
          } else {
            // build from matrix data
            _createFromArray(matrix, source.valueOf(), datatype || source._datatype);
          }
        }

        function _createFromArray(matrix, data, datatype) {
          // initialize fields
          matrix._values = [];
          matrix._index = [];
          matrix._ptr = [];
          matrix._datatype = datatype; // discover rows & columns, do not use math.size() to avoid looping array twice

          var rows = data.length;
          var columns = 0; // equal signature to use

          var eq = equalScalar; // zero value

          var zero = 0;

          if (isString(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [datatype, datatype]) || equalScalar; // convert 0 to the same datatype

            zero = typed.convert(0, datatype);
          } // check we have rows (empty array)


          if (rows > 0) {
            // column index
            var j = 0;

            do {
              // store pointer to values index
              matrix._ptr.push(matrix._index.length); // loop rows


              for (var i = 0; i < rows; i++) {
                // current row
                var row = data[i]; // check row is an array

                if (isArray(row)) {
                  // update columns if needed (only on first column)
                  if (j === 0 && columns < row.length) {
                    columns = row.length;
                  } // check row has column


                  if (j < row.length) {
                    // value
                    var v = row[j]; // check value != 0

                    if (!eq(v, zero)) {
                      // store value
                      matrix._values.push(v); // index


                      matrix._index.push(i);
                    }
                  }
                } else {
                  // update columns if needed (only on first column)
                  if (j === 0 && columns < 1) {
                    columns = 1;
                  } // check value != 0 (row is a scalar)


                  if (!eq(row, zero)) {
                    // store value
                    matrix._values.push(row); // index


                    matrix._index.push(i);
                  }
                }
              } // increment index


              j++;
            } while (j < columns);
          } // store number of values in ptr


          matrix._ptr.push(matrix._index.length); // size


          matrix._size = [rows, columns];
        }

        SparseMatrix.prototype = new Matrix();
        /**
         * Attach type information
         */

        SparseMatrix.prototype.type = 'SparseMatrix';
        SparseMatrix.prototype.isSparseMatrix = true;
        /**
         * Get the matrix type
         *
         * Usage:
         *    const matrixType = matrix.getDataType()  // retrieves the matrix type
         *
         * @memberOf SparseMatrix
         * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
         */

        SparseMatrix.prototype.getDataType = function () {
          return getArrayDataType(this._values);
        };
        /**
         * Get the storage format used by the matrix.
         *
         * Usage:
         *     const format = matrix.storage()   // retrieve storage format
         *
         * @memberof SparseMatrix
         * @return {string}           The storage format.
         */


        SparseMatrix.prototype.storage = function () {
          return 'sparse';
        };
        /**
         * Get the datatype of the data stored in the matrix.
         *
         * Usage:
         *     const format = matrix.datatype()    // retrieve matrix datatype
         *
         * @memberof SparseMatrix
         * @return {string}           The datatype.
         */


        SparseMatrix.prototype.datatype = function () {
          return this._datatype;
        };
        /**
         * Create a new SparseMatrix
         * @memberof SparseMatrix
         * @param {Array} data
         * @param {string} [datatype]
         */


        SparseMatrix.prototype.create = function (data, datatype) {
          return new SparseMatrix(data, datatype);
        };
        /**
         * Get the matrix density.
         *
         * Usage:
         *     const density = matrix.density()                   // retrieve matrix density
         *
         * @memberof SparseMatrix
         * @return {number}           The matrix density.
         */


        SparseMatrix.prototype.density = function () {
          // rows & columns
          var rows = this._size[0];
          var columns = this._size[1]; // calculate density

          return rows !== 0 && columns !== 0 ? this._index.length / (rows * columns) : 0;
        };
        /**
         * Get a subset of the matrix, or replace a subset of the matrix.
         *
         * Usage:
         *     const subset = matrix.subset(index)               // retrieve subset
         *     const value = matrix.subset(index, replacement)   // replace subset
         *
         * @memberof SparseMatrix
         * @param {Index} index
         * @param {Array | Matrix | *} [replacement]
         * @param {*} [defaultValue=0]      Default value, filled in on new entries when
         *                                  the matrix is resized. If not provided,
         *                                  new matrix elements will be filled with zeros.
         */


        SparseMatrix.prototype.subset = function (index, replacement, defaultValue) {
          // check it is a pattern matrix
          if (!this._values) {
            throw new Error('Cannot invoke subset on a Pattern only matrix');
          } // check arguments


          switch (arguments.length) {
            case 1:
              return _getsubset(this, index);
            // intentional fall through

            case 2:
            case 3:
              return _setsubset(this, index, replacement, defaultValue);

            default:
              throw new SyntaxError('Wrong number of arguments');
          }
        };

        function _getsubset(matrix, idx) {
          // check idx
          if (!type.isIndex(idx)) {
            throw new TypeError('Invalid index');
          }

          var isScalar = idx.isScalar();

          if (isScalar) {
            // return a scalar
            return matrix.get(idx.min());
          } // validate dimensions


          var size = idx.size();

          if (size.length !== matrix._size.length) {
            throw new DimensionError(size.length, matrix._size.length);
          } // vars


          var i, ii, k, kk; // validate if any of the ranges in the index is out of range

          var min = idx.min();
          var max = idx.max();

          for (i = 0, ii = matrix._size.length; i < ii; i++) {
            validateIndex(min[i], matrix._size[i]);
            validateIndex(max[i], matrix._size[i]);
          } // matrix arrays


          var mvalues = matrix._values;
          var mindex = matrix._index;
          var mptr = matrix._ptr; // rows & columns dimensions for result matrix

          var rows = idx.dimension(0);
          var columns = idx.dimension(1); // workspace & permutation vector

          var w = [];
          var pv = []; // loop rows in resulting matrix

          rows.forEach(function (i, r) {
            // update permutation vector
            pv[i] = r[0]; // mark i in workspace

            w[i] = true;
          }); // result matrix arrays

          var values = mvalues ? [] : undefined;
          var index = [];
          var ptr = []; // loop columns in result matrix

          columns.forEach(function (j) {
            // update ptr
            ptr.push(index.length); // loop values in column j

            for (k = mptr[j], kk = mptr[j + 1]; k < kk; k++) {
              // row
              i = mindex[k]; // check row is in result matrix

              if (w[i] === true) {
                // push index
                index.push(pv[i]); // check we need to process values

                if (values) {
                  values.push(mvalues[k]);
                }
              }
            }
          }); // update ptr

          ptr.push(index.length); // return matrix

          return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: size,
            datatype: matrix._datatype
          });
        }

        function _setsubset(matrix, index, submatrix, defaultValue) {
          // check index
          if (!index || index.isIndex !== true) {
            throw new TypeError('Invalid index');
          } // get index size and check whether the index contains a single value


          var iSize = index.size();
          var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed

          var sSize;

          if (type.isMatrix(submatrix)) {
            // submatrix size
            sSize = submatrix.size(); // use array representation

            submatrix = submatrix.toArray();
          } else {
            // get submatrix size (array, scalar)
            sSize = array.size(submatrix);
          } // check index is a scalar


          if (isScalar) {
            // verify submatrix is a scalar
            if (sSize.length !== 0) {
              throw new TypeError('Scalar expected');
            } // set value


            matrix.set(index.min(), submatrix, defaultValue);
          } else {
            // validate dimensions, index size must be one or two dimensions
            if (iSize.length !== 1 && iSize.length !== 2) {
              throw new DimensionError(iSize.length, matrix._size.length, '<');
            } // check submatrix and index have the same dimensions


            if (sSize.length < iSize.length) {
              // calculate number of missing outer dimensions
              var i = 0;
              var outer = 0;

              while (iSize[i] === 1 && sSize[i] === 1) {
                i++;
              }

              while (iSize[i] === 1) {
                outer++;
                i++;
              } // unsqueeze both outer and inner dimensions


              submatrix = array.unsqueeze(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size


            if (!object.deepEqual(iSize, sSize)) {
              throw new DimensionError(iSize, sSize, '>');
            } // offsets


            var x0 = index.min()[0];
            var y0 = index.min()[1]; // submatrix rows and columns

            var m = sSize[0];
            var n = sSize[1]; // loop submatrix

            for (var x = 0; x < m; x++) {
              // loop columns
              for (var y = 0; y < n; y++) {
                // value at i, j
                var v = submatrix[x][y]; // invoke set (zero value will remove entry from matrix)

                matrix.set([x + x0, y + y0], v, defaultValue);
              }
            }
          }

          return matrix;
        }
        /**
         * Get a single element from the matrix.
         * @memberof SparseMatrix
         * @param {number[]} index   Zero-based index
         * @return {*} value
         */


        SparseMatrix.prototype.get = function (index) {
          if (!isArray(index)) {
            throw new TypeError('Array expected');
          }

          if (index.length !== this._size.length) {
            throw new DimensionError(index.length, this._size.length);
          } // check it is a pattern matrix


          if (!this._values) {
            throw new Error('Cannot invoke get on a Pattern only matrix');
          } // row and column


          var i = index[0];
          var j = index[1]; // check i, j are valid

          validateIndex(i, this._size[0]);
          validateIndex(j, this._size[1]); // find value index

          var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row


          if (k < this._ptr[j + 1] && this._index[k] === i) {
            return this._values[k];
          }

          return 0;
        };
        /**
         * Replace a single element in the matrix.
         * @memberof SparseMatrix
         * @param {number[]} index   Zero-based index
         * @param {*} v
         * @param {*} [defaultValue]        Default value, filled in on new entries when
         *                                  the matrix is resized. If not provided,
         *                                  new matrix elements will be set to zero.
         * @return {SparseMatrix} self
         */


        SparseMatrix.prototype.set = function (index, v, defaultValue) {
          if (!isArray(index)) {
            throw new TypeError('Array expected');
          }

          if (index.length !== this._size.length) {
            throw new DimensionError(index.length, this._size.length);
          } // check it is a pattern matrix


          if (!this._values) {
            throw new Error('Cannot invoke set on a Pattern only matrix');
          } // row and column


          var i = index[0];
          var j = index[1]; // rows & columns

          var rows = this._size[0];
          var columns = this._size[1]; // equal signature to use

          var eq = equalScalar; // zero value

          var zero = 0;

          if (isString(this._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [this._datatype, this._datatype]) || equalScalar; // convert 0 to the same datatype

            zero = typed.convert(0, this._datatype);
          } // check we need to resize matrix


          if (i > rows - 1 || j > columns - 1) {
            // resize matrix
            _resize(this, Math.max(i + 1, rows), Math.max(j + 1, columns), defaultValue); // update rows & columns


            rows = this._size[0];
            columns = this._size[1];
          } // check i, j are valid


          validateIndex(i, rows);
          validateIndex(j, columns); // find value index

          var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row


          if (k < this._ptr[j + 1] && this._index[k] === i) {
            // check value != 0
            if (!eq(v, zero)) {
              // update value
              this._values[k] = v;
            } else {
              // remove value from matrix
              _remove(k, j, this._values, this._index, this._ptr);
            }
          } else {
            // insert value @ (i, j)
            _insert(k, i, j, v, this._values, this._index, this._ptr);
          }

          return this;
        };

        function _getValueIndex(i, top, bottom, index) {
          // check row is on the bottom side
          if (bottom - top === 0) {
            return bottom;
          } // loop rows [top, bottom[


          for (var r = top; r < bottom; r++) {
            // check we found value index
            if (index[r] === i) {
              return r;
            }
          } // we did not find row


          return top;
        }

        function _remove(k, j, values, index, ptr) {
          // remove value @ k
          values.splice(k, 1);
          index.splice(k, 1); // update pointers

          for (var x = j + 1; x < ptr.length; x++) {
            ptr[x]--;
          }
        }

        function _insert(k, i, j, v, values, index, ptr) {
          // insert value
          values.splice(k, 0, v); // update row for k

          index.splice(k, 0, i); // update column pointers

          for (var x = j + 1; x < ptr.length; x++) {
            ptr[x]++;
          }
        }
        /**
         * Resize the matrix to the given size. Returns a copy of the matrix when
         * `copy=true`, otherwise return the matrix itself (resize in place).
         *
         * @memberof SparseMatrix
         * @param {number[]} size           The new size the matrix should have.
         * @param {*} [defaultValue=0]      Default value, filled in on new entries.
         *                                  If not provided, the matrix elements will
         *                                  be filled with zeros.
         * @param {boolean} [copy]          Return a resized copy of the matrix
         *
         * @return {Matrix}                 The resized matrix
         */


        SparseMatrix.prototype.resize = function (size, defaultValue, copy) {
          // validate arguments
          if (!isArray(size)) {
            throw new TypeError('Array expected');
          }

          if (size.length !== 2) {
            throw new Error('Only two dimensions matrix are supported');
          } // check sizes


          size.forEach(function (value) {
            if (!number.isNumber(value) || !number.isInteger(value) || value < 0) {
              throw new TypeError('Invalid size, must contain positive integers ' + '(size: ' + string.format(size) + ')');
            }
          }); // matrix to resize

          var m = copy ? this.clone() : this; // resize matrix

          return _resize(m, size[0], size[1], defaultValue);
        };

        function _resize(matrix, rows, columns, defaultValue) {
          // value to insert at the time of growing matrix
          var value = defaultValue || 0; // equal signature to use

          var eq = equalScalar; // zero value

          var zero = 0;

          if (isString(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [matrix._datatype, matrix._datatype]) || equalScalar; // convert 0 to the same datatype

            zero = typed.convert(0, matrix._datatype); // convert value to the same datatype

            value = typed.convert(value, matrix._datatype);
          } // should we insert the value?


          var ins = !eq(value, zero); // old columns and rows

          var r = matrix._size[0];
          var c = matrix._size[1];
          var i, j, k; // check we need to increase columns

          if (columns > c) {
            // loop new columns
            for (j = c; j < columns; j++) {
              // update matrix._ptr for current column
              matrix._ptr[j] = matrix._values.length; // check we need to insert matrix._values

              if (ins) {
                // loop rows
                for (i = 0; i < r; i++) {
                  // add new matrix._values
                  matrix._values.push(value); // update matrix._index


                  matrix._index.push(i);
                }
              }
            } // store number of matrix._values in matrix._ptr


            matrix._ptr[columns] = matrix._values.length;
          } else if (columns < c) {
            // truncate matrix._ptr
            matrix._ptr.splice(columns + 1, c - columns); // truncate matrix._values and matrix._index


            matrix._values.splice(matrix._ptr[columns], matrix._values.length);

            matrix._index.splice(matrix._ptr[columns], matrix._index.length);
          } // update columns


          c = columns; // check we need to increase rows

          if (rows > r) {
            // check we have to insert values
            if (ins) {
              // inserts
              var n = 0; // loop columns

              for (j = 0; j < c; j++) {
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._ptr[j] + n; // where to insert matrix._values

                k = matrix._ptr[j + 1] + n; // pointer

                var p = 0; // loop new rows, initialize pointer

                for (i = r; i < rows; i++, p++) {
                  // add value
                  matrix._values.splice(k + p, 0, value); // update matrix._index


                  matrix._index.splice(k + p, 0, i); // increment inserts


                  n++;
                }
              } // store number of matrix._values in matrix._ptr


              matrix._ptr[c] = matrix._values.length;
            }
          } else if (rows < r) {
            // deletes
            var d = 0; // loop columns

            for (j = 0; j < c; j++) {
              // update matrix._ptr for current column
              matrix._ptr[j] = matrix._ptr[j] - d; // where matrix._values start for next column

              var k0 = matrix._ptr[j];
              var k1 = matrix._ptr[j + 1] - d; // loop matrix._index

              for (k = k0; k < k1; k++) {
                // row
                i = matrix._index[k]; // check we need to delete value and matrix._index

                if (i > rows - 1) {
                  // remove value
                  matrix._values.splice(k, 1); // remove item from matrix._index


                  matrix._index.splice(k, 1); // increase deletes


                  d++;
                }
              }
            } // update matrix._ptr for current column


            matrix._ptr[j] = matrix._values.length;
          } // update matrix._size


          matrix._size[0] = rows;
          matrix._size[1] = columns; // return matrix

          return matrix;
        }
        /**
         * Reshape the matrix to the given size. Returns a copy of the matrix when
         * `copy=true`, otherwise return the matrix itself (reshape in place).
         *
         * NOTE: This might be better suited to copy by default, instead of modifying
         *       in place. For now, it operates in place to remain consistent with
         *       resize().
         *
         * @memberof SparseMatrix
         * @param {number[]} size           The new size the matrix should have.
         * @param {boolean} [copy]          Return a reshaped copy of the matrix
         *
         * @return {Matrix}                 The reshaped matrix
         */


        SparseMatrix.prototype.reshape = function (size, copy) {
          // validate arguments
          if (!isArray(size)) {
            throw new TypeError('Array expected');
          }

          if (size.length !== 2) {
            throw new Error('Sparse matrices can only be reshaped in two dimensions');
          } // check sizes


          size.forEach(function (value) {
            if (!number.isNumber(value) || !number.isInteger(value) || value < 0) {
              throw new TypeError('Invalid size, must contain positive integers ' + '(size: ' + string.format(size) + ')');
            }
          }); // m * n must not change

          if (this._size[0] * this._size[1] !== size[0] * size[1]) {
            throw new Error('Reshaping sparse matrix will result in the wrong number of elements');
          } // matrix to reshape


          var m = copy ? this.clone() : this; // return unchanged if the same shape

          if (this._size[0] === size[0] && this._size[1] === size[1]) {
            return m;
          } // Convert to COO format (generate a column index)


          var colIndex = [];

          for (var i = 0; i < m._ptr.length; i++) {
            for (var j = 0; j < m._ptr[i + 1] - m._ptr[i]; j++) {
              colIndex.push(i);
            }
          } // Clone the values array


          var values = m._values.slice(); // Clone the row index array


          var rowIndex = m._index.slice(); // Transform the (row, column) indices


          for (var _i = 0; _i < m._index.length; _i++) {
            var r1 = rowIndex[_i];
            var c1 = colIndex[_i];
            var flat = r1 * m._size[1] + c1;
            colIndex[_i] = flat % size[1];
            rowIndex[_i] = Math.floor(flat / size[1]);
          } // Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
          // in column-major order, so we have to reorder the value array now. One option is to use a multisort,
          // sorting several arrays based on some other array.
          // OR, we could easily just:
          // 1. Remove all values from the matrix


          m._values.length = 0;
          m._index.length = 0;
          m._ptr.length = size[1] + 1;
          m._size = size.slice();

          for (var _i2 = 0; _i2 < m._ptr.length; _i2++) {
            m._ptr[_i2] = 0;
          } // 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
          // This step is probably the most time-consuming


          for (var h = 0; h < values.length; h++) {
            var _i3 = rowIndex[h];
            var _j = colIndex[h];
            var v = values[h];

            var k = _getValueIndex(_i3, m._ptr[_j], m._ptr[_j + 1], m._index);

            _insert(k, _i3, _j, v, m._values, m._index, m._ptr);
          } // The value indices are inserted out of order, but apparently that's... still OK?


          return m;
        };
        /**
         * Create a clone of the matrix
         * @memberof SparseMatrix
         * @return {SparseMatrix} clone
         */


        SparseMatrix.prototype.clone = function () {
          var m = new SparseMatrix({
            values: this._values ? object.clone(this._values) : undefined,
            index: object.clone(this._index),
            ptr: object.clone(this._ptr),
            size: object.clone(this._size),
            datatype: this._datatype
          });
          return m;
        };
        /**
         * Retrieve the size of the matrix.
         * @memberof SparseMatrix
         * @returns {number[]} size
         */


        SparseMatrix.prototype.size = function () {
          return this._size.slice(0); // copy the Array
        };
        /**
         * Create a new matrix with the results of the callback function executed on
         * each entry of the matrix.
         * @memberof SparseMatrix
         * @param {Function} callback   The callback function is invoked with three
         *                              parameters: the value of the element, the index
         *                              of the element, and the Matrix being traversed.
         * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
         *
         * @return {SparseMatrix} matrix
         */


        SparseMatrix.prototype.map = function (callback, skipZeros) {
          // check it is a pattern matrix
          if (!this._values) {
            throw new Error('Cannot invoke map on a Pattern only matrix');
          } // matrix instance


          var me = this; // rows and columns

          var rows = this._size[0];
          var columns = this._size[1]; // invoke callback

          var invoke = function invoke(v, i, j) {
            // invoke callback
            return callback(v, [i, j], me);
          }; // invoke _map


          return _map(this, 0, rows - 1, 0, columns - 1, invoke, skipZeros);
        };
        /**
         * Create a new matrix with the results of the callback function executed on the interval
         * [minRow..maxRow, minColumn..maxColumn].
         */


        function _map(matrix, minRow, maxRow, minColumn, maxColumn, callback, skipZeros) {
          // result arrays
          var values = [];
          var index = [];
          var ptr = []; // equal signature to use

          var eq = equalScalar; // zero value

          var zero = 0;

          if (isString(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [matrix._datatype, matrix._datatype]) || equalScalar; // convert 0 to the same datatype

            zero = typed.convert(0, matrix._datatype);
          } // invoke callback


          var invoke = function invoke(v, x, y) {
            // invoke callback
            v = callback(v, x, y); // check value != 0

            if (!eq(v, zero)) {
              // store value
              values.push(v); // index

              index.push(x);
            }
          }; // loop columns


          for (var j = minColumn; j <= maxColumn; j++) {
            // store pointer to values index
            ptr.push(values.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]

            var k0 = matrix._ptr[j];
            var k1 = matrix._ptr[j + 1];

            if (skipZeros) {
              // loop k within [k0, k1[
              for (var k = k0; k < k1; k++) {
                // row index
                var i = matrix._index[k]; // check i is in range

                if (i >= minRow && i <= maxRow) {
                  // value @ k
                  invoke(matrix._values[k], i - minRow, j - minColumn);
                }
              }
            } else {
              // create a cache holding all defined values
              var _values = {};

              for (var _k = k0; _k < k1; _k++) {
                var _i4 = matrix._index[_k];
                _values[_i4] = matrix._values[_k];
              } // loop over all rows (indexes can be unordered so we can't use that),
              // and either read the value or zero


              for (var _i5 = minRow; _i5 <= maxRow; _i5++) {
                var value = _i5 in _values ? _values[_i5] : 0;
                invoke(value, _i5 - minRow, j - minColumn);
              }
            }
          } // store number of values in ptr


          ptr.push(values.length); // return sparse matrix

          return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [maxRow - minRow + 1, maxColumn - minColumn + 1]
          });
        }
        /**
         * Execute a callback function on each entry of the matrix.
         * @memberof SparseMatrix
         * @param {Function} callback   The callback function is invoked with three
         *                              parameters: the value of the element, the index
         *                              of the element, and the Matrix being traversed.
         * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
         */


        SparseMatrix.prototype.forEach = function (callback, skipZeros) {
          // check it is a pattern matrix
          if (!this._values) {
            throw new Error('Cannot invoke forEach on a Pattern only matrix');
          } // matrix instance


          var me = this; // rows and columns

          var rows = this._size[0];
          var columns = this._size[1]; // loop columns

          for (var j = 0; j < columns; j++) {
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];

            if (skipZeros) {
              // loop k within [k0, k1[
              for (var k = k0; k < k1; k++) {
                // row index
                var i = this._index[k]; // value @ k

                callback(this._values[k], [i, j], me);
              }
            } else {
              // create a cache holding all defined values
              var values = {};

              for (var _k2 = k0; _k2 < k1; _k2++) {
                var _i6 = this._index[_k2];
                values[_i6] = this._values[_k2];
              } // loop over all rows (indexes can be unordered so we can't use that),
              // and either read the value or zero


              for (var _i7 = 0; _i7 < rows; _i7++) {
                var value = _i7 in values ? values[_i7] : 0;
                callback(value, [_i7, j], me);
              }
            }
          }
        };
        /**
         * Create an Array with a copy of the data of the SparseMatrix
         * @memberof SparseMatrix
         * @returns {Array} array
         */


        SparseMatrix.prototype.toArray = function () {
          return _toArray(this._values, this._index, this._ptr, this._size, true);
        };
        /**
         * Get the primitive value of the SparseMatrix: a two dimensions array
         * @memberof SparseMatrix
         * @returns {Array} array
         */


        SparseMatrix.prototype.valueOf = function () {
          return _toArray(this._values, this._index, this._ptr, this._size, false);
        };

        function _toArray(values, index, ptr, size, copy) {
          // rows and columns
          var rows = size[0];
          var columns = size[1]; // result

          var a = []; // vars

          var i, j; // initialize array

          for (i = 0; i < rows; i++) {
            a[i] = [];

            for (j = 0; j < columns; j++) {
              a[i][j] = 0;
            }
          } // loop columns


          for (j = 0; j < columns; j++) {
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // loop k within [k0, k1[

            for (var k = k0; k < k1; k++) {
              // row index
              i = index[k]; // set value (use one for pattern matrix)

              a[i][j] = values ? copy ? object.clone(values[k]) : values[k] : 1;
            }
          }

          return a;
        }
        /**
         * Get a string representation of the matrix, with optional formatting options.
         * @memberof SparseMatrix
         * @param {Object | number | Function} [options]  Formatting options. See
         *                                                lib/utils/number:format for a
         *                                                description of the available
         *                                                options.
         * @returns {string} str
         */


        SparseMatrix.prototype.format = function (options) {
          // rows and columns
          var rows = this._size[0];
          var columns = this._size[1]; // density

          var density = this.density(); // rows & columns

          var str = 'Sparse Matrix [' + string.format(rows, options) + ' x ' + string.format(columns, options) + '] density: ' + string.format(density, options) + '\n'; // loop columns

          for (var j = 0; j < columns; j++) {
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop k within [k0, k1[

            for (var k = k0; k < k1; k++) {
              // row index
              var i = this._index[k]; // append value

              str += '\n    (' + string.format(i, options) + ', ' + string.format(j, options) + ') ==> ' + (this._values ? string.format(this._values[k], options) : 'X');
            }
          }

          return str;
        };
        /**
         * Get a string representation of the matrix
         * @memberof SparseMatrix
         * @returns {string} str
         */


        SparseMatrix.prototype.toString = function () {
          return string.format(this.toArray());
        };
        /**
         * Get a JSON representation of the matrix
         * @memberof SparseMatrix
         * @returns {Object}
         */


        SparseMatrix.prototype.toJSON = function () {
          return {
            mathjs: 'SparseMatrix',
            values: this._values,
            index: this._index,
            ptr: this._ptr,
            size: this._size,
            datatype: this._datatype
          };
        };
        /**
         * Get the kth Matrix diagonal.
         *
         * @memberof SparseMatrix
         * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
         *
         * @returns {Matrix}                     The matrix vector with the diagonal values.
         */


        SparseMatrix.prototype.diagonal = function (k) {
          // validate k if any
          if (k) {
            // convert BigNumber to a number
            if (type.isBigNumber(k)) {
              k = k.toNumber();
            } // is must be an integer


            if (!isNumber(k) || !isInteger(k)) {
              throw new TypeError('The parameter k must be an integer number');
            }
          } else {
            // default value
            k = 0;
          }

          var kSuper = k > 0 ? k : 0;
          var kSub = k < 0 ? -k : 0; // rows & columns

          var rows = this._size[0];
          var columns = this._size[1]; // number diagonal values

          var n = Math.min(rows - kSub, columns - kSuper); // diagonal arrays

          var values = [];
          var index = [];
          var ptr = []; // initial ptr value

          ptr[0] = 0; // loop columns

          for (var j = kSuper; j < columns && values.length < n; j++) {
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop x within [k0, k1[

            for (var x = k0; x < k1; x++) {
              // row index
              var i = this._index[x]; // check row

              if (i === j - kSuper + kSub) {
                // value on this column
                values.push(this._values[x]); // store row

                index[values.length - 1] = i - kSub; // exit loop

                break;
              }
            }
          } // close ptr


          ptr.push(values.length); // return matrix

          return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [n, 1]
          });
        };
        /**
         * Generate a matrix from a JSON object
         * @memberof SparseMatrix
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
         *                       where mathjs is optional
         * @returns {SparseMatrix}
         */


        SparseMatrix.fromJSON = function (json) {
          return new SparseMatrix(json);
        };
        /**
         * Create a diagonal matrix.
         *
         * @memberof SparseMatrix
         * @param {Array} size                       The matrix size.
         * @param {number | Array | Matrix } value   The values for the diagonal.
         * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
         * @param {number} [defaultValue]            The default value for non-diagonal
         * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
         *
         * @returns {SparseMatrix}
         */


        SparseMatrix.diagonal = function (size, value, k, defaultValue, datatype) {
          if (!isArray(size)) {
            throw new TypeError('Array expected, size parameter');
          }

          if (size.length !== 2) {
            throw new Error('Only two dimensions matrix are supported');
          } // map size & validate


          size = size.map(function (s) {
            // check it is a big number
            if (type.isBigNumber(s)) {
              // convert it
              s = s.toNumber();
            } // validate arguments


            if (!isNumber(s) || !isInteger(s) || s < 1) {
              throw new Error('Size values must be positive integers');
            }

            return s;
          }); // validate k if any

          if (k) {
            // convert BigNumber to a number
            if (type.isBigNumber(k)) {
              k = k.toNumber();
            } // is must be an integer


            if (!isNumber(k) || !isInteger(k)) {
              throw new TypeError('The parameter k must be an integer number');
            }
          } else {
            // default value
            k = 0;
          } // equal signature to use


          var eq = equalScalar; // zero value

          var zero = 0;

          if (isString(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [datatype, datatype]) || equalScalar; // convert 0 to the same datatype

            zero = typed.convert(0, datatype);
          }

          var kSuper = k > 0 ? k : 0;
          var kSub = k < 0 ? -k : 0; // rows and columns

          var rows = size[0];
          var columns = size[1]; // number of non-zero items

          var n = Math.min(rows - kSub, columns - kSuper); // value extraction function

          var _value; // check value


          if (isArray(value)) {
            // validate array
            if (value.length !== n) {
              // number of values in array must be n
              throw new Error('Invalid value array length');
            } // define function


            _value = function _value(i) {
              // return value @ i
              return value[i];
            };
          } else if (type.isMatrix(value)) {
            // matrix size
            var ms = value.size(); // validate matrix

            if (ms.length !== 1 || ms[0] !== n) {
              // number of values in array must be n
              throw new Error('Invalid matrix length');
            } // define function


            _value = function _value(i) {
              // return value @ i
              return value.get([i]);
            };
          } else {
            // define function
            _value = function _value() {
              // return value
              return value;
            };
          } // create arrays


          var values = [];
          var index = [];
          var ptr = []; // loop items

          for (var j = 0; j < columns; j++) {
            // number of rows with value
            ptr.push(values.length); // diagonal index

            var i = j - kSuper; // check we need to set diagonal value

            if (i >= 0 && i < n) {
              // get value @ i
              var v = _value(i); // check for zero


              if (!eq(v, zero)) {
                // column
                index.push(i + kSub); // add value

                values.push(v);
              }
            }
          } // last value should be number of values


          ptr.push(values.length); // create SparseMatrix

          return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [rows, columns]
          });
        };
        /**
         * Swap rows i and j in Matrix.
         *
         * @memberof SparseMatrix
         * @param {number} i       Matrix row index 1
         * @param {number} j       Matrix row index 2
         *
         * @return {Matrix}        The matrix reference
         */


        SparseMatrix.prototype.swapRows = function (i, j) {
          // check index
          if (!isNumber(i) || !isInteger(i) || !isNumber(j) || !isInteger(j)) {
            throw new Error('Row index must be positive integers');
          } // check dimensions


          if (this._size.length !== 2) {
            throw new Error('Only two dimensional matrix is supported');
          } // validate index


          validateIndex(i, this._size[0]);
          validateIndex(j, this._size[0]); // swap rows

          SparseMatrix._swapRows(i, j, this._size[1], this._values, this._index, this._ptr); // return current instance


          return this;
        };
        /**
         * Loop rows with data in column j.
         *
         * @param {number} j            Column
         * @param {Array} values        Matrix values
         * @param {Array} index         Matrix row indeces
         * @param {Array} ptr           Matrix column pointers
         * @param {Function} callback   Callback function invoked for every row in column j
         */


        SparseMatrix._forEachRow = function (j, values, index, ptr, callback) {
          // indeces for column j
          var k0 = ptr[j];
          var k1 = ptr[j + 1]; // loop

          for (var k = k0; k < k1; k++) {
            // invoke callback
            callback(index[k], values[k]);
          }
        };
        /**
         * Swap rows x and y in Sparse Matrix data structures.
         *
         * @param {number} x         Matrix row index 1
         * @param {number} y         Matrix row index 2
         * @param {number} columns   Number of columns in matrix
         * @param {Array} values     Matrix values
         * @param {Array} index      Matrix row indeces
         * @param {Array} ptr        Matrix column pointers
         */


        SparseMatrix._swapRows = function (x, y, columns, values, index, ptr) {
          // loop columns
          for (var j = 0; j < columns; j++) {
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // find value index @ x

            var kx = _getValueIndex(x, k0, k1, index); // find value index @ x


            var ky = _getValueIndex(y, k0, k1, index); // check both rows exist in matrix


            if (kx < k1 && ky < k1 && index[kx] === x && index[ky] === y) {
              // swap values (check for pattern matrix)
              if (values) {
                var v = values[kx];
                values[kx] = values[ky];
                values[ky] = v;
              } // next column


              continue;
            } // check x row exist & no y row


            if (kx < k1 && index[kx] === x && (ky >= k1 || index[ky] !== y)) {
              // value @ x (check for pattern matrix)
              var vx = values ? values[kx] : undefined; // insert value @ y

              index.splice(ky, 0, y);

              if (values) {
                values.splice(ky, 0, vx);
              } // remove value @ x (adjust array index if needed)


              index.splice(ky <= kx ? kx + 1 : kx, 1);

              if (values) {
                values.splice(ky <= kx ? kx + 1 : kx, 1);
              } // next column


              continue;
            } // check y row exist & no x row


            if (ky < k1 && index[ky] === y && (kx >= k1 || index[kx] !== x)) {
              // value @ y (check for pattern matrix)
              var vy = values ? values[ky] : undefined; // insert value @ x

              index.splice(kx, 0, x);

              if (values) {
                values.splice(kx, 0, vy);
              } // remove value @ y (adjust array index if needed)


              index.splice(kx <= ky ? ky + 1 : ky, 1);

              if (values) {
                values.splice(kx <= ky ? ky + 1 : ky, 1);
              }
            }
          }
        }; // register this type in the base class Matrix


        type.Matrix._storage.sparse = SparseMatrix;
        return SparseMatrix;
      }

      exports.name = 'SparseMatrix';
      exports.path = 'type';
      exports.factory = factory;
      exports.lazy = false; // no lazy loading, as we alter type.Matrix._storage

      /***/
    },
    /* 762 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      module.exports = [// types
      __webpack_require__(301), __webpack_require__(394), __webpack_require__(761), __webpack_require__(760), __webpack_require__(759), __webpack_require__(758), __webpack_require__(300), __webpack_require__(407), // construction functions
      __webpack_require__(757), __webpack_require__(46), __webpack_require__(756), // util functions
      __webpack_require__(228)];
      /***/
    },
    /* 763 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepForEach = __webpack_require__(398);

      var reduce = __webpack_require__(397);

      var containsCollections = __webpack_require__(396);

      function factory(type, config, load, typed) {
        var smaller = load(__webpack_require__(229));
        var improveErrorMessage = load(__webpack_require__(395));
        /**
         * Compute the minimum value of a matrix or a  list of values.
         * In case of a multi dimensional array, the minimum of the flattened array
         * will be calculated. When `dim` is provided, the minimum over the selected
         * dimension will be calculated. Parameter `dim` is zero-based.
         *
         * Syntax:
         *
         *     math.min(a, b, c, ...)
         *     math.min(A)
         *     math.min(A, dim)
         *
         * Examples:
         *
         *     math.min(2, 1, 4, 3)                  // returns 1
         *     math.min([2, 1, 4, 3])                // returns 1
         *
         *     // minimum over a specified dimension (zero-based)
         *     math.min([[2, 5], [4, 3], [1, 7]], 0) // returns [1, 3]
         *     math.min([[2, 5], [4, 3], [1, 7]], 1) // returns [2, 3, 1]
         *
         *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
         *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
         *
         * See also:
         *
         *    mean, median, max, prod, std, sum, var
         *
         * @param {... *} args  A single matrix or or multiple scalar values
         * @return {*} The minimum value
         */

        var min = typed('min', {
          // min([a, b, c, d, ...])
          'Array | Matrix': _min,
          // min([a, b, c, d, ...], dim)
          'Array | Matrix, number | BigNumber': function ArrayMatrixNumberBigNumber(array, dim) {
            return reduce(array, dim.valueOf(), _smallest);
          },
          // min(a, b, c, d, ...)
          '...': function _(args) {
            if (containsCollections(args)) {
              throw new TypeError('Scalar values expected in function min');
            }

            return _min(args);
          }
        });
        min.toTex = "\\min\\left(${args}\\right)";
        return min;
        /**
         * Return the smallest of two values
         * @param {*} x
         * @param {*} y
         * @returns {*} Returns x when x is smallest, or y when y is smallest
         * @private
         */

        function _smallest(x, y) {
          try {
            return smaller(x, y) ? x : y;
          } catch (err) {
            throw improveErrorMessage(err, 'min', y);
          }
        }
        /**
         * Recursively calculate the minimum value in an n-dimensional array
         * @param {Array} array
         * @return {number} min
         * @private
         */


        function _min(array) {
          var min;
          deepForEach(array, function (value) {
            try {
              if (isNaN(value) && typeof value === 'number') {
                min = NaN;
              } else if (min === undefined || smaller(value, min)) {
                min = value;
              }
            } catch (err) {
              throw improveErrorMessage(err, 'min', value);
            }
          });

          if (min === undefined) {
            throw new Error('Cannot calculate min of an empty array');
          }

          return min;
        }
      }

      exports.name = 'min';
      exports.factory = factory;
      /***/
    },
    /* 764 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var isMatrix = __webpack_require__(199);
      /**
       * Test whether a value is a collection: an Array or Matrix
       * @param {*} x
       * @returns {boolean} isCollection
       */


      module.exports = function isCollection(x) {
        return Array.isArray(x) || isMatrix(x);
      };
      /***/

    },
    /* 765 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        var latex = __webpack_require__(72);
        /**
         * Unary plus operation.
         * Boolean values and strings will be converted to a number, numeric values will be returned as is.
         *
         * For matrices, the function is evaluated element wise.
         *
         * Syntax:
         *
         *    math.unaryPlus(x)
         *
         * Examples:
         *
         *    math.unaryPlus(3.5)      // returns 3.5
         *    math.unaryPlus(1)     // returns 1
         *
         * See also:
         *
         *    unaryMinus, add, subtract
         *
         * @param  {number | BigNumber | Fraction | string | Complex | Unit | Array | Matrix} x
         *            Input value
         * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
         *            Returns the input value when numeric, converts to a number when input is non-numeric.
         */


        var unaryPlus = typed('unaryPlus', {
          'number': function number(x) {
            return x;
          },
          'Complex': function Complex(x) {
            return x; // complex numbers are immutable
          },
          'BigNumber': function BigNumber(x) {
            return x; // bignumbers are immutable
          },
          'Fraction': function Fraction(x) {
            return x; // fractions are immutable
          },
          'Unit': function Unit(x) {
            return x.clone();
          },
          'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryPlus(0) = 0
            return deepMap(x, unaryPlus, true);
          },
          'boolean | string': function booleanString(x) {
            // convert to a number or bignumber
            return config.number === 'BigNumber' ? new type.BigNumber(+x) : +x;
          }
        });
        unaryPlus.toTex = {
          1: "".concat(latex.operators['unaryPlus'], "\\left(${args[0]}\\right)")
        };
        return unaryPlus;
      }

      exports.name = 'unaryPlus';
      exports.factory = factory;
      /***/
    },
    /* 766 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var isInteger = __webpack_require__(67).isInteger;

      var size = __webpack_require__(48).size;

      function factory(type, config, load, typed) {
        var latex = __webpack_require__(72);

        var identity = load(__webpack_require__(193));
        var multiply = load(__webpack_require__(124));
        var matrix = load(__webpack_require__(46));
        var fraction = load(__webpack_require__(411));
        var number = load(__webpack_require__(306));
        /**
         * Calculates the power of x to y, `x ^ y`.
         * Matrix exponentiation is supported for square matrices `x`, and positive
         * integer exponents `y`.
         *
         * For cubic roots of negative numbers, the function returns the principal
         * root by default. In order to let the function return the real root,
         * math.js can be configured with `math.config({predictable: true})`.
         * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
         *
         * Syntax:
         *
         *    math.pow(x, y)
         *
         * Examples:
         *
         *    math.pow(2, 3)               // returns number 8
         *
         *    const a = math.complex(2, 3)
         *    math.pow(a, 2)                // returns Complex -5 + 12i
         *
         *    const b = [[1, 2], [4, 3]]
         *    math.pow(b, 2)               // returns Array [[9, 8], [16, 17]]
         *
         * See also:
         *
         *    multiply, sqrt, cbrt, nthRoot
         *
         * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
         * @param  {number | BigNumber | Complex} y                          The exponent
         * @return {number | BigNumber | Complex | Array | Matrix} The value of `x` to the power `y`
         */

        var pow = typed('pow', {
          'number, number': _pow,
          'Complex, Complex': function ComplexComplex(x, y) {
            return x.pow(y);
          },
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            if (y.isInteger() || x >= 0 || config.predictable) {
              return x.pow(y);
            } else {
              return new type.Complex(x.toNumber(), 0).pow(y.toNumber(), 0);
            }
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            if (y.d !== 1) {
              if (config.predictable) {
                throw new Error('Function pow does not support non-integer exponents for fractions.');
              } else {
                return _pow(x.valueOf(), y.valueOf());
              }
            } else {
              return x.pow(y);
            }
          },
          'Array, number': _powArray,
          'Array, BigNumber': function ArrayBigNumber(x, y) {
            return _powArray(x, y.toNumber());
          },
          'Matrix, number': _powMatrix,
          'Matrix, BigNumber': function MatrixBigNumber(x, y) {
            return _powMatrix(x, y.toNumber());
          },
          'Unit, number | BigNumber': function UnitNumberBigNumber(x, y) {
            return x.pow(y);
          }
        });
        /**
         * Calculates the power of x to y, x^y, for two numbers.
         * @param {number} x
         * @param {number} y
         * @return {number | Complex} res
         * @private
         */

        function _pow(x, y) {
          // Alternatively could define a 'realmode' config option or something, but
          // 'predictable' will work for now
          if (config.predictable && !isInteger(y) && x < 0) {
            // Check to see if y can be represented as a fraction
            try {
              var yFrac = fraction(y);
              var yNum = number(yFrac);

              if (y === yNum || Math.abs((y - yNum) / y) < 1e-14) {
                if (yFrac.d % 2 === 1) {
                  return (yFrac.n % 2 === 0 ? 1 : -1) * Math.pow(-x, y);
                }
              }
            } catch (ex) {} // fraction() throws an error if y is Infinity, etc.
            // Unable to express y as a fraction, so continue on

          } // x^Infinity === 0 if -1 < x < 1
          // A real number 0 is returned instead of complex(0)


          if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) {
            return 0;
          } // **for predictable mode** x^Infinity === NaN if x < -1
          // N.B. this behavour is different from `Math.pow` which gives
          // (-2)^Infinity === Infinity


          if (config.predictable && (x < -1 && y === Infinity || x > -1 && x < 0 && y === -Infinity)) {
            return NaN;
          }

          if (isInteger(y) || x >= 0 || config.predictable) {
            return Math.pow(x, y);
          } else {
            return new type.Complex(x, 0).pow(y, 0);
          }
        }
        /**
         * Calculate the power of a 2d array
         * @param {Array} x     must be a 2 dimensional, square matrix
         * @param {number} y    a positive, integer value
         * @returns {Array}
         * @private
         */


        function _powArray(x, y) {
          if (!isInteger(y) || y < 0) {
            throw new TypeError('For A^b, b must be a positive integer (value is ' + y + ')');
          } // verify that A is a 2 dimensional square matrix


          var s = size(x);

          if (s.length !== 2) {
            throw new Error('For A^b, A must be 2 dimensional (A has ' + s.length + ' dimensions)');
          }

          if (s[0] !== s[1]) {
            throw new Error('For A^b, A must be square (size is ' + s[0] + 'x' + s[1] + ')');
          }

          var res = identity(s[0]).valueOf();
          var px = x;

          while (y >= 1) {
            if ((y & 1) === 1) {
              res = multiply(px, res);
            }

            y >>= 1;
            px = multiply(px, px);
          }

          return res;
        }
        /**
         * Calculate the power of a 2d matrix
         * @param {Matrix} x     must be a 2 dimensional, square matrix
         * @param {number} y    a positive, integer value
         * @returns {Matrix}
         * @private
         */


        function _powMatrix(x, y) {
          return matrix(_powArray(x.valueOf(), y));
        }

        pow.toTex = {
          2: "\\left(${args[0]}\\right)".concat(latex.operators['pow'], "{${args[1]}}")
        };
        return pow;
      }

      exports.name = 'pow';
      exports.factory = factory;
      /***/
    },
    /* 767 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var DimensionError = __webpack_require__(92);

      function factory(type, config, load, typed) {
        var equalScalar = load(__webpack_require__(125));
        var SparseMatrix = type.SparseMatrix;
        /**
         * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
         * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
         *
         *
         *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
         * C(i,j) = ┤
         *          └  0            ; otherwise
         *
         *
         * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
         * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
         * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
         * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
         *
         * @return {Matrix}                    SparseMatrix (C)
         *
         * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
         */

        var algorithm02 = function algorithm02(denseMatrix, sparseMatrix, callback, inverse) {
          // dense matrix arrays
          var adata = denseMatrix._data;
          var asize = denseMatrix._size;
          var adt = denseMatrix._datatype; // sparse matrix arrays

          var bvalues = sparseMatrix._values;
          var bindex = sparseMatrix._index;
          var bptr = sparseMatrix._ptr;
          var bsize = sparseMatrix._size;
          var bdt = sparseMatrix._datatype; // validate dimensions

          if (asize.length !== bsize.length) {
            throw new DimensionError(asize.length, bsize.length);
          } // check rows & columns


          if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) {
            throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
          } // sparse matrix cannot be a Pattern matrix


          if (!bvalues) {
            throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
          } // rows & columns


          var rows = asize[0];
          var columns = asize[1]; // datatype

          var dt; // equal signature to use

          var eq = equalScalar; // zero value

          var zero = 0; // callback signature to use

          var cf = callback; // process data types

          if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)

            eq = typed.find(equalScalar, [dt, dt]); // convert 0 to the same datatype

            zero = typed.convert(0, dt); // callback

            cf = typed.find(callback, [dt, dt]);
          } // result (SparseMatrix)


          var cvalues = [];
          var cindex = [];
          var cptr = []; // loop columns in b

          for (var j = 0; j < columns; j++) {
            // update cptr
            cptr[j] = cindex.length; // values in column j

            for (var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
              // row
              var i = bindex[k]; // update C(i,j)

              var cij = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // check for nonzero

              if (!eq(cij, zero)) {
                // push i & v
                cindex.push(i);
                cvalues.push(cij);
              }
            }
          } // update cptr


          cptr[columns] = cindex.length; // return sparse matrix

          return new SparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [rows, columns],
            datatype: dt
          });
        };

        return algorithm02;
      }

      exports.name = 'algorithm02';
      exports.factory = factory;
      /***/
    },
    /* 768 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));

        var latex = __webpack_require__(72);

        var algorithm02 = load(__webpack_require__(767));
        var algorithm03 = load(__webpack_require__(152));
        var algorithm05 = load(__webpack_require__(304));
        var algorithm11 = load(__webpack_require__(234));
        var algorithm12 = load(__webpack_require__(150));
        var algorithm13 = load(__webpack_require__(129));
        var algorithm14 = load(__webpack_require__(107));
        /**
         * Calculates the modulus, the remainder of an integer division.
         *
         * For matrices, the function is evaluated element wise.
         *
         * The modulus is defined as:
         *
         *     x - y * floor(x / y)
         *
         * See https://en.wikipedia.org/wiki/Modulo_operation.
         *
         * Syntax:
         *
         *    math.mod(x, y)
         *
         * Examples:
         *
         *    math.mod(8, 3)                // returns 2
         *    math.mod(11, 2)               // returns 1
         *
         *    function isOdd(x) {
         *      return math.mod(x, 2) != 0
         *    }
         *
         *    isOdd(2)                      // returns false
         *    isOdd(3)                      // returns true
         *
         * See also:
         *
         *    divide
         *
         * @param  {number | BigNumber | Fraction | Array | Matrix} x Dividend
         * @param  {number | BigNumber | Fraction | Array | Matrix} y Divisor
         * @return {number | BigNumber | Fraction | Array | Matrix} Returns the remainder of `x` divided by `y`.
         */

        var mod = typed('mod', {
          'number, number': _mod,
          'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return y.isZero() ? x : x.mod(y);
          },
          'Fraction, Fraction': function FractionFraction(x, y) {
            return x.mod(y);
          },
          'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, mod, false);
          },
          'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, mod, true);
          },
          'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, mod, false);
          },
          'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, mod);
          },
          'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return mod(matrix(x), matrix(y)).valueOf();
          },
          'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return mod(matrix(x), y);
          },
          'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return mod(x, matrix(y));
          },
          'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm11(x, y, mod, false);
          },
          'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, mod, false);
          },
          'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, mod, true);
          },
          'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, mod, true);
          },
          'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, mod, false).valueOf();
          },
          'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, mod, true).valueOf();
          }
        });
        mod.toTex = {
          2: "\\left(${args[0]}".concat(latex.operators['mod'], "${args[1]}\\right)")
        };
        return mod;
        /**
         * Calculate the modulus of two numbers
         * @param {number} x
         * @param {number} y
         * @returns {number} res
         * @private
         */

        function _mod(x, y) {
          if (y > 0) {
            // We don't use JavaScript's % operator here as this doesn't work
            // correctly for x < 0 and x === 0
            // see https://en.wikipedia.org/wiki/Modulo_operation
            return x - y * Math.floor(x / y);
          } else if (y === 0) {
            return x;
          } else {
            // y < 0
            // TODO: implement mod for a negative divisor
            throw new Error('Cannot calculate mod for a negative divisor');
          }
        }
      }

      exports.name = 'mod';
      exports.factory = factory;
      /***/
    },
    /* 769 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      var nearlyEqual = __webpack_require__(67).nearlyEqual;

      var bigNearlyEqual = __webpack_require__(130);

      function factory(type, config, load, typed) {
        var round = load(__webpack_require__(402));
        /**
         * Round a value towards minus infinity.
         * For matrices, the function is evaluated element wise.
         *
         * Syntax:
         *
         *    math.floor(x)
         *
         * Examples:
         *
         *    math.floor(3.2)              // returns number 3
         *    math.floor(3.8)              // returns number 3
         *    math.floor(-4.2)             // returns number -5
         *    math.floor(-4.7)             // returns number -5
         *
         *    const c = math.complex(3.2, -2.7)
         *    math.floor(c)                // returns Complex 3 - 3i
         *
         *    math.floor([3.2, 3.8, -4.7]) // returns Array [3, 3, -5]
         *
         * See also:
         *
         *    ceil, fix, round
         *
         * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
         * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
         */

        var floor = typed('floor', {
          'number': function number(x) {
            if (nearlyEqual(x, round(x), config.epsilon)) {
              return round(x);
            } else {
              return Math.floor(x);
            }
          },
          'Complex': function Complex(x) {
            return x.floor();
          },
          'BigNumber': function BigNumber(x) {
            if (bigNearlyEqual(x, round(x), config.epsilon)) {
              return round(x);
            } else {
              return x.floor();
            }
          },
          'Fraction': function Fraction(x) {
            return x.floor();
          },
          'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since floor(0) = 0
            return deepMap(x, floor, true);
          }
        });
        floor.toTex = {
          1: "\\left\\lfloor${args[0]}\\right\\rfloor"
        };
        return floor;
      }

      exports.name = 'floor';
      exports.factory = factory;
      /***/
    },
    /* 770 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        /**
         * Compute the cube of a value, `x * x * x`.
         * For matrices, the function is evaluated element wise.
         *
         * Syntax:
         *
         *    math.cube(x)
         *
         * Examples:
         *
         *    math.cube(2)            // returns number 8
         *    math.pow(2, 3)          // returns number 8
         *    math.cube(4)            // returns number 64
         *    4 * 4 * 4               // returns number 64
         *
         *    math.cube([1, 2, 3, 4]) // returns Array [1, 8, 27, 64]
         *
         * See also:
         *
         *    multiply, square, pow, cbrt
         *
         * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x  Number for which to calculate the cube
         * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} Cube of x
         */
        var cube = typed('cube', {
          'number': function number(x) {
            return x * x * x;
          },
          'Complex': function Complex(x) {
            return x.mul(x).mul(x); // Is faster than pow(x, 3)
          },
          'BigNumber': function BigNumber(x) {
            return x.times(x).times(x);
          },
          'Fraction': function Fraction(x) {
            return x.pow(3); // Is faster than mul()mul()mul()
          },
          'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since cube(0) = 0
            return deepMap(x, cube, true);
          },
          'Unit': function Unit(x) {
            return x.pow(3);
          }
        });
        cube.toTex = {
          1: "\\left(${args[0]}\\right)^3"
        };
        return cube;
      }

      exports.name = 'cube';
      exports.factory = factory;
      /***/
    },
    /* 771 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      var nearlyEqual = __webpack_require__(67).nearlyEqual;

      var bigNearlyEqual = __webpack_require__(130);

      function factory(type, config, load, typed) {
        var round = load(__webpack_require__(402));
        /**
         * Round a value towards plus infinity
         * If `x` is complex, both real and imaginary part are rounded towards plus infinity.
         * For matrices, the function is evaluated element wise.
         *
         * Syntax:
         *
         *    math.ceil(x)
         *
         * Examples:
         *
         *    math.ceil(3.2)               // returns number 4
         *    math.ceil(3.8)               // returns number 4
         *    math.ceil(-4.2)              // returns number -4
         *    math.ceil(-4.7)              // returns number -4
         *
         *    const c = math.complex(3.2, -2.7)
         *    math.ceil(c)                 // returns Complex 4 - 2i
         *
         *    math.ceil([3.2, 3.8, -4.7])  // returns Array [4, 4, -4]
         *
         * See also:
         *
         *    floor, fix, round
         *
         * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
         * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
         */

        var ceil = typed('ceil', {
          'number': function number(x) {
            if (nearlyEqual(x, round(x), config.epsilon)) {
              return round(x);
            } else {
              return Math.ceil(x);
            }
          },
          'Complex': function Complex(x) {
            return x.ceil();
          },
          'BigNumber': function BigNumber(x) {
            if (bigNearlyEqual(x, round(x), config.epsilon)) {
              return round(x);
            } else {
              return x.ceil();
            }
          },
          'Fraction': function Fraction(x) {
            return x.ceil();
          },
          'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since ceil(0) = 0
            return deepMap(x, ceil, true);
          }
        });
        ceil.toTex = {
          1: "\\left\\lceil${args[0]}\\right\\rceil"
        };
        return ceil;
      }

      exports.name = 'ceil';
      exports.factory = factory;
      /***/
    },
    /* 772 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var util = __webpack_require__(151);

      var object = util.object;

      function factory(type, config, load, typed) {
        var matrix = load(__webpack_require__(46));
        var abs = load(__webpack_require__(194));
        var addScalar = load(__webpack_require__(197));
        var divideScalar = load(__webpack_require__(302));
        var multiplyScalar = load(__webpack_require__(303));
        var subtract = load(__webpack_require__(196));
        var larger = load(__webpack_require__(231));
        var equalScalar = load(__webpack_require__(125));
        var unaryMinus = load(__webpack_require__(195));
        var SparseMatrix = type.SparseMatrix;
        var DenseMatrix = type.DenseMatrix;
        var Spa = type.Spa;
        /**
         * Calculate the Matrix LU decomposition with partial pivoting. Matrix `A` is decomposed in two matrices (`L`, `U`) and a
         * row permutation vector `p` where `A[p,:] = L * U`
         *
         * Syntax:
         *
         *    math.lup(A)
         *
         * Example:
         *
         *    const m = [[2, 1], [1, 4]]
         *    const r = math.lup(m)
         *    // r = {
         *    //   L: [[1, 0], [0.5, 1]],
         *    //   U: [[2, 1], [0, 3.5]],
         *    //   P: [0, 1]
         *    // }
         *
         * See also:
         *
         *    slu, lsolve, lusolve, usolve
         *
         * @param {Matrix | Array} A    A two dimensional matrix or array for which to get the LUP decomposition.
         *
         * @return {{L: Array | Matrix, U: Array | Matrix, P: Array.<number>}} The lower triangular matrix, the upper triangular matrix and the permutation matrix.
         */

        var lup = typed('lup', {
          'DenseMatrix': function DenseMatrix(m) {
            return _denseLUP(m);
          },
          'SparseMatrix': function SparseMatrix(m) {
            return _sparseLUP(m);
          },
          'Array': function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation

            var r = _denseLUP(m); // result


            return {
              L: r.L.valueOf(),
              U: r.U.valueOf(),
              p: r.p
            };
          }
        });

        function _denseLUP(m) {
          // rows & columns
          var rows = m._size[0];
          var columns = m._size[1]; // minimum rows and columns

          var n = Math.min(rows, columns); // matrix array, clone original data

          var data = object.clone(m._data); // l matrix arrays

          var ldata = [];
          var lsize = [rows, n]; // u matrix arrays

          var udata = [];
          var usize = [n, columns]; // vars

          var i, j, k; // permutation vector

          var p = [];

          for (i = 0; i < rows; i++) {
            p[i] = i;
          } // loop columns


          for (j = 0; j < columns; j++) {
            // skip first column in upper triangular matrix
            if (j > 0) {
              // loop rows
              for (i = 0; i < rows; i++) {
                // min i,j
                var min = Math.min(i, j); // v[i, j]

                var s = 0; // loop up to min

                for (k = 0; k < min; k++) {
                  // s = l[i, k] - data[k, j]
                  s = addScalar(s, multiplyScalar(data[i][k], data[k][j]));
                }

                data[i][j] = subtract(data[i][j], s);
              }
            } // row with larger value in cvector, row >= j


            var pi = j;
            var pabsv = 0;
            var vjj = 0; // loop rows

            for (i = j; i < rows; i++) {
              // data @ i, j
              var v = data[i][j]; // absolute value

              var absv = abs(v); // value is greater than pivote value

              if (larger(absv, pabsv)) {
                // store row
                pi = i; // update max value

                pabsv = absv; // value @ [j, j]

                vjj = v;
              }
            } // swap rows (j <-> pi)


            if (j !== pi) {
              // swap values j <-> pi in p
              p[j] = [p[pi], p[pi] = p[j]][0]; // swap j <-> pi in data

              DenseMatrix._swapRows(j, pi, data);
            } // check column is in lower triangular matrix


            if (j < rows) {
              // loop rows (lower triangular matrix)
              for (i = j + 1; i < rows; i++) {
                // value @ i, j
                var vij = data[i][j];

                if (!equalScalar(vij, 0)) {
                  // update data
                  data[i][j] = divideScalar(data[i][j], vjj);
                }
              }
            }
          } // loop columns


          for (j = 0; j < columns; j++) {
            // loop rows
            for (i = 0; i < rows; i++) {
              // initialize row in arrays
              if (j === 0) {
                // check row exists in upper triangular matrix
                if (i < columns) {
                  // U
                  udata[i] = [];
                } // L


                ldata[i] = [];
              } // check we are in the upper triangular matrix


              if (i < j) {
                // check row exists in upper triangular matrix
                if (i < columns) {
                  // U
                  udata[i][j] = data[i][j];
                } // check column exists in lower triangular matrix


                if (j < rows) {
                  // L
                  ldata[i][j] = 0;
                }

                continue;
              } // diagonal value


              if (i === j) {
                // check row exists in upper triangular matrix
                if (i < columns) {
                  // U
                  udata[i][j] = data[i][j];
                } // check column exists in lower triangular matrix


                if (j < rows) {
                  // L
                  ldata[i][j] = 1;
                }

                continue;
              } // check row exists in upper triangular matrix


              if (i < columns) {
                // U
                udata[i][j] = 0;
              } // check column exists in lower triangular matrix


              if (j < rows) {
                // L
                ldata[i][j] = data[i][j];
              }
            }
          } // l matrix


          var l = new DenseMatrix({
            data: ldata,
            size: lsize
          }); // u matrix

          var u = new DenseMatrix({
            data: udata,
            size: usize
          }); // p vector

          var pv = [];

          for (i = 0, n = p.length; i < n; i++) {
            pv[p[i]] = i;
          } // return matrices


          return {
            L: l,
            U: u,
            p: pv,
            toString: function toString() {
              return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\nP: ' + this.p;
            }
          };
        }

        function _sparseLUP(m) {
          // rows & columns
          var rows = m._size[0];
          var columns = m._size[1]; // minimum rows and columns

          var n = Math.min(rows, columns); // matrix arrays (will not be modified, thanks to permutation vector)

          var values = m._values;
          var index = m._index;
          var ptr = m._ptr; // l matrix arrays

          var lvalues = [];
          var lindex = [];
          var lptr = [];
          var lsize = [rows, n]; // u matrix arrays

          var uvalues = [];
          var uindex = [];
          var uptr = [];
          var usize = [n, columns]; // vars

          var i, j, k; // permutation vectors, (current index -> original index) and (original index -> current index)

          var pvCo = [];
          var pvOc = [];

          for (i = 0; i < rows; i++) {
            pvCo[i] = i;
            pvOc[i] = i;
          } // swap indices in permutation vectors (condition x < y)!


          var swapIndeces = function swapIndeces(x, y) {
            // find pv indeces getting data from x and y
            var kx = pvOc[x];
            var ky = pvOc[y]; // update permutation vector current -> original

            pvCo[kx] = y;
            pvCo[ky] = x; // update permutation vector original -> current

            pvOc[x] = ky;
            pvOc[y] = kx;
          }; // loop columns


          var _loop = function _loop() {
            // sparse accumulator
            var spa = new Spa(); // check lower triangular matrix has a value @ column j

            if (j < rows) {
              // update ptr
              lptr.push(lvalues.length); // first value in j column for lower triangular matrix

              lvalues.push(1);
              lindex.push(j);
            } // update ptr


            uptr.push(uvalues.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]

            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // copy column j into sparse accumulator

            for (k = k0; k < k1; k++) {
              // row
              i = index[k]; // copy column values into sparse accumulator (use permutation vector)

              spa.set(pvCo[i], values[k]);
            } // skip first column in upper triangular matrix


            if (j > 0) {
              // loop rows in column j (above diagonal)
              spa.forEach(0, j - 1, function (k, vkj) {
                // loop rows in column k (L)
                SparseMatrix._forEachRow(k, lvalues, lindex, lptr, function (i, vik) {
                  // check row is below k
                  if (i > k) {
                    // update spa value
                    spa.accumulate(i, unaryMinus(multiplyScalar(vik, vkj)));
                  }
                });
              });
            } // row with larger value in spa, row >= j


            var pi = j;
            var vjj = spa.get(j);
            var pabsv = abs(vjj); // loop values in spa (order by row, below diagonal)

            spa.forEach(j + 1, rows - 1, function (x, v) {
              // absolute value
              var absv = abs(v); // value is greater than pivote value

              if (larger(absv, pabsv)) {
                // store row
                pi = x; // update max value

                pabsv = absv; // value @ [j, j]

                vjj = v;
              }
            }); // swap rows (j <-> pi)

            if (j !== pi) {
              // swap values j <-> pi in L
              SparseMatrix._swapRows(j, pi, lsize[1], lvalues, lindex, lptr); // swap values j <-> pi in U


              SparseMatrix._swapRows(j, pi, usize[1], uvalues, uindex, uptr); // swap values in spa


              spa.swap(j, pi); // update permutation vector (swap values @ j, pi)

              swapIndeces(j, pi);
            } // loop values in spa (order by row)


            spa.forEach(0, rows - 1, function (x, v) {
              // check we are above diagonal
              if (x <= j) {
                // update upper triangular matrix
                uvalues.push(v);
                uindex.push(x);
              } else {
                // update value
                v = divideScalar(v, vjj); // check value is non zero

                if (!equalScalar(v, 0)) {
                  // update lower triangular matrix
                  lvalues.push(v);
                  lindex.push(x);
                }
              }
            });
          };

          for (j = 0; j < columns; j++) {
            _loop();
          } // update ptrs


          uptr.push(uvalues.length);
          lptr.push(lvalues.length); // return matrices

          return {
            L: new SparseMatrix({
              values: lvalues,
              index: lindex,
              ptr: lptr,
              size: lsize
            }),
            U: new SparseMatrix({
              values: uvalues,
              index: uindex,
              ptr: uptr,
              size: usize
            }),
            p: pvCo,
            toString: function toString() {
              return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\nP: ' + this.p;
            }
          };
        }

        return lup;
      }

      exports.name = 'lup';
      exports.factory = factory;
      /***/
    },
    /* 773 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Test whether value is a boolean
       * @param {*} value
       * @return {boolean} isBoolean
       */

      exports.isBoolean = function (value) {
        return typeof value === 'boolean';
      };
      /***/

    },
    /* 774 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var extend = __webpack_require__(59).extend;

      function factory(type, config, load, typed) {
        var divideScalar = load(__webpack_require__(302));
        var multiply = load(__webpack_require__(124));
        var inv = load(__webpack_require__(233));
        var matrix = load(__webpack_require__(46));
        var algorithm11 = load(__webpack_require__(234));
        var algorithm14 = load(__webpack_require__(107));
        /**
         * Divide two values, `x / y`.
         * To divide matrices, `x` is multiplied with the inverse of `y`: `x * inv(y)`.
         *
         * Syntax:
         *
         *    math.divide(x, y)
         *
         * Examples:
         *
         *    math.divide(2, 3)            // returns number 0.6666666666666666
         *
         *    const a = math.complex(5, 14)
         *    const b = math.complex(4, 1)
         *    math.divide(a, b)            // returns Complex 2 + 3i
         *
         *    const c = [[7, -6], [13, -4]]
         *    const d = [[1, 2], [4, 3]]
         *    math.divide(c, d)            // returns Array [[-9, 4], [-11, 6]]
         *
         *    const e = math.unit('18 km')
         *    math.divide(e, 4.5)          // returns Unit 4 km
         *
         * See also:
         *
         *    multiply
         *
         * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x   Numerator
         * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} y          Denominator
         * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                      Quotient, `x / y`
         */

        var divide = typed('divide', extend({
          // we extend the signatures of divideScalar with signatures dealing with matrices
          'Array | Matrix, Array | Matrix': function ArrayMatrixArrayMatrix(x, y) {
            // TODO: implement matrix right division using pseudo inverse
            // https://www.mathworks.nl/help/matlab/ref/mrdivide.html
            // https://www.gnu.org/software/octave/doc/interpreter/Arithmetic-Ops.html
            // https://stackoverflow.com/questions/12263932/how-does-gnu-octave-matrix-division-work-getting-unexpected-behaviour
            return multiply(x, inv(y));
          },
          'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
          },
          'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
          },
          'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
          },
          'any, Array | Matrix': function anyArrayMatrix(x, y) {
            return multiply(x, inv(y));
          }
        }, divideScalar.signatures));
        divide.toTex = {
          2: "\\frac{${args[0]}}{${args[1]}}"
        };
        return divide;
      }

      exports.name = 'divide';
      exports.factory = factory;
      /***/
    },
    /* 775 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var DimensionError = __webpack_require__(92);

      function factory(type, config, load, typed) {
        var equalScalar = load(__webpack_require__(125));
        var SparseMatrix = type.SparseMatrix;
        /**
         * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
         * Callback function invoked MAX(NNZA, NNZB) times
         *
         *
         *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
         * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
         *          └  B(i,j)       ; B(i,j) !== 0
         *
         *
         * @param {Matrix}   a                 The SparseMatrix instance (A)
         * @param {Matrix}   b                 The SparseMatrix instance (B)
         * @param {Function} callback          The f(Aij,Bij) operation to invoke
         *
         * @return {Matrix}                    SparseMatrix (C)
         *
         * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
         */

        var algorithm04 = function algorithm04(a, b, callback) {
          // sparse matrix arrays
          var avalues = a._values;
          var aindex = a._index;
          var aptr = a._ptr;
          var asize = a._size;
          var adt = a._datatype; // sparse matrix arrays

          var bvalues = b._values;
          var bindex = b._index;
          var bptr = b._ptr;
          var bsize = b._size;
          var bdt = b._datatype; // validate dimensions

          if (asize.length !== bsize.length) {
            throw new DimensionError(asize.length, bsize.length);
          } // check rows & columns


          if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) {
            throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
          } // rows & columns


          var rows = asize[0];
          var columns = asize[1]; // datatype

          var dt; // equal signature to use

          var eq = equalScalar; // zero value

          var zero = 0; // callback signature to use

          var cf = callback; // process data types

          if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)

            eq = typed.find(equalScalar, [dt, dt]); // convert 0 to the same datatype

            zero = typed.convert(0, dt); // callback

            cf = typed.find(callback, [dt, dt]);
          } // result arrays


          var cvalues = avalues && bvalues ? [] : undefined;
          var cindex = [];
          var cptr = []; // matrix

          var c = new SparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [rows, columns],
            datatype: dt
          }); // workspace

          var xa = avalues && bvalues ? [] : undefined;
          var xb = avalues && bvalues ? [] : undefined; // marks indicating we have a value in x for a given column

          var wa = [];
          var wb = []; // vars

          var i, j, k, k0, k1; // loop columns

          for (j = 0; j < columns; j++) {
            // update cptr
            cptr[j] = cindex.length; // columns mark

            var mark = j + 1; // loop A(:,j)

            for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
              // row
              i = aindex[k]; // update c

              cindex.push(i); // update workspace

              wa[i] = mark; // check we need to process values

              if (xa) {
                xa[i] = avalues[k];
              }
            } // loop B(:,j)


            for (k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
              // row
              i = bindex[k]; // check row exists in A

              if (wa[i] === mark) {
                // update record in xa @ i
                if (xa) {
                  // invoke callback
                  var v = cf(xa[i], bvalues[k]); // check for zero

                  if (!eq(v, zero)) {
                    // update workspace
                    xa[i] = v;
                  } else {
                    // remove mark (index will be removed later)
                    wa[i] = null;
                  }
                }
              } else {
                // update c
                cindex.push(i); // update workspace

                wb[i] = mark; // check we need to process values

                if (xb) {
                  xb[i] = bvalues[k];
                }
              }
            } // check we need to process values (non pattern matrix)


            if (xa && xb) {
              // initialize first index in j
              k = cptr[j]; // loop index in j

              while (k < cindex.length) {
                // row
                i = cindex[k]; // check workspace has value @ i

                if (wa[i] === mark) {
                  // push value (Aij != 0 || (Aij != 0 && Bij != 0))
                  cvalues[k] = xa[i]; // increment pointer

                  k++;
                } else if (wb[i] === mark) {
                  // push value (bij != 0)
                  cvalues[k] = xb[i]; // increment pointer

                  k++;
                } else {
                  // remove index @ k
                  cindex.splice(k, 1);
                }
              }
            }
          } // update cptr


          cptr[columns] = cindex.length; // return sparse matrix

          return c;
        };

        return algorithm04;
      }

      exports.name = 'algorithm04';
      exports.factory = factory;
      /***/
    },
    /* 776 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var operators = __webpack_require__(171);

      var latex = __webpack_require__(72);

      var escape = __webpack_require__(79).escape;

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));

        var getSafeProperty = __webpack_require__(88).getSafeProperty;
        /**
         * A node representing a chained conditional expression, such as 'x > y > z'
         *
         * @param {String[]} conditionals   An array of conditional operators used to compare the parameters
         * @param {Node[]} params   The parameters that will be compared
         *
         * @constructor RelationalNode
         * @extends {Node}
         */


        function RelationalNode(conditionals, params) {
          if (!(this instanceof RelationalNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          if (!Array.isArray(conditionals)) throw new TypeError('Parameter conditionals must be an array');
          if (!Array.isArray(params)) throw new TypeError('Parameter params must be an array');
          if (conditionals.length !== params.length - 1) throw new TypeError('Parameter params must contain exactly one more element than parameter conditionals');
          this.conditionals = conditionals;
          this.params = params;
        }

        RelationalNode.prototype = new Node();
        RelationalNode.prototype.type = 'RelationalNode';
        RelationalNode.prototype.isRelationalNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        RelationalNode.prototype._compile = function (math, argNames) {
          var self = this;
          var compiled = this.params.map(function (p) {
            return p._compile(math, argNames);
          });
          return function evalRelationalNode(scope, args, context) {
            var evalLhs;
            var evalRhs = compiled[0](scope, args, context);

            for (var i = 0; i < self.conditionals.length; i++) {
              evalLhs = evalRhs;
              evalRhs = compiled[i + 1](scope, args, context);
              var condFn = getSafeProperty(math, self.conditionals[i]);

              if (!condFn(evalLhs, evalRhs)) {
                return false;
              }
            }

            return true;
          };
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        RelationalNode.prototype.forEach = function (callback) {
          var _this = this;

          this.params.forEach(function (n, i) {
            return callback(n, 'params[' + i + ']', _this);
          }, this);
        };
        /**
         * Create a new RelationalNode having its childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {RelationalNode} Returns a transformed copy of the node
         */


        RelationalNode.prototype.map = function (callback) {
          var _this2 = this;

          return new RelationalNode(this.conditionals.slice(), this.params.map(function (n, i) {
            return _this2._ifNode(callback(n, 'params[' + i + ']', _this2));
          }, this));
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {RelationalNode}
         */


        RelationalNode.prototype.clone = function () {
          return new RelationalNode(this.conditionals, this.params);
        };
        /**
         * Get string representation.
         * @param {Object} options
         * @return {string} str
         */


        RelationalNode.prototype._toString = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var precedence = operators.getPrecedence(this, parenthesis);
          var paramStrings = this.params.map(function (p, index) {
            var paramPrecedence = operators.getPrecedence(p, parenthesis);
            return parenthesis === 'all' || paramPrecedence !== null && paramPrecedence <= precedence ? '(' + p.toString(options) + ')' : p.toString(options);
          });
          var operatorMap = {
            'equal': '==',
            'unequal': '!=',
            'smaller': '<',
            'larger': '>',
            'smallerEq': '<=',
            'largerEq': '>='
          };
          var ret = paramStrings[0];

          for (var i = 0; i < this.conditionals.length; i++) {
            ret += ' ' + operatorMap[this.conditionals[i]] + ' ' + paramStrings[i + 1];
          }

          return ret;
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        RelationalNode.prototype.toJSON = function () {
          return {
            mathjs: 'RelationalNode',
            conditionals: this.conditionals,
            params: this.params
          };
        };
        /**
         * Instantiate a RelationalNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "RelationalNode", "condition": ..., "trueExpr": ..., "falseExpr": ...}`,
         *                       where mathjs is optional
         * @returns {RelationalNode}
         */


        RelationalNode.fromJSON = function (json) {
          return new RelationalNode(json.conditionals, json.params);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         */


        RelationalNode.prototype.toHTML = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var precedence = operators.getPrecedence(this, parenthesis);
          var paramStrings = this.params.map(function (p, index) {
            var paramPrecedence = operators.getPrecedence(p, parenthesis);
            return parenthesis === 'all' || paramPrecedence !== null && paramPrecedence <= precedence ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + p.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : p.toHTML(options);
          });
          var operatorMap = {
            'equal': '==',
            'unequal': '!=',
            'smaller': '<',
            'larger': '>',
            'smallerEq': '<=',
            'largerEq': '>='
          };
          var ret = paramStrings[0];

          for (var i = 0; i < this.conditionals.length; i++) {
            ret += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape(operatorMap[this.conditionals[i]]) + '</span>' + paramStrings[i + 1];
          }

          return ret;
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         */


        RelationalNode.prototype._toTex = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var precedence = operators.getPrecedence(this, parenthesis);
          var paramStrings = this.params.map(function (p, index) {
            var paramPrecedence = operators.getPrecedence(p, parenthesis);
            return parenthesis === 'all' || paramPrecedence !== null && paramPrecedence <= precedence ? '\\left(' + p.toTex(options) + '\right)' : p.toTex(options);
          });
          var ret = paramStrings[0];

          for (var i = 0; i < this.conditionals.length; i++) {
            ret += latex.operators[this.conditionals[i]] + paramStrings[i + 1];
          }

          return ret;
        };

        return RelationalNode;
      }

      exports.name = 'RelationalNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 777 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var operators = __webpack_require__(171);

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        /**
         * @constructor RangeNode
         * @extends {Node}
         * create a range
         * @param {Node} start  included lower-bound
         * @param {Node} end    included upper-bound
         * @param {Node} [step] optional step
         */

        function RangeNode(start, end, step) {
          if (!(this instanceof RangeNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          } // validate inputs


          if (!type.isNode(start)) throw new TypeError('Node expected');
          if (!type.isNode(end)) throw new TypeError('Node expected');
          if (step && !type.isNode(step)) throw new TypeError('Node expected');
          if (arguments.length > 3) throw new Error('Too many arguments');
          this.start = start; // included lower-bound

          this.end = end; // included upper-bound

          this.step = step || null; // optional step
        }

        RangeNode.prototype = new Node();
        RangeNode.prototype.type = 'RangeNode';
        RangeNode.prototype.isRangeNode = true;
        /**
         * Check whether the RangeNode needs the `end` symbol to be defined.
         * This end is the size of the Matrix in current dimension.
         * @return {boolean}
         */

        RangeNode.prototype.needsEnd = function () {
          // find all `end` symbols in this RangeNode
          var endSymbols = this.filter(function (node) {
            return type.isSymbolNode(node) && node.name === 'end';
          });
          return endSymbols.length > 0;
        };
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */


        RangeNode.prototype._compile = function (math, argNames) {
          var range = math.range;

          var evalStart = this.start._compile(math, argNames);

          var evalEnd = this.end._compile(math, argNames);

          if (this.step) {
            var evalStep = this.step._compile(math, argNames);

            return function evalRangeNode(scope, args, context) {
              return range(evalStart(scope, args, context), evalEnd(scope, args, context), evalStep(scope, args, context));
            };
          } else {
            return function evalRangeNode(scope, args, context) {
              return range(evalStart(scope, args, context), evalEnd(scope, args, context));
            };
          }
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        RangeNode.prototype.forEach = function (callback) {
          callback(this.start, 'start', this);
          callback(this.end, 'end', this);

          if (this.step) {
            callback(this.step, 'step', this);
          }
        };
        /**
         * Create a new RangeNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {RangeNode} Returns a transformed copy of the node
         */


        RangeNode.prototype.map = function (callback) {
          return new RangeNode(this._ifNode(callback(this.start, 'start', this)), this._ifNode(callback(this.end, 'end', this)), this.step && this._ifNode(callback(this.step, 'step', this)));
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {RangeNode}
         */


        RangeNode.prototype.clone = function () {
          return new RangeNode(this.start, this.end, this.step && this.step);
        };
        /**
         * Calculate the necessary parentheses
         * @param {Node} node
         * @param {string} parenthesis
         * @return {Object} parentheses
         * @private
         */


        function calculateNecessaryParentheses(node, parenthesis) {
          var precedence = operators.getPrecedence(node, parenthesis);
          var parens = {};
          var startPrecedence = operators.getPrecedence(node.start, parenthesis);
          parens.start = startPrecedence !== null && startPrecedence <= precedence || parenthesis === 'all';

          if (node.step) {
            var stepPrecedence = operators.getPrecedence(node.step, parenthesis);
            parens.step = stepPrecedence !== null && stepPrecedence <= precedence || parenthesis === 'all';
          }

          var endPrecedence = operators.getPrecedence(node.end, parenthesis);
          parens.end = endPrecedence !== null && endPrecedence <= precedence || parenthesis === 'all';
          return parens;
        }
        /**
         * Get string representation
         * @param {Object} options
         * @return {string} str
         */


        RangeNode.prototype._toString = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var parens = calculateNecessaryParentheses(this, parenthesis); // format string as start:step:stop

          var str;
          var start = this.start.toString(options);

          if (parens.start) {
            start = '(' + start + ')';
          }

          str = start;

          if (this.step) {
            var step = this.step.toString(options);

            if (parens.step) {
              step = '(' + step + ')';
            }

            str += ':' + step;
          }

          var end = this.end.toString(options);

          if (parens.end) {
            end = '(' + end + ')';
          }

          str += ':' + end;
          return str;
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        RangeNode.prototype.toJSON = function () {
          return {
            mathjs: 'RangeNode',
            start: this.start,
            end: this.end,
            step: this.step
          };
        };
        /**
         * Instantiate an RangeNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "RangeNode", "start": ..., "end": ..., "step": ...}`,
         *                       where mathjs is optional
         * @returns {RangeNode}
         */


        RangeNode.fromJSON = function (json) {
          return new RangeNode(json.start, json.end, json.step);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         */


        RangeNode.prototype.toHTML = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var parens = calculateNecessaryParentheses(this, parenthesis); // format string as start:step:stop

          var str;
          var start = this.start.toHTML(options);

          if (parens.start) {
            start = '<span class="math-parenthesis math-round-parenthesis">(</span>' + start + '<span class="math-parenthesis math-round-parenthesis">)</span>';
          }

          str = start;

          if (this.step) {
            var step = this.step.toHTML(options);

            if (parens.step) {
              step = '<span class="math-parenthesis math-round-parenthesis">(</span>' + step + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            }

            str += '<span class="math-operator math-range-operator">:</span>' + step;
          }

          var end = this.end.toHTML(options);

          if (parens.end) {
            end = '<span class="math-parenthesis math-round-parenthesis">(</span>' + end + '<span class="math-parenthesis math-round-parenthesis">)</span>';
          }

          str += '<span class="math-operator math-range-operator">:</span>' + end;
          return str;
        };
        /**
         * Get LaTeX representation
         * @params {Object} options
         * @return {string} str
         */


        RangeNode.prototype._toTex = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var parens = calculateNecessaryParentheses(this, parenthesis);
          var str = this.start.toTex(options);

          if (parens.start) {
            str = "\\left(".concat(str, "\\right)");
          }

          if (this.step) {
            var step = this.step.toTex(options);

            if (parens.step) {
              step = "\\left(".concat(step, "\\right)");
            }

            str += ':' + step;
          }

          var end = this.end.toTex(options);

          if (parens.end) {
            end = "\\left(".concat(end, "\\right)");
          }

          str += ':' + end;
          return str;
        };

        return RangeNode;
      }

      exports.name = 'RangeNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 778 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      function _extends() {
        _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        return _extends.apply(this, arguments);
      }

      var latex = __webpack_require__(72);

      var escape = __webpack_require__(79).escape;

      var hasOwnProperty = __webpack_require__(59).hasOwnProperty;

      var map = __webpack_require__(48).map;

      var validateSafeMethod = __webpack_require__(88).validateSafeMethod;

      var getSafeProperty = __webpack_require__(88).getSafeProperty;

      function factory(type, config, load, typed, math) {
        var Node = load(__webpack_require__(87));
        var SymbolNode = load(__webpack_require__(406));
        /**
         * @constructor FunctionNode
         * @extends {./Node}
         * invoke a list with arguments on a node
         * @param {./Node | string} fn Node resolving with a function on which to invoke
         *                             the arguments, typically a SymboNode or AccessorNode
         * @param {./Node[]} args
         */

        function FunctionNode(fn, args) {
          if (!(this instanceof FunctionNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          if (typeof fn === 'string') {
            fn = new SymbolNode(fn);
          } // validate input


          if (!type.isNode(fn)) throw new TypeError('Node expected as parameter "fn"');

          if (!Array.isArray(args) || !args.every(type.isNode)) {
            throw new TypeError('Array containing Nodes expected for parameter "args"');
          }

          this.fn = fn;
          this.args = args || []; // readonly property name

          Object.defineProperty(this, 'name', {
            get: function () {
              return this.fn.name || '';
            }.bind(this),
            set: function set() {
              throw new Error('Cannot assign a new name, name is read-only');
            }
          }); // TODO: deprecated since v3, remove some day

          var deprecated = function deprecated() {
            throw new Error('Property `FunctionNode.object` is deprecated, use `FunctionNode.fn` instead');
          };

          Object.defineProperty(this, 'object', {
            get: deprecated,
            set: deprecated
          });
        }

        FunctionNode.prototype = new Node();
        FunctionNode.prototype.type = 'FunctionNode';
        FunctionNode.prototype.isFunctionNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        FunctionNode.prototype._compile = function (math, argNames) {
          if (!(this instanceof FunctionNode)) {
            throw new TypeError('No valid FunctionNode');
          } // compile arguments


          var evalArgs = map(this.args, function (arg) {
            return arg._compile(math, argNames);
          });

          if (type.isSymbolNode(this.fn)) {
            // we can statically determine whether the function has an rawArgs property
            var name = this.fn.name;
            var fn = name in math ? getSafeProperty(math, name) : undefined;
            var isRaw = typeof fn === 'function' && fn.rawArgs === true;

            if (isRaw) {
              // pass unevaluated parameters (nodes) to the function
              // "raw" evaluation
              var rawArgs = this.args;
              return function evalFunctionNode(scope, args, context) {
                return (name in scope ? getSafeProperty(scope, name) : fn)(rawArgs, math, _extends({}, scope, args));
              };
            } else {
              // "regular" evaluation
              if (evalArgs.length === 1) {
                var evalArg0 = evalArgs[0];
                return function evalFunctionNode(scope, args, context) {
                  return (name in scope ? getSafeProperty(scope, name) : fn)(evalArg0(scope, args, context));
                };
              } else if (evalArgs.length === 2) {
                var _evalArg = evalArgs[0];
                var evalArg1 = evalArgs[1];
                return function evalFunctionNode(scope, args, context) {
                  return (name in scope ? getSafeProperty(scope, name) : fn)(_evalArg(scope, args, context), evalArg1(scope, args, context));
                };
              } else {
                return function evalFunctionNode(scope, args, context) {
                  return (name in scope ? getSafeProperty(scope, name) : fn).apply(null, map(evalArgs, function (evalArg) {
                    return evalArg(scope, args, context);
                  }));
                };
              }
            }
          } else if (type.isAccessorNode(this.fn) && type.isIndexNode(this.fn.index) && this.fn.index.isObjectProperty()) {
            // execute the function with the right context: the object of the AccessorNode
            var evalObject = this.fn.object._compile(math, argNames);

            var prop = this.fn.index.getObjectProperty();
            var _rawArgs = this.args;
            return function evalFunctionNode(scope, args, context) {
              var object = evalObject(scope, args, context);
              validateSafeMethod(object, prop);
              var isRaw = object[prop] && object[prop].rawArgs;
              return isRaw ? object[prop](_rawArgs, math, _extends({}, scope, args)) // "raw" evaluation
              : object[prop].apply(object, map(evalArgs, function (evalArg) {
                // "regular" evaluation
                return evalArg(scope, args, context);
              }));
            };
          } else {
            // node.fn.isAccessorNode && !node.fn.index.isObjectProperty()
            // we have to dynamically determine whether the function has a rawArgs property
            var evalFn = this.fn._compile(math, argNames);

            var _rawArgs2 = this.args;
            return function evalFunctionNode(scope, args, context) {
              var fn = evalFn(scope, args, context);
              var isRaw = fn && fn.rawArgs;
              return isRaw ? fn(_rawArgs2, math, _extends({}, scope, args)) // "raw" evaluation
              : fn.apply(fn, map(evalArgs, function (evalArg) {
                // "regular" evaluation
                return evalArg(scope, args, context);
              }));
            };
          }
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        FunctionNode.prototype.forEach = function (callback) {
          callback(this.fn, 'fn', this);

          for (var i = 0; i < this.args.length; i++) {
            callback(this.args[i], 'args[' + i + ']', this);
          }
        };
        /**
         * Create a new FunctionNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {FunctionNode} Returns a transformed copy of the node
         */


        FunctionNode.prototype.map = function (callback) {
          var fn = this._ifNode(callback(this.fn, 'fn', this));

          var args = [];

          for (var i = 0; i < this.args.length; i++) {
            args[i] = this._ifNode(callback(this.args[i], 'args[' + i + ']', this));
          }

          return new FunctionNode(fn, args);
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {FunctionNode}
         */


        FunctionNode.prototype.clone = function () {
          return new FunctionNode(this.fn, this.args.slice(0));
        }; // backup Node's toString function
        // @private


        var nodeToString = FunctionNode.prototype.toString;
        /**
         * Get string representation. (wrapper function)
         * This overrides parts of Node's toString function.
         * If callback is an object containing callbacks, it
         * calls the correct callback for the current node,
         * otherwise it falls back to calling Node's toString
         * function.
         *
         * @param {Object} options
         * @return {string} str
         * @override
         */

        FunctionNode.prototype.toString = function (options) {
          var customString;
          var name = this.fn.toString(options);

          if (options && _typeof(options.handler) === 'object' && hasOwnProperty(options.handler, name)) {
            // callback is a map of callback functions
            customString = options.handler[name](this, options);
          }

          if (typeof customString !== 'undefined') {
            return customString;
          } // fall back to Node's toString


          return nodeToString.call(this, options);
        };
        /**
         * Get string representation
         * @param {Object} options
         * @return {string} str
         */


        FunctionNode.prototype._toString = function (options) {
          var args = this.args.map(function (arg) {
            return arg.toString(options);
          });
          var fn = type.isFunctionAssignmentNode(this.fn) ? '(' + this.fn.toString(options) + ')' : this.fn.toString(options); // format the arguments like "add(2, 4.2)"

          return fn + '(' + args.join(', ') + ')';
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        FunctionNode.prototype.toJSON = function () {
          return {
            mathjs: 'FunctionNode',
            fn: this.fn,
            args: this.args
          };
        };
        /**
         * Instantiate an AssignmentNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "FunctionNode", fn: ..., args: ...}`,
         *                       where mathjs is optional
         * @returns {FunctionNode}
         */


        FunctionNode.fromJSON = function (json) {
          return new FunctionNode(json.fn, json.args);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         */


        FunctionNode.prototype.toHTML = function (options) {
          var args = this.args.map(function (arg) {
            return arg.toHTML(options);
          }); // format the arguments like "add(2, 4.2)"

          return '<span class="math-function">' + escape(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + args.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
        };
        /*
         * Expand a LaTeX template
         *
         * @param {string} template
         * @param {Node} node
         * @param {Object} options
         * @private
         **/


        function expandTemplate(template, node, options) {
          var latex = ''; // Match everything of the form ${identifier} or ${identifier[2]} or $$
          // while submatching identifier and 2 (in the second case)

          var regex = new RegExp('\\$(?:\\{([a-z_][a-z_0-9]*)(?:\\[([0-9]+)\\])?\\}|\\$)', 'ig');
          var inputPos = 0; // position in the input string

          var match;

          while ((match = regex.exec(template)) !== null) {
            // go through all matches
            // add everything in front of the match to the LaTeX string
            latex += template.substring(inputPos, match.index);
            inputPos = match.index;

            if (match[0] === '$$') {
              // escaped dollar sign
              latex += '$';
              inputPos++;
            } else {
              // template parameter
              inputPos += match[0].length;
              var property = node[match[1]];

              if (!property) {
                throw new ReferenceError('Template: Property ' + match[1] + ' does not exist.');
              }

              if (match[2] === undefined) {
                // no square brackets
                switch (_typeof(property)) {
                  case 'string':
                    latex += property;
                    break;

                  case 'object':
                    if (type.isNode(property)) {
                      latex += property.toTex(options);
                    } else if (Array.isArray(property)) {
                      // make array of Nodes into comma separated list
                      latex += property.map(function (arg, index) {
                        if (type.isNode(arg)) {
                          return arg.toTex(options);
                        }

                        throw new TypeError('Template: ' + match[1] + '[' + index + '] is not a Node.');
                      }).join(',');
                    } else {
                      throw new TypeError('Template: ' + match[1] + ' has to be a Node, String or array of Nodes');
                    }

                    break;

                  default:
                    throw new TypeError('Template: ' + match[1] + ' has to be a Node, String or array of Nodes');
                }
              } else {
                // with square brackets
                if (type.isNode(property[match[2]] && property[match[2]])) {
                  latex += property[match[2]].toTex(options);
                } else {
                  throw new TypeError('Template: ' + match[1] + '[' + match[2] + '] is not a Node.');
                }
              }
            }
          }

          latex += template.slice(inputPos); // append rest of the template

          return latex;
        } // backup Node's toTex function
        // @private


        var nodeToTex = FunctionNode.prototype.toTex;
        /**
         * Get LaTeX representation. (wrapper function)
         * This overrides parts of Node's toTex function.
         * If callback is an object containing callbacks, it
         * calls the correct callback for the current node,
         * otherwise it falls back to calling Node's toTex
         * function.
         *
         * @param {Object} options
         * @return {string}
         */

        FunctionNode.prototype.toTex = function (options) {
          var customTex;

          if (options && _typeof(options.handler) === 'object' && hasOwnProperty(options.handler, this.name)) {
            // callback is a map of callback functions
            customTex = options.handler[this.name](this, options);
          }

          if (typeof customTex !== 'undefined') {
            return customTex;
          } // fall back to Node's toTex


          return nodeToTex.call(this, options);
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         */


        FunctionNode.prototype._toTex = function (options) {
          var args = this.args.map(function (arg) {
            // get LaTeX of the arguments
            return arg.toTex(options);
          });
          var latexConverter;

          if (math[this.name] && (typeof math[this.name].toTex === 'function' || _typeof(math[this.name].toTex) === 'object' || typeof math[this.name].toTex === 'string')) {
            // .toTex is a callback function
            latexConverter = math[this.name].toTex;
          }

          var customToTex;

          switch (_typeof(latexConverter)) {
            case 'function':
              // a callback function
              customToTex = latexConverter(this, options);
              break;

            case 'string':
              // a template string
              customToTex = expandTemplate(latexConverter, this, options);
              break;

            case 'object':
              // an object with different "converters" for different numbers of arguments
              switch (_typeof(latexConverter[args.length])) {
                case 'function':
                  customToTex = latexConverter[args.length](this, options);
                  break;

                case 'string':
                  customToTex = expandTemplate(latexConverter[args.length], this, options);
                  break;
              }

          }

          if (typeof customToTex !== 'undefined') {
            return customToTex;
          }

          return expandTemplate(latex.defaultTemplate, this, options);
        };
        /**
         * Get identifier.
         * @return {string}
         */


        FunctionNode.prototype.getIdentifier = function () {
          return this.type + ':' + this.name;
        };

        return FunctionNode;
      }

      exports.name = 'FunctionNode';
      exports.path = 'expression.node';
      exports.math = true; // request access to the math namespace as 5th argument of the factory function

      exports.factory = factory;
      /***/
    },
    /* 779 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        /**
         * @constructor ParenthesisNode
         * @extends {Node}
         * A parenthesis node describes manual parenthesis from the user input
         * @param {Node} content
         * @extends {Node}
         */

        function ParenthesisNode(content) {
          if (!(this instanceof ParenthesisNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          } // validate input


          if (!type.isNode(content)) {
            throw new TypeError('Node expected for parameter "content"');
          }

          this.content = content;
        }

        ParenthesisNode.prototype = new Node();
        ParenthesisNode.prototype.type = 'ParenthesisNode';
        ParenthesisNode.prototype.isParenthesisNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        ParenthesisNode.prototype._compile = function (math, argNames) {
          return this.content._compile(math, argNames);
        };
        /**
         * Get the content of the current Node.
         * @return {Node} content
         * @override
         **/


        ParenthesisNode.prototype.getContent = function () {
          return this.content.getContent();
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        ParenthesisNode.prototype.forEach = function (callback) {
          callback(this.content, 'content', this);
        };
        /**
         * Create a new ParenthesisNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node) : Node} callback
         * @returns {ParenthesisNode} Returns a clone of the node
         */


        ParenthesisNode.prototype.map = function (callback) {
          var content = callback(this.content, 'content', this);
          return new ParenthesisNode(content);
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {ParenthesisNode}
         */


        ParenthesisNode.prototype.clone = function () {
          return new ParenthesisNode(this.content);
        };
        /**
         * Get string representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        ParenthesisNode.prototype._toString = function (options) {
          if (!options || options && !options.parenthesis || options && options.parenthesis === 'keep') {
            return '(' + this.content.toString(options) + ')';
          }

          return this.content.toString(options);
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        ParenthesisNode.prototype.toJSON = function () {
          return {
            mathjs: 'ParenthesisNode',
            content: this.content
          };
        };
        /**
         * Instantiate an ParenthesisNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "ParenthesisNode", "content": ...}`,
         *                       where mathjs is optional
         * @returns {ParenthesisNode}
         */


        ParenthesisNode.fromJSON = function (json) {
          return new ParenthesisNode(json.content);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        ParenthesisNode.prototype.toHTML = function (options) {
          if (!options || options && !options.parenthesis || options && options.parenthesis === 'keep') {
            return '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>';
          }

          return this.content.toHTML(options);
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        ParenthesisNode.prototype._toTex = function (options) {
          if (!options || options && !options.parenthesis || options && options.parenthesis === 'keep') {
            return "\\left(".concat(this.content.toTex(options), "\\right)");
          }

          return this.content.toTex(options);
        };

        return ParenthesisNode;
      }

      exports.name = 'ParenthesisNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 780 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var latex = __webpack_require__(72);

      var map = __webpack_require__(48).map;

      var escape = __webpack_require__(79).escape;

      var isSafeMethod = __webpack_require__(88).isSafeMethod;

      var getSafeProperty = __webpack_require__(88).getSafeProperty;

      var operators = __webpack_require__(171);

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        /**
         * @constructor OperatorNode
         * @extends {Node}
         * An operator with two arguments, like 2+3
         *
         * @param {string} op           Operator name, for example '+'
         * @param {string} fn           Function name, for example 'add'
         * @param {Node[]} args         Operator arguments
         * @param {boolean} [implicit]  Is this an implicit multiplication?
         */

        function OperatorNode(op, fn, args, implicit) {
          if (!(this instanceof OperatorNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          } // validate input


          if (typeof op !== 'string') {
            throw new TypeError('string expected for parameter "op"');
          }

          if (typeof fn !== 'string') {
            throw new TypeError('string expected for parameter "fn"');
          }

          if (!Array.isArray(args) || !args.every(type.isNode)) {
            throw new TypeError('Array containing Nodes expected for parameter "args"');
          }

          this.implicit = implicit === true;
          this.op = op;
          this.fn = fn;
          this.args = args || [];
        }

        OperatorNode.prototype = new Node();
        OperatorNode.prototype.type = 'OperatorNode';
        OperatorNode.prototype.isOperatorNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        OperatorNode.prototype._compile = function (math, argNames) {
          // validate fn
          if (typeof this.fn !== 'string' || !isSafeMethod(math, this.fn)) {
            if (!math[this.fn]) {
              throw new Error('Function ' + this.fn + ' missing in provided namespace "math"');
            } else {
              throw new Error('No access to function "' + this.fn + '"');
            }
          }

          var fn = getSafeProperty(math, this.fn);
          var evalArgs = map(this.args, function (arg) {
            return arg._compile(math, argNames);
          });

          if (evalArgs.length === 1) {
            var evalArg0 = evalArgs[0];
            return function evalOperatorNode(scope, args, context) {
              return fn(evalArg0(scope, args, context));
            };
          } else if (evalArgs.length === 2) {
            var _evalArg = evalArgs[0];
            var evalArg1 = evalArgs[1];
            return function evalOperatorNode(scope, args, context) {
              return fn(_evalArg(scope, args, context), evalArg1(scope, args, context));
            };
          } else {
            return function evalOperatorNode(scope, args, context) {
              return fn.apply(null, map(evalArgs, function (evalArg) {
                return evalArg(scope, args, context);
              }));
            };
          }
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        OperatorNode.prototype.forEach = function (callback) {
          for (var i = 0; i < this.args.length; i++) {
            callback(this.args[i], 'args[' + i + ']', this);
          }
        };
        /**
         * Create a new OperatorNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {OperatorNode} Returns a transformed copy of the node
         */


        OperatorNode.prototype.map = function (callback) {
          var args = [];

          for (var i = 0; i < this.args.length; i++) {
            args[i] = this._ifNode(callback(this.args[i], 'args[' + i + ']', this));
          }

          return new OperatorNode(this.op, this.fn, args, this.implicit);
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {OperatorNode}
         */


        OperatorNode.prototype.clone = function () {
          return new OperatorNode(this.op, this.fn, this.args.slice(0), this.implicit);
        };
        /**
         * Check whether this is an unary OperatorNode:
         * has exactly one argument, like `-a`.
         * @return {boolean} Returns true when an unary operator node, false otherwise.
         */


        OperatorNode.prototype.isUnary = function () {
          return this.args.length === 1;
        };
        /**
         * Check whether this is a binary OperatorNode:
         * has exactly two arguments, like `a + b`.
         * @return {boolean} Returns true when a binary operator node, false otherwise.
         */


        OperatorNode.prototype.isBinary = function () {
          return this.args.length === 2;
        };
        /**
         * Calculate which parentheses are necessary. Gets an OperatorNode
         * (which is the root of the tree) and an Array of Nodes
         * (this.args) and returns an array where 'true' means that an argument
         * has to be enclosed in parentheses whereas 'false' means the opposite.
         *
         * @param {OperatorNode} root
         * @param {string} parenthesis
         * @param {Node[]} args
         * @param {boolean} latex
         * @return {boolean[]}
         * @private
         */


        function calculateNecessaryParentheses(root, parenthesis, implicit, args, latex) {
          // precedence of the root OperatorNode
          var precedence = operators.getPrecedence(root, parenthesis);
          var associativity = operators.getAssociativity(root, parenthesis);

          if (parenthesis === 'all' || args.length > 2 && root.getIdentifier() !== 'OperatorNode:add' && root.getIdentifier() !== 'OperatorNode:multiply') {
            var parens = args.map(function (arg) {
              switch (arg.getContent().type) {
                // Nodes that don't need extra parentheses
                case 'ArrayNode':
                case 'ConstantNode':
                case 'SymbolNode':
                case 'ParenthesisNode':
                  return false;

                default:
                  return true;
              }
            });
            return parens;
          }

          var result;

          switch (args.length) {
            case 0:
              result = [];
              break;

            case 1:
              // unary operators
              // precedence of the operand
              var operandPrecedence = operators.getPrecedence(args[0], parenthesis); // handle special cases for LaTeX, where some of the parentheses aren't needed

              if (latex && operandPrecedence !== null) {
                var operandIdentifier;
                var rootIdentifier;

                if (parenthesis === 'keep') {
                  operandIdentifier = args[0].getIdentifier();
                  rootIdentifier = root.getIdentifier();
                } else {
                  // Ignore Parenthesis Nodes when not in 'keep' mode
                  operandIdentifier = args[0].getContent().getIdentifier();
                  rootIdentifier = root.getContent().getIdentifier();
                }

                if (operators.properties[precedence][rootIdentifier].latexLeftParens === false) {
                  result = [false];
                  break;
                }

                if (operators.properties[operandPrecedence][operandIdentifier].latexParens === false) {
                  result = [false];
                  break;
                }
              }

              if (operandPrecedence === null) {
                // if the operand has no defined precedence, no parens are needed
                result = [false];
                break;
              }

              if (operandPrecedence <= precedence) {
                // if the operands precedence is lower, parens are needed
                result = [true];
                break;
              } // otherwise, no parens needed


              result = [false];
              break;

            case 2:
              // binary operators
              var lhsParens; // left hand side needs parenthesis?
              // precedence of the left hand side

              var lhsPrecedence = operators.getPrecedence(args[0], parenthesis); // is the root node associative with the left hand side

              var assocWithLhs = operators.isAssociativeWith(root, args[0], parenthesis);

              if (lhsPrecedence === null) {
                // if the left hand side has no defined precedence, no parens are needed
                // FunctionNode for example
                lhsParens = false;
              } else if (lhsPrecedence === precedence && associativity === 'right' && !assocWithLhs) {
                // In case of equal precedence, if the root node is left associative
                // parens are **never** necessary for the left hand side.
                // If it is right associative however, parens are necessary
                // if the root node isn't associative with the left hand side
                lhsParens = true;
              } else if (lhsPrecedence < precedence) {
                lhsParens = true;
              } else {
                lhsParens = false;
              }

              var rhsParens; // right hand side needs parenthesis?
              // precedence of the right hand side

              var rhsPrecedence = operators.getPrecedence(args[1], parenthesis); // is the root node associative with the right hand side?

              var assocWithRhs = operators.isAssociativeWith(root, args[1], parenthesis);

              if (rhsPrecedence === null) {
                // if the right hand side has no defined precedence, no parens are needed
                // FunctionNode for example
                rhsParens = false;
              } else if (rhsPrecedence === precedence && associativity === 'left' && !assocWithRhs) {
                // In case of equal precedence, if the root node is right associative
                // parens are **never** necessary for the right hand side.
                // If it is left associative however, parens are necessary
                // if the root node isn't associative with the right hand side
                rhsParens = true;
              } else if (rhsPrecedence < precedence) {
                rhsParens = true;
              } else {
                rhsParens = false;
              } // handle special cases for LaTeX, where some of the parentheses aren't needed


              if (latex) {
                var _rootIdentifier;

                var lhsIdentifier;
                var rhsIdentifier;

                if (parenthesis === 'keep') {
                  _rootIdentifier = root.getIdentifier();
                  lhsIdentifier = root.args[0].getIdentifier();
                  rhsIdentifier = root.args[1].getIdentifier();
                } else {
                  // Ignore ParenthesisNodes when not in 'keep' mode
                  _rootIdentifier = root.getContent().getIdentifier();
                  lhsIdentifier = root.args[0].getContent().getIdentifier();
                  rhsIdentifier = root.args[1].getContent().getIdentifier();
                }

                if (lhsPrecedence !== null) {
                  if (operators.properties[precedence][_rootIdentifier].latexLeftParens === false) {
                    lhsParens = false;
                  }

                  if (operators.properties[lhsPrecedence][lhsIdentifier].latexParens === false) {
                    lhsParens = false;
                  }
                }

                if (rhsPrecedence !== null) {
                  if (operators.properties[precedence][_rootIdentifier].latexRightParens === false) {
                    rhsParens = false;
                  }

                  if (operators.properties[rhsPrecedence][rhsIdentifier].latexParens === false) {
                    rhsParens = false;
                  }
                }
              }

              result = [lhsParens, rhsParens];
              break;

            default:
              if (root.getIdentifier() === 'OperatorNode:add' || root.getIdentifier() === 'OperatorNode:multiply') {
                result = args.map(function (arg) {
                  var argPrecedence = operators.getPrecedence(arg, parenthesis);
                  var assocWithArg = operators.isAssociativeWith(root, arg, parenthesis);
                  var argAssociativity = operators.getAssociativity(arg, parenthesis);

                  if (argPrecedence === null) {
                    // if the argument has no defined precedence, no parens are needed
                    return false;
                  } else if (precedence === argPrecedence && associativity === argAssociativity && !assocWithArg) {
                    return true;
                  } else if (argPrecedence < precedence) {
                    return true;
                  }

                  return false;
                });
              }

              break;
          } // handles an edge case of 'auto' parentheses with implicit multiplication of ConstantNode
          // In that case print parentheses for ParenthesisNodes even though they normally wouldn't be
          // printed.


          if (args.length >= 2 && root.getIdentifier() === 'OperatorNode:multiply' && root.implicit && parenthesis === 'auto' && implicit === 'hide') {
            result = args.map(function (arg, index) {
              var isParenthesisNode = arg.getIdentifier() === 'ParenthesisNode';

              if (result[index] || isParenthesisNode) {
                // put in parenthesis?
                return true;
              }

              return false;
            });
          }

          return result;
        }
        /**
         * Get string representation.
         * @param {Object} options
         * @return {string} str
         */


        OperatorNode.prototype._toString = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var implicit = options && options.implicit ? options.implicit : 'hide';
          var args = this.args;
          var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);

          if (args.length === 1) {
            // unary operators
            var assoc = operators.getAssociativity(this, parenthesis);
            var operand = args[0].toString(options);

            if (parens[0]) {
              operand = '(' + operand + ')';
            } // for example for "not", we want a space between operand and argument


            var opIsNamed = /[a-zA-Z]+/.test(this.op);

            if (assoc === 'right') {
              // prefix operator
              return this.op + (opIsNamed ? ' ' : '') + operand;
            } else if (assoc === 'left') {
              // postfix
              return operand + (opIsNamed ? ' ' : '') + this.op;
            } // fall back to postfix


            return operand + this.op;
          } else if (args.length === 2) {
            var lhs = args[0].toString(options); // left hand side

            var rhs = args[1].toString(options); // right hand side

            if (parens[0]) {
              // left hand side in parenthesis?
              lhs = '(' + lhs + ')';
            }

            if (parens[1]) {
              // right hand side in parenthesis?
              rhs = '(' + rhs + ')';
            }

            if (this.implicit && this.getIdentifier() === 'OperatorNode:multiply' && implicit === 'hide') {
              return lhs + ' ' + rhs;
            }

            return lhs + ' ' + this.op + ' ' + rhs;
          } else if (args.length > 2 && (this.getIdentifier() === 'OperatorNode:add' || this.getIdentifier() === 'OperatorNode:multiply')) {
            var stringifiedArgs = args.map(function (arg, index) {
              arg = arg.toString(options);

              if (parens[index]) {
                // put in parenthesis?
                arg = '(' + arg + ')';
              }

              return arg;
            });

            if (this.implicit && this.getIdentifier() === 'OperatorNode:multiply' && implicit === 'hide') {
              return stringifiedArgs.join(' ');
            }

            return stringifiedArgs.join(' ' + this.op + ' ');
          } else {
            // fallback to formatting as a function call
            return this.fn + '(' + this.args.join(', ') + ')';
          }
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        OperatorNode.prototype.toJSON = function () {
          return {
            mathjs: 'OperatorNode',
            op: this.op,
            fn: this.fn,
            args: this.args,
            implicit: this.implicit
          };
        };
        /**
         * Instantiate an OperatorNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "OperatorNode", "op": "+", "fn": "add", "args": [...], "implicit": false}`,
         *                       where mathjs is optional
         * @returns {OperatorNode}
         */


        OperatorNode.fromJSON = function (json) {
          return new OperatorNode(json.op, json.fn, json.args, json.implicit);
        };
        /**
         * Get HTML representation.
         * @param {Object} options
         * @return {string} str
         */


        OperatorNode.prototype.toHTML = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var implicit = options && options.implicit ? options.implicit : 'hide';
          var args = this.args;
          var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);

          if (args.length === 1) {
            // unary operators
            var assoc = operators.getAssociativity(this, parenthesis);
            var operand = args[0].toHTML(options);

            if (parens[0]) {
              operand = '<span class="math-parenthesis math-round-parenthesis">(</span>' + operand + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            }

            if (assoc === 'right') {
              // prefix operator
              return '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + escape(this.op) + '</span>' + operand;
            } else {
              // postfix when assoc === 'left' or undefined
              return operand + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + escape(this.op) + '</span>';
            }
          } else if (args.length === 2) {
            // binary operatoes
            var lhs = args[0].toHTML(options); // left hand side

            var rhs = args[1].toHTML(options); // right hand side

            if (parens[0]) {
              // left hand side in parenthesis?
              lhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + lhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            }

            if (parens[1]) {
              // right hand side in parenthesis?
              rhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + rhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
            }

            if (this.implicit && this.getIdentifier() === 'OperatorNode:multiply' && implicit === 'hide') {
              return lhs + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + rhs;
            }

            return lhs + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape(this.op) + '</span>' + rhs;
          } else {
            var stringifiedArgs = args.map(function (arg, index) {
              arg = arg.toHTML(options);

              if (parens[index]) {
                // put in parenthesis?
                arg = '<span class="math-parenthesis math-round-parenthesis">(</span>' + arg + '<span class="math-parenthesis math-round-parenthesis">)</span>';
              }

              return arg;
            });

            if (args.length > 2 && (this.getIdentifier() === 'OperatorNode:add' || this.getIdentifier() === 'OperatorNode:multiply')) {
              if (this.implicit && this.getIdentifier() === 'OperatorNode:multiply' && implicit === 'hide') {
                return stringifiedArgs.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>');
              }

              return stringifiedArgs.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape(this.op) + '</span>');
            } else {
              // fallback to formatting as a function call
              return '<span class="math-function">' + escape(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + stringifiedArgs.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
            }
          }
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         */


        OperatorNode.prototype._toTex = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var implicit = options && options.implicit ? options.implicit : 'hide';
          var args = this.args;
          var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, true);
          var op = latex.operators[this.fn];
          op = typeof op === 'undefined' ? this.op : op; // fall back to using this.op

          if (args.length === 1) {
            // unary operators
            var assoc = operators.getAssociativity(this, parenthesis);
            var operand = args[0].toTex(options);

            if (parens[0]) {
              operand = "\\left(".concat(operand, "\\right)");
            }

            if (assoc === 'right') {
              // prefix operator
              return op + operand;
            } else if (assoc === 'left') {
              // postfix operator
              return operand + op;
            } // fall back to postfix


            return operand + op;
          } else if (args.length === 2) {
            // binary operators
            var lhs = args[0]; // left hand side

            var lhsTex = lhs.toTex(options);

            if (parens[0]) {
              lhsTex = "\\left(".concat(lhsTex, "\\right)");
            }

            var rhs = args[1]; // right hand side

            var rhsTex = rhs.toTex(options);

            if (parens[1]) {
              rhsTex = "\\left(".concat(rhsTex, "\\right)");
            } // handle some exceptions (due to the way LaTeX works)


            var lhsIdentifier;

            if (parenthesis === 'keep') {
              lhsIdentifier = lhs.getIdentifier();
            } else {
              // Ignore ParenthesisNodes if in 'keep' mode
              lhsIdentifier = lhs.getContent().getIdentifier();
            }

            switch (this.getIdentifier()) {
              case 'OperatorNode:divide':
                // op contains '\\frac' at this point
                return op + '{' + lhsTex + '}' + '{' + rhsTex + '}';

              case 'OperatorNode:pow':
                lhsTex = '{' + lhsTex + '}';
                rhsTex = '{' + rhsTex + '}';

                switch (lhsIdentifier) {
                  case 'ConditionalNode': //

                  case 'OperatorNode:divide':
                    lhsTex = "\\left(".concat(lhsTex, "\\right)");
                }

                break;

              case 'OperatorNode:multiply':
                if (this.implicit && implicit === 'hide') {
                  return lhsTex + '~' + rhsTex;
                }

            }

            return lhsTex + op + rhsTex;
          } else if (args.length > 2 && (this.getIdentifier() === 'OperatorNode:add' || this.getIdentifier() === 'OperatorNode:multiply')) {
            var texifiedArgs = args.map(function (arg, index) {
              arg = arg.toTex(options);

              if (parens[index]) {
                arg = "\\left(".concat(arg, "\\right)");
              }

              return arg;
            });

            if (this.getIdentifier() === 'OperatorNode:multiply' && this.implicit) {
              return texifiedArgs.join('~');
            }

            return texifiedArgs.join(op);
          } else {
            // fall back to formatting as a function call
            // as this is a fallback, it doesn't use
            // fancy function names
            return '\\mathrm{' + this.fn + '}\\left(' + args.map(function (arg) {
              return arg.toTex(options);
            }).join(',') + '\\right)';
          }
        };
        /**
         * Get identifier.
         * @return {string}
         */


        OperatorNode.prototype.getIdentifier = function () {
          return this.type + ':' + this.fn;
        };

        return OperatorNode;
      }

      exports.name = 'OperatorNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 781 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      var stringify = __webpack_require__(79).stringify;

      var escape = __webpack_require__(79).escape;

      var isSafeProperty = __webpack_require__(88).isSafeProperty;

      var hasOwnProperty = __webpack_require__(59).hasOwnProperty;

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        /**
         * @constructor ObjectNode
         * @extends {Node}
         * Holds an object with keys/values
         * @param {Object.<string, Node>} [properties]   object with key/value pairs
         */

        function ObjectNode(properties) {
          if (!(this instanceof ObjectNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          this.properties = properties || {}; // validate input

          if (properties) {
            if (!(_typeof(properties) === 'object') || !Object.keys(properties).every(function (key) {
              return type.isNode(properties[key]);
            })) {
              throw new TypeError('Object containing Nodes expected');
            }
          }
        }

        ObjectNode.prototype = new Node();
        ObjectNode.prototype.type = 'ObjectNode';
        ObjectNode.prototype.isObjectNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        ObjectNode.prototype._compile = function (math, argNames) {
          var evalEntries = {};

          for (var key in this.properties) {
            if (hasOwnProperty(this.properties, key)) {
              // we stringify/parse the key here to resolve unicode characters,
              // so you cannot create a key like {"co\\u006Estructor": null}
              var stringifiedKey = stringify(key);
              var parsedKey = JSON.parse(stringifiedKey);

              if (!isSafeProperty(this.properties, parsedKey)) {
                throw new Error('No access to property "' + parsedKey + '"');
              }

              evalEntries[parsedKey] = this.properties[key]._compile(math, argNames);
            }
          }

          return function evalObjectNode(scope, args, context) {
            var obj = {};

            for (var _key in evalEntries) {
              if (hasOwnProperty(evalEntries, _key)) {
                obj[_key] = evalEntries[_key](scope, args, context);
              }
            }

            return obj;
          };
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        ObjectNode.prototype.forEach = function (callback) {
          for (var key in this.properties) {
            if (this.properties.hasOwnProperty(key)) {
              callback(this.properties[key], 'properties[' + stringify(key) + ']', this);
            }
          }
        };
        /**
         * Create a new ObjectNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {ObjectNode} Returns a transformed copy of the node
         */


        ObjectNode.prototype.map = function (callback) {
          var properties = {};

          for (var key in this.properties) {
            if (this.properties.hasOwnProperty(key)) {
              properties[key] = this._ifNode(callback(this.properties[key], 'properties[' + stringify(key) + ']', this));
            }
          }

          return new ObjectNode(properties);
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {ObjectNode}
         */


        ObjectNode.prototype.clone = function () {
          var properties = {};

          for (var key in this.properties) {
            if (this.properties.hasOwnProperty(key)) {
              properties[key] = this.properties[key];
            }
          }

          return new ObjectNode(properties);
        };
        /**
         * Get string representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        ObjectNode.prototype._toString = function (options) {
          var entries = [];

          for (var key in this.properties) {
            if (this.properties.hasOwnProperty(key)) {
              entries.push(stringify(key) + ': ' + this.properties[key].toString(options));
            }
          }

          return '{' + entries.join(', ') + '}';
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        ObjectNode.prototype.toJSON = function () {
          return {
            mathjs: 'ObjectNode',
            properties: this.properties
          };
        };
        /**
         * Instantiate an OperatorNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "ObjectNode", "properties": {...}}`,
         *                       where mathjs is optional
         * @returns {ObjectNode}
         */


        ObjectNode.fromJSON = function (json) {
          return new ObjectNode(json.properties);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        ObjectNode.prototype.toHTML = function (options) {
          var entries = [];

          for (var key in this.properties) {
            if (this.properties.hasOwnProperty(key)) {
              entries.push('<span class="math-symbol math-property">' + escape(key) + '</span>' + '<span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[key].toHTML(options));
            }
          }

          return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + entries.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         */


        ObjectNode.prototype._toTex = function (options) {
          var entries = [];

          for (var key in this.properties) {
            if (this.properties.hasOwnProperty(key)) {
              entries.push('\\mathbf{' + key + ':} & ' + this.properties[key].toTex(options) + '\\\\');
            }
          }

          return "\\left\\{\\begin{array}{ll}".concat(entries.join('\n'), "\\end{array}\\right\\}");
        };

        return ObjectNode;
      }

      exports.name = 'ObjectNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 782 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var map = __webpack_require__(48).map;

      var escape = __webpack_require__(79).escape;

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        var Range = load(__webpack_require__(407));
        var isArray = Array.isArray;
        /**
         * @constructor IndexNode
         * @extends Node
         *
         * Describes a subset of a matrix or an object property.
         * Cannot be used on its own, needs to be used within an AccessorNode or
         * AssignmentNode.
         *
         * @param {Node[]} dimensions
         * @param {boolean} [dotNotation=false]  Optional property describing whether
         *                                       this index was written using dot
         *                                       notation like `a.b`, or using bracket
         *                                       notation like `a["b"]` (default).
         *                                       Used to stringify an IndexNode.
         */

        function IndexNode(dimensions, dotNotation) {
          if (!(this instanceof IndexNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          this.dimensions = dimensions;
          this.dotNotation = dotNotation || false; // validate input

          if (!isArray(dimensions) || !dimensions.every(type.isNode)) {
            throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
          }

          if (this.dotNotation && !this.isObjectProperty()) {
            throw new Error('dotNotation only applicable for object properties');
          } // TODO: deprecated since v3, remove some day


          var deprecated = function deprecated() {
            throw new Error('Property `IndexNode.object` is deprecated, use `IndexNode.fn` instead');
          };

          Object.defineProperty(this, 'object', {
            get: deprecated,
            set: deprecated
          });
        }

        IndexNode.prototype = new Node();
        IndexNode.prototype.type = 'IndexNode';
        IndexNode.prototype.isIndexNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        IndexNode.prototype._compile = function (math, argNames) {
          // TODO: implement support for bignumber (currently bignumbers are silently
          //       reduced to numbers when changing the value to zero-based)
          // TODO: Optimization: when the range values are ConstantNodes,
          //       we can beforehand resolve the zero-based value
          // optimization for a simple object property
          var evalDimensions = map(this.dimensions, function (range, i) {
            if (type.isRangeNode(range)) {
              if (range.needsEnd()) {
                // create a range containing end (like '4:end')
                var childArgNames = Object.create(argNames);
                childArgNames['end'] = true;

                var evalStart = range.start._compile(math, childArgNames);

                var evalEnd = range.end._compile(math, childArgNames);

                var evalStep = range.step ? range.step._compile(math, childArgNames) : function () {
                  return 1;
                };
                return function evalDimension(scope, args, context) {
                  var size = math.size(context).valueOf();
                  var childArgs = Object.create(args);
                  childArgs['end'] = size[i];
                  return createRange(evalStart(scope, childArgs, context), evalEnd(scope, childArgs, context), evalStep(scope, childArgs, context));
                };
              } else {
                // create range
                var _evalStart = range.start._compile(math, argNames);

                var _evalEnd = range.end._compile(math, argNames);

                var _evalStep = range.step ? range.step._compile(math, argNames) : function () {
                  return 1;
                };

                return function evalDimension(scope, args, context) {
                  return createRange(_evalStart(scope, args, context), _evalEnd(scope, args, context), _evalStep(scope, args, context));
                };
              }
            } else if (type.isSymbolNode(range) && range.name === 'end') {
              // SymbolNode 'end'
              var _childArgNames = Object.create(argNames);

              _childArgNames['end'] = true;

              var evalRange = range._compile(math, _childArgNames);

              return function evalDimension(scope, args, context) {
                var size = math.size(context).valueOf();
                var childArgs = Object.create(args);
                childArgs['end'] = size[i];
                return evalRange(scope, childArgs, context);
              };
            } else {
              // ConstantNode
              var _evalRange = range._compile(math, argNames);

              return function evalDimension(scope, args, context) {
                return _evalRange(scope, args, context);
              };
            }
          });
          return function evalIndexNode(scope, args, context) {
            var dimensions = map(evalDimensions, function (evalDimension) {
              return evalDimension(scope, args, context);
            });
            return math.index.apply(math, dimensions);
          };
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        IndexNode.prototype.forEach = function (callback) {
          for (var i = 0; i < this.dimensions.length; i++) {
            callback(this.dimensions[i], 'dimensions[' + i + ']', this);
          }
        };
        /**
         * Create a new IndexNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {IndexNode} Returns a transformed copy of the node
         */


        IndexNode.prototype.map = function (callback) {
          var dimensions = [];

          for (var i = 0; i < this.dimensions.length; i++) {
            dimensions[i] = this._ifNode(callback(this.dimensions[i], 'dimensions[' + i + ']', this));
          }

          return new IndexNode(dimensions);
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {IndexNode}
         */


        IndexNode.prototype.clone = function () {
          return new IndexNode(this.dimensions.slice(0));
        };
        /**
         * Test whether this IndexNode contains a single property name
         * @return {boolean}
         */


        IndexNode.prototype.isObjectProperty = function () {
          return this.dimensions.length === 1 && type.isConstantNode(this.dimensions[0]) && typeof this.dimensions[0].value === 'string';
        };
        /**
         * Returns the property name if IndexNode contains a property.
         * If not, returns null.
         * @return {string | null}
         */


        IndexNode.prototype.getObjectProperty = function () {
          return this.isObjectProperty() ? this.dimensions[0].value : null;
        };
        /**
         * Get string representation
         * @param {Object} options
         * @return {string} str
         */


        IndexNode.prototype._toString = function (options) {
          // format the parameters like "[1, 0:5]"
          return this.dotNotation ? '.' + this.getObjectProperty() : '[' + this.dimensions.join(', ') + ']';
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        IndexNode.prototype.toJSON = function () {
          return {
            mathjs: 'IndexNode',
            dimensions: this.dimensions,
            dotNotation: this.dotNotation
          };
        };
        /**
         * Instantiate an IndexNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "IndexNode", dimensions: [...], dotNotation: false}`,
         *                       where mathjs is optional
         * @returns {IndexNode}
         */


        IndexNode.fromJSON = function (json) {
          return new IndexNode(json.dimensions, json.dotNotation);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         */


        IndexNode.prototype.toHTML = function (options) {
          // format the parameters like "[1, 0:5]"
          var dimensions = [];

          for (var i = 0; i < this.dimensions.length; i++) {
            dimensions[i] = this.dimensions[i].toHTML();
          }

          if (this.dotNotation) {
            return '<span class="math-operator math-accessor-operator">.</span>' + '<span class="math-symbol math-property">' + escape(this.getObjectProperty()) + '</span>';
          } else {
            return '<span class="math-parenthesis math-square-parenthesis">[</span>' + dimensions.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
          }
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         */


        IndexNode.prototype._toTex = function (options) {
          var dimensions = this.dimensions.map(function (range) {
            return range.toTex(options);
          });
          return this.dotNotation ? '.' + this.getObjectProperty() + '' : '_{' + dimensions.join(',') + '}';
        }; // helper function to create a Range from start, step and end


        function createRange(start, end, step) {
          return new Range(type.isBigNumber(start) ? start.toNumber() : start, type.isBigNumber(end) ? end.toNumber() : end, type.isBigNumber(step) ? step.toNumber() : step);
        }

        return IndexNode;
      }

      exports.name = 'IndexNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 783 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var keywords = __webpack_require__(410);

      var escape = __webpack_require__(79).escape;

      var forEach = __webpack_require__(48).forEach;

      var join = __webpack_require__(48).join;

      var latex = __webpack_require__(72);

      var operators = __webpack_require__(171);

      var setSafeProperty = __webpack_require__(88).setSafeProperty;

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        /**
         * @constructor FunctionAssignmentNode
         * @extends {Node}
         * Function assignment
         *
         * @param {string} name           Function name
         * @param {string[] | Array.<{name: string, type: string}>} params
         *                                Array with function parameter names, or an
         *                                array with objects containing the name
         *                                and type of the parameter
         * @param {Node} expr             The function expression
         */

        function FunctionAssignmentNode(name, params, expr) {
          if (!(this instanceof FunctionAssignmentNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          } // validate input


          if (typeof name !== 'string') throw new TypeError('String expected for parameter "name"');
          if (!Array.isArray(params)) throw new TypeError('Array containing strings or objects expected for parameter "params"');
          if (!type.isNode(expr)) throw new TypeError('Node expected for parameter "expr"');
          if (name in keywords) throw new Error('Illegal function name, "' + name + '" is a reserved keyword');
          this.name = name;
          this.params = params.map(function (param) {
            return param && param.name || param;
          });
          this.types = params.map(function (param) {
            return param && param.type || 'any';
          });
          this.expr = expr;
        }

        FunctionAssignmentNode.prototype = new Node();
        FunctionAssignmentNode.prototype.type = 'FunctionAssignmentNode';
        FunctionAssignmentNode.prototype.isFunctionAssignmentNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        FunctionAssignmentNode.prototype._compile = function (math, argNames) {
          var childArgNames = Object.create(argNames);
          forEach(this.params, function (param) {
            childArgNames[param] = true;
          }); // compile the function expression with the child args

          var evalExpr = this.expr._compile(math, childArgNames);

          var name = this.name;
          var params = this.params;
          var signature = join(this.types, ',');
          var syntax = name + '(' + join(this.params, ', ') + ')';
          return function evalFunctionAssignmentNode(scope, args, context) {
            var signatures = {};

            signatures[signature] = function () {
              var childArgs = Object.create(args);

              for (var i = 0; i < params.length; i++) {
                childArgs[params[i]] = arguments[i];
              }

              return evalExpr(scope, childArgs, context);
            };

            var fn = typed(name, signatures);
            fn.syntax = syntax;
            setSafeProperty(scope, name, fn);
            return fn;
          };
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        FunctionAssignmentNode.prototype.forEach = function (callback) {
          callback(this.expr, 'expr', this);
        };
        /**
         * Create a new FunctionAssignmentNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {FunctionAssignmentNode} Returns a transformed copy of the node
         */


        FunctionAssignmentNode.prototype.map = function (callback) {
          var expr = this._ifNode(callback(this.expr, 'expr', this));

          return new FunctionAssignmentNode(this.name, this.params.slice(0), expr);
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {FunctionAssignmentNode}
         */


        FunctionAssignmentNode.prototype.clone = function () {
          return new FunctionAssignmentNode(this.name, this.params.slice(0), this.expr);
        };
        /**
         * Is parenthesis needed?
         * @param {Node} node
         * @param {Object} parenthesis
         * @private
         */


        function needParenthesis(node, parenthesis) {
          var precedence = operators.getPrecedence(node, parenthesis);
          var exprPrecedence = operators.getPrecedence(node.expr, parenthesis);
          return parenthesis === 'all' || exprPrecedence !== null && exprPrecedence <= precedence;
        }
        /**
         * get string representation
         * @param {Object} options
         * @return {string} str
         */


        FunctionAssignmentNode.prototype._toString = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var expr = this.expr.toString(options);

          if (needParenthesis(this, parenthesis)) {
            expr = '(' + expr + ')';
          }

          return this.name + '(' + this.params.join(', ') + ') = ' + expr;
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        FunctionAssignmentNode.prototype.toJSON = function () {
          var types = this.types;
          return {
            mathjs: 'FunctionAssignmentNode',
            name: this.name,
            params: this.params.map(function (param, index) {
              return {
                name: param,
                type: types[index]
              };
            }),
            expr: this.expr
          };
        };
        /**
         * Instantiate an FunctionAssignmentNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "FunctionAssignmentNode", name: ..., params: ..., expr: ...}`,
         *                       where mathjs is optional
         * @returns {FunctionAssignmentNode}
         */


        FunctionAssignmentNode.fromJSON = function (json) {
          return new FunctionAssignmentNode(json.name, json.params, json.expr);
        };
        /**
         * get HTML representation
         * @param {Object} options
         * @return {string} str
         */


        FunctionAssignmentNode.prototype.toHTML = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var params = [];

          for (var i = 0; i < this.params.length; i++) {
            params.push('<span class="math-symbol math-parameter">' + escape(this.params[i]) + '</span>');
          }

          var expr = this.expr.toHTML(options);

          if (needParenthesis(this, parenthesis)) {
            expr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + expr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
          }

          return '<span class="math-function">' + escape(this.name) + '</span>' + '<span class="math-parenthesis math-round-parenthesis">(</span>' + params.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + expr;
        };
        /**
         * get LaTeX representation
         * @param {Object} options
         * @return {string} str
         */


        FunctionAssignmentNode.prototype._toTex = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var expr = this.expr.toTex(options);

          if (needParenthesis(this, parenthesis)) {
            expr = "\\left(".concat(expr, "\\right)");
          }

          return '\\mathrm{' + this.name + '}\\left(' + this.params.map(latex.toSymbol).join(',') + '\\right):=' + expr;
        };

        return FunctionAssignmentNode;
      }

      exports.name = 'FunctionAssignmentNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 784 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // Map the characters to escape to their escaped values. The list is derived
      // from http://www.cespedes.org/blog/85/how-to-escape-latex-special-characters

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var defaultEscapes = {
        "{": "\\{",
        "}": "\\}",
        "\\": "\\textbackslash{}",
        "#": "\\#",
        $: "\\$",
        "%": "\\%",
        "&": "\\&",
        "^": "\\textasciicircum{}",
        _: "\\_",
        "~": "\\textasciitilde{}"
      };
      var formatEscapes = {
        "\u2013": "\\--",
        "\u2014": "\\---",
        " ": "~",
        "\t": "\\qquad{}",
        "\r\n": "\\newline{}",
        "\n": "\\newline{}"
      };

      var defaultEscapeMapFn = function defaultEscapeMapFn(defaultEscapes, formatEscapes) {
        return _extends({}, defaultEscapes, formatEscapes);
      };
      /**
       * Escape a string to be used in LaTeX documents.
       * @param {string} str the string to be escaped.
       * @param {boolean} params.preserveFormatting whether formatting escapes should
       *  be performed (default: false).
       * @param {function} params.escapeMapFn the function to modify the escape maps.
       * @return {string} the escaped string, ready to be used in LaTeX.
       */


      module.exports = function (str) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$preserveFormatti = _ref.preserveFormatting,
            preserveFormatting = _ref$preserveFormatti === undefined ? false : _ref$preserveFormatti,
            _ref$escapeMapFn = _ref.escapeMapFn,
            escapeMapFn = _ref$escapeMapFn === undefined ? defaultEscapeMapFn : _ref$escapeMapFn;

        var runningStr = String(str);
        var result = "";
        var escapes = escapeMapFn(_extends({}, defaultEscapes), preserveFormatting ? _extends({}, formatEscapes) : {});
        var escapeKeys = Object.keys(escapes); // as it is reused later on
        // Algorithm: Go through the string character by character, if it matches
        // with one of the special characters then we'll replace it with the escaped
        // version.

        var _loop = function _loop() {
          var specialCharFound = false;
          escapeKeys.forEach(function (key, index) {
            if (specialCharFound) {
              return;
            }

            if (runningStr.length >= key.length && runningStr.slice(0, key.length) === key) {
              result += escapes[escapeKeys[index]];
              runningStr = runningStr.slice(key.length, runningStr.length);
              specialCharFound = true;
            }
          });

          if (!specialCharFound) {
            result += runningStr.slice(0, 1);
            runningStr = runningStr.slice(1, runningStr.length);
          }
        };

        while (runningStr) {
          _loop();
        }

        return result;
      };
      /***/

    },
    /* 785 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var format = __webpack_require__(79).format;

      var escapeLatex = __webpack_require__(72).escape;

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        var getType = load(__webpack_require__(131));
        /**
         * A ConstantNode holds a constant value like a number or string.
         *
         * Usage:
         *
         *     new ConstantNode(2.3)
         *     new ConstantNode('hello')
         *
         * @param {*} value    Value can be any type (number, BigNumber, string, ...)
         * @constructor ConstantNode
         * @extends {Node}
         */

        function ConstantNode(value) {
          if (!(this instanceof ConstantNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          if (arguments.length === 2) {
            // TODO: remove deprecation error some day (created 2018-01-23)
            throw new SyntaxError('new ConstantNode(valueStr, valueType) is not supported anymore since math v4.0.0. Use new ConstantNode(value) instead, where value is a non-stringified value.');
          }

          this.value = value;
        }

        ConstantNode.prototype = new Node();
        ConstantNode.prototype.type = 'ConstantNode';
        ConstantNode.prototype.isConstantNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        ConstantNode.prototype._compile = function (math, argNames) {
          var value = this.value;
          return function evalConstantNode() {
            return value;
          };
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        ConstantNode.prototype.forEach = function (callback) {} // nothing to do, we don't have childs

        /**
         * Create a new ConstantNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node) : Node} callback
         * @returns {ConstantNode} Returns a clone of the node
         */
        ;

        ConstantNode.prototype.map = function (callback) {
          return this.clone();
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {ConstantNode}
         */


        ConstantNode.prototype.clone = function () {
          return new ConstantNode(this.value);
        };
        /**
         * Get string representation
         * @param {Object} options
         * @return {string} str
         */


        ConstantNode.prototype._toString = function (options) {
          return format(this.value, options);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         */


        ConstantNode.prototype.toHTML = function (options) {
          var value = this._toString(options);

          switch (getType(this.value)) {
            case 'number':
            case 'BigNumber':
            case 'Fraction':
              return '<span class="math-number">' + value + '</span>';

            case 'string':
              return '<span class="math-string">' + value + '</span>';

            case 'boolean':
              return '<span class="math-boolean">' + value + '</span>';

            case 'null':
              return '<span class="math-null-symbol">' + value + '</span>';

            case 'undefined':
              return '<span class="math-undefined">' + value + '</span>';

            default:
              return '<span class="math-symbol">' + value + '</span>';
          }
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        ConstantNode.prototype.toJSON = function () {
          return {
            mathjs: 'ConstantNode',
            value: this.value
          };
        };
        /**
         * Instantiate a ConstantNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "SymbolNode", value: 2.3}`,
         *                       where mathjs is optional
         * @returns {ConstantNode}
         */


        ConstantNode.fromJSON = function (json) {
          return new ConstantNode(json.value);
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         */


        ConstantNode.prototype._toTex = function (options) {
          var value = this._toString(options);

          switch (getType(this.value)) {
            case 'string':
              return '\\mathtt{' + escapeLatex(value) + '}';

            case 'number':
            case 'BigNumber':
              var index = value.toLowerCase().indexOf('e');

              if (index !== -1) {
                return value.substring(0, index) + '\\cdot10^{' + value.substring(index + 1) + '}';
              }

              return value;

            case 'Fraction':
              return this.value.toLatex();

            default:
              return value;
          }
        };

        return ConstantNode;
      }

      exports.name = 'ConstantNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 786 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var operators = __webpack_require__(171);

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        var mathTypeOf = load(__webpack_require__(131));
        /**
         * A lazy evaluating conditional operator: 'condition ? trueExpr : falseExpr'
         *
         * @param {Node} condition   Condition, must result in a boolean
         * @param {Node} trueExpr    Expression evaluated when condition is true
         * @param {Node} falseExpr   Expression evaluated when condition is true
         *
         * @constructor ConditionalNode
         * @extends {Node}
         */

        function ConditionalNode(condition, trueExpr, falseExpr) {
          if (!(this instanceof ConditionalNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          if (!type.isNode(condition)) throw new TypeError('Parameter condition must be a Node');
          if (!type.isNode(trueExpr)) throw new TypeError('Parameter trueExpr must be a Node');
          if (!type.isNode(falseExpr)) throw new TypeError('Parameter falseExpr must be a Node');
          this.condition = condition;
          this.trueExpr = trueExpr;
          this.falseExpr = falseExpr;
        }

        ConditionalNode.prototype = new Node();
        ConditionalNode.prototype.type = 'ConditionalNode';
        ConditionalNode.prototype.isConditionalNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        ConditionalNode.prototype._compile = function (math, argNames) {
          var evalCondition = this.condition._compile(math, argNames);

          var evalTrueExpr = this.trueExpr._compile(math, argNames);

          var evalFalseExpr = this.falseExpr._compile(math, argNames);

          return function evalConditionalNode(scope, args, context) {
            return testCondition(evalCondition(scope, args, context)) ? evalTrueExpr(scope, args, context) : evalFalseExpr(scope, args, context);
          };
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        ConditionalNode.prototype.forEach = function (callback) {
          callback(this.condition, 'condition', this);
          callback(this.trueExpr, 'trueExpr', this);
          callback(this.falseExpr, 'falseExpr', this);
        };
        /**
         * Create a new ConditionalNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {ConditionalNode} Returns a transformed copy of the node
         */


        ConditionalNode.prototype.map = function (callback) {
          return new ConditionalNode(this._ifNode(callback(this.condition, 'condition', this)), this._ifNode(callback(this.trueExpr, 'trueExpr', this)), this._ifNode(callback(this.falseExpr, 'falseExpr', this)));
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {ConditionalNode}
         */


        ConditionalNode.prototype.clone = function () {
          return new ConditionalNode(this.condition, this.trueExpr, this.falseExpr);
        };
        /**
         * Get string representation
         * @param {Object} options
         * @return {string} str
         */


        ConditionalNode.prototype._toString = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var precedence = operators.getPrecedence(this, parenthesis); // Enclose Arguments in parentheses if they are an OperatorNode
          // or have lower or equal precedence
          // NOTE: enclosing all OperatorNodes in parentheses is a decision
          // purely based on aesthetics and readability

          var condition = this.condition.toString(options);
          var conditionPrecedence = operators.getPrecedence(this.condition, parenthesis);

          if (parenthesis === 'all' || this.condition.type === 'OperatorNode' || conditionPrecedence !== null && conditionPrecedence <= precedence) {
            condition = '(' + condition + ')';
          }

          var trueExpr = this.trueExpr.toString(options);
          var truePrecedence = operators.getPrecedence(this.trueExpr, parenthesis);

          if (parenthesis === 'all' || this.trueExpr.type === 'OperatorNode' || truePrecedence !== null && truePrecedence <= precedence) {
            trueExpr = '(' + trueExpr + ')';
          }

          var falseExpr = this.falseExpr.toString(options);
          var falsePrecedence = operators.getPrecedence(this.falseExpr, parenthesis);

          if (parenthesis === 'all' || this.falseExpr.type === 'OperatorNode' || falsePrecedence !== null && falsePrecedence <= precedence) {
            falseExpr = '(' + falseExpr + ')';
          }

          return condition + ' ? ' + trueExpr + ' : ' + falseExpr;
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        ConditionalNode.prototype.toJSON = function () {
          return {
            mathjs: 'ConditionalNode',
            condition: this.condition,
            trueExpr: this.trueExpr,
            falseExpr: this.falseExpr
          };
        };
        /**
         * Instantiate an ConditionalNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "ConditionalNode", "condition": ..., "trueExpr": ..., "falseExpr": ...}`,
         *                       where mathjs is optional
         * @returns {ConditionalNode}
         */


        ConditionalNode.fromJSON = function (json) {
          return new ConditionalNode(json.condition, json.trueExpr, json.falseExpr);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         */


        ConditionalNode.prototype.toHTML = function (options) {
          var parenthesis = options && options.parenthesis ? options.parenthesis : 'keep';
          var precedence = operators.getPrecedence(this, parenthesis); // Enclose Arguments in parentheses if they are an OperatorNode
          // or have lower or equal precedence
          // NOTE: enclosing all OperatorNodes in parentheses is a decision
          // purely based on aesthetics and readability

          var condition = this.condition.toHTML(options);
          var conditionPrecedence = operators.getPrecedence(this.condition, parenthesis);

          if (parenthesis === 'all' || this.condition.type === 'OperatorNode' || conditionPrecedence !== null && conditionPrecedence <= precedence) {
            condition = '<span class="math-parenthesis math-round-parenthesis">(</span>' + condition + '<span class="math-parenthesis math-round-parenthesis">)</span>';
          }

          var trueExpr = this.trueExpr.toHTML(options);
          var truePrecedence = operators.getPrecedence(this.trueExpr, parenthesis);

          if (parenthesis === 'all' || this.trueExpr.type === 'OperatorNode' || truePrecedence !== null && truePrecedence <= precedence) {
            trueExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + trueExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
          }

          var falseExpr = this.falseExpr.toHTML(options);
          var falsePrecedence = operators.getPrecedence(this.falseExpr, parenthesis);

          if (parenthesis === 'all' || this.falseExpr.type === 'OperatorNode' || falsePrecedence !== null && falsePrecedence <= precedence) {
            falseExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + falseExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
          }

          return condition + '<span class="math-operator math-conditional-operator">?</span>' + trueExpr + '<span class="math-operator math-conditional-operator">:</span>' + falseExpr;
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         */


        ConditionalNode.prototype._toTex = function (options) {
          return '\\begin{cases} {' + this.trueExpr.toTex(options) + '}, &\\quad{\\text{if }\\;' + this.condition.toTex(options) + '}\\\\{' + this.falseExpr.toTex(options) + '}, &\\quad{\\text{otherwise}}\\end{cases}';
        };
        /**
         * Test whether a condition is met
         * @param {*} condition
         * @returns {boolean} true if condition is true or non-zero, else false
         */


        function testCondition(condition) {
          if (typeof condition === 'number' || typeof condition === 'boolean' || typeof condition === 'string') {
            return !!condition;
          }

          if (condition) {
            if (type.isBigNumber(condition)) {
              return !condition.isZero();
            }

            if (type.isComplex(condition)) {
              return !!(condition.re || condition.im);
            }

            if (type.isUnit(condition)) {
              return !!condition.value;
            }
          }

          if (condition === null || condition === undefined) {
            return false;
          }

          throw new TypeError('Unsupported type of condition "' + mathTypeOf(condition) + '"');
        }

        return ConditionalNode;
      }

      exports.name = 'ConditionalNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 787 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function factory(type, config, load, typed) {
        /**
         * A ResultSet contains a list or results
         * @class ResultSet
         * @param {Array} entries
         * @constructor ResultSet
         */
        function ResultSet(entries) {
          if (!(this instanceof ResultSet)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          this.entries = entries || [];
        }
        /**
         * Attach type information
         */


        ResultSet.prototype.type = 'ResultSet';
        ResultSet.prototype.isResultSet = true;
        /**
         * Returns the array with results hold by this ResultSet
         * @memberof ResultSet
         * @returns {Array} entries
         */

        ResultSet.prototype.valueOf = function () {
          return this.entries;
        };
        /**
         * Returns the stringified results of the ResultSet
         * @memberof ResultSet
         * @returns {string} string
         */


        ResultSet.prototype.toString = function () {
          return '[' + this.entries.join(', ') + ']';
        };
        /**
         * Get a JSON representation of the ResultSet
         * @memberof ResultSet
         * @returns {Object} Returns a JSON object structured as:
         *                   `{"mathjs": "ResultSet", "entries": [...]}`
         */


        ResultSet.prototype.toJSON = function () {
          return {
            mathjs: 'ResultSet',
            entries: this.entries
          };
        };
        /**
         * Instantiate a ResultSet from a JSON object
         * @memberof ResultSet
         * @param {Object} json  A JSON object structured as:
         *                       `{"mathjs": "ResultSet", "entries": [...]}`
         * @return {ResultSet}
         */


        ResultSet.fromJSON = function (json) {
          return new ResultSet(json.entries);
        };

        return ResultSet;
      }

      exports.name = 'ResultSet';
      exports.path = 'type';
      exports.factory = factory;
      /***/
    },
    /* 788 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var forEach = __webpack_require__(48).forEach;

      var map = __webpack_require__(48).map;

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        var ResultSet = load(__webpack_require__(787));
        /**
         * @constructor BlockNode
         * @extends {Node}
         * Holds a set with blocks
         * @param {Array.<{node: Node} | {node: Node, visible: boolean}>} blocks
         *            An array with blocks, where a block is constructed as an Object
         *            with properties block, which is a Node, and visible, which is
         *            a boolean. The property visible is optional and is true by default
         */

        function BlockNode(blocks) {
          if (!(this instanceof BlockNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          } // validate input, copy blocks


          if (!Array.isArray(blocks)) throw new Error('Array expected');
          this.blocks = blocks.map(function (block) {
            var node = block && block.node;
            var visible = block && block.visible !== undefined ? block.visible : true;
            if (!type.isNode(node)) throw new TypeError('Property "node" must be a Node');
            if (typeof visible !== 'boolean') throw new TypeError('Property "visible" must be a boolean');
            return {
              node: node,
              visible: visible
            };
          });
        }

        BlockNode.prototype = new Node();
        BlockNode.prototype.type = 'BlockNode';
        BlockNode.prototype.isBlockNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        BlockNode.prototype._compile = function (math, argNames) {
          var evalBlocks = map(this.blocks, function (block) {
            return {
              eval: block.node._compile(math, argNames),
              visible: block.visible
            };
          });
          return function evalBlockNodes(scope, args, context) {
            var results = [];
            forEach(evalBlocks, function evalBlockNode(block) {
              var result = block.eval(scope, args, context);

              if (block.visible) {
                results.push(result);
              }
            });
            return new ResultSet(results);
          };
        };
        /**
         * Execute a callback for each of the child blocks of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        BlockNode.prototype.forEach = function (callback) {
          for (var i = 0; i < this.blocks.length; i++) {
            callback(this.blocks[i].node, 'blocks[' + i + '].node', this);
          }
        };
        /**
         * Create a new BlockNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {BlockNode} Returns a transformed copy of the node
         */


        BlockNode.prototype.map = function (callback) {
          var blocks = [];

          for (var i = 0; i < this.blocks.length; i++) {
            var block = this.blocks[i];

            var node = this._ifNode(callback(block.node, 'blocks[' + i + '].node', this));

            blocks[i] = {
              node: node,
              visible: block.visible
            };
          }

          return new BlockNode(blocks);
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {BlockNode}
         */


        BlockNode.prototype.clone = function () {
          var blocks = this.blocks.map(function (block) {
            return {
              node: block.node,
              visible: block.visible
            };
          });
          return new BlockNode(blocks);
        };
        /**
         * Get string representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        BlockNode.prototype._toString = function (options) {
          return this.blocks.map(function (param) {
            return param.node.toString(options) + (param.visible ? '' : ';');
          }).join('\n');
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        BlockNode.prototype.toJSON = function () {
          return {
            mathjs: 'BlockNode',
            blocks: this.blocks
          };
        };
        /**
         * Instantiate an BlockNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "BlockNode", blocks: [{node: ..., visible: false}, ...]}`,
         *                       where mathjs is optional
         * @returns {BlockNode}
         */


        BlockNode.fromJSON = function (json) {
          return new BlockNode(json.blocks);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        BlockNode.prototype.toHTML = function (options) {
          return this.blocks.map(function (param) {
            return param.node.toHTML(options) + (param.visible ? '' : '<span class="math-separator">;</span>');
          }).join('<span class="math-separator"><br /></span>');
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         */


        BlockNode.prototype._toTex = function (options) {
          return this.blocks.map(function (param) {
            return param.node.toTex(options) + (param.visible ? '' : ';');
          }).join('\\;\\;\n');
        };

        return BlockNode;
      }

      exports.name = 'BlockNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 789 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      var errorTransform = __webpack_require__(408).transform;

      var setSafeProperty = __webpack_require__(88).setSafeProperty;

      function factory(type, config, load, typed) {
        var subset = load(__webpack_require__(305));
        var matrix = load(__webpack_require__(46));
        /**
         * Replace part of an object:
         *
         * - Assign a property to an object
         * - Replace a part of a string
         * - Replace a matrix subset
         *
         * @param {Object | Array | Matrix | string} object
         * @param {Index} index
         * @param {*} value
         * @return {Object | Array | Matrix | string} Returns the original object
         *                                            except in case of a string
         */
        // TODO: change assign to return the value instead of the object

        return function assign(object, index, value) {
          try {
            if (Array.isArray(object)) {
              return matrix(object).subset(index, value).valueOf();
            } else if (object && typeof object.subset === 'function') {
              // Matrix
              return object.subset(index, value);
            } else if (typeof object === 'string') {
              // TODO: move setStringSubset into a separate util file, use that
              return subset(object, index, value);
            } else if (_typeof(object) === 'object') {
              if (!index.isObjectProperty()) {
                throw TypeError('Cannot apply a numeric index as object property');
              }

              setSafeProperty(object, index.getObjectProperty(), value);
              return object;
            } else {
              throw new TypeError('Cannot apply index: unsupported type of object');
            }
          } catch (err) {
            throw errorTransform(err);
          }
        };
      }

      exports.factory = factory;
      /***/
    },
    /* 790 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var getSafeProperty = __webpack_require__(88).getSafeProperty;

      var setSafeProperty = __webpack_require__(88).setSafeProperty;

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        var assign = load(__webpack_require__(789));
        var access = load(__webpack_require__(409));

        var operators = __webpack_require__(171);
        /**
         * @constructor AssignmentNode
         * @extends {Node}
         *
         * Define a symbol, like `a=3.2`, update a property like `a.b=3.2`, or
         * replace a subset of a matrix like `A[2,2]=42`.
         *
         * Syntax:
         *
         *     new AssignmentNode(symbol, value)
         *     new AssignmentNode(object, index, value)
         *
         * Usage:
         *
         *    new AssignmentNode(new SymbolNode('a'), new ConstantNode(2))                       // a=2
         *    new AssignmentNode(new SymbolNode('a'), new IndexNode('b'), new ConstantNode(2))   // a.b=2
         *    new AssignmentNode(new SymbolNode('a'), new IndexNode(1, 2), new ConstantNode(3))  // a[1,2]=3
         *
         * @param {SymbolNode | AccessorNode} object  Object on which to assign a value
         * @param {IndexNode} [index=null]            Index, property name or matrix
         *                                            index. Optional. If not provided
         *                                            and `object` is a SymbolNode,
         *                                            the property is assigned to the
         *                                            global scope.
         * @param {Node} value                        The value to be assigned
         */


        function AssignmentNode(object, index, value) {
          if (!(this instanceof AssignmentNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          this.object = object;
          this.index = value ? index : null;
          this.value = value || index; // validate input

          if (!type.isSymbolNode(object) && !type.isAccessorNode(object)) {
            throw new TypeError('SymbolNode or AccessorNode expected as "object"');
          }

          if (type.isSymbolNode(object) && object.name === 'end') {
            throw new Error('Cannot assign to symbol "end"');
          }

          if (this.index && !type.isIndexNode(this.index)) {
            // index is optional
            throw new TypeError('IndexNode expected as "index"');
          }

          if (!type.isNode(this.value)) {
            throw new TypeError('Node expected as "value"');
          } // readonly property name


          Object.defineProperty(this, 'name', {
            get: function () {
              if (this.index) {
                return this.index.isObjectProperty() ? this.index.getObjectProperty() : '';
              } else {
                return this.object.name || '';
              }
            }.bind(this),
            set: function set() {
              throw new Error('Cannot assign a new name, name is read-only');
            }
          });
        }

        AssignmentNode.prototype = new Node();
        AssignmentNode.prototype.type = 'AssignmentNode';
        AssignmentNode.prototype.isAssignmentNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        AssignmentNode.prototype._compile = function (math, argNames) {
          var evalObject = this.object._compile(math, argNames);

          var evalIndex = this.index ? this.index._compile(math, argNames) : null;

          var evalValue = this.value._compile(math, argNames);

          var name = this.object.name;

          if (!this.index) {
            // apply a variable to the scope, for example `a=2`
            if (!type.isSymbolNode(this.object)) {
              throw new TypeError('SymbolNode expected as object');
            }

            return function evalAssignmentNode(scope, args, context) {
              return setSafeProperty(scope, name, evalValue(scope, args, context));
            };
          } else if (this.index.isObjectProperty()) {
            // apply an object property for example `a.b=2`
            var prop = this.index.getObjectProperty();
            return function evalAssignmentNode(scope, args, context) {
              var object = evalObject(scope, args, context);
              var value = evalValue(scope, args, context);
              return setSafeProperty(object, prop, value);
            };
          } else if (type.isSymbolNode(this.object)) {
            // update a matrix subset, for example `a[2]=3`
            return function evalAssignmentNode(scope, args, context) {
              var childObject = evalObject(scope, args, context);
              var value = evalValue(scope, args, context);
              var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context

              setSafeProperty(scope, name, assign(childObject, index, value));
              return value;
            };
          } else {
            // type.isAccessorNode(node.object) === true
            // update a matrix subset, for example `a.b[2]=3`
            // we will not use the compile function of the AccessorNode, but compile it
            // ourselves here as we need the parent object of the AccessorNode:
            // wee need to apply the updated object to parent object
            var evalParentObject = this.object.object._compile(math, argNames);

            if (this.object.index.isObjectProperty()) {
              var parentProp = this.object.index.getObjectProperty();
              return function evalAssignmentNode(scope, args, context) {
                var parent = evalParentObject(scope, args, context);
                var childObject = getSafeProperty(parent, parentProp);
                var index = evalIndex(scope, args, childObject); // Important: we pass childObject instead of context

                var value = evalValue(scope, args, context);
                setSafeProperty(parent, parentProp, assign(childObject, index, value));
                return value;
              };
            } else {
              // if some parameters use the 'end' parameter, we need to calculate the size
              var evalParentIndex = this.object.index._compile(math, argNames);

              return function evalAssignmentNode(scope, args, context) {
                var parent = evalParentObject(scope, args, context);
                var parentIndex = evalParentIndex(scope, args, parent); // Important: we pass parent instead of context

                var childObject = access(parent, parentIndex);
                var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context

                var value = evalValue(scope, args, context);
                assign(parent, parentIndex, assign(childObject, index, value));
                return value;
              };
            }
          }
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        AssignmentNode.prototype.forEach = function (callback) {
          callback(this.object, 'object', this);

          if (this.index) {
            callback(this.index, 'index', this);
          }

          callback(this.value, 'value', this);
        };
        /**
         * Create a new AssignmentNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {AssignmentNode} Returns a transformed copy of the node
         */


        AssignmentNode.prototype.map = function (callback) {
          var object = this._ifNode(callback(this.object, 'object', this));

          var index = this.index ? this._ifNode(callback(this.index, 'index', this)) : null;

          var value = this._ifNode(callback(this.value, 'value', this));

          return new AssignmentNode(object, index, value);
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {AssignmentNode}
         */


        AssignmentNode.prototype.clone = function () {
          return new AssignmentNode(this.object, this.index, this.value);
        };
        /*
         * Is parenthesis needed?
         * @param {node} node
         * @param {string} [parenthesis='keep']
         * @private
         */


        function needParenthesis(node, parenthesis) {
          if (!parenthesis) {
            parenthesis = 'keep';
          }

          var precedence = operators.getPrecedence(node, parenthesis);
          var exprPrecedence = operators.getPrecedence(node.value, parenthesis);
          return parenthesis === 'all' || exprPrecedence !== null && exprPrecedence <= precedence;
        }
        /**
         * Get string representation
         * @param {Object} options
         * @return {string}
         */


        AssignmentNode.prototype._toString = function (options) {
          var object = this.object.toString(options);
          var index = this.index ? this.index.toString(options) : '';
          var value = this.value.toString(options);

          if (needParenthesis(this, options && options.parenthesis)) {
            value = '(' + value + ')';
          }

          return object + index + ' = ' + value;
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        AssignmentNode.prototype.toJSON = function () {
          return {
            mathjs: 'AssignmentNode',
            object: this.object,
            index: this.index,
            value: this.value
          };
        };
        /**
         * Instantiate an AssignmentNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "AssignmentNode", object: ..., index: ..., value: ...}`,
         *                       where mathjs is optional
         * @returns {AssignmentNode}
         */


        AssignmentNode.fromJSON = function (json) {
          return new AssignmentNode(json.object, json.index, json.value);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string}
         */


        AssignmentNode.prototype.toHTML = function (options) {
          var object = this.object.toHTML(options);
          var index = this.index ? this.index.toHTML(options) : '';
          var value = this.value.toHTML(options);

          if (needParenthesis(this, options && options.parenthesis)) {
            value = '<span class="math-paranthesis math-round-parenthesis">(</span>' + value + '<span class="math-paranthesis math-round-parenthesis">)</span>';
          }

          return object + index + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + value;
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string}
         */


        AssignmentNode.prototype._toTex = function (options) {
          var object = this.object.toTex(options);
          var index = this.index ? this.index.toTex(options) : '';
          var value = this.value.toTex(options);

          if (needParenthesis(this, options && options.parenthesis)) {
            value = "\\left(".concat(value, "\\right)");
          }

          return object + index + ':=' + value;
        };

        return AssignmentNode;
      }

      exports.name = 'AssignmentNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 791 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var map = __webpack_require__(48).map;

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        /**
         * @constructor ArrayNode
         * @extends {Node}
         * Holds an 1-dimensional array with items
         * @param {Node[]} [items]   1 dimensional array with items
         */

        function ArrayNode(items) {
          if (!(this instanceof ArrayNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          this.items = items || []; // validate input

          if (!Array.isArray(this.items) || !this.items.every(type.isNode)) {
            throw new TypeError('Array containing Nodes expected');
          } // TODO: deprecated since v3, remove some day


          var deprecated = function deprecated() {
            throw new Error('Property `ArrayNode.nodes` is deprecated, use `ArrayNode.items` instead');
          };

          Object.defineProperty(this, 'nodes', {
            get: deprecated,
            set: deprecated
          });
        }

        ArrayNode.prototype = new Node();
        ArrayNode.prototype.type = 'ArrayNode';
        ArrayNode.prototype.isArrayNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        ArrayNode.prototype._compile = function (math, argNames) {
          var evalItems = map(this.items, function (item) {
            return item._compile(math, argNames);
          });
          var asMatrix = math.config().matrix !== 'Array';

          if (asMatrix) {
            var matrix = math.matrix;
            return function evalArrayNode(scope, args, context) {
              return matrix(map(evalItems, function (evalItem) {
                return evalItem(scope, args, context);
              }));
            };
          } else {
            return function evalArrayNode(scope, args, context) {
              return map(evalItems, function (evalItem) {
                return evalItem(scope, args, context);
              });
            };
          }
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        ArrayNode.prototype.forEach = function (callback) {
          for (var i = 0; i < this.items.length; i++) {
            var node = this.items[i];
            callback(node, 'items[' + i + ']', this);
          }
        };
        /**
         * Create a new ArrayNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {ArrayNode} Returns a transformed copy of the node
         */


        ArrayNode.prototype.map = function (callback) {
          var items = [];

          for (var i = 0; i < this.items.length; i++) {
            items[i] = this._ifNode(callback(this.items[i], 'items[' + i + ']', this));
          }

          return new ArrayNode(items);
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {ArrayNode}
         */


        ArrayNode.prototype.clone = function () {
          return new ArrayNode(this.items.slice(0));
        };
        /**
         * Get string representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        ArrayNode.prototype._toString = function (options) {
          var items = this.items.map(function (node) {
            return node.toString(options);
          });
          return '[' + items.join(', ') + ']';
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        ArrayNode.prototype.toJSON = function () {
          return {
            mathjs: 'ArrayNode',
            items: this.items
          };
        };
        /**
         * Instantiate an ArrayNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "ArrayNode", items: [...]}`,
         *                       where mathjs is optional
         * @returns {ArrayNode}
         */


        ArrayNode.fromJSON = function (json) {
          return new ArrayNode(json.items);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string} str
         * @override
         */


        ArrayNode.prototype.toHTML = function (options) {
          var items = this.items.map(function (node) {
            return node.toHTML(options);
          });
          return '<span class="math-parenthesis math-square-parenthesis">[</span>' + items.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string} str
         */


        ArrayNode.prototype._toTex = function (options) {
          var s = '\\begin{bmatrix}';
          this.items.forEach(function (node) {
            if (node.items) {
              s += node.items.map(function (childNode) {
                return childNode.toTex(options);
              }).join('&');
            } else {
              s += node.toTex(options);
            } // new line


            s += '\\\\';
          });
          s += '\\end{bmatrix}';
          return s;
        };

        return ArrayNode;
      }

      exports.name = 'ArrayNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 792 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var objectUtils = __webpack_require__(59);
      /**
       * Convert a BigNumber to a formatted string representation.
       *
       * Syntax:
       *
       *    format(value)
       *    format(value, options)
       *    format(value, precision)
       *    format(value, fn)
       *
       * Where:
       *
       *    {number} value   The value to be formatted
       *    {Object} options An object with formatting options. Available options:
       *                     {string} notation
       *                         Number notation. Choose from:
       *                         'fixed'          Always use regular number notation.
       *                                          For example '123.40' and '14000000'
       *                         'exponential'    Always use exponential notation.
       *                                          For example '1.234e+2' and '1.4e+7'
       *                         'auto' (default) Regular number notation for numbers
       *                                          having an absolute value between
       *                                          `lower` and `upper` bounds, and uses
       *                                          exponential notation elsewhere.
       *                                          Lower bound is included, upper bound
       *                                          is excluded.
       *                                          For example '123.4' and '1.4e7'.
       *                     {number} precision   A number between 0 and 16 to round
       *                                          the digits of the number.
       *                                          In case of notations 'exponential',
       *                                          'engineering', and 'auto',
       *                                          `precision` defines the total
       *                                          number of significant digits returned.
       *                                          In case of notation 'fixed',
       *                                          `precision` defines the number of
       *                                          significant digits after the decimal
       *                                          point.
       *                                          `precision` is undefined by default.
       *                     {number} lowerExp    Exponent determining the lower boundary
       *                                          for formatting a value with an exponent
       *                                          when `notation='auto`.
       *                                          Default value is `-3`.
       *                     {number} upperExp    Exponent determining the upper boundary
       *                                          for formatting a value with an exponent
       *                                          when `notation='auto`.
       *                                          Default value is `5`.
       *    {Function} fn    A custom formatting function. Can be used to override the
       *                     built-in notations. Function `fn` is called with `value` as
       *                     parameter and must return a string. Is useful for example to
       *                     format all values inside a matrix in a particular way.
       *
       * Examples:
       *
       *    format(6.4)                                        // '6.4'
       *    format(1240000)                                    // '1.24e6'
       *    format(1/3)                                        // '0.3333333333333333'
       *    format(1/3, 3)                                     // '0.333'
       *    format(21385, 2)                                   // '21000'
       *    format(12e8, {notation: 'fixed'})                  // returns '1200000000'
       *    format(2.3,    {notation: 'fixed', precision: 4})  // returns '2.3000'
       *    format(52.8,   {notation: 'exponential'})          // returns '5.28e+1'
       *    format(12400,  {notation: 'engineering'})          // returns '12.400e+3'
       *
       * @param {BigNumber} value
       * @param {Object | Function | number} [options]
       * @return {string} str The formatted value
       */


      exports.format = function (value, options) {
        if (typeof options === 'function') {
          // handle format(value, fn)
          return options(value);
        } // handle special cases


        if (!value.isFinite()) {
          return value.isNaN() ? 'NaN' : value.gt(0) ? 'Infinity' : '-Infinity';
        } // default values for options


        var notation = 'auto';
        var precision;

        if (options !== undefined) {
          // determine notation from options
          if (options.notation) {
            notation = options.notation;
          } // determine precision from options


          if (typeof options === 'number') {
            precision = options;
          } else if (options.precision) {
            precision = options.precision;
          }
        } // handle the various notations


        switch (notation) {
          case 'fixed':
            return exports.toFixed(value, precision);

          case 'exponential':
            return exports.toExponential(value, precision);

          case 'engineering':
            return exports.toEngineering(value, precision);

          case 'auto':
            // TODO: clean up some day. Deprecated since: 2018-01-24
            // @deprecated upper and lower are replaced with upperExp and lowerExp since v4.0.0
            if (options && options.exponential && (options.exponential.lower !== undefined || options.exponential.upper !== undefined)) {
              var fixedOptions = objectUtils.map(options, function (x) {
                return x;
              });
              fixedOptions.exponential = undefined;

              if (options.exponential.lower !== undefined) {
                fixedOptions.lowerExp = Math.round(Math.log(options.exponential.lower) / Math.LN10);
              }

              if (options.exponential.upper !== undefined) {
                fixedOptions.upperExp = Math.round(Math.log(options.exponential.upper) / Math.LN10);
              }

              console.warn('Deprecation warning: Formatting options exponential.lower and exponential.upper ' + '(minimum and maximum value) ' + 'are replaced with exponential.lowerExp and exponential.upperExp ' + '(minimum and maximum exponent) since version 4.0.0. ' + 'Replace ' + JSON.stringify(options) + ' with ' + JSON.stringify(fixedOptions));
              return exports.format(value, fixedOptions);
            } // determine lower and upper bound for exponential notation.
            // TODO: implement support for upper and lower to be BigNumbers themselves


            var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
            var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5; // handle special case zero

            if (value.isZero()) return '0'; // determine whether or not to output exponential notation

            var str;
            var exp = value.e;

            if (exp >= lowerExp && exp < upperExp) {
              // normal number notation
              str = value.toSignificantDigits(precision).toFixed();
            } else {
              // exponential notation
              str = exports.toExponential(value, precision);
            } // remove trailing zeros after the decimal point


            return str.replace(/((\.\d*?)(0+))($|e)/, function () {
              var digits = arguments[2];
              var e = arguments[4];
              return digits !== '.' ? digits + e : e;
            });

          default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", or "fixed".');
        }
      };
      /**
       * Format a BigNumber in engineering notation. Like '1.23e+6', '2.3e+0', '3.500e-3'
       * @param {BigNumber | string} value
       * @param {number} [precision]        Optional number of significant figures to return.
       */


      exports.toEngineering = function (value, precision) {
        // find nearest lower multiple of 3 for exponent
        var e = value.e;
        var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3; // find difference in exponents, and calculate the value without exponent

        var valueWithoutExp = value.mul(Math.pow(10, -newExp));
        var valueStr = valueWithoutExp.toPrecision(precision);

        if (valueStr.indexOf('e') !== -1) {
          valueStr = valueWithoutExp.toString();
        }

        return valueStr + 'e' + (e >= 0 ? '+' : '') + newExp.toString();
      };
      /**
       * Format a number in exponential notation. Like '1.23e+5', '2.3e+0', '3.500e-3'
       * @param {BigNumber} value
       * @param {number} [precision]  Number of digits in formatted output.
       *                              If not provided, the maximum available digits
       *                              is used.
       * @returns {string} str
       */


      exports.toExponential = function (value, precision) {
        if (precision !== undefined) {
          return value.toExponential(precision - 1); // Note the offset of one
        } else {
          return value.toExponential();
        }
      };
      /**
       * Format a number with fixed notation.
       * @param {BigNumber} value
       * @param {number} [precision=undefined] Optional number of decimals after the
       *                                       decimal point. Undefined by default.
       */


      exports.toFixed = function (value, precision) {
        return value.toFixed(precision);
      };
      /***/

    },
    /* 793 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var getSafeProperty = __webpack_require__(88).getSafeProperty;

      function factory(type, config, load, typed) {
        var Node = load(__webpack_require__(87));
        var access = load(__webpack_require__(409));
        /**
         * @constructor AccessorNode
         * @extends {Node}
         * Access an object property or get a matrix subset
         *
         * @param {Node} object                 The object from which to retrieve
         *                                      a property or subset.
         * @param {IndexNode} index             IndexNode containing ranges
         */

        function AccessorNode(object, index) {
          if (!(this instanceof AccessorNode)) {
            throw new SyntaxError('Constructor must be called with the new operator');
          }

          if (!type.isNode(object)) {
            throw new TypeError('Node expected for parameter "object"');
          }

          if (!type.isIndexNode(index)) {
            throw new TypeError('IndexNode expected for parameter "index"');
          }

          this.object = object || null;
          this.index = index; // readonly property name

          Object.defineProperty(this, 'name', {
            get: function () {
              if (this.index) {
                return this.index.isObjectProperty() ? this.index.getObjectProperty() : '';
              } else {
                return this.object.name || '';
              }
            }.bind(this),
            set: function set() {
              throw new Error('Cannot assign a new name, name is read-only');
            }
          });
        }

        AccessorNode.prototype = new Node();
        AccessorNode.prototype.type = 'AccessorNode';
        AccessorNode.prototype.isAccessorNode = true;
        /**
         * Compile a node into a JavaScript function.
         * This basically pre-calculates as much as possible and only leaves open
         * calculations which depend on a dynamic scope with variables.
         * @param {Object} math     Math.js namespace with functions and constants.
         * @param {Object} argNames An object with argument names as key and `true`
         *                          as value. Used in the SymbolNode to optimize
         *                          for arguments from user assigned functions
         *                          (see FunctionAssignmentNode) or special symbols
         *                          like `end` (see IndexNode).
         * @return {function} Returns a function which can be called like:
         *                        evalNode(scope: Object, args: Object, context: *)
         */

        AccessorNode.prototype._compile = function (math, argNames) {
          var evalObject = this.object._compile(math, argNames);

          var evalIndex = this.index._compile(math, argNames);

          if (this.index.isObjectProperty()) {
            var prop = this.index.getObjectProperty();
            return function evalAccessorNode(scope, args, context) {
              return getSafeProperty(evalObject(scope, args, context), prop);
            };
          } else {
            return function evalAccessorNode(scope, args, context) {
              var object = evalObject(scope, args, context);
              var index = evalIndex(scope, args, object); // we pass object here instead of context

              return access(object, index);
            };
          }
        };
        /**
         * Execute a callback for each of the child nodes of this node
         * @param {function(child: Node, path: string, parent: Node)} callback
         */


        AccessorNode.prototype.forEach = function (callback) {
          callback(this.object, 'object', this);
          callback(this.index, 'index', this);
        };
        /**
         * Create a new AccessorNode having it's childs be the results of calling
         * the provided callback function for each of the childs of the original node.
         * @param {function(child: Node, path: string, parent: Node): Node} callback
         * @returns {AccessorNode} Returns a transformed copy of the node
         */


        AccessorNode.prototype.map = function (callback) {
          return new AccessorNode(this._ifNode(callback(this.object, 'object', this)), this._ifNode(callback(this.index, 'index', this)));
        };
        /**
         * Create a clone of this node, a shallow copy
         * @return {AccessorNode}
         */


        AccessorNode.prototype.clone = function () {
          return new AccessorNode(this.object, this.index);
        };
        /**
         * Get string representation
         * @param {Object} options
         * @return {string}
         */


        AccessorNode.prototype._toString = function (options) {
          var object = this.object.toString(options);

          if (needParenthesis(this.object)) {
            object = '(' + object + ')';
          }

          return object + this.index.toString(options);
        };
        /**
         * Get HTML representation
         * @param {Object} options
         * @return {string}
         */


        AccessorNode.prototype.toHTML = function (options) {
          var object = this.object.toHTML(options);

          if (needParenthesis(this.object)) {
            object = '<span class="math-parenthesis math-round-parenthesis">(</span>' + object + '<span class="math-parenthesis math-round-parenthesis">)</span>';
          }

          return object + this.index.toHTML(options);
        };
        /**
         * Get LaTeX representation
         * @param {Object} options
         * @return {string}
         */


        AccessorNode.prototype._toTex = function (options) {
          var object = this.object.toTex(options);

          if (needParenthesis(this.object)) {
            object = "\\left(' + object + '\\right)";
          }

          return object + this.index.toTex(options);
        };
        /**
         * Get a JSON representation of the node
         * @returns {Object}
         */


        AccessorNode.prototype.toJSON = function () {
          return {
            mathjs: 'AccessorNode',
            object: this.object,
            index: this.index
          };
        };
        /**
         * Instantiate an AccessorNode from its JSON representation
         * @param {Object} json  An object structured like
         *                       `{"mathjs": "AccessorNode", object: ..., index: ...}`,
         *                       where mathjs is optional
         * @returns {AccessorNode}
         */


        AccessorNode.fromJSON = function (json) {
          return new AccessorNode(json.object, json.index);
        };
        /**
         * Are parenthesis needed?
         * @private
         */


        function needParenthesis(node) {
          // TODO: maybe make a method on the nodes which tells whether they need parenthesis?
          return !(type.isAccessorNode(node) || type.isArrayNode(node) || type.isConstantNode(node) || type.isFunctionNode(node) || type.isObjectNode(node) || type.isParenthesisNode(node) || type.isSymbolNode(node));
        }

        return AccessorNode;
      }

      exports.name = 'AccessorNode';
      exports.path = 'expression.node';
      exports.factory = factory;
      /***/
    },
    /* 794 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        /**
         * Create a BigNumber, which can store numbers with arbitrary precision.
         * When a matrix is provided, all elements will be converted to BigNumber.
         *
         * Syntax:
         *
         *    math.bignumber(x)
         *
         * Examples:
         *
         *    0.1 + 0.2                                  // returns number 0.30000000000000004
         *    math.bignumber(0.1) + math.bignumber(0.2)  // returns BigNumber 0.3
         *
         *
         *    7.2e500                                    // returns number Infinity
         *    math.bignumber('7.2e500')                  // returns BigNumber 7.2e500
         *
         * See also:
         *
         *    boolean, complex, index, matrix, string, unit
         *
         * @param {number | string | Fraction | BigNumber | Array | Matrix | boolean | null} [value]  Value for the big number,
         *                                                    0 by default.
         * @returns {BigNumber} The created bignumber
         */
        var bignumber = typed('bignumber', {
          '': function _() {
            return new type.BigNumber(0);
          },
          'number': function number(x) {
            // convert to string to prevent errors in case of >15 digits
            return new type.BigNumber(x + '');
          },
          'string': function string(x) {
            return new type.BigNumber(x);
          },
          'BigNumber': function BigNumber(x) {
            // we assume a BigNumber is immutable
            return x;
          },
          'Fraction': function Fraction(x) {
            return new type.BigNumber(x.n).div(x.d).times(x.s);
          },
          'null': function _null(x) {
            return new type.BigNumber(0);
          },
          'Array | Matrix': function ArrayMatrix(x) {
            return deepMap(x, bignumber);
          }
        });
        bignumber.toTex = {
          0: '0',
          1: "\\left(${args[0]}\\right)"
        };
        return bignumber;
      }

      exports.name = 'bignumber';
      exports.factory = factory;
      /***/
    },
    /* 795 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _extends() {
        _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        return _extends.apply(this, arguments);
      }

      var ArgumentsError = __webpack_require__(307);

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        var numeric = load(__webpack_require__(412));
        var AccessorNode = load(__webpack_require__(793));
        var ArrayNode = load(__webpack_require__(791));
        var AssignmentNode = load(__webpack_require__(790));
        var BlockNode = load(__webpack_require__(788));
        var ConditionalNode = load(__webpack_require__(786));
        var ConstantNode = load(__webpack_require__(785));
        var FunctionAssignmentNode = load(__webpack_require__(783));
        var IndexNode = load(__webpack_require__(782));
        var ObjectNode = load(__webpack_require__(781));
        var OperatorNode = load(__webpack_require__(780));
        var ParenthesisNode = load(__webpack_require__(779));
        var FunctionNode = load(__webpack_require__(778));
        var RangeNode = load(__webpack_require__(777));
        var RelationalNode = load(__webpack_require__(776));
        var SymbolNode = load(__webpack_require__(406));
        /**
         * Parse an expression. Returns a node tree, which can be evaluated by
         * invoking node.eval().
         *
         * Syntax:
         *
         *     parse(expr)
         *     parse(expr, options)
         *     parse([expr1, expr2, expr3, ...])
         *     parse([expr1, expr2, expr3, ...], options)
         *
         * Example:
         *
         *     const node = parse('sqrt(3^2 + 4^2)')
         *     node.compile(math).eval() // 5
         *
         *     let scope = {a:3, b:4}
         *     const node = parse('a * b') // 12
         *     const code = node.compile(math)
         *     code.eval(scope) // 12
         *     scope.a = 5
         *     code.eval(scope) // 20
         *
         *     const nodes = math.parse(['a = 3', 'b = 4', 'a * b'])
         *     nodes[2].compile(math).eval() // 12
         *
         * @param {string | string[] | Matrix} expr
         * @param {{nodes: Object<string, Node>}} [options]  Available options:
         *                                                   - `nodes` a set of custom nodes
         * @return {Node | Node[]} node
         * @throws {Error}
         */

        function parse(expr, options) {
          if (arguments.length !== 1 && arguments.length !== 2) {
            throw new ArgumentsError('parse', arguments.length, 1, 2);
          } // pass extra nodes


          var extraNodes = options && options.nodes ? options.nodes : {};

          if (typeof expr === 'string') {
            // parse a single expression
            return parseStart(expr, extraNodes);
          } else if (Array.isArray(expr) || expr instanceof type.Matrix) {
            // parse an array or matrix with expressions
            return deepMap(expr, function (elem) {
              if (typeof elem !== 'string') throw new TypeError('String expected');
              return parseStart(elem, extraNodes);
            });
          } else {
            // oops
            throw new TypeError('String or matrix expected');
          }
        } // token types enumeration


        var TOKENTYPE = {
          NULL: 0,
          DELIMITER: 1,
          NUMBER: 2,
          SYMBOL: 3,
          UNKNOWN: 4 // map with all delimiters

        };
        var DELIMITERS = {
          ',': true,
          '(': true,
          ')': true,
          '[': true,
          ']': true,
          '{': true,
          '}': true,
          '"': true,
          '\'': true,
          ';': true,
          '+': true,
          '-': true,
          '*': true,
          '.*': true,
          '/': true,
          './': true,
          '%': true,
          '^': true,
          '.^': true,
          '~': true,
          '!': true,
          '&': true,
          '|': true,
          '^|': true,
          '=': true,
          ':': true,
          '?': true,
          '==': true,
          '!=': true,
          '<': true,
          '>': true,
          '<=': true,
          '>=': true,
          '<<': true,
          '>>': true,
          '>>>': true // map with all named delimiters

        };
        var NAMED_DELIMITERS = {
          'mod': true,
          'to': true,
          'in': true,
          'and': true,
          'xor': true,
          'or': true,
          'not': true
        };
        var CONSTANTS = {
          'true': true,
          'false': false,
          'null': null,
          'undefined': undefined
        };
        var NUMERIC_CONSTANTS = ['NaN', 'Infinity'];

        function initialState() {
          return {
            extraNodes: {},
            // current extra nodes, must be careful not to mutate
            expression: '',
            // current expression
            comment: '',
            // last parsed comment
            index: 0,
            // current index in expr
            token: '',
            // current token
            tokenType: TOKENTYPE.NULL,
            // type of the token
            nestingLevel: 0,
            // level of nesting inside parameters, used to ignore newline characters
            conditionalLevel: null // when a conditional is being parsed, the level of the conditional is stored here

          };
        }
        /**
         * View upto `length` characters of the expression starting at the current character.
         *
         * @param {State} state
         * @param {number} [length=1] Number of characters to view
         * @returns {string}
         * @private
         */


        function currentString(state, length) {
          return state.expression.substr(state.index, length);
        }
        /**
         * View the current character. Returns '' if end of expression is reached.
         *
         * @param {State} state
         * @returns {string}
         * @private
         */


        function currentCharacter(state) {
          return currentString(state, 1);
        }
        /**
         * Get the next character from the expression.
         * The character is stored into the char c. If the end of the expression is
         * reached, the function puts an empty string in c.
         * @private
         */


        function next(state) {
          state.index++;
        }
        /**
         * Preview the previous character from the expression.
         * @return {string} cNext
         * @private
         */


        function prevCharacter(state) {
          return state.expression.charAt(state.index - 1);
        }
        /**
         * Preview the next character from the expression.
         * @return {string} cNext
         * @private
         */


        function nextCharacter(state) {
          return state.expression.charAt(state.index + 1);
        }
        /**
         * Get next token in the current string expr.
         * The token and token type are available as token and tokenType
         * @private
         */


        function getToken(state) {
          state.tokenType = TOKENTYPE.NULL;
          state.token = '';
          state.comment = ''; // skip over whitespaces
          // space, tab, and newline when inside parameters

          while (parse.isWhitespace(currentCharacter(state), state.nestingLevel)) {
            next(state);
          } // skip comment


          if (currentCharacter(state) === '#') {
            while (currentCharacter(state) !== '\n' && currentCharacter(state) !== '') {
              state.comment += currentCharacter(state);
              next(state);
            }
          } // check for end of expression


          if (currentCharacter(state) === '') {
            // token is still empty
            state.tokenType = TOKENTYPE.DELIMITER;
            return;
          } // check for new line character


          if (currentCharacter(state) === '\n' && !state.nestingLevel) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = currentCharacter(state);
            next(state);
            return;
          }

          var c1 = currentCharacter(state);
          var c2 = currentString(state, 2);
          var c3 = currentString(state, 3);

          if (c3.length === 3 && DELIMITERS[c3]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c3;
            next(state);
            next(state);
            next(state);
            return;
          } // check for delimiters consisting of 2 characters


          if (c2.length === 2 && DELIMITERS[c2]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c2;
            next(state);
            next(state);
            return;
          } // check for delimiters consisting of 1 character


          if (DELIMITERS[c1]) {
            state.tokenType = TOKENTYPE.DELIMITER;
            state.token = c1;
            next(state);
            return;
          } // check for a number


          if (parse.isDigitDot(c1)) {
            state.tokenType = TOKENTYPE.NUMBER; // get number, can have a single dot

            if (currentCharacter(state) === '.') {
              state.token += currentCharacter(state);
              next(state);

              if (!parse.isDigit(currentCharacter(state))) {
                // this is no number, it is just a dot (can be dot notation)
                state.tokenType = TOKENTYPE.DELIMITER;
              }
            } else {
              while (parse.isDigit(currentCharacter(state))) {
                state.token += currentCharacter(state);
                next(state);
              }

              if (parse.isDecimalMark(currentCharacter(state), nextCharacter(state))) {
                state.token += currentCharacter(state);
                next(state);
              }
            }

            while (parse.isDigit(currentCharacter(state))) {
              state.token += currentCharacter(state);
              next(state);
            } // check for exponential notation like "2.3e-4", "1.23e50" or "2e+4"


            if (currentCharacter(state) === 'E' || currentCharacter(state) === 'e') {
              if (parse.isDigit(nextCharacter(state)) || nextCharacter(state) === '-' || nextCharacter(state) === '+') {
                state.token += currentCharacter(state);
                next(state);

                if (currentCharacter(state) === '+' || currentCharacter(state) === '-') {
                  state.token += currentCharacter(state);
                  next(state);
                } // Scientific notation MUST be followed by an exponent


                if (!parse.isDigit(currentCharacter(state))) {
                  throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                }

                while (parse.isDigit(currentCharacter(state))) {
                  state.token += currentCharacter(state);
                  next(state);
                }

                if (parse.isDecimalMark(currentCharacter(state), nextCharacter(state))) {
                  throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
                }
              } else if (nextCharacter(state) === '.') {
                next(state);
                throw createSyntaxError(state, 'Digit expected, got "' + currentCharacter(state) + '"');
              }
            }

            return;
          } // check for variables, functions, named operators


          if (parse.isAlpha(currentCharacter(state), prevCharacter(state), nextCharacter(state))) {
            while (parse.isAlpha(currentCharacter(state), prevCharacter(state), nextCharacter(state)) || parse.isDigit(currentCharacter(state))) {
              state.token += currentCharacter(state);
              next(state);
            }

            if (NAMED_DELIMITERS.hasOwnProperty(state.token)) {
              state.tokenType = TOKENTYPE.DELIMITER;
            } else {
              state.tokenType = TOKENTYPE.SYMBOL;
            }

            return;
          } // something unknown is found, wrong characters -> a syntax error


          state.tokenType = TOKENTYPE.UNKNOWN;

          while (currentCharacter(state) !== '') {
            state.token += currentCharacter(state);
            next(state);
          }

          throw createSyntaxError(state, 'Syntax error in part "' + state.token + '"');
        }
        /**
         * Get next token and skip newline tokens
         */


        function getTokenSkipNewline(state) {
          do {
            getToken(state);
          } while (state.token === '\n'); // eslint-disable-line no-unmodified-loop-condition

        }
        /**
         * Open parameters.
         * New line characters will be ignored until closeParams(state) is called
         */


        function openParams(state) {
          state.nestingLevel++;
        }
        /**
         * Close parameters.
         * New line characters will no longer be ignored
         */


        function closeParams(state) {
          state.nestingLevel--;
        }
        /**
         * Checks whether the current character `c` is a valid alpha character:
         *
         * - A latin letter (upper or lower case) Ascii: a-z, A-Z
         * - An underscore                        Ascii: _
         * - A dollar sign                        Ascii: $
         * - A latin letter with accents          Unicode: \u00C0 - \u02AF
         * - A greek letter                       Unicode: \u0370 - \u03FF
         * - A mathematical alphanumeric symbol   Unicode: \u{1D400} - \u{1D7FF} excluding invalid code points
         *
         * The previous and next characters are needed to determine whether
         * this character is part of a unicode surrogate pair.
         *
         * @param {string} c      Current character in the expression
         * @param {string} cPrev  Previous character
         * @param {string} cNext  Next character
         * @return {boolean}
         */


        parse.isAlpha = function isAlpha(c, cPrev, cNext) {
          return parse.isValidLatinOrGreek(c) || parse.isValidMathSymbol(c, cNext) || parse.isValidMathSymbol(cPrev, c);
        };
        /**
         * Test whether a character is a valid latin, greek, or letter-like character
         * @param {string} c
         * @return {boolean}
         */


        parse.isValidLatinOrGreek = function isValidLatinOrGreek(c) {
          return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(c);
        };
        /**
         * Test whether two given 16 bit characters form a surrogate pair of a
         * unicode math symbol.
         *
         * https://unicode-table.com/en/
         * https://www.wikiwand.com/en/Mathematical_operators_and_symbols_in_Unicode
         *
         * Note: In ES6 will be unicode aware:
         * https://stackoverflow.com/questions/280712/javascript-unicode-regexes
         * https://mathiasbynens.be/notes/es6-unicode-regex
         *
         * @param {string} high
         * @param {string} low
         * @return {boolean}
         */


        parse.isValidMathSymbol = function isValidMathSymbol(high, low) {
          return /^[\uD835]$/.test(high) && /^[\uDC00-\uDFFF]$/.test(low) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(low);
        };
        /**
         * Check whether given character c is a white space character: space, tab, or enter
         * @param {string} c
         * @param {number} nestingLevel
         * @return {boolean}
         */


        parse.isWhitespace = function isWhitespace(c, nestingLevel) {
          // TODO: also take '\r' carriage return as newline? Or does that give problems on mac?
          return c === ' ' || c === '\t' || c === '\n' && nestingLevel > 0;
        };
        /**
         * Test whether the character c is a decimal mark (dot).
         * This is the case when it's not the start of a delimiter '.*', './', or '.^'
         * @param {string} c
         * @param {string} cNext
         * @return {boolean}
         */


        parse.isDecimalMark = function isDecimalMark(c, cNext) {
          return c === '.' && cNext !== '/' && cNext !== '*' && cNext !== '^';
        };
        /**
         * checks if the given char c is a digit or dot
         * @param {string} c   a string with one character
         * @return {boolean}
         */


        parse.isDigitDot = function isDigitDot(c) {
          return c >= '0' && c <= '9' || c === '.';
        };
        /**
         * checks if the given char c is a digit
         * @param {string} c   a string with one character
         * @return {boolean}
         */


        parse.isDigit = function isDigit(c) {
          return c >= '0' && c <= '9';
        };
        /**
         * Start of the parse levels below, in order of precedence
         * @return {Node} node
         * @private
         */


        function parseStart(expression, extraNodes) {
          var state = initialState();

          _extends(state, {
            expression: expression,
            extraNodes: extraNodes
          });

          getToken(state);
          var node = parseBlock(state); // check for garbage at the end of the expression
          // an expression ends with a empty character '' and tokenType DELIMITER

          if (state.token !== '') {
            if (state.tokenType === TOKENTYPE.DELIMITER) {
              // user entered a not existing operator like "//"
              // TODO: give hints for aliases, for example with "<>" give as hint " did you mean !== ?"
              throw createError(state, 'Unexpected operator ' + state.token);
            } else {
              throw createSyntaxError(state, 'Unexpected part "' + state.token + '"');
            }
          }

          return node;
        }
        /**
         * Parse a block with expressions. Expressions can be separated by a newline
         * character '\n', or by a semicolon ';'. In case of a semicolon, no output
         * of the preceding line is returned.
         * @return {Node} node
         * @private
         */


        function parseBlock(state) {
          var node;
          var blocks = [];
          var visible;

          if (state.token !== '' && state.token !== '\n' && state.token !== ';') {
            node = parseAssignment(state);
            node.comment = state.comment;
          } // TODO: simplify this loop


          while (state.token === '\n' || state.token === ';') {
            // eslint-disable-line no-unmodified-loop-condition
            if (blocks.length === 0 && node) {
              visible = state.token !== ';';
              blocks.push({
                node: node,
                visible: visible
              });
            }

            getToken(state);

            if (state.token !== '\n' && state.token !== ';' && state.token !== '') {
              node = parseAssignment(state);
              node.comment = state.comment;
              visible = state.token !== ';';
              blocks.push({
                node: node,
                visible: visible
              });
            }
          }

          if (blocks.length > 0) {
            return new BlockNode(blocks);
          } else {
            if (!node) {
              node = new ConstantNode(undefined);
              node.comment = state.comment;
            }

            return node;
          }
        }
        /**
         * Assignment of a function or variable,
         * - can be a variable like 'a=2.3'
         * - or a updating an existing variable like 'matrix(2,3:5)=[6,7,8]'
         * - defining a function like 'f(x) = x^2'
         * @return {Node} node
         * @private
         */


        function parseAssignment(state) {
          var name, args, value, valid;
          var node = parseConditional(state);

          if (state.token === '=') {
            if (type.isSymbolNode(node)) {
              // parse a variable assignment like 'a = 2/3'
              name = node.name;
              getTokenSkipNewline(state);
              value = parseAssignment(state);
              return new AssignmentNode(new SymbolNode(name), value);
            } else if (type.isAccessorNode(node)) {
              // parse a matrix subset assignment like 'A[1,2] = 4'
              getTokenSkipNewline(state);
              value = parseAssignment(state);
              return new AssignmentNode(node.object, node.index, value);
            } else if (type.isFunctionNode(node) && type.isSymbolNode(node.fn)) {
              // parse function assignment like 'f(x) = x^2'
              valid = true;
              args = [];
              name = node.name;
              node.args.forEach(function (arg, index) {
                if (type.isSymbolNode(arg)) {
                  args[index] = arg.name;
                } else {
                  valid = false;
                }
              });

              if (valid) {
                getTokenSkipNewline(state);
                value = parseAssignment(state);
                return new FunctionAssignmentNode(name, args, value);
              }
            }

            throw createSyntaxError(state, 'Invalid left hand side of assignment operator =');
          }

          return node;
        }
        /**
         * conditional operation
         *
         *     condition ? truePart : falsePart
         *
         * Note: conditional operator is right-associative
         *
         * @return {Node} node
         * @private
         */


        function parseConditional(state) {
          var node = parseLogicalOr(state);

          while (state.token === '?') {
            // eslint-disable-line no-unmodified-loop-condition
            // set a conditional level, the range operator will be ignored as long
            // as conditionalLevel === state.nestingLevel.
            var prev = state.conditionalLevel;
            state.conditionalLevel = state.nestingLevel;
            getTokenSkipNewline(state);
            var condition = node;
            var trueExpr = parseAssignment(state);
            if (state.token !== ':') throw createSyntaxError(state, 'False part of conditional expression expected');
            state.conditionalLevel = null;
            getTokenSkipNewline(state);
            var falseExpr = parseAssignment(state); // Note: check for conditional operator again, right associativity

            node = new ConditionalNode(condition, trueExpr, falseExpr); // restore the previous conditional level

            state.conditionalLevel = prev;
          }

          return node;
        }
        /**
         * logical or, 'x or y'
         * @return {Node} node
         * @private
         */


        function parseLogicalOr(state) {
          var node = parseLogicalXor(state);

          while (state.token === 'or') {
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode('or', 'or', [node, parseLogicalXor(state)]);
          }

          return node;
        }
        /**
         * logical exclusive or, 'x xor y'
         * @return {Node} node
         * @private
         */


        function parseLogicalXor(state) {
          var node = parseLogicalAnd(state);

          while (state.token === 'xor') {
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode('xor', 'xor', [node, parseLogicalAnd(state)]);
          }

          return node;
        }
        /**
         * logical and, 'x and y'
         * @return {Node} node
         * @private
         */


        function parseLogicalAnd(state) {
          var node = parseBitwiseOr(state);

          while (state.token === 'and') {
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode('and', 'and', [node, parseBitwiseOr(state)]);
          }

          return node;
        }
        /**
         * bitwise or, 'x | y'
         * @return {Node} node
         * @private
         */


        function parseBitwiseOr(state) {
          var node = parseBitwiseXor(state);

          while (state.token === '|') {
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode('|', 'bitOr', [node, parseBitwiseXor(state)]);
          }

          return node;
        }
        /**
         * bitwise exclusive or (xor), 'x ^| y'
         * @return {Node} node
         * @private
         */


        function parseBitwiseXor(state) {
          var node = parseBitwiseAnd(state);

          while (state.token === '^|') {
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode('^|', 'bitXor', [node, parseBitwiseAnd(state)]);
          }

          return node;
        }
        /**
         * bitwise and, 'x & y'
         * @return {Node} node
         * @private
         */


        function parseBitwiseAnd(state) {
          var node = parseRelational(state);

          while (state.token === '&') {
            // eslint-disable-line no-unmodified-loop-condition
            getTokenSkipNewline(state);
            node = new OperatorNode('&', 'bitAnd', [node, parseRelational(state)]);
          }

          return node;
        }
        /**
         * Parse a chained conditional, like 'a > b >= c'
         * @return {Node} node
         */


        function parseRelational(state) {
          var params = [parseShift(state)];
          var conditionals = [];
          var operators = {
            '==': 'equal',
            '!=': 'unequal',
            '<': 'smaller',
            '>': 'larger',
            '<=': 'smallerEq',
            '>=': 'largerEq'
          };

          while (operators.hasOwnProperty(state.token)) {
            // eslint-disable-line no-unmodified-loop-condition
            var cond = {
              name: state.token,
              fn: operators[state.token]
            };
            conditionals.push(cond);
            getTokenSkipNewline(state);
            params.push(parseShift(state));
          }

          if (params.length === 1) {
            return params[0];
          } else if (params.length === 2) {
            return new OperatorNode(conditionals[0].name, conditionals[0].fn, params);
          } else {
            return new RelationalNode(conditionals.map(function (c) {
              return c.fn;
            }), params);
          }
        }
        /**
         * Bitwise left shift, bitwise right arithmetic shift, bitwise right logical shift
         * @return {Node} node
         * @private
         */


        function parseShift(state) {
          var node, operators, name, fn, params;
          node = parseConversion(state);
          operators = {
            '<<': 'leftShift',
            '>>': 'rightArithShift',
            '>>>': 'rightLogShift'
          };

          while (operators.hasOwnProperty(state.token)) {
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            params = [node, parseConversion(state)];
            node = new OperatorNode(name, fn, params);
          }

          return node;
        }
        /**
         * conversion operators 'to' and 'in'
         * @return {Node} node
         * @private
         */


        function parseConversion(state) {
          var node, operators, name, fn, params;
          node = parseRange(state);
          operators = {
            'to': 'to',
            'in': 'to' // alias of 'to'

          };

          while (operators.hasOwnProperty(state.token)) {
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);

            if (name === 'in' && state.token === '') {
              // end of expression -> this is the unit 'in' ('inch')
              node = new OperatorNode('*', 'multiply', [node, new SymbolNode('in')], true);
            } else {
              // operator 'a to b' or 'a in b'
              params = [node, parseRange(state)];
              node = new OperatorNode(name, fn, params);
            }
          }

          return node;
        }
        /**
         * parse range, "start:end", "start:step:end", ":", "start:", ":end", etc
         * @return {Node} node
         * @private
         */


        function parseRange(state) {
          var node;
          var params = [];

          if (state.token === ':') {
            // implicit start=1 (one-based)
            node = new ConstantNode(1);
          } else {
            // explicit start
            node = parseAddSubtract(state);
          }

          if (state.token === ':' && state.conditionalLevel !== state.nestingLevel) {
            // we ignore the range operator when a conditional operator is being processed on the same level
            params.push(node); // parse step and end

            while (state.token === ':' && params.length < 3) {
              // eslint-disable-line no-unmodified-loop-condition
              getTokenSkipNewline(state);

              if (state.token === ')' || state.token === ']' || state.token === ',' || state.token === '') {
                // implicit end
                params.push(new SymbolNode('end'));
              } else {
                // explicit end
                params.push(parseAddSubtract(state));
              }
            }

            if (params.length === 3) {
              // params = [start, step, end]
              node = new RangeNode(params[0], params[2], params[1]); // start, end, step
            } else {
              // length === 2
              // params = [start, end]
              node = new RangeNode(params[0], params[1]); // start, end
            }
          }

          return node;
        }
        /**
         * add or subtract
         * @return {Node} node
         * @private
         */


        function parseAddSubtract(state) {
          var node, operators, name, fn, params;
          node = parseMultiplyDivide(state);
          operators = {
            '+': 'add',
            '-': 'subtract'
          };

          while (operators.hasOwnProperty(state.token)) {
            name = state.token;
            fn = operators[name];
            getTokenSkipNewline(state);
            params = [node, parseMultiplyDivide(state)];
            node = new OperatorNode(name, fn, params);
          }

          return node;
        }
        /**
         * multiply, divide, modulus
         * @return {Node} node
         * @private
         */


        function parseMultiplyDivide(state) {
          var node, last, operators, name, fn;
          node = parseImplicitMultiplication(state);
          last = node;
          operators = {
            '*': 'multiply',
            '.*': 'dotMultiply',
            '/': 'divide',
            './': 'dotDivide',
            '%': 'mod',
            'mod': 'mod'
          };

          while (true) {
            if (operators.hasOwnProperty(state.token)) {
              // explicit operators
              name = state.token;
              fn = operators[name];
              getTokenSkipNewline(state);
              last = parseImplicitMultiplication(state);
              node = new OperatorNode(name, fn, [node, last]);
            } else {
              break;
            }
          }

          return node;
        }
        /**
         * implicit multiplication
         * @return {Node} node
         * @private
         */


        function parseImplicitMultiplication(state) {
          var node, last;
          node = parseRule2(state);
          last = node;

          while (true) {
            if (state.tokenType === TOKENTYPE.SYMBOL || state.token === 'in' && type.isConstantNode(node) || state.tokenType === TOKENTYPE.NUMBER && !type.isConstantNode(last) && (!type.isOperatorNode(last) || last.op === '!') || state.token === '(') {
              // parse implicit multiplication
              //
              // symbol:      implicit multiplication like '2a', '(2+3)a', 'a b'
              // number:      implicit multiplication like '(2+3)2'
              // parenthesis: implicit multiplication like '2(3+4)', '(3+4)(1+2)'
              last = parseRule2(state);
              node = new OperatorNode('*', 'multiply', [node, last], true
              /* implicit */
              );
            } else {
              break;
            }
          }

          return node;
        }
        /**
         * Infamous "rule 2" as described in https://github.com/josdejong/mathjs/issues/792#issuecomment-361065370
         * Explicit division gets higher precedence than implicit multiplication
         * when the division matches this pattern: [number] / [number] [symbol]
         * @return {Node} node
         * @private
         */


        function parseRule2(state) {
          var node = parseUnary(state);
          var last = node;
          var tokenStates = [];

          while (true) {
            // Match the "number /" part of the pattern "number / number symbol"
            if (state.token === '/' && type.isConstantNode(last)) {
              // Look ahead to see if the next token is a number
              tokenStates.push(_extends({}, state));
              getTokenSkipNewline(state); // Match the "number / number" part of the pattern

              if (state.tokenType === TOKENTYPE.NUMBER) {
                // Look ahead again
                tokenStates.push(_extends({}, state));
                getTokenSkipNewline(state); // Match the "symbol" part of the pattern, or a left parenthesis

                if (state.tokenType === TOKENTYPE.SYMBOL || state.token === '(') {
                  // We've matched the pattern "number / number symbol".
                  // Rewind once and build the "number / number" node; the symbol will be consumed later
                  _extends(state, tokenStates.pop());

                  tokenStates.pop();
                  last = parseUnary(state);
                  node = new OperatorNode('/', 'divide', [node, last]);
                } else {
                  // Not a match, so rewind
                  tokenStates.pop();

                  _extends(state, tokenStates.pop());

                  break;
                }
              } else {
                // Not a match, so rewind
                _extends(state, tokenStates.pop());

                break;
              }
            } else {
              break;
            }
          }

          return node;
        }
        /**
         * Unary plus and minus, and logical and bitwise not
         * @return {Node} node
         * @private
         */


        function parseUnary(state) {
          var name, params, fn;
          var operators = {
            '-': 'unaryMinus',
            '+': 'unaryPlus',
            '~': 'bitNot',
            'not': 'not'
          };

          if (operators.hasOwnProperty(state.token)) {
            fn = operators[state.token];
            name = state.token;
            getTokenSkipNewline(state);
            params = [parseUnary(state)];
            return new OperatorNode(name, fn, params);
          }

          return parsePow(state);
        }
        /**
         * power
         * Note: power operator is right associative
         * @return {Node} node
         * @private
         */


        function parsePow(state) {
          var node, name, fn, params;
          node = parseLeftHandOperators(state);

          if (state.token === '^' || state.token === '.^') {
            name = state.token;
            fn = name === '^' ? 'pow' : 'dotPow';
            getTokenSkipNewline(state);
            params = [node, parseUnary(state)]; // Go back to unary, we can have '2^-3'

            node = new OperatorNode(name, fn, params);
          }

          return node;
        }
        /**
         * Left hand operators: factorial x!, ctranspose x'
         * @return {Node} node
         * @private
         */


        function parseLeftHandOperators(state) {
          var node, operators, name, fn, params;
          node = parseCustomNodes(state);
          operators = {
            '!': 'factorial',
            '\'': 'ctranspose'
          };

          while (operators.hasOwnProperty(state.token)) {
            name = state.token;
            fn = operators[name];
            getToken(state);
            params = [node];
            node = new OperatorNode(name, fn, params);
            node = parseAccessors(state, node);
          }

          return node;
        }
        /**
         * Parse a custom node handler. A node handler can be used to process
         * nodes in a custom way, for example for handling a plot.
         *
         * A handler must be passed as second argument of the parse function.
         * - must extend math.expression.node.Node
         * - must contain a function _compile(defs: Object) : string
         * - must contain a function find(filter: Object) : Node[]
         * - must contain a function toString() : string
         * - the constructor is called with a single argument containing all parameters
         *
         * For example:
         *
         *     nodes = {
         *       'plot': PlotHandler
         *     }
         *
         * The constructor of the handler is called as:
         *
         *     node = new PlotHandler(params)
         *
         * The handler will be invoked when evaluating an expression like:
         *
         *     node = math.parse('plot(sin(x), x)', nodes)
         *
         * @return {Node} node
         * @private
         */


        function parseCustomNodes(state) {
          var params = [];

          if (state.tokenType === TOKENTYPE.SYMBOL && state.extraNodes.hasOwnProperty(state.token)) {
            var CustomNode = state.extraNodes[state.token];
            getToken(state); // parse parameters

            if (state.token === '(') {
              params = [];
              openParams(state);
              getToken(state);

              if (state.token !== ')') {
                params.push(parseAssignment(state)); // parse a list with parameters

                while (state.token === ',') {
                  // eslint-disable-line no-unmodified-loop-condition
                  getToken(state);
                  params.push(parseAssignment(state));
                }
              }

              if (state.token !== ')') {
                throw createSyntaxError(state, 'Parenthesis ) expected');
              }

              closeParams(state);
              getToken(state);
            } // create a new custom node
            // noinspection JSValidateTypes


            return new CustomNode(params);
          }

          return parseSymbol(state);
        }
        /**
         * parse symbols: functions, variables, constants, units
         * @return {Node} node
         * @private
         */


        function parseSymbol(state) {
          var node, name;

          if (state.tokenType === TOKENTYPE.SYMBOL || state.tokenType === TOKENTYPE.DELIMITER && state.token in NAMED_DELIMITERS) {
            name = state.token;
            getToken(state);

            if (CONSTANTS.hasOwnProperty(name)) {
              // true, false, null, ...
              node = new ConstantNode(CONSTANTS[name]);
            } else if (NUMERIC_CONSTANTS.indexOf(name) !== -1) {
              // NaN, Infinity
              node = new ConstantNode(numeric(name, 'number'));
            } else {
              node = new SymbolNode(name);
            } // parse function parameters and matrix index


            node = parseAccessors(state, node);
            return node;
          }

          return parseDoubleQuotesString(state);
        }
        /**
         * parse accessors:
         * - function invocation in round brackets (...), for example sqrt(2)
         * - index enclosed in square brackets [...], for example A[2,3]
         * - dot notation for properties, like foo.bar
         * @param {Node} node    Node on which to apply the parameters. If there
         *                       are no parameters in the expression, the node
         *                       itself is returned
         * @param {string[]} [types]  Filter the types of notations
         *                            can be ['(', '[', '.']
         * @return {Node} node
         * @private
         */


        function parseAccessors(state, node, types) {
          var params;

          while ((state.token === '(' || state.token === '[' || state.token === '.') && (!types || types.indexOf(state.token) !== -1)) {
            // eslint-disable-line no-unmodified-loop-condition
            params = [];

            if (state.token === '(') {
              if (type.isSymbolNode(node) || type.isAccessorNode(node)) {
                // function invocation like fn(2, 3) or obj.fn(2, 3)
                openParams(state);
                getToken(state);

                if (state.token !== ')') {
                  params.push(parseAssignment(state)); // parse a list with parameters

                  while (state.token === ',') {
                    // eslint-disable-line no-unmodified-loop-condition
                    getToken(state);
                    params.push(parseAssignment(state));
                  }
                }

                if (state.token !== ')') {
                  throw createSyntaxError(state, 'Parenthesis ) expected');
                }

                closeParams(state);
                getToken(state);
                node = new FunctionNode(node, params);
              } else {
                // implicit multiplication like (2+3)(4+5) or sqrt(2)(1+2)
                // don't parse it here but let it be handled by parseImplicitMultiplication
                // with correct precedence
                return node;
              }
            } else if (state.token === '[') {
              // index notation like variable[2, 3]
              openParams(state);
              getToken(state);

              if (state.token !== ']') {
                params.push(parseAssignment(state)); // parse a list with parameters

                while (state.token === ',') {
                  // eslint-disable-line no-unmodified-loop-condition
                  getToken(state);
                  params.push(parseAssignment(state));
                }
              }

              if (state.token !== ']') {
                throw createSyntaxError(state, 'Parenthesis ] expected');
              }

              closeParams(state);
              getToken(state);
              node = new AccessorNode(node, new IndexNode(params));
            } else {
              // dot notation like variable.prop
              getToken(state);

              if (state.tokenType !== TOKENTYPE.SYMBOL) {
                throw createSyntaxError(state, 'Property name expected after dot');
              }

              params.push(new ConstantNode(state.token));
              getToken(state);
              var dotNotation = true;
              node = new AccessorNode(node, new IndexNode(params, dotNotation));
            }
          }

          return node;
        }
        /**
         * Parse a double quotes string.
         * @return {Node} node
         * @private
         */


        function parseDoubleQuotesString(state) {
          var node, str;

          if (state.token === '"') {
            str = parseDoubleQuotesStringToken(state); // create constant

            node = new ConstantNode(str); // parse index parameters

            node = parseAccessors(state, node);
            return node;
          }

          return parseSingleQuotesString(state);
        }
        /**
         * Parse a string surrounded by double quotes "..."
         * @return {string}
         */


        function parseDoubleQuotesStringToken(state) {
          var str = '';

          while (currentCharacter(state) !== '' && currentCharacter(state) !== '"') {
            if (currentCharacter(state) === '\\') {
              // escape character, immediately process the next
              // character to prevent stopping at a next '\"'
              str += currentCharacter(state);
              next(state);
            }

            str += currentCharacter(state);
            next(state);
          }

          getToken(state);

          if (state.token !== '"') {
            throw createSyntaxError(state, 'End of string " expected');
          }

          getToken(state);
          return JSON.parse('"' + str + '"'); // unescape escaped characters
        }
        /**
         * Parse a single quotes string.
         * @return {Node} node
         * @private
         */


        function parseSingleQuotesString(state) {
          var node, str;

          if (state.token === '\'') {
            str = parseSingleQuotesStringToken(state); // create constant

            node = new ConstantNode(str); // parse index parameters

            node = parseAccessors(state, node);
            return node;
          }

          return parseMatrix(state);
        }
        /**
         * Parse a string surrounded by single quotes '...'
         * @return {string}
         */


        function parseSingleQuotesStringToken(state) {
          var str = '';

          while (currentCharacter(state) !== '' && currentCharacter(state) !== '\'') {
            if (currentCharacter(state) === '\\') {
              // escape character, immediately process the next
              // character to prevent stopping at a next '\''
              str += currentCharacter(state);
              next(state);
            }

            str += currentCharacter(state);
            next(state);
          }

          getToken(state);

          if (state.token !== '\'') {
            throw createSyntaxError(state, 'End of string \' expected');
          }

          getToken(state);
          return JSON.parse('"' + str + '"'); // unescape escaped characters
        }
        /**
         * parse the matrix
         * @return {Node} node
         * @private
         */


        function parseMatrix(state) {
          var array, params, rows, cols;

          if (state.token === '[') {
            // matrix [...]
            openParams(state);
            getToken(state);

            if (state.token !== ']') {
              // this is a non-empty matrix
              var row = parseRow(state);

              if (state.token === ';') {
                // 2 dimensional array
                rows = 1;
                params = [row]; // the rows of the matrix are separated by dot-comma's

                while (state.token === ';') {
                  // eslint-disable-line no-unmodified-loop-condition
                  getToken(state);
                  params[rows] = parseRow(state);
                  rows++;
                }

                if (state.token !== ']') {
                  throw createSyntaxError(state, 'End of matrix ] expected');
                }

                closeParams(state);
                getToken(state); // check if the number of columns matches in all rows

                cols = params[0].items.length;

                for (var r = 1; r < rows; r++) {
                  if (params[r].items.length !== cols) {
                    throw createError(state, 'Column dimensions mismatch ' + '(' + params[r].items.length + ' !== ' + cols + ')');
                  }
                }

                array = new ArrayNode(params);
              } else {
                // 1 dimensional vector
                if (state.token !== ']') {
                  throw createSyntaxError(state, 'End of matrix ] expected');
                }

                closeParams(state);
                getToken(state);
                array = row;
              }
            } else {
              // this is an empty matrix "[ ]"
              closeParams(state);
              getToken(state);
              array = new ArrayNode([]);
            }

            return parseAccessors(state, array);
          }

          return parseObject(state);
        }
        /**
         * Parse a single comma-separated row from a matrix, like 'a, b, c'
         * @return {ArrayNode} node
         */


        function parseRow(state) {
          var params = [parseAssignment(state)];
          var len = 1;

          while (state.token === ',') {
            // eslint-disable-line no-unmodified-loop-condition
            getToken(state); // parse expression

            params[len] = parseAssignment(state);
            len++;
          }

          return new ArrayNode(params);
        }
        /**
         * parse an object, enclosed in angle brackets{...}, for example {value: 2}
         * @return {Node} node
         * @private
         */


        function parseObject(state) {
          if (state.token === '{') {
            openParams(state);
            var key;
            var properties = {};

            do {
              getToken(state);

              if (state.token !== '}') {
                // parse key
                if (state.token === '"') {
                  key = parseDoubleQuotesStringToken(state);
                } else if (state.token === '\'') {
                  key = parseSingleQuotesStringToken(state);
                } else if (state.tokenType === TOKENTYPE.SYMBOL) {
                  key = state.token;
                  getToken(state);
                } else {
                  throw createSyntaxError(state, 'Symbol or string expected as object key');
                } // parse key/value separator


                if (state.token !== ':') {
                  throw createSyntaxError(state, 'Colon : expected after object key');
                }

                getToken(state); // parse key

                properties[key] = parseAssignment(state);
              }
            } while (state.token === ','); // eslint-disable-line no-unmodified-loop-condition


            if (state.token !== '}') {
              throw createSyntaxError(state, 'Comma , or bracket } expected after object value');
            }

            closeParams(state);
            getToken(state);
            var node = new ObjectNode(properties); // parse index parameters

            node = parseAccessors(state, node);
            return node;
          }

          return parseNumber(state);
        }
        /**
         * parse a number
         * @return {Node} node
         * @private
         */


        function parseNumber(state) {
          var numberStr;

          if (state.tokenType === TOKENTYPE.NUMBER) {
            // this is a number
            numberStr = state.token;
            getToken(state);
            return new ConstantNode(numeric(numberStr, config.number));
          }

          return parseParentheses(state);
        }
        /**
         * parentheses
         * @return {Node} node
         * @private
         */


        function parseParentheses(state) {
          var node; // check if it is a parenthesized expression

          if (state.token === '(') {
            // parentheses (...)
            openParams(state);
            getToken(state);
            node = parseAssignment(state); // start again

            if (state.token !== ')') {
              throw createSyntaxError(state, 'Parenthesis ) expected');
            }

            closeParams(state);
            getToken(state);
            node = new ParenthesisNode(node);
            node = parseAccessors(state, node);
            return node;
          }

          return parseEnd(state);
        }
        /**
         * Evaluated when the expression is not yet ended but expected to end
         * @return {Node} res
         * @private
         */


        function parseEnd(state) {
          if (state.token === '') {
            // syntax error or unexpected end of expression
            throw createSyntaxError(state, 'Unexpected end of expression');
          } else {
            throw createSyntaxError(state, 'Value expected');
          }
        }
        /**
         * Shortcut for getting the current row value (one based)
         * Returns the line of the currently handled expression
         * @private
         */

        /* TODO: implement keeping track on the row number
        function row () {
          return null
        }
        */

        /**
         * Shortcut for getting the current col value (one based)
         * Returns the column (position) where the last state.token starts
         * @private
         */


        function col(state) {
          return state.index - state.token.length + 1;
        }
        /**
         * Create an error
         * @param {string} message
         * @return {SyntaxError} instantiated error
         * @private
         */


        function createSyntaxError(state, message) {
          var c = col(state);
          var error = new SyntaxError(message + ' (char ' + c + ')');
          error['char'] = c;
          return error;
        }
        /**
         * Create an error
         * @param {string} message
         * @return {Error} instantiated error
         * @private
         */


        function createError(state, message) {
          var c = col(state);
          var error = new SyntaxError(message + ' (char ' + c + ')');
          error['char'] = c;
          return error;
        }

        return parse;
      }

      exports.name = 'parse';
      exports.path = 'expression';
      exports.factory = factory;
      /***/
    },
    /* 796 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var deepMap = __webpack_require__(80);

      function factory(type, config, load, typed) {
        var parse = load(__webpack_require__(795));
        /**
         * Evaluate an expression.
         *
         * Note the evaluating arbitrary expressions may involve security risks,
         * see [https://mathjs.org/docs/expressions/security.html](https://mathjs.org/docs/expressions/security.html) for more information.
         *
         * Syntax:
         *
         *     math.eval(expr)
         *     math.eval(expr, scope)
         *     math.eval([expr1, expr2, expr3, ...])
         *     math.eval([expr1, expr2, expr3, ...], scope)
         *
         * Example:
         *
         *     math.eval('(2+3)/4')                // 1.25
         *     math.eval('sqrt(3^2 + 4^2)')        // 5
         *     math.eval('sqrt(-4)')               // 2i
         *     math.eval(['a=3', 'b=4', 'a*b'])    // [3, 4, 12]
         *
         *     let scope = {a:3, b:4}
         *     math.eval('a * b', scope)           // 12
         *
         * See also:
         *
         *    parse, compile
         *
         * @param {string | string[] | Matrix} expr   The expression to be evaluated
         * @param {Object} [scope]                    Scope to read/write variables
         * @return {*} The result of the expression
         * @throws {Error}
         */

        return typed('compile', {
          'string': function string(expr) {
            var scope = {};
            return parse(expr).compile().eval(scope);
          },
          'string, Object': function stringObject(expr, scope) {
            return parse(expr).compile().eval(scope);
          },
          'Array | Matrix': function ArrayMatrix(expr) {
            var scope = {};
            return deepMap(expr, function (entry) {
              return parse(entry).compile().eval(scope);
            });
          },
          'Array | Matrix, Object': function ArrayMatrixObject(expr, scope) {
            return deepMap(expr, function (entry) {
              return parse(entry).compile().eval(scope);
            });
          }
        });
      }

      exports.name = 'eval';
      exports.factory = factory;
      /***/
    },
    /* 797 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var object = __webpack_require__(59);

      function factory(type, config, load, typed, math) {
        var MATRIX = ['Matrix', 'Array']; // valid values for option matrix

        var NUMBER = ['number', 'BigNumber', 'Fraction']; // valid values for option number

        /**
         * Set configuration options for math.js, and get current options.
         * Will emit a 'config' event, with arguments (curr, prev, changes).
         *
         * Syntax:
         *
         *     math.config(config: Object): Object
         *
         * Examples:
         *
         *     math.config().number                // outputs 'number'
         *     math.eval('0.4')                    // outputs number 0.4
         *     math.config({number: 'Fraction'})
         *     math.eval('0.4')                    // outputs Fraction 2/5
         *
         * @param {Object} [options] Available options:
         *                            {number} epsilon
         *                              Minimum relative difference between two
         *                              compared values, used by all comparison functions.
         *                            {string} matrix
         *                              A string 'Matrix' (default) or 'Array'.
         *                            {string} number
         *                              A string 'number' (default), 'BigNumber', or 'Fraction'
         *                            {number} precision
         *                              The number of significant digits for BigNumbers.
         *                              Not applicable for Numbers.
         *                            {string} parenthesis
         *                              How to display parentheses in LaTeX and string
         *                              output.
         *                            {string} randomSeed
         *                              Random seed for seeded pseudo random number generator.
         *                              Set to null to randomly seed.
         * @return {Object} Returns the current configuration
         */

        function _config(options) {
          if (options) {
            var prev = object.map(config, object.clone); // validate some of the options

            validateOption(options, 'matrix', MATRIX);
            validateOption(options, 'number', NUMBER); // merge options

            object.deepExtend(config, options);
            var curr = object.map(config, object.clone);
            var changes = object.map(options, object.clone); // emit 'config' event

            math.emit('config', curr, prev, changes);
            return curr;
          } else {
            return object.map(config, object.clone);
          }
        } // attach the valid options to the function so they can be extended


        _config.MATRIX = MATRIX;
        _config.NUMBER = NUMBER;
        return _config;
      }
      /**
       * Test whether an Array contains a specific item.
       * @param {Array.<string>} array
       * @param {string} item
       * @return {boolean}
       */


      function contains(array, item) {
        return array.indexOf(item) !== -1;
      }
      /**
       * Find a string in an array. Case insensitive search
       * @param {Array.<string>} array
       * @param {string} item
       * @return {number} Returns the index when found. Returns -1 when not found
       */


      function findIndex(array, item) {
        return array.map(function (i) {
          return i.toLowerCase();
        }).indexOf(item.toLowerCase());
      }
      /**
       * Validate an option
       * @param {Object} options         Object with options
       * @param {string} name            Name of the option to validate
       * @param {Array.<string>} values  Array with valid values for this option
       */


      function validateOption(options, name, values) {
        if (options[name] !== undefined && !contains(values, options[name])) {
          var index = findIndex(values, options[name]);

          if (index !== -1) {
            // right value, wrong casing
            // TODO: lower case values are deprecated since v3, remove this warning some day.
            console.warn('Warning: Wrong casing for configuration option "' + name + '", should be "' + values[index] + '" instead of "' + options[name] + '".');
            options[name] = values[index]; // change the option to the right casing
          } else {
            // unknown value
            console.warn('Warning: Unknown value "' + options[name] + '" for configuration option "' + name + '". Available options: ' + values.map(JSON.stringify).join(', ') + '.');
          }
        }
      }

      exports.name = 'config';
      exports.math = true; // request the math namespace as fifth argument

      exports.factory = factory;
      /***/
    },
    /* 798 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      var lazy = __webpack_require__(59).lazy;

      var isFactory = __webpack_require__(59).isFactory;

      var traverse = __webpack_require__(59).traverse;

      var ArgumentsError = __webpack_require__(307);

      function factory(type, config, load, typed, math) {
        /**
         * Import functions from an object or a module
         *
         * Syntax:
         *
         *    math.import(object)
         *    math.import(object, options)
         *
         * Where:
         *
         * - `object: Object`
         *   An object with functions to be imported.
         * - `options: Object` An object with import options. Available options:
         *   - `override: boolean`
         *     If true, existing functions will be overwritten. False by default.
         *   - `silent: boolean`
         *     If true, the function will not throw errors on duplicates or invalid
         *     types. False by default.
         *   - `wrap: boolean`
         *     If true, the functions will be wrapped in a wrapper function
         *     which converts data types like Matrix to primitive data types like Array.
         *     The wrapper is needed when extending math.js with libraries which do not
         *     support these data type. False by default.
         *
         * Examples:
         *
         *    // define new functions and variables
         *    math.import({
         *      myvalue: 42,
         *      hello: function (name) {
         *        return 'hello, ' + name + '!'
         *      }
         *    })
         *
         *    // use the imported function and variable
         *    math.myvalue * 2               // 84
         *    math.hello('user')             // 'hello, user!'
         *
         *    // import the npm module 'numbers'
         *    // (must be installed first with `npm install numbers`)
         *    math.import(require('numbers'), {wrap: true})
         *
         *    math.fibonacci(7) // returns 13
         *
         * @param {Object | Array} object   Object with functions to be imported.
         * @param {Object} [options]        Import options.
         */
        function mathImport(object, options) {
          var num = arguments.length;

          if (num !== 1 && num !== 2) {
            throw new ArgumentsError('import', num, 1, 2);
          }

          if (!options) {
            options = {};
          } // TODO: allow a typed-function with name too


          if (isFactory(object)) {
            _importFactory(object, options);
          } else if (Array.isArray(object)) {
            object.forEach(function (entry) {
              mathImport(entry, options);
            });
          } else if (_typeof(object) === 'object') {
            // a map with functions
            for (var name in object) {
              if (object.hasOwnProperty(name)) {
                var value = object[name];

                if (isSupportedType(value)) {
                  _import(name, value, options);
                } else if (isFactory(object)) {
                  _importFactory(object, options);
                } else {
                  mathImport(value, options);
                }
              }
            }
          } else {
            if (!options.silent) {
              throw new TypeError('Factory, Object, or Array expected');
            }
          }
        }
        /**
         * Add a property to the math namespace and create a chain proxy for it.
         * @param {string} name
         * @param {*} value
         * @param {Object} options  See import for a description of the options
         * @private
         */


        function _import(name, value, options) {
          // TODO: refactor this function, it's to complicated and contains duplicate code
          if (options.wrap && typeof value === 'function') {
            // create a wrapper around the function
            value = _wrap(value);
          }

          if (isTypedFunction(math[name]) && isTypedFunction(value)) {
            if (options.override) {
              // give the typed function the right name
              value = typed(name, value.signatures);
            } else {
              // merge the existing and typed function
              value = typed(math[name], value);
            }

            math[name] = value;

            _importTransform(name, value);

            math.emit('import', name, function resolver() {
              return value;
            });
            return;
          }

          if (math[name] === undefined || options.override) {
            math[name] = value;

            _importTransform(name, value);

            math.emit('import', name, function resolver() {
              return value;
            });
            return;
          }

          if (!options.silent) {
            throw new Error('Cannot import "' + name + '": already exists');
          }
        }

        function _importTransform(name, value) {
          if (value && typeof value.transform === 'function') {
            math.expression.transform[name] = value.transform;

            if (allowedInExpressions(name)) {
              math.expression.mathWithTransform[name] = value.transform;
            }
          } else {
            // remove existing transform
            delete math.expression.transform[name];

            if (allowedInExpressions(name)) {
              math.expression.mathWithTransform[name] = value;
            }
          }
        }

        function _deleteTransform(name) {
          delete math.expression.transform[name];

          if (allowedInExpressions(name)) {
            math.expression.mathWithTransform[name] = math[name];
          } else {
            delete math.expression.mathWithTransform[name];
          }
        }
        /**
         * Create a wrapper a round an function which converts the arguments
         * to their primitive values (like convert a Matrix to Array)
         * @param {Function} fn
         * @return {Function} Returns the wrapped function
         * @private
         */


        function _wrap(fn) {
          var wrapper = function wrapper() {
            var args = [];

            for (var i = 0, len = arguments.length; i < len; i++) {
              var arg = arguments[i];
              args[i] = arg && arg.valueOf();
            }

            return fn.apply(math, args);
          };

          if (fn.transform) {
            wrapper.transform = fn.transform;
          }

          return wrapper;
        }
        /**
         * Import an instance of a factory into math.js
         * @param {{factory: Function, name: string, path: string, math: boolean}} factory
         * @param {Object} options  See import for a description of the options
         * @private
         */


        function _importFactory(factory, options) {
          if (typeof factory.name === 'string') {
            var name = factory.name;
            var existingTransform = name in math.expression.transform;
            var namespace = factory.path ? traverse(math, factory.path) : math;
            var existing = namespace.hasOwnProperty(name) ? namespace[name] : undefined;

            var resolver = function resolver() {
              var instance = load(factory);

              if (instance && typeof instance.transform === 'function') {
                throw new Error('Transforms cannot be attached to factory functions. ' + 'Please create a separate function for it with exports.path="expression.transform"');
              }

              if (isTypedFunction(existing) && isTypedFunction(instance)) {
                if (options.override) {// replace the existing typed function (nothing to do)
                } else {
                  // merge the existing and new typed function
                  instance = typed(existing, instance);
                }

                return instance;
              }

              if (existing === undefined || options.override) {
                return instance;
              }

              if (!options.silent) {
                throw new Error('Cannot import "' + name + '": already exists');
              }
            };

            if (factory.lazy !== false) {
              lazy(namespace, name, resolver);

              if (existingTransform) {
                _deleteTransform(name);
              } else {
                if (factory.path === 'expression.transform' || factoryAllowedInExpressions(factory)) {
                  lazy(math.expression.mathWithTransform, name, resolver);
                }
              }
            } else {
              namespace[name] = resolver();

              if (existingTransform) {
                _deleteTransform(name);
              } else {
                if (factory.path === 'expression.transform' || factoryAllowedInExpressions(factory)) {
                  math.expression.mathWithTransform[name] = resolver();
                }
              }
            }

            math.emit('import', name, resolver, factory.path);
          } else {
            // unnamed factory.
            // no lazy loading
            load(factory);
          }
        }
        /**
         * Check whether given object is a type which can be imported
         * @param {Function | number | string | boolean | null | Unit | Complex} object
         * @return {boolean}
         * @private
         */


        function isSupportedType(object) {
          return typeof object === 'function' || typeof object === 'number' || typeof object === 'string' || typeof object === 'boolean' || object === null || object && type.isUnit(object) || object && type.isComplex(object) || object && type.isBigNumber(object) || object && type.isFraction(object) || object && type.isMatrix(object) || object && Array.isArray(object);
        }
        /**
         * Test whether a given thing is a typed-function
         * @param {*} fn
         * @return {boolean} Returns true when `fn` is a typed-function
         */


        function isTypedFunction(fn) {
          return typeof fn === 'function' && _typeof(fn.signatures) === 'object';
        }

        function allowedInExpressions(name) {
          return !unsafe.hasOwnProperty(name);
        }

        function factoryAllowedInExpressions(factory) {
          return factory.path === undefined && !unsafe.hasOwnProperty(factory.name);
        } // namespaces and functions not available in the parser for safety reasons


        var unsafe = {
          'expression': true,
          'type': true,
          'docs': true,
          'error': true,
          'json': true,
          'chain': true // chain method not supported. Note that there is a unit chain too.

        };
        return mathImport;
      }

      exports.math = true; // request access to the math namespace as 5th argument of the factory function

      exports.name = 'import';
      exports.factory = factory;
      exports.lazy = true;
      /***/
    },
    /* 799 */

    /***/
    function (module, exports) {
      function E() {// Keep this empty so it's easier to inherit from
        // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
      }

      E.prototype = {
        on: function on(name, callback, ctx) {
          var e = this.e || (this.e = {});
          (e[name] || (e[name] = [])).push({
            fn: callback,
            ctx: ctx
          });
          return this;
        },
        once: function once(name, callback, ctx) {
          var self = this;

          function listener() {
            self.off(name, listener);
            callback.apply(ctx, arguments);
          }

          ;
          listener._ = callback;
          return this.on(name, listener, ctx);
        },
        emit: function emit(name) {
          var data = [].slice.call(arguments, 1);
          var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
          var i = 0;
          var len = evtArr.length;

          for (i; i < len; i++) {
            evtArr[i].fn.apply(evtArr[i].ctx, data);
          }

          return this;
        },
        off: function off(name, callback) {
          var e = this.e || (this.e = {});
          var evts = e[name];
          var liveEvents = [];

          if (evts && callback) {
            for (var i = 0, len = evts.length; i < len; i++) {
              if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
            }
          } // Remove event from queue to prevent memory leak
          // Suggested by https://github.com/lazd
          // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910


          liveEvents.length ? e[name] = liveEvents : delete e[name];
          return this;
        }
      };
      module.exports = E;
      module.exports.TinyEmitter = E;
      /***/
    },
    /* 800 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /**
      * typed-function
      *
      * Type checking for JavaScript functions
      *
      * https://github.com/josdejong/typed-function
      */


      (function (root, factory) {
        if (true) {
          // AMD. Register as an anonymous module.
          !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
      })(this, function () {
        function ok() {
          return true;
        }

        function notOk() {
          return false;
        }

        function undef() {
          return undefined;
        }
        /**
         * @typedef {{
         *   params: Param[],
         *   fn: function
         * }} Signature
         *
         * @typedef {{
         *   types: Type[],
         *   restParam: boolean
         * }} Param
         *
         * @typedef {{
         *   name: string,
         *   typeIndex: number,
         *   test: function,
         *   conversion?: ConversionDef,
         *   conversionIndex: number,
         * }} Type
         *
         * @typedef {{
         *   from: string,
         *   to: string,
         *   convert: function (*) : *
         * }} ConversionDef
         *
         * @typedef {{
         *   name: string,
         *   test: function(*) : boolean
         * }} TypeDef
         */
        // create a new instance of typed-function


        function create() {
          // data type tests
          var _types = [{
            name: 'number',
            test: function test(x) {
              return typeof x === 'number';
            }
          }, {
            name: 'string',
            test: function test(x) {
              return typeof x === 'string';
            }
          }, {
            name: 'boolean',
            test: function test(x) {
              return typeof x === 'boolean';
            }
          }, {
            name: 'Function',
            test: function test(x) {
              return typeof x === 'function';
            }
          }, {
            name: 'Array',
            test: Array.isArray
          }, {
            name: 'Date',
            test: function test(x) {
              return x instanceof Date;
            }
          }, {
            name: 'RegExp',
            test: function test(x) {
              return x instanceof RegExp;
            }
          }, {
            name: 'Object',
            test: function test(x) {
              return typeof x === 'object' && x.constructor === Object;
            }
          }, {
            name: 'null',
            test: function test(x) {
              return x === null;
            }
          }, {
            name: 'undefined',
            test: function test(x) {
              return x === undefined;
            }
          }];
          var anyType = {
            name: 'any',
            test: ok // types which need to be ignored

          };
          var _ignore = []; // type conversions

          var _conversions = []; // This is a temporary object, will be replaced with a typed function at the end

          var typed = {
            types: _types,
            conversions: _conversions,
            ignore: _ignore
          };
          /**
           * Find the test function for a type
           * @param {String} typeName
           * @return {TypeDef} Returns the type definition when found,
           *                    Throws a TypeError otherwise
           */

          function findTypeByName(typeName) {
            var entry = findInArray(typed.types, function (entry) {
              return entry.name === typeName;
            });

            if (entry) {
              return entry;
            }

            if (typeName === 'any') {
              // special baked-in case 'any'
              return anyType;
            }

            var hint = findInArray(typed.types, function (entry) {
              return entry.name.toLowerCase() === typeName.toLowerCase();
            });
            throw new TypeError('Unknown type "' + typeName + '"' + (hint ? '. Did you mean "' + hint.name + '"?' : ''));
          }
          /**
           * Find the index of a type definition. Handles special case 'any'
           * @param {TypeDef} type
           * @return {number}
           */


          function findTypeIndex(type) {
            if (type === anyType) {
              return 999;
            }

            return typed.types.indexOf(type);
          }
          /**
           * Find a type that matches a value.
           * @param {*} value
           * @return {string} Returns the name of the first type for which
           *                  the type test matches the value.
           */


          function findTypeName(value) {
            var entry = findInArray(typed.types, function (entry) {
              return entry.test(value);
            });

            if (entry) {
              return entry.name;
            }

            throw new TypeError('Value has unknown type. Value: ' + value);
          }
          /**
           * Find a specific signature from a (composed) typed function, for example:
           *
           *   typed.find(fn, ['number', 'string'])
           *   typed.find(fn, 'number, string')
           *
           * Function find only only works for exact matches.
           *
           * @param {Function} fn                   A typed-function
           * @param {string | string[]} signature   Signature to be found, can be
           *                                        an array or a comma separated string.
           * @return {Function}                     Returns the matching signature, or
           *                                        throws an error when no signature
           *                                        is found.
           */


          function find(fn, signature) {
            if (!fn.signatures) {
              throw new TypeError('Function is no typed-function');
            } // normalize input


            var arr;

            if (typeof signature === 'string') {
              arr = signature.split(',');

              for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].trim();
              }
            } else if (Array.isArray(signature)) {
              arr = signature;
            } else {
              throw new TypeError('String array or a comma separated string expected');
            }

            var str = arr.join(','); // find an exact match

            var match = fn.signatures[str];

            if (match) {
              return match;
            } // TODO: extend find to match non-exact signatures


            throw new TypeError('Signature not found (signature: ' + (fn.name || 'unnamed') + '(' + arr.join(', ') + '))');
          }
          /**
           * Convert a given value to another data type.
           * @param {*} value
           * @param {string} type
           */


          function convert(value, type) {
            var from = findTypeName(value); // check conversion is needed

            if (type === from) {
              return value;
            }

            for (var i = 0; i < typed.conversions.length; i++) {
              var conversion = typed.conversions[i];

              if (conversion.from === from && conversion.to === type) {
                return conversion.convert(value);
              }
            }

            throw new Error('Cannot convert from ' + from + ' to ' + type);
          }
          /**
           * Stringify parameters in a normalized way
           * @param {Param[]} params
           * @return {string}
           */


          function stringifyParams(params) {
            return params.map(function (param) {
              var typeNames = param.types.map(getTypeName);
              return (param.restParam ? '...' : '') + typeNames.join('|');
            }).join(',');
          }
          /**
           * Parse a parameter, like "...number | boolean"
           * @param {string} param
           * @param {ConversionDef[]} conversions
           * @return {Param} param
           */


          function parseParam(param, conversions) {
            var restParam = param.indexOf('...') === 0;
            var types = !restParam ? param : param.length > 3 ? param.slice(3) : 'any';
            var typeNames = types.split('|').map(trim).filter(notEmpty).filter(notIgnore);
            var matchingConversions = filterConversions(conversions, typeNames);
            var exactTypes = typeNames.map(function (typeName) {
              var type = findTypeByName(typeName);
              return {
                name: typeName,
                typeIndex: findTypeIndex(type),
                test: type.test,
                conversion: null,
                conversionIndex: -1
              };
            });
            var convertibleTypes = matchingConversions.map(function (conversion) {
              var type = findTypeByName(conversion.from);
              return {
                name: conversion.from,
                typeIndex: findTypeIndex(type),
                test: type.test,
                conversion: conversion,
                conversionIndex: conversions.indexOf(conversion)
              };
            });
            return {
              types: exactTypes.concat(convertibleTypes),
              restParam: restParam
            };
          }
          /**
           * Parse a signature with comma separated parameters,
           * like "number | boolean, ...string"
           * @param {string} signature
           * @param {function} fn
           * @param {ConversionDef[]} conversions
           * @return {Signature | null} signature
           */


          function parseSignature(signature, fn, conversions) {
            var params = [];

            if (signature.trim() !== '') {
              params = signature.split(',').map(trim).map(function (param, index, array) {
                var parsedParam = parseParam(param, conversions);

                if (parsedParam.restParam && index !== array.length - 1) {
                  throw new SyntaxError('Unexpected rest parameter "' + param + '": ' + 'only allowed for the last parameter');
                }

                return parsedParam;
              });
            }

            if (params.some(isInvalidParam)) {
              // invalid signature: at least one parameter has no types
              // (they may have been filtered)
              return null;
            }

            return {
              params: params,
              fn: fn
            };
          }
          /**
           * Test whether a set of params contains a restParam
           * @param {Param[]} params
           * @return {boolean} Returns true when the last parameter is a restParam
           */


          function hasRestParam(params) {
            var param = last(params);
            return param ? param.restParam : false;
          }
          /**
           * Test whether a parameter contains conversions
           * @param {Param} param
           * @return {boolean} Returns true when at least one of the parameters
           *                   contains a conversion.
           */


          function hasConversions(param) {
            return param.types.some(function (type) {
              return type.conversion != null;
            });
          }
          /**
           * Create a type test for a single parameter, which can have one or multiple
           * types.
           * @param {Param} param
           * @return {function(x: *) : boolean} Returns a test function
           */


          function compileTest(param) {
            if (!param || param.types.length === 0) {
              // nothing to do
              return ok;
            } else if (param.types.length === 1) {
              return findTypeByName(param.types[0].name).test;
            } else if (param.types.length === 2) {
              var test0 = findTypeByName(param.types[0].name).test;
              var test1 = findTypeByName(param.types[1].name).test;
              return function or(x) {
                return test0(x) || test1(x);
              };
            } else {
              // param.types.length > 2
              var tests = param.types.map(function (type) {
                return findTypeByName(type.name).test;
              });
              return function or(x) {
                for (var i = 0; i < tests.length; i++) {
                  if (tests[i](x)) {
                    return true;
                  }
                }

                return false;
              };
            }
          }
          /**
           * Create a test for all parameters of a signature
           * @param {Param[]} params
           * @return {function(args: Array<*>) : boolean}
           */


          function compileTests(params) {
            var tests, test0, test1;

            if (hasRestParam(params)) {
              // variable arguments like '...number'
              tests = initial(params).map(compileTest);
              var varIndex = tests.length;
              var lastTest = compileTest(last(params));

              var testRestParam = function testRestParam(args) {
                for (var i = varIndex; i < args.length; i++) {
                  if (!lastTest(args[i])) {
                    return false;
                  }
                }

                return true;
              };

              return function testArgs(args) {
                for (var i = 0; i < tests.length; i++) {
                  if (!tests[i](args[i])) {
                    return false;
                  }
                }

                return testRestParam(args) && args.length >= varIndex + 1;
              };
            } else {
              // no variable arguments
              if (params.length === 0) {
                return function testArgs(args) {
                  return args.length === 0;
                };
              } else if (params.length === 1) {
                test0 = compileTest(params[0]);
                return function testArgs(args) {
                  return test0(args[0]) && args.length === 1;
                };
              } else if (params.length === 2) {
                test0 = compileTest(params[0]);
                test1 = compileTest(params[1]);
                return function testArgs(args) {
                  return test0(args[0]) && test1(args[1]) && args.length === 2;
                };
              } else {
                // arguments.length > 2
                tests = params.map(compileTest);
                return function testArgs(args) {
                  for (var i = 0; i < tests.length; i++) {
                    if (!tests[i](args[i])) {
                      return false;
                    }
                  }

                  return args.length === tests.length;
                };
              }
            }
          }
          /**
           * Find the parameter at a specific index of a signature.
           * Handles rest parameters.
           * @param {Signature} signature
           * @param {number} index
           * @return {Param | null} Returns the matching parameter when found,
           *                        null otherwise.
           */


          function getParamAtIndex(signature, index) {
            return index < signature.params.length ? signature.params[index] : hasRestParam(signature.params) ? last(signature.params) : null;
          }
          /**
           * Get all type names of a parameter
           * @param {Signature} signature
           * @param {number} index
           * @param {boolean} excludeConversions
           * @return {string[]} Returns an array with type names
           */


          function getExpectedTypeNames(signature, index, excludeConversions) {
            var param = getParamAtIndex(signature, index);
            var types = param ? excludeConversions ? param.types.filter(isExactType) : param.types : [];
            return types.map(getTypeName);
          }
          /**
           * Returns the name of a type
           * @param {Type} type
           * @return {string} Returns the type name
           */


          function getTypeName(type) {
            return type.name;
          }
          /**
           * Test whether a type is an exact type or conversion
           * @param {Type} type
           * @return {boolean} Returns true when
           */


          function isExactType(type) {
            return type.conversion === null || type.conversion === undefined;
          }
          /**
           * Helper function for creating error messages: create an array with
           * all available types on a specific argument index.
           * @param {Signature[]} signatures
           * @param {number} index
           * @return {string[]} Returns an array with available types
           */


          function mergeExpectedParams(signatures, index) {
            var typeNames = uniq(flatMap(signatures, function (signature) {
              return getExpectedTypeNames(signature, index, false);
            }));
            return typeNames.indexOf('any') !== -1 ? ['any'] : typeNames;
          }
          /**
           * Create
           * @param {string} name             The name of the function
           * @param {array.<*>} args          The actual arguments passed to the function
           * @param {Signature[]} signatures  A list with available signatures
           * @return {TypeError} Returns a type error with additional data
           *                     attached to it in the property `data`
           */


          function createError(name, args, signatures) {
            var err, expected;

            var _name = name || 'unnamed'; // test for wrong type at some index


            var matchingSignatures = signatures;
            var index;

            for (index = 0; index < args.length; index++) {
              var nextMatchingDefs = matchingSignatures.filter(function (signature) {
                var test = compileTest(getParamAtIndex(signature, index));
                return (index < signature.params.length || hasRestParam(signature.params)) && test(args[index]);
              });

              if (nextMatchingDefs.length === 0) {
                // no matching signatures anymore, throw error "wrong type"
                expected = mergeExpectedParams(matchingSignatures, index);

                if (expected.length > 0) {
                  var actualType = findTypeName(args[index]);
                  err = new TypeError('Unexpected type of argument in function ' + _name + ' (expected: ' + expected.join(' or ') + ', actual: ' + actualType + ', index: ' + index + ')');
                  err.data = {
                    category: 'wrongType',
                    fn: _name,
                    index: index,
                    actual: actualType,
                    expected: expected
                  };
                  return err;
                }
              } else {
                matchingSignatures = nextMatchingDefs;
              }
            } // test for too few arguments


            var lengths = matchingSignatures.map(function (signature) {
              return hasRestParam(signature.params) ? Infinity : signature.params.length;
            });

            if (args.length < Math.min.apply(null, lengths)) {
              expected = mergeExpectedParams(matchingSignatures, index);
              err = new TypeError('Too few arguments in function ' + _name + ' (expected: ' + expected.join(' or ') + ', index: ' + args.length + ')');
              err.data = {
                category: 'tooFewArgs',
                fn: _name,
                index: args.length,
                expected: expected
              };
              return err;
            } // test for too many arguments


            var maxLength = Math.max.apply(null, lengths);

            if (args.length > maxLength) {
              err = new TypeError('Too many arguments in function ' + _name + ' (expected: ' + maxLength + ', actual: ' + args.length + ')');
              err.data = {
                category: 'tooManyArgs',
                fn: _name,
                index: args.length,
                expectedLength: maxLength
              };
              return err;
            }

            err = new TypeError('Arguments of type "' + args.join(', ') + '" do not match any of the defined signatures of function ' + _name + '.');
            err.data = {
              category: 'mismatch',
              actual: args.map(findTypeName)
            };
            return err;
          }
          /**
           * Find the lowest index of all exact types of a parameter (no conversions)
           * @param {Param} param
           * @return {number} Returns the index of the lowest type in typed.types
           */


          function getLowestTypeIndex(param) {
            var min = 999;

            for (var i = 0; i < param.types.length; i++) {
              if (isExactType(param.types[i])) {
                min = Math.min(min, param.types[i].typeIndex);
              }
            }

            return min;
          }
          /**
           * Find the lowest index of the conversion of all types of the parameter
           * having a conversion
           * @param {Param} param
           * @return {number} Returns the lowest index of the conversions of this type
           */


          function getLowestConversionIndex(param) {
            var min = 999;

            for (var i = 0; i < param.types.length; i++) {
              if (!isExactType(param.types[i])) {
                min = Math.min(min, param.types[i].conversionIndex);
              }
            }

            return min;
          }
          /**
           * Compare two params
           * @param {Param} param1
           * @param {Param} param2
           * @return {number} returns a negative number when param1 must get a lower
           *                  index than param2, a positive number when the opposite,
           *                  or zero when both are equal
           */


          function compareParams(param1, param2) {
            var c; // compare having a rest parameter or not

            c = param1.restParam - param2.restParam;

            if (c !== 0) {
              return c;
            } // compare having conversions or not


            c = hasConversions(param1) - hasConversions(param2);

            if (c !== 0) {
              return c;
            } // compare the index of the types


            c = getLowestTypeIndex(param1) - getLowestTypeIndex(param2);

            if (c !== 0) {
              return c;
            } // compare the index of any conversion


            return getLowestConversionIndex(param1) - getLowestConversionIndex(param2);
          }
          /**
           * Compare two signatures
           * @param {Signature} signature1
           * @param {Signature} signature2
           * @return {number} returns a negative number when param1 must get a lower
           *                  index than param2, a positive number when the opposite,
           *                  or zero when both are equal
           */


          function compareSignatures(signature1, signature2) {
            var len = Math.min(signature1.params.length, signature2.params.length);
            var i;
            var c; // compare whether the params have conversions at all or not

            c = signature1.params.some(hasConversions) - signature2.params.some(hasConversions);

            if (c !== 0) {
              return c;
            } // next compare whether the params have conversions one by one


            for (i = 0; i < len; i++) {
              c = hasConversions(signature1.params[i]) - hasConversions(signature2.params[i]);

              if (c !== 0) {
                return c;
              }
            } // compare the types of the params one by one


            for (i = 0; i < len; i++) {
              c = compareParams(signature1.params[i], signature2.params[i]);

              if (c !== 0) {
                return c;
              }
            } // compare the number of params


            return signature1.params.length - signature2.params.length;
          }
          /**
           * Get params containing all types that can be converted to the defined types.
           *
           * @param {ConversionDef[]} conversions
           * @param {string[]} typeNames
           * @return {ConversionDef[]} Returns the conversions that are available
           *                        for every type (if any)
           */


          function filterConversions(conversions, typeNames) {
            var matches = {};
            conversions.forEach(function (conversion) {
              if (typeNames.indexOf(conversion.from) === -1 && typeNames.indexOf(conversion.to) !== -1 && !matches[conversion.from]) {
                matches[conversion.from] = conversion;
              }
            });
            return Object.keys(matches).map(function (from) {
              return matches[from];
            });
          }
          /**
           * Preprocess arguments before calling the original function:
           * - if needed convert the parameters
           * - in case of rest parameters, move the rest parameters into an Array
           * @param {Param[]} params
           * @param {function} fn
           * @return {function} Returns a wrapped function
           */


          function compileArgsPreprocessing(params, fn) {
            var fnConvert = fn; // TODO: can we make this wrapper function smarter/simpler?

            if (params.some(hasConversions)) {
              var restParam = hasRestParam(params);
              var compiledConversions = params.map(compileArgConversion);

              fnConvert = function convertArgs() {
                var args = [];
                var last = restParam ? arguments.length - 1 : arguments.length;

                for (var i = 0; i < last; i++) {
                  args[i] = compiledConversions[i](arguments[i]);
                }

                if (restParam) {
                  args[last] = arguments[last].map(compiledConversions[last]);
                }

                return fn.apply(null, args);
              };
            }

            var fnPreprocess = fnConvert;

            if (hasRestParam(params)) {
              var offset = params.length - 1;

              fnPreprocess = function preprocessRestParams() {
                return fnConvert.apply(null, slice(arguments, 0, offset).concat([slice(arguments, offset)]));
              };
            }

            return fnPreprocess;
          }
          /**
           * Compile conversion for a parameter to the right type
           * @param {Param} param
           * @return {function} Returns the wrapped function that will convert arguments
           *
           */


          function compileArgConversion(param) {
            var test0, test1, conversion0, conversion1;
            var tests = [];
            var conversions = [];
            param.types.forEach(function (type) {
              if (type.conversion) {
                tests.push(findTypeByName(type.conversion.from).test);
                conversions.push(type.conversion.convert);
              }
            }); // create optimized conversion functions depending on the number of conversions

            switch (conversions.length) {
              case 0:
                return function convertArg(arg) {
                  return arg;
                };

              case 1:
                test0 = tests[0];
                conversion0 = conversions[0];
                return function convertArg(arg) {
                  if (test0(arg)) {
                    return conversion0(arg);
                  }

                  return arg;
                };

              case 2:
                test0 = tests[0];
                test1 = tests[1];
                conversion0 = conversions[0];
                conversion1 = conversions[1];
                return function convertArg(arg) {
                  if (test0(arg)) {
                    return conversion0(arg);
                  }

                  if (test1(arg)) {
                    return conversion1(arg);
                  }

                  return arg;
                };

              default:
                return function convertArg(arg) {
                  for (var i = 0; i < conversions.length; i++) {
                    if (tests[i](arg)) {
                      return conversions[i](arg);
                    }
                  }

                  return arg;
                };
            }
          }
          /**
           * Convert an array with signatures into a map with signatures,
           * where signatures with union types are split into separate signatures
           *
           * Throws an error when there are conflicting types
           *
           * @param {Signature[]} signatures
           * @return {Object.<string, function>}  Returns a map with signatures
           *                                      as key and the original function
           *                                      of this signature as value.
           */


          function createSignaturesMap(signatures) {
            var signaturesMap = {};
            signatures.forEach(function (signature) {
              if (!signature.params.some(hasConversions)) {
                splitParams(signature.params, true).forEach(function (params) {
                  signaturesMap[stringifyParams(params)] = signature.fn;
                });
              }
            });
            return signaturesMap;
          }
          /**
           * Split params with union types in to separate params.
           *
           * For example:
           *
           *     splitParams([['Array', 'Object'], ['string', 'RegExp'])
           *     // returns:
           *     // [
           *     //   ['Array', 'string'],
           *     //   ['Array', 'RegExp'],
           *     //   ['Object', 'string'],
           *     //   ['Object', 'RegExp']
           *     // ]
           *
           * @param {Param[]} params
           * @param {boolean} ignoreConversionTypes
           * @return {Param[]}
           */


          function splitParams(params, ignoreConversionTypes) {
            function _splitParams(params, index, types) {
              if (index < params.length) {
                var param = params[index];
                var filteredTypes = ignoreConversionTypes ? param.types.filter(isExactType) : param.types;
                var typeGroups;

                if (param.restParam) {
                  // split the types of a rest parameter in two:
                  // one with only exact types, and one with exact types and conversions
                  var exactTypes = filteredTypes.filter(isExactType);
                  typeGroups = exactTypes.length < filteredTypes.length ? [exactTypes, filteredTypes] : [filteredTypes];
                } else {
                  // split all the types of a regular parameter into one type per group
                  typeGroups = filteredTypes.map(function (type) {
                    return [type];
                  });
                } // recurse over the groups with types


                return flatMap(typeGroups, function (typeGroup) {
                  return _splitParams(params, index + 1, types.concat([typeGroup]));
                });
              } else {
                // we've reached the end of the parameters. Now build a new Param
                var splittedParams = types.map(function (type, typeIndex) {
                  return {
                    types: type,
                    restParam: typeIndex === params.length - 1 && hasRestParam(params)
                  };
                });
                return [splittedParams];
              }
            }

            return _splitParams(params, 0, []);
          }
          /**
           * Test whether two signatures have a conflicting signature
           * @param {Signature} signature1
           * @param {Signature} signature2
           * @return {boolean} Returns true when the signatures conflict, false otherwise.
           */


          function hasConflictingParams(signature1, signature2) {
            var ii = Math.max(signature1.params.length, signature2.params.length);

            for (var i = 0; i < ii; i++) {
              var typesNames1 = getExpectedTypeNames(signature1, i, true);
              var typesNames2 = getExpectedTypeNames(signature2, i, true);

              if (!hasOverlap(typesNames1, typesNames2)) {
                return false;
              }
            }

            var len1 = signature1.params.length;
            var len2 = signature2.params.length;
            var restParam1 = hasRestParam(signature1.params);
            var restParam2 = hasRestParam(signature2.params);
            return restParam1 ? restParam2 ? len1 === len2 : len2 >= len1 : restParam2 ? len1 >= len2 : len1 === len2;
          }
          /**
           * Create a typed function
           * @param {String} name               The name for the typed function
           * @param {Object.<string, function>} signaturesMap
           *                                    An object with one or
           *                                    multiple signatures as key, and the
           *                                    function corresponding to the
           *                                    signature as value.
           * @return {function}  Returns the created typed function.
           */


          function createTypedFunction(name, signaturesMap) {
            if (Object.keys(signaturesMap).length === 0) {
              throw new SyntaxError('No signatures provided');
            } // parse the signatures, and check for conflicts


            var parsedSignatures = [];
            Object.keys(signaturesMap).map(function (signature) {
              return parseSignature(signature, signaturesMap[signature], typed.conversions);
            }).filter(notNull).forEach(function (parsedSignature) {
              // check whether this parameter conflicts with already parsed signatures
              var conflictingSignature = findInArray(parsedSignatures, function (s) {
                return hasConflictingParams(s, parsedSignature);
              });

              if (conflictingSignature) {
                throw new TypeError('Conflicting signatures "' + stringifyParams(conflictingSignature.params) + '" and "' + stringifyParams(parsedSignature.params) + '".');
              }

              parsedSignatures.push(parsedSignature);
            }); // split and filter the types of the signatures, and then order them

            var signatures = flatMap(parsedSignatures, function (parsedSignature) {
              var params = parsedSignature ? splitParams(parsedSignature.params, false) : [];
              return params.map(function (params) {
                return {
                  params: params,
                  fn: parsedSignature.fn
                };
              });
            }).filter(notNull);
            signatures.sort(compareSignatures); // we create a highly optimized checks for the first couple of signatures with max 2 arguments

            var ok0 = signatures[0] && signatures[0].params.length <= 2 && !hasRestParam(signatures[0].params);
            var ok1 = signatures[1] && signatures[1].params.length <= 2 && !hasRestParam(signatures[1].params);
            var ok2 = signatures[2] && signatures[2].params.length <= 2 && !hasRestParam(signatures[2].params);
            var ok3 = signatures[3] && signatures[3].params.length <= 2 && !hasRestParam(signatures[3].params);
            var ok4 = signatures[4] && signatures[4].params.length <= 2 && !hasRestParam(signatures[4].params);
            var ok5 = signatures[5] && signatures[5].params.length <= 2 && !hasRestParam(signatures[5].params);
            var allOk = ok0 && ok1 && ok2 && ok3 && ok4 && ok5; // compile the tests

            var tests = signatures.map(function (signature) {
              return compileTests(signature.params);
            });
            var test00 = ok0 ? compileTest(signatures[0].params[0]) : notOk;
            var test10 = ok1 ? compileTest(signatures[1].params[0]) : notOk;
            var test20 = ok2 ? compileTest(signatures[2].params[0]) : notOk;
            var test30 = ok3 ? compileTest(signatures[3].params[0]) : notOk;
            var test40 = ok4 ? compileTest(signatures[4].params[0]) : notOk;
            var test50 = ok5 ? compileTest(signatures[5].params[0]) : notOk;
            var test01 = ok0 ? compileTest(signatures[0].params[1]) : notOk;
            var test11 = ok1 ? compileTest(signatures[1].params[1]) : notOk;
            var test21 = ok2 ? compileTest(signatures[2].params[1]) : notOk;
            var test31 = ok3 ? compileTest(signatures[3].params[1]) : notOk;
            var test41 = ok4 ? compileTest(signatures[4].params[1]) : notOk;
            var test51 = ok5 ? compileTest(signatures[5].params[1]) : notOk; // compile the functions

            var fns = signatures.map(function (signature) {
              return compileArgsPreprocessing(signature.params, signature.fn);
            });
            var fn0 = ok0 ? fns[0] : undef;
            var fn1 = ok1 ? fns[1] : undef;
            var fn2 = ok2 ? fns[2] : undef;
            var fn3 = ok3 ? fns[3] : undef;
            var fn4 = ok4 ? fns[4] : undef;
            var fn5 = ok5 ? fns[5] : undef;
            var len0 = ok0 ? signatures[0].params.length : -1;
            var len1 = ok1 ? signatures[1].params.length : -1;
            var len2 = ok2 ? signatures[2].params.length : -1;
            var len3 = ok3 ? signatures[3].params.length : -1;
            var len4 = ok4 ? signatures[4].params.length : -1;
            var len5 = ok5 ? signatures[5].params.length : -1; // simple and generic, but also slow

            var iStart = allOk ? 6 : 0;
            var iEnd = signatures.length;

            var generic = function generic() {
              'use strict';

              for (var i = iStart; i < iEnd; i++) {
                if (tests[i](arguments)) {
                  return fns[i].apply(null, arguments);
                }
              }

              throw createError(name, arguments, signatures);
            }; // create the typed function
            // fast, specialized version. Falls back to the slower, generic one if needed


            var fn = function fn(arg0, arg1) {
              'use strict';

              if (arguments.length === len0 && test00(arg0) && test01(arg1)) {
                return fn0.apply(null, arguments);
              }

              if (arguments.length === len1 && test10(arg0) && test11(arg1)) {
                return fn1.apply(null, arguments);
              }

              if (arguments.length === len2 && test20(arg0) && test21(arg1)) {
                return fn2.apply(null, arguments);
              }

              if (arguments.length === len3 && test30(arg0) && test31(arg1)) {
                return fn3.apply(null, arguments);
              }

              if (arguments.length === len4 && test40(arg0) && test41(arg1)) {
                return fn4.apply(null, arguments);
              }

              if (arguments.length === len5 && test50(arg0) && test51(arg1)) {
                return fn5.apply(null, arguments);
              }

              return generic.apply(null, arguments);
            }; // attach name the typed function


            try {
              Object.defineProperty(fn, 'name', {
                value: name
              });
            } catch (err) {} // old browsers do not support Object.defineProperty and some don't support setting the name property
            // the function name is not essential for the functioning, it's mostly useful for debugging,
            // so it's fine to have unnamed functions.
            // attach signatures to the function


            fn.signatures = createSignaturesMap(signatures);
            return fn;
          }
          /**
           * Test whether a type should be NOT be ignored
           * @param {string} typeName
           * @return {boolean}
           */


          function notIgnore(typeName) {
            return typed.ignore.indexOf(typeName) === -1;
          }
          /**
           * trim a string
           * @param {string} str
           * @return {string}
           */


          function trim(str) {
            return str.trim();
          }
          /**
           * Test whether a string is not empty
           * @param {string} str
           * @return {boolean}
           */


          function notEmpty(str) {
            return !!str;
          }
          /**
           * test whether a value is not strict equal to null
           * @param {*} value
           * @return {boolean}
           */


          function notNull(value) {
            return value !== null;
          }
          /**
           * Test whether a parameter has no types defined
           * @param {Param} param
           * @return {boolean}
           */


          function isInvalidParam(param) {
            return param.types.length === 0;
          }
          /**
           * Return all but the last items of an array
           * @param {Array} arr
           * @return {Array}
           */


          function initial(arr) {
            return arr.slice(0, arr.length - 1);
          }
          /**
           * return the last item of an array
           * @param {Array} arr
           * @return {*}
           */


          function last(arr) {
            return arr[arr.length - 1];
          }
          /**
           * Slice an array or function Arguments
           * @param {Array | Arguments | IArguments} arr
           * @param {number} start
           * @param {number} [end]
           * @return {Array}
           */


          function slice(arr, start, end) {
            return Array.prototype.slice.call(arr, start, end);
          }
          /**
           * Test whether an array contains some item
           * @param {Array} array
           * @param {*} item
           * @return {boolean} Returns true if array contains item, false if not.
           */


          function contains(array, item) {
            return array.indexOf(item) !== -1;
          }
          /**
           * Test whether two arrays have overlapping items
           * @param {Array} array1
           * @param {Array} array2
           * @return {boolean} Returns true when at least one item exists in both arrays
           */


          function hasOverlap(array1, array2) {
            for (var i = 0; i < array1.length; i++) {
              if (contains(array2, array1[i])) {
                return true;
              }
            }

            return false;
          }
          /**
           * Return the first item from an array for which test(arr[i]) returns true
           * @param {Array} arr
           * @param {function} test
           * @return {* | undefined} Returns the first matching item
           *                         or undefined when there is no match
           */


          function findInArray(arr, test) {
            for (var i = 0; i < arr.length; i++) {
              if (test(arr[i])) {
                return arr[i];
              }
            }

            return undefined;
          }
          /**
           * Filter unique items of an array with strings
           * @param {string[]} arr
           * @return {string[]}
           */


          function uniq(arr) {
            var entries = {};

            for (var i = 0; i < arr.length; i++) {
              entries[arr[i]] = true;
            }

            return Object.keys(entries);
          }
          /**
           * Flat map the result invoking a callback for every item in an array.
           * https://gist.github.com/samgiles/762ee337dff48623e729
           * @param {Array} arr
           * @param {function} callback
           * @return {Array}
           */


          function flatMap(arr, callback) {
            return Array.prototype.concat.apply([], arr.map(callback));
          }
          /**
           * Retrieve the function name from a set of typed functions,
           * and check whether the name of all functions match (if given)
           * @param {function[]} fns
           */


          function getName(fns) {
            var name = '';

            for (var i = 0; i < fns.length; i++) {
              var fn = fns[i]; // check whether the names are the same when defined

              if ((typeof fn.signatures === 'object' || typeof fn.signature === 'string') && fn.name !== '') {
                if (name === '') {
                  name = fn.name;
                } else if (name !== fn.name) {
                  var err = new Error('Function names do not match (expected: ' + name + ', actual: ' + fn.name + ')');
                  err.data = {
                    actual: fn.name,
                    expected: name
                  };
                  throw err;
                }
              }
            }

            return name;
          } // extract and merge all signatures of a list with typed functions


          function extractSignatures(fns) {
            var err;
            var signaturesMap = {};

            function validateUnique(_signature, _fn) {
              if (signaturesMap.hasOwnProperty(_signature) && _fn !== signaturesMap[_signature]) {
                err = new Error('Signature "' + _signature + '" is defined twice');
                err.data = {
                  signature: _signature
                };
                throw err; // else: both signatures point to the same function, that's fine
              }
            }

            for (var i = 0; i < fns.length; i++) {
              var fn = fns[i]; // test whether this is a typed-function

              if (typeof fn.signatures === 'object') {
                // merge the signatures
                for (var signature in fn.signatures) {
                  if (fn.signatures.hasOwnProperty(signature)) {
                    validateUnique(signature, fn.signatures[signature]);
                    signaturesMap[signature] = fn.signatures[signature];
                  }
                }
              } else if (typeof fn.signature === 'string') {
                validateUnique(fn.signature, fn);
                signaturesMap[fn.signature] = fn;
              } else {
                err = new TypeError('Function is no typed-function (index: ' + i + ')');
                err.data = {
                  index: i
                };
                throw err;
              }
            }

            return signaturesMap;
          }

          typed = createTypedFunction('typed', {
            'string, Object': createTypedFunction,
            'Object': function Object(signaturesMap) {
              // find existing name
              var fns = [];

              for (var signature in signaturesMap) {
                if (signaturesMap.hasOwnProperty(signature)) {
                  fns.push(signaturesMap[signature]);
                }
              }

              var name = getName(fns);
              return createTypedFunction(name, signaturesMap);
            },
            '...Function': function Function(fns) {
              return createTypedFunction(getName(fns), extractSignatures(fns));
            },
            'string, ...Function': function stringFunction(name, fns) {
              return createTypedFunction(name, extractSignatures(fns));
            }
          });
          typed.create = create;
          typed.types = _types;
          typed.conversions = _conversions;
          typed.ignore = _ignore;
          typed.convert = convert;
          typed.find = find;
          /**
           * add a type
           * @param {{name: string, test: function}} type
           * @param {boolean} [beforeObjectTest=true]
           *                          If true, the new test will be inserted before
           *                          the test with name 'Object' (if any), since
           *                          tests for Object match Array and classes too.
           */

          typed.addType = function (type, beforeObjectTest) {
            if (!type || typeof type.name !== 'string' || typeof type.test !== 'function') {
              throw new TypeError('Object with properties {name: string, test: function} expected');
            }

            if (beforeObjectTest !== false) {
              for (var i = 0; i < typed.types.length; i++) {
                if (typed.types[i].name === 'Object') {
                  typed.types.splice(i, 0, type);
                  return;
                }
              }
            }

            typed.types.push(type);
          }; // add a conversion


          typed.addConversion = function (conversion) {
            if (!conversion || typeof conversion.from !== 'string' || typeof conversion.to !== 'string' || typeof conversion.convert !== 'function') {
              throw new TypeError('Object with properties {from: string, to: string, convert: function} expected');
            }

            typed.conversions.push(conversion);
          };

          return typed;
        }

        return create();
      });
      /***/

    },
    /* 801 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }

        return _typeof(obj);
      }

      var typedFunction = __webpack_require__(800);

      var digits = __webpack_require__(67).digits;

      var isBigNumber = __webpack_require__(308);

      var isMatrix = __webpack_require__(199); // returns a new instance of typed-function


      var _createTyped = function createTyped() {
        // initially, return the original instance of typed-function
        // consecutively, return a new instance from typed.create.
        _createTyped = typedFunction.create;
        return typedFunction;
      };
      /**
       * Factory function for creating a new typed instance
       * @param {Object} type   Object with data types like Complex and BigNumber
       * @returns {Function}
       */


      exports.create = function create(type) {
        // TODO: typed-function must be able to silently ignore signatures with unknown data types
        // type checks for all known types
        //
        // note that:
        //
        // - check by duck-typing on a property like `isUnit`, instead of checking instanceof.
        //   instanceof cannot be used because that would not allow to pass data from
        //   one instance of math.js to another since each has it's own instance of Unit.
        // - check the `isUnit` property via the constructor, so there will be no
        //   matches for "fake" instances like plain objects with a property `isUnit`.
        //   That is important for security reasons.
        // - It must not be possible to override the type checks used internally,
        //   for security reasons, so these functions are not exposed in the expression
        //   parser.
        type.isNumber = function (x) {
          return typeof x === 'number';
        };

        type.isComplex = function (x) {
          return type.Complex && x instanceof type.Complex || false;
        };

        type.isBigNumber = isBigNumber;

        type.isFraction = function (x) {
          return type.Fraction && x instanceof type.Fraction || false;
        };

        type.isUnit = function (x) {
          return x && x.constructor.prototype.isUnit || false;
        };

        type.isString = function (x) {
          return typeof x === 'string';
        };

        type.isArray = Array.isArray;
        type.isMatrix = isMatrix;

        type.isDenseMatrix = function (x) {
          return x && x.isDenseMatrix && x.constructor.prototype.isMatrix || false;
        };

        type.isSparseMatrix = function (x) {
          return x && x.isSparseMatrix && x.constructor.prototype.isMatrix || false;
        };

        type.isRange = function (x) {
          return x && x.constructor.prototype.isRange || false;
        };

        type.isIndex = function (x) {
          return x && x.constructor.prototype.isIndex || false;
        };

        type.isBoolean = function (x) {
          return typeof x === 'boolean';
        };

        type.isResultSet = function (x) {
          return x && x.constructor.prototype.isResultSet || false;
        };

        type.isHelp = function (x) {
          return x && x.constructor.prototype.isHelp || false;
        };

        type.isFunction = function (x) {
          return typeof x === 'function';
        };

        type.isDate = function (x) {
          return x instanceof Date;
        };

        type.isRegExp = function (x) {
          return x instanceof RegExp;
        };

        type.isObject = function (x) {
          return _typeof(x) === 'object' && x.constructor === Object && !type.isComplex(x) && !type.isFraction(x);
        };

        type.isNull = function (x) {
          return x === null;
        };

        type.isUndefined = function (x) {
          return x === undefined;
        };

        type.isAccessorNode = function (x) {
          return x && x.isAccessorNode && x.constructor.prototype.isNode || false;
        };

        type.isArrayNode = function (x) {
          return x && x.isArrayNode && x.constructor.prototype.isNode || false;
        };

        type.isAssignmentNode = function (x) {
          return x && x.isAssignmentNode && x.constructor.prototype.isNode || false;
        };

        type.isBlockNode = function (x) {
          return x && x.isBlockNode && x.constructor.prototype.isNode || false;
        };

        type.isConditionalNode = function (x) {
          return x && x.isConditionalNode && x.constructor.prototype.isNode || false;
        };

        type.isConstantNode = function (x) {
          return x && x.isConstantNode && x.constructor.prototype.isNode || false;
        };

        type.isFunctionAssignmentNode = function (x) {
          return x && x.isFunctionAssignmentNode && x.constructor.prototype.isNode || false;
        };

        type.isFunctionNode = function (x) {
          return x && x.isFunctionNode && x.constructor.prototype.isNode || false;
        };

        type.isIndexNode = function (x) {
          return x && x.isIndexNode && x.constructor.prototype.isNode || false;
        };

        type.isNode = function (x) {
          return x && x.isNode && x.constructor.prototype.isNode || false;
        };

        type.isObjectNode = function (x) {
          return x && x.isObjectNode && x.constructor.prototype.isNode || false;
        };

        type.isOperatorNode = function (x) {
          return x && x.isOperatorNode && x.constructor.prototype.isNode || false;
        };

        type.isParenthesisNode = function (x) {
          return x && x.isParenthesisNode && x.constructor.prototype.isNode || false;
        };

        type.isRangeNode = function (x) {
          return x && x.isRangeNode && x.constructor.prototype.isNode || false;
        };

        type.isSymbolNode = function (x) {
          return x && x.isSymbolNode && x.constructor.prototype.isNode || false;
        };

        type.isChain = function (x) {
          return x && x.constructor.prototype.isChain || false;
        }; // get a new instance of typed-function


        var typed = _createTyped(); // define all types. The order of the types determines in which order function
        // arguments are type-checked (so for performance it's important to put the
        // most used types first).


        typed.types = [{
          name: 'number',
          test: type.isNumber
        }, {
          name: 'Complex',
          test: type.isComplex
        }, {
          name: 'BigNumber',
          test: type.isBigNumber
        }, {
          name: 'Fraction',
          test: type.isFraction
        }, {
          name: 'Unit',
          test: type.isUnit
        }, {
          name: 'string',
          test: type.isString
        }, {
          name: 'Array',
          test: type.isArray
        }, {
          name: 'Matrix',
          test: type.isMatrix
        }, {
          name: 'DenseMatrix',
          test: type.isDenseMatrix
        }, {
          name: 'SparseMatrix',
          test: type.isSparseMatrix
        }, {
          name: 'Range',
          test: type.isRange
        }, {
          name: 'Index',
          test: type.isIndex
        }, {
          name: 'boolean',
          test: type.isBoolean
        }, {
          name: 'ResultSet',
          test: type.isResultSet
        }, {
          name: 'Help',
          test: type.isHelp
        }, {
          name: 'function',
          test: type.isFunction
        }, {
          name: 'Date',
          test: type.isDate
        }, {
          name: 'RegExp',
          test: type.isRegExp
        }, {
          name: 'null',
          test: type.isNull
        }, {
          name: 'undefined',
          test: type.isUndefined
        }, {
          name: 'OperatorNode',
          test: type.isOperatorNode
        }, {
          name: 'ConstantNode',
          test: type.isConstantNode
        }, {
          name: 'SymbolNode',
          test: type.isSymbolNode
        }, {
          name: 'ParenthesisNode',
          test: type.isParenthesisNode
        }, {
          name: 'FunctionNode',
          test: type.isFunctionNode
        }, {
          name: 'FunctionAssignmentNode',
          test: type.isFunctionAssignmentNode
        }, {
          name: 'ArrayNode',
          test: type.isArrayNode
        }, {
          name: 'AssignmentNode',
          test: type.isAssignmentNode
        }, {
          name: 'BlockNode',
          test: type.isBlockNode
        }, {
          name: 'ConditionalNode',
          test: type.isConditionalNode
        }, {
          name: 'IndexNode',
          test: type.isIndexNode
        }, {
          name: 'RangeNode',
          test: type.isRangeNode
        }, {
          name: 'Node',
          test: type.isNode
        }, {
          name: 'Object',
          test: type.isObject // order 'Object' last, it matches on other classes too

        }]; // TODO: add conversion from BigNumber to number?

        typed.conversions = [{
          from: 'number',
          to: 'BigNumber',
          convert: function convert(x) {
            // note: conversion from number to BigNumber can fail if x has >15 digits
            if (digits(x) > 15) {
              throw new TypeError('Cannot implicitly convert a number with >15 significant digits to BigNumber ' + '(value: ' + x + '). ' + 'Use function bignumber(x) to convert to BigNumber.');
            }

            return new type.BigNumber(x);
          }
        }, {
          from: 'number',
          to: 'Complex',
          convert: function convert(x) {
            return new type.Complex(x, 0);
          }
        }, {
          from: 'number',
          to: 'string',
          convert: function convert(x) {
            return x + '';
          }
        }, {
          from: 'BigNumber',
          to: 'Complex',
          convert: function convert(x) {
            return new type.Complex(x.toNumber(), 0);
          }
        }, {
          from: 'Fraction',
          to: 'BigNumber',
          convert: function convert(x) {
            throw new TypeError('Cannot implicitly convert a Fraction to BigNumber or vice versa. ' + 'Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.');
          }
        }, {
          from: 'Fraction',
          to: 'Complex',
          convert: function convert(x) {
            return new type.Complex(x.valueOf(), 0);
          }
        }, {
          from: 'number',
          to: 'Fraction',
          convert: function convert(x) {
            var f = new type.Fraction(x);

            if (f.valueOf() !== x) {
              throw new TypeError('Cannot implicitly convert a number to a Fraction when there will be a loss of precision ' + '(value: ' + x + '). ' + 'Use function fraction(x) to convert to Fraction.');
            }

            return new type.Fraction(x);
          }
        }, {
          // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
          //  from: 'Fraction',
          //  to: 'number',
          //  convert: function (x) {
          //    return x.valueOf()
          //  }
          // }, {
          from: 'string',
          to: 'number',
          convert: function convert(x) {
            var n = Number(x);

            if (isNaN(n)) {
              throw new Error('Cannot convert "' + x + '" to a number');
            }

            return n;
          }
        }, {
          from: 'string',
          to: 'BigNumber',
          convert: function convert(x) {
            try {
              return new type.BigNumber(x);
            } catch (err) {
              throw new Error('Cannot convert "' + x + '" to BigNumber');
            }
          }
        }, {
          from: 'string',
          to: 'Fraction',
          convert: function convert(x) {
            try {
              return new type.Fraction(x);
            } catch (err) {
              throw new Error('Cannot convert "' + x + '" to Fraction');
            }
          }
        }, {
          from: 'string',
          to: 'Complex',
          convert: function convert(x) {
            try {
              return new type.Complex(x);
            } catch (err) {
              throw new Error('Cannot convert "' + x + '" to Complex');
            }
          }
        }, {
          from: 'boolean',
          to: 'number',
          convert: function convert(x) {
            return +x;
          }
        }, {
          from: 'boolean',
          to: 'BigNumber',
          convert: function convert(x) {
            return new type.BigNumber(+x);
          }
        }, {
          from: 'boolean',
          to: 'Fraction',
          convert: function convert(x) {
            return new type.Fraction(+x);
          }
        }, {
          from: 'boolean',
          to: 'string',
          convert: function convert(x) {
            return +x;
          }
        }, {
          from: 'Array',
          to: 'Matrix',
          convert: function convert(array) {
            return new type.DenseMatrix(array);
          }
        }, {
          from: 'Matrix',
          to: 'Array',
          convert: function convert(matrix) {
            return matrix.valueOf();
          }
        }];
        return typed;
      };
      /***/

    },
    /* 802 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // TODO: remove these polyfills as soon as we have a build process that transpiles the code to ES5
      // Polyfill for IE 11 (Number.isFinite is used in `complex.js`)
      // source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isFinite

      Number.isFinite = Number.isFinite || function (value) {
        return typeof value === 'number' && isFinite(value);
      }; // Polyfill for IE 11
      // source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN


      Number.isNaN = Number.isNaN || function (value) {
        return value !== value; // eslint-disable-line no-self-compare
      };
      /***/

    },
    /* 803 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      __webpack_require__(802);

      var isFactory = __webpack_require__(59).isFactory;

      var typedFactory = __webpack_require__(801);

      var emitter = __webpack_require__(413);

      var importFactory = __webpack_require__(798);

      var configFactory = __webpack_require__(797);
      /**
       * Math.js core. Creates a new, empty math.js instance
       * @param {Object} [options] Available options:
       *                            {number} epsilon
       *                              Minimum relative difference between two
       *                              compared values, used by all comparison functions.
       *                            {string} matrix
       *                              A string 'Matrix' (default) or 'Array'.
       *                            {string} number
       *                              A string 'number' (default), 'BigNumber', or 'Fraction'
       *                            {number} precision
       *                              The number of significant digits for BigNumbers.
       *                              Not applicable for Numbers.
       *                            {boolean} predictable
       *                              Predictable output type of functions. When true,
       *                              output type depends only on the input types. When
       *                              false (default), output type can vary depending
       *                              on input values. For example `math.sqrt(-4)`
       *                              returns `complex('2i')` when predictable is false, and
       *                              returns `NaN` when true.
       *                            {string} randomSeed
       *                              Random seed for seeded pseudo random number generator.
       *                              Set to null to randomly seed.
       * @returns {Object} Returns a bare-bone math.js instance containing
       *                   functions:
       *                   - `import` to add new functions
       *                   - `config` to change configuration
       *                   - `on`, `off`, `once`, `emit` for events
       */


      exports.create = function create(options) {
        // simple test for ES5 support
        if (typeof Object.create !== 'function') {
          throw new Error('ES5 not supported by this JavaScript engine. ' + 'Please load the es5-shim and es5-sham library for compatibility.');
        } // cached factories and instances


        var factories = [];
        var instances = []; // create a namespace for the mathjs instance, and attach emitter functions

        var math = emitter.mixin({});
        math.type = {};
        math.expression = {
          transform: {},
          mathWithTransform: {} // create a new typed instance

        };
        math.typed = typedFactory.create(math.type); // create configuration options. These are private

        var _config = {
          // minimum relative difference between two compared values,
          // used by all comparison functions
          epsilon: 1e-12,
          // type of default matrix output. Choose 'matrix' (default) or 'array'
          matrix: 'Matrix',
          // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
          number: 'number',
          // number of significant digits in BigNumbers
          precision: 64,
          // predictable output type of functions. When true, output type depends only
          // on the input types. When false (default), output type can vary depending
          // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
          // predictable is false, and returns `NaN` when true.
          predictable: false,
          // random seed for seeded pseudo random number generation
          // null = randomly seed
          randomSeed: null
          /**
           * Load a function or data type from a factory.
           * If the function or data type already exists, the existing instance is
           * returned.
           * @param {{type: string, name: string, factory: Function}} factory
           * @returns {*}
           */

        };

        function load(factory) {
          if (!isFactory(factory)) {
            throw new Error('Factory object with properties `type`, `name`, and `factory` expected');
          }

          var index = factories.indexOf(factory);
          var instance;

          if (index === -1) {
            // doesn't yet exist
            if (factory.math === true) {
              // pass with math namespace
              instance = factory.factory(math.type, _config, load, math.typed, math);
            } else {
              instance = factory.factory(math.type, _config, load, math.typed);
            } // append to the cache


            factories.push(factory);
            instances.push(instance);
          } else {
            // already existing function, return the cached instance
            instance = instances[index];
          }

          return instance;
        } // load the import and config functions


        math['import'] = load(importFactory);
        math['config'] = load(configFactory);
        math.expression.mathWithTransform['config'] = math['config']; // apply options

        if (options) {
          math.config(options);
        }

        return math;
      };
      /***/

    },
    /* 804 */

    /***/
    function (module, exports) {
      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeFloor = Math.floor,
          nativeRandom = Math.random;
      /**
       * The base implementation of `_.random` without support for returning
       * floating-point numbers.
       *
       * @private
       * @param {number} lower The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the random number.
       */

      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }

      module.exports = baseRandom;
      /***/
    },
    /* 805 */

    /***/
    function (module, exports, __webpack_require__) {
      var identity = __webpack_require__(207);
      /**
       * Casts `value` to `identity` if it's not a function.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {Function} Returns cast function.
       */


      function castFunction(value) {
        return typeof value == 'function' ? value : identity;
      }

      module.exports = castFunction;
      /***/
    },
    /* 806 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(415);

      var has = Object.prototype.hasOwnProperty;
      var defaults = {
        allowDots: false,
        allowPrototypes: false,
        arrayLimit: 20,
        charset: 'utf-8',
        charsetSentinel: false,
        comma: false,
        decoder: utils.decode,
        delimiter: '&',
        depth: 5,
        ignoreQueryPrefix: false,
        interpretNumericEntities: false,
        parameterLimit: 1000,
        parseArrays: true,
        plainObjects: false,
        strictNullHandling: false
      };

      var interpretNumericEntities = function interpretNumericEntities(str) {
        return str.replace(/&#(\d+);/g, function ($0, numberStr) {
          return String.fromCharCode(parseInt(numberStr, 10));
        });
      }; // This is what browsers will submit when the ✓ character occurs in an
      // application/x-www-form-urlencoded body and the encoding of the page containing
      // the form is iso-8859-1, or when the submitted form has an accept-charset
      // attribute of iso-8859-1. Presumably also with other charsets that do not contain
      // the ✓ character, such as us-ascii.


      var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
      // These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.

      var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

      var parseValues = function parseQueryStringValues(str, options) {
        var obj = {};
        var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
        var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
        var parts = cleanStr.split(options.delimiter, limit);
        var skipIndex = -1; // Keep track of where the utf8 sentinel was found

        var i;
        var charset = options.charset;

        if (options.charsetSentinel) {
          for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
              if (parts[i] === charsetSentinel) {
                charset = 'utf-8';
              } else if (parts[i] === isoSentinel) {
                charset = 'iso-8859-1';
              }

              skipIndex = i;
              i = parts.length; // The eslint settings do not allow break;
            }
          }
        }

        for (i = 0; i < parts.length; ++i) {
          if (i === skipIndex) {
            continue;
          }

          var part = parts[i];
          var bracketEqualsPos = part.indexOf(']=');
          var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
          var key, val;

          if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset);
            val = options.strictNullHandling ? null : '';
          } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset);
            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset);
          }

          if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
          }

          if (val && options.comma && val.indexOf(',') > -1) {
            val = val.split(',');
          }

          if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
          } else {
            obj[key] = val;
          }
        }

        return obj;
      };

      var parseObject = function parseObject(chain, val, options) {
        var leaf = val;

        for (var i = chain.length - 1; i >= 0; --i) {
          var obj;
          var root = chain[i];

          if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
          } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);

            if (!options.parseArrays && cleanRoot === '') {
              obj = {
                0: leaf
              };
            } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
              obj = [];
              obj[index] = leaf;
            } else {
              obj[cleanRoot] = leaf;
            }
          }

          leaf = obj;
        }

        return leaf;
      };

      var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
        if (!givenKey) {
          return;
        } // Transform dot notation to bracket notation


        var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey; // The regex chunks

        var brackets = /(\[[^[\]]*])/;
        var child = /(\[[^[\]]*])/g; // Get the parent

        var segment = brackets.exec(key);
        var parent = segment ? key.slice(0, segment.index) : key; // Stash the parent if it exists

        var keys = [];

        if (parent) {
          // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
          if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
              return;
            }
          }

          keys.push(parent);
        } // Loop through children appending to the array until we hit depth


        var i = 0;

        while ((segment = child.exec(key)) !== null && i < options.depth) {
          i += 1;

          if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
              return;
            }
          }

          keys.push(segment[1]);
        } // If there's a remainder, just add whatever is left


        if (segment) {
          keys.push('[' + key.slice(segment.index) + ']');
        }

        return parseObject(keys, val, options);
      };

      var normalizeParseOptions = function normalizeParseOptions(opts) {
        if (!opts) {
          return defaults;
        }

        if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
          throw new TypeError('Decoder has to be a function.');
        }

        if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
          throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
        }

        var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
        return {
          allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
          allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
          arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
          charset: charset,
          charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
          comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
          decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
          delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
          depth: typeof opts.depth === 'number' ? opts.depth : defaults.depth,
          ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
          interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
          parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
          parseArrays: opts.parseArrays !== false,
          plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
          strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
        };
      };

      module.exports = function (str, opts) {
        var options = normalizeParseOptions(opts);

        if (str === '' || str === null || typeof str === 'undefined') {
          return options.plainObjects ? Object.create(null) : {};
        }

        var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
        var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

        var keys = Object.keys(tempObj);

        for (var i = 0; i < keys.length; ++i) {
          var key = keys[i];
          var newObj = parseKeys(key, tempObj[key], options);
          obj = utils.merge(obj, newObj, options);
        }

        return utils.compact(obj);
      };
      /***/

    },
    /* 807 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(415);

      var formats = __webpack_require__(414);

      var has = Object.prototype.hasOwnProperty;
      var arrayPrefixGenerators = {
        brackets: function brackets(prefix) {
          // eslint-disable-line func-name-matching
          return prefix + '[]';
        },
        comma: 'comma',
        indices: function indices(prefix, key) {
          // eslint-disable-line func-name-matching
          return prefix + '[' + key + ']';
        },
        repeat: function repeat(prefix) {
          // eslint-disable-line func-name-matching
          return prefix;
        }
      };
      var isArray = Array.isArray;
      var push = Array.prototype.push;

      var pushToArray = function pushToArray(arr, valueOrArray) {
        push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
      };

      var toISO = Date.prototype.toISOString;
      var defaults = {
        addQueryPrefix: false,
        allowDots: false,
        charset: 'utf-8',
        charsetSentinel: false,
        delimiter: '&',
        encode: true,
        encoder: utils.encode,
        encodeValuesOnly: false,
        formatter: formats.formatters[formats['default']],
        // deprecated
        indices: false,
        serializeDate: function serializeDate(date) {
          // eslint-disable-line func-name-matching
          return toISO.call(date);
        },
        skipNulls: false,
        strictNullHandling: false
      };

      var stringify = function stringify( // eslint-disable-line func-name-matching
      object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset) {
        var obj = object;

        if (typeof filter === 'function') {
          obj = filter(prefix, obj);
        } else if (obj instanceof Date) {
          obj = serializeDate(obj);
        } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
          obj = obj.join(',');
        }

        if (obj === null) {
          if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset) : prefix;
          }

          obj = '';
        }

        if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
          if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset))];
          }

          return [formatter(prefix) + '=' + formatter(String(obj))];
        }

        var values = [];

        if (typeof obj === 'undefined') {
          return values;
        }

        var objKeys;

        if (isArray(filter)) {
          objKeys = filter;
        } else {
          var keys = Object.keys(obj);
          objKeys = sort ? keys.sort(sort) : keys;
        }

        for (var i = 0; i < objKeys.length; ++i) {
          var key = objKeys[i];

          if (skipNulls && obj[key] === null) {
            continue;
          }

          if (isArray(obj)) {
            pushToArray(values, stringify(obj[key], typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
          } else {
            pushToArray(values, stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
          }
        }

        return values;
      };

      var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
        if (!opts) {
          return defaults;
        }

        if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
          throw new TypeError('Encoder has to be a function.');
        }

        var charset = opts.charset || defaults.charset;

        if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
          throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
        }

        var format = formats['default'];

        if (typeof opts.format !== 'undefined') {
          if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
          }

          format = opts.format;
        }

        var formatter = formats.formatters[format];
        var filter = defaults.filter;

        if (typeof opts.filter === 'function' || isArray(opts.filter)) {
          filter = opts.filter;
        }

        return {
          addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
          allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
          charset: charset,
          charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
          delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
          encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
          encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
          encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
          filter: filter,
          formatter: formatter,
          serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
          skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
          sort: typeof opts.sort === 'function' ? opts.sort : null,
          strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
        };
      };

      module.exports = function (object, opts) {
        var obj = object;
        var options = normalizeStringifyOptions(opts);
        var objKeys;
        var filter;

        if (typeof options.filter === 'function') {
          filter = options.filter;
          obj = filter('', obj);
        } else if (isArray(options.filter)) {
          filter = options.filter;
          objKeys = filter;
        }

        var keys = [];

        if (typeof obj !== 'object' || obj === null) {
          return '';
        }

        var arrayFormat;

        if (opts && opts.arrayFormat in arrayPrefixGenerators) {
          arrayFormat = opts.arrayFormat;
        } else if (opts && 'indices' in opts) {
          arrayFormat = opts.indices ? 'indices' : 'repeat';
        } else {
          arrayFormat = 'indices';
        }

        var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

        if (!objKeys) {
          objKeys = Object.keys(obj);
        }

        if (options.sort) {
          objKeys.sort(options.sort);
        }

        for (var i = 0; i < objKeys.length; ++i) {
          var key = objKeys[i];

          if (options.skipNulls && obj[key] === null) {
            continue;
          }

          pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.formatter, options.encodeValuesOnly, options.charset));
        }

        var joined = keys.join(options.delimiter);
        var prefix = options.addQueryPrefix === true ? '?' : '';

        if (options.charsetSentinel) {
          if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
          } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
          }
        }

        return joined.length > 0 ? prefix + joined : '';
      };
      /***/

    },
    /* 808 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Syntactic sugar for invoking a function and expanding an array for arguments.
       *
       * Common use case would be to use `Function.prototype.apply`.
       *
       *  ```js
       *  function f(x, y, z) {}
       *  var args = [1, 2, 3];
       *  f.apply(null, args);
       *  ```
       *
       * With `spread` this example can be re-written.
       *
       *  ```js
       *  spread(function(x, y, z) {})([1, 2, 3]);
       *  ```
       *
       * @param {Function} callback
       * @returns {Function}
       */

      module.exports = function spread(callback) {
        return function wrap(arr) {
          return callback.apply(null, arr);
        };
      };
      /***/

    },
    /* 809 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var Cancel = __webpack_require__(416);
      /**
       * A `CancelToken` is an object that can be used to request cancellation of an operation.
       *
       * @class
       * @param {Function} executor The executor function.
       */


      function CancelToken(executor) {
        if (typeof executor !== 'function') {
          throw new TypeError('executor must be a function.');
        }

        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
          resolvePromise = resolve;
        });
        var token = this;
        executor(function cancel(message) {
          if (token.reason) {
            // Cancellation has already been requested
            return;
          }

          token.reason = new Cancel(message);
          resolvePromise(token.reason);
        });
      }
      /**
       * Throws a `Cancel` if cancellation has been requested.
       */


      CancelToken.prototype.throwIfRequested = function throwIfRequested() {
        if (this.reason) {
          throw this.reason;
        }
      };
      /**
       * Returns an object that contains a new `CancelToken` and a function that, when called,
       * cancels the `CancelToken`.
       */


      CancelToken.source = function source() {
        var cancel;
        var token = new CancelToken(function executor(c) {
          cancel = c;
        });
        return {
          token: token,
          cancel: cancel
        };
      };

      module.exports = CancelToken;
      /***/
    },
    /* 810 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Creates a new URL by combining the specified URLs
       *
       * @param {string} baseURL The base URL
       * @param {string} relativeURL The relative URL
       * @returns {string} The combined URL
       */

      module.exports = function combineURLs(baseURL, relativeURL) {
        return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
      };
      /***/

    },
    /* 811 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Determines whether the specified URL is absolute
       *
       * @param {string} url The URL to test
       * @returns {boolean} True if the specified URL is absolute, otherwise false
       */

      module.exports = function isAbsoluteURL(url) {
        // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
        // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
        // by any combination of letters, digits, plus, period, or hyphen.
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
      };
      /***/

    },
    /* 812 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(101);
      /**
       * Transform the data for a request or a response
       *
       * @param {Object|String} data The data to be transformed
       * @param {Array} headers The headers for the request or response
       * @param {Array|Function} fns A single function or Array of functions
       * @returns {*} The resulting transformed data
       */


      module.exports = function transformData(data, headers, fns) {
        /*eslint no-param-reassign:0*/
        utils.forEach(fns, function transform(fn) {
          data = fn(data, headers);
        });
        return data;
      };
      /***/

    },
    /* 813 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(101);

      var transformData = __webpack_require__(812);

      var isCancel = __webpack_require__(417);

      var defaults = __webpack_require__(309);
      /**
       * Throws a `Cancel` if cancellation has been requested.
       */


      function throwIfCancellationRequested(config) {
        if (config.cancelToken) {
          config.cancelToken.throwIfRequested();
        }
      }
      /**
       * Dispatch a request to the server using the configured adapter.
       *
       * @param {object} config The config that is to be used for the request
       * @returns {Promise} The Promise to be fulfilled
       */


      module.exports = function dispatchRequest(config) {
        throwIfCancellationRequested(config); // Ensure headers exist

        config.headers = config.headers || {}; // Transform request data

        config.data = transformData(config.data, config.headers, config.transformRequest); // Flatten headers

        config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
        utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
          delete config.headers[method];
        });
        var adapter = config.adapter || defaults.adapter;
        return adapter(config).then(function onAdapterResolution(response) {
          throwIfCancellationRequested(config); // Transform response data

          response.data = transformData(response.data, response.headers, config.transformResponse);
          return response;
        }, function onAdapterRejection(reason) {
          if (!isCancel(reason)) {
            throwIfCancellationRequested(config); // Transform response data

            if (reason && reason.response) {
              reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
            }
          }

          return Promise.reject(reason);
        });
      };
      /***/

    },
    /* 814 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(101);

      function InterceptorManager() {
        this.handlers = [];
      }
      /**
       * Add a new interceptor to the stack
       *
       * @param {Function} fulfilled The function to handle `then` for a `Promise`
       * @param {Function} rejected The function to handle `reject` for a `Promise`
       *
       * @return {Number} An ID used to remove interceptor later
       */


      InterceptorManager.prototype.use = function use(fulfilled, rejected) {
        this.handlers.push({
          fulfilled: fulfilled,
          rejected: rejected
        });
        return this.handlers.length - 1;
      };
      /**
       * Remove an interceptor from the stack
       *
       * @param {Number} id The ID that was returned by `use`
       */


      InterceptorManager.prototype.eject = function eject(id) {
        if (this.handlers[id]) {
          this.handlers[id] = null;
        }
      };
      /**
       * Iterate over all the registered interceptors
       *
       * This method is particularly useful for skipping over any
       * interceptors that may have become `null` calling `eject`.
       *
       * @param {Function} fn The function to call for each interceptor
       */


      InterceptorManager.prototype.forEach = function forEach(fn) {
        utils.forEach(this.handlers, function forEachHandler(h) {
          if (h !== null) {
            fn(h);
          }
        });
      };

      module.exports = InterceptorManager;
      /***/
    },
    /* 815 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(101);

      module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
      function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));

            if (utils.isNumber(expires)) {
              cookie.push('expires=' + new Date(expires).toGMTString());
            }

            if (utils.isString(path)) {
              cookie.push('path=' + path);
            }

            if (utils.isString(domain)) {
              cookie.push('domain=' + domain);
            }

            if (secure === true) {
              cookie.push('secure');
            }

            document.cookie = cookie.join('; ');
          },
          read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
          },
          remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
          }
        };
      }() : // Non standard browser env (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return {
          write: function write() {},
          read: function read() {
            return null;
          },
          remove: function remove() {}
        };
      }();
      /***/
    },
    /* 816 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

      var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

      function E() {
        this.message = 'String contains an invalid character';
      }

      E.prototype = new Error();
      E.prototype.code = 5;
      E.prototype.name = 'InvalidCharacterError';

      function btoa(input) {
        var str = String(input);
        var output = '';

        for ( // initialize result and counter
        var block, charCode, idx = 0, map = chars; // if the next str index does not exist:
        //   change the mapping table to "="
        //   check if d has no fractional digits
        str.charAt(idx | 0) || (map = '=', idx % 1); // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
        output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
          charCode = str.charCodeAt(idx += 3 / 4);

          if (charCode > 0xFF) {
            throw new E();
          }

          block = block << 8 | charCode;
        }

        return output;
      }

      module.exports = btoa;
      /***/
    },
    /* 817 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(101);

      module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement('a');
        var originURL;
        /**
        * Parse a URL to discover it's components
        *
        * @param {String} url The URL to be parsed
        * @returns {Object}
        */

        function resolveURL(url) {
          var href = url;

          if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
          }

          urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
          };
        }

        originURL = resolveURL(window.location.href);
        /**
        * Determine if a URL shares the same origin as the current location
        *
        * @param {String} requestURL The URL to test
        * @returns {boolean} True if URL shares the same origin, otherwise false
        */

        return function isURLSameOrigin(requestURL) {
          var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }() : // Non standard browser envs (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      }();
      /***/
    },
    /* 818 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(101);
      /**
       * Parse headers into an object
       *
       * ```
       * Date: Wed, 27 Aug 2014 08:58:49 GMT
       * Content-Type: application/json
       * Connection: keep-alive
       * Transfer-Encoding: chunked
       * ```
       *
       * @param {String} headers Headers needing to be parsed
       * @returns {Object} Headers parsed into an object
       */


      module.exports = function parseHeaders(headers) {
        var parsed = {};
        var key;
        var val;
        var i;

        if (!headers) {
          return parsed;
        }

        utils.forEach(headers.split('\n'), function parser(line) {
          i = line.indexOf(':');
          key = utils.trim(line.substr(0, i)).toLowerCase();
          val = utils.trim(line.substr(i + 1));

          if (key) {
            parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
          }
        });
        return parsed;
      };
      /***/

    },
    /* 819 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(101);

      function encode(val) {
        return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
      }
      /**
       * Build a URL by appending params to the end
       *
       * @param {string} url The base of the url (e.g., http://www.google.com)
       * @param {object} [params] The params to be appended
       * @returns {string} The formatted url
       */


      module.exports = function buildURL(url, params, paramsSerializer) {
        /*eslint no-param-reassign:0*/
        if (!params) {
          return url;
        }

        var serializedParams;

        if (paramsSerializer) {
          serializedParams = paramsSerializer(params);
        } else if (utils.isURLSearchParams(params)) {
          serializedParams = params.toString();
        } else {
          var parts = [];
          utils.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') {
              return;
            }

            if (utils.isArray(val)) {
              key = key + '[]';
            }

            if (!utils.isArray(val)) {
              val = [val];
            }

            utils.forEach(val, function parseValue(v) {
              if (utils.isDate(v)) {
                v = v.toISOString();
              } else if (utils.isObject(v)) {
                v = JSON.stringify(v);
              }

              parts.push(encode(key) + '=' + encode(v));
            });
          });
          serializedParams = parts.join('&');
        }

        if (serializedParams) {
          url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
        }

        return url;
      };
      /***/

    },
    /* 820 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Update an Error with the specified config, error code, and response.
       *
       * @param {Error} error The error to update.
       * @param {Object} config The config.
       * @param {string} [code] The error code (for example, 'ECONNABORTED').
       * @param {Object} [request] The request.
       * @param {Object} [response] The response.
       * @returns {Error} The error.
       */

      module.exports = function enhanceError(error, config, code, request, response) {
        error.config = config;

        if (code) {
          error.code = code;
        }

        error.request = request;
        error.response = response;
        return error;
      };
      /***/

    },
    /* 821 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var createError = __webpack_require__(418);
      /**
       * Resolve or reject a Promise based on response status.
       *
       * @param {Function} resolve A function that resolves the promise.
       * @param {Function} reject A function that rejects the promise.
       * @param {object} response The response.
       */


      module.exports = function settle(resolve, reject, response) {
        var validateStatus = response.config.validateStatus; // Note: status is not exposed by XDomainRequest

        if (!response.status || !validateStatus || validateStatus(response.status)) {
          resolve(response);
        } else {
          reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
        }
      };
      /***/

    },
    /* 822 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(101);

      module.exports = function normalizeHeaderName(headers, normalizedName) {
        utils.forEach(headers, function processHeader(value, name) {
          if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
          }
        });
      };
      /***/

    },
    /* 823 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var defaults = __webpack_require__(309);

      var utils = __webpack_require__(101);

      var InterceptorManager = __webpack_require__(814);

      var dispatchRequest = __webpack_require__(813);

      var isAbsoluteURL = __webpack_require__(811);

      var combineURLs = __webpack_require__(810);
      /**
       * Create a new instance of Axios
       *
       * @param {Object} instanceConfig The default config for the instance
       */


      function Axios(instanceConfig) {
        this.defaults = instanceConfig;
        this.interceptors = {
          request: new InterceptorManager(),
          response: new InterceptorManager()
        };
      }
      /**
       * Dispatch a request
       *
       * @param {Object} config The config specific for this request (merged with this.defaults)
       */


      Axios.prototype.request = function request(config) {
        /*eslint no-param-reassign:0*/
        // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof config === 'string') {
          config = utils.merge({
            url: arguments[0]
          }, arguments[1]);
        }

        config = utils.merge(defaults, this.defaults, {
          method: 'get'
        }, config);
        config.method = config.method.toLowerCase(); // Support baseURL config

        if (config.baseURL && !isAbsoluteURL(config.url)) {
          config.url = combineURLs(config.baseURL, config.url);
        } // Hook up interceptors middleware


        var chain = [dispatchRequest, undefined];
        var promise = Promise.resolve(config);
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
          chain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
          chain.push(interceptor.fulfilled, interceptor.rejected);
        });

        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }

        return promise;
      }; // Provide aliases for supported request methods


      utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
        /*eslint func-names:0*/
        Axios.prototype[method] = function (url, config) {
          return this.request(utils.merge(config || {}, {
            method: method,
            url: url
          }));
        };
      });
      utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
        /*eslint func-names:0*/
        Axios.prototype[method] = function (url, data, config) {
          return this.request(utils.merge(config || {}, {
            method: method,
            url: url,
            data: data
          }));
        };
      });
      module.exports = Axios;
      /***/
    },
    /* 824 */

    /***/
    function (module, exports) {
      /*!
       * Determine if an object is a Buffer
       *
       * @author   Feross Aboukhadijeh <https://feross.org>
       * @license  MIT
       */
      // The _isBuffer check is for Safari 5-7 support, because it's missing
      // Object.prototype.constructor. Remove this eventually
      module.exports = function (obj) {
        return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
      };

      function isBuffer(obj) {
        return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
      } // For Node v0.10 support. Remove this eventually.


      function isSlowBuffer(obj) {
        return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
      }
      /***/

    },
    /* 825 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(101);

      var bind = __webpack_require__(420);

      var Axios = __webpack_require__(823);

      var defaults = __webpack_require__(309);
      /**
       * Create an instance of Axios
       *
       * @param {Object} defaultConfig The default config for the instance
       * @return {Axios} A new instance of Axios
       */


      function createInstance(defaultConfig) {
        var context = new Axios(defaultConfig);
        var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

        utils.extend(instance, Axios.prototype, context); // Copy context to instance

        utils.extend(instance, context);
        return instance;
      } // Create the default instance to be exported


      var axios = createInstance(defaults); // Expose Axios class to allow class inheritance

      axios.Axios = Axios; // Factory for creating new instances

      axios.create = function create(instanceConfig) {
        return createInstance(utils.merge(defaults, instanceConfig));
      }; // Expose Cancel & CancelToken


      axios.Cancel = __webpack_require__(416);
      axios.CancelToken = __webpack_require__(809);
      axios.isCancel = __webpack_require__(417); // Expose all/spread

      axios.all = function all(promises) {
        return Promise.all(promises);
      };

      axios.spread = __webpack_require__(808);
      module.exports = axios; // Allow use of default import syntax in TypeScript

      module.exports.default = axios;
      /***/
    },
    /* 826 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var animation = void 0;

      function isCssAnimationSupported() {
        if (animation !== undefined) {
          return animation;
        }

        var domPrefixes = 'Webkit Moz O ms Khtml'.split(' ');
        var elm = document.createElement('div');

        if (elm.style.animationName !== undefined) {
          animation = true;
        }

        if (animation !== undefined) {
          for (var i = 0; i < domPrefixes.length; i++) {
            if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
              animation = true;
              break;
            }
          }
        }

        animation = animation || false;
        return animation;
      }

      exports['default'] = isCssAnimationSupported;
      module.exports = exports['default'];
      /***/
    },
    /* 827 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _moment = __webpack_require__(14);

      var moment = _interopRequireWildcard(_moment);

      var _rcCalendar = __webpack_require__(183);

      var _rcCalendar2 = _interopRequireDefault(_rcCalendar);

      var _Picker = __webpack_require__(311);

      var _Picker2 = _interopRequireDefault(_Picker);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _icon = __webpack_require__(126);

      var _icon2 = _interopRequireDefault(_icon);

      var _interopDefault = __webpack_require__(235);

      var _interopDefault2 = _interopRequireDefault(_interopDefault);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function formatValue(value, format) {
        return value && value.format(format) || '';
      }

      var WeekPicker = function (_React$Component) {
        (0, _inherits3['default'])(WeekPicker, _React$Component);

        function WeekPicker(props) {
          (0, _classCallCheck3['default'])(this, WeekPicker);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (WeekPicker.__proto__ || Object.getPrototypeOf(WeekPicker)).call(this, props));

          _this.weekDateRender = function (current) {
            var selectedValue = _this.state.value;
            var prefixCls = _this.props.prefixCls;

            if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
              return React.createElement('div', {
                className: prefixCls + '-selected-day'
              }, React.createElement('div', {
                className: prefixCls + '-date'
              }, current.date()));
            }

            return React.createElement('div', {
              className: prefixCls + '-calendar-date'
            }, current.date());
          };

          _this.handleChange = function (value) {
            if (!('value' in _this.props)) {
              _this.setState({
                value: value
              });
            }

            _this.props.onChange(value, formatValue(value, _this.props.format));
          };

          _this.clearSelection = function (e) {
            e.preventDefault();
            e.stopPropagation();

            _this.handleChange(null);
          };

          _this.saveInput = function (node) {
            _this.input = node;
          };

          var value = props.value || props.defaultValue;

          if (value && !(0, _interopDefault2['default'])(moment).isMoment(value)) {
            throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
          }

          _this.state = {
            value: value
          };
          return _this;
        }

        (0, _createClass3['default'])(WeekPicker, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
              this.setState({
                value: nextProps.value
              });
            }
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.input.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.input.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                disabled = _props.disabled,
                pickerClass = _props.pickerClass,
                popupStyle = _props.popupStyle,
                pickerInputClass = _props.pickerInputClass,
                format = _props.format,
                allowClear = _props.allowClear,
                locale = _props.locale,
                localeCode = _props.localeCode,
                disabledDate = _props.disabledDate,
                style = _props.style,
                onFocus = _props.onFocus,
                onBlur = _props.onBlur;
            var pickerValue = this.state.value;

            if (pickerValue && localeCode) {
              pickerValue.locale(localeCode);
            }

            var placeholder = 'placeholder' in this.props ? this.props.placeholder : locale.lang.placeholder;
            var calendar = React.createElement(_rcCalendar2['default'], {
              showWeekNumber: true,
              dateRender: this.weekDateRender,
              prefixCls: prefixCls,
              format: format,
              locale: locale.lang,
              showDateInput: false,
              showToday: false,
              disabledDate: disabledDate
            });
            var clearIcon = !disabled && allowClear && this.state.value ? React.createElement(_icon2['default'], {
              type: 'cross-circle',
              className: prefixCls + '-picker-clear',
              onClick: this.clearSelection
            }) : null;

            var input = function input(_ref) {
              var value = _ref.value;
              return React.createElement('span', null, React.createElement('input', {
                ref: _this2.saveInput,
                disabled: disabled,
                readOnly: true,
                value: value && value.format(format) || '',
                placeholder: placeholder,
                className: pickerInputClass,
                onFocus: onFocus,
                onBlur: onBlur,
                style: style
              }), clearIcon, React.createElement('span', {
                className: prefixCls + '-picker-icon'
              }));
            };

            return React.createElement('span', {
              className: (0, _classnames2['default'])(className, pickerClass),
              id: this.props.id
            }, React.createElement(_Picker2['default'], (0, _extends3['default'])({}, this.props, {
              calendar: calendar,
              prefixCls: prefixCls + '-picker-container',
              value: pickerValue,
              onChange: this.handleChange,
              style: popupStyle
            }), input));
          }
        }]);
        return WeekPicker;
      }(React.Component);

      exports['default'] = WeekPicker;
      WeekPicker.defaultProps = {
        format: 'gggg-wo',
        allowClear: true
      };
      module.exports = exports['default'];
      /***/
    },
    /* 828 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports.goStartMonth = goStartMonth;
      exports.goEndMonth = goEndMonth;
      exports.goTime = goTime;
      exports.includesTime = includesTime;

      function goStartMonth(time) {
        return time.clone().startOf('month');
      }

      function goEndMonth(time) {
        return time.clone().endOf('month');
      }

      function goTime(time, direction, unit) {
        return time.clone().add(direction, unit);
      }

      function includesTime() {
        var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var time = arguments[1];
        var unit = arguments[2];
        return timeList.some(function (t) {
          return t.isSame(time, unit);
        });
      }
      /***/

    },
    /* 829 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _reactDom = __webpack_require__(16);

      var _reactDom2 = _interopRequireDefault(_reactDom);

      var _createReactClass = __webpack_require__(32);

      var _createReactClass2 = _interopRequireDefault(_createReactClass);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _moment = __webpack_require__(14);

      var _moment2 = _interopRequireDefault(_moment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var DateInput = (0, _createReactClass2['default'])({
        displayName: 'DateInput',
        propTypes: {
          prefixCls: _propTypes2['default'].string,
          timePicker: _propTypes2['default'].object,
          value: _propTypes2['default'].object,
          disabledTime: _propTypes2['default'].any,
          format: _propTypes2['default'].string,
          locale: _propTypes2['default'].object,
          disabledDate: _propTypes2['default'].func,
          onChange: _propTypes2['default'].func,
          onClear: _propTypes2['default'].func,
          placeholder: _propTypes2['default'].string,
          onSelect: _propTypes2['default'].func,
          selectedValue: _propTypes2['default'].object
        },
        getInitialState: function getInitialState() {
          var selectedValue = this.props.selectedValue;
          return {
            str: selectedValue && selectedValue.format(this.props.format) || '',
            invalid: false
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          this.cachedSelectionStart = this.dateInputInstance.selectionStart;
          this.cachedSelectionEnd = this.dateInputInstance.selectionEnd; // when popup show, click body will call this, bug!

          var selectedValue = nextProps.selectedValue;
          this.setState({
            str: selectedValue && selectedValue.format(nextProps.format) || '',
            invalid: false
          });
        },
        componentDidUpdate: function componentDidUpdate() {
          if (!this.state.invalid) {
            this.dateInputInstance.setSelectionRange(this.cachedSelectionStart, this.cachedSelectionEnd);
          }
        },
        onInputChange: function onInputChange(event) {
          var str = event.target.value;
          this.setState({
            str: str
          });
          var value = void 0;
          var _props = this.props,
              disabledDate = _props.disabledDate,
              format = _props.format,
              onChange = _props.onChange;

          if (str) {
            var parsed = (0, _moment2['default'])(str, format, true);

            if (!parsed.isValid()) {
              this.setState({
                invalid: true
              });
              return;
            }

            value = this.props.value.clone();
            value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

            if (value && (!disabledDate || !disabledDate(value))) {
              var originalValue = this.props.selectedValue;

              if (originalValue && value) {
                if (!originalValue.isSame(value)) {
                  onChange(value);
                }
              } else if (originalValue !== value) {
                onChange(value);
              }
            } else {
              this.setState({
                invalid: true
              });
              return;
            }
          } else {
            onChange(null);
          }

          this.setState({
            invalid: false
          });
        },
        onClear: function onClear() {
          this.setState({
            str: ''
          });
          this.props.onClear(null);
        },
        getRootDOMNode: function getRootDOMNode() {
          return _reactDom2['default'].findDOMNode(this);
        },
        focus: function focus() {
          if (this.dateInputInstance) {
            this.dateInputInstance.focus();
          }
        },
        saveDateInput: function saveDateInput(dateInput) {
          this.dateInputInstance = dateInput;
        },
        render: function render() {
          var props = this.props;
          var _state = this.state,
              invalid = _state.invalid,
              str = _state.str;
          var locale = props.locale,
              prefixCls = props.prefixCls,
              placeholder = props.placeholder;
          var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
          return _react2['default'].createElement('div', {
            className: prefixCls + '-input-wrap'
          }, _react2['default'].createElement('div', {
            className: prefixCls + '-date-input-wrap'
          }, _react2['default'].createElement('input', {
            ref: this.saveDateInput,
            className: prefixCls + '-input ' + invalidClass,
            value: str,
            disabled: props.disabled,
            placeholder: placeholder,
            onChange: this.onInputChange
          })), props.showClear ? _react2['default'].createElement('a', {
            className: prefixCls + '-clear-btn',
            role: 'button',
            title: locale.clear,
            onClick: this.onClear
          }) : null);
        }
      });
      exports['default'] = DateInput;
      module.exports = exports['default'];
      /***/
    },
    /* 830 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _createReactClass = __webpack_require__(32);

      var _createReactClass2 = _interopRequireDefault(_createReactClass);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _DateConstants = __webpack_require__(421);

      var _DateConstants2 = _interopRequireDefault(_DateConstants);

      var _util = __webpack_require__(172);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function isSameDay(one, two) {
        return one && two && one.isSame(two, 'day');
      }

      function beforeCurrentMonthYear(current, today) {
        if (current.year() < today.year()) {
          return 1;
        }

        return current.year() === today.year() && current.month() < today.month();
      }

      function afterCurrentMonthYear(current, today) {
        if (current.year() > today.year()) {
          return 1;
        }

        return current.year() === today.year() && current.month() > today.month();
      }

      function getIdFromDate(date) {
        return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
      }

      var DateTBody = (0, _createReactClass2['default'])({
        displayName: 'DateTBody',
        propTypes: {
          contentRender: _propTypes2['default'].func,
          dateRender: _propTypes2['default'].func,
          disabledDate: _propTypes2['default'].func,
          prefixCls: _propTypes2['default'].string,
          selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
          value: _propTypes2['default'].object,
          hoverValue: _propTypes2['default'].any,
          showWeekNumber: _propTypes2['default'].bool
        },
        getDefaultProps: function getDefaultProps() {
          return {
            hoverValue: []
          };
        },
        render: function render() {
          var props = this.props;
          var contentRender = props.contentRender,
              prefixCls = props.prefixCls,
              selectedValue = props.selectedValue,
              value = props.value,
              showWeekNumber = props.showWeekNumber,
              dateRender = props.dateRender,
              disabledDate = props.disabledDate,
              hoverValue = props.hoverValue;
          var iIndex = void 0;
          var jIndex = void 0;
          var current = void 0;
          var dateTable = [];
          var today = (0, _util.getTodayTime)(value);
          var cellClass = prefixCls + '-cell';
          var weekNumberCellClass = prefixCls + '-week-number-cell';
          var dateClass = prefixCls + '-date';
          var todayClass = prefixCls + '-today';
          var selectedClass = prefixCls + '-selected-day';
          var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation

          var selectedStartDateClass = prefixCls + '-selected-start-date';
          var selectedEndDateClass = prefixCls + '-selected-end-date';
          var inRangeClass = prefixCls + '-in-range-cell';
          var lastMonthDayClass = prefixCls + '-last-month-cell';
          var nextMonthDayClass = prefixCls + '-next-month-btn-day';
          var disabledClass = prefixCls + '-disabled-cell';
          var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
          var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
          var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
          var month1 = value.clone();
          month1.date(1);
          var day = month1.day();
          var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7; // calculate last month

          var lastMonth1 = month1.clone();
          lastMonth1.add(0 - lastMonthDiffDay, 'days');
          var passed = 0;

          for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
            for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
              current = lastMonth1;

              if (passed) {
                current = current.clone();
                current.add(passed, 'days');
              }

              dateTable.push(current);
              passed++;
            }
          }

          var tableHtml = [];
          passed = 0;

          for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
            var _cx;

            var isCurrentWeek = void 0;
            var weekNumberCell = void 0;
            var isActiveWeek = false;
            var dateCells = [];

            if (showWeekNumber) {
              weekNumberCell = _react2['default'].createElement('td', {
                key: dateTable[passed].week(),
                role: 'gridcell',
                className: weekNumberCellClass
              }, dateTable[passed].week());
            }

            for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
              var next = null;
              var last = null;
              current = dateTable[passed];

              if (jIndex < _DateConstants2['default'].DATE_COL_COUNT - 1) {
                next = dateTable[passed + 1];
              }

              if (jIndex > 0) {
                last = dateTable[passed - 1];
              }

              var cls = cellClass;
              var disabled = false;
              var selected = false;

              if (isSameDay(current, today)) {
                cls += ' ' + todayClass;
                isCurrentWeek = true;
              }

              var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
              var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

              if (selectedValue && Array.isArray(selectedValue)) {
                var rangeValue = hoverValue.length ? hoverValue : selectedValue;

                if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
                  var startValue = rangeValue[0];
                  var endValue = rangeValue[1];

                  if (startValue) {
                    if (isSameDay(current, startValue)) {
                      selected = true;
                      isActiveWeek = true;
                      cls += ' ' + selectedStartDateClass;
                    }
                  }

                  if (startValue && endValue) {
                    if (isSameDay(current, endValue)) {
                      selected = true;
                      isActiveWeek = true;
                      cls += ' ' + selectedEndDateClass;
                    } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                      cls += ' ' + inRangeClass;
                    }
                  }
                }
              } else if (isSameDay(current, value)) {
                // keyboard change value, highlight works
                selected = true;
                isActiveWeek = true;
              }

              if (isSameDay(current, selectedValue)) {
                cls += ' ' + selectedDateClass;
              }

              if (isBeforeCurrentMonthYear) {
                cls += ' ' + lastMonthDayClass;
              }

              if (isAfterCurrentMonthYear) {
                cls += ' ' + nextMonthDayClass;
              }

              if (current.clone().endOf('month').date() === current.date()) {
                cls += ' ' + lastDayOfMonthClass;
              }

              if (disabledDate) {
                if (disabledDate(current, value)) {
                  disabled = true;

                  if (!last || !disabledDate(last, value)) {
                    cls += ' ' + firstDisableClass;
                  }

                  if (!next || !disabledDate(next, value)) {
                    cls += ' ' + lastDisableClass;
                  }
                }
              }

              if (selected) {
                cls += ' ' + selectedClass;
              }

              if (disabled) {
                cls += ' ' + disabledClass;
              }

              var dateHtml = void 0;

              if (dateRender) {
                dateHtml = dateRender(current, value);
              } else {
                var content = contentRender ? contentRender(current, value) : current.date();
                dateHtml = _react2['default'].createElement('div', {
                  key: getIdFromDate(current),
                  className: dateClass,
                  'aria-selected': selected,
                  'aria-disabled': disabled
                }, content);
              }

              dateCells.push(_react2['default'].createElement('td', {
                key: passed,
                onClick: disabled ? undefined : props.onSelect.bind(null, current),
                onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
                role: 'gridcell',
                title: (0, _util.getTitleString)(current),
                className: cls
              }, dateHtml));
              passed++;
            }

            tableHtml.push(_react2['default'].createElement('tr', {
              key: iIndex,
              role: 'row',
              className: (0, _classnames2['default'])((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
            }, weekNumberCell, dateCells));
          }

          return _react2['default'].createElement('tbody', {
            className: prefixCls + '-tbody'
          }, tableHtml);
        }
      });
      exports['default'] = DateTBody;
      module.exports = exports['default'];
      /***/
    },
    /* 831 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _DateConstants = __webpack_require__(421);

      var _DateConstants2 = _interopRequireDefault(_DateConstants);

      var _moment = __webpack_require__(14);

      var _moment2 = _interopRequireDefault(_moment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var DateTHead = function (_React$Component) {
        (0, _inherits3['default'])(DateTHead, _React$Component);

        function DateTHead() {
          (0, _classCallCheck3['default'])(this, DateTHead);
          return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
        }

        DateTHead.prototype.render = function render() {
          var props = this.props;
          var value = props.value;
          var localeData = value.localeData();
          var prefixCls = props.prefixCls;
          var veryShortWeekdays = [];
          var weekDays = [];
          var firstDayOfWeek = localeData.firstDayOfWeek();
          var showWeekNumberEl = void 0;
          var now = (0, _moment2['default'])();

          for (var dateColIndex = 0; dateColIndex < _DateConstants2['default'].DATE_COL_COUNT; dateColIndex++) {
            var index = (firstDayOfWeek + dateColIndex) % _DateConstants2['default'].DATE_COL_COUNT;
            now.day(index);
            veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
            weekDays[dateColIndex] = localeData.weekdaysShort(now);
          }

          if (props.showWeekNumber) {
            showWeekNumberEl = _react2['default'].createElement('th', {
              role: 'columnheader',
              className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
            }, _react2['default'].createElement('span', {
              className: prefixCls + '-column-header-inner'
            }, 'x'));
          }

          var weekDaysEls = weekDays.map(function (day, xindex) {
            return _react2['default'].createElement('th', {
              key: xindex,
              role: 'columnheader',
              title: day,
              className: prefixCls + '-column-header'
            }, _react2['default'].createElement('span', {
              className: prefixCls + '-column-header-inner'
            }, veryShortWeekdays[xindex]));
          });
          return _react2['default'].createElement('thead', null, _react2['default'].createElement('tr', {
            role: 'row'
          }, showWeekNumberEl, weekDaysEls));
        };

        return DateTHead;
      }(_react2['default'].Component);

      exports['default'] = DateTHead;
      module.exports = exports['default'];
      /***/
    },
    /* 832 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _DateTHead = __webpack_require__(831);

      var _DateTHead2 = _interopRequireDefault(_DateTHead);

      var _DateTBody = __webpack_require__(830);

      var _DateTBody2 = _interopRequireDefault(_DateTBody);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var DateTable = function (_React$Component) {
        (0, _inherits3['default'])(DateTable, _React$Component);

        function DateTable() {
          (0, _classCallCheck3['default'])(this, DateTable);
          return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
        }

        DateTable.prototype.render = function render() {
          var props = this.props;
          var prefixCls = props.prefixCls;
          return _react2['default'].createElement('table', {
            className: prefixCls + '-table',
            cellSpacing: '0',
            role: 'grid'
          }, _react2['default'].createElement(_DateTHead2['default'], props), _react2['default'].createElement(_DateTBody2['default'], props));
        };

        return DateTable;
      }(_react2['default'].Component);

      exports['default'] = DateTable;
      module.exports = exports['default'];
      /***/
    },
    /* 833 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _createReactClass = __webpack_require__(32);

      var _createReactClass2 = _interopRequireDefault(_createReactClass);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _CalendarHeader = __webpack_require__(428);

      var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

      var _DateTable = __webpack_require__(832);

      var _DateTable2 = _interopRequireDefault(_DateTable);

      var _DateInput = __webpack_require__(829);

      var _DateInput2 = _interopRequireDefault(_DateInput);

      var _index = __webpack_require__(172);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var CalendarPart = (0, _createReactClass2['default'])({
        displayName: 'CalendarPart',
        propTypes: {
          prefixCls: _propTypes2['default'].string,
          value: _propTypes2['default'].any,
          hoverValue: _propTypes2['default'].any,
          selectedValue: _propTypes2['default'].any,
          direction: _propTypes2['default'].any,
          locale: _propTypes2['default'].any,
          showDateInput: _propTypes2['default'].bool,
          showTimePicker: _propTypes2['default'].bool,
          format: _propTypes2['default'].any,
          placeholder: _propTypes2['default'].any,
          disabledDate: _propTypes2['default'].any,
          timePicker: _propTypes2['default'].any,
          disabledTime: _propTypes2['default'].any,
          onInputSelect: _propTypes2['default'].func,
          timePickerDisabledTime: _propTypes2['default'].object,
          enableNext: _propTypes2['default'].any,
          enablePrev: _propTypes2['default'].any
        },
        render: function render() {
          var props = this.props;
          var prefixCls = props.prefixCls,
              value = props.value,
              hoverValue = props.hoverValue,
              selectedValue = props.selectedValue,
              mode = props.mode,
              direction = props.direction,
              locale = props.locale,
              format = props.format,
              placeholder = props.placeholder,
              disabledDate = props.disabledDate,
              timePicker = props.timePicker,
              disabledTime = props.disabledTime,
              timePickerDisabledTime = props.timePickerDisabledTime,
              showTimePicker = props.showTimePicker,
              onInputSelect = props.onInputSelect,
              enablePrev = props.enablePrev,
              enableNext = props.enableNext;
          var shouldShowTimePicker = showTimePicker && timePicker;
          var disabledTimeConfig = shouldShowTimePicker && disabledTime ? (0, _index.getTimeConfig)(selectedValue, disabledTime) : null;
          var rangeClassName = prefixCls + '-range';
          var newProps = {
            locale: locale,
            value: value,
            prefixCls: prefixCls,
            showTimePicker: showTimePicker
          };
          var index = direction === 'left' ? 0 : 1;

          var timePickerEle = shouldShowTimePicker && _react2['default'].cloneElement(timePicker, (0, _extends3['default'])({
            showHour: true,
            showMinute: true,
            showSecond: true
          }, timePicker.props, disabledTimeConfig, timePickerDisabledTime, {
            onChange: onInputSelect,
            defaultOpenValue: value,
            value: selectedValue[index]
          }));

          var dateInputElement = props.showDateInput && _react2['default'].createElement(_DateInput2['default'], {
            format: format,
            locale: locale,
            prefixCls: prefixCls,
            timePicker: timePicker,
            disabledDate: disabledDate,
            placeholder: placeholder,
            disabledTime: disabledTime,
            value: value,
            showClear: false,
            selectedValue: selectedValue[index],
            onChange: onInputSelect
          });

          return _react2['default'].createElement('div', {
            className: rangeClassName + '-part ' + rangeClassName + '-' + direction
          }, dateInputElement, _react2['default'].createElement('div', {
            style: {
              outline: 'none'
            }
          }, _react2['default'].createElement(_CalendarHeader2['default'], (0, _extends3['default'])({}, newProps, {
            mode: mode,
            enableNext: enableNext,
            enablePrev: enablePrev,
            onValueChange: props.onValueChange,
            onPanelChange: props.onPanelChange,
            disabledMonth: props.disabledMonth
          })), showTimePicker ? _react2['default'].createElement('div', {
            className: prefixCls + '-time-picker'
          }, _react2['default'].createElement('div', {
            className: prefixCls + '-time-picker-panel'
          }, timePickerEle)) : null, _react2['default'].createElement('div', {
            className: prefixCls + '-body'
          }, _react2['default'].createElement(_DateTable2['default'], (0, _extends3['default'])({}, newProps, {
            hoverValue: hoverValue,
            selectedValue: selectedValue,
            dateRender: props.dateRender,
            onSelect: props.onSelect,
            onDayHover: props.onDayHover,
            disabledDate: disabledDate,
            showWeekNumber: props.showWeekNumber
          })))));
        }
      });
      exports['default'] = CalendarPart;
      module.exports = exports['default'];
      /***/
    },
    /* 834 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _createReactClass = __webpack_require__(32);

      var _createReactClass2 = _interopRequireDefault(_createReactClass);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _moment = __webpack_require__(14);

      var _moment2 = _interopRequireDefault(_moment);

      var _classnames2 = __webpack_require__(3);

      var _classnames3 = _interopRequireDefault(_classnames2);

      var _KeyCode = __webpack_require__(236);

      var _KeyCode2 = _interopRequireDefault(_KeyCode);

      var _CalendarPart = __webpack_require__(833);

      var _CalendarPart2 = _interopRequireDefault(_CalendarPart);

      var _TodayButton = __webpack_require__(426);

      var _TodayButton2 = _interopRequireDefault(_TodayButton);

      var _OkButton = __webpack_require__(425);

      var _OkButton2 = _interopRequireDefault(_OkButton);

      var _TimePickerButton = __webpack_require__(424);

      var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

      var _CommonMixin = __webpack_require__(423);

      var _CommonMixin2 = _interopRequireDefault(_CommonMixin);

      var _util = __webpack_require__(172);

      var _toTime = __webpack_require__(828);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function noop() {}

      function isEmptyArray(arr) {
        return Array.isArray(arr) && (arr.length === 0 || arr.every(function (i) {
          return !i;
        }));
      }

      function isArraysEqual(a, b) {
        if (a === b) return true;

        if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
          return false;
        }

        if (a.length !== b.length) return false;

        for (var i = 0; i < a.length; ++i) {
          if (a[i] !== b[i]) return false;
        }

        return true;
      }

      function getValueFromSelectedValue(selectedValue) {
        var start = selectedValue[0],
            end = selectedValue[1];
        var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
        return [start, newEnd];
      }

      function normalizeAnchor(props, init) {
        var selectedValue = props.selectedValue || init && props.defaultSelectedValue;
        var value = props.value || init && props.defaultValue;
        var normalizedValue = value ? getValueFromSelectedValue(value) : getValueFromSelectedValue(selectedValue);
        return !isEmptyArray(normalizedValue) ? normalizedValue : init && [(0, _moment2['default'])(), (0, _moment2['default'])().add(1, 'months')];
      }

      function generateOptions(length, extraOptionGen) {
        var arr = extraOptionGen ? extraOptionGen().concat() : [];

        for (var value = 0; value < length; value++) {
          if (arr.indexOf(value) === -1) {
            arr.push(value);
          }
        }

        return arr;
      }

      function onInputSelect(direction, value) {
        if (!value) {
          return;
        }

        var originalValue = this.state.selectedValue;
        var selectedValue = originalValue.concat();
        var index = direction === 'left' ? 0 : 1;
        selectedValue[index] = value;

        if (selectedValue[0] && this.compare(selectedValue[0], selectedValue[1]) > 0) {
          selectedValue[1 - index] = this.state.showTimePicker ? selectedValue[index] : undefined;
        }

        this.props.onInputSelect(selectedValue);
        this.fireSelectValueChange(selectedValue);
      }

      var RangeCalendar = (0, _createReactClass2['default'])({
        displayName: 'RangeCalendar',
        propTypes: {
          prefixCls: _propTypes2['default'].string,
          dateInputPlaceholder: _propTypes2['default'].any,
          defaultValue: _propTypes2['default'].any,
          value: _propTypes2['default'].any,
          hoverValue: _propTypes2['default'].any,
          mode: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOf(['date', 'month', 'year', 'decade'])),
          showDateInput: _propTypes2['default'].bool,
          timePicker: _propTypes2['default'].any,
          showOk: _propTypes2['default'].bool,
          showToday: _propTypes2['default'].bool,
          defaultSelectedValue: _propTypes2['default'].array,
          selectedValue: _propTypes2['default'].array,
          onOk: _propTypes2['default'].func,
          showClear: _propTypes2['default'].bool,
          locale: _propTypes2['default'].object,
          onChange: _propTypes2['default'].func,
          onSelect: _propTypes2['default'].func,
          onValueChange: _propTypes2['default'].func,
          onHoverChange: _propTypes2['default'].func,
          onPanelChange: _propTypes2['default'].func,
          format: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
          onClear: _propTypes2['default'].func,
          type: _propTypes2['default'].any,
          disabledDate: _propTypes2['default'].func,
          disabledTime: _propTypes2['default'].func
        },
        mixins: [_CommonMixin2['default']],
        getDefaultProps: function getDefaultProps() {
          return {
            type: 'both',
            defaultSelectedValue: [],
            onValueChange: noop,
            onHoverChange: noop,
            onPanelChange: noop,
            disabledTime: noop,
            onInputSelect: noop,
            showToday: true,
            showDateInput: true
          };
        },
        getInitialState: function getInitialState() {
          var props = this.props;
          var selectedValue = props.selectedValue || props.defaultSelectedValue;
          var value = normalizeAnchor(props, 1);
          return {
            selectedValue: selectedValue,
            prevSelectedValue: selectedValue,
            firstSelectedValue: null,
            hoverValue: props.hoverValue || [],
            value: value,
            showTimePicker: false,
            mode: props.mode || ['date', 'date']
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          var state = this.state;
          var newState = {};

          if ('value' in nextProps) {
            newState.value = normalizeAnchor(nextProps, 0);
            this.setState(newState);
          }

          if ('hoverValue' in nextProps && !isArraysEqual(state.hoverValue, nextProps.hoverValue)) {
            this.setState({
              hoverValue: nextProps.hoverValue
            });
          }

          if ('selectedValue' in nextProps) {
            newState.selectedValue = nextProps.selectedValue;
            newState.prevSelectedValue = nextProps.selectedValue;
            this.setState(newState);
          }

          if ('mode' in nextProps && !isArraysEqual(state.mode, nextProps.mode)) {
            this.setState({
              mode: nextProps.mode
            });
          }
        },
        onDatePanelEnter: function onDatePanelEnter() {
          if (this.hasSelectedValue()) {
            this.fireHoverValueChange(this.state.selectedValue.concat());
          }
        },
        onDatePanelLeave: function onDatePanelLeave() {
          if (this.hasSelectedValue()) {
            this.fireHoverValueChange([]);
          }
        },
        onSelect: function onSelect(value) {
          var type = this.props.type;
          var _state = this.state,
              selectedValue = _state.selectedValue,
              prevSelectedValue = _state.prevSelectedValue,
              firstSelectedValue = _state.firstSelectedValue;
          var nextSelectedValue = void 0;

          if (type === 'both') {
            if (!firstSelectedValue) {
              (0, _util.syncTime)(prevSelectedValue[0], value);
              nextSelectedValue = [value];
            } else if (this.compare(firstSelectedValue, value) < 0) {
              (0, _util.syncTime)(prevSelectedValue[1], value);
              nextSelectedValue = [firstSelectedValue, value];
            } else {
              (0, _util.syncTime)(prevSelectedValue[0], value);
              (0, _util.syncTime)(prevSelectedValue[1], firstSelectedValue);
              nextSelectedValue = [value, firstSelectedValue];
            }
          } else if (type === 'start') {
            (0, _util.syncTime)(prevSelectedValue[0], value);
            var endValue = selectedValue[1];
            nextSelectedValue = endValue && this.compare(endValue, value) > 0 ? [value, endValue] : [value];
          } else {
            // type === 'end'
            var startValue = selectedValue[0];

            if (startValue && this.compare(startValue, value) <= 0) {
              (0, _util.syncTime)(prevSelectedValue[1], value);
              nextSelectedValue = [startValue, value];
            } else {
              (0, _util.syncTime)(prevSelectedValue[0], value);
              nextSelectedValue = [value];
            }
          }

          this.fireSelectValueChange(nextSelectedValue);
        },
        onKeyDown: function onKeyDown(event) {
          var _this = this;

          if (event.target.nodeName.toLowerCase() === 'input') {
            return;
          }

          var keyCode = event.keyCode;
          var ctrlKey = event.ctrlKey || event.metaKey;
          var _state2 = this.state,
              selectedValue = _state2.selectedValue,
              hoverValue = _state2.hoverValue,
              firstSelectedValue = _state2.firstSelectedValue,
              value = _state2.value;
          var _props = this.props,
              onKeyDown = _props.onKeyDown,
              disabledDate = _props.disabledDate; // Update last time of the picker

          var updateHoverPoint = function updateHoverPoint(func) {
            // Change hover to make focus in UI
            var currentHoverTime = void 0;
            var nextHoverTime = void 0;
            var nextHoverValue = void 0;

            if (!firstSelectedValue) {
              currentHoverTime = hoverValue[0] || selectedValue[0] || value[0] || (0, _moment2['default'])();
              nextHoverTime = func(currentHoverTime);
              nextHoverValue = [nextHoverTime];

              _this.fireHoverValueChange(nextHoverValue);
            } else {
              if (hoverValue.length === 1) {
                currentHoverTime = hoverValue[0].clone();
                nextHoverTime = func(currentHoverTime);
                nextHoverValue = _this.onDayHover(nextHoverTime);
              } else {
                currentHoverTime = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
                nextHoverTime = func(currentHoverTime);
                nextHoverValue = _this.onDayHover(nextHoverTime);
              }
            } // Find origin hover time on value index


            if (nextHoverValue.length >= 2) {
              var miss = nextHoverValue.some(function (ht) {
                return !(0, _toTime.includesTime)(value, ht, 'month');
              });

              if (miss) {
                var newValue = nextHoverValue.slice().sort(function (t1, t2) {
                  return t1.valueOf() - t2.valueOf();
                });

                if (newValue[0].isSame(newValue[1], 'month')) {
                  newValue[1] = newValue[0].clone().add(1, 'month');
                }

                _this.fireValueChange(newValue);
              }
            } else if (nextHoverValue.length === 1) {
              // If only one value, let's keep the origin panel
              var oriValueIndex = value.findIndex(function (time) {
                return time.isSame(currentHoverTime, 'month');
              });
              if (oriValueIndex === -1) oriValueIndex = 0;

              if (value.every(function (time) {
                return !time.isSame(nextHoverTime, 'month');
              })) {
                var _newValue = value.slice();

                _newValue[oriValueIndex] = nextHoverTime.clone();

                _this.fireValueChange(_newValue);
              }
            }

            event.preventDefault();
            return nextHoverTime;
          };

          switch (keyCode) {
            case _KeyCode2['default'].DOWN:
              updateHoverPoint(function (time) {
                return (0, _toTime.goTime)(time, 1, 'weeks');
              });
              return;

            case _KeyCode2['default'].UP:
              updateHoverPoint(function (time) {
                return (0, _toTime.goTime)(time, -1, 'weeks');
              });
              return;

            case _KeyCode2['default'].LEFT:
              if (ctrlKey) {
                updateHoverPoint(function (time) {
                  return (0, _toTime.goTime)(time, -1, 'years');
                });
              } else {
                updateHoverPoint(function (time) {
                  return (0, _toTime.goTime)(time, -1, 'days');
                });
              }

              return;

            case _KeyCode2['default'].RIGHT:
              if (ctrlKey) {
                updateHoverPoint(function (time) {
                  return (0, _toTime.goTime)(time, 1, 'years');
                });
              } else {
                updateHoverPoint(function (time) {
                  return (0, _toTime.goTime)(time, 1, 'days');
                });
              }

              return;

            case _KeyCode2['default'].HOME:
              updateHoverPoint(function (time) {
                return (0, _toTime.goStartMonth)(time);
              });
              return;

            case _KeyCode2['default'].END:
              updateHoverPoint(function (time) {
                return (0, _toTime.goEndMonth)(time);
              });
              return;

            case _KeyCode2['default'].PAGE_DOWN:
              updateHoverPoint(function (time) {
                return (0, _toTime.goTime)(time, 1, 'month');
              });
              return;

            case _KeyCode2['default'].PAGE_UP:
              updateHoverPoint(function (time) {
                return (0, _toTime.goTime)(time, -1, 'month');
              });
              return;

            case _KeyCode2['default'].ENTER:
              {
                var lastValue = void 0;

                if (hoverValue.length === 0) {
                  lastValue = updateHoverPoint(function (time) {
                    return time;
                  });
                } else if (hoverValue.length === 1) {
                  lastValue = hoverValue[0];
                } else {
                  lastValue = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
                }

                if (lastValue && (!disabledDate || !disabledDate(lastValue))) {
                  this.onSelect(lastValue);
                }

                event.preventDefault();
                return;
              }

            default:
              if (onKeyDown) {
                onKeyDown(event);
              }

          }
        },
        onDayHover: function onDayHover(value) {
          var hoverValue = [];
          var _state3 = this.state,
              selectedValue = _state3.selectedValue,
              firstSelectedValue = _state3.firstSelectedValue;
          var type = this.props.type;

          if (type === 'start' && selectedValue[1]) {
            hoverValue = this.compare(value, selectedValue[1]) < 0 ? [value, selectedValue[1]] : [value];
          } else if (type === 'end' && selectedValue[0]) {
            hoverValue = this.compare(value, selectedValue[0]) > 0 ? [selectedValue[0], value] : [];
          } else {
            if (!firstSelectedValue) {
              if (this.state.hoverValue.length) {
                this.setState({
                  hoverValue: []
                });
              }

              return hoverValue;
            }

            hoverValue = this.compare(value, firstSelectedValue) < 0 ? [value, firstSelectedValue] : [firstSelectedValue, value];
          }

          this.fireHoverValueChange(hoverValue);
          return hoverValue;
        },
        onToday: function onToday() {
          var startValue = (0, _util.getTodayTime)(this.state.value[0]);
          var endValue = startValue.clone().add(1, 'months');
          this.setState({
            value: [startValue, endValue]
          });
        },
        onOpenTimePicker: function onOpenTimePicker() {
          this.setState({
            showTimePicker: true
          });
        },
        onCloseTimePicker: function onCloseTimePicker() {
          this.setState({
            showTimePicker: false
          });
        },
        onOk: function onOk() {
          var selectedValue = this.state.selectedValue;

          if (this.isAllowedDateAndTime(selectedValue)) {
            this.props.onOk(this.state.selectedValue);
          }
        },
        onStartInputSelect: function onStartInputSelect() {
          for (var _len = arguments.length, oargs = Array(_len), _key = 0; _key < _len; _key++) {
            oargs[_key] = arguments[_key];
          }

          var args = ['left'].concat(oargs);
          return onInputSelect.apply(this, args);
        },
        onEndInputSelect: function onEndInputSelect() {
          for (var _len2 = arguments.length, oargs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            oargs[_key2] = arguments[_key2];
          }

          var args = ['right'].concat(oargs);
          return onInputSelect.apply(this, args);
        },
        onStartValueChange: function onStartValueChange(leftValue) {
          var value = [].concat(this.state.value);
          value[0] = leftValue;
          return this.fireValueChange(value);
        },
        onEndValueChange: function onEndValueChange(rightValue) {
          var value = [].concat(this.state.value);
          value[1] = rightValue;
          return this.fireValueChange(value);
        },
        onStartPanelChange: function onStartPanelChange(value, mode) {
          var props = this.props,
              state = this.state;
          var newMode = [mode, state.mode[1]];

          if (!('mode' in props)) {
            this.setState({
              mode: newMode
            });
          }

          var newValue = [value || state.value[0], state.value[1]];
          props.onPanelChange(newValue, newMode);
        },
        onEndPanelChange: function onEndPanelChange(value, mode) {
          var props = this.props,
              state = this.state;
          var newMode = [state.mode[0], mode];

          if (!('mode' in props)) {
            this.setState({
              mode: newMode
            });
          }

          var newValue = [state.value[0], value || state.value[1]];
          props.onPanelChange(newValue, newMode);
        },
        getStartValue: function getStartValue() {
          var value = this.state.value[0];
          var selectedValue = this.state.selectedValue; // keep selectedTime when select date

          if (selectedValue[0] && this.props.timePicker) {
            value = value.clone();
            (0, _util.syncTime)(selectedValue[0], value);
          }

          if (this.state.showTimePicker && selectedValue[0]) {
            return selectedValue[0];
          }

          return value;
        },
        getEndValue: function getEndValue() {
          var _state4 = this.state,
              value = _state4.value,
              selectedValue = _state4.selectedValue,
              showTimePicker = _state4.showTimePicker;
          var endValue = value[1] ? value[1].clone() : value[0].clone().add(1, 'month'); // keep selectedTime when select date

          if (selectedValue[1] && this.props.timePicker) {
            (0, _util.syncTime)(selectedValue[1], endValue);
          }

          if (showTimePicker) {
            return selectedValue[1] ? selectedValue[1] : this.getStartValue();
          }

          return endValue;
        },
        // get disabled hours for second picker
        getEndDisableTime: function getEndDisableTime() {
          var _state5 = this.state,
              selectedValue = _state5.selectedValue,
              value = _state5.value;
          var disabledTime = this.props.disabledTime;
          var userSettingDisabledTime = disabledTime(selectedValue, 'end') || {};
          var startValue = selectedValue && selectedValue[0] || value[0].clone(); // if startTime and endTime is same day..
          // the second time picker will not able to pick time before first time picker

          if (!selectedValue[1] || startValue.isSame(selectedValue[1], 'day')) {
            var hours = startValue.hour();
            var minutes = startValue.minute();
            var second = startValue.second();
            var _disabledHours = userSettingDisabledTime.disabledHours,
                _disabledMinutes = userSettingDisabledTime.disabledMinutes,
                _disabledSeconds = userSettingDisabledTime.disabledSeconds;
            var oldDisabledMinutes = _disabledMinutes ? _disabledMinutes() : [];
            var olddisabledSeconds = _disabledSeconds ? _disabledSeconds() : [];
            _disabledHours = generateOptions(hours, _disabledHours);
            _disabledMinutes = generateOptions(minutes, _disabledMinutes);
            _disabledSeconds = generateOptions(second, _disabledSeconds);
            return {
              disabledHours: function disabledHours() {
                return _disabledHours;
              },
              disabledMinutes: function disabledMinutes(hour) {
                if (hour === hours) {
                  return _disabledMinutes;
                }

                return oldDisabledMinutes;
              },
              disabledSeconds: function disabledSeconds(hour, minute) {
                if (hour === hours && minute === minutes) {
                  return _disabledSeconds;
                }

                return olddisabledSeconds;
              }
            };
          }

          return userSettingDisabledTime;
        },
        isAllowedDateAndTime: function isAllowedDateAndTime(selectedValue) {
          return (0, _util.isAllowedDate)(selectedValue[0], this.props.disabledDate, this.disabledStartTime) && (0, _util.isAllowedDate)(selectedValue[1], this.props.disabledDate, this.disabledEndTime);
        },
        isMonthYearPanelShow: function isMonthYearPanelShow(mode) {
          return ['month', 'year', 'decade'].indexOf(mode) > -1;
        },
        hasSelectedValue: function hasSelectedValue() {
          var selectedValue = this.state.selectedValue;
          return !!selectedValue[1] && !!selectedValue[0];
        },
        compare: function compare(v1, v2) {
          if (this.props.timePicker) {
            return v1.diff(v2);
          }

          return v1.diff(v2, 'days');
        },
        fireSelectValueChange: function fireSelectValueChange(selectedValue, direct) {
          var timePicker = this.props.timePicker;
          var prevSelectedValue = this.state.prevSelectedValue;

          if (timePicker && timePicker.props.defaultValue) {
            var timePickerDefaultValue = timePicker.props.defaultValue;

            if (!prevSelectedValue[0] && selectedValue[0]) {
              (0, _util.syncTime)(timePickerDefaultValue[0], selectedValue[0]);
            }

            if (!prevSelectedValue[1] && selectedValue[1]) {
              (0, _util.syncTime)(timePickerDefaultValue[1], selectedValue[1]);
            }
          }

          if (!('selectedValue' in this.props)) {
            this.setState({
              selectedValue: selectedValue
            });
          } // 尚未选择过时间，直接输入的话


          if (!this.state.selectedValue[0] || !this.state.selectedValue[1]) {
            var startValue = selectedValue[0] || (0, _moment2['default'])();
            var endValue = selectedValue[1] || startValue.clone().add(1, 'months');
            this.setState({
              selectedValue: selectedValue,
              value: getValueFromSelectedValue([startValue, endValue])
            });
          }

          if (selectedValue[0] && !selectedValue[1]) {
            this.setState({
              firstSelectedValue: selectedValue[0]
            });
            this.fireHoverValueChange(selectedValue.concat());
          }

          this.props.onChange(selectedValue);

          if (direct || selectedValue[0] && selectedValue[1]) {
            this.setState({
              prevSelectedValue: selectedValue,
              firstSelectedValue: null
            });
            this.fireHoverValueChange([]);
            this.props.onSelect(selectedValue);
          }
        },
        fireValueChange: function fireValueChange(value) {
          var props = this.props;

          if (!('value' in props)) {
            this.setState({
              value: value
            });
          }

          props.onValueChange(value);
        },
        fireHoverValueChange: function fireHoverValueChange(hoverValue) {
          var props = this.props;

          if (!('hoverValue' in props)) {
            this.setState({
              hoverValue: hoverValue
            });
          }

          props.onHoverChange(hoverValue);
        },
        clear: function clear() {
          this.fireSelectValueChange([], true);
          this.props.onClear();
        },
        disabledStartTime: function disabledStartTime(time) {
          return this.props.disabledTime(time, 'start');
        },
        disabledEndTime: function disabledEndTime(time) {
          return this.props.disabledTime(time, 'end');
        },
        disabledStartMonth: function disabledStartMonth(month) {
          var value = this.state.value;
          return month.isSameOrAfter(value[1], 'month');
        },
        disabledEndMonth: function disabledEndMonth(month) {
          var value = this.state.value;
          return month.isSameOrBefore(value[0], 'month');
        },
        render: function render() {
          var _className, _classnames;

          var props = this.props,
              state = this.state;
          var prefixCls = props.prefixCls,
              dateInputPlaceholder = props.dateInputPlaceholder,
              timePicker = props.timePicker,
              showOk = props.showOk,
              locale = props.locale,
              showClear = props.showClear,
              showToday = props.showToday,
              type = props.type;
          var hoverValue = state.hoverValue,
              selectedValue = state.selectedValue,
              mode = state.mode,
              showTimePicker = state.showTimePicker;
          var className = (_className = {}, _className[props.className] = !!props.className, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[prefixCls + '-range'] = 1, _className[prefixCls + '-show-time-picker'] = showTimePicker, _className[prefixCls + '-week-number'] = props.showWeekNumber, _className);
          var classes = (0, _classnames3['default'])(className);
          var newProps = {
            selectedValue: state.selectedValue,
            onSelect: this.onSelect,
            onDayHover: type === 'start' && selectedValue[1] || type === 'end' && selectedValue[0] || !!hoverValue.length ? this.onDayHover : undefined
          };
          var placeholder1 = void 0;
          var placeholder2 = void 0;

          if (dateInputPlaceholder) {
            if (Array.isArray(dateInputPlaceholder)) {
              placeholder1 = dateInputPlaceholder[0];
              placeholder2 = dateInputPlaceholder[1];
            } else {
              placeholder1 = placeholder2 = dateInputPlaceholder;
            }
          }

          var showOkButton = showOk === true || showOk !== false && !!timePicker;
          var cls = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-footer'] = true, _classnames[prefixCls + '-range-bottom'] = true, _classnames[prefixCls + '-footer-show-ok'] = showOkButton, _classnames));
          var startValue = this.getStartValue();
          var endValue = this.getEndValue();
          var todayTime = (0, _util.getTodayTime)(startValue);
          var thisMonth = todayTime.month();
          var thisYear = todayTime.year();
          var isTodayInView = startValue.year() === thisYear && startValue.month() === thisMonth || endValue.year() === thisYear && endValue.month() === thisMonth;
          var nextMonthOfStart = startValue.clone().add(1, 'months');
          var isClosestMonths = nextMonthOfStart.year() === endValue.year() && nextMonthOfStart.month() === endValue.month(); // console.warn('Render:', selectedValue.map(t => t.format('YYYY-MM-DD')).join(', '));
          // console.log('start:', startValue.format('YYYY-MM-DD'));
          // console.log('end:', endValue.format('YYYY-MM-DD'));

          return _react2['default'].createElement('div', {
            ref: this.saveRoot,
            className: classes,
            style: props.style,
            tabIndex: '0',
            onKeyDown: this.onKeyDown
          }, props.renderSidebar(), _react2['default'].createElement('div', {
            className: prefixCls + '-panel'
          }, showClear && selectedValue[0] && selectedValue[1] ? _react2['default'].createElement('a', {
            className: prefixCls + '-clear-btn',
            role: 'button',
            title: locale.clear,
            onClick: this.clear
          }) : null, _react2['default'].createElement('div', {
            className: prefixCls + '-date-panel',
            onMouseLeave: type !== 'both' ? this.onDatePanelLeave : undefined,
            onMouseEnter: type !== 'both' ? this.onDatePanelEnter : undefined
          }, _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'left',
            disabledTime: this.disabledStartTime,
            disabledMonth: this.disabledStartMonth,
            format: this.getFormat(),
            value: startValue,
            mode: mode[0],
            placeholder: placeholder1,
            onInputSelect: this.onStartInputSelect,
            onValueChange: this.onStartValueChange,
            onPanelChange: this.onStartPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker,
            enablePrev: true,
            enableNext: !isClosestMonths || this.isMonthYearPanelShow(mode[1])
          })), _react2['default'].createElement('span', {
            className: prefixCls + '-range-middle'
          }, '~'), _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
            hoverValue: hoverValue,
            direction: 'right',
            format: this.getFormat(),
            timePickerDisabledTime: this.getEndDisableTime(),
            placeholder: placeholder2,
            value: endValue,
            mode: mode[1],
            onInputSelect: this.onEndInputSelect,
            onValueChange: this.onEndValueChange,
            onPanelChange: this.onEndPanelChange,
            showDateInput: this.props.showDateInput,
            timePicker: timePicker,
            showTimePicker: showTimePicker,
            disabledTime: this.disabledEndTime,
            disabledMonth: this.disabledEndMonth,
            enablePrev: !isClosestMonths || this.isMonthYearPanelShow(mode[0]),
            enableNext: true
          }))), _react2['default'].createElement('div', {
            className: cls
          }, props.renderFooter(), showToday || props.timePicker || showOkButton ? _react2['default'].createElement('div', {
            className: prefixCls + '-footer-btn'
          }, showToday ? _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, {
            disabled: isTodayInView,
            value: state.value[0],
            onToday: this.onToday,
            text: locale.backToToday
          })) : null, props.timePicker ? _react2['default'].createElement(_TimePickerButton2['default'], (0, _extends3['default'])({}, props, {
            showTimePicker: showTimePicker,
            onOpenTimePicker: this.onOpenTimePicker,
            onCloseTimePicker: this.onCloseTimePicker,
            timePickerDisabled: !this.hasSelectedValue() || hoverValue.length
          })) : null, showOkButton ? _react2['default'].createElement(_OkButton2['default'], (0, _extends3['default'])({}, props, {
            onOk: this.onOk,
            okDisabled: !this.isAllowedDateAndTime(selectedValue) || !this.hasSelectedValue() || hoverValue.length
          })) : null) : null)));
        }
      });
      exports['default'] = RangeCalendar;
      module.exports = exports['default'];
      /***/
    },
    /* 835 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _slicedToArray2 = __webpack_require__(145);

      var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _moment = __webpack_require__(14);

      var moment = _interopRequireWildcard(_moment);

      var _RangeCalendar = __webpack_require__(834);

      var _RangeCalendar2 = _interopRequireDefault(_RangeCalendar);

      var _Picker = __webpack_require__(311);

      var _Picker2 = _interopRequireDefault(_Picker);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _icon = __webpack_require__(126);

      var _icon2 = _interopRequireDefault(_icon);

      var _warning = __webpack_require__(310);

      var _warning2 = _interopRequireDefault(_warning);

      var _interopDefault = __webpack_require__(235);

      var _interopDefault2 = _interopRequireDefault(_interopDefault);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }
      /* tslint:disable jsx-no-multiline-js */


      function getShowDateFromValue(value) {
        var _value = (0, _slicedToArray3['default'])(value, 2),
            start = _value[0],
            end = _value[1]; // value could be an empty array, then we should not reset showDate


        if (!start && !end) {
          return;
        }

        var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
        return [start, newEnd];
      }

      function formatValue(value, format) {
        return value && value.format(format) || '';
      }

      function pickerValueAdapter(value) {
        if (!value) {
          return;
        }

        if (Array.isArray(value)) {
          return value;
        }

        return [value, value.clone().add(1, 'month')];
      }

      function isEmptyArray(arr) {
        if (Array.isArray(arr)) {
          return arr.length === 0 || arr.every(function (i) {
            return !i;
          });
        }

        return false;
      }

      function fixLocale(value, localeCode) {
        if (!localeCode) {
          return;
        }

        if (!value || value.length === 0) {
          return;
        }

        if (value[0]) {
          value[0].locale(localeCode);
        }

        if (value[1]) {
          value[1].locale(localeCode);
        }
      }

      var RangePicker = function (_React$Component) {
        (0, _inherits3['default'])(RangePicker, _React$Component);

        function RangePicker(props) {
          (0, _classCallCheck3['default'])(this, RangePicker);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (RangePicker.__proto__ || Object.getPrototypeOf(RangePicker)).call(this, props));

          _this.clearSelection = function (e) {
            e.preventDefault();
            e.stopPropagation();

            _this.setState({
              value: []
            });

            _this.handleChange([]);
          };

          _this.clearHoverValue = function () {
            return _this.setState({
              hoverValue: []
            });
          };

          _this.handleChange = function (value) {
            var props = _this.props;

            if (!('value' in props)) {
              _this.setState(function (_ref) {
                var showDate = _ref.showDate;
                return {
                  value: value,
                  showDate: getShowDateFromValue(value) || showDate
                };
              });
            }

            props.onChange(value, [formatValue(value[0], props.format), formatValue(value[1], props.format)]);
          };

          _this.handleOpenChange = function (open) {
            if (!('open' in _this.props)) {
              _this.setState({
                open: open
              });
            }

            if (open === false) {
              _this.clearHoverValue();
            }

            var onOpenChange = _this.props.onOpenChange;

            if (onOpenChange) {
              onOpenChange(open);
            }
          };

          _this.handleShowDateChange = function (showDate) {
            return _this.setState({
              showDate: showDate
            });
          };

          _this.handleHoverChange = function (hoverValue) {
            return _this.setState({
              hoverValue: hoverValue
            });
          };

          _this.handleRangeMouseLeave = function () {
            if (_this.state.open) {
              _this.clearHoverValue();
            }
          };

          _this.handleCalendarInputSelect = function (value) {
            if (!value[0]) {
              return;
            }

            _this.setState(function (_ref2) {
              var showDate = _ref2.showDate;
              return {
                value: value,
                showDate: getShowDateFromValue(value) || showDate
              };
            });
          };

          _this.handleRangeClick = function (value) {
            if (typeof value === 'function') {
              value = value();
            }

            _this.setValue(value, true);

            var onOk = _this.props.onOk;

            if (onOk) {
              onOk(value);
            }
          };

          _this.savePicker = function (node) {
            _this.picker = node;
          };

          _this.renderFooter = function () {
            var _this$props = _this.props,
                prefixCls = _this$props.prefixCls,
                ranges = _this$props.ranges,
                renderExtraFooter = _this$props.renderExtraFooter;

            if (!ranges && !renderExtraFooter) {
              return null;
            }

            var customFooter = renderExtraFooter ? React.createElement('div', {
              className: prefixCls + '-footer-extra',
              key: 'extra'
            }, renderExtraFooter.apply(undefined, arguments)) : null;
            var operations = Object.keys(ranges || {}).map(function (range) {
              var value = ranges[range];
              return React.createElement('a', {
                key: range,
                onClick: function onClick() {
                  return _this.handleRangeClick(value);
                },
                onMouseEnter: function onMouseEnter() {
                  return _this.setState({
                    hoverValue: value
                  });
                },
                onMouseLeave: _this.handleRangeMouseLeave
              }, range);
            });
            var rangeNode = React.createElement('div', {
              className: prefixCls + '-footer-extra ' + prefixCls + '-range-quick-selector',
              key: 'range'
            }, operations);
            return [rangeNode, customFooter];
          };

          var value = props.value || props.defaultValue || [];

          if (value[0] && !(0, _interopDefault2['default'])(moment).isMoment(value[0]) || value[1] && !(0, _interopDefault2['default'])(moment).isMoment(value[1])) {
            throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
          }

          var pickerValue = !value || isEmptyArray(value) ? props.defaultPickerValue : value;
          _this.state = {
            value: value,
            showDate: pickerValueAdapter(pickerValue || (0, _interopDefault2['default'])(moment)()),
            open: props.open,
            hoverValue: []
          };
          return _this;
        }

        (0, _createClass3['default'])(RangePicker, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
              var state = this.state;
              var value = nextProps.value || [];
              this.setState({
                value: value,
                showDate: getShowDateFromValue(value) || state.showDate
              });
            }

            if ('open' in nextProps) {
              this.setState({
                open: nextProps.open
              });
            }
          }
        }, {
          key: 'setValue',
          value: function setValue(value, hidePanel) {
            this.handleChange(value);

            if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
              this.setState({
                open: false
              });
            }
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.picker.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.picker.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames,
                _this2 = this;

            var state = this.state,
                props = this.props;
            var value = state.value,
                showDate = state.showDate,
                hoverValue = state.hoverValue,
                open = state.open;
            var prefixCls = props.prefixCls,
                popupStyle = props.popupStyle,
                style = props.style,
                disabledDate = props.disabledDate,
                disabledTime = props.disabledTime,
                showTime = props.showTime,
                showToday = props.showToday,
                ranges = props.ranges,
                onOk = props.onOk,
                locale = props.locale,
                localeCode = props.localeCode,
                format = props.format,
                dateRender = props.dateRender,
                onCalendarChange = props.onCalendarChange;
            fixLocale(value, localeCode);
            fixLocale(showDate, localeCode);
            (0, _warning2['default'])(!('onOK' in props), 'It should be `RangePicker[onOk]`, instead of `onOK`!');
            var calendarClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-time', showTime), (0, _defineProperty3['default'])(_classNames, prefixCls + '-range-with-ranges', ranges), _classNames)); // 需要选择时间时，点击 ok 时才触发 onChange

            var pickerChangeHandler = {
              onChange: this.handleChange
            };
            var calendarProps = {
              onOk: this.handleChange
            };

            if (props.timePicker) {
              pickerChangeHandler.onChange = function (changedValue) {
                return _this2.handleChange(changedValue);
              };
            } else {
              calendarProps = {};
            }

            if ('mode' in props) {
              calendarProps.mode = props.mode;
            }

            var startPlaceholder = 'placeholder' in props ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
            var endPlaceholder = 'placeholder' in props ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
            var calendar = React.createElement(_RangeCalendar2['default'], (0, _extends3['default'])({}, calendarProps, {
              onChange: onCalendarChange,
              format: format,
              prefixCls: prefixCls,
              className: calendarClassName,
              renderFooter: this.renderFooter,
              timePicker: props.timePicker,
              disabledDate: disabledDate,
              disabledTime: disabledTime,
              dateInputPlaceholder: [startPlaceholder, endPlaceholder],
              locale: locale.lang,
              onOk: onOk,
              dateRender: dateRender,
              value: showDate,
              onValueChange: this.handleShowDateChange,
              hoverValue: hoverValue,
              onHoverChange: this.handleHoverChange,
              onPanelChange: props.onPanelChange,
              showToday: showToday,
              onInputSelect: this.handleCalendarInputSelect
            })); // default width for showTime

            var pickerStyle = {};

            if (props.showTime) {
              pickerStyle.width = style && style.width || 350;
            }

            var clearIcon = !props.disabled && props.allowClear && value && (value[0] || value[1]) ? React.createElement(_icon2['default'], {
              type: 'cross-circle',
              className: prefixCls + '-picker-clear',
              onClick: this.clearSelection
            }) : null;

            var input = function input(_ref3) {
              var inputValue = _ref3.value;
              var start = inputValue[0];
              var end = inputValue[1];
              return React.createElement('span', {
                className: props.pickerInputClass
              }, React.createElement('input', {
                disabled: props.disabled,
                readOnly: true,
                value: start && start.format(props.format) || '',
                placeholder: startPlaceholder,
                className: prefixCls + '-range-picker-input',
                tabIndex: -1
              }), React.createElement('span', {
                className: prefixCls + '-range-picker-separator'
              }, ' ~ '), React.createElement('input', {
                disabled: props.disabled,
                readOnly: true,
                value: end && end.format(props.format) || '',
                placeholder: endPlaceholder,
                className: prefixCls + '-range-picker-input',
                tabIndex: -1
              }), clearIcon, React.createElement('span', {
                className: prefixCls + '-picker-icon'
              }));
            };

            return React.createElement('span', {
              ref: this.savePicker,
              id: props.id,
              className: (0, _classnames2['default'])(props.className, props.pickerClass),
              style: (0, _extends3['default'])({}, style, pickerStyle),
              tabIndex: props.disabled ? -1 : 0,
              onFocus: props.onFocus,
              onBlur: props.onBlur
            }, React.createElement(_Picker2['default'], (0, _extends3['default'])({}, props, pickerChangeHandler, {
              calendar: calendar,
              value: value,
              open: open,
              onOpenChange: this.handleOpenChange,
              prefixCls: prefixCls + '-picker-container',
              style: popupStyle
            }), input));
          }
        }]);
        return RangePicker;
      }(React.Component);

      exports['default'] = RangePicker;
      RangePicker.defaultProps = {
        prefixCls: 'ant-calendar',
        allowClear: true,
        showToday: false
      };
      module.exports = exports['default'];
      /***/
    },
    /* 836 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var autoAdjustOverflow = {
        adjustX: 1,
        adjustY: 1
      };
      var targetOffset = [0, 0];
      var placements = {
        bottomLeft: {
          points: ['tl', 'tl'],
          overflow: autoAdjustOverflow,
          offset: [0, -3],
          targetOffset: targetOffset
        },
        bottomRight: {
          points: ['tr', 'tr'],
          overflow: autoAdjustOverflow,
          offset: [0, -3],
          targetOffset: targetOffset
        },
        topRight: {
          points: ['br', 'br'],
          overflow: autoAdjustOverflow,
          offset: [0, 3],
          targetOffset: targetOffset
        },
        topLeft: {
          points: ['bl', 'bl'],
          overflow: autoAdjustOverflow,
          offset: [0, 3],
          targetOffset: targetOffset
        }
      };
      exports['default'] = placements;
      module.exports = exports['default'];
      /***/
    },
    /* 837 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _rcTrigger = __webpack_require__(75);

      var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

      var _Panel = __webpack_require__(422);

      var _Panel2 = _interopRequireDefault(_Panel);

      var _placements = __webpack_require__(836);

      var _placements2 = _interopRequireDefault(_placements);

      var _moment = __webpack_require__(14);

      var _moment2 = _interopRequireDefault(_moment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function noop() {}

      function refFn(field, component) {
        this[field] = component;
      }

      var Picker = function (_Component) {
        (0, _inherits3['default'])(Picker, _Component);

        function Picker(props) {
          (0, _classCallCheck3['default'])(this, Picker);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));

          _initialiseProps.call(_this);

          _this.saveInputRef = refFn.bind(_this, 'picker');
          _this.savePanelRef = refFn.bind(_this, 'panelInstance');
          var defaultOpen = props.defaultOpen,
              defaultValue = props.defaultValue,
              _props$open = props.open,
              open = _props$open === undefined ? defaultOpen : _props$open,
              _props$value = props.value,
              value = _props$value === undefined ? defaultValue : _props$value;
          _this.state = {
            open: open,
            value: value
          };
          return _this;
        }

        (0, _createClass3['default'])(Picker, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var value = nextProps.value,
                open = nextProps.open;

            if ('value' in nextProps) {
              this.setState({
                value: value
              });
            }

            if (open !== undefined) {
              this.setState({
                open: open
              });
            }
          }
        }, {
          key: 'setValue',
          value: function setValue(value) {
            if (!('value' in this.props)) {
              this.setState({
                value: value
              });
            }

            this.props.onChange(value);
          }
        }, {
          key: 'getFormat',
          value: function getFormat() {
            var _props = this.props,
                format = _props.format,
                showHour = _props.showHour,
                showMinute = _props.showMinute,
                showSecond = _props.showSecond,
                use12Hours = _props.use12Hours;

            if (format) {
              return format;
            }

            if (use12Hours) {
              var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
                return !!item;
              }).join(':');
              return fmtString.concat(' a');
            }

            return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
              return !!item;
            }).join(':');
          }
        }, {
          key: 'getPanelElement',
          value: function getPanelElement() {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                placeholder = _props2.placeholder,
                disabledHours = _props2.disabledHours,
                disabledMinutes = _props2.disabledMinutes,
                disabledSeconds = _props2.disabledSeconds,
                hideDisabledOptions = _props2.hideDisabledOptions,
                inputReadOnly = _props2.inputReadOnly,
                allowEmpty = _props2.allowEmpty,
                showHour = _props2.showHour,
                showMinute = _props2.showMinute,
                showSecond = _props2.showSecond,
                defaultOpenValue = _props2.defaultOpenValue,
                clearText = _props2.clearText,
                addon = _props2.addon,
                use12Hours = _props2.use12Hours,
                focusOnOpen = _props2.focusOnOpen,
                onKeyDown = _props2.onKeyDown,
                hourStep = _props2.hourStep,
                minuteStep = _props2.minuteStep,
                secondStep = _props2.secondStep;
            return _react2['default'].createElement(_Panel2['default'], {
              clearText: clearText,
              prefixCls: prefixCls + '-panel',
              ref: this.savePanelRef,
              value: this.state.value,
              inputReadOnly: inputReadOnly,
              onChange: this.onPanelChange,
              onClear: this.onPanelClear,
              defaultOpenValue: defaultOpenValue,
              showHour: showHour,
              showMinute: showMinute,
              showSecond: showSecond,
              onEsc: this.onEsc,
              allowEmpty: allowEmpty,
              format: this.getFormat(),
              placeholder: placeholder,
              disabledHours: disabledHours,
              disabledMinutes: disabledMinutes,
              disabledSeconds: disabledSeconds,
              hideDisabledOptions: hideDisabledOptions,
              use12Hours: use12Hours,
              hourStep: hourStep,
              minuteStep: minuteStep,
              secondStep: secondStep,
              addon: addon,
              focusOnOpen: focusOnOpen,
              onKeyDown: onKeyDown
            });
          }
        }, {
          key: 'getPopupClassName',
          value: function getPopupClassName() {
            var _props3 = this.props,
                showHour = _props3.showHour,
                showMinute = _props3.showMinute,
                showSecond = _props3.showSecond,
                use12Hours = _props3.use12Hours,
                prefixCls = _props3.prefixCls;
            var popupClassName = this.props.popupClassName; // Keep it for old compatibility

            if ((!showHour || !showMinute || !showSecond) && !use12Hours) {
              popupClassName += ' ' + prefixCls + '-panel-narrow';
            }

            var selectColumnCount = 0;

            if (showHour) {
              selectColumnCount += 1;
            }

            if (showMinute) {
              selectColumnCount += 1;
            }

            if (showSecond) {
              selectColumnCount += 1;
            }

            if (use12Hours) {
              selectColumnCount += 1;
            }

            popupClassName += ' ' + prefixCls + '-panel-column-' + selectColumnCount;
            return popupClassName;
          }
        }, {
          key: 'setOpen',
          value: function setOpen(open) {
            var _props4 = this.props,
                onOpen = _props4.onOpen,
                onClose = _props4.onClose;

            if (this.state.open !== open) {
              if (!('open' in this.props)) {
                this.setState({
                  open: open
                });
              }

              if (open) {
                onOpen({
                  open: open
                });
              } else {
                onClose({
                  open: open
                });
              }
            }
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.picker.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.picker.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _props5 = this.props,
                prefixCls = _props5.prefixCls,
                placeholder = _props5.placeholder,
                placement = _props5.placement,
                align = _props5.align,
                disabled = _props5.disabled,
                transitionName = _props5.transitionName,
                style = _props5.style,
                className = _props5.className,
                getPopupContainer = _props5.getPopupContainer,
                name = _props5.name,
                autoComplete = _props5.autoComplete,
                onFocus = _props5.onFocus,
                onBlur = _props5.onBlur,
                autoFocus = _props5.autoFocus,
                inputReadOnly = _props5.inputReadOnly;
            var _state = this.state,
                open = _state.open,
                value = _state.value;
            var popupClassName = this.getPopupClassName();
            return _react2['default'].createElement(_rcTrigger2['default'], {
              prefixCls: prefixCls + '-panel',
              popupClassName: popupClassName,
              popup: this.getPanelElement(),
              popupAlign: align,
              builtinPlacements: _placements2['default'],
              popupPlacement: placement,
              action: disabled ? [] : ['click'],
              destroyPopupOnHide: true,
              getPopupContainer: getPopupContainer,
              popupTransitionName: transitionName,
              popupVisible: open,
              onPopupVisibleChange: this.onVisibleChange
            }, _react2['default'].createElement('span', {
              className: prefixCls + ' ' + className,
              style: style
            }, _react2['default'].createElement('input', {
              className: prefixCls + '-input',
              ref: this.saveInputRef,
              type: 'text',
              placeholder: placeholder,
              name: name,
              onKeyDown: this.onKeyDown,
              disabled: disabled,
              value: value && value.format(this.getFormat()) || '',
              autoComplete: autoComplete,
              onFocus: onFocus,
              onBlur: onBlur,
              autoFocus: autoFocus,
              onChange: noop,
              readOnly: !!inputReadOnly
            }), _react2['default'].createElement('span', {
              className: prefixCls + '-icon'
            })));
          }
        }]);
        return Picker;
      }(_react.Component);

      Picker.propTypes = {
        prefixCls: _propTypes2['default'].string,
        clearText: _propTypes2['default'].string,
        value: _propTypes2['default'].object,
        defaultOpenValue: _propTypes2['default'].object,
        inputReadOnly: _propTypes2['default'].bool,
        disabled: _propTypes2['default'].bool,
        allowEmpty: _propTypes2['default'].bool,
        defaultValue: _propTypes2['default'].object,
        open: _propTypes2['default'].bool,
        defaultOpen: _propTypes2['default'].bool,
        align: _propTypes2['default'].object,
        placement: _propTypes2['default'].any,
        transitionName: _propTypes2['default'].string,
        getPopupContainer: _propTypes2['default'].func,
        placeholder: _propTypes2['default'].string,
        format: _propTypes2['default'].string,
        showHour: _propTypes2['default'].bool,
        showMinute: _propTypes2['default'].bool,
        showSecond: _propTypes2['default'].bool,
        style: _propTypes2['default'].object,
        className: _propTypes2['default'].string,
        popupClassName: _propTypes2['default'].string,
        disabledHours: _propTypes2['default'].func,
        disabledMinutes: _propTypes2['default'].func,
        disabledSeconds: _propTypes2['default'].func,
        hideDisabledOptions: _propTypes2['default'].bool,
        onChange: _propTypes2['default'].func,
        onOpen: _propTypes2['default'].func,
        onClose: _propTypes2['default'].func,
        onFocus: _propTypes2['default'].func,
        onBlur: _propTypes2['default'].func,
        addon: _propTypes2['default'].func,
        name: _propTypes2['default'].string,
        autoComplete: _propTypes2['default'].string,
        use12Hours: _propTypes2['default'].bool,
        hourStep: _propTypes2['default'].number,
        minuteStep: _propTypes2['default'].number,
        secondStep: _propTypes2['default'].number,
        focusOnOpen: _propTypes2['default'].bool,
        onKeyDown: _propTypes2['default'].func,
        autoFocus: _propTypes2['default'].bool
      };
      Picker.defaultProps = {
        clearText: 'clear',
        prefixCls: 'rc-time-picker',
        defaultOpen: false,
        inputReadOnly: false,
        style: {},
        className: '',
        popupClassName: '',
        align: {},
        defaultOpenValue: (0, _moment2['default'])(),
        allowEmpty: true,
        showHour: true,
        showMinute: true,
        showSecond: true,
        disabledHours: noop,
        disabledMinutes: noop,
        disabledSeconds: noop,
        hideDisabledOptions: false,
        placement: 'bottomLeft',
        onChange: noop,
        onOpen: noop,
        onClose: noop,
        onFocus: noop,
        onBlur: noop,
        addon: noop,
        use12Hours: false,
        focusOnOpen: false,
        onKeyDown: noop
      };

      var _initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.onPanelChange = function (value) {
          _this2.setValue(value);
        };

        this.onPanelClear = function () {
          _this2.setValue(null);

          _this2.setOpen(false);
        };

        this.onVisibleChange = function (open) {
          _this2.setOpen(open);
        };

        this.onEsc = function () {
          _this2.setOpen(false);

          _this2.focus();
        };

        this.onKeyDown = function (e) {
          if (e.keyCode === 40) {
            _this2.setOpen(true);
          }
        };
      };

      exports['default'] = Picker;
      module.exports = exports['default'];
      /***/
    },
    /* 838 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _moment = __webpack_require__(14);

      var moment = _interopRequireWildcard(_moment);

      var _TimePicker = __webpack_require__(837);

      var _TimePicker2 = _interopRequireDefault(_TimePicker);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _LocaleReceiver = __webpack_require__(201);

      var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

      var _en_US = __webpack_require__(324);

      var _en_US2 = _interopRequireDefault(_en_US);

      var _interopDefault = __webpack_require__(235);

      var _interopDefault2 = _interopRequireDefault(_interopDefault);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function generateShowHourMinuteSecond(format) {
        // Ref: http://momentjs.com/docs/#/parsing/string-format/
        return {
          showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
          showMinute: format.indexOf('m') > -1,
          showSecond: format.indexOf('s') > -1
        };
      }

      var TimePicker = function (_React$Component) {
        (0, _inherits3['default'])(TimePicker, _React$Component);

        function TimePicker(props) {
          (0, _classCallCheck3['default'])(this, TimePicker);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

          _this.handleChange = function (value) {
            if (!('value' in _this.props)) {
              _this.setState({
                value: value
              });
            }

            var _this$props = _this.props,
                onChange = _this$props.onChange,
                _this$props$format = _this$props.format,
                format = _this$props$format === undefined ? 'HH:mm:ss' : _this$props$format;

            if (onChange) {
              onChange(value, value && value.format(format) || '');
            }
          };

          _this.handleOpenClose = function (_ref) {
            var open = _ref.open;
            var onOpenChange = _this.props.onOpenChange;

            if (onOpenChange) {
              onOpenChange(open);
            }
          };

          _this.saveTimePicker = function (timePickerRef) {
            _this.timePickerRef = timePickerRef;
          };

          _this.renderTimePicker = function (locale) {
            var props = (0, _extends3['default'])({}, _this.props);
            delete props.defaultValue;

            var format = _this.getDefaultFormat();

            var className = (0, _classnames2['default'])(props.className, (0, _defineProperty3['default'])({}, props.prefixCls + '-' + props.size, !!props.size));

            var addon = function addon(panel) {
              return props.addon ? React.createElement('div', {
                className: props.prefixCls + '-panel-addon'
              }, props.addon(panel)) : null;
            };

            return React.createElement(_TimePicker2['default'], (0, _extends3['default'])({}, generateShowHourMinuteSecond(format), props, {
              ref: _this.saveTimePicker,
              format: format,
              className: className,
              value: _this.state.value,
              placeholder: props.placeholder === undefined ? locale.placeholder : props.placeholder,
              onChange: _this.handleChange,
              onOpen: _this.handleOpenClose,
              onClose: _this.handleOpenClose,
              addon: addon
            }));
          };

          var value = props.value || props.defaultValue;

          if (value && !(0, _interopDefault2['default'])(moment).isMoment(value)) {
            throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
          }

          _this.state = {
            value: value
          };
          return _this;
        }

        (0, _createClass3['default'])(TimePicker, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
              this.setState({
                value: nextProps.value
              });
            }
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.timePickerRef.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.timePickerRef.blur();
          }
        }, {
          key: 'getDefaultFormat',
          value: function getDefaultFormat() {
            var _props = this.props,
                format = _props.format,
                use12Hours = _props.use12Hours;

            if (format) {
              return format;
            } else if (use12Hours) {
              return 'h:mm:ss a';
            }

            return 'HH:mm:ss';
          }
        }, {
          key: 'render',
          value: function render() {
            return React.createElement(_LocaleReceiver2['default'], {
              componentName: 'TimePicker',
              defaultLocale: _en_US2['default']
            }, this.renderTimePicker);
          }
        }]);
        return TimePicker;
      }(React.Component);

      exports['default'] = TimePicker;
      TimePicker.defaultProps = {
        prefixCls: 'ant-time-picker',
        align: {
          offset: [0, -2]
        },
        disabled: false,
        disabledHours: undefined,
        disabledMinutes: undefined,
        disabledSeconds: undefined,
        hideDisabledOptions: false,
        placement: 'bottomLeft',
        transitionName: 'slide-up',
        focusOnOpen: true
      };
      /***/
    },
    /* 839 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _reactDom = __webpack_require__(16);

      var _reactDom2 = _interopRequireDefault(_reactDom);

      var _classnames3 = __webpack_require__(3);

      var _classnames4 = _interopRequireDefault(_classnames3);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var scrollTo = function scrollTo(element, to, duration) {
        var requestAnimationFrame = window.requestAnimationFrame || function requestAnimationFrameTimeout() {
          return setTimeout(arguments[0], 10);
        }; // jump to target if duration zero


        if (duration <= 0) {
          element.scrollTop = to;
          return;
        }

        var difference = to - element.scrollTop;
        var perTick = difference / duration * 10;
        requestAnimationFrame(function () {
          element.scrollTop = element.scrollTop + perTick;
          if (element.scrollTop === to) return;
          scrollTo(element, to, duration - 10);
        });
      };

      var Select = function (_Component) {
        (0, _inherits3['default'])(Select, _Component);

        function Select() {
          var _ref;

          var _temp, _this, _ret;

          (0, _classCallCheck3['default'])(this, Select);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            active: false
          }, _this.onSelect = function (value) {
            var _this$props = _this.props,
                onSelect = _this$props.onSelect,
                type = _this$props.type;
            onSelect(type, value);
          }, _this.handleMouseEnter = function (e) {
            _this.setState({
              active: true
            });

            _this.props.onMouseEnter(e);
          }, _this.handleMouseLeave = function () {
            _this.setState({
              active: false
            });
          }, _this.saveList = function (node) {
            _this.list = node;
          }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
        }

        (0, _createClass3['default'])(Select, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            // jump to selected option
            this.scrollToSelected(0);
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate(prevProps) {
            // smooth scroll to selected option
            if (prevProps.selectedIndex !== this.props.selectedIndex) {
              this.scrollToSelected(120);
            }
          }
        }, {
          key: 'getOptions',
          value: function getOptions() {
            var _this2 = this;

            var _props = this.props,
                options = _props.options,
                selectedIndex = _props.selectedIndex,
                prefixCls = _props.prefixCls;
            return options.map(function (item, index) {
              var _classnames;

              var cls = (0, _classnames4['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-select-option-selected', selectedIndex === index), (0, _defineProperty3['default'])(_classnames, prefixCls + '-select-option-disabled', item.disabled), _classnames));
              var onclick = null;

              if (!item.disabled) {
                onclick = _this2.onSelect.bind(_this2, item.value);
              }

              return _react2['default'].createElement('li', {
                className: cls,
                key: index,
                onClick: onclick,
                disabled: item.disabled
              }, item.value);
            });
          }
        }, {
          key: 'scrollToSelected',
          value: function scrollToSelected(duration) {
            // move to selected item
            var select = _reactDom2['default'].findDOMNode(this);

            var list = _reactDom2['default'].findDOMNode(this.list);

            if (!list) {
              return;
            }

            var index = this.props.selectedIndex;

            if (index < 0) {
              index = 0;
            }

            var topOption = list.children[index];
            var to = topOption.offsetTop;
            scrollTo(select, to, duration);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classnames2;

            if (this.props.options.length === 0) {
              return null;
            }

            var prefixCls = this.props.prefixCls;
            var cls = (0, _classnames4['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-select', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-select-active', this.state.active), _classnames2));
            return _react2['default'].createElement('div', {
              className: cls,
              onMouseEnter: this.handleMouseEnter,
              onMouseLeave: this.handleMouseLeave
            }, _react2['default'].createElement('ul', {
              ref: this.saveList
            }, this.getOptions()));
          }
        }]);
        return Select;
      }(_react.Component);

      Select.propTypes = {
        prefixCls: _propTypes2['default'].string,
        options: _propTypes2['default'].array,
        selectedIndex: _propTypes2['default'].number,
        type: _propTypes2['default'].string,
        onSelect: _propTypes2['default'].func,
        onMouseEnter: _propTypes2['default'].func
      };
      exports['default'] = Select;
      module.exports = exports['default'];
      /***/
    },
    /* 840 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _Select = __webpack_require__(839);

      var _Select2 = _interopRequireDefault(_Select);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var formatOption = function formatOption(option, disabledOptions) {
        var value = '' + option;

        if (option < 10) {
          value = '0' + option;
        }

        var disabled = false;

        if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
          disabled = true;
        }

        return {
          value: value,
          disabled: disabled
        };
      };

      var Combobox = function (_Component) {
        (0, _inherits3['default'])(Combobox, _Component);

        function Combobox() {
          var _ref;

          var _temp, _this, _ret;

          (0, _classCallCheck3['default'])(this, Combobox);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Combobox.__proto__ || Object.getPrototypeOf(Combobox)).call.apply(_ref, [this].concat(args))), _this), _this.onItemChange = function (type, itemValue) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                defaultOpenValue = _this$props.defaultOpenValue,
                use12Hours = _this$props.use12Hours;
            var value = (_this.props.value || defaultOpenValue).clone();

            if (type === 'hour') {
              if (use12Hours) {
                if (_this.props.isAM) {
                  value.hour(+itemValue % 12);
                } else {
                  value.hour(+itemValue % 12 + 12);
                }
              } else {
                value.hour(+itemValue);
              }
            } else if (type === 'minute') {
              value.minute(+itemValue);
            } else if (type === 'ampm') {
              var ampm = itemValue.toUpperCase();

              if (use12Hours) {
                if (ampm === 'PM' && value.hour() < 12) {
                  value.hour(value.hour() % 12 + 12);
                }

                if (ampm === 'AM') {
                  if (value.hour() >= 12) {
                    value.hour(value.hour() - 12);
                  }
                }
              }
            } else {
              value.second(+itemValue);
            }

            onChange(value);
          }, _this.onEnterSelectPanel = function (range) {
            _this.props.onCurrentSelectPanelChange(range);
          }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
        }

        (0, _createClass3['default'])(Combobox, [{
          key: 'getHourSelect',
          value: function getHourSelect(hour) {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                hourOptions = _props.hourOptions,
                disabledHours = _props.disabledHours,
                showHour = _props.showHour,
                use12Hours = _props.use12Hours;

            if (!showHour) {
              return null;
            }

            var disabledOptions = disabledHours();
            var hourOptionsAdj = void 0;
            var hourAdj = void 0;

            if (use12Hours) {
              hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
                return h < 12 && h > 0;
              }));
              hourAdj = hour % 12 || 12;
            } else {
              hourOptionsAdj = hourOptions;
              hourAdj = hour;
            }

            return _react2['default'].createElement(_Select2['default'], {
              prefixCls: prefixCls,
              options: hourOptionsAdj.map(function (option) {
                return formatOption(option, disabledOptions);
              }),
              selectedIndex: hourOptionsAdj.indexOf(hourAdj),
              type: 'hour',
              onSelect: this.onItemChange,
              onMouseEnter: this.onEnterSelectPanel.bind(this, 'hour')
            });
          }
        }, {
          key: 'getMinuteSelect',
          value: function getMinuteSelect(minute) {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                minuteOptions = _props2.minuteOptions,
                disabledMinutes = _props2.disabledMinutes,
                defaultOpenValue = _props2.defaultOpenValue,
                showMinute = _props2.showMinute;

            if (!showMinute) {
              return null;
            }

            var value = this.props.value || defaultOpenValue;
            var disabledOptions = disabledMinutes(value.hour());
            return _react2['default'].createElement(_Select2['default'], {
              prefixCls: prefixCls,
              options: minuteOptions.map(function (option) {
                return formatOption(option, disabledOptions);
              }),
              selectedIndex: minuteOptions.indexOf(minute),
              type: 'minute',
              onSelect: this.onItemChange,
              onMouseEnter: this.onEnterSelectPanel.bind(this, 'minute')
            });
          }
        }, {
          key: 'getSecondSelect',
          value: function getSecondSelect(second) {
            var _props3 = this.props,
                prefixCls = _props3.prefixCls,
                secondOptions = _props3.secondOptions,
                disabledSeconds = _props3.disabledSeconds,
                showSecond = _props3.showSecond,
                defaultOpenValue = _props3.defaultOpenValue;

            if (!showSecond) {
              return null;
            }

            var value = this.props.value || defaultOpenValue;
            var disabledOptions = disabledSeconds(value.hour(), value.minute());
            return _react2['default'].createElement(_Select2['default'], {
              prefixCls: prefixCls,
              options: secondOptions.map(function (option) {
                return formatOption(option, disabledOptions);
              }),
              selectedIndex: secondOptions.indexOf(second),
              type: 'second',
              onSelect: this.onItemChange,
              onMouseEnter: this.onEnterSelectPanel.bind(this, 'second')
            });
          }
        }, {
          key: 'getAMPMSelect',
          value: function getAMPMSelect() {
            var _props4 = this.props,
                prefixCls = _props4.prefixCls,
                use12Hours = _props4.use12Hours,
                format = _props4.format;

            if (!use12Hours) {
              return null;
            }

            var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
            .map(function (c) {
              return format.match(/\sA/) ? c.toUpperCase() : c;
            }).map(function (c) {
              return {
                value: c
              };
            });
            var selected = this.props.isAM ? 0 : 1;
            return _react2['default'].createElement(_Select2['default'], {
              prefixCls: prefixCls,
              options: AMPMOptions,
              selectedIndex: selected,
              type: 'ampm',
              onSelect: this.onItemChange,
              onMouseEnter: this.onEnterSelectPanel.bind(this, 'ampm')
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var _props5 = this.props,
                prefixCls = _props5.prefixCls,
                defaultOpenValue = _props5.defaultOpenValue;
            var value = this.props.value || defaultOpenValue;
            return _react2['default'].createElement('div', {
              className: prefixCls + '-combobox'
            }, this.getHourSelect(value.hour()), this.getMinuteSelect(value.minute()), this.getSecondSelect(value.second()), this.getAMPMSelect(value.hour()));
          }
        }]);
        return Combobox;
      }(_react.Component);

      Combobox.propTypes = {
        format: _propTypes2['default'].string,
        defaultOpenValue: _propTypes2['default'].object,
        prefixCls: _propTypes2['default'].string,
        value: _propTypes2['default'].object,
        onChange: _propTypes2['default'].func,
        showHour: _propTypes2['default'].bool,
        showMinute: _propTypes2['default'].bool,
        showSecond: _propTypes2['default'].bool,
        hourOptions: _propTypes2['default'].array,
        minuteOptions: _propTypes2['default'].array,
        secondOptions: _propTypes2['default'].array,
        disabledHours: _propTypes2['default'].func,
        disabledMinutes: _propTypes2['default'].func,
        disabledSeconds: _propTypes2['default'].func,
        onCurrentSelectPanelChange: _propTypes2['default'].func,
        use12Hours: _propTypes2['default'].bool,
        isAM: _propTypes2['default'].bool
      };
      exports['default'] = Combobox;
      module.exports = exports['default'];
      /***/
    },
    /* 841 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _moment = __webpack_require__(14);

      var _moment2 = _interopRequireDefault(_moment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var Header = function (_Component) {
        (0, _inherits3['default'])(Header, _Component);

        function Header(props) {
          (0, _classCallCheck3['default'])(this, Header);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

          _initialiseProps.call(_this);

          var value = props.value,
              format = props.format;
          _this.state = {
            str: value && value.format(format) || '',
            invalid: false
          };
          return _this;
        }

        (0, _createClass3['default'])(Header, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _this2 = this;

            if (this.props.focusOnOpen) {
              // Wait one frame for the panel to be positioned before focusing
              var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
              requestAnimationFrame(function () {
                _this2.refs.input.focus();

                _this2.refs.input.select();
              });
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var value = nextProps.value,
                format = nextProps.format;
            this.setState({
              str: value && value.format(format) || '',
              invalid: false
            });
          }
        }, {
          key: 'getClearButton',
          value: function getClearButton() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                allowEmpty = _props.allowEmpty;

            if (!allowEmpty) {
              return null;
            }

            return _react2['default'].createElement('a', {
              className: prefixCls + '-clear-btn',
              role: 'button',
              title: this.props.clearText,
              onMouseDown: this.onClear
            });
          }
        }, {
          key: 'getProtoValue',
          value: function getProtoValue() {
            return this.props.value || this.props.defaultOpenValue;
          }
        }, {
          key: 'getInput',
          value: function getInput() {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                placeholder = _props2.placeholder,
                inputReadOnly = _props2.inputReadOnly;
            var _state = this.state,
                invalid = _state.invalid,
                str = _state.str;
            var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
            return _react2['default'].createElement('input', {
              className: prefixCls + '-input  ' + invalidClass,
              ref: 'input',
              onKeyDown: this.onKeyDown,
              value: str,
              placeholder: placeholder,
              onChange: this.onInputChange,
              readOnly: !!inputReadOnly
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var prefixCls = this.props.prefixCls;
            return _react2['default'].createElement('div', {
              className: prefixCls + '-input-wrap'
            }, this.getInput(), this.getClearButton());
          }
        }]);
        return Header;
      }(_react.Component);

      Header.propTypes = {
        format: _propTypes2['default'].string,
        prefixCls: _propTypes2['default'].string,
        disabledDate: _propTypes2['default'].func,
        placeholder: _propTypes2['default'].string,
        clearText: _propTypes2['default'].string,
        value: _propTypes2['default'].object,
        inputReadOnly: _propTypes2['default'].bool,
        hourOptions: _propTypes2['default'].array,
        minuteOptions: _propTypes2['default'].array,
        secondOptions: _propTypes2['default'].array,
        disabledHours: _propTypes2['default'].func,
        disabledMinutes: _propTypes2['default'].func,
        disabledSeconds: _propTypes2['default'].func,
        onChange: _propTypes2['default'].func,
        onClear: _propTypes2['default'].func,
        onEsc: _propTypes2['default'].func,
        allowEmpty: _propTypes2['default'].bool,
        defaultOpenValue: _propTypes2['default'].object,
        currentSelectPanel: _propTypes2['default'].string,
        focusOnOpen: _propTypes2['default'].bool,
        onKeyDown: _propTypes2['default'].func
      };
      Header.defaultProps = {
        inputReadOnly: false
      };

      var _initialiseProps = function _initialiseProps() {
        var _this3 = this;

        this.onInputChange = function (event) {
          var str = event.target.value;

          _this3.setState({
            str: str
          });

          var _props3 = _this3.props,
              format = _props3.format,
              hourOptions = _props3.hourOptions,
              minuteOptions = _props3.minuteOptions,
              secondOptions = _props3.secondOptions,
              disabledHours = _props3.disabledHours,
              disabledMinutes = _props3.disabledMinutes,
              disabledSeconds = _props3.disabledSeconds,
              onChange = _props3.onChange,
              allowEmpty = _props3.allowEmpty;

          if (str) {
            var originalValue = _this3.props.value;

            var value = _this3.getProtoValue().clone();

            var parsed = (0, _moment2['default'])(str, format, true);

            if (!parsed.isValid()) {
              _this3.setState({
                invalid: true
              });

              return;
            }

            value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second()); // if time value not allowed, response warning.

            if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
              _this3.setState({
                invalid: true
              });

              return;
            } // if time value is disabled, response warning.


            var disabledHourOptions = disabledHours();
            var disabledMinuteOptions = disabledMinutes(value.hour());
            var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());

            if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
              _this3.setState({
                invalid: true
              });

              return;
            }

            if (originalValue) {
              if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
                // keep other fields for rc-calendar
                var changedValue = originalValue.clone();
                changedValue.hour(value.hour());
                changedValue.minute(value.minute());
                changedValue.second(value.second());
                onChange(changedValue);
              }
            } else if (originalValue !== value) {
              onChange(value);
            }
          } else if (allowEmpty) {
            onChange(null);
          } else {
            _this3.setState({
              invalid: true
            });

            return;
          }

          _this3.setState({
            invalid: false
          });
        };

        this.onKeyDown = function (e) {
          var _props4 = _this3.props,
              onEsc = _props4.onEsc,
              onKeyDown = _props4.onKeyDown;

          if (e.keyCode === 27) {
            onEsc();
          }

          onKeyDown(e);
        };

        this.onClear = function () {
          _this3.setState({
            str: ''
          });

          _this3.props.onClear();
        };
      };

      exports['default'] = Header;
      module.exports = exports['default'];
      /***/
    },
    /* 842 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      exports['default'] = wrapPicker;

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _Panel = __webpack_require__(422);

      var _Panel2 = _interopRequireDefault(_Panel);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _LocaleReceiver = __webpack_require__(201);

      var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);

      var _timePicker = __webpack_require__(838);

      var _en_US = __webpack_require__(325);

      var _en_US2 = _interopRequireDefault(_en_US);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function getColumns(_ref) {
        var showHour = _ref.showHour,
            showMinute = _ref.showMinute,
            showSecond = _ref.showSecond,
            use12Hours = _ref.use12Hours;
        var column = 0;

        if (showHour) {
          column += 1;
        }

        if (showMinute) {
          column += 1;
        }

        if (showSecond) {
          column += 1;
        }

        if (use12Hours) {
          column += 1;
        }

        return column;
      }

      function wrapPicker(Picker, defaultFormat) {
        return _a = function (_React$Component) {
          (0, _inherits3['default'])(PickerWrapper, _React$Component);

          function PickerWrapper() {
            (0, _classCallCheck3['default'])(this, PickerWrapper);

            var _this = (0, _possibleConstructorReturn3['default'])(this, (PickerWrapper.__proto__ || Object.getPrototypeOf(PickerWrapper)).apply(this, arguments));

            _this.handleOpenChange = function (open) {
              var onOpenChange = _this.props.onOpenChange;
              onOpenChange(open);
            };

            _this.handleFocus = function (e) {
              var onFocus = _this.props.onFocus;

              if (onFocus) {
                onFocus(e);
              }
            };

            _this.handleBlur = function (e) {
              var onBlur = _this.props.onBlur;

              if (onBlur) {
                onBlur(e);
              }
            };

            _this.savePicker = function (node) {
              _this.picker = node;
            };

            _this.getDefaultLocale = function () {
              var result = (0, _extends3['default'])({}, _en_US2['default'], _this.props.locale);
              result.lang = (0, _extends3['default'])({}, result.lang, (_this.props.locale || {}).lang);
              return result;
            };

            _this.renderPicker = function (locale, localeCode) {
              var _classNames2;

              var props = _this.props;
              var prefixCls = props.prefixCls,
                  inputPrefixCls = props.inputPrefixCls;
              var pickerClass = (0, _classnames2['default'])(prefixCls + '-picker', (0, _defineProperty3['default'])({}, prefixCls + '-picker-' + props.size, !!props.size));
              var pickerInputClass = (0, _classnames2['default'])(prefixCls + '-picker-input', inputPrefixCls, (_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, inputPrefixCls + '-lg', props.size === 'large'), (0, _defineProperty3['default'])(_classNames2, inputPrefixCls + '-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames2, inputPrefixCls + '-disabled', props.disabled), _classNames2));
              var timeFormat = props.showTime && props.showTime.format || 'HH:mm:ss';
              var rcTimePickerProps = (0, _extends3['default'])({}, (0, _timePicker.generateShowHourMinuteSecond)(timeFormat), {
                format: timeFormat,
                use12Hours: props.showTime && props.showTime.use12Hours
              });
              var columns = getColumns(rcTimePickerProps);
              var timePickerCls = prefixCls + '-time-picker-column-' + columns;
              var timePicker = props.showTime ? React.createElement(_Panel2['default'], (0, _extends3['default'])({}, rcTimePickerProps, props.showTime, {
                prefixCls: prefixCls + '-time-picker',
                className: timePickerCls,
                placeholder: locale.timePickerLocale.placeholder,
                transitionName: 'slide-up'
              })) : null;
              return React.createElement(Picker, (0, _extends3['default'])({}, props, {
                ref: _this.savePicker,
                pickerClass: pickerClass,
                pickerInputClass: pickerInputClass,
                locale: locale,
                localeCode: localeCode,
                timePicker: timePicker,
                onOpenChange: _this.handleOpenChange,
                onFocus: _this.handleFocus,
                onBlur: _this.handleBlur
              }));
            };

            return _this;
          }

          (0, _createClass3['default'])(PickerWrapper, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              var _props = this.props,
                  autoFocus = _props.autoFocus,
                  disabled = _props.disabled;

              if (autoFocus && !disabled) {
                this.focus();
              }
            }
          }, {
            key: 'focus',
            value: function focus() {
              this.picker.focus();
            }
          }, {
            key: 'blur',
            value: function blur() {
              this.picker.blur();
            }
          }, {
            key: 'render',
            value: function render() {
              return React.createElement(_LocaleReceiver2['default'], {
                componentName: 'DatePicker',
                defaultLocale: this.getDefaultLocale
              }, this.renderPicker);
            }
          }]);
          return PickerWrapper;
        }(React.Component), _a.defaultProps = {
          format: defaultFormat || 'YYYY-MM-DD',
          transitionName: 'slide-up',
          popupStyle: {},
          onChange: function onChange() {},
          onOk: function onOk() {},
          onOpenChange: function onOpenChange() {},
          locale: {},
          prefixCls: 'ant-calendar',
          inputPrefixCls: 'ant-input'
        }, _a;

        var _a;
      }

      module.exports = exports['default'];
      /***/
    },
    /* 843 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      var autoAdjustOverflow = {
        adjustX: 1,
        adjustY: 1
      };
      var targetOffset = [0, 0];
      var placements = {
        bottomLeft: {
          points: ['tl', 'tl'],
          overflow: autoAdjustOverflow,
          offset: [0, -3],
          targetOffset: targetOffset
        },
        bottomRight: {
          points: ['tr', 'tr'],
          overflow: autoAdjustOverflow,
          offset: [0, -3],
          targetOffset: targetOffset
        },
        topRight: {
          points: ['br', 'br'],
          overflow: autoAdjustOverflow,
          offset: [0, 3],
          targetOffset: targetOffset
        },
        topLeft: {
          points: ['bl', 'bl'],
          overflow: autoAdjustOverflow,
          offset: [0, 3],
          targetOffset: targetOffset
        }
      };
      exports['default'] = placements;
      module.exports = exports['default'];
      /***/
    },
    /* 844 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports["default"] = createChainedFunction;
      /**
       * Safe chained function
       *
       * Will only create a new function if needed,
       * otherwise will pass back existing functions or null.
       *
       * @returns {function|null}
       */

      function createChainedFunction() {
        var args = [].slice.call(arguments, 0);

        if (args.length === 1) {
          return args[0];
        }

        return function chainedFunction() {
          for (var i = 0; i < args.length; i++) {
            if (args[i] && args[i].apply) {
              args[i].apply(this, arguments);
            }
          }
        };
      }

      module.exports = exports['default'];
      /***/
    },
    /* 845 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      exports['default'] = createPicker;

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _moment = __webpack_require__(14);

      var moment = _interopRequireWildcard(_moment);

      var _MonthCalendar = __webpack_require__(429);

      var _MonthCalendar2 = _interopRequireDefault(_MonthCalendar);

      var _Picker = __webpack_require__(311);

      var _Picker2 = _interopRequireDefault(_Picker);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _omit = __webpack_require__(45);

      var _omit2 = _interopRequireDefault(_omit);

      var _icon = __webpack_require__(126);

      var _icon2 = _interopRequireDefault(_icon);

      var _warning = __webpack_require__(310);

      var _warning2 = _interopRequireDefault(_warning);

      var _interopDefault = __webpack_require__(235);

      var _interopDefault2 = _interopRequireDefault(_interopDefault);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function createPicker(TheCalendar) {
        return _a = function (_React$Component) {
          (0, _inherits3['default'])(CalenderWrapper, _React$Component);

          function CalenderWrapper(props) {
            (0, _classCallCheck3['default'])(this, CalenderWrapper);

            var _this = (0, _possibleConstructorReturn3['default'])(this, (CalenderWrapper.__proto__ || Object.getPrototypeOf(CalenderWrapper)).call(this, props));

            _this.renderFooter = function () {
              var _this$props = _this.props,
                  prefixCls = _this$props.prefixCls,
                  renderExtraFooter = _this$props.renderExtraFooter;
              return renderExtraFooter ? React.createElement('div', {
                className: prefixCls + '-footer-extra'
              }, renderExtraFooter.apply(undefined, arguments)) : null;
            };

            _this.clearSelection = function (e) {
              e.preventDefault();
              e.stopPropagation();

              _this.handleChange(null);
            };

            _this.handleChange = function (value) {
              var props = _this.props;

              if (!('value' in props)) {
                _this.setState({
                  value: value,
                  showDate: value
                });
              }

              props.onChange(value, value && value.format(props.format) || '');
            };

            _this.handleCalendarChange = function (value) {
              _this.setState({
                showDate: value
              });
            };

            _this.saveInput = function (node) {
              _this.input = node;
            };

            var value = props.value || props.defaultValue;

            if (value && !(0, _interopDefault2['default'])(moment).isMoment(value)) {
              throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
            }

            _this.state = {
              value: value,
              showDate: value
            };
            return _this;
          }

          (0, _createClass3['default'])(CalenderWrapper, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
              if ('value' in nextProps) {
                this.setState({
                  value: nextProps.value,
                  showDate: nextProps.value
                });
              }
            }
          }, {
            key: 'focus',
            value: function focus() {
              this.input.focus();
            }
          }, {
            key: 'blur',
            value: function blur() {
              this.input.blur();
            }
          }, {
            key: 'render',
            value: function render() {
              var _classNames,
                  _this2 = this;

              var _state = this.state,
                  value = _state.value,
                  showDate = _state.showDate;
              var props = (0, _omit2['default'])(this.props, ['onChange']);
              var prefixCls = props.prefixCls,
                  locale = props.locale,
                  localeCode = props.localeCode;
              var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
              var disabledTime = props.showTime ? props.disabledTime : null;
              var calendarClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-time', props.showTime), (0, _defineProperty3['default'])(_classNames, prefixCls + '-month', _MonthCalendar2['default'] === TheCalendar), _classNames));

              if (value && localeCode) {
                value.locale(localeCode);
              }

              var pickerProps = {};
              var calendarProps = {};

              if (props.showTime) {
                calendarProps = {
                  // fix https://github.com/ant-design/ant-design/issues/1902
                  onSelect: this.handleChange
                };
              } else {
                pickerProps = {
                  onChange: this.handleChange
                };
              }

              if ('mode' in props) {
                calendarProps.mode = props.mode;
              }

              (0, _warning2['default'])(!('onOK' in props), 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');
              var calendar = React.createElement(TheCalendar, (0, _extends3['default'])({}, calendarProps, {
                disabledDate: props.disabledDate,
                disabledTime: disabledTime,
                locale: locale.lang,
                timePicker: props.timePicker,
                defaultValue: props.defaultPickerValue || (0, _interopDefault2['default'])(moment)(),
                dateInputPlaceholder: placeholder,
                prefixCls: prefixCls,
                className: calendarClassName,
                onOk: props.onOk,
                dateRender: props.dateRender,
                format: props.format,
                showToday: props.showToday,
                monthCellContentRender: props.monthCellContentRender,
                renderFooter: this.renderFooter,
                onPanelChange: props.onPanelChange,
                onChange: this.handleCalendarChange,
                value: showDate
              }));
              var clearIcon = !props.disabled && props.allowClear && value ? React.createElement(_icon2['default'], {
                type: 'cross-circle',
                className: prefixCls + '-picker-clear',
                onClick: this.clearSelection
              }) : null;

              var input = function input(_ref) {
                var inputValue = _ref.value;
                return React.createElement('div', null, React.createElement('input', {
                  ref: _this2.saveInput,
                  disabled: props.disabled,
                  readOnly: true,
                  value: inputValue && inputValue.format(props.format) || '',
                  placeholder: placeholder,
                  className: props.pickerInputClass
                }), clearIcon, React.createElement('span', {
                  className: prefixCls + '-picker-icon'
                }));
              };

              return React.createElement('span', {
                id: props.id,
                className: (0, _classnames2['default'])(props.className, props.pickerClass),
                style: props.style,
                onFocus: props.onFocus,
                onBlur: props.onBlur
              }, React.createElement(_Picker2['default'], (0, _extends3['default'])({}, props, pickerProps, {
                calendar: calendar,
                value: value,
                prefixCls: prefixCls + '-picker-container',
                style: props.popupStyle
              }), input));
            }
          }]);
          return CalenderWrapper;
        }(React.Component), _a.defaultProps = {
          prefixCls: 'ant-calendar',
          allowClear: true,
          showToday: true
        }, _a;

        var _a;
      }

      module.exports = exports['default'];
      /***/
    },
    /* 846 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _moment = __webpack_require__(14);

      var _moment2 = _interopRequireDefault(_moment);

      var _index = __webpack_require__(172);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function noop() {}

      function getNow() {
        return (0, _moment2['default'])();
      }

      function getNowByCurrentStateValue(value) {
        var ret = void 0;

        if (value) {
          ret = (0, _index.getTodayTime)(value);
        } else {
          ret = getNow();
        }

        return ret;
      }

      var CalendarMixin = {
        propTypes: {
          value: _propTypes2['default'].object,
          defaultValue: _propTypes2['default'].object,
          onKeyDown: _propTypes2['default'].func
        },
        getDefaultProps: function getDefaultProps() {
          return {
            onKeyDown: noop
          };
        },
        getInitialState: function getInitialState() {
          var props = this.props;
          var value = props.value || props.defaultValue || getNow();
          return {
            value: value,
            selectedValue: props.selectedValue || props.defaultSelectedValue
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          var value = nextProps.value;
          var selectedValue = nextProps.selectedValue;

          if ('value' in nextProps) {
            value = value || nextProps.defaultValue || getNowByCurrentStateValue(this.state.value);
            this.setState({
              value: value
            });
          }

          if ('selectedValue' in nextProps) {
            this.setState({
              selectedValue: selectedValue
            });
          }
        },
        onSelect: function onSelect(value, cause) {
          if (value) {
            this.setValue(value);
          }

          this.setSelectedValue(value, cause);
        },
        renderRoot: function renderRoot(newProps) {
          var _className;

          var props = this.props;
          var prefixCls = props.prefixCls;
          var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);
          return _react2['default'].createElement('div', {
            ref: this.saveRoot,
            className: '' + (0, _classnames2['default'])(className),
            style: this.props.style,
            tabIndex: '0',
            onKeyDown: this.onKeyDown
          }, newProps.children);
        },
        setSelectedValue: function setSelectedValue(selectedValue, cause) {
          // if (this.isAllowedDate(selectedValue)) {
          if (!('selectedValue' in this.props)) {
            this.setState({
              selectedValue: selectedValue
            });
          }

          this.props.onSelect(selectedValue, cause); // }
        },
        setValue: function setValue(value) {
          var originalValue = this.state.value;

          if (!('value' in this.props)) {
            this.setState({
              value: value
            });
          }

          if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
            this.props.onChange(value);
          }
        },
        isAllowedDate: function isAllowedDate(value) {
          var disabledDate = this.props.disabledDate;
          var disabledTime = this.props.disabledTime;
          return (0, _index.isAllowedDate)(value, disabledDate, disabledTime);
        }
      };
      exports['default'] = CalendarMixin;
      module.exports = exports['default'];
      /***/
    },
    /* 847 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _reactDom = __webpack_require__(16);

      var _reactDom2 = _interopRequireDefault(_reactDom);

      var _createReactClass = __webpack_require__(32);

      var _createReactClass2 = _interopRequireDefault(_createReactClass);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _mapSelf = __webpack_require__(427);

      var _mapSelf2 = _interopRequireDefault(_mapSelf);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _TodayButton = __webpack_require__(426);

      var _TodayButton2 = _interopRequireDefault(_TodayButton);

      var _OkButton = __webpack_require__(425);

      var _OkButton2 = _interopRequireDefault(_OkButton);

      var _TimePickerButton = __webpack_require__(424);

      var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var CalendarFooter = (0, _createReactClass2['default'])({
        displayName: 'CalendarFooter',
        propTypes: {
          prefixCls: _propTypes2['default'].string,
          showDateInput: _propTypes2['default'].bool,
          disabledTime: _propTypes2['default'].any,
          timePicker: _propTypes2['default'].element,
          selectedValue: _propTypes2['default'].any,
          showOk: _propTypes2['default'].bool,
          onSelect: _propTypes2['default'].func,
          value: _propTypes2['default'].object,
          renderFooter: _propTypes2['default'].func,
          defaultValue: _propTypes2['default'].object
        },
        onSelect: function onSelect(value) {
          this.props.onSelect(value);
        },
        getRootDOMNode: function getRootDOMNode() {
          return _reactDom2['default'].findDOMNode(this);
        },
        render: function render() {
          var props = this.props;
          var value = props.value,
              prefixCls = props.prefixCls,
              showOk = props.showOk,
              timePicker = props.timePicker,
              renderFooter = props.renderFooter;
          var footerEl = null;
          var extraFooter = renderFooter();

          if (props.showToday || timePicker || extraFooter) {
            var _cx;

            var nowEl = void 0;

            if (props.showToday) {
              nowEl = _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, {
                value: value
              }));
            }

            var okBtn = void 0;

            if (showOk === true || showOk !== false && !!props.timePicker) {
              okBtn = _react2['default'].createElement(_OkButton2['default'], props);
            }

            var timePickerBtn = void 0;

            if (!!props.timePicker) {
              timePickerBtn = _react2['default'].createElement(_TimePickerButton2['default'], props);
            }

            var footerBtn = void 0;

            if (nowEl || timePickerBtn || okBtn) {
              footerBtn = _react2['default'].createElement('span', {
                className: prefixCls + '-footer-btn'
              }, (0, _mapSelf2['default'])([nowEl, timePickerBtn, okBtn]));
            }

            var cls = (0, _classnames2['default'])((_cx = {}, _cx[prefixCls + '-footer'] = true, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
            footerEl = _react2['default'].createElement('div', {
              className: cls
            }, extraFooter, footerBtn);
          }

          return footerEl;
        }
      });
      exports['default'] = CalendarFooter;
      module.exports = exports['default'];
      /***/
    },
    /* 848 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var ROW = 4;
      var COL = 3;

      function goYear(direction) {
        var next = this.state.value.clone();
        next.add(direction, 'years');
        this.setState({
          value: next
        });
      }

      function chooseDecade(year, event) {
        var next = this.state.value.clone();
        next.year(year);
        next.month(this.state.value.month());
        this.props.onSelect(next);
        event.preventDefault();
      }

      var DecadePanel = function (_React$Component) {
        (0, _inherits3['default'])(DecadePanel, _React$Component);

        function DecadePanel(props) {
          (0, _classCallCheck3['default'])(this, DecadePanel);

          var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

          _this.state = {
            value: props.value || props.defaultValue
          }; // bind methods

          _this.prefixCls = props.rootPrefixCls + '-decade-panel';
          _this.nextCentury = goYear.bind(_this, 100);
          _this.previousCentury = goYear.bind(_this, -100);
          return _this;
        }

        DecadePanel.prototype.render = function render() {
          var _this2 = this;

          var value = this.state.value;
          var locale = this.props.locale;
          var currentYear = value.year();
          var startYear = parseInt(currentYear / 100, 10) * 100;
          var preYear = startYear - 10;
          var endYear = startYear + 99;
          var decades = [];
          var index = 0;
          var prefixCls = this.prefixCls;

          for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
            decades[rowIndex] = [];

            for (var colIndex = 0; colIndex < COL; colIndex++) {
              var startDecade = preYear + index * 10;
              var endDecade = preYear + index * 10 + 9;
              decades[rowIndex][colIndex] = {
                startDecade: startDecade,
                endDecade: endDecade
              };
              index++;
            }
          }

          var decadesEls = decades.map(function (row, decadeIndex) {
            var tds = row.map(function (decadeData) {
              var _classNameMap;

              var dStartDecade = decadeData.startDecade;
              var dEndDecade = decadeData.endDecade;
              var isLast = dStartDecade < startYear;
              var isNext = dEndDecade > endYear;
              var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
              var content = dStartDecade + '-' + dEndDecade;
              var clickHandler = void 0;

              if (isLast) {
                clickHandler = _this2.previousCentury;
              } else if (isNext) {
                clickHandler = _this2.nextCentury;
              } else {
                clickHandler = chooseDecade.bind(_this2, dStartDecade);
              }

              return _react2['default'].createElement('td', {
                key: dStartDecade,
                onClick: clickHandler,
                role: 'gridcell',
                className: (0, _classnames2['default'])(classNameMap)
              }, _react2['default'].createElement('a', {
                className: prefixCls + '-decade'
              }, content));
            });
            return _react2['default'].createElement('tr', {
              key: decadeIndex,
              role: 'row'
            }, tds);
          });
          return _react2['default'].createElement('div', {
            className: this.prefixCls
          }, _react2['default'].createElement('div', {
            className: prefixCls + '-header'
          }, _react2['default'].createElement('a', {
            className: prefixCls + '-prev-century-btn',
            role: 'button',
            onClick: this.previousCentury,
            title: locale.previousCentury
          }), _react2['default'].createElement('div', {
            className: prefixCls + '-century'
          }, startYear, '-', endYear), _react2['default'].createElement('a', {
            className: prefixCls + '-next-century-btn',
            role: 'button',
            onClick: this.nextCentury,
            title: locale.nextCentury
          })), _react2['default'].createElement('div', {
            className: prefixCls + '-body'
          }, _react2['default'].createElement('table', {
            className: prefixCls + '-table',
            cellSpacing: '0',
            role: 'grid'
          }, _react2['default'].createElement('tbody', {
            className: prefixCls + '-tbody'
          }, decadesEls))));
        };

        return DecadePanel;
      }(_react2['default'].Component);

      exports['default'] = DecadePanel;
      DecadePanel.propTypes = {
        locale: _propTypes2['default'].object,
        value: _propTypes2['default'].object,
        defaultValue: _propTypes2['default'].object,
        rootPrefixCls: _propTypes2['default'].string
      };
      DecadePanel.defaultProps = {
        onSelect: function onSelect() {}
      };
      module.exports = exports['default'];
      /***/
    },
    /* 849 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var ROW = 4;
      var COL = 3;

      function goYear(direction) {
        var value = this.state.value.clone();
        value.add(direction, 'year');
        this.setState({
          value: value
        });
      }

      function chooseYear(year) {
        var value = this.state.value.clone();
        value.year(year);
        value.month(this.state.value.month());
        this.props.onSelect(value);
      }

      var YearPanel = function (_React$Component) {
        (0, _inherits3['default'])(YearPanel, _React$Component);

        function YearPanel(props) {
          (0, _classCallCheck3['default'])(this, YearPanel);

          var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

          _this.prefixCls = props.rootPrefixCls + '-year-panel';
          _this.state = {
            value: props.value || props.defaultValue
          };
          _this.nextDecade = goYear.bind(_this, 10);
          _this.previousDecade = goYear.bind(_this, -10);
          return _this;
        }

        YearPanel.prototype.years = function years() {
          var value = this.state.value;
          var currentYear = value.year();
          var startYear = parseInt(currentYear / 10, 10) * 10;
          var previousYear = startYear - 1;
          var years = [];
          var index = 0;

          for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
            years[rowIndex] = [];

            for (var colIndex = 0; colIndex < COL; colIndex++) {
              var year = previousYear + index;
              var content = String(year);
              years[rowIndex][colIndex] = {
                content: content,
                year: year,
                title: content
              };
              index++;
            }
          }

          return years;
        };

        YearPanel.prototype.render = function render() {
          var _this2 = this;

          var props = this.props;
          var value = this.state.value;
          var locale = props.locale;
          var years = this.years();
          var currentYear = value.year();
          var startYear = parseInt(currentYear / 10, 10) * 10;
          var endYear = startYear + 9;
          var prefixCls = this.prefixCls;
          var yeasEls = years.map(function (row, index) {
            var tds = row.map(function (yearData) {
              var _classNameMap;

              var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
              var clickHandler = void 0;

              if (yearData.year < startYear) {
                clickHandler = _this2.previousDecade;
              } else if (yearData.year > endYear) {
                clickHandler = _this2.nextDecade;
              } else {
                clickHandler = chooseYear.bind(_this2, yearData.year);
              }

              return _react2['default'].createElement('td', {
                role: 'gridcell',
                title: yearData.title,
                key: yearData.content,
                onClick: clickHandler,
                className: (0, _classnames2['default'])(classNameMap)
              }, _react2['default'].createElement('a', {
                className: prefixCls + '-year'
              }, yearData.content));
            });
            return _react2['default'].createElement('tr', {
              key: index,
              role: 'row'
            }, tds);
          });
          return _react2['default'].createElement('div', {
            className: this.prefixCls
          }, _react2['default'].createElement('div', null, _react2['default'].createElement('div', {
            className: prefixCls + '-header'
          }, _react2['default'].createElement('a', {
            className: prefixCls + '-prev-decade-btn',
            role: 'button',
            onClick: this.previousDecade,
            title: locale.previousDecade
          }), _react2['default'].createElement('a', {
            className: prefixCls + '-decade-select',
            role: 'button',
            onClick: props.onDecadePanelShow,
            title: locale.decadeSelect
          }, _react2['default'].createElement('span', {
            className: prefixCls + '-decade-select-content'
          }, startYear, '-', endYear), _react2['default'].createElement('span', {
            className: prefixCls + '-decade-select-arrow'
          }, 'x')), _react2['default'].createElement('a', {
            className: prefixCls + '-next-decade-btn',
            role: 'button',
            onClick: this.nextDecade,
            title: locale.nextDecade
          })), _react2['default'].createElement('div', {
            className: prefixCls + '-body'
          }, _react2['default'].createElement('table', {
            className: prefixCls + '-table',
            cellSpacing: '0',
            role: 'grid'
          }, _react2['default'].createElement('tbody', {
            className: prefixCls + '-tbody'
          }, yeasEls)))));
        };

        return YearPanel;
      }(_react2['default'].Component);

      exports['default'] = YearPanel;
      YearPanel.propTypes = {
        rootPrefixCls: _propTypes2['default'].string,
        value: _propTypes2['default'].object,
        defaultValue: _propTypes2['default'].object
      };
      YearPanel.defaultProps = {
        onSelect: function onSelect() {}
      };
      module.exports = exports['default'];
      /***/
    },
    /* 850 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _index = __webpack_require__(172);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var ROW = 4;
      var COL = 3;

      function chooseMonth(month) {
        var next = this.state.value.clone();
        next.month(month);
        this.setAndSelectValue(next);
      }

      function noop() {}

      var MonthTable = function (_Component) {
        (0, _inherits3['default'])(MonthTable, _Component);

        function MonthTable(props) {
          (0, _classCallCheck3['default'])(this, MonthTable);

          var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));

          _this.state = {
            value: props.value
          };
          return _this;
        }

        MonthTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          if ('value' in nextProps) {
            this.setState({
              value: nextProps.value
            });
          }
        };

        MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
          this.setState({
            value: value
          });
          this.props.onSelect(value);
        };

        MonthTable.prototype.months = function months() {
          var value = this.state.value;
          var current = value.clone();
          var months = [];
          var index = 0;

          for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
            months[rowIndex] = [];

            for (var colIndex = 0; colIndex < COL; colIndex++) {
              current.month(index);
              var content = (0, _index.getMonthName)(current);
              months[rowIndex][colIndex] = {
                value: index,
                content: content,
                title: content
              };
              index++;
            }
          }

          return months;
        };

        MonthTable.prototype.render = function render() {
          var _this2 = this;

          var props = this.props;
          var value = this.state.value;
          var today = (0, _index.getTodayTime)(value);
          var months = this.months();
          var currentMonth = value.month();
          var prefixCls = props.prefixCls,
              locale = props.locale,
              contentRender = props.contentRender,
              cellRender = props.cellRender;
          var monthsEls = months.map(function (month, index) {
            var tds = month.map(function (monthData) {
              var _classNameMap;

              var disabled = false;

              if (props.disabledDate) {
                var testValue = value.clone();
                testValue.month(monthData.value);
                disabled = props.disabledDate(testValue);
              }

              var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
              var cellEl = void 0;

              if (cellRender) {
                var currentValue = value.clone();
                currentValue.month(monthData.value);
                cellEl = cellRender(currentValue, locale);
              } else {
                var content = void 0;

                if (contentRender) {
                  var _currentValue = value.clone();

                  _currentValue.month(monthData.value);

                  content = contentRender(_currentValue, locale);
                } else {
                  content = monthData.content;
                }

                cellEl = _react2['default'].createElement('a', {
                  className: prefixCls + '-month'
                }, content);
              }

              return _react2['default'].createElement('td', {
                role: 'gridcell',
                key: monthData.value,
                onClick: disabled ? null : chooseMonth.bind(_this2, monthData.value),
                title: monthData.title,
                className: (0, _classnames2['default'])(classNameMap)
              }, cellEl);
            });
            return _react2['default'].createElement('tr', {
              key: index,
              role: 'row'
            }, tds);
          });
          return _react2['default'].createElement('table', {
            className: prefixCls + '-table',
            cellSpacing: '0',
            role: 'grid'
          }, _react2['default'].createElement('tbody', {
            className: prefixCls + '-tbody'
          }, monthsEls));
        };

        return MonthTable;
      }(_react.Component);

      MonthTable.defaultProps = {
        onSelect: noop
      };
      MonthTable.propTypes = {
        onSelect: _propTypes2['default'].func,
        cellRender: _propTypes2['default'].func,
        prefixCls: _propTypes2['default'].string,
        value: _propTypes2['default'].object
      };
      exports['default'] = MonthTable;
      module.exports = exports['default'];
      /***/
    },
    /* 851 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _createReactClass = __webpack_require__(32);

      var _createReactClass2 = _interopRequireDefault(_createReactClass);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _MonthTable = __webpack_require__(850);

      var _MonthTable2 = _interopRequireDefault(_MonthTable);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function goYear(direction) {
        var next = this.state.value.clone();
        next.add(direction, 'year');
        this.setAndChangeValue(next);
      }

      function noop() {}

      var MonthPanel = (0, _createReactClass2['default'])({
        displayName: 'MonthPanel',
        propTypes: {
          onChange: _propTypes2['default'].func,
          disabledDate: _propTypes2['default'].func,
          onSelect: _propTypes2['default'].func
        },
        getDefaultProps: function getDefaultProps() {
          return {
            onChange: noop,
            onSelect: noop
          };
        },
        getInitialState: function getInitialState() {
          var props = this.props; // bind methods

          this.nextYear = goYear.bind(this, 1);
          this.previousYear = goYear.bind(this, -1);
          this.prefixCls = props.rootPrefixCls + '-month-panel';
          return {
            value: props.value || props.defaultValue
          };
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
          if ('value' in nextProps) {
            this.setState({
              value: nextProps.value
            });
          }
        },
        setAndChangeValue: function setAndChangeValue(value) {
          this.setValue(value);
          this.props.onChange(value);
        },
        setAndSelectValue: function setAndSelectValue(value) {
          this.setValue(value);
          this.props.onSelect(value);
        },
        setValue: function setValue(value) {
          if (!('value' in this.props)) {
            this.setState({
              value: value
            });
          }
        },
        render: function render() {
          var props = this.props;
          var value = this.state.value;
          var cellRender = props.cellRender;
          var contentRender = props.contentRender;
          var locale = props.locale;
          var year = value.year();
          var prefixCls = this.prefixCls;
          return _react2['default'].createElement('div', {
            className: prefixCls,
            style: props.style
          }, _react2['default'].createElement('div', null, _react2['default'].createElement('div', {
            className: prefixCls + '-header'
          }, _react2['default'].createElement('a', {
            className: prefixCls + '-prev-year-btn',
            role: 'button',
            onClick: this.previousYear,
            title: locale.previousYear
          }), _react2['default'].createElement('a', {
            className: prefixCls + '-year-select',
            role: 'button',
            onClick: props.onYearPanelShow,
            title: locale.yearSelect
          }, _react2['default'].createElement('span', {
            className: prefixCls + '-year-select-content'
          }, year), _react2['default'].createElement('span', {
            className: prefixCls + '-year-select-arrow'
          }, 'x')), _react2['default'].createElement('a', {
            className: prefixCls + '-next-year-btn',
            role: 'button',
            onClick: this.nextYear,
            title: locale.nextYear
          })), _react2['default'].createElement('div', {
            className: prefixCls + '-body'
          }, _react2['default'].createElement(_MonthTable2['default'], {
            disabledDate: props.disabledDate,
            onSelect: this.setAndSelectValue,
            locale: locale,
            value: value,
            cellRender: cellRender,
            contentRender: contentRender,
            prefixCls: prefixCls
          }))));
        }
      });
      exports['default'] = MonthPanel;
      module.exports = exports['default'];
      /***/
    },
    /* 852 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _reactDom = __webpack_require__(16);

      var ReactDOM = _interopRequireWildcard(_reactDom);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var InputElement = function (_React$Component) {
        (0, _inherits3['default'])(InputElement, _React$Component);

        function InputElement() {
          (0, _classCallCheck3['default'])(this, InputElement);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (InputElement.__proto__ || Object.getPrototypeOf(InputElement)).apply(this, arguments));

          _this.focus = function () {
            _this.ele.focus ? _this.ele.focus() : ReactDOM.findDOMNode(_this.ele).focus();
          };

          _this.blur = function () {
            _this.ele.blur ? _this.ele.blur() : ReactDOM.findDOMNode(_this.ele).blur();
          };

          _this.saveRef = function (ele) {
            _this.ele = ele;
            var childRef = _this.props.children.ref;

            if (typeof childRef === 'function') {
              childRef(ele);
            }
          };

          return _this;
        }

        (0, _createClass3['default'])(InputElement, [{
          key: 'render',
          value: function render() {
            return React.cloneElement(this.props.children, (0, _extends3['default'])({}, this.props, {
              ref: this.saveRef
            }), null);
          }
        }]);
        return InputElement;
      }(React.Component);

      exports['default'] = InputElement;
      module.exports = exports['default'];
      /***/
    },
    /* 853 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports['default'] = calculateNodeHeight; // Thanks to https://github.com/andreypopp/react-textarea-autosize/

      /**
       * calculateNodeHeight(uiTextNode, useCache = false)
       */

      var HIDDEN_TEXTAREA_STYLE = '\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
      var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
      var computedStyleCache = {};
      var hiddenTextarea = void 0;

      function calculateNodeStyling(node) {
        var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

        if (useCache && computedStyleCache[nodeRef]) {
          return computedStyleCache[nodeRef];
        }

        var style = window.getComputedStyle(node);
        var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
        var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
        var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
        var sizingStyle = SIZING_STYLE.map(function (name) {
          return name + ':' + style.getPropertyValue(name);
        }).join(';');
        var nodeInfo = {
          sizingStyle: sizingStyle,
          paddingSize: paddingSize,
          borderSize: borderSize,
          boxSizing: boxSizing
        };

        if (useCache && nodeRef) {
          computedStyleCache[nodeRef] = nodeInfo;
        }

        return nodeInfo;
      }

      function calculateNodeHeight(uiTextNode) {
        var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        if (!hiddenTextarea) {
          hiddenTextarea = document.createElement('textarea');
          document.body.appendChild(hiddenTextarea);
        } // Fix wrap="off" issue
        // https://github.com/ant-design/ant-design/issues/6577


        if (uiTextNode.getAttribute('wrap')) {
          hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
        } else {
          hiddenTextarea.removeAttribute('wrap');
        } // Copy all CSS properties that have an impact on the height of the content in
        // the textbox


        var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
            paddingSize = _calculateNodeStyling.paddingSize,
            borderSize = _calculateNodeStyling.borderSize,
            boxSizing = _calculateNodeStyling.boxSizing,
            sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
        // text-lines will not calculated properly as the shadow will technically be
        // narrower for content


        hiddenTextarea.setAttribute('style', sizingStyle + ';' + HIDDEN_TEXTAREA_STYLE);
        hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
        var minHeight = Number.MIN_SAFE_INTEGER;
        var maxHeight = Number.MAX_SAFE_INTEGER;
        var height = hiddenTextarea.scrollHeight;
        var overflowY = void 0;

        if (boxSizing === 'border-box') {
          // border-box: add border, since height = content + padding + border
          height = height + borderSize;
        } else if (boxSizing === 'content-box') {
          // remove padding, since height = content
          height = height - paddingSize;
        }

        if (minRows !== null || maxRows !== null) {
          // measure height of a textarea with a single row
          hiddenTextarea.value = ' ';
          var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

          if (minRows !== null) {
            minHeight = singleRowHeight * minRows;

            if (boxSizing === 'border-box') {
              minHeight = minHeight + paddingSize + borderSize;
            }

            height = Math.max(minHeight, height);
          }

          if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;

            if (boxSizing === 'border-box') {
              maxHeight = maxHeight + paddingSize + borderSize;
            }

            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
          }
        } // Remove scroll bar flash when autosize without maxRows


        if (!maxRows) {
          overflowY = 'hidden';
        }

        return {
          height: height,
          minHeight: minHeight,
          maxHeight: maxHeight,
          overflowY: overflowY
        };
      }

      module.exports = exports['default'];
      /***/
    },
    /* 854 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _omit = __webpack_require__(45);

      var _omit2 = _interopRequireDefault(_omit);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _calculateNodeHeight = __webpack_require__(853);

      var _calculateNodeHeight2 = _interopRequireDefault(_calculateNodeHeight);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      function onNextFrame(cb) {
        if (window.requestAnimationFrame) {
          return window.requestAnimationFrame(cb);
        }

        return window.setTimeout(cb, 1);
      }

      function clearNextFrameAction(nextFrameId) {
        if (window.cancelAnimationFrame) {
          window.cancelAnimationFrame(nextFrameId);
        } else {
          window.clearTimeout(nextFrameId);
        }
      }

      var TextArea = function (_React$Component) {
        (0, _inherits3['default'])(TextArea, _React$Component);

        function TextArea() {
          (0, _classCallCheck3['default'])(this, TextArea);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).apply(this, arguments));

          _this.state = {
            textareaStyles: {}
          };

          _this.resizeTextarea = function () {
            var autosize = _this.props.autosize;

            if (!autosize || !_this.textAreaRef) {
              return;
            }

            var minRows = autosize ? autosize.minRows : null;
            var maxRows = autosize ? autosize.maxRows : null;
            var textareaStyles = (0, _calculateNodeHeight2['default'])(_this.textAreaRef, false, minRows, maxRows);

            _this.setState({
              textareaStyles: textareaStyles
            });
          };

          _this.handleTextareaChange = function (e) {
            if (!('value' in _this.props)) {
              _this.resizeTextarea();
            }

            var onChange = _this.props.onChange;

            if (onChange) {
              onChange(e);
            }
          };

          _this.handleKeyDown = function (e) {
            var _this$props = _this.props,
                onPressEnter = _this$props.onPressEnter,
                onKeyDown = _this$props.onKeyDown;

            if (e.keyCode === 13 && onPressEnter) {
              onPressEnter(e);
            }

            if (onKeyDown) {
              onKeyDown(e);
            }
          };

          _this.saveTextAreaRef = function (textArea) {
            _this.textAreaRef = textArea;
          };

          return _this;
        }

        (0, _createClass3['default'])(TextArea, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.resizeTextarea();
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            // Re-render with the new content then recalculate the height as required.
            if (this.props.value !== nextProps.value) {
              if (this.nextFrameActionId) {
                clearNextFrameAction(this.nextFrameActionId);
              }

              this.nextFrameActionId = onNextFrame(this.resizeTextarea);
            }
          }
        }, {
          key: 'focus',
          value: function focus() {
            this.textAreaRef.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.textAreaRef.blur();
          }
        }, {
          key: 'getTextAreaClassName',
          value: function getTextAreaClassName() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                disabled = _props.disabled;
            return (0, _classnames2['default'])(prefixCls, className, (0, _defineProperty3['default'])({}, prefixCls + '-disabled', disabled));
          }
        }, {
          key: 'render',
          value: function render() {
            var props = this.props;
            var otherProps = (0, _omit2['default'])(props, ['prefixCls', 'onPressEnter', 'autosize']);
            var style = (0, _extends3['default'])({}, props.style, this.state.textareaStyles); // Fix https://github.com/ant-design/ant-design/issues/6776
            // Make sure it could be reset when using form.getFieldDecorator

            if ('value' in otherProps) {
              otherProps.value = otherProps.value || '';
            }

            return React.createElement('textarea', (0, _extends3['default'])({}, otherProps, {
              className: this.getTextAreaClassName(),
              style: style,
              onKeyDown: this.handleKeyDown,
              onChange: this.handleTextareaChange,
              ref: this.saveTextAreaRef
            }));
          }
        }]);
        return TextArea;
      }(React.Component);

      exports['default'] = TextArea;
      TextArea.defaultProps = {
        prefixCls: 'ant-input'
      };
      module.exports = exports['default'];
      /***/
    },
    /* 855 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _Input = __webpack_require__(430);

      var _Input2 = _interopRequireDefault(_Input);

      var _icon = __webpack_require__(126);

      var _icon2 = _interopRequireDefault(_icon);

      var _button = __webpack_require__(318);

      var _button2 = _interopRequireDefault(_button);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var __rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var Search = function (_React$Component) {
        (0, _inherits3['default'])(Search, _React$Component);

        function Search() {
          (0, _classCallCheck3['default'])(this, Search);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));

          _this.onSearch = function () {
            var onSearch = _this.props.onSearch;

            if (onSearch) {
              onSearch(_this.input.input.value);
            }

            _this.input.focus();
          };

          _this.saveInput = function (node) {
            _this.input = node;
          };

          return _this;
        }

        (0, _createClass3['default'])(Search, [{
          key: 'focus',
          value: function focus() {
            this.input.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.input.blur();
          }
        }, {
          key: 'getButtonOrIcon',
          value: function getButtonOrIcon() {
            var _props = this.props,
                enterButton = _props.enterButton,
                prefixCls = _props.prefixCls,
                size = _props.size;

            if (!enterButton) {
              return React.createElement(_icon2['default'], {
                className: prefixCls + '-icon',
                type: 'search',
                key: 'searchIcon'
              });
            }

            var enterButtonAsElement = enterButton;

            if (enterButtonAsElement.type === _button2['default'] || enterButtonAsElement.type === 'button') {
              return React.cloneElement(enterButtonAsElement, enterButtonAsElement.type === _button2['default'] ? {
                className: prefixCls + '-button',
                size: size,
                onClick: this.onSearch
              } : {
                onClick: this.onSearch
              });
            }

            return React.createElement(_button2['default'], {
              className: prefixCls + '-button',
              type: 'primary',
              size: size,
              onClick: this.onSearch,
              key: 'enterButton'
            }, enterButton === true ? React.createElement(_icon2['default'], {
              type: 'search'
            }) : enterButton);
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _a = this.props,
                className = _a.className,
                prefixCls = _a.prefixCls,
                inputPrefixCls = _a.inputPrefixCls,
                size = _a.size,
                suffix = _a.suffix,
                enterButton = _a.enterButton,
                others = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "suffix", "enterButton"]);

            delete others.onSearch;
            var buttonOrIcon = this.getButtonOrIcon();
            var searchSuffix = suffix ? [suffix, buttonOrIcon] : buttonOrIcon;
            var inputClassName = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-enter-button', !!enterButton), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, !!size), _classNames));
            return React.createElement(_Input2['default'], (0, _extends3['default'])({
              onPressEnter: this.onSearch
            }, others, {
              size: size,
              className: inputClassName,
              prefixCls: inputPrefixCls,
              suffix: searchSuffix,
              ref: this.saveInput
            }));
          }
        }]);
        return Search;
      }(React.Component);

      exports['default'] = Search;
      Search.defaultProps = {
        inputPrefixCls: 'ant-input',
        prefixCls: 'ant-input-search',
        enterButton: false
      };
      module.exports = exports['default'];
      /***/
    },
    /* 856 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var Group = function Group(props) {
        var _classNames;

        var _props$prefixCls = props.prefixCls,
            prefixCls = _props$prefixCls === undefined ? 'ant-input-group' : _props$prefixCls,
            _props$className = props.className,
            className = _props$className === undefined ? '' : _props$className;
        var cls = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', props.size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-compact', props.compact), _classNames), className);
        return React.createElement('span', {
          className: cls,
          style: props.style
        }, props.children);
      };

      exports['default'] = Group;
      module.exports = exports['default'];
      /***/
    },
    /* 857 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _Input = __webpack_require__(430);

      var _Input2 = _interopRequireDefault(_Input);

      var _Group = __webpack_require__(856);

      var _Group2 = _interopRequireDefault(_Group);

      var _Search = __webpack_require__(855);

      var _Search2 = _interopRequireDefault(_Search);

      var _TextArea = __webpack_require__(854);

      var _TextArea2 = _interopRequireDefault(_TextArea);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      _Input2['default'].Group = _Group2['default'];
      _Input2['default'].Search = _Search2['default'];
      _Input2['default'].TextArea = _TextArea2['default'];
      exports['default'] = _Input2['default'];
      module.exports = exports['default'];
      /***/
    },
    /* 858 */

    /***/
    function (module, exports) {
      /**
       * The base implementation of `_.clamp` which doesn't coerce arguments.
       *
       * @private
       * @param {number} number The number to clamp.
       * @param {number} [lower] The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the clamped number.
       */
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined) {
            number = number <= upper ? number : upper;
          }

          if (lower !== undefined) {
            number = number >= lower ? number : lower;
          }
        }

        return number;
      }

      module.exports = baseClamp;
      /***/
    },
    /* 859 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _Upload = __webpack_require__(433);

      var _Upload2 = _interopRequireDefault(_Upload);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var Dragger = function (_React$Component) {
        (0, _inherits3['default'])(Dragger, _React$Component);

        function Dragger() {
          (0, _classCallCheck3['default'])(this, Dragger);
          return (0, _possibleConstructorReturn3['default'])(this, (Dragger.__proto__ || Object.getPrototypeOf(Dragger)).apply(this, arguments));
        }

        (0, _createClass3['default'])(Dragger, [{
          key: 'render',
          value: function render() {
            var props = this.props;
            return React.createElement(_Upload2['default'], (0, _extends3['default'])({}, props, {
              type: 'drag',
              style: (0, _extends3['default'])({}, props.style, {
                height: props.height
              })
            }));
          }
        }]);
        return Dragger;
      }(React.Component);

      exports['default'] = Dragger;
      module.exports = exports['default'];
      /***/
    },
    /* 860 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.T = T;
      exports.fileToObject = fileToObject;
      exports.genPercentAdd = genPercentAdd;
      exports.getFileItem = getFileItem;
      exports.removeFileItem = removeFileItem;

      function T() {
        return true;
      } // Fix IE file.status problem
      // via coping a new Object


      function fileToObject(file) {
        return {
          lastModified: file.lastModified,
          lastModifiedDate: file.lastModifiedDate,
          name: file.filename || file.name,
          size: file.size,
          type: file.type,
          uid: file.uid,
          response: file.response,
          error: file.error,
          percent: 0,
          originFileObj: file
        };
      }
      /**
       * 生成Progress percent: 0.1 -> 0.98
       *   - for ie
       */


      function genPercentAdd() {
        var k = 0.1;
        var i = 0.01;
        var end = 0.98;
        return function (s) {
          var start = s;

          if (start >= end) {
            return start;
          }

          start += k;
          k = k - i;

          if (k < 0.001) {
            k = 0.001;
          }

          return start * 100;
        };
      }

      function getFileItem(file, fileList) {
        var matchKey = file.uid !== undefined ? 'uid' : 'name';
        return fileList.filter(function (item) {
          return item[matchKey] === file[matchKey];
        })[0];
      }

      function removeFileItem(file, fileList) {
        var matchKey = file.uid !== undefined ? 'uid' : 'name';
        var removed = fileList.filter(function (item) {
          return item[matchKey] !== file[matchKey];
        });

        if (removed.length === fileList.length) {
          return null;
        }

        return removed;
      }
      /***/

    },
    /* 861 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _icon = __webpack_require__(126);

      var _icon2 = _interopRequireDefault(_icon);

      var _rcProgress = __webpack_require__(376);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var __rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var statusColorMap = {
        normal: '#108ee9',
        exception: '#ff5500',
        success: '#87d068'
      };

      var Progress = function (_React$Component) {
        (0, _inherits3['default'])(Progress, _React$Component);

        function Progress() {
          (0, _classCallCheck3['default'])(this, Progress);
          return (0, _possibleConstructorReturn3['default'])(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
        }

        (0, _createClass3['default'])(Progress, [{
          key: 'render',
          value: function render() {
            var _classNames;

            var props = this.props;

            var prefixCls = props.prefixCls,
                className = props.className,
                _props$percent = props.percent,
                percent = _props$percent === undefined ? 0 : _props$percent,
                status = props.status,
                format = props.format,
                trailColor = props.trailColor,
                size = props.size,
                successPercent = props.successPercent,
                type = props.type,
                strokeWidth = props.strokeWidth,
                width = props.width,
                showInfo = props.showInfo,
                _props$gapDegree = props.gapDegree,
                gapDegree = _props$gapDegree === undefined ? 0 : _props$gapDegree,
                gapPosition = props.gapPosition,
                restProps = __rest(props, ["prefixCls", "className", "percent", "status", "format", "trailColor", "size", "successPercent", "type", "strokeWidth", "width", "showInfo", "gapDegree", "gapPosition"]);

            var progressStatus = parseInt(successPercent ? successPercent.toString() : percent.toString(), 10) >= 100 && !('status' in props) ? 'success' : status || 'normal';
            var progressInfo = void 0;
            var progress = void 0;

            var textFormatter = format || function (percentNumber) {
              return percentNumber + '%';
            };

            if (showInfo) {
              var text = void 0;
              var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';

              if (progressStatus === 'exception') {
                text = format ? textFormatter(percent) : React.createElement(_icon2['default'], {
                  type: 'cross' + iconType
                });
              } else if (progressStatus === 'success') {
                text = format ? textFormatter(percent) : React.createElement(_icon2['default'], {
                  type: 'check' + iconType
                });
              } else {
                text = textFormatter(percent);
              }

              progressInfo = React.createElement('span', {
                className: prefixCls + '-text'
              }, text);
            }

            if (type === 'line') {
              var percentStyle = {
                width: percent + '%',
                height: strokeWidth || (size === 'small' ? 6 : 8)
              };
              var successPercentStyle = {
                width: successPercent + '%',
                height: strokeWidth || (size === 'small' ? 6 : 8)
              };
              var successSegment = successPercent !== undefined ? React.createElement('div', {
                className: prefixCls + '-success-bg',
                style: successPercentStyle
              }) : null;
              progress = React.createElement('div', null, React.createElement('div', {
                className: prefixCls + '-outer'
              }, React.createElement('div', {
                className: prefixCls + '-inner'
              }, React.createElement('div', {
                className: prefixCls + '-bg',
                style: percentStyle
              }), successSegment)), progressInfo);
            } else if (type === 'circle' || type === 'dashboard') {
              var circleSize = width || 120;
              var circleStyle = {
                width: circleSize,
                height: circleSize,
                fontSize: circleSize * 0.15 + 6
              };
              var circleWidth = strokeWidth || 6;
              var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
              var gapDeg = gapDegree || type === 'dashboard' && 75;
              progress = React.createElement('div', {
                className: prefixCls + '-inner',
                style: circleStyle
              }, React.createElement(_rcProgress.Circle, {
                percent: percent,
                strokeWidth: circleWidth,
                trailWidth: circleWidth,
                strokeColor: statusColorMap[progressStatus],
                trailColor: trailColor,
                prefixCls: prefixCls,
                gapDegree: gapDeg,
                gapPosition: gapPos
              }), progressInfo);
            }

            var classString = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + (type === 'dashboard' && 'circle' || type), true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-status-' + progressStatus, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-show-info', showInfo), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, size), _classNames), className);
            return React.createElement('div', (0, _extends3['default'])({}, restProps, {
              className: classString
            }), progress);
          }
        }]);
        return Progress;
      }(React.Component);

      exports['default'] = Progress;
      Progress.defaultProps = {
        type: 'line',
        percent: 0,
        showInfo: true,
        trailColor: '#f3f3f3',
        prefixCls: 'ant-progress',
        size: 'default'
      };
      Progress.propTypes = {
        status: _propTypes2['default'].oneOf(['normal', 'exception', 'active', 'success']),
        type: _propTypes2['default'].oneOf(['line', 'circle', 'dashboard']),
        showInfo: _propTypes2['default'].bool,
        percent: _propTypes2['default'].number,
        width: _propTypes2['default'].number,
        strokeWidth: _propTypes2['default'].number,
        trailColor: _propTypes2['default'].string,
        format: _propTypes2['default'].func,
        gapDegree: _propTypes2['default'].number,
        'default': _propTypes2['default'].oneOf(['default', 'small'])
      };
      module.exports = exports['default'];
      /***/
    },
    /* 862 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _progress = __webpack_require__(861);

      var _progress2 = _interopRequireDefault(_progress);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      exports['default'] = _progress2['default'];
      module.exports = exports['default'];
      /***/
    },
    /* 863 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _rcAnimate = __webpack_require__(43);

      var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

      var _icon = __webpack_require__(126);

      var _icon2 = _interopRequireDefault(_icon);

      var _tooltip = __webpack_require__(312);

      var _tooltip2 = _interopRequireDefault(_tooltip);

      var _progress = __webpack_require__(862);

      var _progress2 = _interopRequireDefault(_progress);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      } // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL


      var previewFile = function previewFile(file, callback) {
        var reader = new FileReader();

        reader.onloadend = function () {
          return callback(reader.result);
        };

        reader.readAsDataURL(file);
      };

      var isImageUrl = function isImageUrl(url) {
        return /^data:image\//.test(url) || /\.(webp|svg|png|gif|jpg|jpeg)$/.test(url);
      };

      var UploadList = function (_React$Component) {
        (0, _inherits3['default'])(UploadList, _React$Component);

        function UploadList() {
          (0, _classCallCheck3['default'])(this, UploadList);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (UploadList.__proto__ || Object.getPrototypeOf(UploadList)).apply(this, arguments));

          _this.handleClose = function (file) {
            var onRemove = _this.props.onRemove;

            if (onRemove) {
              onRemove(file);
            }
          };

          _this.handlePreview = function (file, e) {
            var onPreview = _this.props.onPreview;

            if (!onPreview) {
              return;
            }

            e.preventDefault();
            return onPreview(file);
          };

          return _this;
        }

        (0, _createClass3['default'])(UploadList, [{
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            var _this2 = this;

            if (this.props.listType !== 'picture' && this.props.listType !== 'picture-card') {
              return;
            }

            (this.props.items || []).forEach(function (file) {
              if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File) || file.thumbUrl !== undefined) {
                return;
              }
              /*eslint-disable */


              file.thumbUrl = '';
              /*eslint-enable */

              previewFile(file.originFileObj, function (previewDataUrl) {
                /*eslint-disable */
                file.thumbUrl = previewDataUrl;
                /*eslint-enable */

                _this2.forceUpdate();
              });
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var _this3 = this,
                _classNames2;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                _props$items = _props.items,
                items = _props$items === undefined ? [] : _props$items,
                listType = _props.listType,
                showPreviewIcon = _props.showPreviewIcon,
                showRemoveIcon = _props.showRemoveIcon,
                locale = _props.locale;
            var list = items.map(function (file) {
              var _classNames;

              var progress = void 0;
              var icon = React.createElement(_icon2['default'], {
                type: file.status === 'uploading' ? 'loading' : 'paper-clip'
              });

              if (listType === 'picture' || listType === 'picture-card') {
                if (listType === 'picture-card' && file.status === 'uploading') {
                  icon = React.createElement('div', {
                    className: prefixCls + '-list-item-uploading-text'
                  }, locale.uploading);
                } else if (!file.thumbUrl && !file.url) {
                  icon = React.createElement(_icon2['default'], {
                    className: prefixCls + '-list-item-thumbnail',
                    type: 'picture'
                  });
                } else {
                  var thumbnail = isImageUrl(file.thumbUrl || file.url) ? React.createElement('img', {
                    src: file.thumbUrl || file.url,
                    alt: file.name
                  }) : React.createElement(_icon2['default'], {
                    type: 'file',
                    style: {
                      fontSize: 48,
                      color: 'rgba(0,0,0,0.5)'
                    }
                  });
                  icon = React.createElement('a', {
                    className: prefixCls + '-list-item-thumbnail',
                    onClick: function onClick(e) {
                      return _this3.handlePreview(file, e);
                    },
                    href: file.url || file.thumbUrl,
                    target: '_blank',
                    rel: 'noopener noreferrer'
                  }, thumbnail);
                }
              }

              if (file.status === 'uploading') {
                // show loading icon if upload progress listener is disabled
                var loadingProgress = 'percent' in file ? React.createElement(_progress2['default'], (0, _extends3['default'])({
                  type: 'line'
                }, _this3.props.progressAttr, {
                  percent: file.percent
                })) : null;
                progress = React.createElement('div', {
                  className: prefixCls + '-list-item-progress',
                  key: 'progress'
                }, loadingProgress);
              }

              var infoUploadingClass = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-list-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-list-item-' + file.status, true), _classNames));
              var preview = file.url ? React.createElement('a', (0, _extends3['default'])({}, file.linkProps, {
                href: file.url,
                target: '_blank',
                rel: 'noopener noreferrer',
                className: prefixCls + '-list-item-name',
                onClick: function onClick(e) {
                  return _this3.handlePreview(file, e);
                },
                title: file.name
              }), file.name) : React.createElement('span', {
                className: prefixCls + '-list-item-name',
                onClick: function onClick(e) {
                  return _this3.handlePreview(file, e);
                },
                title: file.name
              }, file.name);
              var style = file.url || file.thumbUrl ? undefined : {
                pointerEvents: 'none',
                opacity: 0.5
              };
              var previewIcon = showPreviewIcon ? React.createElement('a', {
                href: file.url || file.thumbUrl,
                target: '_blank',
                rel: 'noopener noreferrer',
                style: style,
                onClick: function onClick(e) {
                  return _this3.handlePreview(file, e);
                },
                title: locale.previewFile
              }, React.createElement(_icon2['default'], {
                type: 'eye-o'
              })) : null;
              var removeIcon = showRemoveIcon ? React.createElement(_icon2['default'], {
                type: 'delete',
                title: locale.removeFile,
                onClick: function onClick() {
                  return _this3.handleClose(file);
                }
              }) : null;
              var removeIconCross = showRemoveIcon ? React.createElement(_icon2['default'], {
                type: 'cross',
                title: locale.removeFile,
                onClick: function onClick() {
                  return _this3.handleClose(file);
                }
              }) : null;
              var actions = listType === 'picture-card' && file.status !== 'uploading' ? React.createElement('span', {
                className: prefixCls + '-list-item-actions'
              }, previewIcon, removeIcon) : removeIconCross;
              var message = void 0;

              if (file.response && typeof file.response === 'string') {
                message = file.response;
              } else {
                message = file.error && file.error.statusText || locale.uploadError;
              }

              var iconAndPreview = file.status === 'error' ? React.createElement(_tooltip2['default'], {
                title: message
              }, icon, preview) : React.createElement('span', null, icon, preview);
              return React.createElement('div', {
                className: infoUploadingClass,
                key: file.uid
              }, React.createElement('div', {
                className: prefixCls + '-list-item-info'
              }, iconAndPreview), actions, React.createElement(_rcAnimate2['default'], {
                transitionName: 'fade',
                component: ''
              }, progress));
            });
            var listClassNames = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-list', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-list-' + listType, true), _classNames2));
            var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
            return React.createElement(_rcAnimate2['default'], {
              transitionName: prefixCls + '-' + animationDirection,
              component: 'div',
              className: listClassNames
            }, list);
          }
        }]);
        return UploadList;
      }(React.Component);

      exports['default'] = UploadList;
      UploadList.defaultProps = {
        listType: 'text',
        progressAttr: {
          strokeWidth: 2,
          showInfo: false
        },
        prefixCls: 'ant-upload',
        showRemoveIcon: true,
        showPreviewIcon: true
      };
      module.exports = exports['default'];
      /***/
    },
    /* 864 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      var autoAdjustOverflow = {
        adjustX: 1,
        adjustY: 1
      };
      var targetOffset = [0, 0];
      var placements = exports.placements = {
        left: {
          points: ['cr', 'cl'],
          overflow: autoAdjustOverflow,
          offset: [-4, 0],
          targetOffset: targetOffset
        },
        right: {
          points: ['cl', 'cr'],
          overflow: autoAdjustOverflow,
          offset: [4, 0],
          targetOffset: targetOffset
        },
        top: {
          points: ['bc', 'tc'],
          overflow: autoAdjustOverflow,
          offset: [0, -4],
          targetOffset: targetOffset
        },
        bottom: {
          points: ['tc', 'bc'],
          overflow: autoAdjustOverflow,
          offset: [0, 4],
          targetOffset: targetOffset
        },
        topLeft: {
          points: ['bl', 'tl'],
          overflow: autoAdjustOverflow,
          offset: [0, -4],
          targetOffset: targetOffset
        },
        leftTop: {
          points: ['tr', 'tl'],
          overflow: autoAdjustOverflow,
          offset: [-4, 0],
          targetOffset: targetOffset
        },
        topRight: {
          points: ['br', 'tr'],
          overflow: autoAdjustOverflow,
          offset: [0, -4],
          targetOffset: targetOffset
        },
        rightTop: {
          points: ['tl', 'tr'],
          overflow: autoAdjustOverflow,
          offset: [4, 0],
          targetOffset: targetOffset
        },
        bottomRight: {
          points: ['tr', 'br'],
          overflow: autoAdjustOverflow,
          offset: [0, 4],
          targetOffset: targetOffset
        },
        rightBottom: {
          points: ['bl', 'br'],
          overflow: autoAdjustOverflow,
          offset: [4, 0],
          targetOffset: targetOffset
        },
        bottomLeft: {
          points: ['tl', 'bl'],
          overflow: autoAdjustOverflow,
          offset: [0, 4],
          targetOffset: targetOffset
        },
        leftBottom: {
          points: ['br', 'bl'],
          overflow: autoAdjustOverflow,
          offset: [-4, 0],
          targetOffset: targetOffset
        }
      };
      exports['default'] = placements;
      /***/
    },
    /* 865 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      exports.getOverflowOptions = getOverflowOptions;
      exports['default'] = getPlacements;

      var _placements = __webpack_require__(864);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var autoAdjustOverflowEnabled = {
        adjustX: 1,
        adjustY: 1
      };
      var autoAdjustOverflowDisabled = {
        adjustX: 0,
        adjustY: 0
      };
      var targetOffset = [0, 0];

      function getOverflowOptions(autoAdjustOverflow) {
        if (typeof autoAdjustOverflow === 'boolean') {
          return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
        }

        return (0, _extends3['default'])({}, autoAdjustOverflowDisabled, autoAdjustOverflow);
      }

      function getPlacements() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _config$arrowWidth = config.arrowWidth,
            arrowWidth = _config$arrowWidth === undefined ? 5 : _config$arrowWidth,
            _config$horizontalArr = config.horizontalArrowShift,
            horizontalArrowShift = _config$horizontalArr === undefined ? 16 : _config$horizontalArr,
            _config$verticalArrow = config.verticalArrowShift,
            verticalArrowShift = _config$verticalArrow === undefined ? 12 : _config$verticalArrow,
            _config$autoAdjustOve = config.autoAdjustOverflow,
            autoAdjustOverflow = _config$autoAdjustOve === undefined ? true : _config$autoAdjustOve;
        var placementMap = {
          left: {
            points: ['cr', 'cl'],
            offset: [-4, 0]
          },
          right: {
            points: ['cl', 'cr'],
            offset: [4, 0]
          },
          top: {
            points: ['bc', 'tc'],
            offset: [0, -4]
          },
          bottom: {
            points: ['tc', 'bc'],
            offset: [0, 4]
          },
          topLeft: {
            points: ['bl', 'tc'],
            offset: [-(horizontalArrowShift + arrowWidth), -4]
          },
          leftTop: {
            points: ['tr', 'cl'],
            offset: [-4, -(verticalArrowShift + arrowWidth)]
          },
          topRight: {
            points: ['br', 'tc'],
            offset: [horizontalArrowShift + arrowWidth, -4]
          },
          rightTop: {
            points: ['tl', 'cr'],
            offset: [4, -(verticalArrowShift + arrowWidth)]
          },
          bottomRight: {
            points: ['tr', 'bc'],
            offset: [horizontalArrowShift + arrowWidth, 4]
          },
          rightBottom: {
            points: ['bl', 'cr'],
            offset: [4, verticalArrowShift + arrowWidth]
          },
          bottomLeft: {
            points: ['tl', 'bc'],
            offset: [-(horizontalArrowShift + arrowWidth), 4]
          },
          leftBottom: {
            points: ['br', 'cl'],
            offset: [-4, verticalArrowShift + arrowWidth]
          }
        };
        Object.keys(placementMap).forEach(function (key) {
          placementMap[key] = config.arrowPointAtCenter ? (0, _extends3['default'])({}, placementMap[key], {
            overflow: getOverflowOptions(autoAdjustOverflow),
            targetOffset: targetOffset
          }) : (0, _extends3['default'])({}, _placements.placements[key], {
            overflow: getOverflowOptions(autoAdjustOverflow)
          });
        });
        return placementMap;
      }
      /***/

    },
    /* 866 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _toConsumableArray2 = __webpack_require__(65);

      var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _shallowequal = __webpack_require__(56);

      var _shallowequal2 = _interopRequireDefault(_shallowequal);

      var _Track = __webpack_require__(436);

      var _Track2 = _interopRequireDefault(_Track);

      var _createSlider = __webpack_require__(435);

      var _createSlider2 = _interopRequireDefault(_createSlider);

      var _utils = __webpack_require__(313);

      var utils = _interopRequireWildcard(_utils);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var Range = function (_React$Component) {
        (0, _inherits3['default'])(Range, _React$Component);

        function Range(props) {
          (0, _classCallCheck3['default'])(this, Range);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

          _this.onEnd = function (force) {
            var handle = _this.state.handle;

            _this.removeDocumentEvents();

            if (handle !== null || force) {
              _this.props.onAfterChange(_this.getValue());
            }

            _this.setState({
              handle: null
            });
          };

          var count = props.count,
              min = props.min,
              max = props.max;
          var initialValue = Array.apply(undefined, (0, _toConsumableArray3['default'])(Array(count + 1))).map(function () {
            return min;
          });
          var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
          var value = props.value !== undefined ? props.value : defaultValue;
          var bounds = value.map(function (v, i) {
            return _this.trimAlignValue(v, i);
          });
          var recent = bounds[0] === max ? 0 : bounds.length - 1;
          _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds
          };
          return _this;
        }

        (0, _createClass3['default'])(Range, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;

            if (this.props.min === nextProps.min && this.props.max === nextProps.max && (0, _shallowequal2['default'])(this.props.value, nextProps.value)) {
              return;
            }

            var bounds = this.state.bounds;
            var value = nextProps.value || bounds;
            var nextBounds = value.map(function (v, i) {
              return _this2.trimAlignValue(v, i, nextProps);
            });
            if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
              return v === bounds[i];
            })) return;
            this.setState({
              bounds: nextBounds
            });

            if (value.some(function (v) {
              return utils.isValueOutOfRange(v, nextProps);
            })) {
              var newValues = value.map(function (v) {
                return utils.ensureValueInRange(v, nextProps);
              });
              this.props.onChange(newValues);
            }
          }
        }, {
          key: 'onChange',
          value: function onChange(state) {
            var props = this.props;
            var isNotControlled = !('value' in props);

            if (isNotControlled) {
              this.setState(state);
            } else {
              var controlledState = {};
              ['handle', 'recent'].forEach(function (item) {
                if (state[item] !== undefined) {
                  controlledState[item] = state[item];
                }
              });

              if (Object.keys(controlledState).length) {
                this.setState(controlledState);
              }
            }

            var data = (0, _extends3['default'])({}, this.state, state);
            var changedValue = data.bounds;
            props.onChange(changedValue);
          }
        }, {
          key: 'onStart',
          value: function onStart(position) {
            var props = this.props;
            var state = this.state;
            var bounds = this.getValue();
            props.onBeforeChange(bounds);
            var value = this.calcValueByPos(position);
            this.startValue = value;
            this.startPosition = position;
            var closestBound = this.getClosestBound(value);
            this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
            this.setState({
              handle: this.prevMovedHandleIndex,
              recent: this.prevMovedHandleIndex
            });
            var prevValue = bounds[this.prevMovedHandleIndex];
            if (value === prevValue) return;
            var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
            nextBounds[this.prevMovedHandleIndex] = value;
            this.onChange({
              bounds: nextBounds
            });
          }
        }, {
          key: 'onMove',
          value: function onMove(e, position) {
            utils.pauseEvent(e);
            var state = this.state;
            var value = this.calcValueByPos(position);
            var oldValue = state.bounds[state.handle];
            if (value === oldValue) return;
            this.moveTo(value);
          }
        }, {
          key: 'onKeyboard',
          value: function onKeyboard(e) {
            var valueMutator = utils.getKeyboardValueMutator(e);

            if (valueMutator) {
              utils.pauseEvent(e);
              var state = this.state,
                  props = this.props;
              var bounds = state.bounds,
                  handle = state.handle;
              var oldValue = bounds[handle === null ? state.recent : handle];
              var mutatedValue = valueMutator(oldValue, props);
              var value = this.trimAlignValue(mutatedValue);
              if (value === oldValue) return;
              var isFromKeyboardEvent = true;
              this.moveTo(value, isFromKeyboardEvent);
            }
          }
        }, {
          key: 'getValue',
          value: function getValue() {
            return this.state.bounds;
          }
        }, {
          key: 'getClosestBound',
          value: function getClosestBound(value) {
            var bounds = this.state.bounds;
            var closestBound = 0;

            for (var i = 1; i < bounds.length - 1; ++i) {
              if (value > bounds[i]) {
                closestBound = i;
              }
            }

            if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
              closestBound += 1;
            }

            return closestBound;
          }
        }, {
          key: 'getBoundNeedMoving',
          value: function getBoundNeedMoving(value, closestBound) {
            var _state = this.state,
                bounds = _state.bounds,
                recent = _state.recent;
            var boundNeedMoving = closestBound;
            var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

            if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
              boundNeedMoving = recent;
            }

            if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
              boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
            }

            return boundNeedMoving;
          }
        }, {
          key: 'getLowerBound',
          value: function getLowerBound() {
            return this.state.bounds[0];
          }
        }, {
          key: 'getUpperBound',
          value: function getUpperBound() {
            var bounds = this.state.bounds;
            return bounds[bounds.length - 1];
          }
          /**
           * Returns an array of possible slider points, taking into account both
           * `marks` and `step`. The result is cached.
           */

        }, {
          key: 'getPoints',
          value: function getPoints() {
            var _props = this.props,
                marks = _props.marks,
                step = _props.step,
                min = _props.min,
                max = _props.max;
            var cache = this._getPointsCache;

            if (!cache || cache.marks !== marks || cache.step !== step) {
              var pointsObject = (0, _extends3['default'])({}, marks);

              if (step !== null) {
                for (var point = min; point <= max; point += step) {
                  pointsObject[point] = point;
                }
              }

              var points = Object.keys(pointsObject).map(parseFloat);
              points.sort(function (a, b) {
                return a - b;
              });
              this._getPointsCache = {
                marks: marks,
                step: step,
                points: points
              };
            }

            return this._getPointsCache.points;
          }
        }, {
          key: 'moveTo',
          value: function moveTo(value, isFromKeyboardEvent) {
            var _this3 = this;

            var state = this.state,
                props = this.props;
            var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
            var handle = state.handle === null ? state.recent : state.handle;
            nextBounds[handle] = value;
            var nextHandle = handle;

            if (props.pushable !== false) {
              this.pushSurroundingHandles(nextBounds, nextHandle);
            } else if (props.allowCross) {
              nextBounds.sort(function (a, b) {
                return a - b;
              });
              nextHandle = nextBounds.indexOf(value);
            }

            this.onChange({
              recent: nextHandle,
              handle: nextHandle,
              bounds: nextBounds
            });

            if (isFromKeyboardEvent) {
              // known problem: because setState is async,
              // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
              // cause onBeforeChange and onAfterChange receive wrong value.
              // here use setState callback to hack，but not elegant
              this.props.onAfterChange(nextBounds);
              this.setState({}, function () {
                _this3.handlesRefs[nextHandle].focus();
              });
              this.onEnd();
            }
          }
        }, {
          key: 'pushSurroundingHandles',
          value: function pushSurroundingHandles(bounds, handle) {
            var value = bounds[handle];
            var threshold = this.props.pushable;
            threshold = Number(threshold);
            var direction = 0;

            if (bounds[handle + 1] - value < threshold) {
              direction = +1; // push to right
            }

            if (value - bounds[handle - 1] < threshold) {
              direction = -1; // push to left
            }

            if (direction === 0) {
              return;
            }

            var nextHandle = handle + direction;
            var diffToNext = direction * (bounds[nextHandle] - value);

            if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
              // revert to original value if pushing is impossible
              bounds[handle] = bounds[nextHandle] - direction * threshold;
            }
          }
        }, {
          key: 'pushHandle',
          value: function pushHandle(bounds, handle, direction, amount) {
            var originalValue = bounds[handle];
            var currentValue = bounds[handle];

            while (direction * (currentValue - originalValue) < amount) {
              if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                // can't push handle enough to create the needed `amount` gap, so we
                // revert its position to the original value
                bounds[handle] = originalValue;
                return false;
              }

              currentValue = bounds[handle];
            } // the handle was pushed enough to create the needed `amount` gap


            return true;
          }
        }, {
          key: 'pushHandleOnePoint',
          value: function pushHandleOnePoint(bounds, handle, direction) {
            var points = this.getPoints();
            var pointIndex = points.indexOf(bounds[handle]);
            var nextPointIndex = pointIndex + direction;

            if (nextPointIndex >= points.length || nextPointIndex < 0) {
              // reached the minimum or maximum available point, can't push anymore
              return false;
            }

            var nextHandle = handle + direction;
            var nextValue = points[nextPointIndex];
            var threshold = this.props.pushable;
            var diffToNext = direction * (bounds[nextHandle] - nextValue);

            if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
              // couldn't push next handle, so we won't push this one either
              return false;
            } // push the handle


            bounds[handle] = nextValue;
            return true;
          }
        }, {
          key: 'trimAlignValue',
          value: function trimAlignValue(v, handle) {
            var nextProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
            var valInRange = utils.ensureValueInRange(v, mergedProps);
            var valNotConflict = this.ensureValueNotConflict(handle, valInRange, mergedProps);
            return utils.ensureValuePrecision(valNotConflict, mergedProps);
          }
        }, {
          key: 'ensureValueNotConflict',
          value: function ensureValueNotConflict(handle, val, _ref) {
            var allowCross = _ref.allowCross,
                thershold = _ref.pushable;
            var state = this.state || {};
            var bounds = state.bounds;
            handle = handle === undefined ? state.handle : handle;
            thershold = Number(thershold);
            /* eslint-disable eqeqeq */

            if (!allowCross && handle != null && bounds !== undefined) {
              if (handle > 0 && val <= bounds[handle - 1] + thershold) {
                return bounds[handle - 1] + thershold;
              }

              if (handle < bounds.length - 1 && val >= bounds[handle + 1] - thershold) {
                return bounds[handle + 1] - thershold;
              }
            }
            /* eslint-enable eqeqeq */


            return val;
          }
        }, {
          key: 'render',
          value: function render() {
            var _this4 = this;

            var _state2 = this.state,
                handle = _state2.handle,
                bounds = _state2.bounds;
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                vertical = _props2.vertical,
                included = _props2.included,
                disabled = _props2.disabled,
                min = _props2.min,
                max = _props2.max,
                handleGenerator = _props2.handle,
                trackStyle = _props2.trackStyle,
                handleStyle = _props2.handleStyle,
                tabIndex = _props2.tabIndex;
            var offsets = bounds.map(function (v) {
              return _this4.calcOffset(v);
            });
            var handleClassName = prefixCls + '-handle';
            var handles = bounds.map(function (v, i) {
              var _classNames;

              var _tabIndex = tabIndex[i] || 0;

              if (disabled || tabIndex[i] === null) {
                _tabIndex = null;
              }

              return handleGenerator({
                className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, handleClassName, true), (0, _defineProperty3['default'])(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
                prefixCls: prefixCls,
                vertical: vertical,
                offset: offsets[i],
                value: v,
                dragging: handle === i,
                index: i,
                tabIndex: _tabIndex,
                min: min,
                max: max,
                disabled: disabled,
                style: handleStyle[i],
                ref: function ref(h) {
                  return _this4.saveHandle(i, h);
                }
              });
            });
            var tracks = bounds.slice(0, -1).map(function (_, index) {
              var _classNames2;

              var i = index + 1;
              var trackClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
              return _react2['default'].createElement(_Track2['default'], {
                className: trackClassName,
                vertical: vertical,
                included: included,
                offset: offsets[i - 1],
                length: offsets[i] - offsets[i - 1],
                style: trackStyle[index],
                key: i
              });
            });
            return {
              tracks: tracks,
              handles: handles
            };
          }
        }]);
        return Range;
      }(_react2['default'].Component);
      /* eslint-disable react/prop-types */


      Range.displayName = 'Range';
      Range.propTypes = {
        defaultValue: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
        value: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
        count: _propTypes2['default'].number,
        pushable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].number]),
        allowCross: _propTypes2['default'].bool,
        disabled: _propTypes2['default'].bool,
        tabIndex: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
        min: _propTypes2['default'].number,
        max: _propTypes2['default'].number
      };
      Range.defaultProps = {
        count: 1,
        allowCross: true,
        pushable: false,
        tabIndex: []
      };
      exports['default'] = (0, _createSlider2['default'])(Range);
      module.exports = exports['default'];
      /***/
    },
    /* 867 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var Marks = function Marks(_ref) {
        var className = _ref.className,
            vertical = _ref.vertical,
            marks = _ref.marks,
            included = _ref.included,
            upperBound = _ref.upperBound,
            lowerBound = _ref.lowerBound,
            max = _ref.max,
            min = _ref.min,
            onClickLabel = _ref.onClickLabel;
        var marksKeys = Object.keys(marks);
        var range = max - min;
        var elements = marksKeys.map(parseFloat).sort(function (a, b) {
          return a - b;
        }).map(function (point) {
          var _classNames;

          var markPoint = marks[point];
          var markPointIsObject = typeof markPoint === 'object' && !_react2['default'].isValidElement(markPoint);
          var markLabel = markPointIsObject ? markPoint.label : markPoint;

          if (!markLabel && markLabel !== 0) {
            return null;
          }

          var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
          var markClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className + '-text', true), (0, _defineProperty3['default'])(_classNames, className + '-text-active', isActive), _classNames));
          var bottomStyle = {
            marginBottom: '-50%',
            bottom: (point - min) / range * 100 + '%'
          };
          var leftStyle = {
            left: (point - min) / range * 100 + '%',
            transform: 'translateX(-50%)',
            msTransform: 'translateX(-50%)'
          };
          var style = vertical ? bottomStyle : leftStyle;
          var markStyle = markPointIsObject ? (0, _extends3['default'])({}, style, markPoint.style) : style;
          return _react2['default'].createElement('span', {
            className: markClassName,
            style: markStyle,
            key: point,
            onMouseDown: function onMouseDown(e) {
              return onClickLabel(e, point);
            },
            onTouchStart: function onTouchStart(e) {
              return onClickLabel(e, point);
            }
          }, markLabel);
        });
        return _react2['default'].createElement('div', {
          className: className
        }, elements);
      };

      Marks.propTypes = {
        className: _propTypes2['default'].string,
        vertical: _propTypes2['default'].bool,
        marks: _propTypes2['default'].object,
        included: _propTypes2['default'].bool,
        upperBound: _propTypes2['default'].number,
        lowerBound: _propTypes2['default'].number,
        max: _propTypes2['default'].number,
        min: _propTypes2['default'].number,
        onClickLabel: _propTypes2['default'].func
      };
      exports['default'] = Marks;
      module.exports = exports['default'];
      /***/
    },
    /* 868 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _warning = __webpack_require__(114);

      var _warning2 = _interopRequireDefault(_warning);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
        (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
        var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
          return a - b;
        });

        if (dots && step) {
          for (var i = min; i <= max; i += step) {
            if (points.indexOf(i) === -1) {
              points.push(i);
            }
          }
        }

        return points;
      };

      var Steps = function Steps(_ref) {
        var prefixCls = _ref.prefixCls,
            vertical = _ref.vertical,
            marks = _ref.marks,
            dots = _ref.dots,
            step = _ref.step,
            included = _ref.included,
            lowerBound = _ref.lowerBound,
            upperBound = _ref.upperBound,
            max = _ref.max,
            min = _ref.min,
            dotStyle = _ref.dotStyle,
            activeDotStyle = _ref.activeDotStyle;
        var range = max - min;
        var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
          var _classNames;

          var offset = Math.abs(point - min) / range * 100 + '%';
          var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
          var style = vertical ? (0, _extends3['default'])({
            bottom: offset
          }, dotStyle) : (0, _extends3['default'])({
            left: offset
          }, dotStyle);

          if (isActived) {
            style = (0, _extends3['default'])({}, style, activeDotStyle);
          }

          var pointClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-active', isActived), _classNames));
          return _react2['default'].createElement('span', {
            className: pointClassName,
            style: style,
            key: point
          });
        });
        return _react2['default'].createElement('div', {
          className: prefixCls + '-step'
        }, elements);
      };

      Steps.propTypes = {
        prefixCls: _propTypes2['default'].string,
        activeDotStyle: _propTypes2['default'].object,
        dotStyle: _propTypes2['default'].object,
        min: _propTypes2['default'].number,
        max: _propTypes2['default'].number,
        upperBound: _propTypes2['default'].number,
        lowerBound: _propTypes2['default'].number,
        included: _propTypes2['default'].bool,
        dots: _propTypes2['default'].bool,
        step: _propTypes2['default'].number,
        marks: _propTypes2['default'].object,
        vertical: _propTypes2['default'].bool
      };
      exports['default'] = Steps;
      module.exports = exports['default'];
      /***/
    },
    /* 869 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _warning = __webpack_require__(114);

      var _warning2 = _interopRequireDefault(_warning);

      var _Track = __webpack_require__(436);

      var _Track2 = _interopRequireDefault(_Track);

      var _createSlider = __webpack_require__(435);

      var _createSlider2 = _interopRequireDefault(_createSlider);

      var _utils = __webpack_require__(313);

      var utils = _interopRequireWildcard(_utils);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }
      /* eslint-disable react/prop-types */


      var Slider = function (_React$Component) {
        (0, _inherits3['default'])(Slider, _React$Component);

        function Slider(props) {
          (0, _classCallCheck3['default'])(this, Slider);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

          _this.onEnd = function (force) {
            var dragging = _this.state.dragging;

            _this.removeDocumentEvents();

            if (dragging || force) {
              _this.props.onAfterChange(_this.getValue());
            }

            _this.setState({
              dragging: false
            });
          };

          var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
          var value = props.value !== undefined ? props.value : defaultValue;
          _this.state = {
            value: _this.trimAlignValue(value),
            dragging: false
          };

          if (utils.isDev()) {
            (0, _warning2['default'])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
            (0, _warning2['default'])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
          }

          return _this;
        }

        (0, _createClass3['default'])(Slider, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _props = this.props,
                autoFocus = _props.autoFocus,
                disabled = _props.disabled;

            if (autoFocus && !disabled) {
              this.focus();
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
            var prevValue = this.state.value;
            var value = nextProps.value !== undefined ? nextProps.value : prevValue;
            var nextValue = this.trimAlignValue(value, nextProps);
            if (nextValue === prevValue) return;
            this.setState({
              value: nextValue
            });

            if (utils.isValueOutOfRange(value, nextProps)) {
              this.props.onChange(nextValue);
            }
          }
        }, {
          key: 'onChange',
          value: function onChange(state) {
            var props = this.props;
            var isNotControlled = !('value' in props);
            var nextState = state.value > this.props.max ? (0, _extends3['default'])({}, state, {
              value: this.props.max
            }) : state;

            if (isNotControlled) {
              this.setState(nextState);
            }

            var changedValue = nextState.value;
            props.onChange(changedValue);
          }
        }, {
          key: 'onStart',
          value: function onStart(position) {
            this.setState({
              dragging: true
            });
            var props = this.props;
            var prevValue = this.getValue();
            props.onBeforeChange(prevValue);
            var value = this.calcValueByPos(position);
            this.startValue = value;
            this.startPosition = position;
            if (value === prevValue) return;
            this.prevMovedHandleIndex = 0;
            this.onChange({
              value: value
            });
          }
        }, {
          key: 'onMove',
          value: function onMove(e, position) {
            utils.pauseEvent(e);
            var oldValue = this.state.value;
            var value = this.calcValueByPos(position);
            if (value === oldValue) return;
            this.onChange({
              value: value
            });
          }
        }, {
          key: 'onKeyboard',
          value: function onKeyboard(e) {
            var valueMutator = utils.getKeyboardValueMutator(e);

            if (valueMutator) {
              utils.pauseEvent(e);
              var state = this.state;
              var oldValue = state.value;
              var mutatedValue = valueMutator(oldValue, this.props);
              var value = this.trimAlignValue(mutatedValue);
              if (value === oldValue) return;
              this.onChange({
                value: value
              });
              this.props.onAfterChange(value);
              this.onEnd();
            }
          }
        }, {
          key: 'getValue',
          value: function getValue() {
            return this.state.value;
          }
        }, {
          key: 'getLowerBound',
          value: function getLowerBound() {
            return this.props.min;
          }
        }, {
          key: 'getUpperBound',
          value: function getUpperBound() {
            return this.state.value;
          }
        }, {
          key: 'trimAlignValue',
          value: function trimAlignValue(v) {
            var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (v === null) {
              return null;
            }

            var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
            var val = utils.ensureValueInRange(v, mergedProps);
            return utils.ensureValuePrecision(val, mergedProps);
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                vertical = _props2.vertical,
                included = _props2.included,
                disabled = _props2.disabled,
                minimumTrackStyle = _props2.minimumTrackStyle,
                trackStyle = _props2.trackStyle,
                handleStyle = _props2.handleStyle,
                tabIndex = _props2.tabIndex,
                min = _props2.min,
                max = _props2.max,
                handleGenerator = _props2.handle;
            var _state = this.state,
                value = _state.value,
                dragging = _state.dragging;
            var offset = this.calcOffset(value);
            var handle = handleGenerator({
              className: prefixCls + '-handle',
              prefixCls: prefixCls,
              vertical: vertical,
              offset: offset,
              value: value,
              dragging: dragging,
              disabled: disabled,
              min: min,
              max: max,
              index: 0,
              tabIndex: tabIndex,
              style: handleStyle[0] || handleStyle,
              ref: function ref(h) {
                return _this2.saveHandle(0, h);
              }
            });

            var _trackStyle = trackStyle[0] || trackStyle;

            var track = _react2['default'].createElement(_Track2['default'], {
              className: prefixCls + '-track',
              vertical: vertical,
              included: included,
              offset: 0,
              length: offset,
              style: (0, _extends3['default'])({}, minimumTrackStyle, _trackStyle)
            });

            return {
              tracks: track,
              handles: handle
            };
          }
        }]);
        return Slider;
      }(_react2['default'].Component);

      Slider.propTypes = {
        defaultValue: _propTypes2['default'].number,
        value: _propTypes2['default'].number,
        disabled: _propTypes2['default'].bool,
        autoFocus: _propTypes2['default'].bool,
        tabIndex: _propTypes2['default'].number,
        min: _propTypes2['default'].number,
        max: _propTypes2['default'].number
      };
      exports['default'] = (0, _createSlider2['default'])(Slider);
      module.exports = exports['default'];
      /***/
    },
    /* 870 */

    /***/
    function (module, exports) {
      /**
       * Converts `set` to its value-value pairs.
       *
       * @private
       * @param {Object} set The set to convert.
       * @returns {Array} Returns the value-value pairs.
       */
      function setToPairs(set) {
        var index = -1,
            result = Array(set.size);
        set.forEach(function (value) {
          result[++index] = [value, value];
        });
        return result;
      }

      module.exports = setToPairs;
      /***/
    },
    /* 871 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayMap = __webpack_require__(176);
      /**
       * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
       * of key-value pairs for `object` corresponding to the property names of `props`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} props The property names to get values for.
       * @returns {Object} Returns the key-value pairs.
       */


      function baseToPairs(object, props) {
        return arrayMap(props, function (key) {
          return [key, object[key]];
        });
      }

      module.exports = baseToPairs;
      /***/
    },
    /* 872 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseToPairs = __webpack_require__(871),
          getTag = __webpack_require__(153),
          mapToArray = __webpack_require__(331),
          setToPairs = __webpack_require__(870);
      /** `Object#toString` result references. */


      var mapTag = '[object Map]',
          setTag = '[object Set]';
      /**
       * Creates a `_.toPairs` or `_.toPairsIn` function.
       *
       * @private
       * @param {Function} keysFunc The function to get the keys of a given object.
       * @returns {Function} Returns the new pairs function.
       */

      function createToPairs(keysFunc) {
        return function (object) {
          var tag = getTag(object);

          if (tag == mapTag) {
            return mapToArray(object);
          }

          if (tag == setTag) {
            return setToPairs(object);
          }

          return baseToPairs(object, keysFunc(object));
        };
      }

      module.exports = createToPairs;
      /***/
    },
    /* 873 */

    /***/
    function (module, exports) {
      function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }

      module.exports = _nonIterableSpread;
      /***/
    },
    /* 874 */

    /***/
    function (module, exports) {
      function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
      }

      module.exports = _iterableToArray;
      /***/
    },
    /* 875 */

    /***/
    function (module, exports) {
      function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        }
      }

      module.exports = _arrayWithoutHoles;
      /***/
    },
    /* 876 */

    /***/
    function (module, exports, __webpack_require__) {
      var isPlainObject = __webpack_require__(495);
      /**
       * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
       * objects.
       *
       * @private
       * @param {*} value The value to inspect.
       * @param {string} key The key of the property to inspect.
       * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
       */


      function customOmitClone(value) {
        return isPlainObject(value) ? undefined : value;
      }

      module.exports = customOmitClone;
      /***/
    },
    /* 877 */

    /***/
    function (module, exports) {
      /**
       * The base implementation of `_.slice` without an iteratee call guard.
       *
       * @private
       * @param {Array} array The array to slice.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the slice of `array`.
       */
      function baseSlice(array, start, end) {
        var index = -1,
            length = array.length;

        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }

        end = end > length ? length : end;

        if (end < 0) {
          end += length;
        }

        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result = Array(length);

        while (++index < length) {
          result[index] = array[index + start];
        }

        return result;
      }

      module.exports = baseSlice;
      /***/
    },
    /* 878 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGet = __webpack_require__(249),
          baseSlice = __webpack_require__(877);
      /**
       * Gets the parent value at `path` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} path The path to get the parent value of.
       * @returns {*} Returns the parent value.
       */


      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }

      module.exports = parent;
      /***/
    },
    /* 879 */

    /***/
    function (module, exports) {
      /**
       * Gets the last element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {*} Returns the last element of `array`.
       * @example
       *
       * _.last([1, 2, 3]);
       * // => 3
       */
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined;
      }

      module.exports = last;
      /***/
    },
    /* 880 */

    /***/
    function (module, exports, __webpack_require__) {
      var castPath = __webpack_require__(177),
          last = __webpack_require__(879),
          parent = __webpack_require__(878),
          toKey = __webpack_require__(175);
      /**
       * The base implementation of `_.unset`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The property path to unset.
       * @returns {boolean} Returns `true` if the property is deleted, else `false`.
       */


      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }

      module.exports = baseUnset;
      /***/
    },
    /* 881 */

    /***/
    function (module, exports, __webpack_require__) {
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var runtime = function (exports) {
        "use strict";

        var Op = Object.prototype;
        var hasOwn = Op.hasOwnProperty;
        var undefined; // More compressible than void 0.

        var $Symbol = typeof Symbol === "function" ? Symbol : {};
        var iteratorSymbol = $Symbol.iterator || "@@iterator";
        var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
        var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

        function wrap(innerFn, outerFn, self, tryLocsList) {
          // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
          var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
          var generator = Object.create(protoGenerator.prototype);
          var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
          // .throw, and .return methods.

          generator._invoke = makeInvokeMethod(innerFn, self, context);
          return generator;
        }

        exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
        // record like context.tryEntries[i].completion. This interface could
        // have been (and was previously) designed to take a closure to be
        // invoked without arguments, but in all the cases we care about we
        // already have an existing method we want to call, so there's no need
        // to create a new function object. We can even get away with assuming
        // the method takes exactly one argument, since that happens to be true
        // in every case, so we don't have to touch the arguments object. The
        // only additional allocation required is the completion record, which
        // has a stable shape and so hopefully should be cheap to allocate.

        function tryCatch(fn, obj, arg) {
          try {
            return {
              type: "normal",
              arg: fn.call(obj, arg)
            };
          } catch (err) {
            return {
              type: "throw",
              arg: err
            };
          }
        }

        var GenStateSuspendedStart = "suspendedStart";
        var GenStateSuspendedYield = "suspendedYield";
        var GenStateExecuting = "executing";
        var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
        // breaking out of the dispatch switch statement.

        var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
        // .constructor.prototype properties for functions that return Generator
        // objects. For full spec compliance, you may wish to configure your
        // minifier not to mangle the names of these two functions.

        function Generator() {}

        function GeneratorFunction() {}

        function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
        // don't natively support it.


        var IteratorPrototype = {};

        IteratorPrototype[iteratorSymbol] = function () {
          return this;
        };

        var getProto = Object.getPrototypeOf;
        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

        if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
          // This environment has a native %IteratorPrototype%; use it instead
          // of the polyfill.
          IteratorPrototype = NativeIteratorPrototype;
        }

        var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
        GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
        GeneratorFunctionPrototype.constructor = GeneratorFunction;
        GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
        // Iterator interface in terms of a single ._invoke method.

        function defineIteratorMethods(prototype) {
          ["next", "throw", "return"].forEach(function (method) {
            prototype[method] = function (arg) {
              return this._invoke(method, arg);
            };
          });
        }

        exports.isGeneratorFunction = function (genFun) {
          var ctor = typeof genFun === "function" && genFun.constructor;
          return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
          // do is to check its .name property.
          (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
        };

        exports.mark = function (genFun) {
          if (Object.setPrototypeOf) {
            Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
          } else {
            genFun.__proto__ = GeneratorFunctionPrototype;

            if (!(toStringTagSymbol in genFun)) {
              genFun[toStringTagSymbol] = "GeneratorFunction";
            }
          }

          genFun.prototype = Object.create(Gp);
          return genFun;
        }; // Within the body of any async function, `await x` is transformed to
        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
        // `hasOwn.call(value, "__await")` to determine if the yielded value is
        // meant to be awaited.


        exports.awrap = function (arg) {
          return {
            __await: arg
          };
        };

        function AsyncIterator(generator) {
          function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);

            if (record.type === "throw") {
              reject(record.arg);
            } else {
              var result = record.arg;
              var value = result.value;

              if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                return Promise.resolve(value.__await).then(function (value) {
                  invoke("next", value, resolve, reject);
                }, function (err) {
                  invoke("throw", err, resolve, reject);
                });
              }

              return Promise.resolve(value).then(function (unwrapped) {
                // When a yielded Promise is resolved, its final value becomes
                // the .value of the Promise<{value,done}> result for the
                // current iteration.
                result.value = unwrapped;
                resolve(result);
              }, function (error) {
                // If a rejected Promise was yielded, throw the rejection back
                // into the async generator function so it can be handled there.
                return invoke("throw", error, resolve, reject);
              });
            }
          }

          var previousPromise;

          function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
              return new Promise(function (resolve, reject) {
                invoke(method, arg, resolve, reject);
              });
            }

            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
          } // Define the unified helper method that is used to implement .next,
          // .throw, and .return (see defineIteratorMethods).


          this._invoke = enqueue;
        }

        defineIteratorMethods(AsyncIterator.prototype);

        AsyncIterator.prototype[asyncIteratorSymbol] = function () {
          return this;
        };

        exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
        // AsyncIterator objects; they just return a Promise for the value of
        // the final result produced by the iterator.

        exports.async = function (innerFn, outerFn, self, tryLocsList) {
          var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
          return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
          : iter.next().then(function (result) {
            return result.done ? result.value : iter.next();
          });
        };

        function makeInvokeMethod(innerFn, self, context) {
          var state = GenStateSuspendedStart;
          return function invoke(method, arg) {
            if (state === GenStateExecuting) {
              throw new Error("Generator is already running");
            }

            if (state === GenStateCompleted) {
              if (method === "throw") {
                throw arg;
              } // Be forgiving, per 25.3.3.3.3 of the spec:
              // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


              return doneResult();
            }

            context.method = method;
            context.arg = arg;

            while (true) {
              var delegate = context.delegate;

              if (delegate) {
                var delegateResult = maybeInvokeDelegate(delegate, context);

                if (delegateResult) {
                  if (delegateResult === ContinueSentinel) continue;
                  return delegateResult;
                }
              }

              if (context.method === "next") {
                // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
              } else if (context.method === "throw") {
                if (state === GenStateSuspendedStart) {
                  state = GenStateCompleted;
                  throw context.arg;
                }

                context.dispatchException(context.arg);
              } else if (context.method === "return") {
                context.abrupt("return", context.arg);
              }

              state = GenStateExecuting;
              var record = tryCatch(innerFn, self, context);

              if (record.type === "normal") {
                // If an exception is thrown from innerFn, we leave state ===
                // GenStateExecuting and loop back for another invocation.
                state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                if (record.arg === ContinueSentinel) {
                  continue;
                }

                return {
                  value: record.arg,
                  done: context.done
                };
              } else if (record.type === "throw") {
                state = GenStateCompleted; // Dispatch the exception by looping back around to the
                // context.dispatchException(context.arg) call above.

                context.method = "throw";
                context.arg = record.arg;
              }
            }
          };
        } // Call delegate.iterator[context.method](context.arg) and handle the
        // result, either by returning a { value, done } result from the
        // delegate iterator, or by modifying context.method and context.arg,
        // setting context.delegate to null, and returning the ContinueSentinel.


        function maybeInvokeDelegate(delegate, context) {
          var method = delegate.iterator[context.method];

          if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;

            if (context.method === "throw") {
              // Note: ["return"] must be used for ES3 parsing compatibility.
              if (delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);

                if (context.method === "throw") {
                  // If maybeInvokeDelegate(context) changed context.method from
                  // "return" to "throw", let that override the TypeError below.
                  return ContinueSentinel;
                }
              }

              context.method = "throw";
              context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return ContinueSentinel;
          }

          var record = tryCatch(method, delegate.iterator, context.arg);

          if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
          }

          var info = record.arg;

          if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
          }

          if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

            context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.

            if (context.method !== "return") {
              context.method = "next";
              context.arg = undefined;
            }
          } else {
            // Re-yield the result returned by the delegate method.
            return info;
          } // The delegate iterator is finished, so forget it and continue with
          // the outer generator.


          context.delegate = null;
          return ContinueSentinel;
        } // Define Generator.prototype.{next,throw,return} in terms of the
        // unified ._invoke helper method.


        defineIteratorMethods(Gp);
        Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
        // @@iterator function is called on it. Some browsers' implementations of the
        // iterator prototype chain incorrectly implement this, causing the Generator
        // object to not be returned from this call. This ensures that doesn't happen.
        // See https://github.com/facebook/regenerator/issues/274 for more details.

        Gp[iteratorSymbol] = function () {
          return this;
        };

        Gp.toString = function () {
          return "[object Generator]";
        };

        function pushTryEntry(locs) {
          var entry = {
            tryLoc: locs[0]
          };

          if (1 in locs) {
            entry.catchLoc = locs[1];
          }

          if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
          }

          this.tryEntries.push(entry);
        }

        function resetTryEntry(entry) {
          var record = entry.completion || {};
          record.type = "normal";
          delete record.arg;
          entry.completion = record;
        }

        function Context(tryLocsList) {
          // The root entry object (effectively a try statement without a catch
          // or a finally block) gives us a place to store values thrown from
          // locations where there is no enclosing try statement.
          this.tryEntries = [{
            tryLoc: "root"
          }];
          tryLocsList.forEach(pushTryEntry, this);
          this.reset(true);
        }

        exports.keys = function (object) {
          var keys = [];

          for (var key in object) {
            keys.push(key);
          }

          keys.reverse(); // Rather than returning an object with a next method, we keep
          // things simple and return the next function itself.

          return function next() {
            while (keys.length) {
              var key = keys.pop();

              if (key in object) {
                next.value = key;
                next.done = false;
                return next;
              }
            } // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.


            next.done = true;
            return next;
          };
        };

        function values(iterable) {
          if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];

            if (iteratorMethod) {
              return iteratorMethod.call(iterable);
            }

            if (typeof iterable.next === "function") {
              return iterable;
            }

            if (!isNaN(iterable.length)) {
              var i = -1,
                  next = function next() {
                while (++i < iterable.length) {
                  if (hasOwn.call(iterable, i)) {
                    next.value = iterable[i];
                    next.done = false;
                    return next;
                  }
                }

                next.value = undefined;
                next.done = true;
                return next;
              };

              return next.next = next;
            }
          } // Return an iterator with no values.


          return {
            next: doneResult
          };
        }

        exports.values = values;

        function doneResult() {
          return {
            value: undefined,
            done: true
          };
        }

        Context.prototype = {
          constructor: Context,
          reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0; // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.

            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);

            if (!skipTempReset) {
              for (var name in this) {
                // Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                  this[name] = undefined;
                }
              }
            }
          },
          stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;

            if (rootRecord.type === "throw") {
              throw rootRecord.arg;
            }

            return this.rval;
          },
          dispatchException: function dispatchException(exception) {
            if (this.done) {
              throw exception;
            }

            var context = this;

            function handle(loc, caught) {
              record.type = "throw";
              record.arg = exception;
              context.next = loc;

              if (caught) {
                // If the dispatched exception was caught by a catch block,
                // then let that catch block handle the exception normally.
                context.method = "next";
                context.arg = undefined;
              }

              return !!caught;
            }

            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              var record = entry.completion;

              if (entry.tryLoc === "root") {
                // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
              }

              if (entry.tryLoc <= this.prev) {
                var hasCatch = hasOwn.call(entry, "catchLoc");
                var hasFinally = hasOwn.call(entry, "finallyLoc");

                if (hasCatch && hasFinally) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  } else if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else if (hasCatch) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  }
                } else if (hasFinally) {
                  if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else {
                  throw new Error("try statement without catch or finally");
                }
              }
            }
          },
          abrupt: function abrupt(type, arg) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];

              if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                var finallyEntry = entry;
                break;
              }
            }

            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
              // Ignore the finally entry if control is not jumping to a
              // location outside the try/catch block.
              finallyEntry = null;
            }

            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;

            if (finallyEntry) {
              this.method = "next";
              this.next = finallyEntry.finallyLoc;
              return ContinueSentinel;
            }

            return this.complete(record);
          },
          complete: function complete(record, afterLoc) {
            if (record.type === "throw") {
              throw record.arg;
            }

            if (record.type === "break" || record.type === "continue") {
              this.next = record.arg;
            } else if (record.type === "return") {
              this.rval = this.arg = record.arg;
              this.method = "return";
              this.next = "end";
            } else if (record.type === "normal" && afterLoc) {
              this.next = afterLoc;
            }

            return ContinueSentinel;
          },
          finish: function finish(finallyLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];

              if (entry.finallyLoc === finallyLoc) {
                this.complete(entry.completion, entry.afterLoc);
                resetTryEntry(entry);
                return ContinueSentinel;
              }
            }
          },
          "catch": function _catch(tryLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];

              if (entry.tryLoc === tryLoc) {
                var record = entry.completion;

                if (record.type === "throw") {
                  var thrown = record.arg;
                  resetTryEntry(entry);
                }

                return thrown;
              }
            } // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.


            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
              iterator: values(iterable),
              resultName: resultName,
              nextLoc: nextLoc
            };

            if (this.method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              this.arg = undefined;
            }

            return ContinueSentinel;
          }
        }; // Regardless of whether this script is executing as a CommonJS module
        // or not, return the runtime object so that we can declare the variable
        // regeneratorRuntime in the outer scope, which allows this module to be
        // injected easily by `bin/regenerator --include-runtime script.js`.

        return exports;
      }( // If this script is executing as a CommonJS module, use module.exports
      // as the regeneratorRuntime namespace. Otherwise create a new empty
      // object. Either way, the resulting object will be used to initialize
      // the regeneratorRuntime variable at the top of this file.
      true ? module.exports : undefined);

      try {
        regeneratorRuntime = runtime;
      } catch (accidentalStrictMode) {
        // This module should not be running in strict mode, so the above
        // assignment should always work unless something is misconfigured. Just
        // in case runtime.js accidentally runs in strict mode, we can escape
        // strict mode using a global Function call. This could conceivably fail
        // if a Content Security Policy forbids using Function, but in that case
        // the proper solution is to fix the accidental strict mode problem. If
        // you've misconfigured your bundler to force strict mode and applied a
        // CSP to forbid Function, and you're not willing to fix either of those
        // problems, please detail your unique predicament in a GitHub issue.
        Function("r", "regeneratorRuntime = r")(runtime);
      }
      /***/

    },
    /* 882 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* DEPRECATED */

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var React = __webpack_require__(1);

      var ReactDOM = __webpack_require__(16);

      var utils = __webpack_require__(200);

      var scrollSpy = __webpack_require__(316);

      var defaultScroller = __webpack_require__(237);

      var PropTypes = __webpack_require__(0);

      var scrollHash = __webpack_require__(438);

      var protoTypes = {
        to: PropTypes.string.isRequired,
        containerId: PropTypes.string,
        container: PropTypes.object,
        activeClass: PropTypes.string,
        spy: PropTypes.bool,
        smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        offset: PropTypes.number,
        delay: PropTypes.number,
        isDynamic: PropTypes.bool,
        onClick: PropTypes.func,
        duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
        absolute: PropTypes.bool,
        onSetActive: PropTypes.func,
        onSetInactive: PropTypes.func,
        ignoreCancelEvents: PropTypes.bool,
        hashSpy: PropTypes.bool
      };
      var Helpers = {
        Scroll: function Scroll(Component, customScroller) {
          console.warn("Helpers.Scroll is deprecated since v1.7.0");
          var scroller = customScroller || defaultScroller;

          var Scroll = function (_React$Component) {
            _inherits(Scroll, _React$Component);

            function Scroll(props) {
              _classCallCheck(this, Scroll);

              var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

              _initialiseProps.call(_this);

              _this.state = {
                active: false
              };
              return _this;
            }

            _createClass(Scroll, [{
              key: 'getScrollSpyContainer',
              value: function getScrollSpyContainer() {
                var containerId = this.props.containerId;
                var container = this.props.container;

                if (containerId) {
                  return document.getElementById(containerId);
                }

                if (container && container.nodeType) {
                  return container;
                }

                return document;
              }
            }, {
              key: 'componentDidMount',
              value: function componentDidMount() {
                if (this.props.spy || this.props.hashSpy) {
                  var scrollSpyContainer = this.getScrollSpyContainer();

                  if (!scrollSpy.isMounted(scrollSpyContainer)) {
                    scrollSpy.mount(scrollSpyContainer);
                  }

                  if (this.props.hashSpy) {
                    if (!scrollHash.isMounted()) {
                      scrollHash.mount(scroller);
                    }

                    scrollHash.mapContainer(this.props.to, scrollSpyContainer);
                  }

                  if (this.props.spy) {
                    scrollSpy.addStateHandler(this.stateHandler);
                  }

                  scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);
                  this.setState({
                    container: scrollSpyContainer
                  });
                }
              }
            }, {
              key: 'componentWillUnmount',
              value: function componentWillUnmount() {
                scrollSpy.unmount(this.stateHandler, this.spyHandler);
              }
            }, {
              key: 'render',
              value: function render() {
                var className = "";

                if (this.state && this.state.active) {
                  className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
                } else {
                  className = this.props.className;
                }

                var props = _extends({}, this.props);

                for (var prop in protoTypes) {
                  if (props.hasOwnProperty(prop)) {
                    delete props[prop];
                  }
                }

                props.className = className;
                props.onClick = this.handleClick;
                return React.createElement(Component, props);
              }
            }]);

            return Scroll;
          }(React.Component);

          var _initialiseProps = function _initialiseProps() {
            var _this2 = this;

            this.scrollTo = function (to, props) {
              scroller.scrollTo(to, _extends({}, _this2.state, props));
            };

            this.handleClick = function (event) {
              /*
               * give the posibility to override onClick
               */
              if (_this2.props.onClick) {
                _this2.props.onClick(event);
              }
              /*
               * dont bubble the navigation
               */


              if (event.stopPropagation) event.stopPropagation();
              if (event.preventDefault) event.preventDefault();
              /*
               * do the magic!
               */

              _this2.scrollTo(_this2.props.to, _this2.props);
            };

            this.stateHandler = function () {
              if (scroller.getActiveLink() !== _this2.props.to) {
                if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
                  _this2.props.onSetInactive();
                }

                _this2.setState({
                  active: false
                });
              }
            };

            this.spyHandler = function (y) {
              var scrollSpyContainer = _this2.getScrollSpyContainer();

              if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
                return;
              }

              var to = _this2.props.to;
              var element = null;
              var elemTopBound = 0;
              var elemBottomBound = 0;
              var containerTop = 0;

              if (scrollSpyContainer.getBoundingClientRect) {
                var containerCords = scrollSpyContainer.getBoundingClientRect();
                containerTop = containerCords.top;
              }

              if (!element || _this2.props.isDynamic) {
                element = scroller.get(to);

                if (!element) {
                  return;
                }

                var cords = element.getBoundingClientRect();
                elemTopBound = cords.top - containerTop + y;
                elemBottomBound = elemTopBound + cords.height;
              }

              var offsetY = y - _this2.props.offset;
              var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
              var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
              var activeLink = scroller.getActiveLink();

              if (isOutside) {
                if (to === activeLink) {
                  scroller.setActiveLink(void 0);
                }

                if (_this2.props.hashSpy && scrollHash.getHash() === to) {
                  scrollHash.changeHash();
                }

                if (_this2.props.spy && _this2.state.active) {
                  _this2.setState({
                    active: false
                  });

                  _this2.props.onSetInactive && _this2.props.onSetInactive();
                }

                return scrollSpy.updateStates();
              }

              if (isInside && activeLink !== to) {
                scroller.setActiveLink(to);
                _this2.props.hashSpy && scrollHash.changeHash(to);

                if (_this2.props.spy) {
                  _this2.setState({
                    active: true
                  });

                  _this2.props.onSetActive && _this2.props.onSetActive(to);
                }

                return scrollSpy.updateStates();
              }
            };
          };

          ;
          Scroll.propTypes = protoTypes;
          Scroll.defaultProps = {
            offset: 0
          };
          return Scroll;
        },
        Element: function Element(Component) {
          console.warn("Helpers.Element is deprecated since v1.7.0");

          var Element = function (_React$Component2) {
            _inherits(Element, _React$Component2);

            function Element(props) {
              _classCallCheck(this, Element);

              var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

              _this3.childBindings = {
                domNode: null
              };
              return _this3;
            }

            _createClass(Element, [{
              key: 'componentDidMount',
              value: function componentDidMount() {
                if (typeof window === 'undefined') {
                  return false;
                }

                this.registerElems(this.props.name);
              }
            }, {
              key: 'componentWillReceiveProps',
              value: function componentWillReceiveProps(nextProps) {
                if (this.props.name !== nextProps.name) {
                  this.registerElems(nextProps.name);
                }
              }
            }, {
              key: 'componentWillUnmount',
              value: function componentWillUnmount() {
                if (typeof window === 'undefined') {
                  return false;
                }

                defaultScroller.unregister(this.props.name);
              }
            }, {
              key: 'registerElems',
              value: function registerElems(name) {
                defaultScroller.register(name, this.childBindings.domNode);
              }
            }, {
              key: 'render',
              value: function render() {
                return React.createElement(Component, _extends({}, this.props, {
                  parentBindings: this.childBindings
                }));
              }
            }]);

            return Element;
          }(React.Component);

          ;
          Element.propTypes = {
            name: PropTypes.string,
            id: PropTypes.string
          };
          return Element;
        }
      };
      module.exports = Helpers;
      /***/
    },
    /* 883 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _scrollElement = __webpack_require__(437);

      var _scrollElement2 = _interopRequireDefault(_scrollElement);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ElementWrapper = function (_React$Component) {
        _inherits(ElementWrapper, _React$Component);

        function ElementWrapper() {
          _classCallCheck(this, ElementWrapper);

          return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
        }

        _createClass(ElementWrapper, [{
          key: 'render',
          value: function render() {
            var _this2 = this; // Remove `parentBindings` from props


            var newProps = _extends({}, this.props);

            if (newProps.parentBindings) {
              delete newProps.parentBindings;
            }

            return _react2.default.createElement('div', _extends({}, newProps, {
              ref: function ref(el) {
                _this2.props.parentBindings.domNode = el;
              }
            }), this.props.children);
          }
        }]);

        return ElementWrapper;
      }(_react2.default.Component);

      ;
      ElementWrapper.propTypes = {
        name: _propTypes2.default.string,
        id: _propTypes2.default.string
      };
      exports.default = (0, _scrollElement2.default)(ElementWrapper);
      /***/
    },
    /* 884 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _scrollLink = __webpack_require__(317);

      var _scrollLink2 = _interopRequireDefault(_scrollLink);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ButtonElement = function (_React$Component) {
        _inherits(ButtonElement, _React$Component);

        function ButtonElement() {
          _classCallCheck(this, ButtonElement);

          return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
        }

        _createClass(ButtonElement, [{
          key: 'render',
          value: function render() {
            return _react2.default.createElement('input', this.props, this.props.children);
          }
        }]);

        return ButtonElement;
      }(_react2.default.Component);

      ;
      exports.default = (0, _scrollLink2.default)(ButtonElement);
      /***/
    },
    /* 885 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _passiveEventListeners = __webpack_require__(315);

      var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];
      exports.default = {
        subscribe: function subscribe(cancelEvent) {
          return typeof document !== 'undefined' && events.forEach(function (event) {
            return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
          });
        }
      };
      /***/
    },
    /* 886 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = {
        /*
         * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
         */
        defaultEasing: function defaultEasing(x) {
          if (x < 0.5) {
            return Math.pow(x * 2, 2) / 2;
          }

          return 1 - Math.pow((1 - x) * 2, 2) / 2;
        },

        /*
         * https://gist.github.com/gre/1650294
         */
        // no easing, no acceleration
        linear: function linear(x) {
          return x;
        },
        // accelerating from zero velocity
        easeInQuad: function easeInQuad(x) {
          return x * x;
        },
        // decelerating to zero velocity
        easeOutQuad: function easeOutQuad(x) {
          return x * (2 - x);
        },
        // acceleration until halfway, then deceleration
        easeInOutQuad: function easeInOutQuad(x) {
          return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
        },
        // accelerating from zero velocity 
        easeInCubic: function easeInCubic(x) {
          return x * x * x;
        },
        // decelerating to zero velocity π
        easeOutCubic: function easeOutCubic(x) {
          return --x * x * x + 1;
        },
        // acceleration until halfway, then deceleration 
        easeInOutCubic: function easeInOutCubic(x) {
          return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
        },
        // accelerating from zero velocity 
        easeInQuart: function easeInQuart(x) {
          return x * x * x * x;
        },
        // decelerating to zero velocity 
        easeOutQuart: function easeOutQuart(x) {
          return 1 - --x * x * x * x;
        },
        // acceleration until halfway, then deceleration
        easeInOutQuart: function easeInOutQuart(x) {
          return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
        },
        // accelerating from zero velocity
        easeInQuint: function easeInQuint(x) {
          return x * x * x * x * x;
        },
        // decelerating to zero velocity
        easeOutQuint: function easeOutQuint(x) {
          return 1 + --x * x * x * x * x;
        },
        // acceleration until halfway, then deceleration 
        easeInOutQuint: function easeInOutQuint(x) {
          return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
        }
      };
      /***/
    },
    /* 887 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _scrollLink = __webpack_require__(317);

      var _scrollLink2 = _interopRequireDefault(_scrollLink);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var LinkElement = function (_React$Component) {
        _inherits(LinkElement, _React$Component);

        function LinkElement() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, LinkElement);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            return _react2.default.createElement('a', _this.props, _this.props.children);
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        return LinkElement;
      }(_react2.default.Component);

      ;
      exports.default = (0, _scrollLink2.default)(LinkElement);
      /***/
    },
    /* 888 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _reactDom = __webpack_require__(16);

      var ReactDOM = _interopRequireWildcard(_reactDom);

      var _button = __webpack_require__(318);

      var _button2 = _interopRequireDefault(_button);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var ActionButton = function (_React$Component) {
        (0, _inherits3['default'])(ActionButton, _React$Component);

        function ActionButton(props) {
          (0, _classCallCheck3['default'])(this, ActionButton);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).call(this, props));

          _this.onClick = function () {
            var _this$props = _this.props,
                actionFn = _this$props.actionFn,
                closeModal = _this$props.closeModal;

            if (actionFn) {
              var ret = void 0;

              if (actionFn.length) {
                ret = actionFn(closeModal);
              } else {
                ret = actionFn();

                if (!ret) {
                  closeModal();
                }
              }

              if (ret && ret.then) {
                _this.setState({
                  loading: true
                });

                ret.then(function () {
                  // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
                  // this.setState({ loading: false });
                  closeModal.apply(undefined, arguments);
                }, function () {
                  // See: https://github.com/ant-design/ant-design/issues/6183
                  _this.setState({
                    loading: false
                  });
                });
              }
            } else {
              closeModal();
            }
          };

          _this.state = {
            loading: false
          };
          return _this;
        }

        (0, _createClass3['default'])(ActionButton, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (this.props.autoFocus) {
              var $this = ReactDOM.findDOMNode(this);
              this.timeoutId = setTimeout(function () {
                return $this.focus();
              });
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            clearTimeout(this.timeoutId);
          }
        }, {
          key: 'render',
          value: function render() {
            var _props = this.props,
                type = _props.type,
                children = _props.children;
            var loading = this.state.loading;
            return React.createElement(_button2['default'], {
              type: type,
              onClick: this.onClick,
              loading: loading
            }, children);
          }
        }]);
        return ActionButton;
      }(React.Component);

      exports['default'] = ActionButton;
      module.exports = exports['default'];
      /***/
    },
    /* 889 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      exports['default'] = confirm;

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _reactDom = __webpack_require__(16);

      var ReactDOM = _interopRequireWildcard(_reactDom);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _icon = __webpack_require__(126);

      var _icon2 = _interopRequireDefault(_icon);

      var _Modal = __webpack_require__(441);

      var _Modal2 = _interopRequireDefault(_Modal);

      var _ActionButton = __webpack_require__(888);

      var _ActionButton2 = _interopRequireDefault(_ActionButton);

      var _locale = __webpack_require__(440);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var IS_REACT_16 = !!ReactDOM.createPortal;

      var ConfirmDialog = function ConfirmDialog(props) {
        var onCancel = props.onCancel,
            onOk = props.onOk,
            close = props.close,
            zIndex = props.zIndex,
            afterClose = props.afterClose,
            visible = props.visible,
            keyboard = props.keyboard;
        var iconType = props.iconType || 'question-circle';
        var okType = props.okType || 'primary';
        var prefixCls = props.prefixCls || 'ant-confirm'; // 默认为 true，保持向下兼容

        var okCancel = 'okCancel' in props ? props.okCancel : true;
        var width = props.width || 416;
        var style = props.style || {}; // 默认为 false，保持旧版默认行为

        var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
        var runtimeLocale = (0, _locale.getConfirmLocale)();
        var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
        var cancelText = props.cancelText || runtimeLocale.cancelText;
        var classString = (0, _classnames2['default'])(prefixCls, prefixCls + '-' + props.type, props.className);
        var cancelButton = okCancel && React.createElement(_ActionButton2['default'], {
          actionFn: onCancel,
          closeModal: close
        }, cancelText);
        return React.createElement(_Modal2['default'], {
          className: classString,
          onCancel: close.bind(undefined, {
            triggerCancel: true
          }),
          visible: visible,
          title: '',
          transitionName: 'zoom',
          footer: '',
          maskTransitionName: 'fade',
          maskClosable: maskClosable,
          style: style,
          width: width,
          zIndex: zIndex,
          afterClose: afterClose,
          keyboard: keyboard
        }, React.createElement('div', {
          className: prefixCls + '-body-wrapper'
        }, React.createElement('div', {
          className: prefixCls + '-body'
        }, React.createElement(_icon2['default'], {
          type: iconType
        }), React.createElement('span', {
          className: prefixCls + '-title'
        }, props.title), React.createElement('div', {
          className: prefixCls + '-content'
        }, props.content)), React.createElement('div', {
          className: prefixCls + '-btns'
        }, cancelButton, React.createElement(_ActionButton2['default'], {
          type: okType,
          actionFn: onOk,
          closeModal: close,
          autoFocus: true
        }, okText))));
      };

      function confirm(config) {
        var div = document.createElement('div');
        document.body.appendChild(div);

        function close() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (IS_REACT_16) {
            render((0, _extends3['default'])({}, config, {
              close: close,
              visible: false,
              afterClose: destroy.bind.apply(destroy, [this].concat(args))
            }));
          } else {
            destroy.apply(undefined, args);
          }
        }

        function destroy() {
          var unmountResult = ReactDOM.unmountComponentAtNode(div);

          if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
          }

          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          var triggerCancel = args && args.length && args.some(function (param) {
            return param && param.triggerCancel;
          });

          if (config.onCancel && triggerCancel) {
            config.onCancel.apply(config, args);
          }
        }

        function render(props) {
          ReactDOM.render(React.createElement(ConfirmDialog, props), div);
        }

        render((0, _extends3['default'])({}, config, {
          visible: true,
          close: close
        }));
        return {
          destroy: close
        };
      }

      module.exports = exports['default'];
      /***/
    },
    /* 890 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var __rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var ButtonGroup = function ButtonGroup(props) {
        var _props$prefixCls = props.prefixCls,
            prefixCls = _props$prefixCls === undefined ? 'ant-btn-group' : _props$prefixCls,
            size = props.size,
            className = props.className,
            others = __rest(props, ["prefixCls", "size", "className"]); // large => lg
        // small => sm


        var sizeCls = '';

        switch (size) {
          case 'large':
            sizeCls = 'lg';
            break;

          case 'small':
            sizeCls = 'sm';

          default:
            break;
        }

        var classes = (0, _classnames2['default'])(prefixCls, (0, _defineProperty3['default'])({}, prefixCls + '-' + sizeCls, sizeCls), className);
        return React.createElement('div', (0, _extends3['default'])({}, others, {
          className: classes
        }));
      };

      exports['default'] = ButtonGroup;
      module.exports = exports['default'];
      /***/
    },
    /* 891 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends2 = __webpack_require__(2);

      var _extends3 = _interopRequireDefault(_extends2);

      var _defineProperty2 = __webpack_require__(6);

      var _defineProperty3 = _interopRequireDefault(_defineProperty2);

      var _classCallCheck2 = __webpack_require__(7);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(12);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(5);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(8);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(1);

      var React = _interopRequireWildcard(_react);

      var _reactDom = __webpack_require__(16);

      var _propTypes = __webpack_require__(0);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _omit = __webpack_require__(45);

      var _omit2 = _interopRequireDefault(_omit);

      var _icon = __webpack_require__(126);

      var _icon2 = _interopRequireDefault(_icon);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj['default'] = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var __rest = undefined && undefined.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
      var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);

      function isString(str) {
        return typeof str === 'string';
      } // Insert one space between two chinese characters automatically.


      function insertSpace(child, needInserted) {
        // Check the child if is undefined or null.
        if (child == null) {
          return;
        }

        var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.

        if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
          return React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
        }

        if (typeof child === 'string') {
          if (isTwoCNChar(child)) {
            child = child.split('').join(SPACE);
          }

          return React.createElement('span', null, child);
        }

        return child;
      }

      var Button = function (_React$Component) {
        (0, _inherits3['default'])(Button, _React$Component);

        function Button(props) {
          (0, _classCallCheck3['default'])(this, Button);

          var _this = (0, _possibleConstructorReturn3['default'])(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

          _this.handleClick = function (e) {
            // Add click effect
            _this.setState({
              clicked: true
            });

            clearTimeout(_this.timeout);
            _this.timeout = window.setTimeout(function () {
              return _this.setState({
                clicked: false
              });
            }, 500);
            var onClick = _this.props.onClick;

            if (onClick) {
              onClick(e);
            }
          };

          _this.state = {
            loading: props.loading,
            clicked: false,
            hasTwoCNChar: false
          };
          return _this;
        }

        (0, _createClass3['default'])(Button, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.fixTwoCNChar();
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var currentLoading = this.props.loading;
            var loading = nextProps.loading;

            if (currentLoading) {
              clearTimeout(this.delayTimeout);
            }

            if (typeof loading !== 'boolean' && loading && loading.delay) {
              this.delayTimeout = window.setTimeout(function () {
                return _this2.setState({
                  loading: loading
                });
              }, loading.delay);
            } else {
              this.setState({
                loading: loading
              });
            }
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            this.fixTwoCNChar();
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.timeout) {
              clearTimeout(this.timeout);
            }

            if (this.delayTimeout) {
              clearTimeout(this.delayTimeout);
            }
          }
        }, {
          key: 'fixTwoCNChar',
          value: function fixTwoCNChar() {
            // Fix for HOC usage like <FormatMessage />
            var node = (0, _reactDom.findDOMNode)(this);
            var buttonText = node.textContent || node.innerText;

            if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
              if (!this.state.hasTwoCNChar) {
                this.setState({
                  hasTwoCNChar: true
                });
              }
            } else if (this.state.hasTwoCNChar) {
              this.setState({
                hasTwoCNChar: false
              });
            }
          }
        }, {
          key: 'isNeedInserted',
          value: function isNeedInserted() {
            var _props = this.props,
                loading = _props.loading,
                icon = _props.icon,
                children = _props.children;
            var iconType = loading ? 'loading' : icon;
            return React.Children.count(children) === 1 && (!iconType || iconType === 'loading');
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames,
                _this3 = this;

            var _a = this.props,
                type = _a.type,
                shape = _a.shape,
                size = _a.size,
                className = _a.className,
                htmlType = _a.htmlType,
                children = _a.children,
                icon = _a.icon,
                prefixCls = _a.prefixCls,
                ghost = _a.ghost,
                others = __rest(_a, ["type", "shape", "size", "className", "htmlType", "children", "icon", "prefixCls", "ghost"]);

            var _state = this.state,
                loading = _state.loading,
                clicked = _state.clicked,
                hasTwoCNChar = _state.hasTwoCNChar; // large => lg
            // small => sm

            var sizeCls = '';

            switch (size) {
              case 'large':
                sizeCls = 'lg';
                break;

              case 'small':
                sizeCls = 'sm';

              default:
                break;
            }

            var ComponentProp = others.href ? 'a' : 'button';
            var classes = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, type), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + shape, shape), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + sizeCls, sizeCls), (0, _defineProperty3['default'])(_classNames, prefixCls + '-icon-only', !children && icon), (0, _defineProperty3['default'])(_classNames, prefixCls + '-loading', loading), (0, _defineProperty3['default'])(_classNames, prefixCls + '-clicked', clicked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-background-ghost', ghost), (0, _defineProperty3['default'])(_classNames, prefixCls + '-two-chinese-chars', hasTwoCNChar), _classNames));
            var iconType = loading ? 'loading' : icon;
            var iconNode = iconType ? React.createElement(_icon2['default'], {
              type: iconType
            }) : null;
            var kids = children || children === 0 ? React.Children.map(children, function (child) {
              return insertSpace(child, _this3.isNeedInserted());
            }) : null;
            return React.createElement(ComponentProp, (0, _extends3['default'])({}, (0, _omit2['default'])(others, ['loading']), {
              type: others.href ? undefined : htmlType || 'button',
              className: classes,
              onClick: this.handleClick
            }), iconNode, kids);
          }
        }]);
        return Button;
      }(React.Component);

      exports['default'] = Button;
      Button.__ANT_BUTTON = true;
      Button.defaultProps = {
        prefixCls: 'ant-btn',
        loading: false,
        ghost: false
      };
      Button.propTypes = {
        type: _propTypes2['default'].string,
        shape: _propTypes2['default'].oneOf(['circle', 'circle-outline']),
        size: _propTypes2['default'].oneOf(['large', 'default', 'small']),
        htmlType: _propTypes2['default'].oneOf(['submit', 'button', 'reset']),
        onClick: _propTypes2['default'].func,
        loading: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
        className: _propTypes2['default'].string,
        icon: _propTypes2['default'].string
      };
      module.exports = exports['default'];
      /***/
    },
    /* 892 */

    /***/
    function (module, exports, __webpack_require__) {
      var Symbol = __webpack_require__(158),
          isArguments = __webpack_require__(211),
          isArray = __webpack_require__(55);
      /** Built-in value references. */


      var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
      /**
       * Checks if `value` is a flattenable `arguments` object or array.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
       */

      function isFlattenable(value) {
        return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }

      module.exports = isFlattenable;
      /***/
    },
    /* 893 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseFlatten = __webpack_require__(320);
      /**
       * Flattens `array` a single level deep.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * _.flatten([1, [2, [3, [4]], 5]]);
       * // => [1, 2, [3, [4]], 5]
       */


      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }

      module.exports = flatten;
      /***/
    },
    /* 894 */

    /***/
    function (module, exports, __webpack_require__) {
      var basePickBy = __webpack_require__(443),
          hasIn = __webpack_require__(449);
      /**
       * The base implementation of `_.pick` without support for individual
       * property identifiers.
       *
       * @private
       * @param {Object} object The source object.
       * @param {string[]} paths The property paths to pick.
       * @returns {Object} Returns the new object.
       */


      function basePick(object, paths) {
        return basePickBy(object, paths, function (value, path) {
          return hasIn(object, path);
        });
      }

      module.exports = basePick;
      /***/
    },
    /* 895 */

    /***/
    function (module, exports) {
      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }

      module.exports = _nonIterableRest;
      /***/
    },
    /* 896 */

    /***/
    function (module, exports) {
      function _iterableToArrayLimit(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;

        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);

            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }

      module.exports = _iterableToArrayLimit;
      /***/
    },
    /* 897 */

    /***/
    function (module, exports) {
      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }

      module.exports = _arrayWithHoles;
      /***/
    },
    /* 898 */

    /***/
    function (module, exports, __webpack_require__) {
      var isArrayLike = __webpack_require__(134);
      /**
       * Creates a `baseEach` or `baseEachRight` function.
       *
       * @private
       * @param {Function} eachFunc The function to iterate over a collection.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new base function.
       */


      function createBaseEach(eachFunc, fromRight) {
        return function (collection, iteratee) {
          if (collection == null) {
            return collection;
          }

          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
          }

          var length = collection.length,
              index = fromRight ? length : -1,
              iterable = Object(collection);

          while (fromRight ? index-- : ++index < length) {
            if (iteratee(iterable[index], index, iterable) === false) {
              break;
            }
          }

          return collection;
        };
      }

      module.exports = createBaseEach;
      /***/
    },
    /* 899 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseEach = __webpack_require__(444);
      /**
       * Aggregates elements of `collection` on `accumulator` with keys transformed
       * by `iteratee` and values set by `setter`.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform keys.
       * @param {Object} accumulator The initial aggregated object.
       * @returns {Function} Returns `accumulator`.
       */


      function baseAggregator(collection, setter, iteratee, accumulator) {
        baseEach(collection, function (value, key, collection) {
          setter(accumulator, value, iteratee(value), collection);
        });
        return accumulator;
      }

      module.exports = baseAggregator;
      /***/
    },
    /* 900 */

    /***/
    function (module, exports) {
      /**
       * A specialized version of `baseAggregator` for arrays.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform keys.
       * @param {Object} accumulator The initial aggregated object.
       * @returns {Function} Returns `accumulator`.
       */
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1,
            length = array == null ? 0 : array.length;

        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }

        return accumulator;
      }

      module.exports = arrayAggregator;
      /***/
    },
    /* 901 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayAggregator = __webpack_require__(900),
          baseAggregator = __webpack_require__(899),
          baseIteratee = __webpack_require__(202),
          isArray = __webpack_require__(55);
      /**
       * Creates a function like `_.groupBy`.
       *
       * @private
       * @param {Function} setter The function to set accumulator values.
       * @param {Function} [initializer] The accumulator object initializer.
       * @returns {Function} Returns the new aggregator function.
       */


      function createAggregator(setter, initializer) {
        return function (collection, iteratee) {
          var func = isArray(collection) ? arrayAggregator : baseAggregator,
              accumulator = initializer ? initializer() : {};
          return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
        };
      }

      module.exports = createAggregator;
      /***/
    },
    /* 902 */

    /***/
    function (module, exports, __webpack_require__) {
      var getTag = __webpack_require__(153),
          isObjectLike = __webpack_require__(109);
      /** `Object#toString` result references. */


      var setTag = '[object Set]';
      /**
       * The base implementation of `_.isSet` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       */

      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }

      module.exports = baseIsSet;
      /***/
    },
    /* 903 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIsSet = __webpack_require__(902),
          baseUnary = __webpack_require__(244),
          nodeUtil = __webpack_require__(346);
      /* Node.js helper references. */


      var nodeIsSet = nodeUtil && nodeUtil.isSet;
      /**
       * Checks if `value` is classified as a `Set` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       * @example
       *
       * _.isSet(new Set);
       * // => true
       *
       * _.isSet(new WeakSet);
       * // => false
       */

      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      module.exports = isSet;
      /***/
    },
    /* 904 */

    /***/
    function (module, exports, __webpack_require__) {
      var getTag = __webpack_require__(153),
          isObjectLike = __webpack_require__(109);
      /** `Object#toString` result references. */


      var mapTag = '[object Map]';
      /**
       * The base implementation of `_.isMap` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       */

      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }

      module.exports = baseIsMap;
      /***/
    },
    /* 905 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIsMap = __webpack_require__(904),
          baseUnary = __webpack_require__(244),
          nodeUtil = __webpack_require__(346);
      /* Node.js helper references. */


      var nodeIsMap = nodeUtil && nodeUtil.isMap;
      /**
       * Checks if `value` is classified as a `Map` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       * @example
       *
       * _.isMap(new Map);
       * // => true
       *
       * _.isMap(new WeakMap);
       * // => false
       */

      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      module.exports = isMap;
      /***/
    },
    /* 906 */

    /***/
    function (module, exports, __webpack_require__) {
      var Symbol = __webpack_require__(158);
      /** Used to convert symbols to primitives and strings. */


      var symbolProto = Symbol ? Symbol.prototype : undefined,
          symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
      /**
       * Creates a clone of the `symbol` object.
       *
       * @private
       * @param {Object} symbol The symbol object to clone.
       * @returns {Object} Returns the cloned symbol object.
       */

      function cloneSymbol(symbol) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
      }

      module.exports = cloneSymbol;
      /***/
    },
    /* 907 */

    /***/
    function (module, exports) {
      /** Used to match `RegExp` flags from their coerced string values. */
      var reFlags = /\w*$/;
      /**
       * Creates a clone of `regexp`.
       *
       * @private
       * @param {Object} regexp The regexp to clone.
       * @returns {Object} Returns the cloned regexp.
       */

      function cloneRegExp(regexp) {
        var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result.lastIndex = regexp.lastIndex;
        return result;
      }

      module.exports = cloneRegExp;
      /***/
    },
    /* 908 */

    /***/
    function (module, exports, __webpack_require__) {
      var cloneArrayBuffer = __webpack_require__(348);
      /**
       * Creates a clone of `dataView`.
       *
       * @private
       * @param {Object} dataView The data view to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned data view.
       */


      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }

      module.exports = cloneDataView;
      /***/
    },
    /* 909 */

    /***/
    function (module, exports, __webpack_require__) {
      var cloneArrayBuffer = __webpack_require__(348),
          cloneDataView = __webpack_require__(908),
          cloneRegExp = __webpack_require__(907),
          cloneSymbol = __webpack_require__(906),
          cloneTypedArray = __webpack_require__(500);
      /** `Object#toString` result references. */


      var boolTag = '[object Boolean]',
          dateTag = '[object Date]',
          mapTag = '[object Map]',
          numberTag = '[object Number]',
          regexpTag = '[object RegExp]',
          setTag = '[object Set]',
          stringTag = '[object String]',
          symbolTag = '[object Symbol]';
      var arrayBufferTag = '[object ArrayBuffer]',
          dataViewTag = '[object DataView]',
          float32Tag = '[object Float32Array]',
          float64Tag = '[object Float64Array]',
          int8Tag = '[object Int8Array]',
          int16Tag = '[object Int16Array]',
          int32Tag = '[object Int32Array]',
          uint8Tag = '[object Uint8Array]',
          uint8ClampedTag = '[object Uint8ClampedArray]',
          uint16Tag = '[object Uint16Array]',
          uint32Tag = '[object Uint32Array]';
      /**
       * Initializes an object clone based on its `toStringTag`.
       *
       * **Note:** This function only supports cloning values with tags of
       * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
       *
       * @private
       * @param {Object} object The object to clone.
       * @param {string} tag The `toStringTag` of the object to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the initialized clone.
       */

      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;

        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);

          case boolTag:
          case dateTag:
            return new Ctor(+object);

          case dataViewTag:
            return cloneDataView(object, isDeep);

          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);

          case mapTag:
            return new Ctor();

          case numberTag:
          case stringTag:
            return new Ctor(object);

          case regexpTag:
            return cloneRegExp(object);

          case setTag:
            return new Ctor();

          case symbolTag:
            return cloneSymbol(object);
        }
      }

      module.exports = initCloneByTag;
      /***/
    },
    /* 910 */

    /***/
    function (module, exports) {
      /** Used for built-in method references. */
      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Initializes an array clone.
       *
       * @private
       * @param {Array} array The array to clone.
       * @returns {Array} Returns the initialized clone.
       */

      function initCloneArray(array) {
        var length = array.length,
            result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

        if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
          result.index = array.index;
          result.input = array.input;
        }

        return result;
      }

      module.exports = initCloneArray;
      /***/
    },
    /* 911 */

    /***/
    function (module, exports, __webpack_require__) {
      var copyObject = __webpack_require__(156),
          getSymbolsIn = __webpack_require__(445);
      /**
       * Copies own and inherited symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */


      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }

      module.exports = copySymbolsIn;
      /***/
    },
    /* 912 */

    /***/
    function (module, exports, __webpack_require__) {
      var copyObject = __webpack_require__(156),
          getSymbols = __webpack_require__(327);
      /**
       * Copies own symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */


      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }

      module.exports = copySymbols;
      /***/
    },
    /* 913 */

    /***/
    function (module, exports, __webpack_require__) {
      var copyObject = __webpack_require__(156),
          keysIn = __webpack_require__(243);
      /**
       * The base implementation of `_.assignIn` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */


      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }

      module.exports = baseAssignIn;
      /***/
    },
    /* 914 */

    /***/
    function (module, exports, __webpack_require__) {
      var copyObject = __webpack_require__(156),
          keys = __webpack_require__(132);
      /**
       * The base implementation of `_.assign` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */


      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }

      module.exports = baseAssign;
      /***/
    },
    /* 915 */

    /***/
    function (module, exports) {
      /**
       * A specialized version of `_.forEach` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns `array`.
       */
      function arrayEach(array, iteratee) {
        var index = -1,
            length = array == null ? 0 : array.length;

        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }

        return array;
      }

      module.exports = arrayEach;
      /***/
    },
    /* 916 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _en_US = __webpack_require__(325);

      var _en_US2 = _interopRequireDefault(_en_US);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      exports['default'] = _en_US2['default'];
      module.exports = exports['default'];
      /***/
    },
    /* 917 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports['default'] = {
        // Options.jsx
        items_per_page: '/ page',
        jump_to: 'Goto',
        jump_to_confirm: 'confirm',
        page: '',
        // Pagination.jsx
        prev_page: 'Previous Page',
        next_page: 'Next Page',
        prev_5: 'Previous 5 Pages',
        next_5: 'Next 5 Pages',
        prev_3: 'Previous 3 Pages',
        next_3: 'Next 3 Pages'
      };
      module.exports = exports['default'];
      /***/
    },
    /* 918 */

    /***/
    function (module, exports, __webpack_require__) {
      var Set = __webpack_require__(457),
          noop = __webpack_require__(9),
          setToArray = __webpack_require__(240);
      /** Used as references for various `Number` constants. */


      var INFINITY = 1 / 0;
      /**
       * Creates a set object of `values`.
       *
       * @private
       * @param {Array} values The values to add to the set.
       * @returns {Object} Returns the new set.
       */

      var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
        return new Set(values);
      };
      module.exports = createSet;
      /***/
    },
    /* 919 */

    /***/
    function (module, exports) {
      /**
       * A specialized version of `_.indexOf` which performs strict equality
       * comparisons of values, i.e. `===`.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1,
            length = array.length;

        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }

        return -1;
      }

      module.exports = strictIndexOf;
      /***/
    },
    /* 920 */

    /***/
    function (module, exports) {
      /**
       * The base implementation of `_.isNaN` without support for number objects.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
       */
      function baseIsNaN(value) {
        return value !== value;
      }

      module.exports = baseIsNaN;
      /***/
    },
    /* 921 */

    /***/
    function (module, exports) {
      /**
       * The base implementation of `_.findIndex` and `_.findLastIndex` without
       * support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} predicate The function invoked per iteration.
       * @param {number} fromIndex The index to search from.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length,
            index = fromIndex + (fromRight ? 1 : -1);

        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }

        return -1;
      }

      module.exports = baseFindIndex;
      /***/
    },
    /* 922 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseFindIndex = __webpack_require__(921),
          baseIsNaN = __webpack_require__(920),
          strictIndexOf = __webpack_require__(919);
      /**
       * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */


      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }

      module.exports = baseIndexOf;
      /***/
    },
    /* 923 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGet = __webpack_require__(249);
      /**
       * A specialized version of `baseProperty` which supports deep paths.
       *
       * @private
       * @param {Array|string} path The path of the property to get.
       * @returns {Function} Returns the new accessor function.
       */


      function basePropertyDeep(path) {
        return function (object) {
          return baseGet(object, path);
        };
      }

      module.exports = basePropertyDeep;
      /***/
    },
    /* 924 */

    /***/
    function (module, exports) {
      /**
       * The base implementation of `_.property` without support for deep paths.
       *
       * @private
       * @param {string} key The key of the property to get.
       * @returns {Function} Returns the new accessor function.
       */
      function baseProperty(key) {
        return function (object) {
          return object == null ? undefined : object[key];
        };
      }

      module.exports = baseProperty;
      /***/
    },
    /* 925 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseProperty = __webpack_require__(924),
          basePropertyDeep = __webpack_require__(923),
          isKey = __webpack_require__(353),
          toKey = __webpack_require__(175);
      /**
       * Creates a function that returns the value at `path` of a given object.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Util
       * @param {Array|string} path The path of the property to get.
       * @returns {Function} Returns the new accessor function.
       * @example
       *
       * var objects = [
       *   { 'a': { 'b': 2 } },
       *   { 'a': { 'b': 1 } }
       * ];
       *
       * _.map(objects, _.property('a.b'));
       * // => [2, 1]
       *
       * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
       * // => [1, 2]
       */


      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }

      module.exports = property;
      /***/
    },
    /* 926 */

    /***/
    function (module, exports) {
      /**
       * The base implementation of `_.hasIn` without support for deep paths.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {Array|string} key The key to check.
       * @returns {boolean} Returns `true` if `key` exists, else `false`.
       */
      function baseHasIn(object, key) {
        return object != null && key in Object(object);
      }

      module.exports = baseHasIn;
      /***/
    },
    /* 927 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIsEqual = __webpack_require__(330),
          get = __webpack_require__(10),
          hasIn = __webpack_require__(449),
          isKey = __webpack_require__(353),
          isStrictComparable = __webpack_require__(451),
          matchesStrictComparable = __webpack_require__(450),
          toKey = __webpack_require__(175);
      /** Used to compose bitmasks for value comparisons. */


      var COMPARE_PARTIAL_FLAG = 1,
          COMPARE_UNORDERED_FLAG = 2;
      /**
       * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
       *
       * @private
       * @param {string} path The path of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       */

      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }

        return function (object) {
          var objValue = get(object, path);
          return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }

      module.exports = baseMatchesProperty;
      /***/
    },
    /* 928 */

    /***/
    function (module, exports, __webpack_require__) {
      var isStrictComparable = __webpack_require__(451),
          keys = __webpack_require__(132);
      /**
       * Gets the property names, values, and compare flags of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the match data of `object`.
       */


      function getMatchData(object) {
        var result = keys(object),
            length = result.length;

        while (length--) {
          var key = result[length],
              value = object[key];
          result[length] = [key, value, isStrictComparable(value)];
        }

        return result;
      }

      module.exports = getMatchData;
      /***/
    },
    /* 929 */

    /***/
    function (module, exports) {
      /**
       * A specialized version of `_.filter` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       */
      function arrayFilter(array, predicate) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
          var value = array[index];

          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }

        return result;
      }

      module.exports = arrayFilter;
      /***/
    },
    /* 930 */

    /***/
    function (module, exports, __webpack_require__) {
      var getAllKeys = __webpack_require__(454);
      /** Used to compose bitmasks for value comparisons. */


      var COMPARE_PARTIAL_FLAG = 1;
      /** Used for built-in method references. */

      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * A specialized version of `baseIsEqualDeep` for objects with support for
       * partial deep comparisons.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */

      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
            objProps = getAllKeys(object),
            objLength = objProps.length,
            othProps = getAllKeys(other),
            othLength = othProps.length;

        if (objLength != othLength && !isPartial) {
          return false;
        }

        var index = objLength;

        while (index--) {
          var key = objProps[index];

          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        } // Assume cyclic values are equal.


        var stacked = stack.get(object);

        if (stacked && stack.get(other)) {
          return stacked == other;
        }

        var result = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;

        while (++index < objLength) {
          key = objProps[index];
          var objValue = object[key],
              othValue = other[key];

          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          } // Recursively compare objects (susceptible to call stack limits).


          if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
          }

          skipCtor || (skipCtor = key == 'constructor');
        }

        if (result && !skipCtor) {
          var objCtor = object.constructor,
              othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

          if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
            result = false;
          }
        }

        stack['delete'](object);
        stack['delete'](other);
        return result;
      }

      module.exports = equalObjects;
      /***/
    },
    /* 931 */

    /***/
    function (module, exports, __webpack_require__) {
      var Symbol = __webpack_require__(158),
          Uint8Array = __webpack_require__(499),
          eq = __webpack_require__(163),
          equalArrays = __webpack_require__(455),
          mapToArray = __webpack_require__(331),
          setToArray = __webpack_require__(240);
      /** Used to compose bitmasks for value comparisons. */


      var COMPARE_PARTIAL_FLAG = 1,
          COMPARE_UNORDERED_FLAG = 2;
      /** `Object#toString` result references. */

      var boolTag = '[object Boolean]',
          dateTag = '[object Date]',
          errorTag = '[object Error]',
          mapTag = '[object Map]',
          numberTag = '[object Number]',
          regexpTag = '[object RegExp]',
          setTag = '[object Set]',
          stringTag = '[object String]',
          symbolTag = '[object Symbol]';
      var arrayBufferTag = '[object ArrayBuffer]',
          dataViewTag = '[object DataView]';
      /** Used to convert symbols to primitives and strings. */

      var symbolProto = Symbol ? Symbol.prototype : undefined,
          symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
      /**
       * A specialized version of `baseIsEqualDeep` for comparing objects of
       * the same `toStringTag`.
       *
       * **Note:** This function only supports comparing values with tags of
       * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {string} tag The `toStringTag` of the objects to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */

      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }

            object = object.buffer;
            other = other.buffer;

          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
              return false;
            }

            return true;

          case boolTag:
          case dateTag:
          case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);

          case errorTag:
            return object.name == other.name && object.message == other.message;

          case regexpTag:
          case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';

          case mapTag:
            var convert = mapToArray;

          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);

            if (object.size != other.size && !isPartial) {
              return false;
            } // Assume cyclic values are equal.


            var stacked = stack.get(object);

            if (stacked) {
              return stacked == other;
            }

            bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;

          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }

        }

        return false;
      }

      module.exports = equalByTag;
      /***/
    },
    /* 932 */

    /***/
    function (module, exports) {
      /**
       * A specialized version of `_.some` for arrays without support for iteratee
       * shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if any element passes the predicate check,
       *  else `false`.
       */
      function arraySome(array, predicate) {
        var index = -1,
            length = array == null ? 0 : array.length;

        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }

        return false;
      }

      module.exports = arraySome;
      /***/
    },
    /* 933 */

    /***/
    function (module, exports) {
      /**
       * Checks if `value` is in the array cache.
       *
       * @private
       * @name has
       * @memberOf SetCache
       * @param {*} value The value to search for.
       * @returns {number} Returns `true` if `value` is found, else `false`.
       */
      function setCacheHas(value) {
        return this.__data__.has(value);
      }

      module.exports = setCacheHas;
      /***/
    },
    /* 934 */

    /***/
    function (module, exports) {
      /** Used to stand-in for `undefined` hash values. */
      var HASH_UNDEFINED = '__lodash_hash_undefined__';
      /**
       * Adds `value` to the array cache.
       *
       * @private
       * @name add
       * @memberOf SetCache
       * @alias push
       * @param {*} value The value to cache.
       * @returns {Object} Returns the cache instance.
       */

      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);

        return this;
      }

      module.exports = setCacheAdd;
      /***/
    },
    /* 935 */

    /***/
    function (module, exports, __webpack_require__) {
      var Stack = __webpack_require__(247),
          equalArrays = __webpack_require__(455),
          equalByTag = __webpack_require__(931),
          equalObjects = __webpack_require__(930),
          getTag = __webpack_require__(153),
          isArray = __webpack_require__(55),
          isBuffer = __webpack_require__(208),
          isTypedArray = __webpack_require__(245);
      /** Used to compose bitmasks for value comparisons. */


      var COMPARE_PARTIAL_FLAG = 1;
      /** `Object#toString` result references. */

      var argsTag = '[object Arguments]',
          arrayTag = '[object Array]',
          objectTag = '[object Object]';
      /** Used for built-in method references. */

      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * A specialized version of `baseIsEqual` for arrays and objects which performs
       * deep comparisons and tracks traversed objects enabling objects with circular
       * references to be compared.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} [stack] Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */

      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray(object),
            othIsArr = isArray(other),
            objTag = objIsArr ? arrayTag : getTag(object),
            othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag,
            othIsObj = othTag == objectTag,
            isSameTag = objTag == othTag;

        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }

          objIsArr = true;
          objIsObj = false;
        }

        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }

        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
              othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object,
                othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }

        if (!isSameTag) {
          return false;
        }

        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }

      module.exports = baseIsEqualDeep;
      /***/
    },
    /* 936 */

    /***/
    function (module, exports, __webpack_require__) {
      var Stack = __webpack_require__(247),
          baseIsEqual = __webpack_require__(330);
      /** Used to compose bitmasks for value comparisons. */


      var COMPARE_PARTIAL_FLAG = 1,
          COMPARE_UNORDERED_FLAG = 2;
      /**
       * The base implementation of `_.isMatch` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property values to match.
       * @param {Array} matchData The property names, values, and compare flags to match.
       * @param {Function} [customizer] The function to customize comparisons.
       * @returns {boolean} Returns `true` if `object` is a match, else `false`.
       */

      function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length,
            length = index,
            noCustomizer = !customizer;

        if (object == null) {
          return !length;
        }

        object = Object(object);

        while (index--) {
          var data = matchData[index];

          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }

        while (++index < length) {
          data = matchData[index];
          var key = data[0],
              objValue = object[key],
              srcValue = data[1];

          if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();

            if (customizer) {
              var result = customizer(objValue, srcValue, key, object, source, stack);
            }

            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
              return false;
            }
          }
        }

        return true;
      }

      module.exports = baseIsMatch;
      /***/
    },
    /* 937 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseIsMatch = __webpack_require__(936),
          getMatchData = __webpack_require__(928),
          matchesStrictComparable = __webpack_require__(450);
      /**
       * The base implementation of `_.matches` which doesn't clone `source`.
       *
       * @private
       * @param {Object} source The object of property values to match.
       * @returns {Function} Returns the new spec function.
       */


      function baseMatches(source) {
        var matchData = getMatchData(source);

        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }

        return function (object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }

      module.exports = baseMatches;
      /***/
    },
    /* 938 */

    /***/
    function (module, exports, __webpack_require__) {
      var overArg = __webpack_require__(497);
      /* Built-in method references for those with the same name as other `lodash` methods. */


      var nativeKeys = overArg(Object.keys, Object);
      module.exports = nativeKeys;
      /***/
    },
    /* 939 */

    /***/
    function (module, exports, __webpack_require__) {
      var arrayMap = __webpack_require__(176);
      /**
       * The base implementation of `_.values` and `_.valuesIn` which creates an
       * array of `object` property values corresponding to the property names
       * of `props`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} props The property names to get values for.
       * @returns {Object} Returns the array of property values.
       */


      function baseValues(object, props) {
        return arrayMap(props, function (key) {
          return object[key];
        });
      }

      module.exports = baseValues;
      /***/
    },
    /* 940 */

    /***/
    function (module, exports) {
      /** Used to compose unicode character classes. */
      var rsAstralRange = "\\ud800-\\udfff",
          rsComboMarksRange = "\\u0300-\\u036f",
          reComboHalfMarksRange = "\\ufe20-\\ufe2f",
          rsComboSymbolsRange = "\\u20d0-\\u20ff",
          rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
          rsVarRange = "\\ufe0e\\ufe0f";
      /** Used to compose unicode capture groups. */

      var rsAstral = '[' + rsAstralRange + ']',
          rsCombo = '[' + rsComboRange + ']',
          rsFitz = "\\ud83c[\\udffb-\\udfff]",
          rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
          rsNonAstral = '[^' + rsAstralRange + ']',
          rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          rsZWJ = "\\u200d";
      /** Used to compose unicode regexes. */

      var reOptMod = rsModifier + '?',
          rsOptVar = '[' + rsVarRange + ']?',
          rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
          rsSeq = rsOptVar + reOptMod + rsOptJoin,
          rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
      /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

      var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
      /**
       * Converts a Unicode `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */

      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }

      module.exports = unicodeToArray;
      /***/
    },
    /* 941 */

    /***/
    function (module, exports) {
      /** Used to compose unicode character classes. */
      var rsAstralRange = "\\ud800-\\udfff",
          rsComboMarksRange = "\\u0300-\\u036f",
          reComboHalfMarksRange = "\\ufe20-\\ufe2f",
          rsComboSymbolsRange = "\\u20d0-\\u20ff",
          rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
          rsVarRange = "\\ufe0e\\ufe0f";
      /** Used to compose unicode capture groups. */

      var rsZWJ = "\\u200d";
      /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

      var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
      /**
       * Checks if `string` contains Unicode symbols.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {boolean} Returns `true` if a symbol is found, else `false`.
       */

      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }

      module.exports = hasUnicode;
      /***/
    },
    /* 942 */

    /***/
    function (module, exports) {
      /**
       * Converts an ASCII `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */
      function asciiToArray(string) {
        return string.split('');
      }

      module.exports = asciiToArray;
      /***/
    },
    /* 943 */

    /***/
    function (module, exports, __webpack_require__) {
      var asciiToArray = __webpack_require__(942),
          hasUnicode = __webpack_require__(941),
          unicodeToArray = __webpack_require__(940);
      /**
       * Converts `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */


      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }

      module.exports = stringToArray;
      /***/
    },
    /* 944 */

    /***/
    function (module, exports) {
      /**
       * Converts `iterator` to an array.
       *
       * @private
       * @param {Object} iterator The iterator to convert.
       * @returns {Array} Returns the converted array.
       */
      function iteratorToArray(iterator) {
        var data,
            result = [];

        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }

        return result;
      }

      module.exports = iteratorToArray;
      /***/
    },
    /* 945 */

    /***/
    function (module, exports, __webpack_require__) {
      var getNative = __webpack_require__(157),
          root = __webpack_require__(103);
      /* Built-in method references that are verified to be native. */


      var WeakMap = getNative(root, 'WeakMap');
      module.exports = WeakMap;
      /***/
    },
    /* 946 */

    /***/
    function (module, exports, __webpack_require__) {
      var getNative = __webpack_require__(157),
          root = __webpack_require__(103);
      /* Built-in method references that are verified to be native. */


      var Promise = getNative(root, 'Promise');
      module.exports = Promise;
      /***/
    },
    /* 947 */

    /***/
    function (module, exports, __webpack_require__) {
      var getNative = __webpack_require__(157),
          root = __webpack_require__(103);
      /* Built-in method references that are verified to be native. */


      var DataView = getNative(root, 'DataView');
      module.exports = DataView;
      /***/
    },
    /* 948 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getRangeBoundingClientRect
       * @format
       * 
       */

      var getRangeClientRects = __webpack_require__(467);
      /**
       * Like range.getBoundingClientRect() but normalizes for browser bugs.
       */


      function getRangeBoundingClientRect(range) {
        // "Return a DOMRect object describing the smallest rectangle that includes
        // the first rectangle in list and all of the remaining rectangles of which
        // the height or width is not zero."
        // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
        var rects = getRangeClientRects(range);
        var top = 0;
        var right = 0;
        var bottom = 0;
        var left = 0;

        if (rects.length) {
          // If the first rectangle has 0 width, we use the second, this is needed
          // because Chrome renders a 0 width rectangle when the selection contains
          // a line break.
          if (rects.length > 1 && rects[0].width === 0) {
            var _rects$ = rects[1];
            top = _rects$.top;
            right = _rects$.right;
            bottom = _rects$.bottom;
            left = _rects$.left;
          } else {
            var _rects$2 = rects[0];
            top = _rects$2.top;
            right = _rects$2.right;
            bottom = _rects$2.bottom;
            left = _rects$2.left;
          }

          for (var ii = 1; ii < rects.length; ii++) {
            var rect = rects[ii];

            if (rect.height !== 0 && rect.width !== 0) {
              top = Math.min(top, rect.top);
              right = Math.max(right, rect.right);
              bottom = Math.max(bottom, rect.bottom);
              left = Math.min(left, rect.left);
            }
          }
        }

        return {
          top: top,
          right: right,
          bottom: bottom,
          left: left,
          width: right - left,
          height: bottom - top
        };
      }

      module.exports = getRangeBoundingClientRect;
      /***/
    },
    /* 949 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getVisibleSelectionRect
       * @format
       * 
       */

      var getRangeBoundingClientRect = __webpack_require__(948);
      /**
       * Return the bounding ClientRect for the visible DOM selection, if any.
       * In cases where there are no selected ranges or the bounding rect is
       * temporarily invalid, return null.
       */


      function getVisibleSelectionRect(global) {
        var selection = global.getSelection();

        if (!selection.rangeCount) {
          return null;
        }

        var range = selection.getRangeAt(0);
        var boundingRect = getRangeBoundingClientRect(range);
        var top = boundingRect.top,
            right = boundingRect.right,
            bottom = boundingRect.bottom,
            left = boundingRect.left; // When a re-render leads to a node being removed, the DOM selection will
        // temporarily be placed on an ancestor node, which leads to an invalid
        // bounding rect. Discard this state.

        if (top === 0 && right === 0 && bottom === 0 && left === 0) {
          return null;
        }

        return boundingRect;
      }

      module.exports = getVisibleSelectionRect;
      /***/
    },
    /* 950 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule decodeInlineStyleRanges
       * @format
       * 
       */

      var _require = __webpack_require__(53),
          OrderedSet = _require.OrderedSet;

      var UnicodeUtils = __webpack_require__(154);

      var substr = UnicodeUtils.substr;
      var EMPTY_SET = OrderedSet();
      /**
       * Convert to native JavaScript string lengths to determine ranges.
       */

      function decodeInlineStyleRanges(text, ranges) {
        var styles = Array(text.length).fill(EMPTY_SET);

        if (ranges) {
          ranges.forEach(function (
          /*object*/
          range) {
            var cursor = substr(text, 0, range.offset).length;
            var end = cursor + substr(text, range.offset, range.length).length;

            while (cursor < end) {
              styles[cursor] = styles[cursor].add(range.style);
              cursor++;
            }
          });
        }

        return styles;
      }

      module.exports = decodeInlineStyleRanges;
      /***/
    },
    /* 951 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule decodeEntityRanges
       * @format
       * 
       */

      var UnicodeUtils = __webpack_require__(154);

      var substr = UnicodeUtils.substr;
      /**
       * Convert to native JavaScript string lengths to determine ranges.
       */

      function decodeEntityRanges(text, ranges) {
        var entities = Array(text.length).fill(null);

        if (ranges) {
          ranges.forEach(function (range) {
            // Using Unicode-enabled substrings converted to JavaScript lengths,
            // fill the output array with entity keys.
            var start = substr(text, 0, range.offset).length;
            var end = start + substr(text, range.offset, range.length).length;

            for (var ii = start; ii < end; ii++) {
              entities[ii] = range.key;
            }
          });
        }

        return entities;
      }

      module.exports = decodeEntityRanges;
      /***/
    },
    /* 952 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule createCharacterList
       * @format
       * 
       */

      var CharacterMetadata = __webpack_require__(96);

      var Immutable = __webpack_require__(53);

      var List = Immutable.List;

      function createCharacterList(inlineStyles, entities) {
        var characterArray = inlineStyles.map(function (style, ii) {
          var entity = entities[ii];
          return CharacterMetadata.create({
            style: style,
            entity: entity
          });
        });
        return List(characterArray);
      }

      module.exports = createCharacterList;
      /***/
    },
    /* 953 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var _assign = __webpack_require__(82);

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftTreeAdapter
       * @format
       * 
       *
       * This is unstable and not part of the public API and should not be used by
       * production systems. This file may be update/removed without notice.
       */


      var invariant = __webpack_require__(51);

      var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
        var stack = [].concat(blocks).reverse();

        while (stack.length) {
          var _block = stack.pop();

          fn(_block);
          var children = _block.children;
          !Array.isArray(children) ? false ? undefined : invariant(false) : void 0;
          stack = stack.concat([].concat(children.reverse()));
        }
      };

      var isListBlock = function isListBlock(block) {
        if (!(block && block.type)) {
          return false;
        }

        var type = block.type;
        return type === 'unordered-list-item' || type === 'ordered-list-item';
      };

      var addDepthToChildren = function addDepthToChildren(block) {
        if (Array.isArray(block.children)) {
          block.children = block.children.map(function (child) {
            return child.type === block.type ? _extends({}, child, {
              depth: (block.depth || 0) + 1
            }) : child;
          });
        }
      };
      /**
       * This adapter is intended to be be used as an adapter to draft tree data
       *
       * draft state <=====> draft tree state
       */


      var DraftTreeAdapter = {
        /**
         * Converts from a tree raw state back to  draft raw state
         */
        fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
          var blocks = draftTreeState.blocks;
          var transformedBlocks = [];
          !Array.isArray(blocks) ? false ? undefined : invariant(false) : void 0;

          if (!Array.isArray(blocks) || !blocks.length) {
            return draftTreeState;
          }

          traverseInDepthOrder(blocks, function (block) {
            var newBlock = _extends({}, block);

            if (isListBlock(block)) {
              newBlock.depth = newBlock.depth || 0;
              addDepthToChildren(block);
            }

            delete newBlock.children;
            transformedBlocks.push(newBlock);
          });
          draftTreeState.blocks = transformedBlocks;
          return _extends({}, draftTreeState, {
            blocks: transformedBlocks
          });
        },

        /**
         * Converts from draft raw state to tree draft state
         */
        fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
          var lastListDepthCacheRef = {};
          var transformedBlocks = [];
          draftState.blocks.forEach(function (block) {
            var isList = isListBlock(block);
            var depth = block.depth || 0;

            var treeBlock = _extends({}, block, {
              children: []
            });

            if (!isList) {
              // reset the cache path
              lastListDepthCacheRef = {};
              transformedBlocks.push(treeBlock);
              return;
            } // update our depth cache reference path


            lastListDepthCacheRef[depth] = treeBlock; // if we are greater than zero we must have seen a parent already

            if (depth > 0) {
              var parent = lastListDepthCacheRef[depth - 1];
              !parent ? false ? undefined : invariant(false) : void 0; // push nested list blocks

              parent.children.push(treeBlock);
              return;
            } // push root list blocks


            transformedBlocks.push(treeBlock);
          });
          return _extends({}, draftState, {
            blocks: transformedBlocks
          });
        }
      };
      module.exports = DraftTreeAdapter;
      /***/
    },
    /* 954 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule convertFromRawToDraftState
       * @format
       * 
       */

      var _assign = __webpack_require__(82);

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var ContentBlock = __webpack_require__(155);

      var ContentBlockNode = __webpack_require__(102);

      var ContentState = __webpack_require__(344);

      var DraftEntity = __webpack_require__(241);

      var DraftFeatureFlags = __webpack_require__(133);

      var DraftTreeAdapter = __webpack_require__(953);

      var Immutable = __webpack_require__(53);

      var SelectionState = __webpack_require__(174);

      var createCharacterList = __webpack_require__(952);

      var decodeEntityRanges = __webpack_require__(951);

      var decodeInlineStyleRanges = __webpack_require__(950);

      var generateRandomKey = __webpack_require__(127);

      var invariant = __webpack_require__(51);

      var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
      var List = Immutable.List,
          Map = Immutable.Map,
          OrderedMap = Immutable.OrderedMap;

      var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
        var key = block.key,
            type = block.type,
            data = block.data,
            text = block.text,
            depth = block.depth;
        var blockNodeConfig = {
          text: text,
          depth: depth || 0,
          type: type || 'unstyled',
          key: key || generateRandomKey(),
          data: Map(data),
          characterList: decodeCharacterList(block, entityMap)
        };
        return blockNodeConfig;
      };

      var decodeCharacterList = function decodeCharacterList(block, entityMap) {
        var text = block.text,
            rawEntityRanges = block.entityRanges,
            rawInlineStyleRanges = block.inlineStyleRanges;
        var entityRanges = rawEntityRanges || [];
        var inlineStyleRanges = rawInlineStyleRanges || []; // Translate entity range keys to the DraftEntity map.

        return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
          return entityMap.hasOwnProperty(range.key);
        }).map(function (range) {
          return _extends({}, range, {
            key: entityMap[range.key]
          });
        })));
      };

      var addKeyIfMissing = function addKeyIfMissing(block) {
        return _extends({}, block, {
          key: block.key || generateRandomKey()
        });
      };
      /**
       * Node stack is responsible to ensure we traverse the tree only once
       * in depth order, while also providing parent refs to inner nodes to
       * construct their links.
       */


      var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
        var nodesWithParentRef = nodes.map(function (block) {
          return _extends({}, block, {
            parentRef: parentRef
          });
        }); // since we pop nodes from the stack we need to insert them in reverse

        return stack.concat(nodesWithParentRef.reverse());
      };
      /**
       * This will build a tree draft content state by creating the node
       * reference links into a single tree walk. Each node has a link
       * reference to "parent", "children", "nextSibling" and "prevSibling"
       * blockMap will be created using depth ordering.
       */


      var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
        return blocks // ensure children have valid keys to enable sibling links
        .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
          !Array.isArray(block.children) ? false ? undefined : invariant(false) : void 0; // ensure children have valid keys to enable sibling links

          var children = block.children.map(addKeyIfMissing); // root level nodes

          var contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(block, entityMap), {
            prevSibling: index === 0 ? null : blocks[index - 1].key,
            nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
            children: List(children.map(function (child) {
              return child.key;
            }))
          })); // push root node to blockMap

          blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

          var stack = updateNodeStack([], children, contentBlockNode); // start computing children nodes

          while (stack.length > 0) {
            // we pop from the stack and start processing this node
            var node = stack.pop(); // parentRef already points to a converted ContentBlockNode

            var parentRef = node.parentRef;
            var siblings = parentRef.getChildKeys();

            var _index = siblings.indexOf(node.key);

            var isValidBlock = Array.isArray(node.children);

            if (!isValidBlock) {
              !isValidBlock ? false ? undefined : invariant(false) : void 0;
              break;
            } // ensure children have valid keys to enable sibling links


            var _children = node.children.map(addKeyIfMissing);

            var _contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(node, entityMap), {
              parent: parentRef.getKey(),
              children: List(_children.map(function (child) {
                return child.key;
              })),
              prevSibling: _index === 0 ? null : siblings.get(_index - 1),
              nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
            })); // push node to blockMap


            blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

            stack = updateNodeStack(stack, _children, _contentBlockNode);
          }

          return blockMap;
        }, OrderedMap());
      };

      var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
        return OrderedMap(blocks.map(function (block) {
          var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
          return [contentBlock.getKey(), contentBlock];
        }));
      };

      var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
        var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
        var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

        if (!experimentalTreeDataSupport) {
          return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
        }

        return decodeContentBlockNodes(rawBlocks, entityMap);
      };

      var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
        var rawEntityMap = rawState.entityMap;
        var entityMap = {}; // TODO: Update this once we completely remove DraftEntity

        Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
          var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
              type = _rawEntityMap$rawEnti.type,
              mutability = _rawEntityMap$rawEnti.mutability,
              data = _rawEntityMap$rawEnti.data; // get the key reference to created entity

          entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
        });
        return entityMap;
      };

      var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
        !Array.isArray(rawState.blocks) ? false ? undefined : invariant(false) : void 0; // decode entities

        var entityMap = decodeRawEntityMap(rawState); // decode blockMap

        var blockMap = decodeRawBlocks(rawState, entityMap); // create initial selection

        var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
        return new ContentState({
          blockMap: blockMap,
          entityMap: entityMap,
          selectionBefore: selectionState,
          selectionAfter: selectionState
        });
      };

      module.exports = convertFromRawToDraftState;
      /***/
    },
    /* 955 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule encodeInlineStyleRanges
       * @format
       * 
       */

      var UnicodeUtils = __webpack_require__(154);

      var findRangesImmutable = __webpack_require__(205);

      var areEqual = function areEqual(a, b) {
        return a === b;
      };

      var isTruthy = function isTruthy(a) {
        return !!a;
      };

      var EMPTY_ARRAY = [];
      /**
       * Helper function for getting encoded styles for each inline style. Convert
       * to UTF-8 character counts for storage.
       */

      function getEncodedInlinesForType(block, styleList, styleToEncode) {
        var ranges = []; // Obtain an array with ranges for only the specified style.

        var filteredInlines = styleList.map(function (style) {
          return style.has(styleToEncode);
        }).toList();
        findRangesImmutable(filteredInlines, areEqual, // We only want to keep ranges with nonzero style values.
        isTruthy, function (start, end) {
          var text = block.getText();
          ranges.push({
            offset: UnicodeUtils.strlen(text.slice(0, start)),
            length: UnicodeUtils.strlen(text.slice(start, end)),
            style: styleToEncode
          });
        });
        return ranges;
      }
      /*
       * Retrieve the encoded arrays of inline styles, with each individual style
       * treated separately.
       */


      function encodeInlineStyleRanges(block) {
        var styleList = block.getCharacterList().map(function (c) {
          return c.getStyle();
        }).toList();
        var ranges = styleList.flatten().toSet().map(function (style) {
          return getEncodedInlinesForType(block, styleList, style);
        });
        return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
      }

      module.exports = encodeInlineStyleRanges;
      /***/
    },
    /* 956 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule encodeEntityRanges
       * @format
       * 
       */

      var DraftStringKey = __webpack_require__(459);

      var UnicodeUtils = __webpack_require__(154);

      var strlen = UnicodeUtils.strlen;
      /**
       * Convert to UTF-8 character counts for storage.
       */

      function encodeEntityRanges(block, storageMap) {
        var encoded = [];
        block.findEntityRanges(function (character) {
          return !!character.getEntity();
        }, function (
        /*number*/
        start,
        /*number*/
        end) {
          var text = block.getText();
          var key = block.getEntityAt(start);
          encoded.push({
            offset: strlen(text.slice(0, start)),
            length: strlen(text.slice(start, end)),
            // Encode the key as a number for range storage.
            key: Number(storageMap[DraftStringKey.stringify(key)])
          });
        });
        return encoded;
      }

      module.exports = encodeEntityRanges;
      /***/
    },
    /* 957 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule convertFromDraftStateToRaw
       * @format
       * 
       */

      var _assign = __webpack_require__(82);

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var ContentBlock = __webpack_require__(155);

      var ContentBlockNode = __webpack_require__(102);

      var DraftStringKey = __webpack_require__(459);

      var encodeEntityRanges = __webpack_require__(956);

      var encodeInlineStyleRanges = __webpack_require__(955);

      var invariant = __webpack_require__(51);

      var createRawBlock = function createRawBlock(block, entityStorageMap) {
        return {
          key: block.getKey(),
          text: block.getText(),
          type: block.getType(),
          depth: block.getDepth(),
          inlineStyleRanges: encodeInlineStyleRanges(block),
          entityRanges: encodeEntityRanges(block, entityStorageMap),
          data: block.getData().toObject()
        };
      };

      var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
        if (block instanceof ContentBlock) {
          rawBlocks.push(createRawBlock(block, entityMap));
          return;
        }

        !(block instanceof ContentBlockNode) ? false ? undefined : invariant(false) : void 0;
        var parentKey = block.getParentKey();

        var rawBlock = blockCacheRef[block.getKey()] = _extends({}, createRawBlock(block, entityMap), {
          children: []
        });

        if (parentKey) {
          blockCacheRef[parentKey].children.push(rawBlock);
          return;
        }

        rawBlocks.push(rawBlock);
      };

      var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
        var entityMap = rawState.entityMap;
        var rawBlocks = [];
        var blockCacheRef = {};
        var entityCacheRef = {};
        var entityStorageKey = 0;
        contentState.getBlockMap().forEach(function (block) {
          block.findEntityRanges(function (character) {
            return character.getEntity() !== null;
          }, function (start) {
            var entityKey = block.getEntityAt(start); // Stringify to maintain order of otherwise numeric keys.

            var stringifiedEntityKey = DraftStringKey.stringify(entityKey); // This makes this function resilient to two entities
            // erroneously having the same key

            if (entityCacheRef[stringifiedEntityKey]) {
              return;
            }

            entityCacheRef[stringifiedEntityKey] = entityKey; // we need the `any` casting here since this is a temporary state
            // where we will later on flip the entity map and populate it with
            // real entity, at this stage we just need to map back the entity
            // key used by the BlockNode

            entityMap[stringifiedEntityKey] = '' + entityStorageKey;
            entityStorageKey++;
          });
          insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
        });
        return {
          blocks: rawBlocks,
          entityMap: entityMap
        };
      }; // Flip storage map so that our storage keys map to global
      // DraftEntity keys.


      var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
        var blocks = rawState.blocks,
            entityMap = rawState.entityMap;
        var rawEntityMap = {};
        Object.keys(entityMap).forEach(function (key, index) {
          var entity = contentState.getEntity(DraftStringKey.unstringify(key));
          rawEntityMap[index] = {
            type: entity.getType(),
            mutability: entity.getMutability(),
            data: entity.getData()
          };
        });
        return {
          blocks: blocks,
          entityMap: rawEntityMap
        };
      };

      var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
        var rawDraftContentState = {
          entityMap: {},
          blocks: []
        }; // add blocks

        rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState); // add entities

        rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
        return rawDraftContentState;
      };

      module.exports = convertFromDraftStateToRaw;
      /***/
    },
    /* 958 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEditorPlaceholder.react
       * @format
       * 
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var React = __webpack_require__(1);

      var cx = __webpack_require__(173);
      /**
       * This component is responsible for rendering placeholder text for the
       * `DraftEditor` component.
       *
       * Override placeholder style via CSS.
       */


      var DraftEditorPlaceholder = function (_React$Component) {
        _inherits(DraftEditorPlaceholder, _React$Component);

        function DraftEditorPlaceholder() {
          _classCallCheck(this, DraftEditorPlaceholder);

          return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
        };

        DraftEditorPlaceholder.prototype.render = function render() {
          var hasFocus = this.props.editorState.getSelection().getHasFocus();
          var className = cx({
            'public/DraftEditorPlaceholder/root': true,
            'public/DraftEditorPlaceholder/hasFocus': hasFocus
          });
          var contentStyle = {
            whiteSpace: 'pre-wrap'
          };
          return React.createElement('div', {
            className: className
          }, React.createElement('div', {
            className: cx('public/DraftEditorPlaceholder/inner'),
            id: this.props.accessibilityID,
            style: contentStyle
          }, this.props.text));
        };

        return DraftEditorPlaceholder;
      }(React.Component);

      module.exports = DraftEditorPlaceholder;
      /***/
    },
    /* 959 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (global) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        * All rights reserved.
        *
        * This source code is licensed under the BSD-style license found in the
        * LICENSE file in the root directory of this source tree. An additional grant
        * of patent rights can be found in the PATENTS file in the same directory.
        *
        * @providesModule getDraftEditorSelection
        * @format
        * 
        */
        var getDraftEditorSelectionWithNodes = __webpack_require__(466);
        /**
         * Convert the current selection range to an anchor/focus pair of offset keys
         * and values that can be interpreted by components.
         */


        function getDraftEditorSelection(editorState, root) {
          var selection = global.getSelection(); // No active selection.

          if (selection.rangeCount === 0) {
            return {
              selectionState: editorState.getSelection().set('hasFocus', false),
              needsRecovery: false
            };
          }

          return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
        }

        module.exports = getDraftEditorSelection;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 960 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule editOnSelect
       * @format
       * 
       */

      var EditorState = __webpack_require__(60);

      var ReactDOM = __webpack_require__(16);

      var getDraftEditorSelection = __webpack_require__(959);

      var invariant = __webpack_require__(51);

      function editOnSelect(editor) {
        if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
          return;
        }

        var editorState = editor.props.editorState;
        var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
        !editorNode ? false ? undefined : invariant(false) : void 0;
        !(editorNode.firstChild instanceof HTMLElement) ? false ? undefined : invariant(false) : void 0;
        var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild);
        var updatedSelectionState = documentSelection.selectionState;

        if (updatedSelectionState !== editorState.getSelection()) {
          if (documentSelection.needsRecovery) {
            editorState = EditorState.forceSelection(editorState, updatedSelectionState);
          } else {
            editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
          }

          editor.update(editorState);
        }
      }

      module.exports = editOnSelect;
      /***/
    },
    /* 961 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule splitTextIntoTextBlocks
       * @format
       * 
       */

      var NEWLINE_REGEX = /\r\n?|\n/g;

      function splitTextIntoTextBlocks(text) {
        return text.split(NEWLINE_REGEX);
      }

      module.exports = splitTextIntoTextBlocks;
      /***/
    },
    /* 962 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule adjustBlockDepthForContentState
       * @format
       * 
       */

      function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
        var startKey = selectionState.getStartKey();
        var endKey = selectionState.getEndKey();
        var blockMap = contentState.getBlockMap();
        var blocks = blockMap.toSeq().skipUntil(function (_, k) {
          return k === startKey;
        }).takeUntil(function (_, k) {
          return k === endKey;
        }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
          var depth = block.getDepth() + adjustment;
          depth = Math.max(0, Math.min(depth, maxDepth));
          return block.set('depth', depth);
        });
        blockMap = blockMap.merge(blocks);
        return contentState.merge({
          blockMap: blockMap,
          selectionBefore: selectionState,
          selectionAfter: selectionState
        });
      }

      module.exports = adjustBlockDepthForContentState;
      /***/
    },
    /* 963 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * 
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var URI = function () {
        function URI(uri) {
          _classCallCheck(this, URI);

          this._uri = uri;
        }

        URI.prototype.toString = function toString() {
          return this._uri;
        };

        return URI;
      }();

      module.exports = URI;
      /***/
    },
    /* 964 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftPasteProcessor
       * @format
       * 
       */

      var _assign = __webpack_require__(82);

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var CharacterMetadata = __webpack_require__(96);

      var ContentBlock = __webpack_require__(155);

      var ContentBlockNode = __webpack_require__(102);

      var DraftFeatureFlags = __webpack_require__(133);

      var Immutable = __webpack_require__(53);

      var convertFromHTMLtoContentBlocks = __webpack_require__(463);

      var generateRandomKey = __webpack_require__(127);

      var getSafeBodyFromHTML = __webpack_require__(462);

      var sanitizeDraftText = __webpack_require__(343);

      var List = Immutable.List,
          Repeat = Immutable.Repeat;
      var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
      var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
      var DraftPasteProcessor = {
        processHTML: function processHTML(html, blockRenderMap) {
          return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
        },
        processText: function processText(textBlocks, character, type) {
          return textBlocks.reduce(function (acc, textLine, index) {
            textLine = sanitizeDraftText(textLine);
            var key = generateRandomKey();
            var blockNodeConfig = {
              key: key,
              type: type,
              text: textLine,
              characterList: List(Repeat(character, textLine.length))
            }; // next block updates previous block

            if (experimentalTreeDataSupport && index !== 0) {
              var prevSiblingIndex = index - 1; // update previous block

              var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
                nextSibling: key
              });
              blockNodeConfig = _extends({}, blockNodeConfig, {
                prevSibling: previousBlock.getKey()
              });
            }

            acc.push(new ContentBlockRecord(blockNodeConfig));
            return acc;
          }, []);
        }
      };
      module.exports = DraftPasteProcessor;
      /***/
    },
    /* 965 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule editOnPaste
       * @format
       * 
       */

      var BlockMapBuilder = __webpack_require__(206);

      var CharacterMetadata = __webpack_require__(96);

      var DataTransfer = __webpack_require__(472);

      var DraftModifier = __webpack_require__(93);

      var DraftPasteProcessor = __webpack_require__(964);

      var EditorState = __webpack_require__(60);

      var RichTextEditorUtil = __webpack_require__(461);

      var getEntityKeyForSelection = __webpack_require__(339);

      var getTextContentFromFiles = __webpack_require__(470);

      var isEventHandled = __webpack_require__(204);

      var splitTextIntoTextBlocks = __webpack_require__(961);
      /**
       * Paste content.
       */


      function editOnPaste(editor, e) {
        e.preventDefault();
        var data = new DataTransfer(e.clipboardData); // Get files, unless this is likely to be a string the user wants inline.

        if (!data.isRichText()) {
          var files = data.getFiles();
          var defaultFileText = data.getText();

          if (files.length > 0) {
            // Allow customized paste handling for images, etc. Otherwise, fall
            // through to insert text contents into the editor.
            if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
              return;
            }

            getTextContentFromFiles(files, function (
            /*string*/
            fileText) {
              fileText = fileText || defaultFileText;

              if (!fileText) {
                return;
              }

              var editorState = editor._latestEditorState;
              var blocks = splitTextIntoTextBlocks(fileText);
              var character = CharacterMetadata.create({
                style: editorState.getCurrentInlineStyle(),
                entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
              });
              var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
              var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
              var fragment = BlockMapBuilder.createFromArray(text);
              var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
              editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
            });
            return;
          }
        }

        var textBlocks = [];
        var text = data.getText();
        var html = data.getHTML();
        var editorState = editor._latestEditorState;

        if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
          return;
        }

        if (text) {
          textBlocks = splitTextIntoTextBlocks(text);
        }

        if (!editor.props.stripPastedStyles) {
          // If the text from the paste event is rich content that matches what we
          // already have on the internal clipboard, assume that we should just use
          // the clipboard fragment for the paste. This will allow us to preserve
          // styling and entities, if any are present. Note that newlines are
          // stripped during comparison -- this is because copy/paste within the
          // editor in Firefox and IE will not include empty lines. The resulting
          // paste will preserve the newlines correctly.
          var internalClipboard = editor.getClipboard();

          if (data.isRichText() && internalClipboard) {
            if ( // If the editorKey is present in the pasted HTML, it should be safe to
            // assume this is an internal paste.
            html.indexOf(editor.getEditorKey()) !== -1 || // The copy may have been made within a single block, in which case the
            // editor key won't be part of the paste. In this case, just check
            // whether the pasted text matches the internal clipboard.
            textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
              editor.update(insertFragment(editor._latestEditorState, internalClipboard));
              return;
            }
          } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
            // Safari does not properly store text/html in some cases.
            // Use the internalClipboard if present and equal to what is on
            // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
            editor.update(insertFragment(editor._latestEditorState, internalClipboard));
            return;
          } // If there is html paste data, try to parse that.


          if (html) {
            var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);

            if (htmlFragment) {
              var contentBlocks = htmlFragment.contentBlocks,
                  entityMap = htmlFragment.entityMap;

              if (contentBlocks) {
                var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
                editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
                return;
              }
            }
          } // Otherwise, create a new fragment from our pasted text. Also
          // empty the internal clipboard, since it's no longer valid.


          editor.setClipboard(null);
        }

        if (textBlocks.length) {
          var character = CharacterMetadata.create({
            style: editorState.getCurrentInlineStyle(),
            entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
          });
          var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
          var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
          var textMap = BlockMapBuilder.createFromArray(textFragment);
          editor.update(insertFragment(editor._latestEditorState, textMap));
        }
      }

      function insertFragment(editorState, fragment, entityMap) {
        var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment); // TODO: merge the entity map once we stop using DraftEntity
        // like this:
        // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

        return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
      }

      function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
        return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
          return block.getText() === textBlocks[ii];
        });
      }

      module.exports = editOnPaste;
      /***/
    },
    /* 966 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule keyCommandUndo
       * @format
       * 
       */

      var EditorState = __webpack_require__(60);

      function keyCommandUndo(e, editorState, updateFn) {
        var undoneState = EditorState.undo(editorState); // If the last change to occur was a spellcheck change, allow the undo
        // event to fall through to the browser. This allows the browser to record
        // the unwanted change, which should soon lead it to learn not to suggest
        // the correction again.

        if (editorState.getLastChangeType() === 'spellcheck-change') {
          var nativelyRenderedContent = undoneState.getCurrentContent();
          updateFn(EditorState.set(undoneState, {
            nativelyRenderedContent: nativelyRenderedContent
          }));
          return;
        } // Otheriwse, manage the undo behavior manually.


        e.preventDefault();

        if (!editorState.getNativelyRenderedContent()) {
          updateFn(undoneState);
          return;
        } // Trigger a re-render with the current content state to ensure that the
        // component tree has up-to-date props for comparison.


        updateFn(EditorState.set(editorState, {
          nativelyRenderedContent: null
        })); // Wait to ensure that the re-render has occurred before performing
        // the undo action.

        setTimeout(function () {
          updateFn(undoneState);
        }, 0);
      }

      module.exports = keyCommandUndo;
      /***/
    },
    /* 967 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule keyCommandTransposeCharacters
       * @format
       * 
       */

      var DraftModifier = __webpack_require__(93);

      var EditorState = __webpack_require__(60);

      var getContentStateFragment = __webpack_require__(242);
      /**
       * Transpose the characters on either side of a collapsed cursor, or
       * if the cursor is at the end of the block, transpose the last two
       * characters.
       */


      function keyCommandTransposeCharacters(editorState) {
        var selection = editorState.getSelection();

        if (!selection.isCollapsed()) {
          return editorState;
        }

        var offset = selection.getAnchorOffset();

        if (offset === 0) {
          return editorState;
        }

        var blockKey = selection.getAnchorKey();
        var content = editorState.getCurrentContent();
        var block = content.getBlockForKey(blockKey);
        var length = block.getLength(); // Nothing to transpose if there aren't two characters.

        if (length <= 1) {
          return editorState;
        }

        var removalRange;
        var finalSelection;

        if (offset === length) {
          // The cursor is at the end of the block. Swap the last two characters.
          removalRange = selection.set('anchorOffset', offset - 1);
          finalSelection = selection;
        } else {
          removalRange = selection.set('focusOffset', offset + 1);
          finalSelection = removalRange.set('anchorOffset', offset + 1);
        } // Extract the character to move as a fragment. This preserves its
        // styling and entity, if any.


        var movedFragment = getContentStateFragment(content, removalRange);
        var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward'); // After the removal, the insertion target is one character back.

        var selectionAfter = afterRemoval.getSelectionAfter();
        var targetOffset = selectionAfter.getAnchorOffset() - 1;
        var targetRange = selectionAfter.merge({
          anchorOffset: targetOffset,
          focusOffset: targetOffset
        });
        var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
        var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
        return EditorState.acceptSelection(newEditorState, finalSelection);
      }

      module.exports = keyCommandTransposeCharacters;
      /***/
    },
    /* 968 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule keyCommandPlainDelete
       * @format
       * 
       */

      var EditorState = __webpack_require__(60);

      var UnicodeUtils = __webpack_require__(154);

      var moveSelectionForward = __webpack_require__(464);

      var removeTextWithStrategy = __webpack_require__(203);
      /**
       * Remove the selected range. If the cursor is collapsed, remove the following
       * character. This operation is Unicode-aware, so removing a single character
       * will remove a surrogate pair properly as well.
       */


      function keyCommandPlainDelete(editorState) {
        var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
          var selection = strategyState.getSelection();
          var content = strategyState.getCurrentContent();
          var key = selection.getAnchorKey();
          var offset = selection.getAnchorOffset();
          var charAhead = content.getBlockForKey(key).getText()[offset];
          return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
        }, 'forward');

        if (afterRemoval === editorState.getCurrentContent()) {
          return editorState;
        }

        var selection = editorState.getSelection();
        return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
      }

      module.exports = keyCommandPlainDelete;
      /***/
    },
    /* 969 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule keyCommandPlainBackspace
       * @format
       * 
       */

      var EditorState = __webpack_require__(60);

      var UnicodeUtils = __webpack_require__(154);

      var moveSelectionBackward = __webpack_require__(332);

      var removeTextWithStrategy = __webpack_require__(203);
      /**
       * Remove the selected range. If the cursor is collapsed, remove the preceding
       * character. This operation is Unicode-aware, so removing a single character
       * will remove a surrogate pair properly as well.
       */


      function keyCommandPlainBackspace(editorState) {
        var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
          var selection = strategyState.getSelection();
          var content = strategyState.getCurrentContent();
          var key = selection.getAnchorKey();
          var offset = selection.getAnchorOffset();
          var charBehind = content.getBlockForKey(key).getText()[offset - 1];
          return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
        }, 'backward');

        if (afterRemoval === editorState.getCurrentContent()) {
          return editorState;
        }

        var selection = editorState.getSelection();
        return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
      }

      module.exports = keyCommandPlainBackspace;
      /***/
    },
    /* 970 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule keyCommandMoveSelectionToStartOfBlock
       * @format
       * 
       */

      var EditorState = __webpack_require__(60);
      /**
       * Collapse selection at the start of the first selected block. This is used
       * for Firefox versions that attempt to navigate forward/backward instead of
       * moving the cursor. Other browsers are able to move the cursor natively.
       */


      function keyCommandMoveSelectionToStartOfBlock(editorState) {
        var selection = editorState.getSelection();
        var startKey = selection.getStartKey();
        return EditorState.set(editorState, {
          selection: selection.merge({
            anchorKey: startKey,
            anchorOffset: 0,
            focusKey: startKey,
            focusOffset: 0,
            isBackward: false
          }),
          forceSelection: true
        });
      }

      module.exports = keyCommandMoveSelectionToStartOfBlock;
      /***/
    },
    /* 971 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule keyCommandMoveSelectionToEndOfBlock
       * @format
       * 
       */

      var EditorState = __webpack_require__(60);
      /**
       * See comment for `moveSelectionToStartOfBlock`.
       */


      function keyCommandMoveSelectionToEndOfBlock(editorState) {
        var selection = editorState.getSelection();
        var endKey = selection.getEndKey();
        var content = editorState.getCurrentContent();
        var textLength = content.getBlockForKey(endKey).getLength();
        return EditorState.set(editorState, {
          selection: selection.merge({
            anchorKey: endKey,
            anchorOffset: textLength,
            focusKey: endKey,
            focusOffset: textLength,
            isBackward: false
          }),
          forceSelection: true
        });
      }

      module.exports = keyCommandMoveSelectionToEndOfBlock;
      /***/
    },
    /* 972 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule keyCommandInsertNewline
       * @format
       * 
       */

      var DraftModifier = __webpack_require__(93);

      var EditorState = __webpack_require__(60);

      function keyCommandInsertNewline(editorState) {
        var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
        return EditorState.push(editorState, contentState, 'split-block');
      }

      module.exports = keyCommandInsertNewline;
      /***/
    },
    /* 973 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule keyCommandDeleteWord
       * @format
       * 
       */

      var DraftRemovableWord = __webpack_require__(465);

      var EditorState = __webpack_require__(60);

      var moveSelectionForward = __webpack_require__(464);

      var removeTextWithStrategy = __webpack_require__(203);
      /**
       * Delete the word that is right of the cursor, as well as any spaces or
       * punctuation before the word.
       */


      function keyCommandDeleteWord(editorState) {
        var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
          var selection = strategyState.getSelection();
          var offset = selection.getStartOffset();
          var key = selection.getStartKey();
          var content = strategyState.getCurrentContent();
          var text = content.getBlockForKey(key).getText().slice(offset);
          var toRemove = DraftRemovableWord.getForward(text); // If there are no words in front of the cursor, remove the newline.

          return moveSelectionForward(strategyState, toRemove.length || 1);
        }, 'forward');

        if (afterRemoval === editorState.getCurrentContent()) {
          return editorState;
        }

        return EditorState.push(editorState, afterRemoval, 'remove-range');
      }

      module.exports = keyCommandDeleteWord;
      /***/
    },
    /* 974 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       * @stub
       * 
       */
      // \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
      //             is latin supplement punctuation except fractions and superscript
      //             numbers
      // \u2010-\u2027\u2030-\u205e
      //             is punctuation from the general punctuation block:
      //             weird quotes, commas, bullets, dashes, etc.
      // \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
      //             is CJK punctuation
      // \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
      //             is some full-width/half-width punctuation
      // \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
      //             is some Arabic punctuation marks
      // \u1801\u0964\u104a\u104b
      //             is misc. other language punctuation marks

      var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + "\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F" + "\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D" + "\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E" + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';
      module.exports = {
        getPunctuation: function getPunctuation() {
          return PUNCTUATION;
        }
      };
      /***/
    },
    /* 975 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule keyCommandBackspaceWord
       * @format
       * 
       */

      var DraftRemovableWord = __webpack_require__(465);

      var EditorState = __webpack_require__(60);

      var moveSelectionBackward = __webpack_require__(332);

      var removeTextWithStrategy = __webpack_require__(203);
      /**
       * Delete the word that is left of the cursor, as well as any spaces or
       * punctuation after the word.
       */


      function keyCommandBackspaceWord(editorState) {
        var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
          var selection = strategyState.getSelection();
          var offset = selection.getStartOffset(); // If there are no words before the cursor, remove the preceding newline.

          if (offset === 0) {
            return moveSelectionBackward(strategyState, 1);
          }

          var key = selection.getStartKey();
          var content = strategyState.getCurrentContent();
          var text = content.getBlockForKey(key).getText().slice(0, offset);
          var toRemove = DraftRemovableWord.getBackward(text);
          return moveSelectionBackward(strategyState, toRemove.length || 1);
        }, 'backward');

        if (afterRemoval === editorState.getCurrentContent()) {
          return editorState;
        }

        return EditorState.push(editorState, afterRemoval, 'remove-range');
      }

      module.exports = keyCommandBackspaceWord;
      /***/
    },
    /* 976 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule expandRangeToStartOfLine
       * @format
       * 
       */

      var UnicodeUtils = __webpack_require__(154);

      var getRangeClientRects = __webpack_require__(467);

      var invariant = __webpack_require__(51);
      /**
       * Return the computed line height, in pixels, for the provided element.
       */


      function getLineHeightPx(element) {
        var computed = getComputedStyle(element);
        var div = document.createElement('div');
        div.style.fontFamily = computed.fontFamily;
        div.style.fontSize = computed.fontSize;
        div.style.fontStyle = computed.fontStyle;
        div.style.fontWeight = computed.fontWeight;
        div.style.lineHeight = computed.lineHeight;
        div.style.position = 'absolute';
        div.textContent = 'M';
        var documentBody = document.body;
        !documentBody ? false ? undefined : invariant(false) : void 0; // forced layout here

        documentBody.appendChild(div);
        var rect = div.getBoundingClientRect();
        documentBody.removeChild(div);
        return rect.height;
      }
      /**
       * Return whether every ClientRect in the provided list lies on the same line.
       *
       * We assume that the rects on the same line all contain the baseline, so the
       * lowest top line needs to be above the highest bottom line (i.e., if you were
       * to project the rects onto the y-axis, their intersection would be nonempty).
       *
       * In addition, we require that no two boxes are lineHeight (or more) apart at
       * either top or bottom, which helps protect against false positives for fonts
       * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
       * produces rects of height 58px!).
       */


      function areRectsOnOneLine(rects, lineHeight) {
        var minTop = Infinity;
        var minBottom = Infinity;
        var maxTop = -Infinity;
        var maxBottom = -Infinity;

        for (var ii = 0; ii < rects.length; ii++) {
          var rect = rects[ii];

          if (rect.width === 0 || rect.width === 1) {
            // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
            // Safari) include an empty rect on the previous or next line. When the
            // text lies in a container whose position is not integral (e.g., from
            // margin: auto), Safari makes these empty rects have width 1 (instead of
            // 0). Having one-pixel-wide characters seems unlikely (and most browsers
            // report widths in subpixel precision anyway) so it's relatively safe to
            // skip over them.
            continue;
          }

          minTop = Math.min(minTop, rect.top);
          minBottom = Math.min(minBottom, rect.bottom);
          maxTop = Math.max(maxTop, rect.top);
          maxBottom = Math.max(maxBottom, rect.bottom);
        }

        return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
      }
      /**
       * Return the length of a node, as used by Range offsets.
       */


      function getNodeLength(node) {
        // http://www.w3.org/TR/dom/#concept-node-length
        switch (node.nodeType) {
          case Node.DOCUMENT_TYPE_NODE:
            return 0;

          case Node.TEXT_NODE:
          case Node.PROCESSING_INSTRUCTION_NODE:
          case Node.COMMENT_NODE:
            return node.length;

          default:
            return node.childNodes.length;
        }
      }
      /**
       * Given a collapsed range, move the start position backwards as far as
       * possible while the range still spans only a single line.
       */


      function expandRangeToStartOfLine(range) {
        !range.collapsed ? false ? undefined : invariant(false) : void 0;
        range = range.cloneRange();
        var containingElement = range.startContainer;

        if (containingElement.nodeType !== 1) {
          containingElement = containingElement.parentNode;
        }

        var lineHeight = getLineHeightPx(containingElement); // Imagine our text looks like:
        //   <div><span>once upon a time, there was a <em>boy
        //   who lived</em> </span><q><strong>under^ the
        //   stairs</strong> in a small closet.</q></div>
        // where the caret represents the cursor. First, we crawl up the tree until
        // the range spans multiple lines (setting the start point to before
        // "<strong>", then before "<div>"), then at each level we do a search to
        // find the latest point which is still on a previous line. We'll find that
        // the break point is inside the span, then inside the <em>, then in its text
        // node child, the actual break point before "who".

        var bestContainer = range.endContainer;
        var bestOffset = range.endOffset;
        range.setStart(range.startContainer, 0);

        while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
          bestContainer = range.startContainer;
          bestOffset = range.startOffset;
          !bestContainer.parentNode ? false ? undefined : invariant(false) : void 0;
          range.setStartBefore(bestContainer);

          if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
            // The start of the line is never in a different block-level container.
            break;
          }
        } // In the above example, range now spans from "<div>" to "under",
        // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
        // Picking out which child to recurse into here is a special case since we
        // don't want to check past <q> -- once we find that the final range starts
        // in <span>, we can look at all of its children (and all of their children)
        // to find the break point.
        // At all times, (bestContainer, bestOffset) is the latest single-line start
        // point that we know of.


        var currentContainer = bestContainer;
        var maxIndexToConsider = bestOffset - 1;

        do {
          var nodeValue = currentContainer.nodeValue;

          for (var ii = maxIndexToConsider; ii >= 0; ii--) {
            if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
              // We're in the middle of a surrogate pair -- skip over so we never
              // return a range with an endpoint in the middle of a code point.
              continue;
            }

            range.setStart(currentContainer, ii);

            if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
              bestContainer = currentContainer;
              bestOffset = ii;
            } else {
              break;
            }
          }

          if (ii === -1 || currentContainer.childNodes.length === 0) {
            // If ii === -1, then (bestContainer, bestOffset), which is equal to
            // (currentContainer, 0), was a single-line start point but a start
            // point before currentContainer wasn't, so the line break seems to
            // have occurred immediately after currentContainer's start tag
            //
            // If currentContainer.childNodes.length === 0, we're already at a
            // terminal node (e.g., text node) and should return our current best.
            break;
          }

          currentContainer = currentContainer.childNodes[ii];
          maxIndexToConsider = getNodeLength(currentContainer);
        } while (true);

        range.setStart(bestContainer, bestOffset);
        return range;
      }

      module.exports = expandRangeToStartOfLine;
      /***/
    },
    /* 977 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (global) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        * All rights reserved.
        *
        * This source code is licensed under the BSD-style license found in the
        * LICENSE file in the root directory of this source tree. An additional grant
        * of patent rights can be found in the PATENTS file in the same directory.
        *
        * @providesModule keyCommandBackspaceToStartOfLine
        * @format
        * 
        */
        var EditorState = __webpack_require__(60);

        var expandRangeToStartOfLine = __webpack_require__(976);

        var getDraftEditorSelectionWithNodes = __webpack_require__(466);

        var moveSelectionBackward = __webpack_require__(332);

        var removeTextWithStrategy = __webpack_require__(203);

        function keyCommandBackspaceToStartOfLine(editorState) {
          var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
            var selection = strategyState.getSelection();

            if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
              return moveSelectionBackward(strategyState, 1);
            }

            var domSelection = global.getSelection();
            var range = domSelection.getRangeAt(0);
            range = expandRangeToStartOfLine(range);
            return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
          }, 'backward');

          if (afterRemoval === editorState.getCurrentContent()) {
            return editorState;
          }

          return EditorState.push(editorState, afterRemoval, 'remove-range');
        }

        module.exports = keyCommandBackspaceToStartOfLine;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 978 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule SecondaryClipboard
       * @format
       * 
       */

      var DraftModifier = __webpack_require__(93);

      var EditorState = __webpack_require__(60);

      var getContentStateFragment = __webpack_require__(242);

      var nullthrows = __webpack_require__(108);

      var clipboard = null;
      /**
       * Some systems offer a "secondary" clipboard to allow quick internal cut
       * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
       */

      var SecondaryClipboard = {
        cut: function cut(editorState) {
          var content = editorState.getCurrentContent();
          var selection = editorState.getSelection();
          var targetRange = null;

          if (selection.isCollapsed()) {
            var anchorKey = selection.getAnchorKey();
            var blockEnd = content.getBlockForKey(anchorKey).getLength();

            if (blockEnd === selection.getAnchorOffset()) {
              return editorState;
            }

            targetRange = selection.set('focusOffset', blockEnd);
          } else {
            targetRange = selection;
          }

          targetRange = nullthrows(targetRange);
          clipboard = getContentStateFragment(content, targetRange);
          var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');

          if (afterRemoval === content) {
            return editorState;
          }

          return EditorState.push(editorState, afterRemoval, 'remove-range');
        },
        paste: function paste(editorState) {
          if (!clipboard) {
            return editorState;
          }

          var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
          return EditorState.push(editorState, newContent, 'insert-fragment');
        }
      };
      module.exports = SecondaryClipboard;
      /***/
    },
    /* 979 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule editOnKeyDown
       * @format
       * 
       */

      var DraftModifier = __webpack_require__(93);

      var EditorState = __webpack_require__(60);

      var KeyBindingUtil = __webpack_require__(333);

      var Keys = __webpack_require__(340);

      var SecondaryClipboard = __webpack_require__(978);

      var UserAgent = __webpack_require__(113);

      var isEventHandled = __webpack_require__(204);

      var keyCommandBackspaceToStartOfLine = __webpack_require__(977);

      var keyCommandBackspaceWord = __webpack_require__(975);

      var keyCommandDeleteWord = __webpack_require__(973);

      var keyCommandInsertNewline = __webpack_require__(972);

      var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(971);

      var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(970);

      var keyCommandPlainBackspace = __webpack_require__(969);

      var keyCommandPlainDelete = __webpack_require__(968);

      var keyCommandTransposeCharacters = __webpack_require__(967);

      var keyCommandUndo = __webpack_require__(966);

      var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
      var isChrome = UserAgent.isBrowser('Chrome');
      /**
       * Map a `DraftEditorCommand` command value to a corresponding function.
       */

      function onKeyCommand(command, editorState) {
        switch (command) {
          case 'redo':
            return EditorState.redo(editorState);

          case 'delete':
            return keyCommandPlainDelete(editorState);

          case 'delete-word':
            return keyCommandDeleteWord(editorState);

          case 'backspace':
            return keyCommandPlainBackspace(editorState);

          case 'backspace-word':
            return keyCommandBackspaceWord(editorState);

          case 'backspace-to-start-of-line':
            return keyCommandBackspaceToStartOfLine(editorState);

          case 'split-block':
            return keyCommandInsertNewline(editorState);

          case 'transpose-characters':
            return keyCommandTransposeCharacters(editorState);

          case 'move-selection-to-start-of-block':
            return keyCommandMoveSelectionToStartOfBlock(editorState);

          case 'move-selection-to-end-of-block':
            return keyCommandMoveSelectionToEndOfBlock(editorState);

          case 'secondary-cut':
            return SecondaryClipboard.cut(editorState);

          case 'secondary-paste':
            return SecondaryClipboard.paste(editorState);

          default:
            return editorState;
        }
      }
      /**
       * Intercept keydown behavior to handle keys and commands manually, if desired.
       *
       * Keydown combinations may be mapped to `DraftCommand` values, which may
       * correspond to command functions that modify the editor or its contents.
       *
       * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
       * component may provide a custom mapping via the `keyBindingFn` prop.
       */


      function editOnKeyDown(editor, e) {
        var keyCode = e.which;
        var editorState = editor._latestEditorState;

        switch (keyCode) {
          case Keys.RETURN:
            e.preventDefault(); // The top-level component may manually handle newline insertion. If
            // no special handling is performed, fall through to command handling.

            if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
              return;
            }

            break;

          case Keys.ESC:
            e.preventDefault();
            editor.props.onEscape && editor.props.onEscape(e);
            return;

          case Keys.TAB:
            editor.props.onTab && editor.props.onTab(e);
            return;

          case Keys.UP:
            editor.props.onUpArrow && editor.props.onUpArrow(e);
            return;

          case Keys.RIGHT:
            editor.props.onRightArrow && editor.props.onRightArrow(e);
            return;

          case Keys.DOWN:
            editor.props.onDownArrow && editor.props.onDownArrow(e);
            return;

          case Keys.LEFT:
            editor.props.onLeftArrow && editor.props.onLeftArrow(e);
            return;

          case Keys.SPACE:
            // Handling for OSX where option + space scrolls.
            if (isChrome && isOptionKeyCommand(e)) {
              e.preventDefault(); // Insert a nbsp into the editor.

              var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
              editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
              return;
            }

        }

        var command = editor.props.keyBindingFn(e); // If no command is specified, allow keydown event to continue.

        if (!command) {
          return;
        }

        if (command === 'undo') {
          // Since undo requires some special updating behavior to keep the editor
          // in sync, handle it separately.
          keyCommandUndo(e, editorState, editor.update);
          return;
        } // At this point, we know that we're handling a command of some kind, so
        // we don't want to insert a character following the keydown.


        e.preventDefault(); // Allow components higher up the tree to handle the command first.

        if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
          return;
        }

        var newState = onKeyCommand(command, editorState);

        if (newState !== editorState) {
          editor.update(newState);
        }
      }

      module.exports = editOnKeyDown;
      /***/
    },
    /* 980 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (global) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        * All rights reserved.
        *
        * This source code is licensed under the BSD-style license found in the
        * LICENSE file in the root directory of this source tree. An additional grant
        * of patent rights can be found in the PATENTS file in the same directory.
        *
        * @providesModule editOnInput
        * @format
        * 
        */
        var DraftFeatureFlags = __webpack_require__(133);

        var DraftModifier = __webpack_require__(93);

        var DraftOffsetKey = __webpack_require__(182);

        var EditorState = __webpack_require__(60);

        var UserAgent = __webpack_require__(113);

        var findAncestorOffsetKey = __webpack_require__(335);

        var nullthrows = __webpack_require__(108);

        var isGecko = UserAgent.isEngine('Gecko');
        var DOUBLE_NEWLINE = '\n\n';
        /**
         * This function is intended to handle spellcheck and autocorrect changes,
         * which occur in the DOM natively without any opportunity to observe or
         * interpret the changes before they occur.
         *
         * The `input` event fires in contentEditable elements reliably for non-IE
         * browsers, immediately after changes occur to the editor DOM. Since our other
         * handlers override or otherwise handle cover other varieties of text input,
         * the DOM state should match the model in all controlled input cases. Thus,
         * when an `input` change leads to a DOM/model mismatch, the change should be
         * due to a spellcheck change, and we can incorporate it into our model.
         */

        function editOnInput(editor) {
          if (editor._pendingStateFromBeforeInput !== undefined) {
            editor.update(editor._pendingStateFromBeforeInput);
            editor._pendingStateFromBeforeInput = undefined;
          }

          var domSelection = global.getSelection();
          var anchorNode = domSelection.anchorNode,
              isCollapsed = domSelection.isCollapsed;
          var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
          var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;

          if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
            if (isNotTextNode) {
              return;
            }
          } else {
            if (isNotTextOrElementNode) {
              // TODO: (t16149272) figure out context for this change
              return;
            }
          }

          if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
            // When typing at the beginning of a visual line, Chrome splits the text
            // nodes into two. Why? No one knows. This commit is suspicious:
            // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
            // To work around, we'll merge the sibling text nodes back into this one.
            var span = anchorNode.parentNode;
            anchorNode.nodeValue = span.textContent;

            for (var child = span.firstChild; child !== null; child = child.nextSibling) {
              if (child !== anchorNode) {
                span.removeChild(child);
              }
            }
          }

          var domText = anchorNode.textContent;
          var editorState = editor._latestEditorState;
          var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));

          var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
              blockKey = _DraftOffsetKey$decod.blockKey,
              decoratorKey = _DraftOffsetKey$decod.decoratorKey,
              leafKey = _DraftOffsetKey$decod.leafKey;

          var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
              start = _editorState$getBlock.start,
              end = _editorState$getBlock.end;

          var content = editorState.getCurrentContent();
          var block = content.getBlockForKey(blockKey);
          var modelText = block.getText().slice(start, end); // Special-case soft newlines here. If the DOM text ends in a soft newline,
          // we will have manually inserted an extra soft newline in DraftEditorLeaf.
          // We want to remove this extra newline for the purpose of our comparison
          // of DOM and model text.

          if (domText.endsWith(DOUBLE_NEWLINE)) {
            domText = domText.slice(0, -1);
          } // No change -- the DOM is up to date. Nothing to do here.


          if (domText === modelText) {
            // This can be buggy for some Android keyboards because they don't fire
            // standard onkeydown/pressed events and only fired editOnInput
            // so domText is already changed by the browser and ends up being equal
            // to modelText unexpectedly
            return;
          }

          var selection = editorState.getSelection(); // We'll replace the entire leaf with the text content of the target.

          var targetRange = selection.merge({
            anchorOffset: start,
            focusOffset: end,
            isBackward: false
          });
          var entityKey = block.getEntityAt(start);
          var entity = entityKey && content.getEntity(entityKey);
          var entityType = entity && entity.getMutability();
          var preserveEntity = entityType === 'MUTABLE'; // Immutable or segmented entities cannot properly be handled by the
          // default browser undo, so we have to use a different change type to
          // force using our internal undo method instead of falling through to the
          // native browser undo.

          var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
          var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
          var anchorOffset, focusOffset, startOffset, endOffset;

          if (isGecko) {
            // Firefox selection does not change while the context menu is open, so
            // we preserve the anchor and focus values of the DOM selection.
            anchorOffset = domSelection.anchorOffset;
            focusOffset = domSelection.focusOffset;
            startOffset = start + Math.min(anchorOffset, focusOffset);
            endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
            anchorOffset = startOffset;
            focusOffset = endOffset;
          } else {
            // Browsers other than Firefox may adjust DOM selection while the context
            // menu is open, and Safari autocorrect is prone to providing an inaccurate
            // DOM selection. Don't trust it. Instead, use our existing SelectionState
            // and adjust it based on the number of characters changed during the
            // mutation.
            var charDelta = domText.length - modelText.length;
            startOffset = selection.getStartOffset();
            endOffset = selection.getEndOffset();
            anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
            focusOffset = endOffset + charDelta;
          } // Segmented entities are completely or partially removed when their
          // text content changes. For this case we do not want any text to be selected
          // after the change, so we are not merging the selection.


          var contentWithAdjustedDOMSelection = newContent.merge({
            selectionBefore: content.getSelectionAfter(),
            selectionAfter: selection.merge({
              anchorOffset: anchorOffset,
              focusOffset: focusOffset
            })
          });
          editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
        }

        module.exports = editOnInput;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 981 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule editOnFocus
       * @format
       * 
       */

      var EditorState = __webpack_require__(60);

      var UserAgent = __webpack_require__(113);

      function editOnFocus(editor, e) {
        var editorState = editor._latestEditorState;
        var currentSelection = editorState.getSelection();

        if (currentSelection.getHasFocus()) {
          return;
        }

        var selection = currentSelection.set('hasFocus', true);
        editor.props.onFocus && editor.props.onFocus(e); // When the tab containing this text editor is hidden and the user does a
        // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
        // selection was right after sending this focus event and (if you let it)
        // moves the cursor back to the beginning of the editor, so we force the
        // selection here instead of simply accepting it in order to preserve the
        // old cursor position. See https://crbug.com/540004.
        // But it looks like this is fixed in Chrome 60.0.3081.0.
        // Other browsers also don't have this bug, so we prefer to acceptSelection
        // when possible, to ensure that unfocusing and refocusing a Draft editor
        // doesn't preserve the selection, matching how textareas work.

        if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
          editor.update(EditorState.forceSelection(editorState, selection));
        } else {
          editor.update(EditorState.acceptSelection(editorState, selection));
        }
      }

      module.exports = editOnFocus;
      /***/
    },
    /* 982 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule editOnDragStart
       * @format
       * 
       */

      /**
       * A `dragstart` event has begun within the text editor component.
       */

      function editOnDragStart(editor) {
        editor._internalDrag = true;
        editor.setMode('drag');
      }

      module.exports = editOnDragStart;
      /***/
    },
    /* 983 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule editOnDragOver
       * @format
       * 
       */

      /**
       * Drag behavior has begun from outside the editor element.
       */

      function editOnDragOver(editor, e) {
        editor._internalDrag = false;
        editor.setMode('drag');
        e.preventDefault();
      }

      module.exports = editOnDragOver;
      /***/
    },
    /* 984 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule editOnCut
       * @format
       * 
       */

      var DraftModifier = __webpack_require__(93);

      var EditorState = __webpack_require__(60);

      var Style = __webpack_require__(337);

      var getFragmentFromSelection = __webpack_require__(468);

      var getScrollPosition = __webpack_require__(336);
      /**
       * On `cut` events, native behavior is allowed to occur so that the system
       * clipboard is set properly. This means that we need to take steps to recover
       * the editor DOM state after the `cut` has occurred in order to maintain
       * control of the component.
       *
       * In addition, we can keep a copy of the removed fragment, including all
       * styles and entities, for use as an internal paste.
       */


      function editOnCut(editor, e) {
        var editorState = editor._latestEditorState;
        var selection = editorState.getSelection();
        var element = e.target;
        var scrollPosition = void 0; // No selection, so there's nothing to cut.

        if (selection.isCollapsed()) {
          e.preventDefault();
          return;
        } // Track the current scroll position so that it can be forced back in place
        // after the editor regains control of the DOM.


        if (element instanceof Node) {
          scrollPosition = getScrollPosition(Style.getScrollParent(element));
        }

        var fragment = getFragmentFromSelection(editorState);
        editor.setClipboard(fragment); // Set `cut` mode to disable all event handling temporarily.

        editor.setMode('cut'); // Let native `cut` behavior occur, then recover control.

        setTimeout(function () {
          editor.restoreEditorDOM(scrollPosition);
          editor.exitCurrentMode();
          editor.update(removeFragment(editorState));
        }, 0);
      }

      function removeFragment(editorState) {
        var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
        return EditorState.push(editorState, newContent, 'remove-range');
      }

      module.exports = editOnCut;
      /***/
    },
    /* 985 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule editOnCopy
       * @format
       * 
       */

      var getFragmentFromSelection = __webpack_require__(468);
      /**
       * If we have a selection, create a ContentState fragment and store
       * it in our internal clipboard. Subsequent paste events will use this
       * fragment if no external clipboard data is supplied.
       */


      function editOnCopy(editor, e) {
        var editorState = editor._latestEditorState;
        var selection = editorState.getSelection(); // No selection, so there's nothing to copy.

        if (selection.isCollapsed()) {
          e.preventDefault();
          return;
        }

        editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
      }

      module.exports = editOnCopy;
      /***/
    },
    /* 986 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule editOnCompositionStart
       * @format
       * 
       */

      var EditorState = __webpack_require__(60);
      /**
       * The user has begun using an IME input system. Switching to `composite` mode
       * allows handling composition input and disables other edit behavior.
       */


      function editOnCompositionStart(editor, e) {
        editor.setMode('composite');
        editor.update(EditorState.set(editor._latestEditorState, {
          inCompositionMode: true
        })); // Allow composition handler to interpret the compositionstart event

        editor._onCompositionStart(e);
      }

      module.exports = editOnCompositionStart;
      /***/
    },
    /* 987 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (global) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        * All rights reserved.
        *
        * This source code is licensed under the BSD-style license found in the
        * LICENSE file in the root directory of this source tree. An additional grant
        * of patent rights can be found in the PATENTS file in the same directory.
        *
        * @providesModule editOnBlur
        * @format
        * 
        */
        var EditorState = __webpack_require__(60);

        var containsNode = __webpack_require__(338);

        var getActiveElement = __webpack_require__(474);

        function editOnBlur(editor, e) {
          // In a contentEditable element, when you select a range and then click
          // another active element, this does trigger a `blur` event but will not
          // remove the DOM selection from the contenteditable.
          // This is consistent across all browsers, but we prefer that the editor
          // behave like a textarea, where a `blur` event clears the DOM selection.
          // We therefore force the issue to be certain, checking whether the active
          // element is `body` to force it when blurring occurs within the window (as
          // opposed to clicking to another tab or window).
          if (getActiveElement() === document.body) {
            var _selection = global.getSelection();

            var editorNode = editor.editor;

            if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
              _selection.removeAllRanges();
            }
          }

          var editorState = editor._latestEditorState;
          var currentSelection = editorState.getSelection();

          if (!currentSelection.getHasFocus()) {
            return;
          }

          var selection = currentSelection.set('hasFocus', false);
          editor.props.onBlur && editor.props.onBlur(e);
          editor.update(EditorState.acceptSelection(editorState, selection));
        }

        module.exports = editOnBlur;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 988 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (global) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        *
        * This source code is licensed under the MIT license found in the
        * LICENSE file in the root directory of this source tree.
        *
        */
        // setimmediate adds setImmediate to the global. We want to make sure we export
        // the actual function.
        __webpack_require__(334);

        module.exports = global.setImmediate;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 989 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (global) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        * All rights reserved.
        *
        * This source code is licensed under the BSD-style license found in the
        * LICENSE file in the root directory of this source tree. An additional grant
        * of patent rights can be found in the PATENTS file in the same directory.
        *
        * @providesModule editOnBeforeInput
        * @format
        * 
        */
        var BlockTree = __webpack_require__(480);

        var DraftModifier = __webpack_require__(93);

        var EditorState = __webpack_require__(60);

        var UserAgent = __webpack_require__(113);

        var getEntityKeyForSelection = __webpack_require__(339);

        var isEventHandled = __webpack_require__(204);

        var isSelectionAtLeafStart = __webpack_require__(476);

        var nullthrows = __webpack_require__(108);

        var setImmediate = __webpack_require__(988); // When nothing is focused, Firefox regards two characters, `'` and `/`, as
        // commands that should open and focus the "quickfind" search bar. This should
        // *never* happen while a contenteditable is focused, but as of v28, it
        // sometimes does, even when the keypress event target is the contenteditable.
        // This breaks the input. Special case these characters to ensure that when
        // they are typed, we prevent default on the event to make sure not to
        // trigger quickfind.


        var FF_QUICKFIND_CHAR = "'";
        var FF_QUICKFIND_LINK_CHAR = '/';
        var isFirefox = UserAgent.isBrowser('Firefox');

        function mustPreventDefaultForCharacter(character) {
          return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
        }
        /**
         * Replace the current selection with the specified text string, with the
         * inline style and entity key applied to the newly inserted text.
         */


        function replaceText(editorState, text, inlineStyle, entityKey) {
          var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
          return EditorState.push(editorState, contentState, 'insert-characters');
        }
        /**
         * When `onBeforeInput` executes, the browser is attempting to insert a
         * character into the editor. Apply this character data to the document,
         * allowing native insertion if possible.
         *
         * Native insertion is encouraged in order to limit re-rendering and to
         * preserve spellcheck highlighting, which disappears or flashes if re-render
         * occurs on the relevant text nodes.
         */


        function editOnBeforeInput(editor, e) {
          if (editor._pendingStateFromBeforeInput !== undefined) {
            editor.update(editor._pendingStateFromBeforeInput);
            editor._pendingStateFromBeforeInput = undefined;
          }

          var editorState = editor._latestEditorState;
          var chars = e.data; // In some cases (ex: IE ideographic space insertion) no character data
          // is provided. There's nothing to do when this happens.

          if (!chars) {
            return;
          } // Allow the top-level component to handle the insertion manually. This is
          // useful when triggering interesting behaviors for a character insertion,
          // Simple examples: replacing a raw text ':)' with a smile emoji or image
          // decorator, or setting a block to be a list item after typing '- ' at the
          // start of the block.


          if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) {
            e.preventDefault();
            return;
          } // If selection is collapsed, conditionally allow native behavior. This
          // reduces re-renders and preserves spellcheck highlighting. If the selection
          // is not collapsed, we will re-render.


          var selection = editorState.getSelection();
          var selectionStart = selection.getStartOffset();
          var selectionEnd = selection.getEndOffset();
          var anchorKey = selection.getAnchorKey();

          if (!selection.isCollapsed()) {
            e.preventDefault(); // If the currently selected text matches what the user is trying to
            // replace it with, let's just update the `SelectionState`. If not, update
            // the `ContentState` with the new text.

            var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);

            if (chars === currentlySelectedChars) {
              editor.update(EditorState.forceSelection(editorState, selection.merge({
                focusOffset: selectionEnd
              })));
            } else {
              editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
            }

            return;
          }

          var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())); // Bunch of different cases follow where we need to prevent native insertion.

          var mustPreventNative = false;

          if (!mustPreventNative) {
            // Browsers tend to insert text in weird places in the DOM when typing at
            // the start of a leaf, so we'll handle it ourselves.
            mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
          }

          if (!mustPreventNative) {
            // Chrome will also split up a node into two pieces if it contains a Tab
            // char, for no explicable reason. Seemingly caused by this commit:
            // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
            var nativeSelection = global.getSelection(); // Selection is necessarily collapsed at this point due to earlier check.

            if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
              // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
              var parentNode = nativeSelection.anchorNode.parentNode;
              mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
            }
          }

          if (!mustPreventNative) {
            // Check the old and new "fingerprints" of the current block to determine
            // whether this insertion requires any addition or removal of text nodes,
            // in which case we would prevent the native character insertion.
            var originalFingerprint = BlockTree.getFingerprint(editorState.getBlockTree(anchorKey));
            var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
            mustPreventNative = originalFingerprint !== newFingerprint;
          }

          if (!mustPreventNative) {
            mustPreventNative = mustPreventDefaultForCharacter(chars);
          }

          if (!mustPreventNative) {
            mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
          }

          if (mustPreventNative) {
            e.preventDefault();
            editor.update(newEditorState);
            return;
          } // We made it all the way! Let the browser do its thing and insert the char.


          newEditorState = EditorState.set(newEditorState, {
            nativelyRenderedContent: newEditorState.getCurrentContent()
          }); // The native event is allowed to occur. To allow user onChange handlers to
          // change the inserted text, we wait until the text is actually inserted
          // before we actually update our state. That way when we rerender, the text
          // we see in the DOM will already have been inserted properly.

          editor._pendingStateFromBeforeInput = newEditorState;
          setImmediate(function () {
            if (editor._pendingStateFromBeforeInput !== undefined) {
              editor.update(editor._pendingStateFromBeforeInput);
              editor._pendingStateFromBeforeInput = undefined;
            }
          });
        }

        module.exports = editOnBeforeInput;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 990 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEditorEditHandler
       * @format
       * 
       */

      var onBeforeInput = __webpack_require__(989);

      var onBlur = __webpack_require__(987);

      var onCompositionStart = __webpack_require__(986);

      var onCopy = __webpack_require__(985);

      var onCut = __webpack_require__(984);

      var onDragOver = __webpack_require__(983);

      var onDragStart = __webpack_require__(982);

      var onFocus = __webpack_require__(981);

      var onInput = __webpack_require__(980);

      var onKeyDown = __webpack_require__(979);

      var onPaste = __webpack_require__(965);

      var onSelect = __webpack_require__(960);

      var DraftEditorEditHandler = {
        onBeforeInput: onBeforeInput,
        onBlur: onBlur,
        onCompositionStart: onCompositionStart,
        onCopy: onCopy,
        onCut: onCut,
        onDragOver: onDragOver,
        onDragStart: onDragStart,
        onFocus: onFocus,
        onInput: onInput,
        onKeyDown: onKeyDown,
        onPaste: onPaste,
        onSelect: onSelect
      };
      module.exports = DraftEditorEditHandler;
      /***/
    },
    /* 991 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      var invariant = __webpack_require__(51);
      /**
       * Convert array-like objects to arrays.
       *
       * This API assumes the caller knows the contents of the data type. For less
       * well defined inputs use createArrayFromMixed.
       *
       * @param {object|function|filelist} obj
       * @return {array}
       */


      function toArray(obj) {
        var length = obj.length; // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
        // in old versions of Safari).

        !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? false ? undefined : invariant(false) : void 0;
        !(typeof length === 'number') ? false ? undefined : invariant(false) : void 0;
        !(length === 0 || length - 1 in obj) ? false ? undefined : invariant(false) : void 0;
        !(typeof obj.callee !== 'function') ? false ? undefined : invariant(false) : void 0; // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
        // without method will throw during the slice call and skip straight to the
        // fallback.

        if (obj.hasOwnProperty) {
          try {
            return Array.prototype.slice.call(obj);
          } catch (e) {// IE < 9 does not support Array#slice on collections objects
          }
        } // Fall back to copying key by key. This assumes all keys have a value,
        // so will not preserve sparsely populated inputs.


        var ret = Array(length);

        for (var ii = 0; ii < length; ii++) {
          ret[ii] = obj[ii];
        }

        return ret;
      }
      /**
       * Perform a heuristic test to determine if an object is "array-like".
       *
       *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
       *   Joshu replied: "Mu."
       *
       * This function determines if its argument has "array nature": it returns
       * true if the argument is an actual array, an `arguments' object, or an
       * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
       *
       * It will return false for other array-like objects like Filelist.
       *
       * @param {*} obj
       * @return {boolean}
       */


      function hasArrayNature(obj) {
        return (// not null/false
          !!obj && ( // arrays are objects, NodeLists are functions in Safari
          typeof obj == 'object' || typeof obj == 'function') && // quacks like an array
          'length' in obj && // not window
          !('setInterval' in obj) && // no DOM node should be considered an array-like
          // a 'select' element has 'length' and 'item' properties on IE8
          typeof obj.nodeType != 'number' && ( // a real array
          Array.isArray(obj) || // arguments
          'callee' in obj || // HTMLCollection/NodeList
          'item' in obj)
        );
      }
      /**
       * Ensure that the argument is an array by wrapping it in an array if it is not.
       * Creates a copy of the argument if it is already an array.
       *
       * This is mostly useful idiomatically:
       *
       *   var createArrayFromMixed = require('createArrayFromMixed');
       *
       *   function takesOneOrMoreThings(things) {
       *     things = createArrayFromMixed(things);
       *     ...
       *   }
       *
       * This allows you to treat `things' as an array, but accept scalars in the API.
       *
       * If you need to convert an array-like object, like `arguments`, into an array
       * use toArray instead.
       *
       * @param {*} obj
       * @return {array}
       */


      function createArrayFromMixed(obj) {
        if (!hasArrayNature(obj)) {
          return [obj];
        } else if (Array.isArray(obj)) {
          return obj.slice();
        } else {
          return toArray(obj);
        }
      }

      module.exports = createArrayFromMixed;
      /***/
    },
    /* 992 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      var PhotosMimeType = {
        isImage: function isImage(mimeString) {
          return getParts(mimeString)[0] === 'image';
        },
        isJpeg: function isJpeg(mimeString) {
          var parts = getParts(mimeString);
          return PhotosMimeType.isImage(mimeString) && ( // see http://fburl.com/10972194
          parts[1] === 'jpeg' || parts[1] === 'pjpeg');
        }
      };

      function getParts(mimeString) {
        return mimeString.split('/');
      }

      module.exports = PhotosMimeType;
      /***/
    },
    /* 993 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEditorDragHandler
       * @format
       * 
       */

      var DataTransfer = __webpack_require__(472);

      var DraftModifier = __webpack_require__(93);

      var EditorState = __webpack_require__(60);

      var findAncestorOffsetKey = __webpack_require__(335);

      var getTextContentFromFiles = __webpack_require__(470);

      var getUpdatedSelectionState = __webpack_require__(469);

      var isEventHandled = __webpack_require__(204);

      var nullthrows = __webpack_require__(108);
      /**
       * Get a SelectionState for the supplied mouse event.
       */


      function getSelectionForEvent(event, editorState) {
        var node = null;
        var offset = null;

        if (typeof document.caretRangeFromPoint === 'function') {
          var dropRange = document.caretRangeFromPoint(event.x, event.y);
          node = dropRange.startContainer;
          offset = dropRange.startOffset;
        } else if (event.rangeParent) {
          node = event.rangeParent;
          offset = event.rangeOffset;
        } else {
          return null;
        }

        node = nullthrows(node);
        offset = nullthrows(offset);
        var offsetKey = nullthrows(findAncestorOffsetKey(node));
        return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
      }

      var DraftEditorDragHandler = {
        /**
         * Drag originating from input terminated.
         */
        onDragEnd: function onDragEnd(editor) {
          editor.exitCurrentMode();
        },

        /**
         * Handle data being dropped.
         */
        onDrop: function onDrop(editor, e) {
          var data = new DataTransfer(e.nativeEvent.dataTransfer);
          var editorState = editor._latestEditorState;
          var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
          e.preventDefault();
          editor.exitCurrentMode();

          if (dropSelection == null) {
            return;
          }

          var files = data.getFiles();

          if (files.length > 0) {
            if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
              return;
            }

            getTextContentFromFiles(files, function (fileText) {
              fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
            });
            return;
          }

          var dragType = editor._internalDrag ? 'internal' : 'external';

          if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {
            return;
          }

          if (editor._internalDrag) {
            editor.update(moveText(editorState, dropSelection));
            return;
          }

          editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
        }
      };

      function moveText(editorState, targetSelection) {
        var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
        return EditorState.push(editorState, newContentState, 'insert-fragment');
      }
      /**
       * Insert text at a specified selection.
       */


      function insertTextAtSelection(editorState, selection, text) {
        var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
        return EditorState.push(editorState, newContentState, 'insert-fragment');
      }

      module.exports = DraftEditorDragHandler;
      /***/
    },
    /* 994 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks static-only
       */

      /**
       * Combines multiple className strings into one.
       * http://jsperf.com/joinclasses-args-vs-array
       *
       * @param {...?string} className
       * @return {string}
       */

      function joinClasses(className
      /*, ... */
      ) {
        if (!className) {
          className = '';
        }

        var nextClass = void 0;
        var argLength = arguments.length;

        if (argLength > 1) {
          for (var ii = 1; ii < argLength; ii++) {
            nextClass = arguments[ii];

            if (nextClass) {
              className = (className ? className + ' ' : '') + nextClass;
            }
          }
        }

        return className;
      }

      module.exports = joinClasses;
      /***/
    },
    /* 995 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function getViewportWidth() {
        var width = void 0;

        if (document.documentElement) {
          width = document.documentElement.clientWidth;
        }

        if (!width && document.body) {
          width = document.body.clientWidth;
        }

        return width || 0;
      }
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * 
       * @typechecks
       */


      function getViewportHeight() {
        var height = void 0;

        if (document.documentElement) {
          height = document.documentElement.clientHeight;
        }

        if (!height && document.body) {
          height = document.body.clientHeight;
        }

        return height || 0;
      }
      /**
       * Gets the viewport dimensions including any scrollbars.
       */


      function getViewportDimensions() {
        return {
          width: window.innerWidth || getViewportWidth(),
          height: window.innerHeight || getViewportHeight()
        };
      }
      /**
       * Gets the viewport dimensions excluding any scrollbars.
       */


      getViewportDimensions.withoutScrollbars = function () {
        return {
          width: getViewportWidth(),
          height: getViewportHeight()
        };
      };

      module.exports = getViewportDimensions;
      /***/
    },
    /* 996 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      /**
       * Gets the scroll position of the supplied element or window.
       *
       * The return values are unbounded, unlike `getScrollPosition`. This means they
       * may be negative or exceed the element boundaries (which is possible using
       * inertial scrolling).
       *
       * @param {DOMWindow|DOMElement} scrollable
       * @return {object} Map with `x` and `y` keys.
       */

      function getUnboundedScrollPosition(scrollable) {
        if (scrollable.Window && scrollable instanceof scrollable.Window) {
          return {
            x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
            y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
          };
        }

        return {
          x: scrollable.scrollLeft,
          y: scrollable.scrollTop
        };
      }

      module.exports = getUnboundedScrollPosition;
      /***/
    },
    /* 997 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
      /**
       * Gets the element with the document scroll properties such as `scrollLeft` and
       * `scrollHeight`. This may differ across different browsers.
       *
       * NOTE: The return value can be null if the DOM is not yet ready.
       *
       * @param {?DOMDocument} doc Defaults to current document.
       * @return {?DOMElement}
       */

      function getDocumentScrollElement(doc) {
        doc = doc || document;

        if (doc.scrollingElement) {
          return doc.scrollingElement;
        }

        return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
      }

      module.exports = getDocumentScrollElement;
      /***/
    },
    /* 998 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      var containsNode = __webpack_require__(338);
      /**
       * Gets an element's bounding rect in pixels relative to the viewport.
       *
       * @param {DOMElement} elem
       * @return {object}
       */


      function getElementRect(elem) {
        var docElem = elem.ownerDocument.documentElement; // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
        // IE9- will throw if the element is not in the document.

        if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
          return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          };
        } // Subtracts clientTop/Left because IE8- added a 2px border to the
        // <html> element (see http://fburl.com/1493213). IE 7 in
        // Quicksmode does not report clientLeft/clientTop so there
        // will be an unaccounted offset of 2px when in quirksmode


        var rect = elem.getBoundingClientRect();
        return {
          left: Math.round(rect.left) - docElem.clientLeft,
          right: Math.round(rect.right) - docElem.clientLeft,
          top: Math.round(rect.top) - docElem.clientTop,
          bottom: Math.round(rect.bottom) - docElem.clientTop
        };
      }

      module.exports = getElementRect;
      /***/
    },
    /* 999 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      var getElementRect = __webpack_require__(998);
      /**
       * Gets an element's position in pixels relative to the viewport. The returned
       * object represents the position of the element's top left corner.
       *
       * @param {DOMElement} element
       * @return {object}
       */


      function getElementPosition(element) {
        var rect = getElementRect(element);
        return {
          x: rect.left,
          y: rect.top,
          width: rect.right - rect.left,
          height: rect.bottom - rect.top
        };
      }

      module.exports = getElementPosition;
      /***/
    },
    /* 1000 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      var _uppercasePattern = /([A-Z])/g;
      /**
       * Hyphenates a camelcased string, for example:
       *
       *   > hyphenate('backgroundColor')
       *   < "background-color"
       *
       * For CSS style names, use `hyphenateStyleName` instead which works properly
       * with all vendor prefixes, including `ms`.
       *
       * @param {string} string
       * @return {string}
       */

      function hyphenate(string) {
        return string.replace(_uppercasePattern, '-$1').toLowerCase();
      }

      module.exports = hyphenate;
      /***/
    },
    /* 1001 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      var _hyphenPattern = /-(.)/g;
      /**
       * Camelcases a hyphenated string, for example:
       *
       *   > camelize('background-color')
       *   < "backgroundColor"
       *
       * @param {string} string
       * @return {string}
       */

      function camelize(string) {
        return string.replace(_hyphenPattern, function (_, character) {
          return character.toUpperCase();
        });
      }

      module.exports = camelize;
      /***/
    },
    /* 1002 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      var camelize = __webpack_require__(1001);

      var hyphenate = __webpack_require__(1000);

      function asString(value)
      /*?string*/
      {
        return value == null ? value : String(value);
      }

      function getStyleProperty(
      /*DOMNode*/
      node,
      /*string*/
      name)
      /*?string*/
      {
        var computedStyle = void 0; // W3C Standard

        if (window.getComputedStyle) {
          // In certain cases such as within an iframe in FF3, this returns null.
          computedStyle = window.getComputedStyle(node, null);

          if (computedStyle) {
            return asString(computedStyle.getPropertyValue(hyphenate(name)));
          }
        } // Safari


        if (document.defaultView && document.defaultView.getComputedStyle) {
          computedStyle = document.defaultView.getComputedStyle(node, null); // A Safari bug causes this to return null for `display: none` elements.

          if (computedStyle) {
            return asString(computedStyle.getPropertyValue(hyphenate(name)));
          }

          if (name === 'display') {
            return 'none';
          }
        } // Internet Explorer


        if (node.currentStyle) {
          if (name === 'float') {
            return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
          }

          return asString(node.currentStyle[camelize(name)]);
        }

        return asString(node.style && node.style[camelize(name)]);
      }

      module.exports = getStyleProperty;
      /***/
    },
    /* 1003 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      /**
       * @param {*} object The object to check.
       * @return {boolean} Whether or not the object is a DOM node.
       */

      function isNode(object) {
        var doc = object ? object.ownerDocument || object : document;
        var defaultView = doc.defaultView || window;
        return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
      }

      module.exports = isNode;
      /***/
    },
    /* 1004 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       */

      var isNode = __webpack_require__(1003);
      /**
       * @param {*} object The object to check.
       * @return {boolean} Whether or not the object is a DOM text node.
       */


      function isTextNode(object) {
        return isNode(object) && object.nodeType == 3;
      }

      module.exports = isTextNode;
      /***/
    },
    /* 1005 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftJsDebugLogging
       */

      module.exports = {
        logSelectionStateFailure: function logSelectionStateFailure() {
          return null;
        }
      };
      /***/
    },
    /* 1006 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (global) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        * All rights reserved.
        *
        * This source code is licensed under the BSD-style license found in the
        * LICENSE file in the root directory of this source tree. An additional grant
        * of patent rights can be found in the PATENTS file in the same directory.
        *
        * @providesModule setDraftEditorSelection
        * @format
        * 
        */
        var DraftJsDebugLogging = __webpack_require__(1005);

        var containsNode = __webpack_require__(338);

        var getActiveElement = __webpack_require__(474);

        var invariant = __webpack_require__(51);

        function getAnonymizedDOM(node, getNodeLabels) {
          if (!node) {
            return '[empty]';
          }

          var anonymized = anonymizeTextWithin(node, getNodeLabels);

          if (anonymized.nodeType === Node.TEXT_NODE) {
            return anonymized.textContent;
          }

          !(anonymized instanceof Element) ? false ? undefined : invariant(false) : void 0;
          return anonymized.outerHTML;
        }

        function anonymizeTextWithin(node, getNodeLabels) {
          var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

          if (node.nodeType === Node.TEXT_NODE) {
            var length = node.textContent.length;
            return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
          }

          var clone = node.cloneNode();

          if (clone.nodeType === 1 && labels.length) {
            clone.setAttribute('data-labels', labels.join(', '));
          }

          var childNodes = node.childNodes;

          for (var ii = 0; ii < childNodes.length; ii++) {
            clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
          }

          return clone;
        }

        function getAnonymizedEditorDOM(node, getNodeLabels) {
          // grabbing the DOM content of the Draft editor
          var currentNode = node;

          while (currentNode) {
            if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
              // found the Draft editor container
              return getAnonymizedDOM(currentNode, getNodeLabels);
            } else {
              currentNode = currentNode.parentNode;
            }
          }

          return 'Could not find contentEditable parent of node';
        }

        function getNodeLength(node) {
          return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
        }
        /**
         * In modern non-IE browsers, we can support both forward and backward
         * selections.
         *
         * Note: IE10+ supports the Selection object, but it does not support
         * the `extend` method, which means that even in modern IE, it's not possible
         * to programatically create a backward selection. Thus, for all IE
         * versions, we use the old IE API to create our selections.
         */


        function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
          // It's possible that the editor has been removed from the DOM but
          // our selection code doesn't know it yet. Forcing selection in
          // this case may lead to errors, so just bail now.
          if (!containsNode(document.documentElement, node)) {
            return;
          }

          var selection = global.getSelection();
          var anchorKey = selectionState.getAnchorKey();
          var anchorOffset = selectionState.getAnchorOffset();
          var focusKey = selectionState.getFocusKey();
          var focusOffset = selectionState.getFocusOffset();
          var isBackward = selectionState.getIsBackward(); // IE doesn't support backward selection. Swap key/offset pairs.

          if (!selection.extend && isBackward) {
            var tempKey = anchorKey;
            var tempOffset = anchorOffset;
            anchorKey = focusKey;
            anchorOffset = focusOffset;
            focusKey = tempKey;
            focusOffset = tempOffset;
            isBackward = false;
          }

          var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
          var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset; // If the selection is entirely bound within this node, set the selection
          // and be done.

          if (hasAnchor && hasFocus) {
            selection.removeAllRanges();
            addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
            addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
            return;
          }

          if (!isBackward) {
            // If the anchor is within this node, set the range start.
            if (hasAnchor) {
              selection.removeAllRanges();
              addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
            } // If the focus is within this node, we can assume that we have
            // already set the appropriate start range on the selection, and
            // can simply extend the selection.


            if (hasFocus) {
              addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
            }
          } else {
            // If this node has the focus, set the selection range to be a
            // collapsed range beginning here. Later, when we encounter the anchor,
            // we'll use this information to extend the selection.
            if (hasFocus) {
              selection.removeAllRanges();
              addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
            } // If this node has the anchor, we may assume that the correct
            // focus information is already stored on the selection object.
            // We keep track of it, reset the selection range, and extend it
            // back to the focus point.


            if (hasAnchor) {
              var storedFocusNode = selection.focusNode;
              var storedFocusOffset = selection.focusOffset;
              selection.removeAllRanges();
              addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
              addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
            }
          }
        }
        /**
         * Extend selection towards focus point.
         */


        function addFocusToSelection(selection, node, offset, selectionState) {
          var activeElement = getActiveElement();

          if (selection.extend && containsNode(activeElement, node)) {
            // If `extend` is called while another element has focus, an error is
            // thrown. We therefore disable `extend` if the active element is somewhere
            // other than the node we are selecting. This should only occur in Firefox,
            // since it is the only browser to support multiple selections.
            // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
            // logging to catch bug that is being reported in t16250795
            if (offset > getNodeLength(node)) {
              // the call to 'selection.extend' is about to throw
              DraftJsDebugLogging.logSelectionStateFailure({
                anonymizedDom: getAnonymizedEditorDOM(node),
                extraParams: JSON.stringify({
                  offset: offset
                }),
                selectionState: JSON.stringify(selectionState.toJS())
              });
            } // logging to catch bug that is being reported in t18110632


            var nodeWasFocus = node === selection.focusNode;

            try {
              selection.extend(node, offset);
            } catch (e) {
              DraftJsDebugLogging.logSelectionStateFailure({
                anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
                  var labels = [];

                  if (n === activeElement) {
                    labels.push('active element');
                  }

                  if (n === selection.anchorNode) {
                    labels.push('selection anchor node');
                  }

                  if (n === selection.focusNode) {
                    labels.push('selection focus node');
                  }

                  return labels;
                }),
                extraParams: JSON.stringify({
                  activeElementName: activeElement ? activeElement.nodeName : null,
                  nodeIsFocus: node === selection.focusNode,
                  nodeWasFocus: nodeWasFocus,
                  selectionRangeCount: selection.rangeCount,
                  selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
                  selectionAnchorOffset: selection.anchorOffset,
                  selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
                  selectionFocusOffset: selection.focusOffset,
                  message: e ? '' + e : null,
                  offset: offset
                }, null, 2),
                selectionState: JSON.stringify(selectionState.toJS(), null, 2)
              }); // allow the error to be thrown -
              // better than continuing in a broken state

              throw e;
            }
          } else {
            // IE doesn't support extend. This will mean no backward selection.
            // Extract the existing selection range and add focus to it.
            // Additionally, clone the selection range. IE11 throws an
            // InvalidStateError when attempting to access selection properties
            // after the range is detached.
            var range = selection.getRangeAt(0);
            range.setEnd(node, offset);
            selection.addRange(range.cloneRange());
          }
        }

        function addPointToSelection(selection, node, offset, selectionState) {
          var range = document.createRange(); // logging to catch bug that is being reported in t16250795

          if (offset > getNodeLength(node)) {
            // in this case we know that the call to 'range.setStart' is about to throw
            DraftJsDebugLogging.logSelectionStateFailure({
              anonymizedDom: getAnonymizedEditorDOM(node),
              extraParams: JSON.stringify({
                offset: offset
              }),
              selectionState: JSON.stringify(selectionState.toJS())
            });
          }

          range.setStart(node, offset);
          selection.addRange(range);
        }

        module.exports = setDraftEditorSelection;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 1007 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * 
       * @typechecks static-only
       */

      /**
       * Memoizes the return value of a function that accepts one string argument.
       */

      function memoizeStringOnly(callback) {
        var cache = {};
        return function (string) {
          if (!cache.hasOwnProperty(string)) {
            cache[string] = callback.call(this, string);
          }

          return cache[string];
        };
      }

      module.exports = memoizeStringOnly;
      /***/
    },
    /* 1008 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      var hasOwnProperty = Object.prototype.hasOwnProperty;
      /**
       * Executes the provided `callback` once for each enumerable own property in the
       * object and constructs a new object from the results. The `callback` is
       * invoked with three arguments:
       *
       *  - the property value
       *  - the property name
       *  - the object being traversed
       *
       * Properties that are added after the call to `mapObject` will not be visited
       * by `callback`. If the values of existing properties are changed, the value
       * passed to `callback` will be the value at the time `mapObject` visits them.
       * Properties that are deleted before being visited are not visited.
       *
       * @grep function objectMap()
       * @grep function objMap()
       *
       * @param {?object} object
       * @param {function} callback
       * @param {*} context
       * @return {?object}
       */

      function mapObject(object, callback, context) {
        if (!object) {
          return null;
        }

        var result = {};

        for (var name in object) {
          if (hasOwnProperty.call(object, name)) {
            result[name] = callback.call(context, object[name], name, object);
          }
        }

        return result;
      }

      module.exports = mapObject;
      /***/
    },
    /* 1009 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      var invariant = __webpack_require__(51);

      var componentRegex = /\./;
      var orRegex = /\|\|/;
      var rangeRegex = /\s+\-\s+/;
      var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
      var numericRegex = /^(\d*)(.*)/;
      /**
       * Splits input `range` on "||" and returns true if any subrange matches
       * `version`.
       *
       * @param {string} range
       * @param {string} version
       * @returns {boolean}
       */

      function checkOrExpression(range, version) {
        var expressions = range.split(orRegex);

        if (expressions.length > 1) {
          return expressions.some(function (range) {
            return VersionRange.contains(range, version);
          });
        } else {
          range = expressions[0].trim();
          return checkRangeExpression(range, version);
        }
      }
      /**
       * Splits input `range` on " - " (the surrounding whitespace is required) and
       * returns true if version falls between the two operands.
       *
       * @param {string} range
       * @param {string} version
       * @returns {boolean}
       */


      function checkRangeExpression(range, version) {
        var expressions = range.split(rangeRegex);
        !(expressions.length > 0 && expressions.length <= 2) ? false ? undefined : invariant(false) : void 0;

        if (expressions.length === 1) {
          return checkSimpleExpression(expressions[0], version);
        } else {
          var startVersion = expressions[0],
              endVersion = expressions[1];
          !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ? false ? undefined : invariant(false) : void 0;
          return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
        }
      }
      /**
       * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
       * not a compound range using the " - " or "||" operators).
       *
       * @param {string} range
       * @param {string} version
       * @returns {boolean}
       */


      function checkSimpleExpression(range, version) {
        range = range.trim();

        if (range === '') {
          return true;
        }

        var versionComponents = version.split(componentRegex);

        var _getModifierAndCompon = getModifierAndComponents(range),
            modifier = _getModifierAndCompon.modifier,
            rangeComponents = _getModifierAndCompon.rangeComponents;

        switch (modifier) {
          case '<':
            return checkLessThan(versionComponents, rangeComponents);

          case '<=':
            return checkLessThanOrEqual(versionComponents, rangeComponents);

          case '>=':
            return checkGreaterThanOrEqual(versionComponents, rangeComponents);

          case '>':
            return checkGreaterThan(versionComponents, rangeComponents);

          case '~':
          case '~>':
            return checkApproximateVersion(versionComponents, rangeComponents);

          default:
            return checkEqual(versionComponents, rangeComponents);
        }
      }
      /**
       * Checks whether `a` is less than `b`.
       *
       * @param {array<string>} a
       * @param {array<string>} b
       * @returns {boolean}
       */


      function checkLessThan(a, b) {
        return compareComponents(a, b) === -1;
      }
      /**
       * Checks whether `a` is less than or equal to `b`.
       *
       * @param {array<string>} a
       * @param {array<string>} b
       * @returns {boolean}
       */


      function checkLessThanOrEqual(a, b) {
        var result = compareComponents(a, b);
        return result === -1 || result === 0;
      }
      /**
       * Checks whether `a` is equal to `b`.
       *
       * @param {array<string>} a
       * @param {array<string>} b
       * @returns {boolean}
       */


      function checkEqual(a, b) {
        return compareComponents(a, b) === 0;
      }
      /**
       * Checks whether `a` is greater than or equal to `b`.
       *
       * @param {array<string>} a
       * @param {array<string>} b
       * @returns {boolean}
       */


      function checkGreaterThanOrEqual(a, b) {
        var result = compareComponents(a, b);
        return result === 1 || result === 0;
      }
      /**
       * Checks whether `a` is greater than `b`.
       *
       * @param {array<string>} a
       * @param {array<string>} b
       * @returns {boolean}
       */


      function checkGreaterThan(a, b) {
        return compareComponents(a, b) === 1;
      }
      /**
       * Checks whether `a` is "reasonably close" to `b` (as described in
       * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
       * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
       *
       * @param {array<string>} a
       * @param {array<string>} b
       * @returns {boolean}
       */


      function checkApproximateVersion(a, b) {
        var lowerBound = b.slice();
        var upperBound = b.slice();

        if (upperBound.length > 1) {
          upperBound.pop();
        }

        var lastIndex = upperBound.length - 1;
        var numeric = parseInt(upperBound[lastIndex], 10);

        if (isNumber(numeric)) {
          upperBound[lastIndex] = numeric + 1 + '';
        }

        return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
      }
      /**
       * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
       * components from `range`.
       *
       * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
       * `">="` and `components` of `[1, 2, 3]`.
       *
       * @param {string} range
       * @returns {object}
       */


      function getModifierAndComponents(range) {
        var rangeComponents = range.split(componentRegex);
        var matches = rangeComponents[0].match(modifierRegex);
        !matches ? false ? undefined : invariant(false) : void 0;
        return {
          modifier: matches[1],
          rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
        };
      }
      /**
       * Determines if `number` is a number.
       *
       * @param {mixed} number
       * @returns {boolean}
       */


      function isNumber(number) {
        return !isNaN(number) && isFinite(number);
      }
      /**
       * Tests whether `range` is a "simple" version number without any modifiers
       * (">", "~" etc).
       *
       * @param {string} range
       * @returns {boolean}
       */


      function isSimpleVersion(range) {
        return !getModifierAndComponents(range).modifier;
      }
      /**
       * Zero-pads array `array` until it is at least `length` long.
       *
       * @param {array} array
       * @param {number} length
       */


      function zeroPad(array, length) {
        for (var i = array.length; i < length; i++) {
          array[i] = '0';
        }
      }
      /**
       * Normalizes `a` and `b` in preparation for comparison by doing the following:
       *
       * - zero-pads `a` and `b`
       * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
       *   in both `a` and `b`
       * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
       *   and all of its successors in `a`
       *
       * @param {array<string>} a
       * @param {array<string>} b
       * @returns {array<array<string>>}
       */


      function normalizeVersions(a, b) {
        a = a.slice();
        b = b.slice();
        zeroPad(a, b.length); // mark "x" and "*" components as equal

        for (var i = 0; i < b.length; i++) {
          var matches = b[i].match(/^[x*]$/i);

          if (matches) {
            b[i] = a[i] = '0'; // final "*" greedily zeros all remaining components

            if (matches[0] === '*' && i === b.length - 1) {
              for (var j = i; j < a.length; j++) {
                a[j] = '0';
              }
            }
          }
        }

        zeroPad(b, a.length);
        return [a, b];
      }
      /**
       * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
       *
       * For example, `10-alpha` is greater than `2-beta`.
       *
       * @param {string} a
       * @param {string} b
       * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
       * or greater than `b`, respectively
       */


      function compareNumeric(a, b) {
        var aPrefix = a.match(numericRegex)[1];
        var bPrefix = b.match(numericRegex)[1];
        var aNumeric = parseInt(aPrefix, 10);
        var bNumeric = parseInt(bPrefix, 10);

        if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
          return compare(aNumeric, bNumeric);
        } else {
          return compare(a, b);
        }
      }
      /**
       * Returns the ordering of `a` and `b`.
       *
       * @param {string|number} a
       * @param {string|number} b
       * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
       * or greater than `b`, respectively
       */


      function compare(a, b) {
        !(typeof a === typeof b) ? false ? undefined : invariant(false) : void 0;

        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1;
        } else {
          return 0;
        }
      }
      /**
       * Compares arrays of version components.
       *
       * @param {array<string>} a
       * @param {array<string>} b
       * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
       * or greater than `b`, respectively
       */


      function compareComponents(a, b) {
        var _normalizeVersions = normalizeVersions(a, b),
            aNormalized = _normalizeVersions[0],
            bNormalized = _normalizeVersions[1];

        for (var i = 0; i < bNormalized.length; i++) {
          var result = compareNumeric(aNormalized[i], bNormalized[i]);

          if (result) {
            return result;
          }
        }

        return 0;
      }

      var VersionRange = {
        /**
         * Checks whether `version` satisfies the `range` specification.
         *
         * We support a subset of the expressions defined in
         * https://www.npmjs.org/doc/misc/semver.html:
         *
         *    version   Must match version exactly
         *    =version  Same as just version
         *    >version  Must be greater than version
         *    >=version Must be greater than or equal to version
         *    <version  Must be less than version
         *    <=version Must be less than or equal to version
         *    ~version  Must be at least version, but less than the next significant
         *              revision above version:
         *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
         *    ~>version Equivalent to ~version
         *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
         *              anything
         *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
         *              "greedy" wildcard, so will match any number of additional
         *              components:
         *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
         *    *         Any version
         *    ""        (Empty string) Same as *
         *    v1 - v2   Equivalent to ">= v1 and <= v2"
         *    r1 || r2  Passes if either r1 or r2 are satisfied
         *
         * @param {string} range
         * @param {string} version
         * @returns {boolean}
         */
        contains: function contains(range, version) {
          return checkOrExpression(range.trim(), version.trim());
        }
      };
      module.exports = VersionRange;
      /***/
    },
    /* 1010 */

    /***/
    function (module, exports) {
      /* WEBPACK VAR INJECTION */
      (function (__webpack_amd_options__) {
        /* globals __webpack_amd_options__ */
        module.exports = __webpack_amd_options__;
        /* WEBPACK VAR INJECTION */
      }).call(this, {});
      /***/
    },
    /* 1011 */

    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
      * UAParser.js v0.7.19
      * Lightweight JavaScript-based User-Agent string parser
      * https://github.com/faisalman/ua-parser-js
      *
      * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
      * Dual licensed under GPLv2 or MIT
      */


      (function (window, undefined) {
        'use strict'; //////////////
        // Constants
        /////////////

        var LIBVERSION = '0.7.19',
            EMPTY = '',
            UNKNOWN = '?',
            FUNC_TYPE = 'function',
            UNDEF_TYPE = 'undefined',
            OBJ_TYPE = 'object',
            STR_TYPE = 'string',
            MAJOR = 'major',
            // deprecated
        MODEL = 'model',
            NAME = 'name',
            TYPE = 'type',
            VENDOR = 'vendor',
            VERSION = 'version',
            ARCHITECTURE = 'architecture',
            CONSOLE = 'console',
            MOBILE = 'mobile',
            TABLET = 'tablet',
            SMARTTV = 'smarttv',
            WEARABLE = 'wearable',
            EMBEDDED = 'embedded'; ///////////
        // Helper
        //////////

        var util = {
          extend: function extend(regexes, extensions) {
            var margedRegexes = {};

            for (var i in regexes) {
              if (extensions[i] && extensions[i].length % 2 === 0) {
                margedRegexes[i] = extensions[i].concat(regexes[i]);
              } else {
                margedRegexes[i] = regexes[i];
              }
            }

            return margedRegexes;
          },
          has: function has(str1, str2) {
            if (typeof str1 === "string") {
              return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
            } else {
              return false;
            }
          },
          lowerize: function lowerize(str) {
            return str.toLowerCase();
          },
          major: function major(version) {
            return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, '').split(".")[0] : undefined;
          },
          trim: function trim(str) {
            return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
          }
        }; ///////////////
        // Map helper
        //////////////

        var mapper = {
          rgx: function rgx(ua, arrays) {
            //var result = {},
            var i = 0,
                j,
                k,
                p,
                q,
                matches,
                match; //, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/
            // loop through all regexes maps

            while (i < arrays.length && !matches) {
              var regex = arrays[i],
                  // even sequence (0,2,4,..)
              props = arrays[i + 1]; // odd sequence (1,3,5,..)

              j = k = 0; // try matching uastring with regexes

              while (j < regex.length && !matches) {
                matches = regex[j++].exec(ua);

                if (!!matches) {
                  for (p = 0; p < props.length; p++) {
                    match = matches[++k];
                    q = props[p]; // check if given property is actually array

                    if (typeof q === OBJ_TYPE && q.length > 0) {
                      if (q.length == 2) {
                        if (typeof q[1] == FUNC_TYPE) {
                          // assign modified match
                          this[q[0]] = q[1].call(this, match);
                        } else {
                          // assign given value, ignore regex match
                          this[q[0]] = q[1];
                        }
                      } else if (q.length == 3) {
                        // check whether function or regex
                        if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                          // call function (usually string mapper)
                          this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                        } else {
                          // sanitize match using given regex
                          this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        }
                      } else if (q.length == 4) {
                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                      }
                    } else {
                      this[q] = match ? match : undefined;
                    }
                  }
                }
              }

              i += 2;
            } // console.log(this);
            //return this;

          },
          str: function str(_str, map) {
            for (var i in map) {
              // check if array
              if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                for (var j = 0; j < map[i].length; j++) {
                  if (util.has(map[i][j], _str)) {
                    return i === UNKNOWN ? undefined : i;
                  }
                }
              } else if (util.has(map[i], _str)) {
                return i === UNKNOWN ? undefined : i;
              }
            }

            return _str;
          }
        }; ///////////////
        // String map
        //////////////

        var maps = {
          browser: {
            oldsafari: {
              version: {
                '1.0': '/8',
                '1.2': '/1',
                '1.3': '/3',
                '2.0': '/412',
                '2.0.2': '/416',
                '2.0.3': '/417',
                '2.0.4': '/419',
                '?': '/'
              }
            }
          },
          device: {
            amazon: {
              model: {
                'Fire Phone': ['SD', 'KF']
              }
            },
            sprint: {
              model: {
                'Evo Shift 4G': '7373KT'
              },
              vendor: {
                'HTC': 'APA',
                'Sprint': 'Sprint'
              }
            }
          },
          os: {
            windows: {
              version: {
                'ME': '4.90',
                'NT 3.11': 'NT3.51',
                'NT 4.0': 'NT4.0',
                '2000': 'NT 5.0',
                'XP': ['NT 5.1', 'NT 5.2'],
                'Vista': 'NT 6.0',
                '7': 'NT 6.1',
                '8': 'NT 6.2',
                '8.1': 'NT 6.3',
                '10': ['NT 6.4', 'NT 10.0'],
                'RT': 'ARM'
              }
            }
          }
        }; //////////////
        // Regex map
        /////////////

        var regexes = {
          browser: [[// Presto based
          /(opera\smini)\/([\w\.-]+)/i, // Opera Mini
          /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, // Opera Mobi/Tablet
          /(opera).+version\/([\w\.]+)/i, // Opera > 9.80
          /(opera)[\/\s]+([\w\.]+)/i // Opera < 9.80
          ], [NAME, VERSION], [/(opios)[\/\s]+([\w\.]+)/i // Opera mini on iphone >= 8.0
          ], [[NAME, 'Opera Mini'], VERSION], [/\s(opr)\/([\w\.]+)/i // Opera Webkit
          ], [[NAME, 'Opera'], VERSION], [// Mixed
          /(kindle)\/([\w\.]+)/i, // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser/Baidu
          /(?:ms|\()(ie)\s([\w\.]+)/i, // Internet Explorer
          // Webkit/KHTML based
          /(rekonq)\/([\w\.]*)/i, // Rekonq
          /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
          ], [NAME, VERSION], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i // IE11
          ], [[NAME, 'IE'], VERSION], [/(edge|edgios|edga)\/((\d+)?[\w\.]+)/i // Microsoft Edge
          ], [[NAME, 'Edge'], VERSION], [/(yabrowser)\/([\w\.]+)/i // Yandex
          ], [[NAME, 'Yandex'], VERSION], [/(puffin)\/([\w\.]+)/i // Puffin
          ], [[NAME, 'Puffin'], VERSION], [/(focus)\/([\w\.]+)/i // Firefox Focus
          ], [[NAME, 'Firefox Focus'], VERSION], [/(opt)\/([\w\.]+)/i // Opera Touch
          ], [[NAME, 'Opera Touch'], VERSION], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i // UCBrowser
          ], [[NAME, 'UCBrowser'], VERSION], [/(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
          ], [[NAME, /_/g, ' '], VERSION], [/(micromessenger)\/([\w\.]+)/i // WeChat
          ], [[NAME, 'WeChat'], VERSION], [/(brave)\/([\w\.]+)/i // Brave browser
          ], [[NAME, 'Brave'], VERSION], [/(qqbrowserlite)\/([\w\.]+)/i // QQBrowserLite
          ], [NAME, VERSION], [/(QQ)\/([\d\.]+)/i // QQ, aka ShouQ
          ], [NAME, VERSION], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i // QQBrowser
          ], [NAME, VERSION], [/(BIDUBrowser)[\/\s]?([\w\.]+)/i // Baidu Browser
          ], [NAME, VERSION], [/(2345Explorer)[\/\s]?([\w\.]+)/i // 2345 Browser
          ], [NAME, VERSION], [/(MetaSr)[\/\s]?([\w\.]+)/i // SouGouBrowser
          ], [NAME], [/(LBBROWSER)/i // LieBao Browser
          ], [NAME], [/xiaomi\/miuibrowser\/([\w\.]+)/i // MIUI Browser
          ], [VERSION, [NAME, 'MIUI Browser']], [/;fbav\/([\w\.]+);/i // Facebook App for iOS & Android
          ], [VERSION, [NAME, 'Facebook']], [/safari\s(line)\/([\w\.]+)/i, // Line App for iOS
          /android.+(line)\/([\w\.]+)\/iab/i // Line App for Android
          ], [NAME, VERSION], [/headlesschrome(?:\/([\w\.]+)|\s)/i // Chrome Headless
          ], [VERSION, [NAME, 'Chrome Headless']], [/\swv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
          ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [// Oculus / Samsung Browser
          /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i // Android Browser
          ], [VERSION, [NAME, 'Android Browser']], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
          ], [NAME, VERSION], [/(dolfin)\/([\w\.]+)/i // Dolphin
          ], [[NAME, 'Dolphin'], VERSION], [/((?:android.+)crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
          ], [[NAME, 'Chrome'], VERSION], [/(coast)\/([\w\.]+)/i // Opera Coast
          ], [[NAME, 'Opera Coast'], VERSION], [/fxios\/([\w\.-]+)/i // Firefox for iOS
          ], [VERSION, [NAME, 'Firefox']], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i // Mobile Safari
          ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i // Safari & Safari Mobile
          ], [VERSION, NAME], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Google Search Appliance on iOS
          ], [[NAME, 'GSA'], VERSION], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
          ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [/(konqueror)\/([\w\.]+)/i, // Konqueror
          /(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [// Gecko based
          /(navigator|netscape)\/([\w\.-]+)/i // Netscape
          ], [[NAME, 'Netscape'], VERSION], [/(swiftfox)/i, // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
          /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
          /(links)\s\(([\w\.]+)/i, // Links
          /(gobrowser)\/?([\w\.]*)/i, // GoBrowser
          /(ice\s?browser)\/v?([\w\._]+)/i, // ICE Browser
          /(mosaic)[\/\s]([\w\.]+)/i // Mosaic
          ], [NAME, VERSION]
          /* /////////////////////
          // Media players BEGIN
          ////////////////////////
           , [
           /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
          /(coremedia) v((\d+)[\w\._]+)/i
          ], [NAME, VERSION], [
           /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
          ], [NAME, VERSION], [
           /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
          ], [NAME, VERSION], [
           /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                              // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                              // NSPlayer/PSP-InternetRadioPlayer/Videos
          /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
          /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
          /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
          ], [NAME, VERSION], [
          /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
          ], [NAME, VERSION], [
           /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
          ], [[NAME, 'Flip Player'], VERSION], [
           /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                              // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
          ], [NAME], [
           /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                              // Gstreamer
          ], [NAME, VERSION], [
           /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
          /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                              // Java/urllib/requests/wget/cURL
          /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
          ], [NAME, VERSION], [
           /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
          ], [[NAME, /_/g, ' '], VERSION], [
           /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                              // MPlayer SVN
          ], [NAME, VERSION], [
           /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
          ], [NAME, VERSION], [
           /(mplayer)/i,                                                       // MPlayer (no other info)
          /(yourmuze)/i,                                                      // YourMuze
          /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
          ], [NAME], [
           /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
          ], [NAME, VERSION], [
           /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
          ], [NAME, VERSION], [
           /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
          ], [NAME, VERSION], [
           /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
          /(winamp)\s((\d+)[\w\.-]+)/i,
          /(winamp)mpeg\/((\d+)[\w\.-]+)/i
          ], [NAME, VERSION], [
           /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                              // inlight radio
          ], [NAME], [
           /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                              // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                              // SoundTap/Totem/Stagefright/Streamium
          ], [NAME, VERSION], [
           /(smp)((\d+)[\d\.]+)/i                                              // SMP
          ], [NAME, VERSION], [
           /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
          /(vlc)\/((\d+)[\w\.-]+)/i,
          /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
          /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
          /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
          ], [NAME, VERSION], [
           /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
          /(windows-media-player)\/((\d+)[\w\.-]+)/i
          ], [[NAME, /-/g, ' '], VERSION], [
           /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                              // Windows Media Server
          ], [VERSION, [NAME, 'Windows']], [
           /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
          ], [NAME, VERSION], [
           /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
          /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
          ], [[NAME, 'rad.io'], VERSION]
           //////////////////////
          // Media players END
          ////////////////////*/
          ],
          cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i // AMD64
          ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
          ], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32
          ], [[ARCHITECTURE, 'ia32']], [// PocketPC mistakenly identified as PowerPC
          /windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i // PowerPC
          ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [/(sun4\w)[;\)]/i // SPARC
          ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
          ], [[ARCHITECTURE, util.lowerize]]],
          device: [[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i // iPad/PlayBook
          ], [MODEL, VENDOR, [TYPE, TABLET]], [/applecoremedia\/[\w\.]+ \((ipad)/ // iPad
          ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [/(apple\s{0,1}tv)/i // Apple TV
          ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [/(archos)\s(gamepad2?)/i, // Archos
          /(hp).+(touchpad)/i, // HP TouchPad
          /(hp).+(tablet)/i, // HP Tablet
          /(kindle)\/([\w\.]+)/i, // Kindle
          /\s(nook)[\w\s]+build\/(\w+)/i, // Nook
          /(dell)\s(strea[kpr\s\d]*[\dko])/i // Dell Streak
          ], [VENDOR, MODEL, [TYPE, TABLET]], [/(kf[A-z]+)\sbuild\/.+silk\//i // Kindle Fire HD
          ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i // Fire Phone
          ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [/android.+aft([bms])\sbuild/i // Fire TV
          ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [/\((ip[honed|\s\w*]+);.+(apple)/i // iPod/iPhone
          ], [MODEL, VENDOR, [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);/i // iPod/iPhone
          ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [/(blackberry)[\s-]?(\w+)/i, // BlackBerry
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp)\s([\w\s]+\w)/i, // HP iPAQ
          /(asus)-?(\w+)/i // Asus
          ], [VENDOR, MODEL, [TYPE, MOBILE]], [/\(bb10;\s(\w+)/i // BlackBerry 10
          ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [// Asus Tablets
          /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [/(sony)\s(tablet\s[ps])\sbuild\//i, // Sony
          /(sony)?(?:sgp.+)\sbuild\//i], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [/\s(ouya)\s/i, // Ouya
          /(nintendo)\s([wids3u]+)/i // Nintendo
          ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/android.+;\s(shield)\sbuild/i // Nvidia
          ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation\s[34portablevi]+)/i // Playstation
          ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [/(sprint\s(\w+))/i // Sprint Phones
          ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i // Lenovo tablets
          ], [VENDOR, MODEL, [TYPE, TABLET]], [/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, // HTC
          /(zte)-(\w*)/i, // ZTE
          /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
          ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [/(nexus\s9)/i // HTC Nexus 9
          ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i // Huawei
          ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [/(microsoft);\s(lumia[\s\w]+)/i // Microsoft Lumia
          ], [VENDOR, MODEL, [TYPE, MOBILE]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i // Microsoft Xbox
          ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
          ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [// Motorola
          /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
          ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
          ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [// Samsung
          /smart-tv.+(samsung)/i], [VENDOR, [TYPE, SMARTTV], MODEL], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [/sie-(\w*)/i // Siemens
          ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, // Nokia
          /(nokia)[\s_-]?([\w-]*)/i], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [/android\s3\.[\s\w;-]{10}(a\d{3})/i // Acer
          ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [/android.+([vl]k\-?\d{3})\s+build/i // LG Tablet
          ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i // LG Tablet
          ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [/(lg) netcast\.tv/i // LG SmartTV
          ], [VENDOR, MODEL, [TYPE, SMARTTV]], [/(nexus\s[45])/i, // LG
          /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [/android.+(ideatab[a-z0-9\-\s]+)/i // Lenovo
          ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [/linux;.+((jolla));/i // Jolla
          ], [VENDOR, MODEL, [TYPE, MOBILE]], [/((pebble))app\/[\d\.]+\s/i // Pebble
          ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
          ], [VENDOR, MODEL, [TYPE, MOBILE]], [/crkey/i // Google Chromecast
          ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [/android.+;\s(glass)\s\d/i // Google Glass
          ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [/android.+;\s(pixel c)[\s)]/i // Google Pixel C
          ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [/android.+;\s(pixel( [23])?( xl)?)\s/i // Google Pixel
          ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [/android.+;\s(\w+)\s+build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
          /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, // Xiaomi Hongmi
          /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, // Xiaomi Mi
          /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i // Redmi Phones
          ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i // Mi Pad tablets
          ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [/android.+;\s(m[1-5]\snote)\sbuild/i // Meizu Tablet
          ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [/(mz)-([\w-]{2,})/i // Meizu Phone
          ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [/android.+a000(1)\s+build/i, // OnePlus
          /android.+oneplus\s(a\d{4})\s+build/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i // RCA Tablets
          ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i // Dell Venue Tablets
          ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i // Verizon Tablet
          ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i // Barnes & Noble Tablet
          ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i // Barnes & Noble Tablet
          ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/android.+;\s(k88)\sbuild/i // ZTE K Series Tablet
          ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i // Swiss GEN Mobile
          ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/android.+[;\/]\s*(zur\d{3})\s+build/i // Swiss ZUR Tablet
          ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i // Zeki Tablets
          ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i // Dragon Touch Tablet
          ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i // Insignia Tablets
          ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i // NextBook Tablets
          ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [// Voice Xtreme Phones
          /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i // LvTel Phones
          ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/android.+;\s(PH-1)\s/i], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [// Essential PH-1
          /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i // Envizen Tablets
          ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i // Le Pan Tablets
          ], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i // MachSpeed Tablets
          ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i // Trinity Tablets
          ], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*TU_(1491)\s+build/i // Rotor Tablets
          ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/android.+(KS(.+))\s+build/i // Amazon Kindle Tablets
          ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i // Gigaset Tablets
          ], [VENDOR, MODEL, [TYPE, TABLET]], [/\s(tablet|tab)[;\/]/i, // Unidentifiable Tablet
          /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
          ], [[TYPE, util.lowerize], VENDOR, MODEL], [/(android[\w\.\s\-]{0,9});.+build/i // Generic Android Device
          ], [MODEL, [VENDOR, 'Generic']]
          /*//////////////////////////
              // TODO: move to string map
              ////////////////////////////
               /(C6603)/i                                                          // Sony Xperia Z C6603
              ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
              /(C6903)/i                                                          // Sony Xperia Z 1
              ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
               /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
              ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
              /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
              ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
              /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
              ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
              /(SM-G313HZ)/i                                                      // Samsung Galaxy V
              ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
              /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
              ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
              /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
              ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
              /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
              ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
               /(T3C)/i                                                            // Advan Vandroid T3C
              ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
              /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
              ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
              /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
              ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
               /(V972M)/i                                                          // ZTE V972M
              ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
               /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [
              /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
              ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
              /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
              ], [VENDOR, MODEL, [TYPE, MOBILE]], [
              /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
              ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
               /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
              ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
               /////////////
              // END TODO
              ///////////*/
          ],
          engine: [[/windows.+\sedge\/([\w\.]+)/i // EdgeHTML
          ], [VERSION, [NAME, 'EdgeHTML']], [/(presto)\/([\w\.]+)/i, // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
          /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, // KHTML/Tasman/Links
          /(icab)[\/\s]([23]\.[\d\.]+)/i // iCab
          ], [NAME, VERSION], [/rv\:([\w\.]{1,9}).+(gecko)/i // Gecko
          ], [VERSION, NAME]],
          os: [[// Windows based
          /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
          ], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, // Windows RT
          /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, // Windows Phone
          /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [// Mobile/Embedded OS
          /\((bb)(10);/i // BlackBerry 10
          ], [[NAME, 'BlackBerry'], VERSION], [/(blackberry)\w*\/?([\w\.]*)/i, // Blackberry
          /(tizen)[\/\s]([\w\.]+)/i, // Tizen
          /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i, // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
          /linux;.+(sailfish);/i // Sailfish OS
          ], [NAME, VERSION], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i // Symbian
          ], [[NAME, 'Symbian'], VERSION], [/\((series40);/i // Series 40
          ], [NAME], [/mozilla.+\(mobile;.+gecko.+firefox/i // Firefox OS
          ], [[NAME, 'Firefox OS'], VERSION], [// Console
          /(nintendo|playstation)\s([wids34portablevu]+)/i, // Nintendo/Playstation
          // GNU/Linux based
          /(mint)[\/\s\(]?(\w*)/i, // Mint
          /(mageia|vectorlinux)[;\s]/i, // Mageia/VectorLinux
          /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i, // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
          // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
          /(hurd|linux)\s?([\w\.]*)/i, // Hurd/Linux
          /(gnu)\s?([\w\.]*)/i // GNU
          ], [NAME, VERSION], [/(cros)\s[\w]+\s([\w\.]+\w)/i // Chromium OS
          ], [[NAME, 'Chromium OS'], VERSION], [// Solaris
          /(sunos)\s?([\w\.\d]*)/i // Solaris
          ], [[NAME, 'Solaris'], VERSION], [// BSD based
          /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
          ], [NAME, VERSION], [/(haiku)\s(\w+)/i // Haiku
          ], [NAME, VERSION], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i // iOS
          ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i // Mac OS
          ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [// Other
          /((?:open)?solaris)[\/\s-]?([\w\.]*)/i, // Solaris
          /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, // AIX
          /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
          /(unix)\s?([\w\.]*)/i // UNIX
          ], [NAME, VERSION]]
        }; /////////////////
        // Constructor
        ////////////////

        /*
        var Browser = function (name, version) {
            this[NAME] = name;
            this[VERSION] = version;
        };
        var CPU = function (arch) {
            this[ARCHITECTURE] = arch;
        };
        var Device = function (vendor, model, type) {
            this[VENDOR] = vendor;
            this[MODEL] = model;
            this[TYPE] = type;
        };
        var Engine = Browser;
        var OS = Browser;
        */

        var UAParser = function UAParser(uastring, extensions) {
          if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
          }

          if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
          }

          var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
          var rgxmap = extensions ? util.extend(regexes, extensions) : regexes; //var browser = new Browser();
          //var cpu = new CPU();
          //var device = new Device();
          //var engine = new Engine();
          //var os = new OS();

          this.getBrowser = function () {
            var browser = {
              name: undefined,
              version: undefined
            };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated

            return browser;
          };

          this.getCPU = function () {
            var cpu = {
              architecture: undefined
            };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
          };

          this.getDevice = function () {
            var device = {
              vendor: undefined,
              model: undefined,
              type: undefined
            };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
          };

          this.getEngine = function () {
            var engine = {
              name: undefined,
              version: undefined
            };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
          };

          this.getOS = function () {
            var os = {
              name: undefined,
              version: undefined
            };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
          };

          this.getResult = function () {
            return {
              ua: this.getUA(),
              browser: this.getBrowser(),
              engine: this.getEngine(),
              os: this.getOS(),
              device: this.getDevice(),
              cpu: this.getCPU()
            };
          };

          this.getUA = function () {
            return ua;
          };

          this.setUA = function (uastring) {
            ua = uastring; //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();

            return this;
          };

          return this;
        };

        UAParser.VERSION = LIBVERSION;
        UAParser.BROWSER = {
          NAME: NAME,
          MAJOR: MAJOR,
          // deprecated
          VERSION: VERSION
        };
        UAParser.CPU = {
          ARCHITECTURE: ARCHITECTURE
        };
        UAParser.DEVICE = {
          MODEL: MODEL,
          VENDOR: VENDOR,
          TYPE: TYPE,
          CONSOLE: CONSOLE,
          MOBILE: MOBILE,
          SMARTTV: SMARTTV,
          TABLET: TABLET,
          WEARABLE: WEARABLE,
          EMBEDDED: EMBEDDED
        };
        UAParser.ENGINE = {
          NAME: NAME,
          VERSION: VERSION
        };
        UAParser.OS = {
          NAME: NAME,
          VERSION: VERSION
        }; //UAParser.Utils = util;
        ///////////
        // Export
        //////////
        // check js environment

        if (typeof exports !== UNDEF_TYPE) {
          // nodejs env
          if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
          } // TODO: test!!!!!!!!

          /*
          if (require && require.main === module && process) {
              // cli
              var jsonize = function (arr) {
                  var res = [];
                  for (var i in arr) {
                      res.push(new UAParser(arr[i]).getResult());
                  }
                  process.stdout.write(JSON.stringify(res, null, 2) + '\n');
              };
              if (process.stdin.isTTY) {
                  // via args
                  jsonize(process.argv.slice(2));
              } else {
                  // via pipe
                  var str = '';
                  process.stdin.on('readable', function() {
                      var read = process.stdin.read();
                      if (read !== null) {
                          str += read;
                      }
                  });
                  process.stdin.on('end', function () {
                      jsonize(str.replace(/\n$/, '').split('\n'));
                  });
              }
          }
          */


          exports.UAParser = UAParser;
        } else {
          // requirejs env (optional)
          if ("function" === FUNC_TYPE && __webpack_require__(1010)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return UAParser;
            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else if (window) {
            // browser env
            window.UAParser = UAParser;
          }
        } // jQuery/Zepto specific (optional)
        // Note:
        //   In AMD env the global scope should be kept clean, but jQuery is an exception.
        //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
        //   and we should catch that.


        var $ = window && (window.jQuery || window.Zepto);

        if (typeof $ !== UNDEF_TYPE && !$.ua) {
          var parser = new UAParser();
          $.ua = parser.getResult();

          $.ua.get = function () {
            return parser.getUA();
          };

          $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();

            for (var prop in result) {
              $.ua[prop] = result[prop];
            }
          };
        }
      })(typeof window === 'object' ? window : this);
      /***/

    },
    /* 1012 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      /**
       * Usage note:
       * This module makes a best effort to export the same data we would internally.
       * At Facebook we use a server-generated module that does the parsing and
       * exports the data for the client to use. We can't rely on a server-side
       * implementation in open source so instead we make use of an open source
       * library to do the heavy lifting and then make some adjustments as necessary.
       * It's likely there will be some differences. Some we can smooth over.
       * Others are going to be harder.
       */

      var UAParser = __webpack_require__(1011);

      var UNKNOWN = 'Unknown';
      var PLATFORM_MAP = {
        'Mac OS': 'Mac OS X'
      };
      /**
       * Convert from UAParser platform name to what we expect.
       */

      function convertPlatformName(name) {
        return PLATFORM_MAP[name] || name;
      }
      /**
       * Get the version number in parts. This is very naive. We actually get major
       * version as a part of UAParser already, which is generally good enough, but
       * let's get the minor just in case.
       */


      function getBrowserVersion(version) {
        if (!version) {
          return {
            major: '',
            minor: ''
          };
        }

        var parts = version.split('.');
        return {
          major: parts[0],
          minor: parts[1]
        };
      }
      /**
       * Get the UA data fom UAParser and then convert it to the format we're
       * expecting for our APIS.
       */


      var parser = new UAParser();
      var results = parser.getResult(); // Do some conversion first.

      var browserVersionData = getBrowserVersion(results.browser.version);
      var uaData = {
        browserArchitecture: results.cpu.architecture || UNKNOWN,
        browserFullVersion: results.browser.version || UNKNOWN,
        browserMinorVersion: browserVersionData.minor || UNKNOWN,
        browserName: results.browser.name || UNKNOWN,
        browserVersion: results.browser.major || UNKNOWN,
        deviceName: results.device.model || UNKNOWN,
        engineName: results.engine.name || UNKNOWN,
        engineVersion: results.engine.version || UNKNOWN,
        platformArchitecture: results.cpu.architecture || UNKNOWN,
        platformName: convertPlatformName(results.os.name) || UNKNOWN,
        platformVersion: results.os.version || UNKNOWN,
        platformFullVersion: results.os.version || UNKNOWN
      };
      module.exports = uaData;
      /***/
    },
    /* 1013 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEditorTextNode.react
       * @format
       * 
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var React = __webpack_require__(1);

      var ReactDOM = __webpack_require__(16);

      var UserAgent = __webpack_require__(113);

      var invariant = __webpack_require__(51); // In IE, spans with <br> tags render as two newlines. By rendering a span
      // with only a newline character, we can be sure to render a single line.


      var useNewlineChar = UserAgent.isBrowser('IE <= 11');
      /**
       * Check whether the node should be considered a newline.
       */

      function isNewline(node) {
        return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
      }
      /**
       * Placeholder elements for empty text content.
       *
       * What is this `data-text` attribute, anyway? It turns out that we need to
       * put an attribute on the lowest-level text node in order to preserve correct
       * spellcheck handling. If the <span> is naked, Chrome and Safari may do
       * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
       * If the <span> has an attribute, this appears not to happen.
       * See http://jsfiddle.net/9khdavod/ for the failure case, and
       * http://jsfiddle.net/7pg143f7/ for the fixed case.
       */


      var NEWLINE_A = useNewlineChar ? React.createElement('span', {
        key: 'A',
        'data-text': 'true'
      }, '\n') : React.createElement('br', {
        key: 'A',
        'data-text': 'true'
      });
      var NEWLINE_B = useNewlineChar ? React.createElement('span', {
        key: 'B',
        'data-text': 'true'
      }, '\n') : React.createElement('br', {
        key: 'B',
        'data-text': 'true'
      });
      /**
       * The lowest-level component in a `DraftEditor`, the text node component
       * replaces the default React text node implementation. This allows us to
       * perform custom handling of newline behavior and avoid re-rendering text
       * nodes with DOM state that already matches the expectations of our immutable
       * editor state.
       */

      var DraftEditorTextNode = function (_React$Component) {
        _inherits(DraftEditorTextNode, _React$Component);

        function DraftEditorTextNode(props) {
          _classCallCheck(this, DraftEditorTextNode); // By flipping this flag, we also keep flipping keys which forces
          // React to remount this node every time it rerenders.


          var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

          _this._forceFlag = false;
          return _this;
        }

        DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          var node = ReactDOM.findDOMNode(this);
          var shouldBeNewline = nextProps.children === '';
          !(node instanceof Element) ? false ? undefined : invariant(false) : void 0;

          if (shouldBeNewline) {
            return !isNewline(node);
          }

          return node.textContent !== nextProps.children;
        };

        DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
          this._forceFlag = !this._forceFlag;
        };

        DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
          this._forceFlag = !this._forceFlag;
        };

        DraftEditorTextNode.prototype.render = function render() {
          if (this.props.children === '') {
            return this._forceFlag ? NEWLINE_A : NEWLINE_B;
          }

          return React.createElement('span', {
            key: this._forceFlag ? 'A' : 'B',
            'data-text': 'true'
          }, this.props.children);
        };

        return DraftEditorTextNode;
      }(React.Component);

      module.exports = DraftEditorTextNode;
      /***/
    },
    /* 1014 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEditorLeaf.react
       * @format
       * 
       */

      var _assign = __webpack_require__(82);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var DraftEditorTextNode = __webpack_require__(1013);

      var React = __webpack_require__(1);

      var ReactDOM = __webpack_require__(16);

      var invariant = __webpack_require__(51);

      var setDraftEditorSelection = __webpack_require__(1006);
      /**
       * All leaf nodes in the editor are spans with single text nodes. Leaf
       * elements are styled based on the merging of an optional custom style map
       * and a default style map.
       *
       * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
       * DOM Selection API. In this way, top-level components can declaratively
       * maintain the selection state.
       */


      var DraftEditorLeaf = function (_React$Component) {
        _inherits(DraftEditorLeaf, _React$Component);

        function DraftEditorLeaf() {
          _classCallCheck(this, DraftEditorLeaf);

          return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        DraftEditorLeaf.prototype._setSelection = function _setSelection() {
          var selection = this.props.selection; // If selection state is irrelevant to the parent block, no-op.

          if (selection == null || !selection.getHasFocus()) {
            return;
          }

          var _props = this.props,
              block = _props.block,
              start = _props.start,
              text = _props.text;
          var blockKey = block.getKey();
          var end = start + text.length;

          if (!selection.hasEdgeWithin(blockKey, start, end)) {
            return;
          } // Determine the appropriate target node for selection. If the child
          // is not a text node, it is a <br /> spacer. In this case, use the
          // <span> itself as the selection target.


          var node = ReactDOM.findDOMNode(this);
          !node ? false ? undefined : invariant(false) : void 0;
          var child = node.firstChild;
          !child ? false ? undefined : invariant(false) : void 0;
          var targetNode = void 0;

          if (child.nodeType === Node.TEXT_NODE) {
            targetNode = child;
          } else if (child.tagName === 'BR') {
            targetNode = node;
          } else {
            targetNode = child.firstChild;
            !targetNode ? false ? undefined : invariant(false) : void 0;
          }

          setDraftEditorSelection(selection, targetNode, blockKey, start, end);
        };
        /**
         * By making individual leaf instances aware of their context within
         * the text of the editor, we can set our selection range more
         * easily than we could in the non-React world.
         *
         * Note that this depends on our maintaining tight control over the
         * DOM structure of the DraftEditor component. If leaves had multiple
         * text nodes, this would be harder.
         */


        DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          var leafNode = ReactDOM.findDOMNode(this.leaf);
          !leafNode ? false ? undefined : invariant(false) : void 0;
          return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
        };

        DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
          this._setSelection();
        };

        DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
          this._setSelection();
        };

        DraftEditorLeaf.prototype.render = function render() {
          var _this2 = this;

          var block = this.props.block;
          var text = this.props.text; // If the leaf is at the end of its block and ends in a soft newline, append
          // an extra line feed character. Browsers collapse trailing newline
          // characters, which leaves the cursor in the wrong place after a
          // shift+enter. The extra character repairs this.

          if (text.endsWith('\n') && this.props.isLast) {
            text += '\n';
          }

          var _props2 = this.props,
              customStyleMap = _props2.customStyleMap,
              customStyleFn = _props2.customStyleFn,
              offsetKey = _props2.offsetKey,
              styleSet = _props2.styleSet;
          var styleObj = styleSet.reduce(function (map, styleName) {
            var mergedStyles = {};
            var style = customStyleMap[styleName];

            if (style !== undefined && map.textDecoration !== style.textDecoration) {
              // .trim() is necessary for IE9/10/11 and Edge
              mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
            }

            return _assign(map, style, mergedStyles);
          }, {});

          if (customStyleFn) {
            var newStyles = customStyleFn(styleSet, block);
            styleObj = _assign(styleObj, newStyles);
          }

          return React.createElement('span', {
            'data-offset-key': offsetKey,
            ref: function ref(_ref) {
              return _this2.leaf = _ref;
            },
            style: styleObj
          }, React.createElement(DraftEditorTextNode, null, text));
        };

        return DraftEditorLeaf;
      }(React.Component);

      module.exports = DraftEditorLeaf;
      /***/
    },
    /* 1015 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEditorContents-core.react
       * @format
       * 
       */

      var _assign = __webpack_require__(82);

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var DraftEditorBlock = __webpack_require__(475);

      var DraftOffsetKey = __webpack_require__(182);

      var EditorState = __webpack_require__(60);

      var React = __webpack_require__(1);

      var cx = __webpack_require__(173);

      var joinClasses = __webpack_require__(994);

      var nullthrows = __webpack_require__(108);
      /**
       * Provide default styling for list items. This way, lists will be styled with
       * proper counters and indentation even if the caller does not specify
       * their own styling at all. If more than five levels of nesting are needed,
       * the necessary CSS classes can be provided via `blockStyleFn` configuration.
       */


      var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
        return cx({
          'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
          'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
          'public/DraftStyleDefault/reset': shouldResetCount,
          'public/DraftStyleDefault/depth0': depth === 0,
          'public/DraftStyleDefault/depth1': depth === 1,
          'public/DraftStyleDefault/depth2': depth === 2,
          'public/DraftStyleDefault/depth3': depth === 3,
          'public/DraftStyleDefault/depth4': depth === 4,
          'public/DraftStyleDefault/listLTR': direction === 'LTR',
          'public/DraftStyleDefault/listRTL': direction === 'RTL'
        });
      };
      /**
       * `DraftEditorContents` is the container component for all block components
       * rendered for a `DraftEditor`. It is optimized to aggressively avoid
       * re-rendering blocks whenever possible.
       *
       * This component is separate from `DraftEditor` because certain props
       * (for instance, ARIA props) must be allowed to update without affecting
       * the contents of the editor.
       */


      var DraftEditorContents = function (_React$Component) {
        _inherits(DraftEditorContents, _React$Component);

        function DraftEditorContents() {
          _classCallCheck(this, DraftEditorContents);

          return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          var prevEditorState = this.props.editorState;
          var nextEditorState = nextProps.editorState;
          var prevDirectionMap = prevEditorState.getDirectionMap();
          var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.

          if (prevDirectionMap !== nextDirectionMap) {
            return true;
          }

          var didHaveFocus = prevEditorState.getSelection().getHasFocus();
          var nowHasFocus = nextEditorState.getSelection().getHasFocus();

          if (didHaveFocus !== nowHasFocus) {
            return true;
          }

          var nextNativeContent = nextEditorState.getNativelyRenderedContent();
          var wasComposing = prevEditorState.isInCompositionMode();
          var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
          // rendered state, there's nothing new to be done.

          if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
            return false;
          }

          var prevContent = prevEditorState.getCurrentContent();
          var nextContent = nextEditorState.getCurrentContent();
          var prevDecorator = prevEditorState.getDecorator();
          var nextDecorator = nextEditorState.getDecorator();
          return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
        };

        DraftEditorContents.prototype.render = function render() {
          var _props = this.props,
              blockRenderMap = _props.blockRenderMap,
              blockRendererFn = _props.blockRendererFn,
              blockStyleFn = _props.blockStyleFn,
              customStyleMap = _props.customStyleMap,
              customStyleFn = _props.customStyleFn,
              editorState = _props.editorState,
              editorKey = _props.editorKey,
              textDirectionality = _props.textDirectionality;
          var content = editorState.getCurrentContent();
          var selection = editorState.getSelection();
          var forceSelection = editorState.mustForceSelection();
          var decorator = editorState.getDecorator();
          var directionMap = nullthrows(editorState.getDirectionMap());
          var blocksAsArray = content.getBlocksAsArray();
          var processedBlocks = [];
          var currentDepth = null;
          var lastWrapperTemplate = null;

          for (var ii = 0; ii < blocksAsArray.length; ii++) {
            var _block = blocksAsArray[ii];

            var key = _block.getKey();

            var blockType = _block.getType();

            var customRenderer = blockRendererFn(_block);
            var CustomComponent = void 0,
                customProps = void 0,
                customEditable = void 0;

            if (customRenderer) {
              CustomComponent = customRenderer.component;
              customProps = customRenderer.props;
              customEditable = customRenderer.editable;
            }

            var direction = textDirectionality ? textDirectionality : directionMap.get(key);
            var offsetKey = DraftOffsetKey.encode(key, 0, 0);
            var componentProps = {
              contentState: content,
              block: _block,
              blockProps: customProps,
              blockStyleFn: blockStyleFn,
              customStyleMap: customStyleMap,
              customStyleFn: customStyleFn,
              decorator: decorator,
              direction: direction,
              forceSelection: forceSelection,
              key: key,
              offsetKey: offsetKey,
              selection: selection,
              tree: editorState.getBlockTree(key)
            };
            var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
            var wrapperTemplate = configForType.wrapper;
            var Element = configForType.element || blockRenderMap.get('unstyled').element;

            var depth = _block.getDepth();

            var className = '';

            if (blockStyleFn) {
              className = blockStyleFn(_block);
            } // List items are special snowflakes, since we handle nesting and
            // counters manually.


            if (Element === 'li') {
              var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
              className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
            }

            var Component = CustomComponent || DraftEditorBlock;
            var childProps = {
              className: className,
              'data-block': true,
              'data-editor': editorKey,
              'data-offset-key': offsetKey,
              key: key
            };

            if (customEditable !== undefined) {
              childProps = _extends({}, childProps, {
                contentEditable: customEditable,
                suppressContentEditableWarning: true
              });
            }

            var child = React.createElement(Element, childProps, React.createElement(Component, componentProps));
            processedBlocks.push({
              block: child,
              wrapperTemplate: wrapperTemplate,
              key: key,
              offsetKey: offsetKey
            });

            if (wrapperTemplate) {
              currentDepth = _block.getDepth();
            } else {
              currentDepth = null;
            }

            lastWrapperTemplate = wrapperTemplate;
          } // Group contiguous runs of blocks that have the same wrapperTemplate


          var outputBlocks = [];

          for (var _ii = 0; _ii < processedBlocks.length;) {
            var info = processedBlocks[_ii];

            if (info.wrapperTemplate) {
              var blocks = [];

              do {
                blocks.push(processedBlocks[_ii].block);
                _ii++;
              } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);

              var wrapperElement = React.cloneElement(info.wrapperTemplate, {
                key: info.key + '-wrap',
                'data-offset-key': info.offsetKey
              }, blocks);
              outputBlocks.push(wrapperElement);
            } else {
              outputBlocks.push(info.block);
              _ii++;
            }
          }

          return React.createElement('div', {
            'data-contents': 'true'
          }, outputBlocks);
        };

        return DraftEditorContents;
      }(React.Component);

      module.exports = DraftEditorContents;
      /***/
    },
    /* 1016 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEditorContents.react
       * @format
       * 
       */

      var DraftEditorContents = __webpack_require__(1015);

      module.exports = DraftEditorContents;
      /***/
    },
    /* 1017 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEditorCompositionHandler
       * @format
       * 
       */

      var DraftFeatureFlags = __webpack_require__(133);

      var DraftModifier = __webpack_require__(93);

      var EditorState = __webpack_require__(60);

      var Keys = __webpack_require__(340);

      var getEntityKeyForSelection = __webpack_require__(339);

      var isEventHandled = __webpack_require__(204);

      var isSelectionAtLeafStart = __webpack_require__(476);
      /**
       * Millisecond delay to allow `compositionstart` to fire again upon
       * `compositionend`.
       *
       * This is used for Korean input to ensure that typing can continue without
       * the editor trying to render too quickly. More specifically, Safari 7.1+
       * triggers `compositionstart` a little slower than Chrome/FF, which
       * leads to composed characters being resolved and re-render occurring
       * sooner than we want.
       */


      var RESOLVE_DELAY = 20;
      /**
       * A handful of variables used to track the current composition and its
       * resolution status. These exist at the module level because it is not
       * possible to have compositions occurring in multiple editors simultaneously,
       * and it simplifies state management with respect to the DraftEditor component.
       */

      var resolved = false;
      var stillComposing = false;
      var textInputData = '';
      var DraftEditorCompositionHandler = {
        onBeforeInput: function onBeforeInput(editor, e) {
          textInputData = (textInputData || '') + e.data;
        },

        /**
         * A `compositionstart` event has fired while we're still in composition
         * mode. Continue the current composition session to prevent a re-render.
         */
        onCompositionStart: function onCompositionStart(editor) {
          stillComposing = true;
        },

        /**
         * Attempt to end the current composition session.
         *
         * Defer handling because browser will still insert the chars into active
         * element after `compositionend`. If a `compositionstart` event fires
         * before `resolveComposition` executes, our composition session will
         * continue.
         *
         * The `resolved` flag is useful because certain IME interfaces fire the
         * `compositionend` event multiple times, thus queueing up multiple attempts
         * at handling the composition. Since handling the same composition event
         * twice could break the DOM, we only use the first event. Example: Arabic
         * Google Input Tools on Windows 8.1 fires `compositionend` three times.
         */
        onCompositionEnd: function onCompositionEnd(editor) {
          resolved = false;
          stillComposing = false;
          setTimeout(function () {
            if (!resolved) {
              DraftEditorCompositionHandler.resolveComposition(editor);
            }
          }, RESOLVE_DELAY);
        },

        /**
         * In Safari, keydown events may fire when committing compositions. If
         * the arrow keys are used to commit, prevent default so that the cursor
         * doesn't move, otherwise it will jump back noticeably on re-render.
         */
        onKeyDown: function onKeyDown(editor, e) {
          if (!stillComposing) {
            // If a keydown event is received after compositionend but before the
            // 20ms timer expires (ex: type option-E then backspace, or type A then
            // backspace in 2-Set Korean), we should immediately resolve the
            // composition and reinterpret the key press in edit mode.
            DraftEditorCompositionHandler.resolveComposition(editor);

            editor._onKeyDown(e);

            return;
          }

          if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
            e.preventDefault();
          }
        },

        /**
         * Keypress events may fire when committing compositions. In Firefox,
         * pressing RETURN commits the composition and inserts extra newline
         * characters that we do not want. `preventDefault` allows the composition
         * to be committed while preventing the extra characters.
         */
        onKeyPress: function onKeyPress(editor, e) {
          if (e.which === Keys.RETURN) {
            e.preventDefault();
          }
        },

        /**
         * Attempt to insert composed characters into the document.
         *
         * If we are still in a composition session, do nothing. Otherwise, insert
         * the characters into the document and terminate the composition session.
         *
         * If no characters were composed -- for instance, the user
         * deleted all composed characters and committed nothing new --
         * force a re-render. We also re-render when the composition occurs
         * at the beginning of a leaf, to ensure that if the browser has
         * created a new text node for the composition, we will discard it.
         *
         * Resetting innerHTML will move focus to the beginning of the editor,
         * so we update to force it back to the correct place.
         */
        resolveComposition: function resolveComposition(editor) {
          if (stillComposing) {
            return;
          }

          resolved = true;
          var composedChars = textInputData;
          textInputData = '';
          var editorState = EditorState.set(editor._latestEditorState, {
            inCompositionMode: false
          });
          var currentStyle = editorState.getCurrentInlineStyle();
          var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());
          var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;

          if (mustReset) {
            editor.restoreEditorDOM();
          }

          editor.exitCurrentMode();

          if (composedChars) {
            if (DraftFeatureFlags.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(composedChars, editorState))) {
              return;
            } // If characters have been composed, re-rendering with the update
            // is sufficient to reset the editor.


            var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
            editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
            return;
          }

          if (mustReset) {
            editor.update(EditorState.set(editorState, {
              nativelyRenderedContent: null,
              forceSelection: true
            }));
          }
        }
      };
      module.exports = DraftEditorCompositionHandler;
      /***/
    },
    /* 1018 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEditor.react
       * @format
       * 
       * @preventMunge
       */

      var _assign = __webpack_require__(82);

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var DefaultDraftBlockRenderMap = __webpack_require__(341);

      var DefaultDraftInlineStyle = __webpack_require__(477);

      var DraftEditorCompositionHandler = __webpack_require__(1017);

      var DraftEditorContents = __webpack_require__(1016);

      var DraftEditorDragHandler = __webpack_require__(993);

      var DraftEditorEditHandler = __webpack_require__(990);

      var DraftEditorPlaceholder = __webpack_require__(958);

      var EditorState = __webpack_require__(60);

      var React = __webpack_require__(1);

      var ReactDOM = __webpack_require__(16);

      var Scroll = __webpack_require__(473);

      var Style = __webpack_require__(337);

      var UserAgent = __webpack_require__(113);

      var cx = __webpack_require__(173);

      var emptyFunction = __webpack_require__(345);

      var generateRandomKey = __webpack_require__(127);

      var getDefaultKeyBinding = __webpack_require__(460);

      var getScrollPosition = __webpack_require__(336);

      var invariant = __webpack_require__(51);

      var nullthrows = __webpack_require__(108);

      var isIE = UserAgent.isBrowser('IE'); // IE does not support the `input` event on contentEditable, so we can't
      // observe spellcheck behavior.

      var allowSpellCheck = !isIE; // Define a set of handler objects to correspond to each possible `mode`
      // of editor behavior.

      var handlerMap = {
        edit: DraftEditorEditHandler,
        composite: DraftEditorCompositionHandler,
        drag: DraftEditorDragHandler,
        cut: null,
        render: null
      };
      /**
       * `DraftEditor` is the root editor component. It composes a `contentEditable`
       * div, and provides a wide variety of useful function props for managing the
       * state of the editor. See `DraftEditorProps` for details.
       */

      var DraftEditor = function (_React$Component) {
        _inherits(DraftEditor, _React$Component);

        function DraftEditor(props) {
          _classCallCheck(this, DraftEditor);

          var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

          _this.focus = function (scrollPosition) {
            var editorState = _this.props.editorState;
            var alreadyHasFocus = editorState.getSelection().getHasFocus();
            var editorNode = ReactDOM.findDOMNode(_this.editor);

            if (!editorNode) {
              // once in a while people call 'focus' in a setTimeout, and the node has
              // been deleted, so it can be null in that case.
              return;
            }

            var scrollParent = Style.getScrollParent(editorNode);

            var _ref = scrollPosition || getScrollPosition(scrollParent),
                x = _ref.x,
                y = _ref.y;

            !(editorNode instanceof HTMLElement) ? false ? undefined : invariant(false) : void 0;
            editorNode.focus(); // Restore scroll position

            if (scrollParent === window) {
              window.scrollTo(x, y);
            } else {
              Scroll.setTop(scrollParent, y);
            } // On Chrome and Safari, calling focus on contenteditable focuses the
            // cursor at the first character. This is something you don't expect when
            // you're clicking on an input element but not directly on a character.
            // Put the cursor back where it was before the blur.


            if (!alreadyHasFocus) {
              _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
            }
          };

          _this.blur = function () {
            var editorNode = ReactDOM.findDOMNode(_this.editor);
            !(editorNode instanceof HTMLElement) ? false ? undefined : invariant(false) : void 0;
            editorNode.blur();
          };

          _this.setMode = function (mode) {
            _this._handler = handlerMap[mode];
          };

          _this.exitCurrentMode = function () {
            _this.setMode('edit');
          };

          _this.restoreEditorDOM = function (scrollPosition) {
            _this.setState({
              contentsKey: _this.state.contentsKey + 1
            }, function () {
              _this.focus(scrollPosition);
            });
          };

          _this.setClipboard = function (clipboard) {
            _this._clipboard = clipboard;
          };

          _this.getClipboard = function () {
            return _this._clipboard;
          };

          _this.update = function (editorState) {
            _this._latestEditorState = editorState;

            _this.props.onChange(editorState);
          };

          _this.onDragEnter = function () {
            _this._dragCount++;
          };

          _this.onDragLeave = function () {
            _this._dragCount--;

            if (_this._dragCount === 0) {
              _this.exitCurrentMode();
            }
          };

          _this._blockSelectEvents = false;
          _this._clipboard = null;
          _this._handler = null;
          _this._dragCount = 0;
          _this._editorKey = props.editorKey || generateRandomKey();
          _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
          _this._latestEditorState = props.editorState;
          _this._latestCommittedEditorState = props.editorState;
          _this._onBeforeInput = _this._buildHandler('onBeforeInput');
          _this._onBlur = _this._buildHandler('onBlur');
          _this._onCharacterData = _this._buildHandler('onCharacterData');
          _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
          _this._onCompositionStart = _this._buildHandler('onCompositionStart');
          _this._onCopy = _this._buildHandler('onCopy');
          _this._onCut = _this._buildHandler('onCut');
          _this._onDragEnd = _this._buildHandler('onDragEnd');
          _this._onDragOver = _this._buildHandler('onDragOver');
          _this._onDragStart = _this._buildHandler('onDragStart');
          _this._onDrop = _this._buildHandler('onDrop');
          _this._onInput = _this._buildHandler('onInput');
          _this._onFocus = _this._buildHandler('onFocus');
          _this._onKeyDown = _this._buildHandler('onKeyDown');
          _this._onKeyPress = _this._buildHandler('onKeyPress');
          _this._onKeyUp = _this._buildHandler('onKeyUp');
          _this._onMouseDown = _this._buildHandler('onMouseDown');
          _this._onMouseUp = _this._buildHandler('onMouseUp');
          _this._onPaste = _this._buildHandler('onPaste');
          _this._onSelect = _this._buildHandler('onSelect');

          _this.getEditorKey = function () {
            return _this._editorKey;
          }; // See `restoreEditorDOM()`.


          _this.state = {
            contentsKey: 0
          };
          return _this;
        }
        /**
         * Build a method that will pass the event to the specified handler method.
         * This allows us to look up the correct handler function for the current
         * editor mode, if any has been specified.
         */

        /**
         * Define proxies that can route events to the current handler.
         */


        DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
          var _this2 = this;

          return function (e) {
            if (!_this2.props.readOnly) {
              var method = _this2._handler && _this2._handler[eventName];
              method && method(_this2, e);
            }
          };
        };

        DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
          return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
        };

        DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
          if (this._showPlaceholder()) {
            var placeHolderProps = {
              text: nullthrows(this.props.placeholder),
              editorState: this.props.editorState,
              textAlignment: this.props.textAlignment,
              accessibilityID: this._placeholderAccessibilityID
            };
            return React.createElement(DraftEditorPlaceholder, placeHolderProps);
          }

          return null;
        };

        DraftEditor.prototype.render = function render() {
          var _this3 = this;

          var _props = this.props,
              blockRenderMap = _props.blockRenderMap,
              blockRendererFn = _props.blockRendererFn,
              blockStyleFn = _props.blockStyleFn,
              customStyleFn = _props.customStyleFn,
              customStyleMap = _props.customStyleMap,
              editorState = _props.editorState,
              readOnly = _props.readOnly,
              textAlignment = _props.textAlignment,
              textDirectionality = _props.textDirectionality;
          var rootClass = cx({
            'DraftEditor/root': true,
            'DraftEditor/alignLeft': textAlignment === 'left',
            'DraftEditor/alignRight': textAlignment === 'right',
            'DraftEditor/alignCenter': textAlignment === 'center'
          });
          var contentStyle = {
            outline: 'none',
            // fix parent-draggable Safari bug. #1326
            userSelect: 'text',
            WebkitUserSelect: 'text',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word'
          }; // The aria-expanded and aria-haspopup properties should only be rendered
          // for a combobox.

          var ariaRole = this.props.role || 'textbox';
          var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
          var editorContentsProps = {
            blockRenderMap: blockRenderMap,
            blockRendererFn: blockRendererFn,
            blockStyleFn: blockStyleFn,
            customStyleMap: _extends({}, DefaultDraftInlineStyle, customStyleMap),
            customStyleFn: customStyleFn,
            editorKey: this._editorKey,
            editorState: editorState,
            key: 'contents' + this.state.contentsKey,
            textDirectionality: textDirectionality
          };
          return React.createElement('div', {
            className: rootClass
          }, this._renderPlaceholder(), React.createElement('div', {
            className: cx('DraftEditor/editorContainer'),
            ref: function ref(_ref3) {
              return _this3.editorContainer = _ref3;
            }
          }, React.createElement('div', {
            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
            'aria-controls': readOnly ? null : this.props.ariaControls,
            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
            'aria-expanded': readOnly ? null : ariaExpanded,
            'aria-label': this.props.ariaLabel,
            'aria-labelledby': this.props.ariaLabelledBy,
            'aria-multiline': this.props.ariaMultiline,
            autoCapitalize: this.props.autoCapitalize,
            autoComplete: this.props.autoComplete,
            autoCorrect: this.props.autoCorrect,
            className: cx({
              // Chrome's built-in translation feature mutates the DOM in ways
              // that Draft doesn't expect (ex: adding <font> tags inside
              // DraftEditorLeaf spans) and causes problems. We add notranslate
              // here which makes its autotranslation skip over this subtree.
              notranslate: !readOnly,
              'public/DraftEditor/content': true
            }),
            contentEditable: !readOnly,
            'data-testid': this.props.webDriverTestID,
            onBeforeInput: this._onBeforeInput,
            onBlur: this._onBlur,
            onCompositionEnd: this._onCompositionEnd,
            onCompositionStart: this._onCompositionStart,
            onCopy: this._onCopy,
            onCut: this._onCut,
            onDragEnd: this._onDragEnd,
            onDragEnter: this.onDragEnter,
            onDragLeave: this.onDragLeave,
            onDragOver: this._onDragOver,
            onDragStart: this._onDragStart,
            onDrop: this._onDrop,
            onFocus: this._onFocus,
            onInput: this._onInput,
            onKeyDown: this._onKeyDown,
            onKeyPress: this._onKeyPress,
            onKeyUp: this._onKeyUp,
            onMouseUp: this._onMouseUp,
            onPaste: this._onPaste,
            onSelect: this._onSelect,
            ref: function ref(_ref2) {
              return _this3.editor = _ref2;
            },
            role: readOnly ? null : ariaRole,
            spellCheck: allowSpellCheck && this.props.spellCheck,
            style: contentStyle,
            suppressContentEditableWarning: true,
            tabIndex: this.props.tabIndex
          }, React.createElement(DraftEditorContents, editorContentsProps))));
        };

        DraftEditor.prototype.componentDidMount = function componentDidMount() {
          this.setMode('edit');
          /**
           * IE has a hardcoded "feature" that attempts to convert link text into
           * anchors in contentEditable DOM. This breaks the editor's expectations of
           * the DOM, and control is lost. Disable it to make IE behave.
           * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
           * ie9-beta-minor-change-list.aspx
           */

          if (isIE) {
            document.execCommand('AutoUrlDetect', false, false);
          }
        };
        /**
         * Prevent selection events from affecting the current editor state. This
         * is mostly intended to defend against IE, which fires off `selectionchange`
         * events regardless of whether the selection is set via the browser or
         * programmatically. We only care about selection events that occur because
         * of browser interaction, not re-renders and forced selections.
         */


        DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
          this._blockSelectEvents = true;
          this._latestEditorState = nextProps.editorState;
        };

        DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
          this._blockSelectEvents = false;
          this._latestCommittedEditorState = this.props.editorState;
        };
        /**
         * Used via `this.focus()`.
         *
         * Force focus back onto the editor node.
         *
         * We attempt to preserve scroll position when focusing. You can also pass
         * a specified scroll position (for cases like `cut` behavior where it should
         * be restored to a known position).
         */

        /**
         * Used via `this.setMode(...)`.
         *
         * Set the behavior mode for the editor component. This switches the current
         * handler module to ensure that DOM events are managed appropriately for
         * the active mode.
         */

        /**
         * Used via `this.restoreEditorDOM()`.
         *
         * Force a complete re-render of the DraftEditorContents based on the current
         * EditorState. This is useful when we know we are going to lose control of
         * the DOM state (cut command, IME) and we want to make sure that
         * reconciliation occurs on a version of the DOM that is synchronized with
         * our EditorState.
         */

        /**
         * Used via `this.setClipboard(...)`.
         *
         * Set the clipboard state for a cut/copy event.
         */

        /**
         * Used via `this.getClipboard()`.
         *
         * Retrieve the clipboard state for a cut/copy event.
         */

        /**
         * Used via `this.update(...)`.
         *
         * Propagate a new `EditorState` object to higher-level components. This is
         * the method by which event handlers inform the `DraftEditor` component of
         * state changes. A component that composes a `DraftEditor` **must** provide
         * an `onChange` prop to receive state updates passed along from this
         * function.
         */

        /**
         * Used in conjunction with `onDragLeave()`, by counting the number of times
         * a dragged element enters and leaves the editor (or any of its children),
         * to determine when the dragged element absolutely leaves the editor.
         */

        /**
         * See `onDragEnter()`.
         */


        return DraftEditor;
      }(React.Component);

      DraftEditor.defaultProps = {
        blockRenderMap: DefaultDraftBlockRenderMap,
        blockRendererFn: emptyFunction.thatReturnsNull,
        blockStyleFn: emptyFunction.thatReturns(''),
        keyBindingFn: getDefaultKeyBinding,
        readOnly: false,
        spellCheck: false,
        stripPastedStyles: false
      };
      module.exports = DraftEditor;
      /***/
    },
    /* 1019 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule CompositeDraftDecorator
       * @format
       * 
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Immutable = __webpack_require__(53);

      var List = Immutable.List;
      var DELIMITER = '.';
      /**
       * A CompositeDraftDecorator traverses through a list of DraftDecorator
       * instances to identify sections of a ContentBlock that should be rendered
       * in a "decorated" manner. For example, hashtags, mentions, and links may
       * be intended to stand out visually, be rendered as anchors, etc.
       *
       * The list of decorators supplied to the constructor will be used in the
       * order they are provided. This allows the caller to specify a priority for
       * string matching, in case of match collisions among decorators.
       *
       * For instance, I may have a link with a `#` in its text. Though this section
       * of text may match our hashtag decorator, it should not be treated as a
       * hashtag. I should therefore list my link DraftDecorator
       * before my hashtag DraftDecorator when constructing this composite
       * decorator instance.
       *
       * Thus, when a collision like this is encountered, the earlier match is
       * preserved and the new match is discarded.
       */

      var CompositeDraftDecorator = function () {
        function CompositeDraftDecorator(decorators) {
          _classCallCheck(this, CompositeDraftDecorator); // Copy the decorator array, since we use this array order to determine
          // precedence of decoration matching. If the array is mutated externally,
          // we don't want to be affected here.


          this._decorators = decorators.slice();
        }

        CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
          var decorations = Array(block.getText().length).fill(null);

          this._decorators.forEach(function (
          /*object*/
          decorator,
          /*number*/
          ii) {
            var counter = 0;
            var strategy = decorator.strategy;

            var callback = function callback(
            /*number*/
            start,
            /*number*/
            end) {
              // Find out if any of our matching range is already occupied
              // by another decorator. If so, discard the match. Otherwise, store
              // the component key for rendering.
              if (canOccupySlice(decorations, start, end)) {
                occupySlice(decorations, start, end, ii + DELIMITER + counter);
                counter++;
              }
            };

            strategy(block, callback, contentState);
          });

          return List(decorations);
        };

        CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
          var componentKey = parseInt(key.split(DELIMITER)[0], 10);
          return this._decorators[componentKey].component;
        };

        CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
          var componentKey = parseInt(key.split(DELIMITER)[0], 10);
          return this._decorators[componentKey].props;
        };

        return CompositeDraftDecorator;
      }();
      /**
       * Determine whether we can occupy the specified slice of the decorations
       * array.
       */


      function canOccupySlice(decorations, start, end) {
        for (var ii = start; ii < end; ii++) {
          if (decorations[ii] != null) {
            return false;
          }
        }

        return true;
      }
      /**
       * Splice the specified component into our decoration array at the desired
       * range.
       */


      function occupySlice(targetArr, start, end, componentKey) {
        for (var ii = start; ii < end; ii++) {
          targetArr[ii] = componentKey;
        }
      }

      module.exports = CompositeDraftDecorator;
      /***/
    },
    /* 1020 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule moveBlockInContentState
       * @format
       * 
       */

      var ContentBlockNode = __webpack_require__(102);

      var Immutable = __webpack_require__(53);

      var getNextDelimiterBlockKey = __webpack_require__(481);

      var invariant = __webpack_require__(51);

      var OrderedMap = Immutable.OrderedMap,
          List = Immutable.List;

      var transformBlock = function transformBlock(key, blockMap, func) {
        if (!key) {
          return;
        }

        var block = blockMap.get(key);

        if (!block) {
          return;
        }

        blockMap.set(key, func(block));
      };

      var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
        if (!isExperimentalTreeBlock) {
          return blockMap;
        } // possible values of 'insertionMode' are: 'after', 'before'


        var isInsertedAfterTarget = insertionMode === 'after';
        var originalBlockKey = originalBlockToBeMoved.getKey();
        var originalTargetKey = originalTargetBlock.getKey();
        var originalParentKey = originalBlockToBeMoved.getParentKey();
        var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
        var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
        var newParentKey = originalTargetBlock.getParentKey();
        var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
        var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
        return blockMap.withMutations(function (blocks) {
          // update old parent
          transformBlock(originalParentKey, blocks, function (block) {
            var parentChildrenList = block.getChildKeys();
            return block.merge({
              children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
            });
          }); // update old prev

          transformBlock(originalPrevSiblingKey, blocks, function (block) {
            return block.merge({
              nextSibling: originalNextSiblingKey
            });
          }); // update old next

          transformBlock(originalNextSiblingKey, blocks, function (block) {
            return block.merge({
              prevSibling: originalPrevSiblingKey
            });
          }); // update new next

          transformBlock(newNextSiblingKey, blocks, function (block) {
            return block.merge({
              prevSibling: originalBlockKey
            });
          }); // update new prev

          transformBlock(newPrevSiblingKey, blocks, function (block) {
            return block.merge({
              nextSibling: originalBlockKey
            });
          }); // update new parent

          transformBlock(newParentKey, blocks, function (block) {
            var newParentChildrenList = block.getChildKeys();
            var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
            var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
            var newChildrenArray = newParentChildrenList.toArray();
            newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
            return block.merge({
              children: List(newChildrenArray)
            });
          }); // update block

          transformBlock(originalBlockKey, blocks, function (block) {
            return block.merge({
              nextSibling: newNextSiblingKey,
              prevSibling: newPrevSiblingKey,
              parent: newParentKey
            });
          });
        });
      };

      var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
        !(insertionMode !== 'replace') ? false ? undefined : invariant(false) : void 0;
        var targetKey = targetBlock.getKey();
        var blockKey = blockToBeMoved.getKey();
        !(blockKey !== targetKey) ? false ? undefined : invariant(false) : void 0;
        var blockMap = contentState.getBlockMap();
        var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;
        var blocksToBeMoved = [blockToBeMoved];
        var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);

        if (isExperimentalTreeBlock) {
          blocksToBeMoved = [];
          blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
            var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
            var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
            blocks.toSeq().skipUntil(function (block) {
              return block.getKey() === blockKey;
            }).takeWhile(function (block) {
              var key = block.getKey();
              var isBlockToBeMoved = key === blockKey;
              var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
              var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
              return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
            }).forEach(function (block) {
              blocksToBeMoved.push(block);
              blocks['delete'](block.getKey());
            });
          });
        }

        var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
          return v === targetBlock;
        });
        var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
          return v === targetBlock;
        }).skip(1);
        var slicedBlocks = blocksToBeMoved.map(function (block) {
          return [block.getKey(), block];
        });
        var newBlocks = OrderedMap();

        if (insertionMode === 'before') {
          var blockBefore = contentState.getBlockBefore(targetKey);
          !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ? false ? undefined : invariant(false) : void 0;
          newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
        } else if (insertionMode === 'after') {
          var blockAfter = contentState.getBlockAfter(targetKey);
          !(!blockAfter || blockAfter.getKey() !== blockKey) ? false ? undefined : invariant(false) : void 0;
          newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
        }

        return contentState.merge({
          blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
          selectionBefore: contentState.getSelectionAfter(),
          selectionAfter: contentState.getSelectionAfter().merge({
            anchorKey: blockKey,
            focusKey: blockKey
          })
        });
      };

      module.exports = moveBlockInContentState;
      /***/
    },
    /* 1021 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       * @typechecks
       * 
       */

      /**
       * Stateful API for text direction detection
       *
       * This class can be used in applications where you need to detect the
       * direction of a sequence of text blocks, where each direction shall be used
       * as the fallback direction for the next one.
       *
       * NOTE: A default direction, if not provided, is set based on the global
       *       direction, as defined by `UnicodeBidiDirection`.
       *
       * == Example ==
       * ```
       * var UnicodeBidiService = require('UnicodeBidiService');
       *
       * var bidiService = new UnicodeBidiService();
       *
       * ...
       *
       * bidiService.reset();
       * for (var para in paragraphs) {
       *   var dir = bidiService.getDirection(para);
       *   ...
       * }
       * ```
       *
       * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
       * Unicode Standard Annex #9 (UAX9)
       * http://www.unicode.org/reports/tr9/
       */

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var UnicodeBidi = __webpack_require__(478);

      var UnicodeBidiDirection = __webpack_require__(342);

      var invariant = __webpack_require__(51);

      var UnicodeBidiService = function () {
        /**
         * Stateful class for paragraph direction detection
         *
         * @param defaultDir  Default direction of the service
         */
        function UnicodeBidiService(defaultDir) {
          _classCallCheck(this, UnicodeBidiService);

          if (!defaultDir) {
            defaultDir = UnicodeBidiDirection.getGlobalDir();
          } else {
            !UnicodeBidiDirection.isStrong(defaultDir) ? false ? undefined : invariant(false) : void 0;
          }

          this._defaultDir = defaultDir;
          this.reset();
        }
        /**
         * Reset the internal state
         *
         * Instead of creating a new instance, you can just reset() your instance
         * everytime you start a new loop.
         */


        UnicodeBidiService.prototype.reset = function reset() {
          this._lastDir = this._defaultDir;
        };
        /**
         * Returns the direction of a block of text, and remembers it as the
         * fall-back direction for the next paragraph.
         *
         * @param str  A text block, e.g. paragraph, table cell, tag
         * @return     The resolved direction
         */


        UnicodeBidiService.prototype.getDirection = function getDirection(str) {
          this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
          return this._lastDir;
        };

        return UnicodeBidiService;
      }();

      module.exports = UnicodeBidiService;
      /***/
    },
    /* 1022 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule EditorBidiService
       * @format
       * 
       */

      var Immutable = __webpack_require__(53);

      var UnicodeBidiService = __webpack_require__(1021);

      var nullthrows = __webpack_require__(108);

      var OrderedMap = Immutable.OrderedMap;
      var bidiService;
      var EditorBidiService = {
        getDirectionMap: function getDirectionMap(content, prevBidiMap) {
          if (!bidiService) {
            bidiService = new UnicodeBidiService();
          } else {
            bidiService.reset();
          }

          var blockMap = content.getBlockMap();
          var nextBidi = blockMap.valueSeq().map(function (block) {
            return nullthrows(bidiService).getDirection(block.getText());
          });
          var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));

          if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
            return prevBidiMap;
          }

          return bidiMap;
        }
      };
      module.exports = EditorBidiService;
      /***/
    },
    /* 1023 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule splitBlockInContentState
       * @format
       * 
       */

      var ContentBlockNode = __webpack_require__(102);

      var Immutable = __webpack_require__(53);

      var generateRandomKey = __webpack_require__(127);

      var invariant = __webpack_require__(51);

      var List = Immutable.List,
          Map = Immutable.Map;

      var transformBlock = function transformBlock(key, blockMap, func) {
        if (!key) {
          return;
        }

        var block = blockMap.get(key);

        if (!block) {
          return;
        }

        blockMap.set(key, func(block));
      };

      var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
        return blockMap.withMutations(function (blocks) {
          var originalBlockKey = originalBlock.getKey();
          var belowBlockKey = belowBlock.getKey(); // update block parent

          transformBlock(originalBlock.getParentKey(), blocks, function (block) {
            var parentChildrenList = block.getChildKeys();
            var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
            var newChildrenArray = parentChildrenList.toArray();
            newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
            return block.merge({
              children: List(newChildrenArray)
            });
          }); // update original next block

          transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
            return block.merge({
              prevSibling: belowBlockKey
            });
          }); // update original block

          transformBlock(originalBlockKey, blocks, function (block) {
            return block.merge({
              nextSibling: belowBlockKey
            });
          }); // update below block

          transformBlock(belowBlockKey, blocks, function (block) {
            return block.merge({
              prevSibling: originalBlockKey
            });
          });
        });
      };

      var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
        !selectionState.isCollapsed() ? false ? undefined : invariant(false) : void 0;
        var key = selectionState.getAnchorKey();
        var offset = selectionState.getAnchorOffset();
        var blockMap = contentState.getBlockMap();
        var blockToSplit = blockMap.get(key);
        var text = blockToSplit.getText();
        var chars = blockToSplit.getCharacterList();
        var keyBelow = generateRandomKey();
        var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;
        var blockAbove = blockToSplit.merge({
          text: text.slice(0, offset),
          characterList: chars.slice(0, offset)
        });
        var blockBelow = blockAbove.merge({
          key: keyBelow,
          text: text.slice(offset),
          characterList: chars.slice(offset),
          data: Map()
        });
        var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
          return v === blockToSplit;
        });
        var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
          return v === blockToSplit;
        }).rest();
        var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

        if (isExperimentalTreeBlock) {
          !blockToSplit.getChildKeys().isEmpty() ? false ? undefined : invariant(false) : void 0;
          newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
        }

        return contentState.merge({
          blockMap: newBlocks,
          selectionBefore: selectionState,
          selectionAfter: selectionState.merge({
            anchorKey: keyBelow,
            anchorOffset: 0,
            focusKey: keyBelow,
            focusOffset: 0,
            isBackward: false
          })
        });
      };

      module.exports = splitBlockInContentState;
      /***/
    },
    /* 1024 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule removeRangeFromContentState
       * @format
       * 
       */

      var ContentBlockNode = __webpack_require__(102);

      var Immutable = __webpack_require__(53);

      var getNextDelimiterBlockKey = __webpack_require__(481);

      var List = Immutable.List,
          Map = Immutable.Map;

      var transformBlock = function transformBlock(key, blockMap, func) {
        if (!key) {
          return;
        }

        var block = blockMap.get(key);

        if (!block) {
          return;
        }

        blockMap.set(key, func(block));
      };
      /**
       * Ancestors needs to be preserved when there are non selected
       * children to make sure we do not leave any orphans behind
       */


      var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
        var parents = [];

        if (!blockKey) {
          return parents;
        }

        var blockNode = blockMap.get(blockKey);

        while (blockNode && blockNode.getParentKey()) {
          var parentKey = blockNode.getParentKey();

          if (parentKey) {
            parents.push(parentKey);
          }

          blockNode = parentKey ? blockMap.get(parentKey) : null;
        }

        return parents;
      };
      /**
       * Get all next delimiter keys until we hit a root delimiter and return
       * an array of key references
       */


      var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
        var nextDelimiters = [];

        if (!block) {
          return nextDelimiters;
        }

        var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);

        while (nextDelimiter && blockMap.get(nextDelimiter)) {
          var _block = blockMap.get(nextDelimiter);

          nextDelimiters.push(nextDelimiter); // we do not need to keep checking all root node siblings, just the first occurance

          nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
        }

        return nextDelimiters;
      };

      var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
        if (!block) {
          return null;
        } // note that we need to make sure we refer to the original block since this
        // function is called within a withMutations


        var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

        while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
          nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
        }

        return nextValidSiblingKey;
      };

      var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
        if (!block) {
          return null;
        } // note that we need to make sure we refer to the original block since this
        // function is called within a withMutations


        var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

        while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
          prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
        }

        return prevValidSiblingKey;
      };

      var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
        return blockMap.withMutations(function (blocks) {
          // update start block if its retained
          transformBlock(startBlock.getKey(), blocks, function (block) {
            return block.merge({
              nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
              prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
            });
          }); // update endblock if its retained

          transformBlock(endBlock.getKey(), blocks, function (block) {
            return block.merge({
              nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
              prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
            });
          }); // update start block parent ancestors

          getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
            return transformBlock(parentKey, blocks, function (block) {
              return block.merge({
                children: block.getChildKeys().filter(function (key) {
                  return blocks.get(key);
                }),
                nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
                prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
              });
            });
          }); // update start block next - can only happen if startBlock == endBlock

          transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
            return block.merge({
              prevSibling: startBlock.getPrevSiblingKey()
            });
          }); // update start block prev

          transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
            return block.merge({
              nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
            });
          }); // update end block next

          transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
            return block.merge({
              prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
            });
          }); // update end block prev

          transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
            return block.merge({
              nextSibling: endBlock.getNextSiblingKey()
            });
          }); // update end block parent ancestors

          getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
            transformBlock(parentKey, blocks, function (block) {
              return block.merge({
                children: block.getChildKeys().filter(function (key) {
                  return blocks.get(key);
                }),
                nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
                prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
              });
            });
          }); // update next delimiters all the way to a root delimiter

          getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
            return transformBlock(delimiterKey, blocks, function (block) {
              return block.merge({
                nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
                prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
              });
            });
          });
        });
      };

      var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
        if (selectionState.isCollapsed()) {
          return contentState;
        }

        var blockMap = contentState.getBlockMap();
        var startKey = selectionState.getStartKey();
        var startOffset = selectionState.getStartOffset();
        var endKey = selectionState.getEndKey();
        var endOffset = selectionState.getEndOffset();
        var startBlock = blockMap.get(startKey);
        var endBlock = blockMap.get(endKey); // we assume that ContentBlockNode and ContentBlocks are not mixed together

        var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode; // used to retain blocks that should not be deleted to avoid orphan children

        var parentAncestors = [];

        if (isExperimentalTreeBlock) {
          var endBlockchildrenKeys = endBlock.getChildKeys();
          var endBlockAncestors = getAncestorsKeys(endKey, blockMap); // endBlock has unselected sibblings so we can not remove its ancestors parents

          if (endBlock.getNextSiblingKey()) {
            parentAncestors = parentAncestors.concat(endBlockAncestors);
          } // endBlock has children so can not remove this block or any of its ancestors


          if (!endBlockchildrenKeys.isEmpty()) {
            parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
          } // we need to retain all ancestors of the next delimiter block


          parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
        }

        var characterList = void 0;

        if (startBlock === endBlock) {
          characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
        } else {
          characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
        }

        var modifiedStart = startBlock.merge({
          text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
          characterList: characterList
        });
        var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
          return k === startKey;
        }).takeUntil(function (_, k) {
          return k === endKey;
        }).filter(function (_, k) {
          return parentAncestors.indexOf(k) === -1;
        }).concat(Map([[endKey, null]])).map(function (_, k) {
          return k === startKey ? modifiedStart : null;
        });
        var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
          return !!block;
        });

        if (isExperimentalTreeBlock) {
          updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
        }

        return contentState.merge({
          blockMap: updatedBlockMap,
          selectionBefore: selectionState,
          selectionAfter: selectionState.merge({
            anchorKey: startKey,
            anchorOffset: startOffset,
            focusKey: startKey,
            focusOffset: startOffset,
            isBackward: false
          })
        });
      };
      /**
       * Maintain persistence for target list when removing characters on the
       * head and tail of the character list.
       */


      var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
        if (startOffset === 0) {
          while (startOffset < endOffset) {
            targetList = targetList.shift();
            startOffset++;
          }
        } else if (endOffset === targetList.count()) {
          while (endOffset > startOffset) {
            targetList = targetList.pop();
            endOffset--;
          }
        } else {
          var head = targetList.slice(0, startOffset);
          var tail = targetList.slice(endOffset);
          targetList = head.concat(tail).toList();
        }

        return targetList;
      };

      module.exports = removeRangeFromContentState;
      /***/
    },
    /* 1025 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule modifyBlockForContentState
       * @format
       * 
       */

      var Immutable = __webpack_require__(53);

      var Map = Immutable.Map;

      function modifyBlockForContentState(contentState, selectionState, operation) {
        var startKey = selectionState.getStartKey();
        var endKey = selectionState.getEndKey();
        var blockMap = contentState.getBlockMap();
        var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
          return k === startKey;
        }).takeUntil(function (_, k) {
          return k === endKey;
        }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
        return contentState.merge({
          blockMap: blockMap.merge(newBlocks),
          selectionBefore: selectionState,
          selectionAfter: selectionState
        });
      }

      module.exports = modifyBlockForContentState;
      /***/
    },
    /* 1026 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule insertTextIntoContentState
       * @format
       * 
       */

      var Immutable = __webpack_require__(53);

      var insertIntoList = __webpack_require__(482);

      var invariant = __webpack_require__(51);

      var Repeat = Immutable.Repeat;

      function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
        !selectionState.isCollapsed() ? false ? undefined : invariant(false) : void 0;
        var len = text.length;

        if (!len) {
          return contentState;
        }

        var blockMap = contentState.getBlockMap();
        var key = selectionState.getStartKey();
        var offset = selectionState.getStartOffset();
        var block = blockMap.get(key);
        var blockText = block.getText();
        var newBlock = block.merge({
          text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
          characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
        });
        var newOffset = offset + len;
        return contentState.merge({
          blockMap: blockMap.set(key, newBlock),
          selectionAfter: selectionState.merge({
            anchorOffset: newOffset,
            focusOffset: newOffset
          })
        });
      }

      module.exports = insertTextIntoContentState;
      /***/
    },
    /* 1027 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule insertFragmentIntoContentState
       * @format
       * 
       */

      var BlockMapBuilder = __webpack_require__(206);

      var ContentBlockNode = __webpack_require__(102);

      var Immutable = __webpack_require__(53);

      var insertIntoList = __webpack_require__(482);

      var invariant = __webpack_require__(51);

      var randomizeBlockMapKeys = __webpack_require__(484);

      var List = Immutable.List;

      var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
        var targetBlock = blockMap.get(targetKey);
        var text = targetBlock.getText();
        var chars = targetBlock.getCharacterList();
        var finalKey = targetKey;
        var finalOffset = targetOffset + fragmentBlock.getText().length;
        var newBlock = targetBlock.merge({
          text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
          characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
          data: fragmentBlock.getData()
        });
        return contentState.merge({
          blockMap: blockMap.set(targetKey, newBlock),
          selectionBefore: selectionState,
          selectionAfter: selectionState.merge({
            anchorKey: finalKey,
            anchorOffset: finalOffset,
            focusKey: finalKey,
            focusOffset: finalOffset,
            isBackward: false
          })
        });
      };
      /**
       * Appends text/characterList from the fragment first block to
       * target block.
       */


      var updateHead = function updateHead(block, targetOffset, fragment) {
        var text = block.getText();
        var chars = block.getCharacterList(); // Modify head portion of block.

        var headText = text.slice(0, targetOffset);
        var headCharacters = chars.slice(0, targetOffset);
        var appendToHead = fragment.first();
        return block.merge({
          text: headText + appendToHead.getText(),
          characterList: headCharacters.concat(appendToHead.getCharacterList()),
          type: headText ? block.getType() : appendToHead.getType(),
          data: appendToHead.getData()
        });
      };
      /**
       * Appends offset text/characterList from the target block to the last
       * fragment block.
       */


      var updateTail = function updateTail(block, targetOffset, fragment) {
        // Modify tail portion of block.
        var text = block.getText();
        var chars = block.getCharacterList(); // Modify head portion of block.

        var blockSize = text.length;
        var tailText = text.slice(targetOffset, blockSize);
        var tailCharacters = chars.slice(targetOffset, blockSize);
        var prependToTail = fragment.last();
        return prependToTail.merge({
          text: prependToTail.getText() + tailText,
          characterList: prependToTail.getCharacterList().concat(tailCharacters),
          data: prependToTail.getData()
        });
      };

      var getRootBlocks = function getRootBlocks(block, blockMap) {
        var headKey = block.getKey();
        var rootBlock = block;
        var rootBlocks = []; // sometimes the fragment head block will not be part of the blockMap itself this can happen when
        // the fragment head is used to update the target block, however when this does not happen we need
        // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
        // fragment root block

        if (blockMap.get(headKey)) {
          rootBlocks.push(headKey);
        }

        while (rootBlock && rootBlock.getNextSiblingKey()) {
          var lastSiblingKey = rootBlock.getNextSiblingKey();

          if (!lastSiblingKey) {
            break;
          }

          rootBlocks.push(lastSiblingKey);
          rootBlock = blockMap.get(lastSiblingKey);
        }

        return rootBlocks;
      };

      var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
        return blockMap.withMutations(function (blockMapState) {
          var targetKey = targetBlock.getKey();
          var headKey = fragmentHeadBlock.getKey();
          var targetNextKey = targetBlock.getNextSiblingKey();
          var targetParentKey = targetBlock.getParentKey();
          var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
          var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

          if (blockMapState.get(headKey)) {
            // update the fragment head when it is part of the blockMap otherwise
            blockMapState.setIn([targetKey, 'nextSibling'], headKey);
            blockMapState.setIn([headKey, 'prevSibling'], targetKey);
          } else {
            // update the target block that had the fragment head contents merged into it
            blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
            blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
          } // update the last root block fragment


          blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey); // update the original target next block

          if (targetNextKey) {
            blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
          } // update fragment parent links


          fragmentRootBlocks.forEach(function (blockKey) {
            return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
          }); // update targetBlock parent child links

          if (targetParentKey) {
            var targetParent = blockMap.get(targetParentKey);
            var originalTargetParentChildKeys = targetParent.getChildKeys();
            var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
            var insertionIndex = targetBlockIndex + 1;
            var newChildrenKeysArray = originalTargetParentChildKeys.toArray(); // insert fragment children

            newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
            blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
          }
        });
      };

      var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
        var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
        var newBlockArr = [];
        var fragmentSize = fragment.size;
        var target = blockMap.get(targetKey);
        var head = fragment.first();
        var tail = fragment.last();
        var finalOffset = tail.getLength();
        var finalKey = tail.getKey();
        var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
        blockMap.forEach(function (block, blockKey) {
          if (blockKey !== targetKey) {
            newBlockArr.push(block);
            return;
          }

          if (shouldNotUpdateFromFragmentBlock) {
            newBlockArr.push(block);
          } else {
            newBlockArr.push(updateHead(block, targetOffset, fragment));
          } // Insert fragment blocks after the head and before the tail.


          fragment // when we are updating the target block with the head fragment block we skip the first fragment
          // head since its contents have already been merged with the target block otherwise we include
          // the whole fragment
          .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
            return newBlockArr.push(fragmentBlock);
          }); // update tail

          newBlockArr.push(updateTail(block, targetOffset, fragment));
        });
        var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);

        if (isTreeBasedBlockMap) {
          updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
        }

        return contentState.merge({
          blockMap: updatedBlockMap,
          selectionBefore: selectionState,
          selectionAfter: selectionState.merge({
            anchorKey: finalKey,
            anchorOffset: finalOffset,
            focusKey: finalKey,
            focusOffset: finalOffset,
            isBackward: false
          })
        });
      };

      var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
        !selectionState.isCollapsed() ? false ? undefined : invariant(false) : void 0;
        var blockMap = contentState.getBlockMap();
        var fragment = randomizeBlockMapKeys(fragmentBlockMap);
        var targetKey = selectionState.getStartKey();
        var targetOffset = selectionState.getStartOffset();
        var targetBlock = blockMap.get(targetKey);

        if (targetBlock instanceof ContentBlockNode) {
          !targetBlock.getChildKeys().isEmpty() ? false ? undefined : invariant(false) : void 0;
        } // When we insert a fragment with a single block we simply update the target block
        // with the contents of the inserted fragment block


        if (fragment.size === 1) {
          return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
        }

        return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
      };

      module.exports = insertFragmentIntoContentState;
      /***/
    },
    /* 1028 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getRangesForDraftEntity
       * @format
       * 
       */

      var invariant = __webpack_require__(51);
      /**
       * Obtain the start and end positions of the range that has the
       * specified entity applied to it.
       *
       * Entity keys are applied only to contiguous stretches of text, so this
       * method searches for the first instance of the entity key and returns
       * the subsequent range.
       */


      function getRangesForDraftEntity(block, key) {
        var ranges = [];
        block.findEntityRanges(function (c) {
          return c.getEntity() === key;
        }, function (start, end) {
          ranges.push({
            start: start,
            end: end
          });
        });
        !!!ranges.length ? false ? undefined : invariant(false) : void 0;
        return ranges;
      }

      module.exports = getRangesForDraftEntity;
      /***/
    },
    /* 1029 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftEntitySegments
       * @format
       * 
       */

      /**
       * Identify the range to delete from a segmented entity.
       *
       * Rules:
       *
       *  Example: 'John F. Kennedy'
       *
       *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
       *     will return the range of that text.
       *
       *       'John F. Kennedy' -> 'John F.'
       *                  ^
       *
       *   - Forward deletion of whitespace will remove the following section:
       *
       *       'John F. Kennedy' -> 'John Kennedy'
       *            ^
       *
       *   - Backward deletion of whitespace will remove the previous section:
       *
       *       'John F. Kennedy' -> 'F. Kennedy'
       *            ^
       */

      var DraftEntitySegments = {
        getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
          var segments = text.split(' ');
          segments = segments.map(function (
          /*string*/
          segment,
          /*number*/
          ii) {
            if (direction === 'forward') {
              if (ii > 0) {
                return ' ' + segment;
              }
            } else if (ii < segments.length - 1) {
              return segment + ' ';
            }

            return segment;
          });
          var segmentStart = entityStart;
          var segmentEnd;
          var segment;
          var removalStart = null;
          var removalEnd = null;

          for (var jj = 0; jj < segments.length; jj++) {
            segment = segments[jj];
            segmentEnd = segmentStart + segment.length; // Our selection overlaps this segment.

            if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
              if (removalStart !== null) {
                removalEnd = segmentEnd;
              } else {
                removalStart = segmentStart;
                removalEnd = segmentEnd;
              }
            } else if (removalStart !== null) {
              break;
            }

            segmentStart = segmentEnd;
          }

          var entityEnd = entityStart + text.length;
          var atStart = removalStart === entityStart;
          var atEnd = removalEnd === entityEnd;

          if (!atStart && atEnd || atStart && !atEnd) {
            if (direction === 'forward') {
              if (removalEnd !== entityEnd) {
                removalEnd++;
              }
            } else if (removalStart !== entityStart) {
              removalStart--;
            }
          }

          return {
            start: removalStart,
            end: removalEnd
          };
        }
      };
      module.exports = DraftEntitySegments;
      /***/
    },
    /* 1030 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule getCharacterRemovalRange
       * @format
       * 
       */

      var DraftEntitySegments = __webpack_require__(1029);

      var getRangesForDraftEntity = __webpack_require__(1028);

      var invariant = __webpack_require__(51);
      /**
       * Given a SelectionState and a removal direction, determine the entire range
       * that should be removed from a ContentState. This is based on any entities
       * within the target, with their `mutability` values taken into account.
       *
       * For instance, if we are attempting to remove part of an "immutable" entity
       * range, the entire entity must be removed. The returned `SelectionState`
       * will be adjusted accordingly.
       */


      function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
        var start = selectionState.getStartOffset();
        var end = selectionState.getEndOffset();
        var startEntityKey = startBlock.getEntityAt(start);
        var endEntityKey = endBlock.getEntityAt(end - 1);

        if (!startEntityKey && !endEntityKey) {
          return selectionState;
        }

        var newSelectionState = selectionState;

        if (startEntityKey && startEntityKey === endEntityKey) {
          newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
        } else if (startEntityKey && endEntityKey) {
          var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
          var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
          newSelectionState = newSelectionState.merge({
            anchorOffset: startSelectionState.getAnchorOffset(),
            focusOffset: endSelectionState.getFocusOffset(),
            isBackward: false
          });
        } else if (startEntityKey) {
          var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);

          newSelectionState = newSelectionState.merge({
            anchorOffset: _startSelectionState.getStartOffset(),
            isBackward: false
          });
        } else if (endEntityKey) {
          var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);

          newSelectionState = newSelectionState.merge({
            focusOffset: _endSelectionState.getEndOffset(),
            isBackward: false
          });
        }

        return newSelectionState;
      }

      function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
        var start = selectionState.getStartOffset();
        var end = selectionState.getEndOffset();

        var entity = entityMap.__get(entityKey);

        var mutability = entity.getMutability();
        var sideToConsider = isEntityAtStart ? start : end; // `MUTABLE` entities can just have the specified range of text removed
        // directly. No adjustments are needed.

        if (mutability === 'MUTABLE') {
          return selectionState;
        } // Find the entity range that overlaps with our removal range.


        var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
          return sideToConsider <= range.end && sideToConsider >= range.start;
        });
        !(entityRanges.length == 1) ? false ? undefined : invariant(false) : void 0;
        var entityRange = entityRanges[0]; // For `IMMUTABLE` entity types, we will remove the entire entity range.

        if (mutability === 'IMMUTABLE') {
          return selectionState.merge({
            anchorOffset: entityRange.start,
            focusOffset: entityRange.end,
            isBackward: false
          });
        } // For `SEGMENTED` entity types, determine the appropriate segment to
        // remove.


        if (!isEntireSelectionWithinEntity) {
          if (isEntityAtStart) {
            end = entityRange.end;
          } else {
            start = entityRange.start;
          }
        }

        var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
        return selectionState.merge({
          anchorOffset: removalRange.start,
          focusOffset: removalRange.end,
          isBackward: false
        });
      }

      module.exports = getCharacterRemovalRange;
      /***/
    },
    /* 1031 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule applyEntityToContentBlock
       * @format
       * 
       */

      var CharacterMetadata = __webpack_require__(96);

      function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
        var characterList = contentBlock.getCharacterList();

        while (start < end) {
          characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
          start++;
        }

        return contentBlock.set('characterList', characterList);
      }

      module.exports = applyEntityToContentBlock;
      /***/
    },
    /* 1032 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule applyEntityToContentState
       * @format
       * 
       */

      var Immutable = __webpack_require__(53);

      var applyEntityToContentBlock = __webpack_require__(1031);

      function applyEntityToContentState(contentState, selectionState, entityKey) {
        var blockMap = contentState.getBlockMap();
        var startKey = selectionState.getStartKey();
        var startOffset = selectionState.getStartOffset();
        var endKey = selectionState.getEndKey();
        var endOffset = selectionState.getEndOffset();
        var newBlocks = blockMap.skipUntil(function (_, k) {
          return k === startKey;
        }).takeUntil(function (_, k) {
          return k === endKey;
        }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
          var sliceStart = blockKey === startKey ? startOffset : 0;
          var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
          return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
        });
        return contentState.merge({
          blockMap: blockMap.merge(newBlocks),
          selectionBefore: selectionState,
          selectionAfter: selectionState
        });
      }

      module.exports = applyEntityToContentState;
      /***/
    },
    /* 1033 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule ContentStateInlineStyle
       * @format
       * 
       */

      var CharacterMetadata = __webpack_require__(96);

      var _require = __webpack_require__(53),
          Map = _require.Map;

      var ContentStateInlineStyle = {
        add: function add(contentState, selectionState, inlineStyle) {
          return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
        },
        remove: function remove(contentState, selectionState, inlineStyle) {
          return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
        }
      };

      function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
        var blockMap = contentState.getBlockMap();
        var startKey = selectionState.getStartKey();
        var startOffset = selectionState.getStartOffset();
        var endKey = selectionState.getEndKey();
        var endOffset = selectionState.getEndOffset();
        var newBlocks = blockMap.skipUntil(function (_, k) {
          return k === startKey;
        }).takeUntil(function (_, k) {
          return k === endKey;
        }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
          var sliceStart;
          var sliceEnd;

          if (startKey === endKey) {
            sliceStart = startOffset;
            sliceEnd = endOffset;
          } else {
            sliceStart = blockKey === startKey ? startOffset : 0;
            sliceEnd = blockKey === endKey ? endOffset : block.getLength();
          }

          var chars = block.getCharacterList();
          var current;

          while (sliceStart < sliceEnd) {
            current = chars.get(sliceStart);
            chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
            sliceStart++;
          }

          return block.set('characterList', chars);
        });
        return contentState.merge({
          blockMap: blockMap.merge(newBlocks),
          selectionBefore: selectionState,
          selectionAfter: selectionState
        });
      }

      module.exports = ContentStateInlineStyle;
      /***/
    },
    /* 1034 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule DraftFeatureFlags-core
       * @format
       * 
       */

      var DraftFeatureFlags = {
        draft_killswitch_allow_nontextnodes: false,
        draft_segmented_entities_behavior: false,
        draft_handlebeforeinput_composed_text: false,
        draft_tree_data_support: false
      };
      module.exports = DraftFeatureFlags;
      /***/
    },
    /* 1035 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * LICENSE file in the root directory of this source tree. An additional grant
       * of patent rights can be found in the PATENTS file in the same directory.
       *
       * @providesModule AtomicBlockUtils
       * @format
       * 
       */

      var _assign = __webpack_require__(82);

      var _extends = _assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var BlockMapBuilder = __webpack_require__(206);

      var CharacterMetadata = __webpack_require__(96);

      var ContentBlock = __webpack_require__(155);

      var ContentBlockNode = __webpack_require__(102);

      var DraftFeatureFlags = __webpack_require__(133);

      var DraftModifier = __webpack_require__(93);

      var EditorState = __webpack_require__(60);

      var Immutable = __webpack_require__(53);

      var SelectionState = __webpack_require__(174);

      var generateRandomKey = __webpack_require__(127);

      var moveBlockInContentState = __webpack_require__(1020);

      var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
      var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
      var List = Immutable.List,
          Repeat = Immutable.Repeat;
      var AtomicBlockUtils = {
        insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
          var contentState = editorState.getCurrentContent();
          var selectionState = editorState.getSelection();
          var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
          var targetSelection = afterRemoval.getSelectionAfter();
          var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
          var insertionTarget = afterSplit.getSelectionAfter();
          var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
          var charData = CharacterMetadata.create({
            entity: entityKey
          });
          var atomicBlockConfig = {
            key: generateRandomKey(),
            type: 'atomic',
            text: character,
            characterList: List(Repeat(charData, character.length))
          };
          var atomicDividerBlockConfig = {
            key: generateRandomKey(),
            type: 'unstyled'
          };

          if (experimentalTreeDataSupport) {
            atomicBlockConfig = _extends({}, atomicBlockConfig, {
              nextSibling: atomicDividerBlockConfig.key
            });
            atomicDividerBlockConfig = _extends({}, atomicDividerBlockConfig, {
              prevSibling: atomicBlockConfig.key
            });
          }

          var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];
          var fragment = BlockMapBuilder.createFromArray(fragmentArray);
          var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
          var newContent = withAtomicBlock.merge({
            selectionBefore: selectionState,
            selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
          });
          return EditorState.push(editorState, newContent, 'insert-fragment');
        },
        moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
          var contentState = editorState.getCurrentContent();
          var selectionState = editorState.getSelection();
          var withMovedAtomicBlock = void 0;

          if (insertionMode === 'before' || insertionMode === 'after') {
            var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
            withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
          } else {
            var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');
            var selectionAfterRemoval = afterRemoval.getSelectionAfter();

            var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

            if (selectionAfterRemoval.getStartOffset() === 0) {
              withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
            } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
              withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
            } else {
              var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);
              var selectionAfterSplit = afterSplit.getSelectionAfter();

              var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

              withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
            }
          }

          var newContent = withMovedAtomicBlock.merge({
            selectionBefore: selectionState,
            selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
          });
          return EditorState.push(editorState, newContent, 'move-block');
        }
      };
      module.exports = AtomicBlockUtils;
      /***/
    },
    /* 1036 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = getElementPosition;
      /*
      * Finds element's position relative to the whole document,
      * rather than to the viewport as it is the case with .getBoundingClientRect().
      */

      function getElementPosition(element) {
        var rect = element.getBoundingClientRect();
        return {
          top: rect.top + window.pageYOffset,
          left: rect.left + window.pageXOffset
        };
      }
      /***/

    },
    /* 1037 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = inViewport;

      var _getElementPosition = __webpack_require__(1036);

      var _getElementPosition2 = _interopRequireDefault(_getElementPosition);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var isHidden = function isHidden(element) {
        return element.offsetParent === null;
      };

      function inViewport(element, container, customOffset) {
        if (isHidden(element)) {
          return false;
        }

        var top = void 0;
        var bottom = void 0;
        var left = void 0;
        var right = void 0;

        if (typeof container === 'undefined' || container === window) {
          top = window.pageYOffset;
          left = window.pageXOffset;
          bottom = top + window.innerHeight;
          right = left + window.innerWidth;
        } else {
          var containerPosition = (0, _getElementPosition2.default)(container);
          top = containerPosition.top;
          left = containerPosition.left;
          bottom = top + container.offsetHeight;
          right = left + container.offsetWidth;
        }

        var elementPosition = (0, _getElementPosition2.default)(element);
        return top <= elementPosition.top + element.offsetHeight + customOffset.top && bottom >= elementPosition.top - customOffset.bottom && left <= elementPosition.left + element.offsetWidth + customOffset.left && right >= elementPosition.left - customOffset.right;
      }
      /***/

    },
    /* 1038 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var style = function style(element, prop) {
        return typeof getComputedStyle !== 'undefined' ? getComputedStyle(element, null).getPropertyValue(prop) : element.style[prop];
      };

      var overflow = function overflow(element) {
        return style(element, 'overflow') + style(element, 'overflow-y') + style(element, 'overflow-x');
      };

      var scrollParent = function scrollParent(element) {
        if (!(element instanceof HTMLElement)) {
          return window;
        }

        var parent = element;

        while (parent) {
          if (parent === document.body || parent === document.documentElement) {
            break;
          }

          if (!parent.parentNode) {
            break;
          }

          if (/(scroll|auto)/.test(overflow(parent))) {
            return parent;
          }

          parent = parent.parentNode;
        }

        return window;
      };

      exports.default = scrollParent;
      /***/
    },
    /* 1039 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global) {
        /**
        * lodash (Custom Build) <https://lodash.com/>
        * Build: `lodash modularize exports="npm" -o ./`
        * Copyright jQuery Foundation and other contributors <https://jquery.org/>
        * Released under MIT license <https://lodash.com/license>
        * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
        * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
        */

        /** Used as the `TypeError` message for "Functions" methods. */
        var FUNC_ERROR_TEXT = 'Expected a function';
        /** Used as references for various `Number` constants. */

        var NAN = 0 / 0;
        /** `Object#toString` result references. */

        var symbolTag = '[object Symbol]';
        /** Used to match leading and trailing whitespace. */

        var reTrim = /^\s+|\s+$/g;
        /** Used to detect bad signed hexadecimal string values. */

        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
        /** Used to detect binary string values. */

        var reIsBinary = /^0b[01]+$/i;
        /** Used to detect octal string values. */

        var reIsOctal = /^0o[0-7]+$/i;
        /** Built-in method references without a dependency on `root`. */

        var freeParseInt = parseInt;
        /** Detect free variable `global` from Node.js. */

        var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
        /** Detect free variable `self`. */

        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        /** Used as a reference to the global object. */

        var root = freeGlobal || freeSelf || Function('return this')();
        /** Used for built-in method references. */

        var objectProto = Object.prototype;
        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */

        var objectToString = objectProto.toString;
        /* Built-in method references for those with the same name as other `lodash` methods. */

        var nativeMax = Math.max,
            nativeMin = Math.min;
        /**
         * Gets the timestamp of the number of milliseconds that have elapsed since
         * the Unix epoch (1 January 1970 00:00:00 UTC).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Date
         * @returns {number} Returns the timestamp.
         * @example
         *
         * _.defer(function(stamp) {
         *   console.log(_.now() - stamp);
         * }, _.now());
         * // => Logs the number of milliseconds it took for the deferred invocation.
         */

        var now = function now() {
          return root.Date.now();
        };
        /**
         * Creates a debounced function that delays invoking `func` until after `wait`
         * milliseconds have elapsed since the last time the debounced function was
         * invoked. The debounced function comes with a `cancel` method to cancel
         * delayed `func` invocations and a `flush` method to immediately invoke them.
         * Provide `options` to indicate whether `func` should be invoked on the
         * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
         * with the last arguments provided to the debounced function. Subsequent
         * calls to the debounced function return the result of the last `func`
         * invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the debounced function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.debounce` and `_.throttle`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to debounce.
         * @param {number} [wait=0] The number of milliseconds to delay.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=false]
         *  Specify invoking on the leading edge of the timeout.
         * @param {number} [options.maxWait]
         *  The maximum time `func` is allowed to be delayed before it's invoked.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new debounced function.
         * @example
         *
         * // Avoid costly calculations while the window size is in flux.
         * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
         *
         * // Invoke `sendMail` when clicked, debouncing subsequent calls.
         * jQuery(element).on('click', _.debounce(sendMail, 300, {
         *   'leading': true,
         *   'trailing': false
         * }));
         *
         * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
         * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
         * var source = new EventSource('/stream');
         * jQuery(source).on('message', debounced);
         *
         * // Cancel the trailing debounced invocation.
         * jQuery(window).on('popstate', debounced.cancel);
         */


        function debounce(func, wait, options) {
          var lastArgs,
              lastThis,
              maxWait,
              result,
              timerId,
              lastCallTime,
              lastInvokeTime = 0,
              leading = false,
              maxing = false,
              trailing = true;

          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          wait = toNumber(wait) || 0;

          if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
          }

          function invokeFunc(time) {
            var args = lastArgs,
                thisArg = lastThis;
            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
          }

          function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time; // Start the timer for the trailing edge.

            timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

            return leading ? invokeFunc(time) : result;
          }

          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime,
                timeSinceLastInvoke = time - lastInvokeTime,
                result = wait - timeSinceLastCall;
            return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
          }

          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime,
                timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.

            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }

          function timerExpired() {
            var time = now();

            if (shouldInvoke(time)) {
              return trailingEdge(time);
            } // Restart the timer.


            timerId = setTimeout(timerExpired, remainingWait(time));
          }

          function trailingEdge(time) {
            timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.

            if (trailing && lastArgs) {
              return invokeFunc(time);
            }

            lastArgs = lastThis = undefined;
            return result;
          }

          function cancel() {
            if (timerId !== undefined) {
              clearTimeout(timerId);
            }

            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
          }

          function flush() {
            return timerId === undefined ? result : trailingEdge(now());
          }

          function debounced() {
            var time = now(),
                isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;

            if (isInvoking) {
              if (timerId === undefined) {
                return leadingEdge(lastCallTime);
              }

              if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }

            if (timerId === undefined) {
              timerId = setTimeout(timerExpired, wait);
            }

            return result;
          }

          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */


        function isObject(value) {
          var type = typeof value;
          return !!value && (type == 'object' || type == 'function');
        }
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */


        function isObjectLike(value) {
          return !!value && typeof value == 'object';
        }
        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */


        function isSymbol(value) {
          return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
        }
        /**
         * Converts `value` to a number.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         * @example
         *
         * _.toNumber(3.2);
         * // => 3.2
         *
         * _.toNumber(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toNumber(Infinity);
         * // => Infinity
         *
         * _.toNumber('3.2');
         * // => 3.2
         */


        function toNumber(value) {
          if (typeof value == 'number') {
            return value;
          }

          if (isSymbol(value)) {
            return NAN;
          }

          if (isObject(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject(other) ? other + '' : other;
          }

          if (typeof value != 'string') {
            return value === 0 ? value : +value;
          }

          value = value.replace(reTrim, '');
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }

        module.exports = debounce;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 1040 */

    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

      (function (root, factory) {
        if (true) {
          !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
      })(this, function () {
        function wrap(standard, fallback) {
          return function (el, evtName, listener, useCapture) {
            if (el[standard]) {
              el[standard](evtName, listener, useCapture);
            } else if (el[fallback]) {
              el[fallback]('on' + evtName, listener);
            }
          };
        }

        return {
          add: wrap('addEventListener', 'attachEvent'),
          remove: wrap('removeEventListener', 'detachEvent')
        };
      });
      /***/

    },
    /* 1041 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Determine if a DOM element matches a CSS selector
       *
       * @param {Element} elem
       * @param {String} selector
       * @return {Boolean}
       * @api public
       */

      function matches(elem, selector) {
        // Vendor-specific implementations of `Element.prototype.matches()`.
        var proto = window.Element.prototype;
        var nativeMatches = proto.matches || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;

        if (!elem || elem.nodeType !== 1) {
          return false;
        }

        var parentElem = elem.parentNode; // use native 'matches'

        if (nativeMatches) {
          return nativeMatches.call(elem, selector);
        } // native support for `matches` is missing and a fallback is required


        var nodes = parentElem.querySelectorAll(selector);
        var len = nodes.length;

        for (var i = 0; i < len; i++) {
          if (nodes[i] === elem) {
            return true;
          }
        }

        return false;
      }
      /**
       * Expose `matches`
       */


      module.exports = matches;
      /***/
    },
    /* 1042 */

    /***/
    function (module, exports) {
      /** Used to detect hot functions by number of calls within a span of milliseconds. */
      var HOT_COUNT = 800,
          HOT_SPAN = 16;
      /* Built-in method references for those with the same name as other `lodash` methods. */

      var nativeNow = Date.now;
      /**
       * Creates a function that'll short out and invoke `identity` instead
       * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
       * milliseconds.
       *
       * @private
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new shortable function.
       */

      function shortOut(func) {
        var count = 0,
            lastCalled = 0;
        return function () {
          var stamp = nativeNow(),
              remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;

          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }

          return func.apply(undefined, arguments);
        };
      }

      module.exports = shortOut;
      /***/
    },
    /* 1043 */

    /***/
    function (module, exports, __webpack_require__) {
      var constant = __webpack_require__(487),
          defineProperty = __webpack_require__(505),
          identity = __webpack_require__(207);
      /**
       * The base implementation of `setToString` without support for hot loop shorting.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */


      var baseSetToString = !defineProperty ? identity : function (func, string) {
        return defineProperty(func, 'toString', {
          'configurable': true,
          'enumerable': false,
          'value': constant(string),
          'writable': true
        });
      };
      module.exports = baseSetToString;
      /***/
    },
    /* 1044 */

    /***/
    function (module, exports) {
      /**
       * A faster alternative to `Function#apply`, this function invokes `func`
       * with the `this` binding of `thisArg` and the arguments of `args`.
       *
       * @private
       * @param {Function} func The function to invoke.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {Array} args The arguments to invoke `func` with.
       * @returns {*} Returns the result of `func`.
       */
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);

          case 1:
            return func.call(thisArg, args[0]);

          case 2:
            return func.call(thisArg, args[0], args[1]);

          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }

        return func.apply(thisArg, args);
      }

      module.exports = apply;
      /***/
    },
    /* 1045 */

    /***/
    function (module, exports) {
      /**
       * This function is like
       * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * except that it includes inherited enumerable properties.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function nativeKeysIn(object) {
        var result = [];

        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }

        return result;
      }

      module.exports = nativeKeysIn;
      /***/
    },
    /* 1046 */

    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(97),
          isPrototype = __webpack_require__(209),
          nativeKeysIn = __webpack_require__(1045);
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */

      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }

        var isProto = isPrototype(object),
            result = [];

        for (var key in object) {
          if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
          }
        }

        return result;
      }

      module.exports = baseKeysIn;
      /***/
    },
    /* 1047 */

    /***/
    function (module, exports, __webpack_require__) {
      var copyObject = __webpack_require__(156),
          keysIn = __webpack_require__(243);
      /**
       * Converts `value` to a plain object flattening inherited enumerable string
       * keyed properties of `value` to own properties of the plain object.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Object} Returns the converted plain object.
       * @example
       *
       * function Foo() {
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.assign({ 'a': 1 }, new Foo);
       * // => { 'a': 1, 'b': 2 }
       *
       * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
       * // => { 'a': 1, 'b': 2, 'c': 3 }
       */


      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }

      module.exports = toPlainObject;
      /***/
    },
    /* 1048 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGetTag = __webpack_require__(135),
          isLength = __webpack_require__(349),
          isObjectLike = __webpack_require__(109);
      /** `Object#toString` result references. */


      var argsTag = '[object Arguments]',
          arrayTag = '[object Array]',
          boolTag = '[object Boolean]',
          dateTag = '[object Date]',
          errorTag = '[object Error]',
          funcTag = '[object Function]',
          mapTag = '[object Map]',
          numberTag = '[object Number]',
          objectTag = '[object Object]',
          regexpTag = '[object RegExp]',
          setTag = '[object Set]',
          stringTag = '[object String]',
          weakMapTag = '[object WeakMap]';
      var arrayBufferTag = '[object ArrayBuffer]',
          dataViewTag = '[object DataView]',
          float32Tag = '[object Float32Array]',
          float64Tag = '[object Float64Array]',
          int8Tag = '[object Int8Array]',
          int16Tag = '[object Int16Array]',
          int32Tag = '[object Int32Array]',
          uint8Tag = '[object Uint8Array]',
          uint8ClampedTag = '[object Uint8ClampedArray]',
          uint16Tag = '[object Uint16Array]',
          uint32Tag = '[object Uint32Array]';
      /** Used to identify `toStringTag` values of typed arrays. */

      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      /**
       * The base implementation of `_.isTypedArray` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       */

      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }

      module.exports = baseIsTypedArray;
      /***/
    },
    /* 1049 */

    /***/
    function (module, exports) {
      /**
       * This method returns `false`.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {boolean} Returns `false`.
       * @example
       *
       * _.times(2, _.stubFalse);
       * // => [false, false]
       */
      function stubFalse() {
        return false;
      }

      module.exports = stubFalse;
      /***/
    },
    /* 1050 */

    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(97);
      /** Built-in value references. */


      var objectCreate = Object.create;
      /**
       * The base implementation of `_.create` without support for assigning
       * properties to the created object.
       *
       * @private
       * @param {Object} proto The object to inherit from.
       * @returns {Object} Returns the new object.
       */

      var baseCreate = function () {
        function object() {}

        return function (proto) {
          if (!isObject(proto)) {
            return {};
          }

          if (objectCreate) {
            return objectCreate(proto);
          }

          object.prototype = proto;
          var result = new object();
          object.prototype = undefined;
          return result;
        };
      }();

      module.exports = baseCreate;
      /***/
    },
    /* 1051 */

    /***/
    function (module, exports, __webpack_require__) {
      var assignMergeValue = __webpack_require__(503),
          cloneBuffer = __webpack_require__(501),
          cloneTypedArray = __webpack_require__(500),
          copyArray = __webpack_require__(246),
          initCloneObject = __webpack_require__(498),
          isArguments = __webpack_require__(211),
          isArray = __webpack_require__(55),
          isArrayLikeObject = __webpack_require__(496),
          isBuffer = __webpack_require__(208),
          isFunction = __webpack_require__(351),
          isObject = __webpack_require__(97),
          isPlainObject = __webpack_require__(495),
          isTypedArray = __webpack_require__(245),
          safeGet = __webpack_require__(494),
          toPlainObject = __webpack_require__(1047);
      /**
       * A specialized version of `baseMerge` for arrays and objects which performs
       * deep merges and tracks traversed objects enabling objects with circular
       * references to be merged.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {string} key The key of the value to merge.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} mergeFunc The function to merge values.
       * @param {Function} [customizer] The function to customize assigned values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */


      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key),
            srcValue = safeGet(source, key),
            stacked = stack.get(srcValue);

        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }

        var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
        var isCommon = newValue === undefined;

        if (isCommon) {
          var isArr = isArray(srcValue),
              isBuff = !isArr && isBuffer(srcValue),
              isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;

          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;

            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }

        if (isCommon) {
          // Recursively merge objects and arrays (susceptible to call stack limits).
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack['delete'](srcValue);
        }

        assignMergeValue(object, key, newValue);
      }

      module.exports = baseMergeDeep;
      /***/
    },
    /* 1052 */

    /***/
    function (module, exports) {
      /**
       * Creates a base function for methods like `_.forIn` and `_.forOwn`.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new base function.
       */
      function createBaseFor(fromRight) {
        return function (object, iteratee, keysFunc) {
          var index = -1,
              iterable = Object(object),
              props = keysFunc(object),
              length = props.length;

          while (length--) {
            var key = props[fromRight ? length : ++index];

            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }

          return object;
        };
      }

      module.exports = createBaseFor;
      /***/
    },
    /* 1053 */

    /***/
    function (module, exports, __webpack_require__) {
      var ListCache = __webpack_require__(253),
          Map = __webpack_require__(350),
          MapCache = __webpack_require__(352);
      /** Used as the size to enable large array optimizations. */


      var LARGE_ARRAY_SIZE = 200;
      /**
       * Sets the stack `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Stack
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the stack cache instance.
       */

      function stackSet(key, value) {
        var data = this.__data__;

        if (data instanceof ListCache) {
          var pairs = data.__data__;

          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }

          data = this.__data__ = new MapCache(pairs);
        }

        data.set(key, value);
        this.size = data.size;
        return this;
      }

      module.exports = stackSet;
      /***/
    },
    /* 1054 */

    /***/
    function (module, exports) {
      /**
       * Checks if a stack value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Stack
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function stackHas(key) {
        return this.__data__.has(key);
      }

      module.exports = stackHas;
      /***/
    },
    /* 1055 */

    /***/
    function (module, exports) {
      /**
       * Gets the stack value for `key`.
       *
       * @private
       * @name get
       * @memberOf Stack
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function stackGet(key) {
        return this.__data__.get(key);
      }

      module.exports = stackGet;
      /***/
    },
    /* 1056 */

    /***/
    function (module, exports) {
      /**
       * Removes `key` and its value from the stack.
       *
       * @private
       * @name delete
       * @memberOf Stack
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function stackDelete(key) {
        var data = this.__data__,
            result = data['delete'](key);
        this.size = data.size;
        return result;
      }

      module.exports = stackDelete;
      /***/
    },
    /* 1057 */

    /***/
    function (module, exports, __webpack_require__) {
      var ListCache = __webpack_require__(253);
      /**
       * Removes all key-value entries from the stack.
       *
       * @private
       * @name clear
       * @memberOf Stack
       */


      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }

      module.exports = stackClear;
      /***/
    },
    /* 1058 */

    /***/
    function (module, exports, __webpack_require__) {
      var Stack = __webpack_require__(247),
          assignMergeValue = __webpack_require__(503),
          baseFor = __webpack_require__(502),
          baseMergeDeep = __webpack_require__(1051),
          isObject = __webpack_require__(97),
          keysIn = __webpack_require__(243),
          safeGet = __webpack_require__(494);
      /**
       * The base implementation of `_.merge` without support for multiple sources.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} [customizer] The function to customize merged values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */


      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }

        baseFor(source, function (srcValue, key) {
          if (isObject(srcValue)) {
            stack || (stack = new Stack());
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

            if (newValue === undefined) {
              newValue = srcValue;
            }

            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }

      module.exports = baseMerge;
      /***/
    },
    /* 1059 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */


      var babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
      /* harmony import */


      var babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */


      var babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
      /* harmony import */


      var babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */


      var babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42);
      /* harmony import */


      var babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */


      var babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
      /* harmony import */


      var babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */


      var babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
      /* harmony import */


      var babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */


      var babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
      /* harmony import */


      var babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */


      var babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8);
      /* harmony import */


      var babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
      /*#__PURE__*/
      __webpack_require__.n(babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);
      /* harmony import */


      var react__WEBPACK_IMPORTED_MODULE_7___default =
      /*#__PURE__*/
      __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(0);
      /* harmony import */


      var prop_types__WEBPACK_IMPORTED_MODULE_8___default =
      /*#__PURE__*/
      __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);

      var classNames = __webpack_require__(3);

      function noop() {}

      var Switch = function (_Component) {
        babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Switch, _Component);

        function Switch(props) {
          babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Switch);

          var _this = babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, props));

          _initialiseProps.call(_this);

          var checked = false;

          if ('checked' in props) {
            checked = !!props.checked;
          } else {
            checked = !!props.defaultChecked;
          }

          _this.state = {
            checked: checked
          };
          return _this;
        }

        babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Switch, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _props = this.props,
                autoFocus = _props.autoFocus,
                disabled = _props.disabled;

            if (autoFocus && !disabled) {
              this.focus();
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            if ('checked' in nextProps) {
              this.setState({
                checked: !!nextProps.checked
              });
            }
          }
        }, {
          key: 'setChecked',
          value: function setChecked(checked) {
            if (this.props.disabled) {
              return;
            }

            if (!('checked' in this.props)) {
              this.setState({
                checked: checked
              });
            }

            this.props.onChange(checked);
          } // Handle auto focus when click switch in Chrome

        }, {
          key: 'focus',
          value: function focus() {
            this.node.focus();
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.node.blur();
          }
        }, {
          key: 'render',
          value: function render() {
            var _classNames;

            var _props2 = this.props,
                className = _props2.className,
                prefixCls = _props2.prefixCls,
                disabled = _props2.disabled,
                checkedChildren = _props2.checkedChildren,
                tabIndex = _props2.tabIndex,
                unCheckedChildren = _props2.unCheckedChildren,
                restProps = babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_props2, ['className', 'prefixCls', 'disabled', 'checkedChildren', 'tabIndex', 'unCheckedChildren']);
            var checked = this.state.checked;
            var switchTabIndex = disabled ? -1 : tabIndex || 0;
            var switchClassName = classNames((_classNames = {}, babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_classNames, className, !!className), babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_classNames, prefixCls, true), babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_classNames, prefixCls + '-checked', checked), babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_classNames, prefixCls + '-disabled', disabled), _classNames));
            return react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement('span', babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, restProps, {
              className: switchClassName,
              tabIndex: switchTabIndex,
              ref: this.saveNode,
              onKeyDown: this.handleKeyDown,
              onClick: this.toggle,
              onMouseUp: this.handleMouseUp
            }), react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement('span', {
              className: prefixCls + '-inner'
            }, checked ? checkedChildren : unCheckedChildren));
          }
        }]);
        return Switch;
      }(react__WEBPACK_IMPORTED_MODULE_7__["Component"]);

      var _initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.toggle = function () {
          var onClick = _this2.props.onClick;
          var checked = !_this2.state.checked;

          _this2.setChecked(checked);

          onClick(checked);
        };

        this.handleKeyDown = function (e) {
          if (e.keyCode === 37) {
            // Left
            _this2.setChecked(false);
          } else if (e.keyCode === 39) {
            // Right
            _this2.setChecked(true);
          } else if (e.keyCode === 32 || e.keyCode === 13) {
            // Space, Enter
            _this2.toggle();
          }
        };

        this.handleMouseUp = function (e) {
          if (_this2.node) {
            _this2.node.blur();
          }

          if (_this2.props.onMouseUp) {
            _this2.props.onMouseUp(e);
          }
        };

        this.saveNode = function (node) {
          _this2.node = node;
        };
      };

      Switch.propTypes = {
        className: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
        prefixCls: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
        disabled: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,
        checkedChildren: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.any,
        unCheckedChildren: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.any,
        onChange: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func,
        onMouseUp: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func,
        onClick: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func,
        tabIndex: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.number,
        checked: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,
        defaultChecked: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,
        autoFocus: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool
      };
      Switch.defaultProps = {
        prefixCls: 'rc-switch',
        checkedChildren: null,
        unCheckedChildren: null,
        className: '',
        defaultChecked: false,
        onChange: noop,
        onClick: noop
      };
      /* harmony default export */

      __webpack_exports__["default"] = Switch;
      /***/
    },
    /* 1060 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
      var toIObject = __webpack_require__(159);

      var $getOwnPropertyDescriptor = __webpack_require__(355).f;

      __webpack_require__(504)('getOwnPropertyDescriptor', function () {
        return function getOwnPropertyDescriptor(it, key) {
          return $getOwnPropertyDescriptor(toIObject(it), key);
        };
      });
      /***/

    },
    /* 1061 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(1060);

      var $Object = __webpack_require__(89).Object;

      module.exports = function getOwnPropertyDescriptor(it, key) {
        return $Object.getOwnPropertyDescriptor(it, key);
      };
      /***/

    },
    /* 1062 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1061),
        __esModule: true
      };
      /***/
    },
    /* 1063 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.9 Object.getPrototypeOf(O)
      var toObject = __webpack_require__(213);

      var $getPrototypeOf = __webpack_require__(647);

      __webpack_require__(504)('getPrototypeOf', function () {
        return function getPrototypeOf(it) {
          return $getPrototypeOf(toObject(it));
        };
      });
      /***/

    },
    /* 1064 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(1063);

      module.exports = __webpack_require__(89).Object.getPrototypeOf;
      /***/
    },
    /* 1065 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1064),
        __esModule: true
      };
      /***/
    },
    /* 1066 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /** @license React v16.8.6
       * react-is.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      Object.defineProperty(exports, "__esModule", {
        value: !0
      });
      var b = "function" === typeof Symbol && Symbol.for,
          c = b ? Symbol.for("react.element") : 60103,
          d = b ? Symbol.for("react.portal") : 60106,
          e = b ? Symbol.for("react.fragment") : 60107,
          f = b ? Symbol.for("react.strict_mode") : 60108,
          g = b ? Symbol.for("react.profiler") : 60114,
          h = b ? Symbol.for("react.provider") : 60109,
          k = b ? Symbol.for("react.context") : 60110,
          l = b ? Symbol.for("react.async_mode") : 60111,
          m = b ? Symbol.for("react.concurrent_mode") : 60111,
          n = b ? Symbol.for("react.forward_ref") : 60112,
          p = b ? Symbol.for("react.suspense") : 60113,
          q = b ? Symbol.for("react.memo") : 60115,
          r = b ? Symbol.for("react.lazy") : 60116;

      function t(a) {
        if ("object" === typeof a && null !== a) {
          var u = a.$$typeof;

          switch (u) {
            case c:
              switch (a = a.type, a) {
                case l:
                case m:
                case e:
                case g:
                case f:
                case p:
                  return a;

                default:
                  switch (a = a && a.$$typeof, a) {
                    case k:
                    case n:
                    case h:
                      return a;

                    default:
                      return u;
                  }

              }

            case r:
            case q:
            case d:
              return u;
          }
        }
      }

      function v(a) {
        return t(a) === m;
      }

      exports.typeOf = t;
      exports.AsyncMode = l;
      exports.ConcurrentMode = m;
      exports.ContextConsumer = k;
      exports.ContextProvider = h;
      exports.Element = c;
      exports.ForwardRef = n;
      exports.Fragment = e;
      exports.Lazy = r;
      exports.Memo = q;
      exports.Portal = d;
      exports.Profiler = g;
      exports.StrictMode = f;
      exports.Suspense = p;

      exports.isValidElementType = function (a) {
        return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
      };

      exports.isAsyncMode = function (a) {
        return v(a) || t(a) === l;
      };

      exports.isConcurrentMode = v;

      exports.isContextConsumer = function (a) {
        return t(a) === k;
      };

      exports.isContextProvider = function (a) {
        return t(a) === h;
      };

      exports.isElement = function (a) {
        return "object" === typeof a && null !== a && a.$$typeof === c;
      };

      exports.isForwardRef = function (a) {
        return t(a) === n;
      };

      exports.isFragment = function (a) {
        return t(a) === e;
      };

      exports.isLazy = function (a) {
        return t(a) === r;
      };

      exports.isMemo = function (a) {
        return t(a) === q;
      };

      exports.isPortal = function (a) {
        return t(a) === d;
      };

      exports.isProfiler = function (a) {
        return t(a) === g;
      };

      exports.isStrictMode = function (a) {
        return t(a) === f;
      };

      exports.isSuspense = function (a) {
        return t(a) === p;
      };
      /***/

    },
    /* 1067 */

    /***/
    function (module, exports, __webpack_require__) {
      var baseGetTag = __webpack_require__(135),
          isObjectLike = __webpack_require__(109);
      /** `Object#toString` result references. */


      var argsTag = '[object Arguments]';
      /**
       * The base implementation of `_.isArguments`.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       */

      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }

      module.exports = baseIsArguments;
      /***/
    },
    /* 1068 */

    /***/
    function (module, exports, __webpack_require__) {
      var getMapData = __webpack_require__(251);
      /**
       * Sets the map `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf MapCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the map cache instance.
       */


      function mapCacheSet(key, value) {
        var data = getMapData(this, key),
            size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }

      module.exports = mapCacheSet;
      /***/
    },
    /* 1069 */

    /***/
    function (module, exports, __webpack_require__) {
      var getMapData = __webpack_require__(251);
      /**
       * Checks if a map value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf MapCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */


      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }

      module.exports = mapCacheHas;
      /***/
    },
    /* 1070 */

    /***/
    function (module, exports, __webpack_require__) {
      var getMapData = __webpack_require__(251);
      /**
       * Gets the map value for `key`.
       *
       * @private
       * @name get
       * @memberOf MapCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */


      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }

      module.exports = mapCacheGet;
      /***/
    },
    /* 1071 */

    /***/
    function (module, exports) {
      /**
       * Checks if `value` is suitable for use as unique object key.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
       */
      function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
      }

      module.exports = isKeyable;
      /***/
    },
    /* 1072 */

    /***/
    function (module, exports, __webpack_require__) {
      var getMapData = __webpack_require__(251);
      /**
       * Removes `key` and its value from the map.
       *
       * @private
       * @name delete
       * @memberOf MapCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */


      function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
      }

      module.exports = mapCacheDelete;
      /***/
    },
    /* 1073 */

    /***/
    function (module, exports, __webpack_require__) {
      var assocIndexOf = __webpack_require__(252);
      /**
       * Sets the list cache `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf ListCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the list cache instance.
       */


      function listCacheSet(key, value) {
        var data = this.__data__,
            index = assocIndexOf(data, key);

        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }

        return this;
      }

      module.exports = listCacheSet;
      /***/
    },
    /* 1074 */

    /***/
    function (module, exports, __webpack_require__) {
      var assocIndexOf = __webpack_require__(252);
      /**
       * Checks if a list cache value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf ListCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */


      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }

      module.exports = listCacheHas;
      /***/
    },
    /* 1075 */

    /***/
    function (module, exports, __webpack_require__) {
      var assocIndexOf = __webpack_require__(252);
      /**
       * Gets the list cache value for `key`.
       *
       * @private
       * @name get
       * @memberOf ListCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */


      function listCacheGet(key) {
        var data = this.__data__,
            index = assocIndexOf(data, key);
        return index < 0 ? undefined : data[index][1];
      }

      module.exports = listCacheGet;
      /***/
    },
    /* 1076 */

    /***/
    function (module, exports, __webpack_require__) {
      var assocIndexOf = __webpack_require__(252);
      /** Used for built-in method references. */


      var arrayProto = Array.prototype;
      /** Built-in value references. */

      var splice = arrayProto.splice;
      /**
       * Removes `key` and its value from the list cache.
       *
       * @private
       * @name delete
       * @memberOf ListCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */

      function listCacheDelete(key) {
        var data = this.__data__,
            index = assocIndexOf(data, key);

        if (index < 0) {
          return false;
        }

        var lastIndex = data.length - 1;

        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }

        --this.size;
        return true;
      }

      module.exports = listCacheDelete;
      /***/
    },
    /* 1077 */

    /***/
    function (module, exports) {
      /**
       * Removes all key-value entries from the list cache.
       *
       * @private
       * @name clear
       * @memberOf ListCache
       */
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }

      module.exports = listCacheClear;
      /***/
    },
    /* 1078 */

    /***/
    function (module, exports, __webpack_require__) {
      var nativeCreate = __webpack_require__(254);
      /** Used to stand-in for `undefined` hash values. */


      var HASH_UNDEFINED = '__lodash_hash_undefined__';
      /**
       * Sets the hash `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Hash
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the hash instance.
       */

      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        return this;
      }

      module.exports = hashSet;
      /***/
    },
    /* 1079 */

    /***/
    function (module, exports, __webpack_require__) {
      var nativeCreate = __webpack_require__(254);
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Checks if a hash value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Hash
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */

      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
      }

      module.exports = hashHas;
      /***/
    },
    /* 1080 */

    /***/
    function (module, exports, __webpack_require__) {
      var nativeCreate = __webpack_require__(254);
      /** Used to stand-in for `undefined` hash values. */


      var HASH_UNDEFINED = '__lodash_hash_undefined__';
      /** Used for built-in method references. */

      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Gets the hash value for `key`.
       *
       * @private
       * @name get
       * @memberOf Hash
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */

      function hashGet(key) {
        var data = this.__data__;

        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? undefined : result;
        }

        return hasOwnProperty.call(data, key) ? data[key] : undefined;
      }

      module.exports = hashGet;
      /***/
    },
    /* 1081 */

    /***/
    function (module, exports) {
      /**
       * Removes `key` and its value from the hash.
       *
       * @private
       * @name delete
       * @memberOf Hash
       * @param {Object} hash The hash to modify.
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }

      module.exports = hashDelete;
      /***/
    },
    /* 1082 */

    /***/
    function (module, exports) {
      /**
       * Gets the value at `key` of `object`.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {string} key The key of the property to get.
       * @returns {*} Returns the property value.
       */
      function getValue(object, key) {
        return object == null ? undefined : object[key];
      }

      module.exports = getValue;
      /***/
    },
    /* 1083 */

    /***/
    function (module, exports, __webpack_require__) {
      var root = __webpack_require__(103);
      /** Used to detect overreaching core-js shims. */


      var coreJsData = root['__core-js_shared__'];
      module.exports = coreJsData;
      /***/
    },
    /* 1084 */

    /***/
    function (module, exports, __webpack_require__) {
      var coreJsData = __webpack_require__(1083);
      /** Used to detect methods masquerading as native. */


      var maskSrcKey = function () {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
      }();
      /**
       * Checks if `func` has its source masked.
       *
       * @private
       * @param {Function} func The function to check.
       * @returns {boolean} Returns `true` if `func` is masked, else `false`.
       */


      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }

      module.exports = isMasked;
      /***/
    },
    /* 1085 */

    /***/
    function (module, exports, __webpack_require__) {
      var isFunction = __webpack_require__(351),
          isMasked = __webpack_require__(1084),
          isObject = __webpack_require__(97),
          toSource = __webpack_require__(508);
      /**
       * Used to match `RegExp`
       * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
       */


      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
      /** Used to detect host constructors (Safari). */

      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      /** Used for built-in method references. */

      var funcProto = Function.prototype,
          objectProto = Object.prototype;
      /** Used to resolve the decompiled source of functions. */

      var funcToString = funcProto.toString;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /** Used to detect if a method is native. */

      var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
      /**
       * The base implementation of `_.isNative` without bad shim checks.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function,
       *  else `false`.
       */

      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }

        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }

      module.exports = baseIsNative;
      /***/
    },
    /* 1086 */

    /***/
    function (module, exports, __webpack_require__) {
      var nativeCreate = __webpack_require__(254);
      /**
       * Removes all key-value entries from the hash.
       *
       * @private
       * @name clear
       * @memberOf Hash
       */


      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }

      module.exports = hashClear;
      /***/
    },
    /* 1087 */

    /***/
    function (module, exports, __webpack_require__) {
      var hashClear = __webpack_require__(1086),
          hashDelete = __webpack_require__(1081),
          hashGet = __webpack_require__(1080),
          hashHas = __webpack_require__(1079),
          hashSet = __webpack_require__(1078);
      /**
       * Creates a hash object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */


      function Hash(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;
        this.clear();

        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      } // Add methods to `Hash`.


      Hash.prototype.clear = hashClear;
      Hash.prototype['delete'] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      module.exports = Hash;
      /***/
    },
    /* 1088 */

    /***/
    function (module, exports, __webpack_require__) {
      var Hash = __webpack_require__(1087),
          ListCache = __webpack_require__(253),
          Map = __webpack_require__(350);
      /**
       * Removes all key-value entries from the map.
       *
       * @private
       * @name clear
       * @memberOf MapCache
       */


      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          'hash': new Hash(),
          'map': new (Map || ListCache)(),
          'string': new Hash()
        };
      }

      module.exports = mapCacheClear;
      /***/
    },
    /* 1089 */

    /***/
    function (module, exports, __webpack_require__) {
      var MapCache = __webpack_require__(352);
      /** Error message constants. */


      var FUNC_ERROR_TEXT = 'Expected a function';
      /**
       * Creates a function that memoizes the result of `func`. If `resolver` is
       * provided, it determines the cache key for storing the result based on the
       * arguments provided to the memoized function. By default, the first argument
       * provided to the memoized function is used as the map cache key. The `func`
       * is invoked with the `this` binding of the memoized function.
       *
       * **Note:** The cache is exposed as the `cache` property on the memoized
       * function. Its creation may be customized by replacing the `_.memoize.Cache`
       * constructor with one whose instances implement the
       * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
       * method interface of `clear`, `delete`, `get`, `has`, and `set`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to have its output memoized.
       * @param {Function} [resolver] The function to resolve the cache key.
       * @returns {Function} Returns the new memoized function.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       * var other = { 'c': 3, 'd': 4 };
       *
       * var values = _.memoize(_.values);
       * values(object);
       * // => [1, 2]
       *
       * values(other);
       * // => [3, 4]
       *
       * object.a = 2;
       * values(object);
       * // => [1, 2]
       *
       * // Modify the result cache.
       * values.cache.set(object, ['a', 'b']);
       * values(object);
       * // => ['a', 'b']
       *
       * // Replace `_.memoize.Cache`.
       * _.memoize.Cache = WeakMap;
       */

      function memoize(func, resolver) {
        if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        var memoized = function memoized() {
          var args = arguments,
              key = resolver ? resolver.apply(this, args) : args[0],
              cache = memoized.cache;

          if (cache.has(key)) {
            return cache.get(key);
          }

          var result = func.apply(this, args);
          memoized.cache = cache.set(key, result) || cache;
          return result;
        };

        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      } // Expose `MapCache`.


      memoize.Cache = MapCache;
      module.exports = memoize;
      /***/
    },
    /* 1090 */

    /***/
    function (module, exports, __webpack_require__) {
      var memoize = __webpack_require__(1089);
      /** Used as the maximum memoize cache size. */


      var MAX_MEMOIZE_SIZE = 500;
      /**
       * A specialized version of `_.memoize` which clears the memoized function's
       * cache when it exceeds `MAX_MEMOIZE_SIZE`.
       *
       * @private
       * @param {Function} func The function to have its output memoized.
       * @returns {Function} Returns the new memoized function.
       */

      function memoizeCapped(func) {
        var result = memoize(func, function (key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }

          return key;
        });
        var cache = result.cache;
        return result;
      }

      module.exports = memoizeCapped;
      /***/
    },
    /* 1091 */

    /***/
    function (module, exports, __webpack_require__) {
      var memoizeCapped = __webpack_require__(1090);
      /** Used to match property names within property paths. */


      var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      /** Used to match backslashes in property paths. */

      var reEscapeChar = /\\(\\)?/g;
      /**
       * Converts `string` to a property path array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the property path array.
       */

      var stringToPath = memoizeCapped(function (string) {
        var result = [];

        if (string.charCodeAt(0) === 46
        /* . */
        ) {
            result.push('');
          }

        string.replace(rePropName, function (match, number, quote, subString) {
          result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        });
        return result;
      });
      module.exports = stringToPath;
      /***/
    },
    /* 1092 */

    /***/
    function (module, exports) {
      /** Used for built-in method references. */
      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * The base implementation of `_.has` without support for deep paths.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {Array|string} key The key to check.
       * @returns {boolean} Returns `true` if `key` exists, else `false`.
       */

      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }

      module.exports = baseHas;
      /***/
    },
    /* 1093 */

    /***/
    function (module, exports) {
      /**
       * Delegate to handle a media query being matched and unmatched.
       *
       * @param {object} options
       * @param {function} options.match callback for when the media query is matched
       * @param {function} [options.unmatch] callback for when the media query is unmatched
       * @param {function} [options.setup] one-time callback triggered the first time a query is matched
       * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
       * @constructor
       */
      function QueryHandler(options) {
        this.options = options;
        !options.deferSetup && this.setup();
      }

      QueryHandler.prototype = {
        constructor: QueryHandler,

        /**
         * coordinates setup of the handler
         *
         * @function
         */
        setup: function setup() {
          if (this.options.setup) {
            this.options.setup();
          }

          this.initialised = true;
        },

        /**
         * coordinates setup and triggering of the handler
         *
         * @function
         */
        on: function on() {
          !this.initialised && this.setup();
          this.options.match && this.options.match();
        },

        /**
         * coordinates the unmatch event for the handler
         *
         * @function
         */
        off: function off() {
          this.options.unmatch && this.options.unmatch();
        },

        /**
         * called when a handler is to be destroyed.
         * delegates to the destroy or unmatch callbacks, depending on availability.
         *
         * @function
         */
        destroy: function destroy() {
          this.options.destroy ? this.options.destroy() : this.off();
        },

        /**
         * determines equality by reference.
         * if object is supplied compare options, if function, compare match callback
         *
         * @function
         * @param {object || function} [target] the target for comparison
         */
        equals: function equals(target) {
          return this.options === target || this.options.match === target;
        }
      };
      module.exports = QueryHandler;
      /***/
    },
    /* 1094 */

    /***/
    function (module, exports, __webpack_require__) {
      var QueryHandler = __webpack_require__(1093);

      var each = __webpack_require__(510).each;
      /**
       * Represents a single media query, manages it's state and registered handlers for this query
       *
       * @constructor
       * @param {string} query the media query string
       * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
       */


      function MediaQuery(query, isUnconditional) {
        this.query = query;
        this.isUnconditional = isUnconditional;
        this.handlers = [];
        this.mql = window.matchMedia(query);
        var self = this;

        this.listener = function (mql) {
          // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
          self.mql = mql.currentTarget || mql;
          self.assess();
        };

        this.mql.addListener(this.listener);
      }

      MediaQuery.prototype = {
        constuctor: MediaQuery,

        /**
         * add a handler for this query, triggering if already active
         *
         * @param {object} handler
         * @param {function} handler.match callback for when query is activated
         * @param {function} [handler.unmatch] callback for when query is deactivated
         * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
         * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
         */
        addHandler: function addHandler(handler) {
          var qh = new QueryHandler(handler);
          this.handlers.push(qh);
          this.matches() && qh.on();
        },

        /**
         * removes the given handler from the collection, and calls it's destroy methods
         *
         * @param {object || function} handler the handler to remove
         */
        removeHandler: function removeHandler(handler) {
          var handlers = this.handlers;
          each(handlers, function (h, i) {
            if (h.equals(handler)) {
              h.destroy();
              return !handlers.splice(i, 1); //remove from array and exit each early
            }
          });
        },

        /**
         * Determine whether the media query should be considered a match
         *
         * @return {Boolean} true if media query can be considered a match, false otherwise
         */
        matches: function matches() {
          return this.mql.matches || this.isUnconditional;
        },

        /**
         * Clears all handlers and unbinds events
         */
        clear: function clear() {
          each(this.handlers, function (handler) {
            handler.destroy();
          });
          this.mql.removeListener(this.listener);
          this.handlers.length = 0; //clear array
        },

        /*
            * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
            */
        assess: function assess() {
          var action = this.matches() ? 'on' : 'off';
          each(this.handlers, function (handler) {
            handler[action]();
          });
        }
      };
      module.exports = MediaQuery;
      /***/
    },
    /* 1095 */

    /***/
    function (module, exports, __webpack_require__) {
      var MediaQuery = __webpack_require__(1094);

      var Util = __webpack_require__(510);

      var each = Util.each;
      var isFunction = Util.isFunction;
      var isArray = Util.isArray;
      /**
       * Allows for registration of query handlers.
       * Manages the query handler's state and is responsible for wiring up browser events
       *
       * @constructor
       */

      function MediaQueryDispatch() {
        if (!window.matchMedia) {
          throw new Error('matchMedia not present, legacy browsers require a polyfill');
        }

        this.queries = {};
        this.browserIsIncapable = !window.matchMedia('only all').matches;
      }

      MediaQueryDispatch.prototype = {
        constructor: MediaQueryDispatch,

        /**
         * Registers a handler for the given media query
         *
         * @param {string} q the media query
         * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
         * @param {function} options.match fired when query matched
         * @param {function} [options.unmatch] fired when a query is no longer matched
         * @param {function} [options.setup] fired when handler first triggered
         * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
         * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
         */
        register: function register(q, options, shouldDegrade) {
          var queries = this.queries,
              isUnconditional = shouldDegrade && this.browserIsIncapable;

          if (!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
          } //normalise to object in an array


          if (isFunction(options)) {
            options = {
              match: options
            };
          }

          if (!isArray(options)) {
            options = [options];
          }

          each(options, function (handler) {
            if (isFunction(handler)) {
              handler = {
                match: handler
              };
            }

            queries[q].addHandler(handler);
          });
          return this;
        },

        /**
         * unregisters a query and all it's handlers, or a specific handler for a query
         *
         * @param {string} q the media query to target
         * @param {object || function} [handler] specific handler to unregister
         */
        unregister: function unregister(q, handler) {
          var query = this.queries[q];

          if (query) {
            if (handler) {
              query.removeHandler(handler);
            } else {
              query.clear();
              delete this.queries[q];
            }
          }

          return this;
        }
      };
      module.exports = MediaQueryDispatch;
      /***/
    },
    /* 1096 */

    /***/
    function (module, exports) {
      var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
      module.exports = canUseDOM;
      /***/
    },
    /* 1097 */

    /***/
    function (module, exports) {
      var camel2hyphen = function camel2hyphen(str) {
        return str.replace(/[A-Z]/g, function (match) {
          return '-' + match.toLowerCase();
        }).toLowerCase();
      };

      module.exports = camel2hyphen;
      /***/
    },
    /* 1098 */

    /***/
    function (module, exports, __webpack_require__) {
      var camel2hyphen = __webpack_require__(1097);

      var isDimension = function isDimension(feature) {
        var re = /[height|width]$/;
        return re.test(feature);
      };

      var obj2mq = function obj2mq(obj) {
        var mq = '';
        var features = Object.keys(obj);
        features.forEach(function (feature, index) {
          var value = obj[feature];
          feature = camel2hyphen(feature); // Add px to dimension features

          if (isDimension(feature) && typeof value === 'number') {
            value = value + 'px';
          }

          if (value === true) {
            mq += feature;
          } else if (value === false) {
            mq += 'not ' + feature;
          } else {
            mq += '(' + feature + ': ' + value + ')';
          }

          if (index < features.length - 1) {
            mq += ' and ';
          }
        });
        return mq;
      };

      var json2mq = function json2mq(query) {
        var mq = '';

        if (typeof query === 'string') {
          return query;
        } // Handling array of media queries


        if (query instanceof Array) {
          query.forEach(function (q, index) {
            mq += obj2mq(q);

            if (index < query.length - 1) {
              mq += ', ';
            }
          });
          return mq;
        } // Handling single media query


        return obj2mq(query);
      };

      module.exports = json2mq;
      /***/
    },
    /* 1099 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* WEBPACK VAR INJECTION */


      (function (global) {
        /**
        * A collection of shims that provide minimal functionality of the ES6 collections.
        *
        * These implementations are not meant to be used outside of the ResizeObserver
        * modules as they cover only a limited range of use cases.
        */

        /* eslint-disable require-jsdoc, valid-jsdoc */
        var MapShim = function () {
          if (typeof Map !== 'undefined') {
            return Map;
          }
          /**
           * Returns index in provided array that matches the specified key.
           *
           * @param {Array<Array>} arr
           * @param {*} key
           * @returns {number}
           */


          function getIndex(arr, key) {
            var result = -1;
            arr.some(function (entry, index) {
              if (entry[0] === key) {
                result = index;
                return true;
              }

              return false;
            });
            return result;
          }

          return (
            /** @class */
            function () {
              function class_1() {
                this.__entries__ = [];
              }

              Object.defineProperty(class_1.prototype, "size", {
                /**
                 * @returns {boolean}
                 */
                get: function get() {
                  return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
              });
              /**
               * @param {*} key
               * @returns {*}
               */

              class_1.prototype.get = function (key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
              };
              /**
               * @param {*} key
               * @param {*} value
               * @returns {void}
               */


              class_1.prototype.set = function (key, value) {
                var index = getIndex(this.__entries__, key);

                if (~index) {
                  this.__entries__[index][1] = value;
                } else {
                  this.__entries__.push([key, value]);
                }
              };
              /**
               * @param {*} key
               * @returns {void}
               */


              class_1.prototype.delete = function (key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);

                if (~index) {
                  entries.splice(index, 1);
                }
              };
              /**
               * @param {*} key
               * @returns {void}
               */


              class_1.prototype.has = function (key) {
                return !!~getIndex(this.__entries__, key);
              };
              /**
               * @returns {void}
               */


              class_1.prototype.clear = function () {
                this.__entries__.splice(0);
              };
              /**
               * @param {Function} callback
               * @param {*} [ctx=null]
               * @returns {void}
               */


              class_1.prototype.forEach = function (callback, ctx) {
                if (ctx === void 0) {
                  ctx = null;
                }

                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                  var entry = _a[_i];
                  callback.call(ctx, entry[1], entry[0]);
                }
              };

              return class_1;
            }()
          );
        }();
        /**
         * Detects whether window and document objects are available in current environment.
         */


        var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document; // Returns global object of a current environment.

        var global$1 = function () {
          if (typeof global !== 'undefined' && global.Math === Math) {
            return global;
          }

          if (typeof self !== 'undefined' && self.Math === Math) {
            return self;
          }

          if (typeof window !== 'undefined' && window.Math === Math) {
            return window;
          } // eslint-disable-next-line no-new-func


          return Function('return this')();
        }();
        /**
         * A shim for the requestAnimationFrame which falls back to the setTimeout if
         * first one is not supported.
         *
         * @returns {number} Requests' identifier.
         */


        var requestAnimationFrame$1 = function () {
          if (typeof requestAnimationFrame === 'function') {
            // It's required to use a bounded function because IE sometimes throws
            // an "Invalid calling object" error if rAF is invoked without the global
            // object on the left hand side.
            return requestAnimationFrame.bind(global$1);
          }

          return function (callback) {
            return setTimeout(function () {
              return callback(Date.now());
            }, 1000 / 60);
          };
        }(); // Defines minimum timeout before adding a trailing call.


        var trailingTimeout = 2;
        /**
         * Creates a wrapper function which ensures that provided callback will be
         * invoked only once during the specified delay period.
         *
         * @param {Function} callback - Function to be invoked after the delay period.
         * @param {number} delay - Delay after which to invoke callback.
         * @returns {Function}
         */

        function throttle(callback, delay) {
          var leadingCall = false,
              trailingCall = false,
              lastCallTime = 0;
          /**
           * Invokes the original callback function and schedules new invocation if
           * the "proxy" was called during current request.
           *
           * @returns {void}
           */

          function resolvePending() {
            if (leadingCall) {
              leadingCall = false;
              callback();
            }

            if (trailingCall) {
              proxy();
            }
          }
          /**
           * Callback invoked after the specified delay. It will further postpone
           * invocation of the original function delegating it to the
           * requestAnimationFrame.
           *
           * @returns {void}
           */


          function timeoutCallback() {
            requestAnimationFrame$1(resolvePending);
          }
          /**
           * Schedules invocation of the original function.
           *
           * @returns {void}
           */


          function proxy() {
            var timeStamp = Date.now();

            if (leadingCall) {
              // Reject immediately following calls.
              if (timeStamp - lastCallTime < trailingTimeout) {
                return;
              } // Schedule new call to be in invoked when the pending one is resolved.
              // This is important for "transitions" which never actually start
              // immediately so there is a chance that we might miss one if change
              // happens amids the pending invocation.


              trailingCall = true;
            } else {
              leadingCall = true;
              trailingCall = false;
              setTimeout(timeoutCallback, delay);
            }

            lastCallTime = timeStamp;
          }

          return proxy;
        } // Minimum delay before invoking the update of observers.


        var REFRESH_DELAY = 20; // A list of substrings of CSS properties used to find transition events that
        // might affect dimensions of observed elements.

        var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight']; // Check if MutationObserver is available.

        var mutationObserverSupported = typeof MutationObserver !== 'undefined';
        /**
         * Singleton controller class which handles updates of ResizeObserver instances.
         */

        var ResizeObserverController =
        /** @class */
        function () {
          /**
           * Creates a new instance of ResizeObserverController.
           *
           * @private
           */
          function ResizeObserverController() {
            /**
             * Indicates whether DOM listeners have been added.
             *
             * @private {boolean}
             */
            this.connected_ = false;
            /**
             * Tells that controller has subscribed for Mutation Events.
             *
             * @private {boolean}
             */

            this.mutationEventsAdded_ = false;
            /**
             * Keeps reference to the instance of MutationObserver.
             *
             * @private {MutationObserver}
             */

            this.mutationsObserver_ = null;
            /**
             * A list of connected observers.
             *
             * @private {Array<ResizeObserverSPI>}
             */

            this.observers_ = [];
            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
          }
          /**
           * Adds observer to observers list.
           *
           * @param {ResizeObserverSPI} observer - Observer to be added.
           * @returns {void}
           */


          ResizeObserverController.prototype.addObserver = function (observer) {
            if (!~this.observers_.indexOf(observer)) {
              this.observers_.push(observer);
            } // Add listeners if they haven't been added yet.


            if (!this.connected_) {
              this.connect_();
            }
          };
          /**
           * Removes observer from observers list.
           *
           * @param {ResizeObserverSPI} observer - Observer to be removed.
           * @returns {void}
           */


          ResizeObserverController.prototype.removeObserver = function (observer) {
            var observers = this.observers_;
            var index = observers.indexOf(observer); // Remove observer if it's present in registry.

            if (~index) {
              observers.splice(index, 1);
            } // Remove listeners if controller has no connected observers.


            if (!observers.length && this.connected_) {
              this.disconnect_();
            }
          };
          /**
           * Invokes the update of observers. It will continue running updates insofar
           * it detects changes.
           *
           * @returns {void}
           */


          ResizeObserverController.prototype.refresh = function () {
            var changesDetected = this.updateObservers_(); // Continue running updates if changes have been detected as there might
            // be future ones caused by CSS transitions.

            if (changesDetected) {
              this.refresh();
            }
          };
          /**
           * Updates every observer from observers list and notifies them of queued
           * entries.
           *
           * @private
           * @returns {boolean} Returns "true" if any observer has detected changes in
           *      dimensions of it's elements.
           */


          ResizeObserverController.prototype.updateObservers_ = function () {
            // Collect observers that have active observations.
            var activeObservers = this.observers_.filter(function (observer) {
              return observer.gatherActive(), observer.hasActive();
            }); // Deliver notifications in a separate cycle in order to avoid any
            // collisions between observers, e.g. when multiple instances of
            // ResizeObserver are tracking the same element and the callback of one
            // of them changes content dimensions of the observed target. Sometimes
            // this may result in notifications being blocked for the rest of observers.

            activeObservers.forEach(function (observer) {
              return observer.broadcastActive();
            });
            return activeObservers.length > 0;
          };
          /**
           * Initializes DOM listeners.
           *
           * @private
           * @returns {void}
           */


          ResizeObserverController.prototype.connect_ = function () {
            // Do nothing if running in a non-browser environment or if listeners
            // have been already added.
            if (!isBrowser || this.connected_) {
              return;
            } // Subscription to the "Transitionend" event is used as a workaround for
            // delayed transitions. This way it's possible to capture at least the
            // final state of an element.


            document.addEventListener('transitionend', this.onTransitionEnd_);
            window.addEventListener('resize', this.refresh);

            if (mutationObserverSupported) {
              this.mutationsObserver_ = new MutationObserver(this.refresh);
              this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
              });
            } else {
              document.addEventListener('DOMSubtreeModified', this.refresh);
              this.mutationEventsAdded_ = true;
            }

            this.connected_ = true;
          };
          /**
           * Removes DOM listeners.
           *
           * @private
           * @returns {void}
           */


          ResizeObserverController.prototype.disconnect_ = function () {
            // Do nothing if running in a non-browser environment or if listeners
            // have been already removed.
            if (!isBrowser || !this.connected_) {
              return;
            }

            document.removeEventListener('transitionend', this.onTransitionEnd_);
            window.removeEventListener('resize', this.refresh);

            if (this.mutationsObserver_) {
              this.mutationsObserver_.disconnect();
            }

            if (this.mutationEventsAdded_) {
              document.removeEventListener('DOMSubtreeModified', this.refresh);
            }

            this.mutationsObserver_ = null;
            this.mutationEventsAdded_ = false;
            this.connected_ = false;
          };
          /**
           * "Transitionend" event handler.
           *
           * @private
           * @param {TransitionEvent} event
           * @returns {void}
           */


          ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
            var _b = _a.propertyName,
                propertyName = _b === void 0 ? '' : _b; // Detect whether transition may affect dimensions of an element.

            var isReflowProperty = transitionKeys.some(function (key) {
              return !!~propertyName.indexOf(key);
            });

            if (isReflowProperty) {
              this.refresh();
            }
          };
          /**
           * Returns instance of the ResizeObserverController.
           *
           * @returns {ResizeObserverController}
           */


          ResizeObserverController.getInstance = function () {
            if (!this.instance_) {
              this.instance_ = new ResizeObserverController();
            }

            return this.instance_;
          };
          /**
           * Holds reference to the controller's instance.
           *
           * @private {ResizeObserverController}
           */


          ResizeObserverController.instance_ = null;
          return ResizeObserverController;
        }();
        /**
         * Defines non-writable/enumerable properties of the provided target object.
         *
         * @param {Object} target - Object for which to define properties.
         * @param {Object} props - Properties to be defined.
         * @returns {Object} Target object.
         */


        var defineConfigurable = function defineConfigurable(target, props) {
          for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
            var key = _a[_i];
            Object.defineProperty(target, key, {
              value: props[key],
              enumerable: false,
              writable: false,
              configurable: true
            });
          }

          return target;
        };
        /**
         * Returns the global object associated with provided element.
         *
         * @param {Object} target
         * @returns {Object}
         */


        var getWindowOf = function getWindowOf(target) {
          // Assume that the element is an instance of Node, which means that it
          // has the "ownerDocument" property from which we can retrieve a
          // corresponding global object.
          var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local global object if it's not possible extract one from
          // provided element.

          return ownerGlobal || global$1;
        }; // Placeholder of an empty content rectangle.


        var emptyRect = createRectInit(0, 0, 0, 0);
        /**
         * Converts provided string to a number.
         *
         * @param {number|string} value
         * @returns {number}
         */

        function toFloat(value) {
          return parseFloat(value) || 0;
        }
        /**
         * Extracts borders size from provided styles.
         *
         * @param {CSSStyleDeclaration} styles
         * @param {...string} positions - Borders positions (top, right, ...)
         * @returns {number}
         */


        function getBordersSize(styles) {
          var positions = [];

          for (var _i = 1; _i < arguments.length; _i++) {
            positions[_i - 1] = arguments[_i];
          }

          return positions.reduce(function (size, position) {
            var value = styles['border-' + position + '-width'];
            return size + toFloat(value);
          }, 0);
        }
        /**
         * Extracts paddings sizes from provided styles.
         *
         * @param {CSSStyleDeclaration} styles
         * @returns {Object} Paddings box.
         */


        function getPaddings(styles) {
          var positions = ['top', 'right', 'bottom', 'left'];
          var paddings = {};

          for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
            var position = positions_1[_i];
            var value = styles['padding-' + position];
            paddings[position] = toFloat(value);
          }

          return paddings;
        }
        /**
         * Calculates content rectangle of provided SVG element.
         *
         * @param {SVGGraphicsElement} target - Element content rectangle of which needs
         *      to be calculated.
         * @returns {DOMRectInit}
         */


        function getSVGContentRect(target) {
          var bbox = target.getBBox();
          return createRectInit(0, 0, bbox.width, bbox.height);
        }
        /**
         * Calculates content rectangle of provided HTMLElement.
         *
         * @param {HTMLElement} target - Element for which to calculate the content rectangle.
         * @returns {DOMRectInit}
         */


        function getHTMLElementContentRect(target) {
          // Client width & height properties can't be
          // used exclusively as they provide rounded values.
          var clientWidth = target.clientWidth,
              clientHeight = target.clientHeight; // By this condition we can catch all non-replaced inline, hidden and
          // detached elements. Though elements with width & height properties less
          // than 0.5 will be discarded as well.
          //
          // Without it we would need to implement separate methods for each of
          // those cases and it's not possible to perform a precise and performance
          // effective test for hidden elements. E.g. even jQuery's ':visible' filter
          // gives wrong results for elements with width & height less than 0.5.

          if (!clientWidth && !clientHeight) {
            return emptyRect;
          }

          var styles = getWindowOf(target).getComputedStyle(target);
          var paddings = getPaddings(styles);
          var horizPad = paddings.left + paddings.right;
          var vertPad = paddings.top + paddings.bottom; // Computed styles of width & height are being used because they are the
          // only dimensions available to JS that contain non-rounded values. It could
          // be possible to utilize the getBoundingClientRect if only it's data wasn't
          // affected by CSS transformations let alone paddings, borders and scroll bars.

          var width = toFloat(styles.width),
              height = toFloat(styles.height); // Width & height include paddings and borders when the 'border-box' box
          // model is applied (except for IE).

          if (styles.boxSizing === 'border-box') {
            // Following conditions are required to handle Internet Explorer which
            // doesn't include paddings and borders to computed CSS dimensions.
            //
            // We can say that if CSS dimensions + paddings are equal to the "client"
            // properties then it's either IE, and thus we don't need to subtract
            // anything, or an element merely doesn't have paddings/borders styles.
            if (Math.round(width + horizPad) !== clientWidth) {
              width -= getBordersSize(styles, 'left', 'right') + horizPad;
            }

            if (Math.round(height + vertPad) !== clientHeight) {
              height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
            }
          } // Following steps can't be applied to the document's root element as its
          // client[Width/Height] properties represent viewport area of the window.
          // Besides, it's as well not necessary as the <html> itself neither has
          // rendered scroll bars nor it can be clipped.


          if (!isDocumentElement(target)) {
            // In some browsers (only in Firefox, actually) CSS width & height
            // include scroll bars size which can be removed at this step as scroll
            // bars are the only difference between rounded dimensions + paddings
            // and "client" properties, though that is not always true in Chrome.
            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
            var horizScrollbar = Math.round(height + vertPad) - clientHeight; // Chrome has a rather weird rounding of "client" properties.
            // E.g. for an element with content width of 314.2px it sometimes gives
            // the client width of 315px and for the width of 314.7px it may give
            // 314px. And it doesn't happen all the time. So just ignore this delta
            // as a non-relevant.

            if (Math.abs(vertScrollbar) !== 1) {
              width -= vertScrollbar;
            }

            if (Math.abs(horizScrollbar) !== 1) {
              height -= horizScrollbar;
            }
          }

          return createRectInit(paddings.left, paddings.top, width, height);
        }
        /**
         * Checks whether provided element is an instance of the SVGGraphicsElement.
         *
         * @param {Element} target - Element to be checked.
         * @returns {boolean}
         */


        var isSVGGraphicsElement = function () {
          // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
          // interface.
          if (typeof SVGGraphicsElement !== 'undefined') {
            return function (target) {
              return target instanceof getWindowOf(target).SVGGraphicsElement;
            };
          } // If it's so, then check that element is at least an instance of the
          // SVGElement and that it has the "getBBox" method.
          // eslint-disable-next-line no-extra-parens


          return function (target) {
            return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
          };
        }();
        /**
         * Checks whether provided element is a document element (<html>).
         *
         * @param {Element} target - Element to be checked.
         * @returns {boolean}
         */


        function isDocumentElement(target) {
          return target === getWindowOf(target).document.documentElement;
        }
        /**
         * Calculates an appropriate content rectangle for provided html or svg element.
         *
         * @param {Element} target - Element content rectangle of which needs to be calculated.
         * @returns {DOMRectInit}
         */


        function getContentRect(target) {
          if (!isBrowser) {
            return emptyRect;
          }

          if (isSVGGraphicsElement(target)) {
            return getSVGContentRect(target);
          }

          return getHTMLElementContentRect(target);
        }
        /**
         * Creates rectangle with an interface of the DOMRectReadOnly.
         * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
         *
         * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
         * @returns {DOMRectReadOnly}
         */


        function createReadOnlyRect(_a) {
          var x = _a.x,
              y = _a.y,
              width = _a.width,
              height = _a.height; // If DOMRectReadOnly is available use it as a prototype for the rectangle.

          var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
          var rect = Object.create(Constr.prototype); // Rectangle's properties are not writable and non-enumerable.

          defineConfigurable(rect, {
            x: x,
            y: y,
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: height + y,
            left: x
          });
          return rect;
        }
        /**
         * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
         * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
         *
         * @param {number} x - X coordinate.
         * @param {number} y - Y coordinate.
         * @param {number} width - Rectangle's width.
         * @param {number} height - Rectangle's height.
         * @returns {DOMRectInit}
         */


        function createRectInit(x, y, width, height) {
          return {
            x: x,
            y: y,
            width: width,
            height: height
          };
        }
        /**
         * Class that is responsible for computations of the content rectangle of
         * provided DOM element and for keeping track of it's changes.
         */


        var ResizeObservation =
        /** @class */
        function () {
          /**
           * Creates an instance of ResizeObservation.
           *
           * @param {Element} target - Element to be observed.
           */
          function ResizeObservation(target) {
            /**
             * Broadcasted width of content rectangle.
             *
             * @type {number}
             */
            this.broadcastWidth = 0;
            /**
             * Broadcasted height of content rectangle.
             *
             * @type {number}
             */

            this.broadcastHeight = 0;
            /**
             * Reference to the last observed content rectangle.
             *
             * @private {DOMRectInit}
             */

            this.contentRect_ = createRectInit(0, 0, 0, 0);
            this.target = target;
          }
          /**
           * Updates content rectangle and tells whether it's width or height properties
           * have changed since the last broadcast.
           *
           * @returns {boolean}
           */


          ResizeObservation.prototype.isActive = function () {
            var rect = getContentRect(this.target);
            this.contentRect_ = rect;
            return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
          };
          /**
           * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
           * from the corresponding properties of the last observed content rectangle.
           *
           * @returns {DOMRectInit} Last observed content rectangle.
           */


          ResizeObservation.prototype.broadcastRect = function () {
            var rect = this.contentRect_;
            this.broadcastWidth = rect.width;
            this.broadcastHeight = rect.height;
            return rect;
          };

          return ResizeObservation;
        }();

        var ResizeObserverEntry =
        /** @class */
        function () {
          /**
           * Creates an instance of ResizeObserverEntry.
           *
           * @param {Element} target - Element that is being observed.
           * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
           */
          function ResizeObserverEntry(target, rectInit) {
            var contentRect = createReadOnlyRect(rectInit); // According to the specification following properties are not writable
            // and are also not enumerable in the native implementation.
            //
            // Property accessors are not being used as they'd require to define a
            // private WeakMap storage which may cause memory leaks in browsers that
            // don't support this type of collections.

            defineConfigurable(this, {
              target: target,
              contentRect: contentRect
            });
          }

          return ResizeObserverEntry;
        }();

        var ResizeObserverSPI =
        /** @class */
        function () {
          /**
           * Creates a new instance of ResizeObserver.
           *
           * @param {ResizeObserverCallback} callback - Callback function that is invoked
           *      when one of the observed elements changes it's content dimensions.
           * @param {ResizeObserverController} controller - Controller instance which
           *      is responsible for the updates of observer.
           * @param {ResizeObserver} callbackCtx - Reference to the public
           *      ResizeObserver instance which will be passed to callback function.
           */
          function ResizeObserverSPI(callback, controller, callbackCtx) {
            /**
             * Collection of resize observations that have detected changes in dimensions
             * of elements.
             *
             * @private {Array<ResizeObservation>}
             */
            this.activeObservations_ = [];
            /**
             * Registry of the ResizeObservation instances.
             *
             * @private {Map<Element, ResizeObservation>}
             */

            this.observations_ = new MapShim();

            if (typeof callback !== 'function') {
              throw new TypeError('The callback provided as parameter 1 is not a function.');
            }

            this.callback_ = callback;
            this.controller_ = controller;
            this.callbackCtx_ = callbackCtx;
          }
          /**
           * Starts observing provided element.
           *
           * @param {Element} target - Element to be observed.
           * @returns {void}
           */


          ResizeObserverSPI.prototype.observe = function (target) {
            if (!arguments.length) {
              throw new TypeError('1 argument required, but only 0 present.');
            } // Do nothing if current environment doesn't have the Element interface.


            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
              return;
            }

            if (!(target instanceof getWindowOf(target).Element)) {
              throw new TypeError('parameter 1 is not of type "Element".');
            }

            var observations = this.observations_; // Do nothing if element is already being observed.

            if (observations.has(target)) {
              return;
            }

            observations.set(target, new ResizeObservation(target));
            this.controller_.addObserver(this); // Force the update of observations.

            this.controller_.refresh();
          };
          /**
           * Stops observing provided element.
           *
           * @param {Element} target - Element to stop observing.
           * @returns {void}
           */


          ResizeObserverSPI.prototype.unobserve = function (target) {
            if (!arguments.length) {
              throw new TypeError('1 argument required, but only 0 present.');
            } // Do nothing if current environment doesn't have the Element interface.


            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
              return;
            }

            if (!(target instanceof getWindowOf(target).Element)) {
              throw new TypeError('parameter 1 is not of type "Element".');
            }

            var observations = this.observations_; // Do nothing if element is not being observed.

            if (!observations.has(target)) {
              return;
            }

            observations.delete(target);

            if (!observations.size) {
              this.controller_.removeObserver(this);
            }
          };
          /**
           * Stops observing all elements.
           *
           * @returns {void}
           */


          ResizeObserverSPI.prototype.disconnect = function () {
            this.clearActive();
            this.observations_.clear();
            this.controller_.removeObserver(this);
          };
          /**
           * Collects observation instances the associated element of which has changed
           * it's content rectangle.
           *
           * @returns {void}
           */


          ResizeObserverSPI.prototype.gatherActive = function () {
            var _this = this;

            this.clearActive();
            this.observations_.forEach(function (observation) {
              if (observation.isActive()) {
                _this.activeObservations_.push(observation);
              }
            });
          };
          /**
           * Invokes initial callback function with a list of ResizeObserverEntry
           * instances collected from active resize observations.
           *
           * @returns {void}
           */


          ResizeObserverSPI.prototype.broadcastActive = function () {
            // Do nothing if observer doesn't have active observations.
            if (!this.hasActive()) {
              return;
            }

            var ctx = this.callbackCtx_; // Create ResizeObserverEntry instance for every active observation.

            var entries = this.activeObservations_.map(function (observation) {
              return new ResizeObserverEntry(observation.target, observation.broadcastRect());
            });
            this.callback_.call(ctx, entries, ctx);
            this.clearActive();
          };
          /**
           * Clears the collection of active observations.
           *
           * @returns {void}
           */


          ResizeObserverSPI.prototype.clearActive = function () {
            this.activeObservations_.splice(0);
          };
          /**
           * Tells whether observer has active observations.
           *
           * @returns {boolean}
           */


          ResizeObserverSPI.prototype.hasActive = function () {
            return this.activeObservations_.length > 0;
          };

          return ResizeObserverSPI;
        }(); // Registry of internal observers. If WeakMap is not available use current shim
        // for the Map collection as it has all required methods and because WeakMap
        // can't be fully polyfilled anyway.


        var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
        /**
         * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
         * exposing only those methods and properties that are defined in the spec.
         */

        var ResizeObserver =
        /** @class */
        function () {
          /**
           * Creates a new instance of ResizeObserver.
           *
           * @param {ResizeObserverCallback} callback - Callback that is invoked when
           *      dimensions of the observed elements change.
           */
          function ResizeObserver(callback) {
            if (!(this instanceof ResizeObserver)) {
              throw new TypeError('Cannot call a class as a function.');
            }

            if (!arguments.length) {
              throw new TypeError('1 argument required, but only 0 present.');
            }

            var controller = ResizeObserverController.getInstance();
            var observer = new ResizeObserverSPI(callback, controller, this);
            observers.set(this, observer);
          }

          return ResizeObserver;
        }(); // Expose public methods of ResizeObserver.


        ['observe', 'unobserve', 'disconnect'].forEach(function (method) {
          ResizeObserver.prototype[method] = function () {
            var _a;

            return (_a = observers.get(this))[method].apply(_a, arguments);
          };
        });

        var index = function () {
          // Export existing implementation if available.
          if (typeof global$1.ResizeObserver !== 'undefined') {
            return global$1.ResizeObserver;
          }

          return ResizeObserver;
        }();
        /* harmony default export */


        __webpack_exports__["default"] = index;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 1100 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports.NextArrow = exports.PrevArrow = undefined;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _innerSliderUtils = __webpack_require__(354);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var PrevArrow = exports.PrevArrow = function (_React$Component) {
        _inherits(PrevArrow, _React$Component);

        function PrevArrow() {
          _classCallCheck(this, PrevArrow);

          return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
          if (e) {
            e.preventDefault();
          }

          this.props.clickHandler(options, e);
        };

        PrevArrow.prototype.render = function render() {
          var prevClasses = {
            'slick-arrow': true,
            'slick-prev': true
          };
          var prevHandler = this.clickHandler.bind(this, {
            message: 'previous'
          });

          if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
            prevClasses['slick-disabled'] = true;
            prevHandler = null;
          }

          var prevArrowProps = {
            key: '0',
            'data-role': 'none',
            className: (0, _classnames2.default)(prevClasses),
            style: {
              display: 'block'
            },
            onClick: prevHandler
          };
          var customProps = {
            currentSlide: this.props.currentSlide,
            slideCount: this.props.slideCount
          };
          var prevArrow = void 0;

          if (this.props.prevArrow) {
            prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
          } else {
            prevArrow = _react2.default.createElement('button', _extends({
              key: '0',
              type: 'button'
            }, prevArrowProps), ' Previous');
          }

          return prevArrow;
        };

        return PrevArrow;
      }(_react2.default.Component);

      var NextArrow = exports.NextArrow = function (_React$Component2) {
        _inherits(NextArrow, _React$Component2);

        function NextArrow() {
          _classCallCheck(this, NextArrow);

          return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
        }

        NextArrow.prototype.clickHandler = function clickHandler(options, e) {
          if (e) {
            e.preventDefault();
          }

          this.props.clickHandler(options, e);
        };

        NextArrow.prototype.render = function render() {
          var nextClasses = {
            'slick-arrow': true,
            'slick-next': true
          };
          var nextHandler = this.clickHandler.bind(this, {
            message: 'next'
          });

          if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
            nextClasses['slick-disabled'] = true;
            nextHandler = null;
          }

          var nextArrowProps = {
            key: '1',
            'data-role': 'none',
            className: (0, _classnames2.default)(nextClasses),
            style: {
              display: 'block'
            },
            onClick: nextHandler
          };
          var customProps = {
            currentSlide: this.props.currentSlide,
            slideCount: this.props.slideCount
          };
          var nextArrow = void 0;

          if (this.props.nextArrow) {
            nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
          } else {
            nextArrow = _react2.default.createElement('button', _extends({
              key: '1',
              type: 'button'
            }, nextArrowProps), ' Next');
          }

          return nextArrow;
        };

        return NextArrow;
      }(_react2.default.Component);
      /***/

    },
    /* 1101 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports.Dots = undefined;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var getDotCount = function getDotCount(spec) {
        var dots;

        if (spec.infinite) {
          dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
        } else {
          dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
        }

        return dots;
      };

      var Dots = exports.Dots = function (_React$Component) {
        _inherits(Dots, _React$Component);

        function Dots() {
          _classCallCheck(this, Dots);

          return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        Dots.prototype.clickHandler = function clickHandler(options, e) {
          // In Autoplay the focus stays on clicked button even after transition
          // to next slide. That only goes away by click somewhere outside
          e.preventDefault();
          this.props.clickHandler(options);
        };

        Dots.prototype.render = function render() {
          var _this2 = this;

          var dotCount = getDotCount({
            slideCount: this.props.slideCount,
            slidesToScroll: this.props.slidesToScroll,
            slidesToShow: this.props.slidesToShow,
            infinite: this.props.infinite
          }); // Apply join & split to Array to pre-fill it for IE8
          //
          // Credit: http://stackoverflow.com/a/13735425/1849458

          var _props = this.props,
              onMouseEnter = _props.onMouseEnter,
              onMouseOver = _props.onMouseOver,
              onMouseLeave = _props.onMouseLeave;
          var mouseEvents = {
            onMouseEnter: onMouseEnter,
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave
          };
          var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
            var leftBound = i * _this2.props.slidesToScroll;
            var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
            var className = (0, _classnames2.default)({
              'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
            });
            var dotOptions = {
              message: 'dots',
              index: i,
              slidesToScroll: _this2.props.slidesToScroll,
              currentSlide: _this2.props.currentSlide
            };

            var onClick = _this2.clickHandler.bind(_this2, dotOptions);

            return _react2.default.createElement('li', {
              key: i,
              className: className
            }, _react2.default.cloneElement(_this2.props.customPaging(i), {
              onClick: onClick
            }));
          });
          return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
            className: this.props.dotsClass
          }, mouseEvents));
        };

        return Dots;
      }(_react2.default.Component);
      /***/

    },
    /* 1102 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports.Track = undefined;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _innerSliderUtils = __webpack_require__(354);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // given specifications/props for a slide, fetch all the classes that need to be applied to the slide


      var getSlideClasses = function getSlideClasses(spec) {
        // if spec has currentSlideIndex, we can also apply slickCurrent class according to that (https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L2300-L2302)
        var slickActive, slickCenter, slickCloned;
        var centerOffset, index;

        if (spec.rtl) {
          // if we're going right to left, index is reversed
          index = spec.slideCount - 1 - spec.index;
        } else {
          // index of the slide
          index = spec.index;
        }

        slickCloned = index < 0 || index >= spec.slideCount;

        if (spec.centerMode) {
          centerOffset = Math.floor(spec.slidesToShow / 2);
          slickCenter = (index - spec.currentSlide) % spec.slideCount === 0; // concern: not sure if this should be correct (https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L2328-L2346)

          if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
            slickActive = true;
          }
        } else {
          // concern: following can be incorrect in case where currentSlide is lastSlide in frame and rest of the slides to show have index smaller than currentSlideIndex
          slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
        }

        var slickCurrent = index === spec.currentSlide;
        return (0, _classnames2.default)({
          'slick-slide': true,
          'slick-active': slickActive,
          'slick-center': slickCenter,
          'slick-cloned': slickCloned,
          'slick-current': slickCurrent // dubious in case of RTL

        });
      };

      var getSlideStyle = function getSlideStyle(spec) {
        var style = {};

        if (spec.variableWidth === undefined || spec.variableWidth === false) {
          style.width = spec.slideWidth;
        }

        if (spec.fade) {
          style.position = 'relative';

          if (spec.vertical) {
            style.top = -spec.index * spec.slideHeight;
          } else {
            style.left = -spec.index * spec.slideWidth;
          }

          style.opacity = spec.currentSlide === spec.index ? 1 : 0;
          style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase + ', ' + 'visibility ' + spec.speed + 'ms ' + spec.cssEase;
          style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase + ', ' + 'visibility ' + spec.speed + 'ms ' + spec.cssEase;
        }

        return style;
      };

      var getKey = function getKey(child, fallbackKey) {
        return child.key || fallbackKey;
      };

      var renderSlides = function renderSlides(spec) {
        var key;
        var slides = [];
        var preCloneSlides = [];
        var postCloneSlides = [];

        var childrenCount = _react2.default.Children.count(spec.children);

        var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
        var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

        _react2.default.Children.forEach(spec.children, function (elem, index) {
          var child = void 0;
          var childOnClickOptions = {
            message: 'children',
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
          }; // in case of lazyLoad, whether or not we want to fetch the slide

          if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
            child = elem;
          } else {
            child = _react2.default.createElement('div', null);
          }

          var childStyle = getSlideStyle(_extends({}, spec, {
            index: index
          }));
          var slideClass = child.props.className || ''; // push a cloned element of the desired slide

          slides.push(_react2.default.cloneElement(child, {
            key: 'original' + getKey(child, index),
            'data-index': index,
            className: (0, _classnames2.default)(getSlideClasses(_extends({}, spec, {
              index: index
            })), slideClass),
            tabIndex: '-1',
            style: _extends({
              outline: 'none'
            }, child.props.style || {}, childStyle),
            onClick: function onClick(e) {
              child.props && child.props.onClick && child.props.onClick(e);

              if (spec.focusOnSelect) {
                spec.focusOnSelect(childOnClickOptions);
              }
            }
          })); // if slide needs to be precloned or postcloned

          if (spec.infinite && spec.fade === false) {
            var preCloneNo = childrenCount - index;

            if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
              key = -preCloneNo;

              if (key >= startIndex) {
                child = elem;
              }

              preCloneSlides.push(_react2.default.cloneElement(child, {
                key: 'precloned' + getKey(child, key),
                'data-index': key,
                tabIndex: '-1',
                className: (0, _classnames2.default)(getSlideClasses(_extends({}, spec, {
                  index: key
                })), slideClass),
                style: _extends({}, child.props.style || {}, childStyle),
                onClick: function onClick(e) {
                  child.props && child.props.onClick && child.props.onClick(e);

                  if (spec.focusOnSelect) {
                    spec.focusOnSelect(childOnClickOptions);
                  }
                }
              }));
            }

            if (childrenCount !== spec.slidesToShow) {
              key = childrenCount + index;

              if (key < endIndex) {
                child = elem;
              }

              postCloneSlides.push(_react2.default.cloneElement(child, {
                key: 'postcloned' + getKey(child, key),
                'data-index': key,
                tabIndex: '-1',
                className: (0, _classnames2.default)(getSlideClasses(_extends({}, spec, {
                  index: key
                })), slideClass),
                style: _extends({}, child.props.style || {}, childStyle),
                onClick: function onClick(e) {
                  child.props && child.props.onClick && child.props.onClick(e);

                  if (spec.focusOnSelect) {
                    spec.focusOnSelect(childOnClickOptions);
                  }
                }
              }));
            }
          }
        });

        if (spec.rtl) {
          return preCloneSlides.concat(slides, postCloneSlides).reverse();
        } else {
          return preCloneSlides.concat(slides, postCloneSlides);
        }
      };

      var Track = exports.Track = function (_React$Component) {
        _inherits(Track, _React$Component);

        function Track() {
          _classCallCheck(this, Track);

          return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        Track.prototype.render = function render() {
          var slides = renderSlides(this.props);
          var _props = this.props,
              onMouseEnter = _props.onMouseEnter,
              onMouseOver = _props.onMouseOver,
              onMouseLeave = _props.onMouseLeave;
          var mouseEvents = {
            onMouseEnter: onMouseEnter,
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave
          };
          return _react2.default.createElement('div', _extends({
            className: 'slick-track',
            style: this.props.trackStyle
          }, mouseEvents), slides);
        };

        return Track;
      }(_react2.default.Component);
      /***/

    },
    /* 1103 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      var initialState = {
        animating: false,
        autoplaying: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        dragging: false,
        edgeDragged: false,
        initialized: false,
        lazyLoadedList: [],
        listHeight: null,
        listWidth: null,
        scrolling: false,
        slideCount: null,
        slideHeight: null,
        slideWidth: null,
        swipeLeft: null,
        swiped: false,
        // used by swipeEvent. differentites between touch and swipe.
        swiping: false,
        touchObject: {
          startX: 0,
          startY: 0,
          curX: 0,
          curY: 0
        },
        trackStyle: {},
        trackWidth: 0
      };
      exports.default = initialState;
      /***/
    },
    /* 1104 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      exports.InnerSlider = undefined;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _reactDom = __webpack_require__(16);

      var _reactDom2 = _interopRequireDefault(_reactDom);

      var _initialState = __webpack_require__(1103);

      var _initialState2 = _interopRequireDefault(_initialState);

      var _defaultProps = __webpack_require__(512);

      var _defaultProps2 = _interopRequireDefault(_defaultProps);

      var _createReactClass = __webpack_require__(32);

      var _createReactClass2 = _interopRequireDefault(_createReactClass);

      var _classnames = __webpack_require__(3);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _innerSliderUtils = __webpack_require__(354);

      var _track = __webpack_require__(1102);

      var _dots = __webpack_require__(1101);

      var _arrows = __webpack_require__(1100);

      var _resizeObserverPolyfill = __webpack_require__(1099);

      var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var InnerSlider = exports.InnerSlider = function (_React$Component) {
        _inherits(InnerSlider, _React$Component);

        function InnerSlider(props) {
          _classCallCheck(this, InnerSlider);

          var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

          _this.listRefHandler = function (ref) {
            return _this.list = ref;
          };

          _this.trackRefHandler = function (ref) {
            return _this.track = ref;
          };

          _this.adaptHeight = function () {
            if (_this.props.adaptiveHeight && _this.list) {
              var elem = _this.list.querySelector('[data-index="' + _this.state.currentSlide + '"]');

              _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + 'px';
            }
          };

          _this.componentWillMount = function () {
            _this.props.onInit && _this.props.onInit();

            if (_this.props.lazyLoad) {
              var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));

              if (slidesToLoad.length > 0) {
                _this.setState(function (prevState, props) {
                  return {
                    lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                  };
                });

                if (_this.props.onLazyLoad) {
                  _this.props.onLazyLoad(slidesToLoad);
                }
              }
            }
          };

          _this.componentDidMount = function () {
            var spec = _extends({
              listRef: _this.list,
              trackRef: _this.track
            }, _this.props);

            _this.updateState(spec, true, function () {
              _this.adaptHeight();

              _this.props.autoplay && _this.autoPlay('update');
            });

            if (_this.props.lazyLoad === 'progressive') {
              _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            }

            _this.ro = new _resizeObserverPolyfill2.default(function (entries) {
              return _this.onWindowResized();
            });

            _this.ro.observe(_this.list);

            Array.from(document.querySelectorAll('.slick-slide')).forEach(function (slide) {
              slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
              slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            }); // To support server-side rendering

            if (!window) {
              return;
            }

            if (window.addEventListener) {
              window.addEventListener('resize', _this.onWindowResized);
            } else {
              window.attachEvent('onresize', _this.onWindowResized);
            }
          };

          _this.componentWillUnmount = function () {
            if (_this.animationEndCallback) {
              clearTimeout(_this.animationEndCallback);
            }

            if (_this.lazyLoadTimer) {
              clearInterval(_this.lazyLoadTimer);
            }

            if (_this.callbackTimers.length) {
              _this.callbackTimers.forEach(function (timer) {
                return clearTimeout(timer);
              });

              _this.callbackTimers = [];
            }

            if (window.addEventListener) {
              window.removeEventListener('resize', _this.onWindowResized);
            } else {
              window.detachEvent('onresize', _this.onWindowResized);
            }

            if (_this.autoplayTimer) {
              clearInterval(_this.autoplayTimer);
            }
          };

          _this.componentWillReceiveProps = function (nextProps) {
            var spec = _extends({
              listRef: _this.list,
              trackRef: _this.track
            }, nextProps, _this.state);

            _this.updateState(spec, false, function () {
              if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
                _this.changeSlide({
                  message: 'index',
                  index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
                  currentSlide: _this.state.currentSlide
                });
              }

              if (nextProps.autoplay) {
                _this.autoPlay('update');
              } else {
                _this.pause('paused');
              }
            });
          };

          _this.componentDidUpdate = function () {
            _this.checkImagesLoad();

            _this.props.onReInit && _this.props.onReInit();

            if (_this.props.lazyLoad) {
              var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));

              if (slidesToLoad.length > 0) {
                _this.setState(function (prevState, props) {
                  return {
                    lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                  };
                });

                if (_this.props.onLazyLoad) {
                  _this.props.onLazyLoad(slidesToLoad);
                }
              }
            } // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }


            _this.adaptHeight();
          };

          _this.onWindowResized = function () {
            if (!_reactDom2.default.findDOMNode(_this.track)) return;

            var spec = _extends({
              listRef: _this.list,
              trackRef: _this.track
            }, _this.props, _this.state);

            _this.updateState(spec, true, function () {
              if (_this.props.autoplay) _this.autoPlay('update');else _this.pause('paused');
            }); // animating state should be cleared while resizing, otherwise autoplay stops working


            _this.setState({
              animating: false
            });

            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
          };

          _this.updateState = function (spec, setTrackStyle, callback) {
            var updatedState = (0, _innerSliderUtils.initializedState)(spec);
            spec = _extends({}, spec, updatedState, {
              slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
            spec = _extends({}, spec, {
              left: targetLeft
            });
            var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

            if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
              updatedState['trackStyle'] = trackStyle;
            }

            _this.setState(updatedState, callback);
          };

          _this.checkImagesLoad = function () {
            var images = document.querySelectorAll('.slick-slide img');
            var imagesCount = images.length,
                loadedCount = 0;
            Array.from(images).forEach(function (image) {
              var handler = function handler() {
                return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
              };

              if (!image.onclick) {
                image.onclick = function () {
                  return image.parentNode.focus();
                };
              } else {
                var prevClickHandler = image.onclick;

                image.onclick = function () {
                  prevClickHandler();
                  image.parentNode.focus();
                };
              }

              if (!image.onload) {
                if (_this.props.lazyLoad) {
                  image.onload = function () {
                    _this.adaptHeight();

                    _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                  };
                } else {
                  image.onload = handler;

                  image.onerror = function () {
                    handler();
                    _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                  };
                }
              }
            });
          };

          _this.progressiveLazyLoad = function () {
            var slidesToLoad = [];

            var spec = _extends({}, _this.props, _this.state);

            for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
              if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
              }
            }

            for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
              if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
              }
            }

            if (slidesToLoad.length > 0) {
              _this.setState(function (state) {
                return {
                  lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                };
              });

              if (_this.props.onLazyLoad) {
                _this.props.onLazyLoad(slidesToLoad);
              }
            } else {
              if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
              }
            }
          };

          _this.slideHandler = function (index) {
            var _this$props = _this.props,
                asNavFor = _this$props.asNavFor,
                currentSlide = _this$props.currentSlide,
                beforeChange = _this$props.beforeChange,
                onLazyLoad = _this$props.onLazyLoad,
                speed = _this$props.speed,
                afterChange = _this$props.afterChange;

            var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
              index: index
            }, _this.props, _this.state, {
              trackRef: _this.track
            })),
                state = _slideHandler.state,
                nextState = _slideHandler.nextState;

            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function (value) {
              return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

            _this.setState(state, function () {
              asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
              _this.animationEndCallback = setTimeout(function () {
                var animating = nextState.animating,
                    firstBatch = _objectWithoutProperties(nextState, ['animating']);

                _this.setState(firstBatch, function () {
                  _this.callbackTimers.push(setTimeout(function () {
                    return _this.setState({
                      animating: animating
                    });
                  }, 10));

                  afterChange && afterChange(state.currentSlide);
                  delete _this.animationEndCallback;
                });
              }, speed);
            });
          };

          _this.changeSlide = function (options) {
            var spec = _extends({}, _this.props, _this.state);

            var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;

            _this.slideHandler(targetSlide);
          };

          _this.keyHandler = function (e) {
            var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
            dir !== '' && _this.changeSlide({
              message: dir
            });
          };

          _this.selectHandler = function (options) {
            _this.changeSlide(options);
          };

          _this.swipeStart = function (e) {
            var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
            state !== '' && _this.setState(state);
          };

          _this.swipeMove = function (e) {
            var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
              trackRef: _this.track,
              listRef: _this.list,
              slideIndex: _this.state.currentSlide
            }));
            if (!state) return;

            _this.setState(state);
          };

          _this.swipeEnd = function (e) {
            var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
              trackRef: _this.track,
              listRef: _this.list,
              slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state['triggerSlideHandler'];
            delete state['triggerSlideHandler'];

            _this.setState(state);

            if (triggerSlideHandler === undefined) return;

            _this.slideHandler(triggerSlideHandler);
          };

          _this.slickPrev = function () {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function () {
              return _this.changeSlide({
                message: 'previous'
              });
            }, 0));
          };

          _this.slickNext = function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.changeSlide({
                message: 'next'
              });
            }, 0));
          };

          _this.slickGoTo = function (slide) {
            slide = Number(slide);
            if (isNaN(slide)) return '';

            _this.callbackTimers.push(setTimeout(function () {
              return _this.changeSlide({
                message: 'index',
                index: slide,
                currentSlide: _this.state.currentSlide
              });
            }, 0));
          };

          _this.play = function () {
            var nextIndex;

            if (_this.props.rtl) {
              nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            } else {
              if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
                nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
              } else {
                return false;
              }
            }

            _this.slideHandler(nextIndex);
          };

          _this.autoPlay = function (playType) {
            if (_this.autoplayTimer) {
              console.warn("autoPlay is triggered more than once");
              clearInterval(_this.autoplayTimer);
            }

            var autoplaying = _this.state.autoplaying;

            if (playType === 'update') {
              if (autoplaying === 'hovered' || autoplaying === 'focused' || autoplaying === 'paused') {
                return;
              }
            } else if (playType === 'leave') {
              if (autoplaying === 'paused' || autoplaying === 'focused') {
                return;
              }
            } else if (playType === 'blur') {
              if (autoplaying === 'paused' || autoplaying === 'hovered') {
                return;
              }
            }

            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

            _this.setState({
              autoplaying: 'playing'
            });
          };

          _this.pause = function (pauseType) {
            if (_this.autoplayTimer) {
              clearInterval(_this.autoplayTimer);
              _this.autoplayTimer = null;
            }

            var autoplaying = _this.state.autoplaying;

            if (pauseType === 'paused') {
              _this.setState({
                autoplaying: 'paused'
              });
            } else if (pauseType === 'focused') {
              if (autoplaying === 'hovered' || autoplaying === 'playing') {
                _this.setState({
                  autoplaying: 'focused'
                });
              }
            } else {
              // pauseType  is 'hovered'
              if (autoplaying === 'playing') {
                _this.setState({
                  autoplaying: 'hovered'
                });
              }
            }
          };

          _this.onDotsOver = function (e) {
            return _this.props.autoplay && _this.pause('hovered');
          };

          _this.onDotsLeave = function (e) {
            return _this.props.autoplay && _this.state.autoplaying === 'hovered' && _this.autoPlay('leave');
          };

          _this.onTrackOver = function (e) {
            return _this.props.autoplay && _this.pause('hovered');
          };

          _this.onTrackLeave = function (e) {
            return _this.props.autoplay && _this.state.autoplaying === 'hovered' && _this.autoPlay('leave');
          };

          _this.onSlideFocus = function (e) {
            return _this.props.autoplay && _this.pause('focused');
          };

          _this.onSlideBlur = function (e) {
            return _this.props.autoplay && _this.state.autoplaying === 'focused' && _this.autoPlay('blur');
          };

          _this.render = function () {
            var className = (0, _classnames2.default)('regular', 'slider', 'slick-initialized', 'slick-slider', _this.props.className, {
              'slick-vertical': _this.props.vertical
            });

            var spec = _extends({}, _this.props, _this.state);

            var trackProps = (0, _innerSliderUtils.extractObject)(spec, ['fade', 'cssEase', 'speed', 'infinite', 'centerMode', 'focusOnSelect', 'currentSlide', 'lazyLoad', 'lazyLoadedList', 'rtl', 'slideWidth', 'slideHeight', 'listHeight', 'vertical', 'slidesToShow', 'slidesToScroll', 'slideCount', 'trackStyle', 'variableWidth', 'unslick', 'centerPadding']);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = _extends({}, trackProps, {
              onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
              onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
              onMouseOver: pauseOnHover ? _this.onTrackOver : null,
              focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
            });
            var dots;

            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
              var dotProps = (0, _innerSliderUtils.extractObject)(spec, ['dotsClass', 'slideCount', 'slidesToShow', 'currentSlide', 'slidesToScroll', 'clickHandler', 'children', 'customPaging', 'infinite', 'appendDots']);
              var pauseOnDotsHover = _this.props.pauseOnDotsHover;
              dotProps = _extends({}, dotProps, {
                clickHandler: _this.changeSlide,
                onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
              });
              dots = _react2.default.createElement(_dots.Dots, dotProps);
            }

            var prevArrow, nextArrow;
            var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ['infinite', 'centerMode', 'currentSlide', 'slideCount', 'slidesToShow', 'prevArrow', 'nextArrow']);
            arrowProps.clickHandler = _this.changeSlide;

            if (_this.props.arrows) {
              prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
              nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
            }

            var verticalHeightStyle = null;

            if (_this.props.vertical) {
              verticalHeightStyle = {
                height: _this.state.listHeight
              };
            }

            var centerPaddingStyle = null;

            if (_this.props.vertical === false) {
              if (_this.props.centerMode === true) {
                centerPaddingStyle = {
                  padding: '0px ' + _this.props.centerPadding
                };
              }
            } else {
              if (_this.props.centerMode === true) {
                centerPaddingStyle = {
                  padding: _this.props.centerPadding + ' 0px'
                };
              }
            }

            var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);

            var touchMove = _this.props.touchMove;
            var listProps = {
              className: 'slick-list',
              style: listStyle,
              onMouseDown: touchMove ? _this.swipeStart : null,
              onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
              onMouseUp: touchMove ? _this.swipeEnd : null,
              onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
              onTouchStart: touchMove ? _this.swipeStart : null,
              onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
              onTouchEnd: touchMove ? _this.swipeEnd : null,
              onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
              onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
              className: className,
              dir: 'ltr'
            };

            if (_this.props.unslick) {
              listProps = {
                className: 'slick-list'
              };
              innerSliderProps = {
                className: className
              };
            }

            return _react2.default.createElement('div', innerSliderProps, !_this.props.unslick ? prevArrow : '', _react2.default.createElement('div', _extends({
              ref: _this.listRefHandler
            }, listProps), _react2.default.createElement(_track.Track, _extends({
              ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : '', !_this.props.unslick ? dots : '');
          };

          _this.list = null;
          _this.track = null;
          _this.state = _extends({}, _initialState2.default, {
            currentSlide: _this.props.initialSlide
          });
          _this.callbackTimers = [];
          return _this;
        }

        return InnerSlider;
      }(_react2.default.Component);
      /***/

    },
    /* 1105 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _innerSlider = __webpack_require__(1104);

      var _json2mq = __webpack_require__(1098);

      var _json2mq2 = _interopRequireDefault(_json2mq);

      var _defaultProps = __webpack_require__(512);

      var _defaultProps2 = _interopRequireDefault(_defaultProps);

      var _canUseDom = __webpack_require__(1096);

      var _canUseDom2 = _interopRequireDefault(_canUseDom);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var enquire = _canUseDom2.default && __webpack_require__(511);

      var Slider = function (_React$Component) {
        _inherits(Slider, _React$Component);

        function Slider(props) {
          _classCallCheck(this, Slider);

          var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

          _this.innerSliderRefHandler = function (ref) {
            return _this.innerSlider = ref;
          };

          _this.slickPrev = function () {
            return _this.innerSlider.slickPrev();
          };

          _this.slickNext = function () {
            return _this.innerSlider.slickNext();
          };

          _this.slickGoTo = function (slide) {
            return _this.innerSlider.slickGoTo(slide);
          };

          _this.slickPause = function () {
            return _this.innerSlider.pause('paused');
          };

          _this.slickPlay = function () {
            return _this.innerSlider.autoPlay('play');
          };

          _this.state = {
            breakpoint: null
          };
          _this._responsiveMediaHandlers = [];
          return _this;
        }

        Slider.prototype.media = function media(query, handler) {
          // javascript handler for  css media query
          enquire.register(query, handler);

          this._responsiveMediaHandlers.push({
            query: query,
            handler: handler
          });
        }; // handles responsive breakpoints


        Slider.prototype.componentWillMount = function componentWillMount() {
          var _this2 = this;

          if (this.props.responsive) {
            var breakpoints = this.props.responsive.map(function (breakpt) {
              return breakpt.breakpoint;
            }); // sort them in increasing order of their numerical value

            breakpoints.sort(function (x, y) {
              return x - y;
            });
            breakpoints.forEach(function (breakpoint, index) {
              // media query for each breakpoint
              var bQuery = void 0;

              if (index === 0) {
                bQuery = (0, _json2mq2.default)({
                  minWidth: 0,
                  maxWidth: breakpoint
                });
              } else {
                bQuery = (0, _json2mq2.default)({
                  minWidth: breakpoints[index - 1] + 1,
                  maxWidth: breakpoint
                });
              } // when not using server side rendering


              _canUseDom2.default && _this2.media(bQuery, function () {
                _this2.setState({
                  breakpoint: breakpoint
                });
              });
            }); // Register media query for full screen. Need to support resize from small to large
            // convert javascript object to media query string

            var query = (0, _json2mq2.default)({
              minWidth: breakpoints.slice(-1)[0]
            });
            _canUseDom2.default && this.media(query, function () {
              _this2.setState({
                breakpoint: null
              });
            });
          }
        };

        Slider.prototype.componentWillUnmount = function componentWillUnmount() {
          this._responsiveMediaHandlers.forEach(function (obj) {
            enquire.unregister(obj.query, obj.handler);
          });
        };

        Slider.prototype.render = function render() {
          var _this3 = this;

          var settings;
          var newProps;

          if (this.state.breakpoint) {
            newProps = this.props.responsive.filter(function (resp) {
              return resp.breakpoint === _this3.state.breakpoint;
            });
            settings = newProps[0].settings === 'unslick' ? 'unslick' : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
          } else {
            settings = _extends({}, _defaultProps2.default, this.props);
          } // force scrolling by one if centerMode is on


          if (settings.centerMode) {
            if (settings.slidesToScroll > 1 && "production" !== 'production') {
              console.warn('slidesToScroll should be equal to 1 in centerMode, you are using ' + settings.slidesToScroll);
            }

            settings.slidesToScroll = 1;
          } // force showing one slide and scrolling by one if the fade mode is on


          if (settings.fade) {
            if (settings.slidesToShow > 1 && "production" !== 'production') {
              console.warn('slidesToShow should be equal to 1 when fade is true, you\'re using ' + settings.slidesToShow);
            }

            if (settings.slidesToScroll > 1 && "production" !== 'production') {
              console.warn('slidesToScroll should be equal to 1 when fade is true, you\'re using ' + settings.slidesToScroll);
            }

            settings.slidesToShow = 1;
            settings.slidesToScroll = 1;
          } // makes sure that children is an array, even when there is only 1 child


          var children = _react2.default.Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
          // children may also contain string filled with spaces (in certain cases where we use jsx strings)


          children = children.filter(function (child) {
            if (typeof child === 'string') {
              return !!child.trim();
            }

            return !!child;
          });

          if (settings === 'unslick') {
            var className = 'regular slider ' + (this.props.className || '');
            return _react2.default.createElement('div', {
              className: className
            }, children);
          } else if (children.length <= settings.slidesToShow) {
            settings.unslick = true;
          }

          return _react2.default.createElement(_innerSlider.InnerSlider, _extends({
            ref: this.innerSliderRefHandler
          }, settings), children);
        };

        return Slider;
      }(_react2.default.Component);

      exports.default = Slider;
      /***/
    },
    /* 1106 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _slider = __webpack_require__(1105);

      var _slider2 = _interopRequireDefault(_slider);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = _slider2.default;
      /***/
    },
    /* 1107 */

    /***/
    function (module, exports) {
      /** Used for built-in method references. */
      var objectProto = Object.prototype;
      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */

      var nativeObjectToString = objectProto.toString;
      /**
       * Converts `value` to a string using `Object.prototype.toString`.
       *
       * @private
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       */

      function objectToString(value) {
        return nativeObjectToString.call(value);
      }

      module.exports = objectToString;
      /***/
    },
    /* 1108 */

    /***/
    function (module, exports, __webpack_require__) {
      var Symbol = __webpack_require__(158);
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */

      var nativeObjectToString = objectProto.toString;
      /** Built-in value references. */

      var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
      /**
       * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the raw `toStringTag`.
       */

      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];

        try {
          value[symToStringTag] = undefined;
          var unmasked = true;
        } catch (e) {}

        var result = nativeObjectToString.call(value);

        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }

        return result;
      }

      module.exports = getRawTag;
      /***/
    },
    /* 1109 */

    /***/
    function (module, exports, __webpack_require__) {
      var root = __webpack_require__(103);
      /**
       * Gets the timestamp of the number of milliseconds that have elapsed since
       * the Unix epoch (1 January 1970 00:00:00 UTC).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Date
       * @returns {number} Returns the timestamp.
       * @example
       *
       * _.defer(function(stamp) {
       *   console.log(_.now() - stamp);
       * }, _.now());
       * // => Logs the number of milliseconds it took for the deferred invocation.
       */


      var now = function now() {
        return root.Date.now();
      };

      module.exports = now;
      /***/
    },
    /* 1110 */

    /***/
    function (module, exports) {
      /**
       * lodash 3.0.4 (Custom Build) <https://lodash.com/>
       * Build: `lodash modern modularize exports="npm" -o ./`
       * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       * Available under MIT license <https://lodash.com/license>
       */

      /** `Object#toString` result references. */
      var arrayTag = '[object Array]',
          funcTag = '[object Function]';
      /** Used to detect host constructors (Safari > 5). */

      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      /**
       * Checks if `value` is object-like.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       */

      function isObjectLike(value) {
        return !!value && typeof value == 'object';
      }
      /** Used for native method references. */


      var objectProto = Object.prototype;
      /** Used to resolve the decompiled source of functions. */

      var fnToString = Function.prototype.toString;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
       * of values.
       */

      var objToString = objectProto.toString;
      /** Used to detect if a method is native. */

      var reIsNative = RegExp('^' + fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
      /* Native method references for those with the same name as other `lodash` methods. */

      var nativeIsArray = getNative(Array, 'isArray');
      /**
       * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
       * of an array-like value.
       */

      var MAX_SAFE_INTEGER = 9007199254740991;
      /**
       * Gets the native function at `key` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the method to get.
       * @returns {*} Returns the function if it's native, else `undefined`.
       */

      function getNative(object, key) {
        var value = object == null ? undefined : object[key];
        return isNative(value) ? value : undefined;
      }
      /**
       * Checks if `value` is a valid array-like length.
       *
       * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
       */


      function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      /**
       * Checks if `value` is classified as an `Array` object.
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
       * @example
       *
       * _.isArray([1, 2, 3]);
       * // => true
       *
       * _.isArray(function() { return arguments; }());
       * // => false
       */


      var isArray = nativeIsArray || function (value) {
        return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
      };
      /**
       * Checks if `value` is classified as a `Function` object.
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
       * @example
       *
       * _.isFunction(_);
       * // => true
       *
       * _.isFunction(/abc/);
       * // => false
       */


      function isFunction(value) {
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in older versions of Chrome and Safari which return 'function' for regexes
        // and Safari 8 equivalents which return 'object' for typed array constructors.
        return isObject(value) && objToString.call(value) == funcTag;
      }
      /**
       * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
       * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(1);
       * // => false
       */


      function isObject(value) {
        // Avoid a V8 JIT bug in Chrome 19-20.
        // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
      }
      /**
       * Checks if `value` is a native function.
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
       * @example
       *
       * _.isNative(Array.prototype.push);
       * // => true
       *
       * _.isNative(_);
       * // => false
       */


      function isNative(value) {
        if (value == null) {
          return false;
        }

        if (isFunction(value)) {
          return reIsNative.test(fnToString.call(value));
        }

        return isObjectLike(value) && reIsHostCtor.test(value);
      }

      module.exports = isArray;
      /***/
    },
    /* 1111 */

    /***/
    function (module, exports) {
      /**
       * lodash (Custom Build) <https://lodash.com/>
       * Build: `lodash modularize exports="npm" -o ./`
       * Copyright jQuery Foundation and other contributors <https://jquery.org/>
       * Released under MIT license <https://lodash.com/license>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       */

      /** Used as references for various `Number` constants. */
      var MAX_SAFE_INTEGER = 9007199254740991;
      /** `Object#toString` result references. */

      var argsTag = '[object Arguments]',
          funcTag = '[object Function]',
          genTag = '[object GeneratorFunction]';
      /** Used for built-in method references. */

      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */

      var objectToString = objectProto.toString;
      /** Built-in value references. */

      var propertyIsEnumerable = objectProto.propertyIsEnumerable;
      /**
       * Checks if `value` is likely an `arguments` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       *  else `false`.
       * @example
       *
       * _.isArguments(function() { return arguments; }());
       * // => true
       *
       * _.isArguments([1, 2, 3]);
       * // => false
       */

      function isArguments(value) {
        // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
        return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
      }
      /**
       * Checks if `value` is array-like. A value is considered array-like if it's
       * not a function and has a `value.length` that's an integer greater than or
       * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
       * @example
       *
       * _.isArrayLike([1, 2, 3]);
       * // => true
       *
       * _.isArrayLike(document.body.children);
       * // => true
       *
       * _.isArrayLike('abc');
       * // => true
       *
       * _.isArrayLike(_.noop);
       * // => false
       */


      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }
      /**
       * This method is like `_.isArrayLike` except that it also checks if `value`
       * is an object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array-like object,
       *  else `false`.
       * @example
       *
       * _.isArrayLikeObject([1, 2, 3]);
       * // => true
       *
       * _.isArrayLikeObject(document.body.children);
       * // => true
       *
       * _.isArrayLikeObject('abc');
       * // => false
       *
       * _.isArrayLikeObject(_.noop);
       * // => false
       */


      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      /**
       * Checks if `value` is classified as a `Function` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a function, else `false`.
       * @example
       *
       * _.isFunction(_);
       * // => true
       *
       * _.isFunction(/abc/);
       * // => false
       */


      function isFunction(value) {
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 8-9 which returns 'object' for typed array and other constructors.
        var tag = isObject(value) ? objectToString.call(value) : '';
        return tag == funcTag || tag == genTag;
      }
      /**
       * Checks if `value` is a valid array-like length.
       *
       * **Note:** This method is loosely based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
       * @example
       *
       * _.isLength(3);
       * // => true
       *
       * _.isLength(Number.MIN_VALUE);
       * // => false
       *
       * _.isLength(Infinity);
       * // => false
       *
       * _.isLength('3');
       * // => false
       */


      function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      /**
       * Checks if `value` is the
       * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
       * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(_.noop);
       * // => true
       *
       * _.isObject(null);
       * // => false
       */


      function isObject(value) {
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
      }
      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */


      function isObjectLike(value) {
        return !!value && typeof value == 'object';
      }

      module.exports = isArguments;
      /***/
    },
    /* 1112 */

    /***/
    function (module, exports) {
      /**
       * lodash 3.9.1 (Custom Build) <https://lodash.com/>
       * Build: `lodash modern modularize exports="npm" -o ./`
       * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       * Available under MIT license <https://lodash.com/license>
       */

      /** `Object#toString` result references. */
      var funcTag = '[object Function]';
      /** Used to detect host constructors (Safari > 5). */

      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      /**
       * Checks if `value` is object-like.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       */

      function isObjectLike(value) {
        return !!value && typeof value == 'object';
      }
      /** Used for native method references. */


      var objectProto = Object.prototype;
      /** Used to resolve the decompiled source of functions. */

      var fnToString = Function.prototype.toString;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
       * of values.
       */

      var objToString = objectProto.toString;
      /** Used to detect if a method is native. */

      var reIsNative = RegExp('^' + fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
      /**
       * Gets the native function at `key` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the method to get.
       * @returns {*} Returns the function if it's native, else `undefined`.
       */

      function getNative(object, key) {
        var value = object == null ? undefined : object[key];
        return isNative(value) ? value : undefined;
      }
      /**
       * Checks if `value` is classified as a `Function` object.
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
       * @example
       *
       * _.isFunction(_);
       * // => true
       *
       * _.isFunction(/abc/);
       * // => false
       */


      function isFunction(value) {
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in older versions of Chrome and Safari which return 'function' for regexes
        // and Safari 8 equivalents which return 'object' for typed array constructors.
        return isObject(value) && objToString.call(value) == funcTag;
      }
      /**
       * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
       * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(1);
       * // => false
       */


      function isObject(value) {
        // Avoid a V8 JIT bug in Chrome 19-20.
        // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
      }
      /**
       * Checks if `value` is a native function.
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
       * @example
       *
       * _.isNative(Array.prototype.push);
       * // => true
       *
       * _.isNative(_);
       * // => false
       */


      function isNative(value) {
        if (value == null) {
          return false;
        }

        if (isFunction(value)) {
          return reIsNative.test(fnToString.call(value));
        }

        return isObjectLike(value) && reIsHostCtor.test(value);
      }

      module.exports = getNative;
      /***/
    },
    /* 1113 */

    /***/
    function (module, exports, __webpack_require__) {
      /**
       * lodash 3.1.2 (Custom Build) <https://lodash.com/>
       * Build: `lodash modern modularize exports="npm" -o ./`
       * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       * Available under MIT license <https://lodash.com/license>
       */
      var getNative = __webpack_require__(1112),
          isArguments = __webpack_require__(1111),
          isArray = __webpack_require__(1110);
      /** Used to detect unsigned integer values. */


      var reIsUint = /^\d+$/;
      /** Used for native method references. */

      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /* Native method references for those with the same name as other `lodash` methods. */

      var nativeKeys = getNative(Object, 'keys');
      /**
       * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
       * of an array-like value.
       */

      var MAX_SAFE_INTEGER = 9007199254740991;
      /**
       * The base implementation of `_.property` without support for deep paths.
       *
       * @private
       * @param {string} key The key of the property to get.
       * @returns {Function} Returns the new function.
       */

      function baseProperty(key) {
        return function (object) {
          return object == null ? undefined : object[key];
        };
      }
      /**
       * Gets the "length" property value of `object`.
       *
       * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
       * that affects Safari on at least iOS 8.1-8.3 ARM64.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {*} Returns the "length" value.
       */


      var getLength = baseProperty('length');
      /**
       * Checks if `value` is array-like.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
       */

      function isArrayLike(value) {
        return value != null && isLength(getLength(value));
      }
      /**
       * Checks if `value` is a valid array-like index.
       *
       * @private
       * @param {*} value The value to check.
       * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
       * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
       */


      function isIndex(value, length) {
        value = typeof value == 'number' || reIsUint.test(value) ? +value : -1;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return value > -1 && value % 1 == 0 && value < length;
      }
      /**
       * Checks if `value` is a valid array-like length.
       *
       * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
       */


      function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      /**
       * A fallback implementation of `Object.keys` which creates an array of the
       * own enumerable property names of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */


      function shimKeys(object) {
        var props = keysIn(object),
            propsLength = props.length,
            length = propsLength && object.length;
        var allowIndexes = !!length && isLength(length) && (isArray(object) || isArguments(object));
        var index = -1,
            result = [];

        while (++index < propsLength) {
          var key = props[index];

          if (allowIndexes && isIndex(key, length) || hasOwnProperty.call(object, key)) {
            result.push(key);
          }
        }

        return result;
      }
      /**
       * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
       * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(1);
       * // => false
       */


      function isObject(value) {
        // Avoid a V8 JIT bug in Chrome 19-20.
        // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
      }
      /**
       * Creates an array of the own enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects. See the
       * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
       * for more details.
       *
       * @static
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keys(new Foo);
       * // => ['a', 'b'] (iteration order is not guaranteed)
       *
       * _.keys('hi');
       * // => ['0', '1']
       */


      var keys = !nativeKeys ? shimKeys : function (object) {
        var Ctor = object == null ? undefined : object.constructor;

        if (typeof Ctor == 'function' && Ctor.prototype === object || typeof object != 'function' && isArrayLike(object)) {
          return shimKeys(object);
        }

        return isObject(object) ? nativeKeys(object) : [];
      };
      /**
       * Creates an array of the own and inherited enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keysIn(new Foo);
       * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
       */

      function keysIn(object) {
        if (object == null) {
          return [];
        }

        if (!isObject(object)) {
          object = Object(object);
        }

        var length = object.length;
        length = length && isLength(length) && (isArray(object) || isArguments(object)) && length || 0;
        var Ctor = object.constructor,
            index = -1,
            isProto = typeof Ctor == 'function' && Ctor.prototype === object,
            result = Array(length),
            skipIndexes = length > 0;

        while (++index < length) {
          result[index] = index + '';
        }

        for (var key in object) {
          if (!(skipIndexes && isIndex(key, length)) && !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
          }
        }

        return result;
      }

      module.exports = keys;
      /***/
    },
    /* 1114 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var fetchKeys = __webpack_require__(1113);

      module.exports = function shallowEqual(objA, objB, compare, compareContext) {
        var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

        if (ret !== void 0) {
          return !!ret;
        }

        if (objA === objB) {
          return true;
        }

        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
          return false;
        }

        var keysA = fetchKeys(objA);
        var keysB = fetchKeys(objB);
        var len = keysA.length;

        if (len !== keysB.length) {
          return false;
        }

        compareContext = compareContext || null; // Test for A's keys different from B.

        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

        for (var i = 0; i < len; i++) {
          var key = keysA[i];

          if (!bHasOwnProperty(key)) {
            return false;
          }

          var valueA = objA[key];
          var valueB = objB[key];

          var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

          if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
          }
        }

        return true;
      };
      /***/

    },
    /* 1115 */

    /***/
    function (module, exports, __webpack_require__) {
      var map = {
        "./af": 641,
        "./af.js": 641,
        "./ar": 640,
        "./ar-dz": 639,
        "./ar-dz.js": 639,
        "./ar-kw": 638,
        "./ar-kw.js": 638,
        "./ar-ly": 637,
        "./ar-ly.js": 637,
        "./ar-ma": 636,
        "./ar-ma.js": 636,
        "./ar-sa": 635,
        "./ar-sa.js": 635,
        "./ar-tn": 634,
        "./ar-tn.js": 634,
        "./ar.js": 640,
        "./az": 633,
        "./az.js": 633,
        "./be": 632,
        "./be.js": 632,
        "./bg": 631,
        "./bg.js": 631,
        "./bm": 630,
        "./bm.js": 630,
        "./bn": 629,
        "./bn.js": 629,
        "./bo": 628,
        "./bo.js": 628,
        "./br": 627,
        "./br.js": 627,
        "./bs": 626,
        "./bs.js": 626,
        "./ca": 625,
        "./ca.js": 625,
        "./cs": 624,
        "./cs.js": 624,
        "./cv": 623,
        "./cv.js": 623,
        "./cy": 622,
        "./cy.js": 622,
        "./da": 621,
        "./da.js": 621,
        "./de": 620,
        "./de-at": 619,
        "./de-at.js": 619,
        "./de-ch": 618,
        "./de-ch.js": 618,
        "./de.js": 620,
        "./dv": 617,
        "./dv.js": 617,
        "./el": 616,
        "./el.js": 616,
        "./en-SG": 615,
        "./en-SG.js": 615,
        "./en-au": 614,
        "./en-au.js": 614,
        "./en-ca": 613,
        "./en-ca.js": 613,
        "./en-gb": 612,
        "./en-gb.js": 612,
        "./en-ie": 611,
        "./en-ie.js": 611,
        "./en-il": 610,
        "./en-il.js": 610,
        "./en-nz": 609,
        "./en-nz.js": 609,
        "./eo": 608,
        "./eo.js": 608,
        "./es": 607,
        "./es-do": 606,
        "./es-do.js": 606,
        "./es-us": 605,
        "./es-us.js": 605,
        "./es.js": 607,
        "./et": 604,
        "./et.js": 604,
        "./eu": 603,
        "./eu.js": 603,
        "./fa": 602,
        "./fa.js": 602,
        "./fi": 601,
        "./fi.js": 601,
        "./fo": 600,
        "./fo.js": 600,
        "./fr": 599,
        "./fr-ca": 598,
        "./fr-ca.js": 598,
        "./fr-ch": 597,
        "./fr-ch.js": 597,
        "./fr.js": 599,
        "./fy": 596,
        "./fy.js": 596,
        "./ga": 595,
        "./ga.js": 595,
        "./gd": 594,
        "./gd.js": 594,
        "./gl": 593,
        "./gl.js": 593,
        "./gom-latn": 592,
        "./gom-latn.js": 592,
        "./gu": 591,
        "./gu.js": 591,
        "./he": 590,
        "./he.js": 590,
        "./hi": 589,
        "./hi.js": 589,
        "./hr": 588,
        "./hr.js": 588,
        "./hu": 587,
        "./hu.js": 587,
        "./hy-am": 586,
        "./hy-am.js": 586,
        "./id": 585,
        "./id.js": 585,
        "./is": 584,
        "./is.js": 584,
        "./it": 583,
        "./it-ch": 582,
        "./it-ch.js": 582,
        "./it.js": 583,
        "./ja": 581,
        "./ja.js": 581,
        "./jv": 580,
        "./jv.js": 580,
        "./ka": 579,
        "./ka.js": 579,
        "./kk": 578,
        "./kk.js": 578,
        "./km": 577,
        "./km.js": 577,
        "./kn": 576,
        "./kn.js": 576,
        "./ko": 575,
        "./ko.js": 575,
        "./ku": 574,
        "./ku.js": 574,
        "./ky": 573,
        "./ky.js": 573,
        "./lb": 572,
        "./lb.js": 572,
        "./lo": 571,
        "./lo.js": 571,
        "./lt": 570,
        "./lt.js": 570,
        "./lv": 569,
        "./lv.js": 569,
        "./me": 568,
        "./me.js": 568,
        "./mi": 567,
        "./mi.js": 567,
        "./mk": 566,
        "./mk.js": 566,
        "./ml": 565,
        "./ml.js": 565,
        "./mn": 564,
        "./mn.js": 564,
        "./mr": 563,
        "./mr.js": 563,
        "./ms": 562,
        "./ms-my": 561,
        "./ms-my.js": 561,
        "./ms.js": 562,
        "./mt": 560,
        "./mt.js": 560,
        "./my": 559,
        "./my.js": 559,
        "./nb": 558,
        "./nb.js": 558,
        "./ne": 557,
        "./ne.js": 557,
        "./nl": 556,
        "./nl-be": 555,
        "./nl-be.js": 555,
        "./nl.js": 556,
        "./nn": 554,
        "./nn.js": 554,
        "./pa-in": 553,
        "./pa-in.js": 553,
        "./pl": 552,
        "./pl.js": 552,
        "./pt": 551,
        "./pt-br": 550,
        "./pt-br.js": 550,
        "./pt.js": 551,
        "./ro": 549,
        "./ro.js": 549,
        "./ru": 548,
        "./ru.js": 548,
        "./sd": 547,
        "./sd.js": 547,
        "./se": 546,
        "./se.js": 546,
        "./si": 545,
        "./si.js": 545,
        "./sk": 544,
        "./sk.js": 544,
        "./sl": 543,
        "./sl.js": 543,
        "./sq": 542,
        "./sq.js": 542,
        "./sr": 541,
        "./sr-cyrl": 540,
        "./sr-cyrl.js": 540,
        "./sr.js": 541,
        "./ss": 539,
        "./ss.js": 539,
        "./sv": 538,
        "./sv.js": 538,
        "./sw": 537,
        "./sw.js": 537,
        "./ta": 536,
        "./ta.js": 536,
        "./te": 535,
        "./te.js": 535,
        "./tet": 534,
        "./tet.js": 534,
        "./tg": 533,
        "./tg.js": 533,
        "./th": 532,
        "./th.js": 532,
        "./tl-ph": 531,
        "./tl-ph.js": 531,
        "./tlh": 530,
        "./tlh.js": 530,
        "./tr": 529,
        "./tr.js": 529,
        "./tzl": 528,
        "./tzl.js": 528,
        "./tzm": 527,
        "./tzm-latn": 526,
        "./tzm-latn.js": 526,
        "./tzm.js": 527,
        "./ug-cn": 525,
        "./ug-cn.js": 525,
        "./uk": 524,
        "./uk.js": 524,
        "./ur": 523,
        "./ur.js": 523,
        "./uz": 522,
        "./uz-latn": 521,
        "./uz-latn.js": 521,
        "./uz.js": 522,
        "./vi": 520,
        "./vi.js": 520,
        "./x-pseudo": 519,
        "./x-pseudo.js": 519,
        "./yo": 518,
        "./yo.js": 518,
        "./zh-cn": 517,
        "./zh-cn.js": 517,
        "./zh-hk": 516,
        "./zh-hk.js": 516,
        "./zh-tw": 515,
        "./zh-tw.js": 515
      };

      function webpackContext(req) {
        var id = webpackContextResolve(req);

        var module = __webpack_require__(id);

        return module;
      }

      function webpackContextResolve(req) {
        var id = map[req];

        if (!(id + 1)) {
          // check for number or string
          var e = new Error('Cannot find module "' + req + '".');
          e.code = 'MODULE_NOT_FOUND';
          throw e;
        }

        return id;
      }

      webpackContext.keys = function webpackContextKeys() {
        return Object.keys(map);
      };

      webpackContext.resolve = webpackContextResolve;
      module.exports = webpackContext;
      webpackContext.id = 1115;
      /***/
    },
    /* 1116 */

    /***/
    function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(161);

      var get = __webpack_require__(645);

      module.exports = __webpack_require__(89).getIterator = function (it) {
        var iterFn = get(it);
        if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
        return anObject(iterFn.call(it));
      };
      /***/

    },
    /* 1117 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(358);

      __webpack_require__(256);

      module.exports = __webpack_require__(1116);
      /***/
    },
    /* 1118 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1117),
        __esModule: true
      };
      /***/
    },
    /* 1119 */

    /***/
    function (module, exports, __webpack_require__) {
      var classof = __webpack_require__(644);

      var ITERATOR = __webpack_require__(110)('iterator');

      var Iterators = __webpack_require__(178);

      module.exports = __webpack_require__(89).isIterable = function (it) {
        var O = Object(it);
        return O[ITERATOR] !== undefined || '@@iterator' in O // eslint-disable-next-line no-prototype-builtins
        || Iterators.hasOwnProperty(classof(O));
      };
      /***/

    },
    /* 1120 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(358);

      __webpack_require__(256);

      module.exports = __webpack_require__(1119);
      /***/
    },
    /* 1121 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1120),
        __esModule: true
      };
      /***/
    },
    /* 1122 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
      };

      var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

      function getClientPosition(elem) {
        var box = undefined;
        var x = undefined;
        var y = undefined;
        var doc = elem.ownerDocument;
        var body = doc.body;
        var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

        box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
        // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
        // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

        x = box.left;
        y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
        // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
        // IE6 standards mode, this border can be overridden by setting the
        // document element's border to zero -- thus, we cannot rely on the
        // offset always being 2 pixels.
        // In quirks mode, the offset can be determined by querying the body's
        // clientLeft/clientTop, but in standards mode, it is found by querying
        // the document element's clientLeft/clientTop.  Since we already called
        // getClientBoundingRect we have already forced a reflow, so it is not
        // too expensive just to query them all.
        // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
        // 窗口边框标准是设 documentElement ,quirks 时设置 body
        // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
        // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
        // 标准 ie 下 docElem.clientTop 就是 border-top
        // ie7 html 即窗口边框改变不了。永远为 2
        // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

        x -= docElem.clientLeft || body.clientLeft || 0;
        y -= docElem.clientTop || body.clientTop || 0;
        return {
          left: x,
          top: y
        };
      }

      function getScroll(w, top) {
        var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
        var method = 'scroll' + (top ? 'Top' : 'Left');

        if (typeof ret !== 'number') {
          var d = w.document; // ie6,7,8 standard mode

          ret = d.documentElement[method];

          if (typeof ret !== 'number') {
            // quirks mode
            ret = d.body[method];
          }
        }

        return ret;
      }

      function getScrollLeft(w) {
        return getScroll(w);
      }

      function getScrollTop(w) {
        return getScroll(w, true);
      }

      function getOffset(el) {
        var pos = getClientPosition(el);
        var doc = el.ownerDocument;
        var w = doc.defaultView || doc.parentWindow;
        pos.left += getScrollLeft(w);
        pos.top += getScrollTop(w);
        return pos;
      }

      function _getComputedStyle(elem, name, computedStyle_) {
        var val = '';
        var d = elem.ownerDocument;
        var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

        if (computedStyle) {
          val = computedStyle.getPropertyValue(name) || computedStyle[name];
        }

        return val;
      }

      var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');

      var RE_POS = /^(top|right|bottom|left)$/;
      var CURRENT_STYLE = 'currentStyle';
      var RUNTIME_STYLE = 'runtimeStyle';
      var LEFT = 'left';
      var PX = 'px';

      function _getComputedStyleIE(elem, name) {
        // currentStyle maybe null
        // http://msdn.microsoft.com/en-us/library/ms535231.aspx
        var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
        // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
        // 在 ie 下不对，需要直接用 offset 方式
        // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
        // From the awesome hack by Dean Edwards
        // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
        // If we're not dealing with a regular pixel number
        // but a number that has a weird ending, we need to convert it to pixels
        // exclude left right for relativity

        if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
          // Remember the original values
          var style = elem.style;
          var left = style[LEFT];
          var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

          elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

          style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
          ret = style.pixelLeft + PX; // Revert the changed values

          style[LEFT] = left;
          elem[RUNTIME_STYLE][LEFT] = rsLeft;
        }

        return ret === '' ? 'auto' : ret;
      }

      var getComputedStyleX = undefined;

      if (typeof window !== 'undefined') {
        getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
      }

      function each(arr, fn) {
        for (var i = 0; i < arr.length; i++) {
          fn(arr[i]);
        }
      }

      function isBorderBoxFn(elem) {
        return getComputedStyleX(elem, 'boxSizing') === 'border-box';
      }

      var BOX_MODELS = ['margin', 'border', 'padding'];
      var CONTENT_INDEX = -1;
      var PADDING_INDEX = 2;
      var BORDER_INDEX = 1;
      var MARGIN_INDEX = 0;

      function swap(elem, options, callback) {
        var old = {};
        var style = elem.style;
        var name = undefined; // Remember the old values, and insert the new ones

        for (name in options) {
          if (options.hasOwnProperty(name)) {
            old[name] = style[name];
            style[name] = options[name];
          }
        }

        callback.call(elem); // Revert the old values

        for (name in options) {
          if (options.hasOwnProperty(name)) {
            style[name] = old[name];
          }
        }
      }

      function getPBMWidth(elem, props, which) {
        var value = 0;
        var prop = undefined;
        var j = undefined;
        var i = undefined;

        for (j = 0; j < props.length; j++) {
          prop = props[j];

          if (prop) {
            for (i = 0; i < which.length; i++) {
              var cssProp = undefined;

              if (prop === 'border') {
                cssProp = prop + which[i] + 'Width';
              } else {
                cssProp = prop + which[i];
              }

              value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
            }
          }
        }

        return value;
      }
      /**
       * A crude way of determining if an object is a window
       * @member util
       */


      function isWindow(obj) {
        // must use == for ie8

        /* eslint eqeqeq:0 */
        return obj != null && obj == obj.window;
      }

      var domUtils = {};
      each(['Width', 'Height'], function (name) {
        domUtils['doc' + name] = function (refWin) {
          var d = refWin.document;
          return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
          // ie standard mode : documentElement.scrollHeight> body.scrollHeight
          d.documentElement['scroll' + name], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
          d.body['scroll' + name], domUtils['viewport' + name](d));
        };

        domUtils['viewport' + name] = function (win) {
          // pc browser includes scrollbar in window.innerWidth
          var prop = 'client' + name;
          var doc = win.document;
          var body = doc.body;
          var documentElement = doc.documentElement;
          var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
          // backcompat 取 body

          return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
        };
      });
      /*
       得到元素的大小信息
       @param elem
       @param name
       @param {String} [extra]  'padding' : (css width) + padding
       'border' : (css width) + padding + border
       'margin' : (css width) + padding + border + margin
       */

      function getWH(elem, name, extra) {
        if (isWindow(elem)) {
          return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
        } else if (elem.nodeType === 9) {
          return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
        }

        var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
        var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem, computedStyle);
        var cssBoxValue = 0;

        if (borderBoxValue == null || borderBoxValue <= 0) {
          borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

          cssBoxValue = getComputedStyleX(elem, name);

          if (cssBoxValue == null || Number(cssBoxValue) < 0) {
            cssBoxValue = elem.style[name] || 0;
          } // Normalize '', auto, and prepare for extra


          cssBoxValue = parseFloat(cssBoxValue) || 0;
        }

        if (extra === undefined) {
          extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
        }

        var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
        var val = borderBoxValue || cssBoxValue;

        if (extra === CONTENT_INDEX) {
          if (borderBoxValueOrIsBorderBox) {
            return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
          }

          return cssBoxValue;
        }

        if (borderBoxValueOrIsBorderBox) {
          var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
          return val + (extra === BORDER_INDEX ? 0 : padding);
        }

        return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
      }

      var cssShow = {
        position: 'absolute',
        visibility: 'hidden',
        display: 'block'
      }; // fix #119 : https://github.com/kissyteam/kissy/issues/119

      function getWHIgnoreDisplay(elem) {
        var val = undefined;
        var args = arguments; // in case elem is window
        // elem.offsetWidth === undefined

        if (elem.offsetWidth !== 0) {
          val = getWH.apply(undefined, args);
        } else {
          swap(elem, cssShow, function () {
            val = getWH.apply(undefined, args);
          });
        }

        return val;
      }

      function css(el, name, v) {
        var value = v;

        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
          for (var i in name) {
            if (name.hasOwnProperty(i)) {
              css(el, i, name[i]);
            }
          }

          return undefined;
        }

        if (typeof value !== 'undefined') {
          if (typeof value === 'number') {
            value += 'px';
          }

          el.style[name] = value;
          return undefined;
        }

        return getComputedStyleX(el, name);
      }

      each(['width', 'height'], function (name) {
        var first = name.charAt(0).toUpperCase() + name.slice(1);

        domUtils['outer' + first] = function (el, includeMargin) {
          return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
        };

        var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

        domUtils[name] = function (elem, val) {
          if (val !== undefined) {
            if (elem) {
              var computedStyle = getComputedStyleX(elem);
              var isBorderBox = isBorderBoxFn(elem);

              if (isBorderBox) {
                val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
              }

              return css(elem, name, val);
            }

            return undefined;
          }

          return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
        };
      }); // 设置 elem 相对 elem.ownerDocument 的坐标

      function setOffset(elem, offset) {
        // set position first, in-case top/left are set even on static elem
        if (css(elem, 'position') === 'static') {
          elem.style.position = 'relative';
        }

        var old = getOffset(elem);
        var ret = {};
        var current = undefined;
        var key = undefined;

        for (key in offset) {
          if (offset.hasOwnProperty(key)) {
            current = parseFloat(css(elem, key)) || 0;
            ret[key] = current + offset[key] - old[key];
          }
        }

        css(elem, ret);
      }

      module.exports = _extends({
        getWindow: function getWindow(node) {
          var doc = node.ownerDocument || node;
          return doc.defaultView || doc.parentWindow;
        },
        offset: function offset(el, value) {
          if (typeof value !== 'undefined') {
            setOffset(el, value);
          } else {
            return getOffset(el);
          }
        },
        isWindow: isWindow,
        each: each,
        css: css,
        clone: function clone(obj) {
          var ret = {};

          for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
              ret[i] = obj[i];
            }
          }

          var overflow = obj.overflow;

          if (overflow) {
            for (var i in obj) {
              if (obj.hasOwnProperty(i)) {
                ret.overflow[i] = obj.overflow[i];
              }
            }
          }

          return ret;
        },
        scrollLeft: function scrollLeft(w, v) {
          if (isWindow(w)) {
            if (v === undefined) {
              return getScrollLeft(w);
            }

            window.scrollTo(v, getScrollTop(w));
          } else {
            if (v === undefined) {
              return w.scrollLeft;
            }

            w.scrollLeft = v;
          }
        },
        scrollTop: function scrollTop(w, v) {
          if (isWindow(w)) {
            if (v === undefined) {
              return getScrollTop(w);
            }

            window.scrollTo(getScrollLeft(w), v);
          } else {
            if (v === undefined) {
              return w.scrollTop;
            }

            w.scrollTop = v;
          }
        },
        viewportWidth: 0,
        viewportHeight: 0
      }, domUtils);
      /***/
    },
    /* 1123 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var util = __webpack_require__(1122);

      function scrollIntoView(elem, container, config) {
        config = config || {}; // document 归一化到 window

        if (container.nodeType === 9) {
          container = util.getWindow(container);
        }

        var allowHorizontalScroll = config.allowHorizontalScroll;
        var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
        var alignWithTop = config.alignWithTop;
        var alignWithLeft = config.alignWithLeft;
        var offsetTop = config.offsetTop || 0;
        var offsetLeft = config.offsetLeft || 0;
        var offsetBottom = config.offsetBottom || 0;
        var offsetRight = config.offsetRight || 0;
        allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;
        var isWin = util.isWindow(container);
        var elemOffset = util.offset(elem);
        var eh = util.outerHeight(elem);
        var ew = util.outerWidth(elem);
        var containerOffset = undefined;
        var ch = undefined;
        var cw = undefined;
        var containerScroll = undefined;
        var diffTop = undefined;
        var diffBottom = undefined;
        var win = undefined;
        var winScroll = undefined;
        var ww = undefined;
        var wh = undefined;

        if (isWin) {
          win = container;
          wh = util.height(win);
          ww = util.width(win);
          winScroll = {
            left: util.scrollLeft(win),
            top: util.scrollTop(win)
          }; // elem 相对 container 可视视窗的距离

          diffTop = {
            left: elemOffset.left - winScroll.left - offsetLeft,
            top: elemOffset.top - winScroll.top - offsetTop
          };
          diffBottom = {
            left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
            top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
          };
          containerScroll = winScroll;
        } else {
          containerOffset = util.offset(container);
          ch = container.clientHeight;
          cw = container.clientWidth;
          containerScroll = {
            left: container.scrollLeft,
            top: container.scrollTop
          }; // elem 相对 container 可视视窗的距离
          // 注意边框, offset 是边框到根节点

          diffTop = {
            left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
            top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
          };
          diffBottom = {
            left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
            top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
          };
        }

        if (diffTop.top < 0 || diffBottom.top > 0) {
          // 强制向上
          if (alignWithTop === true) {
            util.scrollTop(container, containerScroll.top + diffTop.top);
          } else if (alignWithTop === false) {
            util.scrollTop(container, containerScroll.top + diffBottom.top);
          } else {
            // 自动调整
            if (diffTop.top < 0) {
              util.scrollTop(container, containerScroll.top + diffTop.top);
            } else {
              util.scrollTop(container, containerScroll.top + diffBottom.top);
            }
          }
        } else {
          if (!onlyScrollIfNeeded) {
            alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;

            if (alignWithTop) {
              util.scrollTop(container, containerScroll.top + diffTop.top);
            } else {
              util.scrollTop(container, containerScroll.top + diffBottom.top);
            }
          }
        }

        if (allowHorizontalScroll) {
          if (diffTop.left < 0 || diffBottom.left > 0) {
            // 强制向上
            if (alignWithLeft === true) {
              util.scrollLeft(container, containerScroll.left + diffTop.left);
            } else if (alignWithLeft === false) {
              util.scrollLeft(container, containerScroll.left + diffBottom.left);
            } else {
              // 自动调整
              if (diffTop.left < 0) {
                util.scrollLeft(container, containerScroll.left + diffTop.left);
              } else {
                util.scrollLeft(container, containerScroll.left + diffBottom.left);
              }
            }
          } else {
            if (!onlyScrollIfNeeded) {
              alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;

              if (alignWithLeft) {
                util.scrollLeft(container, containerScroll.left + diffTop.left);
              } else {
                util.scrollLeft(container, containerScroll.left + diffBottom.left);
              }
            }
          }
        }
      }

      module.exports = scrollIntoView;
      /***/
    },
    /* 1124 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      exports.default = create;

      function create(initialState) {
        var state = initialState;
        var listeners = [];

        function setState(partial) {
          state = _extends({}, state, partial);

          for (var i = 0; i < listeners.length; i++) {
            listeners[i]();
          }
        }

        function getState() {
          return state;
        }

        function subscribe(listener) {
          listeners.push(listener);
          return function unsubscribe() {
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
          };
        }

        return {
          setState: setState,
          getState: getState,
          subscribe: subscribe
        };
      }
      /***/

    },
    /* 1125 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      exports.default = connect;

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _shallowequal = __webpack_require__(56);

      var _shallowequal2 = _interopRequireDefault(_shallowequal);

      var _hoistNonReactStatics = __webpack_require__(370);

      var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

      var _reactLifecyclesCompat = __webpack_require__(111);

      var _PropTypes = __webpack_require__(642);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
      }

      function isStateless(Component) {
        return !Component.prototype.render;
      }

      var defaultMapStateToProps = function defaultMapStateToProps() {
        return {};
      };

      function connect(mapStateToProps) {
        var shouldSubscribe = !!mapStateToProps;
        var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;
        return function wrapWithConnect(WrappedComponent) {
          var Connect = function (_Component) {
            _inherits(Connect, _Component);

            _createClass(Connect, null, [{
              key: 'getDerivedStateFromProps',
              value: function getDerivedStateFromProps(props, prevState) {
                // using ownProps
                if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
                  return {
                    subscribed: finnalMapStateToProps(prevState.store.getState(), props),
                    props: props
                  };
                }

                return {
                  props: props
                };
              }
            }]);

            function Connect(props, context) {
              _classCallCheck(this, Connect);

              var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));

              _this.handleChange = function () {
                if (!_this.unsubscribe) {
                  return;
                }

                var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);

                if (!(0, _shallowequal2.default)(_this.state.subscribed, nextState)) {
                  _this.setState({
                    subscribed: nextState
                  });
                }
              };

              _this.store = context.miniStore;
              _this.state = {
                subscribed: finnalMapStateToProps(_this.store.getState(), props),
                store: _this.store,
                props: props
              };
              return _this;
            }

            _createClass(Connect, [{
              key: 'componentDidMount',
              value: function componentDidMount() {
                this.trySubscribe();
              }
            }, {
              key: 'componentWillUnmount',
              value: function componentWillUnmount() {
                this.tryUnsubscribe();
              }
            }, {
              key: 'trySubscribe',
              value: function trySubscribe() {
                if (shouldSubscribe) {
                  this.unsubscribe = this.store.subscribe(this.handleChange);
                  this.handleChange();
                }
              }
            }, {
              key: 'tryUnsubscribe',
              value: function tryUnsubscribe() {
                if (this.unsubscribe) {
                  this.unsubscribe();
                  this.unsubscribe = null;
                }
              }
            }, {
              key: 'getWrappedInstance',
              value: function getWrappedInstance() {
                return this.wrappedInstance;
              }
            }, {
              key: 'render',
              value: function render() {
                var _this2 = this;

                var props = _extends({}, this.props, this.state.subscribed, {
                  store: this.store
                });

                if (!isStateless(WrappedComponent)) {
                  props = _extends({}, props, {
                    ref: function ref(c) {
                      return _this2.wrappedInstance = c;
                    }
                  });
                }

                return _react2.default.createElement(WrappedComponent, props);
              }
            }]);

            return Connect;
          }(_react.Component);

          Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
          Connect.contextTypes = {
            miniStore: _PropTypes.storeShape.isRequired
          };
          (0, _reactLifecyclesCompat.polyfill)(Connect);
          return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
        };
      }
      /***/

    },
    /* 1126 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _react = __webpack_require__(1);

      var _react2 = _interopRequireDefault(_react);

      var _PropTypes = __webpack_require__(642);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Provider = function (_Component) {
        _inherits(Provider, _Component);

        function Provider() {
          _classCallCheck(this, Provider);

          return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
        }

        _createClass(Provider, [{
          key: 'getChildContext',
          value: function getChildContext() {
            return {
              miniStore: this.props.store
            };
          }
        }, {
          key: 'render',
          value: function render() {
            return _react.Children.only(this.props.children);
          }
        }]);

        return Provider;
      }(_react.Component);

      Provider.propTypes = {
        store: _PropTypes.storeShape.isRequired
      };
      Provider.childContextTypes = {
        miniStore: _PropTypes.storeShape.isRequired
      };
      exports.default = Provider;
      /***/
    },
    /* 1127 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      var emptyObject = {};

      if (false) {}

      module.exports = emptyObject;
      /***/
    },
    /* 1128 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       *
       */

      var _assign = __webpack_require__(82);

      var emptyObject = __webpack_require__(1127);

      var _invariant = __webpack_require__(51);

      if (false) {
        var warning;
      }

      var MIXINS_KEY = 'mixins'; // Helper function to allow the creation of anonymous functions which do not
      // have .name set to the name of the variable being assigned to.

      function identity(fn) {
        return fn;
      }

      var ReactPropTypeLocationNames;

      if (false) {} else {
        ReactPropTypeLocationNames = {};
      }

      function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
        /**
         * Policies that describe methods in `ReactClassInterface`.
         */
        var injectedMixins = [];
        /**
         * Composite components are higher-level components that compose other composite
         * or host components.
         *
         * To create a new type of `ReactClass`, pass a specification of
         * your new class to `React.createClass`. The only requirement of your class
         * specification is that you implement a `render` method.
         *
         *   var MyComponent = React.createClass({
         *     render: function() {
         *       return <div>Hello World</div>;
         *     }
         *   });
         *
         * The class specification supports a specific protocol of methods that have
         * special meaning (e.g. `render`). See `ReactClassInterface` for
         * more the comprehensive protocol. Any other properties and methods in the
         * class specification will be available on the prototype.
         *
         * @interface ReactClassInterface
         * @internal
         */

        var ReactClassInterface = {
          /**
           * An array of Mixin objects to include when defining your component.
           *
           * @type {array}
           * @optional
           */
          mixins: 'DEFINE_MANY',

          /**
           * An object containing properties and methods that should be defined on
           * the component's constructor instead of its prototype (static methods).
           *
           * @type {object}
           * @optional
           */
          statics: 'DEFINE_MANY',

          /**
           * Definition of prop types for this component.
           *
           * @type {object}
           * @optional
           */
          propTypes: 'DEFINE_MANY',

          /**
           * Definition of context types for this component.
           *
           * @type {object}
           * @optional
           */
          contextTypes: 'DEFINE_MANY',

          /**
           * Definition of context types this component sets for its children.
           *
           * @type {object}
           * @optional
           */
          childContextTypes: 'DEFINE_MANY',
          // ==== Definition methods ====

          /**
           * Invoked when the component is mounted. Values in the mapping will be set on
           * `this.props` if that prop is not specified (i.e. using an `in` check).
           *
           * This method is invoked before `getInitialState` and therefore cannot rely
           * on `this.state` or use `this.setState`.
           *
           * @return {object}
           * @optional
           */
          getDefaultProps: 'DEFINE_MANY_MERGED',

          /**
           * Invoked once before the component is mounted. The return value will be used
           * as the initial value of `this.state`.
           *
           *   getInitialState: function() {
           *     return {
           *       isOn: false,
           *       fooBaz: new BazFoo()
           *     }
           *   }
           *
           * @return {object}
           * @optional
           */
          getInitialState: 'DEFINE_MANY_MERGED',

          /**
           * @return {object}
           * @optional
           */
          getChildContext: 'DEFINE_MANY_MERGED',

          /**
           * Uses props from `this.props` and state from `this.state` to render the
           * structure of the component.
           *
           * No guarantees are made about when or how often this method is invoked, so
           * it must not have side effects.
           *
           *   render: function() {
           *     var name = this.props.name;
           *     return <div>Hello, {name}!</div>;
           *   }
           *
           * @return {ReactComponent}
           * @required
           */
          render: 'DEFINE_ONCE',
          // ==== Delegate methods ====

          /**
           * Invoked when the component is initially created and about to be mounted.
           * This may have side effects, but any external subscriptions or data created
           * by this method must be cleaned up in `componentWillUnmount`.
           *
           * @optional
           */
          componentWillMount: 'DEFINE_MANY',

          /**
           * Invoked when the component has been mounted and has a DOM representation.
           * However, there is no guarantee that the DOM node is in the document.
           *
           * Use this as an opportunity to operate on the DOM when the component has
           * been mounted (initialized and rendered) for the first time.
           *
           * @param {DOMElement} rootNode DOM element representing the component.
           * @optional
           */
          componentDidMount: 'DEFINE_MANY',

          /**
           * Invoked before the component receives new props.
           *
           * Use this as an opportunity to react to a prop transition by updating the
           * state using `this.setState`. Current props are accessed via `this.props`.
           *
           *   componentWillReceiveProps: function(nextProps, nextContext) {
           *     this.setState({
           *       likesIncreasing: nextProps.likeCount > this.props.likeCount
           *     });
           *   }
           *
           * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
           * transition may cause a state change, but the opposite is not true. If you
           * need it, you are probably looking for `componentWillUpdate`.
           *
           * @param {object} nextProps
           * @optional
           */
          componentWillReceiveProps: 'DEFINE_MANY',

          /**
           * Invoked while deciding if the component should be updated as a result of
           * receiving new props, state and/or context.
           *
           * Use this as an opportunity to `return false` when you're certain that the
           * transition to the new props/state/context will not require a component
           * update.
           *
           *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
           *     return !equal(nextProps, this.props) ||
           *       !equal(nextState, this.state) ||
           *       !equal(nextContext, this.context);
           *   }
           *
           * @param {object} nextProps
           * @param {?object} nextState
           * @param {?object} nextContext
           * @return {boolean} True if the component should update.
           * @optional
           */
          shouldComponentUpdate: 'DEFINE_ONCE',

          /**
           * Invoked when the component is about to update due to a transition from
           * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
           * and `nextContext`.
           *
           * Use this as an opportunity to perform preparation before an update occurs.
           *
           * NOTE: You **cannot** use `this.setState()` in this method.
           *
           * @param {object} nextProps
           * @param {?object} nextState
           * @param {?object} nextContext
           * @param {ReactReconcileTransaction} transaction
           * @optional
           */
          componentWillUpdate: 'DEFINE_MANY',

          /**
           * Invoked when the component's DOM representation has been updated.
           *
           * Use this as an opportunity to operate on the DOM when the component has
           * been updated.
           *
           * @param {object} prevProps
           * @param {?object} prevState
           * @param {?object} prevContext
           * @param {DOMElement} rootNode DOM element representing the component.
           * @optional
           */
          componentDidUpdate: 'DEFINE_MANY',

          /**
           * Invoked when the component is about to be removed from its parent and have
           * its DOM representation destroyed.
           *
           * Use this as an opportunity to deallocate any external resources.
           *
           * NOTE: There is no `componentDidUnmount` since your component will have been
           * destroyed by that point.
           *
           * @optional
           */
          componentWillUnmount: 'DEFINE_MANY',

          /**
           * Replacement for (deprecated) `componentWillMount`.
           *
           * @optional
           */
          UNSAFE_componentWillMount: 'DEFINE_MANY',

          /**
           * Replacement for (deprecated) `componentWillReceiveProps`.
           *
           * @optional
           */
          UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

          /**
           * Replacement for (deprecated) `componentWillUpdate`.
           *
           * @optional
           */
          UNSAFE_componentWillUpdate: 'DEFINE_MANY',
          // ==== Advanced methods ====

          /**
           * Updates the component's currently mounted DOM representation.
           *
           * By default, this implements React's rendering and reconciliation algorithm.
           * Sophisticated clients may wish to override this.
           *
           * @param {ReactReconcileTransaction} transaction
           * @internal
           * @overridable
           */
          updateComponent: 'OVERRIDE_BASE'
        };
        /**
         * Similar to ReactClassInterface but for static methods.
         */

        var ReactClassStaticInterface = {
          /**
           * This method is invoked after a component is instantiated and when it
           * receives new props. Return an object to update state in response to
           * prop changes. Return null to indicate no change to state.
           *
           * If an object is returned, its keys will be merged into the existing state.
           *
           * @return {object || null}
           * @optional
           */
          getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
        };
        /**
         * Mapping from class specification keys to special processing functions.
         *
         * Although these are declared like instance properties in the specification
         * when defining classes using `React.createClass`, they are actually static
         * and are accessible on the constructor instead of the prototype. Despite
         * being static, they must be defined outside of the "statics" key under
         * which all other static methods are defined.
         */

        var RESERVED_SPEC_KEYS = {
          displayName: function displayName(Constructor, _displayName2) {
            Constructor.displayName = _displayName2;
          },
          mixins: function mixins(Constructor, _mixins2) {
            if (_mixins2) {
              for (var i = 0; i < _mixins2.length; i++) {
                mixSpecIntoComponent(Constructor, _mixins2[i]);
              }
            }
          },
          childContextTypes: function childContextTypes(Constructor, _childContextTypes3) {
            if (false) {}

            Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, _childContextTypes3);
          },
          contextTypes: function contextTypes(Constructor, _contextTypes3) {
            if (false) {}

            Constructor.contextTypes = _assign({}, Constructor.contextTypes, _contextTypes3);
          },

          /**
           * Special case getDefaultProps which should move into statics but requires
           * automatic merging.
           */
          getDefaultProps: function getDefaultProps(Constructor, _getDefaultProps2) {
            if (Constructor.getDefaultProps) {
              Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, _getDefaultProps2);
            } else {
              Constructor.getDefaultProps = _getDefaultProps2;
            }
          },
          propTypes: function propTypes(Constructor, _propTypes4) {
            if (false) {}

            Constructor.propTypes = _assign({}, Constructor.propTypes, _propTypes4);
          },
          statics: function statics(Constructor, _statics2) {
            mixStaticSpecIntoComponent(Constructor, _statics2);
          },
          autobind: function autobind() {}
        };

        function validateTypeDef(Constructor, typeDef, location) {
          for (var propName in typeDef) {
            if (typeDef.hasOwnProperty(propName)) {
              // use a warning instead of an _invariant so components
              // don't show up in prod but only in __DEV__
              if (false) {}
            }
          }
        }

        function validateMethodOverride(isAlreadyDefined, name) {
          var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null; // Disallow overriding of base class methods unless explicitly allowed.

          if (ReactClassMixin.hasOwnProperty(name)) {
            _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
          } // Disallow defining methods more than once unless explicitly allowed.


          if (isAlreadyDefined) {
            _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
          }
        }
        /**
         * Mixin helper which handles policy validation and reserved
         * specification keys when building React classes.
         */


        function mixSpecIntoComponent(Constructor, spec) {
          if (!spec) {
            if (false) {
              var isMixinValid, typeofSpec;
            }

            return;
          }

          _invariant(typeof spec !== 'function', "ReactClass: You're attempting to " + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');

          _invariant(!isValidElement(spec), "ReactClass: You're attempting to " + 'use a component as a mixin. Instead, just use a regular object.');

          var proto = Constructor.prototype;
          var autoBindPairs = proto.__reactAutoBindPairs; // By handling mixins before any other properties, we ensure the same
          // chaining order is applied to methods with DEFINE_MANY policy, whether
          // mixins are listed before or after these methods in the spec.

          if (spec.hasOwnProperty(MIXINS_KEY)) {
            RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
          }

          for (var name in spec) {
            if (!spec.hasOwnProperty(name)) {
              continue;
            }

            if (name === MIXINS_KEY) {
              // We have already handled mixins in a special case above.
              continue;
            }

            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);

            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
              RESERVED_SPEC_KEYS[name](Constructor, property);
            } else {
              // Setup methods on prototype:
              // The following member methods should not be automatically bound:
              // 1. Expected ReactClass methods (in the "interface").
              // 2. Overridden methods (that were mixed in).
              var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
              var isFunction = typeof property === 'function';
              var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

              if (shouldAutoBind) {
                autoBindPairs.push(name, property);
                proto[name] = property;
              } else {
                if (isAlreadyDefined) {
                  var specPolicy = ReactClassInterface[name]; // These cases should already be caught by validateMethodOverride.

                  _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name); // For methods which are defined more than once, call the existing
                  // methods before calling the new property, merging if appropriate.


                  if (specPolicy === 'DEFINE_MANY_MERGED') {
                    proto[name] = createMergedResultFunction(proto[name], property);
                  } else if (specPolicy === 'DEFINE_MANY') {
                    proto[name] = createChainedFunction(proto[name], property);
                  }
                } else {
                  proto[name] = property;

                  if (false) {}
                }
              }
            }
          }
        }

        function mixStaticSpecIntoComponent(Constructor, statics) {
          if (!statics) {
            return;
          }

          for (var name in statics) {
            var property = statics[name];

            if (!statics.hasOwnProperty(name)) {
              continue;
            }

            var isReserved = name in RESERVED_SPEC_KEYS;

            _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);

            var isAlreadyDefined = name in Constructor;

            if (isAlreadyDefined) {
              var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;

              _invariant(specPolicy === 'DEFINE_MANY_MERGED', 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);

              Constructor[name] = createMergedResultFunction(Constructor[name], property);
              return;
            }

            Constructor[name] = property;
          }
        }
        /**
         * Merge two objects, but throw if both contain the same key.
         *
         * @param {object} one The first object, which is mutated.
         * @param {object} two The second object
         * @return {object} one after it has been mutated to contain everything in two.
         */


        function mergeIntoWithNoDuplicateKeys(one, two) {
          _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

          for (var key in two) {
            if (two.hasOwnProperty(key)) {
              _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);

              one[key] = two[key];
            }
          }

          return one;
        }
        /**
         * Creates a function that invokes two functions and merges their return values.
         *
         * @param {function} one Function to invoke first.
         * @param {function} two Function to invoke second.
         * @return {function} Function that invokes the two argument functions.
         * @private
         */


        function createMergedResultFunction(one, two) {
          return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);

            if (a == null) {
              return b;
            } else if (b == null) {
              return a;
            }

            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
          };
        }
        /**
         * Creates a function that invokes two functions and ignores their return vales.
         *
         * @param {function} one Function to invoke first.
         * @param {function} two Function to invoke second.
         * @return {function} Function that invokes the two argument functions.
         * @private
         */


        function createChainedFunction(one, two) {
          return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
          };
        }
        /**
         * Binds a method to the component.
         *
         * @param {object} component Component whose method is going to be bound.
         * @param {function} method Method to be bound.
         * @return {function} The bound method.
         */


        function bindAutoBindMethod(component, method) {
          var boundMethod = method.bind(component);

          if (false) {
            var _bind, componentName;
          }

          return boundMethod;
        }
        /**
         * Binds all auto-bound methods in a component.
         *
         * @param {object} component Component whose method is going to be bound.
         */


        function bindAutoBindMethods(component) {
          var pairs = component.__reactAutoBindPairs;

          for (var i = 0; i < pairs.length; i += 2) {
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
          }
        }

        var IsMountedPreMixin = {
          componentDidMount: function componentDidMount() {
            this.__isMounted = true;
          }
        };
        var IsMountedPostMixin = {
          componentWillUnmount: function componentWillUnmount() {
            this.__isMounted = false;
          }
        };
        /**
         * Add more to the ReactClass base class. These are all legacy features and
         * therefore not already part of the modern ReactComponent.
         */

        var ReactClassMixin = {
          /**
           * TODO: This will be deprecated because state should always keep a consistent
           * type signature and the only use case for this, is to avoid that.
           */
          replaceState: function replaceState(newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
          },

          /**
           * Checks whether or not this composite component is mounted.
           * @return {boolean} True if mounted, false otherwise.
           * @protected
           * @final
           */
          isMounted: function isMounted() {
            if (false) {}

            return !!this.__isMounted;
          }
        };

        var ReactClassComponent = function ReactClassComponent() {};

        _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
        /**
         * Creates a composite component class given a class specification.
         * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
         *
         * @param {object} spec Class specification (which must define `render`).
         * @return {function} Component constructor function.
         * @public
         */


        function createClass(spec) {
          // To keep our warnings more understandable, we'll use a little hack here to
          // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
          // unnecessarily identify a class without displayName as 'Constructor'.
          var Constructor = identity(function (props, context, updater) {
            // This constructor gets overridden by mocks. The argument is used
            // by mocks to assert on what gets mounted.
            if (false) {} // Wire up auto-binding


            if (this.__reactAutoBindPairs.length) {
              bindAutoBindMethods(this);
            }

            this.props = props;
            this.context = context;
            this.refs = emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null; // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.

            var initialState = this.getInitialState ? this.getInitialState() : null;

            if (false) {}

            _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');

            this.state = initialState;
          });
          Constructor.prototype = new ReactClassComponent();
          Constructor.prototype.constructor = Constructor;
          Constructor.prototype.__reactAutoBindPairs = [];
          injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
          mixSpecIntoComponent(Constructor, IsMountedPreMixin);
          mixSpecIntoComponent(Constructor, spec);
          mixSpecIntoComponent(Constructor, IsMountedPostMixin); // Initialize the defaultProps property after all mixins have been merged.

          if (Constructor.getDefaultProps) {
            Constructor.defaultProps = Constructor.getDefaultProps();
          }

          if (false) {}

          _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

          if (false) {} // Reduce time spent doing lookups by setting these on the prototype.


          for (var methodName in ReactClassInterface) {
            if (!Constructor.prototype[methodName]) {
              Constructor.prototype[methodName] = null;
            }
          }

          return Constructor;
        }

        return createClass;
      }

      module.exports = factory;
      /***/
    },
    /* 1129 */

    /***/
    function (module, exports, __webpack_require__) {
      var ITERATOR = __webpack_require__(110)('iterator');

      var SAFE_CLOSING = false;

      try {
        var riter = [7][ITERATOR]();

        riter['return'] = function () {
          SAFE_CLOSING = true;
        }; // eslint-disable-next-line no-throw-literal


        Array.from(riter, function () {
          throw 2;
        });
      } catch (e) {
        /* empty */
      }

      module.exports = function (exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return false;
        var safe = false;

        try {
          var arr = [7];
          var iter = arr[ITERATOR]();

          iter.next = function () {
            return {
              done: safe = true
            };
          };

          arr[ITERATOR] = function () {
            return iter;
          };

          exec(arr);
        } catch (e) {
          /* empty */
        }

        return safe;
      };
      /***/

    },
    /* 1130 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var $defineProperty = __webpack_require__(137);

      var createDesc = __webpack_require__(214);

      module.exports = function (object, index, value) {
        if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
      };
      /***/

    },
    /* 1131 */

    /***/
    function (module, exports, __webpack_require__) {
      // check on default Array iterator
      var Iterators = __webpack_require__(178);

      var ITERATOR = __webpack_require__(110)('iterator');

      var ArrayProto = Array.prototype;

      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
      };
      /***/

    },
    /* 1132 */

    /***/
    function (module, exports, __webpack_require__) {
      // call something on iterator step with safe closing on error
      var anObject = __webpack_require__(161);

      module.exports = function (iterator, fn, value, entries) {
        try {
          return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
        } catch (e) {
          var ret = iterator['return'];
          if (ret !== undefined) anObject(ret.call(iterator));
          throw e;
        }
      };
      /***/

    },
    /* 1133 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var ctx = __webpack_require__(369);

      var $export = __webpack_require__(139);

      var toObject = __webpack_require__(213);

      var call = __webpack_require__(1132);

      var isArrayIter = __webpack_require__(1131);

      var toLength = __webpack_require__(650);

      var createProperty = __webpack_require__(1130);

      var getIterFn = __webpack_require__(645);

      $export($export.S + $export.F * !__webpack_require__(1129)(function (iter) {
        Array.from(iter);
      }), 'Array', {
        // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
        from: function from(arrayLike
        /* , mapfn = undefined, thisArg = undefined */
        ) {
          var O = toObject(arrayLike);
          var C = typeof this == 'function' ? this : Array;
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          var index = 0;
          var iterFn = getIterFn(O);
          var length, result, step, iterator;
          if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

          if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
            for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
              createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
            }
          } else {
            length = toLength(O.length);

            for (result = new C(length); length > index; index++) {
              createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
            }
          }

          result.length = index;
          return result;
        }
      });
      /***/
    },
    /* 1134 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(256);

      __webpack_require__(1133);

      module.exports = __webpack_require__(89).Array.from;
      /***/
    },
    /* 1135 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1134),
        __esModule: true
      };
      /***/
    },
    /* 1136 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * @ignore
       * base event object for custom and dom event.
       * @author yiminghe@gmail.com
       */

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      function returnFalse() {
        return false;
      }

      function returnTrue() {
        return true;
      }

      function EventBaseObject() {
        this.timeStamp = Date.now();
        this.target = undefined;
        this.currentTarget = undefined;
      }

      EventBaseObject.prototype = {
        isEventObject: 1,
        constructor: EventBaseObject,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        preventDefault: function preventDefault() {
          this.isDefaultPrevented = returnTrue;
        },
        stopPropagation: function stopPropagation() {
          this.isPropagationStopped = returnTrue;
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
          this.isImmediatePropagationStopped = returnTrue; // fixed 1.2
          // call stopPropagation implicitly

          this.stopPropagation();
        },
        halt: function halt(immediate) {
          if (immediate) {
            this.stopImmediatePropagation();
          } else {
            this.stopPropagation();
          }

          this.preventDefault();
        }
      };
      exports["default"] = EventBaseObject;
      module.exports = exports["default"];
      /***/
    },
    /* 1137 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * @ignore
       * event object for dom
       * @author yiminghe@gmail.com
       */

      Object.defineProperty(exports, '__esModule', {
        value: true
      });

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          'default': obj
        };
      }

      var _EventBaseObject = __webpack_require__(1136);

      var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

      var _objectAssign = __webpack_require__(82);

      var _objectAssign2 = _interopRequireDefault(_objectAssign);

      var TRUE = true;
      var FALSE = false;
      var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

      function isNullOrUndefined(w) {
        return w === null || w === undefined;
      }

      var eventNormalizers = [{
        reg: /^key/,
        props: ['char', 'charCode', 'key', 'keyCode', 'which'],
        fix: function fix(event, nativeEvent) {
          if (isNullOrUndefined(event.which)) {
            event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
          } // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)


          if (event.metaKey === undefined) {
            event.metaKey = event.ctrlKey;
          }
        }
      }, {
        reg: /^touch/,
        props: ['touches', 'changedTouches', 'targetTouches']
      }, {
        reg: /^hashchange$/,
        props: ['newURL', 'oldURL']
      }, {
        reg: /^gesturechange$/i,
        props: ['rotation', 'scale']
      }, {
        reg: /^(mousewheel|DOMMouseScroll)$/,
        props: [],
        fix: function fix(event, nativeEvent) {
          var deltaX = undefined;
          var deltaY = undefined;
          var delta = undefined;
          var wheelDelta = nativeEvent.wheelDelta;
          var axis = nativeEvent.axis;
          var wheelDeltaY = nativeEvent.wheelDeltaY;
          var wheelDeltaX = nativeEvent.wheelDeltaX;
          var detail = nativeEvent.detail; // ie/webkit

          if (wheelDelta) {
            delta = wheelDelta / 120;
          } // gecko


          if (detail) {
            // press control e.detail == 1 else e.detail == 3
            delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
          } // Gecko


          if (axis !== undefined) {
            if (axis === event.HORIZONTAL_AXIS) {
              deltaY = 0;
              deltaX = 0 - delta;
            } else if (axis === event.VERTICAL_AXIS) {
              deltaX = 0;
              deltaY = delta;
            }
          } // Webkit


          if (wheelDeltaY !== undefined) {
            deltaY = wheelDeltaY / 120;
          }

          if (wheelDeltaX !== undefined) {
            deltaX = -1 * wheelDeltaX / 120;
          } // 默认 deltaY (ie)


          if (!deltaX && !deltaY) {
            deltaY = delta;
          }

          if (deltaX !== undefined) {
            /**
             * deltaX of mousewheel event
             * @property deltaX
             * @member Event.DomEvent.Object
             */
            event.deltaX = deltaX;
          }

          if (deltaY !== undefined) {
            /**
             * deltaY of mousewheel event
             * @property deltaY
             * @member Event.DomEvent.Object
             */
            event.deltaY = deltaY;
          }

          if (delta !== undefined) {
            /**
             * delta of mousewheel event
             * @property delta
             * @member Event.DomEvent.Object
             */
            event.delta = delta;
          }
        }
      }, {
        reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
        props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
        fix: function fix(event, nativeEvent) {
          var eventDoc = undefined;
          var doc = undefined;
          var body = undefined;
          var target = event.target;
          var button = nativeEvent.button; // Calculate pageX/Y if missing and clientX/Y available

          if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
            eventDoc = target.ownerDocument || document;
            doc = eventDoc.documentElement;
            body = eventDoc.body;
            event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
            event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
          } // which for click: 1 === left; 2 === middle; 3 === right
          // do not use button


          if (!event.which && button !== undefined) {
            if (button & 1) {
              event.which = 1;
            } else if (button & 2) {
              event.which = 3;
            } else if (button & 4) {
              event.which = 2;
            } else {
              event.which = 0;
            }
          } // add relatedTarget, if necessary


          if (!event.relatedTarget && event.fromElement) {
            event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
          }

          return event;
        }
      }];

      function retTrue() {
        return TRUE;
      }

      function retFalse() {
        return FALSE;
      }

      function DomEventObject(nativeEvent) {
        var type = nativeEvent.type;
        var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

        _EventBaseObject2['default'].call(this);

        this.nativeEvent = nativeEvent; // in case dom event has been mark as default prevented by lower dom node

        var isDefaultPrevented = retFalse;

        if ('defaultPrevented' in nativeEvent) {
          isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
        } else if ('getPreventDefault' in nativeEvent) {
          // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
          isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
        } else if ('returnValue' in nativeEvent) {
          isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
        }

        this.isDefaultPrevented = isDefaultPrevented;
        var fixFns = [];
        var fixFn = undefined;
        var l = undefined;
        var prop = undefined;
        var props = commonProps.concat();
        eventNormalizers.forEach(function (normalizer) {
          if (type.match(normalizer.reg)) {
            props = props.concat(normalizer.props);

            if (normalizer.fix) {
              fixFns.push(normalizer.fix);
            }
          }
        });
        l = props.length; // clone properties of the original event object

        while (l) {
          prop = props[--l];
          this[prop] = nativeEvent[prop];
        } // fix target property, if necessary


        if (!this.target && isNative) {
          this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
        } // check if target is a text node (safari)


        if (this.target && this.target.nodeType === 3) {
          this.target = this.target.parentNode;
        }

        l = fixFns.length;

        while (l) {
          fixFn = fixFns[--l];
          fixFn(this, nativeEvent);
        }

        this.timeStamp = nativeEvent.timeStamp || Date.now();
      }

      var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
      (0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
        constructor: DomEventObject,
        preventDefault: function preventDefault() {
          var e = this.nativeEvent; // if preventDefault exists run it on the original event

          if (e.preventDefault) {
            e.preventDefault();
          } else {
            // otherwise set the returnValue property of the original event to FALSE (IE)
            e.returnValue = FALSE;
          }

          EventBaseObjectProto.preventDefault.call(this);
        },
        stopPropagation: function stopPropagation() {
          var e = this.nativeEvent; // if stopPropagation exists run it on the original event

          if (e.stopPropagation) {
            e.stopPropagation();
          } else {
            // otherwise set the cancelBubble property of the original event to TRUE (IE)
            e.cancelBubble = TRUE;
          }

          EventBaseObjectProto.stopPropagation.call(this);
        }
      });
      exports['default'] = DomEventObject;
      module.exports = exports['default'];
      /***/
    },
    /* 1138 */

    /***/
    function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(139); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


      $export($export.S, 'Object', {
        create: __webpack_require__(360)
      });
      /***/
    },
    /* 1139 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(1138);

      var $Object = __webpack_require__(89).Object;

      module.exports = function create(P, D) {
        return $Object.create(P, D);
      };
      /***/

    },
    /* 1140 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1139),
        __esModule: true
      };
      /***/
    },
    /* 1141 */

    /***/
    function (module, exports, __webpack_require__) {
      // Works with __proto__ only. Old v8 can't work with null proto objects.

      /* eslint-disable no-proto */
      var isObject = __webpack_require__(180);

      var anObject = __webpack_require__(161);

      var check = function check(O, proto) {
        anObject(O);
        if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
      };

      module.exports = {
        set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
        function (test, buggy, set) {
          try {
            set = __webpack_require__(369)(Function.call, __webpack_require__(355).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
          } catch (e) {
            buggy = true;
          }

          return function setPrototypeOf(O, proto) {
            check(O, proto);
            if (buggy) O.__proto__ = proto;else set(O, proto);
            return O;
          };
        }({}, false) : undefined),
        check: check
      };
      /***/
    },
    /* 1142 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.3.19 Object.setPrototypeOf(O, proto)
      var $export = __webpack_require__(139);

      $export($export.S, 'Object', {
        setPrototypeOf: __webpack_require__(1141).set
      });
      /***/
    },
    /* 1143 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(1142);

      module.exports = __webpack_require__(89).Object.setPrototypeOf;
      /***/
    },
    /* 1144 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1143),
        __esModule: true
      };
      /***/
    },
    /* 1145 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(356)('observable');
      /***/

    },
    /* 1146 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(356)('asyncIterator');
      /***/

    },
    /* 1147 */

    /***/
    function (module, exports) {
      /***/
    },
    /* 1148 */

    /***/
    function (module, exports, __webpack_require__) {
      // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
      var toIObject = __webpack_require__(159);

      var gOPN = __webpack_require__(646).f;

      var toString = {}.toString;
      var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

      var getWindowNames = function getWindowNames(it) {
        try {
          return gOPN(it);
        } catch (e) {
          return windowNames.slice();
        }
      };

      module.exports.f = function getOwnPropertyNames(it) {
        return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
      };
      /***/

    },
    /* 1149 */

    /***/
    function (module, exports, __webpack_require__) {
      // 7.2.2 IsArray(argument)
      var cof = __webpack_require__(367);

      module.exports = Array.isArray || function isArray(arg) {
        return cof(arg) == 'Array';
      };
      /***/

    },
    /* 1150 */

    /***/
    function (module, exports, __webpack_require__) {
      // all enumerable object keys, includes symbols
      var getKeys = __webpack_require__(260);

      var gOPS = __webpack_require__(361);

      var pIE = __webpack_require__(257);

      module.exports = function (it) {
        var result = getKeys(it);
        var getSymbols = gOPS.f;

        if (getSymbols) {
          var symbols = getSymbols(it);
          var isEnum = pIE.f;
          var i = 0;
          var key;

          while (symbols.length > i) {
            if (isEnum.call(it, key = symbols[i++])) result.push(key);
          }
        }

        return result;
      };
      /***/

    },
    /* 1151 */

    /***/
    function (module, exports, __webpack_require__) {
      var META = __webpack_require__(258)('meta');

      var isObject = __webpack_require__(180);

      var has = __webpack_require__(160);

      var setDesc = __webpack_require__(137).f;

      var id = 0;

      var isExtensible = Object.isExtensible || function () {
        return true;
      };

      var FREEZE = !__webpack_require__(179)(function () {
        return isExtensible(Object.preventExtensions({}));
      });

      var setMeta = function setMeta(it) {
        setDesc(it, META, {
          value: {
            i: 'O' + ++id,
            // object ID
            w: {} // weak collections IDs

          }
        });
      };

      var fastKey = function fastKey(it, create) {
        // return primitive with prefix
        if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return 'F'; // not necessary to add metadata

          if (!create) return 'E'; // add missing metadata

          setMeta(it); // return object ID
        }

        return it[META].i;
      };

      var getWeak = function getWeak(it, create) {
        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return true; // not necessary to add metadata

          if (!create) return false; // add missing metadata

          setMeta(it); // return hash weak collections IDs
        }

        return it[META].w;
      }; // add metadata on freeze-family methods calling


      var onFreeze = function onFreeze(it) {
        if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
        return it;
      };

      var meta = module.exports = {
        KEY: META,
        NEED: false,
        fastKey: fastKey,
        getWeak: getWeak,
        onFreeze: onFreeze
      };
      /***/
    },
    /* 1152 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // ECMAScript 6 symbols shim

      var global = __webpack_require__(138);

      var has = __webpack_require__(160);

      var DESCRIPTORS = __webpack_require__(136);

      var $export = __webpack_require__(139);

      var redefine = __webpack_require__(648);

      var META = __webpack_require__(1151).KEY;

      var $fails = __webpack_require__(179);

      var shared = __webpack_require__(363);

      var setToStringTag = __webpack_require__(359);

      var uid = __webpack_require__(258);

      var wks = __webpack_require__(110);

      var wksExt = __webpack_require__(357);

      var wksDefine = __webpack_require__(356);

      var enumKeys = __webpack_require__(1150);

      var isArray = __webpack_require__(1149);

      var anObject = __webpack_require__(161);

      var isObject = __webpack_require__(180);

      var toObject = __webpack_require__(213);

      var toIObject = __webpack_require__(159);

      var toPrimitive = __webpack_require__(368);

      var createDesc = __webpack_require__(214);

      var _create = __webpack_require__(360);

      var gOPNExt = __webpack_require__(1148);

      var $GOPD = __webpack_require__(355);

      var $GOPS = __webpack_require__(361);

      var $DP = __webpack_require__(137);

      var $keys = __webpack_require__(260);

      var gOPD = $GOPD.f;
      var dP = $DP.f;
      var gOPN = gOPNExt.f;
      var $Symbol = global.Symbol;
      var $JSON = global.JSON;

      var _stringify = $JSON && $JSON.stringify;

      var PROTOTYPE = 'prototype';
      var HIDDEN = wks('_hidden');
      var TO_PRIMITIVE = wks('toPrimitive');
      var isEnum = {}.propertyIsEnumerable;
      var SymbolRegistry = shared('symbol-registry');
      var AllSymbols = shared('symbols');
      var OPSymbols = shared('op-symbols');
      var ObjectProto = Object[PROTOTYPE];
      var USE_NATIVE = typeof $Symbol == 'function';
      var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

      var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

      var setSymbolDesc = DESCRIPTORS && $fails(function () {
        return _create(dP({}, 'a', {
          get: function get() {
            return dP(this, 'a', {
              value: 7
            }).a;
          }
        })).a != 7;
      }) ? function (it, key, D) {
        var protoDesc = gOPD(ObjectProto, key);
        if (protoDesc) delete ObjectProto[key];
        dP(it, key, D);
        if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
      } : dP;

      var wrap = function wrap(tag) {
        var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

        sym._k = tag;
        return sym;
      };

      var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
        return typeof it == 'symbol';
      } : function (it) {
        return it instanceof $Symbol;
      };

      var $defineProperty = function defineProperty(it, key, D) {
        if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
        anObject(it);
        key = toPrimitive(key, true);
        anObject(D);

        if (has(AllSymbols, key)) {
          if (!D.enumerable) {
            if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
          } else {
            if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
            D = _create(D, {
              enumerable: createDesc(0, false)
            });
          }

          return setSymbolDesc(it, key, D);
        }

        return dP(it, key, D);
      };

      var $defineProperties = function defineProperties(it, P) {
        anObject(it);
        var keys = enumKeys(P = toIObject(P));
        var i = 0;
        var l = keys.length;
        var key;

        while (l > i) {
          $defineProperty(it, key = keys[i++], P[key]);
        }

        return it;
      };

      var $create = function create(it, P) {
        return P === undefined ? _create(it) : $defineProperties(_create(it), P);
      };

      var $propertyIsEnumerable = function propertyIsEnumerable(key) {
        var E = isEnum.call(this, key = toPrimitive(key, true));
        if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
        return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
      };

      var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
        it = toIObject(it);
        key = toPrimitive(key, true);
        if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
        var D = gOPD(it, key);
        if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
        return D;
      };

      var $getOwnPropertyNames = function getOwnPropertyNames(it) {
        var names = gOPN(toIObject(it));
        var result = [];
        var i = 0;
        var key;

        while (names.length > i) {
          if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
        }

        return result;
      };

      var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
        var IS_OP = it === ObjectProto;
        var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
        var result = [];
        var i = 0;
        var key;

        while (names.length > i) {
          if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
        }

        return result;
      }; // 19.4.1.1 Symbol([description])


      if (!USE_NATIVE) {
        $Symbol = function Symbol() {
          if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
          var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

          var $set = function $set(value) {
            if (this === ObjectProto) $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
          };

          if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
            configurable: true,
            set: $set
          });
          return wrap(tag);
        };

        redefine($Symbol[PROTOTYPE], 'toString', function toString() {
          return this._k;
        });
        $GOPD.f = $getOwnPropertyDescriptor;
        $DP.f = $defineProperty;
        __webpack_require__(646).f = gOPNExt.f = $getOwnPropertyNames;
        __webpack_require__(257).f = $propertyIsEnumerable;
        $GOPS.f = $getOwnPropertySymbols;

        if (DESCRIPTORS && !__webpack_require__(259)) {
          redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
        }

        wksExt.f = function (name) {
          return wrap(wks(name));
        };
      }

      $export($export.G + $export.W + $export.F * !USE_NATIVE, {
        Symbol: $Symbol
      });

      for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
      'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
        wks(es6Symbols[j++]);
      }

      for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
        wksDefine(wellKnownSymbols[k++]);
      }

      $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
        // 19.4.2.1 Symbol.for(key)
        'for': function _for(key) {
          return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
        },
        // 19.4.2.5 Symbol.keyFor(sym)
        keyFor: function keyFor(sym) {
          if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

          for (var key in SymbolRegistry) {
            if (SymbolRegistry[key] === sym) return key;
          }
        },
        useSetter: function useSetter() {
          setter = true;
        },
        useSimple: function useSimple() {
          setter = false;
        }
      });
      $export($export.S + $export.F * !USE_NATIVE, 'Object', {
        // 19.1.2.2 Object.create(O [, Properties])
        create: $create,
        // 19.1.2.4 Object.defineProperty(O, P, Attributes)
        defineProperty: $defineProperty,
        // 19.1.2.3 Object.defineProperties(O, Properties)
        defineProperties: $defineProperties,
        // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
        // 19.1.2.7 Object.getOwnPropertyNames(O)
        getOwnPropertyNames: $getOwnPropertyNames,
        // 19.1.2.8 Object.getOwnPropertySymbols(O)
        getOwnPropertySymbols: $getOwnPropertySymbols
      }); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
      // https://bugs.chromium.org/p/v8/issues/detail?id=3443

      var FAILS_ON_PRIMITIVES = $fails(function () {
        $GOPS.f(1);
      });
      $export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
          return $GOPS.f(toObject(it));
        }
      }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

      $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
        var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
        // WebKit converts symbol values to JSON as null
        // V8 throws on boxed symbols

        return _stringify([S]) != '[null]' || _stringify({
          a: S
        }) != '{}' || _stringify(Object(S)) != '{}';
      })), 'JSON', {
        stringify: function stringify(it) {
          var args = [it];
          var i = 1;
          var replacer, $replacer;

          while (arguments.length > i) {
            args.push(arguments[i++]);
          }

          $replacer = replacer = args[1];
          if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

          if (!isArray(replacer)) replacer = function replacer(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!isSymbol(value)) return value;
          };
          args[1] = replacer;
          return _stringify.apply($JSON, args);
        }
      }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

      $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(181)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

      setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

      setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

      setToStringTag(global.JSON, 'JSON', true);
      /***/
    },
    /* 1153 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(1152);

      __webpack_require__(1147);

      __webpack_require__(1146);

      __webpack_require__(1145);

      module.exports = __webpack_require__(89).Symbol;
      /***/
    },
    /* 1154 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1153),
        __esModule: true
      };
      /***/
    },
    /* 1155 */

    /***/
    function (module, exports) {
      module.exports = function (done, value) {
        return {
          value: value,
          done: !!done
        };
      };
      /***/

    },
    /* 1156 */

    /***/
    function (module, exports) {
      module.exports = function () {
        /* empty */
      };
      /***/

    },
    /* 1157 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var addToUnscopables = __webpack_require__(1156);

      var step = __webpack_require__(1155);

      var Iterators = __webpack_require__(178);

      var toIObject = __webpack_require__(159); // 22.1.3.4 Array.prototype.entries()
      // 22.1.3.13 Array.prototype.keys()
      // 22.1.3.29 Array.prototype.values()
      // 22.1.3.30 Array.prototype[@@iterator]()


      module.exports = __webpack_require__(649)(Array, 'Array', function (iterated, kind) {
        this._t = toIObject(iterated); // target

        this._i = 0; // next index

        this._k = kind; // kind
        // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
      }, function () {
        var O = this._t;
        var kind = this._k;
        var index = this._i++;

        if (!O || index >= O.length) {
          this._t = undefined;
          return step(1);
        }

        if (kind == 'keys') return step(0, index);
        if (kind == 'values') return step(0, O[index]);
        return step(0, [index, O[index]]);
      }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

      Iterators.Arguments = Iterators.Array;
      addToUnscopables('keys');
      addToUnscopables('values');
      addToUnscopables('entries');
      /***/
    },
    /* 1158 */

    /***/
    function (module, exports, __webpack_require__) {
      var document = __webpack_require__(138).document;

      module.exports = document && document.documentElement;
      /***/
    },
    /* 1159 */

    /***/
    function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(137);

      var anObject = __webpack_require__(161);

      var getKeys = __webpack_require__(260);

      module.exports = __webpack_require__(136) ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = getKeys(Properties);
        var length = keys.length;
        var i = 0;
        var P;

        while (length > i) {
          dP.f(O, P = keys[i++], Properties[P]);
        }

        return O;
      };
      /***/
    },
    /* 1160 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var create = __webpack_require__(360);

      var descriptor = __webpack_require__(214);

      var setToStringTag = __webpack_require__(359);

      var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

      __webpack_require__(181)(IteratorPrototype, __webpack_require__(110)('iterator'), function () {
        return this;
      });

      module.exports = function (Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, {
          next: descriptor(1, next)
        });
        setToStringTag(Constructor, NAME + ' Iterator');
      };
      /***/

    },
    /* 1161 */

    /***/
    function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(365);

      var defined = __webpack_require__(366); // true  -> String#at
      // false -> String#codePointAt


      module.exports = function (TO_STRING) {
        return function (that, pos) {
          var s = String(defined(that));
          var i = toInteger(pos);
          var l = s.length;
          var a, b;
          if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
          a = s.charCodeAt(i);
          return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
        };
      };
      /***/

    },
    /* 1162 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(256);

      __webpack_require__(358);

      module.exports = __webpack_require__(357).f('iterator');
      /***/
    },
    /* 1163 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1162),
        __esModule: true
      };
      /***/
    },
    /* 1164 */

    /***/
    function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(365);

      var max = Math.max;
      var min = Math.min;

      module.exports = function (index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };
      /***/

    },
    /* 1165 */

    /***/
    function (module, exports, __webpack_require__) {
      // false -> Array#indexOf
      // true  -> Array#includes
      var toIObject = __webpack_require__(159);

      var toLength = __webpack_require__(650);

      var toAbsoluteIndex = __webpack_require__(1164);

      module.exports = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value; // Array#includes uses SameValueZero equality algorithm
          // eslint-disable-next-line no-self-compare

          if (IS_INCLUDES && el != el) while (length > index) {
            value = O[index++]; // eslint-disable-next-line no-self-compare

            if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
          } else for (; length > index; index++) {
            if (IS_INCLUDES || index in O) {
              if (O[index] === el) return IS_INCLUDES || index || 0;
            }
          }
          return !IS_INCLUDES && -1;
        };
      };
      /***/

    },
    /* 1166 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // 19.1.2.1 Object.assign(target, source, ...)

      var DESCRIPTORS = __webpack_require__(136);

      var getKeys = __webpack_require__(260);

      var gOPS = __webpack_require__(361);

      var pIE = __webpack_require__(257);

      var toObject = __webpack_require__(213);

      var IObject = __webpack_require__(651);

      var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

      module.exports = !$assign || __webpack_require__(179)(function () {
        var A = {};
        var B = {}; // eslint-disable-next-line no-undef

        var S = Symbol();
        var K = 'abcdefghijklmnopqrst';
        A[S] = 7;
        K.split('').forEach(function (k) {
          B[k] = k;
        });
        return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
      }) ? function assign(target, source) {
        // eslint-disable-line no-unused-vars
        var T = toObject(target);
        var aLen = arguments.length;
        var index = 1;
        var getSymbols = gOPS.f;
        var isEnum = pIE.f;

        while (aLen > index) {
          var S = IObject(arguments[index++]);
          var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
          var length = keys.length;
          var j = 0;
          var key;

          while (length > j) {
            key = keys[j++];
            if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
          }
        }

        return T;
      } : $assign;
      /***/
    },
    /* 1167 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.3.1 Object.assign(target, source)
      var $export = __webpack_require__(139);

      $export($export.S + $export.F, 'Object', {
        assign: __webpack_require__(1166)
      });
      /***/
    },
    /* 1168 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(1167);

      module.exports = __webpack_require__(89).Object.assign;
      /***/
    },
    /* 1169 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(1168),
        __esModule: true
      };
      /***/
    },
    /* 1170 */

    /***/
    function (module, exports) {
      module.exports = function (it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
      };
      /***/

    },
    /* 1171 */

    /***/
    function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(139); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


      $export($export.S + $export.F * !__webpack_require__(136), 'Object', {
        defineProperty: __webpack_require__(137).f
      });
      /***/
    },
    /* 1172 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(1171);

      var $Object = __webpack_require__(89).Object;

      module.exports = function defineProperty(it, key, desc) {
        return $Object.defineProperty(it, key, desc);
      };
      /***/

    },
    /* 1173 */

    /***/
    function (module, exports) {
      /**
       * lodash (Custom Build) <https://lodash.com/>
       * Build: `lodash modularize exports="npm" -o ./`
       * Copyright jQuery Foundation and other contributors <https://jquery.org/>
       * Released under MIT license <https://lodash.com/license>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       */

      /** Used as references for various `Number` constants. */
      var MAX_SAFE_INTEGER = 9007199254740991;
      /** `Object#toString` result references. */

      var argsTag = '[object Arguments]',
          funcTag = '[object Function]',
          genTag = '[object GeneratorFunction]';
      /** Used to detect unsigned integer values. */

      var reIsUint = /^(?:0|[1-9]\d*)$/;
      /**
       * A faster alternative to `Function#apply`, this function invokes `func`
       * with the `this` binding of `thisArg` and the arguments of `args`.
       *
       * @private
       * @param {Function} func The function to invoke.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {Array} args The arguments to invoke `func` with.
       * @returns {*} Returns the result of `func`.
       */

      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);

          case 1:
            return func.call(thisArg, args[0]);

          case 2:
            return func.call(thisArg, args[0], args[1]);

          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }

        return func.apply(thisArg, args);
      }
      /**
       * The base implementation of `_.times` without support for iteratee shorthands
       * or max array length checks.
       *
       * @private
       * @param {number} n The number of times to invoke `iteratee`.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the array of results.
       */


      function baseTimes(n, iteratee) {
        var index = -1,
            result = Array(n);

        while (++index < n) {
          result[index] = iteratee(index);
        }

        return result;
      }
      /**
       * Creates a unary function that invokes `func` with its argument transformed.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {Function} transform The argument transform.
       * @returns {Function} Returns the new function.
       */


      function overArg(func, transform) {
        return function (arg) {
          return func(transform(arg));
        };
      }
      /** Used for built-in method references. */


      var objectProto = Object.prototype;
      /** Used to check objects for own properties. */

      var hasOwnProperty = objectProto.hasOwnProperty;
      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */

      var objectToString = objectProto.toString;
      /** Built-in value references. */

      var propertyIsEnumerable = objectProto.propertyIsEnumerable;
      /* Built-in method references for those with the same name as other `lodash` methods. */

      var nativeKeys = overArg(Object.keys, Object),
          nativeMax = Math.max;
      /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */

      var nonEnumShadows = !propertyIsEnumerable.call({
        'valueOf': 1
      }, 'valueOf');
      /**
       * Creates an array of the enumerable property names of the array-like `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @param {boolean} inherited Specify returning inherited property names.
       * @returns {Array} Returns the array of property names.
       */

      function arrayLikeKeys(value, inherited) {
        // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
        // Safari 9 makes `arguments.length` enumerable in strict mode.
        var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
        var length = result.length,
            skipIndexes = !!length;

        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
            result.push(key);
          }
        }

        return result;
      }
      /**
       * Assigns `value` to `key` of `object` if the existing value is not equivalent
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */


      function assignValue(object, key, value) {
        var objValue = object[key];

        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
          object[key] = value;
        }
      }
      /**
       * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */


      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }

        var result = [];

        for (var key in Object(object)) {
          if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
          }
        }

        return result;
      }
      /**
       * The base implementation of `_.rest` which doesn't validate or coerce arguments.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       */


      function baseRest(func, start) {
        start = nativeMax(start === undefined ? func.length - 1 : start, 0);
        return function () {
          var args = arguments,
              index = -1,
              length = nativeMax(args.length - start, 0),
              array = Array(length);

          while (++index < length) {
            array[index] = args[start + index];
          }

          index = -1;
          var otherArgs = Array(start + 1);

          while (++index < start) {
            otherArgs[index] = args[index];
          }

          otherArgs[start] = array;
          return apply(func, this, otherArgs);
        };
      }
      /**
       * Copies properties of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy properties from.
       * @param {Array} props The property identifiers to copy.
       * @param {Object} [object={}] The object to copy properties to.
       * @param {Function} [customizer] The function to customize copied values.
       * @returns {Object} Returns `object`.
       */


      function copyObject(source, props, object, customizer) {
        object || (object = {});
        var index = -1,
            length = props.length;

        while (++index < length) {
          var key = props[index];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
          assignValue(object, key, newValue === undefined ? source[key] : newValue);
        }

        return object;
      }
      /**
       * Creates a function like `_.assign`.
       *
       * @private
       * @param {Function} assigner The function to assign values.
       * @returns {Function} Returns the new assigner function.
       */


      function createAssigner(assigner) {
        return baseRest(function (object, sources) {
          var index = -1,
              length = sources.length,
              customizer = length > 1 ? sources[length - 1] : undefined,
              guard = length > 2 ? sources[2] : undefined;
          customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
          }

          object = Object(object);

          while (++index < length) {
            var source = sources[index];

            if (source) {
              assigner(object, source, index, customizer);
            }
          }

          return object;
        });
      }
      /**
       * Checks if `value` is a valid array-like index.
       *
       * @private
       * @param {*} value The value to check.
       * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
       * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
       */


      function isIndex(value, length) {
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
      }
      /**
       * Checks if the given arguments are from an iteratee call.
       *
       * @private
       * @param {*} value The potential iteratee value argument.
       * @param {*} index The potential iteratee index or key argument.
       * @param {*} object The potential iteratee object argument.
       * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
       *  else `false`.
       */


      function isIterateeCall(value, index, object) {
        if (!isObject(object)) {
          return false;
        }

        var type = typeof index;

        if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
          return eq(object[index], value);
        }

        return false;
      }
      /**
       * Checks if `value` is likely a prototype object.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
       */


      function isPrototype(value) {
        var Ctor = value && value.constructor,
            proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
        return value === proto;
      }
      /**
       * Performs a
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * comparison between two values to determine if they are equivalent.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * var object = { 'a': 1 };
       * var other = { 'a': 1 };
       *
       * _.eq(object, object);
       * // => true
       *
       * _.eq(object, other);
       * // => false
       *
       * _.eq('a', 'a');
       * // => true
       *
       * _.eq('a', Object('a'));
       * // => false
       *
       * _.eq(NaN, NaN);
       * // => true
       */


      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      /**
       * Checks if `value` is likely an `arguments` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       *  else `false`.
       * @example
       *
       * _.isArguments(function() { return arguments; }());
       * // => true
       *
       * _.isArguments([1, 2, 3]);
       * // => false
       */


      function isArguments(value) {
        // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
        return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
      }
      /**
       * Checks if `value` is classified as an `Array` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array, else `false`.
       * @example
       *
       * _.isArray([1, 2, 3]);
       * // => true
       *
       * _.isArray(document.body.children);
       * // => false
       *
       * _.isArray('abc');
       * // => false
       *
       * _.isArray(_.noop);
       * // => false
       */


      var isArray = Array.isArray;
      /**
       * Checks if `value` is array-like. A value is considered array-like if it's
       * not a function and has a `value.length` that's an integer greater than or
       * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
       * @example
       *
       * _.isArrayLike([1, 2, 3]);
       * // => true
       *
       * _.isArrayLike(document.body.children);
       * // => true
       *
       * _.isArrayLike('abc');
       * // => true
       *
       * _.isArrayLike(_.noop);
       * // => false
       */

      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }
      /**
       * This method is like `_.isArrayLike` except that it also checks if `value`
       * is an object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array-like object,
       *  else `false`.
       * @example
       *
       * _.isArrayLikeObject([1, 2, 3]);
       * // => true
       *
       * _.isArrayLikeObject(document.body.children);
       * // => true
       *
       * _.isArrayLikeObject('abc');
       * // => false
       *
       * _.isArrayLikeObject(_.noop);
       * // => false
       */


      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      /**
       * Checks if `value` is classified as a `Function` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a function, else `false`.
       * @example
       *
       * _.isFunction(_);
       * // => true
       *
       * _.isFunction(/abc/);
       * // => false
       */


      function isFunction(value) {
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 8-9 which returns 'object' for typed array and other constructors.
        var tag = isObject(value) ? objectToString.call(value) : '';
        return tag == funcTag || tag == genTag;
      }
      /**
       * Checks if `value` is a valid array-like length.
       *
       * **Note:** This method is loosely based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
       * @example
       *
       * _.isLength(3);
       * // => true
       *
       * _.isLength(Number.MIN_VALUE);
       * // => false
       *
       * _.isLength(Infinity);
       * // => false
       *
       * _.isLength('3');
       * // => false
       */


      function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      /**
       * Checks if `value` is the
       * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
       * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(_.noop);
       * // => true
       *
       * _.isObject(null);
       * // => false
       */


      function isObject(value) {
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
      }
      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */


      function isObjectLike(value) {
        return !!value && typeof value == 'object';
      }
      /**
       * Assigns own enumerable string keyed properties of source objects to the
       * destination object. Source objects are applied from left to right.
       * Subsequent sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object` and is loosely based on
       * [`Object.assign`](https://mdn.io/Object/assign).
       *
       * @static
       * @memberOf _
       * @since 0.10.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.assignIn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * function Bar() {
       *   this.c = 3;
       * }
       *
       * Foo.prototype.b = 2;
       * Bar.prototype.d = 4;
       *
       * _.assign({ 'a': 0 }, new Foo, new Bar);
       * // => { 'a': 1, 'c': 3 }
       */


      var assign = createAssigner(function (object, source) {
        if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }

        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      /**
       * Creates an array of the own enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects. See the
       * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * for more details.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keys(new Foo);
       * // => ['a', 'b'] (iteration order is not guaranteed)
       *
       * _.keys('hi');
       * // => ['0', '1']
       */

      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }

      module.exports = assign;
      /***/
    },
    /* 1174 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (process) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var assign = __webpack_require__(1173);

        function addGraphQLSubscriptions(networkInterface, wsClient) {
          if (process && process.env && "production" !== 'production') {
            console.warn('Notice that addGraphQLSubscriptions method will become deprecated in the new package ' + 'graphql-transport-ws that will be released soon. Keep track for the new hybrid network release here: ' + 'https://github.com/apollographql/subscriptions-transport-ws/issues/169');
          }

          return assign(networkInterface, {
            subscribe: function subscribe(request, handler) {
              return wsClient.subscribe(request, handler);
            },
            unsubscribe: function unsubscribe(id) {
              wsClient.unsubscribe(id);
            }
          });
        }

        exports.addGraphQLSubscriptions = addGraphQLSubscriptions;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(162));
      /***/
    },
    /* 1175 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var MessageTypes = function () {
        function MessageTypes() {
          throw new Error('Static Class');
        }

        MessageTypes.GQL_CONNECTION_INIT = 'connection_init';
        MessageTypes.GQL_CONNECTION_ACK = 'connection_ack';
        MessageTypes.GQL_CONNECTION_ERROR = 'connection_error';
        MessageTypes.GQL_CONNECTION_KEEP_ALIVE = 'ka';
        MessageTypes.GQL_CONNECTION_TERMINATE = 'connection_terminate';
        MessageTypes.GQL_START = 'start';
        MessageTypes.GQL_DATA = 'data';
        MessageTypes.GQL_ERROR = 'error';
        MessageTypes.GQL_COMPLETE = 'complete';
        MessageTypes.GQL_STOP = 'stop';
        MessageTypes.SUBSCRIPTION_START = 'subscription_start';
        MessageTypes.SUBSCRIPTION_DATA = 'subscription_data';
        MessageTypes.SUBSCRIPTION_SUCCESS = 'subscription_success';
        MessageTypes.SUBSCRIPTION_FAIL = 'subscription_fail';
        MessageTypes.SUBSCRIPTION_END = 'subscription_end';
        MessageTypes.INIT = 'init';
        MessageTypes.INIT_SUCCESS = 'init_success';
        MessageTypes.INIT_FAIL = 'init_fail';
        return MessageTypes;
      }();

      exports.default = MessageTypes;
      /***/
    },
    /* 1176 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var WS_TIMEOUT = 10000;
      exports.WS_TIMEOUT = WS_TIMEOUT;
      /***/
    },
    /* 1177 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var GRAPHQL_WS = 'graphql-ws';
      exports.GRAPHQL_WS = GRAPHQL_WS;
      var GRAPHQL_SUBSCRIPTIONS = 'graphql-subscriptions';
      exports.GRAPHQL_SUBSCRIPTIONS = GRAPHQL_SUBSCRIPTIONS;
      /***/
    },
    /* 1178 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getOperationAST = getOperationAST;

      var _kinds = __webpack_require__(656);
      /**
       * Returns an operation AST given a document AST and optionally an operation
       * name. If a name is not provided, an operation is only returned if only one is
       * provided in the document.
       */


      function getOperationAST(documentAST, operationName) {
        var operation = null;

        for (var i = 0; i < documentAST.definitions.length; i++) {
          var definition = documentAST.definitions[i];

          if (definition.kind === _kinds.OPERATION_DEFINITION) {
            if (!operationName) {
              // If no operation name was provided, only return an Operation if there
              // is one defined in the document. Upon encountering the second, return
              // null.
              if (operation) {
                return null;
              }

              operation = definition;
            } else if (definition.name && definition.name.value === operationName) {
              return definition;
            }
          }
        }

        return operation;
      }
      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */

      /***/

    },
    /* 1179 */

    /***/
    function (module, exports) {
      /**
       * lodash 3.0.2 (Custom Build) <https://lodash.com/>
       * Build: `lodash modern modularize exports="npm" -o ./`
       * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       * Available under MIT license <https://lodash.com/license>
       */

      /**
       * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
       * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(1);
       * // => false
       */
      function isObject(value) {
        // Avoid a V8 JIT bug in Chrome 19-20.
        // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
      }

      module.exports = isObject;
      /***/
    },
    /* 1180 */

    /***/
    function (module, exports) {
      /**
       * lodash 4.0.1 (Custom Build) <https://lodash.com/>
       * Build: `lodash modularize exports="npm" -o ./`
       * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       * Available under MIT license <https://lodash.com/license>
       */

      /** `Object#toString` result references. */
      var stringTag = '[object String]';
      /** Used for built-in method references. */

      var objectProto = Object.prototype;
      /**
       * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
       * of values.
       */

      var objectToString = objectProto.toString;
      /**
       * Checks if `value` is classified as an `Array` object.
       *
       * @static
       * @memberOf _
       * @type Function
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
       * @example
       *
       * _.isArray([1, 2, 3]);
       * // => true
       *
       * _.isArray(document.body.children);
       * // => false
       *
       * _.isArray('abc');
       * // => false
       *
       * _.isArray(_.noop);
       * // => false
       */

      var isArray = Array.isArray;
      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */

      function isObjectLike(value) {
        return !!value && typeof value == 'object';
      }
      /**
       * Checks if `value` is classified as a `String` primitive or object.
       *
       * @static
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
       * @example
       *
       * _.isString('abc');
       * // => true
       *
       * _.isString(1);
       * // => false
       */


      function isString(value) {
        return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag;
      }

      module.exports = isString;
      /***/
    },
    /* 1181 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var has = Object.prototype.hasOwnProperty,
          prefix = '~';
      /**
       * Constructor to create a storage for our `EE` objects.
       * An `Events` instance is a plain object whose properties are event names.
       *
       * @constructor
       * @api private
       */

      function Events() {} //
      // We try to not inherit from `Object.prototype`. In some engines creating an
      // instance in this way is faster than calling `Object.create(null)` directly.
      // If `Object.create(null)` is not supported we prefix the event names with a
      // character to make sure that the built-in object properties are not
      // overridden or used as an attack vector.
      //


      if (Object.create) {
        Events.prototype = Object.create(null); //
        // This hack is needed because the `__proto__` property is still inherited in
        // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
        //

        if (!new Events().__proto__) prefix = false;
      }
      /**
       * Representation of a single event listener.
       *
       * @param {Function} fn The listener function.
       * @param {Mixed} context The context to invoke the listener with.
       * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
       * @constructor
       * @api private
       */


      function EE(fn, context, once) {
        this.fn = fn;
        this.context = context;
        this.once = once || false;
      }
      /**
       * Minimal `EventEmitter` interface that is molded against the Node.js
       * `EventEmitter` interface.
       *
       * @constructor
       * @api public
       */


      function EventEmitter() {
        this._events = new Events();
        this._eventsCount = 0;
      }
      /**
       * Return an array listing the events for which the emitter has registered
       * listeners.
       *
       * @returns {Array}
       * @api public
       */


      EventEmitter.prototype.eventNames = function eventNames() {
        var names = [],
            events,
            name;
        if (this._eventsCount === 0) return names;

        for (name in events = this._events) {
          if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
        }

        if (Object.getOwnPropertySymbols) {
          return names.concat(Object.getOwnPropertySymbols(events));
        }

        return names;
      };
      /**
       * Return the listeners registered for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Boolean} exists Only check if there are listeners.
       * @returns {Array|Boolean}
       * @api public
       */


      EventEmitter.prototype.listeners = function listeners(event, exists) {
        var evt = prefix ? prefix + event : event,
            available = this._events[evt];
        if (exists) return !!available;
        if (!available) return [];
        if (available.fn) return [available.fn];

        for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
          ee[i] = available[i].fn;
        }

        return ee;
      };
      /**
       * Calls each of the listeners registered for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @returns {Boolean} `true` if the event had listeners, else `false`.
       * @api public
       */


      EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return false;
        var listeners = this._events[evt],
            len = arguments.length,
            args,
            i;

        if (listeners.fn) {
          if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

          switch (len) {
            case 1:
              return listeners.fn.call(listeners.context), true;

            case 2:
              return listeners.fn.call(listeners.context, a1), true;

            case 3:
              return listeners.fn.call(listeners.context, a1, a2), true;

            case 4:
              return listeners.fn.call(listeners.context, a1, a2, a3), true;

            case 5:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;

            case 6:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
          }

          for (i = 1, args = new Array(len - 1); i < len; i++) {
            args[i - 1] = arguments[i];
          }

          listeners.fn.apply(listeners.context, args);
        } else {
          var length = listeners.length,
              j;

          for (i = 0; i < length; i++) {
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

            switch (len) {
              case 1:
                listeners[i].fn.call(listeners[i].context);
                break;

              case 2:
                listeners[i].fn.call(listeners[i].context, a1);
                break;

              case 3:
                listeners[i].fn.call(listeners[i].context, a1, a2);
                break;

              case 4:
                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                break;

              default:
                if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                  args[j - 1] = arguments[j];
                }
                listeners[i].fn.apply(listeners[i].context, args);
            }
          }
        }

        return true;
      };
      /**
       * Add a listener for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Function} fn The listener function.
       * @param {Mixed} [context=this] The context to invoke the listener with.
       * @returns {EventEmitter} `this`.
       * @api public
       */


      EventEmitter.prototype.on = function on(event, fn, context) {
        var listener = new EE(fn, context || this),
            evt = prefix ? prefix + event : event;
        if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
        return this;
      };
      /**
       * Add a one-time listener for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Function} fn The listener function.
       * @param {Mixed} [context=this] The context to invoke the listener with.
       * @returns {EventEmitter} `this`.
       * @api public
       */


      EventEmitter.prototype.once = function once(event, fn, context) {
        var listener = new EE(fn, context || this, true),
            evt = prefix ? prefix + event : event;
        if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
        return this;
      };
      /**
       * Remove the listeners of a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Function} fn Only remove the listeners that match this function.
       * @param {Mixed} context Only remove the listeners that have this context.
       * @param {Boolean} once Only remove one-time listeners.
       * @returns {EventEmitter} `this`.
       * @api public
       */


      EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return this;

        if (!fn) {
          if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          return this;
        }

        var listeners = this._events[evt];

        if (listeners.fn) {
          if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
            if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          }
        } else {
          for (var i = 0, events = [], length = listeners.length; i < length; i++) {
            if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
              events.push(listeners[i]);
            }
          } //
          // Reset the array, or remove it completely if we have no more listeners.
          //


          if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
        }

        return this;
      };
      /**
       * Remove all listeners, or those of the specified event.
       *
       * @param {String|Symbol} [event] The event name.
       * @returns {EventEmitter} `this`.
       * @api public
       */


      EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
        var evt;

        if (event) {
          evt = prefix ? prefix + event : event;

          if (this._events[evt]) {
            if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          }
        } else {
          this._events = new Events();
          this._eventsCount = 0;
        }

        return this;
      }; //
      // Alias methods names because people roll like that.
      //


      EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
      EventEmitter.prototype.addListener = EventEmitter.prototype.on; //
      // This function doesn't apply anymore.
      //

      EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
        return this;
      }; //
      // Expose the prefix.
      //


      EventEmitter.prefixed = prefix; //
      // Allow `EventEmitter` to be imported as module namespace.
      //

      EventEmitter.EventEmitter = EventEmitter; //
      // Expose the module.
      //

      if (true) {
        module.exports = EventEmitter;
      }
      /***/

    },
    /* 1182 */

    /***/
    function (module, exports) {
      /**
       * Expose `Backoff`.
       */
      module.exports = Backoff;
      /**
       * Initialize backoff timer with `opts`.
       *
       * - `min` initial timeout in milliseconds [100]
       * - `max` max timeout [10000]
       * - `jitter` [0]
       * - `factor` [2]
       *
       * @param {Object} opts
       * @api public
       */

      function Backoff(opts) {
        opts = opts || {};
        this.ms = opts.min || 100;
        this.max = opts.max || 10000;
        this.factor = opts.factor || 2;
        this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
        this.attempts = 0;
      }
      /**
       * Return the backoff duration.
       *
       * @return {Number}
       * @api public
       */


      Backoff.prototype.duration = function () {
        var ms = this.ms * Math.pow(this.factor, this.attempts++);

        if (this.jitter) {
          var rand = Math.random();
          var deviation = Math.floor(rand * this.jitter * ms);
          ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
        }

        return Math.min(ms, this.max) | 0;
      };
      /**
       * Reset the number of attempts.
       *
       * @api public
       */


      Backoff.prototype.reset = function () {
        this.attempts = 0;
      };
      /**
       * Set the minimum duration
       *
       * @api public
       */


      Backoff.prototype.setMin = function (min) {
        this.ms = min;
      };
      /**
       * Set the maximum duration
       *
       * @api public
       */


      Backoff.prototype.setMax = function (max) {
        this.max = max;
      };
      /**
       * Set the jitter
       *
       * @api public
       */


      Backoff.prototype.setJitter = function (jitter) {
        this.jitter = jitter;
      };
      /***/

    },
    /* 1183 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global) {
        /**
        * lodash (Custom Build) <https://lodash.com/>
        * Build: `lodash modularize exports="npm" -o ./`
        * Copyright jQuery Foundation and other contributors <https://jquery.org/>
        * Released under MIT license <https://lodash.com/license>
        * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
        * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
        */

        /** Used as references for various `Number` constants. */
        var INFINITY = 1 / 0,
            MAX_SAFE_INTEGER = 9007199254740991;
        /** `Object#toString` result references. */

        var argsTag = '[object Arguments]',
            funcTag = '[object Function]',
            genTag = '[object GeneratorFunction]',
            symbolTag = '[object Symbol]';
        /** Detect free variable `global` from Node.js. */

        var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
        /** Detect free variable `self`. */

        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        /** Used as a reference to the global object. */

        var root = freeGlobal || freeSelf || Function('return this')();
        /**
         * A faster alternative to `Function#apply`, this function invokes `func`
         * with the `this` binding of `thisArg` and the arguments of `args`.
         *
         * @private
         * @param {Function} func The function to invoke.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {Array} args The arguments to invoke `func` with.
         * @returns {*} Returns the result of `func`.
         */

        function apply(func, thisArg, args) {
          switch (args.length) {
            case 0:
              return func.call(thisArg);

            case 1:
              return func.call(thisArg, args[0]);

            case 2:
              return func.call(thisArg, args[0], args[1]);

            case 3:
              return func.call(thisArg, args[0], args[1], args[2]);
          }

          return func.apply(thisArg, args);
        }
        /**
         * A specialized version of `_.map` for arrays without support for iteratee
         * shorthands.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         */


        function arrayMap(array, iteratee) {
          var index = -1,
              length = array ? array.length : 0,
              result = Array(length);

          while (++index < length) {
            result[index] = iteratee(array[index], index, array);
          }

          return result;
        }
        /**
         * Appends the elements of `values` to `array`.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {Array} values The values to append.
         * @returns {Array} Returns `array`.
         */


        function arrayPush(array, values) {
          var index = -1,
              length = values.length,
              offset = array.length;

          while (++index < length) {
            array[offset + index] = values[index];
          }

          return array;
        }
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */

        var objectToString = objectProto.toString;
        /** Built-in value references. */

        var Symbol = root.Symbol,
            propertyIsEnumerable = objectProto.propertyIsEnumerable,
            spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
        /* Built-in method references for those with the same name as other `lodash` methods. */

        var nativeMax = Math.max;
        /**
         * The base implementation of `_.flatten` with support for restricting flattening.
         *
         * @private
         * @param {Array} array The array to flatten.
         * @param {number} depth The maximum recursion depth.
         * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
         * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
         * @param {Array} [result=[]] The initial result value.
         * @returns {Array} Returns the new flattened array.
         */

        function baseFlatten(array, depth, predicate, isStrict, result) {
          var index = -1,
              length = array.length;
          predicate || (predicate = isFlattenable);
          result || (result = []);

          while (++index < length) {
            var value = array[index];

            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                // Recursively flatten arrays (susceptible to call stack limits).
                baseFlatten(value, depth - 1, predicate, isStrict, result);
              } else {
                arrayPush(result, value);
              }
            } else if (!isStrict) {
              result[result.length] = value;
            }
          }

          return result;
        }
        /**
         * The base implementation of `_.pick` without support for individual
         * property identifiers.
         *
         * @private
         * @param {Object} object The source object.
         * @param {string[]} props The property identifiers to pick.
         * @returns {Object} Returns the new object.
         */


        function basePick(object, props) {
          object = Object(object);
          return basePickBy(object, props, function (value, key) {
            return key in object;
          });
        }
        /**
         * The base implementation of  `_.pickBy` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The source object.
         * @param {string[]} props The property identifiers to pick from.
         * @param {Function} predicate The function invoked per property.
         * @returns {Object} Returns the new object.
         */


        function basePickBy(object, props, predicate) {
          var index = -1,
              length = props.length,
              result = {};

          while (++index < length) {
            var key = props[index],
                value = object[key];

            if (predicate(value, key)) {
              result[key] = value;
            }
          }

          return result;
        }
        /**
         * The base implementation of `_.rest` which doesn't validate or coerce arguments.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         */


        function baseRest(func, start) {
          start = nativeMax(start === undefined ? func.length - 1 : start, 0);
          return function () {
            var args = arguments,
                index = -1,
                length = nativeMax(args.length - start, 0),
                array = Array(length);

            while (++index < length) {
              array[index] = args[start + index];
            }

            index = -1;
            var otherArgs = Array(start + 1);

            while (++index < start) {
              otherArgs[index] = args[index];
            }

            otherArgs[start] = array;
            return apply(func, this, otherArgs);
          };
        }
        /**
         * Checks if `value` is a flattenable `arguments` object or array.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
         */


        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
         * Converts `value` to a string key if it's not a string or symbol.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {string|symbol} Returns the key.
         */


        function toKey(value) {
          if (typeof value == 'string' || isSymbol(value)) {
            return value;
          }

          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
         * Checks if `value` is likely an `arguments` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         *  else `false`.
         * @example
         *
         * _.isArguments(function() { return arguments; }());
         * // => true
         *
         * _.isArguments([1, 2, 3]);
         * // => false
         */


        function isArguments(value) {
          // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
          return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
        }
        /**
         * Checks if `value` is classified as an `Array` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array, else `false`.
         * @example
         *
         * _.isArray([1, 2, 3]);
         * // => true
         *
         * _.isArray(document.body.children);
         * // => false
         *
         * _.isArray('abc');
         * // => false
         *
         * _.isArray(_.noop);
         * // => false
         */


        var isArray = Array.isArray;
        /**
         * Checks if `value` is array-like. A value is considered array-like if it's
         * not a function and has a `value.length` that's an integer greater than or
         * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
         * @example
         *
         * _.isArrayLike([1, 2, 3]);
         * // => true
         *
         * _.isArrayLike(document.body.children);
         * // => true
         *
         * _.isArrayLike('abc');
         * // => true
         *
         * _.isArrayLike(_.noop);
         * // => false
         */

        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
         * This method is like `_.isArrayLike` except that it also checks if `value`
         * is an object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array-like object,
         *  else `false`.
         * @example
         *
         * _.isArrayLikeObject([1, 2, 3]);
         * // => true
         *
         * _.isArrayLikeObject(document.body.children);
         * // => true
         *
         * _.isArrayLikeObject('abc');
         * // => false
         *
         * _.isArrayLikeObject(_.noop);
         * // => false
         */


        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        /**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */


        function isFunction(value) {
          // The use of `Object#toString` avoids issues with the `typeof` operator
          // in Safari 8-9 which returns 'object' for typed array and other constructors.
          var tag = isObject(value) ? objectToString.call(value) : '';
          return tag == funcTag || tag == genTag;
        }
        /**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */


        function isLength(value) {
          return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */


        function isObject(value) {
          var type = typeof value;
          return !!value && (type == 'object' || type == 'function');
        }
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */


        function isObjectLike(value) {
          return !!value && typeof value == 'object';
        }
        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */


        function isSymbol(value) {
          return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
        }
        /**
         * Creates an object composed of the picked `object` properties.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The source object.
         * @param {...(string|string[])} [props] The property identifiers to pick.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.pick(object, ['a', 'c']);
         * // => { 'a': 1, 'c': 3 }
         */


        var pick = baseRest(function (object, props) {
          return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
        });
        module.exports = pick;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    },
    /* 1184 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.TokenKind = undefined;
      exports.createLexer = createLexer;
      exports.getTokenDesc = getTokenDesc;

      var _error = __webpack_require__(658);
      /**
       * Given a Source object, this returns a Lexer for that source.
       * A Lexer is a stateful stream generator in that every time
       * it is advanced, it returns the next token in the Source. Assuming the
       * source lexes, the final Token emitted by the lexer will be of kind
       * EOF, after which the lexer will repeatedly return the same EOF token
       * whenever called.
       */


      function createLexer(source, options) {
        var startOfFileToken = new Tok(SOF, 0, 0, 0, 0, null);
        var lexer = {
          source: source,
          options: options,
          lastToken: startOfFileToken,
          token: startOfFileToken,
          line: 1,
          lineStart: 0,
          advance: advanceLexer
        };
        return lexer;
      }
      /*  /
      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */


      function advanceLexer() {
        var token = this.lastToken = this.token;

        if (token.kind !== EOF) {
          do {
            token = token.next = readToken(this, token);
          } while (token.kind === COMMENT);

          this.token = token;
        }

        return token;
      }
      /**
       * The return type of createLexer.
       */
      // Each kind of token.


      var SOF = '<SOF>';
      var EOF = '<EOF>';
      var BANG = '!';
      var DOLLAR = '$';
      var PAREN_L = '(';
      var PAREN_R = ')';
      var SPREAD = '...';
      var COLON = ':';
      var EQUALS = '=';
      var AT = '@';
      var BRACKET_L = '[';
      var BRACKET_R = ']';
      var BRACE_L = '{';
      var PIPE = '|';
      var BRACE_R = '}';
      var NAME = 'Name';
      var INT = 'Int';
      var FLOAT = 'Float';
      var STRING = 'String';
      var COMMENT = 'Comment';
      /**
       * An exported enum describing the different kinds of tokens that the
       * lexer emits.
       */

      var TokenKind = exports.TokenKind = {
        SOF: SOF,
        EOF: EOF,
        BANG: BANG,
        DOLLAR: DOLLAR,
        PAREN_L: PAREN_L,
        PAREN_R: PAREN_R,
        SPREAD: SPREAD,
        COLON: COLON,
        EQUALS: EQUALS,
        AT: AT,
        BRACKET_L: BRACKET_L,
        BRACKET_R: BRACKET_R,
        BRACE_L: BRACE_L,
        PIPE: PIPE,
        BRACE_R: BRACE_R,
        NAME: NAME,
        INT: INT,
        FLOAT: FLOAT,
        STRING: STRING,
        COMMENT: COMMENT
      };
      /**
       * A helper function to describe a token as a string for debugging
       */

      function getTokenDesc(token) {
        var value = token.value;
        return value ? token.kind + ' "' + value + '"' : token.kind;
      }

      var charCodeAt = String.prototype.charCodeAt;
      var slice = String.prototype.slice;
      /**
       * Helper function for constructing the Token object.
       */

      function Tok(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
      } // Print a simplified form when appearing in JSON/util.inspect.


      Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
        return {
          kind: this.kind,
          value: this.value,
          line: this.line,
          column: this.column
        };
      };

      function printCharCode(code) {
        return (// NaN/undefined represents access beyond the end of the file.
          isNaN(code) ? EOF : // Trust JSON for ASCII.
          code < 0x007F ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
          "\"\\u" + ('00' + code.toString(16).toUpperCase()).slice(-4) + '"'
        );
      }
      /**
       * Gets the next token from the source starting at the given position.
       *
       * This skips over whitespace and comments until it finds the next lexable
       * token, then lexes punctuators immediately or calls the appropriate helper
       * function for more complicated tokens.
       */


      function readToken(lexer, prev) {
        var source = lexer.source;
        var body = source.body;
        var bodyLength = body.length;
        var position = positionAfterWhitespace(body, prev.end, lexer);
        var line = lexer.line;
        var col = 1 + position - lexer.lineStart;

        if (position >= bodyLength) {
          return new Tok(EOF, bodyLength, bodyLength, line, col, prev);
        }

        var code = charCodeAt.call(body, position); // SourceCharacter

        if (code < 0x0020 && code !== 0x0009 && code !== 0x000A && code !== 0x000D) {
          throw (0, _error.syntaxError)(source, position, 'Cannot contain the invalid character ' + printCharCode(code) + '.');
        }

        switch (code) {
          // !
          case 33:
            return new Tok(BANG, position, position + 1, line, col, prev);
          // #

          case 35:
            return readComment(source, position, line, col, prev);
          // $

          case 36:
            return new Tok(DOLLAR, position, position + 1, line, col, prev);
          // (

          case 40:
            return new Tok(PAREN_L, position, position + 1, line, col, prev);
          // )

          case 41:
            return new Tok(PAREN_R, position, position + 1, line, col, prev);
          // .

          case 46:
            if (charCodeAt.call(body, position + 1) === 46 && charCodeAt.call(body, position + 2) === 46) {
              return new Tok(SPREAD, position, position + 3, line, col, prev);
            }

            break;
          // :

          case 58:
            return new Tok(COLON, position, position + 1, line, col, prev);
          // =

          case 61:
            return new Tok(EQUALS, position, position + 1, line, col, prev);
          // @

          case 64:
            return new Tok(AT, position, position + 1, line, col, prev);
          // [

          case 91:
            return new Tok(BRACKET_L, position, position + 1, line, col, prev);
          // ]

          case 93:
            return new Tok(BRACKET_R, position, position + 1, line, col, prev);
          // {

          case 123:
            return new Tok(BRACE_L, position, position + 1, line, col, prev);
          // |

          case 124:
            return new Tok(PIPE, position, position + 1, line, col, prev);
          // }

          case 125:
            return new Tok(BRACE_R, position, position + 1, line, col, prev);
          // A-Z _ a-z

          case 65:
          case 66:
          case 67:
          case 68:
          case 69:
          case 70:
          case 71:
          case 72:
          case 73:
          case 74:
          case 75:
          case 76:
          case 77:
          case 78:
          case 79:
          case 80:
          case 81:
          case 82:
          case 83:
          case 84:
          case 85:
          case 86:
          case 87:
          case 88:
          case 89:
          case 90:
          case 95:
          case 97:
          case 98:
          case 99:
          case 100:
          case 101:
          case 102:
          case 103:
          case 104:
          case 105:
          case 106:
          case 107:
          case 108:
          case 109:
          case 110:
          case 111:
          case 112:
          case 113:
          case 114:
          case 115:
          case 116:
          case 117:
          case 118:
          case 119:
          case 120:
          case 121:
          case 122:
            return readName(source, position, line, col, prev);
          // - 0-9

          case 45:
          case 48:
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return readNumber(source, position, code, line, col, prev);
          // "

          case 34:
            return readString(source, position, line, col, prev);
        }

        throw (0, _error.syntaxError)(source, position, unexpectedCharacterMessage(code));
      }
      /**
       * Report a message that an unexpected character was encountered.
       */


      function unexpectedCharacterMessage(code) {
        if (code === 39) {
          // '
          return 'Unexpected single quote character (\'), did you mean to use ' + 'a double quote (")?';
        }

        return 'Cannot parse the unexpected character ' + printCharCode(code) + '.';
      }
      /**
       * Reads from body starting at startPosition until it finds a non-whitespace
       * or commented character, then returns the position of that character for
       * lexing.
       */


      function positionAfterWhitespace(body, startPosition, lexer) {
        var bodyLength = body.length;
        var position = startPosition;

        while (position < bodyLength) {
          var code = charCodeAt.call(body, position); // tab | space | comma | BOM

          if (code === 9 || code === 32 || code === 44 || code === 0xFEFF) {
            ++position;
          } else if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
          } else if (code === 13) {
            // carriage return
            if (charCodeAt.call(body, position + 1) === 10) {
              position += 2;
            } else {
              ++position;
            }

            ++lexer.line;
            lexer.lineStart = position;
          } else {
            break;
          }
        }

        return position;
      }
      /**
       * Reads a comment token from the source file.
       *
       * #[\u0009\u0020-\uFFFF]*
       */


      function readComment(source, start, line, col, prev) {
        var body = source.body;
        var code = void 0;
        var position = start;

        do {
          code = charCodeAt.call(body, ++position);
        } while (code !== null && ( // SourceCharacter but not LineTerminator
        code > 0x001F || code === 0x0009));

        return new Tok(COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
      }
      /**
       * Reads a number token from the source file, either a float
       * or an int depending on whether a decimal point appears.
       *
       * Int:   -?(0|[1-9][0-9]*)
       * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
       */


      function readNumber(source, start, firstCode, line, col, prev) {
        var body = source.body;
        var code = firstCode;
        var position = start;
        var isFloat = false;

        if (code === 45) {
          // -
          code = charCodeAt.call(body, ++position);
        }

        if (code === 48) {
          // 0
          code = charCodeAt.call(body, ++position);

          if (code >= 48 && code <= 57) {
            throw (0, _error.syntaxError)(source, position, 'Invalid number, unexpected digit after 0: ' + printCharCode(code) + '.');
          }
        } else {
          position = readDigits(source, position, code);
          code = charCodeAt.call(body, position);
        }

        if (code === 46) {
          // .
          isFloat = true;
          code = charCodeAt.call(body, ++position);
          position = readDigits(source, position, code);
          code = charCodeAt.call(body, position);
        }

        if (code === 69 || code === 101) {
          // E e
          isFloat = true;
          code = charCodeAt.call(body, ++position);

          if (code === 43 || code === 45) {
            // + -
            code = charCodeAt.call(body, ++position);
          }

          position = readDigits(source, position, code);
        }

        return new Tok(isFloat ? FLOAT : INT, start, position, line, col, prev, slice.call(body, start, position));
      }
      /**
       * Returns the new position in the source after reading digits.
       */


      function readDigits(source, start, firstCode) {
        var body = source.body;
        var position = start;
        var code = firstCode;

        if (code >= 48 && code <= 57) {
          // 0 - 9
          do {
            code = charCodeAt.call(body, ++position);
          } while (code >= 48 && code <= 57); // 0 - 9


          return position;
        }

        throw (0, _error.syntaxError)(source, position, 'Invalid number, expected digit but got: ' + printCharCode(code) + '.');
      }
      /**
       * Reads a string token from the source file.
       *
       * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
       */


      function readString(source, start, line, col, prev) {
        var body = source.body;
        var position = start + 1;
        var chunkStart = position;
        var code = 0;
        var value = '';

        while (position < body.length && (code = charCodeAt.call(body, position)) !== null && // not LineTerminator
        code !== 0x000A && code !== 0x000D && // not Quote (")
        code !== 34) {
          // SourceCharacter
          if (code < 0x0020 && code !== 0x0009) {
            throw (0, _error.syntaxError)(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
          }

          ++position;

          if (code === 92) {
            // \
            value += slice.call(body, chunkStart, position - 1);
            code = charCodeAt.call(body, position);

            switch (code) {
              case 34:
                value += '"';
                break;

              case 47:
                value += '/';
                break;

              case 92:
                value += '\\';
                break;

              case 98:
                value += '\b';
                break;

              case 102:
                value += '\f';
                break;

              case 110:
                value += '\n';
                break;

              case 114:
                value += '\r';
                break;

              case 116:
                value += '\t';
                break;

              case 117:
                // u
                var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));

                if (charCode < 0) {
                  throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: ' + ("\\u" + body.slice(position + 1, position + 5) + '.'));
                }

                value += String.fromCharCode(charCode);
                position += 4;
                break;

              default:
                throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: \\' + String.fromCharCode(code) + '.');
            }

            ++position;
            chunkStart = position;
          }
        }

        if (code !== 34) {
          // quote (")
          throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
        }

        value += slice.call(body, chunkStart, position);
        return new Tok(STRING, start, position + 1, line, col, prev, value);
      }
      /**
       * Converts four hexidecimal chars to the integer that the
       * string represents. For example, uniCharCode('0','0','0','f')
       * will return 15, and uniCharCode('0','0','f','f') returns 255.
       *
       * Returns a negative number on error, if a char was invalid.
       *
       * This is implemented by noting that char2hex() returns -1 on error,
       * which means the result of ORing the char2hex() will also be negative.
       */


      function uniCharCode(a, b, c, d) {
        return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
      }
      /**
       * Converts a hex character to its integer value.
       * '0' becomes 0, '9' becomes 9
       * 'A' becomes 10, 'F' becomes 15
       * 'a' becomes 10, 'f' becomes 15
       *
       * Returns -1 on error.
       */


      function char2hex(a) {
        return a >= 48 && a <= 57 ? a - 48 : // 0-9
        a >= 65 && a <= 70 ? a - 55 : // A-F
        a >= 97 && a <= 102 ? a - 87 : // a-f
        -1;
      }
      /**
       * Reads an alphanumeric + underscore name from the source.
       *
       * [_A-Za-z][_0-9A-Za-z]*
       */


      function readName(source, position, line, col, prev) {
        var body = source.body;
        var bodyLength = body.length;
        var end = position + 1;
        var code = 0;

        while (end !== bodyLength && (code = charCodeAt.call(body, end)) !== null && (code === 95 || // _
        code >= 48 && code <= 57 || // 0-9
        code >= 65 && code <= 90 || // A-Z
        code >= 97 && code <= 122 // a-z
        )) {
          ++end;
        }

        return new Tok(NAME, position, end, line, col, prev, slice.call(body, position, end));
      }
      /***/

    },
    /* 1185 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.formatError = formatError;

      var _invariant = __webpack_require__(659);

      var _invariant2 = _interopRequireDefault(_invariant);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /**
       * Given a GraphQLError, format it according to the rules described by the
       * Response Format, Errors section of the GraphQL Specification.
       */


      function formatError(error) {
        !error ? (0, _invariant2.default)(0, 'Received null or undefined error.') : void 0;
        return {
          message: error.message,
          locations: error.locations,
          path: error.path
        };
      }
      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */

      /***/

    },
    /* 1186 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.locatedError = locatedError;

      var _GraphQLError = __webpack_require__(372);
      /**
       * Given an arbitrary Error, presumably thrown while attempting to execute a
       * GraphQL operation, produce a new GraphQLError aware of the location in the
       * document responsible for the original Error.
       */


      function locatedError(originalError, nodes, path) {
        // Note: this uses a brand-check to support GraphQL errors originating from
        // other contexts.
        if (originalError && originalError.path) {
          return originalError;
        }

        var message = originalError ? originalError.message || String(originalError) : 'An unknown error occurred.';
        return new _GraphQLError.GraphQLError(message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
      }
      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */

      /***/

    },
    /* 1187 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.syntaxError = syntaxError;

      var _location = __webpack_require__(657);

      var _GraphQLError = __webpack_require__(372);
      /**
       * Produces a GraphQLError representing a syntax error, containing useful
       * descriptive information about the syntax error's position in the source.
       */

      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */


      function syntaxError(source, position, description) {
        var location = (0, _location.getLocation)(source, position);
        var line = location.line + source.locationOffset.line - 1;
        var columnOffset = getColumnOffset(source, location);
        var column = location.column + columnOffset;
        var error = new _GraphQLError.GraphQLError('Syntax Error ' + source.name + ' (' + line + ':' + column + ') ' + description + '\n\n' + highlightSourceAtLocation(source, location), undefined, source, [position]);
        return error;
      }
      /**
       * Render a helpful description of the location of the error in the GraphQL
       * Source document.
       */


      function highlightSourceAtLocation(source, location) {
        var line = location.line;
        var lineOffset = source.locationOffset.line - 1;
        var columnOffset = getColumnOffset(source, location);
        var contextLine = line + lineOffset;
        var prevLineNum = (contextLine - 1).toString();
        var lineNum = contextLine.toString();
        var nextLineNum = (contextLine + 1).toString();
        var padLen = nextLineNum.length;
        var lines = source.body.split(/\r\n|[\n\r]/g);
        lines[0] = whitespace(source.locationOffset.column - 1) + lines[0];
        return (line >= 2 ? lpad(padLen, prevLineNum) + ': ' + lines[line - 2] + '\n' : '') + lpad(padLen, lineNum) + ': ' + lines[line - 1] + '\n' + whitespace(2 + padLen + location.column - 1 + columnOffset) + '^\n' + (line < lines.length ? lpad(padLen, nextLineNum) + ': ' + lines[line] + '\n' : '');
      }

      function getColumnOffset(source, location) {
        return location.line === 1 ? source.locationOffset.column - 1 : 0;
      }

      function whitespace(len) {
        return Array(len + 1).join(' ');
      }

      function lpad(len, str) {
        return whitespace(len - str.length) + str;
      }
      /***/

    },
    /* 1188 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Source = undefined;

      var _invariant = __webpack_require__(659);

      var _invariant2 = _interopRequireDefault(_invariant);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */

      /**
       * A representation of source input to GraphQL.
       * `name` and `locationOffset` are optional. They are useful for clients who
       * store GraphQL documents in source files; for example, if the GraphQL input
       * starts at line 40 in a file named Foo.graphql, it might be useful for name to
       * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
       * line and column in locationOffset are 1-indexed
       */


      var Source = exports.Source = function Source(body, name, locationOffset) {
        _classCallCheck(this, Source);

        this.body = body;
        this.name = name || 'GraphQL request';
        this.locationOffset = locationOffset || {
          line: 1,
          column: 1
        };
        !(this.locationOffset.line > 0) ? (0, _invariant2.default)(0, 'line in locationOffset is 1-indexed and must be positive') : void 0;
        !(this.locationOffset.column > 0) ? (0, _invariant2.default)(0, 'column in locationOffset is 1-indexed and must be positive') : void 0;
      };
      /***/

    },
    /* 1189 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.parse = parse;
      exports.parseValue = parseValue;
      exports.parseType = parseType;
      exports.parseConstValue = parseConstValue;
      exports.parseTypeReference = parseTypeReference;
      exports.parseNamedType = parseNamedType;

      var _source = __webpack_require__(1188);

      var _error = __webpack_require__(658);

      var _lexer = __webpack_require__(1184);

      var _kinds = __webpack_require__(656);
      /**
       * Given a GraphQL source, parses it into a Document.
       * Throws GraphQLError if a syntax error is encountered.
       */

      /**
       * Configuration options to control parser behavior
       */

      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */


      function parse(source, options) {
        var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;

        if (!(sourceObj instanceof _source.Source)) {
          throw new TypeError('Must provide Source. Received: ' + String(sourceObj));
        }

        var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
        return parseDocument(lexer);
      }
      /**
       * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
       * that value.
       * Throws GraphQLError if a syntax error is encountered.
       *
       * This is useful within tools that operate upon GraphQL Values directly and
       * in isolation of complete GraphQL documents.
       *
       * Consider providing the results to the utility function: valueFromAST().
       */


      function parseValue(source, options) {
        var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
        var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
        expect(lexer, _lexer.TokenKind.SOF);
        var value = parseValueLiteral(lexer, false);
        expect(lexer, _lexer.TokenKind.EOF);
        return value;
      }
      /**
       * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
       * that type.
       * Throws GraphQLError if a syntax error is encountered.
       *
       * This is useful within tools that operate upon GraphQL Types directly and
       * in isolation of complete GraphQL documents.
       *
       * Consider providing the results to the utility function: typeFromAST().
       */


      function parseType(source, options) {
        var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
        var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
        expect(lexer, _lexer.TokenKind.SOF);
        var type = parseTypeReference(lexer);
        expect(lexer, _lexer.TokenKind.EOF);
        return type;
      }
      /**
       * Converts a name lex token into a name parse node.
       */


      function parseName(lexer) {
        var token = expect(lexer, _lexer.TokenKind.NAME);
        return {
          kind: _kinds.NAME,
          value: token.value,
          loc: loc(lexer, token)
        };
      } // Implements the parsing rules in the Document section.

      /**
       * Document : Definition+
       */


      function parseDocument(lexer) {
        var start = lexer.token;
        expect(lexer, _lexer.TokenKind.SOF);
        var definitions = [];

        do {
          definitions.push(parseDefinition(lexer));
        } while (!skip(lexer, _lexer.TokenKind.EOF));

        return {
          kind: _kinds.DOCUMENT,
          definitions: definitions,
          loc: loc(lexer, start)
        };
      }
      /**
       * Definition :
       *   - OperationDefinition
       *   - FragmentDefinition
       *   - TypeSystemDefinition
       */


      function parseDefinition(lexer) {
        if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
          return parseOperationDefinition(lexer);
        }

        if (peek(lexer, _lexer.TokenKind.NAME)) {
          switch (lexer.token.value) {
            // Note: subscription is an experimental non-spec addition.
            case 'query':
            case 'mutation':
            case 'subscription':
              return parseOperationDefinition(lexer);

            case 'fragment':
              return parseFragmentDefinition(lexer);
            // Note: the Type System IDL is an experimental non-spec addition.

            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'extend':
            case 'directive':
              return parseTypeSystemDefinition(lexer);
          }
        }

        throw unexpected(lexer);
      } // Implements the parsing rules in the Operations section.

      /**
       * OperationDefinition :
       *  - SelectionSet
       *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
       */


      function parseOperationDefinition(lexer) {
        var start = lexer.token;

        if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
          return {
            kind: _kinds.OPERATION_DEFINITION,
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: parseSelectionSet(lexer),
            loc: loc(lexer, start)
          };
        }

        var operation = parseOperationType(lexer);
        var name = void 0;

        if (peek(lexer, _lexer.TokenKind.NAME)) {
          name = parseName(lexer);
        }

        return {
          kind: _kinds.OPERATION_DEFINITION,
          operation: operation,
          name: name,
          variableDefinitions: parseVariableDefinitions(lexer),
          directives: parseDirectives(lexer),
          selectionSet: parseSelectionSet(lexer),
          loc: loc(lexer, start)
        };
      }
      /**
       * OperationType : one of query mutation subscription
       */


      function parseOperationType(lexer) {
        var operationToken = expect(lexer, _lexer.TokenKind.NAME);

        switch (operationToken.value) {
          case 'query':
            return 'query';

          case 'mutation':
            return 'mutation';
          // Note: subscription is an experimental non-spec addition.

          case 'subscription':
            return 'subscription';
        }

        throw unexpected(lexer, operationToken);
      }
      /**
       * VariableDefinitions : ( VariableDefinition+ )
       */


      function parseVariableDefinitions(lexer) {
        return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseVariableDefinition, _lexer.TokenKind.PAREN_R) : [];
      }
      /**
       * VariableDefinition : Variable : Type DefaultValue?
       */


      function parseVariableDefinition(lexer) {
        var start = lexer.token;
        return {
          kind: _kinds.VARIABLE_DEFINITION,
          variable: parseVariable(lexer),
          type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
          defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : null,
          loc: loc(lexer, start)
        };
      }
      /**
       * Variable : $ Name
       */


      function parseVariable(lexer) {
        var start = lexer.token;
        expect(lexer, _lexer.TokenKind.DOLLAR);
        return {
          kind: _kinds.VARIABLE,
          name: parseName(lexer),
          loc: loc(lexer, start)
        };
      }
      /**
       * SelectionSet : { Selection+ }
       */


      function parseSelectionSet(lexer) {
        var start = lexer.token;
        return {
          kind: _kinds.SELECTION_SET,
          selections: many(lexer, _lexer.TokenKind.BRACE_L, parseSelection, _lexer.TokenKind.BRACE_R),
          loc: loc(lexer, start)
        };
      }
      /**
       * Selection :
       *   - Field
       *   - FragmentSpread
       *   - InlineFragment
       */


      function parseSelection(lexer) {
        return peek(lexer, _lexer.TokenKind.SPREAD) ? parseFragment(lexer) : parseField(lexer);
      }
      /**
       * Field : Alias? Name Arguments? Directives? SelectionSet?
       *
       * Alias : Name :
       */


      function parseField(lexer) {
        var start = lexer.token;
        var nameOrAlias = parseName(lexer);
        var alias = void 0;
        var name = void 0;

        if (skip(lexer, _lexer.TokenKind.COLON)) {
          alias = nameOrAlias;
          name = parseName(lexer);
        } else {
          alias = null;
          name = nameOrAlias;
        }

        return {
          kind: _kinds.FIELD,
          alias: alias,
          name: name,
          arguments: parseArguments(lexer),
          directives: parseDirectives(lexer),
          selectionSet: peek(lexer, _lexer.TokenKind.BRACE_L) ? parseSelectionSet(lexer) : null,
          loc: loc(lexer, start)
        };
      }
      /**
       * Arguments : ( Argument+ )
       */


      function parseArguments(lexer) {
        return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseArgument, _lexer.TokenKind.PAREN_R) : [];
      }
      /**
       * Argument : Name : Value
       */


      function parseArgument(lexer) {
        var start = lexer.token;
        return {
          kind: _kinds.ARGUMENT,
          name: parseName(lexer),
          value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, false)),
          loc: loc(lexer, start)
        };
      } // Implements the parsing rules in the Fragments section.

      /**
       * Corresponds to both FragmentSpread and InlineFragment in the spec.
       *
       * FragmentSpread : ... FragmentName Directives?
       *
       * InlineFragment : ... TypeCondition? Directives? SelectionSet
       */


      function parseFragment(lexer) {
        var start = lexer.token;
        expect(lexer, _lexer.TokenKind.SPREAD);

        if (peek(lexer, _lexer.TokenKind.NAME) && lexer.token.value !== 'on') {
          return {
            kind: _kinds.FRAGMENT_SPREAD,
            name: parseFragmentName(lexer),
            directives: parseDirectives(lexer),
            loc: loc(lexer, start)
          };
        }

        var typeCondition = null;

        if (lexer.token.value === 'on') {
          lexer.advance();
          typeCondition = parseNamedType(lexer);
        }

        return {
          kind: _kinds.INLINE_FRAGMENT,
          typeCondition: typeCondition,
          directives: parseDirectives(lexer),
          selectionSet: parseSelectionSet(lexer),
          loc: loc(lexer, start)
        };
      }
      /**
       * FragmentDefinition :
       *   - fragment FragmentName on TypeCondition Directives? SelectionSet
       *
       * TypeCondition : NamedType
       */


      function parseFragmentDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, 'fragment');
        return {
          kind: _kinds.FRAGMENT_DEFINITION,
          name: parseFragmentName(lexer),
          typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
          directives: parseDirectives(lexer),
          selectionSet: parseSelectionSet(lexer),
          loc: loc(lexer, start)
        };
      }
      /**
       * FragmentName : Name but not `on`
       */


      function parseFragmentName(lexer) {
        if (lexer.token.value === 'on') {
          throw unexpected(lexer);
        }

        return parseName(lexer);
      } // Implements the parsing rules in the Values section.

      /**
       * Value[Const] :
       *   - [~Const] Variable
       *   - IntValue
       *   - FloatValue
       *   - StringValue
       *   - BooleanValue
       *   - NullValue
       *   - EnumValue
       *   - ListValue[?Const]
       *   - ObjectValue[?Const]
       *
       * BooleanValue : one of `true` `false`
       *
       * NullValue : `null`
       *
       * EnumValue : Name but not `true`, `false` or `null`
       */


      function parseValueLiteral(lexer, isConst) {
        var token = lexer.token;

        switch (token.kind) {
          case _lexer.TokenKind.BRACKET_L:
            return parseList(lexer, isConst);

          case _lexer.TokenKind.BRACE_L:
            return parseObject(lexer, isConst);

          case _lexer.TokenKind.INT:
            lexer.advance();
            return {
              kind: _kinds.INT,
              value: token.value,
              loc: loc(lexer, token)
            };

          case _lexer.TokenKind.FLOAT:
            lexer.advance();
            return {
              kind: _kinds.FLOAT,
              value: token.value,
              loc: loc(lexer, token)
            };

          case _lexer.TokenKind.STRING:
            lexer.advance();
            return {
              kind: _kinds.STRING,
              value: token.value,
              loc: loc(lexer, token)
            };

          case _lexer.TokenKind.NAME:
            if (token.value === 'true' || token.value === 'false') {
              lexer.advance();
              return {
                kind: _kinds.BOOLEAN,
                value: token.value === 'true',
                loc: loc(lexer, token)
              };
            } else if (token.value === 'null') {
              lexer.advance();
              return {
                kind: _kinds.NULL,
                loc: loc(lexer, token)
              };
            }

            lexer.advance();
            return {
              kind: _kinds.ENUM,
              value: token.value,
              loc: loc(lexer, token)
            };

          case _lexer.TokenKind.DOLLAR:
            if (!isConst) {
              return parseVariable(lexer);
            }

            break;
        }

        throw unexpected(lexer);
      }

      function parseConstValue(lexer) {
        return parseValueLiteral(lexer, true);
      }

      function parseValueValue(lexer) {
        return parseValueLiteral(lexer, false);
      }
      /**
       * ListValue[Const] :
       *   - [ ]
       *   - [ Value[?Const]+ ]
       */


      function parseList(lexer, isConst) {
        var start = lexer.token;
        var item = isConst ? parseConstValue : parseValueValue;
        return {
          kind: _kinds.LIST,
          values: any(lexer, _lexer.TokenKind.BRACKET_L, item, _lexer.TokenKind.BRACKET_R),
          loc: loc(lexer, start)
        };
      }
      /**
       * ObjectValue[Const] :
       *   - { }
       *   - { ObjectField[?Const]+ }
       */


      function parseObject(lexer, isConst) {
        var start = lexer.token;
        expect(lexer, _lexer.TokenKind.BRACE_L);
        var fields = [];

        while (!skip(lexer, _lexer.TokenKind.BRACE_R)) {
          fields.push(parseObjectField(lexer, isConst));
        }

        return {
          kind: _kinds.OBJECT,
          fields: fields,
          loc: loc(lexer, start)
        };
      }
      /**
       * ObjectField[Const] : Name : Value[?Const]
       */


      function parseObjectField(lexer, isConst) {
        var start = lexer.token;
        return {
          kind: _kinds.OBJECT_FIELD,
          name: parseName(lexer),
          value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, isConst)),
          loc: loc(lexer, start)
        };
      } // Implements the parsing rules in the Directives section.

      /**
       * Directives : Directive+
       */


      function parseDirectives(lexer) {
        var directives = [];

        while (peek(lexer, _lexer.TokenKind.AT)) {
          directives.push(parseDirective(lexer));
        }

        return directives;
      }
      /**
       * Directive : @ Name Arguments?
       */


      function parseDirective(lexer) {
        var start = lexer.token;
        expect(lexer, _lexer.TokenKind.AT);
        return {
          kind: _kinds.DIRECTIVE,
          name: parseName(lexer),
          arguments: parseArguments(lexer),
          loc: loc(lexer, start)
        };
      } // Implements the parsing rules in the Types section.

      /**
       * Type :
       *   - NamedType
       *   - ListType
       *   - NonNullType
       */


      function parseTypeReference(lexer) {
        var start = lexer.token;
        var type = void 0;

        if (skip(lexer, _lexer.TokenKind.BRACKET_L)) {
          type = parseTypeReference(lexer);
          expect(lexer, _lexer.TokenKind.BRACKET_R);
          type = {
            kind: _kinds.LIST_TYPE,
            type: type,
            loc: loc(lexer, start)
          };
        } else {
          type = parseNamedType(lexer);
        }

        if (skip(lexer, _lexer.TokenKind.BANG)) {
          return {
            kind: _kinds.NON_NULL_TYPE,
            type: type,
            loc: loc(lexer, start)
          };
        }

        return type;
      }
      /**
       * NamedType : Name
       */


      function parseNamedType(lexer) {
        var start = lexer.token;
        return {
          kind: _kinds.NAMED_TYPE,
          name: parseName(lexer),
          loc: loc(lexer, start)
        };
      } // Implements the parsing rules in the Type Definition section.

      /**
       * TypeSystemDefinition :
       *   - SchemaDefinition
       *   - TypeDefinition
       *   - TypeExtensionDefinition
       *   - DirectiveDefinition
       *
       * TypeDefinition :
       *   - ScalarTypeDefinition
       *   - ObjectTypeDefinition
       *   - InterfaceTypeDefinition
       *   - UnionTypeDefinition
       *   - EnumTypeDefinition
       *   - InputObjectTypeDefinition
       */


      function parseTypeSystemDefinition(lexer) {
        if (peek(lexer, _lexer.TokenKind.NAME)) {
          switch (lexer.token.value) {
            case 'schema':
              return parseSchemaDefinition(lexer);

            case 'scalar':
              return parseScalarTypeDefinition(lexer);

            case 'type':
              return parseObjectTypeDefinition(lexer);

            case 'interface':
              return parseInterfaceTypeDefinition(lexer);

            case 'union':
              return parseUnionTypeDefinition(lexer);

            case 'enum':
              return parseEnumTypeDefinition(lexer);

            case 'input':
              return parseInputObjectTypeDefinition(lexer);

            case 'extend':
              return parseTypeExtensionDefinition(lexer);

            case 'directive':
              return parseDirectiveDefinition(lexer);
          }
        }

        throw unexpected(lexer);
      }
      /**
       * SchemaDefinition : schema Directives? { OperationTypeDefinition+ }
       *
       * OperationTypeDefinition : OperationType : NamedType
       */


      function parseSchemaDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, 'schema');
        var directives = parseDirectives(lexer);
        var operationTypes = many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R);
        return {
          kind: _kinds.SCHEMA_DEFINITION,
          directives: directives,
          operationTypes: operationTypes,
          loc: loc(lexer, start)
        };
      }

      function parseOperationTypeDefinition(lexer) {
        var start = lexer.token;
        var operation = parseOperationType(lexer);
        expect(lexer, _lexer.TokenKind.COLON);
        var type = parseNamedType(lexer);
        return {
          kind: _kinds.OPERATION_TYPE_DEFINITION,
          operation: operation,
          type: type,
          loc: loc(lexer, start)
        };
      }
      /**
       * ScalarTypeDefinition : scalar Name Directives?
       */


      function parseScalarTypeDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, 'scalar');
        var name = parseName(lexer);
        var directives = parseDirectives(lexer);
        return {
          kind: _kinds.SCALAR_TYPE_DEFINITION,
          name: name,
          directives: directives,
          loc: loc(lexer, start)
        };
      }
      /**
       * ObjectTypeDefinition :
       *   - type Name ImplementsInterfaces? Directives? { FieldDefinition+ }
       */


      function parseObjectTypeDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, 'type');
        var name = parseName(lexer);
        var interfaces = parseImplementsInterfaces(lexer);
        var directives = parseDirectives(lexer);
        var fields = any(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R);
        return {
          kind: _kinds.OBJECT_TYPE_DEFINITION,
          name: name,
          interfaces: interfaces,
          directives: directives,
          fields: fields,
          loc: loc(lexer, start)
        };
      }
      /**
       * ImplementsInterfaces : implements NamedType+
       */


      function parseImplementsInterfaces(lexer) {
        var types = [];

        if (lexer.token.value === 'implements') {
          lexer.advance();

          do {
            types.push(parseNamedType(lexer));
          } while (peek(lexer, _lexer.TokenKind.NAME));
        }

        return types;
      }
      /**
       * FieldDefinition : Name ArgumentsDefinition? : Type Directives?
       */


      function parseFieldDefinition(lexer) {
        var start = lexer.token;
        var name = parseName(lexer);
        var args = parseArgumentDefs(lexer);
        expect(lexer, _lexer.TokenKind.COLON);
        var type = parseTypeReference(lexer);
        var directives = parseDirectives(lexer);
        return {
          kind: _kinds.FIELD_DEFINITION,
          name: name,
          arguments: args,
          type: type,
          directives: directives,
          loc: loc(lexer, start)
        };
      }
      /**
       * ArgumentsDefinition : ( InputValueDefinition+ )
       */


      function parseArgumentDefs(lexer) {
        if (!peek(lexer, _lexer.TokenKind.PAREN_L)) {
          return [];
        }

        return many(lexer, _lexer.TokenKind.PAREN_L, parseInputValueDef, _lexer.TokenKind.PAREN_R);
      }
      /**
       * InputValueDefinition : Name : Type DefaultValue? Directives?
       */


      function parseInputValueDef(lexer) {
        var start = lexer.token;
        var name = parseName(lexer);
        expect(lexer, _lexer.TokenKind.COLON);
        var type = parseTypeReference(lexer);
        var defaultValue = null;

        if (skip(lexer, _lexer.TokenKind.EQUALS)) {
          defaultValue = parseConstValue(lexer);
        }

        var directives = parseDirectives(lexer);
        return {
          kind: _kinds.INPUT_VALUE_DEFINITION,
          name: name,
          type: type,
          defaultValue: defaultValue,
          directives: directives,
          loc: loc(lexer, start)
        };
      }
      /**
       * InterfaceTypeDefinition : interface Name Directives? { FieldDefinition+ }
       */


      function parseInterfaceTypeDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, 'interface');
        var name = parseName(lexer);
        var directives = parseDirectives(lexer);
        var fields = any(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R);
        return {
          kind: _kinds.INTERFACE_TYPE_DEFINITION,
          name: name,
          directives: directives,
          fields: fields,
          loc: loc(lexer, start)
        };
      }
      /**
       * UnionTypeDefinition : union Name Directives? = UnionMembers
       */


      function parseUnionTypeDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, 'union');
        var name = parseName(lexer);
        var directives = parseDirectives(lexer);
        expect(lexer, _lexer.TokenKind.EQUALS);
        var types = parseUnionMembers(lexer);
        return {
          kind: _kinds.UNION_TYPE_DEFINITION,
          name: name,
          directives: directives,
          types: types,
          loc: loc(lexer, start)
        };
      }
      /**
       * UnionMembers :
       *   - `|`? NamedType
       *   - UnionMembers | NamedType
       */


      function parseUnionMembers(lexer) {
        // Optional leading pipe
        skip(lexer, _lexer.TokenKind.PIPE);
        var members = [];

        do {
          members.push(parseNamedType(lexer));
        } while (skip(lexer, _lexer.TokenKind.PIPE));

        return members;
      }
      /**
       * EnumTypeDefinition : enum Name Directives? { EnumValueDefinition+ }
       */


      function parseEnumTypeDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, 'enum');
        var name = parseName(lexer);
        var directives = parseDirectives(lexer);
        var values = many(lexer, _lexer.TokenKind.BRACE_L, parseEnumValueDefinition, _lexer.TokenKind.BRACE_R);
        return {
          kind: _kinds.ENUM_TYPE_DEFINITION,
          name: name,
          directives: directives,
          values: values,
          loc: loc(lexer, start)
        };
      }
      /**
       * EnumValueDefinition : EnumValue Directives?
       *
       * EnumValue : Name
       */


      function parseEnumValueDefinition(lexer) {
        var start = lexer.token;
        var name = parseName(lexer);
        var directives = parseDirectives(lexer);
        return {
          kind: _kinds.ENUM_VALUE_DEFINITION,
          name: name,
          directives: directives,
          loc: loc(lexer, start)
        };
      }
      /**
       * InputObjectTypeDefinition : input Name Directives? { InputValueDefinition+ }
       */


      function parseInputObjectTypeDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, 'input');
        var name = parseName(lexer);
        var directives = parseDirectives(lexer);
        var fields = any(lexer, _lexer.TokenKind.BRACE_L, parseInputValueDef, _lexer.TokenKind.BRACE_R);
        return {
          kind: _kinds.INPUT_OBJECT_TYPE_DEFINITION,
          name: name,
          directives: directives,
          fields: fields,
          loc: loc(lexer, start)
        };
      }
      /**
       * TypeExtensionDefinition : extend ObjectTypeDefinition
       */


      function parseTypeExtensionDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, 'extend');
        var definition = parseObjectTypeDefinition(lexer);
        return {
          kind: _kinds.TYPE_EXTENSION_DEFINITION,
          definition: definition,
          loc: loc(lexer, start)
        };
      }
      /**
       * DirectiveDefinition :
       *   - directive @ Name ArgumentsDefinition? on DirectiveLocations
       */


      function parseDirectiveDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, 'directive');
        expect(lexer, _lexer.TokenKind.AT);
        var name = parseName(lexer);
        var args = parseArgumentDefs(lexer);
        expectKeyword(lexer, 'on');
        var locations = parseDirectiveLocations(lexer);
        return {
          kind: _kinds.DIRECTIVE_DEFINITION,
          name: name,
          arguments: args,
          locations: locations,
          loc: loc(lexer, start)
        };
      }
      /**
       * DirectiveLocations :
       *   - `|`? Name
       *   - DirectiveLocations | Name
       */


      function parseDirectiveLocations(lexer) {
        // Optional leading pipe
        skip(lexer, _lexer.TokenKind.PIPE);
        var locations = [];

        do {
          locations.push(parseName(lexer));
        } while (skip(lexer, _lexer.TokenKind.PIPE));

        return locations;
      } // Core parsing utility functions

      /**
       * Returns a location object, used to identify the place in
       * the source that created a given parsed object.
       */


      function loc(lexer, startToken) {
        if (!lexer.options.noLocation) {
          return new Loc(startToken, lexer.lastToken, lexer.source);
        }
      }

      function Loc(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
      } // Print a simplified form when appearing in JSON/util.inspect.


      Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
        return {
          start: this.start,
          end: this.end
        };
      };
      /**
       * Determines if the next token is of a given kind
       */


      function peek(lexer, kind) {
        return lexer.token.kind === kind;
      }
      /**
       * If the next token is of the given kind, return true after advancing
       * the lexer. Otherwise, do not change the parser state and return false.
       */


      function skip(lexer, kind) {
        var match = lexer.token.kind === kind;

        if (match) {
          lexer.advance();
        }

        return match;
      }
      /**
       * If the next token is of the given kind, return that token after advancing
       * the lexer. Otherwise, do not change the parser state and throw an error.
       */


      function expect(lexer, kind) {
        var token = lexer.token;

        if (token.kind === kind) {
          lexer.advance();
          return token;
        }

        throw (0, _error.syntaxError)(lexer.source, token.start, 'Expected ' + kind + ', found ' + (0, _lexer.getTokenDesc)(token));
      }
      /**
       * If the next token is a keyword with the given value, return that token after
       * advancing the lexer. Otherwise, do not change the parser state and return
       * false.
       */


      function expectKeyword(lexer, value) {
        var token = lexer.token;

        if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
          lexer.advance();
          return token;
        }

        throw (0, _error.syntaxError)(lexer.source, token.start, 'Expected "' + value + '", found ' + (0, _lexer.getTokenDesc)(token));
      }
      /**
       * Helper function for creating an error when an unexpected lexed token
       * is encountered.
       */


      function unexpected(lexer, atToken) {
        var token = atToken || lexer.token;
        return (0, _error.syntaxError)(lexer.source, token.start, 'Unexpected ' + (0, _lexer.getTokenDesc)(token));
      }
      /**
       * Returns a possibly empty list of parse nodes, determined by
       * the parseFn. This list begins with a lex token of openKind
       * and ends with a lex token of closeKind. Advances the parser
       * to the next lex token after the closing token.
       */


      function any(lexer, openKind, parseFn, closeKind) {
        expect(lexer, openKind);
        var nodes = [];

        while (!skip(lexer, closeKind)) {
          nodes.push(parseFn(lexer));
        }

        return nodes;
      }
      /**
       * Returns a non-empty list of parse nodes, determined by
       * the parseFn. This list begins with a lex token of openKind
       * and ends with a lex token of closeKind. Advances the parser
       * to the next lex token after the closing token.
       */


      function many(lexer, openKind, parseFn, closeKind) {
        expect(lexer, openKind);
        var nodes = [parseFn(lexer)];

        while (!skip(lexer, closeKind)) {
          nodes.push(parseFn(lexer));
        }

        return nodes;
      }
      /***/

    },
    /* 1190 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var storeUtils_1 = __webpack_require__(662);

      function getDirectiveInfoFromField(field, variables) {
        if (field.directives && field.directives.length) {
          var directiveObj_1 = {};
          field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = storeUtils_1.argumentsObjectFromField(directive, variables);
          });
          return directiveObj_1;
        }

        return null;
      }

      exports.getDirectiveInfoFromField = getDirectiveInfoFromField;

      function shouldInclude(selection, variables) {
        if (variables === void 0) {
          variables = {};
        }

        if (!selection.directives) {
          return true;
        }

        var res = true;
        selection.directives.some(function (directive) {
          if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
            return;
          }

          var directiveArguments = directive.arguments;
          var directiveName = directive.name.value;

          if (directiveArguments.length !== 1) {
            throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
          }

          var ifArgument = directive.arguments[0];

          if (!ifArgument.name || ifArgument.name.value !== 'if') {
            throw new Error("Invalid argument for the @" + directiveName + " directive.");
          }

          var ifValue = directive.arguments[0].value;
          var evaledValue = false;

          if (!ifValue || ifValue.kind !== 'BooleanValue') {
            if (ifValue.kind !== 'Variable') {
              throw new Error("Argument for the @" + directiveName + " directive must be a variable or a bool ean value.");
            } else {
              evaledValue = variables[ifValue.name.value];

              if (evaledValue === undefined) {
                throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
              }
            }
          } else {
            evaledValue = ifValue.value;
          }

          if (directiveName === 'skip') {
            evaledValue = !evaledValue;
          }

          if (!evaledValue) {
            res = false;
            return true;
          }

          return false;
        });
        return res;
      }

      exports.shouldInclude = shouldInclude;
      /***/
    },
    /* 1191 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      function checkDocument(doc) {
        if (doc.kind !== 'Document') {
          throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
        }

        var numOpDefinitions = doc.definitions.filter(function (definition) {
          return definition.kind === 'OperationDefinition';
        }).length;

        if (numOpDefinitions > 1) {
          throw new Error('Queries must have exactly one operation definition.');
        }
      }

      function getFragmentDefinitions(doc) {
        var fragmentDefinitions = doc.definitions.filter(function (definition) {
          if (definition.kind === 'FragmentDefinition') {
            return true;
          } else {
            return false;
          }
        });
        return fragmentDefinitions;
      }

      exports.getFragmentDefinitions = getFragmentDefinitions;

      function createFragmentMap(fragments) {
        if (fragments === void 0) {
          fragments = [];
        }

        var symTable = {};
        fragments.forEach(function (fragment) {
          symTable[fragment.name.value] = fragment;
        });
        return symTable;
      }

      exports.createFragmentMap = createFragmentMap;

      function getMainDefinition(queryDoc) {
        checkDocument(queryDoc);
        var fragmentDefinition;

        for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
          var definition = _a[_i];

          if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;

            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') {
              return definition;
            }
          }

          if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
          }
        }

        if (fragmentDefinition) {
          return fragmentDefinition;
        }

        throw new Error('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
      }

      exports.getMainDefinition = getMainDefinition;
      /***/
    },
    /* 1192 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var graphql_1 = __webpack_require__(663);

      function filter(doc, data) {
        var resolver = function resolver(fieldName, root, args, context, info) {
          return root[info.resultKey];
        };

        return graphql_1.graphql(resolver, doc, data);
      }

      exports.filter = filter;

      function check(doc, data) {
        var resolver = function resolver(fieldName, root, args, context, info) {
          if (!{}.hasOwnProperty.call(root, info.resultKey)) {
            throw new Error(info.resultKey + " missing on " + root);
          }

          return root[info.resultKey];
        };

        graphql_1.graphql(resolver, doc, data, {}, {}, {
          fragmentMatcher: function fragmentMatcher() {
            return false;
          }
        });
      }

      exports.check = check;
      var ANONYMOUS = '<<anonymous>>';

      function PropTypeError(message) {
        this.message = message;
        this.stack = '';
      }

      PropTypeError.prototype = Error.prototype;
      var reactPropTypeLocationNames = {
        prop: 'prop',
        context: 'context',
        childContext: 'child context'
      };

      function createChainableTypeChecker(validate) {
        function checkType(isRequired, props, propName, componentName, location, propFullName) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;

          if (props[propName] == null) {
            var locationName = reactPropTypeLocationNames[location];

            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }

              return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }

            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }

        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }

      function propType(doc) {
        return createChainableTypeChecker(function (props, propName) {
          var prop = props[propName];

          try {
            check(doc, prop);
            return null;
          } catch (e) {
            return e;
          }
        });
      }

      exports.propType = propType;
      /***/
    },
    /* 1193 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.visit = visit;
      exports.visitInParallel = visitInParallel;
      exports.visitWithTypeInfo = visitWithTypeInfo;
      exports.getVisitFn = getVisitFn;
      /**
       *  Copyright (c) 2015, Facebook, Inc.
       *  All rights reserved.
       *
       *  This source code is licensed under the BSD-style license found in the
       *  LICENSE file in the root directory of this source tree. An additional grant
       *  of patent rights can be found in the PATENTS file in the same directory.
       */

      var QueryDocumentKeys = exports.QueryDocumentKeys = {
        Name: [],
        Document: ['definitions'],
        OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
        VariableDefinition: ['variable', 'type', 'defaultValue'],
        Variable: ['name'],
        SelectionSet: ['selections'],
        Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
        Argument: ['name', 'value'],
        FragmentSpread: ['name', 'directives'],
        InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
        FragmentDefinition: ['name', 'typeCondition', 'directives', 'selectionSet'],
        IntValue: [],
        FloatValue: [],
        StringValue: [],
        BooleanValue: [],
        NullValue: [],
        EnumValue: [],
        ListValue: ['values'],
        ObjectValue: ['fields'],
        ObjectField: ['name', 'value'],
        Directive: ['name', 'arguments'],
        NamedType: ['name'],
        ListType: ['type'],
        NonNullType: ['type'],
        SchemaDefinition: ['directives', 'operationTypes'],
        OperationTypeDefinition: ['type'],
        ScalarTypeDefinition: ['name', 'directives'],
        ObjectTypeDefinition: ['name', 'interfaces', 'directives', 'fields'],
        FieldDefinition: ['name', 'arguments', 'type', 'directives'],
        InputValueDefinition: ['name', 'type', 'defaultValue', 'directives'],
        InterfaceTypeDefinition: ['name', 'directives', 'fields'],
        UnionTypeDefinition: ['name', 'directives', 'types'],
        EnumTypeDefinition: ['name', 'directives', 'values'],
        EnumValueDefinition: ['name', 'directives'],
        InputObjectTypeDefinition: ['name', 'directives', 'fields'],
        TypeExtensionDefinition: ['definition'],
        DirectiveDefinition: ['name', 'arguments', 'locations']
      };
      var BREAK = exports.BREAK = {};
      /**
       * visit() will walk through an AST using a depth first traversal, calling
       * the visitor's enter function at each node in the traversal, and calling the
       * leave function after visiting that node and all of its child nodes.
       *
       * By returning different values from the enter and leave functions, the
       * behavior of the visitor can be altered, including skipping over a sub-tree of
       * the AST (by returning false), editing the AST by returning a value or null
       * to remove the value, or to stop the whole traversal by returning BREAK.
       *
       * When using visit() to edit an AST, the original AST will not be modified, and
       * a new version of the AST with the changes applied will be returned from the
       * visit function.
       *
       *     const editedAST = visit(ast, {
       *       enter(node, key, parent, path, ancestors) {
       *         // @return
       *         //   undefined: no action
       *         //   false: skip visiting this node
       *         //   visitor.BREAK: stop visiting altogether
       *         //   null: delete this node
       *         //   any value: replace this node with the returned value
       *       },
       *       leave(node, key, parent, path, ancestors) {
       *         // @return
       *         //   undefined: no action
       *         //   false: no action
       *         //   visitor.BREAK: stop visiting altogether
       *         //   null: delete this node
       *         //   any value: replace this node with the returned value
       *       }
       *     });
       *
       * Alternatively to providing enter() and leave() functions, a visitor can
       * instead provide functions named the same as the kinds of AST nodes, or
       * enter/leave visitors at a named key, leading to four permutations of
       * visitor API:
       *
       * 1) Named visitors triggered when entering a node a specific kind.
       *
       *     visit(ast, {
       *       Kind(node) {
       *         // enter the "Kind" node
       *       }
       *     })
       *
       * 2) Named visitors that trigger upon entering and leaving a node of
       *    a specific kind.
       *
       *     visit(ast, {
       *       Kind: {
       *         enter(node) {
       *           // enter the "Kind" node
       *         }
       *         leave(node) {
       *           // leave the "Kind" node
       *         }
       *       }
       *     })
       *
       * 3) Generic visitors that trigger upon entering and leaving any node.
       *
       *     visit(ast, {
       *       enter(node) {
       *         // enter any node
       *       },
       *       leave(node) {
       *         // leave any node
       *       }
       *     })
       *
       * 4) Parallel visitors for entering and leaving nodes of a specific kind.
       *
       *     visit(ast, {
       *       enter: {
       *         Kind(node) {
       *           // enter the "Kind" node
       *         }
       *       },
       *       leave: {
       *         Kind(node) {
       *           // leave the "Kind" node
       *         }
       *       }
       *     })
       */

      function visit(root, visitor, keyMap) {
        var visitorKeys = keyMap || QueryDocumentKeys;
        var stack = void 0;
        var inArray = Array.isArray(root);
        var keys = [root];
        var index = -1;
        var edits = [];
        var parent = void 0;
        var path = [];
        var ancestors = [];
        var newRoot = root;

        do {
          index++;
          var isLeaving = index === keys.length;
          var key = void 0;
          var node = void 0;
          var isEdited = isLeaving && edits.length !== 0;

          if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path.pop();
            node = parent;
            parent = ancestors.pop();

            if (isEdited) {
              if (inArray) {
                node = node.slice();
              } else {
                var clone = {};

                for (var k in node) {
                  if (node.hasOwnProperty(k)) {
                    clone[k] = node[k];
                  }
                }

                node = clone;
              }

              var editOffset = 0;

              for (var ii = 0; ii < edits.length; ii++) {
                var editKey = edits[ii][0];
                var editValue = edits[ii][1];

                if (inArray) {
                  editKey -= editOffset;
                }

                if (inArray && editValue === null) {
                  node.splice(editKey, 1);
                  editOffset++;
                } else {
                  node[editKey] = editValue;
                }
              }
            }

            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
          } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;

            if (node === null || node === undefined) {
              continue;
            }

            if (parent) {
              path.push(key);
            }
          }

          var result = void 0;

          if (!Array.isArray(node)) {
            if (!isNode(node)) {
              throw new Error('Invalid AST Node: ' + JSON.stringify(node));
            }

            var visitFn = getVisitFn(visitor, node.kind, isLeaving);

            if (visitFn) {
              result = visitFn.call(visitor, node, key, parent, path, ancestors);

              if (result === BREAK) {
                break;
              }

              if (result === false) {
                if (!isLeaving) {
                  path.pop();
                  continue;
                }
              } else if (result !== undefined) {
                edits.push([key, result]);

                if (!isLeaving) {
                  if (isNode(result)) {
                    node = result;
                  } else {
                    path.pop();
                    continue;
                  }
                }
              }
            }
          }

          if (result === undefined && isEdited) {
            edits.push([key, node]);
          }

          if (!isLeaving) {
            stack = {
              inArray: inArray,
              index: index,
              keys: keys,
              edits: edits,
              prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : visitorKeys[node.kind] || [];
            index = -1;
            edits = [];

            if (parent) {
              ancestors.push(parent);
            }

            parent = node;
          }
        } while (stack !== undefined);

        if (edits.length !== 0) {
          newRoot = edits[edits.length - 1][1];
        }

        return newRoot;
      }

      function isNode(maybeNode) {
        return maybeNode && typeof maybeNode.kind === 'string';
      }
      /**
       * Creates a new visitor instance which delegates to many visitors to run in
       * parallel. Each visitor will be visited for each node before moving on.
       *
       * If a prior visitor edits a node, no following visitors will see that node.
       */


      function visitInParallel(visitors) {
        var skipping = new Array(visitors.length);
        return {
          enter: function enter(node) {
            for (var i = 0; i < visitors.length; i++) {
              if (!skipping[i]) {
                var fn = getVisitFn(visitors[i], node.kind,
                /* isLeaving */
                false);

                if (fn) {
                  var result = fn.apply(visitors[i], arguments);

                  if (result === false) {
                    skipping[i] = node;
                  } else if (result === BREAK) {
                    skipping[i] = BREAK;
                  } else if (result !== undefined) {
                    return result;
                  }
                }
              }
            }
          },
          leave: function leave(node) {
            for (var i = 0; i < visitors.length; i++) {
              if (!skipping[i]) {
                var fn = getVisitFn(visitors[i], node.kind,
                /* isLeaving */
                true);

                if (fn) {
                  var result = fn.apply(visitors[i], arguments);

                  if (result === BREAK) {
                    skipping[i] = BREAK;
                  } else if (result !== undefined && result !== false) {
                    return result;
                  }
                }
              } else if (skipping[i] === node) {
                skipping[i] = null;
              }
            }
          }
        };
      }
      /**
       * Creates a new visitor instance which maintains a provided TypeInfo instance
       * along with visiting visitor.
       */


      function visitWithTypeInfo(typeInfo, visitor) {
        return {
          enter: function enter(node) {
            typeInfo.enter(node);
            var fn = getVisitFn(visitor, node.kind,
            /* isLeaving */
            false);

            if (fn) {
              var result = fn.apply(visitor, arguments);

              if (result !== undefined) {
                typeInfo.leave(node);

                if (isNode(result)) {
                  typeInfo.enter(result);
                }
              }

              return result;
            }
          },
          leave: function leave(node) {
            var fn = getVisitFn(visitor, node.kind,
            /* isLeaving */
            true);
            var result = void 0;

            if (fn) {
              result = fn.apply(visitor, arguments);
            }

            typeInfo.leave(node);
            return result;
          }
        };
      }
      /**
       * Given a visitor instance, if it is leaving or not, and a node kind, return
       * the function the visitor runtime should call.
       */


      function getVisitFn(visitor, kind, isLeaving) {
        var kindVisitor = visitor[kind];

        if (kindVisitor) {
          if (!isLeaving && typeof kindVisitor === 'function') {
            // { Kind() {} }
            return kindVisitor;
          }

          var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

          if (typeof kindSpecificVisitor === 'function') {
            // { Kind: { enter() {}, leave() {} } }
            return kindSpecificVisitor;
          }
        } else {
          var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

          if (specificVisitor) {
            if (typeof specificVisitor === 'function') {
              // { enter() {}, leave() {} }
              return specificVisitor;
            }

            var specificKindVisitor = specificVisitor[kind];

            if (typeof specificKindVisitor === 'function') {
              // { enter: { Kind() {} }, leave: { Kind() {} } }
              return specificKindVisitor;
            }
          }
        }
      }
      /***/

    },
    /* 1194 */

    /***/
    function (module, exports) {
      module.exports = function (originalModule) {
        if (!originalModule.webpackPolyfill) {
          var module = Object.create(originalModule); // module.parent = undefined by default

          if (!module.children) module.children = [];
          Object.defineProperty(module, "loaded", {
            enumerable: true,
            get: function get() {
              return module.l;
            }
          });
          Object.defineProperty(module, "id", {
            enumerable: true,
            get: function get() {
              return module.i;
            }
          });
          Object.defineProperty(module, "exports", {
            enumerable: true
          });
          module.webpackPolyfill = 1;
        }

        return module;
      };
      /***/

    },
    /* 1195 */

    /***/
    function (module, exports) {
      function _setPrototypeOf(o, p) {
        module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };

        return _setPrototypeOf(o, p);
      }

      module.exports = _setPrototypeOf;
      /***/
    },
    /* 1196 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* WEBPACK VAR INJECTION */


      (function (process) {
        /* harmony export (binding) */
        __webpack_require__.d(__webpack_exports__, "Events", function () {
          return Events;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13);
        /* harmony import */


        var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(0);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var react_apollo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58);
        /* harmony import */


        var react_apollo__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(react_apollo__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var subscriptions_transport_ws__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(387);
        /* harmony import */


        var subscriptions_transport_ws__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(subscriptions_transport_ws__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var redux__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "compose", function () {
          return redux__WEBPACK_IMPORTED_MODULE_11__["compose"];
        });
        /* harmony import */


        var mitt__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(710);
        /* harmony import */


        var antd__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(128);
        /* harmony import */


        var antd_lib_locale_provider_en_US__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(695);
        /* harmony import */


        var antd_lib_locale_provider_en_US__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(antd_lib_locale_provider_en_US__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68);
        /* harmony import */


        var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var react_redux__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "connect", function () {
          return react_redux__WEBPACK_IMPORTED_MODULE_16__["a"];
        });
        /* harmony import */


        var _App__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(667);
        /* harmony import */


        var _config__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(28);
        /* harmony import */


        var _core_utils_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(27);
        /* harmony reexport (module object) */


        __webpack_require__.d(__webpack_exports__, "Constants", function () {
          return _core_utils_constants__WEBPACK_IMPORTED_MODULE_19__;
        });
        /* harmony import */


        var _core_utils_index__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(216);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Utils", function () {
          return _core_utils_index__WEBPACK_IMPORTED_MODULE_20__["a"];
        });
        /* harmony import */


        var _components__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(15);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Components", function () {
          return _components__WEBPACK_IMPORTED_MODULE_21__["C"];
        });
        /* harmony import */


        var _containers__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(391);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Containers", function () {
          return _containers__WEBPACK_IMPORTED_MODULE_22__["a"];
        });
        /* harmony import */


        var _core_utils_data__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(388);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Data", function () {
          return _core_utils_data__WEBPACK_IMPORTED_MODULE_23__["a"];
        });
        /* harmony import */


        var _core_utils__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(18);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "formatWord", function () {
          return _core_utils__WEBPACK_IMPORTED_MODULE_24__["b"];
        });
        /* harmony import */


        var _core_actions__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(29);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "setVisibleFields", function () {
          return _core_actions__WEBPACK_IMPORTED_MODULE_25__["Ca"];
        });
        /* harmony import */


        var _core_reducers__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(192);
        /* harmony import */


        var _core_injectables_Overrides__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(390);
        /* harmony reexport (module object) */


        __webpack_require__.d(__webpack_exports__, "Overrides", function () {
          return _core_injectables_Overrides__WEBPACK_IMPORTED_MODULE_27__;
        });
        /* harmony import */


        var _core_injectables_RootComponent__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(389);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "RootComponent", function () {
          return _core_injectables_RootComponent__WEBPACK_IMPORTED_MODULE_28__["a"];
        });
        /* harmony import */


        var _core_utils_localStorage__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(44);
        /* harmony import */


        var _core_utils_actions__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(69);
        /* harmony import */


        var _hocs_withAnalytics__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(41);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "withAnalytics", function () {
          return _hocs_withAnalytics__WEBPACK_IMPORTED_MODULE_31__["a"];
        });
        /* harmony import */


        var _hocs_withFieldSync__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(37);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "withFieldSync", function () {
          return _hocs_withFieldSync__WEBPACK_IMPORTED_MODULE_32__["a"];
        });
        /* harmony import */


        var _hocs_withFieldToken__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(34);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "withFieldToken", function () {
          return _hocs_withFieldToken__WEBPACK_IMPORTED_MODULE_33__["a"];
        });
        /* harmony import */


        var _hocs_withHelpText__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(95);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "withHelpText", function () {
          return _hocs_withHelpText__WEBPACK_IMPORTED_MODULE_34__["c"];
        });
        /* harmony import */


        var _hocs_withFieldValidation__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(38);
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "withFieldValidation", function () {
          return _hocs_withFieldValidation__WEBPACK_IMPORTED_MODULE_35__["a"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "withFieldValidationWithoutOverride", function () {
          return _hocs_withFieldValidation__WEBPACK_IMPORTED_MODULE_35__["b"];
        });
        /**
         * Creates an apollo client with the apiKey + config.server
         * @param  String [apiKey=null]
         * @return ApolloClient
         */


        var createApolloClient = function createApolloClient() {
          var apiKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var networkInterface = Object(react_apollo__WEBPACK_IMPORTED_MODULE_9__["createNetworkInterface"])({
            uri: _config__WEBPACK_IMPORTED_MODULE_18__[
            /* default */
            "a"].getServer()
          });
          networkInterface.use([{
            applyMiddleware: function applyMiddleware(req, next) {
              if (!req.options.headers) {
                req.options.headers = {};
              }

              req.options.headers.authorization = apiKey ? "Bearer ".concat(apiKey) : null;
              req.options.headers = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_6___default()({}, req.options.headers, {
                'Client-Version': "0.9.78"
              });
              next();
            }
          }]);
          var networkInterfaceWithSubscriptions;
          var supportsWebSockets = (typeof window === "undefined" ? "undefined" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default()(window)) === 'object' && ('WebSocket' in window || 'MozWebSocket' in window);

          if (supportsWebSockets) {
            var wsClient = null;

            if (process.browser) {
              wsClient = new subscriptions_transport_ws__WEBPACK_IMPORTED_MODULE_10__["SubscriptionClient"](_config__WEBPACK_IMPORTED_MODULE_18__[
              /* default */
              "a"].getSubscriptionServer(), {
                reconnect: true,
                timeout: _config__WEBPACK_IMPORTED_MODULE_18__[
                /* default */
                "a"].getSubscriptionTimeout(),
                connectionParams: {
                  authToken: apiKey
                }
              });
            }

            networkInterfaceWithSubscriptions = process.browser ? Object(subscriptions_transport_ws__WEBPACK_IMPORTED_MODULE_10__["addGraphQLSubscriptions"])(networkInterface, wsClient) : networkInterface;
          }

          return new react_apollo__WEBPACK_IMPORTED_MODULE_9__["ApolloClient"]({
            networkInterface: supportsWebSockets ? networkInterfaceWithSubscriptions : networkInterface
          });
        };
        /**
         * Creates a store with apollo middleware/reducers applied
         * @param  ApolloClient [client=null]
         * @param Object [state={}]
         * @return Store
         */


        var createApolloStore = function createApolloStore() {
          var client = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var state = arguments.length > 1 ? arguments[1] : undefined;
          var runReduxDevTools = arguments.length > 2 ? arguments[2] : undefined;
          return Object(redux__WEBPACK_IMPORTED_MODULE_11__["createStore"])(Object(redux__WEBPACK_IMPORTED_MODULE_11__["combineReducers"])({
            formatic: _core_reducers__WEBPACK_IMPORTED_MODULE_26__[
            /* default */
            "a"],
            apollo: client.reducer()
          }), state, Object(redux__WEBPACK_IMPORTED_MODULE_11__["compose"])(Object(redux__WEBPACK_IMPORTED_MODULE_11__["applyMiddleware"])(client.middleware()), runReduxDevTools && typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined' ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
            return f;
          }));
        }; // only support string, number, bool


        var supportedPropTypesFromUrl = ['apiKey', 'apiServerUrl', 'appendFormIdToSubmissionIdKey', 'channel', 'config', 'environment', 'fieldUpdateDebounceWaitingTime', 'formId', 'getFromParentPage', 'loadPropsFromUrl', 'runReduxDevTools', 'serverUrl', 'submissionId', 'submissionIdKey', 'subscriptionServerUrl', 'subscriptionTimeout'];
        var numericProps = ['fieldUpdateDebounceWaitingTime', 'subscriptionTimeout'];
        var booleanProps = ['appendFormIdToSubmissionIdKey', 'getFromParentPage', 'loadPropsFromUrl', 'runReduxDevTools'];

        var Formatic =
        /*#__PURE__*/
        function (_Component) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(Formatic, _Component);

          function Formatic(props) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Formatic);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Formatic).call(this, props));
            var propsToLoad = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_15___default()(props); // only load props from URL if loadPropsFromUrl when:
            // 1- loadPropsFromUrl is true
            // 2- the prop is on the supportedPropTypesFromUrl list
            // 3- there was no value assigned for that prop

            if (props.loadPropsFromUrl) {
              // load props from url
              Object.keys(Formatic.propTypes).forEach(function (key) {
                if (props[key] === undefined && supportedPropTypesFromUrl.includes(key)) {
                  propsToLoad[key] = Object(_core_utils__WEBPACK_IMPORTED_MODULE_24__[
                  /* getParameterByName */
                  "j"])(key, undefined, props.getFromParentPage);

                  if (propsToLoad[key] !== undefined) {
                    // convert numbers and booleans
                    if (numericProps.includes(key)) {
                      propsToLoad[key] = parseInt(propsToLoad[key], 10);
                    } else if (booleanProps.includes(key)) {
                      propsToLoad[key] = propsToLoad[key] === 'true';
                    }
                  }
                }
              });
            } // load default values for those props that are still undefined


            Object.keys(Formatic.FormaticDefaultProps).forEach(function (key) {
              if (propsToLoad[key] === undefined) {
                propsToLoad[key] = Formatic.FormaticDefaultProps[key];
              }
            }); // set internal configuration from prop values

            _config__WEBPACK_IMPORTED_MODULE_18__[
            /* default */
            "a"].setConfigFromProps({
              apiServer: propsToLoad.apiServerUrl,
              appendFormIdToSubmissionIdKey: propsToLoad.appendFormIdToSubmissionIdKey,
              fieldUpdateTimeout: propsToLoad.fieldUpdateDebounceWaitingTime,
              server: propsToLoad.serverUrl,
              submissionIdKey: propsToLoad.submissionIdKey,
              subscriptionServer: propsToLoad.subscriptionServerUrl,
              subscriptionTimeout: propsToLoad.subscriptionTimeout
            });

            propsToLoad.submissionId = propsToLoad.submissionId || Object(_core_utils_localStorage__WEBPACK_IMPORTED_MODULE_29__[
            /* getLocalSubmissionId */
            "d"])(propsToLoad.formId);
            _this.state = {
              overrides: Object(_core_utils__WEBPACK_IMPORTED_MODULE_24__[
              /* getOverrides */
              "i"])(propsToLoad.children),
              rootComponents: Object(_core_utils__WEBPACK_IMPORTED_MODULE_24__[
              /* getRootComponents */
              "l"])(propsToLoad.children),
              propsToLoad: propsToLoad
            };
            var emitter = Object(mitt__WEBPACK_IMPORTED_MODULE_12__[
            /* default */
            "a"])();
            _this._client = createApolloClient(propsToLoad.apiKey);
            _this._store = createApolloStore(_this._client, {
              formatic: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_6___default()({}, _core_reducers__WEBPACK_IMPORTED_MODULE_26__[
              /* initialState */
              "b"], {
                apiKey: propsToLoad.apiKey,
                environment: propsToLoad.environment || _core_reducers__WEBPACK_IMPORTED_MODULE_26__[
                /* initialState */
                "b"].environment,
                channel: propsToLoad.channel || _core_reducers__WEBPACK_IMPORTED_MODULE_26__[
                /* initialState */
                "b"].channel,
                config: propsToLoad.config || _core_reducers__WEBPACK_IMPORTED_MODULE_26__[
                /* initialState */
                "b"].config,
                emitter: emitter,
                formId: propsToLoad.formId,
                submissionId: propsToLoad.submissionId
              })
            }, propsToLoad.runReduxDevTools); // Set data for front end actions

            Object(_core_utils_actions__WEBPACK_IMPORTED_MODULE_30__[
            /* setClient */
            "f"])(_this._client);
            Object(_core_utils_actions__WEBPACK_IMPORTED_MODULE_30__[
            /* setStore */
            "h"])(_this._store);
            Object(_core_utils_actions__WEBPACK_IMPORTED_MODULE_30__[
            /* setEmitter */
            "g"])(emitter);

            if (props.data) {
              props.data.initialise(_this._client, _this._store);
            }

            return _this;
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Formatic, [{
            key: "render",
            value: function render() {
              if (this.state.propsToLoad.formId === undefined) {
                return react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("p", null, "Please inform a formId");
              }

              return react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(react_apollo__WEBPACK_IMPORTED_MODULE_9__["ApolloProvider"], {
                store: this._store,
                client: this._client
              }, react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(antd__WEBPACK_IMPORTED_MODULE_13__[
              /* LocaleProvider */
              "a"], {
                locale: antd_lib_locale_provider_en_US__WEBPACK_IMPORTED_MODULE_14___default.a
              }, react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(_App__WEBPACK_IMPORTED_MODULE_17__[
              /* default */
              "a"], {
                propsToLoad: this.state.propsToLoad,
                overrides: this.state.overrides,
                rootComponents: this.state.rootComponents
              })));
            }
          }]);

          return Formatic;
        }(react__WEBPACK_IMPORTED_MODULE_7__["Component"]);
        /**
         * NOTE: Not using .defaultProps here because otherwise there wouldn't be a way to distinguish when the user has provided a value for a
         *       prop or if it was the .defaultProps setting it.
         *
         *       We need to distinguish it since we'll only load prop from URL if loadPropsFromUrl is true and also if no value was provided for it.
         *       Other than that, we also verify if the prop is in supportedPropTypesFromUrl list.
         */


        Formatic.FormaticDefaultProps = {
          apiKey: '',
          apiServerUrl: undefined,
          appendFormIdToSubmissionIdKey: undefined,
          channel: 'master',
          children: undefined,
          config: 'default',
          data: undefined,
          emitter: undefined,
          environment: 'Live',
          fieldUpdateDebounceWaitingTime: undefined,
          formId: undefined,
          getFromParentPage: false,
          initialValues: {},
          loadPropsFromUrl: false,
          runReduxDevTools: false,
          serverUrl: undefined,
          submissionId: undefined,
          submissionIdKey: undefined,
          subscriptionServerUrl: undefined,
          subscriptionTimeout: undefined,
          theme: 'default'
        };
        Formatic.defaultProps = {
          apiServerUrl: undefined,
          appendFormIdToSubmissionIdKey: undefined,
          channel: 'master',
          children: undefined,
          config: 'default',
          data: undefined,
          emitter: undefined,
          environment: 'Live',
          fieldUpdateDebounceWaitingTime: undefined,
          getFromParentPage: false,
          initialValues: {},
          loadPropsFromUrl: false,
          runReduxDevTools: false,
          serverUrl: undefined,
          submissionId: undefined,
          submissionIdKey: undefined,
          subscriptionServerUrl: undefined,
          subscriptionTimeout: undefined,
          theme: 'default'
        };
        /**
         * NOTE: if a new propType is added/removed/updated:
         *
         * 1- update FormaticDefaultProps properly
         * 2- update supportedPropTypesFromUrl accordingly
         * 3- update numericProps and booleanProps accordingly
         */

        Formatic.propTypes = {
          apiKey: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string.isRequired,
          apiServerUrl: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
          appendFormIdToSubmissionIdKey: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,
          channel: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
          children: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.node,
          config: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
          data: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,
          emitter: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,
          environment: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
          fieldUpdateDebounceWaitingTime: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.number,
          formId: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.number.isRequired,
          initialValues: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,
          getFromParentPage: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,
          loadPropsFromUrl: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,
          runReduxDevTools: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,
          serverUrl: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
          submissionId: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
          submissionIdKey: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
          subscriptionServerUrl: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
          subscriptionTimeout: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.number,
          theme: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string
        };
        var Events = _core_utils_constants__WEBPACK_IMPORTED_MODULE_19__["Events"];
        /* harmony default export */

        __webpack_exports__["default"] = Formatic;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(162));
      /***/
    },
    /* 1197 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (global) {
        /** Detect free variable `global` from Node.js. */
        var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
        /* harmony default export */

        __webpack_exports__["a"] = freeGlobal;
        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(71));
      /***/
    }])
  );
});